// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%237E8299%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 13 11%27 width=%2713%27 height=%2711%27 fill=%27none%27%3e%3cpath d=%27M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23ffffff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23B5B5C3%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ffffff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2350cd89%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23f1416c%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23f1416c%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23181C32%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23009ef7%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23A1A5B7%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23474761%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%236D6D80%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23FFFFFF%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23ffffff%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27%235E6278%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27%235E6278%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-pagination-focus-color%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-pagination-focus-color%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-pagination-hover-color%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-pagination-hover-color%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-pagination-active-color%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-pagination-active-color%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-pagination-disabled-color%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-pagination-disabled-color%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-muted%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-muted%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-white%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-white%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-white%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-white%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-primary%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-primary%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-primary%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-primary%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-secondary%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-secondary%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-secondary%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-secondary%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-light%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-light%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-light%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-light%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-success%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-success%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-success%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-success%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-info%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-info%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-info%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-info%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-warning%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-warning%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-warning%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-warning%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-danger%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-danger%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-danger%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-danger%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-dark%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-dark%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-dark%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-dark%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-muted%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-muted%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-100%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-100%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_74___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-100%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_75___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-100%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_76___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-200%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_77___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-200%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_78___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-200%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_79___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-200%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_80___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-300%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_81___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-300%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_82___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-300%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_83___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-300%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_84___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-400%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_85___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-400%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_86___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-400%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_87___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-400%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_88___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-500%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_89___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-500%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_90___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-500%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_91___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-500%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_92___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-600%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_93___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-600%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_94___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-600%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_95___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-600%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_96___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-700%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_97___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-700%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_98___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-700%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_99___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-700%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_100___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-800%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_101___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-800%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_102___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-800%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_103___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-800%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_104___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-900%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_105___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-gray-900%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_106___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-900%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_107___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-gray-900%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_108___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-menu-link-color-hover%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_109___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-menu-link-color-hover%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_110___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-menu-link-color-here%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_111___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-menu-link-color-here%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_112___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-menu-link-color-show%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_113___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-menu-link-color-show%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_114___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-menu-link-color-active%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_115___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-menu-link-color-active%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_116___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-primary-inverse%29%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_117___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-primary-inverse%29%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_118___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-muted%29%27%3e%3cpath d=%27M3.23571 2.72011L4.97917 4.46358C5.15176 4.63618 5.43158 4.63617 5.60417 4.46358C5.77676 4.29099 5.77676 4.01118 5.60417 3.83861L3.29463 1.52904C3.13192 1.36629 2.86809 1.36629 2.70538 1.52904L0.395812 3.83861C0.22325 4.01117 0.22325 4.29099 0.395812 4.46358C0.568437 4.63617 0.84825 4.63617 1.02081 4.46358L2.76429 2.72011C2.89446 2.58994 3.10554 2.58994 3.23571 2.72011Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_119___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27var%28--kt-text-muted%29%27%3e%3cpath d=%27M2.76429 3.27989L1.02083 1.53642C0.848244 1.36382 0.568419 1.36383 0.395831 1.53642C0.223244 1.70901 0.223244 1.98882 0.395831 2.16139L2.70537 4.47096C2.86808 4.63371 3.13191 4.63371 3.29462 4.47096L5.60419 2.16139C5.77675 1.98883 5.77675 1.70901 5.60419 1.53642C5.43156 1.36383 5.15175 1.36383 4.97919 1.53642L3.23571 3.27989C3.10554 3.41006 2.89446 3.41006 2.76429 3.27989Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_120___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--kt-gray-500%29%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_121___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27%23787887%27%3e%3cpath d=%27M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_122___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 6 6%27 fill=%27%23787887%27%3e%3cpath d=%27M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_74___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_75___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_76___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_77___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_78___);
var ___CSS_LOADER_URL_REPLACEMENT_79___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_79___);
var ___CSS_LOADER_URL_REPLACEMENT_80___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_80___);
var ___CSS_LOADER_URL_REPLACEMENT_81___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_81___);
var ___CSS_LOADER_URL_REPLACEMENT_82___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_82___);
var ___CSS_LOADER_URL_REPLACEMENT_83___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_83___);
var ___CSS_LOADER_URL_REPLACEMENT_84___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_84___);
var ___CSS_LOADER_URL_REPLACEMENT_85___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_85___);
var ___CSS_LOADER_URL_REPLACEMENT_86___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_86___);
var ___CSS_LOADER_URL_REPLACEMENT_87___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_87___);
var ___CSS_LOADER_URL_REPLACEMENT_88___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_88___);
var ___CSS_LOADER_URL_REPLACEMENT_89___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_89___);
var ___CSS_LOADER_URL_REPLACEMENT_90___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_90___);
var ___CSS_LOADER_URL_REPLACEMENT_91___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_91___);
var ___CSS_LOADER_URL_REPLACEMENT_92___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_92___);
var ___CSS_LOADER_URL_REPLACEMENT_93___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_93___);
var ___CSS_LOADER_URL_REPLACEMENT_94___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_94___);
var ___CSS_LOADER_URL_REPLACEMENT_95___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_95___);
var ___CSS_LOADER_URL_REPLACEMENT_96___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_96___);
var ___CSS_LOADER_URL_REPLACEMENT_97___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_97___);
var ___CSS_LOADER_URL_REPLACEMENT_98___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_98___);
var ___CSS_LOADER_URL_REPLACEMENT_99___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_99___);
var ___CSS_LOADER_URL_REPLACEMENT_100___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_100___);
var ___CSS_LOADER_URL_REPLACEMENT_101___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_101___);
var ___CSS_LOADER_URL_REPLACEMENT_102___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_102___);
var ___CSS_LOADER_URL_REPLACEMENT_103___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_103___);
var ___CSS_LOADER_URL_REPLACEMENT_104___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_104___);
var ___CSS_LOADER_URL_REPLACEMENT_105___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_105___);
var ___CSS_LOADER_URL_REPLACEMENT_106___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_106___);
var ___CSS_LOADER_URL_REPLACEMENT_107___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_107___);
var ___CSS_LOADER_URL_REPLACEMENT_108___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_108___);
var ___CSS_LOADER_URL_REPLACEMENT_109___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_109___);
var ___CSS_LOADER_URL_REPLACEMENT_110___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_110___);
var ___CSS_LOADER_URL_REPLACEMENT_111___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_111___);
var ___CSS_LOADER_URL_REPLACEMENT_112___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_112___);
var ___CSS_LOADER_URL_REPLACEMENT_113___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_113___);
var ___CSS_LOADER_URL_REPLACEMENT_114___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_114___);
var ___CSS_LOADER_URL_REPLACEMENT_115___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_115___);
var ___CSS_LOADER_URL_REPLACEMENT_116___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_116___);
var ___CSS_LOADER_URL_REPLACEMENT_117___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_117___);
var ___CSS_LOADER_URL_REPLACEMENT_118___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_118___);
var ___CSS_LOADER_URL_REPLACEMENT_119___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_119___);
var ___CSS_LOADER_URL_REPLACEMENT_120___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_120___);
var ___CSS_LOADER_URL_REPLACEMENT_121___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_121___);
var ___CSS_LOADER_URL_REPLACEMENT_122___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_122___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000000;
  --bs-white: #ffffff;
  --bs-gray: #7E8299;
  --bs-gray-dark: #3F4254;
  --bs-gray-100: #f5f8fa;
  --bs-gray-200: #eff2f5;
  --bs-gray-300: #E4E6EF;
  --bs-gray-400: #B5B5C3;
  --bs-gray-500: #A1A5B7;
  --bs-gray-600: #7E8299;
  --bs-gray-700: #5E6278;
  --bs-gray-800: #3F4254;
  --bs-gray-900: #181C32;
  --bs-white: #ffffff;
  --bs-light: #f5f8fa;
  --bs-primary: #009ef7;
  --bs-secondary: #E4E6EF;
  --bs-success: #50cd89;
  --bs-info: #7239ea;
  --bs-warning: #ffc700;
  --bs-danger: #f1416c;
  --bs-dark: #181C32;
  --bs-white-rgb: 255, 255, 255;
  --bs-light-rgb: 245, 248, 250;
  --bs-primary-rgb: 0, 158, 247;
  --bs-secondary-rgb: 228, 230, 239;
  --bs-success-rgb: 80, 205, 137;
  --bs-info-rgb: 114, 57, 234;
  --bs-warning-rgb: 255, 199, 0;
  --bs-danger-rgb: 241, 65, 108;
  --bs-dark-rgb: 24, 28, 50;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-body-color-rgb: 24, 28, 50;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-font-sans-serif: Inter, Helvetica, "sans-serif";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #181C32;
  --bs-body-bg: #ffffff;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #eff2f5;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.475rem;
  --bs-border-radius-sm: 0.425rem;
  --bs-border-radius-lg: 0.625rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-2xl: 2rem;
  --bs-border-radius-pill: 50rem;
  --bs-link-color: #009ef7;
  --bs-link-hover-color: #0095e8;
  --bs-code-color: #b93993;
  --bs-highlight-bg: #fff3cd;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.2;
  color: #181C32;
}

h1, .h1 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 1.75rem;
  }
}

h2, .h2 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.5rem;
  }
}

h3, .h3 {
  font-size: calc(1.26rem + 0.12vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.35rem;
  }
}

h4, .h4 {
  font-size: 1.25rem;
}

h5, .h5 {
  font-size: 1.15rem;
}

h6, .h6 {
  font-size: 1.075rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: 700;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--bs-link-color);
  text-decoration: none;
}
a:hover {
  color: var(--bs-link-hover-color);
  text-decoration: none;
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.425rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #A1A5B7;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 700;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 700;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 700;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 700;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 700;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 700;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #7E8299;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #ffffff;
  border: 1px solid #eff2f5;
  border-radius: 0.475rem;
  box-shadow: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: #7E8299;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0rem;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0rem;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 0.75rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 0.75rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 1.25rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 1.25rem;
}

.g-6,
.gx-6 {
  --bs-gutter-x: 1.5rem;
}

.g-6,
.gy-6 {
  --bs-gutter-y: 1.5rem;
}

.g-7,
.gx-7 {
  --bs-gutter-x: 1.75rem;
}

.g-7,
.gy-7 {
  --bs-gutter-y: 1.75rem;
}

.g-8,
.gx-8 {
  --bs-gutter-x: 2rem;
}

.g-8,
.gy-8 {
  --bs-gutter-y: 2rem;
}

.g-9,
.gx-9 {
  --bs-gutter-x: 2.25rem;
}

.g-9,
.gy-9 {
  --bs-gutter-y: 2.25rem;
}

.g-10,
.gx-10 {
  --bs-gutter-x: 2.5rem;
}

.g-10,
.gy-10 {
  --bs-gutter-y: 2.5rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }

  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }

  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }

  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-sm-0 {
    margin-left: 0;
  }

  .offset-sm-1 {
    margin-left: 8.33333333%;
  }

  .offset-sm-2 {
    margin-left: 16.66666667%;
  }

  .offset-sm-3 {
    margin-left: 25%;
  }

  .offset-sm-4 {
    margin-left: 33.33333333%;
  }

  .offset-sm-5 {
    margin-left: 41.66666667%;
  }

  .offset-sm-6 {
    margin-left: 50%;
  }

  .offset-sm-7 {
    margin-left: 58.33333333%;
  }

  .offset-sm-8 {
    margin-left: 66.66666667%;
  }

  .offset-sm-9 {
    margin-left: 75%;
  }

  .offset-sm-10 {
    margin-left: 83.33333333%;
  }

  .offset-sm-11 {
    margin-left: 91.66666667%;
  }

  .g-sm-0,
.gx-sm-0 {
    --bs-gutter-x: 0rem;
  }

  .g-sm-0,
.gy-sm-0 {
    --bs-gutter-y: 0rem;
  }

  .g-sm-1,
.gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-sm-1,
.gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-sm-2,
.gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-sm-2,
.gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-sm-3,
.gx-sm-3 {
    --bs-gutter-x: 0.75rem;
  }

  .g-sm-3,
.gy-sm-3 {
    --bs-gutter-y: 0.75rem;
  }

  .g-sm-4,
.gx-sm-4 {
    --bs-gutter-x: 1rem;
  }

  .g-sm-4,
.gy-sm-4 {
    --bs-gutter-y: 1rem;
  }

  .g-sm-5,
.gx-sm-5 {
    --bs-gutter-x: 1.25rem;
  }

  .g-sm-5,
.gy-sm-5 {
    --bs-gutter-y: 1.25rem;
  }

  .g-sm-6,
.gx-sm-6 {
    --bs-gutter-x: 1.5rem;
  }

  .g-sm-6,
.gy-sm-6 {
    --bs-gutter-y: 1.5rem;
  }

  .g-sm-7,
.gx-sm-7 {
    --bs-gutter-x: 1.75rem;
  }

  .g-sm-7,
.gy-sm-7 {
    --bs-gutter-y: 1.75rem;
  }

  .g-sm-8,
.gx-sm-8 {
    --bs-gutter-x: 2rem;
  }

  .g-sm-8,
.gy-sm-8 {
    --bs-gutter-y: 2rem;
  }

  .g-sm-9,
.gx-sm-9 {
    --bs-gutter-x: 2.25rem;
  }

  .g-sm-9,
.gy-sm-9 {
    --bs-gutter-y: 2.25rem;
  }

  .g-sm-10,
.gx-sm-10 {
    --bs-gutter-x: 2.5rem;
  }

  .g-sm-10,
.gy-sm-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }

  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }

  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }

  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-md-0 {
    margin-left: 0;
  }

  .offset-md-1 {
    margin-left: 8.33333333%;
  }

  .offset-md-2 {
    margin-left: 16.66666667%;
  }

  .offset-md-3 {
    margin-left: 25%;
  }

  .offset-md-4 {
    margin-left: 33.33333333%;
  }

  .offset-md-5 {
    margin-left: 41.66666667%;
  }

  .offset-md-6 {
    margin-left: 50%;
  }

  .offset-md-7 {
    margin-left: 58.33333333%;
  }

  .offset-md-8 {
    margin-left: 66.66666667%;
  }

  .offset-md-9 {
    margin-left: 75%;
  }

  .offset-md-10 {
    margin-left: 83.33333333%;
  }

  .offset-md-11 {
    margin-left: 91.66666667%;
  }

  .g-md-0,
.gx-md-0 {
    --bs-gutter-x: 0rem;
  }

  .g-md-0,
.gy-md-0 {
    --bs-gutter-y: 0rem;
  }

  .g-md-1,
.gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-md-1,
.gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-md-2,
.gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-md-2,
.gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-md-3,
.gx-md-3 {
    --bs-gutter-x: 0.75rem;
  }

  .g-md-3,
.gy-md-3 {
    --bs-gutter-y: 0.75rem;
  }

  .g-md-4,
.gx-md-4 {
    --bs-gutter-x: 1rem;
  }

  .g-md-4,
.gy-md-4 {
    --bs-gutter-y: 1rem;
  }

  .g-md-5,
.gx-md-5 {
    --bs-gutter-x: 1.25rem;
  }

  .g-md-5,
.gy-md-5 {
    --bs-gutter-y: 1.25rem;
  }

  .g-md-6,
.gx-md-6 {
    --bs-gutter-x: 1.5rem;
  }

  .g-md-6,
.gy-md-6 {
    --bs-gutter-y: 1.5rem;
  }

  .g-md-7,
.gx-md-7 {
    --bs-gutter-x: 1.75rem;
  }

  .g-md-7,
.gy-md-7 {
    --bs-gutter-y: 1.75rem;
  }

  .g-md-8,
.gx-md-8 {
    --bs-gutter-x: 2rem;
  }

  .g-md-8,
.gy-md-8 {
    --bs-gutter-y: 2rem;
  }

  .g-md-9,
.gx-md-9 {
    --bs-gutter-x: 2.25rem;
  }

  .g-md-9,
.gy-md-9 {
    --bs-gutter-y: 2.25rem;
  }

  .g-md-10,
.gx-md-10 {
    --bs-gutter-x: 2.5rem;
  }

  .g-md-10,
.gy-md-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }

  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }

  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }

  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-lg-0 {
    margin-left: 0;
  }

  .offset-lg-1 {
    margin-left: 8.33333333%;
  }

  .offset-lg-2 {
    margin-left: 16.66666667%;
  }

  .offset-lg-3 {
    margin-left: 25%;
  }

  .offset-lg-4 {
    margin-left: 33.33333333%;
  }

  .offset-lg-5 {
    margin-left: 41.66666667%;
  }

  .offset-lg-6 {
    margin-left: 50%;
  }

  .offset-lg-7 {
    margin-left: 58.33333333%;
  }

  .offset-lg-8 {
    margin-left: 66.66666667%;
  }

  .offset-lg-9 {
    margin-left: 75%;
  }

  .offset-lg-10 {
    margin-left: 83.33333333%;
  }

  .offset-lg-11 {
    margin-left: 91.66666667%;
  }

  .g-lg-0,
.gx-lg-0 {
    --bs-gutter-x: 0rem;
  }

  .g-lg-0,
.gy-lg-0 {
    --bs-gutter-y: 0rem;
  }

  .g-lg-1,
.gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-lg-1,
.gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-lg-2,
.gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-lg-2,
.gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-lg-3,
.gx-lg-3 {
    --bs-gutter-x: 0.75rem;
  }

  .g-lg-3,
.gy-lg-3 {
    --bs-gutter-y: 0.75rem;
  }

  .g-lg-4,
.gx-lg-4 {
    --bs-gutter-x: 1rem;
  }

  .g-lg-4,
.gy-lg-4 {
    --bs-gutter-y: 1rem;
  }

  .g-lg-5,
.gx-lg-5 {
    --bs-gutter-x: 1.25rem;
  }

  .g-lg-5,
.gy-lg-5 {
    --bs-gutter-y: 1.25rem;
  }

  .g-lg-6,
.gx-lg-6 {
    --bs-gutter-x: 1.5rem;
  }

  .g-lg-6,
.gy-lg-6 {
    --bs-gutter-y: 1.5rem;
  }

  .g-lg-7,
.gx-lg-7 {
    --bs-gutter-x: 1.75rem;
  }

  .g-lg-7,
.gy-lg-7 {
    --bs-gutter-y: 1.75rem;
  }

  .g-lg-8,
.gx-lg-8 {
    --bs-gutter-x: 2rem;
  }

  .g-lg-8,
.gy-lg-8 {
    --bs-gutter-y: 2rem;
  }

  .g-lg-9,
.gx-lg-9 {
    --bs-gutter-x: 2.25rem;
  }

  .g-lg-9,
.gy-lg-9 {
    --bs-gutter-y: 2.25rem;
  }

  .g-lg-10,
.gx-lg-10 {
    --bs-gutter-x: 2.5rem;
  }

  .g-lg-10,
.gy-lg-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }

  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }

  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }

  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-xl-0 {
    margin-left: 0;
  }

  .offset-xl-1 {
    margin-left: 8.33333333%;
  }

  .offset-xl-2 {
    margin-left: 16.66666667%;
  }

  .offset-xl-3 {
    margin-left: 25%;
  }

  .offset-xl-4 {
    margin-left: 33.33333333%;
  }

  .offset-xl-5 {
    margin-left: 41.66666667%;
  }

  .offset-xl-6 {
    margin-left: 50%;
  }

  .offset-xl-7 {
    margin-left: 58.33333333%;
  }

  .offset-xl-8 {
    margin-left: 66.66666667%;
  }

  .offset-xl-9 {
    margin-left: 75%;
  }

  .offset-xl-10 {
    margin-left: 83.33333333%;
  }

  .offset-xl-11 {
    margin-left: 91.66666667%;
  }

  .g-xl-0,
.gx-xl-0 {
    --bs-gutter-x: 0rem;
  }

  .g-xl-0,
.gy-xl-0 {
    --bs-gutter-y: 0rem;
  }

  .g-xl-1,
.gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-xl-1,
.gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-xl-2,
.gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-xl-2,
.gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-xl-3,
.gx-xl-3 {
    --bs-gutter-x: 0.75rem;
  }

  .g-xl-3,
.gy-xl-3 {
    --bs-gutter-y: 0.75rem;
  }

  .g-xl-4,
.gx-xl-4 {
    --bs-gutter-x: 1rem;
  }

  .g-xl-4,
.gy-xl-4 {
    --bs-gutter-y: 1rem;
  }

  .g-xl-5,
.gx-xl-5 {
    --bs-gutter-x: 1.25rem;
  }

  .g-xl-5,
.gy-xl-5 {
    --bs-gutter-y: 1.25rem;
  }

  .g-xl-6,
.gx-xl-6 {
    --bs-gutter-x: 1.5rem;
  }

  .g-xl-6,
.gy-xl-6 {
    --bs-gutter-y: 1.5rem;
  }

  .g-xl-7,
.gx-xl-7 {
    --bs-gutter-x: 1.75rem;
  }

  .g-xl-7,
.gy-xl-7 {
    --bs-gutter-y: 1.75rem;
  }

  .g-xl-8,
.gx-xl-8 {
    --bs-gutter-x: 2rem;
  }

  .g-xl-8,
.gy-xl-8 {
    --bs-gutter-y: 2rem;
  }

  .g-xl-9,
.gx-xl-9 {
    --bs-gutter-x: 2.25rem;
  }

  .g-xl-9,
.gy-xl-9 {
    --bs-gutter-y: 2.25rem;
  }

  .g-xl-10,
.gx-xl-10 {
    --bs-gutter-x: 2.5rem;
  }

  .g-xl-10,
.gy-xl-10 {
    --bs-gutter-y: 2.5rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }

  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }

  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }

  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }

  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }

  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }

  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }

  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }

  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }

  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }

  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }

  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }

  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }

  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }

  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }

  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }

  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }

  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }

  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }

  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }

  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }

  .offset-xxl-0 {
    margin-left: 0;
  }

  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }

  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }

  .offset-xxl-3 {
    margin-left: 25%;
  }

  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }

  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }

  .offset-xxl-6 {
    margin-left: 50%;
  }

  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }

  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }

  .offset-xxl-9 {
    margin-left: 75%;
  }

  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }

  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }

  .g-xxl-0,
.gx-xxl-0 {
    --bs-gutter-x: 0rem;
  }

  .g-xxl-0,
.gy-xxl-0 {
    --bs-gutter-y: 0rem;
  }

  .g-xxl-1,
.gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }

  .g-xxl-1,
.gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }

  .g-xxl-2,
.gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }

  .g-xxl-2,
.gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }

  .g-xxl-3,
.gx-xxl-3 {
    --bs-gutter-x: 0.75rem;
  }

  .g-xxl-3,
.gy-xxl-3 {
    --bs-gutter-y: 0.75rem;
  }

  .g-xxl-4,
.gx-xxl-4 {
    --bs-gutter-x: 1rem;
  }

  .g-xxl-4,
.gy-xxl-4 {
    --bs-gutter-y: 1rem;
  }

  .g-xxl-5,
.gx-xxl-5 {
    --bs-gutter-x: 1.25rem;
  }

  .g-xxl-5,
.gy-xxl-5 {
    --bs-gutter-y: 1.25rem;
  }

  .g-xxl-6,
.gx-xxl-6 {
    --bs-gutter-x: 1.5rem;
  }

  .g-xxl-6,
.gy-xxl-6 {
    --bs-gutter-y: 1.5rem;
  }

  .g-xxl-7,
.gx-xxl-7 {
    --bs-gutter-x: 1.75rem;
  }

  .g-xxl-7,
.gy-xxl-7 {
    --bs-gutter-y: 1.75rem;
  }

  .g-xxl-8,
.gx-xxl-8 {
    --bs-gutter-x: 2rem;
  }

  .g-xxl-8,
.gy-xxl-8 {
    --bs-gutter-y: 2rem;
  }

  .g-xxl-9,
.gx-xxl-9 {
    --bs-gutter-x: 2.25rem;
  }

  .g-xxl-9,
.gy-xxl-9 {
    --bs-gutter-y: 2.25rem;
  }

  .g-xxl-10,
.gx-xxl-10 {
    --bs-gutter-x: 2.5rem;
  }

  .g-xxl-10,
.gy-xxl-10 {
    --bs-gutter-y: 2.5rem;
  }
}
.table {
  --bs-table-color: #181C32;
  --bs-table-bg: transparent;
  --bs-table-border-color: #eff2f5;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: #181C32;
  --bs-table-striped-bg: rgba(245, 248, 250, 0.75);
  --bs-table-active-color: #181C32;
  --bs-table-active-bg: #f5f8fa;
  --bs-table-hover-color: #181C32;
  --bs-table-hover-bg: #f5f8fa;
  width: 100%;
  margin-bottom: 1rem;
  color: var(--bs-table-color);
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.75rem 0.75rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: 2px solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color);
}

.table-active {
  --bs-table-accent-bg: var(--bs-table-active-bg);
  color: var(--bs-table-active-color);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-accent-bg: var(--bs-table-hover-bg);
  color: var(--bs-table-hover-color);
}

.table-primary {
  --bs-table-color: #000000;
  --bs-table-bg: #ccecfd;
  --bs-table-border-color: #b8d4e4;
  --bs-table-striped-bg: #c2e0f0;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #b8d4e4;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #bddaea;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000000;
  --bs-table-bg: #fafafc;
  --bs-table-border-color: #e1e1e3;
  --bs-table-striped-bg: #eeeeef;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e1e1e3;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #e7e7e9;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000000;
  --bs-table-bg: #dcf5e7;
  --bs-table-border-color: #c6ddd0;
  --bs-table-striped-bg: #d1e9db;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #c6ddd0;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #cce3d6;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000000;
  --bs-table-bg: #e3d7fb;
  --bs-table-border-color: #ccc2e2;
  --bs-table-striped-bg: #d8ccee;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #ccc2e2;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #d2c7e8;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000000;
  --bs-table-bg: #fff4cc;
  --bs-table-border-color: #e6dcb8;
  --bs-table-striped-bg: #f2e8c2;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e6dcb8;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #ece2bd;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000000;
  --bs-table-bg: #fcd9e2;
  --bs-table-border-color: #e3c3cb;
  --bs-table-striped-bg: #efced7;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #e3c3cb;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #e9c9d1;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000000;
  --bs-table-bg: #f5f8fa;
  --bs-table-border-color: #dddfe1;
  --bs-table-striped-bg: #e9ecee;
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: #dddfe1;
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: #e3e5e7;
  --bs-table-hover-color: #000000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #ffffff;
  --bs-table-bg: #181C32;
  --bs-table-border-color: #2f3347;
  --bs-table-striped-bg: #24273c;
  --bs-table-striped-color: #ffffff;
  --bs-table-active-bg: #2f3347;
  --bs-table-active-color: #ffffff;
  --bs-table-hover-bg: #292d41;
  --bs-table-hover-color: #ffffff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
  font-size: 1.05rem;
  font-weight: 500;
  color: #3F4254;
}

.col-form-label {
  padding-top: calc(0.775rem + 1px);
  padding-bottom: calc(0.775rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  font-weight: 500;
  line-height: 1.5;
  color: #3F4254;
}

.col-form-label-lg {
  padding-top: calc(0.825rem + 1px);
  padding-bottom: calc(0.825rem + 1px);
  font-size: 1.15rem;
}

.col-form-label-sm {
  padding-top: calc(0.55rem + 1px);
  padding-bottom: calc(0.55rem + 1px);
  font-size: 0.925rem;
}

.form-text {
  margin-top: 0.5rem;
  font-size: 0.925rem;
  color: #A1A5B7;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.775rem 1rem;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  color: #5E6278;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 1px solid #E4E6EF;
  appearance: none;
  border-radius: 0.475rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: #5E6278;
  background-color: #ffffff;
  border-color: #B5B5C3;
  outline: 0;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0.25rem rgba(0, 158, 247, 0.25);
}
.form-control::-webkit-date-and-time-value {
  height: 1.5em;
}
.form-control::placeholder {
  color: #A1A5B7;
  opacity: 1;
}
.form-control:disabled {
  background-color: #eff2f5;
  border-color: #E4E6EF;
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.775rem 1rem;
  margin: -0.775rem -1rem;
  margin-inline-end: 1rem;
  color: #5E6278;
  background-color: #f5f8fa;
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: shade-color(#f5f8fa, 5%);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.775rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: #5E6278;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 1.1rem + 2px);
  padding: 0.55rem 0.75rem;
  font-size: 0.925rem;
  border-radius: 0.425rem;
}
.form-control-sm::file-selector-button {
  padding: 0.55rem 0.75rem;
  margin: -0.55rem -0.75rem;
  margin-inline-end: 0.75rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1.65rem + 2px);
  padding: 0.825rem 1.5rem;
  font-size: 1.15rem;
  border-radius: 0.625rem;
}
.form-control-lg::file-selector-button {
  padding: 0.825rem 1.5rem;
  margin: -0.825rem -1.5rem;
  margin-inline-end: 1.5rem;
}

textarea.form-control {
  min-height: calc(1.5em + 1.55rem + 2px);
}
textarea.form-control-sm {
  min-height: calc(1.5em + 1.1rem + 2px);
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1.65rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 1.55rem + 2px);
  padding: 0.775rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.475rem;
}
.form-control-color::-webkit-color-swatch {
  border-radius: 0.475rem;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 1.1rem + 2px);
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1.65rem + 2px);
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.775rem 3rem 0.775rem 1rem;
  -moz-padding-start: calc(1rem - 3px);
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  color: #5E6278;
  background-color: #ffffff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 16px 12px;
  border: 1px solid #E4E6EF;
  border-radius: 0.475rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: #B5B5C3;
  outline: 0;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0.25rem rgba(0, 158, 247, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 1rem;
  background-image: none;
}
.form-select:disabled {
  background-color: #eff2f5;
  border-color: #E4E6EF;
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #5E6278;
}

.form-select-sm {
  padding-top: 0.55rem;
  padding-bottom: 0.55rem;
  padding-left: 0.75rem;
  font-size: 0.925rem;
  border-radius: 0.425rem;
}

.form-select-lg {
  padding-top: 0.825rem;
  padding-bottom: 0.825rem;
  padding-left: 1.5rem;
  font-size: 1.15rem;
  border-radius: 0.625rem;
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 2.25rem;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -2.25rem;
}

.form-check-reverse {
  padding-right: 2.25rem;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -2.25rem;
  margin-left: 0;
}

.form-check-input {
  width: 1.75rem;
  height: 1.75rem;
  margin-top: -0.125rem;
  vertical-align: top;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid #E4E6EF;
  appearance: none;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.45em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #B5B5C3;
  outline: 0;
  box-shadow: none;
}
.form-check-input:checked {
  background-color: #009ef7;
  border-color: #009ef7;
}
.form-check-input:checked[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.form-check-input:checked[type=radio] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #009ef7;
  border-color: #009ef7;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-check-label {
  color: #A1A5B7;
}

.form-switch {
  padding-left: 3.75rem;
}
.form-switch .form-check-input {
  width: 3.25rem;
  margin-left: -3.75rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: left center;
  border-radius: 3.25rem;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch.form-check-reverse {
  padding-right: 3.75rem;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -3.75rem;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(0, 158, 247, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(0, 158, 247, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #009ef7;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #b3e2fd;
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--kt-gray-300);
  border-color: transparent;
  border-radius: 0.475rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #009ef7;
  border: 0;
  border-radius: 1rem;
  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #b3e2fd;
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--kt-gray-300);
  border-color: transparent;
  border-radius: 0.475rem;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--kt-gray-500);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--kt-gray-500);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.75rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 1rem 1rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 1rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.85rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.85rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.85rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.775rem 1rem;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.5;
  color: #5E6278;
  text-align: center;
  white-space: nowrap;
  background-color: #f5f8fa;
  border: 1px solid #E4E6EF;
  border-radius: 0.475rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.825rem 1.5rem;
  font-size: 1.15rem;
  border-radius: 0.625rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.55rem 0.75rem;
  font-size: 0.925rem;
  border-radius: 0.425rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 4rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.5rem;
  font-size: 0.925rem;
  color: #50cd89;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.75rem 1rem;
  margin-top: 0.1rem;
  font-size: 0.925rem;
  color: #000000;
  background-color: #50cd89;
  border-radius: 0.475rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #50cd89;
  padding-right: calc(1.5em + 1.55rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.3875rem) center;
  background-size: calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #50cd89;
  box-shadow: 0 0 0 0.25rem rgba(80, 205, 137, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1.55rem);
  background-position: top calc(0.375em + 0.3875rem) right calc(0.375em + 0.3875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #50cd89;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  padding-right: 5.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  background-position: right 1rem center, center right 3rem;
  background-size: 16px 12px, calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #50cd89;
  box-shadow: 0 0 0 0.25rem rgba(80, 205, 137, 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 1.55rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #50cd89;
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #50cd89;
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(80, 205, 137, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #50cd89;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.5rem;
  font-size: 0.925rem;
  color: #f1416c;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.75rem 1rem;
  margin-top: 0.1rem;
  font-size: 0.925rem;
  color: #000000;
  background-color: #f1416c;
  border-radius: 0.475rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #f1416c;
  padding-right: calc(1.5em + 1.55rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.3875rem) center;
  background-size: calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #f1416c;
  box-shadow: 0 0 0 0.25rem rgba(241, 65, 108, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1.55rem);
  background-position: top calc(0.375em + 0.3875rem) right calc(0.375em + 0.3875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #f1416c;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  padding-right: 5.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: right 1rem center, center right 3rem;
  background-size: 16px 12px, calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #f1416c;
  box-shadow: 0 0 0 0.25rem rgba(241, 65, 108, 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 1.55rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #f1416c;
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #f1416c;
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(241, 65, 108, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #f1416c;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 1.5rem;
  --bs-btn-padding-y: 0.775rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1.1rem;
  --bs-btn-font-weight: 500;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: #181C32;
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.475rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  box-shadow: var(--bs-btn-box-shadow);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
  box-shadow: var(--bs-btn-active-shadow);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-active-shadow), var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
  box-shadow: none;
}

.btn-white {
  --bs-btn-color: #000000;
  --bs-btn-bg: #ffffff;
  --bs-btn-border-color: #ffffff;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: white;
  --bs-btn-hover-border-color: white;
  --bs-btn-focus-shadow-rgb: 217, 217, 217;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: white;
  --bs-btn-active-border-color: white;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #ffffff;
  --bs-btn-disabled-border-color: #ffffff;
}

.btn-light {
  --bs-btn-color: #000000;
  --bs-btn-bg: #f5f8fa;
  --bs-btn-border-color: #f5f8fa;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #d0d3d5;
  --bs-btn-hover-border-color: #c4c6c8;
  --bs-btn-focus-shadow-rgb: 208, 211, 213;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #c4c6c8;
  --bs-btn-active-border-color: #b8babc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #f5f8fa;
  --bs-btn-disabled-border-color: #f5f8fa;
}

.btn-primary {
  --bs-btn-color: #000000;
  --bs-btn-bg: #009ef7;
  --bs-btn-border-color: #009ef7;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #26adf8;
  --bs-btn-hover-border-color: #1aa8f8;
  --bs-btn-focus-shadow-rgb: 0, 134, 210;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #33b1f9;
  --bs-btn-active-border-color: #1aa8f8;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #009ef7;
  --bs-btn-disabled-border-color: #009ef7;
}

.btn-secondary {
  --bs-btn-color: #000000;
  --bs-btn-bg: #E4E6EF;
  --bs-btn-border-color: #E4E6EF;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #e8eaf1;
  --bs-btn-hover-border-color: #e7e9f1;
  --bs-btn-focus-shadow-rgb: 194, 196, 203;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #e9ebf2;
  --bs-btn-active-border-color: #e7e9f1;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #E4E6EF;
  --bs-btn-disabled-border-color: #E4E6EF;
}

.btn-success {
  --bs-btn-color: #000000;
  --bs-btn-bg: #50cd89;
  --bs-btn-border-color: #50cd89;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #6ad59b;
  --bs-btn-hover-border-color: #62d295;
  --bs-btn-focus-shadow-rgb: 68, 174, 116;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #73d7a1;
  --bs-btn-active-border-color: #62d295;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #50cd89;
  --bs-btn-disabled-border-color: #50cd89;
}

.btn-info {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #7239ea;
  --bs-btn-border-color: #7239ea;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #6130c7;
  --bs-btn-hover-border-color: #5b2ebb;
  --bs-btn-focus-shadow-rgb: 135, 87, 237;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #5b2ebb;
  --bs-btn-active-border-color: #562bb0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #7239ea;
  --bs-btn-disabled-border-color: #7239ea;
}

.btn-warning {
  --bs-btn-color: #000000;
  --bs-btn-bg: #ffc700;
  --bs-btn-border-color: #ffc700;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #ffcf26;
  --bs-btn-hover-border-color: #ffcd1a;
  --bs-btn-focus-shadow-rgb: 217, 169, 0;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #ffd233;
  --bs-btn-active-border-color: #ffcd1a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #ffc700;
  --bs-btn-disabled-border-color: #ffc700;
}

.btn-danger {
  --bs-btn-color: #000000;
  --bs-btn-bg: #f1416c;
  --bs-btn-border-color: #f1416c;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #f35e82;
  --bs-btn-hover-border-color: #f2547b;
  --bs-btn-focus-shadow-rgb: 205, 55, 92;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #f46789;
  --bs-btn-active-border-color: #f2547b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: #f1416c;
  --bs-btn-disabled-border-color: #f1416c;
}

.btn-dark {
  --bs-btn-color: #ffffff;
  --bs-btn-bg: #181C32;
  --bs-btn-border-color: #181C32;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #3b3e51;
  --bs-btn-hover-border-color: #2f3347;
  --bs-btn-focus-shadow-rgb: 59, 62, 81;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #46495b;
  --bs-btn-active-border-color: #2f3347;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: #181C32;
  --bs-btn-disabled-border-color: #181C32;
}

.btn-outline-white {
  --bs-btn-color: #ffffff;
  --bs-btn-border-color: #ffffff;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #ffffff;
  --bs-btn-hover-border-color: #ffffff;
  --bs-btn-focus-shadow-rgb: 255, 255, 255;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #ffffff;
  --bs-btn-active-border-color: #ffffff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffffff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffffff;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f5f8fa;
  --bs-btn-border-color: #f5f8fa;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #f5f8fa;
  --bs-btn-hover-border-color: #f5f8fa;
  --bs-btn-focus-shadow-rgb: 245, 248, 250;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #f5f8fa;
  --bs-btn-active-border-color: #f5f8fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f5f8fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f5f8fa;
  --bs-gradient: none;
}

.btn-outline-primary {
  --bs-btn-color: #009ef7;
  --bs-btn-border-color: #009ef7;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #009ef7;
  --bs-btn-hover-border-color: #009ef7;
  --bs-btn-focus-shadow-rgb: 0, 158, 247;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #009ef7;
  --bs-btn-active-border-color: #009ef7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #009ef7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #009ef7;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #E4E6EF;
  --bs-btn-border-color: #E4E6EF;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #E4E6EF;
  --bs-btn-hover-border-color: #E4E6EF;
  --bs-btn-focus-shadow-rgb: 228, 230, 239;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #E4E6EF;
  --bs-btn-active-border-color: #E4E6EF;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #E4E6EF;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #E4E6EF;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #50cd89;
  --bs-btn-border-color: #50cd89;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #50cd89;
  --bs-btn-hover-border-color: #50cd89;
  --bs-btn-focus-shadow-rgb: 80, 205, 137;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #50cd89;
  --bs-btn-active-border-color: #50cd89;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #50cd89;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #50cd89;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #7239ea;
  --bs-btn-border-color: #7239ea;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #7239ea;
  --bs-btn-hover-border-color: #7239ea;
  --bs-btn-focus-shadow-rgb: 114, 57, 234;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #7239ea;
  --bs-btn-active-border-color: #7239ea;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #7239ea;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #7239ea;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc700;
  --bs-btn-border-color: #ffc700;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #ffc700;
  --bs-btn-hover-border-color: #ffc700;
  --bs-btn-focus-shadow-rgb: 255, 199, 0;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #ffc700;
  --bs-btn-active-border-color: #ffc700;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc700;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc700;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #f1416c;
  --bs-btn-border-color: #f1416c;
  --bs-btn-hover-color: #000000;
  --bs-btn-hover-bg: #f1416c;
  --bs-btn-hover-border-color: #f1416c;
  --bs-btn-focus-shadow-rgb: 241, 65, 108;
  --bs-btn-active-color: #000000;
  --bs-btn-active-bg: #f1416c;
  --bs-btn-active-border-color: #f1416c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f1416c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f1416c;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #181C32;
  --bs-btn-border-color: #181C32;
  --bs-btn-hover-color: #ffffff;
  --bs-btn-hover-bg: #181C32;
  --bs-btn-hover-border-color: #181C32;
  --bs-btn-focus-shadow-rgb: 24, 28, 50;
  --bs-btn-active-color: #ffffff;
  --bs-btn-active-bg: #181C32;
  --bs-btn-active-border-color: #181C32;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #181C32;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #181C32;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: #009ef7;
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: #0095e8;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: #0095e8;
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #7E8299;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: none;
  --bs-btn-focus-shadow-rgb: 0, 134, 210;
  text-decoration: none;
}
.btn-link:hover, .btn-link:focus-visible {
  text-decoration: none;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.825rem;
  --bs-btn-padding-x: 1.75rem;
  --bs-btn-font-size: 1.15rem;
  --bs-btn-border-radius: 0.625rem;
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.55rem;
  --bs-btn-padding-x: 1.25rem;
  --bs-btn-font-size: 0.925rem;
  --bs-btn-border-radius: 0.425rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: #181C32;
  --bs-dropdown-bg: #ffffff;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: 0.475rem;
  --bs-dropdown-border-width: 0;
  --bs-dropdown-inner-border-radius: 0.475rem;
  --bs-dropdown-divider-bg: #f5f8fa;
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --bs-dropdown-link-color: #181C32;
  --bs-dropdown-link-hover-color: shade-color(#181C32, 10%);
  --bs-dropdown-link-hover-bg: #eff2f5;
  --bs-dropdown-link-active-color: #ffffff;
  --bs-dropdown-link-active-bg: #009ef7;
  --bs-dropdown-link-disabled-color: #A1A5B7;
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #7E8299;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
  box-shadow: var(--bs-dropdown-box-shadow);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }

  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.925rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #E4E6EF;
  --bs-dropdown-bg: #3F4254;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #E4E6EF;
  --bs-dropdown-link-hover-color: #ffffff;
  --bs-dropdown-divider-bg: #f5f8fa;
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #ffffff;
  --bs-dropdown-link-active-bg: #009ef7;
  --bs-dropdown-link-disabled-color: #A1A5B7;
  --bs-dropdown-header-color: #A1A5B7;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.475rem;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 1.125rem;
  padding-left: 1.125rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 1.3125rem;
  padding-left: 1.3125rem;
}

.btn-group.show .dropdown-toggle {
  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
}
.btn-group.show .dropdown-toggle.btn-link {
  box-shadow: none;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: #7E8299;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  transition: color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link.disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: 1px;
  --bs-nav-tabs-border-color: #eff2f5;
  --bs-nav-tabs-border-radius: 0.475rem;
  --bs-nav-tabs-link-hover-border-color: #eff2f5 #eff2f5 #eff2f5;
  --bs-nav-tabs-link-active-color: #5E6278;
  --bs-nav-tabs-link-active-bg: #ffffff;
  --bs-nav-tabs-link-active-border-color: #E4E6EF #E4E6EF #ffffff;
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  background: none;
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: 0.475rem;
  --bs-nav-pills-link-active-color: #ffffff;
  --bs-nav-pills-link-active-bg: #009ef7;
}
.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  background-color: transparent;
  border-color: transparent;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(0, 0, 0, 0.55);
  --bs-navbar-hover-color: rgba(0, 0, 0, 0.7);
  --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);
  --bs-navbar-active-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-padding-y: 0.44375rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.075rem;
  --bs-navbar-brand-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.075rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --bs-navbar-toggler-border-radius: 0.475rem;
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .show > .nav-link,
.navbar-nav .nav-link.active {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    box-shadow: none;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  box-shadow: none;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #ffffff;
  --bs-navbar-brand-color: #ffffff;
  --bs-navbar-brand-hover-color: #ffffff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-border-width: 1px;
  --bs-card-border-color: #eff2f5;
  --bs-card-border-radius: 0.625rem;
  --bs-card-box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);
  --bs-card-inner-border-radius: calc(0.625rem - 1px);
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: transparent;
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: #ffffff;
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
  box-shadow: var(--bs-card-box-shadow);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
.card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
.card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
.card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
.card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: #181C32;
  --bs-accordion-bg: #ffffff;
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: #eff2f5;
  --bs-accordion-border-width: 1px;
  --bs-accordion-border-radius: 0.475rem;
  --bs-accordion-inner-border-radius: calc(0.475rem - 1px);
  --bs-accordion-btn-padding-x: 1.5rem;
  --bs-accordion-btn-padding-y: 1.5rem;
  --bs-accordion-btn-color: #181C32;
  --bs-accordion-btn-bg: #ffffff;
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-accordion-btn-icon-width: 1.15rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --bs-accordion-btn-focus-border-color: #eff2f5;
  --bs-accordion-btn-focus-box-shadow: none;
  --bs-accordion-body-padding-x: 1.5rem;
  --bs-accordion-body-padding-y: 1.5rem;
  --bs-accordion-active-color: #009ef7;
  --bs-accordion-active-bg: #f5f8fa;
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: #7E8299;
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: #009ef7;
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1.075rem;
  --bs-pagination-color: #5E6278;
  --bs-pagination-bg: transparent;
  --bs-pagination-border-width: 0;
  --bs-pagination-border-color: transparent;
  --bs-pagination-border-radius: 0.475rem;
  --bs-pagination-hover-color: #009ef7;
  --bs-pagination-hover-bg: #F4F6FA;
  --bs-pagination-hover-border-color: transparent;
  --bs-pagination-focus-color: #009ef7;
  --bs-pagination-focus-bg: #F4F6FA;
  --bs-pagination-focus-box-shadow: none;
  --bs-pagination-active-color: #ffffff;
  --bs-pagination-active-bg: #009ef7;
  --bs-pagination-active-border-color: transparent;
  --bs-pagination-disabled-color: #B5B5C3;
  --bs-pagination-disabled-bg: transparent;
  --bs-pagination-disabled-border-color: transparent;
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: 0;
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.075rem;
  --bs-pagination-border-radius: 0.625rem;
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.925rem;
  --bs-pagination-border-radius: 0.425rem;
}

.badge {
  --bs-badge-padding-x: 0.5rem;
  --bs-badge-padding-y: 0.325rem;
  --bs-badge-font-size: 0.85rem;
  --bs-badge-font-weight: 600;
  --bs-badge-color: #ffffff;
  --bs-badge-border-radius: 0.425rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: 1px solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 0.475rem;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-white {
  --bs-alert-color: #666666;
  --bs-alert-bg: white;
  --bs-alert-border-color: white;
}
.alert-white .alert-link {
  color: #525252;
}

.alert-light {
  --bs-alert-color: #626364;
  --bs-alert-bg: #fdfefe;
  --bs-alert-border-color: #fcfdfe;
}
.alert-light .alert-link {
  color: #4e4f50;
}

.alert-primary {
  --bs-alert-color: #005f94;
  --bs-alert-bg: #ccecfd;
  --bs-alert-border-color: #b3e2fd;
}
.alert-primary .alert-link {
  color: #004c76;
}

.alert-secondary {
  --bs-alert-color: #5b5c60;
  --bs-alert-bg: #fafafc;
  --bs-alert-border-color: #f7f8fa;
}
.alert-secondary .alert-link {
  color: #494a4d;
}

.alert-success {
  --bs-alert-color: #205237;
  --bs-alert-bg: #dcf5e7;
  --bs-alert-border-color: #cbf0dc;
}
.alert-success .alert-link {
  color: #1a422c;
}

.alert-info {
  --bs-alert-color: #44228c;
  --bs-alert-bg: #e3d7fb;
  --bs-alert-border-color: #d5c4f9;
}
.alert-info .alert-link {
  color: #361b70;
}

.alert-warning {
  --bs-alert-color: #665000;
  --bs-alert-bg: #fff4cc;
  --bs-alert-border-color: #ffeeb3;
}
.alert-warning .alert-link {
  color: #524000;
}

.alert-danger {
  --bs-alert-color: #912741;
  --bs-alert-bg: #fcd9e2;
  --bs-alert-border-color: #fbc6d3;
}
.alert-danger .alert-link {
  color: #741f34;
}

.alert-dark {
  --bs-alert-color: #0e111e;
  --bs-alert-bg: #d1d2d6;
  --bs-alert-border-color: #babbc2;
}
.alert-dark .alert-link {
  color: #0b0e18;
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: #f5f8fa;
  --bs-progress-border-radius: 6px;
  --bs-progress-box-shadow: none;
  --bs-progress-bar-color: #ffffff;
  --bs-progress-bar-bg: #009ef7;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
  box-shadow: var(--bs-progress-box-shadow);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: #181C32;
  --bs-list-group-bg: #ffffff;
  --bs-list-group-border-color: rgba(0, 0, 0, 0.125);
  --bs-list-group-border-width: 1px;
  --bs-list-group-border-radius: 0.475rem;
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: #5E6278;
  --bs-list-group-action-hover-color: #5E6278;
  --bs-list-group-action-hover-bg: #f5f8fa;
  --bs-list-group-action-active-color: #181C32;
  --bs-list-group-action-active-bg: #eff2f5;
  --bs-list-group-disabled-color: #7E8299;
  --bs-list-group-disabled-bg: #ffffff;
  --bs-list-group-active-color: #ffffff;
  --bs-list-group-active-bg: #009ef7;
  --bs-list-group-active-border-color: #009ef7;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-white {
  color: #666666;
  background-color: white;
}
.list-group-item-white.list-group-item-action:hover, .list-group-item-white.list-group-item-action:focus {
  color: #666666;
  background-color: #e6e6e6;
}
.list-group-item-white.list-group-item-action.active {
  color: #ffffff;
  background-color: #666666;
  border-color: #666666;
}

.list-group-item-light {
  color: #626364;
  background-color: #fdfefe;
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: #626364;
  background-color: #e4e5e5;
}
.list-group-item-light.list-group-item-action.active {
  color: #ffffff;
  background-color: #626364;
  border-color: #626364;
}

.list-group-item-primary {
  color: #005f94;
  background-color: #ccecfd;
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: #005f94;
  background-color: #b8d4e4;
}
.list-group-item-primary.list-group-item-action.active {
  color: #ffffff;
  background-color: #005f94;
  border-color: #005f94;
}

.list-group-item-secondary {
  color: #5b5c60;
  background-color: #fafafc;
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: #5b5c60;
  background-color: #e1e1e3;
}
.list-group-item-secondary.list-group-item-action.active {
  color: #ffffff;
  background-color: #5b5c60;
  border-color: #5b5c60;
}

.list-group-item-success {
  color: #205237;
  background-color: #dcf5e7;
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: #205237;
  background-color: #c6ddd0;
}
.list-group-item-success.list-group-item-action.active {
  color: #ffffff;
  background-color: #205237;
  border-color: #205237;
}

.list-group-item-info {
  color: #44228c;
  background-color: #e3d7fb;
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: #44228c;
  background-color: #ccc2e2;
}
.list-group-item-info.list-group-item-action.active {
  color: #ffffff;
  background-color: #44228c;
  border-color: #44228c;
}

.list-group-item-warning {
  color: #665000;
  background-color: #fff4cc;
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: #665000;
  background-color: #e6dcb8;
}
.list-group-item-warning.list-group-item-action.active {
  color: #ffffff;
  background-color: #665000;
  border-color: #665000;
}

.list-group-item-danger {
  color: #912741;
  background-color: #fcd9e2;
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: #912741;
  background-color: #e3c3cb;
}
.list-group-item-danger.list-group-item-action.active {
  color: #ffffff;
  background-color: #912741;
  border-color: #912741;
}

.list-group-item-dark {
  color: #0e111e;
  background-color: #d1d2d6;
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: #0e111e;
  background-color: #bcbdc1;
}
.list-group-item-dark.list-group-item-action.active {
  color: #ffffff;
  background-color: #0e111e;
  border-color: #0e111e;
}

.btn-close {
  box-sizing: content-box;
  width: 0.75rem;
  height: 0.75rem;
  padding: 0.25em 0.25em;
  color: #000000;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_13___}) center/0.75rem auto no-repeat;
  border: 0;
  border-radius: 0.475rem;
  opacity: 0.5;
}
.btn-close:hover {
  color: #000000;
  text-decoration: none;
  opacity: 0.75;
}
.btn-close:focus {
  outline: 0;
  box-shadow: none;
  opacity: 1;
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.25;
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-border-width: 1px;
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: 0.475rem;
  --bs-toast-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --bs-toast-header-color: #7E8299;
  --bs-toast-header-bg: rgba(255, 255, 255, 0.85);
  --bs-toast-header-border-color: rgba(0, 0, 0, 0.05);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1.75rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: #ffffff;
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: 0;
  --bs-modal-border-radius: 0.475rem;
  --bs-modal-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
  --bs-modal-inner-border-radius: 0.475rem;
  --bs-modal-header-padding-x: 1.75rem;
  --bs-modal-header-padding-y: 1.75rem;
  --bs-modal-header-padding: 1.75rem 1.75rem;
  --bs-modal-header-border-color: #eff2f5;
  --bs-modal-header-border-width: 1px;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: #eff2f5;
  --bs-modal-footer-border-width: 1px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  box-shadow: var(--bs-modal-box-shadow);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000000;
  --bs-backdrop-opacity: 0.3;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  }

  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }

  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
.modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
.modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
.modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
.modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
.modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
.modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 1rem;
  --bs-tooltip-padding-y: 0.75rem;
  --bs-tooltip-margin: 0;
  --bs-tooltip-font-size: 0.925rem;
  --bs-tooltip-color: #3F4254;
  --bs-tooltip-bg: #ffffff;
  --bs-tooltip-border-radius: 0.475rem;
  --bs-tooltip-opacity: 1;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  padding: var(--bs-tooltip-arrow-height);
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: 0;
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: 0;
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: 0;
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: 0;
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 1rem;
  --bs-popover-bg: #ffffff;
  --bs-popover-border-width: 1px;
  --bs-popover-border-color: #ffffff;
  --bs-popover-border-radius: 0.475rem;
  --bs-popover-inner-border-radius: calc(0.475rem - 1px);
  --bs-popover-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --bs-popover-header-padding-x: 1.25rem;
  --bs-popover-header-padding-y: 1rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: #3F4254;
  --bs-popover-header-bg: #ffffff;
  --bs-popover-body-padding-x: 1.25rem;
  --bs-popover-body-padding-y: 1.25rem;
  --bs-popover-body-color: #3F4254;
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
  box-shadow: var(--bs-popover-box-shadow);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

/* rtl:begin:ignore */
.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

/* rtl:end:ignore */
.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #ffffff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
.carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #ffffff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #ffffff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #ffffff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000000;
}
.carousel-dark .carousel-caption {
  color: #000000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.185rem;
  --bs-spinner-animation-speed: 0.65s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.145em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.65s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
.spinner-grow {
    --bs-spinner-animation-speed: 1.3s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1.75rem;
  --bs-offcanvas-padding-y: 1.75rem;
  --bs-offcanvas-color: ;
  --bs-offcanvas-bg: #ffffff;
  --bs-offcanvas-border-width: 0;
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    box-shadow: var(--bs-offcanvas-box-shadow);
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  box-shadow: var(--bs-offcanvas-box-shadow);
  transition: transform 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.3;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000000 55%, rgba(0, 0, 0, 0.8) 75%, #000000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-white {
  color: #000000 !important;
  background-color: RGBA(255, 255, 255, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000000 !important;
  background-color: RGBA(245, 248, 250, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary {
  color: #000000 !important;
  background-color: RGBA(0, 158, 247, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #000000 !important;
  background-color: RGBA(228, 230, 239, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #000000 !important;
  background-color: RGBA(80, 205, 137, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #ffffff !important;
  background-color: RGBA(114, 57, 234, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000000 !important;
  background-color: RGBA(255, 199, 0, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #000000 !important;
  background-color: RGBA(241, 65, 108, var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #ffffff !important;
  background-color: RGBA(24, 28, 50, var(--bs-bg-opacity, 1)) !important;
}

.link-white {
  color: #ffffff !important;
}
.link-white:hover, .link-white:focus {
  color: white !important;
}

.link-light {
  color: #f5f8fa !important;
}
.link-light:hover, .link-light:focus {
  color: #f7f9fb !important;
}

.link-primary {
  color: #009ef7 !important;
}
.link-primary:hover, .link-primary:focus {
  color: #33b1f9 !important;
}

.link-secondary {
  color: #E4E6EF !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: #e9ebf2 !important;
}

.link-success {
  color: #50cd89 !important;
}
.link-success:hover, .link-success:focus {
  color: #73d7a1 !important;
}

.link-info {
  color: #7239ea !important;
}
.link-info:hover, .link-info:focus {
  color: #5b2ebb !important;
}

.link-warning {
  color: #ffc700 !important;
}
.link-warning:hover, .link-warning:focus {
  color: #ffd233 !important;
}

.link-danger {
  color: #f1416c !important;
}
.link-danger:hover, .link-danger:focus {
  color: #f46789 !important;
}

.link-dark {
  color: #181C32 !important;
}
.link-dark:hover, .link-dark:focus {
  color: #131628 !important;
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }

  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-5 {
  opacity: 0.05 !important;
}

.opacity-10 {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.opacity-20 {
  opacity: 0.2 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-sm {
  box-shadow: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-25 {
  top: 25% !important;
}

.top-50 {
  top: 50% !important;
}

.top-75 {
  top: 75% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-25 {
  bottom: 25% !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-75 {
  bottom: 75% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-25 {
  left: 25% !important;
}

.start-50 {
  left: 50% !important;
}

.start-75 {
  left: 75% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-25 {
  right: 25% !important;
}

.end-50 {
  right: 50% !important;
}

.end-75 {
  right: 75% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-0 {
  --bs-border-width: 0;
}

.border-1 {
  --bs-border-width: 1px;
}

.border-2 {
  --bs-border-width: 2px;
}

.border-3 {
  --bs-border-width: 3px;
}

.border-4 {
  --bs-border-width: 4px;
}

.border-5 {
  --bs-border-width: 5px;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-unset {
  width: unset !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.w-1px {
  width: 1px !important;
}

.w-2px {
  width: 2px !important;
}

.w-3px {
  width: 3px !important;
}

.w-4px {
  width: 4px !important;
}

.w-5px {
  width: 5px !important;
}

.w-6px {
  width: 6px !important;
}

.w-7px {
  width: 7px !important;
}

.w-8px {
  width: 8px !important;
}

.w-9px {
  width: 9px !important;
}

.w-10px {
  width: 10px !important;
}

.w-15px {
  width: 15px !important;
}

.w-20px {
  width: 20px !important;
}

.w-25px {
  width: 25px !important;
}

.w-30px {
  width: 30px !important;
}

.w-35px {
  width: 35px !important;
}

.w-40px {
  width: 40px !important;
}

.w-45px {
  width: 45px !important;
}

.w-50px {
  width: 50px !important;
}

.w-55px {
  width: 55px !important;
}

.w-60px {
  width: 60px !important;
}

.w-65px {
  width: 65px !important;
}

.w-70px {
  width: 70px !important;
}

.w-75px {
  width: 75px !important;
}

.w-80px {
  width: 80px !important;
}

.w-85px {
  width: 85px !important;
}

.w-90px {
  width: 90px !important;
}

.w-95px {
  width: 95px !important;
}

.w-100px {
  width: 100px !important;
}

.w-125px {
  width: 125px !important;
}

.w-150px {
  width: 150px !important;
}

.w-175px {
  width: 175px !important;
}

.w-200px {
  width: 200px !important;
}

.w-225px {
  width: 225px !important;
}

.w-250px {
  width: 250px !important;
}

.w-275px {
  width: 275px !important;
}

.w-300px {
  width: 300px !important;
}

.w-325px {
  width: 325px !important;
}

.w-350px {
  width: 350px !important;
}

.w-375px {
  width: 375px !important;
}

.w-400px {
  width: 400px !important;
}

.w-425px {
  width: 425px !important;
}

.w-450px {
  width: 450px !important;
}

.w-475px {
  width: 475px !important;
}

.w-500px {
  width: 500px !important;
}

.w-550px {
  width: 550px !important;
}

.w-600px {
  width: 600px !important;
}

.w-650px {
  width: 650px !important;
}

.w-700px {
  width: 700px !important;
}

.w-750px {
  width: 750px !important;
}

.w-800px {
  width: 800px !important;
}

.w-850px {
  width: 850px !important;
}

.w-900px {
  width: 900px !important;
}

.w-950px {
  width: 950px !important;
}

.w-1000px {
  width: 1000px !important;
}

.mw-unset {
  max-width: unset !important;
}

.mw-25 {
  max-width: 25% !important;
}

.mw-50 {
  max-width: 50% !important;
}

.mw-75 {
  max-width: 75% !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mw-auto {
  max-width: auto !important;
}

.mw-1px {
  max-width: 1px !important;
}

.mw-2px {
  max-width: 2px !important;
}

.mw-3px {
  max-width: 3px !important;
}

.mw-4px {
  max-width: 4px !important;
}

.mw-5px {
  max-width: 5px !important;
}

.mw-6px {
  max-width: 6px !important;
}

.mw-7px {
  max-width: 7px !important;
}

.mw-8px {
  max-width: 8px !important;
}

.mw-9px {
  max-width: 9px !important;
}

.mw-10px {
  max-width: 10px !important;
}

.mw-15px {
  max-width: 15px !important;
}

.mw-20px {
  max-width: 20px !important;
}

.mw-25px {
  max-width: 25px !important;
}

.mw-30px {
  max-width: 30px !important;
}

.mw-35px {
  max-width: 35px !important;
}

.mw-40px {
  max-width: 40px !important;
}

.mw-45px {
  max-width: 45px !important;
}

.mw-50px {
  max-width: 50px !important;
}

.mw-55px {
  max-width: 55px !important;
}

.mw-60px {
  max-width: 60px !important;
}

.mw-65px {
  max-width: 65px !important;
}

.mw-70px {
  max-width: 70px !important;
}

.mw-75px {
  max-width: 75px !important;
}

.mw-80px {
  max-width: 80px !important;
}

.mw-85px {
  max-width: 85px !important;
}

.mw-90px {
  max-width: 90px !important;
}

.mw-95px {
  max-width: 95px !important;
}

.mw-100px {
  max-width: 100px !important;
}

.mw-125px {
  max-width: 125px !important;
}

.mw-150px {
  max-width: 150px !important;
}

.mw-175px {
  max-width: 175px !important;
}

.mw-200px {
  max-width: 200px !important;
}

.mw-225px {
  max-width: 225px !important;
}

.mw-250px {
  max-width: 250px !important;
}

.mw-275px {
  max-width: 275px !important;
}

.mw-300px {
  max-width: 300px !important;
}

.mw-325px {
  max-width: 325px !important;
}

.mw-350px {
  max-width: 350px !important;
}

.mw-375px {
  max-width: 375px !important;
}

.mw-400px {
  max-width: 400px !important;
}

.mw-425px {
  max-width: 425px !important;
}

.mw-450px {
  max-width: 450px !important;
}

.mw-475px {
  max-width: 475px !important;
}

.mw-500px {
  max-width: 500px !important;
}

.mw-550px {
  max-width: 550px !important;
}

.mw-600px {
  max-width: 600px !important;
}

.mw-650px {
  max-width: 650px !important;
}

.mw-700px {
  max-width: 700px !important;
}

.mw-750px {
  max-width: 750px !important;
}

.mw-800px {
  max-width: 800px !important;
}

.mw-850px {
  max-width: 850px !important;
}

.mw-900px {
  max-width: 900px !important;
}

.mw-950px {
  max-width: 950px !important;
}

.mw-1000px {
  max-width: 1000px !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-unset {
  height: unset !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.h-1px {
  height: 1px !important;
}

.h-2px {
  height: 2px !important;
}

.h-3px {
  height: 3px !important;
}

.h-4px {
  height: 4px !important;
}

.h-5px {
  height: 5px !important;
}

.h-6px {
  height: 6px !important;
}

.h-7px {
  height: 7px !important;
}

.h-8px {
  height: 8px !important;
}

.h-9px {
  height: 9px !important;
}

.h-10px {
  height: 10px !important;
}

.h-15px {
  height: 15px !important;
}

.h-20px {
  height: 20px !important;
}

.h-25px {
  height: 25px !important;
}

.h-30px {
  height: 30px !important;
}

.h-35px {
  height: 35px !important;
}

.h-40px {
  height: 40px !important;
}

.h-45px {
  height: 45px !important;
}

.h-50px {
  height: 50px !important;
}

.h-55px {
  height: 55px !important;
}

.h-60px {
  height: 60px !important;
}

.h-65px {
  height: 65px !important;
}

.h-70px {
  height: 70px !important;
}

.h-75px {
  height: 75px !important;
}

.h-80px {
  height: 80px !important;
}

.h-85px {
  height: 85px !important;
}

.h-90px {
  height: 90px !important;
}

.h-95px {
  height: 95px !important;
}

.h-100px {
  height: 100px !important;
}

.h-125px {
  height: 125px !important;
}

.h-150px {
  height: 150px !important;
}

.h-175px {
  height: 175px !important;
}

.h-200px {
  height: 200px !important;
}

.h-225px {
  height: 225px !important;
}

.h-250px {
  height: 250px !important;
}

.h-275px {
  height: 275px !important;
}

.h-300px {
  height: 300px !important;
}

.h-325px {
  height: 325px !important;
}

.h-350px {
  height: 350px !important;
}

.h-375px {
  height: 375px !important;
}

.h-400px {
  height: 400px !important;
}

.h-425px {
  height: 425px !important;
}

.h-450px {
  height: 450px !important;
}

.h-475px {
  height: 475px !important;
}

.h-500px {
  height: 500px !important;
}

.h-550px {
  height: 550px !important;
}

.h-600px {
  height: 600px !important;
}

.h-650px {
  height: 650px !important;
}

.h-700px {
  height: 700px !important;
}

.h-750px {
  height: 750px !important;
}

.h-800px {
  height: 800px !important;
}

.h-850px {
  height: 850px !important;
}

.h-900px {
  height: 900px !important;
}

.h-950px {
  height: 950px !important;
}

.h-1000px {
  height: 1000px !important;
}

.mh-unset {
  max-height: unset !important;
}

.mh-25 {
  max-height: 25% !important;
}

.mh-50 {
  max-height: 50% !important;
}

.mh-75 {
  max-height: 75% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.mh-auto {
  max-height: auto !important;
}

.mh-1px {
  max-height: 1px !important;
}

.mh-2px {
  max-height: 2px !important;
}

.mh-3px {
  max-height: 3px !important;
}

.mh-4px {
  max-height: 4px !important;
}

.mh-5px {
  max-height: 5px !important;
}

.mh-6px {
  max-height: 6px !important;
}

.mh-7px {
  max-height: 7px !important;
}

.mh-8px {
  max-height: 8px !important;
}

.mh-9px {
  max-height: 9px !important;
}

.mh-10px {
  max-height: 10px !important;
}

.mh-15px {
  max-height: 15px !important;
}

.mh-20px {
  max-height: 20px !important;
}

.mh-25px {
  max-height: 25px !important;
}

.mh-30px {
  max-height: 30px !important;
}

.mh-35px {
  max-height: 35px !important;
}

.mh-40px {
  max-height: 40px !important;
}

.mh-45px {
  max-height: 45px !important;
}

.mh-50px {
  max-height: 50px !important;
}

.mh-55px {
  max-height: 55px !important;
}

.mh-60px {
  max-height: 60px !important;
}

.mh-65px {
  max-height: 65px !important;
}

.mh-70px {
  max-height: 70px !important;
}

.mh-75px {
  max-height: 75px !important;
}

.mh-80px {
  max-height: 80px !important;
}

.mh-85px {
  max-height: 85px !important;
}

.mh-90px {
  max-height: 90px !important;
}

.mh-95px {
  max-height: 95px !important;
}

.mh-100px {
  max-height: 100px !important;
}

.mh-125px {
  max-height: 125px !important;
}

.mh-150px {
  max-height: 150px !important;
}

.mh-175px {
  max-height: 175px !important;
}

.mh-200px {
  max-height: 200px !important;
}

.mh-225px {
  max-height: 225px !important;
}

.mh-250px {
  max-height: 250px !important;
}

.mh-275px {
  max-height: 275px !important;
}

.mh-300px {
  max-height: 300px !important;
}

.mh-325px {
  max-height: 325px !important;
}

.mh-350px {
  max-height: 350px !important;
}

.mh-375px {
  max-height: 375px !important;
}

.mh-400px {
  max-height: 400px !important;
}

.mh-425px {
  max-height: 425px !important;
}

.mh-450px {
  max-height: 450px !important;
}

.mh-475px {
  max-height: 475px !important;
}

.mh-500px {
  max-height: 500px !important;
}

.mh-550px {
  max-height: 550px !important;
}

.mh-600px {
  max-height: 600px !important;
}

.mh-650px {
  max-height: 650px !important;
}

.mh-700px {
  max-height: 700px !important;
}

.mh-750px {
  max-height: 750px !important;
}

.mh-800px {
  max-height: 800px !important;
}

.mh-850px {
  max-height: 850px !important;
}

.mh-900px {
  max-height: 900px !important;
}

.mh-950px {
  max-height: 950px !important;
}

.mh-1000px {
  max-height: 1000px !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 0.75rem !important;
}

.m-4 {
  margin: 1rem !important;
}

.m-5 {
  margin: 1.25rem !important;
}

.m-6 {
  margin: 1.5rem !important;
}

.m-7 {
  margin: 1.75rem !important;
}

.m-8 {
  margin: 2rem !important;
}

.m-9 {
  margin: 2.25rem !important;
}

.m-10 {
  margin: 2.5rem !important;
}

.m-11 {
  margin: 2.75rem !important;
}

.m-12 {
  margin: 3rem !important;
}

.m-13 {
  margin: 3.25rem !important;
}

.m-14 {
  margin: 3.5rem !important;
}

.m-15 {
  margin: 3.75rem !important;
}

.m-16 {
  margin: 4rem !important;
}

.m-17 {
  margin: 4.25rem !important;
}

.m-18 {
  margin: 4.5rem !important;
}

.m-19 {
  margin: 4.75rem !important;
}

.m-20 {
  margin: 5rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 0.75rem !important;
  margin-left: 0.75rem !important;
}

.mx-4 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-5 {
  margin-right: 1.25rem !important;
  margin-left: 1.25rem !important;
}

.mx-6 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-7 {
  margin-right: 1.75rem !important;
  margin-left: 1.75rem !important;
}

.mx-8 {
  margin-right: 2rem !important;
  margin-left: 2rem !important;
}

.mx-9 {
  margin-right: 2.25rem !important;
  margin-left: 2.25rem !important;
}

.mx-10 {
  margin-right: 2.5rem !important;
  margin-left: 2.5rem !important;
}

.mx-11 {
  margin-right: 2.75rem !important;
  margin-left: 2.75rem !important;
}

.mx-12 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-13 {
  margin-right: 3.25rem !important;
  margin-left: 3.25rem !important;
}

.mx-14 {
  margin-right: 3.5rem !important;
  margin-left: 3.5rem !important;
}

.mx-15 {
  margin-right: 3.75rem !important;
  margin-left: 3.75rem !important;
}

.mx-16 {
  margin-right: 4rem !important;
  margin-left: 4rem !important;
}

.mx-17 {
  margin-right: 4.25rem !important;
  margin-left: 4.25rem !important;
}

.mx-18 {
  margin-right: 4.5rem !important;
  margin-left: 4.5rem !important;
}

.mx-19 {
  margin-right: 4.75rem !important;
  margin-left: 4.75rem !important;
}

.mx-20 {
  margin-right: 5rem !important;
  margin-left: 5rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}

.my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-5 {
  margin-top: 1.25rem !important;
  margin-bottom: 1.25rem !important;
}

.my-6 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-7 {
  margin-top: 1.75rem !important;
  margin-bottom: 1.75rem !important;
}

.my-8 {
  margin-top: 2rem !important;
  margin-bottom: 2rem !important;
}

.my-9 {
  margin-top: 2.25rem !important;
  margin-bottom: 2.25rem !important;
}

.my-10 {
  margin-top: 2.5rem !important;
  margin-bottom: 2.5rem !important;
}

.my-11 {
  margin-top: 2.75rem !important;
  margin-bottom: 2.75rem !important;
}

.my-12 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-13 {
  margin-top: 3.25rem !important;
  margin-bottom: 3.25rem !important;
}

.my-14 {
  margin-top: 3.5rem !important;
  margin-bottom: 3.5rem !important;
}

.my-15 {
  margin-top: 3.75rem !important;
  margin-bottom: 3.75rem !important;
}

.my-16 {
  margin-top: 4rem !important;
  margin-bottom: 4rem !important;
}

.my-17 {
  margin-top: 4.25rem !important;
  margin-bottom: 4.25rem !important;
}

.my-18 {
  margin-top: 4.5rem !important;
  margin-bottom: 4.5rem !important;
}

.my-19 {
  margin-top: 4.75rem !important;
  margin-bottom: 4.75rem !important;
}

.my-20 {
  margin-top: 5rem !important;
  margin-bottom: 5rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 0.75rem !important;
}

.mt-4 {
  margin-top: 1rem !important;
}

.mt-5 {
  margin-top: 1.25rem !important;
}

.mt-6 {
  margin-top: 1.5rem !important;
}

.mt-7 {
  margin-top: 1.75rem !important;
}

.mt-8 {
  margin-top: 2rem !important;
}

.mt-9 {
  margin-top: 2.25rem !important;
}

.mt-10 {
  margin-top: 2.5rem !important;
}

.mt-11 {
  margin-top: 2.75rem !important;
}

.mt-12 {
  margin-top: 3rem !important;
}

.mt-13 {
  margin-top: 3.25rem !important;
}

.mt-14 {
  margin-top: 3.5rem !important;
}

.mt-15 {
  margin-top: 3.75rem !important;
}

.mt-16 {
  margin-top: 4rem !important;
}

.mt-17 {
  margin-top: 4.25rem !important;
}

.mt-18 {
  margin-top: 4.5rem !important;
}

.mt-19 {
  margin-top: 4.75rem !important;
}

.mt-20 {
  margin-top: 5rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 0.75rem !important;
}

.me-4 {
  margin-right: 1rem !important;
}

.me-5 {
  margin-right: 1.25rem !important;
}

.me-6 {
  margin-right: 1.5rem !important;
}

.me-7 {
  margin-right: 1.75rem !important;
}

.me-8 {
  margin-right: 2rem !important;
}

.me-9 {
  margin-right: 2.25rem !important;
}

.me-10 {
  margin-right: 2.5rem !important;
}

.me-11 {
  margin-right: 2.75rem !important;
}

.me-12 {
  margin-right: 3rem !important;
}

.me-13 {
  margin-right: 3.25rem !important;
}

.me-14 {
  margin-right: 3.5rem !important;
}

.me-15 {
  margin-right: 3.75rem !important;
}

.me-16 {
  margin-right: 4rem !important;
}

.me-17 {
  margin-right: 4.25rem !important;
}

.me-18 {
  margin-right: 4.5rem !important;
}

.me-19 {
  margin-right: 4.75rem !important;
}

.me-20 {
  margin-right: 5rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 0.75rem !important;
}

.mb-4 {
  margin-bottom: 1rem !important;
}

.mb-5 {
  margin-bottom: 1.25rem !important;
}

.mb-6 {
  margin-bottom: 1.5rem !important;
}

.mb-7 {
  margin-bottom: 1.75rem !important;
}

.mb-8 {
  margin-bottom: 2rem !important;
}

.mb-9 {
  margin-bottom: 2.25rem !important;
}

.mb-10 {
  margin-bottom: 2.5rem !important;
}

.mb-11 {
  margin-bottom: 2.75rem !important;
}

.mb-12 {
  margin-bottom: 3rem !important;
}

.mb-13 {
  margin-bottom: 3.25rem !important;
}

.mb-14 {
  margin-bottom: 3.5rem !important;
}

.mb-15 {
  margin-bottom: 3.75rem !important;
}

.mb-16 {
  margin-bottom: 4rem !important;
}

.mb-17 {
  margin-bottom: 4.25rem !important;
}

.mb-18 {
  margin-bottom: 4.5rem !important;
}

.mb-19 {
  margin-bottom: 4.75rem !important;
}

.mb-20 {
  margin-bottom: 5rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 0.75rem !important;
}

.ms-4 {
  margin-left: 1rem !important;
}

.ms-5 {
  margin-left: 1.25rem !important;
}

.ms-6 {
  margin-left: 1.5rem !important;
}

.ms-7 {
  margin-left: 1.75rem !important;
}

.ms-8 {
  margin-left: 2rem !important;
}

.ms-9 {
  margin-left: 2.25rem !important;
}

.ms-10 {
  margin-left: 2.5rem !important;
}

.ms-11 {
  margin-left: 2.75rem !important;
}

.ms-12 {
  margin-left: 3rem !important;
}

.ms-13 {
  margin-left: 3.25rem !important;
}

.ms-14 {
  margin-left: 3.5rem !important;
}

.ms-15 {
  margin-left: 3.75rem !important;
}

.ms-16 {
  margin-left: 4rem !important;
}

.ms-17 {
  margin-left: 4.25rem !important;
}

.ms-18 {
  margin-left: 4.5rem !important;
}

.ms-19 {
  margin-left: 4.75rem !important;
}

.ms-20 {
  margin-left: 5rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -0.75rem !important;
}

.m-n4 {
  margin: -1rem !important;
}

.m-n5 {
  margin: -1.25rem !important;
}

.m-n6 {
  margin: -1.5rem !important;
}

.m-n7 {
  margin: -1.75rem !important;
}

.m-n8 {
  margin: -2rem !important;
}

.m-n9 {
  margin: -2.25rem !important;
}

.m-n10 {
  margin: -2.5rem !important;
}

.m-n11 {
  margin: -2.75rem !important;
}

.m-n12 {
  margin: -3rem !important;
}

.m-n13 {
  margin: -3.25rem !important;
}

.m-n14 {
  margin: -3.5rem !important;
}

.m-n15 {
  margin: -3.75rem !important;
}

.m-n16 {
  margin: -4rem !important;
}

.m-n17 {
  margin: -4.25rem !important;
}

.m-n18 {
  margin: -4.5rem !important;
}

.m-n19 {
  margin: -4.75rem !important;
}

.m-n20 {
  margin: -5rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -0.75rem !important;
  margin-left: -0.75rem !important;
}

.mx-n4 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n5 {
  margin-right: -1.25rem !important;
  margin-left: -1.25rem !important;
}

.mx-n6 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n7 {
  margin-right: -1.75rem !important;
  margin-left: -1.75rem !important;
}

.mx-n8 {
  margin-right: -2rem !important;
  margin-left: -2rem !important;
}

.mx-n9 {
  margin-right: -2.25rem !important;
  margin-left: -2.25rem !important;
}

.mx-n10 {
  margin-right: -2.5rem !important;
  margin-left: -2.5rem !important;
}

.mx-n11 {
  margin-right: -2.75rem !important;
  margin-left: -2.75rem !important;
}

.mx-n12 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.mx-n13 {
  margin-right: -3.25rem !important;
  margin-left: -3.25rem !important;
}

.mx-n14 {
  margin-right: -3.5rem !important;
  margin-left: -3.5rem !important;
}

.mx-n15 {
  margin-right: -3.75rem !important;
  margin-left: -3.75rem !important;
}

.mx-n16 {
  margin-right: -4rem !important;
  margin-left: -4rem !important;
}

.mx-n17 {
  margin-right: -4.25rem !important;
  margin-left: -4.25rem !important;
}

.mx-n18 {
  margin-right: -4.5rem !important;
  margin-left: -4.5rem !important;
}

.mx-n19 {
  margin-right: -4.75rem !important;
  margin-left: -4.75rem !important;
}

.mx-n20 {
  margin-right: -5rem !important;
  margin-left: -5rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -0.75rem !important;
  margin-bottom: -0.75rem !important;
}

.my-n4 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n5 {
  margin-top: -1.25rem !important;
  margin-bottom: -1.25rem !important;
}

.my-n6 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n7 {
  margin-top: -1.75rem !important;
  margin-bottom: -1.75rem !important;
}

.my-n8 {
  margin-top: -2rem !important;
  margin-bottom: -2rem !important;
}

.my-n9 {
  margin-top: -2.25rem !important;
  margin-bottom: -2.25rem !important;
}

.my-n10 {
  margin-top: -2.5rem !important;
  margin-bottom: -2.5rem !important;
}

.my-n11 {
  margin-top: -2.75rem !important;
  margin-bottom: -2.75rem !important;
}

.my-n12 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.my-n13 {
  margin-top: -3.25rem !important;
  margin-bottom: -3.25rem !important;
}

.my-n14 {
  margin-top: -3.5rem !important;
  margin-bottom: -3.5rem !important;
}

.my-n15 {
  margin-top: -3.75rem !important;
  margin-bottom: -3.75rem !important;
}

.my-n16 {
  margin-top: -4rem !important;
  margin-bottom: -4rem !important;
}

.my-n17 {
  margin-top: -4.25rem !important;
  margin-bottom: -4.25rem !important;
}

.my-n18 {
  margin-top: -4.5rem !important;
  margin-bottom: -4.5rem !important;
}

.my-n19 {
  margin-top: -4.75rem !important;
  margin-bottom: -4.75rem !important;
}

.my-n20 {
  margin-top: -5rem !important;
  margin-bottom: -5rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -0.75rem !important;
}

.mt-n4 {
  margin-top: -1rem !important;
}

.mt-n5 {
  margin-top: -1.25rem !important;
}

.mt-n6 {
  margin-top: -1.5rem !important;
}

.mt-n7 {
  margin-top: -1.75rem !important;
}

.mt-n8 {
  margin-top: -2rem !important;
}

.mt-n9 {
  margin-top: -2.25rem !important;
}

.mt-n10 {
  margin-top: -2.5rem !important;
}

.mt-n11 {
  margin-top: -2.75rem !important;
}

.mt-n12 {
  margin-top: -3rem !important;
}

.mt-n13 {
  margin-top: -3.25rem !important;
}

.mt-n14 {
  margin-top: -3.5rem !important;
}

.mt-n15 {
  margin-top: -3.75rem !important;
}

.mt-n16 {
  margin-top: -4rem !important;
}

.mt-n17 {
  margin-top: -4.25rem !important;
}

.mt-n18 {
  margin-top: -4.5rem !important;
}

.mt-n19 {
  margin-top: -4.75rem !important;
}

.mt-n20 {
  margin-top: -5rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -0.75rem !important;
}

.me-n4 {
  margin-right: -1rem !important;
}

.me-n5 {
  margin-right: -1.25rem !important;
}

.me-n6 {
  margin-right: -1.5rem !important;
}

.me-n7 {
  margin-right: -1.75rem !important;
}

.me-n8 {
  margin-right: -2rem !important;
}

.me-n9 {
  margin-right: -2.25rem !important;
}

.me-n10 {
  margin-right: -2.5rem !important;
}

.me-n11 {
  margin-right: -2.75rem !important;
}

.me-n12 {
  margin-right: -3rem !important;
}

.me-n13 {
  margin-right: -3.25rem !important;
}

.me-n14 {
  margin-right: -3.5rem !important;
}

.me-n15 {
  margin-right: -3.75rem !important;
}

.me-n16 {
  margin-right: -4rem !important;
}

.me-n17 {
  margin-right: -4.25rem !important;
}

.me-n18 {
  margin-right: -4.5rem !important;
}

.me-n19 {
  margin-right: -4.75rem !important;
}

.me-n20 {
  margin-right: -5rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -0.75rem !important;
}

.mb-n4 {
  margin-bottom: -1rem !important;
}

.mb-n5 {
  margin-bottom: -1.25rem !important;
}

.mb-n6 {
  margin-bottom: -1.5rem !important;
}

.mb-n7 {
  margin-bottom: -1.75rem !important;
}

.mb-n8 {
  margin-bottom: -2rem !important;
}

.mb-n9 {
  margin-bottom: -2.25rem !important;
}

.mb-n10 {
  margin-bottom: -2.5rem !important;
}

.mb-n11 {
  margin-bottom: -2.75rem !important;
}

.mb-n12 {
  margin-bottom: -3rem !important;
}

.mb-n13 {
  margin-bottom: -3.25rem !important;
}

.mb-n14 {
  margin-bottom: -3.5rem !important;
}

.mb-n15 {
  margin-bottom: -3.75rem !important;
}

.mb-n16 {
  margin-bottom: -4rem !important;
}

.mb-n17 {
  margin-bottom: -4.25rem !important;
}

.mb-n18 {
  margin-bottom: -4.5rem !important;
}

.mb-n19 {
  margin-bottom: -4.75rem !important;
}

.mb-n20 {
  margin-bottom: -5rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -0.75rem !important;
}

.ms-n4 {
  margin-left: -1rem !important;
}

.ms-n5 {
  margin-left: -1.25rem !important;
}

.ms-n6 {
  margin-left: -1.5rem !important;
}

.ms-n7 {
  margin-left: -1.75rem !important;
}

.ms-n8 {
  margin-left: -2rem !important;
}

.ms-n9 {
  margin-left: -2.25rem !important;
}

.ms-n10 {
  margin-left: -2.5rem !important;
}

.ms-n11 {
  margin-left: -2.75rem !important;
}

.ms-n12 {
  margin-left: -3rem !important;
}

.ms-n13 {
  margin-left: -3.25rem !important;
}

.ms-n14 {
  margin-left: -3.5rem !important;
}

.ms-n15 {
  margin-left: -3.75rem !important;
}

.ms-n16 {
  margin-left: -4rem !important;
}

.ms-n17 {
  margin-left: -4.25rem !important;
}

.ms-n18 {
  margin-left: -4.5rem !important;
}

.ms-n19 {
  margin-left: -4.75rem !important;
}

.ms-n20 {
  margin-left: -5rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 0.75rem !important;
}

.p-4 {
  padding: 1rem !important;
}

.p-5 {
  padding: 1.25rem !important;
}

.p-6 {
  padding: 1.5rem !important;
}

.p-7 {
  padding: 1.75rem !important;
}

.p-8 {
  padding: 2rem !important;
}

.p-9 {
  padding: 2.25rem !important;
}

.p-10 {
  padding: 2.5rem !important;
}

.p-11 {
  padding: 2.75rem !important;
}

.p-12 {
  padding: 3rem !important;
}

.p-13 {
  padding: 3.25rem !important;
}

.p-14 {
  padding: 3.5rem !important;
}

.p-15 {
  padding: 3.75rem !important;
}

.p-16 {
  padding: 4rem !important;
}

.p-17 {
  padding: 4.25rem !important;
}

.p-18 {
  padding: 4.5rem !important;
}

.p-19 {
  padding: 4.75rem !important;
}

.p-20 {
  padding: 5rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 0.75rem !important;
  padding-left: 0.75rem !important;
}

.px-4 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-5 {
  padding-right: 1.25rem !important;
  padding-left: 1.25rem !important;
}

.px-6 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-7 {
  padding-right: 1.75rem !important;
  padding-left: 1.75rem !important;
}

.px-8 {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}

.px-9 {
  padding-right: 2.25rem !important;
  padding-left: 2.25rem !important;
}

.px-10 {
  padding-right: 2.5rem !important;
  padding-left: 2.5rem !important;
}

.px-11 {
  padding-right: 2.75rem !important;
  padding-left: 2.75rem !important;
}

.px-12 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.px-13 {
  padding-right: 3.25rem !important;
  padding-left: 3.25rem !important;
}

.px-14 {
  padding-right: 3.5rem !important;
  padding-left: 3.5rem !important;
}

.px-15 {
  padding-right: 3.75rem !important;
  padding-left: 3.75rem !important;
}

.px-16 {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}

.px-17 {
  padding-right: 4.25rem !important;
  padding-left: 4.25rem !important;
}

.px-18 {
  padding-right: 4.5rem !important;
  padding-left: 4.5rem !important;
}

.px-19 {
  padding-right: 4.75rem !important;
  padding-left: 4.75rem !important;
}

.px-20 {
  padding-right: 5rem !important;
  padding-left: 5rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-5 {
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}

.py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-7 {
  padding-top: 1.75rem !important;
  padding-bottom: 1.75rem !important;
}

.py-8 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.py-9 {
  padding-top: 2.25rem !important;
  padding-bottom: 2.25rem !important;
}

.py-10 {
  padding-top: 2.5rem !important;
  padding-bottom: 2.5rem !important;
}

.py-11 {
  padding-top: 2.75rem !important;
  padding-bottom: 2.75rem !important;
}

.py-12 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.py-13 {
  padding-top: 3.25rem !important;
  padding-bottom: 3.25rem !important;
}

.py-14 {
  padding-top: 3.5rem !important;
  padding-bottom: 3.5rem !important;
}

.py-15 {
  padding-top: 3.75rem !important;
  padding-bottom: 3.75rem !important;
}

.py-16 {
  padding-top: 4rem !important;
  padding-bottom: 4rem !important;
}

.py-17 {
  padding-top: 4.25rem !important;
  padding-bottom: 4.25rem !important;
}

.py-18 {
  padding-top: 4.5rem !important;
  padding-bottom: 4.5rem !important;
}

.py-19 {
  padding-top: 4.75rem !important;
  padding-bottom: 4.75rem !important;
}

.py-20 {
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 0.75rem !important;
}

.pt-4 {
  padding-top: 1rem !important;
}

.pt-5 {
  padding-top: 1.25rem !important;
}

.pt-6 {
  padding-top: 1.5rem !important;
}

.pt-7 {
  padding-top: 1.75rem !important;
}

.pt-8 {
  padding-top: 2rem !important;
}

.pt-9 {
  padding-top: 2.25rem !important;
}

.pt-10 {
  padding-top: 2.5rem !important;
}

.pt-11 {
  padding-top: 2.75rem !important;
}

.pt-12 {
  padding-top: 3rem !important;
}

.pt-13 {
  padding-top: 3.25rem !important;
}

.pt-14 {
  padding-top: 3.5rem !important;
}

.pt-15 {
  padding-top: 3.75rem !important;
}

.pt-16 {
  padding-top: 4rem !important;
}

.pt-17 {
  padding-top: 4.25rem !important;
}

.pt-18 {
  padding-top: 4.5rem !important;
}

.pt-19 {
  padding-top: 4.75rem !important;
}

.pt-20 {
  padding-top: 5rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 0.75rem !important;
}

.pe-4 {
  padding-right: 1rem !important;
}

.pe-5 {
  padding-right: 1.25rem !important;
}

.pe-6 {
  padding-right: 1.5rem !important;
}

.pe-7 {
  padding-right: 1.75rem !important;
}

.pe-8 {
  padding-right: 2rem !important;
}

.pe-9 {
  padding-right: 2.25rem !important;
}

.pe-10 {
  padding-right: 2.5rem !important;
}

.pe-11 {
  padding-right: 2.75rem !important;
}

.pe-12 {
  padding-right: 3rem !important;
}

.pe-13 {
  padding-right: 3.25rem !important;
}

.pe-14 {
  padding-right: 3.5rem !important;
}

.pe-15 {
  padding-right: 3.75rem !important;
}

.pe-16 {
  padding-right: 4rem !important;
}

.pe-17 {
  padding-right: 4.25rem !important;
}

.pe-18 {
  padding-right: 4.5rem !important;
}

.pe-19 {
  padding-right: 4.75rem !important;
}

.pe-20 {
  padding-right: 5rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 0.75rem !important;
}

.pb-4 {
  padding-bottom: 1rem !important;
}

.pb-5 {
  padding-bottom: 1.25rem !important;
}

.pb-6 {
  padding-bottom: 1.5rem !important;
}

.pb-7 {
  padding-bottom: 1.75rem !important;
}

.pb-8 {
  padding-bottom: 2rem !important;
}

.pb-9 {
  padding-bottom: 2.25rem !important;
}

.pb-10 {
  padding-bottom: 2.5rem !important;
}

.pb-11 {
  padding-bottom: 2.75rem !important;
}

.pb-12 {
  padding-bottom: 3rem !important;
}

.pb-13 {
  padding-bottom: 3.25rem !important;
}

.pb-14 {
  padding-bottom: 3.5rem !important;
}

.pb-15 {
  padding-bottom: 3.75rem !important;
}

.pb-16 {
  padding-bottom: 4rem !important;
}

.pb-17 {
  padding-bottom: 4.25rem !important;
}

.pb-18 {
  padding-bottom: 4.5rem !important;
}

.pb-19 {
  padding-bottom: 4.75rem !important;
}

.pb-20 {
  padding-bottom: 5rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 0.75rem !important;
}

.ps-4 {
  padding-left: 1rem !important;
}

.ps-5 {
  padding-left: 1.25rem !important;
}

.ps-6 {
  padding-left: 1.5rem !important;
}

.ps-7 {
  padding-left: 1.75rem !important;
}

.ps-8 {
  padding-left: 2rem !important;
}

.ps-9 {
  padding-left: 2.25rem !important;
}

.ps-10 {
  padding-left: 2.5rem !important;
}

.ps-11 {
  padding-left: 2.75rem !important;
}

.ps-12 {
  padding-left: 3rem !important;
}

.ps-13 {
  padding-left: 3.25rem !important;
}

.ps-14 {
  padding-left: 3.5rem !important;
}

.ps-15 {
  padding-left: 3.75rem !important;
}

.ps-16 {
  padding-left: 4rem !important;
}

.ps-17 {
  padding-left: 4.25rem !important;
}

.ps-18 {
  padding-left: 4.5rem !important;
}

.ps-19 {
  padding-left: 4.75rem !important;
}

.ps-20 {
  padding-left: 5rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 0.75rem !important;
}

.gap-4 {
  gap: 1rem !important;
}

.gap-5 {
  gap: 1.25rem !important;
}

.gap-6 {
  gap: 1.5rem !important;
}

.gap-7 {
  gap: 1.75rem !important;
}

.gap-8 {
  gap: 2rem !important;
}

.gap-9 {
  gap: 2.25rem !important;
}

.gap-10 {
  gap: 2.5rem !important;
}

.gap-11 {
  gap: 2.75rem !important;
}

.gap-12 {
  gap: 3rem !important;
}

.gap-13 {
  gap: 3.25rem !important;
}

.gap-14 {
  gap: 3.5rem !important;
}

.gap-15 {
  gap: 3.75rem !important;
}

.gap-16 {
  gap: 4rem !important;
}

.gap-17 {
  gap: 4.25rem !important;
}

.gap-18 {
  gap: 4.5rem !important;
}

.gap-19 {
  gap: 4.75rem !important;
}

.gap-20 {
  gap: 5rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-2 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-3 {
  font-size: calc(1.26rem + 0.12vw) !important;
}

.fs-4 {
  font-size: 1.25rem !important;
}

.fs-5 {
  font-size: 1.15rem !important;
}

.fs-6 {
  font-size: 1.075rem !important;
}

.fs-7 {
  font-size: 0.95rem !important;
}

.fs-8 {
  font-size: 0.85rem !important;
}

.fs-9 {
  font-size: 0.75rem !important;
}

.fs-10 {
  font-size: 0.5rem !important;
}

.fs-base {
  font-size: 1rem !important;
}

.fs-fluid {
  font-size: 100% !important;
}

.fs-2x {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-2qx {
  font-size: calc(1.35rem + 1.2vw) !important;
}

.fs-2hx {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2tx {
  font-size: calc(1.4rem + 1.8vw) !important;
}

.fs-3x {
  font-size: calc(1.425rem + 2.1vw) !important;
}

.fs-3qx {
  font-size: calc(1.45rem + 2.4vw) !important;
}

.fs-3hx {
  font-size: calc(1.475rem + 2.7vw) !important;
}

.fs-3tx {
  font-size: calc(1.5rem + 3vw) !important;
}

.fs-4x {
  font-size: calc(1.525rem + 3.3vw) !important;
}

.fs-4qx {
  font-size: calc(1.55rem + 3.6vw) !important;
}

.fs-4hx {
  font-size: calc(1.575rem + 3.9vw) !important;
}

.fs-4tx {
  font-size: calc(1.6rem + 4.2vw) !important;
}

.fs-5x {
  font-size: calc(1.625rem + 4.5vw) !important;
}

.fs-5qx {
  font-size: calc(1.65rem + 4.8vw) !important;
}

.fs-5hx {
  font-size: calc(1.675rem + 5.1vw) !important;
}

.fs-5tx {
  font-size: calc(1.7rem + 5.4vw) !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-bold {
  font-weight: 600 !important;
}

.fw-semibold {
  font-weight: 500 !important;
}

.fw-bolder {
  font-weight: 700 !important;
}

.lh-0 {
  line-height: 0 !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 1.75 !important;
}

.lh-xl {
  line-height: 2 !important;
}

.lh-xxl {
  line-height: 2.25 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: #A1A5B7 !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: 0.475rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: 0.425rem !important;
}

.rounded-2 {
  border-radius: 0.475rem !important;
}

.rounded-3 {
  border-radius: 0.625rem !important;
}

.rounded-4 {
  border-radius: 1rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-0-hover:hover {
  opacity: 0 !important;
}

.opacity-5 {
  opacity: 0.05 !important;
}

.opacity-5-hover:hover {
  opacity: 0.05 !important;
}

.opacity-10 {
  opacity: 0.1 !important;
}

.opacity-10-hover:hover {
  opacity: 0.1 !important;
}

.opacity-15 {
  opacity: 0.15 !important;
}

.opacity-15-hover:hover {
  opacity: 0.15 !important;
}

.opacity-20 {
  opacity: 0.2 !important;
}

.opacity-20-hover:hover {
  opacity: 0.2 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-25-hover:hover {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-50-hover:hover {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-75-hover:hover {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.opacity-100-hover:hover {
  opacity: 1 !important;
}

.min-w-unset {
  min-width: unset !important;
}

.min-w-25 {
  min-width: 25% !important;
}

.min-w-50 {
  min-width: 50% !important;
}

.min-w-75 {
  min-width: 75% !important;
}

.min-w-100 {
  min-width: 100% !important;
}

.min-w-auto {
  min-width: auto !important;
}

.min-w-1px {
  min-width: 1px !important;
}

.min-w-2px {
  min-width: 2px !important;
}

.min-w-3px {
  min-width: 3px !important;
}

.min-w-4px {
  min-width: 4px !important;
}

.min-w-5px {
  min-width: 5px !important;
}

.min-w-6px {
  min-width: 6px !important;
}

.min-w-7px {
  min-width: 7px !important;
}

.min-w-8px {
  min-width: 8px !important;
}

.min-w-9px {
  min-width: 9px !important;
}

.min-w-10px {
  min-width: 10px !important;
}

.min-w-15px {
  min-width: 15px !important;
}

.min-w-20px {
  min-width: 20px !important;
}

.min-w-25px {
  min-width: 25px !important;
}

.min-w-30px {
  min-width: 30px !important;
}

.min-w-35px {
  min-width: 35px !important;
}

.min-w-40px {
  min-width: 40px !important;
}

.min-w-45px {
  min-width: 45px !important;
}

.min-w-50px {
  min-width: 50px !important;
}

.min-w-55px {
  min-width: 55px !important;
}

.min-w-60px {
  min-width: 60px !important;
}

.min-w-65px {
  min-width: 65px !important;
}

.min-w-70px {
  min-width: 70px !important;
}

.min-w-75px {
  min-width: 75px !important;
}

.min-w-80px {
  min-width: 80px !important;
}

.min-w-85px {
  min-width: 85px !important;
}

.min-w-90px {
  min-width: 90px !important;
}

.min-w-95px {
  min-width: 95px !important;
}

.min-w-100px {
  min-width: 100px !important;
}

.min-w-125px {
  min-width: 125px !important;
}

.min-w-150px {
  min-width: 150px !important;
}

.min-w-175px {
  min-width: 175px !important;
}

.min-w-200px {
  min-width: 200px !important;
}

.min-w-225px {
  min-width: 225px !important;
}

.min-w-250px {
  min-width: 250px !important;
}

.min-w-275px {
  min-width: 275px !important;
}

.min-w-300px {
  min-width: 300px !important;
}

.min-w-325px {
  min-width: 325px !important;
}

.min-w-350px {
  min-width: 350px !important;
}

.min-w-375px {
  min-width: 375px !important;
}

.min-w-400px {
  min-width: 400px !important;
}

.min-w-425px {
  min-width: 425px !important;
}

.min-w-450px {
  min-width: 450px !important;
}

.min-w-475px {
  min-width: 475px !important;
}

.min-w-500px {
  min-width: 500px !important;
}

.min-w-550px {
  min-width: 550px !important;
}

.min-w-600px {
  min-width: 600px !important;
}

.min-w-650px {
  min-width: 650px !important;
}

.min-w-700px {
  min-width: 700px !important;
}

.min-w-750px {
  min-width: 750px !important;
}

.min-w-800px {
  min-width: 800px !important;
}

.min-w-850px {
  min-width: 850px !important;
}

.min-w-900px {
  min-width: 900px !important;
}

.min-w-950px {
  min-width: 950px !important;
}

.min-w-1000px {
  min-width: 1000px !important;
}

.min-h-unset {
  min-height: unset !important;
}

.min-h-25 {
  min-height: 25% !important;
}

.min-h-50 {
  min-height: 50% !important;
}

.min-h-75 {
  min-height: 75% !important;
}

.min-h-100 {
  min-height: 100% !important;
}

.min-h-auto {
  min-height: auto !important;
}

.min-h-1px {
  min-height: 1px !important;
}

.min-h-2px {
  min-height: 2px !important;
}

.min-h-3px {
  min-height: 3px !important;
}

.min-h-4px {
  min-height: 4px !important;
}

.min-h-5px {
  min-height: 5px !important;
}

.min-h-6px {
  min-height: 6px !important;
}

.min-h-7px {
  min-height: 7px !important;
}

.min-h-8px {
  min-height: 8px !important;
}

.min-h-9px {
  min-height: 9px !important;
}

.min-h-10px {
  min-height: 10px !important;
}

.min-h-15px {
  min-height: 15px !important;
}

.min-h-20px {
  min-height: 20px !important;
}

.min-h-25px {
  min-height: 25px !important;
}

.min-h-30px {
  min-height: 30px !important;
}

.min-h-35px {
  min-height: 35px !important;
}

.min-h-40px {
  min-height: 40px !important;
}

.min-h-45px {
  min-height: 45px !important;
}

.min-h-50px {
  min-height: 50px !important;
}

.min-h-55px {
  min-height: 55px !important;
}

.min-h-60px {
  min-height: 60px !important;
}

.min-h-65px {
  min-height: 65px !important;
}

.min-h-70px {
  min-height: 70px !important;
}

.min-h-75px {
  min-height: 75px !important;
}

.min-h-80px {
  min-height: 80px !important;
}

.min-h-85px {
  min-height: 85px !important;
}

.min-h-90px {
  min-height: 90px !important;
}

.min-h-95px {
  min-height: 95px !important;
}

.min-h-100px {
  min-height: 100px !important;
}

.min-h-125px {
  min-height: 125px !important;
}

.min-h-150px {
  min-height: 150px !important;
}

.min-h-175px {
  min-height: 175px !important;
}

.min-h-200px {
  min-height: 200px !important;
}

.min-h-225px {
  min-height: 225px !important;
}

.min-h-250px {
  min-height: 250px !important;
}

.min-h-275px {
  min-height: 275px !important;
}

.min-h-300px {
  min-height: 300px !important;
}

.min-h-325px {
  min-height: 325px !important;
}

.min-h-350px {
  min-height: 350px !important;
}

.min-h-375px {
  min-height: 375px !important;
}

.min-h-400px {
  min-height: 400px !important;
}

.min-h-425px {
  min-height: 425px !important;
}

.min-h-450px {
  min-height: 450px !important;
}

.min-h-475px {
  min-height: 475px !important;
}

.min-h-500px {
  min-height: 500px !important;
}

.min-h-550px {
  min-height: 550px !important;
}

.min-h-600px {
  min-height: 600px !important;
}

.min-h-650px {
  min-height: 650px !important;
}

.min-h-700px {
  min-height: 700px !important;
}

.min-h-750px {
  min-height: 750px !important;
}

.min-h-800px {
  min-height: 800px !important;
}

.min-h-850px {
  min-height: 850px !important;
}

.min-h-900px {
  min-height: 900px !important;
}

.min-h-950px {
  min-height: 950px !important;
}

.min-h-1000px {
  min-height: 1000px !important;
}

.z-index-n1 {
  z-index: -1 !important;
}

.z-index-n2 {
  z-index: -2 !important;
}

.z-index-0 {
  z-index: 0 !important;
}

.z-index-1 {
  z-index: 1 !important;
}

.z-index-2 {
  z-index: 2 !important;
}

.z-index-3 {
  z-index: 3 !important;
}

.border-top-0 {
  border-top-width: 0 !important;
}

.border-top-1 {
  border-top-width: 1px !important;
}

.border-top-2 {
  border-top-width: 2px !important;
}

.border-top-3 {
  border-top-width: 3px !important;
}

.border-top-4 {
  border-top-width: 4px !important;
}

.border-top-5 {
  border-top-width: 5px !important;
}

.border-bottom-0 {
  border-bottom-width: 0 !important;
}

.border-bottom-1 {
  border-bottom-width: 1px !important;
}

.border-bottom-2 {
  border-bottom-width: 2px !important;
}

.border-bottom-3 {
  border-bottom-width: 3px !important;
}

.border-bottom-4 {
  border-bottom-width: 4px !important;
}

.border-bottom-5 {
  border-bottom-width: 5px !important;
}

.border-right-0 {
  border-right-width: 0 !important;
}

.border-right-1 {
  border-right-width: 1px !important;
}

.border-right-2 {
  border-right-width: 2px !important;
}

.border-right-3 {
  border-right-width: 3px !important;
}

.border-right-4 {
  border-right-width: 4px !important;
}

.border-right-5 {
  border-right-width: 5px !important;
}

.border-left-0 {
  border-left-width: 0 !important;
}

.border-left-1 {
  border-left-width: 1px !important;
}

.border-left-2 {
  border-left-width: 2px !important;
}

.border-left-3 {
  border-left-width: 3px !important;
}

.border-left-4 {
  border-left-width: 4px !important;
}

.border-left-5 {
  border-left-width: 5px !important;
}

.ls-1 {
  letter-spacing: 0.1rem !important;
}

.ls-2 {
  letter-spacing: 0.115rem !important;
}

.ls-3 {
  letter-spacing: 0.125rem !important;
}

.ls-4 {
  letter-spacing: 0.25rem !important;
}

.ls-5 {
  letter-spacing: 0.5rem !important;
}

.ls-n1 {
  letter-spacing: -0.1rem !important;
}

.ls-n2 {
  letter-spacing: -0.115rem !important;
}

.ls-n3 {
  letter-spacing: -0.125rem !important;
}

.ls-n4 {
  letter-spacing: -0.25rem !important;
}

.ls-n5 {
  letter-spacing: -0.5rem !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }

  .float-sm-end {
    float: right !important;
  }

  .float-sm-none {
    float: none !important;
  }

  .d-sm-inline {
    display: inline !important;
  }

  .d-sm-inline-block {
    display: inline-block !important;
  }

  .d-sm-block {
    display: block !important;
  }

  .d-sm-grid {
    display: grid !important;
  }

  .d-sm-table {
    display: table !important;
  }

  .d-sm-table-row {
    display: table-row !important;
  }

  .d-sm-table-cell {
    display: table-cell !important;
  }

  .d-sm-flex {
    display: flex !important;
  }

  .d-sm-inline-flex {
    display: inline-flex !important;
  }

  .d-sm-none {
    display: none !important;
  }

  .position-sm-static {
    position: static !important;
  }

  .position-sm-relative {
    position: relative !important;
  }

  .position-sm-absolute {
    position: absolute !important;
  }

  .position-sm-fixed {
    position: fixed !important;
  }

  .position-sm-sticky {
    position: sticky !important;
  }

  .w-sm-unset {
    width: unset !important;
  }

  .w-sm-25 {
    width: 25% !important;
  }

  .w-sm-50 {
    width: 50% !important;
  }

  .w-sm-75 {
    width: 75% !important;
  }

  .w-sm-100 {
    width: 100% !important;
  }

  .w-sm-auto {
    width: auto !important;
  }

  .w-sm-1px {
    width: 1px !important;
  }

  .w-sm-2px {
    width: 2px !important;
  }

  .w-sm-3px {
    width: 3px !important;
  }

  .w-sm-4px {
    width: 4px !important;
  }

  .w-sm-5px {
    width: 5px !important;
  }

  .w-sm-6px {
    width: 6px !important;
  }

  .w-sm-7px {
    width: 7px !important;
  }

  .w-sm-8px {
    width: 8px !important;
  }

  .w-sm-9px {
    width: 9px !important;
  }

  .w-sm-10px {
    width: 10px !important;
  }

  .w-sm-15px {
    width: 15px !important;
  }

  .w-sm-20px {
    width: 20px !important;
  }

  .w-sm-25px {
    width: 25px !important;
  }

  .w-sm-30px {
    width: 30px !important;
  }

  .w-sm-35px {
    width: 35px !important;
  }

  .w-sm-40px {
    width: 40px !important;
  }

  .w-sm-45px {
    width: 45px !important;
  }

  .w-sm-50px {
    width: 50px !important;
  }

  .w-sm-55px {
    width: 55px !important;
  }

  .w-sm-60px {
    width: 60px !important;
  }

  .w-sm-65px {
    width: 65px !important;
  }

  .w-sm-70px {
    width: 70px !important;
  }

  .w-sm-75px {
    width: 75px !important;
  }

  .w-sm-80px {
    width: 80px !important;
  }

  .w-sm-85px {
    width: 85px !important;
  }

  .w-sm-90px {
    width: 90px !important;
  }

  .w-sm-95px {
    width: 95px !important;
  }

  .w-sm-100px {
    width: 100px !important;
  }

  .w-sm-125px {
    width: 125px !important;
  }

  .w-sm-150px {
    width: 150px !important;
  }

  .w-sm-175px {
    width: 175px !important;
  }

  .w-sm-200px {
    width: 200px !important;
  }

  .w-sm-225px {
    width: 225px !important;
  }

  .w-sm-250px {
    width: 250px !important;
  }

  .w-sm-275px {
    width: 275px !important;
  }

  .w-sm-300px {
    width: 300px !important;
  }

  .w-sm-325px {
    width: 325px !important;
  }

  .w-sm-350px {
    width: 350px !important;
  }

  .w-sm-375px {
    width: 375px !important;
  }

  .w-sm-400px {
    width: 400px !important;
  }

  .w-sm-425px {
    width: 425px !important;
  }

  .w-sm-450px {
    width: 450px !important;
  }

  .w-sm-475px {
    width: 475px !important;
  }

  .w-sm-500px {
    width: 500px !important;
  }

  .w-sm-550px {
    width: 550px !important;
  }

  .w-sm-600px {
    width: 600px !important;
  }

  .w-sm-650px {
    width: 650px !important;
  }

  .w-sm-700px {
    width: 700px !important;
  }

  .w-sm-750px {
    width: 750px !important;
  }

  .w-sm-800px {
    width: 800px !important;
  }

  .w-sm-850px {
    width: 850px !important;
  }

  .w-sm-900px {
    width: 900px !important;
  }

  .w-sm-950px {
    width: 950px !important;
  }

  .w-sm-1000px {
    width: 1000px !important;
  }

  .mw-sm-unset {
    max-width: unset !important;
  }

  .mw-sm-25 {
    max-width: 25% !important;
  }

  .mw-sm-50 {
    max-width: 50% !important;
  }

  .mw-sm-75 {
    max-width: 75% !important;
  }

  .mw-sm-100 {
    max-width: 100% !important;
  }

  .mw-sm-auto {
    max-width: auto !important;
  }

  .mw-sm-1px {
    max-width: 1px !important;
  }

  .mw-sm-2px {
    max-width: 2px !important;
  }

  .mw-sm-3px {
    max-width: 3px !important;
  }

  .mw-sm-4px {
    max-width: 4px !important;
  }

  .mw-sm-5px {
    max-width: 5px !important;
  }

  .mw-sm-6px {
    max-width: 6px !important;
  }

  .mw-sm-7px {
    max-width: 7px !important;
  }

  .mw-sm-8px {
    max-width: 8px !important;
  }

  .mw-sm-9px {
    max-width: 9px !important;
  }

  .mw-sm-10px {
    max-width: 10px !important;
  }

  .mw-sm-15px {
    max-width: 15px !important;
  }

  .mw-sm-20px {
    max-width: 20px !important;
  }

  .mw-sm-25px {
    max-width: 25px !important;
  }

  .mw-sm-30px {
    max-width: 30px !important;
  }

  .mw-sm-35px {
    max-width: 35px !important;
  }

  .mw-sm-40px {
    max-width: 40px !important;
  }

  .mw-sm-45px {
    max-width: 45px !important;
  }

  .mw-sm-50px {
    max-width: 50px !important;
  }

  .mw-sm-55px {
    max-width: 55px !important;
  }

  .mw-sm-60px {
    max-width: 60px !important;
  }

  .mw-sm-65px {
    max-width: 65px !important;
  }

  .mw-sm-70px {
    max-width: 70px !important;
  }

  .mw-sm-75px {
    max-width: 75px !important;
  }

  .mw-sm-80px {
    max-width: 80px !important;
  }

  .mw-sm-85px {
    max-width: 85px !important;
  }

  .mw-sm-90px {
    max-width: 90px !important;
  }

  .mw-sm-95px {
    max-width: 95px !important;
  }

  .mw-sm-100px {
    max-width: 100px !important;
  }

  .mw-sm-125px {
    max-width: 125px !important;
  }

  .mw-sm-150px {
    max-width: 150px !important;
  }

  .mw-sm-175px {
    max-width: 175px !important;
  }

  .mw-sm-200px {
    max-width: 200px !important;
  }

  .mw-sm-225px {
    max-width: 225px !important;
  }

  .mw-sm-250px {
    max-width: 250px !important;
  }

  .mw-sm-275px {
    max-width: 275px !important;
  }

  .mw-sm-300px {
    max-width: 300px !important;
  }

  .mw-sm-325px {
    max-width: 325px !important;
  }

  .mw-sm-350px {
    max-width: 350px !important;
  }

  .mw-sm-375px {
    max-width: 375px !important;
  }

  .mw-sm-400px {
    max-width: 400px !important;
  }

  .mw-sm-425px {
    max-width: 425px !important;
  }

  .mw-sm-450px {
    max-width: 450px !important;
  }

  .mw-sm-475px {
    max-width: 475px !important;
  }

  .mw-sm-500px {
    max-width: 500px !important;
  }

  .mw-sm-550px {
    max-width: 550px !important;
  }

  .mw-sm-600px {
    max-width: 600px !important;
  }

  .mw-sm-650px {
    max-width: 650px !important;
  }

  .mw-sm-700px {
    max-width: 700px !important;
  }

  .mw-sm-750px {
    max-width: 750px !important;
  }

  .mw-sm-800px {
    max-width: 800px !important;
  }

  .mw-sm-850px {
    max-width: 850px !important;
  }

  .mw-sm-900px {
    max-width: 900px !important;
  }

  .mw-sm-950px {
    max-width: 950px !important;
  }

  .mw-sm-1000px {
    max-width: 1000px !important;
  }

  .h-sm-unset {
    height: unset !important;
  }

  .h-sm-25 {
    height: 25% !important;
  }

  .h-sm-50 {
    height: 50% !important;
  }

  .h-sm-75 {
    height: 75% !important;
  }

  .h-sm-100 {
    height: 100% !important;
  }

  .h-sm-auto {
    height: auto !important;
  }

  .h-sm-1px {
    height: 1px !important;
  }

  .h-sm-2px {
    height: 2px !important;
  }

  .h-sm-3px {
    height: 3px !important;
  }

  .h-sm-4px {
    height: 4px !important;
  }

  .h-sm-5px {
    height: 5px !important;
  }

  .h-sm-6px {
    height: 6px !important;
  }

  .h-sm-7px {
    height: 7px !important;
  }

  .h-sm-8px {
    height: 8px !important;
  }

  .h-sm-9px {
    height: 9px !important;
  }

  .h-sm-10px {
    height: 10px !important;
  }

  .h-sm-15px {
    height: 15px !important;
  }

  .h-sm-20px {
    height: 20px !important;
  }

  .h-sm-25px {
    height: 25px !important;
  }

  .h-sm-30px {
    height: 30px !important;
  }

  .h-sm-35px {
    height: 35px !important;
  }

  .h-sm-40px {
    height: 40px !important;
  }

  .h-sm-45px {
    height: 45px !important;
  }

  .h-sm-50px {
    height: 50px !important;
  }

  .h-sm-55px {
    height: 55px !important;
  }

  .h-sm-60px {
    height: 60px !important;
  }

  .h-sm-65px {
    height: 65px !important;
  }

  .h-sm-70px {
    height: 70px !important;
  }

  .h-sm-75px {
    height: 75px !important;
  }

  .h-sm-80px {
    height: 80px !important;
  }

  .h-sm-85px {
    height: 85px !important;
  }

  .h-sm-90px {
    height: 90px !important;
  }

  .h-sm-95px {
    height: 95px !important;
  }

  .h-sm-100px {
    height: 100px !important;
  }

  .h-sm-125px {
    height: 125px !important;
  }

  .h-sm-150px {
    height: 150px !important;
  }

  .h-sm-175px {
    height: 175px !important;
  }

  .h-sm-200px {
    height: 200px !important;
  }

  .h-sm-225px {
    height: 225px !important;
  }

  .h-sm-250px {
    height: 250px !important;
  }

  .h-sm-275px {
    height: 275px !important;
  }

  .h-sm-300px {
    height: 300px !important;
  }

  .h-sm-325px {
    height: 325px !important;
  }

  .h-sm-350px {
    height: 350px !important;
  }

  .h-sm-375px {
    height: 375px !important;
  }

  .h-sm-400px {
    height: 400px !important;
  }

  .h-sm-425px {
    height: 425px !important;
  }

  .h-sm-450px {
    height: 450px !important;
  }

  .h-sm-475px {
    height: 475px !important;
  }

  .h-sm-500px {
    height: 500px !important;
  }

  .h-sm-550px {
    height: 550px !important;
  }

  .h-sm-600px {
    height: 600px !important;
  }

  .h-sm-650px {
    height: 650px !important;
  }

  .h-sm-700px {
    height: 700px !important;
  }

  .h-sm-750px {
    height: 750px !important;
  }

  .h-sm-800px {
    height: 800px !important;
  }

  .h-sm-850px {
    height: 850px !important;
  }

  .h-sm-900px {
    height: 900px !important;
  }

  .h-sm-950px {
    height: 950px !important;
  }

  .h-sm-1000px {
    height: 1000px !important;
  }

  .mh-sm-unset {
    max-height: unset !important;
  }

  .mh-sm-25 {
    max-height: 25% !important;
  }

  .mh-sm-50 {
    max-height: 50% !important;
  }

  .mh-sm-75 {
    max-height: 75% !important;
  }

  .mh-sm-100 {
    max-height: 100% !important;
  }

  .mh-sm-auto {
    max-height: auto !important;
  }

  .mh-sm-1px {
    max-height: 1px !important;
  }

  .mh-sm-2px {
    max-height: 2px !important;
  }

  .mh-sm-3px {
    max-height: 3px !important;
  }

  .mh-sm-4px {
    max-height: 4px !important;
  }

  .mh-sm-5px {
    max-height: 5px !important;
  }

  .mh-sm-6px {
    max-height: 6px !important;
  }

  .mh-sm-7px {
    max-height: 7px !important;
  }

  .mh-sm-8px {
    max-height: 8px !important;
  }

  .mh-sm-9px {
    max-height: 9px !important;
  }

  .mh-sm-10px {
    max-height: 10px !important;
  }

  .mh-sm-15px {
    max-height: 15px !important;
  }

  .mh-sm-20px {
    max-height: 20px !important;
  }

  .mh-sm-25px {
    max-height: 25px !important;
  }

  .mh-sm-30px {
    max-height: 30px !important;
  }

  .mh-sm-35px {
    max-height: 35px !important;
  }

  .mh-sm-40px {
    max-height: 40px !important;
  }

  .mh-sm-45px {
    max-height: 45px !important;
  }

  .mh-sm-50px {
    max-height: 50px !important;
  }

  .mh-sm-55px {
    max-height: 55px !important;
  }

  .mh-sm-60px {
    max-height: 60px !important;
  }

  .mh-sm-65px {
    max-height: 65px !important;
  }

  .mh-sm-70px {
    max-height: 70px !important;
  }

  .mh-sm-75px {
    max-height: 75px !important;
  }

  .mh-sm-80px {
    max-height: 80px !important;
  }

  .mh-sm-85px {
    max-height: 85px !important;
  }

  .mh-sm-90px {
    max-height: 90px !important;
  }

  .mh-sm-95px {
    max-height: 95px !important;
  }

  .mh-sm-100px {
    max-height: 100px !important;
  }

  .mh-sm-125px {
    max-height: 125px !important;
  }

  .mh-sm-150px {
    max-height: 150px !important;
  }

  .mh-sm-175px {
    max-height: 175px !important;
  }

  .mh-sm-200px {
    max-height: 200px !important;
  }

  .mh-sm-225px {
    max-height: 225px !important;
  }

  .mh-sm-250px {
    max-height: 250px !important;
  }

  .mh-sm-275px {
    max-height: 275px !important;
  }

  .mh-sm-300px {
    max-height: 300px !important;
  }

  .mh-sm-325px {
    max-height: 325px !important;
  }

  .mh-sm-350px {
    max-height: 350px !important;
  }

  .mh-sm-375px {
    max-height: 375px !important;
  }

  .mh-sm-400px {
    max-height: 400px !important;
  }

  .mh-sm-425px {
    max-height: 425px !important;
  }

  .mh-sm-450px {
    max-height: 450px !important;
  }

  .mh-sm-475px {
    max-height: 475px !important;
  }

  .mh-sm-500px {
    max-height: 500px !important;
  }

  .mh-sm-550px {
    max-height: 550px !important;
  }

  .mh-sm-600px {
    max-height: 600px !important;
  }

  .mh-sm-650px {
    max-height: 650px !important;
  }

  .mh-sm-700px {
    max-height: 700px !important;
  }

  .mh-sm-750px {
    max-height: 750px !important;
  }

  .mh-sm-800px {
    max-height: 800px !important;
  }

  .mh-sm-850px {
    max-height: 850px !important;
  }

  .mh-sm-900px {
    max-height: 900px !important;
  }

  .mh-sm-950px {
    max-height: 950px !important;
  }

  .mh-sm-1000px {
    max-height: 1000px !important;
  }

  .flex-sm-fill {
    flex: 1 1 auto !important;
  }

  .flex-sm-row {
    flex-direction: row !important;
  }

  .flex-sm-column {
    flex-direction: column !important;
  }

  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }

  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-sm-start {
    justify-content: flex-start !important;
  }

  .justify-content-sm-end {
    justify-content: flex-end !important;
  }

  .justify-content-sm-center {
    justify-content: center !important;
  }

  .justify-content-sm-between {
    justify-content: space-between !important;
  }

  .justify-content-sm-around {
    justify-content: space-around !important;
  }

  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-sm-start {
    align-items: flex-start !important;
  }

  .align-items-sm-end {
    align-items: flex-end !important;
  }

  .align-items-sm-center {
    align-items: center !important;
  }

  .align-items-sm-baseline {
    align-items: baseline !important;
  }

  .align-items-sm-stretch {
    align-items: stretch !important;
  }

  .align-content-sm-start {
    align-content: flex-start !important;
  }

  .align-content-sm-end {
    align-content: flex-end !important;
  }

  .align-content-sm-center {
    align-content: center !important;
  }

  .align-content-sm-between {
    align-content: space-between !important;
  }

  .align-content-sm-around {
    align-content: space-around !important;
  }

  .align-content-sm-stretch {
    align-content: stretch !important;
  }

  .align-self-sm-auto {
    align-self: auto !important;
  }

  .align-self-sm-start {
    align-self: flex-start !important;
  }

  .align-self-sm-end {
    align-self: flex-end !important;
  }

  .align-self-sm-center {
    align-self: center !important;
  }

  .align-self-sm-baseline {
    align-self: baseline !important;
  }

  .align-self-sm-stretch {
    align-self: stretch !important;
  }

  .order-sm-first {
    order: -1 !important;
  }

  .order-sm-0 {
    order: 0 !important;
  }

  .order-sm-1 {
    order: 1 !important;
  }

  .order-sm-2 {
    order: 2 !important;
  }

  .order-sm-3 {
    order: 3 !important;
  }

  .order-sm-4 {
    order: 4 !important;
  }

  .order-sm-5 {
    order: 5 !important;
  }

  .order-sm-last {
    order: 6 !important;
  }

  .m-sm-0 {
    margin: 0 !important;
  }

  .m-sm-1 {
    margin: 0.25rem !important;
  }

  .m-sm-2 {
    margin: 0.5rem !important;
  }

  .m-sm-3 {
    margin: 0.75rem !important;
  }

  .m-sm-4 {
    margin: 1rem !important;
  }

  .m-sm-5 {
    margin: 1.25rem !important;
  }

  .m-sm-6 {
    margin: 1.5rem !important;
  }

  .m-sm-7 {
    margin: 1.75rem !important;
  }

  .m-sm-8 {
    margin: 2rem !important;
  }

  .m-sm-9 {
    margin: 2.25rem !important;
  }

  .m-sm-10 {
    margin: 2.5rem !important;
  }

  .m-sm-11 {
    margin: 2.75rem !important;
  }

  .m-sm-12 {
    margin: 3rem !important;
  }

  .m-sm-13 {
    margin: 3.25rem !important;
  }

  .m-sm-14 {
    margin: 3.5rem !important;
  }

  .m-sm-15 {
    margin: 3.75rem !important;
  }

  .m-sm-16 {
    margin: 4rem !important;
  }

  .m-sm-17 {
    margin: 4.25rem !important;
  }

  .m-sm-18 {
    margin: 4.5rem !important;
  }

  .m-sm-19 {
    margin: 4.75rem !important;
  }

  .m-sm-20 {
    margin: 5rem !important;
  }

  .m-sm-auto {
    margin: auto !important;
  }

  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-sm-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-sm-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-sm-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-sm-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-sm-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-sm-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-sm-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-sm-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-sm-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-sm-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-sm-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-sm-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-sm-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-sm-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-sm-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-sm-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-sm-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-sm-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-sm-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-sm-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-sm-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-sm-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-sm-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-sm-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-sm-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-sm-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-sm-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-sm-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-sm-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-sm-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-sm-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-sm-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-sm-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-sm-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-sm-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-sm-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-sm-0 {
    margin-top: 0 !important;
  }

  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }

  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }

  .mt-sm-3 {
    margin-top: 0.75rem !important;
  }

  .mt-sm-4 {
    margin-top: 1rem !important;
  }

  .mt-sm-5 {
    margin-top: 1.25rem !important;
  }

  .mt-sm-6 {
    margin-top: 1.5rem !important;
  }

  .mt-sm-7 {
    margin-top: 1.75rem !important;
  }

  .mt-sm-8 {
    margin-top: 2rem !important;
  }

  .mt-sm-9 {
    margin-top: 2.25rem !important;
  }

  .mt-sm-10 {
    margin-top: 2.5rem !important;
  }

  .mt-sm-11 {
    margin-top: 2.75rem !important;
  }

  .mt-sm-12 {
    margin-top: 3rem !important;
  }

  .mt-sm-13 {
    margin-top: 3.25rem !important;
  }

  .mt-sm-14 {
    margin-top: 3.5rem !important;
  }

  .mt-sm-15 {
    margin-top: 3.75rem !important;
  }

  .mt-sm-16 {
    margin-top: 4rem !important;
  }

  .mt-sm-17 {
    margin-top: 4.25rem !important;
  }

  .mt-sm-18 {
    margin-top: 4.5rem !important;
  }

  .mt-sm-19 {
    margin-top: 4.75rem !important;
  }

  .mt-sm-20 {
    margin-top: 5rem !important;
  }

  .mt-sm-auto {
    margin-top: auto !important;
  }

  .me-sm-0 {
    margin-right: 0 !important;
  }

  .me-sm-1 {
    margin-right: 0.25rem !important;
  }

  .me-sm-2 {
    margin-right: 0.5rem !important;
  }

  .me-sm-3 {
    margin-right: 0.75rem !important;
  }

  .me-sm-4 {
    margin-right: 1rem !important;
  }

  .me-sm-5 {
    margin-right: 1.25rem !important;
  }

  .me-sm-6 {
    margin-right: 1.5rem !important;
  }

  .me-sm-7 {
    margin-right: 1.75rem !important;
  }

  .me-sm-8 {
    margin-right: 2rem !important;
  }

  .me-sm-9 {
    margin-right: 2.25rem !important;
  }

  .me-sm-10 {
    margin-right: 2.5rem !important;
  }

  .me-sm-11 {
    margin-right: 2.75rem !important;
  }

  .me-sm-12 {
    margin-right: 3rem !important;
  }

  .me-sm-13 {
    margin-right: 3.25rem !important;
  }

  .me-sm-14 {
    margin-right: 3.5rem !important;
  }

  .me-sm-15 {
    margin-right: 3.75rem !important;
  }

  .me-sm-16 {
    margin-right: 4rem !important;
  }

  .me-sm-17 {
    margin-right: 4.25rem !important;
  }

  .me-sm-18 {
    margin-right: 4.5rem !important;
  }

  .me-sm-19 {
    margin-right: 4.75rem !important;
  }

  .me-sm-20 {
    margin-right: 5rem !important;
  }

  .me-sm-auto {
    margin-right: auto !important;
  }

  .mb-sm-0 {
    margin-bottom: 0 !important;
  }

  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-sm-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-sm-4 {
    margin-bottom: 1rem !important;
  }

  .mb-sm-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-sm-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-sm-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-sm-8 {
    margin-bottom: 2rem !important;
  }

  .mb-sm-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-sm-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-sm-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-sm-12 {
    margin-bottom: 3rem !important;
  }

  .mb-sm-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-sm-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-sm-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-sm-16 {
    margin-bottom: 4rem !important;
  }

  .mb-sm-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-sm-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-sm-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-sm-20 {
    margin-bottom: 5rem !important;
  }

  .mb-sm-auto {
    margin-bottom: auto !important;
  }

  .ms-sm-0 {
    margin-left: 0 !important;
  }

  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }

  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }

  .ms-sm-3 {
    margin-left: 0.75rem !important;
  }

  .ms-sm-4 {
    margin-left: 1rem !important;
  }

  .ms-sm-5 {
    margin-left: 1.25rem !important;
  }

  .ms-sm-6 {
    margin-left: 1.5rem !important;
  }

  .ms-sm-7 {
    margin-left: 1.75rem !important;
  }

  .ms-sm-8 {
    margin-left: 2rem !important;
  }

  .ms-sm-9 {
    margin-left: 2.25rem !important;
  }

  .ms-sm-10 {
    margin-left: 2.5rem !important;
  }

  .ms-sm-11 {
    margin-left: 2.75rem !important;
  }

  .ms-sm-12 {
    margin-left: 3rem !important;
  }

  .ms-sm-13 {
    margin-left: 3.25rem !important;
  }

  .ms-sm-14 {
    margin-left: 3.5rem !important;
  }

  .ms-sm-15 {
    margin-left: 3.75rem !important;
  }

  .ms-sm-16 {
    margin-left: 4rem !important;
  }

  .ms-sm-17 {
    margin-left: 4.25rem !important;
  }

  .ms-sm-18 {
    margin-left: 4.5rem !important;
  }

  .ms-sm-19 {
    margin-left: 4.75rem !important;
  }

  .ms-sm-20 {
    margin-left: 5rem !important;
  }

  .ms-sm-auto {
    margin-left: auto !important;
  }

  .m-sm-n1 {
    margin: -0.25rem !important;
  }

  .m-sm-n2 {
    margin: -0.5rem !important;
  }

  .m-sm-n3 {
    margin: -0.75rem !important;
  }

  .m-sm-n4 {
    margin: -1rem !important;
  }

  .m-sm-n5 {
    margin: -1.25rem !important;
  }

  .m-sm-n6 {
    margin: -1.5rem !important;
  }

  .m-sm-n7 {
    margin: -1.75rem !important;
  }

  .m-sm-n8 {
    margin: -2rem !important;
  }

  .m-sm-n9 {
    margin: -2.25rem !important;
  }

  .m-sm-n10 {
    margin: -2.5rem !important;
  }

  .m-sm-n11 {
    margin: -2.75rem !important;
  }

  .m-sm-n12 {
    margin: -3rem !important;
  }

  .m-sm-n13 {
    margin: -3.25rem !important;
  }

  .m-sm-n14 {
    margin: -3.5rem !important;
  }

  .m-sm-n15 {
    margin: -3.75rem !important;
  }

  .m-sm-n16 {
    margin: -4rem !important;
  }

  .m-sm-n17 {
    margin: -4.25rem !important;
  }

  .m-sm-n18 {
    margin: -4.5rem !important;
  }

  .m-sm-n19 {
    margin: -4.75rem !important;
  }

  .m-sm-n20 {
    margin: -5rem !important;
  }

  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-sm-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-sm-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-sm-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-sm-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-sm-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-sm-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-sm-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-sm-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-sm-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-sm-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-sm-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-sm-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-sm-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-sm-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-sm-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-sm-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-sm-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-sm-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-sm-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-sm-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-sm-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-sm-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-sm-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-sm-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-sm-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-sm-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-sm-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-sm-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-sm-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-sm-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-sm-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-sm-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-sm-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-sm-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-sm-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-sm-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-sm-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-sm-n4 {
    margin-top: -1rem !important;
  }

  .mt-sm-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-sm-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-sm-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-sm-n8 {
    margin-top: -2rem !important;
  }

  .mt-sm-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-sm-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-sm-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-sm-n12 {
    margin-top: -3rem !important;
  }

  .mt-sm-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-sm-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-sm-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-sm-n16 {
    margin-top: -4rem !important;
  }

  .mt-sm-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-sm-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-sm-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-sm-n20 {
    margin-top: -5rem !important;
  }

  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }

  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }

  .me-sm-n3 {
    margin-right: -0.75rem !important;
  }

  .me-sm-n4 {
    margin-right: -1rem !important;
  }

  .me-sm-n5 {
    margin-right: -1.25rem !important;
  }

  .me-sm-n6 {
    margin-right: -1.5rem !important;
  }

  .me-sm-n7 {
    margin-right: -1.75rem !important;
  }

  .me-sm-n8 {
    margin-right: -2rem !important;
  }

  .me-sm-n9 {
    margin-right: -2.25rem !important;
  }

  .me-sm-n10 {
    margin-right: -2.5rem !important;
  }

  .me-sm-n11 {
    margin-right: -2.75rem !important;
  }

  .me-sm-n12 {
    margin-right: -3rem !important;
  }

  .me-sm-n13 {
    margin-right: -3.25rem !important;
  }

  .me-sm-n14 {
    margin-right: -3.5rem !important;
  }

  .me-sm-n15 {
    margin-right: -3.75rem !important;
  }

  .me-sm-n16 {
    margin-right: -4rem !important;
  }

  .me-sm-n17 {
    margin-right: -4.25rem !important;
  }

  .me-sm-n18 {
    margin-right: -4.5rem !important;
  }

  .me-sm-n19 {
    margin-right: -4.75rem !important;
  }

  .me-sm-n20 {
    margin-right: -5rem !important;
  }

  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-sm-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-sm-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-sm-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-sm-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-sm-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-sm-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-sm-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-sm-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-sm-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-sm-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-sm-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-sm-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-sm-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-sm-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-sm-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-sm-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-sm-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-sm-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-sm-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-sm-n4 {
    margin-left: -1rem !important;
  }

  .ms-sm-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-sm-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-sm-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-sm-n8 {
    margin-left: -2rem !important;
  }

  .ms-sm-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-sm-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-sm-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-sm-n12 {
    margin-left: -3rem !important;
  }

  .ms-sm-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-sm-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-sm-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-sm-n16 {
    margin-left: -4rem !important;
  }

  .ms-sm-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-sm-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-sm-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-sm-n20 {
    margin-left: -5rem !important;
  }

  .p-sm-0 {
    padding: 0 !important;
  }

  .p-sm-1 {
    padding: 0.25rem !important;
  }

  .p-sm-2 {
    padding: 0.5rem !important;
  }

  .p-sm-3 {
    padding: 0.75rem !important;
  }

  .p-sm-4 {
    padding: 1rem !important;
  }

  .p-sm-5 {
    padding: 1.25rem !important;
  }

  .p-sm-6 {
    padding: 1.5rem !important;
  }

  .p-sm-7 {
    padding: 1.75rem !important;
  }

  .p-sm-8 {
    padding: 2rem !important;
  }

  .p-sm-9 {
    padding: 2.25rem !important;
  }

  .p-sm-10 {
    padding: 2.5rem !important;
  }

  .p-sm-11 {
    padding: 2.75rem !important;
  }

  .p-sm-12 {
    padding: 3rem !important;
  }

  .p-sm-13 {
    padding: 3.25rem !important;
  }

  .p-sm-14 {
    padding: 3.5rem !important;
  }

  .p-sm-15 {
    padding: 3.75rem !important;
  }

  .p-sm-16 {
    padding: 4rem !important;
  }

  .p-sm-17 {
    padding: 4.25rem !important;
  }

  .p-sm-18 {
    padding: 4.5rem !important;
  }

  .p-sm-19 {
    padding: 4.75rem !important;
  }

  .p-sm-20 {
    padding: 5rem !important;
  }

  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-sm-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-sm-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-sm-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-sm-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-sm-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-sm-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-sm-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-sm-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-sm-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-sm-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-sm-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-sm-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-sm-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-sm-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-sm-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-sm-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-sm-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-sm-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-sm-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-sm-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-sm-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-sm-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-sm-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-sm-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-sm-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-sm-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-sm-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-sm-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-sm-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-sm-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-sm-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-sm-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-sm-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-sm-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-sm-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-sm-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-sm-0 {
    padding-top: 0 !important;
  }

  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }

  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }

  .pt-sm-3 {
    padding-top: 0.75rem !important;
  }

  .pt-sm-4 {
    padding-top: 1rem !important;
  }

  .pt-sm-5 {
    padding-top: 1.25rem !important;
  }

  .pt-sm-6 {
    padding-top: 1.5rem !important;
  }

  .pt-sm-7 {
    padding-top: 1.75rem !important;
  }

  .pt-sm-8 {
    padding-top: 2rem !important;
  }

  .pt-sm-9 {
    padding-top: 2.25rem !important;
  }

  .pt-sm-10 {
    padding-top: 2.5rem !important;
  }

  .pt-sm-11 {
    padding-top: 2.75rem !important;
  }

  .pt-sm-12 {
    padding-top: 3rem !important;
  }

  .pt-sm-13 {
    padding-top: 3.25rem !important;
  }

  .pt-sm-14 {
    padding-top: 3.5rem !important;
  }

  .pt-sm-15 {
    padding-top: 3.75rem !important;
  }

  .pt-sm-16 {
    padding-top: 4rem !important;
  }

  .pt-sm-17 {
    padding-top: 4.25rem !important;
  }

  .pt-sm-18 {
    padding-top: 4.5rem !important;
  }

  .pt-sm-19 {
    padding-top: 4.75rem !important;
  }

  .pt-sm-20 {
    padding-top: 5rem !important;
  }

  .pe-sm-0 {
    padding-right: 0 !important;
  }

  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }

  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }

  .pe-sm-3 {
    padding-right: 0.75rem !important;
  }

  .pe-sm-4 {
    padding-right: 1rem !important;
  }

  .pe-sm-5 {
    padding-right: 1.25rem !important;
  }

  .pe-sm-6 {
    padding-right: 1.5rem !important;
  }

  .pe-sm-7 {
    padding-right: 1.75rem !important;
  }

  .pe-sm-8 {
    padding-right: 2rem !important;
  }

  .pe-sm-9 {
    padding-right: 2.25rem !important;
  }

  .pe-sm-10 {
    padding-right: 2.5rem !important;
  }

  .pe-sm-11 {
    padding-right: 2.75rem !important;
  }

  .pe-sm-12 {
    padding-right: 3rem !important;
  }

  .pe-sm-13 {
    padding-right: 3.25rem !important;
  }

  .pe-sm-14 {
    padding-right: 3.5rem !important;
  }

  .pe-sm-15 {
    padding-right: 3.75rem !important;
  }

  .pe-sm-16 {
    padding-right: 4rem !important;
  }

  .pe-sm-17 {
    padding-right: 4.25rem !important;
  }

  .pe-sm-18 {
    padding-right: 4.5rem !important;
  }

  .pe-sm-19 {
    padding-right: 4.75rem !important;
  }

  .pe-sm-20 {
    padding-right: 5rem !important;
  }

  .pb-sm-0 {
    padding-bottom: 0 !important;
  }

  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-sm-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-sm-4 {
    padding-bottom: 1rem !important;
  }

  .pb-sm-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-sm-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-sm-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-sm-8 {
    padding-bottom: 2rem !important;
  }

  .pb-sm-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-sm-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-sm-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-sm-12 {
    padding-bottom: 3rem !important;
  }

  .pb-sm-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-sm-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-sm-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-sm-16 {
    padding-bottom: 4rem !important;
  }

  .pb-sm-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-sm-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-sm-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-sm-20 {
    padding-bottom: 5rem !important;
  }

  .ps-sm-0 {
    padding-left: 0 !important;
  }

  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }

  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }

  .ps-sm-3 {
    padding-left: 0.75rem !important;
  }

  .ps-sm-4 {
    padding-left: 1rem !important;
  }

  .ps-sm-5 {
    padding-left: 1.25rem !important;
  }

  .ps-sm-6 {
    padding-left: 1.5rem !important;
  }

  .ps-sm-7 {
    padding-left: 1.75rem !important;
  }

  .ps-sm-8 {
    padding-left: 2rem !important;
  }

  .ps-sm-9 {
    padding-left: 2.25rem !important;
  }

  .ps-sm-10 {
    padding-left: 2.5rem !important;
  }

  .ps-sm-11 {
    padding-left: 2.75rem !important;
  }

  .ps-sm-12 {
    padding-left: 3rem !important;
  }

  .ps-sm-13 {
    padding-left: 3.25rem !important;
  }

  .ps-sm-14 {
    padding-left: 3.5rem !important;
  }

  .ps-sm-15 {
    padding-left: 3.75rem !important;
  }

  .ps-sm-16 {
    padding-left: 4rem !important;
  }

  .ps-sm-17 {
    padding-left: 4.25rem !important;
  }

  .ps-sm-18 {
    padding-left: 4.5rem !important;
  }

  .ps-sm-19 {
    padding-left: 4.75rem !important;
  }

  .ps-sm-20 {
    padding-left: 5rem !important;
  }

  .gap-sm-0 {
    gap: 0 !important;
  }

  .gap-sm-1 {
    gap: 0.25rem !important;
  }

  .gap-sm-2 {
    gap: 0.5rem !important;
  }

  .gap-sm-3 {
    gap: 0.75rem !important;
  }

  .gap-sm-4 {
    gap: 1rem !important;
  }

  .gap-sm-5 {
    gap: 1.25rem !important;
  }

  .gap-sm-6 {
    gap: 1.5rem !important;
  }

  .gap-sm-7 {
    gap: 1.75rem !important;
  }

  .gap-sm-8 {
    gap: 2rem !important;
  }

  .gap-sm-9 {
    gap: 2.25rem !important;
  }

  .gap-sm-10 {
    gap: 2.5rem !important;
  }

  .gap-sm-11 {
    gap: 2.75rem !important;
  }

  .gap-sm-12 {
    gap: 3rem !important;
  }

  .gap-sm-13 {
    gap: 3.25rem !important;
  }

  .gap-sm-14 {
    gap: 3.5rem !important;
  }

  .gap-sm-15 {
    gap: 3.75rem !important;
  }

  .gap-sm-16 {
    gap: 4rem !important;
  }

  .gap-sm-17 {
    gap: 4.25rem !important;
  }

  .gap-sm-18 {
    gap: 4.5rem !important;
  }

  .gap-sm-19 {
    gap: 4.75rem !important;
  }

  .gap-sm-20 {
    gap: 5rem !important;
  }

  .fs-sm-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }

  .fs-sm-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }

  .fs-sm-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }

  .fs-sm-4 {
    font-size: 1.25rem !important;
  }

  .fs-sm-5 {
    font-size: 1.15rem !important;
  }

  .fs-sm-6 {
    font-size: 1.075rem !important;
  }

  .fs-sm-7 {
    font-size: 0.95rem !important;
  }

  .fs-sm-8 {
    font-size: 0.85rem !important;
  }

  .fs-sm-9 {
    font-size: 0.75rem !important;
  }

  .fs-sm-10 {
    font-size: 0.5rem !important;
  }

  .fs-sm-base {
    font-size: 1rem !important;
  }

  .fs-sm-fluid {
    font-size: 100% !important;
  }

  .fs-sm-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }

  .fs-sm-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }

  .fs-sm-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }

  .fs-sm-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }

  .fs-sm-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }

  .fs-sm-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }

  .fs-sm-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }

  .fs-sm-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }

  .fs-sm-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }

  .fs-sm-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }

  .fs-sm-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }

  .fs-sm-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }

  .fs-sm-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }

  .fs-sm-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }

  .fs-sm-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }

  .fs-sm-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }

  .text-sm-start {
    text-align: left !important;
  }

  .text-sm-end {
    text-align: right !important;
  }

  .text-sm-center {
    text-align: center !important;
  }

  .min-w-sm-unset {
    min-width: unset !important;
  }

  .min-w-sm-25 {
    min-width: 25% !important;
  }

  .min-w-sm-50 {
    min-width: 50% !important;
  }

  .min-w-sm-75 {
    min-width: 75% !important;
  }

  .min-w-sm-100 {
    min-width: 100% !important;
  }

  .min-w-sm-auto {
    min-width: auto !important;
  }

  .min-w-sm-1px {
    min-width: 1px !important;
  }

  .min-w-sm-2px {
    min-width: 2px !important;
  }

  .min-w-sm-3px {
    min-width: 3px !important;
  }

  .min-w-sm-4px {
    min-width: 4px !important;
  }

  .min-w-sm-5px {
    min-width: 5px !important;
  }

  .min-w-sm-6px {
    min-width: 6px !important;
  }

  .min-w-sm-7px {
    min-width: 7px !important;
  }

  .min-w-sm-8px {
    min-width: 8px !important;
  }

  .min-w-sm-9px {
    min-width: 9px !important;
  }

  .min-w-sm-10px {
    min-width: 10px !important;
  }

  .min-w-sm-15px {
    min-width: 15px !important;
  }

  .min-w-sm-20px {
    min-width: 20px !important;
  }

  .min-w-sm-25px {
    min-width: 25px !important;
  }

  .min-w-sm-30px {
    min-width: 30px !important;
  }

  .min-w-sm-35px {
    min-width: 35px !important;
  }

  .min-w-sm-40px {
    min-width: 40px !important;
  }

  .min-w-sm-45px {
    min-width: 45px !important;
  }

  .min-w-sm-50px {
    min-width: 50px !important;
  }

  .min-w-sm-55px {
    min-width: 55px !important;
  }

  .min-w-sm-60px {
    min-width: 60px !important;
  }

  .min-w-sm-65px {
    min-width: 65px !important;
  }

  .min-w-sm-70px {
    min-width: 70px !important;
  }

  .min-w-sm-75px {
    min-width: 75px !important;
  }

  .min-w-sm-80px {
    min-width: 80px !important;
  }

  .min-w-sm-85px {
    min-width: 85px !important;
  }

  .min-w-sm-90px {
    min-width: 90px !important;
  }

  .min-w-sm-95px {
    min-width: 95px !important;
  }

  .min-w-sm-100px {
    min-width: 100px !important;
  }

  .min-w-sm-125px {
    min-width: 125px !important;
  }

  .min-w-sm-150px {
    min-width: 150px !important;
  }

  .min-w-sm-175px {
    min-width: 175px !important;
  }

  .min-w-sm-200px {
    min-width: 200px !important;
  }

  .min-w-sm-225px {
    min-width: 225px !important;
  }

  .min-w-sm-250px {
    min-width: 250px !important;
  }

  .min-w-sm-275px {
    min-width: 275px !important;
  }

  .min-w-sm-300px {
    min-width: 300px !important;
  }

  .min-w-sm-325px {
    min-width: 325px !important;
  }

  .min-w-sm-350px {
    min-width: 350px !important;
  }

  .min-w-sm-375px {
    min-width: 375px !important;
  }

  .min-w-sm-400px {
    min-width: 400px !important;
  }

  .min-w-sm-425px {
    min-width: 425px !important;
  }

  .min-w-sm-450px {
    min-width: 450px !important;
  }

  .min-w-sm-475px {
    min-width: 475px !important;
  }

  .min-w-sm-500px {
    min-width: 500px !important;
  }

  .min-w-sm-550px {
    min-width: 550px !important;
  }

  .min-w-sm-600px {
    min-width: 600px !important;
  }

  .min-w-sm-650px {
    min-width: 650px !important;
  }

  .min-w-sm-700px {
    min-width: 700px !important;
  }

  .min-w-sm-750px {
    min-width: 750px !important;
  }

  .min-w-sm-800px {
    min-width: 800px !important;
  }

  .min-w-sm-850px {
    min-width: 850px !important;
  }

  .min-w-sm-900px {
    min-width: 900px !important;
  }

  .min-w-sm-950px {
    min-width: 950px !important;
  }

  .min-w-sm-1000px {
    min-width: 1000px !important;
  }

  .min-h-sm-unset {
    min-height: unset !important;
  }

  .min-h-sm-25 {
    min-height: 25% !important;
  }

  .min-h-sm-50 {
    min-height: 50% !important;
  }

  .min-h-sm-75 {
    min-height: 75% !important;
  }

  .min-h-sm-100 {
    min-height: 100% !important;
  }

  .min-h-sm-auto {
    min-height: auto !important;
  }

  .min-h-sm-1px {
    min-height: 1px !important;
  }

  .min-h-sm-2px {
    min-height: 2px !important;
  }

  .min-h-sm-3px {
    min-height: 3px !important;
  }

  .min-h-sm-4px {
    min-height: 4px !important;
  }

  .min-h-sm-5px {
    min-height: 5px !important;
  }

  .min-h-sm-6px {
    min-height: 6px !important;
  }

  .min-h-sm-7px {
    min-height: 7px !important;
  }

  .min-h-sm-8px {
    min-height: 8px !important;
  }

  .min-h-sm-9px {
    min-height: 9px !important;
  }

  .min-h-sm-10px {
    min-height: 10px !important;
  }

  .min-h-sm-15px {
    min-height: 15px !important;
  }

  .min-h-sm-20px {
    min-height: 20px !important;
  }

  .min-h-sm-25px {
    min-height: 25px !important;
  }

  .min-h-sm-30px {
    min-height: 30px !important;
  }

  .min-h-sm-35px {
    min-height: 35px !important;
  }

  .min-h-sm-40px {
    min-height: 40px !important;
  }

  .min-h-sm-45px {
    min-height: 45px !important;
  }

  .min-h-sm-50px {
    min-height: 50px !important;
  }

  .min-h-sm-55px {
    min-height: 55px !important;
  }

  .min-h-sm-60px {
    min-height: 60px !important;
  }

  .min-h-sm-65px {
    min-height: 65px !important;
  }

  .min-h-sm-70px {
    min-height: 70px !important;
  }

  .min-h-sm-75px {
    min-height: 75px !important;
  }

  .min-h-sm-80px {
    min-height: 80px !important;
  }

  .min-h-sm-85px {
    min-height: 85px !important;
  }

  .min-h-sm-90px {
    min-height: 90px !important;
  }

  .min-h-sm-95px {
    min-height: 95px !important;
  }

  .min-h-sm-100px {
    min-height: 100px !important;
  }

  .min-h-sm-125px {
    min-height: 125px !important;
  }

  .min-h-sm-150px {
    min-height: 150px !important;
  }

  .min-h-sm-175px {
    min-height: 175px !important;
  }

  .min-h-sm-200px {
    min-height: 200px !important;
  }

  .min-h-sm-225px {
    min-height: 225px !important;
  }

  .min-h-sm-250px {
    min-height: 250px !important;
  }

  .min-h-sm-275px {
    min-height: 275px !important;
  }

  .min-h-sm-300px {
    min-height: 300px !important;
  }

  .min-h-sm-325px {
    min-height: 325px !important;
  }

  .min-h-sm-350px {
    min-height: 350px !important;
  }

  .min-h-sm-375px {
    min-height: 375px !important;
  }

  .min-h-sm-400px {
    min-height: 400px !important;
  }

  .min-h-sm-425px {
    min-height: 425px !important;
  }

  .min-h-sm-450px {
    min-height: 450px !important;
  }

  .min-h-sm-475px {
    min-height: 475px !important;
  }

  .min-h-sm-500px {
    min-height: 500px !important;
  }

  .min-h-sm-550px {
    min-height: 550px !important;
  }

  .min-h-sm-600px {
    min-height: 600px !important;
  }

  .min-h-sm-650px {
    min-height: 650px !important;
  }

  .min-h-sm-700px {
    min-height: 700px !important;
  }

  .min-h-sm-750px {
    min-height: 750px !important;
  }

  .min-h-sm-800px {
    min-height: 800px !important;
  }

  .min-h-sm-850px {
    min-height: 850px !important;
  }

  .min-h-sm-900px {
    min-height: 900px !important;
  }

  .min-h-sm-950px {
    min-height: 950px !important;
  }

  .min-h-sm-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }

  .float-md-end {
    float: right !important;
  }

  .float-md-none {
    float: none !important;
  }

  .d-md-inline {
    display: inline !important;
  }

  .d-md-inline-block {
    display: inline-block !important;
  }

  .d-md-block {
    display: block !important;
  }

  .d-md-grid {
    display: grid !important;
  }

  .d-md-table {
    display: table !important;
  }

  .d-md-table-row {
    display: table-row !important;
  }

  .d-md-table-cell {
    display: table-cell !important;
  }

  .d-md-flex {
    display: flex !important;
  }

  .d-md-inline-flex {
    display: inline-flex !important;
  }

  .d-md-none {
    display: none !important;
  }

  .position-md-static {
    position: static !important;
  }

  .position-md-relative {
    position: relative !important;
  }

  .position-md-absolute {
    position: absolute !important;
  }

  .position-md-fixed {
    position: fixed !important;
  }

  .position-md-sticky {
    position: sticky !important;
  }

  .w-md-unset {
    width: unset !important;
  }

  .w-md-25 {
    width: 25% !important;
  }

  .w-md-50 {
    width: 50% !important;
  }

  .w-md-75 {
    width: 75% !important;
  }

  .w-md-100 {
    width: 100% !important;
  }

  .w-md-auto {
    width: auto !important;
  }

  .w-md-1px {
    width: 1px !important;
  }

  .w-md-2px {
    width: 2px !important;
  }

  .w-md-3px {
    width: 3px !important;
  }

  .w-md-4px {
    width: 4px !important;
  }

  .w-md-5px {
    width: 5px !important;
  }

  .w-md-6px {
    width: 6px !important;
  }

  .w-md-7px {
    width: 7px !important;
  }

  .w-md-8px {
    width: 8px !important;
  }

  .w-md-9px {
    width: 9px !important;
  }

  .w-md-10px {
    width: 10px !important;
  }

  .w-md-15px {
    width: 15px !important;
  }

  .w-md-20px {
    width: 20px !important;
  }

  .w-md-25px {
    width: 25px !important;
  }

  .w-md-30px {
    width: 30px !important;
  }

  .w-md-35px {
    width: 35px !important;
  }

  .w-md-40px {
    width: 40px !important;
  }

  .w-md-45px {
    width: 45px !important;
  }

  .w-md-50px {
    width: 50px !important;
  }

  .w-md-55px {
    width: 55px !important;
  }

  .w-md-60px {
    width: 60px !important;
  }

  .w-md-65px {
    width: 65px !important;
  }

  .w-md-70px {
    width: 70px !important;
  }

  .w-md-75px {
    width: 75px !important;
  }

  .w-md-80px {
    width: 80px !important;
  }

  .w-md-85px {
    width: 85px !important;
  }

  .w-md-90px {
    width: 90px !important;
  }

  .w-md-95px {
    width: 95px !important;
  }

  .w-md-100px {
    width: 100px !important;
  }

  .w-md-125px {
    width: 125px !important;
  }

  .w-md-150px {
    width: 150px !important;
  }

  .w-md-175px {
    width: 175px !important;
  }

  .w-md-200px {
    width: 200px !important;
  }

  .w-md-225px {
    width: 225px !important;
  }

  .w-md-250px {
    width: 250px !important;
  }

  .w-md-275px {
    width: 275px !important;
  }

  .w-md-300px {
    width: 300px !important;
  }

  .w-md-325px {
    width: 325px !important;
  }

  .w-md-350px {
    width: 350px !important;
  }

  .w-md-375px {
    width: 375px !important;
  }

  .w-md-400px {
    width: 400px !important;
  }

  .w-md-425px {
    width: 425px !important;
  }

  .w-md-450px {
    width: 450px !important;
  }

  .w-md-475px {
    width: 475px !important;
  }

  .w-md-500px {
    width: 500px !important;
  }

  .w-md-550px {
    width: 550px !important;
  }

  .w-md-600px {
    width: 600px !important;
  }

  .w-md-650px {
    width: 650px !important;
  }

  .w-md-700px {
    width: 700px !important;
  }

  .w-md-750px {
    width: 750px !important;
  }

  .w-md-800px {
    width: 800px !important;
  }

  .w-md-850px {
    width: 850px !important;
  }

  .w-md-900px {
    width: 900px !important;
  }

  .w-md-950px {
    width: 950px !important;
  }

  .w-md-1000px {
    width: 1000px !important;
  }

  .mw-md-unset {
    max-width: unset !important;
  }

  .mw-md-25 {
    max-width: 25% !important;
  }

  .mw-md-50 {
    max-width: 50% !important;
  }

  .mw-md-75 {
    max-width: 75% !important;
  }

  .mw-md-100 {
    max-width: 100% !important;
  }

  .mw-md-auto {
    max-width: auto !important;
  }

  .mw-md-1px {
    max-width: 1px !important;
  }

  .mw-md-2px {
    max-width: 2px !important;
  }

  .mw-md-3px {
    max-width: 3px !important;
  }

  .mw-md-4px {
    max-width: 4px !important;
  }

  .mw-md-5px {
    max-width: 5px !important;
  }

  .mw-md-6px {
    max-width: 6px !important;
  }

  .mw-md-7px {
    max-width: 7px !important;
  }

  .mw-md-8px {
    max-width: 8px !important;
  }

  .mw-md-9px {
    max-width: 9px !important;
  }

  .mw-md-10px {
    max-width: 10px !important;
  }

  .mw-md-15px {
    max-width: 15px !important;
  }

  .mw-md-20px {
    max-width: 20px !important;
  }

  .mw-md-25px {
    max-width: 25px !important;
  }

  .mw-md-30px {
    max-width: 30px !important;
  }

  .mw-md-35px {
    max-width: 35px !important;
  }

  .mw-md-40px {
    max-width: 40px !important;
  }

  .mw-md-45px {
    max-width: 45px !important;
  }

  .mw-md-50px {
    max-width: 50px !important;
  }

  .mw-md-55px {
    max-width: 55px !important;
  }

  .mw-md-60px {
    max-width: 60px !important;
  }

  .mw-md-65px {
    max-width: 65px !important;
  }

  .mw-md-70px {
    max-width: 70px !important;
  }

  .mw-md-75px {
    max-width: 75px !important;
  }

  .mw-md-80px {
    max-width: 80px !important;
  }

  .mw-md-85px {
    max-width: 85px !important;
  }

  .mw-md-90px {
    max-width: 90px !important;
  }

  .mw-md-95px {
    max-width: 95px !important;
  }

  .mw-md-100px {
    max-width: 100px !important;
  }

  .mw-md-125px {
    max-width: 125px !important;
  }

  .mw-md-150px {
    max-width: 150px !important;
  }

  .mw-md-175px {
    max-width: 175px !important;
  }

  .mw-md-200px {
    max-width: 200px !important;
  }

  .mw-md-225px {
    max-width: 225px !important;
  }

  .mw-md-250px {
    max-width: 250px !important;
  }

  .mw-md-275px {
    max-width: 275px !important;
  }

  .mw-md-300px {
    max-width: 300px !important;
  }

  .mw-md-325px {
    max-width: 325px !important;
  }

  .mw-md-350px {
    max-width: 350px !important;
  }

  .mw-md-375px {
    max-width: 375px !important;
  }

  .mw-md-400px {
    max-width: 400px !important;
  }

  .mw-md-425px {
    max-width: 425px !important;
  }

  .mw-md-450px {
    max-width: 450px !important;
  }

  .mw-md-475px {
    max-width: 475px !important;
  }

  .mw-md-500px {
    max-width: 500px !important;
  }

  .mw-md-550px {
    max-width: 550px !important;
  }

  .mw-md-600px {
    max-width: 600px !important;
  }

  .mw-md-650px {
    max-width: 650px !important;
  }

  .mw-md-700px {
    max-width: 700px !important;
  }

  .mw-md-750px {
    max-width: 750px !important;
  }

  .mw-md-800px {
    max-width: 800px !important;
  }

  .mw-md-850px {
    max-width: 850px !important;
  }

  .mw-md-900px {
    max-width: 900px !important;
  }

  .mw-md-950px {
    max-width: 950px !important;
  }

  .mw-md-1000px {
    max-width: 1000px !important;
  }

  .h-md-unset {
    height: unset !important;
  }

  .h-md-25 {
    height: 25% !important;
  }

  .h-md-50 {
    height: 50% !important;
  }

  .h-md-75 {
    height: 75% !important;
  }

  .h-md-100 {
    height: 100% !important;
  }

  .h-md-auto {
    height: auto !important;
  }

  .h-md-1px {
    height: 1px !important;
  }

  .h-md-2px {
    height: 2px !important;
  }

  .h-md-3px {
    height: 3px !important;
  }

  .h-md-4px {
    height: 4px !important;
  }

  .h-md-5px {
    height: 5px !important;
  }

  .h-md-6px {
    height: 6px !important;
  }

  .h-md-7px {
    height: 7px !important;
  }

  .h-md-8px {
    height: 8px !important;
  }

  .h-md-9px {
    height: 9px !important;
  }

  .h-md-10px {
    height: 10px !important;
  }

  .h-md-15px {
    height: 15px !important;
  }

  .h-md-20px {
    height: 20px !important;
  }

  .h-md-25px {
    height: 25px !important;
  }

  .h-md-30px {
    height: 30px !important;
  }

  .h-md-35px {
    height: 35px !important;
  }

  .h-md-40px {
    height: 40px !important;
  }

  .h-md-45px {
    height: 45px !important;
  }

  .h-md-50px {
    height: 50px !important;
  }

  .h-md-55px {
    height: 55px !important;
  }

  .h-md-60px {
    height: 60px !important;
  }

  .h-md-65px {
    height: 65px !important;
  }

  .h-md-70px {
    height: 70px !important;
  }

  .h-md-75px {
    height: 75px !important;
  }

  .h-md-80px {
    height: 80px !important;
  }

  .h-md-85px {
    height: 85px !important;
  }

  .h-md-90px {
    height: 90px !important;
  }

  .h-md-95px {
    height: 95px !important;
  }

  .h-md-100px {
    height: 100px !important;
  }

  .h-md-125px {
    height: 125px !important;
  }

  .h-md-150px {
    height: 150px !important;
  }

  .h-md-175px {
    height: 175px !important;
  }

  .h-md-200px {
    height: 200px !important;
  }

  .h-md-225px {
    height: 225px !important;
  }

  .h-md-250px {
    height: 250px !important;
  }

  .h-md-275px {
    height: 275px !important;
  }

  .h-md-300px {
    height: 300px !important;
  }

  .h-md-325px {
    height: 325px !important;
  }

  .h-md-350px {
    height: 350px !important;
  }

  .h-md-375px {
    height: 375px !important;
  }

  .h-md-400px {
    height: 400px !important;
  }

  .h-md-425px {
    height: 425px !important;
  }

  .h-md-450px {
    height: 450px !important;
  }

  .h-md-475px {
    height: 475px !important;
  }

  .h-md-500px {
    height: 500px !important;
  }

  .h-md-550px {
    height: 550px !important;
  }

  .h-md-600px {
    height: 600px !important;
  }

  .h-md-650px {
    height: 650px !important;
  }

  .h-md-700px {
    height: 700px !important;
  }

  .h-md-750px {
    height: 750px !important;
  }

  .h-md-800px {
    height: 800px !important;
  }

  .h-md-850px {
    height: 850px !important;
  }

  .h-md-900px {
    height: 900px !important;
  }

  .h-md-950px {
    height: 950px !important;
  }

  .h-md-1000px {
    height: 1000px !important;
  }

  .mh-md-unset {
    max-height: unset !important;
  }

  .mh-md-25 {
    max-height: 25% !important;
  }

  .mh-md-50 {
    max-height: 50% !important;
  }

  .mh-md-75 {
    max-height: 75% !important;
  }

  .mh-md-100 {
    max-height: 100% !important;
  }

  .mh-md-auto {
    max-height: auto !important;
  }

  .mh-md-1px {
    max-height: 1px !important;
  }

  .mh-md-2px {
    max-height: 2px !important;
  }

  .mh-md-3px {
    max-height: 3px !important;
  }

  .mh-md-4px {
    max-height: 4px !important;
  }

  .mh-md-5px {
    max-height: 5px !important;
  }

  .mh-md-6px {
    max-height: 6px !important;
  }

  .mh-md-7px {
    max-height: 7px !important;
  }

  .mh-md-8px {
    max-height: 8px !important;
  }

  .mh-md-9px {
    max-height: 9px !important;
  }

  .mh-md-10px {
    max-height: 10px !important;
  }

  .mh-md-15px {
    max-height: 15px !important;
  }

  .mh-md-20px {
    max-height: 20px !important;
  }

  .mh-md-25px {
    max-height: 25px !important;
  }

  .mh-md-30px {
    max-height: 30px !important;
  }

  .mh-md-35px {
    max-height: 35px !important;
  }

  .mh-md-40px {
    max-height: 40px !important;
  }

  .mh-md-45px {
    max-height: 45px !important;
  }

  .mh-md-50px {
    max-height: 50px !important;
  }

  .mh-md-55px {
    max-height: 55px !important;
  }

  .mh-md-60px {
    max-height: 60px !important;
  }

  .mh-md-65px {
    max-height: 65px !important;
  }

  .mh-md-70px {
    max-height: 70px !important;
  }

  .mh-md-75px {
    max-height: 75px !important;
  }

  .mh-md-80px {
    max-height: 80px !important;
  }

  .mh-md-85px {
    max-height: 85px !important;
  }

  .mh-md-90px {
    max-height: 90px !important;
  }

  .mh-md-95px {
    max-height: 95px !important;
  }

  .mh-md-100px {
    max-height: 100px !important;
  }

  .mh-md-125px {
    max-height: 125px !important;
  }

  .mh-md-150px {
    max-height: 150px !important;
  }

  .mh-md-175px {
    max-height: 175px !important;
  }

  .mh-md-200px {
    max-height: 200px !important;
  }

  .mh-md-225px {
    max-height: 225px !important;
  }

  .mh-md-250px {
    max-height: 250px !important;
  }

  .mh-md-275px {
    max-height: 275px !important;
  }

  .mh-md-300px {
    max-height: 300px !important;
  }

  .mh-md-325px {
    max-height: 325px !important;
  }

  .mh-md-350px {
    max-height: 350px !important;
  }

  .mh-md-375px {
    max-height: 375px !important;
  }

  .mh-md-400px {
    max-height: 400px !important;
  }

  .mh-md-425px {
    max-height: 425px !important;
  }

  .mh-md-450px {
    max-height: 450px !important;
  }

  .mh-md-475px {
    max-height: 475px !important;
  }

  .mh-md-500px {
    max-height: 500px !important;
  }

  .mh-md-550px {
    max-height: 550px !important;
  }

  .mh-md-600px {
    max-height: 600px !important;
  }

  .mh-md-650px {
    max-height: 650px !important;
  }

  .mh-md-700px {
    max-height: 700px !important;
  }

  .mh-md-750px {
    max-height: 750px !important;
  }

  .mh-md-800px {
    max-height: 800px !important;
  }

  .mh-md-850px {
    max-height: 850px !important;
  }

  .mh-md-900px {
    max-height: 900px !important;
  }

  .mh-md-950px {
    max-height: 950px !important;
  }

  .mh-md-1000px {
    max-height: 1000px !important;
  }

  .flex-md-fill {
    flex: 1 1 auto !important;
  }

  .flex-md-row {
    flex-direction: row !important;
  }

  .flex-md-column {
    flex-direction: column !important;
  }

  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-md-wrap {
    flex-wrap: wrap !important;
  }

  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-md-start {
    justify-content: flex-start !important;
  }

  .justify-content-md-end {
    justify-content: flex-end !important;
  }

  .justify-content-md-center {
    justify-content: center !important;
  }

  .justify-content-md-between {
    justify-content: space-between !important;
  }

  .justify-content-md-around {
    justify-content: space-around !important;
  }

  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-md-start {
    align-items: flex-start !important;
  }

  .align-items-md-end {
    align-items: flex-end !important;
  }

  .align-items-md-center {
    align-items: center !important;
  }

  .align-items-md-baseline {
    align-items: baseline !important;
  }

  .align-items-md-stretch {
    align-items: stretch !important;
  }

  .align-content-md-start {
    align-content: flex-start !important;
  }

  .align-content-md-end {
    align-content: flex-end !important;
  }

  .align-content-md-center {
    align-content: center !important;
  }

  .align-content-md-between {
    align-content: space-between !important;
  }

  .align-content-md-around {
    align-content: space-around !important;
  }

  .align-content-md-stretch {
    align-content: stretch !important;
  }

  .align-self-md-auto {
    align-self: auto !important;
  }

  .align-self-md-start {
    align-self: flex-start !important;
  }

  .align-self-md-end {
    align-self: flex-end !important;
  }

  .align-self-md-center {
    align-self: center !important;
  }

  .align-self-md-baseline {
    align-self: baseline !important;
  }

  .align-self-md-stretch {
    align-self: stretch !important;
  }

  .order-md-first {
    order: -1 !important;
  }

  .order-md-0 {
    order: 0 !important;
  }

  .order-md-1 {
    order: 1 !important;
  }

  .order-md-2 {
    order: 2 !important;
  }

  .order-md-3 {
    order: 3 !important;
  }

  .order-md-4 {
    order: 4 !important;
  }

  .order-md-5 {
    order: 5 !important;
  }

  .order-md-last {
    order: 6 !important;
  }

  .m-md-0 {
    margin: 0 !important;
  }

  .m-md-1 {
    margin: 0.25rem !important;
  }

  .m-md-2 {
    margin: 0.5rem !important;
  }

  .m-md-3 {
    margin: 0.75rem !important;
  }

  .m-md-4 {
    margin: 1rem !important;
  }

  .m-md-5 {
    margin: 1.25rem !important;
  }

  .m-md-6 {
    margin: 1.5rem !important;
  }

  .m-md-7 {
    margin: 1.75rem !important;
  }

  .m-md-8 {
    margin: 2rem !important;
  }

  .m-md-9 {
    margin: 2.25rem !important;
  }

  .m-md-10 {
    margin: 2.5rem !important;
  }

  .m-md-11 {
    margin: 2.75rem !important;
  }

  .m-md-12 {
    margin: 3rem !important;
  }

  .m-md-13 {
    margin: 3.25rem !important;
  }

  .m-md-14 {
    margin: 3.5rem !important;
  }

  .m-md-15 {
    margin: 3.75rem !important;
  }

  .m-md-16 {
    margin: 4rem !important;
  }

  .m-md-17 {
    margin: 4.25rem !important;
  }

  .m-md-18 {
    margin: 4.5rem !important;
  }

  .m-md-19 {
    margin: 4.75rem !important;
  }

  .m-md-20 {
    margin: 5rem !important;
  }

  .m-md-auto {
    margin: auto !important;
  }

  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-md-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-md-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-md-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-md-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-md-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-md-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-md-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-md-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-md-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-md-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-md-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-md-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-md-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-md-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-md-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-md-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-md-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-md-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-md-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-md-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-md-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-md-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-md-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-md-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-md-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-md-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-md-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-md-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-md-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-md-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-md-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-md-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-md-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-md-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-md-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-md-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-md-0 {
    margin-top: 0 !important;
  }

  .mt-md-1 {
    margin-top: 0.25rem !important;
  }

  .mt-md-2 {
    margin-top: 0.5rem !important;
  }

  .mt-md-3 {
    margin-top: 0.75rem !important;
  }

  .mt-md-4 {
    margin-top: 1rem !important;
  }

  .mt-md-5 {
    margin-top: 1.25rem !important;
  }

  .mt-md-6 {
    margin-top: 1.5rem !important;
  }

  .mt-md-7 {
    margin-top: 1.75rem !important;
  }

  .mt-md-8 {
    margin-top: 2rem !important;
  }

  .mt-md-9 {
    margin-top: 2.25rem !important;
  }

  .mt-md-10 {
    margin-top: 2.5rem !important;
  }

  .mt-md-11 {
    margin-top: 2.75rem !important;
  }

  .mt-md-12 {
    margin-top: 3rem !important;
  }

  .mt-md-13 {
    margin-top: 3.25rem !important;
  }

  .mt-md-14 {
    margin-top: 3.5rem !important;
  }

  .mt-md-15 {
    margin-top: 3.75rem !important;
  }

  .mt-md-16 {
    margin-top: 4rem !important;
  }

  .mt-md-17 {
    margin-top: 4.25rem !important;
  }

  .mt-md-18 {
    margin-top: 4.5rem !important;
  }

  .mt-md-19 {
    margin-top: 4.75rem !important;
  }

  .mt-md-20 {
    margin-top: 5rem !important;
  }

  .mt-md-auto {
    margin-top: auto !important;
  }

  .me-md-0 {
    margin-right: 0 !important;
  }

  .me-md-1 {
    margin-right: 0.25rem !important;
  }

  .me-md-2 {
    margin-right: 0.5rem !important;
  }

  .me-md-3 {
    margin-right: 0.75rem !important;
  }

  .me-md-4 {
    margin-right: 1rem !important;
  }

  .me-md-5 {
    margin-right: 1.25rem !important;
  }

  .me-md-6 {
    margin-right: 1.5rem !important;
  }

  .me-md-7 {
    margin-right: 1.75rem !important;
  }

  .me-md-8 {
    margin-right: 2rem !important;
  }

  .me-md-9 {
    margin-right: 2.25rem !important;
  }

  .me-md-10 {
    margin-right: 2.5rem !important;
  }

  .me-md-11 {
    margin-right: 2.75rem !important;
  }

  .me-md-12 {
    margin-right: 3rem !important;
  }

  .me-md-13 {
    margin-right: 3.25rem !important;
  }

  .me-md-14 {
    margin-right: 3.5rem !important;
  }

  .me-md-15 {
    margin-right: 3.75rem !important;
  }

  .me-md-16 {
    margin-right: 4rem !important;
  }

  .me-md-17 {
    margin-right: 4.25rem !important;
  }

  .me-md-18 {
    margin-right: 4.5rem !important;
  }

  .me-md-19 {
    margin-right: 4.75rem !important;
  }

  .me-md-20 {
    margin-right: 5rem !important;
  }

  .me-md-auto {
    margin-right: auto !important;
  }

  .mb-md-0 {
    margin-bottom: 0 !important;
  }

  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-md-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-md-4 {
    margin-bottom: 1rem !important;
  }

  .mb-md-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-md-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-md-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-md-8 {
    margin-bottom: 2rem !important;
  }

  .mb-md-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-md-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-md-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-md-12 {
    margin-bottom: 3rem !important;
  }

  .mb-md-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-md-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-md-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-md-16 {
    margin-bottom: 4rem !important;
  }

  .mb-md-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-md-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-md-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-md-20 {
    margin-bottom: 5rem !important;
  }

  .mb-md-auto {
    margin-bottom: auto !important;
  }

  .ms-md-0 {
    margin-left: 0 !important;
  }

  .ms-md-1 {
    margin-left: 0.25rem !important;
  }

  .ms-md-2 {
    margin-left: 0.5rem !important;
  }

  .ms-md-3 {
    margin-left: 0.75rem !important;
  }

  .ms-md-4 {
    margin-left: 1rem !important;
  }

  .ms-md-5 {
    margin-left: 1.25rem !important;
  }

  .ms-md-6 {
    margin-left: 1.5rem !important;
  }

  .ms-md-7 {
    margin-left: 1.75rem !important;
  }

  .ms-md-8 {
    margin-left: 2rem !important;
  }

  .ms-md-9 {
    margin-left: 2.25rem !important;
  }

  .ms-md-10 {
    margin-left: 2.5rem !important;
  }

  .ms-md-11 {
    margin-left: 2.75rem !important;
  }

  .ms-md-12 {
    margin-left: 3rem !important;
  }

  .ms-md-13 {
    margin-left: 3.25rem !important;
  }

  .ms-md-14 {
    margin-left: 3.5rem !important;
  }

  .ms-md-15 {
    margin-left: 3.75rem !important;
  }

  .ms-md-16 {
    margin-left: 4rem !important;
  }

  .ms-md-17 {
    margin-left: 4.25rem !important;
  }

  .ms-md-18 {
    margin-left: 4.5rem !important;
  }

  .ms-md-19 {
    margin-left: 4.75rem !important;
  }

  .ms-md-20 {
    margin-left: 5rem !important;
  }

  .ms-md-auto {
    margin-left: auto !important;
  }

  .m-md-n1 {
    margin: -0.25rem !important;
  }

  .m-md-n2 {
    margin: -0.5rem !important;
  }

  .m-md-n3 {
    margin: -0.75rem !important;
  }

  .m-md-n4 {
    margin: -1rem !important;
  }

  .m-md-n5 {
    margin: -1.25rem !important;
  }

  .m-md-n6 {
    margin: -1.5rem !important;
  }

  .m-md-n7 {
    margin: -1.75rem !important;
  }

  .m-md-n8 {
    margin: -2rem !important;
  }

  .m-md-n9 {
    margin: -2.25rem !important;
  }

  .m-md-n10 {
    margin: -2.5rem !important;
  }

  .m-md-n11 {
    margin: -2.75rem !important;
  }

  .m-md-n12 {
    margin: -3rem !important;
  }

  .m-md-n13 {
    margin: -3.25rem !important;
  }

  .m-md-n14 {
    margin: -3.5rem !important;
  }

  .m-md-n15 {
    margin: -3.75rem !important;
  }

  .m-md-n16 {
    margin: -4rem !important;
  }

  .m-md-n17 {
    margin: -4.25rem !important;
  }

  .m-md-n18 {
    margin: -4.5rem !important;
  }

  .m-md-n19 {
    margin: -4.75rem !important;
  }

  .m-md-n20 {
    margin: -5rem !important;
  }

  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-md-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-md-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-md-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-md-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-md-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-md-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-md-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-md-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-md-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-md-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-md-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-md-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-md-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-md-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-md-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-md-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-md-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-md-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-md-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-md-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-md-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-md-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-md-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-md-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-md-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-md-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-md-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-md-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-md-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-md-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-md-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-md-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-md-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-md-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-md-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-md-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-md-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-md-n4 {
    margin-top: -1rem !important;
  }

  .mt-md-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-md-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-md-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-md-n8 {
    margin-top: -2rem !important;
  }

  .mt-md-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-md-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-md-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-md-n12 {
    margin-top: -3rem !important;
  }

  .mt-md-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-md-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-md-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-md-n16 {
    margin-top: -4rem !important;
  }

  .mt-md-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-md-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-md-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-md-n20 {
    margin-top: -5rem !important;
  }

  .me-md-n1 {
    margin-right: -0.25rem !important;
  }

  .me-md-n2 {
    margin-right: -0.5rem !important;
  }

  .me-md-n3 {
    margin-right: -0.75rem !important;
  }

  .me-md-n4 {
    margin-right: -1rem !important;
  }

  .me-md-n5 {
    margin-right: -1.25rem !important;
  }

  .me-md-n6 {
    margin-right: -1.5rem !important;
  }

  .me-md-n7 {
    margin-right: -1.75rem !important;
  }

  .me-md-n8 {
    margin-right: -2rem !important;
  }

  .me-md-n9 {
    margin-right: -2.25rem !important;
  }

  .me-md-n10 {
    margin-right: -2.5rem !important;
  }

  .me-md-n11 {
    margin-right: -2.75rem !important;
  }

  .me-md-n12 {
    margin-right: -3rem !important;
  }

  .me-md-n13 {
    margin-right: -3.25rem !important;
  }

  .me-md-n14 {
    margin-right: -3.5rem !important;
  }

  .me-md-n15 {
    margin-right: -3.75rem !important;
  }

  .me-md-n16 {
    margin-right: -4rem !important;
  }

  .me-md-n17 {
    margin-right: -4.25rem !important;
  }

  .me-md-n18 {
    margin-right: -4.5rem !important;
  }

  .me-md-n19 {
    margin-right: -4.75rem !important;
  }

  .me-md-n20 {
    margin-right: -5rem !important;
  }

  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-md-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-md-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-md-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-md-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-md-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-md-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-md-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-md-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-md-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-md-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-md-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-md-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-md-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-md-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-md-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-md-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-md-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-md-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-md-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-md-n4 {
    margin-left: -1rem !important;
  }

  .ms-md-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-md-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-md-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-md-n8 {
    margin-left: -2rem !important;
  }

  .ms-md-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-md-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-md-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-md-n12 {
    margin-left: -3rem !important;
  }

  .ms-md-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-md-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-md-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-md-n16 {
    margin-left: -4rem !important;
  }

  .ms-md-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-md-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-md-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-md-n20 {
    margin-left: -5rem !important;
  }

  .p-md-0 {
    padding: 0 !important;
  }

  .p-md-1 {
    padding: 0.25rem !important;
  }

  .p-md-2 {
    padding: 0.5rem !important;
  }

  .p-md-3 {
    padding: 0.75rem !important;
  }

  .p-md-4 {
    padding: 1rem !important;
  }

  .p-md-5 {
    padding: 1.25rem !important;
  }

  .p-md-6 {
    padding: 1.5rem !important;
  }

  .p-md-7 {
    padding: 1.75rem !important;
  }

  .p-md-8 {
    padding: 2rem !important;
  }

  .p-md-9 {
    padding: 2.25rem !important;
  }

  .p-md-10 {
    padding: 2.5rem !important;
  }

  .p-md-11 {
    padding: 2.75rem !important;
  }

  .p-md-12 {
    padding: 3rem !important;
  }

  .p-md-13 {
    padding: 3.25rem !important;
  }

  .p-md-14 {
    padding: 3.5rem !important;
  }

  .p-md-15 {
    padding: 3.75rem !important;
  }

  .p-md-16 {
    padding: 4rem !important;
  }

  .p-md-17 {
    padding: 4.25rem !important;
  }

  .p-md-18 {
    padding: 4.5rem !important;
  }

  .p-md-19 {
    padding: 4.75rem !important;
  }

  .p-md-20 {
    padding: 5rem !important;
  }

  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-md-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-md-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-md-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-md-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-md-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-md-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-md-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-md-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-md-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-md-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-md-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-md-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-md-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-md-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-md-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-md-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-md-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-md-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-md-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-md-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-md-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-md-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-md-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-md-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-md-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-md-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-md-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-md-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-md-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-md-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-md-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-md-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-md-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-md-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-md-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-md-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-md-0 {
    padding-top: 0 !important;
  }

  .pt-md-1 {
    padding-top: 0.25rem !important;
  }

  .pt-md-2 {
    padding-top: 0.5rem !important;
  }

  .pt-md-3 {
    padding-top: 0.75rem !important;
  }

  .pt-md-4 {
    padding-top: 1rem !important;
  }

  .pt-md-5 {
    padding-top: 1.25rem !important;
  }

  .pt-md-6 {
    padding-top: 1.5rem !important;
  }

  .pt-md-7 {
    padding-top: 1.75rem !important;
  }

  .pt-md-8 {
    padding-top: 2rem !important;
  }

  .pt-md-9 {
    padding-top: 2.25rem !important;
  }

  .pt-md-10 {
    padding-top: 2.5rem !important;
  }

  .pt-md-11 {
    padding-top: 2.75rem !important;
  }

  .pt-md-12 {
    padding-top: 3rem !important;
  }

  .pt-md-13 {
    padding-top: 3.25rem !important;
  }

  .pt-md-14 {
    padding-top: 3.5rem !important;
  }

  .pt-md-15 {
    padding-top: 3.75rem !important;
  }

  .pt-md-16 {
    padding-top: 4rem !important;
  }

  .pt-md-17 {
    padding-top: 4.25rem !important;
  }

  .pt-md-18 {
    padding-top: 4.5rem !important;
  }

  .pt-md-19 {
    padding-top: 4.75rem !important;
  }

  .pt-md-20 {
    padding-top: 5rem !important;
  }

  .pe-md-0 {
    padding-right: 0 !important;
  }

  .pe-md-1 {
    padding-right: 0.25rem !important;
  }

  .pe-md-2 {
    padding-right: 0.5rem !important;
  }

  .pe-md-3 {
    padding-right: 0.75rem !important;
  }

  .pe-md-4 {
    padding-right: 1rem !important;
  }

  .pe-md-5 {
    padding-right: 1.25rem !important;
  }

  .pe-md-6 {
    padding-right: 1.5rem !important;
  }

  .pe-md-7 {
    padding-right: 1.75rem !important;
  }

  .pe-md-8 {
    padding-right: 2rem !important;
  }

  .pe-md-9 {
    padding-right: 2.25rem !important;
  }

  .pe-md-10 {
    padding-right: 2.5rem !important;
  }

  .pe-md-11 {
    padding-right: 2.75rem !important;
  }

  .pe-md-12 {
    padding-right: 3rem !important;
  }

  .pe-md-13 {
    padding-right: 3.25rem !important;
  }

  .pe-md-14 {
    padding-right: 3.5rem !important;
  }

  .pe-md-15 {
    padding-right: 3.75rem !important;
  }

  .pe-md-16 {
    padding-right: 4rem !important;
  }

  .pe-md-17 {
    padding-right: 4.25rem !important;
  }

  .pe-md-18 {
    padding-right: 4.5rem !important;
  }

  .pe-md-19 {
    padding-right: 4.75rem !important;
  }

  .pe-md-20 {
    padding-right: 5rem !important;
  }

  .pb-md-0 {
    padding-bottom: 0 !important;
  }

  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-md-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-md-4 {
    padding-bottom: 1rem !important;
  }

  .pb-md-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-md-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-md-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-md-8 {
    padding-bottom: 2rem !important;
  }

  .pb-md-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-md-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-md-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-md-12 {
    padding-bottom: 3rem !important;
  }

  .pb-md-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-md-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-md-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-md-16 {
    padding-bottom: 4rem !important;
  }

  .pb-md-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-md-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-md-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-md-20 {
    padding-bottom: 5rem !important;
  }

  .ps-md-0 {
    padding-left: 0 !important;
  }

  .ps-md-1 {
    padding-left: 0.25rem !important;
  }

  .ps-md-2 {
    padding-left: 0.5rem !important;
  }

  .ps-md-3 {
    padding-left: 0.75rem !important;
  }

  .ps-md-4 {
    padding-left: 1rem !important;
  }

  .ps-md-5 {
    padding-left: 1.25rem !important;
  }

  .ps-md-6 {
    padding-left: 1.5rem !important;
  }

  .ps-md-7 {
    padding-left: 1.75rem !important;
  }

  .ps-md-8 {
    padding-left: 2rem !important;
  }

  .ps-md-9 {
    padding-left: 2.25rem !important;
  }

  .ps-md-10 {
    padding-left: 2.5rem !important;
  }

  .ps-md-11 {
    padding-left: 2.75rem !important;
  }

  .ps-md-12 {
    padding-left: 3rem !important;
  }

  .ps-md-13 {
    padding-left: 3.25rem !important;
  }

  .ps-md-14 {
    padding-left: 3.5rem !important;
  }

  .ps-md-15 {
    padding-left: 3.75rem !important;
  }

  .ps-md-16 {
    padding-left: 4rem !important;
  }

  .ps-md-17 {
    padding-left: 4.25rem !important;
  }

  .ps-md-18 {
    padding-left: 4.5rem !important;
  }

  .ps-md-19 {
    padding-left: 4.75rem !important;
  }

  .ps-md-20 {
    padding-left: 5rem !important;
  }

  .gap-md-0 {
    gap: 0 !important;
  }

  .gap-md-1 {
    gap: 0.25rem !important;
  }

  .gap-md-2 {
    gap: 0.5rem !important;
  }

  .gap-md-3 {
    gap: 0.75rem !important;
  }

  .gap-md-4 {
    gap: 1rem !important;
  }

  .gap-md-5 {
    gap: 1.25rem !important;
  }

  .gap-md-6 {
    gap: 1.5rem !important;
  }

  .gap-md-7 {
    gap: 1.75rem !important;
  }

  .gap-md-8 {
    gap: 2rem !important;
  }

  .gap-md-9 {
    gap: 2.25rem !important;
  }

  .gap-md-10 {
    gap: 2.5rem !important;
  }

  .gap-md-11 {
    gap: 2.75rem !important;
  }

  .gap-md-12 {
    gap: 3rem !important;
  }

  .gap-md-13 {
    gap: 3.25rem !important;
  }

  .gap-md-14 {
    gap: 3.5rem !important;
  }

  .gap-md-15 {
    gap: 3.75rem !important;
  }

  .gap-md-16 {
    gap: 4rem !important;
  }

  .gap-md-17 {
    gap: 4.25rem !important;
  }

  .gap-md-18 {
    gap: 4.5rem !important;
  }

  .gap-md-19 {
    gap: 4.75rem !important;
  }

  .gap-md-20 {
    gap: 5rem !important;
  }

  .fs-md-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }

  .fs-md-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }

  .fs-md-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }

  .fs-md-4 {
    font-size: 1.25rem !important;
  }

  .fs-md-5 {
    font-size: 1.15rem !important;
  }

  .fs-md-6 {
    font-size: 1.075rem !important;
  }

  .fs-md-7 {
    font-size: 0.95rem !important;
  }

  .fs-md-8 {
    font-size: 0.85rem !important;
  }

  .fs-md-9 {
    font-size: 0.75rem !important;
  }

  .fs-md-10 {
    font-size: 0.5rem !important;
  }

  .fs-md-base {
    font-size: 1rem !important;
  }

  .fs-md-fluid {
    font-size: 100% !important;
  }

  .fs-md-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }

  .fs-md-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }

  .fs-md-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }

  .fs-md-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }

  .fs-md-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }

  .fs-md-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }

  .fs-md-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }

  .fs-md-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }

  .fs-md-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }

  .fs-md-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }

  .fs-md-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }

  .fs-md-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }

  .fs-md-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }

  .fs-md-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }

  .fs-md-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }

  .fs-md-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }

  .text-md-start {
    text-align: left !important;
  }

  .text-md-end {
    text-align: right !important;
  }

  .text-md-center {
    text-align: center !important;
  }

  .min-w-md-unset {
    min-width: unset !important;
  }

  .min-w-md-25 {
    min-width: 25% !important;
  }

  .min-w-md-50 {
    min-width: 50% !important;
  }

  .min-w-md-75 {
    min-width: 75% !important;
  }

  .min-w-md-100 {
    min-width: 100% !important;
  }

  .min-w-md-auto {
    min-width: auto !important;
  }

  .min-w-md-1px {
    min-width: 1px !important;
  }

  .min-w-md-2px {
    min-width: 2px !important;
  }

  .min-w-md-3px {
    min-width: 3px !important;
  }

  .min-w-md-4px {
    min-width: 4px !important;
  }

  .min-w-md-5px {
    min-width: 5px !important;
  }

  .min-w-md-6px {
    min-width: 6px !important;
  }

  .min-w-md-7px {
    min-width: 7px !important;
  }

  .min-w-md-8px {
    min-width: 8px !important;
  }

  .min-w-md-9px {
    min-width: 9px !important;
  }

  .min-w-md-10px {
    min-width: 10px !important;
  }

  .min-w-md-15px {
    min-width: 15px !important;
  }

  .min-w-md-20px {
    min-width: 20px !important;
  }

  .min-w-md-25px {
    min-width: 25px !important;
  }

  .min-w-md-30px {
    min-width: 30px !important;
  }

  .min-w-md-35px {
    min-width: 35px !important;
  }

  .min-w-md-40px {
    min-width: 40px !important;
  }

  .min-w-md-45px {
    min-width: 45px !important;
  }

  .min-w-md-50px {
    min-width: 50px !important;
  }

  .min-w-md-55px {
    min-width: 55px !important;
  }

  .min-w-md-60px {
    min-width: 60px !important;
  }

  .min-w-md-65px {
    min-width: 65px !important;
  }

  .min-w-md-70px {
    min-width: 70px !important;
  }

  .min-w-md-75px {
    min-width: 75px !important;
  }

  .min-w-md-80px {
    min-width: 80px !important;
  }

  .min-w-md-85px {
    min-width: 85px !important;
  }

  .min-w-md-90px {
    min-width: 90px !important;
  }

  .min-w-md-95px {
    min-width: 95px !important;
  }

  .min-w-md-100px {
    min-width: 100px !important;
  }

  .min-w-md-125px {
    min-width: 125px !important;
  }

  .min-w-md-150px {
    min-width: 150px !important;
  }

  .min-w-md-175px {
    min-width: 175px !important;
  }

  .min-w-md-200px {
    min-width: 200px !important;
  }

  .min-w-md-225px {
    min-width: 225px !important;
  }

  .min-w-md-250px {
    min-width: 250px !important;
  }

  .min-w-md-275px {
    min-width: 275px !important;
  }

  .min-w-md-300px {
    min-width: 300px !important;
  }

  .min-w-md-325px {
    min-width: 325px !important;
  }

  .min-w-md-350px {
    min-width: 350px !important;
  }

  .min-w-md-375px {
    min-width: 375px !important;
  }

  .min-w-md-400px {
    min-width: 400px !important;
  }

  .min-w-md-425px {
    min-width: 425px !important;
  }

  .min-w-md-450px {
    min-width: 450px !important;
  }

  .min-w-md-475px {
    min-width: 475px !important;
  }

  .min-w-md-500px {
    min-width: 500px !important;
  }

  .min-w-md-550px {
    min-width: 550px !important;
  }

  .min-w-md-600px {
    min-width: 600px !important;
  }

  .min-w-md-650px {
    min-width: 650px !important;
  }

  .min-w-md-700px {
    min-width: 700px !important;
  }

  .min-w-md-750px {
    min-width: 750px !important;
  }

  .min-w-md-800px {
    min-width: 800px !important;
  }

  .min-w-md-850px {
    min-width: 850px !important;
  }

  .min-w-md-900px {
    min-width: 900px !important;
  }

  .min-w-md-950px {
    min-width: 950px !important;
  }

  .min-w-md-1000px {
    min-width: 1000px !important;
  }

  .min-h-md-unset {
    min-height: unset !important;
  }

  .min-h-md-25 {
    min-height: 25% !important;
  }

  .min-h-md-50 {
    min-height: 50% !important;
  }

  .min-h-md-75 {
    min-height: 75% !important;
  }

  .min-h-md-100 {
    min-height: 100% !important;
  }

  .min-h-md-auto {
    min-height: auto !important;
  }

  .min-h-md-1px {
    min-height: 1px !important;
  }

  .min-h-md-2px {
    min-height: 2px !important;
  }

  .min-h-md-3px {
    min-height: 3px !important;
  }

  .min-h-md-4px {
    min-height: 4px !important;
  }

  .min-h-md-5px {
    min-height: 5px !important;
  }

  .min-h-md-6px {
    min-height: 6px !important;
  }

  .min-h-md-7px {
    min-height: 7px !important;
  }

  .min-h-md-8px {
    min-height: 8px !important;
  }

  .min-h-md-9px {
    min-height: 9px !important;
  }

  .min-h-md-10px {
    min-height: 10px !important;
  }

  .min-h-md-15px {
    min-height: 15px !important;
  }

  .min-h-md-20px {
    min-height: 20px !important;
  }

  .min-h-md-25px {
    min-height: 25px !important;
  }

  .min-h-md-30px {
    min-height: 30px !important;
  }

  .min-h-md-35px {
    min-height: 35px !important;
  }

  .min-h-md-40px {
    min-height: 40px !important;
  }

  .min-h-md-45px {
    min-height: 45px !important;
  }

  .min-h-md-50px {
    min-height: 50px !important;
  }

  .min-h-md-55px {
    min-height: 55px !important;
  }

  .min-h-md-60px {
    min-height: 60px !important;
  }

  .min-h-md-65px {
    min-height: 65px !important;
  }

  .min-h-md-70px {
    min-height: 70px !important;
  }

  .min-h-md-75px {
    min-height: 75px !important;
  }

  .min-h-md-80px {
    min-height: 80px !important;
  }

  .min-h-md-85px {
    min-height: 85px !important;
  }

  .min-h-md-90px {
    min-height: 90px !important;
  }

  .min-h-md-95px {
    min-height: 95px !important;
  }

  .min-h-md-100px {
    min-height: 100px !important;
  }

  .min-h-md-125px {
    min-height: 125px !important;
  }

  .min-h-md-150px {
    min-height: 150px !important;
  }

  .min-h-md-175px {
    min-height: 175px !important;
  }

  .min-h-md-200px {
    min-height: 200px !important;
  }

  .min-h-md-225px {
    min-height: 225px !important;
  }

  .min-h-md-250px {
    min-height: 250px !important;
  }

  .min-h-md-275px {
    min-height: 275px !important;
  }

  .min-h-md-300px {
    min-height: 300px !important;
  }

  .min-h-md-325px {
    min-height: 325px !important;
  }

  .min-h-md-350px {
    min-height: 350px !important;
  }

  .min-h-md-375px {
    min-height: 375px !important;
  }

  .min-h-md-400px {
    min-height: 400px !important;
  }

  .min-h-md-425px {
    min-height: 425px !important;
  }

  .min-h-md-450px {
    min-height: 450px !important;
  }

  .min-h-md-475px {
    min-height: 475px !important;
  }

  .min-h-md-500px {
    min-height: 500px !important;
  }

  .min-h-md-550px {
    min-height: 550px !important;
  }

  .min-h-md-600px {
    min-height: 600px !important;
  }

  .min-h-md-650px {
    min-height: 650px !important;
  }

  .min-h-md-700px {
    min-height: 700px !important;
  }

  .min-h-md-750px {
    min-height: 750px !important;
  }

  .min-h-md-800px {
    min-height: 800px !important;
  }

  .min-h-md-850px {
    min-height: 850px !important;
  }

  .min-h-md-900px {
    min-height: 900px !important;
  }

  .min-h-md-950px {
    min-height: 950px !important;
  }

  .min-h-md-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }

  .float-lg-end {
    float: right !important;
  }

  .float-lg-none {
    float: none !important;
  }

  .d-lg-inline {
    display: inline !important;
  }

  .d-lg-inline-block {
    display: inline-block !important;
  }

  .d-lg-block {
    display: block !important;
  }

  .d-lg-grid {
    display: grid !important;
  }

  .d-lg-table {
    display: table !important;
  }

  .d-lg-table-row {
    display: table-row !important;
  }

  .d-lg-table-cell {
    display: table-cell !important;
  }

  .d-lg-flex {
    display: flex !important;
  }

  .d-lg-inline-flex {
    display: inline-flex !important;
  }

  .d-lg-none {
    display: none !important;
  }

  .position-lg-static {
    position: static !important;
  }

  .position-lg-relative {
    position: relative !important;
  }

  .position-lg-absolute {
    position: absolute !important;
  }

  .position-lg-fixed {
    position: fixed !important;
  }

  .position-lg-sticky {
    position: sticky !important;
  }

  .w-lg-unset {
    width: unset !important;
  }

  .w-lg-25 {
    width: 25% !important;
  }

  .w-lg-50 {
    width: 50% !important;
  }

  .w-lg-75 {
    width: 75% !important;
  }

  .w-lg-100 {
    width: 100% !important;
  }

  .w-lg-auto {
    width: auto !important;
  }

  .w-lg-1px {
    width: 1px !important;
  }

  .w-lg-2px {
    width: 2px !important;
  }

  .w-lg-3px {
    width: 3px !important;
  }

  .w-lg-4px {
    width: 4px !important;
  }

  .w-lg-5px {
    width: 5px !important;
  }

  .w-lg-6px {
    width: 6px !important;
  }

  .w-lg-7px {
    width: 7px !important;
  }

  .w-lg-8px {
    width: 8px !important;
  }

  .w-lg-9px {
    width: 9px !important;
  }

  .w-lg-10px {
    width: 10px !important;
  }

  .w-lg-15px {
    width: 15px !important;
  }

  .w-lg-20px {
    width: 20px !important;
  }

  .w-lg-25px {
    width: 25px !important;
  }

  .w-lg-30px {
    width: 30px !important;
  }

  .w-lg-35px {
    width: 35px !important;
  }

  .w-lg-40px {
    width: 40px !important;
  }

  .w-lg-45px {
    width: 45px !important;
  }

  .w-lg-50px {
    width: 50px !important;
  }

  .w-lg-55px {
    width: 55px !important;
  }

  .w-lg-60px {
    width: 60px !important;
  }

  .w-lg-65px {
    width: 65px !important;
  }

  .w-lg-70px {
    width: 70px !important;
  }

  .w-lg-75px {
    width: 75px !important;
  }

  .w-lg-80px {
    width: 80px !important;
  }

  .w-lg-85px {
    width: 85px !important;
  }

  .w-lg-90px {
    width: 90px !important;
  }

  .w-lg-95px {
    width: 95px !important;
  }

  .w-lg-100px {
    width: 100px !important;
  }

  .w-lg-125px {
    width: 125px !important;
  }

  .w-lg-150px {
    width: 150px !important;
  }

  .w-lg-175px {
    width: 175px !important;
  }

  .w-lg-200px {
    width: 200px !important;
  }

  .w-lg-225px {
    width: 225px !important;
  }

  .w-lg-250px {
    width: 250px !important;
  }

  .w-lg-275px {
    width: 275px !important;
  }

  .w-lg-300px {
    width: 300px !important;
  }

  .w-lg-325px {
    width: 325px !important;
  }

  .w-lg-350px {
    width: 350px !important;
  }

  .w-lg-375px {
    width: 375px !important;
  }

  .w-lg-400px {
    width: 400px !important;
  }

  .w-lg-425px {
    width: 425px !important;
  }

  .w-lg-450px {
    width: 450px !important;
  }

  .w-lg-475px {
    width: 475px !important;
  }

  .w-lg-500px {
    width: 500px !important;
  }

  .w-lg-550px {
    width: 550px !important;
  }

  .w-lg-600px {
    width: 600px !important;
  }

  .w-lg-650px {
    width: 650px !important;
  }

  .w-lg-700px {
    width: 700px !important;
  }

  .w-lg-750px {
    width: 750px !important;
  }

  .w-lg-800px {
    width: 800px !important;
  }

  .w-lg-850px {
    width: 850px !important;
  }

  .w-lg-900px {
    width: 900px !important;
  }

  .w-lg-950px {
    width: 950px !important;
  }

  .w-lg-1000px {
    width: 1000px !important;
  }

  .mw-lg-unset {
    max-width: unset !important;
  }

  .mw-lg-25 {
    max-width: 25% !important;
  }

  .mw-lg-50 {
    max-width: 50% !important;
  }

  .mw-lg-75 {
    max-width: 75% !important;
  }

  .mw-lg-100 {
    max-width: 100% !important;
  }

  .mw-lg-auto {
    max-width: auto !important;
  }

  .mw-lg-1px {
    max-width: 1px !important;
  }

  .mw-lg-2px {
    max-width: 2px !important;
  }

  .mw-lg-3px {
    max-width: 3px !important;
  }

  .mw-lg-4px {
    max-width: 4px !important;
  }

  .mw-lg-5px {
    max-width: 5px !important;
  }

  .mw-lg-6px {
    max-width: 6px !important;
  }

  .mw-lg-7px {
    max-width: 7px !important;
  }

  .mw-lg-8px {
    max-width: 8px !important;
  }

  .mw-lg-9px {
    max-width: 9px !important;
  }

  .mw-lg-10px {
    max-width: 10px !important;
  }

  .mw-lg-15px {
    max-width: 15px !important;
  }

  .mw-lg-20px {
    max-width: 20px !important;
  }

  .mw-lg-25px {
    max-width: 25px !important;
  }

  .mw-lg-30px {
    max-width: 30px !important;
  }

  .mw-lg-35px {
    max-width: 35px !important;
  }

  .mw-lg-40px {
    max-width: 40px !important;
  }

  .mw-lg-45px {
    max-width: 45px !important;
  }

  .mw-lg-50px {
    max-width: 50px !important;
  }

  .mw-lg-55px {
    max-width: 55px !important;
  }

  .mw-lg-60px {
    max-width: 60px !important;
  }

  .mw-lg-65px {
    max-width: 65px !important;
  }

  .mw-lg-70px {
    max-width: 70px !important;
  }

  .mw-lg-75px {
    max-width: 75px !important;
  }

  .mw-lg-80px {
    max-width: 80px !important;
  }

  .mw-lg-85px {
    max-width: 85px !important;
  }

  .mw-lg-90px {
    max-width: 90px !important;
  }

  .mw-lg-95px {
    max-width: 95px !important;
  }

  .mw-lg-100px {
    max-width: 100px !important;
  }

  .mw-lg-125px {
    max-width: 125px !important;
  }

  .mw-lg-150px {
    max-width: 150px !important;
  }

  .mw-lg-175px {
    max-width: 175px !important;
  }

  .mw-lg-200px {
    max-width: 200px !important;
  }

  .mw-lg-225px {
    max-width: 225px !important;
  }

  .mw-lg-250px {
    max-width: 250px !important;
  }

  .mw-lg-275px {
    max-width: 275px !important;
  }

  .mw-lg-300px {
    max-width: 300px !important;
  }

  .mw-lg-325px {
    max-width: 325px !important;
  }

  .mw-lg-350px {
    max-width: 350px !important;
  }

  .mw-lg-375px {
    max-width: 375px !important;
  }

  .mw-lg-400px {
    max-width: 400px !important;
  }

  .mw-lg-425px {
    max-width: 425px !important;
  }

  .mw-lg-450px {
    max-width: 450px !important;
  }

  .mw-lg-475px {
    max-width: 475px !important;
  }

  .mw-lg-500px {
    max-width: 500px !important;
  }

  .mw-lg-550px {
    max-width: 550px !important;
  }

  .mw-lg-600px {
    max-width: 600px !important;
  }

  .mw-lg-650px {
    max-width: 650px !important;
  }

  .mw-lg-700px {
    max-width: 700px !important;
  }

  .mw-lg-750px {
    max-width: 750px !important;
  }

  .mw-lg-800px {
    max-width: 800px !important;
  }

  .mw-lg-850px {
    max-width: 850px !important;
  }

  .mw-lg-900px {
    max-width: 900px !important;
  }

  .mw-lg-950px {
    max-width: 950px !important;
  }

  .mw-lg-1000px {
    max-width: 1000px !important;
  }

  .h-lg-unset {
    height: unset !important;
  }

  .h-lg-25 {
    height: 25% !important;
  }

  .h-lg-50 {
    height: 50% !important;
  }

  .h-lg-75 {
    height: 75% !important;
  }

  .h-lg-100 {
    height: 100% !important;
  }

  .h-lg-auto {
    height: auto !important;
  }

  .h-lg-1px {
    height: 1px !important;
  }

  .h-lg-2px {
    height: 2px !important;
  }

  .h-lg-3px {
    height: 3px !important;
  }

  .h-lg-4px {
    height: 4px !important;
  }

  .h-lg-5px {
    height: 5px !important;
  }

  .h-lg-6px {
    height: 6px !important;
  }

  .h-lg-7px {
    height: 7px !important;
  }

  .h-lg-8px {
    height: 8px !important;
  }

  .h-lg-9px {
    height: 9px !important;
  }

  .h-lg-10px {
    height: 10px !important;
  }

  .h-lg-15px {
    height: 15px !important;
  }

  .h-lg-20px {
    height: 20px !important;
  }

  .h-lg-25px {
    height: 25px !important;
  }

  .h-lg-30px {
    height: 30px !important;
  }

  .h-lg-35px {
    height: 35px !important;
  }

  .h-lg-40px {
    height: 40px !important;
  }

  .h-lg-45px {
    height: 45px !important;
  }

  .h-lg-50px {
    height: 50px !important;
  }

  .h-lg-55px {
    height: 55px !important;
  }

  .h-lg-60px {
    height: 60px !important;
  }

  .h-lg-65px {
    height: 65px !important;
  }

  .h-lg-70px {
    height: 70px !important;
  }

  .h-lg-75px {
    height: 75px !important;
  }

  .h-lg-80px {
    height: 80px !important;
  }

  .h-lg-85px {
    height: 85px !important;
  }

  .h-lg-90px {
    height: 90px !important;
  }

  .h-lg-95px {
    height: 95px !important;
  }

  .h-lg-100px {
    height: 100px !important;
  }

  .h-lg-125px {
    height: 125px !important;
  }

  .h-lg-150px {
    height: 150px !important;
  }

  .h-lg-175px {
    height: 175px !important;
  }

  .h-lg-200px {
    height: 200px !important;
  }

  .h-lg-225px {
    height: 225px !important;
  }

  .h-lg-250px {
    height: 250px !important;
  }

  .h-lg-275px {
    height: 275px !important;
  }

  .h-lg-300px {
    height: 300px !important;
  }

  .h-lg-325px {
    height: 325px !important;
  }

  .h-lg-350px {
    height: 350px !important;
  }

  .h-lg-375px {
    height: 375px !important;
  }

  .h-lg-400px {
    height: 400px !important;
  }

  .h-lg-425px {
    height: 425px !important;
  }

  .h-lg-450px {
    height: 450px !important;
  }

  .h-lg-475px {
    height: 475px !important;
  }

  .h-lg-500px {
    height: 500px !important;
  }

  .h-lg-550px {
    height: 550px !important;
  }

  .h-lg-600px {
    height: 600px !important;
  }

  .h-lg-650px {
    height: 650px !important;
  }

  .h-lg-700px {
    height: 700px !important;
  }

  .h-lg-750px {
    height: 750px !important;
  }

  .h-lg-800px {
    height: 800px !important;
  }

  .h-lg-850px {
    height: 850px !important;
  }

  .h-lg-900px {
    height: 900px !important;
  }

  .h-lg-950px {
    height: 950px !important;
  }

  .h-lg-1000px {
    height: 1000px !important;
  }

  .mh-lg-unset {
    max-height: unset !important;
  }

  .mh-lg-25 {
    max-height: 25% !important;
  }

  .mh-lg-50 {
    max-height: 50% !important;
  }

  .mh-lg-75 {
    max-height: 75% !important;
  }

  .mh-lg-100 {
    max-height: 100% !important;
  }

  .mh-lg-auto {
    max-height: auto !important;
  }

  .mh-lg-1px {
    max-height: 1px !important;
  }

  .mh-lg-2px {
    max-height: 2px !important;
  }

  .mh-lg-3px {
    max-height: 3px !important;
  }

  .mh-lg-4px {
    max-height: 4px !important;
  }

  .mh-lg-5px {
    max-height: 5px !important;
  }

  .mh-lg-6px {
    max-height: 6px !important;
  }

  .mh-lg-7px {
    max-height: 7px !important;
  }

  .mh-lg-8px {
    max-height: 8px !important;
  }

  .mh-lg-9px {
    max-height: 9px !important;
  }

  .mh-lg-10px {
    max-height: 10px !important;
  }

  .mh-lg-15px {
    max-height: 15px !important;
  }

  .mh-lg-20px {
    max-height: 20px !important;
  }

  .mh-lg-25px {
    max-height: 25px !important;
  }

  .mh-lg-30px {
    max-height: 30px !important;
  }

  .mh-lg-35px {
    max-height: 35px !important;
  }

  .mh-lg-40px {
    max-height: 40px !important;
  }

  .mh-lg-45px {
    max-height: 45px !important;
  }

  .mh-lg-50px {
    max-height: 50px !important;
  }

  .mh-lg-55px {
    max-height: 55px !important;
  }

  .mh-lg-60px {
    max-height: 60px !important;
  }

  .mh-lg-65px {
    max-height: 65px !important;
  }

  .mh-lg-70px {
    max-height: 70px !important;
  }

  .mh-lg-75px {
    max-height: 75px !important;
  }

  .mh-lg-80px {
    max-height: 80px !important;
  }

  .mh-lg-85px {
    max-height: 85px !important;
  }

  .mh-lg-90px {
    max-height: 90px !important;
  }

  .mh-lg-95px {
    max-height: 95px !important;
  }

  .mh-lg-100px {
    max-height: 100px !important;
  }

  .mh-lg-125px {
    max-height: 125px !important;
  }

  .mh-lg-150px {
    max-height: 150px !important;
  }

  .mh-lg-175px {
    max-height: 175px !important;
  }

  .mh-lg-200px {
    max-height: 200px !important;
  }

  .mh-lg-225px {
    max-height: 225px !important;
  }

  .mh-lg-250px {
    max-height: 250px !important;
  }

  .mh-lg-275px {
    max-height: 275px !important;
  }

  .mh-lg-300px {
    max-height: 300px !important;
  }

  .mh-lg-325px {
    max-height: 325px !important;
  }

  .mh-lg-350px {
    max-height: 350px !important;
  }

  .mh-lg-375px {
    max-height: 375px !important;
  }

  .mh-lg-400px {
    max-height: 400px !important;
  }

  .mh-lg-425px {
    max-height: 425px !important;
  }

  .mh-lg-450px {
    max-height: 450px !important;
  }

  .mh-lg-475px {
    max-height: 475px !important;
  }

  .mh-lg-500px {
    max-height: 500px !important;
  }

  .mh-lg-550px {
    max-height: 550px !important;
  }

  .mh-lg-600px {
    max-height: 600px !important;
  }

  .mh-lg-650px {
    max-height: 650px !important;
  }

  .mh-lg-700px {
    max-height: 700px !important;
  }

  .mh-lg-750px {
    max-height: 750px !important;
  }

  .mh-lg-800px {
    max-height: 800px !important;
  }

  .mh-lg-850px {
    max-height: 850px !important;
  }

  .mh-lg-900px {
    max-height: 900px !important;
  }

  .mh-lg-950px {
    max-height: 950px !important;
  }

  .mh-lg-1000px {
    max-height: 1000px !important;
  }

  .flex-lg-fill {
    flex: 1 1 auto !important;
  }

  .flex-lg-row {
    flex-direction: row !important;
  }

  .flex-lg-column {
    flex-direction: column !important;
  }

  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }

  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-lg-start {
    justify-content: flex-start !important;
  }

  .justify-content-lg-end {
    justify-content: flex-end !important;
  }

  .justify-content-lg-center {
    justify-content: center !important;
  }

  .justify-content-lg-between {
    justify-content: space-between !important;
  }

  .justify-content-lg-around {
    justify-content: space-around !important;
  }

  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-lg-start {
    align-items: flex-start !important;
  }

  .align-items-lg-end {
    align-items: flex-end !important;
  }

  .align-items-lg-center {
    align-items: center !important;
  }

  .align-items-lg-baseline {
    align-items: baseline !important;
  }

  .align-items-lg-stretch {
    align-items: stretch !important;
  }

  .align-content-lg-start {
    align-content: flex-start !important;
  }

  .align-content-lg-end {
    align-content: flex-end !important;
  }

  .align-content-lg-center {
    align-content: center !important;
  }

  .align-content-lg-between {
    align-content: space-between !important;
  }

  .align-content-lg-around {
    align-content: space-around !important;
  }

  .align-content-lg-stretch {
    align-content: stretch !important;
  }

  .align-self-lg-auto {
    align-self: auto !important;
  }

  .align-self-lg-start {
    align-self: flex-start !important;
  }

  .align-self-lg-end {
    align-self: flex-end !important;
  }

  .align-self-lg-center {
    align-self: center !important;
  }

  .align-self-lg-baseline {
    align-self: baseline !important;
  }

  .align-self-lg-stretch {
    align-self: stretch !important;
  }

  .order-lg-first {
    order: -1 !important;
  }

  .order-lg-0 {
    order: 0 !important;
  }

  .order-lg-1 {
    order: 1 !important;
  }

  .order-lg-2 {
    order: 2 !important;
  }

  .order-lg-3 {
    order: 3 !important;
  }

  .order-lg-4 {
    order: 4 !important;
  }

  .order-lg-5 {
    order: 5 !important;
  }

  .order-lg-last {
    order: 6 !important;
  }

  .m-lg-0 {
    margin: 0 !important;
  }

  .m-lg-1 {
    margin: 0.25rem !important;
  }

  .m-lg-2 {
    margin: 0.5rem !important;
  }

  .m-lg-3 {
    margin: 0.75rem !important;
  }

  .m-lg-4 {
    margin: 1rem !important;
  }

  .m-lg-5 {
    margin: 1.25rem !important;
  }

  .m-lg-6 {
    margin: 1.5rem !important;
  }

  .m-lg-7 {
    margin: 1.75rem !important;
  }

  .m-lg-8 {
    margin: 2rem !important;
  }

  .m-lg-9 {
    margin: 2.25rem !important;
  }

  .m-lg-10 {
    margin: 2.5rem !important;
  }

  .m-lg-11 {
    margin: 2.75rem !important;
  }

  .m-lg-12 {
    margin: 3rem !important;
  }

  .m-lg-13 {
    margin: 3.25rem !important;
  }

  .m-lg-14 {
    margin: 3.5rem !important;
  }

  .m-lg-15 {
    margin: 3.75rem !important;
  }

  .m-lg-16 {
    margin: 4rem !important;
  }

  .m-lg-17 {
    margin: 4.25rem !important;
  }

  .m-lg-18 {
    margin: 4.5rem !important;
  }

  .m-lg-19 {
    margin: 4.75rem !important;
  }

  .m-lg-20 {
    margin: 5rem !important;
  }

  .m-lg-auto {
    margin: auto !important;
  }

  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-lg-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-lg-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-lg-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-lg-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-lg-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-lg-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-lg-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-lg-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-lg-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-lg-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-lg-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-lg-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-lg-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-lg-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-lg-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-lg-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-lg-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-lg-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-lg-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-lg-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-lg-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-lg-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-lg-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-lg-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-lg-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-lg-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-lg-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-lg-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-lg-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-lg-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-lg-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-lg-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-lg-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-lg-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-lg-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-lg-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-lg-0 {
    margin-top: 0 !important;
  }

  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }

  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }

  .mt-lg-3 {
    margin-top: 0.75rem !important;
  }

  .mt-lg-4 {
    margin-top: 1rem !important;
  }

  .mt-lg-5 {
    margin-top: 1.25rem !important;
  }

  .mt-lg-6 {
    margin-top: 1.5rem !important;
  }

  .mt-lg-7 {
    margin-top: 1.75rem !important;
  }

  .mt-lg-8 {
    margin-top: 2rem !important;
  }

  .mt-lg-9 {
    margin-top: 2.25rem !important;
  }

  .mt-lg-10 {
    margin-top: 2.5rem !important;
  }

  .mt-lg-11 {
    margin-top: 2.75rem !important;
  }

  .mt-lg-12 {
    margin-top: 3rem !important;
  }

  .mt-lg-13 {
    margin-top: 3.25rem !important;
  }

  .mt-lg-14 {
    margin-top: 3.5rem !important;
  }

  .mt-lg-15 {
    margin-top: 3.75rem !important;
  }

  .mt-lg-16 {
    margin-top: 4rem !important;
  }

  .mt-lg-17 {
    margin-top: 4.25rem !important;
  }

  .mt-lg-18 {
    margin-top: 4.5rem !important;
  }

  .mt-lg-19 {
    margin-top: 4.75rem !important;
  }

  .mt-lg-20 {
    margin-top: 5rem !important;
  }

  .mt-lg-auto {
    margin-top: auto !important;
  }

  .me-lg-0 {
    margin-right: 0 !important;
  }

  .me-lg-1 {
    margin-right: 0.25rem !important;
  }

  .me-lg-2 {
    margin-right: 0.5rem !important;
  }

  .me-lg-3 {
    margin-right: 0.75rem !important;
  }

  .me-lg-4 {
    margin-right: 1rem !important;
  }

  .me-lg-5 {
    margin-right: 1.25rem !important;
  }

  .me-lg-6 {
    margin-right: 1.5rem !important;
  }

  .me-lg-7 {
    margin-right: 1.75rem !important;
  }

  .me-lg-8 {
    margin-right: 2rem !important;
  }

  .me-lg-9 {
    margin-right: 2.25rem !important;
  }

  .me-lg-10 {
    margin-right: 2.5rem !important;
  }

  .me-lg-11 {
    margin-right: 2.75rem !important;
  }

  .me-lg-12 {
    margin-right: 3rem !important;
  }

  .me-lg-13 {
    margin-right: 3.25rem !important;
  }

  .me-lg-14 {
    margin-right: 3.5rem !important;
  }

  .me-lg-15 {
    margin-right: 3.75rem !important;
  }

  .me-lg-16 {
    margin-right: 4rem !important;
  }

  .me-lg-17 {
    margin-right: 4.25rem !important;
  }

  .me-lg-18 {
    margin-right: 4.5rem !important;
  }

  .me-lg-19 {
    margin-right: 4.75rem !important;
  }

  .me-lg-20 {
    margin-right: 5rem !important;
  }

  .me-lg-auto {
    margin-right: auto !important;
  }

  .mb-lg-0 {
    margin-bottom: 0 !important;
  }

  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-lg-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-lg-4 {
    margin-bottom: 1rem !important;
  }

  .mb-lg-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-lg-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-lg-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-lg-8 {
    margin-bottom: 2rem !important;
  }

  .mb-lg-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-lg-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-lg-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-lg-12 {
    margin-bottom: 3rem !important;
  }

  .mb-lg-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-lg-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-lg-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-lg-16 {
    margin-bottom: 4rem !important;
  }

  .mb-lg-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-lg-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-lg-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-lg-20 {
    margin-bottom: 5rem !important;
  }

  .mb-lg-auto {
    margin-bottom: auto !important;
  }

  .ms-lg-0 {
    margin-left: 0 !important;
  }

  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }

  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }

  .ms-lg-3 {
    margin-left: 0.75rem !important;
  }

  .ms-lg-4 {
    margin-left: 1rem !important;
  }

  .ms-lg-5 {
    margin-left: 1.25rem !important;
  }

  .ms-lg-6 {
    margin-left: 1.5rem !important;
  }

  .ms-lg-7 {
    margin-left: 1.75rem !important;
  }

  .ms-lg-8 {
    margin-left: 2rem !important;
  }

  .ms-lg-9 {
    margin-left: 2.25rem !important;
  }

  .ms-lg-10 {
    margin-left: 2.5rem !important;
  }

  .ms-lg-11 {
    margin-left: 2.75rem !important;
  }

  .ms-lg-12 {
    margin-left: 3rem !important;
  }

  .ms-lg-13 {
    margin-left: 3.25rem !important;
  }

  .ms-lg-14 {
    margin-left: 3.5rem !important;
  }

  .ms-lg-15 {
    margin-left: 3.75rem !important;
  }

  .ms-lg-16 {
    margin-left: 4rem !important;
  }

  .ms-lg-17 {
    margin-left: 4.25rem !important;
  }

  .ms-lg-18 {
    margin-left: 4.5rem !important;
  }

  .ms-lg-19 {
    margin-left: 4.75rem !important;
  }

  .ms-lg-20 {
    margin-left: 5rem !important;
  }

  .ms-lg-auto {
    margin-left: auto !important;
  }

  .m-lg-n1 {
    margin: -0.25rem !important;
  }

  .m-lg-n2 {
    margin: -0.5rem !important;
  }

  .m-lg-n3 {
    margin: -0.75rem !important;
  }

  .m-lg-n4 {
    margin: -1rem !important;
  }

  .m-lg-n5 {
    margin: -1.25rem !important;
  }

  .m-lg-n6 {
    margin: -1.5rem !important;
  }

  .m-lg-n7 {
    margin: -1.75rem !important;
  }

  .m-lg-n8 {
    margin: -2rem !important;
  }

  .m-lg-n9 {
    margin: -2.25rem !important;
  }

  .m-lg-n10 {
    margin: -2.5rem !important;
  }

  .m-lg-n11 {
    margin: -2.75rem !important;
  }

  .m-lg-n12 {
    margin: -3rem !important;
  }

  .m-lg-n13 {
    margin: -3.25rem !important;
  }

  .m-lg-n14 {
    margin: -3.5rem !important;
  }

  .m-lg-n15 {
    margin: -3.75rem !important;
  }

  .m-lg-n16 {
    margin: -4rem !important;
  }

  .m-lg-n17 {
    margin: -4.25rem !important;
  }

  .m-lg-n18 {
    margin: -4.5rem !important;
  }

  .m-lg-n19 {
    margin: -4.75rem !important;
  }

  .m-lg-n20 {
    margin: -5rem !important;
  }

  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-lg-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-lg-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-lg-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-lg-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-lg-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-lg-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-lg-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-lg-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-lg-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-lg-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-lg-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-lg-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-lg-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-lg-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-lg-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-lg-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-lg-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-lg-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-lg-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-lg-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-lg-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-lg-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-lg-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-lg-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-lg-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-lg-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-lg-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-lg-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-lg-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-lg-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-lg-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-lg-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-lg-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-lg-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-lg-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-lg-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-lg-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-lg-n4 {
    margin-top: -1rem !important;
  }

  .mt-lg-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-lg-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-lg-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-lg-n8 {
    margin-top: -2rem !important;
  }

  .mt-lg-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-lg-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-lg-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-lg-n12 {
    margin-top: -3rem !important;
  }

  .mt-lg-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-lg-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-lg-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-lg-n16 {
    margin-top: -4rem !important;
  }

  .mt-lg-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-lg-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-lg-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-lg-n20 {
    margin-top: -5rem !important;
  }

  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }

  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }

  .me-lg-n3 {
    margin-right: -0.75rem !important;
  }

  .me-lg-n4 {
    margin-right: -1rem !important;
  }

  .me-lg-n5 {
    margin-right: -1.25rem !important;
  }

  .me-lg-n6 {
    margin-right: -1.5rem !important;
  }

  .me-lg-n7 {
    margin-right: -1.75rem !important;
  }

  .me-lg-n8 {
    margin-right: -2rem !important;
  }

  .me-lg-n9 {
    margin-right: -2.25rem !important;
  }

  .me-lg-n10 {
    margin-right: -2.5rem !important;
  }

  .me-lg-n11 {
    margin-right: -2.75rem !important;
  }

  .me-lg-n12 {
    margin-right: -3rem !important;
  }

  .me-lg-n13 {
    margin-right: -3.25rem !important;
  }

  .me-lg-n14 {
    margin-right: -3.5rem !important;
  }

  .me-lg-n15 {
    margin-right: -3.75rem !important;
  }

  .me-lg-n16 {
    margin-right: -4rem !important;
  }

  .me-lg-n17 {
    margin-right: -4.25rem !important;
  }

  .me-lg-n18 {
    margin-right: -4.5rem !important;
  }

  .me-lg-n19 {
    margin-right: -4.75rem !important;
  }

  .me-lg-n20 {
    margin-right: -5rem !important;
  }

  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-lg-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-lg-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-lg-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-lg-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-lg-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-lg-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-lg-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-lg-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-lg-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-lg-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-lg-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-lg-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-lg-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-lg-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-lg-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-lg-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-lg-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-lg-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-lg-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-lg-n4 {
    margin-left: -1rem !important;
  }

  .ms-lg-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-lg-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-lg-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-lg-n8 {
    margin-left: -2rem !important;
  }

  .ms-lg-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-lg-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-lg-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-lg-n12 {
    margin-left: -3rem !important;
  }

  .ms-lg-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-lg-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-lg-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-lg-n16 {
    margin-left: -4rem !important;
  }

  .ms-lg-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-lg-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-lg-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-lg-n20 {
    margin-left: -5rem !important;
  }

  .p-lg-0 {
    padding: 0 !important;
  }

  .p-lg-1 {
    padding: 0.25rem !important;
  }

  .p-lg-2 {
    padding: 0.5rem !important;
  }

  .p-lg-3 {
    padding: 0.75rem !important;
  }

  .p-lg-4 {
    padding: 1rem !important;
  }

  .p-lg-5 {
    padding: 1.25rem !important;
  }

  .p-lg-6 {
    padding: 1.5rem !important;
  }

  .p-lg-7 {
    padding: 1.75rem !important;
  }

  .p-lg-8 {
    padding: 2rem !important;
  }

  .p-lg-9 {
    padding: 2.25rem !important;
  }

  .p-lg-10 {
    padding: 2.5rem !important;
  }

  .p-lg-11 {
    padding: 2.75rem !important;
  }

  .p-lg-12 {
    padding: 3rem !important;
  }

  .p-lg-13 {
    padding: 3.25rem !important;
  }

  .p-lg-14 {
    padding: 3.5rem !important;
  }

  .p-lg-15 {
    padding: 3.75rem !important;
  }

  .p-lg-16 {
    padding: 4rem !important;
  }

  .p-lg-17 {
    padding: 4.25rem !important;
  }

  .p-lg-18 {
    padding: 4.5rem !important;
  }

  .p-lg-19 {
    padding: 4.75rem !important;
  }

  .p-lg-20 {
    padding: 5rem !important;
  }

  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-lg-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-lg-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-lg-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-lg-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-lg-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-lg-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-lg-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-lg-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-lg-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-lg-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-lg-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-lg-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-lg-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-lg-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-lg-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-lg-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-lg-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-lg-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-lg-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-lg-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-lg-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-lg-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-lg-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-lg-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-lg-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-lg-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-lg-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-lg-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-lg-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-lg-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-lg-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-lg-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-lg-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-lg-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-lg-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-lg-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-lg-0 {
    padding-top: 0 !important;
  }

  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }

  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }

  .pt-lg-3 {
    padding-top: 0.75rem !important;
  }

  .pt-lg-4 {
    padding-top: 1rem !important;
  }

  .pt-lg-5 {
    padding-top: 1.25rem !important;
  }

  .pt-lg-6 {
    padding-top: 1.5rem !important;
  }

  .pt-lg-7 {
    padding-top: 1.75rem !important;
  }

  .pt-lg-8 {
    padding-top: 2rem !important;
  }

  .pt-lg-9 {
    padding-top: 2.25rem !important;
  }

  .pt-lg-10 {
    padding-top: 2.5rem !important;
  }

  .pt-lg-11 {
    padding-top: 2.75rem !important;
  }

  .pt-lg-12 {
    padding-top: 3rem !important;
  }

  .pt-lg-13 {
    padding-top: 3.25rem !important;
  }

  .pt-lg-14 {
    padding-top: 3.5rem !important;
  }

  .pt-lg-15 {
    padding-top: 3.75rem !important;
  }

  .pt-lg-16 {
    padding-top: 4rem !important;
  }

  .pt-lg-17 {
    padding-top: 4.25rem !important;
  }

  .pt-lg-18 {
    padding-top: 4.5rem !important;
  }

  .pt-lg-19 {
    padding-top: 4.75rem !important;
  }

  .pt-lg-20 {
    padding-top: 5rem !important;
  }

  .pe-lg-0 {
    padding-right: 0 !important;
  }

  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }

  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }

  .pe-lg-3 {
    padding-right: 0.75rem !important;
  }

  .pe-lg-4 {
    padding-right: 1rem !important;
  }

  .pe-lg-5 {
    padding-right: 1.25rem !important;
  }

  .pe-lg-6 {
    padding-right: 1.5rem !important;
  }

  .pe-lg-7 {
    padding-right: 1.75rem !important;
  }

  .pe-lg-8 {
    padding-right: 2rem !important;
  }

  .pe-lg-9 {
    padding-right: 2.25rem !important;
  }

  .pe-lg-10 {
    padding-right: 2.5rem !important;
  }

  .pe-lg-11 {
    padding-right: 2.75rem !important;
  }

  .pe-lg-12 {
    padding-right: 3rem !important;
  }

  .pe-lg-13 {
    padding-right: 3.25rem !important;
  }

  .pe-lg-14 {
    padding-right: 3.5rem !important;
  }

  .pe-lg-15 {
    padding-right: 3.75rem !important;
  }

  .pe-lg-16 {
    padding-right: 4rem !important;
  }

  .pe-lg-17 {
    padding-right: 4.25rem !important;
  }

  .pe-lg-18 {
    padding-right: 4.5rem !important;
  }

  .pe-lg-19 {
    padding-right: 4.75rem !important;
  }

  .pe-lg-20 {
    padding-right: 5rem !important;
  }

  .pb-lg-0 {
    padding-bottom: 0 !important;
  }

  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-lg-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-lg-4 {
    padding-bottom: 1rem !important;
  }

  .pb-lg-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-lg-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-lg-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-lg-8 {
    padding-bottom: 2rem !important;
  }

  .pb-lg-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-lg-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-lg-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-lg-12 {
    padding-bottom: 3rem !important;
  }

  .pb-lg-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-lg-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-lg-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-lg-16 {
    padding-bottom: 4rem !important;
  }

  .pb-lg-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-lg-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-lg-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-lg-20 {
    padding-bottom: 5rem !important;
  }

  .ps-lg-0 {
    padding-left: 0 !important;
  }

  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }

  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }

  .ps-lg-3 {
    padding-left: 0.75rem !important;
  }

  .ps-lg-4 {
    padding-left: 1rem !important;
  }

  .ps-lg-5 {
    padding-left: 1.25rem !important;
  }

  .ps-lg-6 {
    padding-left: 1.5rem !important;
  }

  .ps-lg-7 {
    padding-left: 1.75rem !important;
  }

  .ps-lg-8 {
    padding-left: 2rem !important;
  }

  .ps-lg-9 {
    padding-left: 2.25rem !important;
  }

  .ps-lg-10 {
    padding-left: 2.5rem !important;
  }

  .ps-lg-11 {
    padding-left: 2.75rem !important;
  }

  .ps-lg-12 {
    padding-left: 3rem !important;
  }

  .ps-lg-13 {
    padding-left: 3.25rem !important;
  }

  .ps-lg-14 {
    padding-left: 3.5rem !important;
  }

  .ps-lg-15 {
    padding-left: 3.75rem !important;
  }

  .ps-lg-16 {
    padding-left: 4rem !important;
  }

  .ps-lg-17 {
    padding-left: 4.25rem !important;
  }

  .ps-lg-18 {
    padding-left: 4.5rem !important;
  }

  .ps-lg-19 {
    padding-left: 4.75rem !important;
  }

  .ps-lg-20 {
    padding-left: 5rem !important;
  }

  .gap-lg-0 {
    gap: 0 !important;
  }

  .gap-lg-1 {
    gap: 0.25rem !important;
  }

  .gap-lg-2 {
    gap: 0.5rem !important;
  }

  .gap-lg-3 {
    gap: 0.75rem !important;
  }

  .gap-lg-4 {
    gap: 1rem !important;
  }

  .gap-lg-5 {
    gap: 1.25rem !important;
  }

  .gap-lg-6 {
    gap: 1.5rem !important;
  }

  .gap-lg-7 {
    gap: 1.75rem !important;
  }

  .gap-lg-8 {
    gap: 2rem !important;
  }

  .gap-lg-9 {
    gap: 2.25rem !important;
  }

  .gap-lg-10 {
    gap: 2.5rem !important;
  }

  .gap-lg-11 {
    gap: 2.75rem !important;
  }

  .gap-lg-12 {
    gap: 3rem !important;
  }

  .gap-lg-13 {
    gap: 3.25rem !important;
  }

  .gap-lg-14 {
    gap: 3.5rem !important;
  }

  .gap-lg-15 {
    gap: 3.75rem !important;
  }

  .gap-lg-16 {
    gap: 4rem !important;
  }

  .gap-lg-17 {
    gap: 4.25rem !important;
  }

  .gap-lg-18 {
    gap: 4.5rem !important;
  }

  .gap-lg-19 {
    gap: 4.75rem !important;
  }

  .gap-lg-20 {
    gap: 5rem !important;
  }

  .fs-lg-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }

  .fs-lg-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }

  .fs-lg-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }

  .fs-lg-4 {
    font-size: 1.25rem !important;
  }

  .fs-lg-5 {
    font-size: 1.15rem !important;
  }

  .fs-lg-6 {
    font-size: 1.075rem !important;
  }

  .fs-lg-7 {
    font-size: 0.95rem !important;
  }

  .fs-lg-8 {
    font-size: 0.85rem !important;
  }

  .fs-lg-9 {
    font-size: 0.75rem !important;
  }

  .fs-lg-10 {
    font-size: 0.5rem !important;
  }

  .fs-lg-base {
    font-size: 1rem !important;
  }

  .fs-lg-fluid {
    font-size: 100% !important;
  }

  .fs-lg-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }

  .fs-lg-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }

  .fs-lg-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }

  .fs-lg-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }

  .fs-lg-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }

  .fs-lg-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }

  .fs-lg-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }

  .fs-lg-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }

  .fs-lg-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }

  .fs-lg-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }

  .fs-lg-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }

  .fs-lg-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }

  .fs-lg-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }

  .fs-lg-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }

  .fs-lg-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }

  .fs-lg-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }

  .text-lg-start {
    text-align: left !important;
  }

  .text-lg-end {
    text-align: right !important;
  }

  .text-lg-center {
    text-align: center !important;
  }

  .min-w-lg-unset {
    min-width: unset !important;
  }

  .min-w-lg-25 {
    min-width: 25% !important;
  }

  .min-w-lg-50 {
    min-width: 50% !important;
  }

  .min-w-lg-75 {
    min-width: 75% !important;
  }

  .min-w-lg-100 {
    min-width: 100% !important;
  }

  .min-w-lg-auto {
    min-width: auto !important;
  }

  .min-w-lg-1px {
    min-width: 1px !important;
  }

  .min-w-lg-2px {
    min-width: 2px !important;
  }

  .min-w-lg-3px {
    min-width: 3px !important;
  }

  .min-w-lg-4px {
    min-width: 4px !important;
  }

  .min-w-lg-5px {
    min-width: 5px !important;
  }

  .min-w-lg-6px {
    min-width: 6px !important;
  }

  .min-w-lg-7px {
    min-width: 7px !important;
  }

  .min-w-lg-8px {
    min-width: 8px !important;
  }

  .min-w-lg-9px {
    min-width: 9px !important;
  }

  .min-w-lg-10px {
    min-width: 10px !important;
  }

  .min-w-lg-15px {
    min-width: 15px !important;
  }

  .min-w-lg-20px {
    min-width: 20px !important;
  }

  .min-w-lg-25px {
    min-width: 25px !important;
  }

  .min-w-lg-30px {
    min-width: 30px !important;
  }

  .min-w-lg-35px {
    min-width: 35px !important;
  }

  .min-w-lg-40px {
    min-width: 40px !important;
  }

  .min-w-lg-45px {
    min-width: 45px !important;
  }

  .min-w-lg-50px {
    min-width: 50px !important;
  }

  .min-w-lg-55px {
    min-width: 55px !important;
  }

  .min-w-lg-60px {
    min-width: 60px !important;
  }

  .min-w-lg-65px {
    min-width: 65px !important;
  }

  .min-w-lg-70px {
    min-width: 70px !important;
  }

  .min-w-lg-75px {
    min-width: 75px !important;
  }

  .min-w-lg-80px {
    min-width: 80px !important;
  }

  .min-w-lg-85px {
    min-width: 85px !important;
  }

  .min-w-lg-90px {
    min-width: 90px !important;
  }

  .min-w-lg-95px {
    min-width: 95px !important;
  }

  .min-w-lg-100px {
    min-width: 100px !important;
  }

  .min-w-lg-125px {
    min-width: 125px !important;
  }

  .min-w-lg-150px {
    min-width: 150px !important;
  }

  .min-w-lg-175px {
    min-width: 175px !important;
  }

  .min-w-lg-200px {
    min-width: 200px !important;
  }

  .min-w-lg-225px {
    min-width: 225px !important;
  }

  .min-w-lg-250px {
    min-width: 250px !important;
  }

  .min-w-lg-275px {
    min-width: 275px !important;
  }

  .min-w-lg-300px {
    min-width: 300px !important;
  }

  .min-w-lg-325px {
    min-width: 325px !important;
  }

  .min-w-lg-350px {
    min-width: 350px !important;
  }

  .min-w-lg-375px {
    min-width: 375px !important;
  }

  .min-w-lg-400px {
    min-width: 400px !important;
  }

  .min-w-lg-425px {
    min-width: 425px !important;
  }

  .min-w-lg-450px {
    min-width: 450px !important;
  }

  .min-w-lg-475px {
    min-width: 475px !important;
  }

  .min-w-lg-500px {
    min-width: 500px !important;
  }

  .min-w-lg-550px {
    min-width: 550px !important;
  }

  .min-w-lg-600px {
    min-width: 600px !important;
  }

  .min-w-lg-650px {
    min-width: 650px !important;
  }

  .min-w-lg-700px {
    min-width: 700px !important;
  }

  .min-w-lg-750px {
    min-width: 750px !important;
  }

  .min-w-lg-800px {
    min-width: 800px !important;
  }

  .min-w-lg-850px {
    min-width: 850px !important;
  }

  .min-w-lg-900px {
    min-width: 900px !important;
  }

  .min-w-lg-950px {
    min-width: 950px !important;
  }

  .min-w-lg-1000px {
    min-width: 1000px !important;
  }

  .min-h-lg-unset {
    min-height: unset !important;
  }

  .min-h-lg-25 {
    min-height: 25% !important;
  }

  .min-h-lg-50 {
    min-height: 50% !important;
  }

  .min-h-lg-75 {
    min-height: 75% !important;
  }

  .min-h-lg-100 {
    min-height: 100% !important;
  }

  .min-h-lg-auto {
    min-height: auto !important;
  }

  .min-h-lg-1px {
    min-height: 1px !important;
  }

  .min-h-lg-2px {
    min-height: 2px !important;
  }

  .min-h-lg-3px {
    min-height: 3px !important;
  }

  .min-h-lg-4px {
    min-height: 4px !important;
  }

  .min-h-lg-5px {
    min-height: 5px !important;
  }

  .min-h-lg-6px {
    min-height: 6px !important;
  }

  .min-h-lg-7px {
    min-height: 7px !important;
  }

  .min-h-lg-8px {
    min-height: 8px !important;
  }

  .min-h-lg-9px {
    min-height: 9px !important;
  }

  .min-h-lg-10px {
    min-height: 10px !important;
  }

  .min-h-lg-15px {
    min-height: 15px !important;
  }

  .min-h-lg-20px {
    min-height: 20px !important;
  }

  .min-h-lg-25px {
    min-height: 25px !important;
  }

  .min-h-lg-30px {
    min-height: 30px !important;
  }

  .min-h-lg-35px {
    min-height: 35px !important;
  }

  .min-h-lg-40px {
    min-height: 40px !important;
  }

  .min-h-lg-45px {
    min-height: 45px !important;
  }

  .min-h-lg-50px {
    min-height: 50px !important;
  }

  .min-h-lg-55px {
    min-height: 55px !important;
  }

  .min-h-lg-60px {
    min-height: 60px !important;
  }

  .min-h-lg-65px {
    min-height: 65px !important;
  }

  .min-h-lg-70px {
    min-height: 70px !important;
  }

  .min-h-lg-75px {
    min-height: 75px !important;
  }

  .min-h-lg-80px {
    min-height: 80px !important;
  }

  .min-h-lg-85px {
    min-height: 85px !important;
  }

  .min-h-lg-90px {
    min-height: 90px !important;
  }

  .min-h-lg-95px {
    min-height: 95px !important;
  }

  .min-h-lg-100px {
    min-height: 100px !important;
  }

  .min-h-lg-125px {
    min-height: 125px !important;
  }

  .min-h-lg-150px {
    min-height: 150px !important;
  }

  .min-h-lg-175px {
    min-height: 175px !important;
  }

  .min-h-lg-200px {
    min-height: 200px !important;
  }

  .min-h-lg-225px {
    min-height: 225px !important;
  }

  .min-h-lg-250px {
    min-height: 250px !important;
  }

  .min-h-lg-275px {
    min-height: 275px !important;
  }

  .min-h-lg-300px {
    min-height: 300px !important;
  }

  .min-h-lg-325px {
    min-height: 325px !important;
  }

  .min-h-lg-350px {
    min-height: 350px !important;
  }

  .min-h-lg-375px {
    min-height: 375px !important;
  }

  .min-h-lg-400px {
    min-height: 400px !important;
  }

  .min-h-lg-425px {
    min-height: 425px !important;
  }

  .min-h-lg-450px {
    min-height: 450px !important;
  }

  .min-h-lg-475px {
    min-height: 475px !important;
  }

  .min-h-lg-500px {
    min-height: 500px !important;
  }

  .min-h-lg-550px {
    min-height: 550px !important;
  }

  .min-h-lg-600px {
    min-height: 600px !important;
  }

  .min-h-lg-650px {
    min-height: 650px !important;
  }

  .min-h-lg-700px {
    min-height: 700px !important;
  }

  .min-h-lg-750px {
    min-height: 750px !important;
  }

  .min-h-lg-800px {
    min-height: 800px !important;
  }

  .min-h-lg-850px {
    min-height: 850px !important;
  }

  .min-h-lg-900px {
    min-height: 900px !important;
  }

  .min-h-lg-950px {
    min-height: 950px !important;
  }

  .min-h-lg-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }

  .float-xl-end {
    float: right !important;
  }

  .float-xl-none {
    float: none !important;
  }

  .d-xl-inline {
    display: inline !important;
  }

  .d-xl-inline-block {
    display: inline-block !important;
  }

  .d-xl-block {
    display: block !important;
  }

  .d-xl-grid {
    display: grid !important;
  }

  .d-xl-table {
    display: table !important;
  }

  .d-xl-table-row {
    display: table-row !important;
  }

  .d-xl-table-cell {
    display: table-cell !important;
  }

  .d-xl-flex {
    display: flex !important;
  }

  .d-xl-inline-flex {
    display: inline-flex !important;
  }

  .d-xl-none {
    display: none !important;
  }

  .position-xl-static {
    position: static !important;
  }

  .position-xl-relative {
    position: relative !important;
  }

  .position-xl-absolute {
    position: absolute !important;
  }

  .position-xl-fixed {
    position: fixed !important;
  }

  .position-xl-sticky {
    position: sticky !important;
  }

  .w-xl-unset {
    width: unset !important;
  }

  .w-xl-25 {
    width: 25% !important;
  }

  .w-xl-50 {
    width: 50% !important;
  }

  .w-xl-75 {
    width: 75% !important;
  }

  .w-xl-100 {
    width: 100% !important;
  }

  .w-xl-auto {
    width: auto !important;
  }

  .w-xl-1px {
    width: 1px !important;
  }

  .w-xl-2px {
    width: 2px !important;
  }

  .w-xl-3px {
    width: 3px !important;
  }

  .w-xl-4px {
    width: 4px !important;
  }

  .w-xl-5px {
    width: 5px !important;
  }

  .w-xl-6px {
    width: 6px !important;
  }

  .w-xl-7px {
    width: 7px !important;
  }

  .w-xl-8px {
    width: 8px !important;
  }

  .w-xl-9px {
    width: 9px !important;
  }

  .w-xl-10px {
    width: 10px !important;
  }

  .w-xl-15px {
    width: 15px !important;
  }

  .w-xl-20px {
    width: 20px !important;
  }

  .w-xl-25px {
    width: 25px !important;
  }

  .w-xl-30px {
    width: 30px !important;
  }

  .w-xl-35px {
    width: 35px !important;
  }

  .w-xl-40px {
    width: 40px !important;
  }

  .w-xl-45px {
    width: 45px !important;
  }

  .w-xl-50px {
    width: 50px !important;
  }

  .w-xl-55px {
    width: 55px !important;
  }

  .w-xl-60px {
    width: 60px !important;
  }

  .w-xl-65px {
    width: 65px !important;
  }

  .w-xl-70px {
    width: 70px !important;
  }

  .w-xl-75px {
    width: 75px !important;
  }

  .w-xl-80px {
    width: 80px !important;
  }

  .w-xl-85px {
    width: 85px !important;
  }

  .w-xl-90px {
    width: 90px !important;
  }

  .w-xl-95px {
    width: 95px !important;
  }

  .w-xl-100px {
    width: 100px !important;
  }

  .w-xl-125px {
    width: 125px !important;
  }

  .w-xl-150px {
    width: 150px !important;
  }

  .w-xl-175px {
    width: 175px !important;
  }

  .w-xl-200px {
    width: 200px !important;
  }

  .w-xl-225px {
    width: 225px !important;
  }

  .w-xl-250px {
    width: 250px !important;
  }

  .w-xl-275px {
    width: 275px !important;
  }

  .w-xl-300px {
    width: 300px !important;
  }

  .w-xl-325px {
    width: 325px !important;
  }

  .w-xl-350px {
    width: 350px !important;
  }

  .w-xl-375px {
    width: 375px !important;
  }

  .w-xl-400px {
    width: 400px !important;
  }

  .w-xl-425px {
    width: 425px !important;
  }

  .w-xl-450px {
    width: 450px !important;
  }

  .w-xl-475px {
    width: 475px !important;
  }

  .w-xl-500px {
    width: 500px !important;
  }

  .w-xl-550px {
    width: 550px !important;
  }

  .w-xl-600px {
    width: 600px !important;
  }

  .w-xl-650px {
    width: 650px !important;
  }

  .w-xl-700px {
    width: 700px !important;
  }

  .w-xl-750px {
    width: 750px !important;
  }

  .w-xl-800px {
    width: 800px !important;
  }

  .w-xl-850px {
    width: 850px !important;
  }

  .w-xl-900px {
    width: 900px !important;
  }

  .w-xl-950px {
    width: 950px !important;
  }

  .w-xl-1000px {
    width: 1000px !important;
  }

  .mw-xl-unset {
    max-width: unset !important;
  }

  .mw-xl-25 {
    max-width: 25% !important;
  }

  .mw-xl-50 {
    max-width: 50% !important;
  }

  .mw-xl-75 {
    max-width: 75% !important;
  }

  .mw-xl-100 {
    max-width: 100% !important;
  }

  .mw-xl-auto {
    max-width: auto !important;
  }

  .mw-xl-1px {
    max-width: 1px !important;
  }

  .mw-xl-2px {
    max-width: 2px !important;
  }

  .mw-xl-3px {
    max-width: 3px !important;
  }

  .mw-xl-4px {
    max-width: 4px !important;
  }

  .mw-xl-5px {
    max-width: 5px !important;
  }

  .mw-xl-6px {
    max-width: 6px !important;
  }

  .mw-xl-7px {
    max-width: 7px !important;
  }

  .mw-xl-8px {
    max-width: 8px !important;
  }

  .mw-xl-9px {
    max-width: 9px !important;
  }

  .mw-xl-10px {
    max-width: 10px !important;
  }

  .mw-xl-15px {
    max-width: 15px !important;
  }

  .mw-xl-20px {
    max-width: 20px !important;
  }

  .mw-xl-25px {
    max-width: 25px !important;
  }

  .mw-xl-30px {
    max-width: 30px !important;
  }

  .mw-xl-35px {
    max-width: 35px !important;
  }

  .mw-xl-40px {
    max-width: 40px !important;
  }

  .mw-xl-45px {
    max-width: 45px !important;
  }

  .mw-xl-50px {
    max-width: 50px !important;
  }

  .mw-xl-55px {
    max-width: 55px !important;
  }

  .mw-xl-60px {
    max-width: 60px !important;
  }

  .mw-xl-65px {
    max-width: 65px !important;
  }

  .mw-xl-70px {
    max-width: 70px !important;
  }

  .mw-xl-75px {
    max-width: 75px !important;
  }

  .mw-xl-80px {
    max-width: 80px !important;
  }

  .mw-xl-85px {
    max-width: 85px !important;
  }

  .mw-xl-90px {
    max-width: 90px !important;
  }

  .mw-xl-95px {
    max-width: 95px !important;
  }

  .mw-xl-100px {
    max-width: 100px !important;
  }

  .mw-xl-125px {
    max-width: 125px !important;
  }

  .mw-xl-150px {
    max-width: 150px !important;
  }

  .mw-xl-175px {
    max-width: 175px !important;
  }

  .mw-xl-200px {
    max-width: 200px !important;
  }

  .mw-xl-225px {
    max-width: 225px !important;
  }

  .mw-xl-250px {
    max-width: 250px !important;
  }

  .mw-xl-275px {
    max-width: 275px !important;
  }

  .mw-xl-300px {
    max-width: 300px !important;
  }

  .mw-xl-325px {
    max-width: 325px !important;
  }

  .mw-xl-350px {
    max-width: 350px !important;
  }

  .mw-xl-375px {
    max-width: 375px !important;
  }

  .mw-xl-400px {
    max-width: 400px !important;
  }

  .mw-xl-425px {
    max-width: 425px !important;
  }

  .mw-xl-450px {
    max-width: 450px !important;
  }

  .mw-xl-475px {
    max-width: 475px !important;
  }

  .mw-xl-500px {
    max-width: 500px !important;
  }

  .mw-xl-550px {
    max-width: 550px !important;
  }

  .mw-xl-600px {
    max-width: 600px !important;
  }

  .mw-xl-650px {
    max-width: 650px !important;
  }

  .mw-xl-700px {
    max-width: 700px !important;
  }

  .mw-xl-750px {
    max-width: 750px !important;
  }

  .mw-xl-800px {
    max-width: 800px !important;
  }

  .mw-xl-850px {
    max-width: 850px !important;
  }

  .mw-xl-900px {
    max-width: 900px !important;
  }

  .mw-xl-950px {
    max-width: 950px !important;
  }

  .mw-xl-1000px {
    max-width: 1000px !important;
  }

  .h-xl-unset {
    height: unset !important;
  }

  .h-xl-25 {
    height: 25% !important;
  }

  .h-xl-50 {
    height: 50% !important;
  }

  .h-xl-75 {
    height: 75% !important;
  }

  .h-xl-100 {
    height: 100% !important;
  }

  .h-xl-auto {
    height: auto !important;
  }

  .h-xl-1px {
    height: 1px !important;
  }

  .h-xl-2px {
    height: 2px !important;
  }

  .h-xl-3px {
    height: 3px !important;
  }

  .h-xl-4px {
    height: 4px !important;
  }

  .h-xl-5px {
    height: 5px !important;
  }

  .h-xl-6px {
    height: 6px !important;
  }

  .h-xl-7px {
    height: 7px !important;
  }

  .h-xl-8px {
    height: 8px !important;
  }

  .h-xl-9px {
    height: 9px !important;
  }

  .h-xl-10px {
    height: 10px !important;
  }

  .h-xl-15px {
    height: 15px !important;
  }

  .h-xl-20px {
    height: 20px !important;
  }

  .h-xl-25px {
    height: 25px !important;
  }

  .h-xl-30px {
    height: 30px !important;
  }

  .h-xl-35px {
    height: 35px !important;
  }

  .h-xl-40px {
    height: 40px !important;
  }

  .h-xl-45px {
    height: 45px !important;
  }

  .h-xl-50px {
    height: 50px !important;
  }

  .h-xl-55px {
    height: 55px !important;
  }

  .h-xl-60px {
    height: 60px !important;
  }

  .h-xl-65px {
    height: 65px !important;
  }

  .h-xl-70px {
    height: 70px !important;
  }

  .h-xl-75px {
    height: 75px !important;
  }

  .h-xl-80px {
    height: 80px !important;
  }

  .h-xl-85px {
    height: 85px !important;
  }

  .h-xl-90px {
    height: 90px !important;
  }

  .h-xl-95px {
    height: 95px !important;
  }

  .h-xl-100px {
    height: 100px !important;
  }

  .h-xl-125px {
    height: 125px !important;
  }

  .h-xl-150px {
    height: 150px !important;
  }

  .h-xl-175px {
    height: 175px !important;
  }

  .h-xl-200px {
    height: 200px !important;
  }

  .h-xl-225px {
    height: 225px !important;
  }

  .h-xl-250px {
    height: 250px !important;
  }

  .h-xl-275px {
    height: 275px !important;
  }

  .h-xl-300px {
    height: 300px !important;
  }

  .h-xl-325px {
    height: 325px !important;
  }

  .h-xl-350px {
    height: 350px !important;
  }

  .h-xl-375px {
    height: 375px !important;
  }

  .h-xl-400px {
    height: 400px !important;
  }

  .h-xl-425px {
    height: 425px !important;
  }

  .h-xl-450px {
    height: 450px !important;
  }

  .h-xl-475px {
    height: 475px !important;
  }

  .h-xl-500px {
    height: 500px !important;
  }

  .h-xl-550px {
    height: 550px !important;
  }

  .h-xl-600px {
    height: 600px !important;
  }

  .h-xl-650px {
    height: 650px !important;
  }

  .h-xl-700px {
    height: 700px !important;
  }

  .h-xl-750px {
    height: 750px !important;
  }

  .h-xl-800px {
    height: 800px !important;
  }

  .h-xl-850px {
    height: 850px !important;
  }

  .h-xl-900px {
    height: 900px !important;
  }

  .h-xl-950px {
    height: 950px !important;
  }

  .h-xl-1000px {
    height: 1000px !important;
  }

  .mh-xl-unset {
    max-height: unset !important;
  }

  .mh-xl-25 {
    max-height: 25% !important;
  }

  .mh-xl-50 {
    max-height: 50% !important;
  }

  .mh-xl-75 {
    max-height: 75% !important;
  }

  .mh-xl-100 {
    max-height: 100% !important;
  }

  .mh-xl-auto {
    max-height: auto !important;
  }

  .mh-xl-1px {
    max-height: 1px !important;
  }

  .mh-xl-2px {
    max-height: 2px !important;
  }

  .mh-xl-3px {
    max-height: 3px !important;
  }

  .mh-xl-4px {
    max-height: 4px !important;
  }

  .mh-xl-5px {
    max-height: 5px !important;
  }

  .mh-xl-6px {
    max-height: 6px !important;
  }

  .mh-xl-7px {
    max-height: 7px !important;
  }

  .mh-xl-8px {
    max-height: 8px !important;
  }

  .mh-xl-9px {
    max-height: 9px !important;
  }

  .mh-xl-10px {
    max-height: 10px !important;
  }

  .mh-xl-15px {
    max-height: 15px !important;
  }

  .mh-xl-20px {
    max-height: 20px !important;
  }

  .mh-xl-25px {
    max-height: 25px !important;
  }

  .mh-xl-30px {
    max-height: 30px !important;
  }

  .mh-xl-35px {
    max-height: 35px !important;
  }

  .mh-xl-40px {
    max-height: 40px !important;
  }

  .mh-xl-45px {
    max-height: 45px !important;
  }

  .mh-xl-50px {
    max-height: 50px !important;
  }

  .mh-xl-55px {
    max-height: 55px !important;
  }

  .mh-xl-60px {
    max-height: 60px !important;
  }

  .mh-xl-65px {
    max-height: 65px !important;
  }

  .mh-xl-70px {
    max-height: 70px !important;
  }

  .mh-xl-75px {
    max-height: 75px !important;
  }

  .mh-xl-80px {
    max-height: 80px !important;
  }

  .mh-xl-85px {
    max-height: 85px !important;
  }

  .mh-xl-90px {
    max-height: 90px !important;
  }

  .mh-xl-95px {
    max-height: 95px !important;
  }

  .mh-xl-100px {
    max-height: 100px !important;
  }

  .mh-xl-125px {
    max-height: 125px !important;
  }

  .mh-xl-150px {
    max-height: 150px !important;
  }

  .mh-xl-175px {
    max-height: 175px !important;
  }

  .mh-xl-200px {
    max-height: 200px !important;
  }

  .mh-xl-225px {
    max-height: 225px !important;
  }

  .mh-xl-250px {
    max-height: 250px !important;
  }

  .mh-xl-275px {
    max-height: 275px !important;
  }

  .mh-xl-300px {
    max-height: 300px !important;
  }

  .mh-xl-325px {
    max-height: 325px !important;
  }

  .mh-xl-350px {
    max-height: 350px !important;
  }

  .mh-xl-375px {
    max-height: 375px !important;
  }

  .mh-xl-400px {
    max-height: 400px !important;
  }

  .mh-xl-425px {
    max-height: 425px !important;
  }

  .mh-xl-450px {
    max-height: 450px !important;
  }

  .mh-xl-475px {
    max-height: 475px !important;
  }

  .mh-xl-500px {
    max-height: 500px !important;
  }

  .mh-xl-550px {
    max-height: 550px !important;
  }

  .mh-xl-600px {
    max-height: 600px !important;
  }

  .mh-xl-650px {
    max-height: 650px !important;
  }

  .mh-xl-700px {
    max-height: 700px !important;
  }

  .mh-xl-750px {
    max-height: 750px !important;
  }

  .mh-xl-800px {
    max-height: 800px !important;
  }

  .mh-xl-850px {
    max-height: 850px !important;
  }

  .mh-xl-900px {
    max-height: 900px !important;
  }

  .mh-xl-950px {
    max-height: 950px !important;
  }

  .mh-xl-1000px {
    max-height: 1000px !important;
  }

  .flex-xl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xl-row {
    flex-direction: row !important;
  }

  .flex-xl-column {
    flex-direction: column !important;
  }

  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-xl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xl-center {
    justify-content: center !important;
  }

  .justify-content-xl-between {
    justify-content: space-between !important;
  }

  .justify-content-xl-around {
    justify-content: space-around !important;
  }

  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xl-start {
    align-items: flex-start !important;
  }

  .align-items-xl-end {
    align-items: flex-end !important;
  }

  .align-items-xl-center {
    align-items: center !important;
  }

  .align-items-xl-baseline {
    align-items: baseline !important;
  }

  .align-items-xl-stretch {
    align-items: stretch !important;
  }

  .align-content-xl-start {
    align-content: flex-start !important;
  }

  .align-content-xl-end {
    align-content: flex-end !important;
  }

  .align-content-xl-center {
    align-content: center !important;
  }

  .align-content-xl-between {
    align-content: space-between !important;
  }

  .align-content-xl-around {
    align-content: space-around !important;
  }

  .align-content-xl-stretch {
    align-content: stretch !important;
  }

  .align-self-xl-auto {
    align-self: auto !important;
  }

  .align-self-xl-start {
    align-self: flex-start !important;
  }

  .align-self-xl-end {
    align-self: flex-end !important;
  }

  .align-self-xl-center {
    align-self: center !important;
  }

  .align-self-xl-baseline {
    align-self: baseline !important;
  }

  .align-self-xl-stretch {
    align-self: stretch !important;
  }

  .order-xl-first {
    order: -1 !important;
  }

  .order-xl-0 {
    order: 0 !important;
  }

  .order-xl-1 {
    order: 1 !important;
  }

  .order-xl-2 {
    order: 2 !important;
  }

  .order-xl-3 {
    order: 3 !important;
  }

  .order-xl-4 {
    order: 4 !important;
  }

  .order-xl-5 {
    order: 5 !important;
  }

  .order-xl-last {
    order: 6 !important;
  }

  .m-xl-0 {
    margin: 0 !important;
  }

  .m-xl-1 {
    margin: 0.25rem !important;
  }

  .m-xl-2 {
    margin: 0.5rem !important;
  }

  .m-xl-3 {
    margin: 0.75rem !important;
  }

  .m-xl-4 {
    margin: 1rem !important;
  }

  .m-xl-5 {
    margin: 1.25rem !important;
  }

  .m-xl-6 {
    margin: 1.5rem !important;
  }

  .m-xl-7 {
    margin: 1.75rem !important;
  }

  .m-xl-8 {
    margin: 2rem !important;
  }

  .m-xl-9 {
    margin: 2.25rem !important;
  }

  .m-xl-10 {
    margin: 2.5rem !important;
  }

  .m-xl-11 {
    margin: 2.75rem !important;
  }

  .m-xl-12 {
    margin: 3rem !important;
  }

  .m-xl-13 {
    margin: 3.25rem !important;
  }

  .m-xl-14 {
    margin: 3.5rem !important;
  }

  .m-xl-15 {
    margin: 3.75rem !important;
  }

  .m-xl-16 {
    margin: 4rem !important;
  }

  .m-xl-17 {
    margin: 4.25rem !important;
  }

  .m-xl-18 {
    margin: 4.5rem !important;
  }

  .m-xl-19 {
    margin: 4.75rem !important;
  }

  .m-xl-20 {
    margin: 5rem !important;
  }

  .m-xl-auto {
    margin: auto !important;
  }

  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-xl-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-xl-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-xl-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-xl-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-xl-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-xl-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-xl-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-xl-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-xl-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-xl-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-xl-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-xl-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-xl-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-xl-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-xl-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-xl-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-xl-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-xl-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xl-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-xl-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xl-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-xl-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xl-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-xl-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-xl-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-xl-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-xl-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-xl-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xl-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-xl-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-xl-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-xl-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-xl-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-xl-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-xl-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-xl-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xl-0 {
    margin-top: 0 !important;
  }

  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xl-3 {
    margin-top: 0.75rem !important;
  }

  .mt-xl-4 {
    margin-top: 1rem !important;
  }

  .mt-xl-5 {
    margin-top: 1.25rem !important;
  }

  .mt-xl-6 {
    margin-top: 1.5rem !important;
  }

  .mt-xl-7 {
    margin-top: 1.75rem !important;
  }

  .mt-xl-8 {
    margin-top: 2rem !important;
  }

  .mt-xl-9 {
    margin-top: 2.25rem !important;
  }

  .mt-xl-10 {
    margin-top: 2.5rem !important;
  }

  .mt-xl-11 {
    margin-top: 2.75rem !important;
  }

  .mt-xl-12 {
    margin-top: 3rem !important;
  }

  .mt-xl-13 {
    margin-top: 3.25rem !important;
  }

  .mt-xl-14 {
    margin-top: 3.5rem !important;
  }

  .mt-xl-15 {
    margin-top: 3.75rem !important;
  }

  .mt-xl-16 {
    margin-top: 4rem !important;
  }

  .mt-xl-17 {
    margin-top: 4.25rem !important;
  }

  .mt-xl-18 {
    margin-top: 4.5rem !important;
  }

  .mt-xl-19 {
    margin-top: 4.75rem !important;
  }

  .mt-xl-20 {
    margin-top: 5rem !important;
  }

  .mt-xl-auto {
    margin-top: auto !important;
  }

  .me-xl-0 {
    margin-right: 0 !important;
  }

  .me-xl-1 {
    margin-right: 0.25rem !important;
  }

  .me-xl-2 {
    margin-right: 0.5rem !important;
  }

  .me-xl-3 {
    margin-right: 0.75rem !important;
  }

  .me-xl-4 {
    margin-right: 1rem !important;
  }

  .me-xl-5 {
    margin-right: 1.25rem !important;
  }

  .me-xl-6 {
    margin-right: 1.5rem !important;
  }

  .me-xl-7 {
    margin-right: 1.75rem !important;
  }

  .me-xl-8 {
    margin-right: 2rem !important;
  }

  .me-xl-9 {
    margin-right: 2.25rem !important;
  }

  .me-xl-10 {
    margin-right: 2.5rem !important;
  }

  .me-xl-11 {
    margin-right: 2.75rem !important;
  }

  .me-xl-12 {
    margin-right: 3rem !important;
  }

  .me-xl-13 {
    margin-right: 3.25rem !important;
  }

  .me-xl-14 {
    margin-right: 3.5rem !important;
  }

  .me-xl-15 {
    margin-right: 3.75rem !important;
  }

  .me-xl-16 {
    margin-right: 4rem !important;
  }

  .me-xl-17 {
    margin-right: 4.25rem !important;
  }

  .me-xl-18 {
    margin-right: 4.5rem !important;
  }

  .me-xl-19 {
    margin-right: 4.75rem !important;
  }

  .me-xl-20 {
    margin-right: 5rem !important;
  }

  .me-xl-auto {
    margin-right: auto !important;
  }

  .mb-xl-0 {
    margin-bottom: 0 !important;
  }

  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xl-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-xl-4 {
    margin-bottom: 1rem !important;
  }

  .mb-xl-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-xl-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xl-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-xl-8 {
    margin-bottom: 2rem !important;
  }

  .mb-xl-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-xl-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-xl-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-xl-12 {
    margin-bottom: 3rem !important;
  }

  .mb-xl-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-xl-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-xl-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-xl-16 {
    margin-bottom: 4rem !important;
  }

  .mb-xl-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-xl-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-xl-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-xl-20 {
    margin-bottom: 5rem !important;
  }

  .mb-xl-auto {
    margin-bottom: auto !important;
  }

  .ms-xl-0 {
    margin-left: 0 !important;
  }

  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }

  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }

  .ms-xl-3 {
    margin-left: 0.75rem !important;
  }

  .ms-xl-4 {
    margin-left: 1rem !important;
  }

  .ms-xl-5 {
    margin-left: 1.25rem !important;
  }

  .ms-xl-6 {
    margin-left: 1.5rem !important;
  }

  .ms-xl-7 {
    margin-left: 1.75rem !important;
  }

  .ms-xl-8 {
    margin-left: 2rem !important;
  }

  .ms-xl-9 {
    margin-left: 2.25rem !important;
  }

  .ms-xl-10 {
    margin-left: 2.5rem !important;
  }

  .ms-xl-11 {
    margin-left: 2.75rem !important;
  }

  .ms-xl-12 {
    margin-left: 3rem !important;
  }

  .ms-xl-13 {
    margin-left: 3.25rem !important;
  }

  .ms-xl-14 {
    margin-left: 3.5rem !important;
  }

  .ms-xl-15 {
    margin-left: 3.75rem !important;
  }

  .ms-xl-16 {
    margin-left: 4rem !important;
  }

  .ms-xl-17 {
    margin-left: 4.25rem !important;
  }

  .ms-xl-18 {
    margin-left: 4.5rem !important;
  }

  .ms-xl-19 {
    margin-left: 4.75rem !important;
  }

  .ms-xl-20 {
    margin-left: 5rem !important;
  }

  .ms-xl-auto {
    margin-left: auto !important;
  }

  .m-xl-n1 {
    margin: -0.25rem !important;
  }

  .m-xl-n2 {
    margin: -0.5rem !important;
  }

  .m-xl-n3 {
    margin: -0.75rem !important;
  }

  .m-xl-n4 {
    margin: -1rem !important;
  }

  .m-xl-n5 {
    margin: -1.25rem !important;
  }

  .m-xl-n6 {
    margin: -1.5rem !important;
  }

  .m-xl-n7 {
    margin: -1.75rem !important;
  }

  .m-xl-n8 {
    margin: -2rem !important;
  }

  .m-xl-n9 {
    margin: -2.25rem !important;
  }

  .m-xl-n10 {
    margin: -2.5rem !important;
  }

  .m-xl-n11 {
    margin: -2.75rem !important;
  }

  .m-xl-n12 {
    margin: -3rem !important;
  }

  .m-xl-n13 {
    margin: -3.25rem !important;
  }

  .m-xl-n14 {
    margin: -3.5rem !important;
  }

  .m-xl-n15 {
    margin: -3.75rem !important;
  }

  .m-xl-n16 {
    margin: -4rem !important;
  }

  .m-xl-n17 {
    margin: -4.25rem !important;
  }

  .m-xl-n18 {
    margin: -4.5rem !important;
  }

  .m-xl-n19 {
    margin: -4.75rem !important;
  }

  .m-xl-n20 {
    margin: -5rem !important;
  }

  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-xl-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-xl-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-xl-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-xl-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-xl-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-xl-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-xl-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-xl-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-xl-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-xl-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-xl-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-xl-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-xl-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-xl-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-xl-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-xl-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-xl-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-xl-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-xl-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-xl-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-xl-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-xl-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-xl-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-xl-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-xl-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-xl-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-xl-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-xl-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-xl-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-xl-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-xl-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-xl-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-xl-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-xl-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-xl-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-xl-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-xl-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-xl-n4 {
    margin-top: -1rem !important;
  }

  .mt-xl-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-xl-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-xl-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-xl-n8 {
    margin-top: -2rem !important;
  }

  .mt-xl-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-xl-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-xl-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-xl-n12 {
    margin-top: -3rem !important;
  }

  .mt-xl-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-xl-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-xl-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-xl-n16 {
    margin-top: -4rem !important;
  }

  .mt-xl-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-xl-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-xl-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-xl-n20 {
    margin-top: -5rem !important;
  }

  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }

  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }

  .me-xl-n3 {
    margin-right: -0.75rem !important;
  }

  .me-xl-n4 {
    margin-right: -1rem !important;
  }

  .me-xl-n5 {
    margin-right: -1.25rem !important;
  }

  .me-xl-n6 {
    margin-right: -1.5rem !important;
  }

  .me-xl-n7 {
    margin-right: -1.75rem !important;
  }

  .me-xl-n8 {
    margin-right: -2rem !important;
  }

  .me-xl-n9 {
    margin-right: -2.25rem !important;
  }

  .me-xl-n10 {
    margin-right: -2.5rem !important;
  }

  .me-xl-n11 {
    margin-right: -2.75rem !important;
  }

  .me-xl-n12 {
    margin-right: -3rem !important;
  }

  .me-xl-n13 {
    margin-right: -3.25rem !important;
  }

  .me-xl-n14 {
    margin-right: -3.5rem !important;
  }

  .me-xl-n15 {
    margin-right: -3.75rem !important;
  }

  .me-xl-n16 {
    margin-right: -4rem !important;
  }

  .me-xl-n17 {
    margin-right: -4.25rem !important;
  }

  .me-xl-n18 {
    margin-right: -4.5rem !important;
  }

  .me-xl-n19 {
    margin-right: -4.75rem !important;
  }

  .me-xl-n20 {
    margin-right: -5rem !important;
  }

  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-xl-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-xl-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-xl-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-xl-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-xl-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-xl-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-xl-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-xl-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-xl-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-xl-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-xl-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-xl-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-xl-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-xl-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-xl-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-xl-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-xl-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-xl-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-xl-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-xl-n4 {
    margin-left: -1rem !important;
  }

  .ms-xl-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-xl-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-xl-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-xl-n8 {
    margin-left: -2rem !important;
  }

  .ms-xl-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-xl-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-xl-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-xl-n12 {
    margin-left: -3rem !important;
  }

  .ms-xl-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-xl-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-xl-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-xl-n16 {
    margin-left: -4rem !important;
  }

  .ms-xl-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-xl-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-xl-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-xl-n20 {
    margin-left: -5rem !important;
  }

  .p-xl-0 {
    padding: 0 !important;
  }

  .p-xl-1 {
    padding: 0.25rem !important;
  }

  .p-xl-2 {
    padding: 0.5rem !important;
  }

  .p-xl-3 {
    padding: 0.75rem !important;
  }

  .p-xl-4 {
    padding: 1rem !important;
  }

  .p-xl-5 {
    padding: 1.25rem !important;
  }

  .p-xl-6 {
    padding: 1.5rem !important;
  }

  .p-xl-7 {
    padding: 1.75rem !important;
  }

  .p-xl-8 {
    padding: 2rem !important;
  }

  .p-xl-9 {
    padding: 2.25rem !important;
  }

  .p-xl-10 {
    padding: 2.5rem !important;
  }

  .p-xl-11 {
    padding: 2.75rem !important;
  }

  .p-xl-12 {
    padding: 3rem !important;
  }

  .p-xl-13 {
    padding: 3.25rem !important;
  }

  .p-xl-14 {
    padding: 3.5rem !important;
  }

  .p-xl-15 {
    padding: 3.75rem !important;
  }

  .p-xl-16 {
    padding: 4rem !important;
  }

  .p-xl-17 {
    padding: 4.25rem !important;
  }

  .p-xl-18 {
    padding: 4.5rem !important;
  }

  .p-xl-19 {
    padding: 4.75rem !important;
  }

  .p-xl-20 {
    padding: 5rem !important;
  }

  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-xl-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-xl-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-xl-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-xl-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-xl-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-xl-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-xl-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-xl-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-xl-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-xl-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-xl-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-xl-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-xl-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-xl-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-xl-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-xl-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-xl-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-xl-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xl-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-xl-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xl-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-xl-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xl-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-xl-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-xl-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-xl-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-xl-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-xl-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-xl-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-xl-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-xl-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-xl-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-xl-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-xl-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-xl-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-xl-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-xl-0 {
    padding-top: 0 !important;
  }

  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xl-3 {
    padding-top: 0.75rem !important;
  }

  .pt-xl-4 {
    padding-top: 1rem !important;
  }

  .pt-xl-5 {
    padding-top: 1.25rem !important;
  }

  .pt-xl-6 {
    padding-top: 1.5rem !important;
  }

  .pt-xl-7 {
    padding-top: 1.75rem !important;
  }

  .pt-xl-8 {
    padding-top: 2rem !important;
  }

  .pt-xl-9 {
    padding-top: 2.25rem !important;
  }

  .pt-xl-10 {
    padding-top: 2.5rem !important;
  }

  .pt-xl-11 {
    padding-top: 2.75rem !important;
  }

  .pt-xl-12 {
    padding-top: 3rem !important;
  }

  .pt-xl-13 {
    padding-top: 3.25rem !important;
  }

  .pt-xl-14 {
    padding-top: 3.5rem !important;
  }

  .pt-xl-15 {
    padding-top: 3.75rem !important;
  }

  .pt-xl-16 {
    padding-top: 4rem !important;
  }

  .pt-xl-17 {
    padding-top: 4.25rem !important;
  }

  .pt-xl-18 {
    padding-top: 4.5rem !important;
  }

  .pt-xl-19 {
    padding-top: 4.75rem !important;
  }

  .pt-xl-20 {
    padding-top: 5rem !important;
  }

  .pe-xl-0 {
    padding-right: 0 !important;
  }

  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }

  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }

  .pe-xl-3 {
    padding-right: 0.75rem !important;
  }

  .pe-xl-4 {
    padding-right: 1rem !important;
  }

  .pe-xl-5 {
    padding-right: 1.25rem !important;
  }

  .pe-xl-6 {
    padding-right: 1.5rem !important;
  }

  .pe-xl-7 {
    padding-right: 1.75rem !important;
  }

  .pe-xl-8 {
    padding-right: 2rem !important;
  }

  .pe-xl-9 {
    padding-right: 2.25rem !important;
  }

  .pe-xl-10 {
    padding-right: 2.5rem !important;
  }

  .pe-xl-11 {
    padding-right: 2.75rem !important;
  }

  .pe-xl-12 {
    padding-right: 3rem !important;
  }

  .pe-xl-13 {
    padding-right: 3.25rem !important;
  }

  .pe-xl-14 {
    padding-right: 3.5rem !important;
  }

  .pe-xl-15 {
    padding-right: 3.75rem !important;
  }

  .pe-xl-16 {
    padding-right: 4rem !important;
  }

  .pe-xl-17 {
    padding-right: 4.25rem !important;
  }

  .pe-xl-18 {
    padding-right: 4.5rem !important;
  }

  .pe-xl-19 {
    padding-right: 4.75rem !important;
  }

  .pe-xl-20 {
    padding-right: 5rem !important;
  }

  .pb-xl-0 {
    padding-bottom: 0 !important;
  }

  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xl-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-xl-4 {
    padding-bottom: 1rem !important;
  }

  .pb-xl-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-xl-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xl-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-xl-8 {
    padding-bottom: 2rem !important;
  }

  .pb-xl-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-xl-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-xl-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-xl-12 {
    padding-bottom: 3rem !important;
  }

  .pb-xl-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-xl-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-xl-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-xl-16 {
    padding-bottom: 4rem !important;
  }

  .pb-xl-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-xl-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-xl-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-xl-20 {
    padding-bottom: 5rem !important;
  }

  .ps-xl-0 {
    padding-left: 0 !important;
  }

  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }

  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }

  .ps-xl-3 {
    padding-left: 0.75rem !important;
  }

  .ps-xl-4 {
    padding-left: 1rem !important;
  }

  .ps-xl-5 {
    padding-left: 1.25rem !important;
  }

  .ps-xl-6 {
    padding-left: 1.5rem !important;
  }

  .ps-xl-7 {
    padding-left: 1.75rem !important;
  }

  .ps-xl-8 {
    padding-left: 2rem !important;
  }

  .ps-xl-9 {
    padding-left: 2.25rem !important;
  }

  .ps-xl-10 {
    padding-left: 2.5rem !important;
  }

  .ps-xl-11 {
    padding-left: 2.75rem !important;
  }

  .ps-xl-12 {
    padding-left: 3rem !important;
  }

  .ps-xl-13 {
    padding-left: 3.25rem !important;
  }

  .ps-xl-14 {
    padding-left: 3.5rem !important;
  }

  .ps-xl-15 {
    padding-left: 3.75rem !important;
  }

  .ps-xl-16 {
    padding-left: 4rem !important;
  }

  .ps-xl-17 {
    padding-left: 4.25rem !important;
  }

  .ps-xl-18 {
    padding-left: 4.5rem !important;
  }

  .ps-xl-19 {
    padding-left: 4.75rem !important;
  }

  .ps-xl-20 {
    padding-left: 5rem !important;
  }

  .gap-xl-0 {
    gap: 0 !important;
  }

  .gap-xl-1 {
    gap: 0.25rem !important;
  }

  .gap-xl-2 {
    gap: 0.5rem !important;
  }

  .gap-xl-3 {
    gap: 0.75rem !important;
  }

  .gap-xl-4 {
    gap: 1rem !important;
  }

  .gap-xl-5 {
    gap: 1.25rem !important;
  }

  .gap-xl-6 {
    gap: 1.5rem !important;
  }

  .gap-xl-7 {
    gap: 1.75rem !important;
  }

  .gap-xl-8 {
    gap: 2rem !important;
  }

  .gap-xl-9 {
    gap: 2.25rem !important;
  }

  .gap-xl-10 {
    gap: 2.5rem !important;
  }

  .gap-xl-11 {
    gap: 2.75rem !important;
  }

  .gap-xl-12 {
    gap: 3rem !important;
  }

  .gap-xl-13 {
    gap: 3.25rem !important;
  }

  .gap-xl-14 {
    gap: 3.5rem !important;
  }

  .gap-xl-15 {
    gap: 3.75rem !important;
  }

  .gap-xl-16 {
    gap: 4rem !important;
  }

  .gap-xl-17 {
    gap: 4.25rem !important;
  }

  .gap-xl-18 {
    gap: 4.5rem !important;
  }

  .gap-xl-19 {
    gap: 4.75rem !important;
  }

  .gap-xl-20 {
    gap: 5rem !important;
  }

  .fs-xl-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }

  .fs-xl-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }

  .fs-xl-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }

  .fs-xl-4 {
    font-size: 1.25rem !important;
  }

  .fs-xl-5 {
    font-size: 1.15rem !important;
  }

  .fs-xl-6 {
    font-size: 1.075rem !important;
  }

  .fs-xl-7 {
    font-size: 0.95rem !important;
  }

  .fs-xl-8 {
    font-size: 0.85rem !important;
  }

  .fs-xl-9 {
    font-size: 0.75rem !important;
  }

  .fs-xl-10 {
    font-size: 0.5rem !important;
  }

  .fs-xl-base {
    font-size: 1rem !important;
  }

  .fs-xl-fluid {
    font-size: 100% !important;
  }

  .fs-xl-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }

  .fs-xl-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }

  .fs-xl-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }

  .fs-xl-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }

  .fs-xl-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }

  .fs-xl-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }

  .fs-xl-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }

  .fs-xl-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }

  .fs-xl-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }

  .fs-xl-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }

  .fs-xl-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }

  .fs-xl-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }

  .fs-xl-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }

  .fs-xl-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }

  .fs-xl-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }

  .fs-xl-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }

  .text-xl-start {
    text-align: left !important;
  }

  .text-xl-end {
    text-align: right !important;
  }

  .text-xl-center {
    text-align: center !important;
  }

  .min-w-xl-unset {
    min-width: unset !important;
  }

  .min-w-xl-25 {
    min-width: 25% !important;
  }

  .min-w-xl-50 {
    min-width: 50% !important;
  }

  .min-w-xl-75 {
    min-width: 75% !important;
  }

  .min-w-xl-100 {
    min-width: 100% !important;
  }

  .min-w-xl-auto {
    min-width: auto !important;
  }

  .min-w-xl-1px {
    min-width: 1px !important;
  }

  .min-w-xl-2px {
    min-width: 2px !important;
  }

  .min-w-xl-3px {
    min-width: 3px !important;
  }

  .min-w-xl-4px {
    min-width: 4px !important;
  }

  .min-w-xl-5px {
    min-width: 5px !important;
  }

  .min-w-xl-6px {
    min-width: 6px !important;
  }

  .min-w-xl-7px {
    min-width: 7px !important;
  }

  .min-w-xl-8px {
    min-width: 8px !important;
  }

  .min-w-xl-9px {
    min-width: 9px !important;
  }

  .min-w-xl-10px {
    min-width: 10px !important;
  }

  .min-w-xl-15px {
    min-width: 15px !important;
  }

  .min-w-xl-20px {
    min-width: 20px !important;
  }

  .min-w-xl-25px {
    min-width: 25px !important;
  }

  .min-w-xl-30px {
    min-width: 30px !important;
  }

  .min-w-xl-35px {
    min-width: 35px !important;
  }

  .min-w-xl-40px {
    min-width: 40px !important;
  }

  .min-w-xl-45px {
    min-width: 45px !important;
  }

  .min-w-xl-50px {
    min-width: 50px !important;
  }

  .min-w-xl-55px {
    min-width: 55px !important;
  }

  .min-w-xl-60px {
    min-width: 60px !important;
  }

  .min-w-xl-65px {
    min-width: 65px !important;
  }

  .min-w-xl-70px {
    min-width: 70px !important;
  }

  .min-w-xl-75px {
    min-width: 75px !important;
  }

  .min-w-xl-80px {
    min-width: 80px !important;
  }

  .min-w-xl-85px {
    min-width: 85px !important;
  }

  .min-w-xl-90px {
    min-width: 90px !important;
  }

  .min-w-xl-95px {
    min-width: 95px !important;
  }

  .min-w-xl-100px {
    min-width: 100px !important;
  }

  .min-w-xl-125px {
    min-width: 125px !important;
  }

  .min-w-xl-150px {
    min-width: 150px !important;
  }

  .min-w-xl-175px {
    min-width: 175px !important;
  }

  .min-w-xl-200px {
    min-width: 200px !important;
  }

  .min-w-xl-225px {
    min-width: 225px !important;
  }

  .min-w-xl-250px {
    min-width: 250px !important;
  }

  .min-w-xl-275px {
    min-width: 275px !important;
  }

  .min-w-xl-300px {
    min-width: 300px !important;
  }

  .min-w-xl-325px {
    min-width: 325px !important;
  }

  .min-w-xl-350px {
    min-width: 350px !important;
  }

  .min-w-xl-375px {
    min-width: 375px !important;
  }

  .min-w-xl-400px {
    min-width: 400px !important;
  }

  .min-w-xl-425px {
    min-width: 425px !important;
  }

  .min-w-xl-450px {
    min-width: 450px !important;
  }

  .min-w-xl-475px {
    min-width: 475px !important;
  }

  .min-w-xl-500px {
    min-width: 500px !important;
  }

  .min-w-xl-550px {
    min-width: 550px !important;
  }

  .min-w-xl-600px {
    min-width: 600px !important;
  }

  .min-w-xl-650px {
    min-width: 650px !important;
  }

  .min-w-xl-700px {
    min-width: 700px !important;
  }

  .min-w-xl-750px {
    min-width: 750px !important;
  }

  .min-w-xl-800px {
    min-width: 800px !important;
  }

  .min-w-xl-850px {
    min-width: 850px !important;
  }

  .min-w-xl-900px {
    min-width: 900px !important;
  }

  .min-w-xl-950px {
    min-width: 950px !important;
  }

  .min-w-xl-1000px {
    min-width: 1000px !important;
  }

  .min-h-xl-unset {
    min-height: unset !important;
  }

  .min-h-xl-25 {
    min-height: 25% !important;
  }

  .min-h-xl-50 {
    min-height: 50% !important;
  }

  .min-h-xl-75 {
    min-height: 75% !important;
  }

  .min-h-xl-100 {
    min-height: 100% !important;
  }

  .min-h-xl-auto {
    min-height: auto !important;
  }

  .min-h-xl-1px {
    min-height: 1px !important;
  }

  .min-h-xl-2px {
    min-height: 2px !important;
  }

  .min-h-xl-3px {
    min-height: 3px !important;
  }

  .min-h-xl-4px {
    min-height: 4px !important;
  }

  .min-h-xl-5px {
    min-height: 5px !important;
  }

  .min-h-xl-6px {
    min-height: 6px !important;
  }

  .min-h-xl-7px {
    min-height: 7px !important;
  }

  .min-h-xl-8px {
    min-height: 8px !important;
  }

  .min-h-xl-9px {
    min-height: 9px !important;
  }

  .min-h-xl-10px {
    min-height: 10px !important;
  }

  .min-h-xl-15px {
    min-height: 15px !important;
  }

  .min-h-xl-20px {
    min-height: 20px !important;
  }

  .min-h-xl-25px {
    min-height: 25px !important;
  }

  .min-h-xl-30px {
    min-height: 30px !important;
  }

  .min-h-xl-35px {
    min-height: 35px !important;
  }

  .min-h-xl-40px {
    min-height: 40px !important;
  }

  .min-h-xl-45px {
    min-height: 45px !important;
  }

  .min-h-xl-50px {
    min-height: 50px !important;
  }

  .min-h-xl-55px {
    min-height: 55px !important;
  }

  .min-h-xl-60px {
    min-height: 60px !important;
  }

  .min-h-xl-65px {
    min-height: 65px !important;
  }

  .min-h-xl-70px {
    min-height: 70px !important;
  }

  .min-h-xl-75px {
    min-height: 75px !important;
  }

  .min-h-xl-80px {
    min-height: 80px !important;
  }

  .min-h-xl-85px {
    min-height: 85px !important;
  }

  .min-h-xl-90px {
    min-height: 90px !important;
  }

  .min-h-xl-95px {
    min-height: 95px !important;
  }

  .min-h-xl-100px {
    min-height: 100px !important;
  }

  .min-h-xl-125px {
    min-height: 125px !important;
  }

  .min-h-xl-150px {
    min-height: 150px !important;
  }

  .min-h-xl-175px {
    min-height: 175px !important;
  }

  .min-h-xl-200px {
    min-height: 200px !important;
  }

  .min-h-xl-225px {
    min-height: 225px !important;
  }

  .min-h-xl-250px {
    min-height: 250px !important;
  }

  .min-h-xl-275px {
    min-height: 275px !important;
  }

  .min-h-xl-300px {
    min-height: 300px !important;
  }

  .min-h-xl-325px {
    min-height: 325px !important;
  }

  .min-h-xl-350px {
    min-height: 350px !important;
  }

  .min-h-xl-375px {
    min-height: 375px !important;
  }

  .min-h-xl-400px {
    min-height: 400px !important;
  }

  .min-h-xl-425px {
    min-height: 425px !important;
  }

  .min-h-xl-450px {
    min-height: 450px !important;
  }

  .min-h-xl-475px {
    min-height: 475px !important;
  }

  .min-h-xl-500px {
    min-height: 500px !important;
  }

  .min-h-xl-550px {
    min-height: 550px !important;
  }

  .min-h-xl-600px {
    min-height: 600px !important;
  }

  .min-h-xl-650px {
    min-height: 650px !important;
  }

  .min-h-xl-700px {
    min-height: 700px !important;
  }

  .min-h-xl-750px {
    min-height: 750px !important;
  }

  .min-h-xl-800px {
    min-height: 800px !important;
  }

  .min-h-xl-850px {
    min-height: 850px !important;
  }

  .min-h-xl-900px {
    min-height: 900px !important;
  }

  .min-h-xl-950px {
    min-height: 950px !important;
  }

  .min-h-xl-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }

  .float-xxl-end {
    float: right !important;
  }

  .float-xxl-none {
    float: none !important;
  }

  .d-xxl-inline {
    display: inline !important;
  }

  .d-xxl-inline-block {
    display: inline-block !important;
  }

  .d-xxl-block {
    display: block !important;
  }

  .d-xxl-grid {
    display: grid !important;
  }

  .d-xxl-table {
    display: table !important;
  }

  .d-xxl-table-row {
    display: table-row !important;
  }

  .d-xxl-table-cell {
    display: table-cell !important;
  }

  .d-xxl-flex {
    display: flex !important;
  }

  .d-xxl-inline-flex {
    display: inline-flex !important;
  }

  .d-xxl-none {
    display: none !important;
  }

  .position-xxl-static {
    position: static !important;
  }

  .position-xxl-relative {
    position: relative !important;
  }

  .position-xxl-absolute {
    position: absolute !important;
  }

  .position-xxl-fixed {
    position: fixed !important;
  }

  .position-xxl-sticky {
    position: sticky !important;
  }

  .w-xxl-unset {
    width: unset !important;
  }

  .w-xxl-25 {
    width: 25% !important;
  }

  .w-xxl-50 {
    width: 50% !important;
  }

  .w-xxl-75 {
    width: 75% !important;
  }

  .w-xxl-100 {
    width: 100% !important;
  }

  .w-xxl-auto {
    width: auto !important;
  }

  .w-xxl-1px {
    width: 1px !important;
  }

  .w-xxl-2px {
    width: 2px !important;
  }

  .w-xxl-3px {
    width: 3px !important;
  }

  .w-xxl-4px {
    width: 4px !important;
  }

  .w-xxl-5px {
    width: 5px !important;
  }

  .w-xxl-6px {
    width: 6px !important;
  }

  .w-xxl-7px {
    width: 7px !important;
  }

  .w-xxl-8px {
    width: 8px !important;
  }

  .w-xxl-9px {
    width: 9px !important;
  }

  .w-xxl-10px {
    width: 10px !important;
  }

  .w-xxl-15px {
    width: 15px !important;
  }

  .w-xxl-20px {
    width: 20px !important;
  }

  .w-xxl-25px {
    width: 25px !important;
  }

  .w-xxl-30px {
    width: 30px !important;
  }

  .w-xxl-35px {
    width: 35px !important;
  }

  .w-xxl-40px {
    width: 40px !important;
  }

  .w-xxl-45px {
    width: 45px !important;
  }

  .w-xxl-50px {
    width: 50px !important;
  }

  .w-xxl-55px {
    width: 55px !important;
  }

  .w-xxl-60px {
    width: 60px !important;
  }

  .w-xxl-65px {
    width: 65px !important;
  }

  .w-xxl-70px {
    width: 70px !important;
  }

  .w-xxl-75px {
    width: 75px !important;
  }

  .w-xxl-80px {
    width: 80px !important;
  }

  .w-xxl-85px {
    width: 85px !important;
  }

  .w-xxl-90px {
    width: 90px !important;
  }

  .w-xxl-95px {
    width: 95px !important;
  }

  .w-xxl-100px {
    width: 100px !important;
  }

  .w-xxl-125px {
    width: 125px !important;
  }

  .w-xxl-150px {
    width: 150px !important;
  }

  .w-xxl-175px {
    width: 175px !important;
  }

  .w-xxl-200px {
    width: 200px !important;
  }

  .w-xxl-225px {
    width: 225px !important;
  }

  .w-xxl-250px {
    width: 250px !important;
  }

  .w-xxl-275px {
    width: 275px !important;
  }

  .w-xxl-300px {
    width: 300px !important;
  }

  .w-xxl-325px {
    width: 325px !important;
  }

  .w-xxl-350px {
    width: 350px !important;
  }

  .w-xxl-375px {
    width: 375px !important;
  }

  .w-xxl-400px {
    width: 400px !important;
  }

  .w-xxl-425px {
    width: 425px !important;
  }

  .w-xxl-450px {
    width: 450px !important;
  }

  .w-xxl-475px {
    width: 475px !important;
  }

  .w-xxl-500px {
    width: 500px !important;
  }

  .w-xxl-550px {
    width: 550px !important;
  }

  .w-xxl-600px {
    width: 600px !important;
  }

  .w-xxl-650px {
    width: 650px !important;
  }

  .w-xxl-700px {
    width: 700px !important;
  }

  .w-xxl-750px {
    width: 750px !important;
  }

  .w-xxl-800px {
    width: 800px !important;
  }

  .w-xxl-850px {
    width: 850px !important;
  }

  .w-xxl-900px {
    width: 900px !important;
  }

  .w-xxl-950px {
    width: 950px !important;
  }

  .w-xxl-1000px {
    width: 1000px !important;
  }

  .mw-xxl-unset {
    max-width: unset !important;
  }

  .mw-xxl-25 {
    max-width: 25% !important;
  }

  .mw-xxl-50 {
    max-width: 50% !important;
  }

  .mw-xxl-75 {
    max-width: 75% !important;
  }

  .mw-xxl-100 {
    max-width: 100% !important;
  }

  .mw-xxl-auto {
    max-width: auto !important;
  }

  .mw-xxl-1px {
    max-width: 1px !important;
  }

  .mw-xxl-2px {
    max-width: 2px !important;
  }

  .mw-xxl-3px {
    max-width: 3px !important;
  }

  .mw-xxl-4px {
    max-width: 4px !important;
  }

  .mw-xxl-5px {
    max-width: 5px !important;
  }

  .mw-xxl-6px {
    max-width: 6px !important;
  }

  .mw-xxl-7px {
    max-width: 7px !important;
  }

  .mw-xxl-8px {
    max-width: 8px !important;
  }

  .mw-xxl-9px {
    max-width: 9px !important;
  }

  .mw-xxl-10px {
    max-width: 10px !important;
  }

  .mw-xxl-15px {
    max-width: 15px !important;
  }

  .mw-xxl-20px {
    max-width: 20px !important;
  }

  .mw-xxl-25px {
    max-width: 25px !important;
  }

  .mw-xxl-30px {
    max-width: 30px !important;
  }

  .mw-xxl-35px {
    max-width: 35px !important;
  }

  .mw-xxl-40px {
    max-width: 40px !important;
  }

  .mw-xxl-45px {
    max-width: 45px !important;
  }

  .mw-xxl-50px {
    max-width: 50px !important;
  }

  .mw-xxl-55px {
    max-width: 55px !important;
  }

  .mw-xxl-60px {
    max-width: 60px !important;
  }

  .mw-xxl-65px {
    max-width: 65px !important;
  }

  .mw-xxl-70px {
    max-width: 70px !important;
  }

  .mw-xxl-75px {
    max-width: 75px !important;
  }

  .mw-xxl-80px {
    max-width: 80px !important;
  }

  .mw-xxl-85px {
    max-width: 85px !important;
  }

  .mw-xxl-90px {
    max-width: 90px !important;
  }

  .mw-xxl-95px {
    max-width: 95px !important;
  }

  .mw-xxl-100px {
    max-width: 100px !important;
  }

  .mw-xxl-125px {
    max-width: 125px !important;
  }

  .mw-xxl-150px {
    max-width: 150px !important;
  }

  .mw-xxl-175px {
    max-width: 175px !important;
  }

  .mw-xxl-200px {
    max-width: 200px !important;
  }

  .mw-xxl-225px {
    max-width: 225px !important;
  }

  .mw-xxl-250px {
    max-width: 250px !important;
  }

  .mw-xxl-275px {
    max-width: 275px !important;
  }

  .mw-xxl-300px {
    max-width: 300px !important;
  }

  .mw-xxl-325px {
    max-width: 325px !important;
  }

  .mw-xxl-350px {
    max-width: 350px !important;
  }

  .mw-xxl-375px {
    max-width: 375px !important;
  }

  .mw-xxl-400px {
    max-width: 400px !important;
  }

  .mw-xxl-425px {
    max-width: 425px !important;
  }

  .mw-xxl-450px {
    max-width: 450px !important;
  }

  .mw-xxl-475px {
    max-width: 475px !important;
  }

  .mw-xxl-500px {
    max-width: 500px !important;
  }

  .mw-xxl-550px {
    max-width: 550px !important;
  }

  .mw-xxl-600px {
    max-width: 600px !important;
  }

  .mw-xxl-650px {
    max-width: 650px !important;
  }

  .mw-xxl-700px {
    max-width: 700px !important;
  }

  .mw-xxl-750px {
    max-width: 750px !important;
  }

  .mw-xxl-800px {
    max-width: 800px !important;
  }

  .mw-xxl-850px {
    max-width: 850px !important;
  }

  .mw-xxl-900px {
    max-width: 900px !important;
  }

  .mw-xxl-950px {
    max-width: 950px !important;
  }

  .mw-xxl-1000px {
    max-width: 1000px !important;
  }

  .h-xxl-unset {
    height: unset !important;
  }

  .h-xxl-25 {
    height: 25% !important;
  }

  .h-xxl-50 {
    height: 50% !important;
  }

  .h-xxl-75 {
    height: 75% !important;
  }

  .h-xxl-100 {
    height: 100% !important;
  }

  .h-xxl-auto {
    height: auto !important;
  }

  .h-xxl-1px {
    height: 1px !important;
  }

  .h-xxl-2px {
    height: 2px !important;
  }

  .h-xxl-3px {
    height: 3px !important;
  }

  .h-xxl-4px {
    height: 4px !important;
  }

  .h-xxl-5px {
    height: 5px !important;
  }

  .h-xxl-6px {
    height: 6px !important;
  }

  .h-xxl-7px {
    height: 7px !important;
  }

  .h-xxl-8px {
    height: 8px !important;
  }

  .h-xxl-9px {
    height: 9px !important;
  }

  .h-xxl-10px {
    height: 10px !important;
  }

  .h-xxl-15px {
    height: 15px !important;
  }

  .h-xxl-20px {
    height: 20px !important;
  }

  .h-xxl-25px {
    height: 25px !important;
  }

  .h-xxl-30px {
    height: 30px !important;
  }

  .h-xxl-35px {
    height: 35px !important;
  }

  .h-xxl-40px {
    height: 40px !important;
  }

  .h-xxl-45px {
    height: 45px !important;
  }

  .h-xxl-50px {
    height: 50px !important;
  }

  .h-xxl-55px {
    height: 55px !important;
  }

  .h-xxl-60px {
    height: 60px !important;
  }

  .h-xxl-65px {
    height: 65px !important;
  }

  .h-xxl-70px {
    height: 70px !important;
  }

  .h-xxl-75px {
    height: 75px !important;
  }

  .h-xxl-80px {
    height: 80px !important;
  }

  .h-xxl-85px {
    height: 85px !important;
  }

  .h-xxl-90px {
    height: 90px !important;
  }

  .h-xxl-95px {
    height: 95px !important;
  }

  .h-xxl-100px {
    height: 100px !important;
  }

  .h-xxl-125px {
    height: 125px !important;
  }

  .h-xxl-150px {
    height: 150px !important;
  }

  .h-xxl-175px {
    height: 175px !important;
  }

  .h-xxl-200px {
    height: 200px !important;
  }

  .h-xxl-225px {
    height: 225px !important;
  }

  .h-xxl-250px {
    height: 250px !important;
  }

  .h-xxl-275px {
    height: 275px !important;
  }

  .h-xxl-300px {
    height: 300px !important;
  }

  .h-xxl-325px {
    height: 325px !important;
  }

  .h-xxl-350px {
    height: 350px !important;
  }

  .h-xxl-375px {
    height: 375px !important;
  }

  .h-xxl-400px {
    height: 400px !important;
  }

  .h-xxl-425px {
    height: 425px !important;
  }

  .h-xxl-450px {
    height: 450px !important;
  }

  .h-xxl-475px {
    height: 475px !important;
  }

  .h-xxl-500px {
    height: 500px !important;
  }

  .h-xxl-550px {
    height: 550px !important;
  }

  .h-xxl-600px {
    height: 600px !important;
  }

  .h-xxl-650px {
    height: 650px !important;
  }

  .h-xxl-700px {
    height: 700px !important;
  }

  .h-xxl-750px {
    height: 750px !important;
  }

  .h-xxl-800px {
    height: 800px !important;
  }

  .h-xxl-850px {
    height: 850px !important;
  }

  .h-xxl-900px {
    height: 900px !important;
  }

  .h-xxl-950px {
    height: 950px !important;
  }

  .h-xxl-1000px {
    height: 1000px !important;
  }

  .mh-xxl-unset {
    max-height: unset !important;
  }

  .mh-xxl-25 {
    max-height: 25% !important;
  }

  .mh-xxl-50 {
    max-height: 50% !important;
  }

  .mh-xxl-75 {
    max-height: 75% !important;
  }

  .mh-xxl-100 {
    max-height: 100% !important;
  }

  .mh-xxl-auto {
    max-height: auto !important;
  }

  .mh-xxl-1px {
    max-height: 1px !important;
  }

  .mh-xxl-2px {
    max-height: 2px !important;
  }

  .mh-xxl-3px {
    max-height: 3px !important;
  }

  .mh-xxl-4px {
    max-height: 4px !important;
  }

  .mh-xxl-5px {
    max-height: 5px !important;
  }

  .mh-xxl-6px {
    max-height: 6px !important;
  }

  .mh-xxl-7px {
    max-height: 7px !important;
  }

  .mh-xxl-8px {
    max-height: 8px !important;
  }

  .mh-xxl-9px {
    max-height: 9px !important;
  }

  .mh-xxl-10px {
    max-height: 10px !important;
  }

  .mh-xxl-15px {
    max-height: 15px !important;
  }

  .mh-xxl-20px {
    max-height: 20px !important;
  }

  .mh-xxl-25px {
    max-height: 25px !important;
  }

  .mh-xxl-30px {
    max-height: 30px !important;
  }

  .mh-xxl-35px {
    max-height: 35px !important;
  }

  .mh-xxl-40px {
    max-height: 40px !important;
  }

  .mh-xxl-45px {
    max-height: 45px !important;
  }

  .mh-xxl-50px {
    max-height: 50px !important;
  }

  .mh-xxl-55px {
    max-height: 55px !important;
  }

  .mh-xxl-60px {
    max-height: 60px !important;
  }

  .mh-xxl-65px {
    max-height: 65px !important;
  }

  .mh-xxl-70px {
    max-height: 70px !important;
  }

  .mh-xxl-75px {
    max-height: 75px !important;
  }

  .mh-xxl-80px {
    max-height: 80px !important;
  }

  .mh-xxl-85px {
    max-height: 85px !important;
  }

  .mh-xxl-90px {
    max-height: 90px !important;
  }

  .mh-xxl-95px {
    max-height: 95px !important;
  }

  .mh-xxl-100px {
    max-height: 100px !important;
  }

  .mh-xxl-125px {
    max-height: 125px !important;
  }

  .mh-xxl-150px {
    max-height: 150px !important;
  }

  .mh-xxl-175px {
    max-height: 175px !important;
  }

  .mh-xxl-200px {
    max-height: 200px !important;
  }

  .mh-xxl-225px {
    max-height: 225px !important;
  }

  .mh-xxl-250px {
    max-height: 250px !important;
  }

  .mh-xxl-275px {
    max-height: 275px !important;
  }

  .mh-xxl-300px {
    max-height: 300px !important;
  }

  .mh-xxl-325px {
    max-height: 325px !important;
  }

  .mh-xxl-350px {
    max-height: 350px !important;
  }

  .mh-xxl-375px {
    max-height: 375px !important;
  }

  .mh-xxl-400px {
    max-height: 400px !important;
  }

  .mh-xxl-425px {
    max-height: 425px !important;
  }

  .mh-xxl-450px {
    max-height: 450px !important;
  }

  .mh-xxl-475px {
    max-height: 475px !important;
  }

  .mh-xxl-500px {
    max-height: 500px !important;
  }

  .mh-xxl-550px {
    max-height: 550px !important;
  }

  .mh-xxl-600px {
    max-height: 600px !important;
  }

  .mh-xxl-650px {
    max-height: 650px !important;
  }

  .mh-xxl-700px {
    max-height: 700px !important;
  }

  .mh-xxl-750px {
    max-height: 750px !important;
  }

  .mh-xxl-800px {
    max-height: 800px !important;
  }

  .mh-xxl-850px {
    max-height: 850px !important;
  }

  .mh-xxl-900px {
    max-height: 900px !important;
  }

  .mh-xxl-950px {
    max-height: 950px !important;
  }

  .mh-xxl-1000px {
    max-height: 1000px !important;
  }

  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }

  .flex-xxl-row {
    flex-direction: row !important;
  }

  .flex-xxl-column {
    flex-direction: column !important;
  }

  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }

  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }

  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }

  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }

  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }

  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }

  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }

  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }

  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }

  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }

  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }

  .justify-content-xxl-center {
    justify-content: center !important;
  }

  .justify-content-xxl-between {
    justify-content: space-between !important;
  }

  .justify-content-xxl-around {
    justify-content: space-around !important;
  }

  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }

  .align-items-xxl-start {
    align-items: flex-start !important;
  }

  .align-items-xxl-end {
    align-items: flex-end !important;
  }

  .align-items-xxl-center {
    align-items: center !important;
  }

  .align-items-xxl-baseline {
    align-items: baseline !important;
  }

  .align-items-xxl-stretch {
    align-items: stretch !important;
  }

  .align-content-xxl-start {
    align-content: flex-start !important;
  }

  .align-content-xxl-end {
    align-content: flex-end !important;
  }

  .align-content-xxl-center {
    align-content: center !important;
  }

  .align-content-xxl-between {
    align-content: space-between !important;
  }

  .align-content-xxl-around {
    align-content: space-around !important;
  }

  .align-content-xxl-stretch {
    align-content: stretch !important;
  }

  .align-self-xxl-auto {
    align-self: auto !important;
  }

  .align-self-xxl-start {
    align-self: flex-start !important;
  }

  .align-self-xxl-end {
    align-self: flex-end !important;
  }

  .align-self-xxl-center {
    align-self: center !important;
  }

  .align-self-xxl-baseline {
    align-self: baseline !important;
  }

  .align-self-xxl-stretch {
    align-self: stretch !important;
  }

  .order-xxl-first {
    order: -1 !important;
  }

  .order-xxl-0 {
    order: 0 !important;
  }

  .order-xxl-1 {
    order: 1 !important;
  }

  .order-xxl-2 {
    order: 2 !important;
  }

  .order-xxl-3 {
    order: 3 !important;
  }

  .order-xxl-4 {
    order: 4 !important;
  }

  .order-xxl-5 {
    order: 5 !important;
  }

  .order-xxl-last {
    order: 6 !important;
  }

  .m-xxl-0 {
    margin: 0 !important;
  }

  .m-xxl-1 {
    margin: 0.25rem !important;
  }

  .m-xxl-2 {
    margin: 0.5rem !important;
  }

  .m-xxl-3 {
    margin: 0.75rem !important;
  }

  .m-xxl-4 {
    margin: 1rem !important;
  }

  .m-xxl-5 {
    margin: 1.25rem !important;
  }

  .m-xxl-6 {
    margin: 1.5rem !important;
  }

  .m-xxl-7 {
    margin: 1.75rem !important;
  }

  .m-xxl-8 {
    margin: 2rem !important;
  }

  .m-xxl-9 {
    margin: 2.25rem !important;
  }

  .m-xxl-10 {
    margin: 2.5rem !important;
  }

  .m-xxl-11 {
    margin: 2.75rem !important;
  }

  .m-xxl-12 {
    margin: 3rem !important;
  }

  .m-xxl-13 {
    margin: 3.25rem !important;
  }

  .m-xxl-14 {
    margin: 3.5rem !important;
  }

  .m-xxl-15 {
    margin: 3.75rem !important;
  }

  .m-xxl-16 {
    margin: 4rem !important;
  }

  .m-xxl-17 {
    margin: 4.25rem !important;
  }

  .m-xxl-18 {
    margin: 4.5rem !important;
  }

  .m-xxl-19 {
    margin: 4.75rem !important;
  }

  .m-xxl-20 {
    margin: 5rem !important;
  }

  .m-xxl-auto {
    margin: auto !important;
  }

  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }

  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }

  .mx-xxl-3 {
    margin-right: 0.75rem !important;
    margin-left: 0.75rem !important;
  }

  .mx-xxl-4 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }

  .mx-xxl-5 {
    margin-right: 1.25rem !important;
    margin-left: 1.25rem !important;
  }

  .mx-xxl-6 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }

  .mx-xxl-7 {
    margin-right: 1.75rem !important;
    margin-left: 1.75rem !important;
  }

  .mx-xxl-8 {
    margin-right: 2rem !important;
    margin-left: 2rem !important;
  }

  .mx-xxl-9 {
    margin-right: 2.25rem !important;
    margin-left: 2.25rem !important;
  }

  .mx-xxl-10 {
    margin-right: 2.5rem !important;
    margin-left: 2.5rem !important;
  }

  .mx-xxl-11 {
    margin-right: 2.75rem !important;
    margin-left: 2.75rem !important;
  }

  .mx-xxl-12 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }

  .mx-xxl-13 {
    margin-right: 3.25rem !important;
    margin-left: 3.25rem !important;
  }

  .mx-xxl-14 {
    margin-right: 3.5rem !important;
    margin-left: 3.5rem !important;
  }

  .mx-xxl-15 {
    margin-right: 3.75rem !important;
    margin-left: 3.75rem !important;
  }

  .mx-xxl-16 {
    margin-right: 4rem !important;
    margin-left: 4rem !important;
  }

  .mx-xxl-17 {
    margin-right: 4.25rem !important;
    margin-left: 4.25rem !important;
  }

  .mx-xxl-18 {
    margin-right: 4.5rem !important;
    margin-left: 4.5rem !important;
  }

  .mx-xxl-19 {
    margin-right: 4.75rem !important;
    margin-left: 4.75rem !important;
  }

  .mx-xxl-20 {
    margin-right: 5rem !important;
    margin-left: 5rem !important;
  }

  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }

  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }

  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }

  .my-xxl-3 {
    margin-top: 0.75rem !important;
    margin-bottom: 0.75rem !important;
  }

  .my-xxl-4 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }

  .my-xxl-5 {
    margin-top: 1.25rem !important;
    margin-bottom: 1.25rem !important;
  }

  .my-xxl-6 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }

  .my-xxl-7 {
    margin-top: 1.75rem !important;
    margin-bottom: 1.75rem !important;
  }

  .my-xxl-8 {
    margin-top: 2rem !important;
    margin-bottom: 2rem !important;
  }

  .my-xxl-9 {
    margin-top: 2.25rem !important;
    margin-bottom: 2.25rem !important;
  }

  .my-xxl-10 {
    margin-top: 2.5rem !important;
    margin-bottom: 2.5rem !important;
  }

  .my-xxl-11 {
    margin-top: 2.75rem !important;
    margin-bottom: 2.75rem !important;
  }

  .my-xxl-12 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }

  .my-xxl-13 {
    margin-top: 3.25rem !important;
    margin-bottom: 3.25rem !important;
  }

  .my-xxl-14 {
    margin-top: 3.5rem !important;
    margin-bottom: 3.5rem !important;
  }

  .my-xxl-15 {
    margin-top: 3.75rem !important;
    margin-bottom: 3.75rem !important;
  }

  .my-xxl-16 {
    margin-top: 4rem !important;
    margin-bottom: 4rem !important;
  }

  .my-xxl-17 {
    margin-top: 4.25rem !important;
    margin-bottom: 4.25rem !important;
  }

  .my-xxl-18 {
    margin-top: 4.5rem !important;
    margin-bottom: 4.5rem !important;
  }

  .my-xxl-19 {
    margin-top: 4.75rem !important;
    margin-bottom: 4.75rem !important;
  }

  .my-xxl-20 {
    margin-top: 5rem !important;
    margin-bottom: 5rem !important;
  }

  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }

  .mt-xxl-0 {
    margin-top: 0 !important;
  }

  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }

  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }

  .mt-xxl-3 {
    margin-top: 0.75rem !important;
  }

  .mt-xxl-4 {
    margin-top: 1rem !important;
  }

  .mt-xxl-5 {
    margin-top: 1.25rem !important;
  }

  .mt-xxl-6 {
    margin-top: 1.5rem !important;
  }

  .mt-xxl-7 {
    margin-top: 1.75rem !important;
  }

  .mt-xxl-8 {
    margin-top: 2rem !important;
  }

  .mt-xxl-9 {
    margin-top: 2.25rem !important;
  }

  .mt-xxl-10 {
    margin-top: 2.5rem !important;
  }

  .mt-xxl-11 {
    margin-top: 2.75rem !important;
  }

  .mt-xxl-12 {
    margin-top: 3rem !important;
  }

  .mt-xxl-13 {
    margin-top: 3.25rem !important;
  }

  .mt-xxl-14 {
    margin-top: 3.5rem !important;
  }

  .mt-xxl-15 {
    margin-top: 3.75rem !important;
  }

  .mt-xxl-16 {
    margin-top: 4rem !important;
  }

  .mt-xxl-17 {
    margin-top: 4.25rem !important;
  }

  .mt-xxl-18 {
    margin-top: 4.5rem !important;
  }

  .mt-xxl-19 {
    margin-top: 4.75rem !important;
  }

  .mt-xxl-20 {
    margin-top: 5rem !important;
  }

  .mt-xxl-auto {
    margin-top: auto !important;
  }

  .me-xxl-0 {
    margin-right: 0 !important;
  }

  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }

  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }

  .me-xxl-3 {
    margin-right: 0.75rem !important;
  }

  .me-xxl-4 {
    margin-right: 1rem !important;
  }

  .me-xxl-5 {
    margin-right: 1.25rem !important;
  }

  .me-xxl-6 {
    margin-right: 1.5rem !important;
  }

  .me-xxl-7 {
    margin-right: 1.75rem !important;
  }

  .me-xxl-8 {
    margin-right: 2rem !important;
  }

  .me-xxl-9 {
    margin-right: 2.25rem !important;
  }

  .me-xxl-10 {
    margin-right: 2.5rem !important;
  }

  .me-xxl-11 {
    margin-right: 2.75rem !important;
  }

  .me-xxl-12 {
    margin-right: 3rem !important;
  }

  .me-xxl-13 {
    margin-right: 3.25rem !important;
  }

  .me-xxl-14 {
    margin-right: 3.5rem !important;
  }

  .me-xxl-15 {
    margin-right: 3.75rem !important;
  }

  .me-xxl-16 {
    margin-right: 4rem !important;
  }

  .me-xxl-17 {
    margin-right: 4.25rem !important;
  }

  .me-xxl-18 {
    margin-right: 4.5rem !important;
  }

  .me-xxl-19 {
    margin-right: 4.75rem !important;
  }

  .me-xxl-20 {
    margin-right: 5rem !important;
  }

  .me-xxl-auto {
    margin-right: auto !important;
  }

  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }

  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }

  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }

  .mb-xxl-3 {
    margin-bottom: 0.75rem !important;
  }

  .mb-xxl-4 {
    margin-bottom: 1rem !important;
  }

  .mb-xxl-5 {
    margin-bottom: 1.25rem !important;
  }

  .mb-xxl-6 {
    margin-bottom: 1.5rem !important;
  }

  .mb-xxl-7 {
    margin-bottom: 1.75rem !important;
  }

  .mb-xxl-8 {
    margin-bottom: 2rem !important;
  }

  .mb-xxl-9 {
    margin-bottom: 2.25rem !important;
  }

  .mb-xxl-10 {
    margin-bottom: 2.5rem !important;
  }

  .mb-xxl-11 {
    margin-bottom: 2.75rem !important;
  }

  .mb-xxl-12 {
    margin-bottom: 3rem !important;
  }

  .mb-xxl-13 {
    margin-bottom: 3.25rem !important;
  }

  .mb-xxl-14 {
    margin-bottom: 3.5rem !important;
  }

  .mb-xxl-15 {
    margin-bottom: 3.75rem !important;
  }

  .mb-xxl-16 {
    margin-bottom: 4rem !important;
  }

  .mb-xxl-17 {
    margin-bottom: 4.25rem !important;
  }

  .mb-xxl-18 {
    margin-bottom: 4.5rem !important;
  }

  .mb-xxl-19 {
    margin-bottom: 4.75rem !important;
  }

  .mb-xxl-20 {
    margin-bottom: 5rem !important;
  }

  .mb-xxl-auto {
    margin-bottom: auto !important;
  }

  .ms-xxl-0 {
    margin-left: 0 !important;
  }

  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }

  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }

  .ms-xxl-3 {
    margin-left: 0.75rem !important;
  }

  .ms-xxl-4 {
    margin-left: 1rem !important;
  }

  .ms-xxl-5 {
    margin-left: 1.25rem !important;
  }

  .ms-xxl-6 {
    margin-left: 1.5rem !important;
  }

  .ms-xxl-7 {
    margin-left: 1.75rem !important;
  }

  .ms-xxl-8 {
    margin-left: 2rem !important;
  }

  .ms-xxl-9 {
    margin-left: 2.25rem !important;
  }

  .ms-xxl-10 {
    margin-left: 2.5rem !important;
  }

  .ms-xxl-11 {
    margin-left: 2.75rem !important;
  }

  .ms-xxl-12 {
    margin-left: 3rem !important;
  }

  .ms-xxl-13 {
    margin-left: 3.25rem !important;
  }

  .ms-xxl-14 {
    margin-left: 3.5rem !important;
  }

  .ms-xxl-15 {
    margin-left: 3.75rem !important;
  }

  .ms-xxl-16 {
    margin-left: 4rem !important;
  }

  .ms-xxl-17 {
    margin-left: 4.25rem !important;
  }

  .ms-xxl-18 {
    margin-left: 4.5rem !important;
  }

  .ms-xxl-19 {
    margin-left: 4.75rem !important;
  }

  .ms-xxl-20 {
    margin-left: 5rem !important;
  }

  .ms-xxl-auto {
    margin-left: auto !important;
  }

  .m-xxl-n1 {
    margin: -0.25rem !important;
  }

  .m-xxl-n2 {
    margin: -0.5rem !important;
  }

  .m-xxl-n3 {
    margin: -0.75rem !important;
  }

  .m-xxl-n4 {
    margin: -1rem !important;
  }

  .m-xxl-n5 {
    margin: -1.25rem !important;
  }

  .m-xxl-n6 {
    margin: -1.5rem !important;
  }

  .m-xxl-n7 {
    margin: -1.75rem !important;
  }

  .m-xxl-n8 {
    margin: -2rem !important;
  }

  .m-xxl-n9 {
    margin: -2.25rem !important;
  }

  .m-xxl-n10 {
    margin: -2.5rem !important;
  }

  .m-xxl-n11 {
    margin: -2.75rem !important;
  }

  .m-xxl-n12 {
    margin: -3rem !important;
  }

  .m-xxl-n13 {
    margin: -3.25rem !important;
  }

  .m-xxl-n14 {
    margin: -3.5rem !important;
  }

  .m-xxl-n15 {
    margin: -3.75rem !important;
  }

  .m-xxl-n16 {
    margin: -4rem !important;
  }

  .m-xxl-n17 {
    margin: -4.25rem !important;
  }

  .m-xxl-n18 {
    margin: -4.5rem !important;
  }

  .m-xxl-n19 {
    margin: -4.75rem !important;
  }

  .m-xxl-n20 {
    margin: -5rem !important;
  }

  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }

  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }

  .mx-xxl-n3 {
    margin-right: -0.75rem !important;
    margin-left: -0.75rem !important;
  }

  .mx-xxl-n4 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }

  .mx-xxl-n5 {
    margin-right: -1.25rem !important;
    margin-left: -1.25rem !important;
  }

  .mx-xxl-n6 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }

  .mx-xxl-n7 {
    margin-right: -1.75rem !important;
    margin-left: -1.75rem !important;
  }

  .mx-xxl-n8 {
    margin-right: -2rem !important;
    margin-left: -2rem !important;
  }

  .mx-xxl-n9 {
    margin-right: -2.25rem !important;
    margin-left: -2.25rem !important;
  }

  .mx-xxl-n10 {
    margin-right: -2.5rem !important;
    margin-left: -2.5rem !important;
  }

  .mx-xxl-n11 {
    margin-right: -2.75rem !important;
    margin-left: -2.75rem !important;
  }

  .mx-xxl-n12 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }

  .mx-xxl-n13 {
    margin-right: -3.25rem !important;
    margin-left: -3.25rem !important;
  }

  .mx-xxl-n14 {
    margin-right: -3.5rem !important;
    margin-left: -3.5rem !important;
  }

  .mx-xxl-n15 {
    margin-right: -3.75rem !important;
    margin-left: -3.75rem !important;
  }

  .mx-xxl-n16 {
    margin-right: -4rem !important;
    margin-left: -4rem !important;
  }

  .mx-xxl-n17 {
    margin-right: -4.25rem !important;
    margin-left: -4.25rem !important;
  }

  .mx-xxl-n18 {
    margin-right: -4.5rem !important;
    margin-left: -4.5rem !important;
  }

  .mx-xxl-n19 {
    margin-right: -4.75rem !important;
    margin-left: -4.75rem !important;
  }

  .mx-xxl-n20 {
    margin-right: -5rem !important;
    margin-left: -5rem !important;
  }

  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }

  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }

  .my-xxl-n3 {
    margin-top: -0.75rem !important;
    margin-bottom: -0.75rem !important;
  }

  .my-xxl-n4 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }

  .my-xxl-n5 {
    margin-top: -1.25rem !important;
    margin-bottom: -1.25rem !important;
  }

  .my-xxl-n6 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }

  .my-xxl-n7 {
    margin-top: -1.75rem !important;
    margin-bottom: -1.75rem !important;
  }

  .my-xxl-n8 {
    margin-top: -2rem !important;
    margin-bottom: -2rem !important;
  }

  .my-xxl-n9 {
    margin-top: -2.25rem !important;
    margin-bottom: -2.25rem !important;
  }

  .my-xxl-n10 {
    margin-top: -2.5rem !important;
    margin-bottom: -2.5rem !important;
  }

  .my-xxl-n11 {
    margin-top: -2.75rem !important;
    margin-bottom: -2.75rem !important;
  }

  .my-xxl-n12 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }

  .my-xxl-n13 {
    margin-top: -3.25rem !important;
    margin-bottom: -3.25rem !important;
  }

  .my-xxl-n14 {
    margin-top: -3.5rem !important;
    margin-bottom: -3.5rem !important;
  }

  .my-xxl-n15 {
    margin-top: -3.75rem !important;
    margin-bottom: -3.75rem !important;
  }

  .my-xxl-n16 {
    margin-top: -4rem !important;
    margin-bottom: -4rem !important;
  }

  .my-xxl-n17 {
    margin-top: -4.25rem !important;
    margin-bottom: -4.25rem !important;
  }

  .my-xxl-n18 {
    margin-top: -4.5rem !important;
    margin-bottom: -4.5rem !important;
  }

  .my-xxl-n19 {
    margin-top: -4.75rem !important;
    margin-bottom: -4.75rem !important;
  }

  .my-xxl-n20 {
    margin-top: -5rem !important;
    margin-bottom: -5rem !important;
  }

  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }

  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }

  .mt-xxl-n3 {
    margin-top: -0.75rem !important;
  }

  .mt-xxl-n4 {
    margin-top: -1rem !important;
  }

  .mt-xxl-n5 {
    margin-top: -1.25rem !important;
  }

  .mt-xxl-n6 {
    margin-top: -1.5rem !important;
  }

  .mt-xxl-n7 {
    margin-top: -1.75rem !important;
  }

  .mt-xxl-n8 {
    margin-top: -2rem !important;
  }

  .mt-xxl-n9 {
    margin-top: -2.25rem !important;
  }

  .mt-xxl-n10 {
    margin-top: -2.5rem !important;
  }

  .mt-xxl-n11 {
    margin-top: -2.75rem !important;
  }

  .mt-xxl-n12 {
    margin-top: -3rem !important;
  }

  .mt-xxl-n13 {
    margin-top: -3.25rem !important;
  }

  .mt-xxl-n14 {
    margin-top: -3.5rem !important;
  }

  .mt-xxl-n15 {
    margin-top: -3.75rem !important;
  }

  .mt-xxl-n16 {
    margin-top: -4rem !important;
  }

  .mt-xxl-n17 {
    margin-top: -4.25rem !important;
  }

  .mt-xxl-n18 {
    margin-top: -4.5rem !important;
  }

  .mt-xxl-n19 {
    margin-top: -4.75rem !important;
  }

  .mt-xxl-n20 {
    margin-top: -5rem !important;
  }

  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }

  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }

  .me-xxl-n3 {
    margin-right: -0.75rem !important;
  }

  .me-xxl-n4 {
    margin-right: -1rem !important;
  }

  .me-xxl-n5 {
    margin-right: -1.25rem !important;
  }

  .me-xxl-n6 {
    margin-right: -1.5rem !important;
  }

  .me-xxl-n7 {
    margin-right: -1.75rem !important;
  }

  .me-xxl-n8 {
    margin-right: -2rem !important;
  }

  .me-xxl-n9 {
    margin-right: -2.25rem !important;
  }

  .me-xxl-n10 {
    margin-right: -2.5rem !important;
  }

  .me-xxl-n11 {
    margin-right: -2.75rem !important;
  }

  .me-xxl-n12 {
    margin-right: -3rem !important;
  }

  .me-xxl-n13 {
    margin-right: -3.25rem !important;
  }

  .me-xxl-n14 {
    margin-right: -3.5rem !important;
  }

  .me-xxl-n15 {
    margin-right: -3.75rem !important;
  }

  .me-xxl-n16 {
    margin-right: -4rem !important;
  }

  .me-xxl-n17 {
    margin-right: -4.25rem !important;
  }

  .me-xxl-n18 {
    margin-right: -4.5rem !important;
  }

  .me-xxl-n19 {
    margin-right: -4.75rem !important;
  }

  .me-xxl-n20 {
    margin-right: -5rem !important;
  }

  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }

  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }

  .mb-xxl-n3 {
    margin-bottom: -0.75rem !important;
  }

  .mb-xxl-n4 {
    margin-bottom: -1rem !important;
  }

  .mb-xxl-n5 {
    margin-bottom: -1.25rem !important;
  }

  .mb-xxl-n6 {
    margin-bottom: -1.5rem !important;
  }

  .mb-xxl-n7 {
    margin-bottom: -1.75rem !important;
  }

  .mb-xxl-n8 {
    margin-bottom: -2rem !important;
  }

  .mb-xxl-n9 {
    margin-bottom: -2.25rem !important;
  }

  .mb-xxl-n10 {
    margin-bottom: -2.5rem !important;
  }

  .mb-xxl-n11 {
    margin-bottom: -2.75rem !important;
  }

  .mb-xxl-n12 {
    margin-bottom: -3rem !important;
  }

  .mb-xxl-n13 {
    margin-bottom: -3.25rem !important;
  }

  .mb-xxl-n14 {
    margin-bottom: -3.5rem !important;
  }

  .mb-xxl-n15 {
    margin-bottom: -3.75rem !important;
  }

  .mb-xxl-n16 {
    margin-bottom: -4rem !important;
  }

  .mb-xxl-n17 {
    margin-bottom: -4.25rem !important;
  }

  .mb-xxl-n18 {
    margin-bottom: -4.5rem !important;
  }

  .mb-xxl-n19 {
    margin-bottom: -4.75rem !important;
  }

  .mb-xxl-n20 {
    margin-bottom: -5rem !important;
  }

  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }

  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }

  .ms-xxl-n3 {
    margin-left: -0.75rem !important;
  }

  .ms-xxl-n4 {
    margin-left: -1rem !important;
  }

  .ms-xxl-n5 {
    margin-left: -1.25rem !important;
  }

  .ms-xxl-n6 {
    margin-left: -1.5rem !important;
  }

  .ms-xxl-n7 {
    margin-left: -1.75rem !important;
  }

  .ms-xxl-n8 {
    margin-left: -2rem !important;
  }

  .ms-xxl-n9 {
    margin-left: -2.25rem !important;
  }

  .ms-xxl-n10 {
    margin-left: -2.5rem !important;
  }

  .ms-xxl-n11 {
    margin-left: -2.75rem !important;
  }

  .ms-xxl-n12 {
    margin-left: -3rem !important;
  }

  .ms-xxl-n13 {
    margin-left: -3.25rem !important;
  }

  .ms-xxl-n14 {
    margin-left: -3.5rem !important;
  }

  .ms-xxl-n15 {
    margin-left: -3.75rem !important;
  }

  .ms-xxl-n16 {
    margin-left: -4rem !important;
  }

  .ms-xxl-n17 {
    margin-left: -4.25rem !important;
  }

  .ms-xxl-n18 {
    margin-left: -4.5rem !important;
  }

  .ms-xxl-n19 {
    margin-left: -4.75rem !important;
  }

  .ms-xxl-n20 {
    margin-left: -5rem !important;
  }

  .p-xxl-0 {
    padding: 0 !important;
  }

  .p-xxl-1 {
    padding: 0.25rem !important;
  }

  .p-xxl-2 {
    padding: 0.5rem !important;
  }

  .p-xxl-3 {
    padding: 0.75rem !important;
  }

  .p-xxl-4 {
    padding: 1rem !important;
  }

  .p-xxl-5 {
    padding: 1.25rem !important;
  }

  .p-xxl-6 {
    padding: 1.5rem !important;
  }

  .p-xxl-7 {
    padding: 1.75rem !important;
  }

  .p-xxl-8 {
    padding: 2rem !important;
  }

  .p-xxl-9 {
    padding: 2.25rem !important;
  }

  .p-xxl-10 {
    padding: 2.5rem !important;
  }

  .p-xxl-11 {
    padding: 2.75rem !important;
  }

  .p-xxl-12 {
    padding: 3rem !important;
  }

  .p-xxl-13 {
    padding: 3.25rem !important;
  }

  .p-xxl-14 {
    padding: 3.5rem !important;
  }

  .p-xxl-15 {
    padding: 3.75rem !important;
  }

  .p-xxl-16 {
    padding: 4rem !important;
  }

  .p-xxl-17 {
    padding: 4.25rem !important;
  }

  .p-xxl-18 {
    padding: 4.5rem !important;
  }

  .p-xxl-19 {
    padding: 4.75rem !important;
  }

  .p-xxl-20 {
    padding: 5rem !important;
  }

  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }

  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }

  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }

  .px-xxl-3 {
    padding-right: 0.75rem !important;
    padding-left: 0.75rem !important;
  }

  .px-xxl-4 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }

  .px-xxl-5 {
    padding-right: 1.25rem !important;
    padding-left: 1.25rem !important;
  }

  .px-xxl-6 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }

  .px-xxl-7 {
    padding-right: 1.75rem !important;
    padding-left: 1.75rem !important;
  }

  .px-xxl-8 {
    padding-right: 2rem !important;
    padding-left: 2rem !important;
  }

  .px-xxl-9 {
    padding-right: 2.25rem !important;
    padding-left: 2.25rem !important;
  }

  .px-xxl-10 {
    padding-right: 2.5rem !important;
    padding-left: 2.5rem !important;
  }

  .px-xxl-11 {
    padding-right: 2.75rem !important;
    padding-left: 2.75rem !important;
  }

  .px-xxl-12 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }

  .px-xxl-13 {
    padding-right: 3.25rem !important;
    padding-left: 3.25rem !important;
  }

  .px-xxl-14 {
    padding-right: 3.5rem !important;
    padding-left: 3.5rem !important;
  }

  .px-xxl-15 {
    padding-right: 3.75rem !important;
    padding-left: 3.75rem !important;
  }

  .px-xxl-16 {
    padding-right: 4rem !important;
    padding-left: 4rem !important;
  }

  .px-xxl-17 {
    padding-right: 4.25rem !important;
    padding-left: 4.25rem !important;
  }

  .px-xxl-18 {
    padding-right: 4.5rem !important;
    padding-left: 4.5rem !important;
  }

  .px-xxl-19 {
    padding-right: 4.75rem !important;
    padding-left: 4.75rem !important;
  }

  .px-xxl-20 {
    padding-right: 5rem !important;
    padding-left: 5rem !important;
  }

  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }

  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .py-xxl-3 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }

  .py-xxl-4 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }

  .py-xxl-5 {
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
  }

  .py-xxl-6 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }

  .py-xxl-7 {
    padding-top: 1.75rem !important;
    padding-bottom: 1.75rem !important;
  }

  .py-xxl-8 {
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
  }

  .py-xxl-9 {
    padding-top: 2.25rem !important;
    padding-bottom: 2.25rem !important;
  }

  .py-xxl-10 {
    padding-top: 2.5rem !important;
    padding-bottom: 2.5rem !important;
  }

  .py-xxl-11 {
    padding-top: 2.75rem !important;
    padding-bottom: 2.75rem !important;
  }

  .py-xxl-12 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }

  .py-xxl-13 {
    padding-top: 3.25rem !important;
    padding-bottom: 3.25rem !important;
  }

  .py-xxl-14 {
    padding-top: 3.5rem !important;
    padding-bottom: 3.5rem !important;
  }

  .py-xxl-15 {
    padding-top: 3.75rem !important;
    padding-bottom: 3.75rem !important;
  }

  .py-xxl-16 {
    padding-top: 4rem !important;
    padding-bottom: 4rem !important;
  }

  .py-xxl-17 {
    padding-top: 4.25rem !important;
    padding-bottom: 4.25rem !important;
  }

  .py-xxl-18 {
    padding-top: 4.5rem !important;
    padding-bottom: 4.5rem !important;
  }

  .py-xxl-19 {
    padding-top: 4.75rem !important;
    padding-bottom: 4.75rem !important;
  }

  .py-xxl-20 {
    padding-top: 5rem !important;
    padding-bottom: 5rem !important;
  }

  .pt-xxl-0 {
    padding-top: 0 !important;
  }

  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }

  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }

  .pt-xxl-3 {
    padding-top: 0.75rem !important;
  }

  .pt-xxl-4 {
    padding-top: 1rem !important;
  }

  .pt-xxl-5 {
    padding-top: 1.25rem !important;
  }

  .pt-xxl-6 {
    padding-top: 1.5rem !important;
  }

  .pt-xxl-7 {
    padding-top: 1.75rem !important;
  }

  .pt-xxl-8 {
    padding-top: 2rem !important;
  }

  .pt-xxl-9 {
    padding-top: 2.25rem !important;
  }

  .pt-xxl-10 {
    padding-top: 2.5rem !important;
  }

  .pt-xxl-11 {
    padding-top: 2.75rem !important;
  }

  .pt-xxl-12 {
    padding-top: 3rem !important;
  }

  .pt-xxl-13 {
    padding-top: 3.25rem !important;
  }

  .pt-xxl-14 {
    padding-top: 3.5rem !important;
  }

  .pt-xxl-15 {
    padding-top: 3.75rem !important;
  }

  .pt-xxl-16 {
    padding-top: 4rem !important;
  }

  .pt-xxl-17 {
    padding-top: 4.25rem !important;
  }

  .pt-xxl-18 {
    padding-top: 4.5rem !important;
  }

  .pt-xxl-19 {
    padding-top: 4.75rem !important;
  }

  .pt-xxl-20 {
    padding-top: 5rem !important;
  }

  .pe-xxl-0 {
    padding-right: 0 !important;
  }

  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }

  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }

  .pe-xxl-3 {
    padding-right: 0.75rem !important;
  }

  .pe-xxl-4 {
    padding-right: 1rem !important;
  }

  .pe-xxl-5 {
    padding-right: 1.25rem !important;
  }

  .pe-xxl-6 {
    padding-right: 1.5rem !important;
  }

  .pe-xxl-7 {
    padding-right: 1.75rem !important;
  }

  .pe-xxl-8 {
    padding-right: 2rem !important;
  }

  .pe-xxl-9 {
    padding-right: 2.25rem !important;
  }

  .pe-xxl-10 {
    padding-right: 2.5rem !important;
  }

  .pe-xxl-11 {
    padding-right: 2.75rem !important;
  }

  .pe-xxl-12 {
    padding-right: 3rem !important;
  }

  .pe-xxl-13 {
    padding-right: 3.25rem !important;
  }

  .pe-xxl-14 {
    padding-right: 3.5rem !important;
  }

  .pe-xxl-15 {
    padding-right: 3.75rem !important;
  }

  .pe-xxl-16 {
    padding-right: 4rem !important;
  }

  .pe-xxl-17 {
    padding-right: 4.25rem !important;
  }

  .pe-xxl-18 {
    padding-right: 4.5rem !important;
  }

  .pe-xxl-19 {
    padding-right: 4.75rem !important;
  }

  .pe-xxl-20 {
    padding-right: 5rem !important;
  }

  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }

  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }

  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }

  .pb-xxl-3 {
    padding-bottom: 0.75rem !important;
  }

  .pb-xxl-4 {
    padding-bottom: 1rem !important;
  }

  .pb-xxl-5 {
    padding-bottom: 1.25rem !important;
  }

  .pb-xxl-6 {
    padding-bottom: 1.5rem !important;
  }

  .pb-xxl-7 {
    padding-bottom: 1.75rem !important;
  }

  .pb-xxl-8 {
    padding-bottom: 2rem !important;
  }

  .pb-xxl-9 {
    padding-bottom: 2.25rem !important;
  }

  .pb-xxl-10 {
    padding-bottom: 2.5rem !important;
  }

  .pb-xxl-11 {
    padding-bottom: 2.75rem !important;
  }

  .pb-xxl-12 {
    padding-bottom: 3rem !important;
  }

  .pb-xxl-13 {
    padding-bottom: 3.25rem !important;
  }

  .pb-xxl-14 {
    padding-bottom: 3.5rem !important;
  }

  .pb-xxl-15 {
    padding-bottom: 3.75rem !important;
  }

  .pb-xxl-16 {
    padding-bottom: 4rem !important;
  }

  .pb-xxl-17 {
    padding-bottom: 4.25rem !important;
  }

  .pb-xxl-18 {
    padding-bottom: 4.5rem !important;
  }

  .pb-xxl-19 {
    padding-bottom: 4.75rem !important;
  }

  .pb-xxl-20 {
    padding-bottom: 5rem !important;
  }

  .ps-xxl-0 {
    padding-left: 0 !important;
  }

  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }

  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }

  .ps-xxl-3 {
    padding-left: 0.75rem !important;
  }

  .ps-xxl-4 {
    padding-left: 1rem !important;
  }

  .ps-xxl-5 {
    padding-left: 1.25rem !important;
  }

  .ps-xxl-6 {
    padding-left: 1.5rem !important;
  }

  .ps-xxl-7 {
    padding-left: 1.75rem !important;
  }

  .ps-xxl-8 {
    padding-left: 2rem !important;
  }

  .ps-xxl-9 {
    padding-left: 2.25rem !important;
  }

  .ps-xxl-10 {
    padding-left: 2.5rem !important;
  }

  .ps-xxl-11 {
    padding-left: 2.75rem !important;
  }

  .ps-xxl-12 {
    padding-left: 3rem !important;
  }

  .ps-xxl-13 {
    padding-left: 3.25rem !important;
  }

  .ps-xxl-14 {
    padding-left: 3.5rem !important;
  }

  .ps-xxl-15 {
    padding-left: 3.75rem !important;
  }

  .ps-xxl-16 {
    padding-left: 4rem !important;
  }

  .ps-xxl-17 {
    padding-left: 4.25rem !important;
  }

  .ps-xxl-18 {
    padding-left: 4.5rem !important;
  }

  .ps-xxl-19 {
    padding-left: 4.75rem !important;
  }

  .ps-xxl-20 {
    padding-left: 5rem !important;
  }

  .gap-xxl-0 {
    gap: 0 !important;
  }

  .gap-xxl-1 {
    gap: 0.25rem !important;
  }

  .gap-xxl-2 {
    gap: 0.5rem !important;
  }

  .gap-xxl-3 {
    gap: 0.75rem !important;
  }

  .gap-xxl-4 {
    gap: 1rem !important;
  }

  .gap-xxl-5 {
    gap: 1.25rem !important;
  }

  .gap-xxl-6 {
    gap: 1.5rem !important;
  }

  .gap-xxl-7 {
    gap: 1.75rem !important;
  }

  .gap-xxl-8 {
    gap: 2rem !important;
  }

  .gap-xxl-9 {
    gap: 2.25rem !important;
  }

  .gap-xxl-10 {
    gap: 2.5rem !important;
  }

  .gap-xxl-11 {
    gap: 2.75rem !important;
  }

  .gap-xxl-12 {
    gap: 3rem !important;
  }

  .gap-xxl-13 {
    gap: 3.25rem !important;
  }

  .gap-xxl-14 {
    gap: 3.5rem !important;
  }

  .gap-xxl-15 {
    gap: 3.75rem !important;
  }

  .gap-xxl-16 {
    gap: 4rem !important;
  }

  .gap-xxl-17 {
    gap: 4.25rem !important;
  }

  .gap-xxl-18 {
    gap: 4.5rem !important;
  }

  .gap-xxl-19 {
    gap: 4.75rem !important;
  }

  .gap-xxl-20 {
    gap: 5rem !important;
  }

  .fs-xxl-1 {
    font-size: calc(1.3rem + 0.6vw) !important;
  }

  .fs-xxl-2 {
    font-size: calc(1.275rem + 0.3vw) !important;
  }

  .fs-xxl-3 {
    font-size: calc(1.26rem + 0.12vw) !important;
  }

  .fs-xxl-4 {
    font-size: 1.25rem !important;
  }

  .fs-xxl-5 {
    font-size: 1.15rem !important;
  }

  .fs-xxl-6 {
    font-size: 1.075rem !important;
  }

  .fs-xxl-7 {
    font-size: 0.95rem !important;
  }

  .fs-xxl-8 {
    font-size: 0.85rem !important;
  }

  .fs-xxl-9 {
    font-size: 0.75rem !important;
  }

  .fs-xxl-10 {
    font-size: 0.5rem !important;
  }

  .fs-xxl-base {
    font-size: 1rem !important;
  }

  .fs-xxl-fluid {
    font-size: 100% !important;
  }

  .fs-xxl-2x {
    font-size: calc(1.325rem + 0.9vw) !important;
  }

  .fs-xxl-2qx {
    font-size: calc(1.35rem + 1.2vw) !important;
  }

  .fs-xxl-2hx {
    font-size: calc(1.375rem + 1.5vw) !important;
  }

  .fs-xxl-2tx {
    font-size: calc(1.4rem + 1.8vw) !important;
  }

  .fs-xxl-3x {
    font-size: calc(1.425rem + 2.1vw) !important;
  }

  .fs-xxl-3qx {
    font-size: calc(1.45rem + 2.4vw) !important;
  }

  .fs-xxl-3hx {
    font-size: calc(1.475rem + 2.7vw) !important;
  }

  .fs-xxl-3tx {
    font-size: calc(1.5rem + 3vw) !important;
  }

  .fs-xxl-4x {
    font-size: calc(1.525rem + 3.3vw) !important;
  }

  .fs-xxl-4qx {
    font-size: calc(1.55rem + 3.6vw) !important;
  }

  .fs-xxl-4hx {
    font-size: calc(1.575rem + 3.9vw) !important;
  }

  .fs-xxl-4tx {
    font-size: calc(1.6rem + 4.2vw) !important;
  }

  .fs-xxl-5x {
    font-size: calc(1.625rem + 4.5vw) !important;
  }

  .fs-xxl-5qx {
    font-size: calc(1.65rem + 4.8vw) !important;
  }

  .fs-xxl-5hx {
    font-size: calc(1.675rem + 5.1vw) !important;
  }

  .fs-xxl-5tx {
    font-size: calc(1.7rem + 5.4vw) !important;
  }

  .text-xxl-start {
    text-align: left !important;
  }

  .text-xxl-end {
    text-align: right !important;
  }

  .text-xxl-center {
    text-align: center !important;
  }

  .min-w-xxl-unset {
    min-width: unset !important;
  }

  .min-w-xxl-25 {
    min-width: 25% !important;
  }

  .min-w-xxl-50 {
    min-width: 50% !important;
  }

  .min-w-xxl-75 {
    min-width: 75% !important;
  }

  .min-w-xxl-100 {
    min-width: 100% !important;
  }

  .min-w-xxl-auto {
    min-width: auto !important;
  }

  .min-w-xxl-1px {
    min-width: 1px !important;
  }

  .min-w-xxl-2px {
    min-width: 2px !important;
  }

  .min-w-xxl-3px {
    min-width: 3px !important;
  }

  .min-w-xxl-4px {
    min-width: 4px !important;
  }

  .min-w-xxl-5px {
    min-width: 5px !important;
  }

  .min-w-xxl-6px {
    min-width: 6px !important;
  }

  .min-w-xxl-7px {
    min-width: 7px !important;
  }

  .min-w-xxl-8px {
    min-width: 8px !important;
  }

  .min-w-xxl-9px {
    min-width: 9px !important;
  }

  .min-w-xxl-10px {
    min-width: 10px !important;
  }

  .min-w-xxl-15px {
    min-width: 15px !important;
  }

  .min-w-xxl-20px {
    min-width: 20px !important;
  }

  .min-w-xxl-25px {
    min-width: 25px !important;
  }

  .min-w-xxl-30px {
    min-width: 30px !important;
  }

  .min-w-xxl-35px {
    min-width: 35px !important;
  }

  .min-w-xxl-40px {
    min-width: 40px !important;
  }

  .min-w-xxl-45px {
    min-width: 45px !important;
  }

  .min-w-xxl-50px {
    min-width: 50px !important;
  }

  .min-w-xxl-55px {
    min-width: 55px !important;
  }

  .min-w-xxl-60px {
    min-width: 60px !important;
  }

  .min-w-xxl-65px {
    min-width: 65px !important;
  }

  .min-w-xxl-70px {
    min-width: 70px !important;
  }

  .min-w-xxl-75px {
    min-width: 75px !important;
  }

  .min-w-xxl-80px {
    min-width: 80px !important;
  }

  .min-w-xxl-85px {
    min-width: 85px !important;
  }

  .min-w-xxl-90px {
    min-width: 90px !important;
  }

  .min-w-xxl-95px {
    min-width: 95px !important;
  }

  .min-w-xxl-100px {
    min-width: 100px !important;
  }

  .min-w-xxl-125px {
    min-width: 125px !important;
  }

  .min-w-xxl-150px {
    min-width: 150px !important;
  }

  .min-w-xxl-175px {
    min-width: 175px !important;
  }

  .min-w-xxl-200px {
    min-width: 200px !important;
  }

  .min-w-xxl-225px {
    min-width: 225px !important;
  }

  .min-w-xxl-250px {
    min-width: 250px !important;
  }

  .min-w-xxl-275px {
    min-width: 275px !important;
  }

  .min-w-xxl-300px {
    min-width: 300px !important;
  }

  .min-w-xxl-325px {
    min-width: 325px !important;
  }

  .min-w-xxl-350px {
    min-width: 350px !important;
  }

  .min-w-xxl-375px {
    min-width: 375px !important;
  }

  .min-w-xxl-400px {
    min-width: 400px !important;
  }

  .min-w-xxl-425px {
    min-width: 425px !important;
  }

  .min-w-xxl-450px {
    min-width: 450px !important;
  }

  .min-w-xxl-475px {
    min-width: 475px !important;
  }

  .min-w-xxl-500px {
    min-width: 500px !important;
  }

  .min-w-xxl-550px {
    min-width: 550px !important;
  }

  .min-w-xxl-600px {
    min-width: 600px !important;
  }

  .min-w-xxl-650px {
    min-width: 650px !important;
  }

  .min-w-xxl-700px {
    min-width: 700px !important;
  }

  .min-w-xxl-750px {
    min-width: 750px !important;
  }

  .min-w-xxl-800px {
    min-width: 800px !important;
  }

  .min-w-xxl-850px {
    min-width: 850px !important;
  }

  .min-w-xxl-900px {
    min-width: 900px !important;
  }

  .min-w-xxl-950px {
    min-width: 950px !important;
  }

  .min-w-xxl-1000px {
    min-width: 1000px !important;
  }

  .min-h-xxl-unset {
    min-height: unset !important;
  }

  .min-h-xxl-25 {
    min-height: 25% !important;
  }

  .min-h-xxl-50 {
    min-height: 50% !important;
  }

  .min-h-xxl-75 {
    min-height: 75% !important;
  }

  .min-h-xxl-100 {
    min-height: 100% !important;
  }

  .min-h-xxl-auto {
    min-height: auto !important;
  }

  .min-h-xxl-1px {
    min-height: 1px !important;
  }

  .min-h-xxl-2px {
    min-height: 2px !important;
  }

  .min-h-xxl-3px {
    min-height: 3px !important;
  }

  .min-h-xxl-4px {
    min-height: 4px !important;
  }

  .min-h-xxl-5px {
    min-height: 5px !important;
  }

  .min-h-xxl-6px {
    min-height: 6px !important;
  }

  .min-h-xxl-7px {
    min-height: 7px !important;
  }

  .min-h-xxl-8px {
    min-height: 8px !important;
  }

  .min-h-xxl-9px {
    min-height: 9px !important;
  }

  .min-h-xxl-10px {
    min-height: 10px !important;
  }

  .min-h-xxl-15px {
    min-height: 15px !important;
  }

  .min-h-xxl-20px {
    min-height: 20px !important;
  }

  .min-h-xxl-25px {
    min-height: 25px !important;
  }

  .min-h-xxl-30px {
    min-height: 30px !important;
  }

  .min-h-xxl-35px {
    min-height: 35px !important;
  }

  .min-h-xxl-40px {
    min-height: 40px !important;
  }

  .min-h-xxl-45px {
    min-height: 45px !important;
  }

  .min-h-xxl-50px {
    min-height: 50px !important;
  }

  .min-h-xxl-55px {
    min-height: 55px !important;
  }

  .min-h-xxl-60px {
    min-height: 60px !important;
  }

  .min-h-xxl-65px {
    min-height: 65px !important;
  }

  .min-h-xxl-70px {
    min-height: 70px !important;
  }

  .min-h-xxl-75px {
    min-height: 75px !important;
  }

  .min-h-xxl-80px {
    min-height: 80px !important;
  }

  .min-h-xxl-85px {
    min-height: 85px !important;
  }

  .min-h-xxl-90px {
    min-height: 90px !important;
  }

  .min-h-xxl-95px {
    min-height: 95px !important;
  }

  .min-h-xxl-100px {
    min-height: 100px !important;
  }

  .min-h-xxl-125px {
    min-height: 125px !important;
  }

  .min-h-xxl-150px {
    min-height: 150px !important;
  }

  .min-h-xxl-175px {
    min-height: 175px !important;
  }

  .min-h-xxl-200px {
    min-height: 200px !important;
  }

  .min-h-xxl-225px {
    min-height: 225px !important;
  }

  .min-h-xxl-250px {
    min-height: 250px !important;
  }

  .min-h-xxl-275px {
    min-height: 275px !important;
  }

  .min-h-xxl-300px {
    min-height: 300px !important;
  }

  .min-h-xxl-325px {
    min-height: 325px !important;
  }

  .min-h-xxl-350px {
    min-height: 350px !important;
  }

  .min-h-xxl-375px {
    min-height: 375px !important;
  }

  .min-h-xxl-400px {
    min-height: 400px !important;
  }

  .min-h-xxl-425px {
    min-height: 425px !important;
  }

  .min-h-xxl-450px {
    min-height: 450px !important;
  }

  .min-h-xxl-475px {
    min-height: 475px !important;
  }

  .min-h-xxl-500px {
    min-height: 500px !important;
  }

  .min-h-xxl-550px {
    min-height: 550px !important;
  }

  .min-h-xxl-600px {
    min-height: 600px !important;
  }

  .min-h-xxl-650px {
    min-height: 650px !important;
  }

  .min-h-xxl-700px {
    min-height: 700px !important;
  }

  .min-h-xxl-750px {
    min-height: 750px !important;
  }

  .min-h-xxl-800px {
    min-height: 800px !important;
  }

  .min-h-xxl-850px {
    min-height: 850px !important;
  }

  .min-h-xxl-900px {
    min-height: 900px !important;
  }

  .min-h-xxl-950px {
    min-height: 950px !important;
  }

  .min-h-xxl-1000px {
    min-height: 1000px !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 1.75rem !important;
  }

  .fs-2 {
    font-size: 1.5rem !important;
  }

  .fs-3 {
    font-size: 1.35rem !important;
  }

  .fs-2x {
    font-size: 2rem !important;
  }

  .fs-2qx {
    font-size: 2.25rem !important;
  }

  .fs-2hx {
    font-size: 2.5rem !important;
  }

  .fs-2tx {
    font-size: 2.75rem !important;
  }

  .fs-3x {
    font-size: 3rem !important;
  }

  .fs-3qx {
    font-size: 3.25rem !important;
  }

  .fs-3hx {
    font-size: 3.5rem !important;
  }

  .fs-3tx {
    font-size: 3.75rem !important;
  }

  .fs-4x {
    font-size: 4rem !important;
  }

  .fs-4qx {
    font-size: 4.25rem !important;
  }

  .fs-4hx {
    font-size: 4.5rem !important;
  }

  .fs-4tx {
    font-size: 4.75rem !important;
  }

  .fs-5x {
    font-size: 5rem !important;
  }

  .fs-5qx {
    font-size: 5.25rem !important;
  }

  .fs-5hx {
    font-size: 5.5rem !important;
  }

  .fs-5tx {
    font-size: 5.75rem !important;
  }

  .fs-sm-1 {
    font-size: 1.75rem !important;
  }

  .fs-sm-2 {
    font-size: 1.5rem !important;
  }

  .fs-sm-3 {
    font-size: 1.35rem !important;
  }

  .fs-sm-2x {
    font-size: 2rem !important;
  }

  .fs-sm-2qx {
    font-size: 2.25rem !important;
  }

  .fs-sm-2hx {
    font-size: 2.5rem !important;
  }

  .fs-sm-2tx {
    font-size: 2.75rem !important;
  }

  .fs-sm-3x {
    font-size: 3rem !important;
  }

  .fs-sm-3qx {
    font-size: 3.25rem !important;
  }

  .fs-sm-3hx {
    font-size: 3.5rem !important;
  }

  .fs-sm-3tx {
    font-size: 3.75rem !important;
  }

  .fs-sm-4x {
    font-size: 4rem !important;
  }

  .fs-sm-4qx {
    font-size: 4.25rem !important;
  }

  .fs-sm-4hx {
    font-size: 4.5rem !important;
  }

  .fs-sm-4tx {
    font-size: 4.75rem !important;
  }

  .fs-sm-5x {
    font-size: 5rem !important;
  }

  .fs-sm-5qx {
    font-size: 5.25rem !important;
  }

  .fs-sm-5hx {
    font-size: 5.5rem !important;
  }

  .fs-sm-5tx {
    font-size: 5.75rem !important;
  }

  .fs-md-1 {
    font-size: 1.75rem !important;
  }

  .fs-md-2 {
    font-size: 1.5rem !important;
  }

  .fs-md-3 {
    font-size: 1.35rem !important;
  }

  .fs-md-2x {
    font-size: 2rem !important;
  }

  .fs-md-2qx {
    font-size: 2.25rem !important;
  }

  .fs-md-2hx {
    font-size: 2.5rem !important;
  }

  .fs-md-2tx {
    font-size: 2.75rem !important;
  }

  .fs-md-3x {
    font-size: 3rem !important;
  }

  .fs-md-3qx {
    font-size: 3.25rem !important;
  }

  .fs-md-3hx {
    font-size: 3.5rem !important;
  }

  .fs-md-3tx {
    font-size: 3.75rem !important;
  }

  .fs-md-4x {
    font-size: 4rem !important;
  }

  .fs-md-4qx {
    font-size: 4.25rem !important;
  }

  .fs-md-4hx {
    font-size: 4.5rem !important;
  }

  .fs-md-4tx {
    font-size: 4.75rem !important;
  }

  .fs-md-5x {
    font-size: 5rem !important;
  }

  .fs-md-5qx {
    font-size: 5.25rem !important;
  }

  .fs-md-5hx {
    font-size: 5.5rem !important;
  }

  .fs-md-5tx {
    font-size: 5.75rem !important;
  }

  .fs-lg-1 {
    font-size: 1.75rem !important;
  }

  .fs-lg-2 {
    font-size: 1.5rem !important;
  }

  .fs-lg-3 {
    font-size: 1.35rem !important;
  }

  .fs-lg-2x {
    font-size: 2rem !important;
  }

  .fs-lg-2qx {
    font-size: 2.25rem !important;
  }

  .fs-lg-2hx {
    font-size: 2.5rem !important;
  }

  .fs-lg-2tx {
    font-size: 2.75rem !important;
  }

  .fs-lg-3x {
    font-size: 3rem !important;
  }

  .fs-lg-3qx {
    font-size: 3.25rem !important;
  }

  .fs-lg-3hx {
    font-size: 3.5rem !important;
  }

  .fs-lg-3tx {
    font-size: 3.75rem !important;
  }

  .fs-lg-4x {
    font-size: 4rem !important;
  }

  .fs-lg-4qx {
    font-size: 4.25rem !important;
  }

  .fs-lg-4hx {
    font-size: 4.5rem !important;
  }

  .fs-lg-4tx {
    font-size: 4.75rem !important;
  }

  .fs-lg-5x {
    font-size: 5rem !important;
  }

  .fs-lg-5qx {
    font-size: 5.25rem !important;
  }

  .fs-lg-5hx {
    font-size: 5.5rem !important;
  }

  .fs-lg-5tx {
    font-size: 5.75rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }

  .d-print-inline-block {
    display: inline-block !important;
  }

  .d-print-block {
    display: block !important;
  }

  .d-print-grid {
    display: grid !important;
  }

  .d-print-table {
    display: table !important;
  }

  .d-print-table-row {
    display: table-row !important;
  }

  .d-print-table-cell {
    display: table-cell !important;
  }

  .d-print-flex {
    display: flex !important;
  }

  .d-print-inline-flex {
    display: inline-flex !important;
  }

  .d-print-none {
    display: none !important;
  }
}
:root,
[data-theme=light] {
  --kt-xs:0;
  --kt-sm:576px;
  --kt-md:768px;
  --kt-lg:992px;
  --kt-xl:1200px;
  --kt-xxl:1400px;
  --kt-white: #ffffff;
  --kt-white-bg-rgb: 255, 255, 255;
  --kt-black: #000000;
  --kt-black-bg-rgb: 0, 0, 0;
  --kt-text-muted: #A1A5B7;
  --kt-gray-100: #f5f8fa;
  --kt-gray-200: #eff2f5;
  --kt-gray-300: #E4E6EF;
  --kt-gray-400: #B5B5C3;
  --kt-gray-500: #A1A5B7;
  --kt-gray-600: #7E8299;
  --kt-gray-700: #5E6278;
  --kt-gray-800: #3F4254;
  --kt-gray-900: #181C32;
  --kt-gray-100-rgb: 245, 248, 250;
  --kt-gray-200-rgb: 239, 242, 245;
  --kt-gray-300-rgb: 228, 230, 239;
  --kt-gray-400-rgb: 181, 181, 195;
  --kt-gray-500-rgb: 161, 165, 183;
  --kt-gray-600-rgb: 126, 130, 153;
  --kt-gray-700-rgb: 94, 98, 120;
  --kt-gray-800-rgb: 63, 66, 84;
  --kt-gray-900-rgb: 24, 28, 50;
  --kt-white: #ffffff;
  --kt-light: #f5f8fa;
  --kt-primary: #009ef7;
  --kt-secondary: #E4E6EF;
  --kt-success: #50cd89;
  --kt-info: #7239ea;
  --kt-warning: #ffc700;
  --kt-danger: #f1416c;
  --kt-dark: #181C32;
  --kt-primary-active: #0095e8;
  --kt-secondary-active: #B5B5C3;
  --kt-light-active: #eff2f5;
  --kt-success-active: #47be7d;
  --kt-info-active: #5014d0;
  --kt-warning-active: #f1bc00;
  --kt-danger-active: #E32539;
  --kt-dark-active: #131628;
  --kt-primary-light: #f1faff;
  --kt-secondary-light: #f5f8fa;
  --kt-success-light: #e8fff3;
  --kt-info-light: #f8f5ff;
  --kt-warning-light: #fff8dd;
  --kt-danger-light: #fff5f8;
  --kt-dark-light: #eff2f5;
  --kt-primary-inverse: #ffffff;
  --kt-secondary-inverse: #3F4254;
  --kt-light-inverse: #7E8299;
  --kt-success-inverse: #ffffff;
  --kt-info-inverse: #ffffff;
  --kt-warning-inverse: #ffffff;
  --kt-danger-inverse: #ffffff;
  --kt-dark-inverse: #ffffff;
  --kt-white-rgb: 255, 255, 255;
  --kt-light-rgb: 245, 248, 250;
  --kt-primary-rgb: 0, 158, 247;
  --kt-secondary-rgb: 228, 230, 239;
  --kt-success-rgb: 80, 205, 137;
  --kt-info-rgb: 114, 57, 234;
  --kt-warning-rgb: 255, 199, 0;
  --kt-danger-rgb: 241, 65, 108;
  --kt-dark-rgb: 24, 28, 50;
  --kt-text-white: #ffffff;
  --kt-text-primary: #009ef7;
  --kt-text-secondary: #E4E6EF;
  --kt-text-light: #f5f8fa;
  --kt-text-success: #50cd89;
  --kt-text-info: #7239ea;
  --kt-text-warning: #ffc700;
  --kt-text-danger: #f1416c;
  --kt-text-dark: #181C32;
  --kt-text-muted: #A1A5B7;
  --kt-text-gray-100: #f5f8fa;
  --kt-text-gray-200: #eff2f5;
  --kt-text-gray-300: #E4E6EF;
  --kt-text-gray-400: #B5B5C3;
  --kt-text-gray-500: #A1A5B7;
  --kt-text-gray-600: #7E8299;
  --kt-text-gray-700: #5E6278;
  --kt-text-gray-800: #3F4254;
  --kt-text-gray-900: #181C32;
  --kt-body-bg: #ffffff;
  --kt-body-bg-rgb: 255, 255, 255;
  --kt-body-color: #181C32;
  --kt-link-color: #009ef7;
  --kt-link-hover-color: #0095e8;
  --kt-border-color: #eff2f5;
  --kt-border-dashed-color: #E4E6EF;
  --kt-component-active-color: #ffffff;
  --kt-component-active-bg: #009ef7;
  --kt-component-hover-color: #009ef7;
  --kt-component-hover-bg: #F4F6FA;
  --kt-component-checked-color: #ffffff;
  --kt-component-checked-bg: #009ef7;
  --kt-box-shadow-xs: 0 0.1rem 0.75rem 0.25rem rgba(0, 0, 0, 0.05);
  --kt-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);
  --kt-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --kt-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);
  --kt-headings-color: #181C32;
  --kt-table-color: #181C32;
  --kt-table-bg: transparent;
  --kt-table-striped-color: #181C32;
  --kt-table-striped-bg: rgba(245, 248, 250, 0.75);
  --kt-table-accent-bg: transparent;
  --kt-table-active-color: #181C32;
  --kt-table-active-bg: #f5f8fa;
  --kt-table-hover-colorr: #181C32;
  --kt-table-hover-bg: #f5f8fa;
  --kt-table-border-color: #eff2f5;
  --kt-table-caption-color: #A1A5B7;
  --kt-table-loading-message-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --kt-table-loading-message-bg: #ffffff;
  --kt-table-loading-message-color: #5E6278;
  --kt-input-btn-focus-color: rgba(0, 158, 247, 0.25);
  --kt-input-btn-focus-box-shadow: 0 0 0 0.25rem rgba(0, 158, 247, 0.25);
  --kt-input-btn-focus-color-opacity: 0.25;
  --kt-input-color: #5E6278;
  --kt-input-placeholder-color: #A1A5B7;
  --kt-input-plaintext-color: #5E6278;
  --kt-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --kt-btn-focus-box-shadow: 0 0 0 0.25rem rgba(0, 158, 247, 0.25);
  --kt-btn-active-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --kt-btn-disabled-opacity: 0.65;
  --kt-btn-link-color: #009ef7;
  --kt-btn-link-hover-color: #0095e8;
  --kt-btn-link-disabled-color: #7E8299;
  --kt-form-label-color: #3F4254;
  --kt-form-text-color: #A1A5B7;
  --kt-input-bg: #ffffff;
  --kt-input-disabled-bg: #eff2f5;
  --kt-input-disabled-color: ;
  --kt-input-disabled-border-color: #E4E6EF;
  --kt-input-color: #5E6278;
  --kt-input-border-color: #E4E6EF;
  --kt-input-focus-bg: #ffffff;
  --kt-input-focus-border-color: #B5B5C3;
  --kt-input-focus-color: #5E6278;
  --kt-input-solid-bg: #f5f8fa;
  --kt-input-solid-bg-focus: #eef3f7;
  --kt-input-solid-placeholder-color: #A1A5B7;
  --kt-input-solid-color: #5E6278;
  --kt-form-check-label-color: #A1A5B7;
  --kt-form-check-label-color-checked: #5E6278;
  --kt-form-check-input-active-filter: brightness(90%);
  --kt-form-check-input-bg: transparent;
  --kt-form-check-input-bg-solid: #eff2f5;
  --kt-form-check-input-border: 1px solid #E4E6EF;
  --kt-form-check-input-focus-border: #B5B5C3;
  --kt-form-check-input-focus-box-shadow: none;
  --kt-form-check-input-checked-color: #ffffff;
  --kt-form-check-input-checked-bg-color: #009ef7;
  --kt-form-check-input-checked-bg-color-solid: #009ef7;
  --kt-form-check-input-checked-border-color: #009ef7;
  --kt-form-check-input-checked-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  --kt-form-check-radio-checked-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  --kt-form-check-input-indeterminate-color: #ffffff;
  --kt-form-check-input-indeterminate-bg-color: #009ef7;
  --kt-form-check-input-indeterminate-border-color: #009ef7;
  --kt-form-check-input-indeterminate-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  --kt-form-check-input-disabled-opacity: 0.5;
  --kt-form-check-label-disabled-opacity: 0.5;
  --kt-form-check-btn-check-disabled-opacity: 0.65;
  --kt-form-switch-color: rgba(0, 0, 0, 0.25);
  --kt-form-switch-color-solid: #ffffff;
  --kt-form-switch-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  --kt-form-switch-bg-image-solid: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  --kt-form-switch-focus-color: #B5B5C3;
  --kt-form-switch-focus-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  --kt-form-switch-checked-color: #ffffff;
  --kt-form-switch-checked-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  --kt-input-group-addon-color: #5E6278;
  --kt-input-group-addon-bg: #f5f8fa;
  --kt-input-group-addon-border-color: #E4E6EF;
  --kt-form-select-color: #5E6278;
  --kt-form-select-bg: #ffffff;
  --kt-form-select-disabled-color: ;
  --kt-form-select-disabled-bg: #eff2f5;
  --kt-form-select-disabled-border-color: #E4E6EF;
  --kt-form-select-indicator-color: #7E8299;
  --kt-form-select-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --kt-form-select-border-color: #E4E6EF;
  --kt-form-select-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --kt-form-select-focus-border-color: #B5B5C3;
  --kt-form-select-focus-box-shadow: 0 0 0 0.25rem rgba(0, 158, 247, 0.25);
  --kt-form-file-button-color: #5E6278;
  --kt-form-file-button-bg: #f5f8fa;
  --kt-form-file-button-hover-bg: shade-color(#f5f8fa, 5%);
  --kt-nav-tabs-border-color: #eff2f5;
  --kt-nav-tabs-link-hover-border-color: #eff2f5 #eff2f5 #eff2f5;
  --kt-nav-tabs-link-active-color: #5E6278;
  --kt-nav-tabs-link-active-bg: #ffffff;
  --kt-nav-tabs-link-active-border-color: #E4E6EF #E4E6EF #ffffff;
  --kt-nav-pills-link-active-color: #ffffff;
  --kt-nav-pills-link-active-bg: #009ef7;
  --kt-dropdown-color: #181C32;
  --kt-dropdown-bg: #ffffff;
  --kt-dropdown-divider-bg: #f5f8fa;
  --kt-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --kt-dropdown-link-color: #181C32;
  --kt-dropdown-link-hover-color: shade-color(#181C32, 10%);
  --kt-dropdown-link-hover-bg: #eff2f5;
  --kt-dropdown-link-active-color: #ffffff;
  --kt-dropdown-link-active-bg: #009ef7;
  --kt-dropdown-link-disabled-color: #A1A5B7;
  --kt-dropdown-header-color: #7E8299;
  --kt-pagination-item-bg: #ffffff;
  --kt-pagination-color: #5E6278;
  --kt-pagination-bg: transparent;
  --kt-pagination-border-color: transparent;
  --kt-pagination-focus-color: #009ef7;
  --kt-pagination-focus-bg: #F4F6FA;
  --kt-pagination-focus-box-shadow: none;
  --kt-pagination-focus-outline: 0;
  --kt-pagination-hover-color: #009ef7;
  --kt-pagination-hover-bg: #F4F6FA;
  --kt-pagination-hover-border-color: transparent;
  --kt-pagination-active-color: #ffffff;
  --kt-pagination-active-bg: #009ef7;
  --kt-pagination-active-border-color: transparent;
  --kt-pagination-disabled-color: #B5B5C3;
  --kt-pagination-disabled-bg: transparent;
  --kt-card-color: ;
  --kt-card-bg: #ffffff;
  --kt-card-box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);
  --kt-card-border-color: #eff2f5;
  --kt-card-border-dashed-color: #E4E6EF;
  --kt-card-cap-bg: transparent;
  --kt-accordion-color: #181C32;
  --kt-accordion-bg: #ffffff;
  --kt-accordion-border-color: #eff2f5;
  --kt-accordion-button-bg: #ffffff;
  --kt-accordion-button-color: #181C32;
  --kt-accordion-button-active-bg: #f5f8fa;
  --kt-accordion-button-active-color: #009ef7;
  --kt-accordion-button-focus-border-color: #eff2f5;
  --kt-accordion-button-focus-box-shadow: none;
  --kt-accordion-icon-color: #181C32;
  --kt-accordion-icon-active-color: #009ef7;
  --kt-accordion-button-icon: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --kt-accordion-button-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --kt-tooltip-color: #3F4254;
  --kt-tooltip-bg: #ffffff;
  --kt-tooltip-opacity: 1;
  --kt-tooltip-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --kt-popover-bg: #ffffff;
  --kt-popover-border-color: #ffffff;
  --kt-popover-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --kt-popover-header-bg: #ffffff;
  --kt-popover-header-color: #3F4254;
  --kt-popover-header-border-color: #eff2f5;
  --kt-popover-body-color: #3F4254;
  --kt-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --kt-dropdown-bg: #ffffff;
  --kt-toast-color: ;
  --kt-toast-background-color: rgba(255, 255, 255, 0.85);
  --kt-toast-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --kt-toast-header-color: #7E8299;
  --kt-toast-header-background-color: rgba(255, 255, 255, 0.85);
  --kt-toast-header-border-color: rgba(0, 0, 0, 0.05);
  --kt-badge-color: #ffffff;
  --kt-modal-bg: #ffffff;
  --kt-modal-color: ;
  --kt-modal-border-color: var(--bs-border-color-translucent);
  --kt-modal-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);
  --kt-modal-content-color: ;
  --kt-modal-content-bg: #ffffff;
  --kt-modal-content-border-color: var(--bs-border-color-translucent);
  --kt-modal-content-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);
  --kt-modal-content-box-shadow-xs: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
  --kt-modal-content-box-shadow-sm-up: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
  --kt-modal-header-border-color: #eff2f5;
  --kt-modal-footer-border-color: #eff2f5;
  --kt-modal-backdrop-bg: #000000;
  --kt-modal-backdrop-opacity: 0.3;
  --kt-progress-bg: #f5f8fa;
  --kt-progress-box-shadow: none;
  --kt-list-group-color: #181C32;
  --kt-list-group-bg: #ffffff;
  --kt-list-group-border-color: rgba(0, 0, 0, 0.125);
  --kt-list-group-hover-bg: #f5f8fa;
  --kt-list-group-active-color: #ffffff;
  --kt-list-group-active-bg: #009ef7;
  --kt-list-group-active-border-colorg: #009ef7;
  --kt-list-group-disabled-color: #7E8299;
  --kt-list-group-disabled-bg: #ffffff;
  --kt-list-group-action-colorg: #5E6278;
  --kt-list-group-action-hover-color: #5E6278;
  --kt-list-group-action-active-color: #181C32;
  --kt-list-group-action-active-bg: #eff2f5;
  --kt-thumbnail-bg: #ffffff;
  --kt-thumbnail-border-color: #eff2f5;
  --kt-thumbnail-box-shadow: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);
  --kt-figure-caption-color: #7E8299;
  --kt-breadcrumb-bg: ;
  --kt-breadcrumb-divider-color: #7E8299;
  --kt-breadcrumb-active-color: #009ef7;
  --kt-carousel-custom-indicator-default-bg-color: #eff2f5;
  --kt-carousel-custom-indicator-active-bg-color: #B5B5C3;
  --kt-carousel-custom-bullet-indicator-default-bg-color: #B5B5C3;
  --kt-carousel-custom-bullet-indicator-active-bg-color: #7E8299;
  --kt-code-bg: #F1F3F8;
  --kt-code-box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);
  --kt-code-color: #b93993;
  --kt-btn-close-color: #000000;
  --kt-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --kt-offcanvas-border-color: var(--bs-border-color-translucent);
  --kt-offcanvas-bg-color: #ffffff;
  --kt-offcanvas-color: ;
  --kt-offcanvas-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
  --kt-offcanvas-backdrop-bg: #000000;
  --kt-offcanvas-backdrop-opacity: 0.3;
  --kt-symbol-label-color: #3F4254;
  --kt-symbol-label-bg: #f5f8fa;
  --kt-symbol-border-color: rgba(255, 255, 255, 0.5);
  --kt-bullet-bg-color: #B5B5C3;
  --kt-scrolltop-opacity: 0;
  --kt-scrolltop-opacity-on: 0.3;
  --kt-scrolltop-opacity-hover: 1;
  --kt-scrolltop-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --kt-scrolltop-bg-color: #009ef7;
  --kt-scrolltop-bg-color-hover: #009ef7;
  --kt-scrolltop-icon-color: #ffffff;
  --kt-scrolltop-icon-color-hover: #ffffff;
  --kt-drawer-box-shadow: 0px 1px 9px -3px rgba(0, 0, 0, 0.05);
  --kt-drawer-bg-color: #ffffff;
  --kt-drawer-overlay-bg-color: rgba(0, 0, 0, 0.2);
  --kt-menu-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --kt-menu-dropdown-bg-color: #ffffff;
  --kt-menu-heading-color: #A1A5B7;
  --kt-menu-link-color-hover: #009ef7;
  --kt-menu-link-color-show: #009ef7;
  --kt-menu-link-color-here: #009ef7;
  --kt-menu-link-color-active: #009ef7;
  --kt-menu-link-bg-color-hover: #F4F6FA;
  --kt-menu-link-bg-color-show: #F4F6FA;
  --kt-menu-link-bg-color-here: #F4F6FA;
  --kt-menu-link-bg-color-active: #F4F6FA;
  --kt-feedback-popup-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);
  --kt-feedback-popup-background-color: #ffffff;
  --kt-scrollbar-color: #eff2f5;
  --kt-scrollbar-hover-color: #e9edf1;
  --kt-scrollbar-width: 0.4rem;
  --kt-scrollbar-height: 0.4rem;
  --kt-scrollbar-space: 0.5rem;
  --kt-overlay-bg: rgba(0, 0, 0, 0.05);
  --kt-blockui-overlay-bg: rgba(0, 0, 0, 0.05);
  --kt-rating-color-default: #B5B5C3;
  --kt-rating-color-active: #FFAD0F;
  --kt-ribbon-label-box-shadow: 0px -1px 5px 0px rgba(24, 28, 50, 0.1);
  --kt-ribbon-label-bg: #009ef7;
  --kt-ribbon-label-border-color: #005d91;
  --kt-ribbon-clip-bg: #181C32;
  --kt-engage-btn-bg: #ffffff;
  --kt-engage-btn-color: #7E8299;
  --kt-engage-btn-color-active: #3F4254;
}

[data-theme=dark] {
  --kt-text-muted: #565674;
  --kt-gray-100: #1b1b29;
  --kt-gray-200: #2B2B40;
  --kt-gray-300: #323248;
  --kt-gray-400: #474761;
  --kt-gray-500: #565674;
  --kt-gray-600: #6D6D80;
  --kt-gray-700: #92929F;
  --kt-gray-800: #CDCDDE;
  --kt-gray-900: #FFFFFF;
  --kt-gray-100-rgb: 27, 27, 41;
  --kt-gray-200-rgb: 43, 43, 64;
  --kt-gray-300-rgb: 50, 50, 72;
  --kt-gray-400-rgb: 71, 71, 97;
  --kt-gray-500-rgb: 86, 86, 116;
  --kt-gray-600-rgb: 109, 109, 128;
  --kt-gray-700-rgb: 146, 146, 159;
  --kt-gray-800-rgb: 205, 205, 222;
  --kt-gray-900-rgb: 255, 255, 255;
  --kt-dark: #FFFFFF;
  --kt-light: #2B2B40;
  --kt-secondary: #323248;
  --kt-dark-active: white;
  --kt-light-active: #323248;
  --kt-secondary-active: #474761;
  --kt-primary-light: #212e48;
  --kt-success-light: #1c3238;
  --kt-info-light: #2f264f;
  --kt-warning-light: #392f28;
  --kt-danger-light: #3a2434;
  --kt-dark-light: #2B2B40;
  --kt-secondary-light: #1b1b29;
  --kt-dark-inverse: #1b1b29;
  --kt-light-inverse: #6D6D80;
  --kt-secondary-inverse: #CDCDDE;
  --kt-dark-rgb: 255, 255, 255;
  --kt-light-rgb: 43, 43, 64;
  --kt-secondary-rgb: 50, 50, 72;
  --kt-text-dark: #FFFFFF;
  --kt-text-muted: #565674;
  --kt-text-secondary: #323248;
  --kt-text-gray-100: #1b1b29;
  --kt-text-gray-200: #2B2B40;
  --kt-text-gray-300: #323248;
  --kt-text-gray-400: #474761;
  --kt-text-gray-500: #565674;
  --kt-text-gray-600: #6D6D80;
  --kt-text-gray-700: #92929F;
  --kt-text-gray-800: #CDCDDE;
  --kt-text-gray-900: #FFFFFF;
  --kt-body-bg: #1e1e2d;
  --kt-body-bg-rgb: 30, 30, 45;
  --kt-body-color: #FFFFFF;
  --kt-link-color: #009ef7;
  --kt-link-hover-color: #0095e8;
  --kt-border-color: #2B2B40;
  --kt-border-dashed-color: #323248;
  --kt-component-active-color: #ffffff;
  --kt-component-active-bg: #009ef7;
  --kt-component-hover-color: #009ef7;
  --kt-component-hover-bg: #2B2B40;
  --kt-component-checked-color: #ffffff;
  --kt-component-checked-bg: #009ef7;
  --kt-box-shadow-xs: 0 0.1rem 0.75rem 0.25rem rgba(0, 0, 0, 0.05);
  --kt-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);
  --kt-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --kt-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);
  --kt-headings-color: #FFFFFF;
  --kt-table-color: #FFFFFF;
  --kt-table-bg: transparent;
  --kt-table-striped-color: #FFFFFF;
  --kt-table-striped-bg: rgba(27, 27, 41, 0.75);
  --kt-table-accent-bg: transparent;
  --kt-table-active-color: #FFFFFF;
  --kt-table-active-bg: #1b1b29;
  --kt-table-hover-colorr: #FFFFFF;
  --kt-table-hover-bg: #1b1b29;
  --kt-table-border-color: #2B2B40;
  --kt-table-caption-color: #565674;
  --kt-table-loading-message-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --kt-table-loading-message-bg: #2B2B40;
  --kt-table-loading-message-color: #92929F;
  --kt-input-btn-focus-color: rgba(0, 158, 247, 0.25);
  --kt-input-btn-focus-box-shadow: ;
  --kt-input-btn-focus-color-opacity: 0.25;
  --kt-input-color: #92929F;
  --kt-input-placeholder-color: #565674;
  --kt-input-plaintext-color: #92929F;
  --kt-btn-box-shadow: ;
  --kt-btn-focus-box-shadow: ;
  --kt-btn-active-box-shadow: ;
  --kt-btn-disabled-opacity: 0.65;
  --kt-btn-link-color: #009ef7;
  --kt-btn-link-hover-color: #0095e8;
  --kt-btn-link-disabled-color: #6D6D80;
  --kt-form-label-color: #CDCDDE;
  --kt-form-text-color: #565674;
  --kt-input-bg: #1e1e2d;
  --kt-input-disabled-bg: #2B2B40;
  --kt-input-disabled-color: ;
  --kt-input-disabled-border-color: #323248;
  --kt-input-color: #92929F;
  --kt-input-border-color: #323248;
  --kt-input-focus-bg: #1e1e2d;
  --kt-input-focus-border-color: #474761;
  --kt-input-focus-color: #92929F;
  --kt-input-solid-bg: #1b1b29;
  --kt-input-solid-bg-focus: #1f1f2f;
  --kt-input-solid-placeholder-color: #565674;
  --kt-input-solid-color: #92929F;
  --kt-form-check-label-color: #565674;
  --kt-form-check-label-color-checked: #92929F;
  --kt-form-check-input-active-filter: brightness(90%);
  --kt-form-check-input-bg: transparent;
  --kt-form-check-input-bg-solid: #2B2B40;
  --kt-form-check-input-border: 1px solid #323248;
  --kt-form-check-input-focus-border: #474761;
  --kt-form-check-input-focus-box-shadow: none;
  --kt-form-check-input-checked-color: #ffffff;
  --kt-form-check-input-checked-bg-color: #009ef7;
  --kt-form-check-input-checked-border-color: #009ef7;
  --kt-form-check-input-checked-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  --kt-form-check-radio-checked-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  --kt-form-check-input-indeterminate-color: #ffffff;
  --kt-form-check-input-indeterminate-bg-color: #009ef7;
  --kt-form-check-input-indeterminate-border-color: #009ef7;
  --kt-form-check-input-indeterminate-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  --kt-form-check-input-disabled-opacity: 0.5;
  --kt-form-check-label-disabled-opacity: 0.5;
  --kt-form-check-btn-check-disabled-opacity: 0.65;
  --kt-form-switch-color: rgba(255, 255, 255, 0.25);
  --kt-form-switch-color-solid: #A1A5B7;
  --kt-form-switch-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --kt-form-switch-bg-image-solid: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  --kt-form-switch-focus-color: #474761;
  --kt-form-switch-focus-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  --kt-form-switch-checked-color: #ffffff;
  --kt-form-switch-checked-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  --kt-input-group-addon-color: #92929F;
  --kt-input-group-addon-bg: #1b1b29;
  --kt-input-group-addon-border-color: #323248;
  --kt-form-select-color: #92929F;
  --kt-form-select-bg: #1e1e2d;
  --kt-form-select-disabled-color: ;
  --kt-form-select-disabled-bg: #2B2B40;
  --kt-form-select-disabled-border-color: #323248;
  --kt-form-select-indicator-color: #6D6D80;
  --kt-form-select-indicator: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  --kt-form-select-border-color: #323248;
  --kt-form-select-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --kt-form-select-focus-border-color: #474761;
  --kt-form-select-focus-box-shadow: 0 0 0 0.25rem rgba(0, 158, 247, 0.25);
  --kt-form-file-button-color: #92929F;
  --kt-form-file-button-bg: #1b1b29;
  --kt-form-file-button-hover-bg: shade-color(#1b1b29, 5%);
  --kt-nav-tabs-border-color: #2B2B40;
  --kt-nav-tabs-link-hover-border-color: #2B2B40 #2B2B40 #2B2B40;
  --kt-nav-tabs-link-active-color: #92929F;
  --kt-nav-tabs-link-active-bg: #1e1e2d;
  --kt-nav-tabs-link-active-border-color: #323248 #323248 #1e1e2d;
  --kt-nav-pills-link-active-color: #ffffff;
  --kt-nav-pills-link-active-bg: #009ef7;
  --kt-dropdown-color: #FFFFFF;
  --kt-dropdown-bg: #1e1e2d;
  --kt-dropdown-divider-bg: #1b1b29;
  --kt-dropdown-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --kt-dropdown-link-color: #FFFFFF;
  --kt-dropdown-link-hover-color: shade-color(#FFFFFF, 10%);
  --kt-dropdown-link-hover-bg: #2B2B40;
  --kt-dropdown-link-active-color: #ffffff;
  --kt-dropdown-link-active-bg: #009ef7;
  --kt-dropdown-link-disabled-color: #565674;
  --kt-dropdown-header-color: #6D6D80;
  --kt-pagination-item-bg: #1e1e2d;
  --kt-pagination-color: #92929F;
  --kt-pagination-bg: transparent;
  --kt-pagination-border-color: transparent;
  --kt-pagination-focus-color: #009ef7;
  --kt-pagination-focus-bg: #2B2B40;
  --kt-pagination-focus-box-shadow: none;
  --kt-pagination-focus-outline: 0;
  --kt-pagination-hover-color: #009ef7;
  --kt-pagination-hover-bg: #2B2B40;
  --kt-pagination-hover-border-color: transparent;
  --kt-pagination-active-color: #ffffff;
  --kt-pagination-active-bg: #009ef7;
  --kt-pagination-active-border-color: transparent;
  --kt-pagination-disabled-color: #474761;
  --kt-pagination-disabled-bg: transparent;
  --kt-card-bg: #1e1e2d;
  --kt-card-color: ;
  --kt-card-box-shadow: none;
  --kt-card-border-color: #2B2B40;
  --kt-card-border-dashed-color: #323248;
  --kt-card-cap-bg: transparent;
  --kt-accordion-color: #FFFFFF;
  --kt-accordion-bg: #1e1e2d;
  --kt-accordion-border-color: #2B2B40;
  --kt-accordion-button-color: #FFFFFF;
  --kt-accordion-button-bg: #1e1e2d;
  --kt-accordion-button-active-bg: #1b1b29;
  --kt-accordion-button-active-color: #009ef7;
  --kt-accordion-button-focus-border-color: #2B2B40;
  --kt-accordion-button-focus-box-shadow: none;
  --kt-accordion-icon-color: #FFFFFF;
  --kt-accordion-icon-active-color: #009ef7;
  --kt-accordion-button-icon: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  --kt-accordion-button-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  --kt-tooltip-color: #CDCDDE;
  --kt-tooltip-bg: #2B2B40;
  --kt-tooltip-opacity: 1;
  --kt-tooltip-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --kt-popover-bg: #2B2B40;
  --kt-popover-border-color: #2B2B40;
  --kt-popover-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --kt-popover-header-bg: #2B2B40;
  --kt-popover-header-color: #CDCDDE;
  --kt-popover-header-border-color: #323248;
  --kt-popover-body-color: #CDCDDE;
  --kt-dropdown-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --kt-dropdown-bg: #1e1e2d;
  --kt-toast-color: ;
  --kt-toast-background-color: rgba(0, 0, 0, 0.85);
  --kt-toast-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --kt-toast-header-color: #6D6D80;
  --kt-toast-header-background-color: rgba(0, 0, 0, 0.85);
  --kt-toast-header-border-color: rgba(255, 255, 255, 0.05);
  --kt-badge-color: #1e1e2d;
  --kt-modal-bg: #1e1e2d;
  --kt-modal-color: ;
  --kt-modal-border-color: ;
  --kt-modal-box-shadow: 0 0.25rem 0.5rem rgba(255, 255, 255, 0.05);
  --kt-modal-content-color: ;
  --kt-modal-content-bg: #1e1e2d;
  --kt-modal-content-border-color: ;
  --kt-modal-content-box-shadow: 0 0.25rem 0.5rem rgba(255, 255, 255, 0.05);
  --kt-modal-content-box-shadow-xs: 0 0.25rem 0.5rem rgba(255, 255, 255, 0.1);
  --kt-modal-content-box-shadow-sm-up: 0 0.5rem 1rem rgba(255, 255, 255, 0.1);
  --kt-modal-header-border-color: #2B2B40;
  --kt-modal-footer-border-color: #2B2B40;
  --kt-modal-backdrop-bg: #000000;
  --kt-modal-backdrop-opacity: 0.4;
  --kt-progress-bg: #1b1b29;
  --kt-progress-box-shadow: none;
  --kt-list-group-color: #FFFFFF;
  --kt-list-group-bg: #000000;
  --kt-list-group-border-color: rgba(255, 255, 255, 0.125);
  --kt-list-group-hover-bg: #f5f8fa;
  --kt-list-group-active-color: #ffffff;
  --kt-list-group-active-bg: #009ef7;
  --kt-list-group-active-border-colorg: #009ef7;
  --kt-list-group-disabled-color: #6D6D80;
  --kt-list-group-disabled-bg: #000000;
  --kt-list-group-action-colorg: #92929F;
  --kt-list-group-action-hover-color: #92929F;
  --kt-list-group-action-active-color: #FFFFFF;
  --kt-list-group-action-active-bg: #2B2B40;
  --kt-thumbnail-bg: #1e1e2d;
  --kt-thumbnail-border-color: #2B2B40;
  --kt-thumbnail-box-shadow: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);
  --kt-figure-caption-color: #6D6D80;
  --kt-breadcrumb-bg: ;
  --kt-breadcrumb-divider-color: #6D6D80;
  --kt-breadcrumb-active-color: #009ef7;
  --kt-carousel-custom-indicator-default-bg-color: #2B2B40;
  --kt-carousel-custom-indicator-active-bg-color: #474761;
  --kt-arousel-custom-bullet-indicator-default-bg-color: #474761;
  --kt-carousel-custom-bullet-indicator-active-bg-color: #6D6D80;
  --kt-btn-close-color: #ffffff;
  --kt-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  --kt-code-bg: #2B2B40;
  --kt-code-box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);
  --kt-code-color: #b93993;
  --kt-offcanvas-border-color: ;
  --kt-offcanvas-bg-color: #1e1e2d;
  --kt-offcanvas-color: ;
  --kt-offcanvas-box-shadow: 0 0.25rem 0.5rem rgba(255, 255, 255, 0.1);
  --kt-offcanvas-backdrop-bg: #000000;
  --kt-offcanvas-backdrop-opacity: 0.4;
  --kt-code-bg: #2B2B40;
  --kt-code-box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);
  --kt-code-color: #b93993;
  --kt-symbol-label-color: #CDCDDE;
  --kt-symbol-label-bg: #1b1b29;
  --kt-symbol-border-color: rgba(255, 255, 255, 0.5);
  --kt-bullet-bg-color: #474761;
  --kt-scrolltop-opacity: 0;
  --kt-scrolltop-opacity-on: 0.3;
  --kt-scrolltop-opacity-hover: 1;
  --kt-scrolltop-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);
  --kt-scrolltop-bg-color: #009ef7;
  --kt-scrolltop-bg-color-hover: #009ef7;
  --kt-scrolltop-icon-color: #ffffff;
  --kt-scrolltop-icon-color-hover: #ffffff;
  --kt-drawer-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  --kt-drawer-bg-color: #1e1e2d;
  --kt-drawer-overlay-bg-color: rgba(0, 0, 0, 0.4);
  --kt-menu-dropdown-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --kt-menu-dropdown-bg-color: #1e1e2d;
  --kt-menu-heading-color: #565674;
  --kt-menu-link-color-hover: #009ef7;
  --kt-menu-link-color-show: #009ef7;
  --kt-menu-link-color-here: #009ef7;
  --kt-menu-link-color-active: #009ef7;
  --kt-menu-link-bg-color-hover: #2B2B40;
  --kt-menu-link-bg-color-show: #2B2B40;
  --kt-menu-link-bg-color-here: #2B2B40;
  --kt-menu-link-bg-color-active: #2B2B40;
  --kt-feedback-popup-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);
  --kt-feedback-popup-background-color: #1e1e2d;
  --kt-scrollbar-color: #2B2B40;
  --kt-scrollbar-hover-color: #27273a;
  --kt-overlay-bg: rgba(255, 255, 255, 0.05);
  --kt-blockui-overlay-bg: rgba(255, 255, 255, 0.05);
  --kt-rating-color-default: #474761;
  --kt-rating-color-active: #FFAD0F;
  --kt-ribbon-label-box-shadow: 0px -1px 5px 0px rgba(255, 255, 255, 0.1);
  --kt-ribbon-label-bg: #009ef7;
  --kt-ribbon-label-border-color: #005d91;
  --kt-ribbon-clip-bg: #f5f8fa;
  --kt-engage-btn-bg: #2B2B40;
  --kt-engage-btn-color: #6D6D80;
  --kt-engage-btn-color-active: #CDCDDE;
}

[data-theme=dark] {
  --bs-gray-100: #1b1b29;
  --bs-gray-200: #2B2B40;
  --bs-gray-300: #323248;
  --bs-gray-400: #474761;
  --bs-gray-500: #565674;
  --bs-gray-600: #6D6D80;
  --bs-gray-700: #92929F;
  --bs-gray-800: #CDCDDE;
  --bs-gray-900: #FFFFFF;
  --bs-dark: #FFFFFF;
  --bs-light: #2B2B40;
  --bs-secondary: #323248;
  --bs-body-color-rgb: 255, 255, 255;
  --bs-body-bg-rgb: 30, 30, 45;
  --bs-body-color: #FFFFFF;
  --bs-body-bg: #1e1e2d;
  --bs-border-color: #2B2B40;
  --bs-heading-color: #FFFFFF;
  --bs-link-color: #009ef7;
  --bs-link-hover-color: #0095e8;
  --bs-code-color: #b93993;
}

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  color: var(--kt-headings-color);
  outline: 0;
}

.blockquote-footer {
  color: var(--kt-blockquote-footer-color);
}

[data-kt-theme-mode-switching=true] * {
  transition: none !important;
}

html:not([data-theme=dark]) .theme-dark-show {
  display: none !important;
}
html:not([data-theme=dark]) .theme-light-bg-transparent {
  background-color: transparent !important;
}
html:not([data-theme=dark]) .theme-light-bg-body {
  background-color: var(--kt-body-bg) !important;
}

[data-theme=dark] .theme-light-show {
  display: none !important;
}
[data-theme=dark] .theme-dark-bg-transparent {
  background-color: transparent !important;
}
[data-theme=dark] .theme-dark-bg-body {
  background-color: var(--kt-body-bg) !important;
}

.animation {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes animationSlideInDown {
  from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animation-slide-in-down {
  animation-name: animationSlideInDown;
}

@keyframes animationSlideInUp {
  from {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}
.animation-slide-in-up {
  animation-name: animationSlideInUp;
}

@keyframes animationFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.animation-fade-in {
  animation-name: animationFadeIn;
}

@keyframes animationFadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.animation-fade-out {
  animation-name: animationFadeOut;
}

.animation-blink {
  animation: animationBlink 1s steps(5, start) infinite;
}

@keyframes animationBlink {
  to {
    visibility: hidden;
  }
}
.animation-breathe {
  animation: breathe 1.5s ease-in-out infinite alternate;
}

@keyframes breathe {
  from {
    opacity: 0.3;
  }
  to {
    opacity: 1;
  }
}
.alert-white {
  color: var(--kt-white);
  border-color: var(--kt-white);
  background-color: var(--kt-white-light);
}
.alert-white .alert-link {
  color: var(--kt-white);
}

.alert-light {
  color: var(--kt-light);
  border-color: var(--kt-light);
  background-color: var(--kt-light-light);
}
.alert-light .alert-link {
  color: var(--kt-light);
}

.alert-primary {
  color: var(--kt-primary);
  border-color: var(--kt-primary);
  background-color: var(--kt-primary-light);
}
.alert-primary .alert-link {
  color: var(--kt-primary);
}

.alert-secondary {
  color: var(--kt-secondary);
  border-color: var(--kt-secondary);
  background-color: var(--kt-secondary-light);
}
.alert-secondary .alert-link {
  color: var(--kt-secondary);
}

.alert-success {
  color: var(--kt-success);
  border-color: var(--kt-success);
  background-color: var(--kt-success-light);
}
.alert-success .alert-link {
  color: var(--kt-success);
}

.alert-info {
  color: var(--kt-info);
  border-color: var(--kt-info);
  background-color: var(--kt-info-light);
}
.alert-info .alert-link {
  color: var(--kt-info);
}

.alert-warning {
  color: var(--kt-warning);
  border-color: var(--kt-warning);
  background-color: var(--kt-warning-light);
}
.alert-warning .alert-link {
  color: var(--kt-warning);
}

.alert-danger {
  color: var(--kt-danger);
  border-color: var(--kt-danger);
  background-color: var(--kt-danger-light);
}
.alert-danger .alert-link {
  color: var(--kt-danger);
}

.alert-dark {
  color: var(--kt-dark);
  border-color: var(--kt-dark);
  background-color: var(--kt-dark-light);
}
.alert-dark .alert-link {
  color: var(--kt-dark);
}

.list-group {
  --bs-list-group-color: var(--kt-list-group-color);
  --bs-list-group-bg: var(--kt-list-group-bg);
  --bs-list-group-border-color: var(--kt-list-group-border-color);
  --bs-list-group-action-color: var(--kt-list-group-action-color);
  --bs-list-group-action-hover-color: var(--kt-list-group-action-hover-color);
  --bs-list-group-action-hover-bg: var(--kt-list-group-hover-bg);
  --bs-list-group-action-active-color: var(--kt-list-group-action-active-color);
  --bs-list-group-action-active-bg: var(--kt-list-group-action-active-bg);
  --bs-list-group-disabled-color: var(--kt-list-group-disabled-color);
  --bs-list-group-disabled-bg: var(--kt-list-group-disabled-bg);
  --bs-list-group-active-color: var(--kt-list-group-active-color);
  --bs-list-group-active-bg: var(--kt-list-group-active-bg);
  --bs-list-group-active-border-color: var(--kt-list-group-active-border-color);
}

.img-thumbnail {
  background-color: var(--kt-thumbnail-bg);
  border: 1px solid var(--kt-thumbnail-border-color);
  box-shadow: var(--kt-thumbnail-box-shadow);
}

.figure-caption {
  color: var(--kt-figure-caption-color);
}

.btn-group.show .dropdown-toggle {
  box-shadow: var(--kt-btn-active-box-shadow);
}

.dropdown-menu {
  --bs-dropdown-color: var(--kt-dropdown-color);
  --bs-dropdown-bg: var(--kt-dropdown-bg);
  --bs-dropdown-border-color: var(--kt-dropdown-border-color);
  --bs-dropdown-divider-bg: var(--kt-dropdown-divider-bg);
  --bs-dropdown-box-shadow: var(--kt-dropdown-box-shadow);
  --bs-dropdown-link-color: var(--kt-dropdown-link-color);
  --bs-dropdown-link-hover-color: var(--kt-dropdown-link-hover-color);
  --bs-dropdown-link-hover-bg: var(--kt-dropdown-link-hover-bg);
  --bs-dropdown-link-active-color: var(--kt-dropdown-link-active-color);
  --bs-dropdown-link-active-bg: var(--kt-dropdown-link-active-bg);
  --bs-dropdown-link-disabled-color: var(--kt-dropdown-link-disabled-color);
  --bs-dropdown-header-color: var(--kt-dropdown-header-color);
}

.toast {
  --bs-toast-color: var(--kt-toast-color);
  --bs-toast-bg: var(--kt-toast-background-color);
  --bs-toast-border-color: var(--kt-toast-border-color);
  --bs-toast-box-shadow: var(--kt-toast-box-shadow);
  --bs-toast-header-color: var(--kt-toast-header-color);
  --bs-toast-header-bg: var(--kt-toast-header-background-color);
  --bs-toast-header-border-color: var(--kt-toast-header-border-color);
}
.toast .toast-header .btn-close {
  margin-right: 0;
}

.btn-close {
  color: var(--kt-btn-close-color);
  background-image: var(--kt-btn-close-bg);
  background-position: center;
}
.btn-close:hover {
  color: var(--kt-btn-close-color);
}

.offcanvas-sm, .offcanvas-md, .offcanvas-lg, .offcanvas-xl, .offcanvas-xxl, .offcanvas {
  --bs-offcanvas-color: var(--kt-offcanvas-color);
  --bs-offcanvas-bg: var(--kt-offcanvas-bg-color);
  --bs-offcanvas-border-color: var(--kt-offcanvas-border-color);
  --bs-offcanvas-box-shadow: var(--kt-offcanvas-box-shadow);
}

.nav {
  --bs-nav-link-color: var(--kt-nav-link-color);
  --bs-nav-link-hover-color: var(--kt-nav-link-hover-color);
  --bs-nav-link-disabled-color: var(--kt-nav-link-disabled-color);
}

.nav-tabs {
  --bs-nav-tabs-border-color: var(--kt-nav-tabs-border-color);
  --bs-nav-tabs-link-hover-border-color: var(--kt-nav-tabs-link-hover-border-color);
  --bs-nav-tabs-link-active-color: var(--kt-nav-tabs-link-active-color);
  --bs-nav-tabs-link-active-bg: var(--kt-nav-tabs-link-active-bg);
  --bs-nav-tabs-link-active-border-color: var(--kt-nav-tabs-link-active-border-color);
}

.nav-pills {
  --bs-nav-pills-link-active-color: var(--kt-nav-pills-link-active-color);
  --bs-nav-pills-link-active-bg: var(--kt-nav-pills-link-active-bg);
}

.nav-pills .nav-item {
  margin-right: 0.5rem;
}
.nav-pills .nav-item:last-child {
  margin-right: 0;
}

.nav-stretch {
  align-items: stretch;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.nav-stretch .nav-item {
  display: flex;
  align-items: stretch;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.nav-stretch .nav-link {
  display: flex;
  align-items: center;
}

.nav-group {
  padding: 0.35rem;
  border-radius: 0.475rem;
  background-color: var(--kt-gray-100);
}
.nav-group.nav-group-outline {
  background-color: transparent;
  border: 1px solid var(--kt-border-color);
}
.nav-group.nav-group-fluid {
  display: flex;
}
.nav-group.nav-group-fluid > label,
.nav-group.nav-group-fluid > .btn {
  position: relative;
  flex-shrink: 0;
  flex-grow: 1;
  flex-basis: 0;
}
.nav-group.nav-group-fluid > label {
  margin-right: 0.1rem;
}
.nav-group.nav-group-fluid > label > .btn {
  width: 100%;
}
.nav-group.nav-group-fluid > label:last-child {
  margin-right: 0;
}

.nav-line-tabs {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: var(--kt-border-color);
}
.nav-line-tabs .nav-item {
  margin-bottom: -1px;
}
.nav-line-tabs .nav-item .nav-link {
  color: var(--kt-gray-500);
  border: 0;
  border-bottom: 1px solid transparent;
  transition: color 0.2s ease;
  padding: 0.5rem 0;
  margin: 0 1rem;
}
.nav-line-tabs .nav-item:first-child .nav-link {
  margin-left: 0;
}
.nav-line-tabs .nav-item:last-child .nav-link {
  margin-right: 0;
}
.nav-line-tabs .nav-item .nav-link.active,
.nav-line-tabs .nav-item.show .nav-link,
.nav-line-tabs .nav-item .nav-link:hover:not(.disabled) {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid var(--kt-primary);
  transition: color 0.2s ease;
}
.nav-line-tabs.nav-line-tabs-2x {
  border-bottom-width: 2px;
}
.nav-line-tabs.nav-line-tabs-2x .nav-item {
  margin-bottom: -2px;
}
.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link {
  border-bottom-width: 2px;
}
.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link.active,
.nav-line-tabs.nav-line-tabs-2x .nav-item.show .nav-link,
.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link:hover:not(.disabled) {
  border-bottom-width: 2px;
}

.nav.nav-pills.nav-pills-custom .show > .nav-link,
.nav.nav-pills.nav-pills-custom .nav-link {
  border: 1px dashed var(--kt-border-dashed-color);
  border-radius: 0.625rem;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link.nav-link-border-solid,
.nav.nav-pills.nav-pills-custom .nav-link.nav-link-border-solid {
  border: 3px solid var(--kt-border-dashed-color);
}
.nav.nav-pills.nav-pills-custom .show > .nav-link.nav-link-border-solid.active,
.nav.nav-pills.nav-pills-custom .nav-link.nav-link-border-solid.active {
  border: 3px solid var(--kt-primary);
}
.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img,
.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img {
  width: 30px;
  transition: color 0.2s ease;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.default,
.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.default {
  display: inline-block;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.active,
.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.active {
  display: none;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link.active,
.nav.nav-pills.nav-pills-custom .nav-link.active {
  background-color: transparent;
  border: 1px solid var(--kt-border-dashed-color);
  transition-duration: 1ms;
  position: relative;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link.active .nav-text,
.nav.nav-pills.nav-pills-custom .nav-link.active .nav-text {
  color: var(--kt-gray-800) !important;
  transition: color 0.2s ease;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link.active .bullet-custom,
.nav.nav-pills.nav-pills-custom .nav-link.active .bullet-custom {
  display: block;
}
.nav.nav-pills.nav-pills-custom .show > .nav-link .bullet-custom,
.nav.nav-pills.nav-pills-custom .nav-link .bullet-custom {
  display: none;
}
.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:not(:active) span:nth-child(1) {
  color: #B5B5C3;
}
.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:not(:active) span:nth-child(2) {
  color: #3F4254;
}
.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:hover span:nth-child(1) {
  color: #ffffff !important;
}
.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:hover span:nth-child(2) {
  color: #ffffff !important;
}
.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link.active span:nth-child(1) {
  color: #ffffff !important;
}
.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link.active span:nth-child(2) {
  color: #ffffff !important;
}

.pagination {
  --bs-pagination-color: var(--kt-pagination-color);
  --bs-pagination-bg: var(--kt-pagination-bg);
  --bs-pagination-border-color: var(--kt-pagination-border-color);
  --bs-pagination-hover-color: var(--kt-pagination-hover-color);
  --bs-pagination-hover-bg: var(--kt-pagination-hover-bg);
  --bs-pagination-hover-border-color: var(--kt-pagination-hover-border-color);
  --bs-pagination-focus-color: var(--kt-pagination-focus-color);
  --bs-pagination-focus-bg: var(--kt-pagination-focus-bg);
  --bs-pagination-focus-box-shadow: var(--kt-pagination-focus-box-shadow);
  --bs-pagination-active-color: var(--kt-pagination-active-color);
  --bs-pagination-active-bg: var(--kt-pagination-active-bg);
  --bs-pagination-active-border-color: var(--kt-pagination-active-border-color);
  --bs-pagination-disabled-color: var(--kt-pagination-disabled-color);
  --bs-pagination-disabled-bg: var(--kt-pagination-disabled-bg);
  --bs-pagination-disabled-border-color: var(--kt-pagination-disabled-border-color);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0;
}
.pagination.pagination-circle .page-link {
  border-radius: 50%;
}
.pagination.pagination-outline .page-link {
  border: 1px solid var(--kt-border-color);
}
.pagination.pagination-outline .page-item:hover:not(.disabled) .page-link, .pagination.pagination-outline .page-item.active .page-link {
  border-color: var(--kt-primary-light);
}

.page-item {
  margin-right: 0.5rem;
  /*rtl:end:ignore*/
}
.page-item:last-child {
  margin-right: 0;
}
.page-item .page-link {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.475rem;
  height: 2.5rem;
  min-width: 2.5rem;
  font-weight: 500;
  font-size: 1.075rem;
  /*rtl:options:{"autoRename":false}*/
  /*rtl:end:ignore*/
  /*rtl:options:{"autoRename":false}*/
}
.page-item .page-link i {
  font-size: 0.85rem;
}
.page-item .page-link .previous,
.page-item .page-link .next {
  display: block;
  height: 0.875rem;
  width: 0.875rem;
  /*rtl:raw:transform: rotateZ(-180deg);*/
}
.page-item .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: #5E6278;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
}
.page-item .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: #5E6278;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
}
.page-item:focus .page-link {
  color: var(--kt-pagination-focus-color);
  /*rtl:options:{"autoRename":false}*/
}
.page-item:focus .page-link .svg-icon,
.page-item:focus .page-link i {
  color: var(--kt-pagination-focus-color);
}
.page-item:focus .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-pagination-focus-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
}
.page-item:focus .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-pagination-focus-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
}
.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link {
  color: var(--kt-pagination-hover-color);
  /*rtl:options:{"autoRename":false}*/
}
.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link.page-text {
  background-color: transparent;
}
.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .svg-icon,
.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link i {
  color: var(--kt-pagination-hover-color);
}
.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-pagination-hover-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
}
.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-pagination-hover-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
}
.page-item.active .page-link {
  color: var(--kt-pagination-active-color);
  /*rtl:options:{"autoRename":false}*/
}
.page-item.active .page-link.page-text {
  background-color: transparent;
}
.page-item.active .page-link .svg-icon,
.page-item.active .page-link i {
  color: var(--kt-pagination-active-color);
}
.page-item.active .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-pagination-active-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}
.page-item.active .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-pagination-active-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
}
.page-item.disabled .page-link {
  color: var(--kt-pagination-disabled-color);
  /*rtl:options:{"autoRename":false}*/
}
.page-item.disabled .page-link .svg-icon,
.page-item.disabled .page-link i {
  color: var(--kt-pagination-disabled-color);
}
.page-item.disabled .page-link .previous {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-pagination-disabled-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
}
.page-item.disabled .page-link .next {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-pagination-disabled-color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_31___});
}

@media (max-width: 991.98px) {
  .page-item {
    margin-right: 0.25rem;
  }
  .page-item:last-child {
    margin-right: 0;
  }
}
.separator {
  display: block;
  height: 0;
  border-bottom: 1px solid var(--kt-border-color);
}
.separator.separator-dotted {
  border-bottom-style: dotted;
  border-bottom-color: var(--kt-border-dashed-color);
}
.separator.separator-dashed {
  border-bottom-style: dashed;
  border-bottom-color: var(--kt-border-dashed-color);
}
.separator.separator-content {
  display: flex;
  align-items: center;
  border-bottom: 0;
  text-align: center;
}
.separator.separator-content::before, .separator.separator-content::after {
  content: " ";
  width: 50%;
  border-bottom: 1px solid var(--kt-border-color);
}
.separator.separator-content::before {
  margin-right: 1.25rem;
}
.separator.separator-content::after {
  margin-left: 1.25rem;
}
.separator.separator-content.separator-dotted::before, .separator.separator-content.separator-dotted::after {
  border-bottom-style: dotted;
  border-bottom-color: var(--kt-border-dashed-color);
}
.separator.separator-content.separator-dashed::before, .separator.separator-content.separator-dashed::after {
  border-bottom-style: dashed;
  border-bottom-color: var(--kt-border-dashed-color);
}
.separator.separator-content.border-white::before, .separator.separator-content.border-white::after {
  border-color: #ffffff !important;
}
.separator.separator-content.border-light::before, .separator.separator-content.border-light::after {
  border-color: #f5f8fa !important;
}
.separator.separator-content.border-primary::before, .separator.separator-content.border-primary::after {
  border-color: #009ef7 !important;
}
.separator.separator-content.border-secondary::before, .separator.separator-content.border-secondary::after {
  border-color: #E4E6EF !important;
}
.separator.separator-content.border-success::before, .separator.separator-content.border-success::after {
  border-color: #50cd89 !important;
}
.separator.separator-content.border-info::before, .separator.separator-content.border-info::after {
  border-color: #7239ea !important;
}
.separator.separator-content.border-warning::before, .separator.separator-content.border-warning::after {
  border-color: #ffc700 !important;
}
.separator.separator-content.border-danger::before, .separator.separator-content.border-danger::after {
  border-color: #f1416c !important;
}
.separator.separator-content.border-dark::before, .separator.separator-content.border-dark::after {
  border-color: #181C32 !important;
}

.carousel-custom .carousel-indicators {
  align-items: center;
  position: static;
  z-index: auto;
  margin: 0;
  padding: 0;
  list-style: none;
}
.carousel-custom .carousel-indicators li {
  transform: none;
  opacity: 1;
}
.carousel-custom .carousel-indicators li.active {
  transform: none;
  opacity: 1;
}
.carousel-custom .carousel-indicators.carousel-indicators-dots li {
  border-radius: 0;
  background-color: transparent;
  height: 13px;
  width: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.carousel-custom .carousel-indicators.carousel-indicators-dots li:after {
  display: inline-block;
  content: " ";
  border-radius: 50%;
  transition: all 0.3s ease;
  background-color: var(--kt-carousel-custom-indicator-default-bg-color);
  height: 9px;
  width: 9px;
}
.carousel-custom .carousel-indicators.carousel-indicators-dots li.active {
  background-color: transparent;
}
.carousel-custom .carousel-indicators.carousel-indicators-dots li.active:after {
  transition: all 0.3s ease;
  height: 13px;
  width: 13px;
  background-color: var(--kt-carousel-custom-indicator-active-bg-color);
}
.carousel-custom .carousel-indicators.carousel-indicators-bullet li {
  transition: all 0.3s ease;
  background-color: transparent;
  border-radius: 6px;
  height: 6px;
  width: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.carousel-custom .carousel-indicators.carousel-indicators-bullet li:after {
  display: inline-block;
  content: " ";
  transition: all 0.3s ease;
  background-color: var(--kt-carousel-custom-bullet-indicator-default-bg-color);
  border-radius: 6px;
  height: 6px;
  width: 6px;
}
.carousel-custom .carousel-indicators.carousel-indicators-bullet li.active {
  transition: all 0.3s ease;
  background-color: transparent;
  height: 6px;
  width: 16px;
}
.carousel-custom .carousel-indicators.carousel-indicators-bullet li.active:after {
  transition: all 0.3s ease;
  height: 6px;
  width: 16px;
  background-color: var(--kt-carousel-custom-bullet-indicator-active-bg-color);
}
.carousel-custom .carousel-indicators-active-white li.active:after {
  background-color: #ffffff !important;
}
.carousel-custom .carousel-indicators-active-light li.active:after {
  background-color: #f5f8fa !important;
}
.carousel-custom .carousel-indicators-active-primary li.active:after {
  background-color: #009ef7 !important;
}
.carousel-custom .carousel-indicators-active-secondary li.active:after {
  background-color: #E4E6EF !important;
}
.carousel-custom .carousel-indicators-active-success li.active:after {
  background-color: #50cd89 !important;
}
.carousel-custom .carousel-indicators-active-info li.active:after {
  background-color: #7239ea !important;
}
.carousel-custom .carousel-indicators-active-warning li.active:after {
  background-color: #ffc700 !important;
}
.carousel-custom .carousel-indicators-active-danger li.active:after {
  background-color: #f1416c !important;
}
.carousel-custom .carousel-indicators-active-dark li.active:after {
  background-color: #181C32 !important;
}
.carousel-custom.carousel-stretch {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.carousel-custom.carousel-stretch .carousel-inner {
  flex-grow: 1;
}
.carousel-custom.carousel-stretch .carousel-item {
  height: 100%;
}
.carousel-custom.carousel-stretch .carousel-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.menu-group {
  display: flex;
}

.menu,
.menu-wrapper {
  display: flex;
  padding: 0;
  margin: 0;
  list-style: none;
}

.menu-inner {
  padding: 0;
  margin: 0;
  list-style: none;
}

.menu-sub {
  display: none;
  padding: 0;
  margin: 0;
  list-style: none;
  flex-direction: column;
}

.menu-item {
  display: block;
  padding: 0.15rem 0;
}
.menu-item .menu-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
  flex: 0 0 100%;
  padding: 0.65rem 1rem;
  transition: none;
  outline: none !important;
}
.menu-item .menu-link .menu-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  margin-right: 0.5rem;
}
.menu-item .menu-link .menu-icon .svg-icon {
  line-height: 1;
}
.menu-item .menu-link .menu-bullet {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  margin-right: 0.5rem;
}
.menu-item .menu-link .menu-title {
  display: flex;
  align-items: center;
  flex-grow: 1;
}
.menu-item .menu-link .menu-badge {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 0.5rem;
}
.menu-item .menu-link .menu-arrow {
  display: flex;
  align-items: stretch;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  margin-left: 5px;
  width: 9px;
  height: 9px;
}
.menu-item .menu-link .menu-arrow:after {
  display: block;
  width: 100%;
  content: " ";
  will-change: transform;
  background-size: 100% 100%;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-muted);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-muted);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  /*rtl:end:remove*/
}
.menu-item .menu-content {
  padding: 0.65rem 1rem;
}

.menu-item.show .menu-link .menu-arrow:after {
  backface-visibility: hidden;
  transition: transform 0.3s ease;
}

.menu-center {
  justify-content: center;
}

.menu-heading {
  color: var(--kt-menu-heading-color);
}

.menu-item.menu-accordion .menu-arrow:after {
  /*rtl:ignore*/
  transform: rotateZ(-90deg);
  /*rtl:remove*/
  transform: rotateZ(90deg);
  transition: transform 0.3s ease;
}
.menu-item.menu-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
  /*rtl:ignore*/
  transform: rotateZ(90deg);
  /*rtl:remove*/
  transform: rotateZ(-90deg);
  transition: transform 0.3s ease;
}

.menu-sub-dropdown {
  display: none;
  border-radius: 0.475rem;
  background-color: var(--kt-menu-dropdown-bg-color);
  box-shadow: var(--kt-menu-dropdown-box-shadow);
  z-index: 107;
}
.show.menu-dropdown > .menu-sub-dropdown, .menu-sub-dropdown.menu.show, .menu-sub-dropdown.show[data-popper-placement] {
  display: flex;
  will-change: transform;
  animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
}

.menu-sub-accordion {
  display: none;
}
.show:not(.menu-dropdown) > .menu-sub-accordion, .menu-sub-accordion.show {
  display: flex;
}

.menu-sub-indention .menu-sub:not([data-popper-placement]) {
  margin-left: 1rem;
}
.menu-sub-indention .menu-item .menu-item .menu-link.active {
  margin-right: 1rem;
}

.menu-inline {
  display: flex;
}

.menu-fit > .menu-item > .menu-content,
.menu-fit > .menu-item > .menu-link {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.menu-column {
  flex-direction: column;
  width: 100%;
}

.menu-row {
  flex-direction: row;
}
.menu-row > .menu-item {
  display: flex;
  align-items: center;
}
.menu-row > .menu-item > .menu-link .menu-arrow:after {
  /*rtl:ignore*/
  transform: rotateZ(-90deg);
  /*rtl:remove*/
  transform: rotateZ(90deg);
  transition: transform 0.3s ease;
}

.menu-rounded .menu-link {
  border-radius: 0.475rem;
}

.menu-pill .menu-link {
  border-radius: 50px;
}

.menu-rounded-0 .menu-link {
  border-radius: 0 !important;
}

@media (min-width: 576px) {
  .menu-item.menu-sm-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-sm-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }

  .menu-sub-sm-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--kt-menu-dropdown-bg-color);
    box-shadow: var(--kt-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-sm-dropdown, .menu-sub-sm-dropdown.menu.show, .menu-sub-sm-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }

  .menu-sub-sm-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-sm-accordion, .menu-sub-sm-accordion.show {
    display: flex;
  }

  .menu-sub-sm-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-sm-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }

  .menu-sm-inline {
    display: flex;
  }

  .menu-sm-fit > .menu-item > .menu-content,
.menu-sm-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-sm-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-sm-row {
    flex-direction: row;
  }
  .menu-sm-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-sm-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }

  .menu-sm-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-sm-pill .menu-link {
    border-radius: 50px;
  }

  .menu-sm-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 768px) {
  .menu-item.menu-md-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-md-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }

  .menu-sub-md-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--kt-menu-dropdown-bg-color);
    box-shadow: var(--kt-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-md-dropdown, .menu-sub-md-dropdown.menu.show, .menu-sub-md-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }

  .menu-sub-md-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-md-accordion, .menu-sub-md-accordion.show {
    display: flex;
  }

  .menu-sub-md-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-md-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }

  .menu-md-inline {
    display: flex;
  }

  .menu-md-fit > .menu-item > .menu-content,
.menu-md-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-md-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-md-row {
    flex-direction: row;
  }
  .menu-md-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-md-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }

  .menu-md-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-md-pill .menu-link {
    border-radius: 50px;
  }

  .menu-md-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 992px) {
  .menu-item.menu-lg-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-lg-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }

  .menu-sub-lg-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--kt-menu-dropdown-bg-color);
    box-shadow: var(--kt-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-lg-dropdown, .menu-sub-lg-dropdown.menu.show, .menu-sub-lg-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }

  .menu-sub-lg-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-lg-accordion, .menu-sub-lg-accordion.show {
    display: flex;
  }

  .menu-sub-lg-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-lg-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }

  .menu-lg-inline {
    display: flex;
  }

  .menu-lg-fit > .menu-item > .menu-content,
.menu-lg-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-lg-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-lg-row {
    flex-direction: row;
  }
  .menu-lg-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-lg-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }

  .menu-lg-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-lg-pill .menu-link {
    border-radius: 50px;
  }

  .menu-lg-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 1200px) {
  .menu-item.menu-xl-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-xl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }

  .menu-sub-xl-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--kt-menu-dropdown-bg-color);
    box-shadow: var(--kt-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-xl-dropdown, .menu-sub-xl-dropdown.menu.show, .menu-sub-xl-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }

  .menu-sub-xl-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xl-accordion, .menu-sub-xl-accordion.show {
    display: flex;
  }

  .menu-sub-xl-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-xl-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }

  .menu-xl-inline {
    display: flex;
  }

  .menu-xl-fit > .menu-item > .menu-content,
.menu-xl-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-xl-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-xl-row {
    flex-direction: row;
  }
  .menu-xl-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xl-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }

  .menu-xl-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-xl-pill .menu-link {
    border-radius: 50px;
  }

  .menu-xl-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (min-width: 1400px) {
  .menu-item.menu-xxl-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-xxl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }

  .menu-sub-xxl-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--kt-menu-dropdown-bg-color);
    box-shadow: var(--kt-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-xxl-dropdown, .menu-sub-xxl-dropdown.menu.show, .menu-sub-xxl-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }

  .menu-sub-xxl-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xxl-accordion, .menu-sub-xxl-accordion.show {
    display: flex;
  }

  .menu-sub-xxl-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-xxl-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }

  .menu-xxl-inline {
    display: flex;
  }

  .menu-xxl-fit > .menu-item > .menu-content,
.menu-xxl-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-xxl-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-xxl-row {
    flex-direction: row;
  }
  .menu-xxl-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xxl-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }

  .menu-xxl-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-xxl-pill .menu-link {
    border-radius: 50px;
  }

  .menu-xxl-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 575.98px) {
  .menu-item.menu-sm-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-sm-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }

  .menu-sub-sm-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--kt-menu-dropdown-bg-color);
    box-shadow: var(--kt-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-sm-down-dropdown, .menu-sub-sm-down-dropdown.menu.show, .menu-sub-sm-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }

  .menu-sub-sm-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-sm-down-accordion, .menu-sub-sm-down-accordion.show {
    display: flex;
  }

  .menu-sub-sm-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-sm-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }

  .menu-sm-down-inline {
    display: flex;
  }

  .menu-sm-down-fit > .menu-item > .menu-content,
.menu-sm-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-sm-down-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-sm-down-row {
    flex-direction: row;
  }
  .menu-sm-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-sm-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }

  .menu-sm-down-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-sm-down-pill .menu-link {
    border-radius: 50px;
  }

  .menu-sm-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 767.98px) {
  .menu-item.menu-md-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-md-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }

  .menu-sub-md-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--kt-menu-dropdown-bg-color);
    box-shadow: var(--kt-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-md-down-dropdown, .menu-sub-md-down-dropdown.menu.show, .menu-sub-md-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }

  .menu-sub-md-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-md-down-accordion, .menu-sub-md-down-accordion.show {
    display: flex;
  }

  .menu-sub-md-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-md-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }

  .menu-md-down-inline {
    display: flex;
  }

  .menu-md-down-fit > .menu-item > .menu-content,
.menu-md-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-md-down-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-md-down-row {
    flex-direction: row;
  }
  .menu-md-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-md-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }

  .menu-md-down-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-md-down-pill .menu-link {
    border-radius: 50px;
  }

  .menu-md-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 991.98px) {
  .menu-item.menu-lg-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-lg-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }

  .menu-sub-lg-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--kt-menu-dropdown-bg-color);
    box-shadow: var(--kt-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-lg-down-dropdown, .menu-sub-lg-down-dropdown.menu.show, .menu-sub-lg-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }

  .menu-sub-lg-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-lg-down-accordion, .menu-sub-lg-down-accordion.show {
    display: flex;
  }

  .menu-sub-lg-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-lg-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }

  .menu-lg-down-inline {
    display: flex;
  }

  .menu-lg-down-fit > .menu-item > .menu-content,
.menu-lg-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-lg-down-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-lg-down-row {
    flex-direction: row;
  }
  .menu-lg-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-lg-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }

  .menu-lg-down-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-lg-down-pill .menu-link {
    border-radius: 50px;
  }

  .menu-lg-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 1199.98px) {
  .menu-item.menu-xl-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-xl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }

  .menu-sub-xl-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--kt-menu-dropdown-bg-color);
    box-shadow: var(--kt-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-xl-down-dropdown, .menu-sub-xl-down-dropdown.menu.show, .menu-sub-xl-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }

  .menu-sub-xl-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xl-down-accordion, .menu-sub-xl-down-accordion.show {
    display: flex;
  }

  .menu-sub-xl-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-xl-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }

  .menu-xl-down-inline {
    display: flex;
  }

  .menu-xl-down-fit > .menu-item > .menu-content,
.menu-xl-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-xl-down-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-xl-down-row {
    flex-direction: row;
  }
  .menu-xl-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xl-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }

  .menu-xl-down-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-xl-down-pill .menu-link {
    border-radius: 50px;
  }

  .menu-xl-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
@media (max-width: 1399.98px) {
  .menu-item.menu-xxl-down-accordion .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }
  .menu-item.menu-xxl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(90deg);
    /*rtl:remove*/
    transform: rotateZ(-90deg);
    transition: transform 0.3s ease;
  }

  .menu-sub-xxl-down-dropdown {
    display: none;
    border-radius: 0.475rem;
    background-color: var(--kt-menu-dropdown-bg-color);
    box-shadow: var(--kt-menu-dropdown-box-shadow);
    z-index: 107;
  }
  .show.menu-dropdown > .menu-sub-xxl-down-dropdown, .menu-sub-xxl-down-dropdown.menu.show, .menu-sub-xxl-down-dropdown.show[data-popper-placement] {
    display: flex;
    will-change: transform;
    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;
  }

  .menu-sub-xxl-down-accordion {
    display: none;
  }
  .show:not(.menu-dropdown) > .menu-sub-xxl-down-accordion, .menu-sub-xxl-down-accordion.show {
    display: flex;
  }

  .menu-sub-xxl-down-indention .menu-sub:not([data-popper-placement]) {
    margin-left: 1rem;
  }
  .menu-sub-xxl-down-indention .menu-item .menu-item .menu-link.active {
    margin-right: 1rem;
  }

  .menu-xxl-down-inline {
    display: flex;
  }

  .menu-xxl-down-fit > .menu-item > .menu-content,
.menu-xxl-down-fit > .menu-item > .menu-link {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .menu-xxl-down-column {
    flex-direction: column;
    width: 100%;
  }

  .menu-xxl-down-row {
    flex-direction: row;
  }
  .menu-xxl-down-row > .menu-item {
    display: flex;
    align-items: center;
  }
  .menu-xxl-down-row > .menu-item > .menu-link .menu-arrow:after {
    /*rtl:ignore*/
    transform: rotateZ(-90deg);
    /*rtl:remove*/
    transform: rotateZ(90deg);
    transition: transform 0.3s ease;
  }

  .menu-xxl-down-rounded .menu-link {
    border-radius: 0.475rem;
  }

  .menu-xxl-down-pill .menu-link {
    border-radius: 50px;
  }

  .menu-xxl-down-rounded-0 .menu-link {
    border-radius: 0 !important;
  }
}
.menu-link-indention .menu-item {
  padding-top: 0;
  padding-bottom: 0;
}
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: calc(1rem + 1rem);
}
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: calc(2rem + 1rem);
}
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: calc(3rem + 1rem);
}
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: calc(4rem + 1rem);
}
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: 1rem;
  padding-right: 0;
}
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: calc(2rem);
  padding-right: 0;
}
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: calc(3rem);
  padding-right: 0;
}
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,
.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {
  padding-left: calc(4rem);
  padding-right: 0;
}

@keyframes menu-sub-dropdown-animation-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes menu-sub-dropdown-animation-move-up {
  from {
    margin-top: 0.75rem;
  }
  to {
    margin-top: 0;
  }
}
@keyframes menu-sub-dropdown-animation-move-down {
  from {
    margin-bottom: 0.75rem;
  }
  to {
    margin-bottom: 0;
  }
}
.menu-white .menu-item .menu-link {
  color: var(--kt-white);
}
.menu-white .menu-item .menu-link .menu-title {
  color: var(--kt-white);
}
.menu-white .menu-item .menu-link .menu-icon,
.menu-white .menu-item .menu-link .menu-icon .svg-icon,
.menu-white .menu-item .menu-link .menu-icon i {
  color: var(--kt-white);
}
.menu-white .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-white);
}
.menu-white .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-white);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-white);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  /*rtl:end:remove*/
}

.menu-title-white .menu-item .menu-link {
  color: var(--kt-text-white);
}
.menu-title-white .menu-item .menu-link .menu-title {
  color: var(--kt-text-white);
}

.menu-icon-white .menu-item .menu-link .menu-icon,
.menu-icon-white .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-white .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-white);
}

.menu-bullet-white .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-white);
}

.menu-arrow-white .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-white);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-white);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
  /*rtl:end:remove*/
}

.menu-primary .menu-item .menu-link {
  color: var(--kt-primary);
}
.menu-primary .menu-item .menu-link .menu-title {
  color: var(--kt-primary);
}
.menu-primary .menu-item .menu-link .menu-icon,
.menu-primary .menu-item .menu-link .menu-icon .svg-icon,
.menu-primary .menu-item .menu-link .menu-icon i {
  color: var(--kt-primary);
}
.menu-primary .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-primary .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-title-primary .menu-item .menu-link {
  color: var(--kt-text-primary);
}
.menu-title-primary .menu-item .menu-link .menu-title {
  color: var(--kt-text-primary);
}

.menu-icon-primary .menu-item .menu-link .menu-icon,
.menu-icon-primary .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-primary .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-primary);
}

.menu-bullet-primary .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-primary);
}

.menu-arrow-primary .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  /*rtl:end:remove*/
}

.menu-secondary .menu-item .menu-link {
  color: var(--kt-secondary);
}
.menu-secondary .menu-item .menu-link .menu-title {
  color: var(--kt-secondary);
}
.menu-secondary .menu-item .menu-link .menu-icon,
.menu-secondary .menu-item .menu-link .menu-icon .svg-icon,
.menu-secondary .menu-item .menu-link .menu-icon i {
  color: var(--kt-secondary);
}
.menu-secondary .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-secondary);
}
.menu-secondary .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-secondary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-secondary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  /*rtl:end:remove*/
}

.menu-title-secondary .menu-item .menu-link {
  color: var(--kt-text-secondary);
}
.menu-title-secondary .menu-item .menu-link .menu-title {
  color: var(--kt-text-secondary);
}

.menu-icon-secondary .menu-item .menu-link .menu-icon,
.menu-icon-secondary .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-secondary .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-secondary);
}

.menu-bullet-secondary .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-secondary);
}

.menu-arrow-secondary .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-secondary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-secondary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  /*rtl:end:remove*/
}

.menu-light .menu-item .menu-link {
  color: var(--kt-light);
}
.menu-light .menu-item .menu-link .menu-title {
  color: var(--kt-light);
}
.menu-light .menu-item .menu-link .menu-icon,
.menu-light .menu-item .menu-link .menu-icon .svg-icon,
.menu-light .menu-item .menu-link .menu-icon i {
  color: var(--kt-light);
}
.menu-light .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-light);
}
.menu-light .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-light);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-light);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_47___});
  /*rtl:end:remove*/
}

.menu-title-light .menu-item .menu-link {
  color: var(--kt-text-light);
}
.menu-title-light .menu-item .menu-link .menu-title {
  color: var(--kt-text-light);
}

.menu-icon-light .menu-item .menu-link .menu-icon,
.menu-icon-light .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-light .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-light);
}

.menu-bullet-light .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-light);
}

.menu-arrow-light .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-light);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-light);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
  /*rtl:end:remove*/
}

.menu-success .menu-item .menu-link {
  color: var(--kt-success);
}
.menu-success .menu-item .menu-link .menu-title {
  color: var(--kt-success);
}
.menu-success .menu-item .menu-link .menu-icon,
.menu-success .menu-item .menu-link .menu-icon .svg-icon,
.menu-success .menu-item .menu-link .menu-icon i {
  color: var(--kt-success);
}
.menu-success .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-success);
}
.menu-success .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-success);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-success);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_51___});
  /*rtl:end:remove*/
}

.menu-title-success .menu-item .menu-link {
  color: var(--kt-text-success);
}
.menu-title-success .menu-item .menu-link .menu-title {
  color: var(--kt-text-success);
}

.menu-icon-success .menu-item .menu-link .menu-icon,
.menu-icon-success .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-success .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-success);
}

.menu-bullet-success .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-success);
}

.menu-arrow-success .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-success);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-success);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_53___});
  /*rtl:end:remove*/
}

.menu-info .menu-item .menu-link {
  color: var(--kt-info);
}
.menu-info .menu-item .menu-link .menu-title {
  color: var(--kt-info);
}
.menu-info .menu-item .menu-link .menu-icon,
.menu-info .menu-item .menu-link .menu-icon .svg-icon,
.menu-info .menu-item .menu-link .menu-icon i {
  color: var(--kt-info);
}
.menu-info .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-info);
}
.menu-info .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-info);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-info);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
  /*rtl:end:remove*/
}

.menu-title-info .menu-item .menu-link {
  color: var(--kt-text-info);
}
.menu-title-info .menu-item .menu-link .menu-title {
  color: var(--kt-text-info);
}

.menu-icon-info .menu-item .menu-link .menu-icon,
.menu-icon-info .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-info .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-info);
}

.menu-bullet-info .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-info);
}

.menu-arrow-info .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-info);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-info);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_57___});
  /*rtl:end:remove*/
}

.menu-warning .menu-item .menu-link {
  color: var(--kt-warning);
}
.menu-warning .menu-item .menu-link .menu-title {
  color: var(--kt-warning);
}
.menu-warning .menu-item .menu-link .menu-icon,
.menu-warning .menu-item .menu-link .menu-icon .svg-icon,
.menu-warning .menu-item .menu-link .menu-icon i {
  color: var(--kt-warning);
}
.menu-warning .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-warning);
}
.menu-warning .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-warning);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-warning);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
  /*rtl:end:remove*/
}

.menu-title-warning .menu-item .menu-link {
  color: var(--kt-text-warning);
}
.menu-title-warning .menu-item .menu-link .menu-title {
  color: var(--kt-text-warning);
}

.menu-icon-warning .menu-item .menu-link .menu-icon,
.menu-icon-warning .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-warning .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-warning);
}

.menu-bullet-warning .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-warning);
}

.menu-arrow-warning .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-warning);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-warning);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  /*rtl:end:remove*/
}

.menu-danger .menu-item .menu-link {
  color: var(--kt-danger);
}
.menu-danger .menu-item .menu-link .menu-title {
  color: var(--kt-danger);
}
.menu-danger .menu-item .menu-link .menu-icon,
.menu-danger .menu-item .menu-link .menu-icon .svg-icon,
.menu-danger .menu-item .menu-link .menu-icon i {
  color: var(--kt-danger);
}
.menu-danger .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-danger);
}
.menu-danger .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-danger);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-danger);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
  /*rtl:end:remove*/
}

.menu-title-danger .menu-item .menu-link {
  color: var(--kt-text-danger);
}
.menu-title-danger .menu-item .menu-link .menu-title {
  color: var(--kt-text-danger);
}

.menu-icon-danger .menu-item .menu-link .menu-icon,
.menu-icon-danger .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-danger .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-danger);
}

.menu-bullet-danger .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-danger);
}

.menu-arrow-danger .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-danger);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-danger);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
  /*rtl:end:remove*/
}

.menu-dark .menu-item .menu-link {
  color: var(--kt-dark);
}
.menu-dark .menu-item .menu-link .menu-title {
  color: var(--kt-dark);
}
.menu-dark .menu-item .menu-link .menu-icon,
.menu-dark .menu-item .menu-link .menu-icon .svg-icon,
.menu-dark .menu-item .menu-link .menu-icon i {
  color: var(--kt-dark);
}
.menu-dark .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-dark);
}
.menu-dark .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
  /*rtl:end:remove*/
}

.menu-title-dark .menu-item .menu-link {
  color: var(--kt-text-dark);
}
.menu-title-dark .menu-item .menu-link .menu-title {
  color: var(--kt-text-dark);
}

.menu-icon-dark .menu-item .menu-link .menu-icon,
.menu-icon-dark .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-dark .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-dark);
}

.menu-bullet-dark .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-dark);
}

.menu-arrow-dark .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
  /*rtl:end:remove*/
}

.menu-muted .menu-item .menu-link {
  color: var(--kt-muted);
}
.menu-muted .menu-item .menu-link .menu-title {
  color: var(--kt-muted);
}
.menu-muted .menu-item .menu-link .menu-icon,
.menu-muted .menu-item .menu-link .menu-icon .svg-icon,
.menu-muted .menu-item .menu-link .menu-icon i {
  color: var(--kt-muted);
}
.menu-muted .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-muted);
}
.menu-muted .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-muted);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-muted);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
  /*rtl:end:remove*/
}

.menu-title-muted .menu-item .menu-link {
  color: var(--kt-text-muted);
}
.menu-title-muted .menu-item .menu-link .menu-title {
  color: var(--kt-text-muted);
}

.menu-icon-muted .menu-item .menu-link .menu-icon,
.menu-icon-muted .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-muted .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-muted);
}

.menu-bullet-muted .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-muted);
}

.menu-arrow-muted .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-muted);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_32___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-muted);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_33___});
  /*rtl:end:remove*/
}

.menu-gray-100 .menu-item .menu-link {
  color: var(--kt-gray-100);
}
.menu-gray-100 .menu-item .menu-link .menu-title {
  color: var(--kt-gray-100);
}
.menu-gray-100 .menu-item .menu-link .menu-icon,
.menu-gray-100 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-100 .menu-item .menu-link .menu-icon i {
  color: var(--kt-gray-100);
}
.menu-gray-100 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-gray-100);
}
.menu-gray-100 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-100);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-100);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
  /*rtl:end:remove*/
}

.menu-title-gray-100 .menu-item .menu-link {
  color: var(--kt-text-gray-100);
}
.menu-title-gray-100 .menu-item .menu-link .menu-title {
  color: var(--kt-text-gray-100);
}

.menu-icon-gray-100 .menu-item .menu-link .menu-icon,
.menu-icon-gray-100 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-100 .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-gray-100);
}

.menu-bullet-gray-100 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-gray-100);
}

.menu-arrow-gray-100 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-100);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-100);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
  /*rtl:end:remove*/
}

.menu-gray-200 .menu-item .menu-link {
  color: var(--kt-gray-200);
}
.menu-gray-200 .menu-item .menu-link .menu-title {
  color: var(--kt-gray-200);
}
.menu-gray-200 .menu-item .menu-link .menu-icon,
.menu-gray-200 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-200 .menu-item .menu-link .menu-icon i {
  color: var(--kt-gray-200);
}
.menu-gray-200 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-gray-200);
}
.menu-gray-200 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-200);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-200);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
  /*rtl:end:remove*/
}

.menu-title-gray-200 .menu-item .menu-link {
  color: var(--kt-text-gray-200);
}
.menu-title-gray-200 .menu-item .menu-link .menu-title {
  color: var(--kt-text-gray-200);
}

.menu-icon-gray-200 .menu-item .menu-link .menu-icon,
.menu-icon-gray-200 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-200 .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-gray-200);
}

.menu-bullet-gray-200 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-gray-200);
}

.menu-arrow-gray-200 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-200);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_78___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-200);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_79___});
  /*rtl:end:remove*/
}

.menu-gray-300 .menu-item .menu-link {
  color: var(--kt-gray-300);
}
.menu-gray-300 .menu-item .menu-link .menu-title {
  color: var(--kt-gray-300);
}
.menu-gray-300 .menu-item .menu-link .menu-icon,
.menu-gray-300 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-300 .menu-item .menu-link .menu-icon i {
  color: var(--kt-gray-300);
}
.menu-gray-300 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-gray-300);
}
.menu-gray-300 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-300);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_80___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-300);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_81___});
  /*rtl:end:remove*/
}

.menu-title-gray-300 .menu-item .menu-link {
  color: var(--kt-text-gray-300);
}
.menu-title-gray-300 .menu-item .menu-link .menu-title {
  color: var(--kt-text-gray-300);
}

.menu-icon-gray-300 .menu-item .menu-link .menu-icon,
.menu-icon-gray-300 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-300 .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-gray-300);
}

.menu-bullet-gray-300 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-gray-300);
}

.menu-arrow-gray-300 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-300);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_82___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-300);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_83___});
  /*rtl:end:remove*/
}

.menu-gray-400 .menu-item .menu-link {
  color: var(--kt-gray-400);
}
.menu-gray-400 .menu-item .menu-link .menu-title {
  color: var(--kt-gray-400);
}
.menu-gray-400 .menu-item .menu-link .menu-icon,
.menu-gray-400 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-400 .menu-item .menu-link .menu-icon i {
  color: var(--kt-gray-400);
}
.menu-gray-400 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-gray-400);
}
.menu-gray-400 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-400);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_84___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-400);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_85___});
  /*rtl:end:remove*/
}

.menu-title-gray-400 .menu-item .menu-link {
  color: var(--kt-text-gray-400);
}
.menu-title-gray-400 .menu-item .menu-link .menu-title {
  color: var(--kt-text-gray-400);
}

.menu-icon-gray-400 .menu-item .menu-link .menu-icon,
.menu-icon-gray-400 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-400 .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-gray-400);
}

.menu-bullet-gray-400 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-gray-400);
}

.menu-arrow-gray-400 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-400);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_86___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-400);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_87___});
  /*rtl:end:remove*/
}

.menu-gray-500 .menu-item .menu-link {
  color: var(--kt-gray-500);
}
.menu-gray-500 .menu-item .menu-link .menu-title {
  color: var(--kt-gray-500);
}
.menu-gray-500 .menu-item .menu-link .menu-icon,
.menu-gray-500 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-500 .menu-item .menu-link .menu-icon i {
  color: var(--kt-gray-500);
}
.menu-gray-500 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-gray-500);
}
.menu-gray-500 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-500);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_88___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-500);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_89___});
  /*rtl:end:remove*/
}

.menu-title-gray-500 .menu-item .menu-link {
  color: var(--kt-text-gray-500);
}
.menu-title-gray-500 .menu-item .menu-link .menu-title {
  color: var(--kt-text-gray-500);
}

.menu-icon-gray-500 .menu-item .menu-link .menu-icon,
.menu-icon-gray-500 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-500 .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-gray-500);
}

.menu-bullet-gray-500 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-gray-500);
}

.menu-arrow-gray-500 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-500);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_90___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-500);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_91___});
  /*rtl:end:remove*/
}

.menu-gray-600 .menu-item .menu-link {
  color: var(--kt-gray-600);
}
.menu-gray-600 .menu-item .menu-link .menu-title {
  color: var(--kt-gray-600);
}
.menu-gray-600 .menu-item .menu-link .menu-icon,
.menu-gray-600 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-600 .menu-item .menu-link .menu-icon i {
  color: var(--kt-gray-600);
}
.menu-gray-600 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-gray-600);
}
.menu-gray-600 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-600);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_92___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-600);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_93___});
  /*rtl:end:remove*/
}

.menu-title-gray-600 .menu-item .menu-link {
  color: var(--kt-text-gray-600);
}
.menu-title-gray-600 .menu-item .menu-link .menu-title {
  color: var(--kt-text-gray-600);
}

.menu-icon-gray-600 .menu-item .menu-link .menu-icon,
.menu-icon-gray-600 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-600 .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-gray-600);
}

.menu-bullet-gray-600 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-gray-600);
}

.menu-arrow-gray-600 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-600);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_94___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-600);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_95___});
  /*rtl:end:remove*/
}

.menu-gray-700 .menu-item .menu-link {
  color: var(--kt-gray-700);
}
.menu-gray-700 .menu-item .menu-link .menu-title {
  color: var(--kt-gray-700);
}
.menu-gray-700 .menu-item .menu-link .menu-icon,
.menu-gray-700 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-700 .menu-item .menu-link .menu-icon i {
  color: var(--kt-gray-700);
}
.menu-gray-700 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-gray-700);
}
.menu-gray-700 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_96___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_97___});
  /*rtl:end:remove*/
}

.menu-title-gray-700 .menu-item .menu-link {
  color: var(--kt-text-gray-700);
}
.menu-title-gray-700 .menu-item .menu-link .menu-title {
  color: var(--kt-text-gray-700);
}

.menu-icon-gray-700 .menu-item .menu-link .menu-icon,
.menu-icon-gray-700 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-700 .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-gray-700);
}

.menu-bullet-gray-700 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-gray-700);
}

.menu-arrow-gray-700 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_98___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_99___});
  /*rtl:end:remove*/
}

.menu-gray-800 .menu-item .menu-link {
  color: var(--kt-gray-800);
}
.menu-gray-800 .menu-item .menu-link .menu-title {
  color: var(--kt-gray-800);
}
.menu-gray-800 .menu-item .menu-link .menu-icon,
.menu-gray-800 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-800 .menu-item .menu-link .menu-icon i {
  color: var(--kt-gray-800);
}
.menu-gray-800 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-gray-800);
}
.menu-gray-800 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-800);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_100___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-800);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_101___});
  /*rtl:end:remove*/
}

.menu-title-gray-800 .menu-item .menu-link {
  color: var(--kt-text-gray-800);
}
.menu-title-gray-800 .menu-item .menu-link .menu-title {
  color: var(--kt-text-gray-800);
}

.menu-icon-gray-800 .menu-item .menu-link .menu-icon,
.menu-icon-gray-800 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-800 .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-gray-800);
}

.menu-bullet-gray-800 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-gray-800);
}

.menu-arrow-gray-800 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-800);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_102___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-800);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_103___});
  /*rtl:end:remove*/
}

.menu-gray-900 .menu-item .menu-link {
  color: var(--kt-gray-900);
}
.menu-gray-900 .menu-item .menu-link .menu-title {
  color: var(--kt-gray-900);
}
.menu-gray-900 .menu-item .menu-link .menu-icon,
.menu-gray-900 .menu-item .menu-link .menu-icon .svg-icon,
.menu-gray-900 .menu-item .menu-link .menu-icon i {
  color: var(--kt-gray-900);
}
.menu-gray-900 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-gray-900);
}
.menu-gray-900 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-900);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_104___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-900);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_105___});
  /*rtl:end:remove*/
}

.menu-title-gray-900 .menu-item .menu-link {
  color: var(--kt-text-gray-900);
}
.menu-title-gray-900 .menu-item .menu-link .menu-title {
  color: var(--kt-text-gray-900);
}

.menu-icon-gray-900 .menu-item .menu-link .menu-icon,
.menu-icon-gray-900 .menu-item .menu-link .menu-icon .svg-icon,
.menu-icon-gray-900 .menu-item .menu-link .menu-icon i {
  color: var(--kt-text-gray-900);
}

.menu-bullet-gray-900 .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-text-gray-900);
}

.menu-arrow-gray-900 .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-900);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_106___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-gray-900);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_107___});
  /*rtl:end:remove*/
}

.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--kt-menu-link-bg-color-hover);
  color: var(--kt-menu-link-color-hover);
}
.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-menu-link-color-hover);
}
.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-menu-link-color-hover);
}
.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-menu-link-color-hover);
}
.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-hover);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-hover);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
  /*rtl:end:remove*/
}

.menu-here-bg .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-menu-link-bg-color-here);
  color: var(--kt-menu-link-color-here);
}
.menu-here-bg .menu-item.here > .menu-link .menu-title {
  color: var(--kt-menu-link-color-here);
}
.menu-here-bg .menu-item.here > .menu-link .menu-icon,
.menu-here-bg .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-bg .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-menu-link-color-here);
}
.menu-here-bg .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-menu-link-color-here);
}
.menu-here-bg .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-here);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-here);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

.menu-root-here-bg > .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-menu-link-bg-color-here);
  color: var(--kt-menu-link-color-here);
}
.menu-root-here-bg > .menu-item.here > .menu-link .menu-title {
  color: var(--kt-menu-link-color-here);
}
.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon,
.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-menu-link-color-here);
}
.menu-root-here-bg > .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-menu-link-color-here);
}
.menu-root-here-bg > .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-here);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-here);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}

@media (min-width: 992px) {
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link {
    transition: color 0.2s ease;
    background-color: var(--kt-menu-link-bg-color-here);
    color: var(--kt-menu-link-color-here);
  }
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-title {
    color: var(--kt-menu-link-color-here);
  }
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon,
.menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon i {
    color: var(--kt-menu-link-color-here);
  }
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-bullet .bullet {
    background-color: var(--kt-menu-link-color-here);
  }
  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-arrow:after {
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-menu-link-color-here);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-menu-link-color-here);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
    /*rtl:end:remove*/
  }
}
.menu-show-bg .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-menu-link-bg-color-show);
  color: var(--kt-menu-link-color-show);
}
.menu-show-bg .menu-item.show > .menu-link .menu-title {
  color: var(--kt-menu-link-color-show);
}
.menu-show-bg .menu-item.show > .menu-link .menu-icon,
.menu-show-bg .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-bg .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-menu-link-color-show);
}
.menu-show-bg .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-menu-link-color-show);
}
.menu-show-bg .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-show);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-show);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_113___});
  /*rtl:end:remove*/
}

.menu-active-bg .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--kt-menu-link-bg-color-active);
  color: var(--kt-menu-link-color-active);
}
.menu-active-bg .menu-item .menu-link.active .menu-title {
  color: var(--kt-menu-link-color-active);
}
.menu-active-bg .menu-item .menu-link.active .menu-icon,
.menu-active-bg .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-bg .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-menu-link-color-active);
}
.menu-active-bg .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-menu-link-color-active);
}
.menu-active-bg .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-active);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_114___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-active);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_115___});
  /*rtl:end:remove*/
}

.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--kt-menu-link-bg-color-hover);
  color: var(--kt-menu-link-color-hover);
}
.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-menu-link-color-hover);
}
.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-menu-link-color-hover);
}
.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-menu-link-color-hover);
}
.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-hover);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-hover);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
  /*rtl:end:remove*/
}
.menu-state-bg .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-menu-link-bg-color-here);
  color: var(--kt-menu-link-color-here);
}
.menu-state-bg .menu-item.here > .menu-link .menu-title {
  color: var(--kt-menu-link-color-here);
}
.menu-state-bg .menu-item.here > .menu-link .menu-icon,
.menu-state-bg .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-bg .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-menu-link-color-here);
}
.menu-state-bg .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-menu-link-color-here);
}
.menu-state-bg .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-here);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-here);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}
.menu-state-bg .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-menu-link-bg-color-show);
  color: var(--kt-menu-link-color-show);
}
.menu-state-bg .menu-item.show > .menu-link .menu-title {
  color: var(--kt-menu-link-color-show);
}
.menu-state-bg .menu-item.show > .menu-link .menu-icon,
.menu-state-bg .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-bg .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-menu-link-color-show);
}
.menu-state-bg .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-menu-link-color-show);
}
.menu-state-bg .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-show);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-show);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_113___});
  /*rtl:end:remove*/
}
.menu-state-bg .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--kt-menu-link-bg-color-active);
  color: var(--kt-menu-link-color-active);
}
.menu-state-bg .menu-item .menu-link.active .menu-title {
  color: var(--kt-menu-link-color-active);
}
.menu-state-bg .menu-item .menu-link.active .menu-icon,
.menu-state-bg .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-bg .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-menu-link-color-active);
}
.menu-state-bg .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-menu-link-color-active);
}
.menu-state-bg .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-active);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_114___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-active);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_115___});
  /*rtl:end:remove*/
}

.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--kt-menu-link-color-hover);
}
.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-menu-link-color-hover);
}
.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-menu-link-color-hover);
}
.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-menu-link-color-hover);
}
.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-hover);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_108___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-hover);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_109___});
  /*rtl:end:remove*/
}
.menu-state-color .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-menu-link-color-here);
}
.menu-state-color .menu-item.here > .menu-link .menu-title {
  color: var(--kt-menu-link-color-here);
}
.menu-state-color .menu-item.here > .menu-link .menu-icon,
.menu-state-color .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-color .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-menu-link-color-here);
}
.menu-state-color .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-menu-link-color-here);
}
.menu-state-color .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-here);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_110___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-here);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_111___});
  /*rtl:end:remove*/
}
.menu-state-color .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-menu-link-color-show);
}
.menu-state-color .menu-item.show > .menu-link .menu-title {
  color: var(--kt-menu-link-color-show);
}
.menu-state-color .menu-item.show > .menu-link .menu-icon,
.menu-state-color .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-color .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-menu-link-color-show);
}
.menu-state-color .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-menu-link-color-show);
}
.menu-state-color .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-show);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_112___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-show);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_113___});
  /*rtl:end:remove*/
}
.menu-state-color .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--kt-menu-link-color-active);
}
.menu-state-color .menu-item .menu-link.active .menu-title {
  color: var(--kt-menu-link-color-active);
}
.menu-state-color .menu-item .menu-link.active .menu-icon,
.menu-state-color .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-color .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-menu-link-color-active);
}
.menu-state-color .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-menu-link-color-active);
}
.menu-state-color .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-active);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_114___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-menu-link-color-active);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_115___});
  /*rtl:end:remove*/
}

.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--kt-primary);
  color: var(--kt-primary-inverse);
}
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-primary-inverse);
}
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-primary-inverse);
}
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-primary-inverse);
}
.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
  /*rtl:end:remove*/
}

.menu-show-bg-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-primary);
  color: var(--kt-primary-inverse);
}
.menu-show-bg-primary .menu-item.show > .menu-link .menu-title {
  color: var(--kt-primary-inverse);
}
.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon,
.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-primary-inverse);
}
.menu-show-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary-inverse);
}
.menu-show-bg-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
  /*rtl:end:remove*/
}

.menu-here-bg-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-primary);
  color: var(--kt-primary-inverse);
}
.menu-here-bg-primary .menu-item.here > .menu-link .menu-title {
  color: var(--kt-primary-inverse);
}
.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon,
.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-primary-inverse);
}
.menu-here-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary-inverse);
}
.menu-here-bg-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
  /*rtl:end:remove*/
}

.menu-active-bg-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--kt-primary);
  color: var(--kt-primary-inverse);
}
.menu-active-bg-primary .menu-item .menu-link.active .menu-title {
  color: var(--kt-primary-inverse);
}
.menu-active-bg-primary .menu-item .menu-link.active .menu-icon,
.menu-active-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-bg-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-primary-inverse);
}
.menu-active-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-primary-inverse);
}
.menu-active-bg-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
  /*rtl:end:remove*/
}

.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--kt-primary);
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
  /*rtl:end:remove*/
}
.menu-state-bg-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-primary);
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-title {
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
  /*rtl:end:remove*/
}
.menu-state-bg-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-primary);
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.here > .menu-link .menu-title {
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon,
.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
  /*rtl:end:remove*/
}
.menu-state-bg-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--kt-primary);
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item .menu-link.active .menu-title {
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item .menu-link.active .menu-icon,
.menu-state-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
  /*rtl:end:remove*/
}
.menu-state-bg-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-primary);
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-title {
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary-inverse);
}
.menu-state-bg-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
  /*rtl:end:remove*/
}

.menu-show-bg-light-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-primary-light);
  color: var(--kt-primary);
}
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-title {
  color: var(--kt-primary);
}
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon,
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-primary);
}
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-here-bg-light-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-primary-light);
  color: var(--kt-primary);
}
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-title {
  color: var(--kt-primary);
}
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon,
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-primary);
}
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--kt-primary-light);
  color: var(--kt-primary);
}
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-primary);
}
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-primary);
}
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-active-bg-light-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--kt-primary-light);
  color: var(--kt-primary);
}
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-title {
  color: var(--kt-primary);
}
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon,
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-primary);
}
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-active-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-state-bg-light-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-primary-light);
  color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-title {
  color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}
.menu-state-bg-light-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-primary-light);
  color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-title {
  color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon,
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--kt-primary-light);
  color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}
.menu-state-bg-light-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--kt-primary-light);
  color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-title {
  color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon,
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-state-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-primary);
}
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-primary);
}
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-show-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-show-primary .menu-item.show > .menu-link .menu-title {
  color: var(--kt-primary);
}
.menu-show-primary .menu-item.show > .menu-link .menu-icon,
.menu-show-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-primary);
}
.menu-show-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-show-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-here-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-here-primary .menu-item.here > .menu-link .menu-title {
  color: var(--kt-primary);
}
.menu-here-primary .menu-item.here > .menu-link .menu-icon,
.menu-here-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-primary);
}
.menu-here-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-here-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-active-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-active-primary .menu-item .menu-link.active .menu-title {
  color: var(--kt-primary);
}
.menu-active-primary .menu-item .menu-link.active .menu-icon,
.menu-active-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-primary);
}
.menu-active-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-active-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-primary);
}
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-primary);
}
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}
.menu-state-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-state-primary .menu-item.show > .menu-link .menu-title {
  color: var(--kt-primary);
}
.menu-state-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-primary);
}
.menu-state-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-state-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}
.menu-state-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-state-primary .menu-item.here > .menu-link .menu-title {
  color: var(--kt-primary);
}
.menu-state-primary .menu-item.here > .menu-link .menu-icon,
.menu-state-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-primary);
}
.menu-state-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-state-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}
.menu-state-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-state-primary .menu-item .menu-link.active .menu-title {
  color: var(--kt-primary);
}
.menu-state-primary .menu-item .menu-link.active .menu-icon,
.menu-state-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-primary);
}
.menu-state-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-state-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--kt-dark);
}
.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-dark);
}
.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-dark);
}
.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-dark);
}
.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
  /*rtl:end:remove*/
}
.menu-state-dark .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-dark);
}
.menu-state-dark .menu-item.show > .menu-link .menu-title {
  color: var(--kt-dark);
}
.menu-state-dark .menu-item.show > .menu-link .menu-icon,
.menu-state-dark .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-dark .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-dark);
}
.menu-state-dark .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-dark);
}
.menu-state-dark .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
  /*rtl:end:remove*/
}
.menu-state-dark .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-dark);
}
.menu-state-dark .menu-item.here > .menu-link .menu-title {
  color: var(--kt-dark);
}
.menu-state-dark .menu-item.here > .menu-link .menu-icon,
.menu-state-dark .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-dark .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-dark);
}
.menu-state-dark .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-dark);
}
.menu-state-dark .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
  /*rtl:end:remove*/
}
.menu-state-dark .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--kt-dark);
}
.menu-state-dark .menu-item .menu-link.active .menu-title {
  color: var(--kt-dark);
}
.menu-state-dark .menu-item .menu-link.active .menu-icon,
.menu-state-dark .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-dark .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-dark);
}
.menu-state-dark .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-dark);
}
.menu-state-dark .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-dark);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
  /*rtl:end:remove*/
}

.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-primary);
}

.menu-here-title-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-here-title-primary .menu-item.here > .menu-link .menu-title {
  color: var(--kt-primary);
}

.menu-show-title-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-show-title-primary .menu-item.show > .menu-link .menu-title {
  color: var(--kt-primary);
}

.menu-active-title-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-active-title-primary .menu-item .menu-link.active .menu-title {
  color: var(--kt-primary);
}

.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-primary);
}
.menu-state-title-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-state-title-primary .menu-item.here > .menu-link .menu-title {
  color: var(--kt-primary);
}
.menu-state-title-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-state-title-primary .menu-item.show > .menu-link .menu-title {
  color: var(--kt-primary);
}
.menu-state-title-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.menu-state-title-primary .menu-item .menu-link.active .menu-title {
  color: var(--kt-primary);
}

.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}
.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-primary);
}

.menu-here-icon-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}
.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon,
.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-primary);
}

.menu-show-icon-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}
.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon,
.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-primary);
}

.menu-active-icon-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}
.menu-active-icon-primary .menu-item .menu-link.active .menu-icon,
.menu-active-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-active-icon-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-primary);
}

.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}
.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-primary);
}
.menu-state-icon-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}
.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon,
.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-primary);
}
.menu-state-icon-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}
.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon,
.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-primary);
}
.menu-state-icon-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}
.menu-state-icon-primary .menu-item .menu-link.active .menu-icon,
.menu-state-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon,
.menu-state-icon-primary .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-primary);
}

.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}
.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-primary);
}

.menu-show-bullet-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}
.menu-show-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}

.menu-here-bullet-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}
.menu-here-bullet-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}

.menu-active-bullet-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}
.menu-active-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-primary);
}

.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}
.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-state-bullet-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}
.menu-state-bullet-primary .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-state-bullet-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}
.menu-state-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.menu-state-bullet-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}
.menu-state-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-primary);
}

.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}
.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-here-arrow-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}
.menu-here-arrow-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-show-arrow-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}
.menu-show-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-active-arrow-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}
.menu-active-arrow-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
}
.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}
.menu-state-arrow-primary .menu-item.here > .menu-link {
  transition: color 0.2s ease;
}
.menu-state-arrow-primary .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}
.menu-state-arrow-primary .menu-item.show > .menu-link {
  transition: color 0.2s ease;
}
.menu-state-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}
.menu-state-arrow-primary .menu-item .menu-link.active {
  transition: color 0.2s ease;
}
.menu-state-arrow-primary .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

.anchor {
  display: flex;
  align-items: center;
}
.anchor a {
  position: relative;
  display: none;
  align-items: center;
  justify-content: flex-start;
  height: 1em;
  width: 1.25em;
  margin-left: -1.25em;
  font-weight: 500;
  font-size: 0.8em;
  color: var(--kt-text-muted);
  transition: all 0.2s ease-in-out;
}
.anchor a:before {
  content: "#";
}
.anchor:hover a {
  display: flex;
}
.anchor:hover a:hover {
  color: var(--kt-primary);
  transition: all 0.2s ease-in-out;
}

.card {
  border: 0;
  box-shadow: var(--kt-card-box-shadow);
  background-color: var(--kt-card-bg);
}
.card .card-header {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  min-height: 70px;
  padding: 0 2.25rem;
  color: var(--kt-card-cap-color);
  background-color: var(--kt-card-cap-bg);
  border-bottom: 1px solid var(--kt-card-border-color);
}
.card .card-header .card-title {
  display: flex;
  align-items: center;
  margin: 0.5rem;
  margin-left: 0;
}
.card .card-header .card-title.flex-column {
  align-items: flex-start;
  justify-content: center;
}
.card .card-header .card-title .card-icon {
  margin-right: 0.75rem;
  line-height: 0;
}
.card .card-header .card-title .card-icon i {
  font-size: 1.25rem;
  color: var(--kt-gray-600);
  line-height: 0;
}
.card .card-header .card-title .card-icon i:after, .card .card-header .card-title .card-icon i:before {
  line-height: 0;
}
.card .card-header .card-title .card-icon .svg-icon {
  color: var(--kt-gray-600);
}
.card .card-header .card-title .card-icon .svg-icon svg {
  height: 24px;
  width: 24px;
}
.card .card-header .card-title,
.card .card-header .card-title .card-label {
  font-weight: 500;
  font-size: 1.275rem;
  color: var(--kt-text-dark);
}
.card .card-header .card-title .card-label {
  margin: 0 0.75rem 0 0;
  flex-wrap: wrap;
}
.card .card-header .card-title small, .card .card-header .card-title .small {
  color: var(--kt-text-muted);
  font-size: 1rem;
}
.card .card-header .card-title h1, .card .card-header .card-title .h1, .card .card-header .card-title h2, .card .card-header .card-title .h2, .card .card-header .card-title h3, .card .card-header .card-title .h3, .card .card-header .card-title h4, .card .card-header .card-title .h4, .card .card-header .card-title h5, .card .card-header .card-title .h5, .card .card-header .card-title h6, .card .card-header .card-title .h6 {
  margin-bottom: 0;
}
.card .card-header .card-toolbar {
  display: flex;
  align-items: center;
  margin: 0.5rem 0;
  flex-wrap: wrap;
}
.card .card-body {
  padding: 2rem 2.25rem;
  color: var(--kt-card-color);
}
.card .card-footer {
  padding: 2rem 2.25rem;
  color: var(--kt-card-cap-color);
  background-color: var(--kt-card-cap-bg);
  border-top: 1px solid var(--kt-card-border-color);
}
.card .card-scroll {
  position: relative;
  overflow: auto;
}
.card.card-px-0 .card-header,
.card.card-px-0 .card-body,
.card.card-px-0 .card-footer {
  padding-left: 0;
  padding-right: 0;
}
.card.card-py-0 .card-header,
.card.card-py-0 .card-body,
.card.card-py-0 .card-footer {
  padding-top: 0;
  padding-bottom: 0;
}
.card.card-p-0 .card-header,
.card.card-p-0 .card-body,
.card.card-p-0 .card-footer {
  padding: 0;
}
.card.card-dashed {
  box-shadow: none;
  border: 1px dashed var(--kt-card-border-dashed-color);
}
.card.card-dashed > .card-header {
  border-bottom: 1px dashed var(--kt-card-border-dashed-color);
}
.card.card-dashed > .card-footer {
  border-top: 1px dashed var(--kt-card-border-dashed-color);
}
.card.card-bordered {
  box-shadow: none;
  border: 1px solid var(--kt-card-border-color);
}
.card.card-flush > .card-header {
  border-bottom: 0 !important;
}
.card.card-flush > .card-footer {
  border-top: 0 !important;
}
.card.card-shadow {
  box-shadow: var(--kt-card-box-shadow);
  border: 0;
}
.card.card-reset {
  border: 0 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.card.card-reset > .card-header {
  border-bottom: 0 !important;
}
.card.card-reset > .card-footer {
  border-top: 0 !important;
}

.card.card-stretch {
  height: calc(100% - var(--bs-gutter-y));
}
.card.card-stretch-75 {
  height: calc(75% - var(--bs-gutter-y));
}
.card.card-stretch-50 {
  height: calc(50% - var(--bs-gutter-y));
}
.card.card-stretch-33 {
  height: calc(33.333% - var(--bs-gutter-y));
}
.card.card-stretch-25 {
  height: calc(25% - var(--bs-gutter-y));
}
.card .card-header-stretch {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  align-items: stretch;
}
.card .card-header-stretch .card-toolbar {
  margin: 0;
  align-items: stretch;
}
@media (min-width: 576px) {
  .card.card-sm-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-sm-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-sm-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-sm-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 768px) {
  .card.card-md-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-md-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-md-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-md-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 992px) {
  .card.card-lg-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-lg-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-lg-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-lg-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 1200px) {
  .card.card-xl-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-xl-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-xl-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-xl-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}
@media (min-width: 1400px) {
  .card.card-xxl-stretch {
    height: calc(100% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-75 {
    height: calc(75% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-50 {
    height: calc(50% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-33 {
    height: calc(33.333% - var(--bs-gutter-y));
  }
  .card.card-xxl-stretch-25 {
    height: calc(25% - var(--bs-gutter-y));
  }
  .card .card-header-xxl-stretch {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    align-items: stretch;
  }
  .card .card-header-xxl-stretch .card-toolbar {
    margin: 0;
    align-items: stretch;
  }
}

.card-p {
  padding: 2rem 2.25rem !important;
}

.card-px {
  padding-left: 2.25rem !important;
  padding-right: 2.25rem !important;
}

.card-shadow {
  box-shadow: var(--kt-card-box-shadow);
}

.card-py {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}

.card-rounded {
  border-radius: 0.625rem;
}

.card-rounded-start {
  border-top-left-radius: 0.625rem;
  border-bottom-left-radius: 0.625rem;
}

.card-rounded-end {
  border-top-right-radius: 0.625rem;
  border-bottom-right-radius: 0.625rem;
}

.card-rounded-top {
  border-top-left-radius: 0.625rem;
  border-top-right-radius: 0.625rem;
}

.card-rounded-bottom {
  border-bottom-left-radius: 0.625rem;
  border-bottom-right-radius: 0.625rem;
}

@media (max-width: 767.98px) {
  .card > .card-header:not(.flex-nowrap) {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
}
.breadcrumb {
  --bs-breadcrumb-bg: var(--kt-breadcrumb-bg);
  --bs-breadcrumb-divider-color: var(--kt-breadcrumb-divider-color);
  --bs-breadcrumb-item-active-color: var(--kt-breadcrumb-item-active-color);
  display: flex;
  align-items: center;
  background-color: transparent;
  padding: 0;
  margin: 0;
}
.breadcrumb .breadcrumb-item {
  display: flex;
  align-items: center;
  padding-left: 0;
  padding-right: 0.5rem;
}
.breadcrumb .breadcrumb-item:last-child {
  padding-right: 0;
}
.breadcrumb .breadcrumb-item:after {
  content: "/";
}
.breadcrumb .breadcrumb-item:before {
  display: none;
}
.breadcrumb .breadcrumb-item:last-child:after {
  display: none;
}

.breadcrumb-line .breadcrumb-item:after {
  content: "-";
}

.breadcrumb-dot .breadcrumb-item:after {
  content: "•";
}

.breadcrumb-separatorless .breadcrumb-item:after {
  display: none;
}

.btn {
  --bs-btn-color: var(--kt-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  outline: none !important;
}
.btn:not(.btn-shadow):not(.shadow):not(.shadow-sm):not(.shadow-lg):not(.shadow-xs) {
  box-shadow: none !important;
}
.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {
  border: 0;
  padding: calc(0.775rem + 1px) calc(1.5rem + 1px);
}
.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon).btn-lg, .btn-group-lg > .btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {
  padding: calc(0.825rem + 1px) calc(1.75rem + 1px);
}
.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon).btn-sm, .btn-group-sm > .btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {
  padding: calc(0.55rem + 1px) calc(1.25rem + 1px);
}
.btn.btn-link {
  border: 0;
  border-radius: 0;
  padding-left: 0 !important;
  padding-right: 0 !important;
  text-decoration: none;
  font-weight: 500;
}
.btn.btn-outline:not(.btn-outline-dashed) {
  border: 1px solid var(--kt-input-border-color);
}
.btn.btn-outline-dashed {
  border: 1px dashed var(--kt-input-border-color);
}
.btn.btn-flush {
  appearance: none;
  box-shadow: none;
  border-radius: 0;
  border: none;
  cursor: pointer;
  background-color: transparent;
  outline: none !important;
  margin: 0;
  padding: 0;
}
.btn.btn-flex {
  display: inline-flex;
  align-items: center;
}
.btn.btn-trim-start {
  justify-content: flex-start !important;
  padding-left: 0 !important;
}
.btn.btn-trim-end {
  justify-content: flex-end !important;
  padding-right: 0 !important;
}

.btn i {
  display: inline-flex;
  font-size: 1rem;
  padding-right: 0.35rem;
  vertical-align: middle;
  line-height: 0;
}
.btn .svg-icon {
  flex-shrink: 0;
  line-height: 0;
  margin-right: 0.5rem;
}
.btn.btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  height: calc(1.5em + 1.55rem + 2px);
  width: calc(1.5em + 1.55rem + 2px);
}
.btn.btn-icon:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush) {
  border: 0;
}
.btn.btn-icon.btn-sm, .btn-group-sm > .btn.btn-icon {
  height: calc(1.5em + 1.1rem + 2px);
  width: calc(1.5em + 1.1rem + 2px);
}
.btn.btn-icon.btn-lg, .btn-group-lg > .btn.btn-icon {
  height: calc(1.5em + 1.65rem + 2px);
  width: calc(1.5em + 1.65rem + 2px);
}
.btn.btn-icon.btn-circle {
  border-radius: 50%;
}
.btn.btn-icon i,
.btn.btn-icon .svg-icon {
  padding: 0;
  margin: 0;
  line-height: 1;
}

.btn.btn-outline.btn-outline-dashed {
  border-width: 1px;
  border-style: dashed;
}
.btn-check:checked + .btn.btn-outline.btn-outline-dashed, .btn-check:active + .btn.btn-outline.btn-outline-dashed, .btn.btn-outline.btn-outline-dashed:focus:not(.btn-active), .btn.btn-outline.btn-outline-dashed:hover:not(.btn-active), .btn.btn-outline.btn-outline-dashed:active:not(.btn-active), .btn.btn-outline.btn-outline-dashed.active, .btn.btn-outline.btn-outline-dashed.show, .show > .btn.btn-outline.btn-outline-dashed {
  border-color: var(--kt-primary);
}

.btn.btn-white {
  color: var(--kt-white-inverse);
  border-color: var(--kt-white);
  background-color: var(--kt-white);
}
.btn.btn-white i,
.btn.btn-white .svg-icon {
  color: var(--kt-white-inverse);
}
.btn.btn-white.dropdown-toggle:after {
  color: var(--kt-white-inverse);
}
.btn-check:checked + .btn.btn-white, .btn-check:active + .btn.btn-white, .btn.btn-white:focus:not(.btn-active), .btn.btn-white:hover:not(.btn-active), .btn.btn-white:active:not(.btn-active), .btn.btn-white.active, .btn.btn-white.show, .show > .btn.btn-white {
  color: var(--kt-white-inverse);
  border-color: var(--kt-white-active);
  background-color: var(--kt-white-active) !important;
}
.btn-check:checked + .btn.btn-white i,
.btn-check:checked + .btn.btn-white .svg-icon, .btn-check:active + .btn.btn-white i,
.btn-check:active + .btn.btn-white .svg-icon, .btn.btn-white:focus:not(.btn-active) i,
.btn.btn-white:focus:not(.btn-active) .svg-icon, .btn.btn-white:hover:not(.btn-active) i,
.btn.btn-white:hover:not(.btn-active) .svg-icon, .btn.btn-white:active:not(.btn-active) i,
.btn.btn-white:active:not(.btn-active) .svg-icon, .btn.btn-white.active i,
.btn.btn-white.active .svg-icon, .btn.btn-white.show i,
.btn.btn-white.show .svg-icon, .show > .btn.btn-white i,
.show > .btn.btn-white .svg-icon {
  color: var(--kt-white-inverse);
}
.btn-check:checked + .btn.btn-white.dropdown-toggle:after, .btn-check:active + .btn.btn-white.dropdown-toggle:after, .btn.btn-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-white.active.dropdown-toggle:after, .btn.btn-white.show.dropdown-toggle:after, .show > .btn.btn-white.dropdown-toggle:after {
  color: var(--kt-white-inverse);
}

.btn.btn-bg-white {
  border-color: var(--kt-white);
  background-color: var(--kt-white);
}
.btn-check:checked + .btn.btn-active-white, .btn-check:active + .btn.btn-active-white, .btn.btn-active-white:focus:not(.btn-active), .btn.btn-active-white:hover:not(.btn-active), .btn.btn-active-white:active:not(.btn-active), .btn.btn-active-white.active, .btn.btn-active-white.show, .show > .btn.btn-active-white {
  color: var(--kt-white-inverse);
  border-color: var(--kt-white);
  background-color: var(--kt-white) !important;
}
.btn-check:checked + .btn.btn-active-white i,
.btn-check:checked + .btn.btn-active-white .svg-icon, .btn-check:active + .btn.btn-active-white i,
.btn-check:active + .btn.btn-active-white .svg-icon, .btn.btn-active-white:focus:not(.btn-active) i,
.btn.btn-active-white:focus:not(.btn-active) .svg-icon, .btn.btn-active-white:hover:not(.btn-active) i,
.btn.btn-active-white:hover:not(.btn-active) .svg-icon, .btn.btn-active-white:active:not(.btn-active) i,
.btn.btn-active-white:active:not(.btn-active) .svg-icon, .btn.btn-active-white.active i,
.btn.btn-active-white.active .svg-icon, .btn.btn-active-white.show i,
.btn.btn-active-white.show .svg-icon, .show > .btn.btn-active-white i,
.show > .btn.btn-active-white .svg-icon {
  color: var(--kt-white-inverse);
}
.btn-check:checked + .btn.btn-active-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-white.dropdown-toggle:after, .btn.btn-active-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-white.active.dropdown-toggle:after, .btn.btn-active-white.show.dropdown-toggle:after, .show > .btn.btn-active-white.dropdown-toggle:after {
  color: var(--kt-white-inverse);
}

.btn.btn-outline.btn-outline-white {
  color: var(--kt-white);
  border-color: var(--kt-white);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-white i,
.btn.btn-outline.btn-outline-white .svg-icon {
  color: var(--kt-white);
}
.btn.btn-outline.btn-outline-white.dropdown-toggle:after {
  color: var(--kt-white);
}
.btn-check:checked + .btn.btn-outline.btn-outline-white, .btn-check:active + .btn.btn-outline.btn-outline-white, .btn.btn-outline.btn-outline-white:focus:not(.btn-active), .btn.btn-outline.btn-outline-white:hover:not(.btn-active), .btn.btn-outline.btn-outline-white:active:not(.btn-active), .btn.btn-outline.btn-outline-white.active, .btn.btn-outline.btn-outline-white.show, .show > .btn.btn-outline.btn-outline-white {
  color: var(--kt-white-active);
  border-color: var(--kt-white);
  background-color: var(--kt-white-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-white i,
.btn-check:checked + .btn.btn-outline.btn-outline-white .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-white i,
.btn-check:active + .btn.btn-outline.btn-outline-white .svg-icon, .btn.btn-outline.btn-outline-white:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-white:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-white:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-white:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-white:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-white:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-white.active i,
.btn.btn-outline.btn-outline-white.active .svg-icon, .btn.btn-outline.btn-outline-white.show i,
.btn.btn-outline.btn-outline-white.show .svg-icon, .show > .btn.btn-outline.btn-outline-white i,
.show > .btn.btn-outline.btn-outline-white .svg-icon {
  color: var(--kt-white-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-white.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-white.dropdown-toggle:after, .btn.btn-outline.btn-outline-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-white.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-white.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-white.dropdown-toggle:after {
  color: var(--kt-white-active);
}

.btn.btn-light {
  color: var(--kt-light-inverse);
  border-color: var(--kt-light);
  background-color: var(--kt-light);
}
.btn.btn-light i,
.btn.btn-light .svg-icon {
  color: var(--kt-light-inverse);
}
.btn.btn-light.dropdown-toggle:after {
  color: var(--kt-light-inverse);
}
.btn-check:checked + .btn.btn-light, .btn-check:active + .btn.btn-light, .btn.btn-light:focus:not(.btn-active), .btn.btn-light:hover:not(.btn-active), .btn.btn-light:active:not(.btn-active), .btn.btn-light.active, .btn.btn-light.show, .show > .btn.btn-light {
  color: var(--kt-light-inverse);
  border-color: var(--kt-light-active);
  background-color: var(--kt-light-active) !important;
}
.btn-check:checked + .btn.btn-light i,
.btn-check:checked + .btn.btn-light .svg-icon, .btn-check:active + .btn.btn-light i,
.btn-check:active + .btn.btn-light .svg-icon, .btn.btn-light:focus:not(.btn-active) i,
.btn.btn-light:focus:not(.btn-active) .svg-icon, .btn.btn-light:hover:not(.btn-active) i,
.btn.btn-light:hover:not(.btn-active) .svg-icon, .btn.btn-light:active:not(.btn-active) i,
.btn.btn-light:active:not(.btn-active) .svg-icon, .btn.btn-light.active i,
.btn.btn-light.active .svg-icon, .btn.btn-light.show i,
.btn.btn-light.show .svg-icon, .show > .btn.btn-light i,
.show > .btn.btn-light .svg-icon {
  color: var(--kt-light-inverse);
}
.btn-check:checked + .btn.btn-light.dropdown-toggle:after, .btn-check:active + .btn.btn-light.dropdown-toggle:after, .btn.btn-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light.active.dropdown-toggle:after, .btn.btn-light.show.dropdown-toggle:after, .show > .btn.btn-light.dropdown-toggle:after {
  color: var(--kt-light-inverse);
}

.btn.btn-bg-light {
  border-color: var(--kt-light);
  background-color: var(--kt-light);
}
.btn-check:checked + .btn.btn-active-light, .btn-check:active + .btn.btn-active-light, .btn.btn-active-light:focus:not(.btn-active), .btn.btn-active-light:hover:not(.btn-active), .btn.btn-active-light:active:not(.btn-active), .btn.btn-active-light.active, .btn.btn-active-light.show, .show > .btn.btn-active-light {
  color: var(--kt-light-inverse);
  border-color: var(--kt-light);
  background-color: var(--kt-light) !important;
}
.btn-check:checked + .btn.btn-active-light i,
.btn-check:checked + .btn.btn-active-light .svg-icon, .btn-check:active + .btn.btn-active-light i,
.btn-check:active + .btn.btn-active-light .svg-icon, .btn.btn-active-light:focus:not(.btn-active) i,
.btn.btn-active-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-light:hover:not(.btn-active) i,
.btn.btn-active-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-light:active:not(.btn-active) i,
.btn.btn-active-light:active:not(.btn-active) .svg-icon, .btn.btn-active-light.active i,
.btn.btn-active-light.active .svg-icon, .btn.btn-active-light.show i,
.btn.btn-active-light.show .svg-icon, .show > .btn.btn-active-light i,
.show > .btn.btn-active-light .svg-icon {
  color: var(--kt-light-inverse);
}
.btn-check:checked + .btn.btn-active-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light.dropdown-toggle:after, .btn.btn-active-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light.active.dropdown-toggle:after, .btn.btn-active-light.show.dropdown-toggle:after, .show > .btn.btn-active-light.dropdown-toggle:after {
  color: var(--kt-light-inverse);
}

.btn.btn-outline.btn-outline-light {
  color: var(--kt-light);
  border-color: var(--kt-light);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-light i,
.btn.btn-outline.btn-outline-light .svg-icon {
  color: var(--kt-light);
}
.btn.btn-outline.btn-outline-light.dropdown-toggle:after {
  color: var(--kt-light);
}
.btn-check:checked + .btn.btn-outline.btn-outline-light, .btn-check:active + .btn.btn-outline.btn-outline-light, .btn.btn-outline.btn-outline-light:focus:not(.btn-active), .btn.btn-outline.btn-outline-light:hover:not(.btn-active), .btn.btn-outline.btn-outline-light:active:not(.btn-active), .btn.btn-outline.btn-outline-light.active, .btn.btn-outline.btn-outline-light.show, .show > .btn.btn-outline.btn-outline-light {
  color: var(--kt-light-active);
  border-color: var(--kt-light);
  background-color: var(--kt-light-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-light i,
.btn-check:checked + .btn.btn-outline.btn-outline-light .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-light i,
.btn-check:active + .btn.btn-outline.btn-outline-light .svg-icon, .btn.btn-outline.btn-outline-light:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-light:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-light:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-light:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light.active i,
.btn.btn-outline.btn-outline-light.active .svg-icon, .btn.btn-outline.btn-outline-light.show i,
.btn.btn-outline.btn-outline-light.show .svg-icon, .show > .btn.btn-outline.btn-outline-light i,
.show > .btn.btn-outline.btn-outline-light .svg-icon {
  color: var(--kt-light-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-light.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-light.dropdown-toggle:after, .btn.btn-outline.btn-outline-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-light.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-light.dropdown-toggle:after {
  color: var(--kt-light-active);
}

.btn.btn-primary {
  color: var(--kt-primary-inverse);
  border-color: var(--kt-primary);
  background-color: var(--kt-primary);
}
.btn.btn-primary i,
.btn.btn-primary .svg-icon {
  color: var(--kt-primary-inverse);
}
.btn.btn-primary.dropdown-toggle:after {
  color: var(--kt-primary-inverse);
}
.btn-check:checked + .btn.btn-primary, .btn-check:active + .btn.btn-primary, .btn.btn-primary:focus:not(.btn-active), .btn.btn-primary:hover:not(.btn-active), .btn.btn-primary:active:not(.btn-active), .btn.btn-primary.active, .btn.btn-primary.show, .show > .btn.btn-primary {
  color: var(--kt-primary-inverse);
  border-color: var(--kt-primary-active);
  background-color: var(--kt-primary-active) !important;
}
.btn-check:checked + .btn.btn-primary i,
.btn-check:checked + .btn.btn-primary .svg-icon, .btn-check:active + .btn.btn-primary i,
.btn-check:active + .btn.btn-primary .svg-icon, .btn.btn-primary:focus:not(.btn-active) i,
.btn.btn-primary:focus:not(.btn-active) .svg-icon, .btn.btn-primary:hover:not(.btn-active) i,
.btn.btn-primary:hover:not(.btn-active) .svg-icon, .btn.btn-primary:active:not(.btn-active) i,
.btn.btn-primary:active:not(.btn-active) .svg-icon, .btn.btn-primary.active i,
.btn.btn-primary.active .svg-icon, .btn.btn-primary.show i,
.btn.btn-primary.show .svg-icon, .show > .btn.btn-primary i,
.show > .btn.btn-primary .svg-icon {
  color: var(--kt-primary-inverse);
}
.btn-check:checked + .btn.btn-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-primary.dropdown-toggle:after, .btn.btn-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-primary.active.dropdown-toggle:after, .btn.btn-primary.show.dropdown-toggle:after, .show > .btn.btn-primary.dropdown-toggle:after {
  color: var(--kt-primary-inverse);
}

.btn.btn-light-primary {
  color: var(--kt-primary);
  border-color: var(--kt-primary-light);
  background-color: var(--kt-primary-light);
}
.btn.btn-light-primary i,
.btn.btn-light-primary .svg-icon {
  color: var(--kt-primary);
}
.btn.btn-light-primary.dropdown-toggle:after {
  color: var(--kt-primary);
}
.btn-check:checked + .btn.btn-light-primary, .btn-check:active + .btn.btn-light-primary, .btn.btn-light-primary:focus:not(.btn-active), .btn.btn-light-primary:hover:not(.btn-active), .btn.btn-light-primary:active:not(.btn-active), .btn.btn-light-primary.active, .btn.btn-light-primary.show, .show > .btn.btn-light-primary {
  color: var(--kt-primary-inverse);
  border-color: var(--kt-primary);
  background-color: var(--kt-primary) !important;
}
.btn-check:checked + .btn.btn-light-primary i,
.btn-check:checked + .btn.btn-light-primary .svg-icon, .btn-check:active + .btn.btn-light-primary i,
.btn-check:active + .btn.btn-light-primary .svg-icon, .btn.btn-light-primary:focus:not(.btn-active) i,
.btn.btn-light-primary:focus:not(.btn-active) .svg-icon, .btn.btn-light-primary:hover:not(.btn-active) i,
.btn.btn-light-primary:hover:not(.btn-active) .svg-icon, .btn.btn-light-primary:active:not(.btn-active) i,
.btn.btn-light-primary:active:not(.btn-active) .svg-icon, .btn.btn-light-primary.active i,
.btn.btn-light-primary.active .svg-icon, .btn.btn-light-primary.show i,
.btn.btn-light-primary.show .svg-icon, .show > .btn.btn-light-primary i,
.show > .btn.btn-light-primary .svg-icon {
  color: var(--kt-primary-inverse);
}
.btn-check:checked + .btn.btn-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-light-primary.dropdown-toggle:after, .btn.btn-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary.active.dropdown-toggle:after, .btn.btn-light-primary.show.dropdown-toggle:after, .show > .btn.btn-light-primary.dropdown-toggle:after {
  color: var(--kt-primary-inverse);
}

.btn.btn-bg-primary {
  border-color: var(--kt-primary);
  background-color: var(--kt-primary);
}
.btn-check:checked + .btn.btn-active-primary, .btn-check:active + .btn.btn-active-primary, .btn.btn-active-primary:focus:not(.btn-active), .btn.btn-active-primary:hover:not(.btn-active), .btn.btn-active-primary:active:not(.btn-active), .btn.btn-active-primary.active, .btn.btn-active-primary.show, .show > .btn.btn-active-primary {
  color: var(--kt-primary-inverse);
  border-color: var(--kt-primary);
  background-color: var(--kt-primary) !important;
}
.btn-check:checked + .btn.btn-active-primary i,
.btn-check:checked + .btn.btn-active-primary .svg-icon, .btn-check:active + .btn.btn-active-primary i,
.btn-check:active + .btn.btn-active-primary .svg-icon, .btn.btn-active-primary:focus:not(.btn-active) i,
.btn.btn-active-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-primary:hover:not(.btn-active) i,
.btn.btn-active-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-primary:active:not(.btn-active) i,
.btn.btn-active-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-primary.active i,
.btn.btn-active-primary.active .svg-icon, .btn.btn-active-primary.show i,
.btn.btn-active-primary.show .svg-icon, .show > .btn.btn-active-primary i,
.show > .btn.btn-active-primary .svg-icon {
  color: var(--kt-primary-inverse);
}
.btn-check:checked + .btn.btn-active-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-primary.dropdown-toggle:after, .btn.btn-active-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary.active.dropdown-toggle:after, .btn.btn-active-primary.show.dropdown-toggle:after, .show > .btn.btn-active-primary.dropdown-toggle:after {
  color: var(--kt-primary-inverse);
}

.btn-check:checked + .btn.btn-active-light-primary, .btn-check:active + .btn.btn-active-light-primary, .btn.btn-active-light-primary:focus:not(.btn-active), .btn.btn-active-light-primary:hover:not(.btn-active), .btn.btn-active-light-primary:active:not(.btn-active), .btn.btn-active-light-primary.active, .btn.btn-active-light-primary.show, .show > .btn.btn-active-light-primary {
  color: var(--kt-primary);
  border-color: var(--kt-primary-light);
  background-color: var(--kt-primary-light) !important;
}
.btn-check:checked + .btn.btn-active-light-primary i,
.btn-check:checked + .btn.btn-active-light-primary .svg-icon, .btn-check:active + .btn.btn-active-light-primary i,
.btn-check:active + .btn.btn-active-light-primary .svg-icon, .btn.btn-active-light-primary:focus:not(.btn-active) i,
.btn.btn-active-light-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-primary:hover:not(.btn-active) i,
.btn.btn-active-light-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-primary:active:not(.btn-active) i,
.btn.btn-active-light-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-light-primary.active i,
.btn.btn-active-light-primary.active .svg-icon, .btn.btn-active-light-primary.show i,
.btn.btn-active-light-primary.show .svg-icon, .show > .btn.btn-active-light-primary i,
.show > .btn.btn-active-light-primary .svg-icon {
  color: var(--kt-primary);
}
.btn-check:checked + .btn.btn-active-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-primary.dropdown-toggle:after, .btn.btn-active-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary.active.dropdown-toggle:after, .btn.btn-active-light-primary.show.dropdown-toggle:after, .show > .btn.btn-active-light-primary.dropdown-toggle:after {
  color: var(--kt-primary);
}

.btn.btn-outline.btn-outline-primary {
  color: var(--kt-primary);
  border-color: var(--kt-primary);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-primary i,
.btn.btn-outline.btn-outline-primary .svg-icon {
  color: var(--kt-primary);
}
.btn.btn-outline.btn-outline-primary.dropdown-toggle:after {
  color: var(--kt-primary);
}
.btn-check:checked + .btn.btn-outline.btn-outline-primary, .btn-check:active + .btn.btn-outline.btn-outline-primary, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active), .btn.btn-outline.btn-outline-primary:hover:not(.btn-active), .btn.btn-outline.btn-outline-primary:active:not(.btn-active), .btn.btn-outline.btn-outline-primary.active, .btn.btn-outline.btn-outline-primary.show, .show > .btn.btn-outline.btn-outline-primary {
  color: var(--kt-primary-active);
  border-color: var(--kt-primary);
  background-color: var(--kt-primary-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-primary i,
.btn-check:checked + .btn.btn-outline.btn-outline-primary .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-primary i,
.btn-check:active + .btn.btn-outline.btn-outline-primary .svg-icon, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-primary:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-primary:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-primary:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary.active i,
.btn.btn-outline.btn-outline-primary.active .svg-icon, .btn.btn-outline.btn-outline-primary.show i,
.btn.btn-outline.btn-outline-primary.show .svg-icon, .show > .btn.btn-outline.btn-outline-primary i,
.show > .btn.btn-outline.btn-outline-primary .svg-icon {
  color: var(--kt-primary-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-primary.dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-primary.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-primary.dropdown-toggle:after {
  color: var(--kt-primary-active);
}

.btn.btn-secondary {
  color: var(--kt-secondary-inverse);
  border-color: var(--kt-secondary);
  background-color: var(--kt-secondary);
}
.btn.btn-secondary i,
.btn.btn-secondary .svg-icon {
  color: var(--kt-secondary-inverse);
}
.btn.btn-secondary.dropdown-toggle:after {
  color: var(--kt-secondary-inverse);
}
.btn-check:checked + .btn.btn-secondary, .btn-check:active + .btn.btn-secondary, .btn.btn-secondary:focus:not(.btn-active), .btn.btn-secondary:hover:not(.btn-active), .btn.btn-secondary:active:not(.btn-active), .btn.btn-secondary.active, .btn.btn-secondary.show, .show > .btn.btn-secondary {
  color: var(--kt-secondary-inverse);
  border-color: var(--kt-secondary-active);
  background-color: var(--kt-secondary-active) !important;
}
.btn-check:checked + .btn.btn-secondary i,
.btn-check:checked + .btn.btn-secondary .svg-icon, .btn-check:active + .btn.btn-secondary i,
.btn-check:active + .btn.btn-secondary .svg-icon, .btn.btn-secondary:focus:not(.btn-active) i,
.btn.btn-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-secondary:hover:not(.btn-active) i,
.btn.btn-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-secondary:active:not(.btn-active) i,
.btn.btn-secondary:active:not(.btn-active) .svg-icon, .btn.btn-secondary.active i,
.btn.btn-secondary.active .svg-icon, .btn.btn-secondary.show i,
.btn.btn-secondary.show .svg-icon, .show > .btn.btn-secondary i,
.show > .btn.btn-secondary .svg-icon {
  color: var(--kt-secondary-inverse);
}
.btn-check:checked + .btn.btn-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-secondary.dropdown-toggle:after, .btn.btn-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary.active.dropdown-toggle:after, .btn.btn-secondary.show.dropdown-toggle:after, .show > .btn.btn-secondary.dropdown-toggle:after {
  color: var(--kt-secondary-inverse);
}

.btn.btn-light-secondary {
  color: var(--kt-secondary);
  border-color: var(--kt-secondary-light);
  background-color: var(--kt-secondary-light);
}
.btn.btn-light-secondary i,
.btn.btn-light-secondary .svg-icon {
  color: var(--kt-secondary);
}
.btn.btn-light-secondary.dropdown-toggle:after {
  color: var(--kt-secondary);
}
.btn-check:checked + .btn.btn-light-secondary, .btn-check:active + .btn.btn-light-secondary, .btn.btn-light-secondary:focus:not(.btn-active), .btn.btn-light-secondary:hover:not(.btn-active), .btn.btn-light-secondary:active:not(.btn-active), .btn.btn-light-secondary.active, .btn.btn-light-secondary.show, .show > .btn.btn-light-secondary {
  color: var(--kt-secondary-inverse);
  border-color: var(--kt-secondary);
  background-color: var(--kt-secondary) !important;
}
.btn-check:checked + .btn.btn-light-secondary i,
.btn-check:checked + .btn.btn-light-secondary .svg-icon, .btn-check:active + .btn.btn-light-secondary i,
.btn-check:active + .btn.btn-light-secondary .svg-icon, .btn.btn-light-secondary:focus:not(.btn-active) i,
.btn.btn-light-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-light-secondary:hover:not(.btn-active) i,
.btn.btn-light-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-light-secondary:active:not(.btn-active) i,
.btn.btn-light-secondary:active:not(.btn-active) .svg-icon, .btn.btn-light-secondary.active i,
.btn.btn-light-secondary.active .svg-icon, .btn.btn-light-secondary.show i,
.btn.btn-light-secondary.show .svg-icon, .show > .btn.btn-light-secondary i,
.show > .btn.btn-light-secondary .svg-icon {
  color: var(--kt-secondary-inverse);
}
.btn-check:checked + .btn.btn-light-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-light-secondary.dropdown-toggle:after, .btn.btn-light-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary.active.dropdown-toggle:after, .btn.btn-light-secondary.show.dropdown-toggle:after, .show > .btn.btn-light-secondary.dropdown-toggle:after {
  color: var(--kt-secondary-inverse);
}

.btn.btn-bg-secondary {
  border-color: var(--kt-secondary);
  background-color: var(--kt-secondary);
}
.btn-check:checked + .btn.btn-active-secondary, .btn-check:active + .btn.btn-active-secondary, .btn.btn-active-secondary:focus:not(.btn-active), .btn.btn-active-secondary:hover:not(.btn-active), .btn.btn-active-secondary:active:not(.btn-active), .btn.btn-active-secondary.active, .btn.btn-active-secondary.show, .show > .btn.btn-active-secondary {
  color: var(--kt-secondary-inverse);
  border-color: var(--kt-secondary);
  background-color: var(--kt-secondary) !important;
}
.btn-check:checked + .btn.btn-active-secondary i,
.btn-check:checked + .btn.btn-active-secondary .svg-icon, .btn-check:active + .btn.btn-active-secondary i,
.btn-check:active + .btn.btn-active-secondary .svg-icon, .btn.btn-active-secondary:focus:not(.btn-active) i,
.btn.btn-active-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-secondary:hover:not(.btn-active) i,
.btn.btn-active-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-secondary:active:not(.btn-active) i,
.btn.btn-active-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-secondary.active i,
.btn.btn-active-secondary.active .svg-icon, .btn.btn-active-secondary.show i,
.btn.btn-active-secondary.show .svg-icon, .show > .btn.btn-active-secondary i,
.show > .btn.btn-active-secondary .svg-icon {
  color: var(--kt-secondary-inverse);
}
.btn-check:checked + .btn.btn-active-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-secondary.dropdown-toggle:after, .btn.btn-active-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary.active.dropdown-toggle:after, .btn.btn-active-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-secondary.dropdown-toggle:after {
  color: var(--kt-secondary-inverse);
}

.btn-check:checked + .btn.btn-active-light-secondary, .btn-check:active + .btn.btn-active-light-secondary, .btn.btn-active-light-secondary:focus:not(.btn-active), .btn.btn-active-light-secondary:hover:not(.btn-active), .btn.btn-active-light-secondary:active:not(.btn-active), .btn.btn-active-light-secondary.active, .btn.btn-active-light-secondary.show, .show > .btn.btn-active-light-secondary {
  color: var(--kt-secondary);
  border-color: var(--kt-secondary-light);
  background-color: var(--kt-secondary-light) !important;
}
.btn-check:checked + .btn.btn-active-light-secondary i,
.btn-check:checked + .btn.btn-active-light-secondary .svg-icon, .btn-check:active + .btn.btn-active-light-secondary i,
.btn-check:active + .btn.btn-active-light-secondary .svg-icon, .btn.btn-active-light-secondary:focus:not(.btn-active) i,
.btn.btn-active-light-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary:hover:not(.btn-active) i,
.btn.btn-active-light-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary:active:not(.btn-active) i,
.btn.btn-active-light-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary.active i,
.btn.btn-active-light-secondary.active .svg-icon, .btn.btn-active-light-secondary.show i,
.btn.btn-active-light-secondary.show .svg-icon, .show > .btn.btn-active-light-secondary i,
.show > .btn.btn-active-light-secondary .svg-icon {
  color: var(--kt-secondary);
}
.btn-check:checked + .btn.btn-active-light-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-secondary.dropdown-toggle:after, .btn.btn-active-light-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary.active.dropdown-toggle:after, .btn.btn-active-light-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-light-secondary.dropdown-toggle:after {
  color: var(--kt-secondary);
}

.btn.btn-outline.btn-outline-secondary {
  color: var(--kt-secondary);
  border-color: var(--kt-secondary);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-secondary i,
.btn.btn-outline.btn-outline-secondary .svg-icon {
  color: var(--kt-secondary);
}
.btn.btn-outline.btn-outline-secondary.dropdown-toggle:after {
  color: var(--kt-secondary);
}
.btn-check:checked + .btn.btn-outline.btn-outline-secondary, .btn-check:active + .btn.btn-outline.btn-outline-secondary, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active), .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active), .btn.btn-outline.btn-outline-secondary:active:not(.btn-active), .btn.btn-outline.btn-outline-secondary.active, .btn.btn-outline.btn-outline-secondary.show, .show > .btn.btn-outline.btn-outline-secondary {
  color: var(--kt-secondary-active);
  border-color: var(--kt-secondary);
  background-color: var(--kt-secondary-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-secondary i,
.btn-check:checked + .btn.btn-outline.btn-outline-secondary .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-secondary i,
.btn-check:active + .btn.btn-outline.btn-outline-secondary .svg-icon, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-secondary:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary.active i,
.btn.btn-outline.btn-outline-secondary.active .svg-icon, .btn.btn-outline.btn-outline-secondary.show i,
.btn.btn-outline.btn-outline-secondary.show .svg-icon, .show > .btn.btn-outline.btn-outline-secondary i,
.show > .btn.btn-outline.btn-outline-secondary .svg-icon {
  color: var(--kt-secondary-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after {
  color: var(--kt-secondary-active);
}

.btn.btn-success {
  color: var(--kt-success-inverse);
  border-color: var(--kt-success);
  background-color: var(--kt-success);
}
.btn.btn-success i,
.btn.btn-success .svg-icon {
  color: var(--kt-success-inverse);
}
.btn.btn-success.dropdown-toggle:after {
  color: var(--kt-success-inverse);
}
.btn-check:checked + .btn.btn-success, .btn-check:active + .btn.btn-success, .btn.btn-success:focus:not(.btn-active), .btn.btn-success:hover:not(.btn-active), .btn.btn-success:active:not(.btn-active), .btn.btn-success.active, .btn.btn-success.show, .show > .btn.btn-success {
  color: var(--kt-success-inverse);
  border-color: var(--kt-success-active);
  background-color: var(--kt-success-active) !important;
}
.btn-check:checked + .btn.btn-success i,
.btn-check:checked + .btn.btn-success .svg-icon, .btn-check:active + .btn.btn-success i,
.btn-check:active + .btn.btn-success .svg-icon, .btn.btn-success:focus:not(.btn-active) i,
.btn.btn-success:focus:not(.btn-active) .svg-icon, .btn.btn-success:hover:not(.btn-active) i,
.btn.btn-success:hover:not(.btn-active) .svg-icon, .btn.btn-success:active:not(.btn-active) i,
.btn.btn-success:active:not(.btn-active) .svg-icon, .btn.btn-success.active i,
.btn.btn-success.active .svg-icon, .btn.btn-success.show i,
.btn.btn-success.show .svg-icon, .show > .btn.btn-success i,
.show > .btn.btn-success .svg-icon {
  color: var(--kt-success-inverse);
}
.btn-check:checked + .btn.btn-success.dropdown-toggle:after, .btn-check:active + .btn.btn-success.dropdown-toggle:after, .btn.btn-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-success.active.dropdown-toggle:after, .btn.btn-success.show.dropdown-toggle:after, .show > .btn.btn-success.dropdown-toggle:after {
  color: var(--kt-success-inverse);
}

.btn.btn-light-success {
  color: var(--kt-success);
  border-color: var(--kt-success-light);
  background-color: var(--kt-success-light);
}
.btn.btn-light-success i,
.btn.btn-light-success .svg-icon {
  color: var(--kt-success);
}
.btn.btn-light-success.dropdown-toggle:after {
  color: var(--kt-success);
}
.btn-check:checked + .btn.btn-light-success, .btn-check:active + .btn.btn-light-success, .btn.btn-light-success:focus:not(.btn-active), .btn.btn-light-success:hover:not(.btn-active), .btn.btn-light-success:active:not(.btn-active), .btn.btn-light-success.active, .btn.btn-light-success.show, .show > .btn.btn-light-success {
  color: var(--kt-success-inverse);
  border-color: var(--kt-success);
  background-color: var(--kt-success) !important;
}
.btn-check:checked + .btn.btn-light-success i,
.btn-check:checked + .btn.btn-light-success .svg-icon, .btn-check:active + .btn.btn-light-success i,
.btn-check:active + .btn.btn-light-success .svg-icon, .btn.btn-light-success:focus:not(.btn-active) i,
.btn.btn-light-success:focus:not(.btn-active) .svg-icon, .btn.btn-light-success:hover:not(.btn-active) i,
.btn.btn-light-success:hover:not(.btn-active) .svg-icon, .btn.btn-light-success:active:not(.btn-active) i,
.btn.btn-light-success:active:not(.btn-active) .svg-icon, .btn.btn-light-success.active i,
.btn.btn-light-success.active .svg-icon, .btn.btn-light-success.show i,
.btn.btn-light-success.show .svg-icon, .show > .btn.btn-light-success i,
.show > .btn.btn-light-success .svg-icon {
  color: var(--kt-success-inverse);
}
.btn-check:checked + .btn.btn-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-light-success.dropdown-toggle:after, .btn.btn-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success.active.dropdown-toggle:after, .btn.btn-light-success.show.dropdown-toggle:after, .show > .btn.btn-light-success.dropdown-toggle:after {
  color: var(--kt-success-inverse);
}

.btn.btn-bg-success {
  border-color: var(--kt-success);
  background-color: var(--kt-success);
}
.btn-check:checked + .btn.btn-active-success, .btn-check:active + .btn.btn-active-success, .btn.btn-active-success:focus:not(.btn-active), .btn.btn-active-success:hover:not(.btn-active), .btn.btn-active-success:active:not(.btn-active), .btn.btn-active-success.active, .btn.btn-active-success.show, .show > .btn.btn-active-success {
  color: var(--kt-success-inverse);
  border-color: var(--kt-success);
  background-color: var(--kt-success) !important;
}
.btn-check:checked + .btn.btn-active-success i,
.btn-check:checked + .btn.btn-active-success .svg-icon, .btn-check:active + .btn.btn-active-success i,
.btn-check:active + .btn.btn-active-success .svg-icon, .btn.btn-active-success:focus:not(.btn-active) i,
.btn.btn-active-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-success:hover:not(.btn-active) i,
.btn.btn-active-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-success:active:not(.btn-active) i,
.btn.btn-active-success:active:not(.btn-active) .svg-icon, .btn.btn-active-success.active i,
.btn.btn-active-success.active .svg-icon, .btn.btn-active-success.show i,
.btn.btn-active-success.show .svg-icon, .show > .btn.btn-active-success i,
.show > .btn.btn-active-success .svg-icon {
  color: var(--kt-success-inverse);
}
.btn-check:checked + .btn.btn-active-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-success.dropdown-toggle:after, .btn.btn-active-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success.active.dropdown-toggle:after, .btn.btn-active-success.show.dropdown-toggle:after, .show > .btn.btn-active-success.dropdown-toggle:after {
  color: var(--kt-success-inverse);
}

.btn-check:checked + .btn.btn-active-light-success, .btn-check:active + .btn.btn-active-light-success, .btn.btn-active-light-success:focus:not(.btn-active), .btn.btn-active-light-success:hover:not(.btn-active), .btn.btn-active-light-success:active:not(.btn-active), .btn.btn-active-light-success.active, .btn.btn-active-light-success.show, .show > .btn.btn-active-light-success {
  color: var(--kt-success);
  border-color: var(--kt-success-light);
  background-color: var(--kt-success-light) !important;
}
.btn-check:checked + .btn.btn-active-light-success i,
.btn-check:checked + .btn.btn-active-light-success .svg-icon, .btn-check:active + .btn.btn-active-light-success i,
.btn-check:active + .btn.btn-active-light-success .svg-icon, .btn.btn-active-light-success:focus:not(.btn-active) i,
.btn.btn-active-light-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-success:hover:not(.btn-active) i,
.btn.btn-active-light-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-success:active:not(.btn-active) i,
.btn.btn-active-light-success:active:not(.btn-active) .svg-icon, .btn.btn-active-light-success.active i,
.btn.btn-active-light-success.active .svg-icon, .btn.btn-active-light-success.show i,
.btn.btn-active-light-success.show .svg-icon, .show > .btn.btn-active-light-success i,
.show > .btn.btn-active-light-success .svg-icon {
  color: var(--kt-success);
}
.btn-check:checked + .btn.btn-active-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-success.dropdown-toggle:after, .btn.btn-active-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success.active.dropdown-toggle:after, .btn.btn-active-light-success.show.dropdown-toggle:after, .show > .btn.btn-active-light-success.dropdown-toggle:after {
  color: var(--kt-success);
}

.btn.btn-outline.btn-outline-success {
  color: var(--kt-success);
  border-color: var(--kt-success);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-success i,
.btn.btn-outline.btn-outline-success .svg-icon {
  color: var(--kt-success);
}
.btn.btn-outline.btn-outline-success.dropdown-toggle:after {
  color: var(--kt-success);
}
.btn-check:checked + .btn.btn-outline.btn-outline-success, .btn-check:active + .btn.btn-outline.btn-outline-success, .btn.btn-outline.btn-outline-success:focus:not(.btn-active), .btn.btn-outline.btn-outline-success:hover:not(.btn-active), .btn.btn-outline.btn-outline-success:active:not(.btn-active), .btn.btn-outline.btn-outline-success.active, .btn.btn-outline.btn-outline-success.show, .show > .btn.btn-outline.btn-outline-success {
  color: var(--kt-success-active);
  border-color: var(--kt-success);
  background-color: var(--kt-success-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-success i,
.btn-check:checked + .btn.btn-outline.btn-outline-success .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-success i,
.btn-check:active + .btn.btn-outline.btn-outline-success .svg-icon, .btn.btn-outline.btn-outline-success:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-success:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-success:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-success:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success.active i,
.btn.btn-outline.btn-outline-success.active .svg-icon, .btn.btn-outline.btn-outline-success.show i,
.btn.btn-outline.btn-outline-success.show .svg-icon, .show > .btn.btn-outline.btn-outline-success i,
.show > .btn.btn-outline.btn-outline-success .svg-icon {
  color: var(--kt-success-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-success.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-success.dropdown-toggle:after, .btn.btn-outline.btn-outline-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-success.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-success.dropdown-toggle:after {
  color: var(--kt-success-active);
}

.btn.btn-info {
  color: var(--kt-info-inverse);
  border-color: var(--kt-info);
  background-color: var(--kt-info);
}
.btn.btn-info i,
.btn.btn-info .svg-icon {
  color: var(--kt-info-inverse);
}
.btn.btn-info.dropdown-toggle:after {
  color: var(--kt-info-inverse);
}
.btn-check:checked + .btn.btn-info, .btn-check:active + .btn.btn-info, .btn.btn-info:focus:not(.btn-active), .btn.btn-info:hover:not(.btn-active), .btn.btn-info:active:not(.btn-active), .btn.btn-info.active, .btn.btn-info.show, .show > .btn.btn-info {
  color: var(--kt-info-inverse);
  border-color: var(--kt-info-active);
  background-color: var(--kt-info-active) !important;
}
.btn-check:checked + .btn.btn-info i,
.btn-check:checked + .btn.btn-info .svg-icon, .btn-check:active + .btn.btn-info i,
.btn-check:active + .btn.btn-info .svg-icon, .btn.btn-info:focus:not(.btn-active) i,
.btn.btn-info:focus:not(.btn-active) .svg-icon, .btn.btn-info:hover:not(.btn-active) i,
.btn.btn-info:hover:not(.btn-active) .svg-icon, .btn.btn-info:active:not(.btn-active) i,
.btn.btn-info:active:not(.btn-active) .svg-icon, .btn.btn-info.active i,
.btn.btn-info.active .svg-icon, .btn.btn-info.show i,
.btn.btn-info.show .svg-icon, .show > .btn.btn-info i,
.show > .btn.btn-info .svg-icon {
  color: var(--kt-info-inverse);
}
.btn-check:checked + .btn.btn-info.dropdown-toggle:after, .btn-check:active + .btn.btn-info.dropdown-toggle:after, .btn.btn-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-info.active.dropdown-toggle:after, .btn.btn-info.show.dropdown-toggle:after, .show > .btn.btn-info.dropdown-toggle:after {
  color: var(--kt-info-inverse);
}

.btn.btn-light-info {
  color: var(--kt-info);
  border-color: var(--kt-info-light);
  background-color: var(--kt-info-light);
}
.btn.btn-light-info i,
.btn.btn-light-info .svg-icon {
  color: var(--kt-info);
}
.btn.btn-light-info.dropdown-toggle:after {
  color: var(--kt-info);
}
.btn-check:checked + .btn.btn-light-info, .btn-check:active + .btn.btn-light-info, .btn.btn-light-info:focus:not(.btn-active), .btn.btn-light-info:hover:not(.btn-active), .btn.btn-light-info:active:not(.btn-active), .btn.btn-light-info.active, .btn.btn-light-info.show, .show > .btn.btn-light-info {
  color: var(--kt-info-inverse);
  border-color: var(--kt-info);
  background-color: var(--kt-info) !important;
}
.btn-check:checked + .btn.btn-light-info i,
.btn-check:checked + .btn.btn-light-info .svg-icon, .btn-check:active + .btn.btn-light-info i,
.btn-check:active + .btn.btn-light-info .svg-icon, .btn.btn-light-info:focus:not(.btn-active) i,
.btn.btn-light-info:focus:not(.btn-active) .svg-icon, .btn.btn-light-info:hover:not(.btn-active) i,
.btn.btn-light-info:hover:not(.btn-active) .svg-icon, .btn.btn-light-info:active:not(.btn-active) i,
.btn.btn-light-info:active:not(.btn-active) .svg-icon, .btn.btn-light-info.active i,
.btn.btn-light-info.active .svg-icon, .btn.btn-light-info.show i,
.btn.btn-light-info.show .svg-icon, .show > .btn.btn-light-info i,
.show > .btn.btn-light-info .svg-icon {
  color: var(--kt-info-inverse);
}
.btn-check:checked + .btn.btn-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-light-info.dropdown-toggle:after, .btn.btn-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info.active.dropdown-toggle:after, .btn.btn-light-info.show.dropdown-toggle:after, .show > .btn.btn-light-info.dropdown-toggle:after {
  color: var(--kt-info-inverse);
}

.btn.btn-bg-info {
  border-color: var(--kt-info);
  background-color: var(--kt-info);
}
.btn-check:checked + .btn.btn-active-info, .btn-check:active + .btn.btn-active-info, .btn.btn-active-info:focus:not(.btn-active), .btn.btn-active-info:hover:not(.btn-active), .btn.btn-active-info:active:not(.btn-active), .btn.btn-active-info.active, .btn.btn-active-info.show, .show > .btn.btn-active-info {
  color: var(--kt-info-inverse);
  border-color: var(--kt-info);
  background-color: var(--kt-info) !important;
}
.btn-check:checked + .btn.btn-active-info i,
.btn-check:checked + .btn.btn-active-info .svg-icon, .btn-check:active + .btn.btn-active-info i,
.btn-check:active + .btn.btn-active-info .svg-icon, .btn.btn-active-info:focus:not(.btn-active) i,
.btn.btn-active-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-info:hover:not(.btn-active) i,
.btn.btn-active-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-info:active:not(.btn-active) i,
.btn.btn-active-info:active:not(.btn-active) .svg-icon, .btn.btn-active-info.active i,
.btn.btn-active-info.active .svg-icon, .btn.btn-active-info.show i,
.btn.btn-active-info.show .svg-icon, .show > .btn.btn-active-info i,
.show > .btn.btn-active-info .svg-icon {
  color: var(--kt-info-inverse);
}
.btn-check:checked + .btn.btn-active-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-info.dropdown-toggle:after, .btn.btn-active-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info.active.dropdown-toggle:after, .btn.btn-active-info.show.dropdown-toggle:after, .show > .btn.btn-active-info.dropdown-toggle:after {
  color: var(--kt-info-inverse);
}

.btn-check:checked + .btn.btn-active-light-info, .btn-check:active + .btn.btn-active-light-info, .btn.btn-active-light-info:focus:not(.btn-active), .btn.btn-active-light-info:hover:not(.btn-active), .btn.btn-active-light-info:active:not(.btn-active), .btn.btn-active-light-info.active, .btn.btn-active-light-info.show, .show > .btn.btn-active-light-info {
  color: var(--kt-info);
  border-color: var(--kt-info-light);
  background-color: var(--kt-info-light) !important;
}
.btn-check:checked + .btn.btn-active-light-info i,
.btn-check:checked + .btn.btn-active-light-info .svg-icon, .btn-check:active + .btn.btn-active-light-info i,
.btn-check:active + .btn.btn-active-light-info .svg-icon, .btn.btn-active-light-info:focus:not(.btn-active) i,
.btn.btn-active-light-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-info:hover:not(.btn-active) i,
.btn.btn-active-light-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-info:active:not(.btn-active) i,
.btn.btn-active-light-info:active:not(.btn-active) .svg-icon, .btn.btn-active-light-info.active i,
.btn.btn-active-light-info.active .svg-icon, .btn.btn-active-light-info.show i,
.btn.btn-active-light-info.show .svg-icon, .show > .btn.btn-active-light-info i,
.show > .btn.btn-active-light-info .svg-icon {
  color: var(--kt-info);
}
.btn-check:checked + .btn.btn-active-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-info.dropdown-toggle:after, .btn.btn-active-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info.active.dropdown-toggle:after, .btn.btn-active-light-info.show.dropdown-toggle:after, .show > .btn.btn-active-light-info.dropdown-toggle:after {
  color: var(--kt-info);
}

.btn.btn-outline.btn-outline-info {
  color: var(--kt-info);
  border-color: var(--kt-info);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-info i,
.btn.btn-outline.btn-outline-info .svg-icon {
  color: var(--kt-info);
}
.btn.btn-outline.btn-outline-info.dropdown-toggle:after {
  color: var(--kt-info);
}
.btn-check:checked + .btn.btn-outline.btn-outline-info, .btn-check:active + .btn.btn-outline.btn-outline-info, .btn.btn-outline.btn-outline-info:focus:not(.btn-active), .btn.btn-outline.btn-outline-info:hover:not(.btn-active), .btn.btn-outline.btn-outline-info:active:not(.btn-active), .btn.btn-outline.btn-outline-info.active, .btn.btn-outline.btn-outline-info.show, .show > .btn.btn-outline.btn-outline-info {
  color: var(--kt-info-active);
  border-color: var(--kt-info);
  background-color: var(--kt-info-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-info i,
.btn-check:checked + .btn.btn-outline.btn-outline-info .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-info i,
.btn-check:active + .btn.btn-outline.btn-outline-info .svg-icon, .btn.btn-outline.btn-outline-info:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-info:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-info:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-info:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info.active i,
.btn.btn-outline.btn-outline-info.active .svg-icon, .btn.btn-outline.btn-outline-info.show i,
.btn.btn-outline.btn-outline-info.show .svg-icon, .show > .btn.btn-outline.btn-outline-info i,
.show > .btn.btn-outline.btn-outline-info .svg-icon {
  color: var(--kt-info-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-info.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-info.dropdown-toggle:after, .btn.btn-outline.btn-outline-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-info.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-info.dropdown-toggle:after {
  color: var(--kt-info-active);
}

.btn.btn-warning {
  color: var(--kt-warning-inverse);
  border-color: var(--kt-warning);
  background-color: var(--kt-warning);
}
.btn.btn-warning i,
.btn.btn-warning .svg-icon {
  color: var(--kt-warning-inverse);
}
.btn.btn-warning.dropdown-toggle:after {
  color: var(--kt-warning-inverse);
}
.btn-check:checked + .btn.btn-warning, .btn-check:active + .btn.btn-warning, .btn.btn-warning:focus:not(.btn-active), .btn.btn-warning:hover:not(.btn-active), .btn.btn-warning:active:not(.btn-active), .btn.btn-warning.active, .btn.btn-warning.show, .show > .btn.btn-warning {
  color: var(--kt-warning-inverse);
  border-color: var(--kt-warning-active);
  background-color: var(--kt-warning-active) !important;
}
.btn-check:checked + .btn.btn-warning i,
.btn-check:checked + .btn.btn-warning .svg-icon, .btn-check:active + .btn.btn-warning i,
.btn-check:active + .btn.btn-warning .svg-icon, .btn.btn-warning:focus:not(.btn-active) i,
.btn.btn-warning:focus:not(.btn-active) .svg-icon, .btn.btn-warning:hover:not(.btn-active) i,
.btn.btn-warning:hover:not(.btn-active) .svg-icon, .btn.btn-warning:active:not(.btn-active) i,
.btn.btn-warning:active:not(.btn-active) .svg-icon, .btn.btn-warning.active i,
.btn.btn-warning.active .svg-icon, .btn.btn-warning.show i,
.btn.btn-warning.show .svg-icon, .show > .btn.btn-warning i,
.show > .btn.btn-warning .svg-icon {
  color: var(--kt-warning-inverse);
}
.btn-check:checked + .btn.btn-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-warning.dropdown-toggle:after, .btn.btn-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-warning.active.dropdown-toggle:after, .btn.btn-warning.show.dropdown-toggle:after, .show > .btn.btn-warning.dropdown-toggle:after {
  color: var(--kt-warning-inverse);
}

.btn.btn-light-warning {
  color: var(--kt-warning);
  border-color: var(--kt-warning-light);
  background-color: var(--kt-warning-light);
}
.btn.btn-light-warning i,
.btn.btn-light-warning .svg-icon {
  color: var(--kt-warning);
}
.btn.btn-light-warning.dropdown-toggle:after {
  color: var(--kt-warning);
}
.btn-check:checked + .btn.btn-light-warning, .btn-check:active + .btn.btn-light-warning, .btn.btn-light-warning:focus:not(.btn-active), .btn.btn-light-warning:hover:not(.btn-active), .btn.btn-light-warning:active:not(.btn-active), .btn.btn-light-warning.active, .btn.btn-light-warning.show, .show > .btn.btn-light-warning {
  color: var(--kt-warning-inverse);
  border-color: var(--kt-warning);
  background-color: var(--kt-warning) !important;
}
.btn-check:checked + .btn.btn-light-warning i,
.btn-check:checked + .btn.btn-light-warning .svg-icon, .btn-check:active + .btn.btn-light-warning i,
.btn-check:active + .btn.btn-light-warning .svg-icon, .btn.btn-light-warning:focus:not(.btn-active) i,
.btn.btn-light-warning:focus:not(.btn-active) .svg-icon, .btn.btn-light-warning:hover:not(.btn-active) i,
.btn.btn-light-warning:hover:not(.btn-active) .svg-icon, .btn.btn-light-warning:active:not(.btn-active) i,
.btn.btn-light-warning:active:not(.btn-active) .svg-icon, .btn.btn-light-warning.active i,
.btn.btn-light-warning.active .svg-icon, .btn.btn-light-warning.show i,
.btn.btn-light-warning.show .svg-icon, .show > .btn.btn-light-warning i,
.show > .btn.btn-light-warning .svg-icon {
  color: var(--kt-warning-inverse);
}
.btn-check:checked + .btn.btn-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-light-warning.dropdown-toggle:after, .btn.btn-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning.active.dropdown-toggle:after, .btn.btn-light-warning.show.dropdown-toggle:after, .show > .btn.btn-light-warning.dropdown-toggle:after {
  color: var(--kt-warning-inverse);
}

.btn.btn-bg-warning {
  border-color: var(--kt-warning);
  background-color: var(--kt-warning);
}
.btn-check:checked + .btn.btn-active-warning, .btn-check:active + .btn.btn-active-warning, .btn.btn-active-warning:focus:not(.btn-active), .btn.btn-active-warning:hover:not(.btn-active), .btn.btn-active-warning:active:not(.btn-active), .btn.btn-active-warning.active, .btn.btn-active-warning.show, .show > .btn.btn-active-warning {
  color: var(--kt-warning-inverse);
  border-color: var(--kt-warning);
  background-color: var(--kt-warning) !important;
}
.btn-check:checked + .btn.btn-active-warning i,
.btn-check:checked + .btn.btn-active-warning .svg-icon, .btn-check:active + .btn.btn-active-warning i,
.btn-check:active + .btn.btn-active-warning .svg-icon, .btn.btn-active-warning:focus:not(.btn-active) i,
.btn.btn-active-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-warning:hover:not(.btn-active) i,
.btn.btn-active-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-warning:active:not(.btn-active) i,
.btn.btn-active-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-warning.active i,
.btn.btn-active-warning.active .svg-icon, .btn.btn-active-warning.show i,
.btn.btn-active-warning.show .svg-icon, .show > .btn.btn-active-warning i,
.show > .btn.btn-active-warning .svg-icon {
  color: var(--kt-warning-inverse);
}
.btn-check:checked + .btn.btn-active-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-warning.dropdown-toggle:after, .btn.btn-active-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning.active.dropdown-toggle:after, .btn.btn-active-warning.show.dropdown-toggle:after, .show > .btn.btn-active-warning.dropdown-toggle:after {
  color: var(--kt-warning-inverse);
}

.btn-check:checked + .btn.btn-active-light-warning, .btn-check:active + .btn.btn-active-light-warning, .btn.btn-active-light-warning:focus:not(.btn-active), .btn.btn-active-light-warning:hover:not(.btn-active), .btn.btn-active-light-warning:active:not(.btn-active), .btn.btn-active-light-warning.active, .btn.btn-active-light-warning.show, .show > .btn.btn-active-light-warning {
  color: var(--kt-warning);
  border-color: var(--kt-warning-light);
  background-color: var(--kt-warning-light) !important;
}
.btn-check:checked + .btn.btn-active-light-warning i,
.btn-check:checked + .btn.btn-active-light-warning .svg-icon, .btn-check:active + .btn.btn-active-light-warning i,
.btn-check:active + .btn.btn-active-light-warning .svg-icon, .btn.btn-active-light-warning:focus:not(.btn-active) i,
.btn.btn-active-light-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-warning:hover:not(.btn-active) i,
.btn.btn-active-light-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-warning:active:not(.btn-active) i,
.btn.btn-active-light-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-light-warning.active i,
.btn.btn-active-light-warning.active .svg-icon, .btn.btn-active-light-warning.show i,
.btn.btn-active-light-warning.show .svg-icon, .show > .btn.btn-active-light-warning i,
.show > .btn.btn-active-light-warning .svg-icon {
  color: var(--kt-warning);
}
.btn-check:checked + .btn.btn-active-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-warning.dropdown-toggle:after, .btn.btn-active-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning.active.dropdown-toggle:after, .btn.btn-active-light-warning.show.dropdown-toggle:after, .show > .btn.btn-active-light-warning.dropdown-toggle:after {
  color: var(--kt-warning);
}

.btn.btn-outline.btn-outline-warning {
  color: var(--kt-warning);
  border-color: var(--kt-warning);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-warning i,
.btn.btn-outline.btn-outline-warning .svg-icon {
  color: var(--kt-warning);
}
.btn.btn-outline.btn-outline-warning.dropdown-toggle:after {
  color: var(--kt-warning);
}
.btn-check:checked + .btn.btn-outline.btn-outline-warning, .btn-check:active + .btn.btn-outline.btn-outline-warning, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active), .btn.btn-outline.btn-outline-warning:hover:not(.btn-active), .btn.btn-outline.btn-outline-warning:active:not(.btn-active), .btn.btn-outline.btn-outline-warning.active, .btn.btn-outline.btn-outline-warning.show, .show > .btn.btn-outline.btn-outline-warning {
  color: var(--kt-warning-active);
  border-color: var(--kt-warning);
  background-color: var(--kt-warning-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-warning i,
.btn-check:checked + .btn.btn-outline.btn-outline-warning .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-warning i,
.btn-check:active + .btn.btn-outline.btn-outline-warning .svg-icon, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-warning:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-warning:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-warning:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning.active i,
.btn.btn-outline.btn-outline-warning.active .svg-icon, .btn.btn-outline.btn-outline-warning.show i,
.btn.btn-outline.btn-outline-warning.show .svg-icon, .show > .btn.btn-outline.btn-outline-warning i,
.show > .btn.btn-outline.btn-outline-warning .svg-icon {
  color: var(--kt-warning-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-warning.dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-warning.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-warning.dropdown-toggle:after {
  color: var(--kt-warning-active);
}

.btn.btn-danger {
  color: var(--kt-danger-inverse);
  border-color: var(--kt-danger);
  background-color: var(--kt-danger);
}
.btn.btn-danger i,
.btn.btn-danger .svg-icon {
  color: var(--kt-danger-inverse);
}
.btn.btn-danger.dropdown-toggle:after {
  color: var(--kt-danger-inverse);
}
.btn-check:checked + .btn.btn-danger, .btn-check:active + .btn.btn-danger, .btn.btn-danger:focus:not(.btn-active), .btn.btn-danger:hover:not(.btn-active), .btn.btn-danger:active:not(.btn-active), .btn.btn-danger.active, .btn.btn-danger.show, .show > .btn.btn-danger {
  color: var(--kt-danger-inverse);
  border-color: var(--kt-danger-active);
  background-color: var(--kt-danger-active) !important;
}
.btn-check:checked + .btn.btn-danger i,
.btn-check:checked + .btn.btn-danger .svg-icon, .btn-check:active + .btn.btn-danger i,
.btn-check:active + .btn.btn-danger .svg-icon, .btn.btn-danger:focus:not(.btn-active) i,
.btn.btn-danger:focus:not(.btn-active) .svg-icon, .btn.btn-danger:hover:not(.btn-active) i,
.btn.btn-danger:hover:not(.btn-active) .svg-icon, .btn.btn-danger:active:not(.btn-active) i,
.btn.btn-danger:active:not(.btn-active) .svg-icon, .btn.btn-danger.active i,
.btn.btn-danger.active .svg-icon, .btn.btn-danger.show i,
.btn.btn-danger.show .svg-icon, .show > .btn.btn-danger i,
.show > .btn.btn-danger .svg-icon {
  color: var(--kt-danger-inverse);
}
.btn-check:checked + .btn.btn-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-danger.dropdown-toggle:after, .btn.btn-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-danger.active.dropdown-toggle:after, .btn.btn-danger.show.dropdown-toggle:after, .show > .btn.btn-danger.dropdown-toggle:after {
  color: var(--kt-danger-inverse);
}

.btn.btn-light-danger {
  color: var(--kt-danger);
  border-color: var(--kt-danger-light);
  background-color: var(--kt-danger-light);
}
.btn.btn-light-danger i,
.btn.btn-light-danger .svg-icon {
  color: var(--kt-danger);
}
.btn.btn-light-danger.dropdown-toggle:after {
  color: var(--kt-danger);
}
.btn-check:checked + .btn.btn-light-danger, .btn-check:active + .btn.btn-light-danger, .btn.btn-light-danger:focus:not(.btn-active), .btn.btn-light-danger:hover:not(.btn-active), .btn.btn-light-danger:active:not(.btn-active), .btn.btn-light-danger.active, .btn.btn-light-danger.show, .show > .btn.btn-light-danger {
  color: var(--kt-danger-inverse);
  border-color: var(--kt-danger);
  background-color: var(--kt-danger) !important;
}
.btn-check:checked + .btn.btn-light-danger i,
.btn-check:checked + .btn.btn-light-danger .svg-icon, .btn-check:active + .btn.btn-light-danger i,
.btn-check:active + .btn.btn-light-danger .svg-icon, .btn.btn-light-danger:focus:not(.btn-active) i,
.btn.btn-light-danger:focus:not(.btn-active) .svg-icon, .btn.btn-light-danger:hover:not(.btn-active) i,
.btn.btn-light-danger:hover:not(.btn-active) .svg-icon, .btn.btn-light-danger:active:not(.btn-active) i,
.btn.btn-light-danger:active:not(.btn-active) .svg-icon, .btn.btn-light-danger.active i,
.btn.btn-light-danger.active .svg-icon, .btn.btn-light-danger.show i,
.btn.btn-light-danger.show .svg-icon, .show > .btn.btn-light-danger i,
.show > .btn.btn-light-danger .svg-icon {
  color: var(--kt-danger-inverse);
}
.btn-check:checked + .btn.btn-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-light-danger.dropdown-toggle:after, .btn.btn-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger.active.dropdown-toggle:after, .btn.btn-light-danger.show.dropdown-toggle:after, .show > .btn.btn-light-danger.dropdown-toggle:after {
  color: var(--kt-danger-inverse);
}

.btn.btn-bg-danger {
  border-color: var(--kt-danger);
  background-color: var(--kt-danger);
}
.btn-check:checked + .btn.btn-active-danger, .btn-check:active + .btn.btn-active-danger, .btn.btn-active-danger:focus:not(.btn-active), .btn.btn-active-danger:hover:not(.btn-active), .btn.btn-active-danger:active:not(.btn-active), .btn.btn-active-danger.active, .btn.btn-active-danger.show, .show > .btn.btn-active-danger {
  color: var(--kt-danger-inverse);
  border-color: var(--kt-danger);
  background-color: var(--kt-danger) !important;
}
.btn-check:checked + .btn.btn-active-danger i,
.btn-check:checked + .btn.btn-active-danger .svg-icon, .btn-check:active + .btn.btn-active-danger i,
.btn-check:active + .btn.btn-active-danger .svg-icon, .btn.btn-active-danger:focus:not(.btn-active) i,
.btn.btn-active-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-danger:hover:not(.btn-active) i,
.btn.btn-active-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-danger:active:not(.btn-active) i,
.btn.btn-active-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-danger.active i,
.btn.btn-active-danger.active .svg-icon, .btn.btn-active-danger.show i,
.btn.btn-active-danger.show .svg-icon, .show > .btn.btn-active-danger i,
.show > .btn.btn-active-danger .svg-icon {
  color: var(--kt-danger-inverse);
}
.btn-check:checked + .btn.btn-active-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-danger.dropdown-toggle:after, .btn.btn-active-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger.active.dropdown-toggle:after, .btn.btn-active-danger.show.dropdown-toggle:after, .show > .btn.btn-active-danger.dropdown-toggle:after {
  color: var(--kt-danger-inverse);
}

.btn-check:checked + .btn.btn-active-light-danger, .btn-check:active + .btn.btn-active-light-danger, .btn.btn-active-light-danger:focus:not(.btn-active), .btn.btn-active-light-danger:hover:not(.btn-active), .btn.btn-active-light-danger:active:not(.btn-active), .btn.btn-active-light-danger.active, .btn.btn-active-light-danger.show, .show > .btn.btn-active-light-danger {
  color: var(--kt-danger);
  border-color: var(--kt-danger-light);
  background-color: var(--kt-danger-light) !important;
}
.btn-check:checked + .btn.btn-active-light-danger i,
.btn-check:checked + .btn.btn-active-light-danger .svg-icon, .btn-check:active + .btn.btn-active-light-danger i,
.btn-check:active + .btn.btn-active-light-danger .svg-icon, .btn.btn-active-light-danger:focus:not(.btn-active) i,
.btn.btn-active-light-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-danger:hover:not(.btn-active) i,
.btn.btn-active-light-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-danger:active:not(.btn-active) i,
.btn.btn-active-light-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-light-danger.active i,
.btn.btn-active-light-danger.active .svg-icon, .btn.btn-active-light-danger.show i,
.btn.btn-active-light-danger.show .svg-icon, .show > .btn.btn-active-light-danger i,
.show > .btn.btn-active-light-danger .svg-icon {
  color: var(--kt-danger);
}
.btn-check:checked + .btn.btn-active-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-danger.dropdown-toggle:after, .btn.btn-active-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger.active.dropdown-toggle:after, .btn.btn-active-light-danger.show.dropdown-toggle:after, .show > .btn.btn-active-light-danger.dropdown-toggle:after {
  color: var(--kt-danger);
}

.btn.btn-outline.btn-outline-danger {
  color: var(--kt-danger);
  border-color: var(--kt-danger);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-danger i,
.btn.btn-outline.btn-outline-danger .svg-icon {
  color: var(--kt-danger);
}
.btn.btn-outline.btn-outline-danger.dropdown-toggle:after {
  color: var(--kt-danger);
}
.btn-check:checked + .btn.btn-outline.btn-outline-danger, .btn-check:active + .btn.btn-outline.btn-outline-danger, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active), .btn.btn-outline.btn-outline-danger:hover:not(.btn-active), .btn.btn-outline.btn-outline-danger:active:not(.btn-active), .btn.btn-outline.btn-outline-danger.active, .btn.btn-outline.btn-outline-danger.show, .show > .btn.btn-outline.btn-outline-danger {
  color: var(--kt-danger-active);
  border-color: var(--kt-danger);
  background-color: var(--kt-danger-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-danger i,
.btn-check:checked + .btn.btn-outline.btn-outline-danger .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-danger i,
.btn-check:active + .btn.btn-outline.btn-outline-danger .svg-icon, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-danger:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-danger:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-danger:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger.active i,
.btn.btn-outline.btn-outline-danger.active .svg-icon, .btn.btn-outline.btn-outline-danger.show i,
.btn.btn-outline.btn-outline-danger.show .svg-icon, .show > .btn.btn-outline.btn-outline-danger i,
.show > .btn.btn-outline.btn-outline-danger .svg-icon {
  color: var(--kt-danger-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-danger.dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-danger.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-danger.dropdown-toggle:after {
  color: var(--kt-danger-active);
}

.btn.btn-dark {
  color: var(--kt-dark-inverse);
  border-color: var(--kt-dark);
  background-color: var(--kt-dark);
}
.btn.btn-dark i,
.btn.btn-dark .svg-icon {
  color: var(--kt-dark-inverse);
}
.btn.btn-dark.dropdown-toggle:after {
  color: var(--kt-dark-inverse);
}
.btn-check:checked + .btn.btn-dark, .btn-check:active + .btn.btn-dark, .btn.btn-dark:focus:not(.btn-active), .btn.btn-dark:hover:not(.btn-active), .btn.btn-dark:active:not(.btn-active), .btn.btn-dark.active, .btn.btn-dark.show, .show > .btn.btn-dark {
  color: var(--kt-dark-inverse);
  border-color: var(--kt-dark-active);
  background-color: var(--kt-dark-active) !important;
}
.btn-check:checked + .btn.btn-dark i,
.btn-check:checked + .btn.btn-dark .svg-icon, .btn-check:active + .btn.btn-dark i,
.btn-check:active + .btn.btn-dark .svg-icon, .btn.btn-dark:focus:not(.btn-active) i,
.btn.btn-dark:focus:not(.btn-active) .svg-icon, .btn.btn-dark:hover:not(.btn-active) i,
.btn.btn-dark:hover:not(.btn-active) .svg-icon, .btn.btn-dark:active:not(.btn-active) i,
.btn.btn-dark:active:not(.btn-active) .svg-icon, .btn.btn-dark.active i,
.btn.btn-dark.active .svg-icon, .btn.btn-dark.show i,
.btn.btn-dark.show .svg-icon, .show > .btn.btn-dark i,
.show > .btn.btn-dark .svg-icon {
  color: var(--kt-dark-inverse);
}
.btn-check:checked + .btn.btn-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-dark.dropdown-toggle:after, .btn.btn-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-dark.active.dropdown-toggle:after, .btn.btn-dark.show.dropdown-toggle:after, .show > .btn.btn-dark.dropdown-toggle:after {
  color: var(--kt-dark-inverse);
}

.btn.btn-light-dark {
  color: var(--kt-dark);
  border-color: var(--kt-dark-light);
  background-color: var(--kt-dark-light);
}
.btn.btn-light-dark i,
.btn.btn-light-dark .svg-icon {
  color: var(--kt-dark);
}
.btn.btn-light-dark.dropdown-toggle:after {
  color: var(--kt-dark);
}
.btn-check:checked + .btn.btn-light-dark, .btn-check:active + .btn.btn-light-dark, .btn.btn-light-dark:focus:not(.btn-active), .btn.btn-light-dark:hover:not(.btn-active), .btn.btn-light-dark:active:not(.btn-active), .btn.btn-light-dark.active, .btn.btn-light-dark.show, .show > .btn.btn-light-dark {
  color: var(--kt-dark-inverse);
  border-color: var(--kt-dark);
  background-color: var(--kt-dark) !important;
}
.btn-check:checked + .btn.btn-light-dark i,
.btn-check:checked + .btn.btn-light-dark .svg-icon, .btn-check:active + .btn.btn-light-dark i,
.btn-check:active + .btn.btn-light-dark .svg-icon, .btn.btn-light-dark:focus:not(.btn-active) i,
.btn.btn-light-dark:focus:not(.btn-active) .svg-icon, .btn.btn-light-dark:hover:not(.btn-active) i,
.btn.btn-light-dark:hover:not(.btn-active) .svg-icon, .btn.btn-light-dark:active:not(.btn-active) i,
.btn.btn-light-dark:active:not(.btn-active) .svg-icon, .btn.btn-light-dark.active i,
.btn.btn-light-dark.active .svg-icon, .btn.btn-light-dark.show i,
.btn.btn-light-dark.show .svg-icon, .show > .btn.btn-light-dark i,
.show > .btn.btn-light-dark .svg-icon {
  color: var(--kt-dark-inverse);
}
.btn-check:checked + .btn.btn-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-light-dark.dropdown-toggle:after, .btn.btn-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark.active.dropdown-toggle:after, .btn.btn-light-dark.show.dropdown-toggle:after, .show > .btn.btn-light-dark.dropdown-toggle:after {
  color: var(--kt-dark-inverse);
}

.btn.btn-bg-dark {
  border-color: var(--kt-dark);
  background-color: var(--kt-dark);
}
.btn-check:checked + .btn.btn-active-dark, .btn-check:active + .btn.btn-active-dark, .btn.btn-active-dark:focus:not(.btn-active), .btn.btn-active-dark:hover:not(.btn-active), .btn.btn-active-dark:active:not(.btn-active), .btn.btn-active-dark.active, .btn.btn-active-dark.show, .show > .btn.btn-active-dark {
  color: var(--kt-dark-inverse);
  border-color: var(--kt-dark);
  background-color: var(--kt-dark) !important;
}
.btn-check:checked + .btn.btn-active-dark i,
.btn-check:checked + .btn.btn-active-dark .svg-icon, .btn-check:active + .btn.btn-active-dark i,
.btn-check:active + .btn.btn-active-dark .svg-icon, .btn.btn-active-dark:focus:not(.btn-active) i,
.btn.btn-active-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-dark:hover:not(.btn-active) i,
.btn.btn-active-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-dark:active:not(.btn-active) i,
.btn.btn-active-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-dark.active i,
.btn.btn-active-dark.active .svg-icon, .btn.btn-active-dark.show i,
.btn.btn-active-dark.show .svg-icon, .show > .btn.btn-active-dark i,
.show > .btn.btn-active-dark .svg-icon {
  color: var(--kt-dark-inverse);
}
.btn-check:checked + .btn.btn-active-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-dark.dropdown-toggle:after, .btn.btn-active-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark.active.dropdown-toggle:after, .btn.btn-active-dark.show.dropdown-toggle:after, .show > .btn.btn-active-dark.dropdown-toggle:after {
  color: var(--kt-dark-inverse);
}

.btn-check:checked + .btn.btn-active-light-dark, .btn-check:active + .btn.btn-active-light-dark, .btn.btn-active-light-dark:focus:not(.btn-active), .btn.btn-active-light-dark:hover:not(.btn-active), .btn.btn-active-light-dark:active:not(.btn-active), .btn.btn-active-light-dark.active, .btn.btn-active-light-dark.show, .show > .btn.btn-active-light-dark {
  color: var(--kt-dark);
  border-color: var(--kt-dark-light);
  background-color: var(--kt-dark-light) !important;
}
.btn-check:checked + .btn.btn-active-light-dark i,
.btn-check:checked + .btn.btn-active-light-dark .svg-icon, .btn-check:active + .btn.btn-active-light-dark i,
.btn-check:active + .btn.btn-active-light-dark .svg-icon, .btn.btn-active-light-dark:focus:not(.btn-active) i,
.btn.btn-active-light-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-dark:hover:not(.btn-active) i,
.btn.btn-active-light-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-dark:active:not(.btn-active) i,
.btn.btn-active-light-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-light-dark.active i,
.btn.btn-active-light-dark.active .svg-icon, .btn.btn-active-light-dark.show i,
.btn.btn-active-light-dark.show .svg-icon, .show > .btn.btn-active-light-dark i,
.show > .btn.btn-active-light-dark .svg-icon {
  color: var(--kt-dark);
}
.btn-check:checked + .btn.btn-active-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-dark.dropdown-toggle:after, .btn.btn-active-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark.active.dropdown-toggle:after, .btn.btn-active-light-dark.show.dropdown-toggle:after, .show > .btn.btn-active-light-dark.dropdown-toggle:after {
  color: var(--kt-dark);
}

.btn.btn-outline.btn-outline-dark {
  color: var(--kt-dark);
  border-color: var(--kt-dark);
  background-color: transparent;
}
.btn.btn-outline.btn-outline-dark i,
.btn.btn-outline.btn-outline-dark .svg-icon {
  color: var(--kt-dark);
}
.btn.btn-outline.btn-outline-dark.dropdown-toggle:after {
  color: var(--kt-dark);
}
.btn-check:checked + .btn.btn-outline.btn-outline-dark, .btn-check:active + .btn.btn-outline.btn-outline-dark, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active), .btn.btn-outline.btn-outline-dark:hover:not(.btn-active), .btn.btn-outline.btn-outline-dark:active:not(.btn-active), .btn.btn-outline.btn-outline-dark.active, .btn.btn-outline.btn-outline-dark.show, .show > .btn.btn-outline.btn-outline-dark {
  color: var(--kt-dark-active);
  border-color: var(--kt-dark);
  background-color: var(--kt-dark-light) !important;
}
.btn-check:checked + .btn.btn-outline.btn-outline-dark i,
.btn-check:checked + .btn.btn-outline.btn-outline-dark .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-dark i,
.btn-check:active + .btn.btn-outline.btn-outline-dark .svg-icon, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active) i,
.btn.btn-outline.btn-outline-dark:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark:hover:not(.btn-active) i,
.btn.btn-outline.btn-outline-dark:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark:active:not(.btn-active) i,
.btn.btn-outline.btn-outline-dark:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark.active i,
.btn.btn-outline.btn-outline-dark.active .svg-icon, .btn.btn-outline.btn-outline-dark.show i,
.btn.btn-outline.btn-outline-dark.show .svg-icon, .show > .btn.btn-outline.btn-outline-dark i,
.show > .btn.btn-outline.btn-outline-dark .svg-icon {
  color: var(--kt-dark-active);
}
.btn-check:checked + .btn.btn-outline.btn-outline-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-dark.dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-dark.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-dark.dropdown-toggle:after {
  color: var(--kt-dark-active);
}

.btn.btn-color-white {
  color: var(--kt-text-white);
}
.btn.btn-color-white i,
.btn.btn-color-white .svg-icon {
  color: var(--kt-text-white);
}
.btn.btn-color-white.dropdown-toggle:after {
  color: var(--kt-text-white);
}
.btn-check:checked + .btn.btn-active-color-white, .btn-check:active + .btn.btn-active-color-white, .btn.btn-active-color-white:focus:not(.btn-active), .btn.btn-active-color-white:hover:not(.btn-active), .btn.btn-active-color-white:active:not(.btn-active), .btn.btn-active-color-white.active, .btn.btn-active-color-white.show, .show > .btn.btn-active-color-white {
  color: var(--kt-text-white);
}
.btn-check:checked + .btn.btn-active-color-white i,
.btn-check:checked + .btn.btn-active-color-white .svg-icon, .btn-check:active + .btn.btn-active-color-white i,
.btn-check:active + .btn.btn-active-color-white .svg-icon, .btn.btn-active-color-white:focus:not(.btn-active) i,
.btn.btn-active-color-white:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-white:hover:not(.btn-active) i,
.btn.btn-active-color-white:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-white:active:not(.btn-active) i,
.btn.btn-active-color-white:active:not(.btn-active) .svg-icon, .btn.btn-active-color-white.active i,
.btn.btn-active-color-white.active .svg-icon, .btn.btn-active-color-white.show i,
.btn.btn-active-color-white.show .svg-icon, .show > .btn.btn-active-color-white i,
.show > .btn.btn-active-color-white .svg-icon {
  color: var(--kt-text-white);
}
.btn-check:checked + .btn.btn-active-color-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-white.dropdown-toggle:after, .btn.btn-active-color-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white.active.dropdown-toggle:after, .btn.btn-active-color-white.show.dropdown-toggle:after, .show > .btn.btn-active-color-white.dropdown-toggle:after {
  color: var(--kt-text-white);
}

.btn.btn-icon-white i,
.btn.btn-icon-white .svg-icon {
  color: var(--kt-text-white);
}
.btn.btn-icon-white.dropdown-toggle:after {
  color: var(--kt-text-white);
}
.btn-check:checked + .btn.btn-active-icon-white i,
.btn-check:checked + .btn.btn-active-icon-white .svg-icon, .btn-check:active + .btn.btn-active-icon-white i,
.btn-check:active + .btn.btn-active-icon-white .svg-icon, .btn.btn-active-icon-white:focus:not(.btn-active) i,
.btn.btn-active-icon-white:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-white:hover:not(.btn-active) i,
.btn.btn-active-icon-white:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-white:active:not(.btn-active) i,
.btn.btn-active-icon-white:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-white.active i,
.btn.btn-active-icon-white.active .svg-icon, .btn.btn-active-icon-white.show i,
.btn.btn-active-icon-white.show .svg-icon, .show > .btn.btn-active-icon-white i,
.show > .btn.btn-active-icon-white .svg-icon {
  color: var(--kt-text-white);
}
.btn-check:checked + .btn.btn-active-icon-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-white.dropdown-toggle:after, .btn.btn-active-icon-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white.active.dropdown-toggle:after, .btn.btn-active-icon-white.show.dropdown-toggle:after, .show > .btn.btn-active-icon-white.dropdown-toggle:after {
  color: var(--kt-text-white);
}

.btn.btn-text-white {
  color: var(--kt-text-white);
}
.btn-check:checked + .btn.btn-active-text-white, .btn-check:active + .btn.btn-active-text-white, .btn.btn-active-text-white:focus:not(.btn-active), .btn.btn-active-text-white:hover:not(.btn-active), .btn.btn-active-text-white:active:not(.btn-active), .btn.btn-active-text-white.active, .btn.btn-active-text-white.show, .show > .btn.btn-active-text-white {
  color: var(--kt-text-white);
}

.btn.btn-color-primary {
  color: var(--kt-text-primary);
}
.btn.btn-color-primary i,
.btn.btn-color-primary .svg-icon {
  color: var(--kt-text-primary);
}
.btn.btn-color-primary.dropdown-toggle:after {
  color: var(--kt-text-primary);
}
.btn-check:checked + .btn.btn-active-color-primary, .btn-check:active + .btn.btn-active-color-primary, .btn.btn-active-color-primary:focus:not(.btn-active), .btn.btn-active-color-primary:hover:not(.btn-active), .btn.btn-active-color-primary:active:not(.btn-active), .btn.btn-active-color-primary.active, .btn.btn-active-color-primary.show, .show > .btn.btn-active-color-primary {
  color: var(--kt-text-primary);
}
.btn-check:checked + .btn.btn-active-color-primary i,
.btn-check:checked + .btn.btn-active-color-primary .svg-icon, .btn-check:active + .btn.btn-active-color-primary i,
.btn-check:active + .btn.btn-active-color-primary .svg-icon, .btn.btn-active-color-primary:focus:not(.btn-active) i,
.btn.btn-active-color-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-primary:hover:not(.btn-active) i,
.btn.btn-active-color-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-primary:active:not(.btn-active) i,
.btn.btn-active-color-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-color-primary.active i,
.btn.btn-active-color-primary.active .svg-icon, .btn.btn-active-color-primary.show i,
.btn.btn-active-color-primary.show .svg-icon, .show > .btn.btn-active-color-primary i,
.show > .btn.btn-active-color-primary .svg-icon {
  color: var(--kt-text-primary);
}
.btn-check:checked + .btn.btn-active-color-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-primary.dropdown-toggle:after, .btn.btn-active-color-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary.active.dropdown-toggle:after, .btn.btn-active-color-primary.show.dropdown-toggle:after, .show > .btn.btn-active-color-primary.dropdown-toggle:after {
  color: var(--kt-text-primary);
}

.btn.btn-icon-primary i,
.btn.btn-icon-primary .svg-icon {
  color: var(--kt-text-primary);
}
.btn.btn-icon-primary.dropdown-toggle:after {
  color: var(--kt-text-primary);
}
.btn-check:checked + .btn.btn-active-icon-primary i,
.btn-check:checked + .btn.btn-active-icon-primary .svg-icon, .btn-check:active + .btn.btn-active-icon-primary i,
.btn-check:active + .btn.btn-active-icon-primary .svg-icon, .btn.btn-active-icon-primary:focus:not(.btn-active) i,
.btn.btn-active-icon-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary:hover:not(.btn-active) i,
.btn.btn-active-icon-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary:active:not(.btn-active) i,
.btn.btn-active-icon-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary.active i,
.btn.btn-active-icon-primary.active .svg-icon, .btn.btn-active-icon-primary.show i,
.btn.btn-active-icon-primary.show .svg-icon, .show > .btn.btn-active-icon-primary i,
.show > .btn.btn-active-icon-primary .svg-icon {
  color: var(--kt-text-primary);
}
.btn-check:checked + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn.btn-active-icon-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary.active.dropdown-toggle:after, .btn.btn-active-icon-primary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-primary.dropdown-toggle:after {
  color: var(--kt-text-primary);
}

.btn.btn-text-primary {
  color: var(--kt-text-primary);
}
.btn-check:checked + .btn.btn-active-text-primary, .btn-check:active + .btn.btn-active-text-primary, .btn.btn-active-text-primary:focus:not(.btn-active), .btn.btn-active-text-primary:hover:not(.btn-active), .btn.btn-active-text-primary:active:not(.btn-active), .btn.btn-active-text-primary.active, .btn.btn-active-text-primary.show, .show > .btn.btn-active-text-primary {
  color: var(--kt-text-primary);
}

.btn.btn-color-secondary {
  color: var(--kt-text-secondary);
}
.btn.btn-color-secondary i,
.btn.btn-color-secondary .svg-icon {
  color: var(--kt-text-secondary);
}
.btn.btn-color-secondary.dropdown-toggle:after {
  color: var(--kt-text-secondary);
}
.btn-check:checked + .btn.btn-active-color-secondary, .btn-check:active + .btn.btn-active-color-secondary, .btn.btn-active-color-secondary:focus:not(.btn-active), .btn.btn-active-color-secondary:hover:not(.btn-active), .btn.btn-active-color-secondary:active:not(.btn-active), .btn.btn-active-color-secondary.active, .btn.btn-active-color-secondary.show, .show > .btn.btn-active-color-secondary {
  color: var(--kt-text-secondary);
}
.btn-check:checked + .btn.btn-active-color-secondary i,
.btn-check:checked + .btn.btn-active-color-secondary .svg-icon, .btn-check:active + .btn.btn-active-color-secondary i,
.btn-check:active + .btn.btn-active-color-secondary .svg-icon, .btn.btn-active-color-secondary:focus:not(.btn-active) i,
.btn.btn-active-color-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary:hover:not(.btn-active) i,
.btn.btn-active-color-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary:active:not(.btn-active) i,
.btn.btn-active-color-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary.active i,
.btn.btn-active-color-secondary.active .svg-icon, .btn.btn-active-color-secondary.show i,
.btn.btn-active-color-secondary.show .svg-icon, .show > .btn.btn-active-color-secondary i,
.show > .btn.btn-active-color-secondary .svg-icon {
  color: var(--kt-text-secondary);
}
.btn-check:checked + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn.btn-active-color-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary.active.dropdown-toggle:after, .btn.btn-active-color-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-color-secondary.dropdown-toggle:after {
  color: var(--kt-text-secondary);
}

.btn.btn-icon-secondary i,
.btn.btn-icon-secondary .svg-icon {
  color: var(--kt-text-secondary);
}
.btn.btn-icon-secondary.dropdown-toggle:after {
  color: var(--kt-text-secondary);
}
.btn-check:checked + .btn.btn-active-icon-secondary i,
.btn-check:checked + .btn.btn-active-icon-secondary .svg-icon, .btn-check:active + .btn.btn-active-icon-secondary i,
.btn-check:active + .btn.btn-active-icon-secondary .svg-icon, .btn.btn-active-icon-secondary:focus:not(.btn-active) i,
.btn.btn-active-icon-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary:hover:not(.btn-active) i,
.btn.btn-active-icon-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary:active:not(.btn-active) i,
.btn.btn-active-icon-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary.active i,
.btn.btn-active-icon-secondary.active .svg-icon, .btn.btn-active-icon-secondary.show i,
.btn.btn-active-icon-secondary.show .svg-icon, .show > .btn.btn-active-icon-secondary i,
.show > .btn.btn-active-icon-secondary .svg-icon {
  color: var(--kt-text-secondary);
}
.btn-check:checked + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn.btn-active-icon-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary.active.dropdown-toggle:after, .btn.btn-active-icon-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-secondary.dropdown-toggle:after {
  color: var(--kt-text-secondary);
}

.btn.btn-text-secondary {
  color: var(--kt-text-secondary);
}
.btn-check:checked + .btn.btn-active-text-secondary, .btn-check:active + .btn.btn-active-text-secondary, .btn.btn-active-text-secondary:focus:not(.btn-active), .btn.btn-active-text-secondary:hover:not(.btn-active), .btn.btn-active-text-secondary:active:not(.btn-active), .btn.btn-active-text-secondary.active, .btn.btn-active-text-secondary.show, .show > .btn.btn-active-text-secondary {
  color: var(--kt-text-secondary);
}

.btn.btn-color-light {
  color: var(--kt-text-light);
}
.btn.btn-color-light i,
.btn.btn-color-light .svg-icon {
  color: var(--kt-text-light);
}
.btn.btn-color-light.dropdown-toggle:after {
  color: var(--kt-text-light);
}
.btn-check:checked + .btn.btn-active-color-light, .btn-check:active + .btn.btn-active-color-light, .btn.btn-active-color-light:focus:not(.btn-active), .btn.btn-active-color-light:hover:not(.btn-active), .btn.btn-active-color-light:active:not(.btn-active), .btn.btn-active-color-light.active, .btn.btn-active-color-light.show, .show > .btn.btn-active-color-light {
  color: var(--kt-text-light);
}
.btn-check:checked + .btn.btn-active-color-light i,
.btn-check:checked + .btn.btn-active-color-light .svg-icon, .btn-check:active + .btn.btn-active-color-light i,
.btn-check:active + .btn.btn-active-color-light .svg-icon, .btn.btn-active-color-light:focus:not(.btn-active) i,
.btn.btn-active-color-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-light:hover:not(.btn-active) i,
.btn.btn-active-color-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-light:active:not(.btn-active) i,
.btn.btn-active-color-light:active:not(.btn-active) .svg-icon, .btn.btn-active-color-light.active i,
.btn.btn-active-color-light.active .svg-icon, .btn.btn-active-color-light.show i,
.btn.btn-active-color-light.show .svg-icon, .show > .btn.btn-active-color-light i,
.show > .btn.btn-active-color-light .svg-icon {
  color: var(--kt-text-light);
}
.btn-check:checked + .btn.btn-active-color-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-light.dropdown-toggle:after, .btn.btn-active-color-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light.active.dropdown-toggle:after, .btn.btn-active-color-light.show.dropdown-toggle:after, .show > .btn.btn-active-color-light.dropdown-toggle:after {
  color: var(--kt-text-light);
}

.btn.btn-icon-light i,
.btn.btn-icon-light .svg-icon {
  color: var(--kt-text-light);
}
.btn.btn-icon-light.dropdown-toggle:after {
  color: var(--kt-text-light);
}
.btn-check:checked + .btn.btn-active-icon-light i,
.btn-check:checked + .btn.btn-active-icon-light .svg-icon, .btn-check:active + .btn.btn-active-icon-light i,
.btn-check:active + .btn.btn-active-icon-light .svg-icon, .btn.btn-active-icon-light:focus:not(.btn-active) i,
.btn.btn-active-icon-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-light:hover:not(.btn-active) i,
.btn.btn-active-icon-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-light:active:not(.btn-active) i,
.btn.btn-active-icon-light:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-light.active i,
.btn.btn-active-icon-light.active .svg-icon, .btn.btn-active-icon-light.show i,
.btn.btn-active-icon-light.show .svg-icon, .show > .btn.btn-active-icon-light i,
.show > .btn.btn-active-icon-light .svg-icon {
  color: var(--kt-text-light);
}
.btn-check:checked + .btn.btn-active-icon-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-light.dropdown-toggle:after, .btn.btn-active-icon-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light.active.dropdown-toggle:after, .btn.btn-active-icon-light.show.dropdown-toggle:after, .show > .btn.btn-active-icon-light.dropdown-toggle:after {
  color: var(--kt-text-light);
}

.btn.btn-text-light {
  color: var(--kt-text-light);
}
.btn-check:checked + .btn.btn-active-text-light, .btn-check:active + .btn.btn-active-text-light, .btn.btn-active-text-light:focus:not(.btn-active), .btn.btn-active-text-light:hover:not(.btn-active), .btn.btn-active-text-light:active:not(.btn-active), .btn.btn-active-text-light.active, .btn.btn-active-text-light.show, .show > .btn.btn-active-text-light {
  color: var(--kt-text-light);
}

.btn.btn-color-success {
  color: var(--kt-text-success);
}
.btn.btn-color-success i,
.btn.btn-color-success .svg-icon {
  color: var(--kt-text-success);
}
.btn.btn-color-success.dropdown-toggle:after {
  color: var(--kt-text-success);
}
.btn-check:checked + .btn.btn-active-color-success, .btn-check:active + .btn.btn-active-color-success, .btn.btn-active-color-success:focus:not(.btn-active), .btn.btn-active-color-success:hover:not(.btn-active), .btn.btn-active-color-success:active:not(.btn-active), .btn.btn-active-color-success.active, .btn.btn-active-color-success.show, .show > .btn.btn-active-color-success {
  color: var(--kt-text-success);
}
.btn-check:checked + .btn.btn-active-color-success i,
.btn-check:checked + .btn.btn-active-color-success .svg-icon, .btn-check:active + .btn.btn-active-color-success i,
.btn-check:active + .btn.btn-active-color-success .svg-icon, .btn.btn-active-color-success:focus:not(.btn-active) i,
.btn.btn-active-color-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-success:hover:not(.btn-active) i,
.btn.btn-active-color-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-success:active:not(.btn-active) i,
.btn.btn-active-color-success:active:not(.btn-active) .svg-icon, .btn.btn-active-color-success.active i,
.btn.btn-active-color-success.active .svg-icon, .btn.btn-active-color-success.show i,
.btn.btn-active-color-success.show .svg-icon, .show > .btn.btn-active-color-success i,
.show > .btn.btn-active-color-success .svg-icon {
  color: var(--kt-text-success);
}
.btn-check:checked + .btn.btn-active-color-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-success.dropdown-toggle:after, .btn.btn-active-color-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success.active.dropdown-toggle:after, .btn.btn-active-color-success.show.dropdown-toggle:after, .show > .btn.btn-active-color-success.dropdown-toggle:after {
  color: var(--kt-text-success);
}

.btn.btn-icon-success i,
.btn.btn-icon-success .svg-icon {
  color: var(--kt-text-success);
}
.btn.btn-icon-success.dropdown-toggle:after {
  color: var(--kt-text-success);
}
.btn-check:checked + .btn.btn-active-icon-success i,
.btn-check:checked + .btn.btn-active-icon-success .svg-icon, .btn-check:active + .btn.btn-active-icon-success i,
.btn-check:active + .btn.btn-active-icon-success .svg-icon, .btn.btn-active-icon-success:focus:not(.btn-active) i,
.btn.btn-active-icon-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-success:hover:not(.btn-active) i,
.btn.btn-active-icon-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-success:active:not(.btn-active) i,
.btn.btn-active-icon-success:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-success.active i,
.btn.btn-active-icon-success.active .svg-icon, .btn.btn-active-icon-success.show i,
.btn.btn-active-icon-success.show .svg-icon, .show > .btn.btn-active-icon-success i,
.show > .btn.btn-active-icon-success .svg-icon {
  color: var(--kt-text-success);
}
.btn-check:checked + .btn.btn-active-icon-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-success.dropdown-toggle:after, .btn.btn-active-icon-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success.active.dropdown-toggle:after, .btn.btn-active-icon-success.show.dropdown-toggle:after, .show > .btn.btn-active-icon-success.dropdown-toggle:after {
  color: var(--kt-text-success);
}

.btn.btn-text-success {
  color: var(--kt-text-success);
}
.btn-check:checked + .btn.btn-active-text-success, .btn-check:active + .btn.btn-active-text-success, .btn.btn-active-text-success:focus:not(.btn-active), .btn.btn-active-text-success:hover:not(.btn-active), .btn.btn-active-text-success:active:not(.btn-active), .btn.btn-active-text-success.active, .btn.btn-active-text-success.show, .show > .btn.btn-active-text-success {
  color: var(--kt-text-success);
}

.btn.btn-color-info {
  color: var(--kt-text-info);
}
.btn.btn-color-info i,
.btn.btn-color-info .svg-icon {
  color: var(--kt-text-info);
}
.btn.btn-color-info.dropdown-toggle:after {
  color: var(--kt-text-info);
}
.btn-check:checked + .btn.btn-active-color-info, .btn-check:active + .btn.btn-active-color-info, .btn.btn-active-color-info:focus:not(.btn-active), .btn.btn-active-color-info:hover:not(.btn-active), .btn.btn-active-color-info:active:not(.btn-active), .btn.btn-active-color-info.active, .btn.btn-active-color-info.show, .show > .btn.btn-active-color-info {
  color: var(--kt-text-info);
}
.btn-check:checked + .btn.btn-active-color-info i,
.btn-check:checked + .btn.btn-active-color-info .svg-icon, .btn-check:active + .btn.btn-active-color-info i,
.btn-check:active + .btn.btn-active-color-info .svg-icon, .btn.btn-active-color-info:focus:not(.btn-active) i,
.btn.btn-active-color-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-info:hover:not(.btn-active) i,
.btn.btn-active-color-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-info:active:not(.btn-active) i,
.btn.btn-active-color-info:active:not(.btn-active) .svg-icon, .btn.btn-active-color-info.active i,
.btn.btn-active-color-info.active .svg-icon, .btn.btn-active-color-info.show i,
.btn.btn-active-color-info.show .svg-icon, .show > .btn.btn-active-color-info i,
.show > .btn.btn-active-color-info .svg-icon {
  color: var(--kt-text-info);
}
.btn-check:checked + .btn.btn-active-color-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-info.dropdown-toggle:after, .btn.btn-active-color-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info.active.dropdown-toggle:after, .btn.btn-active-color-info.show.dropdown-toggle:after, .show > .btn.btn-active-color-info.dropdown-toggle:after {
  color: var(--kt-text-info);
}

.btn.btn-icon-info i,
.btn.btn-icon-info .svg-icon {
  color: var(--kt-text-info);
}
.btn.btn-icon-info.dropdown-toggle:after {
  color: var(--kt-text-info);
}
.btn-check:checked + .btn.btn-active-icon-info i,
.btn-check:checked + .btn.btn-active-icon-info .svg-icon, .btn-check:active + .btn.btn-active-icon-info i,
.btn-check:active + .btn.btn-active-icon-info .svg-icon, .btn.btn-active-icon-info:focus:not(.btn-active) i,
.btn.btn-active-icon-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-info:hover:not(.btn-active) i,
.btn.btn-active-icon-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-info:active:not(.btn-active) i,
.btn.btn-active-icon-info:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-info.active i,
.btn.btn-active-icon-info.active .svg-icon, .btn.btn-active-icon-info.show i,
.btn.btn-active-icon-info.show .svg-icon, .show > .btn.btn-active-icon-info i,
.show > .btn.btn-active-icon-info .svg-icon {
  color: var(--kt-text-info);
}
.btn-check:checked + .btn.btn-active-icon-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-info.dropdown-toggle:after, .btn.btn-active-icon-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info.active.dropdown-toggle:after, .btn.btn-active-icon-info.show.dropdown-toggle:after, .show > .btn.btn-active-icon-info.dropdown-toggle:after {
  color: var(--kt-text-info);
}

.btn.btn-text-info {
  color: var(--kt-text-info);
}
.btn-check:checked + .btn.btn-active-text-info, .btn-check:active + .btn.btn-active-text-info, .btn.btn-active-text-info:focus:not(.btn-active), .btn.btn-active-text-info:hover:not(.btn-active), .btn.btn-active-text-info:active:not(.btn-active), .btn.btn-active-text-info.active, .btn.btn-active-text-info.show, .show > .btn.btn-active-text-info {
  color: var(--kt-text-info);
}

.btn.btn-color-warning {
  color: var(--kt-text-warning);
}
.btn.btn-color-warning i,
.btn.btn-color-warning .svg-icon {
  color: var(--kt-text-warning);
}
.btn.btn-color-warning.dropdown-toggle:after {
  color: var(--kt-text-warning);
}
.btn-check:checked + .btn.btn-active-color-warning, .btn-check:active + .btn.btn-active-color-warning, .btn.btn-active-color-warning:focus:not(.btn-active), .btn.btn-active-color-warning:hover:not(.btn-active), .btn.btn-active-color-warning:active:not(.btn-active), .btn.btn-active-color-warning.active, .btn.btn-active-color-warning.show, .show > .btn.btn-active-color-warning {
  color: var(--kt-text-warning);
}
.btn-check:checked + .btn.btn-active-color-warning i,
.btn-check:checked + .btn.btn-active-color-warning .svg-icon, .btn-check:active + .btn.btn-active-color-warning i,
.btn-check:active + .btn.btn-active-color-warning .svg-icon, .btn.btn-active-color-warning:focus:not(.btn-active) i,
.btn.btn-active-color-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-warning:hover:not(.btn-active) i,
.btn.btn-active-color-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-warning:active:not(.btn-active) i,
.btn.btn-active-color-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-color-warning.active i,
.btn.btn-active-color-warning.active .svg-icon, .btn.btn-active-color-warning.show i,
.btn.btn-active-color-warning.show .svg-icon, .show > .btn.btn-active-color-warning i,
.show > .btn.btn-active-color-warning .svg-icon {
  color: var(--kt-text-warning);
}
.btn-check:checked + .btn.btn-active-color-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-warning.dropdown-toggle:after, .btn.btn-active-color-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning.active.dropdown-toggle:after, .btn.btn-active-color-warning.show.dropdown-toggle:after, .show > .btn.btn-active-color-warning.dropdown-toggle:after {
  color: var(--kt-text-warning);
}

.btn.btn-icon-warning i,
.btn.btn-icon-warning .svg-icon {
  color: var(--kt-text-warning);
}
.btn.btn-icon-warning.dropdown-toggle:after {
  color: var(--kt-text-warning);
}
.btn-check:checked + .btn.btn-active-icon-warning i,
.btn-check:checked + .btn.btn-active-icon-warning .svg-icon, .btn-check:active + .btn.btn-active-icon-warning i,
.btn-check:active + .btn.btn-active-icon-warning .svg-icon, .btn.btn-active-icon-warning:focus:not(.btn-active) i,
.btn.btn-active-icon-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning:hover:not(.btn-active) i,
.btn.btn-active-icon-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning:active:not(.btn-active) i,
.btn.btn-active-icon-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning.active i,
.btn.btn-active-icon-warning.active .svg-icon, .btn.btn-active-icon-warning.show i,
.btn.btn-active-icon-warning.show .svg-icon, .show > .btn.btn-active-icon-warning i,
.show > .btn.btn-active-icon-warning .svg-icon {
  color: var(--kt-text-warning);
}
.btn-check:checked + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn.btn-active-icon-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning.active.dropdown-toggle:after, .btn.btn-active-icon-warning.show.dropdown-toggle:after, .show > .btn.btn-active-icon-warning.dropdown-toggle:after {
  color: var(--kt-text-warning);
}

.btn.btn-text-warning {
  color: var(--kt-text-warning);
}
.btn-check:checked + .btn.btn-active-text-warning, .btn-check:active + .btn.btn-active-text-warning, .btn.btn-active-text-warning:focus:not(.btn-active), .btn.btn-active-text-warning:hover:not(.btn-active), .btn.btn-active-text-warning:active:not(.btn-active), .btn.btn-active-text-warning.active, .btn.btn-active-text-warning.show, .show > .btn.btn-active-text-warning {
  color: var(--kt-text-warning);
}

.btn.btn-color-danger {
  color: var(--kt-text-danger);
}
.btn.btn-color-danger i,
.btn.btn-color-danger .svg-icon {
  color: var(--kt-text-danger);
}
.btn.btn-color-danger.dropdown-toggle:after {
  color: var(--kt-text-danger);
}
.btn-check:checked + .btn.btn-active-color-danger, .btn-check:active + .btn.btn-active-color-danger, .btn.btn-active-color-danger:focus:not(.btn-active), .btn.btn-active-color-danger:hover:not(.btn-active), .btn.btn-active-color-danger:active:not(.btn-active), .btn.btn-active-color-danger.active, .btn.btn-active-color-danger.show, .show > .btn.btn-active-color-danger {
  color: var(--kt-text-danger);
}
.btn-check:checked + .btn.btn-active-color-danger i,
.btn-check:checked + .btn.btn-active-color-danger .svg-icon, .btn-check:active + .btn.btn-active-color-danger i,
.btn-check:active + .btn.btn-active-color-danger .svg-icon, .btn.btn-active-color-danger:focus:not(.btn-active) i,
.btn.btn-active-color-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-danger:hover:not(.btn-active) i,
.btn.btn-active-color-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-danger:active:not(.btn-active) i,
.btn.btn-active-color-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-color-danger.active i,
.btn.btn-active-color-danger.active .svg-icon, .btn.btn-active-color-danger.show i,
.btn.btn-active-color-danger.show .svg-icon, .show > .btn.btn-active-color-danger i,
.show > .btn.btn-active-color-danger .svg-icon {
  color: var(--kt-text-danger);
}
.btn-check:checked + .btn.btn-active-color-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-danger.dropdown-toggle:after, .btn.btn-active-color-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger.active.dropdown-toggle:after, .btn.btn-active-color-danger.show.dropdown-toggle:after, .show > .btn.btn-active-color-danger.dropdown-toggle:after {
  color: var(--kt-text-danger);
}

.btn.btn-icon-danger i,
.btn.btn-icon-danger .svg-icon {
  color: var(--kt-text-danger);
}
.btn.btn-icon-danger.dropdown-toggle:after {
  color: var(--kt-text-danger);
}
.btn-check:checked + .btn.btn-active-icon-danger i,
.btn-check:checked + .btn.btn-active-icon-danger .svg-icon, .btn-check:active + .btn.btn-active-icon-danger i,
.btn-check:active + .btn.btn-active-icon-danger .svg-icon, .btn.btn-active-icon-danger:focus:not(.btn-active) i,
.btn.btn-active-icon-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger:hover:not(.btn-active) i,
.btn.btn-active-icon-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger:active:not(.btn-active) i,
.btn.btn-active-icon-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger.active i,
.btn.btn-active-icon-danger.active .svg-icon, .btn.btn-active-icon-danger.show i,
.btn.btn-active-icon-danger.show .svg-icon, .show > .btn.btn-active-icon-danger i,
.show > .btn.btn-active-icon-danger .svg-icon {
  color: var(--kt-text-danger);
}
.btn-check:checked + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn.btn-active-icon-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger.active.dropdown-toggle:after, .btn.btn-active-icon-danger.show.dropdown-toggle:after, .show > .btn.btn-active-icon-danger.dropdown-toggle:after {
  color: var(--kt-text-danger);
}

.btn.btn-text-danger {
  color: var(--kt-text-danger);
}
.btn-check:checked + .btn.btn-active-text-danger, .btn-check:active + .btn.btn-active-text-danger, .btn.btn-active-text-danger:focus:not(.btn-active), .btn.btn-active-text-danger:hover:not(.btn-active), .btn.btn-active-text-danger:active:not(.btn-active), .btn.btn-active-text-danger.active, .btn.btn-active-text-danger.show, .show > .btn.btn-active-text-danger {
  color: var(--kt-text-danger);
}

.btn.btn-color-dark {
  color: var(--kt-text-dark);
}
.btn.btn-color-dark i,
.btn.btn-color-dark .svg-icon {
  color: var(--kt-text-dark);
}
.btn.btn-color-dark.dropdown-toggle:after {
  color: var(--kt-text-dark);
}
.btn-check:checked + .btn.btn-active-color-dark, .btn-check:active + .btn.btn-active-color-dark, .btn.btn-active-color-dark:focus:not(.btn-active), .btn.btn-active-color-dark:hover:not(.btn-active), .btn.btn-active-color-dark:active:not(.btn-active), .btn.btn-active-color-dark.active, .btn.btn-active-color-dark.show, .show > .btn.btn-active-color-dark {
  color: var(--kt-text-dark);
}
.btn-check:checked + .btn.btn-active-color-dark i,
.btn-check:checked + .btn.btn-active-color-dark .svg-icon, .btn-check:active + .btn.btn-active-color-dark i,
.btn-check:active + .btn.btn-active-color-dark .svg-icon, .btn.btn-active-color-dark:focus:not(.btn-active) i,
.btn.btn-active-color-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-dark:hover:not(.btn-active) i,
.btn.btn-active-color-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-dark:active:not(.btn-active) i,
.btn.btn-active-color-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-color-dark.active i,
.btn.btn-active-color-dark.active .svg-icon, .btn.btn-active-color-dark.show i,
.btn.btn-active-color-dark.show .svg-icon, .show > .btn.btn-active-color-dark i,
.show > .btn.btn-active-color-dark .svg-icon {
  color: var(--kt-text-dark);
}
.btn-check:checked + .btn.btn-active-color-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-dark.dropdown-toggle:after, .btn.btn-active-color-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark.active.dropdown-toggle:after, .btn.btn-active-color-dark.show.dropdown-toggle:after, .show > .btn.btn-active-color-dark.dropdown-toggle:after {
  color: var(--kt-text-dark);
}

.btn.btn-icon-dark i,
.btn.btn-icon-dark .svg-icon {
  color: var(--kt-text-dark);
}
.btn.btn-icon-dark.dropdown-toggle:after {
  color: var(--kt-text-dark);
}
.btn-check:checked + .btn.btn-active-icon-dark i,
.btn-check:checked + .btn.btn-active-icon-dark .svg-icon, .btn-check:active + .btn.btn-active-icon-dark i,
.btn-check:active + .btn.btn-active-icon-dark .svg-icon, .btn.btn-active-icon-dark:focus:not(.btn-active) i,
.btn.btn-active-icon-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark:hover:not(.btn-active) i,
.btn.btn-active-icon-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark:active:not(.btn-active) i,
.btn.btn-active-icon-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark.active i,
.btn.btn-active-icon-dark.active .svg-icon, .btn.btn-active-icon-dark.show i,
.btn.btn-active-icon-dark.show .svg-icon, .show > .btn.btn-active-icon-dark i,
.show > .btn.btn-active-icon-dark .svg-icon {
  color: var(--kt-text-dark);
}
.btn-check:checked + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn.btn-active-icon-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark.active.dropdown-toggle:after, .btn.btn-active-icon-dark.show.dropdown-toggle:after, .show > .btn.btn-active-icon-dark.dropdown-toggle:after {
  color: var(--kt-text-dark);
}

.btn.btn-text-dark {
  color: var(--kt-text-dark);
}
.btn-check:checked + .btn.btn-active-text-dark, .btn-check:active + .btn.btn-active-text-dark, .btn.btn-active-text-dark:focus:not(.btn-active), .btn.btn-active-text-dark:hover:not(.btn-active), .btn.btn-active-text-dark:active:not(.btn-active), .btn.btn-active-text-dark.active, .btn.btn-active-text-dark.show, .show > .btn.btn-active-text-dark {
  color: var(--kt-text-dark);
}

.btn.btn-color-muted {
  color: var(--kt-text-muted);
}
.btn.btn-color-muted i,
.btn.btn-color-muted .svg-icon {
  color: var(--kt-text-muted);
}
.btn.btn-color-muted.dropdown-toggle:after {
  color: var(--kt-text-muted);
}
.btn-check:checked + .btn.btn-active-color-muted, .btn-check:active + .btn.btn-active-color-muted, .btn.btn-active-color-muted:focus:not(.btn-active), .btn.btn-active-color-muted:hover:not(.btn-active), .btn.btn-active-color-muted:active:not(.btn-active), .btn.btn-active-color-muted.active, .btn.btn-active-color-muted.show, .show > .btn.btn-active-color-muted {
  color: var(--kt-text-muted);
}
.btn-check:checked + .btn.btn-active-color-muted i,
.btn-check:checked + .btn.btn-active-color-muted .svg-icon, .btn-check:active + .btn.btn-active-color-muted i,
.btn-check:active + .btn.btn-active-color-muted .svg-icon, .btn.btn-active-color-muted:focus:not(.btn-active) i,
.btn.btn-active-color-muted:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-muted:hover:not(.btn-active) i,
.btn.btn-active-color-muted:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-muted:active:not(.btn-active) i,
.btn.btn-active-color-muted:active:not(.btn-active) .svg-icon, .btn.btn-active-color-muted.active i,
.btn.btn-active-color-muted.active .svg-icon, .btn.btn-active-color-muted.show i,
.btn.btn-active-color-muted.show .svg-icon, .show > .btn.btn-active-color-muted i,
.show > .btn.btn-active-color-muted .svg-icon {
  color: var(--kt-text-muted);
}
.btn-check:checked + .btn.btn-active-color-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-muted.dropdown-toggle:after, .btn.btn-active-color-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted.active.dropdown-toggle:after, .btn.btn-active-color-muted.show.dropdown-toggle:after, .show > .btn.btn-active-color-muted.dropdown-toggle:after {
  color: var(--kt-text-muted);
}

.btn.btn-icon-muted i,
.btn.btn-icon-muted .svg-icon {
  color: var(--kt-text-muted);
}
.btn.btn-icon-muted.dropdown-toggle:after {
  color: var(--kt-text-muted);
}
.btn-check:checked + .btn.btn-active-icon-muted i,
.btn-check:checked + .btn.btn-active-icon-muted .svg-icon, .btn-check:active + .btn.btn-active-icon-muted i,
.btn-check:active + .btn.btn-active-icon-muted .svg-icon, .btn.btn-active-icon-muted:focus:not(.btn-active) i,
.btn.btn-active-icon-muted:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted:hover:not(.btn-active) i,
.btn.btn-active-icon-muted:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted:active:not(.btn-active) i,
.btn.btn-active-icon-muted:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted.active i,
.btn.btn-active-icon-muted.active .svg-icon, .btn.btn-active-icon-muted.show i,
.btn.btn-active-icon-muted.show .svg-icon, .show > .btn.btn-active-icon-muted i,
.show > .btn.btn-active-icon-muted .svg-icon {
  color: var(--kt-text-muted);
}
.btn-check:checked + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn.btn-active-icon-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted.active.dropdown-toggle:after, .btn.btn-active-icon-muted.show.dropdown-toggle:after, .show > .btn.btn-active-icon-muted.dropdown-toggle:after {
  color: var(--kt-text-muted);
}

.btn.btn-text-muted {
  color: var(--kt-text-muted);
}
.btn-check:checked + .btn.btn-active-text-muted, .btn-check:active + .btn.btn-active-text-muted, .btn.btn-active-text-muted:focus:not(.btn-active), .btn.btn-active-text-muted:hover:not(.btn-active), .btn.btn-active-text-muted:active:not(.btn-active), .btn.btn-active-text-muted.active, .btn.btn-active-text-muted.show, .show > .btn.btn-active-text-muted {
  color: var(--kt-text-muted);
}

.btn.btn-color-gray-100 {
  color: var(--kt-text-gray-100);
}
.btn.btn-color-gray-100 i,
.btn.btn-color-gray-100 .svg-icon {
  color: var(--kt-text-gray-100);
}
.btn.btn-color-gray-100.dropdown-toggle:after {
  color: var(--kt-text-gray-100);
}
.btn-check:checked + .btn.btn-active-color-gray-100, .btn-check:active + .btn.btn-active-color-gray-100, .btn.btn-active-color-gray-100:focus:not(.btn-active), .btn.btn-active-color-gray-100:hover:not(.btn-active), .btn.btn-active-color-gray-100:active:not(.btn-active), .btn.btn-active-color-gray-100.active, .btn.btn-active-color-gray-100.show, .show > .btn.btn-active-color-gray-100 {
  color: var(--kt-text-gray-100);
}
.btn-check:checked + .btn.btn-active-color-gray-100 i,
.btn-check:checked + .btn.btn-active-color-gray-100 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-100 i,
.btn-check:active + .btn.btn-active-color-gray-100 .svg-icon, .btn.btn-active-color-gray-100:focus:not(.btn-active) i,
.btn.btn-active-color-gray-100:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100:hover:not(.btn-active) i,
.btn.btn-active-color-gray-100:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100:active:not(.btn-active) i,
.btn.btn-active-color-gray-100:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100.active i,
.btn.btn-active-color-gray-100.active .svg-icon, .btn.btn-active-color-gray-100.show i,
.btn.btn-active-color-gray-100.show .svg-icon, .show > .btn.btn-active-color-gray-100 i,
.show > .btn.btn-active-color-gray-100 .svg-icon {
  color: var(--kt-text-gray-100);
}
.btn-check:checked + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn.btn-active-color-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100.active.dropdown-toggle:after, .btn.btn-active-color-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-100.dropdown-toggle:after {
  color: var(--kt-text-gray-100);
}

.btn.btn-icon-gray-100 i,
.btn.btn-icon-gray-100 .svg-icon {
  color: var(--kt-text-gray-100);
}
.btn.btn-icon-gray-100.dropdown-toggle:after {
  color: var(--kt-text-gray-100);
}
.btn-check:checked + .btn.btn-active-icon-gray-100 i,
.btn-check:checked + .btn.btn-active-icon-gray-100 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-100 i,
.btn-check:active + .btn.btn-active-icon-gray-100 .svg-icon, .btn.btn-active-icon-gray-100:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-100:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-100:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100:active:not(.btn-active) i,
.btn.btn-active-icon-gray-100:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100.active i,
.btn.btn-active-icon-gray-100.active .svg-icon, .btn.btn-active-icon-gray-100.show i,
.btn.btn-active-icon-gray-100.show .svg-icon, .show > .btn.btn-active-icon-gray-100 i,
.show > .btn.btn-active-icon-gray-100 .svg-icon {
  color: var(--kt-text-gray-100);
}
.btn-check:checked + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn.btn-active-icon-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100.active.dropdown-toggle:after, .btn.btn-active-icon-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-100.dropdown-toggle:after {
  color: var(--kt-text-gray-100);
}

.btn.btn-text-gray-100 {
  color: var(--kt-text-gray-100);
}
.btn-check:checked + .btn.btn-active-text-gray-100, .btn-check:active + .btn.btn-active-text-gray-100, .btn.btn-active-text-gray-100:focus:not(.btn-active), .btn.btn-active-text-gray-100:hover:not(.btn-active), .btn.btn-active-text-gray-100:active:not(.btn-active), .btn.btn-active-text-gray-100.active, .btn.btn-active-text-gray-100.show, .show > .btn.btn-active-text-gray-100 {
  color: var(--kt-text-gray-100);
}

.btn.btn-color-gray-200 {
  color: var(--kt-text-gray-200);
}
.btn.btn-color-gray-200 i,
.btn.btn-color-gray-200 .svg-icon {
  color: var(--kt-text-gray-200);
}
.btn.btn-color-gray-200.dropdown-toggle:after {
  color: var(--kt-text-gray-200);
}
.btn-check:checked + .btn.btn-active-color-gray-200, .btn-check:active + .btn.btn-active-color-gray-200, .btn.btn-active-color-gray-200:focus:not(.btn-active), .btn.btn-active-color-gray-200:hover:not(.btn-active), .btn.btn-active-color-gray-200:active:not(.btn-active), .btn.btn-active-color-gray-200.active, .btn.btn-active-color-gray-200.show, .show > .btn.btn-active-color-gray-200 {
  color: var(--kt-text-gray-200);
}
.btn-check:checked + .btn.btn-active-color-gray-200 i,
.btn-check:checked + .btn.btn-active-color-gray-200 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-200 i,
.btn-check:active + .btn.btn-active-color-gray-200 .svg-icon, .btn.btn-active-color-gray-200:focus:not(.btn-active) i,
.btn.btn-active-color-gray-200:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200:hover:not(.btn-active) i,
.btn.btn-active-color-gray-200:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200:active:not(.btn-active) i,
.btn.btn-active-color-gray-200:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200.active i,
.btn.btn-active-color-gray-200.active .svg-icon, .btn.btn-active-color-gray-200.show i,
.btn.btn-active-color-gray-200.show .svg-icon, .show > .btn.btn-active-color-gray-200 i,
.show > .btn.btn-active-color-gray-200 .svg-icon {
  color: var(--kt-text-gray-200);
}
.btn-check:checked + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn.btn-active-color-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200.active.dropdown-toggle:after, .btn.btn-active-color-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-200.dropdown-toggle:after {
  color: var(--kt-text-gray-200);
}

.btn.btn-icon-gray-200 i,
.btn.btn-icon-gray-200 .svg-icon {
  color: var(--kt-text-gray-200);
}
.btn.btn-icon-gray-200.dropdown-toggle:after {
  color: var(--kt-text-gray-200);
}
.btn-check:checked + .btn.btn-active-icon-gray-200 i,
.btn-check:checked + .btn.btn-active-icon-gray-200 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-200 i,
.btn-check:active + .btn.btn-active-icon-gray-200 .svg-icon, .btn.btn-active-icon-gray-200:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-200:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-200:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200:active:not(.btn-active) i,
.btn.btn-active-icon-gray-200:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200.active i,
.btn.btn-active-icon-gray-200.active .svg-icon, .btn.btn-active-icon-gray-200.show i,
.btn.btn-active-icon-gray-200.show .svg-icon, .show > .btn.btn-active-icon-gray-200 i,
.show > .btn.btn-active-icon-gray-200 .svg-icon {
  color: var(--kt-text-gray-200);
}
.btn-check:checked + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn.btn-active-icon-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200.active.dropdown-toggle:after, .btn.btn-active-icon-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-200.dropdown-toggle:after {
  color: var(--kt-text-gray-200);
}

.btn.btn-text-gray-200 {
  color: var(--kt-text-gray-200);
}
.btn-check:checked + .btn.btn-active-text-gray-200, .btn-check:active + .btn.btn-active-text-gray-200, .btn.btn-active-text-gray-200:focus:not(.btn-active), .btn.btn-active-text-gray-200:hover:not(.btn-active), .btn.btn-active-text-gray-200:active:not(.btn-active), .btn.btn-active-text-gray-200.active, .btn.btn-active-text-gray-200.show, .show > .btn.btn-active-text-gray-200 {
  color: var(--kt-text-gray-200);
}

.btn.btn-color-gray-300 {
  color: var(--kt-text-gray-300);
}
.btn.btn-color-gray-300 i,
.btn.btn-color-gray-300 .svg-icon {
  color: var(--kt-text-gray-300);
}
.btn.btn-color-gray-300.dropdown-toggle:after {
  color: var(--kt-text-gray-300);
}
.btn-check:checked + .btn.btn-active-color-gray-300, .btn-check:active + .btn.btn-active-color-gray-300, .btn.btn-active-color-gray-300:focus:not(.btn-active), .btn.btn-active-color-gray-300:hover:not(.btn-active), .btn.btn-active-color-gray-300:active:not(.btn-active), .btn.btn-active-color-gray-300.active, .btn.btn-active-color-gray-300.show, .show > .btn.btn-active-color-gray-300 {
  color: var(--kt-text-gray-300);
}
.btn-check:checked + .btn.btn-active-color-gray-300 i,
.btn-check:checked + .btn.btn-active-color-gray-300 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-300 i,
.btn-check:active + .btn.btn-active-color-gray-300 .svg-icon, .btn.btn-active-color-gray-300:focus:not(.btn-active) i,
.btn.btn-active-color-gray-300:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300:hover:not(.btn-active) i,
.btn.btn-active-color-gray-300:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300:active:not(.btn-active) i,
.btn.btn-active-color-gray-300:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300.active i,
.btn.btn-active-color-gray-300.active .svg-icon, .btn.btn-active-color-gray-300.show i,
.btn.btn-active-color-gray-300.show .svg-icon, .show > .btn.btn-active-color-gray-300 i,
.show > .btn.btn-active-color-gray-300 .svg-icon {
  color: var(--kt-text-gray-300);
}
.btn-check:checked + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn.btn-active-color-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300.active.dropdown-toggle:after, .btn.btn-active-color-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-300.dropdown-toggle:after {
  color: var(--kt-text-gray-300);
}

.btn.btn-icon-gray-300 i,
.btn.btn-icon-gray-300 .svg-icon {
  color: var(--kt-text-gray-300);
}
.btn.btn-icon-gray-300.dropdown-toggle:after {
  color: var(--kt-text-gray-300);
}
.btn-check:checked + .btn.btn-active-icon-gray-300 i,
.btn-check:checked + .btn.btn-active-icon-gray-300 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-300 i,
.btn-check:active + .btn.btn-active-icon-gray-300 .svg-icon, .btn.btn-active-icon-gray-300:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-300:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-300:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300:active:not(.btn-active) i,
.btn.btn-active-icon-gray-300:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300.active i,
.btn.btn-active-icon-gray-300.active .svg-icon, .btn.btn-active-icon-gray-300.show i,
.btn.btn-active-icon-gray-300.show .svg-icon, .show > .btn.btn-active-icon-gray-300 i,
.show > .btn.btn-active-icon-gray-300 .svg-icon {
  color: var(--kt-text-gray-300);
}
.btn-check:checked + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn.btn-active-icon-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300.active.dropdown-toggle:after, .btn.btn-active-icon-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-300.dropdown-toggle:after {
  color: var(--kt-text-gray-300);
}

.btn.btn-text-gray-300 {
  color: var(--kt-text-gray-300);
}
.btn-check:checked + .btn.btn-active-text-gray-300, .btn-check:active + .btn.btn-active-text-gray-300, .btn.btn-active-text-gray-300:focus:not(.btn-active), .btn.btn-active-text-gray-300:hover:not(.btn-active), .btn.btn-active-text-gray-300:active:not(.btn-active), .btn.btn-active-text-gray-300.active, .btn.btn-active-text-gray-300.show, .show > .btn.btn-active-text-gray-300 {
  color: var(--kt-text-gray-300);
}

.btn.btn-color-gray-400 {
  color: var(--kt-text-gray-400);
}
.btn.btn-color-gray-400 i,
.btn.btn-color-gray-400 .svg-icon {
  color: var(--kt-text-gray-400);
}
.btn.btn-color-gray-400.dropdown-toggle:after {
  color: var(--kt-text-gray-400);
}
.btn-check:checked + .btn.btn-active-color-gray-400, .btn-check:active + .btn.btn-active-color-gray-400, .btn.btn-active-color-gray-400:focus:not(.btn-active), .btn.btn-active-color-gray-400:hover:not(.btn-active), .btn.btn-active-color-gray-400:active:not(.btn-active), .btn.btn-active-color-gray-400.active, .btn.btn-active-color-gray-400.show, .show > .btn.btn-active-color-gray-400 {
  color: var(--kt-text-gray-400);
}
.btn-check:checked + .btn.btn-active-color-gray-400 i,
.btn-check:checked + .btn.btn-active-color-gray-400 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-400 i,
.btn-check:active + .btn.btn-active-color-gray-400 .svg-icon, .btn.btn-active-color-gray-400:focus:not(.btn-active) i,
.btn.btn-active-color-gray-400:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400:hover:not(.btn-active) i,
.btn.btn-active-color-gray-400:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400:active:not(.btn-active) i,
.btn.btn-active-color-gray-400:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400.active i,
.btn.btn-active-color-gray-400.active .svg-icon, .btn.btn-active-color-gray-400.show i,
.btn.btn-active-color-gray-400.show .svg-icon, .show > .btn.btn-active-color-gray-400 i,
.show > .btn.btn-active-color-gray-400 .svg-icon {
  color: var(--kt-text-gray-400);
}
.btn-check:checked + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn.btn-active-color-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400.active.dropdown-toggle:after, .btn.btn-active-color-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-400.dropdown-toggle:after {
  color: var(--kt-text-gray-400);
}

.btn.btn-icon-gray-400 i,
.btn.btn-icon-gray-400 .svg-icon {
  color: var(--kt-text-gray-400);
}
.btn.btn-icon-gray-400.dropdown-toggle:after {
  color: var(--kt-text-gray-400);
}
.btn-check:checked + .btn.btn-active-icon-gray-400 i,
.btn-check:checked + .btn.btn-active-icon-gray-400 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-400 i,
.btn-check:active + .btn.btn-active-icon-gray-400 .svg-icon, .btn.btn-active-icon-gray-400:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-400:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-400:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400:active:not(.btn-active) i,
.btn.btn-active-icon-gray-400:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400.active i,
.btn.btn-active-icon-gray-400.active .svg-icon, .btn.btn-active-icon-gray-400.show i,
.btn.btn-active-icon-gray-400.show .svg-icon, .show > .btn.btn-active-icon-gray-400 i,
.show > .btn.btn-active-icon-gray-400 .svg-icon {
  color: var(--kt-text-gray-400);
}
.btn-check:checked + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn.btn-active-icon-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400.active.dropdown-toggle:after, .btn.btn-active-icon-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-400.dropdown-toggle:after {
  color: var(--kt-text-gray-400);
}

.btn.btn-text-gray-400 {
  color: var(--kt-text-gray-400);
}
.btn-check:checked + .btn.btn-active-text-gray-400, .btn-check:active + .btn.btn-active-text-gray-400, .btn.btn-active-text-gray-400:focus:not(.btn-active), .btn.btn-active-text-gray-400:hover:not(.btn-active), .btn.btn-active-text-gray-400:active:not(.btn-active), .btn.btn-active-text-gray-400.active, .btn.btn-active-text-gray-400.show, .show > .btn.btn-active-text-gray-400 {
  color: var(--kt-text-gray-400);
}

.btn.btn-color-gray-500 {
  color: var(--kt-text-gray-500);
}
.btn.btn-color-gray-500 i,
.btn.btn-color-gray-500 .svg-icon {
  color: var(--kt-text-gray-500);
}
.btn.btn-color-gray-500.dropdown-toggle:after {
  color: var(--kt-text-gray-500);
}
.btn-check:checked + .btn.btn-active-color-gray-500, .btn-check:active + .btn.btn-active-color-gray-500, .btn.btn-active-color-gray-500:focus:not(.btn-active), .btn.btn-active-color-gray-500:hover:not(.btn-active), .btn.btn-active-color-gray-500:active:not(.btn-active), .btn.btn-active-color-gray-500.active, .btn.btn-active-color-gray-500.show, .show > .btn.btn-active-color-gray-500 {
  color: var(--kt-text-gray-500);
}
.btn-check:checked + .btn.btn-active-color-gray-500 i,
.btn-check:checked + .btn.btn-active-color-gray-500 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-500 i,
.btn-check:active + .btn.btn-active-color-gray-500 .svg-icon, .btn.btn-active-color-gray-500:focus:not(.btn-active) i,
.btn.btn-active-color-gray-500:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500:hover:not(.btn-active) i,
.btn.btn-active-color-gray-500:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500:active:not(.btn-active) i,
.btn.btn-active-color-gray-500:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500.active i,
.btn.btn-active-color-gray-500.active .svg-icon, .btn.btn-active-color-gray-500.show i,
.btn.btn-active-color-gray-500.show .svg-icon, .show > .btn.btn-active-color-gray-500 i,
.show > .btn.btn-active-color-gray-500 .svg-icon {
  color: var(--kt-text-gray-500);
}
.btn-check:checked + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn.btn-active-color-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500.active.dropdown-toggle:after, .btn.btn-active-color-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-500.dropdown-toggle:after {
  color: var(--kt-text-gray-500);
}

.btn.btn-icon-gray-500 i,
.btn.btn-icon-gray-500 .svg-icon {
  color: var(--kt-text-gray-500);
}
.btn.btn-icon-gray-500.dropdown-toggle:after {
  color: var(--kt-text-gray-500);
}
.btn-check:checked + .btn.btn-active-icon-gray-500 i,
.btn-check:checked + .btn.btn-active-icon-gray-500 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-500 i,
.btn-check:active + .btn.btn-active-icon-gray-500 .svg-icon, .btn.btn-active-icon-gray-500:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-500:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-500:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500:active:not(.btn-active) i,
.btn.btn-active-icon-gray-500:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500.active i,
.btn.btn-active-icon-gray-500.active .svg-icon, .btn.btn-active-icon-gray-500.show i,
.btn.btn-active-icon-gray-500.show .svg-icon, .show > .btn.btn-active-icon-gray-500 i,
.show > .btn.btn-active-icon-gray-500 .svg-icon {
  color: var(--kt-text-gray-500);
}
.btn-check:checked + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn.btn-active-icon-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500.active.dropdown-toggle:after, .btn.btn-active-icon-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-500.dropdown-toggle:after {
  color: var(--kt-text-gray-500);
}

.btn.btn-text-gray-500 {
  color: var(--kt-text-gray-500);
}
.btn-check:checked + .btn.btn-active-text-gray-500, .btn-check:active + .btn.btn-active-text-gray-500, .btn.btn-active-text-gray-500:focus:not(.btn-active), .btn.btn-active-text-gray-500:hover:not(.btn-active), .btn.btn-active-text-gray-500:active:not(.btn-active), .btn.btn-active-text-gray-500.active, .btn.btn-active-text-gray-500.show, .show > .btn.btn-active-text-gray-500 {
  color: var(--kt-text-gray-500);
}

.btn.btn-color-gray-600 {
  color: var(--kt-text-gray-600);
}
.btn.btn-color-gray-600 i,
.btn.btn-color-gray-600 .svg-icon {
  color: var(--kt-text-gray-600);
}
.btn.btn-color-gray-600.dropdown-toggle:after {
  color: var(--kt-text-gray-600);
}
.btn-check:checked + .btn.btn-active-color-gray-600, .btn-check:active + .btn.btn-active-color-gray-600, .btn.btn-active-color-gray-600:focus:not(.btn-active), .btn.btn-active-color-gray-600:hover:not(.btn-active), .btn.btn-active-color-gray-600:active:not(.btn-active), .btn.btn-active-color-gray-600.active, .btn.btn-active-color-gray-600.show, .show > .btn.btn-active-color-gray-600 {
  color: var(--kt-text-gray-600);
}
.btn-check:checked + .btn.btn-active-color-gray-600 i,
.btn-check:checked + .btn.btn-active-color-gray-600 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-600 i,
.btn-check:active + .btn.btn-active-color-gray-600 .svg-icon, .btn.btn-active-color-gray-600:focus:not(.btn-active) i,
.btn.btn-active-color-gray-600:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600:hover:not(.btn-active) i,
.btn.btn-active-color-gray-600:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600:active:not(.btn-active) i,
.btn.btn-active-color-gray-600:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600.active i,
.btn.btn-active-color-gray-600.active .svg-icon, .btn.btn-active-color-gray-600.show i,
.btn.btn-active-color-gray-600.show .svg-icon, .show > .btn.btn-active-color-gray-600 i,
.show > .btn.btn-active-color-gray-600 .svg-icon {
  color: var(--kt-text-gray-600);
}
.btn-check:checked + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn.btn-active-color-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600.active.dropdown-toggle:after, .btn.btn-active-color-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-600.dropdown-toggle:after {
  color: var(--kt-text-gray-600);
}

.btn.btn-icon-gray-600 i,
.btn.btn-icon-gray-600 .svg-icon {
  color: var(--kt-text-gray-600);
}
.btn.btn-icon-gray-600.dropdown-toggle:after {
  color: var(--kt-text-gray-600);
}
.btn-check:checked + .btn.btn-active-icon-gray-600 i,
.btn-check:checked + .btn.btn-active-icon-gray-600 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-600 i,
.btn-check:active + .btn.btn-active-icon-gray-600 .svg-icon, .btn.btn-active-icon-gray-600:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-600:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-600:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600:active:not(.btn-active) i,
.btn.btn-active-icon-gray-600:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600.active i,
.btn.btn-active-icon-gray-600.active .svg-icon, .btn.btn-active-icon-gray-600.show i,
.btn.btn-active-icon-gray-600.show .svg-icon, .show > .btn.btn-active-icon-gray-600 i,
.show > .btn.btn-active-icon-gray-600 .svg-icon {
  color: var(--kt-text-gray-600);
}
.btn-check:checked + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn.btn-active-icon-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600.active.dropdown-toggle:after, .btn.btn-active-icon-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-600.dropdown-toggle:after {
  color: var(--kt-text-gray-600);
}

.btn.btn-text-gray-600 {
  color: var(--kt-text-gray-600);
}
.btn-check:checked + .btn.btn-active-text-gray-600, .btn-check:active + .btn.btn-active-text-gray-600, .btn.btn-active-text-gray-600:focus:not(.btn-active), .btn.btn-active-text-gray-600:hover:not(.btn-active), .btn.btn-active-text-gray-600:active:not(.btn-active), .btn.btn-active-text-gray-600.active, .btn.btn-active-text-gray-600.show, .show > .btn.btn-active-text-gray-600 {
  color: var(--kt-text-gray-600);
}

.btn.btn-color-gray-700 {
  color: var(--kt-text-gray-700);
}
.btn.btn-color-gray-700 i,
.btn.btn-color-gray-700 .svg-icon {
  color: var(--kt-text-gray-700);
}
.btn.btn-color-gray-700.dropdown-toggle:after {
  color: var(--kt-text-gray-700);
}
.btn-check:checked + .btn.btn-active-color-gray-700, .btn-check:active + .btn.btn-active-color-gray-700, .btn.btn-active-color-gray-700:focus:not(.btn-active), .btn.btn-active-color-gray-700:hover:not(.btn-active), .btn.btn-active-color-gray-700:active:not(.btn-active), .btn.btn-active-color-gray-700.active, .btn.btn-active-color-gray-700.show, .show > .btn.btn-active-color-gray-700 {
  color: var(--kt-text-gray-700);
}
.btn-check:checked + .btn.btn-active-color-gray-700 i,
.btn-check:checked + .btn.btn-active-color-gray-700 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-700 i,
.btn-check:active + .btn.btn-active-color-gray-700 .svg-icon, .btn.btn-active-color-gray-700:focus:not(.btn-active) i,
.btn.btn-active-color-gray-700:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700:hover:not(.btn-active) i,
.btn.btn-active-color-gray-700:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700:active:not(.btn-active) i,
.btn.btn-active-color-gray-700:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700.active i,
.btn.btn-active-color-gray-700.active .svg-icon, .btn.btn-active-color-gray-700.show i,
.btn.btn-active-color-gray-700.show .svg-icon, .show > .btn.btn-active-color-gray-700 i,
.show > .btn.btn-active-color-gray-700 .svg-icon {
  color: var(--kt-text-gray-700);
}
.btn-check:checked + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn.btn-active-color-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700.active.dropdown-toggle:after, .btn.btn-active-color-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-700.dropdown-toggle:after {
  color: var(--kt-text-gray-700);
}

.btn.btn-icon-gray-700 i,
.btn.btn-icon-gray-700 .svg-icon {
  color: var(--kt-text-gray-700);
}
.btn.btn-icon-gray-700.dropdown-toggle:after {
  color: var(--kt-text-gray-700);
}
.btn-check:checked + .btn.btn-active-icon-gray-700 i,
.btn-check:checked + .btn.btn-active-icon-gray-700 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-700 i,
.btn-check:active + .btn.btn-active-icon-gray-700 .svg-icon, .btn.btn-active-icon-gray-700:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-700:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-700:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700:active:not(.btn-active) i,
.btn.btn-active-icon-gray-700:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700.active i,
.btn.btn-active-icon-gray-700.active .svg-icon, .btn.btn-active-icon-gray-700.show i,
.btn.btn-active-icon-gray-700.show .svg-icon, .show > .btn.btn-active-icon-gray-700 i,
.show > .btn.btn-active-icon-gray-700 .svg-icon {
  color: var(--kt-text-gray-700);
}
.btn-check:checked + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn.btn-active-icon-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700.active.dropdown-toggle:after, .btn.btn-active-icon-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-700.dropdown-toggle:after {
  color: var(--kt-text-gray-700);
}

.btn.btn-text-gray-700 {
  color: var(--kt-text-gray-700);
}
.btn-check:checked + .btn.btn-active-text-gray-700, .btn-check:active + .btn.btn-active-text-gray-700, .btn.btn-active-text-gray-700:focus:not(.btn-active), .btn.btn-active-text-gray-700:hover:not(.btn-active), .btn.btn-active-text-gray-700:active:not(.btn-active), .btn.btn-active-text-gray-700.active, .btn.btn-active-text-gray-700.show, .show > .btn.btn-active-text-gray-700 {
  color: var(--kt-text-gray-700);
}

.btn.btn-color-gray-800 {
  color: var(--kt-text-gray-800);
}
.btn.btn-color-gray-800 i,
.btn.btn-color-gray-800 .svg-icon {
  color: var(--kt-text-gray-800);
}
.btn.btn-color-gray-800.dropdown-toggle:after {
  color: var(--kt-text-gray-800);
}
.btn-check:checked + .btn.btn-active-color-gray-800, .btn-check:active + .btn.btn-active-color-gray-800, .btn.btn-active-color-gray-800:focus:not(.btn-active), .btn.btn-active-color-gray-800:hover:not(.btn-active), .btn.btn-active-color-gray-800:active:not(.btn-active), .btn.btn-active-color-gray-800.active, .btn.btn-active-color-gray-800.show, .show > .btn.btn-active-color-gray-800 {
  color: var(--kt-text-gray-800);
}
.btn-check:checked + .btn.btn-active-color-gray-800 i,
.btn-check:checked + .btn.btn-active-color-gray-800 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-800 i,
.btn-check:active + .btn.btn-active-color-gray-800 .svg-icon, .btn.btn-active-color-gray-800:focus:not(.btn-active) i,
.btn.btn-active-color-gray-800:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800:hover:not(.btn-active) i,
.btn.btn-active-color-gray-800:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800:active:not(.btn-active) i,
.btn.btn-active-color-gray-800:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800.active i,
.btn.btn-active-color-gray-800.active .svg-icon, .btn.btn-active-color-gray-800.show i,
.btn.btn-active-color-gray-800.show .svg-icon, .show > .btn.btn-active-color-gray-800 i,
.show > .btn.btn-active-color-gray-800 .svg-icon {
  color: var(--kt-text-gray-800);
}
.btn-check:checked + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn.btn-active-color-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800.active.dropdown-toggle:after, .btn.btn-active-color-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-800.dropdown-toggle:after {
  color: var(--kt-text-gray-800);
}

.btn.btn-icon-gray-800 i,
.btn.btn-icon-gray-800 .svg-icon {
  color: var(--kt-text-gray-800);
}
.btn.btn-icon-gray-800.dropdown-toggle:after {
  color: var(--kt-text-gray-800);
}
.btn-check:checked + .btn.btn-active-icon-gray-800 i,
.btn-check:checked + .btn.btn-active-icon-gray-800 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-800 i,
.btn-check:active + .btn.btn-active-icon-gray-800 .svg-icon, .btn.btn-active-icon-gray-800:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-800:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-800:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800:active:not(.btn-active) i,
.btn.btn-active-icon-gray-800:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800.active i,
.btn.btn-active-icon-gray-800.active .svg-icon, .btn.btn-active-icon-gray-800.show i,
.btn.btn-active-icon-gray-800.show .svg-icon, .show > .btn.btn-active-icon-gray-800 i,
.show > .btn.btn-active-icon-gray-800 .svg-icon {
  color: var(--kt-text-gray-800);
}
.btn-check:checked + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn.btn-active-icon-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800.active.dropdown-toggle:after, .btn.btn-active-icon-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-800.dropdown-toggle:after {
  color: var(--kt-text-gray-800);
}

.btn.btn-text-gray-800 {
  color: var(--kt-text-gray-800);
}
.btn-check:checked + .btn.btn-active-text-gray-800, .btn-check:active + .btn.btn-active-text-gray-800, .btn.btn-active-text-gray-800:focus:not(.btn-active), .btn.btn-active-text-gray-800:hover:not(.btn-active), .btn.btn-active-text-gray-800:active:not(.btn-active), .btn.btn-active-text-gray-800.active, .btn.btn-active-text-gray-800.show, .show > .btn.btn-active-text-gray-800 {
  color: var(--kt-text-gray-800);
}

.btn.btn-color-gray-900 {
  color: var(--kt-text-gray-900);
}
.btn.btn-color-gray-900 i,
.btn.btn-color-gray-900 .svg-icon {
  color: var(--kt-text-gray-900);
}
.btn.btn-color-gray-900.dropdown-toggle:after {
  color: var(--kt-text-gray-900);
}
.btn-check:checked + .btn.btn-active-color-gray-900, .btn-check:active + .btn.btn-active-color-gray-900, .btn.btn-active-color-gray-900:focus:not(.btn-active), .btn.btn-active-color-gray-900:hover:not(.btn-active), .btn.btn-active-color-gray-900:active:not(.btn-active), .btn.btn-active-color-gray-900.active, .btn.btn-active-color-gray-900.show, .show > .btn.btn-active-color-gray-900 {
  color: var(--kt-text-gray-900);
}
.btn-check:checked + .btn.btn-active-color-gray-900 i,
.btn-check:checked + .btn.btn-active-color-gray-900 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-900 i,
.btn-check:active + .btn.btn-active-color-gray-900 .svg-icon, .btn.btn-active-color-gray-900:focus:not(.btn-active) i,
.btn.btn-active-color-gray-900:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900:hover:not(.btn-active) i,
.btn.btn-active-color-gray-900:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900:active:not(.btn-active) i,
.btn.btn-active-color-gray-900:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900.active i,
.btn.btn-active-color-gray-900.active .svg-icon, .btn.btn-active-color-gray-900.show i,
.btn.btn-active-color-gray-900.show .svg-icon, .show > .btn.btn-active-color-gray-900 i,
.show > .btn.btn-active-color-gray-900 .svg-icon {
  color: var(--kt-text-gray-900);
}
.btn-check:checked + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn.btn-active-color-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900.active.dropdown-toggle:after, .btn.btn-active-color-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-900.dropdown-toggle:after {
  color: var(--kt-text-gray-900);
}

.btn.btn-icon-gray-900 i,
.btn.btn-icon-gray-900 .svg-icon {
  color: var(--kt-text-gray-900);
}
.btn.btn-icon-gray-900.dropdown-toggle:after {
  color: var(--kt-text-gray-900);
}
.btn-check:checked + .btn.btn-active-icon-gray-900 i,
.btn-check:checked + .btn.btn-active-icon-gray-900 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-900 i,
.btn-check:active + .btn.btn-active-icon-gray-900 .svg-icon, .btn.btn-active-icon-gray-900:focus:not(.btn-active) i,
.btn.btn-active-icon-gray-900:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900:hover:not(.btn-active) i,
.btn.btn-active-icon-gray-900:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900:active:not(.btn-active) i,
.btn.btn-active-icon-gray-900:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900.active i,
.btn.btn-active-icon-gray-900.active .svg-icon, .btn.btn-active-icon-gray-900.show i,
.btn.btn-active-icon-gray-900.show .svg-icon, .show > .btn.btn-active-icon-gray-900 i,
.show > .btn.btn-active-icon-gray-900 .svg-icon {
  color: var(--kt-text-gray-900);
}
.btn-check:checked + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn.btn-active-icon-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900.active.dropdown-toggle:after, .btn.btn-active-icon-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-900.dropdown-toggle:after {
  color: var(--kt-text-gray-900);
}

.btn.btn-text-gray-900 {
  color: var(--kt-text-gray-900);
}
.btn-check:checked + .btn.btn-active-text-gray-900, .btn-check:active + .btn.btn-active-text-gray-900, .btn.btn-active-text-gray-900:focus:not(.btn-active), .btn.btn-active-text-gray-900:hover:not(.btn-active), .btn.btn-active-text-gray-900:active:not(.btn-active), .btn.btn-active-text-gray-900.active, .btn.btn-active-text-gray-900.show, .show > .btn.btn-active-text-gray-900 {
  color: var(--kt-text-gray-900);
}

.btn.btn-facebook {
  color: #ffffff;
  border-color: #3b5998;
  background-color: #3b5998;
}
.btn.btn-facebook i,
.btn.btn-facebook .svg-icon {
  color: #ffffff;
}
.btn.btn-facebook.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-facebook, .btn-check:active + .btn.btn-facebook, .btn.btn-facebook:focus:not(.btn-active), .btn.btn-facebook:hover:not(.btn-active), .btn.btn-facebook:active:not(.btn-active), .btn.btn-facebook.active, .btn.btn-facebook.show, .show > .btn.btn-facebook {
  border-color: #30497c;
  background-color: #30497c !important;
}

.btn.btn-light-facebook {
  color: #3b5998;
  border-color: rgba(59, 89, 152, 0.1);
  background-color: rgba(59, 89, 152, 0.1);
}
.btn.btn-light-facebook i,
.btn.btn-light-facebook .svg-icon {
  color: #3b5998;
}
.btn.btn-light-facebook.dropdown-toggle:after {
  color: #3b5998;
}
.btn-check:checked + .btn.btn-light-facebook, .btn-check:active + .btn.btn-light-facebook, .btn.btn-light-facebook:focus:not(.btn-active), .btn.btn-light-facebook:hover:not(.btn-active), .btn.btn-light-facebook:active:not(.btn-active), .btn.btn-light-facebook.active, .btn.btn-light-facebook.show, .show > .btn.btn-light-facebook {
  color: #ffffff;
  border-color: #3b5998;
  background-color: #3b5998 !important;
}
.btn-check:checked + .btn.btn-light-facebook i,
.btn-check:checked + .btn.btn-light-facebook .svg-icon, .btn-check:active + .btn.btn-light-facebook i,
.btn-check:active + .btn.btn-light-facebook .svg-icon, .btn.btn-light-facebook:focus:not(.btn-active) i,
.btn.btn-light-facebook:focus:not(.btn-active) .svg-icon, .btn.btn-light-facebook:hover:not(.btn-active) i,
.btn.btn-light-facebook:hover:not(.btn-active) .svg-icon, .btn.btn-light-facebook:active:not(.btn-active) i,
.btn.btn-light-facebook:active:not(.btn-active) .svg-icon, .btn.btn-light-facebook.active i,
.btn.btn-light-facebook.active .svg-icon, .btn.btn-light-facebook.show i,
.btn.btn-light-facebook.show .svg-icon, .show > .btn.btn-light-facebook i,
.show > .btn.btn-light-facebook .svg-icon {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-facebook.dropdown-toggle:after, .btn-check:active + .btn.btn-light-facebook.dropdown-toggle:after, .btn.btn-light-facebook:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook.active.dropdown-toggle:after, .btn.btn-light-facebook.show.dropdown-toggle:after, .show > .btn.btn-light-facebook.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-google {
  color: #ffffff;
  border-color: #dd4b39;
  background-color: #dd4b39;
}
.btn.btn-google i,
.btn.btn-google .svg-icon {
  color: #ffffff;
}
.btn.btn-google.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-google, .btn-check:active + .btn.btn-google, .btn.btn-google:focus:not(.btn-active), .btn.btn-google:hover:not(.btn-active), .btn.btn-google:active:not(.btn-active), .btn.btn-google.active, .btn.btn-google.show, .show > .btn.btn-google {
  border-color: #cd3623;
  background-color: #cd3623 !important;
}

.btn.btn-light-google {
  color: #dd4b39;
  border-color: rgba(221, 75, 57, 0.1);
  background-color: rgba(221, 75, 57, 0.1);
}
.btn.btn-light-google i,
.btn.btn-light-google .svg-icon {
  color: #dd4b39;
}
.btn.btn-light-google.dropdown-toggle:after {
  color: #dd4b39;
}
.btn-check:checked + .btn.btn-light-google, .btn-check:active + .btn.btn-light-google, .btn.btn-light-google:focus:not(.btn-active), .btn.btn-light-google:hover:not(.btn-active), .btn.btn-light-google:active:not(.btn-active), .btn.btn-light-google.active, .btn.btn-light-google.show, .show > .btn.btn-light-google {
  color: #ffffff;
  border-color: #dd4b39;
  background-color: #dd4b39 !important;
}
.btn-check:checked + .btn.btn-light-google i,
.btn-check:checked + .btn.btn-light-google .svg-icon, .btn-check:active + .btn.btn-light-google i,
.btn-check:active + .btn.btn-light-google .svg-icon, .btn.btn-light-google:focus:not(.btn-active) i,
.btn.btn-light-google:focus:not(.btn-active) .svg-icon, .btn.btn-light-google:hover:not(.btn-active) i,
.btn.btn-light-google:hover:not(.btn-active) .svg-icon, .btn.btn-light-google:active:not(.btn-active) i,
.btn.btn-light-google:active:not(.btn-active) .svg-icon, .btn.btn-light-google.active i,
.btn.btn-light-google.active .svg-icon, .btn.btn-light-google.show i,
.btn.btn-light-google.show .svg-icon, .show > .btn.btn-light-google i,
.show > .btn.btn-light-google .svg-icon {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-google.dropdown-toggle:after, .btn-check:active + .btn.btn-light-google.dropdown-toggle:after, .btn.btn-light-google:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google.active.dropdown-toggle:after, .btn.btn-light-google.show.dropdown-toggle:after, .show > .btn.btn-light-google.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-twitter {
  color: #ffffff;
  border-color: #1da1f2;
  background-color: #1da1f2;
}
.btn.btn-twitter i,
.btn.btn-twitter .svg-icon {
  color: #ffffff;
}
.btn.btn-twitter.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-twitter, .btn-check:active + .btn.btn-twitter, .btn.btn-twitter:focus:not(.btn-active), .btn.btn-twitter:hover:not(.btn-active), .btn.btn-twitter:active:not(.btn-active), .btn.btn-twitter.active, .btn.btn-twitter.show, .show > .btn.btn-twitter {
  border-color: #0d8ddc;
  background-color: #0d8ddc !important;
}

.btn.btn-light-twitter {
  color: #1da1f2;
  border-color: rgba(29, 161, 242, 0.1);
  background-color: rgba(29, 161, 242, 0.1);
}
.btn.btn-light-twitter i,
.btn.btn-light-twitter .svg-icon {
  color: #1da1f2;
}
.btn.btn-light-twitter.dropdown-toggle:after {
  color: #1da1f2;
}
.btn-check:checked + .btn.btn-light-twitter, .btn-check:active + .btn.btn-light-twitter, .btn.btn-light-twitter:focus:not(.btn-active), .btn.btn-light-twitter:hover:not(.btn-active), .btn.btn-light-twitter:active:not(.btn-active), .btn.btn-light-twitter.active, .btn.btn-light-twitter.show, .show > .btn.btn-light-twitter {
  color: #ffffff;
  border-color: #1da1f2;
  background-color: #1da1f2 !important;
}
.btn-check:checked + .btn.btn-light-twitter i,
.btn-check:checked + .btn.btn-light-twitter .svg-icon, .btn-check:active + .btn.btn-light-twitter i,
.btn-check:active + .btn.btn-light-twitter .svg-icon, .btn.btn-light-twitter:focus:not(.btn-active) i,
.btn.btn-light-twitter:focus:not(.btn-active) .svg-icon, .btn.btn-light-twitter:hover:not(.btn-active) i,
.btn.btn-light-twitter:hover:not(.btn-active) .svg-icon, .btn.btn-light-twitter:active:not(.btn-active) i,
.btn.btn-light-twitter:active:not(.btn-active) .svg-icon, .btn.btn-light-twitter.active i,
.btn.btn-light-twitter.active .svg-icon, .btn.btn-light-twitter.show i,
.btn.btn-light-twitter.show .svg-icon, .show > .btn.btn-light-twitter i,
.show > .btn.btn-light-twitter .svg-icon {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-twitter.dropdown-toggle:after, .btn-check:active + .btn.btn-light-twitter.dropdown-toggle:after, .btn.btn-light-twitter:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter.active.dropdown-toggle:after, .btn.btn-light-twitter.show.dropdown-toggle:after, .show > .btn.btn-light-twitter.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-instagram {
  color: #ffffff;
  border-color: #e1306c;
  background-color: #e1306c;
}
.btn.btn-instagram i,
.btn.btn-instagram .svg-icon {
  color: #ffffff;
}
.btn.btn-instagram.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-instagram, .btn-check:active + .btn.btn-instagram, .btn.btn-instagram:focus:not(.btn-active), .btn.btn-instagram:hover:not(.btn-active), .btn.btn-instagram:active:not(.btn-active), .btn.btn-instagram.active, .btn.btn-instagram.show, .show > .btn.btn-instagram {
  border-color: #cd1e59;
  background-color: #cd1e59 !important;
}

.btn.btn-light-instagram {
  color: #e1306c;
  border-color: rgba(225, 48, 108, 0.1);
  background-color: rgba(225, 48, 108, 0.1);
}
.btn.btn-light-instagram i,
.btn.btn-light-instagram .svg-icon {
  color: #e1306c;
}
.btn.btn-light-instagram.dropdown-toggle:after {
  color: #e1306c;
}
.btn-check:checked + .btn.btn-light-instagram, .btn-check:active + .btn.btn-light-instagram, .btn.btn-light-instagram:focus:not(.btn-active), .btn.btn-light-instagram:hover:not(.btn-active), .btn.btn-light-instagram:active:not(.btn-active), .btn.btn-light-instagram.active, .btn.btn-light-instagram.show, .show > .btn.btn-light-instagram {
  color: #ffffff;
  border-color: #e1306c;
  background-color: #e1306c !important;
}
.btn-check:checked + .btn.btn-light-instagram i,
.btn-check:checked + .btn.btn-light-instagram .svg-icon, .btn-check:active + .btn.btn-light-instagram i,
.btn-check:active + .btn.btn-light-instagram .svg-icon, .btn.btn-light-instagram:focus:not(.btn-active) i,
.btn.btn-light-instagram:focus:not(.btn-active) .svg-icon, .btn.btn-light-instagram:hover:not(.btn-active) i,
.btn.btn-light-instagram:hover:not(.btn-active) .svg-icon, .btn.btn-light-instagram:active:not(.btn-active) i,
.btn.btn-light-instagram:active:not(.btn-active) .svg-icon, .btn.btn-light-instagram.active i,
.btn.btn-light-instagram.active .svg-icon, .btn.btn-light-instagram.show i,
.btn.btn-light-instagram.show .svg-icon, .show > .btn.btn-light-instagram i,
.show > .btn.btn-light-instagram .svg-icon {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-instagram.dropdown-toggle:after, .btn-check:active + .btn.btn-light-instagram.dropdown-toggle:after, .btn.btn-light-instagram:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram.active.dropdown-toggle:after, .btn.btn-light-instagram.show.dropdown-toggle:after, .show > .btn.btn-light-instagram.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-youtube {
  color: #ffffff;
  border-color: #ff0000;
  background-color: #ff0000;
}
.btn.btn-youtube i,
.btn.btn-youtube .svg-icon {
  color: #ffffff;
}
.btn.btn-youtube.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-youtube, .btn-check:active + .btn.btn-youtube, .btn.btn-youtube:focus:not(.btn-active), .btn.btn-youtube:hover:not(.btn-active), .btn.btn-youtube:active:not(.btn-active), .btn.btn-youtube.active, .btn.btn-youtube.show, .show > .btn.btn-youtube {
  border-color: #d90000;
  background-color: #d90000 !important;
}

.btn.btn-light-youtube {
  color: #ff0000;
  border-color: rgba(255, 0, 0, 0.1);
  background-color: rgba(255, 0, 0, 0.1);
}
.btn.btn-light-youtube i,
.btn.btn-light-youtube .svg-icon {
  color: #ff0000;
}
.btn.btn-light-youtube.dropdown-toggle:after {
  color: #ff0000;
}
.btn-check:checked + .btn.btn-light-youtube, .btn-check:active + .btn.btn-light-youtube, .btn.btn-light-youtube:focus:not(.btn-active), .btn.btn-light-youtube:hover:not(.btn-active), .btn.btn-light-youtube:active:not(.btn-active), .btn.btn-light-youtube.active, .btn.btn-light-youtube.show, .show > .btn.btn-light-youtube {
  color: #ffffff;
  border-color: #ff0000;
  background-color: #ff0000 !important;
}
.btn-check:checked + .btn.btn-light-youtube i,
.btn-check:checked + .btn.btn-light-youtube .svg-icon, .btn-check:active + .btn.btn-light-youtube i,
.btn-check:active + .btn.btn-light-youtube .svg-icon, .btn.btn-light-youtube:focus:not(.btn-active) i,
.btn.btn-light-youtube:focus:not(.btn-active) .svg-icon, .btn.btn-light-youtube:hover:not(.btn-active) i,
.btn.btn-light-youtube:hover:not(.btn-active) .svg-icon, .btn.btn-light-youtube:active:not(.btn-active) i,
.btn.btn-light-youtube:active:not(.btn-active) .svg-icon, .btn.btn-light-youtube.active i,
.btn.btn-light-youtube.active .svg-icon, .btn.btn-light-youtube.show i,
.btn.btn-light-youtube.show .svg-icon, .show > .btn.btn-light-youtube i,
.show > .btn.btn-light-youtube .svg-icon {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-youtube.dropdown-toggle:after, .btn-check:active + .btn.btn-light-youtube.dropdown-toggle:after, .btn.btn-light-youtube:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube.active.dropdown-toggle:after, .btn.btn-light-youtube.show.dropdown-toggle:after, .show > .btn.btn-light-youtube.dropdown-toggle:after {
  color: #ffffff;
}

.btn.btn-linkedin {
  color: #ffffff;
  border-color: #0077b5;
  background-color: #0077b5;
}
.btn.btn-linkedin i,
.btn.btn-linkedin .svg-icon {
  color: #ffffff;
}
.btn.btn-linkedin.dropdown-toggle:after {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-linkedin, .btn-check:active + .btn.btn-linkedin, .btn.btn-linkedin:focus:not(.btn-active), .btn.btn-linkedin:hover:not(.btn-active), .btn.btn-linkedin:active:not(.btn-active), .btn.btn-linkedin.active, .btn.btn-linkedin.show, .show > .btn.btn-linkedin {
  border-color: #005e8f;
  background-color: #005e8f !important;
}

.btn.btn-light-linkedin {
  color: #0077b5;
  border-color: rgba(0, 119, 181, 0.1);
  background-color: rgba(0, 119, 181, 0.1);
}
.btn.btn-light-linkedin i,
.btn.btn-light-linkedin .svg-icon {
  color: #0077b5;
}
.btn.btn-light-linkedin.dropdown-toggle:after {
  color: #0077b5;
}
.btn-check:checked + .btn.btn-light-linkedin, .btn-check:active + .btn.btn-light-linkedin, .btn.btn-light-linkedin:focus:not(.btn-active), .btn.btn-light-linkedin:hover:not(.btn-active), .btn.btn-light-linkedin:active:not(.btn-active), .btn.btn-light-linkedin.active, .btn.btn-light-linkedin.show, .show > .btn.btn-light-linkedin {
  color: #ffffff;
  border-color: #0077b5;
  background-color: #0077b5 !important;
}
.btn-check:checked + .btn.btn-light-linkedin i,
.btn-check:checked + .btn.btn-light-linkedin .svg-icon, .btn-check:active + .btn.btn-light-linkedin i,
.btn-check:active + .btn.btn-light-linkedin .svg-icon, .btn.btn-light-linkedin:focus:not(.btn-active) i,
.btn.btn-light-linkedin:focus:not(.btn-active) .svg-icon, .btn.btn-light-linkedin:hover:not(.btn-active) i,
.btn.btn-light-linkedin:hover:not(.btn-active) .svg-icon, .btn.btn-light-linkedin:active:not(.btn-active) i,
.btn.btn-light-linkedin:active:not(.btn-active) .svg-icon, .btn.btn-light-linkedin.active i,
.btn.btn-light-linkedin.active .svg-icon, .btn.btn-light-linkedin.show i,
.btn.btn-light-linkedin.show .svg-icon, .show > .btn.btn-light-linkedin i,
.show > .btn.btn-light-linkedin .svg-icon {
  color: #ffffff;
}
.btn-check:checked + .btn.btn-light-linkedin.dropdown-toggle:after, .btn-check:active + .btn.btn-light-linkedin.dropdown-toggle:after, .btn.btn-light-linkedin:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin.active.dropdown-toggle:after, .btn.btn-light-linkedin.show.dropdown-toggle:after, .show > .btn.btn-light-linkedin.dropdown-toggle:after {
  color: #ffffff;
}

code:not([class*=language-]) {
  font-weight: 400;
  color: var(--kt-code-color);
  line-height: inherit;
  font-size: inherit;
  background-color: var(--kt-code-bg);
  padding: 0.1rem 0.4rem;
  margin: 0 0.5rem;
  box-shadow: var(--kt-code-box-shadow);
  border-radius: 0.3rem;
}

.form-label {
  color: var(--kt-form-label-color);
}

.col-form-label {
  color: var(--kt-form-label-color);
}

.form-text {
  color: var(--kt-form-text-color);
}

.form-control {
  color: var(--kt-input-color);
  background-color: var(--kt-input-bg);
  border: 1px solid var(--kt-input-border-color);
  box-shadow: none !important;
}
.form-control:focus {
  color: var(--kt-input-focus-color);
  background-color: var(--kt-input-focus-bg);
  border-color: var(--kt-input-focus-border-color);
}
.form-control::placeholder {
  color: var(--kt-input-placeholder-color);
}
.form-control:disabled, .form-control[readonly] {
  color: var(--kt-input-disabled-color);
  background-color: var(--kt-input-disabled-bg);
  border-color: var(--kt-input-disabled-border-color);
}
.form-control::file-selector-button {
  color: var(--kt-form-file-button-color);
  background-color: var(--kt-form-file-button-bg);
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--kt-form-file-button-hover-bg);
}

.form-control-plaintext {
  color: var(--kt-input-plaintext-color);
}

.form-select {
  color: var(--kt-form-select-color);
  background-color: var(--kt-form-select-bg);
  background-image: var(--kt-form-select-indicator);
  border: 1px solid var(--kt-form-select-border-color);
  box-shadow: var(--kt-form-select-box-shadow);
  appearance: none;
}
.form-select:focus {
  border-color: var(--kt-form-select-focus-border-color);
  box-shadow: var(--kt-form-select-box-shadow), var(--kt-form-select-focus-box-shadow);
}
.form-select:disabled {
  color: var(--kt-form-select-disabled-color);
  background-color: var(--kt-form-select-disabled-bg);
  border-color: var(--kt-form-select-disabled-border-color);
}
.form-select:-moz-focusring {
  text-shadow: 0 0 0 var(--kt-form-select-color);
}

.form-check-input {
  background-color: var(--kt-form-check-input-bg);
  border: var(--kt-form-check-input-border);
}
.form-check-input:active {
  filter: var(--kt-form-check-input-active-filter);
}
.form-check-input:focus {
  border-color: var(--kt-form-check-input-focus-border);
  box-shadow: var(--kt-form-check-input-focus-box-shadow);
}
.form-check-input:checked {
  background-color: var(--kt-form-check-input-checked-bg-color);
  border-color: var(--kt-form-check-input-checked-border-color);
}
.form-check-input:checked[type=checkbox] {
  background-image: var(--kt-form-check-input-checked-bg-image);
}
.form-check-input:checked[type=radio] {
  background-image: var(--kt-form-check-radio-checked-bg-image);
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: var(--kt-form-check-input-indeterminate-bg-color);
  border-color: var(--kt-form-check-input-indeterminate-border-color);
  background-image: var(--kt-form-check-input-indeterminate-bg-image);
}
.form-check-input:disabled {
  opacity: var(--kt-form-check-input-disabled-opacity);
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  opacity: var(--kt-form-check-label-disabled-opacity);
}

.form-check-label {
  color: var(--kt-form-check-label-color);
}

.form-check-input:checked + span, .form-check-input:checked + label {
  color: var(--kt-form-check-label-color-checked);
}

.form-switch .form-check-input {
  background-image: var(--kt-form-switch-bg-image);
}
.form-switch .form-check-input:focus {
  background-image: var(--kt-form-switch-focus-bg-image);
}
.form-switch .form-check-input:checked {
  background-image: var(--kt-form-switch-checked-bg-image);
}

.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  opacity: var(--kt-form-check-btn-check-disabled-opacity);
}

.form-floating .form-control.form-control-solid::placeholder {
  color: transparent;
}

.input-group-text {
  color: var(--kt-input-group-addon-color);
  background-color: var(--kt-input-group-addon-bg);
  border: 1px solid var(--kt-input-group-addon-border-color);
}

.dropdown.show > .form-control {
  color: var(--kt-input-focus-color);
  background-color: var(--kt-input-focus-bg);
  border-color: var(--kt-input-focus-border-color);
}
.form-control[readonly] {
  background-color: var(--kt-input-readonly-bg);
}
.form-control.form-control-solid {
  background-color: var(--kt-input-solid-bg);
  border-color: var(--kt-input-solid-bg);
  color: var(--kt-input-solid-color);
  transition: color 0.2s ease;
}
.form-control.form-control-solid::placeholder {
  color: var(--kt-input-solid-placeholder-color);
}
.form-control.form-control-solid::-moz-placeholder {
  color: var(--kt-input-solid-placeholder-color);
  opacity: 1;
}
.dropdown.show > .form-control.form-control-solid, .form-control.form-control-solid:active, .form-control.form-control-solid.active, .form-control.form-control-solid:focus, .form-control.form-control-solid.focus {
  background-color: var(--kt-input-solid-bg-focus);
  border-color: var(--kt-input-solid-bg-focus);
  color: var(--kt-input-solid-color);
  transition: color 0.2s ease;
}
.form-control.form-control-transparent {
  background-color: transparent;
  border-color: transparent;
}
.dropdown.show > .form-control.form-control-transparent, .form-control.form-control-transparent:active, .form-control.form-control-transparent.active, .form-control.form-control-transparent:focus, .form-control.form-control-transparent.focus {
  background-color: transparent;
  border-color: transparent;
}
.form-control.form-control-flush {
  border: 0;
  background-color: transparent;
  outline: none !important;
  box-shadow: none;
  border-radius: 0;
}

.placeholder-gray-500::placeholder {
  color: var(--kt-gray-500);
}

.placeholder-white::placeholder {
  color: #ffffff;
}
.placeholder-white::-moz-placeholder {
  color: #ffffff;
  opacity: 1;
}

.resize-none {
  resize: none;
}

.form-control-solid-bg {
  background-color: var(--kt-input-solid-bg);
}

.form-select {
  box-shadow: none !important;
}
.form-select.form-select-solid {
  background-color: var(--kt-input-solid-bg);
  border-color: var(--kt-input-solid-bg);
  color: var(--kt-input-solid-color);
  transition: color 0.2s ease;
}
.form-select.form-select-solid::placeholder {
  color: var(--kt-input-solid-placeholder-color);
}
.form-select.form-select-solid::-moz-placeholder {
  color: var(--kt-input-solid-placeholder-color);
  opacity: 1;
}
.dropdown.show > .form-select.form-select-solid, .form-select.form-select-solid:active, .form-select.form-select-solid.active, .form-select.form-select-solid:focus, .form-select.form-select-solid.focus {
  background-color: var(--kt-input-solid-bg-focus);
  border-color: var(--kt-input-solid-bg-focus) !important;
  color: var(--kt-input-solid-color);
  transition: color 0.2s ease;
}
.form-select.form-select-transparent {
  background-color: transparent;
  border-color: transparent;
  color: #5E6278;
}
.form-select.form-select-transparent::placeholder {
  color: var(--kt-input-placeholder-color);
}
.form-select.form-select-transparent::-moz-placeholder {
  color: var(--kt-input-placeholder-color);
  opacity: 1;
}
.dropdown.show > .form-select.form-select-transparent, .form-select.form-select-transparent:active, .form-select.form-select-transparent.active, .form-select.form-select-transparent:focus, .form-select.form-select-transparent.focus {
  background-color: transparent;
  border-color: transparent !important;
  color: #5E6278;
}

.form-check:not(.form-switch) .form-check-input[type=checkbox] {
  background-size: 60% 60%;
}

.form-check-custom {
  display: flex;
  align-items: center;
  padding-left: 0;
  margin: 0;
}
.form-check-custom .form-check-input {
  margin: 0;
  float: none;
  flex-shrink: 0;
}
.form-check-custom .form-check-label {
  margin-left: 0.55rem;
}
.form-check-custom.form-check-sm .form-check-input {
  height: 1.55rem;
  width: 1.55rem;
}
.form-check-custom.form-check-lg .form-check-input {
  height: 2.25rem;
  width: 2.25rem;
}
.form-check-custom.form-check-solid .form-check-input {
  border: 0;
  background-color: var(--kt-form-check-input-bg-solid);
}
.form-check-custom.form-check-solid .form-check-input:active, .form-check-custom.form-check-solid .form-check-input:focus {
  filter: none;
  background-color: var(--kt-form-check-input-bg-solid);
}
.form-check-custom.form-check-solid .form-check-input:checked {
  background-color: var(--kt-form-check-input-checked-bg-color-solid);
}
.form-check-custom.form-check-success .form-check-input:checked {
  background-color: var(--kt-success);
}
.form-check-custom.form-check-danger .form-check-input:checked {
  background-color: var(--kt-danger);
}
.form-check-custom.form-check-warning .form-check-input:checked {
  background-color: var(--kt-warning);
}

.form-switch.form-check-solid .form-check-input {
  height: 2.25rem;
  background-image: var(--kt-form-switch-bg-image-solid);
  border-radius: 3.25rem;
}
.form-switch.form-check-solid .form-check-input:checked {
  filter: none;
  background-image: var(--kt-form-switch-checked-bg-image);
}
.form-switch.form-check-solid.form-switch-sm .form-check-input {
  height: 1.5rem;
  width: 2.5rem;
}
.form-switch.form-check-solid.form-switch-lg .form-check-input {
  height: 2.75rem;
  width: 3.75rem;
}

.form-check-clip {
  position: relative;
  overflow: hidden;
}
.form-check-clip .form-check-label {
  padding-top: 0.5rem;
  font-size: 1.05rem;
  color: var(--kt-form-label-color);
  font-weight: 500;
}
.form-check-clip .form-check-wrapper {
  border-radius: 0.625rem;
  border: 2px solid transparent;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  overflow: hidden;
}
.form-check-clip .form-check-indicator {
  transition: all 0.2s ease-in-out;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  width: 1.75rem;
  height: 1.75rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  background-size: 50%;
  background-image: var(--kt-form-check-input-checked-bg-image);
  background-color: var(--kt-component-checked-bg);
  border-bottom-left-radius: 0.625rem;
  border-top-right-radius: 0.625rem;
}
.form-check-clip .form-check-indicator.form-check-indicator-sm {
  width: 1.55rem;
  height: 1.55rem;
}
.form-check-clip .form-check-indicator.form-check-indicator-lg {
  width: 2.25rem;
  height: 2.25rem;
}
.form-check-clip .form-check-content {
  width: 100%;
}
.form-check-clip .btn-check:checked + div {
  border: 2px solid var(--kt-component-checked-bg);
  transition: all 0.2s ease-in-out;
}
.form-check-clip .btn-check:checked + div .form-check-indicator {
  transition: all 0.2s ease-in-out;
  opacity: 1;
}
.form-check-clip .btn-check:disabled + div {
  transition: all 0.2s ease-in-out;
  opacity: var(--kt-form-check-btn-check-disabled-opacity);
}

.form-check-image {
  position: relative;
  overflow: hidden;
}
.form-check-image img {
  max-width: 100%;
}
.form-check-image .form-check-wrapper {
  border-radius: 0.625rem;
  border: 2px solid transparent;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  overflow: hidden;
  margin-bottom: 0.75rem;
}
.form-check-image .form-check-rounded {
  border-radius: 0.625rem;
}
.form-check-image .form-check-label {
  font-weight: 600;
  margin-left: 0.5rem;
}
.form-check-image.active .form-check-wrapper {
  border-color: var(--kt-primary);
}
.form-check-image.form-check-success.active .form-check-wrapper {
  border-color: var(--kt-success);
}
.form-check-image.form-check-danger.active .form-check-wrapper {
  border-color: var(--kt-danger);
}
.form-check-image.disabled {
  opacity: var(--kt-form-check-btn-check-disabled-opacity);
}

.input-group.input-group-solid {
  border-radius: 0.475rem;
}
.input-group.input-group-solid.input-group-sm {
  border-radius: 0.425rem;
}
.input-group.input-group-solid.input-group-lg {
  border-radius: 0.625rem;
}
.input-group.input-group-solid .input-group-text {
  background-color: var(--kt-input-solid-bg);
  border-color: var(--kt-input-solid-bg);
}
.input-group.input-group-solid .input-group-text + .form-control {
  border-left-color: var(--kt-input-border-color);
}
.input-group.input-group-solid .form-control {
  background-color: var(--kt-input-solid-bg);
  border-color: var(--kt-input-solid-bg);
}
.input-group.input-group-solid .form-control + .input-group-text {
  border-left-color: var(--kt-input-border-color);
}

.form-floating .form-control.form-control-solid::placeholder {
  color: transparent;
}

.required:after {
  content: "*";
  position: relative;
  font-size: inherit;
  color: var(--kt-danger);
  padding-left: 0.25rem;
  font-weight: 600;
}

.modal {
  --bs-modal-color: var(--kt-modal-content-color);
  --bs-modal-bg: var(--kt-modal-content-bg);
  --bs-modal-border-color: var(--kt-modal-content-border-color);
  --bs-modal-box-shadow: var(--kt-modal-content-box-shadow-xs);
  --bs-modal-header-border-color: var(--kt-modal-header-border-color);
  --bs-modal-footer-bg: var(--kt-modal-footer-bg);
  --bs-modal-footer-border-color: var(--kt-modal-footer-border-color);
}

.modal-dialog {
  outline: none !important;
}

.modal-header {
  align-items: center;
  justify-content: space-between;
  border-top-left-radius: 0.475rem;
  border-top-right-radius: 0.475rem;
  border-bottom: 1px solid var(--kt-modal-header-border-color);
}
.modal-header h1, .modal-header .h1, .modal-header h2, .modal-header .h2, .modal-header h3, .modal-header .h3, .modal-header h4, .modal-header .h4, .modal-header h5, .modal-header .h5, .modal-header h6, .modal-header .h6 {
  margin-bottom: 0;
}

.modal-content {
  color: var(--kt-modal-color);
  background-color: var(--kt-modal-bg);
  border: 0 solid var(--kt-modal-border-color);
  box-shadow: var(--kt-modal-box-shadow);
}

.modal-footer {
  background-color: var(--kt-modal-footer-bg);
  border-top: 1px solid var(--bs-modal-footer-border-color);
}

.modal-backdrop {
  --bs-backdrop-bg: var(--kt-modal-backdrop-bg);
  --bs-backdrop-opacity: var(--kt-modal-backdrop-opacity);
}

@media (min-width: 576px) {
  .modal-content {
    box-shadow: var(--kt-modal-box-shadow-sm-up);
  }
}
.modal-rounded {
  border-radius: 0.475rem !important;
}

.progress {
  --bs-progress-bg: var(--kt-progress-bg);
  --bs-progress-box-shadow: var(--kt-progress-box-shadow);
  --bs-progress-bar-color: var(--kt-progress-bar-color);
  --bs-progress-bar-bg: var(--kt-progress-bar-bg);
}

.progress-vertical {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
}
.progress-vertical .progress {
  height: 100%;
  border-radius: 0.475rem;
  display: flex;
  align-items: flex-end;
  margin-right: 1rem;
}
.progress-vertical .progress:last-child {
  margin-right: 0;
}
.progress-vertical .progress .progress-bar {
  width: 8px;
  border-radius: 0.475rem;
}

.table {
  --bs-table-color: var(--kt-table-color);
  --bs-table-bg: var(--kt-table-bg);
  --bs-table-border-color: var(--kt-table-border-color);
  --bs-table-accent-bg: var(--kt-table-accent-bg);
  --bs-table-striped-color: var(--kt-table-striped-color);
  --bs-table-striped-bg: var(--kt-table-striped-bg);
  --bs-table-active-color: var(--kt-table-active-color);
  --bs-table-active-bg: var(--kt-table-active-bg);
  --bs-table-hover-color: var(--kt-table-hover-color);
  --bs-table-hover-bg: var(--kt-table-hover-bg);
}
.table > :not(:first-child) {
  border-color: transparent;
  border-width: 0;
  border-style: none;
}
.table > :not(:last-child) > :last-child > * {
  border-bottom-color: inherit;
}
.table tr, .table th, .table td {
  border-color: inherit;
  border-width: inherit;
  border-style: inherit;
  text-transform: inherit;
  font-weight: inherit;
  font-size: inherit;
  color: inherit;
  height: inherit;
  min-height: inherit;
}
.table tr:first-child, .table th:first-child, .table td:first-child {
  padding-left: 0;
}
.table tr:last-child, .table th:last-child, .table td:last-child {
  padding-right: 0;
}
.table tfoot tr:last-child,
.table tbody tr:last-child {
  border-bottom: 0 !important;
}
.table tfoot tr:last-child th, .table tfoot tr:last-child td,
.table tbody tr:last-child th,
.table tbody tr:last-child td {
  border-bottom: 0 !important;
}
.table tfoot th, .table tfoot td {
  border-top: inherit;
}
.table.table-rounded {
  border-radius: 0.475rem;
  border-spacing: 0;
  border-collapse: separate;
}
.table.table-flush tr, .table.table-flush th, .table.table-flush td {
  padding: inherit;
}
.table.table-row-bordered tr {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: var(--kt-border-color);
}
.table.table-row-bordered tfoot th, .table.table-row-bordered tfoot td {
  border-top-width: 1px !important;
}
.table.table-row-dashed tr {
  border-bottom-width: 1px;
  border-bottom-style: dashed;
  border-bottom-color: var(--kt-border-color);
}
.table.table-row-dashed tfoot th, .table.table-row-dashed tfoot td {
  border-top-width: 1px !important;
}
.table.table-row-gray-100 tr {
  border-bottom-color: var(--kt-gray-100);
}
.table.table-row-gray-200 tr {
  border-bottom-color: var(--kt-gray-200);
}
.table.table-row-gray-300 tr {
  border-bottom-color: var(--kt-gray-300);
}
.table.table-row-gray-400 tr {
  border-bottom-color: var(--kt-gray-400);
}
.table.table-row-gray-500 tr {
  border-bottom-color: var(--kt-gray-500);
}
.table.table-row-gray-600 tr {
  border-bottom-color: var(--kt-gray-600);
}
.table.table-row-gray-700 tr {
  border-bottom-color: var(--kt-gray-700);
}
.table.table-row-gray-800 tr {
  border-bottom-color: var(--kt-gray-800);
}
.table.table-row-gray-900 tr {
  border-bottom-color: var(--kt-gray-900);
}

.table-layout-fixed {
  table-layout: fixed;
}

.table-sort:after {
  opacity: 0;
}

.table-sort,
.table-sort-asc,
.table-sort-desc {
  vertical-align: middle;
}
.table-sort:after,
.table-sort-asc:after,
.table-sort-desc:after {
  position: relative;
  display: inline-block;
  width: 0.75rem;
  height: 0.75rem;
  content: " ";
  bottom: auto;
  right: auto;
  left: auto;
  margin-left: 0.5rem;
}

.table-sort-asc:after {
  opacity: 1;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-muted);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_118___});
}

.table-sort-desc:after {
  opacity: 1;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-text-muted);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_119___});
}

.table-loading-message {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 0.475rem;
  box-shadow: var(--kt-table-loading-message-box-shadow);
  background-color: var(--kt-table-loading-message-bg);
  color: var(--kt-table-loading-message-color);
  font-weight: 600;
  margin: 0 !important;
  width: auto;
  padding: 0.85rem 2rem !important;
  transform: translateX(-50%) translateY(-50%);
}

.table-loading {
  position: relative;
}
.table-loading .table-loading-message {
  display: block;
}

.table.g-0 th, .table.g-0 td {
  padding: 0rem;
}
.table.g-0 th.dtr-control, .table.g-0 td.dtr-control {
  padding-left: 0rem !important;
}

.table.gy-0 th, .table.gy-0 td {
  padding-top: 0rem;
  padding-bottom: 0rem;
}

.table.gx-0 th, .table.gx-0 td {
  padding-left: 0rem;
  padding-right: 0rem;
}
.table.gx-0 th.dtr-control, .table.gx-0 td.dtr-control {
  padding-left: 0rem !important;
}

.table.gs-0 th:first-child, .table.gs-0 td:first-child {
  padding-left: 0rem;
}
.table.gs-0 th:last-child, .table.gs-0 td:last-child {
  padding-right: 0rem;
}
.table.gs-0 th.dtr-control:first-child, .table.gs-0 td.dtr-control:first-child {
  padding-left: 0rem !important;
}

.table.g-1 th, .table.g-1 td {
  padding: 0.25rem;
}
.table.g-1 th.dtr-control, .table.g-1 td.dtr-control {
  padding-left: 0.25rem !important;
}

.table.gy-1 th, .table.gy-1 td {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.table.gx-1 th, .table.gx-1 td {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.table.gx-1 th.dtr-control, .table.gx-1 td.dtr-control {
  padding-left: 0.25rem !important;
}

.table.gs-1 th:first-child, .table.gs-1 td:first-child {
  padding-left: 0.25rem;
}
.table.gs-1 th:last-child, .table.gs-1 td:last-child {
  padding-right: 0.25rem;
}
.table.gs-1 th.dtr-control:first-child, .table.gs-1 td.dtr-control:first-child {
  padding-left: 0.25rem !important;
}

.table.g-2 th, .table.g-2 td {
  padding: 0.5rem;
}
.table.g-2 th.dtr-control, .table.g-2 td.dtr-control {
  padding-left: 0.5rem !important;
}

.table.gy-2 th, .table.gy-2 td {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.table.gx-2 th, .table.gx-2 td {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.table.gx-2 th.dtr-control, .table.gx-2 td.dtr-control {
  padding-left: 0.5rem !important;
}

.table.gs-2 th:first-child, .table.gs-2 td:first-child {
  padding-left: 0.5rem;
}
.table.gs-2 th:last-child, .table.gs-2 td:last-child {
  padding-right: 0.5rem;
}
.table.gs-2 th.dtr-control:first-child, .table.gs-2 td.dtr-control:first-child {
  padding-left: 0.5rem !important;
}

.table.g-3 th, .table.g-3 td {
  padding: 0.75rem;
}
.table.g-3 th.dtr-control, .table.g-3 td.dtr-control {
  padding-left: 0.75rem !important;
}

.table.gy-3 th, .table.gy-3 td {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.table.gx-3 th, .table.gx-3 td {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.table.gx-3 th.dtr-control, .table.gx-3 td.dtr-control {
  padding-left: 0.75rem !important;
}

.table.gs-3 th:first-child, .table.gs-3 td:first-child {
  padding-left: 0.75rem;
}
.table.gs-3 th:last-child, .table.gs-3 td:last-child {
  padding-right: 0.75rem;
}
.table.gs-3 th.dtr-control:first-child, .table.gs-3 td.dtr-control:first-child {
  padding-left: 0.75rem !important;
}

.table.g-4 th, .table.g-4 td {
  padding: 1rem;
}
.table.g-4 th.dtr-control, .table.g-4 td.dtr-control {
  padding-left: 1rem !important;
}

.table.gy-4 th, .table.gy-4 td {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.table.gx-4 th, .table.gx-4 td {
  padding-left: 1rem;
  padding-right: 1rem;
}
.table.gx-4 th.dtr-control, .table.gx-4 td.dtr-control {
  padding-left: 1rem !important;
}

.table.gs-4 th:first-child, .table.gs-4 td:first-child {
  padding-left: 1rem;
}
.table.gs-4 th:last-child, .table.gs-4 td:last-child {
  padding-right: 1rem;
}
.table.gs-4 th.dtr-control:first-child, .table.gs-4 td.dtr-control:first-child {
  padding-left: 1rem !important;
}

.table.g-5 th, .table.g-5 td {
  padding: 1.25rem;
}
.table.g-5 th.dtr-control, .table.g-5 td.dtr-control {
  padding-left: 1.25rem !important;
}

.table.gy-5 th, .table.gy-5 td {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.table.gx-5 th, .table.gx-5 td {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.table.gx-5 th.dtr-control, .table.gx-5 td.dtr-control {
  padding-left: 1.25rem !important;
}

.table.gs-5 th:first-child, .table.gs-5 td:first-child {
  padding-left: 1.25rem;
}
.table.gs-5 th:last-child, .table.gs-5 td:last-child {
  padding-right: 1.25rem;
}
.table.gs-5 th.dtr-control:first-child, .table.gs-5 td.dtr-control:first-child {
  padding-left: 1.25rem !important;
}

.table.g-6 th, .table.g-6 td {
  padding: 1.5rem;
}
.table.g-6 th.dtr-control, .table.g-6 td.dtr-control {
  padding-left: 1.5rem !important;
}

.table.gy-6 th, .table.gy-6 td {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.table.gx-6 th, .table.gx-6 td {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.table.gx-6 th.dtr-control, .table.gx-6 td.dtr-control {
  padding-left: 1.5rem !important;
}

.table.gs-6 th:first-child, .table.gs-6 td:first-child {
  padding-left: 1.5rem;
}
.table.gs-6 th:last-child, .table.gs-6 td:last-child {
  padding-right: 1.5rem;
}
.table.gs-6 th.dtr-control:first-child, .table.gs-6 td.dtr-control:first-child {
  padding-left: 1.5rem !important;
}

.table.g-7 th, .table.g-7 td {
  padding: 1.75rem;
}
.table.g-7 th.dtr-control, .table.g-7 td.dtr-control {
  padding-left: 1.75rem !important;
}

.table.gy-7 th, .table.gy-7 td {
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}

.table.gx-7 th, .table.gx-7 td {
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}
.table.gx-7 th.dtr-control, .table.gx-7 td.dtr-control {
  padding-left: 1.75rem !important;
}

.table.gs-7 th:first-child, .table.gs-7 td:first-child {
  padding-left: 1.75rem;
}
.table.gs-7 th:last-child, .table.gs-7 td:last-child {
  padding-right: 1.75rem;
}
.table.gs-7 th.dtr-control:first-child, .table.gs-7 td.dtr-control:first-child {
  padding-left: 1.75rem !important;
}

.table.g-8 th, .table.g-8 td {
  padding: 2rem;
}
.table.g-8 th.dtr-control, .table.g-8 td.dtr-control {
  padding-left: 2rem !important;
}

.table.gy-8 th, .table.gy-8 td {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.table.gx-8 th, .table.gx-8 td {
  padding-left: 2rem;
  padding-right: 2rem;
}
.table.gx-8 th.dtr-control, .table.gx-8 td.dtr-control {
  padding-left: 2rem !important;
}

.table.gs-8 th:first-child, .table.gs-8 td:first-child {
  padding-left: 2rem;
}
.table.gs-8 th:last-child, .table.gs-8 td:last-child {
  padding-right: 2rem;
}
.table.gs-8 th.dtr-control:first-child, .table.gs-8 td.dtr-control:first-child {
  padding-left: 2rem !important;
}

.table.g-9 th, .table.g-9 td {
  padding: 2.25rem;
}
.table.g-9 th.dtr-control, .table.g-9 td.dtr-control {
  padding-left: 2.25rem !important;
}

.table.gy-9 th, .table.gy-9 td {
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}

.table.gx-9 th, .table.gx-9 td {
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}
.table.gx-9 th.dtr-control, .table.gx-9 td.dtr-control {
  padding-left: 2.25rem !important;
}

.table.gs-9 th:first-child, .table.gs-9 td:first-child {
  padding-left: 2.25rem;
}
.table.gs-9 th:last-child, .table.gs-9 td:last-child {
  padding-right: 2.25rem;
}
.table.gs-9 th.dtr-control:first-child, .table.gs-9 td.dtr-control:first-child {
  padding-left: 2.25rem !important;
}

.table.g-10 th, .table.g-10 td {
  padding: 2.5rem;
}
.table.g-10 th.dtr-control, .table.g-10 td.dtr-control {
  padding-left: 2.5rem !important;
}

.table.gy-10 th, .table.gy-10 td {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.table.gx-10 th, .table.gx-10 td {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.table.gx-10 th.dtr-control, .table.gx-10 td.dtr-control {
  padding-left: 2.5rem !important;
}

.table.gs-10 th:first-child, .table.gs-10 td:first-child {
  padding-left: 2.5rem;
}
.table.gs-10 th:last-child, .table.gs-10 td:last-child {
  padding-right: 2.5rem;
}
.table.gs-10 th.dtr-control:first-child, .table.gs-10 td.dtr-control:first-child {
  padding-left: 2.5rem !important;
}

@media (min-width: 576px) {
  .table.g-sm-0 th, .table.g-sm-0 td {
    padding: 0rem;
  }
  .table.g-sm-0 th.dtr-control, .table.g-sm-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gy-sm-0 th, .table.gy-sm-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }

  .table.gx-sm-0 th, .table.gx-sm-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-sm-0 th.dtr-control, .table.gx-sm-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gs-sm-0 th:first-child, .table.gs-sm-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-sm-0 th:last-child, .table.gs-sm-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-sm-0 th.dtr-control:first-child, .table.gs-sm-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }

  .table.g-sm-1 th, .table.g-sm-1 td {
    padding: 0.25rem;
  }
  .table.g-sm-1 th.dtr-control, .table.g-sm-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gy-sm-1 th, .table.gy-sm-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .table.gx-sm-1 th, .table.gx-sm-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-sm-1 th.dtr-control, .table.gx-sm-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gs-sm-1 th:first-child, .table.gs-sm-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-sm-1 th:last-child, .table.gs-sm-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-sm-1 th.dtr-control:first-child, .table.gs-sm-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }

  .table.g-sm-2 th, .table.g-sm-2 td {
    padding: 0.5rem;
  }
  .table.g-sm-2 th.dtr-control, .table.g-sm-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gy-sm-2 th, .table.gy-sm-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .table.gx-sm-2 th, .table.gx-sm-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-sm-2 th.dtr-control, .table.gx-sm-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gs-sm-2 th:first-child, .table.gs-sm-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-sm-2 th:last-child, .table.gs-sm-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-sm-2 th.dtr-control:first-child, .table.gs-sm-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }

  .table.g-sm-3 th, .table.g-sm-3 td {
    padding: 0.75rem;
  }
  .table.g-sm-3 th.dtr-control, .table.g-sm-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gy-sm-3 th, .table.gy-sm-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .table.gx-sm-3 th, .table.gx-sm-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-sm-3 th.dtr-control, .table.gx-sm-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gs-sm-3 th:first-child, .table.gs-sm-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-sm-3 th:last-child, .table.gs-sm-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-sm-3 th.dtr-control:first-child, .table.gs-sm-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }

  .table.g-sm-4 th, .table.g-sm-4 td {
    padding: 1rem;
  }
  .table.g-sm-4 th.dtr-control, .table.g-sm-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gy-sm-4 th, .table.gy-sm-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .table.gx-sm-4 th, .table.gx-sm-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-sm-4 th.dtr-control, .table.gx-sm-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gs-sm-4 th:first-child, .table.gs-sm-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-sm-4 th:last-child, .table.gs-sm-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-sm-4 th.dtr-control:first-child, .table.gs-sm-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }

  .table.g-sm-5 th, .table.g-sm-5 td {
    padding: 1.25rem;
  }
  .table.g-sm-5 th.dtr-control, .table.g-sm-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gy-sm-5 th, .table.gy-sm-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .table.gx-sm-5 th, .table.gx-sm-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-sm-5 th.dtr-control, .table.gx-sm-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gs-sm-5 th:first-child, .table.gs-sm-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-sm-5 th:last-child, .table.gs-sm-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-sm-5 th.dtr-control:first-child, .table.gs-sm-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }

  .table.g-sm-6 th, .table.g-sm-6 td {
    padding: 1.5rem;
  }
  .table.g-sm-6 th.dtr-control, .table.g-sm-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gy-sm-6 th, .table.gy-sm-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .table.gx-sm-6 th, .table.gx-sm-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-sm-6 th.dtr-control, .table.gx-sm-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gs-sm-6 th:first-child, .table.gs-sm-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-sm-6 th:last-child, .table.gs-sm-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-sm-6 th.dtr-control:first-child, .table.gs-sm-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }

  .table.g-sm-7 th, .table.g-sm-7 td {
    padding: 1.75rem;
  }
  .table.g-sm-7 th.dtr-control, .table.g-sm-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gy-sm-7 th, .table.gy-sm-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .table.gx-sm-7 th, .table.gx-sm-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-sm-7 th.dtr-control, .table.gx-sm-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gs-sm-7 th:first-child, .table.gs-sm-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-sm-7 th:last-child, .table.gs-sm-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-sm-7 th.dtr-control:first-child, .table.gs-sm-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }

  .table.g-sm-8 th, .table.g-sm-8 td {
    padding: 2rem;
  }
  .table.g-sm-8 th.dtr-control, .table.g-sm-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gy-sm-8 th, .table.gy-sm-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .table.gx-sm-8 th, .table.gx-sm-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-sm-8 th.dtr-control, .table.gx-sm-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gs-sm-8 th:first-child, .table.gs-sm-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-sm-8 th:last-child, .table.gs-sm-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-sm-8 th.dtr-control:first-child, .table.gs-sm-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }

  .table.g-sm-9 th, .table.g-sm-9 td {
    padding: 2.25rem;
  }
  .table.g-sm-9 th.dtr-control, .table.g-sm-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gy-sm-9 th, .table.gy-sm-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .table.gx-sm-9 th, .table.gx-sm-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-sm-9 th.dtr-control, .table.gx-sm-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gs-sm-9 th:first-child, .table.gs-sm-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-sm-9 th:last-child, .table.gs-sm-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-sm-9 th.dtr-control:first-child, .table.gs-sm-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }

  .table.g-sm-10 th, .table.g-sm-10 td {
    padding: 2.5rem;
  }
  .table.g-sm-10 th.dtr-control, .table.g-sm-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gy-sm-10 th, .table.gy-sm-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .table.gx-sm-10 th, .table.gx-sm-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-sm-10 th.dtr-control, .table.gx-sm-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gs-sm-10 th:first-child, .table.gs-sm-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-sm-10 th:last-child, .table.gs-sm-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-sm-10 th.dtr-control:first-child, .table.gs-sm-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 768px) {
  .table.g-md-0 th, .table.g-md-0 td {
    padding: 0rem;
  }
  .table.g-md-0 th.dtr-control, .table.g-md-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gy-md-0 th, .table.gy-md-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }

  .table.gx-md-0 th, .table.gx-md-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-md-0 th.dtr-control, .table.gx-md-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gs-md-0 th:first-child, .table.gs-md-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-md-0 th:last-child, .table.gs-md-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-md-0 th.dtr-control:first-child, .table.gs-md-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }

  .table.g-md-1 th, .table.g-md-1 td {
    padding: 0.25rem;
  }
  .table.g-md-1 th.dtr-control, .table.g-md-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gy-md-1 th, .table.gy-md-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .table.gx-md-1 th, .table.gx-md-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-md-1 th.dtr-control, .table.gx-md-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gs-md-1 th:first-child, .table.gs-md-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-md-1 th:last-child, .table.gs-md-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-md-1 th.dtr-control:first-child, .table.gs-md-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }

  .table.g-md-2 th, .table.g-md-2 td {
    padding: 0.5rem;
  }
  .table.g-md-2 th.dtr-control, .table.g-md-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gy-md-2 th, .table.gy-md-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .table.gx-md-2 th, .table.gx-md-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-md-2 th.dtr-control, .table.gx-md-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gs-md-2 th:first-child, .table.gs-md-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-md-2 th:last-child, .table.gs-md-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-md-2 th.dtr-control:first-child, .table.gs-md-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }

  .table.g-md-3 th, .table.g-md-3 td {
    padding: 0.75rem;
  }
  .table.g-md-3 th.dtr-control, .table.g-md-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gy-md-3 th, .table.gy-md-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .table.gx-md-3 th, .table.gx-md-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-md-3 th.dtr-control, .table.gx-md-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gs-md-3 th:first-child, .table.gs-md-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-md-3 th:last-child, .table.gs-md-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-md-3 th.dtr-control:first-child, .table.gs-md-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }

  .table.g-md-4 th, .table.g-md-4 td {
    padding: 1rem;
  }
  .table.g-md-4 th.dtr-control, .table.g-md-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gy-md-4 th, .table.gy-md-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .table.gx-md-4 th, .table.gx-md-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-md-4 th.dtr-control, .table.gx-md-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gs-md-4 th:first-child, .table.gs-md-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-md-4 th:last-child, .table.gs-md-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-md-4 th.dtr-control:first-child, .table.gs-md-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }

  .table.g-md-5 th, .table.g-md-5 td {
    padding: 1.25rem;
  }
  .table.g-md-5 th.dtr-control, .table.g-md-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gy-md-5 th, .table.gy-md-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .table.gx-md-5 th, .table.gx-md-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-md-5 th.dtr-control, .table.gx-md-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gs-md-5 th:first-child, .table.gs-md-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-md-5 th:last-child, .table.gs-md-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-md-5 th.dtr-control:first-child, .table.gs-md-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }

  .table.g-md-6 th, .table.g-md-6 td {
    padding: 1.5rem;
  }
  .table.g-md-6 th.dtr-control, .table.g-md-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gy-md-6 th, .table.gy-md-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .table.gx-md-6 th, .table.gx-md-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-md-6 th.dtr-control, .table.gx-md-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gs-md-6 th:first-child, .table.gs-md-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-md-6 th:last-child, .table.gs-md-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-md-6 th.dtr-control:first-child, .table.gs-md-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }

  .table.g-md-7 th, .table.g-md-7 td {
    padding: 1.75rem;
  }
  .table.g-md-7 th.dtr-control, .table.g-md-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gy-md-7 th, .table.gy-md-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .table.gx-md-7 th, .table.gx-md-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-md-7 th.dtr-control, .table.gx-md-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gs-md-7 th:first-child, .table.gs-md-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-md-7 th:last-child, .table.gs-md-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-md-7 th.dtr-control:first-child, .table.gs-md-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }

  .table.g-md-8 th, .table.g-md-8 td {
    padding: 2rem;
  }
  .table.g-md-8 th.dtr-control, .table.g-md-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gy-md-8 th, .table.gy-md-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .table.gx-md-8 th, .table.gx-md-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-md-8 th.dtr-control, .table.gx-md-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gs-md-8 th:first-child, .table.gs-md-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-md-8 th:last-child, .table.gs-md-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-md-8 th.dtr-control:first-child, .table.gs-md-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }

  .table.g-md-9 th, .table.g-md-9 td {
    padding: 2.25rem;
  }
  .table.g-md-9 th.dtr-control, .table.g-md-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gy-md-9 th, .table.gy-md-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .table.gx-md-9 th, .table.gx-md-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-md-9 th.dtr-control, .table.gx-md-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gs-md-9 th:first-child, .table.gs-md-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-md-9 th:last-child, .table.gs-md-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-md-9 th.dtr-control:first-child, .table.gs-md-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }

  .table.g-md-10 th, .table.g-md-10 td {
    padding: 2.5rem;
  }
  .table.g-md-10 th.dtr-control, .table.g-md-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gy-md-10 th, .table.gy-md-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .table.gx-md-10 th, .table.gx-md-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-md-10 th.dtr-control, .table.gx-md-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gs-md-10 th:first-child, .table.gs-md-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-md-10 th:last-child, .table.gs-md-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-md-10 th.dtr-control:first-child, .table.gs-md-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 992px) {
  .table.g-lg-0 th, .table.g-lg-0 td {
    padding: 0rem;
  }
  .table.g-lg-0 th.dtr-control, .table.g-lg-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gy-lg-0 th, .table.gy-lg-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }

  .table.gx-lg-0 th, .table.gx-lg-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-lg-0 th.dtr-control, .table.gx-lg-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gs-lg-0 th:first-child, .table.gs-lg-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-lg-0 th:last-child, .table.gs-lg-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-lg-0 th.dtr-control:first-child, .table.gs-lg-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }

  .table.g-lg-1 th, .table.g-lg-1 td {
    padding: 0.25rem;
  }
  .table.g-lg-1 th.dtr-control, .table.g-lg-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gy-lg-1 th, .table.gy-lg-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .table.gx-lg-1 th, .table.gx-lg-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-lg-1 th.dtr-control, .table.gx-lg-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gs-lg-1 th:first-child, .table.gs-lg-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-lg-1 th:last-child, .table.gs-lg-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-lg-1 th.dtr-control:first-child, .table.gs-lg-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }

  .table.g-lg-2 th, .table.g-lg-2 td {
    padding: 0.5rem;
  }
  .table.g-lg-2 th.dtr-control, .table.g-lg-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gy-lg-2 th, .table.gy-lg-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .table.gx-lg-2 th, .table.gx-lg-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-lg-2 th.dtr-control, .table.gx-lg-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gs-lg-2 th:first-child, .table.gs-lg-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-lg-2 th:last-child, .table.gs-lg-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-lg-2 th.dtr-control:first-child, .table.gs-lg-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }

  .table.g-lg-3 th, .table.g-lg-3 td {
    padding: 0.75rem;
  }
  .table.g-lg-3 th.dtr-control, .table.g-lg-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gy-lg-3 th, .table.gy-lg-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .table.gx-lg-3 th, .table.gx-lg-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-lg-3 th.dtr-control, .table.gx-lg-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gs-lg-3 th:first-child, .table.gs-lg-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-lg-3 th:last-child, .table.gs-lg-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-lg-3 th.dtr-control:first-child, .table.gs-lg-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }

  .table.g-lg-4 th, .table.g-lg-4 td {
    padding: 1rem;
  }
  .table.g-lg-4 th.dtr-control, .table.g-lg-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gy-lg-4 th, .table.gy-lg-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .table.gx-lg-4 th, .table.gx-lg-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-lg-4 th.dtr-control, .table.gx-lg-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gs-lg-4 th:first-child, .table.gs-lg-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-lg-4 th:last-child, .table.gs-lg-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-lg-4 th.dtr-control:first-child, .table.gs-lg-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }

  .table.g-lg-5 th, .table.g-lg-5 td {
    padding: 1.25rem;
  }
  .table.g-lg-5 th.dtr-control, .table.g-lg-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gy-lg-5 th, .table.gy-lg-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .table.gx-lg-5 th, .table.gx-lg-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-lg-5 th.dtr-control, .table.gx-lg-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gs-lg-5 th:first-child, .table.gs-lg-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-lg-5 th:last-child, .table.gs-lg-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-lg-5 th.dtr-control:first-child, .table.gs-lg-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }

  .table.g-lg-6 th, .table.g-lg-6 td {
    padding: 1.5rem;
  }
  .table.g-lg-6 th.dtr-control, .table.g-lg-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gy-lg-6 th, .table.gy-lg-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .table.gx-lg-6 th, .table.gx-lg-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-lg-6 th.dtr-control, .table.gx-lg-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gs-lg-6 th:first-child, .table.gs-lg-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-lg-6 th:last-child, .table.gs-lg-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-lg-6 th.dtr-control:first-child, .table.gs-lg-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }

  .table.g-lg-7 th, .table.g-lg-7 td {
    padding: 1.75rem;
  }
  .table.g-lg-7 th.dtr-control, .table.g-lg-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gy-lg-7 th, .table.gy-lg-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .table.gx-lg-7 th, .table.gx-lg-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-lg-7 th.dtr-control, .table.gx-lg-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gs-lg-7 th:first-child, .table.gs-lg-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-lg-7 th:last-child, .table.gs-lg-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-lg-7 th.dtr-control:first-child, .table.gs-lg-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }

  .table.g-lg-8 th, .table.g-lg-8 td {
    padding: 2rem;
  }
  .table.g-lg-8 th.dtr-control, .table.g-lg-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gy-lg-8 th, .table.gy-lg-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .table.gx-lg-8 th, .table.gx-lg-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-lg-8 th.dtr-control, .table.gx-lg-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gs-lg-8 th:first-child, .table.gs-lg-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-lg-8 th:last-child, .table.gs-lg-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-lg-8 th.dtr-control:first-child, .table.gs-lg-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }

  .table.g-lg-9 th, .table.g-lg-9 td {
    padding: 2.25rem;
  }
  .table.g-lg-9 th.dtr-control, .table.g-lg-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gy-lg-9 th, .table.gy-lg-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .table.gx-lg-9 th, .table.gx-lg-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-lg-9 th.dtr-control, .table.gx-lg-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gs-lg-9 th:first-child, .table.gs-lg-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-lg-9 th:last-child, .table.gs-lg-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-lg-9 th.dtr-control:first-child, .table.gs-lg-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }

  .table.g-lg-10 th, .table.g-lg-10 td {
    padding: 2.5rem;
  }
  .table.g-lg-10 th.dtr-control, .table.g-lg-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gy-lg-10 th, .table.gy-lg-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .table.gx-lg-10 th, .table.gx-lg-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-lg-10 th.dtr-control, .table.gx-lg-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gs-lg-10 th:first-child, .table.gs-lg-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-lg-10 th:last-child, .table.gs-lg-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-lg-10 th.dtr-control:first-child, .table.gs-lg-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 1200px) {
  .table.g-xl-0 th, .table.g-xl-0 td {
    padding: 0rem;
  }
  .table.g-xl-0 th.dtr-control, .table.g-xl-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gy-xl-0 th, .table.gy-xl-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }

  .table.gx-xl-0 th, .table.gx-xl-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-xl-0 th.dtr-control, .table.gx-xl-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gs-xl-0 th:first-child, .table.gs-xl-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-xl-0 th:last-child, .table.gs-xl-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-xl-0 th.dtr-control:first-child, .table.gs-xl-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }

  .table.g-xl-1 th, .table.g-xl-1 td {
    padding: 0.25rem;
  }
  .table.g-xl-1 th.dtr-control, .table.g-xl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gy-xl-1 th, .table.gy-xl-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .table.gx-xl-1 th, .table.gx-xl-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-xl-1 th.dtr-control, .table.gx-xl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gs-xl-1 th:first-child, .table.gs-xl-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-xl-1 th:last-child, .table.gs-xl-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-xl-1 th.dtr-control:first-child, .table.gs-xl-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }

  .table.g-xl-2 th, .table.g-xl-2 td {
    padding: 0.5rem;
  }
  .table.g-xl-2 th.dtr-control, .table.g-xl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gy-xl-2 th, .table.gy-xl-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .table.gx-xl-2 th, .table.gx-xl-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-xl-2 th.dtr-control, .table.gx-xl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gs-xl-2 th:first-child, .table.gs-xl-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-xl-2 th:last-child, .table.gs-xl-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-xl-2 th.dtr-control:first-child, .table.gs-xl-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }

  .table.g-xl-3 th, .table.g-xl-3 td {
    padding: 0.75rem;
  }
  .table.g-xl-3 th.dtr-control, .table.g-xl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gy-xl-3 th, .table.gy-xl-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .table.gx-xl-3 th, .table.gx-xl-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-xl-3 th.dtr-control, .table.gx-xl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gs-xl-3 th:first-child, .table.gs-xl-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-xl-3 th:last-child, .table.gs-xl-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-xl-3 th.dtr-control:first-child, .table.gs-xl-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }

  .table.g-xl-4 th, .table.g-xl-4 td {
    padding: 1rem;
  }
  .table.g-xl-4 th.dtr-control, .table.g-xl-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gy-xl-4 th, .table.gy-xl-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .table.gx-xl-4 th, .table.gx-xl-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-xl-4 th.dtr-control, .table.gx-xl-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gs-xl-4 th:first-child, .table.gs-xl-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-xl-4 th:last-child, .table.gs-xl-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-xl-4 th.dtr-control:first-child, .table.gs-xl-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }

  .table.g-xl-5 th, .table.g-xl-5 td {
    padding: 1.25rem;
  }
  .table.g-xl-5 th.dtr-control, .table.g-xl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gy-xl-5 th, .table.gy-xl-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .table.gx-xl-5 th, .table.gx-xl-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-xl-5 th.dtr-control, .table.gx-xl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gs-xl-5 th:first-child, .table.gs-xl-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-xl-5 th:last-child, .table.gs-xl-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-xl-5 th.dtr-control:first-child, .table.gs-xl-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }

  .table.g-xl-6 th, .table.g-xl-6 td {
    padding: 1.5rem;
  }
  .table.g-xl-6 th.dtr-control, .table.g-xl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gy-xl-6 th, .table.gy-xl-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .table.gx-xl-6 th, .table.gx-xl-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-xl-6 th.dtr-control, .table.gx-xl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gs-xl-6 th:first-child, .table.gs-xl-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-xl-6 th:last-child, .table.gs-xl-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-xl-6 th.dtr-control:first-child, .table.gs-xl-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }

  .table.g-xl-7 th, .table.g-xl-7 td {
    padding: 1.75rem;
  }
  .table.g-xl-7 th.dtr-control, .table.g-xl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gy-xl-7 th, .table.gy-xl-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .table.gx-xl-7 th, .table.gx-xl-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-xl-7 th.dtr-control, .table.gx-xl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gs-xl-7 th:first-child, .table.gs-xl-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-xl-7 th:last-child, .table.gs-xl-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-xl-7 th.dtr-control:first-child, .table.gs-xl-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }

  .table.g-xl-8 th, .table.g-xl-8 td {
    padding: 2rem;
  }
  .table.g-xl-8 th.dtr-control, .table.g-xl-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gy-xl-8 th, .table.gy-xl-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .table.gx-xl-8 th, .table.gx-xl-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-xl-8 th.dtr-control, .table.gx-xl-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gs-xl-8 th:first-child, .table.gs-xl-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-xl-8 th:last-child, .table.gs-xl-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-xl-8 th.dtr-control:first-child, .table.gs-xl-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }

  .table.g-xl-9 th, .table.g-xl-9 td {
    padding: 2.25rem;
  }
  .table.g-xl-9 th.dtr-control, .table.g-xl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gy-xl-9 th, .table.gy-xl-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .table.gx-xl-9 th, .table.gx-xl-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-xl-9 th.dtr-control, .table.gx-xl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gs-xl-9 th:first-child, .table.gs-xl-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-xl-9 th:last-child, .table.gs-xl-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-xl-9 th.dtr-control:first-child, .table.gs-xl-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }

  .table.g-xl-10 th, .table.g-xl-10 td {
    padding: 2.5rem;
  }
  .table.g-xl-10 th.dtr-control, .table.g-xl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gy-xl-10 th, .table.gy-xl-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .table.gx-xl-10 th, .table.gx-xl-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-xl-10 th.dtr-control, .table.gx-xl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gs-xl-10 th:first-child, .table.gs-xl-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-xl-10 th:last-child, .table.gs-xl-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-xl-10 th.dtr-control:first-child, .table.gs-xl-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
@media (min-width: 1400px) {
  .table.g-xxl-0 th, .table.g-xxl-0 td {
    padding: 0rem;
  }
  .table.g-xxl-0 th.dtr-control, .table.g-xxl-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gy-xxl-0 th, .table.gy-xxl-0 td {
    padding-top: 0rem;
    padding-bottom: 0rem;
  }

  .table.gx-xxl-0 th, .table.gx-xxl-0 td {
    padding-left: 0rem;
    padding-right: 0rem;
  }
  .table.gx-xxl-0 th.dtr-control, .table.gx-xxl-0 td.dtr-control {
    padding-left: 0rem !important;
  }

  .table.gs-xxl-0 th:first-child, .table.gs-xxl-0 td:first-child {
    padding-left: 0rem;
  }
  .table.gs-xxl-0 th:last-child, .table.gs-xxl-0 td:last-child {
    padding-right: 0rem;
  }
  .table.gs-xxl-0 th.dtr-control:first-child, .table.gs-xxl-0 td.dtr-control:first-child {
    padding-left: 0rem !important;
  }

  .table.g-xxl-1 th, .table.g-xxl-1 td {
    padding: 0.25rem;
  }
  .table.g-xxl-1 th.dtr-control, .table.g-xxl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gy-xxl-1 th, .table.gy-xxl-1 td {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .table.gx-xxl-1 th, .table.gx-xxl-1 td {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .table.gx-xxl-1 th.dtr-control, .table.gx-xxl-1 td.dtr-control {
    padding-left: 0.25rem !important;
  }

  .table.gs-xxl-1 th:first-child, .table.gs-xxl-1 td:first-child {
    padding-left: 0.25rem;
  }
  .table.gs-xxl-1 th:last-child, .table.gs-xxl-1 td:last-child {
    padding-right: 0.25rem;
  }
  .table.gs-xxl-1 th.dtr-control:first-child, .table.gs-xxl-1 td.dtr-control:first-child {
    padding-left: 0.25rem !important;
  }

  .table.g-xxl-2 th, .table.g-xxl-2 td {
    padding: 0.5rem;
  }
  .table.g-xxl-2 th.dtr-control, .table.g-xxl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gy-xxl-2 th, .table.gy-xxl-2 td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .table.gx-xxl-2 th, .table.gx-xxl-2 td {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .table.gx-xxl-2 th.dtr-control, .table.gx-xxl-2 td.dtr-control {
    padding-left: 0.5rem !important;
  }

  .table.gs-xxl-2 th:first-child, .table.gs-xxl-2 td:first-child {
    padding-left: 0.5rem;
  }
  .table.gs-xxl-2 th:last-child, .table.gs-xxl-2 td:last-child {
    padding-right: 0.5rem;
  }
  .table.gs-xxl-2 th.dtr-control:first-child, .table.gs-xxl-2 td.dtr-control:first-child {
    padding-left: 0.5rem !important;
  }

  .table.g-xxl-3 th, .table.g-xxl-3 td {
    padding: 0.75rem;
  }
  .table.g-xxl-3 th.dtr-control, .table.g-xxl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gy-xxl-3 th, .table.gy-xxl-3 td {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .table.gx-xxl-3 th, .table.gx-xxl-3 td {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .table.gx-xxl-3 th.dtr-control, .table.gx-xxl-3 td.dtr-control {
    padding-left: 0.75rem !important;
  }

  .table.gs-xxl-3 th:first-child, .table.gs-xxl-3 td:first-child {
    padding-left: 0.75rem;
  }
  .table.gs-xxl-3 th:last-child, .table.gs-xxl-3 td:last-child {
    padding-right: 0.75rem;
  }
  .table.gs-xxl-3 th.dtr-control:first-child, .table.gs-xxl-3 td.dtr-control:first-child {
    padding-left: 0.75rem !important;
  }

  .table.g-xxl-4 th, .table.g-xxl-4 td {
    padding: 1rem;
  }
  .table.g-xxl-4 th.dtr-control, .table.g-xxl-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gy-xxl-4 th, .table.gy-xxl-4 td {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .table.gx-xxl-4 th, .table.gx-xxl-4 td {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .table.gx-xxl-4 th.dtr-control, .table.gx-xxl-4 td.dtr-control {
    padding-left: 1rem !important;
  }

  .table.gs-xxl-4 th:first-child, .table.gs-xxl-4 td:first-child {
    padding-left: 1rem;
  }
  .table.gs-xxl-4 th:last-child, .table.gs-xxl-4 td:last-child {
    padding-right: 1rem;
  }
  .table.gs-xxl-4 th.dtr-control:first-child, .table.gs-xxl-4 td.dtr-control:first-child {
    padding-left: 1rem !important;
  }

  .table.g-xxl-5 th, .table.g-xxl-5 td {
    padding: 1.25rem;
  }
  .table.g-xxl-5 th.dtr-control, .table.g-xxl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gy-xxl-5 th, .table.gy-xxl-5 td {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .table.gx-xxl-5 th, .table.gx-xxl-5 td {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }
  .table.gx-xxl-5 th.dtr-control, .table.gx-xxl-5 td.dtr-control {
    padding-left: 1.25rem !important;
  }

  .table.gs-xxl-5 th:first-child, .table.gs-xxl-5 td:first-child {
    padding-left: 1.25rem;
  }
  .table.gs-xxl-5 th:last-child, .table.gs-xxl-5 td:last-child {
    padding-right: 1.25rem;
  }
  .table.gs-xxl-5 th.dtr-control:first-child, .table.gs-xxl-5 td.dtr-control:first-child {
    padding-left: 1.25rem !important;
  }

  .table.g-xxl-6 th, .table.g-xxl-6 td {
    padding: 1.5rem;
  }
  .table.g-xxl-6 th.dtr-control, .table.g-xxl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gy-xxl-6 th, .table.gy-xxl-6 td {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .table.gx-xxl-6 th, .table.gx-xxl-6 td {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .table.gx-xxl-6 th.dtr-control, .table.gx-xxl-6 td.dtr-control {
    padding-left: 1.5rem !important;
  }

  .table.gs-xxl-6 th:first-child, .table.gs-xxl-6 td:first-child {
    padding-left: 1.5rem;
  }
  .table.gs-xxl-6 th:last-child, .table.gs-xxl-6 td:last-child {
    padding-right: 1.5rem;
  }
  .table.gs-xxl-6 th.dtr-control:first-child, .table.gs-xxl-6 td.dtr-control:first-child {
    padding-left: 1.5rem !important;
  }

  .table.g-xxl-7 th, .table.g-xxl-7 td {
    padding: 1.75rem;
  }
  .table.g-xxl-7 th.dtr-control, .table.g-xxl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gy-xxl-7 th, .table.gy-xxl-7 td {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .table.gx-xxl-7 th, .table.gx-xxl-7 td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .table.gx-xxl-7 th.dtr-control, .table.gx-xxl-7 td.dtr-control {
    padding-left: 1.75rem !important;
  }

  .table.gs-xxl-7 th:first-child, .table.gs-xxl-7 td:first-child {
    padding-left: 1.75rem;
  }
  .table.gs-xxl-7 th:last-child, .table.gs-xxl-7 td:last-child {
    padding-right: 1.75rem;
  }
  .table.gs-xxl-7 th.dtr-control:first-child, .table.gs-xxl-7 td.dtr-control:first-child {
    padding-left: 1.75rem !important;
  }

  .table.g-xxl-8 th, .table.g-xxl-8 td {
    padding: 2rem;
  }
  .table.g-xxl-8 th.dtr-control, .table.g-xxl-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gy-xxl-8 th, .table.gy-xxl-8 td {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .table.gx-xxl-8 th, .table.gx-xxl-8 td {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .table.gx-xxl-8 th.dtr-control, .table.gx-xxl-8 td.dtr-control {
    padding-left: 2rem !important;
  }

  .table.gs-xxl-8 th:first-child, .table.gs-xxl-8 td:first-child {
    padding-left: 2rem;
  }
  .table.gs-xxl-8 th:last-child, .table.gs-xxl-8 td:last-child {
    padding-right: 2rem;
  }
  .table.gs-xxl-8 th.dtr-control:first-child, .table.gs-xxl-8 td.dtr-control:first-child {
    padding-left: 2rem !important;
  }

  .table.g-xxl-9 th, .table.g-xxl-9 td {
    padding: 2.25rem;
  }
  .table.g-xxl-9 th.dtr-control, .table.g-xxl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gy-xxl-9 th, .table.gy-xxl-9 td {
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .table.gx-xxl-9 th, .table.gx-xxl-9 td {
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }
  .table.gx-xxl-9 th.dtr-control, .table.gx-xxl-9 td.dtr-control {
    padding-left: 2.25rem !important;
  }

  .table.gs-xxl-9 th:first-child, .table.gs-xxl-9 td:first-child {
    padding-left: 2.25rem;
  }
  .table.gs-xxl-9 th:last-child, .table.gs-xxl-9 td:last-child {
    padding-right: 2.25rem;
  }
  .table.gs-xxl-9 th.dtr-control:first-child, .table.gs-xxl-9 td.dtr-control:first-child {
    padding-left: 2.25rem !important;
  }

  .table.g-xxl-10 th, .table.g-xxl-10 td {
    padding: 2.5rem;
  }
  .table.g-xxl-10 th.dtr-control, .table.g-xxl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gy-xxl-10 th, .table.gy-xxl-10 td {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .table.gx-xxl-10 th, .table.gx-xxl-10 td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .table.gx-xxl-10 th.dtr-control, .table.gx-xxl-10 td.dtr-control {
    padding-left: 2.5rem !important;
  }

  .table.gs-xxl-10 th:first-child, .table.gs-xxl-10 td:first-child {
    padding-left: 2.5rem;
  }
  .table.gs-xxl-10 th:last-child, .table.gs-xxl-10 td:last-child {
    padding-right: 2.5rem;
  }
  .table.gs-xxl-10 th.dtr-control:first-child, .table.gs-xxl-10 td.dtr-control:first-child {
    padding-left: 2.5rem !important;
  }
}
.popover {
  --bs-popover-bg: var(--kt-popover-bg);
  --bs-popover-border-color: var(--kt-popover-border-color);
  --bs-popover-box-shadow: var(--kt-popover-box-shadow);
  --bs-popover-header-color: var(--kt-popover-header-color);
  --bs-popover-header-bg: var(--kt-popover-header-bg);
  --bs-popover-body-color: var(--kt-popover-body-color);
  --bs-popover-arrow-border: var(--kt-popover-bg);
}
.popover .popover-header {
  font-size: 1rem;
  font-weight: 500;
  border-bottom: 1px solid var(--kt-popover-header-border-color);
}
.popover .popover-dismiss {
  position: absolute;
  top: 0.85rem;
  right: 0.85rem;
  height: 1.5rem;
  width: 1.5rem;
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-500);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_120___});
  mask-size: 50%;
  -webkit-mask-size: 50%;
}
.popover .popover-dismiss:hover {
  background-color: var(--kt-primary);
}
.popover .popover-dismiss + .popover-header {
  padding-right: 2.75rem;
}

.popover-inverse {
  background-color: var(--kt-gray-900);
  border: 0;
}
.popover-inverse .popover-header {
  background-color: var(--kt-gray-900);
  color: var(--kt-gray-200);
  border-bottom-color: var(--kt-gray-800);
}
.popover-inverse .popover-body {
  color: var(--kt-gray-400);
}
.popover-inverse.bs-popover-top > .popover-arrow::before, .popover-inverse.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  border-top-color: var(--kt-gray-100);
}
.popover-inverse.bs-popover-top > .popover-arrow::after, .popover-inverse.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-top-color: var(--kt-gray-900);
}
.popover-inverse.bs-popover-end > .popover-arrow::before, .popover-inverse.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  border-right-color: var(--kt-gray-100);
}
.popover-inverse.bs-popover-end > .popover-arrow::after, .popover-inverse.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-right-color: var(--kt-gray-900);
}
.popover-inverse.bs-popover-bottom > .popover-arrow::before, .popover-inverse.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  border-bottom-color: var(--kt-gray-100);
}
.popover-inverse.bs-popover-bottom > .popover-arrow::after, .popover-inverse.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-bottom-color: var(--kt-gray-900);
}
.popover-inverse.bs-popover-bottom .popover-header::before, .popover-inverse.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: var(--kt-gray-900);
}
.popover-inverse.bs-popover-start > .popover-arrow::before, .popover-inverse.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  border-left-color: var(--kt-gray-100);
}
.popover-inverse.bs-popover-start > .popover-arrow::after, .popover-inverse.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-left-color: var(--kt-gray-900);
}

.tooltip {
  --bs-tooltip-color: var(--kt-tooltip-color);
  --bs-tooltip-bg: var(--kt-tooltip-bg);
  --bs-tooltip-opacity: var(--kt-tooltip-opacity);
}
.tooltip .tooltip-inner {
  box-shadow: var(--kt-tooltip-box-shadow);
}
.tooltip.tooltop-auto-width .tooltip-inner {
  white-space: nowrap;
  max-width: none;
}
.tooltip.tooltip-inverse .tooltip-inner {
  color: var(--kt-dark-inverse);
  background-color: var(--kt-dark);
}
.tooltip.tooltip-inverse.bs-tooltip-top .tooltip-arrow::before, .tooltip.tooltip-inverse.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  border-top-color: var(--kt-dark);
}
.tooltip.tooltip-inverse.bs-tooltip-end .tooltip-arrow::before, .tooltip.tooltip-inverse.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  border-right-color: var(--kt-dark);
}
.tooltip.tooltip-inverse.bs-tooltip-bottom .tooltip-arrow::before, .tooltip.tooltip-inverse.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  border-bottom-color: var(--kt-dark);
}
.tooltip.tooltip-inverse.bs-tooltip-start .tooltip-arrow::before, .tooltip.tooltip-inverse.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  border-left-color: var(--kt-dark);
}

.accordion {
  --bs-accordion-color: var(--kt-accordion-color);
  --bs-accordion-bg: var(--kt-accordion-bg);
  --bs-accordion-border-color: var(--kt-accordion-border-color);
  --bs-accordion-btn-color: var(--kt-accordion-color);
  --bs-accordion-btn-bg: var(--kt-accordion-button-bg);
  --bs-accordion-btn-icon: var(--kt-accordion-button-icon);
  --bs-accordion-btn-active-icon: var(--kt-accordion-button-active-icon);
  --bs-accordion-btn-focus-border-color: var(--kt-accordion-button-focus-border-color);
  --bs-accordion-btn-focus-box-shadow: var(--kt-accordion-button-focus-box-shadow);
  --bs-accordion-active-color: var(--kt-accordion-button-active-color);
  --bs-accordion-active-bg: var(--kt-accordion-button-active-bg);
}
.accordion .accordion-header {
  cursor: pointer;
}
.accordion.accordion-icon-toggle .accordion-icon {
  display: flex;
  flex-shrink: 0;
  transition: all 0.2s ease-in-out;
  transform: rotate(90deg);
  align-items: center;
  justify-content: center;
}
.accordion.accordion-icon-toggle .accordion-icon i,
.accordion.accordion-icon-toggle .accordion-icon .svg-icon {
  color: var(--kt-primary);
}
.accordion.accordion-icon-toggle .collapsed .accordion-icon {
  transition: all 0.2s ease-in-out;
  transform: rotate(0);
}
.accordion.accordion-icon-toggle .collapsed .accordion-icon i,
.accordion.accordion-icon-toggle .collapsed .accordion-icon .svg-icon {
  color: var(--kt-text-muted);
}
.accordion.accordion-borderless .accordion-item {
  border: 0;
}
.accordion.accordion-flush .accordion-item {
  background-color: transparent;
  border: 0;
  border-radius: 0;
  padding-left: 0;
  padding-right: 0;
}

.feedback {
  display: none;
}

.feedback-popup {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  position: fixed;
  z-index: 1000;
  box-shadow: var(--kt-feedback-popup-box-shadow);
  background-color: var(--kt-feedback-popup-background-color);
  border-radius: 0.475rem;
  padding: 1rem 1.25rem;
}

.feedback-top-center {
  display: flex;
  transition: top 0.6s ease;
  left: 50%;
  transform: translateX(-50%);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.feedback-top-center.feedback-shown {
  top: 0px;
  transition: top 0.6s ease;
}

.image-input {
  position: relative;
  display: inline-block;
  border-radius: 0.475rem;
  background-repeat: no-repeat;
  background-size: cover;
}
.image-input:not(.image-input-empty) {
  background-image: none !important;
}
.image-input .image-input-wrapper {
  width: 120px;
  height: 120px;
  border-radius: 0.475rem;
  background-repeat: no-repeat;
  background-size: cover;
}
.image-input [data-kt-image-input-action] {
  cursor: pointer;
  position: absolute;
  transform: translate(-50%, -50%);
}
.image-input [data-kt-image-input-action=change] {
  left: 100%;
  top: 0;
}
.image-input [data-kt-image-input-action=change] input {
  width: 0 !important;
  height: 0 !important;
  overflow: hidden;
  opacity: 0;
}
.image-input [data-kt-image-input-action=cancel],
.image-input [data-kt-image-input-action=remove] {
  position: absolute;
  left: 100%;
  top: 100%;
}
.image-input [data-kt-image-input-action=cancel] {
  display: none;
}
.image-input.image-input-changed [data-kt-image-input-action=cancel] {
  display: flex;
}
.image-input.image-input-changed [data-kt-image-input-action=remove] {
  display: none;
}
.image-input.image-input-empty [data-kt-image-input-action=remove],
.image-input.image-input-empty [data-kt-image-input-action=cancel] {
  display: none;
}
.image-input.image-input-circle {
  border-radius: 50%;
}
.image-input.image-input-circle .image-input-wrapper {
  border-radius: 50%;
}
.image-input.image-input-circle [data-kt-image-input-action=change] {
  left: 100%;
  top: 0;
  transform: translate(-100%, 0%);
}
.image-input.image-input-circle [data-kt-image-input-action=cancel],
.image-input.image-input-circle [data-kt-image-input-action=remove] {
  left: 100%;
  top: 100%;
  transform: translate(-100%, -100%);
}
.image-input.image-input-outline .image-input-wrapper {
  border: 3px solid var(--kt-body-bg);
  box-shadow: var(--kt-box-shadow);
}

.symbol {
  display: inline-block;
  flex-shrink: 0;
  position: relative;
  border-radius: 0.475rem;
}
.symbol .symbol-label {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: var(--kt-symbol-label-color);
  background-color: var(--kt-symbol-label-bg);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-radius: 0.475rem;
}
.symbol .symbol-label:after {
  border-radius: 0.475rem;
}
.symbol .symbol-badge {
  position: absolute;
  border-radius: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%) translateY(-50%) !important;
}
.symbol > img {
  width: 100%;
  flex-shrink: 0;
  display: inline-block;
  border-radius: 0.475rem;
}
.symbol.symbol-square,
.symbol.symbol-square > img,
.symbol.symbol-square .symbol-label {
  border-radius: 0 !important;
}
.symbol.symbol-circle,
.symbol.symbol-circle > img,
.symbol.symbol-circle .symbol-label {
  border-radius: 50%;
}
.symbol.symbol-circle:after,
.symbol.symbol-circle > img:after,
.symbol.symbol-circle .symbol-label:after {
  border-radius: 50%;
}
.symbol > img {
  width: 50px;
  height: 50px;
}
.symbol .symbol-label {
  width: 50px;
  height: 50px;
}
.symbol.symbol-fixed .symbol-label {
  width: 50px;
  height: 50px;
}
.symbol.symbol-fixed > img {
  width: 50px;
  height: 50px;
  max-width: none;
}
.symbol.symbol-2by3 .symbol-label {
  height: 50px;
  width: 75px;
}
.symbol.symbol-2by3 > img {
  height: 50px;
  width: 75px;
  max-width: none;
}
.symbol.symbol-20px > img {
  width: 20px;
  height: 20px;
}
.symbol.symbol-20px .symbol-label {
  width: 20px;
  height: 20px;
}
.symbol.symbol-20px.symbol-fixed .symbol-label {
  width: 20px;
  height: 20px;
}
.symbol.symbol-20px.symbol-fixed > img {
  width: 20px;
  height: 20px;
  max-width: none;
}
.symbol.symbol-20px.symbol-2by3 .symbol-label {
  height: 20px;
  width: 30px;
}
.symbol.symbol-20px.symbol-2by3 > img {
  height: 20px;
  width: 30px;
  max-width: none;
}
.symbol.symbol-25px > img {
  width: 25px;
  height: 25px;
}
.symbol.symbol-25px .symbol-label {
  width: 25px;
  height: 25px;
}
.symbol.symbol-25px.symbol-fixed .symbol-label {
  width: 25px;
  height: 25px;
}
.symbol.symbol-25px.symbol-fixed > img {
  width: 25px;
  height: 25px;
  max-width: none;
}
.symbol.symbol-25px.symbol-2by3 .symbol-label {
  height: 25px;
  width: 37.5px;
}
.symbol.symbol-25px.symbol-2by3 > img {
  height: 25px;
  width: 37.5px;
  max-width: none;
}
.symbol.symbol-30px > img {
  width: 30px;
  height: 30px;
}
.symbol.symbol-30px .symbol-label {
  width: 30px;
  height: 30px;
}
.symbol.symbol-30px.symbol-fixed .symbol-label {
  width: 30px;
  height: 30px;
}
.symbol.symbol-30px.symbol-fixed > img {
  width: 30px;
  height: 30px;
  max-width: none;
}
.symbol.symbol-30px.symbol-2by3 .symbol-label {
  height: 30px;
  width: 45px;
}
.symbol.symbol-30px.symbol-2by3 > img {
  height: 30px;
  width: 45px;
  max-width: none;
}
.symbol.symbol-35px > img {
  width: 35px;
  height: 35px;
}
.symbol.symbol-35px .symbol-label {
  width: 35px;
  height: 35px;
}
.symbol.symbol-35px.symbol-fixed .symbol-label {
  width: 35px;
  height: 35px;
}
.symbol.symbol-35px.symbol-fixed > img {
  width: 35px;
  height: 35px;
  max-width: none;
}
.symbol.symbol-35px.symbol-2by3 .symbol-label {
  height: 35px;
  width: 52.5px;
}
.symbol.symbol-35px.symbol-2by3 > img {
  height: 35px;
  width: 52.5px;
  max-width: none;
}
.symbol.symbol-40px > img {
  width: 40px;
  height: 40px;
}
.symbol.symbol-40px .symbol-label {
  width: 40px;
  height: 40px;
}
.symbol.symbol-40px.symbol-fixed .symbol-label {
  width: 40px;
  height: 40px;
}
.symbol.symbol-40px.symbol-fixed > img {
  width: 40px;
  height: 40px;
  max-width: none;
}
.symbol.symbol-40px.symbol-2by3 .symbol-label {
  height: 40px;
  width: 60px;
}
.symbol.symbol-40px.symbol-2by3 > img {
  height: 40px;
  width: 60px;
  max-width: none;
}
.symbol.symbol-45px > img {
  width: 45px;
  height: 45px;
}
.symbol.symbol-45px .symbol-label {
  width: 45px;
  height: 45px;
}
.symbol.symbol-45px.symbol-fixed .symbol-label {
  width: 45px;
  height: 45px;
}
.symbol.symbol-45px.symbol-fixed > img {
  width: 45px;
  height: 45px;
  max-width: none;
}
.symbol.symbol-45px.symbol-2by3 .symbol-label {
  height: 45px;
  width: 67.5px;
}
.symbol.symbol-45px.symbol-2by3 > img {
  height: 45px;
  width: 67.5px;
  max-width: none;
}
.symbol.symbol-50px > img {
  width: 50px;
  height: 50px;
}
.symbol.symbol-50px .symbol-label {
  width: 50px;
  height: 50px;
}
.symbol.symbol-50px.symbol-fixed .symbol-label {
  width: 50px;
  height: 50px;
}
.symbol.symbol-50px.symbol-fixed > img {
  width: 50px;
  height: 50px;
  max-width: none;
}
.symbol.symbol-50px.symbol-2by3 .symbol-label {
  height: 50px;
  width: 75px;
}
.symbol.symbol-50px.symbol-2by3 > img {
  height: 50px;
  width: 75px;
  max-width: none;
}
.symbol.symbol-55px > img {
  width: 55px;
  height: 55px;
}
.symbol.symbol-55px .symbol-label {
  width: 55px;
  height: 55px;
}
.symbol.symbol-55px.symbol-fixed .symbol-label {
  width: 55px;
  height: 55px;
}
.symbol.symbol-55px.symbol-fixed > img {
  width: 55px;
  height: 55px;
  max-width: none;
}
.symbol.symbol-55px.symbol-2by3 .symbol-label {
  height: 55px;
  width: 82.5px;
}
.symbol.symbol-55px.symbol-2by3 > img {
  height: 55px;
  width: 82.5px;
  max-width: none;
}
.symbol.symbol-60px > img {
  width: 60px;
  height: 60px;
}
.symbol.symbol-60px .symbol-label {
  width: 60px;
  height: 60px;
}
.symbol.symbol-60px.symbol-fixed .symbol-label {
  width: 60px;
  height: 60px;
}
.symbol.symbol-60px.symbol-fixed > img {
  width: 60px;
  height: 60px;
  max-width: none;
}
.symbol.symbol-60px.symbol-2by3 .symbol-label {
  height: 60px;
  width: 90px;
}
.symbol.symbol-60px.symbol-2by3 > img {
  height: 60px;
  width: 90px;
  max-width: none;
}
.symbol.symbol-65px > img {
  width: 65px;
  height: 65px;
}
.symbol.symbol-65px .symbol-label {
  width: 65px;
  height: 65px;
}
.symbol.symbol-65px.symbol-fixed .symbol-label {
  width: 65px;
  height: 65px;
}
.symbol.symbol-65px.symbol-fixed > img {
  width: 65px;
  height: 65px;
  max-width: none;
}
.symbol.symbol-65px.symbol-2by3 .symbol-label {
  height: 65px;
  width: 97.5px;
}
.symbol.symbol-65px.symbol-2by3 > img {
  height: 65px;
  width: 97.5px;
  max-width: none;
}
.symbol.symbol-70px > img {
  width: 70px;
  height: 70px;
}
.symbol.symbol-70px .symbol-label {
  width: 70px;
  height: 70px;
}
.symbol.symbol-70px.symbol-fixed .symbol-label {
  width: 70px;
  height: 70px;
}
.symbol.symbol-70px.symbol-fixed > img {
  width: 70px;
  height: 70px;
  max-width: none;
}
.symbol.symbol-70px.symbol-2by3 .symbol-label {
  height: 70px;
  width: 105px;
}
.symbol.symbol-70px.symbol-2by3 > img {
  height: 70px;
  width: 105px;
  max-width: none;
}
.symbol.symbol-75px > img {
  width: 75px;
  height: 75px;
}
.symbol.symbol-75px .symbol-label {
  width: 75px;
  height: 75px;
}
.symbol.symbol-75px.symbol-fixed .symbol-label {
  width: 75px;
  height: 75px;
}
.symbol.symbol-75px.symbol-fixed > img {
  width: 75px;
  height: 75px;
  max-width: none;
}
.symbol.symbol-75px.symbol-2by3 .symbol-label {
  height: 75px;
  width: 112.5px;
}
.symbol.symbol-75px.symbol-2by3 > img {
  height: 75px;
  width: 112.5px;
  max-width: none;
}
.symbol.symbol-90px > img {
  width: 90px;
  height: 90px;
}
.symbol.symbol-90px .symbol-label {
  width: 90px;
  height: 90px;
}
.symbol.symbol-90px.symbol-fixed .symbol-label {
  width: 90px;
  height: 90px;
}
.symbol.symbol-90px.symbol-fixed > img {
  width: 90px;
  height: 90px;
  max-width: none;
}
.symbol.symbol-90px.symbol-2by3 .symbol-label {
  height: 90px;
  width: 135px;
}
.symbol.symbol-90px.symbol-2by3 > img {
  height: 90px;
  width: 135px;
  max-width: none;
}
.symbol.symbol-100px > img {
  width: 100px;
  height: 100px;
}
.symbol.symbol-100px .symbol-label {
  width: 100px;
  height: 100px;
}
.symbol.symbol-100px.symbol-fixed .symbol-label {
  width: 100px;
  height: 100px;
}
.symbol.symbol-100px.symbol-fixed > img {
  width: 100px;
  height: 100px;
  max-width: none;
}
.symbol.symbol-100px.symbol-2by3 .symbol-label {
  height: 100px;
  width: 150px;
}
.symbol.symbol-100px.symbol-2by3 > img {
  height: 100px;
  width: 150px;
  max-width: none;
}
.symbol.symbol-125px > img {
  width: 125px;
  height: 125px;
}
.symbol.symbol-125px .symbol-label {
  width: 125px;
  height: 125px;
}
.symbol.symbol-125px.symbol-fixed .symbol-label {
  width: 125px;
  height: 125px;
}
.symbol.symbol-125px.symbol-fixed > img {
  width: 125px;
  height: 125px;
  max-width: none;
}
.symbol.symbol-125px.symbol-2by3 .symbol-label {
  height: 125px;
  width: 187.5px;
}
.symbol.symbol-125px.symbol-2by3 > img {
  height: 125px;
  width: 187.5px;
  max-width: none;
}
.symbol.symbol-150px > img {
  width: 150px;
  height: 150px;
}
.symbol.symbol-150px .symbol-label {
  width: 150px;
  height: 150px;
}
.symbol.symbol-150px.symbol-fixed .symbol-label {
  width: 150px;
  height: 150px;
}
.symbol.symbol-150px.symbol-fixed > img {
  width: 150px;
  height: 150px;
  max-width: none;
}
.symbol.symbol-150px.symbol-2by3 .symbol-label {
  height: 150px;
  width: 225px;
}
.symbol.symbol-150px.symbol-2by3 > img {
  height: 150px;
  width: 225px;
  max-width: none;
}
.symbol.symbol-160px > img {
  width: 160px;
  height: 160px;
}
.symbol.symbol-160px .symbol-label {
  width: 160px;
  height: 160px;
}
.symbol.symbol-160px.symbol-fixed .symbol-label {
  width: 160px;
  height: 160px;
}
.symbol.symbol-160px.symbol-fixed > img {
  width: 160px;
  height: 160px;
  max-width: none;
}
.symbol.symbol-160px.symbol-2by3 .symbol-label {
  height: 160px;
  width: 240px;
}
.symbol.symbol-160px.symbol-2by3 > img {
  height: 160px;
  width: 240px;
  max-width: none;
}
.symbol.symbol-175px > img {
  width: 175px;
  height: 175px;
}
.symbol.symbol-175px .symbol-label {
  width: 175px;
  height: 175px;
}
.symbol.symbol-175px.symbol-fixed .symbol-label {
  width: 175px;
  height: 175px;
}
.symbol.symbol-175px.symbol-fixed > img {
  width: 175px;
  height: 175px;
  max-width: none;
}
.symbol.symbol-175px.symbol-2by3 .symbol-label {
  height: 175px;
  width: 262.5px;
}
.symbol.symbol-175px.symbol-2by3 > img {
  height: 175px;
  width: 262.5px;
  max-width: none;
}
.symbol.symbol-200px > img {
  width: 200px;
  height: 200px;
}
.symbol.symbol-200px .symbol-label {
  width: 200px;
  height: 200px;
}
.symbol.symbol-200px.symbol-fixed .symbol-label {
  width: 200px;
  height: 200px;
}
.symbol.symbol-200px.symbol-fixed > img {
  width: 200px;
  height: 200px;
  max-width: none;
}
.symbol.symbol-200px.symbol-2by3 .symbol-label {
  height: 200px;
  width: 300px;
}
.symbol.symbol-200px.symbol-2by3 > img {
  height: 200px;
  width: 300px;
  max-width: none;
}
@media (min-width: 576px) {
  .symbol.symbol-sm-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-sm-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-sm-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-sm-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-sm-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-sm-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-sm-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-sm-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-sm-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-sm-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-sm-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-sm-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-sm-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-sm-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-sm-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-sm-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-sm-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-sm-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-sm-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-sm-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-sm-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-sm-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-sm-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-sm-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-sm-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-sm-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-sm-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-sm-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-sm-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-sm-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-sm-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-sm-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-sm-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-sm-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-sm-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-sm-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-sm-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-sm-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-sm-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-sm-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-sm-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-sm-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-sm-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-sm-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-sm-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-sm-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-sm-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-sm-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-sm-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-sm-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-sm-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-sm-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-sm-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-sm-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-sm-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-sm-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-sm-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-sm-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-sm-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-sm-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-sm-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-sm-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-sm-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-sm-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-sm-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-sm-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-sm-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-sm-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-sm-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-sm-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-sm-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-sm-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-sm-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-sm-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-sm-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-sm-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-sm-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-sm-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-sm-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-sm-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-sm-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-sm-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-sm-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-sm-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-sm-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-sm-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-sm-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-sm-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-sm-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-sm-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-sm-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-sm-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-sm-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-sm-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-sm-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-sm-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-sm-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-sm-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-sm-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-sm-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-sm-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-sm-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-sm-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-sm-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-sm-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-sm-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-sm-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-sm-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-sm-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-sm-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-sm-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-sm-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-sm-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-sm-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}
@media (min-width: 768px) {
  .symbol.symbol-md-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-md-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-md-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-md-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-md-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-md-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-md-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-md-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-md-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-md-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-md-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-md-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-md-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-md-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-md-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-md-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-md-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-md-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-md-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-md-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-md-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-md-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-md-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-md-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-md-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-md-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-md-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-md-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-md-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-md-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-md-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-md-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-md-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-md-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-md-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-md-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-md-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-md-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-md-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-md-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-md-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-md-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-md-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-md-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-md-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-md-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-md-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-md-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-md-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-md-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-md-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-md-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-md-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-md-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-md-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-md-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-md-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-md-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-md-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-md-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-md-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-md-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-md-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-md-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-md-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-md-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-md-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-md-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-md-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-md-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-md-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-md-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-md-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-md-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-md-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-md-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-md-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-md-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-md-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-md-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-md-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-md-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-md-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-md-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-md-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-md-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-md-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-md-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-md-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-md-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-md-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-md-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-md-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-md-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-md-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-md-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-md-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-md-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-md-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-md-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-md-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-md-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-md-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-md-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-md-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-md-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-md-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-md-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-md-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-md-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-md-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-md-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-md-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-md-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}
@media (min-width: 992px) {
  .symbol.symbol-lg-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-lg-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-lg-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-lg-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-lg-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-lg-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-lg-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-lg-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-lg-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-lg-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-lg-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-lg-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-lg-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-lg-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-lg-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-lg-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-lg-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-lg-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-lg-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-lg-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-lg-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-lg-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-lg-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-lg-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-lg-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-lg-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-lg-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-lg-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-lg-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-lg-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-lg-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-lg-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-lg-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-lg-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-lg-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-lg-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-lg-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-lg-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-lg-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-lg-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-lg-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-lg-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-lg-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-lg-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-lg-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-lg-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-lg-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-lg-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-lg-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-lg-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-lg-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-lg-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-lg-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-lg-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-lg-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-lg-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-lg-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-lg-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-lg-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-lg-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-lg-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-lg-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-lg-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-lg-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-lg-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-lg-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-lg-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-lg-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-lg-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-lg-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-lg-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-lg-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-lg-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-lg-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-lg-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-lg-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-lg-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-lg-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-lg-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-lg-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-lg-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-lg-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-lg-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-lg-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-lg-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-lg-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-lg-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-lg-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-lg-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-lg-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-lg-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-lg-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-lg-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-lg-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-lg-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-lg-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-lg-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-lg-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-lg-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-lg-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-lg-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-lg-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-lg-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-lg-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-lg-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-lg-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-lg-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-lg-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-lg-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-lg-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-lg-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-lg-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-lg-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-lg-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}
@media (min-width: 1200px) {
  .symbol.symbol-xl-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xl-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xl-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xl-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-xl-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-xl-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-xl-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xl-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xl-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xl-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-xl-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-xl-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-xl-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xl-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xl-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xl-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-xl-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-xl-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-xl-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xl-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xl-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xl-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-xl-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-xl-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-xl-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xl-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xl-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xl-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-xl-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-xl-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-xl-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xl-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xl-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xl-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-xl-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-xl-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-xl-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xl-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xl-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xl-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-xl-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-xl-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-xl-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xl-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xl-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xl-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-xl-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-xl-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-xl-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xl-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xl-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xl-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-xl-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-xl-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-xl-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xl-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xl-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xl-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-xl-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-xl-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-xl-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xl-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xl-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xl-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-xl-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-xl-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-xl-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xl-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xl-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xl-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-xl-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-xl-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-xl-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xl-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xl-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xl-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-xl-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-xl-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-xl-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xl-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xl-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xl-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-xl-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-xl-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-xl-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xl-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xl-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xl-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-xl-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-xl-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-xl-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xl-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xl-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xl-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-xl-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-xl-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-xl-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xl-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xl-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xl-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-xl-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-xl-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-xl-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xl-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xl-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xl-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-xl-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-xl-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-xl-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xl-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xl-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xl-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-xl-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-xl-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}
@media (min-width: 1400px) {
  .symbol.symbol-xxl-20px > img {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xxl-20px .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xxl-20px.symbol-fixed .symbol-label {
    width: 20px;
    height: 20px;
  }
  .symbol.symbol-xxl-20px.symbol-fixed > img {
    width: 20px;
    height: 20px;
    max-width: none;
  }
  .symbol.symbol-xxl-20px.symbol-2by3 .symbol-label {
    height: 20px;
    width: 30px;
  }
  .symbol.symbol-xxl-20px.symbol-2by3 > img {
    height: 20px;
    width: 30px;
    max-width: none;
  }
  .symbol.symbol-xxl-25px > img {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xxl-25px .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xxl-25px.symbol-fixed .symbol-label {
    width: 25px;
    height: 25px;
  }
  .symbol.symbol-xxl-25px.symbol-fixed > img {
    width: 25px;
    height: 25px;
    max-width: none;
  }
  .symbol.symbol-xxl-25px.symbol-2by3 .symbol-label {
    height: 25px;
    width: 37.5px;
  }
  .symbol.symbol-xxl-25px.symbol-2by3 > img {
    height: 25px;
    width: 37.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-30px > img {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xxl-30px .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xxl-30px.symbol-fixed .symbol-label {
    width: 30px;
    height: 30px;
  }
  .symbol.symbol-xxl-30px.symbol-fixed > img {
    width: 30px;
    height: 30px;
    max-width: none;
  }
  .symbol.symbol-xxl-30px.symbol-2by3 .symbol-label {
    height: 30px;
    width: 45px;
  }
  .symbol.symbol-xxl-30px.symbol-2by3 > img {
    height: 30px;
    width: 45px;
    max-width: none;
  }
  .symbol.symbol-xxl-35px > img {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xxl-35px .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xxl-35px.symbol-fixed .symbol-label {
    width: 35px;
    height: 35px;
  }
  .symbol.symbol-xxl-35px.symbol-fixed > img {
    width: 35px;
    height: 35px;
    max-width: none;
  }
  .symbol.symbol-xxl-35px.symbol-2by3 .symbol-label {
    height: 35px;
    width: 52.5px;
  }
  .symbol.symbol-xxl-35px.symbol-2by3 > img {
    height: 35px;
    width: 52.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-40px > img {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xxl-40px .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xxl-40px.symbol-fixed .symbol-label {
    width: 40px;
    height: 40px;
  }
  .symbol.symbol-xxl-40px.symbol-fixed > img {
    width: 40px;
    height: 40px;
    max-width: none;
  }
  .symbol.symbol-xxl-40px.symbol-2by3 .symbol-label {
    height: 40px;
    width: 60px;
  }
  .symbol.symbol-xxl-40px.symbol-2by3 > img {
    height: 40px;
    width: 60px;
    max-width: none;
  }
  .symbol.symbol-xxl-45px > img {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xxl-45px .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xxl-45px.symbol-fixed .symbol-label {
    width: 45px;
    height: 45px;
  }
  .symbol.symbol-xxl-45px.symbol-fixed > img {
    width: 45px;
    height: 45px;
    max-width: none;
  }
  .symbol.symbol-xxl-45px.symbol-2by3 .symbol-label {
    height: 45px;
    width: 67.5px;
  }
  .symbol.symbol-xxl-45px.symbol-2by3 > img {
    height: 45px;
    width: 67.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-50px > img {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xxl-50px .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xxl-50px.symbol-fixed .symbol-label {
    width: 50px;
    height: 50px;
  }
  .symbol.symbol-xxl-50px.symbol-fixed > img {
    width: 50px;
    height: 50px;
    max-width: none;
  }
  .symbol.symbol-xxl-50px.symbol-2by3 .symbol-label {
    height: 50px;
    width: 75px;
  }
  .symbol.symbol-xxl-50px.symbol-2by3 > img {
    height: 50px;
    width: 75px;
    max-width: none;
  }
  .symbol.symbol-xxl-55px > img {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xxl-55px .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xxl-55px.symbol-fixed .symbol-label {
    width: 55px;
    height: 55px;
  }
  .symbol.symbol-xxl-55px.symbol-fixed > img {
    width: 55px;
    height: 55px;
    max-width: none;
  }
  .symbol.symbol-xxl-55px.symbol-2by3 .symbol-label {
    height: 55px;
    width: 82.5px;
  }
  .symbol.symbol-xxl-55px.symbol-2by3 > img {
    height: 55px;
    width: 82.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-60px > img {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xxl-60px .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xxl-60px.symbol-fixed .symbol-label {
    width: 60px;
    height: 60px;
  }
  .symbol.symbol-xxl-60px.symbol-fixed > img {
    width: 60px;
    height: 60px;
    max-width: none;
  }
  .symbol.symbol-xxl-60px.symbol-2by3 .symbol-label {
    height: 60px;
    width: 90px;
  }
  .symbol.symbol-xxl-60px.symbol-2by3 > img {
    height: 60px;
    width: 90px;
    max-width: none;
  }
  .symbol.symbol-xxl-65px > img {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xxl-65px .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xxl-65px.symbol-fixed .symbol-label {
    width: 65px;
    height: 65px;
  }
  .symbol.symbol-xxl-65px.symbol-fixed > img {
    width: 65px;
    height: 65px;
    max-width: none;
  }
  .symbol.symbol-xxl-65px.symbol-2by3 .symbol-label {
    height: 65px;
    width: 97.5px;
  }
  .symbol.symbol-xxl-65px.symbol-2by3 > img {
    height: 65px;
    width: 97.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-70px > img {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xxl-70px .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xxl-70px.symbol-fixed .symbol-label {
    width: 70px;
    height: 70px;
  }
  .symbol.symbol-xxl-70px.symbol-fixed > img {
    width: 70px;
    height: 70px;
    max-width: none;
  }
  .symbol.symbol-xxl-70px.symbol-2by3 .symbol-label {
    height: 70px;
    width: 105px;
  }
  .symbol.symbol-xxl-70px.symbol-2by3 > img {
    height: 70px;
    width: 105px;
    max-width: none;
  }
  .symbol.symbol-xxl-75px > img {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xxl-75px .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xxl-75px.symbol-fixed .symbol-label {
    width: 75px;
    height: 75px;
  }
  .symbol.symbol-xxl-75px.symbol-fixed > img {
    width: 75px;
    height: 75px;
    max-width: none;
  }
  .symbol.symbol-xxl-75px.symbol-2by3 .symbol-label {
    height: 75px;
    width: 112.5px;
  }
  .symbol.symbol-xxl-75px.symbol-2by3 > img {
    height: 75px;
    width: 112.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-90px > img {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xxl-90px .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xxl-90px.symbol-fixed .symbol-label {
    width: 90px;
    height: 90px;
  }
  .symbol.symbol-xxl-90px.symbol-fixed > img {
    width: 90px;
    height: 90px;
    max-width: none;
  }
  .symbol.symbol-xxl-90px.symbol-2by3 .symbol-label {
    height: 90px;
    width: 135px;
  }
  .symbol.symbol-xxl-90px.symbol-2by3 > img {
    height: 90px;
    width: 135px;
    max-width: none;
  }
  .symbol.symbol-xxl-100px > img {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xxl-100px .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xxl-100px.symbol-fixed .symbol-label {
    width: 100px;
    height: 100px;
  }
  .symbol.symbol-xxl-100px.symbol-fixed > img {
    width: 100px;
    height: 100px;
    max-width: none;
  }
  .symbol.symbol-xxl-100px.symbol-2by3 .symbol-label {
    height: 100px;
    width: 150px;
  }
  .symbol.symbol-xxl-100px.symbol-2by3 > img {
    height: 100px;
    width: 150px;
    max-width: none;
  }
  .symbol.symbol-xxl-125px > img {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xxl-125px .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xxl-125px.symbol-fixed .symbol-label {
    width: 125px;
    height: 125px;
  }
  .symbol.symbol-xxl-125px.symbol-fixed > img {
    width: 125px;
    height: 125px;
    max-width: none;
  }
  .symbol.symbol-xxl-125px.symbol-2by3 .symbol-label {
    height: 125px;
    width: 187.5px;
  }
  .symbol.symbol-xxl-125px.symbol-2by3 > img {
    height: 125px;
    width: 187.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-150px > img {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xxl-150px .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xxl-150px.symbol-fixed .symbol-label {
    width: 150px;
    height: 150px;
  }
  .symbol.symbol-xxl-150px.symbol-fixed > img {
    width: 150px;
    height: 150px;
    max-width: none;
  }
  .symbol.symbol-xxl-150px.symbol-2by3 .symbol-label {
    height: 150px;
    width: 225px;
  }
  .symbol.symbol-xxl-150px.symbol-2by3 > img {
    height: 150px;
    width: 225px;
    max-width: none;
  }
  .symbol.symbol-xxl-160px > img {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xxl-160px .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xxl-160px.symbol-fixed .symbol-label {
    width: 160px;
    height: 160px;
  }
  .symbol.symbol-xxl-160px.symbol-fixed > img {
    width: 160px;
    height: 160px;
    max-width: none;
  }
  .symbol.symbol-xxl-160px.symbol-2by3 .symbol-label {
    height: 160px;
    width: 240px;
  }
  .symbol.symbol-xxl-160px.symbol-2by3 > img {
    height: 160px;
    width: 240px;
    max-width: none;
  }
  .symbol.symbol-xxl-175px > img {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xxl-175px .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xxl-175px.symbol-fixed .symbol-label {
    width: 175px;
    height: 175px;
  }
  .symbol.symbol-xxl-175px.symbol-fixed > img {
    width: 175px;
    height: 175px;
    max-width: none;
  }
  .symbol.symbol-xxl-175px.symbol-2by3 .symbol-label {
    height: 175px;
    width: 262.5px;
  }
  .symbol.symbol-xxl-175px.symbol-2by3 > img {
    height: 175px;
    width: 262.5px;
    max-width: none;
  }
  .symbol.symbol-xxl-200px > img {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xxl-200px .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xxl-200px.symbol-fixed .symbol-label {
    width: 200px;
    height: 200px;
  }
  .symbol.symbol-xxl-200px.symbol-fixed > img {
    width: 200px;
    height: 200px;
    max-width: none;
  }
  .symbol.symbol-xxl-200px.symbol-2by3 .symbol-label {
    height: 200px;
    width: 300px;
  }
  .symbol.symbol-xxl-200px.symbol-2by3 > img {
    height: 200px;
    width: 300px;
    max-width: none;
  }
}

.symbol-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-left: 10px;
}
.symbol-group .symbol {
  position: relative;
  z-index: 0;
  margin-left: -10px;
  transition: all 0.3s ease;
}
.symbol-group .symbol:hover {
  transition: all 0.3s ease;
  z-index: 1;
}
.symbol-group .symbol-badge {
  border: 2px solid var(--kt-body-bg);
}
.symbol-group .symbol-label {
  position: relative;
}
.symbol-group .symbol-label:after {
  display: block;
  content: " ";
  border-radius: inherit;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  border: 2px solid var(--kt-symbol-border-color);
  /* for Safari */
  background-clip: padding-box;
  /* for IE9+, Firefox 4+, Opera, Chrome */
}
.symbol-group.symbol-hover .symbol {
  cursor: pointer;
}

.pulse {
  position: relative;
}
.pulse.pulse-white .pulse-ring {
  border-color: #ffffff;
}
.pulse.pulse-light .pulse-ring {
  border-color: #f5f8fa;
}
.pulse.pulse-primary .pulse-ring {
  border-color: #009ef7;
}
.pulse.pulse-secondary .pulse-ring {
  border-color: #E4E6EF;
}
.pulse.pulse-success .pulse-ring {
  border-color: #50cd89;
}
.pulse.pulse-info .pulse-ring {
  border-color: #7239ea;
}
.pulse.pulse-warning .pulse-ring {
  border-color: #ffc700;
}
.pulse.pulse-danger .pulse-ring {
  border-color: #f1416c;
}
.pulse.pulse-dark .pulse-ring {
  border-color: #181C32;
}

.pulse-ring {
  display: block;
  border-radius: 40px;
  height: 40px;
  width: 40px;
  position: absolute;
  animation: animation-pulse 3.5s ease-out;
  animation-iteration-count: infinite;
  opacity: 0;
  border-width: 3px;
  border-style: solid;
  border-color: var(--kt-gray-500);
}

@keyframes animation-pulse {
  0% {
    -webkit-transform: scale(0.1, 0.1);
    opacity: 0;
  }
  60% {
    -webkit-transform: scale(0.1, 0.1);
    opacity: 0;
  }
  65% {
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1.2, 1.2);
    opacity: 0;
  }
}
[data-kt-app-page-loading=on] *,
.page-loading * {
  transition: none !important;
}

.page-loader {
  background: var(--kt-body-bg);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  display: none;
}
[data-kt-app-page-loading=on] .page-loader, .page-loading .page-loader {
  display: flex;
  justify-content: center;
  align-items: center;
}

.scrolltop {
  position: fixed;
  display: none;
  cursor: pointer;
  z-index: 105;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  bottom: 43px;
  right: 7px;
  background-color: var(--kt-scrolltop-bg-color);
  box-shadow: var(--kt-scrolltop-box-shadow);
  opacity: 0;
  transition: color 0.2s ease;
  border-radius: 0.475rem;
}
.scrolltop .svg-icon {
  color: var(--kt-scrolltop-icon-color);
}
.scrolltop .svg-icon svg {
  height: 24px;
  width: 24px;
}
.scrolltop > i {
  font-size: 1.3rem;
  color: var(--kt-scrolltop-icon-color);
}
.scrolltop:hover {
  background-color: var(--kt-scrolltop-bg-color-hover);
}
.scrolltop:hover .svg-icon,
.scrolltop:hover i {
  color: var(--kt-scrolltop-icon-color-hover);
}
[data-kt-scrolltop=on] .scrolltop {
  opacity: var(--kt-scrolltop-opacity-on);
  animation: animation-scrolltop 0.4s ease-out 1;
  display: flex;
}
[data-kt-scrolltop=on] .scrolltop:hover {
  transition: color 0.2s ease;
  opacity: var(--kt-scrolltop-opacity-hover);
}

@media (max-width: 991.98px) {
  .scrolltop {
    bottom: 23px;
    right: 5px;
    width: 30px;
    height: 30px;
  }
}
@keyframes animation-scrolltop {
  from {
    margin-bottom: -15px;
  }
  to {
    margin-bottom: 0;
  }
}
.svg-icon {
  line-height: 1;
  color: var(--kt-text-muted);
}
.svg-icon svg {
  height: 1.15rem;
  width: 1.15rem;
}
.svg-icon.svg-icon-white {
  color: var(--kt-text-white);
}
.svg-icon.svg-icon-primary {
  color: var(--kt-text-primary);
}
.svg-icon.svg-icon-secondary {
  color: var(--kt-text-secondary);
}
.svg-icon.svg-icon-light {
  color: var(--kt-text-light);
}
.svg-icon.svg-icon-success {
  color: var(--kt-text-success);
}
.svg-icon.svg-icon-info {
  color: var(--kt-text-info);
}
.svg-icon.svg-icon-warning {
  color: var(--kt-text-warning);
}
.svg-icon.svg-icon-danger {
  color: var(--kt-text-danger);
}
.svg-icon.svg-icon-dark {
  color: var(--kt-text-dark);
}
.svg-icon.svg-icon-muted {
  color: var(--kt-text-muted);
}
.svg-icon.svg-icon-gray-100 {
  color: var(--kt-text-gray-100);
}
.svg-icon.svg-icon-gray-200 {
  color: var(--kt-text-gray-200);
}
.svg-icon.svg-icon-gray-300 {
  color: var(--kt-text-gray-300);
}
.svg-icon.svg-icon-gray-400 {
  color: var(--kt-text-gray-400);
}
.svg-icon.svg-icon-gray-500 {
  color: var(--kt-text-gray-500);
}
.svg-icon.svg-icon-gray-600 {
  color: var(--kt-text-gray-600);
}
.svg-icon.svg-icon-gray-700 {
  color: var(--kt-text-gray-700);
}
.svg-icon.svg-icon-gray-800 {
  color: var(--kt-text-gray-800);
}
.svg-icon.svg-icon-gray-900 {
  color: var(--kt-text-gray-900);
}
.svg-icon.svg-icon-1 svg {
  height: 1.75rem !important;
  width: 1.75rem !important;
}
.svg-icon.svg-icon-2 svg {
  height: 1.5rem !important;
  width: 1.5rem !important;
}
.svg-icon.svg-icon-3 svg {
  height: 1.35rem !important;
  width: 1.35rem !important;
}
.svg-icon.svg-icon-4 svg {
  height: 1.25rem !important;
  width: 1.25rem !important;
}
.svg-icon.svg-icon-5 svg {
  height: 1.15rem !important;
  width: 1.15rem !important;
}
.svg-icon.svg-icon-6 svg {
  height: 1.075rem !important;
  width: 1.075rem !important;
}
.svg-icon.svg-icon-7 svg {
  height: 0.95rem !important;
  width: 0.95rem !important;
}
.svg-icon.svg-icon-8 svg {
  height: 0.85rem !important;
  width: 0.85rem !important;
}
.svg-icon.svg-icon-9 svg {
  height: 0.75rem !important;
  width: 0.75rem !important;
}
.svg-icon.svg-icon-10 svg {
  height: 0.5rem !important;
  width: 0.5rem !important;
}
.svg-icon.svg-icon-base svg {
  height: 1rem !important;
  width: 1rem !important;
}
.svg-icon.svg-icon-fluid svg {
  height: 100% !important;
  width: 100% !important;
}
.svg-icon.svg-icon-2x svg {
  height: 2rem !important;
  width: 2rem !important;
}
.svg-icon.svg-icon-2qx svg {
  height: 2.25rem !important;
  width: 2.25rem !important;
}
.svg-icon.svg-icon-2hx svg {
  height: 2.5rem !important;
  width: 2.5rem !important;
}
.svg-icon.svg-icon-2tx svg {
  height: 2.75rem !important;
  width: 2.75rem !important;
}
.svg-icon.svg-icon-3x svg {
  height: 3rem !important;
  width: 3rem !important;
}
.svg-icon.svg-icon-3qx svg {
  height: 3.25rem !important;
  width: 3.25rem !important;
}
.svg-icon.svg-icon-3hx svg {
  height: 3.5rem !important;
  width: 3.5rem !important;
}
.svg-icon.svg-icon-3tx svg {
  height: 3.75rem !important;
  width: 3.75rem !important;
}
.svg-icon.svg-icon-4x svg {
  height: 4rem !important;
  width: 4rem !important;
}
.svg-icon.svg-icon-4qx svg {
  height: 4.25rem !important;
  width: 4.25rem !important;
}
.svg-icon.svg-icon-4hx svg {
  height: 4.5rem !important;
  width: 4.5rem !important;
}
.svg-icon.svg-icon-4tx svg {
  height: 4.75rem !important;
  width: 4.75rem !important;
}
.svg-icon.svg-icon-5x svg {
  height: 5rem !important;
  width: 5rem !important;
}
.svg-icon.svg-icon-5qx svg {
  height: 5.25rem !important;
  width: 5.25rem !important;
}
.svg-icon.svg-icon-5hx svg {
  height: 5.5rem !important;
  width: 5.5rem !important;
}
.svg-icon.svg-icon-5tx svg {
  height: 5.75rem !important;
  width: 5.75rem !important;
}
@media (min-width: 576px) {
  .svg-icon.svg-icon-sm-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-sm-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-sm-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-sm-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-sm-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-sm-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-sm-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-sm-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-sm-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-sm-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-sm-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-sm-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-sm-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-sm-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-sm-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-sm-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-sm-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-sm-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-sm-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-sm-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-sm-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-sm-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-sm-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-sm-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-sm-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-sm-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-sm-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-sm-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
}
@media (min-width: 768px) {
  .svg-icon.svg-icon-md-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-md-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-md-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-md-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-md-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-md-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-md-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-md-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-md-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-md-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-md-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-md-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-md-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-md-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-md-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-md-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-md-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-md-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-md-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-md-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-md-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-md-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-md-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-md-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-md-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-md-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-md-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-md-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
}
@media (min-width: 992px) {
  .svg-icon.svg-icon-lg-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-lg-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-lg-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-lg-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-lg-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-lg-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-lg-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-lg-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-lg-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-lg-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-lg-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-lg-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-lg-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-lg-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-lg-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-lg-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-lg-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-lg-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-lg-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-lg-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-lg-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-lg-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-lg-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-lg-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-lg-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-lg-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-lg-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-lg-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
}
@media (min-width: 1200px) {
  .svg-icon.svg-icon-xl-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-xl-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-xl-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-xl-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-xl-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-xl-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-xl-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-xl-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-xl-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-xl-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-xl-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-xl-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-xl-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-xl-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-xl-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-xl-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-xl-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-xl-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-xl-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-xl-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-xl-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-xl-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-xl-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-xl-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-xl-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-xl-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-xl-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-xl-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
}
@media (min-width: 1400px) {
  .svg-icon.svg-icon-xxl-1 svg {
    height: 1.75rem !important;
    width: 1.75rem !important;
  }
  .svg-icon.svg-icon-xxl-2 svg {
    height: 1.5rem !important;
    width: 1.5rem !important;
  }
  .svg-icon.svg-icon-xxl-3 svg {
    height: 1.35rem !important;
    width: 1.35rem !important;
  }
  .svg-icon.svg-icon-xxl-4 svg {
    height: 1.25rem !important;
    width: 1.25rem !important;
  }
  .svg-icon.svg-icon-xxl-5 svg {
    height: 1.15rem !important;
    width: 1.15rem !important;
  }
  .svg-icon.svg-icon-xxl-6 svg {
    height: 1.075rem !important;
    width: 1.075rem !important;
  }
  .svg-icon.svg-icon-xxl-7 svg {
    height: 0.95rem !important;
    width: 0.95rem !important;
  }
  .svg-icon.svg-icon-xxl-8 svg {
    height: 0.85rem !important;
    width: 0.85rem !important;
  }
  .svg-icon.svg-icon-xxl-9 svg {
    height: 0.75rem !important;
    width: 0.75rem !important;
  }
  .svg-icon.svg-icon-xxl-10 svg {
    height: 0.5rem !important;
    width: 0.5rem !important;
  }
  .svg-icon.svg-icon-xxl-base svg {
    height: 1rem !important;
    width: 1rem !important;
  }
  .svg-icon.svg-icon-xxl-fluid svg {
    height: 100% !important;
    width: 100% !important;
  }
  .svg-icon.svg-icon-xxl-2x svg {
    height: 2rem !important;
    width: 2rem !important;
  }
  .svg-icon.svg-icon-xxl-2qx svg {
    height: 2.25rem !important;
    width: 2.25rem !important;
  }
  .svg-icon.svg-icon-xxl-2hx svg {
    height: 2.5rem !important;
    width: 2.5rem !important;
  }
  .svg-icon.svg-icon-xxl-2tx svg {
    height: 2.75rem !important;
    width: 2.75rem !important;
  }
  .svg-icon.svg-icon-xxl-3x svg {
    height: 3rem !important;
    width: 3rem !important;
  }
  .svg-icon.svg-icon-xxl-3qx svg {
    height: 3.25rem !important;
    width: 3.25rem !important;
  }
  .svg-icon.svg-icon-xxl-3hx svg {
    height: 3.5rem !important;
    width: 3.5rem !important;
  }
  .svg-icon.svg-icon-xxl-3tx svg {
    height: 3.75rem !important;
    width: 3.75rem !important;
  }
  .svg-icon.svg-icon-xxl-4x svg {
    height: 4rem !important;
    width: 4rem !important;
  }
  .svg-icon.svg-icon-xxl-4qx svg {
    height: 4.25rem !important;
    width: 4.25rem !important;
  }
  .svg-icon.svg-icon-xxl-4hx svg {
    height: 4.5rem !important;
    width: 4.5rem !important;
  }
  .svg-icon.svg-icon-xxl-4tx svg {
    height: 4.75rem !important;
    width: 4.75rem !important;
  }
  .svg-icon.svg-icon-xxl-5x svg {
    height: 5rem !important;
    width: 5rem !important;
  }
  .svg-icon.svg-icon-xxl-5qx svg {
    height: 5.25rem !important;
    width: 5.25rem !important;
  }
  .svg-icon.svg-icon-xxl-5hx svg {
    height: 5.5rem !important;
    width: 5.5rem !important;
  }
  .svg-icon.svg-icon-xxl-5tx svg {
    height: 5.75rem !important;
    width: 5.75rem !important;
  }
}

.fixed-top {
  position: fixed;
  z-index: 101;
  top: 0;
  left: 0;
  right: 0;
}

@media (min-width: 576px) {
  .fixed-top-sm {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
@media (min-width: 768px) {
  .fixed-top-md {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
@media (min-width: 992px) {
  .fixed-top-lg {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
@media (min-width: 1200px) {
  .fixed-top-xl {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
@media (min-width: 1400px) {
  .fixed-top-xxl {
    position: fixed;
    z-index: 101;
    top: 0;
    left: 0;
    right: 0;
  }
}
.timeline .timeline-item {
  position: relative;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: flex-start;
}
.timeline .timeline-item:last-child .timeline-line {
  bottom: 100%;
}
.timeline .timeline-line {
  display: block;
  content: " ";
  justify-content: center;
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
  bottom: 0;
  transform: translate(50%);
  border-left-width: 1px;
  border-left-style: dashed;
  border-left-color: var(--kt-gray-300);
}
.timeline .timeline-icon {
  z-index: 1;
  flex-shrink: 0;
  margin-right: 1rem;
}
.timeline .timeline-content {
  width: 100%;
  overflow: auto;
  margin-bottom: 1.5rem;
}
.timeline.timeline-center .timeline-item {
  align-items: center;
}
.timeline.timeline-center .timeline-item:first-child .timeline-line {
  top: 50%;
}
.timeline.timeline-center .timeline-item:last-child .timeline-line {
  bottom: 50%;
}

.timeline-label {
  position: relative;
}
.timeline-label:before {
  content: "";
  position: absolute;
  left: 51px;
  width: 3px;
  top: 0;
  bottom: 0;
  background-color: var(--kt-gray-200);
}
.timeline-label .timeline-item {
  display: flex;
  align-items: flex-start;
  position: relative;
  margin-bottom: 1.7rem;
}
.timeline-label .timeline-item:last-child {
  margin-bottom: 0;
}
.timeline-label .timeline-label {
  width: 50px;
  flex-shrink: 0;
  position: relative;
  color: var(--kt-gray-800);
}
.timeline-label .timeline-badge {
  flex-shrink: 0;
  background-color: var(--kt-body-bg);
  width: 1rem;
  height: 1rem;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  position: relative;
  margin-top: 1px;
  margin-left: -0.5rem;
  padding: 3px !important;
  border: 6px solid var(--kt-body-bg) !important;
}
.timeline-label .timeline-badge span {
  display: block;
  border-radius: 100%;
  width: 6px;
  height: 6px;
  background-color: var(--kt-gray-200);
}
.timeline-label .timeline-content {
  flex-grow: 1;
}

.overlay {
  position: relative;
}
.overlay .overlay-layer {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--kt-overlay-bg);
  transition: all 0.3s ease;
  opacity: 0;
}
.overlay.overlay-show .overlay-layer, .overlay.overlay-block .overlay-layer, .overlay:hover .overlay-layer {
  transition: all 0.3s ease;
  opacity: 1;
}
.overlay.overlay-block {
  cursor: wait;
}

.bullet {
  display: inline-block;
  background-color: var(--kt-bullet-bg-color);
  border-radius: 6px;
  width: 8px;
  height: 4px;
  flex-shrink: 0;
}

.bullet-dot {
  width: 4px;
  height: 4px;
  border-radius: 100% !important;
}

.bullet-vertical {
  width: 4px;
  height: 8px;
}

.bullet-line {
  width: 5px;
  height: 1px;
  border-radius: 0;
}

.drawer {
  display: flex !important;
  overflow: auto;
  z-index: 110;
  position: fixed;
  top: 0;
  bottom: 0;
  background-color: var(--kt-drawer-bg-color);
  transition: transform 0.3s ease-in-out !important;
}
.drawer.drawer-start {
  left: 0;
  transform: translateX(-100%);
}
.drawer.drawer-end {
  right: 0;
  transform: translateX(100%);
}
.drawer.drawer-on {
  transform: none;
  box-shadow: var(--kt-drawer-box-shadow);
  transition: transform 0.3s ease-in-out !important;
}

.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  z-index: 109;
  background-color: var(--kt-drawer-overlay-bg-color);
  animation: animation-drawer-fade-in 0.3s ease-in-out 1;
}

[data-kt-drawer=true] {
  display: none;
}

@keyframes animation-drawer-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media (max-width: 991.98px) {
  body[data-kt-drawer=on] {
    overflow: hidden;
  }
}
.badge {
  --bs-badge-color: var(--kt-badge-color);
  display: inline-flex;
  align-items: center;
}
.badge.badge-circle, .badge.badge-square {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 1.75rem;
  min-width: 1.75rem;
  padding: 0 0.1rem;
  line-height: 0;
}
.badge.badge-circle {
  border-radius: 50%;
  padding: 0;
  min-width: unset;
  width: 1.75rem;
}
.badge.badge-sm {
  min-width: 1.5rem;
  font-size: 0.8rem;
}
.badge.badge-sm.badge-square {
  height: 1.5rem;
}
.badge.badge-sm.badge-circle {
  width: 1.5rem;
  height: 1.5rem;
}
.badge.badge-lg {
  min-width: 2rem;
  font-size: 1rem;
}
.badge.badge-lg.badge-square {
  height: 2rem;
}
.badge.badge-lg.badge-circle {
  width: 2rem;
  height: 2rem;
}

.badge-white {
  color: var(--kt-white-inverse);
  background-color: var(--kt-white);
}
.badge-white.badge-outline {
  border: 1px solid var(--kt-white);
  color: var(--kt-white);
  background-color: transparent;
}

.badge-light-white {
  color: var(--kt-white);
  background-color: var(--kt-white-light);
}

.badge-light {
  color: var(--kt-light-inverse);
  background-color: var(--kt-light);
}
.badge-light.badge-outline {
  border: 1px solid var(--kt-light);
  color: var(--kt-light);
  background-color: transparent;
}

.badge-light-light {
  color: var(--kt-light);
  background-color: var(--kt-light-light);
}

.badge-primary {
  color: var(--kt-primary-inverse);
  background-color: var(--kt-primary);
}
.badge-primary.badge-outline {
  border: 1px solid var(--kt-primary);
  color: var(--kt-primary);
  background-color: transparent;
}

.badge-light-primary {
  color: var(--kt-primary);
  background-color: var(--kt-primary-light);
}

.badge-secondary {
  color: var(--kt-secondary-inverse);
  background-color: var(--kt-secondary);
}
.badge-secondary.badge-outline {
  border: 1px solid var(--kt-secondary);
  color: var(--kt-secondary);
  background-color: transparent;
}

.badge-light-secondary {
  color: var(--kt-secondary);
  background-color: var(--kt-secondary-light);
}

.badge-success {
  color: var(--kt-success-inverse);
  background-color: var(--kt-success);
}
.badge-success.badge-outline {
  border: 1px solid var(--kt-success);
  color: var(--kt-success);
  background-color: transparent;
}

.badge-light-success {
  color: var(--kt-success);
  background-color: var(--kt-success-light);
}

.badge-info {
  color: var(--kt-info-inverse);
  background-color: var(--kt-info);
}
.badge-info.badge-outline {
  border: 1px solid var(--kt-info);
  color: var(--kt-info);
  background-color: transparent;
}

.badge-light-info {
  color: var(--kt-info);
  background-color: var(--kt-info-light);
}

.badge-warning {
  color: var(--kt-warning-inverse);
  background-color: var(--kt-warning);
}
.badge-warning.badge-outline {
  border: 1px solid var(--kt-warning);
  color: var(--kt-warning);
  background-color: transparent;
}

.badge-light-warning {
  color: var(--kt-warning);
  background-color: var(--kt-warning-light);
}

.badge-danger {
  color: var(--kt-danger-inverse);
  background-color: var(--kt-danger);
}
.badge-danger.badge-outline {
  border: 1px solid var(--kt-danger);
  color: var(--kt-danger);
  background-color: transparent;
}

.badge-light-danger {
  color: var(--kt-danger);
  background-color: var(--kt-danger-light);
}

.badge-dark {
  color: var(--kt-dark-inverse);
  background-color: var(--kt-dark);
}
.badge-dark.badge-outline {
  border: 1px solid var(--kt-dark);
  color: var(--kt-dark);
  background-color: transparent;
}

.badge-light-dark {
  color: var(--kt-dark);
  background-color: var(--kt-dark-light);
}

.indicator-progress {
  display: none;
}
[data-kt-indicator=on] > .indicator-progress {
  display: inline-block;
}

[data-kt-indicator=on] > .indicator-label {
  display: none;
}

.hover-elevate-up {
  transition: transform 0.3s ease;
}
.hover-elevate-up:hover {
  transform: translateY(-5%);
  transition: transform 0.3s ease;
}

.hover-elevate-down {
  transition: transform 0.3s ease;
}
.hover-elevate-down:hover {
  transform: translateY(5%);
  transition: transform 0.3s ease;
}

.hover-scale {
  transition: transform 0.3s ease;
}
.hover-scale:hover {
  transform: scale(1.1);
  transition: transform 0.3s ease;
}

.hover-rotate-end {
  transition: transform 0.3s ease;
}
.hover-rotate-end:hover {
  transform: rotate(4deg);
  transition: transform 0.3s ease;
}

.hover-rotate-start {
  transition: transform 0.3s ease;
}
.hover-rotate-start:hover {
  transform: rotate(-4deg);
  transition: transform 0.3s ease;
}

.rotate {
  display: inline-flex;
  align-items: center;
}

.rotate-90 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}
.collapsible:not(.collapsed) > .rotate-90, .show > .rotate-90, .active > .rotate-90 {
  transform: rotateZ(90deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-90, [direction=rtl] .show > .rotate-90, [direction=rtl] .active > .rotate-90 {
  transform: rotateZ(-90deg);
}

.rotate-n90 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}
.collapsible:not(.collapsed) > .rotate-n90, .show > .rotate-n90, .active > .rotate-n90 {
  transform: rotateZ(-90deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-n90, [direction=rtl] .show > .rotate-n90, [direction=rtl] .active > .rotate-n90 {
  transform: rotateZ(90deg);
}

.rotate-180 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}
.collapsible:not(.collapsed) > .rotate-180, .show > .rotate-180, .active > .rotate-180 {
  transform: rotateZ(180deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-180, [direction=rtl] .show > .rotate-180, [direction=rtl] .active > .rotate-180 {
  transform: rotateZ(-180deg);
}

.rotate-n180 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}
.collapsible:not(.collapsed) > .rotate-n180, .show > .rotate-n180, .active > .rotate-n180 {
  transform: rotateZ(-180deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-n180, [direction=rtl] .show > .rotate-n180, [direction=rtl] .active > .rotate-n180 {
  transform: rotateZ(180deg);
}

.rotate-270 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}
.collapsible:not(.collapsed) > .rotate-270, .show > .rotate-270, .active > .rotate-270 {
  transform: rotateZ(270deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-270, [direction=rtl] .show > .rotate-270, [direction=rtl] .active > .rotate-270 {
  transform: rotateZ(-270deg);
}

.rotate-n270 {
  transition: transform 0.3s ease;
  backface-visibility: hidden;
  will-change: transform;
}
.collapsible:not(.collapsed) > .rotate-n270, .show > .rotate-n270, .active > .rotate-n270 {
  transform: rotateZ(-270deg);
  transition: transform 0.3s ease;
}
[direction=rtl] .collapsible:not(.collapsed) > .rotate-n270, [direction=rtl] .show > .rotate-n270, [direction=rtl] .active > .rotate-n270 {
  transform: rotateZ(270deg);
}

@media (min-width: 992px) {
  main,
span,
ol,
ul,
pre,
div {
    scrollbar-width: thin;
    scrollbar-color: var(--kt-scrollbar-color) transparent;
  }
  main::-webkit-scrollbar,
span::-webkit-scrollbar,
ol::-webkit-scrollbar,
ul::-webkit-scrollbar,
pre::-webkit-scrollbar,
div::-webkit-scrollbar {
    width: var(--kt-scrollbar-width);
    height: var(--kt-scrollbar-height);
  }
  main ::-webkit-scrollbar-track,
span ::-webkit-scrollbar-track,
ol ::-webkit-scrollbar-track,
ul ::-webkit-scrollbar-track,
pre ::-webkit-scrollbar-track,
div ::-webkit-scrollbar-track {
    border-radius: 0.5rem;
  }
  main ::-webkit-scrollbar-thumb,
span ::-webkit-scrollbar-thumb,
ol ::-webkit-scrollbar-thumb,
ul ::-webkit-scrollbar-thumb,
pre ::-webkit-scrollbar-thumb,
div ::-webkit-scrollbar-thumb {
    border-radius: 0.5rem;
  }
  main::-webkit-scrollbar-thumb,
span::-webkit-scrollbar-thumb,
ol::-webkit-scrollbar-thumb,
ul::-webkit-scrollbar-thumb,
pre::-webkit-scrollbar-thumb,
div::-webkit-scrollbar-thumb {
    background-color: var(--kt-scrollbar-color);
  }
  main::-webkit-scrollbar-corner,
span::-webkit-scrollbar-corner,
ol::-webkit-scrollbar-corner,
ul::-webkit-scrollbar-corner,
pre::-webkit-scrollbar-corner,
div::-webkit-scrollbar-corner {
    background-color: transparent;
  }
  main:hover,
span:hover,
ol:hover,
ul:hover,
pre:hover,
div:hover {
    scrollbar-color: var(--kt-scrollbar-hover-color) transparent;
  }
  main:hover::-webkit-scrollbar-thumb,
span:hover::-webkit-scrollbar-thumb,
ol:hover::-webkit-scrollbar-thumb,
ul:hover::-webkit-scrollbar-thumb,
pre:hover::-webkit-scrollbar-thumb,
div:hover::-webkit-scrollbar-thumb {
    background-color: var(--kt-scrollbar-hover-color);
  }
  main:hover::-webkit-scrollbar-corner,
span:hover::-webkit-scrollbar-corner,
ol:hover::-webkit-scrollbar-corner,
ul:hover::-webkit-scrollbar-corner,
pre:hover::-webkit-scrollbar-corner,
div:hover::-webkit-scrollbar-corner {
    background-color: transparent;
  }
}
.scroll {
  overflow: scroll;
  position: relative;
}
@media (max-width: 991.98px) {
  .scroll {
    overflow: auto;
  }
}

.scroll-x {
  overflow-x: scroll;
  position: relative;
}
@media (max-width: 991.98px) {
  .scroll-x {
    overflow-x: auto;
  }
}

.scroll-y {
  overflow-y: scroll;
  position: relative;
}
@media (max-width: 991.98px) {
  .scroll-y {
    overflow-y: auto;
  }
}

.hover-scroll {
  position: relative;
}
@media (min-width: 992px) {
  .hover-scroll {
    overflow: hidden;
    border-right: var(--kt-scrollbar-width) solid transparent;
    border-bottom: var(--kt-scrollbar-height) transparent;
    margin-right: calc(-1 * var(--kt-scrollbar-width));
    margin-bottom: calc(-1 * var(--kt-scrollbar-height));
  }
  .hover-scroll:hover {
    overflow: scroll;
    border-right: 0;
    border-bottom: 0;
  }
  @-moz-document url-prefix() {
    .hover-scroll {
      overflow: scroll;
      position: relative;
      border-right: 0;
      border-bottom: 0;
    }
  }
}
@media (max-width: 991.98px) {
  .hover-scroll {
    overflow: auto;
  }
}

.hover-scroll-y {
  position: relative;
}
@media (min-width: 992px) {
  .hover-scroll-y {
    overflow-y: hidden;
    border-right: var(--kt-scrollbar-width) solid transparent;
    margin-right: calc(-1 * var(--kt-scrollbar-width));
  }
  .hover-scroll-y:hover {
    overflow-y: scroll;
    border-right: 0;
  }
  @-moz-document url-prefix() {
    .hover-scroll-y {
      overflow-y: scroll;
      position: relative;
      border-right: 0;
    }
  }
}
@media (max-width: 991.98px) {
  .hover-scroll-y {
    overflow-y: auto;
  }
}

.hover-scroll-x {
  position: relative;
}
@media (min-width: 992px) {
  .hover-scroll-x {
    overflow-x: hidden;
    border-bottom: var(--kt-scrollbar-height) solid transparent;
  }
  .hover-scroll-x:hover {
    overflow-x: scroll;
    border-bottom: 0;
  }
  @-moz-document url-prefix() {
    .hover-scroll-x {
      overflow-x: scroll;
      position: relative;
      border-bottom: 0;
    }
  }
}
@media (max-width: 991.98px) {
  .hover-scroll-x {
    overflow-x: auto;
  }
}

.hover-scroll-overlay {
  position: relative;
}
@media (min-width: 992px) {
  .hover-scroll-overlay {
    overflow: hidden;
  }
  .hover-scroll-overlay::-webkit-scrollbar {
    width: calc(var(--kt-scrollbar-width) + var(--kt-scrollbar-width));
    height: calc(var(--kt-scrollbar-width) + var(--kt-scrollbar-width));
  }
  .hover-scroll-overlay::-webkit-scrollbar-track {
    border-radius: 0;
  }
  .hover-scroll-overlay::-webkit-scrollbar-thumb {
    border-radius: 0;
    background-clip: content-box;
    border-right: var(--kt-scrollbar-space) solid transparent;
    border-bottom: var(--kt-scrollbar-space) solid transparent;
  }
  .hover-scroll-overlay:hover {
    overflow: overlay;
  }
  @-moz-document url-prefix() {
    .hover-scroll-overlay {
      overflow: scroll;
      position: relative;
    }
  }
}
@media (max-width: 991.98px) {
  .hover-scroll-overlay {
    overflow: auto;
  }
}

.hover-scroll-overlay-y {
  position: relative;
}
@media (min-width: 992px) {
  .hover-scroll-overlay-y {
    overflow-y: hidden;
  }
  .hover-scroll-overlay-y::-webkit-scrollbar {
    width: calc(var(--kt-scrollbar-width) + var(--kt-scrollbar-space));
  }
  .hover-scroll-overlay-y::-webkit-scrollbar-track {
    border-radius: 0;
  }
  .hover-scroll-overlay-y::-webkit-scrollbar-thumb {
    border-radius: 0;
    background-clip: content-box;
    border-right: var(--kt-scrollbar-space) solid transparent;
  }
  .hover-scroll-overlay-y:hover {
    overflow-y: overlay;
  }
  @-moz-document url-prefix() {
    .hover-scroll-overlay-y {
      overflow-y: scroll;
      position: relative;
    }
  }
}
@media (max-width: 991.98px) {
  .hover-scroll-overlay-y {
    overflow-y: auto;
  }
}

.hover-scroll-overlay-x {
  position: relative;
}
@media (min-width: 992px) {
  .hover-scroll-overlay-x {
    overflow-x: hidden;
  }
  .hover-scroll-overlay-x::-webkit-scrollbar {
    height: calc(var(--kt-scrollbar-width) + var(--kt-scrollbar-space));
  }
  .hover-scroll-overlay-x::-webkit-scrollbar-track {
    border-radius: 0;
  }
  .hover-scroll-overlay-x::-webkit-scrollbar-thumb {
    border-radius: 0;
    background-clip: content-box;
    border-bottom: var(--kt-scrollbar-space) solid transparent;
  }
  .hover-scroll-overlay-x:hover {
    overflow-x: overlay;
  }
  @-moz-document url-prefix() {
    .hover-scroll-overlay-x {
      overflow-x: scroll;
      position: relative;
    }
  }
}
@media (max-width: 991.98px) {
  .hover-scroll-overlay-x {
    overflow-x: auto;
  }
}

.scroll-ps {
  padding-left: var(--kt-scrollbar-width) !important;
}

.scroll-ms {
  margin-left: var(--kt-scrollbar-width) !important;
}

.scroll-mb {
  margin-bottom: var(--kt-scrollbar-height) !important;
}

.scroll-pe {
  padding-right: var(--kt-scrollbar-width) !important;
}

.scroll-me {
  margin-right: var(--kt-scrollbar-width) !important;
}

.scroll-px {
  padding-left: var(--kt-scrollbar-width) !important;
  padding-right: var(--kt-scrollbar-width) !important;
}

.scroll-mx {
  margin-left: var(--kt-scrollbar-width) !important;
  margin-right: var(--kt-scrollbar-width) !important;
}

.rating {
  display: flex;
  align-items: center;
}

.rating-input {
  position: absolute !important;
  left: -9999px !important;
}
.rating-input[disabled] {
  display: none;
}

.rating-label {
  padding: 0;
  margin: 0;
}
.rating-label > i, .rating-label > .svg-icon {
  line-height: 1;
  color: var(--kt-rating-color-default);
}

label.rating-label {
  cursor: pointer;
}

div.rating-label.checked > i, div.rating-label.checked > .svg-icon,
label.rating-label > i,
label.rating-label > .svg-icon {
  color: var(--kt-rating-color-active);
}

.rating-input:checked ~ .rating-label > i, .rating-input:checked ~ .rating-label > .svg-icon {
  color: var(--kt-rating-color-default);
}

.rating:hover label.rating-label > i, .rating:hover label.rating-label > .svg-icon {
  color: var(--kt-rating-color-active);
}

label.rating-label:hover ~ .rating-label {
  color: var(--kt-rating-color-default);
}
label.rating-label:hover ~ .rating-label > i, label.rating-label:hover ~ .rating-label > .svg-icon {
  color: var(--kt-rating-color-default);
}

.stepper [data-kt-stepper-element=info],
.stepper [data-kt-stepper-element=content] {
  display: none;
}
.stepper [data-kt-stepper-element=info].current,
.stepper [data-kt-stepper-element=content].current {
  display: flex;
}
.stepper .stepper-item[data-kt-stepper-action=step] {
  cursor: pointer;
}
.stepper [data-kt-stepper-action=final] {
  display: none;
}
.stepper [data-kt-stepper-action=previous] {
  display: none;
}
.stepper [data-kt-stepper-action=next] {
  display: inline-block;
}
.stepper [data-kt-stepper-action=submit] {
  display: none;
}
.stepper.first [data-kt-stepper-action=previous] {
  display: none;
}
.stepper.first [data-kt-stepper-action=next] {
  display: inline-block;
}
.stepper.first [data-kt-stepper-action=submit] {
  display: none;
}
.stepper.between [data-kt-stepper-action=previous] {
  display: inline-block;
}
.stepper.between [data-kt-stepper-action=next] {
  display: inline-block;
}
.stepper.between [data-kt-stepper-action=submit] {
  display: none;
}
.stepper.last [data-kt-stepper-action=final] {
  display: inline-block;
}
.stepper.last [data-kt-stepper-action=final].btn-flex {
  display: flex;
}
.stepper.last [data-kt-stepper-action=previous] {
  display: inline-block;
}
.stepper.last [data-kt-stepper-action=previous].btn-flex {
  display: flex;
}
.stepper.last [data-kt-stepper-action=next] {
  display: none;
}
.stepper.last [data-kt-stepper-action=next].btn-flex {
  display: flex;
}
.stepper.last [data-kt-stepper-action=submit] {
  display: inline-block;
}
.stepper.last [data-kt-stepper-action=submit].btn-flex {
  display: flex;
}

.stepper.stepper-pills {
  --kt-stepper-pills-size: 40px;
  --kt-stepper-icon-border-radius: 9px;
  --kt-stepper-icon-check-size: 1rem;
  --kt-stepper-icon-bg-color: var(--kt-primary-light);
  --kt-stepper-icon-bg-color-current: var(--kt-primary);
  --kt-stepper-icon-bg-color-completed: var(--kt-primary-light);
  --kt-stepper-icon-border: 0;
  --kt-stepper-icon-border-current: 0;
  --kt-stepper-icon-border-completed: 0;
  --kt-stepper-icon-number-color: var(--kt-primary);
  --kt-stepper-icon-number-color-current: var(--kt-white);
  --kt-stepper-icon-check-color-completed: var(--kt-primary);
  --kt-stepper-label-title-opacity: 1;
  --kt-stepper-label-title-opacity-current: 1;
  --kt-stepper-label-title-opacity-completed: 1;
  --kt-stepper-label-title-color: var(--kt-gray-800);
  --kt-stepper-label-title-color-current: var(--kt-gray-600);
  --kt-stepper-label-title-color-completed: var(--kt-text-muted);
  --kt-stepper-label-desc-opacity: 1;
  --kt-stepper-label-desc-opacity-current: 1;
  --kt-stepper-label-desc-opacity-completed: 1;
  --kt-stepper-label-desc-color: var(--kt-text-muted);
  --kt-stepper-label-desc-color-current: var(--kt-text-400);
  --kt-stepper-label-desc-color-completed: var(--kt-gray-400);
  --kt-stepper-line-border: 1px dashed var(--kt-gray-300);
}
.stepper.stepper-pills .stepper-nav {
  display: flex;
}
.stepper.stepper-pills .stepper-item {
  display: flex;
  align-items: center;
  transition: color 0.2s ease;
}
.stepper.stepper-pills .stepper-item .stepper-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: color 0.2s ease;
  width: var(--kt-stepper-pills-size);
  height: var(--kt-stepper-pills-size);
  border-radius: var(--kt-stepper-icon-border-radius);
  background-color: var(--kt-stepper-icon-bg-color);
  border: var(--kt-stepper-icon-border);
  margin-right: 1.5rem;
}
.stepper.stepper-pills .stepper-item .stepper-icon .stepper-check {
  display: none;
  font-size: var(--kt-stepper-icon-check-size);
}
.stepper.stepper-pills .stepper-item .stepper-icon .stepper-number {
  font-weight: 600;
  color: var(--kt-stepper-icon-number-color);
  font-size: 1.25rem;
}
.stepper.stepper-pills .stepper-item .stepper-label {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.stepper.stepper-pills .stepper-item .stepper-label .stepper-title {
  color: var(--kt-stepper-label-title-color);
  opacity: var(--kt-stepper-label-title-opacity);
  font-weight: 600;
  font-size: 1.25rem;
  margin-bottom: 0.3rem;
}
.stepper.stepper-pills .stepper-item .stepper-label .stepper-desc {
  opacity: var(--kt-stepper-label-desc-opacity);
  color: var(--kt-stepper-label-desc-color);
}
.stepper.stepper-pills .stepper-item.current {
  transition: color 0.2s ease;
}
.stepper.stepper-pills .stepper-item.current .stepper-icon {
  transition: color 0.2s ease;
  background-color: var(--kt-stepper-icon-bg-color-current);
  border: var(--kt-stepper-icon-border-current);
}
.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-check {
  display: none;
}
.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-number {
  color: var(--kt-stepper-icon-number-color-current);
  font-size: 1.35rem;
}
.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-title {
  opacity: var(--kt-stepper-label-title-opacity-current);
  color: var(--kt-stepper-label-title-color-current);
}
.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-desc {
  opacity: var(--kt-stepper-label-desc-opacity-current);
  color: var(--kt-stepper-label-desc-color-current);
}
.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon, .stepper.stepper-pills .stepper-item.completed .stepper-icon {
  transition: color 0.2s ease;
  background-color: var(--kt-stepper-icon-bg-color-completed);
  border: var(--kt-stepper-icon-border-completed);
}
.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon .stepper-check, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-check {
  color: var(--kt-stepper-icon-check-color-completed);
  display: inline-block;
}
.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon .stepper-number, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-number {
  display: none;
}
.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-label .stepper-title, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-title {
  opacity: var(--kt-stepper-label-title-opacity-completed);
  color: var(--kt-stepper-label-title-color-completed);
}
.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-label .stepper-desc, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-desc {
  opacity: var(--kt-stepper-label-desc-opacity-completed);
  color: var(--kt-stepper-label-desc-color-completed);
}
.stepper.stepper-pills.stepper-column .stepper-nav {
  flex-direction: column;
  align-items: start;
}
.stepper.stepper-pills.stepper-column .stepper-item {
  flex-direction: column;
  justify-content: start;
  align-items: stretch;
  padding: 0;
  margin: 0;
}
.stepper.stepper-pills.stepper-column .stepper-wrapper {
  display: flex;
  align-items: center;
}
.stepper.stepper-pills.stepper-column .stepper-icon {
  z-index: 1;
}
.stepper.stepper-pills.stepper-column .stepper-line {
  display: block;
  flex-grow: 1;
  margin-left: calc(var(--kt-stepper-pills-size) / 2);
  border-left: var(--kt-stepper-line-border);
  margin-top: 2px;
  margin-bottom: 2px;
}

.stepper.stepper-links .stepper-nav {
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
.stepper.stepper-links .stepper-nav .stepper-item {
  position: relative;
  flex-shrink: 0;
  margin: 1rem 1.5rem;
}
.stepper.stepper-links .stepper-nav .stepper-item:after {
  content: " ";
  position: absolute;
  top: 2.3rem;
  left: 0;
  height: 2px;
  width: 100%;
  background-color: transparent;
  transition: color 0.2s ease;
}
.stepper.stepper-links .stepper-nav .stepper-item .stepper-title {
  color: var(--kt-dark);
  font-weight: 600;
  font-size: 1.25rem;
}
.stepper.stepper-links .stepper-nav .stepper-item.current {
  transition: color 0.2s ease;
}
.stepper.stepper-links .stepper-nav .stepper-item.current .stepper-title {
  color: var(--kt-primary);
}
.stepper.stepper-links .stepper-nav .stepper-item.current:after {
  background-color: var(--kt-primary);
}
.stepper.stepper-links .stepper-nav .stepper-item.current.mark-completed:last-child .stepper-title, .stepper.stepper-links .stepper-nav .stepper-item.completed .stepper-title {
  color: var(--kt-gray-400);
}

.toggle.collapsible:not(.collapsed) .toggle-off, .toggle.active .toggle-off {
  display: none;
}
.toggle.collapsible.collapsed .toggle-on, .toggle:not(.collapsible):not(.active) .toggle-on {
  display: none;
}

.xehagon {
  clip-path: polygon(45% 1.3397459622%, 46.5797985667% 0.6030737921%, 48.2635182233% 0.1519224699%, 50% 0%, 51.7364817767% 0.1519224699%, 53.4202014333% 0.6030737921%, 55% 1.3397459622%, 89.6410161514% 21.3397459622%, 91.0688922482% 22.3395555688%, 92.3014605826% 23.5721239031%, 93.3012701892% 25%, 94.0379423592% 26.5797985667%, 94.4890936815% 28.2635182233%, 94.6410161514% 30%, 94.6410161514% 70%, 94.4890936815% 71.7364817767%, 94.0379423592% 73.4202014333%, 93.3012701892% 75%, 92.3014605826% 76.4278760969%, 91.0688922482% 77.6604444312%, 89.6410161514% 78.6602540378%, 55% 98.6602540378%, 53.4202014333% 99.3969262079%, 51.7364817767% 99.8480775301%, 50% 100%, 48.2635182233% 99.8480775301%, 46.5797985667% 99.3969262079%, 45% 98.6602540378%, 10.3589838486% 78.6602540378%, 8.9311077518% 77.6604444312%, 7.6985394174% 76.4278760969%, 6.6987298108% 75%, 5.9620576408% 73.4202014333%, 5.5109063185% 71.7364817767%, 5.3589838486% 70%, 5.3589838486% 30%, 5.5109063185% 28.2635182233%, 5.9620576408% 26.5797985667%, 6.6987298108% 25%, 7.6985394174% 23.5721239031%, 8.9311077518% 22.3395555688%, 10.3589838486% 21.3397459622%);
}

.octagon {
  clip-path: polygon(46.1731656763% 0.7612046749%, 47.411809549% 0.3407417371%, 48.6947380778% 0.0855513863%, 50% 0%, 51.3052619222% 0.0855513863%, 52.588190451% 0.3407417371%, 53.8268343237% 0.7612046749%, 82.1111055711% 12.4769334274%, 83.2842712475% 13.0554747147%, 84.3718855375% 13.7821953496%, 85.3553390593% 14.6446609407%, 86.2178046504% 15.6281144625%, 86.9445252853% 16.7157287525%, 87.5230665726% 17.8888944289%, 99.2387953251% 46.1731656763%, 99.6592582629% 47.411809549%, 99.9144486137% 48.6947380778%, 100% 50%, 99.9144486137% 51.3052619222%, 99.6592582629% 52.588190451%, 99.2387953251% 53.8268343237%, 87.5230665726% 82.1111055711%, 86.9445252853% 83.2842712475%, 86.2178046504% 84.3718855375%, 85.3553390593% 85.3553390593%, 84.3718855375% 86.2178046504%, 83.2842712475% 86.9445252853%, 82.1111055711% 87.5230665726%, 53.8268343237% 99.2387953251%, 52.588190451% 99.6592582629%, 51.3052619222% 99.9144486137%, 50% 100%, 48.6947380778% 99.9144486137%, 47.411809549% 99.6592582629%, 46.1731656763% 99.2387953251%, 17.8888944289% 87.5230665726%, 16.7157287525% 86.9445252853%, 15.6281144625% 86.2178046504%, 14.6446609407% 85.3553390593%, 13.7821953496% 84.3718855375%, 13.0554747147% 83.2842712475%, 12.4769334274% 82.1111055711%, 0.7612046749% 53.8268343237%, 0.3407417371% 52.588190451%, 0.0855513863% 51.3052619222%, 0% 50%, 0.0855513863% 48.6947380778%, 0.3407417371% 47.411809549%, 0.7612046749% 46.1731656763%, 12.4769334274% 17.8888944289%, 13.0554747147% 16.7157287525%, 13.7821953496% 15.6281144625%, 14.6446609407% 14.6446609407%, 15.6281144625% 13.7821953496%, 16.7157287525% 13.0554747147%, 17.8888944289% 12.4769334274%);
}

.ribbon {
  position: relative;
}
.ribbon .ribbon-label {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  position: absolute;
  z-index: 1;
  background-color: var(--kt-ribbon-label-bg);
  box-shadow: var(--kt-ribbon-label-box-shadow);
  color: var(--kt-primary-inverse);
  top: 50%;
  right: 0;
  transform: translateX(5px) translateY(-50%);
}
.ribbon .ribbon-label > .ribbon-inner {
  z-index: -1;
  position: absolute;
  padding: 0;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.ribbon .ribbon-label:after {
  border-color: var(--kt-ribbon-label-border-color);
}
.ribbon-vertical .ribbon-label {
  padding: 5px 10px;
  min-width: 36px;
  min-height: 46px;
  text-align: center;
}
.ribbon.ribbon-top .ribbon-label {
  top: 0;
  transform: translateX(-15px) translateY(-4px);
  border-bottom-right-radius: 0.475rem;
  border-bottom-left-radius: 0.475rem;
}
.ribbon.ribbon-bottom .ribbon-label {
  border-top-right-radius: 0.475rem;
  border-top-left-radius: 0.475rem;
}
.ribbon.ribbon-start .ribbon-label {
  top: 50%;
  left: 0;
  right: auto;
  transform: translateX(-5px) translateY(-50%);
  border-top-right-radius: 0.475rem;
  border-bottom-right-radius: 0.475rem;
}
.ribbon.ribbon-end .ribbon-label {
  border-top-left-radius: 0.475rem;
  border-bottom-left-radius: 0.475rem;
}

.ribbon.ribbon-clip.ribbon-start .ribbon-label {
  left: -5px;
}
.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner {
  border-top-right-radius: 0.475rem;
  border-bottom-right-radius: 0.475rem;
}
.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:after {
  content: "";
  position: absolute;
  border-style: solid;
  border-color: transparent !important;
  bottom: -10px;
}
.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before {
  border-width: 0 10px 10px 0;
  border-right-color: var(--kt-ribbon-clip-bg) !important;
  left: 0;
}
.ribbon.ribbon-clip.ribbon-end .ribbon-label {
  right: -5px;
}
.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner {
  border-top-left-radius: 0.475rem;
  border-bottom-left-radius: 0.475rem;
}
.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:after {
  content: "";
  position: absolute;
  border-style: solid;
  border-color: transparent !important;
  bottom: -10px;
}
.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before {
  border-width: 0 0 10px 10px;
  border-left-color: var(--kt-ribbon-clip-bg) !important;
  right: 0;
}

.ribbon.ribbon-triangle {
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.ribbon.ribbon-triangle.ribbon-top-start {
  top: 0;
  left: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem transparent !important;
  border-left: solid 2rem transparent;
  border-right: solid 2rem transparent !important;
  border-top: solid 2rem transparent;
}
.ribbon.ribbon-triangle.ribbon-top-end {
  top: 0;
  right: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem transparent !important;
  border-left: solid 2rem transparent !important;
  border-right: solid 2rem transparent;
  border-top: solid 2rem transparent;
}
.ribbon.ribbon-triangle.ribbon-bottom-start {
  bottom: 0;
  left: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem transparent;
  border-left: solid 2rem transparent;
  border-right: solid 2rem transparent !important;
  border-top: solid 2rem transparent !important;
}
.ribbon.ribbon-triangle.ribbon-bottom-end {
  bottom: 0;
  right: 0;
  width: 4rem;
  height: 4rem;
  border-bottom: solid 2rem transparent;
  border-right: solid 2rem transparent;
  border-left: solid 2rem transparent !important;
  border-top: solid 2rem transparent !important;
}

.blockui {
  position: relative;
}
.blockui .blockui-overlay {
  transition: all 0.3s ease;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--kt-blockui-overlay-bg);
}
.blockui .blockui-overlay .spinner-border {
  height: 1.35rem;
  width: 1.35rem;
}
.blockui .blockui-message {
  display: flex;
  align-items: center;
  border-radius: 0.475rem;
  box-shadow: var(--kt-dropdown-box-shadow);
  background-color: var(--kt-tooltip-bg);
  color: var(--kt-gray-700);
  font-weight: 600;
  margin: 0 !important;
  width: auto;
  padding: 0.85rem 1.75rem !important;
}
.blockui .blockui-message .spinner-border {
  margin-right: 0.65rem;
}

.explore-btn-toggle {
  color: var(--kt-gray-600);
  background-color: #ffffff;
}
.explore-btn-toggle:hover, .explore-btn-toggle:focus, .explore-btn-toggle:active {
  color: #ffffff;
  background-color: #00B2FF;
}

.explore-btn-dismiss {
  border: 0;
}
.explore-btn-dismiss:hover i,
.explore-btn-dismiss:hover .svg-icon {
  color: #00B2FF;
}

.explore-btn-primary {
  border: 0;
  color: #ffffff;
  background-color: #00B2FF;
}
.explore-btn-primary:hover {
  color: #ffffff;
  background-color: #0098DA;
}

.explore-btn-secondary {
  border: 0;
  color: var(--kt-gray-600);
  background-color: var(--kt-gray-100);
}
.explore-btn-secondary:hover {
  color: var(--kt-gray-800);
  background-color: var(--kt-gray-200);
}

.explore-btn-outline {
  border: 1px dashed var(--kt-gray-300) !important;
}
.explore-btn-outline:hover, .explore-btn-outline.active {
  border: 1px dashed #50CD89 !important;
  background-color: #E8FFF3;
}

.explore-link {
  color: #00B2FF;
}
.explore-link:hover {
  color: #0098DA;
}

.explore-link-hover:hover {
  color: #00B2FF !important;
}

.explore-icon-success {
  color: #50CD89;
}

.explore-icon-danger {
  color: #F1416C;
}

.explore-label-free {
  color: #ffffff;
  background-color: #FFC700;
}

.explore-label-pro {
  color: #ffffff;
  background-color: #50CD89;
}

.engage-btn {
  display: flex;
  align-items: center;
  height: 35px !important;
  color: var(--kt-engage-btn-color);
  border-color: var(--kt-engage-btn-bg);
  background-color: var(--kt-engage-btn-bg);
}
.engage-btn i,
.engage-btn .svg-icon {
  color: var(--kt-engage-btn-color);
}
.engage-btn.dropdown-toggle:after {
  color: var(--kt-engage-btn-color);
}
.btn-check:checked + .engage-btn, .btn-check:active + .engage-btn, .engage-btn:focus:not(.btn-active), .engage-btn:hover:not(.btn-active), .engage-btn:active:not(.btn-active), .engage-btn.active, .engage-btn.show, .show > .engage-btn {
  color: var(--kt-engage-btn-color-active);
  border-color: var(--kt-engage-btn-bg);
  background-color: var(--kt-engage-btn-bg) !important;
}
.btn-check:checked + .engage-btn i,
.btn-check:checked + .engage-btn .svg-icon, .btn-check:active + .engage-btn i,
.btn-check:active + .engage-btn .svg-icon, .engage-btn:focus:not(.btn-active) i,
.engage-btn:focus:not(.btn-active) .svg-icon, .engage-btn:hover:not(.btn-active) i,
.engage-btn:hover:not(.btn-active) .svg-icon, .engage-btn:active:not(.btn-active) i,
.engage-btn:active:not(.btn-active) .svg-icon, .engage-btn.active i,
.engage-btn.active .svg-icon, .engage-btn.show i,
.engage-btn.show .svg-icon, .show > .engage-btn i,
.show > .engage-btn .svg-icon {
  color: var(--kt-engage-btn-color-active);
}
.btn-check:checked + .engage-btn.dropdown-toggle:after, .btn-check:active + .engage-btn.dropdown-toggle:after, .engage-btn:focus:not(.btn-active).dropdown-toggle:after, .engage-btn:hover:not(.btn-active).dropdown-toggle:after, .engage-btn:active:not(.btn-active).dropdown-toggle:after, .engage-btn.active.dropdown-toggle:after, .engage-btn.show.dropdown-toggle:after, .show > .engage-btn.dropdown-toggle:after {
  color: var(--kt-engage-btn-color-active);
}

.cookiealert {
  background: inherit;
  color: inherit;
}

@media print {
  .print-content-only {
    padding: 0 !important;
    background: none !important;
  }
  .print-content-only .wrapper,
.print-content-only .page,
.print-content-only .page-title .content,
.print-content-only .container,
.print-content-only .container-xxl,
.print-content-only .container-fluid,
.print-content-only .container-sm,
.print-content-only .container-md,
.print-content-only .container-lg,
.print-content-only .container-xl {
    background: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .print-content-only .aside,
.print-content-only .sidebar,
.print-content-only .scrolltop,
.print-content-only .header,
.print-content-only .footer,
.print-content-only .toolbar,
.print-content-only .drawer,
.print-content-only .btn {
    display: none !important;
  }
}
.bg-white {
  --kt-bg-rgb-color: var(--kt-white-bg-rgb);
  background-color: #000000 !important;
}

.bg-black {
  --kt-bg-rgb-color: var(--kt-black-bg-rgb);
  background-color: #000000 !important;
}

.bg-body {
  --kt-bg-rgb-color: var(--kt-body-bg-rgb);
  background-color: var(--kt-body-bg) !important;
}

.bg-hover-body {
  cursor: pointer;
}
.bg-hover-body:hover {
  background-color: var(--kt-body-bg) !important;
}

.bg-active-body.active {
  background-color: var(--kt-body-bg) !important;
}

.bg-state-body {
  cursor: pointer;
}
.bg-state-body.active, .bg-state-body:hover {
  background-color: var(--kt-body-bg) !important;
}

.bg-white {
  --kt-bg-rgb-color: var(--kt-white-rgb);
  background-color: var(--kt-white) !important;
}

.bg-hover-white {
  cursor: pointer;
}
.bg-hover-white:hover {
  background-color: var(--kt-white) !important;
}

.bg-active-white.active {
  background-color: var(--kt-white) !important;
}

.bg-state-white {
  cursor: pointer;
}
.bg-state-white.active, .bg-state-white:hover {
  background-color: var(--kt-white) !important;
}

.bg-light {
  --kt-bg-rgb-color: var(--kt-light-rgb);
  background-color: var(--kt-light) !important;
}

.bg-hover-light {
  cursor: pointer;
}
.bg-hover-light:hover {
  background-color: var(--kt-light) !important;
}

.bg-active-light.active {
  background-color: var(--kt-light) !important;
}

.bg-state-light {
  cursor: pointer;
}
.bg-state-light.active, .bg-state-light:hover {
  background-color: var(--kt-light) !important;
}

.bg-light-primary {
  background-color: var(--kt-primary-light) !important;
}

.bg-primary {
  --kt-bg-rgb-color: var(--kt-primary-rgb);
  background-color: var(--kt-primary) !important;
}

.bg-hover-light-primary {
  cursor: pointer;
}
.bg-hover-light-primary:hover {
  background-color: var(--kt-primary-light) !important;
}

.bg-state-light-primary {
  cursor: pointer;
}
.bg-state-light-primary.active, .bg-state-light-primary:hover {
  background-color: var(--kt-primary-light) !important;
}

.bg-hover-primary {
  cursor: pointer;
}
.bg-hover-primary:hover {
  background-color: var(--kt-primary) !important;
}

.bg-active-primary.active {
  background-color: var(--kt-primary) !important;
}

.bg-state-primary {
  cursor: pointer;
}
.bg-state-primary.active, .bg-state-primary:hover {
  background-color: var(--kt-primary) !important;
}

.bg-light-secondary {
  background-color: var(--kt-secondary-light) !important;
}

.bg-secondary {
  --kt-bg-rgb-color: var(--kt-secondary-rgb);
  background-color: var(--kt-secondary) !important;
}

.bg-hover-light-secondary {
  cursor: pointer;
}
.bg-hover-light-secondary:hover {
  background-color: var(--kt-secondary-light) !important;
}

.bg-state-light-secondary {
  cursor: pointer;
}
.bg-state-light-secondary.active, .bg-state-light-secondary:hover {
  background-color: var(--kt-secondary-light) !important;
}

.bg-hover-secondary {
  cursor: pointer;
}
.bg-hover-secondary:hover {
  background-color: var(--kt-secondary) !important;
}

.bg-active-secondary.active {
  background-color: var(--kt-secondary) !important;
}

.bg-state-secondary {
  cursor: pointer;
}
.bg-state-secondary.active, .bg-state-secondary:hover {
  background-color: var(--kt-secondary) !important;
}

.bg-light-success {
  background-color: var(--kt-success-light) !important;
}

.bg-success {
  --kt-bg-rgb-color: var(--kt-success-rgb);
  background-color: var(--kt-success) !important;
}

.bg-hover-light-success {
  cursor: pointer;
}
.bg-hover-light-success:hover {
  background-color: var(--kt-success-light) !important;
}

.bg-state-light-success {
  cursor: pointer;
}
.bg-state-light-success.active, .bg-state-light-success:hover {
  background-color: var(--kt-success-light) !important;
}

.bg-hover-success {
  cursor: pointer;
}
.bg-hover-success:hover {
  background-color: var(--kt-success) !important;
}

.bg-active-success.active {
  background-color: var(--kt-success) !important;
}

.bg-state-success {
  cursor: pointer;
}
.bg-state-success.active, .bg-state-success:hover {
  background-color: var(--kt-success) !important;
}

.bg-light-info {
  background-color: var(--kt-info-light) !important;
}

.bg-info {
  --kt-bg-rgb-color: var(--kt-info-rgb);
  background-color: var(--kt-info) !important;
}

.bg-hover-light-info {
  cursor: pointer;
}
.bg-hover-light-info:hover {
  background-color: var(--kt-info-light) !important;
}

.bg-state-light-info {
  cursor: pointer;
}
.bg-state-light-info.active, .bg-state-light-info:hover {
  background-color: var(--kt-info-light) !important;
}

.bg-hover-info {
  cursor: pointer;
}
.bg-hover-info:hover {
  background-color: var(--kt-info) !important;
}

.bg-active-info.active {
  background-color: var(--kt-info) !important;
}

.bg-state-info {
  cursor: pointer;
}
.bg-state-info.active, .bg-state-info:hover {
  background-color: var(--kt-info) !important;
}

.bg-light-warning {
  background-color: var(--kt-warning-light) !important;
}

.bg-warning {
  --kt-bg-rgb-color: var(--kt-warning-rgb);
  background-color: var(--kt-warning) !important;
}

.bg-hover-light-warning {
  cursor: pointer;
}
.bg-hover-light-warning:hover {
  background-color: var(--kt-warning-light) !important;
}

.bg-state-light-warning {
  cursor: pointer;
}
.bg-state-light-warning.active, .bg-state-light-warning:hover {
  background-color: var(--kt-warning-light) !important;
}

.bg-hover-warning {
  cursor: pointer;
}
.bg-hover-warning:hover {
  background-color: var(--kt-warning) !important;
}

.bg-active-warning.active {
  background-color: var(--kt-warning) !important;
}

.bg-state-warning {
  cursor: pointer;
}
.bg-state-warning.active, .bg-state-warning:hover {
  background-color: var(--kt-warning) !important;
}

.bg-light-danger {
  background-color: var(--kt-danger-light) !important;
}

.bg-danger {
  --kt-bg-rgb-color: var(--kt-danger-rgb);
  background-color: var(--kt-danger) !important;
}

.bg-hover-light-danger {
  cursor: pointer;
}
.bg-hover-light-danger:hover {
  background-color: var(--kt-danger-light) !important;
}

.bg-state-light-danger {
  cursor: pointer;
}
.bg-state-light-danger.active, .bg-state-light-danger:hover {
  background-color: var(--kt-danger-light) !important;
}

.bg-hover-danger {
  cursor: pointer;
}
.bg-hover-danger:hover {
  background-color: var(--kt-danger) !important;
}

.bg-active-danger.active {
  background-color: var(--kt-danger) !important;
}

.bg-state-danger {
  cursor: pointer;
}
.bg-state-danger.active, .bg-state-danger:hover {
  background-color: var(--kt-danger) !important;
}

.bg-light-dark {
  background-color: var(--kt-dark-light) !important;
}

.bg-dark {
  --kt-bg-rgb-color: var(--kt-dark-rgb);
  background-color: var(--kt-dark) !important;
}

.bg-hover-light-dark {
  cursor: pointer;
}
.bg-hover-light-dark:hover {
  background-color: var(--kt-dark-light) !important;
}

.bg-state-light-dark {
  cursor: pointer;
}
.bg-state-light-dark.active, .bg-state-light-dark:hover {
  background-color: var(--kt-dark-light) !important;
}

.bg-hover-dark {
  cursor: pointer;
}
.bg-hover-dark:hover {
  background-color: var(--kt-dark) !important;
}

.bg-active-dark.active {
  background-color: var(--kt-dark) !important;
}

.bg-state-dark {
  cursor: pointer;
}
.bg-state-dark.active, .bg-state-dark:hover {
  background-color: var(--kt-dark) !important;
}

.bg-gray-100 {
  background-color: var(--kt-gray-100);
}

.bg-gray-100i {
  background-color: var(--kt-gray-100) !important;
}

.bg-gray-200 {
  background-color: var(--kt-gray-200);
}

.bg-gray-200i {
  background-color: var(--kt-gray-200) !important;
}

.bg-gray-300 {
  background-color: var(--kt-gray-300);
}

.bg-gray-300i {
  background-color: var(--kt-gray-300) !important;
}

.bg-gray-400 {
  background-color: var(--kt-gray-400);
}

.bg-gray-400i {
  background-color: var(--kt-gray-400) !important;
}

.bg-gray-500 {
  background-color: var(--kt-gray-500);
}

.bg-gray-500i {
  background-color: var(--kt-gray-500) !important;
}

.bg-gray-600 {
  background-color: var(--kt-gray-600);
}

.bg-gray-600i {
  background-color: var(--kt-gray-600) !important;
}

.bg-gray-700 {
  background-color: var(--kt-gray-700);
}

.bg-gray-700i {
  background-color: var(--kt-gray-700) !important;
}

.bg-gray-800 {
  background-color: var(--kt-gray-800);
}

.bg-gray-800i {
  background-color: var(--kt-gray-800) !important;
}

.bg-gray-900 {
  background-color: var(--kt-gray-900);
}

.bg-gray-900i {
  background-color: var(--kt-gray-900) !important;
}

.bg-opacity-0 {
  background-color: rgba(var(--kt-bg-rgb-color), 0) !important;
}

.bg-hover-opacity-0:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0) !important;
}

.bg-active-opacity-0.active {
  background-color: rgba(var(--kt-bg-rgb-color), 0) !important;
}

.bg-state-opacity-0 .active, .bg-state-opacity-0:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0) !important;
}

.bg-opacity-5 {
  background-color: rgba(var(--kt-bg-rgb-color), 0.05) !important;
}

.bg-hover-opacity-5:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0.05) !important;
}

.bg-active-opacity-5.active {
  background-color: rgba(var(--kt-bg-rgb-color), 0.05) !important;
}

.bg-state-opacity-5 .active, .bg-state-opacity-5:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0.05) !important;
}

.bg-opacity-10 {
  background-color: rgba(var(--kt-bg-rgb-color), 0.1) !important;
}

.bg-hover-opacity-10:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0.1) !important;
}

.bg-active-opacity-10.active {
  background-color: rgba(var(--kt-bg-rgb-color), 0.1) !important;
}

.bg-state-opacity-10 .active, .bg-state-opacity-10:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0.1) !important;
}

.bg-opacity-15 {
  background-color: rgba(var(--kt-bg-rgb-color), 0.15) !important;
}

.bg-hover-opacity-15:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0.15) !important;
}

.bg-active-opacity-15.active {
  background-color: rgba(var(--kt-bg-rgb-color), 0.15) !important;
}

.bg-state-opacity-15 .active, .bg-state-opacity-15:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0.15) !important;
}

.bg-opacity-20 {
  background-color: rgba(var(--kt-bg-rgb-color), 0.2) !important;
}

.bg-hover-opacity-20:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0.2) !important;
}

.bg-active-opacity-20.active {
  background-color: rgba(var(--kt-bg-rgb-color), 0.2) !important;
}

.bg-state-opacity-20 .active, .bg-state-opacity-20:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0.2) !important;
}

.bg-opacity-25 {
  background-color: rgba(var(--kt-bg-rgb-color), 0.25) !important;
}

.bg-hover-opacity-25:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0.25) !important;
}

.bg-active-opacity-25.active {
  background-color: rgba(var(--kt-bg-rgb-color), 0.25) !important;
}

.bg-state-opacity-25 .active, .bg-state-opacity-25:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0.25) !important;
}

.bg-opacity-50 {
  background-color: rgba(var(--kt-bg-rgb-color), 0.5) !important;
}

.bg-hover-opacity-50:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0.5) !important;
}

.bg-active-opacity-50.active {
  background-color: rgba(var(--kt-bg-rgb-color), 0.5) !important;
}

.bg-state-opacity-50 .active, .bg-state-opacity-50:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0.5) !important;
}

.bg-opacity-75 {
  background-color: rgba(var(--kt-bg-rgb-color), 0.75) !important;
}

.bg-hover-opacity-75:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0.75) !important;
}

.bg-active-opacity-75.active {
  background-color: rgba(var(--kt-bg-rgb-color), 0.75) !important;
}

.bg-state-opacity-75 .active, .bg-state-opacity-75:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 0.75) !important;
}

.bg-opacity-100 {
  background-color: rgba(var(--kt-bg-rgb-color), 1) !important;
}

.bg-hover-opacity-100:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 1) !important;
}

.bg-active-opacity-100.active {
  background-color: rgba(var(--kt-bg-rgb-color), 1) !important;
}

.bg-state-opacity-100 .active, .bg-state-opacity-100:hover {
  background-color: rgba(var(--kt-bg-rgb-color), 1) !important;
}

.bgi-no-repeat {
  background-repeat: no-repeat;
}

.bgi-position-y-top {
  background-position-y: top;
}

.bgi-position-y-bottom {
  background-position-y: bottom;
}

.bgi-position-y-center {
  background-position-y: center;
}

.bgi-position-x-start {
  background-position-x: left;
}

.bgi-position-x-end {
  background-position-x: right;
}

.bgi-position-x-center {
  background-position-x: center;
}

.bgi-position-top {
  background-position: 0 top;
}

.bgi-position-bottom {
  background-position: 0 bottom;
}

.bgi-position-center {
  background-position: center;
}

.bgi-size-auto {
  background-size: auto;
}

.bgi-size-cover {
  background-size: cover;
}

.bgi-size-contain {
  background-size: contain;
}

.bgi-attachment-fixed {
  background-attachment: fixed;
}

.bgi-attachment-scroll {
  background-attachment: scroll;
}

@media (min-width: 576px) {
  .bgi-size-sm-auto {
    background-size: auto;
  }

  .bgi-size-sm-cover {
    background-size: cover;
  }

  .bgi-size-sm-contain {
    background-size: contain;
  }

  .bgi-attachment-sm-fixed {
    background-attachment: fixed;
  }

  .bgi-attachment-sm-scroll {
    background-attachment: scroll;
  }
}
@media (min-width: 768px) {
  .bgi-size-md-auto {
    background-size: auto;
  }

  .bgi-size-md-cover {
    background-size: cover;
  }

  .bgi-size-md-contain {
    background-size: contain;
  }

  .bgi-attachment-md-fixed {
    background-attachment: fixed;
  }

  .bgi-attachment-md-scroll {
    background-attachment: scroll;
  }
}
@media (min-width: 992px) {
  .bgi-size-lg-auto {
    background-size: auto;
  }

  .bgi-size-lg-cover {
    background-size: cover;
  }

  .bgi-size-lg-contain {
    background-size: contain;
  }

  .bgi-attachment-lg-fixed {
    background-attachment: fixed;
  }

  .bgi-attachment-lg-scroll {
    background-attachment: scroll;
  }
}
@media (min-width: 1200px) {
  .bgi-size-xl-auto {
    background-size: auto;
  }

  .bgi-size-xl-cover {
    background-size: cover;
  }

  .bgi-size-xl-contain {
    background-size: contain;
  }

  .bgi-attachment-xl-fixed {
    background-attachment: fixed;
  }

  .bgi-attachment-xl-scroll {
    background-attachment: scroll;
  }
}
@media (min-width: 1400px) {
  .bgi-size-xxl-auto {
    background-size: auto;
  }

  .bgi-size-xxl-cover {
    background-size: cover;
  }

  .bgi-size-xxl-contain {
    background-size: contain;
  }

  .bgi-attachment-xxl-fixed {
    background-attachment: fixed;
  }

  .bgi-attachment-xxl-scroll {
    background-attachment: scroll;
  }
}
.border-active:not(.active):not(:active):not(:hover):not(:focus) {
  border-color: transparent !important;
}

.border-hover:not(:hover):not(:focus):not(.active):not(:active) {
  cursor: pointer;
  border-color: transparent !important;
}

.border-gray-100 {
  border-color: var(--kt-gray-100) !important;
}

.border-gray-200 {
  border-color: var(--kt-gray-200) !important;
}

.border-gray-300 {
  border-color: var(--kt-gray-300) !important;
}

.border-gray-400 {
  border-color: var(--kt-gray-400) !important;
}

.border-gray-500 {
  border-color: var(--kt-gray-500) !important;
}

.border-gray-600 {
  border-color: var(--kt-gray-600) !important;
}

.border-gray-700 {
  border-color: var(--kt-gray-700) !important;
}

.border-gray-800 {
  border-color: var(--kt-gray-800) !important;
}

.border-gray-900 {
  border-color: var(--kt-gray-900) !important;
}

.border-hover-white:hover {
  border-color: var(--kt-white) !important;
}

.border-active-white.active {
  border-color: var(--kt-white) !important;
}

.border-hover-light:hover {
  border-color: var(--kt-light) !important;
}

.border-active-light.active {
  border-color: var(--kt-light) !important;
}

.border-hover-primary:hover {
  border-color: var(--kt-primary) !important;
}

.border-active-primary.active {
  border-color: var(--kt-primary) !important;
}

.border-hover-secondary:hover {
  border-color: var(--kt-secondary) !important;
}

.border-active-secondary.active {
  border-color: var(--kt-secondary) !important;
}

.border-hover-success:hover {
  border-color: var(--kt-success) !important;
}

.border-active-success.active {
  border-color: var(--kt-success) !important;
}

.border-hover-info:hover {
  border-color: var(--kt-info) !important;
}

.border-active-info.active {
  border-color: var(--kt-info) !important;
}

.border-hover-warning:hover {
  border-color: var(--kt-warning) !important;
}

.border-active-warning.active {
  border-color: var(--kt-warning) !important;
}

.border-hover-danger:hover {
  border-color: var(--kt-danger) !important;
}

.border-active-danger.active {
  border-color: var(--kt-danger) !important;
}

.border-hover-dark:hover {
  border-color: var(--kt-dark) !important;
}

.border-active-dark.active {
  border-color: var(--kt-dark) !important;
}

.border-hover-transparent:hover {
  border-color: transparent !important;
}

.border-dashed {
  border-style: dashed !important;
  border-color: var(--kt-border-dashed-color);
}

.border-top-dashed {
  border-top-style: dashed !important;
}

.border-bottom-dashed {
  border-bottom-style: dashed !important;
}

.border-start-dashed {
  border-left-style: dashed !important;
}

.border-end-dashed {
  border-right-style: dashed !important;
}

.border-dotted {
  border-style: dotted !important;
}

.border-top-dotted {
  border-top-style: dotted !important;
}

.border-bottom-dotted {
  border-bottom-style: dotted !important;
}

.border-start-dotted {
  border-left-style: dotted !important;
}

.border-end-dotted {
  border-right-style: dotted !important;
}

.border-transparent {
  border-color: transparent !important;
}

.border-body {
  border-color: var(--kt-body-bg) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-bottom-0 {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-start-0 {
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.flex-root {
  flex: 1 1;
}

.flex-column-auto {
  flex: none;
}

.flex-column-fluid {
  flex: 1 0 auto;
}

.flex-row-auto {
  flex: 0 0 auto;
}

.flex-row-fluid {
  flex: 1 1 auto;
  min-width: 0;
}

.flex-center {
  justify-content: center;
  align-items: center;
}

.flex-start {
  justify-content: start;
  align-items: start;
}

.flex-end {
  justify-content: end;
  align-items: end;
}

.flex-stack {
  justify-content: space-between;
  align-items: center;
}

@media (min-width: 576px) {
  .flex-sm-root {
    flex: 1 1;
  }

  .flex-sm-column-auto {
    flex: none;
  }

  .flex-sm-column-fluid {
    flex: 1 0 auto;
  }

  .flex-sm-row-auto {
    flex: 0 0 auto;
  }

  .flex-sm-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }

  .flex-sm-center {
    justify-content: center;
    align-items: center;
  }

  .flex-sm-start {
    justify-content: start;
    align-items: start;
  }

  .flex-sm-end {
    justify-content: end;
    align-items: end;
  }

  .flex-sm-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 768px) {
  .flex-md-root {
    flex: 1 1;
  }

  .flex-md-column-auto {
    flex: none;
  }

  .flex-md-column-fluid {
    flex: 1 0 auto;
  }

  .flex-md-row-auto {
    flex: 0 0 auto;
  }

  .flex-md-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }

  .flex-md-center {
    justify-content: center;
    align-items: center;
  }

  .flex-md-start {
    justify-content: start;
    align-items: start;
  }

  .flex-md-end {
    justify-content: end;
    align-items: end;
  }

  .flex-md-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 992px) {
  .flex-lg-root {
    flex: 1 1;
  }

  .flex-lg-column-auto {
    flex: none;
  }

  .flex-lg-column-fluid {
    flex: 1 0 auto;
  }

  .flex-lg-row-auto {
    flex: 0 0 auto;
  }

  .flex-lg-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }

  .flex-lg-center {
    justify-content: center;
    align-items: center;
  }

  .flex-lg-start {
    justify-content: start;
    align-items: start;
  }

  .flex-lg-end {
    justify-content: end;
    align-items: end;
  }

  .flex-lg-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 1200px) {
  .flex-xl-root {
    flex: 1 1;
  }

  .flex-xl-column-auto {
    flex: none;
  }

  .flex-xl-column-fluid {
    flex: 1 0 auto;
  }

  .flex-xl-row-auto {
    flex: 0 0 auto;
  }

  .flex-xl-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }

  .flex-xl-center {
    justify-content: center;
    align-items: center;
  }

  .flex-xl-start {
    justify-content: start;
    align-items: start;
  }

  .flex-xl-end {
    justify-content: end;
    align-items: end;
  }

  .flex-xl-stack {
    justify-content: space-between;
    align-items: center;
  }
}
@media (min-width: 1400px) {
  .flex-xxl-root {
    flex: 1 1;
  }

  .flex-xxl-column-auto {
    flex: none;
  }

  .flex-xxl-column-fluid {
    flex: 1 0 auto;
  }

  .flex-xxl-row-auto {
    flex: 0 0 auto;
  }

  .flex-xxl-row-fluid {
    flex: 1 1 auto;
    min-width: 0;
  }

  .flex-xxl-center {
    justify-content: center;
    align-items: center;
  }

  .flex-xxl-start {
    justify-content: start;
    align-items: start;
  }

  .flex-xxl-end {
    justify-content: end;
    align-items: end;
  }

  .flex-xxl-stack {
    justify-content: space-between;
    align-items: center;
  }
}
.flex-equal {
  flex-grow: 1;
  flex-basis: 0;
  flex-shrink: 0;
}

.shadow-xs {
  box-shadow: var(--kt-box-shadow-xs);
}

.shadow-sm {
  box-shadow: var(--kt-box-shadow-sm);
}

.shadow {
  box-shadow: var(--kt-box-shadow);
}

.shadow-lg {
  box-shadow: var(--kt-box-shadow-lg);
}

.text-white {
  color: var(--kt-text-white) !important;
}

.text-hover-white {
  transition: color 0.2s ease;
}
.text-hover-white i {
  transition: color 0.2s ease;
}
.text-hover-white:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-white) !important;
}
.text-hover-white:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-white) !important;
}
.text-hover-white:hover .svg-icon {
  color: var(--kt-text-white) !important;
}

.text-active-white {
  transition: color 0.2s ease;
}
.text-active-white i {
  transition: color 0.2s ease;
}
.text-active-white.active {
  transition: color 0.2s ease;
  color: var(--kt-text-white) !important;
}
.text-active-white.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-white) !important;
}
.text-active-white.active .svg-icon {
  color: var(--kt-text-white) !important;
}

.text-primary {
  color: var(--kt-text-primary) !important;
}

.text-inverse-primary {
  color: var(--kt-primary-inverse) !important;
}

.text-light-primary {
  color: var(--kt-primary-light) !important;
}

.text-hover-primary {
  transition: color 0.2s ease;
}
.text-hover-primary i {
  transition: color 0.2s ease;
}
.text-hover-primary:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-primary) !important;
}
.text-hover-primary:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-primary) !important;
}
.text-hover-primary:hover .svg-icon {
  color: var(--kt-text-primary) !important;
}

.text-active-primary {
  transition: color 0.2s ease;
}
.text-active-primary i {
  transition: color 0.2s ease;
}
.text-active-primary.active {
  transition: color 0.2s ease;
  color: var(--kt-text-primary) !important;
}
.text-active-primary.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-primary) !important;
}
.text-active-primary.active .svg-icon {
  color: var(--kt-text-primary) !important;
}

.text-secondary {
  color: var(--kt-text-secondary) !important;
}

.text-inverse-secondary {
  color: var(--kt-secondary-inverse) !important;
}

.text-light-secondary {
  color: var(--kt-secondary-light) !important;
}

.text-hover-secondary {
  transition: color 0.2s ease;
}
.text-hover-secondary i {
  transition: color 0.2s ease;
}
.text-hover-secondary:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-secondary) !important;
}
.text-hover-secondary:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-secondary) !important;
}
.text-hover-secondary:hover .svg-icon {
  color: var(--kt-text-secondary) !important;
}

.text-active-secondary {
  transition: color 0.2s ease;
}
.text-active-secondary i {
  transition: color 0.2s ease;
}
.text-active-secondary.active {
  transition: color 0.2s ease;
  color: var(--kt-text-secondary) !important;
}
.text-active-secondary.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-secondary) !important;
}
.text-active-secondary.active .svg-icon {
  color: var(--kt-text-secondary) !important;
}

.text-light {
  color: var(--kt-text-light) !important;
}

.text-inverse-light {
  color: var(--kt-light-inverse) !important;
}

.text-hover-light {
  transition: color 0.2s ease;
}
.text-hover-light i {
  transition: color 0.2s ease;
}
.text-hover-light:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-light) !important;
}
.text-hover-light:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-light) !important;
}
.text-hover-light:hover .svg-icon {
  color: var(--kt-text-light) !important;
}

.text-active-light {
  transition: color 0.2s ease;
}
.text-active-light i {
  transition: color 0.2s ease;
}
.text-active-light.active {
  transition: color 0.2s ease;
  color: var(--kt-text-light) !important;
}
.text-active-light.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-light) !important;
}
.text-active-light.active .svg-icon {
  color: var(--kt-text-light) !important;
}

.text-success {
  color: var(--kt-text-success) !important;
}

.text-inverse-success {
  color: var(--kt-success-inverse) !important;
}

.text-light-success {
  color: var(--kt-success-light) !important;
}

.text-hover-success {
  transition: color 0.2s ease;
}
.text-hover-success i {
  transition: color 0.2s ease;
}
.text-hover-success:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-success) !important;
}
.text-hover-success:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-success) !important;
}
.text-hover-success:hover .svg-icon {
  color: var(--kt-text-success) !important;
}

.text-active-success {
  transition: color 0.2s ease;
}
.text-active-success i {
  transition: color 0.2s ease;
}
.text-active-success.active {
  transition: color 0.2s ease;
  color: var(--kt-text-success) !important;
}
.text-active-success.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-success) !important;
}
.text-active-success.active .svg-icon {
  color: var(--kt-text-success) !important;
}

.text-info {
  color: var(--kt-text-info) !important;
}

.text-inverse-info {
  color: var(--kt-info-inverse) !important;
}

.text-light-info {
  color: var(--kt-info-light) !important;
}

.text-hover-info {
  transition: color 0.2s ease;
}
.text-hover-info i {
  transition: color 0.2s ease;
}
.text-hover-info:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-info) !important;
}
.text-hover-info:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-info) !important;
}
.text-hover-info:hover .svg-icon {
  color: var(--kt-text-info) !important;
}

.text-active-info {
  transition: color 0.2s ease;
}
.text-active-info i {
  transition: color 0.2s ease;
}
.text-active-info.active {
  transition: color 0.2s ease;
  color: var(--kt-text-info) !important;
}
.text-active-info.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-info) !important;
}
.text-active-info.active .svg-icon {
  color: var(--kt-text-info) !important;
}

.text-warning {
  color: var(--kt-text-warning) !important;
}

.text-inverse-warning {
  color: var(--kt-warning-inverse) !important;
}

.text-light-warning {
  color: var(--kt-warning-light) !important;
}

.text-hover-warning {
  transition: color 0.2s ease;
}
.text-hover-warning i {
  transition: color 0.2s ease;
}
.text-hover-warning:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-warning) !important;
}
.text-hover-warning:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-warning) !important;
}
.text-hover-warning:hover .svg-icon {
  color: var(--kt-text-warning) !important;
}

.text-active-warning {
  transition: color 0.2s ease;
}
.text-active-warning i {
  transition: color 0.2s ease;
}
.text-active-warning.active {
  transition: color 0.2s ease;
  color: var(--kt-text-warning) !important;
}
.text-active-warning.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-warning) !important;
}
.text-active-warning.active .svg-icon {
  color: var(--kt-text-warning) !important;
}

.text-danger {
  color: var(--kt-text-danger) !important;
}

.text-inverse-danger {
  color: var(--kt-danger-inverse) !important;
}

.text-light-danger {
  color: var(--kt-danger-light) !important;
}

.text-hover-danger {
  transition: color 0.2s ease;
}
.text-hover-danger i {
  transition: color 0.2s ease;
}
.text-hover-danger:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-danger) !important;
}
.text-hover-danger:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-danger) !important;
}
.text-hover-danger:hover .svg-icon {
  color: var(--kt-text-danger) !important;
}

.text-active-danger {
  transition: color 0.2s ease;
}
.text-active-danger i {
  transition: color 0.2s ease;
}
.text-active-danger.active {
  transition: color 0.2s ease;
  color: var(--kt-text-danger) !important;
}
.text-active-danger.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-danger) !important;
}
.text-active-danger.active .svg-icon {
  color: var(--kt-text-danger) !important;
}

.text-dark {
  color: var(--kt-text-dark) !important;
}

.text-inverse-dark {
  color: var(--kt-dark-inverse) !important;
}

.text-light-dark {
  color: var(--kt-dark-light) !important;
}

.text-hover-dark {
  transition: color 0.2s ease;
}
.text-hover-dark i {
  transition: color 0.2s ease;
}
.text-hover-dark:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-dark) !important;
}
.text-hover-dark:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-dark) !important;
}
.text-hover-dark:hover .svg-icon {
  color: var(--kt-text-dark) !important;
}

.text-active-dark {
  transition: color 0.2s ease;
}
.text-active-dark i {
  transition: color 0.2s ease;
}
.text-active-dark.active {
  transition: color 0.2s ease;
  color: var(--kt-text-dark) !important;
}
.text-active-dark.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-dark) !important;
}
.text-active-dark.active .svg-icon {
  color: var(--kt-text-dark) !important;
}

.text-muted {
  color: var(--kt-text-muted) !important;
}

.text-hover-muted {
  transition: color 0.2s ease;
}
.text-hover-muted i {
  transition: color 0.2s ease;
}
.text-hover-muted:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-muted) !important;
}
.text-hover-muted:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-muted) !important;
}
.text-hover-muted:hover .svg-icon {
  color: var(--kt-text-muted) !important;
}

.text-active-muted {
  transition: color 0.2s ease;
}
.text-active-muted i {
  transition: color 0.2s ease;
}
.text-active-muted.active {
  transition: color 0.2s ease;
  color: var(--kt-text-muted) !important;
}
.text-active-muted.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-muted) !important;
}
.text-active-muted.active .svg-icon {
  color: var(--kt-text-muted) !important;
}

.text-gray-100 {
  color: var(--kt-text-gray-100) !important;
}

.text-hover-gray-100 {
  transition: color 0.2s ease;
}
.text-hover-gray-100 i {
  transition: color 0.2s ease;
}
.text-hover-gray-100:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-100) !important;
}
.text-hover-gray-100:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-100) !important;
}
.text-hover-gray-100:hover .svg-icon {
  color: var(--kt-text-gray-100) !important;
}

.text-active-gray-100 {
  transition: color 0.2s ease;
}
.text-active-gray-100 i {
  transition: color 0.2s ease;
}
.text-active-gray-100.active {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-100) !important;
}
.text-active-gray-100.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-100) !important;
}
.text-active-gray-100.active .svg-icon {
  color: var(--kt-text-gray-100) !important;
}

.text-gray-200 {
  color: var(--kt-text-gray-200) !important;
}

.text-hover-gray-200 {
  transition: color 0.2s ease;
}
.text-hover-gray-200 i {
  transition: color 0.2s ease;
}
.text-hover-gray-200:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-200) !important;
}
.text-hover-gray-200:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-200) !important;
}
.text-hover-gray-200:hover .svg-icon {
  color: var(--kt-text-gray-200) !important;
}

.text-active-gray-200 {
  transition: color 0.2s ease;
}
.text-active-gray-200 i {
  transition: color 0.2s ease;
}
.text-active-gray-200.active {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-200) !important;
}
.text-active-gray-200.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-200) !important;
}
.text-active-gray-200.active .svg-icon {
  color: var(--kt-text-gray-200) !important;
}

.text-gray-300 {
  color: var(--kt-text-gray-300) !important;
}

.text-hover-gray-300 {
  transition: color 0.2s ease;
}
.text-hover-gray-300 i {
  transition: color 0.2s ease;
}
.text-hover-gray-300:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-300) !important;
}
.text-hover-gray-300:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-300) !important;
}
.text-hover-gray-300:hover .svg-icon {
  color: var(--kt-text-gray-300) !important;
}

.text-active-gray-300 {
  transition: color 0.2s ease;
}
.text-active-gray-300 i {
  transition: color 0.2s ease;
}
.text-active-gray-300.active {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-300) !important;
}
.text-active-gray-300.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-300) !important;
}
.text-active-gray-300.active .svg-icon {
  color: var(--kt-text-gray-300) !important;
}

.text-gray-400 {
  color: var(--kt-text-gray-400) !important;
}

.text-hover-gray-400 {
  transition: color 0.2s ease;
}
.text-hover-gray-400 i {
  transition: color 0.2s ease;
}
.text-hover-gray-400:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-400) !important;
}
.text-hover-gray-400:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-400) !important;
}
.text-hover-gray-400:hover .svg-icon {
  color: var(--kt-text-gray-400) !important;
}

.text-active-gray-400 {
  transition: color 0.2s ease;
}
.text-active-gray-400 i {
  transition: color 0.2s ease;
}
.text-active-gray-400.active {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-400) !important;
}
.text-active-gray-400.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-400) !important;
}
.text-active-gray-400.active .svg-icon {
  color: var(--kt-text-gray-400) !important;
}

.text-gray-500 {
  color: var(--kt-text-gray-500) !important;
}

.text-hover-gray-500 {
  transition: color 0.2s ease;
}
.text-hover-gray-500 i {
  transition: color 0.2s ease;
}
.text-hover-gray-500:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-500) !important;
}
.text-hover-gray-500:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-500) !important;
}
.text-hover-gray-500:hover .svg-icon {
  color: var(--kt-text-gray-500) !important;
}

.text-active-gray-500 {
  transition: color 0.2s ease;
}
.text-active-gray-500 i {
  transition: color 0.2s ease;
}
.text-active-gray-500.active {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-500) !important;
}
.text-active-gray-500.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-500) !important;
}
.text-active-gray-500.active .svg-icon {
  color: var(--kt-text-gray-500) !important;
}

.text-gray-600 {
  color: var(--kt-text-gray-600) !important;
}

.text-hover-gray-600 {
  transition: color 0.2s ease;
}
.text-hover-gray-600 i {
  transition: color 0.2s ease;
}
.text-hover-gray-600:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-600) !important;
}
.text-hover-gray-600:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-600) !important;
}
.text-hover-gray-600:hover .svg-icon {
  color: var(--kt-text-gray-600) !important;
}

.text-active-gray-600 {
  transition: color 0.2s ease;
}
.text-active-gray-600 i {
  transition: color 0.2s ease;
}
.text-active-gray-600.active {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-600) !important;
}
.text-active-gray-600.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-600) !important;
}
.text-active-gray-600.active .svg-icon {
  color: var(--kt-text-gray-600) !important;
}

.text-gray-700 {
  color: var(--kt-text-gray-700) !important;
}

.text-hover-gray-700 {
  transition: color 0.2s ease;
}
.text-hover-gray-700 i {
  transition: color 0.2s ease;
}
.text-hover-gray-700:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-700) !important;
}
.text-hover-gray-700:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-700) !important;
}
.text-hover-gray-700:hover .svg-icon {
  color: var(--kt-text-gray-700) !important;
}

.text-active-gray-700 {
  transition: color 0.2s ease;
}
.text-active-gray-700 i {
  transition: color 0.2s ease;
}
.text-active-gray-700.active {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-700) !important;
}
.text-active-gray-700.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-700) !important;
}
.text-active-gray-700.active .svg-icon {
  color: var(--kt-text-gray-700) !important;
}

.text-gray-800 {
  color: var(--kt-text-gray-800) !important;
}

.text-hover-gray-800 {
  transition: color 0.2s ease;
}
.text-hover-gray-800 i {
  transition: color 0.2s ease;
}
.text-hover-gray-800:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-800) !important;
}
.text-hover-gray-800:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-800) !important;
}
.text-hover-gray-800:hover .svg-icon {
  color: var(--kt-text-gray-800) !important;
}

.text-active-gray-800 {
  transition: color 0.2s ease;
}
.text-active-gray-800 i {
  transition: color 0.2s ease;
}
.text-active-gray-800.active {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-800) !important;
}
.text-active-gray-800.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-800) !important;
}
.text-active-gray-800.active .svg-icon {
  color: var(--kt-text-gray-800) !important;
}

.text-gray-900 {
  color: var(--kt-text-gray-900) !important;
}

.text-hover-gray-900 {
  transition: color 0.2s ease;
}
.text-hover-gray-900 i {
  transition: color 0.2s ease;
}
.text-hover-gray-900:hover {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-900) !important;
}
.text-hover-gray-900:hover i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-900) !important;
}
.text-hover-gray-900:hover .svg-icon {
  color: var(--kt-text-gray-900) !important;
}

.text-active-gray-900 {
  transition: color 0.2s ease;
}
.text-active-gray-900 i {
  transition: color 0.2s ease;
}
.text-active-gray-900.active {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-900) !important;
}
.text-active-gray-900.active i {
  transition: color 0.2s ease;
  color: var(--kt-text-gray-900) !important;
}
.text-active-gray-900.active .svg-icon {
  color: var(--kt-text-gray-900) !important;
}

.text-transparent {
  color: transparent;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-default {
  cursor: default;
}

.cursor-move {
  cursor: move;
}

i.bi, i[class^=fonticon-], i[class*=" fonticon-"], i[class^=fa-], i[class*=" fa-"], i[class^=la-], i[class*=" la-"] {
  line-height: 1;
  font-size: 1rem;
  color: var(--kt-text-muted);
}

a {
  transition: color 0.2s ease;
}
a:hover {
  transition: color 0.2s ease;
}

.opacity-active-0.active {
  opacity: 0 !important;
}

.opacity-state-0:hover, .opacity-state-0.active {
  opacity: 0 !important;
}

.opacity-active-5.active {
  opacity: 0.05 !important;
}

.opacity-state-5:hover, .opacity-state-5.active {
  opacity: 0.05 !important;
}

.opacity-active-10.active {
  opacity: 0.1 !important;
}

.opacity-state-10:hover, .opacity-state-10.active {
  opacity: 0.1 !important;
}

.opacity-active-15.active {
  opacity: 0.15 !important;
}

.opacity-state-15:hover, .opacity-state-15.active {
  opacity: 0.15 !important;
}

.opacity-active-20.active {
  opacity: 0.2 !important;
}

.opacity-state-20:hover, .opacity-state-20.active {
  opacity: 0.2 !important;
}

.opacity-active-25.active {
  opacity: 0.25 !important;
}

.opacity-state-25:hover, .opacity-state-25.active {
  opacity: 0.25 !important;
}

.opacity-active-50.active {
  opacity: 0.5 !important;
}

.opacity-state-50:hover, .opacity-state-50.active {
  opacity: 0.5 !important;
}

.opacity-active-75.active {
  opacity: 0.75 !important;
}

.opacity-state-75:hover, .opacity-state-75.active {
  opacity: 0.75 !important;
}

.opacity-active-100.active {
  opacity: 1 !important;
}

.opacity-state-100:hover, .opacity-state-100.active {
  opacity: 1 !important;
}

.transform-90 {
  transform: rotate(90deg);
  transform-origin: right top;
}

.stepper.stepper-pills.stepper-multistep {
  --kt-stepper-pills-size: 46px;
  --kt-stepper-icon-border-radius: 9px;
  --kt-stepper-icon-check-size: 1.25rem;
  --kt-stepper-icon-bg-color: rgba(255, 255, 255, 0.03);
  --kt-stepper-icon-bg-color-current: var(--kt-success);
  --kt-stepper-icon-bg-color-completed: rgba(255, 255, 255, 0.03);
  --kt-stepper-icon-border: 1px dashed rgba(255, 255, 255, 0.3);
  --kt-stepper-icon-border-current: 0;
  --kt-stepper-icon-border-completed: 1px dashed rgba(255, 255, 255, 0.3);
  --kt-stepper-icon-number-color: var(--kt-white);
  --kt-stepper-icon-number-color-current: var(--kt-white);
  --kt-stepper-icon-number-color-completed: var(--kt-white);
  --kt-stepper-icon-check-color-completed: var(--kt-success);
  --kt-stepper-label-title-opacity: 0.7;
  --kt-stepper-label-title-opacity-current: 1;
  --kt-stepper-label-title-opacity-completed: 1;
  --kt-stepper-label-title-color: var(--kt-white);
  --kt-stepper-label-title-color-current: var(--kt-white);
  --kt-stepper-label-title-color-completed: var(--kt-white);
  --kt-stepper-label-desc-opacity: 0.7;
  --kt-stepper-label-desc-opacity-current: 0.7;
  --kt-stepper-label-desc-opacity-completed: 0.7;
  --kt-stepper-label-desc-color: var(--kt-white);
  --kt-stepper-label-desc-color-current: var(--kt-white);
  --kt-stepper-label-desc-color-completed: var(--kt-white);
  --kt-stepper-line-border: 1px dashed rgba(255, 255, 255, 0.3);
}

.landing-dark-bg {
  background-color: #13263C;
}

.landing-dark-color {
  color: #13263C;
}

.landing-dark-border {
  border: 1px dashed #2C3F5B;
}

.landing-dark-separator {
  border-top: 1px dashed #2C3F5B;
}

.landing-curve {
  position: relative;
}
.landing-curve svg {
  position: relative;
  top: 0;
  display: block;
}

.landing-header {
  display: flex;
  align-items: center;
  height: 100px;
}
.landing-header .logo-default {
  display: block;
}
.landing-header .logo-sticky {
  display: none;
}
.landing-header .menu .menu-link.active {
  color: #ffffff;
}
[data-kt-sticky-landing-header=on] .landing-header .menu .menu-link.active {
  color: #009ef7;
  background-color: rgba(239, 242, 245, 0.4);
}
[data-kt-sticky-landing-header=on] .landing-header {
  padding: 0;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 100;
  background-color: #ffffff;
  box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  height: 70px;
}
[data-kt-sticky-landing-header=on] .landing-header .logo-sticky {
  display: block;
}
[data-kt-sticky-landing-header=on] .landing-header .logo-default {
  display: none;
}

body[data-kt-sticky-landing-header=on] {
  padding-top: 100px;
}

@media (max-width: 991.98px) {
  .landing-header {
    height: 70px;
  }
  .landing-header .landing-menu-wrapper {
    position: relative;
    overflow: auto;
  }
  [data-kt-sticky-landing-header=on] .landing-header {
    height: 70px;
  }
  .landing-header .menu .menu-link.active {
    color: #009ef7;
    background-color: rgba(239, 242, 245, 0.4);
  }

  body[data-kt-sticky-landing-header=on] {
    padding-top: 70px;
  }
}
:root,
[data-theme=light] {
  --kt-app-bg-color: #f5f8fa;
  --kt-app-blank-bg-color: #ffffff;
  --kt-app-header-base-bg-color: #ffffff;
  --kt-app-header-base-bg-color-mobile: #ffffff;
  --kt-app-header-base-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  --kt-app-header-base-box-shadow-mobile: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  --kt-app-toolbar-base-bg-color: #ffffff;
  --kt-app-toolbar-base-bg-color-mobile: #ffffff;
  --kt-app-toolbar-base-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  --kt-app-toolbar-base-box-shadow-mobile: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  --kt-app-toolbar-base-border-top: 1px solid #eff2f5;
  --kt-app-toolbar-base-border-top-mobile: 1px solid #eff2f5;
  --kt-app-footer-bg-color: #ffffff;
  --kt-app-footer-bg-color-mobile: #ffffff;
}

[data-theme=dark] {
  --kt-app-bg-color: #151521;
  --kt-app-blank-bg-color: #151521;
  --kt-app-header-base-bg-color: #1e1e2d;
  --kt-app-header-base-bg-color-mobile: #1e1e2d;
  --kt-app-header-base-box-shadow: none;
  --kt-app-header-base-box-shadow-mobile: none;
  --kt-app-toolbar-base-bg-color: #1a1a27;
  --kt-app-toolbar-base-bg-color-mobile: #1a1a27;
  --kt-app-toolbar-base-box-shadow: none;
  --kt-app-toolbar-base-box-shadow-mobile: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  --kt-app-toolbar-base-border-top: 0;
  --kt-app-toolbar-base-border-top-mobile: 1px solid #eff2f5;
  --kt-app-footer-bg-color: #1e1e2d;
  --kt-app-footer-bg-color-mobile: #1e1e2d;
}

html {
  font-family: sans-serif;
  text-size-adjust: 100%;
}

html,
body {
  height: 100%;
  margin: 0px;
  padding: 0px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 13px !important;
  font-weight: 400;
  font-family: Inter, Helvetica, "sans-serif";
}
@media (max-width: 991.98px) {
  html,
body {
    font-size: 12px !important;
  }
}
@media (max-width: 767.98px) {
  html,
body {
    font-size: 12px !important;
  }
}

body {
  display: flex;
  flex-direction: column;
}
body a:hover,
body a:active,
body a:focus {
  text-decoration: none !important;
}

canvas {
  -webkit-user-select: none;
          user-select: none;
}

router-outlet {
  display: none;
}

body,
.app-default {
  background-color: var(--kt-app-bg-color);
}

.app-blank {
  background-color: var(--kt-app-blank-bg-color);
}

[data-kt-app-reset-transition=true] * {
  transition: none !important;
}

.app-page {
  display: flex;
}

[data-kt-app-page-loading=on] {
  overflow: hidden;
}

[data-kt-app-page-loading=on] * {
  transition: none !important;
}

.app-page-loader {
  background: var(--kt-body-bg);
  color: var(--kt-body-color);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  display: none;
}
[data-kt-app-page-loading=on] .app-page-loader {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media (min-width: 992px) {
  .app-container {
    padding-left: 30px !important;
    padding-right: 30px !important;
  }

  .app-container-fit-desktop {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
@media (max-width: 991.98px) {
  .app-container {
    max-width: none;
    padding-left: 20px !important;
    padding-right: 20px !important;
  }

  .app-container-fit-mobile {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
@media print {
  .app-print-content-only {
    padding: 0 !important;
    background: none !important;
  }
  .app-print-content-only .app-wrapper,
.app-print-content-only .app-page,
.app-print-content-only .app-page-title,
.app-print-content-only .app-content,
.app-print-content-only .app-container {
    background: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .app-print-content-only .app-aside,
.app-print-content-only .app-aside-panel,
.app-print-content-only .app-sidebar,
.app-print-content-only .app-sidebar-panel,
.app-print-content-only .app-header,
.app-print-content-only .app-footer,
.app-print-content-only .app-toolbar,
.app-print-content-only .drawer,
.app-print-content-only .scrolltop,
.app-print-content-only .btn {
    display: none !important;
  }
}
.app-navbar {
  display: flex;
  align-items: stretch;
}
.app-navbar .app-navbar-item {
  display: flex;
  align-items: center;
}
.app-navbar.app-navbar-stretch .app-navbar-item {
  align-items: stretch;
}

.app-header {
  transition: none;
  display: flex;
  align-items: stretch;
}

@media (min-width: 992px) {
  .app-header {
    background-color: var(--kt-app-header-base-bg-color);
    box-shadow: var(--kt-app-header-base-box-shadow);
    border-bottom: var(--kt-app-header-base-border-bottom);
  }

  :root {
    --kt-app-header-height: 70px;
    --kt-app-header-height-actual: 70px;
  }

  [data-kt-app-header-sticky=on] {
    --kt-app-header-height: 70px;
    --kt-app-header-height-actual: 70px;
  }

  [data-kt-app-header-sticky=on][data-kt-app-header-stacked=true] {
    --kt-app-header-height: calc(var(--kt-app-header-primary-height, 0px) + var(--kt-app-header-secondary-height, 0px));
    --kt-app-header-height-actual: calc(70px + 70px);
  }

  [data-kt-app-header-minimize=on] {
    --kt-app-header-height: 70px;
  }

  .app-header {
    height: var(--kt-app-header-height);
  }
  [data-kt-app-header-fixed=true] .app-header {
    z-index: 100;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
  }
  [data-kt-app-header-static=true] .app-header {
    position: relative;
  }
  [data-kt-app-header-stacked=true] .app-header {
    flex-direction: column;
    height: calc(var(--kt-app-header-primary-height) + var(--kt-app-header-secondary-height, 0px));
  }
  [data-kt-app-header-sticky=on] .app-header {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 100;
    background-color: var(--kt-app-header-sticky-bg-color);
    box-shadow: var(--kt-app-header-sticky-box-shadow);
    border-bottom: var(--kt-app-header-sticky-border-bottom);
  }
  [data-kt-app-header-minimize=on] .app-header {
    transition: none;
    z-index: 100;
    background-color: var(--kt-app-header-minimize-bg-color);
    box-shadow: var(--kt-app-header-minimize-box-shadow);
    border-bottom: var(--kt-app-header-minimize-border-bottom);
  }
  .app-header .app-header-mobile-drawer {
    display: flex;
  }

  [data-kt-app-header-fixed=true][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header, [data-kt-app-header-fixed=true][data-kt-app-sidebar-sticky=on][data-kt-app-sidebar-push-header=true] .app-header {
    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));
  }
  body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header, body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-sticky=on][data-kt-app-sidebar-push-header=true] .app-header {
    margin-left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-header-fixed=true][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header, [data-kt-app-header-fixed=true][data-kt-app-sidebar-panel-sticky=on][data-kt-app-sidebar-panel-push-header=true] .app-header {
    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));
  }
  body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header, body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-panel-sticky=on][data-kt-app-sidebar-panel-push-header=true] .app-header {
    margin-left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));
  }
  [data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true] .app-header {
    box-shadow: none;
  }
}
@media (max-width: 991.98px) {
  .app-header {
    background-color: var(--kt-app-header-base-bg-color-mobile);
    box-shadow: var(--kt-app-header-base-box-shadow-mobile);
    border-bottom: var(--kt-app-header-base-border-bottom-mobile);
  }

  :root {
    --kt-app-header-height: 60px;
  }

  [data-kt-app-header-sticky=on] {
    --kt-app-header-height: 70px;
    --kt-app-header-height-actual: 70px;
  }

  [data-kt-app-header-minimize=on] {
    --kt-app-header-height: 70px;
    --kt-app-header-height-actual: 70px;
  }

  .app-header {
    height: var(--kt-app-header-height);
    align-items: stretch;
  }
  .app-header .app-header-mobile-drawer {
    display: none;
  }
  [data-kt-app-header-stacked=true] .app-header {
    flex-direction: column;
  }
  [data-kt-app-header-fixed-mobile=true] .app-header {
    z-index: 100;
    transition: none;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
  }
  [data-kt-app-header-sticky=on] .app-header {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 100;
    background-color: var(--kt-app-header-sticky-bg-color-mobile);
    box-shadow: var(--kt-app-header-sticky-box-shadow-mobile);
    border-bottom: var(--kt-app-header-sticky-border-bottom-mobile);
  }
  [data-kt-app-header-minimize=on] .app-header {
    z-index: 100;
    transition: none;
    background-color: var(--kt-app-header-minimize-bg-color-mobile);
    box-shadow: var(--kt-app-header-minimize-box-shadow-mobile);
    border-bottom: var(--kt-app-header-minimize-border-bottom-mobile);
  }

  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-fixed-mobile=true] .app-header {
    box-shadow: none;
  }
  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-sticky=on] .app-header {
    box-shadow: none;
  }
}
.app-header-primary {
  transition: none;
  display: flex;
  align-items: stretch;
}

@media (min-width: 992px) {
  .app-header-primary {
    background-color: var(--kt-app-header-primary-base-bg-color);
    box-shadow: var(--kt-app-header-primary-base-box-shadow);
    border-bottom: var(--kt-app-header-primary-base-border-bottom);
  }

  :root {
    --kt-app-header-primary-height: 70px;
  }

  [data-kt-app-header-sticky=on] {
    --kt-app-header-primary-height: 70px;
  }

  [data-kt-app-header-minimize=on] {
    --kt-app-header-primary-height: 70px;
  }

  [data-kt-app-header-sticky=on][data-kt-app-header-primary-sticky-hide=true] {
    --kt-app-header-primary-height: 0;
  }

  .app-header-primary {
    height: var(--kt-app-header-primary-height);
  }
  [data-kt-app-header-primary-fixed=true] .app-header-primary {
    z-index: 100;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
  }
  [data-kt-app-header-primary-static=true] .app-header-primary {
    position: relative;
  }
  [data-kt-app-header-primary-sticky=on] .app-header-primary {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    height: 70px;
    z-index: 100;
    background-color: var(--kt-app-header-primary-sticky-bg-color);
    box-shadow: var(--kt-app-header-primary-sticky-box-shadow);
    border-bottom: var(--kt-app-header-primary-sticky-border-bottom);
  }
  [data-kt-app-header-primary-minimize=on] .app-header-primary {
    transition: none;
    height: 70px;
    z-index: 100;
    background-color: var(--kt-app-header-primary-minimize-bg-color);
    box-shadow: var(--kt-app-header-primary-minimize-box-shadow);
    border-bottom: var(--kt-app-header-primary-minimize-border-bottom);
  }
  [data-kt-app-header-sticky=on][data-kt-app-header-primary-sticky-hide=true] .app-header-primary {
    display: none !important;
  }

  [data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header-primary {
    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header-primary {
    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));
  }
}
@media (max-width: 991.98px) {
  .app-header-primary {
    flex-grow: 1;
    background-color: var(--kt-app-header-primary-base-bg-color-mobile);
    box-shadow: var(--kt-app-header-primary-base-box-shadow-mobile);
    border-bottom: var(--kt-app-header-primary-base-border-bottom-mobile);
  }
}
.app-header-secondary {
  transition: none;
  display: flex;
  align-items: stretch;
}

@media (min-width: 992px) {
  .app-header-secondary {
    background-color: var(--kt-app-header-secondary-base-bg-color);
    box-shadow: var(--kt-app-header-secondary-base-box-shadow);
    border-bottom: var(--kt-app-header-secondary-base-border-bottom);
  }

  :root {
    --kt-app-header-secondary-height: 70px;
  }

  [data-kt-app-header-sticky=on] {
    --kt-app-header-secondary-height: 70px;
  }

  [data-kt-app-header-minimize=on] {
    --kt-app-header-secondary-height: 70px;
  }

  [data-kt-app-header-sticky=on][data-kt-app-header-secondary-sticky-hide=true] {
    --kt-app-header-secondary-height: 0;
  }

  .app-header-secondary {
    height: var(--kt-app-header-secondary-height);
  }
  [data-kt-app-header-secondary-fixed=true] .app-header-secondary {
    z-index: 100;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
  }
  [data-kt-app-header-secondary-static=true] .app-header-secondary {
    position: static;
  }
  [data-kt-app-header-secondary-sticky=on] .app-header-secondary {
    transition: none;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    height: 70px;
    z-index: 100;
    background-color: var(--kt-app-header-secondary-sticky-bg-color);
    box-shadow: var(--kt-app-header-secondary-sticky-box-shadow);
    border-bottom: var(--kt-app-header-secondary-sticky-border-bottom);
  }
  [data-kt-app-header-secondary-minimize=on] .app-header-secondary {
    transition: none;
    height: 70px;
    z-index: 100;
    background-color: var(--kt-app-header-secondary-minimize-bg-color);
    box-shadow: var(--kt-app-header-secondary-minimize-box-shadow);
    border-bottom: var(--kt-app-header-secondary-minimize-border-bottom);
  }
  [data-kt-app-header-sticky=on][data-kt-app-header-secondary-sticky-hide=true] .app-header-secondary {
    display: none !important;
  }

  [data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header-secondary {
    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header-secondary {
    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));
  }
}
@media (max-width: 991.98px) {
  .app-header-secondary {
    flex-grow: 1;
    background-color: var(--kt-app-header-secondary-base-bg-color-mobile);
    box-shadow: var(--kt-app-header-secondary-base-box-shadow-mobile);
    border-left: var(--kt-app-header-secondary-base-border-start-mobile);
    border-right: var(--kt-app-header-secondary-base-border-end-mobile);
  }
}
.app-toolbar {
  display: flex;
  align-items: stretch;
}
.app-toolbar.app-toolbar-minimize {
  transition: none;
}

@media (min-width: 992px) {
  .app-toolbar {
    background-color: var(--kt-app-toolbar-base-bg-color);
    box-shadow: var(--kt-app-toolbar-base-box-shadow);
    border-top: var(--kt-app-toolbar-base-border-top);
    border-bottom: var(--kt-app-toolbar-base-border-bottom);
  }

  :root {
    --kt-app-toolbar-height: 55px;
    --kt-app-toolbar-height-actual: 55px;
  }

  [data-kt-app-toolbar-sticky=on] {
    --kt-app-toolbar-height: 70px;
  }

  [data-kt-app-toolbar-minimize=on] {
    --kt-app-toolbar-height: 70px;
  }

  .app-toolbar {
    height: var(--kt-app-toolbar-height);
  }
  [data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true] .app-toolbar {
    z-index: 99;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
  }
  [data-kt-app-toolbar-sticky=on] .app-toolbar {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 99;
    box-shadow: var(--kt-app-toolbar-sticky-box-shadow);
    background-color: var(--kt-app-toolbar-sticky-bg-color);
    border-top: var(--kt-app-toolbar-sticky-border-top);
    border-bottom: var(--kt-app-toolbar-sticky-border-bottom);
  }
  [data-kt-app-toolbar-minimize=on] .app-toolbar {
    transition: none;
    z-index: 99;
    box-shadow: var(--kt-app-toolbar-minimize-box-shadow);
    background-color: var(--kt-app-toolbar-minimize-bg-color);
    border-top: var(--kt-app-toolbar-minimize-border-top);
    border-bottom: var(--kt-app-toolbar-minimize-border-bottom);
  }

  [data-kt-app-toolbar-fixed=true][data-kt-app-header-fixed=true] .app-toolbar {
    top: var(--kt-app-header-height);
  }
  [data-kt-app-toolbar-sticky=on][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-toolbar=true] .app-toolbar, [data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-toolbar=true] .app-toolbar {
    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-toolbar-sticky=on][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-toolbar=true] .app-toolbar, [data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-toolbar=true] .app-toolbar {
    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));
  }
  [data-kt-app-toolbar-sticky=on][data-kt-app-aside-fixed=true][data-kt-app-aside-push-toolbar=true] .app-toolbar, [data-kt-app-toolbar-fixed=true][data-kt-app-aside-fixed=true][data-kt-app-aside-push-toolbar=true] .app-toolbar {
    right: calc(var(--kt-app-aside-width) + var(--kt-app-aside-gap-start, 0px) + var(--kt-app-aside-gap-end, 0px));
  }
}
@media (max-width: 991.98px) {
  .app-toolbar {
    z-index: 99;
    box-shadow: var(--kt-app-toolbar-base-box-shadow-mobile);
    background-color: var(--kt-app-toolbar-base-bg-color-mobile);
    border-top: var(--kt-app-toolbar-base-border-top-mobile);
    border-bottom: var(--kt-app-toolbar-base-border-bottom-mobile);
  }

  :root {
    --kt-app-toolbar-height: ;
  }

  [data-kt-app-toolbar-sticky=on] {
    --kt-app-toolbar-height: 70px;
  }

  [data-kt-app-toolbar-minimize=on] {
    --kt-app-toolbar-height: 70px;
  }

  .app-toolbar {
    height: var(--kt-app-toolbar-height);
  }
  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-fixed-mobile=true] .app-toolbar {
    z-index: 99;
    position: fixed;
    top: calc(var(--kt-app-header-height, 0px) + var(--kt-app-header-mobile-height, 0px));
    left: 0;
    right: 0;
  }
  [data-kt-app-toolbar-sticky=on] .app-toolbar {
    position: fixed;
    left: 0;
    right: 0;
    top: var(--kt-app-header-height, 0px);
    box-shadow: var(--kt-app-toolbar-sticky-box-shadow-mobile);
    background-color: var(--kt-app-toolbar-sticky-bg-color-mobile);
    border-top: var(--kt-app-toolbar-sticky-border-top-mobile);
    border-bottom: var(--kt-app-toolbar-sticky-border-bottom-mobile);
    z-index: 99;
  }
  [data-kt-app-toolbar-minimize=on] .app-toolbar {
    transition: none;
    box-shadow: var(--kt-app-toolbar-minimize-box-shadow-mobile);
    background-color: var(--kt-app-toolbar-minimize-bg-color-mobile);
    border-top: var(--kt-app-toolbar-minimize-border-top-mobile);
    border-bottom: var(--kt-app-toolbar-minimize-border-bottom-mobile);
    z-index: 99;
  }
}
.app-hero {
  display: flex;
  align-items: stretch;
  background-color: var(--kt-app-hero-bg-color);
  box-shadow: var(--kt-app-hero-box-shadow);
  border-top: var(--kt-app-hero-border-top);
  border-bottom: var(--kt-app-hero-border-bottom);
}

.app-sidebar {
  transition: width 0.3s ease;
}

.app-sidebar-minimize-d-flex,
.app-sidebar-sticky-d-flex,
.app-sidebar-collapse-d-flex,
.app-sidebar-minimize-mobile-d-flex,
.app-sidebar-collapse-mobile-d-flex {
  display: none;
}

@media (min-width: 992px) {
  .app-sidebar {
    display: flex;
    flex-shrink: 0;
    width: var(--kt-app-sidebar-width);
    background-color: var(--kt-app-sidebar-base-bg-color);
    box-shadow: var(--kt-app-sidebar-base-box-shadow);
    border-left: var(--kt-app-sidebar-base-border-start);
    border-right: var(--kt-app-sidebar-base-border-end);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  :root {
    --kt-app-sidebar-width: 265px;
    --kt-app-sidebar-width-actual: 265px;
    --kt-app-sidebar-gap-start: 0px;
    --kt-app-sidebar-gap-end: 0px;
    --kt-app-sidebar-gap-top: 0px;
    --kt-app-sidebar-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-stacked=true] {
    --kt-app-sidebar-width: calc(var(--kt-app-sidebar-primary-width) + var(--kt-app-sidebar-secondary-width));
  }

  [data-kt-app-sidebar-minimize=on] {
    --kt-app-sidebar-width: 75px;
    --kt-app-sidebar-gap-start: 0px;
    --kt-app-sidebar-gap-end: 0px;
    --kt-app-sidebar-gap-top: 0px;
    --kt-app-sidebar-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-sticky=on] {
    --kt-app-sidebar-width: 300px;
    --kt-app-sidebar-gap-start: 0px;
    --kt-app-sidebar-gap-end: 0px;
    --kt-app-sidebar-gap-top: 0px;
    --kt-app-sidebar-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-collapse=on] {
    --kt-app-sidebar-width: 0px;
  }

  [data-kt-app-sidebar-static=true] .app-sidebar {
    position: relative;
  }
  [data-kt-app-sidebar-offcanvas=true] .app-sidebar {
    display: none;
  }
  [data-kt-app-sidebar-fixed=true] .app-sidebar {
    position: fixed;
    z-index: 105;
    top: 0;
    bottom: 0;
    left: 0;
  }
  [data-kt-app-sidebar-stacked=true] .app-sidebar {
    align-items: stretch;
  }
  [data-kt-app-sidebar-sticky=on] .app-sidebar {
    position: fixed;
    transition: width 0.3s ease;
    top: auto;
    bottom: auto;
    left: auto;
    z-index: 105;
    box-shadow: var(--kt-app-sidebar-sticky-box-shadow);
    border-left: var(--kt-app-sidebar-sticky-border-start);
    border-right: var(--kt-app-sidebar-sticky-border-end);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-minimize=on] .app-sidebar {
    transition: width 0.3s ease;
    background-color: var(--kt-app-sidebar-minimize-bg-color);
    box-shadow: var(--kt-app-sidebar-minimize-box-shadow);
    border-left: var(--kt-app-sidebar-minimize-border-start);
    border-right: var(--kt-app-sidebar-minimize-border-end);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-hoverable=true] .app-sidebar .app-sidebar-wrapper {
    width: var(--kt-app-sidebar-width-actual);
  }
  [data-kt-app-sidebar-hoverable=true][data-kt-app-sidebar-minimize=on] .app-sidebar:hover:not(.animating) {
    transition: width 0.3s ease;
    width: var(--kt-app-sidebar-width-actual);
  }
  [data-kt-app-sidebar-collapse=on] .app-sidebar {
    transition: width 0.3s ease;
    width: var(--kt-app-sidebar-width-actual);
    margin-left: calc(-1 * var(--kt-app-sidebar-width-actual));
  }

  [data-kt-app-sidebar-minimize=on] .app-sidebar-minimize-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-minimize=on] .app-sidebar-minimize-d-flex {
    display: flex !important;
  }

  [data-kt-app-sidebar-sticky=on] .app-sidebar-sticky-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-sticky=on] .app-sidebar-sticky-d-flex {
    display: flex !important;
  }

  [data-kt-app-sidebar-collapse=on] .app-sidebar-collapse-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-collapse=on] .app-sidebar-collapse-d-flex {
    display: flex !important;
  }

  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true]:not([data-kt-app-sidebar-push-header=true]) .app-sidebar {
    top: var(--kt-app-header-height);
  }
  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true]:not([data-kt-app-sidebar-push-toolbar=true]) .app-sidebar {
    top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0px));
  }
}
@media (max-width: 991.98px) {
  .app-sidebar {
    display: none;
    width: var(--kt-app-sidebar-width);
    background-color: var(--kt-app-sidebar-base-bg-color-mobile);
    box-shadow: var(--kt-app-sidebar-base-box-shadow-mobile);
    border-left: var(--kt-app-sidebar-base-border-start-mobile);
    border-right: var(--kt-app-sidebar-base-border-end-mobile);
    z-index: 106;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  :root {
    --kt-app-sidebar-width: 250px;
    --kt-app-sidebar-width-actual: 250px;
    --kt-app-sidebar-gap-start: 0px;
    --kt-app-sidebar-gap-end: 0px;
    --kt-app-sidebar-gap-top: 0px;
    --kt-app-sidebar-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-minimize-mobile=on] {
    --kt-app-sidebar-width: 75px;
    --kt-app-sidebar-gap-start: 0px;
    --kt-app-sidebar-gap-end: 0px;
    --kt-app-sidebar-gap-top: 0px;
    --kt-app-sidebar-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-collapse-mobile=on] {
    --kt-app-sidebar-width: 0px;
  }

  [data-kt-app-sidebar-stacked=true] .app-sidebar {
    align-items: stretch;
  }
  [data-kt-app-sidebar-minimize-mobile=on] .app-sidebar {
    transition: width 0.3s ease;
    background-color: var(--kt-app-sidebar-minimize-bg-color-mobilee);
    box-shadow: var(--kt-app-sidebar-minimize-box-shadow-mobile);
    border-left: var(--kt-app-sidebar-minimize-border-start-mobile);
    border-right: var(--kt-app-sidebar-minimize-border-end-mobile);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-hoverable-mobile=true] .app-sidebar .app-sidebar-wrapper {
    width: var(--kt-app-sidebar-width-actual);
  }
  [data-kt-app-sidebar-hoverable-mobile=true][data-kt-app-sidebar-minimize-mobile=on] .app-sidebar:hover:not(.animating) {
    transition: width 0.3s ease;
    width: var(--kt-app-sidebar-width-actual);
    box-shadow: var(--kt-app-sidebar-minimize-hover-box-shadow-mobile);
  }
  [data-kt-app-sidebar-collapse-mobile=on] .app-sidebar {
    transition: width 0.3s ease;
    width: var(--kt-app-sidebar-width-actual);
    margin-left: calc(-1 * var(--kt-app-sidebar-width-actual));
  }

  [data-kt-app-sidebar-minimize-mobile=on] .app-sidebar-minimize-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-minimize-mobile=on] .app-sidebar-minimize-mobile-d-flex {
    display: flex !important;
  }

  [data-kt-app-sidebar-collapse-mobile=on] .app-sidebar-collapse-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-collapse-mobile=on] .app-sidebar-collapse-mobile-d-flex {
    display: flex !important;
  }
}
.app-sidebar-primary {
  transition: none;
  position: relative;
  flex-shrink: 0;
}

.app-sidebar-primary-collapse-d-flex,
.app-sidebar-primary-minimize-d-flex,
.app-sidebar-primary-collapse-mobile-d-flex,
.app-sidebar-primary-minimize-mobile-d-flex {
  display: none;
}

@media (min-width: 992px) {
  .app-sidebar-primary {
    background-color: var(--kt-app-sidebar-primary-base-bg-color);
    box-shadow: var(--kt-app-sidebar-primary-base-box-shadow);
    border-left: var(--kt-app-sidebar-primary-base-border-start);
    border-right: var(--kt-app-sidebar-primary-base-border-end);
    z-index: 1;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  :root {
    --kt-app-sidebar-primary-width-actual: 100px;
  }

  [data-kt-app-sidebar-stacked=true] {
    --kt-app-sidebar-primary-width: 100px;
    --kt-app-sidebar-primary-gap-start: 0px;
    --kt-app-sidebar-primary-gap-end: 0px;
    --kt-app-sidebar-primary-gap-top: 0px;
    --kt-app-sidebar-primary-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-primary-minimize=on] {
    --kt-app-sidebar-primary-width: 75px;
    --kt-app-sidebar-primary-gap-start: 0px;
    --kt-app-sidebar-primary-gap-end: 0px;
    --kt-app-sidebar-primary-gap-top: 0px;
    --kt-app-sidebar-primary-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-primary-collapse=on] {
    --kt-app-sidebar-primary-width: 0px;
  }

  .app-sidebar-primary {
    width: var(--kt-app-sidebar-primary-width);
  }
  [data-kt-app-sidebar-primary-collapse=on] .app-sidebar-primary {
    transition: none;
    width: var(--kt-app-sidebar-primary-width-actual);
    margin-left: calc(-1 * var(--kt-app-sidebar-primary-width-actual));
  }
  [data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary {
    transition: none;
    background-color: var(--kt-app-sidebar-primary-minimize-bg-color);
    box-shadow: var(--kt-app-sidebar-primary-minimize-box-shadow);
    border-left: var(--kt-app-sidebar-primary-minimize-border-start);
    border-right: var(--kt-app-sidebar-primary-minimize-border-end);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-primary-hoverable=true] .app-sidebar-primary .app-sidebar-primary-hoverable {
    width: var(--kt-app-sidebar-primary-width-actual);
  }
  [data-kt-app-sidebar-primary-hoverable=true][data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary:hover:not(.animating) {
    transition: none;
    width: var(--kt-app-sidebar-primary-width-actual);
    box-shadow: var(--kt-app-sidebar-primary-minimize-hover-box-shadow);
  }

  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-sidebar-primary-below-header=true] .app-sidebar-primary {
    top: var(--kt-app-header-height);
  }
  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-primary-below-toolbar=true] .app-sidebar-primary {
    top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0));
  }

  [data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary-minimize-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary-minimize-d-flex {
    display: flex !important;
  }

  [data-kt-app-sidebar-primary-collapse=on] .app-sidebar-primary-collapse-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-primary-collapse=on] .app-sidebar-primary-collapse-d-flex {
    display: flex !important;
  }
}
@media (max-width: 991.98px) {
  .app-sidebar-primary {
    z-index: 1;
    background-color: var(--kt-app-sidebar-primary-base-bg-color-mobile);
    box-shadow: var(--kt-app-sidebar-primary-base-box-shadow-mobile);
    border-left: var(--kt-app-sidebar-primary-base-border-start-mobile);
    border-right: var(--kt-app-sidebar-primary-base-border-end-mobile);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  :root {
    --kt-app-sidebar-primary-width-actual: 100px;
  }

  [data-kt-app-sidebar-stacked=true] {
    --kt-app-sidebar-primary-width: 100px;
    --kt-app-sidebar-primary-gap-start: 0px;
    --kt-app-sidebar-primary-gap-end: 0px;
    --kt-app-sidebar-primary-gap-top: 0px;
    --kt-app-sidebar-primary-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-primary-minimize-mobile=on] {
    --kt-app-sidebar-primary-width: 75px;
    --kt-app-sidebar-primary-gap-start: 0px;
    --kt-app-sidebar-primary-gap-end: 0px;
    --kt-app-sidebar-primary-gap-top: 0px;
    --kt-app-sidebar-primary-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-primary-collapse-mobile=on] {
    --kt-app-sidebar-primary-width: 0px;
  }

  .app-sidebar-primary {
    width: var(--kt-app-sidebar-primary-width);
  }
  [data-kt-app-sidebar-primary-collapse-mobile=on] .app-sidebar-primary {
    transition: none;
    width: var(--kt-app-sidebar-primary-width-actual);
    margin-left: calc(-1 * var(--kt-app-sidebar-primary-width-actual));
  }
  [data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary {
    transition: none;
    background-color: var(--kt-app-sidebar-primary-minimize-bg-color-mobile);
    box-shadow: var(--kt-app-sidebar-primary-base-box-shadow-mobile);
    border-left: var(--kt-app-sidebar-primary-minimize-border-start-mobile);
    border-left: var(--kt-app-sidebar-primary-minimize-border-end-mobile);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-primary-hoverable-mobile=true] .app-sidebar-primary .app-sidebar-primary-hoverable {
    width: var(--kt-app-sidebar-primary-width-actual);
  }
  [data-kt-app-sidebar-primary-hoverable-mobile=true][data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary:hover:not(.animating) {
    transition: none;
    width: var(--kt-app-sidebar-primary-width-actual);
    box-shadow: var(--kt-app-sidebar-primary-minimize-hover-box-shadow-mobile);
  }

  [data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary-minimize-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary-minimize-mobile-d-flex {
    display: flex !important;
  }

  [data-kt-app-sidebar-primary-collapse-mobile=on] .app-sidebar-primary-collapse-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-primary-collapse-mobile=on] .app-sidebar-primary-collapse-mobile-d-flex {
    display: flex !important;
  }
}
.app-sidebar-secondary {
  transition: none;
  position: relative;
  flex-shrink: 0;
}

.app-sidebar-secondary-collapse-d-flex,
.app-sidebar-secondary-minimize-d-flex,
.app-sidebar-secondary-collapse-mobile-d-flex,
.app-sidebar-secondary-minimize-mobile-d-flex {
  display: none;
}

@media (min-width: 992px) {
  .app-sidebar-secondary {
    background-color: var(--kt-app-sidebar-secondary-base-bg-color);
    box-shadow: var(--kt-app-sidebar-secondary-base-box-shadow);
    border-left: var(--kt-app-sidebar-secondary-base-border-start);
    border-right: var(--kt-app-sidebar-secondary-base-border-end);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  :root {
    --kt-app-sidebar-secondary-width-actual: calc(
        265px -
        100px -
        0px -
        0px -
        0px -
        0px
    );
  }

  [data-kt-app-sidebar-stacked=true] {
    --kt-app-sidebar-secondary-width: calc(
        265px -
        100px -
        0px -
        0px -
        0px -
        0px
    );
    --kt-app-sidebar-secondary-gap-start: 0px;
    --kt-app-sidebar-secondary-gap-end: 0px;
    --kt-app-sidebar-secondary-gap-top: 0px;
    --kt-app-sidebar-secondary-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-secondary-minimize=on] {
    --kt-app-sidebar-secondary-width: 75px;
    --kt-app-sidebar-secondary-gap-start: 0px;
    --kt-app-sidebar-secondary-gap-end: 0px;
    --kt-app-sidebar-secondary-gap-top: 0px;
    --kt-app-sidebar-secondary-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-secondary-collapse=on] {
    --kt-app-sidebar-secondary-width-actual: calc(
        265px -
        100px -
        0px -
        0px -
        0px -
        0px
    );
    --kt-app-sidebar-secondary-width: 0px;
  }

  .app-sidebar-secondary {
    width: var(--kt-app-sidebar-secondary-width);
  }
  [data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary {
    transition: none;
    width: var(--kt-app-sidebar-secondary-width-actual);
    margin-left: calc(-1 * var(--kt-app-sidebar-secondary-width-actual));
  }
  [data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary {
    transition: none;
    background-color: var(--kt-app-sidebar-secondary-minimize-bg-color);
    box-shadow: var(--kt-app-sidebar-secondary-minimize-box-shadow);
    border-left: var(--kt-app-sidebar-secondary-minimize-border-start);
    border-right: var(--kt-app-sidebar-secondary-minimize-border-end);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-secondary-hoverable=true] .app-sidebar-secondary .app-sidebar-secondary-hoverable {
    width: var(--kt-app-sidebar-secondary-width-actual);
  }
  [data-kt-app-sidebar-secondary-hoverable=true][data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary:hover:not(.animating) {
    transition: none;
    width: var(--kt-app-sidebar-secondary-width-actual);
    box-shadow: var(--kt-app-sidebar-secondary-minimize-hover-box-shadow);
  }

  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-sidebar-secondary-below-header=true] .app-sidebar-secondary {
    top: var(--kt-app-header-height);
  }
  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-secondary-below-toolbar=true] .app-sidebar-secondary {
    top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0));
  }

  [data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary-minimize-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary-minimize-d-flex {
    display: flex !important;
  }

  [data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-d-flex {
    display: flex !important;
  }
}
@media (max-width: 991.98px) {
  .app-sidebar-secondary {
    background-color: var(--kt-app-sidebar-secondary-base-bg-color-mobile);
    box-shadow: var(--kt-app-sidebar-secondary-base-box-shadow-mobile);
    border-left: var(--kt-app-sidebar-secondary-base-border-start-mobile);
    border-right: var(--kt-app-sidebar-secondary-base-border-end-mobile);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  :root {
    --kt-app-sidebar-secondary-width-actual: calc(
        250px -
        100px -
        0px -
        0px -
        0px -
        0px
    );
  }

  [data-kt-app-sidebar-stacked=true] {
    --kt-app-sidebar-secondary-width: calc(
        250px -
        100px -
        0px -
        0px -
        0px -
        0px
    );
    --kt-app-sidebar-secondary-gap-start: 0px;
    --kt-app-sidebar-secondary-gap-end: 0px;
    --kt-app-sidebar-secondary-gap-top: 0px;
    --kt-app-sidebar-secondary-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-secondary-minimize-mobile=on] {
    --kt-app-sidebar-secondary-width: 75px;
    --kt-app-sidebar-secondary-gap-start: 0px;
    --kt-app-sidebar-secondary-gap-end: 0px;
    --kt-app-sidebar-secondary-gap-top: 0px;
    --kt-app-sidebar-secondary-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-secondary-collapse-mobile=on] {
    --kt-app-sidebar-secondary-width-actual: calc(
        250px -
        100px -
        0px -
        0px -
        0px -
        0px
    );
    --kt-app-sidebar-secondary-width: 0px;
  }

  .app-sidebar-secondary {
    width: var(--kt-app-sidebar-secondary-width);
  }
  [data-kt-app-sidebar-secondary-collapse-mobile=on] .app-sidebar-secondary {
    transition: none;
    width: var(--kt-app-sidebar-secondary-width-actual);
    margin-left: calc(-1 * var(--kt-app-sidebar-secondary-width-actual));
  }
  [data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary {
    transition: none;
    background-color: var(--kt-app-sidebar-secondary-minimize-bg-color-mobile);
    box-shadow: var(--kt-app-sidebar-secondary-minimize-box-shadow-mobile);
    border-left: var(--kt-app-sidebar-secondary-minimize-border-start-mobile);
    border-right: var(--kt-app-sidebar-secondary-minimize-border-end-mobile);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-secondary-hoverable-mobile=true] .app-sidebar-secondary .app-sidebar-secondary-hoverable {
    width: var(--kt-app-sidebar-secondary-width-actual);
  }
  [data-kt-app-sidebar-secondary-hoverable-mobile=true][data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary:hover:not(.animating) {
    transition: none;
    width: var(--kt-app-sidebar-secondary-width-actual);
    box-shadow: var(--kt-app-sidebar-secondary-minimize-hover-box-shadow-mobile);
  }

  [data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary-minimize-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary-minimize-mobile-d-flex {
    display: flex !important;
  }

  [data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-mobile-d-flex {
    display: flex !important;
  }
}
.app-sidebar-panel {
  transition: none;
}

.app-sidebar-panel-minimize-d-flex,
.app-sidebar-panel-sticky-d-flex,
.app-sidebar-panel-collapse-d-flex,
.app-sidebar-panel-minimize-mobile-d-flex,
.app-sidebar-panel-collapse-mobile-d-flex {
  display: none;
}

@media (min-width: 992px) {
  .app-sidebar-panel {
    display: flex;
    flex-shrink: 0;
    width: var(--kt-app-sidebar-panel-width);
    background-color: var(--kt-app-sidebar-panel-base-bg-color);
    box-shadow: var(--kt-app-sidebar-panel-base-box-shadow);
    border-left: var(--kt-app-sidebar-panel-base-border-start);
    border-right: var(--kt-app-sidebar-panel-base-border-end);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  :root {
    --kt-app-sidebar-panel-width: 300px;
    --kt-app-sidebar-panel-width-actual: 300px;
    --kt-app-sidebar-panel-gap-start: 0px;
    --kt-app-sidebar-panel-gap-end: 0px;
    --kt-app-sidebar-panel-gap-top: 0px;
    --kt-app-sidebar-panel-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-panel-minimize=on] {
    --kt-app-sidebar-panel-width: 75px;
    --kt-app-sidebar-panel-gap-start: 0px;
    --kt-app-sidebar-panel-gap-end: 0px;
    --kt-app-sidebar-panel-gap-top: 0px;
    --kt-app-sidebar-panel-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-panel-sticky=on] {
    --kt-app-sidebar-panel-width: 300px;
    --kt-app-sidebar-panel-gap-start: 0px;
    --kt-app-sidebar-panel-gap-end: 0px;
    --kt-app-sidebar-panel-gap-top: 0px;
    --kt-app-sidebar-panel-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-panel-collapse=on] {
    --kt-app-sidebar-panel-width-actual: 300px;
    --kt-app-sidebar-panel-width: 0px;
  }

  [data-kt-app-sidebar-panel-static=true] .app-sidebar-panel {
    position: relative;
  }
  [data-kt-app-sidebar-panel-offcanvas=true] .app-sidebar-panel {
    display: none;
  }
  [data-kt-app-sidebar-panel-fixed=true] .app-sidebar-panel {
    z-index: 104;
    position: fixed;
    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));
    top: 0;
    bottom: 0;
  }
  [data-kt-app-sidebar-panel-sticky=on] .app-sidebar-panel {
    position: fixed;
    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));
    top: 0;
    bottom: 0;
    transition: none;
    box-shadow: var(--kt-app-sidebar-panel-sticky-box-shadow);
    border-left: var(--kt-app-sidebar-panel-sticky-border-start);
    border-right: var(--kt-app-sidebar-panel-sticky-border-end);
    z-index: 104;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel {
    transition: none;
    background-color: var(--kt-app-sidebar-panel-minimize-bg-color);
    box-shadow: var(--kt-app-sidebar-panel-minimize-box-shadow);
    border-left: var(--kt-app-sidebar-panel-minimize-border-start);
    border-right: var(--kt-app-sidebar-panel-minimize-border-end);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-panel-hoverable=true] .app-sidebar-panel .app-sidebar-panel-hoverable {
    width: var(--kt-app-sidebar-panel-width-actual);
  }
  [data-kt-app-sidebar-panel-hoverable=true][data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel:hover:not(.animating) {
    transition: none;
    width: var(--kt-app-sidebar-panel-width-actual);
    box-shadow: var(--kt-app-sidebar-panel-minimize-hover-box-shadow);
  }
  [data-kt-app-sidebar-panel-collapse=on] .app-sidebar-panel {
    transition: none;
    width: var(--kt-app-sidebar-panel-width-actual);
    margin-left: calc(-1 * (var(--kt-app-sidebar-panel-width-actual) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px)));
  }

  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-header-fixed=true]:not([data-kt-app-sidebar-panel-push-header=true]) .app-sidebar-panel {
    top: var(--kt-app-header-height);
  }
  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true]:not([data-kt-app-sidebar-panel-push-toolbar=true]) .app-sidebar-panel {
    top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0));
  }

  [data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel-minimize-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel-minimize-d-flex {
    display: flex !important;
  }

  [data-kt-app-sidebar-panel-sticky=on] .app-sidebar-panel-sticky-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-panel-sticky=on] .app-sidebar-panel-sticky-d-flex {
    display: flex !important;
  }

  [data-kt-app-sidebar-panel-collapse=on] .app-sidebar-panel-collapse-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-panel-collapse=on] .app-sidebar-panel-collapse-d-flex {
    display: flex !important;
  }
}
@media (max-width: 991.98px) {
  .app-sidebar-panel {
    display: none;
    width: var(--kt-app-sidebar-panel-width);
    background-color: var(--kt-app-sidebar-panel-base-bg-color-mobile);
    box-shadow: var(--kt-app-sidebar-panel-base-box-shadow-mobile);
    border-left: var(--kt-app-sidebar-panel-base-border-start-mobile);
    border-right: var(--kt-app-sidebar-panel-base-border-end-mobile);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  :root {
    --kt-app-sidebar-panel-gap-start: 0px;
    --kt-app-sidebar-panel-gap-end: 0px;
    --kt-app-sidebar-panel-gap-top: 0px;
    --kt-app-sidebar-panel-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-panel-minimize-mobile=on] {
    --kt-app-sidebar-panel-width: 75px;
    --kt-app-sidebar-panel-gap-start: 0px;
    --kt-app-sidebar-panel-gap-end: 0px;
    --kt-app-sidebar-panel-gap-top: 0px;
    --kt-app-sidebar-panel-gap-bottom: 0px;
  }

  [data-kt-app-sidebar-panel-collapse-mobile=on] {
    --kt-app-sidebar-panel-width-actual: 300px;
    --kt-app-sidebar-panel-width: 0px;
  }

  [data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel {
    transition: none;
    background-color: var(--kt-app-sidebar-panel-minimize-bg-color-mobile);
    box-shadow: var(--kt-app-sidebar-panel-minimize-box-shadow-mobile);
    border-left: var(--kt-app-sidebar-panel-minimize-border-start-mobile);
    border-right: var(--kt-app-sidebar-panel-minimize-border-end-mobile);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-sidebar-panel-hoverable-mobile=true] .app-sidebar-panel .app-sidebar-panel-hoverable {
    width: var(--kt-app-sidebar-panel-width-actual);
  }
  [data-kt-app-sidebar-panel-hoverable-mobile=true][data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel:hover:not(.animating) {
    transition: none;
    width: var(--kt-app-sidebar-panel-width-actual);
    box-shadow: var(--kt-app-sidebar-panel-minimize-hover-box-shadow-mobile);
  }
  [data-kt-app-sidebar-panel-collapse-mobile=on] .app-sidebar-panel {
    transition: none;
    width: var(--kt-app-sidebar-panel-width-actual);
    margin-left: calc(-1 * var(--kt-app-sidebar-panel-width-actual));
  }

  [data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel-minimize-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel-minimize-mobile-d-flex {
    display: flex !important;
  }

  [data-kt-app-sidebar-panel-collapse-mobile=on] .app-sidebar-panel-collapse-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-sidebar-panel-collapse-mobile=on] .app-sidebar-panel-collapse-mobile-d-flex {
    display: flex !important;
  }
}
.app-aside {
  transition: none;
}

.app-aside-minimize-d-flex,
.app-aside-sticky-d-flex,
.app-aside-collapse-d-flex,
.app-aside-minimize-mobile-d-flex,
.app-aside-collapse-mobile-d-flex {
  display: none;
}

@media (min-width: 992px) {
  .app-aside {
    display: flex;
    flex-shrink: 0;
    width: var(--kt-app-aside-width);
    background-color: var(--kt-app-aside-base-bg-color);
    box-shadow: var(--kt-app-aside-base-box-shadow);
    border-left: var(--kt-app-aside-base-border-left);
    border-right: var(--kt-app-aside-base-border-right);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  :root {
    --kt-app-aside-width: 300px;
    --kt-app-aside-width-actual: 300px;
    --kt-app-aside-gap-start: 0px;
    --kt-app-aside-gap-end: 0px;
    --kt-app-aside-gap-top: 0px;
    --kt-app-aside-gap-bottom: 0px;
  }

  [data-kt-app-aside-stacked=true] {
    --kt-app-aside-width: calc(var(--kt-app-aside-primary-width) + var(--kt-app-aside-secondary-width));
  }

  [data-kt-app-aside-minimize=on] {
    --kt-app-aside-width: 75px;
    --kt-app-aside-gap-start: 0px;
    --kt-app-aside-gap-end: 0px;
    --kt-app-aside-gap-top: 0px;
    --kt-app-aside-gap-bottom: 0px;
  }

  [data-kt-app-aside-sticky=on] {
    --kt-app-aside-width: 300px;
    --kt-app-aside-gap-start: 0px;
    --kt-app-aside-gap-end: 0px;
    --kt-app-aside-gap-top: 0px;
    --kt-app-aside-gap-bottom: 0px;
  }

  [data-kt-app-aside-collapse=on] {
    --kt-app-aside-width: 0px;
  }

  [data-kt-app-aside-static=true] .app-aside {
    position: relative;
  }
  [data-kt-app-aside-offcanvas=true] .app-aside {
    display: none;
  }
  [data-kt-app-aside-fixed=true] .app-aside {
    position: fixed;
    z-index: 105;
    top: 0;
    bottom: 0;
    right: 0;
  }
  [data-kt-app-aside-stacked=true] .app-aside {
    align-items: stretch;
  }
  [data-kt-app-aside-sticky=on] .app-aside {
    position: fixed;
    transition: none;
    box-shadow: var(--kt-app-aside-sticky-box-shadow);
    border-left: var(--kt-aside-sticky-border-start);
    border-right: var(--kt-app-aside-sticky-border-end);
    top: auto;
    bottom: auto;
    left: auto;
    z-index: 105;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-aside-minimize=on] .app-aside {
    transition: none;
    background-color: var(--kt-app-aside-minimize-bg-color);
    box-shadow: var(--kt-app-aside-minimize-box-shadow);
    border-start: var(--kt-app-aside-minimize-border-start);
    border-end: var(--kt-app-aside-minimize-border-end);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-aside-hoverable=true] .app-aside .app-aside-wrapper {
    width: var(--kt-app-aside-width-actual);
  }
  [data-kt-app-aside-hoverable=true][data-kt-app-aside-minimize=on] .app-aside:hover:not(.animating) {
    transition: none;
    width: var(--kt-app-aside-width-actual);
    box-shadow: var(--kt-app-aside-minimize-hover-box-shadow);
  }
  [data-kt-app-aside-collapse=on] .app-aside {
    transition: none;
    width: var(--kt-app-aside-width-actual);
    margin-right: calc(-1 * var(--kt-app-aside-width-actual));
  }

  [data-kt-app-aside-minimize=on] .app-aside-minimize-d-none {
    display: none !important;
  }
  [data-kt-app-aside-minimize=on] .app-aside-minimize-d-flex {
    display: flex !important;
  }

  [data-kt-app-aside-sticky=on] .app-aside-sticky-d-none {
    display: none !important;
  }
  [data-kt-app-aside-sticky=on] .app-aside-sticky-d-flex {
    display: flex !important;
  }

  [data-kt-app-aside-collapse=on] .app-aside-collapse-d-none {
    display: none !important;
  }
  [data-kt-app-aside-collapse=on] .app-aside-collapse-d-flex {
    display: flex !important;
  }

  [data-kt-app-aside-fixed=true][data-kt-app-header-fixed=true]:not([data-kt-app-aside-push-header=true]) .app-aside {
    top: var(--kt-app-header-height);
  }
  [data-kt-app-aside-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true]:not([data-kt-app-aside-push-toolbar=true]) .app-aside {
    top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0px));
  }
}
@media (max-width: 991.98px) {
  .app-aside {
    display: none;
    width: var(--kt-app-aside-width);
    z-index: 106;
    background-color: var(--kt-app-aside-base-bg-color-mobile);
    box-shadow: var(--kt-app-aside-base-box-shadow-mobile);
    border-left: var(--kt-app-aside-base-border-start-mobile);
    order-right: var(--kt-app-aside-base-border-end-mobile);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  :root {
    --kt-app-aside-width: 275px;
    --kt-app-aside-width-actual: 275px;
    --kt-app-aside-gap-start: 0px;
    --kt-app-aside-gap-end: 0px;
    --kt-app-aside-gap-top: 0px;
    --kt-app-aside-gap-bottom: 0px;
  }

  [data-kt-app-aside-minimize-mobile=on] {
    --kt-app-aside-width: 75px;
    --kt-app-aside-gap-start: 0px;
    --kt-app-aside-gap-end: 0px;
    --kt-app-aside-gap-top: 0px;
    --kt-app-aside-gap-bottom: 0px;
  }

  [data-kt-app-aside-collapse-mobile=on] {
    --kt-app-aside-width: 0px;
  }

  [data-kt-app-aside-stacked=true] .app-aside {
    align-items: stretch;
  }
  [data-kt-app-aside-minimize-mobile=on] .app-aside {
    transition: none;
    background-color: var(--kt-app-aside-minimize-bg-color-mobile);
    box-shadow: var(--kt-app-aside-minimize-box-shadow-mobile);
    border-left: var(--kt-app-aside-minimize-border-start-mobile);
    border-right: var(--kt-app-aside-minimize-border-end-mobile);
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
  [data-kt-app-aside-hoverable-mobile=true] .app-aside .app-aside-wrapper {
    width: var(--kt-app-aside-width-actual);
  }
  [data-kt-app-aside-hoverable-mobile=true][data-kt-app-aside-minimize-mobile=on] .app-aside:hover:not(.animating) {
    transition: none;
    width: var(--kt-app-aside-width-actual);
    box-shadow: var(--kt-app-aside-minimize-hover-box-shadow-mobile);
  }
  [data-kt-app-aside-collapse-mobile=on] .app-aside {
    transition: none;
    width: var(--kt-app-aside-width-actual);
    margin-right: calc(-1 * var(--kt-app-aside-width-actual));
  }

  [data-kt-app-aside-minimize-mobile=on] .app-aside-minimize-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-aside-minimize-mobile=on] .app-aside-minimize-mobile-d-flex {
    display: flex !important;
  }

  [data-kt-app-aside-collapse-mobile=on] .app-aside-collapse-mobile-d-none {
    display: none !important;
  }
  [data-kt-app-aside-collapse-mobile=on] .app-aside-collapse-mobile-d-flex {
    display: flex !important;
  }
}
.app-wrapper {
  display: flex;
}

@media (min-width: 992px) {
  .app-wrapper {
    transition: margin-left 0.3s ease, margin-right 0.3s ease;
  }
  [data-kt-app-header-sticky=on] .app-wrapper {
    margin-top: var(--kt-app-header-height-actual);
  }
  [data-kt-app-header-fixed=true] .app-wrapper {
    margin-top: var(--kt-app-header-height);
  }
  [data-kt-app-toolbar-sticky=on] .app-wrapper {
    margin-top: var(--kt-app-toolbar-height);
  }
  [data-kt-app-header-fixed=true][data-kt-app-toolbar-sticky=on] .app-wrapper {
    margin-top: calc(var(--kt-app-header-height-actual) + var(--kt-app-toolbar-height-actual));
  }
  [data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true] .app-wrapper {
    margin-top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height));
  }
  [data-kt-app-sidebar-fixed=true] .app-wrapper {
    margin-left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-sidebar-panel-fixed=true] .app-wrapper {
    margin-left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));
  }
  [data-kt-app-aside-fixed=true] .app-wrapper {
    margin-right: calc(var(--kt-app-aside-width) + var(--kt-app-aside-gap-start, 0px) + var(--kt-app-aside-gap-end, 0px));
  }
  [data-kt-app-footer-fixed=true] .app-wrapper {
    margin-bottom: var(--kt-app-footer-height);
  }
}
@media (max-width: 991.98px) {
  .app-wrapper {
    transition: margin-left 0.3s ease, margin-right 0.3s ease;
  }
  [data-kt-app-header-sticky=on] .app-wrapper {
    margin-top: var(--kt-app-header-height-actual);
  }
  [data-kt-app-header-fixed-mobile=true] .app-wrapper {
    margin-top: var(--kt-app-header-height);
  }
  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-sticky=on] .app-wrapper {
    margin-top: calc(var(--kt-app-header-height-actual) + var(--kt-app-toolbar-height-actual));
  }
  [data-kt-app-footer-fixed-mobile=true] .app-wrapper {
    margin-bottom: var(--kt-app-footer-height);
  }
}
.app-main {
  display: flex;
}

@media (min-width: 992px) {
  .app-main {
    transition: margin 0.3s ease;
  }

  [data-kt-app-sidebar-sticky=true] .app-main {
    margin-left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-sidebar-panel-sticky=true] .app-main {
    margin-left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));
  }
  [data-kt-app-aside-sticky=true] .app-main {
    margin-right: calc(var(--kt-app-aside-width) + var(--kt-app-aside-gap-start, 0px) + var(--kt-app-aside-gap-end, 0px));
  }
}
@media (max-width: 991.98px) {
  .app-main {
    padding-left: 0;
    padding-right: 0;
  }
}
@media (min-width: 992px) {
  .app-content {
    padding-top: 30px;
    padding-bottom: 30px;
    padding-left: 0;
    padding-right: 0;
  }
}
@media (max-width: 991.98px) {
  .app-content {
    max-width: none;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 0;
    padding-right: 0;
  }
}
.app-footer {
  transition: left 0.3s ease, right 0.3s ease;
  display: flex;
  align-items: stretch;
}

@media (min-width: 992px) {
  .app-footer {
    background-color: var(--kt-app-footer-bg-color);
    box-shadow: var(--kt-app-footer-box-shadow);
    border-top: var(--kt-app-footer-border-top);
  }

  :root {
    --kt-app-footer-height: 60px;
  }

  .app-footer {
    height: var(--kt-app-footer-height);
  }
  [data-kt-app-footer-fixed=true] .app-footer {
    z-index: 100;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
  }

  [data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-footer=true] .app-footer {
    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));
  }
  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-footer=true] .app-footer {
    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));
  }
  [data-kt-app-aside-fixed=true][data-kt-app-aside-push-footer=true] .app-footer {
    right: calc(var(--kt-app-aside-width) + var(--kt-app-aside-gap-start, 0px) + var(--kt-app-aside-gap-end, 0px));
  }
}
@media (max-width: 991.98px) {
  .app-footer {
    background-color: var(--kt-app-footer-bg-color-mobile);
    box-shadow: var(--kt-app-footer-box-shadow-mobile);
    border-top: var(--kt-app-footer-border-top-mobile);
  }

  body {
    --kt-app-footer-height: auto;
  }

  .app-footer {
    height: var(--kt-app-footer-height);
  }
  [data-kt-app-footer-fixed-mobile=true] .app-footer {
    z-index: 100;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
.app-layout-builder-toggle {
  position: fixed;
  z-index: 105;
  bottom: 40px;
  right: 50px;
}

@media (max-width: 991.98px) {
  .app-layout-builder-toggle {
    bottom: 20px;
    right: 40px;
  }
}
html:not([data-theme=dark]) {
  --kt-app-bg-color: #f5f8fa;
  --kt-app-blank-bg-color: #ffffff;
  --kt-app-header-base-bg-color: #ffffff;
  --kt-app-header-base-bg-color-mobile: #ffffff;
  --kt-app-header-base-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  --kt-app-header-base-box-shadow-mobile: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  --kt-app-header-base-menu-link-bg-color-active: #F4F6FA;
  --kt-app-header-light-separator-color: #E4E6EF;
  --kt-app-sidebar-base-toggle-btn-box-shadow: 0px 0px 10px rgba(113, 121, 136, 0.1);
  --kt-app-sidebar-base-toggle-btn-bg-color: #ffffff;
  --kt-app-sidebar-light-bg-color: #ffffff;
  --kt-app-sidebar-light-box-shadow: 0 0 28px 0 rgba(82, 63, 105, 0.05);
  --kt-app-sidebar-light-separator-color: #E4E6EF;
  --kt-app-sidebar-light-scrollbar-color: #eff2f5;
  --kt-app-sidebar-light-scrollbar-color-hover: #eff2f5;
  --kt-app-sidebar-light-menu-heading-color: #B5B5C3;
  --kt-app-sidebar-light-menu-link-bg-color-active: #F4F6FA;
  --kt-app-sidebar-light-header-menu-link-bg-color-active: #EAEEF2;
  --kt-app-toolbar-base-bg-color: #ffffff;
  --kt-app-toolbar-base-bg-color-mobile: #ffffff;
  --kt-app-toolbar-base-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  --kt-app-toolbar-base-box-shadow-mobile: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  --kt-app-toolbar-base-border-top: 1px solid #eff2f5;
  --kt-app-toolbar-base-border-top-mobile: 1px solid #eff2f5;
  --kt-app-footer-bg-color: #ffffff;
  --kt-app-footer-bg-color-mobile: #ffffff;
}

[data-theme=dark] {
  --kt-app-bg-color: #151521;
  --kt-app-blank-bg-color: #151521;
  --kt-app-header-base-bg-color: #1e1e2d;
  --kt-app-header-base-bg-color-mobile: #1e1e2d;
  --kt-app-header-base-box-shadow: none;
  --kt-app-header-base-box-shadow-mobile: none;
  --kt-app-header-base-menu-link-bg-color-active: #2A2A3C;
  --kt-app-header-light-separator-color: #2B2B40;
  --kt-app-sidebar-base-toggle-btn-box-shadow: none;
  --kt-app-sidebar-base-toggle-btn-bg-color: #2A2A3C;
  --kt-app-sidebar-light-bg-color: #1e1e2d;
  --kt-app-sidebar-light-box-shadow: none;
  --kt-app-sidebar-light-separator-color: #2B2B40;
  --kt-app-sidebar-light-scrollbar-color: #2B2B40;
  --kt-app-sidebar-light-scrollbar-color-hover: #2B2B40;
  --kt-app-sidebar-light-menu-heading-color: #565674;
  --kt-app-sidebar-light-menu-link-bg-color-active: #2A2A3C;
  --kt-app-sidebar-light-header-menu-link-bg-color-active: #1b1b29;
  --kt-app-toolbar-base-bg-color: #1a1a27;
  --kt-app-toolbar-base-bg-color-mobile: #1a1a27;
  --kt-app-toolbar-base-box-shadow: none;
  --kt-app-toolbar-base-box-shadow-mobile: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);
  --kt-app-toolbar-base-border-top: 0;
  --kt-app-toolbar-base-border-top-mobile: 1px solid #eff2f5;
  --kt-app-footer-bg-color: #1e1e2d;
  --kt-app-footer-bg-color-mobile: #1e1e2d;
}

@media (min-width: 992px) {
  .app-sidebar-toggle {
    box-shadow: var(--kt-app-sidebar-base-toggle-btn-box-shadow) !important;
    background-color: var(--kt-app-sidebar-base-toggle-btn-bg-color) !important;
  }
  .app-sidebar-toggle .active .svg-icon {
    transform: rotateZ(0deg) !important;
  }

  [dir=rtl] .app-sidebar-toggle .svg-icon {
    transform: rotateZ(180deg);
  }
  [dir=rtl] .app-sidebar-toggle.active .svg-icon {
    transform: rotateZ(0deg) !important;
  }

  .app-sidebar-logo {
    height: var(--kt-app-header-height);
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    flex-shrink: 0;
  }

  .app-sidebar-menu .menu > .menu-item {
    margin-left: 0.115rem;
  }
}
@media (max-width: 991.98px) {
  .app-sidebar-logo {
    display: none;
  }
}
.app-sidebar-logo-minimize {
  display: none;
}

.app-sidebar-footer .btn-custom .btn-icon {
  display: none;
}

@media (min-width: 992px) {
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-logo .app-sidebar-logo-default {
    display: none;
  }
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-logo .app-sidebar-logo-minimize {
    display: inline-block;
  }
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-wrapper {
    width: var(--kt-app-sidebar-width-actual);
  }
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-menu .menu-content,
[data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-menu .menu-title {
    opacity: 0;
    transition: opacity 0.3s ease !important;
  }
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-menu .menu-item.show > .menu-sub {
    height: 0;
    overflow: hidden;
    transition: height 0.3s ease !important;
  }
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-footer .btn-custom {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-footer .btn-custom .btn-label {
    width: 0;
    display: none;
  }
  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-footer .btn-custom .btn-icon {
    width: auto;
    display: block;
  }

  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-logo .app-sidebar-logo-default {
    display: none;
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-logo .app-sidebar-logo-minimize {
    display: inline-block;
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-wrapper {
    width: var(--kt-app-sidebar-width-actual);
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-menu .menu-content,
[data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-menu .menu-title {
    opacity: 0;
    transition: opacity 0.3s ease !important;
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-menu .menu-item.show > .menu-sub {
    height: 0;
    overflow: hidden;
    transition: height 0.3s ease !important;
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-footer .btn-custom {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-footer .btn-custom .btn-label {
    width: 0;
    display: none;
  }
  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-footer .btn-custom .btn-icon {
    width: auto;
    display: block;
  }
}
[data-kt-app-layout=dark-sidebar] .app-sidebar {
  background-color: #1e1e2d;
  border-right: 0 !important;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y {
  scrollbar-color: #323248 transparent;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-thumb {
  background-color: #323248;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-corner {
  background-color: transparent;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y:hover {
  scrollbar-color: #323248 transparent;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-thumb {
  background-color: #323248;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-corner {
  background-color: transparent;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .app-sidebar-logo {
  border-bottom: 1px dashed #393945;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom {
  color: #B5B5C3;
  background-color: rgba(63, 66, 84, 0.35);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom i,
[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom .svg-icon {
  color: #B5B5C3;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom.dropdown-toggle:after {
  color: #B5B5C3;
}
.btn-check:checked + [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom, .btn-check:active + [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom, [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom:focus:not(.btn-active), [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom:hover:not(.btn-active), [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom:active:not(.btn-active), [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom.active, [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom.show, .show > [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom {
  color: #B5B5C3;
  background-color: rgba(63, 66, 84, 0.35) !important;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-heading {
  color: #646477 !important;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link {
  color: #9D9DA6;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-title {
  color: #9D9DA6;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon i {
  color: #C5C5D8;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-bullet .bullet {
  background-color: #787887;
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: #787887;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_121___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: #787887;
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_122___});
  /*rtl:end:remove*/
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
  /*rtl:end:remove*/
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-title {
  color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
  /*rtl:end:remove*/
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-title {
  color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
  /*rtl:end:remove*/
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: #2A2A3C;
  color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-title {
  color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon .svg-icon,
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-primary-inverse);
}
[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary-inverse);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
  /*rtl:end:remove*/
}

[data-kt-app-layout=light-sidebar] .app-sidebar {
  background-color: var(--kt-app-sidebar-light-bg-color);
  border-right: 0 !important;
}
[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y {
  scrollbar-color: var(--kt-app-sidebar-light-scrollbar-color) transparent;
}
[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-thumb {
  background-color: var(--kt-app-sidebar-light-scrollbar-color);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-corner {
  background-color: transparent;
}
[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y:hover {
  scrollbar-color: var(--kt-app-sidebar-light-scrollbar-color-hover) transparent;
}
[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-thumb {
  background-color: var(--kt-app-sidebar-light-scrollbar-color-hover);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-corner {
  background-color: transparent;
}
[data-kt-app-layout=light-sidebar] .app-sidebar .app-sidebar-logo {
  border-bottom: 1px solid var(--kt-app-sidebar-light-separator-color);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu {
  font-weight: 500;
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-heading {
  color: var(--kt-app-sidebar-light-menu-heading-color) !important;
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link {
  color: var(--kt-gray-700);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-title {
  color: var(--kt-gray-700);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon i {
  color: var(--kt-gray-500);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-gray-500);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-500);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_88___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-500);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_89___});
  /*rtl:end:remove*/
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  color: var(--kt-gray-900);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-gray-900);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-gray-700);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-gray-700);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_96___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_97___});
  /*rtl:end:remove*/
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-gray-900);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-title {
  color: var(--kt-gray-900);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-gray-700);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-gray-700);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_96___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_97___});
  /*rtl:end:remove*/
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-gray-900);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-title {
  color: var(--kt-gray-900);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-gray-700);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-gray-700);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_96___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-700);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_97___});
  /*rtl:end:remove*/
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--kt-app-sidebar-light-menu-link-bg-color-active);
  color: var(--kt-primary);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-title {
  color: var(--kt-primary);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon .svg-icon,
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-primary);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}

[data-kt-app-layout=light-sidebar][data-kt-app-header-fixed=true] .app-sidebar .app-sidebar-logo {
  border-bottom: 1px dashed var(--kt-app-sidebar-light-separator-color);
}

.app-header-menu .menu .menu-item .menu-link {
  color: var(--kt-gray-700);
}
.app-header-menu .menu .menu-item .menu-link .menu-title {
  color: var(--kt-gray-700);
}
.app-header-menu .menu .menu-item .menu-link .menu-icon,
.app-header-menu .menu .menu-item .menu-link .menu-icon .svg-icon,
.app-header-menu .menu .menu-item .menu-link .menu-icon i {
  color: var(--kt-gray-500);
}
.app-header-menu .menu .menu-item .menu-link .menu-bullet .bullet {
  background-color: var(--kt-gray-500);
}
.app-header-menu .menu .menu-item .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-500);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_88___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-gray-500);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_89___});
  /*rtl:end:remove*/
}
.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {
  transition: color 0.2s ease;
  background-color: var(--kt-menu-link-bg-color-active);
  color: var(--kt-primary);
}
.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
  color: var(--kt-primary);
}
.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
.app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
.app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
  color: var(--kt-primary);
}
.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}
.app-header-menu .menu .menu-item.show > .menu-link {
  transition: color 0.2s ease;
  color: var(--kt-primary);
}
.app-header-menu .menu .menu-item.show > .menu-link .menu-title {
  color: var(--kt-primary);
}
.app-header-menu .menu .menu-item.show > .menu-link .menu-icon,
.app-header-menu .menu .menu-item.show > .menu-link .menu-icon .svg-icon,
.app-header-menu .menu .menu-item.show > .menu-link .menu-icon i {
  color: var(--kt-primary);
}
.app-header-menu .menu .menu-item.show > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.app-header-menu .menu .menu-item.show > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}
.app-header-menu .menu .menu-item.here > .menu-link {
  transition: color 0.2s ease;
  background-color: var(--kt-menu-link-bg-color-active);
  color: var(--kt-primary);
}
.app-header-menu .menu .menu-item.here > .menu-link .menu-title {
  color: var(--kt-primary);
}
.app-header-menu .menu .menu-item.here > .menu-link .menu-icon,
.app-header-menu .menu .menu-item.here > .menu-link .menu-icon .svg-icon,
.app-header-menu .menu .menu-item.here > .menu-link .menu-icon i {
  color: var(--kt-primary);
}
.app-header-menu .menu .menu-item.here > .menu-link .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.app-header-menu .menu .menu-item.here > .menu-link .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}
.app-header-menu .menu .menu-item .menu-link.active {
  transition: color 0.2s ease;
  background-color: var(--kt-menu-link-bg-color-active);
  color: var(--kt-primary);
}
.app-header-menu .menu .menu-item .menu-link.active .menu-title {
  color: var(--kt-primary);
}
.app-header-menu .menu .menu-item .menu-link.active .menu-icon,
.app-header-menu .menu .menu-item .menu-link.active .menu-icon .svg-icon,
.app-header-menu .menu .menu-item .menu-link.active .menu-icon i {
  color: var(--kt-primary);
}
.app-header-menu .menu .menu-item .menu-link.active .menu-bullet .bullet {
  background-color: var(--kt-primary);
}
.app-header-menu .menu .menu-item .menu-link.active .menu-arrow:after {
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  /*rtl:begin:remove*/
  mask-repeat: no-repeat;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-position: center;
  background-color: var(--kt-primary);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
  /*rtl:end:remove*/
}
.app-header-menu .menu-extended {
  --kt-menu-link-bg-color-active: rgba(var(--kt-gray-100-rgb), 0.7);
  --kt-menu-link-bg-color-hover: rgba(var(--kt-gray-100-rgb), 0.7);
}
.app-header-menu .menu-extended .menu-custom-icon {
  background-color: var(--kt-gray-100);
}
.app-header-menu .menu-extended .menu-link.active .menu-custom-icon, .app-header-menu .menu-extended .menu-link:hover .menu-custom-icon {
  background-color: var(--kt-gray-200);
}

@media (min-width: 992px) {
  .app-header-menu .menu > .menu-item {
    margin-right: 0.5rem;
  }
  .app-header-menu .menu > .menu-item > .menu-link {
    padding-top: 0.775rem;
    padding-bottom: 0.775rem;
    font-weight: 500;
  }
  .app-header-menu .menu > .menu-item.here > .menu-link {
    transition: color 0.2s ease;
    background-color: var(--kt-app-header-base-menu-link-bg-color-active);
    color: var(--kt-primary);
  }
  .app-header-menu .menu > .menu-item.here > .menu-link .menu-title {
    color: var(--kt-primary);
  }
  .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon,
.app-header-menu .menu > .menu-item.here > .menu-link .menu-icon .svg-icon,
.app-header-menu .menu > .menu-item.here > .menu-link .menu-icon i {
    color: var(--kt-primary);
  }
  .app-header-menu .menu > .menu-item.here > .menu-link .menu-bullet .bullet {
    background-color: var(--kt-primary);
  }
  .app-header-menu .menu > .menu-item.here > .menu-link .menu-arrow:after {
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-primary);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-primary);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
    /*rtl:end:remove*/
  }
}
@media (max-width: 991.98px) {
  .app-header .page-title {
    display: none !important;
  }
}
[data-kt-app-layout=dark-header] .app-header {
  background-color: #1e1e2d;
  border-bottom: 0 !important;
}
[data-kt-app-layout=dark-header] .app-header .btn-custom {
  color: #B5B5C3;
}
[data-kt-app-layout=dark-header] .app-header .btn-custom i,
[data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon {
  color: #B5B5C3;
}
[data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after {
  color: #B5B5C3;
}
.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom, .btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom, [data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active), [data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active), [data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active), [data-kt-app-layout=dark-header] .app-header .btn-custom.active, [data-kt-app-layout=dark-header] .app-header .btn-custom.show, .show > [data-kt-app-layout=dark-header] .app-header .btn-custom {
  color: #B5B5C3;
  background-color: rgba(63, 66, 84, 0.35) !important;
}
.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom i,
.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon, .btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom i,
.btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active) i,
[data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active) .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active) i,
[data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active) .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active) i,
[data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active) .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom.active i,
[data-kt-app-layout=dark-header] .app-header .btn-custom.active .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom.show i,
[data-kt-app-layout=dark-header] .app-header .btn-custom.show .svg-icon, .show > [data-kt-app-layout=dark-header] .app-header .btn-custom i,
.show > [data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon {
  color: var(--kt-primary);
}
.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after, .btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active).dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active).dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active).dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom.active.dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom.show.dropdown-toggle:after, .show > [data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after {
  color: var(--kt-primary);
}
@media (min-width: 992px) {
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link {
    color: #9D9DA6;
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-title {
    color: #9D9DA6;
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-icon,
[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-icon i {
    color: #C5C5D8;
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-bullet .bullet {
    background-color: #787887;
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-arrow:after {
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: #787887;
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_121___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: #787887;
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_122___});
    /*rtl:end:remove*/
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) {
    transition: color 0.2s ease;
    background-color: #2A2A3C;
    color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {
    color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,
[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,
[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,
[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {
    color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {
    background-color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-primary-inverse);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-primary-inverse);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
    /*rtl:end:remove*/
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link {
    transition: color 0.2s ease;
    color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-title {
    color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-icon,
[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-icon i {
    color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-bullet .bullet {
    background-color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-arrow:after {
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-primary-inverse);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-primary-inverse);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
    /*rtl:end:remove*/
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link {
    transition: color 0.2s ease;
    background-color: #2A2A3C;
    color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-title {
    color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon,
[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon i {
    color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-bullet .bullet {
    background-color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-arrow:after {
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-primary-inverse);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-primary-inverse);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
    /*rtl:end:remove*/
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active {
    transition: color 0.2s ease;
    background-color: #2A2A3C;
    color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-title {
    color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon,
[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon .svg-icon,
[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon i {
    color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-bullet .bullet {
    background-color: var(--kt-primary-inverse);
  }
  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-arrow:after {
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-primary-inverse);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_116___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-primary-inverse);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_117___});
    /*rtl:end:remove*/
  }
}

@media (min-width: 992px) {
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link {
    transition: color 0.2s ease;
    background-color: var(--kt-app-sidebar-light-header-menu-link-bg-color-active);
    color: var(--kt-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-title {
    color: var(--kt-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon,
[data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon .svg-icon,
[data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon i {
    color: var(--kt-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-bullet .bullet {
    background-color: var(--kt-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-arrow:after {
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-primary);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-primary);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
    /*rtl:end:remove*/
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active {
    transition: color 0.2s ease;
    background-color: var(--kt-app-sidebar-light-header-menu-link-bg-color-active);
    color: var(--kt-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-title {
    color: var(--kt-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon,
[data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon .svg-icon,
[data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon i {
    color: var(--kt-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-bullet .bullet {
    background-color: var(--kt-primary);
  }
  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-arrow:after {
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-primary);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
    /*rtl:begin:remove*/
    mask-repeat: no-repeat;
    mask-position: center;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    background-color: var(--kt-primary);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
    /*rtl:end:remove*/
  }
}

@media (min-width: 992px) {
  [data-kt-app-layout=light-sidebar]:not([data-kt-app-header-fixed=true]) .app-header {
    background-color: transparent;
    box-shadow: none;
    border-bottom: 1px solid var(--kt-app-sidebar-light-separator-color);
  }
}
@media (max-width: 991.98px) {
  [data-kt-app-layout=light-sidebar]:not([data-kt-app-header-fixed-mobile=true]) .app-header {
    background-color: transparent;
    box-shadow: none;
    border-bottom: 1px solid var(--kt-app-sidebar-light-separator-color);
  }
}
@media (min-width: 992px) {
  [data-kt-app-toolbar-enabled=true]:not([data-kt-app-toolbar-fixed=true]) .app-content {
    padding-top: 0;
  }
}
@media (max-width: 991.98px) {
  [data-kt-app-toolbar-enabled=true]:not([data-kt-app-toolbar-fixed-mobile=true]) .app-content {
    padding-top: 0;
  }
}
:is([data-kt-app-layout=light-sidebar], [data-kt-app-layout=light-header], [data-kt-app-layout=dark-header]) .app-toolbar .form-select.form-select {
  background-color: var(--kt-body-bg) !important;
}

@media (min-width: 992px) {
  body:not([data-kt-app-toolbar-fixed=true]) .app-toolbar {
    height: auto;
    background-color: transparent;
    border-top: 0;
    border-bottom: 0;
    box-shadow: none;
  }
}
@media (max-width: 991.98px) {
  body:not([data-kt-app-toolbar-fixed-mobile=true]) .app-toolbar {
    height: auto;
    background-color: transparent;
    border-top: 0;
    border-bottom: 0;
    box-shadow: none;
  }
}
@media (min-width: 992px) {
  [data-kt-app-layout=dark-header] .app-header .page-heading {
    color: #ffffff !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/_metronic/assets/sass/style.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./src/_metronic/assets/sass/core/components/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./src/_metronic/assets/sass/components/_variables.custom.scss","webpack://./node_modules/bootstrap/scss/mixins/_box-shadow.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/_metronic/assets/sass/core/components/_root.scss","webpack://./src/_metronic/assets/sass/core/components/_root-bs.scss","webpack://./src/_metronic/assets/sass/core/components/_reboot.scss","webpack://./src/_metronic/assets/sass/core/components/_type.scss","webpack://./src/_metronic/assets/sass/core/components/_theme-mode.scss","webpack://./src/_metronic/assets/sass/core/components/_animation.scss","webpack://./src/_metronic/assets/sass/core/components/_alert.scss","webpack://./src/_metronic/assets/sass/core/components/_list-group.scss","webpack://./src/_metronic/assets/sass/core/components/_images.scss","webpack://./src/_metronic/assets/sass/core/components/_button-group.scss","webpack://./src/_metronic/assets/sass/core/components/_dropdown.scss","webpack://./src/_metronic/assets/sass/core/components/_toasts.scss","webpack://./src/_metronic/assets/sass/core/components/_close.scss","webpack://./src/_metronic/assets/sass/core/components/_offcanvas.scss","webpack://./src/_metronic/assets/sass/core/components/_nav.scss","webpack://./src/_metronic/assets/sass/core/components/_nav-line-tabs.scss","webpack://./src/_metronic/assets/sass/core/components/_nav-pills-custom.scss","webpack://./src/_metronic/assets/sass/core/components/_pagination.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_svg-bg-icon.scss","webpack://./src/_metronic/assets/sass/core/components/_separator.scss","webpack://./src/_metronic/assets/sass/core/components/_carousel.scss","webpack://./src/_metronic/assets/sass/core/components/menu/_base.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_menu.scss","webpack://./src/_metronic/assets/sass/core/base/mixins/_breakpoints.scss","webpack://./src/_metronic/assets/sass/core/components/menu/_theme.scss","webpack://./src/_metronic/assets/sass/core/components/_anchor.scss","webpack://./src/_metronic/assets/sass/core/components/_card.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_svg-icon.scss","webpack://./src/_metronic/assets/sass/core/components/_breadcrumb.scss","webpack://./src/_metronic/assets/sass/core/components/buttons/_base.scss","webpack://./src/_metronic/assets/sass/core/base/mixins/_reset.scss","webpack://./src/_metronic/assets/sass/core/components/buttons/_theme.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_buttons.scss","webpack://./src/_metronic/assets/sass/core/components/_code.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_labels.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_form-text.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_form-control.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_form-select.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_form-check.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_floating-labels.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_input-group.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_form-control-solid.scss","webpack://./src/_metronic/assets/sass/core/base/mixins/_placeholder.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_form-select-solid.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_form-check-solid.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_input-group-solid.scss","webpack://./src/_metronic/assets/sass/core/components/forms/_required.scss","webpack://./src/_metronic/assets/sass/core/components/_modal.scss","webpack://./src/_metronic/assets/sass/core/components/_progress.scss","webpack://./src/_metronic/assets/sass/core/components/_tables.scss","webpack://./src/_metronic/assets/sass/core/components/_popover.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_popover.scss","webpack://./src/_metronic/assets/sass/core/components/_tooltip.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_tooltip.scss","webpack://./src/_metronic/assets/sass/core/components/_accordion.scss","webpack://./src/_metronic/assets/sass/core/components/_feedback.scss","webpack://./src/_metronic/assets/sass/core/components/_image-input.scss","webpack://./src/_metronic/assets/sass/core/components/_symbol.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_symbol.scss","webpack://./src/_metronic/assets/sass/core/components/_pulse.scss","webpack://./src/_metronic/assets/sass/core/components/_page-loader.scss","webpack://./src/_metronic/assets/sass/core/components/_scrolltop.scss","webpack://./src/_metronic/assets/sass/layout/_variables.custom.scss","webpack://./src/_metronic/assets/sass/core/components/_svg-icon.scss","webpack://./src/_metronic/assets/sass/core/components/_fixed.scss","webpack://./src/_metronic/assets/sass/core/components/_timeline.scss","webpack://./src/_metronic/assets/sass/core/components/_timeline-label.scss","webpack://./src/_metronic/assets/sass/core/components/_overlay.scss","webpack://./src/_metronic/assets/sass/core/components/_bullet.scss","webpack://./src/_metronic/assets/sass/core/components/_drawer.scss","webpack://./src/_metronic/assets/sass/core/components/_badge.scss","webpack://./src/_metronic/assets/sass/core/components/_indicator.scss","webpack://./src/_metronic/assets/sass/core/components/_hover.scss","webpack://./src/_metronic/assets/sass/core/components/_rotate.scss","webpack://./src/_metronic/assets/sass/core/components/_scroll.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_scroll.scss","webpack://./src/_metronic/assets/sass/core/components/_rating.scss","webpack://./src/_metronic/assets/sass/core/components/stepper/_base.scss","webpack://./src/_metronic/assets/sass/core/components/stepper/_pills.scss","webpack://./src/_metronic/assets/sass/core/components/stepper/_links.scss","webpack://./src/_metronic/assets/sass/core/components/_toggle.scss","webpack://./src/_metronic/assets/sass/core/components/_shape.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_shape.scss","webpack://./src/_metronic/assets/sass/core/components/_ribbon.scss","webpack://./src/_metronic/assets/sass/core/components/_blockui.scss","webpack://./src/_metronic/assets/sass/core/components/_explore.scss","webpack://./src/_metronic/assets/sass/core/components/_engage.scss","webpack://./src/_metronic/assets/sass/core/components/_cookiealert.scss","webpack://./src/_metronic/assets/sass/core/components/_print.scss","webpack://./src/_metronic/assets/sass/core/components/helpers/_background.scss","webpack://./src/_metronic/assets/sass/core/components/helpers/_borders.scss","webpack://./src/_metronic/assets/sass/core/components/helpers/_flex.scss","webpack://./src/_metronic/assets/sass/core/components/helpers/_shadow.scss","webpack://./src/_metronic/assets/sass/core/components/helpers/_text.scss","webpack://./src/_metronic/assets/sass/core/components/helpers/_opacity.scss","webpack://./src/_metronic/assets/sass/core/components/helpers/_transform.scss","webpack://./src/_metronic/assets/sass/components/stepper/_multistep.scss","webpack://./src/_metronic/assets/sass/components/_landing.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_root.scss","webpack://./src/_metronic/assets/sass/core/base/mixins/_property.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_reboot.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_page.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_page-loader.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_container.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_print.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_navbar.scss","webpack://./src/_metronic/assets/sass/core/layout/base/header/_header.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_variables.scss","webpack://./src/_metronic/assets/sass/core/layout/base/header/_header-primary.scss","webpack://./src/_metronic/assets/sass/core/layout/base/header/_header-secondary.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_toolbar.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_hero.scss","webpack://./src/_metronic/assets/sass/core/layout/base/sidebar/_sidebar.scss","webpack://./src/_metronic/assets/sass/core/layout/base/sidebar/_sidebar-primary.scss","webpack://./src/_metronic/assets/sass/core/layout/base/sidebar/_sidebar-secondary.scss","webpack://./src/_metronic/assets/sass/core/layout/base/sidebar/_sidebar-panel.scss","webpack://./src/_metronic/assets/sass/core/layout/base/aside/_aside.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_wrapper.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_main.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_content.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_footer.scss","webpack://./src/_metronic/assets/sass/core/layout/base/_layout-builder.scss","webpack://./src/_metronic/assets/sass/core/components/mixins/_theme-mode.scss","webpack://./src/_metronic/assets/sass/layout/_root.scss","webpack://./src/_metronic/assets/sass/layout/sidebar/_sidebar.scss","webpack://./src/_metronic/assets/sass/layout/sidebar/_sidebar-minimize.scss","webpack://./src/_metronic/assets/sass/core/layout/base/mixins/_layout-transition.scss","webpack://./src/_metronic/assets/sass/layout/sidebar/_sidebar-dark.scss","webpack://./src/_metronic/assets/sass/layout/sidebar/_sidebar-light.scss","webpack://./src/_metronic/assets/sass/layout/header/_header.scss","webpack://./src/_metronic/assets/sass/layout/header/_header-dark.scss","webpack://./src/_metronic/assets/sass/layout/header/_header-sidebar-light.scss","webpack://./src/_metronic/assets/sass/layout/_content.scss","webpack://./src/_metronic/assets/sass/layout/_toolbar.scss","webpack://./src/_metronic/assets/sass/layout/_page-title.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;EAQI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,mBAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,kBAAA;EAIA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,yBAAA;EAGF,6BAAA;EACA,uBAAA;EACA,+BAAA;EACA,+BAAA;EAMA,oDAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC4PI,yBALI;EDrPR,0BAAA;EACA,0BAAA;EACA,wBAAA;EAIA,qBAAA;EAIA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,+BAAA;EACA,+BAAA;EACA,2BAAA;EACA,4BAAA;EACA,8BAAA;EAGA,wBAAA;EACA,8BAAA;EAEA,wBAAA;EAEA,0BAAA;ADDF;;AGvDA;;;EAGE,sBAAA;AH0DF;;AG5BA;EACE,SAAA;EACA,uCAAA;EDmPI,mCALI;EC5OR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AH+BF;;AGtBA;EACE,cAAA;EACA,cCijB4B;EDhjB5B,SAAA;EACA,qBAAA;EACA,aCujB4B;AJ9hB9B;;AGfA;EACE,aAAA;EACA,qBCwf4B;EDrf5B,gBE6ZwB;EF5ZxB,gBE+Z6B;EF9Z7B,cEtES;ALsFX;;AGbA;ED6MQ,+BAAA;AF5LR;AE0BI;EC3CJ;IDoNQ,kBAAA;EF/LN;AACF;;AGjBA;EDwMQ,iCAAA;AFnLR;AEiBI;ECtCJ;ID+MQ,iBAAA;EFtLN;AACF;;AGrBA;EDmMQ,iCAAA;AF1KR;AEQI;ECjCJ;ID0MQ,kBAAA;EF7KN;AACF;;AGzBA;ED0LM,kBALI;AFxJV;;AGxBA;EDqLM,kBALI;AFpJV;;AGvBA;EDgLM,mBALI;AFhJV;;AGhBA;EACE,aAAA;EACA,mBE6LgC;AL1KlC;;AGTA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;AHYF;;AGNA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AHSF;;AGHA;;EAEE,kBAAA;AHMF;;AGHA;;;EAGE,aAAA;EACA,mBAAA;AHMF;;AGHA;;;;EAIE,gBAAA;AHMF;;AGHA;EACE,gBEsQiB;ALhQnB;;AGDA;EACE,qBAAA;EACA,cAAA;AHIF;;AGEA;EACE,gBAAA;AHCF;;AGOA;;EAEE,gBE+OmB;ALnPrB;;AGYA;EDmFM,kBALI;AFtFV;;AGeA;EACE,iBC+a4B;ED9a5B,wCAAA;AHZF;;AGqBA;;EAEE,kBAAA;ED+DI,iBALI;ECxDR,cAAA;EACA,wBAAA;AHlBF;;AGqBA;EAAM,eAAA;AHjBN;;AGkBA;EAAM,WAAA;AHdN;;AGmBA;EACE,2BAAA;EACA,qBEiE0B;ALjF5B;AGkBE;EACE,iCAAA;EACA,qBEiEwB;ALjF5B;;AG0BE;EAEE,cAAA;EACA,qBAAA;AHxBJ;;AG+BA;;;;EAIE,qCCkR4B;EF7PxB,cALI;AF3CV;;AGmCA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EDSI,kBALI;AFnCV;AGoCE;EDII,kBALI;ECGN,cAAA;EACA,kBAAA;AHlCJ;;AGsCA;EDHM,kBALI;ECUR,2BAAA;EACA,qBAAA;AHnCF;AGsCE;EACE,cAAA;AHpCJ;;AGwCA;EACE,2BAAA;EDfI,kBALI;ECsBR,wBCuyCkC;EDtyClC,sCCuyCkC;EE3kDhC,uBAAA;ANgQJ;AGuCE;EACE,UAAA;EDtBE,cALI;AFTV;;AG+CA;EACE,gBAAA;AH5CF;;AGkDA;;EAEE,sBAAA;AH/CF;;AGuDA;EACE,oBAAA;EACA,yBAAA;AHpDF;;AGuDA;EACE,oBEgL0C;EF/K1C,uBE+K0C;EF9K1C,cEhVS;EFiVT,gBAAA;AHpDF;;AG2DA;EAEE,mBAAA;EACA,gCAAA;AHzDF;;AG4DA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AHzDF;;AGiEA;EACE,qBAAA;AH9DF;;AGoEA;EAEE,gBAAA;AHlEF;;AG0EA;EACE,UAAA;AHvEF;;AG4EA;;;;;EAKE,SAAA;EACA,oBAAA;EDrHI,kBALI;EC4HR,oBAAA;AHzEF;;AG6EA;;EAEE,oBAAA;AH1EF;;AG+EA;EACE,eAAA;AH5EF;;AG+EA;EAGE,iBAAA;AH9EF;AGiFE;EACE,UAAA;AH/EJ;;AGsFA;EACE,wBAAA;AHnFF;;AG2FA;;;;EAIE,0BAAA;AHxFF;AG2FI;;;;EACE,eAAA;AHtFN;;AG6FA;EACE,UAAA;EACA,kBAAA;AH1FF;;AG+FA;EACE,gBAAA;AH5FF;;AGsGA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AHnGF;;AG2GA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBC8I4B;EFxVtB,iCAAA;EC6MN,oBAAA;AHzGF;AEtQI;ECwWJ;ID/LQ,iBAAA;EFiGN;AACF;AGsGE;EACE,WAAA;AHpGJ;;AG2GA;;;;;;;EAOE,UAAA;AHxGF;;AG2GA;EACE,YAAA;AHxGF;;AGiHA;EACE,oBAAA;EACA,6BAAA;AH9GF;;AGsHA;;;;;;;CAAA;AAWA;EACE,wBAAA;AHtHF;;AG2HA;EACE,UAAA;AHxHF;;AG+HA;EACE,aAAA;EACA,0BAAA;AH5HF;;AGiIA;EACE,qBAAA;AH9HF;;AGmIA;EACE,SAAA;AHhIF;;AGuIA;EACE,kBAAA;EACA,eAAA;AHpIF;;AG4IA;EACE,wBAAA;AHzIF;;AGiJA;EACE,wBAAA;AH9IF;;AOtbA;ELyQM,kBALI;EKlQR,gBHwkB4B;AJ/I9B;;AOpbE;ELsQM,iCAAA;EKlQJ,gBFkZiB;EEjZjB,gBF+c2B;AL1B/B;AEtVI;EKpGF;IL6QM,eAAA;EFiLN;AACF;;AO/bE;ELsQM,iCAAA;EKlQJ,gBFkZiB;EEjZjB,gBF+c2B;ALf/B;AEjWI;EKpGF;IL6QM,iBAAA;EF4LN;AACF;;AO1cE;ELsQM,iCAAA;EKlQJ,gBFkZiB;EEjZjB,gBF+c2B;ALJ/B;AE5WI;EKpGF;IL6QM,eAAA;EFuMN;AACF;;AOrdE;ELsQM,iCAAA;EKlQJ,gBFkZiB;EEjZjB,gBF+c2B;ALO/B;AEvXI;EKpGF;IL6QM,iBAAA;EFkNN;AACF;;AOheE;ELsQM,iCAAA;EKlQJ,gBFkZiB;EEjZjB,gBF+c2B;ALkB/B;AElYI;EKpGF;IL6QM,eAAA;EF6NN;AACF;;AO3eE;ELsQM,iCAAA;EKlQJ,gBFkZiB;EEjZjB,gBF+c2B;AL6B/B;AE7YI;EKpGF;IL6QM,iBAAA;EFwON;AACF;;AO9dA;ECvDE,eAAA;EACA,gBAAA;ARyhBF;;AO9dA;EC5DE,eAAA;EACA,gBAAA;AR8hBF;;AOheA;EACE,qBAAA;APmeF;AOjeE;EACE,oBHgkB0B;AJ7F9B;;AOzdA;ELoNM,kBALI;EK7MR,yBAAA;AP4dF;;AOxdA;EACE,mBFqKO;EHwCH,kBALI;AFoRV;AOzdE;EACE,gBAAA;AP2dJ;;AOvdA;EACE,iBAAA;EACA,mBF2JO;EHwCH,kBALI;EK5LR,cFpFS;AL8iBX;AOxdE;EACE,aAAA;AP0dJ;;AS1jBA;ECIE,eAAA;EAGA,YAAA;AVwjBF;;ASzjBA;EACE,gBL48CkC;EK38ClC,yBERiB;EFSjB,yBAAA;EHGE,uBAAA;EMLE,qDARW;EFKf,eAAA;EAGA,YAAA;AVkkBF;;ASpjBA;EAEE,qBAAA;ATsjBF;;ASnjBA;EACE,qBAAA;EACA,cAAA;ATsjBF;;ASnjBA;EP+PM,kBALI;EOxPR,cJxBS;AL8kBX;;AaxlBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AdqmBF;;Ae/iBI;EF5CE;IACE,gBRiUe;EL8RrB;AACF;AerjBI;EF5CE;IACE,gBRiUe;ELmSrB;AACF;Ae1jBI;EF5CE;IACE,gBRiUe;ELwSrB;AACF;Ae/jBI;EF5CE;IACE,iBRiUe;EL6SrB;AACF;AepkBI;EF5CE;IACE,iBRiUe;ELkTrB;AACF;AgBnoBE;ECAA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AjBqoBF;AgBzoBI;ECaF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AjB+nBF;;AiBhlBM;EACE,SAAA;AjBmlBR;;AiBhlBM;EApCJ,cAAA;EACA,WAAA;AjBwnBF;;AiB1mBE;EACE,cAAA;EACA,WAAA;AjB6mBJ;;AiB/mBE;EACE,cAAA;EACA,UAAA;AjBknBJ;;AiBpnBE;EACE,cAAA;EACA,qBAAA;AjBunBJ;;AiBznBE;EACE,cAAA;EACA,UAAA;AjB4nBJ;;AiB9nBE;EACE,cAAA;EACA,UAAA;AjBioBJ;;AiBnoBE;EACE,cAAA;EACA,qBAAA;AjBsoBJ;;AiBvmBM;EAhDJ,cAAA;EACA,WAAA;AjB2pBF;;AiBtmBU;EAhEN,cAAA;EACA,kBAAA;AjB0qBJ;;AiB3mBU;EAhEN,cAAA;EACA,mBAAA;AjB+qBJ;;AiBhnBU;EAhEN,cAAA;EACA,UAAA;AjBorBJ;;AiBrnBU;EAhEN,cAAA;EACA,mBAAA;AjByrBJ;;AiB1nBU;EAhEN,cAAA;EACA,mBAAA;AjB8rBJ;;AiB/nBU;EAhEN,cAAA;EACA,UAAA;AjBmsBJ;;AiBpoBU;EAhEN,cAAA;EACA,mBAAA;AjBwsBJ;;AiBzoBU;EAhEN,cAAA;EACA,mBAAA;AjB6sBJ;;AiB9oBU;EAhEN,cAAA;EACA,UAAA;AjBktBJ;;AiBnpBU;EAhEN,cAAA;EACA,mBAAA;AjButBJ;;AiBxpBU;EAhEN,cAAA;EACA,mBAAA;AjB4tBJ;;AiB7pBU;EAhEN,cAAA;EACA,WAAA;AjBiuBJ;;AiB1pBY;EAxDV,wBAAA;AjBstBF;;AiB9pBY;EAxDV,yBAAA;AjB0tBF;;AiBlqBY;EAxDV,gBAAA;AjB8tBF;;AiBtqBY;EAxDV,yBAAA;AjBkuBF;;AiB1qBY;EAxDV,yBAAA;AjBsuBF;;AiB9qBY;EAxDV,gBAAA;AjB0uBF;;AiBlrBY;EAxDV,yBAAA;AjB8uBF;;AiBtrBY;EAxDV,yBAAA;AjBkvBF;;AiB1rBY;EAxDV,gBAAA;AjBsvBF;;AiB9rBY;EAxDV,yBAAA;AjB0vBF;;AiBlsBY;EAxDV,yBAAA;AjB8vBF;;AiB3rBQ;;EAEE,mBAAA;AjB8rBV;;AiB3rBQ;;EAEE,mBAAA;AjB8rBV;;AiBrsBQ;;EAEE,sBAAA;AjBwsBV;;AiBrsBQ;;EAEE,sBAAA;AjBwsBV;;AiB/sBQ;;EAEE,qBAAA;AjBktBV;;AiB/sBQ;;EAEE,qBAAA;AjBktBV;;AiBztBQ;;EAEE,sBAAA;AjB4tBV;;AiBztBQ;;EAEE,sBAAA;AjB4tBV;;AiBnuBQ;;EAEE,mBAAA;AjBsuBV;;AiBnuBQ;;EAEE,mBAAA;AjBsuBV;;AiB7uBQ;;EAEE,sBAAA;AjBgvBV;;AiB7uBQ;;EAEE,sBAAA;AjBgvBV;;AiBvvBQ;;EAEE,qBAAA;AjB0vBV;;AiBvvBQ;;EAEE,qBAAA;AjB0vBV;;AiBjwBQ;;EAEE,sBAAA;AjBowBV;;AiBjwBQ;;EAEE,sBAAA;AjBowBV;;AiB3wBQ;;EAEE,mBAAA;AjB8wBV;;AiB3wBQ;;EAEE,mBAAA;AjB8wBV;;AiBrxBQ;;EAEE,sBAAA;AjBwxBV;;AiBrxBQ;;EAEE,sBAAA;AjBwxBV;;AiB/xBQ;;EAEE,qBAAA;AjBkyBV;;AiB/xBQ;;EAEE,qBAAA;AjBkyBV;;Ae51BI;EEUE;IACE,SAAA;EjBs1BN;;EiBn1BI;IApCJ,cAAA;IACA,WAAA;EjB23BA;;EiB72BA;IACE,cAAA;IACA,WAAA;EjBg3BF;;EiBl3BA;IACE,cAAA;IACA,UAAA;EjBq3BF;;EiBv3BA;IACE,cAAA;IACA,qBAAA;EjB03BF;;EiB53BA;IACE,cAAA;IACA,UAAA;EjB+3BF;;EiBj4BA;IACE,cAAA;IACA,UAAA;EjBo4BF;;EiBt4BA;IACE,cAAA;IACA,qBAAA;EjBy4BF;;EiB12BI;IAhDJ,cAAA;IACA,WAAA;EjB85BA;;EiBz2BQ;IAhEN,cAAA;IACA,kBAAA;EjB66BF;;EiB92BQ;IAhEN,cAAA;IACA,mBAAA;EjBk7BF;;EiBn3BQ;IAhEN,cAAA;IACA,UAAA;EjBu7BF;;EiBx3BQ;IAhEN,cAAA;IACA,mBAAA;EjB47BF;;EiB73BQ;IAhEN,cAAA;IACA,mBAAA;EjBi8BF;;EiBl4BQ;IAhEN,cAAA;IACA,UAAA;EjBs8BF;;EiBv4BQ;IAhEN,cAAA;IACA,mBAAA;EjB28BF;;EiB54BQ;IAhEN,cAAA;IACA,mBAAA;EjBg9BF;;EiBj5BQ;IAhEN,cAAA;IACA,UAAA;EjBq9BF;;EiBt5BQ;IAhEN,cAAA;IACA,mBAAA;EjB09BF;;EiB35BQ;IAhEN,cAAA;IACA,mBAAA;EjB+9BF;;EiBh6BQ;IAhEN,cAAA;IACA,WAAA;EjBo+BF;;EiB75BU;IAxDV,cAAA;EjBy9BA;;EiBj6BU;IAxDV,wBAAA;EjB69BA;;EiBr6BU;IAxDV,yBAAA;EjBi+BA;;EiBz6BU;IAxDV,gBAAA;EjBq+BA;;EiB76BU;IAxDV,yBAAA;EjBy+BA;;EiBj7BU;IAxDV,yBAAA;EjB6+BA;;EiBr7BU;IAxDV,gBAAA;EjBi/BA;;EiBz7BU;IAxDV,yBAAA;EjBq/BA;;EiB77BU;IAxDV,yBAAA;EjBy/BA;;EiBj8BU;IAxDV,gBAAA;EjB6/BA;;EiBr8BU;IAxDV,yBAAA;EjBigCA;;EiBz8BU;IAxDV,yBAAA;EjBqgCA;;EiBl8BM;;IAEE,mBAAA;EjBq8BR;;EiBl8BM;;IAEE,mBAAA;EjBq8BR;;EiB58BM;;IAEE,sBAAA;EjB+8BR;;EiB58BM;;IAEE,sBAAA;EjB+8BR;;EiBt9BM;;IAEE,qBAAA;EjBy9BR;;EiBt9BM;;IAEE,qBAAA;EjBy9BR;;EiBh+BM;;IAEE,sBAAA;EjBm+BR;;EiBh+BM;;IAEE,sBAAA;EjBm+BR;;EiB1+BM;;IAEE,mBAAA;EjB6+BR;;EiB1+BM;;IAEE,mBAAA;EjB6+BR;;EiBp/BM;;IAEE,sBAAA;EjBu/BR;;EiBp/BM;;IAEE,sBAAA;EjBu/BR;;EiB9/BM;;IAEE,qBAAA;EjBigCR;;EiB9/BM;;IAEE,qBAAA;EjBigCR;;EiBxgCM;;IAEE,sBAAA;EjB2gCR;;EiBxgCM;;IAEE,sBAAA;EjB2gCR;;EiBlhCM;;IAEE,mBAAA;EjBqhCR;;EiBlhCM;;IAEE,mBAAA;EjBqhCR;;EiB5hCM;;IAEE,sBAAA;EjB+hCR;;EiB5hCM;;IAEE,sBAAA;EjB+hCR;;EiBtiCM;;IAEE,qBAAA;EjByiCR;;EiBtiCM;;IAEE,qBAAA;EjByiCR;AACF;AepmCI;EEUE;IACE,SAAA;EjB6lCN;;EiB1lCI;IApCJ,cAAA;IACA,WAAA;EjBkoCA;;EiBpnCA;IACE,cAAA;IACA,WAAA;EjBunCF;;EiBznCA;IACE,cAAA;IACA,UAAA;EjB4nCF;;EiB9nCA;IACE,cAAA;IACA,qBAAA;EjBioCF;;EiBnoCA;IACE,cAAA;IACA,UAAA;EjBsoCF;;EiBxoCA;IACE,cAAA;IACA,UAAA;EjB2oCF;;EiB7oCA;IACE,cAAA;IACA,qBAAA;EjBgpCF;;EiBjnCI;IAhDJ,cAAA;IACA,WAAA;EjBqqCA;;EiBhnCQ;IAhEN,cAAA;IACA,kBAAA;EjBorCF;;EiBrnCQ;IAhEN,cAAA;IACA,mBAAA;EjByrCF;;EiB1nCQ;IAhEN,cAAA;IACA,UAAA;EjB8rCF;;EiB/nCQ;IAhEN,cAAA;IACA,mBAAA;EjBmsCF;;EiBpoCQ;IAhEN,cAAA;IACA,mBAAA;EjBwsCF;;EiBzoCQ;IAhEN,cAAA;IACA,UAAA;EjB6sCF;;EiB9oCQ;IAhEN,cAAA;IACA,mBAAA;EjBktCF;;EiBnpCQ;IAhEN,cAAA;IACA,mBAAA;EjButCF;;EiBxpCQ;IAhEN,cAAA;IACA,UAAA;EjB4tCF;;EiB7pCQ;IAhEN,cAAA;IACA,mBAAA;EjBiuCF;;EiBlqCQ;IAhEN,cAAA;IACA,mBAAA;EjBsuCF;;EiBvqCQ;IAhEN,cAAA;IACA,WAAA;EjB2uCF;;EiBpqCU;IAxDV,cAAA;EjBguCA;;EiBxqCU;IAxDV,wBAAA;EjBouCA;;EiB5qCU;IAxDV,yBAAA;EjBwuCA;;EiBhrCU;IAxDV,gBAAA;EjB4uCA;;EiBprCU;IAxDV,yBAAA;EjBgvCA;;EiBxrCU;IAxDV,yBAAA;EjBovCA;;EiB5rCU;IAxDV,gBAAA;EjBwvCA;;EiBhsCU;IAxDV,yBAAA;EjB4vCA;;EiBpsCU;IAxDV,yBAAA;EjBgwCA;;EiBxsCU;IAxDV,gBAAA;EjBowCA;;EiB5sCU;IAxDV,yBAAA;EjBwwCA;;EiBhtCU;IAxDV,yBAAA;EjB4wCA;;EiBzsCM;;IAEE,mBAAA;EjB4sCR;;EiBzsCM;;IAEE,mBAAA;EjB4sCR;;EiBntCM;;IAEE,sBAAA;EjBstCR;;EiBntCM;;IAEE,sBAAA;EjBstCR;;EiB7tCM;;IAEE,qBAAA;EjBguCR;;EiB7tCM;;IAEE,qBAAA;EjBguCR;;EiBvuCM;;IAEE,sBAAA;EjB0uCR;;EiBvuCM;;IAEE,sBAAA;EjB0uCR;;EiBjvCM;;IAEE,mBAAA;EjBovCR;;EiBjvCM;;IAEE,mBAAA;EjBovCR;;EiB3vCM;;IAEE,sBAAA;EjB8vCR;;EiB3vCM;;IAEE,sBAAA;EjB8vCR;;EiBrwCM;;IAEE,qBAAA;EjBwwCR;;EiBrwCM;;IAEE,qBAAA;EjBwwCR;;EiB/wCM;;IAEE,sBAAA;EjBkxCR;;EiB/wCM;;IAEE,sBAAA;EjBkxCR;;EiBzxCM;;IAEE,mBAAA;EjB4xCR;;EiBzxCM;;IAEE,mBAAA;EjB4xCR;;EiBnyCM;;IAEE,sBAAA;EjBsyCR;;EiBnyCM;;IAEE,sBAAA;EjBsyCR;;EiB7yCM;;IAEE,qBAAA;EjBgzCR;;EiB7yCM;;IAEE,qBAAA;EjBgzCR;AACF;Ae32CI;EEUE;IACE,SAAA;EjBo2CN;;EiBj2CI;IApCJ,cAAA;IACA,WAAA;EjBy4CA;;EiB33CA;IACE,cAAA;IACA,WAAA;EjB83CF;;EiBh4CA;IACE,cAAA;IACA,UAAA;EjBm4CF;;EiBr4CA;IACE,cAAA;IACA,qBAAA;EjBw4CF;;EiB14CA;IACE,cAAA;IACA,UAAA;EjB64CF;;EiB/4CA;IACE,cAAA;IACA,UAAA;EjBk5CF;;EiBp5CA;IACE,cAAA;IACA,qBAAA;EjBu5CF;;EiBx3CI;IAhDJ,cAAA;IACA,WAAA;EjB46CA;;EiBv3CQ;IAhEN,cAAA;IACA,kBAAA;EjB27CF;;EiB53CQ;IAhEN,cAAA;IACA,mBAAA;EjBg8CF;;EiBj4CQ;IAhEN,cAAA;IACA,UAAA;EjBq8CF;;EiBt4CQ;IAhEN,cAAA;IACA,mBAAA;EjB08CF;;EiB34CQ;IAhEN,cAAA;IACA,mBAAA;EjB+8CF;;EiBh5CQ;IAhEN,cAAA;IACA,UAAA;EjBo9CF;;EiBr5CQ;IAhEN,cAAA;IACA,mBAAA;EjBy9CF;;EiB15CQ;IAhEN,cAAA;IACA,mBAAA;EjB89CF;;EiB/5CQ;IAhEN,cAAA;IACA,UAAA;EjBm+CF;;EiBp6CQ;IAhEN,cAAA;IACA,mBAAA;EjBw+CF;;EiBz6CQ;IAhEN,cAAA;IACA,mBAAA;EjB6+CF;;EiB96CQ;IAhEN,cAAA;IACA,WAAA;EjBk/CF;;EiB36CU;IAxDV,cAAA;EjBu+CA;;EiB/6CU;IAxDV,wBAAA;EjB2+CA;;EiBn7CU;IAxDV,yBAAA;EjB++CA;;EiBv7CU;IAxDV,gBAAA;EjBm/CA;;EiB37CU;IAxDV,yBAAA;EjBu/CA;;EiB/7CU;IAxDV,yBAAA;EjB2/CA;;EiBn8CU;IAxDV,gBAAA;EjB+/CA;;EiBv8CU;IAxDV,yBAAA;EjBmgDA;;EiB38CU;IAxDV,yBAAA;EjBugDA;;EiB/8CU;IAxDV,gBAAA;EjB2gDA;;EiBn9CU;IAxDV,yBAAA;EjB+gDA;;EiBv9CU;IAxDV,yBAAA;EjBmhDA;;EiBh9CM;;IAEE,mBAAA;EjBm9CR;;EiBh9CM;;IAEE,mBAAA;EjBm9CR;;EiB19CM;;IAEE,sBAAA;EjB69CR;;EiB19CM;;IAEE,sBAAA;EjB69CR;;EiBp+CM;;IAEE,qBAAA;EjBu+CR;;EiBp+CM;;IAEE,qBAAA;EjBu+CR;;EiB9+CM;;IAEE,sBAAA;EjBi/CR;;EiB9+CM;;IAEE,sBAAA;EjBi/CR;;EiBx/CM;;IAEE,mBAAA;EjB2/CR;;EiBx/CM;;IAEE,mBAAA;EjB2/CR;;EiBlgDM;;IAEE,sBAAA;EjBqgDR;;EiBlgDM;;IAEE,sBAAA;EjBqgDR;;EiB5gDM;;IAEE,qBAAA;EjB+gDR;;EiB5gDM;;IAEE,qBAAA;EjB+gDR;;EiBthDM;;IAEE,sBAAA;EjByhDR;;EiBthDM;;IAEE,sBAAA;EjByhDR;;EiBhiDM;;IAEE,mBAAA;EjBmiDR;;EiBhiDM;;IAEE,mBAAA;EjBmiDR;;EiB1iDM;;IAEE,sBAAA;EjB6iDR;;EiB1iDM;;IAEE,sBAAA;EjB6iDR;;EiBpjDM;;IAEE,qBAAA;EjBujDR;;EiBpjDM;;IAEE,qBAAA;EjBujDR;AACF;AelnDI;EEUE;IACE,SAAA;EjB2mDN;;EiBxmDI;IApCJ,cAAA;IACA,WAAA;EjBgpDA;;EiBloDA;IACE,cAAA;IACA,WAAA;EjBqoDF;;EiBvoDA;IACE,cAAA;IACA,UAAA;EjB0oDF;;EiB5oDA;IACE,cAAA;IACA,qBAAA;EjB+oDF;;EiBjpDA;IACE,cAAA;IACA,UAAA;EjBopDF;;EiBtpDA;IACE,cAAA;IACA,UAAA;EjBypDF;;EiB3pDA;IACE,cAAA;IACA,qBAAA;EjB8pDF;;EiB/nDI;IAhDJ,cAAA;IACA,WAAA;EjBmrDA;;EiB9nDQ;IAhEN,cAAA;IACA,kBAAA;EjBksDF;;EiBnoDQ;IAhEN,cAAA;IACA,mBAAA;EjBusDF;;EiBxoDQ;IAhEN,cAAA;IACA,UAAA;EjB4sDF;;EiB7oDQ;IAhEN,cAAA;IACA,mBAAA;EjBitDF;;EiBlpDQ;IAhEN,cAAA;IACA,mBAAA;EjBstDF;;EiBvpDQ;IAhEN,cAAA;IACA,UAAA;EjB2tDF;;EiB5pDQ;IAhEN,cAAA;IACA,mBAAA;EjBguDF;;EiBjqDQ;IAhEN,cAAA;IACA,mBAAA;EjBquDF;;EiBtqDQ;IAhEN,cAAA;IACA,UAAA;EjB0uDF;;EiB3qDQ;IAhEN,cAAA;IACA,mBAAA;EjB+uDF;;EiBhrDQ;IAhEN,cAAA;IACA,mBAAA;EjBovDF;;EiBrrDQ;IAhEN,cAAA;IACA,WAAA;EjByvDF;;EiBlrDU;IAxDV,cAAA;EjB8uDA;;EiBtrDU;IAxDV,wBAAA;EjBkvDA;;EiB1rDU;IAxDV,yBAAA;EjBsvDA;;EiB9rDU;IAxDV,gBAAA;EjB0vDA;;EiBlsDU;IAxDV,yBAAA;EjB8vDA;;EiBtsDU;IAxDV,yBAAA;EjBkwDA;;EiB1sDU;IAxDV,gBAAA;EjBswDA;;EiB9sDU;IAxDV,yBAAA;EjB0wDA;;EiBltDU;IAxDV,yBAAA;EjB8wDA;;EiBttDU;IAxDV,gBAAA;EjBkxDA;;EiB1tDU;IAxDV,yBAAA;EjBsxDA;;EiB9tDU;IAxDV,yBAAA;EjB0xDA;;EiBvtDM;;IAEE,mBAAA;EjB0tDR;;EiBvtDM;;IAEE,mBAAA;EjB0tDR;;EiBjuDM;;IAEE,sBAAA;EjBouDR;;EiBjuDM;;IAEE,sBAAA;EjBouDR;;EiB3uDM;;IAEE,qBAAA;EjB8uDR;;EiB3uDM;;IAEE,qBAAA;EjB8uDR;;EiBrvDM;;IAEE,sBAAA;EjBwvDR;;EiBrvDM;;IAEE,sBAAA;EjBwvDR;;EiB/vDM;;IAEE,mBAAA;EjBkwDR;;EiB/vDM;;IAEE,mBAAA;EjBkwDR;;EiBzwDM;;IAEE,sBAAA;EjB4wDR;;EiBzwDM;;IAEE,sBAAA;EjB4wDR;;EiBnxDM;;IAEE,qBAAA;EjBsxDR;;EiBnxDM;;IAEE,qBAAA;EjBsxDR;;EiB7xDM;;IAEE,sBAAA;EjBgyDR;;EiB7xDM;;IAEE,sBAAA;EjBgyDR;;EiBvyDM;;IAEE,mBAAA;EjB0yDR;;EiBvyDM;;IAEE,mBAAA;EjB0yDR;;EiBjzDM;;IAEE,sBAAA;EjBozDR;;EiBjzDM;;IAEE,sBAAA;EjBozDR;;EiB3zDM;;IAEE,qBAAA;EjB8zDR;;EiB3zDM;;IAEE,qBAAA;EjB8zDR;AACF;Aez3DI;EEUE;IACE,SAAA;EjBk3DN;;EiB/2DI;IApCJ,cAAA;IACA,WAAA;EjBu5DA;;EiBz4DA;IACE,cAAA;IACA,WAAA;EjB44DF;;EiB94DA;IACE,cAAA;IACA,UAAA;EjBi5DF;;EiBn5DA;IACE,cAAA;IACA,qBAAA;EjBs5DF;;EiBx5DA;IACE,cAAA;IACA,UAAA;EjB25DF;;EiB75DA;IACE,cAAA;IACA,UAAA;EjBg6DF;;EiBl6DA;IACE,cAAA;IACA,qBAAA;EjBq6DF;;EiBt4DI;IAhDJ,cAAA;IACA,WAAA;EjB07DA;;EiBr4DQ;IAhEN,cAAA;IACA,kBAAA;EjBy8DF;;EiB14DQ;IAhEN,cAAA;IACA,mBAAA;EjB88DF;;EiB/4DQ;IAhEN,cAAA;IACA,UAAA;EjBm9DF;;EiBp5DQ;IAhEN,cAAA;IACA,mBAAA;EjBw9DF;;EiBz5DQ;IAhEN,cAAA;IACA,mBAAA;EjB69DF;;EiB95DQ;IAhEN,cAAA;IACA,UAAA;EjBk+DF;;EiBn6DQ;IAhEN,cAAA;IACA,mBAAA;EjBu+DF;;EiBx6DQ;IAhEN,cAAA;IACA,mBAAA;EjB4+DF;;EiB76DQ;IAhEN,cAAA;IACA,UAAA;EjBi/DF;;EiBl7DQ;IAhEN,cAAA;IACA,mBAAA;EjBs/DF;;EiBv7DQ;IAhEN,cAAA;IACA,mBAAA;EjB2/DF;;EiB57DQ;IAhEN,cAAA;IACA,WAAA;EjBggEF;;EiBz7DU;IAxDV,cAAA;EjBq/DA;;EiB77DU;IAxDV,wBAAA;EjBy/DA;;EiBj8DU;IAxDV,yBAAA;EjB6/DA;;EiBr8DU;IAxDV,gBAAA;EjBigEA;;EiBz8DU;IAxDV,yBAAA;EjBqgEA;;EiB78DU;IAxDV,yBAAA;EjBygEA;;EiBj9DU;IAxDV,gBAAA;EjB6gEA;;EiBr9DU;IAxDV,yBAAA;EjBihEA;;EiBz9DU;IAxDV,yBAAA;EjBqhEA;;EiB79DU;IAxDV,gBAAA;EjByhEA;;EiBj+DU;IAxDV,yBAAA;EjB6hEA;;EiBr+DU;IAxDV,yBAAA;EjBiiEA;;EiB99DM;;IAEE,mBAAA;EjBi+DR;;EiB99DM;;IAEE,mBAAA;EjBi+DR;;EiBx+DM;;IAEE,sBAAA;EjB2+DR;;EiBx+DM;;IAEE,sBAAA;EjB2+DR;;EiBl/DM;;IAEE,qBAAA;EjBq/DR;;EiBl/DM;;IAEE,qBAAA;EjBq/DR;;EiB5/DM;;IAEE,sBAAA;EjB+/DR;;EiB5/DM;;IAEE,sBAAA;EjB+/DR;;EiBtgEM;;IAEE,mBAAA;EjBygER;;EiBtgEM;;IAEE,mBAAA;EjBygER;;EiBhhEM;;IAEE,sBAAA;EjBmhER;;EiBhhEM;;IAEE,sBAAA;EjBmhER;;EiB1hEM;;IAEE,qBAAA;EjB6hER;;EiB1hEM;;IAEE,qBAAA;EjB6hER;;EiBpiEM;;IAEE,sBAAA;EjBuiER;;EiBpiEM;;IAEE,sBAAA;EjBuiER;;EiB9iEM;;IAEE,mBAAA;EjBijER;;EiB9iEM;;IAEE,mBAAA;EjBijER;;EiBxjEM;;IAEE,sBAAA;EjB2jER;;EiBxjEM;;IAEE,sBAAA;EjB2jER;;EiBlkEM;;IAEE,qBAAA;EjBqkER;;EiBlkEM;;IAEE,qBAAA;EjBqkER;AACF;AkB3rEA;EACE,yBAAA;EACA,0BAAA;EACA,gCAAA;EACA,iCAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,6BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,WAAA;EACA,mBb4OO;Ea3OP,4BAAA;EACA,mBdqoB4B;EcpoB5B,0CAAA;AlB4rEF;AkBrrEE;EACE,wBAAA;EACA,oCAAA;EACA,wBbmU4B;EalU5B,wDAAA;AlBurEJ;AkBprEE;EACE,uBAAA;AlBsrEJ;AkBnrEE;EACE,sBAAA;AlBqrEJ;;AkBjrEA;EACE,kCAAA;AlBorEF;;AkB7qEA;EACE,iBAAA;AlBgrEF;;AkBtqEE;EACE,sBAAA;AlByqEJ;;AkB1pEE;EACE,mBAAA;AlB6pEJ;AkB1pEI;EACE,mBAAA;AlB4pEN;;AkBrpEE;EACE,sBAAA;AlBwpEJ;AkBrpEE;EACE,mBAAA;AlBupEJ;;AkB7oEE;EACE,gDAAA;EACA,oCAAA;AlBgpEJ;;AkB1oEE;EACE,gDAAA;EACA,oCAAA;AlB6oEJ;;AkBroEA;EACE,+CAAA;EACA,mCAAA;AlBwoEF;;AkBhoEE;EACE,8CAAA;EACA,kCAAA;AlBmoEJ;;AmBxwEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnBowEJ;;AmBtxEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnBkxEJ;;AmBpyEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnBgyEJ;;AmBlzEE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnB8yEJ;;AmBh0EE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnB4zEJ;;AmB90EE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnB00EJ;;AmB51EE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnBw1EJ;;AmB12EE;EAOE,yBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,0CAAA;AnBs2EJ;;AkB5tEI;EACE,gBAAA;EACA,iCAAA;AlB+tEN;;AenzEI;EGkFA;IACE,gBAAA;IACA,iCAAA;ElBquEJ;AACF;Ae1zEI;EGkFA;IACE,gBAAA;IACA,iCAAA;ElB2uEJ;AACF;Aeh0EI;EGkFA;IACE,gBAAA;IACA,iCAAA;ElBivEJ;AACF;Aet0EI;EGkFA;IACE,gBAAA;IACA,iCAAA;ElBuvEJ;AACF;Ae50EI;EGkFA;IACE,gBAAA;IACA,iCAAA;ElB6vEJ;AACF;AoB15EA;EACE,qBf+nB0C;EH/VtC,kBALI;EkBxRR,gBf8nB0C;Ee7nB1C,cfSS;ALk5EX;;AoBt5EA;EACE,iCAAA;EACA,oCAAA;EACA,gBAAA;ElBoRI,kBALI;EkB5QR,gBfknB0C;EejnB1C,gBfyaiB;EexajB,cfJS;AL45EX;;AoBr5EA;EACE,iCAAA;EACA,oCAAA;ElB0QI,kBALI;AFopEV;;AoBr5EA;EACE,gCAAA;EACA,mCAAA;ElBoQI,mBALI;AF0pEV;;AqBt7EA;EACE,kBhB0nB0C;EH1VtC,mBALI;EmBvRR,chBMS;ALi7EX;;AsB57EA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EpB8RI,iBALI;EoBtRR,gBjB6aqB;EiB5arB,gBjBmbiB;EiBlbjB,cjBKS;EiBJT,yBXNiB;EWOjB,4BAAA;EACA,yBAAA;EACA,gBAAA;EhBGE,uBAAA;EMLE,gDARW;EWUX,wEDMJ;AtB27EF;AuB77EM;EDhBN;ICiBQ,gBAAA;EvBg8EN;AACF;AsB97EE;EACE,gBAAA;AtBg8EJ;AsB97EI;EACE,eAAA;AtBg8EN;AsB37EE;EACE,cjBjBO;EiBkBP,yBX5Be;EW6Bf,qBjBtBO;EiBuBP,UAAA;EVvBE,uFARW;AZ69EjB;AsBl7EE;EAEE,aAAA;AtBm7EJ;AsB/6EE;EACE,cjBzCO;EiB2CP,UAAA;AtBg7EJ;AsBx6EE;EAEE,yBjBxDO;EiByDP,qBjBxDO;EiB0DP,UAAA;AtBw6EJ;AsBp6EE;EACE,sBAAA;EACA,uBAAA;EACA,uBjB6ewC;EiB5exC,cjB9DO;EmBbT,yBnBOS;EiBsEP,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BjB4Q4B;EiB3Q5B,gBAAA;ECtEE,qIDuEF;AtBs6EJ;AuBz+EM;EDuDJ;ICtDM,gBAAA;EvB4+EN;AACF;AsBx6EE;EACE,0CjBmvBgD;ALurDpD;;AsBj6EA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBjBqViB;EiBpVjB,cjBzFS;EiB0FT,6BAAA;EACA,yBAAA;EACA,mBAAA;AtBo6EF;AsBl6EE;EACE,UAAA;AtBo6EJ;AsBj6EE;EAEE,gBAAA;EACA,eAAA;AtBk6EJ;;AsBv5EA;EACE,sClBstBsC;EkBrtBtC,wBAAA;EpBkKI,mBALI;EI7QN,uBAAA;AN4gFJ;AsBx5EE;EACE,wBAAA;EACA,yBAAA;EACA,0BjB+bwC;AL29D5C;;AsBt5EA;EACE,uClB0sBsC;EkBzsBtC,wBAAA;EpBqJI,kBALI;EI7QN,uBAAA;ANwhFJ;AsBv5EE;EACE,wBAAA;EACA,yBAAA;EACA,yBjBsbwC;ALm+D5C;;AsBj5EE;EACE,uClBurBoC;AJ6tDxC;AsBj5EE;EACE,sClBorBoC;AJ+tDxC;AsBh5EE;EACE,uClBirBoC;AJiuDxC;;AsB74EA;EACE,WlB+qBsC;EkB9qBtC,mClBwqBsC;EkBvqBtC,iBjB0Y0C;ALsgE5C;AsB94EE;EACE,eAAA;AtBg5EJ;AsB74EE;EACE,oBAAA;EhBpKA,uBAAA;ANojFJ;AsB54EE;EhBxKE,uBAAA;ANujFJ;AsB34EE;EAAoB,kClBypBkB;AJqvDxC;AsB74EE;EAAoB,mClBypBkB;AJuvDxC;;AyB3kFA;EACE,cAAA;EACA,WAAA;EACA,oCAAA;EACA,oCAAA;EvB4RI,iBALI;EuBpRR,gBpB2aqB;EoB1arB,gBpBibiB;EoBhbjB,cpBGS;EoBFT,yBdRiB;EcSjB,yDAAA;EACA,4BAAA;EACA,sCrBw5BkC;EqBv5BlC,0BrBw5BkC;EqBv5BlC,yBAAA;EnBDE,uBAAA;EMLE,gDARW;EWUX,wEEOJ;EACA,gBAAA;AzB6kFF;AuBjlFM;EEfN;IFgBQ,gBAAA;EvBolFN;AACF;AyBhlFE;EACE,qBpBbO;EoBcP,UAAA;EbdE,uFARW;AZymFjB;AyB1kFE;EAEE,mBpBohBwC;EoBnhBxC,sBAAA;AzB2kFJ;AyBxkFE;EAEE,yBpBjCO;EoBkCP,qBpBjCO;AL0mFX;AyBrkFE;EACE,kBAAA;EACA,0BAAA;AzBukFJ;;AyBnkFA;EACE,oBpB+gB0C;EoB9gB1C,uBpB8gB0C;EoB7gB1C,qBpB8gB0C;EHpStC,mBALI;EI7QN,uBAAA;ANgnFJ;;AyBnkFA;EACE,qBpB2gB0C;EoB1gB1C,wBpB0gB0C;EoBzgB1C,oBpB0gB0C;EHxStC,kBALI;EI7QN,uBAAA;ANwnFJ;;A0BvoFA;EACE,cAAA;EACA,kBrBgsB0C;EqB/rB1C,qBrBgsB0C;EqB/rB1C,uBrBisB0C;ALy8D5C;A0BxoFE;EACE,WAAA;EACA,qBAAA;A1B0oFJ;;A0BtoFA;EACE,sBrBsrB0C;EqBrrB1C,eAAA;EACA,iBAAA;A1ByoFF;A0BvoFE;EACE,YAAA;EACA,sBAAA;EACA,cAAA;A1ByoFJ;;A0BroFA;EACE,crBqqB0C;EqBpqB1C,erBoqB0C;EqBnqB1C,qBAAA;EACA,mBAAA;EACA,6BrBorB0C;EqBnrB1C,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,yBrBsrB0C;EqBrrB1C,gBAAA;EACA,iCAAA;UAAA,yBAAA;A1BwoFF;A0BroFE;EpBvBE,qBAAA;AN+pFJ;A0BpoFE;EAEE,kBrB8qBwC;ALu9D5C;A0BloFE;EACE,uBrB8pBwC;ALs+D5C;A0BjoFE;EACE,qBrB1CO;EqB2CP,UAAA;EACA,gBrBuqBwC;AL49D5C;A0BhoFE;EACE,yBfnDqB;EeoDrB,qBfpDqB;AXsrFzB;A0BhoFI;EAII,yDAAA;A1B+nFR;A0B3nFI;EAII,yDAAA;A1B0nFR;A0BrnFE;EACE,yBfxEqB;EeyErB,qBfzEqB;Ee8EnB,yDAAA;A1BmnFN;A0B/mFE;EACE,oBAAA;EACA,YAAA;EACA,YrB0pBgD;ALu9DpD;A0B1mFI;EACE,eAAA;EACA,YrBipB8C;AL29DpD;;A0BvmFA;EACE,crBhGS;AL0sFX;;A0BlmFA;EACE,qBrBopBkD;ALi9DpD;A0BnmFE;EACE,crB0oBgD;EqBzoBhD,qBAAA;EACA,yDAAA;EACA,gCAAA;EpB3GA,sBAAA;EiBHE,iDGgHF;A1BqmFJ;AuBjtFM;EGsGJ;IHrGM,gBAAA;EvBotFN;AACF;A0BxmFI;EACE,yDAAA;A1B0mFN;A0BvmFI;EACE,iCrBspB8C;EqBjpB5C,yDAAA;A1BqmFR;A0BhmFE;EACE,sBrB0nBgD;EqBznBhD,eAAA;A1BkmFJ;A0BhmFI;EACE,sBAAA;EACA,cAAA;A1BkmFN;;A0B7lFA;EACE,qBAAA;EACA,kBtBmuBgC;AJ63DlC;;A0B7lFA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A1BgmFF;A0B5lFI;EACE,oBAAA;EACA,YAAA;EACA,arBicsC;AL6pE5C;;A2BnwFA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;A3BswFF;A2BpwFE;EACE,UAAA;A3BswFJ;A2BlwFI;EAA0B,oEvBq8Ba;AJg0D3C;A2BpwFI;EAA0B,oEvBo8Ba;AJm0D3C;A2BpwFE;EACE,SAAA;A3BswFJ;A2BnwFE;EACE,WvBs7BuC;EuBr7BvC,YvBq7BuC;EuBp7BvC,oBAAA;EHzBF,yBbOuB;EgBoBrB,SvBq7BuC;EEj8BvC,mBAAA;EMLE,+CARW;EWUX,oHIkBF;EJlBE,4GIkBF;EACA,gBAAA;A3BqwFJ;AuBpxFM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EvBuxFN;AACF;A2BxwFI;EHjCF,yBpBq9ByC;AJu1D3C;A2BtwFE;EACE,WvB+5B8B;EuB95B9B,cvB+5B8B;EuB95B9B,kBAAA;EACA,evB85B8B;EuB75B9B,oCtBsxBgD;EsBrxBhD,yBAAA;ErB7BA,uBAAA;EMLE,gDARW;AZozFjB;A2BrwFE;EACE,WvB25BuC;EuB15BvC,YvB05BuC;EoB78BzC,yBbOuB;EgB8CrB,SvB25BuC;EEj8BvC,mBAAA;EMLE,+CARW;EWUX,iHI4CF;EJ5CE,4GI4CF;EACA,gBAAA;A3BuwFJ;AuBhzFM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EvBmzFN;AACF;A2B1wFI;EH3DF,yBpBq9ByC;AJm3D3C;A2BxwFE;EACE,WvBq4B8B;EuBp4B9B,cvBq4B8B;EuBp4B9B,kBAAA;EACA,evBo4B8B;EuBn4B9B,oCtB4vBgD;EsB3vBhD,yBAAA;ErBvDA,uBAAA;EMLE,gDARW;AZg1FjB;A2BvwFE;EACE,oBAAA;A3BywFJ;A2BvwFI;EACE,oCtBmvB8C;ALshEpD;A2BtwFI;EACE,oCtB+uB8C;ALyhEpD;;A4B/1FA;EACE,kBAAA;A5Bk2FF;A4Bh2FE;;;EAGE,2BvB80BmC;EuB70BnC,iBxB+9B8B;AJm4DlC;A4B/1FE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELPE,gEKQF;A5Bi2FJ;AuBr2FM;EKVJ;ILWM,gBAAA;EvBw2FN;AACF;A4Bn2FE;;EAEE,kBAAA;A5Bq2FJ;A4Bn2FI;;EACE,kBAAA;A5Bs2FN;A4Bn2FI;;;EAEE,oBvBgzB8C;EuB/yB9C,wBxBo8B4B;AJk6DlC;A4Bn2FI;;EACE,oBvB2yB8C;EuB1yB9C,wBxB+7B4B;AJu6DlC;A4Bl2FE;EACE,oBvBqyBgD;EuBpyBhD,wBxBy7B8B;AJ26DlC;A4B71FI;;;;EACE,axBk7B4B;EwBj7B5B,8DxBk7B4B;AJg7DlC;A4B71FI;EACE,axB26B4B;EwB16B5B,8DxB26B4B;AJo7DlC;A4B11FI;EACE,mBAAA;A5B41FN;;A6B/5FA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A7Bk6FF;A6Bh6FE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A7Bk6FJ;A6B95FE;;;EAGE,UAAA;A7Bg6FJ;A6B15FE;EACE,kBAAA;EACA,UAAA;A7B45FJ;A6B15FI;EACE,UAAA;A7B45FN;;A6Bj5FA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;E3BoPI,iBALI;E2B7OR,gBxBoYqB;EwBnYrB,gBxB0YiB;EwBzYjB,cxBpCS;EwBqCT,kBAAA;EACA,mBAAA;EACA,yBxB7CS;EwB8CT,yBAAA;EvBtCE,uBAAA;AN27FJ;;A6B34FA;;;;EAIE,wBAAA;E3B8NI,kBALI;EI7QN,uBAAA;ANo8FJ;;A6B34FA;;;;EAIE,wBAAA;E3BqNI,mBALI;EI7QN,uBAAA;AN68FJ;;A6B34FA;;EAEE,mBAAA;A7B84FF;;A6Bj4FI;;;;EvBjEA,0BAAA;EACA,6BAAA;ANy8FJ;A6Bh4FI;;;;EvB1EA,0BAAA;EACA,6BAAA;ANg9FJ;A6B13FE;EACE,iBAAA;EvB1EA,yBAAA;EACA,4BAAA;ANu8FJ;A6B13FE;;EvB9EE,yBAAA;EACA,4BAAA;AN48FJ;;A8Br+FE;EACE,aAAA;EACA,WAAA;EACA,kBzBmmBwC;EH1VtC,mBALI;E4BjQN,c1Bi+BqB;AJsgEzB;;A8Bp+FE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;E5B4PE,mBALI;E4BpPN,cAvBc;EAwBd,yBAvBiB;ExBHjB,uBAAA;ANigGJ;;A8Bl+FI;;;;EAEE,cAAA;A9Bu+FN;;A8BrhGI;EAoDE,qB1Bs8BmB;E0Bn8BjB,oC1BsxBgC;E0BrxBhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A9Bm+FR;A8Bh+FM;EACE,qB1B27BiB;E0B17BjB,kDA/Ca;A9BihGrB;;A8BliGI;EAyEI,oC1BowBgC;E0BnwBhC,kFAAA;A9B69FR;;A8BviGI;EAiFE,qB1By6BmB;AJijEzB;A8Bv9FQ;EAEE,qB1Bm1B8B;E0Bl1B9B,kGAAA;EACA,yDAAA;EACA,2EAAA;A9Bw9FV;A8Bp9FM;EACE,qB1B45BiB;E0B35BjB,kDA9Ea;A9BoiGrB;;A8BrjGI;EAuGI,yCAAA;A9Bk9FR;;A8BzjGI;EA8GE,qB1B44BmB;AJmkEzB;A8B78FM;EACE,yB1By4BiB;AJskEzB;A8B58FM;EACE,kDApGa;A9BkjGrB;A8B38FM;EACE,c1Bi4BiB;AJ4kEzB;;A8Bx8FI;EACE,kBAAA;A9B28FN;;A8B1kGI;;;;;EAyIM,UAAA;A9By8FV;;A8B/jGE;EACE,aAAA;EACA,WAAA;EACA,kBzBmmBwC;EH1VtC,mBALI;E4BjQN,c1Bi+BqB;AJgmEzB;;A8B9jGE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;E5B4PE,mBALI;E4BpPN,cAvBc;EAwBd,yBAvBiB;ExBHjB,uBAAA;AN2lGJ;;A8B5jGI;;;;EAEE,cAAA;A9BikGN;;A8B/mGI;EAoDE,qB1Bs8BmB;E0Bn8BjB,oC1BsxBgC;E0BrxBhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A9B6jGR;A8B1jGM;EACE,qB1B27BiB;E0B17BjB,kDA/Ca;A9B2mGrB;;A8B5nGI;EAyEI,oC1BowBgC;E0BnwBhC,kFAAA;A9BujGR;;A8BjoGI;EAiFE,qB1By6BmB;AJ2oEzB;A8BjjGQ;EAEE,qB1Bm1B8B;E0Bl1B9B,kGAAA;EACA,yDAAA;EACA,2EAAA;A9BkjGV;A8B9iGM;EACE,qB1B45BiB;E0B35BjB,kDA9Ea;A9B8nGrB;;A8B/oGI;EAuGI,yCAAA;A9B4iGR;;A8BnpGI;EA8GE,qB1B44BmB;AJ6pEzB;A8BviGM;EACE,yB1By4BiB;AJgqEzB;A8BtiGM;EACE,kDApGa;A9B4oGrB;A8BriGM;EACE,c1Bi4BiB;AJsqEzB;;A8BliGI;EACE,kBAAA;A9BqiGN;;A8BpqGI;;;;;EA2IM,UAAA;A9BiiGV;;A+B9qGA;EAEE,0BAAA;EACA,4BAAA;EACA,sBAAA;E7B6RI,0BALI;E6BtRR,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0BAAA;EACA,kCAAA;EACA,gCAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E7B4QI,kCALI;E6BrQR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EAGA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EzBjBE,0CAAA;EkBfF,kCOkCqB;EnBxBjB,oCARW;EWUX,qIQwBJ;A/B4qGF;AuBhsGM;EQhBN;IRiBQ,gBAAA;EvBmsGN;AACF;A+B/qGE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A/BgrGJ;A+B7qGE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A/B8qGJ;A+B3qGE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAGE,oEAAA;A/B2qGN;A+BrqGE;EACE,8CAAA;EACA,UAAA;EAGE,oEAAA;A/BqqGN;A+B/pGE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;EnB3EE,uCARW;AZ+uGjB;A+BzpGI;EAGI,uEAAA;A/BypGR;A+BlpGE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;EnBhGE,gBARW;AZ0vGjB;;A+BtoGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,wBAAA;EACA,kCAAA;EACA,wCAAA;EACA,8BAAA;EACA,yBAAA;EACA,mCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AhCgvGF;;A+BvpGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AhCiwGF;;A+BxqGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AhCkxGF;;A+BzrGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AhCmyGF;;A+B1sGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AhCozGF;;A+B3tGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AhCq0GF;;A+B5uGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AhCs1GF;;A+B7vGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AhCu2GF;;A+B9wGE;ECtGA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,6BAAA;EACA,uCAAA;AhCw3GF;;A+BrwGE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCg3GF;;A+BtxGE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCi4GF;;A+BvyGE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCk5GF;;A+BxzGE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCm6GF;;A+Bz0GE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCo7GF;;A+B11GE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCq8GF;;A+B32GE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCs9GF;;A+B53GE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCu+GF;;A+B74GE;ECvGA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,8BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCw/GF;;A+Bl5GA;EACE,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,kCAAA;EACA,6BAAA;EACA,wCAAA;EACA,8BAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,yBAAA;EACA,sCAAA;EAEA,qB1BuI0B;AL6wG5B;A+B/4GE;EAEE,qB1BoIwB;AL4wG5B;A+B74GE;EACE,0BAAA;A/B+4GJ;A+B54GE;EACE,gCAAA;A/B84GJ;;A+Bn4GA;ECxIE,4BAAA;EACA,2BAAA;E9BoOI,2BALI;E8B7NR,gCAAA;AhC+gHF;;A+Bt4GA;EC5IE,2BAAA;EACA,2BAAA;E9BoOI,4BALI;E8B7NR,gCAAA;AhCshHF;;AiCzlHA;EVgBM,gCUfJ;AjC4lHF;AuBzkHM;EUpBN;IVqBQ,gBAAA;EvB4kHN;AACF;AiC/lHE;EACE,UAAA;AjCimHJ;;AiC3lHE;EACE,aAAA;AjC8lHJ;;AiC1lHA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AjC6lHF;AuB3lHM;EULN;IVMQ,gBAAA;EvB8lHN;AACF;AiChmHE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AjCkmHJ;AuBrmHM;EUAJ;IVCM,gBAAA;EvBwmHN;AACF;;AkC7nHA;;;;;;EAME,kBAAA;AlCgoHF;;AkC7nHA;EACE,mBAAA;AlCgoHF;AmC7mHI;EACE,qBAAA;EACA,oB/BmewB;E+BlexB,uB/BiewB;E+BhexB,WAAA;EAhCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AnCgpHF;AmC3lHI;EACE,cAAA;AnC6lHN;;AkCtoHA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;EhC6QI,6BALI;EgCtQR,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,qCAAA;EACA,6BAAA;EACA,2CAAA;EACA,iCAAA;EACA,sCAAA;EACA,kEAAA;EACA,iCAAA;EACA,yDAAA;EACA,oCAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;EhCgPI,uCALI;EgCzOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E5BzCE,+CAAA;EMLE,yCARW;AZ8rHjB;AkCpoHE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AlCsoHJ;;AkC9mHI;EACE,oBAAA;AlCinHN;AkC/mHM;EACE,WAAA;EACA,OAAA;AlCinHR;;AkC7mHI;EACE,kBAAA;AlCgnHN;AkC9mHM;EACE,QAAA;EACA,UAAA;AlCgnHR;;Ae1pHI;EmB4BA;IACE,oBAAA;ElCkoHJ;EkChoHI;IACE,WAAA;IACA,OAAA;ElCkoHN;;EkC9nHE;IACE,kBAAA;ElCioHJ;EkC/nHI;IACE,QAAA;IACA,UAAA;ElCioHN;AACF;Ae5qHI;EmB4BA;IACE,oBAAA;ElCmpHJ;EkCjpHI;IACE,WAAA;IACA,OAAA;ElCmpHN;;EkC/oHE;IACE,kBAAA;ElCkpHJ;EkChpHI;IACE,QAAA;IACA,UAAA;ElCkpHN;AACF;Ae7rHI;EmB4BA;IACE,oBAAA;ElCoqHJ;EkClqHI;IACE,WAAA;IACA,OAAA;ElCoqHN;;EkChqHE;IACE,kBAAA;ElCmqHJ;EkCjqHI;IACE,QAAA;IACA,UAAA;ElCmqHN;AACF;Ae9sHI;EmB4BA;IACE,oBAAA;ElCqrHJ;EkCnrHI;IACE,WAAA;IACA,OAAA;ElCqrHN;;EkCjrHE;IACE,kBAAA;ElCorHJ;EkClrHI;IACE,QAAA;IACA,UAAA;ElCorHN;AACF;Ae/tHI;EmB4BA;IACE,oBAAA;ElCssHJ;EkCpsHI;IACE,WAAA;IACA,OAAA;ElCssHN;;EkClsHE;IACE,kBAAA;ElCqsHJ;EkCnsHI;IACE,QAAA;IACA,UAAA;ElCqsHN;AACF;AkC5rHE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AlC8rHJ;AmCvxHI;EACE,qBAAA;EACA,oB/BmewB;E+BlexB,uB/BiewB;E+BhexB,WAAA;EAzBJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AnCmzHF;AmCrwHI;EACE,cAAA;AnCuwHN;;AkClsHE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AlCqsHJ;AmC5yHI;EACE,qBAAA;EACA,oB/BmewB;E+BlexB,uB/BiewB;E+BhexB,WAAA;EAlBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AnCi0HF;AmC1xHI;EACE,cAAA;AnC4xHN;AkC7sHI;EACE,iBAAA;AlC+sHN;;AkCzsHE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AlC4sHJ;AmCp0HI;EACE,qBAAA;EACA,oB/BmewB;E+BlexB,uB/BiewB;E+BhexB,WAAA;AnCs0HN;AmC3zHM;EACE,aAAA;AnC6zHR;AmC1zHM;EACE,qBAAA;EACA,qB/BgdsB;E+B/ctB,uB/B8csB;E+B7ctB,WAAA;EA9BN,mCAAA;EACA,yBAAA;EACA,sCAAA;AnC21HF;AmC1zHI;EACE,cAAA;AnC4zHN;AkC5tHI;EACE,iBAAA;AlC8tHN;;AkCvtHA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AlC0tHF;;AkCptHA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB7BmQmB;E6BlQnB,oCAAA;EACA,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;AlCstHF;AkCptHE;EAEE,0CAAA;EVzLF,kDU2LuB;AlCotHzB;AkCjtHE;EAEE,2CAAA;EACA,qBAAA;EVjMF,mDUkMuB;AlCktHzB;AkC/sHE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AlCgtHJ;;AkC1sHA;EACE,cAAA;AlC6sHF;;AkCzsHA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;EhC0EI,mBALI;EgCnER,sCAAA;EACA,mBAAA;AlC4sHF;;AkCxsHA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AlC2sHF;;AkCvsHA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,uCAAA;EACA,iCAAA;EACA,sDAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AlCysHF;;AoC97HA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ApCi8HF;AoC/7HE;;EACE,kBAAA;EACA,cAAA;ApCk8HJ;AoC77HE;;;;;;;;;;;;EAME,UAAA;ApCq8HJ;;AoCh8HA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ApCm8HF;AoCj8HE;EACE,WAAA;ApCm8HJ;;AoC/7HA;E9BhBI,uBAAA;ANm9HJ;AoC/7HE;;EAEE,iBAAA;ApCi8HJ;AoC77HE;;;E9BVE,0BAAA;EACA,6BAAA;AN48HJ;AoCz7HE;;;E9BNE,yBAAA;EACA,4BAAA;ANo8HJ;;AoC56HA;EACE,uBAAA;EACA,sBAAA;ApC+6HF;AoC76HE;EAGE,cAAA;ApC66HJ;AoC16HE;EACE,eAAA;ApC46HJ;;AoCx6HA;EACE,wBAAA;EACA,uBAAA;ApC26HF;;AoCx6HA;EACE,wBAAA;EACA,uBAAA;ApC26HF;;AoCr6HA;ExBxFM,gDARW;AZygIjB;AoCr6HE;ExB5FI,gBARW;AZ4gIjB;;AoC95HA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ApCi6HF;AoC/5HE;;EAEE,WAAA;ApCi6HJ;AoC95HE;;EAEE,gBAAA;ApCg6HJ;AoC55HE;;E9B1FE,6BAAA;EACA,4BAAA;AN0/HJ;AoC55HE;;E9B7GE,yBAAA;EACA,0BAAA;AN6gIJ;;AqCriIA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,qCAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArCoiIF;;AqCjiIA;EACE,cAAA;EACA,kEAAA;EnC4QI,uCALI;EmCrQR,2CAAA;EACA,+BAAA;EdZI,mCccJ;ArCmiIF;AuB7iIM;EcGN;IdFQ,gBAAA;EvBgjIN;AACF;AqCtiIE;EAEE,qCAAA;ArCuiIJ;AqCliIE;EACE,wCAAA;EACA,oBAAA;EACA,eAAA;ArCoiIJ;;AqC5hIA;EAEE,+BAAA;EACA,mCAAA;EACA,qCAAA;EACA,8DAAA;EACA,wCAAA;EACA,qCAAA;EACA,+DAAA;EAGA,oFAAA;ArC4hIF;AqC1hIE;EACE,yDAAA;EACA,gBAAA;EACA,yDAAA;E/BtCA,wDAAA;EACA,yDAAA;ANmkIJ;AqC3hII;EAGE,kBAAA;EACA,wDAAA;ArC2hIN;AqCxhII;EAEE,wCAAA;EACA,6BAAA;EACA,yBAAA;ArCyhIN;AqCrhIE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ArCuhIJ;AqCphIE;EAEE,sDAAA;E/BjEA,yBAAA;EACA,0BAAA;ANulIJ;;AqC5gIA;EAEE,sCAAA;EACA,yCAAA;EACA,sCAAA;ArC8gIF;AqC3gIE;EACE,gBAAA;EACA,SAAA;E/B9FA,gDAAA;AN4mIJ;AqC3gII;EACE,wCAAA;EACA,6BAAA;EACA,yBAAA;ArC6gIN;AqCzgIE;;EAEE,4CAAA;EbzHF,oDa0HuB;ArC2gIzB;;AqCjgIE;;EAEE,cAAA;EACA,kBAAA;ArCogIJ;;AqC//HE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;ArCkgIJ;;AqC5/HE;;EACE,WAAA;ArCggIJ;;AqCt/HE;EACE,aAAA;ArCy/HJ;AqCv/HE;EACE,cAAA;ArCy/HJ;;AsC7pIA;EAEE,wBAAA;EACA,6BAAA;EACA,sCAAA;EACA,2CAAA;EACA,8CAAA;EACA,4CAAA;EACA,uCAAA;EACA,kCAAA;EACA,qCAAA;EACA,2CAAA;EACA,iDAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,uCAAA;EACA,oEAAA;EACA,oDAAA;EACA,2CAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AtC6pIF;AsCvpIE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AtC+pIJ;AsC3oIA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EpCkOI,2CALI;EoC3NR,mCAAA;EAEA,mBAAA;AtC4oIF;AsC1oIE;EAEE,yCAAA;AtC2oIJ;;AsCjoIA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtCgoIF;AsC9nIE;;EAEE,oCAAA;AtCgoIJ;AsC7nIE;EACE,gBAAA;AtC+nIJ;;AsCtnIA;EACE,mBlC46BkC;EkC36BlC,sBlC26BkC;EkC16BlC,6BAAA;AtCynIF;AsCvnIE;;;EAGE,oCAAA;AtCynIJ;;AsC5mIA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AtC6mIF;;AsCzmIA;EACE,8EAAA;EpCiJI,6CALI;EoC1IR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;EhCtIE,qDAAA;EiBHE,+Ce2IJ;AtC4mIF;AuBnvIM;Ee+HN;If9HQ,gBAAA;EvBsvIN;AACF;AsC/mIE;EACE,qBAAA;AtCinIJ;AsC9mIE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AtCgnIJ;;AsC1mIA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AtC6mIF;;AsC1mIA;EACE,yCAAA;EACA,gBAAA;AtC6mIF;;AeruII;EuBoIA;IAEI,iBAAA;IACA,2BAAA;EtComIN;EsClmIM;IACE,mBAAA;EtComIR;EsClmIQ;IACE,kBAAA;EtComIV;EsCjmIQ;IACE,kDAAA;IACA,iDAAA;EtCmmIV;EsC/lIM;IACE,iBAAA;EtCimIR;EsC9lIM;IACE,wBAAA;IACA,gBAAA;EtCgmIR;EsC7lIM;IACE,aAAA;EtC+lIR;EsC5lIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I1B9NJ,gBARW;IWUX,gBe8NI;EtC6lIR;EsC1lIQ;IACE,aAAA;EtC4lIV;EsCzlIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtC2lIV;AACF;AetxII;EuBoIA;IAEI,iBAAA;IACA,2BAAA;EtCopIN;EsClpIM;IACE,mBAAA;EtCopIR;EsClpIQ;IACE,kBAAA;EtCopIV;EsCjpIQ;IACE,kDAAA;IACA,iDAAA;EtCmpIV;EsC/oIM;IACE,iBAAA;EtCipIR;EsC9oIM;IACE,wBAAA;IACA,gBAAA;EtCgpIR;EsC7oIM;IACE,aAAA;EtC+oIR;EsC5oIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I1B9NJ,gBARW;IWUX,gBe8NI;EtC6oIR;EsC1oIQ;IACE,aAAA;EtC4oIV;EsCzoIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtC2oIV;AACF;Aet0II;EuBoIA;IAEI,iBAAA;IACA,2BAAA;EtCosIN;EsClsIM;IACE,mBAAA;EtCosIR;EsClsIQ;IACE,kBAAA;EtCosIV;EsCjsIQ;IACE,kDAAA;IACA,iDAAA;EtCmsIV;EsC/rIM;IACE,iBAAA;EtCisIR;EsC9rIM;IACE,wBAAA;IACA,gBAAA;EtCgsIR;EsC7rIM;IACE,aAAA;EtC+rIR;EsC5rIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I1B9NJ,gBARW;IWUX,gBe8NI;EtC6rIR;EsC1rIQ;IACE,aAAA;EtC4rIV;EsCzrIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtC2rIV;AACF;Aet3II;EuBoIA;IAEI,iBAAA;IACA,2BAAA;EtCovIN;EsClvIM;IACE,mBAAA;EtCovIR;EsClvIQ;IACE,kBAAA;EtCovIV;EsCjvIQ;IACE,kDAAA;IACA,iDAAA;EtCmvIV;EsC/uIM;IACE,iBAAA;EtCivIR;EsC9uIM;IACE,wBAAA;IACA,gBAAA;EtCgvIR;EsC7uIM;IACE,aAAA;EtC+uIR;EsC5uIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I1B9NJ,gBARW;IWUX,gBe8NI;EtC6uIR;EsC1uIQ;IACE,aAAA;EtC4uIV;EsCzuIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtC2uIV;AACF;Aet6II;EuBoIA;IAEI,iBAAA;IACA,2BAAA;EtCoyIN;EsClyIM;IACE,mBAAA;EtCoyIR;EsClyIQ;IACE,kBAAA;EtCoyIV;EsCjyIQ;IACE,kDAAA;IACA,iDAAA;EtCmyIV;EsC/xIM;IACE,iBAAA;EtCiyIR;EsC9xIM;IACE,wBAAA;IACA,gBAAA;EtCgyIR;EsC7xIM;IACE,aAAA;EtC+xIR;EsC5xIM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;I1B9NJ,gBARW;IWUX,gBe8NI;EtC6xIR;EsC1xIQ;IACE,aAAA;EtC4xIV;EsCzxIQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtC2xIV;AACF;AsCl1II;EAEI,iBAAA;EACA,2BAAA;AtCm1IR;AsCj1IQ;EACE,mBAAA;AtCm1IV;AsCj1IU;EACE,kBAAA;AtCm1IZ;AsCh1IU;EACE,kDAAA;EACA,iDAAA;AtCk1IZ;AsC90IQ;EACE,iBAAA;AtCg1IV;AsC70IQ;EACE,wBAAA;EACA,gBAAA;AtC+0IV;AsC50IQ;EACE,aAAA;AtC80IV;AsC30IQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;E1B9NJ,gBARW;EWUX,gBe8NI;AtC40IV;AsCz0IU;EACE,aAAA;AtC20IZ;AsCx0IU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AtC00IZ;;AsCzzIA;EAEE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,iCAAA;EACA,gCAAA;EACA,sCAAA;EACA,0DAAA;EACA,qEAAA;AtC2zIF;;AuC1kJA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,2BAAA;EACA,+BAAA;EACA,iCAAA;EACA,8DAAA;EACA,mDAAA;EACA,+BAAA;EACA,6BAAA;EACA,6BAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;EjCdE,2CAAA;EMLE,qCARW;AZumJjB;AuCxkJE;EACE,eAAA;EACA,cAAA;AvC0kJJ;AuCvkJE;EACE,mBAAA;EACA,sBAAA;AvCykJJ;AuCvkJI;EACE,mBAAA;EjCnBF,0DAAA;EACA,2DAAA;AN6lJJ;AuCvkJI;EACE,sBAAA;EjCVF,8DAAA;EACA,6DAAA;ANolJJ;AuCpkJE;;EAEE,aAAA;AvCskJJ;;AuClkJA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AvCmkJF;;AuChkJA;EACE,4CAAA;AvCmkJF;;AuChkJA;EACE,sDAAA;EACA,gBAAA;AvCmkJF;;AuChkJA;EACE,gBAAA;AvCmkJF;;AuC3jJE;EACE,oCAAA;AvC8jJJ;;AuCtjJA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AvCyjJF;AuCvjJE;EjCxFE,wFAAA;ANkpJJ;;AuCrjJA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AvCwjJF;AuCtjJE;EjCnGE,wFAAA;AN4pJJ;;AuC/iJA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AvCkjJF;AuChjJE;EACE,mCAAA;EACA,sCAAA;AvCkjJJ;;AuC9iJA;EACE,uDAAA;EACA,sDAAA;AvCijJF;;AuC7iJA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;EjCrIE,iDAAA;ANsrJJ;;AuC7iJA;;;EAGE,WAAA;AvCgjJF;;AuC7iJA;;EjCtII,0DAAA;EACA,2DAAA;ANwrJJ;;AuC9iJA;;EjC7HI,8DAAA;EACA,6DAAA;ANgrJJ;;AuCviJE;EACE,0CAAA;AvC0iJJ;AehqJI;EwBkHJ;IAQI,aAAA;IACA,mBAAA;EvC0iJF;EuCviJE;IAEE,SAAA;IACA,gBAAA;EvCwiJJ;EuCtiJI;IACE,cAAA;IACA,cAAA;EvCwiJN;EuCniJM;IjCtKJ,0BAAA;IACA,6BAAA;EN4sJF;EuCpiJQ;;IAGE,0BAAA;EvCqiJV;EuCniJQ;;IAGE,6BAAA;EvCoiJV;EuChiJM;IjCvKJ,yBAAA;IACA,4BAAA;EN0sJF;EuCjiJQ;;IAGE,yBAAA;EvCkiJV;EuChiJQ;;IAGE,4BAAA;EvCiiJV;AACF;;AwCjwJA;EAEE,6BAAA;EACA,0BAAA;EACA,8KAAA;EACA,oCAAA;EACA,gCAAA;EACA,sCAAA;EACA,wDAAA;EACA,oCAAA;EACA,oCAAA;EACA,iCAAA;EACA,8BAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,8CAAA;EACA,yCAAA;EACA,qCAAA;EACA,qCAAA;EACA,oCAAA;EACA,iCAAA;AxCmwJF;;AwC/vJA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EtCiQI,eALI;EsC1PR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;ElCtBE,gBAAA;EkCwBF,qBAAA;EjB3BI,0CiB4BJ;AxCkwJF;AuB1xJM;EiBWN;IjBVQ,gBAAA;EvB6xJN;AACF;AwCrwJE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AxCuwJJ;AwCrwJI;EACE,qDAAA;EACA,iDAAA;AxCuwJN;AwClwJE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBlDE,mDiBmDF;AxCowJJ;AuBnzJM;EiBsCJ;IjBrCM,gBAAA;EvBszJN;AACF;AwCtwJE;EACE,UAAA;AxCwwJJ;AwCrwJE;EACE,UAAA;EACA,wDAAA;EACA,UAAA;EACA,oDAAA;AxCuwJJ;;AwCnwJA;EACE,gBAAA;AxCswJF;;AwCnwJA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AxCswJF;AwCpwJE;ElC/DE,yDAAA;EACA,0DAAA;ANs0JJ;AwCrwJI;ElClEA,+DAAA;EACA,gEAAA;AN00JJ;AwCpwJE;EACE,aAAA;AxCswJJ;AwClwJE;ElC9DE,6DAAA;EACA,4DAAA;ANm0JJ;AwClwJM;ElClEF,mEAAA;EACA,kEAAA;ANu0JJ;AwCjwJI;ElCvEA,6DAAA;EACA,4DAAA;AN20JJ;;AwC/vJA;EACE,8EAAA;AxCkwJF;;AwCzvJE;EACE,eAAA;AxC4vJJ;AwCzvJE;EACE,eAAA;EACA,cAAA;ElCpHA,gBAAA;ANg3JJ;AwCzvJI;EAAgB,aAAA;AxC4vJpB;AwC3vJI;EAAe,gBAAA;AxC8vJnB;AwC3vJM;ElC3HF,gBAAA;ANy3JJ;;AyC54JA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EvCqRI,yCALI;EuC9QR,gBAAA;EACA,yCAAA;EnCAE,iDAAA;AN44JJ;;AyCt4JE;EACE,iDAAA;AzCy4JJ;AyCv4JI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;AzCy4JN;AyCr4JE;EACE,6CAAA;AzCu4JJ;;A0C56JA;EAEE,kCAAA;EACA,mCAAA;ExCkSI,mCALI;EwC3RR,8BAAA;EACA,+BAAA;EACA,+BAAA;EACA,yCAAA;EACA,uCAAA;EACA,oCAAA;EACA,iCAAA;EACA,+CAAA;EACA,oCAAA;EACA,iCAAA;EACA,sCAAA;EACA,qCAAA;EACA,kCAAA;EACA,gDAAA;EACA,uCAAA;EACA,wCAAA;EACA,kDAAA;EAGA,aAAA;ElCpBA,eAAA;EACA,gBAAA;ARi8JF;;A0C16JA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;ExCsQI,yCALI;EwC/PR,iCAAA;EAEA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;A1C46JF;AuB77JM;EmBQN;InBPQ,gBAAA;EvBg8JN;AACF;A0C/6JE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A1Cg7JJ;A0C76JE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UrCw3BgD;EqCv3BhD,iDAAA;A1C+6JJ;A0C56JE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A1C66JJ;A0C16JE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A1C26JJ;;A0Ct6JE;EACE,ctCmmCgC;AJs0HpC;A0Cp6JM;EpC9BF,0DAAA;EACA,6DAAA;ANq8JJ;A0Cl6JM;EpClDF,2DAAA;EACA,8DAAA;ANu9JJ;;A0Cr5JA;EClGE,iCAAA;EACA,kCAAA;EzCgSI,mCALI;EyCzRR,uCAAA;A3C2/JF;;A0Cx5JA;ECtGE,iCAAA;EACA,kCAAA;EzCgSI,mCALI;EyCzRR,uCAAA;A3CkgKF;;A4CpgKA;EAEE,4BAAA;EACA,8BAAA;E1C6RI,6BALI;E0CtRR,2BAAA;EACA,yBAAA;EACA,kCAAA;EAGA,qBAAA;EACA,4DAAA;E1CqRI,oCALI;E0C9QR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EtCJE,4CAAA;ANygKJ;A4ChgKE;EACE,aAAA;A5CkgKJ;;A4C7/JA;EACE,kBAAA;EACA,SAAA;A5CggKF;;A6ChiKA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,yDAAA;EACA,kCAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EvCFE,4CAAA;ANmiKJ;;A6C5hKA;EAEE,cAAA;A7C8hKF;;A6C1hKA;EACE,gBxCuZiB;ALsoJnB;;A6CrhKA;EACE,mBzC43C8B;AJ4pHhC;A6CrhKE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A7CuhKJ;;A6CvgKE;EChEA,yBAAA;EACA,oBAAA;EACA,8BAAA;A9C2kKF;A8CrkKE;EACE,cAAA;A9CukKJ;;A6ChhKE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A9ColKF;A8C9kKE;EACE,cAAA;A9CglKJ;;A6CzhKE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A9C6lKF;A8CvlKE;EACE,cAAA;A9CylKJ;;A6CliKE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A9CsmKF;A8ChmKE;EACE,cAAA;A9CkmKJ;;A6C3iKE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A9C+mKF;A8CzmKE;EACE,cAAA;A9C2mKJ;;A6CpjKE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A9CwnKF;A8ClnKE;EACE,cAAA;A9ConKJ;;A6C7jKE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A9CioKF;A8C3nKE;EACE,cAAA;A9C6nKJ;;A6CtkKE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A9C0oKF;A8CpoKE;EACE,cAAA;A9CsoKJ;;A6C/kKE;EChEA,yBAAA;EACA,sBAAA;EACA,gCAAA;A9CmpKF;A8C7oKE;EACE,cAAA;A9C+oKJ;;A+CtpKE;EACE;IAAK,2B1C2mC2B;EL+iIlC;AACF;A+CtpKA;EAEE,0BAAA;E7CyRI,gCALI;E6ClRR,yBAAA;EACA,gCAAA;EACA,8BAAA;EACA,gCAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E7C6QI,uCALI;E6CtQR,uCAAA;EzCPE,+CAAA;EMLE,yCARW;AZ2qKjB;;A+ClpKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;ExBvBI,6CwBwBJ;A/CqpKF;AuBzqKM;EwBWN;IxBVQ,gBAAA;EvB4qKN;AACF;;A+CvpKA;EvBCE,qMAAA;EuBCA,oEAAA;A/C0pKF;;A+CtpKE;EACE,kDAAA;A/CypKJ;A+CtpKM;EAJJ;IAKM,eAAA;E/CypKN;AACF;;AgD5sKA;EAEE,8BAAA;EACA,2BAAA;EACA,kDAAA;EACA,iCAAA;EACA,uCAAA;EACA,oCAAA;EACA,sCAAA;EACA,qCAAA;EACA,2CAAA;EACA,wCAAA;EACA,4CAAA;EACA,yCAAA;EACA,uCAAA;EACA,oCAAA;EACA,qCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;E1CXE,iDAAA;ANstKJ;;AgDvsKA;EACE,qBAAA;EACA,sBAAA;AhD0sKF;AgDxsKE;EAEE,oCAAA;EACA,0BAAA;AhDysKJ;;AgDhsKA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AhDmsKF;AgDhsKE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AhDisKJ;AgD9rKE;EACE,+CAAA;EACA,uDAAA;AhDgsKJ;;AgDxrKA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EAEA,yCAAA;EACA,iFAAA;AhD0rKF;AgDxrKE;E1CvDE,+BAAA;EACA,gCAAA;ANkvKJ;AgDxrKE;E1C7CE,mCAAA;EACA,kCAAA;ANwuKJ;AgDxrKE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;AhDyrKJ;AgDrrKE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AhDurKJ;AgDnrKE;EACE,mBAAA;AhDqrKJ;AgDnrKI;EACE,wDAAA;EACA,mDAAA;AhDqrKN;;AgDxqKI;EACE,mBAAA;AhD2qKN;AgDxqKQ;E1CvDJ,6DAAA;EAZA,0BAAA;AN+uKJ;AgDvqKQ;E1CxEJ,2DAAA;EAYA,4BAAA;ANuuKJ;AgDtqKQ;EACE,aAAA;AhDwqKV;AgDrqKQ;EACE,mDAAA;EACA,oBAAA;AhDuqKV;AgDrqKU;EACE,yDAAA;EACA,oDAAA;AhDuqKZ;;Ae7vKI;EiC8DA;IACE,mBAAA;EhDmsKJ;EgDhsKM;I1CvDJ,6DAAA;IAZA,0BAAA;ENuwKF;EgD/rKM;I1CxEJ,2DAAA;IAYA,4BAAA;EN+vKF;EgD9rKM;IACE,aAAA;EhDgsKR;EgD7rKM;IACE,mDAAA;IACA,oBAAA;EhD+rKR;EgD7rKQ;IACE,yDAAA;IACA,oDAAA;EhD+rKV;AACF;AetxKI;EiC8DA;IACE,mBAAA;EhD2tKJ;EgDxtKM;I1CvDJ,6DAAA;IAZA,0BAAA;EN+xKF;EgDvtKM;I1CxEJ,2DAAA;IAYA,4BAAA;ENuxKF;EgDttKM;IACE,aAAA;EhDwtKR;EgDrtKM;IACE,mDAAA;IACA,oBAAA;EhDutKR;EgDrtKQ;IACE,yDAAA;IACA,oDAAA;EhDutKV;AACF;Ae9yKI;EiC8DA;IACE,mBAAA;EhDmvKJ;EgDhvKM;I1CvDJ,6DAAA;IAZA,0BAAA;ENuzKF;EgD/uKM;I1CxEJ,2DAAA;IAYA,4BAAA;EN+yKF;EgD9uKM;IACE,aAAA;EhDgvKR;EgD7uKM;IACE,mDAAA;IACA,oBAAA;EhD+uKR;EgD7uKQ;IACE,yDAAA;IACA,oDAAA;EhD+uKV;AACF;Aet0KI;EiC8DA;IACE,mBAAA;EhD2wKJ;EgDxwKM;I1CvDJ,6DAAA;IAZA,0BAAA;EN+0KF;EgDvwKM;I1CxEJ,2DAAA;IAYA,4BAAA;ENu0KF;EgDtwKM;IACE,aAAA;EhDwwKR;EgDrwKM;IACE,mDAAA;IACA,oBAAA;EhDuwKR;EgDrwKQ;IACE,yDAAA;IACA,oDAAA;EhDuwKV;AACF;Ae91KI;EiC8DA;IACE,mBAAA;EhDmyKJ;EgDhyKM;I1CvDJ,6DAAA;IAZA,0BAAA;ENu2KF;EgD/xKM;I1CxEJ,2DAAA;IAYA,4BAAA;EN+1KF;EgD9xKM;IACE,aAAA;EhDgyKR;EgD7xKM;IACE,mDAAA;IACA,oBAAA;EhD+xKR;EgD7xKQ;IACE,yDAAA;IACA,oDAAA;EhD+xKV;AACF;AgDlxKA;E1ChJI,gBAAA;ANq6KJ;AgDlxKE;EACE,mDAAA;AhDoxKJ;AgDlxKI;EACE,sBAAA;AhDoxKN;;AiD17KE;EACE,cDqL2B;ECpL3B,uBDiLsB;AhD4wK1B;AiD17KM;EAEE,cD+KuB;EC9KvB,yBAAA;AjD27KR;AiDx7KM;EACE,ctCTW;EsCUX,yBDyKuB;ECxKvB,qBDwKuB;AhDkxK/B;;AiDx8KE;EACE,cDqL2B;ECpL3B,yBDiLsB;AhD0xK1B;AiDx8KM;EAEE,cD+KuB;EC9KvB,yBAAA;AjDy8KR;AiDt8KM;EACE,ctCTW;EsCUX,yBDyKuB;ECxKvB,qBDwKuB;AhDgyK/B;;AiDt9KE;EACE,cDmLyB;EClLzB,yBDiLsB;AhDwyK1B;AiDt9KM;EAEE,cD6KqB;EC5KrB,yBAAA;AjDu9KR;AiDp9KM;EACE,ctCTW;EsCUX,yBDuKqB;ECtKrB,qBDsKqB;AhDgzK7B;;AiDp+KE;EACE,cDqL2B;ECpL3B,yBDiLsB;AhDszK1B;AiDp+KM;EAEE,cD+KuB;EC9KvB,yBAAA;AjDq+KR;AiDl+KM;EACE,ctCTW;EsCUX,yBDyKuB;ECxKvB,qBDwKuB;AhD4zK/B;;AiDl/KE;EACE,cDqL2B;ECpL3B,yBDiLsB;AhDo0K1B;AiDl/KM;EAEE,cD+KuB;EC9KvB,yBAAA;AjDm/KR;AiDh/KM;EACE,ctCTW;EsCUX,yBDyKuB;ECxKvB,qBDwKuB;AhD00K/B;;AiDhgLE;EACE,cDmLyB;EClLzB,yBDiLsB;AhDk1K1B;AiDhgLM;EAEE,cD6KqB;EC5KrB,yBAAA;AjDigLR;AiD9/KM;EACE,ctCTW;EsCUX,yBDuKqB;ECtKrB,qBDsKqB;AhD01K7B;;AiD9gLE;EACE,cDqL2B;ECpL3B,yBDiLsB;AhDg2K1B;AiD9gLM;EAEE,cD+KuB;EC9KvB,yBAAA;AjD+gLR;AiD5gLM;EACE,ctCTW;EsCUX,yBDyKuB;ECxKvB,qBDwKuB;AhDs2K/B;;AiD5hLE;EACE,cDmLyB;EClLzB,yBDiLsB;AhD82K1B;AiD5hLM;EAEE,cD6KqB;EC5KrB,yBAAA;AjD6hLR;AiD1hLM;EACE,ctCTW;EsCUX,yBDuKqB;ECtKrB,qBDsKqB;AhDs3K7B;;AiD1iLE;EACE,cDmLyB;EClLzB,yBDiLsB;AhD43K1B;AiD1iLM;EAEE,cD6KqB;EC5KrB,yBAAA;AjD2iLR;AiDxiLM;EACE,ctCTW;EsCUX,yBDuKqB;ECtKrB,qBDsKqB;AhDo4K7B;;AkDvjLA;EACE,uBAAA;EACA,c7CosC+B;E6CnsC/B,e7CmsC+B;E6ClsC/B,sBAAA;EACA,c7CFK;E6CGL,8FAAA;EACA,SAAA;E5COE,uBAAA;E4CLF,Y9C6iD2B;AJ6gI7B;AkDvjLE;EACE,c7CVG;E6CWH,qBAAA;EACA,a9CwiDyB;AJihI7B;AkDtjLE;EACE,UAAA;EACA,gB7CwrCyB;E6CvrCzB,U9CmiDyB;AJqhI7B;AkDrjLE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,a9C6hDyB;AJyhI7B;;AkDljLA;EACE,kD9CyhD2B;AJ4hI7B;;AmD3lLA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;EjD+RI,8BALI;EiDxRR,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,2DAAA;EACA,kCAAA;EACA,kEAAA;EACA,gCAAA;EACA,+CAAA;EACA,mDAAA;EAGA,gCAAA;EACA,eAAA;EjDiRI,oCALI;EiD1QR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;E7CRE,4CAAA;ANomLJ;AmDzlLE;EACE,UAAA;AnD2lLJ;AmDxlLE;EACE,aAAA;AnD0lLJ;;AmDtlLA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AnDwlLF;AmDtlLE;EACE,sCAAA;AnDwlLJ;;AmDplLA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;E7ChCE,0FAAA;EACA,2FAAA;ANwnLJ;AmDtlLE;EACE,oDAAA;EACA,sCAAA;AnDwlLJ;;AmDplLA;EACE,kCAAA;EACA,qBAAA;AnDulLF;;AoDrpLA;EAEE,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,2DAAA;EACA,0BAAA;EACA,kCAAA;EACA,0DAAA;EACA,wCAAA;EACA,oCAAA;EACA,oCAAA;EACA,0CAAA;EACA,uCAAA;EACA,mCAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,uCAAA;EACA,mCAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;ApDmpLF;;AoD5oLA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;ApD8oLF;AoD3oLE;E7B5CI,mC6B6CF;EACA,8BhDm1CgC;AJ0zIpC;AuBvrLM;E6BwCJ;I7BvCM,gBAAA;EvB0rLN;AACF;AoDhpLE;EACE,ehDi1CgC;AJi0IpC;AoD9oLE;EACE,sBhD80CgC;AJk0IpC;;AoD5oLA;EACE,+CAAA;ApD+oLF;AoD7oLE;EACE,gBAAA;EACA,gBAAA;ApD+oLJ;AoD5oLE;EACE,gBAAA;ApD8oLJ;;AoD1oLA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;ApD6oLF;;AoDzoLA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E9CrFE,4CAAA;EMLE,sCARW;EwCsGf,UAAA;ApD0oLF;;AoDtoLA;EAEE,0BAAA;EACA,yBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;ApD4oL9D;AqDxvLE;EAAS,UAAA;ArD2vLX;AqD1vLE;EAAS,mCD2GiF;ApDkpL5F;;AoD7oLA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,4FAAA;E9CtGE,2DAAA;EACA,4DAAA;ANuvLJ;AoD/oLE;EACE,kGAAA;EACA,sJAAA;ApDipLJ;;AoD5oLA;EACE,gBAAA;EACA,8CAAA;ApD+oLF;;AoD1oLA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;ApD2oLF;;AoDvoLA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E9C1HE,+DAAA;EACA,8DAAA;ANqwLJ;AoDtoLE;EACE,8CAAA;ApDwoLJ;;AepvLI;EqCkHF;IACE,0BAAA;IACA,uDAAA;EpDsoLF;;EoDloLA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EpDqoLF;;EoDloLA;IACE,uBAAA;EpDqoLF;AACF;AerwLI;EqCoIF;;IAEE,uBAAA;EpDooLF;AACF;Ae3wLI;EqC2IF;IACE,wBAAA;EpDmoLF;AACF;AoD1nLI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;ApD4nLN;AoD1nLM;EACE,YAAA;EACA,SAAA;E9C1MJ,gBAAA;ANu0LJ;AoDznLM;;E9C9MF,gBAAA;AN20LJ;AoDxnLM;EACE,gBAAA;ApD0nLR;;AerxLI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpDgpLJ;EoD9oLI;IACE,YAAA;IACA,SAAA;I9C1MJ,gBAAA;EN21LF;EoD7oLI;;I9C9MF,gBAAA;EN+1LF;EoD5oLI;IACE,gBAAA;EpD8oLN;AACF;Ae1yLI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpDoqLJ;EoDlqLI;IACE,YAAA;IACA,SAAA;I9C1MJ,gBAAA;EN+2LF;EoDjqLI;;I9C9MF,gBAAA;ENm3LF;EoDhqLI;IACE,gBAAA;EpDkqLN;AACF;Ae9zLI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpDwrLJ;EoDtrLI;IACE,YAAA;IACA,SAAA;I9C1MJ,gBAAA;ENm4LF;EoDrrLI;;I9C9MF,gBAAA;ENu4LF;EoDprLI;IACE,gBAAA;EpDsrLN;AACF;Ael1LI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpD4sLJ;EoD1sLI;IACE,YAAA;IACA,SAAA;I9C1MJ,gBAAA;ENu5LF;EoDzsLI;;I9C9MF,gBAAA;EN25LF;EoDxsLI;IACE,gBAAA;EpD0sLN;AACF;Aet2LI;EqCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EpDguLJ;EoD9tLI;IACE,YAAA;IACA,SAAA;I9C1MJ,gBAAA;EN26LF;EoD7tLI;;I9C9MF,gBAAA;EN+6LF;EoD5tLI;IACE,gBAAA;EpD8tLN;AACF;AsDr8LA;EAEE,yBAAA;EACA,6BAAA;EACA,4BAAA;EACA,+BAAA;EACA,sBAAA;EpD8RI,gCALI;EoDvRR,2BAAA;EACA,wBAAA;EACA,oCAAA;EACA,uBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,uCAAA;EACA,gCAAA;ECnBA,sCnDgiB4B;EmD9hB5B,kBAAA;EACA,gBlDkbmB;EkDjbnB,gBlDybiB;EkDxbjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;ErDsRI,sCALI;EoDrQR,qBAAA;EACA,UAAA;AtD68LF;AsD38LE;EAAS,kCAAA;AtD88LX;AsD58LE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AtD88LJ;AsD58LI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AtD88LN;;AsDz8LA;EACE,SAAA;AtD48LF;AsD18LE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AtD48LJ;;AsDx8LA,qBAAA;AACA;EACE,OAAA;EACA,qCAAA;EACA,qCAAA;AtD28LF;AsDz8LE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AtD28LJ;;AsDv8LA,mBAAA;AAEA;EACE,MAAA;AtDy8LF;AsDv8LE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AtDy8LJ;;AsDr8LA,qBAAA;AACA;EACE,QAAA;EACA,qCAAA;EACA,qCAAA;AtDw8LF;AsDt8LE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AtDw8LJ;;AsDp8LA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;EhDlGE,8CAAA;ANyhMJ;;AwD5iMA;EAEE,yBAAA;EACA,6BAAA;EtDkSI,4BALI;EsD3RR,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,oCAAA;EACA,sDAAA;EACA,iEAAA;EACA,sCAAA;EACA,mCAAA;EtDyRI,mCALI;EsDlRR,kCAAA;EACA,+BAAA;EACA,oCAAA;EACA,oCAAA;EACA,gCAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sCnDgiB4B;EmD9hB5B,kBAAA;EACA,gBlDkbmB;EkDjbnB,gBlDybiB;EkDxbjB,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;ErDsRI,sCALI;EsDhQR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;ElDhBE,8CAAA;EMLE,wCARW;AZqlMjB;AwDpjME;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AxDsjMJ;AwDpjMI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AxDqjMN;;AwD/iME;EACE,oFAAA;AxDkjMJ;AwDhjMI;EAEE,wFAAA;AxDijMN;AwD9iMI;EACE,SAAA;EACA,gDAAA;AxDgjMN;AwD7iMI;EACE,sCAAA;EACA,sCAAA;AxD+iMN;;AwD1iMA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AxD4iMJ;AwD1iMI;EAEE,kIAAA;AxD2iMN;AwDxiMI;EACE,OAAA;EACA,kDAAA;AxD0iMN;AwDviMI;EACE,oCAAA;EACA,wCAAA;AxDyiMN;;AwDpiMA,mBAAA;AAGE;EACE,iFAAA;AxDqiMJ;AwDniMI;EAEE,wFAAA;AxDoiMN;AwDjiMI;EACE,MAAA;EACA,mDAAA;AxDmiMN;AwDhiMI;EACE,mCAAA;EACA,yCAAA;AxDkiMN;AwD7hME;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AxD+hMJ;;AwD3hMA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AxD6hMJ;AwD3hMI;EAEE,kIAAA;AxD4hMN;AwDzhMI;EACE,QAAA;EACA,iDAAA;AxD2hMN;AwDxhMI;EACE,qCAAA;EACA,uCAAA;AxD0hMN;;AwDrhMA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;EtDiHI,6CALI;EsD1GR,qCAAA;EACA,6CAAA;EACA,kFAAA;ElD5JE,6DAAA;EACA,8DAAA;ANoqMJ;AwDtgME;EACE,aAAA;AxDwgMJ;;AwDpgMA;EACE,0EAAA;EACA,mCAAA;AxDugMF;;AyD5rMA;EACE,kBAAA;AzD+rMF;;AyD5rMA;EACE,mBAAA;AzD+rMF;;AyD5rMA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AzD+rMF;A0DrtME;EACE,cAAA;EACA,WAAA;EACA,WAAA;A1DutMJ;;AyDhsMA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;ElClBI,sCkCmBJ;AzDmsMF;AuBltMM;EkCQN;IlCPQ,gBAAA;EvBqtMN;AACF;;AyDrsMA;;;EAGE,cAAA;AzDwsMF;;AyDrsMA,qBAAA;AACA;;EAEE,2BAAA;AzDwsMF;;AyDrsMA;;EAEE,4BAAA;AzDwsMF;;AyDrsMA,mBAAA;AAQE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AzDisMJ;AyD9rME;;;EAGE,UAAA;EACA,UAAA;AzDgsMJ;AyD7rME;;EAEE,UAAA;EACA,UAAA;ElC/DE,2BkCgEF;AzD+rMJ;AuB3vMM;EkCwDJ;;IlCvDM,gBAAA;EvB+vMN;AACF;;AyD5rMA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UrD45CmC;EqD35CnC,UAAA;EACA,c9C9FiB;E8C+FjB,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YrDu5CmC;EmBh/C/B,8BkC0FJ;AzD8rMF;AuBpxMM;EkCqEN;;IlCpEQ,gBAAA;EvBwxMN;AACF;AyDjsME;;;EAEE,c9CxGe;E8CyGf,qBAAA;EACA,UAAA;EACA,YrD+4CiC;AJqzJrC;;AyDjsMA;EACE,OAAA;AzDosMF;;AyDjsMA;EACE,QAAA;AzDosMF;;AyD/rMA;;EAEE,qBAAA;EACA,WrDg5CmC;EqD/4CnC,YrD+4CmC;EqD94CnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AzDksMF;;AyD/rMA;;;;;;;GAAA;AAQA;EACE,0DAAA;AzDksMF;;AyDhsMA;EACE,0DAAA;AzDmsMF;;AyD3rMA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBrDw1CmC;EqDv1CnC,mBAAA;EACA,gBrDs1CmC;EqDr1CnC,gBAAA;AzD6rMF;AyD3rME;EACE,uBAAA;EACA,cAAA;EACA,WrDq1CiC;EqDp1CjC,WrDq1CiC;EqDp1CjC,UAAA;EACA,iBrDq1CiC;EqDp1CjC,gBrDo1CiC;EqDn1CjC,mBAAA;EACA,eAAA;EACA,yB9C/Ke;E8CgLf,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YrD40CiC;EmBx/C/B,6BkC6KF;AzD4rMJ;AuBr2MM;EkCwJJ;IlCvJM,gBAAA;EvBw2MN;AACF;AyD9rME;EACE,UrDy0CiC;AJu3JrC;;AyDvrMA;EACE,kBAAA;EACA,UAAA;EACA,erDm0CmC;EqDl0CnC,SAAA;EACA,oBrDg0CmC;EqD/zCnC,uBrD+zCmC;EqD9zCnC,c9C1MiB;E8C2MjB,kBAAA;AzD0rMF;;AyDprME;;EAEE,gCrDo0CiC;AJm3JrC;AyDprME;EACE,yBpDtNG;AL44MP;AyDnrME;EACE,cpD1NG;AL+4MP;;A2Dn5MA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A3Dq5MF;;A2Dj5MA;EACE;IAAK,0CAAA;E3Dq5ML;AACF;A2Dl5MA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A3Di5MF;;A2D94MA;EAEE,wBAAA;EACA,yBAAA;EACA,kCAAA;A3Dg5MF;;A2Dv4MA;EACE;IACE,mBAAA;E3D04MF;E2Dx4MA;IACE,UAAA;IACA,eAAA;E3D04MF;AACF;A2Dt4MA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A3Dq4MF;;A2Dl4MA;EACE,wBAAA;EACA,yBAAA;A3Dq4MF;;A2Dj4ME;EACE;;IAEE,kCAAA;E3Do4MJ;AACF;A4Dp9MA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,iCAAA;EACA,iCAAA;EACA,sBAAA;EACA,0BAAA;EACA,8BAAA;EACA,+DAAA;EACA,8DAAA;A5Dq9MF;;Aet5MI;E6C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IhD5BA,0CARW;IWUX,sCqC4BA;E5Du8MJ;AACF;AuBh+MM;EqCUJ;IrCTM,gBAAA;EvBm+MN;AACF;Ae76MI;E6C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5D88MN;AACF;Aet7MI;E6CtBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5D+8MN;AACF;Ae/7MI;E6CdE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5Dg9MN;AACF;Ae18MI;E6CJE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5Di9MN;AACF;Aep9MI;E6CKE;IAEE,eAAA;E5Di9MN;AACF;Aez9MI;E6CUE;IAGE,mBAAA;E5Dg9MN;AACF;Ae3+MI;E6CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5D+8MN;E4D78MM;IACE,aAAA;E5D+8MR;E4D58MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5D68MR;AACF;;Ae/+MI;E6C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IhD5BA,0CARW;IWUX,sCqC4BA;E5DgiNJ;AACF;AuBzjNM;EqCUJ;IrCTM,gBAAA;EvB4jNN;AACF;AetgNI;E6C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5DuiNN;AACF;Ae/gNI;E6CtBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5DwiNN;AACF;AexhNI;E6CdE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5DyiNN;AACF;AeniNI;E6CJE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5D0iNN;AACF;Ae7iNI;E6CKE;IAEE,eAAA;E5D0iNN;AACF;AeljNI;E6CUE;IAGE,mBAAA;E5DyiNN;AACF;AepkNI;E6CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5DwiNN;E4DtiNM;IACE,aAAA;E5DwiNR;E4DriNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5DsiNR;AACF;;AexkNI;E6C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IhD5BA,0CARW;IWUX,sCqC4BA;E5DynNJ;AACF;AuBlpNM;EqCUJ;IrCTM,gBAAA;EvBqpNN;AACF;Ae/lNI;E6C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5DgoNN;AACF;AexmNI;E6CtBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5DioNN;AACF;AejnNI;E6CdE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5DkoNN;AACF;Ae5nNI;E6CJE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5DmoNN;AACF;AetoNI;E6CKE;IAEE,eAAA;E5DmoNN;AACF;Ae3oNI;E6CUE;IAGE,mBAAA;E5DkoNN;AACF;Ae7pNI;E6CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5DioNN;E4D/nNM;IACE,aAAA;E5DioNR;E4D9nNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5D+nNR;AACF;;AejqNI;E6C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IhD5BA,0CARW;IWUX,sCqC4BA;E5DktNJ;AACF;AuB3uNM;EqCUJ;IrCTM,gBAAA;EvB8uNN;AACF;AexrNI;E6C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5DytNN;AACF;AejsNI;E6CtBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5D0tNN;AACF;Ae1sNI;E6CdE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5D2tNN;AACF;AertNI;E6CJE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5D4tNN;AACF;Ae/tNI;E6CKE;IAEE,eAAA;E5D4tNN;AACF;AepuNI;E6CUE;IAGE,mBAAA;E5D2tNN;AACF;AetvNI;E6CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5D0tNN;E4DxtNM;IACE,aAAA;E5D0tNR;E4DvtNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5DwtNR;AACF;;Ae1vNI;E6C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IhD5BA,0CARW;IWUX,sCqC4BA;E5D2yNJ;AACF;AuBp0NM;EqCUJ;IrCTM,gBAAA;EvBu0NN;AACF;AejxNI;E6C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E5DkzNN;AACF;Ae1xNI;E6CtBE;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E5DmzNN;AACF;AenyNI;E6CdE;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E5DozNN;AACF;Ae9yNI;E6CJE;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E5DqzNN;AACF;AexzNI;E6CKE;IAEE,eAAA;E5DqzNN;AACF;Ae7zNI;E6CUE;IAGE,mBAAA;E5DozNN;AACF;Ae/0NI;E6CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E5DmzNN;E4DjzNM;IACE,aAAA;E5DmzNR;E4DhzNM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E5DizNR;AACF;;A4Dj4NE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EhD5BA,0CARW;EWUX,sCqC4BA;A5Dm4NN;AuB35NM;EqCUJ;IrCTM,gBAAA;EvB85NN;AACF;A4Dt4NM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A5Dw4NR;A4Dr4NM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A5Du4NR;A4Dp4NM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A5Ds4NR;A4Dn4NM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A5Dq4NR;A4Dl4NM;EAEE,eAAA;A5Dm4NR;A4Dh4NM;EAGE,mBAAA;A5Dg4NR;;A4Dr2NA;EPlHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,ajDghCkC;EiD/gClC,YAAA;EACA,aAAA;EACA,yBAAA;ArD29NF;AqDx9NE;EAAS,UAAA;ArD29NX;AqD19NE;EAAS,YhDylC4B;ALo4LvC;;A4Dj3NA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oEAAA;A5Do3NF;A4Dl3NE;EACE,4FAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;A5Do3NJ;;A4Dh3NA;EACE,gBAAA;EACA,gBvDsTiB;AL6jNnB;;A4Dh3NA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A5Dm3NF;;A6DjgOA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YzDqsCkC;AJ+zLpC;A6DlgOE;EACE,qBAAA;EACA,WAAA;A7DogOJ;;A6D//NA;EACE,iBAAA;A7DkgOF;;A6D//NA;EACE,iBAAA;A7DkgOF;;A6D//NA;EACE,iBAAA;A7DkgOF;;A6D7/NE;EACE,mDAAA;A7DggOJ;;A6D5/NA;EACE;IACE,YzDwqCgC;EJu1LlC;AACF;A6D5/NA;EACE,qFAAA;EACA,oBAAA;EACA,8CAAA;A7D8/NF;;A6D3/NA;EACE;IACE,uBAAA;E7D8/NF;AACF;A0D7iOE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A1D+iOJ;;A8D/iOE;EACE,yBAAA;EACA,yEAAA;A9DkjOJ;;A8DpjOE;EACE,yBAAA;EACA,yEAAA;A9DujOJ;;A8DzjOE;EACE,yBAAA;EACA,uEAAA;A9D4jOJ;;A8D9jOE;EACE,yBAAA;EACA,yEAAA;A9DikOJ;;A8DnkOE;EACE,yBAAA;EACA,wEAAA;A9DskOJ;;A8DxkOE;EACE,yBAAA;EACA,wEAAA;A9D2kOJ;;A8D7kOE;EACE,yBAAA;EACA,uEAAA;A9DglOJ;;A8DllOE;EACE,yBAAA;EACA,wEAAA;A9DqlOJ;;A8DvlOE;EACE,yBAAA;EACA,sEAAA;A9D0lOJ;;A+DhmOE;EACE,yBAAA;A/DmmOJ;A+DhmOM;EAEE,uBAAA;A/DimOR;;A+DvmOE;EACE,yBAAA;A/D0mOJ;A+DvmOM;EAEE,yBAAA;A/DwmOR;;A+D9mOE;EACE,yBAAA;A/DinOJ;A+D9mOM;EAEE,yBAAA;A/D+mOR;;A+DrnOE;EACE,yBAAA;A/DwnOJ;A+DrnOM;EAEE,yBAAA;A/DsnOR;;A+D5nOE;EACE,yBAAA;A/D+nOJ;A+D5nOM;EAEE,yBAAA;A/D6nOR;;A+DnoOE;EACE,yBAAA;A/DsoOJ;A+DnoOM;EAEE,yBAAA;A/DooOR;;A+D1oOE;EACE,yBAAA;A/D6oOJ;A+D1oOM;EAEE,yBAAA;A/D2oOR;;A+DjpOE;EACE,yBAAA;A/DopOJ;A+DjpOM;EAEE,yBAAA;A/DkpOR;;A+DxpOE;EACE,yBAAA;A/D2pOJ;A+DxpOM;EAEE,yBAAA;A/DypOR;;AgE9pOA;EACE,kBAAA;EACA,WAAA;AhEiqOF;AgE/pOE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AhEiqOJ;AgE9pOE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AhEgqOJ;;AgE3pOE;EACE,uBAAA;AhE8pOJ;;AgE/pOE;EACE,sBAAA;AhEkqOJ;;AgEnqOE;EACE,yBAAA;AhEsqOJ;;AgEvqOE;EACE,iCAAA;AhE0qOJ;;AiE/rOA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a7D6gCkC;AJqrMpC;;AiE/rOA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a7DqgCkC;AJ6rMpC;;AiE1rOI;EACE,gBAAA;EACA,MAAA;EACA,a7Dy/B8B;AJosMpC;;AiE1rOI;EACE,gBAAA;EACA,SAAA;EACA,a7Dm/B8B;AJ0sMpC;;Ae9pOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a7Dy/B8B;EJitMlC;;EiEvsOE;IACE,gBAAA;IACA,SAAA;IACA,a7Dm/B8B;EJutMlC;AACF;Ae5qOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a7Dy/B8B;EJ8tMlC;;EiEptOE;IACE,gBAAA;IACA,SAAA;IACA,a7Dm/B8B;EJouMlC;AACF;AezrOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a7Dy/B8B;EJ2uMlC;;EiEjuOE;IACE,gBAAA;IACA,SAAA;IACA,a7Dm/B8B;EJivMlC;AACF;AetsOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a7Dy/B8B;EJwvMlC;;EiE9uOE;IACE,gBAAA;IACA,SAAA;IACA,a7Dm/B8B;EJ8vMlC;AACF;AentOI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a7Dy/B8B;EJqwMlC;;EiE3vOE;IACE,gBAAA;IACA,SAAA;IACA,a7Dm/B8B;EJ2wMlC;AACF;AkE9xOA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AlEgyOF;;AkE7xOA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AlEgyOF;;AmExyOA;;ECIE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;ApEyyOF;;AqEpzOE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UjEoZsC;EiEnZtC,WAAA;ArEuzOJ;;AsE/zOA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AvEm0OF;;AwEz0OA;EACE,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,8BAAA;EACA,apEynB4B;AJmtN9B;;AyEhxOQ;EAOI,mCAAA;AzE6wOZ;;AyEpxOQ;EAOI,8BAAA;AzEixOZ;;AyExxOQ;EAOI,iCAAA;AzEqxOZ;;AyE5xOQ;EAOI,iCAAA;AzEyxOZ;;AyEhyOQ;EAOI,sCAAA;AzE6xOZ;;AyEpyOQ;EAOI,mCAAA;AzEiyOZ;;AyExyOQ;EAOI,sBAAA;AzEqyOZ;;AyE5yOQ;EAOI,uBAAA;AzEyyOZ;;AyEhzOQ;EAOI,sBAAA;AzE6yOZ;;AyEpzOQ;EAOI,qBAAA;AzEizOZ;;AyExzOQ;EAOI,wBAAA;AzEqzOZ;;AyE5zOQ;EAOI,uBAAA;AzEyzOZ;;AyEh0OQ;EAOI,wBAAA;AzE6zOZ;;AyEp0OQ;EAOI,uBAAA;AzEi0OZ;;AyEx0OQ;EAOI,wBAAA;AzEq0OZ;;AyE50OQ;EAOI,uBAAA;AzEy0OZ;;AyEh1OQ;EAOI,wBAAA;AzE60OZ;;AyEp1OQ;EAOI,qBAAA;AzEi1OZ;;AyEx1OQ;EAOI,yBAAA;AzEq1OZ;;AyE51OQ;EAOI,2BAAA;AzEy1OZ;;AyEh2OQ;EAOI,4BAAA;AzE61OZ;;AyEp2OQ;EAOI,2BAAA;AzEi2OZ;;AyEx2OQ;EAOI,0BAAA;AzEq2OZ;;AyE52OQ;EAOI,gCAAA;AzEy2OZ;;AyEh3OQ;EAOI,yBAAA;AzE62OZ;;AyEp3OQ;EAOI,wBAAA;AzEi3OZ;;AyEx3OQ;EAOI,yBAAA;AzEq3OZ;;AyE53OQ;EAOI,6BAAA;AzEy3OZ;;AyEh4OQ;EAOI,8BAAA;AzE63OZ;;AyEp4OQ;EAOI,wBAAA;AzEi4OZ;;AyEx4OQ;EAOI,+BAAA;AzEq4OZ;;AyE54OQ;EAOI,wBAAA;AzEy4OZ;;AyEh5OQ;EAOI,kEAAA;AzE64OZ;;AyEp5OQ;EAOI,gEAAA;AzEi5OZ;;AyEx5OQ;EAOI,0DAAA;AzEq5OZ;;AyE55OQ;EAOI,2BAAA;AzEy5OZ;;AyEh6OQ;EAOI,2BAAA;AzE65OZ;;AyEp6OQ;EAOI,6BAAA;AzEi6OZ;;AyEx6OQ;EAOI,6BAAA;AzEq6OZ;;AyE56OQ;EAOI,0BAAA;AzEy6OZ;;AyEh7OQ;EAOI,2BAAA;AzE66OZ;;AyEp7OQ;EAOI,iBAAA;AzEi7OZ;;AyEx7OQ;EAOI,mBAAA;AzEq7OZ;;AyE57OQ;EAOI,mBAAA;AzEy7OZ;;AyEh8OQ;EAOI,mBAAA;AzE67OZ;;AyEp8OQ;EAOI,oBAAA;AzEi8OZ;;AyEx8OQ;EAOI,oBAAA;AzEq8OZ;;AyE58OQ;EAOI,sBAAA;AzEy8OZ;;AyEh9OQ;EAOI,sBAAA;AzE68OZ;;AyEp9OQ;EAOI,sBAAA;AzEi9OZ;;AyEx9OQ;EAOI,uBAAA;AzEq9OZ;;AyE59OQ;EAOI,kBAAA;AzEy9OZ;;AyEh+OQ;EAOI,oBAAA;AzE69OZ;;AyEp+OQ;EAOI,oBAAA;AzEi+OZ;;AyEx+OQ;EAOI,oBAAA;AzEq+OZ;;AyE5+OQ;EAOI,qBAAA;AzEy+OZ;;AyEh/OQ;EAOI,mBAAA;AzE6+OZ;;AyEp/OQ;EAOI,qBAAA;AzEi/OZ;;AyEx/OQ;EAOI,qBAAA;AzEq/OZ;;AyE5/OQ;EAOI,qBAAA;AzEy/OZ;;AyEhgPQ;EAOI,sBAAA;AzE6/OZ;;AyEpgPQ;EAOI,2CAAA;AzEigPZ;;AyExgPQ;EAOI,sCAAA;AzEqgPZ;;AyE5gPQ;EAOI,sCAAA;AzEygPZ;;AyEhhPQ;EAOI,uFAAA;AzE6gPZ;;AyEphPQ;EAOI,oBAAA;AzEihPZ;;AyExhPQ;EAOI,2FAAA;AzEqhPZ;;AyE5hPQ;EAOI,wBAAA;AzEyhPZ;;AyEhiPQ;EAOI,6FAAA;AzE6hPZ;;AyEpiPQ;EAOI,0BAAA;AzEiiPZ;;AyExiPQ;EAOI,8FAAA;AzEqiPZ;;AyE5iPQ;EAOI,2BAAA;AzEyiPZ;;AyEhjPQ;EAOI,4FAAA;AzE6iPZ;;AyEpjPQ;EAOI,yBAAA;AzEijPZ;;AyExjPQ;EAIQ,sBAAA;EAGJ,4EAAA;AzEsjPZ;;AyE7jPQ;EAIQ,sBAAA;EAGJ,4EAAA;AzE2jPZ;;AyElkPQ;EAIQ,sBAAA;EAGJ,8EAAA;AzEgkPZ;;AyEvkPQ;EAIQ,sBAAA;EAGJ,gFAAA;AzEqkPZ;;AyE5kPQ;EAIQ,sBAAA;EAGJ,8EAAA;AzE0kPZ;;AyEjlPQ;EAIQ,sBAAA;EAGJ,2EAAA;AzE+kPZ;;AyEtlPQ;EAIQ,sBAAA;EAGJ,8EAAA;AzEolPZ;;AyE3lPQ;EAIQ,sBAAA;EAGJ,6EAAA;AzEylPZ;;AyEhmPQ;EAIQ,sBAAA;EAGJ,2EAAA;AzE8lPZ;;AyE/mPQ;EACE,oBAAA;AzEknPV;;AyEnnPQ;EACE,sBAAA;AzEsnPV;;AyEvnPQ;EACE,sBAAA;AzE0nPV;;AyE3nPQ;EACE,sBAAA;AzE8nPV;;AyE/nPQ;EACE,sBAAA;AzEkoPV;;AyEnoPQ;EACE,sBAAA;AzEsoPV;;AyEvoPQ;EACE,wBAAA;AzE0oPV;;AyE3oPQ;EACE,yBAAA;AzE8oPV;;AyE/oPQ;EACE,wBAAA;AzEkpPV;;AyEnpPQ;EACE,yBAAA;AzEspPV;;AyEvpPQ;EACE,sBAAA;AzE0pPV;;AyEjpPQ;EAOI,uBAAA;AzE8oPZ;;AyErpPQ;EAOI,qBAAA;AzEkpPZ;;AyEzpPQ;EAOI,qBAAA;AzEspPZ;;AyE7pPQ;EAOI,qBAAA;AzE0pPZ;;AyEjqPQ;EAOI,sBAAA;AzE8pPZ;;AyErqPQ;EAOI,sBAAA;AzEkqPZ;;AyEzqPQ;EAOI,qBAAA;AzEsqPZ;;AyE7qPQ;EAOI,qBAAA;AzE0qPZ;;AyEjrPQ;EAOI,qBAAA;AzE8qPZ;;AyErrPQ;EAOI,qBAAA;AzEkrPZ;;AyEzrPQ;EAOI,qBAAA;AzEsrPZ;;AyE7rPQ;EAOI,qBAAA;AzE0rPZ;;AyEjsPQ;EAOI,qBAAA;AzE8rPZ;;AyErsPQ;EAOI,qBAAA;AzEksPZ;;AyEzsPQ;EAOI,qBAAA;AzEssPZ;;AyE7sPQ;EAOI,sBAAA;AzE0sPZ;;AyEjtPQ;EAOI,sBAAA;AzE8sPZ;;AyErtPQ;EAOI,sBAAA;AzEktPZ;;AyEztPQ;EAOI,sBAAA;AzEstPZ;;AyE7tPQ;EAOI,sBAAA;AzE0tPZ;;AyEjuPQ;EAOI,sBAAA;AzE8tPZ;;AyEruPQ;EAOI,sBAAA;AzEkuPZ;;AyEzuPQ;EAOI,sBAAA;AzEsuPZ;;AyE7uPQ;EAOI,sBAAA;AzE0uPZ;;AyEjvPQ;EAOI,sBAAA;AzE8uPZ;;AyErvPQ;EAOI,sBAAA;AzEkvPZ;;AyEzvPQ;EAOI,sBAAA;AzEsvPZ;;AyE7vPQ;EAOI,sBAAA;AzE0vPZ;;AyEjwPQ;EAOI,sBAAA;AzE8vPZ;;AyErwPQ;EAOI,sBAAA;AzEkwPZ;;AyEzwPQ;EAOI,sBAAA;AzEswPZ;;AyE7wPQ;EAOI,sBAAA;AzE0wPZ;;AyEjxPQ;EAOI,sBAAA;AzE8wPZ;;AyErxPQ;EAOI,uBAAA;AzEkxPZ;;AyEzxPQ;EAOI,uBAAA;AzEsxPZ;;AyE7xPQ;EAOI,uBAAA;AzE0xPZ;;AyEjyPQ;EAOI,uBAAA;AzE8xPZ;;AyEryPQ;EAOI,uBAAA;AzEkyPZ;;AyEzyPQ;EAOI,uBAAA;AzEsyPZ;;AyE7yPQ;EAOI,uBAAA;AzE0yPZ;;AyEjzPQ;EAOI,uBAAA;AzE8yPZ;;AyErzPQ;EAOI,uBAAA;AzEkzPZ;;AyEzzPQ;EAOI,uBAAA;AzEszPZ;;AyE7zPQ;EAOI,uBAAA;AzE0zPZ;;AyEj0PQ;EAOI,uBAAA;AzE8zPZ;;AyEr0PQ;EAOI,uBAAA;AzEk0PZ;;AyEz0PQ;EAOI,uBAAA;AzEs0PZ;;AyE70PQ;EAOI,uBAAA;AzE00PZ;;AyEj1PQ;EAOI,uBAAA;AzE80PZ;;AyEr1PQ;EAOI,uBAAA;AzEk1PZ;;AyEz1PQ;EAOI,uBAAA;AzEs1PZ;;AyE71PQ;EAOI,uBAAA;AzE01PZ;;AyEj2PQ;EAOI,uBAAA;AzE81PZ;;AyEr2PQ;EAOI,uBAAA;AzEk2PZ;;AyEz2PQ;EAOI,uBAAA;AzEs2PZ;;AyE72PQ;EAOI,uBAAA;AzE02PZ;;AyEj3PQ;EAOI,uBAAA;AzE82PZ;;AyEr3PQ;EAOI,uBAAA;AzEk3PZ;;AyEz3PQ;EAOI,uBAAA;AzEs3PZ;;AyE73PQ;EAOI,wBAAA;AzE03PZ;;AyEj4PQ;EAOI,2BAAA;AzE83PZ;;AyEr4PQ;EAOI,yBAAA;AzEk4PZ;;AyEz4PQ;EAOI,yBAAA;AzEs4PZ;;AyE74PQ;EAOI,yBAAA;AzE04PZ;;AyEj5PQ;EAOI,0BAAA;AzE84PZ;;AyEr5PQ;EAOI,0BAAA;AzEk5PZ;;AyEz5PQ;EAOI,yBAAA;AzEs5PZ;;AyE75PQ;EAOI,yBAAA;AzE05PZ;;AyEj6PQ;EAOI,yBAAA;AzE85PZ;;AyEr6PQ;EAOI,yBAAA;AzEk6PZ;;AyEz6PQ;EAOI,yBAAA;AzEs6PZ;;AyE76PQ;EAOI,yBAAA;AzE06PZ;;AyEj7PQ;EAOI,yBAAA;AzE86PZ;;AyEr7PQ;EAOI,yBAAA;AzEk7PZ;;AyEz7PQ;EAOI,yBAAA;AzEs7PZ;;AyE77PQ;EAOI,0BAAA;AzE07PZ;;AyEj8PQ;EAOI,0BAAA;AzE87PZ;;AyEr8PQ;EAOI,0BAAA;AzEk8PZ;;AyEz8PQ;EAOI,0BAAA;AzEs8PZ;;AyE78PQ;EAOI,0BAAA;AzE08PZ;;AyEj9PQ;EAOI,0BAAA;AzE88PZ;;AyEr9PQ;EAOI,0BAAA;AzEk9PZ;;AyEz9PQ;EAOI,0BAAA;AzEs9PZ;;AyE79PQ;EAOI,0BAAA;AzE09PZ;;AyEj+PQ;EAOI,0BAAA;AzE89PZ;;AyEr+PQ;EAOI,0BAAA;AzEk+PZ;;AyEz+PQ;EAOI,0BAAA;AzEs+PZ;;AyE7+PQ;EAOI,0BAAA;AzE0+PZ;;AyEj/PQ;EAOI,0BAAA;AzE8+PZ;;AyEr/PQ;EAOI,0BAAA;AzEk/PZ;;AyEz/PQ;EAOI,0BAAA;AzEs/PZ;;AyE7/PQ;EAOI,0BAAA;AzE0/PZ;;AyEjgQQ;EAOI,0BAAA;AzE8/PZ;;AyErgQQ;EAOI,2BAAA;AzEkgQZ;;AyEzgQQ;EAOI,2BAAA;AzEsgQZ;;AyE7gQQ;EAOI,2BAAA;AzE0gQZ;;AyEjhQQ;EAOI,2BAAA;AzE8gQZ;;AyErhQQ;EAOI,2BAAA;AzEkhQZ;;AyEzhQQ;EAOI,2BAAA;AzEshQZ;;AyE7hQQ;EAOI,2BAAA;AzE0hQZ;;AyEjiQQ;EAOI,2BAAA;AzE8hQZ;;AyEriQQ;EAOI,2BAAA;AzEkiQZ;;AyEziQQ;EAOI,2BAAA;AzEsiQZ;;AyE7iQQ;EAOI,2BAAA;AzE0iQZ;;AyEjjQQ;EAOI,2BAAA;AzE8iQZ;;AyErjQQ;EAOI,2BAAA;AzEkjQZ;;AyEzjQQ;EAOI,2BAAA;AzEsjQZ;;AyE7jQQ;EAOI,2BAAA;AzE0jQZ;;AyEjkQQ;EAOI,2BAAA;AzE8jQZ;;AyErkQQ;EAOI,2BAAA;AzEkkQZ;;AyEzkQQ;EAOI,2BAAA;AzEskQZ;;AyE7kQQ;EAOI,2BAAA;AzE0kQZ;;AyEjlQQ;EAOI,2BAAA;AzE8kQZ;;AyErlQQ;EAOI,2BAAA;AzEklQZ;;AyEzlQQ;EAOI,2BAAA;AzEslQZ;;AyE7lQQ;EAOI,2BAAA;AzE0lQZ;;AyEjmQQ;EAOI,2BAAA;AzE8lQZ;;AyErmQQ;EAOI,2BAAA;AzEkmQZ;;AyEzmQQ;EAOI,2BAAA;AzEsmQZ;;AyE7mQQ;EAOI,4BAAA;AzE0mQZ;;AyEjnQQ;EAOI,uBAAA;AzE8mQZ;;AyErnQQ;EAOI,2BAAA;AzEknQZ;;AyEznQQ;EAOI,wBAAA;AzEsnQZ;;AyE7nQQ;EAOI,sBAAA;AzE0nQZ;;AyEjoQQ;EAOI,sBAAA;AzE8nQZ;;AyEroQQ;EAOI,sBAAA;AzEkoQZ;;AyEzoQQ;EAOI,uBAAA;AzEsoQZ;;AyE7oQQ;EAOI,uBAAA;AzE0oQZ;;AyEjpQQ;EAOI,sBAAA;AzE8oQZ;;AyErpQQ;EAOI,sBAAA;AzEkpQZ;;AyEzpQQ;EAOI,sBAAA;AzEspQZ;;AyE7pQQ;EAOI,sBAAA;AzE0pQZ;;AyEjqQQ;EAOI,sBAAA;AzE8pQZ;;AyErqQQ;EAOI,sBAAA;AzEkqQZ;;AyEzqQQ;EAOI,sBAAA;AzEsqQZ;;AyE7qQQ;EAOI,sBAAA;AzE0qQZ;;AyEjrQQ;EAOI,sBAAA;AzE8qQZ;;AyErrQQ;EAOI,uBAAA;AzEkrQZ;;AyEzrQQ;EAOI,uBAAA;AzEsrQZ;;AyE7rQQ;EAOI,uBAAA;AzE0rQZ;;AyEjsQQ;EAOI,uBAAA;AzE8rQZ;;AyErsQQ;EAOI,uBAAA;AzEksQZ;;AyEzsQQ;EAOI,uBAAA;AzEssQZ;;AyE7sQQ;EAOI,uBAAA;AzE0sQZ;;AyEjtQQ;EAOI,uBAAA;AzE8sQZ;;AyErtQQ;EAOI,uBAAA;AzEktQZ;;AyEztQQ;EAOI,uBAAA;AzEstQZ;;AyE7tQQ;EAOI,uBAAA;AzE0tQZ;;AyEjuQQ;EAOI,uBAAA;AzE8tQZ;;AyEruQQ;EAOI,uBAAA;AzEkuQZ;;AyEzuQQ;EAOI,uBAAA;AzEsuQZ;;AyE7uQQ;EAOI,uBAAA;AzE0uQZ;;AyEjvQQ;EAOI,uBAAA;AzE8uQZ;;AyErvQQ;EAOI,uBAAA;AzEkvQZ;;AyEzvQQ;EAOI,uBAAA;AzEsvQZ;;AyE7vQQ;EAOI,wBAAA;AzE0vQZ;;AyEjwQQ;EAOI,wBAAA;AzE8vQZ;;AyErwQQ;EAOI,wBAAA;AzEkwQZ;;AyEzwQQ;EAOI,wBAAA;AzEswQZ;;AyE7wQQ;EAOI,wBAAA;AzE0wQZ;;AyEjxQQ;EAOI,wBAAA;AzE8wQZ;;AyErxQQ;EAOI,wBAAA;AzEkxQZ;;AyEzxQQ;EAOI,wBAAA;AzEsxQZ;;AyE7xQQ;EAOI,wBAAA;AzE0xQZ;;AyEjyQQ;EAOI,wBAAA;AzE8xQZ;;AyEryQQ;EAOI,wBAAA;AzEkyQZ;;AyEzyQQ;EAOI,wBAAA;AzEsyQZ;;AyE7yQQ;EAOI,wBAAA;AzE0yQZ;;AyEjzQQ;EAOI,wBAAA;AzE8yQZ;;AyErzQQ;EAOI,wBAAA;AzEkzQZ;;AyEzzQQ;EAOI,wBAAA;AzEszQZ;;AyE7zQQ;EAOI,wBAAA;AzE0zQZ;;AyEj0QQ;EAOI,wBAAA;AzE8zQZ;;AyEr0QQ;EAOI,wBAAA;AzEk0QZ;;AyEz0QQ;EAOI,wBAAA;AzEs0QZ;;AyE70QQ;EAOI,wBAAA;AzE00QZ;;AyEj1QQ;EAOI,wBAAA;AzE80QZ;;AyEr1QQ;EAOI,wBAAA;AzEk1QZ;;AyEz1QQ;EAOI,wBAAA;AzEs1QZ;;AyE71QQ;EAOI,wBAAA;AzE01QZ;;AyEj2QQ;EAOI,wBAAA;AzE81QZ;;AyEr2QQ;EAOI,yBAAA;AzEk2QZ;;AyEz2QQ;EAOI,4BAAA;AzEs2QZ;;AyE72QQ;EAOI,0BAAA;AzE02QZ;;AyEj3QQ;EAOI,0BAAA;AzE82QZ;;AyEr3QQ;EAOI,0BAAA;AzEk3QZ;;AyEz3QQ;EAOI,2BAAA;AzEs3QZ;;AyE73QQ;EAOI,2BAAA;AzE03QZ;;AyEj4QQ;EAOI,0BAAA;AzE83QZ;;AyEr4QQ;EAOI,0BAAA;AzEk4QZ;;AyEz4QQ;EAOI,0BAAA;AzEs4QZ;;AyE74QQ;EAOI,0BAAA;AzE04QZ;;AyEj5QQ;EAOI,0BAAA;AzE84QZ;;AyEr5QQ;EAOI,0BAAA;AzEk5QZ;;AyEz5QQ;EAOI,0BAAA;AzEs5QZ;;AyE75QQ;EAOI,0BAAA;AzE05QZ;;AyEj6QQ;EAOI,0BAAA;AzE85QZ;;AyEr6QQ;EAOI,2BAAA;AzEk6QZ;;AyEz6QQ;EAOI,2BAAA;AzEs6QZ;;AyE76QQ;EAOI,2BAAA;AzE06QZ;;AyEj7QQ;EAOI,2BAAA;AzE86QZ;;AyEr7QQ;EAOI,2BAAA;AzEk7QZ;;AyEz7QQ;EAOI,2BAAA;AzEs7QZ;;AyE77QQ;EAOI,2BAAA;AzE07QZ;;AyEj8QQ;EAOI,2BAAA;AzE87QZ;;AyEr8QQ;EAOI,2BAAA;AzEk8QZ;;AyEz8QQ;EAOI,2BAAA;AzEs8QZ;;AyE78QQ;EAOI,2BAAA;AzE08QZ;;AyEj9QQ;EAOI,2BAAA;AzE88QZ;;AyEr9QQ;EAOI,2BAAA;AzEk9QZ;;AyEz9QQ;EAOI,2BAAA;AzEs9QZ;;AyE79QQ;EAOI,2BAAA;AzE09QZ;;AyEj+QQ;EAOI,2BAAA;AzE89QZ;;AyEr+QQ;EAOI,2BAAA;AzEk+QZ;;AyEz+QQ;EAOI,2BAAA;AzEs+QZ;;AyE7+QQ;EAOI,4BAAA;AzE0+QZ;;AyEj/QQ;EAOI,4BAAA;AzE8+QZ;;AyEr/QQ;EAOI,4BAAA;AzEk/QZ;;AyEz/QQ;EAOI,4BAAA;AzEs/QZ;;AyE7/QQ;EAOI,4BAAA;AzE0/QZ;;AyEjgRQ;EAOI,4BAAA;AzE8/QZ;;AyErgRQ;EAOI,4BAAA;AzEkgRZ;;AyEzgRQ;EAOI,4BAAA;AzEsgRZ;;AyE7gRQ;EAOI,4BAAA;AzE0gRZ;;AyEjhRQ;EAOI,4BAAA;AzE8gRZ;;AyErhRQ;EAOI,4BAAA;AzEkhRZ;;AyEzhRQ;EAOI,4BAAA;AzEshRZ;;AyE7hRQ;EAOI,4BAAA;AzE0hRZ;;AyEjiRQ;EAOI,4BAAA;AzE8hRZ;;AyEriRQ;EAOI,4BAAA;AzEkiRZ;;AyEziRQ;EAOI,4BAAA;AzEsiRZ;;AyE7iRQ;EAOI,4BAAA;AzE0iRZ;;AyEjjRQ;EAOI,4BAAA;AzE8iRZ;;AyErjRQ;EAOI,4BAAA;AzEkjRZ;;AyEzjRQ;EAOI,4BAAA;AzEsjRZ;;AyE7jRQ;EAOI,4BAAA;AzE0jRZ;;AyEjkRQ;EAOI,4BAAA;AzE8jRZ;;AyErkRQ;EAOI,4BAAA;AzEkkRZ;;AyEzkRQ;EAOI,4BAAA;AzEskRZ;;AyE7kRQ;EAOI,4BAAA;AzE0kRZ;;AyEjlRQ;EAOI,4BAAA;AzE8kRZ;;AyErlRQ;EAOI,6BAAA;AzEklRZ;;AyEzlRQ;EAOI,wBAAA;AzEslRZ;;AyE7lRQ;EAOI,4BAAA;AzE0lRZ;;AyEjmRQ;EAOI,yBAAA;AzE8lRZ;;AyErmRQ;EAOI,8BAAA;AzEkmRZ;;AyEzmRQ;EAOI,iCAAA;AzEsmRZ;;AyE7mRQ;EAOI,sCAAA;AzE0mRZ;;AyEjnRQ;EAOI,yCAAA;AzE8mRZ;;AyErnRQ;EAOI,uBAAA;AzEknRZ;;AyEznRQ;EAOI,uBAAA;AzEsnRZ;;AyE7nRQ;EAOI,yBAAA;AzE0nRZ;;AyEjoRQ;EAOI,yBAAA;AzE8nRZ;;AyEroRQ;EAOI,0BAAA;AzEkoRZ;;AyEzoRQ;EAOI,4BAAA;AzEsoRZ;;AyE7oRQ;EAOI,kCAAA;AzE0oRZ;;AyEjpRQ;EAOI,sCAAA;AzE8oRZ;;AyErpRQ;EAOI,oCAAA;AzEkpRZ;;AyEzpRQ;EAOI,kCAAA;AzEspRZ;;AyE7pRQ;EAOI,yCAAA;AzE0pRZ;;AyEjqRQ;EAOI,wCAAA;AzE8pRZ;;AyErqRQ;EAOI,wCAAA;AzEkqRZ;;AyEzqRQ;EAOI,kCAAA;AzEsqRZ;;AyE7qRQ;EAOI,gCAAA;AzE0qRZ;;AyEjrRQ;EAOI,8BAAA;AzE8qRZ;;AyErrRQ;EAOI,gCAAA;AzEkrRZ;;AyEzrRQ;EAOI,+BAAA;AzEsrRZ;;AyE7rRQ;EAOI,oCAAA;AzE0rRZ;;AyEjsRQ;EAOI,kCAAA;AzE8rRZ;;AyErsRQ;EAOI,gCAAA;AzEksRZ;;AyEzsRQ;EAOI,uCAAA;AzEssRZ;;AyE7sRQ;EAOI,sCAAA;AzE0sRZ;;AyEjtRQ;EAOI,iCAAA;AzE8sRZ;;AyErtRQ;EAOI,2BAAA;AzEktRZ;;AyEztRQ;EAOI,iCAAA;AzEstRZ;;AyE7tRQ;EAOI,+BAAA;AzE0tRZ;;AyEjuRQ;EAOI,6BAAA;AzE8tRZ;;AyEruRQ;EAOI,+BAAA;AzEkuRZ;;AyEzuRQ;EAOI,8BAAA;AzEsuRZ;;AyE7uRQ;EAOI,oBAAA;AzE0uRZ;;AyEjvRQ;EAOI,mBAAA;AzE8uRZ;;AyErvRQ;EAOI,mBAAA;AzEkvRZ;;AyEzvRQ;EAOI,mBAAA;AzEsvRZ;;AyE7vRQ;EAOI,mBAAA;AzE0vRZ;;AyEjwRQ;EAOI,mBAAA;AzE8vRZ;;AyErwRQ;EAOI,mBAAA;AzEkwRZ;;AyEzwRQ;EAOI,mBAAA;AzEswRZ;;AyE7wRQ;EAOI,oBAAA;AzE0wRZ;;AyEjxRQ;EAOI,0BAAA;AzE8wRZ;;AyErxRQ;EAOI,yBAAA;AzEkxRZ;;AyEzxRQ;EAOI,0BAAA;AzEsxRZ;;AyE7xRQ;EAOI,uBAAA;AzE0xRZ;;AyEjyRQ;EAOI,0BAAA;AzE8xRZ;;AyEryRQ;EAOI,yBAAA;AzEkyRZ;;AyEzyRQ;EAOI,0BAAA;AzEsyRZ;;AyE7yRQ;EAOI,uBAAA;AzE0yRZ;;AyEjzRQ;EAOI,0BAAA;AzE8yRZ;;AyErzRQ;EAOI,yBAAA;AzEkzRZ;;AyEzzRQ;EAOI,0BAAA;AzEszRZ;;AyE7zRQ;EAOI,uBAAA;AzE0zRZ;;AyEj0RQ;EAOI,0BAAA;AzE8zRZ;;AyEr0RQ;EAOI,yBAAA;AzEk0RZ;;AyEz0RQ;EAOI,0BAAA;AzEs0RZ;;AyE70RQ;EAOI,uBAAA;AzE00RZ;;AyEj1RQ;EAOI,0BAAA;AzE80RZ;;AyEr1RQ;EAOI,yBAAA;AzEk1RZ;;AyEz1RQ;EAOI,0BAAA;AzEs1RZ;;AyE71RQ;EAOI,uBAAA;AzE01RZ;;AyEj2RQ;EAOI,uBAAA;AzE81RZ;;AyEr2RQ;EAOI,0BAAA;EAAA,yBAAA;AzEm2RZ;;AyE12RQ;EAOI,gCAAA;EAAA,+BAAA;AzEw2RZ;;AyE/2RQ;EAOI,+BAAA;EAAA,8BAAA;AzE62RZ;;AyEp3RQ;EAOI,gCAAA;EAAA,+BAAA;AzEk3RZ;;AyEz3RQ;EAOI,6BAAA;EAAA,4BAAA;AzEu3RZ;;AyE93RQ;EAOI,gCAAA;EAAA,+BAAA;AzE43RZ;;AyEn4RQ;EAOI,+BAAA;EAAA,8BAAA;AzEi4RZ;;AyEx4RQ;EAOI,gCAAA;EAAA,+BAAA;AzEs4RZ;;AyE74RQ;EAOI,6BAAA;EAAA,4BAAA;AzE24RZ;;AyEl5RQ;EAOI,gCAAA;EAAA,+BAAA;AzEg5RZ;;AyEv5RQ;EAOI,+BAAA;EAAA,8BAAA;AzEq5RZ;;AyE55RQ;EAOI,gCAAA;EAAA,+BAAA;AzE05RZ;;AyEj6RQ;EAOI,6BAAA;EAAA,4BAAA;AzE+5RZ;;AyEt6RQ;EAOI,gCAAA;EAAA,+BAAA;AzEo6RZ;;AyE36RQ;EAOI,+BAAA;EAAA,8BAAA;AzEy6RZ;;AyEh7RQ;EAOI,gCAAA;EAAA,+BAAA;AzE86RZ;;AyEr7RQ;EAOI,6BAAA;EAAA,4BAAA;AzEm7RZ;;AyE17RQ;EAOI,gCAAA;EAAA,+BAAA;AzEw7RZ;;AyE/7RQ;EAOI,+BAAA;EAAA,8BAAA;AzE67RZ;;AyEp8RQ;EAOI,gCAAA;EAAA,+BAAA;AzEk8RZ;;AyEz8RQ;EAOI,6BAAA;EAAA,4BAAA;AzEu8RZ;;AyE98RQ;EAOI,6BAAA;EAAA,4BAAA;AzE48RZ;;AyEn9RQ;EAOI,wBAAA;EAAA,2BAAA;AzEi9RZ;;AyEx9RQ;EAOI,8BAAA;EAAA,iCAAA;AzEs9RZ;;AyE79RQ;EAOI,6BAAA;EAAA,gCAAA;AzE29RZ;;AyEl+RQ;EAOI,8BAAA;EAAA,iCAAA;AzEg+RZ;;AyEv+RQ;EAOI,2BAAA;EAAA,8BAAA;AzEq+RZ;;AyE5+RQ;EAOI,8BAAA;EAAA,iCAAA;AzE0+RZ;;AyEj/RQ;EAOI,6BAAA;EAAA,gCAAA;AzE++RZ;;AyEt/RQ;EAOI,8BAAA;EAAA,iCAAA;AzEo/RZ;;AyE3/RQ;EAOI,2BAAA;EAAA,8BAAA;AzEy/RZ;;AyEhgSQ;EAOI,8BAAA;EAAA,iCAAA;AzE8/RZ;;AyErgSQ;EAOI,6BAAA;EAAA,gCAAA;AzEmgSZ;;AyE1gSQ;EAOI,8BAAA;EAAA,iCAAA;AzEwgSZ;;AyE/gSQ;EAOI,2BAAA;EAAA,8BAAA;AzE6gSZ;;AyEphSQ;EAOI,8BAAA;EAAA,iCAAA;AzEkhSZ;;AyEzhSQ;EAOI,6BAAA;EAAA,gCAAA;AzEuhSZ;;AyE9hSQ;EAOI,8BAAA;EAAA,iCAAA;AzE4hSZ;;AyEniSQ;EAOI,2BAAA;EAAA,8BAAA;AzEiiSZ;;AyExiSQ;EAOI,8BAAA;EAAA,iCAAA;AzEsiSZ;;AyE7iSQ;EAOI,6BAAA;EAAA,gCAAA;AzE2iSZ;;AyEljSQ;EAOI,8BAAA;EAAA,iCAAA;AzEgjSZ;;AyEvjSQ;EAOI,2BAAA;EAAA,8BAAA;AzEqjSZ;;AyE5jSQ;EAOI,2BAAA;EAAA,8BAAA;AzE0jSZ;;AyEjkSQ;EAOI,wBAAA;AzE8jSZ;;AyErkSQ;EAOI,8BAAA;AzEkkSZ;;AyEzkSQ;EAOI,6BAAA;AzEskSZ;;AyE7kSQ;EAOI,8BAAA;AzE0kSZ;;AyEjlSQ;EAOI,2BAAA;AzE8kSZ;;AyErlSQ;EAOI,8BAAA;AzEklSZ;;AyEzlSQ;EAOI,6BAAA;AzEslSZ;;AyE7lSQ;EAOI,8BAAA;AzE0lSZ;;AyEjmSQ;EAOI,2BAAA;AzE8lSZ;;AyErmSQ;EAOI,8BAAA;AzEkmSZ;;AyEzmSQ;EAOI,6BAAA;AzEsmSZ;;AyE7mSQ;EAOI,8BAAA;AzE0mSZ;;AyEjnSQ;EAOI,2BAAA;AzE8mSZ;;AyErnSQ;EAOI,8BAAA;AzEknSZ;;AyEznSQ;EAOI,6BAAA;AzEsnSZ;;AyE7nSQ;EAOI,8BAAA;AzE0nSZ;;AyEjoSQ;EAOI,2BAAA;AzE8nSZ;;AyEroSQ;EAOI,8BAAA;AzEkoSZ;;AyEzoSQ;EAOI,6BAAA;AzEsoSZ;;AyE7oSQ;EAOI,8BAAA;AzE0oSZ;;AyEjpSQ;EAOI,2BAAA;AzE8oSZ;;AyErpSQ;EAOI,2BAAA;AzEkpSZ;;AyEzpSQ;EAOI,0BAAA;AzEspSZ;;AyE7pSQ;EAOI,gCAAA;AzE0pSZ;;AyEjqSQ;EAOI,+BAAA;AzE8pSZ;;AyErqSQ;EAOI,gCAAA;AzEkqSZ;;AyEzqSQ;EAOI,6BAAA;AzEsqSZ;;AyE7qSQ;EAOI,gCAAA;AzE0qSZ;;AyEjrSQ;EAOI,+BAAA;AzE8qSZ;;AyErrSQ;EAOI,gCAAA;AzEkrSZ;;AyEzrSQ;EAOI,6BAAA;AzEsrSZ;;AyE7rSQ;EAOI,gCAAA;AzE0rSZ;;AyEjsSQ;EAOI,+BAAA;AzE8rSZ;;AyErsSQ;EAOI,gCAAA;AzEksSZ;;AyEzsSQ;EAOI,6BAAA;AzEssSZ;;AyE7sSQ;EAOI,gCAAA;AzE0sSZ;;AyEjtSQ;EAOI,+BAAA;AzE8sSZ;;AyErtSQ;EAOI,gCAAA;AzEktSZ;;AyEztSQ;EAOI,6BAAA;AzEstSZ;;AyE7tSQ;EAOI,gCAAA;AzE0tSZ;;AyEjuSQ;EAOI,+BAAA;AzE8tSZ;;AyEruSQ;EAOI,gCAAA;AzEkuSZ;;AyEzuSQ;EAOI,6BAAA;AzEsuSZ;;AyE7uSQ;EAOI,6BAAA;AzE0uSZ;;AyEjvSQ;EAOI,2BAAA;AzE8uSZ;;AyErvSQ;EAOI,iCAAA;AzEkvSZ;;AyEzvSQ;EAOI,gCAAA;AzEsvSZ;;AyE7vSQ;EAOI,iCAAA;AzE0vSZ;;AyEjwSQ;EAOI,8BAAA;AzE8vSZ;;AyErwSQ;EAOI,iCAAA;AzEkwSZ;;AyEzwSQ;EAOI,gCAAA;AzEswSZ;;AyE7wSQ;EAOI,iCAAA;AzE0wSZ;;AyEjxSQ;EAOI,8BAAA;AzE8wSZ;;AyErxSQ;EAOI,iCAAA;AzEkxSZ;;AyEzxSQ;EAOI,gCAAA;AzEsxSZ;;AyE7xSQ;EAOI,iCAAA;AzE0xSZ;;AyEjySQ;EAOI,8BAAA;AzE8xSZ;;AyErySQ;EAOI,iCAAA;AzEkySZ;;AyEzySQ;EAOI,gCAAA;AzEsySZ;;AyE7ySQ;EAOI,iCAAA;AzE0ySZ;;AyEjzSQ;EAOI,8BAAA;AzE8ySZ;;AyErzSQ;EAOI,iCAAA;AzEkzSZ;;AyEzzSQ;EAOI,gCAAA;AzEszSZ;;AyE7zSQ;EAOI,iCAAA;AzE0zSZ;;AyEj0SQ;EAOI,8BAAA;AzE8zSZ;;AyEr0SQ;EAOI,8BAAA;AzEk0SZ;;AyEz0SQ;EAOI,yBAAA;AzEs0SZ;;AyE70SQ;EAOI,+BAAA;AzE00SZ;;AyEj1SQ;EAOI,8BAAA;AzE80SZ;;AyEr1SQ;EAOI,+BAAA;AzEk1SZ;;AyEz1SQ;EAOI,4BAAA;AzEs1SZ;;AyE71SQ;EAOI,+BAAA;AzE01SZ;;AyEj2SQ;EAOI,8BAAA;AzE81SZ;;AyEr2SQ;EAOI,+BAAA;AzEk2SZ;;AyEz2SQ;EAOI,4BAAA;AzEs2SZ;;AyE72SQ;EAOI,+BAAA;AzE02SZ;;AyEj3SQ;EAOI,8BAAA;AzE82SZ;;AyEr3SQ;EAOI,+BAAA;AzEk3SZ;;AyEz3SQ;EAOI,4BAAA;AzEs3SZ;;AyE73SQ;EAOI,+BAAA;AzE03SZ;;AyEj4SQ;EAOI,8BAAA;AzE83SZ;;AyEr4SQ;EAOI,+BAAA;AzEk4SZ;;AyEz4SQ;EAOI,4BAAA;AzEs4SZ;;AyE74SQ;EAOI,+BAAA;AzE04SZ;;AyEj5SQ;EAOI,8BAAA;AzE84SZ;;AyEr5SQ;EAOI,+BAAA;AzEk5SZ;;AyEz5SQ;EAOI,4BAAA;AzEs5SZ;;AyE75SQ;EAOI,4BAAA;AzE05SZ;;AyEj6SQ;EAOI,2BAAA;AzE85SZ;;AyEr6SQ;EAOI,0BAAA;AzEk6SZ;;AyEz6SQ;EAOI,2BAAA;AzEs6SZ;;AyE76SQ;EAOI,wBAAA;AzE06SZ;;AyEj7SQ;EAOI,2BAAA;AzE86SZ;;AyEr7SQ;EAOI,0BAAA;AzEk7SZ;;AyEz7SQ;EAOI,2BAAA;AzEs7SZ;;AyE77SQ;EAOI,wBAAA;AzE07SZ;;AyEj8SQ;EAOI,2BAAA;AzE87SZ;;AyEr8SQ;EAOI,0BAAA;AzEk8SZ;;AyEz8SQ;EAOI,2BAAA;AzEs8SZ;;AyE78SQ;EAOI,wBAAA;AzE08SZ;;AyEj9SQ;EAOI,2BAAA;AzE88SZ;;AyEr9SQ;EAOI,0BAAA;AzEk9SZ;;AyEz9SQ;EAOI,2BAAA;AzEs9SZ;;AyE79SQ;EAOI,wBAAA;AzE09SZ;;AyEj+SQ;EAOI,2BAAA;AzE89SZ;;AyEr+SQ;EAOI,0BAAA;AzEk+SZ;;AyEz+SQ;EAOI,2BAAA;AzEs+SZ;;AyE7+SQ;EAOI,wBAAA;AzE0+SZ;;AyEj/SQ;EAOI,iCAAA;EAAA,gCAAA;AzE++SZ;;AyEt/SQ;EAOI,gCAAA;EAAA,+BAAA;AzEo/SZ;;AyE3/SQ;EAOI,iCAAA;EAAA,gCAAA;AzEy/SZ;;AyEhgTQ;EAOI,8BAAA;EAAA,6BAAA;AzE8/SZ;;AyErgTQ;EAOI,iCAAA;EAAA,gCAAA;AzEmgTZ;;AyE1gTQ;EAOI,gCAAA;EAAA,+BAAA;AzEwgTZ;;AyE/gTQ;EAOI,iCAAA;EAAA,gCAAA;AzE6gTZ;;AyEphTQ;EAOI,8BAAA;EAAA,6BAAA;AzEkhTZ;;AyEzhTQ;EAOI,iCAAA;EAAA,gCAAA;AzEuhTZ;;AyE9hTQ;EAOI,gCAAA;EAAA,+BAAA;AzE4hTZ;;AyEniTQ;EAOI,iCAAA;EAAA,gCAAA;AzEiiTZ;;AyExiTQ;EAOI,8BAAA;EAAA,6BAAA;AzEsiTZ;;AyE7iTQ;EAOI,iCAAA;EAAA,gCAAA;AzE2iTZ;;AyEljTQ;EAOI,gCAAA;EAAA,+BAAA;AzEgjTZ;;AyEvjTQ;EAOI,iCAAA;EAAA,gCAAA;AzEqjTZ;;AyE5jTQ;EAOI,8BAAA;EAAA,6BAAA;AzE0jTZ;;AyEjkTQ;EAOI,iCAAA;EAAA,gCAAA;AzE+jTZ;;AyEtkTQ;EAOI,gCAAA;EAAA,+BAAA;AzEokTZ;;AyE3kTQ;EAOI,iCAAA;EAAA,gCAAA;AzEykTZ;;AyEhlTQ;EAOI,8BAAA;EAAA,6BAAA;AzE8kTZ;;AyErlTQ;EAOI,+BAAA;EAAA,kCAAA;AzEmlTZ;;AyE1lTQ;EAOI,8BAAA;EAAA,iCAAA;AzEwlTZ;;AyE/lTQ;EAOI,+BAAA;EAAA,kCAAA;AzE6lTZ;;AyEpmTQ;EAOI,4BAAA;EAAA,+BAAA;AzEkmTZ;;AyEzmTQ;EAOI,+BAAA;EAAA,kCAAA;AzEumTZ;;AyE9mTQ;EAOI,8BAAA;EAAA,iCAAA;AzE4mTZ;;AyEnnTQ;EAOI,+BAAA;EAAA,kCAAA;AzEinTZ;;AyExnTQ;EAOI,4BAAA;EAAA,+BAAA;AzEsnTZ;;AyE7nTQ;EAOI,+BAAA;EAAA,kCAAA;AzE2nTZ;;AyEloTQ;EAOI,8BAAA;EAAA,iCAAA;AzEgoTZ;;AyEvoTQ;EAOI,+BAAA;EAAA,kCAAA;AzEqoTZ;;AyE5oTQ;EAOI,4BAAA;EAAA,+BAAA;AzE0oTZ;;AyEjpTQ;EAOI,+BAAA;EAAA,kCAAA;AzE+oTZ;;AyEtpTQ;EAOI,8BAAA;EAAA,iCAAA;AzEopTZ;;AyE3pTQ;EAOI,+BAAA;EAAA,kCAAA;AzEypTZ;;AyEhqTQ;EAOI,4BAAA;EAAA,+BAAA;AzE8pTZ;;AyErqTQ;EAOI,+BAAA;EAAA,kCAAA;AzEmqTZ;;AyE1qTQ;EAOI,8BAAA;EAAA,iCAAA;AzEwqTZ;;AyE/qTQ;EAOI,+BAAA;EAAA,kCAAA;AzE6qTZ;;AyEprTQ;EAOI,4BAAA;EAAA,+BAAA;AzEkrTZ;;AyEzrTQ;EAOI,+BAAA;AzEsrTZ;;AyE7rTQ;EAOI,8BAAA;AzE0rTZ;;AyEjsTQ;EAOI,+BAAA;AzE8rTZ;;AyErsTQ;EAOI,4BAAA;AzEksTZ;;AyEzsTQ;EAOI,+BAAA;AzEssTZ;;AyE7sTQ;EAOI,8BAAA;AzE0sTZ;;AyEjtTQ;EAOI,+BAAA;AzE8sTZ;;AyErtTQ;EAOI,4BAAA;AzEktTZ;;AyEztTQ;EAOI,+BAAA;AzEstTZ;;AyE7tTQ;EAOI,8BAAA;AzE0tTZ;;AyEjuTQ;EAOI,+BAAA;AzE8tTZ;;AyEruTQ;EAOI,4BAAA;AzEkuTZ;;AyEzuTQ;EAOI,+BAAA;AzEsuTZ;;AyE7uTQ;EAOI,8BAAA;AzE0uTZ;;AyEjvTQ;EAOI,+BAAA;AzE8uTZ;;AyErvTQ;EAOI,4BAAA;AzEkvTZ;;AyEzvTQ;EAOI,+BAAA;AzEsvTZ;;AyE7vTQ;EAOI,8BAAA;AzE0vTZ;;AyEjwTQ;EAOI,+BAAA;AzE8vTZ;;AyErwTQ;EAOI,4BAAA;AzEkwTZ;;AyEzwTQ;EAOI,iCAAA;AzEswTZ;;AyE7wTQ;EAOI,gCAAA;AzE0wTZ;;AyEjxTQ;EAOI,iCAAA;AzE8wTZ;;AyErxTQ;EAOI,8BAAA;AzEkxTZ;;AyEzxTQ;EAOI,iCAAA;AzEsxTZ;;AyE7xTQ;EAOI,gCAAA;AzE0xTZ;;AyEjyTQ;EAOI,iCAAA;AzE8xTZ;;AyEryTQ;EAOI,8BAAA;AzEkyTZ;;AyEzyTQ;EAOI,iCAAA;AzEsyTZ;;AyE7yTQ;EAOI,gCAAA;AzE0yTZ;;AyEjzTQ;EAOI,iCAAA;AzE8yTZ;;AyErzTQ;EAOI,8BAAA;AzEkzTZ;;AyEzzTQ;EAOI,iCAAA;AzEszTZ;;AyE7zTQ;EAOI,gCAAA;AzE0zTZ;;AyEj0TQ;EAOI,iCAAA;AzE8zTZ;;AyEr0TQ;EAOI,8BAAA;AzEk0TZ;;AyEz0TQ;EAOI,iCAAA;AzEs0TZ;;AyE70TQ;EAOI,gCAAA;AzE00TZ;;AyEj1TQ;EAOI,iCAAA;AzE80TZ;;AyEr1TQ;EAOI,8BAAA;AzEk1TZ;;AyEz1TQ;EAOI,kCAAA;AzEs1TZ;;AyE71TQ;EAOI,iCAAA;AzE01TZ;;AyEj2TQ;EAOI,kCAAA;AzE81TZ;;AyEr2TQ;EAOI,+BAAA;AzEk2TZ;;AyEz2TQ;EAOI,kCAAA;AzEs2TZ;;AyE72TQ;EAOI,iCAAA;AzE02TZ;;AyEj3TQ;EAOI,kCAAA;AzE82TZ;;AyEr3TQ;EAOI,+BAAA;AzEk3TZ;;AyEz3TQ;EAOI,kCAAA;AzEs3TZ;;AyE73TQ;EAOI,iCAAA;AzE03TZ;;AyEj4TQ;EAOI,kCAAA;AzE83TZ;;AyEr4TQ;EAOI,+BAAA;AzEk4TZ;;AyEz4TQ;EAOI,kCAAA;AzEs4TZ;;AyE74TQ;EAOI,iCAAA;AzE04TZ;;AyEj5TQ;EAOI,kCAAA;AzE84TZ;;AyEr5TQ;EAOI,+BAAA;AzEk5TZ;;AyEz5TQ;EAOI,kCAAA;AzEs5TZ;;AyE75TQ;EAOI,iCAAA;AzE05TZ;;AyEj6TQ;EAOI,kCAAA;AzE85TZ;;AyEr6TQ;EAOI,+BAAA;AzEk6TZ;;AyEz6TQ;EAOI,gCAAA;AzEs6TZ;;AyE76TQ;EAOI,+BAAA;AzE06TZ;;AyEj7TQ;EAOI,gCAAA;AzE86TZ;;AyEr7TQ;EAOI,6BAAA;AzEk7TZ;;AyEz7TQ;EAOI,gCAAA;AzEs7TZ;;AyE77TQ;EAOI,+BAAA;AzE07TZ;;AyEj8TQ;EAOI,gCAAA;AzE87TZ;;AyEr8TQ;EAOI,6BAAA;AzEk8TZ;;AyEz8TQ;EAOI,gCAAA;AzEs8TZ;;AyE78TQ;EAOI,+BAAA;AzE08TZ;;AyEj9TQ;EAOI,gCAAA;AzE88TZ;;AyEr9TQ;EAOI,6BAAA;AzEk9TZ;;AyEz9TQ;EAOI,gCAAA;AzEs9TZ;;AyE79TQ;EAOI,+BAAA;AzE09TZ;;AyEj+TQ;EAOI,gCAAA;AzE89TZ;;AyEr+TQ;EAOI,6BAAA;AzEk+TZ;;AyEz+TQ;EAOI,gCAAA;AzEs+TZ;;AyE7+TQ;EAOI,+BAAA;AzE0+TZ;;AyEj/TQ;EAOI,gCAAA;AzE8+TZ;;AyEr/TQ;EAOI,6BAAA;AzEk/TZ;;AyEz/TQ;EAOI,qBAAA;AzEs/TZ;;AyE7/TQ;EAOI,2BAAA;AzE0/TZ;;AyEjgUQ;EAOI,0BAAA;AzE8/TZ;;AyErgUQ;EAOI,2BAAA;AzEkgUZ;;AyEzgUQ;EAOI,wBAAA;AzEsgUZ;;AyE7gUQ;EAOI,2BAAA;AzE0gUZ;;AyEjhUQ;EAOI,0BAAA;AzE8gUZ;;AyErhUQ;EAOI,2BAAA;AzEkhUZ;;AyEzhUQ;EAOI,wBAAA;AzEshUZ;;AyE7hUQ;EAOI,2BAAA;AzE0hUZ;;AyEjiUQ;EAOI,0BAAA;AzE8hUZ;;AyEriUQ;EAOI,2BAAA;AzEkiUZ;;AyEziUQ;EAOI,wBAAA;AzEsiUZ;;AyE7iUQ;EAOI,2BAAA;AzE0iUZ;;AyEjjUQ;EAOI,0BAAA;AzE8iUZ;;AyErjUQ;EAOI,2BAAA;AzEkjUZ;;AyEzjUQ;EAOI,wBAAA;AzEsjUZ;;AyE7jUQ;EAOI,2BAAA;AzE0jUZ;;AyEjkUQ;EAOI,0BAAA;AzE8jUZ;;AyErkUQ;EAOI,2BAAA;AzEkkUZ;;AyEzkUQ;EAOI,wBAAA;AzEskUZ;;AyE7kUQ;EAOI,2BAAA;EAAA,0BAAA;AzE2kUZ;;AyEllUQ;EAOI,iCAAA;EAAA,gCAAA;AzEglUZ;;AyEvlUQ;EAOI,gCAAA;EAAA,+BAAA;AzEqlUZ;;AyE5lUQ;EAOI,iCAAA;EAAA,gCAAA;AzE0lUZ;;AyEjmUQ;EAOI,8BAAA;EAAA,6BAAA;AzE+lUZ;;AyEtmUQ;EAOI,iCAAA;EAAA,gCAAA;AzEomUZ;;AyE3mUQ;EAOI,gCAAA;EAAA,+BAAA;AzEymUZ;;AyEhnUQ;EAOI,iCAAA;EAAA,gCAAA;AzE8mUZ;;AyErnUQ;EAOI,8BAAA;EAAA,6BAAA;AzEmnUZ;;AyE1nUQ;EAOI,iCAAA;EAAA,gCAAA;AzEwnUZ;;AyE/nUQ;EAOI,gCAAA;EAAA,+BAAA;AzE6nUZ;;AyEpoUQ;EAOI,iCAAA;EAAA,gCAAA;AzEkoUZ;;AyEzoUQ;EAOI,8BAAA;EAAA,6BAAA;AzEuoUZ;;AyE9oUQ;EAOI,iCAAA;EAAA,gCAAA;AzE4oUZ;;AyEnpUQ;EAOI,gCAAA;EAAA,+BAAA;AzEipUZ;;AyExpUQ;EAOI,iCAAA;EAAA,gCAAA;AzEspUZ;;AyE7pUQ;EAOI,8BAAA;EAAA,6BAAA;AzE2pUZ;;AyElqUQ;EAOI,iCAAA;EAAA,gCAAA;AzEgqUZ;;AyEvqUQ;EAOI,gCAAA;EAAA,+BAAA;AzEqqUZ;;AyE5qUQ;EAOI,iCAAA;EAAA,gCAAA;AzE0qUZ;;AyEjrUQ;EAOI,8BAAA;EAAA,6BAAA;AzE+qUZ;;AyEtrUQ;EAOI,yBAAA;EAAA,4BAAA;AzEorUZ;;AyE3rUQ;EAOI,+BAAA;EAAA,kCAAA;AzEyrUZ;;AyEhsUQ;EAOI,8BAAA;EAAA,iCAAA;AzE8rUZ;;AyErsUQ;EAOI,+BAAA;EAAA,kCAAA;AzEmsUZ;;AyE1sUQ;EAOI,4BAAA;EAAA,+BAAA;AzEwsUZ;;AyE/sUQ;EAOI,+BAAA;EAAA,kCAAA;AzE6sUZ;;AyEptUQ;EAOI,8BAAA;EAAA,iCAAA;AzEktUZ;;AyEztUQ;EAOI,+BAAA;EAAA,kCAAA;AzEutUZ;;AyE9tUQ;EAOI,4BAAA;EAAA,+BAAA;AzE4tUZ;;AyEnuUQ;EAOI,+BAAA;EAAA,kCAAA;AzEiuUZ;;AyExuUQ;EAOI,8BAAA;EAAA,iCAAA;AzEsuUZ;;AyE7uUQ;EAOI,+BAAA;EAAA,kCAAA;AzE2uUZ;;AyElvUQ;EAOI,4BAAA;EAAA,+BAAA;AzEgvUZ;;AyEvvUQ;EAOI,+BAAA;EAAA,kCAAA;AzEqvUZ;;AyE5vUQ;EAOI,8BAAA;EAAA,iCAAA;AzE0vUZ;;AyEjwUQ;EAOI,+BAAA;EAAA,kCAAA;AzE+vUZ;;AyEtwUQ;EAOI,4BAAA;EAAA,+BAAA;AzEowUZ;;AyE3wUQ;EAOI,+BAAA;EAAA,kCAAA;AzEywUZ;;AyEhxUQ;EAOI,8BAAA;EAAA,iCAAA;AzE8wUZ;;AyErxUQ;EAOI,+BAAA;EAAA,kCAAA;AzEmxUZ;;AyE1xUQ;EAOI,4BAAA;EAAA,+BAAA;AzEwxUZ;;AyE/xUQ;EAOI,yBAAA;AzE4xUZ;;AyEnyUQ;EAOI,+BAAA;AzEgyUZ;;AyEvyUQ;EAOI,8BAAA;AzEoyUZ;;AyE3yUQ;EAOI,+BAAA;AzEwyUZ;;AyE/yUQ;EAOI,4BAAA;AzE4yUZ;;AyEnzUQ;EAOI,+BAAA;AzEgzUZ;;AyEvzUQ;EAOI,8BAAA;AzEozUZ;;AyE3zUQ;EAOI,+BAAA;AzEwzUZ;;AyE/zUQ;EAOI,4BAAA;AzE4zUZ;;AyEn0UQ;EAOI,+BAAA;AzEg0UZ;;AyEv0UQ;EAOI,8BAAA;AzEo0UZ;;AyE30UQ;EAOI,+BAAA;AzEw0UZ;;AyE/0UQ;EAOI,4BAAA;AzE40UZ;;AyEn1UQ;EAOI,+BAAA;AzEg1UZ;;AyEv1UQ;EAOI,8BAAA;AzEo1UZ;;AyE31UQ;EAOI,+BAAA;AzEw1UZ;;AyE/1UQ;EAOI,4BAAA;AzE41UZ;;AyEn2UQ;EAOI,+BAAA;AzEg2UZ;;AyEv2UQ;EAOI,8BAAA;AzEo2UZ;;AyE32UQ;EAOI,+BAAA;AzEw2UZ;;AyE/2UQ;EAOI,4BAAA;AzE42UZ;;AyEn3UQ;EAOI,2BAAA;AzEg3UZ;;AyEv3UQ;EAOI,iCAAA;AzEo3UZ;;AyE33UQ;EAOI,gCAAA;AzEw3UZ;;AyE/3UQ;EAOI,iCAAA;AzE43UZ;;AyEn4UQ;EAOI,8BAAA;AzEg4UZ;;AyEv4UQ;EAOI,iCAAA;AzEo4UZ;;AyE34UQ;EAOI,gCAAA;AzEw4UZ;;AyE/4UQ;EAOI,iCAAA;AzE44UZ;;AyEn5UQ;EAOI,8BAAA;AzEg5UZ;;AyEv5UQ;EAOI,iCAAA;AzEo5UZ;;AyE35UQ;EAOI,gCAAA;AzEw5UZ;;AyE/5UQ;EAOI,iCAAA;AzE45UZ;;AyEn6UQ;EAOI,8BAAA;AzEg6UZ;;AyEv6UQ;EAOI,iCAAA;AzEo6UZ;;AyE36UQ;EAOI,gCAAA;AzEw6UZ;;AyE/6UQ;EAOI,iCAAA;AzE46UZ;;AyEn7UQ;EAOI,8BAAA;AzEg7UZ;;AyEv7UQ;EAOI,iCAAA;AzEo7UZ;;AyE37UQ;EAOI,gCAAA;AzEw7UZ;;AyE/7UQ;EAOI,iCAAA;AzE47UZ;;AyEn8UQ;EAOI,8BAAA;AzEg8UZ;;AyEv8UQ;EAOI,4BAAA;AzEo8UZ;;AyE38UQ;EAOI,kCAAA;AzEw8UZ;;AyE/8UQ;EAOI,iCAAA;AzE48UZ;;AyEn9UQ;EAOI,kCAAA;AzEg9UZ;;AyEv9UQ;EAOI,+BAAA;AzEo9UZ;;AyE39UQ;EAOI,kCAAA;AzEw9UZ;;AyE/9UQ;EAOI,iCAAA;AzE49UZ;;AyEn+UQ;EAOI,kCAAA;AzEg+UZ;;AyEv+UQ;EAOI,+BAAA;AzEo+UZ;;AyE3+UQ;EAOI,kCAAA;AzEw+UZ;;AyE/+UQ;EAOI,iCAAA;AzE4+UZ;;AyEn/UQ;EAOI,kCAAA;AzEg/UZ;;AyEv/UQ;EAOI,+BAAA;AzEo/UZ;;AyE3/UQ;EAOI,kCAAA;AzEw/UZ;;AyE//UQ;EAOI,iCAAA;AzE4/UZ;;AyEngVQ;EAOI,kCAAA;AzEggVZ;;AyEvgVQ;EAOI,+BAAA;AzEogVZ;;AyE3gVQ;EAOI,kCAAA;AzEwgVZ;;AyE/gVQ;EAOI,iCAAA;AzE4gVZ;;AyEnhVQ;EAOI,kCAAA;AzEghVZ;;AyEvhVQ;EAOI,+BAAA;AzEohVZ;;AyE3hVQ;EAOI,0BAAA;AzEwhVZ;;AyE/hVQ;EAOI,gCAAA;AzE4hVZ;;AyEniVQ;EAOI,+BAAA;AzEgiVZ;;AyEviVQ;EAOI,gCAAA;AzEoiVZ;;AyE3iVQ;EAOI,6BAAA;AzEwiVZ;;AyE/iVQ;EAOI,gCAAA;AzE4iVZ;;AyEnjVQ;EAOI,+BAAA;AzEgjVZ;;AyEvjVQ;EAOI,gCAAA;AzEojVZ;;AyE3jVQ;EAOI,6BAAA;AzEwjVZ;;AyE/jVQ;EAOI,gCAAA;AzE4jVZ;;AyEnkVQ;EAOI,+BAAA;AzEgkVZ;;AyEvkVQ;EAOI,gCAAA;AzEokVZ;;AyE3kVQ;EAOI,6BAAA;AzEwkVZ;;AyE/kVQ;EAOI,gCAAA;AzE4kVZ;;AyEnlVQ;EAOI,+BAAA;AzEglVZ;;AyEvlVQ;EAOI,gCAAA;AzEolVZ;;AyE3lVQ;EAOI,6BAAA;AzEwlVZ;;AyE/lVQ;EAOI,gCAAA;AzE4lVZ;;AyEnmVQ;EAOI,+BAAA;AzEgmVZ;;AyEvmVQ;EAOI,gCAAA;AzEomVZ;;AyE3mVQ;EAOI,6BAAA;AzEwmVZ;;AyE/mVQ;EAOI,iBAAA;AzE4mVZ;;AyEnnVQ;EAOI,uBAAA;AzEgnVZ;;AyEvnVQ;EAOI,sBAAA;AzEonVZ;;AyE3nVQ;EAOI,uBAAA;AzEwnVZ;;AyE/nVQ;EAOI,oBAAA;AzE4nVZ;;AyEnoVQ;EAOI,uBAAA;AzEgoVZ;;AyEvoVQ;EAOI,sBAAA;AzEooVZ;;AyE3oVQ;EAOI,uBAAA;AzEwoVZ;;AyE/oVQ;EAOI,oBAAA;AzE4oVZ;;AyEnpVQ;EAOI,uBAAA;AzEgpVZ;;AyEvpVQ;EAOI,sBAAA;AzEopVZ;;AyE3pVQ;EAOI,uBAAA;AzEwpVZ;;AyE/pVQ;EAOI,oBAAA;AzE4pVZ;;AyEnqVQ;EAOI,uBAAA;AzEgqVZ;;AyEvqVQ;EAOI,sBAAA;AzEoqVZ;;AyE3qVQ;EAOI,uBAAA;AzEwqVZ;;AyE/qVQ;EAOI,oBAAA;AzE4qVZ;;AyEnrVQ;EAOI,uBAAA;AzEgrVZ;;AyEvrVQ;EAOI,sBAAA;AzEorVZ;;AyE3rVQ;EAOI,uBAAA;AzEwrVZ;;AyE/rVQ;EAOI,oBAAA;AzE4rVZ;;AyEnsVQ;EAOI,gDAAA;AzEgsVZ;;AyEvsVQ;EAOI,0CAAA;AzEosVZ;;AyE3sVQ;EAOI,4CAAA;AzEwsVZ;;AyE/sVQ;EAOI,4CAAA;AzE4sVZ;;AyEntVQ;EAOI,6BAAA;AzEgtVZ;;AyEvtVQ;EAOI,6BAAA;AzEotVZ;;AyE3tVQ;EAOI,8BAAA;AzEwtVZ;;AyE/tVQ;EAOI,6BAAA;AzE4tVZ;;AyEnuVQ;EAOI,6BAAA;AzEguVZ;;AyEvuVQ;EAOI,6BAAA;AzEouVZ;;AyE3uVQ;EAOI,4BAAA;AzEwuVZ;;AyE/uVQ;EAOI,0BAAA;AzE4uVZ;;AyEnvVQ;EAOI,0BAAA;AzEgvVZ;;AyEvvVQ;EAOI,4CAAA;AzEovVZ;;AyE3vVQ;EAOI,2CAAA;AzEwvVZ;;AyE/vVQ;EAOI,4CAAA;AzE4vVZ;;AyEnwVQ;EAOI,0CAAA;AzEgwVZ;;AyEvwVQ;EAOI,4CAAA;AzEowVZ;;AyE3wVQ;EAOI,2CAAA;AzEwwVZ;;AyE/wVQ;EAOI,4CAAA;AzE4wVZ;;AyEnxVQ;EAOI,wCAAA;AzEgxVZ;;AyEvxVQ;EAOI,4CAAA;AzEoxVZ;;AyE3xVQ;EAOI,2CAAA;AzEwxVZ;;AyE/xVQ;EAOI,4CAAA;AzE4xVZ;;AyEnyVQ;EAOI,0CAAA;AzEgyVZ;;AyEvyVQ;EAOI,4CAAA;AzEoyVZ;;AyE3yVQ;EAOI,2CAAA;AzEwyVZ;;AyE/yVQ;EAOI,4CAAA;AzE4yVZ;;AyEnzVQ;EAOI,0CAAA;AzEgzVZ;;AyEvzVQ;EAOI,6BAAA;AzEozVZ;;AyE3zVQ;EAOI,6BAAA;AzEwzVZ;;AyE/zVQ;EAOI,2BAAA;AzE4zVZ;;AyEn0VQ;EAOI,+BAAA;AzEg0VZ;;AyEv0VQ;EAOI,2BAAA;AzEo0VZ;;AyE30VQ;EAOI,2BAAA;AzEw0VZ;;AyE/0VQ;EAOI,2BAAA;AzE40VZ;;AyEn1VQ;EAOI,2BAAA;AzEg1VZ;;AyEv1VQ;EAOI,yBAAA;AzEo1VZ;;AyE31VQ;EAOI,yBAAA;AzEw1VZ;;AyE/1VQ;EAOI,4BAAA;AzE41VZ;;AyEn2VQ;EAOI,2BAAA;AzEg2VZ;;AyEv2VQ;EAOI,4BAAA;AzEo2VZ;;AyE32VQ;EAOI,yBAAA;AzEw2VZ;;AyE/2VQ;EAOI,4BAAA;AzE42VZ;;AyEn3VQ;EAOI,2BAAA;AzEg3VZ;;AyEv3VQ;EAOI,4BAAA;AzEo3VZ;;AyE33VQ;EAOI,6BAAA;AzEw3VZ;;AyE/3VQ;EAOI,gCAAA;AzE43VZ;;AyEn4VQ;EAOI,qCAAA;AzEg4VZ;;AyEv4VQ;EAOI,wCAAA;AzEo4VZ;;AyE34VQ;EAOI,oCAAA;AzEw4VZ;;AyE/4VQ;EAOI,oCAAA;AzE44VZ;;AyEn5VQ;EAOI,qCAAA;AzEg5VZ;;AyEv5VQ;EAOI,8BAAA;AzEo5VZ;;AyE35VQ;EAOI,8BAAA;AzEw5VZ;;AyE76VQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AzE85VZ;;AyE34VQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,mEAAA;AzEo6VZ;;AyE36VQ;EAIQ,oBAAA;EAGJ,mEAAA;AzEy6VZ;;AyEh7VQ;EAIQ,oBAAA;EAGJ,qEAAA;AzE86VZ;;AyEr7VQ;EAIQ,oBAAA;EAGJ,uEAAA;AzEm7VZ;;AyE17VQ;EAIQ,oBAAA;EAGJ,qEAAA;AzEw7VZ;;AyE/7VQ;EAIQ,oBAAA;EAGJ,kEAAA;AzE67VZ;;AyEp8VQ;EAIQ,oBAAA;EAGJ,qEAAA;AzEk8VZ;;AyEz8VQ;EAIQ,oBAAA;EAGJ,oEAAA;AzEu8VZ;;AyE98VQ;EAIQ,oBAAA;EAGJ,kEAAA;AzE48VZ;;AyEn9VQ;EAIQ,oBAAA;EAGJ,mEAAA;AzEi9VZ;;AyEx9VQ;EAIQ,oBAAA;EAGJ,wEAAA;AzEs9VZ;;AyE79VQ;EAIQ,oBAAA;EAGJ,yBAAA;AzE29VZ;;AyEl+VQ;EAIQ,oBAAA;EAGJ,oCAAA;AzEg+VZ;;AyEv+VQ;EAIQ,oBAAA;EAGJ,0CAAA;AzEq+VZ;;AyE5+VQ;EAIQ,oBAAA;EAGJ,yBAAA;AzE0+VZ;;AyE3/VQ;EACE,uBAAA;AzE8/VV;;AyE//VQ;EACE,sBAAA;AzEkgWV;;AyEngWQ;EACE,uBAAA;AzEsgWV;;AyEvgWQ;EACE,oBAAA;AzE0gWV;;AyEjgWQ;EAIQ,kBAAA;EAGJ,4EAAA;AzE+/VZ;;AyEtgWQ;EAIQ,kBAAA;EAGJ,4EAAA;AzEogWZ;;AyE3gWQ;EAIQ,kBAAA;EAGJ,8EAAA;AzEygWZ;;AyEhhWQ;EAIQ,kBAAA;EAGJ,gFAAA;AzE8gWZ;;AyErhWQ;EAIQ,kBAAA;EAGJ,8EAAA;AzEmhWZ;;AyE1hWQ;EAIQ,kBAAA;EAGJ,2EAAA;AzEwhWZ;;AyE/hWQ;EAIQ,kBAAA;EAGJ,8EAAA;AzE6hWZ;;AyEpiWQ;EAIQ,kBAAA;EAGJ,6EAAA;AzEkiWZ;;AyEziWQ;EAIQ,kBAAA;EAGJ,2EAAA;AzEuiWZ;;AyE9iWQ;EAIQ,kBAAA;EAGJ,4EAAA;AzE4iWZ;;AyEnjWQ;EAIQ,kBAAA;EAGJ,8EAAA;AzEijWZ;;AyExjWQ;EAIQ,kBAAA;EAGJ,wCAAA;AzEsjWZ;;AyEvkWQ;EACE,oBAAA;AzE0kWV;;AyE3kWQ;EACE,qBAAA;AzE8kWV;;AyE/kWQ;EACE,oBAAA;AzEklWV;;AyEnlWQ;EACE,qBAAA;AzEslWV;;AyEvlWQ;EACE,kBAAA;AzE0lWV;;AyEjlWQ;EAOI,+CAAA;AzE8kWZ;;AyErlWQ;EAOI,mCAAA;UAAA,2BAAA;AzEklWZ;;AyEzlWQ;EAOI,oCAAA;UAAA,4BAAA;AzEslWZ;;AyE7lWQ;EAOI,oCAAA;UAAA,4BAAA;AzE0lWZ;;AyEjmWQ;EAOI,+BAAA;AzE8lWZ;;AyErmWQ;EAOI,+BAAA;AzEkmWZ;;AyEzmWQ;EAOI,kCAAA;AzEsmWZ;;AyE7mWQ;EAOI,2BAAA;AzE0mWZ;;AyEjnWQ;EAOI,kCAAA;AzE8mWZ;;AyErnWQ;EAOI,kCAAA;AzEknWZ;;AyEznWQ;EAOI,kCAAA;AzEsnWZ;;AyE7nWQ;EAOI,8BAAA;AzE0nWZ;;AyEjoWQ;EAOI,6BAAA;AzE8nWZ;;AyEroWQ;EAOI,+BAAA;AzEkoWZ;;AyEzoWQ;EAOI,0DAAA;EAAA,2DAAA;AzEuoWZ;;AyE9oWQ;EAOI,2DAAA;EAAA,8DAAA;AzE4oWZ;;AyEnpWQ;EAOI,8DAAA;EAAA,6DAAA;AzEipWZ;;AyExpWQ;EAOI,6DAAA;EAAA,0DAAA;AzEspWZ;;AyE7pWQ;EAOI,8BAAA;AzE0pWZ;;AyEjqWQ;EAOI,6BAAA;AzE8pWZ;;AyErqWQ;EAOI,qBAAA;AzEkqWZ;;AyE7pWU;EAOI,qBAAA;AzE0pWd;;AyE7qWQ;EAOI,wBAAA;AzE0qWZ;;AyErqWU;EAOI,wBAAA;AzEkqWd;;AyErrWQ;EAOI,uBAAA;AzEkrWZ;;AyE7qWU;EAOI,uBAAA;AzE0qWd;;AyE7rWQ;EAOI,wBAAA;AzE0rWZ;;AyErrWU;EAOI,wBAAA;AzEkrWd;;AyErsWQ;EAOI,uBAAA;AzEksWZ;;AyE7rWU;EAOI,uBAAA;AzE0rWd;;AyE7sWQ;EAOI,wBAAA;AzE0sWZ;;AyErsWU;EAOI,wBAAA;AzEksWd;;AyErtWQ;EAOI,uBAAA;AzEktWZ;;AyE7sWU;EAOI,uBAAA;AzE0sWd;;AyE7tWQ;EAOI,wBAAA;AzE0tWZ;;AyErtWU;EAOI,wBAAA;AzEktWd;;AyEruWQ;EAOI,qBAAA;AzEkuWZ;;AyE7tWU;EAOI,qBAAA;AzE0tWd;;AyE7uWQ;EAOI,2BAAA;AzE0uWZ;;AyEjvWQ;EAOI,yBAAA;AzE8uWZ;;AyErvWQ;EAOI,yBAAA;AzEkvWZ;;AyEzvWQ;EAOI,yBAAA;AzEsvWZ;;AyE7vWQ;EAOI,0BAAA;AzE0vWZ;;AyEjwWQ;EAOI,0BAAA;AzE8vWZ;;AyErwWQ;EAOI,yBAAA;AzEkwWZ;;AyEzwWQ;EAOI,yBAAA;AzEswWZ;;AyE7wWQ;EAOI,yBAAA;AzE0wWZ;;AyEjxWQ;EAOI,yBAAA;AzE8wWZ;;AyErxWQ;EAOI,yBAAA;AzEkxWZ;;AyEzxWQ;EAOI,yBAAA;AzEsxWZ;;AyE7xWQ;EAOI,yBAAA;AzE0xWZ;;AyEjyWQ;EAOI,yBAAA;AzE8xWZ;;AyEryWQ;EAOI,yBAAA;AzEkyWZ;;AyEzyWQ;EAOI,0BAAA;AzEsyWZ;;AyE7yWQ;EAOI,0BAAA;AzE0yWZ;;AyEjzWQ;EAOI,0BAAA;AzE8yWZ;;AyErzWQ;EAOI,0BAAA;AzEkzWZ;;AyEzzWQ;EAOI,0BAAA;AzEszWZ;;AyE7zWQ;EAOI,0BAAA;AzE0zWZ;;AyEj0WQ;EAOI,0BAAA;AzE8zWZ;;AyEr0WQ;EAOI,0BAAA;AzEk0WZ;;AyEz0WQ;EAOI,0BAAA;AzEs0WZ;;AyE70WQ;EAOI,0BAAA;AzE00WZ;;AyEj1WQ;EAOI,0BAAA;AzE80WZ;;AyEr1WQ;EAOI,0BAAA;AzEk1WZ;;AyEz1WQ;EAOI,0BAAA;AzEs1WZ;;AyE71WQ;EAOI,0BAAA;AzE01WZ;;AyEj2WQ;EAOI,0BAAA;AzE81WZ;;AyEr2WQ;EAOI,0BAAA;AzEk2WZ;;AyEz2WQ;EAOI,0BAAA;AzEs2WZ;;AyE72WQ;EAOI,0BAAA;AzE02WZ;;AyEj3WQ;EAOI,2BAAA;AzE82WZ;;AyEr3WQ;EAOI,2BAAA;AzEk3WZ;;AyEz3WQ;EAOI,2BAAA;AzEs3WZ;;AyE73WQ;EAOI,2BAAA;AzE03WZ;;AyEj4WQ;EAOI,2BAAA;AzE83WZ;;AyEr4WQ;EAOI,2BAAA;AzEk4WZ;;AyEz4WQ;EAOI,2BAAA;AzEs4WZ;;AyE74WQ;EAOI,2BAAA;AzE04WZ;;AyEj5WQ;EAOI,2BAAA;AzE84WZ;;AyEr5WQ;EAOI,2BAAA;AzEk5WZ;;AyEz5WQ;EAOI,2BAAA;AzEs5WZ;;AyE75WQ;EAOI,2BAAA;AzE05WZ;;AyEj6WQ;EAOI,2BAAA;AzE85WZ;;AyEr6WQ;EAOI,2BAAA;AzEk6WZ;;AyEz6WQ;EAOI,2BAAA;AzEs6WZ;;AyE76WQ;EAOI,2BAAA;AzE06WZ;;AyEj7WQ;EAOI,2BAAA;AzE86WZ;;AyEr7WQ;EAOI,2BAAA;AzEk7WZ;;AyEz7WQ;EAOI,2BAAA;AzEs7WZ;;AyE77WQ;EAOI,2BAAA;AzE07WZ;;AyEj8WQ;EAOI,2BAAA;AzE87WZ;;AyEr8WQ;EAOI,2BAAA;AzEk8WZ;;AyEz8WQ;EAOI,2BAAA;AzEs8WZ;;AyE78WQ;EAOI,2BAAA;AzE08WZ;;AyEj9WQ;EAOI,2BAAA;AzE88WZ;;AyEr9WQ;EAOI,2BAAA;AzEk9WZ;;AyEz9WQ;EAOI,4BAAA;AzEs9WZ;;AyE79WQ;EAOI,4BAAA;AzE09WZ;;AyEj+WQ;EAOI,0BAAA;AzE89WZ;;AyEr+WQ;EAOI,0BAAA;AzEk+WZ;;AyEz+WQ;EAOI,0BAAA;AzEs+WZ;;AyE7+WQ;EAOI,2BAAA;AzE0+WZ;;AyEj/WQ;EAOI,2BAAA;AzE8+WZ;;AyEr/WQ;EAOI,0BAAA;AzEk/WZ;;AyEz/WQ;EAOI,0BAAA;AzEs/WZ;;AyE7/WQ;EAOI,0BAAA;AzE0/WZ;;AyEjgXQ;EAOI,0BAAA;AzE8/WZ;;AyErgXQ;EAOI,0BAAA;AzEkgXZ;;AyEzgXQ;EAOI,0BAAA;AzEsgXZ;;AyE7gXQ;EAOI,0BAAA;AzE0gXZ;;AyEjhXQ;EAOI,0BAAA;AzE8gXZ;;AyErhXQ;EAOI,0BAAA;AzEkhXZ;;AyEzhXQ;EAOI,2BAAA;AzEshXZ;;AyE7hXQ;EAOI,2BAAA;AzE0hXZ;;AyEjiXQ;EAOI,2BAAA;AzE8hXZ;;AyEriXQ;EAOI,2BAAA;AzEkiXZ;;AyEziXQ;EAOI,2BAAA;AzEsiXZ;;AyE7iXQ;EAOI,2BAAA;AzE0iXZ;;AyEjjXQ;EAOI,2BAAA;AzE8iXZ;;AyErjXQ;EAOI,2BAAA;AzEkjXZ;;AyEzjXQ;EAOI,2BAAA;AzEsjXZ;;AyE7jXQ;EAOI,2BAAA;AzE0jXZ;;AyEjkXQ;EAOI,2BAAA;AzE8jXZ;;AyErkXQ;EAOI,2BAAA;AzEkkXZ;;AyEzkXQ;EAOI,2BAAA;AzEskXZ;;AyE7kXQ;EAOI,2BAAA;AzE0kXZ;;AyEjlXQ;EAOI,2BAAA;AzE8kXZ;;AyErlXQ;EAOI,2BAAA;AzEklXZ;;AyEzlXQ;EAOI,2BAAA;AzEslXZ;;AyE7lXQ;EAOI,2BAAA;AzE0lXZ;;AyEjmXQ;EAOI,4BAAA;AzE8lXZ;;AyErmXQ;EAOI,4BAAA;AzEkmXZ;;AyEzmXQ;EAOI,4BAAA;AzEsmXZ;;AyE7mXQ;EAOI,4BAAA;AzE0mXZ;;AyEjnXQ;EAOI,4BAAA;AzE8mXZ;;AyErnXQ;EAOI,4BAAA;AzEknXZ;;AyEznXQ;EAOI,4BAAA;AzEsnXZ;;AyE7nXQ;EAOI,4BAAA;AzE0nXZ;;AyEjoXQ;EAOI,4BAAA;AzE8nXZ;;AyEroXQ;EAOI,4BAAA;AzEkoXZ;;AyEzoXQ;EAOI,4BAAA;AzEsoXZ;;AyE7oXQ;EAOI,4BAAA;AzE0oXZ;;AyEjpXQ;EAOI,4BAAA;AzE8oXZ;;AyErpXQ;EAOI,4BAAA;AzEkpXZ;;AyEzpXQ;EAOI,4BAAA;AzEspXZ;;AyE7pXQ;EAOI,4BAAA;AzE0pXZ;;AyEjqXQ;EAOI,4BAAA;AzE8pXZ;;AyErqXQ;EAOI,4BAAA;AzEkqXZ;;AyEzqXQ;EAOI,4BAAA;AzEsqXZ;;AyE7qXQ;EAOI,4BAAA;AzE0qXZ;;AyEjrXQ;EAOI,4BAAA;AzE8qXZ;;AyErrXQ;EAOI,4BAAA;AzEkrXZ;;AyEzrXQ;EAOI,4BAAA;AzEsrXZ;;AyE7rXQ;EAOI,4BAAA;AzE0rXZ;;AyEjsXQ;EAOI,4BAAA;AzE8rXZ;;AyErsXQ;EAOI,4BAAA;AzEksXZ;;AyEzsXQ;EAOI,6BAAA;AzEssXZ;;AyE7sXQ;EAOI,sBAAA;AzE0sXZ;;AyEjtXQ;EAOI,sBAAA;AzE8sXZ;;AyErtXQ;EAOI,qBAAA;AzEktXZ;;AyEztXQ;EAOI,qBAAA;AzEstXZ;;AyE7tXQ;EAOI,qBAAA;AzE0tXZ;;AyEjuXQ;EAOI,qBAAA;AzE8tXZ;;AyEruXQ;EAOI,8BAAA;AzEkuXZ;;AyEzuXQ;EAOI,gCAAA;AzEsuXZ;;AyE7uXQ;EAOI,gCAAA;AzE0uXZ;;AyEjvXQ;EAOI,gCAAA;AzE8uXZ;;AyErvXQ;EAOI,gCAAA;AzEkvXZ;;AyEzvXQ;EAOI,gCAAA;AzEsvXZ;;AyE7vXQ;EAOI,iCAAA;AzE0vXZ;;AyEjwXQ;EAOI,mCAAA;AzE8vXZ;;AyErwXQ;EAOI,mCAAA;AzEkwXZ;;AyEzwXQ;EAOI,mCAAA;AzEswXZ;;AyE7wXQ;EAOI,mCAAA;AzE0wXZ;;AyEjxXQ;EAOI,mCAAA;AzE8wXZ;;AyErxXQ;EAOI,gCAAA;AzEkxXZ;;AyEzxXQ;EAOI,kCAAA;AzEsxXZ;;AyE7xXQ;EAOI,kCAAA;AzE0xXZ;;AyEjyXQ;EAOI,kCAAA;AzE8xXZ;;AyEryXQ;EAOI,kCAAA;AzEkyXZ;;AyEzyXQ;EAOI,kCAAA;AzEsyXZ;;AyE7yXQ;EAOI,+BAAA;AzE0yXZ;;AyEjzXQ;EAOI,iCAAA;AzE8yXZ;;AyErzXQ;EAOI,iCAAA;AzEkzXZ;;AyEzzXQ;EAOI,iCAAA;AzEszXZ;;AyE7zXQ;EAOI,iCAAA;AzE0zXZ;;AyEj0XQ;EAOI,iCAAA;AzE8zXZ;;AyEr0XQ;EAOI,iCAAA;AzEk0XZ;;AyEz0XQ;EAOI,mCAAA;AzEs0XZ;;AyE70XQ;EAOI,mCAAA;AzE00XZ;;AyEj1XQ;EAOI,kCAAA;AzE80XZ;;AyEr1XQ;EAOI,iCAAA;AzEk1XZ;;AyEz1XQ;EAOI,kCAAA;AzEs1XZ;;AyE71XQ;EAOI,oCAAA;AzE01XZ;;AyEj2XQ;EAOI,oCAAA;AzE81XZ;;AyEr2XQ;EAOI,mCAAA;AzEk2XZ;;AyEz2XQ;EAOI,kCAAA;AzEs2XZ;;Aeh3XI;E0DGI;IAOI,sBAAA;EzE22XV;;EyEl3XM;IAOI,uBAAA;EzE+2XV;;EyEt3XM;IAOI,sBAAA;EzEm3XV;;EyE13XM;IAOI,0BAAA;EzEu3XV;;EyE93XM;IAOI,gCAAA;EzE23XV;;EyEl4XM;IAOI,yBAAA;EzE+3XV;;EyEt4XM;IAOI,wBAAA;EzEm4XV;;EyE14XM;IAOI,yBAAA;EzEu4XV;;EyE94XM;IAOI,6BAAA;EzE24XV;;EyEl5XM;IAOI,8BAAA;EzE+4XV;;EyEt5XM;IAOI,wBAAA;EzEm5XV;;EyE15XM;IAOI,+BAAA;EzEu5XV;;EyE95XM;IAOI,wBAAA;EzE25XV;;EyEl6XM;IAOI,2BAAA;EzE+5XV;;EyEt6XM;IAOI,6BAAA;EzEm6XV;;EyE16XM;IAOI,6BAAA;EzEu6XV;;EyE96XM;IAOI,0BAAA;EzE26XV;;EyEl7XM;IAOI,2BAAA;EzE+6XV;;EyEt7XM;IAOI,uBAAA;EzEm7XV;;EyE17XM;IAOI,qBAAA;EzEu7XV;;EyE97XM;IAOI,qBAAA;EzE27XV;;EyEl8XM;IAOI,qBAAA;EzE+7XV;;EyEt8XM;IAOI,sBAAA;EzEm8XV;;EyE18XM;IAOI,sBAAA;EzEu8XV;;EyE98XM;IAOI,qBAAA;EzE28XV;;EyEl9XM;IAOI,qBAAA;EzE+8XV;;EyEt9XM;IAOI,qBAAA;EzEm9XV;;EyE19XM;IAOI,qBAAA;EzEu9XV;;EyE99XM;IAOI,qBAAA;EzE29XV;;EyEl+XM;IAOI,qBAAA;EzE+9XV;;EyEt+XM;IAOI,qBAAA;EzEm+XV;;EyE1+XM;IAOI,qBAAA;EzEu+XV;;EyE9+XM;IAOI,qBAAA;EzE2+XV;;EyEl/XM;IAOI,sBAAA;EzE++XV;;EyEt/XM;IAOI,sBAAA;EzEm/XV;;EyE1/XM;IAOI,sBAAA;EzEu/XV;;EyE9/XM;IAOI,sBAAA;EzE2/XV;;EyElgYM;IAOI,sBAAA;EzE+/XV;;EyEtgYM;IAOI,sBAAA;EzEmgYV;;EyE1gYM;IAOI,sBAAA;EzEugYV;;EyE9gYM;IAOI,sBAAA;EzE2gYV;;EyElhYM;IAOI,sBAAA;EzE+gYV;;EyEthYM;IAOI,sBAAA;EzEmhYV;;EyE1hYM;IAOI,sBAAA;EzEuhYV;;EyE9hYM;IAOI,sBAAA;EzE2hYV;;EyEliYM;IAOI,sBAAA;EzE+hYV;;EyEtiYM;IAOI,sBAAA;EzEmiYV;;EyE1iYM;IAOI,sBAAA;EzEuiYV;;EyE9iYM;IAOI,sBAAA;EzE2iYV;;EyEljYM;IAOI,sBAAA;EzE+iYV;;EyEtjYM;IAOI,sBAAA;EzEmjYV;;EyE1jYM;IAOI,uBAAA;EzEujYV;;EyE9jYM;IAOI,uBAAA;EzE2jYV;;EyElkYM;IAOI,uBAAA;EzE+jYV;;EyEtkYM;IAOI,uBAAA;EzEmkYV;;EyE1kYM;IAOI,uBAAA;EzEukYV;;EyE9kYM;IAOI,uBAAA;EzE2kYV;;EyEllYM;IAOI,uBAAA;EzE+kYV;;EyEtlYM;IAOI,uBAAA;EzEmlYV;;EyE1lYM;IAOI,uBAAA;EzEulYV;;EyE9lYM;IAOI,uBAAA;EzE2lYV;;EyElmYM;IAOI,uBAAA;EzE+lYV;;EyEtmYM;IAOI,uBAAA;EzEmmYV;;EyE1mYM;IAOI,uBAAA;EzEumYV;;EyE9mYM;IAOI,uBAAA;EzE2mYV;;EyElnYM;IAOI,uBAAA;EzE+mYV;;EyEtnYM;IAOI,uBAAA;EzEmnYV;;EyE1nYM;IAOI,uBAAA;EzEunYV;;EyE9nYM;IAOI,uBAAA;EzE2nYV;;EyEloYM;IAOI,uBAAA;EzE+nYV;;EyEtoYM;IAOI,uBAAA;EzEmoYV;;EyE1oYM;IAOI,uBAAA;EzEuoYV;;EyE9oYM;IAOI,uBAAA;EzE2oYV;;EyElpYM;IAOI,uBAAA;EzE+oYV;;EyEtpYM;IAOI,uBAAA;EzEmpYV;;EyE1pYM;IAOI,uBAAA;EzEupYV;;EyE9pYM;IAOI,uBAAA;EzE2pYV;;EyElqYM;IAOI,wBAAA;EzE+pYV;;EyEtqYM;IAOI,2BAAA;EzEmqYV;;EyE1qYM;IAOI,yBAAA;EzEuqYV;;EyE9qYM;IAOI,yBAAA;EzE2qYV;;EyElrYM;IAOI,yBAAA;EzE+qYV;;EyEtrYM;IAOI,0BAAA;EzEmrYV;;EyE1rYM;IAOI,0BAAA;EzEurYV;;EyE9rYM;IAOI,yBAAA;EzE2rYV;;EyElsYM;IAOI,yBAAA;EzE+rYV;;EyEtsYM;IAOI,yBAAA;EzEmsYV;;EyE1sYM;IAOI,yBAAA;EzEusYV;;EyE9sYM;IAOI,yBAAA;EzE2sYV;;EyEltYM;IAOI,yBAAA;EzE+sYV;;EyEttYM;IAOI,yBAAA;EzEmtYV;;EyE1tYM;IAOI,yBAAA;EzEutYV;;EyE9tYM;IAOI,yBAAA;EzE2tYV;;EyEluYM;IAOI,0BAAA;EzE+tYV;;EyEtuYM;IAOI,0BAAA;EzEmuYV;;EyE1uYM;IAOI,0BAAA;EzEuuYV;;EyE9uYM;IAOI,0BAAA;EzE2uYV;;EyElvYM;IAOI,0BAAA;EzE+uYV;;EyEtvYM;IAOI,0BAAA;EzEmvYV;;EyE1vYM;IAOI,0BAAA;EzEuvYV;;EyE9vYM;IAOI,0BAAA;EzE2vYV;;EyElwYM;IAOI,0BAAA;EzE+vYV;;EyEtwYM;IAOI,0BAAA;EzEmwYV;;EyE1wYM;IAOI,0BAAA;EzEuwYV;;EyE9wYM;IAOI,0BAAA;EzE2wYV;;EyElxYM;IAOI,0BAAA;EzE+wYV;;EyEtxYM;IAOI,0BAAA;EzEmxYV;;EyE1xYM;IAOI,0BAAA;EzEuxYV;;EyE9xYM;IAOI,0BAAA;EzE2xYV;;EyElyYM;IAOI,0BAAA;EzE+xYV;;EyEtyYM;IAOI,0BAAA;EzEmyYV;;EyE1yYM;IAOI,2BAAA;EzEuyYV;;EyE9yYM;IAOI,2BAAA;EzE2yYV;;EyElzYM;IAOI,2BAAA;EzE+yYV;;EyEtzYM;IAOI,2BAAA;EzEmzYV;;EyE1zYM;IAOI,2BAAA;EzEuzYV;;EyE9zYM;IAOI,2BAAA;EzE2zYV;;EyEl0YM;IAOI,2BAAA;EzE+zYV;;EyEt0YM;IAOI,2BAAA;EzEm0YV;;EyE10YM;IAOI,2BAAA;EzEu0YV;;EyE90YM;IAOI,2BAAA;EzE20YV;;EyEl1YM;IAOI,2BAAA;EzE+0YV;;EyEt1YM;IAOI,2BAAA;EzEm1YV;;EyE11YM;IAOI,2BAAA;EzEu1YV;;EyE91YM;IAOI,2BAAA;EzE21YV;;EyEl2YM;IAOI,2BAAA;EzE+1YV;;EyEt2YM;IAOI,2BAAA;EzEm2YV;;EyE12YM;IAOI,2BAAA;EzEu2YV;;EyE92YM;IAOI,2BAAA;EzE22YV;;EyEl3YM;IAOI,2BAAA;EzE+2YV;;EyEt3YM;IAOI,2BAAA;EzEm3YV;;EyE13YM;IAOI,2BAAA;EzEu3YV;;EyE93YM;IAOI,2BAAA;EzE23YV;;EyEl4YM;IAOI,2BAAA;EzE+3YV;;EyEt4YM;IAOI,2BAAA;EzEm4YV;;EyE14YM;IAOI,2BAAA;EzEu4YV;;EyE94YM;IAOI,2BAAA;EzE24YV;;EyEl5YM;IAOI,4BAAA;EzE+4YV;;EyEt5YM;IAOI,wBAAA;EzEm5YV;;EyE15YM;IAOI,sBAAA;EzEu5YV;;EyE95YM;IAOI,sBAAA;EzE25YV;;EyEl6YM;IAOI,sBAAA;EzE+5YV;;EyEt6YM;IAOI,uBAAA;EzEm6YV;;EyE16YM;IAOI,uBAAA;EzEu6YV;;EyE96YM;IAOI,sBAAA;EzE26YV;;EyEl7YM;IAOI,sBAAA;EzE+6YV;;EyEt7YM;IAOI,sBAAA;EzEm7YV;;EyE17YM;IAOI,sBAAA;EzEu7YV;;EyE97YM;IAOI,sBAAA;EzE27YV;;EyEl8YM;IAOI,sBAAA;EzE+7YV;;EyEt8YM;IAOI,sBAAA;EzEm8YV;;EyE18YM;IAOI,sBAAA;EzEu8YV;;EyE98YM;IAOI,sBAAA;EzE28YV;;EyEl9YM;IAOI,uBAAA;EzE+8YV;;EyEt9YM;IAOI,uBAAA;EzEm9YV;;EyE19YM;IAOI,uBAAA;EzEu9YV;;EyE99YM;IAOI,uBAAA;EzE29YV;;EyEl+YM;IAOI,uBAAA;EzE+9YV;;EyEt+YM;IAOI,uBAAA;EzEm+YV;;EyE1+YM;IAOI,uBAAA;EzEu+YV;;EyE9+YM;IAOI,uBAAA;EzE2+YV;;EyEl/YM;IAOI,uBAAA;EzE++YV;;EyEt/YM;IAOI,uBAAA;EzEm/YV;;EyE1/YM;IAOI,uBAAA;EzEu/YV;;EyE9/YM;IAOI,uBAAA;EzE2/YV;;EyElgZM;IAOI,uBAAA;EzE+/YV;;EyEtgZM;IAOI,uBAAA;EzEmgZV;;EyE1gZM;IAOI,uBAAA;EzEugZV;;EyE9gZM;IAOI,uBAAA;EzE2gZV;;EyElhZM;IAOI,uBAAA;EzE+gZV;;EyEthZM;IAOI,uBAAA;EzEmhZV;;EyE1hZM;IAOI,wBAAA;EzEuhZV;;EyE9hZM;IAOI,wBAAA;EzE2hZV;;EyEliZM;IAOI,wBAAA;EzE+hZV;;EyEtiZM;IAOI,wBAAA;EzEmiZV;;EyE1iZM;IAOI,wBAAA;EzEuiZV;;EyE9iZM;IAOI,wBAAA;EzE2iZV;;EyEljZM;IAOI,wBAAA;EzE+iZV;;EyEtjZM;IAOI,wBAAA;EzEmjZV;;EyE1jZM;IAOI,wBAAA;EzEujZV;;EyE9jZM;IAOI,wBAAA;EzE2jZV;;EyElkZM;IAOI,wBAAA;EzE+jZV;;EyEtkZM;IAOI,wBAAA;EzEmkZV;;EyE1kZM;IAOI,wBAAA;EzEukZV;;EyE9kZM;IAOI,wBAAA;EzE2kZV;;EyEllZM;IAOI,wBAAA;EzE+kZV;;EyEtlZM;IAOI,wBAAA;EzEmlZV;;EyE1lZM;IAOI,wBAAA;EzEulZV;;EyE9lZM;IAOI,wBAAA;EzE2lZV;;EyElmZM;IAOI,wBAAA;EzE+lZV;;EyEtmZM;IAOI,wBAAA;EzEmmZV;;EyE1mZM;IAOI,wBAAA;EzEumZV;;EyE9mZM;IAOI,wBAAA;EzE2mZV;;EyElnZM;IAOI,wBAAA;EzE+mZV;;EyEtnZM;IAOI,wBAAA;EzEmnZV;;EyE1nZM;IAOI,wBAAA;EzEunZV;;EyE9nZM;IAOI,wBAAA;EzE2nZV;;EyEloZM;IAOI,yBAAA;EzE+nZV;;EyEtoZM;IAOI,4BAAA;EzEmoZV;;EyE1oZM;IAOI,0BAAA;EzEuoZV;;EyE9oZM;IAOI,0BAAA;EzE2oZV;;EyElpZM;IAOI,0BAAA;EzE+oZV;;EyEtpZM;IAOI,2BAAA;EzEmpZV;;EyE1pZM;IAOI,2BAAA;EzEupZV;;EyE9pZM;IAOI,0BAAA;EzE2pZV;;EyElqZM;IAOI,0BAAA;EzE+pZV;;EyEtqZM;IAOI,0BAAA;EzEmqZV;;EyE1qZM;IAOI,0BAAA;EzEuqZV;;EyE9qZM;IAOI,0BAAA;EzE2qZV;;EyElrZM;IAOI,0BAAA;EzE+qZV;;EyEtrZM;IAOI,0BAAA;EzEmrZV;;EyE1rZM;IAOI,0BAAA;EzEurZV;;EyE9rZM;IAOI,0BAAA;EzE2rZV;;EyElsZM;IAOI,2BAAA;EzE+rZV;;EyEtsZM;IAOI,2BAAA;EzEmsZV;;EyE1sZM;IAOI,2BAAA;EzEusZV;;EyE9sZM;IAOI,2BAAA;EzE2sZV;;EyEltZM;IAOI,2BAAA;EzE+sZV;;EyEttZM;IAOI,2BAAA;EzEmtZV;;EyE1tZM;IAOI,2BAAA;EzEutZV;;EyE9tZM;IAOI,2BAAA;EzE2tZV;;EyEluZM;IAOI,2BAAA;EzE+tZV;;EyEtuZM;IAOI,2BAAA;EzEmuZV;;EyE1uZM;IAOI,2BAAA;EzEuuZV;;EyE9uZM;IAOI,2BAAA;EzE2uZV;;EyElvZM;IAOI,2BAAA;EzE+uZV;;EyEtvZM;IAOI,2BAAA;EzEmvZV;;EyE1vZM;IAOI,2BAAA;EzEuvZV;;EyE9vZM;IAOI,2BAAA;EzE2vZV;;EyElwZM;IAOI,2BAAA;EzE+vZV;;EyEtwZM;IAOI,2BAAA;EzEmwZV;;EyE1wZM;IAOI,4BAAA;EzEuwZV;;EyE9wZM;IAOI,4BAAA;EzE2wZV;;EyElxZM;IAOI,4BAAA;EzE+wZV;;EyEtxZM;IAOI,4BAAA;EzEmxZV;;EyE1xZM;IAOI,4BAAA;EzEuxZV;;EyE9xZM;IAOI,4BAAA;EzE2xZV;;EyElyZM;IAOI,4BAAA;EzE+xZV;;EyEtyZM;IAOI,4BAAA;EzEmyZV;;EyE1yZM;IAOI,4BAAA;EzEuyZV;;EyE9yZM;IAOI,4BAAA;EzE2yZV;;EyElzZM;IAOI,4BAAA;EzE+yZV;;EyEtzZM;IAOI,4BAAA;EzEmzZV;;EyE1zZM;IAOI,4BAAA;EzEuzZV;;EyE9zZM;IAOI,4BAAA;EzE2zZV;;EyEl0ZM;IAOI,4BAAA;EzE+zZV;;EyEt0ZM;IAOI,4BAAA;EzEm0ZV;;EyE10ZM;IAOI,4BAAA;EzEu0ZV;;EyE90ZM;IAOI,4BAAA;EzE20ZV;;EyEl1ZM;IAOI,4BAAA;EzE+0ZV;;EyEt1ZM;IAOI,4BAAA;EzEm1ZV;;EyE11ZM;IAOI,4BAAA;EzEu1ZV;;EyE91ZM;IAOI,4BAAA;EzE21ZV;;EyEl2ZM;IAOI,4BAAA;EzE+1ZV;;EyEt2ZM;IAOI,4BAAA;EzEm2ZV;;EyE12ZM;IAOI,4BAAA;EzEu2ZV;;EyE92ZM;IAOI,4BAAA;EzE22ZV;;EyEl3ZM;IAOI,6BAAA;EzE+2ZV;;EyEt3ZM;IAOI,yBAAA;EzEm3ZV;;EyE13ZM;IAOI,8BAAA;EzEu3ZV;;EyE93ZM;IAOI,iCAAA;EzE23ZV;;EyEl4ZM;IAOI,sCAAA;EzE+3ZV;;EyEt4ZM;IAOI,yCAAA;EzEm4ZV;;EyE14ZM;IAOI,uBAAA;EzEu4ZV;;EyE94ZM;IAOI,uBAAA;EzE24ZV;;EyEl5ZM;IAOI,yBAAA;EzE+4ZV;;EyEt5ZM;IAOI,yBAAA;EzEm5ZV;;EyE15ZM;IAOI,0BAAA;EzEu5ZV;;EyE95ZM;IAOI,4BAAA;EzE25ZV;;EyEl6ZM;IAOI,kCAAA;EzE+5ZV;;EyEt6ZM;IAOI,sCAAA;EzEm6ZV;;EyE16ZM;IAOI,oCAAA;EzEu6ZV;;EyE96ZM;IAOI,kCAAA;EzE26ZV;;EyEl7ZM;IAOI,yCAAA;EzE+6ZV;;EyEt7ZM;IAOI,wCAAA;EzEm7ZV;;EyE17ZM;IAOI,wCAAA;EzEu7ZV;;EyE97ZM;IAOI,kCAAA;EzE27ZV;;EyEl8ZM;IAOI,gCAAA;EzE+7ZV;;EyEt8ZM;IAOI,8BAAA;EzEm8ZV;;EyE18ZM;IAOI,gCAAA;EzEu8ZV;;EyE98ZM;IAOI,+BAAA;EzE28ZV;;EyEl9ZM;IAOI,oCAAA;EzE+8ZV;;EyEt9ZM;IAOI,kCAAA;EzEm9ZV;;EyE19ZM;IAOI,gCAAA;EzEu9ZV;;EyE99ZM;IAOI,uCAAA;EzE29ZV;;EyEl+ZM;IAOI,sCAAA;EzE+9ZV;;EyEt+ZM;IAOI,iCAAA;EzEm+ZV;;EyE1+ZM;IAOI,2BAAA;EzEu+ZV;;EyE9+ZM;IAOI,iCAAA;EzE2+ZV;;EyEl/ZM;IAOI,+BAAA;EzE++ZV;;EyEt/ZM;IAOI,6BAAA;EzEm/ZV;;EyE1/ZM;IAOI,+BAAA;EzEu/ZV;;EyE9/ZM;IAOI,8BAAA;EzE2/ZV;;EyElgaM;IAOI,oBAAA;EzE+/ZV;;EyEtgaM;IAOI,mBAAA;EzEmgaV;;EyE1gaM;IAOI,mBAAA;EzEugaV;;EyE9gaM;IAOI,mBAAA;EzE2gaV;;EyElhaM;IAOI,mBAAA;EzE+gaV;;EyEthaM;IAOI,mBAAA;EzEmhaV;;EyE1haM;IAOI,mBAAA;EzEuhaV;;EyE9haM;IAOI,mBAAA;EzE2haV;;EyEliaM;IAOI,oBAAA;EzE+haV;;EyEtiaM;IAOI,0BAAA;EzEmiaV;;EyE1iaM;IAOI,yBAAA;EzEuiaV;;EyE9iaM;IAOI,0BAAA;EzE2iaV;;EyEljaM;IAOI,uBAAA;EzE+iaV;;EyEtjaM;IAOI,0BAAA;EzEmjaV;;EyE1jaM;IAOI,yBAAA;EzEujaV;;EyE9jaM;IAOI,0BAAA;EzE2jaV;;EyElkaM;IAOI,uBAAA;EzE+jaV;;EyEtkaM;IAOI,0BAAA;EzEmkaV;;EyE1kaM;IAOI,yBAAA;EzEukaV;;EyE9kaM;IAOI,0BAAA;EzE2kaV;;EyEllaM;IAOI,uBAAA;EzE+kaV;;EyEtlaM;IAOI,0BAAA;EzEmlaV;;EyE1laM;IAOI,yBAAA;EzEulaV;;EyE9laM;IAOI,0BAAA;EzE2laV;;EyElmaM;IAOI,uBAAA;EzE+laV;;EyEtmaM;IAOI,0BAAA;EzEmmaV;;EyE1maM;IAOI,yBAAA;EzEumaV;;EyE9maM;IAOI,0BAAA;EzE2maV;;EyElnaM;IAOI,uBAAA;EzE+maV;;EyEtnaM;IAOI,uBAAA;EzEmnaV;;EyE1naM;IAOI,0BAAA;IAAA,yBAAA;EzEwnaV;;EyE/naM;IAOI,gCAAA;IAAA,+BAAA;EzE6naV;;EyEpoaM;IAOI,+BAAA;IAAA,8BAAA;EzEkoaV;;EyEzoaM;IAOI,gCAAA;IAAA,+BAAA;EzEuoaV;;EyE9oaM;IAOI,6BAAA;IAAA,4BAAA;EzE4oaV;;EyEnpaM;IAOI,gCAAA;IAAA,+BAAA;EzEipaV;;EyExpaM;IAOI,+BAAA;IAAA,8BAAA;EzEspaV;;EyE7paM;IAOI,gCAAA;IAAA,+BAAA;EzE2paV;;EyElqaM;IAOI,6BAAA;IAAA,4BAAA;EzEgqaV;;EyEvqaM;IAOI,gCAAA;IAAA,+BAAA;EzEqqaV;;EyE5qaM;IAOI,+BAAA;IAAA,8BAAA;EzE0qaV;;EyEjraM;IAOI,gCAAA;IAAA,+BAAA;EzE+qaV;;EyEtraM;IAOI,6BAAA;IAAA,4BAAA;EzEoraV;;EyE3raM;IAOI,gCAAA;IAAA,+BAAA;EzEyraV;;EyEhsaM;IAOI,+BAAA;IAAA,8BAAA;EzE8raV;;EyErsaM;IAOI,gCAAA;IAAA,+BAAA;EzEmsaV;;EyE1saM;IAOI,6BAAA;IAAA,4BAAA;EzEwsaV;;EyE/saM;IAOI,gCAAA;IAAA,+BAAA;EzE6saV;;EyEptaM;IAOI,+BAAA;IAAA,8BAAA;EzEktaV;;EyEztaM;IAOI,gCAAA;IAAA,+BAAA;EzEutaV;;EyE9taM;IAOI,6BAAA;IAAA,4BAAA;EzE4taV;;EyEnuaM;IAOI,6BAAA;IAAA,4BAAA;EzEiuaV;;EyExuaM;IAOI,wBAAA;IAAA,2BAAA;EzEsuaV;;EyE7uaM;IAOI,8BAAA;IAAA,iCAAA;EzE2uaV;;EyElvaM;IAOI,6BAAA;IAAA,gCAAA;EzEgvaV;;EyEvvaM;IAOI,8BAAA;IAAA,iCAAA;EzEqvaV;;EyE5vaM;IAOI,2BAAA;IAAA,8BAAA;EzE0vaV;;EyEjwaM;IAOI,8BAAA;IAAA,iCAAA;EzE+vaV;;EyEtwaM;IAOI,6BAAA;IAAA,gCAAA;EzEowaV;;EyE3waM;IAOI,8BAAA;IAAA,iCAAA;EzEywaV;;EyEhxaM;IAOI,2BAAA;IAAA,8BAAA;EzE8waV;;EyErxaM;IAOI,8BAAA;IAAA,iCAAA;EzEmxaV;;EyE1xaM;IAOI,6BAAA;IAAA,gCAAA;EzEwxaV;;EyE/xaM;IAOI,8BAAA;IAAA,iCAAA;EzE6xaV;;EyEpyaM;IAOI,2BAAA;IAAA,8BAAA;EzEkyaV;;EyEzyaM;IAOI,8BAAA;IAAA,iCAAA;EzEuyaV;;EyE9yaM;IAOI,6BAAA;IAAA,gCAAA;EzE4yaV;;EyEnzaM;IAOI,8BAAA;IAAA,iCAAA;EzEizaV;;EyExzaM;IAOI,2BAAA;IAAA,8BAAA;EzEszaV;;EyE7zaM;IAOI,8BAAA;IAAA,iCAAA;EzE2zaV;;EyEl0aM;IAOI,6BAAA;IAAA,gCAAA;EzEg0aV;;EyEv0aM;IAOI,8BAAA;IAAA,iCAAA;EzEq0aV;;EyE50aM;IAOI,2BAAA;IAAA,8BAAA;EzE00aV;;EyEj1aM;IAOI,2BAAA;IAAA,8BAAA;EzE+0aV;;EyEt1aM;IAOI,wBAAA;EzEm1aV;;EyE11aM;IAOI,8BAAA;EzEu1aV;;EyE91aM;IAOI,6BAAA;EzE21aV;;EyEl2aM;IAOI,8BAAA;EzE+1aV;;EyEt2aM;IAOI,2BAAA;EzEm2aV;;EyE12aM;IAOI,8BAAA;EzEu2aV;;EyE92aM;IAOI,6BAAA;EzE22aV;;EyEl3aM;IAOI,8BAAA;EzE+2aV;;EyEt3aM;IAOI,2BAAA;EzEm3aV;;EyE13aM;IAOI,8BAAA;EzEu3aV;;EyE93aM;IAOI,6BAAA;EzE23aV;;EyEl4aM;IAOI,8BAAA;EzE+3aV;;EyEt4aM;IAOI,2BAAA;EzEm4aV;;EyE14aM;IAOI,8BAAA;EzEu4aV;;EyE94aM;IAOI,6BAAA;EzE24aV;;EyEl5aM;IAOI,8BAAA;EzE+4aV;;EyEt5aM;IAOI,2BAAA;EzEm5aV;;EyE15aM;IAOI,8BAAA;EzEu5aV;;EyE95aM;IAOI,6BAAA;EzE25aV;;EyEl6aM;IAOI,8BAAA;EzE+5aV;;EyEt6aM;IAOI,2BAAA;EzEm6aV;;EyE16aM;IAOI,2BAAA;EzEu6aV;;EyE96aM;IAOI,0BAAA;EzE26aV;;EyEl7aM;IAOI,gCAAA;EzE+6aV;;EyEt7aM;IAOI,+BAAA;EzEm7aV;;EyE17aM;IAOI,gCAAA;EzEu7aV;;EyE97aM;IAOI,6BAAA;EzE27aV;;EyEl8aM;IAOI,gCAAA;EzE+7aV;;EyEt8aM;IAOI,+BAAA;EzEm8aV;;EyE18aM;IAOI,gCAAA;EzEu8aV;;EyE98aM;IAOI,6BAAA;EzE28aV;;EyEl9aM;IAOI,gCAAA;EzE+8aV;;EyEt9aM;IAOI,+BAAA;EzEm9aV;;EyE19aM;IAOI,gCAAA;EzEu9aV;;EyE99aM;IAOI,6BAAA;EzE29aV;;EyEl+aM;IAOI,gCAAA;EzE+9aV;;EyEt+aM;IAOI,+BAAA;EzEm+aV;;EyE1+aM;IAOI,gCAAA;EzEu+aV;;EyE9+aM;IAOI,6BAAA;EzE2+aV;;EyEl/aM;IAOI,gCAAA;EzE++aV;;EyEt/aM;IAOI,+BAAA;EzEm/aV;;EyE1/aM;IAOI,gCAAA;EzEu/aV;;EyE9/aM;IAOI,6BAAA;EzE2/aV;;EyElgbM;IAOI,6BAAA;EzE+/aV;;EyEtgbM;IAOI,2BAAA;EzEmgbV;;EyE1gbM;IAOI,iCAAA;EzEugbV;;EyE9gbM;IAOI,gCAAA;EzE2gbV;;EyElhbM;IAOI,iCAAA;EzE+gbV;;EyEthbM;IAOI,8BAAA;EzEmhbV;;EyE1hbM;IAOI,iCAAA;EzEuhbV;;EyE9hbM;IAOI,gCAAA;EzE2hbV;;EyElibM;IAOI,iCAAA;EzE+hbV;;EyEtibM;IAOI,8BAAA;EzEmibV;;EyE1ibM;IAOI,iCAAA;EzEuibV;;EyE9ibM;IAOI,gCAAA;EzE2ibV;;EyEljbM;IAOI,iCAAA;EzE+ibV;;EyEtjbM;IAOI,8BAAA;EzEmjbV;;EyE1jbM;IAOI,iCAAA;EzEujbV;;EyE9jbM;IAOI,gCAAA;EzE2jbV;;EyElkbM;IAOI,iCAAA;EzE+jbV;;EyEtkbM;IAOI,8BAAA;EzEmkbV;;EyE1kbM;IAOI,iCAAA;EzEukbV;;EyE9kbM;IAOI,gCAAA;EzE2kbV;;EyEllbM;IAOI,iCAAA;EzE+kbV;;EyEtlbM;IAOI,8BAAA;EzEmlbV;;EyE1lbM;IAOI,8BAAA;EzEulbV;;EyE9lbM;IAOI,yBAAA;EzE2lbV;;EyElmbM;IAOI,+BAAA;EzE+lbV;;EyEtmbM;IAOI,8BAAA;EzEmmbV;;EyE1mbM;IAOI,+BAAA;EzEumbV;;EyE9mbM;IAOI,4BAAA;EzE2mbV;;EyElnbM;IAOI,+BAAA;EzE+mbV;;EyEtnbM;IAOI,8BAAA;EzEmnbV;;EyE1nbM;IAOI,+BAAA;EzEunbV;;EyE9nbM;IAOI,4BAAA;EzE2nbV;;EyElobM;IAOI,+BAAA;EzE+nbV;;EyEtobM;IAOI,8BAAA;EzEmobV;;EyE1obM;IAOI,+BAAA;EzEuobV;;EyE9obM;IAOI,4BAAA;EzE2obV;;EyElpbM;IAOI,+BAAA;EzE+obV;;EyEtpbM;IAOI,8BAAA;EzEmpbV;;EyE1pbM;IAOI,+BAAA;EzEupbV;;EyE9pbM;IAOI,4BAAA;EzE2pbV;;EyElqbM;IAOI,+BAAA;EzE+pbV;;EyEtqbM;IAOI,8BAAA;EzEmqbV;;EyE1qbM;IAOI,+BAAA;EzEuqbV;;EyE9qbM;IAOI,4BAAA;EzE2qbV;;EyElrbM;IAOI,4BAAA;EzE+qbV;;EyEtrbM;IAOI,2BAAA;EzEmrbV;;EyE1rbM;IAOI,0BAAA;EzEurbV;;EyE9rbM;IAOI,2BAAA;EzE2rbV;;EyElsbM;IAOI,wBAAA;EzE+rbV;;EyEtsbM;IAOI,2BAAA;EzEmsbV;;EyE1sbM;IAOI,0BAAA;EzEusbV;;EyE9sbM;IAOI,2BAAA;EzE2sbV;;EyEltbM;IAOI,wBAAA;EzE+sbV;;EyEttbM;IAOI,2BAAA;EzEmtbV;;EyE1tbM;IAOI,0BAAA;EzEutbV;;EyE9tbM;IAOI,2BAAA;EzE2tbV;;EyElubM;IAOI,wBAAA;EzE+tbV;;EyEtubM;IAOI,2BAAA;EzEmubV;;EyE1ubM;IAOI,0BAAA;EzEuubV;;EyE9ubM;IAOI,2BAAA;EzE2ubV;;EyElvbM;IAOI,wBAAA;EzE+ubV;;EyEtvbM;IAOI,2BAAA;EzEmvbV;;EyE1vbM;IAOI,0BAAA;EzEuvbV;;EyE9vbM;IAOI,2BAAA;EzE2vbV;;EyElwbM;IAOI,wBAAA;EzE+vbV;;EyEtwbM;IAOI,iCAAA;IAAA,gCAAA;EzEowbV;;EyE3wbM;IAOI,gCAAA;IAAA,+BAAA;EzEywbV;;EyEhxbM;IAOI,iCAAA;IAAA,gCAAA;EzE8wbV;;EyErxbM;IAOI,8BAAA;IAAA,6BAAA;EzEmxbV;;EyE1xbM;IAOI,iCAAA;IAAA,gCAAA;EzEwxbV;;EyE/xbM;IAOI,gCAAA;IAAA,+BAAA;EzE6xbV;;EyEpybM;IAOI,iCAAA;IAAA,gCAAA;EzEkybV;;EyEzybM;IAOI,8BAAA;IAAA,6BAAA;EzEuybV;;EyE9ybM;IAOI,iCAAA;IAAA,gCAAA;EzE4ybV;;EyEnzbM;IAOI,gCAAA;IAAA,+BAAA;EzEizbV;;EyExzbM;IAOI,iCAAA;IAAA,gCAAA;EzEszbV;;EyE7zbM;IAOI,8BAAA;IAAA,6BAAA;EzE2zbV;;EyEl0bM;IAOI,iCAAA;IAAA,gCAAA;EzEg0bV;;EyEv0bM;IAOI,gCAAA;IAAA,+BAAA;EzEq0bV;;EyE50bM;IAOI,iCAAA;IAAA,gCAAA;EzE00bV;;EyEj1bM;IAOI,8BAAA;IAAA,6BAAA;EzE+0bV;;EyEt1bM;IAOI,iCAAA;IAAA,gCAAA;EzEo1bV;;EyE31bM;IAOI,gCAAA;IAAA,+BAAA;EzEy1bV;;EyEh2bM;IAOI,iCAAA;IAAA,gCAAA;EzE81bV;;EyEr2bM;IAOI,8BAAA;IAAA,6BAAA;EzEm2bV;;EyE12bM;IAOI,+BAAA;IAAA,kCAAA;EzEw2bV;;EyE/2bM;IAOI,8BAAA;IAAA,iCAAA;EzE62bV;;EyEp3bM;IAOI,+BAAA;IAAA,kCAAA;EzEk3bV;;EyEz3bM;IAOI,4BAAA;IAAA,+BAAA;EzEu3bV;;EyE93bM;IAOI,+BAAA;IAAA,kCAAA;EzE43bV;;EyEn4bM;IAOI,8BAAA;IAAA,iCAAA;EzEi4bV;;EyEx4bM;IAOI,+BAAA;IAAA,kCAAA;EzEs4bV;;EyE74bM;IAOI,4BAAA;IAAA,+BAAA;EzE24bV;;EyEl5bM;IAOI,+BAAA;IAAA,kCAAA;EzEg5bV;;EyEv5bM;IAOI,8BAAA;IAAA,iCAAA;EzEq5bV;;EyE55bM;IAOI,+BAAA;IAAA,kCAAA;EzE05bV;;EyEj6bM;IAOI,4BAAA;IAAA,+BAAA;EzE+5bV;;EyEt6bM;IAOI,+BAAA;IAAA,kCAAA;EzEo6bV;;EyE36bM;IAOI,8BAAA;IAAA,iCAAA;EzEy6bV;;EyEh7bM;IAOI,+BAAA;IAAA,kCAAA;EzE86bV;;EyEr7bM;IAOI,4BAAA;IAAA,+BAAA;EzEm7bV;;EyE17bM;IAOI,+BAAA;IAAA,kCAAA;EzEw7bV;;EyE/7bM;IAOI,8BAAA;IAAA,iCAAA;EzE67bV;;EyEp8bM;IAOI,+BAAA;IAAA,kCAAA;EzEk8bV;;EyEz8bM;IAOI,4BAAA;IAAA,+BAAA;EzEu8bV;;EyE98bM;IAOI,+BAAA;EzE28bV;;EyEl9bM;IAOI,8BAAA;EzE+8bV;;EyEt9bM;IAOI,+BAAA;EzEm9bV;;EyE19bM;IAOI,4BAAA;EzEu9bV;;EyE99bM;IAOI,+BAAA;EzE29bV;;EyEl+bM;IAOI,8BAAA;EzE+9bV;;EyEt+bM;IAOI,+BAAA;EzEm+bV;;EyE1+bM;IAOI,4BAAA;EzEu+bV;;EyE9+bM;IAOI,+BAAA;EzE2+bV;;EyEl/bM;IAOI,8BAAA;EzE++bV;;EyEt/bM;IAOI,+BAAA;EzEm/bV;;EyE1/bM;IAOI,4BAAA;EzEu/bV;;EyE9/bM;IAOI,+BAAA;EzE2/bV;;EyElgcM;IAOI,8BAAA;EzE+/bV;;EyEtgcM;IAOI,+BAAA;EzEmgcV;;EyE1gcM;IAOI,4BAAA;EzEugcV;;EyE9gcM;IAOI,+BAAA;EzE2gcV;;EyElhcM;IAOI,8BAAA;EzE+gcV;;EyEthcM;IAOI,+BAAA;EzEmhcV;;EyE1hcM;IAOI,4BAAA;EzEuhcV;;EyE9hcM;IAOI,iCAAA;EzE2hcV;;EyElicM;IAOI,gCAAA;EzE+hcV;;EyEticM;IAOI,iCAAA;EzEmicV;;EyE1icM;IAOI,8BAAA;EzEuicV;;EyE9icM;IAOI,iCAAA;EzE2icV;;EyEljcM;IAOI,gCAAA;EzE+icV;;EyEtjcM;IAOI,iCAAA;EzEmjcV;;EyE1jcM;IAOI,8BAAA;EzEujcV;;EyE9jcM;IAOI,iCAAA;EzE2jcV;;EyElkcM;IAOI,gCAAA;EzE+jcV;;EyEtkcM;IAOI,iCAAA;EzEmkcV;;EyE1kcM;IAOI,8BAAA;EzEukcV;;EyE9kcM;IAOI,iCAAA;EzE2kcV;;EyEllcM;IAOI,gCAAA;EzE+kcV;;EyEtlcM;IAOI,iCAAA;EzEmlcV;;EyE1lcM;IAOI,8BAAA;EzEulcV;;EyE9lcM;IAOI,iCAAA;EzE2lcV;;EyElmcM;IAOI,gCAAA;EzE+lcV;;EyEtmcM;IAOI,iCAAA;EzEmmcV;;EyE1mcM;IAOI,8BAAA;EzEumcV;;EyE9mcM;IAOI,kCAAA;EzE2mcV;;EyElncM;IAOI,iCAAA;EzE+mcV;;EyEtncM;IAOI,kCAAA;EzEmncV;;EyE1ncM;IAOI,+BAAA;EzEuncV;;EyE9ncM;IAOI,kCAAA;EzE2ncV;;EyElocM;IAOI,iCAAA;EzE+ncV;;EyEtocM;IAOI,kCAAA;EzEmocV;;EyE1ocM;IAOI,+BAAA;EzEuocV;;EyE9ocM;IAOI,kCAAA;EzE2ocV;;EyElpcM;IAOI,iCAAA;EzE+ocV;;EyEtpcM;IAOI,kCAAA;EzEmpcV;;EyE1pcM;IAOI,+BAAA;EzEupcV;;EyE9pcM;IAOI,kCAAA;EzE2pcV;;EyElqcM;IAOI,iCAAA;EzE+pcV;;EyEtqcM;IAOI,kCAAA;EzEmqcV;;EyE1qcM;IAOI,+BAAA;EzEuqcV;;EyE9qcM;IAOI,kCAAA;EzE2qcV;;EyElrcM;IAOI,iCAAA;EzE+qcV;;EyEtrcM;IAOI,kCAAA;EzEmrcV;;EyE1rcM;IAOI,+BAAA;EzEurcV;;EyE9rcM;IAOI,gCAAA;EzE2rcV;;EyElscM;IAOI,+BAAA;EzE+rcV;;EyEtscM;IAOI,gCAAA;EzEmscV;;EyE1scM;IAOI,6BAAA;EzEuscV;;EyE9scM;IAOI,gCAAA;EzE2scV;;EyEltcM;IAOI,+BAAA;EzE+scV;;EyEttcM;IAOI,gCAAA;EzEmtcV;;EyE1tcM;IAOI,6BAAA;EzEutcV;;EyE9tcM;IAOI,gCAAA;EzE2tcV;;EyElucM;IAOI,+BAAA;EzE+tcV;;EyEtucM;IAOI,gCAAA;EzEmucV;;EyE1ucM;IAOI,6BAAA;EzEuucV;;EyE9ucM;IAOI,gCAAA;EzE2ucV;;EyElvcM;IAOI,+BAAA;EzE+ucV;;EyEtvcM;IAOI,gCAAA;EzEmvcV;;EyE1vcM;IAOI,6BAAA;EzEuvcV;;EyE9vcM;IAOI,gCAAA;EzE2vcV;;EyElwcM;IAOI,+BAAA;EzE+vcV;;EyEtwcM;IAOI,gCAAA;EzEmwcV;;EyE1wcM;IAOI,6BAAA;EzEuwcV;;EyE9wcM;IAOI,qBAAA;EzE2wcV;;EyElxcM;IAOI,2BAAA;EzE+wcV;;EyEtxcM;IAOI,0BAAA;EzEmxcV;;EyE1xcM;IAOI,2BAAA;EzEuxcV;;EyE9xcM;IAOI,wBAAA;EzE2xcV;;EyElycM;IAOI,2BAAA;EzE+xcV;;EyEtycM;IAOI,0BAAA;EzEmycV;;EyE1ycM;IAOI,2BAAA;EzEuycV;;EyE9ycM;IAOI,wBAAA;EzE2ycV;;EyElzcM;IAOI,2BAAA;EzE+ycV;;EyEtzcM;IAOI,0BAAA;EzEmzcV;;EyE1zcM;IAOI,2BAAA;EzEuzcV;;EyE9zcM;IAOI,wBAAA;EzE2zcV;;EyEl0cM;IAOI,2BAAA;EzE+zcV;;EyEt0cM;IAOI,0BAAA;EzEm0cV;;EyE10cM;IAOI,2BAAA;EzEu0cV;;EyE90cM;IAOI,wBAAA;EzE20cV;;EyEl1cM;IAOI,2BAAA;EzE+0cV;;EyEt1cM;IAOI,0BAAA;EzEm1cV;;EyE11cM;IAOI,2BAAA;EzEu1cV;;EyE91cM;IAOI,wBAAA;EzE21cV;;EyEl2cM;IAOI,2BAAA;IAAA,0BAAA;EzEg2cV;;EyEv2cM;IAOI,iCAAA;IAAA,gCAAA;EzEq2cV;;EyE52cM;IAOI,gCAAA;IAAA,+BAAA;EzE02cV;;EyEj3cM;IAOI,iCAAA;IAAA,gCAAA;EzE+2cV;;EyEt3cM;IAOI,8BAAA;IAAA,6BAAA;EzEo3cV;;EyE33cM;IAOI,iCAAA;IAAA,gCAAA;EzEy3cV;;EyEh4cM;IAOI,gCAAA;IAAA,+BAAA;EzE83cV;;EyEr4cM;IAOI,iCAAA;IAAA,gCAAA;EzEm4cV;;EyE14cM;IAOI,8BAAA;IAAA,6BAAA;EzEw4cV;;EyE/4cM;IAOI,iCAAA;IAAA,gCAAA;EzE64cV;;EyEp5cM;IAOI,gCAAA;IAAA,+BAAA;EzEk5cV;;EyEz5cM;IAOI,iCAAA;IAAA,gCAAA;EzEu5cV;;EyE95cM;IAOI,8BAAA;IAAA,6BAAA;EzE45cV;;EyEn6cM;IAOI,iCAAA;IAAA,gCAAA;EzEi6cV;;EyEx6cM;IAOI,gCAAA;IAAA,+BAAA;EzEs6cV;;EyE76cM;IAOI,iCAAA;IAAA,gCAAA;EzE26cV;;EyEl7cM;IAOI,8BAAA;IAAA,6BAAA;EzEg7cV;;EyEv7cM;IAOI,iCAAA;IAAA,gCAAA;EzEq7cV;;EyE57cM;IAOI,gCAAA;IAAA,+BAAA;EzE07cV;;EyEj8cM;IAOI,iCAAA;IAAA,gCAAA;EzE+7cV;;EyEt8cM;IAOI,8BAAA;IAAA,6BAAA;EzEo8cV;;EyE38cM;IAOI,yBAAA;IAAA,4BAAA;EzEy8cV;;EyEh9cM;IAOI,+BAAA;IAAA,kCAAA;EzE88cV;;EyEr9cM;IAOI,8BAAA;IAAA,iCAAA;EzEm9cV;;EyE19cM;IAOI,+BAAA;IAAA,kCAAA;EzEw9cV;;EyE/9cM;IAOI,4BAAA;IAAA,+BAAA;EzE69cV;;EyEp+cM;IAOI,+BAAA;IAAA,kCAAA;EzEk+cV;;EyEz+cM;IAOI,8BAAA;IAAA,iCAAA;EzEu+cV;;EyE9+cM;IAOI,+BAAA;IAAA,kCAAA;EzE4+cV;;EyEn/cM;IAOI,4BAAA;IAAA,+BAAA;EzEi/cV;;EyEx/cM;IAOI,+BAAA;IAAA,kCAAA;EzEs/cV;;EyE7/cM;IAOI,8BAAA;IAAA,iCAAA;EzE2/cV;;EyElgdM;IAOI,+BAAA;IAAA,kCAAA;EzEggdV;;EyEvgdM;IAOI,4BAAA;IAAA,+BAAA;EzEqgdV;;EyE5gdM;IAOI,+BAAA;IAAA,kCAAA;EzE0gdV;;EyEjhdM;IAOI,8BAAA;IAAA,iCAAA;EzE+gdV;;EyEthdM;IAOI,+BAAA;IAAA,kCAAA;EzEohdV;;EyE3hdM;IAOI,4BAAA;IAAA,+BAAA;EzEyhdV;;EyEhidM;IAOI,+BAAA;IAAA,kCAAA;EzE8hdV;;EyEridM;IAOI,8BAAA;IAAA,iCAAA;EzEmidV;;EyE1idM;IAOI,+BAAA;IAAA,kCAAA;EzEwidV;;EyE/idM;IAOI,4BAAA;IAAA,+BAAA;EzE6idV;;EyEpjdM;IAOI,yBAAA;EzEijdV;;EyExjdM;IAOI,+BAAA;EzEqjdV;;EyE5jdM;IAOI,8BAAA;EzEyjdV;;EyEhkdM;IAOI,+BAAA;EzE6jdV;;EyEpkdM;IAOI,4BAAA;EzEikdV;;EyExkdM;IAOI,+BAAA;EzEqkdV;;EyE5kdM;IAOI,8BAAA;EzEykdV;;EyEhldM;IAOI,+BAAA;EzE6kdV;;EyEpldM;IAOI,4BAAA;EzEildV;;EyExldM;IAOI,+BAAA;EzEqldV;;EyE5ldM;IAOI,8BAAA;EzEyldV;;EyEhmdM;IAOI,+BAAA;EzE6ldV;;EyEpmdM;IAOI,4BAAA;EzEimdV;;EyExmdM;IAOI,+BAAA;EzEqmdV;;EyE5mdM;IAOI,8BAAA;EzEymdV;;EyEhndM;IAOI,+BAAA;EzE6mdV;;EyEpndM;IAOI,4BAAA;EzEindV;;EyExndM;IAOI,+BAAA;EzEqndV;;EyE5ndM;IAOI,8BAAA;EzEyndV;;EyEhodM;IAOI,+BAAA;EzE6ndV;;EyEpodM;IAOI,4BAAA;EzEiodV;;EyExodM;IAOI,2BAAA;EzEqodV;;EyE5odM;IAOI,iCAAA;EzEyodV;;EyEhpdM;IAOI,gCAAA;EzE6odV;;EyEppdM;IAOI,iCAAA;EzEipdV;;EyExpdM;IAOI,8BAAA;EzEqpdV;;EyE5pdM;IAOI,iCAAA;EzEypdV;;EyEhqdM;IAOI,gCAAA;EzE6pdV;;EyEpqdM;IAOI,iCAAA;EzEiqdV;;EyExqdM;IAOI,8BAAA;EzEqqdV;;EyE5qdM;IAOI,iCAAA;EzEyqdV;;EyEhrdM;IAOI,gCAAA;EzE6qdV;;EyEprdM;IAOI,iCAAA;EzEirdV;;EyExrdM;IAOI,8BAAA;EzEqrdV;;EyE5rdM;IAOI,iCAAA;EzEyrdV;;EyEhsdM;IAOI,gCAAA;EzE6rdV;;EyEpsdM;IAOI,iCAAA;EzEisdV;;EyExsdM;IAOI,8BAAA;EzEqsdV;;EyE5sdM;IAOI,iCAAA;EzEysdV;;EyEhtdM;IAOI,gCAAA;EzE6sdV;;EyEptdM;IAOI,iCAAA;EzEitdV;;EyExtdM;IAOI,8BAAA;EzEqtdV;;EyE5tdM;IAOI,4BAAA;EzEytdV;;EyEhudM;IAOI,kCAAA;EzE6tdV;;EyEpudM;IAOI,iCAAA;EzEiudV;;EyExudM;IAOI,kCAAA;EzEqudV;;EyE5udM;IAOI,+BAAA;EzEyudV;;EyEhvdM;IAOI,kCAAA;EzE6udV;;EyEpvdM;IAOI,iCAAA;EzEivdV;;EyExvdM;IAOI,kCAAA;EzEqvdV;;EyE5vdM;IAOI,+BAAA;EzEyvdV;;EyEhwdM;IAOI,kCAAA;EzE6vdV;;EyEpwdM;IAOI,iCAAA;EzEiwdV;;EyExwdM;IAOI,kCAAA;EzEqwdV;;EyE5wdM;IAOI,+BAAA;EzEywdV;;EyEhxdM;IAOI,kCAAA;EzE6wdV;;EyEpxdM;IAOI,iCAAA;EzEixdV;;EyExxdM;IAOI,kCAAA;EzEqxdV;;EyE5xdM;IAOI,+BAAA;EzEyxdV;;EyEhydM;IAOI,kCAAA;EzE6xdV;;EyEpydM;IAOI,iCAAA;EzEiydV;;EyExydM;IAOI,kCAAA;EzEqydV;;EyE5ydM;IAOI,+BAAA;EzEyydV;;EyEhzdM;IAOI,0BAAA;EzE6ydV;;EyEpzdM;IAOI,gCAAA;EzEizdV;;EyExzdM;IAOI,+BAAA;EzEqzdV;;EyE5zdM;IAOI,gCAAA;EzEyzdV;;EyEh0dM;IAOI,6BAAA;EzE6zdV;;EyEp0dM;IAOI,gCAAA;EzEi0dV;;EyEx0dM;IAOI,+BAAA;EzEq0dV;;EyE50dM;IAOI,gCAAA;EzEy0dV;;EyEh1dM;IAOI,6BAAA;EzE60dV;;EyEp1dM;IAOI,gCAAA;EzEi1dV;;EyEx1dM;IAOI,+BAAA;EzEq1dV;;EyE51dM;IAOI,gCAAA;EzEy1dV;;EyEh2dM;IAOI,6BAAA;EzE61dV;;EyEp2dM;IAOI,gCAAA;EzEi2dV;;EyEx2dM;IAOI,+BAAA;EzEq2dV;;EyE52dM;IAOI,gCAAA;EzEy2dV;;EyEh3dM;IAOI,6BAAA;EzE62dV;;EyEp3dM;IAOI,gCAAA;EzEi3dV;;EyEx3dM;IAOI,+BAAA;EzEq3dV;;EyE53dM;IAOI,gCAAA;EzEy3dV;;EyEh4dM;IAOI,6BAAA;EzE63dV;;EyEp4dM;IAOI,iBAAA;EzEi4dV;;EyEx4dM;IAOI,uBAAA;EzEq4dV;;EyE54dM;IAOI,sBAAA;EzEy4dV;;EyEh5dM;IAOI,uBAAA;EzE64dV;;EyEp5dM;IAOI,oBAAA;EzEi5dV;;EyEx5dM;IAOI,uBAAA;EzEq5dV;;EyE55dM;IAOI,sBAAA;EzEy5dV;;EyEh6dM;IAOI,uBAAA;EzE65dV;;EyEp6dM;IAOI,oBAAA;EzEi6dV;;EyEx6dM;IAOI,uBAAA;EzEq6dV;;EyE56dM;IAOI,sBAAA;EzEy6dV;;EyEh7dM;IAOI,uBAAA;EzE66dV;;EyEp7dM;IAOI,oBAAA;EzEi7dV;;EyEx7dM;IAOI,uBAAA;EzEq7dV;;EyE57dM;IAOI,sBAAA;EzEy7dV;;EyEh8dM;IAOI,uBAAA;EzE67dV;;EyEp8dM;IAOI,oBAAA;EzEi8dV;;EyEx8dM;IAOI,uBAAA;EzEq8dV;;EyE58dM;IAOI,sBAAA;EzEy8dV;;EyEh9dM;IAOI,uBAAA;EzE68dV;;EyEp9dM;IAOI,oBAAA;EzEi9dV;;EyEx9dM;IAOI,0CAAA;EzEq9dV;;EyE59dM;IAOI,4CAAA;EzEy9dV;;EyEh+dM;IAOI,4CAAA;EzE69dV;;EyEp+dM;IAOI,6BAAA;EzEi+dV;;EyEx+dM;IAOI,6BAAA;EzEq+dV;;EyE5+dM;IAOI,8BAAA;EzEy+dV;;EyEh/dM;IAOI,6BAAA;EzE6+dV;;EyEp/dM;IAOI,6BAAA;EzEi/dV;;EyEx/dM;IAOI,6BAAA;EzEq/dV;;EyE5/dM;IAOI,4BAAA;EzEy/dV;;EyEhgeM;IAOI,0BAAA;EzE6/dV;;EyEpgeM;IAOI,0BAAA;EzEigeV;;EyExgeM;IAOI,4CAAA;EzEqgeV;;EyE5geM;IAOI,2CAAA;EzEygeV;;EyEhheM;IAOI,4CAAA;EzE6geV;;EyEpheM;IAOI,0CAAA;EzEiheV;;EyExheM;IAOI,4CAAA;EzEqheV;;EyE5heM;IAOI,2CAAA;EzEyheV;;EyEhieM;IAOI,4CAAA;EzE6heV;;EyEpieM;IAOI,wCAAA;EzEiieV;;EyExieM;IAOI,4CAAA;EzEqieV;;EyE5ieM;IAOI,2CAAA;EzEyieV;;EyEhjeM;IAOI,4CAAA;EzE6ieV;;EyEpjeM;IAOI,0CAAA;EzEijeV;;EyExjeM;IAOI,4CAAA;EzEqjeV;;EyE5jeM;IAOI,2CAAA;EzEyjeV;;EyEhkeM;IAOI,4CAAA;EzE6jeV;;EyEpkeM;IAOI,0CAAA;EzEikeV;;EyExkeM;IAOI,2BAAA;EzEqkeV;;EyE5keM;IAOI,4BAAA;EzEykeV;;EyEhleM;IAOI,6BAAA;EzE6keV;;EyEpleM;IAOI,2BAAA;EzEileV;;EyExleM;IAOI,yBAAA;EzEqleV;;EyE5leM;IAOI,yBAAA;EzEyleV;;EyEhmeM;IAOI,yBAAA;EzE6leV;;EyEpmeM;IAOI,0BAAA;EzEimeV;;EyExmeM;IAOI,0BAAA;EzEqmeV;;EyE5meM;IAOI,yBAAA;EzEymeV;;EyEhneM;IAOI,yBAAA;EzE6meV;;EyEpneM;IAOI,yBAAA;EzEineV;;EyExneM;IAOI,yBAAA;EzEqneV;;EyE5neM;IAOI,yBAAA;EzEyneV;;EyEhoeM;IAOI,yBAAA;EzE6neV;;EyEpoeM;IAOI,yBAAA;EzEioeV;;EyExoeM;IAOI,yBAAA;EzEqoeV;;EyE5oeM;IAOI,yBAAA;EzEyoeV;;EyEhpeM;IAOI,0BAAA;EzE6oeV;;EyEppeM;IAOI,0BAAA;EzEipeV;;EyExpeM;IAOI,0BAAA;EzEqpeV;;EyE5peM;IAOI,0BAAA;EzEypeV;;EyEhqeM;IAOI,0BAAA;EzE6peV;;EyEpqeM;IAOI,0BAAA;EzEiqeV;;EyExqeM;IAOI,0BAAA;EzEqqeV;;EyE5qeM;IAOI,0BAAA;EzEyqeV;;EyEhreM;IAOI,0BAAA;EzE6qeV;;EyEpreM;IAOI,0BAAA;EzEireV;;EyExreM;IAOI,0BAAA;EzEqreV;;EyE5reM;IAOI,0BAAA;EzEyreV;;EyEhseM;IAOI,0BAAA;EzE6reV;;EyEpseM;IAOI,0BAAA;EzEiseV;;EyExseM;IAOI,0BAAA;EzEqseV;;EyE5seM;IAOI,0BAAA;EzEyseV;;EyEhteM;IAOI,0BAAA;EzE6seV;;EyEpteM;IAOI,0BAAA;EzEiteV;;EyExteM;IAOI,2BAAA;EzEqteV;;EyE5teM;IAOI,2BAAA;EzEyteV;;EyEhueM;IAOI,2BAAA;EzE6teV;;EyEpueM;IAOI,2BAAA;EzEiueV;;EyExueM;IAOI,2BAAA;EzEqueV;;EyE5ueM;IAOI,2BAAA;EzEyueV;;EyEhveM;IAOI,2BAAA;EzE6ueV;;EyEpveM;IAOI,2BAAA;EzEiveV;;EyExveM;IAOI,2BAAA;EzEqveV;;EyE5veM;IAOI,2BAAA;EzEyveV;;EyEhweM;IAOI,2BAAA;EzE6veV;;EyEpweM;IAOI,2BAAA;EzEiweV;;EyExweM;IAOI,2BAAA;EzEqweV;;EyE5weM;IAOI,2BAAA;EzEyweV;;EyEhxeM;IAOI,2BAAA;EzE6weV;;EyEpxeM;IAOI,2BAAA;EzEixeV;;EyExxeM;IAOI,2BAAA;EzEqxeV;;EyE5xeM;IAOI,2BAAA;EzEyxeV;;EyEhyeM;IAOI,2BAAA;EzE6xeV;;EyEpyeM;IAOI,2BAAA;EzEiyeV;;EyExyeM;IAOI,2BAAA;EzEqyeV;;EyE5yeM;IAOI,2BAAA;EzEyyeV;;EyEhzeM;IAOI,2BAAA;EzE6yeV;;EyEpzeM;IAOI,2BAAA;EzEizeV;;EyExzeM;IAOI,2BAAA;EzEqzeV;;EyE5zeM;IAOI,2BAAA;EzEyzeV;;EyEh0eM;IAOI,4BAAA;EzE6zeV;;EyEp0eM;IAOI,4BAAA;EzEi0eV;;EyEx0eM;IAOI,0BAAA;EzEq0eV;;EyE50eM;IAOI,0BAAA;EzEy0eV;;EyEh1eM;IAOI,0BAAA;EzE60eV;;EyEp1eM;IAOI,2BAAA;EzEi1eV;;EyEx1eM;IAOI,2BAAA;EzEq1eV;;EyE51eM;IAOI,0BAAA;EzEy1eV;;EyEh2eM;IAOI,0BAAA;EzE61eV;;EyEp2eM;IAOI,0BAAA;EzEi2eV;;EyEx2eM;IAOI,0BAAA;EzEq2eV;;EyE52eM;IAOI,0BAAA;EzEy2eV;;EyEh3eM;IAOI,0BAAA;EzE62eV;;EyEp3eM;IAOI,0BAAA;EzEi3eV;;EyEx3eM;IAOI,0BAAA;EzEq3eV;;EyE53eM;IAOI,0BAAA;EzEy3eV;;EyEh4eM;IAOI,2BAAA;EzE63eV;;EyEp4eM;IAOI,2BAAA;EzEi4eV;;EyEx4eM;IAOI,2BAAA;EzEq4eV;;EyE54eM;IAOI,2BAAA;EzEy4eV;;EyEh5eM;IAOI,2BAAA;EzE64eV;;EyEp5eM;IAOI,2BAAA;EzEi5eV;;EyEx5eM;IAOI,2BAAA;EzEq5eV;;EyE55eM;IAOI,2BAAA;EzEy5eV;;EyEh6eM;IAOI,2BAAA;EzE65eV;;EyEp6eM;IAOI,2BAAA;EzEi6eV;;EyEx6eM;IAOI,2BAAA;EzEq6eV;;EyE56eM;IAOI,2BAAA;EzEy6eV;;EyEh7eM;IAOI,2BAAA;EzE66eV;;EyEp7eM;IAOI,2BAAA;EzEi7eV;;EyEx7eM;IAOI,2BAAA;EzEq7eV;;EyE57eM;IAOI,2BAAA;EzEy7eV;;EyEh8eM;IAOI,2BAAA;EzE67eV;;EyEp8eM;IAOI,2BAAA;EzEi8eV;;EyEx8eM;IAOI,4BAAA;EzEq8eV;;EyE58eM;IAOI,4BAAA;EzEy8eV;;EyEh9eM;IAOI,4BAAA;EzE68eV;;EyEp9eM;IAOI,4BAAA;EzEi9eV;;EyEx9eM;IAOI,4BAAA;EzEq9eV;;EyE59eM;IAOI,4BAAA;EzEy9eV;;EyEh+eM;IAOI,4BAAA;EzE69eV;;EyEp+eM;IAOI,4BAAA;EzEi+eV;;EyEx+eM;IAOI,4BAAA;EzEq+eV;;EyE5+eM;IAOI,4BAAA;EzEy+eV;;EyEh/eM;IAOI,4BAAA;EzE6+eV;;EyEp/eM;IAOI,4BAAA;EzEi/eV;;EyEx/eM;IAOI,4BAAA;EzEq/eV;;EyE5/eM;IAOI,4BAAA;EzEy/eV;;EyEhgfM;IAOI,4BAAA;EzE6/eV;;EyEpgfM;IAOI,4BAAA;EzEigfV;;EyExgfM;IAOI,4BAAA;EzEqgfV;;EyE5gfM;IAOI,4BAAA;EzEygfV;;EyEhhfM;IAOI,4BAAA;EzE6gfV;;EyEphfM;IAOI,4BAAA;EzEihfV;;EyExhfM;IAOI,4BAAA;EzEqhfV;;EyE5hfM;IAOI,4BAAA;EzEyhfV;;EyEhifM;IAOI,4BAAA;EzE6hfV;;EyEpifM;IAOI,4BAAA;EzEiifV;;EyExifM;IAOI,4BAAA;EzEqifV;;EyE5ifM;IAOI,4BAAA;EzEyifV;;EyEhjfM;IAOI,6BAAA;EzE6ifV;AACF;AexjfI;E0DGI;IAOI,sBAAA;EzEkjfV;;EyEzjfM;IAOI,uBAAA;EzEsjfV;;EyE7jfM;IAOI,sBAAA;EzE0jfV;;EyEjkfM;IAOI,0BAAA;EzE8jfV;;EyErkfM;IAOI,gCAAA;EzEkkfV;;EyEzkfM;IAOI,yBAAA;EzEskfV;;EyE7kfM;IAOI,wBAAA;EzE0kfV;;EyEjlfM;IAOI,yBAAA;EzE8kfV;;EyErlfM;IAOI,6BAAA;EzEklfV;;EyEzlfM;IAOI,8BAAA;EzEslfV;;EyE7lfM;IAOI,wBAAA;EzE0lfV;;EyEjmfM;IAOI,+BAAA;EzE8lfV;;EyErmfM;IAOI,wBAAA;EzEkmfV;;EyEzmfM;IAOI,2BAAA;EzEsmfV;;EyE7mfM;IAOI,6BAAA;EzE0mfV;;EyEjnfM;IAOI,6BAAA;EzE8mfV;;EyErnfM;IAOI,0BAAA;EzEknfV;;EyEznfM;IAOI,2BAAA;EzEsnfV;;EyE7nfM;IAOI,uBAAA;EzE0nfV;;EyEjofM;IAOI,qBAAA;EzE8nfV;;EyErofM;IAOI,qBAAA;EzEkofV;;EyEzofM;IAOI,qBAAA;EzEsofV;;EyE7ofM;IAOI,sBAAA;EzE0ofV;;EyEjpfM;IAOI,sBAAA;EzE8ofV;;EyErpfM;IAOI,qBAAA;EzEkpfV;;EyEzpfM;IAOI,qBAAA;EzEspfV;;EyE7pfM;IAOI,qBAAA;EzE0pfV;;EyEjqfM;IAOI,qBAAA;EzE8pfV;;EyErqfM;IAOI,qBAAA;EzEkqfV;;EyEzqfM;IAOI,qBAAA;EzEsqfV;;EyE7qfM;IAOI,qBAAA;EzE0qfV;;EyEjrfM;IAOI,qBAAA;EzE8qfV;;EyErrfM;IAOI,qBAAA;EzEkrfV;;EyEzrfM;IAOI,sBAAA;EzEsrfV;;EyE7rfM;IAOI,sBAAA;EzE0rfV;;EyEjsfM;IAOI,sBAAA;EzE8rfV;;EyErsfM;IAOI,sBAAA;EzEksfV;;EyEzsfM;IAOI,sBAAA;EzEssfV;;EyE7sfM;IAOI,sBAAA;EzE0sfV;;EyEjtfM;IAOI,sBAAA;EzE8sfV;;EyErtfM;IAOI,sBAAA;EzEktfV;;EyEztfM;IAOI,sBAAA;EzEstfV;;EyE7tfM;IAOI,sBAAA;EzE0tfV;;EyEjufM;IAOI,sBAAA;EzE8tfV;;EyErufM;IAOI,sBAAA;EzEkufV;;EyEzufM;IAOI,sBAAA;EzEsufV;;EyE7ufM;IAOI,sBAAA;EzE0ufV;;EyEjvfM;IAOI,sBAAA;EzE8ufV;;EyErvfM;IAOI,sBAAA;EzEkvfV;;EyEzvfM;IAOI,sBAAA;EzEsvfV;;EyE7vfM;IAOI,sBAAA;EzE0vfV;;EyEjwfM;IAOI,uBAAA;EzE8vfV;;EyErwfM;IAOI,uBAAA;EzEkwfV;;EyEzwfM;IAOI,uBAAA;EzEswfV;;EyE7wfM;IAOI,uBAAA;EzE0wfV;;EyEjxfM;IAOI,uBAAA;EzE8wfV;;EyErxfM;IAOI,uBAAA;EzEkxfV;;EyEzxfM;IAOI,uBAAA;EzEsxfV;;EyE7xfM;IAOI,uBAAA;EzE0xfV;;EyEjyfM;IAOI,uBAAA;EzE8xfV;;EyEryfM;IAOI,uBAAA;EzEkyfV;;EyEzyfM;IAOI,uBAAA;EzEsyfV;;EyE7yfM;IAOI,uBAAA;EzE0yfV;;EyEjzfM;IAOI,uBAAA;EzE8yfV;;EyErzfM;IAOI,uBAAA;EzEkzfV;;EyEzzfM;IAOI,uBAAA;EzEszfV;;EyE7zfM;IAOI,uBAAA;EzE0zfV;;EyEj0fM;IAOI,uBAAA;EzE8zfV;;EyEr0fM;IAOI,uBAAA;EzEk0fV;;EyEz0fM;IAOI,uBAAA;EzEs0fV;;EyE70fM;IAOI,uBAAA;EzE00fV;;EyEj1fM;IAOI,uBAAA;EzE80fV;;EyEr1fM;IAOI,uBAAA;EzEk1fV;;EyEz1fM;IAOI,uBAAA;EzEs1fV;;EyE71fM;IAOI,uBAAA;EzE01fV;;EyEj2fM;IAOI,uBAAA;EzE81fV;;EyEr2fM;IAOI,uBAAA;EzEk2fV;;EyEz2fM;IAOI,wBAAA;EzEs2fV;;EyE72fM;IAOI,2BAAA;EzE02fV;;EyEj3fM;IAOI,yBAAA;EzE82fV;;EyEr3fM;IAOI,yBAAA;EzEk3fV;;EyEz3fM;IAOI,yBAAA;EzEs3fV;;EyE73fM;IAOI,0BAAA;EzE03fV;;EyEj4fM;IAOI,0BAAA;EzE83fV;;EyEr4fM;IAOI,yBAAA;EzEk4fV;;EyEz4fM;IAOI,yBAAA;EzEs4fV;;EyE74fM;IAOI,yBAAA;EzE04fV;;EyEj5fM;IAOI,yBAAA;EzE84fV;;EyEr5fM;IAOI,yBAAA;EzEk5fV;;EyEz5fM;IAOI,yBAAA;EzEs5fV;;EyE75fM;IAOI,yBAAA;EzE05fV;;EyEj6fM;IAOI,yBAAA;EzE85fV;;EyEr6fM;IAOI,yBAAA;EzEk6fV;;EyEz6fM;IAOI,0BAAA;EzEs6fV;;EyE76fM;IAOI,0BAAA;EzE06fV;;EyEj7fM;IAOI,0BAAA;EzE86fV;;EyEr7fM;IAOI,0BAAA;EzEk7fV;;EyEz7fM;IAOI,0BAAA;EzEs7fV;;EyE77fM;IAOI,0BAAA;EzE07fV;;EyEj8fM;IAOI,0BAAA;EzE87fV;;EyEr8fM;IAOI,0BAAA;EzEk8fV;;EyEz8fM;IAOI,0BAAA;EzEs8fV;;EyE78fM;IAOI,0BAAA;EzE08fV;;EyEj9fM;IAOI,0BAAA;EzE88fV;;EyEr9fM;IAOI,0BAAA;EzEk9fV;;EyEz9fM;IAOI,0BAAA;EzEs9fV;;EyE79fM;IAOI,0BAAA;EzE09fV;;EyEj+fM;IAOI,0BAAA;EzE89fV;;EyEr+fM;IAOI,0BAAA;EzEk+fV;;EyEz+fM;IAOI,0BAAA;EzEs+fV;;EyE7+fM;IAOI,0BAAA;EzE0+fV;;EyEj/fM;IAOI,2BAAA;EzE8+fV;;EyEr/fM;IAOI,2BAAA;EzEk/fV;;EyEz/fM;IAOI,2BAAA;EzEs/fV;;EyE7/fM;IAOI,2BAAA;EzE0/fV;;EyEjggBM;IAOI,2BAAA;EzE8/fV;;EyErggBM;IAOI,2BAAA;EzEkggBV;;EyEzggBM;IAOI,2BAAA;EzEsggBV;;EyE7ggBM;IAOI,2BAAA;EzE0ggBV;;EyEjhgBM;IAOI,2BAAA;EzE8ggBV;;EyErhgBM;IAOI,2BAAA;EzEkhgBV;;EyEzhgBM;IAOI,2BAAA;EzEshgBV;;EyE7hgBM;IAOI,2BAAA;EzE0hgBV;;EyEjigBM;IAOI,2BAAA;EzE8hgBV;;EyErigBM;IAOI,2BAAA;EzEkigBV;;EyEzigBM;IAOI,2BAAA;EzEsigBV;;EyE7igBM;IAOI,2BAAA;EzE0igBV;;EyEjjgBM;IAOI,2BAAA;EzE8igBV;;EyErjgBM;IAOI,2BAAA;EzEkjgBV;;EyEzjgBM;IAOI,2BAAA;EzEsjgBV;;EyE7jgBM;IAOI,2BAAA;EzE0jgBV;;EyEjkgBM;IAOI,2BAAA;EzE8jgBV;;EyErkgBM;IAOI,2BAAA;EzEkkgBV;;EyEzkgBM;IAOI,2BAAA;EzEskgBV;;EyE7kgBM;IAOI,2BAAA;EzE0kgBV;;EyEjlgBM;IAOI,2BAAA;EzE8kgBV;;EyErlgBM;IAOI,2BAAA;EzEklgBV;;EyEzlgBM;IAOI,4BAAA;EzEslgBV;;EyE7lgBM;IAOI,wBAAA;EzE0lgBV;;EyEjmgBM;IAOI,sBAAA;EzE8lgBV;;EyErmgBM;IAOI,sBAAA;EzEkmgBV;;EyEzmgBM;IAOI,sBAAA;EzEsmgBV;;EyE7mgBM;IAOI,uBAAA;EzE0mgBV;;EyEjngBM;IAOI,uBAAA;EzE8mgBV;;EyErngBM;IAOI,sBAAA;EzEkngBV;;EyEzngBM;IAOI,sBAAA;EzEsngBV;;EyE7ngBM;IAOI,sBAAA;EzE0ngBV;;EyEjogBM;IAOI,sBAAA;EzE8ngBV;;EyErogBM;IAOI,sBAAA;EzEkogBV;;EyEzogBM;IAOI,sBAAA;EzEsogBV;;EyE7ogBM;IAOI,sBAAA;EzE0ogBV;;EyEjpgBM;IAOI,sBAAA;EzE8ogBV;;EyErpgBM;IAOI,sBAAA;EzEkpgBV;;EyEzpgBM;IAOI,uBAAA;EzEspgBV;;EyE7pgBM;IAOI,uBAAA;EzE0pgBV;;EyEjqgBM;IAOI,uBAAA;EzE8pgBV;;EyErqgBM;IAOI,uBAAA;EzEkqgBV;;EyEzqgBM;IAOI,uBAAA;EzEsqgBV;;EyE7qgBM;IAOI,uBAAA;EzE0qgBV;;EyEjrgBM;IAOI,uBAAA;EzE8qgBV;;EyErrgBM;IAOI,uBAAA;EzEkrgBV;;EyEzrgBM;IAOI,uBAAA;EzEsrgBV;;EyE7rgBM;IAOI,uBAAA;EzE0rgBV;;EyEjsgBM;IAOI,uBAAA;EzE8rgBV;;EyErsgBM;IAOI,uBAAA;EzEksgBV;;EyEzsgBM;IAOI,uBAAA;EzEssgBV;;EyE7sgBM;IAOI,uBAAA;EzE0sgBV;;EyEjtgBM;IAOI,uBAAA;EzE8sgBV;;EyErtgBM;IAOI,uBAAA;EzEktgBV;;EyEztgBM;IAOI,uBAAA;EzEstgBV;;EyE7tgBM;IAOI,uBAAA;EzE0tgBV;;EyEjugBM;IAOI,wBAAA;EzE8tgBV;;EyErugBM;IAOI,wBAAA;EzEkugBV;;EyEzugBM;IAOI,wBAAA;EzEsugBV;;EyE7ugBM;IAOI,wBAAA;EzE0ugBV;;EyEjvgBM;IAOI,wBAAA;EzE8ugBV;;EyErvgBM;IAOI,wBAAA;EzEkvgBV;;EyEzvgBM;IAOI,wBAAA;EzEsvgBV;;EyE7vgBM;IAOI,wBAAA;EzE0vgBV;;EyEjwgBM;IAOI,wBAAA;EzE8vgBV;;EyErwgBM;IAOI,wBAAA;EzEkwgBV;;EyEzwgBM;IAOI,wBAAA;EzEswgBV;;EyE7wgBM;IAOI,wBAAA;EzE0wgBV;;EyEjxgBM;IAOI,wBAAA;EzE8wgBV;;EyErxgBM;IAOI,wBAAA;EzEkxgBV;;EyEzxgBM;IAOI,wBAAA;EzEsxgBV;;EyE7xgBM;IAOI,wBAAA;EzE0xgBV;;EyEjygBM;IAOI,wBAAA;EzE8xgBV;;EyErygBM;IAOI,wBAAA;EzEkygBV;;EyEzygBM;IAOI,wBAAA;EzEsygBV;;EyE7ygBM;IAOI,wBAAA;EzE0ygBV;;EyEjzgBM;IAOI,wBAAA;EzE8ygBV;;EyErzgBM;IAOI,wBAAA;EzEkzgBV;;EyEzzgBM;IAOI,wBAAA;EzEszgBV;;EyE7zgBM;IAOI,wBAAA;EzE0zgBV;;EyEj0gBM;IAOI,wBAAA;EzE8zgBV;;EyEr0gBM;IAOI,wBAAA;EzEk0gBV;;EyEz0gBM;IAOI,yBAAA;EzEs0gBV;;EyE70gBM;IAOI,4BAAA;EzE00gBV;;EyEj1gBM;IAOI,0BAAA;EzE80gBV;;EyEr1gBM;IAOI,0BAAA;EzEk1gBV;;EyEz1gBM;IAOI,0BAAA;EzEs1gBV;;EyE71gBM;IAOI,2BAAA;EzE01gBV;;EyEj2gBM;IAOI,2BAAA;EzE81gBV;;EyEr2gBM;IAOI,0BAAA;EzEk2gBV;;EyEz2gBM;IAOI,0BAAA;EzEs2gBV;;EyE72gBM;IAOI,0BAAA;EzE02gBV;;EyEj3gBM;IAOI,0BAAA;EzE82gBV;;EyEr3gBM;IAOI,0BAAA;EzEk3gBV;;EyEz3gBM;IAOI,0BAAA;EzEs3gBV;;EyE73gBM;IAOI,0BAAA;EzE03gBV;;EyEj4gBM;IAOI,0BAAA;EzE83gBV;;EyEr4gBM;IAOI,0BAAA;EzEk4gBV;;EyEz4gBM;IAOI,2BAAA;EzEs4gBV;;EyE74gBM;IAOI,2BAAA;EzE04gBV;;EyEj5gBM;IAOI,2BAAA;EzE84gBV;;EyEr5gBM;IAOI,2BAAA;EzEk5gBV;;EyEz5gBM;IAOI,2BAAA;EzEs5gBV;;EyE75gBM;IAOI,2BAAA;EzE05gBV;;EyEj6gBM;IAOI,2BAAA;EzE85gBV;;EyEr6gBM;IAOI,2BAAA;EzEk6gBV;;EyEz6gBM;IAOI,2BAAA;EzEs6gBV;;EyE76gBM;IAOI,2BAAA;EzE06gBV;;EyEj7gBM;IAOI,2BAAA;EzE86gBV;;EyEr7gBM;IAOI,2BAAA;EzEk7gBV;;EyEz7gBM;IAOI,2BAAA;EzEs7gBV;;EyE77gBM;IAOI,2BAAA;EzE07gBV;;EyEj8gBM;IAOI,2BAAA;EzE87gBV;;EyEr8gBM;IAOI,2BAAA;EzEk8gBV;;EyEz8gBM;IAOI,2BAAA;EzEs8gBV;;EyE78gBM;IAOI,2BAAA;EzE08gBV;;EyEj9gBM;IAOI,4BAAA;EzE88gBV;;EyEr9gBM;IAOI,4BAAA;EzEk9gBV;;EyEz9gBM;IAOI,4BAAA;EzEs9gBV;;EyE79gBM;IAOI,4BAAA;EzE09gBV;;EyEj+gBM;IAOI,4BAAA;EzE89gBV;;EyEr+gBM;IAOI,4BAAA;EzEk+gBV;;EyEz+gBM;IAOI,4BAAA;EzEs+gBV;;EyE7+gBM;IAOI,4BAAA;EzE0+gBV;;EyEj/gBM;IAOI,4BAAA;EzE8+gBV;;EyEr/gBM;IAOI,4BAAA;EzEk/gBV;;EyEz/gBM;IAOI,4BAAA;EzEs/gBV;;EyE7/gBM;IAOI,4BAAA;EzE0/gBV;;EyEjghBM;IAOI,4BAAA;EzE8/gBV;;EyErghBM;IAOI,4BAAA;EzEkghBV;;EyEzghBM;IAOI,4BAAA;EzEsghBV;;EyE7ghBM;IAOI,4BAAA;EzE0ghBV;;EyEjhhBM;IAOI,4BAAA;EzE8ghBV;;EyErhhBM;IAOI,4BAAA;EzEkhhBV;;EyEzhhBM;IAOI,4BAAA;EzEshhBV;;EyE7hhBM;IAOI,4BAAA;EzE0hhBV;;EyEjihBM;IAOI,4BAAA;EzE8hhBV;;EyErihBM;IAOI,4BAAA;EzEkihBV;;EyEzihBM;IAOI,4BAAA;EzEsihBV;;EyE7ihBM;IAOI,4BAAA;EzE0ihBV;;EyEjjhBM;IAOI,4BAAA;EzE8ihBV;;EyErjhBM;IAOI,4BAAA;EzEkjhBV;;EyEzjhBM;IAOI,6BAAA;EzEsjhBV;;EyE7jhBM;IAOI,yBAAA;EzE0jhBV;;EyEjkhBM;IAOI,8BAAA;EzE8jhBV;;EyErkhBM;IAOI,iCAAA;EzEkkhBV;;EyEzkhBM;IAOI,sCAAA;EzEskhBV;;EyE7khBM;IAOI,yCAAA;EzE0khBV;;EyEjlhBM;IAOI,uBAAA;EzE8khBV;;EyErlhBM;IAOI,uBAAA;EzEklhBV;;EyEzlhBM;IAOI,yBAAA;EzEslhBV;;EyE7lhBM;IAOI,yBAAA;EzE0lhBV;;EyEjmhBM;IAOI,0BAAA;EzE8lhBV;;EyErmhBM;IAOI,4BAAA;EzEkmhBV;;EyEzmhBM;IAOI,kCAAA;EzEsmhBV;;EyE7mhBM;IAOI,sCAAA;EzE0mhBV;;EyEjnhBM;IAOI,oCAAA;EzE8mhBV;;EyErnhBM;IAOI,kCAAA;EzEknhBV;;EyEznhBM;IAOI,yCAAA;EzEsnhBV;;EyE7nhBM;IAOI,wCAAA;EzE0nhBV;;EyEjohBM;IAOI,wCAAA;EzE8nhBV;;EyErohBM;IAOI,kCAAA;EzEkohBV;;EyEzohBM;IAOI,gCAAA;EzEsohBV;;EyE7ohBM;IAOI,8BAAA;EzE0ohBV;;EyEjphBM;IAOI,gCAAA;EzE8ohBV;;EyErphBM;IAOI,+BAAA;EzEkphBV;;EyEzphBM;IAOI,oCAAA;EzEsphBV;;EyE7phBM;IAOI,kCAAA;EzE0phBV;;EyEjqhBM;IAOI,gCAAA;EzE8phBV;;EyErqhBM;IAOI,uCAAA;EzEkqhBV;;EyEzqhBM;IAOI,sCAAA;EzEsqhBV;;EyE7qhBM;IAOI,iCAAA;EzE0qhBV;;EyEjrhBM;IAOI,2BAAA;EzE8qhBV;;EyErrhBM;IAOI,iCAAA;EzEkrhBV;;EyEzrhBM;IAOI,+BAAA;EzEsrhBV;;EyE7rhBM;IAOI,6BAAA;EzE0rhBV;;EyEjshBM;IAOI,+BAAA;EzE8rhBV;;EyErshBM;IAOI,8BAAA;EzEkshBV;;EyEzshBM;IAOI,oBAAA;EzEsshBV;;EyE7shBM;IAOI,mBAAA;EzE0shBV;;EyEjthBM;IAOI,mBAAA;EzE8shBV;;EyErthBM;IAOI,mBAAA;EzEkthBV;;EyEzthBM;IAOI,mBAAA;EzEsthBV;;EyE7thBM;IAOI,mBAAA;EzE0thBV;;EyEjuhBM;IAOI,mBAAA;EzE8thBV;;EyEruhBM;IAOI,mBAAA;EzEkuhBV;;EyEzuhBM;IAOI,oBAAA;EzEsuhBV;;EyE7uhBM;IAOI,0BAAA;EzE0uhBV;;EyEjvhBM;IAOI,yBAAA;EzE8uhBV;;EyErvhBM;IAOI,0BAAA;EzEkvhBV;;EyEzvhBM;IAOI,uBAAA;EzEsvhBV;;EyE7vhBM;IAOI,0BAAA;EzE0vhBV;;EyEjwhBM;IAOI,yBAAA;EzE8vhBV;;EyErwhBM;IAOI,0BAAA;EzEkwhBV;;EyEzwhBM;IAOI,uBAAA;EzEswhBV;;EyE7whBM;IAOI,0BAAA;EzE0whBV;;EyEjxhBM;IAOI,yBAAA;EzE8whBV;;EyErxhBM;IAOI,0BAAA;EzEkxhBV;;EyEzxhBM;IAOI,uBAAA;EzEsxhBV;;EyE7xhBM;IAOI,0BAAA;EzE0xhBV;;EyEjyhBM;IAOI,yBAAA;EzE8xhBV;;EyEryhBM;IAOI,0BAAA;EzEkyhBV;;EyEzyhBM;IAOI,uBAAA;EzEsyhBV;;EyE7yhBM;IAOI,0BAAA;EzE0yhBV;;EyEjzhBM;IAOI,yBAAA;EzE8yhBV;;EyErzhBM;IAOI,0BAAA;EzEkzhBV;;EyEzzhBM;IAOI,uBAAA;EzEszhBV;;EyE7zhBM;IAOI,uBAAA;EzE0zhBV;;EyEj0hBM;IAOI,0BAAA;IAAA,yBAAA;EzE+zhBV;;EyEt0hBM;IAOI,gCAAA;IAAA,+BAAA;EzEo0hBV;;EyE30hBM;IAOI,+BAAA;IAAA,8BAAA;EzEy0hBV;;EyEh1hBM;IAOI,gCAAA;IAAA,+BAAA;EzE80hBV;;EyEr1hBM;IAOI,6BAAA;IAAA,4BAAA;EzEm1hBV;;EyE11hBM;IAOI,gCAAA;IAAA,+BAAA;EzEw1hBV;;EyE/1hBM;IAOI,+BAAA;IAAA,8BAAA;EzE61hBV;;EyEp2hBM;IAOI,gCAAA;IAAA,+BAAA;EzEk2hBV;;EyEz2hBM;IAOI,6BAAA;IAAA,4BAAA;EzEu2hBV;;EyE92hBM;IAOI,gCAAA;IAAA,+BAAA;EzE42hBV;;EyEn3hBM;IAOI,+BAAA;IAAA,8BAAA;EzEi3hBV;;EyEx3hBM;IAOI,gCAAA;IAAA,+BAAA;EzEs3hBV;;EyE73hBM;IAOI,6BAAA;IAAA,4BAAA;EzE23hBV;;EyEl4hBM;IAOI,gCAAA;IAAA,+BAAA;EzEg4hBV;;EyEv4hBM;IAOI,+BAAA;IAAA,8BAAA;EzEq4hBV;;EyE54hBM;IAOI,gCAAA;IAAA,+BAAA;EzE04hBV;;EyEj5hBM;IAOI,6BAAA;IAAA,4BAAA;EzE+4hBV;;EyEt5hBM;IAOI,gCAAA;IAAA,+BAAA;EzEo5hBV;;EyE35hBM;IAOI,+BAAA;IAAA,8BAAA;EzEy5hBV;;EyEh6hBM;IAOI,gCAAA;IAAA,+BAAA;EzE85hBV;;EyEr6hBM;IAOI,6BAAA;IAAA,4BAAA;EzEm6hBV;;EyE16hBM;IAOI,6BAAA;IAAA,4BAAA;EzEw6hBV;;EyE/6hBM;IAOI,wBAAA;IAAA,2BAAA;EzE66hBV;;EyEp7hBM;IAOI,8BAAA;IAAA,iCAAA;EzEk7hBV;;EyEz7hBM;IAOI,6BAAA;IAAA,gCAAA;EzEu7hBV;;EyE97hBM;IAOI,8BAAA;IAAA,iCAAA;EzE47hBV;;EyEn8hBM;IAOI,2BAAA;IAAA,8BAAA;EzEi8hBV;;EyEx8hBM;IAOI,8BAAA;IAAA,iCAAA;EzEs8hBV;;EyE78hBM;IAOI,6BAAA;IAAA,gCAAA;EzE28hBV;;EyEl9hBM;IAOI,8BAAA;IAAA,iCAAA;EzEg9hBV;;EyEv9hBM;IAOI,2BAAA;IAAA,8BAAA;EzEq9hBV;;EyE59hBM;IAOI,8BAAA;IAAA,iCAAA;EzE09hBV;;EyEj+hBM;IAOI,6BAAA;IAAA,gCAAA;EzE+9hBV;;EyEt+hBM;IAOI,8BAAA;IAAA,iCAAA;EzEo+hBV;;EyE3+hBM;IAOI,2BAAA;IAAA,8BAAA;EzEy+hBV;;EyEh/hBM;IAOI,8BAAA;IAAA,iCAAA;EzE8+hBV;;EyEr/hBM;IAOI,6BAAA;IAAA,gCAAA;EzEm/hBV;;EyE1/hBM;IAOI,8BAAA;IAAA,iCAAA;EzEw/hBV;;EyE//hBM;IAOI,2BAAA;IAAA,8BAAA;EzE6/hBV;;EyEpgiBM;IAOI,8BAAA;IAAA,iCAAA;EzEkgiBV;;EyEzgiBM;IAOI,6BAAA;IAAA,gCAAA;EzEugiBV;;EyE9giBM;IAOI,8BAAA;IAAA,iCAAA;EzE4giBV;;EyEnhiBM;IAOI,2BAAA;IAAA,8BAAA;EzEihiBV;;EyExhiBM;IAOI,2BAAA;IAAA,8BAAA;EzEshiBV;;EyE7hiBM;IAOI,wBAAA;EzE0hiBV;;EyEjiiBM;IAOI,8BAAA;EzE8hiBV;;EyEriiBM;IAOI,6BAAA;EzEkiiBV;;EyEziiBM;IAOI,8BAAA;EzEsiiBV;;EyE7iiBM;IAOI,2BAAA;EzE0iiBV;;EyEjjiBM;IAOI,8BAAA;EzE8iiBV;;EyErjiBM;IAOI,6BAAA;EzEkjiBV;;EyEzjiBM;IAOI,8BAAA;EzEsjiBV;;EyE7jiBM;IAOI,2BAAA;EzE0jiBV;;EyEjkiBM;IAOI,8BAAA;EzE8jiBV;;EyErkiBM;IAOI,6BAAA;EzEkkiBV;;EyEzkiBM;IAOI,8BAAA;EzEskiBV;;EyE7kiBM;IAOI,2BAAA;EzE0kiBV;;EyEjliBM;IAOI,8BAAA;EzE8kiBV;;EyErliBM;IAOI,6BAAA;EzEkliBV;;EyEzliBM;IAOI,8BAAA;EzEsliBV;;EyE7liBM;IAOI,2BAAA;EzE0liBV;;EyEjmiBM;IAOI,8BAAA;EzE8liBV;;EyErmiBM;IAOI,6BAAA;EzEkmiBV;;EyEzmiBM;IAOI,8BAAA;EzEsmiBV;;EyE7miBM;IAOI,2BAAA;EzE0miBV;;EyEjniBM;IAOI,2BAAA;EzE8miBV;;EyErniBM;IAOI,0BAAA;EzEkniBV;;EyEzniBM;IAOI,gCAAA;EzEsniBV;;EyE7niBM;IAOI,+BAAA;EzE0niBV;;EyEjoiBM;IAOI,gCAAA;EzE8niBV;;EyEroiBM;IAOI,6BAAA;EzEkoiBV;;EyEzoiBM;IAOI,gCAAA;EzEsoiBV;;EyE7oiBM;IAOI,+BAAA;EzE0oiBV;;EyEjpiBM;IAOI,gCAAA;EzE8oiBV;;EyErpiBM;IAOI,6BAAA;EzEkpiBV;;EyEzpiBM;IAOI,gCAAA;EzEspiBV;;EyE7piBM;IAOI,+BAAA;EzE0piBV;;EyEjqiBM;IAOI,gCAAA;EzE8piBV;;EyErqiBM;IAOI,6BAAA;EzEkqiBV;;EyEzqiBM;IAOI,gCAAA;EzEsqiBV;;EyE7qiBM;IAOI,+BAAA;EzE0qiBV;;EyEjriBM;IAOI,gCAAA;EzE8qiBV;;EyErriBM;IAOI,6BAAA;EzEkriBV;;EyEzriBM;IAOI,gCAAA;EzEsriBV;;EyE7riBM;IAOI,+BAAA;EzE0riBV;;EyEjsiBM;IAOI,gCAAA;EzE8riBV;;EyErsiBM;IAOI,6BAAA;EzEksiBV;;EyEzsiBM;IAOI,6BAAA;EzEssiBV;;EyE7siBM;IAOI,2BAAA;EzE0siBV;;EyEjtiBM;IAOI,iCAAA;EzE8siBV;;EyErtiBM;IAOI,gCAAA;EzEktiBV;;EyEztiBM;IAOI,iCAAA;EzEstiBV;;EyE7tiBM;IAOI,8BAAA;EzE0tiBV;;EyEjuiBM;IAOI,iCAAA;EzE8tiBV;;EyEruiBM;IAOI,gCAAA;EzEkuiBV;;EyEzuiBM;IAOI,iCAAA;EzEsuiBV;;EyE7uiBM;IAOI,8BAAA;EzE0uiBV;;EyEjviBM;IAOI,iCAAA;EzE8uiBV;;EyErviBM;IAOI,gCAAA;EzEkviBV;;EyEzviBM;IAOI,iCAAA;EzEsviBV;;EyE7viBM;IAOI,8BAAA;EzE0viBV;;EyEjwiBM;IAOI,iCAAA;EzE8viBV;;EyErwiBM;IAOI,gCAAA;EzEkwiBV;;EyEzwiBM;IAOI,iCAAA;EzEswiBV;;EyE7wiBM;IAOI,8BAAA;EzE0wiBV;;EyEjxiBM;IAOI,iCAAA;EzE8wiBV;;EyErxiBM;IAOI,gCAAA;EzEkxiBV;;EyEzxiBM;IAOI,iCAAA;EzEsxiBV;;EyE7xiBM;IAOI,8BAAA;EzE0xiBV;;EyEjyiBM;IAOI,8BAAA;EzE8xiBV;;EyEryiBM;IAOI,yBAAA;EzEkyiBV;;EyEzyiBM;IAOI,+BAAA;EzEsyiBV;;EyE7yiBM;IAOI,8BAAA;EzE0yiBV;;EyEjziBM;IAOI,+BAAA;EzE8yiBV;;EyErziBM;IAOI,4BAAA;EzEkziBV;;EyEzziBM;IAOI,+BAAA;EzEsziBV;;EyE7ziBM;IAOI,8BAAA;EzE0ziBV;;EyEj0iBM;IAOI,+BAAA;EzE8ziBV;;EyEr0iBM;IAOI,4BAAA;EzEk0iBV;;EyEz0iBM;IAOI,+BAAA;EzEs0iBV;;EyE70iBM;IAOI,8BAAA;EzE00iBV;;EyEj1iBM;IAOI,+BAAA;EzE80iBV;;EyEr1iBM;IAOI,4BAAA;EzEk1iBV;;EyEz1iBM;IAOI,+BAAA;EzEs1iBV;;EyE71iBM;IAOI,8BAAA;EzE01iBV;;EyEj2iBM;IAOI,+BAAA;EzE81iBV;;EyEr2iBM;IAOI,4BAAA;EzEk2iBV;;EyEz2iBM;IAOI,+BAAA;EzEs2iBV;;EyE72iBM;IAOI,8BAAA;EzE02iBV;;EyEj3iBM;IAOI,+BAAA;EzE82iBV;;EyEr3iBM;IAOI,4BAAA;EzEk3iBV;;EyEz3iBM;IAOI,4BAAA;EzEs3iBV;;EyE73iBM;IAOI,2BAAA;EzE03iBV;;EyEj4iBM;IAOI,0BAAA;EzE83iBV;;EyEr4iBM;IAOI,2BAAA;EzEk4iBV;;EyEz4iBM;IAOI,wBAAA;EzEs4iBV;;EyE74iBM;IAOI,2BAAA;EzE04iBV;;EyEj5iBM;IAOI,0BAAA;EzE84iBV;;EyEr5iBM;IAOI,2BAAA;EzEk5iBV;;EyEz5iBM;IAOI,wBAAA;EzEs5iBV;;EyE75iBM;IAOI,2BAAA;EzE05iBV;;EyEj6iBM;IAOI,0BAAA;EzE85iBV;;EyEr6iBM;IAOI,2BAAA;EzEk6iBV;;EyEz6iBM;IAOI,wBAAA;EzEs6iBV;;EyE76iBM;IAOI,2BAAA;EzE06iBV;;EyEj7iBM;IAOI,0BAAA;EzE86iBV;;EyEr7iBM;IAOI,2BAAA;EzEk7iBV;;EyEz7iBM;IAOI,wBAAA;EzEs7iBV;;EyE77iBM;IAOI,2BAAA;EzE07iBV;;EyEj8iBM;IAOI,0BAAA;EzE87iBV;;EyEr8iBM;IAOI,2BAAA;EzEk8iBV;;EyEz8iBM;IAOI,wBAAA;EzEs8iBV;;EyE78iBM;IAOI,iCAAA;IAAA,gCAAA;EzE28iBV;;EyEl9iBM;IAOI,gCAAA;IAAA,+BAAA;EzEg9iBV;;EyEv9iBM;IAOI,iCAAA;IAAA,gCAAA;EzEq9iBV;;EyE59iBM;IAOI,8BAAA;IAAA,6BAAA;EzE09iBV;;EyEj+iBM;IAOI,iCAAA;IAAA,gCAAA;EzE+9iBV;;EyEt+iBM;IAOI,gCAAA;IAAA,+BAAA;EzEo+iBV;;EyE3+iBM;IAOI,iCAAA;IAAA,gCAAA;EzEy+iBV;;EyEh/iBM;IAOI,8BAAA;IAAA,6BAAA;EzE8+iBV;;EyEr/iBM;IAOI,iCAAA;IAAA,gCAAA;EzEm/iBV;;EyE1/iBM;IAOI,gCAAA;IAAA,+BAAA;EzEw/iBV;;EyE//iBM;IAOI,iCAAA;IAAA,gCAAA;EzE6/iBV;;EyEpgjBM;IAOI,8BAAA;IAAA,6BAAA;EzEkgjBV;;EyEzgjBM;IAOI,iCAAA;IAAA,gCAAA;EzEugjBV;;EyE9gjBM;IAOI,gCAAA;IAAA,+BAAA;EzE4gjBV;;EyEnhjBM;IAOI,iCAAA;IAAA,gCAAA;EzEihjBV;;EyExhjBM;IAOI,8BAAA;IAAA,6BAAA;EzEshjBV;;EyE7hjBM;IAOI,iCAAA;IAAA,gCAAA;EzE2hjBV;;EyElijBM;IAOI,gCAAA;IAAA,+BAAA;EzEgijBV;;EyEvijBM;IAOI,iCAAA;IAAA,gCAAA;EzEqijBV;;EyE5ijBM;IAOI,8BAAA;IAAA,6BAAA;EzE0ijBV;;EyEjjjBM;IAOI,+BAAA;IAAA,kCAAA;EzE+ijBV;;EyEtjjBM;IAOI,8BAAA;IAAA,iCAAA;EzEojjBV;;EyE3jjBM;IAOI,+BAAA;IAAA,kCAAA;EzEyjjBV;;EyEhkjBM;IAOI,4BAAA;IAAA,+BAAA;EzE8jjBV;;EyErkjBM;IAOI,+BAAA;IAAA,kCAAA;EzEmkjBV;;EyE1kjBM;IAOI,8BAAA;IAAA,iCAAA;EzEwkjBV;;EyE/kjBM;IAOI,+BAAA;IAAA,kCAAA;EzE6kjBV;;EyEpljBM;IAOI,4BAAA;IAAA,+BAAA;EzEkljBV;;EyEzljBM;IAOI,+BAAA;IAAA,kCAAA;EzEuljBV;;EyE9ljBM;IAOI,8BAAA;IAAA,iCAAA;EzE4ljBV;;EyEnmjBM;IAOI,+BAAA;IAAA,kCAAA;EzEimjBV;;EyExmjBM;IAOI,4BAAA;IAAA,+BAAA;EzEsmjBV;;EyE7mjBM;IAOI,+BAAA;IAAA,kCAAA;EzE2mjBV;;EyElnjBM;IAOI,8BAAA;IAAA,iCAAA;EzEgnjBV;;EyEvnjBM;IAOI,+BAAA;IAAA,kCAAA;EzEqnjBV;;EyE5njBM;IAOI,4BAAA;IAAA,+BAAA;EzE0njBV;;EyEjojBM;IAOI,+BAAA;IAAA,kCAAA;EzE+njBV;;EyEtojBM;IAOI,8BAAA;IAAA,iCAAA;EzEoojBV;;EyE3ojBM;IAOI,+BAAA;IAAA,kCAAA;EzEyojBV;;EyEhpjBM;IAOI,4BAAA;IAAA,+BAAA;EzE8ojBV;;EyErpjBM;IAOI,+BAAA;EzEkpjBV;;EyEzpjBM;IAOI,8BAAA;EzEspjBV;;EyE7pjBM;IAOI,+BAAA;EzE0pjBV;;EyEjqjBM;IAOI,4BAAA;EzE8pjBV;;EyErqjBM;IAOI,+BAAA;EzEkqjBV;;EyEzqjBM;IAOI,8BAAA;EzEsqjBV;;EyE7qjBM;IAOI,+BAAA;EzE0qjBV;;EyEjrjBM;IAOI,4BAAA;EzE8qjBV;;EyErrjBM;IAOI,+BAAA;EzEkrjBV;;EyEzrjBM;IAOI,8BAAA;EzEsrjBV;;EyE7rjBM;IAOI,+BAAA;EzE0rjBV;;EyEjsjBM;IAOI,4BAAA;EzE8rjBV;;EyErsjBM;IAOI,+BAAA;EzEksjBV;;EyEzsjBM;IAOI,8BAAA;EzEssjBV;;EyE7sjBM;IAOI,+BAAA;EzE0sjBV;;EyEjtjBM;IAOI,4BAAA;EzE8sjBV;;EyErtjBM;IAOI,+BAAA;EzEktjBV;;EyEztjBM;IAOI,8BAAA;EzEstjBV;;EyE7tjBM;IAOI,+BAAA;EzE0tjBV;;EyEjujBM;IAOI,4BAAA;EzE8tjBV;;EyErujBM;IAOI,iCAAA;EzEkujBV;;EyEzujBM;IAOI,gCAAA;EzEsujBV;;EyE7ujBM;IAOI,iCAAA;EzE0ujBV;;EyEjvjBM;IAOI,8BAAA;EzE8ujBV;;EyErvjBM;IAOI,iCAAA;EzEkvjBV;;EyEzvjBM;IAOI,gCAAA;EzEsvjBV;;EyE7vjBM;IAOI,iCAAA;EzE0vjBV;;EyEjwjBM;IAOI,8BAAA;EzE8vjBV;;EyErwjBM;IAOI,iCAAA;EzEkwjBV;;EyEzwjBM;IAOI,gCAAA;EzEswjBV;;EyE7wjBM;IAOI,iCAAA;EzE0wjBV;;EyEjxjBM;IAOI,8BAAA;EzE8wjBV;;EyErxjBM;IAOI,iCAAA;EzEkxjBV;;EyEzxjBM;IAOI,gCAAA;EzEsxjBV;;EyE7xjBM;IAOI,iCAAA;EzE0xjBV;;EyEjyjBM;IAOI,8BAAA;EzE8xjBV;;EyEryjBM;IAOI,iCAAA;EzEkyjBV;;EyEzyjBM;IAOI,gCAAA;EzEsyjBV;;EyE7yjBM;IAOI,iCAAA;EzE0yjBV;;EyEjzjBM;IAOI,8BAAA;EzE8yjBV;;EyErzjBM;IAOI,kCAAA;EzEkzjBV;;EyEzzjBM;IAOI,iCAAA;EzEszjBV;;EyE7zjBM;IAOI,kCAAA;EzE0zjBV;;EyEj0jBM;IAOI,+BAAA;EzE8zjBV;;EyEr0jBM;IAOI,kCAAA;EzEk0jBV;;EyEz0jBM;IAOI,iCAAA;EzEs0jBV;;EyE70jBM;IAOI,kCAAA;EzE00jBV;;EyEj1jBM;IAOI,+BAAA;EzE80jBV;;EyEr1jBM;IAOI,kCAAA;EzEk1jBV;;EyEz1jBM;IAOI,iCAAA;EzEs1jBV;;EyE71jBM;IAOI,kCAAA;EzE01jBV;;EyEj2jBM;IAOI,+BAAA;EzE81jBV;;EyEr2jBM;IAOI,kCAAA;EzEk2jBV;;EyEz2jBM;IAOI,iCAAA;EzEs2jBV;;EyE72jBM;IAOI,kCAAA;EzE02jBV;;EyEj3jBM;IAOI,+BAAA;EzE82jBV;;EyEr3jBM;IAOI,kCAAA;EzEk3jBV;;EyEz3jBM;IAOI,iCAAA;EzEs3jBV;;EyE73jBM;IAOI,kCAAA;EzE03jBV;;EyEj4jBM;IAOI,+BAAA;EzE83jBV;;EyEr4jBM;IAOI,gCAAA;EzEk4jBV;;EyEz4jBM;IAOI,+BAAA;EzEs4jBV;;EyE74jBM;IAOI,gCAAA;EzE04jBV;;EyEj5jBM;IAOI,6BAAA;EzE84jBV;;EyEr5jBM;IAOI,gCAAA;EzEk5jBV;;EyEz5jBM;IAOI,+BAAA;EzEs5jBV;;EyE75jBM;IAOI,gCAAA;EzE05jBV;;EyEj6jBM;IAOI,6BAAA;EzE85jBV;;EyEr6jBM;IAOI,gCAAA;EzEk6jBV;;EyEz6jBM;IAOI,+BAAA;EzEs6jBV;;EyE76jBM;IAOI,gCAAA;EzE06jBV;;EyEj7jBM;IAOI,6BAAA;EzE86jBV;;EyEr7jBM;IAOI,gCAAA;EzEk7jBV;;EyEz7jBM;IAOI,+BAAA;EzEs7jBV;;EyE77jBM;IAOI,gCAAA;EzE07jBV;;EyEj8jBM;IAOI,6BAAA;EzE87jBV;;EyEr8jBM;IAOI,gCAAA;EzEk8jBV;;EyEz8jBM;IAOI,+BAAA;EzEs8jBV;;EyE78jBM;IAOI,gCAAA;EzE08jBV;;EyEj9jBM;IAOI,6BAAA;EzE88jBV;;EyEr9jBM;IAOI,qBAAA;EzEk9jBV;;EyEz9jBM;IAOI,2BAAA;EzEs9jBV;;EyE79jBM;IAOI,0BAAA;EzE09jBV;;EyEj+jBM;IAOI,2BAAA;EzE89jBV;;EyEr+jBM;IAOI,wBAAA;EzEk+jBV;;EyEz+jBM;IAOI,2BAAA;EzEs+jBV;;EyE7+jBM;IAOI,0BAAA;EzE0+jBV;;EyEj/jBM;IAOI,2BAAA;EzE8+jBV;;EyEr/jBM;IAOI,wBAAA;EzEk/jBV;;EyEz/jBM;IAOI,2BAAA;EzEs/jBV;;EyE7/jBM;IAOI,0BAAA;EzE0/jBV;;EyEjgkBM;IAOI,2BAAA;EzE8/jBV;;EyErgkBM;IAOI,wBAAA;EzEkgkBV;;EyEzgkBM;IAOI,2BAAA;EzEsgkBV;;EyE7gkBM;IAOI,0BAAA;EzE0gkBV;;EyEjhkBM;IAOI,2BAAA;EzE8gkBV;;EyErhkBM;IAOI,wBAAA;EzEkhkBV;;EyEzhkBM;IAOI,2BAAA;EzEshkBV;;EyE7hkBM;IAOI,0BAAA;EzE0hkBV;;EyEjikBM;IAOI,2BAAA;EzE8hkBV;;EyErikBM;IAOI,wBAAA;EzEkikBV;;EyEzikBM;IAOI,2BAAA;IAAA,0BAAA;EzEuikBV;;EyE9ikBM;IAOI,iCAAA;IAAA,gCAAA;EzE4ikBV;;EyEnjkBM;IAOI,gCAAA;IAAA,+BAAA;EzEijkBV;;EyExjkBM;IAOI,iCAAA;IAAA,gCAAA;EzEsjkBV;;EyE7jkBM;IAOI,8BAAA;IAAA,6BAAA;EzE2jkBV;;EyElkkBM;IAOI,iCAAA;IAAA,gCAAA;EzEgkkBV;;EyEvkkBM;IAOI,gCAAA;IAAA,+BAAA;EzEqkkBV;;EyE5kkBM;IAOI,iCAAA;IAAA,gCAAA;EzE0kkBV;;EyEjlkBM;IAOI,8BAAA;IAAA,6BAAA;EzE+kkBV;;EyEtlkBM;IAOI,iCAAA;IAAA,gCAAA;EzEolkBV;;EyE3lkBM;IAOI,gCAAA;IAAA,+BAAA;EzEylkBV;;EyEhmkBM;IAOI,iCAAA;IAAA,gCAAA;EzE8lkBV;;EyErmkBM;IAOI,8BAAA;IAAA,6BAAA;EzEmmkBV;;EyE1mkBM;IAOI,iCAAA;IAAA,gCAAA;EzEwmkBV;;EyE/mkBM;IAOI,gCAAA;IAAA,+BAAA;EzE6mkBV;;EyEpnkBM;IAOI,iCAAA;IAAA,gCAAA;EzEknkBV;;EyEznkBM;IAOI,8BAAA;IAAA,6BAAA;EzEunkBV;;EyE9nkBM;IAOI,iCAAA;IAAA,gCAAA;EzE4nkBV;;EyEnokBM;IAOI,gCAAA;IAAA,+BAAA;EzEiokBV;;EyExokBM;IAOI,iCAAA;IAAA,gCAAA;EzEsokBV;;EyE7okBM;IAOI,8BAAA;IAAA,6BAAA;EzE2okBV;;EyElpkBM;IAOI,yBAAA;IAAA,4BAAA;EzEgpkBV;;EyEvpkBM;IAOI,+BAAA;IAAA,kCAAA;EzEqpkBV;;EyE5pkBM;IAOI,8BAAA;IAAA,iCAAA;EzE0pkBV;;EyEjqkBM;IAOI,+BAAA;IAAA,kCAAA;EzE+pkBV;;EyEtqkBM;IAOI,4BAAA;IAAA,+BAAA;EzEoqkBV;;EyE3qkBM;IAOI,+BAAA;IAAA,kCAAA;EzEyqkBV;;EyEhrkBM;IAOI,8BAAA;IAAA,iCAAA;EzE8qkBV;;EyErrkBM;IAOI,+BAAA;IAAA,kCAAA;EzEmrkBV;;EyE1rkBM;IAOI,4BAAA;IAAA,+BAAA;EzEwrkBV;;EyE/rkBM;IAOI,+BAAA;IAAA,kCAAA;EzE6rkBV;;EyEpskBM;IAOI,8BAAA;IAAA,iCAAA;EzEkskBV;;EyEzskBM;IAOI,+BAAA;IAAA,kCAAA;EzEuskBV;;EyE9skBM;IAOI,4BAAA;IAAA,+BAAA;EzE4skBV;;EyEntkBM;IAOI,+BAAA;IAAA,kCAAA;EzEitkBV;;EyExtkBM;IAOI,8BAAA;IAAA,iCAAA;EzEstkBV;;EyE7tkBM;IAOI,+BAAA;IAAA,kCAAA;EzE2tkBV;;EyElukBM;IAOI,4BAAA;IAAA,+BAAA;EzEgukBV;;EyEvukBM;IAOI,+BAAA;IAAA,kCAAA;EzEqukBV;;EyE5ukBM;IAOI,8BAAA;IAAA,iCAAA;EzE0ukBV;;EyEjvkBM;IAOI,+BAAA;IAAA,kCAAA;EzE+ukBV;;EyEtvkBM;IAOI,4BAAA;IAAA,+BAAA;EzEovkBV;;EyE3vkBM;IAOI,yBAAA;EzEwvkBV;;EyE/vkBM;IAOI,+BAAA;EzE4vkBV;;EyEnwkBM;IAOI,8BAAA;EzEgwkBV;;EyEvwkBM;IAOI,+BAAA;EzEowkBV;;EyE3wkBM;IAOI,4BAAA;EzEwwkBV;;EyE/wkBM;IAOI,+BAAA;EzE4wkBV;;EyEnxkBM;IAOI,8BAAA;EzEgxkBV;;EyEvxkBM;IAOI,+BAAA;EzEoxkBV;;EyE3xkBM;IAOI,4BAAA;EzEwxkBV;;EyE/xkBM;IAOI,+BAAA;EzE4xkBV;;EyEnykBM;IAOI,8BAAA;EzEgykBV;;EyEvykBM;IAOI,+BAAA;EzEoykBV;;EyE3ykBM;IAOI,4BAAA;EzEwykBV;;EyE/ykBM;IAOI,+BAAA;EzE4ykBV;;EyEnzkBM;IAOI,8BAAA;EzEgzkBV;;EyEvzkBM;IAOI,+BAAA;EzEozkBV;;EyE3zkBM;IAOI,4BAAA;EzEwzkBV;;EyE/zkBM;IAOI,+BAAA;EzE4zkBV;;EyEn0kBM;IAOI,8BAAA;EzEg0kBV;;EyEv0kBM;IAOI,+BAAA;EzEo0kBV;;EyE30kBM;IAOI,4BAAA;EzEw0kBV;;EyE/0kBM;IAOI,2BAAA;EzE40kBV;;EyEn1kBM;IAOI,iCAAA;EzEg1kBV;;EyEv1kBM;IAOI,gCAAA;EzEo1kBV;;EyE31kBM;IAOI,iCAAA;EzEw1kBV;;EyE/1kBM;IAOI,8BAAA;EzE41kBV;;EyEn2kBM;IAOI,iCAAA;EzEg2kBV;;EyEv2kBM;IAOI,gCAAA;EzEo2kBV;;EyE32kBM;IAOI,iCAAA;EzEw2kBV;;EyE/2kBM;IAOI,8BAAA;EzE42kBV;;EyEn3kBM;IAOI,iCAAA;EzEg3kBV;;EyEv3kBM;IAOI,gCAAA;EzEo3kBV;;EyE33kBM;IAOI,iCAAA;EzEw3kBV;;EyE/3kBM;IAOI,8BAAA;EzE43kBV;;EyEn4kBM;IAOI,iCAAA;EzEg4kBV;;EyEv4kBM;IAOI,gCAAA;EzEo4kBV;;EyE34kBM;IAOI,iCAAA;EzEw4kBV;;EyE/4kBM;IAOI,8BAAA;EzE44kBV;;EyEn5kBM;IAOI,iCAAA;EzEg5kBV;;EyEv5kBM;IAOI,gCAAA;EzEo5kBV;;EyE35kBM;IAOI,iCAAA;EzEw5kBV;;EyE/5kBM;IAOI,8BAAA;EzE45kBV;;EyEn6kBM;IAOI,4BAAA;EzEg6kBV;;EyEv6kBM;IAOI,kCAAA;EzEo6kBV;;EyE36kBM;IAOI,iCAAA;EzEw6kBV;;EyE/6kBM;IAOI,kCAAA;EzE46kBV;;EyEn7kBM;IAOI,+BAAA;EzEg7kBV;;EyEv7kBM;IAOI,kCAAA;EzEo7kBV;;EyE37kBM;IAOI,iCAAA;EzEw7kBV;;EyE/7kBM;IAOI,kCAAA;EzE47kBV;;EyEn8kBM;IAOI,+BAAA;EzEg8kBV;;EyEv8kBM;IAOI,kCAAA;EzEo8kBV;;EyE38kBM;IAOI,iCAAA;EzEw8kBV;;EyE/8kBM;IAOI,kCAAA;EzE48kBV;;EyEn9kBM;IAOI,+BAAA;EzEg9kBV;;EyEv9kBM;IAOI,kCAAA;EzEo9kBV;;EyE39kBM;IAOI,iCAAA;EzEw9kBV;;EyE/9kBM;IAOI,kCAAA;EzE49kBV;;EyEn+kBM;IAOI,+BAAA;EzEg+kBV;;EyEv+kBM;IAOI,kCAAA;EzEo+kBV;;EyE3+kBM;IAOI,iCAAA;EzEw+kBV;;EyE/+kBM;IAOI,kCAAA;EzE4+kBV;;EyEn/kBM;IAOI,+BAAA;EzEg/kBV;;EyEv/kBM;IAOI,0BAAA;EzEo/kBV;;EyE3/kBM;IAOI,gCAAA;EzEw/kBV;;EyE//kBM;IAOI,+BAAA;EzE4/kBV;;EyEnglBM;IAOI,gCAAA;EzEgglBV;;EyEvglBM;IAOI,6BAAA;EzEoglBV;;EyE3glBM;IAOI,gCAAA;EzEwglBV;;EyE/glBM;IAOI,+BAAA;EzE4glBV;;EyEnhlBM;IAOI,gCAAA;EzEghlBV;;EyEvhlBM;IAOI,6BAAA;EzEohlBV;;EyE3hlBM;IAOI,gCAAA;EzEwhlBV;;EyE/hlBM;IAOI,+BAAA;EzE4hlBV;;EyEnilBM;IAOI,gCAAA;EzEgilBV;;EyEvilBM;IAOI,6BAAA;EzEoilBV;;EyE3ilBM;IAOI,gCAAA;EzEwilBV;;EyE/ilBM;IAOI,+BAAA;EzE4ilBV;;EyEnjlBM;IAOI,gCAAA;EzEgjlBV;;EyEvjlBM;IAOI,6BAAA;EzEojlBV;;EyE3jlBM;IAOI,gCAAA;EzEwjlBV;;EyE/jlBM;IAOI,+BAAA;EzE4jlBV;;EyEnklBM;IAOI,gCAAA;EzEgklBV;;EyEvklBM;IAOI,6BAAA;EzEoklBV;;EyE3klBM;IAOI,iBAAA;EzEwklBV;;EyE/klBM;IAOI,uBAAA;EzE4klBV;;EyEnllBM;IAOI,sBAAA;EzEgllBV;;EyEvllBM;IAOI,uBAAA;EzEollBV;;EyE3llBM;IAOI,oBAAA;EzEwllBV;;EyE/llBM;IAOI,uBAAA;EzE4llBV;;EyEnmlBM;IAOI,sBAAA;EzEgmlBV;;EyEvmlBM;IAOI,uBAAA;EzEomlBV;;EyE3mlBM;IAOI,oBAAA;EzEwmlBV;;EyE/mlBM;IAOI,uBAAA;EzE4mlBV;;EyEnnlBM;IAOI,sBAAA;EzEgnlBV;;EyEvnlBM;IAOI,uBAAA;EzEonlBV;;EyE3nlBM;IAOI,oBAAA;EzEwnlBV;;EyE/nlBM;IAOI,uBAAA;EzE4nlBV;;EyEnolBM;IAOI,sBAAA;EzEgolBV;;EyEvolBM;IAOI,uBAAA;EzEoolBV;;EyE3olBM;IAOI,oBAAA;EzEwolBV;;EyE/olBM;IAOI,uBAAA;EzE4olBV;;EyEnplBM;IAOI,sBAAA;EzEgplBV;;EyEvplBM;IAOI,uBAAA;EzEoplBV;;EyE3plBM;IAOI,oBAAA;EzEwplBV;;EyE/plBM;IAOI,0CAAA;EzE4plBV;;EyEnqlBM;IAOI,4CAAA;EzEgqlBV;;EyEvqlBM;IAOI,4CAAA;EzEoqlBV;;EyE3qlBM;IAOI,6BAAA;EzEwqlBV;;EyE/qlBM;IAOI,6BAAA;EzE4qlBV;;EyEnrlBM;IAOI,8BAAA;EzEgrlBV;;EyEvrlBM;IAOI,6BAAA;EzEorlBV;;EyE3rlBM;IAOI,6BAAA;EzEwrlBV;;EyE/rlBM;IAOI,6BAAA;EzE4rlBV;;EyEnslBM;IAOI,4BAAA;EzEgslBV;;EyEvslBM;IAOI,0BAAA;EzEoslBV;;EyE3slBM;IAOI,0BAAA;EzEwslBV;;EyE/slBM;IAOI,4CAAA;EzE4slBV;;EyEntlBM;IAOI,2CAAA;EzEgtlBV;;EyEvtlBM;IAOI,4CAAA;EzEotlBV;;EyE3tlBM;IAOI,0CAAA;EzEwtlBV;;EyE/tlBM;IAOI,4CAAA;EzE4tlBV;;EyEnulBM;IAOI,2CAAA;EzEgulBV;;EyEvulBM;IAOI,4CAAA;EzEoulBV;;EyE3ulBM;IAOI,wCAAA;EzEwulBV;;EyE/ulBM;IAOI,4CAAA;EzE4ulBV;;EyEnvlBM;IAOI,2CAAA;EzEgvlBV;;EyEvvlBM;IAOI,4CAAA;EzEovlBV;;EyE3vlBM;IAOI,0CAAA;EzEwvlBV;;EyE/vlBM;IAOI,4CAAA;EzE4vlBV;;EyEnwlBM;IAOI,2CAAA;EzEgwlBV;;EyEvwlBM;IAOI,4CAAA;EzEowlBV;;EyE3wlBM;IAOI,0CAAA;EzEwwlBV;;EyE/wlBM;IAOI,2BAAA;EzE4wlBV;;EyEnxlBM;IAOI,4BAAA;EzEgxlBV;;EyEvxlBM;IAOI,6BAAA;EzEoxlBV;;EyE3xlBM;IAOI,2BAAA;EzEwxlBV;;EyE/xlBM;IAOI,yBAAA;EzE4xlBV;;EyEnylBM;IAOI,yBAAA;EzEgylBV;;EyEvylBM;IAOI,yBAAA;EzEoylBV;;EyE3ylBM;IAOI,0BAAA;EzEwylBV;;EyE/ylBM;IAOI,0BAAA;EzE4ylBV;;EyEnzlBM;IAOI,yBAAA;EzEgzlBV;;EyEvzlBM;IAOI,yBAAA;EzEozlBV;;EyE3zlBM;IAOI,yBAAA;EzEwzlBV;;EyE/zlBM;IAOI,yBAAA;EzE4zlBV;;EyEn0lBM;IAOI,yBAAA;EzEg0lBV;;EyEv0lBM;IAOI,yBAAA;EzEo0lBV;;EyE30lBM;IAOI,yBAAA;EzEw0lBV;;EyE/0lBM;IAOI,yBAAA;EzE40lBV;;EyEn1lBM;IAOI,yBAAA;EzEg1lBV;;EyEv1lBM;IAOI,0BAAA;EzEo1lBV;;EyE31lBM;IAOI,0BAAA;EzEw1lBV;;EyE/1lBM;IAOI,0BAAA;EzE41lBV;;EyEn2lBM;IAOI,0BAAA;EzEg2lBV;;EyEv2lBM;IAOI,0BAAA;EzEo2lBV;;EyE32lBM;IAOI,0BAAA;EzEw2lBV;;EyE/2lBM;IAOI,0BAAA;EzE42lBV;;EyEn3lBM;IAOI,0BAAA;EzEg3lBV;;EyEv3lBM;IAOI,0BAAA;EzEo3lBV;;EyE33lBM;IAOI,0BAAA;EzEw3lBV;;EyE/3lBM;IAOI,0BAAA;EzE43lBV;;EyEn4lBM;IAOI,0BAAA;EzEg4lBV;;EyEv4lBM;IAOI,0BAAA;EzEo4lBV;;EyE34lBM;IAOI,0BAAA;EzEw4lBV;;EyE/4lBM;IAOI,0BAAA;EzE44lBV;;EyEn5lBM;IAOI,0BAAA;EzEg5lBV;;EyEv5lBM;IAOI,0BAAA;EzEo5lBV;;EyE35lBM;IAOI,0BAAA;EzEw5lBV;;EyE/5lBM;IAOI,2BAAA;EzE45lBV;;EyEn6lBM;IAOI,2BAAA;EzEg6lBV;;EyEv6lBM;IAOI,2BAAA;EzEo6lBV;;EyE36lBM;IAOI,2BAAA;EzEw6lBV;;EyE/6lBM;IAOI,2BAAA;EzE46lBV;;EyEn7lBM;IAOI,2BAAA;EzEg7lBV;;EyEv7lBM;IAOI,2BAAA;EzEo7lBV;;EyE37lBM;IAOI,2BAAA;EzEw7lBV;;EyE/7lBM;IAOI,2BAAA;EzE47lBV;;EyEn8lBM;IAOI,2BAAA;EzEg8lBV;;EyEv8lBM;IAOI,2BAAA;EzEo8lBV;;EyE38lBM;IAOI,2BAAA;EzEw8lBV;;EyE/8lBM;IAOI,2BAAA;EzE48lBV;;EyEn9lBM;IAOI,2BAAA;EzEg9lBV;;EyEv9lBM;IAOI,2BAAA;EzEo9lBV;;EyE39lBM;IAOI,2BAAA;EzEw9lBV;;EyE/9lBM;IAOI,2BAAA;EzE49lBV;;EyEn+lBM;IAOI,2BAAA;EzEg+lBV;;EyEv+lBM;IAOI,2BAAA;EzEo+lBV;;EyE3+lBM;IAOI,2BAAA;EzEw+lBV;;EyE/+lBM;IAOI,2BAAA;EzE4+lBV;;EyEn/lBM;IAOI,2BAAA;EzEg/lBV;;EyEv/lBM;IAOI,2BAAA;EzEo/lBV;;EyE3/lBM;IAOI,2BAAA;EzEw/lBV;;EyE//lBM;IAOI,2BAAA;EzE4/lBV;;EyEngmBM;IAOI,2BAAA;EzEggmBV;;EyEvgmBM;IAOI,4BAAA;EzEogmBV;;EyE3gmBM;IAOI,4BAAA;EzEwgmBV;;EyE/gmBM;IAOI,0BAAA;EzE4gmBV;;EyEnhmBM;IAOI,0BAAA;EzEghmBV;;EyEvhmBM;IAOI,0BAAA;EzEohmBV;;EyE3hmBM;IAOI,2BAAA;EzEwhmBV;;EyE/hmBM;IAOI,2BAAA;EzE4hmBV;;EyEnimBM;IAOI,0BAAA;EzEgimBV;;EyEvimBM;IAOI,0BAAA;EzEoimBV;;EyE3imBM;IAOI,0BAAA;EzEwimBV;;EyE/imBM;IAOI,0BAAA;EzE4imBV;;EyEnjmBM;IAOI,0BAAA;EzEgjmBV;;EyEvjmBM;IAOI,0BAAA;EzEojmBV;;EyE3jmBM;IAOI,0BAAA;EzEwjmBV;;EyE/jmBM;IAOI,0BAAA;EzE4jmBV;;EyEnkmBM;IAOI,0BAAA;EzEgkmBV;;EyEvkmBM;IAOI,2BAAA;EzEokmBV;;EyE3kmBM;IAOI,2BAAA;EzEwkmBV;;EyE/kmBM;IAOI,2BAAA;EzE4kmBV;;EyEnlmBM;IAOI,2BAAA;EzEglmBV;;EyEvlmBM;IAOI,2BAAA;EzEolmBV;;EyE3lmBM;IAOI,2BAAA;EzEwlmBV;;EyE/lmBM;IAOI,2BAAA;EzE4lmBV;;EyEnmmBM;IAOI,2BAAA;EzEgmmBV;;EyEvmmBM;IAOI,2BAAA;EzEommBV;;EyE3mmBM;IAOI,2BAAA;EzEwmmBV;;EyE/mmBM;IAOI,2BAAA;EzE4mmBV;;EyEnnmBM;IAOI,2BAAA;EzEgnmBV;;EyEvnmBM;IAOI,2BAAA;EzEonmBV;;EyE3nmBM;IAOI,2BAAA;EzEwnmBV;;EyE/nmBM;IAOI,2BAAA;EzE4nmBV;;EyEnomBM;IAOI,2BAAA;EzEgomBV;;EyEvomBM;IAOI,2BAAA;EzEoomBV;;EyE3omBM;IAOI,2BAAA;EzEwomBV;;EyE/omBM;IAOI,4BAAA;EzE4omBV;;EyEnpmBM;IAOI,4BAAA;EzEgpmBV;;EyEvpmBM;IAOI,4BAAA;EzEopmBV;;EyE3pmBM;IAOI,4BAAA;EzEwpmBV;;EyE/pmBM;IAOI,4BAAA;EzE4pmBV;;EyEnqmBM;IAOI,4BAAA;EzEgqmBV;;EyEvqmBM;IAOI,4BAAA;EzEoqmBV;;EyE3qmBM;IAOI,4BAAA;EzEwqmBV;;EyE/qmBM;IAOI,4BAAA;EzE4qmBV;;EyEnrmBM;IAOI,4BAAA;EzEgrmBV;;EyEvrmBM;IAOI,4BAAA;EzEormBV;;EyE3rmBM;IAOI,4BAAA;EzEwrmBV;;EyE/rmBM;IAOI,4BAAA;EzE4rmBV;;EyEnsmBM;IAOI,4BAAA;EzEgsmBV;;EyEvsmBM;IAOI,4BAAA;EzEosmBV;;EyE3smBM;IAOI,4BAAA;EzEwsmBV;;EyE/smBM;IAOI,4BAAA;EzE4smBV;;EyEntmBM;IAOI,4BAAA;EzEgtmBV;;EyEvtmBM;IAOI,4BAAA;EzEotmBV;;EyE3tmBM;IAOI,4BAAA;EzEwtmBV;;EyE/tmBM;IAOI,4BAAA;EzE4tmBV;;EyEnumBM;IAOI,4BAAA;EzEgumBV;;EyEvumBM;IAOI,4BAAA;EzEoumBV;;EyE3umBM;IAOI,4BAAA;EzEwumBV;;EyE/umBM;IAOI,4BAAA;EzE4umBV;;EyEnvmBM;IAOI,4BAAA;EzEgvmBV;;EyEvvmBM;IAOI,6BAAA;EzEovmBV;AACF;Ae/vmBI;E0DGI;IAOI,sBAAA;EzEyvmBV;;EyEhwmBM;IAOI,uBAAA;EzE6vmBV;;EyEpwmBM;IAOI,sBAAA;EzEiwmBV;;EyExwmBM;IAOI,0BAAA;EzEqwmBV;;EyE5wmBM;IAOI,gCAAA;EzEywmBV;;EyEhxmBM;IAOI,yBAAA;EzE6wmBV;;EyEpxmBM;IAOI,wBAAA;EzEixmBV;;EyExxmBM;IAOI,yBAAA;EzEqxmBV;;EyE5xmBM;IAOI,6BAAA;EzEyxmBV;;EyEhymBM;IAOI,8BAAA;EzE6xmBV;;EyEpymBM;IAOI,wBAAA;EzEiymBV;;EyExymBM;IAOI,+BAAA;EzEqymBV;;EyE5ymBM;IAOI,wBAAA;EzEyymBV;;EyEhzmBM;IAOI,2BAAA;EzE6ymBV;;EyEpzmBM;IAOI,6BAAA;EzEizmBV;;EyExzmBM;IAOI,6BAAA;EzEqzmBV;;EyE5zmBM;IAOI,0BAAA;EzEyzmBV;;EyEh0mBM;IAOI,2BAAA;EzE6zmBV;;EyEp0mBM;IAOI,uBAAA;EzEi0mBV;;EyEx0mBM;IAOI,qBAAA;EzEq0mBV;;EyE50mBM;IAOI,qBAAA;EzEy0mBV;;EyEh1mBM;IAOI,qBAAA;EzE60mBV;;EyEp1mBM;IAOI,sBAAA;EzEi1mBV;;EyEx1mBM;IAOI,sBAAA;EzEq1mBV;;EyE51mBM;IAOI,qBAAA;EzEy1mBV;;EyEh2mBM;IAOI,qBAAA;EzE61mBV;;EyEp2mBM;IAOI,qBAAA;EzEi2mBV;;EyEx2mBM;IAOI,qBAAA;EzEq2mBV;;EyE52mBM;IAOI,qBAAA;EzEy2mBV;;EyEh3mBM;IAOI,qBAAA;EzE62mBV;;EyEp3mBM;IAOI,qBAAA;EzEi3mBV;;EyEx3mBM;IAOI,qBAAA;EzEq3mBV;;EyE53mBM;IAOI,qBAAA;EzEy3mBV;;EyEh4mBM;IAOI,sBAAA;EzE63mBV;;EyEp4mBM;IAOI,sBAAA;EzEi4mBV;;EyEx4mBM;IAOI,sBAAA;EzEq4mBV;;EyE54mBM;IAOI,sBAAA;EzEy4mBV;;EyEh5mBM;IAOI,sBAAA;EzE64mBV;;EyEp5mBM;IAOI,sBAAA;EzEi5mBV;;EyEx5mBM;IAOI,sBAAA;EzEq5mBV;;EyE55mBM;IAOI,sBAAA;EzEy5mBV;;EyEh6mBM;IAOI,sBAAA;EzE65mBV;;EyEp6mBM;IAOI,sBAAA;EzEi6mBV;;EyEx6mBM;IAOI,sBAAA;EzEq6mBV;;EyE56mBM;IAOI,sBAAA;EzEy6mBV;;EyEh7mBM;IAOI,sBAAA;EzE66mBV;;EyEp7mBM;IAOI,sBAAA;EzEi7mBV;;EyEx7mBM;IAOI,sBAAA;EzEq7mBV;;EyE57mBM;IAOI,sBAAA;EzEy7mBV;;EyEh8mBM;IAOI,sBAAA;EzE67mBV;;EyEp8mBM;IAOI,sBAAA;EzEi8mBV;;EyEx8mBM;IAOI,uBAAA;EzEq8mBV;;EyE58mBM;IAOI,uBAAA;EzEy8mBV;;EyEh9mBM;IAOI,uBAAA;EzE68mBV;;EyEp9mBM;IAOI,uBAAA;EzEi9mBV;;EyEx9mBM;IAOI,uBAAA;EzEq9mBV;;EyE59mBM;IAOI,uBAAA;EzEy9mBV;;EyEh+mBM;IAOI,uBAAA;EzE69mBV;;EyEp+mBM;IAOI,uBAAA;EzEi+mBV;;EyEx+mBM;IAOI,uBAAA;EzEq+mBV;;EyE5+mBM;IAOI,uBAAA;EzEy+mBV;;EyEh/mBM;IAOI,uBAAA;EzE6+mBV;;EyEp/mBM;IAOI,uBAAA;EzEi/mBV;;EyEx/mBM;IAOI,uBAAA;EzEq/mBV;;EyE5/mBM;IAOI,uBAAA;EzEy/mBV;;EyEhgnBM;IAOI,uBAAA;EzE6/mBV;;EyEpgnBM;IAOI,uBAAA;EzEignBV;;EyExgnBM;IAOI,uBAAA;EzEqgnBV;;EyE5gnBM;IAOI,uBAAA;EzEygnBV;;EyEhhnBM;IAOI,uBAAA;EzE6gnBV;;EyEphnBM;IAOI,uBAAA;EzEihnBV;;EyExhnBM;IAOI,uBAAA;EzEqhnBV;;EyE5hnBM;IAOI,uBAAA;EzEyhnBV;;EyEhinBM;IAOI,uBAAA;EzE6hnBV;;EyEpinBM;IAOI,uBAAA;EzEiinBV;;EyExinBM;IAOI,uBAAA;EzEqinBV;;EyE5inBM;IAOI,uBAAA;EzEyinBV;;EyEhjnBM;IAOI,wBAAA;EzE6inBV;;EyEpjnBM;IAOI,2BAAA;EzEijnBV;;EyExjnBM;IAOI,yBAAA;EzEqjnBV;;EyE5jnBM;IAOI,yBAAA;EzEyjnBV;;EyEhknBM;IAOI,yBAAA;EzE6jnBV;;EyEpknBM;IAOI,0BAAA;EzEiknBV;;EyExknBM;IAOI,0BAAA;EzEqknBV;;EyE5knBM;IAOI,yBAAA;EzEyknBV;;EyEhlnBM;IAOI,yBAAA;EzE6knBV;;EyEplnBM;IAOI,yBAAA;EzEilnBV;;EyExlnBM;IAOI,yBAAA;EzEqlnBV;;EyE5lnBM;IAOI,yBAAA;EzEylnBV;;EyEhmnBM;IAOI,yBAAA;EzE6lnBV;;EyEpmnBM;IAOI,yBAAA;EzEimnBV;;EyExmnBM;IAOI,yBAAA;EzEqmnBV;;EyE5mnBM;IAOI,yBAAA;EzEymnBV;;EyEhnnBM;IAOI,0BAAA;EzE6mnBV;;EyEpnnBM;IAOI,0BAAA;EzEinnBV;;EyExnnBM;IAOI,0BAAA;EzEqnnBV;;EyE5nnBM;IAOI,0BAAA;EzEynnBV;;EyEhonBM;IAOI,0BAAA;EzE6nnBV;;EyEponBM;IAOI,0BAAA;EzEionBV;;EyExonBM;IAOI,0BAAA;EzEqonBV;;EyE5onBM;IAOI,0BAAA;EzEyonBV;;EyEhpnBM;IAOI,0BAAA;EzE6onBV;;EyEppnBM;IAOI,0BAAA;EzEipnBV;;EyExpnBM;IAOI,0BAAA;EzEqpnBV;;EyE5pnBM;IAOI,0BAAA;EzEypnBV;;EyEhqnBM;IAOI,0BAAA;EzE6pnBV;;EyEpqnBM;IAOI,0BAAA;EzEiqnBV;;EyExqnBM;IAOI,0BAAA;EzEqqnBV;;EyE5qnBM;IAOI,0BAAA;EzEyqnBV;;EyEhrnBM;IAOI,0BAAA;EzE6qnBV;;EyEprnBM;IAOI,0BAAA;EzEirnBV;;EyExrnBM;IAOI,2BAAA;EzEqrnBV;;EyE5rnBM;IAOI,2BAAA;EzEyrnBV;;EyEhsnBM;IAOI,2BAAA;EzE6rnBV;;EyEpsnBM;IAOI,2BAAA;EzEisnBV;;EyExsnBM;IAOI,2BAAA;EzEqsnBV;;EyE5snBM;IAOI,2BAAA;EzEysnBV;;EyEhtnBM;IAOI,2BAAA;EzE6snBV;;EyEptnBM;IAOI,2BAAA;EzEitnBV;;EyExtnBM;IAOI,2BAAA;EzEqtnBV;;EyE5tnBM;IAOI,2BAAA;EzEytnBV;;EyEhunBM;IAOI,2BAAA;EzE6tnBV;;EyEpunBM;IAOI,2BAAA;EzEiunBV;;EyExunBM;IAOI,2BAAA;EzEqunBV;;EyE5unBM;IAOI,2BAAA;EzEyunBV;;EyEhvnBM;IAOI,2BAAA;EzE6unBV;;EyEpvnBM;IAOI,2BAAA;EzEivnBV;;EyExvnBM;IAOI,2BAAA;EzEqvnBV;;EyE5vnBM;IAOI,2BAAA;EzEyvnBV;;EyEhwnBM;IAOI,2BAAA;EzE6vnBV;;EyEpwnBM;IAOI,2BAAA;EzEiwnBV;;EyExwnBM;IAOI,2BAAA;EzEqwnBV;;EyE5wnBM;IAOI,2BAAA;EzEywnBV;;EyEhxnBM;IAOI,2BAAA;EzE6wnBV;;EyEpxnBM;IAOI,2BAAA;EzEixnBV;;EyExxnBM;IAOI,2BAAA;EzEqxnBV;;EyE5xnBM;IAOI,2BAAA;EzEyxnBV;;EyEhynBM;IAOI,4BAAA;EzE6xnBV;;EyEpynBM;IAOI,wBAAA;EzEiynBV;;EyExynBM;IAOI,sBAAA;EzEqynBV;;EyE5ynBM;IAOI,sBAAA;EzEyynBV;;EyEhznBM;IAOI,sBAAA;EzE6ynBV;;EyEpznBM;IAOI,uBAAA;EzEiznBV;;EyExznBM;IAOI,uBAAA;EzEqznBV;;EyE5znBM;IAOI,sBAAA;EzEyznBV;;EyEh0nBM;IAOI,sBAAA;EzE6znBV;;EyEp0nBM;IAOI,sBAAA;EzEi0nBV;;EyEx0nBM;IAOI,sBAAA;EzEq0nBV;;EyE50nBM;IAOI,sBAAA;EzEy0nBV;;EyEh1nBM;IAOI,sBAAA;EzE60nBV;;EyEp1nBM;IAOI,sBAAA;EzEi1nBV;;EyEx1nBM;IAOI,sBAAA;EzEq1nBV;;EyE51nBM;IAOI,sBAAA;EzEy1nBV;;EyEh2nBM;IAOI,uBAAA;EzE61nBV;;EyEp2nBM;IAOI,uBAAA;EzEi2nBV;;EyEx2nBM;IAOI,uBAAA;EzEq2nBV;;EyE52nBM;IAOI,uBAAA;EzEy2nBV;;EyEh3nBM;IAOI,uBAAA;EzE62nBV;;EyEp3nBM;IAOI,uBAAA;EzEi3nBV;;EyEx3nBM;IAOI,uBAAA;EzEq3nBV;;EyE53nBM;IAOI,uBAAA;EzEy3nBV;;EyEh4nBM;IAOI,uBAAA;EzE63nBV;;EyEp4nBM;IAOI,uBAAA;EzEi4nBV;;EyEx4nBM;IAOI,uBAAA;EzEq4nBV;;EyE54nBM;IAOI,uBAAA;EzEy4nBV;;EyEh5nBM;IAOI,uBAAA;EzE64nBV;;EyEp5nBM;IAOI,uBAAA;EzEi5nBV;;EyEx5nBM;IAOI,uBAAA;EzEq5nBV;;EyE55nBM;IAOI,uBAAA;EzEy5nBV;;EyEh6nBM;IAOI,uBAAA;EzE65nBV;;EyEp6nBM;IAOI,uBAAA;EzEi6nBV;;EyEx6nBM;IAOI,wBAAA;EzEq6nBV;;EyE56nBM;IAOI,wBAAA;EzEy6nBV;;EyEh7nBM;IAOI,wBAAA;EzE66nBV;;EyEp7nBM;IAOI,wBAAA;EzEi7nBV;;EyEx7nBM;IAOI,wBAAA;EzEq7nBV;;EyE57nBM;IAOI,wBAAA;EzEy7nBV;;EyEh8nBM;IAOI,wBAAA;EzE67nBV;;EyEp8nBM;IAOI,wBAAA;EzEi8nBV;;EyEx8nBM;IAOI,wBAAA;EzEq8nBV;;EyE58nBM;IAOI,wBAAA;EzEy8nBV;;EyEh9nBM;IAOI,wBAAA;EzE68nBV;;EyEp9nBM;IAOI,wBAAA;EzEi9nBV;;EyEx9nBM;IAOI,wBAAA;EzEq9nBV;;EyE59nBM;IAOI,wBAAA;EzEy9nBV;;EyEh+nBM;IAOI,wBAAA;EzE69nBV;;EyEp+nBM;IAOI,wBAAA;EzEi+nBV;;EyEx+nBM;IAOI,wBAAA;EzEq+nBV;;EyE5+nBM;IAOI,wBAAA;EzEy+nBV;;EyEh/nBM;IAOI,wBAAA;EzE6+nBV;;EyEp/nBM;IAOI,wBAAA;EzEi/nBV;;EyEx/nBM;IAOI,wBAAA;EzEq/nBV;;EyE5/nBM;IAOI,wBAAA;EzEy/nBV;;EyEhgoBM;IAOI,wBAAA;EzE6/nBV;;EyEpgoBM;IAOI,wBAAA;EzEigoBV;;EyExgoBM;IAOI,wBAAA;EzEqgoBV;;EyE5goBM;IAOI,wBAAA;EzEygoBV;;EyEhhoBM;IAOI,yBAAA;EzE6goBV;;EyEphoBM;IAOI,4BAAA;EzEihoBV;;EyExhoBM;IAOI,0BAAA;EzEqhoBV;;EyE5hoBM;IAOI,0BAAA;EzEyhoBV;;EyEhioBM;IAOI,0BAAA;EzE6hoBV;;EyEpioBM;IAOI,2BAAA;EzEiioBV;;EyExioBM;IAOI,2BAAA;EzEqioBV;;EyE5ioBM;IAOI,0BAAA;EzEyioBV;;EyEhjoBM;IAOI,0BAAA;EzE6ioBV;;EyEpjoBM;IAOI,0BAAA;EzEijoBV;;EyExjoBM;IAOI,0BAAA;EzEqjoBV;;EyE5joBM;IAOI,0BAAA;EzEyjoBV;;EyEhkoBM;IAOI,0BAAA;EzE6joBV;;EyEpkoBM;IAOI,0BAAA;EzEikoBV;;EyExkoBM;IAOI,0BAAA;EzEqkoBV;;EyE5koBM;IAOI,0BAAA;EzEykoBV;;EyEhloBM;IAOI,2BAAA;EzE6koBV;;EyEploBM;IAOI,2BAAA;EzEiloBV;;EyExloBM;IAOI,2BAAA;EzEqloBV;;EyE5loBM;IAOI,2BAAA;EzEyloBV;;EyEhmoBM;IAOI,2BAAA;EzE6loBV;;EyEpmoBM;IAOI,2BAAA;EzEimoBV;;EyExmoBM;IAOI,2BAAA;EzEqmoBV;;EyE5moBM;IAOI,2BAAA;EzEymoBV;;EyEhnoBM;IAOI,2BAAA;EzE6moBV;;EyEpnoBM;IAOI,2BAAA;EzEinoBV;;EyExnoBM;IAOI,2BAAA;EzEqnoBV;;EyE5noBM;IAOI,2BAAA;EzEynoBV;;EyEhooBM;IAOI,2BAAA;EzE6noBV;;EyEpooBM;IAOI,2BAAA;EzEiooBV;;EyExooBM;IAOI,2BAAA;EzEqooBV;;EyE5ooBM;IAOI,2BAAA;EzEyooBV;;EyEhpoBM;IAOI,2BAAA;EzE6ooBV;;EyEppoBM;IAOI,2BAAA;EzEipoBV;;EyExpoBM;IAOI,4BAAA;EzEqpoBV;;EyE5poBM;IAOI,4BAAA;EzEypoBV;;EyEhqoBM;IAOI,4BAAA;EzE6poBV;;EyEpqoBM;IAOI,4BAAA;EzEiqoBV;;EyExqoBM;IAOI,4BAAA;EzEqqoBV;;EyE5qoBM;IAOI,4BAAA;EzEyqoBV;;EyEhroBM;IAOI,4BAAA;EzE6qoBV;;EyEproBM;IAOI,4BAAA;EzEiroBV;;EyExroBM;IAOI,4BAAA;EzEqroBV;;EyE5roBM;IAOI,4BAAA;EzEyroBV;;EyEhsoBM;IAOI,4BAAA;EzE6roBV;;EyEpsoBM;IAOI,4BAAA;EzEisoBV;;EyExsoBM;IAOI,4BAAA;EzEqsoBV;;EyE5soBM;IAOI,4BAAA;EzEysoBV;;EyEhtoBM;IAOI,4BAAA;EzE6soBV;;EyEptoBM;IAOI,4BAAA;EzEitoBV;;EyExtoBM;IAOI,4BAAA;EzEqtoBV;;EyE5toBM;IAOI,4BAAA;EzEytoBV;;EyEhuoBM;IAOI,4BAAA;EzE6toBV;;EyEpuoBM;IAOI,4BAAA;EzEiuoBV;;EyExuoBM;IAOI,4BAAA;EzEquoBV;;EyE5uoBM;IAOI,4BAAA;EzEyuoBV;;EyEhvoBM;IAOI,4BAAA;EzE6uoBV;;EyEpvoBM;IAOI,4BAAA;EzEivoBV;;EyExvoBM;IAOI,4BAAA;EzEqvoBV;;EyE5voBM;IAOI,4BAAA;EzEyvoBV;;EyEhwoBM;IAOI,6BAAA;EzE6voBV;;EyEpwoBM;IAOI,yBAAA;EzEiwoBV;;EyExwoBM;IAOI,8BAAA;EzEqwoBV;;EyE5woBM;IAOI,iCAAA;EzEywoBV;;EyEhxoBM;IAOI,sCAAA;EzE6woBV;;EyEpxoBM;IAOI,yCAAA;EzEixoBV;;EyExxoBM;IAOI,uBAAA;EzEqxoBV;;EyE5xoBM;IAOI,uBAAA;EzEyxoBV;;EyEhyoBM;IAOI,yBAAA;EzE6xoBV;;EyEpyoBM;IAOI,yBAAA;EzEiyoBV;;EyExyoBM;IAOI,0BAAA;EzEqyoBV;;EyE5yoBM;IAOI,4BAAA;EzEyyoBV;;EyEhzoBM;IAOI,kCAAA;EzE6yoBV;;EyEpzoBM;IAOI,sCAAA;EzEizoBV;;EyExzoBM;IAOI,oCAAA;EzEqzoBV;;EyE5zoBM;IAOI,kCAAA;EzEyzoBV;;EyEh0oBM;IAOI,yCAAA;EzE6zoBV;;EyEp0oBM;IAOI,wCAAA;EzEi0oBV;;EyEx0oBM;IAOI,wCAAA;EzEq0oBV;;EyE50oBM;IAOI,kCAAA;EzEy0oBV;;EyEh1oBM;IAOI,gCAAA;EzE60oBV;;EyEp1oBM;IAOI,8BAAA;EzEi1oBV;;EyEx1oBM;IAOI,gCAAA;EzEq1oBV;;EyE51oBM;IAOI,+BAAA;EzEy1oBV;;EyEh2oBM;IAOI,oCAAA;EzE61oBV;;EyEp2oBM;IAOI,kCAAA;EzEi2oBV;;EyEx2oBM;IAOI,gCAAA;EzEq2oBV;;EyE52oBM;IAOI,uCAAA;EzEy2oBV;;EyEh3oBM;IAOI,sCAAA;EzE62oBV;;EyEp3oBM;IAOI,iCAAA;EzEi3oBV;;EyEx3oBM;IAOI,2BAAA;EzEq3oBV;;EyE53oBM;IAOI,iCAAA;EzEy3oBV;;EyEh4oBM;IAOI,+BAAA;EzE63oBV;;EyEp4oBM;IAOI,6BAAA;EzEi4oBV;;EyEx4oBM;IAOI,+BAAA;EzEq4oBV;;EyE54oBM;IAOI,8BAAA;EzEy4oBV;;EyEh5oBM;IAOI,oBAAA;EzE64oBV;;EyEp5oBM;IAOI,mBAAA;EzEi5oBV;;EyEx5oBM;IAOI,mBAAA;EzEq5oBV;;EyE55oBM;IAOI,mBAAA;EzEy5oBV;;EyEh6oBM;IAOI,mBAAA;EzE65oBV;;EyEp6oBM;IAOI,mBAAA;EzEi6oBV;;EyEx6oBM;IAOI,mBAAA;EzEq6oBV;;EyE56oBM;IAOI,mBAAA;EzEy6oBV;;EyEh7oBM;IAOI,oBAAA;EzE66oBV;;EyEp7oBM;IAOI,0BAAA;EzEi7oBV;;EyEx7oBM;IAOI,yBAAA;EzEq7oBV;;EyE57oBM;IAOI,0BAAA;EzEy7oBV;;EyEh8oBM;IAOI,uBAAA;EzE67oBV;;EyEp8oBM;IAOI,0BAAA;EzEi8oBV;;EyEx8oBM;IAOI,yBAAA;EzEq8oBV;;EyE58oBM;IAOI,0BAAA;EzEy8oBV;;EyEh9oBM;IAOI,uBAAA;EzE68oBV;;EyEp9oBM;IAOI,0BAAA;EzEi9oBV;;EyEx9oBM;IAOI,yBAAA;EzEq9oBV;;EyE59oBM;IAOI,0BAAA;EzEy9oBV;;EyEh+oBM;IAOI,uBAAA;EzE69oBV;;EyEp+oBM;IAOI,0BAAA;EzEi+oBV;;EyEx+oBM;IAOI,yBAAA;EzEq+oBV;;EyE5+oBM;IAOI,0BAAA;EzEy+oBV;;EyEh/oBM;IAOI,uBAAA;EzE6+oBV;;EyEp/oBM;IAOI,0BAAA;EzEi/oBV;;EyEx/oBM;IAOI,yBAAA;EzEq/oBV;;EyE5/oBM;IAOI,0BAAA;EzEy/oBV;;EyEhgpBM;IAOI,uBAAA;EzE6/oBV;;EyEpgpBM;IAOI,uBAAA;EzEigpBV;;EyExgpBM;IAOI,0BAAA;IAAA,yBAAA;EzEsgpBV;;EyE7gpBM;IAOI,gCAAA;IAAA,+BAAA;EzE2gpBV;;EyElhpBM;IAOI,+BAAA;IAAA,8BAAA;EzEghpBV;;EyEvhpBM;IAOI,gCAAA;IAAA,+BAAA;EzEqhpBV;;EyE5hpBM;IAOI,6BAAA;IAAA,4BAAA;EzE0hpBV;;EyEjipBM;IAOI,gCAAA;IAAA,+BAAA;EzE+hpBV;;EyEtipBM;IAOI,+BAAA;IAAA,8BAAA;EzEoipBV;;EyE3ipBM;IAOI,gCAAA;IAAA,+BAAA;EzEyipBV;;EyEhjpBM;IAOI,6BAAA;IAAA,4BAAA;EzE8ipBV;;EyErjpBM;IAOI,gCAAA;IAAA,+BAAA;EzEmjpBV;;EyE1jpBM;IAOI,+BAAA;IAAA,8BAAA;EzEwjpBV;;EyE/jpBM;IAOI,gCAAA;IAAA,+BAAA;EzE6jpBV;;EyEpkpBM;IAOI,6BAAA;IAAA,4BAAA;EzEkkpBV;;EyEzkpBM;IAOI,gCAAA;IAAA,+BAAA;EzEukpBV;;EyE9kpBM;IAOI,+BAAA;IAAA,8BAAA;EzE4kpBV;;EyEnlpBM;IAOI,gCAAA;IAAA,+BAAA;EzEilpBV;;EyExlpBM;IAOI,6BAAA;IAAA,4BAAA;EzEslpBV;;EyE7lpBM;IAOI,gCAAA;IAAA,+BAAA;EzE2lpBV;;EyElmpBM;IAOI,+BAAA;IAAA,8BAAA;EzEgmpBV;;EyEvmpBM;IAOI,gCAAA;IAAA,+BAAA;EzEqmpBV;;EyE5mpBM;IAOI,6BAAA;IAAA,4BAAA;EzE0mpBV;;EyEjnpBM;IAOI,6BAAA;IAAA,4BAAA;EzE+mpBV;;EyEtnpBM;IAOI,wBAAA;IAAA,2BAAA;EzEonpBV;;EyE3npBM;IAOI,8BAAA;IAAA,iCAAA;EzEynpBV;;EyEhopBM;IAOI,6BAAA;IAAA,gCAAA;EzE8npBV;;EyEropBM;IAOI,8BAAA;IAAA,iCAAA;EzEmopBV;;EyE1opBM;IAOI,2BAAA;IAAA,8BAAA;EzEwopBV;;EyE/opBM;IAOI,8BAAA;IAAA,iCAAA;EzE6opBV;;EyEpppBM;IAOI,6BAAA;IAAA,gCAAA;EzEkppBV;;EyEzppBM;IAOI,8BAAA;IAAA,iCAAA;EzEuppBV;;EyE9ppBM;IAOI,2BAAA;IAAA,8BAAA;EzE4ppBV;;EyEnqpBM;IAOI,8BAAA;IAAA,iCAAA;EzEiqpBV;;EyExqpBM;IAOI,6BAAA;IAAA,gCAAA;EzEsqpBV;;EyE7qpBM;IAOI,8BAAA;IAAA,iCAAA;EzE2qpBV;;EyElrpBM;IAOI,2BAAA;IAAA,8BAAA;EzEgrpBV;;EyEvrpBM;IAOI,8BAAA;IAAA,iCAAA;EzEqrpBV;;EyE5rpBM;IAOI,6BAAA;IAAA,gCAAA;EzE0rpBV;;EyEjspBM;IAOI,8BAAA;IAAA,iCAAA;EzE+rpBV;;EyEtspBM;IAOI,2BAAA;IAAA,8BAAA;EzEospBV;;EyE3spBM;IAOI,8BAAA;IAAA,iCAAA;EzEyspBV;;EyEhtpBM;IAOI,6BAAA;IAAA,gCAAA;EzE8spBV;;EyErtpBM;IAOI,8BAAA;IAAA,iCAAA;EzEmtpBV;;EyE1tpBM;IAOI,2BAAA;IAAA,8BAAA;EzEwtpBV;;EyE/tpBM;IAOI,2BAAA;IAAA,8BAAA;EzE6tpBV;;EyEpupBM;IAOI,wBAAA;EzEiupBV;;EyExupBM;IAOI,8BAAA;EzEqupBV;;EyE5upBM;IAOI,6BAAA;EzEyupBV;;EyEhvpBM;IAOI,8BAAA;EzE6upBV;;EyEpvpBM;IAOI,2BAAA;EzEivpBV;;EyExvpBM;IAOI,8BAAA;EzEqvpBV;;EyE5vpBM;IAOI,6BAAA;EzEyvpBV;;EyEhwpBM;IAOI,8BAAA;EzE6vpBV;;EyEpwpBM;IAOI,2BAAA;EzEiwpBV;;EyExwpBM;IAOI,8BAAA;EzEqwpBV;;EyE5wpBM;IAOI,6BAAA;EzEywpBV;;EyEhxpBM;IAOI,8BAAA;EzE6wpBV;;EyEpxpBM;IAOI,2BAAA;EzEixpBV;;EyExxpBM;IAOI,8BAAA;EzEqxpBV;;EyE5xpBM;IAOI,6BAAA;EzEyxpBV;;EyEhypBM;IAOI,8BAAA;EzE6xpBV;;EyEpypBM;IAOI,2BAAA;EzEiypBV;;EyExypBM;IAOI,8BAAA;EzEqypBV;;EyE5ypBM;IAOI,6BAAA;EzEyypBV;;EyEhzpBM;IAOI,8BAAA;EzE6ypBV;;EyEpzpBM;IAOI,2BAAA;EzEizpBV;;EyExzpBM;IAOI,2BAAA;EzEqzpBV;;EyE5zpBM;IAOI,0BAAA;EzEyzpBV;;EyEh0pBM;IAOI,gCAAA;EzE6zpBV;;EyEp0pBM;IAOI,+BAAA;EzEi0pBV;;EyEx0pBM;IAOI,gCAAA;EzEq0pBV;;EyE50pBM;IAOI,6BAAA;EzEy0pBV;;EyEh1pBM;IAOI,gCAAA;EzE60pBV;;EyEp1pBM;IAOI,+BAAA;EzEi1pBV;;EyEx1pBM;IAOI,gCAAA;EzEq1pBV;;EyE51pBM;IAOI,6BAAA;EzEy1pBV;;EyEh2pBM;IAOI,gCAAA;EzE61pBV;;EyEp2pBM;IAOI,+BAAA;EzEi2pBV;;EyEx2pBM;IAOI,gCAAA;EzEq2pBV;;EyE52pBM;IAOI,6BAAA;EzEy2pBV;;EyEh3pBM;IAOI,gCAAA;EzE62pBV;;EyEp3pBM;IAOI,+BAAA;EzEi3pBV;;EyEx3pBM;IAOI,gCAAA;EzEq3pBV;;EyE53pBM;IAOI,6BAAA;EzEy3pBV;;EyEh4pBM;IAOI,gCAAA;EzE63pBV;;EyEp4pBM;IAOI,+BAAA;EzEi4pBV;;EyEx4pBM;IAOI,gCAAA;EzEq4pBV;;EyE54pBM;IAOI,6BAAA;EzEy4pBV;;EyEh5pBM;IAOI,6BAAA;EzE64pBV;;EyEp5pBM;IAOI,2BAAA;EzEi5pBV;;EyEx5pBM;IAOI,iCAAA;EzEq5pBV;;EyE55pBM;IAOI,gCAAA;EzEy5pBV;;EyEh6pBM;IAOI,iCAAA;EzE65pBV;;EyEp6pBM;IAOI,8BAAA;EzEi6pBV;;EyEx6pBM;IAOI,iCAAA;EzEq6pBV;;EyE56pBM;IAOI,gCAAA;EzEy6pBV;;EyEh7pBM;IAOI,iCAAA;EzE66pBV;;EyEp7pBM;IAOI,8BAAA;EzEi7pBV;;EyEx7pBM;IAOI,iCAAA;EzEq7pBV;;EyE57pBM;IAOI,gCAAA;EzEy7pBV;;EyEh8pBM;IAOI,iCAAA;EzE67pBV;;EyEp8pBM;IAOI,8BAAA;EzEi8pBV;;EyEx8pBM;IAOI,iCAAA;EzEq8pBV;;EyE58pBM;IAOI,gCAAA;EzEy8pBV;;EyEh9pBM;IAOI,iCAAA;EzE68pBV;;EyEp9pBM;IAOI,8BAAA;EzEi9pBV;;EyEx9pBM;IAOI,iCAAA;EzEq9pBV;;EyE59pBM;IAOI,gCAAA;EzEy9pBV;;EyEh+pBM;IAOI,iCAAA;EzE69pBV;;EyEp+pBM;IAOI,8BAAA;EzEi+pBV;;EyEx+pBM;IAOI,8BAAA;EzEq+pBV;;EyE5+pBM;IAOI,yBAAA;EzEy+pBV;;EyEh/pBM;IAOI,+BAAA;EzE6+pBV;;EyEp/pBM;IAOI,8BAAA;EzEi/pBV;;EyEx/pBM;IAOI,+BAAA;EzEq/pBV;;EyE5/pBM;IAOI,4BAAA;EzEy/pBV;;EyEhgqBM;IAOI,+BAAA;EzE6/pBV;;EyEpgqBM;IAOI,8BAAA;EzEigqBV;;EyExgqBM;IAOI,+BAAA;EzEqgqBV;;EyE5gqBM;IAOI,4BAAA;EzEygqBV;;EyEhhqBM;IAOI,+BAAA;EzE6gqBV;;EyEphqBM;IAOI,8BAAA;EzEihqBV;;EyExhqBM;IAOI,+BAAA;EzEqhqBV;;EyE5hqBM;IAOI,4BAAA;EzEyhqBV;;EyEhiqBM;IAOI,+BAAA;EzE6hqBV;;EyEpiqBM;IAOI,8BAAA;EzEiiqBV;;EyExiqBM;IAOI,+BAAA;EzEqiqBV;;EyE5iqBM;IAOI,4BAAA;EzEyiqBV;;EyEhjqBM;IAOI,+BAAA;EzE6iqBV;;EyEpjqBM;IAOI,8BAAA;EzEijqBV;;EyExjqBM;IAOI,+BAAA;EzEqjqBV;;EyE5jqBM;IAOI,4BAAA;EzEyjqBV;;EyEhkqBM;IAOI,4BAAA;EzE6jqBV;;EyEpkqBM;IAOI,2BAAA;EzEikqBV;;EyExkqBM;IAOI,0BAAA;EzEqkqBV;;EyE5kqBM;IAOI,2BAAA;EzEykqBV;;EyEhlqBM;IAOI,wBAAA;EzE6kqBV;;EyEplqBM;IAOI,2BAAA;EzEilqBV;;EyExlqBM;IAOI,0BAAA;EzEqlqBV;;EyE5lqBM;IAOI,2BAAA;EzEylqBV;;EyEhmqBM;IAOI,wBAAA;EzE6lqBV;;EyEpmqBM;IAOI,2BAAA;EzEimqBV;;EyExmqBM;IAOI,0BAAA;EzEqmqBV;;EyE5mqBM;IAOI,2BAAA;EzEymqBV;;EyEhnqBM;IAOI,wBAAA;EzE6mqBV;;EyEpnqBM;IAOI,2BAAA;EzEinqBV;;EyExnqBM;IAOI,0BAAA;EzEqnqBV;;EyE5nqBM;IAOI,2BAAA;EzEynqBV;;EyEhoqBM;IAOI,wBAAA;EzE6nqBV;;EyEpoqBM;IAOI,2BAAA;EzEioqBV;;EyExoqBM;IAOI,0BAAA;EzEqoqBV;;EyE5oqBM;IAOI,2BAAA;EzEyoqBV;;EyEhpqBM;IAOI,wBAAA;EzE6oqBV;;EyEppqBM;IAOI,iCAAA;IAAA,gCAAA;EzEkpqBV;;EyEzpqBM;IAOI,gCAAA;IAAA,+BAAA;EzEupqBV;;EyE9pqBM;IAOI,iCAAA;IAAA,gCAAA;EzE4pqBV;;EyEnqqBM;IAOI,8BAAA;IAAA,6BAAA;EzEiqqBV;;EyExqqBM;IAOI,iCAAA;IAAA,gCAAA;EzEsqqBV;;EyE7qqBM;IAOI,gCAAA;IAAA,+BAAA;EzE2qqBV;;EyElrqBM;IAOI,iCAAA;IAAA,gCAAA;EzEgrqBV;;EyEvrqBM;IAOI,8BAAA;IAAA,6BAAA;EzEqrqBV;;EyE5rqBM;IAOI,iCAAA;IAAA,gCAAA;EzE0rqBV;;EyEjsqBM;IAOI,gCAAA;IAAA,+BAAA;EzE+rqBV;;EyEtsqBM;IAOI,iCAAA;IAAA,gCAAA;EzEosqBV;;EyE3sqBM;IAOI,8BAAA;IAAA,6BAAA;EzEysqBV;;EyEhtqBM;IAOI,iCAAA;IAAA,gCAAA;EzE8sqBV;;EyErtqBM;IAOI,gCAAA;IAAA,+BAAA;EzEmtqBV;;EyE1tqBM;IAOI,iCAAA;IAAA,gCAAA;EzEwtqBV;;EyE/tqBM;IAOI,8BAAA;IAAA,6BAAA;EzE6tqBV;;EyEpuqBM;IAOI,iCAAA;IAAA,gCAAA;EzEkuqBV;;EyEzuqBM;IAOI,gCAAA;IAAA,+BAAA;EzEuuqBV;;EyE9uqBM;IAOI,iCAAA;IAAA,gCAAA;EzE4uqBV;;EyEnvqBM;IAOI,8BAAA;IAAA,6BAAA;EzEivqBV;;EyExvqBM;IAOI,+BAAA;IAAA,kCAAA;EzEsvqBV;;EyE7vqBM;IAOI,8BAAA;IAAA,iCAAA;EzE2vqBV;;EyElwqBM;IAOI,+BAAA;IAAA,kCAAA;EzEgwqBV;;EyEvwqBM;IAOI,4BAAA;IAAA,+BAAA;EzEqwqBV;;EyE5wqBM;IAOI,+BAAA;IAAA,kCAAA;EzE0wqBV;;EyEjxqBM;IAOI,8BAAA;IAAA,iCAAA;EzE+wqBV;;EyEtxqBM;IAOI,+BAAA;IAAA,kCAAA;EzEoxqBV;;EyE3xqBM;IAOI,4BAAA;IAAA,+BAAA;EzEyxqBV;;EyEhyqBM;IAOI,+BAAA;IAAA,kCAAA;EzE8xqBV;;EyEryqBM;IAOI,8BAAA;IAAA,iCAAA;EzEmyqBV;;EyE1yqBM;IAOI,+BAAA;IAAA,kCAAA;EzEwyqBV;;EyE/yqBM;IAOI,4BAAA;IAAA,+BAAA;EzE6yqBV;;EyEpzqBM;IAOI,+BAAA;IAAA,kCAAA;EzEkzqBV;;EyEzzqBM;IAOI,8BAAA;IAAA,iCAAA;EzEuzqBV;;EyE9zqBM;IAOI,+BAAA;IAAA,kCAAA;EzE4zqBV;;EyEn0qBM;IAOI,4BAAA;IAAA,+BAAA;EzEi0qBV;;EyEx0qBM;IAOI,+BAAA;IAAA,kCAAA;EzEs0qBV;;EyE70qBM;IAOI,8BAAA;IAAA,iCAAA;EzE20qBV;;EyEl1qBM;IAOI,+BAAA;IAAA,kCAAA;EzEg1qBV;;EyEv1qBM;IAOI,4BAAA;IAAA,+BAAA;EzEq1qBV;;EyE51qBM;IAOI,+BAAA;EzEy1qBV;;EyEh2qBM;IAOI,8BAAA;EzE61qBV;;EyEp2qBM;IAOI,+BAAA;EzEi2qBV;;EyEx2qBM;IAOI,4BAAA;EzEq2qBV;;EyE52qBM;IAOI,+BAAA;EzEy2qBV;;EyEh3qBM;IAOI,8BAAA;EzE62qBV;;EyEp3qBM;IAOI,+BAAA;EzEi3qBV;;EyEx3qBM;IAOI,4BAAA;EzEq3qBV;;EyE53qBM;IAOI,+BAAA;EzEy3qBV;;EyEh4qBM;IAOI,8BAAA;EzE63qBV;;EyEp4qBM;IAOI,+BAAA;EzEi4qBV;;EyEx4qBM;IAOI,4BAAA;EzEq4qBV;;EyE54qBM;IAOI,+BAAA;EzEy4qBV;;EyEh5qBM;IAOI,8BAAA;EzE64qBV;;EyEp5qBM;IAOI,+BAAA;EzEi5qBV;;EyEx5qBM;IAOI,4BAAA;EzEq5qBV;;EyE55qBM;IAOI,+BAAA;EzEy5qBV;;EyEh6qBM;IAOI,8BAAA;EzE65qBV;;EyEp6qBM;IAOI,+BAAA;EzEi6qBV;;EyEx6qBM;IAOI,4BAAA;EzEq6qBV;;EyE56qBM;IAOI,iCAAA;EzEy6qBV;;EyEh7qBM;IAOI,gCAAA;EzE66qBV;;EyEp7qBM;IAOI,iCAAA;EzEi7qBV;;EyEx7qBM;IAOI,8BAAA;EzEq7qBV;;EyE57qBM;IAOI,iCAAA;EzEy7qBV;;EyEh8qBM;IAOI,gCAAA;EzE67qBV;;EyEp8qBM;IAOI,iCAAA;EzEi8qBV;;EyEx8qBM;IAOI,8BAAA;EzEq8qBV;;EyE58qBM;IAOI,iCAAA;EzEy8qBV;;EyEh9qBM;IAOI,gCAAA;EzE68qBV;;EyEp9qBM;IAOI,iCAAA;EzEi9qBV;;EyEx9qBM;IAOI,8BAAA;EzEq9qBV;;EyE59qBM;IAOI,iCAAA;EzEy9qBV;;EyEh+qBM;IAOI,gCAAA;EzE69qBV;;EyEp+qBM;IAOI,iCAAA;EzEi+qBV;;EyEx+qBM;IAOI,8BAAA;EzEq+qBV;;EyE5+qBM;IAOI,iCAAA;EzEy+qBV;;EyEh/qBM;IAOI,gCAAA;EzE6+qBV;;EyEp/qBM;IAOI,iCAAA;EzEi/qBV;;EyEx/qBM;IAOI,8BAAA;EzEq/qBV;;EyE5/qBM;IAOI,kCAAA;EzEy/qBV;;EyEhgrBM;IAOI,iCAAA;EzE6/qBV;;EyEpgrBM;IAOI,kCAAA;EzEigrBV;;EyExgrBM;IAOI,+BAAA;EzEqgrBV;;EyE5grBM;IAOI,kCAAA;EzEygrBV;;EyEhhrBM;IAOI,iCAAA;EzE6grBV;;EyEphrBM;IAOI,kCAAA;EzEihrBV;;EyExhrBM;IAOI,+BAAA;EzEqhrBV;;EyE5hrBM;IAOI,kCAAA;EzEyhrBV;;EyEhirBM;IAOI,iCAAA;EzE6hrBV;;EyEpirBM;IAOI,kCAAA;EzEiirBV;;EyExirBM;IAOI,+BAAA;EzEqirBV;;EyE5irBM;IAOI,kCAAA;EzEyirBV;;EyEhjrBM;IAOI,iCAAA;EzE6irBV;;EyEpjrBM;IAOI,kCAAA;EzEijrBV;;EyExjrBM;IAOI,+BAAA;EzEqjrBV;;EyE5jrBM;IAOI,kCAAA;EzEyjrBV;;EyEhkrBM;IAOI,iCAAA;EzE6jrBV;;EyEpkrBM;IAOI,kCAAA;EzEikrBV;;EyExkrBM;IAOI,+BAAA;EzEqkrBV;;EyE5krBM;IAOI,gCAAA;EzEykrBV;;EyEhlrBM;IAOI,+BAAA;EzE6krBV;;EyEplrBM;IAOI,gCAAA;EzEilrBV;;EyExlrBM;IAOI,6BAAA;EzEqlrBV;;EyE5lrBM;IAOI,gCAAA;EzEylrBV;;EyEhmrBM;IAOI,+BAAA;EzE6lrBV;;EyEpmrBM;IAOI,gCAAA;EzEimrBV;;EyExmrBM;IAOI,6BAAA;EzEqmrBV;;EyE5mrBM;IAOI,gCAAA;EzEymrBV;;EyEhnrBM;IAOI,+BAAA;EzE6mrBV;;EyEpnrBM;IAOI,gCAAA;EzEinrBV;;EyExnrBM;IAOI,6BAAA;EzEqnrBV;;EyE5nrBM;IAOI,gCAAA;EzEynrBV;;EyEhorBM;IAOI,+BAAA;EzE6nrBV;;EyEporBM;IAOI,gCAAA;EzEiorBV;;EyExorBM;IAOI,6BAAA;EzEqorBV;;EyE5orBM;IAOI,gCAAA;EzEyorBV;;EyEhprBM;IAOI,+BAAA;EzE6orBV;;EyEpprBM;IAOI,gCAAA;EzEiprBV;;EyExprBM;IAOI,6BAAA;EzEqprBV;;EyE5prBM;IAOI,qBAAA;EzEyprBV;;EyEhqrBM;IAOI,2BAAA;EzE6prBV;;EyEpqrBM;IAOI,0BAAA;EzEiqrBV;;EyExqrBM;IAOI,2BAAA;EzEqqrBV;;EyE5qrBM;IAOI,wBAAA;EzEyqrBV;;EyEhrrBM;IAOI,2BAAA;EzE6qrBV;;EyEprrBM;IAOI,0BAAA;EzEirrBV;;EyExrrBM;IAOI,2BAAA;EzEqrrBV;;EyE5rrBM;IAOI,wBAAA;EzEyrrBV;;EyEhsrBM;IAOI,2BAAA;EzE6rrBV;;EyEpsrBM;IAOI,0BAAA;EzEisrBV;;EyExsrBM;IAOI,2BAAA;EzEqsrBV;;EyE5srBM;IAOI,wBAAA;EzEysrBV;;EyEhtrBM;IAOI,2BAAA;EzE6srBV;;EyEptrBM;IAOI,0BAAA;EzEitrBV;;EyExtrBM;IAOI,2BAAA;EzEqtrBV;;EyE5trBM;IAOI,wBAAA;EzEytrBV;;EyEhurBM;IAOI,2BAAA;EzE6trBV;;EyEpurBM;IAOI,0BAAA;EzEiurBV;;EyExurBM;IAOI,2BAAA;EzEqurBV;;EyE5urBM;IAOI,wBAAA;EzEyurBV;;EyEhvrBM;IAOI,2BAAA;IAAA,0BAAA;EzE8urBV;;EyErvrBM;IAOI,iCAAA;IAAA,gCAAA;EzEmvrBV;;EyE1vrBM;IAOI,gCAAA;IAAA,+BAAA;EzEwvrBV;;EyE/vrBM;IAOI,iCAAA;IAAA,gCAAA;EzE6vrBV;;EyEpwrBM;IAOI,8BAAA;IAAA,6BAAA;EzEkwrBV;;EyEzwrBM;IAOI,iCAAA;IAAA,gCAAA;EzEuwrBV;;EyE9wrBM;IAOI,gCAAA;IAAA,+BAAA;EzE4wrBV;;EyEnxrBM;IAOI,iCAAA;IAAA,gCAAA;EzEixrBV;;EyExxrBM;IAOI,8BAAA;IAAA,6BAAA;EzEsxrBV;;EyE7xrBM;IAOI,iCAAA;IAAA,gCAAA;EzE2xrBV;;EyElyrBM;IAOI,gCAAA;IAAA,+BAAA;EzEgyrBV;;EyEvyrBM;IAOI,iCAAA;IAAA,gCAAA;EzEqyrBV;;EyE5yrBM;IAOI,8BAAA;IAAA,6BAAA;EzE0yrBV;;EyEjzrBM;IAOI,iCAAA;IAAA,gCAAA;EzE+yrBV;;EyEtzrBM;IAOI,gCAAA;IAAA,+BAAA;EzEozrBV;;EyE3zrBM;IAOI,iCAAA;IAAA,gCAAA;EzEyzrBV;;EyEh0rBM;IAOI,8BAAA;IAAA,6BAAA;EzE8zrBV;;EyEr0rBM;IAOI,iCAAA;IAAA,gCAAA;EzEm0rBV;;EyE10rBM;IAOI,gCAAA;IAAA,+BAAA;EzEw0rBV;;EyE/0rBM;IAOI,iCAAA;IAAA,gCAAA;EzE60rBV;;EyEp1rBM;IAOI,8BAAA;IAAA,6BAAA;EzEk1rBV;;EyEz1rBM;IAOI,yBAAA;IAAA,4BAAA;EzEu1rBV;;EyE91rBM;IAOI,+BAAA;IAAA,kCAAA;EzE41rBV;;EyEn2rBM;IAOI,8BAAA;IAAA,iCAAA;EzEi2rBV;;EyEx2rBM;IAOI,+BAAA;IAAA,kCAAA;EzEs2rBV;;EyE72rBM;IAOI,4BAAA;IAAA,+BAAA;EzE22rBV;;EyEl3rBM;IAOI,+BAAA;IAAA,kCAAA;EzEg3rBV;;EyEv3rBM;IAOI,8BAAA;IAAA,iCAAA;EzEq3rBV;;EyE53rBM;IAOI,+BAAA;IAAA,kCAAA;EzE03rBV;;EyEj4rBM;IAOI,4BAAA;IAAA,+BAAA;EzE+3rBV;;EyEt4rBM;IAOI,+BAAA;IAAA,kCAAA;EzEo4rBV;;EyE34rBM;IAOI,8BAAA;IAAA,iCAAA;EzEy4rBV;;EyEh5rBM;IAOI,+BAAA;IAAA,kCAAA;EzE84rBV;;EyEr5rBM;IAOI,4BAAA;IAAA,+BAAA;EzEm5rBV;;EyE15rBM;IAOI,+BAAA;IAAA,kCAAA;EzEw5rBV;;EyE/5rBM;IAOI,8BAAA;IAAA,iCAAA;EzE65rBV;;EyEp6rBM;IAOI,+BAAA;IAAA,kCAAA;EzEk6rBV;;EyEz6rBM;IAOI,4BAAA;IAAA,+BAAA;EzEu6rBV;;EyE96rBM;IAOI,+BAAA;IAAA,kCAAA;EzE46rBV;;EyEn7rBM;IAOI,8BAAA;IAAA,iCAAA;EzEi7rBV;;EyEx7rBM;IAOI,+BAAA;IAAA,kCAAA;EzEs7rBV;;EyE77rBM;IAOI,4BAAA;IAAA,+BAAA;EzE27rBV;;EyEl8rBM;IAOI,yBAAA;EzE+7rBV;;EyEt8rBM;IAOI,+BAAA;EzEm8rBV;;EyE18rBM;IAOI,8BAAA;EzEu8rBV;;EyE98rBM;IAOI,+BAAA;EzE28rBV;;EyEl9rBM;IAOI,4BAAA;EzE+8rBV;;EyEt9rBM;IAOI,+BAAA;EzEm9rBV;;EyE19rBM;IAOI,8BAAA;EzEu9rBV;;EyE99rBM;IAOI,+BAAA;EzE29rBV;;EyEl+rBM;IAOI,4BAAA;EzE+9rBV;;EyEt+rBM;IAOI,+BAAA;EzEm+rBV;;EyE1+rBM;IAOI,8BAAA;EzEu+rBV;;EyE9+rBM;IAOI,+BAAA;EzE2+rBV;;EyEl/rBM;IAOI,4BAAA;EzE++rBV;;EyEt/rBM;IAOI,+BAAA;EzEm/rBV;;EyE1/rBM;IAOI,8BAAA;EzEu/rBV;;EyE9/rBM;IAOI,+BAAA;EzE2/rBV;;EyElgsBM;IAOI,4BAAA;EzE+/rBV;;EyEtgsBM;IAOI,+BAAA;EzEmgsBV;;EyE1gsBM;IAOI,8BAAA;EzEugsBV;;EyE9gsBM;IAOI,+BAAA;EzE2gsBV;;EyElhsBM;IAOI,4BAAA;EzE+gsBV;;EyEthsBM;IAOI,2BAAA;EzEmhsBV;;EyE1hsBM;IAOI,iCAAA;EzEuhsBV;;EyE9hsBM;IAOI,gCAAA;EzE2hsBV;;EyElisBM;IAOI,iCAAA;EzE+hsBV;;EyEtisBM;IAOI,8BAAA;EzEmisBV;;EyE1isBM;IAOI,iCAAA;EzEuisBV;;EyE9isBM;IAOI,gCAAA;EzE2isBV;;EyEljsBM;IAOI,iCAAA;EzE+isBV;;EyEtjsBM;IAOI,8BAAA;EzEmjsBV;;EyE1jsBM;IAOI,iCAAA;EzEujsBV;;EyE9jsBM;IAOI,gCAAA;EzE2jsBV;;EyElksBM;IAOI,iCAAA;EzE+jsBV;;EyEtksBM;IAOI,8BAAA;EzEmksBV;;EyE1ksBM;IAOI,iCAAA;EzEuksBV;;EyE9ksBM;IAOI,gCAAA;EzE2ksBV;;EyEllsBM;IAOI,iCAAA;EzE+ksBV;;EyEtlsBM;IAOI,8BAAA;EzEmlsBV;;EyE1lsBM;IAOI,iCAAA;EzEulsBV;;EyE9lsBM;IAOI,gCAAA;EzE2lsBV;;EyElmsBM;IAOI,iCAAA;EzE+lsBV;;EyEtmsBM;IAOI,8BAAA;EzEmmsBV;;EyE1msBM;IAOI,4BAAA;EzEumsBV;;EyE9msBM;IAOI,kCAAA;EzE2msBV;;EyElnsBM;IAOI,iCAAA;EzE+msBV;;EyEtnsBM;IAOI,kCAAA;EzEmnsBV;;EyE1nsBM;IAOI,+BAAA;EzEunsBV;;EyE9nsBM;IAOI,kCAAA;EzE2nsBV;;EyElosBM;IAOI,iCAAA;EzE+nsBV;;EyEtosBM;IAOI,kCAAA;EzEmosBV;;EyE1osBM;IAOI,+BAAA;EzEuosBV;;EyE9osBM;IAOI,kCAAA;EzE2osBV;;EyElpsBM;IAOI,iCAAA;EzE+osBV;;EyEtpsBM;IAOI,kCAAA;EzEmpsBV;;EyE1psBM;IAOI,+BAAA;EzEupsBV;;EyE9psBM;IAOI,kCAAA;EzE2psBV;;EyElqsBM;IAOI,iCAAA;EzE+psBV;;EyEtqsBM;IAOI,kCAAA;EzEmqsBV;;EyE1qsBM;IAOI,+BAAA;EzEuqsBV;;EyE9qsBM;IAOI,kCAAA;EzE2qsBV;;EyElrsBM;IAOI,iCAAA;EzE+qsBV;;EyEtrsBM;IAOI,kCAAA;EzEmrsBV;;EyE1rsBM;IAOI,+BAAA;EzEursBV;;EyE9rsBM;IAOI,0BAAA;EzE2rsBV;;EyElssBM;IAOI,gCAAA;EzE+rsBV;;EyEtssBM;IAOI,+BAAA;EzEmssBV;;EyE1ssBM;IAOI,gCAAA;EzEussBV;;EyE9ssBM;IAOI,6BAAA;EzE2ssBV;;EyEltsBM;IAOI,gCAAA;EzE+ssBV;;EyEttsBM;IAOI,+BAAA;EzEmtsBV;;EyE1tsBM;IAOI,gCAAA;EzEutsBV;;EyE9tsBM;IAOI,6BAAA;EzE2tsBV;;EyElusBM;IAOI,gCAAA;EzE+tsBV;;EyEtusBM;IAOI,+BAAA;EzEmusBV;;EyE1usBM;IAOI,gCAAA;EzEuusBV;;EyE9usBM;IAOI,6BAAA;EzE2usBV;;EyElvsBM;IAOI,gCAAA;EzE+usBV;;EyEtvsBM;IAOI,+BAAA;EzEmvsBV;;EyE1vsBM;IAOI,gCAAA;EzEuvsBV;;EyE9vsBM;IAOI,6BAAA;EzE2vsBV;;EyElwsBM;IAOI,gCAAA;EzE+vsBV;;EyEtwsBM;IAOI,+BAAA;EzEmwsBV;;EyE1wsBM;IAOI,gCAAA;EzEuwsBV;;EyE9wsBM;IAOI,6BAAA;EzE2wsBV;;EyElxsBM;IAOI,iBAAA;EzE+wsBV;;EyEtxsBM;IAOI,uBAAA;EzEmxsBV;;EyE1xsBM;IAOI,sBAAA;EzEuxsBV;;EyE9xsBM;IAOI,uBAAA;EzE2xsBV;;EyElysBM;IAOI,oBAAA;EzE+xsBV;;EyEtysBM;IAOI,uBAAA;EzEmysBV;;EyE1ysBM;IAOI,sBAAA;EzEuysBV;;EyE9ysBM;IAOI,uBAAA;EzE2ysBV;;EyElzsBM;IAOI,oBAAA;EzE+ysBV;;EyEtzsBM;IAOI,uBAAA;EzEmzsBV;;EyE1zsBM;IAOI,sBAAA;EzEuzsBV;;EyE9zsBM;IAOI,uBAAA;EzE2zsBV;;EyEl0sBM;IAOI,oBAAA;EzE+zsBV;;EyEt0sBM;IAOI,uBAAA;EzEm0sBV;;EyE10sBM;IAOI,sBAAA;EzEu0sBV;;EyE90sBM;IAOI,uBAAA;EzE20sBV;;EyEl1sBM;IAOI,oBAAA;EzE+0sBV;;EyEt1sBM;IAOI,uBAAA;EzEm1sBV;;EyE11sBM;IAOI,sBAAA;EzEu1sBV;;EyE91sBM;IAOI,uBAAA;EzE21sBV;;EyEl2sBM;IAOI,oBAAA;EzE+1sBV;;EyEt2sBM;IAOI,0CAAA;EzEm2sBV;;EyE12sBM;IAOI,4CAAA;EzEu2sBV;;EyE92sBM;IAOI,4CAAA;EzE22sBV;;EyEl3sBM;IAOI,6BAAA;EzE+2sBV;;EyEt3sBM;IAOI,6BAAA;EzEm3sBV;;EyE13sBM;IAOI,8BAAA;EzEu3sBV;;EyE93sBM;IAOI,6BAAA;EzE23sBV;;EyEl4sBM;IAOI,6BAAA;EzE+3sBV;;EyEt4sBM;IAOI,6BAAA;EzEm4sBV;;EyE14sBM;IAOI,4BAAA;EzEu4sBV;;EyE94sBM;IAOI,0BAAA;EzE24sBV;;EyEl5sBM;IAOI,0BAAA;EzE+4sBV;;EyEt5sBM;IAOI,4CAAA;EzEm5sBV;;EyE15sBM;IAOI,2CAAA;EzEu5sBV;;EyE95sBM;IAOI,4CAAA;EzE25sBV;;EyEl6sBM;IAOI,0CAAA;EzE+5sBV;;EyEt6sBM;IAOI,4CAAA;EzEm6sBV;;EyE16sBM;IAOI,2CAAA;EzEu6sBV;;EyE96sBM;IAOI,4CAAA;EzE26sBV;;EyEl7sBM;IAOI,wCAAA;EzE+6sBV;;EyEt7sBM;IAOI,4CAAA;EzEm7sBV;;EyE17sBM;IAOI,2CAAA;EzEu7sBV;;EyE97sBM;IAOI,4CAAA;EzE27sBV;;EyEl8sBM;IAOI,0CAAA;EzE+7sBV;;EyEt8sBM;IAOI,4CAAA;EzEm8sBV;;EyE18sBM;IAOI,2CAAA;EzEu8sBV;;EyE98sBM;IAOI,4CAAA;EzE28sBV;;EyEl9sBM;IAOI,0CAAA;EzE+8sBV;;EyEt9sBM;IAOI,2BAAA;EzEm9sBV;;EyE19sBM;IAOI,4BAAA;EzEu9sBV;;EyE99sBM;IAOI,6BAAA;EzE29sBV;;EyEl+sBM;IAOI,2BAAA;EzE+9sBV;;EyEt+sBM;IAOI,yBAAA;EzEm+sBV;;EyE1+sBM;IAOI,yBAAA;EzEu+sBV;;EyE9+sBM;IAOI,yBAAA;EzE2+sBV;;EyEl/sBM;IAOI,0BAAA;EzE++sBV;;EyEt/sBM;IAOI,0BAAA;EzEm/sBV;;EyE1/sBM;IAOI,yBAAA;EzEu/sBV;;EyE9/sBM;IAOI,yBAAA;EzE2/sBV;;EyElgtBM;IAOI,yBAAA;EzE+/sBV;;EyEtgtBM;IAOI,yBAAA;EzEmgtBV;;EyE1gtBM;IAOI,yBAAA;EzEugtBV;;EyE9gtBM;IAOI,yBAAA;EzE2gtBV;;EyElhtBM;IAOI,yBAAA;EzE+gtBV;;EyEthtBM;IAOI,yBAAA;EzEmhtBV;;EyE1htBM;IAOI,yBAAA;EzEuhtBV;;EyE9htBM;IAOI,0BAAA;EzE2htBV;;EyElitBM;IAOI,0BAAA;EzE+htBV;;EyEtitBM;IAOI,0BAAA;EzEmitBV;;EyE1itBM;IAOI,0BAAA;EzEuitBV;;EyE9itBM;IAOI,0BAAA;EzE2itBV;;EyEljtBM;IAOI,0BAAA;EzE+itBV;;EyEtjtBM;IAOI,0BAAA;EzEmjtBV;;EyE1jtBM;IAOI,0BAAA;EzEujtBV;;EyE9jtBM;IAOI,0BAAA;EzE2jtBV;;EyElktBM;IAOI,0BAAA;EzE+jtBV;;EyEtktBM;IAOI,0BAAA;EzEmktBV;;EyE1ktBM;IAOI,0BAAA;EzEuktBV;;EyE9ktBM;IAOI,0BAAA;EzE2ktBV;;EyElltBM;IAOI,0BAAA;EzE+ktBV;;EyEtltBM;IAOI,0BAAA;EzEmltBV;;EyE1ltBM;IAOI,0BAAA;EzEultBV;;EyE9ltBM;IAOI,0BAAA;EzE2ltBV;;EyElmtBM;IAOI,0BAAA;EzE+ltBV;;EyEtmtBM;IAOI,2BAAA;EzEmmtBV;;EyE1mtBM;IAOI,2BAAA;EzEumtBV;;EyE9mtBM;IAOI,2BAAA;EzE2mtBV;;EyElntBM;IAOI,2BAAA;EzE+mtBV;;EyEtntBM;IAOI,2BAAA;EzEmntBV;;EyE1ntBM;IAOI,2BAAA;EzEuntBV;;EyE9ntBM;IAOI,2BAAA;EzE2ntBV;;EyElotBM;IAOI,2BAAA;EzE+ntBV;;EyEtotBM;IAOI,2BAAA;EzEmotBV;;EyE1otBM;IAOI,2BAAA;EzEuotBV;;EyE9otBM;IAOI,2BAAA;EzE2otBV;;EyElptBM;IAOI,2BAAA;EzE+otBV;;EyEtptBM;IAOI,2BAAA;EzEmptBV;;EyE1ptBM;IAOI,2BAAA;EzEuptBV;;EyE9ptBM;IAOI,2BAAA;EzE2ptBV;;EyElqtBM;IAOI,2BAAA;EzE+ptBV;;EyEtqtBM;IAOI,2BAAA;EzEmqtBV;;EyE1qtBM;IAOI,2BAAA;EzEuqtBV;;EyE9qtBM;IAOI,2BAAA;EzE2qtBV;;EyElrtBM;IAOI,2BAAA;EzE+qtBV;;EyEtrtBM;IAOI,2BAAA;EzEmrtBV;;EyE1rtBM;IAOI,2BAAA;EzEurtBV;;EyE9rtBM;IAOI,2BAAA;EzE2rtBV;;EyElstBM;IAOI,2BAAA;EzE+rtBV;;EyEtstBM;IAOI,2BAAA;EzEmstBV;;EyE1stBM;IAOI,2BAAA;EzEustBV;;EyE9stBM;IAOI,4BAAA;EzE2stBV;;EyElttBM;IAOI,4BAAA;EzE+stBV;;EyEtttBM;IAOI,0BAAA;EzEmttBV;;EyE1ttBM;IAOI,0BAAA;EzEuttBV;;EyE9ttBM;IAOI,0BAAA;EzE2ttBV;;EyElutBM;IAOI,2BAAA;EzE+ttBV;;EyEtutBM;IAOI,2BAAA;EzEmutBV;;EyE1utBM;IAOI,0BAAA;EzEuutBV;;EyE9utBM;IAOI,0BAAA;EzE2utBV;;EyElvtBM;IAOI,0BAAA;EzE+utBV;;EyEtvtBM;IAOI,0BAAA;EzEmvtBV;;EyE1vtBM;IAOI,0BAAA;EzEuvtBV;;EyE9vtBM;IAOI,0BAAA;EzE2vtBV;;EyElwtBM;IAOI,0BAAA;EzE+vtBV;;EyEtwtBM;IAOI,0BAAA;EzEmwtBV;;EyE1wtBM;IAOI,0BAAA;EzEuwtBV;;EyE9wtBM;IAOI,2BAAA;EzE2wtBV;;EyElxtBM;IAOI,2BAAA;EzE+wtBV;;EyEtxtBM;IAOI,2BAAA;EzEmxtBV;;EyE1xtBM;IAOI,2BAAA;EzEuxtBV;;EyE9xtBM;IAOI,2BAAA;EzE2xtBV;;EyElytBM;IAOI,2BAAA;EzE+xtBV;;EyEtytBM;IAOI,2BAAA;EzEmytBV;;EyE1ytBM;IAOI,2BAAA;EzEuytBV;;EyE9ytBM;IAOI,2BAAA;EzE2ytBV;;EyElztBM;IAOI,2BAAA;EzE+ytBV;;EyEtztBM;IAOI,2BAAA;EzEmztBV;;EyE1ztBM;IAOI,2BAAA;EzEuztBV;;EyE9ztBM;IAOI,2BAAA;EzE2ztBV;;EyEl0tBM;IAOI,2BAAA;EzE+ztBV;;EyEt0tBM;IAOI,2BAAA;EzEm0tBV;;EyE10tBM;IAOI,2BAAA;EzEu0tBV;;EyE90tBM;IAOI,2BAAA;EzE20tBV;;EyEl1tBM;IAOI,2BAAA;EzE+0tBV;;EyEt1tBM;IAOI,4BAAA;EzEm1tBV;;EyE11tBM;IAOI,4BAAA;EzEu1tBV;;EyE91tBM;IAOI,4BAAA;EzE21tBV;;EyEl2tBM;IAOI,4BAAA;EzE+1tBV;;EyEt2tBM;IAOI,4BAAA;EzEm2tBV;;EyE12tBM;IAOI,4BAAA;EzEu2tBV;;EyE92tBM;IAOI,4BAAA;EzE22tBV;;EyEl3tBM;IAOI,4BAAA;EzE+2tBV;;EyEt3tBM;IAOI,4BAAA;EzEm3tBV;;EyE13tBM;IAOI,4BAAA;EzEu3tBV;;EyE93tBM;IAOI,4BAAA;EzE23tBV;;EyEl4tBM;IAOI,4BAAA;EzE+3tBV;;EyEt4tBM;IAOI,4BAAA;EzEm4tBV;;EyE14tBM;IAOI,4BAAA;EzEu4tBV;;EyE94tBM;IAOI,4BAAA;EzE24tBV;;EyEl5tBM;IAOI,4BAAA;EzE+4tBV;;EyEt5tBM;IAOI,4BAAA;EzEm5tBV;;EyE15tBM;IAOI,4BAAA;EzEu5tBV;;EyE95tBM;IAOI,4BAAA;EzE25tBV;;EyEl6tBM;IAOI,4BAAA;EzE+5tBV;;EyEt6tBM;IAOI,4BAAA;EzEm6tBV;;EyE16tBM;IAOI,4BAAA;EzEu6tBV;;EyE96tBM;IAOI,4BAAA;EzE26tBV;;EyEl7tBM;IAOI,4BAAA;EzE+6tBV;;EyEt7tBM;IAOI,4BAAA;EzEm7tBV;;EyE17tBM;IAOI,4BAAA;EzEu7tBV;;EyE97tBM;IAOI,6BAAA;EzE27tBV;AACF;Aet8tBI;E0DGI;IAOI,sBAAA;EzEg8tBV;;EyEv8tBM;IAOI,uBAAA;EzEo8tBV;;EyE38tBM;IAOI,sBAAA;EzEw8tBV;;EyE/8tBM;IAOI,0BAAA;EzE48tBV;;EyEn9tBM;IAOI,gCAAA;EzEg9tBV;;EyEv9tBM;IAOI,yBAAA;EzEo9tBV;;EyE39tBM;IAOI,wBAAA;EzEw9tBV;;EyE/9tBM;IAOI,yBAAA;EzE49tBV;;EyEn+tBM;IAOI,6BAAA;EzEg+tBV;;EyEv+tBM;IAOI,8BAAA;EzEo+tBV;;EyE3+tBM;IAOI,wBAAA;EzEw+tBV;;EyE/+tBM;IAOI,+BAAA;EzE4+tBV;;EyEn/tBM;IAOI,wBAAA;EzEg/tBV;;EyEv/tBM;IAOI,2BAAA;EzEo/tBV;;EyE3/tBM;IAOI,6BAAA;EzEw/tBV;;EyE//tBM;IAOI,6BAAA;EzE4/tBV;;EyEnguBM;IAOI,0BAAA;EzEgguBV;;EyEvguBM;IAOI,2BAAA;EzEoguBV;;EyE3guBM;IAOI,uBAAA;EzEwguBV;;EyE/guBM;IAOI,qBAAA;EzE4guBV;;EyEnhuBM;IAOI,qBAAA;EzEghuBV;;EyEvhuBM;IAOI,qBAAA;EzEohuBV;;EyE3huBM;IAOI,sBAAA;EzEwhuBV;;EyE/huBM;IAOI,sBAAA;EzE4huBV;;EyEniuBM;IAOI,qBAAA;EzEgiuBV;;EyEviuBM;IAOI,qBAAA;EzEoiuBV;;EyE3iuBM;IAOI,qBAAA;EzEwiuBV;;EyE/iuBM;IAOI,qBAAA;EzE4iuBV;;EyEnjuBM;IAOI,qBAAA;EzEgjuBV;;EyEvjuBM;IAOI,qBAAA;EzEojuBV;;EyE3juBM;IAOI,qBAAA;EzEwjuBV;;EyE/juBM;IAOI,qBAAA;EzE4juBV;;EyEnkuBM;IAOI,qBAAA;EzEgkuBV;;EyEvkuBM;IAOI,sBAAA;EzEokuBV;;EyE3kuBM;IAOI,sBAAA;EzEwkuBV;;EyE/kuBM;IAOI,sBAAA;EzE4kuBV;;EyEnluBM;IAOI,sBAAA;EzEgluBV;;EyEvluBM;IAOI,sBAAA;EzEoluBV;;EyE3luBM;IAOI,sBAAA;EzEwluBV;;EyE/luBM;IAOI,sBAAA;EzE4luBV;;EyEnmuBM;IAOI,sBAAA;EzEgmuBV;;EyEvmuBM;IAOI,sBAAA;EzEomuBV;;EyE3muBM;IAOI,sBAAA;EzEwmuBV;;EyE/muBM;IAOI,sBAAA;EzE4muBV;;EyEnnuBM;IAOI,sBAAA;EzEgnuBV;;EyEvnuBM;IAOI,sBAAA;EzEonuBV;;EyE3nuBM;IAOI,sBAAA;EzEwnuBV;;EyE/nuBM;IAOI,sBAAA;EzE4nuBV;;EyEnouBM;IAOI,sBAAA;EzEgouBV;;EyEvouBM;IAOI,sBAAA;EzEoouBV;;EyE3ouBM;IAOI,sBAAA;EzEwouBV;;EyE/ouBM;IAOI,uBAAA;EzE4ouBV;;EyEnpuBM;IAOI,uBAAA;EzEgpuBV;;EyEvpuBM;IAOI,uBAAA;EzEopuBV;;EyE3puBM;IAOI,uBAAA;EzEwpuBV;;EyE/puBM;IAOI,uBAAA;EzE4puBV;;EyEnquBM;IAOI,uBAAA;EzEgquBV;;EyEvquBM;IAOI,uBAAA;EzEoquBV;;EyE3quBM;IAOI,uBAAA;EzEwquBV;;EyE/quBM;IAOI,uBAAA;EzE4quBV;;EyEnruBM;IAOI,uBAAA;EzEgruBV;;EyEvruBM;IAOI,uBAAA;EzEoruBV;;EyE3ruBM;IAOI,uBAAA;EzEwruBV;;EyE/ruBM;IAOI,uBAAA;EzE4ruBV;;EyEnsuBM;IAOI,uBAAA;EzEgsuBV;;EyEvsuBM;IAOI,uBAAA;EzEosuBV;;EyE3suBM;IAOI,uBAAA;EzEwsuBV;;EyE/suBM;IAOI,uBAAA;EzE4suBV;;EyEntuBM;IAOI,uBAAA;EzEgtuBV;;EyEvtuBM;IAOI,uBAAA;EzEotuBV;;EyE3tuBM;IAOI,uBAAA;EzEwtuBV;;EyE/tuBM;IAOI,uBAAA;EzE4tuBV;;EyEnuuBM;IAOI,uBAAA;EzEguuBV;;EyEvuuBM;IAOI,uBAAA;EzEouuBV;;EyE3uuBM;IAOI,uBAAA;EzEwuuBV;;EyE/uuBM;IAOI,uBAAA;EzE4uuBV;;EyEnvuBM;IAOI,uBAAA;EzEgvuBV;;EyEvvuBM;IAOI,wBAAA;EzEovuBV;;EyE3vuBM;IAOI,2BAAA;EzEwvuBV;;EyE/vuBM;IAOI,yBAAA;EzE4vuBV;;EyEnwuBM;IAOI,yBAAA;EzEgwuBV;;EyEvwuBM;IAOI,yBAAA;EzEowuBV;;EyE3wuBM;IAOI,0BAAA;EzEwwuBV;;EyE/wuBM;IAOI,0BAAA;EzE4wuBV;;EyEnxuBM;IAOI,yBAAA;EzEgxuBV;;EyEvxuBM;IAOI,yBAAA;EzEoxuBV;;EyE3xuBM;IAOI,yBAAA;EzEwxuBV;;EyE/xuBM;IAOI,yBAAA;EzE4xuBV;;EyEnyuBM;IAOI,yBAAA;EzEgyuBV;;EyEvyuBM;IAOI,yBAAA;EzEoyuBV;;EyE3yuBM;IAOI,yBAAA;EzEwyuBV;;EyE/yuBM;IAOI,yBAAA;EzE4yuBV;;EyEnzuBM;IAOI,yBAAA;EzEgzuBV;;EyEvzuBM;IAOI,0BAAA;EzEozuBV;;EyE3zuBM;IAOI,0BAAA;EzEwzuBV;;EyE/zuBM;IAOI,0BAAA;EzE4zuBV;;EyEn0uBM;IAOI,0BAAA;EzEg0uBV;;EyEv0uBM;IAOI,0BAAA;EzEo0uBV;;EyE30uBM;IAOI,0BAAA;EzEw0uBV;;EyE/0uBM;IAOI,0BAAA;EzE40uBV;;EyEn1uBM;IAOI,0BAAA;EzEg1uBV;;EyEv1uBM;IAOI,0BAAA;EzEo1uBV;;EyE31uBM;IAOI,0BAAA;EzEw1uBV;;EyE/1uBM;IAOI,0BAAA;EzE41uBV;;EyEn2uBM;IAOI,0BAAA;EzEg2uBV;;EyEv2uBM;IAOI,0BAAA;EzEo2uBV;;EyE32uBM;IAOI,0BAAA;EzEw2uBV;;EyE/2uBM;IAOI,0BAAA;EzE42uBV;;EyEn3uBM;IAOI,0BAAA;EzEg3uBV;;EyEv3uBM;IAOI,0BAAA;EzEo3uBV;;EyE33uBM;IAOI,0BAAA;EzEw3uBV;;EyE/3uBM;IAOI,2BAAA;EzE43uBV;;EyEn4uBM;IAOI,2BAAA;EzEg4uBV;;EyEv4uBM;IAOI,2BAAA;EzEo4uBV;;EyE34uBM;IAOI,2BAAA;EzEw4uBV;;EyE/4uBM;IAOI,2BAAA;EzE44uBV;;EyEn5uBM;IAOI,2BAAA;EzEg5uBV;;EyEv5uBM;IAOI,2BAAA;EzEo5uBV;;EyE35uBM;IAOI,2BAAA;EzEw5uBV;;EyE/5uBM;IAOI,2BAAA;EzE45uBV;;EyEn6uBM;IAOI,2BAAA;EzEg6uBV;;EyEv6uBM;IAOI,2BAAA;EzEo6uBV;;EyE36uBM;IAOI,2BAAA;EzEw6uBV;;EyE/6uBM;IAOI,2BAAA;EzE46uBV;;EyEn7uBM;IAOI,2BAAA;EzEg7uBV;;EyEv7uBM;IAOI,2BAAA;EzEo7uBV;;EyE37uBM;IAOI,2BAAA;EzEw7uBV;;EyE/7uBM;IAOI,2BAAA;EzE47uBV;;EyEn8uBM;IAOI,2BAAA;EzEg8uBV;;EyEv8uBM;IAOI,2BAAA;EzEo8uBV;;EyE38uBM;IAOI,2BAAA;EzEw8uBV;;EyE/8uBM;IAOI,2BAAA;EzE48uBV;;EyEn9uBM;IAOI,2BAAA;EzEg9uBV;;EyEv9uBM;IAOI,2BAAA;EzEo9uBV;;EyE39uBM;IAOI,2BAAA;EzEw9uBV;;EyE/9uBM;IAOI,2BAAA;EzE49uBV;;EyEn+uBM;IAOI,2BAAA;EzEg+uBV;;EyEv+uBM;IAOI,4BAAA;EzEo+uBV;;EyE3+uBM;IAOI,wBAAA;EzEw+uBV;;EyE/+uBM;IAOI,sBAAA;EzE4+uBV;;EyEn/uBM;IAOI,sBAAA;EzEg/uBV;;EyEv/uBM;IAOI,sBAAA;EzEo/uBV;;EyE3/uBM;IAOI,uBAAA;EzEw/uBV;;EyE//uBM;IAOI,uBAAA;EzE4/uBV;;EyEngvBM;IAOI,sBAAA;EzEggvBV;;EyEvgvBM;IAOI,sBAAA;EzEogvBV;;EyE3gvBM;IAOI,sBAAA;EzEwgvBV;;EyE/gvBM;IAOI,sBAAA;EzE4gvBV;;EyEnhvBM;IAOI,sBAAA;EzEghvBV;;EyEvhvBM;IAOI,sBAAA;EzEohvBV;;EyE3hvBM;IAOI,sBAAA;EzEwhvBV;;EyE/hvBM;IAOI,sBAAA;EzE4hvBV;;EyEnivBM;IAOI,sBAAA;EzEgivBV;;EyEvivBM;IAOI,uBAAA;EzEoivBV;;EyE3ivBM;IAOI,uBAAA;EzEwivBV;;EyE/ivBM;IAOI,uBAAA;EzE4ivBV;;EyEnjvBM;IAOI,uBAAA;EzEgjvBV;;EyEvjvBM;IAOI,uBAAA;EzEojvBV;;EyE3jvBM;IAOI,uBAAA;EzEwjvBV;;EyE/jvBM;IAOI,uBAAA;EzE4jvBV;;EyEnkvBM;IAOI,uBAAA;EzEgkvBV;;EyEvkvBM;IAOI,uBAAA;EzEokvBV;;EyE3kvBM;IAOI,uBAAA;EzEwkvBV;;EyE/kvBM;IAOI,uBAAA;EzE4kvBV;;EyEnlvBM;IAOI,uBAAA;EzEglvBV;;EyEvlvBM;IAOI,uBAAA;EzEolvBV;;EyE3lvBM;IAOI,uBAAA;EzEwlvBV;;EyE/lvBM;IAOI,uBAAA;EzE4lvBV;;EyEnmvBM;IAOI,uBAAA;EzEgmvBV;;EyEvmvBM;IAOI,uBAAA;EzEomvBV;;EyE3mvBM;IAOI,uBAAA;EzEwmvBV;;EyE/mvBM;IAOI,wBAAA;EzE4mvBV;;EyEnnvBM;IAOI,wBAAA;EzEgnvBV;;EyEvnvBM;IAOI,wBAAA;EzEonvBV;;EyE3nvBM;IAOI,wBAAA;EzEwnvBV;;EyE/nvBM;IAOI,wBAAA;EzE4nvBV;;EyEnovBM;IAOI,wBAAA;EzEgovBV;;EyEvovBM;IAOI,wBAAA;EzEoovBV;;EyE3ovBM;IAOI,wBAAA;EzEwovBV;;EyE/ovBM;IAOI,wBAAA;EzE4ovBV;;EyEnpvBM;IAOI,wBAAA;EzEgpvBV;;EyEvpvBM;IAOI,wBAAA;EzEopvBV;;EyE3pvBM;IAOI,wBAAA;EzEwpvBV;;EyE/pvBM;IAOI,wBAAA;EzE4pvBV;;EyEnqvBM;IAOI,wBAAA;EzEgqvBV;;EyEvqvBM;IAOI,wBAAA;EzEoqvBV;;EyE3qvBM;IAOI,wBAAA;EzEwqvBV;;EyE/qvBM;IAOI,wBAAA;EzE4qvBV;;EyEnrvBM;IAOI,wBAAA;EzEgrvBV;;EyEvrvBM;IAOI,wBAAA;EzEorvBV;;EyE3rvBM;IAOI,wBAAA;EzEwrvBV;;EyE/rvBM;IAOI,wBAAA;EzE4rvBV;;EyEnsvBM;IAOI,wBAAA;EzEgsvBV;;EyEvsvBM;IAOI,wBAAA;EzEosvBV;;EyE3svBM;IAOI,wBAAA;EzEwsvBV;;EyE/svBM;IAOI,wBAAA;EzE4svBV;;EyEntvBM;IAOI,wBAAA;EzEgtvBV;;EyEvtvBM;IAOI,yBAAA;EzEotvBV;;EyE3tvBM;IAOI,4BAAA;EzEwtvBV;;EyE/tvBM;IAOI,0BAAA;EzE4tvBV;;EyEnuvBM;IAOI,0BAAA;EzEguvBV;;EyEvuvBM;IAOI,0BAAA;EzEouvBV;;EyE3uvBM;IAOI,2BAAA;EzEwuvBV;;EyE/uvBM;IAOI,2BAAA;EzE4uvBV;;EyEnvvBM;IAOI,0BAAA;EzEgvvBV;;EyEvvvBM;IAOI,0BAAA;EzEovvBV;;EyE3vvBM;IAOI,0BAAA;EzEwvvBV;;EyE/vvBM;IAOI,0BAAA;EzE4vvBV;;EyEnwvBM;IAOI,0BAAA;EzEgwvBV;;EyEvwvBM;IAOI,0BAAA;EzEowvBV;;EyE3wvBM;IAOI,0BAAA;EzEwwvBV;;EyE/wvBM;IAOI,0BAAA;EzE4wvBV;;EyEnxvBM;IAOI,0BAAA;EzEgxvBV;;EyEvxvBM;IAOI,2BAAA;EzEoxvBV;;EyE3xvBM;IAOI,2BAAA;EzEwxvBV;;EyE/xvBM;IAOI,2BAAA;EzE4xvBV;;EyEnyvBM;IAOI,2BAAA;EzEgyvBV;;EyEvyvBM;IAOI,2BAAA;EzEoyvBV;;EyE3yvBM;IAOI,2BAAA;EzEwyvBV;;EyE/yvBM;IAOI,2BAAA;EzE4yvBV;;EyEnzvBM;IAOI,2BAAA;EzEgzvBV;;EyEvzvBM;IAOI,2BAAA;EzEozvBV;;EyE3zvBM;IAOI,2BAAA;EzEwzvBV;;EyE/zvBM;IAOI,2BAAA;EzE4zvBV;;EyEn0vBM;IAOI,2BAAA;EzEg0vBV;;EyEv0vBM;IAOI,2BAAA;EzEo0vBV;;EyE30vBM;IAOI,2BAAA;EzEw0vBV;;EyE/0vBM;IAOI,2BAAA;EzE40vBV;;EyEn1vBM;IAOI,2BAAA;EzEg1vBV;;EyEv1vBM;IAOI,2BAAA;EzEo1vBV;;EyE31vBM;IAOI,2BAAA;EzEw1vBV;;EyE/1vBM;IAOI,4BAAA;EzE41vBV;;EyEn2vBM;IAOI,4BAAA;EzEg2vBV;;EyEv2vBM;IAOI,4BAAA;EzEo2vBV;;EyE32vBM;IAOI,4BAAA;EzEw2vBV;;EyE/2vBM;IAOI,4BAAA;EzE42vBV;;EyEn3vBM;IAOI,4BAAA;EzEg3vBV;;EyEv3vBM;IAOI,4BAAA;EzEo3vBV;;EyE33vBM;IAOI,4BAAA;EzEw3vBV;;EyE/3vBM;IAOI,4BAAA;EzE43vBV;;EyEn4vBM;IAOI,4BAAA;EzEg4vBV;;EyEv4vBM;IAOI,4BAAA;EzEo4vBV;;EyE34vBM;IAOI,4BAAA;EzEw4vBV;;EyE/4vBM;IAOI,4BAAA;EzE44vBV;;EyEn5vBM;IAOI,4BAAA;EzEg5vBV;;EyEv5vBM;IAOI,4BAAA;EzEo5vBV;;EyE35vBM;IAOI,4BAAA;EzEw5vBV;;EyE/5vBM;IAOI,4BAAA;EzE45vBV;;EyEn6vBM;IAOI,4BAAA;EzEg6vBV;;EyEv6vBM;IAOI,4BAAA;EzEo6vBV;;EyE36vBM;IAOI,4BAAA;EzEw6vBV;;EyE/6vBM;IAOI,4BAAA;EzE46vBV;;EyEn7vBM;IAOI,4BAAA;EzEg7vBV;;EyEv7vBM;IAOI,4BAAA;EzEo7vBV;;EyE37vBM;IAOI,4BAAA;EzEw7vBV;;EyE/7vBM;IAOI,4BAAA;EzE47vBV;;EyEn8vBM;IAOI,4BAAA;EzEg8vBV;;EyEv8vBM;IAOI,6BAAA;EzEo8vBV;;EyE38vBM;IAOI,yBAAA;EzEw8vBV;;EyE/8vBM;IAOI,8BAAA;EzE48vBV;;EyEn9vBM;IAOI,iCAAA;EzEg9vBV;;EyEv9vBM;IAOI,sCAAA;EzEo9vBV;;EyE39vBM;IAOI,yCAAA;EzEw9vBV;;EyE/9vBM;IAOI,uBAAA;EzE49vBV;;EyEn+vBM;IAOI,uBAAA;EzEg+vBV;;EyEv+vBM;IAOI,yBAAA;EzEo+vBV;;EyE3+vBM;IAOI,yBAAA;EzEw+vBV;;EyE/+vBM;IAOI,0BAAA;EzE4+vBV;;EyEn/vBM;IAOI,4BAAA;EzEg/vBV;;EyEv/vBM;IAOI,kCAAA;EzEo/vBV;;EyE3/vBM;IAOI,sCAAA;EzEw/vBV;;EyE//vBM;IAOI,oCAAA;EzE4/vBV;;EyEngwBM;IAOI,kCAAA;EzEggwBV;;EyEvgwBM;IAOI,yCAAA;EzEogwBV;;EyE3gwBM;IAOI,wCAAA;EzEwgwBV;;EyE/gwBM;IAOI,wCAAA;EzE4gwBV;;EyEnhwBM;IAOI,kCAAA;EzEghwBV;;EyEvhwBM;IAOI,gCAAA;EzEohwBV;;EyE3hwBM;IAOI,8BAAA;EzEwhwBV;;EyE/hwBM;IAOI,gCAAA;EzE4hwBV;;EyEniwBM;IAOI,+BAAA;EzEgiwBV;;EyEviwBM;IAOI,oCAAA;EzEoiwBV;;EyE3iwBM;IAOI,kCAAA;EzEwiwBV;;EyE/iwBM;IAOI,gCAAA;EzE4iwBV;;EyEnjwBM;IAOI,uCAAA;EzEgjwBV;;EyEvjwBM;IAOI,sCAAA;EzEojwBV;;EyE3jwBM;IAOI,iCAAA;EzEwjwBV;;EyE/jwBM;IAOI,2BAAA;EzE4jwBV;;EyEnkwBM;IAOI,iCAAA;EzEgkwBV;;EyEvkwBM;IAOI,+BAAA;EzEokwBV;;EyE3kwBM;IAOI,6BAAA;EzEwkwBV;;EyE/kwBM;IAOI,+BAAA;EzE4kwBV;;EyEnlwBM;IAOI,8BAAA;EzEglwBV;;EyEvlwBM;IAOI,oBAAA;EzEolwBV;;EyE3lwBM;IAOI,mBAAA;EzEwlwBV;;EyE/lwBM;IAOI,mBAAA;EzE4lwBV;;EyEnmwBM;IAOI,mBAAA;EzEgmwBV;;EyEvmwBM;IAOI,mBAAA;EzEomwBV;;EyE3mwBM;IAOI,mBAAA;EzEwmwBV;;EyE/mwBM;IAOI,mBAAA;EzE4mwBV;;EyEnnwBM;IAOI,mBAAA;EzEgnwBV;;EyEvnwBM;IAOI,oBAAA;EzEonwBV;;EyE3nwBM;IAOI,0BAAA;EzEwnwBV;;EyE/nwBM;IAOI,yBAAA;EzE4nwBV;;EyEnowBM;IAOI,0BAAA;EzEgowBV;;EyEvowBM;IAOI,uBAAA;EzEoowBV;;EyE3owBM;IAOI,0BAAA;EzEwowBV;;EyE/owBM;IAOI,yBAAA;EzE4owBV;;EyEnpwBM;IAOI,0BAAA;EzEgpwBV;;EyEvpwBM;IAOI,uBAAA;EzEopwBV;;EyE3pwBM;IAOI,0BAAA;EzEwpwBV;;EyE/pwBM;IAOI,yBAAA;EzE4pwBV;;EyEnqwBM;IAOI,0BAAA;EzEgqwBV;;EyEvqwBM;IAOI,uBAAA;EzEoqwBV;;EyE3qwBM;IAOI,0BAAA;EzEwqwBV;;EyE/qwBM;IAOI,yBAAA;EzE4qwBV;;EyEnrwBM;IAOI,0BAAA;EzEgrwBV;;EyEvrwBM;IAOI,uBAAA;EzEorwBV;;EyE3rwBM;IAOI,0BAAA;EzEwrwBV;;EyE/rwBM;IAOI,yBAAA;EzE4rwBV;;EyEnswBM;IAOI,0BAAA;EzEgswBV;;EyEvswBM;IAOI,uBAAA;EzEoswBV;;EyE3swBM;IAOI,uBAAA;EzEwswBV;;EyE/swBM;IAOI,0BAAA;IAAA,yBAAA;EzE6swBV;;EyEptwBM;IAOI,gCAAA;IAAA,+BAAA;EzEktwBV;;EyEztwBM;IAOI,+BAAA;IAAA,8BAAA;EzEutwBV;;EyE9twBM;IAOI,gCAAA;IAAA,+BAAA;EzE4twBV;;EyEnuwBM;IAOI,6BAAA;IAAA,4BAAA;EzEiuwBV;;EyExuwBM;IAOI,gCAAA;IAAA,+BAAA;EzEsuwBV;;EyE7uwBM;IAOI,+BAAA;IAAA,8BAAA;EzE2uwBV;;EyElvwBM;IAOI,gCAAA;IAAA,+BAAA;EzEgvwBV;;EyEvvwBM;IAOI,6BAAA;IAAA,4BAAA;EzEqvwBV;;EyE5vwBM;IAOI,gCAAA;IAAA,+BAAA;EzE0vwBV;;EyEjwwBM;IAOI,+BAAA;IAAA,8BAAA;EzE+vwBV;;EyEtwwBM;IAOI,gCAAA;IAAA,+BAAA;EzEowwBV;;EyE3wwBM;IAOI,6BAAA;IAAA,4BAAA;EzEywwBV;;EyEhxwBM;IAOI,gCAAA;IAAA,+BAAA;EzE8wwBV;;EyErxwBM;IAOI,+BAAA;IAAA,8BAAA;EzEmxwBV;;EyE1xwBM;IAOI,gCAAA;IAAA,+BAAA;EzEwxwBV;;EyE/xwBM;IAOI,6BAAA;IAAA,4BAAA;EzE6xwBV;;EyEpywBM;IAOI,gCAAA;IAAA,+BAAA;EzEkywBV;;EyEzywBM;IAOI,+BAAA;IAAA,8BAAA;EzEuywBV;;EyE9ywBM;IAOI,gCAAA;IAAA,+BAAA;EzE4ywBV;;EyEnzwBM;IAOI,6BAAA;IAAA,4BAAA;EzEizwBV;;EyExzwBM;IAOI,6BAAA;IAAA,4BAAA;EzEszwBV;;EyE7zwBM;IAOI,wBAAA;IAAA,2BAAA;EzE2zwBV;;EyEl0wBM;IAOI,8BAAA;IAAA,iCAAA;EzEg0wBV;;EyEv0wBM;IAOI,6BAAA;IAAA,gCAAA;EzEq0wBV;;EyE50wBM;IAOI,8BAAA;IAAA,iCAAA;EzE00wBV;;EyEj1wBM;IAOI,2BAAA;IAAA,8BAAA;EzE+0wBV;;EyEt1wBM;IAOI,8BAAA;IAAA,iCAAA;EzEo1wBV;;EyE31wBM;IAOI,6BAAA;IAAA,gCAAA;EzEy1wBV;;EyEh2wBM;IAOI,8BAAA;IAAA,iCAAA;EzE81wBV;;EyEr2wBM;IAOI,2BAAA;IAAA,8BAAA;EzEm2wBV;;EyE12wBM;IAOI,8BAAA;IAAA,iCAAA;EzEw2wBV;;EyE/2wBM;IAOI,6BAAA;IAAA,gCAAA;EzE62wBV;;EyEp3wBM;IAOI,8BAAA;IAAA,iCAAA;EzEk3wBV;;EyEz3wBM;IAOI,2BAAA;IAAA,8BAAA;EzEu3wBV;;EyE93wBM;IAOI,8BAAA;IAAA,iCAAA;EzE43wBV;;EyEn4wBM;IAOI,6BAAA;IAAA,gCAAA;EzEi4wBV;;EyEx4wBM;IAOI,8BAAA;IAAA,iCAAA;EzEs4wBV;;EyE74wBM;IAOI,2BAAA;IAAA,8BAAA;EzE24wBV;;EyEl5wBM;IAOI,8BAAA;IAAA,iCAAA;EzEg5wBV;;EyEv5wBM;IAOI,6BAAA;IAAA,gCAAA;EzEq5wBV;;EyE55wBM;IAOI,8BAAA;IAAA,iCAAA;EzE05wBV;;EyEj6wBM;IAOI,2BAAA;IAAA,8BAAA;EzE+5wBV;;EyEt6wBM;IAOI,2BAAA;IAAA,8BAAA;EzEo6wBV;;EyE36wBM;IAOI,wBAAA;EzEw6wBV;;EyE/6wBM;IAOI,8BAAA;EzE46wBV;;EyEn7wBM;IAOI,6BAAA;EzEg7wBV;;EyEv7wBM;IAOI,8BAAA;EzEo7wBV;;EyE37wBM;IAOI,2BAAA;EzEw7wBV;;EyE/7wBM;IAOI,8BAAA;EzE47wBV;;EyEn8wBM;IAOI,6BAAA;EzEg8wBV;;EyEv8wBM;IAOI,8BAAA;EzEo8wBV;;EyE38wBM;IAOI,2BAAA;EzEw8wBV;;EyE/8wBM;IAOI,8BAAA;EzE48wBV;;EyEn9wBM;IAOI,6BAAA;EzEg9wBV;;EyEv9wBM;IAOI,8BAAA;EzEo9wBV;;EyE39wBM;IAOI,2BAAA;EzEw9wBV;;EyE/9wBM;IAOI,8BAAA;EzE49wBV;;EyEn+wBM;IAOI,6BAAA;EzEg+wBV;;EyEv+wBM;IAOI,8BAAA;EzEo+wBV;;EyE3+wBM;IAOI,2BAAA;EzEw+wBV;;EyE/+wBM;IAOI,8BAAA;EzE4+wBV;;EyEn/wBM;IAOI,6BAAA;EzEg/wBV;;EyEv/wBM;IAOI,8BAAA;EzEo/wBV;;EyE3/wBM;IAOI,2BAAA;EzEw/wBV;;EyE//wBM;IAOI,2BAAA;EzE4/wBV;;EyEngxBM;IAOI,0BAAA;EzEggxBV;;EyEvgxBM;IAOI,gCAAA;EzEogxBV;;EyE3gxBM;IAOI,+BAAA;EzEwgxBV;;EyE/gxBM;IAOI,gCAAA;EzE4gxBV;;EyEnhxBM;IAOI,6BAAA;EzEghxBV;;EyEvhxBM;IAOI,gCAAA;EzEohxBV;;EyE3hxBM;IAOI,+BAAA;EzEwhxBV;;EyE/hxBM;IAOI,gCAAA;EzE4hxBV;;EyEnixBM;IAOI,6BAAA;EzEgixBV;;EyEvixBM;IAOI,gCAAA;EzEoixBV;;EyE3ixBM;IAOI,+BAAA;EzEwixBV;;EyE/ixBM;IAOI,gCAAA;EzE4ixBV;;EyEnjxBM;IAOI,6BAAA;EzEgjxBV;;EyEvjxBM;IAOI,gCAAA;EzEojxBV;;EyE3jxBM;IAOI,+BAAA;EzEwjxBV;;EyE/jxBM;IAOI,gCAAA;EzE4jxBV;;EyEnkxBM;IAOI,6BAAA;EzEgkxBV;;EyEvkxBM;IAOI,gCAAA;EzEokxBV;;EyE3kxBM;IAOI,+BAAA;EzEwkxBV;;EyE/kxBM;IAOI,gCAAA;EzE4kxBV;;EyEnlxBM;IAOI,6BAAA;EzEglxBV;;EyEvlxBM;IAOI,6BAAA;EzEolxBV;;EyE3lxBM;IAOI,2BAAA;EzEwlxBV;;EyE/lxBM;IAOI,iCAAA;EzE4lxBV;;EyEnmxBM;IAOI,gCAAA;EzEgmxBV;;EyEvmxBM;IAOI,iCAAA;EzEomxBV;;EyE3mxBM;IAOI,8BAAA;EzEwmxBV;;EyE/mxBM;IAOI,iCAAA;EzE4mxBV;;EyEnnxBM;IAOI,gCAAA;EzEgnxBV;;EyEvnxBM;IAOI,iCAAA;EzEonxBV;;EyE3nxBM;IAOI,8BAAA;EzEwnxBV;;EyE/nxBM;IAOI,iCAAA;EzE4nxBV;;EyEnoxBM;IAOI,gCAAA;EzEgoxBV;;EyEvoxBM;IAOI,iCAAA;EzEooxBV;;EyE3oxBM;IAOI,8BAAA;EzEwoxBV;;EyE/oxBM;IAOI,iCAAA;EzE4oxBV;;EyEnpxBM;IAOI,gCAAA;EzEgpxBV;;EyEvpxBM;IAOI,iCAAA;EzEopxBV;;EyE3pxBM;IAOI,8BAAA;EzEwpxBV;;EyE/pxBM;IAOI,iCAAA;EzE4pxBV;;EyEnqxBM;IAOI,gCAAA;EzEgqxBV;;EyEvqxBM;IAOI,iCAAA;EzEoqxBV;;EyE3qxBM;IAOI,8BAAA;EzEwqxBV;;EyE/qxBM;IAOI,8BAAA;EzE4qxBV;;EyEnrxBM;IAOI,yBAAA;EzEgrxBV;;EyEvrxBM;IAOI,+BAAA;EzEorxBV;;EyE3rxBM;IAOI,8BAAA;EzEwrxBV;;EyE/rxBM;IAOI,+BAAA;EzE4rxBV;;EyEnsxBM;IAOI,4BAAA;EzEgsxBV;;EyEvsxBM;IAOI,+BAAA;EzEosxBV;;EyE3sxBM;IAOI,8BAAA;EzEwsxBV;;EyE/sxBM;IAOI,+BAAA;EzE4sxBV;;EyEntxBM;IAOI,4BAAA;EzEgtxBV;;EyEvtxBM;IAOI,+BAAA;EzEotxBV;;EyE3txBM;IAOI,8BAAA;EzEwtxBV;;EyE/txBM;IAOI,+BAAA;EzE4txBV;;EyEnuxBM;IAOI,4BAAA;EzEguxBV;;EyEvuxBM;IAOI,+BAAA;EzEouxBV;;EyE3uxBM;IAOI,8BAAA;EzEwuxBV;;EyE/uxBM;IAOI,+BAAA;EzE4uxBV;;EyEnvxBM;IAOI,4BAAA;EzEgvxBV;;EyEvvxBM;IAOI,+BAAA;EzEovxBV;;EyE3vxBM;IAOI,8BAAA;EzEwvxBV;;EyE/vxBM;IAOI,+BAAA;EzE4vxBV;;EyEnwxBM;IAOI,4BAAA;EzEgwxBV;;EyEvwxBM;IAOI,4BAAA;EzEowxBV;;EyE3wxBM;IAOI,2BAAA;EzEwwxBV;;EyE/wxBM;IAOI,0BAAA;EzE4wxBV;;EyEnxxBM;IAOI,2BAAA;EzEgxxBV;;EyEvxxBM;IAOI,wBAAA;EzEoxxBV;;EyE3xxBM;IAOI,2BAAA;EzEwxxBV;;EyE/xxBM;IAOI,0BAAA;EzE4xxBV;;EyEnyxBM;IAOI,2BAAA;EzEgyxBV;;EyEvyxBM;IAOI,wBAAA;EzEoyxBV;;EyE3yxBM;IAOI,2BAAA;EzEwyxBV;;EyE/yxBM;IAOI,0BAAA;EzE4yxBV;;EyEnzxBM;IAOI,2BAAA;EzEgzxBV;;EyEvzxBM;IAOI,wBAAA;EzEozxBV;;EyE3zxBM;IAOI,2BAAA;EzEwzxBV;;EyE/zxBM;IAOI,0BAAA;EzE4zxBV;;EyEn0xBM;IAOI,2BAAA;EzEg0xBV;;EyEv0xBM;IAOI,wBAAA;EzEo0xBV;;EyE30xBM;IAOI,2BAAA;EzEw0xBV;;EyE/0xBM;IAOI,0BAAA;EzE40xBV;;EyEn1xBM;IAOI,2BAAA;EzEg1xBV;;EyEv1xBM;IAOI,wBAAA;EzEo1xBV;;EyE31xBM;IAOI,iCAAA;IAAA,gCAAA;EzEy1xBV;;EyEh2xBM;IAOI,gCAAA;IAAA,+BAAA;EzE81xBV;;EyEr2xBM;IAOI,iCAAA;IAAA,gCAAA;EzEm2xBV;;EyE12xBM;IAOI,8BAAA;IAAA,6BAAA;EzEw2xBV;;EyE/2xBM;IAOI,iCAAA;IAAA,gCAAA;EzE62xBV;;EyEp3xBM;IAOI,gCAAA;IAAA,+BAAA;EzEk3xBV;;EyEz3xBM;IAOI,iCAAA;IAAA,gCAAA;EzEu3xBV;;EyE93xBM;IAOI,8BAAA;IAAA,6BAAA;EzE43xBV;;EyEn4xBM;IAOI,iCAAA;IAAA,gCAAA;EzEi4xBV;;EyEx4xBM;IAOI,gCAAA;IAAA,+BAAA;EzEs4xBV;;EyE74xBM;IAOI,iCAAA;IAAA,gCAAA;EzE24xBV;;EyEl5xBM;IAOI,8BAAA;IAAA,6BAAA;EzEg5xBV;;EyEv5xBM;IAOI,iCAAA;IAAA,gCAAA;EzEq5xBV;;EyE55xBM;IAOI,gCAAA;IAAA,+BAAA;EzE05xBV;;EyEj6xBM;IAOI,iCAAA;IAAA,gCAAA;EzE+5xBV;;EyEt6xBM;IAOI,8BAAA;IAAA,6BAAA;EzEo6xBV;;EyE36xBM;IAOI,iCAAA;IAAA,gCAAA;EzEy6xBV;;EyEh7xBM;IAOI,gCAAA;IAAA,+BAAA;EzE86xBV;;EyEr7xBM;IAOI,iCAAA;IAAA,gCAAA;EzEm7xBV;;EyE17xBM;IAOI,8BAAA;IAAA,6BAAA;EzEw7xBV;;EyE/7xBM;IAOI,+BAAA;IAAA,kCAAA;EzE67xBV;;EyEp8xBM;IAOI,8BAAA;IAAA,iCAAA;EzEk8xBV;;EyEz8xBM;IAOI,+BAAA;IAAA,kCAAA;EzEu8xBV;;EyE98xBM;IAOI,4BAAA;IAAA,+BAAA;EzE48xBV;;EyEn9xBM;IAOI,+BAAA;IAAA,kCAAA;EzEi9xBV;;EyEx9xBM;IAOI,8BAAA;IAAA,iCAAA;EzEs9xBV;;EyE79xBM;IAOI,+BAAA;IAAA,kCAAA;EzE29xBV;;EyEl+xBM;IAOI,4BAAA;IAAA,+BAAA;EzEg+xBV;;EyEv+xBM;IAOI,+BAAA;IAAA,kCAAA;EzEq+xBV;;EyE5+xBM;IAOI,8BAAA;IAAA,iCAAA;EzE0+xBV;;EyEj/xBM;IAOI,+BAAA;IAAA,kCAAA;EzE++xBV;;EyEt/xBM;IAOI,4BAAA;IAAA,+BAAA;EzEo/xBV;;EyE3/xBM;IAOI,+BAAA;IAAA,kCAAA;EzEy/xBV;;EyEhgyBM;IAOI,8BAAA;IAAA,iCAAA;EzE8/xBV;;EyErgyBM;IAOI,+BAAA;IAAA,kCAAA;EzEmgyBV;;EyE1gyBM;IAOI,4BAAA;IAAA,+BAAA;EzEwgyBV;;EyE/gyBM;IAOI,+BAAA;IAAA,kCAAA;EzE6gyBV;;EyEphyBM;IAOI,8BAAA;IAAA,iCAAA;EzEkhyBV;;EyEzhyBM;IAOI,+BAAA;IAAA,kCAAA;EzEuhyBV;;EyE9hyBM;IAOI,4BAAA;IAAA,+BAAA;EzE4hyBV;;EyEniyBM;IAOI,+BAAA;EzEgiyBV;;EyEviyBM;IAOI,8BAAA;EzEoiyBV;;EyE3iyBM;IAOI,+BAAA;EzEwiyBV;;EyE/iyBM;IAOI,4BAAA;EzE4iyBV;;EyEnjyBM;IAOI,+BAAA;EzEgjyBV;;EyEvjyBM;IAOI,8BAAA;EzEojyBV;;EyE3jyBM;IAOI,+BAAA;EzEwjyBV;;EyE/jyBM;IAOI,4BAAA;EzE4jyBV;;EyEnkyBM;IAOI,+BAAA;EzEgkyBV;;EyEvkyBM;IAOI,8BAAA;EzEokyBV;;EyE3kyBM;IAOI,+BAAA;EzEwkyBV;;EyE/kyBM;IAOI,4BAAA;EzE4kyBV;;EyEnlyBM;IAOI,+BAAA;EzEglyBV;;EyEvlyBM;IAOI,8BAAA;EzEolyBV;;EyE3lyBM;IAOI,+BAAA;EzEwlyBV;;EyE/lyBM;IAOI,4BAAA;EzE4lyBV;;EyEnmyBM;IAOI,+BAAA;EzEgmyBV;;EyEvmyBM;IAOI,8BAAA;EzEomyBV;;EyE3myBM;IAOI,+BAAA;EzEwmyBV;;EyE/myBM;IAOI,4BAAA;EzE4myBV;;EyEnnyBM;IAOI,iCAAA;EzEgnyBV;;EyEvnyBM;IAOI,gCAAA;EzEonyBV;;EyE3nyBM;IAOI,iCAAA;EzEwnyBV;;EyE/nyBM;IAOI,8BAAA;EzE4nyBV;;EyEnoyBM;IAOI,iCAAA;EzEgoyBV;;EyEvoyBM;IAOI,gCAAA;EzEooyBV;;EyE3oyBM;IAOI,iCAAA;EzEwoyBV;;EyE/oyBM;IAOI,8BAAA;EzE4oyBV;;EyEnpyBM;IAOI,iCAAA;EzEgpyBV;;EyEvpyBM;IAOI,gCAAA;EzEopyBV;;EyE3pyBM;IAOI,iCAAA;EzEwpyBV;;EyE/pyBM;IAOI,8BAAA;EzE4pyBV;;EyEnqyBM;IAOI,iCAAA;EzEgqyBV;;EyEvqyBM;IAOI,gCAAA;EzEoqyBV;;EyE3qyBM;IAOI,iCAAA;EzEwqyBV;;EyE/qyBM;IAOI,8BAAA;EzE4qyBV;;EyEnryBM;IAOI,iCAAA;EzEgryBV;;EyEvryBM;IAOI,gCAAA;EzEoryBV;;EyE3ryBM;IAOI,iCAAA;EzEwryBV;;EyE/ryBM;IAOI,8BAAA;EzE4ryBV;;EyEnsyBM;IAOI,kCAAA;EzEgsyBV;;EyEvsyBM;IAOI,iCAAA;EzEosyBV;;EyE3syBM;IAOI,kCAAA;EzEwsyBV;;EyE/syBM;IAOI,+BAAA;EzE4syBV;;EyEntyBM;IAOI,kCAAA;EzEgtyBV;;EyEvtyBM;IAOI,iCAAA;EzEotyBV;;EyE3tyBM;IAOI,kCAAA;EzEwtyBV;;EyE/tyBM;IAOI,+BAAA;EzE4tyBV;;EyEnuyBM;IAOI,kCAAA;EzEguyBV;;EyEvuyBM;IAOI,iCAAA;EzEouyBV;;EyE3uyBM;IAOI,kCAAA;EzEwuyBV;;EyE/uyBM;IAOI,+BAAA;EzE4uyBV;;EyEnvyBM;IAOI,kCAAA;EzEgvyBV;;EyEvvyBM;IAOI,iCAAA;EzEovyBV;;EyE3vyBM;IAOI,kCAAA;EzEwvyBV;;EyE/vyBM;IAOI,+BAAA;EzE4vyBV;;EyEnwyBM;IAOI,kCAAA;EzEgwyBV;;EyEvwyBM;IAOI,iCAAA;EzEowyBV;;EyE3wyBM;IAOI,kCAAA;EzEwwyBV;;EyE/wyBM;IAOI,+BAAA;EzE4wyBV;;EyEnxyBM;IAOI,gCAAA;EzEgxyBV;;EyEvxyBM;IAOI,+BAAA;EzEoxyBV;;EyE3xyBM;IAOI,gCAAA;EzEwxyBV;;EyE/xyBM;IAOI,6BAAA;EzE4xyBV;;EyEnyyBM;IAOI,gCAAA;EzEgyyBV;;EyEvyyBM;IAOI,+BAAA;EzEoyyBV;;EyE3yyBM;IAOI,gCAAA;EzEwyyBV;;EyE/yyBM;IAOI,6BAAA;EzE4yyBV;;EyEnzyBM;IAOI,gCAAA;EzEgzyBV;;EyEvzyBM;IAOI,+BAAA;EzEozyBV;;EyE3zyBM;IAOI,gCAAA;EzEwzyBV;;EyE/zyBM;IAOI,6BAAA;EzE4zyBV;;EyEn0yBM;IAOI,gCAAA;EzEg0yBV;;EyEv0yBM;IAOI,+BAAA;EzEo0yBV;;EyE30yBM;IAOI,gCAAA;EzEw0yBV;;EyE/0yBM;IAOI,6BAAA;EzE40yBV;;EyEn1yBM;IAOI,gCAAA;EzEg1yBV;;EyEv1yBM;IAOI,+BAAA;EzEo1yBV;;EyE31yBM;IAOI,gCAAA;EzEw1yBV;;EyE/1yBM;IAOI,6BAAA;EzE41yBV;;EyEn2yBM;IAOI,qBAAA;EzEg2yBV;;EyEv2yBM;IAOI,2BAAA;EzEo2yBV;;EyE32yBM;IAOI,0BAAA;EzEw2yBV;;EyE/2yBM;IAOI,2BAAA;EzE42yBV;;EyEn3yBM;IAOI,wBAAA;EzEg3yBV;;EyEv3yBM;IAOI,2BAAA;EzEo3yBV;;EyE33yBM;IAOI,0BAAA;EzEw3yBV;;EyE/3yBM;IAOI,2BAAA;EzE43yBV;;EyEn4yBM;IAOI,wBAAA;EzEg4yBV;;EyEv4yBM;IAOI,2BAAA;EzEo4yBV;;EyE34yBM;IAOI,0BAAA;EzEw4yBV;;EyE/4yBM;IAOI,2BAAA;EzE44yBV;;EyEn5yBM;IAOI,wBAAA;EzEg5yBV;;EyEv5yBM;IAOI,2BAAA;EzEo5yBV;;EyE35yBM;IAOI,0BAAA;EzEw5yBV;;EyE/5yBM;IAOI,2BAAA;EzE45yBV;;EyEn6yBM;IAOI,wBAAA;EzEg6yBV;;EyEv6yBM;IAOI,2BAAA;EzEo6yBV;;EyE36yBM;IAOI,0BAAA;EzEw6yBV;;EyE/6yBM;IAOI,2BAAA;EzE46yBV;;EyEn7yBM;IAOI,wBAAA;EzEg7yBV;;EyEv7yBM;IAOI,2BAAA;IAAA,0BAAA;EzEq7yBV;;EyE57yBM;IAOI,iCAAA;IAAA,gCAAA;EzE07yBV;;EyEj8yBM;IAOI,gCAAA;IAAA,+BAAA;EzE+7yBV;;EyEt8yBM;IAOI,iCAAA;IAAA,gCAAA;EzEo8yBV;;EyE38yBM;IAOI,8BAAA;IAAA,6BAAA;EzEy8yBV;;EyEh9yBM;IAOI,iCAAA;IAAA,gCAAA;EzE88yBV;;EyEr9yBM;IAOI,gCAAA;IAAA,+BAAA;EzEm9yBV;;EyE19yBM;IAOI,iCAAA;IAAA,gCAAA;EzEw9yBV;;EyE/9yBM;IAOI,8BAAA;IAAA,6BAAA;EzE69yBV;;EyEp+yBM;IAOI,iCAAA;IAAA,gCAAA;EzEk+yBV;;EyEz+yBM;IAOI,gCAAA;IAAA,+BAAA;EzEu+yBV;;EyE9+yBM;IAOI,iCAAA;IAAA,gCAAA;EzE4+yBV;;EyEn/yBM;IAOI,8BAAA;IAAA,6BAAA;EzEi/yBV;;EyEx/yBM;IAOI,iCAAA;IAAA,gCAAA;EzEs/yBV;;EyE7/yBM;IAOI,gCAAA;IAAA,+BAAA;EzE2/yBV;;EyElgzBM;IAOI,iCAAA;IAAA,gCAAA;EzEggzBV;;EyEvgzBM;IAOI,8BAAA;IAAA,6BAAA;EzEqgzBV;;EyE5gzBM;IAOI,iCAAA;IAAA,gCAAA;EzE0gzBV;;EyEjhzBM;IAOI,gCAAA;IAAA,+BAAA;EzE+gzBV;;EyEthzBM;IAOI,iCAAA;IAAA,gCAAA;EzEohzBV;;EyE3hzBM;IAOI,8BAAA;IAAA,6BAAA;EzEyhzBV;;EyEhizBM;IAOI,yBAAA;IAAA,4BAAA;EzE8hzBV;;EyErizBM;IAOI,+BAAA;IAAA,kCAAA;EzEmizBV;;EyE1izBM;IAOI,8BAAA;IAAA,iCAAA;EzEwizBV;;EyE/izBM;IAOI,+BAAA;IAAA,kCAAA;EzE6izBV;;EyEpjzBM;IAOI,4BAAA;IAAA,+BAAA;EzEkjzBV;;EyEzjzBM;IAOI,+BAAA;IAAA,kCAAA;EzEujzBV;;EyE9jzBM;IAOI,8BAAA;IAAA,iCAAA;EzE4jzBV;;EyEnkzBM;IAOI,+BAAA;IAAA,kCAAA;EzEikzBV;;EyExkzBM;IAOI,4BAAA;IAAA,+BAAA;EzEskzBV;;EyE7kzBM;IAOI,+BAAA;IAAA,kCAAA;EzE2kzBV;;EyEllzBM;IAOI,8BAAA;IAAA,iCAAA;EzEglzBV;;EyEvlzBM;IAOI,+BAAA;IAAA,kCAAA;EzEqlzBV;;EyE5lzBM;IAOI,4BAAA;IAAA,+BAAA;EzE0lzBV;;EyEjmzBM;IAOI,+BAAA;IAAA,kCAAA;EzE+lzBV;;EyEtmzBM;IAOI,8BAAA;IAAA,iCAAA;EzEomzBV;;EyE3mzBM;IAOI,+BAAA;IAAA,kCAAA;EzEymzBV;;EyEhnzBM;IAOI,4BAAA;IAAA,+BAAA;EzE8mzBV;;EyErnzBM;IAOI,+BAAA;IAAA,kCAAA;EzEmnzBV;;EyE1nzBM;IAOI,8BAAA;IAAA,iCAAA;EzEwnzBV;;EyE/nzBM;IAOI,+BAAA;IAAA,kCAAA;EzE6nzBV;;EyEpozBM;IAOI,4BAAA;IAAA,+BAAA;EzEkozBV;;EyEzozBM;IAOI,yBAAA;EzEsozBV;;EyE7ozBM;IAOI,+BAAA;EzE0ozBV;;EyEjpzBM;IAOI,8BAAA;EzE8ozBV;;EyErpzBM;IAOI,+BAAA;EzEkpzBV;;EyEzpzBM;IAOI,4BAAA;EzEspzBV;;EyE7pzBM;IAOI,+BAAA;EzE0pzBV;;EyEjqzBM;IAOI,8BAAA;EzE8pzBV;;EyErqzBM;IAOI,+BAAA;EzEkqzBV;;EyEzqzBM;IAOI,4BAAA;EzEsqzBV;;EyE7qzBM;IAOI,+BAAA;EzE0qzBV;;EyEjrzBM;IAOI,8BAAA;EzE8qzBV;;EyErrzBM;IAOI,+BAAA;EzEkrzBV;;EyEzrzBM;IAOI,4BAAA;EzEsrzBV;;EyE7rzBM;IAOI,+BAAA;EzE0rzBV;;EyEjszBM;IAOI,8BAAA;EzE8rzBV;;EyErszBM;IAOI,+BAAA;EzEkszBV;;EyEzszBM;IAOI,4BAAA;EzEsszBV;;EyE7szBM;IAOI,+BAAA;EzE0szBV;;EyEjtzBM;IAOI,8BAAA;EzE8szBV;;EyErtzBM;IAOI,+BAAA;EzEktzBV;;EyEztzBM;IAOI,4BAAA;EzEstzBV;;EyE7tzBM;IAOI,2BAAA;EzE0tzBV;;EyEjuzBM;IAOI,iCAAA;EzE8tzBV;;EyEruzBM;IAOI,gCAAA;EzEkuzBV;;EyEzuzBM;IAOI,iCAAA;EzEsuzBV;;EyE7uzBM;IAOI,8BAAA;EzE0uzBV;;EyEjvzBM;IAOI,iCAAA;EzE8uzBV;;EyErvzBM;IAOI,gCAAA;EzEkvzBV;;EyEzvzBM;IAOI,iCAAA;EzEsvzBV;;EyE7vzBM;IAOI,8BAAA;EzE0vzBV;;EyEjwzBM;IAOI,iCAAA;EzE8vzBV;;EyErwzBM;IAOI,gCAAA;EzEkwzBV;;EyEzwzBM;IAOI,iCAAA;EzEswzBV;;EyE7wzBM;IAOI,8BAAA;EzE0wzBV;;EyEjxzBM;IAOI,iCAAA;EzE8wzBV;;EyErxzBM;IAOI,gCAAA;EzEkxzBV;;EyEzxzBM;IAOI,iCAAA;EzEsxzBV;;EyE7xzBM;IAOI,8BAAA;EzE0xzBV;;EyEjyzBM;IAOI,iCAAA;EzE8xzBV;;EyEryzBM;IAOI,gCAAA;EzEkyzBV;;EyEzyzBM;IAOI,iCAAA;EzEsyzBV;;EyE7yzBM;IAOI,8BAAA;EzE0yzBV;;EyEjzzBM;IAOI,4BAAA;EzE8yzBV;;EyErzzBM;IAOI,kCAAA;EzEkzzBV;;EyEzzzBM;IAOI,iCAAA;EzEszzBV;;EyE7zzBM;IAOI,kCAAA;EzE0zzBV;;EyEj0zBM;IAOI,+BAAA;EzE8zzBV;;EyEr0zBM;IAOI,kCAAA;EzEk0zBV;;EyEz0zBM;IAOI,iCAAA;EzEs0zBV;;EyE70zBM;IAOI,kCAAA;EzE00zBV;;EyEj1zBM;IAOI,+BAAA;EzE80zBV;;EyEr1zBM;IAOI,kCAAA;EzEk1zBV;;EyEz1zBM;IAOI,iCAAA;EzEs1zBV;;EyE71zBM;IAOI,kCAAA;EzE01zBV;;EyEj2zBM;IAOI,+BAAA;EzE81zBV;;EyEr2zBM;IAOI,kCAAA;EzEk2zBV;;EyEz2zBM;IAOI,iCAAA;EzEs2zBV;;EyE72zBM;IAOI,kCAAA;EzE02zBV;;EyEj3zBM;IAOI,+BAAA;EzE82zBV;;EyEr3zBM;IAOI,kCAAA;EzEk3zBV;;EyEz3zBM;IAOI,iCAAA;EzEs3zBV;;EyE73zBM;IAOI,kCAAA;EzE03zBV;;EyEj4zBM;IAOI,+BAAA;EzE83zBV;;EyEr4zBM;IAOI,0BAAA;EzEk4zBV;;EyEz4zBM;IAOI,gCAAA;EzEs4zBV;;EyE74zBM;IAOI,+BAAA;EzE04zBV;;EyEj5zBM;IAOI,gCAAA;EzE84zBV;;EyEr5zBM;IAOI,6BAAA;EzEk5zBV;;EyEz5zBM;IAOI,gCAAA;EzEs5zBV;;EyE75zBM;IAOI,+BAAA;EzE05zBV;;EyEj6zBM;IAOI,gCAAA;EzE85zBV;;EyEr6zBM;IAOI,6BAAA;EzEk6zBV;;EyEz6zBM;IAOI,gCAAA;EzEs6zBV;;EyE76zBM;IAOI,+BAAA;EzE06zBV;;EyEj7zBM;IAOI,gCAAA;EzE86zBV;;EyEr7zBM;IAOI,6BAAA;EzEk7zBV;;EyEz7zBM;IAOI,gCAAA;EzEs7zBV;;EyE77zBM;IAOI,+BAAA;EzE07zBV;;EyEj8zBM;IAOI,gCAAA;EzE87zBV;;EyEr8zBM;IAOI,6BAAA;EzEk8zBV;;EyEz8zBM;IAOI,gCAAA;EzEs8zBV;;EyE78zBM;IAOI,+BAAA;EzE08zBV;;EyEj9zBM;IAOI,gCAAA;EzE88zBV;;EyEr9zBM;IAOI,6BAAA;EzEk9zBV;;EyEz9zBM;IAOI,iBAAA;EzEs9zBV;;EyE79zBM;IAOI,uBAAA;EzE09zBV;;EyEj+zBM;IAOI,sBAAA;EzE89zBV;;EyEr+zBM;IAOI,uBAAA;EzEk+zBV;;EyEz+zBM;IAOI,oBAAA;EzEs+zBV;;EyE7+zBM;IAOI,uBAAA;EzE0+zBV;;EyEj/zBM;IAOI,sBAAA;EzE8+zBV;;EyEr/zBM;IAOI,uBAAA;EzEk/zBV;;EyEz/zBM;IAOI,oBAAA;EzEs/zBV;;EyE7/zBM;IAOI,uBAAA;EzE0/zBV;;EyEjg0BM;IAOI,sBAAA;EzE8/zBV;;EyErg0BM;IAOI,uBAAA;EzEkg0BV;;EyEzg0BM;IAOI,oBAAA;EzEsg0BV;;EyE7g0BM;IAOI,uBAAA;EzE0g0BV;;EyEjh0BM;IAOI,sBAAA;EzE8g0BV;;EyErh0BM;IAOI,uBAAA;EzEkh0BV;;EyEzh0BM;IAOI,oBAAA;EzEsh0BV;;EyE7h0BM;IAOI,uBAAA;EzE0h0BV;;EyEji0BM;IAOI,sBAAA;EzE8h0BV;;EyEri0BM;IAOI,uBAAA;EzEki0BV;;EyEzi0BM;IAOI,oBAAA;EzEsi0BV;;EyE7i0BM;IAOI,0CAAA;EzE0i0BV;;EyEjj0BM;IAOI,4CAAA;EzE8i0BV;;EyErj0BM;IAOI,4CAAA;EzEkj0BV;;EyEzj0BM;IAOI,6BAAA;EzEsj0BV;;EyE7j0BM;IAOI,6BAAA;EzE0j0BV;;EyEjk0BM;IAOI,8BAAA;EzE8j0BV;;EyErk0BM;IAOI,6BAAA;EzEkk0BV;;EyEzk0BM;IAOI,6BAAA;EzEsk0BV;;EyE7k0BM;IAOI,6BAAA;EzE0k0BV;;EyEjl0BM;IAOI,4BAAA;EzE8k0BV;;EyErl0BM;IAOI,0BAAA;EzEkl0BV;;EyEzl0BM;IAOI,0BAAA;EzEsl0BV;;EyE7l0BM;IAOI,4CAAA;EzE0l0BV;;EyEjm0BM;IAOI,2CAAA;EzE8l0BV;;EyErm0BM;IAOI,4CAAA;EzEkm0BV;;EyEzm0BM;IAOI,0CAAA;EzEsm0BV;;EyE7m0BM;IAOI,4CAAA;EzE0m0BV;;EyEjn0BM;IAOI,2CAAA;EzE8m0BV;;EyErn0BM;IAOI,4CAAA;EzEkn0BV;;EyEzn0BM;IAOI,wCAAA;EzEsn0BV;;EyE7n0BM;IAOI,4CAAA;EzE0n0BV;;EyEjo0BM;IAOI,2CAAA;EzE8n0BV;;EyEro0BM;IAOI,4CAAA;EzEko0BV;;EyEzo0BM;IAOI,0CAAA;EzEso0BV;;EyE7o0BM;IAOI,4CAAA;EzE0o0BV;;EyEjp0BM;IAOI,2CAAA;EzE8o0BV;;EyErp0BM;IAOI,4CAAA;EzEkp0BV;;EyEzp0BM;IAOI,0CAAA;EzEsp0BV;;EyE7p0BM;IAOI,2BAAA;EzE0p0BV;;EyEjq0BM;IAOI,4BAAA;EzE8p0BV;;EyErq0BM;IAOI,6BAAA;EzEkq0BV;;EyEzq0BM;IAOI,2BAAA;EzEsq0BV;;EyE7q0BM;IAOI,yBAAA;EzE0q0BV;;EyEjr0BM;IAOI,yBAAA;EzE8q0BV;;EyErr0BM;IAOI,yBAAA;EzEkr0BV;;EyEzr0BM;IAOI,0BAAA;EzEsr0BV;;EyE7r0BM;IAOI,0BAAA;EzE0r0BV;;EyEjs0BM;IAOI,yBAAA;EzE8r0BV;;EyErs0BM;IAOI,yBAAA;EzEks0BV;;EyEzs0BM;IAOI,yBAAA;EzEss0BV;;EyE7s0BM;IAOI,yBAAA;EzE0s0BV;;EyEjt0BM;IAOI,yBAAA;EzE8s0BV;;EyErt0BM;IAOI,yBAAA;EzEkt0BV;;EyEzt0BM;IAOI,yBAAA;EzEst0BV;;EyE7t0BM;IAOI,yBAAA;EzE0t0BV;;EyEju0BM;IAOI,yBAAA;EzE8t0BV;;EyEru0BM;IAOI,0BAAA;EzEku0BV;;EyEzu0BM;IAOI,0BAAA;EzEsu0BV;;EyE7u0BM;IAOI,0BAAA;EzE0u0BV;;EyEjv0BM;IAOI,0BAAA;EzE8u0BV;;EyErv0BM;IAOI,0BAAA;EzEkv0BV;;EyEzv0BM;IAOI,0BAAA;EzEsv0BV;;EyE7v0BM;IAOI,0BAAA;EzE0v0BV;;EyEjw0BM;IAOI,0BAAA;EzE8v0BV;;EyErw0BM;IAOI,0BAAA;EzEkw0BV;;EyEzw0BM;IAOI,0BAAA;EzEsw0BV;;EyE7w0BM;IAOI,0BAAA;EzE0w0BV;;EyEjx0BM;IAOI,0BAAA;EzE8w0BV;;EyErx0BM;IAOI,0BAAA;EzEkx0BV;;EyEzx0BM;IAOI,0BAAA;EzEsx0BV;;EyE7x0BM;IAOI,0BAAA;EzE0x0BV;;EyEjy0BM;IAOI,0BAAA;EzE8x0BV;;EyEry0BM;IAOI,0BAAA;EzEky0BV;;EyEzy0BM;IAOI,0BAAA;EzEsy0BV;;EyE7y0BM;IAOI,2BAAA;EzE0y0BV;;EyEjz0BM;IAOI,2BAAA;EzE8y0BV;;EyErz0BM;IAOI,2BAAA;EzEkz0BV;;EyEzz0BM;IAOI,2BAAA;EzEsz0BV;;EyE7z0BM;IAOI,2BAAA;EzE0z0BV;;EyEj00BM;IAOI,2BAAA;EzE8z0BV;;EyEr00BM;IAOI,2BAAA;EzEk00BV;;EyEz00BM;IAOI,2BAAA;EzEs00BV;;EyE700BM;IAOI,2BAAA;EzE000BV;;EyEj10BM;IAOI,2BAAA;EzE800BV;;EyEr10BM;IAOI,2BAAA;EzEk10BV;;EyEz10BM;IAOI,2BAAA;EzEs10BV;;EyE710BM;IAOI,2BAAA;EzE010BV;;EyEj20BM;IAOI,2BAAA;EzE810BV;;EyEr20BM;IAOI,2BAAA;EzEk20BV;;EyEz20BM;IAOI,2BAAA;EzEs20BV;;EyE720BM;IAOI,2BAAA;EzE020BV;;EyEj30BM;IAOI,2BAAA;EzE820BV;;EyEr30BM;IAOI,2BAAA;EzEk30BV;;EyEz30BM;IAOI,2BAAA;EzEs30BV;;EyE730BM;IAOI,2BAAA;EzE030BV;;EyEj40BM;IAOI,2BAAA;EzE830BV;;EyEr40BM;IAOI,2BAAA;EzEk40BV;;EyEz40BM;IAOI,2BAAA;EzEs40BV;;EyE740BM;IAOI,2BAAA;EzE040BV;;EyEj50BM;IAOI,2BAAA;EzE840BV;;EyEr50BM;IAOI,4BAAA;EzEk50BV;;EyEz50BM;IAOI,4BAAA;EzEs50BV;;EyE750BM;IAOI,0BAAA;EzE050BV;;EyEj60BM;IAOI,0BAAA;EzE850BV;;EyEr60BM;IAOI,0BAAA;EzEk60BV;;EyEz60BM;IAOI,2BAAA;EzEs60BV;;EyE760BM;IAOI,2BAAA;EzE060BV;;EyEj70BM;IAOI,0BAAA;EzE860BV;;EyEr70BM;IAOI,0BAAA;EzEk70BV;;EyEz70BM;IAOI,0BAAA;EzEs70BV;;EyE770BM;IAOI,0BAAA;EzE070BV;;EyEj80BM;IAOI,0BAAA;EzE870BV;;EyEr80BM;IAOI,0BAAA;EzEk80BV;;EyEz80BM;IAOI,0BAAA;EzEs80BV;;EyE780BM;IAOI,0BAAA;EzE080BV;;EyEj90BM;IAOI,0BAAA;EzE880BV;;EyEr90BM;IAOI,2BAAA;EzEk90BV;;EyEz90BM;IAOI,2BAAA;EzEs90BV;;EyE790BM;IAOI,2BAAA;EzE090BV;;EyEj+0BM;IAOI,2BAAA;EzE890BV;;EyEr+0BM;IAOI,2BAAA;EzEk+0BV;;EyEz+0BM;IAOI,2BAAA;EzEs+0BV;;EyE7+0BM;IAOI,2BAAA;EzE0+0BV;;EyEj/0BM;IAOI,2BAAA;EzE8+0BV;;EyEr/0BM;IAOI,2BAAA;EzEk/0BV;;EyEz/0BM;IAOI,2BAAA;EzEs/0BV;;EyE7/0BM;IAOI,2BAAA;EzE0/0BV;;EyEjg1BM;IAOI,2BAAA;EzE8/0BV;;EyErg1BM;IAOI,2BAAA;EzEkg1BV;;EyEzg1BM;IAOI,2BAAA;EzEsg1BV;;EyE7g1BM;IAOI,2BAAA;EzE0g1BV;;EyEjh1BM;IAOI,2BAAA;EzE8g1BV;;EyErh1BM;IAOI,2BAAA;EzEkh1BV;;EyEzh1BM;IAOI,2BAAA;EzEsh1BV;;EyE7h1BM;IAOI,4BAAA;EzE0h1BV;;EyEji1BM;IAOI,4BAAA;EzE8h1BV;;EyEri1BM;IAOI,4BAAA;EzEki1BV;;EyEzi1BM;IAOI,4BAAA;EzEsi1BV;;EyE7i1BM;IAOI,4BAAA;EzE0i1BV;;EyEjj1BM;IAOI,4BAAA;EzE8i1BV;;EyErj1BM;IAOI,4BAAA;EzEkj1BV;;EyEzj1BM;IAOI,4BAAA;EzEsj1BV;;EyE7j1BM;IAOI,4BAAA;EzE0j1BV;;EyEjk1BM;IAOI,4BAAA;EzE8j1BV;;EyErk1BM;IAOI,4BAAA;EzEkk1BV;;EyEzk1BM;IAOI,4BAAA;EzEsk1BV;;EyE7k1BM;IAOI,4BAAA;EzE0k1BV;;EyEjl1BM;IAOI,4BAAA;EzE8k1BV;;EyErl1BM;IAOI,4BAAA;EzEkl1BV;;EyEzl1BM;IAOI,4BAAA;EzEsl1BV;;EyE7l1BM;IAOI,4BAAA;EzE0l1BV;;EyEjm1BM;IAOI,4BAAA;EzE8l1BV;;EyErm1BM;IAOI,4BAAA;EzEkm1BV;;EyEzm1BM;IAOI,4BAAA;EzEsm1BV;;EyE7m1BM;IAOI,4BAAA;EzE0m1BV;;EyEjn1BM;IAOI,4BAAA;EzE8m1BV;;EyErn1BM;IAOI,4BAAA;EzEkn1BV;;EyEzn1BM;IAOI,4BAAA;EzEsn1BV;;EyE7n1BM;IAOI,4BAAA;EzE0n1BV;;EyEjo1BM;IAOI,4BAAA;EzE8n1BV;;EyEro1BM;IAOI,6BAAA;EzEko1BV;AACF;Ae7o1BI;E0DGI;IAOI,sBAAA;EzEuo1BV;;EyE9o1BM;IAOI,uBAAA;EzE2o1BV;;EyElp1BM;IAOI,sBAAA;EzE+o1BV;;EyEtp1BM;IAOI,0BAAA;EzEmp1BV;;EyE1p1BM;IAOI,gCAAA;EzEup1BV;;EyE9p1BM;IAOI,yBAAA;EzE2p1BV;;EyElq1BM;IAOI,wBAAA;EzE+p1BV;;EyEtq1BM;IAOI,yBAAA;EzEmq1BV;;EyE1q1BM;IAOI,6BAAA;EzEuq1BV;;EyE9q1BM;IAOI,8BAAA;EzE2q1BV;;EyElr1BM;IAOI,wBAAA;EzE+q1BV;;EyEtr1BM;IAOI,+BAAA;EzEmr1BV;;EyE1r1BM;IAOI,wBAAA;EzEur1BV;;EyE9r1BM;IAOI,2BAAA;EzE2r1BV;;EyEls1BM;IAOI,6BAAA;EzE+r1BV;;EyEts1BM;IAOI,6BAAA;EzEms1BV;;EyE1s1BM;IAOI,0BAAA;EzEus1BV;;EyE9s1BM;IAOI,2BAAA;EzE2s1BV;;EyElt1BM;IAOI,uBAAA;EzE+s1BV;;EyEtt1BM;IAOI,qBAAA;EzEmt1BV;;EyE1t1BM;IAOI,qBAAA;EzEut1BV;;EyE9t1BM;IAOI,qBAAA;EzE2t1BV;;EyElu1BM;IAOI,sBAAA;EzE+t1BV;;EyEtu1BM;IAOI,sBAAA;EzEmu1BV;;EyE1u1BM;IAOI,qBAAA;EzEuu1BV;;EyE9u1BM;IAOI,qBAAA;EzE2u1BV;;EyElv1BM;IAOI,qBAAA;EzE+u1BV;;EyEtv1BM;IAOI,qBAAA;EzEmv1BV;;EyE1v1BM;IAOI,qBAAA;EzEuv1BV;;EyE9v1BM;IAOI,qBAAA;EzE2v1BV;;EyElw1BM;IAOI,qBAAA;EzE+v1BV;;EyEtw1BM;IAOI,qBAAA;EzEmw1BV;;EyE1w1BM;IAOI,qBAAA;EzEuw1BV;;EyE9w1BM;IAOI,sBAAA;EzE2w1BV;;EyElx1BM;IAOI,sBAAA;EzE+w1BV;;EyEtx1BM;IAOI,sBAAA;EzEmx1BV;;EyE1x1BM;IAOI,sBAAA;EzEux1BV;;EyE9x1BM;IAOI,sBAAA;EzE2x1BV;;EyEly1BM;IAOI,sBAAA;EzE+x1BV;;EyEty1BM;IAOI,sBAAA;EzEmy1BV;;EyE1y1BM;IAOI,sBAAA;EzEuy1BV;;EyE9y1BM;IAOI,sBAAA;EzE2y1BV;;EyElz1BM;IAOI,sBAAA;EzE+y1BV;;EyEtz1BM;IAOI,sBAAA;EzEmz1BV;;EyE1z1BM;IAOI,sBAAA;EzEuz1BV;;EyE9z1BM;IAOI,sBAAA;EzE2z1BV;;EyEl01BM;IAOI,sBAAA;EzE+z1BV;;EyEt01BM;IAOI,sBAAA;EzEm01BV;;EyE101BM;IAOI,sBAAA;EzEu01BV;;EyE901BM;IAOI,sBAAA;EzE201BV;;EyEl11BM;IAOI,sBAAA;EzE+01BV;;EyEt11BM;IAOI,uBAAA;EzEm11BV;;EyE111BM;IAOI,uBAAA;EzEu11BV;;EyE911BM;IAOI,uBAAA;EzE211BV;;EyEl21BM;IAOI,uBAAA;EzE+11BV;;EyEt21BM;IAOI,uBAAA;EzEm21BV;;EyE121BM;IAOI,uBAAA;EzEu21BV;;EyE921BM;IAOI,uBAAA;EzE221BV;;EyEl31BM;IAOI,uBAAA;EzE+21BV;;EyEt31BM;IAOI,uBAAA;EzEm31BV;;EyE131BM;IAOI,uBAAA;EzEu31BV;;EyE931BM;IAOI,uBAAA;EzE231BV;;EyEl41BM;IAOI,uBAAA;EzE+31BV;;EyEt41BM;IAOI,uBAAA;EzEm41BV;;EyE141BM;IAOI,uBAAA;EzEu41BV;;EyE941BM;IAOI,uBAAA;EzE241BV;;EyEl51BM;IAOI,uBAAA;EzE+41BV;;EyEt51BM;IAOI,uBAAA;EzEm51BV;;EyE151BM;IAOI,uBAAA;EzEu51BV;;EyE951BM;IAOI,uBAAA;EzE251BV;;EyEl61BM;IAOI,uBAAA;EzE+51BV;;EyEt61BM;IAOI,uBAAA;EzEm61BV;;EyE161BM;IAOI,uBAAA;EzEu61BV;;EyE961BM;IAOI,uBAAA;EzE261BV;;EyEl71BM;IAOI,uBAAA;EzE+61BV;;EyEt71BM;IAOI,uBAAA;EzEm71BV;;EyE171BM;IAOI,uBAAA;EzEu71BV;;EyE971BM;IAOI,wBAAA;EzE271BV;;EyEl81BM;IAOI,2BAAA;EzE+71BV;;EyEt81BM;IAOI,yBAAA;EzEm81BV;;EyE181BM;IAOI,yBAAA;EzEu81BV;;EyE981BM;IAOI,yBAAA;EzE281BV;;EyEl91BM;IAOI,0BAAA;EzE+81BV;;EyEt91BM;IAOI,0BAAA;EzEm91BV;;EyE191BM;IAOI,yBAAA;EzEu91BV;;EyE991BM;IAOI,yBAAA;EzE291BV;;EyEl+1BM;IAOI,yBAAA;EzE+91BV;;EyEt+1BM;IAOI,yBAAA;EzEm+1BV;;EyE1+1BM;IAOI,yBAAA;EzEu+1BV;;EyE9+1BM;IAOI,yBAAA;EzE2+1BV;;EyEl/1BM;IAOI,yBAAA;EzE++1BV;;EyEt/1BM;IAOI,yBAAA;EzEm/1BV;;EyE1/1BM;IAOI,yBAAA;EzEu/1BV;;EyE9/1BM;IAOI,0BAAA;EzE2/1BV;;EyElg2BM;IAOI,0BAAA;EzE+/1BV;;EyEtg2BM;IAOI,0BAAA;EzEmg2BV;;EyE1g2BM;IAOI,0BAAA;EzEug2BV;;EyE9g2BM;IAOI,0BAAA;EzE2g2BV;;EyElh2BM;IAOI,0BAAA;EzE+g2BV;;EyEth2BM;IAOI,0BAAA;EzEmh2BV;;EyE1h2BM;IAOI,0BAAA;EzEuh2BV;;EyE9h2BM;IAOI,0BAAA;EzE2h2BV;;EyEli2BM;IAOI,0BAAA;EzE+h2BV;;EyEti2BM;IAOI,0BAAA;EzEmi2BV;;EyE1i2BM;IAOI,0BAAA;EzEui2BV;;EyE9i2BM;IAOI,0BAAA;EzE2i2BV;;EyElj2BM;IAOI,0BAAA;EzE+i2BV;;EyEtj2BM;IAOI,0BAAA;EzEmj2BV;;EyE1j2BM;IAOI,0BAAA;EzEuj2BV;;EyE9j2BM;IAOI,0BAAA;EzE2j2BV;;EyElk2BM;IAOI,0BAAA;EzE+j2BV;;EyEtk2BM;IAOI,2BAAA;EzEmk2BV;;EyE1k2BM;IAOI,2BAAA;EzEuk2BV;;EyE9k2BM;IAOI,2BAAA;EzE2k2BV;;EyEll2BM;IAOI,2BAAA;EzE+k2BV;;EyEtl2BM;IAOI,2BAAA;EzEml2BV;;EyE1l2BM;IAOI,2BAAA;EzEul2BV;;EyE9l2BM;IAOI,2BAAA;EzE2l2BV;;EyElm2BM;IAOI,2BAAA;EzE+l2BV;;EyEtm2BM;IAOI,2BAAA;EzEmm2BV;;EyE1m2BM;IAOI,2BAAA;EzEum2BV;;EyE9m2BM;IAOI,2BAAA;EzE2m2BV;;EyEln2BM;IAOI,2BAAA;EzE+m2BV;;EyEtn2BM;IAOI,2BAAA;EzEmn2BV;;EyE1n2BM;IAOI,2BAAA;EzEun2BV;;EyE9n2BM;IAOI,2BAAA;EzE2n2BV;;EyElo2BM;IAOI,2BAAA;EzE+n2BV;;EyEto2BM;IAOI,2BAAA;EzEmo2BV;;EyE1o2BM;IAOI,2BAAA;EzEuo2BV;;EyE9o2BM;IAOI,2BAAA;EzE2o2BV;;EyElp2BM;IAOI,2BAAA;EzE+o2BV;;EyEtp2BM;IAOI,2BAAA;EzEmp2BV;;EyE1p2BM;IAOI,2BAAA;EzEup2BV;;EyE9p2BM;IAOI,2BAAA;EzE2p2BV;;EyElq2BM;IAOI,2BAAA;EzE+p2BV;;EyEtq2BM;IAOI,2BAAA;EzEmq2BV;;EyE1q2BM;IAOI,2BAAA;EzEuq2BV;;EyE9q2BM;IAOI,4BAAA;EzE2q2BV;;EyElr2BM;IAOI,wBAAA;EzE+q2BV;;EyEtr2BM;IAOI,sBAAA;EzEmr2BV;;EyE1r2BM;IAOI,sBAAA;EzEur2BV;;EyE9r2BM;IAOI,sBAAA;EzE2r2BV;;EyEls2BM;IAOI,uBAAA;EzE+r2BV;;EyEts2BM;IAOI,uBAAA;EzEms2BV;;EyE1s2BM;IAOI,sBAAA;EzEus2BV;;EyE9s2BM;IAOI,sBAAA;EzE2s2BV;;EyElt2BM;IAOI,sBAAA;EzE+s2BV;;EyEtt2BM;IAOI,sBAAA;EzEmt2BV;;EyE1t2BM;IAOI,sBAAA;EzEut2BV;;EyE9t2BM;IAOI,sBAAA;EzE2t2BV;;EyElu2BM;IAOI,sBAAA;EzE+t2BV;;EyEtu2BM;IAOI,sBAAA;EzEmu2BV;;EyE1u2BM;IAOI,sBAAA;EzEuu2BV;;EyE9u2BM;IAOI,uBAAA;EzE2u2BV;;EyElv2BM;IAOI,uBAAA;EzE+u2BV;;EyEtv2BM;IAOI,uBAAA;EzEmv2BV;;EyE1v2BM;IAOI,uBAAA;EzEuv2BV;;EyE9v2BM;IAOI,uBAAA;EzE2v2BV;;EyElw2BM;IAOI,uBAAA;EzE+v2BV;;EyEtw2BM;IAOI,uBAAA;EzEmw2BV;;EyE1w2BM;IAOI,uBAAA;EzEuw2BV;;EyE9w2BM;IAOI,uBAAA;EzE2w2BV;;EyElx2BM;IAOI,uBAAA;EzE+w2BV;;EyEtx2BM;IAOI,uBAAA;EzEmx2BV;;EyE1x2BM;IAOI,uBAAA;EzEux2BV;;EyE9x2BM;IAOI,uBAAA;EzE2x2BV;;EyEly2BM;IAOI,uBAAA;EzE+x2BV;;EyEty2BM;IAOI,uBAAA;EzEmy2BV;;EyE1y2BM;IAOI,uBAAA;EzEuy2BV;;EyE9y2BM;IAOI,uBAAA;EzE2y2BV;;EyElz2BM;IAOI,uBAAA;EzE+y2BV;;EyEtz2BM;IAOI,wBAAA;EzEmz2BV;;EyE1z2BM;IAOI,wBAAA;EzEuz2BV;;EyE9z2BM;IAOI,wBAAA;EzE2z2BV;;EyEl02BM;IAOI,wBAAA;EzE+z2BV;;EyEt02BM;IAOI,wBAAA;EzEm02BV;;EyE102BM;IAOI,wBAAA;EzEu02BV;;EyE902BM;IAOI,wBAAA;EzE202BV;;EyEl12BM;IAOI,wBAAA;EzE+02BV;;EyEt12BM;IAOI,wBAAA;EzEm12BV;;EyE112BM;IAOI,wBAAA;EzEu12BV;;EyE912BM;IAOI,wBAAA;EzE212BV;;EyEl22BM;IAOI,wBAAA;EzE+12BV;;EyEt22BM;IAOI,wBAAA;EzEm22BV;;EyE122BM;IAOI,wBAAA;EzEu22BV;;EyE922BM;IAOI,wBAAA;EzE222BV;;EyEl32BM;IAOI,wBAAA;EzE+22BV;;EyEt32BM;IAOI,wBAAA;EzEm32BV;;EyE132BM;IAOI,wBAAA;EzEu32BV;;EyE932BM;IAOI,wBAAA;EzE232BV;;EyEl42BM;IAOI,wBAAA;EzE+32BV;;EyEt42BM;IAOI,wBAAA;EzEm42BV;;EyE142BM;IAOI,wBAAA;EzEu42BV;;EyE942BM;IAOI,wBAAA;EzE242BV;;EyEl52BM;IAOI,wBAAA;EzE+42BV;;EyEt52BM;IAOI,wBAAA;EzEm52BV;;EyE152BM;IAOI,wBAAA;EzEu52BV;;EyE952BM;IAOI,yBAAA;EzE252BV;;EyEl62BM;IAOI,4BAAA;EzE+52BV;;EyEt62BM;IAOI,0BAAA;EzEm62BV;;EyE162BM;IAOI,0BAAA;EzEu62BV;;EyE962BM;IAOI,0BAAA;EzE262BV;;EyEl72BM;IAOI,2BAAA;EzE+62BV;;EyEt72BM;IAOI,2BAAA;EzEm72BV;;EyE172BM;IAOI,0BAAA;EzEu72BV;;EyE972BM;IAOI,0BAAA;EzE272BV;;EyEl82BM;IAOI,0BAAA;EzE+72BV;;EyEt82BM;IAOI,0BAAA;EzEm82BV;;EyE182BM;IAOI,0BAAA;EzEu82BV;;EyE982BM;IAOI,0BAAA;EzE282BV;;EyEl92BM;IAOI,0BAAA;EzE+82BV;;EyEt92BM;IAOI,0BAAA;EzEm92BV;;EyE192BM;IAOI,0BAAA;EzEu92BV;;EyE992BM;IAOI,2BAAA;EzE292BV;;EyEl+2BM;IAOI,2BAAA;EzE+92BV;;EyEt+2BM;IAOI,2BAAA;EzEm+2BV;;EyE1+2BM;IAOI,2BAAA;EzEu+2BV;;EyE9+2BM;IAOI,2BAAA;EzE2+2BV;;EyEl/2BM;IAOI,2BAAA;EzE++2BV;;EyEt/2BM;IAOI,2BAAA;EzEm/2BV;;EyE1/2BM;IAOI,2BAAA;EzEu/2BV;;EyE9/2BM;IAOI,2BAAA;EzE2/2BV;;EyElg3BM;IAOI,2BAAA;EzE+/2BV;;EyEtg3BM;IAOI,2BAAA;EzEmg3BV;;EyE1g3BM;IAOI,2BAAA;EzEug3BV;;EyE9g3BM;IAOI,2BAAA;EzE2g3BV;;EyElh3BM;IAOI,2BAAA;EzE+g3BV;;EyEth3BM;IAOI,2BAAA;EzEmh3BV;;EyE1h3BM;IAOI,2BAAA;EzEuh3BV;;EyE9h3BM;IAOI,2BAAA;EzE2h3BV;;EyEli3BM;IAOI,2BAAA;EzE+h3BV;;EyEti3BM;IAOI,4BAAA;EzEmi3BV;;EyE1i3BM;IAOI,4BAAA;EzEui3BV;;EyE9i3BM;IAOI,4BAAA;EzE2i3BV;;EyElj3BM;IAOI,4BAAA;EzE+i3BV;;EyEtj3BM;IAOI,4BAAA;EzEmj3BV;;EyE1j3BM;IAOI,4BAAA;EzEuj3BV;;EyE9j3BM;IAOI,4BAAA;EzE2j3BV;;EyElk3BM;IAOI,4BAAA;EzE+j3BV;;EyEtk3BM;IAOI,4BAAA;EzEmk3BV;;EyE1k3BM;IAOI,4BAAA;EzEuk3BV;;EyE9k3BM;IAOI,4BAAA;EzE2k3BV;;EyEll3BM;IAOI,4BAAA;EzE+k3BV;;EyEtl3BM;IAOI,4BAAA;EzEml3BV;;EyE1l3BM;IAOI,4BAAA;EzEul3BV;;EyE9l3BM;IAOI,4BAAA;EzE2l3BV;;EyElm3BM;IAOI,4BAAA;EzE+l3BV;;EyEtm3BM;IAOI,4BAAA;EzEmm3BV;;EyE1m3BM;IAOI,4BAAA;EzEum3BV;;EyE9m3BM;IAOI,4BAAA;EzE2m3BV;;EyEln3BM;IAOI,4BAAA;EzE+m3BV;;EyEtn3BM;IAOI,4BAAA;EzEmn3BV;;EyE1n3BM;IAOI,4BAAA;EzEun3BV;;EyE9n3BM;IAOI,4BAAA;EzE2n3BV;;EyElo3BM;IAOI,4BAAA;EzE+n3BV;;EyEto3BM;IAOI,4BAAA;EzEmo3BV;;EyE1o3BM;IAOI,4BAAA;EzEuo3BV;;EyE9o3BM;IAOI,6BAAA;EzE2o3BV;;EyElp3BM;IAOI,yBAAA;EzE+o3BV;;EyEtp3BM;IAOI,8BAAA;EzEmp3BV;;EyE1p3BM;IAOI,iCAAA;EzEup3BV;;EyE9p3BM;IAOI,sCAAA;EzE2p3BV;;EyElq3BM;IAOI,yCAAA;EzE+p3BV;;EyEtq3BM;IAOI,uBAAA;EzEmq3BV;;EyE1q3BM;IAOI,uBAAA;EzEuq3BV;;EyE9q3BM;IAOI,yBAAA;EzE2q3BV;;EyElr3BM;IAOI,yBAAA;EzE+q3BV;;EyEtr3BM;IAOI,0BAAA;EzEmr3BV;;EyE1r3BM;IAOI,4BAAA;EzEur3BV;;EyE9r3BM;IAOI,kCAAA;EzE2r3BV;;EyEls3BM;IAOI,sCAAA;EzE+r3BV;;EyEts3BM;IAOI,oCAAA;EzEms3BV;;EyE1s3BM;IAOI,kCAAA;EzEus3BV;;EyE9s3BM;IAOI,yCAAA;EzE2s3BV;;EyElt3BM;IAOI,wCAAA;EzE+s3BV;;EyEtt3BM;IAOI,wCAAA;EzEmt3BV;;EyE1t3BM;IAOI,kCAAA;EzEut3BV;;EyE9t3BM;IAOI,gCAAA;EzE2t3BV;;EyElu3BM;IAOI,8BAAA;EzE+t3BV;;EyEtu3BM;IAOI,gCAAA;EzEmu3BV;;EyE1u3BM;IAOI,+BAAA;EzEuu3BV;;EyE9u3BM;IAOI,oCAAA;EzE2u3BV;;EyElv3BM;IAOI,kCAAA;EzE+u3BV;;EyEtv3BM;IAOI,gCAAA;EzEmv3BV;;EyE1v3BM;IAOI,uCAAA;EzEuv3BV;;EyE9v3BM;IAOI,sCAAA;EzE2v3BV;;EyElw3BM;IAOI,iCAAA;EzE+v3BV;;EyEtw3BM;IAOI,2BAAA;EzEmw3BV;;EyE1w3BM;IAOI,iCAAA;EzEuw3BV;;EyE9w3BM;IAOI,+BAAA;EzE2w3BV;;EyElx3BM;IAOI,6BAAA;EzE+w3BV;;EyEtx3BM;IAOI,+BAAA;EzEmx3BV;;EyE1x3BM;IAOI,8BAAA;EzEux3BV;;EyE9x3BM;IAOI,oBAAA;EzE2x3BV;;EyEly3BM;IAOI,mBAAA;EzE+x3BV;;EyEty3BM;IAOI,mBAAA;EzEmy3BV;;EyE1y3BM;IAOI,mBAAA;EzEuy3BV;;EyE9y3BM;IAOI,mBAAA;EzE2y3BV;;EyElz3BM;IAOI,mBAAA;EzE+y3BV;;EyEtz3BM;IAOI,mBAAA;EzEmz3BV;;EyE1z3BM;IAOI,mBAAA;EzEuz3BV;;EyE9z3BM;IAOI,oBAAA;EzE2z3BV;;EyEl03BM;IAOI,0BAAA;EzE+z3BV;;EyEt03BM;IAOI,yBAAA;EzEm03BV;;EyE103BM;IAOI,0BAAA;EzEu03BV;;EyE903BM;IAOI,uBAAA;EzE203BV;;EyEl13BM;IAOI,0BAAA;EzE+03BV;;EyEt13BM;IAOI,yBAAA;EzEm13BV;;EyE113BM;IAOI,0BAAA;EzEu13BV;;EyE913BM;IAOI,uBAAA;EzE213BV;;EyEl23BM;IAOI,0BAAA;EzE+13BV;;EyEt23BM;IAOI,yBAAA;EzEm23BV;;EyE123BM;IAOI,0BAAA;EzEu23BV;;EyE923BM;IAOI,uBAAA;EzE223BV;;EyEl33BM;IAOI,0BAAA;EzE+23BV;;EyEt33BM;IAOI,yBAAA;EzEm33BV;;EyE133BM;IAOI,0BAAA;EzEu33BV;;EyE933BM;IAOI,uBAAA;EzE233BV;;EyEl43BM;IAOI,0BAAA;EzE+33BV;;EyEt43BM;IAOI,yBAAA;EzEm43BV;;EyE143BM;IAOI,0BAAA;EzEu43BV;;EyE943BM;IAOI,uBAAA;EzE243BV;;EyEl53BM;IAOI,uBAAA;EzE+43BV;;EyEt53BM;IAOI,0BAAA;IAAA,yBAAA;EzEo53BV;;EyE353BM;IAOI,gCAAA;IAAA,+BAAA;EzEy53BV;;EyEh63BM;IAOI,+BAAA;IAAA,8BAAA;EzE853BV;;EyEr63BM;IAOI,gCAAA;IAAA,+BAAA;EzEm63BV;;EyE163BM;IAOI,6BAAA;IAAA,4BAAA;EzEw63BV;;EyE/63BM;IAOI,gCAAA;IAAA,+BAAA;EzE663BV;;EyEp73BM;IAOI,+BAAA;IAAA,8BAAA;EzEk73BV;;EyEz73BM;IAOI,gCAAA;IAAA,+BAAA;EzEu73BV;;EyE973BM;IAOI,6BAAA;IAAA,4BAAA;EzE473BV;;EyEn83BM;IAOI,gCAAA;IAAA,+BAAA;EzEi83BV;;EyEx83BM;IAOI,+BAAA;IAAA,8BAAA;EzEs83BV;;EyE783BM;IAOI,gCAAA;IAAA,+BAAA;EzE283BV;;EyEl93BM;IAOI,6BAAA;IAAA,4BAAA;EzEg93BV;;EyEv93BM;IAOI,gCAAA;IAAA,+BAAA;EzEq93BV;;EyE593BM;IAOI,+BAAA;IAAA,8BAAA;EzE093BV;;EyEj+3BM;IAOI,gCAAA;IAAA,+BAAA;EzE+93BV;;EyEt+3BM;IAOI,6BAAA;IAAA,4BAAA;EzEo+3BV;;EyE3+3BM;IAOI,gCAAA;IAAA,+BAAA;EzEy+3BV;;EyEh/3BM;IAOI,+BAAA;IAAA,8BAAA;EzE8+3BV;;EyEr/3BM;IAOI,gCAAA;IAAA,+BAAA;EzEm/3BV;;EyE1/3BM;IAOI,6BAAA;IAAA,4BAAA;EzEw/3BV;;EyE//3BM;IAOI,6BAAA;IAAA,4BAAA;EzE6/3BV;;EyEpg4BM;IAOI,wBAAA;IAAA,2BAAA;EzEkg4BV;;EyEzg4BM;IAOI,8BAAA;IAAA,iCAAA;EzEug4BV;;EyE9g4BM;IAOI,6BAAA;IAAA,gCAAA;EzE4g4BV;;EyEnh4BM;IAOI,8BAAA;IAAA,iCAAA;EzEih4BV;;EyExh4BM;IAOI,2BAAA;IAAA,8BAAA;EzEsh4BV;;EyE7h4BM;IAOI,8BAAA;IAAA,iCAAA;EzE2h4BV;;EyEli4BM;IAOI,6BAAA;IAAA,gCAAA;EzEgi4BV;;EyEvi4BM;IAOI,8BAAA;IAAA,iCAAA;EzEqi4BV;;EyE5i4BM;IAOI,2BAAA;IAAA,8BAAA;EzE0i4BV;;EyEjj4BM;IAOI,8BAAA;IAAA,iCAAA;EzE+i4BV;;EyEtj4BM;IAOI,6BAAA;IAAA,gCAAA;EzEoj4BV;;EyE3j4BM;IAOI,8BAAA;IAAA,iCAAA;EzEyj4BV;;EyEhk4BM;IAOI,2BAAA;IAAA,8BAAA;EzE8j4BV;;EyErk4BM;IAOI,8BAAA;IAAA,iCAAA;EzEmk4BV;;EyE1k4BM;IAOI,6BAAA;IAAA,gCAAA;EzEwk4BV;;EyE/k4BM;IAOI,8BAAA;IAAA,iCAAA;EzE6k4BV;;EyEpl4BM;IAOI,2BAAA;IAAA,8BAAA;EzEkl4BV;;EyEzl4BM;IAOI,8BAAA;IAAA,iCAAA;EzEul4BV;;EyE9l4BM;IAOI,6BAAA;IAAA,gCAAA;EzE4l4BV;;EyEnm4BM;IAOI,8BAAA;IAAA,iCAAA;EzEim4BV;;EyExm4BM;IAOI,2BAAA;IAAA,8BAAA;EzEsm4BV;;EyE7m4BM;IAOI,2BAAA;IAAA,8BAAA;EzE2m4BV;;EyEln4BM;IAOI,wBAAA;EzE+m4BV;;EyEtn4BM;IAOI,8BAAA;EzEmn4BV;;EyE1n4BM;IAOI,6BAAA;EzEun4BV;;EyE9n4BM;IAOI,8BAAA;EzE2n4BV;;EyElo4BM;IAOI,2BAAA;EzE+n4BV;;EyEto4BM;IAOI,8BAAA;EzEmo4BV;;EyE1o4BM;IAOI,6BAAA;EzEuo4BV;;EyE9o4BM;IAOI,8BAAA;EzE2o4BV;;EyElp4BM;IAOI,2BAAA;EzE+o4BV;;EyEtp4BM;IAOI,8BAAA;EzEmp4BV;;EyE1p4BM;IAOI,6BAAA;EzEup4BV;;EyE9p4BM;IAOI,8BAAA;EzE2p4BV;;EyElq4BM;IAOI,2BAAA;EzE+p4BV;;EyEtq4BM;IAOI,8BAAA;EzEmq4BV;;EyE1q4BM;IAOI,6BAAA;EzEuq4BV;;EyE9q4BM;IAOI,8BAAA;EzE2q4BV;;EyElr4BM;IAOI,2BAAA;EzE+q4BV;;EyEtr4BM;IAOI,8BAAA;EzEmr4BV;;EyE1r4BM;IAOI,6BAAA;EzEur4BV;;EyE9r4BM;IAOI,8BAAA;EzE2r4BV;;EyEls4BM;IAOI,2BAAA;EzE+r4BV;;EyEts4BM;IAOI,2BAAA;EzEms4BV;;EyE1s4BM;IAOI,0BAAA;EzEus4BV;;EyE9s4BM;IAOI,gCAAA;EzE2s4BV;;EyElt4BM;IAOI,+BAAA;EzE+s4BV;;EyEtt4BM;IAOI,gCAAA;EzEmt4BV;;EyE1t4BM;IAOI,6BAAA;EzEut4BV;;EyE9t4BM;IAOI,gCAAA;EzE2t4BV;;EyElu4BM;IAOI,+BAAA;EzE+t4BV;;EyEtu4BM;IAOI,gCAAA;EzEmu4BV;;EyE1u4BM;IAOI,6BAAA;EzEuu4BV;;EyE9u4BM;IAOI,gCAAA;EzE2u4BV;;EyElv4BM;IAOI,+BAAA;EzE+u4BV;;EyEtv4BM;IAOI,gCAAA;EzEmv4BV;;EyE1v4BM;IAOI,6BAAA;EzEuv4BV;;EyE9v4BM;IAOI,gCAAA;EzE2v4BV;;EyElw4BM;IAOI,+BAAA;EzE+v4BV;;EyEtw4BM;IAOI,gCAAA;EzEmw4BV;;EyE1w4BM;IAOI,6BAAA;EzEuw4BV;;EyE9w4BM;IAOI,gCAAA;EzE2w4BV;;EyElx4BM;IAOI,+BAAA;EzE+w4BV;;EyEtx4BM;IAOI,gCAAA;EzEmx4BV;;EyE1x4BM;IAOI,6BAAA;EzEux4BV;;EyE9x4BM;IAOI,6BAAA;EzE2x4BV;;EyEly4BM;IAOI,2BAAA;EzE+x4BV;;EyEty4BM;IAOI,iCAAA;EzEmy4BV;;EyE1y4BM;IAOI,gCAAA;EzEuy4BV;;EyE9y4BM;IAOI,iCAAA;EzE2y4BV;;EyElz4BM;IAOI,8BAAA;EzE+y4BV;;EyEtz4BM;IAOI,iCAAA;EzEmz4BV;;EyE1z4BM;IAOI,gCAAA;EzEuz4BV;;EyE9z4BM;IAOI,iCAAA;EzE2z4BV;;EyEl04BM;IAOI,8BAAA;EzE+z4BV;;EyEt04BM;IAOI,iCAAA;EzEm04BV;;EyE104BM;IAOI,gCAAA;EzEu04BV;;EyE904BM;IAOI,iCAAA;EzE204BV;;EyEl14BM;IAOI,8BAAA;EzE+04BV;;EyEt14BM;IAOI,iCAAA;EzEm14BV;;EyE114BM;IAOI,gCAAA;EzEu14BV;;EyE914BM;IAOI,iCAAA;EzE214BV;;EyEl24BM;IAOI,8BAAA;EzE+14BV;;EyEt24BM;IAOI,iCAAA;EzEm24BV;;EyE124BM;IAOI,gCAAA;EzEu24BV;;EyE924BM;IAOI,iCAAA;EzE224BV;;EyEl34BM;IAOI,8BAAA;EzE+24BV;;EyEt34BM;IAOI,8BAAA;EzEm34BV;;EyE134BM;IAOI,yBAAA;EzEu34BV;;EyE934BM;IAOI,+BAAA;EzE234BV;;EyEl44BM;IAOI,8BAAA;EzE+34BV;;EyEt44BM;IAOI,+BAAA;EzEm44BV;;EyE144BM;IAOI,4BAAA;EzEu44BV;;EyE944BM;IAOI,+BAAA;EzE244BV;;EyEl54BM;IAOI,8BAAA;EzE+44BV;;EyEt54BM;IAOI,+BAAA;EzEm54BV;;EyE154BM;IAOI,4BAAA;EzEu54BV;;EyE954BM;IAOI,+BAAA;EzE254BV;;EyEl64BM;IAOI,8BAAA;EzE+54BV;;EyEt64BM;IAOI,+BAAA;EzEm64BV;;EyE164BM;IAOI,4BAAA;EzEu64BV;;EyE964BM;IAOI,+BAAA;EzE264BV;;EyEl74BM;IAOI,8BAAA;EzE+64BV;;EyEt74BM;IAOI,+BAAA;EzEm74BV;;EyE174BM;IAOI,4BAAA;EzEu74BV;;EyE974BM;IAOI,+BAAA;EzE274BV;;EyEl84BM;IAOI,8BAAA;EzE+74BV;;EyEt84BM;IAOI,+BAAA;EzEm84BV;;EyE184BM;IAOI,4BAAA;EzEu84BV;;EyE984BM;IAOI,4BAAA;EzE284BV;;EyEl94BM;IAOI,2BAAA;EzE+84BV;;EyEt94BM;IAOI,0BAAA;EzEm94BV;;EyE194BM;IAOI,2BAAA;EzEu94BV;;EyE994BM;IAOI,wBAAA;EzE294BV;;EyEl+4BM;IAOI,2BAAA;EzE+94BV;;EyEt+4BM;IAOI,0BAAA;EzEm+4BV;;EyE1+4BM;IAOI,2BAAA;EzEu+4BV;;EyE9+4BM;IAOI,wBAAA;EzE2+4BV;;EyEl/4BM;IAOI,2BAAA;EzE++4BV;;EyEt/4BM;IAOI,0BAAA;EzEm/4BV;;EyE1/4BM;IAOI,2BAAA;EzEu/4BV;;EyE9/4BM;IAOI,wBAAA;EzE2/4BV;;EyElg5BM;IAOI,2BAAA;EzE+/4BV;;EyEtg5BM;IAOI,0BAAA;EzEmg5BV;;EyE1g5BM;IAOI,2BAAA;EzEug5BV;;EyE9g5BM;IAOI,wBAAA;EzE2g5BV;;EyElh5BM;IAOI,2BAAA;EzE+g5BV;;EyEth5BM;IAOI,0BAAA;EzEmh5BV;;EyE1h5BM;IAOI,2BAAA;EzEuh5BV;;EyE9h5BM;IAOI,wBAAA;EzE2h5BV;;EyEli5BM;IAOI,iCAAA;IAAA,gCAAA;EzEgi5BV;;EyEvi5BM;IAOI,gCAAA;IAAA,+BAAA;EzEqi5BV;;EyE5i5BM;IAOI,iCAAA;IAAA,gCAAA;EzE0i5BV;;EyEjj5BM;IAOI,8BAAA;IAAA,6BAAA;EzE+i5BV;;EyEtj5BM;IAOI,iCAAA;IAAA,gCAAA;EzEoj5BV;;EyE3j5BM;IAOI,gCAAA;IAAA,+BAAA;EzEyj5BV;;EyEhk5BM;IAOI,iCAAA;IAAA,gCAAA;EzE8j5BV;;EyErk5BM;IAOI,8BAAA;IAAA,6BAAA;EzEmk5BV;;EyE1k5BM;IAOI,iCAAA;IAAA,gCAAA;EzEwk5BV;;EyE/k5BM;IAOI,gCAAA;IAAA,+BAAA;EzE6k5BV;;EyEpl5BM;IAOI,iCAAA;IAAA,gCAAA;EzEkl5BV;;EyEzl5BM;IAOI,8BAAA;IAAA,6BAAA;EzEul5BV;;EyE9l5BM;IAOI,iCAAA;IAAA,gCAAA;EzE4l5BV;;EyEnm5BM;IAOI,gCAAA;IAAA,+BAAA;EzEim5BV;;EyExm5BM;IAOI,iCAAA;IAAA,gCAAA;EzEsm5BV;;EyE7m5BM;IAOI,8BAAA;IAAA,6BAAA;EzE2m5BV;;EyEln5BM;IAOI,iCAAA;IAAA,gCAAA;EzEgn5BV;;EyEvn5BM;IAOI,gCAAA;IAAA,+BAAA;EzEqn5BV;;EyE5n5BM;IAOI,iCAAA;IAAA,gCAAA;EzE0n5BV;;EyEjo5BM;IAOI,8BAAA;IAAA,6BAAA;EzE+n5BV;;EyEto5BM;IAOI,+BAAA;IAAA,kCAAA;EzEoo5BV;;EyE3o5BM;IAOI,8BAAA;IAAA,iCAAA;EzEyo5BV;;EyEhp5BM;IAOI,+BAAA;IAAA,kCAAA;EzE8o5BV;;EyErp5BM;IAOI,4BAAA;IAAA,+BAAA;EzEmp5BV;;EyE1p5BM;IAOI,+BAAA;IAAA,kCAAA;EzEwp5BV;;EyE/p5BM;IAOI,8BAAA;IAAA,iCAAA;EzE6p5BV;;EyEpq5BM;IAOI,+BAAA;IAAA,kCAAA;EzEkq5BV;;EyEzq5BM;IAOI,4BAAA;IAAA,+BAAA;EzEuq5BV;;EyE9q5BM;IAOI,+BAAA;IAAA,kCAAA;EzE4q5BV;;EyEnr5BM;IAOI,8BAAA;IAAA,iCAAA;EzEir5BV;;EyExr5BM;IAOI,+BAAA;IAAA,kCAAA;EzEsr5BV;;EyE7r5BM;IAOI,4BAAA;IAAA,+BAAA;EzE2r5BV;;EyEls5BM;IAOI,+BAAA;IAAA,kCAAA;EzEgs5BV;;EyEvs5BM;IAOI,8BAAA;IAAA,iCAAA;EzEqs5BV;;EyE5s5BM;IAOI,+BAAA;IAAA,kCAAA;EzE0s5BV;;EyEjt5BM;IAOI,4BAAA;IAAA,+BAAA;EzE+s5BV;;EyEtt5BM;IAOI,+BAAA;IAAA,kCAAA;EzEot5BV;;EyE3t5BM;IAOI,8BAAA;IAAA,iCAAA;EzEyt5BV;;EyEhu5BM;IAOI,+BAAA;IAAA,kCAAA;EzE8t5BV;;EyEru5BM;IAOI,4BAAA;IAAA,+BAAA;EzEmu5BV;;EyE1u5BM;IAOI,+BAAA;EzEuu5BV;;EyE9u5BM;IAOI,8BAAA;EzE2u5BV;;EyElv5BM;IAOI,+BAAA;EzE+u5BV;;EyEtv5BM;IAOI,4BAAA;EzEmv5BV;;EyE1v5BM;IAOI,+BAAA;EzEuv5BV;;EyE9v5BM;IAOI,8BAAA;EzE2v5BV;;EyElw5BM;IAOI,+BAAA;EzE+v5BV;;EyEtw5BM;IAOI,4BAAA;EzEmw5BV;;EyE1w5BM;IAOI,+BAAA;EzEuw5BV;;EyE9w5BM;IAOI,8BAAA;EzE2w5BV;;EyElx5BM;IAOI,+BAAA;EzE+w5BV;;EyEtx5BM;IAOI,4BAAA;EzEmx5BV;;EyE1x5BM;IAOI,+BAAA;EzEux5BV;;EyE9x5BM;IAOI,8BAAA;EzE2x5BV;;EyEly5BM;IAOI,+BAAA;EzE+x5BV;;EyEty5BM;IAOI,4BAAA;EzEmy5BV;;EyE1y5BM;IAOI,+BAAA;EzEuy5BV;;EyE9y5BM;IAOI,8BAAA;EzE2y5BV;;EyElz5BM;IAOI,+BAAA;EzE+y5BV;;EyEtz5BM;IAOI,4BAAA;EzEmz5BV;;EyE1z5BM;IAOI,iCAAA;EzEuz5BV;;EyE9z5BM;IAOI,gCAAA;EzE2z5BV;;EyEl05BM;IAOI,iCAAA;EzE+z5BV;;EyEt05BM;IAOI,8BAAA;EzEm05BV;;EyE105BM;IAOI,iCAAA;EzEu05BV;;EyE905BM;IAOI,gCAAA;EzE205BV;;EyEl15BM;IAOI,iCAAA;EzE+05BV;;EyEt15BM;IAOI,8BAAA;EzEm15BV;;EyE115BM;IAOI,iCAAA;EzEu15BV;;EyE915BM;IAOI,gCAAA;EzE215BV;;EyEl25BM;IAOI,iCAAA;EzE+15BV;;EyEt25BM;IAOI,8BAAA;EzEm25BV;;EyE125BM;IAOI,iCAAA;EzEu25BV;;EyE925BM;IAOI,gCAAA;EzE225BV;;EyEl35BM;IAOI,iCAAA;EzE+25BV;;EyEt35BM;IAOI,8BAAA;EzEm35BV;;EyE135BM;IAOI,iCAAA;EzEu35BV;;EyE935BM;IAOI,gCAAA;EzE235BV;;EyEl45BM;IAOI,iCAAA;EzE+35BV;;EyEt45BM;IAOI,8BAAA;EzEm45BV;;EyE145BM;IAOI,kCAAA;EzEu45BV;;EyE945BM;IAOI,iCAAA;EzE245BV;;EyEl55BM;IAOI,kCAAA;EzE+45BV;;EyEt55BM;IAOI,+BAAA;EzEm55BV;;EyE155BM;IAOI,kCAAA;EzEu55BV;;EyE955BM;IAOI,iCAAA;EzE255BV;;EyEl65BM;IAOI,kCAAA;EzE+55BV;;EyEt65BM;IAOI,+BAAA;EzEm65BV;;EyE165BM;IAOI,kCAAA;EzEu65BV;;EyE965BM;IAOI,iCAAA;EzE265BV;;EyEl75BM;IAOI,kCAAA;EzE+65BV;;EyEt75BM;IAOI,+BAAA;EzEm75BV;;EyE175BM;IAOI,kCAAA;EzEu75BV;;EyE975BM;IAOI,iCAAA;EzE275BV;;EyEl85BM;IAOI,kCAAA;EzE+75BV;;EyEt85BM;IAOI,+BAAA;EzEm85BV;;EyE185BM;IAOI,kCAAA;EzEu85BV;;EyE985BM;IAOI,iCAAA;EzE285BV;;EyEl95BM;IAOI,kCAAA;EzE+85BV;;EyEt95BM;IAOI,+BAAA;EzEm95BV;;EyE195BM;IAOI,gCAAA;EzEu95BV;;EyE995BM;IAOI,+BAAA;EzE295BV;;EyEl+5BM;IAOI,gCAAA;EzE+95BV;;EyEt+5BM;IAOI,6BAAA;EzEm+5BV;;EyE1+5BM;IAOI,gCAAA;EzEu+5BV;;EyE9+5BM;IAOI,+BAAA;EzE2+5BV;;EyEl/5BM;IAOI,gCAAA;EzE++5BV;;EyEt/5BM;IAOI,6BAAA;EzEm/5BV;;EyE1/5BM;IAOI,gCAAA;EzEu/5BV;;EyE9/5BM;IAOI,+BAAA;EzE2/5BV;;EyElg6BM;IAOI,gCAAA;EzE+/5BV;;EyEtg6BM;IAOI,6BAAA;EzEmg6BV;;EyE1g6BM;IAOI,gCAAA;EzEug6BV;;EyE9g6BM;IAOI,+BAAA;EzE2g6BV;;EyElh6BM;IAOI,gCAAA;EzE+g6BV;;EyEth6BM;IAOI,6BAAA;EzEmh6BV;;EyE1h6BM;IAOI,gCAAA;EzEuh6BV;;EyE9h6BM;IAOI,+BAAA;EzE2h6BV;;EyEli6BM;IAOI,gCAAA;EzE+h6BV;;EyEti6BM;IAOI,6BAAA;EzEmi6BV;;EyE1i6BM;IAOI,qBAAA;EzEui6BV;;EyE9i6BM;IAOI,2BAAA;EzE2i6BV;;EyElj6BM;IAOI,0BAAA;EzE+i6BV;;EyEtj6BM;IAOI,2BAAA;EzEmj6BV;;EyE1j6BM;IAOI,wBAAA;EzEuj6BV;;EyE9j6BM;IAOI,2BAAA;EzE2j6BV;;EyElk6BM;IAOI,0BAAA;EzE+j6BV;;EyEtk6BM;IAOI,2BAAA;EzEmk6BV;;EyE1k6BM;IAOI,wBAAA;EzEuk6BV;;EyE9k6BM;IAOI,2BAAA;EzE2k6BV;;EyEll6BM;IAOI,0BAAA;EzE+k6BV;;EyEtl6BM;IAOI,2BAAA;EzEml6BV;;EyE1l6BM;IAOI,wBAAA;EzEul6BV;;EyE9l6BM;IAOI,2BAAA;EzE2l6BV;;EyElm6BM;IAOI,0BAAA;EzE+l6BV;;EyEtm6BM;IAOI,2BAAA;EzEmm6BV;;EyE1m6BM;IAOI,wBAAA;EzEum6BV;;EyE9m6BM;IAOI,2BAAA;EzE2m6BV;;EyEln6BM;IAOI,0BAAA;EzE+m6BV;;EyEtn6BM;IAOI,2BAAA;EzEmn6BV;;EyE1n6BM;IAOI,wBAAA;EzEun6BV;;EyE9n6BM;IAOI,2BAAA;IAAA,0BAAA;EzE4n6BV;;EyEno6BM;IAOI,iCAAA;IAAA,gCAAA;EzEio6BV;;EyExo6BM;IAOI,gCAAA;IAAA,+BAAA;EzEso6BV;;EyE7o6BM;IAOI,iCAAA;IAAA,gCAAA;EzE2o6BV;;EyElp6BM;IAOI,8BAAA;IAAA,6BAAA;EzEgp6BV;;EyEvp6BM;IAOI,iCAAA;IAAA,gCAAA;EzEqp6BV;;EyE5p6BM;IAOI,gCAAA;IAAA,+BAAA;EzE0p6BV;;EyEjq6BM;IAOI,iCAAA;IAAA,gCAAA;EzE+p6BV;;EyEtq6BM;IAOI,8BAAA;IAAA,6BAAA;EzEoq6BV;;EyE3q6BM;IAOI,iCAAA;IAAA,gCAAA;EzEyq6BV;;EyEhr6BM;IAOI,gCAAA;IAAA,+BAAA;EzE8q6BV;;EyErr6BM;IAOI,iCAAA;IAAA,gCAAA;EzEmr6BV;;EyE1r6BM;IAOI,8BAAA;IAAA,6BAAA;EzEwr6BV;;EyE/r6BM;IAOI,iCAAA;IAAA,gCAAA;EzE6r6BV;;EyEps6BM;IAOI,gCAAA;IAAA,+BAAA;EzEks6BV;;EyEzs6BM;IAOI,iCAAA;IAAA,gCAAA;EzEus6BV;;EyE9s6BM;IAOI,8BAAA;IAAA,6BAAA;EzE4s6BV;;EyEnt6BM;IAOI,iCAAA;IAAA,gCAAA;EzEit6BV;;EyExt6BM;IAOI,gCAAA;IAAA,+BAAA;EzEst6BV;;EyE7t6BM;IAOI,iCAAA;IAAA,gCAAA;EzE2t6BV;;EyElu6BM;IAOI,8BAAA;IAAA,6BAAA;EzEgu6BV;;EyEvu6BM;IAOI,yBAAA;IAAA,4BAAA;EzEqu6BV;;EyE5u6BM;IAOI,+BAAA;IAAA,kCAAA;EzE0u6BV;;EyEjv6BM;IAOI,8BAAA;IAAA,iCAAA;EzE+u6BV;;EyEtv6BM;IAOI,+BAAA;IAAA,kCAAA;EzEov6BV;;EyE3v6BM;IAOI,4BAAA;IAAA,+BAAA;EzEyv6BV;;EyEhw6BM;IAOI,+BAAA;IAAA,kCAAA;EzE8v6BV;;EyErw6BM;IAOI,8BAAA;IAAA,iCAAA;EzEmw6BV;;EyE1w6BM;IAOI,+BAAA;IAAA,kCAAA;EzEww6BV;;EyE/w6BM;IAOI,4BAAA;IAAA,+BAAA;EzE6w6BV;;EyEpx6BM;IAOI,+BAAA;IAAA,kCAAA;EzEkx6BV;;EyEzx6BM;IAOI,8BAAA;IAAA,iCAAA;EzEux6BV;;EyE9x6BM;IAOI,+BAAA;IAAA,kCAAA;EzE4x6BV;;EyEny6BM;IAOI,4BAAA;IAAA,+BAAA;EzEiy6BV;;EyExy6BM;IAOI,+BAAA;IAAA,kCAAA;EzEsy6BV;;EyE7y6BM;IAOI,8BAAA;IAAA,iCAAA;EzE2y6BV;;EyElz6BM;IAOI,+BAAA;IAAA,kCAAA;EzEgz6BV;;EyEvz6BM;IAOI,4BAAA;IAAA,+BAAA;EzEqz6BV;;EyE5z6BM;IAOI,+BAAA;IAAA,kCAAA;EzE0z6BV;;EyEj06BM;IAOI,8BAAA;IAAA,iCAAA;EzE+z6BV;;EyEt06BM;IAOI,+BAAA;IAAA,kCAAA;EzEo06BV;;EyE306BM;IAOI,4BAAA;IAAA,+BAAA;EzEy06BV;;EyEh16BM;IAOI,yBAAA;EzE606BV;;EyEp16BM;IAOI,+BAAA;EzEi16BV;;EyEx16BM;IAOI,8BAAA;EzEq16BV;;EyE516BM;IAOI,+BAAA;EzEy16BV;;EyEh26BM;IAOI,4BAAA;EzE616BV;;EyEp26BM;IAOI,+BAAA;EzEi26BV;;EyEx26BM;IAOI,8BAAA;EzEq26BV;;EyE526BM;IAOI,+BAAA;EzEy26BV;;EyEh36BM;IAOI,4BAAA;EzE626BV;;EyEp36BM;IAOI,+BAAA;EzEi36BV;;EyEx36BM;IAOI,8BAAA;EzEq36BV;;EyE536BM;IAOI,+BAAA;EzEy36BV;;EyEh46BM;IAOI,4BAAA;EzE636BV;;EyEp46BM;IAOI,+BAAA;EzEi46BV;;EyEx46BM;IAOI,8BAAA;EzEq46BV;;EyE546BM;IAOI,+BAAA;EzEy46BV;;EyEh56BM;IAOI,4BAAA;EzE646BV;;EyEp56BM;IAOI,+BAAA;EzEi56BV;;EyEx56BM;IAOI,8BAAA;EzEq56BV;;EyE556BM;IAOI,+BAAA;EzEy56BV;;EyEh66BM;IAOI,4BAAA;EzE656BV;;EyEp66BM;IAOI,2BAAA;EzEi66BV;;EyEx66BM;IAOI,iCAAA;EzEq66BV;;EyE566BM;IAOI,gCAAA;EzEy66BV;;EyEh76BM;IAOI,iCAAA;EzE666BV;;EyEp76BM;IAOI,8BAAA;EzEi76BV;;EyEx76BM;IAOI,iCAAA;EzEq76BV;;EyE576BM;IAOI,gCAAA;EzEy76BV;;EyEh86BM;IAOI,iCAAA;EzE676BV;;EyEp86BM;IAOI,8BAAA;EzEi86BV;;EyEx86BM;IAOI,iCAAA;EzEq86BV;;EyE586BM;IAOI,gCAAA;EzEy86BV;;EyEh96BM;IAOI,iCAAA;EzE686BV;;EyEp96BM;IAOI,8BAAA;EzEi96BV;;EyEx96BM;IAOI,iCAAA;EzEq96BV;;EyE596BM;IAOI,gCAAA;EzEy96BV;;EyEh+6BM;IAOI,iCAAA;EzE696BV;;EyEp+6BM;IAOI,8BAAA;EzEi+6BV;;EyEx+6BM;IAOI,iCAAA;EzEq+6BV;;EyE5+6BM;IAOI,gCAAA;EzEy+6BV;;EyEh/6BM;IAOI,iCAAA;EzE6+6BV;;EyEp/6BM;IAOI,8BAAA;EzEi/6BV;;EyEx/6BM;IAOI,4BAAA;EzEq/6BV;;EyE5/6BM;IAOI,kCAAA;EzEy/6BV;;EyEhg7BM;IAOI,iCAAA;EzE6/6BV;;EyEpg7BM;IAOI,kCAAA;EzEig7BV;;EyExg7BM;IAOI,+BAAA;EzEqg7BV;;EyE5g7BM;IAOI,kCAAA;EzEyg7BV;;EyEhh7BM;IAOI,iCAAA;EzE6g7BV;;EyEph7BM;IAOI,kCAAA;EzEih7BV;;EyExh7BM;IAOI,+BAAA;EzEqh7BV;;EyE5h7BM;IAOI,kCAAA;EzEyh7BV;;EyEhi7BM;IAOI,iCAAA;EzE6h7BV;;EyEpi7BM;IAOI,kCAAA;EzEii7BV;;EyExi7BM;IAOI,+BAAA;EzEqi7BV;;EyE5i7BM;IAOI,kCAAA;EzEyi7BV;;EyEhj7BM;IAOI,iCAAA;EzE6i7BV;;EyEpj7BM;IAOI,kCAAA;EzEij7BV;;EyExj7BM;IAOI,+BAAA;EzEqj7BV;;EyE5j7BM;IAOI,kCAAA;EzEyj7BV;;EyEhk7BM;IAOI,iCAAA;EzE6j7BV;;EyEpk7BM;IAOI,kCAAA;EzEik7BV;;EyExk7BM;IAOI,+BAAA;EzEqk7BV;;EyE5k7BM;IAOI,0BAAA;EzEyk7BV;;EyEhl7BM;IAOI,gCAAA;EzE6k7BV;;EyEpl7BM;IAOI,+BAAA;EzEil7BV;;EyExl7BM;IAOI,gCAAA;EzEql7BV;;EyE5l7BM;IAOI,6BAAA;EzEyl7BV;;EyEhm7BM;IAOI,gCAAA;EzE6l7BV;;EyEpm7BM;IAOI,+BAAA;EzEim7BV;;EyExm7BM;IAOI,gCAAA;EzEqm7BV;;EyE5m7BM;IAOI,6BAAA;EzEym7BV;;EyEhn7BM;IAOI,gCAAA;EzE6m7BV;;EyEpn7BM;IAOI,+BAAA;EzEin7BV;;EyExn7BM;IAOI,gCAAA;EzEqn7BV;;EyE5n7BM;IAOI,6BAAA;EzEyn7BV;;EyEho7BM;IAOI,gCAAA;EzE6n7BV;;EyEpo7BM;IAOI,+BAAA;EzEio7BV;;EyExo7BM;IAOI,gCAAA;EzEqo7BV;;EyE5o7BM;IAOI,6BAAA;EzEyo7BV;;EyEhp7BM;IAOI,gCAAA;EzE6o7BV;;EyEpp7BM;IAOI,+BAAA;EzEip7BV;;EyExp7BM;IAOI,gCAAA;EzEqp7BV;;EyE5p7BM;IAOI,6BAAA;EzEyp7BV;;EyEhq7BM;IAOI,iBAAA;EzE6p7BV;;EyEpq7BM;IAOI,uBAAA;EzEiq7BV;;EyExq7BM;IAOI,sBAAA;EzEqq7BV;;EyE5q7BM;IAOI,uBAAA;EzEyq7BV;;EyEhr7BM;IAOI,oBAAA;EzE6q7BV;;EyEpr7BM;IAOI,uBAAA;EzEir7BV;;EyExr7BM;IAOI,sBAAA;EzEqr7BV;;EyE5r7BM;IAOI,uBAAA;EzEyr7BV;;EyEhs7BM;IAOI,oBAAA;EzE6r7BV;;EyEps7BM;IAOI,uBAAA;EzEis7BV;;EyExs7BM;IAOI,sBAAA;EzEqs7BV;;EyE5s7BM;IAOI,uBAAA;EzEys7BV;;EyEht7BM;IAOI,oBAAA;EzE6s7BV;;EyEpt7BM;IAOI,uBAAA;EzEit7BV;;EyExt7BM;IAOI,sBAAA;EzEqt7BV;;EyE5t7BM;IAOI,uBAAA;EzEyt7BV;;EyEhu7BM;IAOI,oBAAA;EzE6t7BV;;EyEpu7BM;IAOI,uBAAA;EzEiu7BV;;EyExu7BM;IAOI,sBAAA;EzEqu7BV;;EyE5u7BM;IAOI,uBAAA;EzEyu7BV;;EyEhv7BM;IAOI,oBAAA;EzE6u7BV;;EyEpv7BM;IAOI,0CAAA;EzEiv7BV;;EyExv7BM;IAOI,4CAAA;EzEqv7BV;;EyE5v7BM;IAOI,4CAAA;EzEyv7BV;;EyEhw7BM;IAOI,6BAAA;EzE6v7BV;;EyEpw7BM;IAOI,6BAAA;EzEiw7BV;;EyExw7BM;IAOI,8BAAA;EzEqw7BV;;EyE5w7BM;IAOI,6BAAA;EzEyw7BV;;EyEhx7BM;IAOI,6BAAA;EzE6w7BV;;EyEpx7BM;IAOI,6BAAA;EzEix7BV;;EyExx7BM;IAOI,4BAAA;EzEqx7BV;;EyE5x7BM;IAOI,0BAAA;EzEyx7BV;;EyEhy7BM;IAOI,0BAAA;EzE6x7BV;;EyEpy7BM;IAOI,4CAAA;EzEiy7BV;;EyExy7BM;IAOI,2CAAA;EzEqy7BV;;EyE5y7BM;IAOI,4CAAA;EzEyy7BV;;EyEhz7BM;IAOI,0CAAA;EzE6y7BV;;EyEpz7BM;IAOI,4CAAA;EzEiz7BV;;EyExz7BM;IAOI,2CAAA;EzEqz7BV;;EyE5z7BM;IAOI,4CAAA;EzEyz7BV;;EyEh07BM;IAOI,wCAAA;EzE6z7BV;;EyEp07BM;IAOI,4CAAA;EzEi07BV;;EyEx07BM;IAOI,2CAAA;EzEq07BV;;EyE507BM;IAOI,4CAAA;EzEy07BV;;EyEh17BM;IAOI,0CAAA;EzE607BV;;EyEp17BM;IAOI,4CAAA;EzEi17BV;;EyEx17BM;IAOI,2CAAA;EzEq17BV;;EyE517BM;IAOI,4CAAA;EzEy17BV;;EyEh27BM;IAOI,0CAAA;EzE617BV;;EyEp27BM;IAOI,2BAAA;EzEi27BV;;EyEx27BM;IAOI,4BAAA;EzEq27BV;;EyE527BM;IAOI,6BAAA;EzEy27BV;;EyEh37BM;IAOI,2BAAA;EzE627BV;;EyEp37BM;IAOI,yBAAA;EzEi37BV;;EyEx37BM;IAOI,yBAAA;EzEq37BV;;EyE537BM;IAOI,yBAAA;EzEy37BV;;EyEh47BM;IAOI,0BAAA;EzE637BV;;EyEp47BM;IAOI,0BAAA;EzEi47BV;;EyEx47BM;IAOI,yBAAA;EzEq47BV;;EyE547BM;IAOI,yBAAA;EzEy47BV;;EyEh57BM;IAOI,yBAAA;EzE647BV;;EyEp57BM;IAOI,yBAAA;EzEi57BV;;EyEx57BM;IAOI,yBAAA;EzEq57BV;;EyE557BM;IAOI,yBAAA;EzEy57BV;;EyEh67BM;IAOI,yBAAA;EzE657BV;;EyEp67BM;IAOI,yBAAA;EzEi67BV;;EyEx67BM;IAOI,yBAAA;EzEq67BV;;EyE567BM;IAOI,0BAAA;EzEy67BV;;EyEh77BM;IAOI,0BAAA;EzE667BV;;EyEp77BM;IAOI,0BAAA;EzEi77BV;;EyEx77BM;IAOI,0BAAA;EzEq77BV;;EyE577BM;IAOI,0BAAA;EzEy77BV;;EyEh87BM;IAOI,0BAAA;EzE677BV;;EyEp87BM;IAOI,0BAAA;EzEi87BV;;EyEx87BM;IAOI,0BAAA;EzEq87BV;;EyE587BM;IAOI,0BAAA;EzEy87BV;;EyEh97BM;IAOI,0BAAA;EzE687BV;;EyEp97BM;IAOI,0BAAA;EzEi97BV;;EyEx97BM;IAOI,0BAAA;EzEq97BV;;EyE597BM;IAOI,0BAAA;EzEy97BV;;EyEh+7BM;IAOI,0BAAA;EzE697BV;;EyEp+7BM;IAOI,0BAAA;EzEi+7BV;;EyEx+7BM;IAOI,0BAAA;EzEq+7BV;;EyE5+7BM;IAOI,0BAAA;EzEy+7BV;;EyEh/7BM;IAOI,0BAAA;EzE6+7BV;;EyEp/7BM;IAOI,2BAAA;EzEi/7BV;;EyEx/7BM;IAOI,2BAAA;EzEq/7BV;;EyE5/7BM;IAOI,2BAAA;EzEy/7BV;;EyEhg8BM;IAOI,2BAAA;EzE6/7BV;;EyEpg8BM;IAOI,2BAAA;EzEig8BV;;EyExg8BM;IAOI,2BAAA;EzEqg8BV;;EyE5g8BM;IAOI,2BAAA;EzEyg8BV;;EyEhh8BM;IAOI,2BAAA;EzE6g8BV;;EyEph8BM;IAOI,2BAAA;EzEih8BV;;EyExh8BM;IAOI,2BAAA;EzEqh8BV;;EyE5h8BM;IAOI,2BAAA;EzEyh8BV;;EyEhi8BM;IAOI,2BAAA;EzE6h8BV;;EyEpi8BM;IAOI,2BAAA;EzEii8BV;;EyExi8BM;IAOI,2BAAA;EzEqi8BV;;EyE5i8BM;IAOI,2BAAA;EzEyi8BV;;EyEhj8BM;IAOI,2BAAA;EzE6i8BV;;EyEpj8BM;IAOI,2BAAA;EzEij8BV;;EyExj8BM;IAOI,2BAAA;EzEqj8BV;;EyE5j8BM;IAOI,2BAAA;EzEyj8BV;;EyEhk8BM;IAOI,2BAAA;EzE6j8BV;;EyEpk8BM;IAOI,2BAAA;EzEik8BV;;EyExk8BM;IAOI,2BAAA;EzEqk8BV;;EyE5k8BM;IAOI,2BAAA;EzEyk8BV;;EyEhl8BM;IAOI,2BAAA;EzE6k8BV;;EyEpl8BM;IAOI,2BAAA;EzEil8BV;;EyExl8BM;IAOI,2BAAA;EzEql8BV;;EyE5l8BM;IAOI,4BAAA;EzEyl8BV;;EyEhm8BM;IAOI,4BAAA;EzE6l8BV;;EyEpm8BM;IAOI,0BAAA;EzEim8BV;;EyExm8BM;IAOI,0BAAA;EzEqm8BV;;EyE5m8BM;IAOI,0BAAA;EzEym8BV;;EyEhn8BM;IAOI,2BAAA;EzE6m8BV;;EyEpn8BM;IAOI,2BAAA;EzEin8BV;;EyExn8BM;IAOI,0BAAA;EzEqn8BV;;EyE5n8BM;IAOI,0BAAA;EzEyn8BV;;EyEho8BM;IAOI,0BAAA;EzE6n8BV;;EyEpo8BM;IAOI,0BAAA;EzEio8BV;;EyExo8BM;IAOI,0BAAA;EzEqo8BV;;EyE5o8BM;IAOI,0BAAA;EzEyo8BV;;EyEhp8BM;IAOI,0BAAA;EzE6o8BV;;EyEpp8BM;IAOI,0BAAA;EzEip8BV;;EyExp8BM;IAOI,0BAAA;EzEqp8BV;;EyE5p8BM;IAOI,2BAAA;EzEyp8BV;;EyEhq8BM;IAOI,2BAAA;EzE6p8BV;;EyEpq8BM;IAOI,2BAAA;EzEiq8BV;;EyExq8BM;IAOI,2BAAA;EzEqq8BV;;EyE5q8BM;IAOI,2BAAA;EzEyq8BV;;EyEhr8BM;IAOI,2BAAA;EzE6q8BV;;EyEpr8BM;IAOI,2BAAA;EzEir8BV;;EyExr8BM;IAOI,2BAAA;EzEqr8BV;;EyE5r8BM;IAOI,2BAAA;EzEyr8BV;;EyEhs8BM;IAOI,2BAAA;EzE6r8BV;;EyEps8BM;IAOI,2BAAA;EzEis8BV;;EyExs8BM;IAOI,2BAAA;EzEqs8BV;;EyE5s8BM;IAOI,2BAAA;EzEys8BV;;EyEht8BM;IAOI,2BAAA;EzE6s8BV;;EyEpt8BM;IAOI,2BAAA;EzEit8BV;;EyExt8BM;IAOI,2BAAA;EzEqt8BV;;EyE5t8BM;IAOI,2BAAA;EzEyt8BV;;EyEhu8BM;IAOI,2BAAA;EzE6t8BV;;EyEpu8BM;IAOI,4BAAA;EzEiu8BV;;EyExu8BM;IAOI,4BAAA;EzEqu8BV;;EyE5u8BM;IAOI,4BAAA;EzEyu8BV;;EyEhv8BM;IAOI,4BAAA;EzE6u8BV;;EyEpv8BM;IAOI,4BAAA;EzEiv8BV;;EyExv8BM;IAOI,4BAAA;EzEqv8BV;;EyE5v8BM;IAOI,4BAAA;EzEyv8BV;;EyEhw8BM;IAOI,4BAAA;EzE6v8BV;;EyEpw8BM;IAOI,4BAAA;EzEiw8BV;;EyExw8BM;IAOI,4BAAA;EzEqw8BV;;EyE5w8BM;IAOI,4BAAA;EzEyw8BV;;EyEhx8BM;IAOI,4BAAA;EzE6w8BV;;EyEpx8BM;IAOI,4BAAA;EzEix8BV;;EyExx8BM;IAOI,4BAAA;EzEqx8BV;;EyE5x8BM;IAOI,4BAAA;EzEyx8BV;;EyEhy8BM;IAOI,4BAAA;EzE6x8BV;;EyEpy8BM;IAOI,4BAAA;EzEiy8BV;;EyExy8BM;IAOI,4BAAA;EzEqy8BV;;EyE5y8BM;IAOI,4BAAA;EzEyy8BV;;EyEhz8BM;IAOI,4BAAA;EzE6y8BV;;EyEpz8BM;IAOI,4BAAA;EzEiz8BV;;EyExz8BM;IAOI,4BAAA;EzEqz8BV;;EyE5z8BM;IAOI,4BAAA;EzEyz8BV;;EyEh08BM;IAOI,4BAAA;EzE6z8BV;;EyEp08BM;IAOI,4BAAA;EzEi08BV;;EyEx08BM;IAOI,4BAAA;EzEq08BV;;EyE508BM;IAOI,6BAAA;EzEy08BV;AACF;A0Eh48BA;ED+CQ;IAOI,6BAAA;EzE808BV;;EyEr18BM;IAOI,4BAAA;EzEk18BV;;EyEz18BM;IAOI,6BAAA;EzEs18BV;;EyE718BM;IAOI,0BAAA;EzE018BV;;EyEj28BM;IAOI,6BAAA;EzE818BV;;EyEr28BM;IAOI,4BAAA;EzEk28BV;;EyEz28BM;IAOI,6BAAA;EzEs28BV;;EyE728BM;IAOI,0BAAA;EzE028BV;;EyEj38BM;IAOI,6BAAA;EzE828BV;;EyEr38BM;IAOI,4BAAA;EzEk38BV;;EyEz38BM;IAOI,6BAAA;EzEs38BV;;EyE738BM;IAOI,0BAAA;EzE038BV;;EyEj48BM;IAOI,6BAAA;EzE838BV;;EyEr48BM;IAOI,4BAAA;EzEk48BV;;EyEz48BM;IAOI,6BAAA;EzEs48BV;;EyE748BM;IAOI,0BAAA;EzE048BV;;EyEj58BM;IAOI,6BAAA;EzE848BV;;EyEr58BM;IAOI,4BAAA;EzEk58BV;;EyEz58BM;IAOI,6BAAA;EzEs58BV;;EyE758BM;IAOI,6BAAA;EzE058BV;;EyEj68BM;IAOI,4BAAA;EzE858BV;;EyEr68BM;IAOI,6BAAA;EzEk68BV;;EyEz68BM;IAOI,0BAAA;EzEs68BV;;EyE768BM;IAOI,6BAAA;EzE068BV;;EyEj78BM;IAOI,4BAAA;EzE868BV;;EyEr78BM;IAOI,6BAAA;EzEk78BV;;EyEz78BM;IAOI,0BAAA;EzEs78BV;;EyE778BM;IAOI,6BAAA;EzE078BV;;EyEj88BM;IAOI,4BAAA;EzE878BV;;EyEr88BM;IAOI,6BAAA;EzEk88BV;;EyEz88BM;IAOI,0BAAA;EzEs88BV;;EyE788BM;IAOI,6BAAA;EzE088BV;;EyEj98BM;IAOI,4BAAA;EzE888BV;;EyEr98BM;IAOI,6BAAA;EzEk98BV;;EyEz98BM;IAOI,0BAAA;EzEs98BV;;EyE798BM;IAOI,6BAAA;EzE098BV;;EyEj+8BM;IAOI,4BAAA;EzE898BV;;EyEr+8BM;IAOI,6BAAA;EzEk+8BV;;EyEz+8BM;IAOI,6BAAA;EzEs+8BV;;EyE7+8BM;IAOI,4BAAA;EzE0+8BV;;EyEj/8BM;IAOI,6BAAA;EzE8+8BV;;EyEr/8BM;IAOI,0BAAA;EzEk/8BV;;EyEz/8BM;IAOI,6BAAA;EzEs/8BV;;EyE7/8BM;IAOI,4BAAA;EzE0/8BV;;EyEjg9BM;IAOI,6BAAA;EzE8/8BV;;EyErg9BM;IAOI,0BAAA;EzEkg9BV;;EyEzg9BM;IAOI,6BAAA;EzEsg9BV;;EyE7g9BM;IAOI,4BAAA;EzE0g9BV;;EyEjh9BM;IAOI,6BAAA;EzE8g9BV;;EyErh9BM;IAOI,0BAAA;EzEkh9BV;;EyEzh9BM;IAOI,6BAAA;EzEsh9BV;;EyE7h9BM;IAOI,4BAAA;EzE0h9BV;;EyEji9BM;IAOI,6BAAA;EzE8h9BV;;EyEri9BM;IAOI,0BAAA;EzEki9BV;;EyEzi9BM;IAOI,6BAAA;EzEsi9BV;;EyE7i9BM;IAOI,4BAAA;EzE0i9BV;;EyEjj9BM;IAOI,6BAAA;EzE8i9BV;;EyErj9BM;IAOI,6BAAA;EzEkj9BV;;EyEzj9BM;IAOI,4BAAA;EzEsj9BV;;EyE7j9BM;IAOI,6BAAA;EzE0j9BV;;EyEjk9BM;IAOI,0BAAA;EzE8j9BV;;EyErk9BM;IAOI,6BAAA;EzEkk9BV;;EyEzk9BM;IAOI,4BAAA;EzEsk9BV;;EyE7k9BM;IAOI,6BAAA;EzE0k9BV;;EyEjl9BM;IAOI,0BAAA;EzE8k9BV;;EyErl9BM;IAOI,6BAAA;EzEkl9BV;;EyEzl9BM;IAOI,4BAAA;EzEsl9BV;;EyE7l9BM;IAOI,6BAAA;EzE0l9BV;;EyEjm9BM;IAOI,0BAAA;EzE8l9BV;;EyErm9BM;IAOI,6BAAA;EzEkm9BV;;EyEzm9BM;IAOI,4BAAA;EzEsm9BV;;EyE7m9BM;IAOI,6BAAA;EzE0m9BV;;EyEjn9BM;IAOI,0BAAA;EzE8m9BV;;EyErn9BM;IAOI,6BAAA;EzEkn9BV;;EyEzn9BM;IAOI,4BAAA;EzEsn9BV;;EyE7n9BM;IAOI,6BAAA;EzE0n9BV;AACF;A0E9p9BA;ED4BQ;IAOI,0BAAA;EzE+n9BV;;EyEto9BM;IAOI,gCAAA;EzEmo9BV;;EyE1o9BM;IAOI,yBAAA;EzEuo9BV;;EyE9o9BM;IAOI,wBAAA;EzE2o9BV;;EyElp9BM;IAOI,yBAAA;EzE+o9BV;;EyEtp9BM;IAOI,6BAAA;EzEmp9BV;;EyE1p9BM;IAOI,8BAAA;EzEup9BV;;EyE9p9BM;IAOI,wBAAA;EzE2p9BV;;EyElq9BM;IAOI,+BAAA;EzE+p9BV;;EyEtq9BM;IAOI,wBAAA;EzEmq9BV;AACF;A2Ezu9BA;;EAIQ,SAAA;EAAA,aAAA;EAAA,aAAA;EAAA,aAAA;EAAA,cAAA;EAAA,eAAA;EAIJ,mBAAA;EACA,gCAAA;EACA,mBAAA;EACA,0BAAA;EAGA,wBAAA;EAII,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAKA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,6BAAA;EAKA,mBAAA;EAAA,mBAAA;EAAA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,kBAAA;EAKA,4BAAA;EAAA,8BAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,yBAAA;EAAA,4BAAA;EAAA,2BAAA;EAAA,yBAAA;EAKA,2BAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,wBAAA;EAAA,2BAAA;EAAA,0BAAA;EAAA,wBAAA;EAKA,6BAAA;EAAA,+BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,0BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,0BAAA;EAKA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,iCAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,yBAAA;EAKA,wBAAA;EAAA,0BAAA;EAAA,4BAAA;EAAA,wBAAA;EAAA,0BAAA;EAAA,uBAAA;EAAA,0BAAA;EAAA,yBAAA;EAAA,uBAAA;EAAA,wBAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAIJ,qBAAA;EACA,+BAAA;EACA,wBAAA;EAGA,wBAAA;EACA,8BAAA;EAGA,0BAAA;EACA,iCAAA;EAEA,oCAAA;EACA,iCAAA;EACA,mCAAA;EACA,gCAAA;EACA,qCAAA;EACA,kCAAA;EAGA,gEAAA;EACA,6DAAA;EACA,4DAAA;EACA,uDAAA;EAGA,4BAAA;EAGA,yBAAA;EACA,0BAAA;EACA,iCAAA;EACA,gDAAA;EACA,iCAAA;EACA,gCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EAEA,+EAAA;EACA,sCAAA;EACA,yCAAA;EAGA,mDAAA;EACA,sEAAA;EACA,wCAAA;EAEA,yBAAA;EACA,qCAAA;EACA,mCAAA;EAGA,4FAAA;EACA,gEAAA;EACA,gEAAA;EACA,+BAAA;EAEA,4BAAA;EACA,kCAAA;EACA,qCAAA;EAGA,8BAAA;EACA,6BAAA;EAEA,sBAAA;EACA,+BAAA;EACA,2BAAA;EACA,yCAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4BAAA;EACA,sCAAA;EACA,+BAAA;EAGA,4BAAA;EACA,kCAAA;EACA,2CAAA;EACA,+BAAA;EAGA,oCAAA;EACA,4CAAA;EACA,oDAAA;EAEA,qCAAA;EACA,uCAAA;EACA,+CAAA;EACA,2CAAA;EACA,4CAAA;EAEA,4CAAA;EACA,+CAAA;EACA,qDAAA;EACA,mDAAA;EACA,+EAAA;EACA,+EAAA;EAEA,kDAAA;EACA,qDAAA;EACA,yDAAA;EACA,qFAAA;EAEA,2CAAA;EACA,2CAAA;EACA,gDAAA;EAEA,2CAAA;EACA,qCAAA;EACA,kEAAA;EACA,wEAAA;EACA,qCAAA;EACA,wEAAA;EACA,uCAAA;EACA,0EAAA;EAGA,qCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,+BAAA;EACA,4BAAA;EACA,iCAAA;EACA,qCAAA;EACA,+CAAA;EACA,yCAAA;EACA,mEAAA;EACA,sCAAA;EACA,iEAAA;EACA,4CAAA;EACA,wEAAA;EAGA,oCAAA;EACA,iCAAA;EACA,wDAAA;EAGA,mCAAA;EACA,8DAAA;EACA,wCAAA;EACA,qCAAA;EACA,+DAAA;EAEA,yCAAA;EACA,sCAAA;EAGA,4BAAA;EACA,yBAAA;EACA,iCAAA;EACA,kEAAA;EACA,iCAAA;EACA,yDAAA;EACA,oCAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;EAGA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,yCAAA;EACA,oCAAA;EACA,iCAAA;EACA,sCAAA;EACA,gCAAA;EACA,oCAAA;EACA,iCAAA;EACA,+CAAA;EACA,qCAAA;EACA,kCAAA;EACA,gDAAA;EACA,uCAAA;EACA,wCAAA;EAGA,iBAAA;EACA,qBAAA;EACA,8DAAA;EACA,+BAAA;EACA,sCAAA;EACA,6BAAA;EAGA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,iCAAA;EACA,oCAAA;EACA,wCAAA;EACA,2CAAA;EACA,iDAAA;EACA,4CAAA;EAEA,kCAAA;EACA,yCAAA;EACA,oEAAA;EACA,2EAAA;EAGA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,iEAAA;EAGA,wBAAA;EACA,kCAAA;EACA,iEAAA;EACA,+BAAA;EACA,kCAAA;EACA,yCAAA;EACA,gCAAA;EAGA,kEAAA;EACA,yBAAA;EAGA,kBAAA;EACA,sDAAA;EACA,kEAAA;EACA,gCAAA;EACA,6DAAA;EACA,mDAAA;EAGA,yBAAA;EAGA,sBAAA;EACA,kBAAA;EACA,2DAAA;EACA,2DAAA;EACA,0BAAA;EACA,8BAAA;EACA,mEAAA;EACA,mEAAA;EACA,qEAAA;EACA,qEAAA;EACA,uCAAA;EACA,uCAAA;EACA,+BAAA;EACA,gCAAA;EAGA,yBAAA;EACA,8BAAA;EAGA,8BAAA;EACA,2BAAA;EACA,kDAAA;EACA,iCAAA;EACA,qCAAA;EACA,kCAAA;EACA,6CAAA;EACA,uCAAA;EACA,oCAAA;EACA,sCAAA;EACA,2CAAA;EACA,4CAAA;EACA,yCAAA;EAGA,0BAAA;EACA,oCAAA;EACA,oEAAA;EAGA,kCAAA;EAGA,oBAAA;EACA,sCAAA;EACA,qCAAA;EAGA,wDAAA;EACA,uDAAA;EACA,+DAAA;EACA,8DAAA;EAGA,qBAAA;EACA,qDAAA;EACA,wBAAA;EAGA,6BAAA;EACA,2DAAA;EAGA,+DAAA;EACA,gCAAA;EACA,sBAAA;EACA,8DAAA;EACA,mCAAA;EACA,oCAAA;EAGA,gCAAA;EACA,6BAAA;EACA,kDAAA;EAGA,6BAAA;EAGA,yBAAA;EACA,8BAAA;EACA,+BAAA;EACA,sEAAA;EACA,gCAAA;EACA,sCAAA;EACA,kCAAA;EACA,wCAAA;EAGA,4DAAA;EACA,6BAAA;EACA,gDAAA;EAGA,uEAAA;EACA,oCAAA;EACA,gCAAA;EACA,mCAAA;EACA,kCAAA;EACA,kCAAA;EACA,oCAAA;EACA,sCAAA;EACA,qCAAA;EACA,qCAAA;EACA,uCAAA;EAGA,wEAAA;EACA,6CAAA;EAGA,6BAAA;EACA,mCAAA;EACA,4BAAA;EACA,6BAAA;EACA,4BAAA;EAGA,oCAAA;EAGA,4CAAA;EAGA,kCAAA;EACA,iCAAA;EAGA,oEAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;EAGA,2BAAA;EACA,8BAAA;EACA,qCAAA;A3Eqq9BJ;;A2Elq9BA;EAEI,wBAAA;EAII,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAKA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,8BAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAKA,kBAAA;EAAA,mBAAA;EAAA,uBAAA;EAKA,uBAAA;EAAA,0BAAA;EAAA,8BAAA;EAKA,2BAAA;EAAA,2BAAA;EAAA,wBAAA;EAAA,2BAAA;EAAA,0BAAA;EAAA,wBAAA;EAAA,6BAAA;EAKA,0BAAA;EAAA,2BAAA;EAAA,+BAAA;EAKA,4BAAA;EAAA,0BAAA;EAAA,8BAAA;EAKA,uBAAA;EAAA,wBAAA;EAAA,4BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAAA,2BAAA;EAIJ,qBAAA;EACA,4BAAA;EACA,wBAAA;EAGA,wBAAA;EACA,8BAAA;EAGA,0BAAA;EACA,iCAAA;EAEA,oCAAA;EACA,iCAAA;EACA,mCAAA;EACA,gCAAA;EACA,qCAAA;EACA,kCAAA;EAGA,gEAAA;EACA,6DAAA;EACA,4DAAA;EACA,uDAAA;EAGA,4BAAA;EAGA,yBAAA;EACA,0BAAA;EACA,iCAAA;EACA,6CAAA;EACA,iCAAA;EACA,gCAAA;EACA,6BAAA;EACA,gCAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EAEA,sEAAA;EACA,sCAAA;EACA,yCAAA;EAGA,mDAAA;EACA,iCAAA;EACA,wCAAA;EAEA,yBAAA;EACA,qCAAA;EACA,mCAAA;EAGA,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,+BAAA;EAEA,4BAAA;EACA,kCAAA;EACA,qCAAA;EAGA,8BAAA;EACA,6BAAA;EAEA,sBAAA;EACA,+BAAA;EACA,2BAAA;EACA,yCAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4BAAA;EACA,sCAAA;EACA,+BAAA;EAGA,4BAAA;EACA,kCAAA;EACA,2CAAA;EACA,+BAAA;EAGA,oCAAA;EACA,4CAAA;EACA,oDAAA;EAEA,qCAAA;EACA,uCAAA;EACA,+CAAA;EACA,2CAAA;EACA,4CAAA;EAEA,4CAAA;EACA,+CAAA;EACA,mDAAA;EACA,+EAAA;EACA,+EAAA;EAEA,kDAAA;EACA,qDAAA;EACA,yDAAA;EACA,qFAAA;EAEA,2CAAA;EACA,2CAAA;EACA,gDAAA;EAEA,iDAAA;EACA,qCAAA;EACA,mEAAA;EACA,yEAAA;EACA,qCAAA;EACA,yEAAA;EACA,uCAAA;EACA,0EAAA;EAGA,qCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,+BAAA;EACA,4BAAA;EACA,iCAAA;EACA,qCAAA;EACA,+CAAA;EACA,yCAAA;EACA,oEAAA;EACA,sCAAA;EACA,iEAAA;EACA,4CAAA;EACA,wEAAA;EAGA,oCAAA;EACA,iCAAA;EACA,wDAAA;EAGA,mCAAA;EACA,8DAAA;EACA,wCAAA;EACA,qCAAA;EACA,+DAAA;EAEA,yCAAA;EACA,sCAAA;EAGA,4BAAA;EACA,yBAAA;EACA,iCAAA;EACA,yDAAA;EACA,iCAAA;EACA,yDAAA;EACA,oCAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;EAGA,gCAAA;EACA,8BAAA;EACA,+BAAA;EACA,yCAAA;EACA,oCAAA;EACA,iCAAA;EACA,sCAAA;EACA,gCAAA;EACA,oCAAA;EACA,iCAAA;EACA,+CAAA;EACA,qCAAA;EACA,kCAAA;EACA,gDAAA;EACA,uCAAA;EACA,wCAAA;EAGA,qBAAA;EACA,iBAAA;EACA,0BAAA;EACA,+BAAA;EACA,sCAAA;EACA,6BAAA;EAGA,6BAAA;EACA,0BAAA;EACA,oCAAA;EACA,oCAAA;EACA,iCAAA;EACA,wCAAA;EACA,2CAAA;EACA,iDAAA;EACA,4CAAA;EAEA,kCAAA;EACA,yCAAA;EACA,oEAAA;EACA,2EAAA;EAGA,2BAAA;EACA,wBAAA;EACA,uBAAA;EACA,wDAAA;EAGA,wBAAA;EACA,kCAAA;EACA,wDAAA;EACA,+BAAA;EACA,kCAAA;EACA,yCAAA;EACA,gCAAA;EAGA,yDAAA;EACA,yBAAA;EAGA,kBAAA;EACA,gDAAA;EACA,kEAAA;EACA,gCAAA;EACA,uDAAA;EACA,yDAAA;EAGA,yBAAA;EAGA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iEAAA;EACA,0BAAA;EACA,8BAAA;EACA,iCAAA;EACA,yEAAA;EACA,2EAAA;EACA,2EAAA;EACA,uCAAA;EACA,uCAAA;EACA,+BAAA;EACA,gCAAA;EAGA,yBAAA;EACA,8BAAA;EAGA,8BAAA;EACA,2BAAA;EACA,wDAAA;EACA,iCAAA;EACA,qCAAA;EACA,kCAAA;EACA,6CAAA;EACA,uCAAA;EACA,oCAAA;EACA,sCAAA;EACA,2CAAA;EACA,4CAAA;EACA,yCAAA;EAGA,0BAAA;EACA,oCAAA;EACA,oEAAA;EAGA,kCAAA;EAGA,oBAAA;EACA,sCAAA;EACA,qCAAA;EAGA,wDAAA;EACA,uDAAA;EACA,8DAAA;EACA,8DAAA;EAGA,6BAAA;EACA,2DAAA;EAGA,qBAAA;EACA,qDAAA;EACA,wBAAA;EAGA,6BAAA;EACA,gCAAA;EACA,sBAAA;EACA,oEAAA;EACA,mCAAA;EACA,oCAAA;EAGA,qBAAA;EACA,qDAAA;EACA,wBAAA;EAGA,gCAAA;EACA,6BAAA;EACA,kDAAA;EAGA,6BAAA;EAGA,yBAAA;EACA,8BAAA;EACA,+BAAA;EACA,sEAAA;EACA,gCAAA;EACA,sCAAA;EACA,kCAAA;EACA,wCAAA;EAGA,uDAAA;EACA,6BAAA;EACA,gDAAA;EAGA,8DAAA;EACA,oCAAA;EACA,gCAAA;EAEA,mCAAA;EACA,kCAAA;EACA,kCAAA;EACA,oCAAA;EACA,sCAAA;EACA,qCAAA;EACA,qCAAA;EACA,uCAAA;EAIA,+DAAA;EACA,6CAAA;EAGA,6BAAA;EACA,mCAAA;EAGA,0CAAA;EAGA,kDAAA;EAGA,kCAAA;EACA,iCAAA;EAGA,uEAAA;EACA,6BAAA;EACA,uCAAA;EACA,4BAAA;EAGA,2BAAA;EACA,8BAAA;EACA,qCAAA;A3E+j9BJ;;A4E75+BA;EAEE,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,kBAAA;EAAA,mBAAA;EAAA,uBAAA;EAGD,kCAAA;EACA,4BAAA;EAEA,wBAAA;EACA,qBAAA;EAEA,0BAAA;EAEA,2BAAA;EACA,wBAAA;EACA,8BAAA;EAEA,wBAAA;A5Eg6+BD;;A6Er7+BA;EACC,+BAAA;EACA,UAAA;A7Ew7+BD;;A8E57+BA;EACC,wCAAA;A9E+7+BD;;A+E77+BA;EACI,2BAAA;A/Eg8+BJ;;A+E37+BC;EACC,wBAAA;A/E87+BF;A+E37+BC;EACC,wCAAA;A/E67+BF;A+E17+BC;EACC,8CAAA;A/E47+BF;;A+Et7+BC;EACC,wBAAA;A/Ey7+BF;A+Et7+BC;EACC,wCAAA;A/Ew7+BF;A+Er7+BC;EACC,8CAAA;A/Eu7+BF;;AgFr9+BA;EACE,sBAAA;EACA,yBAAA;AhFw9+BF;;AgFp9+BA;EACI;IACI,mCAAA;IACA,mBAAA;EhFu9+BN;EgFp9+BE;IACI,+BAAA;EhFs9+BN;AACF;AgFn9+BA;EACI,oCAAA;AhFq9+BJ;;AgFj9+BA;EACI;IACI,kCAAA;IACA,mBAAA;EhFo9+BN;EgFj9+BE;IACI,+BAAA;EhFm9+BN;AACF;AgFh9+BA;EACI,kCAAA;AhFk9+BJ;;AgF98+BA;EACI;IACI,UAAA;EhFi9+BN;EgF98+BE;IACI,UAAA;EhFg9+BN;AACF;AgF78+BA;EACI,+BAAA;AhF+8+BJ;;AgF38+BA;EACI;IACI,UAAA;EhF88+BN;EgF38+BE;IACI,UAAA;EhF68+BN;AACF;AgF38+BA;EACI,gCAAA;AhF68+BJ;;AgFz8+BA;EACI,qDAAA;AhF48+BJ;;AgFz8+BA;EACI;IACI,kBAAA;EhF48+BN;AACF;AgFz8+BA;EACI,sDAAA;AhF28+BJ;;AgFx8+BA;EACI;IACI,YAAA;EhF28+BN;EgFx8+BE;IACI,UAAA;EhF08+BN;AACF;AiFli/BC;EACC,sBAAA;EACA,6BAAA;EACA,uCAAA;AjFoi/BF;AiFli/BE;EACI,sBAAA;AjFoi/BN;;AiF1i/BC;EACC,sBAAA;EACA,6BAAA;EACA,uCAAA;AjF6i/BF;AiF3i/BE;EACI,sBAAA;AjF6i/BN;;AiFnj/BC;EACC,wBAAA;EACA,+BAAA;EACA,yCAAA;AjFsj/BF;AiFpj/BE;EACI,wBAAA;AjFsj/BN;;AiF5j/BC;EACC,0BAAA;EACA,iCAAA;EACA,2CAAA;AjF+j/BF;AiF7j/BE;EACI,0BAAA;AjF+j/BN;;AiFrk/BC;EACC,wBAAA;EACA,+BAAA;EACA,yCAAA;AjFwk/BF;AiFtk/BE;EACI,wBAAA;AjFwk/BN;;AiF9k/BC;EACC,qBAAA;EACA,4BAAA;EACA,sCAAA;AjFil/BF;AiF/k/BE;EACI,qBAAA;AjFil/BN;;AiFvl/BC;EACC,wBAAA;EACA,+BAAA;EACA,yCAAA;AjF0l/BF;AiFxl/BE;EACI,wBAAA;AjF0l/BN;;AiFhm/BC;EACC,uBAAA;EACA,8BAAA;EACA,wCAAA;AjFmm/BF;AiFjm/BE;EACI,uBAAA;AjFmm/BN;;AiFzm/BC;EACC,qBAAA;EACA,4BAAA;EACA,sCAAA;AjF4m/BF;AiF1m/BE;EACI,qBAAA;AjF4m/BN;;AkFnn/BA;EACC,iDAAA;EACA,2CAAA;EACA,+DAAA;EACA,+DAAA;EACA,2EAAA;EACA,8DAAA;EACA,6EAAA;EACA,uEAAA;EACA,mEAAA;EACA,6DAAA;EACA,+DAAA;EACA,yDAAA;EACA,6EAAA;AlFsn/BD;;AmFpo/BA;EACC,wCAAA;EACA,kDAAA;EvESK,0CARW;AZuo/BjB;;AmFpo/BA;EACC,qCAAA;AnFuo/BD;;AoF7o/BA;ExEUM,2CARW;AZ+o/BjB;;AqFnp/BA;EACC,6CAAA;EACA,uCAAA;EACA,2DAAA;EACA,uDAAA;EACA,uDAAA;EACA,uDAAA;EACA,mEAAA;EACA,6DAAA;EACA,qEAAA;EACA,+DAAA;EACA,yEAAA;EACA,2DAAA;ArFsp/BD;;AsFpq/BA;EACC,uCAAA;EACA,+CAAA;EACA,qDAAA;EACA,iDAAA;EACA,qDAAA;EACA,6DAAA;EACA,mEAAA;AtFuq/BD;AsFpq/BE;EACC,eAAA;AtFsq/BH;;AuF7q/BA;EACC,gCAAA;EACA,wCAAA;EACA,2BAAA;AvFgr/BD;AuF7q/BC;EACC,gCAAA;AvF+q/BF;;AwF1r/BA;EACC,+CAAA;EACA,+CAAA;EACA,6DAAA;EACA,yDAAA;AxF6r/BD;;AyF5r/BA;EACC,6CAAA;EACA,yDAAA;EACA,+DAAA;AzF+r/BD;;AyF3r/BA;EACC,2DAAA;EACA,iFAAA;EACA,qEAAA;EACA,+DAAA;EACA,mFAAA;AzF8r/BD;;AyF1r/BA;EACC,uEAAA;EACA,iEAAA;AzF6r/BD;;AyFxr/BC;EACC,oBAAA;AzF2r/BF;AyFzr/BE;EACC,eAAA;AzF2r/BH;;AyFrr/BA;EACC,oBAAA;EACA,yBAAA;EACA,4BAAA;AzFwr/BD;AyFtr/BC;EACC,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,4BAAA;AzFwr/BF;AyFrr/BC;EACC,aAAA;EACA,mBAAA;AzFur/BF;;AyFlr/BA;EACC,gBAAA;EnFvCG,uBAAA;EmFyCH,oCAAA;AzFqr/BD;AyFlr/BC;EACC,6BAAA;EACA,wCAAA;AzFor/BF;AyFhr/BC;EACC,aAAA;AzFkr/BF;AyFhr/BE;;EAEC,kBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;AzFkr/BH;AyF/q/BE;EACC,oBAAA;AzFir/BH;AyF/q/BG;EACC,WAAA;AzFir/BJ;AyF9q/BG;EACC,eAAA;AzFgr/BJ;;A0Fnw/BA;EACC,wBAAA;EACA,0BAAA;EACA,2CAAA;A1Fsw/BD;A0Fpw/BC;EACC,mBAAA;A1Fsw/BF;A0Fnw/BE;EACC,yBAAA;EACA,SAAA;EACA,oCAAA;EACA,2BrFyXe;EqFxXf,iBAAA;EACA,cAAA;A1Fqw/BH;A0Fhw/BG;EACC,cAAA;A1Fkw/BJ;A0F5v/BG;EACC,eAAA;A1F8v/BJ;A0Fxv/BC;;;EAGC,6BAAA;EACA,SAAA;EACA,0CAAA;EACA,2BrF8VgB;AL45+BlB;A0Ftv/BC;EACC,wBAAA;A1Fwv/BF;A0Ftv/BE;EACC,mBAAA;A1Fwv/BH;A0Ftv/BG;EACC,wBAAA;A1Fwv/BJ;A0Fnv/BE;;;EAGC,wBAAA;A1Fqv/BH;;A2F/y/BC;;EAEC,gDAAA;ErFWE,uBAAA;ANwy/BJ;A2Fhz/BE;;EACC,+CAAA;A3Fmz/BH;A2Fjz/BG;;EACC,mCAAA;A3Foz/BJ;A2F/y/BY;;EACI,WAAA;EACA,2BtFqXE;AL67+BlB;A2Fhz/BgB;;EACI,qBAAA;A3Fmz/BpB;A2Fhz/BgB;;EACI,aAAA;A3Fmz/BpB;A2F9y/BQ;;EACL,6BAAA;EACA,+CAAA;EACA,wBAAA;EACA,kBAAA;A3Fiz/BH;A2F/y/BG;;EACC,oCAAA;EACA,2BtFiWc;ALi9+BlB;A2F/y/BG;;EACC,cAAA;A3Fkz/BJ;A2F9y/BE;;EACC,aAAA;A3Fiz/BH;A2Fzy/BK;EACC,cAAA;A3F2y/BN;A2Fxy/BK;EACC,cAAA;A3F0y/BN;A2Fry/BK;EACC,yBAAA;A3Fuy/BN;A2Fpy/BK;EACC,yBAAA;A3Fsy/BN;A2Fjy/BK;EACC,yBAAA;A3Fmy/BN;A2Fhy/BK;EACC,yBAAA;A3Fky/BN;;A4Fl3/BA;EACC,iDAAA;EACA,2CAAA;EACA,+DAAA;EACA,6DAAA;EACA,uDAAA;EACA,2EAAA;EACA,6DAAA;EACA,uDAAA;EACA,uEAAA;EACA,+DAAA;EACA,yDAAA;EACA,6EAAA;EACA,mEAAA;EACA,6DAAA;EACA,iFAAA;EAEA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,SAAA;A5Fo3/BD;A4Fh3/BE;EACC,kBAAA;A5Fk3/BH;A4F52/BE;EACC,wCAAA;A5F82/BH;A4Fx2/BO;EACI,qCAAA;A5F02/BX;;A4Fn2/BA;EACI,oBvF01BgD;EuF1tBnD,iBAAA;A5Fuu/BD;A4Fr2/BC;EACO,eAAA;A5Fu2/BR;A4Fp2/BC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBvFoT8B;EuFnT9B,cvF40BkD;EuF30BlD,iBvF20BkD;EuF10BlD,gBvFuXqB;EuFtXrB,mBvFgXa;EuF1Wb,mCAAA;EASA,iBAAA;EAMA,mCAAA;A5Fo1/BF;A4Fv2/BE;EACC,kBvF60BiD;AL4h+BpD;A4Fr2/BE;;EAEC,cAAA;EACA,gBvFu0BiD;EuFt0BjD,evFs0BiD;EuFp0BjD,uCAAA;A5Fs2/BH;A4Fl2/BE;EC5BM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yBxF5CG;EwFgDP,oDAAA;A7F43/BJ;A4Ft2/BE;ECjCM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yBxF5CG;EwFgDP,oDAAA;A7Fq4/BJ;A4Fz2/BE;EACC,uCAAA;EAWA,mCAAA;A5Fi2/BH;A4F12/BG;;EAEC,uCAAA;A5F42/BJ;A4Fz2/BG;EC/CK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDDyC8B;ECrClC,oDAAA;A7Fs5/BJ;A4F72/BG;ECpDK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDD8C4B;EC1ChC,oDAAA;A7F+5/BJ;A4F/2/BE;EACC,uCAAA;EAeA,mCAAA;A5Fm2/BH;A4Fh3/BG;EACC,6BAAA;A5Fk3/BJ;A4F/2/BG;;EAEC,uCAAA;A5Fi3/BJ;A4F92/BG;ECvEK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDDiE8B;EC7DlC,oDAAA;A7Fm7/BJ;A4Fl3/BG;EC5EK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDDsE4B;EClEhC,oDAAA;A7F47/BJ;A4Fp3/BE;EACC,wCAAA;EAeA,mCAAA;A5Fw2/BH;A4Fr3/BG;EACC,6BAAA;A5Fu3/BJ;A4Fp3/BG;;EAEC,wCAAA;A5Fs3/BJ;A4Fn3/BG;EC/FK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mDDyF8B;ECrFlC,oDAAA;A7Fg9/BJ;A4Fv3/BG;ECpGK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mDD8F4B;EC1FhC,oDAAA;A7Fy9/BJ;A4Fz3/BE;EACC,0CAAA;EAWA,mCAAA;A5Fi3/BH;A4F13/BG;;EAEC,0CAAA;A5F43/BJ;A4Fz3/BG;ECnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qDD6G8B;ECzGlC,oDAAA;A7F0+/BJ;A4F73/BG;ECxHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qDDkH4B;EC9GhC,oDAAA;A7Fm//BJ;;Aex+/BI;E6E4GH;IACC,qBvFqtBkD;EL2q+BlD;E4F93/BA;IACC,eAAA;E5Fg4/BD;AACF;A8FzjgCA;EACI,cAAA;EACA,SAAA;EACA,+CAAA;A9F2jgCJ;A8FzjgCI;EACI,2BAAA;EACA,kDAAA;A9F2jgCR;A8FxjgCI;EACI,2BAAA;EACA,kDAAA;A9F0jgCR;A8FvjgCI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;A9FyjgCR;A8FvjgCQ;EAEI,YAAA;EACA,UAAA;EACA,+CAAA;A9FwjgCZ;A8FrjgCQ;EACI,qBAAA;A9FujgCZ;A8FpjgCQ;EACI,oBAAA;A9FsjgCZ;A8FljgCY;EAEI,2BAAA;EACA,kDAAA;A9FmjgChB;A8F9igCY;EAEI,2BAAA;EACA,kDAAA;A9F+igChB;A8FzigCgB;EAEI,gCAAA;A9F0igCpB;A8F5igCgB;EAEI,gCAAA;A9F6igCpB;A8F/igCgB;EAEI,gCAAA;A9FgjgCpB;A8FljgCgB;EAEI,gCAAA;A9FmjgCpB;A8FrjgCgB;EAEI,gCAAA;A9FsjgCpB;A8FxjgCgB;EAEI,gCAAA;A9FyjgCpB;A8F3jgCgB;EAEI,gCAAA;A9F4jgCpB;A8F9jgCgB;EAEI,gCAAA;A9F+jgCpB;A8FjkgCgB;EAEI,gCAAA;A9FkkgCpB;;A+FvngCI;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;A/F0ngCR;A+FxngCQ;EACI,eAAA;EACA,UAAA;A/F0ngCZ;A+FxngCY;EACI,eAAA;EACA,UAAA;A/F0ngChB;A+FpngCY;EACI,gBAAA;EACA,6BAAA;EACA,Y1F4pCgD;E0F3pChD,W1F2pCgD;E0F1pChD,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A/FsngChB;A+FpngCgB;EACI,qBAAA;EACA,YAAA;EzFpBhB,kBAAA;EyFsBgB,yBAAA;EACA,sEAAA;EACA,W1F8oC4C;E0F7oC5C,U1F6oC4C;ALy+9BhE;A+FnngCgB;EACI,6BAAA;A/FqngCpB;A+FnngCoB;EACI,yBAAA;EACA,Y1FsoCwC;E0FroCxC,W1FqoCwC;E0FpoCxC,qEAAA;A/FqngCxB;A+F7mgCY;EACI,yBAAA;EACA,6BAAA;EACA,kB1F2nCgD;E0F1nChD,W1F0nCgD;E0FznChD,U1FynCgD;E0FxnChD,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;A/F+mgChB;A+F7mgCgB;EACI,qBAAA;EACA,YAAA;EACA,yBAAA;EACA,6EAAA;EACA,kB1F8mC4C;E0F7mC5C,W1F6mC4C;E0F5mC5C,U1F4mC4C;ALmg+BhE;A+F5mgCgB;EACI,yBAAA;EACA,6BAAA;EACA,W1FsmC4C;E0FrmC5C,W1FsmC4C;ALwg+BhE;A+F5mgCoB;EACI,yBAAA;EACA,W1FimCwC;E0FhmCxC,W1FimCwC;E0FhmCxC,4EAAA;A/F8mgCxB;A+FpmgCY;EACI,oCAAA;A/FsmgChB;A+FvmgCY;EACI,oCAAA;A/FymgChB;A+F1mgCY;EACI,oCAAA;A/F4mgChB;A+F7mgCY;EACI,oCAAA;A/F+mgChB;A+FhngCY;EACI,oCAAA;A/FkngChB;A+FnngCY;EACI,oCAAA;A/FqngChB;A+FtngCY;EACI,oCAAA;A/FwngChB;A+FzngCY;EACI,oCAAA;A/F2ngChB;A+F5ngCY;EACI,oCAAA;A/F8ngChB;A+FxngCI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;A/F0ngCR;A+FxngCQ;EACI,YAAA;A/F0ngCZ;A+FvngCQ;EACI,YAAA;A/FyngCZ;A+FtngCQ;EACI,aAAA;EACA,sBAAA;EACA,YAAA;A/FwngCZ;;AgGjvgCA;EACI,aAAA;AhGovgCJ;;AgGhvgCA;;EAEI,aAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AhGmvgCJ;;AgG/ugCA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;AhGkvgCJ;;AgG9ugCA;EACI,aAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AhGivgCJ;;AgG7ugCA;EACI,cAAA;EACA,kBAAA;AhGgvgCJ;AgG7ugCI;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,wBAAA;AhG+ugCR;AgG7ugCQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,W3Fo5CK;E2Fn5CL,oB3Fo5CM;AL219BlB;AgG7ugCY;EACI,cAAA;AhG+ugChB;AgG3ugCQ;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,c3Fy4CO;E2Fx4CP,oB3Fy4CQ;ALo29BpB;AgG1ugCQ;EACI,aAAA;EACA,mBAAA;EACA,YAAA;AhG4ugCZ;AgGzugCQ;EACI,aAAA;EACA,mBAAA;EACA,cAAA;EACA,mB3F63CO;AL829BnB;AgGxugCQ;EACI,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gB3Fs3CO;E2Fr3CP,U3Fo3CM;E2Fn3CN,W3Fm3CM;ALu39BlB;AgGxugCY;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,0BAAA;EH9CR,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCGwC0C;EHpC9C,oDAAA;EGqCY,mBAAA;EHhDR,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCG0CwC;EHtC5C,oDAAA;EGuCY,iBAAA;AhGsvgChB;AgGhvgCI;EACI,qBAAA;AhGkvgCR;;AgG1ugCY;EACI,2BAAA;EACA,+B3F4zCkB;ALi79BlC;;AgGtugCA;EACI,uBAAA;AhGyugCJ;;AgGrugCA;EACI,mCAAA;AhGwugCJ;;AgGztgCgB;EC/If,aAAA;EACA,0BAAA;EACA,aAAA;EACA,yBAAA;EACA,+B5F26CiC;ALi89BlC;AgG1tgCwB;ECtJvB,aAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,+B5F26CiC;ALw89BlC;;AgGztgCY;EACI,aAAA;EACA,uB3F2MgB;E2F1MhB,kDAAA;EACA,8CAAA;EACA,Y3FowCQ;ALw99BxB;AgGztgCgB;EAGI,aAAA;EACA,sBAAA;EAKI,2GAAA;AhGqtgCxB;;AgG/sgCY;EACI,aAAA;AhGktgChB;AgGhtgCgB;EAEI,aAAA;AhGitgCpB;;AiGjxgCC;EACC,iB5FmzCyB;ALi+9B3B;AgG5sgCgB;EACI,kB3F+uCE;AL+99BtB;;AgGzsgCY;EACI,aAAA;AhG4sgChB;;AgGtsgCoB;;EAEI,0BAAA;EACA,2BAAA;AhGysgCxB;;AgGpsgCY;EACI,sBAAA;EACA,WAAA;AhGusgChB;;AgGpsgCY;EACI,mBAAA;AhGusgChB;AgGrsgCgB;EACI,aAAA;EACA,mBAAA;AhGusgCpB;AgGpsgCwB;ECrOvB,aAAA;EACA,0BAAA;EACA,aAAA;EACA,yBAAA;EACA,+B5F26CiC;ALig+BlC;;AgGlsgCgB;E1FjOZ,uBAAA;ANu6gCJ;;AgG/rgCgB;EACI,mBAAA;AhGksgCpB;;AgG5rgCgB;EACI,2BAAA;AhG+rgCpB;;AkG17gCY;EF6II;IC/If,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;ELsh+BhC;EgG/ygCsB;ICtJvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+B5F26CiC;EL6h+BhC;;EgG9ygCU;IACI,aAAA;IACA,uB3F2MgB;I2F1MhB,kDAAA;IACA,8CAAA;IACA,Y3FowCQ;EL6i+BtB;EgG9ygCc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;EhG0ygCtB;;EgGpygCU;IACI,aAAA;EhGuygCd;EgGrygCc;IAEI,aAAA;EhGsygClB;;EiGt2gCD;IACC,iB5FmzCyB;ELsj+BzB;EgGjygCc;IACI,kB3F+uCE;ELoj+BpB;;EgG9xgCU;IACI,aAAA;EhGiygCd;;EgG3xgCkB;;IAEI,0BAAA;IACA,2BAAA;EhG8xgCtB;;EgGzxgCU;IACI,sBAAA;IACA,WAAA;EhG4xgCd;;EgGzxgCU;IACI,mBAAA;EhG4xgCd;EgG1xgCc;IACI,aAAA;IACA,mBAAA;EhG4xgClB;EgGzxgCsB;ICrOvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;ELsl+BhC;;EgGvxgCc;I1FjOZ,uBAAA;EN4/gCF;;EgGpxgCc;IACI,mBAAA;EhGuxgClB;;EgGjxgCc;IACI,2BAAA;EhGoxgClB;AACF;AkGhhhCY;EF6II;IC/If,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;EL2m+BhC;EgGp4gCsB;ICtJvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+B5F26CiC;ELkn+BhC;;EgGn4gCU;IACI,aAAA;IACA,uB3F2MgB;I2F1MhB,kDAAA;IACA,8CAAA;IACA,Y3FowCQ;ELko+BtB;EgGn4gCc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;EhG+3gCtB;;EgGz3gCU;IACI,aAAA;EhG43gCd;EgG13gCc;IAEI,aAAA;EhG23gClB;;EiG37gCD;IACC,iB5FmzCyB;EL2o+BzB;EgGt3gCc;IACI,kB3F+uCE;ELyo+BpB;;EgGn3gCU;IACI,aAAA;EhGs3gCd;;EgGh3gCkB;;IAEI,0BAAA;IACA,2BAAA;EhGm3gCtB;;EgG92gCU;IACI,sBAAA;IACA,WAAA;EhGi3gCd;;EgG92gCU;IACI,mBAAA;EhGi3gCd;EgG/2gCc;IACI,aAAA;IACA,mBAAA;EhGi3gClB;EgG92gCsB;ICrOvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;EL2q+BhC;;EgG52gCc;I1FjOZ,uBAAA;ENilhCF;;EgGz2gCc;IACI,mBAAA;EhG42gClB;;EgGt2gCc;IACI,2BAAA;EhGy2gClB;AACF;AkGrmhCY;EF6II;IC/If,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;ELgs+BhC;EgGz9gCsB;ICtJvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+B5F26CiC;ELus+BhC;;EgGx9gCU;IACI,aAAA;IACA,uB3F2MgB;I2F1MhB,kDAAA;IACA,8CAAA;IACA,Y3FowCQ;ELut+BtB;EgGx9gCc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;EhGo9gCtB;;EgG98gCU;IACI,aAAA;EhGi9gCd;EgG/8gCc;IAEI,aAAA;EhGg9gClB;;EiGhhhCD;IACC,iB5FmzCyB;ELgu+BzB;EgG38gCc;IACI,kB3F+uCE;EL8t+BpB;;EgGx8gCU;IACI,aAAA;EhG28gCd;;EgGr8gCkB;;IAEI,0BAAA;IACA,2BAAA;EhGw8gCtB;;EgGn8gCU;IACI,sBAAA;IACA,WAAA;EhGs8gCd;;EgGn8gCU;IACI,mBAAA;EhGs8gCd;EgGp8gCc;IACI,aAAA;IACA,mBAAA;EhGs8gClB;EgGn8gCsB;ICrOvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;ELgw+BhC;;EgGj8gCc;I1FjOZ,uBAAA;ENsqhCF;;EgG97gCc;IACI,mBAAA;EhGi8gClB;;EgG37gCc;IACI,2BAAA;EhG87gClB;AACF;AkG1rhCY;EF6II;IC/If,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;ELqx+BhC;EgG9ihCsB;ICtJvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+B5F26CiC;EL4x+BhC;;EgG7ihCU;IACI,aAAA;IACA,uB3F2MgB;I2F1MhB,kDAAA;IACA,8CAAA;IACA,Y3FowCQ;EL4y+BtB;EgG7ihCc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;EhGyihCtB;;EgGnihCU;IACI,aAAA;EhGsihCd;EgGpihCc;IAEI,aAAA;EhGqihClB;;EiGrmhCD;IACC,iB5FmzCyB;ELqz+BzB;EgGhihCc;IACI,kB3F+uCE;ELmz+BpB;;EgG7hhCU;IACI,aAAA;EhGgihCd;;EgG1hhCkB;;IAEI,0BAAA;IACA,2BAAA;EhG6hhCtB;;EgGxhhCU;IACI,sBAAA;IACA,WAAA;EhG2hhCd;;EgGxhhCU;IACI,mBAAA;EhG2hhCd;EgGzhhCc;IACI,aAAA;IACA,mBAAA;EhG2hhClB;EgGxhhCsB;ICrOvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;ELq1+BhC;;EgGthhCc;I1FjOZ,uBAAA;EN2vhCF;;EgGnhhCc;IACI,mBAAA;EhGshhClB;;EgGhhhCc;IACI,2BAAA;EhGmhhClB;AACF;AkG/whCY;EF6II;IC/If,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;EL02+BhC;EgGnohCsB;ICtJvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+B5F26CiC;ELi3+BhC;;EgGlohCU;IACI,aAAA;IACA,uB3F2MgB;I2F1MhB,kDAAA;IACA,8CAAA;IACA,Y3FowCQ;ELi4+BtB;EgGlohCc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;EhG8nhCtB;;EgGxnhCU;IACI,aAAA;EhG2nhCd;EgGznhCc;IAEI,aAAA;EhG0nhClB;;EiG1rhCD;IACC,iB5FmzCyB;EL04+BzB;EgGrnhCc;IACI,kB3F+uCE;ELw4+BpB;;EgGlnhCU;IACI,aAAA;EhGqnhCd;;EgG/mhCkB;;IAEI,0BAAA;IACA,2BAAA;EhGknhCtB;;EgG7mhCU;IACI,sBAAA;IACA,WAAA;EhGgnhCd;;EgG7mhCU;IACI,mBAAA;EhGgnhCd;EgG9mhCc;IACI,aAAA;IACA,mBAAA;EhGgnhClB;EgG7mhCsB;ICrOvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;EL06+BhC;;EgG3mhCc;I1FjOZ,uBAAA;ENg1hCF;;EgGxmhCc;IACI,mBAAA;EhG2mhClB;;EgGrmhCc;IACI,2BAAA;EhGwmhClB;AACF;AkGz1hCY;EFkII;IC/If,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;EL+7+BhC;EgGxthCsB;ICtJvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+B5F26CiC;ELs8+BhC;;EgGvthCU;IACI,aAAA;IACA,uB3F2MgB;I2F1MhB,kDAAA;IACA,8CAAA;IACA,Y3FowCQ;ELs9+BtB;EgGvthCc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;EhGmthCtB;;EgG7shCU;IACI,aAAA;EhGgthCd;EgG9shCc;IAEI,aAAA;EhG+shClB;;EiG/whCD;IACC,iB5FmzCyB;EL+9+BzB;EgG1shCc;IACI,kB3F+uCE;EL69+BpB;;EgGvshCU;IACI,aAAA;EhG0shCd;;EgGpshCkB;;IAEI,0BAAA;IACA,2BAAA;EhGushCtB;;EgGlshCU;IACI,sBAAA;IACA,WAAA;EhGqshCd;;EgGlshCU;IACI,mBAAA;EhGqshCd;EgGnshCc;IACI,aAAA;IACA,mBAAA;EhGqshClB;EgGlshCsB;ICrOvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;EL+/+BhC;;EgGhshCc;I1FjOZ,uBAAA;ENq6hCF;;EgG7rhCc;IACI,mBAAA;EhGgshClB;;EgG1rhCc;IACI,2BAAA;EhG6rhClB;AACF;AkG96hCY;EFkII;IC/If,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;ELoh/BhC;EgG7yhCsB;ICtJvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+B5F26CiC;EL2h/BhC;;EgG5yhCU;IACI,aAAA;IACA,uB3F2MgB;I2F1MhB,kDAAA;IACA,8CAAA;IACA,Y3FowCQ;EL2i/BtB;EgG5yhCc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;EhGwyhCtB;;EgGlyhCU;IACI,aAAA;EhGqyhCd;EgGnyhCc;IAEI,aAAA;EhGoyhClB;;EiGp2hCD;IACC,iB5FmzCyB;ELoj/BzB;EgG/xhCc;IACI,kB3F+uCE;ELkj/BpB;;EgG5xhCU;IACI,aAAA;EhG+xhCd;;EgGzxhCkB;;IAEI,0BAAA;IACA,2BAAA;EhG4xhCtB;;EgGvxhCU;IACI,sBAAA;IACA,WAAA;EhG0xhCd;;EgGvxhCU;IACI,mBAAA;EhG0xhCd;EgGxxhCc;IACI,aAAA;IACA,mBAAA;EhG0xhClB;EgGvxhCsB;ICrOvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;ELol/BhC;;EgGrxhCc;I1FjOZ,uBAAA;EN0/hCF;;EgGlxhCc;IACI,mBAAA;EhGqxhClB;;EgG/whCc;IACI,2BAAA;EhGkxhClB;AACF;AkGngiCY;EFkII;IC/If,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;ELym/BhC;EgGl4hCsB;ICtJvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+B5F26CiC;ELgn/BhC;;EgGj4hCU;IACI,aAAA;IACA,uB3F2MgB;I2F1MhB,kDAAA;IACA,8CAAA;IACA,Y3FowCQ;ELgo/BtB;EgGj4hCc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;EhG63hCtB;;EgGv3hCU;IACI,aAAA;EhG03hCd;EgGx3hCc;IAEI,aAAA;EhGy3hClB;;EiGz7hCD;IACC,iB5FmzCyB;ELyo/BzB;EgGp3hCc;IACI,kB3F+uCE;ELuo/BpB;;EgGj3hCU;IACI,aAAA;EhGo3hCd;;EgG92hCkB;;IAEI,0BAAA;IACA,2BAAA;EhGi3hCtB;;EgG52hCU;IACI,sBAAA;IACA,WAAA;EhG+2hCd;;EgG52hCU;IACI,mBAAA;EhG+2hCd;EgG72hCc;IACI,aAAA;IACA,mBAAA;EhG+2hClB;EgG52hCsB;ICrOvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;ELyq/BhC;;EgG12hCc;I1FjOZ,uBAAA;EN+kiCF;;EgGv2hCc;IACI,mBAAA;EhG02hClB;;EgGp2hCc;IACI,2BAAA;EhGu2hClB;AACF;AkGxliCY;EFkII;IC/If,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;EL8r/BhC;EgGv9hCsB;ICtJvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+B5F26CiC;ELqs/BhC;;EgGt9hCU;IACI,aAAA;IACA,uB3F2MgB;I2F1MhB,kDAAA;IACA,8CAAA;IACA,Y3FowCQ;ELqt/BtB;EgGt9hCc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;EhGk9hCtB;;EgG58hCU;IACI,aAAA;EhG+8hCd;EgG78hCc;IAEI,aAAA;EhG88hClB;;EiG9giCD;IACC,iB5FmzCyB;EL8t/BzB;EgGz8hCc;IACI,kB3F+uCE;EL4t/BpB;;EgGt8hCU;IACI,aAAA;EhGy8hCd;;EgGn8hCkB;;IAEI,0BAAA;IACA,2BAAA;EhGs8hCtB;;EgGj8hCU;IACI,sBAAA;IACA,WAAA;EhGo8hCd;;EgGj8hCU;IACI,mBAAA;EhGo8hCd;EgGl8hCc;IACI,aAAA;IACA,mBAAA;EhGo8hClB;EgGj8hCsB;ICrOvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;EL8v/BhC;;EgG/7hCc;I1FjOZ,uBAAA;ENoqiCF;;EgG57hCc;IACI,mBAAA;EhG+7hClB;;EgGz7hCc;IACI,2BAAA;EhG47hClB;AACF;AkG7qiCY;EFkII;IC/If,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;ELmx/BhC;EgG5iiCsB;ICtJvB,aAAA;IACA,yBAAA;IACA,aAAA;IACA,0BAAA;IACA,+B5F26CiC;EL0x/BhC;;EgG3iiCU;IACI,aAAA;IACA,uB3F2MgB;I2F1MhB,kDAAA;IACA,8CAAA;IACA,Y3FowCQ;EL0y/BtB;EgG3iiCc;IAGI,aAAA;IACA,sBAAA;IAKI,2GAAA;EhGuiiCtB;;EgGjiiCU;IACI,aAAA;EhGoiiCd;EgGliiCc;IAEI,aAAA;EhGmiiClB;;EiGnmiCD;IACC,iB5FmzCyB;ELmz/BzB;EgG9hiCc;IACI,kB3F+uCE;ELiz/BpB;;EgG3hiCU;IACI,aAAA;EhG8hiCd;;EgGxhiCkB;;IAEI,0BAAA;IACA,2BAAA;EhG2hiCtB;;EgGthiCU;IACI,sBAAA;IACA,WAAA;EhGyhiCd;;EgGthiCU;IACI,mBAAA;EhGyhiCd;EgGvhiCc;IACI,aAAA;IACA,mBAAA;EhGyhiClB;EgGthiCsB;ICrOvB,aAAA;IACA,0BAAA;IACA,aAAA;IACA,yBAAA;IACA,+B5F26CiC;ELm1/BhC;;EgGphiCc;I1FjOZ,uBAAA;ENyviCF;;EgGjhiCc;IACI,mBAAA;EhGohiClB;;EgG9giCc;IACI,2BAAA;EhGihiClB;AACF;AgGzgiCI;EACI,cAAA;EACA,iBAAA;AhG2giCR;AiG/uiCG;;;;EAEC,+BAAA;AjGmviCJ;AiG7uiCK;;;;;;;;EAEC,+BAAA;AjGqviCN;AiG/uiCO;;;;;;;;;;;;;;;;EAEC,+BAAA;AjG+viCR;AiGzviCS;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAEC,+BAAA;AjGyxiCV;AiG1wiCI;;;;EAEC,kBAAA;EACA,gBAAA;AjG8wiCL;AiGxwiCM;;;;;;;;EAEC,wBAAA;EACA,gBAAA;AjGgxiCP;AiG1wiCQ;;;;;;;;;;;;;;;;EAEC,wBAAA;EACA,gBAAA;AjG0xiCT;AiGpxiCU;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAEC,wBAAA;EACA,gBAAA;AjGoziCX;;AgGhpiCA;EACI;IACI,UAAA;EhGmpiCN;EgGhpiCE;IACI,UAAA;EhGkpiCN;AACF;AgG/oiCA;EACI;IACI,mBAAA;EhGipiCN;EgG9oiCE;IACI,aAAA;EhGgpiCN;AACF;AgG7oiCA;EACI;IACI,sBAAA;EhG+oiCN;EgG5oiCE;IACI,gBAAA;EhG8oiCN;AACF;AiGtwiCC;EA5CC,sBEnI4C;AnGw7iC9C;AiGnziCE;EACC,sBEtI2C;AnG27iC9C;AiG/yiCG;;;EAGC,sBE/I8D;AnGg8iClE;AiG1yiCG;EACC,iCEvJkF;AnGm8iCtF;AiGryiCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjGmziCH;;AiGtyiCC;EA5CC,2BE5H4C;AnGk9iC9C;AiGp1iCE;EACC,2BE/H2C;AnGq9iC9C;;AiGh1iCG;;;EAGC,2BEjIgD;AnGo9iCpD;;AiG50iCG;EACC,sCElIsD;AnGi9iC1D;;AiGx0iCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjGu1iCH;;AiG10iCC;EA5CC,wBEnI4C;AnG6/iC9C;AiGx3iCE;EACC,wBEtI2C;AnGggjC9C;AiGp3iCG;;;EAGC,wBE/I8D;AnGqgjClE;AiG/2iCG;EACC,mCEvJkF;AnGwgjCtF;AiG12iCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjGw3iCH;;AiG32iCC;EA5CC,6BE5H4C;AnGuhjC9C;AiGz5iCE;EACC,6BE/H2C;AnG0hjC9C;;AiGr5iCG;;;EAGC,6BEjIgD;AnGyhjCpD;;AiGj5iCG;EACC,wCElIsD;AnGshjC1D;;AiG74iCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,wCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,wCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjG45iCH;;AiG/4iCC;EA5CC,0BEnI4C;AnGkkjC9C;AiG77iCE;EACC,0BEtI2C;AnGqkjC9C;AiGz7iCG;;;EAGC,0BE/I8D;AnG0kjClE;AiGp7iCG;EACC,qCEvJkF;AnG6kjCtF;AiG/6iCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjG67iCH;;AiGh7iCC;EA5CC,+BE5H4C;AnG4ljC9C;AiG99iCE;EACC,+BE/H2C;AnG+ljC9C;;AiG19iCG;;;EAGC,+BEjIgD;AnG8ljCpD;;AiGt9iCG;EACC,0CElIsD;AnG2ljC1D;;AiGl9iCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,0CMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,0CMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjGi+iCH;;AiGp9iCC;EA5CC,sBEnI4C;AnGuojC9C;AiGlgjCE;EACC,sBEtI2C;AnG0ojC9C;AiG9/iCG;;;EAGC,sBE/I8D;AnG+ojClE;AiGz/iCG;EACC,iCEvJkF;AnGkpjCtF;AiGp/iCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjGkgjCH;;AiGr/iCC;EA5CC,2BE5H4C;AnGiqjC9C;AiGnijCE;EACC,2BE/H2C;AnGoqjC9C;;AiG/hjCG;;;EAGC,2BEjIgD;AnGmqjCpD;;AiG3hjCG;EACC,sCElIsD;AnGgqjC1D;;AiGvhjCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjGsijCH;;AiGzhjCC;EA5CC,wBEnI4C;AnG4sjC9C;AiGvkjCE;EACC,wBEtI2C;AnG+sjC9C;AiGnkjCG;;;EAGC,wBE/I8D;AnGotjClE;AiG9jjCG;EACC,mCEvJkF;AnGutjCtF;AiGzjjCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjGukjCH;;AiG1jjCC;EA5CC,6BE5H4C;AnGsujC9C;AiGxmjCE;EACC,6BE/H2C;AnGyujC9C;;AiGpmjCG;;;EAGC,6BEjIgD;AnGwujCpD;;AiGhmjCG;EACC,wCElIsD;AnGqujC1D;;AiG5ljCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,wCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,wCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjG2mjCH;;AiG9ljCC;EA5CC,qBEnI4C;AnGixjC9C;AiG5ojCE;EACC,qBEtI2C;AnGoxjC9C;AiGxojCG;;;EAGC,qBE/I8D;AnGyxjClE;AiGnojCG;EACC,gCEvJkF;AnG4xjCtF;AiG9njCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjG4ojCH;;AiG/njCC;EA5CC,0BE5H4C;AnG2yjC9C;AiG7qjCE;EACC,0BE/H2C;AnG8yjC9C;;AiGzqjCG;;;EAGC,0BEjIgD;AnG6yjCpD;;AiGrqjCG;EACC,qCElIsD;AnG0yjC1D;;AiGjqjCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjGgrjCH;;AiGnqjCC;EA5CC,wBEnI4C;AnGs1jC9C;AiGjtjCE;EACC,wBEtI2C;AnGy1jC9C;AiG7sjCG;;;EAGC,wBE/I8D;AnG81jClE;AiGxsjCG;EACC,mCEvJkF;AnGi2jCtF;AiGnsjCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjGitjCH;;AiGpsjCC;EA5CC,6BE5H4C;AnGg3jC9C;AiGlvjCE;EACC,6BE/H2C;AnGm3jC9C;;AiG9ujCG;;;EAGC,6BEjIgD;AnGk3jCpD;;AiG1ujCG;EACC,wCElIsD;AnG+2jC1D;;AiGtujCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,wCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,wCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjGqvjCH;;AiGxujCC;EA5CC,uBEnI4C;AnG25jC9C;AiGtxjCE;EACC,uBEtI2C;AnG85jC9C;AiGlxjCG;;;EAGC,uBE/I8D;AnGm6jClE;AiG7wjCG;EACC,kCEvJkF;AnGs6jCtF;AiGxwjCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjGsxjCH;;AiGzwjCC;EA5CC,4BE5H4C;AnGq7jC9C;AiGvzjCE;EACC,4BE/H2C;AnGw7jC9C;;AiGnzjCG;;;EAGC,4BEjIgD;AnGu7jCpD;;AiG/yjCG;EACC,uCElIsD;AnGo7jC1D;;AiG3yjCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,uCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,uCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjG0zjCH;;AiG7yjCC;EA5CC,qBEnI4C;AnGg+jC9C;AiG31jCE;EACC,qBEtI2C;AnGm+jC9C;AiGv1jCG;;;EAGC,qBE/I8D;AnGw+jClE;AiGl1jCG;EACC,gCEvJkF;AnG2+jCtF;AiG70jCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjG21jCH;;AiG90jCC;EA5CC,0BE5H4C;AnG0/jC9C;AiG53jCE;EACC,0BE/H2C;AnG6/jC9C;;AiGx3jCG;;;EAGC,0BEjIgD;AnG4/jCpD;;AiGp3jCG;EACC,qCElIsD;AnGy/jC1D;;AiGh3jCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,qCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjG+3jCH;;AiGl3jCC;EA5CC,sBEnI4C;AnGqikC9C;AiGh6jCE;EACC,sBEtI2C;AnGwikC9C;AiG55jCG;;;EAGC,sBE/I8D;AnG6ikClE;AiGv5jCG;EACC,iCEvJkF;AnGgjkCtF;AiGl5jCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjGg6jCH;;AiGn5jCC;EA5CC,2BE5H4C;AnG+jkC9C;AiGj8jCE;EACC,2BE/H2C;AnGkkkC9C;;AiG77jCG;;;EAGC,2BEjIgD;AnGikkCpD;;AiGz7jCG;EACC,sCElIsD;AnG8jkC1D;;AiGr7jCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjGo8jCH;;AiGv7jCC;EA5CC,yBEnI4C;AnG0mkC9C;AiGr+jCE;EACC,yBEtI2C;AnG6mkC9C;AiGj+jCG;;;EAGC,yBE/I8D;AnGknkClE;AiG59jCG;EACC,oCEvJkF;AnGqnkCtF;AiGv9jCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjGq+jCH;;AiGx9jCC;EA5CC,8BE5H4C;AnGookC9C;AiGtgkCE;EACC,8BE/H2C;AnGuokC9C;;AiGlgkCG;;;EAGC,8BEjIgD;AnGsokCpD;;AiG9/jCG;EACC,yCElIsD;AnGmokC1D;;AiG1/jCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjGygkCH;;AiG5/jCC;EA5CC,yBEnI4C;AnG+qkC9C;AiG1ikCE;EACC,yBEtI2C;AnGkrkC9C;AiGtikCG;;;EAGC,yBE/I8D;AnGurkClE;AiGjikCG;EACC,oCEvJkF;AnG0rkCtF;AiG5hkCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjG0ikCH;;AiG7hkCC;EA5CC,8BE5H4C;AnGyskC9C;AiG3kkCE;EACC,8BE/H2C;AnG4skC9C;;AiGvkkCG;;;EAGC,8BEjIgD;AnG2skCpD;;AiGnkkCG;EACC,yCElIsD;AnGwskC1D;;AiG/jkCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjG8kkCH;;AiGjkkCC;EA5CC,yBEnI4C;AnGovkC9C;AiG/mkCE;EACC,yBEtI2C;AnGuvkC9C;AiG3mkCG;;;EAGC,yBE/I8D;AnG4vkClE;AiGtmkCG;EACC,oCEvJkF;AnG+vkCtF;AiGjmkCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjG+mkCH;;AiGlmkCC;EA5CC,8BE5H4C;AnG8wkC9C;AiGhpkCE;EACC,8BE/H2C;AnGixkC9C;;AiG5okCG;;;EAGC,8BEjIgD;AnGgxkCpD;;AiGxokCG;EACC,yCElIsD;AnG6wkC1D;;AiGpokCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjGmpkCH;;AiGtokCC;EA5CC,yBEnI4C;AnGyzkC9C;AiGprkCE;EACC,yBEtI2C;AnG4zkC9C;AiGhrkCG;;;EAGC,yBE/I8D;AnGi0kClE;AiG3qkCG;EACC,oCEvJkF;AnGo0kCtF;AiGtqkCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjGorkCH;;AiGvqkCC;EA5CC,8BE5H4C;AnGm1kC9C;AiGrtkCE;EACC,8BE/H2C;AnGs1kC9C;;AiGjtkCG;;;EAGC,8BEjIgD;AnGq1kCpD;;AiG7skCG;EACC,yCElIsD;AnGk1kC1D;;AiGzskCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjGwtkCH;;AiG3skCC;EA5CC,yBEnI4C;AnG83kC9C;AiGzvkCE;EACC,yBEtI2C;AnGi4kC9C;AiGrvkCG;;;EAGC,yBE/I8D;AnGs4kClE;AiGhvkCG;EACC,oCEvJkF;AnGy4kCtF;AiG3ukCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjGyvkCH;;AiG5ukCC;EA5CC,8BE5H4C;AnGw5kC9C;AiG1xkCE;EACC,8BE/H2C;AnG25kC9C;;AiGtxkCG;;;EAGC,8BEjIgD;AnG05kCpD;;AiGlxkCG;EACC,yCElIsD;AnGu5kC1D;;AiG9wkCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjG6xkCH;;AiGhxkCC;EA5CC,yBEnI4C;AnGm8kC9C;AiG9zkCE;EACC,yBEtI2C;AnGs8kC9C;AiG1zkCG;;;EAGC,yBE/I8D;AnG28kClE;AiGrzkCG;EACC,oCEvJkF;AnG88kCtF;AiGhzkCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjG8zkCH;;AiGjzkCC;EA5CC,8BE5H4C;AnG69kC9C;AiG/1kCE;EACC,8BE/H2C;AnGg+kC9C;;AiG31kCG;;;EAGC,8BEjIgD;AnG+9kCpD;;AiGv1kCG;EACC,yCElIsD;AnG49kC1D;;AiGn1kCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjGk2kCH;;AiGr1kCC;EA5CC,yBEnI4C;AnGwglC9C;AiGn4kCE;EACC,yBEtI2C;AnG2glC9C;AiG/3kCG;;;EAGC,yBE/I8D;AnGghlClE;AiG13kCG;EACC,oCEvJkF;AnGmhlCtF;AiGr3kCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,oDAAA;EI0GD,iBAAA;AjGm4kCH;;AiGt3kCC;EA5CC,8BE5H4C;AnGkilC9C;AiGp6kCE;EACC,8BE/H2C;AnGqilC9C;;AiGh6kCG;;;EAGC,8BEjIgD;AnGoilCpD;;AiG55kCG;EACC,yCElIsD;AnGiilC1D;;AiGx5kCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,oDAAA;EI0GD,iBAAA;AjGu6kCH;;AiG15kCC;EA5CC,yBEnI4C;AnG6klC9C;AiGx8kCE;EACC,yBEtI2C;AnGgllC9C;AiGp8kCG;;;EAGC,yBE/I8D;AnGqllClE;AiG/7kCG;EACC,oCEvJkF;AnGwllCtF;AiG17kCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,qDAAA;EI0GD,iBAAA;AjGw8kCH;;AiG37kCC;EA5CC,8BE5H4C;AnGumlC9C;AiGz+kCE;EACC,8BE/H2C;AnG0mlC9C;;AiGr+kCG;;;EAGC,8BEjIgD;AnGymlCpD;;AiGj+kCG;EACC,yCElIsD;AnGsmlC1D;;AiG79kCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,qDAAA;EI0GD,iBAAA;AjG4+kCH;;AiG/9kCC;EA5CC,yBEnI4C;AnGkplC9C;AiG7glCE;EACC,yBEtI2C;AnGqplC9C;AiGzglCG;;;EAGC,yBE/I8D;AnG0plClE;AiGpglCG;EACC,oCEvJkF;AnG6plCtF;AiG//kCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCMpDkG;ENwDtG,qDAAA;EI0GD,iBAAA;AjG6glCH;;AiGhglCC;EA5CC,8BE5H4C;AnG4qlC9C;AiG9ilCE;EACC,8BE/H2C;AnG+qlC9C;;AiG1ilCG;;;EAGC,8BEjIgD;AnG8qlCpD;;AiGtilCG;EACC,yCElIsD;AnG2qlC1D;;AiGlilCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yCMxBwD;EN4B5D,qDAAA;EI0GD,iBAAA;AjGijlCH;;AiGvhlCC;EAEC,2B5FoMgB;E4FnQhB,oDEtFU;EF0FV,sCE9FU;AnGorlCZ;AiGpllCE;EACC,sCEjGS;AnGurlCZ;AiGhllCG;;;;;EAGC,sCEzGQ;AnG6rlCZ;AiG7klCG;EACC,iDEhHQ;AnG+rlCZ;AiGxklCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iDMZI;ENgBR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iDMZI;ENgBR,qDAAA;EI0GD,iBAAA;AjGsllCH;;AiGzhlCC;EACC,2B5FkKgB;E4FnQhB,mDE1EU;EF8EV,qCElFU;AnG6slCZ;AiGznlCE;EACC,qCErFS;AnGgtlCZ;AiGrnlCG;;;EAGC,qCE7FQ;AnGotlCZ;AiGhnlCG;EACC,gDEpGQ;AnGstlCZ;AiG3mlCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDAAA;EAIJ,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDAAA;EAIJ,qDAAA;EI0GD,iBAAA;AjGynlCH;;AiG5jlCC;EACC,2B5FkKgB;E4FnQhB,mDE9DU;EFkEV,qCEtEU;AnGoulCZ;AiG5plCE;EACC,qCEzES;AnGuulCZ;AiGxplCG;;;EAGC,qCEjFQ;AnG2ulCZ;AiGnplCG;EACC,gDExFQ;AnG6ulCZ;AiG9olCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMYI;ENRR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMYI;ENRR,qDAAA;EI0GD,iBAAA;AjG4plCH;;AexwlCI;EkFyKH;IACC,2B5FkKgB;I4FnQhB,mDEhDc;IFoDd,qCExDc;EnG0vlCd;EiGhslCA;IACC,qCE3Da;EnG6vlCd;EiG5rlCC;;;IAGC,qCEnEY;EnGiwlCd;EiGvrlCC;IACC,gDE1EY;EnGmwlCd;EiGlrlCA;IJjHM,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,gDM0BQ;INtBZ,qDAAA;IIwGD,mBAAA;IJnHK,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,gDM0BQ;INtBZ,qDAAA;II0GD,iBAAA;EjGgslCD;AACF;AiG7olCC;EACC,2B5F2KgB;E4FnQhB,mDEnCU;EFuCV,qCE3CU;AnGgxlCZ;AiGnulCE;EACC,qCE9CS;AnGmxlCZ;AiG/tlCG;;;EAGC,qCEtDQ;AnGuxlCZ;AiG1tlCG;EACC,gDE7DQ;AnGyxlCZ;AiGrtlCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMuCI;ENnCR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMuCI;ENnCR,qDAAA;EI0GD,iBAAA;AjGmulCH;;AiGzrlCC;EACC,2B5FqLgB;E4FnQhB,qDEvBU;EF2BV,uCE/BU;AnGuylCZ;AiGtwlCE;EACC,uCElCS;AnG0ylCZ;AiGlwlCG;;;EAGC,uCE1CQ;AnG8ylCZ;AiG7vlCG;EACC,kDEjDQ;AnGgzlCZ;AiGxvlCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDMmDI;EN/CR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDMmDI;EN/CR,qDAAA;EI0GD,iBAAA;AjGswlCH;;AiG5ulCC;EAEC,2B5FoMgB;E4FnQhB,oDEXU;EFeV,sCEnBU;AnG8zlCZ;AiGzylCE;EACC,sCEtBS;AnGi0lCZ;AiGrylCG;;;;;EAGC,sCE9BQ;AnGu0lCZ;AiGlylCG;EACC,iDErCQ;AnGy0lCZ;AiG7xlCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iDM+DI;EN3DR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iDM+DI;EN3DR,qDAAA;EI0GD,iBAAA;AjG2ylCH;AiG9ulCC;EACC,2B5FkKgB;E4FnQhB,mDEHU;EFOV,qCEXU;AnG01lCZ;AiG70lCE;EACC,qCEdS;AnG61lCZ;AiGz0lCG;;;EAGC,qCEtBQ;AnGi2lCZ;AiGp0lCG;EACC,gDE7BQ;AnGm2lCZ;AiG/zlCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMuEI;ENnER,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMuEI;ENnER,qDAAA;EI0GD,iBAAA;AjG60lCH;AiGzxlCC;EACC,2B5F2KgB;E4FnQhB,mDEKU;EFDV,qCEHU;AnGo3lCZ;AiG/2lCE;EACC,qCENS;AnGu3lCZ;AiG32lCG;;;EAGC,qCEdQ;AnG23lCZ;AiGt2lCG;EACC,gDErBQ;AnG63lCZ;AiGj2lCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDM+EI;EN3ER,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDM+EI;EN3ER,qDAAA;EI0GD,iBAAA;AjG+2lCH;AiGr0lCC;EACC,2B5FqLgB;E4FnQhB,qDEaU;EFTV,uCEKU;AnG84lCZ;AiGj5lCE;EACC,uCEES;AnGi5lCZ;AiG74lCG;;;EAGC,uCENQ;AnGq5lCZ;AiGx4lCG;EACC,kDEbQ;AnGu5lCZ;AiGn4lCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDMuFI;ENnFR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDMuFI;ENnFR,qDAAA;EI0GD,iBAAA;AjGi5lCH;;AiGv3lCC;EAEC,2B5FoMgB;E4F/PhB,sCEiBU;AnGo6lCZ;AiGn7lCE;EACC,sCEcS;AnGu6lCZ;AiG/6lCG;;;;;EAGC,sCEMQ;AnG66lCZ;AiG56lCG;EACC,iDEDQ;AnG+6lCZ;AiGv6lCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iDMmGI;EN/FR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,iDMmGI;EN/FR,qDAAA;EI0GD,iBAAA;AjGq7lCH;AiGx3lCC;EACC,2B5FkKgB;E4F/PhB,qCEyBU;AnG+7lCZ;AiGt9lCE;EACC,qCEsBS;AnGk8lCZ;AiGl9lCG;;;EAGC,qCEcQ;AnGs8lCZ;AiG78lCG;EACC,gDEOQ;AnGw8lCZ;AiGx8lCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDM2GI;ENvGR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDM2GI;ENvGR,qDAAA;EI0GD,iBAAA;AjGs9lCH;AiGl6lCC;EACC,2B5F2KgB;E4F/PhB,qCEiCU;AnGw9lCZ;AiGv/lCE;EACC,qCE8BS;AnG29lCZ;AiGn/lCG;;;EAGC,qCEsBQ;AnG+9lCZ;AiG9+lCG;EACC,gDEeQ;AnGi+lCZ;AiGz+lCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMmHI;EN/GR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gDMmHI;EN/GR,qDAAA;EI0GD,iBAAA;AjGu/lCH;AiG78lCC;EACC,2B5FqLgB;E4F/PhB,uCEyCU;AnGi/lCZ;AiGxhmCE;EACC,uCEsCS;AnGo/lCZ;AiGphmCG;;;EAGC,uCE8BQ;AnGw/lCZ;AiG/gmCG;EACC,kDEuBQ;AnG0/lCZ;AiG1gmCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDM2HI;ENvHR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,kDM2HI;ENvHR,qDAAA;EI0GD,iBAAA;AjGwhmCH;;AiG9/lCC;EAEC,2B5FoMgB;E4FnQhB,mCE8DU;EF1DV,gCEsDU;AnGugmCZ;AiG3jmCE;EACC,gCEmDS;AnG0gmCZ;AiGvjmCG;;;;;EAGC,gCE2CQ;AnGghmCZ;AiGpjmCG;EACC,2CEoCQ;AnGkhmCZ;AiG/imCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwII;ENpIR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwII;ENpIR,qDAAA;EI0GD,iBAAA;AjG6jmCH;;AiGzgmCC;EACC,2B5F2KgB;E4FnQhB,mCE0EU;EFtEV,gCEkEU;AnGgimCZ;AiGhmmCE;EACC,gCE+DS;AnGmimCZ;AiG5lmCG;;;EAGC,gCEuDQ;AnGuimCZ;AiGvlmCG;EACC,2CEgDQ;AnGyimCZ;AiGllmCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMoJI;ENhJR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMoJI;ENhJR,qDAAA;EI0GD,iBAAA;AjGgmmCH;;AiGnimCC;EACC,2B5FkKgB;E4FnQhB,mCEsFU;EFlFV,gCE8EU;AnGujmCZ;AiGnomCE;EACC,gCE2ES;AnG0jmCZ;AiG/nmCG;;;EAGC,gCEmEQ;AnG8jmCZ;AiG1nmCG;EACC,2CE4DQ;AnGgkmCZ;AiGrnmCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMgKI;EN5JR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMgKI;EN5JR,qDAAA;EI0GD,iBAAA;AjGmomCH;;AiGzlmCC;EACC,2B5FqLgB;E4FnQhB,mCEkGU;EF9FV,gCE0FU;AnG8kmCZ;AiGtqmCE;EACC,gCEuFS;AnGilmCZ;AiGlqmCG;;;EAGC,gCE+EQ;AnGqlmCZ;AiG7pmCG;EACC,2CEwEQ;AnGulmCZ;AiGxpmCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CM4KI;ENxKR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CM4KI;ENxKR,qDAAA;EI0GD,iBAAA;AjGsqmCH;;AiG5omCC;EAEC,2B5FoMgB;E4FnQhB,mCE8GU;EF1GV,gCEsGU;AnGqmmCZ;AiGzsmCE;EACC,gCEmGS;AnGwmmCZ;AiGrsmCG;;;;;EAGC,gCE2FQ;AnG8mmCZ;AiGlsmCG;EACC,2CEoFQ;AnGgnmCZ;AiG7rmCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwLI;ENpLR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwLI;ENpLR,qDAAA;EI0GD,iBAAA;AjG2smCH;AiGvpmCC;EACC,2B5F2KgB;E4FnQhB,mCEsHU;EFlHV,gCE8GU;AnGiomCZ;AiG7umCE;EACC,gCE2GS;AnGoomCZ;AiGzumCG;;;EAGC,gCEmGQ;AnGwomCZ;AiGpumCG;EACC,2CE4FQ;AnG0omCZ;AiG/tmCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMgMI;EN5LR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMgMI;EN5LR,qDAAA;EI0GD,iBAAA;AjG6umCH;AiGhrmCC;EACC,2B5FkKgB;E4FnQhB,mCE8HU;EF1HV,gCEsHU;AnG2pmCZ;AiG/wmCE;EACC,gCEmHS;AnG8pmCZ;AiG3wmCG;;;EAGC,gCE2GQ;AnGkqmCZ;AiGtwmCG;EACC,2CEoGQ;AnGoqmCZ;AiGjwmCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwMI;ENpMR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwMI;ENpMR,qDAAA;EI0GD,iBAAA;AjG+wmCH;AiGrumCC;EACC,2B5FqLgB;E4FnQhB,mCEsIU;EFlIV,gCE8HU;AnGqrmCZ;AiGjzmCE;EACC,gCE2HS;AnGwrmCZ;AiG7ymCG;;;EAGC,gCEmHQ;AnG4rmCZ;AiGxymCG;EACC,2CE4GQ;AnG8rmCZ;AiGnymCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMgNI;EN5MR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMgNI;EN5MR,qDAAA;EI0GD,iBAAA;AjGizmCH;AiG7vmCC;EACC,2B5F2KgB;E4FnQhB,mCE8IU;EF1IV,gCEsIU;AnG+smCZ;AiGn1mCE;EACC,gCEmIS;AnGktmCZ;AiG/0mCG;;;EAGC,gCE2HQ;AnGstmCZ;AiG10mCG;EACC,2CEoHQ;AnGwtmCZ;AiGr0mCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwNI;ENpNR,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2CMwNI;ENpNR,qDAAA;EI0GD,iBAAA;AjGm1mCH;;AiG/xmCC;EACC,2B5F2KgB;E4FnQhB,yCEsJiH;EFlJjH,wBEkJqC;AnGsumCvC;AiGt3mCE;EACC,wBE+IoC;AnGyumCvC;AiGl3mCG;;;EAGC,wBEsIsD;AnG8umC1D;AiG72mCG;EACC,mCE8HyE;AnGivmC7E;AiGx2mCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMiOwF;EN7N5F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMiOwF;EN7N5F,oDAAA;EI0GD,iBAAA;AjGs3mCH;;AiGzzmCC;EACC,2B5FkKgB;E4FnQhB,yCE4JiH;EFxJjH,wBEwJqC;AnGmwmCvC;AiGz5mCE;EACC,wBEqJoC;AnGswmCvC;AiGr5mCG;;;EAGC,wBE4IsD;AnG2wmC1D;AiGh5mCG;EACC,mCEoIyE;AnG8wmC7E;AiG34mCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMuOwF;ENnO5F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMuOwF;ENnO5F,oDAAA;EI0GD,iBAAA;AjGy5mCH;;AiG/3mCC;EAEC,2B5FoMgB;E4FnQhB,yCEkKkH;EF9JlH,wBE8JsC;AnGgymCxC;AiG57mCE;EACC,wBE2JqC;AnGmymCxC;AiGx7mCG;;;;;EAGC,wBEkJuD;AnG0ymC3D;AiGr7mCG;EACC,mCE0I0E;AnG6ymC9E;AiGh7mCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM6OyF;ENzO7F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM6OyF;ENzO7F,oDAAA;EI0GD,iBAAA;AjG87mCH;;AiGp5mCC;EACC,2B5FqLgB;E4FnQhB,yCEwKmH;EFpKnH,wBEoKuC;AnG+zmCzC;AiGj+mCE;EACC,wBEiKsC;AnGk0mCzC;AiG79mCG;;;EAGC,wBEwJwD;AnGu0mC5D;AiGx9mCG;EACC,mCEgJ2E;AnG00mC/E;AiGn9mCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMmP0F;EN/O9F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMmP0F;EN/O9F,oDAAA;EI0GD,iBAAA;AjGi+mCH;;AiG76mCC;EACC,2B5F2KgB;E4FnQhB,yCE8KiH;EF1KjH,wBE0KqC;AnG41mCvC;AiGpgnCE;EACC,wBEuKoC;AnG+1mCvC;AiGhgnCG;;;EAGC,wBE8JsD;AnGo2mC1D;AiG3/mCG;EACC,mCEsJyE;AnGu2mC7E;AiGt/mCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMyPwF;ENrP5F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMyPwF;ENrP5F,oDAAA;EI0GD,iBAAA;AjGognCH;AiGv8mCC;EACC,2B5FkKgB;E4FnQhB,yCE+KiH;EF3KjH,wBE2KqC;AnG63mCvC;AiGtinCE;EACC,wBEwKoC;AnGg4mCvC;AiGlinCG;;;EAGC,wBE+JsD;AnGq4mC1D;AiG7hnCG;EACC,mCEuJyE;AnGw4mC7E;AiGxhnCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM0PwF;ENtP5F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM0PwF;ENtP5F,oDAAA;EI0GD,iBAAA;AjGsinCH;AiG5gnCC;EAEC,2B5FoMgB;E4FnQhB,yCEgLkH;EF5KlH,wBE4KsC;AnG85mCxC;AiGxknCE;EACC,wBEyKqC;AnGi6mCxC;AiGpknCG;;;;;EAGC,wBEgKuD;AnGw6mC3D;AiGjknCG;EACC,mCEwJ0E;AnG26mC9E;AiG5jnCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM2PyF;ENvP7F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM2PyF;ENvP7F,oDAAA;EI0GD,iBAAA;AjG0knCH;AiGhinCC;EACC,2B5FqLgB;E4FnQhB,yCEiLmH;EF7KnH,wBE6KuC;AnGi8mCzC;AiG5mnCE;EACC,wBE0KsC;AnGo8mCzC;AiGxmnCG;;;EAGC,wBEiKwD;AnGy8mC5D;AiGnmnCG;EACC,mCEyJ2E;AnG48mC/E;AiG9lnCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM4P0F;ENxP9F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM4P0F;ENxP9F,oDAAA;EI0GD,iBAAA;AjG4mnCH;;AiGllnCC;EAEC,2B5FoMgB;E4F/PhB,wBEoLsC;AnG49mCxC;AiG9onCE;EACC,wBEiLqC;AnG+9mCxC;AiG1onCG;;;;;EAGC,wBEwKuD;AnGs+mC3D;AiGvonCG;EACC,mCEgK0E;AnGy+mC9E;AiGlonCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMmQyF;EN/P7F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMmQyF;EN/P7F,oDAAA;EI0GD,iBAAA;AjGgpnCH;;AiG5lnCC;EACC,2B5F2KgB;E4F/PhB,wBE0LqC;AnG0/mCvC;AiGlrnCE;EACC,wBEuLoC;AnG6/mCvC;AiG9qnCG;;;EAGC,wBE8KsD;AnGkgnC1D;AiGzqnCG;EACC,mCEsKyE;AnGqgnC7E;AiGpqnCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMyQwF;ENrQ5F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMyQwF;ENrQ5F,oDAAA;EI0GD,iBAAA;AjGkrnCH;;AiGrnnCC;EACC,2B5FkKgB;E4F/PhB,wBEgMqC;AnGshnCvC;AiGptnCE;EACC,wBE6LoC;AnGyhnCvC;AiGhtnCG;;;EAGC,wBEoLsD;AnG8hnC1D;AiG3snCG;EACC,mCE4KyE;AnGiinC7E;AiGtsnCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM+QwF;EN3Q5F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM+QwF;EN3Q5F,oDAAA;EI0GD,iBAAA;AjGotnCH;;AiG1qnCC;EACC,2B5FqLgB;E4F/PhB,wBEsMuC;AnGkjnCzC;AiGtvnCE;EACC,wBEmMsC;AnGqjnCzC;AiGlvnCG;;;EAGC,wBE0LwD;AnG0jnC5D;AiG7unCG;EACC,mCEkL2E;AnG6jnC/E;AiGxunCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMqR0F;ENjR9F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMqR0F;ENjR9F,oDAAA;EI0GD,iBAAA;AjGsvnCH;;AiG5tnCC;EAEC,2B5FoMgB;E4F/PhB,wBE4MsC;AnG8knCxC;AiGxxnCE;EACC,wBEyMqC;AnGilnCxC;AiGpxnCG;;;;;EAGC,wBEgMuD;AnGwlnC3D;AiGjxnCG;EACC,mCEwL0E;AnG2lnC9E;AiG5wnCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM2RyF;ENvR7F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM2RyF;ENvR7F,oDAAA;EI0GD,iBAAA;AjG0xnCH;AiGtunCC;EACC,2B5F2KgB;E4F/PhB,wBE6MqC;AnGgnnCvC;AiG3znCE;EACC,wBE0MoC;AnGmnnCvC;AiGvznCG;;;EAGC,wBEiMsD;AnGwnnC1D;AiGlznCG;EACC,mCEyLyE;AnG2nnC7E;AiG7ynCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM4RwF;ENxR5F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM4RwF;ENxR5F,oDAAA;EI0GD,iBAAA;AjG2znCH;AiG9vnCC;EACC,2B5FkKgB;E4F/PhB,wBE8MqC;AnGgpnCvC;AiG51nCE;EACC,wBE2MoC;AnGmpnCvC;AiGx1nCG;;;EAGC,wBEkMsD;AnGwpnC1D;AiGn1nCG;EACC,mCE0LyE;AnG2pnC7E;AiG90nCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM6RwF;ENzR5F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM6RwF;ENzR5F,oDAAA;EI0GD,iBAAA;AjG41nCH;AiGlznCC;EACC,2B5FqLgB;E4F/PhB,wBE+MuC;AnGgrnCzC;AiG73nCE;EACC,wBE4MsC;AnGmrnCzC;AiGz3nCG;;;EAGC,wBEmMwD;AnGwrnC5D;AiGp3nCG;EACC,mCE2L2E;AnG2rnC/E;AiG/2nCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM8R0F;EN1R9F,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM8R0F;EN1R9F,oDAAA;EI0GD,iBAAA;AjG63nCH;;AiGn2nCC;EAEC,2B5FoMgB;E4F/PhB,qBEqNsC;AnG4snCxC;AiG/5nCE;EACC,qBEkNqC;AnG+snCxC;AiG35nCG;;;;;EAGC,qBEyMoD;AnGstnCxD;AiGx5nCG;EACC,gCEiMoE;AnGytnCxE;AiGn5nCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMoSgF;ENhSpF,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMoSgF;ENhSpF,oDAAA;EI0GD,iBAAA;AjGi6nCH;AiG72nCC;EACC,2B5F2KgB;E4F/PhB,qBEsNqC;AnG8unCvC;AiGl8nCE;EACC,qBEmNoC;AnGivnCvC;AiG97nCG;;;EAGC,qBE0MmD;AnGsvnCvD;AiGz7nCG;EACC,gCEkMmE;AnGyvnCvE;AiGp7nCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMqS+E;ENjSnF,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMqS+E;ENjSnF,oDAAA;EI0GD,iBAAA;AjGk8nCH;AiGr4nCC;EACC,2B5FkKgB;E4F/PhB,qBEuNqC;AnG8wnCvC;AiGn+nCE;EACC,qBEoNoC;AnGixnCvC;AiG/9nCG;;;EAGC,qBE2MmD;AnGsxnCvD;AiG19nCG;EACC,gCEmMmE;AnGyxnCvE;AiGr9nCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMsS+E;ENlSnF,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMsS+E;ENlSnF,oDAAA;EI0GD,iBAAA;AjGm+nCH;AiGz7nCC;EACC,2B5FqLgB;E4F/PhB,qBEwNuC;AnG8ynCzC;AiGpgoCE;EACC,qBEqNsC;AnGiznCzC;AiGhgoCG;;;EAGC,qBE4MqD;AnGsznCzD;AiG3/nCG;EACC,gCEoMqE;AnGyznCzE;AiGt/nCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMuSiF;ENnSrF,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,gCMuSiF;ENnSrF,oDAAA;EI0GD,iBAAA;AjGogoCH;;AiG1+nCC;EAEC,2B5FoMgB;E4F/PhB,wBE+NsC;AnGy0nCxC;AiGtioCE;EACC,wBE4NqC;AnG40nCxC;;AiG/8nCC;EACC,2B5FkKgB;E4F/PhB,wBEqOqC;AnG20nCvC;AiG9ioCE;EACC,wBEkOoC;AnG80nCvC;;AiGh+nCC;EACC,2B5F2KgB;E4F/PhB,wBE2OqC;AnG60nCvC;AiGtjoCE;EACC,wBEwOoC;AnGg1nCvC;;AiGl/nCC;EACC,2B5FqLgB;E4F/PhB,wBEiPuC;AnG+0nCzC;AiG9joCE;EACC,wBE8OsC;AnGk1nCzC;;AiG1goCC;EAEC,2B5FoMgB;E4F/PhB,wBEuPsC;AnGi1nCxC;AiGtkoCE;EACC,wBEoPqC;AnGo1nCxC;AiG/+nCC;EACC,2B5FkKgB;E4F/PhB,wBEwPqC;AnGu1nCvC;AiG7koCE;EACC,wBEqPoC;AnG01nCvC;AiG//nCC;EACC,2B5F2KgB;E4F/PhB,wBEyPqC;AnG61nCvC;AiGploCE;EACC,wBEsPoC;AnGg2nCvC;AiGhhoCC;EACC,2B5FqLgB;E4F/PhB,wBE0PuC;AnGm2nCzC;AiG3loCE;EACC,wBEuPsC;AnGs2nCzC;;AiGvioCC;EAEC,2B5FoMgB;ALq2nClB;AiG3loCG;;;;;EAGC,wBEsP0C;AnGy2nC9C;;AiG/goCC;EACC,2B5FkKgB;ALg3nClB;AiGtmoCG;;;EAGC,wBE6PyC;AnG22nC7C;;AiGjioCC;EACC,2B5F2KgB;ALy3nClB;AiG/moCG;;;EAGC,wBEoQyC;AnG62nC7C;;AiGpjoCC;EACC,2B5FqLgB;ALk4nClB;AiGxnoCG;;;EAGC,wBE2Q2C;AnG+2nC/C;;AiG7koCC;EAEC,2B5FoMgB;AL24nClB;AiGjooCG;;;;;EAGC,wBEkR0C;AnGm3nC9C;AiGrjoCC;EACC,2B5FkKgB;ALq5nClB;AiG3ooCG;;;EAGC,wBEmRyC;AnG03nC7C;AiGtkoCC;EACC,2B5F2KgB;AL65nClB;AiGnpoCG;;;EAGC,wBEoRyC;AnGi4nC7C;AiGxloCC;EACC,2B5FqLgB;ALq6nClB;AiG3poCG;;;EAGC,wBEqR2C;AnGw4nC/C;;AiGhnoCC;EAEC,2B5FoMgB;AL86nClB;AiG1poCG;EACC,mCEqRgD;AnGu4nCpD;;AiG7loCC;EACC,2B5F2KgB;ALq7nClB;AiGjqoCG;EACC,mCE4R+C;AnGu4nCnD;;AiG3loCC;EACC,2B5FkKgB;AL47nClB;AiGxqoCG;EACC,mCEmS+C;AnGu4nCnD;;AiGrnoCC;EACC,2B5FqLgB;ALm8nClB;AiG/qoCG;EACC,mCE0SiD;AnGu4nCrD;;AiG5ooCC;EAEC,2B5FoMgB;AL08nClB;AiGtroCG;EACC,mCEiTgD;AnGu4nCpD;AiGhnoCC;EACC,2B5FkKgB;ALg9nClB;AiG5roCG;EACC,mCEkT+C;AnG44nCnD;AiG/noCC;EACC,2B5F2KgB;ALs9nClB;AiGlsoCG;EACC,mCEmT+C;AnGi5nCnD;AiG/ooCC;EACC,2B5FqLgB;AL49nClB;AiGxsoCG;EACC,mCEoTiD;AnGs5nCrD;;AiGrqoCC;EAEC,2B5FoMgB;ALm+nClB;AiGvsoCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM+ZkD;EN3ZtD,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM+ZkD;EN3ZtD,oDAAA;EI0GD,iBAAA;AjGqtoCH;;AiGxpoCC;EACC,2B5FkKgB;ALy/nClB;AiG7toCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMsaiD;ENlarD,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMsaiD;ENlarD,oDAAA;EI0GD,iBAAA;AjG2uoCH;;AiGvroCC;EACC,2B5F2KgB;AL+goClB;AiGnvoCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM6aiD;ENzarD,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM6aiD;ENzarD,oDAAA;EI0GD,iBAAA;AjGiwoCH;;AiGvtoCC;EACC,2B5FqLgB;ALqioClB;AiGzwoCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMobmD;ENhbvD,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCMobmD;ENhbvD,oDAAA;EI0GD,iBAAA;AjGuxoCH;;AiG7voCC;EAEC,2B5FoMgB;AL2joClB;AiG/xoCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM2bkD;ENvbtD,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM2bkD;ENvbtD,oDAAA;EI0GD,iBAAA;AjG6yoCH;AiGhvoCC;EACC,2B5FkKgB;ALgloClB;AiGpzoCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM4biD;ENxbrD,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM4biD;ENxbrD,oDAAA;EI0GD,iBAAA;AjGk0oCH;AiG9woCC;EACC,2B5F2KgB;ALqmoClB;AiGz0oCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM6biD;ENzbrD,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM6biD;ENzbrD,oDAAA;EI0GD,iBAAA;AjGu1oCH;AiG7yoCC;EACC,2B5FqLgB;AL0noClB;AiG91oCE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM8bmD;EN1bvD,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCM8bmD;EN1bvD,oDAAA;EI0GD,iBAAA;AjG42oCH;;AoGnhpCA;EACI,aAAA;EACA,mBAAA;ApGshpCJ;AoGphpCI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gChGmfsB;AJmioC9B;AoGphpCQ;EACI,YAAA;ApGshpCZ;AoGjhpCQ;EACI,aAAA;ApGmhpCZ;AoGjhpCY;EACI,wBAAA;EACA,gChGsec;AJ6ioC9B;;AqG9ipCA;EAIQ,SAAA;EAGJ,qCAAA;EACA,mCAAA;ArG4ipCJ;AqGzipCI;EACI,aAAA;EACA,8BAAA;EACA,oBAAA;EACA,eAAA;EACA,gBhGi8BqB;EgGh8BrB,kBAAA;EACA,+BAAA;EACA,uCAAA;EACA,oDAAA;ArG2ipCR;AqGxipCQ;EACI,aAAA;EACA,mBAAA;EACA,chGs7B4B;EgGr7B5B,cAAA;ArG0ipCZ;AqGxipCY;EACI,uBAAA;EACA,uBAAA;ArG0ipChB;AqGvipCY;EACI,qBAAA;EACA,cAAA;ArGyipChB;AqGvipCgB;EACI,kBAAA;EACA,yBAAA;EACA,cAAA;ArGyipCpB;AqGvipCoB;EAEI,cAAA;ArGwipCxB;AqGpipCgB;EACI,yBAAA;ArGsipCpB;AsGvlpCI;EACI,YAAA;EACA,WAAA;AtGylpCR;AqGripCY;;EAEI,gBAAA;EACA,mBAAA;EACA,0BAAA;ArGuipChB;AqGpipCY;EACI,qBAAA;EACA,eAAA;ArGsipChB;AqGlipCY;EACI,2BAAA;EACA,eAAA;ArGoipChB;AqGhipCY;EACI,gBAAA;ArGkipChB;AqG7hpCQ;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;ArG+hpCZ;AqG1hpCI;EACI,qBAAA;EACA,2BAAA;ArG4hpCR;AqGxhpCI;EACI,qBAAA;EACA,+BAAA;EACA,uCAAA;EACA,iDAAA;ArG0hpCR;AqGthpCI;EACI,kBAAA;EACA,cAAA;ArGwhpCR;AqGnhpCQ;;;EAGI,eAAA;EACA,gBAAA;ArGqhpCZ;AqGhhpCQ;;;EAGI,cAAA;EACA,iBAAA;ArGkhpCZ;AqG7gpCQ;;;EAGI,UAAA;ArG+gpCZ;AqG1gpCI;EACI,gBAAA;EACA,qDAAA;ArG4gpCR;AqG1gpCQ;EACI,4DAAA;ArG4gpCZ;AqGzgpCQ;EACI,yDAAA;ArG2gpCZ;AqGtgpCI;EACI,gBAAA;EACA,6CAAA;ArGwgpCR;AqGngpCQ;EACI,2BAAA;ArGqgpCZ;AqGlgpCQ;EACI,wBAAA;ArGogpCZ;AqG//oCI;EACI,qCAAA;EACA,SAAA;ArGigpCR;AqG7/oCI;EACI,oBAAA;EACA,2BAAA;EACA,wCAAA;ArG+/oCR;AqG7/oCQ;EACI,2BAAA;ArG+/oCZ;AqG5/oCQ;EACI,wBAAA;ArG8/oCZ;;AqGl/oCY;EACI,uCAAA;ArGq/oChB;AqGj/oCY;EACI,sCAAA;ArGm/oChB;AqG/+oCY;EACI,sCAAA;ArGi/oChB;AqG7+oCY;EACI,0CAAA;ArG++oChB;AqG3+oCY;EACI,sCAAA;ArG6+oChB;AqGz+oCY;EACI,yBAAA;EACA,4BAAA;EACA,oBAAA;ArG2+oChB;AqGz+oCgB;EACI,SAAA;EACA,oBAAA;ArG2+oCpB;AepppCI;EsFyIQ;IACI,uCAAA;ErG8gpCd;EqG1gpCU;IACI,sCAAA;ErG4gpCd;EqGxgpCU;IACI,sCAAA;ErG0gpCd;EqGtgpCU;IACI,0CAAA;ErGwgpCd;EqGpgpCU;IACI,sCAAA;ErGsgpCd;EqGlgpCU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;ErGogpCd;EqGlgpCc;IACI,SAAA;IACA,oBAAA;ErGogpClB;AACF;Ae9qpCI;EsFyIQ;IACI,uCAAA;ErGwipCd;EqGpipCU;IACI,sCAAA;ErGsipCd;EqGlipCU;IACI,sCAAA;ErGoipCd;EqGhipCU;IACI,0CAAA;ErGkipCd;EqG9hpCU;IACI,sCAAA;ErGgipCd;EqG5hpCU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;ErG8hpCd;EqG5hpCc;IACI,SAAA;IACA,oBAAA;ErG8hpClB;AACF;AexspCI;EsFyIQ;IACI,uCAAA;ErGkkpCd;EqG9jpCU;IACI,sCAAA;ErGgkpCd;EqG5jpCU;IACI,sCAAA;ErG8jpCd;EqG1jpCU;IACI,0CAAA;ErG4jpCd;EqGxjpCU;IACI,sCAAA;ErG0jpCd;EqGtjpCU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;ErGwjpCd;EqGtjpCc;IACI,SAAA;IACA,oBAAA;ErGwjpClB;AACF;AelupCI;EsFyIQ;IACI,uCAAA;ErG4lpCd;EqGxlpCU;IACI,sCAAA;ErG0lpCd;EqGtlpCU;IACI,sCAAA;ErGwlpCd;EqGplpCU;IACI,0CAAA;ErGslpCd;EqGllpCU;IACI,sCAAA;ErGolpCd;EqGhlpCU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;ErGklpCd;EqGhlpCc;IACI,SAAA;IACA,oBAAA;ErGklpClB;AACF;Ae5vpCI;EsFyIQ;IACI,uCAAA;ErGsnpCd;EqGlnpCU;IACI,sCAAA;ErGonpCd;EqGhnpCU;IACI,sCAAA;ErGknpCd;EqG9mpCU;IACI,0CAAA;ErGgnpCd;EqG5mpCU;IACI,sCAAA;ErG8mpCd;EqG1mpCU;IACI,yBAAA;IACA,4BAAA;IACA,oBAAA;ErG4mpCd;EqG1mpCc;IACI,SAAA;IACA,oBAAA;ErG4mpClB;AACF;;AqGrmpCA;EACI,gCAAA;ArGwmpCJ;;AqGrmpCA;EACI,gCAAA;EACA,iCAAA;ArGwmpCJ;;AqGrmpCA;EACI,qCAAA;ArGwmpCJ;;AqGrmpCA;EACI,4BAAA;EACA,+BAAA;ArGwmpCJ;;AqGrmpCA;EACI,uBhGgH4B;ALw/oChC;;AqGrmpCA;EACI,gChG4G4B;EgG3G5B,mChG2G4B;AL6/oChC;;AqGrmpCA;EACI,iChGuG4B;EgGtG5B,oChGsG4B;ALkgpChC;;AqGrmpCA;EACI,gChGkG4B;EgGjG5B,iChGiG4B;ALugpChC;;AqGrmpCA;EACI,mChG6F4B;EgG5F5B,oChG4F4B;AL4gpChC;;AenzpCI;EsFiNI;IACI,mBhGurB4B;IgGtrB5B,sBhGsrB4B;ELg7nCtC;AACF;AuGj4pCA;EACI,2CAAA;EACA,iEAAA;EACA,yEAAA;EAEA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;AvGk4pCJ;AuG/3pCI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,qBlG0pCgC;ALuunCxC;AuG/3pCQ;EACI,gBAAA;AvGi4pCZ;AuG93pCQ;EACI,YAAA;AvGg4pCZ;AuG53pCQ;EACI,aAAA;AvG83pCZ;AuG13pCY;EACI,aAAA;AvG43pChB;;AuGn3pCQ;EACI,YAAA;AvGs3pCZ;;AuG92pCQ;EACI,YAAA;AvGi3pCZ;;AuGz2pCQ;EACI,aAAA;AvG42pCZ;;AwGz6pCA;EACC,oCAAA;EACA,wBAAA;EACA,kCAAA;EAGA,wBAAA;AxG06pCD;AwGv6pCC;EACC,2BAAA;AxGy6pCF;AwGr6pCC;EACC,SAAA;EACA,gDAAA;AxGu6pCF;AwGr6pCE;EACC,iDAAA;AxGu6pCH;AwGp6pCE;EACC,gDAAA;AxGs6pCH;AwGj6pCC;EACC,SAAA;EACA,gBAAA;EACA,0BAAA;EACA,2BAAA;EACA,qBAAA;EACA,gBnGgZqB;ALmhpCvB;AwG/5pCC;EACC,8CAAA;AxGi6pCF;AwG75pCC;EACC,+CAAA;AxG+5pCF;AwG35pCC;EChDG,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,6BAAA;EACA,wBAAA;EACA,SAAA;EACA,UAAA;AzG88pCJ;AwGj6pCC;EACC,oBAAA;EACA,mBAAA;AxGm6pCF;AwG/5pCC;EACC,sCAAA;EACA,0BAAA;AxGi6pCF;AwG75pCC;EACC,oCAAA;EACA,2BAAA;AxG+5pCF;;AwGx5pCC;EACC,oBAAA;EACA,enG+Ve;EmG9Vf,sBAAA;EACA,sBAAA;EACA,cAAA;AxG25pCF;AwGv5pCC;EACC,cAAA;EACA,cAAA;EACA,oBAAA;AxGy5pCF;AwGr5pCC;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,mCpGmvBsC;EoGlvBtC,kCpGkvBsC;AJqqoCxC;AwGp5pCE;EACC,SAAA;AxGs5pCH;AwGl5pCE;EACC,kCpG0uBqC;EoGzuBrC,iCpGyuBqC;AJ2qoCxC;AwGh5pCE;EACC,mCpGquBqC;EoGpuBrC,kCpGouBqC;AJ8qoCxC;AwG/4pCE;EACC,kBAAA;AxGi5pCH;AwG94pCE;;EAEC,UAAA;EACA,SAAA;EACA,cAAA;AxGg5pCH;;A0G3gqCA;EACC,iBAAA;EACA,oBAAA;A1G8gqCD;A2G9+pCI;EAwBQ,+BD/CW;A1GwgqCvB;;A0G//pCC;ECRO,8BDSE;ECMF,6BDJS;ECQT,iCDPK;A1GigqCb;A2GzgqCQ;;EAEF,8BDIS;A1GugqCf;A2GxgqCQ;EACI,8BAAA;A3G0gqCZ;A2G9/pCI;EASQ,8BDjBK;ECgCL,oCD9BY;ECkCZ,mDAAA;A3Gu+pCZ;A2Gt/pCY;;;;;;;;;EAEF,8BDtBY;A1GqhqCtB;A2G5/pCY;EACI,8BD1BM;A1GwhqCtB;;A0G//pCC;ECzBO,6BD4BS;ECxBT,iCDyBK;A1GggqCb;A2GthqCI;EASQ,8BD8BK;ECfL,6BDiBY;ECbZ,4CAAA;A3G+/pCZ;A2G9gqCY;;;;;;;;;EAEF,8BDyBY;A1G8/pCtB;A2GphqCY;EACI,8BDqBM;A1GigqCtB;;A0Gx+pCC;ECvFO,sBDwFE;ECzEF,6BD2ES;ECvET,6BDwEK;A1G0+pCb;A2GjkqCQ;;EAEF,sBDmFS;A1Gg/pCf;A2GhkqCQ;EACI,sBD+EG;A1Gm/pCf;A2GtjqCI;EASQ,6BD8DK;EC/CL,6BDiDY;EC7CZ,kDAAA;A3G+hqCZ;A2G9iqCY;;;;;;;;;EAEF,6BDyDY;A1G8/pCtB;A2GpjqCY;EACI,6BDqDM;A1GigqCtB;;A0GvlqCC;ECRO,8BDSE;ECMF,6BDJS;ECQT,iCDPK;A1GylqCb;A2GjmqCQ;;EAEF,8BDIS;A1G+lqCf;A2GhmqCQ;EACI,8BAAA;A3GkmqCZ;A2GtlqCI;EASQ,8BDjBK;ECgCL,oCD9BY;ECkCZ,mDAAA;A3G+jqCZ;A2G9kqCY;;;;;;;;;EAEF,8BDtBY;A1G6mqCtB;A2GplqCY;EACI,8BD1BM;A1GgnqCtB;;A0GvlqCC;ECzBO,6BD4BS;ECxBT,iCDyBK;A1GwlqCb;A2G9mqCI;EASQ,8BD8BK;ECfL,6BDiBY;ECbZ,4CAAA;A3GulqCZ;A2GtmqCY;;;;;;;;;EAEF,8BDyBY;A1GslqCtB;A2G5mqCY;EACI,8BDqBM;A1GylqCtB;;A0GhkqCC;ECvFO,sBDwFE;ECzEF,6BD2ES;ECvET,6BDwEK;A1GkkqCb;A2GzpqCQ;;EAEF,sBDmFS;A1GwkqCf;A2GxpqCQ;EACI,sBD+EG;A1G2kqCf;A2G9oqCI;EASQ,6BD8DK;EC/CL,6BDiDY;EC7CZ,kDAAA;A3GunqCZ;A2GtoqCY;;;;;;;;;EAEF,6BDyDY;A1GslqCtB;A2G5oqCY;EACI,6BDqDM;A1GylqCtB;;A0G/qqCC;ECRO,gCDSE;ECMF,+BDJS;ECQT,mCDPK;A1GirqCb;A2GzrqCQ;;EAEF,gCDIS;A1GurqCf;A2GxrqCQ;EACI,gCAAA;A3G0rqCZ;A2G9qqCI;EASQ,gCDjBK;ECgCL,sCD9BY;ECkCZ,qDAAA;A3GupqCZ;A2GtqqCY;;;;;;;;;EAEF,gCDtBY;A1GqsqCtB;A2G5qqCY;EACI,gCD1BM;A1GwsqCtB;;A0G/rqCE;ECxBM,wBDyBG;ECVH,qCDYU;ECRV,yCDSM;A1GisqCd;A2GztqCQ;;EAEF,wBDoBU;A1GusqChB;A2GxtqCQ;EACI,wBDgBI;A1G0sqChB;A2G9sqCI;EASQ,gCDDM;ECgBN,+BDda;ECkBb,8CAAA;A3GurqCZ;A2GtsqCY;;;;;;;;;EAEF,gCDNa;A1GqtqCvB;A2G5sqCY;EACI,gCDVO;A1GwtqCvB;;A0G/sqCC;ECzBO,+BD4BS;ECxBT,mCDyBK;A1GgtqCb;A2GtuqCI;EASQ,gCD8BK;ECfL,+BDiBY;ECbZ,8CAAA;A3G+sqCZ;A2G9tqCY;;;;;;;;;EAEF,gCDyBY;A1G8sqCtB;A2GpuqCY;EACI,gCDqBM;A1GitqCtB;;A2GzvqCI;EASQ,wBD8CM;EC/BN,qCDiCa;EC7Bb,oDAAA;A3GmuqCZ;A2GlvqCY;;;;;;;;;EAEF,wBDyCa;A1GktqCvB;A2GxvqCY;EACI,wBDqCO;A1GqtqCvB;;A0G5sqCC;ECvFO,wBDwFE;ECzEF,+BD2ES;ECvET,6BDwEK;A1G8sqCb;A2GryqCQ;;EAEF,wBDmFS;A1GotqCf;A2GpyqCQ;EACI,wBD+EG;A1GutqCf;A2G1xqCI;EASQ,+BD8DK;EC/CL,+BDiDY;EC7CZ,oDAAA;A3GmwqCZ;A2GlxqCY;;;;;;;;;EAEF,+BDyDY;A1GkuqCtB;A2GxxqCY;EACI,+BDqDM;A1GquqCtB;;A0G3zqCC;ECRO,kCDSE;ECMF,iCDJS;ECQT,qCDPK;A1G6zqCb;A2Gr0qCQ;;EAEF,kCDIS;A1Gm0qCf;A2Gp0qCQ;EACI,kCAAA;A3Gs0qCZ;A2G1zqCI;EASQ,kCDjBK;ECgCL,wCD9BY;ECkCZ,uDAAA;A3GmyqCZ;A2GlzqCY;;;;;;;;;EAEF,kCDtBY;A1Gi1qCtB;A2GxzqCY;EACI,kCD1BM;A1Go1qCtB;;A0G30qCE;ECxBM,0BDyBG;ECVH,uCDYU;ECRV,2CDSM;A1G60qCd;A2Gr2qCQ;;EAEF,0BDoBU;A1Gm1qChB;A2Gp2qCQ;EACI,0BDgBI;A1Gs1qChB;A2G11qCI;EASQ,kCDDM;ECgBN,iCDda;ECkBb,gDAAA;A3Gm0qCZ;A2Gl1qCY;;;;;;;;;EAEF,kCDNa;A1Gi2qCvB;A2Gx1qCY;EACI,kCDVO;A1Go2qCvB;;A0G31qCC;ECzBO,iCD4BS;ECxBT,qCDyBK;A1G41qCb;A2Gl3qCI;EASQ,kCD8BK;ECfL,iCDiBY;ECbZ,gDAAA;A3G21qCZ;A2G12qCY;;;;;;;;;EAEF,kCDyBY;A1G01qCtB;A2Gh3qCY;EACI,kCDqBM;A1G61qCtB;;A2Gr4qCI;EASQ,0BD8CM;EC/BN,uCDiCa;EC7Bb,sDAAA;A3G+2qCZ;A2G93qCY;;;;;;;;;EAEF,0BDyCa;A1G81qCvB;A2Gp4qCY;EACI,0BDqCO;A1Gi2qCvB;;A0Gx1qCC;ECvFO,0BDwFE;ECzEF,iCD2ES;ECvET,6BDwEK;A1G01qCb;A2Gj7qCQ;;EAEF,0BDmFS;A1Gg2qCf;A2Gh7qCQ;EACI,0BD+EG;A1Gm2qCf;A2Gt6qCI;EASQ,iCD8DK;EC/CL,iCDiDY;EC7CZ,sDAAA;A3G+4qCZ;A2G95qCY;;;;;;;;;EAEF,iCDyDY;A1G82qCtB;A2Gp6qCY;EACI,iCDqDM;A1Gi3qCtB;;A0Gv8qCC;ECRO,gCDSE;ECMF,+BDJS;ECQT,mCDPK;A1Gy8qCb;A2Gj9qCQ;;EAEF,gCDIS;A1G+8qCf;A2Gh9qCQ;EACI,gCAAA;A3Gk9qCZ;A2Gt8qCI;EASQ,gCDjBK;ECgCL,sCD9BY;ECkCZ,qDAAA;A3G+6qCZ;A2G97qCY;;;;;;;;;EAEF,gCDtBY;A1G69qCtB;A2Gp8qCY;EACI,gCD1BM;A1Gg+qCtB;;A0Gv9qCE;ECxBM,wBDyBG;ECVH,qCDYU;ECRV,yCDSM;A1Gy9qCd;A2Gj/qCQ;;EAEF,wBDoBU;A1G+9qChB;A2Gh/qCQ;EACI,wBDgBI;A1Gk+qChB;A2Gt+qCI;EASQ,gCDDM;ECgBN,+BDda;ECkBb,8CAAA;A3G+8qCZ;A2G99qCY;;;;;;;;;EAEF,gCDNa;A1G6+qCvB;A2Gp+qCY;EACI,gCDVO;A1Gg/qCvB;;A0Gv+qCC;ECzBO,+BD4BS;ECxBT,mCDyBK;A1Gw+qCb;A2G9/qCI;EASQ,gCD8BK;ECfL,+BDiBY;ECbZ,8CAAA;A3Gu+qCZ;A2Gt/qCY;;;;;;;;;EAEF,gCDyBY;A1Gs+qCtB;A2G5/qCY;EACI,gCDqBM;A1Gy+qCtB;;A2GjhrCI;EASQ,wBD8CM;EC/BN,qCDiCa;EC7Bb,oDAAA;A3G2/qCZ;A2G1grCY;;;;;;;;;EAEF,wBDyCa;A1G0+qCvB;A2GhhrCY;EACI,wBDqCO;A1G6+qCvB;;A0Gp+qCC;ECvFO,wBDwFE;ECzEF,+BD2ES;ECvET,6BDwEK;A1Gs+qCb;A2G7jrCQ;;EAEF,wBDmFS;A1G4+qCf;A2G5jrCQ;EACI,wBD+EG;A1G++qCf;A2GljrCI;EASQ,+BD8DK;EC/CL,+BDiDY;EC7CZ,oDAAA;A3G2hrCZ;A2G1irCY;;;;;;;;;EAEF,+BDyDY;A1G0/qCtB;A2GhjrCY;EACI,+BDqDM;A1G6/qCtB;;A0GnlrCC;ECRO,6BDSE;ECMF,4BDJS;ECQT,gCDPK;A1GqlrCb;A2G7lrCQ;;EAEF,6BDIS;A1G2lrCf;A2G5lrCQ;EACI,6BAAA;A3G8lrCZ;A2GllrCI;EASQ,6BDjBK;ECgCL,mCD9BY;ECkCZ,kDAAA;A3G2jrCZ;A2G1krCY;;;;;;;;;EAEF,6BDtBY;A1GymrCtB;A2GhlrCY;EACI,6BD1BM;A1G4mrCtB;;A0GnmrCE;ECxBM,qBDyBG;ECVH,kCDYU;ECRV,sCDSM;A1GqmrCd;A2G7nrCQ;;EAEF,qBDoBU;A1G2mrChB;A2G5nrCQ;EACI,qBDgBI;A1G8mrChB;A2GlnrCI;EASQ,6BDDM;ECgBN,4BDda;ECkBb,2CAAA;A3G2lrCZ;A2G1mrCY;;;;;;;;;EAEF,6BDNa;A1GynrCvB;A2GhnrCY;EACI,6BDVO;A1G4nrCvB;;A0GnnrCC;ECzBO,4BD4BS;ECxBT,gCDyBK;A1GonrCb;A2G1orCI;EASQ,6BD8BK;ECfL,4BDiBY;ECbZ,2CAAA;A3GmnrCZ;A2GlorCY;;;;;;;;;EAEF,6BDyBY;A1GknrCtB;A2GxorCY;EACI,6BDqBM;A1GqnrCtB;;A2G7prCI;EASQ,qBD8CM;EC/BN,kCDiCa;EC7Bb,iDAAA;A3GuorCZ;A2GtprCY;;;;;;;;;EAEF,qBDyCa;A1GsnrCvB;A2G5prCY;EACI,qBDqCO;A1GynrCvB;;A0GhnrCC;ECvFO,qBDwFE;ECzEF,4BD2ES;ECvET,6BDwEK;A1GknrCb;A2GzsrCQ;;EAEF,qBDmFS;A1GwnrCf;A2GxsrCQ;EACI,qBD+EG;A1G2nrCf;A2G9rrCI;EASQ,4BD8DK;EC/CL,4BDiDY;EC7CZ,iDAAA;A3GuqrCZ;A2GtrrCY;;;;;;;;;EAEF,4BDyDY;A1GsorCtB;A2G5rrCY;EACI,4BDqDM;A1GyorCtB;;A0G/trCC;ECRO,gCDSE;ECMF,+BDJS;ECQT,mCDPK;A1GiurCb;A2GzurCQ;;EAEF,gCDIS;A1GuurCf;A2GxurCQ;EACI,gCAAA;A3G0urCZ;A2G9trCI;EASQ,gCDjBK;ECgCL,sCD9BY;ECkCZ,qDAAA;A3GusrCZ;A2GttrCY;;;;;;;;;EAEF,gCDtBY;A1GqvrCtB;A2G5trCY;EACI,gCD1BM;A1GwvrCtB;;A0G/urCE;ECxBM,wBDyBG;ECVH,qCDYU;ECRV,yCDSM;A1GivrCd;A2GzwrCQ;;EAEF,wBDoBU;A1GuvrChB;A2GxwrCQ;EACI,wBDgBI;A1G0vrChB;A2G9vrCI;EASQ,gCDDM;ECgBN,+BDda;ECkBb,8CAAA;A3GuurCZ;A2GtvrCY;;;;;;;;;EAEF,gCDNa;A1GqwrCvB;A2G5vrCY;EACI,gCDVO;A1GwwrCvB;;A0G/vrCC;ECzBO,+BD4BS;ECxBT,mCDyBK;A1GgwrCb;A2GtxrCI;EASQ,gCD8BK;ECfL,+BDiBY;ECbZ,8CAAA;A3G+vrCZ;A2G9wrCY;;;;;;;;;EAEF,gCDyBY;A1G8vrCtB;A2GpxrCY;EACI,gCDqBM;A1GiwrCtB;;A2GzyrCI;EASQ,wBD8CM;EC/BN,qCDiCa;EC7Bb,oDAAA;A3GmxrCZ;A2GlyrCY;;;;;;;;;EAEF,wBDyCa;A1GkwrCvB;A2GxyrCY;EACI,wBDqCO;A1GqwrCvB;;A0G5vrCC;ECvFO,wBDwFE;ECzEF,+BD2ES;ECvET,6BDwEK;A1G8vrCb;A2Gr1rCQ;;EAEF,wBDmFS;A1GowrCf;A2Gp1rCQ;EACI,wBD+EG;A1GuwrCf;A2G10rCI;EASQ,+BD8DK;EC/CL,+BDiDY;EC7CZ,oDAAA;A3GmzrCZ;A2Gl0rCY;;;;;;;;;EAEF,+BDyDY;A1GkxrCtB;A2Gx0rCY;EACI,+BDqDM;A1GqxrCtB;;A0G32rCC;ECRO,+BDSE;ECMF,8BDJS;ECQT,kCDPK;A1G62rCb;A2Gr3rCQ;;EAEF,+BDIS;A1Gm3rCf;A2Gp3rCQ;EACI,+BAAA;A3Gs3rCZ;A2G12rCI;EASQ,+BDjBK;ECgCL,qCD9BY;ECkCZ,oDAAA;A3Gm1rCZ;A2Gl2rCY;;;;;;;;;EAEF,+BDtBY;A1Gi4rCtB;A2Gx2rCY;EACI,+BD1BM;A1Go4rCtB;;A0G33rCE;ECxBM,uBDyBG;ECVH,oCDYU;ECRV,wCDSM;A1G63rCd;A2Gr5rCQ;;EAEF,uBDoBU;A1Gm4rChB;A2Gp5rCQ;EACI,uBDgBI;A1Gs4rChB;A2G14rCI;EASQ,+BDDM;ECgBN,8BDda;ECkBb,6CAAA;A3Gm3rCZ;A2Gl4rCY;;;;;;;;;EAEF,+BDNa;A1Gi5rCvB;A2Gx4rCY;EACI,+BDVO;A1Go5rCvB;;A0G34rCC;ECzBO,8BD4BS;ECxBT,kCDyBK;A1G44rCb;A2Gl6rCI;EASQ,+BD8BK;ECfL,8BDiBY;ECbZ,6CAAA;A3G24rCZ;A2G15rCY;;;;;;;;;EAEF,+BDyBY;A1G04rCtB;A2Gh6rCY;EACI,+BDqBM;A1G64rCtB;;A2Gr7rCI;EASQ,uBD8CM;EC/BN,oCDiCa;EC7Bb,mDAAA;A3G+5rCZ;A2G96rCY;;;;;;;;;EAEF,uBDyCa;A1G84rCvB;A2Gp7rCY;EACI,uBDqCO;A1Gi5rCvB;;A0Gx4rCC;ECvFO,uBDwFE;ECzEF,8BD2ES;ECvET,6BDwEK;A1G04rCb;A2Gj+rCQ;;EAEF,uBDmFS;A1Gg5rCf;A2Gh+rCQ;EACI,uBD+EG;A1Gm5rCf;A2Gt9rCI;EASQ,8BD8DK;EC/CL,8BDiDY;EC7CZ,mDAAA;A3G+7rCZ;A2G98rCY;;;;;;;;;EAEF,8BDyDY;A1G85rCtB;A2Gp9rCY;EACI,8BDqDM;A1Gi6rCtB;;A0Gv/rCC;ECRO,6BDSE;ECMF,4BDJS;ECQT,gCDPK;A1Gy/rCb;A2GjgsCQ;;EAEF,6BDIS;A1G+/rCf;A2GhgsCQ;EACI,6BAAA;A3GkgsCZ;A2Gt/rCI;EASQ,6BDjBK;ECgCL,mCD9BY;ECkCZ,kDAAA;A3G+9rCZ;A2G9+rCY;;;;;;;;;EAEF,6BDtBY;A1G6gsCtB;A2Gp/rCY;EACI,6BD1BM;A1GghsCtB;;A0GvgsCE;ECxBM,qBDyBG;ECVH,kCDYU;ECRV,sCDSM;A1GygsCd;A2GjisCQ;;EAEF,qBDoBU;A1G+gsChB;A2GhisCQ;EACI,qBDgBI;A1GkhsChB;A2GthsCI;EASQ,6BDDM;ECgBN,4BDda;ECkBb,2CAAA;A3G+/rCZ;A2G9gsCY;;;;;;;;;EAEF,6BDNa;A1G6hsCvB;A2GphsCY;EACI,6BDVO;A1GgisCvB;;A0GvhsCC;ECzBO,4BD4BS;ECxBT,gCDyBK;A1GwhsCb;A2G9isCI;EASQ,6BD8BK;ECfL,4BDiBY;ECbZ,2CAAA;A3GuhsCZ;A2GtisCY;;;;;;;;;EAEF,6BDyBY;A1GshsCtB;A2G5isCY;EACI,6BDqBM;A1GyhsCtB;;A2GjksCI;EASQ,qBD8CM;EC/BN,kCDiCa;EC7Bb,iDAAA;A3G2isCZ;A2G1jsCY;;;;;;;;;EAEF,qBDyCa;A1G0hsCvB;A2GhksCY;EACI,qBDqCO;A1G6hsCvB;;A0GphsCC;ECvFO,qBDwFE;ECzEF,4BD2ES;ECvET,6BDwEK;A1GshsCb;A2G7msCQ;;EAEF,qBDmFS;A1G4hsCf;A2G5msCQ;EACI,qBD+EG;A1G+hsCf;A2GlmsCI;EASQ,4BD8DK;EC/CL,4BDiDY;EC7CZ,iDAAA;A3G2ksCZ;A2G1lsCY;;;;;;;;;EAEF,4BDyDY;A1G0isCtB;A2GhmsCY;EACI,4BDqDM;A1G6isCtB;;A0GlisCC;ECzGO,2BD0GE;A1GqisCV;A2G3osCQ;;EAEF,2BDqGS;A1GwisCf;A2G1osCQ;EACI,2BDiGG;A1G2isCf;A2GhosCI;EASQ,2BD+FK;A1G2hsCjB;A2GtnsCY;;;;;;;;;EAEF,2BD0FY;A1GqisCtB;A2G5nsCY;EACI,2BDsFM;A1GwisCtB;;A2GnqsCQ;;EAEF,2BDmIS;A1GmisCf;A2GnqsCQ;EACI,2BD+HG;A1GsisCf;A2G5osCY;;;;;;;;;EAEF,2BDwHY;A1G6hsCtB;A2GlpsCY;EACI,2BDoHM;A1GgisCtB;;A0GxhsCC;ECrKO,2BDsKE;A1G2hsCV;A2G3qsCI;EASQ,2BD2JK;A1G0gsCjB;;A0G3lsCC;ECzGO,6BD0GE;A1G8lsCV;A2GpssCQ;;EAEF,6BDqGS;A1GimsCf;A2GnssCQ;EACI,6BDiGG;A1GomsCf;A2GzrsCI;EASQ,6BD+FK;A1GolsCjB;A2G/qsCY;;;;;;;;;EAEF,6BD0FY;A1G8lsCtB;A2GrrsCY;EACI,6BDsFM;A1GimsCtB;;A2G5tsCQ;;EAEF,6BDmIS;A1G4lsCf;A2G5tsCQ;EACI,6BD+HG;A1G+lsCf;A2GrssCY;;;;;;;;;EAEF,6BDwHY;A1GslsCtB;A2G3ssCY;EACI,6BDoHM;A1GylsCtB;;A0GjlsCC;ECrKO,6BDsKE;A1GolsCV;A2GpusCI;EASQ,6BD2JK;A1GmksCjB;;A0GppsCC;ECzGO,+BD0GE;A1GupsCV;A2G7vsCQ;;EAEF,+BDqGS;A1G0psCf;A2G5vsCQ;EACI,+BDiGG;A1G6psCf;A2GlvsCI;EASQ,+BD+FK;A1G6osCjB;A2GxusCY;;;;;;;;;EAEF,+BD0FY;A1GupsCtB;A2G9usCY;EACI,+BDsFM;A1G0psCtB;;A2GrxsCQ;;EAEF,+BDmIS;A1GqpsCf;A2GrxsCQ;EACI,+BD+HG;A1GwpsCf;A2G9vsCY;;;;;;;;;EAEF,+BDwHY;A1G+osCtB;A2GpwsCY;EACI,+BDoHM;A1GkpsCtB;;A0G1osCC;ECrKO,+BDsKE;A1G6osCV;A2G7xsCI;EASQ,+BD2JK;A1G4nsCjB;;A0G7ssCC;ECzGO,2BD0GE;A1GgtsCV;A2GtzsCQ;;EAEF,2BDqGS;A1GmtsCf;A2GrzsCQ;EACI,2BDiGG;A1GstsCf;A2G3ysCI;EASQ,2BD+FK;A1GsssCjB;A2GjysCY;;;;;;;;;EAEF,2BD0FY;A1GgtsCtB;A2GvysCY;EACI,2BDsFM;A1GmtsCtB;;A2G90sCQ;;EAEF,2BDmIS;A1G8ssCf;A2G90sCQ;EACI,2BD+HG;A1GitsCf;A2GvzsCY;;;;;;;;;EAEF,2BDwHY;A1GwssCtB;A2G7zsCY;EACI,2BDoHM;A1G2ssCtB;;A0GnssCC;ECrKO,2BDsKE;A1GsssCV;A2Gt1sCI;EASQ,2BD2JK;A1GqrsCjB;;A0GtwsCC;ECzGO,6BD0GE;A1GywsCV;A2G/2sCQ;;EAEF,6BDqGS;A1G4wsCf;A2G92sCQ;EACI,6BDiGG;A1G+wsCf;A2Gp2sCI;EASQ,6BD+FK;A1G+vsCjB;A2G11sCY;;;;;;;;;EAEF,6BD0FY;A1GywsCtB;A2Gh2sCY;EACI,6BDsFM;A1G4wsCtB;;A2Gv4sCQ;;EAEF,6BDmIS;A1GuwsCf;A2Gv4sCQ;EACI,6BD+HG;A1G0wsCf;A2Gh3sCY;;;;;;;;;EAEF,6BDwHY;A1GiwsCtB;A2Gt3sCY;EACI,6BDoHM;A1GowsCtB;;A0G5vsCC;ECrKO,6BDsKE;A1G+vsCV;A2G/4sCI;EASQ,6BD2JK;A1G8usCjB;;A0G/zsCC;ECzGO,0BD0GE;A1Gk0sCV;A2Gx6sCQ;;EAEF,0BDqGS;A1Gq0sCf;A2Gv6sCQ;EACI,0BDiGG;A1Gw0sCf;A2G75sCI;EASQ,0BD+FK;A1GwzsCjB;A2Gn5sCY;;;;;;;;;EAEF,0BD0FY;A1Gk0sCtB;A2Gz5sCY;EACI,0BDsFM;A1Gq0sCtB;;A2Gh8sCQ;;EAEF,0BDmIS;A1Gg0sCf;A2Gh8sCQ;EACI,0BD+HG;A1Gm0sCf;A2Gz6sCY;;;;;;;;;EAEF,0BDwHY;A1G0zsCtB;A2G/6sCY;EACI,0BDoHM;A1G6zsCtB;;A0GrzsCC;ECrKO,0BDsKE;A1GwzsCV;A2Gx8sCI;EASQ,0BD2JK;A1GuysCjB;;A0Gx3sCC;ECzGO,6BD0GE;A1G23sCV;A2Gj+sCQ;;EAEF,6BDqGS;A1G83sCf;A2Gh+sCQ;EACI,6BDiGG;A1Gi4sCf;A2Gt9sCI;EASQ,6BD+FK;A1Gi3sCjB;A2G58sCY;;;;;;;;;EAEF,6BD0FY;A1G23sCtB;A2Gl9sCY;EACI,6BDsFM;A1G83sCtB;;A2Gz/sCQ;;EAEF,6BDmIS;A1Gy3sCf;A2Gz/sCQ;EACI,6BD+HG;A1G43sCf;A2Gl+sCY;;;;;;;;;EAEF,6BDwHY;A1Gm3sCtB;A2Gx+sCY;EACI,6BDoHM;A1Gs3sCtB;;A0G92sCC;ECrKO,6BDsKE;A1Gi3sCV;A2GjgtCI;EASQ,6BD2JK;A1Gg2sCjB;;A0Gj7sCC;ECzGO,4BD0GE;A1Go7sCV;A2G1htCQ;;EAEF,4BDqGS;A1Gu7sCf;A2GzhtCQ;EACI,4BDiGG;A1G07sCf;A2G/gtCI;EASQ,4BD+FK;A1G06sCjB;A2GrgtCY;;;;;;;;;EAEF,4BD0FY;A1Go7sCtB;A2G3gtCY;EACI,4BDsFM;A1Gu7sCtB;;A2GljtCQ;;EAEF,4BDmIS;A1Gk7sCf;A2GljtCQ;EACI,4BD+HG;A1Gq7sCf;A2G3htCY;;;;;;;;;EAEF,4BDwHY;A1G46sCtB;A2GjitCY;EACI,4BDoHM;A1G+6sCtB;;A0Gv6sCC;ECrKO,4BDsKE;A1G06sCV;A2G1jtCI;EASQ,4BD2JK;A1Gy5sCjB;;A0G1+sCC;ECzGO,0BD0GE;A1G6+sCV;A2GnltCQ;;EAEF,0BDqGS;A1Gg/sCf;A2GlltCQ;EACI,0BDiGG;A1Gm/sCf;A2GxktCI;EASQ,0BD+FK;A1Gm+sCjB;A2G9jtCY;;;;;;;;;EAEF,0BD0FY;A1G6+sCtB;A2GpktCY;EACI,0BDsFM;A1Gg/sCtB;;A2G3mtCQ;;EAEF,0BDmIS;A1G2+sCf;A2G3mtCQ;EACI,0BD+HG;A1G8+sCf;A2GpltCY;;;;;;;;;EAEF,0BDwHY;A1Gq+sCtB;A2G1ltCY;EACI,0BDoHM;A1Gw+sCtB;;A0Gh+sCC;ECrKO,0BDsKE;A1Gm+sCV;A2GnntCI;EASQ,0BD2JK;A1Gk9sCjB;;A0GnitCC;ECzGO,2BD0GE;A1GsitCV;A2G5otCQ;;EAEF,2BDqGS;A1GyitCf;A2G3otCQ;EACI,2BDiGG;A1G4itCf;A2GjotCI;EASQ,2BD+FK;A1G4htCjB;A2GvntCY;;;;;;;;;EAEF,2BD0FY;A1GsitCtB;A2G7ntCY;EACI,2BDsFM;A1GyitCtB;;A2GpqtCQ;;EAEF,2BDmIS;A1GoitCf;A2GpqtCQ;EACI,2BD+HG;A1GuitCf;A2G7otCY;;;;;;;;;EAEF,2BDwHY;A1G8htCtB;A2GnptCY;EACI,2BDoHM;A1GiitCtB;;A0GzhtCC;ECrKO,2BDsKE;A1G4htCV;A2G5qtCI;EASQ,2BD2JK;A1G2gtCjB;;A0G5ltCC;ECzGO,8BD0GE;A1G+ltCV;A2GrstCQ;;EAEF,8BDqGS;A1GkmtCf;A2GpstCQ;EACI,8BDiGG;A1GqmtCf;A2G1rtCI;EASQ,8BD+FK;A1GqltCjB;A2GhrtCY;;;;;;;;;EAEF,8BD0FY;A1G+ltCtB;A2GtrtCY;EACI,8BDsFM;A1GkmtCtB;;A2G7ttCQ;;EAEF,8BDmIS;A1G6ltCf;A2G7ttCQ;EACI,8BD+HG;A1GgmtCf;A2GtstCY;;;;;;;;;EAEF,8BDwHY;A1GultCtB;A2G5stCY;EACI,8BDoHM;A1G0ltCtB;;A0GlltCC;ECrKO,8BDsKE;A1GqltCV;A2GrutCI;EASQ,8BD2JK;A1GoktCjB;;A0GrptCC;ECzGO,8BD0GE;A1GwptCV;A2G9vtCQ;;EAEF,8BDqGS;A1G2ptCf;A2G7vtCQ;EACI,8BDiGG;A1G8ptCf;A2GnvtCI;EASQ,8BD+FK;A1G8otCjB;A2GzutCY;;;;;;;;;EAEF,8BD0FY;A1GwptCtB;A2G/utCY;EACI,8BDsFM;A1G2ptCtB;;A2GtxtCQ;;EAEF,8BDmIS;A1GsptCf;A2GtxtCQ;EACI,8BD+HG;A1GyptCf;A2G/vtCY;;;;;;;;;EAEF,8BDwHY;A1GgptCtB;A2GrwtCY;EACI,8BDoHM;A1GmptCtB;;A0G3otCC;ECrKO,8BDsKE;A1G8otCV;A2G9xtCI;EASQ,8BD2JK;A1G6ntCjB;;A0G9stCC;ECzGO,8BD0GE;A1GittCV;A2GvztCQ;;EAEF,8BDqGS;A1GottCf;A2GtztCQ;EACI,8BDiGG;A1GuttCf;A2G5ytCI;EASQ,8BD+FK;A1GustCjB;A2GlytCY;;;;;;;;;EAEF,8BD0FY;A1GittCtB;A2GxytCY;EACI,8BDsFM;A1GottCtB;;A2G/0tCQ;;EAEF,8BDmIS;A1G+stCf;A2G/0tCQ;EACI,8BD+HG;A1GkttCf;A2GxztCY;;;;;;;;;EAEF,8BDwHY;A1GystCtB;A2G9ztCY;EACI,8BDoHM;A1G4stCtB;;A0GpstCC;ECrKO,8BDsKE;A1GustCV;A2Gv1tCI;EASQ,8BD2JK;A1GsrtCjB;;A0GvwtCC;ECzGO,8BD0GE;A1G0wtCV;A2Gh3tCQ;;EAEF,8BDqGS;A1G6wtCf;A2G/2tCQ;EACI,8BDiGG;A1GgxtCf;A2Gr2tCI;EASQ,8BD+FK;A1GgwtCjB;A2G31tCY;;;;;;;;;EAEF,8BD0FY;A1G0wtCtB;A2Gj2tCY;EACI,8BDsFM;A1G6wtCtB;;A2Gx4tCQ;;EAEF,8BDmIS;A1GwwtCf;A2Gx4tCQ;EACI,8BD+HG;A1G2wtCf;A2Gj3tCY;;;;;;;;;EAEF,8BDwHY;A1GkwtCtB;A2Gv3tCY;EACI,8BDoHM;A1GqwtCtB;;A0G7vtCC;ECrKO,8BDsKE;A1GgwtCV;A2Gh5tCI;EASQ,8BD2JK;A1G+utCjB;;A0Gh0tCC;ECzGO,8BD0GE;A1Gm0tCV;A2Gz6tCQ;;EAEF,8BDqGS;A1Gs0tCf;A2Gx6tCQ;EACI,8BDiGG;A1Gy0tCf;A2G95tCI;EASQ,8BD+FK;A1GyztCjB;A2Gp5tCY;;;;;;;;;EAEF,8BD0FY;A1Gm0tCtB;A2G15tCY;EACI,8BDsFM;A1Gs0tCtB;;A2Gj8tCQ;;EAEF,8BDmIS;A1Gi0tCf;A2Gj8tCQ;EACI,8BD+HG;A1Go0tCf;A2G16tCY;;;;;;;;;EAEF,8BDwHY;A1G2ztCtB;A2Gh7tCY;EACI,8BDoHM;A1G8ztCtB;;A0GtztCC;ECrKO,8BDsKE;A1GyztCV;A2Gz8tCI;EASQ,8BD2JK;A1GwytCjB;;A0Gz3tCC;ECzGO,8BD0GE;A1G43tCV;A2Gl+tCQ;;EAEF,8BDqGS;A1G+3tCf;A2Gj+tCQ;EACI,8BDiGG;A1Gk4tCf;A2Gv9tCI;EASQ,8BD+FK;A1Gk3tCjB;A2G78tCY;;;;;;;;;EAEF,8BD0FY;A1G43tCtB;A2Gn9tCY;EACI,8BDsFM;A1G+3tCtB;;A2G1/tCQ;;EAEF,8BDmIS;A1G03tCf;A2G1/tCQ;EACI,8BD+HG;A1G63tCf;A2Gn+tCY;;;;;;;;;EAEF,8BDwHY;A1Go3tCtB;A2Gz+tCY;EACI,8BDoHM;A1Gu3tCtB;;A0G/2tCC;ECrKO,8BDsKE;A1Gk3tCV;A2GlguCI;EASQ,8BD2JK;A1Gi2tCjB;;A0Gl7tCC;ECzGO,8BD0GE;A1Gq7tCV;A2G3huCQ;;EAEF,8BDqGS;A1Gw7tCf;A2G1huCQ;EACI,8BDiGG;A1G27tCf;A2GhhuCI;EASQ,8BD+FK;A1G26tCjB;A2GtguCY;;;;;;;;;EAEF,8BD0FY;A1Gq7tCtB;A2G5guCY;EACI,8BDsFM;A1Gw7tCtB;;A2GnjuCQ;;EAEF,8BDmIS;A1Gm7tCf;A2GnjuCQ;EACI,8BD+HG;A1Gs7tCf;A2G5huCY;;;;;;;;;EAEF,8BDwHY;A1G66tCtB;A2GliuCY;EACI,8BDoHM;A1Gg7tCtB;;A0Gx6tCC;ECrKO,8BDsKE;A1G26tCV;A2G3juCI;EASQ,8BD2JK;A1G05tCjB;;A0G3+tCC;ECzGO,8BD0GE;A1G8+tCV;A2GpluCQ;;EAEF,8BDqGS;A1Gi/tCf;A2GnluCQ;EACI,8BDiGG;A1Go/tCf;A2GzkuCI;EASQ,8BD+FK;A1Go+tCjB;A2G/juCY;;;;;;;;;EAEF,8BD0FY;A1G8+tCtB;A2GrkuCY;EACI,8BDsFM;A1Gi/tCtB;;A2G5muCQ;;EAEF,8BDmIS;A1G4+tCf;A2G5muCQ;EACI,8BD+HG;A1G++tCf;A2GrluCY;;;;;;;;;EAEF,8BDwHY;A1Gs+tCtB;A2G3luCY;EACI,8BDoHM;A1Gy+tCtB;;A0Gj+tCC;ECrKO,8BDsKE;A1Go+tCV;A2GpnuCI;EASQ,8BD2JK;A1Gm9tCjB;;A0GpiuCC;ECzGO,8BD0GE;A1GuiuCV;A2G7ouCQ;;EAEF,8BDqGS;A1G0iuCf;A2G5ouCQ;EACI,8BDiGG;A1G6iuCf;A2GlouCI;EASQ,8BD+FK;A1G6huCjB;A2GxnuCY;;;;;;;;;EAEF,8BD0FY;A1GuiuCtB;A2G9nuCY;EACI,8BDsFM;A1G0iuCtB;;A2GrquCQ;;EAEF,8BDmIS;A1GqiuCf;A2GrquCQ;EACI,8BD+HG;A1GwiuCf;A2G9ouCY;;;;;;;;;EAEF,8BDwHY;A1G+huCtB;A2GppuCY;EACI,8BDoHM;A1GkiuCtB;;A0G1huCC;ECrKO,8BDsKE;A1G6huCV;A2G7quCI;EASQ,8BD2JK;A1G4guCjB;;A0GhguCC;ECtMO,cDuME;ECxLF,qBD0LS;ECtLT,yBDuLK;A1GkguCb;A2GxsuCQ;;EAEF,cDkMS;A1GwguCf;A2GvsuCQ;EACI,cD8LG;A1G2guCf;A2G7ruCI;EAwBQ,qBDgKY;EC5JZ,oCAAA;A3GqquCZ;;A0GlguCC;ECrNO,cDsNE;ECvMF,oCD0MS;ECtMT,wCDqMK;A1GqguCb;A2GztuCQ;;EAEF,cDiNS;A1G0guCf;A2GxtuCQ;EACI,cD6MG;A1G6guCf;A2G9suCI;EASQ,cD4LK;EC7KL,qBDgLY;EC5KZ,oCAAA;A3GuruCZ;A2GtsuCY;;;;;;;;;EAEF,cDuLY;A1GwhuCtB;A2G5suCY;EACI,cDmLM;A1G2huCtB;;A0GjjuCC;ECtMO,cDuME;ECxLF,qBD0LS;ECtLT,yBDuLK;A1GmjuCb;A2GzvuCQ;;EAEF,cDkMS;A1GyjuCf;A2GxvuCQ;EACI,cD8LG;A1G4juCf;A2G9uuCI;EAwBQ,qBDgKY;EC5JZ,oCAAA;A3GstuCZ;;A0GnjuCC;ECrNO,cDsNE;ECvMF,oCD0MS;ECtMT,wCDqMK;A1GsjuCb;A2G1wuCQ;;EAEF,cDiNS;A1G2juCf;A2GzwuCQ;EACI,cD6MG;A1G8juCf;A2G/vuCI;EASQ,cD4LK;EC7KL,qBDgLY;EC5KZ,oCAAA;A3GwuuCZ;A2GvvuCY;;;;;;;;;EAEF,cDuLY;A1GykuCtB;A2G7vuCY;EACI,cDmLM;A1G4kuCtB;;A0GlmuCC;ECtMO,cDuME;ECxLF,qBD0LS;ECtLT,yBDuLK;A1GomuCb;A2G1yuCQ;;EAEF,cDkMS;A1G0muCf;A2GzyuCQ;EACI,cD8LG;A1G6muCf;A2G/xuCI;EAwBQ,qBDgKY;EC5JZ,oCAAA;A3GuwuCZ;;A0GpmuCC;ECrNO,cDsNE;ECvMF,qCD0MS;ECtMT,yCDqMK;A1GumuCb;A2G3zuCQ;;EAEF,cDiNS;A1G4muCf;A2G1zuCQ;EACI,cD6MG;A1G+muCf;A2GhzuCI;EASQ,cD4LK;EC7KL,qBDgLY;EC5KZ,oCAAA;A3GyxuCZ;A2GxyuCY;;;;;;;;;EAEF,cDuLY;A1G0nuCtB;A2G9yuCY;EACI,cDmLM;A1G6nuCtB;;A0GnpuCC;ECtMO,cDuME;ECxLF,qBD0LS;ECtLT,yBDuLK;A1GqpuCb;A2G31uCQ;;EAEF,cDkMS;A1G2puCf;A2G11uCQ;EACI,cD8LG;A1G8puCf;A2Gh1uCI;EAwBQ,qBDgKY;EC5JZ,oCAAA;A3GwzuCZ;;A0GrpuCC;ECrNO,cDsNE;ECvMF,qCD0MS;ECtMT,yCDqMK;A1GwpuCb;A2G52uCQ;;EAEF,cDiNS;A1G6puCf;A2G32uCQ;EACI,cD6MG;A1GgquCf;A2Gj2uCI;EASQ,cD4LK;EC7KL,qBDgLY;EC5KZ,oCAAA;A3G00uCZ;A2Gz1uCY;;;;;;;;;EAEF,cDuLY;A1G2quCtB;A2G/1uCY;EACI,cDmLM;A1G8quCtB;;A0GpsuCC;ECtMO,cDuME;ECxLF,qBD0LS;ECtLT,yBDuLK;A1GssuCb;A2G54uCQ;;EAEF,cDkMS;A1G4suCf;A2G34uCQ;EACI,cD8LG;A1G+suCf;A2Gj4uCI;EAwBQ,qBDgKY;EC5JZ,oCAAA;A3Gy2uCZ;;A0GtsuCC;ECrNO,cDsNE;ECvMF,kCD0MS;ECtMT,sCDqMK;A1GysuCb;A2G75uCQ;;EAEF,cDiNS;A1G8suCf;A2G55uCQ;EACI,cD6MG;A1GituCf;A2Gl5uCI;EASQ,cD4LK;EC7KL,qBDgLY;EC5KZ,oCAAA;A3G23uCZ;A2G14uCY;;;;;;;;;EAEF,cDuLY;A1G4tuCtB;A2Gh5uCY;EACI,cDmLM;A1G+tuCtB;;A0GrvuCC;ECtMO,cDuME;ECxLF,qBD0LS;ECtLT,yBDuLK;A1GuvuCb;A2G77uCQ;;EAEF,cDkMS;A1G6vuCf;A2G57uCQ;EACI,cD8LG;A1GgwuCf;A2Gl7uCI;EAwBQ,qBDgKY;EC5JZ,oCAAA;A3G05uCZ;;A0GvvuCC;ECrNO,cDsNE;ECvMF,oCD0MS;ECtMT,wCDqMK;A1G0vuCb;A2G98uCQ;;EAEF,cDiNS;A1G+vuCf;A2G78uCQ;EACI,cD6MG;A1GkwuCf;A2Gn8uCI;EASQ,cD4LK;EC7KL,qBDgLY;EC5KZ,oCAAA;A3G46uCZ;A2G37uCY;;;;;;;;;EAEF,cDuLY;A1G6wuCtB;A2Gj8uCY;EACI,cDmLM;A1GgxuCtB;;A4Gz/uCA;EACI,gBvGquCwB;EuGpuCxB,2BAAA;EACA,oBAAA;EACA,kBAAA;EACA,mCAAA;EACA,sBvG8tCwB;EuG7tCxB,gBvG8tCwB;EuG7tCxB,qCAAA;EtGOA,qBAAA;ANs/uCJ;;A6GrgvCA;EACC,iCAAA;A7GwgvCD;;A6GngvCA;EACC,iCAAA;A7GsgvCD;;A8G7gvCA;EACC,gCAAA;A9GghvCD;;A+GjhvCA;EACG,4BAAA;EACA,oCAAA;EACF,8CAAA;EACE,2BAAA;A/GohvCH;A+GjhvCG;EACD,kCAAA;EACA,0CAAA;EACA,gDAAA;A/GmhvCF;A+G9gvCG;EACE,wCAAA;A/GghvCL;A+G5gvCG;EAEE,qCAAA;EACA,6CAAA;EACA,mDAAA;A/G6gvCL;A+GzgvCG;EACE,uCAAA;EvF7BH,+CuF8BwB;A/G2gvC1B;A+GxgvCG;EACE,qDAAA;A/G0gvCL;;A+GrgvCA;EACG,sCAAA;A/GwgvCH;;AgH/ivCA;EACC,kCAAA;EACA,0CAAA;EACA,iDAAA;EACA,oDAAA;EpGKK,4CARW;EoGKhB,gBAAA;AhHkjvCD;AgHhjvCC;EACC,sDAAA;EpGAI,oFARW;AZ2jvCjB;AgHzivCC;EACC,2CAAA;EACA,mDAAA;EACA,yDAAA;AhH2ivCF;AgHvivCC;EACC,8CAAA;AhHyivCF;;AiHrkvCA;EACC,+CAAA;EACA,yCAAA;AjHwkvCD;AiHtkvCC;EACC,gDAAA;AjHwkvCF;AiHrkvCC;EACC,qDAAA;EACA,uDAAA;AjHukvCF;AiHpkvCC;EACC,6DAAA;EACA,6DAAA;AjHskvCF;AiHpkvCE;EAIE,6DAAA;AjHmkvCJ;AiH/jvCE;EAIE,6DAAA;AjH8jvCJ;AiHzjvCC;EACC,mEAAA;EACA,mEAAA;EAKC,mEAAA;AjHujvCH;AiHnjvCC;EACC,oDAAA;AjHqjvCF;AiH9ivCE;EACC,oDAAA;AjHgjvCH;;AiH3ivCA;EACC,uCAAA;AjH8ivCD;;AiHzivCE;EAEC,+CAAA;AjH2ivCH;;AiHjivCC;EACC,gDAAA;AjHoivCF;AiHlivCE;EACC,sDAAA;AjHoivCH;AiHjivCE;EAIE,wDAAA;AjHgivCJ;;AiHvhvCE;EACC,wDAAA;AjH0hvCH;;AkH1nvCQ;EACI,kBAAA;AlH6nvCZ;;AmHhovCA;EACC,wCAAA;EACA,gDAAA;EACA,0DAAA;AnHmovCD;;AoHlovCC;EACC,kCAAA;EACA,0CAAA;EACK,gDAAA;ApHqovCP;AoHjovCC;EACC,6CAAA;ApHmovCF;AoH/nvCC;EACC,0CAAA;EACA,sCAAA;EACA,kCAAA;EAEA,2B/GmXiB;AL6wuCnB;AqHnpvCI;EACI,8CDiBe;ApHoovCvB;AqHjpvCI;EACI,8CDYe;ECXf,UAAA;ArHmpvCR;AoHrovCE;EAKC,gDAAA;EACA,4CAAA;EACA,kCAAA;EACA,2B/GyWgB;AL0xuCnB;AoH9nvCC;EACC,6BAAA;EACA,yBAAA;ApHgovCF;AoH9nvCE;EAKC,6BAAA;EACA,yBAAA;ApH4nvCH;AoHvnvCC;EXtCA,SAAA;EACA,6BAAA;EACG,wBAAA;EACH,gBAAA;EACG,gBAAA;AzGgqvCJ;;AqH/qvCI;EACI,yBDuDc;ApH2nvCtB;;AqHnrvCI;EACI,cAAA;ArH0rvCR;AqHtrvCI;EACI,c1GLW;E0GMX,UAAA;ArHwrvCR;;AoH/nvCA;EACC,YAAA;ApHkovCD;;AoH9nvCA;EACC,0CAAA;ApHiovCD;;AsHzsvCA;EACI,2BAAA;AtH4svCJ;AsHzsvCC;EAEC,0CAAA;EACA,sCAAA;EACA,kCAAA;EACA,2BjH+XiB;AL20uCnB;AqHjtvCI;EACI,8CCEe;AtHitvCvB;AqH/svCI;EACI,8CCHe;EDIf,UAAA;ArHitvCR;AsH/svCE;EAKC,gDAAA;EACA,uDAAA;EACA,kCAAA;EACA,2BjHqXgB;ALw1uCnB;AsHxsvCC;EAEC,6BAAA;EACA,yBAAA;EACA,cjHfS;ALwtvCX;AqHnuvCI;EACI,wCCsBe;AtH+svCvB;AqHjuvCI;EACI,wCCiBe;EDhBf,UAAA;ArHmuvCR;AsH9svCE;EAKC,6BAAA;EACA,oCAAA;EACA,cjHxBQ;ALouvCX;;AuH9uvCQ;EACI,wBlH6rBgC;ALojuC5C;;AuH3uvCA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AvH8uvCJ;AuH3uvCI;EACI,SAAA;EACA,WAAA;EACA,cAAA;AvH6uvCR;AuHzuvCI;EACI,oBAAA;AvH2uvCR;AuHtuvCQ;EACI,elHgqBgC;EkH/pBhC,clH+pBgC;ALykuC5C;AuHnuvCQ;EACI,elH0pBgC;EkHzpBhC,clHypBgC;AL4kuC5C;AuH/tvCQ;EACI,SAAA;EACA,qDAAA;AvHiuvCZ;AuH/tvCY;EAEI,YAAA;EACA,qDAAA;AvHguvChB;AuH7tvCY;EACI,mEAAA;AvH+tvChB;AuHttvCY;EACI,mCAAA;AvHwtvChB;AuHhtvCY;EACI,kCAAA;AvHktvChB;AuH1svCY;EACI,mCAAA;AvH4svChB;;AuHpsvCI;EACI,elHqqB4C;EkHpqB5C,sDAAA;EACA,sBlHkqB4C;ALqiuCpD;AuHrsvCQ;EACI,YAAA;EACA,wDAAA;AvHusvCZ;AuHlsvCQ;EACI,clH2pBwC;EkH1pBxC,alHypBwC;AL2iuCpD;AuH/rvCQ;EACI,elHspBwC;EkHrpBxC,clHopBwC;AL6iuCpD;;AuH3rvCA;EACI,kBAAA;EACA,gBAAA;AvH8rvCJ;AuH5rvCI;EACI,mBAAA;EACA,kBlHogBoC;EkHngBpC,iCAAA;EACA,gBlHmgBoC;AL2ruC5C;AuH3rvCI;EjHnHA,uBAAA;EiHqHI,6BAAA;EACA,gCnH6XsB;EmH5XtB,eAAA;EACA,gBAAA;AvH6rvCR;AuH1rvCI;EACI,gCnHuXsB;EmHtXtB,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,clH8iBoC;EkH7iBpC,elH6iBoC;EkH5iBpC,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,oBAAA;EACA,6DAAA;EACA,gDAAA;EjHjFJ,mCAAA;EAZA,iCAAA;AN2xvCJ;AuH1rvCQ;EACI,clHmiBgC;EkHliBhC,elHkiBgC;AL0puC5C;AuHzrvCQ;EACI,clH+hBgC;EkH9hBhC,elH8hBgC;AL6puC5C;AuHvrvCI;EACI,WAAA;AvHyrvCR;AuHtrvCI;EACI,gDAAA;EACA,gCnHsVsB;AJk2uC9B;AuHtrvCQ;EACI,gCnHmVkB;EmHlVlB,UAAA;AvHwrvCZ;AuHprvCI;EACI,gCnH6UsB;EmH5UtB,wDAAA;AvHsrvCR;;AuHjrvCA;EACI,kBAAA;EACA,gBAAA;AvHorvCJ;AuHlrvCI;EACI,eAAA;AvHorvCR;AuHjrvCI;EjHpLA,uBAAA;EiHsLI,6BAAA;EACA,gCnH4TsB;EmH3TtB,eAAA;EACA,gBAAA;EACA,sBAAA;AvHmrvCR;AuHhrvCI;EjH7LA,uBAAA;ANg3vCJ;AuH/qvCI;EACI,gBlHmOW;EkHlOX,mBAAA;AvHirvCR;AuH7qvCQ;EACI,+BAAA;AvH+qvCZ;AuH1qvCQ;EACI,+BAAA;AvH4qvCZ;AuHvqvCQ;EACI,8BAAA;AvHyqvCZ;AuHrqvCI;EACI,wDAAA;AvHuqvCR;;AwH74vCI;ElHaA,uBAAA;ANo4vCJ;AwH94vCQ;ElHUJ,uBAAA;ANu4vCJ;AwH74vCQ;ElHMJ,uBAAA;AN04vCJ;AwH54vCQ;EACI,0CAAA;EACN,sCAAA;AxH84vCN;AwH54vCY;EACI,+CAAA;AxH84vChB;AwH14vCQ;EACI,0CAAA;EACN,sCAAA;AxH44vCN;AwH14vCY;EACI,+CAAA;AxH44vChB;;AkHr6vCQ;EACI,kBAAA;AlHw6vCZ;;AyH16vCI;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBpH6aW;ALggvCnB;;A0Hp7vCA;EACG,+CAAA;EACA,yCAAA;EACA,6DAAA;EACA,4DAAA;EACA,mEAAA;EACA,+CAAA;EACA,mEAAA;A1Hu7vCH;;A0Hn7vCA;EACC,wBAAA;A1Hs7vCD;;A0Hl7vCA;EACC,mBAAA;EACA,8BAAA;EpHMG,gCAAA;EACA,iCAAA;EoHLH,4DAAA;A1Hs7vCD;A0Hn7vCC;EACC,gBAAA;A1Hq7vCF;;A0Hh7vCA;EACC,4BAAA;EACA,oCAAA;EACA,4CAAA;E9GtBK,sCARW;AZk9vCjB;;A0H/6vCA;EACC,2CAAA;EACA,yDAAA;A1Hk7vCD;;A0H96vCA;EACG,6CAAA;EACA,uDAAA;A1Hi7vCH;;Aen6vCI;E2GTH;I9GxCK,4CARW;EZi+vCf;AACF;A0H56vCA;EAEE,kCAAA;A1H66vCF;;A2Ht+vCA;EACE,uCAAA;EACA,uDAAA;EACA,qDAAA;EACA,+CAAA;A3Hy+vCF;;A2Hr+vCA;EACI,aAAA;EACA,oBAAA;EACA,8BAAA;A3Hw+vCJ;A2Ht+vCI;EACI,YAAA;ErHAJ,uBAAA;EqHEI,aAAA;EACA,qBAAA;EACA,kBAAA;A3Hw+vCR;A2Ht+vCQ;EACI,eAAA;A3Hw+vCZ;A2Hr+vCQ;EACI,UAAA;ErHXR,uBAAA;ANm/vCJ;;A4HjgwCA;EACC,uCAAA;EACA,iCAAA;EACA,qDAAA;EACA,+CAAA;EACA,uDAAA;EACA,iDAAA;EACA,qDAAA;EACA,+CAAA;EACA,mDAAA;EACA,6CAAA;A5HogwCD;A4HjgwCC;EACI,yBAAA;EACH,eAAA;EACA,kBAAA;A5HmgwCF;A4HhgwCC;EACC,4BAAA;A5HkgwCF;A4H//vCC;EACC,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;A5HigwCF;A4H//vCE;EACC,eAAA;A5HigwCH;A4H9/vCE;EACC,gBAAA;A5HggwCH;A4H1/vCE;;EACC,2BAAA;A5H6/vCH;A4H3/vCG;;;EACC,2BAAA;A5H+/vCJ;A4Hz/vCE;EACC,mBAAA;A5H2/vCH;A4Ht/vCC;EACC,uBvH8S8B;EuH7S9B,iBAAA;EACA,yBAAA;A5Hw/vCF;A4Hn/vCE;EACC,gBAAA;A5Hq/vCH;A4H/+vCE;EACC,wBAAA;EACA,0BAAA;EACA,2CAAA;A5Hi/vCH;A4H7+vCG;EACC,gCAAA;A5H++vCJ;A4Hx+vCE;EACC,wBAAA;EACA,2BAAA;EACA,2CAAA;A5H0+vCH;A4Ht+vCG;EACC,gCAAA;A5Hw+vCJ;A4Hh+vCG;EACC,uCAAA;A5Hk+vCJ;A4Hn+vCG;EACC,uCAAA;A5Hq+vCJ;A4Ht+vCG;EACC,uCAAA;A5Hw+vCJ;A4Hz+vCG;EACC,uCAAA;A5H2+vCJ;A4H5+vCG;EACC,uCAAA;A5H8+vCJ;A4H/+vCG;EACC,uCAAA;A5Hi/vCJ;A4Hl/vCG;EACC,uCAAA;A5Ho/vCJ;A4Hr/vCG;EACC,uCAAA;A5Hu/vCJ;A4Hx/vCG;EACC,uCAAA;A5H0/vCJ;;A4Hn/vCA;EACC,mBAAA;A5Hs/vCD;;A4Hj/vCC;EACC,UAAA;A5Ho/vCF;;A4Hh/vCA;;;EAGC,sBAAA;A5Hm/vCD;A4Hj/vCC;;;EACC,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;A5Hq/vCF;;A4Hh/vCC;EACC,UAAA;E/BjGM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sC+B2F0B;E/BvF9B,qDAAA;A7FglwCJ;;A4Hp/vCC;EACC,UAAA;E/BxGM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,sC+BkG6B;E/B9FjC,qDAAA;A7F2lwCJ;;A4Hx/vCA;EACC,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EtHrJG,uBAAA;EsHuJH,sDAAA;EACA,oDAAA;EACA,4CAAA;EACA,gBvH2QkB;EuH1QlB,oBAAA;EACA,WAAA;EACA,gCAAA;EACA,4CAAA;A5H2/vCD;;A4Hx/vCA;EACC,kBAAA;A5H2/vCD;A4Hz/vCC;EACC,cAAA;A5H2/vCF;;A4Hh/vCI;EACC,avHuNK;AL4xvCV;A4Hh/vCK;EACC,6BAAA;A5Hk/vCN;;A4H5+vCI;EACC,iBvH4MK;EuH3ML,oBvH2MK;ALoyvCV;;A4H1+vCI;EACC,kBvHqMK;EuHpML,mBvHoMK;ALyyvCV;A4H1+vCK;EACC,6BAAA;A5H4+vCN;;A4Hr+vCK;EACI,kBvHwLC;ALgzvCV;A4Hr+vCK;EACI,mBvHoLC;ALmzvCV;A4Hn+vCK;EACC,6BAAA;A5Hq+vCN;;A4H9gwCI;EACC,gBvHuNK;AL0zvCV;A4H9gwCK;EACC,gCAAA;A5HghwCN;;A4H1gwCI;EACC,oBvH4MK;EuH3ML,uBvH2MK;ALk0vCV;;A4HxgwCI;EACC,qBvHqMK;EuHpML,sBvHoMK;ALu0vCV;A4HxgwCK;EACC,gCAAA;A5H0gwCN;;A4HngwCK;EACI,qBvHwLC;AL80vCV;A4HngwCK;EACI,sBvHoLC;ALi1vCV;A4HjgwCK;EACC,gCAAA;A5HmgwCN;;A4H5iwCI;EACC,evHuNK;ALw1vCV;A4H5iwCK;EACC,+BAAA;A5H8iwCN;;A4HxiwCI;EACC,mBvH4MK;EuH3ML,sBvH2MK;ALg2vCV;;A4HtiwCI;EACC,oBvHqMK;EuHpML,qBvHoMK;ALq2vCV;A4HtiwCK;EACC,+BAAA;A5HwiwCN;;A4HjiwCK;EACI,oBvHwLC;AL42vCV;A4HjiwCK;EACI,qBvHoLC;AL+2vCV;A4H/hwCK;EACC,+BAAA;A5HiiwCN;;A4H1kwCI;EACC,gBvHuNK;ALs3vCV;A4H1kwCK;EACC,gCAAA;A5H4kwCN;;A4HtkwCI;EACC,oBvH4MK;EuH3ML,uBvH2MK;AL83vCV;;A4HpkwCI;EACC,qBvHqMK;EuHpML,sBvHoMK;ALm4vCV;A4HpkwCK;EACC,gCAAA;A5HskwCN;;A4H/jwCK;EACI,qBvHwLC;AL04vCV;A4H/jwCK;EACI,sBvHoLC;AL64vCV;A4H7jwCK;EACC,gCAAA;A5H+jwCN;;A4HxmwCI;EACC,avHuNK;ALo5vCV;A4HxmwCK;EACC,6BAAA;A5H0mwCN;;A4HpmwCI;EACC,iBvH4MK;EuH3ML,oBvH2MK;AL45vCV;;A4HlmwCI;EACC,kBvHqMK;EuHpML,mBvHoMK;ALi6vCV;A4HlmwCK;EACC,6BAAA;A5HomwCN;;A4H7lwCK;EACI,kBvHwLC;ALw6vCV;A4H7lwCK;EACI,mBvHoLC;AL26vCV;A4H3lwCK;EACC,6BAAA;A5H6lwCN;;A4HtowCI;EACC,gBvHuNK;ALk7vCV;A4HtowCK;EACC,gCAAA;A5HwowCN;;A4HlowCI;EACC,oBvH4MK;EuH3ML,uBvH2MK;AL07vCV;;A4HhowCI;EACC,qBvHqMK;EuHpML,sBvHoMK;AL+7vCV;A4HhowCK;EACC,gCAAA;A5HkowCN;;A4H3nwCK;EACI,qBvHwLC;ALs8vCV;A4H3nwCK;EACI,sBvHoLC;ALy8vCV;A4HznwCK;EACC,gCAAA;A5H2nwCN;;A4HpqwCI;EACC,evHuNK;ALg9vCV;A4HpqwCK;EACC,+BAAA;A5HsqwCN;;A4HhqwCI;EACC,mBvH4MK;EuH3ML,sBvH2MK;ALw9vCV;;A4H9pwCI;EACC,oBvHqMK;EuHpML,qBvHoMK;AL69vCV;A4H9pwCK;EACC,+BAAA;A5HgqwCN;;A4HzpwCK;EACI,oBvHwLC;ALo+vCV;A4HzpwCK;EACI,qBvHoLC;ALu+vCV;A4HvpwCK;EACC,+BAAA;A5HypwCN;;A4HlswCI;EACC,gBvHuNK;AL8+vCV;A4HlswCK;EACC,gCAAA;A5HoswCN;;A4H9rwCI;EACC,oBvH4MK;EuH3ML,uBvH2MK;ALs/vCV;;A4H5rwCI;EACC,qBvHqMK;EuHpML,sBvHoMK;AL2/vCV;A4H5rwCK;EACC,gCAAA;A5H8rwCN;;A4HvrwCK;EACI,qBvHwLC;ALkgwCV;A4HvrwCK;EACI,sBvHoLC;ALqgwCV;A4HrrwCK;EACC,gCAAA;A5HurwCN;;A4HhuwCI;EACC,avHuNK;AL4gwCV;A4HhuwCK;EACC,6BAAA;A5HkuwCN;;A4H5twCI;EACC,iBvH4MK;EuH3ML,oBvH2MK;ALohwCV;;A4H1twCI;EACC,kBvHqMK;EuHpML,mBvHoMK;ALyhwCV;A4H1twCK;EACC,6BAAA;A5H4twCN;;A4HrtwCK;EACI,kBvHwLC;ALgiwCV;A4HrtwCK;EACI,mBvHoLC;ALmiwCV;A4HntwCK;EACC,6BAAA;A5HqtwCN;;A4H9vwCI;EACC,gBvHuNK;AL0iwCV;A4H9vwCK;EACC,gCAAA;A5HgwwCN;;A4H1vwCI;EACC,oBvH4MK;EuH3ML,uBvH2MK;ALkjwCV;;A4HxvwCI;EACC,qBvHqMK;EuHpML,sBvHoMK;ALujwCV;A4HxvwCK;EACC,gCAAA;A5H0vwCN;;A4HnvwCK;EACI,qBvHwLC;AL8jwCV;A4HnvwCK;EACI,sBvHoLC;ALikwCV;A4HjvwCK;EACC,gCAAA;A5HmvwCN;;A4H5xwCI;EACC,evHuNK;ALwkwCV;A4H5xwCK;EACC,+BAAA;A5H8xwCN;;A4HxxwCI;EACC,mBvH4MK;EuH3ML,sBvH2MK;ALglwCV;;A4HtxwCI;EACC,oBvHqMK;EuHpML,qBvHoMK;ALqlwCV;A4HtxwCK;EACC,+BAAA;A5HwxwCN;;A4HjxwCK;EACI,oBvHwLC;AL4lwCV;A4HjxwCK;EACI,qBvHoLC;AL+lwCV;A4H/wwCK;EACC,+BAAA;A5HixwCN;;Ae97wCI;E6GoIA;IACC,avHuNK;ELumwCR;E4H3zwCG;IACC,6BAAA;E5H6zwCJ;;E4HvzwCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;EL+mwCR;;E4HrzwCE;IACC,kBvHqMK;IuHpML,mBvHoMK;ELonwCR;E4HrzwCG;IACC,6BAAA;E5HuzwCJ;;E4HhzwCG;IACI,kBvHwLC;EL2nwCR;E4HhzwCG;IACI,mBvHoLC;EL8nwCR;E4H9ywCG;IACC,6BAAA;E5HgzwCJ;;E4Hz1wCE;IACC,gBvHuNK;ELqowCR;E4Hz1wCG;IACC,gCAAA;E5H21wCJ;;E4Hr1wCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;EL6owCR;;E4Hn1wCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELkpwCR;E4Hn1wCG;IACC,gCAAA;E5Hq1wCJ;;E4H90wCG;IACI,qBvHwLC;ELypwCR;E4H90wCG;IACI,sBvHoLC;EL4pwCR;E4H50wCG;IACC,gCAAA;E5H80wCJ;;E4Hv3wCE;IACC,evHuNK;ELmqwCR;E4Hv3wCG;IACC,+BAAA;E5Hy3wCJ;;E4Hn3wCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;EL2qwCR;;E4Hj3wCE;IACC,oBvHqMK;IuHpML,qBvHoMK;ELgrwCR;E4Hj3wCG;IACC,+BAAA;E5Hm3wCJ;;E4H52wCG;IACI,oBvHwLC;ELurwCR;E4H52wCG;IACI,qBvHoLC;EL0rwCR;E4H12wCG;IACC,+BAAA;E5H42wCJ;;E4Hr5wCE;IACC,gBvHuNK;ELiswCR;E4Hr5wCG;IACC,gCAAA;E5Hu5wCJ;;E4Hj5wCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELyswCR;;E4H/4wCE;IACC,qBvHqMK;IuHpML,sBvHoMK;EL8swCR;E4H/4wCG;IACC,gCAAA;E5Hi5wCJ;;E4H14wCG;IACI,qBvHwLC;ELqtwCR;E4H14wCG;IACI,sBvHoLC;ELwtwCR;E4Hx4wCG;IACC,gCAAA;E5H04wCJ;;E4Hn7wCE;IACC,avHuNK;EL+twCR;E4Hn7wCG;IACC,6BAAA;E5Hq7wCJ;;E4H/6wCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;ELuuwCR;;E4H76wCE;IACC,kBvHqMK;IuHpML,mBvHoMK;EL4uwCR;E4H76wCG;IACC,6BAAA;E5H+6wCJ;;E4Hx6wCG;IACI,kBvHwLC;ELmvwCR;E4Hx6wCG;IACI,mBvHoLC;ELsvwCR;E4Ht6wCG;IACC,6BAAA;E5Hw6wCJ;;E4Hj9wCE;IACC,gBvHuNK;EL6vwCR;E4Hj9wCG;IACC,gCAAA;E5Hm9wCJ;;E4H78wCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELqwwCR;;E4H38wCE;IACC,qBvHqMK;IuHpML,sBvHoMK;EL0wwCR;E4H38wCG;IACC,gCAAA;E5H68wCJ;;E4Ht8wCG;IACI,qBvHwLC;ELixwCR;E4Ht8wCG;IACI,sBvHoLC;ELoxwCR;E4Hp8wCG;IACC,gCAAA;E5Hs8wCJ;;E4H/+wCE;IACC,evHuNK;EL2xwCR;E4H/+wCG;IACC,+BAAA;E5Hi/wCJ;;E4H3+wCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;ELmywCR;;E4Hz+wCE;IACC,oBvHqMK;IuHpML,qBvHoMK;ELwywCR;E4Hz+wCG;IACC,+BAAA;E5H2+wCJ;;E4Hp+wCG;IACI,oBvHwLC;EL+ywCR;E4Hp+wCG;IACI,qBvHoLC;ELkzwCR;E4Hl+wCG;IACC,+BAAA;E5Ho+wCJ;;E4H7gxCE;IACC,gBvHuNK;ELyzwCR;E4H7gxCG;IACC,gCAAA;E5H+gxCJ;;E4HzgxCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELi0wCR;;E4HvgxCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELs0wCR;E4HvgxCG;IACC,gCAAA;E5HygxCJ;;E4HlgxCG;IACI,qBvHwLC;EL60wCR;E4HlgxCG;IACI,sBvHoLC;ELg1wCR;E4HhgxCG;IACC,gCAAA;E5HkgxCJ;;E4H3ixCE;IACC,avHuNK;ELu1wCR;E4H3ixCG;IACC,6BAAA;E5H6ixCJ;;E4HvixCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;EL+1wCR;;E4HrixCE;IACC,kBvHqMK;IuHpML,mBvHoMK;ELo2wCR;E4HrixCG;IACC,6BAAA;E5HuixCJ;;E4HhixCG;IACI,kBvHwLC;EL22wCR;E4HhixCG;IACI,mBvHoLC;EL82wCR;E4H9hxCG;IACC,6BAAA;E5HgixCJ;;E4HzkxCE;IACC,gBvHuNK;ELq3wCR;E4HzkxCG;IACC,gCAAA;E5H2kxCJ;;E4HrkxCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;EL63wCR;;E4HnkxCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELk4wCR;E4HnkxCG;IACC,gCAAA;E5HqkxCJ;;E4H9jxCG;IACI,qBvHwLC;ELy4wCR;E4H9jxCG;IACI,sBvHoLC;EL44wCR;E4H5jxCG;IACC,gCAAA;E5H8jxCJ;;E4HvmxCE;IACC,evHuNK;ELm5wCR;E4HvmxCG;IACC,+BAAA;E5HymxCJ;;E4HnmxCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;EL25wCR;;E4HjmxCE;IACC,oBvHqMK;IuHpML,qBvHoMK;ELg6wCR;E4HjmxCG;IACC,+BAAA;E5HmmxCJ;;E4H5lxCG;IACI,oBvHwLC;ELu6wCR;E4H5lxCG;IACI,qBvHoLC;EL06wCR;E4H1lxCG;IACC,+BAAA;E5H4lxCJ;AACF;Ae1wxCI;E6GoIA;IACC,avHuNK;ELk7wCR;E4HtoxCG;IACC,6BAAA;E5HwoxCJ;;E4HloxCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;EL07wCR;;E4HhoxCE;IACC,kBvHqMK;IuHpML,mBvHoMK;EL+7wCR;E4HhoxCG;IACC,6BAAA;E5HkoxCJ;;E4H3nxCG;IACI,kBvHwLC;ELs8wCR;E4H3nxCG;IACI,mBvHoLC;ELy8wCR;E4HznxCG;IACC,6BAAA;E5H2nxCJ;;E4HpqxCE;IACC,gBvHuNK;ELg9wCR;E4HpqxCG;IACC,gCAAA;E5HsqxCJ;;E4HhqxCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELw9wCR;;E4H9pxCE;IACC,qBvHqMK;IuHpML,sBvHoMK;EL69wCR;E4H9pxCG;IACC,gCAAA;E5HgqxCJ;;E4HzpxCG;IACI,qBvHwLC;ELo+wCR;E4HzpxCG;IACI,sBvHoLC;ELu+wCR;E4HvpxCG;IACC,gCAAA;E5HypxCJ;;E4HlsxCE;IACC,evHuNK;EL8+wCR;E4HlsxCG;IACC,+BAAA;E5HosxCJ;;E4H9rxCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;ELs/wCR;;E4H5rxCE;IACC,oBvHqMK;IuHpML,qBvHoMK;EL2/wCR;E4H5rxCG;IACC,+BAAA;E5H8rxCJ;;E4HvrxCG;IACI,oBvHwLC;ELkgxCR;E4HvrxCG;IACI,qBvHoLC;ELqgxCR;E4HrrxCG;IACC,+BAAA;E5HurxCJ;;E4HhuxCE;IACC,gBvHuNK;EL4gxCR;E4HhuxCG;IACC,gCAAA;E5HkuxCJ;;E4H5txCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELohxCR;;E4H1txCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELyhxCR;E4H1txCG;IACC,gCAAA;E5H4txCJ;;E4HrtxCG;IACI,qBvHwLC;ELgixCR;E4HrtxCG;IACI,sBvHoLC;ELmixCR;E4HntxCG;IACC,gCAAA;E5HqtxCJ;;E4H9vxCE;IACC,avHuNK;EL0ixCR;E4H9vxCG;IACC,6BAAA;E5HgwxCJ;;E4H1vxCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;ELkjxCR;;E4HxvxCE;IACC,kBvHqMK;IuHpML,mBvHoMK;ELujxCR;E4HxvxCG;IACC,6BAAA;E5H0vxCJ;;E4HnvxCG;IACI,kBvHwLC;EL8jxCR;E4HnvxCG;IACI,mBvHoLC;ELikxCR;E4HjvxCG;IACC,6BAAA;E5HmvxCJ;;E4H5xxCE;IACC,gBvHuNK;ELwkxCR;E4H5xxCG;IACC,gCAAA;E5H8xxCJ;;E4HxxxCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELglxCR;;E4HtxxCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELqlxCR;E4HtxxCG;IACC,gCAAA;E5HwxxCJ;;E4HjxxCG;IACI,qBvHwLC;EL4lxCR;E4HjxxCG;IACI,sBvHoLC;EL+lxCR;E4H/wxCG;IACC,gCAAA;E5HixxCJ;;E4H1zxCE;IACC,evHuNK;ELsmxCR;E4H1zxCG;IACC,+BAAA;E5H4zxCJ;;E4HtzxCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;EL8mxCR;;E4HpzxCE;IACC,oBvHqMK;IuHpML,qBvHoMK;ELmnxCR;E4HpzxCG;IACC,+BAAA;E5HszxCJ;;E4H/yxCG;IACI,oBvHwLC;EL0nxCR;E4H/yxCG;IACI,qBvHoLC;EL6nxCR;E4H7yxCG;IACC,+BAAA;E5H+yxCJ;;E4Hx1xCE;IACC,gBvHuNK;ELooxCR;E4Hx1xCG;IACC,gCAAA;E5H01xCJ;;E4Hp1xCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;EL4oxCR;;E4Hl1xCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELipxCR;E4Hl1xCG;IACC,gCAAA;E5Ho1xCJ;;E4H70xCG;IACI,qBvHwLC;ELwpxCR;E4H70xCG;IACI,sBvHoLC;EL2pxCR;E4H30xCG;IACC,gCAAA;E5H60xCJ;;E4Ht3xCE;IACC,avHuNK;ELkqxCR;E4Ht3xCG;IACC,6BAAA;E5Hw3xCJ;;E4Hl3xCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;EL0qxCR;;E4Hh3xCE;IACC,kBvHqMK;IuHpML,mBvHoMK;EL+qxCR;E4Hh3xCG;IACC,6BAAA;E5Hk3xCJ;;E4H32xCG;IACI,kBvHwLC;ELsrxCR;E4H32xCG;IACI,mBvHoLC;ELyrxCR;E4Hz2xCG;IACC,6BAAA;E5H22xCJ;;E4Hp5xCE;IACC,gBvHuNK;ELgsxCR;E4Hp5xCG;IACC,gCAAA;E5Hs5xCJ;;E4Hh5xCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELwsxCR;;E4H94xCE;IACC,qBvHqMK;IuHpML,sBvHoMK;EL6sxCR;E4H94xCG;IACC,gCAAA;E5Hg5xCJ;;E4Hz4xCG;IACI,qBvHwLC;ELotxCR;E4Hz4xCG;IACI,sBvHoLC;ELutxCR;E4Hv4xCG;IACC,gCAAA;E5Hy4xCJ;;E4Hl7xCE;IACC,evHuNK;EL8txCR;E4Hl7xCG;IACC,+BAAA;E5Ho7xCJ;;E4H96xCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;ELsuxCR;;E4H56xCE;IACC,oBvHqMK;IuHpML,qBvHoMK;EL2uxCR;E4H56xCG;IACC,+BAAA;E5H86xCJ;;E4Hv6xCG;IACI,oBvHwLC;ELkvxCR;E4Hv6xCG;IACI,qBvHoLC;ELqvxCR;E4Hr6xCG;IACC,+BAAA;E5Hu6xCJ;AACF;AerlyCI;E6GoIA;IACC,avHuNK;EL6vxCR;E4Hj9xCG;IACC,6BAAA;E5Hm9xCJ;;E4H78xCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;ELqwxCR;;E4H38xCE;IACC,kBvHqMK;IuHpML,mBvHoMK;EL0wxCR;E4H38xCG;IACC,6BAAA;E5H68xCJ;;E4Ht8xCG;IACI,kBvHwLC;ELixxCR;E4Ht8xCG;IACI,mBvHoLC;ELoxxCR;E4Hp8xCG;IACC,6BAAA;E5Hs8xCJ;;E4H/+xCE;IACC,gBvHuNK;EL2xxCR;E4H/+xCG;IACC,gCAAA;E5Hi/xCJ;;E4H3+xCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELmyxCR;;E4Hz+xCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELwyxCR;E4Hz+xCG;IACC,gCAAA;E5H2+xCJ;;E4Hp+xCG;IACI,qBvHwLC;EL+yxCR;E4Hp+xCG;IACI,sBvHoLC;ELkzxCR;E4Hl+xCG;IACC,gCAAA;E5Ho+xCJ;;E4H7gyCE;IACC,evHuNK;ELyzxCR;E4H7gyCG;IACC,+BAAA;E5H+gyCJ;;E4HzgyCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;ELi0xCR;;E4HvgyCE;IACC,oBvHqMK;IuHpML,qBvHoMK;ELs0xCR;E4HvgyCG;IACC,+BAAA;E5HygyCJ;;E4HlgyCG;IACI,oBvHwLC;EL60xCR;E4HlgyCG;IACI,qBvHoLC;ELg1xCR;E4HhgyCG;IACC,+BAAA;E5HkgyCJ;;E4H3iyCE;IACC,gBvHuNK;ELu1xCR;E4H3iyCG;IACC,gCAAA;E5H6iyCJ;;E4HviyCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;EL+1xCR;;E4HriyCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELo2xCR;E4HriyCG;IACC,gCAAA;E5HuiyCJ;;E4HhiyCG;IACI,qBvHwLC;EL22xCR;E4HhiyCG;IACI,sBvHoLC;EL82xCR;E4H9hyCG;IACC,gCAAA;E5HgiyCJ;;E4HzkyCE;IACC,avHuNK;ELq3xCR;E4HzkyCG;IACC,6BAAA;E5H2kyCJ;;E4HrkyCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;EL63xCR;;E4HnkyCE;IACC,kBvHqMK;IuHpML,mBvHoMK;ELk4xCR;E4HnkyCG;IACC,6BAAA;E5HqkyCJ;;E4H9jyCG;IACI,kBvHwLC;ELy4xCR;E4H9jyCG;IACI,mBvHoLC;EL44xCR;E4H5jyCG;IACC,6BAAA;E5H8jyCJ;;E4HvmyCE;IACC,gBvHuNK;ELm5xCR;E4HvmyCG;IACC,gCAAA;E5HymyCJ;;E4HnmyCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;EL25xCR;;E4HjmyCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELg6xCR;E4HjmyCG;IACC,gCAAA;E5HmmyCJ;;E4H5lyCG;IACI,qBvHwLC;ELu6xCR;E4H5lyCG;IACI,sBvHoLC;EL06xCR;E4H1lyCG;IACC,gCAAA;E5H4lyCJ;;E4HroyCE;IACC,evHuNK;ELi7xCR;E4HroyCG;IACC,+BAAA;E5HuoyCJ;;E4HjoyCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;ELy7xCR;;E4H/nyCE;IACC,oBvHqMK;IuHpML,qBvHoMK;EL87xCR;E4H/nyCG;IACC,+BAAA;E5HioyCJ;;E4H1nyCG;IACI,oBvHwLC;ELq8xCR;E4H1nyCG;IACI,qBvHoLC;ELw8xCR;E4HxnyCG;IACC,+BAAA;E5H0nyCJ;;E4HnqyCE;IACC,gBvHuNK;EL+8xCR;E4HnqyCG;IACC,gCAAA;E5HqqyCJ;;E4H/pyCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELu9xCR;;E4H7pyCE;IACC,qBvHqMK;IuHpML,sBvHoMK;EL49xCR;E4H7pyCG;IACC,gCAAA;E5H+pyCJ;;E4HxpyCG;IACI,qBvHwLC;ELm+xCR;E4HxpyCG;IACI,sBvHoLC;ELs+xCR;E4HtpyCG;IACC,gCAAA;E5HwpyCJ;;E4HjsyCE;IACC,avHuNK;EL6+xCR;E4HjsyCG;IACC,6BAAA;E5HmsyCJ;;E4H7ryCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;ELq/xCR;;E4H3ryCE;IACC,kBvHqMK;IuHpML,mBvHoMK;EL0/xCR;E4H3ryCG;IACC,6BAAA;E5H6ryCJ;;E4HtryCG;IACI,kBvHwLC;ELigyCR;E4HtryCG;IACI,mBvHoLC;ELogyCR;E4HpryCG;IACC,6BAAA;E5HsryCJ;;E4H/tyCE;IACC,gBvHuNK;EL2gyCR;E4H/tyCG;IACC,gCAAA;E5HiuyCJ;;E4H3tyCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELmhyCR;;E4HztyCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELwhyCR;E4HztyCG;IACC,gCAAA;E5H2tyCJ;;E4HptyCG;IACI,qBvHwLC;EL+hyCR;E4HptyCG;IACI,sBvHoLC;ELkiyCR;E4HltyCG;IACC,gCAAA;E5HotyCJ;;E4H7vyCE;IACC,evHuNK;ELyiyCR;E4H7vyCG;IACC,+BAAA;E5H+vyCJ;;E4HzvyCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;ELijyCR;;E4HvvyCE;IACC,oBvHqMK;IuHpML,qBvHoMK;ELsjyCR;E4HvvyCG;IACC,+BAAA;E5HyvyCJ;;E4HlvyCG;IACI,oBvHwLC;EL6jyCR;E4HlvyCG;IACI,qBvHoLC;ELgkyCR;E4HhvyCG;IACC,+BAAA;E5HkvyCJ;AACF;Aeh6yCI;E6GoIA;IACC,avHuNK;ELwkyCR;E4H5xyCG;IACC,6BAAA;E5H8xyCJ;;E4HxxyCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;ELglyCR;;E4HtxyCE;IACC,kBvHqMK;IuHpML,mBvHoMK;ELqlyCR;E4HtxyCG;IACC,6BAAA;E5HwxyCJ;;E4HjxyCG;IACI,kBvHwLC;EL4lyCR;E4HjxyCG;IACI,mBvHoLC;EL+lyCR;E4H/wyCG;IACC,6BAAA;E5HixyCJ;;E4H1zyCE;IACC,gBvHuNK;ELsmyCR;E4H1zyCG;IACC,gCAAA;E5H4zyCJ;;E4HtzyCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;EL8myCR;;E4HpzyCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELmnyCR;E4HpzyCG;IACC,gCAAA;E5HszyCJ;;E4H/yyCG;IACI,qBvHwLC;EL0nyCR;E4H/yyCG;IACI,sBvHoLC;EL6nyCR;E4H7yyCG;IACC,gCAAA;E5H+yyCJ;;E4Hx1yCE;IACC,evHuNK;ELooyCR;E4Hx1yCG;IACC,+BAAA;E5H01yCJ;;E4Hp1yCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;EL4oyCR;;E4Hl1yCE;IACC,oBvHqMK;IuHpML,qBvHoMK;ELipyCR;E4Hl1yCG;IACC,+BAAA;E5Ho1yCJ;;E4H70yCG;IACI,oBvHwLC;ELwpyCR;E4H70yCG;IACI,qBvHoLC;EL2pyCR;E4H30yCG;IACC,+BAAA;E5H60yCJ;;E4Ht3yCE;IACC,gBvHuNK;ELkqyCR;E4Ht3yCG;IACC,gCAAA;E5Hw3yCJ;;E4Hl3yCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;EL0qyCR;;E4Hh3yCE;IACC,qBvHqMK;IuHpML,sBvHoMK;EL+qyCR;E4Hh3yCG;IACC,gCAAA;E5Hk3yCJ;;E4H32yCG;IACI,qBvHwLC;ELsryCR;E4H32yCG;IACI,sBvHoLC;ELyryCR;E4Hz2yCG;IACC,gCAAA;E5H22yCJ;;E4Hp5yCE;IACC,avHuNK;ELgsyCR;E4Hp5yCG;IACC,6BAAA;E5Hs5yCJ;;E4Hh5yCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;ELwsyCR;;E4H94yCE;IACC,kBvHqMK;IuHpML,mBvHoMK;EL6syCR;E4H94yCG;IACC,6BAAA;E5Hg5yCJ;;E4Hz4yCG;IACI,kBvHwLC;ELotyCR;E4Hz4yCG;IACI,mBvHoLC;ELutyCR;E4Hv4yCG;IACC,6BAAA;E5Hy4yCJ;;E4Hl7yCE;IACC,gBvHuNK;EL8tyCR;E4Hl7yCG;IACC,gCAAA;E5Ho7yCJ;;E4H96yCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELsuyCR;;E4H56yCE;IACC,qBvHqMK;IuHpML,sBvHoMK;EL2uyCR;E4H56yCG;IACC,gCAAA;E5H86yCJ;;E4Hv6yCG;IACI,qBvHwLC;ELkvyCR;E4Hv6yCG;IACI,sBvHoLC;ELqvyCR;E4Hr6yCG;IACC,gCAAA;E5Hu6yCJ;;E4Hh9yCE;IACC,evHuNK;EL4vyCR;E4Hh9yCG;IACC,+BAAA;E5Hk9yCJ;;E4H58yCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;ELowyCR;;E4H18yCE;IACC,oBvHqMK;IuHpML,qBvHoMK;ELywyCR;E4H18yCG;IACC,+BAAA;E5H48yCJ;;E4Hr8yCG;IACI,oBvHwLC;ELgxyCR;E4Hr8yCG;IACI,qBvHoLC;ELmxyCR;E4Hn8yCG;IACC,+BAAA;E5Hq8yCJ;;E4H9+yCE;IACC,gBvHuNK;EL0xyCR;E4H9+yCG;IACC,gCAAA;E5Hg/yCJ;;E4H1+yCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELkyyCR;;E4Hx+yCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELuyyCR;E4Hx+yCG;IACC,gCAAA;E5H0+yCJ;;E4Hn+yCG;IACI,qBvHwLC;EL8yyCR;E4Hn+yCG;IACI,sBvHoLC;ELizyCR;E4Hj+yCG;IACC,gCAAA;E5Hm+yCJ;;E4H5gzCE;IACC,avHuNK;ELwzyCR;E4H5gzCG;IACC,6BAAA;E5H8gzCJ;;E4HxgzCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;ELg0yCR;;E4HtgzCE;IACC,kBvHqMK;IuHpML,mBvHoMK;ELq0yCR;E4HtgzCG;IACC,6BAAA;E5HwgzCJ;;E4HjgzCG;IACI,kBvHwLC;EL40yCR;E4HjgzCG;IACI,mBvHoLC;EL+0yCR;E4H//yCG;IACC,6BAAA;E5HigzCJ;;E4H1izCE;IACC,gBvHuNK;ELs1yCR;E4H1izCG;IACC,gCAAA;E5H4izCJ;;E4HtizCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;EL81yCR;;E4HpizCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELm2yCR;E4HpizCG;IACC,gCAAA;E5HsizCJ;;E4H/hzCG;IACI,qBvHwLC;EL02yCR;E4H/hzCG;IACI,sBvHoLC;EL62yCR;E4H7hzCG;IACC,gCAAA;E5H+hzCJ;;E4HxkzCE;IACC,evHuNK;ELo3yCR;E4HxkzCG;IACC,+BAAA;E5H0kzCJ;;E4HpkzCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;EL43yCR;;E4HlkzCE;IACC,oBvHqMK;IuHpML,qBvHoMK;ELi4yCR;E4HlkzCG;IACC,+BAAA;E5HokzCJ;;E4H7jzCG;IACI,oBvHwLC;ELw4yCR;E4H7jzCG;IACI,qBvHoLC;EL24yCR;E4H3jzCG;IACC,+BAAA;E5H6jzCJ;AACF;Ae3uzCI;E6GoIA;IACC,avHuNK;ELm5yCR;E4HvmzCG;IACC,6BAAA;E5HymzCJ;;E4HnmzCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;EL25yCR;;E4HjmzCE;IACC,kBvHqMK;IuHpML,mBvHoMK;ELg6yCR;E4HjmzCG;IACC,6BAAA;E5HmmzCJ;;E4H5lzCG;IACI,kBvHwLC;ELu6yCR;E4H5lzCG;IACI,mBvHoLC;EL06yCR;E4H1lzCG;IACC,6BAAA;E5H4lzCJ;;E4HrozCE;IACC,gBvHuNK;ELi7yCR;E4HrozCG;IACC,gCAAA;E5HuozCJ;;E4HjozCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELy7yCR;;E4H/nzCE;IACC,qBvHqMK;IuHpML,sBvHoMK;EL87yCR;E4H/nzCG;IACC,gCAAA;E5HiozCJ;;E4H1nzCG;IACI,qBvHwLC;ELq8yCR;E4H1nzCG;IACI,sBvHoLC;ELw8yCR;E4HxnzCG;IACC,gCAAA;E5H0nzCJ;;E4HnqzCE;IACC,evHuNK;EL+8yCR;E4HnqzCG;IACC,+BAAA;E5HqqzCJ;;E4H/pzCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;ELu9yCR;;E4H7pzCE;IACC,oBvHqMK;IuHpML,qBvHoMK;EL49yCR;E4H7pzCG;IACC,+BAAA;E5H+pzCJ;;E4HxpzCG;IACI,oBvHwLC;ELm+yCR;E4HxpzCG;IACI,qBvHoLC;ELs+yCR;E4HtpzCG;IACC,+BAAA;E5HwpzCJ;;E4HjszCE;IACC,gBvHuNK;EL6+yCR;E4HjszCG;IACC,gCAAA;E5HmszCJ;;E4H7rzCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELq/yCR;;E4H3rzCE;IACC,qBvHqMK;IuHpML,sBvHoMK;EL0/yCR;E4H3rzCG;IACC,gCAAA;E5H6rzCJ;;E4HtrzCG;IACI,qBvHwLC;ELigzCR;E4HtrzCG;IACI,sBvHoLC;ELogzCR;E4HprzCG;IACC,gCAAA;E5HsrzCJ;;E4H/tzCE;IACC,avHuNK;EL2gzCR;E4H/tzCG;IACC,6BAAA;E5HiuzCJ;;E4H3tzCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;ELmhzCR;;E4HztzCE;IACC,kBvHqMK;IuHpML,mBvHoMK;ELwhzCR;E4HztzCG;IACC,6BAAA;E5H2tzCJ;;E4HptzCG;IACI,kBvHwLC;EL+hzCR;E4HptzCG;IACI,mBvHoLC;ELkizCR;E4HltzCG;IACC,6BAAA;E5HotzCJ;;E4H7vzCE;IACC,gBvHuNK;ELyizCR;E4H7vzCG;IACC,gCAAA;E5H+vzCJ;;E4HzvzCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELijzCR;;E4HvvzCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELsjzCR;E4HvvzCG;IACC,gCAAA;E5HyvzCJ;;E4HlvzCG;IACI,qBvHwLC;EL6jzCR;E4HlvzCG;IACI,sBvHoLC;ELgkzCR;E4HhvzCG;IACC,gCAAA;E5HkvzCJ;;E4H3xzCE;IACC,evHuNK;ELukzCR;E4H3xzCG;IACC,+BAAA;E5H6xzCJ;;E4HvxzCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;EL+kzCR;;E4HrxzCE;IACC,oBvHqMK;IuHpML,qBvHoMK;ELolzCR;E4HrxzCG;IACC,+BAAA;E5HuxzCJ;;E4HhxzCG;IACI,oBvHwLC;EL2lzCR;E4HhxzCG;IACI,qBvHoLC;EL8lzCR;E4H9wzCG;IACC,+BAAA;E5HgxzCJ;;E4HzzzCE;IACC,gBvHuNK;ELqmzCR;E4HzzzCG;IACC,gCAAA;E5H2zzCJ;;E4HrzzCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;EL6mzCR;;E4HnzzCE;IACC,qBvHqMK;IuHpML,sBvHoMK;ELknzCR;E4HnzzCG;IACC,gCAAA;E5HqzzCJ;;E4H9yzCG;IACI,qBvHwLC;ELynzCR;E4H9yzCG;IACI,sBvHoLC;EL4nzCR;E4H5yzCG;IACC,gCAAA;E5H8yzCJ;;E4Hv1zCE;IACC,avHuNK;ELmozCR;E4Hv1zCG;IACC,6BAAA;E5Hy1zCJ;;E4Hn1zCE;IACC,iBvH4MK;IuH3ML,oBvH2MK;EL2ozCR;;E4Hj1zCE;IACC,kBvHqMK;IuHpML,mBvHoMK;ELgpzCR;E4Hj1zCG;IACC,6BAAA;E5Hm1zCJ;;E4H50zCG;IACI,kBvHwLC;ELupzCR;E4H50zCG;IACI,mBvHoLC;EL0pzCR;E4H10zCG;IACC,6BAAA;E5H40zCJ;;E4Hr3zCE;IACC,gBvHuNK;ELiqzCR;E4Hr3zCG;IACC,gCAAA;E5Hu3zCJ;;E4Hj3zCE;IACC,oBvH4MK;IuH3ML,uBvH2MK;ELyqzCR;;E4H/2zCE;IACC,qBvHqMK;IuHpML,sBvHoMK;EL8qzCR;E4H/2zCG;IACC,gCAAA;E5Hi3zCJ;;E4H12zCG;IACI,qBvHwLC;ELqrzCR;E4H12zCG;IACI,sBvHoLC;ELwrzCR;E4Hx2zCG;IACC,gCAAA;E5H02zCJ;;E4Hn5zCE;IACC,evHuNK;EL+rzCR;E4Hn5zCG;IACC,+BAAA;E5Hq5zCJ;;E4H/4zCE;IACC,mBvH4MK;IuH3ML,sBvH2MK;ELuszCR;;E4H74zCE;IACC,oBvHqMK;IuHpML,qBvHoMK;EL4szCR;E4H74zCG;IACC,+BAAA;E5H+4zCJ;;E4Hx4zCG;IACI,oBvHwLC;ELmtzCR;E4Hx4zCG;IACI,qBvHoLC;ELstzCR;E4Ht4zCG;IACC,+BAAA;E5Hw4zCJ;AACF;A6H/m0CA;EACI,qCAAA;EACA,yDAAA;EACA,qDAAA;EACA,yDAAA;EACA,mDAAA;EACA,qDAAA;EACA,+CAAA;A7Hin0CJ;A6H/m0CI;EACI,exH4gCyB;EwH3gCzB,gBxH0gC2B;EwHzgC3B,8DAAA;A7Hin0CR;A6H9m0CI;EACI,kBAAA;EACA,YxHghCgC;EwH/gChC,cxHghCgC;EwH/gChC,cxH6gCgC;EwH5gChC,axH4gCgC;EwFh/BhC,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oCgClC4B;EhCsChC,qDAAA;EgCrCI,cAAA;EACA,sBAAA;A7Hsn0CR;A6Hpn0CQ;EACI,mCAAA;A7Hsn0CZ;A6Hnn0CQ;EACI,sBAAA;A7Hqn0CZ;;A6H/m0CA;ECrCI,oCDuCe;ECtCf,SAAA;A9Hwp0CJ;A8Hrp0CI;EACI,oCDoCkB;ECnClB,yBDoCe;ECnCf,uCDiCe;A7Hsn0CvB;A8Hnp0CI;EACI,yBD+Ba;A7Hsn0CrB;A8H/o0CY;EACI,oCDyBY;A7Hwn0C5B;A8H9o0CY;EACI,oCDsBM;A7H0n0CtB;A8Hzo0CY;EACI,sCDaY;A7H8n0C5B;A8Hxo0CY;EACI,sCDUM;A7Hgo0CtB;A8Hno0CY;EACI,uCDCY;A7Hoo0C5B;A8Hlo0CY;EACI,uCDFM;A7Hso0CtB;A8H/n0CQ;EACI,uCDZc;A7H6o0C1B;A8H3n0CY;EACI,qCDhBY;A7H6o0C5B;A8H1n0CY;EACI,qCDnBM;A7H+o0CtB;;A+H3r0CA;EACI,2CAAA;EACA,qCAAA;EACA,+CAAA;A/H8r0CJ;A+H5r0CI;EACI,wCAAA;A/H8r0CR;A+H1r0CQ;EACC,mBAAA;EACJ,eAAA;A/H4r0CL;AgIzs0CI;EACI,6BDoBY;ECnBZ,gCDkBe;A/Hyr0CvB;AgIrs0CY;EACI,gCDaU;A/H0r0C1B;AgIhs0CY;EACI,kCDKU;A/H6r0C1B;AgI3r0CY;EACI,mCDHU;A/Hgs0C1B;AgItr0CY;EACI,iCDXU;A/Hms0C1B;;AiIzt0CA;EACC,+CAAA;EACA,yCAAA;EACA,6DAAA;EACA,mDAAA;EACA,oDAAA;EACA,wDAAA;EACA,sEAAA;EACA,oFAAA;EACA,gFAAA;EACA,oEAAA;EACA,8DAAA;AjI4t0CD;AiIzt0CC;EACC,eAAA;AjI2t0CF;AiIrt0CE;EACC,aAAA;EACA,cAAA;EACA,gC7Hye2B;E6Hxe3B,wBAAA;EACA,mBAAA;EACA,uBAAA;AjIut0CH;AiIrt0CG;;EAEI,wBAAA;AjIut0CP;AiIjt0CG;EACC,gC7H2d0B;E6H1d1B,oBAAA;AjImt0CJ;AiIjt0CI;;EAEI,2BAAA;AjImt0CR;AiI1s0CE;EACC,SAAA;AjI4s0CH;AiIrs0CE;EACC,6BAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AjIus0CH;;AkIzw0CA;EACI,aAAA;AlI4w0CJ;;AkIzw0CA;EACI,aAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,a7Hy8CqB;E6Hx8CrB,+CAAA;EACA,2DAAA;EACA,uB7HiW4B;E6HhW5B,qB7H48CqB;ALg0xCzB;;AkIxw0CA;EACI,aAAA;EACA,yBAAA;EACA,SAAA;EACA,2BAAA;E5H+BA,yBAAA;EAMA,0BAAA;ANwu0CJ;AkIzw0CI;EACI,QAAA;EACA,yBAAA;AlI2w0CR;;AmIpy0CA;EACC,kBAAA;EACA,qBAAA;E7HWG,uBAAA;E6HTH,4BAAA;EACA,sBAAA;AnIuy0CD;AmIpy0CC;EACC,iCAAA;AnIsy0CF;AmIly0CC;EACC,YAAA;EACA,aAAA;E7HFE,uBAAA;E6HIF,4BAAA;EACA,sBAAA;AnIoy0CF;AmIhy0CC;EACC,eAAA;EACA,kBAAA;EACA,gCAAA;AnIky0CF;AmI9x0CC;EACC,UAAA;EACA,MAAA;AnIgy0CF;AmI9x0CE;EACC,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,UAAA;AnIgy0CH;AmI3x0CC;;EAEC,kBAAA;EACA,UAAA;EACA,SAAA;AnI6x0CF;AmI1x0CC;EACC,aAAA;AnI4x0CF;AmIvx0CE;EACC,aAAA;AnIyx0CH;AmItx0CE;EACC,aAAA;AnIwx0CH;AmIlx0CE;;EAEC,aAAA;AnIox0CH;AmI/w0CC;EACC,kBAAA;AnIix0CF;AmI9w0CE;EACC,kBAAA;AnIgx0CH;AmI5w0CE;EACC,UAAA;EACA,MAAA;EACA,+BAAA;AnI8w0CH;AmI1w0CE;;EAEC,UAAA;EACA,SAAA;EACA,kCAAA;AnI4w0CH;AmItw0CE;EACC,mCAAA;EACA,gCAAA;AnIww0CH;;AoI920CA;EACI,qBAAA;EACA,cAAA;EACA,kBAAA;E9HWA,uBAAA;ANu20CJ;AoI920CI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,kCAAA;EACA,sBAAA;E9HFJ,uBAAA;ANm30CJ;AoI920CQ;E9HLJ,uBAAA;ANs30CJ;AoI320CI;EACI,kBAAA;EACA,mBAAA;EACA,MAAA;EACA,SAAA;EACA,uDAAA;ApI620CR;AoIz20CI;EACI,WAAA;EACA,cAAA;EACA,qBAAA;E9HvBJ,uBAAA;ANm40CJ;AoIt20CQ;;;EAGI,2BAAA;ApIw20CZ;AoIl20CQ;;;EAGI,kBAAA;ApIo20CZ;AoIl20CY;;;EACI,kBAAA;ApIs20ChB;AqIh60CI;EACI,WD+DiB;EC9DjB,YD8DiB;ApIo20CzB;AqI/50CI;EACI,WD0DiB;ECzDjB,YDyDiB;ApIw20CzB;AqI750CQ;EACI,WDoDa;ECnDb,YDmDa;ApI420CzB;AqI550CQ;EACI,WD+Ca;EC9Cb,YD8Ca;EC7Cb,eAAA;ArI850CZ;AqIx50CQ;EACI,YDsCa;ECrCb,WAAA;ArI050CZ;AqIv50CQ;EACI,YDiCa;EChCb,WAAA;EACA,eAAA;ArIy50CZ;AqI170CI;EACI,WhIi1CO;EgIh1CP,YhIg1CO;AL4myCf;AqIz70CI;EACI,WhI40CO;EgI30CP,YhI20CO;ALgnyCf;AqIv70CQ;EACI,WhIs0CG;EgIr0CH,YhIq0CG;ALonyCf;AqIt70CQ;EACI,WhIi0CG;EgIh0CH,YhIg0CG;EgI/zCH,eAAA;ArIw70CZ;AqIl70CQ;EACI,YhIwzCG;EgIvzCH,WAAA;ArIo70CZ;AqIj70CQ;EACI,YhImzCG;EgIlzCH,WAAA;EACA,eAAA;ArIm70CZ;AqIp90CI;EACI,WhIi1CO;EgIh1CP,YhIg1CO;ALsoyCf;AqIn90CI;EACI,WhI40CO;EgI30CP,YhI20CO;AL0oyCf;AqIj90CQ;EACI,WhIs0CG;EgIr0CH,YhIq0CG;AL8oyCf;AqIh90CQ;EACI,WhIi0CG;EgIh0CH,YhIg0CG;EgI/zCH,eAAA;ArIk90CZ;AqI580CQ;EACI,YhIwzCG;EgIvzCH,aAAA;ArI880CZ;AqI380CQ;EACI,YhImzCG;EgIlzCH,aAAA;EACA,eAAA;ArI680CZ;AqI9+0CI;EACI,WhIi1CO;EgIh1CP,YhIg1CO;ALgqyCf;AqI7+0CI;EACI,WhI40CO;EgI30CP,YhI20CO;ALoqyCf;AqI3+0CQ;EACI,WhIs0CG;EgIr0CH,YhIq0CG;ALwqyCf;AqI1+0CQ;EACI,WhIi0CG;EgIh0CH,YhIg0CG;EgI/zCH,eAAA;ArI4+0CZ;AqIt+0CQ;EACI,YhIwzCG;EgIvzCH,WAAA;ArIw+0CZ;AqIr+0CQ;EACI,YhImzCG;EgIlzCH,WAAA;EACA,eAAA;ArIu+0CZ;AqIxg1CI;EACI,WhIi1CO;EgIh1CP,YhIg1CO;AL0ryCf;AqIvg1CI;EACI,WhI40CO;EgI30CP,YhI20CO;AL8ryCf;AqIrg1CQ;EACI,WhIs0CG;EgIr0CH,YhIq0CG;ALksyCf;AqIpg1CQ;EACI,WhIi0CG;EgIh0CH,YhIg0CG;EgI/zCH,eAAA;ArIsg1CZ;AqIhg1CQ;EACI,YhIwzCG;EgIvzCH,aAAA;ArIkg1CZ;AqI//0CQ;EACI,YhImzCG;EgIlzCH,aAAA;EACA,eAAA;ArIig1CZ;AqIli1CI;EACI,WhIi1CO;EgIh1CP,YhIg1CO;ALotyCf;AqIji1CI;EACI,WhI40CO;EgI30CP,YhI20CO;ALwtyCf;AqI/h1CQ;EACI,WhIs0CG;EgIr0CH,YhIq0CG;AL4tyCf;AqI9h1CQ;EACI,WhIi0CG;EgIh0CH,YhIg0CG;EgI/zCH,eAAA;ArIgi1CZ;AqI1h1CQ;EACI,YhIwzCG;EgIvzCH,WAAA;ArI4h1CZ;AqIzh1CQ;EACI,YhImzCG;EgIlzCH,WAAA;EACA,eAAA;ArI2h1CZ;AqI5j1CI;EACI,WhIi1CO;EgIh1CP,YhIg1CO;AL8uyCf;AqI3j1CI;EACI,WhI40CO;EgI30CP,YhI20CO;ALkvyCf;AqIzj1CQ;EACI,WhIs0CG;EgIr0CH,YhIq0CG;ALsvyCf;AqIxj1CQ;EACI,WhIi0CG;EgIh0CH,YhIg0CG;EgI/zCH,eAAA;ArI0j1CZ;AqIpj1CQ;EACI,YhIwzCG;EgIvzCH,aAAA;ArIsj1CZ;AqInj1CQ;EACI,YhImzCG;EgIlzCH,aAAA;EACA,eAAA;ArIqj1CZ;AqItl1CI;EACI,WhIi1CO;EgIh1CP,YhIg1CO;ALwwyCf;AqIrl1CI;EACI,WhI40CO;EgI30CP,YhI20CO;AL4wyCf;AqInl1CQ;EACI,WhIs0CG;EgIr0CH,YhIq0CG;ALgxyCf;AqIll1CQ;EACI,WhIi0CG;EgIh0CH,YhIg0CG;EgI/zCH,eAAA;ArIol1CZ;AqI9k1CQ;EACI,YhIwzCG;EgIvzCH,WAAA;ArIgl1CZ;AqI7k1CQ;EACI,YhImzCG;EgIlzCH,WAAA;EACA,eAAA;ArI+k1CZ;AqIhn1CI;EACI,WhIi1CO;EgIh1CP,YhIg1CO;ALkyyCf;AqI/m1CI;EACI,WhI40CO;EgI30CP,YhI20CO;ALsyyCf;AqI7m1CQ;EACI,WhIs0CG;EgIr0CH,YhIq0CG;AL0yyCf;AqI5m1CQ;EACI,WhIi0CG;EgIh0CH,YhIg0CG;EgI/zCH,eAAA;ArI8m1CZ;AqIxm1CQ;EACI,YhIwzCG;EgIvzCH,aAAA;ArI0m1CZ;AqIvm1CQ;EACI,YhImzCG;EgIlzCH,aAAA;EACA,eAAA;ArIym1CZ;AqI1o1CI;EACI,WhIi1CO;EgIh1CP,YhIg1CO;AL4zyCf;AqIzo1CI;EACI,WhI40CO;EgI30CP,YhI20CO;ALg0yCf;AqIvo1CQ;EACI,WhIs0CG;EgIr0CH,YhIq0CG;ALo0yCf;AqIto1CQ;EACI,WhIi0CG;EgIh0CH,YhIg0CG;EgI/zCH,eAAA;ArIwo1CZ;AqIlo1CQ;EACI,YhIwzCG;EgIvzCH,WAAA;ArIoo1CZ;AqIjo1CQ;EACI,YhImzCG;EgIlzCH,WAAA;EACA,eAAA;ArImo1CZ;AqIpq1CI;EACI,WhIi1CO;EgIh1CP,YhIg1CO;ALs1yCf;AqInq1CI;EACI,WhI40CO;EgI30CP,YhI20CO;AL01yCf;AqIjq1CQ;EACI,WhIs0CG;EgIr0CH,YhIq0CG;AL81yCf;AqIhq1CQ;EACI,WhIi0CG;EgIh0CH,YhIg0CG;EgI/zCH,eAAA;ArIkq1CZ;AqI5p1CQ;EACI,YhIwzCG;EgIvzCH,aAAA;ArI8p1CZ;AqI3p1CQ;EACI,YhImzCG;EgIlzCH,aAAA;EACA,eAAA;ArI6p1CZ;AqI9r1CI;EACI,WhIi1CO;EgIh1CP,YhIg1CO;ALg3yCf;AqI7r1CI;EACI,WhI40CO;EgI30CP,YhI20CO;ALo3yCf;AqI3r1CQ;EACI,WhIs0CG;EgIr0CH,YhIq0CG;ALw3yCf;AqI1r1CQ;EACI,WhIi0CG;EgIh0CH,YhIg0CG;EgI/zCH,eAAA;ArI4r1CZ;AqItr1CQ;EACI,YhIwzCG;EgIvzCH,YAAA;ArIwr1CZ;AqIrr1CQ;EACI,YhImzCG;EgIlzCH,YAAA;EACA,eAAA;ArIur1CZ;AqIxt1CI;EACI,WhIi1CO;EgIh1CP,YhIg1CO;AL04yCf;AqIvt1CI;EACI,WhI40CO;EgI30CP,YhI20CO;AL84yCf;AqIrt1CQ;EACI,WhIs0CG;EgIr0CH,YhIq0CG;ALk5yCf;AqIpt1CQ;EACI,WhIi0CG;EgIh0CH,YhIg0CG;EgI/zCH,eAAA;ArIst1CZ;AqIht1CQ;EACI,YhIwzCG;EgIvzCH,cAAA;ArIkt1CZ;AqI/s1CQ;EACI,YhImzCG;EgIlzCH,cAAA;EACA,eAAA;ArIit1CZ;AqIlv1CI;EACI,WhIi1CO;EgIh1CP,YhIg1CO;ALo6yCf;AqIjv1CI;EACI,WhI40CO;EgI30CP,YhI20CO;ALw6yCf;AqI/u1CQ;EACI,WhIs0CG;EgIr0CH,YhIq0CG;AL46yCf;AqI9u1CQ;EACI,WhIi0CG;EgIh0CH,YhIg0CG;EgI/zCH,eAAA;ArIgv1CZ;AqI1u1CQ;EACI,YhIwzCG;EgIvzCH,YAAA;ArI4u1CZ;AqIzu1CQ;EACI,YhImzCG;EgIlzCH,YAAA;EACA,eAAA;ArI2u1CZ;AqI5w1CI;EACI,YhIi1CO;EgIh1CP,ahIg1CO;AL87yCf;AqI3w1CI;EACI,YhI40CO;EgI30CP,ahI20CO;ALk8yCf;AqIzw1CQ;EACI,YhIs0CG;EgIr0CH,ahIq0CG;ALs8yCf;AqIxw1CQ;EACI,YhIi0CG;EgIh0CH,ahIg0CG;EgI/zCH,eAAA;ArI0w1CZ;AqIpw1CQ;EACI,ahIwzCG;EgIvzCH,YAAA;ArIsw1CZ;AqInw1CQ;EACI,ahImzCG;EgIlzCH,YAAA;EACA,eAAA;ArIqw1CZ;AqIty1CI;EACI,YhIi1CO;EgIh1CP,ahIg1CO;ALw9yCf;AqIry1CI;EACI,YhI40CO;EgI30CP,ahI20CO;AL49yCf;AqIny1CQ;EACI,YhIs0CG;EgIr0CH,ahIq0CG;ALg+yCf;AqIly1CQ;EACI,YhIi0CG;EgIh0CH,ahIg0CG;EgI/zCH,eAAA;ArIoy1CZ;AqI9x1CQ;EACI,ahIwzCG;EgIvzCH,cAAA;ArIgy1CZ;AqI7x1CQ;EACI,ahImzCG;EgIlzCH,cAAA;EACA,eAAA;ArI+x1CZ;AqIh01CI;EACI,YhIi1CO;EgIh1CP,ahIg1CO;ALk/yCf;AqI/z1CI;EACI,YhI40CO;EgI30CP,ahI20CO;ALs/yCf;AqI7z1CQ;EACI,YhIs0CG;EgIr0CH,ahIq0CG;AL0/yCf;AqI5z1CQ;EACI,YhIi0CG;EgIh0CH,ahIg0CG;EgI/zCH,eAAA;ArI8z1CZ;AqIxz1CQ;EACI,ahIwzCG;EgIvzCH,YAAA;ArI0z1CZ;AqIvz1CQ;EACI,ahImzCG;EgIlzCH,YAAA;EACA,eAAA;ArIyz1CZ;AqI111CI;EACI,YhIi1CO;EgIh1CP,ahIg1CO;AL4gzCf;AqIz11CI;EACI,YhI40CO;EgI30CP,ahI20CO;ALghzCf;AqIv11CQ;EACI,YhIs0CG;EgIr0CH,ahIq0CG;ALohzCf;AqIt11CQ;EACI,YhIi0CG;EgIh0CH,ahIg0CG;EgI/zCH,eAAA;ArIw11CZ;AqIl11CQ;EACI,ahIwzCG;EgIvzCH,YAAA;ArIo11CZ;AqIj11CQ;EACI,ahImzCG;EgIlzCH,YAAA;EACA,eAAA;ArIm11CZ;AqIp31CI;EACI,YhIi1CO;EgIh1CP,ahIg1CO;ALsizCf;AqIn31CI;EACI,YhI40CO;EgI30CP,ahI20CO;AL0izCf;AqIj31CQ;EACI,YhIs0CG;EgIr0CH,ahIq0CG;AL8izCf;AqIh31CQ;EACI,YhIi0CG;EgIh0CH,ahIg0CG;EgI/zCH,eAAA;ArIk31CZ;AqI521CQ;EACI,ahIwzCG;EgIvzCH,cAAA;ArI821CZ;AqI321CQ;EACI,ahImzCG;EgIlzCH,cAAA;EACA,eAAA;ArI621CZ;AqI941CI;EACI,YhIi1CO;EgIh1CP,ahIg1CO;ALgkzCf;AqI741CI;EACI,YhI40CO;EgI30CP,ahI20CO;ALokzCf;AqI341CQ;EACI,YhIs0CG;EgIr0CH,ahIq0CG;ALwkzCf;AqI141CQ;EACI,YhIi0CG;EgIh0CH,ahIg0CG;EgI/zCH,eAAA;ArI441CZ;AqIt41CQ;EACI,ahIwzCG;EgIvzCH,YAAA;ArIw41CZ;AqIr41CQ;EACI,ahImzCG;EgIlzCH,YAAA;EACA,eAAA;ArIu41CZ;Ae921CI;EsH1DA;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL2lzCb;EqIx61CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL+lzCb;EqIt61CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELmmzCb;EqIr61CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIu61CV;EqIj61CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErIm61CV;EqIh61CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIk61CV;EqIn81CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELqnzCb;EqIl81CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELynzCb;EqIh81CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL6nzCb;EqI/71CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIi81CV;EqI371CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErI671CV;EqI171CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErI471CV;EqI791CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL+ozCb;EqI591CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELmpzCb;EqI191CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELupzCb;EqIz91CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI291CV;EqIr91CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErIu91CV;EqIp91CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIs91CV;EqIv/1CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELyqzCb;EqIt/1CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL6qzCb;EqIp/1CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELirzCb;EqIn/1CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIq/1CV;EqI/+1CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIi/1CV;EqI9+1CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIg/1CV;EqIjh2CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELmszCb;EqIhh2CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELuszCb;EqI9g2CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL2szCb;EqI7g2CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI+g2CV;EqIzg2CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErI2g2CV;EqIxg2CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErI0g2CV;EqI3i2CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL6tzCb;EqI1i2CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELiuzCb;EqIxi2CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELquzCb;EqIvi2CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIyi2CV;EqIni2CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIqi2CV;EqIli2CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIoi2CV;EqIrk2CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELuvzCb;EqIpk2CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL2vzCb;EqIlk2CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL+vzCb;EqIjk2CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErImk2CV;EqI7j2CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErI+j2CV;EqI5j2CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErI8j2CV;EqI/l2CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELixzCb;EqI9l2CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELqxzCb;EqI5l2CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELyxzCb;EqI3l2CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI6l2CV;EqIvl2CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIyl2CV;EqItl2CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIwl2CV;EqIzn2CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL2yzCb;EqIxn2CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL+yzCb;EqItn2CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELmzzCb;EqIrn2CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIun2CV;EqIjn2CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErImn2CV;EqIhn2CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIkn2CV;EqInp2CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELq0zCb;EqIlp2CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELy0zCb;EqIhp2CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL60zCb;EqI/o2CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIip2CV;EqI3o2CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErI6o2CV;EqI1o2CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErI4o2CV;EqI7q2CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL+1zCb;EqI5q2CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELm2zCb;EqI1q2CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELu2zCb;EqIzq2CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI2q2CV;EqIrq2CM;IACI,YhIwzCG;IgIvzCH,YAAA;ErIuq2CV;EqIpq2CM;IACI,YhImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIsq2CV;EqIvs2CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELy3zCb;EqIts2CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL63zCb;EqIps2CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELi4zCb;EqIns2CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIqs2CV;EqI/r2CM;IACI,YhIwzCG;IgIvzCH,cAAA;ErIis2CV;EqI9r2CM;IACI,YhImzCG;IgIlzCH,cAAA;IACA,eAAA;ErIgs2CV;EqIju2CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELm5zCb;EqIhu2CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELu5zCb;EqI9t2CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL25zCb;EqI7t2CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI+t2CV;EqIzt2CM;IACI,YhIwzCG;IgIvzCH,YAAA;ErI2t2CV;EqIxt2CM;IACI,YhImzCG;IgIlzCH,YAAA;IACA,eAAA;ErI0t2CV;EqI3v2CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL66zCb;EqI1v2CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELi7zCb;EqIxv2CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELq7zCb;EqIvv2CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIyv2CV;EqInv2CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIqv2CV;EqIlv2CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIov2CV;EqIrx2CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELu8zCb;EqIpx2CE;IACI,YhI40CO;IgI30CP,ahI20CO;EL28zCb;EqIlx2CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;EL+8zCb;EqIjx2CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErImx2CV;EqI7w2CM;IACI,ahIwzCG;IgIvzCH,cAAA;ErI+w2CV;EqI5w2CM;IACI,ahImzCG;IgIlzCH,cAAA;IACA,eAAA;ErI8w2CV;EqI/y2CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELi+zCb;EqI9y2CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELq+zCb;EqI5y2CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELy+zCb;EqI3y2CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErI6y2CV;EqIvy2CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIyy2CV;EqIty2CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIwy2CV;EqIz02CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL2/zCb;EqIx02CE;IACI,YhI40CO;IgI30CP,ahI20CO;EL+/zCb;EqIt02CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELmg0Cb;EqIr02CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIu02CV;EqIj02CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIm02CV;EqIh02CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIk02CV;EqIn22CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELqh0Cb;EqIl22CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELyh0Cb;EqIh22CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;EL6h0Cb;EqI/12CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIi22CV;EqI312CM;IACI,ahIwzCG;IgIvzCH,cAAA;ErI612CV;EqI112CM;IACI,ahImzCG;IgIlzCH,cAAA;IACA,eAAA;ErI412CV;EqI732CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL+i0Cb;EqI532CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELmj0Cb;EqI132CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELuj0Cb;EqIz32CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErI232CV;EqIr32CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIu32CV;EqIp32CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIs32CV;AACF;Ae912CI;EsH1DA;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL2k0Cb;EqIx52CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL+k0Cb;EqIt52CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELml0Cb;EqIr52CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIu52CV;EqIj52CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErIm52CV;EqIh52CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIk52CV;EqIn72CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELqm0Cb;EqIl72CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELym0Cb;EqIh72CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL6m0Cb;EqI/62CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIi72CV;EqI362CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErI662CV;EqI162CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErI462CV;EqI782CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL+n0Cb;EqI582CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELmo0Cb;EqI182CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELuo0Cb;EqIz82CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI282CV;EqIr82CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErIu82CV;EqIp82CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIs82CV;EqIv+2CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELyp0Cb;EqIt+2CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL6p0Cb;EqIp+2CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELiq0Cb;EqIn+2CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIq+2CV;EqI/92CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIi+2CV;EqI992CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIg+2CV;EqIjg3CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELmr0Cb;EqIhg3CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELur0Cb;EqI9/2CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL2r0Cb;EqI7/2CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI+/2CV;EqIz/2CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErI2/2CV;EqIx/2CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErI0/2CV;EqI3h3CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL6s0Cb;EqI1h3CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELit0Cb;EqIxh3CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELqt0Cb;EqIvh3CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIyh3CV;EqInh3CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIqh3CV;EqIlh3CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIoh3CV;EqIrj3CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELuu0Cb;EqIpj3CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL2u0Cb;EqIlj3CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL+u0Cb;EqIjj3CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErImj3CV;EqI7i3CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErI+i3CV;EqI5i3CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErI8i3CV;EqI/k3CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELiw0Cb;EqI9k3CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELqw0Cb;EqI5k3CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELyw0Cb;EqI3k3CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI6k3CV;EqIvk3CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIyk3CV;EqItk3CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIwk3CV;EqIzm3CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL2x0Cb;EqIxm3CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL+x0Cb;EqItm3CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELmy0Cb;EqIrm3CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIum3CV;EqIjm3CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErImm3CV;EqIhm3CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIkm3CV;EqIno3CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELqz0Cb;EqIlo3CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELyz0Cb;EqIho3CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL6z0Cb;EqI/n3CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIio3CV;EqI3n3CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErI6n3CV;EqI1n3CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErI4n3CV;EqI7p3CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL+00Cb;EqI5p3CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELm10Cb;EqI1p3CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELu10Cb;EqIzp3CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI2p3CV;EqIrp3CM;IACI,YhIwzCG;IgIvzCH,YAAA;ErIup3CV;EqIpp3CM;IACI,YhImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIsp3CV;EqIvr3CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELy20Cb;EqItr3CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL620Cb;EqIpr3CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELi30Cb;EqInr3CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIqr3CV;EqI/q3CM;IACI,YhIwzCG;IgIvzCH,cAAA;ErIir3CV;EqI9q3CM;IACI,YhImzCG;IgIlzCH,cAAA;IACA,eAAA;ErIgr3CV;EqIjt3CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELm40Cb;EqIht3CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELu40Cb;EqI9s3CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL240Cb;EqI7s3CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI+s3CV;EqIzs3CM;IACI,YhIwzCG;IgIvzCH,YAAA;ErI2s3CV;EqIxs3CM;IACI,YhImzCG;IgIlzCH,YAAA;IACA,eAAA;ErI0s3CV;EqI3u3CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL650Cb;EqI1u3CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELi60Cb;EqIxu3CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELq60Cb;EqIvu3CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIyu3CV;EqInu3CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIqu3CV;EqIlu3CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIou3CV;EqIrw3CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELu70Cb;EqIpw3CE;IACI,YhI40CO;IgI30CP,ahI20CO;EL270Cb;EqIlw3CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;EL+70Cb;EqIjw3CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErImw3CV;EqI7v3CM;IACI,ahIwzCG;IgIvzCH,cAAA;ErI+v3CV;EqI5v3CM;IACI,ahImzCG;IgIlzCH,cAAA;IACA,eAAA;ErI8v3CV;EqI/x3CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELi90Cb;EqI9x3CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELq90Cb;EqI5x3CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELy90Cb;EqI3x3CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErI6x3CV;EqIvx3CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIyx3CV;EqItx3CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIwx3CV;EqIzz3CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL2+0Cb;EqIxz3CE;IACI,YhI40CO;IgI30CP,ahI20CO;EL++0Cb;EqItz3CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELm/0Cb;EqIrz3CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIuz3CV;EqIjz3CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErImz3CV;EqIhz3CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIkz3CV;EqIn13CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELqg1Cb;EqIl13CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELyg1Cb;EqIh13CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;EL6g1Cb;EqI/03CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIi13CV;EqI303CM;IACI,ahIwzCG;IgIvzCH,cAAA;ErI603CV;EqI103CM;IACI,ahImzCG;IgIlzCH,cAAA;IACA,eAAA;ErI403CV;EqI723CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL+h1Cb;EqI523CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELmi1Cb;EqI123CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELui1Cb;EqIz23CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErI223CV;EqIr23CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIu23CV;EqIp23CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIs23CV;AACF;Ae903CI;EsH1DA;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL2j1Cb;EqIx43CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL+j1Cb;EqIt43CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELmk1Cb;EqIr43CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIu43CV;EqIj43CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErIm43CV;EqIh43CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIk43CV;EqIn63CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELql1Cb;EqIl63CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELyl1Cb;EqIh63CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL6l1Cb;EqI/53CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIi63CV;EqI353CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErI653CV;EqI153CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErI453CV;EqI773CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL+m1Cb;EqI573CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELmn1Cb;EqI173CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELun1Cb;EqIz73CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI273CV;EqIr73CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErIu73CV;EqIp73CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIs73CV;EqIv93CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELyo1Cb;EqIt93CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL6o1Cb;EqIp93CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELip1Cb;EqIn93CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIq93CV;EqI/83CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIi93CV;EqI983CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIg93CV;EqIj/3CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELmq1Cb;EqIh/3CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELuq1Cb;EqI9+3CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL2q1Cb;EqI7+3CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI++3CV;EqIz+3CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErI2+3CV;EqIx+3CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErI0+3CV;EqI3g4CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL6r1Cb;EqI1g4CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELis1Cb;EqIxg4CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELqs1Cb;EqIvg4CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIyg4CV;EqIng4CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIqg4CV;EqIlg4CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIog4CV;EqIri4CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELut1Cb;EqIpi4CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL2t1Cb;EqIli4CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL+t1Cb;EqIji4CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErImi4CV;EqI7h4CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErI+h4CV;EqI5h4CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErI8h4CV;EqI/j4CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELiv1Cb;EqI9j4CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELqv1Cb;EqI5j4CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELyv1Cb;EqI3j4CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI6j4CV;EqIvj4CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIyj4CV;EqItj4CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIwj4CV;EqIzl4CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL2w1Cb;EqIxl4CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL+w1Cb;EqItl4CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELmx1Cb;EqIrl4CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIul4CV;EqIjl4CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErIml4CV;EqIhl4CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIkl4CV;EqInn4CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELqy1Cb;EqIln4CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELyy1Cb;EqIhn4CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL6y1Cb;EqI/m4CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIin4CV;EqI3m4CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErI6m4CV;EqI1m4CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErI4m4CV;EqI7o4CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL+z1Cb;EqI5o4CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELm01Cb;EqI1o4CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELu01Cb;EqIzo4CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI2o4CV;EqIro4CM;IACI,YhIwzCG;IgIvzCH,YAAA;ErIuo4CV;EqIpo4CM;IACI,YhImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIso4CV;EqIvq4CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELy11Cb;EqItq4CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL611Cb;EqIpq4CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELi21Cb;EqInq4CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIqq4CV;EqI/p4CM;IACI,YhIwzCG;IgIvzCH,cAAA;ErIiq4CV;EqI9p4CM;IACI,YhImzCG;IgIlzCH,cAAA;IACA,eAAA;ErIgq4CV;EqIjs4CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELm31Cb;EqIhs4CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELu31Cb;EqI9r4CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL231Cb;EqI7r4CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI+r4CV;EqIzr4CM;IACI,YhIwzCG;IgIvzCH,YAAA;ErI2r4CV;EqIxr4CM;IACI,YhImzCG;IgIlzCH,YAAA;IACA,eAAA;ErI0r4CV;EqI3t4CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL641Cb;EqI1t4CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELi51Cb;EqIxt4CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELq51Cb;EqIvt4CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIyt4CV;EqInt4CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIqt4CV;EqIlt4CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIot4CV;EqIrv4CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELu61Cb;EqIpv4CE;IACI,YhI40CO;IgI30CP,ahI20CO;EL261Cb;EqIlv4CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;EL+61Cb;EqIjv4CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErImv4CV;EqI7u4CM;IACI,ahIwzCG;IgIvzCH,cAAA;ErI+u4CV;EqI5u4CM;IACI,ahImzCG;IgIlzCH,cAAA;IACA,eAAA;ErI8u4CV;EqI/w4CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELi81Cb;EqI9w4CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELq81Cb;EqI5w4CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELy81Cb;EqI3w4CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErI6w4CV;EqIvw4CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIyw4CV;EqItw4CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIww4CV;EqIzy4CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL291Cb;EqIxy4CE;IACI,YhI40CO;IgI30CP,ahI20CO;EL+91Cb;EqIty4CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELm+1Cb;EqIry4CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIuy4CV;EqIjy4CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErImy4CV;EqIhy4CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIky4CV;EqIn04CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELq/1Cb;EqIl04CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELy/1Cb;EqIh04CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;EL6/1Cb;EqI/z4CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIi04CV;EqI3z4CM;IACI,ahIwzCG;IgIvzCH,cAAA;ErI6z4CV;EqI1z4CM;IACI,ahImzCG;IgIlzCH,cAAA;IACA,eAAA;ErI4z4CV;EqI714CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL+g2Cb;EqI514CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELmh2Cb;EqI114CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELuh2Cb;EqIz14CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErI214CV;EqIr14CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIu14CV;EqIp14CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIs14CV;AACF;Ae9z4CI;EsH1DA;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL2i2Cb;EqIx34CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL+i2Cb;EqIt34CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELmj2Cb;EqIr34CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIu34CV;EqIj34CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErIm34CV;EqIh34CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIk34CV;EqIn54CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELqk2Cb;EqIl54CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELyk2Cb;EqIh54CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL6k2Cb;EqI/44CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIi54CV;EqI344CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErI644CV;EqI144CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErI444CV;EqI764CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL+l2Cb;EqI564CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELmm2Cb;EqI164CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELum2Cb;EqIz64CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI264CV;EqIr64CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErIu64CV;EqIp64CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIs64CV;EqIv84CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELyn2Cb;EqIt84CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL6n2Cb;EqIp84CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELio2Cb;EqIn84CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIq84CV;EqI/74CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIi84CV;EqI974CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIg84CV;EqIj+4CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELmp2Cb;EqIh+4CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELup2Cb;EqI994CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL2p2Cb;EqI794CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI+94CV;EqIz94CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErI294CV;EqIx94CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErI094CV;EqI3/4CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL6q2Cb;EqI1/4CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELir2Cb;EqIx/4CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELqr2Cb;EqIv/4CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIy/4CV;EqIn/4CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIq/4CV;EqIl/4CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIo/4CV;EqIrh5CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELus2Cb;EqIph5CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL2s2Cb;EqIlh5CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL+s2Cb;EqIjh5CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErImh5CV;EqI7g5CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErI+g5CV;EqI5g5CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErI8g5CV;EqI/i5CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELiu2Cb;EqI9i5CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELqu2Cb;EqI5i5CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELyu2Cb;EqI3i5CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI6i5CV;EqIvi5CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIyi5CV;EqIti5CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIwi5CV;EqIzk5CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL2v2Cb;EqIxk5CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL+v2Cb;EqItk5CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELmw2Cb;EqIrk5CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIuk5CV;EqIjk5CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErImk5CV;EqIhk5CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIkk5CV;EqInm5CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELqx2Cb;EqIlm5CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELyx2Cb;EqIhm5CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL6x2Cb;EqI/l5CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIim5CV;EqI3l5CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErI6l5CV;EqI1l5CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErI4l5CV;EqI7n5CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL+y2Cb;EqI5n5CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELmz2Cb;EqI1n5CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELuz2Cb;EqIzn5CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI2n5CV;EqIrn5CM;IACI,YhIwzCG;IgIvzCH,YAAA;ErIun5CV;EqIpn5CM;IACI,YhImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIsn5CV;EqIvp5CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELy02Cb;EqItp5CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL602Cb;EqIpp5CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELi12Cb;EqInp5CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIqp5CV;EqI/o5CM;IACI,YhIwzCG;IgIvzCH,cAAA;ErIip5CV;EqI9o5CM;IACI,YhImzCG;IgIlzCH,cAAA;IACA,eAAA;ErIgp5CV;EqIjr5CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELm22Cb;EqIhr5CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELu22Cb;EqI9q5CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL222Cb;EqI7q5CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI+q5CV;EqIzq5CM;IACI,YhIwzCG;IgIvzCH,YAAA;ErI2q5CV;EqIxq5CM;IACI,YhImzCG;IgIlzCH,YAAA;IACA,eAAA;ErI0q5CV;EqI3s5CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL632Cb;EqI1s5CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELi42Cb;EqIxs5CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELq42Cb;EqIvs5CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIys5CV;EqIns5CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIqs5CV;EqIls5CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIos5CV;EqIru5CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELu52Cb;EqIpu5CE;IACI,YhI40CO;IgI30CP,ahI20CO;EL252Cb;EqIlu5CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;EL+52Cb;EqIju5CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErImu5CV;EqI7t5CM;IACI,ahIwzCG;IgIvzCH,cAAA;ErI+t5CV;EqI5t5CM;IACI,ahImzCG;IgIlzCH,cAAA;IACA,eAAA;ErI8t5CV;EqI/v5CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELi72Cb;EqI9v5CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELq72Cb;EqI5v5CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELy72Cb;EqI3v5CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErI6v5CV;EqIvv5CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIyv5CV;EqItv5CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIwv5CV;EqIzx5CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL282Cb;EqIxx5CE;IACI,YhI40CO;IgI30CP,ahI20CO;EL+82Cb;EqItx5CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELm92Cb;EqIrx5CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIux5CV;EqIjx5CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErImx5CV;EqIhx5CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIkx5CV;EqInz5CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELq+2Cb;EqIlz5CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELy+2Cb;EqIhz5CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;EL6+2Cb;EqI/y5CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIiz5CV;EqI3y5CM;IACI,ahIwzCG;IgIvzCH,cAAA;ErI6y5CV;EqI1y5CM;IACI,ahImzCG;IgIlzCH,cAAA;IACA,eAAA;ErI4y5CV;EqI705CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL+/2Cb;EqI505CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELmg3Cb;EqI105CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELug3Cb;EqIz05CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErI205CV;EqIr05CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIu05CV;EqIp05CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIs05CV;AACF;Ae9y5CI;EsH1DA;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL2h3Cb;EqIx25CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL+h3Cb;EqIt25CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELmi3Cb;EqIr25CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIu25CV;EqIj25CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErIm25CV;EqIh25CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIk25CV;EqIn45CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELqj3Cb;EqIl45CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELyj3Cb;EqIh45CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL6j3Cb;EqI/35CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIi45CV;EqI335CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErI635CV;EqI135CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErI435CV;EqI755CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL+k3Cb;EqI555CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELml3Cb;EqI155CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELul3Cb;EqIz55CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI255CV;EqIr55CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErIu55CV;EqIp55CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIs55CV;EqIv75CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELym3Cb;EqIt75CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL6m3Cb;EqIp75CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELin3Cb;EqIn75CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIq75CV;EqI/65CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIi75CV;EqI965CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIg75CV;EqIj95CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELmo3Cb;EqIh95CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELuo3Cb;EqI985CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL2o3Cb;EqI785CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI+85CV;EqIz85CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErI285CV;EqIx85CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErI085CV;EqI3+5CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL6p3Cb;EqI1+5CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELiq3Cb;EqIx+5CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELqq3Cb;EqIv+5CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIy+5CV;EqIn+5CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIq+5CV;EqIl+5CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIo+5CV;EqIrg6CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELur3Cb;EqIpg6CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL2r3Cb;EqIlg6CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL+r3Cb;EqIjg6CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErImg6CV;EqI7/5CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErI+/5CV;EqI5/5CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErI8/5CV;EqI/h6CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELit3Cb;EqI9h6CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELqt3Cb;EqI5h6CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELyt3Cb;EqI3h6CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI6h6CV;EqIvh6CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErIyh6CV;EqIth6CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErIwh6CV;EqIzj6CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL2u3Cb;EqIxj6CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL+u3Cb;EqItj6CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELmv3Cb;EqIrj6CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIuj6CV;EqIjj6CM;IACI,YhIwzCG;IgIvzCH,WAAA;ErImj6CV;EqIhj6CM;IACI,YhImzCG;IgIlzCH,WAAA;IACA,eAAA;ErIkj6CV;EqInl6CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELqw3Cb;EqIll6CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELyw3Cb;EqIhl6CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL6w3Cb;EqI/k6CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIil6CV;EqI3k6CM;IACI,YhIwzCG;IgIvzCH,aAAA;ErI6k6CV;EqI1k6CM;IACI,YhImzCG;IgIlzCH,aAAA;IACA,eAAA;ErI4k6CV;EqI7m6CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;EL+x3Cb;EqI5m6CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELmy3Cb;EqI1m6CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELuy3Cb;EqIzm6CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI2m6CV;EqIrm6CM;IACI,YhIwzCG;IgIvzCH,YAAA;ErIum6CV;EqIpm6CM;IACI,YhImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIsm6CV;EqIvo6CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELyz3Cb;EqIto6CE;IACI,WhI40CO;IgI30CP,YhI20CO;EL6z3Cb;EqIpo6CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;ELi03Cb;EqIno6CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErIqo6CV;EqI/n6CM;IACI,YhIwzCG;IgIvzCH,cAAA;ErIio6CV;EqI9n6CM;IACI,YhImzCG;IgIlzCH,cAAA;IACA,eAAA;ErIgo6CV;EqIjq6CE;IACI,WhIi1CO;IgIh1CP,YhIg1CO;ELm13Cb;EqIhq6CE;IACI,WhI40CO;IgI30CP,YhI20CO;ELu13Cb;EqI9p6CM;IACI,WhIs0CG;IgIr0CH,YhIq0CG;EL213Cb;EqI7p6CM;IACI,WhIi0CG;IgIh0CH,YhIg0CG;IgI/zCH,eAAA;ErI+p6CV;EqIzp6CM;IACI,YhIwzCG;IgIvzCH,YAAA;ErI2p6CV;EqIxp6CM;IACI,YhImzCG;IgIlzCH,YAAA;IACA,eAAA;ErI0p6CV;EqI3r6CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL623Cb;EqI1r6CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELi33Cb;EqIxr6CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELq33Cb;EqIvr6CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIyr6CV;EqInr6CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIqr6CV;EqIlr6CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIor6CV;EqIrt6CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELu43Cb;EqIpt6CE;IACI,YhI40CO;IgI30CP,ahI20CO;EL243Cb;EqIlt6CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;EL+43Cb;EqIjt6CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErImt6CV;EqI7s6CM;IACI,ahIwzCG;IgIvzCH,cAAA;ErI+s6CV;EqI5s6CM;IACI,ahImzCG;IgIlzCH,cAAA;IACA,eAAA;ErI8s6CV;EqI/u6CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELi63Cb;EqI9u6CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELq63Cb;EqI5u6CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELy63Cb;EqI3u6CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErI6u6CV;EqIvu6CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIyu6CV;EqItu6CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIwu6CV;EqIzw6CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL273Cb;EqIxw6CE;IACI,YhI40CO;IgI30CP,ahI20CO;EL+73Cb;EqItw6CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELm83Cb;EqIrw6CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIuw6CV;EqIjw6CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErImw6CV;EqIhw6CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIkw6CV;EqIny6CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;ELq93Cb;EqIly6CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELy93Cb;EqIhy6CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;EL693Cb;EqI/x6CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErIiy6CV;EqI3x6CM;IACI,ahIwzCG;IgIvzCH,cAAA;ErI6x6CV;EqI1x6CM;IACI,ahImzCG;IgIlzCH,cAAA;IACA,eAAA;ErI4x6CV;EqI7z6CE;IACI,YhIi1CO;IgIh1CP,ahIg1CO;EL++3Cb;EqI5z6CE;IACI,YhI40CO;IgI30CP,ahI20CO;ELm/3Cb;EqI1z6CM;IACI,YhIs0CG;IgIr0CH,ahIq0CG;ELu/3Cb;EqIzz6CM;IACI,YhIi0CG;IgIh0CH,ahIg0CG;IgI/zCH,eAAA;ErI2z6CV;EqIrz6CM;IACI,ahIwzCG;IgIvzCH,YAAA;ErIuz6CV;EqIpz6CM;IACI,ahImzCG;IgIlzCH,YAAA;IACA,eAAA;ErIsz6CV;AACF;;AoItw6CA;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;ApIyw6CJ;AoIvw6CI;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;ApIyw6CR;AoIvw6CQ;EACI,yBAAA;EACA,UAAA;ApIyw6CZ;AoIrw6CI;EACI,mCAAA;ApIuw6CR;AoIpw6CI;EACI,kBAAA;ApIsw6CR;AoIpw6CQ;EACI,cAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,+CAAA;EACsC,eAAA;EACtC,4BAAA;EAA8B,wCAAA;ApIww6C1C;AoInw6CQ;EACI,eAAA;ApIqw6CZ;;AsIh46CA;EACI,kBAAA;AtIm46CJ;AsI936CY;EACI,qBjIiHD;AL+w6Cf;AsIj46CY;EACI,qBjIiHD;ALkx6Cf;AsIp46CY;EACI,qBjIiHD;ALqx6Cf;AsIv46CY;EACI,qBjIiHD;ALwx6Cf;AsI146CY;EACI,qBjIiHD;AL2x6Cf;AsI746CY;EACI,qBjIiHD;AL8x6Cf;AsIh56CY;EACI,qBjIiHD;ALiy6Cf;AsIn56CY;EACI,qBjIiHD;ALoy6Cf;AsIt56CY;EACI,qBjIiHD;ALuy6Cf;;AsIl56CA;EACI,cAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,mCAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,gCAAA;AtIq56CJ;;AsIl56CA;EACI;IAAI,kCAAA;IAAoC,UAAA;EtIu56C1C;EsIt56CE;IAAK,kCAAA;IAAoC,UAAA;EtI056C3C;EsIz56CE;IAAK,UAAA;EtI456CP;EsI356CE;IAAM,kCAAA;IAAoC,UAAA;EtI+56C5C;AACF;AuIh86CA;;EAEI,2BAAA;AvIk86CJ;;AuI976CA;EACC,6BAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACG,aAAA;AvIi86CJ;AuI/76CC;EAEC,aAAA;EACA,uBAAA;EACG,mBAAA;AvIg86CL;;AwIr96CA;EACI,eAAA;EACA,aAAA;EACA,eAAA;EACA,YnI03CgB;EmIz3ChB,uBAAA;EACA,mBAAA;EACA,WnIk4Ca;EmIj4Cb,YnIi4Ca;EmIh4Cb,YCsFe;EDrFf,UCuFY;EDtFZ,8CAAA;EACA,0CAAA;EACA,UnIk3CgB;EmIj3ChB,2BnIyXc;ECxXd,uBAAA;ANw96CJ;AwIt96CI;EAEI,qCAAA;AxIu96CR;AsGx+6CI;EACI,YAAA;EACA,WAAA;AtG0+6CR;AwIx96CI;EACI,iBAAA;EACA,qCAAA;AxI096CR;AwIv96CI;EACI,oDAAA;AxIy96CR;AwIv96CQ;;EAEI,2CAAA;AxIy96CZ;AwIr96CI;EACI,uCAAA;EACA,8CAAA;EACA,aAAA;AxIu96CR;AwIr96CQ;EACI,2BnI6VM;EmI5VN,0CAAA;AxIu96CZ;;Ae176CI;EyHpBA;IACI,YC2CkB;ID1ClB,UC4Ce;ID3Cf,WnIm1CgB;ImIl1ChB,YnIk1CgB;ELgo4CtB;AACF;AwI986CA;EACI;IAAS,oBAAA;ExIi96CX;EwIh96CE;IAAM,gBAAA;ExIm96CR;AACF;A0Inh7CA;EACI,cAAA;EACA,2BAAA;A1Iqh7CJ;AsGrh7CI;EACI,eAAA;EACA,cAAA;AtGuh7CR;A0Iph7CQ;EACI,2BAAA;A1Ish7CZ;A0Ivh7CQ;EACI,6BAAA;A1Iyh7CZ;A0I1h7CQ;EACI,+BAAA;A1I4h7CZ;A0I7h7CQ;EACI,2BAAA;A1I+h7CZ;A0Ihi7CQ;EACI,6BAAA;A1Iki7CZ;A0Ini7CQ;EACI,0BAAA;A1Iqi7CZ;A0Iti7CQ;EACI,6BAAA;A1Iwi7CZ;A0Izi7CQ;EACI,4BAAA;A1I2i7CZ;A0I5i7CQ;EACI,0BAAA;A1I8i7CZ;A0I/i7CQ;EACI,2BAAA;A1Iij7CZ;A0Ilj7CQ;EACI,8BAAA;A1Ioj7CZ;A0Irj7CQ;EACI,8BAAA;A1Iuj7CZ;A0Ixj7CQ;EACI,8BAAA;A1I0j7CZ;A0I3j7CQ;EACI,8BAAA;A1I6j7CZ;A0I9j7CQ;EACI,8BAAA;A1Igk7CZ;A0Ijk7CQ;EACI,8BAAA;A1Imk7CZ;A0Ipk7CQ;EACI,8BAAA;A1Isk7CZ;A0Ivk7CQ;EACI,8BAAA;A1Iyk7CZ;A0I1k7CQ;EACI,8BAAA;A1I4k7CZ;AsGll7CI;EACI,0BAAA;EACA,yBAAA;AtGol7CR;AsGtl7CI;EACI,yBAAA;EACA,wBAAA;AtGwl7CR;AsG1l7CI;EACI,0BAAA;EACA,yBAAA;AtG4l7CR;AsG9l7CI;EACI,0BAAA;EACA,yBAAA;AtGgm7CR;AsGlm7CI;EACI,0BAAA;EACA,yBAAA;AtGom7CR;AsGtm7CI;EACI,2BAAA;EACA,0BAAA;AtGwm7CR;AsG1m7CI;EACI,0BAAA;EACA,yBAAA;AtG4m7CR;AsG9m7CI;EACI,0BAAA;EACA,yBAAA;AtGgn7CR;AsGln7CI;EACI,0BAAA;EACA,yBAAA;AtGon7CR;AsGtn7CI;EACI,yBAAA;EACA,wBAAA;AtGwn7CR;AsG1n7CI;EACI,uBAAA;EACA,sBAAA;AtG4n7CR;AsG9n7CI;EACI,uBAAA;EACA,sBAAA;AtGgo7CR;AsGlo7CI;EACI,uBAAA;EACA,sBAAA;AtGoo7CR;AsGto7CI;EACI,0BAAA;EACA,yBAAA;AtGwo7CR;AsG1o7CI;EACI,yBAAA;EACA,wBAAA;AtG4o7CR;AsG9o7CI;EACI,0BAAA;EACA,yBAAA;AtGgp7CR;AsGlp7CI;EACI,uBAAA;EACA,sBAAA;AtGop7CR;AsGtp7CI;EACI,0BAAA;EACA,yBAAA;AtGwp7CR;AsG1p7CI;EACI,yBAAA;EACA,wBAAA;AtG4p7CR;AsG9p7CI;EACI,0BAAA;EACA,yBAAA;AtGgq7CR;AsGlq7CI;EACI,uBAAA;EACA,sBAAA;AtGoq7CR;AsGtq7CI;EACI,0BAAA;EACA,yBAAA;AtGwq7CR;AsG1q7CI;EACI,yBAAA;EACA,wBAAA;AtG4q7CR;AsG9q7CI;EACI,0BAAA;EACA,yBAAA;AtGgr7CR;AsGlr7CI;EACI,uBAAA;EACA,sBAAA;AtGor7CR;AsGtr7CI;EACI,0BAAA;EACA,yBAAA;AtGwr7CR;AsG1r7CI;EACI,yBAAA;EACA,wBAAA;AtG4r7CR;AsG9r7CI;EACI,0BAAA;EACA,yBAAA;AtGgs7CR;Aezo7CI;EuFzDA;IACI,0BAAA;IACA,yBAAA;EtGqs7CN;EsGvs7CE;IACI,yBAAA;IACA,wBAAA;EtGys7CN;EsG3s7CE;IACI,0BAAA;IACA,yBAAA;EtG6s7CN;EsG/s7CE;IACI,0BAAA;IACA,yBAAA;EtGit7CN;EsGnt7CE;IACI,0BAAA;IACA,yBAAA;EtGqt7CN;EsGvt7CE;IACI,2BAAA;IACA,0BAAA;EtGyt7CN;EsG3t7CE;IACI,0BAAA;IACA,yBAAA;EtG6t7CN;EsG/t7CE;IACI,0BAAA;IACA,yBAAA;EtGiu7CN;EsGnu7CE;IACI,0BAAA;IACA,yBAAA;EtGqu7CN;EsGvu7CE;IACI,yBAAA;IACA,wBAAA;EtGyu7CN;EsG3u7CE;IACI,uBAAA;IACA,sBAAA;EtG6u7CN;EsG/u7CE;IACI,uBAAA;IACA,sBAAA;EtGiv7CN;EsGnv7CE;IACI,uBAAA;IACA,sBAAA;EtGqv7CN;EsGvv7CE;IACI,0BAAA;IACA,yBAAA;EtGyv7CN;EsG3v7CE;IACI,yBAAA;IACA,wBAAA;EtG6v7CN;EsG/v7CE;IACI,0BAAA;IACA,yBAAA;EtGiw7CN;EsGnw7CE;IACI,uBAAA;IACA,sBAAA;EtGqw7CN;EsGvw7CE;IACI,0BAAA;IACA,yBAAA;EtGyw7CN;EsG3w7CE;IACI,yBAAA;IACA,wBAAA;EtG6w7CN;EsG/w7CE;IACI,0BAAA;IACA,yBAAA;EtGix7CN;EsGnx7CE;IACI,uBAAA;IACA,sBAAA;EtGqx7CN;EsGvx7CE;IACI,0BAAA;IACA,yBAAA;EtGyx7CN;EsG3x7CE;IACI,yBAAA;IACA,wBAAA;EtG6x7CN;EsG/x7CE;IACI,0BAAA;IACA,yBAAA;EtGiy7CN;EsGny7CE;IACI,uBAAA;IACA,sBAAA;EtGqy7CN;EsGvy7CE;IACI,0BAAA;IACA,yBAAA;EtGyy7CN;EsG3y7CE;IACI,yBAAA;IACA,wBAAA;EtG6y7CN;EsG/y7CE;IACI,0BAAA;IACA,yBAAA;EtGiz7CN;AACF;Ae3v7CI;EuFzDA;IACI,0BAAA;IACA,yBAAA;EtGuz7CN;EsGzz7CE;IACI,yBAAA;IACA,wBAAA;EtG2z7CN;EsG7z7CE;IACI,0BAAA;IACA,yBAAA;EtG+z7CN;EsGj07CE;IACI,0BAAA;IACA,yBAAA;EtGm07CN;EsGr07CE;IACI,0BAAA;IACA,yBAAA;EtGu07CN;EsGz07CE;IACI,2BAAA;IACA,0BAAA;EtG207CN;EsG707CE;IACI,0BAAA;IACA,yBAAA;EtG+07CN;EsGj17CE;IACI,0BAAA;IACA,yBAAA;EtGm17CN;EsGr17CE;IACI,0BAAA;IACA,yBAAA;EtGu17CN;EsGz17CE;IACI,yBAAA;IACA,wBAAA;EtG217CN;EsG717CE;IACI,uBAAA;IACA,sBAAA;EtG+17CN;EsGj27CE;IACI,uBAAA;IACA,sBAAA;EtGm27CN;EsGr27CE;IACI,uBAAA;IACA,sBAAA;EtGu27CN;EsGz27CE;IACI,0BAAA;IACA,yBAAA;EtG227CN;EsG727CE;IACI,yBAAA;IACA,wBAAA;EtG+27CN;EsGj37CE;IACI,0BAAA;IACA,yBAAA;EtGm37CN;EsGr37CE;IACI,uBAAA;IACA,sBAAA;EtGu37CN;EsGz37CE;IACI,0BAAA;IACA,yBAAA;EtG237CN;EsG737CE;IACI,yBAAA;IACA,wBAAA;EtG+37CN;EsGj47CE;IACI,0BAAA;IACA,yBAAA;EtGm47CN;EsGr47CE;IACI,uBAAA;IACA,sBAAA;EtGu47CN;EsGz47CE;IACI,0BAAA;IACA,yBAAA;EtG247CN;EsG747CE;IACI,yBAAA;IACA,wBAAA;EtG+47CN;EsGj57CE;IACI,0BAAA;IACA,yBAAA;EtGm57CN;EsGr57CE;IACI,uBAAA;IACA,sBAAA;EtGu57CN;EsGz57CE;IACI,0BAAA;IACA,yBAAA;EtG257CN;EsG757CE;IACI,yBAAA;IACA,wBAAA;EtG+57CN;EsGj67CE;IACI,0BAAA;IACA,yBAAA;EtGm67CN;AACF;Ae727CI;EuFzDA;IACI,0BAAA;IACA,yBAAA;EtGy67CN;EsG367CE;IACI,yBAAA;IACA,wBAAA;EtG667CN;EsG/67CE;IACI,0BAAA;IACA,yBAAA;EtGi77CN;EsGn77CE;IACI,0BAAA;IACA,yBAAA;EtGq77CN;EsGv77CE;IACI,0BAAA;IACA,yBAAA;EtGy77CN;EsG377CE;IACI,2BAAA;IACA,0BAAA;EtG677CN;EsG/77CE;IACI,0BAAA;IACA,yBAAA;EtGi87CN;EsGn87CE;IACI,0BAAA;IACA,yBAAA;EtGq87CN;EsGv87CE;IACI,0BAAA;IACA,yBAAA;EtGy87CN;EsG387CE;IACI,yBAAA;IACA,wBAAA;EtG687CN;EsG/87CE;IACI,uBAAA;IACA,sBAAA;EtGi97CN;EsGn97CE;IACI,uBAAA;IACA,sBAAA;EtGq97CN;EsGv97CE;IACI,uBAAA;IACA,sBAAA;EtGy97CN;EsG397CE;IACI,0BAAA;IACA,yBAAA;EtG697CN;EsG/97CE;IACI,yBAAA;IACA,wBAAA;EtGi+7CN;EsGn+7CE;IACI,0BAAA;IACA,yBAAA;EtGq+7CN;EsGv+7CE;IACI,uBAAA;IACA,sBAAA;EtGy+7CN;EsG3+7CE;IACI,0BAAA;IACA,yBAAA;EtG6+7CN;EsG/+7CE;IACI,yBAAA;IACA,wBAAA;EtGi/7CN;EsGn/7CE;IACI,0BAAA;IACA,yBAAA;EtGq/7CN;EsGv/7CE;IACI,uBAAA;IACA,sBAAA;EtGy/7CN;EsG3/7CE;IACI,0BAAA;IACA,yBAAA;EtG6/7CN;EsG//7CE;IACI,yBAAA;IACA,wBAAA;EtGig8CN;EsGng8CE;IACI,0BAAA;IACA,yBAAA;EtGqg8CN;EsGvg8CE;IACI,uBAAA;IACA,sBAAA;EtGyg8CN;EsG3g8CE;IACI,0BAAA;IACA,yBAAA;EtG6g8CN;EsG/g8CE;IACI,yBAAA;IACA,wBAAA;EtGih8CN;EsGnh8CE;IACI,0BAAA;IACA,yBAAA;EtGqh8CN;AACF;Ae/97CI;EuFzDA;IACI,0BAAA;IACA,yBAAA;EtG2h8CN;EsG7h8CE;IACI,yBAAA;IACA,wBAAA;EtG+h8CN;EsGji8CE;IACI,0BAAA;IACA,yBAAA;EtGmi8CN;EsGri8CE;IACI,0BAAA;IACA,yBAAA;EtGui8CN;EsGzi8CE;IACI,0BAAA;IACA,yBAAA;EtG2i8CN;EsG7i8CE;IACI,2BAAA;IACA,0BAAA;EtG+i8CN;EsGjj8CE;IACI,0BAAA;IACA,yBAAA;EtGmj8CN;EsGrj8CE;IACI,0BAAA;IACA,yBAAA;EtGuj8CN;EsGzj8CE;IACI,0BAAA;IACA,yBAAA;EtG2j8CN;EsG7j8CE;IACI,yBAAA;IACA,wBAAA;EtG+j8CN;EsGjk8CE;IACI,uBAAA;IACA,sBAAA;EtGmk8CN;EsGrk8CE;IACI,uBAAA;IACA,sBAAA;EtGuk8CN;EsGzk8CE;IACI,uBAAA;IACA,sBAAA;EtG2k8CN;EsG7k8CE;IACI,0BAAA;IACA,yBAAA;EtG+k8CN;EsGjl8CE;IACI,yBAAA;IACA,wBAAA;EtGml8CN;EsGrl8CE;IACI,0BAAA;IACA,yBAAA;EtGul8CN;EsGzl8CE;IACI,uBAAA;IACA,sBAAA;EtG2l8CN;EsG7l8CE;IACI,0BAAA;IACA,yBAAA;EtG+l8CN;EsGjm8CE;IACI,yBAAA;IACA,wBAAA;EtGmm8CN;EsGrm8CE;IACI,0BAAA;IACA,yBAAA;EtGum8CN;EsGzm8CE;IACI,uBAAA;IACA,sBAAA;EtG2m8CN;EsG7m8CE;IACI,0BAAA;IACA,yBAAA;EtG+m8CN;EsGjn8CE;IACI,yBAAA;IACA,wBAAA;EtGmn8CN;EsGrn8CE;IACI,0BAAA;IACA,yBAAA;EtGun8CN;EsGzn8CE;IACI,uBAAA;IACA,sBAAA;EtG2n8CN;EsG7n8CE;IACI,0BAAA;IACA,yBAAA;EtG+n8CN;EsGjo8CE;IACI,yBAAA;IACA,wBAAA;EtGmo8CN;EsGro8CE;IACI,0BAAA;IACA,yBAAA;EtGuo8CN;AACF;Aejl8CI;EuFzDA;IACI,0BAAA;IACA,yBAAA;EtG6o8CN;EsG/o8CE;IACI,yBAAA;IACA,wBAAA;EtGip8CN;EsGnp8CE;IACI,0BAAA;IACA,yBAAA;EtGqp8CN;EsGvp8CE;IACI,0BAAA;IACA,yBAAA;EtGyp8CN;EsG3p8CE;IACI,0BAAA;IACA,yBAAA;EtG6p8CN;EsG/p8CE;IACI,2BAAA;IACA,0BAAA;EtGiq8CN;EsGnq8CE;IACI,0BAAA;IACA,yBAAA;EtGqq8CN;EsGvq8CE;IACI,0BAAA;IACA,yBAAA;EtGyq8CN;EsG3q8CE;IACI,0BAAA;IACA,yBAAA;EtG6q8CN;EsG/q8CE;IACI,yBAAA;IACA,wBAAA;EtGir8CN;EsGnr8CE;IACI,uBAAA;IACA,sBAAA;EtGqr8CN;EsGvr8CE;IACI,uBAAA;IACA,sBAAA;EtGyr8CN;EsG3r8CE;IACI,uBAAA;IACA,sBAAA;EtG6r8CN;EsG/r8CE;IACI,0BAAA;IACA,yBAAA;EtGis8CN;EsGns8CE;IACI,yBAAA;IACA,wBAAA;EtGqs8CN;EsGvs8CE;IACI,0BAAA;IACA,yBAAA;EtGys8CN;EsG3s8CE;IACI,uBAAA;IACA,sBAAA;EtG6s8CN;EsG/s8CE;IACI,0BAAA;IACA,yBAAA;EtGit8CN;EsGnt8CE;IACI,yBAAA;IACA,wBAAA;EtGqt8CN;EsGvt8CE;IACI,0BAAA;IACA,yBAAA;EtGyt8CN;EsG3t8CE;IACI,uBAAA;IACA,sBAAA;EtG6t8CN;EsG/t8CE;IACI,0BAAA;IACA,yBAAA;EtGiu8CN;EsGnu8CE;IACI,yBAAA;IACA,wBAAA;EtGqu8CN;EsGvu8CE;IACI,0BAAA;IACA,yBAAA;EtGyu8CN;EsG3u8CE;IACI,uBAAA;IACA,sBAAA;EtG6u8CN;EsG/u8CE;IACI,0BAAA;IACA,yBAAA;EtGiv8CN;EsGnv8CE;IACI,yBAAA;IACA,wBAAA;EtGqv8CN;EsGvv8CE;IACI,0BAAA;IACA,yBAAA;EtGyv8CN;AACF;;A2I1v8CQ;EACI,eAAA;EACA,YtIw/CI;EsIv/CJ,MAAA;EACA,OAAA;EACA,QAAA;A3I6v8CZ;;Ae3s8CI;E4HvDI;IACI,eAAA;IACA,YtIw/CI;IsIv/CJ,MAAA;IACA,OAAA;IACA,QAAA;E3Isw8CV;AACF;Aert8CI;E4HvDI;IACI,eAAA;IACA,YtIw/CI;IsIv/CJ,MAAA;IACA,OAAA;IACA,QAAA;E3I+w8CV;AACF;Ae9t8CI;E4HvDI;IACI,eAAA;IACA,YtIw/CI;IsIv/CJ,MAAA;IACA,OAAA;IACA,QAAA;E3Iwx8CV;AACF;Aevu8CI;E4HvDI;IACI,eAAA;IACA,YtIw/CI;IsIv/CJ,MAAA;IACA,OAAA;IACA,QAAA;E3Iiy8CV;AACF;Aehv8CI;E4HvDI;IACI,eAAA;IACA,YtIw/CI;IsIv/CJ,MAAA;IACA,OAAA;IACA,QAAA;E3I0y8CV;AACF;A4Ijz8CC;EACC,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,uBAAA;A5Imz8CF;A4Ihz8CG;EACC,YAAA;A5Ikz8CJ;A4I5y8CC;EACC,cAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qCAAA;A5I8y8CF;A4I1y8CC;EACC,UAAA;EACA,cAAA;EACA,kBAAA;A5I4y8CF;A4Ixy8CC;EACC,WAAA;EACA,cAAA;EACA,qBAAA;A5I0y8CF;A4Iry8CE;EACC,mBAAA;A5Iuy8CH;A4Ipy8CgB;EACI,QAAA;A5Isy8CpB;A4Ijy8CgB;EACI,WAAA;A5Imy8CpB;;A6I918CA;EACC,kBAAA;A7Ii28CD;A6I718CC;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;A7I+18CF;A6I318CC;EACC,aAAA;EACM,uBAAA;EACN,kBAAA;EACA,qBAAA;A7I618CF;A6I318CQ;EACI,gBAAA;A7I618CZ;A6Iz18CC;EACC,WAzBgB;EA0BhB,cAAA;EACA,kBAAA;EACA,yBAAA;A7I218CF;A6Ix18CC;EACC,cAAA;EACA,mCAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,8CAAA;A7I018CF;A6Ix18CE;EACC,cAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;EACA,oCAAA;A7I018CH;A6It18CC;EACC,YAAA;A7Iw18CF;;A8Ip58CA;EACI,kBAAA;A9Iu58CJ;A8Ir58CI;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,UAAA;A9Iu58CR;A8Ij58CQ;EACI,yBAAA;EACA,UAAA;A9Im58CZ;A8I/48CI;EACI,YAAA;A9Ii58CR;;A+I568CA;EACI,qBAAA;EACA,2CAAA;EzIYA,kBAAA;EyIVA,U1Ik3Ce;E0Ij3Cf,W1Ig3CgB;E0I/2ChB,cAAA;A/I+68CJ;;A+I368CA;EACI,U1Iy2Cc;E0Ix2Cd,W1Iw2Cc;E0Iv2Cd,8BAAA;A/I868CJ;;A+I168CA;EACI,U1Im2CgB;E0Il2ChB,W1Im2Ce;AL0k6CnB;;A+Iz68CA;EACI,U1Ii2CgB;E0Ih2ChB,W1I+1CiB;E0I91CjB,gBAAA;A/I468CJ;;AgJt88CA;EACC,wBAAA;EACA,cAAA;EACA,Y3Iw5CgB;E2Iv5ChB,eAAA;EACA,MAAA;EACA,SAAA;EACA,2CAAA;EACA,iDAAA;AhJy88CD;AgJv88CC;EACC,OAAA;EACA,4BAAA;AhJy88CF;AgJt88CC;EACC,QAAA;EACA,2BAAA;AhJw88CF;AgJr88CC;EACC,eAAA;EACA,uCAAA;EACA,iDAAA;AhJu88CF;;AgJl88CA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,mDAAA;EACA,sDAAA;AhJq88CD;;AgJj88CA;EACC,aAAA;AhJo88CD;;AgJh88CA;EACC;IAAS,UAAA;EhJo88CR;EgJn88CD;IAAK,UAAA;EhJs88CJ;AACF;Aeh78CI;EiIlBH;IACC,gBAAA;EhJq88CA;AACF;AiJ7/8CA;EACI,uCAAA;EAEA,oBAAA;EACA,mBAAA;AjJ8/8CJ;AiJ3/8CI;EAEI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,e5IojCwB;E4InjCxB,kB5ImjCwB;E4IljCxB,iBAAA;EACA,cAAA;AjJ4/8CR;AiJx/8CI;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,c5IyiCwB;ALi96ChC;AiJt/8CI;EACI,iB5IqiCwB;E4IpiCxB,iB5I2hCwB;AL696ChC;AiJt/8CQ;EACI,c5IiiCoB;ALu96ChC;AiJr/8CQ;EACI,a5I6hCoB;E4I5hCpB,c5I4hCoB;AL296ChC;AiJn/8CI;EACI,e5IwhCwB;E4IvhCxB,e5I8gCwB;ALu+6ChC;AiJn/8CQ;EACI,Y5IohCoB;ALi+6ChC;AiJl/8CQ;EACI,W5IghCoB;E4I/gCpB,Y5I+gCoB;ALq+6ChC;;AiJ9+8CI;EACI,8BAAA;EACA,iCAAA;AjJi/8CR;AiJ/+8CQ;EACI,iCAAA;EACA,sBAAA;EACA,6BAAA;AjJi/8CZ;;AiJ7+8CI;EACI,sBAAA;EACA,uCAAA;AjJg/8CR;;AiJ7/8CI;EACI,8BAAA;EACA,iCAAA;AjJgg9CR;AiJ9/8CQ;EACI,iCAAA;EACA,sBAAA;EACA,6BAAA;AjJgg9CZ;;AiJ5/8CI;EACI,sBAAA;EACA,uCAAA;AjJ+/8CR;;AiJ5g9CI;EACI,gCAAA;EACA,mCAAA;AjJ+g9CR;AiJ7g9CQ;EACI,mCAAA;EACA,wBAAA;EACA,6BAAA;AjJ+g9CZ;;AiJ3g9CI;EACI,wBAAA;EACA,yCAAA;AjJ8g9CR;;AiJ3h9CI;EACI,kCAAA;EACA,qCAAA;AjJ8h9CR;AiJ5h9CQ;EACI,qCAAA;EACA,0BAAA;EACA,6BAAA;AjJ8h9CZ;;AiJ1h9CI;EACI,0BAAA;EACA,2CAAA;AjJ6h9CR;;AiJ1i9CI;EACI,gCAAA;EACA,mCAAA;AjJ6i9CR;AiJ3i9CQ;EACI,mCAAA;EACA,wBAAA;EACA,6BAAA;AjJ6i9CZ;;AiJzi9CI;EACI,wBAAA;EACA,yCAAA;AjJ4i9CR;;AiJzj9CI;EACI,6BAAA;EACA,gCAAA;AjJ4j9CR;AiJ1j9CQ;EACI,gCAAA;EACA,qBAAA;EACA,6BAAA;AjJ4j9CZ;;AiJxj9CI;EACI,qBAAA;EACA,sCAAA;AjJ2j9CR;;AiJxk9CI;EACI,gCAAA;EACA,mCAAA;AjJ2k9CR;AiJzk9CQ;EACI,mCAAA;EACA,wBAAA;EACA,6BAAA;AjJ2k9CZ;;AiJvk9CI;EACI,wBAAA;EACA,yCAAA;AjJ0k9CR;;AiJvl9CI;EACI,+BAAA;EACA,kCAAA;AjJ0l9CR;AiJxl9CQ;EACI,kCAAA;EACA,uBAAA;EACA,6BAAA;AjJ0l9CZ;;AiJtl9CI;EACI,uBAAA;EACA,wCAAA;AjJyl9CR;;AiJtm9CI;EACI,6BAAA;EACA,gCAAA;AjJym9CR;AiJvm9CQ;EACI,gCAAA;EACA,qBAAA;EACA,6BAAA;AjJym9CZ;;AiJrm9CI;EACI,qBAAA;EACA,sCAAA;AjJwm9CR;;AkJ9q9CA;EACI,aAAA;AlJir9CJ;AkJ/q9CI;EACI,qBAAA;AlJir9CR;;AkJ5q9CI;EACI,aAAA;AlJ+q9CR;;AmJzr9CA;EACC,+BAAA;AnJ4r9CD;AmJ1r9CC;EACC,0BAAA;EACA,+BAAA;AnJ4r9CF;;AmJxr9CA;EACC,+BAAA;AnJ2r9CD;AmJzr9CC;EACC,yBAAA;EACA,+BAAA;AnJ2r9CF;;AmJvr9CA;EACC,+BAAA;AnJ0r9CD;AmJxr9CC;EACC,qBAAA;EACA,+BAAA;AnJ0r9CF;;AmJtr9CA;EACC,+BAAA;AnJyr9CD;AmJvr9CC;EACC,uBAAA;EACA,+BAAA;AnJyr9CF;;AmJrr9CA;EACC,+BAAA;AnJwr9CD;AmJtr9CC;EACC,wBAAA;EACA,+BAAA;AnJwr9CF;;AoJ9t9CA;EACI,oBAAA;EACA,mBAAA;ApJiu9CJ;;AoJ7t9CI;EACI,+BATY;EAUZ,2BAAA;EACA,sBAAA;ApJgu9CR;AoJ9t9CQ;EAGI,yBAAA;EACA,+BAjBQ;ApJ+u9CpB;AoJ5t9CY;EACI,0BAAA;ApJ8t9ChB;;AoJzt9CI;EACI,+BA1BY;EA2BZ,2BAAA;EACA,sBAAA;ApJ4t9CR;AoJ1t9CQ;EAGI,0BAAA;EACA,+BAlCQ;ApJ4v9CpB;AoJxt9CY;EACI,yBAAA;ApJ0t9ChB;;AoJvv9CI;EACI,+BATY;EAUZ,2BAAA;EACA,sBAAA;ApJ0v9CR;AoJxv9CQ;EAGI,0BAAA;EACA,+BAjBQ;ApJyw9CpB;AoJtv9CY;EACI,2BAAA;ApJwv9ChB;;AoJnv9CI;EACI,+BA1BY;EA2BZ,2BAAA;EACA,sBAAA;ApJsv9CR;AoJpv9CQ;EAGI,2BAAA;EACA,+BAlCQ;ApJsx9CpB;AoJlv9CY;EACI,0BAAA;ApJov9ChB;;AoJjx9CI;EACI,+BATY;EAUZ,2BAAA;EACA,sBAAA;ApJox9CR;AoJlx9CQ;EAGI,0BAAA;EACA,+BAjBQ;ApJmy9CpB;AoJhx9CY;EACI,2BAAA;ApJkx9ChB;;AoJ7w9CI;EACI,+BA1BY;EA2BZ,2BAAA;EACA,sBAAA;ApJgx9CR;AoJ9w9CQ;EAGI,2BAAA;EACA,+BAlCQ;ApJgz9CpB;AoJ5w9CY;EACI,0BAAA;ApJ8w9ChB;;Aezv9CI;EsIxDA;;;;;;IAOI,qBAAA;ICRJ,sDAAA;EtJ6z9CF;EqJlz9CM;;;;;;IACI,gCAAA;IACA,kCAAA;ErJyz9CV;EqJtz9CM;;;;;;I/IHJ,qBAAA;ENi09CF;EqJ1z9CM;;;;;;I/IPJ,qBAAA;ENy09CF;EsJn19CE;;;;;;IACI,2CDqByB;ErJq09C/B;EsJv19CE;;;;;;IACI,6BAAA;EtJ819CN;EsJz19CM;;;;;;IAEI,4DAAA;EtJ+19CV;EsJ519CU;;;;;;IACI,iDDM4C;ErJ619C1D;EsJh29CU;;;;;;IACI,6BAAA;EtJu29Cd;AACF;AqJj29CA;EACI,gBAAA;EACA,kBAAA;ArJm29CJ;Ae7z9CI;EsIxCJ;IAMQ,cAAA;ErJm29CN;AACF;;AqJh29CA;EACI,kBAAA;EACA,kBAAA;ArJm29CJ;Aev09CI;EsI9BJ;IAMQ,gBAAA;ErJm29CN;AACF;;AqJh29CA;EACI,kBAAA;EACA,kBAAA;ArJm29CJ;Aej19CI;EsIpBJ;IAMQ,gBAAA;ErJm29CN;AACF;;AqJ/19CA;EACI,kBAAA;ArJk29CJ;Aev29CI;EsIIJ;IAKQ,gBAAA;IAEA,yDAAA;IACA,qDAAA;IACA,kDAAA;IACA,oDAAA;ErJi29CN;EqJ/19CM;IACI,gBAAA;IACA,eAAA;IACA,gBAAA;ErJi29CV;EqJ719CM;IAnBR;MAoBY,gBAAA;MACA,kBAAA;MACA,eAAA;MACA,gBAAA;IrJg29CR;EACF;AACF;Aeh39CI;EsITJ;IA6BQ,cAAA;ErJg29CN;AACF;;AqJ519CA;EACI,kBAAA;ArJ+19CJ;Aet49CI;EsIsCJ;IAKQ,kBAAA;IACA,yDAAA;IACA,kDAAA;ErJ+19CN;EqJ719CM;IACI,kBAAA;IACA,eAAA;ErJ+19CV;EqJ319CM;IAfR;MAgBY,kBAAA;MACA,kBAAA;MACA,eAAA;IrJ819CR;EACF;AACF;Ae349CI;EsIyBJ;IAwBQ,gBAAA;ErJ819CN;AACF;;AqJ119CA;EACI,kBAAA;ArJ619CJ;Aej69CI;EsImEJ;IAKQ,kBAAA;IACA,2DAAA;ErJ619CN;EqJ319CM;IACI,kBAAA;IACA,gBAAA;ErJ619CV;EqJz19CM;IAdR;MAeY,kBAAA;MACA,kBAAA;MACA,gBAAA;IrJ419CR;EACF;AACF;Aer69CI;EsIsDJ;IAuBQ,gBAAA;ErJ419CN;AACF;;AqJx19CA;EACI,kBAAA;ArJ219CJ;Ae379CI;EsI+FJ;IAKQ,gBAAA;ErJ219CN;EqJx19CM;IACI,kEAAA;IACA,mEAAA;ErJ019CV;EqJv19CM;IACI,gBAAA;ErJy19CV;EqJt19CM;IACI,gBAAA;IACA,4BAAA;IACA,yDAAA;IACA,0DAAA;ErJw19CV;EqJr19CM;IACI,iBAAA;ErJu19CV;EqJn19CM;IA7BR;MA8BY,gBAAA;MACA,kBAAA;IrJs19CR;EACF;AACF;Aez89CI;EsIkFJ;IAqCQ,cAAA;ErJs19CN;AACF;;AqJl19CA;EACI,kBAAA;ArJq19CJ;Ae/99CI;EsIyIJ;IAKQ,kBAAA;ErJq19CN;EqJl19CM;IACI,kEAAA;ErJo19CV;EqJj19CM;IACI,gBAAA;ErJm19CV;EqJh19CM;IACI,gBAAA;IACA,4BAAA;IACA,yDAAA;ErJk19CV;EqJ/09CM;IACI,mBAAA;ErJi19CV;EqJ709CM;IA3BR;MA4BY,kBAAA;MACA,kBAAA;IrJg19CR;EACF;AACF;Ae3+9CI;EsI4HJ;IAmCQ,gBAAA;ErJg19CN;AACF;;AqJ509CA;EACI,kBAAA;ArJ+09CJ;Aejg+CI;EsIiLJ;IAKQ,kBAAA;ErJ+09CN;EqJ509CM;IACI,mEAAA;ErJ809CV;EqJ309CM;IACI,gBAAA;ErJ609CV;EqJ109CM;IACI,gBAAA;IACA,4BAAA;IACA,0DAAA;ErJ409CV;EqJz09CM;IACI,mBAAA;ErJ209CV;EqJv09CM;IA3BR;MA4BY,kBAAA;MACA,kBAAA;IrJ009CR;EACF;AACF;Ae7g+CI;EsIoKJ;IAmCQ,gBAAA;ErJ009CN;AACF;;AqJt09CA;EACI,kDAAA;ArJy09CJ;;AqJt09CA;EACI,iDAAA;ArJy09CJ;;AqJt09CA;EACI,oDAAA;ArJy09CJ;;AqJt09CA;EACI,mDAAA;ArJy09CJ;;AqJt09CA;EACI,kDAAA;ArJy09CJ;;AqJt09CA;EACI,kDAAA;EACA,mDAAA;ArJy09CJ;;AqJt09CA;EACI,iDAAA;EACA,kDAAA;ArJy09CJ;;AuJxn+CA;EACI,aAAA;EACA,mBAAA;AvJ2n+CJ;;AuJxn+CA;EACI,6BAAA;EACA,wBAAA;AvJ2n+CJ;AuJzn+CI;EACI,aAAA;AvJ2n+CR;;AuJvn+CA;EACI,UAAA;EACA,SAAA;AvJ0n+CJ;AuJxn+CI;EAEI,cAAA;EACA,qCAAA;AvJyn+CR;;AuJrn+CA;EACI,eAAA;AvJwn+CJ;;AuJnn+CI;;;EAEI,oCAAA;AvJun+CR;;AuJln+CI;EAEI,qCAAA;AvJon+CR;;AuJ/m+CI;EAEI,oCAAA;AvJin+CR;;AuJ7m+CA;EAKI,qCAAA;AvJ4m+CJ;AuJhn+CI;EAEI,qCAAA;AvJin+CR;;AwJpq+CC;;EAEC,aAAA;AxJuq+CF;AwJrq+CE;;EACC,aAAA;AxJwq+CH;AwJnq+CC;EACC,eAAA;AxJqq+CF;AwJhq+CE;EACC,aAAA;AxJkq+CH;AwJ/p+CE;EACC,aAAA;AxJiq+CH;AwJ9p+CE;EACC,qBAAA;AxJgq+CH;AwJ7p+CE;EACC,aAAA;AxJ+p+CH;AwJ1p+CE;EACC,aAAA;AxJ4p+CH;AwJzp+CE;EACC,qBAAA;AxJ2p+CH;AwJxp+CE;EACC,aAAA;AxJ0p+CH;AwJrp+CE;EACC,qBAAA;AxJup+CH;AwJpp+CE;EACC,qBAAA;AxJsp+CH;AwJnp+CE;EACC,aAAA;AxJqp+CH;AwJhp+CE;EACC,qBAAA;AxJkp+CH;AwJ/o+CE;EACC,aAAA;AxJip+CH;AwJ9o+CE;EACC,qBAAA;AxJgp+CH;AwJ7o+CE;EACC,aAAA;AxJ+o+CH;AwJ5o+CE;EACC,aAAA;AxJ8o+CH;AwJ3o+CE;EACC,aAAA;AxJ6o+CH;AwJ1o+CE;EACC,qBAAA;AxJ4o+CH;AwJzo+CE;EACC,aAAA;AxJ2o+CH;;AyJxu+CA;EACI,6BAAA;EACA,oCAAA;EACA,kCAAA;EAEA,mDAAA;EACA,qDAAA;EACA,6DAAA;EAEA,2BAAA;EACA,mCAAA;EACA,qCAAA;EAEA,iDAAA;EACA,uDAAA;EAEA,0DAAA;EAEA,mCAAA;EACA,2CAAA;EACA,6CAAA;EAEA,kDAAA;EACA,0DAAA;EACA,8DAAA;EAEA,kCAAA;EACA,0CAAA;EACA,4CAAA;EAEA,mDAAA;EACA,yDAAA;EACA,2DAAA;EAEA,uDAAA;AzJku+CJ;AyJ/t+CI;EACI,aAAA;AzJiu+CR;AyJ7t+CI;EACI,aAAA;EACA,mBAAA;EACA,2BpJyVU;ALs49ClB;AyJ5t+CQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,2BpJiVM;EoJhVN,mCAAA;EACA,oCAAA;EACA,mDAAA;EACA,iDAAA;EACA,qCAAA;EACA,oBAAA;AzJ8t+CZ;AyJ5t+CY;EACI,aAAA;EACA,4CAAA;AzJ8t+ChB;AyJ3t+CY;EACI,gBpJgXG;EoJ/WH,0CAAA;EACA,kBAAA;AzJ6t+ChB;AyJxt+CQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AzJ0t+CZ;AyJxt+CY;EACI,0CAAA;EACA,8CAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AzJ0t+ChB;AyJvt+CY;EACI,6CAAA;EACA,yCAAA;AzJyt+ChB;AyJpt+CQ;EACI,2BpJuSM;AL+69ClB;AyJpt+CY;EACI,2BpJoSE;EoJnSF,yDAAA;EACA,6CAAA;AzJst+ChB;AyJpt+CgB;EACI,aAAA;AzJst+CpB;AyJnt+CgB;EACI,kDAAA;EACA,kBAAA;AzJqt+CpB;AyJht+CgB;EACI,sDAAA;EACA,kDAAA;AzJkt+CpB;AyJ/s+CgB;EACI,qDAAA;EACA,iDAAA;AzJit+CpB;AyJzs+CY;EACI,2BpJqQE;EoJpQF,2DAAA;EACA,+CAAA;AzJ2s+ChB;AyJzs+CgB;EACI,mDAAA;EACA,qBAAA;AzJ2s+CpB;AyJxs+CgB;EACI,aAAA;AzJ0s+CpB;AyJrs+CgB;EACI,wDAAA;EACA,oDAAA;AzJus+CpB;AyJps+CgB;EACI,uDAAA;EACA,mDAAA;AzJss+CpB;AyJ7r+CQ;EACI,sBAAA;EACA,kBAAA;AzJ+r+CZ;AyJ3r+CQ;EACI,sBAAA;EACA,sBAAA;EACA,oBAAA;EACA,UAAA;EACN,SAAA;AzJ6r+CN;AyJzr+CQ;EACI,aAAA;EACA,mBAAA;AzJ2r+CZ;AyJvr+CQ;EACI,UAAA;AzJyr+CZ;AyJrr+CQ;EACI,cAAA;EACA,YAAA;EACA,mDAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;AzJur+CZ;;A0Jt3+CI;EACF,aAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;A1Jy3+CF;A0Jv3+CQ;EACL,kBAAA;EACA,cAAA;EACA,mBAAA;A1Jy3+CH;A0Jv3+CG;EACC,YAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;EACA,2BrJiXc;ALwg+ClB;A0Jt3+CY;EACI,qBAAA;EACA,gBAAA;EACA,kBAAA;A1Jw3+ChB;A0Jp3+CY;EACR,2BrJsWc;ALgh+ClB;A0Jp3+CI;EACC,wBAAA;A1Js3+CL;A0Jn3+CI;EACC,mCAAA;A1Jq3+CL;A0J/2+CI;EACC,yBAAA;A1Ji3+CL;;A2J75+CQ;EACI,aAAA;A3Jg6+CZ;A2J15+CQ;EACI,aAAA;A3J45+CZ;;A4Jv6+CA;ECuBC,smCAAA;A7Jo5+CD;;A4Jt6+CA;ECkBC,8mDAAA;A7Jw5+CD;;A8J96+CA;EACC,kBAAA;A9Ji7+CD;A8J96+CC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,2CAAA;EACA,6CAAA;EACA,gCAAA;EACA,QAAA;EACA,QAAA;EACA,2CAAA;A9Jg7+CF;A8J96+CE;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;A9Jg7+CH;A8J76+CE;EACC,iDAAA;A9J+6+CH;A8Jz6+CE;EACC,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;A9J26+CH;A8Jt6+CE;EACC,MAAA;EACA,6CAAA;EACA,oCzJ6T6B;EyJ5T7B,mCzJ4T6B;AL4m+ChC;A8Jn6+CE;EACC,iCzJsT6B;EyJrT7B,gCzJqT6B;ALgn+ChC;A8Jh6+CE;EACC,QAAA;EACA,OAAA;EACA,WAAA;EACA,4CAAA;EACA,iCzJ2S6B;EyJ1S7B,oCzJ0S6B;ALwn+ChC;A8J75+CE;EACC,gCzJoS6B;EyJnS7B,mCzJmS6B;AL4n+ChC;;A8Jv5+CE;EACC,UAAA;A9J05+CH;A8Jx5+CG;EACC,iCzJuR4B;EyJtR5B,oCzJsR4B;ALoo+ChC;A8Jx5+CI;EAEC,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;A9Jy5+CL;A8Jt5+CI;EACC,2BAAA;EACA,uDAAA;EACA,OAAA;A9Jw5+CL;A8Jj5+CE;EACC,WAAA;A9Jm5+CH;A8Jj5+CG;EACC,gCzJ6P4B;EyJ5P5B,mCzJ4P4B;ALup+ChC;A8Jj5+CI;EAEC,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,oCAAA;EACA,aAAA;A9Jk5+CL;A8J/4+CI;EACC,2BAAA;EACA,sDAAA;EACA,QAAA;A9Ji5+CL;;A8Jz4+CA;EACC,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,2BAAA;A9J44+CD;A8Jz4+CC;EACC,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,mCAAA;EACA,+CAAA;EACA,kCAAA;A9J24+CF;A8Jv4+CC;EACC,MAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,gDAAA;EACA,8CAAA;EACA,oCAAA;EACA,kCAAA;A9Jy4+CF;A8Jr4+CC;EACC,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,mCAAA;EACA,+CAAA;EACA,6CAAA;A9Ju4+CF;A8Jn4+CC;EACC,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,oCAAA;EACA,8CAAA;EACA,6CAAA;A9Jq4+CF;;A+J/j/CA;EACI,kBAAA;A/Jkk/CJ;A+Jhk/CI;EACI,yBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8CAAA;A/Jkk/CR;A+Jhk/CQ;EACI,eAAA;EACA,cAAA;A/Jkk/CZ;A+J9j/CI;EACI,aAAA;EACA,mBAAA;EzJTJ,uBAAA;EyJWI,yCAAA;EACA,sCAAA;EACA,yBAAA;EACA,gB1JuZW;E0JtZX,oBAAA;EACA,WAAA;EACA,mCAAA;A/Jgk/CR;A+J9j/CQ;EACI,qBAAA;A/Jgk/CZ;;AgKnl/CA;EACI,yBAAA;EACA,yBrJfe;AXqm/CnB;AgKpl/CI;EAGI,crJpBW;EqJqBX,yBAxBU;AhK4m/ClB;;AgKhl/CA;EACI,SAAA;AhKml/CJ;AgKhl/CQ;;EAEI,cAlCM;AhKon/ClB;;AgK7k/CA;EACC,SAAA;EACG,crJtCe;EqJuCf,yBA1Cc;AhK0n/ClB;AgK9k/CI;EACI,crJ1CW;EqJ2CX,yBA5CiB;AhK4n/CzB;;AgK5k/CA;EACC,SAAA;EACG,yBAAA;EACA,oCAAA;AhK+k/CJ;AgK7k/CI;EACI,yBAAA;EACA,oCAAA;AhK+k/CR;;AgK3k/CA;EACI,gDAAA;AhK8k/CJ;AgK5k/CI;EAEI,qCAAA;EACA,yBA7DgB;AhK0o/CxB;;AgKzk/CA;EACI,cAxEc;AhKop/ClB;AgK1k/CI;EACI,cAzEiB;AhKqp/CzB;;AgKxk/CA;EACI,yBAAA;AhK2k/CJ;;AgKxk/CA;EACI,cA/Ec;AhK0p/ClB;;AgKxk/CA;EACI,cA3Ea;AhKsp/CjB;;AgKxk/CA;EACI,crJzFe;EqJ0Ff,yBAnFc;AhK8p/ClB;;AgKxk/CA;EACI,crJ9Fe;EqJ+Ff,yBA7Fc;AhKwq/ClB;;AiK7q/CA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EtDUO,iCsDPE;EtDsBF,qCsDpBS;EtDwBT,yCsDvBK;AjK6q/Cb;A2Grq/CQ;;EAEF,iCsDZS;AjKmr/Cf;A2Gpq/CQ;EACI,iCsDhBG;AjKsr/Cf;A2G1p/CI;EASQ,wCsDlCK;EtDiDL,qCsD/CY;EtDmDZ,oDAAA;A3Gmo/CZ;A2Glp/CY;;;;;;;;;EAEF,wCsDvCY;AjKks/CtB;A2Gxp/CY;EACI,wCsD3CM;AjKqs/CtB;;AkKht/CA;EACI,mBAAA;EACA,cAAA;AlKmt/CJ;;AmKpt/CA;EACI;IACI,qBAAA;IACA,2BAAA;EnKut/CN;EmKrt/CM;;;;;;;;;;IAOI,2BAAA;IACA,qBAAA;IACA,oBAAA;EnK0t/CV;EmKvt/CM;;;;;;;;IAQI,wBAAA;EnKyt/CV;AACF;AoKnv/CA;EACC,yCAAA;EACA,oCAAA;ApKqv/CD;;AoKjv/CA;EACC,yCAAA;EACA,oCAAA;ApKov/CD;;AoKhv/CA;EACC,wCAAA;EACA,8CAAA;ApKmv/CD;;AoKhv/CA;EACC,eAAA;ApKmv/CD;AoKjv/CC;EACE,8CAAA;ApKmv/CH;;AoK9u/CC;EACC,8CAAA;ApKiv/CF;;AoK7u/CA;EACC,eAAA;ApKgv/CD;AoK9u/CC;EAEC,8CAAA;ApK+u/CF;;AoKnu/CC;EACC,sCAAA;EACA,4CAAA;ApKsu/CF;;AoKht/CC;EACC,eAAA;ApKmt/CF;AoKjt/CE;EACC,4CAAA;ApKmt/CH;;AoK9s/CE;EACC,4CAAA;ApKit/CH;;AoK7s/CC;EACC,eAAA;ApKgt/CF;AoK9s/CE;EAEC,4CAAA;ApK+s/CH;;AoK1v/CC;EACC,sCAAA;EACA,4CAAA;ApK6v/CF;;AoKvu/CC;EACC,eAAA;ApK0u/CF;AoKxu/CE;EACC,4CAAA;ApK0u/CH;;AoKru/CE;EACC,4CAAA;ApKwu/CH;;AoKpu/CC;EACC,eAAA;ApKuu/CF;AoKru/CE;EAEC,4CAAA;ApKsu/CH;;AoKtx/CE;EACC,oDAAA;ApKyx/CH;;AoKrx/CC;EACC,wCAAA;EACA,8CAAA;ApKwx/CF;;AoKpx/CE;EACC,eAAA;ApKux/CH;AoKrx/CG;EACC,oDAAA;ApKux/CJ;;AoKnx/CE;EACC,eAAA;ApKsx/CH;AoKpx/CG;EAEC,oDAAA;ApKqx/CJ;;AoKhx/CC;EACC,eAAA;ApKmx/CF;AoKjx/CE;EACC,8CAAA;ApKmx/CH;;AoK9w/CE;EACC,8CAAA;ApKix/CH;;AoK7w/CC;EACC,eAAA;ApKgx/CF;AoK9w/CE;EAEC,8CAAA;ApK+w/CH;;AoK/z/CE;EACC,sDAAA;ApKk0/CH;;AoK9z/CC;EACC,0CAAA;EACA,gDAAA;ApKi0/CF;;AoK7z/CE;EACC,eAAA;ApKg0/CH;AoK9z/CG;EACC,sDAAA;ApKg0/CJ;;AoK5z/CE;EACC,eAAA;ApK+z/CH;AoK7z/CG;EAEC,sDAAA;ApK8z/CJ;;AoKzz/CC;EACC,eAAA;ApK4z/CF;AoK1z/CE;EACC,gDAAA;ApK4z/CH;;AoKvz/CE;EACC,gDAAA;ApK0z/CH;;AoKtz/CC;EACC,eAAA;ApKyz/CF;AoKvz/CE;EAEC,gDAAA;ApKwz/CH;;AoKx2/CE;EACC,oDAAA;ApK22/CH;;AoKv2/CC;EACC,wCAAA;EACA,8CAAA;ApK02/CF;;AoKt2/CE;EACC,eAAA;ApKy2/CH;AoKv2/CG;EACC,oDAAA;ApKy2/CJ;;AoKr2/CE;EACC,eAAA;ApKw2/CH;AoKt2/CG;EAEC,oDAAA;ApKu2/CJ;;AoKl2/CC;EACC,eAAA;ApKq2/CF;AoKn2/CE;EACC,8CAAA;ApKq2/CH;;AoKh2/CE;EACC,8CAAA;ApKm2/CH;;AoK/1/CC;EACC,eAAA;ApKk2/CF;AoKh2/CE;EAEC,8CAAA;ApKi2/CH;;AoKj5/CE;EACC,iDAAA;ApKo5/CH;;AoKh5/CC;EACC,qCAAA;EACA,2CAAA;ApKm5/CF;;AoK/4/CE;EACC,eAAA;ApKk5/CH;AoKh5/CG;EACC,iDAAA;ApKk5/CJ;;AoK94/CE;EACC,eAAA;ApKi5/CH;AoK/4/CG;EAEC,iDAAA;ApKg5/CJ;;AoK34/CC;EACC,eAAA;ApK84/CF;AoK54/CE;EACC,2CAAA;ApK84/CH;;AoKz4/CE;EACC,2CAAA;ApK44/CH;;AoKx4/CC;EACC,eAAA;ApK24/CF;AoKz4/CE;EAEC,2CAAA;ApK04/CH;;AoK17/CE;EACC,oDAAA;ApK67/CH;;AoKz7/CC;EACC,wCAAA;EACA,8CAAA;ApK47/CF;;AoKx7/CE;EACC,eAAA;ApK27/CH;AoKz7/CG;EACC,oDAAA;ApK27/CJ;;AoKv7/CE;EACC,eAAA;ApK07/CH;AoKx7/CG;EAEC,oDAAA;ApKy7/CJ;;AoKp7/CC;EACC,eAAA;ApKu7/CF;AoKr7/CE;EACC,8CAAA;ApKu7/CH;;AoKl7/CE;EACC,8CAAA;ApKq7/CH;;AoKj7/CC;EACC,eAAA;ApKo7/CF;AoKl7/CE;EAEC,8CAAA;ApKm7/CH;;AoKn+/CE;EACC,mDAAA;ApKs+/CH;;AoKl+/CC;EACC,uCAAA;EACA,6CAAA;ApKq+/CF;;AoKj+/CE;EACC,eAAA;ApKo+/CH;AoKl+/CG;EACC,mDAAA;ApKo+/CJ;;AoKh+/CE;EACC,eAAA;ApKm+/CH;AoKj+/CG;EAEC,mDAAA;ApKk+/CJ;;AoK79/CC;EACC,eAAA;ApKg+/CF;AoK99/CE;EACC,6CAAA;ApKg+/CH;;AoK39/CE;EACC,6CAAA;ApK89/CH;;AoK19/CC;EACC,eAAA;ApK69/CF;AoK39/CE;EAEC,6CAAA;ApK49/CH;;AoK5ggDE;EACC,iDAAA;ApK+ggDH;;AoK3ggDC;EACC,qCAAA;EACA,2CAAA;ApK8ggDF;;AoK1ggDE;EACC,eAAA;ApK6ggDH;AoK3ggDG;EACC,iDAAA;ApK6ggDJ;;AoKzggDE;EACC,eAAA;ApK4ggDH;AoK1ggDG;EAEC,iDAAA;ApK2ggDJ;;AoKtggDC;EACC,eAAA;ApKyggDF;AoKvggDE;EACC,2CAAA;ApKyggDH;;AoKpggDE;EACC,2CAAA;ApKuggDH;;AoKnggDC;EACC,eAAA;ApKsggDF;AoKpggDE;EAEC,2CAAA;ApKqggDH;;AoK9//CI;EACF,oCAAA;ApKiggDF;;AoK9//CC;EACC,+CAAA;ApKiggDF;;AoKtggDI;EACF,oCAAA;ApKyggDF;;AoKtggDC;EACC,+CAAA;ApKyggDF;;AoK9ggDI;EACF,oCAAA;ApKihgDF;;AoK9ggDC;EACC,+CAAA;ApKihgDF;;AoKthgDI;EACF,oCAAA;ApKyhgDF;;AoKthgDC;EACC,+CAAA;ApKyhgDF;;AoK9hgDI;EACF,oCAAA;ApKiigDF;;AoK9hgDC;EACC,+CAAA;ApKiigDF;;AoKtigDI;EACF,oCAAA;ApKyigDF;;AoKtigDC;EACC,+CAAA;ApKyigDF;;AoK9igDI;EACF,oCAAA;ApKijgDF;;AoK9igDC;EACC,+CAAA;ApKijgDF;;AoKtjgDI;EACF,oCAAA;ApKyjgDF;;AoKtjgDC;EACC,+CAAA;ApKyjgDF;;AoK9jgDI;EACF,oCAAA;ApKikgDF;;AoK9jgDC;EACC,+CAAA;ApKikgDF;;AoK3jgDC;EACC,4DAAA;ApK8jgDF;;AoK3jgDC;EACC,4DAAA;ApK8jgDF;;AoK3jgDC;EACC,4DAAA;ApK8jgDF;;AoK1jgDE;EAEC,4DAAA;ApK4jgDH;;AoK3kgDC;EACC,+DAAA;ApK8kgDF;;AoK3kgDC;EACC,+DAAA;ApK8kgDF;;AoK3kgDC;EACC,+DAAA;ApK8kgDF;;AoK1kgDE;EAEC,+DAAA;ApK4kgDH;;AoK3lgDC;EACC,8DAAA;ApK8lgDF;;AoK3lgDC;EACC,8DAAA;ApK8lgDF;;AoK3lgDC;EACC,8DAAA;ApK8lgDF;;AoK1lgDE;EAEC,8DAAA;ApK4lgDH;;AoK3mgDC;EACC,+DAAA;ApK8mgDF;;AoK3mgDC;EACC,+DAAA;ApK8mgDF;;AoK3mgDC;EACC,+DAAA;ApK8mgDF;;AoK1mgDE;EAEC,+DAAA;ApK4mgDH;;AoK3ngDC;EACC,8DAAA;ApK8ngDF;;AoK3ngDC;EACC,8DAAA;ApK8ngDF;;AoK3ngDC;EACC,8DAAA;ApK8ngDF;;AoK1ngDE;EAEC,8DAAA;ApK4ngDH;;AoK3ogDC;EACC,+DAAA;ApK8ogDF;;AoK3ogDC;EACC,+DAAA;ApK8ogDF;;AoK3ogDC;EACC,+DAAA;ApK8ogDF;;AoK1ogDE;EAEC,+DAAA;ApK4ogDH;;AoK3pgDC;EACC,8DAAA;ApK8pgDF;;AoK3pgDC;EACC,8DAAA;ApK8pgDF;;AoK3pgDC;EACC,8DAAA;ApK8pgDF;;AoK1pgDE;EAEC,8DAAA;ApK4pgDH;;AoK3qgDC;EACC,+DAAA;ApK8qgDF;;AoK3qgDC;EACC,+DAAA;ApK8qgDF;;AoK3qgDC;EACC,+DAAA;ApK8qgDF;;AoK1qgDE;EAEC,+DAAA;ApK4qgDH;;AoK3rgDC;EACC,4DAAA;ApK8rgDF;;AoK3rgDC;EACC,4DAAA;ApK8rgDF;;AoK3rgDC;EACC,4DAAA;ApK8rgDF;;AoK1rgDE;EAEC,4DAAA;ApK4rgDH;;AoKrrgDA;EACC,4BAAA;ApKwrgDD;;AoKprgDA;EACC,0BAAA;ApKurgDD;;AoKprgDA;EACC,6BAAA;ApKurgDD;;AoKprgDA;EACC,6BAAA;ApKurgDD;;AoKprgDA;EACC,2BAAA;ApKurgDD;;AoKprgDA;EACC,4BAAA;ApKurgDD;;AoKprgDA;EACC,6BAAA;ApKurgDD;;AoKprgDA;EACC,0BAAA;ApKurgDD;;AoKprgDA;EACC,6BAAA;ApKurgDD;;AoKprgDA;EACC,2BAAA;ApKurgDD;;AoK9qgDE;EACC,qBAAA;ApKirgDH;;AoK9qgDE;EACC,sBAAA;ApKirgDH;;AoK9qgDE;EACC,wBAAA;ApKirgDH;;AoK7qgDE;EACC,4BAAA;ApKgrgDH;;AoK7qgDE;EACC,6BAAA;ApKgrgDH;;Ae1zgDI;EqJwHF;IACC,qBAAA;EpKssgDD;;EoKnsgDA;IACC,sBAAA;EpKssgDD;;EoKnsgDA;IACC,wBAAA;EpKssgDD;;EoKlsgDA;IACC,4BAAA;EpKqsgDD;;EoKlsgDA;IACC,6BAAA;EpKqsgDD;AACF;Aeh1gDI;EqJwHF;IACC,qBAAA;EpK2tgDD;;EoKxtgDA;IACC,sBAAA;EpK2tgDD;;EoKxtgDA;IACC,wBAAA;EpK2tgDD;;EoKvtgDA;IACC,4BAAA;EpK0tgDD;;EoKvtgDA;IACC,6BAAA;EpK0tgDD;AACF;Aer2gDI;EqJwHF;IACC,qBAAA;EpKgvgDD;;EoK7ugDA;IACC,sBAAA;EpKgvgDD;;EoK7ugDA;IACC,wBAAA;EpKgvgDD;;EoK5ugDA;IACC,4BAAA;EpK+ugDD;;EoK5ugDA;IACC,6BAAA;EpK+ugDD;AACF;Ae13gDI;EqJwHF;IACC,qBAAA;EpKqwgDD;;EoKlwgDA;IACC,sBAAA;EpKqwgDD;;EoKlwgDA;IACC,wBAAA;EpKqwgDD;;EoKjwgDA;IACC,4BAAA;EpKowgDD;;EoKjwgDA;IACC,6BAAA;EpKowgDD;AACF;Ae/4gDI;EqJwHF;IACC,qBAAA;EpK0xgDD;;EoKvxgDA;IACC,sBAAA;EpK0xgDD;;EoKvxgDA;IACC,wBAAA;EpK0xgDD;;EoKtxgDA;IACC,4BAAA;EpKyxgDD;;EoKtxgDA;IACC,6BAAA;EpKyxgDD;AACF;AqK/9gDA;EACI,oCAAA;ArKi+gDJ;;AqK99gDA;EACI,eAAA;EACA,oCAAA;ArKi+gDJ;;AqK39gDC;EACC,2CAAA;ArK89gDF;;AqK/9gDC;EACC,2CAAA;ArKk+gDF;;AqKn+gDC;EACC,2CAAA;ArKs+gDF;;AqKv+gDC;EACC,2CAAA;ArK0+gDF;;AqK3+gDC;EACC,2CAAA;ArK8+gDF;;AqK/+gDC;EACC,2CAAA;ArKk/gDF;;AqKn/gDC;EACC,2CAAA;ArKs/gDF;;AqKv/gDC;EACC,2CAAA;ArK0/gDF;;AqK3/gDC;EACC,2CAAA;ArK8/gDF;;AqKx/gDI;EACI,wCAAA;ArK2/gDR;;AqKx/gDI;EACI,wCAAA;ArK2/gDR;;AqKhghDI;EACI,wCAAA;ArKmghDR;;AqKhghDI;EACI,wCAAA;ArKmghDR;;AqKxghDI;EACI,0CAAA;ArK2ghDR;;AqKxghDI;EACI,0CAAA;ArK2ghDR;;AqKhhhDI;EACI,4CAAA;ArKmhhDR;;AqKhhhDI;EACI,4CAAA;ArKmhhDR;;AqKxhhDI;EACI,0CAAA;ArK2hhDR;;AqKxhhDI;EACI,0CAAA;ArK2hhDR;;AqKhihDI;EACI,uCAAA;ArKmihDR;;AqKhihDI;EACI,uCAAA;ArKmihDR;;AqKxihDI;EACI,0CAAA;ArK2ihDR;;AqKxihDI;EACI,0CAAA;ArK2ihDR;;AqKhjhDI;EACI,yCAAA;ArKmjhDR;;AqKhjhDI;EACI,yCAAA;ArKmjhDR;;AqKxjhDI;EACI,uCAAA;ArK2jhDR;;AqKxjhDI;EACI,uCAAA;ArK2jhDR;;AqKtjhDA;EACI,oCAAA;ArKyjhDJ;;AqKrjhDA;EACI,+BAAA;EACA,2CAAA;ArKwjhDJ;;AqKrjhDA;EACI,mCAAA;ArKwjhDJ;;AqKrjhDA;EACI,sCAAA;ArKwjhDJ;;AqKrjhDA;EACI,oCAAA;ArKwjhDJ;;AqKrjhDA;EACI,qCAAA;ArKwjhDJ;;AqKpjhDA;EACI,+BAAA;ArKujhDJ;;AqKpjhDA;EACI,mCAAA;ArKujhDJ;;AqKpjhDA;EACI,sCAAA;ArKujhDJ;;AqKpjhDA;EACI,oCAAA;ArKujhDJ;;AqKpjhDA;EACI,qCAAA;ArKujhDJ;;AqKnjhDA;EACI,oCAAA;ArKsjhDJ;;AqKljhDA;EACI,0CAAA;ArKqjhDJ;;AqKjjhDA;EACI,oCAAA;EACA,qCAAA;ArKojhDJ;;AqKjjhDA;EACI,uCAAA;EACA,wCAAA;ArKojhDJ;;AqKjjhDA;EACI,oCAAA;EACA,uCAAA;ArKojhDJ;;AqKjjhDA;EACI,qCAAA;EACA,wCAAA;ArKojhDJ;;AqKjjhDA;EACI,6BAAA;ArKojhDJ;;AsK3phDQ;EACL,SAAA;AtK8phDH;;AsK3phDQ;EACI,UAAA;AtK8phDZ;;AsK3phDQ;EACI,cAAA;AtK8phDZ;;AsK3phDQ;EACI,cAAA;AtK8phDZ;;AsK3phDQ;EACI,cAAA;EACA,YAAA;AtK8phDZ;;AsK3phDK;EACC,uBAAA;EACA,mBAAA;AtK8phDN;;AsK3phDQ;EACF,sBAAA;EACA,kBAAA;AtK8phDN;;AsK3phDQ;EACF,oBAAA;EACA,gBAAA;AtK8phDN;;AsK3phDQ;EACL,8BAAA;EACG,mBAAA;AtK8phDN;;Ae9ohDI;EuJtDI;IACL,SAAA;EtKwshDD;;EsKrshDM;IACI,UAAA;EtKwshDV;;EsKrshDM;IACI,cAAA;EtKwshDV;;EsKrshDM;IACI,cAAA;EtKwshDV;;EsKrshDM;IACI,cAAA;IACA,YAAA;EtKwshDV;;EsKrshDG;IACC,uBAAA;IACA,mBAAA;EtKwshDJ;;EsKrshDM;IACF,sBAAA;IACA,kBAAA;EtKwshDJ;;EsKrshDM;IACF,oBAAA;IACA,gBAAA;EtKwshDJ;;EsKrshDM;IACL,8BAAA;IACG,mBAAA;EtKwshDJ;AACF;AezrhDI;EuJtDI;IACL,SAAA;EtKkvhDD;;EsK/uhDM;IACI,UAAA;EtKkvhDV;;EsK/uhDM;IACI,cAAA;EtKkvhDV;;EsK/uhDM;IACI,cAAA;EtKkvhDV;;EsK/uhDM;IACI,cAAA;IACA,YAAA;EtKkvhDV;;EsK/uhDG;IACC,uBAAA;IACA,mBAAA;EtKkvhDJ;;EsK/uhDM;IACF,sBAAA;IACA,kBAAA;EtKkvhDJ;;EsK/uhDM;IACF,oBAAA;IACA,gBAAA;EtKkvhDJ;;EsK/uhDM;IACL,8BAAA;IACG,mBAAA;EtKkvhDJ;AACF;AenuhDI;EuJtDI;IACL,SAAA;EtK4xhDD;;EsKzxhDM;IACI,UAAA;EtK4xhDV;;EsKzxhDM;IACI,cAAA;EtK4xhDV;;EsKzxhDM;IACI,cAAA;EtK4xhDV;;EsKzxhDM;IACI,cAAA;IACA,YAAA;EtK4xhDV;;EsKzxhDG;IACC,uBAAA;IACA,mBAAA;EtK4xhDJ;;EsKzxhDM;IACF,sBAAA;IACA,kBAAA;EtK4xhDJ;;EsKzxhDM;IACF,oBAAA;IACA,gBAAA;EtK4xhDJ;;EsKzxhDM;IACL,8BAAA;IACG,mBAAA;EtK4xhDJ;AACF;Ae7whDI;EuJtDI;IACL,SAAA;EtKs0hDD;;EsKn0hDM;IACI,UAAA;EtKs0hDV;;EsKn0hDM;IACI,cAAA;EtKs0hDV;;EsKn0hDM;IACI,cAAA;EtKs0hDV;;EsKn0hDM;IACI,cAAA;IACA,YAAA;EtKs0hDV;;EsKn0hDG;IACC,uBAAA;IACA,mBAAA;EtKs0hDJ;;EsKn0hDM;IACF,sBAAA;IACA,kBAAA;EtKs0hDJ;;EsKn0hDM;IACF,oBAAA;IACA,gBAAA;EtKs0hDJ;;EsKn0hDM;IACL,8BAAA;IACG,mBAAA;EtKs0hDJ;AACF;AevzhDI;EuJtDI;IACL,SAAA;EtKg3hDD;;EsK72hDM;IACI,UAAA;EtKg3hDV;;EsK72hDM;IACI,cAAA;EtKg3hDV;;EsK72hDM;IACI,cAAA;EtKg3hDV;;EsK72hDM;IACI,cAAA;IACA,YAAA;EtKg3hDV;;EsK72hDG;IACC,uBAAA;IACA,mBAAA;EtKg3hDJ;;EsK72hDM;IACF,sBAAA;IACA,kBAAA;EtKg3hDJ;;EsK72hDM;IACF,oBAAA;IACA,gBAAA;EtKg3hDJ;;EsK72hDM;IACL,8BAAA;IACG,mBAAA;EtKg3hDJ;AACF;AsK52hDA;EACI,YAAA;EACA,aAAA;EACA,cAAA;AtK82hDJ;;AuKj6hDA;EACI,mCAAA;AvKo6hDJ;;AuKj6hDA;EACI,mCAAA;AvKo6hDJ;;AuKj6hDA;EACI,gCAAA;AvKo6hDJ;;AuKj6hDA;EACI,mCAAA;AvKo6hDJ;;AwK96hDI;EACI,sCAAA;AxKi7hDR;;AwK/5hDI;EACI,2BnKgXU;ALkjhDlB;AwKh6hDQ;EACI,2BnK6WM;ALqjhDlB;AwK/5hDQ;EACI,2BnKyWM;EmKxWN,sCAAA;AxKi6hDZ;AwK/5hDY;EACI,2BnKqWE;EmKpWd,sCAAA;AxKi6hDJ;AwK95hDG;EACC,sCAAA;AxKg6hDJ;;AwK15hDI;EACI,2BnKyVU;ALokhDlB;AwK35hDQ;EACI,2BnKsVM;ALukhDlB;AwK15hDQ;EACI,2BnKkVM;EmKjVN,sCAAA;AxK45hDZ;AwK15hDY;EACI,2BnK8UE;EmK7UF,sCAAA;AxK45hDhB;AwKz5hDY;EACI,sCAAA;AxK25hDhB;;AwKt9hDI;EACI,wCAAA;AxKy9hDR;;AwKp9hDQ;EACI,2CAAA;AxKu9hDZ;;AwKj9hDQ;EACI,yCAAA;AxKo9hDZ;;AwK/8hDI;EACI,2BnKgXU;ALkmhDlB;AwKh9hDQ;EACI,2BnK6WM;ALqmhDlB;AwK/8hDQ;EACI,2BnKyWM;EmKxWN,wCAAA;AxKi9hDZ;AwK/8hDY;EACI,2BnKqWE;EmKpWd,wCAAA;AxKi9hDJ;AwK98hDG;EACC,wCAAA;AxKg9hDJ;;AwK18hDI;EACI,2BnKyVU;ALonhDlB;AwK38hDQ;EACI,2BnKsVM;ALunhDlB;AwK18hDQ;EACI,2BnKkVM;EmKjVN,wCAAA;AxK48hDZ;AwK18hDY;EACI,2BnK8UE;EmK7UF,wCAAA;AxK48hDhB;AwKz8hDY;EACI,wCAAA;AxK28hDhB;;AwKtgiDI;EACI,0CAAA;AxKygiDR;;AwKpgiDQ;EACI,6CAAA;AxKugiDZ;;AwKjgiDQ;EACI,2CAAA;AxKogiDZ;;AwK//hDI;EACI,2BnKgXU;ALkphDlB;AwKhgiDQ;EACI,2BnK6WM;ALqphDlB;AwK//hDQ;EACI,2BnKyWM;EmKxWN,0CAAA;AxKigiDZ;AwK//hDY;EACI,2BnKqWE;EmKpWd,0CAAA;AxKigiDJ;AwK9/hDG;EACC,0CAAA;AxKggiDJ;;AwK1/hDI;EACI,2BnKyVU;ALoqhDlB;AwK3/hDQ;EACI,2BnKsVM;ALuqhDlB;AwK1/hDQ;EACI,2BnKkVM;EmKjVN,0CAAA;AxK4/hDZ;AwK1/hDY;EACI,2BnK8UE;EmK7UF,0CAAA;AxK4/hDhB;AwKz/hDY;EACI,0CAAA;AxK2/hDhB;;AwKtjiDI;EACI,sCAAA;AxKyjiDR;;AwKpjiDQ;EACI,yCAAA;AxKujiDZ;;AwK3iiDI;EACI,2BnKgXU;AL8rhDlB;AwK5iiDQ;EACI,2BnK6WM;ALishDlB;AwK3iiDQ;EACI,2BnKyWM;EmKxWN,sCAAA;AxK6iiDZ;AwK3iiDY;EACI,2BnKqWE;EmKpWd,sCAAA;AxK6iiDJ;AwK1iiDG;EACC,sCAAA;AxK4iiDJ;;AwKtiiDI;EACI,2BnKyVU;ALgthDlB;AwKviiDQ;EACI,2BnKsVM;ALmthDlB;AwKtiiDQ;EACI,2BnKkVM;EmKjVN,sCAAA;AxKwiiDZ;AwKtiiDY;EACI,2BnK8UE;EmK7UF,sCAAA;AxKwiiDhB;AwKriiDY;EACI,sCAAA;AxKuiiDhB;;AwKlmiDI;EACI,wCAAA;AxKqmiDR;;AwKhmiDQ;EACI,2CAAA;AxKmmiDZ;;AwK7liDQ;EACI,yCAAA;AxKgmiDZ;;AwK3liDI;EACI,2BnKgXU;AL8uhDlB;AwK5liDQ;EACI,2BnK6WM;ALivhDlB;AwK3liDQ;EACI,2BnKyWM;EmKxWN,wCAAA;AxK6liDZ;AwK3liDY;EACI,2BnKqWE;EmKpWd,wCAAA;AxK6liDJ;AwK1liDG;EACC,wCAAA;AxK4liDJ;;AwKtliDI;EACI,2BnKyVU;ALgwhDlB;AwKvliDQ;EACI,2BnKsVM;ALmwhDlB;AwKtliDQ;EACI,2BnKkVM;EmKjVN,wCAAA;AxKwliDZ;AwKtliDY;EACI,2BnK8UE;EmK7UF,wCAAA;AxKwliDhB;AwKrliDY;EACI,wCAAA;AxKuliDhB;;AwKlpiDI;EACI,qCAAA;AxKqpiDR;;AwKhpiDQ;EACI,wCAAA;AxKmpiDZ;;AwK7oiDQ;EACI,sCAAA;AxKgpiDZ;;AwK3oiDI;EACI,2BnKgXU;AL8xhDlB;AwK5oiDQ;EACI,2BnK6WM;ALiyhDlB;AwK3oiDQ;EACI,2BnKyWM;EmKxWN,qCAAA;AxK6oiDZ;AwK3oiDY;EACI,2BnKqWE;EmKpWd,qCAAA;AxK6oiDJ;AwK1oiDG;EACC,qCAAA;AxK4oiDJ;;AwKtoiDI;EACI,2BnKyVU;ALgzhDlB;AwKvoiDQ;EACI,2BnKsVM;ALmzhDlB;AwKtoiDQ;EACI,2BnKkVM;EmKjVN,qCAAA;AxKwoiDZ;AwKtoiDY;EACI,2BnK8UE;EmK7UF,qCAAA;AxKwoiDhB;AwKroiDY;EACI,qCAAA;AxKuoiDhB;;AwKlsiDI;EACI,wCAAA;AxKqsiDR;;AwKhsiDQ;EACI,2CAAA;AxKmsiDZ;;AwK7riDQ;EACI,yCAAA;AxKgsiDZ;;AwK3riDI;EACI,2BnKgXU;AL80hDlB;AwK5riDQ;EACI,2BnK6WM;ALi1hDlB;AwK3riDQ;EACI,2BnKyWM;EmKxWN,wCAAA;AxK6riDZ;AwK3riDY;EACI,2BnKqWE;EmKpWd,wCAAA;AxK6riDJ;AwK1riDG;EACC,wCAAA;AxK4riDJ;;AwKtriDI;EACI,2BnKyVU;ALg2hDlB;AwKvriDQ;EACI,2BnKsVM;ALm2hDlB;AwKtriDQ;EACI,2BnKkVM;EmKjVN,wCAAA;AxKwriDZ;AwKtriDY;EACI,2BnK8UE;EmK7UF,wCAAA;AxKwriDhB;AwKrriDY;EACI,wCAAA;AxKuriDhB;;AwKlviDI;EACI,uCAAA;AxKqviDR;;AwKhviDQ;EACI,0CAAA;AxKmviDZ;;AwK7uiDQ;EACI,wCAAA;AxKgviDZ;;AwK3uiDI;EACI,2BnKgXU;AL83hDlB;AwK5uiDQ;EACI,2BnK6WM;ALi4hDlB;AwK3uiDQ;EACI,2BnKyWM;EmKxWN,uCAAA;AxK6uiDZ;AwK3uiDY;EACI,2BnKqWE;EmKpWd,uCAAA;AxK6uiDJ;AwK1uiDG;EACC,uCAAA;AxK4uiDJ;;AwKtuiDI;EACI,2BnKyVU;ALg5hDlB;AwKvuiDQ;EACI,2BnKsVM;ALm5hDlB;AwKtuiDQ;EACI,2BnKkVM;EmKjVN,uCAAA;AxKwuiDZ;AwKtuiDY;EACI,2BnK8UE;EmK7UF,uCAAA;AxKwuiDhB;AwKruiDY;EACI,uCAAA;AxKuuiDhB;;AwKlyiDI;EACI,qCAAA;AxKqyiDR;;AwKhyiDQ;EACI,wCAAA;AxKmyiDZ;;AwK7xiDQ;EACI,sCAAA;AxKgyiDZ;;AwK3xiDI;EACI,2BnKgXU;AL86hDlB;AwK5xiDQ;EACI,2BnK6WM;ALi7hDlB;AwK3xiDQ;EACI,2BnKyWM;EmKxWN,qCAAA;AxK6xiDZ;AwK3xiDY;EACI,2BnKqWE;EmKpWd,qCAAA;AxK6xiDJ;AwK1xiDG;EACC,qCAAA;AxK4xiDJ;;AwKtxiDI;EACI,2BnKyVU;ALg8hDlB;AwKvxiDQ;EACI,2BnKsVM;ALm8hDlB;AwKtxiDQ;EACI,2BnKkVM;EmKjVN,qCAAA;AxKwxiDZ;AwKtxiDY;EACI,2BnK8UE;EmK7UF,qCAAA;AxKwxiDhB;AwKrxiDY;EACI,qCAAA;AxKuxiDhB;;AwKl1iDI;EACI,sCAAA;AxKq1iDR;;AwKn0iDI;EACI,2BnKgXU;ALs9hDlB;AwKp0iDQ;EACI,2BnK6WM;ALy9hDlB;AwKn0iDQ;EACI,2BnKyWM;EmKxWN,sCAAA;AxKq0iDZ;AwKn0iDY;EACI,2BnKqWE;EmKpWd,sCAAA;AxKq0iDJ;AwKl0iDG;EACC,sCAAA;AxKo0iDJ;;AwK9ziDI;EACI,2BnKyVU;ALw+hDlB;AwK/ziDQ;EACI,2BnKsVM;AL2+hDlB;AwK9ziDQ;EACI,2BnKkVM;EmKjVN,sCAAA;AxKg0iDZ;AwK9ziDY;EACI,2BnK8UE;EmK7UF,sCAAA;AxKg0iDhB;AwK7ziDY;EACI,sCAAA;AxK+ziDhB;;AwK13iDI;EACI,yCAAA;AxK63iDR;;AwK32iDI;EACI,2BnKgXU;AL8/hDlB;AwK52iDQ;EACI,2BnK6WM;ALigiDlB;AwK32iDQ;EACI,2BnKyWM;EmKxWN,yCAAA;AxK62iDZ;AwK32iDY;EACI,2BnKqWE;EmKpWd,yCAAA;AxK62iDJ;AwK12iDG;EACC,yCAAA;AxK42iDJ;;AwKt2iDI;EACI,2BnKyVU;ALghiDlB;AwKv2iDQ;EACI,2BnKsVM;ALmhiDlB;AwKt2iDQ;EACI,2BnKkVM;EmKjVN,yCAAA;AxKw2iDZ;AwKt2iDY;EACI,2BnK8UE;EmK7UF,yCAAA;AxKw2iDhB;AwKr2iDY;EACI,yCAAA;AxKu2iDhB;;AwKl6iDI;EACI,yCAAA;AxKq6iDR;;AwKn5iDI;EACI,2BnKgXU;ALsiiDlB;AwKp5iDQ;EACI,2BnK6WM;ALyiiDlB;AwKn5iDQ;EACI,2BnKyWM;EmKxWN,yCAAA;AxKq5iDZ;AwKn5iDY;EACI,2BnKqWE;EmKpWd,yCAAA;AxKq5iDJ;AwKl5iDG;EACC,yCAAA;AxKo5iDJ;;AwK94iDI;EACI,2BnKyVU;ALwjiDlB;AwK/4iDQ;EACI,2BnKsVM;AL2jiDlB;AwK94iDQ;EACI,2BnKkVM;EmKjVN,yCAAA;AxKg5iDZ;AwK94iDY;EACI,2BnK8UE;EmK7UF,yCAAA;AxKg5iDhB;AwK74iDY;EACI,yCAAA;AxK+4iDhB;;AwK18iDI;EACI,yCAAA;AxK68iDR;;AwK37iDI;EACI,2BnKgXU;AL8kiDlB;AwK57iDQ;EACI,2BnK6WM;ALiliDlB;AwK37iDQ;EACI,2BnKyWM;EmKxWN,yCAAA;AxK67iDZ;AwK37iDY;EACI,2BnKqWE;EmKpWd,yCAAA;AxK67iDJ;AwK17iDG;EACC,yCAAA;AxK47iDJ;;AwKt7iDI;EACI,2BnKyVU;ALgmiDlB;AwKv7iDQ;EACI,2BnKsVM;ALmmiDlB;AwKt7iDQ;EACI,2BnKkVM;EmKjVN,yCAAA;AxKw7iDZ;AwKt7iDY;EACI,2BnK8UE;EmK7UF,yCAAA;AxKw7iDhB;AwKr7iDY;EACI,yCAAA;AxKu7iDhB;;AwKl/iDI;EACI,yCAAA;AxKq/iDR;;AwKn+iDI;EACI,2BnKgXU;ALsniDlB;AwKp+iDQ;EACI,2BnK6WM;ALyniDlB;AwKn+iDQ;EACI,2BnKyWM;EmKxWN,yCAAA;AxKq+iDZ;AwKn+iDY;EACI,2BnKqWE;EmKpWd,yCAAA;AxKq+iDJ;AwKl+iDG;EACC,yCAAA;AxKo+iDJ;;AwK99iDI;EACI,2BnKyVU;ALwoiDlB;AwK/9iDQ;EACI,2BnKsVM;AL2oiDlB;AwK99iDQ;EACI,2BnKkVM;EmKjVN,yCAAA;AxKg+iDZ;AwK99iDY;EACI,2BnK8UE;EmK7UF,yCAAA;AxKg+iDhB;AwK79iDY;EACI,yCAAA;AxK+9iDhB;;AwK1hjDI;EACI,yCAAA;AxK6hjDR;;AwK3gjDI;EACI,2BnKgXU;AL8piDlB;AwK5gjDQ;EACI,2BnK6WM;ALiqiDlB;AwK3gjDQ;EACI,2BnKyWM;EmKxWN,yCAAA;AxK6gjDZ;AwK3gjDY;EACI,2BnKqWE;EmKpWd,yCAAA;AxK6gjDJ;AwK1gjDG;EACC,yCAAA;AxK4gjDJ;;AwKtgjDI;EACI,2BnKyVU;ALgriDlB;AwKvgjDQ;EACI,2BnKsVM;ALmriDlB;AwKtgjDQ;EACI,2BnKkVM;EmKjVN,yCAAA;AxKwgjDZ;AwKtgjDY;EACI,2BnK8UE;EmK7UF,yCAAA;AxKwgjDhB;AwKrgjDY;EACI,yCAAA;AxKugjDhB;;AwKlkjDI;EACI,yCAAA;AxKqkjDR;;AwKnjjDI;EACI,2BnKgXU;ALssiDlB;AwKpjjDQ;EACI,2BnK6WM;ALysiDlB;AwKnjjDQ;EACI,2BnKyWM;EmKxWN,yCAAA;AxKqjjDZ;AwKnjjDY;EACI,2BnKqWE;EmKpWd,yCAAA;AxKqjjDJ;AwKljjDG;EACC,yCAAA;AxKojjDJ;;AwK9ijDI;EACI,2BnKyVU;ALwtiDlB;AwK/ijDQ;EACI,2BnKsVM;AL2tiDlB;AwK9ijDQ;EACI,2BnKkVM;EmKjVN,yCAAA;AxKgjjDZ;AwK9ijDY;EACI,2BnK8UE;EmK7UF,yCAAA;AxKgjjDhB;AwK7ijDY;EACI,yCAAA;AxK+ijDhB;;AwK1mjDI;EACI,yCAAA;AxK6mjDR;;AwK3ljDI;EACI,2BnKgXU;AL8uiDlB;AwK5ljDQ;EACI,2BnK6WM;ALiviDlB;AwK3ljDQ;EACI,2BnKyWM;EmKxWN,yCAAA;AxK6ljDZ;AwK3ljDY;EACI,2BnKqWE;EmKpWd,yCAAA;AxK6ljDJ;AwK1ljDG;EACC,yCAAA;AxK4ljDJ;;AwKtljDI;EACI,2BnKyVU;ALgwiDlB;AwKvljDQ;EACI,2BnKsVM;ALmwiDlB;AwKtljDQ;EACI,2BnKkVM;EmKjVN,yCAAA;AxKwljDZ;AwKtljDY;EACI,2BnK8UE;EmK7UF,yCAAA;AxKwljDhB;AwKrljDY;EACI,yCAAA;AxKuljDhB;;AwKlpjDI;EACI,yCAAA;AxKqpjDR;;AwKnojDI;EACI,2BnKgXU;ALsxiDlB;AwKpojDQ;EACI,2BnK6WM;ALyxiDlB;AwKnojDQ;EACI,2BnKyWM;EmKxWN,yCAAA;AxKqojDZ;AwKnojDY;EACI,2BnKqWE;EmKpWd,yCAAA;AxKqojDJ;AwKlojDG;EACC,yCAAA;AxKoojDJ;;AwK9njDI;EACI,2BnKyVU;ALwyiDlB;AwK/njDQ;EACI,2BnKsVM;AL2yiDlB;AwK9njDQ;EACI,2BnKkVM;EmKjVN,yCAAA;AxKgojDZ;AwK9njDY;EACI,2BnK8UE;EmK7UF,yCAAA;AxKgojDhB;AwK7njDY;EACI,yCAAA;AxK+njDhB;;AwK1rjDI;EACI,yCAAA;AxK6rjDR;;AwK3qjDI;EACI,2BnKgXU;AL8ziDlB;AwK5qjDQ;EACI,2BnK6WM;ALi0iDlB;AwK3qjDQ;EACI,2BnKyWM;EmKxWN,yCAAA;AxK6qjDZ;AwK3qjDY;EACI,2BnKqWE;EmKpWd,yCAAA;AxK6qjDJ;AwK1qjDG;EACC,yCAAA;AxK4qjDJ;;AwKtqjDI;EACI,2BnKyVU;ALg1iDlB;AwKvqjDQ;EACI,2BnKsVM;ALm1iDlB;AwKtqjDQ;EACI,2BnKkVM;EmKjVN,yCAAA;AxKwqjDZ;AwKtqjDY;EACI,2BnK8UE;EmK7UF,yCAAA;AxKwqjDhB;AwKrqjDY;EACI,yCAAA;AxKuqjDhB;;AwKhqjDA;EACI,kBAAA;AxKmqjDJ;;AwK/pjDA;EACI,eAAA;AxKkqjDJ;;AwK9pjDA;EACI,eAAA;AxKiqjDJ;;AwK9pjDA;EACI,YAAA;AxKiqjDJ;;AwK5pjDI;EAOI,cAAA;EACA,eAAA;EACA,2BAAA;AxKypjDR;;AwKppjDA;EACI,2BnK+Rc;ALw3iDlB;AwKrpjDI;EACI,2BnK4RU;AL23iDlB;;AyKhwjDC;EACC,qBAAA;AzKmwjDF;;AyK9vjDE;EAEC,qBAAA;AzKgwjDH;;AyKxwjDC;EACC,wBAAA;AzK2wjDF;;AyKtwjDE;EAEC,wBAAA;AzKwwjDH;;AyKhxjDC;EACC,uBAAA;AzKmxjDF;;AyK9wjDE;EAEC,uBAAA;AzKgxjDH;;AyKxxjDC;EACC,wBAAA;AzK2xjDF;;AyKtxjDE;EAEC,wBAAA;AzKwxjDH;;AyKhyjDC;EACC,uBAAA;AzKmyjDF;;AyK9xjDE;EAEC,uBAAA;AzKgyjDH;;AyKxyjDC;EACC,wBAAA;AzK2yjDF;;AyKtyjDE;EAEC,wBAAA;AzKwyjDH;;AyKhzjDC;EACC,uBAAA;AzKmzjDF;;AyK9yjDE;EAEC,uBAAA;AzKgzjDH;;AyKxzjDC;EACC,wBAAA;AzK2zjDF;;AyKtzjDE;EAEC,wBAAA;AzKwzjDH;;AyKh0jDC;EACC,qBAAA;AzKm0jDF;;AyK9zjDE;EAEC,qBAAA;AzKg0jDH;;A0K10jDA;EACI,wBAAA;EACA,2BAAA;A1K60jDJ;;A2K90jDA;EACI,6BAAA;EACA,oCAAA;EACA,qCAAA;EAEA,qDAAA;EACA,qDAAA;EACA,+DAAA;EAEA,6DAAA;EACA,mCAAA;EACA,uEAAA;EAEA,+CAAA;EACA,uDAAA;EACA,yDAAA;EAEA,0DAAA;EAEA,qCAAA;EACA,2CAAA;EACA,6CAAA;EAEA,+CAAA;EACA,uDAAA;EACA,yDAAA;EAEA,oCAAA;EACA,4CAAA;EACA,8CAAA;EAEA,8CAAA;EACA,sDAAA;EACA,wDAAA;EAEA,6DAAA;A3Kw0jDJ;;A4Kp2jDA;EACI,yBARiB;A5K+2jDrB;;A4Kp2jDA;EACI,cAZiB;A5Km3jDrB;;A4Kp2jDA;EACI,0BAAA;A5Ku2jDJ;;A4Kp2jDA;EACI,8BAAA;A5Ku2jDJ;;A4Kp2jDA;EACI,kBAAA;A5Ku2jDJ;A4Kr2jDI;EACI,kBAAA;EACA,MAAA;EACA,cAAA;A5Ku2jDR;;A4Kl2jDA;EACI,aAAA;EACA,mBAAA;EACA,aApCoB;A5Ky4jDxB;A4Kl2jDI;EACI,cAAA;A5Ko2jDR;A4Kj2jDI;EACI,aAAA;A5Km2jDR;A4K51jDY;EACI,cjKnDG;AXi5jDnB;A4Kt1jDgB;EACI,cjKxDK;EiKyDL,0CAAA;A5Kw1jDpB;A4Kj1jDI;EACI,UAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,yBjK3EW;EiK4EX,qDAAA;EACA,YA5EuB;A5K+5jD/B;A4Kh1jDQ;EACI,cAAA;A5Kk1jDZ;A4K/0jDQ;EACI,aAAA;A5Ki1jDZ;;A4K30jDA;EACI,kBA7FoB;A5K26jDxB;;Aer2jDI;E6J6BA;IACI,YAnGkC;E5K+6jDxC;E4Kz0jDM;IACI,kBAAA;IACA,cAAA;E5K20jDV;E4Kv0jDM;IACI,YA3GqC;E5Ko7jD/C;E4Kl0jDc;IACI,cjKjHK;IiKkHL,0CAAA;E5Ko0jDlB;;E4K7zjDE;IACI,iBA9HkC;E5K87jDxC;AACF;A6Kl8jDA;;ECEQ,0BAAA;EAAA,gCAAA;EAAA,sCAAA;EAAA,6CAAA;EAAA,0EAAA;EAAA,iFAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,2EAAA;EAAA,kFAAA;EAAA,mDAAA;EAAA,0DAAA;EAAA,iCAAA;EAAA,wCAAA;A9Ki9jDR;;A6K1tjDA;ECvPQ,0BAAA;EAAA,gCAAA;EAAA,sCAAA;EAAA,6CAAA;EAAA,qCAAA;EAAA,4CAAA;EAAA,uCAAA;EAAA,8CAAA;EAAA,sCAAA;EAAA,kFAAA;EAAA,mCAAA;EAAA,0DAAA;EAAA,iCAAA;EAAA,wCAAA;A9Kk+jDR;;A+Kp+jDA;EACE,uBAAA;EACA,sBAAA;A/Ku+jDF;;A+Kp+jDA;;EAEI,YAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,kCAAA;EACA,0BAAA;EACA,gB1KqaiB;E0KpajB,2C1K4ZqB;AL2kjDzB;Ae76jDI;EgKnEJ;;IAaQ,0BAAA;E/Kw+jDN;AACF;Aen7jDI;EgKnEJ;;IAkBQ,0BAAA;E/Ky+jDN;AACF;;A+Kt+jDA;EACI,aAAA;EACA,sBAAA;A/Ky+jDJ;A+Kv+jDI;;;EAGI,gCAAA;A/Ky+jDR;;A+Kr+jDA;EACI,yBAAA;UAAA,iBAAA;A/Kw+jDJ;;A+Kp+jDA;EACI,aAAA;A/Ku+jDJ;;A+Kn+jDA;;EAEI,wCAAA;A/Ks+jDJ;;A+Kn+jDA;EACI,8CAAA;A/Ks+jDJ;;A+Kl+jDA;EACI,2BAAA;A/Kq+jDJ;;AgLhikDA;EACI,aAAA;AhLmikDJ;;AiLnikDA;EACC,gBAAA;AjLsikDD;;AiLnikDA;EACI,2BAAA;AjLsikDJ;;AiLlikDA;EACC,6BAAA;EACA,2BAAA;EACA,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;EACG,aAAA;AjLqikDJ;AiLnikDI;EACF,aAAA;EACA,uBAAA;EACG,mBAAA;AjLqikDL;;AelgkDI;EmKzDH;IACC,6BAAA;IACM,8BAAA;ElL+jkDN;;EkL5jkDD;IACC,0BAAA;IACA,2BAAA;ElL+jkDA;AACF;AejgkDI;EmKzDH;IACC,eAAA;IACA,6BAAA;IACM,8BAAA;ElL6jkDN;;EkL1jkDD;IACC,0BAAA;IACA,2BAAA;ElL6jkDA;AACF;AmLplkDA;EACI;IACI,qBAAA;IACA,2BAAA;EnLslkDN;EmLplkDM;;;;;IAKI,2BAAA;IACA,qBAAA;IACA,oBAAA;EnLslkDV;EmLnlkDM;;;;;;;;;;IAUI,wBAAA;EnLqlkDV;AACF;AoLhnkDA;EACI,aAAA;EACA,oBAAA;ApLknkDJ;AoLhnkDI;EACI,aAAA;EACA,mBAAA;ApLknkDR;AoL9mkDQ;EACI,oBAAA;ApLgnkDZ;;AqL1nkDA;EACI,gBC0CyB;EDzCzB,aAAA;EACA,oBAAA;ArL6nkDJ;;AetkkDI;EsKjDA;IAGI,oDAAA;IACA,gDAAA;IACA,sDAAA;ErLynkDN;;EqLrnkDE;IACI,4BAAA;IACA,mCAAA;ErLwnkDN;;EqLrnkDE;IACI,4BAAA;IACA,mCAAA;ErLwnkDN;;EqLrnkDE;IACI,mHAAA;IACA,gDAAA;ErLwnkDN;;EqLrnkDE;IACI,4BAAA;ErLwnkDN;;EqLpnkDE;IACI,mCAAA;ErLunkDN;EqLrnkDM;IPxCA,YAAA;IO0CI,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;ErLunkDV;EqLpnkDM;IACI,kBAAA;ErLsnkDV;EqLnnkDM;IACI,sBAAA;IACA,8FAAA;ErLqnkDV;EqLlnkDM;IACI,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IP7DJ,YAAA;IOiEI,sDAAA;IACA,kDAAA;IACA,wDAAA;ErLknkDV;EqL/mkDM;IACI,gBC7BiB;IR1CrB,YAAA;IO2EI,wDAAA;IACA,oDAAA;IACA,0DAAA;ErL+mkDV;EqL5mkDM;IACI,aAAA;ErL8mkDV;;EqLvmkDM;IAEI,mHAAA;ErLymkDV;EqLlmkDM;IAEI,0HAAA;ErLmmkDV;EqL3lkDM;IAEI,+OAAA;ErL4lkDV;EqLllkDM;IAEI,sPAAA;ErLmlkDV;EqLxkkDM;IACI,gBAAA;ErL0kkDV;AACF;Ae1okDI;EsKuEA;IAGI,2DAAA;IACA,uDAAA;IACA,6DAAA;ErLokkDN;;EqLhkkDE;IACI,4BAAA;ErLmkkDN;;EqLhkkDE;IACI,4BAAA;IACA,mCAAA;ErLmkkDN;;EqLhkkDE;IACI,4BAAA;IACA,mCAAA;ErLmkkDN;;EqL/jkDE;IACI,mCAAA;IACA,oBAAA;ErLkkkDN;EqLhkkDM;IACI,aAAA;ErLkkkDV;EqL/jkDM;IACI,sBAAA;ErLikkDV;EqL9jkDM;IPjLA,YAAA;IOmLI,gBCzIiB;ID0IjB,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;ErLgkkDV;EqL7jkDM;IACI,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IP9LJ,YAAA;IOkMI,6DAAA;IACA,yDAAA;IACA,+DAAA;ErL6jkDV;EqL1jkDM;IPvMA,YAAA;IO2MI,gBCjKiB;IDkKjB,+DAAA;IACA,2DAAA;IACA,iEAAA;ErL0jkDV;;EqLnjkDM;IACI,gBAAA;ErLsjkDV;EqLnjkDM;IACI,gBAAA;ErLqjkDV;AACF;AuLjxkDA;EACI,gBDyGiC;ECxGjC,aAAA;EACA,oBAAA;AvLmxkDJ;;Ae5tkDI;EwKjDA;IAGI,4DAAA;IACA,wDAAA;IACA,8DAAA;EvL+wkDN;;EuL3wkDE;IACI,oCAAA;EvL8wkDN;;EuL3wkDE;IACI,oCAAA;EvL8wkDN;;EuL3wkDE;IACI,oCAAA;EvL8wkDN;;EuL3wkDE;IACI,iCAAA;EvL8wkDN;;EuL1wkDE;IACI,2CAAA;EvL6wkDN;EuL3wkDM;ITrCA,YAAA;ISuCI,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;EvL6wkDV;EuL1wkDM;IACI,kBAAA;EvL4wkDV;EuLzwkDM;IACI,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;ITrDJ,YAAA;IAAA,YAAA;ISyDI,8DAAA;IACA,0DAAA;IACA,gEAAA;EvL0wkDV;EuLvwkDM;IACI,gBD0CyB;IRzG7B,YAAA;IAAA,YAAA;ISmEI,gEAAA;IACA,4DAAA;IACA,kEAAA;EvLwwkDV;EuLrwkDM;IACI,wBAAA;EvLuwkDV;;EuLhwkDM;IACI,mHAAA;EvLmwkDV;EuL3vkDM;IACI,+OAAA;EvL6vkDV;AACF;AelxkDI;EwKmCA;IACI,YAAA;IAGA,mEAAA;IACA,+DAAA;IACA,qEAAA;EvLgvkDN;AACF;AwLj2kDA;EACI,gBFmJmC;EElJnC,aAAA;EACA,oBAAA;AxLm2kDJ;;Ae5ykDI;EyKjDA;IAGI,8DAAA;IACA,0DAAA;IACA,gEAAA;ExL+1kDN;;EwL31kDE;IACI,sCAAA;ExL81kDN;;EwL31kDE;IACI,sCAAA;ExL81kDN;;EwL31kDE;IACI,sCAAA;ExL81kDN;;EwL31kDE;IACI,mCAAA;ExL81kDN;;EwL11kDE;IACI,6CAAA;ExL61kDN;EwL31kDM;IVrCA,YAAA;IUuCI,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;ExL61kDV;EwL11kDM;IACI,gBAAA;ExL41kDV;EwLz1kDM;IACI,gBFiG2B;IEhG3B,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IVtDJ,YAAA;IAAA,YAAA;IU0DI,gEAAA;IACA,4DAAA;IACA,kEAAA;ExL01kDV;EwLv1kDM;IACI,gBFmF2B;IRnJ/B,YAAA;IAAA,YAAA;IUoEI,kEAAA;IACA,8DAAA;IACA,oEAAA;ExLw1kDV;EwLr1kDM;IACI,wBAAA;ExLu1kDV;;EwLh1kDM;IACI,mHAAA;ExLm1kDV;EwL30kDM;IACI,+OAAA;ExL60kDV;AACF;Aen2kDI;EyKoCA;IACI,YAAA;IACA,qEAAA;IACA,iEAAA;IACA,oEAAA;IACA,mEAAA;ExLk0kDN;AACF;AyLn7kDA;EACI,aAAA;EACA,oBAAA;AzLq7kDJ;AyLn7kDI;EACI,gBH4LsB;AtLyvkD9B;;Aeh4kDI;E0K9CA;IACI,qDAAA;IACA,iDAAA;IACA,iDAAA;IACA,uDAAA;EzLk7kDN;;EyL96kDE;IACI,6BAAA;IACA,oCAAA;EzLi7kDN;;EyL96kDE;IACI,6BAAA;EzLi7kDN;;EyL96kDE;IACI,6BAAA;EzLi7kDN;;EyL76kDE;IACI,oCAAA;EzLg7kDN;EyL96kDM;IXpCA,WAAA;IWsCI,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;EzLg7kDV;EyL76kDM;IACI,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IXhDJ,WAAA;IWoDI,mDAAA;IACA,uDAAA;IACA,mDAAA;IACA,yDAAA;EzL66kDV;EyL16kDM;IACI,gBHqIkB;IRhMtB,WAAA;IW+DI,qDAAA;IACA,yDAAA;IACA,qDAAA;IACA,2DAAA;EzL06kDV;;EyLn6kDM;IACI,gCAAA;EzLs6kDV;EyLl6kDM;IAEI,mHAAA;EzLm6kDV;EyL35kDM;IAEI,+OAAA;EzL45kDV;EyLj5kDM;IAEI,8GAAA;EzLk5kDV;AACF;Aep7kDI;E0K6CA;IXnHI,WAAA;IWsHA,wDAAA;IACA,4DAAA;IACA,wDAAA;IACA,8DAAA;EzLy4kDN;;EyLr4kDE;IACI,yBAAA;EzLw4kDN;;EyLr4kDE;IACI,6BAAA;EzLw4kDN;;EyLr4kDE;IACI,6BAAA;EzLw4kDN;;EyLp4kDE;IACI,oCAAA;EzLu4kDN;EyLr4kDM;IX7IA,WAAA;IW+II,eAAA;IACA,qFAAA;IACA,OAAA;IACA,QAAA;EzLu4kDV;EyLp4kDM;IACI,eAAA;IACA,OAAA;IACA,QAAA;IACA,qCAAA;IAEA,0DAAA;IACA,8DAAA;IACA,0DAAA;IACA,gEAAA;IX9JJ,WAAA;E9KoilDN;EyLh4kDM;IACI,gBH2BkB;IGzBlB,4DAAA;IACA,gEAAA;IACA,4DAAA;IACA,kEAAA;IX1KJ,WAAA;E9K4ilDN;AACF;A0L9ilDA;EACI,aAAA;EACA,oBAAA;EACA,6CAAA;EACA,yCAAA;EACA,yCAAA;EACA,+CAAA;A1LgjlDJ;;A2LtjlDA;EACI,2BLiR0B;AtLwykD9B;;A2LrjlDA;;;;;EAKI,aAAA;A3LwjlDJ;;AexglDI;E4K1CA;IACI,aAAA;IACA,cAAA;IACA,kCAAA;IAEA,qDAAA;IACA,iDAAA;IACA,oDAAA;IACA,mDAAA;IbvBA,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9KgllDN;;E2L/ilDE;IACI,6BAAA;IACA,oCAAA;IAEA,+BAAA;IACA,6BAAA;IACA,6BAAA;IACA,gCAAA;E3LijlDN;;E2L9ilDE;IACI,yGAAA;E3LijlDN;;E2L9ilDE;IACI,4BAAA;IAEA,+BAAA;IACA,6BAAA;IACA,6BAAA;IACA,gCAAA;E3LgjlDN;;E2L7ilDE;IACI,6BAAA;IAEA,+BAAA;IACA,6BAAA;IACA,6BAAA;IACA,gCAAA;E3L+ilDN;;E2L5ilDE;IACI,2BAAA;E3L+ilDN;;E2L1ilDM;IACI,kBAAA;E3L6ilDV;E2L1ilDM;IACI,aAAA;E3L4ilDV;E2LzilDM;IACI,eAAA;IbhFJ,YAAA;IAAA,MAAA;IAAA,SAAA;IAAA,OAAA;E9K+nlDN;E2LxilDM;IACI,oBAAA;E3L0ilDV;E2LvilDM;IACI,eAAA;IACA,2BLoLkB;IRjRtB,SAAA;IAAA,YAAA;IAAA,UAAA;IAAA,YAAA;IamGI,mDAAA;IACA,sDAAA;IACA,qDAAA;IbrGJ,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9KiplDN;E2LpilDM;IACI,2BLmKkB;IKjKlB,yDAAA;IACA,qDAAA;IACA,wDAAA;IACA,uDAAA;IbnHJ,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9K4plDN;E2LhilDU;IACI,yCAAA;E3LkilDd;E2L9hlDM;IACI,2BL+IkB;IK9I3B,yCAAA;E3LgilDD;E2L5hlDM;IACI,2BLyIkB;IKxIlB,yCAAA;IACA,0DAAA;E3L8hlDV;;E2LxhlDM;IACI,wBAAA;E3L2hlDV;E2LxhlDM;IACI,wBAAA;E3L0hlDV;;E2LrhlDM;IACI,wBAAA;E3LwhlDV;E2LrhlDM;IACI,wBAAA;E3LuhlDV;;E2LlhlDM;IACI,wBAAA;E3LqhlDV;E2LlhlDM;IACI,wBAAA;E3LohlDV;;E2L7glDM;IACI,gCAAA;E3LghlDV;E2L5glDM;IACI,0EAAA;E3L8glDV;AACF;Ae/nlDI;E4KwHA;IACI,aAAA;IACA,kCAAA;IAEA,4DAAA;IACA,wDAAA;IACA,2DAAA;IACA,0DAAA;IbrMA,YAAA;IAAA,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9KmtlDN;;E2LpglDE;IACI,6BAAA;IACA,oCAAA;IAEA,+BAAA;IACA,6BAAA;IACA,6BAAA;IACA,gCAAA;E3LsglDN;;E2LnglDE;IACI,4BAAA;IAEA,+BAAA;IACA,6BAAA;IACA,6BAAA;IACA,gCAAA;E3LqglDN;;E2LlglDE;IACI,2BAAA;E3LqglDN;;E2LhglDM;IACI,oBAAA;E3LmglDV;E2LhglDM;IACI,2BLoCkB;IKlClB,iEAAA;IACA,4DAAA;IACA,+DAAA;IACA,8DAAA;IblPJ,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9KuvlDN;E2L5/kDU;IACI,yCAAA;E3L8/kDd;E2L1/kDM;IACI,2BLgBkB;IKf3B,yCAAA;IACS,kEAAA;E3L4/kDV;E2Lz/kDM;IACI,2BLUkB;IKTlB,yCAAA;IACA,0DAAA;E3L2/kDV;;E2Lr/kDM;IACI,wBAAA;E3Lw/kDV;E2Lr/kDM;IACI,wBAAA;E3Lu/kDV;;E2Ll/kDM;IACI,wBAAA;E3Lq/kDV;E2Ll/kDM;IACI,wBAAA;E3Lo/kDV;AACF;A4LpxlDA;EACI,gBNyWkC;EMxWlC,kBAAA;EACA,cAAA;A5LsxlDJ;;A4LlxlDA;;;;EAII,aAAA;A5LqxlDJ;;AetulDI;E6KzCA;IACI,6DAAA;IACA,yDAAA;IACA,4DAAA;IACA,2DAAA;IdpBA,UAAA;IAAA,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9K4ylDN;;E4L9wlDE;IACI,4CAAA;E5LixlDN;;E4L9wlDE;IACI,qCAAA;IAEA,uCAAA;IACA,qCAAA;IACA,qCAAA;IACA,wCAAA;E5LgxlDN;;E4L7wlDE;IACI,oCAAA;IAEA,uCAAA;IACA,qCAAA;IACA,qCAAA;IACA,wCAAA;E5L+wlDN;;E4L5wlDE;IACI,mCAAA;E5L+wlDN;;E4L3wlDE;IACI,0CAAA;E5L8wlDN;E4L5wlDM;IACI,gBN4S0B;IM3S1B,iDAAA;IACA,kEAAA;E5L8wlDV;E4L3wlDM;IACI,gBNsS0B;IMpS1B,iEAAA;IACA,6DAAA;IACA,gEAAA;IACA,+DAAA;IdxEJ,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9Kw1lDN;E4LvwlDU;IACI,iDAAA;E5LywlDd;E4LpwlDM;IACI,gBNiR0B;IMhRnC,iDAAA;IACS,mEAAA;E5LswlDV;;E4L/vlDM;IACI,gCAAA;E5LkwlDV;E4L9vlDM;IACI,wEAAA;E5LgwlDV;;E4L1vlDM;IACI,wBAAA;E5L6vlDV;E4L1vlDM;IACI,wBAAA;E5L4vlDV;;E4LvvlDM;IACI,wBAAA;E5L0vlDV;E4LvvlDM;IACI,wBAAA;E5LyvlDV;AACF;AehzlDI;E6K8DA;IdpII,UAAA;IcuIA,oEAAA;IACA,gEAAA;IACA,mEAAA;IACA,kEAAA;Id1IA,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9Kk4lDN;;E4L/ulDE;IACI,4CAAA;E5LkvlDN;;E4L/ulDE;IACI,qCAAA;IAEA,uCAAA;IACA,qCAAA;IACA,qCAAA;IACA,wCAAA;E5LivlDN;;E4L9ulDE;IACI,oCAAA;IAEA,uCAAA;IACA,qCAAA;IACA,qCAAA;IACA,wCAAA;E5LgvlDN;;E4L7ulDE;IACI,mCAAA;E5LgvlDN;;E4L5ulDE;IACI,0CAAA;E5L+ulDN;E4L7ulDM;IACI,gBNuL0B;IMtL1B,iDAAA;IACA,kEAAA;E5L+ulDV;E4L5ulDM;IACI,gBNiL0B;IMhL1B,wEAAA;IACA,gEAAA;IACA,uEAAA;IACA,qEAAA;Id5LJ,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9K86lDN;E4LzulDU;IACI,iDAAA;E5L2ulDd;E4LvulDM;IACI,gBN8J0B;IM7JnC,iDAAA;IACS,0EAAA;E5LyulDV;;E4LnulDM;IACI,wBAAA;E5LsulDV;E4LnulDM;IACI,wBAAA;E5LqulDV;;E4LhulDM;IACI,wBAAA;E5LmulDV;E4LhulDM;IACI,wBAAA;E5LkulDV;AACF;A6Lt8lDA;EACI,gBPwaoC;EOvapC,kBAAA;EACA,cAAA;A7Lw8lDJ;;A6Lp8lDA;;;;EAII,aAAA;A7Lu8lDJ;;Aex5lDI;E8KzCA;IAGI,+DAAA;IACA,2DAAA;IACA,8DAAA;IACA,6DAAA;IftBA,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9K69lDN;;E6L97lDE;IACI;;;;;;;KAAA;E7Lw8lDN;;E6L97lDE;IACI;;;;;;;KAAA;IASA,yCAAA;IACA,uCAAA;IACA,uCAAA;IACA,0CAAA;E7Lg8lDN;;E6L77lDE;IACI,sCAAA;IAEA,yCAAA;IACA,uCAAA;IACA,uCAAA;IACA,0CAAA;E7L+7lDN;;E6L57lDE;IACI;;;;;;;KAAA;IASA,qCAAA;E7L87lDN;;E6L17lDE;IACI,4CAAA;E7L67lDN;E6L37lDM;IACI,gBPmV4B;IOlV5B,mDAAA;IACA,oEAAA;E7L67lDV;E6L17lDM;IACI,gBP6U4B;IO3U5B,mEAAA;IACA,+DAAA;IACA,kEAAA;IACA,iEAAA;IfhGJ,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9K+hmDN;E6Lt7lDU;IACI,mDAAA;E7Lw7lDd;E6Lp7lDM;IACI,gBPyT4B;IOxTrC,mDAAA;IACS,qEAAA;E7Ls7lDV;;E6L/6lDM;IACI,gCAAA;E7Lk7lDV;E6L96lDM;IACI,wEAAA;E7Lg7lDV;;E6L16lDM;IACI,wBAAA;E7L66lDV;E6L16lDM;IACI,wBAAA;E7L46lDV;;E6Lv6lDM;IACI,wBAAA;E7L06lDV;E6Lv6lDM;IACI,wBAAA;E7Ly6lDV;AACF;Aev/lDI;E8KqFA;IAGI,sEAAA;IACA,kEAAA;IACA,qEAAA;IACA,oEAAA;IfjKA,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9KwkmDN;;E6L95lDE;IACI;;;;;;;KAAA;E7Lw6lDN;;E6L95lDE;IACI;;;;;;;KAAA;IASA,yCAAA;IACA,uCAAA;IACA,uCAAA;IACA,0CAAA;E7Lg6lDN;;E6L75lDE;IACI,sCAAA;IAEA,yCAAA;IACA,uCAAA;IACA,uCAAA;IACA,0CAAA;E7L+5lDN;;E6L55lDE;IACI;;;;;;;KAAA;IASA,qCAAA;E7L85lDN;;E6L15lDE;IACI,4CAAA;E7L65lDN;E6L35lDM;IACI,gBPwM4B;IOvM5B,mDAAA;IACA,oEAAA;E7L65lDV;E6L15lDM;IACI,gBPkM4B;IOjM5B,0EAAA;IACA,sEAAA;IACA,yEAAA;IACA,wEAAA;If1OJ,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9K0omDN;E6Lv5lDU;IACI,mDAAA;E7Ly5lDd;E6Lr5lDM;IACI,gBP+K4B;IO9KrC,mDAAA;IACS,4EAAA;E7Lu5lDV;;E6Lj5lDM;IACI,wBAAA;E7Lo5lDV;E6Lj5lDM;IACI,wBAAA;E7Lm5lDV;;E6L94lDM;IACI,wBAAA;E7Li5lDV;E6L94lDM;IACI,wBAAA;E7Lg5lDV;AACF;A8LlqmDA;EACI,gBRqegC;AtL+rlDpC;;A8LhqmDA;;;;;EAKI,aAAA;A9LmqmDJ;;AennmDI;E+K1CA;IACI,aAAA;IACA,cAAA;IACA,wCAAA;IACA,2DAAA;IACA,uDAAA;IACA,0DAAA;IACA,yDAAA;IhBtBA,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9K2rmDN;;E8L3pmDE;IACI,mCAAA;IACA,0CAAA;IAEA,qCAAA;IACA,mCAAA;IACA,mCAAA;IACA,sCAAA;E9L6pmDN;;E8L1pmDE;IACI,kCAAA;IAEA,qCAAA;IACA,mCAAA;IACA,mCAAA;IACA,sCAAA;E9L4pmDN;;E8LzpmDE;IACI,mCAAA;IAEA,qCAAA;IACA,mCAAA;IACA,mCAAA;IACA,sCAAA;E9L2pmDN;;E8LxpmDE;IACI,0CAAA;IACA,iCAAA;E9L2pmDN;;E8LtpmDM;IACI,kBAAA;E9LypmDV;E8LtpmDM;IACI,aAAA;E9LwpmDV;E8LrpmDM;IhB3EA,YAAA;IgB6EI,eAAA;IACA,mHAAA;IACA,MAAA;IACA,SAAA;E9LupmDV;E8LppmDM;IACI,eAAA;IACA,mHAAA;IACA,MAAA;IACA,SAAA;IACA,gBR6YwB;IQ3YxB,yDAAA;IACA,4DAAA;IACA,2DAAA;IhB5FJ,YAAA;IAAA,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9KsvmDN;E8LjpmDM;IACI,gBR+XwB;IQ9XxB,+DAAA;IACA,2DAAA;IACA,8DAAA;IACA,6DAAA;IhB1GJ,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9KiwmDN;E8L7omDU;IACI,+CAAA;E9L+omDd;E8L3omDM;IACI,gBR2WwB;IQ1WjC,+CAAA;IACS,iEAAA;E9L6omDV;E8L1omDM;IACI,gBRqWwB;IQpWxB,+CAAA;IACA,8IAAA;E9L4omDV;;E8LromDM;IACI,gCAAA;E9LwomDV;E8LpomDM;IACI,wEAAA;E9LsomDV;;E8LhomDM;IACI,wBAAA;E9LmomDV;E8LhomDM;IACI,wBAAA;E9LkomDV;;E8L7nmDM;IACI,wBAAA;E9LgomDV;E8L7nmDM;IACI,wBAAA;E9L+nmDV;;E8L1nmDM;IACI,wBAAA;E9L6nmDV;E8L1nmDM;IACI,wBAAA;E9L4nmDV;AACF;AerumDI;E+KgHA;IACI,aAAA;IACA,wCAAA;IAEA,kEAAA;IACA,8DAAA;IACA,iEAAA;IACA,gEAAA;IhB7LA,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9KwzmDN;;E8LjnmDE;IACI,qCAAA;IACA,mCAAA;IACA,mCAAA;IACA,sCAAA;E9LonmDN;;E8LjnmDE;IACI,kCAAA;IAEA,qCAAA;IACA,mCAAA;IACA,mCAAA;IACA,sCAAA;E9LmnmDN;;E8LhnmDE;IACI,0CAAA;IACA,iCAAA;E9LmnmDN;;E8L9mmDM;IACI,gBRsQwB;IQpQxB,sEAAA;IACA,kEAAA;IACA,qEAAA;IACA,oEAAA;IhBpOJ,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9Kw1mDN;E8L3mmDU;IACI,+CAAA;E9L6mmDd;E8LzmmDM;IACI,gBRkPwB;IQjPjC,+CAAA;IAES,wEAAA;E9L0mmDV;E8LvmmDM;IACI,gBR2OwB;IQ1OxB,+CAAA;IACA,gEAAA;E9LymmDV;;E8LnmmDM;IACI,wBAAA;E9LsmmDV;E8LnmmDM;IACI,wBAAA;E9LqmmDV;;E8LhmmDM;IACI,wBAAA;E9LmmmDV;E8LhmmDM;IACI,wBAAA;E9LkmmDV;AACF;A+Lr3mDA;EACI,gBT8jBwB;AtLyzlD5B;;A+Ln3mDA;;;;;EAKI,aAAA;A/Ls3mDJ;;Aet0mDI;EgL1CA;IACI,aAAA;IACA,cAAA;IACA,gCAAA;IACA,mDAAA;IACA,+CAAA;IACA,iDAAA;IACA,mDAAA;IjBtBA,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9K84mDN;;E+L92mDE;IACI,2BAAA;IACA,kCAAA;IAEA,6BAAA;IACA,2BAAA;IACA,2BAAA;IACA,8BAAA;E/Lg3mDN;;E+L72mDE;IACI,mGAAA;E/Lg3mDN;;E+L72mDE;IACI,0BAAA;IAEA,6BAAA;IACA,2BAAA;IACA,2BAAA;IACA,8BAAA;E/L+2mDN;;E+L52mDE;IACI,2BAAA;IAEA,6BAAA;IACA,2BAAA;IACA,2BAAA;IACA,8BAAA;E/L82mDN;;E+L32mDE;IACI,yBAAA;E/L82mDN;;E+Lz2mDM;IACI,kBAAA;E/L42mDV;E+Lz2mDM;IACI,aAAA;E/L22mDV;E+Lx2mDM;IACI,eAAA;IjB/EJ,YAAA;IAAA,MAAA;IAAA,SAAA;IAAA,QAAA;E9K67mDN;E+Lv2mDM;IACI,oBAAA;E/Ly2mDV;E+Lt2mDM;IACI,eAAA;IACA,gBTkegB;IShehB,iDAAA;IACA,gDAAA;IACA,mDAAA;IjBhGJ,SAAA;IAAA,YAAA;IAAA,UAAA;IAAA,YAAA;IAAA,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9K+8mDN;E+Ln2mDM;IACI,gBTidgB;IS/chB,uDAAA;IACA,mDAAA;IACA,uDAAA;IACA,mDAAA;IjBlHJ,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9K09mDN;E+L/1mDU;IACI,uCAAA;E/Li2mDd;E+L71mDM;IACI,gBT6bgB;IS5bzB,uCAAA;IACS,yDAAA;E/L+1mDV;E+L51mDM;IACI,gBTubgB;IStbhB,uCAAA;IACA,yDAAA;E/L81mDV;;E+Lx1mDM;IACI,wBAAA;E/L21mDV;E+Lx1mDM;IACI,wBAAA;E/L01mDV;;E+Lr1mDM;IACI,wBAAA;E/Lw1mDV;E+Lr1mDM;IACI,wBAAA;E/Lu1mDV;;E+Ll1mDM;IACI,wBAAA;E/Lq1mDV;E+Ll1mDM;IACI,wBAAA;E/Lo1mDV;;E+L70mDM;IACI,gCAAA;E/Lg1mDV;E+L50mDM;IACI,0EAAA;E/L80mDV;AACF;Ae97mDI;EgLuHA;IACI,aAAA;IACA,gCAAA;IjB/LA,YAAA;IiBkMA,0DAAA;IACA,sDAAA;IACA,yDAAA;IACA,uDAAA;IjBrMA,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9KkhnDN;;E+Lp0mDE;IACI,2BAAA;IACA,kCAAA;IAEA,6BAAA;IACA,2BAAA;IACA,2BAAA;IACA,8BAAA;E/Ls0mDN;;E+Ln0mDE;IACI,0BAAA;IAEA,6BAAA;IACA,2BAAA;IACA,2BAAA;IACA,8BAAA;E/Lq0mDN;;E+Ll0mDE;IACI,yBAAA;E/Lq0mDN;;E+Lh0mDM;IACI,oBAAA;E/Lm0mDV;E+Lh0mDM;IACI,gBTkVgB;ISjVhB,8DAAA;IACA,0DAAA;IACA,6DAAA;IACA,4DAAA;IjBhPJ,gBAAA;IAAA,iBAAA;IAAA,eAAA;IAAA,kBAAA;E9KsjnDN;E+L7zmDU;IACI,uCAAA;E/L+zmDd;E+L3zmDM;IACI,gBT+TgB;IS9TzB,uCAAA;IACS,gEAAA;E/L6zmDV;E+L1zmDM;IACI,gBTyTgB;ISxThB,uCAAA;IACA,yDAAA;E/L4zmDV;;E+LtzmDM;IACI,wBAAA;E/LyzmDV;E+LtzmDM;IACI,wBAAA;E/LwzmDV;;E+LnzmDM;IACI,wBAAA;E/LszmDV;E+LnzmDM;IACI,wBAAA;E/LqzmDV;AACF;AgMnlnDA;EACI,aAAA;AhMqlnDJ;;Ae5hnDI;EiLnDA;IACI,yDVwBiB;EtL2jnDvB;EgMhlnDM;IACI,8CAAA;EhMklnDV;EgM/knDM;IACI,uCAAA;EhMilnDV;EgM7knDM;IACI,wCAAA;EhM+knDV;EgM5knDM;IACI,0FAAA;EhM8knDV;EgM3knDM;IACI,4EAAA;EhM6knDV;EgMzknDM;IACI,0HAAA;EhM2knDV;EgMnknDM;IACI,sPAAA;EhMqknDV;EgM1jnDM;IACI,qHAAA;EhM4jnDV;EgMpjnDM;IACI,0CAAA;EhMsjnDV;AACF;AehjnDI;EiLCA;IACI,yDVzCiB;EtL2lnDvB;EgM/inDM;IACI,8CAAA;EhMijnDV;EgM9inDM;IACI,uCAAA;EhMgjnDV;EgM5inDM;IACI,0FAAA;EhM8inDV;EgM1inDM;IACI,0CAAA;EhM4inDV;AACF;AiMxonDA;EACI,aAAA;AjM0onDJ;;AejlnDI;EkLnDA;IACI,4BXac;EtL2nnDpB;;EiMxnnDM;IACI,0HAAA;EjM2nnDV;EiMnnnDM;IACI,sPAAA;EjMqnnDV;EiM1mnDM;IACI,qHAAA;EjM4mnDV;AACF;AeplnDI;EkLbA;InBzDI,eAAA;IAAA,gBAAA;E9K+pnDN;AACF;AevmnDI;EmLzDH;IACC,iBZmCsB;IYlChB,oBZkCgB;IYjChB,eZmCgB;IYlChB,gBZkCgB;EtLionDtB;AACF;AelmnDI;EmL5DH;IACC,eAAA;IACA,iBZyB6B;IYxBvB,oBZwBuB;IYvBvB,eZyBuB;IYxBvB,gBZwBuB;EtLyonD7B;AACF;AmMlrnDA;EACI,2CbspBoB;EarpBpB,aAAA;EACA,oBAAA;AnMornDJ;;Ae7nnDI;EoLjDA;IAGI,+CAAA;IACA,2CAAA;IACA,2CAAA;EnMgrnDN;;EmM5qnDE;IACI,4BAAA;EnM+qnDN;;EmM3qnDE;IACI,mCAAA;EnM8qnDN;EmM5qnDM;IrBzBA,YAAA;IqB2BI,eAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;EnM8qnDV;;EmMvqnDM;IACI,mHAAA;EnM0qnDV;EmMlqnDM;IACI,+OAAA;EnMoqnDV;EmMzpnDM;IACI,8GAAA;EnM2pnDV;AACF;AejpnDI;EoLCA;IAGI,sDAAA;IACA,kDAAA;IACA,kDAAA;EnMipnDN;;EmM7onDE;IACI,4BAAA;EnMgpnDN;;EmM5onDE;IACI,mCAAA;EnM+onDN;EmM7onDM;IrBxFA,YAAA;IqB0FI,eAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;EnM+onDV;AACF;AoM9unDA;EACI,eAAA;EACA,Yd4qBgC;Ec3qBhC,Y3DmG+B;E2DlG/B,W3DgG4B;AzIgpnDhC;;Ae7qnDI;EqL9DH;IACC,Y3D6FwC;I2D5FlC,W3D0F+B;EzIqpnDrC;AACF;AqM3vnDC;ECEG,0BAAA;EACA,gCAAA;EAGA,sCAAA;EACA,6CAAA;EACA,0EAAA;EACA,iFAAA;EACA,uDAAA;EAGA,8CAAA;EAGA,kFAAA;EACA,kDAAA;EAGA,wCAAA;EACA,qEAAA;EACA,+CAAA;EACA,+CAAA;EACA,qDAAA;EACA,kDAAA;EACA,yDAAA;EACA,gEAAA;EAGA,uCAAA;EACA,8CAAA;EACA,2EAAA;EACA,kFAAA;EACA,mDAAA;EACA,0DAAA;EAGA,iCAAA;EACA,wCAAA;AtMgvnDJ;;AqMjxnDC;ECuCG,0BAAA;EACA,gCAAA;EAGA,sCAAA;EACA,6CAAA;EACA,qCAAA;EACA,4CAAA;EACA,uDAAA;EAGA,8CAAA;EAGA,iDAAA;EACA,kDAAA;EAGA,wCAAA;EACA,uCAAA;EACA,+CAAA;EACA,+CAAA;EACA,qDAAA;EACA,kDAAA;EACA,yDAAA;EACA,gEAAA;EAGA,uCAAA;EACA,8CAAA;EACA,sCAAA;EACA,kFAAA;EACA,mCAAA;EACA,0DAAA;EAGA,iCAAA;EACA,wCAAA;AtMkunDJ;;Ae1vnDI;EwLzDA;IACI,uEAAA;IACA,2EAAA;EvMuznDN;EuMrznDM;IACI,mCAAA;EvMuznDV;;EuMjznDU;IACI,0BAAA;EvMoznDd;EuMjznDU;IACI,mCAAA;EvMmznDd;;EuM9ynDE;IACI,mCAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,kBAAA;IACA,cAAA;EvMiznDN;;EuM5ynDU;IACI,qBAAA;EvM+ynDd;AACF;Ae3wnDI;EwL7BA;IACI,aAAA;EvM2ynDN;AACF;AwMx1nDA;EACI,aAAA;AxM01nDJ;;AwMp1nDQ;EACI,aAAA;AxMu1nDZ;;AepynDI;EyL3CI;IACI,aAAA;ExMm1nDV;EwMh1nDM;IACI,qBAAA;ExMk1nDV;EwM90nDE;IACI,yCAAA;ExMg1nDN;EwM50nDM;;IAEI,UAAA;IC/BR,wCAAA;EzM82nDF;EwM30nDM;IACI,SAAA;IACA,gBAAA;ICrCR,uCAAA;EzMm3nDF;EwMx0nDM;IACI,0BAAA;IACA,2BAAA;ExM00nDV;EwMx0nDU;IACI,QAAA;IACA,aAAA;ExM00nDd;EwMv0nDU;IACI,WAAA;IACA,cAAA;ExMy0nDd;;EwMh3nDM;IACI,aAAA;ExMm3nDV;EwMh3nDM;IACI,qBAAA;ExMk3nDV;EwM92nDE;IACI,yCAAA;ExMg3nDN;EwM52nDM;;IAEI,UAAA;IC/BR,wCAAA;EzM84nDF;EwM32nDM;IACI,SAAA;IACA,gBAAA;ICrCR,uCAAA;EzMm5nDF;EwMx2nDM;IACI,0BAAA;IACA,2BAAA;ExM02nDV;EwMx2nDU;IACI,QAAA;IACA,aAAA;ExM02nDd;EwMv2nDU;IACI,WAAA;IACA,cAAA;ExMy2nDd;AACF;A0Mh6nDI;EACI,yBjE8DoB;EiE7DpB,0BAAA;A1Mk6nDR;A0Mh6nDQ;EpDHJ,oCAAA;AtJs6nDJ;AsJn6nDI;EACI,yBjJaS;ALw5nDjB;AsJl6nDI;EACI,6BAAA;AtJo6nDR;AsJ/5nDQ;EAEI,oCAAA;AtJg6nDZ;AsJ75nDY;EACI,yBjJFC;ALi6nDjB;AsJ55nDY;EACI,6BAAA;AtJ85nDhB;A0M96nDQ;EACI,iCAAA;A1Mg7nDZ;A0M76nDQ;E/FAA,c+FEe;E/FiBf,wC+FdmB;A1M46nD3B;A2G76nDQ;;EAEF,c+FHuB;A1Mk7nD7B;A2G56nDQ;EACI,c+FPiB;A1Mq7nD7B;A2Gl6nDI;EASQ,c+FzBmB;E/F4CnB,mDAAA;A3G04nDZ;A0M76nDgB;EACI,yBAAA;A1M+6nDpB;AiGxxnDC;EA5CC,cyGvGgC;A1M86nDlC;AiGr0nDE;EACC,cyG1G+B;A1Mi7nDlC;AiGj0nDG;;;EAGC,cyGlH4B;A1Mq7nDhC;AiG5znDG;EACC,yByGzH8B;A1Mu7nDlC;AiGvznDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yB6GrB0B;E7GyB9B,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,yB6GrB0B;E7GyB9B,qDAAA;EI0GD,iBAAA;AjGq0nDH;AiG3ynDC;EAEC,2B5FoMgB;E4F/PhB,gCyG/FgC;A1Mu8nDlC;AiGt2nDE;EACC,gCyGlG+B;A1M08nDlC;AiGl2nDG;;;;;EAGC,gCyG1G6B;A1Mg9nDjC;AiG/1nDG;EACC,2CyGjH+B;A1Mk9nDnC;AiG11nDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2C6Gb0B;E7GiB9B,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2C6Gb0B;E7GiB9B,qDAAA;EI0GD,iBAAA;AjGw2nDH;AiG3ynDC;EACC,2B5FkKgB;E4F/PhB,gCyGvFgC;A1Mk+nDlC;AiGz4nDE;EACC,gCyG1F+B;A1Mq+nDlC;AiGr4nDG;;;EAGC,gCyGlG6B;A1My+nDjC;AiGh4nDG;EACC,2CyGzG+B;A1M2+nDnC;AiG33nDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2C6GL0B;E7GS9B,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2C6GL0B;E7GS9B,qDAAA;EI0GD,iBAAA;AjGy4nDH;AiGr1nDC;EACC,2B5F2KgB;E4F/PhB,gCyG/EgC;A1M2/nDlC;AiG16nDE;EACC,gCyGlF+B;A1M8/nDlC;AiGt6nDG;;;EAGC,gCyG1F6B;A1MkgoDjC;AiGj6nDG;EACC,2CyGjG+B;A1MogoDnC;AiG55nDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2C6GG0B;E7GC9B,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2C6GG0B;E7GC9B,qDAAA;EI0GD,iBAAA;AjG06nDH;AiGh4nDC;EACC,2B5FqLgB;E4FnQhB,yBwC/D2C;ExCmE3C,gCyGvEgC;A1MqhoDlC;AiG58nDE;EACC,gCyG1E+B;A1MwhoDlC;AiGx8nDG;;;EAGC,gCyGlF6B;A1M4hoDjC;AiGn8nDG;EACC,2CyGzF+B;A1M8hoDnC;AiG97nDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2C6GW0B;E7GP9B,qDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,2C6GW0B;E7GP9B,qDAAA;EI0GD,iBAAA;AjG48nDH;;A2MlnoDI;EACI,sDAAA;EACA,0BAAA;A3MqnoDR;A2MnnoDQ;ErDHJ,wEAAA;AtJynoDJ;AsJtnoDI;EACI,6DAAA;AtJwnoDR;AsJrnoDI;EACI,6BAAA;AtJunoDR;AsJlnoDQ;EAEI,8EAAA;AtJmnoDZ;AsJhnoDY;EACI,mEqDfkE;A3MiooDlF;AsJ/moDY;EACI,6BAAA;AtJinoDhB;A2MjooDQ;EACI,oEAAA;A3MmooDZ;A2MhooDQ;EACI,gBtMqaW;AL6tnDvB;A2M/noDgB;EACI,gEAAA;A3MiooDpB;AiG/9nDC;EA5CC,yB0GlHgC;A3MgooDlC;AiG5goDE;EACC,yB0GrH+B;A3MmooDlC;AiGxgoDG;;;EAGC,yB0G7H6B;A3MuooDjC;AiGngoDG;EACC,oC0GpI+B;A3MyooDnC;AiG9/nDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oC8GhC0B;E9GoC9B,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oC8GhC0B;E9GoC9B,oDAAA;EI0GD,iBAAA;AjG4goDH;AiGl/nDC;EAEC,2B5FoMgB;E4F/PhB,yB0G1GgC;A3MypoDlC;AiG7ioDE;EACC,yB0G7G+B;A3M4poDlC;AiGzioDG;;;;;EAGC,yB0GrH6B;A3MkqoDjC;AiGtioDG;EACC,oC0G5H+B;A3MoqoDnC;AiGjioDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oC8GxB0B;E9G4B9B,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oC8GxB0B;E9G4B9B,oDAAA;EI0GD,iBAAA;AjG+ioDH;AiG3/nDC;EACC,2B5F2KgB;E4F/PhB,yB0GlGgC;A3MoroDlC;AiGhloDE;EACC,yB0GrG+B;A3MuroDlC;AiG5koDG;;;EAGC,yB0G7G6B;A3M2roDjC;AiGvkoDG;EACC,oC0GpH+B;A3M6roDnC;AiGlkoDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oC8GhB0B;E9GoB9B,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oC8GhB0B;E9GoB9B,oDAAA;EI0GD,iBAAA;AjGgloDH;AiGnhoDC;EACC,2B5FkKgB;E4F/PhB,yB0G1FgC;A3M6soDlC;AiGjnoDE;EACC,yB0G7F+B;A3MgtoDlC;AiG7moDG;;;EAGC,yB0GrG6B;A3MotoDjC;AiGxmoDG;EACC,oC0G5G+B;A3MstoDnC;AiGnmoDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oC8GR0B;E9GY9B,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oC8GR0B;E9GY9B,oDAAA;EI0GD,iBAAA;AjGinoDH;AiGvkoDC;EACC,2B5FqLgB;E4FnQhB,uE0G1E6B;E1G8E7B,wB0GlFgC;A3MuuoDlC;AiGnpoDE;EACC,wB0GrF+B;A3M0uoDlC;AiG/ooDG;;;EAGC,wB0G7F6B;A3M8uoDjC;AiG1ooDG;EACC,mC0GpG+B;A3MgvoDnC;AiGrooDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCAAA;EAIJ,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mCAAA;EAIJ,oDAAA;EI0GD,iBAAA;AjGmpoDH;;A2MvvoDQ;EACI,qEAAA;A3M0voDZ;;AiG1ooDC;EA5CC,yB2GnI4B;A5M6zoD9B;AiGxroDE;EACC,yB2GtI2B;A5Mg0oD9B;AiGproDG;;;EAGC,yB2G9IyB;A5Mo0oD7B;AiG/qoDG;EACC,oC2GrJ2B;A5Ms0oD/B;AiG1qoDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oC+GjDsB;E/GqD1B,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,oC+GjDsB;E/GqD1B,oDAAA;EI0GD,iBAAA;AjGwroDH;AiG9poDC;EAEC,2B5FoMgB;E4FnQhB,qD2GnHyB;E3GuHzB,wB2G3H4B;A5Mu1oD9B;AiG1toDE;EACC,wB2G9H2B;A5M01oD9B;AiGttoDG;;;;;EAGC,wB2GtIyB;A5Mg2oD7B;AiGntoDG;EACC,mC2G7I2B;A5Mk2oD/B;AiG9soDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mC+GzCsB;E/G6C1B,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mC+GzCsB;E/G6C1B,oDAAA;EI0GD,iBAAA;AjG4toDH;AiGxqoDC;EACC,2B5F2KgB;E4F/PhB,wB2GnH4B;A5Mk3oD9B;AiG7voDE;EACC,wB2GtH2B;A5Mq3oD9B;AiGzvoDG;;;EAGC,wB2G9HyB;A5My3oD7B;AiGpvoDG;EACC,mC2GrI2B;A5M23oD/B;AiG/uoDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mC+GjCsB;E/GqC1B,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mC+GjCsB;E/GqC1B,oDAAA;EI0GD,iBAAA;AjG6voDH;AiGhsoDC;EACC,2B5FkKgB;E4FnQhB,qD2GnGyB;E3GuGzB,wB2G3G4B;A5M44oD9B;AiG/xoDE;EACC,wB2G9G2B;A5M+4oD9B;AiG3xoDG;;;EAGC,wB2GtHyB;A5Mm5oD7B;AiGtxoDG;EACC,mC2G7H2B;A5Mq5oD/B;AiGjxoDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mC+GzBsB;E/G6B1B,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mC+GzBsB;E/G6B1B,oDAAA;EI0GD,iBAAA;AjG+xoDH;AiGrvoDC;EACC,2B5FqLgB;E4FnQhB,qD2G3FyB;E3G+FzB,wB2GnG4B;A5Ms6oD9B;AiGj0oDE;EACC,wB2GtG2B;A5My6oD9B;AiG7zoDG;;;EAGC,wB2G9GyB;A5M66oD7B;AiGxzoDG;EACC,mC2GrH2B;A5M+6oD/B;AiGnzoDE;EJjHM,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mC+GjBsB;E/GqB1B,oDAAA;EIwGD,mBAAA;EJnHK,sBAAA;EACA,qBAAA;EACA,8BAAA;EACA,6BAAA;EAIA,mC+GjBsB;E/GqB1B,oDAAA;EI0GD,iBAAA;AjGi0oDH;A4M17oDI;EACI,iEAAA;EACA,gEAAA;A5M47oDR;A4Mz7oDQ;EACI,oCAAA;A5M27oDZ;A4Mr7oDgB;EACI,oCAAA;A5Mu7oDpB;;Aev7oDI;E6LYQ;IACI,oBAAA;E5M+6oDd;E4M76oDc;IACI,qBAAA;IACA,wBAAA;IACA,gBvMsWG;ELykoDrB;EiGxxoDD;IACC,2B5FkKgB;I4FnQhB,qE2G/C6B;I3GmD7B,wB2GvDgC;E5Mg7oDhC;EiGv3oDA;IACC,wB2G1D+B;E5Mm7oDhC;EiGn3oDC;;;IAGC,wB2GlE6B;E5Mu7oD/B;EiG92oDC;IACC,mC2GzE+B;E5My7oDjC;EiGz2oDA;IJjHM,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,mC+G2B0B;I/GvB9B,oDAAA;IIwGD,mBAAA;IJnHK,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,mC+G2B0B;I/GvB9B,oDAAA;II0GD,iBAAA;EjGu3oDD;AACF;Aev9oDI;E6LuBF;IACU,wBAAA;E5Mm8oDV;AACF;A6MnipDI;EACI,yBpEuBmB;EoEtBnB,2BAAA;A7MqipDR;A6MnipDQ;ElGQA,ckGNe;A7MoipDvB;A2G1hpDQ;;EAEF,ckGXuB;A7MuipD7B;A2GzhpDQ;EACI,ckGfiB;A7M0ipD7B;A2G/gpDI;EASQ,ckGjCmB;ElGoDnB,mDAAA;A3Gu/oDZ;A2GtgpDY;;;;;;;;;EAEF,wBkGtC0B;A7MqjpDpC;A2G5gpDY;EACI,wBkG1CoB;A7MwjpDpC;AezgpDI;EkFyHH;IA5CC,c4G7GoC;E7M6ipDpC;EiG97oDA;IACC,c4GhHmC;E7MgjpDpC;EiG17oDC;;;IAGC,c4GxHgC;E7MojpDlC;EiGr7oDC;IACC,yB4G/HkC;E7MsjpDpC;EiGh7oDA;IJjHM,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,yBgH3B8B;IhH+BlC,qDAAA;IIwGD,mBAAA;IJnHK,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,yBgH3B8B;IhH+BlC,qDAAA;II0GD,iBAAA;EjG87oDD;EiGp6oDD;IAEC,2B5FoMgB;I4FnQhB,yBwC/D2C;IxCmE3C,gC4GpGoC;E7MskpDpC;EiGh+oDA;IACC,gC4GvGmC;E7MykpDpC;EiG59oDC;;;;;IAGC,gC4G/GiC;E7M+kpDnC;EiGz9oDC;IACC,2C4GtHmC;E7MilpDrC;EiGp9oDA;IJjHM,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,2CgHlB8B;IhHsBlC,qDAAA;IIwGD,mBAAA;IJnHK,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,2CgHlB8B;IhHsBlC,qDAAA;II0GD,iBAAA;EjGk+oDD;EiG96oDD;IACC,2B5F2KgB;I4F/PhB,gC4G3FoC;E7MgmpDpC;EiGngpDA;IACC,gC4G9FmC;E7MmmpDpC;EiG//oDC;;;IAGC,gC4GtGiC;E7MumpDnC;EiG1/oDC;IACC,2C4G7GmC;E7MympDrC;EiGr/oDA;IJjHM,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,2CgHT8B;IhHalC,qDAAA;IIwGD,mBAAA;IJnHK,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,2CgHT8B;IhHalC,qDAAA;II0GD,iBAAA;EjGmgpDD;EiGt8oDD;IACC,2B5FkKgB;I4FnQhB,yBwC/D2C;IxCmE3C,gC4GlFoC;E7MynpDpC;EiGripDA;IACC,gC4GrFmC;E7M4npDpC;EiGjipDC;;;IAGC,gC4G7FiC;E7MgopDnC;EiG5hpDC;IACC,2C4GpGmC;E7MkopDrC;EiGvhpDA;IJjHM,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,2CAAA;IAIJ,qDAAA;IIwGD,mBAAA;IJnHK,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,2CAAA;IAIJ,qDAAA;II0GD,iBAAA;EjGqipDD;EiG3/oDD;IACC,2B5FqLgB;I4FnQhB,yBwC/D2C;IxCmE3C,gC4GzEoC;E7MkppDpC;EiGvkpDA;IACC,gC4G5EmC;E7MqppDpC;EiGnkpDC;;;IAGC,gC4GpFiC;E7MyppDnC;EiG9jpDC;IACC,2C4G3FmC;E7M2ppDrC;EiGzjpDA;IJjHM,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,2CgHS8B;IhHLlC,qDAAA;IIwGD,mBAAA;IJnHK,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,2CgHS8B;IhHLlC,qDAAA;II0GD,iBAAA;EjGukpDD;AACF;;AeprpDI;EkFyKH;IACC,2B5FkKgB;I4FnQhB,8E6GxHiC;I7G4HjC,wB6GhIoC;E9M8upDpC;EiG5mpDA;IACC,wB6GnImC;E9MivpDpC;EiGxmpDC;;;IAGC,wB6G3IiC;E9MqvpDnC;EiGnmpDC;IACC,mC6GlJmC;E9MuvpDrC;EiG9lpDA;IJjHM,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,mCiH9C8B;IjHkDlC,oDAAA;IIwGD,mBAAA;IJnHK,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,mCiH9C8B;IjHkDlC,oDAAA;II0GD,iBAAA;EjG4mpDD;EiGlkpDD;IACC,2B5FqLgB;I4FnQhB,8E6G/GiC;I7GmHjC,wB6GvHoC;E9MuwpDpC;EiG9opDA;IACC,wB6G1HmC;E9M0wpDpC;EiG1opDC;;;IAGC,wB6GlIiC;E9M8wpDnC;EiGropDC;IACC,mC6GzImC;E9MgxpDrC;EiGhopDA;IJjHM,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,mCiHrC8B;IjHyClC,oDAAA;IIwGD,mBAAA;IJnHK,sBAAA;IACA,qBAAA;IACA,8BAAA;IACA,6BAAA;IAIA,mCiHrC8B;IjHyClC,oDAAA;II0GD,iBAAA;EjG8opDD;AACF;;Ae3vpDI;E+L1BI;IACI,6BAAA;IACA,gBAAA;IACA,oEAAA;E9MyxpDV;AACF;AetvpDI;E+L5BI;IACI,6BAAA;IACA,gBAAA;IACA,oEAAA;E9MqxpDV;AACF;Ae1wpDI;EgMxDF;IACC,cAAA;E/Mq0pDD;AACF;AelwpDI;EgM5DF;IACC,cAAA;E/Mi0pDD;AACF;AgN50pDQ;EACI,8CAAA;AhN80pDZ;;AevxpDI;EiM/CI;IACI,YAAA;IACA,6BAAA;IACA,aAAA;IACA,gBAAA;IACA,gBAAA;EhN00pDV;AACF;AepxpDI;EiM/CI;IACI,YAAA;IACA,6BAAA;IACA,aAAA;IACA,gBAAA;IACA,gBAAA;EhNs0pDV;AACF;Ae1ypDI;EkMvDQ;IACI,yBAAA;EjNo2pDd;AACF","sourcesContent":["@charset \"UTF-8\";\n:root {\n  --bs-blue: #0d6efd;\n  --bs-indigo: #6610f2;\n  --bs-purple: #6f42c1;\n  --bs-pink: #d63384;\n  --bs-red: #dc3545;\n  --bs-orange: #fd7e14;\n  --bs-yellow: #ffc107;\n  --bs-green: #198754;\n  --bs-teal: #20c997;\n  --bs-cyan: #0dcaf0;\n  --bs-black: #000000;\n  --bs-white: #ffffff;\n  --bs-gray: #7E8299;\n  --bs-gray-dark: #3F4254;\n  --bs-gray-100: #f5f8fa;\n  --bs-gray-200: #eff2f5;\n  --bs-gray-300: #E4E6EF;\n  --bs-gray-400: #B5B5C3;\n  --bs-gray-500: #A1A5B7;\n  --bs-gray-600: #7E8299;\n  --bs-gray-700: #5E6278;\n  --bs-gray-800: #3F4254;\n  --bs-gray-900: #181C32;\n  --bs-white: #ffffff;\n  --bs-light: #f5f8fa;\n  --bs-primary: #009ef7;\n  --bs-secondary: #E4E6EF;\n  --bs-success: #50cd89;\n  --bs-info: #7239ea;\n  --bs-warning: #ffc700;\n  --bs-danger: #f1416c;\n  --bs-dark: #181C32;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-light-rgb: 245, 248, 250;\n  --bs-primary-rgb: 0, 158, 247;\n  --bs-secondary-rgb: 228, 230, 239;\n  --bs-success-rgb: 80, 205, 137;\n  --bs-info-rgb: 114, 57, 234;\n  --bs-warning-rgb: 255, 199, 0;\n  --bs-danger-rgb: 241, 65, 108;\n  --bs-dark-rgb: 24, 28, 50;\n  --bs-white-rgb: 255, 255, 255;\n  --bs-black-rgb: 0, 0, 0;\n  --bs-body-color-rgb: 24, 28, 50;\n  --bs-body-bg-rgb: 255, 255, 255;\n  --bs-font-sans-serif: Inter, Helvetica, \"sans-serif\";\n  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n  --bs-body-font-family: var(--bs-font-sans-serif);\n  --bs-body-font-size: 1rem;\n  --bs-body-font-weight: 400;\n  --bs-body-line-height: 1.5;\n  --bs-body-color: #181C32;\n  --bs-body-bg: #ffffff;\n  --bs-border-width: 1px;\n  --bs-border-style: solid;\n  --bs-border-color: #eff2f5;\n  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);\n  --bs-border-radius: 0.475rem;\n  --bs-border-radius-sm: 0.425rem;\n  --bs-border-radius-lg: 0.625rem;\n  --bs-border-radius-xl: 1rem;\n  --bs-border-radius-2xl: 2rem;\n  --bs-border-radius-pill: 50rem;\n  --bs-link-color: #009ef7;\n  --bs-link-hover-color: #0095e8;\n  --bs-code-color: #b93993;\n  --bs-highlight-bg: #fff3cd;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  font-size: var(--bs-body-font-size);\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  color: var(--bs-body-color);\n  text-align: var(--bs-body-text-align);\n  background-color: var(--bs-body-bg);\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nhr {\n  margin: 1rem 0;\n  color: inherit;\n  border: 0;\n  border-top: 1px solid;\n  opacity: 0.25;\n}\n\nh6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  line-height: 1.2;\n  color: #181C32;\n}\n\nh1, .h1 {\n  font-size: calc(1.3rem + 0.6vw);\n}\n@media (min-width: 1200px) {\n  h1, .h1 {\n    font-size: 1.75rem;\n  }\n}\n\nh2, .h2 {\n  font-size: calc(1.275rem + 0.3vw);\n}\n@media (min-width: 1200px) {\n  h2, .h2 {\n    font-size: 1.5rem;\n  }\n}\n\nh3, .h3 {\n  font-size: calc(1.26rem + 0.12vw);\n}\n@media (min-width: 1200px) {\n  h3, .h3 {\n    font-size: 1.35rem;\n  }\n}\n\nh4, .h4 {\n  font-size: 1.25rem;\n}\n\nh5, .h5 {\n  font-size: 1.15rem;\n}\n\nh6, .h6 {\n  font-size: 1.075rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title] {\n  text-decoration: underline dotted;\n  cursor: help;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 600;\n}\n\ndd {\n  margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: 700;\n}\n\nsmall, .small {\n  font-size: 0.875em;\n}\n\nmark, .mark {\n  padding: 0.1875em;\n  background-color: var(--bs-highlight-bg);\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 0.75em;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\na {\n  color: var(--bs-link-color);\n  text-decoration: none;\n}\na:hover {\n  color: var(--bs-link-hover-color);\n  text-decoration: none;\n}\n\na:not([href]):not([class]), a:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: var(--bs-font-monospace);\n  font-size: 1em;\n}\n\npre {\n  display: block;\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  font-size: 0.875em;\n}\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\ncode {\n  font-size: 0.875em;\n  color: var(--bs-code-color);\n  word-wrap: break-word;\n}\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.1875rem 0.375rem;\n  font-size: 0.875em;\n  color: var(--bs-body-bg);\n  background-color: var(--bs-body-color);\n  border-radius: 0.425rem;\n}\nkbd kbd {\n  padding: 0;\n  font-size: 1em;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #A1A5B7;\n  text-align: left;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\nlabel {\n  display: inline-block;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=button] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\nselect:disabled {\n  opacity: 1;\n}\n\n[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\nbutton,\n[type=button],\n[type=reset],\n[type=submit] {\n  -webkit-appearance: button;\n}\nbutton:not(:disabled),\n[type=button]:not(:disabled),\n[type=reset]:not(:disabled),\n[type=submit]:not(:disabled) {\n  cursor: pointer;\n}\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ntextarea {\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  float: left;\n  width: 100%;\n  padding: 0;\n  margin-bottom: 0.5rem;\n  font-size: calc(1.275rem + 0.3vw);\n  line-height: inherit;\n}\n@media (min-width: 1200px) {\n  legend {\n    font-size: 1.5rem;\n  }\n}\nlegend + * {\n  clear: left;\n}\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n[type=search] {\n  outline-offset: -2px;\n  -webkit-appearance: textfield;\n}\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n::file-selector-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\niframe {\n  border: 0;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 300;\n}\n\n.display-1 {\n  font-size: calc(1.625rem + 4.5vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-1 {\n    font-size: 5rem;\n  }\n}\n\n.display-2 {\n  font-size: calc(1.575rem + 3.9vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-2 {\n    font-size: 4.5rem;\n  }\n}\n\n.display-3 {\n  font-size: calc(1.525rem + 3.3vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-3 {\n    font-size: 4rem;\n  }\n}\n\n.display-4 {\n  font-size: calc(1.475rem + 2.7vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-4 {\n    font-size: 3.5rem;\n  }\n}\n\n.display-5 {\n  font-size: calc(1.425rem + 2.1vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-5 {\n    font-size: 3rem;\n  }\n}\n\n.display-6 {\n  font-size: calc(1.375rem + 1.5vw);\n  font-weight: 700;\n  line-height: 1.2;\n}\n@media (min-width: 1200px) {\n  .display-6 {\n    font-size: 2.5rem;\n  }\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 0.875em;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n.blockquote > :last-child {\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: -1rem;\n  margin-bottom: 1rem;\n  font-size: 0.875em;\n  color: #7E8299;\n}\n.blockquote-footer::before {\n  content: \"— \";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #ffffff;\n  border: 1px solid #eff2f5;\n  border-radius: 0.475rem;\n  box-shadow: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 0.875em;\n  color: #7E8299;\n}\n\n.container,\n.container-fluid,\n.container-xxl,\n.container-xl,\n.container-lg,\n.container-md,\n.container-sm {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container-sm, .container {\n    max-width: 540px;\n  }\n}\n@media (min-width: 768px) {\n  .container-md, .container-sm, .container {\n    max-width: 720px;\n  }\n}\n@media (min-width: 992px) {\n  .container-lg, .container-md, .container-sm, .container {\n    max-width: 960px;\n  }\n}\n@media (min-width: 1200px) {\n  .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1140px;\n  }\n}\n@media (min-width: 1400px) {\n  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {\n    max-width: 1320px;\n  }\n}\n.row {\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  margin-top: calc(-1 * var(--bs-gutter-y));\n  margin-right: calc(-0.5 * var(--bs-gutter-x));\n  margin-left: calc(-0.5 * var(--bs-gutter-x));\n}\n.row > * {\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%;\n  padding-right: calc(var(--bs-gutter-x) * 0.5);\n  padding-left: calc(var(--bs-gutter-x) * 0.5);\n  margin-top: var(--bs-gutter-y);\n}\n\n.col {\n  flex: 1 0 0%;\n}\n\n.row-cols-auto > * {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.row-cols-1 > * {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.row-cols-2 > * {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.row-cols-3 > * {\n  flex: 0 0 auto;\n  width: 33.3333333333%;\n}\n\n.row-cols-4 > * {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.row-cols-5 > * {\n  flex: 0 0 auto;\n  width: 20%;\n}\n\n.row-cols-6 > * {\n  flex: 0 0 auto;\n  width: 16.6666666667%;\n}\n\n.col-auto {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n.col-1 {\n  flex: 0 0 auto;\n  width: 8.33333333%;\n}\n\n.col-2 {\n  flex: 0 0 auto;\n  width: 16.66666667%;\n}\n\n.col-3 {\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.col-4 {\n  flex: 0 0 auto;\n  width: 33.33333333%;\n}\n\n.col-5 {\n  flex: 0 0 auto;\n  width: 41.66666667%;\n}\n\n.col-6 {\n  flex: 0 0 auto;\n  width: 50%;\n}\n\n.col-7 {\n  flex: 0 0 auto;\n  width: 58.33333333%;\n}\n\n.col-8 {\n  flex: 0 0 auto;\n  width: 66.66666667%;\n}\n\n.col-9 {\n  flex: 0 0 auto;\n  width: 75%;\n}\n\n.col-10 {\n  flex: 0 0 auto;\n  width: 83.33333333%;\n}\n\n.col-11 {\n  flex: 0 0 auto;\n  width: 91.66666667%;\n}\n\n.col-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n.offset-1 {\n  margin-left: 8.33333333%;\n}\n\n.offset-2 {\n  margin-left: 16.66666667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333333%;\n}\n\n.offset-5 {\n  margin-left: 41.66666667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333333%;\n}\n\n.offset-8 {\n  margin-left: 66.66666667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333333%;\n}\n\n.offset-11 {\n  margin-left: 91.66666667%;\n}\n\n.g-0,\n.gx-0 {\n  --bs-gutter-x: 0rem;\n}\n\n.g-0,\n.gy-0 {\n  --bs-gutter-y: 0rem;\n}\n\n.g-1,\n.gx-1 {\n  --bs-gutter-x: 0.25rem;\n}\n\n.g-1,\n.gy-1 {\n  --bs-gutter-y: 0.25rem;\n}\n\n.g-2,\n.gx-2 {\n  --bs-gutter-x: 0.5rem;\n}\n\n.g-2,\n.gy-2 {\n  --bs-gutter-y: 0.5rem;\n}\n\n.g-3,\n.gx-3 {\n  --bs-gutter-x: 0.75rem;\n}\n\n.g-3,\n.gy-3 {\n  --bs-gutter-y: 0.75rem;\n}\n\n.g-4,\n.gx-4 {\n  --bs-gutter-x: 1rem;\n}\n\n.g-4,\n.gy-4 {\n  --bs-gutter-y: 1rem;\n}\n\n.g-5,\n.gx-5 {\n  --bs-gutter-x: 1.25rem;\n}\n\n.g-5,\n.gy-5 {\n  --bs-gutter-y: 1.25rem;\n}\n\n.g-6,\n.gx-6 {\n  --bs-gutter-x: 1.5rem;\n}\n\n.g-6,\n.gy-6 {\n  --bs-gutter-y: 1.5rem;\n}\n\n.g-7,\n.gx-7 {\n  --bs-gutter-x: 1.75rem;\n}\n\n.g-7,\n.gy-7 {\n  --bs-gutter-y: 1.75rem;\n}\n\n.g-8,\n.gx-8 {\n  --bs-gutter-x: 2rem;\n}\n\n.g-8,\n.gy-8 {\n  --bs-gutter-y: 2rem;\n}\n\n.g-9,\n.gx-9 {\n  --bs-gutter-x: 2.25rem;\n}\n\n.g-9,\n.gy-9 {\n  --bs-gutter-y: 2.25rem;\n}\n\n.g-10,\n.gx-10 {\n  --bs-gutter-x: 2.5rem;\n}\n\n.g-10,\n.gy-10 {\n  --bs-gutter-y: 2.5rem;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    flex: 1 0 0%;\n  }\n\n  .row-cols-sm-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-sm-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-sm-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-sm-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n\n  .row-cols-sm-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-sm-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-sm-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n\n  .col-sm-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-sm-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-sm-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-sm-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-sm-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-sm-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-sm-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-sm-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-sm-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-sm-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-sm-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-sm-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-sm-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n\n  .offset-sm-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-sm-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n\n  .offset-sm-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-sm-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n\n  .offset-sm-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-sm-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n\n  .offset-sm-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-sm-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-sm-0,\n.gx-sm-0 {\n    --bs-gutter-x: 0rem;\n  }\n\n  .g-sm-0,\n.gy-sm-0 {\n    --bs-gutter-y: 0rem;\n  }\n\n  .g-sm-1,\n.gx-sm-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-sm-1,\n.gy-sm-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-sm-2,\n.gx-sm-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-sm-2,\n.gy-sm-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-sm-3,\n.gx-sm-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n\n  .g-sm-3,\n.gy-sm-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n\n  .g-sm-4,\n.gx-sm-4 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-sm-4,\n.gy-sm-4 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-sm-5,\n.gx-sm-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n\n  .g-sm-5,\n.gy-sm-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n\n  .g-sm-6,\n.gx-sm-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-sm-6,\n.gy-sm-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-sm-7,\n.gx-sm-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n\n  .g-sm-7,\n.gy-sm-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n\n  .g-sm-8,\n.gx-sm-8 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-sm-8,\n.gy-sm-8 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-sm-9,\n.gx-sm-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n\n  .g-sm-9,\n.gy-sm-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n\n  .g-sm-10,\n.gx-sm-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-sm-10,\n.gy-sm-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 768px) {\n  .col-md {\n    flex: 1 0 0%;\n  }\n\n  .row-cols-md-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-md-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-md-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-md-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n\n  .row-cols-md-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-md-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-md-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n\n  .col-md-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-md-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-md-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-md-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-md-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-md-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-md-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-md-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-md-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-md-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-md-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-md-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-md-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-md-0 {\n    margin-left: 0;\n  }\n\n  .offset-md-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-md-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n\n  .offset-md-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-md-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n\n  .offset-md-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-md-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n\n  .offset-md-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-md-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-md-0,\n.gx-md-0 {\n    --bs-gutter-x: 0rem;\n  }\n\n  .g-md-0,\n.gy-md-0 {\n    --bs-gutter-y: 0rem;\n  }\n\n  .g-md-1,\n.gx-md-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-md-1,\n.gy-md-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-md-2,\n.gx-md-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-md-2,\n.gy-md-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-md-3,\n.gx-md-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n\n  .g-md-3,\n.gy-md-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n\n  .g-md-4,\n.gx-md-4 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-md-4,\n.gy-md-4 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-md-5,\n.gx-md-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n\n  .g-md-5,\n.gy-md-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n\n  .g-md-6,\n.gx-md-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-md-6,\n.gy-md-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-md-7,\n.gx-md-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n\n  .g-md-7,\n.gy-md-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n\n  .g-md-8,\n.gx-md-8 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-md-8,\n.gy-md-8 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-md-9,\n.gx-md-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n\n  .g-md-9,\n.gy-md-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n\n  .g-md-10,\n.gx-md-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-md-10,\n.gy-md-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 992px) {\n  .col-lg {\n    flex: 1 0 0%;\n  }\n\n  .row-cols-lg-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-lg-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-lg-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-lg-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n\n  .row-cols-lg-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-lg-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-lg-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n\n  .col-lg-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-lg-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-lg-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-lg-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-lg-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-lg-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-lg-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-lg-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-lg-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-lg-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-lg-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-lg-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n\n  .offset-lg-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-lg-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n\n  .offset-lg-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-lg-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n\n  .offset-lg-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-lg-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n\n  .offset-lg-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-lg-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-lg-0,\n.gx-lg-0 {\n    --bs-gutter-x: 0rem;\n  }\n\n  .g-lg-0,\n.gy-lg-0 {\n    --bs-gutter-y: 0rem;\n  }\n\n  .g-lg-1,\n.gx-lg-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-lg-1,\n.gy-lg-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-lg-2,\n.gx-lg-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-lg-2,\n.gy-lg-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-lg-3,\n.gx-lg-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n\n  .g-lg-3,\n.gy-lg-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n\n  .g-lg-4,\n.gx-lg-4 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-lg-4,\n.gy-lg-4 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-lg-5,\n.gx-lg-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n\n  .g-lg-5,\n.gy-lg-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n\n  .g-lg-6,\n.gx-lg-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-lg-6,\n.gy-lg-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-lg-7,\n.gx-lg-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n\n  .g-lg-7,\n.gy-lg-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n\n  .g-lg-8,\n.gx-lg-8 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-lg-8,\n.gy-lg-8 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-lg-9,\n.gx-lg-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n\n  .g-lg-9,\n.gy-lg-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n\n  .g-lg-10,\n.gx-lg-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-lg-10,\n.gy-lg-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 1200px) {\n  .col-xl {\n    flex: 1 0 0%;\n  }\n\n  .row-cols-xl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-xl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-xl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-xl-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n\n  .row-cols-xl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-xl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-xl-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n\n  .col-xl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-xl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-xl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-xl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-xl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-xl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-xl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-xl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-xl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-xl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-xl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-xl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-xl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xl-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-xl-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xl-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-xl-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xl-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-xl-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xl-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-xl-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-xl-0,\n.gx-xl-0 {\n    --bs-gutter-x: 0rem;\n  }\n\n  .g-xl-0,\n.gy-xl-0 {\n    --bs-gutter-y: 0rem;\n  }\n\n  .g-xl-1,\n.gx-xl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-xl-1,\n.gy-xl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-xl-2,\n.gx-xl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-xl-2,\n.gy-xl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-xl-3,\n.gx-xl-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n\n  .g-xl-3,\n.gy-xl-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n\n  .g-xl-4,\n.gx-xl-4 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-xl-4,\n.gy-xl-4 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-xl-5,\n.gx-xl-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n\n  .g-xl-5,\n.gy-xl-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n\n  .g-xl-6,\n.gx-xl-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-xl-6,\n.gy-xl-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-xl-7,\n.gx-xl-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n\n  .g-xl-7,\n.gy-xl-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n\n  .g-xl-8,\n.gx-xl-8 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-xl-8,\n.gy-xl-8 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-xl-9,\n.gx-xl-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n\n  .g-xl-9,\n.gy-xl-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n\n  .g-xl-10,\n.gx-xl-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-xl-10,\n.gy-xl-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n@media (min-width: 1400px) {\n  .col-xxl {\n    flex: 1 0 0%;\n  }\n\n  .row-cols-xxl-auto > * {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .row-cols-xxl-1 > * {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .row-cols-xxl-2 > * {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .row-cols-xxl-3 > * {\n    flex: 0 0 auto;\n    width: 33.3333333333%;\n  }\n\n  .row-cols-xxl-4 > * {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .row-cols-xxl-5 > * {\n    flex: 0 0 auto;\n    width: 20%;\n  }\n\n  .row-cols-xxl-6 > * {\n    flex: 0 0 auto;\n    width: 16.6666666667%;\n  }\n\n  .col-xxl-auto {\n    flex: 0 0 auto;\n    width: auto;\n  }\n\n  .col-xxl-1 {\n    flex: 0 0 auto;\n    width: 8.33333333%;\n  }\n\n  .col-xxl-2 {\n    flex: 0 0 auto;\n    width: 16.66666667%;\n  }\n\n  .col-xxl-3 {\n    flex: 0 0 auto;\n    width: 25%;\n  }\n\n  .col-xxl-4 {\n    flex: 0 0 auto;\n    width: 33.33333333%;\n  }\n\n  .col-xxl-5 {\n    flex: 0 0 auto;\n    width: 41.66666667%;\n  }\n\n  .col-xxl-6 {\n    flex: 0 0 auto;\n    width: 50%;\n  }\n\n  .col-xxl-7 {\n    flex: 0 0 auto;\n    width: 58.33333333%;\n  }\n\n  .col-xxl-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n\n  .col-xxl-9 {\n    flex: 0 0 auto;\n    width: 75%;\n  }\n\n  .col-xxl-10 {\n    flex: 0 0 auto;\n    width: 83.33333333%;\n  }\n\n  .col-xxl-11 {\n    flex: 0 0 auto;\n    width: 91.66666667%;\n  }\n\n  .col-xxl-12 {\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .offset-xxl-0 {\n    margin-left: 0;\n  }\n\n  .offset-xxl-1 {\n    margin-left: 8.33333333%;\n  }\n\n  .offset-xxl-2 {\n    margin-left: 16.66666667%;\n  }\n\n  .offset-xxl-3 {\n    margin-left: 25%;\n  }\n\n  .offset-xxl-4 {\n    margin-left: 33.33333333%;\n  }\n\n  .offset-xxl-5 {\n    margin-left: 41.66666667%;\n  }\n\n  .offset-xxl-6 {\n    margin-left: 50%;\n  }\n\n  .offset-xxl-7 {\n    margin-left: 58.33333333%;\n  }\n\n  .offset-xxl-8 {\n    margin-left: 66.66666667%;\n  }\n\n  .offset-xxl-9 {\n    margin-left: 75%;\n  }\n\n  .offset-xxl-10 {\n    margin-left: 83.33333333%;\n  }\n\n  .offset-xxl-11 {\n    margin-left: 91.66666667%;\n  }\n\n  .g-xxl-0,\n.gx-xxl-0 {\n    --bs-gutter-x: 0rem;\n  }\n\n  .g-xxl-0,\n.gy-xxl-0 {\n    --bs-gutter-y: 0rem;\n  }\n\n  .g-xxl-1,\n.gx-xxl-1 {\n    --bs-gutter-x: 0.25rem;\n  }\n\n  .g-xxl-1,\n.gy-xxl-1 {\n    --bs-gutter-y: 0.25rem;\n  }\n\n  .g-xxl-2,\n.gx-xxl-2 {\n    --bs-gutter-x: 0.5rem;\n  }\n\n  .g-xxl-2,\n.gy-xxl-2 {\n    --bs-gutter-y: 0.5rem;\n  }\n\n  .g-xxl-3,\n.gx-xxl-3 {\n    --bs-gutter-x: 0.75rem;\n  }\n\n  .g-xxl-3,\n.gy-xxl-3 {\n    --bs-gutter-y: 0.75rem;\n  }\n\n  .g-xxl-4,\n.gx-xxl-4 {\n    --bs-gutter-x: 1rem;\n  }\n\n  .g-xxl-4,\n.gy-xxl-4 {\n    --bs-gutter-y: 1rem;\n  }\n\n  .g-xxl-5,\n.gx-xxl-5 {\n    --bs-gutter-x: 1.25rem;\n  }\n\n  .g-xxl-5,\n.gy-xxl-5 {\n    --bs-gutter-y: 1.25rem;\n  }\n\n  .g-xxl-6,\n.gx-xxl-6 {\n    --bs-gutter-x: 1.5rem;\n  }\n\n  .g-xxl-6,\n.gy-xxl-6 {\n    --bs-gutter-y: 1.5rem;\n  }\n\n  .g-xxl-7,\n.gx-xxl-7 {\n    --bs-gutter-x: 1.75rem;\n  }\n\n  .g-xxl-7,\n.gy-xxl-7 {\n    --bs-gutter-y: 1.75rem;\n  }\n\n  .g-xxl-8,\n.gx-xxl-8 {\n    --bs-gutter-x: 2rem;\n  }\n\n  .g-xxl-8,\n.gy-xxl-8 {\n    --bs-gutter-y: 2rem;\n  }\n\n  .g-xxl-9,\n.gx-xxl-9 {\n    --bs-gutter-x: 2.25rem;\n  }\n\n  .g-xxl-9,\n.gy-xxl-9 {\n    --bs-gutter-y: 2.25rem;\n  }\n\n  .g-xxl-10,\n.gx-xxl-10 {\n    --bs-gutter-x: 2.5rem;\n  }\n\n  .g-xxl-10,\n.gy-xxl-10 {\n    --bs-gutter-y: 2.5rem;\n  }\n}\n.table {\n  --bs-table-color: #181C32;\n  --bs-table-bg: transparent;\n  --bs-table-border-color: #eff2f5;\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: #181C32;\n  --bs-table-striped-bg: rgba(245, 248, 250, 0.75);\n  --bs-table-active-color: #181C32;\n  --bs-table-active-bg: #f5f8fa;\n  --bs-table-hover-color: #181C32;\n  --bs-table-hover-bg: #f5f8fa;\n  width: 100%;\n  margin-bottom: 1rem;\n  color: var(--bs-table-color);\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.table > :not(caption) > * > * {\n  padding: 0.75rem 0.75rem;\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n}\n.table > tbody {\n  vertical-align: inherit;\n}\n.table > thead {\n  vertical-align: bottom;\n}\n\n.table-group-divider {\n  border-top: 2px solid currentcolor;\n}\n\n.caption-top {\n  caption-side: top;\n}\n\n.table-sm > :not(caption) > * > * {\n  padding: 0.5rem 0.5rem;\n}\n\n.table-bordered > :not(caption) > * {\n  border-width: 1px 0;\n}\n.table-bordered > :not(caption) > * > * {\n  border-width: 0 1px;\n}\n\n.table-borderless > :not(caption) > * > * {\n  border-bottom-width: 0;\n}\n.table-borderless > :not(:first-child) {\n  border-top-width: 0;\n}\n\n.table-striped > tbody > tr:nth-of-type(odd) > * {\n  --bs-table-accent-bg: var(--bs-table-striped-bg);\n  color: var(--bs-table-striped-color);\n}\n\n.table-striped-columns > :not(caption) > tr > :nth-child(even) {\n  --bs-table-accent-bg: var(--bs-table-striped-bg);\n  color: var(--bs-table-striped-color);\n}\n\n.table-active {\n  --bs-table-accent-bg: var(--bs-table-active-bg);\n  color: var(--bs-table-active-color);\n}\n\n.table-hover > tbody > tr:hover > * {\n  --bs-table-accent-bg: var(--bs-table-hover-bg);\n  color: var(--bs-table-hover-color);\n}\n\n.table-primary {\n  --bs-table-color: #000000;\n  --bs-table-bg: #ccecfd;\n  --bs-table-border-color: #b8d4e4;\n  --bs-table-striped-bg: #c2e0f0;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #b8d4e4;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #bddaea;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-secondary {\n  --bs-table-color: #000000;\n  --bs-table-bg: #fafafc;\n  --bs-table-border-color: #e1e1e3;\n  --bs-table-striped-bg: #eeeeef;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e1e1e3;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #e7e7e9;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-success {\n  --bs-table-color: #000000;\n  --bs-table-bg: #dcf5e7;\n  --bs-table-border-color: #c6ddd0;\n  --bs-table-striped-bg: #d1e9db;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #c6ddd0;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #cce3d6;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-info {\n  --bs-table-color: #000000;\n  --bs-table-bg: #e3d7fb;\n  --bs-table-border-color: #ccc2e2;\n  --bs-table-striped-bg: #d8ccee;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #ccc2e2;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #d2c7e8;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-warning {\n  --bs-table-color: #000000;\n  --bs-table-bg: #fff4cc;\n  --bs-table-border-color: #e6dcb8;\n  --bs-table-striped-bg: #f2e8c2;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e6dcb8;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #ece2bd;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-danger {\n  --bs-table-color: #000000;\n  --bs-table-bg: #fcd9e2;\n  --bs-table-border-color: #e3c3cb;\n  --bs-table-striped-bg: #efced7;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #e3c3cb;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #e9c9d1;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-light {\n  --bs-table-color: #000000;\n  --bs-table-bg: #f5f8fa;\n  --bs-table-border-color: #dddfe1;\n  --bs-table-striped-bg: #e9ecee;\n  --bs-table-striped-color: #000000;\n  --bs-table-active-bg: #dddfe1;\n  --bs-table-active-color: #000000;\n  --bs-table-hover-bg: #e3e5e7;\n  --bs-table-hover-color: #000000;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-dark {\n  --bs-table-color: #ffffff;\n  --bs-table-bg: #181C32;\n  --bs-table-border-color: #2f3347;\n  --bs-table-striped-bg: #24273c;\n  --bs-table-striped-color: #ffffff;\n  --bs-table-active-bg: #2f3347;\n  --bs-table-active-color: #ffffff;\n  --bs-table-hover-bg: #292d41;\n  --bs-table-hover-color: #ffffff;\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n@media (max-width: 1399.98px) {\n  .table-responsive-xxl {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n.form-label {\n  margin-bottom: 0.5rem;\n  font-size: 1.05rem;\n  font-weight: 500;\n  color: #3F4254;\n}\n\n.col-form-label {\n  padding-top: calc(0.775rem + 1px);\n  padding-bottom: calc(0.775rem + 1px);\n  margin-bottom: 0;\n  font-size: inherit;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #3F4254;\n}\n\n.col-form-label-lg {\n  padding-top: calc(0.825rem + 1px);\n  padding-bottom: calc(0.825rem + 1px);\n  font-size: 1.15rem;\n}\n\n.col-form-label-sm {\n  padding-top: calc(0.55rem + 1px);\n  padding-bottom: calc(0.55rem + 1px);\n  font-size: 0.925rem;\n}\n\n.form-text {\n  margin-top: 0.5rem;\n  font-size: 0.925rem;\n  color: #A1A5B7;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 0.775rem 1rem;\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #5E6278;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 1px solid #E4E6EF;\n  appearance: none;\n  border-radius: 0.475rem;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n.form-control[type=file] {\n  overflow: hidden;\n}\n.form-control[type=file]:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control:focus {\n  color: #5E6278;\n  background-color: #ffffff;\n  border-color: #B5B5C3;\n  outline: 0;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0.25rem rgba(0, 158, 247, 0.25);\n}\n.form-control::-webkit-date-and-time-value {\n  height: 1.5em;\n}\n.form-control::placeholder {\n  color: #A1A5B7;\n  opacity: 1;\n}\n.form-control:disabled {\n  background-color: #eff2f5;\n  border-color: #E4E6EF;\n  opacity: 1;\n}\n.form-control::file-selector-button {\n  padding: 0.775rem 1rem;\n  margin: -0.775rem -1rem;\n  margin-inline-end: 1rem;\n  color: #5E6278;\n  background-color: #f5f8fa;\n  pointer-events: none;\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n  border-inline-end-width: 1px;\n  border-radius: 0;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-control::file-selector-button {\n    transition: none;\n  }\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: shade-color(#f5f8fa, 5%);\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.775rem 0;\n  margin-bottom: 0;\n  line-height: 1.5;\n  color: #5E6278;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 1px 0;\n}\n.form-control-plaintext:focus {\n  outline: 0;\n}\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  min-height: calc(1.5em + 1.1rem + 2px);\n  padding: 0.55rem 0.75rem;\n  font-size: 0.925rem;\n  border-radius: 0.425rem;\n}\n.form-control-sm::file-selector-button {\n  padding: 0.55rem 0.75rem;\n  margin: -0.55rem -0.75rem;\n  margin-inline-end: 0.75rem;\n}\n\n.form-control-lg {\n  min-height: calc(1.5em + 1.65rem + 2px);\n  padding: 0.825rem 1.5rem;\n  font-size: 1.15rem;\n  border-radius: 0.625rem;\n}\n.form-control-lg::file-selector-button {\n  padding: 0.825rem 1.5rem;\n  margin: -0.825rem -1.5rem;\n  margin-inline-end: 1.5rem;\n}\n\ntextarea.form-control {\n  min-height: calc(1.5em + 1.55rem + 2px);\n}\ntextarea.form-control-sm {\n  min-height: calc(1.5em + 1.1rem + 2px);\n}\ntextarea.form-control-lg {\n  min-height: calc(1.5em + 1.65rem + 2px);\n}\n\n.form-control-color {\n  width: 3rem;\n  height: calc(1.5em + 1.55rem + 2px);\n  padding: 0.775rem;\n}\n.form-control-color:not(:disabled):not([readonly]) {\n  cursor: pointer;\n}\n.form-control-color::-moz-color-swatch {\n  border: 0 !important;\n  border-radius: 0.475rem;\n}\n.form-control-color::-webkit-color-swatch {\n  border-radius: 0.475rem;\n}\n.form-control-color.form-control-sm {\n  height: calc(1.5em + 1.1rem + 2px);\n}\n.form-control-color.form-control-lg {\n  height: calc(1.5em + 1.65rem + 2px);\n}\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: 0.775rem 3rem 0.775rem 1rem;\n  -moz-padding-start: calc(1rem - 3px);\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #5E6278;\n  background-color: #ffffff;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%237E8299' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 1rem center;\n  background-size: 16px 12px;\n  border: 1px solid #E4E6EF;\n  border-radius: 0.475rem;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-select {\n    transition: none;\n  }\n}\n.form-select:focus {\n  border-color: #B5B5C3;\n  outline: 0;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075), 0 0 0 0.25rem rgba(0, 158, 247, 0.25);\n}\n.form-select[multiple], .form-select[size]:not([size=\"1\"]) {\n  padding-right: 1rem;\n  background-image: none;\n}\n.form-select:disabled {\n  background-color: #eff2f5;\n  border-color: #E4E6EF;\n}\n.form-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #5E6278;\n}\n\n.form-select-sm {\n  padding-top: 0.55rem;\n  padding-bottom: 0.55rem;\n  padding-left: 0.75rem;\n  font-size: 0.925rem;\n  border-radius: 0.425rem;\n}\n\n.form-select-lg {\n  padding-top: 0.825rem;\n  padding-bottom: 0.825rem;\n  padding-left: 1.5rem;\n  font-size: 1.15rem;\n  border-radius: 0.625rem;\n}\n\n.form-check {\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 2.25rem;\n  margin-bottom: 0.125rem;\n}\n.form-check .form-check-input {\n  float: left;\n  margin-left: -2.25rem;\n}\n\n.form-check-reverse {\n  padding-right: 2.25rem;\n  padding-left: 0;\n  text-align: right;\n}\n.form-check-reverse .form-check-input {\n  float: right;\n  margin-right: -2.25rem;\n  margin-left: 0;\n}\n\n.form-check-input {\n  width: 1.75rem;\n  height: 1.75rem;\n  margin-top: -0.125rem;\n  vertical-align: top;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: 1px solid #E4E6EF;\n  appearance: none;\n  print-color-adjust: exact;\n}\n.form-check-input[type=checkbox] {\n  border-radius: 0.45em;\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n}\n.form-check-input:active {\n  filter: brightness(90%);\n}\n.form-check-input:focus {\n  border-color: #B5B5C3;\n  outline: 0;\n  box-shadow: none;\n}\n.form-check-input:checked {\n  background-color: #009ef7;\n  border-color: #009ef7;\n}\n.form-check-input:checked[type=checkbox] {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 11' width='13' height='11' fill='none'%3e%3cpath d='M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n.form-check-input:checked[type=radio] {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: #009ef7;\n  border-color: #009ef7;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n}\n.form-check-input:disabled {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.5;\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  cursor: default;\n  opacity: 0.5;\n}\n\n.form-check-label {\n  color: #A1A5B7;\n}\n\n.form-switch {\n  padding-left: 3.75rem;\n}\n.form-switch .form-check-input {\n  width: 3.25rem;\n  margin-left: -3.75rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  background-position: left center;\n  border-radius: 3.25rem;\n  transition: background-position 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-switch .form-check-input {\n    transition: none;\n  }\n}\n.form-switch .form-check-input:focus {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23B5B5C3'/%3e%3c/svg%3e\");\n}\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e\");\n}\n.form-switch.form-check-reverse {\n  padding-right: 3.75rem;\n  padding-left: 0;\n}\n.form-switch.form-check-reverse .form-check-input {\n  margin-right: -3.75rem;\n  margin-left: 0;\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: 1rem;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  pointer-events: none;\n  filter: none;\n  opacity: 0.65;\n}\n\n.form-range {\n  width: 100%;\n  height: 1.5rem;\n  padding: 0;\n  background-color: transparent;\n  appearance: none;\n}\n.form-range:focus {\n  outline: 0;\n}\n.form-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(0, 158, 247, 0.25);\n}\n.form-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #ffffff, 0 0 0 0.25rem rgba(0, 158, 247, 0.25);\n}\n.form-range::-moz-focus-outer {\n  border: 0;\n}\n.form-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #009ef7;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-webkit-slider-thumb {\n    transition: none;\n  }\n}\n.form-range::-webkit-slider-thumb:active {\n  background-color: #b3e2fd;\n}\n.form-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--kt-gray-300);\n  border-color: transparent;\n  border-radius: 0.475rem;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n}\n.form-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #009ef7;\n  border: 0;\n  border-radius: 1rem;\n  box-shadow: 0 0.1rem 0.25rem rgba(0, 0, 0, 0.1);\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-range::-moz-range-thumb {\n    transition: none;\n  }\n}\n.form-range::-moz-range-thumb:active {\n  background-color: #b3e2fd;\n}\n.form-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: var(--kt-gray-300);\n  border-color: transparent;\n  border-radius: 0.475rem;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n}\n.form-range:disabled {\n  pointer-events: none;\n}\n.form-range:disabled::-webkit-slider-thumb {\n  background-color: var(--kt-gray-500);\n}\n.form-range:disabled::-moz-range-thumb {\n  background-color: var(--kt-gray-500);\n}\n\n.form-floating {\n  position: relative;\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.75rem + 2px);\n  line-height: 1.25;\n}\n.form-floating > label {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding: 1rem 1rem;\n  overflow: hidden;\n  text-align: start;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  pointer-events: none;\n  border: 1px solid transparent;\n  transform-origin: 0 0;\n  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .form-floating > label {\n    transition: none;\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext {\n  padding: 1rem 1rem;\n}\n.form-floating > .form-control::placeholder,\n.form-floating > .form-control-plaintext::placeholder {\n  color: transparent;\n}\n.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),\n.form-floating > .form-control-plaintext:focus,\n.form-floating > .form-control-plaintext:not(:placeholder-shown) {\n  padding-top: 1.85rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:-webkit-autofill,\n.form-floating > .form-control-plaintext:-webkit-autofill {\n  padding-top: 1.85rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-select {\n  padding-top: 1.85rem;\n  padding-bottom: 0.625rem;\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-select ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control:-webkit-autofill ~ label {\n  opacity: 0.65;\n  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);\n}\n.form-floating > .form-control-plaintext ~ label {\n  border-width: 1px 0;\n}\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 100%;\n}\n.input-group > .form-control,\n.input-group > .form-select,\n.input-group > .form-floating {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n}\n.input-group > .form-control:focus,\n.input-group > .form-select:focus,\n.input-group > .form-floating:focus-within {\n  z-index: 5;\n}\n.input-group .btn {\n  position: relative;\n  z-index: 2;\n}\n.input-group .btn:focus {\n  z-index: 5;\n}\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: 0.775rem 1rem;\n  font-size: 1.1rem;\n  font-weight: 500;\n  line-height: 1.5;\n  color: #5E6278;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #f5f8fa;\n  border: 1px solid #E4E6EF;\n  border-radius: 0.475rem;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: 0.825rem 1.5rem;\n  font-size: 1.15rem;\n  border-radius: 0.625rem;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: 0.55rem 0.75rem;\n  font-size: 0.925rem;\n  border-radius: 0.425rem;\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: 4rem;\n}\n\n.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,\n.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,\n.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: -1px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.input-group > .form-floating:not(:first-child) > .form-control,\n.input-group > .form-floating:not(:first-child) > .form-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.5rem;\n  font-size: 0.925rem;\n  color: #50cd89;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.75rem 1rem;\n  margin-top: 0.1rem;\n  font-size: 0.925rem;\n  color: #000000;\n  background-color: #50cd89;\n  border-radius: 0.475rem;\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: #50cd89;\n  padding-right: calc(1.5em + 1.55rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2350cd89' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.3875rem) center;\n  background-size: calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);\n}\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: #50cd89;\n  box-shadow: 0 0 0 0.25rem rgba(80, 205, 137, 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.5em + 1.55rem);\n  background-position: top calc(0.375em + 0.3875rem) right calc(0.375em + 0.3875rem);\n}\n\n.was-validated .form-select:valid, .form-select.is-valid {\n  border-color: #50cd89;\n}\n.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size=\"1\"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size=\"1\"] {\n  padding-right: 5.5rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%237E8299' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2350cd89' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-position: right 1rem center, center right 3rem;\n  background-size: 16px 12px, calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);\n}\n.was-validated .form-select:valid:focus, .form-select.is-valid:focus {\n  border-color: #50cd89;\n  box-shadow: 0 0 0 0.25rem rgba(80, 205, 137, 0.25);\n}\n\n.was-validated .form-control-color:valid, .form-control-color.is-valid {\n  width: calc(3rem + calc(1.5em + 1.55rem));\n}\n\n.was-validated .form-check-input:valid, .form-check-input.is-valid {\n  border-color: #50cd89;\n}\n.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {\n  background-color: #50cd89;\n}\n.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(80, 205, 137, 0.25);\n}\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #50cd89;\n}\n\n.form-check-inline .form-check-input ~ .valid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,\n.was-validated .input-group > .form-select:not(:focus):valid,\n.input-group > .form-select:not(:focus).is-valid,\n.was-validated .input-group > .form-floating:not(:focus-within):valid,\n.input-group > .form-floating:not(:focus-within).is-valid {\n  z-index: 3;\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.5rem;\n  font-size: 0.925rem;\n  color: #f1416c;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.75rem 1rem;\n  margin-top: 0.1rem;\n  font-size: 0.925rem;\n  color: #000000;\n  background-color: #f1416c;\n  border-radius: 0.475rem;\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: #f1416c;\n  padding-right: calc(1.5em + 1.55rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f1416c'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f1416c' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.375em + 0.3875rem) center;\n  background-size: calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);\n}\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: #f1416c;\n  box-shadow: 0 0 0 0.25rem rgba(241, 65, 108, 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.5em + 1.55rem);\n  background-position: top calc(0.375em + 0.3875rem) right calc(0.375em + 0.3875rem);\n}\n\n.was-validated .form-select:invalid, .form-select.is-invalid {\n  border-color: #f1416c;\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"] {\n  padding-right: 5.5rem;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%237E8299' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\"), url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f1416c'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23f1416c' stroke='none'/%3e%3c/svg%3e\");\n  background-position: right 1rem center, center right 3rem;\n  background-size: 16px 12px, calc(0.75em + 0.775rem) calc(0.75em + 0.775rem);\n}\n.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {\n  border-color: #f1416c;\n  box-shadow: 0 0 0 0.25rem rgba(241, 65, 108, 0.25);\n}\n\n.was-validated .form-control-color:invalid, .form-control-color.is-invalid {\n  width: calc(3rem + calc(1.5em + 1.55rem));\n}\n\n.was-validated .form-check-input:invalid, .form-check-input.is-invalid {\n  border-color: #f1416c;\n}\n.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {\n  background-color: #f1416c;\n}\n.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(241, 65, 108, 0.25);\n}\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #f1416c;\n}\n\n.form-check-inline .form-check-input ~ .invalid-feedback {\n  margin-left: 0.5em;\n}\n\n.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,\n.was-validated .input-group > .form-select:not(:focus):invalid,\n.input-group > .form-select:not(:focus).is-invalid,\n.was-validated .input-group > .form-floating:not(:focus-within):invalid,\n.input-group > .form-floating:not(:focus-within).is-invalid {\n  z-index: 4;\n}\n\n.btn {\n  --bs-btn-padding-x: 1.5rem;\n  --bs-btn-padding-y: 0.775rem;\n  --bs-btn-font-family: ;\n  --bs-btn-font-size: 1.1rem;\n  --bs-btn-font-weight: 500;\n  --bs-btn-line-height: 1.5;\n  --bs-btn-color: #181C32;\n  --bs-btn-bg: transparent;\n  --bs-btn-border-width: 1px;\n  --bs-btn-border-color: transparent;\n  --bs-btn-border-radius: 0.475rem;\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n  --bs-btn-disabled-opacity: 0.65;\n  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);\n  display: inline-block;\n  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);\n  font-family: var(--bs-btn-font-family);\n  font-size: var(--bs-btn-font-size);\n  font-weight: var(--bs-btn-font-weight);\n  line-height: var(--bs-btn-line-height);\n  color: var(--bs-btn-color);\n  text-align: center;\n  vertical-align: middle;\n  cursor: pointer;\n  user-select: none;\n  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);\n  border-radius: var(--bs-btn-border-radius);\n  background-color: var(--bs-btn-bg);\n  box-shadow: var(--bs-btn-box-shadow);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n.btn:hover {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n}\n.btn-check + .btn:hover {\n  color: var(--bs-btn-color);\n  background-color: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n}\n.btn:focus-visible {\n  color: var(--bs-btn-hover-color);\n  background-color: var(--bs-btn-hover-bg);\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);\n}\n.btn-check:focus-visible + .btn {\n  border-color: var(--bs-btn-hover-border-color);\n  outline: 0;\n  box-shadow: var(--bs-btn-box-shadow), var(--bs-btn-focus-box-shadow);\n}\n.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {\n  color: var(--bs-btn-active-color);\n  background-color: var(--bs-btn-active-bg);\n  border-color: var(--bs-btn-active-border-color);\n  box-shadow: var(--bs-btn-active-shadow);\n}\n.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {\n  box-shadow: var(--bs-btn-active-shadow), var(--bs-btn-focus-box-shadow);\n}\n.btn:disabled, .btn.disabled, fieldset:disabled .btn {\n  color: var(--bs-btn-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-btn-disabled-bg);\n  border-color: var(--bs-btn-disabled-border-color);\n  opacity: var(--bs-btn-disabled-opacity);\n  box-shadow: none;\n}\n\n.btn-white {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #ffffff;\n  --bs-btn-border-color: #ffffff;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: white;\n  --bs-btn-hover-border-color: white;\n  --bs-btn-focus-shadow-rgb: 217, 217, 217;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: white;\n  --bs-btn-active-border-color: white;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #ffffff;\n  --bs-btn-disabled-border-color: #ffffff;\n}\n\n.btn-light {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #f5f8fa;\n  --bs-btn-border-color: #f5f8fa;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #d0d3d5;\n  --bs-btn-hover-border-color: #c4c6c8;\n  --bs-btn-focus-shadow-rgb: 208, 211, 213;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #c4c6c8;\n  --bs-btn-active-border-color: #b8babc;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #f5f8fa;\n  --bs-btn-disabled-border-color: #f5f8fa;\n}\n\n.btn-primary {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #009ef7;\n  --bs-btn-border-color: #009ef7;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #26adf8;\n  --bs-btn-hover-border-color: #1aa8f8;\n  --bs-btn-focus-shadow-rgb: 0, 134, 210;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #33b1f9;\n  --bs-btn-active-border-color: #1aa8f8;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #009ef7;\n  --bs-btn-disabled-border-color: #009ef7;\n}\n\n.btn-secondary {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #E4E6EF;\n  --bs-btn-border-color: #E4E6EF;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #e8eaf1;\n  --bs-btn-hover-border-color: #e7e9f1;\n  --bs-btn-focus-shadow-rgb: 194, 196, 203;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #e9ebf2;\n  --bs-btn-active-border-color: #e7e9f1;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #E4E6EF;\n  --bs-btn-disabled-border-color: #E4E6EF;\n}\n\n.btn-success {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #50cd89;\n  --bs-btn-border-color: #50cd89;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #6ad59b;\n  --bs-btn-hover-border-color: #62d295;\n  --bs-btn-focus-shadow-rgb: 68, 174, 116;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #73d7a1;\n  --bs-btn-active-border-color: #62d295;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #50cd89;\n  --bs-btn-disabled-border-color: #50cd89;\n}\n\n.btn-info {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #7239ea;\n  --bs-btn-border-color: #7239ea;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #6130c7;\n  --bs-btn-hover-border-color: #5b2ebb;\n  --bs-btn-focus-shadow-rgb: 135, 87, 237;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #5b2ebb;\n  --bs-btn-active-border-color: #562bb0;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #7239ea;\n  --bs-btn-disabled-border-color: #7239ea;\n}\n\n.btn-warning {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #ffc700;\n  --bs-btn-border-color: #ffc700;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #ffcf26;\n  --bs-btn-hover-border-color: #ffcd1a;\n  --bs-btn-focus-shadow-rgb: 217, 169, 0;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #ffd233;\n  --bs-btn-active-border-color: #ffcd1a;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #ffc700;\n  --bs-btn-disabled-border-color: #ffc700;\n}\n\n.btn-danger {\n  --bs-btn-color: #000000;\n  --bs-btn-bg: #f1416c;\n  --bs-btn-border-color: #f1416c;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #f35e82;\n  --bs-btn-hover-border-color: #f2547b;\n  --bs-btn-focus-shadow-rgb: 205, 55, 92;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #f46789;\n  --bs-btn-active-border-color: #f2547b;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #000000;\n  --bs-btn-disabled-bg: #f1416c;\n  --bs-btn-disabled-border-color: #f1416c;\n}\n\n.btn-dark {\n  --bs-btn-color: #ffffff;\n  --bs-btn-bg: #181C32;\n  --bs-btn-border-color: #181C32;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #3b3e51;\n  --bs-btn-hover-border-color: #2f3347;\n  --bs-btn-focus-shadow-rgb: 59, 62, 81;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #46495b;\n  --bs-btn-active-border-color: #2f3347;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: #181C32;\n  --bs-btn-disabled-border-color: #181C32;\n}\n\n.btn-outline-white {\n  --bs-btn-color: #ffffff;\n  --bs-btn-border-color: #ffffff;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #ffffff;\n  --bs-btn-hover-border-color: #ffffff;\n  --bs-btn-focus-shadow-rgb: 255, 255, 255;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #ffffff;\n  --bs-btn-active-border-color: #ffffff;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffffff;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ffffff;\n  --bs-gradient: none;\n}\n\n.btn-outline-light {\n  --bs-btn-color: #f5f8fa;\n  --bs-btn-border-color: #f5f8fa;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #f5f8fa;\n  --bs-btn-hover-border-color: #f5f8fa;\n  --bs-btn-focus-shadow-rgb: 245, 248, 250;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #f5f8fa;\n  --bs-btn-active-border-color: #f5f8fa;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f5f8fa;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f5f8fa;\n  --bs-gradient: none;\n}\n\n.btn-outline-primary {\n  --bs-btn-color: #009ef7;\n  --bs-btn-border-color: #009ef7;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #009ef7;\n  --bs-btn-hover-border-color: #009ef7;\n  --bs-btn-focus-shadow-rgb: 0, 158, 247;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #009ef7;\n  --bs-btn-active-border-color: #009ef7;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #009ef7;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #009ef7;\n  --bs-gradient: none;\n}\n\n.btn-outline-secondary {\n  --bs-btn-color: #E4E6EF;\n  --bs-btn-border-color: #E4E6EF;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #E4E6EF;\n  --bs-btn-hover-border-color: #E4E6EF;\n  --bs-btn-focus-shadow-rgb: 228, 230, 239;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #E4E6EF;\n  --bs-btn-active-border-color: #E4E6EF;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #E4E6EF;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #E4E6EF;\n  --bs-gradient: none;\n}\n\n.btn-outline-success {\n  --bs-btn-color: #50cd89;\n  --bs-btn-border-color: #50cd89;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #50cd89;\n  --bs-btn-hover-border-color: #50cd89;\n  --bs-btn-focus-shadow-rgb: 80, 205, 137;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #50cd89;\n  --bs-btn-active-border-color: #50cd89;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #50cd89;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #50cd89;\n  --bs-gradient: none;\n}\n\n.btn-outline-info {\n  --bs-btn-color: #7239ea;\n  --bs-btn-border-color: #7239ea;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #7239ea;\n  --bs-btn-hover-border-color: #7239ea;\n  --bs-btn-focus-shadow-rgb: 114, 57, 234;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #7239ea;\n  --bs-btn-active-border-color: #7239ea;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #7239ea;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #7239ea;\n  --bs-gradient: none;\n}\n\n.btn-outline-warning {\n  --bs-btn-color: #ffc700;\n  --bs-btn-border-color: #ffc700;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #ffc700;\n  --bs-btn-hover-border-color: #ffc700;\n  --bs-btn-focus-shadow-rgb: 255, 199, 0;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #ffc700;\n  --bs-btn-active-border-color: #ffc700;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #ffc700;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #ffc700;\n  --bs-gradient: none;\n}\n\n.btn-outline-danger {\n  --bs-btn-color: #f1416c;\n  --bs-btn-border-color: #f1416c;\n  --bs-btn-hover-color: #000000;\n  --bs-btn-hover-bg: #f1416c;\n  --bs-btn-hover-border-color: #f1416c;\n  --bs-btn-focus-shadow-rgb: 241, 65, 108;\n  --bs-btn-active-color: #000000;\n  --bs-btn-active-bg: #f1416c;\n  --bs-btn-active-border-color: #f1416c;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #f1416c;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #f1416c;\n  --bs-gradient: none;\n}\n\n.btn-outline-dark {\n  --bs-btn-color: #181C32;\n  --bs-btn-border-color: #181C32;\n  --bs-btn-hover-color: #ffffff;\n  --bs-btn-hover-bg: #181C32;\n  --bs-btn-hover-border-color: #181C32;\n  --bs-btn-focus-shadow-rgb: 24, 28, 50;\n  --bs-btn-active-color: #ffffff;\n  --bs-btn-active-bg: #181C32;\n  --bs-btn-active-border-color: #181C32;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #181C32;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #181C32;\n  --bs-gradient: none;\n}\n\n.btn-link {\n  --bs-btn-font-weight: 400;\n  --bs-btn-color: #009ef7;\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  --bs-btn-hover-color: #0095e8;\n  --bs-btn-hover-border-color: transparent;\n  --bs-btn-active-color: #0095e8;\n  --bs-btn-active-border-color: transparent;\n  --bs-btn-disabled-color: #7E8299;\n  --bs-btn-disabled-border-color: transparent;\n  --bs-btn-box-shadow: none;\n  --bs-btn-focus-shadow-rgb: 0, 134, 210;\n  text-decoration: none;\n}\n.btn-link:hover, .btn-link:focus-visible {\n  text-decoration: none;\n}\n.btn-link:focus-visible {\n  color: var(--bs-btn-color);\n}\n.btn-link:hover {\n  color: var(--bs-btn-hover-color);\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  --bs-btn-padding-y: 0.825rem;\n  --bs-btn-padding-x: 1.75rem;\n  --bs-btn-font-size: 1.15rem;\n  --bs-btn-border-radius: 0.625rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  --bs-btn-padding-y: 0.55rem;\n  --bs-btn-padding-x: 1.25rem;\n  --bs-btn-font-size: 0.925rem;\n  --bs-btn-border-radius: 0.425rem;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n.collapsing.collapse-horizontal {\n  width: 0;\n  height: auto;\n  transition: width 0.35s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .collapsing.collapse-horizontal {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0;\n  border-left: 0.3em solid transparent;\n}\n.dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropdown-menu {\n  --bs-dropdown-zindex: 1000;\n  --bs-dropdown-min-width: 10rem;\n  --bs-dropdown-padding-x: 0;\n  --bs-dropdown-padding-y: 0.5rem;\n  --bs-dropdown-spacer: 0.125rem;\n  --bs-dropdown-font-size: 1rem;\n  --bs-dropdown-color: #181C32;\n  --bs-dropdown-bg: #ffffff;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-border-radius: 0.475rem;\n  --bs-dropdown-border-width: 0;\n  --bs-dropdown-inner-border-radius: 0.475rem;\n  --bs-dropdown-divider-bg: #f5f8fa;\n  --bs-dropdown-divider-margin-y: 0.5rem;\n  --bs-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --bs-dropdown-link-color: #181C32;\n  --bs-dropdown-link-hover-color: shade-color(#181C32, 10%);\n  --bs-dropdown-link-hover-bg: #eff2f5;\n  --bs-dropdown-link-active-color: #ffffff;\n  --bs-dropdown-link-active-bg: #009ef7;\n  --bs-dropdown-link-disabled-color: #A1A5B7;\n  --bs-dropdown-item-padding-x: 1rem;\n  --bs-dropdown-item-padding-y: 0.25rem;\n  --bs-dropdown-header-color: #7E8299;\n  --bs-dropdown-header-padding-x: 1rem;\n  --bs-dropdown-header-padding-y: 0.5rem;\n  position: absolute;\n  z-index: var(--bs-dropdown-zindex);\n  display: none;\n  min-width: var(--bs-dropdown-min-width);\n  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);\n  margin: 0;\n  font-size: var(--bs-dropdown-font-size);\n  color: var(--bs-dropdown-color);\n  text-align: left;\n  list-style: none;\n  background-color: var(--bs-dropdown-bg);\n  background-clip: padding-box;\n  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);\n  border-radius: var(--bs-dropdown-border-radius);\n  box-shadow: var(--bs-dropdown-box-shadow);\n}\n.dropdown-menu[data-bs-popper] {\n  top: 100%;\n  left: 0;\n  margin-top: var(--bs-dropdown-spacer);\n}\n\n.dropdown-menu-start {\n  --bs-position: start;\n}\n.dropdown-menu-start[data-bs-popper] {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-end {\n  --bs-position: end;\n}\n.dropdown-menu-end[data-bs-popper] {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-sm-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-sm-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-sm-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 768px) {\n  .dropdown-menu-md-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-md-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-md-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-md-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 992px) {\n  .dropdown-menu-lg-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-lg-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-lg-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-lg-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n@media (min-width: 1400px) {\n  .dropdown-menu-xxl-start {\n    --bs-position: start;\n  }\n  .dropdown-menu-xxl-start[data-bs-popper] {\n    right: auto;\n    left: 0;\n  }\n\n  .dropdown-menu-xxl-end {\n    --bs-position: end;\n  }\n  .dropdown-menu-xxl-end[data-bs-popper] {\n    right: 0;\n    left: auto;\n  }\n}\n.dropup .dropdown-menu[data-bs-popper] {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: var(--bs-dropdown-spacer);\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0;\n  border-right: 0.3em solid transparent;\n  border-bottom: 0.3em solid;\n  border-left: 0.3em solid transparent;\n}\n.dropup .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n\n.dropend .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: var(--bs-dropdown-spacer);\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0;\n  border-bottom: 0.3em solid transparent;\n  border-left: 0.3em solid;\n}\n.dropend .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropend .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropstart .dropdown-menu[data-bs-popper] {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: var(--bs-dropdown-spacer);\n}\n.dropstart .dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n}\n.dropstart .dropdown-toggle::after {\n  display: none;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-right: 0.255em;\n  vertical-align: 0.255em;\n  content: \"\";\n  border-top: 0.3em solid transparent;\n  border-right: 0.3em solid;\n  border-bottom: 0.3em solid transparent;\n}\n.dropstart .dropdown-toggle:empty::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: var(--bs-dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--bs-dropdown-divider-bg);\n  opacity: 1;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  clear: both;\n  font-weight: 400;\n  color: var(--bs-dropdown-link-color);\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n.dropdown-item:hover, .dropdown-item:focus {\n  color: var(--bs-dropdown-link-hover-color);\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n.dropdown-item.active, .dropdown-item:active {\n  color: var(--bs-dropdown-link-active-color);\n  text-decoration: none;\n  background-color: var(--bs-dropdown-link-active-bg);\n}\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: var(--bs-dropdown-link-disabled-color);\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);\n  margin-bottom: 0;\n  font-size: 0.925rem;\n  color: var(--bs-dropdown-header-color);\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-menu-dark {\n  --bs-dropdown-color: #E4E6EF;\n  --bs-dropdown-bg: #3F4254;\n  --bs-dropdown-border-color: var(--bs-border-color-translucent);\n  --bs-dropdown-box-shadow: ;\n  --bs-dropdown-link-color: #E4E6EF;\n  --bs-dropdown-link-hover-color: #ffffff;\n  --bs-dropdown-divider-bg: #f5f8fa;\n  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);\n  --bs-dropdown-link-active-color: #ffffff;\n  --bs-dropdown-link-active-bg: #009ef7;\n  --bs-dropdown-link-disabled-color: #A1A5B7;\n  --bs-dropdown-header-color: #A1A5B7;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  flex: 1 1 auto;\n}\n.btn-group > .btn-check:checked + .btn,\n.btn-group > .btn-check:focus + .btn,\n.btn-group > .btn:hover,\n.btn-group > .btn:focus,\n.btn-group > .btn:active,\n.btn-group > .btn.active,\n.btn-group-vertical > .btn-check:checked + .btn,\n.btn-group-vertical > .btn-check:focus + .btn,\n.btn-group-vertical > .btn:hover,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group {\n  border-radius: 0.475rem;\n}\n.btn-group > :not(.btn-check:first-child) + .btn,\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: -1px;\n}\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn.dropdown-toggle-split:first-child,\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.btn-group > .btn:nth-child(n+3),\n.btn-group > :not(.btn-check) + .btn,\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 1.125rem;\n  padding-left: 1.125rem;\n}\n.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n.dropstart .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.9375rem;\n  padding-left: 0.9375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 1.3125rem;\n  padding-left: 1.3125rem;\n}\n\n.btn-group.show .dropdown-toggle {\n  box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n}\n.btn-group.show .dropdown-toggle.btn-link {\n  box-shadow: none;\n}\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: -1px;\n}\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.btn-group-vertical > .btn ~ .btn,\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav {\n  --bs-nav-link-padding-x: 1rem;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-link-color);\n  --bs-nav-link-hover-color: var(--bs-link-hover-color);\n  --bs-nav-link-disabled-color: #7E8299;\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);\n  font-size: var(--bs-nav-link-font-size);\n  font-weight: var(--bs-nav-link-font-weight);\n  color: var(--bs-nav-link-color);\n  transition: color 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .nav-link {\n    transition: none;\n  }\n}\n.nav-link:hover, .nav-link:focus {\n  color: var(--bs-nav-link-hover-color);\n}\n.nav-link.disabled {\n  color: var(--bs-nav-link-disabled-color);\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-width: 1px;\n  --bs-nav-tabs-border-color: #eff2f5;\n  --bs-nav-tabs-border-radius: 0.475rem;\n  --bs-nav-tabs-link-hover-border-color: #eff2f5 #eff2f5 #eff2f5;\n  --bs-nav-tabs-link-active-color: #5E6278;\n  --bs-nav-tabs-link-active-bg: #ffffff;\n  --bs-nav-tabs-link-active-border-color: #E4E6EF #E4E6EF #ffffff;\n  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);\n}\n.nav-tabs .nav-link {\n  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));\n  background: none;\n  border: var(--bs-nav-tabs-border-width) solid transparent;\n  border-top-left-radius: var(--bs-nav-tabs-border-radius);\n  border-top-right-radius: var(--bs-nav-tabs-border-radius);\n}\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  isolation: isolate;\n  border-color: var(--bs-nav-tabs-link-hover-border-color);\n}\n.nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  background-color: transparent;\n  border-color: transparent;\n}\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: var(--bs-nav-tabs-link-active-color);\n  background-color: var(--bs-nav-tabs-link-active-bg);\n  border-color: var(--bs-nav-tabs-link-active-border-color);\n}\n.nav-tabs .dropdown-menu {\n  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills {\n  --bs-nav-pills-border-radius: 0.475rem;\n  --bs-nav-pills-link-active-color: #ffffff;\n  --bs-nav-pills-link-active-bg: #009ef7;\n}\n.nav-pills .nav-link {\n  background: none;\n  border: 0;\n  border-radius: var(--bs-nav-pills-border-radius);\n}\n.nav-pills .nav-link:disabled {\n  color: var(--bs-nav-link-disabled-color);\n  background-color: transparent;\n  border-color: transparent;\n}\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: var(--bs-nav-pills-link-active-color);\n  background-color: var(--bs-nav-pills-link-active-bg);\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  flex-basis: 0;\n  flex-grow: 1;\n  text-align: center;\n}\n\n.nav-fill .nav-item .nav-link,\n.nav-justified .nav-item .nav-link {\n  width: 100%;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  --bs-navbar-padding-x: 0;\n  --bs-navbar-padding-y: 0.5rem;\n  --bs-navbar-color: rgba(0, 0, 0, 0.55);\n  --bs-navbar-hover-color: rgba(0, 0, 0, 0.7);\n  --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);\n  --bs-navbar-active-color: rgba(0, 0, 0, 0.9);\n  --bs-navbar-brand-padding-y: 0.44375rem;\n  --bs-navbar-brand-margin-end: 1rem;\n  --bs-navbar-brand-font-size: 1.075rem;\n  --bs-navbar-brand-color: rgba(0, 0, 0, 0.9);\n  --bs-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);\n  --bs-navbar-nav-link-padding-x: 0.5rem;\n  --bs-navbar-toggler-padding-y: 0.25rem;\n  --bs-navbar-toggler-padding-x: 0.75rem;\n  --bs-navbar-toggler-font-size: 1.075rem;\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%280, 0, 0, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);\n  --bs-navbar-toggler-border-radius: 0.475rem;\n  --bs-navbar-toggler-focus-width: 0.25rem;\n  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);\n}\n.navbar > .container,\n.navbar > .container-fluid,\n.navbar > .container-sm,\n.navbar > .container-md,\n.navbar > .container-lg,\n.navbar > .container-xl,\n.navbar > .container-xxl {\n  display: flex;\n  flex-wrap: inherit;\n  align-items: center;\n  justify-content: space-between;\n}\n.navbar-brand {\n  padding-top: var(--bs-navbar-brand-padding-y);\n  padding-bottom: var(--bs-navbar-brand-padding-y);\n  margin-right: var(--bs-navbar-brand-margin-end);\n  font-size: var(--bs-navbar-brand-font-size);\n  color: var(--bs-navbar-brand-color);\n  white-space: nowrap;\n}\n.navbar-brand:hover, .navbar-brand:focus {\n  color: var(--bs-navbar-brand-hover-color);\n}\n\n.navbar-nav {\n  --bs-nav-link-padding-x: 0;\n  --bs-nav-link-padding-y: 0.5rem;\n  --bs-nav-link-font-weight: ;\n  --bs-nav-link-color: var(--bs-navbar-color);\n  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);\n  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n.navbar-nav .show > .nav-link,\n.navbar-nav .nav-link.active {\n  color: var(--bs-navbar-active-color);\n}\n.navbar-nav .dropdown-menu {\n  position: static;\n}\n\n.navbar-text {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  color: var(--bs-navbar-color);\n}\n.navbar-text a,\n.navbar-text a:hover,\n.navbar-text a:focus {\n  color: var(--bs-navbar-active-color);\n}\n\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  align-items: center;\n}\n\n.navbar-toggler {\n  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);\n  font-size: var(--bs-navbar-toggler-font-size);\n  line-height: 1;\n  color: var(--bs-navbar-color);\n  background-color: transparent;\n  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);\n  border-radius: var(--bs-navbar-toggler-border-radius);\n  transition: var(--bs-navbar-toggler-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .navbar-toggler {\n    transition: none;\n  }\n}\n.navbar-toggler:hover {\n  text-decoration: none;\n}\n.navbar-toggler:focus {\n  text-decoration: none;\n  outline: 0;\n  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--bs-navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--bs-scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-sm .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-sm .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-md .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-md .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-lg .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-lg .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .navbar-expand-xxl {\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n  }\n  .navbar-expand-xxl .navbar-nav {\n    flex-direction: row;\n  }\n  .navbar-expand-xxl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xxl .navbar-nav .nav-link {\n    padding-right: var(--bs-navbar-nav-link-padding-x);\n    padding-left: var(--bs-navbar-nav-link-padding-x);\n  }\n  .navbar-expand-xxl .navbar-nav-scroll {\n    overflow: visible;\n  }\n  .navbar-expand-xxl .navbar-collapse {\n    display: flex !important;\n    flex-basis: auto;\n  }\n  .navbar-expand-xxl .navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas {\n    position: static;\n    z-index: auto;\n    flex-grow: 1;\n    width: auto !important;\n    height: auto !important;\n    visibility: visible !important;\n    background-color: transparent !important;\n    border: 0 !important;\n    transform: none !important;\n    box-shadow: none;\n    transition: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-header {\n    display: none;\n  }\n  .navbar-expand-xxl .offcanvas .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n  }\n}\n.navbar-expand {\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.navbar-expand .navbar-nav {\n  flex-direction: row;\n}\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: var(--bs-navbar-nav-link-padding-x);\n  padding-left: var(--bs-navbar-nav-link-padding-x);\n}\n.navbar-expand .navbar-nav-scroll {\n  overflow: visible;\n}\n.navbar-expand .navbar-collapse {\n  display: flex !important;\n  flex-basis: auto;\n}\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n.navbar-expand .offcanvas {\n  position: static;\n  z-index: auto;\n  flex-grow: 1;\n  width: auto !important;\n  height: auto !important;\n  visibility: visible !important;\n  background-color: transparent !important;\n  border: 0 !important;\n  transform: none !important;\n  box-shadow: none;\n  transition: none;\n}\n.navbar-expand .offcanvas .offcanvas-header {\n  display: none;\n}\n.navbar-expand .offcanvas .offcanvas-body {\n  display: flex;\n  flex-grow: 0;\n  padding: 0;\n  overflow-y: visible;\n}\n\n.navbar-dark {\n  --bs-navbar-color: rgba(255, 255, 255, 0.55);\n  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);\n  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);\n  --bs-navbar-active-color: #ffffff;\n  --bs-navbar-brand-color: #ffffff;\n  --bs-navbar-brand-hover-color: #ffffff;\n  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);\n  --bs-navbar-toggler-icon-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.55%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.card {\n  --bs-card-spacer-y: 1rem;\n  --bs-card-spacer-x: 1rem;\n  --bs-card-title-spacer-y: 0.5rem;\n  --bs-card-border-width: 1px;\n  --bs-card-border-color: #eff2f5;\n  --bs-card-border-radius: 0.625rem;\n  --bs-card-box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);\n  --bs-card-inner-border-radius: calc(0.625rem - 1px);\n  --bs-card-cap-padding-y: 0.5rem;\n  --bs-card-cap-padding-x: 1rem;\n  --bs-card-cap-bg: transparent;\n  --bs-card-cap-color: ;\n  --bs-card-height: ;\n  --bs-card-color: ;\n  --bs-card-bg: #ffffff;\n  --bs-card-img-overlay-padding: 1rem;\n  --bs-card-group-margin: 0.75rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  height: var(--bs-card-height);\n  word-wrap: break-word;\n  background-color: var(--bs-card-bg);\n  background-clip: border-box;\n  border: var(--bs-card-border-width) solid var(--bs-card-border-color);\n  border-radius: var(--bs-card-border-radius);\n  box-shadow: var(--bs-card-box-shadow);\n}\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);\n  color: var(--bs-card-color);\n}\n\n.card-title {\n  margin-bottom: var(--bs-card-title-spacer-y);\n}\n\n.card-subtitle {\n  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link + .card-link {\n  margin-left: var(--bs-card-spacer-x);\n}\n\n.card-header {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  margin-bottom: 0;\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-header:first-child {\n  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;\n}\n\n.card-footer {\n  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);\n  color: var(--bs-card-cap-color);\n  background-color: var(--bs-card-cap-bg);\n  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);\n}\n.card-footer:last-child {\n  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);\n}\n\n.card-header-tabs {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n  border-bottom: 0;\n}\n.card-header-tabs .nav-link.active {\n  background-color: var(--bs-card-bg);\n  border-bottom-color: var(--bs-card-bg);\n}\n\n.card-header-pills {\n  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));\n  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--bs-card-img-overlay-padding);\n  border-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: var(--bs-card-inner-border-radius);\n  border-top-right-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: var(--bs-card-inner-border-radius);\n  border-bottom-left-radius: var(--bs-card-inner-border-radius);\n}\n\n.card-group > .card {\n  margin-bottom: var(--bs-card-group-margin);\n}\n@media (min-width: 576px) {\n  .card-group {\n    display: flex;\n    flex-flow: row wrap;\n  }\n  .card-group > .card {\n    flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n.card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n.card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n.card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n.card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.accordion {\n  --bs-accordion-color: #181C32;\n  --bs-accordion-bg: #ffffff;\n  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;\n  --bs-accordion-border-color: #eff2f5;\n  --bs-accordion-border-width: 1px;\n  --bs-accordion-border-radius: 0.475rem;\n  --bs-accordion-inner-border-radius: calc(0.475rem - 1px);\n  --bs-accordion-btn-padding-x: 1.5rem;\n  --bs-accordion-btn-padding-y: 1.5rem;\n  --bs-accordion-btn-color: #181C32;\n  --bs-accordion-btn-bg: #ffffff;\n  --bs-accordion-btn-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23181C32'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-icon-width: 1.15rem;\n  --bs-accordion-btn-icon-transform: rotate(-180deg);\n  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;\n  --bs-accordion-btn-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23009ef7'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --bs-accordion-btn-focus-border-color: #eff2f5;\n  --bs-accordion-btn-focus-box-shadow: none;\n  --bs-accordion-body-padding-x: 1.5rem;\n  --bs-accordion-body-padding-y: 1.5rem;\n  --bs-accordion-active-color: #009ef7;\n  --bs-accordion-active-bg: #f5f8fa;\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);\n  font-size: 1rem;\n  color: var(--bs-accordion-btn-color);\n  text-align: left;\n  background-color: var(--bs-accordion-btn-bg);\n  border: 0;\n  border-radius: 0;\n  overflow-anchor: none;\n  transition: var(--bs-accordion-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button {\n    transition: none;\n  }\n}\n.accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-active-color);\n  background-color: var(--bs-accordion-active-bg);\n  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);\n}\n.accordion-button:not(.collapsed)::after {\n  background-image: var(--bs-accordion-btn-active-icon);\n  transform: var(--bs-accordion-btn-icon-transform);\n}\n.accordion-button::after {\n  flex-shrink: 0;\n  width: var(--bs-accordion-btn-icon-width);\n  height: var(--bs-accordion-btn-icon-width);\n  margin-left: auto;\n  content: \"\";\n  background-image: var(--bs-accordion-btn-icon);\n  background-repeat: no-repeat;\n  background-size: var(--bs-accordion-btn-icon-width);\n  transition: var(--bs-accordion-btn-icon-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .accordion-button::after {\n    transition: none;\n  }\n}\n.accordion-button:hover {\n  z-index: 2;\n}\n.accordion-button:focus {\n  z-index: 3;\n  border-color: var(--bs-accordion-btn-focus-border-color);\n  outline: 0;\n  box-shadow: var(--bs-accordion-btn-focus-box-shadow);\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--bs-accordion-color);\n  background-color: var(--bs-accordion-bg);\n  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);\n}\n.accordion-item:first-of-type {\n  border-top-left-radius: var(--bs-accordion-border-radius);\n  border-top-right-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: var(--bs-accordion-inner-border-radius);\n  border-top-right-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:not(:first-of-type) {\n  border-top: 0;\n}\n.accordion-item:last-of-type {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n.accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);\n}\n.accordion-item:last-of-type .accordion-collapse {\n  border-bottom-right-radius: var(--bs-accordion-border-radius);\n  border-bottom-left-radius: var(--bs-accordion-border-radius);\n}\n\n.accordion-body {\n  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);\n}\n\n.accordion-flush .accordion-collapse {\n  border-width: 0;\n}\n.accordion-flush .accordion-item {\n  border-right: 0;\n  border-left: 0;\n  border-radius: 0;\n}\n.accordion-flush .accordion-item:first-child {\n  border-top: 0;\n}\n.accordion-flush .accordion-item:last-child {\n  border-bottom: 0;\n}\n.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {\n  border-radius: 0;\n}\n\n.breadcrumb {\n  --bs-breadcrumb-padding-x: 0;\n  --bs-breadcrumb-padding-y: 0;\n  --bs-breadcrumb-margin-bottom: 1rem;\n  --bs-breadcrumb-bg: ;\n  --bs-breadcrumb-border-radius: ;\n  --bs-breadcrumb-divider-color: #7E8299;\n  --bs-breadcrumb-item-padding-x: 0.5rem;\n  --bs-breadcrumb-item-active-color: #009ef7;\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);\n  margin-bottom: var(--bs-breadcrumb-margin-bottom);\n  font-size: var(--bs-breadcrumb-font-size);\n  list-style: none;\n  background-color: var(--bs-breadcrumb-bg);\n  border-radius: var(--bs-breadcrumb-border-radius);\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: var(--bs-breadcrumb-item-padding-x);\n}\n.breadcrumb-item + .breadcrumb-item::before {\n  float: left;\n  padding-right: var(--bs-breadcrumb-item-padding-x);\n  color: var(--bs-breadcrumb-divider-color);\n  content: var(--bs-breadcrumb-divider, \"/\") /* rtl: var(--bs-breadcrumb-divider, \"/\") */;\n}\n.breadcrumb-item.active {\n  color: var(--bs-breadcrumb-item-active-color);\n}\n\n.pagination {\n  --bs-pagination-padding-x: 0.75rem;\n  --bs-pagination-padding-y: 0.375rem;\n  --bs-pagination-font-size: 1.075rem;\n  --bs-pagination-color: #5E6278;\n  --bs-pagination-bg: transparent;\n  --bs-pagination-border-width: 0;\n  --bs-pagination-border-color: transparent;\n  --bs-pagination-border-radius: 0.475rem;\n  --bs-pagination-hover-color: #009ef7;\n  --bs-pagination-hover-bg: #F4F6FA;\n  --bs-pagination-hover-border-color: transparent;\n  --bs-pagination-focus-color: #009ef7;\n  --bs-pagination-focus-bg: #F4F6FA;\n  --bs-pagination-focus-box-shadow: none;\n  --bs-pagination-active-color: #ffffff;\n  --bs-pagination-active-bg: #009ef7;\n  --bs-pagination-active-border-color: transparent;\n  --bs-pagination-disabled-color: #B5B5C3;\n  --bs-pagination-disabled-bg: transparent;\n  --bs-pagination-disabled-border-color: transparent;\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);\n  font-size: var(--bs-pagination-font-size);\n  color: var(--bs-pagination-color);\n  background-color: var(--bs-pagination-bg);\n  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .page-link {\n    transition: none;\n  }\n}\n.page-link:hover {\n  z-index: 2;\n  color: var(--bs-pagination-hover-color);\n  background-color: var(--bs-pagination-hover-bg);\n  border-color: var(--bs-pagination-hover-border-color);\n}\n.page-link:focus {\n  z-index: 3;\n  color: var(--bs-pagination-focus-color);\n  background-color: var(--bs-pagination-focus-bg);\n  outline: 0;\n  box-shadow: var(--bs-pagination-focus-box-shadow);\n}\n.page-link.active, .active > .page-link {\n  z-index: 3;\n  color: var(--bs-pagination-active-color);\n  background-color: var(--bs-pagination-active-bg);\n  border-color: var(--bs-pagination-active-border-color);\n}\n.page-link.disabled, .disabled > .page-link {\n  color: var(--bs-pagination-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-pagination-disabled-bg);\n  border-color: var(--bs-pagination-disabled-border-color);\n}\n\n.page-item:not(:first-child) .page-link {\n  margin-left: 0;\n}\n.page-item:first-child .page-link {\n  border-top-left-radius: var(--bs-pagination-border-radius);\n  border-bottom-left-radius: var(--bs-pagination-border-radius);\n}\n.page-item:last-child .page-link {\n  border-top-right-radius: var(--bs-pagination-border-radius);\n  border-bottom-right-radius: var(--bs-pagination-border-radius);\n}\n\n.pagination-lg {\n  --bs-pagination-padding-x: 1.5rem;\n  --bs-pagination-padding-y: 0.75rem;\n  --bs-pagination-font-size: 1.075rem;\n  --bs-pagination-border-radius: 0.625rem;\n}\n\n.pagination-sm {\n  --bs-pagination-padding-x: 0.5rem;\n  --bs-pagination-padding-y: 0.25rem;\n  --bs-pagination-font-size: 0.925rem;\n  --bs-pagination-border-radius: 0.425rem;\n}\n\n.badge {\n  --bs-badge-padding-x: 0.5rem;\n  --bs-badge-padding-y: 0.325rem;\n  --bs-badge-font-size: 0.85rem;\n  --bs-badge-font-weight: 600;\n  --bs-badge-color: #ffffff;\n  --bs-badge-border-radius: 0.425rem;\n  display: inline-block;\n  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);\n  font-size: var(--bs-badge-font-size);\n  font-weight: var(--bs-badge-font-weight);\n  line-height: 1;\n  color: var(--bs-badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: var(--bs-badge-border-radius);\n}\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.alert {\n  --bs-alert-bg: transparent;\n  --bs-alert-padding-x: 1rem;\n  --bs-alert-padding-y: 1rem;\n  --bs-alert-margin-bottom: 1rem;\n  --bs-alert-color: inherit;\n  --bs-alert-border-color: transparent;\n  --bs-alert-border: 1px solid var(--bs-alert-border-color);\n  --bs-alert-border-radius: 0.475rem;\n  position: relative;\n  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);\n  margin-bottom: var(--bs-alert-margin-bottom);\n  color: var(--bs-alert-color);\n  background-color: var(--bs-alert-bg);\n  border: var(--bs-alert-border);\n  border-radius: var(--bs-alert-border-radius);\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 600;\n}\n\n.alert-dismissible {\n  padding-right: 3rem;\n}\n.alert-dismissible .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 1.25rem 1rem;\n}\n\n.alert-white {\n  --bs-alert-color: #666666;\n  --bs-alert-bg: white;\n  --bs-alert-border-color: white;\n}\n.alert-white .alert-link {\n  color: #525252;\n}\n\n.alert-light {\n  --bs-alert-color: #626364;\n  --bs-alert-bg: #fdfefe;\n  --bs-alert-border-color: #fcfdfe;\n}\n.alert-light .alert-link {\n  color: #4e4f50;\n}\n\n.alert-primary {\n  --bs-alert-color: #005f94;\n  --bs-alert-bg: #ccecfd;\n  --bs-alert-border-color: #b3e2fd;\n}\n.alert-primary .alert-link {\n  color: #004c76;\n}\n\n.alert-secondary {\n  --bs-alert-color: #5b5c60;\n  --bs-alert-bg: #fafafc;\n  --bs-alert-border-color: #f7f8fa;\n}\n.alert-secondary .alert-link {\n  color: #494a4d;\n}\n\n.alert-success {\n  --bs-alert-color: #205237;\n  --bs-alert-bg: #dcf5e7;\n  --bs-alert-border-color: #cbf0dc;\n}\n.alert-success .alert-link {\n  color: #1a422c;\n}\n\n.alert-info {\n  --bs-alert-color: #44228c;\n  --bs-alert-bg: #e3d7fb;\n  --bs-alert-border-color: #d5c4f9;\n}\n.alert-info .alert-link {\n  color: #361b70;\n}\n\n.alert-warning {\n  --bs-alert-color: #665000;\n  --bs-alert-bg: #fff4cc;\n  --bs-alert-border-color: #ffeeb3;\n}\n.alert-warning .alert-link {\n  color: #524000;\n}\n\n.alert-danger {\n  --bs-alert-color: #912741;\n  --bs-alert-bg: #fcd9e2;\n  --bs-alert-border-color: #fbc6d3;\n}\n.alert-danger .alert-link {\n  color: #741f34;\n}\n\n.alert-dark {\n  --bs-alert-color: #0e111e;\n  --bs-alert-bg: #d1d2d6;\n  --bs-alert-border-color: #babbc2;\n}\n.alert-dark .alert-link {\n  color: #0b0e18;\n}\n\n@keyframes progress-bar-stripes {\n  0% {\n    background-position-x: 1rem;\n  }\n}\n.progress {\n  --bs-progress-height: 1rem;\n  --bs-progress-font-size: 0.75rem;\n  --bs-progress-bg: #f5f8fa;\n  --bs-progress-border-radius: 6px;\n  --bs-progress-box-shadow: none;\n  --bs-progress-bar-color: #ffffff;\n  --bs-progress-bar-bg: #009ef7;\n  --bs-progress-bar-transition: width 0.6s ease;\n  display: flex;\n  height: var(--bs-progress-height);\n  overflow: hidden;\n  font-size: var(--bs-progress-font-size);\n  background-color: var(--bs-progress-bg);\n  border-radius: var(--bs-progress-border-radius);\n  box-shadow: var(--bs-progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--bs-progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--bs-progress-bar-bg);\n  transition: var(--bs-progress-bar-transition);\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: var(--bs-progress-height) var(--bs-progress-height);\n}\n\n.progress-bar-animated {\n  animation: 1s linear infinite progress-bar-stripes;\n}\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    animation: none;\n  }\n}\n\n.list-group {\n  --bs-list-group-color: #181C32;\n  --bs-list-group-bg: #ffffff;\n  --bs-list-group-border-color: rgba(0, 0, 0, 0.125);\n  --bs-list-group-border-width: 1px;\n  --bs-list-group-border-radius: 0.475rem;\n  --bs-list-group-item-padding-x: 1rem;\n  --bs-list-group-item-padding-y: 0.5rem;\n  --bs-list-group-action-color: #5E6278;\n  --bs-list-group-action-hover-color: #5E6278;\n  --bs-list-group-action-hover-bg: #f5f8fa;\n  --bs-list-group-action-active-color: #181C32;\n  --bs-list-group-action-active-bg: #eff2f5;\n  --bs-list-group-disabled-color: #7E8299;\n  --bs-list-group-disabled-bg: #ffffff;\n  --bs-list-group-active-color: #ffffff;\n  --bs-list-group-active-bg: #009ef7;\n  --bs-list-group-active-border-color: #009ef7;\n  display: flex;\n  flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: var(--bs-list-group-border-radius);\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n}\n.list-group-numbered > .list-group-item::before {\n  content: counters(section, \".\") \". \";\n  counter-increment: section;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: var(--bs-list-group-action-color);\n  text-align: inherit;\n}\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: var(--bs-list-group-action-hover-color);\n  text-decoration: none;\n  background-color: var(--bs-list-group-action-hover-bg);\n}\n.list-group-item-action:active {\n  color: var(--bs-list-group-action-active-color);\n  background-color: var(--bs-list-group-action-active-bg);\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);\n  color: var(--bs-list-group-color);\n  background-color: var(--bs-list-group-bg);\n  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);\n}\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n.list-group-item.disabled, .list-group-item:disabled {\n  color: var(--bs-list-group-disabled-color);\n  pointer-events: none;\n  background-color: var(--bs-list-group-disabled-bg);\n}\n.list-group-item.active {\n  z-index: 2;\n  color: var(--bs-list-group-active-color);\n  background-color: var(--bs-list-group-active-bg);\n  border-color: var(--bs-list-group-active-border-color);\n}\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n.list-group-item + .list-group-item.active {\n  margin-top: calc(-1 * var(--bs-list-group-border-width));\n  border-top-width: var(--bs-list-group-border-width);\n}\n\n.list-group-horizontal {\n  flex-direction: row;\n}\n.list-group-horizontal > .list-group-item:first-child:not(:last-child) {\n  border-bottom-left-radius: var(--bs-list-group-border-radius);\n  border-top-right-radius: 0;\n}\n.list-group-horizontal > .list-group-item:last-child:not(:first-child) {\n  border-top-right-radius: var(--bs-list-group-border-radius);\n  border-bottom-left-radius: 0;\n}\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: var(--bs-list-group-border-width);\n  border-left-width: 0;\n}\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: calc(-1 * var(--bs-list-group-border-width));\n  border-left-width: var(--bs-list-group-border-width);\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n@media (min-width: 1400px) {\n  .list-group-horizontal-xxl {\n    flex-direction: row;\n  }\n  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {\n    border-bottom-left-radius: var(--bs-list-group-border-radius);\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {\n    border-top-right-radius: var(--bs-list-group-border-radius);\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item {\n    border-top-width: var(--bs-list-group-border-width);\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {\n    margin-left: calc(-1 * var(--bs-list-group-border-width));\n    border-left-width: var(--bs-list-group-border-width);\n  }\n}\n.list-group-flush {\n  border-radius: 0;\n}\n.list-group-flush > .list-group-item {\n  border-width: 0 0 var(--bs-list-group-border-width);\n}\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-white {\n  color: #666666;\n  background-color: white;\n}\n.list-group-item-white.list-group-item-action:hover, .list-group-item-white.list-group-item-action:focus {\n  color: #666666;\n  background-color: #e6e6e6;\n}\n.list-group-item-white.list-group-item-action.active {\n  color: #ffffff;\n  background-color: #666666;\n  border-color: #666666;\n}\n\n.list-group-item-light {\n  color: #626364;\n  background-color: #fdfefe;\n}\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n  color: #626364;\n  background-color: #e4e5e5;\n}\n.list-group-item-light.list-group-item-action.active {\n  color: #ffffff;\n  background-color: #626364;\n  border-color: #626364;\n}\n\n.list-group-item-primary {\n  color: #005f94;\n  background-color: #ccecfd;\n}\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n  color: #005f94;\n  background-color: #b8d4e4;\n}\n.list-group-item-primary.list-group-item-action.active {\n  color: #ffffff;\n  background-color: #005f94;\n  border-color: #005f94;\n}\n\n.list-group-item-secondary {\n  color: #5b5c60;\n  background-color: #fafafc;\n}\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n  color: #5b5c60;\n  background-color: #e1e1e3;\n}\n.list-group-item-secondary.list-group-item-action.active {\n  color: #ffffff;\n  background-color: #5b5c60;\n  border-color: #5b5c60;\n}\n\n.list-group-item-success {\n  color: #205237;\n  background-color: #dcf5e7;\n}\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n  color: #205237;\n  background-color: #c6ddd0;\n}\n.list-group-item-success.list-group-item-action.active {\n  color: #ffffff;\n  background-color: #205237;\n  border-color: #205237;\n}\n\n.list-group-item-info {\n  color: #44228c;\n  background-color: #e3d7fb;\n}\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n  color: #44228c;\n  background-color: #ccc2e2;\n}\n.list-group-item-info.list-group-item-action.active {\n  color: #ffffff;\n  background-color: #44228c;\n  border-color: #44228c;\n}\n\n.list-group-item-warning {\n  color: #665000;\n  background-color: #fff4cc;\n}\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n  color: #665000;\n  background-color: #e6dcb8;\n}\n.list-group-item-warning.list-group-item-action.active {\n  color: #ffffff;\n  background-color: #665000;\n  border-color: #665000;\n}\n\n.list-group-item-danger {\n  color: #912741;\n  background-color: #fcd9e2;\n}\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n  color: #912741;\n  background-color: #e3c3cb;\n}\n.list-group-item-danger.list-group-item-action.active {\n  color: #ffffff;\n  background-color: #912741;\n  border-color: #912741;\n}\n\n.list-group-item-dark {\n  color: #0e111e;\n  background-color: #d1d2d6;\n}\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n  color: #0e111e;\n  background-color: #bcbdc1;\n}\n.list-group-item-dark.list-group-item-action.active {\n  color: #ffffff;\n  background-color: #0e111e;\n  border-color: #0e111e;\n}\n\n.btn-close {\n  box-sizing: content-box;\n  width: 0.75rem;\n  height: 0.75rem;\n  padding: 0.25em 0.25em;\n  color: #000000;\n  background: transparent url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\") center/0.75rem auto no-repeat;\n  border: 0;\n  border-radius: 0.475rem;\n  opacity: 0.5;\n}\n.btn-close:hover {\n  color: #000000;\n  text-decoration: none;\n  opacity: 0.75;\n}\n.btn-close:focus {\n  outline: 0;\n  box-shadow: none;\n  opacity: 1;\n}\n.btn-close:disabled, .btn-close.disabled {\n  pointer-events: none;\n  user-select: none;\n  opacity: 0.25;\n}\n\n.btn-close-white {\n  filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n.toast {\n  --bs-toast-zindex: 1090;\n  --bs-toast-padding-x: 0.75rem;\n  --bs-toast-padding-y: 0.5rem;\n  --bs-toast-spacing: 1.5rem;\n  --bs-toast-max-width: 350px;\n  --bs-toast-font-size: 0.875rem;\n  --bs-toast-color: ;\n  --bs-toast-bg: rgba(255, 255, 255, 0.85);\n  --bs-toast-border-width: 1px;\n  --bs-toast-border-color: var(--bs-border-color-translucent);\n  --bs-toast-border-radius: 0.475rem;\n  --bs-toast-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --bs-toast-header-color: #7E8299;\n  --bs-toast-header-bg: rgba(255, 255, 255, 0.85);\n  --bs-toast-header-border-color: rgba(0, 0, 0, 0.05);\n  width: var(--bs-toast-max-width);\n  max-width: 100%;\n  font-size: var(--bs-toast-font-size);\n  color: var(--bs-toast-color);\n  pointer-events: auto;\n  background-color: var(--bs-toast-bg);\n  background-clip: padding-box;\n  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);\n  box-shadow: var(--bs-toast-box-shadow);\n  border-radius: var(--bs-toast-border-radius);\n}\n.toast.showing {\n  opacity: 0;\n}\n.toast:not(.show) {\n  display: none;\n}\n\n.toast-container {\n  --bs-toast-zindex: 1090;\n  position: absolute;\n  z-index: var(--bs-toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n}\n.toast-container > :not(:last-child) {\n  margin-bottom: var(--bs-toast-spacing);\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);\n  color: var(--bs-toast-header-color);\n  background-color: var(--bs-toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);\n  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));\n}\n.toast-header .btn-close {\n  margin-right: calc(-0.5 * var(--bs-toast-padding-x));\n  margin-left: var(--bs-toast-padding-x);\n}\n\n.toast-body {\n  padding: var(--bs-toast-padding-x);\n  word-wrap: break-word;\n}\n\n.modal {\n  --bs-modal-zindex: 1055;\n  --bs-modal-width: 500px;\n  --bs-modal-padding: 1.75rem;\n  --bs-modal-margin: 0.5rem;\n  --bs-modal-color: ;\n  --bs-modal-bg: #ffffff;\n  --bs-modal-border-color: var(--bs-border-color-translucent);\n  --bs-modal-border-width: 0;\n  --bs-modal-border-radius: 0.475rem;\n  --bs-modal-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);\n  --bs-modal-inner-border-radius: 0.475rem;\n  --bs-modal-header-padding-x: 1.75rem;\n  --bs-modal-header-padding-y: 1.75rem;\n  --bs-modal-header-padding: 1.75rem 1.75rem;\n  --bs-modal-header-border-color: #eff2f5;\n  --bs-modal-header-border-width: 1px;\n  --bs-modal-title-line-height: 1.5;\n  --bs-modal-footer-gap: 0.5rem;\n  --bs-modal-footer-bg: ;\n  --bs-modal-footer-border-color: #eff2f5;\n  --bs-modal-footer-border-width: 1px;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--bs-modal-margin);\n  pointer-events: none;\n}\n.modal.fade .modal-dialog {\n  transition: transform 0.3s ease-out;\n  transform: translate(0, -50px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n.modal.show .modal-dialog {\n  transform: none;\n}\n.modal.modal-static .modal-dialog {\n  transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--bs-modal-margin) * 2);\n}\n.modal-dialog-scrollable .modal-content {\n  max-height: 100%;\n  overflow: hidden;\n}\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--bs-modal-margin) * 2);\n}\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  color: var(--bs-modal-color);\n  pointer-events: auto;\n  background-color: var(--bs-modal-bg);\n  background-clip: padding-box;\n  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);\n  border-radius: var(--bs-modal-border-radius);\n  box-shadow: var(--bs-modal-box-shadow);\n  outline: 0;\n}\n\n.modal-backdrop {\n  --bs-backdrop-zindex: 1050;\n  --bs-backdrop-bg: #000000;\n  --bs-backdrop-opacity: 0.3;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--bs-backdrop-zindex);\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--bs-backdrop-bg);\n}\n.modal-backdrop.fade {\n  opacity: 0;\n}\n.modal-backdrop.show {\n  opacity: var(--bs-backdrop-opacity);\n}\n\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-modal-header-padding);\n  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);\n  border-top-left-radius: var(--bs-modal-inner-border-radius);\n  border-top-right-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-header .btn-close {\n  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);\n  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--bs-modal-title-line-height);\n}\n\n.modal-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: var(--bs-modal-padding);\n}\n\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);\n  background-color: var(--bs-modal-footer-bg);\n  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);\n  border-bottom-right-radius: var(--bs-modal-inner-border-radius);\n  border-bottom-left-radius: var(--bs-modal-inner-border-radius);\n}\n.modal-footer > * {\n  margin: calc(var(--bs-modal-footer-gap) * 0.5);\n}\n\n@media (min-width: 576px) {\n  .modal {\n    --bs-modal-margin: 1.75rem;\n    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);\n  }\n\n  .modal-dialog {\n    max-width: var(--bs-modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --bs-modal-width: 300px;\n  }\n}\n@media (min-width: 992px) {\n  .modal-lg,\n.modal-xl {\n    --bs-modal-width: 800px;\n  }\n}\n@media (min-width: 1200px) {\n  .modal-xl {\n    --bs-modal-width: 1140px;\n  }\n}\n.modal-fullscreen {\n  width: 100vw;\n  max-width: none;\n  height: 100%;\n  margin: 0;\n}\n.modal-fullscreen .modal-content {\n  height: 100%;\n  border: 0;\n  border-radius: 0;\n}\n.modal-fullscreen .modal-header,\n.modal-fullscreen .modal-footer {\n  border-radius: 0;\n}\n.modal-fullscreen .modal-body {\n  overflow-y: auto;\n}\n\n@media (max-width: 575.98px) {\n  .modal-fullscreen-sm-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-sm-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-header,\n.modal-fullscreen-sm-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-sm-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 767.98px) {\n  .modal-fullscreen-md-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-md-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-header,\n.modal-fullscreen-md-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-md-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 991.98px) {\n  .modal-fullscreen-lg-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-lg-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-header,\n.modal-fullscreen-lg-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-lg-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1199.98px) {\n  .modal-fullscreen-xl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-header,\n.modal-fullscreen-xl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n@media (max-width: 1399.98px) {\n  .modal-fullscreen-xxl-down {\n    width: 100vw;\n    max-width: none;\n    height: 100%;\n    margin: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-content {\n    height: 100%;\n    border: 0;\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-header,\n.modal-fullscreen-xxl-down .modal-footer {\n    border-radius: 0;\n  }\n  .modal-fullscreen-xxl-down .modal-body {\n    overflow-y: auto;\n  }\n}\n.tooltip {\n  --bs-tooltip-zindex: 1080;\n  --bs-tooltip-max-width: 200px;\n  --bs-tooltip-padding-x: 1rem;\n  --bs-tooltip-padding-y: 0.75rem;\n  --bs-tooltip-margin: 0;\n  --bs-tooltip-font-size: 0.925rem;\n  --bs-tooltip-color: #3F4254;\n  --bs-tooltip-bg: #ffffff;\n  --bs-tooltip-border-radius: 0.475rem;\n  --bs-tooltip-opacity: 1;\n  --bs-tooltip-arrow-width: 0.8rem;\n  --bs-tooltip-arrow-height: 0.4rem;\n  z-index: var(--bs-tooltip-zindex);\n  display: block;\n  padding: var(--bs-tooltip-arrow-height);\n  margin: var(--bs-tooltip-margin);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-tooltip-font-size);\n  word-wrap: break-word;\n  opacity: 0;\n}\n.tooltip.show {\n  opacity: var(--bs-tooltip-opacity);\n}\n.tooltip .tooltip-arrow {\n  display: block;\n  width: var(--bs-tooltip-arrow-width);\n  height: var(--bs-tooltip-arrow-height);\n}\n.tooltip .tooltip-arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {\n  bottom: 0;\n}\n.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  top: -1px;\n  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-top-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {\n  left: 0;\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  right: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;\n  border-right-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {\n  top: 0;\n}\n.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  bottom: -1px;\n  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-bottom-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {\n  right: 0;\n  width: var(--bs-tooltip-arrow-height);\n  height: var(--bs-tooltip-arrow-width);\n}\n.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  left: -1px;\n  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);\n  border-left-color: var(--bs-tooltip-bg);\n}\n\n/* rtl:end:ignore */\n.tooltip-inner {\n  max-width: var(--bs-tooltip-max-width);\n  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);\n  color: var(--bs-tooltip-color);\n  text-align: center;\n  background-color: var(--bs-tooltip-bg);\n  border-radius: var(--bs-tooltip-border-radius);\n}\n\n.popover {\n  --bs-popover-zindex: 1070;\n  --bs-popover-max-width: 276px;\n  --bs-popover-font-size: 1rem;\n  --bs-popover-bg: #ffffff;\n  --bs-popover-border-width: 1px;\n  --bs-popover-border-color: #ffffff;\n  --bs-popover-border-radius: 0.475rem;\n  --bs-popover-inner-border-radius: calc(0.475rem - 1px);\n  --bs-popover-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --bs-popover-header-padding-x: 1.25rem;\n  --bs-popover-header-padding-y: 1rem;\n  --bs-popover-header-font-size: 1rem;\n  --bs-popover-header-color: #3F4254;\n  --bs-popover-header-bg: #ffffff;\n  --bs-popover-body-padding-x: 1.25rem;\n  --bs-popover-body-padding-y: 1.25rem;\n  --bs-popover-body-color: #3F4254;\n  --bs-popover-arrow-width: 1rem;\n  --bs-popover-arrow-height: 0.5rem;\n  --bs-popover-arrow-border: var(--bs-popover-border-color);\n  z-index: var(--bs-popover-zindex);\n  display: block;\n  max-width: var(--bs-popover-max-width);\n  font-family: var(--bs-font-sans-serif);\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n  font-size: var(--bs-popover-font-size);\n  word-wrap: break-word;\n  background-color: var(--bs-popover-bg);\n  background-clip: padding-box;\n  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-radius: var(--bs-popover-border-radius);\n  box-shadow: var(--bs-popover-box-shadow);\n}\n.popover .popover-arrow {\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  height: var(--bs-popover-arrow-height);\n}\n.popover .popover-arrow::before, .popover .popover-arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n  border-width: 0;\n}\n\n.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {\n  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  bottom: 0;\n  border-top-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  bottom: var(--bs-popover-border-width);\n  border-top-color: var(--bs-popover-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {\n  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;\n}\n.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  left: 0;\n  border-right-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  left: var(--bs-popover-border-width);\n  border-right-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {\n  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  top: 0;\n  border-bottom-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  top: var(--bs-popover-border-width);\n  border-bottom-color: var(--bs-popover-bg);\n}\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: var(--bs-popover-arrow-width);\n  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));\n  content: \"\";\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {\n  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));\n  width: var(--bs-popover-arrow-height);\n  height: var(--bs-popover-arrow-width);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);\n}\n.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  right: 0;\n  border-left-color: var(--bs-popover-arrow-border);\n}\n.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  right: var(--bs-popover-border-width);\n  border-left-color: var(--bs-popover-bg);\n}\n\n/* rtl:end:ignore */\n.popover-header {\n  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);\n  margin-bottom: 0;\n  font-size: var(--bs-popover-header-font-size);\n  color: var(--bs-popover-header-color);\n  background-color: var(--bs-popover-header-bg);\n  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);\n  border-top-left-radius: var(--bs-popover-inner-border-radius);\n  border-top-right-radius: var(--bs-popover-inner-border-radius);\n}\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);\n  color: var(--bs-popover-body-color);\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n/* rtl:begin:ignore */\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n/* rtl:end:ignore */\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  transform: none;\n}\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-start,\n.carousel-fade .carousel-item-prev.carousel-item-end {\n  z-index: 1;\n  opacity: 1;\n}\n.carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-start,\n.carousel-fade .active.carousel-item-end {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 15%;\n  padding: 0;\n  color: #ffffff;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n.carousel-control-next {\n    transition: none;\n  }\n}\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #ffffff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  margin-right: 15%;\n  margin-bottom: 1rem;\n  margin-left: 15%;\n  list-style: none;\n}\n.carousel-indicators [data-bs-target] {\n  box-sizing: content-box;\n  flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  padding: 0;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #ffffff;\n  background-clip: padding-box;\n  border: 0;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: 0.5;\n  transition: opacity 0.6s ease;\n}\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators [data-bs-target] {\n    transition: none;\n  }\n}\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 1.25rem;\n  left: 15%;\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n  color: #ffffff;\n  text-align: center;\n}\n\n.carousel-dark .carousel-control-prev-icon,\n.carousel-dark .carousel-control-next-icon {\n  filter: invert(1) grayscale(100);\n}\n.carousel-dark .carousel-indicators [data-bs-target] {\n  background-color: #000000;\n}\n.carousel-dark .carousel-caption {\n  color: #000000;\n}\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--bs-spinner-width);\n  height: var(--bs-spinner-height);\n  vertical-align: var(--bs-spinner-vertical-align);\n  border-radius: 50%;\n  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);\n}\n\n@keyframes spinner-border {\n  to {\n    transform: rotate(360deg) /* rtl:ignore */;\n  }\n}\n.spinner-border {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-border-width: 0.185rem;\n  --bs-spinner-animation-speed: 0.65s;\n  --bs-spinner-animation-name: spinner-border;\n  border: var(--bs-spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n  --bs-spinner-border-width: 0.145em;\n}\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n.spinner-grow {\n  --bs-spinner-width: 2rem;\n  --bs-spinner-height: 2rem;\n  --bs-spinner-vertical-align: -0.125em;\n  --bs-spinner-animation-speed: 0.65s;\n  --bs-spinner-animation-name: spinner-grow;\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --bs-spinner-width: 1rem;\n  --bs-spinner-height: 1rem;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .spinner-border,\n.spinner-grow {\n    --bs-spinner-animation-speed: 1.3s;\n  }\n}\n.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {\n  --bs-offcanvas-zindex: 1045;\n  --bs-offcanvas-width: 400px;\n  --bs-offcanvas-height: 30vh;\n  --bs-offcanvas-padding-x: 1.75rem;\n  --bs-offcanvas-padding-y: 1.75rem;\n  --bs-offcanvas-color: ;\n  --bs-offcanvas-bg: #ffffff;\n  --bs-offcanvas-border-width: 0;\n  --bs-offcanvas-border-color: var(--bs-border-color-translucent);\n  --bs-offcanvas-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);\n}\n\n@media (max-width: 575.98px) {\n  .offcanvas-sm {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: transform 0.3s ease-in-out;\n  }\n}\n@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-sm {\n    transition: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 575.98px) {\n  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 576px) {\n  .offcanvas-sm {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-sm .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-sm .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .offcanvas-md {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: transform 0.3s ease-in-out;\n  }\n}\n@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-md {\n    transition: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 767.98px) {\n  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 768px) {\n  .offcanvas-md {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-md .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-md .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .offcanvas-lg {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: transform 0.3s ease-in-out;\n  }\n}\n@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-lg {\n    transition: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 992px) {\n  .offcanvas-lg {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-lg .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-lg .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .offcanvas-xl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: transform 0.3s ease-in-out;\n  }\n}\n@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xl {\n    transition: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 1199.98px) {\n  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1200px) {\n  .offcanvas-xl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl {\n    position: fixed;\n    bottom: 0;\n    z-index: var(--bs-offcanvas-zindex);\n    display: flex;\n    flex-direction: column;\n    max-width: 100%;\n    color: var(--bs-offcanvas-color);\n    visibility: hidden;\n    background-color: var(--bs-offcanvas-bg);\n    background-clip: padding-box;\n    outline: 0;\n    box-shadow: var(--bs-offcanvas-box-shadow);\n    transition: transform 0.3s ease-in-out;\n  }\n}\n@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {\n  .offcanvas-xxl {\n    transition: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-start {\n    top: 0;\n    left: 0;\n    width: var(--bs-offcanvas-width);\n    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(-100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-end {\n    top: 0;\n    right: 0;\n    width: var(--bs-offcanvas-width);\n    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateX(100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-top {\n    top: 0;\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(-100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.offcanvas-bottom {\n    right: 0;\n    left: 0;\n    height: var(--bs-offcanvas-height);\n    max-height: 100%;\n    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n    transform: translateY(100%);\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {\n    transform: none;\n  }\n}\n@media (max-width: 1399.98px) {\n  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {\n    visibility: visible;\n  }\n}\n@media (min-width: 1400px) {\n  .offcanvas-xxl {\n    --bs-offcanvas-height: auto;\n    --bs-offcanvas-border-width: 0;\n    background-color: transparent !important;\n  }\n  .offcanvas-xxl .offcanvas-header {\n    display: none;\n  }\n  .offcanvas-xxl .offcanvas-body {\n    display: flex;\n    flex-grow: 0;\n    padding: 0;\n    overflow-y: visible;\n    background-color: transparent !important;\n  }\n}\n\n.offcanvas {\n  position: fixed;\n  bottom: 0;\n  z-index: var(--bs-offcanvas-zindex);\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  color: var(--bs-offcanvas-color);\n  visibility: hidden;\n  background-color: var(--bs-offcanvas-bg);\n  background-clip: padding-box;\n  outline: 0;\n  box-shadow: var(--bs-offcanvas-box-shadow);\n  transition: transform 0.3s ease-in-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .offcanvas {\n    transition: none;\n  }\n}\n.offcanvas.offcanvas-start {\n  top: 0;\n  left: 0;\n  width: var(--bs-offcanvas-width);\n  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(-100%);\n}\n.offcanvas.offcanvas-end {\n  top: 0;\n  right: 0;\n  width: var(--bs-offcanvas-width);\n  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateX(100%);\n}\n.offcanvas.offcanvas-top {\n  top: 0;\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(-100%);\n}\n.offcanvas.offcanvas-bottom {\n  right: 0;\n  left: 0;\n  height: var(--bs-offcanvas-height);\n  max-height: 100%;\n  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);\n  transform: translateY(100%);\n}\n.offcanvas.showing, .offcanvas.show:not(.hiding) {\n  transform: none;\n}\n.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {\n  visibility: visible;\n}\n\n.offcanvas-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1040;\n  width: 100vw;\n  height: 100vh;\n  background-color: #000000;\n}\n.offcanvas-backdrop.fade {\n  opacity: 0;\n}\n.offcanvas-backdrop.show {\n  opacity: 0.3;\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n}\n.offcanvas-header .btn-close {\n  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);\n  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));\n  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));\n  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: 1.5;\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);\n  overflow-y: auto;\n}\n\n.placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: 0.5;\n}\n.placeholder.btn::before {\n  display: inline-block;\n  content: \"\";\n}\n\n.placeholder-xs {\n  min-height: 0.6em;\n}\n\n.placeholder-sm {\n  min-height: 0.8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n.placeholder-glow .placeholder {\n  animation: placeholder-glow 2s ease-in-out infinite;\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: 0.2;\n  }\n}\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, #000000 55%, rgba(0, 0, 0, 0.8) 75%, #000000 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.text-bg-white {\n  color: #000000 !important;\n  background-color: RGBA(255, 255, 255, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-light {\n  color: #000000 !important;\n  background-color: RGBA(245, 248, 250, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-primary {\n  color: #000000 !important;\n  background-color: RGBA(0, 158, 247, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-secondary {\n  color: #000000 !important;\n  background-color: RGBA(228, 230, 239, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-success {\n  color: #000000 !important;\n  background-color: RGBA(80, 205, 137, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-info {\n  color: #ffffff !important;\n  background-color: RGBA(114, 57, 234, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-warning {\n  color: #000000 !important;\n  background-color: RGBA(255, 199, 0, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-danger {\n  color: #000000 !important;\n  background-color: RGBA(241, 65, 108, var(--bs-bg-opacity, 1)) !important;\n}\n\n.text-bg-dark {\n  color: #ffffff !important;\n  background-color: RGBA(24, 28, 50, var(--bs-bg-opacity, 1)) !important;\n}\n\n.link-white {\n  color: #ffffff !important;\n}\n.link-white:hover, .link-white:focus {\n  color: white !important;\n}\n\n.link-light {\n  color: #f5f8fa !important;\n}\n.link-light:hover, .link-light:focus {\n  color: #f7f9fb !important;\n}\n\n.link-primary {\n  color: #009ef7 !important;\n}\n.link-primary:hover, .link-primary:focus {\n  color: #33b1f9 !important;\n}\n\n.link-secondary {\n  color: #E4E6EF !important;\n}\n.link-secondary:hover, .link-secondary:focus {\n  color: #e9ebf2 !important;\n}\n\n.link-success {\n  color: #50cd89 !important;\n}\n.link-success:hover, .link-success:focus {\n  color: #73d7a1 !important;\n}\n\n.link-info {\n  color: #7239ea !important;\n}\n.link-info:hover, .link-info:focus {\n  color: #5b2ebb !important;\n}\n\n.link-warning {\n  color: #ffc700 !important;\n}\n.link-warning:hover, .link-warning:focus {\n  color: #ffd233 !important;\n}\n\n.link-danger {\n  color: #f1416c !important;\n}\n.link-danger:hover, .link-danger:focus {\n  color: #f46789 !important;\n}\n\n.link-dark {\n  color: #181C32 !important;\n}\n.link-dark:hover, .link-dark:focus {\n  color: #131628 !important;\n}\n\n.ratio {\n  position: relative;\n  width: 100%;\n}\n.ratio::before {\n  display: block;\n  padding-top: var(--bs-aspect-ratio);\n  content: \"\";\n}\n.ratio > * {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ratio-1x1 {\n  --bs-aspect-ratio: 100%;\n}\n\n.ratio-4x3 {\n  --bs-aspect-ratio: 75%;\n}\n\n.ratio-16x9 {\n  --bs-aspect-ratio: 56.25%;\n}\n\n.ratio-21x9 {\n  --bs-aspect-ratio: 42.8571428571%;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.sticky-top {\n  position: sticky;\n  top: 0;\n  z-index: 1020;\n}\n\n.sticky-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 1020;\n}\n\n@media (min-width: 576px) {\n  .sticky-sm-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-sm-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 768px) {\n  .sticky-md-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-md-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 992px) {\n  .sticky-lg-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-lg-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1200px) {\n  .sticky-xl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-xl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n@media (min-width: 1400px) {\n  .sticky-xxl-top {\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n\n  .sticky-xxl-bottom {\n    position: sticky;\n    bottom: 0;\n    z-index: 1020;\n  }\n}\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  content: \"\";\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: 0.25;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.float-start {\n  float: left !important;\n}\n\n.float-end {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-5 {\n  opacity: 0.05 !important;\n}\n\n.opacity-10 {\n  opacity: 0.1 !important;\n}\n\n.opacity-15 {\n  opacity: 0.15 !important;\n}\n\n.opacity-20 {\n  opacity: 0.2 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.overflow-visible {\n  overflow: visible !important;\n}\n\n.overflow-scroll {\n  overflow: scroll !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-grid {\n  display: grid !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: inline-flex !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.shadow {\n  box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075) !important;\n}\n\n.shadow-sm {\n  box-shadow: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: sticky !important;\n}\n\n.top-0 {\n  top: 0 !important;\n}\n\n.top-25 {\n  top: 25% !important;\n}\n\n.top-50 {\n  top: 50% !important;\n}\n\n.top-75 {\n  top: 75% !important;\n}\n\n.top-100 {\n  top: 100% !important;\n}\n\n.bottom-0 {\n  bottom: 0 !important;\n}\n\n.bottom-25 {\n  bottom: 25% !important;\n}\n\n.bottom-50 {\n  bottom: 50% !important;\n}\n\n.bottom-75 {\n  bottom: 75% !important;\n}\n\n.bottom-100 {\n  bottom: 100% !important;\n}\n\n.start-0 {\n  left: 0 !important;\n}\n\n.start-25 {\n  left: 25% !important;\n}\n\n.start-50 {\n  left: 50% !important;\n}\n\n.start-75 {\n  left: 75% !important;\n}\n\n.start-100 {\n  left: 100% !important;\n}\n\n.end-0 {\n  right: 0 !important;\n}\n\n.end-25 {\n  right: 25% !important;\n}\n\n.end-50 {\n  right: 50% !important;\n}\n\n.end-75 {\n  right: 75% !important;\n}\n\n.end-100 {\n  right: 100% !important;\n}\n\n.translate-middle {\n  transform: translate(-50%, -50%) !important;\n}\n\n.translate-middle-x {\n  transform: translateX(-50%) !important;\n}\n\n.translate-middle-y {\n  transform: translateY(-50%) !important;\n}\n\n.border {\n  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top {\n  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-end {\n  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-end-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom {\n  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-start {\n  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;\n}\n\n.border-start-0 {\n  border-left: 0 !important;\n}\n\n.border-white {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-light {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-primary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-secondary {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-success {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-info {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-warning {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-danger {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-dark {\n  --bs-border-opacity: 1;\n  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;\n}\n\n.border-0 {\n  --bs-border-width: 0;\n}\n\n.border-1 {\n  --bs-border-width: 1px;\n}\n\n.border-2 {\n  --bs-border-width: 2px;\n}\n\n.border-3 {\n  --bs-border-width: 3px;\n}\n\n.border-4 {\n  --bs-border-width: 4px;\n}\n\n.border-5 {\n  --bs-border-width: 5px;\n}\n\n.border-opacity-10 {\n  --bs-border-opacity: 0.1;\n}\n\n.border-opacity-25 {\n  --bs-border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --bs-border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --bs-border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --bs-border-opacity: 1;\n}\n\n.w-unset {\n  width: unset !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.w-1px {\n  width: 1px !important;\n}\n\n.w-2px {\n  width: 2px !important;\n}\n\n.w-3px {\n  width: 3px !important;\n}\n\n.w-4px {\n  width: 4px !important;\n}\n\n.w-5px {\n  width: 5px !important;\n}\n\n.w-6px {\n  width: 6px !important;\n}\n\n.w-7px {\n  width: 7px !important;\n}\n\n.w-8px {\n  width: 8px !important;\n}\n\n.w-9px {\n  width: 9px !important;\n}\n\n.w-10px {\n  width: 10px !important;\n}\n\n.w-15px {\n  width: 15px !important;\n}\n\n.w-20px {\n  width: 20px !important;\n}\n\n.w-25px {\n  width: 25px !important;\n}\n\n.w-30px {\n  width: 30px !important;\n}\n\n.w-35px {\n  width: 35px !important;\n}\n\n.w-40px {\n  width: 40px !important;\n}\n\n.w-45px {\n  width: 45px !important;\n}\n\n.w-50px {\n  width: 50px !important;\n}\n\n.w-55px {\n  width: 55px !important;\n}\n\n.w-60px {\n  width: 60px !important;\n}\n\n.w-65px {\n  width: 65px !important;\n}\n\n.w-70px {\n  width: 70px !important;\n}\n\n.w-75px {\n  width: 75px !important;\n}\n\n.w-80px {\n  width: 80px !important;\n}\n\n.w-85px {\n  width: 85px !important;\n}\n\n.w-90px {\n  width: 90px !important;\n}\n\n.w-95px {\n  width: 95px !important;\n}\n\n.w-100px {\n  width: 100px !important;\n}\n\n.w-125px {\n  width: 125px !important;\n}\n\n.w-150px {\n  width: 150px !important;\n}\n\n.w-175px {\n  width: 175px !important;\n}\n\n.w-200px {\n  width: 200px !important;\n}\n\n.w-225px {\n  width: 225px !important;\n}\n\n.w-250px {\n  width: 250px !important;\n}\n\n.w-275px {\n  width: 275px !important;\n}\n\n.w-300px {\n  width: 300px !important;\n}\n\n.w-325px {\n  width: 325px !important;\n}\n\n.w-350px {\n  width: 350px !important;\n}\n\n.w-375px {\n  width: 375px !important;\n}\n\n.w-400px {\n  width: 400px !important;\n}\n\n.w-425px {\n  width: 425px !important;\n}\n\n.w-450px {\n  width: 450px !important;\n}\n\n.w-475px {\n  width: 475px !important;\n}\n\n.w-500px {\n  width: 500px !important;\n}\n\n.w-550px {\n  width: 550px !important;\n}\n\n.w-600px {\n  width: 600px !important;\n}\n\n.w-650px {\n  width: 650px !important;\n}\n\n.w-700px {\n  width: 700px !important;\n}\n\n.w-750px {\n  width: 750px !important;\n}\n\n.w-800px {\n  width: 800px !important;\n}\n\n.w-850px {\n  width: 850px !important;\n}\n\n.w-900px {\n  width: 900px !important;\n}\n\n.w-950px {\n  width: 950px !important;\n}\n\n.w-1000px {\n  width: 1000px !important;\n}\n\n.mw-unset {\n  max-width: unset !important;\n}\n\n.mw-25 {\n  max-width: 25% !important;\n}\n\n.mw-50 {\n  max-width: 50% !important;\n}\n\n.mw-75 {\n  max-width: 75% !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.mw-auto {\n  max-width: auto !important;\n}\n\n.mw-1px {\n  max-width: 1px !important;\n}\n\n.mw-2px {\n  max-width: 2px !important;\n}\n\n.mw-3px {\n  max-width: 3px !important;\n}\n\n.mw-4px {\n  max-width: 4px !important;\n}\n\n.mw-5px {\n  max-width: 5px !important;\n}\n\n.mw-6px {\n  max-width: 6px !important;\n}\n\n.mw-7px {\n  max-width: 7px !important;\n}\n\n.mw-8px {\n  max-width: 8px !important;\n}\n\n.mw-9px {\n  max-width: 9px !important;\n}\n\n.mw-10px {\n  max-width: 10px !important;\n}\n\n.mw-15px {\n  max-width: 15px !important;\n}\n\n.mw-20px {\n  max-width: 20px !important;\n}\n\n.mw-25px {\n  max-width: 25px !important;\n}\n\n.mw-30px {\n  max-width: 30px !important;\n}\n\n.mw-35px {\n  max-width: 35px !important;\n}\n\n.mw-40px {\n  max-width: 40px !important;\n}\n\n.mw-45px {\n  max-width: 45px !important;\n}\n\n.mw-50px {\n  max-width: 50px !important;\n}\n\n.mw-55px {\n  max-width: 55px !important;\n}\n\n.mw-60px {\n  max-width: 60px !important;\n}\n\n.mw-65px {\n  max-width: 65px !important;\n}\n\n.mw-70px {\n  max-width: 70px !important;\n}\n\n.mw-75px {\n  max-width: 75px !important;\n}\n\n.mw-80px {\n  max-width: 80px !important;\n}\n\n.mw-85px {\n  max-width: 85px !important;\n}\n\n.mw-90px {\n  max-width: 90px !important;\n}\n\n.mw-95px {\n  max-width: 95px !important;\n}\n\n.mw-100px {\n  max-width: 100px !important;\n}\n\n.mw-125px {\n  max-width: 125px !important;\n}\n\n.mw-150px {\n  max-width: 150px !important;\n}\n\n.mw-175px {\n  max-width: 175px !important;\n}\n\n.mw-200px {\n  max-width: 200px !important;\n}\n\n.mw-225px {\n  max-width: 225px !important;\n}\n\n.mw-250px {\n  max-width: 250px !important;\n}\n\n.mw-275px {\n  max-width: 275px !important;\n}\n\n.mw-300px {\n  max-width: 300px !important;\n}\n\n.mw-325px {\n  max-width: 325px !important;\n}\n\n.mw-350px {\n  max-width: 350px !important;\n}\n\n.mw-375px {\n  max-width: 375px !important;\n}\n\n.mw-400px {\n  max-width: 400px !important;\n}\n\n.mw-425px {\n  max-width: 425px !important;\n}\n\n.mw-450px {\n  max-width: 450px !important;\n}\n\n.mw-475px {\n  max-width: 475px !important;\n}\n\n.mw-500px {\n  max-width: 500px !important;\n}\n\n.mw-550px {\n  max-width: 550px !important;\n}\n\n.mw-600px {\n  max-width: 600px !important;\n}\n\n.mw-650px {\n  max-width: 650px !important;\n}\n\n.mw-700px {\n  max-width: 700px !important;\n}\n\n.mw-750px {\n  max-width: 750px !important;\n}\n\n.mw-800px {\n  max-width: 800px !important;\n}\n\n.mw-850px {\n  max-width: 850px !important;\n}\n\n.mw-900px {\n  max-width: 900px !important;\n}\n\n.mw-950px {\n  max-width: 950px !important;\n}\n\n.mw-1000px {\n  max-width: 1000px !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.h-unset {\n  height: unset !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.h-1px {\n  height: 1px !important;\n}\n\n.h-2px {\n  height: 2px !important;\n}\n\n.h-3px {\n  height: 3px !important;\n}\n\n.h-4px {\n  height: 4px !important;\n}\n\n.h-5px {\n  height: 5px !important;\n}\n\n.h-6px {\n  height: 6px !important;\n}\n\n.h-7px {\n  height: 7px !important;\n}\n\n.h-8px {\n  height: 8px !important;\n}\n\n.h-9px {\n  height: 9px !important;\n}\n\n.h-10px {\n  height: 10px !important;\n}\n\n.h-15px {\n  height: 15px !important;\n}\n\n.h-20px {\n  height: 20px !important;\n}\n\n.h-25px {\n  height: 25px !important;\n}\n\n.h-30px {\n  height: 30px !important;\n}\n\n.h-35px {\n  height: 35px !important;\n}\n\n.h-40px {\n  height: 40px !important;\n}\n\n.h-45px {\n  height: 45px !important;\n}\n\n.h-50px {\n  height: 50px !important;\n}\n\n.h-55px {\n  height: 55px !important;\n}\n\n.h-60px {\n  height: 60px !important;\n}\n\n.h-65px {\n  height: 65px !important;\n}\n\n.h-70px {\n  height: 70px !important;\n}\n\n.h-75px {\n  height: 75px !important;\n}\n\n.h-80px {\n  height: 80px !important;\n}\n\n.h-85px {\n  height: 85px !important;\n}\n\n.h-90px {\n  height: 90px !important;\n}\n\n.h-95px {\n  height: 95px !important;\n}\n\n.h-100px {\n  height: 100px !important;\n}\n\n.h-125px {\n  height: 125px !important;\n}\n\n.h-150px {\n  height: 150px !important;\n}\n\n.h-175px {\n  height: 175px !important;\n}\n\n.h-200px {\n  height: 200px !important;\n}\n\n.h-225px {\n  height: 225px !important;\n}\n\n.h-250px {\n  height: 250px !important;\n}\n\n.h-275px {\n  height: 275px !important;\n}\n\n.h-300px {\n  height: 300px !important;\n}\n\n.h-325px {\n  height: 325px !important;\n}\n\n.h-350px {\n  height: 350px !important;\n}\n\n.h-375px {\n  height: 375px !important;\n}\n\n.h-400px {\n  height: 400px !important;\n}\n\n.h-425px {\n  height: 425px !important;\n}\n\n.h-450px {\n  height: 450px !important;\n}\n\n.h-475px {\n  height: 475px !important;\n}\n\n.h-500px {\n  height: 500px !important;\n}\n\n.h-550px {\n  height: 550px !important;\n}\n\n.h-600px {\n  height: 600px !important;\n}\n\n.h-650px {\n  height: 650px !important;\n}\n\n.h-700px {\n  height: 700px !important;\n}\n\n.h-750px {\n  height: 750px !important;\n}\n\n.h-800px {\n  height: 800px !important;\n}\n\n.h-850px {\n  height: 850px !important;\n}\n\n.h-900px {\n  height: 900px !important;\n}\n\n.h-950px {\n  height: 950px !important;\n}\n\n.h-1000px {\n  height: 1000px !important;\n}\n\n.mh-unset {\n  max-height: unset !important;\n}\n\n.mh-25 {\n  max-height: 25% !important;\n}\n\n.mh-50 {\n  max-height: 50% !important;\n}\n\n.mh-75 {\n  max-height: 75% !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.mh-auto {\n  max-height: auto !important;\n}\n\n.mh-1px {\n  max-height: 1px !important;\n}\n\n.mh-2px {\n  max-height: 2px !important;\n}\n\n.mh-3px {\n  max-height: 3px !important;\n}\n\n.mh-4px {\n  max-height: 4px !important;\n}\n\n.mh-5px {\n  max-height: 5px !important;\n}\n\n.mh-6px {\n  max-height: 6px !important;\n}\n\n.mh-7px {\n  max-height: 7px !important;\n}\n\n.mh-8px {\n  max-height: 8px !important;\n}\n\n.mh-9px {\n  max-height: 9px !important;\n}\n\n.mh-10px {\n  max-height: 10px !important;\n}\n\n.mh-15px {\n  max-height: 15px !important;\n}\n\n.mh-20px {\n  max-height: 20px !important;\n}\n\n.mh-25px {\n  max-height: 25px !important;\n}\n\n.mh-30px {\n  max-height: 30px !important;\n}\n\n.mh-35px {\n  max-height: 35px !important;\n}\n\n.mh-40px {\n  max-height: 40px !important;\n}\n\n.mh-45px {\n  max-height: 45px !important;\n}\n\n.mh-50px {\n  max-height: 50px !important;\n}\n\n.mh-55px {\n  max-height: 55px !important;\n}\n\n.mh-60px {\n  max-height: 60px !important;\n}\n\n.mh-65px {\n  max-height: 65px !important;\n}\n\n.mh-70px {\n  max-height: 70px !important;\n}\n\n.mh-75px {\n  max-height: 75px !important;\n}\n\n.mh-80px {\n  max-height: 80px !important;\n}\n\n.mh-85px {\n  max-height: 85px !important;\n}\n\n.mh-90px {\n  max-height: 90px !important;\n}\n\n.mh-95px {\n  max-height: 95px !important;\n}\n\n.mh-100px {\n  max-height: 100px !important;\n}\n\n.mh-125px {\n  max-height: 125px !important;\n}\n\n.mh-150px {\n  max-height: 150px !important;\n}\n\n.mh-175px {\n  max-height: 175px !important;\n}\n\n.mh-200px {\n  max-height: 200px !important;\n}\n\n.mh-225px {\n  max-height: 225px !important;\n}\n\n.mh-250px {\n  max-height: 250px !important;\n}\n\n.mh-275px {\n  max-height: 275px !important;\n}\n\n.mh-300px {\n  max-height: 300px !important;\n}\n\n.mh-325px {\n  max-height: 325px !important;\n}\n\n.mh-350px {\n  max-height: 350px !important;\n}\n\n.mh-375px {\n  max-height: 375px !important;\n}\n\n.mh-400px {\n  max-height: 400px !important;\n}\n\n.mh-425px {\n  max-height: 425px !important;\n}\n\n.mh-450px {\n  max-height: 450px !important;\n}\n\n.mh-475px {\n  max-height: 475px !important;\n}\n\n.mh-500px {\n  max-height: 500px !important;\n}\n\n.mh-550px {\n  max-height: 550px !important;\n}\n\n.mh-600px {\n  max-height: 600px !important;\n}\n\n.mh-650px {\n  max-height: 650px !important;\n}\n\n.mh-700px {\n  max-height: 700px !important;\n}\n\n.mh-750px {\n  max-height: 750px !important;\n}\n\n.mh-800px {\n  max-height: 800px !important;\n}\n\n.mh-850px {\n  max-height: 850px !important;\n}\n\n.mh-900px {\n  max-height: 900px !important;\n}\n\n.mh-950px {\n  max-height: 950px !important;\n}\n\n.mh-1000px {\n  max-height: 1000px !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.flex-fill {\n  flex: 1 1 auto !important;\n}\n\n.flex-row {\n  flex-direction: row !important;\n}\n\n.flex-column {\n  flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  flex-direction: column-reverse !important;\n}\n\n.flex-grow-0 {\n  flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  flex-shrink: 1 !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse !important;\n}\n\n.justify-content-start {\n  justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  justify-content: center !important;\n}\n\n.justify-content-between {\n  justify-content: space-between !important;\n}\n\n.justify-content-around {\n  justify-content: space-around !important;\n}\n\n.justify-content-evenly {\n  justify-content: space-evenly !important;\n}\n\n.align-items-start {\n  align-items: flex-start !important;\n}\n\n.align-items-end {\n  align-items: flex-end !important;\n}\n\n.align-items-center {\n  align-items: center !important;\n}\n\n.align-items-baseline {\n  align-items: baseline !important;\n}\n\n.align-items-stretch {\n  align-items: stretch !important;\n}\n\n.align-content-start {\n  align-content: flex-start !important;\n}\n\n.align-content-end {\n  align-content: flex-end !important;\n}\n\n.align-content-center {\n  align-content: center !important;\n}\n\n.align-content-between {\n  align-content: space-between !important;\n}\n\n.align-content-around {\n  align-content: space-around !important;\n}\n\n.align-content-stretch {\n  align-content: stretch !important;\n}\n\n.align-self-auto {\n  align-self: auto !important;\n}\n\n.align-self-start {\n  align-self: flex-start !important;\n}\n\n.align-self-end {\n  align-self: flex-end !important;\n}\n\n.align-self-center {\n  align-self: center !important;\n}\n\n.align-self-baseline {\n  align-self: baseline !important;\n}\n\n.align-self-stretch {\n  align-self: stretch !important;\n}\n\n.order-first {\n  order: -1 !important;\n}\n\n.order-0 {\n  order: 0 !important;\n}\n\n.order-1 {\n  order: 1 !important;\n}\n\n.order-2 {\n  order: 2 !important;\n}\n\n.order-3 {\n  order: 3 !important;\n}\n\n.order-4 {\n  order: 4 !important;\n}\n\n.order-5 {\n  order: 5 !important;\n}\n\n.order-last {\n  order: 6 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 0.75rem !important;\n}\n\n.m-4 {\n  margin: 1rem !important;\n}\n\n.m-5 {\n  margin: 1.25rem !important;\n}\n\n.m-6 {\n  margin: 1.5rem !important;\n}\n\n.m-7 {\n  margin: 1.75rem !important;\n}\n\n.m-8 {\n  margin: 2rem !important;\n}\n\n.m-9 {\n  margin: 2.25rem !important;\n}\n\n.m-10 {\n  margin: 2.5rem !important;\n}\n\n.m-11 {\n  margin: 2.75rem !important;\n}\n\n.m-12 {\n  margin: 3rem !important;\n}\n\n.m-13 {\n  margin: 3.25rem !important;\n}\n\n.m-14 {\n  margin: 3.5rem !important;\n}\n\n.m-15 {\n  margin: 3.75rem !important;\n}\n\n.m-16 {\n  margin: 4rem !important;\n}\n\n.m-17 {\n  margin: 4.25rem !important;\n}\n\n.m-18 {\n  margin: 4.5rem !important;\n}\n\n.m-19 {\n  margin: 4.75rem !important;\n}\n\n.m-20 {\n  margin: 5rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mx-0 {\n  margin-right: 0 !important;\n  margin-left: 0 !important;\n}\n\n.mx-1 {\n  margin-right: 0.25rem !important;\n  margin-left: 0.25rem !important;\n}\n\n.mx-2 {\n  margin-right: 0.5rem !important;\n  margin-left: 0.5rem !important;\n}\n\n.mx-3 {\n  margin-right: 0.75rem !important;\n  margin-left: 0.75rem !important;\n}\n\n.mx-4 {\n  margin-right: 1rem !important;\n  margin-left: 1rem !important;\n}\n\n.mx-5 {\n  margin-right: 1.25rem !important;\n  margin-left: 1.25rem !important;\n}\n\n.mx-6 {\n  margin-right: 1.5rem !important;\n  margin-left: 1.5rem !important;\n}\n\n.mx-7 {\n  margin-right: 1.75rem !important;\n  margin-left: 1.75rem !important;\n}\n\n.mx-8 {\n  margin-right: 2rem !important;\n  margin-left: 2rem !important;\n}\n\n.mx-9 {\n  margin-right: 2.25rem !important;\n  margin-left: 2.25rem !important;\n}\n\n.mx-10 {\n  margin-right: 2.5rem !important;\n  margin-left: 2.5rem !important;\n}\n\n.mx-11 {\n  margin-right: 2.75rem !important;\n  margin-left: 2.75rem !important;\n}\n\n.mx-12 {\n  margin-right: 3rem !important;\n  margin-left: 3rem !important;\n}\n\n.mx-13 {\n  margin-right: 3.25rem !important;\n  margin-left: 3.25rem !important;\n}\n\n.mx-14 {\n  margin-right: 3.5rem !important;\n  margin-left: 3.5rem !important;\n}\n\n.mx-15 {\n  margin-right: 3.75rem !important;\n  margin-left: 3.75rem !important;\n}\n\n.mx-16 {\n  margin-right: 4rem !important;\n  margin-left: 4rem !important;\n}\n\n.mx-17 {\n  margin-right: 4.25rem !important;\n  margin-left: 4.25rem !important;\n}\n\n.mx-18 {\n  margin-right: 4.5rem !important;\n  margin-left: 4.5rem !important;\n}\n\n.mx-19 {\n  margin-right: 4.75rem !important;\n  margin-left: 4.75rem !important;\n}\n\n.mx-20 {\n  margin-right: 5rem !important;\n  margin-left: 5rem !important;\n}\n\n.mx-auto {\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\n\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n\n.my-1 {\n  margin-top: 0.25rem !important;\n  margin-bottom: 0.25rem !important;\n}\n\n.my-2 {\n  margin-top: 0.5rem !important;\n  margin-bottom: 0.5rem !important;\n}\n\n.my-3 {\n  margin-top: 0.75rem !important;\n  margin-bottom: 0.75rem !important;\n}\n\n.my-4 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n\n.my-5 {\n  margin-top: 1.25rem !important;\n  margin-bottom: 1.25rem !important;\n}\n\n.my-6 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n\n.my-7 {\n  margin-top: 1.75rem !important;\n  margin-bottom: 1.75rem !important;\n}\n\n.my-8 {\n  margin-top: 2rem !important;\n  margin-bottom: 2rem !important;\n}\n\n.my-9 {\n  margin-top: 2.25rem !important;\n  margin-bottom: 2.25rem !important;\n}\n\n.my-10 {\n  margin-top: 2.5rem !important;\n  margin-bottom: 2.5rem !important;\n}\n\n.my-11 {\n  margin-top: 2.75rem !important;\n  margin-bottom: 2.75rem !important;\n}\n\n.my-12 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n\n.my-13 {\n  margin-top: 3.25rem !important;\n  margin-bottom: 3.25rem !important;\n}\n\n.my-14 {\n  margin-top: 3.5rem !important;\n  margin-bottom: 3.5rem !important;\n}\n\n.my-15 {\n  margin-top: 3.75rem !important;\n  margin-bottom: 3.75rem !important;\n}\n\n.my-16 {\n  margin-top: 4rem !important;\n  margin-bottom: 4rem !important;\n}\n\n.my-17 {\n  margin-top: 4.25rem !important;\n  margin-bottom: 4.25rem !important;\n}\n\n.my-18 {\n  margin-top: 4.5rem !important;\n  margin-bottom: 4.5rem !important;\n}\n\n.my-19 {\n  margin-top: 4.75rem !important;\n  margin-bottom: 4.75rem !important;\n}\n\n.my-20 {\n  margin-top: 5rem !important;\n  margin-bottom: 5rem !important;\n}\n\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mt-3 {\n  margin-top: 0.75rem !important;\n}\n\n.mt-4 {\n  margin-top: 1rem !important;\n}\n\n.mt-5 {\n  margin-top: 1.25rem !important;\n}\n\n.mt-6 {\n  margin-top: 1.5rem !important;\n}\n\n.mt-7 {\n  margin-top: 1.75rem !important;\n}\n\n.mt-8 {\n  margin-top: 2rem !important;\n}\n\n.mt-9 {\n  margin-top: 2.25rem !important;\n}\n\n.mt-10 {\n  margin-top: 2.5rem !important;\n}\n\n.mt-11 {\n  margin-top: 2.75rem !important;\n}\n\n.mt-12 {\n  margin-top: 3rem !important;\n}\n\n.mt-13 {\n  margin-top: 3.25rem !important;\n}\n\n.mt-14 {\n  margin-top: 3.5rem !important;\n}\n\n.mt-15 {\n  margin-top: 3.75rem !important;\n}\n\n.mt-16 {\n  margin-top: 4rem !important;\n}\n\n.mt-17 {\n  margin-top: 4.25rem !important;\n}\n\n.mt-18 {\n  margin-top: 4.5rem !important;\n}\n\n.mt-19 {\n  margin-top: 4.75rem !important;\n}\n\n.mt-20 {\n  margin-top: 5rem !important;\n}\n\n.mt-auto {\n  margin-top: auto !important;\n}\n\n.me-0 {\n  margin-right: 0 !important;\n}\n\n.me-1 {\n  margin-right: 0.25rem !important;\n}\n\n.me-2 {\n  margin-right: 0.5rem !important;\n}\n\n.me-3 {\n  margin-right: 0.75rem !important;\n}\n\n.me-4 {\n  margin-right: 1rem !important;\n}\n\n.me-5 {\n  margin-right: 1.25rem !important;\n}\n\n.me-6 {\n  margin-right: 1.5rem !important;\n}\n\n.me-7 {\n  margin-right: 1.75rem !important;\n}\n\n.me-8 {\n  margin-right: 2rem !important;\n}\n\n.me-9 {\n  margin-right: 2.25rem !important;\n}\n\n.me-10 {\n  margin-right: 2.5rem !important;\n}\n\n.me-11 {\n  margin-right: 2.75rem !important;\n}\n\n.me-12 {\n  margin-right: 3rem !important;\n}\n\n.me-13 {\n  margin-right: 3.25rem !important;\n}\n\n.me-14 {\n  margin-right: 3.5rem !important;\n}\n\n.me-15 {\n  margin-right: 3.75rem !important;\n}\n\n.me-16 {\n  margin-right: 4rem !important;\n}\n\n.me-17 {\n  margin-right: 4.25rem !important;\n}\n\n.me-18 {\n  margin-right: 4.5rem !important;\n}\n\n.me-19 {\n  margin-right: 4.75rem !important;\n}\n\n.me-20 {\n  margin-right: 5rem !important;\n}\n\n.me-auto {\n  margin-right: auto !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 0.75rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-5 {\n  margin-bottom: 1.25rem !important;\n}\n\n.mb-6 {\n  margin-bottom: 1.5rem !important;\n}\n\n.mb-7 {\n  margin-bottom: 1.75rem !important;\n}\n\n.mb-8 {\n  margin-bottom: 2rem !important;\n}\n\n.mb-9 {\n  margin-bottom: 2.25rem !important;\n}\n\n.mb-10 {\n  margin-bottom: 2.5rem !important;\n}\n\n.mb-11 {\n  margin-bottom: 2.75rem !important;\n}\n\n.mb-12 {\n  margin-bottom: 3rem !important;\n}\n\n.mb-13 {\n  margin-bottom: 3.25rem !important;\n}\n\n.mb-14 {\n  margin-bottom: 3.5rem !important;\n}\n\n.mb-15 {\n  margin-bottom: 3.75rem !important;\n}\n\n.mb-16 {\n  margin-bottom: 4rem !important;\n}\n\n.mb-17 {\n  margin-bottom: 4.25rem !important;\n}\n\n.mb-18 {\n  margin-bottom: 4.5rem !important;\n}\n\n.mb-19 {\n  margin-bottom: 4.75rem !important;\n}\n\n.mb-20 {\n  margin-bottom: 5rem !important;\n}\n\n.mb-auto {\n  margin-bottom: auto !important;\n}\n\n.ms-0 {\n  margin-left: 0 !important;\n}\n\n.ms-1 {\n  margin-left: 0.25rem !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n.ms-3 {\n  margin-left: 0.75rem !important;\n}\n\n.ms-4 {\n  margin-left: 1rem !important;\n}\n\n.ms-5 {\n  margin-left: 1.25rem !important;\n}\n\n.ms-6 {\n  margin-left: 1.5rem !important;\n}\n\n.ms-7 {\n  margin-left: 1.75rem !important;\n}\n\n.ms-8 {\n  margin-left: 2rem !important;\n}\n\n.ms-9 {\n  margin-left: 2.25rem !important;\n}\n\n.ms-10 {\n  margin-left: 2.5rem !important;\n}\n\n.ms-11 {\n  margin-left: 2.75rem !important;\n}\n\n.ms-12 {\n  margin-left: 3rem !important;\n}\n\n.ms-13 {\n  margin-left: 3.25rem !important;\n}\n\n.ms-14 {\n  margin-left: 3.5rem !important;\n}\n\n.ms-15 {\n  margin-left: 3.75rem !important;\n}\n\n.ms-16 {\n  margin-left: 4rem !important;\n}\n\n.ms-17 {\n  margin-left: 4.25rem !important;\n}\n\n.ms-18 {\n  margin-left: 4.5rem !important;\n}\n\n.ms-19 {\n  margin-left: 4.75rem !important;\n}\n\n.ms-20 {\n  margin-left: 5rem !important;\n}\n\n.ms-auto {\n  margin-left: auto !important;\n}\n\n.m-n1 {\n  margin: -0.25rem !important;\n}\n\n.m-n2 {\n  margin: -0.5rem !important;\n}\n\n.m-n3 {\n  margin: -0.75rem !important;\n}\n\n.m-n4 {\n  margin: -1rem !important;\n}\n\n.m-n5 {\n  margin: -1.25rem !important;\n}\n\n.m-n6 {\n  margin: -1.5rem !important;\n}\n\n.m-n7 {\n  margin: -1.75rem !important;\n}\n\n.m-n8 {\n  margin: -2rem !important;\n}\n\n.m-n9 {\n  margin: -2.25rem !important;\n}\n\n.m-n10 {\n  margin: -2.5rem !important;\n}\n\n.m-n11 {\n  margin: -2.75rem !important;\n}\n\n.m-n12 {\n  margin: -3rem !important;\n}\n\n.m-n13 {\n  margin: -3.25rem !important;\n}\n\n.m-n14 {\n  margin: -3.5rem !important;\n}\n\n.m-n15 {\n  margin: -3.75rem !important;\n}\n\n.m-n16 {\n  margin: -4rem !important;\n}\n\n.m-n17 {\n  margin: -4.25rem !important;\n}\n\n.m-n18 {\n  margin: -4.5rem !important;\n}\n\n.m-n19 {\n  margin: -4.75rem !important;\n}\n\n.m-n20 {\n  margin: -5rem !important;\n}\n\n.mx-n1 {\n  margin-right: -0.25rem !important;\n  margin-left: -0.25rem !important;\n}\n\n.mx-n2 {\n  margin-right: -0.5rem !important;\n  margin-left: -0.5rem !important;\n}\n\n.mx-n3 {\n  margin-right: -0.75rem !important;\n  margin-left: -0.75rem !important;\n}\n\n.mx-n4 {\n  margin-right: -1rem !important;\n  margin-left: -1rem !important;\n}\n\n.mx-n5 {\n  margin-right: -1.25rem !important;\n  margin-left: -1.25rem !important;\n}\n\n.mx-n6 {\n  margin-right: -1.5rem !important;\n  margin-left: -1.5rem !important;\n}\n\n.mx-n7 {\n  margin-right: -1.75rem !important;\n  margin-left: -1.75rem !important;\n}\n\n.mx-n8 {\n  margin-right: -2rem !important;\n  margin-left: -2rem !important;\n}\n\n.mx-n9 {\n  margin-right: -2.25rem !important;\n  margin-left: -2.25rem !important;\n}\n\n.mx-n10 {\n  margin-right: -2.5rem !important;\n  margin-left: -2.5rem !important;\n}\n\n.mx-n11 {\n  margin-right: -2.75rem !important;\n  margin-left: -2.75rem !important;\n}\n\n.mx-n12 {\n  margin-right: -3rem !important;\n  margin-left: -3rem !important;\n}\n\n.mx-n13 {\n  margin-right: -3.25rem !important;\n  margin-left: -3.25rem !important;\n}\n\n.mx-n14 {\n  margin-right: -3.5rem !important;\n  margin-left: -3.5rem !important;\n}\n\n.mx-n15 {\n  margin-right: -3.75rem !important;\n  margin-left: -3.75rem !important;\n}\n\n.mx-n16 {\n  margin-right: -4rem !important;\n  margin-left: -4rem !important;\n}\n\n.mx-n17 {\n  margin-right: -4.25rem !important;\n  margin-left: -4.25rem !important;\n}\n\n.mx-n18 {\n  margin-right: -4.5rem !important;\n  margin-left: -4.5rem !important;\n}\n\n.mx-n19 {\n  margin-right: -4.75rem !important;\n  margin-left: -4.75rem !important;\n}\n\n.mx-n20 {\n  margin-right: -5rem !important;\n  margin-left: -5rem !important;\n}\n\n.my-n1 {\n  margin-top: -0.25rem !important;\n  margin-bottom: -0.25rem !important;\n}\n\n.my-n2 {\n  margin-top: -0.5rem !important;\n  margin-bottom: -0.5rem !important;\n}\n\n.my-n3 {\n  margin-top: -0.75rem !important;\n  margin-bottom: -0.75rem !important;\n}\n\n.my-n4 {\n  margin-top: -1rem !important;\n  margin-bottom: -1rem !important;\n}\n\n.my-n5 {\n  margin-top: -1.25rem !important;\n  margin-bottom: -1.25rem !important;\n}\n\n.my-n6 {\n  margin-top: -1.5rem !important;\n  margin-bottom: -1.5rem !important;\n}\n\n.my-n7 {\n  margin-top: -1.75rem !important;\n  margin-bottom: -1.75rem !important;\n}\n\n.my-n8 {\n  margin-top: -2rem !important;\n  margin-bottom: -2rem !important;\n}\n\n.my-n9 {\n  margin-top: -2.25rem !important;\n  margin-bottom: -2.25rem !important;\n}\n\n.my-n10 {\n  margin-top: -2.5rem !important;\n  margin-bottom: -2.5rem !important;\n}\n\n.my-n11 {\n  margin-top: -2.75rem !important;\n  margin-bottom: -2.75rem !important;\n}\n\n.my-n12 {\n  margin-top: -3rem !important;\n  margin-bottom: -3rem !important;\n}\n\n.my-n13 {\n  margin-top: -3.25rem !important;\n  margin-bottom: -3.25rem !important;\n}\n\n.my-n14 {\n  margin-top: -3.5rem !important;\n  margin-bottom: -3.5rem !important;\n}\n\n.my-n15 {\n  margin-top: -3.75rem !important;\n  margin-bottom: -3.75rem !important;\n}\n\n.my-n16 {\n  margin-top: -4rem !important;\n  margin-bottom: -4rem !important;\n}\n\n.my-n17 {\n  margin-top: -4.25rem !important;\n  margin-bottom: -4.25rem !important;\n}\n\n.my-n18 {\n  margin-top: -4.5rem !important;\n  margin-bottom: -4.5rem !important;\n}\n\n.my-n19 {\n  margin-top: -4.75rem !important;\n  margin-bottom: -4.75rem !important;\n}\n\n.my-n20 {\n  margin-top: -5rem !important;\n  margin-bottom: -5rem !important;\n}\n\n.mt-n1 {\n  margin-top: -0.25rem !important;\n}\n\n.mt-n2 {\n  margin-top: -0.5rem !important;\n}\n\n.mt-n3 {\n  margin-top: -0.75rem !important;\n}\n\n.mt-n4 {\n  margin-top: -1rem !important;\n}\n\n.mt-n5 {\n  margin-top: -1.25rem !important;\n}\n\n.mt-n6 {\n  margin-top: -1.5rem !important;\n}\n\n.mt-n7 {\n  margin-top: -1.75rem !important;\n}\n\n.mt-n8 {\n  margin-top: -2rem !important;\n}\n\n.mt-n9 {\n  margin-top: -2.25rem !important;\n}\n\n.mt-n10 {\n  margin-top: -2.5rem !important;\n}\n\n.mt-n11 {\n  margin-top: -2.75rem !important;\n}\n\n.mt-n12 {\n  margin-top: -3rem !important;\n}\n\n.mt-n13 {\n  margin-top: -3.25rem !important;\n}\n\n.mt-n14 {\n  margin-top: -3.5rem !important;\n}\n\n.mt-n15 {\n  margin-top: -3.75rem !important;\n}\n\n.mt-n16 {\n  margin-top: -4rem !important;\n}\n\n.mt-n17 {\n  margin-top: -4.25rem !important;\n}\n\n.mt-n18 {\n  margin-top: -4.5rem !important;\n}\n\n.mt-n19 {\n  margin-top: -4.75rem !important;\n}\n\n.mt-n20 {\n  margin-top: -5rem !important;\n}\n\n.me-n1 {\n  margin-right: -0.25rem !important;\n}\n\n.me-n2 {\n  margin-right: -0.5rem !important;\n}\n\n.me-n3 {\n  margin-right: -0.75rem !important;\n}\n\n.me-n4 {\n  margin-right: -1rem !important;\n}\n\n.me-n5 {\n  margin-right: -1.25rem !important;\n}\n\n.me-n6 {\n  margin-right: -1.5rem !important;\n}\n\n.me-n7 {\n  margin-right: -1.75rem !important;\n}\n\n.me-n8 {\n  margin-right: -2rem !important;\n}\n\n.me-n9 {\n  margin-right: -2.25rem !important;\n}\n\n.me-n10 {\n  margin-right: -2.5rem !important;\n}\n\n.me-n11 {\n  margin-right: -2.75rem !important;\n}\n\n.me-n12 {\n  margin-right: -3rem !important;\n}\n\n.me-n13 {\n  margin-right: -3.25rem !important;\n}\n\n.me-n14 {\n  margin-right: -3.5rem !important;\n}\n\n.me-n15 {\n  margin-right: -3.75rem !important;\n}\n\n.me-n16 {\n  margin-right: -4rem !important;\n}\n\n.me-n17 {\n  margin-right: -4.25rem !important;\n}\n\n.me-n18 {\n  margin-right: -4.5rem !important;\n}\n\n.me-n19 {\n  margin-right: -4.75rem !important;\n}\n\n.me-n20 {\n  margin-right: -5rem !important;\n}\n\n.mb-n1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.mb-n2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.mb-n3 {\n  margin-bottom: -0.75rem !important;\n}\n\n.mb-n4 {\n  margin-bottom: -1rem !important;\n}\n\n.mb-n5 {\n  margin-bottom: -1.25rem !important;\n}\n\n.mb-n6 {\n  margin-bottom: -1.5rem !important;\n}\n\n.mb-n7 {\n  margin-bottom: -1.75rem !important;\n}\n\n.mb-n8 {\n  margin-bottom: -2rem !important;\n}\n\n.mb-n9 {\n  margin-bottom: -2.25rem !important;\n}\n\n.mb-n10 {\n  margin-bottom: -2.5rem !important;\n}\n\n.mb-n11 {\n  margin-bottom: -2.75rem !important;\n}\n\n.mb-n12 {\n  margin-bottom: -3rem !important;\n}\n\n.mb-n13 {\n  margin-bottom: -3.25rem !important;\n}\n\n.mb-n14 {\n  margin-bottom: -3.5rem !important;\n}\n\n.mb-n15 {\n  margin-bottom: -3.75rem !important;\n}\n\n.mb-n16 {\n  margin-bottom: -4rem !important;\n}\n\n.mb-n17 {\n  margin-bottom: -4.25rem !important;\n}\n\n.mb-n18 {\n  margin-bottom: -4.5rem !important;\n}\n\n.mb-n19 {\n  margin-bottom: -4.75rem !important;\n}\n\n.mb-n20 {\n  margin-bottom: -5rem !important;\n}\n\n.ms-n1 {\n  margin-left: -0.25rem !important;\n}\n\n.ms-n2 {\n  margin-left: -0.5rem !important;\n}\n\n.ms-n3 {\n  margin-left: -0.75rem !important;\n}\n\n.ms-n4 {\n  margin-left: -1rem !important;\n}\n\n.ms-n5 {\n  margin-left: -1.25rem !important;\n}\n\n.ms-n6 {\n  margin-left: -1.5rem !important;\n}\n\n.ms-n7 {\n  margin-left: -1.75rem !important;\n}\n\n.ms-n8 {\n  margin-left: -2rem !important;\n}\n\n.ms-n9 {\n  margin-left: -2.25rem !important;\n}\n\n.ms-n10 {\n  margin-left: -2.5rem !important;\n}\n\n.ms-n11 {\n  margin-left: -2.75rem !important;\n}\n\n.ms-n12 {\n  margin-left: -3rem !important;\n}\n\n.ms-n13 {\n  margin-left: -3.25rem !important;\n}\n\n.ms-n14 {\n  margin-left: -3.5rem !important;\n}\n\n.ms-n15 {\n  margin-left: -3.75rem !important;\n}\n\n.ms-n16 {\n  margin-left: -4rem !important;\n}\n\n.ms-n17 {\n  margin-left: -4.25rem !important;\n}\n\n.ms-n18 {\n  margin-left: -4.5rem !important;\n}\n\n.ms-n19 {\n  margin-left: -4.75rem !important;\n}\n\n.ms-n20 {\n  margin-left: -5rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 0.75rem !important;\n}\n\n.p-4 {\n  padding: 1rem !important;\n}\n\n.p-5 {\n  padding: 1.25rem !important;\n}\n\n.p-6 {\n  padding: 1.5rem !important;\n}\n\n.p-7 {\n  padding: 1.75rem !important;\n}\n\n.p-8 {\n  padding: 2rem !important;\n}\n\n.p-9 {\n  padding: 2.25rem !important;\n}\n\n.p-10 {\n  padding: 2.5rem !important;\n}\n\n.p-11 {\n  padding: 2.75rem !important;\n}\n\n.p-12 {\n  padding: 3rem !important;\n}\n\n.p-13 {\n  padding: 3.25rem !important;\n}\n\n.p-14 {\n  padding: 3.5rem !important;\n}\n\n.p-15 {\n  padding: 3.75rem !important;\n}\n\n.p-16 {\n  padding: 4rem !important;\n}\n\n.p-17 {\n  padding: 4.25rem !important;\n}\n\n.p-18 {\n  padding: 4.5rem !important;\n}\n\n.p-19 {\n  padding: 4.75rem !important;\n}\n\n.p-20 {\n  padding: 5rem !important;\n}\n\n.px-0 {\n  padding-right: 0 !important;\n  padding-left: 0 !important;\n}\n\n.px-1 {\n  padding-right: 0.25rem !important;\n  padding-left: 0.25rem !important;\n}\n\n.px-2 {\n  padding-right: 0.5rem !important;\n  padding-left: 0.5rem !important;\n}\n\n.px-3 {\n  padding-right: 0.75rem !important;\n  padding-left: 0.75rem !important;\n}\n\n.px-4 {\n  padding-right: 1rem !important;\n  padding-left: 1rem !important;\n}\n\n.px-5 {\n  padding-right: 1.25rem !important;\n  padding-left: 1.25rem !important;\n}\n\n.px-6 {\n  padding-right: 1.5rem !important;\n  padding-left: 1.5rem !important;\n}\n\n.px-7 {\n  padding-right: 1.75rem !important;\n  padding-left: 1.75rem !important;\n}\n\n.px-8 {\n  padding-right: 2rem !important;\n  padding-left: 2rem !important;\n}\n\n.px-9 {\n  padding-right: 2.25rem !important;\n  padding-left: 2.25rem !important;\n}\n\n.px-10 {\n  padding-right: 2.5rem !important;\n  padding-left: 2.5rem !important;\n}\n\n.px-11 {\n  padding-right: 2.75rem !important;\n  padding-left: 2.75rem !important;\n}\n\n.px-12 {\n  padding-right: 3rem !important;\n  padding-left: 3rem !important;\n}\n\n.px-13 {\n  padding-right: 3.25rem !important;\n  padding-left: 3.25rem !important;\n}\n\n.px-14 {\n  padding-right: 3.5rem !important;\n  padding-left: 3.5rem !important;\n}\n\n.px-15 {\n  padding-right: 3.75rem !important;\n  padding-left: 3.75rem !important;\n}\n\n.px-16 {\n  padding-right: 4rem !important;\n  padding-left: 4rem !important;\n}\n\n.px-17 {\n  padding-right: 4.25rem !important;\n  padding-left: 4.25rem !important;\n}\n\n.px-18 {\n  padding-right: 4.5rem !important;\n  padding-left: 4.5rem !important;\n}\n\n.px-19 {\n  padding-right: 4.75rem !important;\n  padding-left: 4.75rem !important;\n}\n\n.px-20 {\n  padding-right: 5rem !important;\n  padding-left: 5rem !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.py-1 {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.py-2 {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n.py-3 {\n  padding-top: 0.75rem !important;\n  padding-bottom: 0.75rem !important;\n}\n\n.py-4 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n\n.py-5 {\n  padding-top: 1.25rem !important;\n  padding-bottom: 1.25rem !important;\n}\n\n.py-6 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n\n.py-7 {\n  padding-top: 1.75rem !important;\n  padding-bottom: 1.75rem !important;\n}\n\n.py-8 {\n  padding-top: 2rem !important;\n  padding-bottom: 2rem !important;\n}\n\n.py-9 {\n  padding-top: 2.25rem !important;\n  padding-bottom: 2.25rem !important;\n}\n\n.py-10 {\n  padding-top: 2.5rem !important;\n  padding-bottom: 2.5rem !important;\n}\n\n.py-11 {\n  padding-top: 2.75rem !important;\n  padding-bottom: 2.75rem !important;\n}\n\n.py-12 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n\n.py-13 {\n  padding-top: 3.25rem !important;\n  padding-bottom: 3.25rem !important;\n}\n\n.py-14 {\n  padding-top: 3.5rem !important;\n  padding-bottom: 3.5rem !important;\n}\n\n.py-15 {\n  padding-top: 3.75rem !important;\n  padding-bottom: 3.75rem !important;\n}\n\n.py-16 {\n  padding-top: 4rem !important;\n  padding-bottom: 4rem !important;\n}\n\n.py-17 {\n  padding-top: 4.25rem !important;\n  padding-bottom: 4.25rem !important;\n}\n\n.py-18 {\n  padding-top: 4.5rem !important;\n  padding-bottom: 4.5rem !important;\n}\n\n.py-19 {\n  padding-top: 4.75rem !important;\n  padding-bottom: 4.75rem !important;\n}\n\n.py-20 {\n  padding-top: 5rem !important;\n  padding-bottom: 5rem !important;\n}\n\n.pt-0 {\n  padding-top: 0 !important;\n}\n\n.pt-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pt-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pt-3 {\n  padding-top: 0.75rem !important;\n}\n\n.pt-4 {\n  padding-top: 1rem !important;\n}\n\n.pt-5 {\n  padding-top: 1.25rem !important;\n}\n\n.pt-6 {\n  padding-top: 1.5rem !important;\n}\n\n.pt-7 {\n  padding-top: 1.75rem !important;\n}\n\n.pt-8 {\n  padding-top: 2rem !important;\n}\n\n.pt-9 {\n  padding-top: 2.25rem !important;\n}\n\n.pt-10 {\n  padding-top: 2.5rem !important;\n}\n\n.pt-11 {\n  padding-top: 2.75rem !important;\n}\n\n.pt-12 {\n  padding-top: 3rem !important;\n}\n\n.pt-13 {\n  padding-top: 3.25rem !important;\n}\n\n.pt-14 {\n  padding-top: 3.5rem !important;\n}\n\n.pt-15 {\n  padding-top: 3.75rem !important;\n}\n\n.pt-16 {\n  padding-top: 4rem !important;\n}\n\n.pt-17 {\n  padding-top: 4.25rem !important;\n}\n\n.pt-18 {\n  padding-top: 4.5rem !important;\n}\n\n.pt-19 {\n  padding-top: 4.75rem !important;\n}\n\n.pt-20 {\n  padding-top: 5rem !important;\n}\n\n.pe-0 {\n  padding-right: 0 !important;\n}\n\n.pe-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pe-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pe-3 {\n  padding-right: 0.75rem !important;\n}\n\n.pe-4 {\n  padding-right: 1rem !important;\n}\n\n.pe-5 {\n  padding-right: 1.25rem !important;\n}\n\n.pe-6 {\n  padding-right: 1.5rem !important;\n}\n\n.pe-7 {\n  padding-right: 1.75rem !important;\n}\n\n.pe-8 {\n  padding-right: 2rem !important;\n}\n\n.pe-9 {\n  padding-right: 2.25rem !important;\n}\n\n.pe-10 {\n  padding-right: 2.5rem !important;\n}\n\n.pe-11 {\n  padding-right: 2.75rem !important;\n}\n\n.pe-12 {\n  padding-right: 3rem !important;\n}\n\n.pe-13 {\n  padding-right: 3.25rem !important;\n}\n\n.pe-14 {\n  padding-right: 3.5rem !important;\n}\n\n.pe-15 {\n  padding-right: 3.75rem !important;\n}\n\n.pe-16 {\n  padding-right: 4rem !important;\n}\n\n.pe-17 {\n  padding-right: 4.25rem !important;\n}\n\n.pe-18 {\n  padding-right: 4.5rem !important;\n}\n\n.pe-19 {\n  padding-right: 4.75rem !important;\n}\n\n.pe-20 {\n  padding-right: 5rem !important;\n}\n\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pb-3 {\n  padding-bottom: 0.75rem !important;\n}\n\n.pb-4 {\n  padding-bottom: 1rem !important;\n}\n\n.pb-5 {\n  padding-bottom: 1.25rem !important;\n}\n\n.pb-6 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pb-7 {\n  padding-bottom: 1.75rem !important;\n}\n\n.pb-8 {\n  padding-bottom: 2rem !important;\n}\n\n.pb-9 {\n  padding-bottom: 2.25rem !important;\n}\n\n.pb-10 {\n  padding-bottom: 2.5rem !important;\n}\n\n.pb-11 {\n  padding-bottom: 2.75rem !important;\n}\n\n.pb-12 {\n  padding-bottom: 3rem !important;\n}\n\n.pb-13 {\n  padding-bottom: 3.25rem !important;\n}\n\n.pb-14 {\n  padding-bottom: 3.5rem !important;\n}\n\n.pb-15 {\n  padding-bottom: 3.75rem !important;\n}\n\n.pb-16 {\n  padding-bottom: 4rem !important;\n}\n\n.pb-17 {\n  padding-bottom: 4.25rem !important;\n}\n\n.pb-18 {\n  padding-bottom: 4.5rem !important;\n}\n\n.pb-19 {\n  padding-bottom: 4.75rem !important;\n}\n\n.pb-20 {\n  padding-bottom: 5rem !important;\n}\n\n.ps-0 {\n  padding-left: 0 !important;\n}\n\n.ps-1 {\n  padding-left: 0.25rem !important;\n}\n\n.ps-2 {\n  padding-left: 0.5rem !important;\n}\n\n.ps-3 {\n  padding-left: 0.75rem !important;\n}\n\n.ps-4 {\n  padding-left: 1rem !important;\n}\n\n.ps-5 {\n  padding-left: 1.25rem !important;\n}\n\n.ps-6 {\n  padding-left: 1.5rem !important;\n}\n\n.ps-7 {\n  padding-left: 1.75rem !important;\n}\n\n.ps-8 {\n  padding-left: 2rem !important;\n}\n\n.ps-9 {\n  padding-left: 2.25rem !important;\n}\n\n.ps-10 {\n  padding-left: 2.5rem !important;\n}\n\n.ps-11 {\n  padding-left: 2.75rem !important;\n}\n\n.ps-12 {\n  padding-left: 3rem !important;\n}\n\n.ps-13 {\n  padding-left: 3.25rem !important;\n}\n\n.ps-14 {\n  padding-left: 3.5rem !important;\n}\n\n.ps-15 {\n  padding-left: 3.75rem !important;\n}\n\n.ps-16 {\n  padding-left: 4rem !important;\n}\n\n.ps-17 {\n  padding-left: 4.25rem !important;\n}\n\n.ps-18 {\n  padding-left: 4.5rem !important;\n}\n\n.ps-19 {\n  padding-left: 4.75rem !important;\n}\n\n.ps-20 {\n  padding-left: 5rem !important;\n}\n\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-1 {\n  gap: 0.25rem !important;\n}\n\n.gap-2 {\n  gap: 0.5rem !important;\n}\n\n.gap-3 {\n  gap: 0.75rem !important;\n}\n\n.gap-4 {\n  gap: 1rem !important;\n}\n\n.gap-5 {\n  gap: 1.25rem !important;\n}\n\n.gap-6 {\n  gap: 1.5rem !important;\n}\n\n.gap-7 {\n  gap: 1.75rem !important;\n}\n\n.gap-8 {\n  gap: 2rem !important;\n}\n\n.gap-9 {\n  gap: 2.25rem !important;\n}\n\n.gap-10 {\n  gap: 2.5rem !important;\n}\n\n.gap-11 {\n  gap: 2.75rem !important;\n}\n\n.gap-12 {\n  gap: 3rem !important;\n}\n\n.gap-13 {\n  gap: 3.25rem !important;\n}\n\n.gap-14 {\n  gap: 3.5rem !important;\n}\n\n.gap-15 {\n  gap: 3.75rem !important;\n}\n\n.gap-16 {\n  gap: 4rem !important;\n}\n\n.gap-17 {\n  gap: 4.25rem !important;\n}\n\n.gap-18 {\n  gap: 4.5rem !important;\n}\n\n.gap-19 {\n  gap: 4.75rem !important;\n}\n\n.gap-20 {\n  gap: 5rem !important;\n}\n\n.font-monospace {\n  font-family: var(--bs-font-monospace) !important;\n}\n\n.fs-1 {\n  font-size: calc(1.3rem + 0.6vw) !important;\n}\n\n.fs-2 {\n  font-size: calc(1.275rem + 0.3vw) !important;\n}\n\n.fs-3 {\n  font-size: calc(1.26rem + 0.12vw) !important;\n}\n\n.fs-4 {\n  font-size: 1.25rem !important;\n}\n\n.fs-5 {\n  font-size: 1.15rem !important;\n}\n\n.fs-6 {\n  font-size: 1.075rem !important;\n}\n\n.fs-7 {\n  font-size: 0.95rem !important;\n}\n\n.fs-8 {\n  font-size: 0.85rem !important;\n}\n\n.fs-9 {\n  font-size: 0.75rem !important;\n}\n\n.fs-10 {\n  font-size: 0.5rem !important;\n}\n\n.fs-base {\n  font-size: 1rem !important;\n}\n\n.fs-fluid {\n  font-size: 100% !important;\n}\n\n.fs-2x {\n  font-size: calc(1.325rem + 0.9vw) !important;\n}\n\n.fs-2qx {\n  font-size: calc(1.35rem + 1.2vw) !important;\n}\n\n.fs-2hx {\n  font-size: calc(1.375rem + 1.5vw) !important;\n}\n\n.fs-2tx {\n  font-size: calc(1.4rem + 1.8vw) !important;\n}\n\n.fs-3x {\n  font-size: calc(1.425rem + 2.1vw) !important;\n}\n\n.fs-3qx {\n  font-size: calc(1.45rem + 2.4vw) !important;\n}\n\n.fs-3hx {\n  font-size: calc(1.475rem + 2.7vw) !important;\n}\n\n.fs-3tx {\n  font-size: calc(1.5rem + 3vw) !important;\n}\n\n.fs-4x {\n  font-size: calc(1.525rem + 3.3vw) !important;\n}\n\n.fs-4qx {\n  font-size: calc(1.55rem + 3.6vw) !important;\n}\n\n.fs-4hx {\n  font-size: calc(1.575rem + 3.9vw) !important;\n}\n\n.fs-4tx {\n  font-size: calc(1.6rem + 4.2vw) !important;\n}\n\n.fs-5x {\n  font-size: calc(1.625rem + 4.5vw) !important;\n}\n\n.fs-5qx {\n  font-size: calc(1.65rem + 4.8vw) !important;\n}\n\n.fs-5hx {\n  font-size: calc(1.675rem + 5.1vw) !important;\n}\n\n.fs-5tx {\n  font-size: calc(1.7rem + 5.4vw) !important;\n}\n\n.fst-italic {\n  font-style: italic !important;\n}\n\n.fst-normal {\n  font-style: normal !important;\n}\n\n.fw-light {\n  font-weight: 300 !important;\n}\n\n.fw-lighter {\n  font-weight: lighter !important;\n}\n\n.fw-normal {\n  font-weight: 400 !important;\n}\n\n.fw-bold {\n  font-weight: 600 !important;\n}\n\n.fw-semibold {\n  font-weight: 500 !important;\n}\n\n.fw-bolder {\n  font-weight: 700 !important;\n}\n\n.lh-0 {\n  line-height: 0 !important;\n}\n\n.lh-1 {\n  line-height: 1 !important;\n}\n\n.lh-sm {\n  line-height: 1.25 !important;\n}\n\n.lh-base {\n  line-height: 1.5 !important;\n}\n\n.lh-lg {\n  line-height: 1.75 !important;\n}\n\n.lh-xl {\n  line-height: 2 !important;\n}\n\n.lh-xxl {\n  line-height: 2.25 !important;\n}\n\n.text-start {\n  text-align: left !important;\n}\n\n.text-end {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-decoration-underline {\n  text-decoration: underline !important;\n}\n\n.text-decoration-line-through {\n  text-decoration: line-through !important;\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n/* rtl:begin:remove */\n.text-break {\n  word-wrap: break-word !important;\n  word-break: break-word !important;\n}\n\n/* rtl:end:remove */\n.text-white {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-light {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-primary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-secondary {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-success {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-info {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-warning {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-danger {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-dark {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-black {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-body {\n  --bs-text-opacity: 1;\n  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: #A1A5B7 !important;\n}\n\n.text-black-50 {\n  --bs-text-opacity: 1;\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  --bs-text-opacity: 1;\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-reset {\n  --bs-text-opacity: 1;\n  color: inherit !important;\n}\n\n.text-opacity-25 {\n  --bs-text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --bs-text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --bs-text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --bs-text-opacity: 1;\n}\n\n.bg-white {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-light {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-primary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-secondary {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-success {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-info {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-warning {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-danger {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-dark {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-black {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-body {\n  --bs-bg-opacity: 1;\n  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;\n}\n\n.bg-transparent {\n  --bs-bg-opacity: 1;\n  background-color: transparent !important;\n}\n\n.bg-opacity-10 {\n  --bs-bg-opacity: 0.1;\n}\n\n.bg-opacity-25 {\n  --bs-bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bs-bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bs-bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bs-bg-opacity: 1;\n}\n\n.bg-gradient {\n  background-image: var(--bs-gradient) !important;\n}\n\n.user-select-all {\n  user-select: all !important;\n}\n\n.user-select-auto {\n  user-select: auto !important;\n}\n\n.user-select-none {\n  user-select: none !important;\n}\n\n.pe-none {\n  pointer-events: none !important;\n}\n\n.pe-auto {\n  pointer-events: auto !important;\n}\n\n.rounded {\n  border-radius: 0.475rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.rounded-1 {\n  border-radius: 0.425rem !important;\n}\n\n.rounded-2 {\n  border-radius: 0.475rem !important;\n}\n\n.rounded-3 {\n  border-radius: 0.625rem !important;\n}\n\n.rounded-4 {\n  border-radius: 1rem !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-top {\n  border-top-left-radius: var(--bs-border-radius) !important;\n  border-top-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-end {\n  border-top-right-radius: var(--bs-border-radius) !important;\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: var(--bs-border-radius) !important;\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n}\n\n.rounded-start {\n  border-bottom-left-radius: var(--bs-border-radius) !important;\n  border-top-left-radius: var(--bs-border-radius) !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n.opacity-0 {\n  opacity: 0 !important;\n}\n\n.opacity-0-hover:hover {\n  opacity: 0 !important;\n}\n\n.opacity-5 {\n  opacity: 0.05 !important;\n}\n\n.opacity-5-hover:hover {\n  opacity: 0.05 !important;\n}\n\n.opacity-10 {\n  opacity: 0.1 !important;\n}\n\n.opacity-10-hover:hover {\n  opacity: 0.1 !important;\n}\n\n.opacity-15 {\n  opacity: 0.15 !important;\n}\n\n.opacity-15-hover:hover {\n  opacity: 0.15 !important;\n}\n\n.opacity-20 {\n  opacity: 0.2 !important;\n}\n\n.opacity-20-hover:hover {\n  opacity: 0.2 !important;\n}\n\n.opacity-25 {\n  opacity: 0.25 !important;\n}\n\n.opacity-25-hover:hover {\n  opacity: 0.25 !important;\n}\n\n.opacity-50 {\n  opacity: 0.5 !important;\n}\n\n.opacity-50-hover:hover {\n  opacity: 0.5 !important;\n}\n\n.opacity-75 {\n  opacity: 0.75 !important;\n}\n\n.opacity-75-hover:hover {\n  opacity: 0.75 !important;\n}\n\n.opacity-100 {\n  opacity: 1 !important;\n}\n\n.opacity-100-hover:hover {\n  opacity: 1 !important;\n}\n\n.min-w-unset {\n  min-width: unset !important;\n}\n\n.min-w-25 {\n  min-width: 25% !important;\n}\n\n.min-w-50 {\n  min-width: 50% !important;\n}\n\n.min-w-75 {\n  min-width: 75% !important;\n}\n\n.min-w-100 {\n  min-width: 100% !important;\n}\n\n.min-w-auto {\n  min-width: auto !important;\n}\n\n.min-w-1px {\n  min-width: 1px !important;\n}\n\n.min-w-2px {\n  min-width: 2px !important;\n}\n\n.min-w-3px {\n  min-width: 3px !important;\n}\n\n.min-w-4px {\n  min-width: 4px !important;\n}\n\n.min-w-5px {\n  min-width: 5px !important;\n}\n\n.min-w-6px {\n  min-width: 6px !important;\n}\n\n.min-w-7px {\n  min-width: 7px !important;\n}\n\n.min-w-8px {\n  min-width: 8px !important;\n}\n\n.min-w-9px {\n  min-width: 9px !important;\n}\n\n.min-w-10px {\n  min-width: 10px !important;\n}\n\n.min-w-15px {\n  min-width: 15px !important;\n}\n\n.min-w-20px {\n  min-width: 20px !important;\n}\n\n.min-w-25px {\n  min-width: 25px !important;\n}\n\n.min-w-30px {\n  min-width: 30px !important;\n}\n\n.min-w-35px {\n  min-width: 35px !important;\n}\n\n.min-w-40px {\n  min-width: 40px !important;\n}\n\n.min-w-45px {\n  min-width: 45px !important;\n}\n\n.min-w-50px {\n  min-width: 50px !important;\n}\n\n.min-w-55px {\n  min-width: 55px !important;\n}\n\n.min-w-60px {\n  min-width: 60px !important;\n}\n\n.min-w-65px {\n  min-width: 65px !important;\n}\n\n.min-w-70px {\n  min-width: 70px !important;\n}\n\n.min-w-75px {\n  min-width: 75px !important;\n}\n\n.min-w-80px {\n  min-width: 80px !important;\n}\n\n.min-w-85px {\n  min-width: 85px !important;\n}\n\n.min-w-90px {\n  min-width: 90px !important;\n}\n\n.min-w-95px {\n  min-width: 95px !important;\n}\n\n.min-w-100px {\n  min-width: 100px !important;\n}\n\n.min-w-125px {\n  min-width: 125px !important;\n}\n\n.min-w-150px {\n  min-width: 150px !important;\n}\n\n.min-w-175px {\n  min-width: 175px !important;\n}\n\n.min-w-200px {\n  min-width: 200px !important;\n}\n\n.min-w-225px {\n  min-width: 225px !important;\n}\n\n.min-w-250px {\n  min-width: 250px !important;\n}\n\n.min-w-275px {\n  min-width: 275px !important;\n}\n\n.min-w-300px {\n  min-width: 300px !important;\n}\n\n.min-w-325px {\n  min-width: 325px !important;\n}\n\n.min-w-350px {\n  min-width: 350px !important;\n}\n\n.min-w-375px {\n  min-width: 375px !important;\n}\n\n.min-w-400px {\n  min-width: 400px !important;\n}\n\n.min-w-425px {\n  min-width: 425px !important;\n}\n\n.min-w-450px {\n  min-width: 450px !important;\n}\n\n.min-w-475px {\n  min-width: 475px !important;\n}\n\n.min-w-500px {\n  min-width: 500px !important;\n}\n\n.min-w-550px {\n  min-width: 550px !important;\n}\n\n.min-w-600px {\n  min-width: 600px !important;\n}\n\n.min-w-650px {\n  min-width: 650px !important;\n}\n\n.min-w-700px {\n  min-width: 700px !important;\n}\n\n.min-w-750px {\n  min-width: 750px !important;\n}\n\n.min-w-800px {\n  min-width: 800px !important;\n}\n\n.min-w-850px {\n  min-width: 850px !important;\n}\n\n.min-w-900px {\n  min-width: 900px !important;\n}\n\n.min-w-950px {\n  min-width: 950px !important;\n}\n\n.min-w-1000px {\n  min-width: 1000px !important;\n}\n\n.min-h-unset {\n  min-height: unset !important;\n}\n\n.min-h-25 {\n  min-height: 25% !important;\n}\n\n.min-h-50 {\n  min-height: 50% !important;\n}\n\n.min-h-75 {\n  min-height: 75% !important;\n}\n\n.min-h-100 {\n  min-height: 100% !important;\n}\n\n.min-h-auto {\n  min-height: auto !important;\n}\n\n.min-h-1px {\n  min-height: 1px !important;\n}\n\n.min-h-2px {\n  min-height: 2px !important;\n}\n\n.min-h-3px {\n  min-height: 3px !important;\n}\n\n.min-h-4px {\n  min-height: 4px !important;\n}\n\n.min-h-5px {\n  min-height: 5px !important;\n}\n\n.min-h-6px {\n  min-height: 6px !important;\n}\n\n.min-h-7px {\n  min-height: 7px !important;\n}\n\n.min-h-8px {\n  min-height: 8px !important;\n}\n\n.min-h-9px {\n  min-height: 9px !important;\n}\n\n.min-h-10px {\n  min-height: 10px !important;\n}\n\n.min-h-15px {\n  min-height: 15px !important;\n}\n\n.min-h-20px {\n  min-height: 20px !important;\n}\n\n.min-h-25px {\n  min-height: 25px !important;\n}\n\n.min-h-30px {\n  min-height: 30px !important;\n}\n\n.min-h-35px {\n  min-height: 35px !important;\n}\n\n.min-h-40px {\n  min-height: 40px !important;\n}\n\n.min-h-45px {\n  min-height: 45px !important;\n}\n\n.min-h-50px {\n  min-height: 50px !important;\n}\n\n.min-h-55px {\n  min-height: 55px !important;\n}\n\n.min-h-60px {\n  min-height: 60px !important;\n}\n\n.min-h-65px {\n  min-height: 65px !important;\n}\n\n.min-h-70px {\n  min-height: 70px !important;\n}\n\n.min-h-75px {\n  min-height: 75px !important;\n}\n\n.min-h-80px {\n  min-height: 80px !important;\n}\n\n.min-h-85px {\n  min-height: 85px !important;\n}\n\n.min-h-90px {\n  min-height: 90px !important;\n}\n\n.min-h-95px {\n  min-height: 95px !important;\n}\n\n.min-h-100px {\n  min-height: 100px !important;\n}\n\n.min-h-125px {\n  min-height: 125px !important;\n}\n\n.min-h-150px {\n  min-height: 150px !important;\n}\n\n.min-h-175px {\n  min-height: 175px !important;\n}\n\n.min-h-200px {\n  min-height: 200px !important;\n}\n\n.min-h-225px {\n  min-height: 225px !important;\n}\n\n.min-h-250px {\n  min-height: 250px !important;\n}\n\n.min-h-275px {\n  min-height: 275px !important;\n}\n\n.min-h-300px {\n  min-height: 300px !important;\n}\n\n.min-h-325px {\n  min-height: 325px !important;\n}\n\n.min-h-350px {\n  min-height: 350px !important;\n}\n\n.min-h-375px {\n  min-height: 375px !important;\n}\n\n.min-h-400px {\n  min-height: 400px !important;\n}\n\n.min-h-425px {\n  min-height: 425px !important;\n}\n\n.min-h-450px {\n  min-height: 450px !important;\n}\n\n.min-h-475px {\n  min-height: 475px !important;\n}\n\n.min-h-500px {\n  min-height: 500px !important;\n}\n\n.min-h-550px {\n  min-height: 550px !important;\n}\n\n.min-h-600px {\n  min-height: 600px !important;\n}\n\n.min-h-650px {\n  min-height: 650px !important;\n}\n\n.min-h-700px {\n  min-height: 700px !important;\n}\n\n.min-h-750px {\n  min-height: 750px !important;\n}\n\n.min-h-800px {\n  min-height: 800px !important;\n}\n\n.min-h-850px {\n  min-height: 850px !important;\n}\n\n.min-h-900px {\n  min-height: 900px !important;\n}\n\n.min-h-950px {\n  min-height: 950px !important;\n}\n\n.min-h-1000px {\n  min-height: 1000px !important;\n}\n\n.z-index-n1 {\n  z-index: -1 !important;\n}\n\n.z-index-n2 {\n  z-index: -2 !important;\n}\n\n.z-index-0 {\n  z-index: 0 !important;\n}\n\n.z-index-1 {\n  z-index: 1 !important;\n}\n\n.z-index-2 {\n  z-index: 2 !important;\n}\n\n.z-index-3 {\n  z-index: 3 !important;\n}\n\n.border-top-0 {\n  border-top-width: 0 !important;\n}\n\n.border-top-1 {\n  border-top-width: 1px !important;\n}\n\n.border-top-2 {\n  border-top-width: 2px !important;\n}\n\n.border-top-3 {\n  border-top-width: 3px !important;\n}\n\n.border-top-4 {\n  border-top-width: 4px !important;\n}\n\n.border-top-5 {\n  border-top-width: 5px !important;\n}\n\n.border-bottom-0 {\n  border-bottom-width: 0 !important;\n}\n\n.border-bottom-1 {\n  border-bottom-width: 1px !important;\n}\n\n.border-bottom-2 {\n  border-bottom-width: 2px !important;\n}\n\n.border-bottom-3 {\n  border-bottom-width: 3px !important;\n}\n\n.border-bottom-4 {\n  border-bottom-width: 4px !important;\n}\n\n.border-bottom-5 {\n  border-bottom-width: 5px !important;\n}\n\n.border-right-0 {\n  border-right-width: 0 !important;\n}\n\n.border-right-1 {\n  border-right-width: 1px !important;\n}\n\n.border-right-2 {\n  border-right-width: 2px !important;\n}\n\n.border-right-3 {\n  border-right-width: 3px !important;\n}\n\n.border-right-4 {\n  border-right-width: 4px !important;\n}\n\n.border-right-5 {\n  border-right-width: 5px !important;\n}\n\n.border-left-0 {\n  border-left-width: 0 !important;\n}\n\n.border-left-1 {\n  border-left-width: 1px !important;\n}\n\n.border-left-2 {\n  border-left-width: 2px !important;\n}\n\n.border-left-3 {\n  border-left-width: 3px !important;\n}\n\n.border-left-4 {\n  border-left-width: 4px !important;\n}\n\n.border-left-5 {\n  border-left-width: 5px !important;\n}\n\n.ls-1 {\n  letter-spacing: 0.1rem !important;\n}\n\n.ls-2 {\n  letter-spacing: 0.115rem !important;\n}\n\n.ls-3 {\n  letter-spacing: 0.125rem !important;\n}\n\n.ls-4 {\n  letter-spacing: 0.25rem !important;\n}\n\n.ls-5 {\n  letter-spacing: 0.5rem !important;\n}\n\n.ls-n1 {\n  letter-spacing: -0.1rem !important;\n}\n\n.ls-n2 {\n  letter-spacing: -0.115rem !important;\n}\n\n.ls-n3 {\n  letter-spacing: -0.125rem !important;\n}\n\n.ls-n4 {\n  letter-spacing: -0.25rem !important;\n}\n\n.ls-n5 {\n  letter-spacing: -0.5rem !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-start {\n    float: left !important;\n  }\n\n  .float-sm-end {\n    float: right !important;\n  }\n\n  .float-sm-none {\n    float: none !important;\n  }\n\n  .d-sm-inline {\n    display: inline !important;\n  }\n\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-sm-block {\n    display: block !important;\n  }\n\n  .d-sm-grid {\n    display: grid !important;\n  }\n\n  .d-sm-table {\n    display: table !important;\n  }\n\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-sm-flex {\n    display: flex !important;\n  }\n\n  .d-sm-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-sm-none {\n    display: none !important;\n  }\n\n  .position-sm-static {\n    position: static !important;\n  }\n\n  .position-sm-relative {\n    position: relative !important;\n  }\n\n  .position-sm-absolute {\n    position: absolute !important;\n  }\n\n  .position-sm-fixed {\n    position: fixed !important;\n  }\n\n  .position-sm-sticky {\n    position: sticky !important;\n  }\n\n  .w-sm-unset {\n    width: unset !important;\n  }\n\n  .w-sm-25 {\n    width: 25% !important;\n  }\n\n  .w-sm-50 {\n    width: 50% !important;\n  }\n\n  .w-sm-75 {\n    width: 75% !important;\n  }\n\n  .w-sm-100 {\n    width: 100% !important;\n  }\n\n  .w-sm-auto {\n    width: auto !important;\n  }\n\n  .w-sm-1px {\n    width: 1px !important;\n  }\n\n  .w-sm-2px {\n    width: 2px !important;\n  }\n\n  .w-sm-3px {\n    width: 3px !important;\n  }\n\n  .w-sm-4px {\n    width: 4px !important;\n  }\n\n  .w-sm-5px {\n    width: 5px !important;\n  }\n\n  .w-sm-6px {\n    width: 6px !important;\n  }\n\n  .w-sm-7px {\n    width: 7px !important;\n  }\n\n  .w-sm-8px {\n    width: 8px !important;\n  }\n\n  .w-sm-9px {\n    width: 9px !important;\n  }\n\n  .w-sm-10px {\n    width: 10px !important;\n  }\n\n  .w-sm-15px {\n    width: 15px !important;\n  }\n\n  .w-sm-20px {\n    width: 20px !important;\n  }\n\n  .w-sm-25px {\n    width: 25px !important;\n  }\n\n  .w-sm-30px {\n    width: 30px !important;\n  }\n\n  .w-sm-35px {\n    width: 35px !important;\n  }\n\n  .w-sm-40px {\n    width: 40px !important;\n  }\n\n  .w-sm-45px {\n    width: 45px !important;\n  }\n\n  .w-sm-50px {\n    width: 50px !important;\n  }\n\n  .w-sm-55px {\n    width: 55px !important;\n  }\n\n  .w-sm-60px {\n    width: 60px !important;\n  }\n\n  .w-sm-65px {\n    width: 65px !important;\n  }\n\n  .w-sm-70px {\n    width: 70px !important;\n  }\n\n  .w-sm-75px {\n    width: 75px !important;\n  }\n\n  .w-sm-80px {\n    width: 80px !important;\n  }\n\n  .w-sm-85px {\n    width: 85px !important;\n  }\n\n  .w-sm-90px {\n    width: 90px !important;\n  }\n\n  .w-sm-95px {\n    width: 95px !important;\n  }\n\n  .w-sm-100px {\n    width: 100px !important;\n  }\n\n  .w-sm-125px {\n    width: 125px !important;\n  }\n\n  .w-sm-150px {\n    width: 150px !important;\n  }\n\n  .w-sm-175px {\n    width: 175px !important;\n  }\n\n  .w-sm-200px {\n    width: 200px !important;\n  }\n\n  .w-sm-225px {\n    width: 225px !important;\n  }\n\n  .w-sm-250px {\n    width: 250px !important;\n  }\n\n  .w-sm-275px {\n    width: 275px !important;\n  }\n\n  .w-sm-300px {\n    width: 300px !important;\n  }\n\n  .w-sm-325px {\n    width: 325px !important;\n  }\n\n  .w-sm-350px {\n    width: 350px !important;\n  }\n\n  .w-sm-375px {\n    width: 375px !important;\n  }\n\n  .w-sm-400px {\n    width: 400px !important;\n  }\n\n  .w-sm-425px {\n    width: 425px !important;\n  }\n\n  .w-sm-450px {\n    width: 450px !important;\n  }\n\n  .w-sm-475px {\n    width: 475px !important;\n  }\n\n  .w-sm-500px {\n    width: 500px !important;\n  }\n\n  .w-sm-550px {\n    width: 550px !important;\n  }\n\n  .w-sm-600px {\n    width: 600px !important;\n  }\n\n  .w-sm-650px {\n    width: 650px !important;\n  }\n\n  .w-sm-700px {\n    width: 700px !important;\n  }\n\n  .w-sm-750px {\n    width: 750px !important;\n  }\n\n  .w-sm-800px {\n    width: 800px !important;\n  }\n\n  .w-sm-850px {\n    width: 850px !important;\n  }\n\n  .w-sm-900px {\n    width: 900px !important;\n  }\n\n  .w-sm-950px {\n    width: 950px !important;\n  }\n\n  .w-sm-1000px {\n    width: 1000px !important;\n  }\n\n  .mw-sm-unset {\n    max-width: unset !important;\n  }\n\n  .mw-sm-25 {\n    max-width: 25% !important;\n  }\n\n  .mw-sm-50 {\n    max-width: 50% !important;\n  }\n\n  .mw-sm-75 {\n    max-width: 75% !important;\n  }\n\n  .mw-sm-100 {\n    max-width: 100% !important;\n  }\n\n  .mw-sm-auto {\n    max-width: auto !important;\n  }\n\n  .mw-sm-1px {\n    max-width: 1px !important;\n  }\n\n  .mw-sm-2px {\n    max-width: 2px !important;\n  }\n\n  .mw-sm-3px {\n    max-width: 3px !important;\n  }\n\n  .mw-sm-4px {\n    max-width: 4px !important;\n  }\n\n  .mw-sm-5px {\n    max-width: 5px !important;\n  }\n\n  .mw-sm-6px {\n    max-width: 6px !important;\n  }\n\n  .mw-sm-7px {\n    max-width: 7px !important;\n  }\n\n  .mw-sm-8px {\n    max-width: 8px !important;\n  }\n\n  .mw-sm-9px {\n    max-width: 9px !important;\n  }\n\n  .mw-sm-10px {\n    max-width: 10px !important;\n  }\n\n  .mw-sm-15px {\n    max-width: 15px !important;\n  }\n\n  .mw-sm-20px {\n    max-width: 20px !important;\n  }\n\n  .mw-sm-25px {\n    max-width: 25px !important;\n  }\n\n  .mw-sm-30px {\n    max-width: 30px !important;\n  }\n\n  .mw-sm-35px {\n    max-width: 35px !important;\n  }\n\n  .mw-sm-40px {\n    max-width: 40px !important;\n  }\n\n  .mw-sm-45px {\n    max-width: 45px !important;\n  }\n\n  .mw-sm-50px {\n    max-width: 50px !important;\n  }\n\n  .mw-sm-55px {\n    max-width: 55px !important;\n  }\n\n  .mw-sm-60px {\n    max-width: 60px !important;\n  }\n\n  .mw-sm-65px {\n    max-width: 65px !important;\n  }\n\n  .mw-sm-70px {\n    max-width: 70px !important;\n  }\n\n  .mw-sm-75px {\n    max-width: 75px !important;\n  }\n\n  .mw-sm-80px {\n    max-width: 80px !important;\n  }\n\n  .mw-sm-85px {\n    max-width: 85px !important;\n  }\n\n  .mw-sm-90px {\n    max-width: 90px !important;\n  }\n\n  .mw-sm-95px {\n    max-width: 95px !important;\n  }\n\n  .mw-sm-100px {\n    max-width: 100px !important;\n  }\n\n  .mw-sm-125px {\n    max-width: 125px !important;\n  }\n\n  .mw-sm-150px {\n    max-width: 150px !important;\n  }\n\n  .mw-sm-175px {\n    max-width: 175px !important;\n  }\n\n  .mw-sm-200px {\n    max-width: 200px !important;\n  }\n\n  .mw-sm-225px {\n    max-width: 225px !important;\n  }\n\n  .mw-sm-250px {\n    max-width: 250px !important;\n  }\n\n  .mw-sm-275px {\n    max-width: 275px !important;\n  }\n\n  .mw-sm-300px {\n    max-width: 300px !important;\n  }\n\n  .mw-sm-325px {\n    max-width: 325px !important;\n  }\n\n  .mw-sm-350px {\n    max-width: 350px !important;\n  }\n\n  .mw-sm-375px {\n    max-width: 375px !important;\n  }\n\n  .mw-sm-400px {\n    max-width: 400px !important;\n  }\n\n  .mw-sm-425px {\n    max-width: 425px !important;\n  }\n\n  .mw-sm-450px {\n    max-width: 450px !important;\n  }\n\n  .mw-sm-475px {\n    max-width: 475px !important;\n  }\n\n  .mw-sm-500px {\n    max-width: 500px !important;\n  }\n\n  .mw-sm-550px {\n    max-width: 550px !important;\n  }\n\n  .mw-sm-600px {\n    max-width: 600px !important;\n  }\n\n  .mw-sm-650px {\n    max-width: 650px !important;\n  }\n\n  .mw-sm-700px {\n    max-width: 700px !important;\n  }\n\n  .mw-sm-750px {\n    max-width: 750px !important;\n  }\n\n  .mw-sm-800px {\n    max-width: 800px !important;\n  }\n\n  .mw-sm-850px {\n    max-width: 850px !important;\n  }\n\n  .mw-sm-900px {\n    max-width: 900px !important;\n  }\n\n  .mw-sm-950px {\n    max-width: 950px !important;\n  }\n\n  .mw-sm-1000px {\n    max-width: 1000px !important;\n  }\n\n  .h-sm-unset {\n    height: unset !important;\n  }\n\n  .h-sm-25 {\n    height: 25% !important;\n  }\n\n  .h-sm-50 {\n    height: 50% !important;\n  }\n\n  .h-sm-75 {\n    height: 75% !important;\n  }\n\n  .h-sm-100 {\n    height: 100% !important;\n  }\n\n  .h-sm-auto {\n    height: auto !important;\n  }\n\n  .h-sm-1px {\n    height: 1px !important;\n  }\n\n  .h-sm-2px {\n    height: 2px !important;\n  }\n\n  .h-sm-3px {\n    height: 3px !important;\n  }\n\n  .h-sm-4px {\n    height: 4px !important;\n  }\n\n  .h-sm-5px {\n    height: 5px !important;\n  }\n\n  .h-sm-6px {\n    height: 6px !important;\n  }\n\n  .h-sm-7px {\n    height: 7px !important;\n  }\n\n  .h-sm-8px {\n    height: 8px !important;\n  }\n\n  .h-sm-9px {\n    height: 9px !important;\n  }\n\n  .h-sm-10px {\n    height: 10px !important;\n  }\n\n  .h-sm-15px {\n    height: 15px !important;\n  }\n\n  .h-sm-20px {\n    height: 20px !important;\n  }\n\n  .h-sm-25px {\n    height: 25px !important;\n  }\n\n  .h-sm-30px {\n    height: 30px !important;\n  }\n\n  .h-sm-35px {\n    height: 35px !important;\n  }\n\n  .h-sm-40px {\n    height: 40px !important;\n  }\n\n  .h-sm-45px {\n    height: 45px !important;\n  }\n\n  .h-sm-50px {\n    height: 50px !important;\n  }\n\n  .h-sm-55px {\n    height: 55px !important;\n  }\n\n  .h-sm-60px {\n    height: 60px !important;\n  }\n\n  .h-sm-65px {\n    height: 65px !important;\n  }\n\n  .h-sm-70px {\n    height: 70px !important;\n  }\n\n  .h-sm-75px {\n    height: 75px !important;\n  }\n\n  .h-sm-80px {\n    height: 80px !important;\n  }\n\n  .h-sm-85px {\n    height: 85px !important;\n  }\n\n  .h-sm-90px {\n    height: 90px !important;\n  }\n\n  .h-sm-95px {\n    height: 95px !important;\n  }\n\n  .h-sm-100px {\n    height: 100px !important;\n  }\n\n  .h-sm-125px {\n    height: 125px !important;\n  }\n\n  .h-sm-150px {\n    height: 150px !important;\n  }\n\n  .h-sm-175px {\n    height: 175px !important;\n  }\n\n  .h-sm-200px {\n    height: 200px !important;\n  }\n\n  .h-sm-225px {\n    height: 225px !important;\n  }\n\n  .h-sm-250px {\n    height: 250px !important;\n  }\n\n  .h-sm-275px {\n    height: 275px !important;\n  }\n\n  .h-sm-300px {\n    height: 300px !important;\n  }\n\n  .h-sm-325px {\n    height: 325px !important;\n  }\n\n  .h-sm-350px {\n    height: 350px !important;\n  }\n\n  .h-sm-375px {\n    height: 375px !important;\n  }\n\n  .h-sm-400px {\n    height: 400px !important;\n  }\n\n  .h-sm-425px {\n    height: 425px !important;\n  }\n\n  .h-sm-450px {\n    height: 450px !important;\n  }\n\n  .h-sm-475px {\n    height: 475px !important;\n  }\n\n  .h-sm-500px {\n    height: 500px !important;\n  }\n\n  .h-sm-550px {\n    height: 550px !important;\n  }\n\n  .h-sm-600px {\n    height: 600px !important;\n  }\n\n  .h-sm-650px {\n    height: 650px !important;\n  }\n\n  .h-sm-700px {\n    height: 700px !important;\n  }\n\n  .h-sm-750px {\n    height: 750px !important;\n  }\n\n  .h-sm-800px {\n    height: 800px !important;\n  }\n\n  .h-sm-850px {\n    height: 850px !important;\n  }\n\n  .h-sm-900px {\n    height: 900px !important;\n  }\n\n  .h-sm-950px {\n    height: 950px !important;\n  }\n\n  .h-sm-1000px {\n    height: 1000px !important;\n  }\n\n  .mh-sm-unset {\n    max-height: unset !important;\n  }\n\n  .mh-sm-25 {\n    max-height: 25% !important;\n  }\n\n  .mh-sm-50 {\n    max-height: 50% !important;\n  }\n\n  .mh-sm-75 {\n    max-height: 75% !important;\n  }\n\n  .mh-sm-100 {\n    max-height: 100% !important;\n  }\n\n  .mh-sm-auto {\n    max-height: auto !important;\n  }\n\n  .mh-sm-1px {\n    max-height: 1px !important;\n  }\n\n  .mh-sm-2px {\n    max-height: 2px !important;\n  }\n\n  .mh-sm-3px {\n    max-height: 3px !important;\n  }\n\n  .mh-sm-4px {\n    max-height: 4px !important;\n  }\n\n  .mh-sm-5px {\n    max-height: 5px !important;\n  }\n\n  .mh-sm-6px {\n    max-height: 6px !important;\n  }\n\n  .mh-sm-7px {\n    max-height: 7px !important;\n  }\n\n  .mh-sm-8px {\n    max-height: 8px !important;\n  }\n\n  .mh-sm-9px {\n    max-height: 9px !important;\n  }\n\n  .mh-sm-10px {\n    max-height: 10px !important;\n  }\n\n  .mh-sm-15px {\n    max-height: 15px !important;\n  }\n\n  .mh-sm-20px {\n    max-height: 20px !important;\n  }\n\n  .mh-sm-25px {\n    max-height: 25px !important;\n  }\n\n  .mh-sm-30px {\n    max-height: 30px !important;\n  }\n\n  .mh-sm-35px {\n    max-height: 35px !important;\n  }\n\n  .mh-sm-40px {\n    max-height: 40px !important;\n  }\n\n  .mh-sm-45px {\n    max-height: 45px !important;\n  }\n\n  .mh-sm-50px {\n    max-height: 50px !important;\n  }\n\n  .mh-sm-55px {\n    max-height: 55px !important;\n  }\n\n  .mh-sm-60px {\n    max-height: 60px !important;\n  }\n\n  .mh-sm-65px {\n    max-height: 65px !important;\n  }\n\n  .mh-sm-70px {\n    max-height: 70px !important;\n  }\n\n  .mh-sm-75px {\n    max-height: 75px !important;\n  }\n\n  .mh-sm-80px {\n    max-height: 80px !important;\n  }\n\n  .mh-sm-85px {\n    max-height: 85px !important;\n  }\n\n  .mh-sm-90px {\n    max-height: 90px !important;\n  }\n\n  .mh-sm-95px {\n    max-height: 95px !important;\n  }\n\n  .mh-sm-100px {\n    max-height: 100px !important;\n  }\n\n  .mh-sm-125px {\n    max-height: 125px !important;\n  }\n\n  .mh-sm-150px {\n    max-height: 150px !important;\n  }\n\n  .mh-sm-175px {\n    max-height: 175px !important;\n  }\n\n  .mh-sm-200px {\n    max-height: 200px !important;\n  }\n\n  .mh-sm-225px {\n    max-height: 225px !important;\n  }\n\n  .mh-sm-250px {\n    max-height: 250px !important;\n  }\n\n  .mh-sm-275px {\n    max-height: 275px !important;\n  }\n\n  .mh-sm-300px {\n    max-height: 300px !important;\n  }\n\n  .mh-sm-325px {\n    max-height: 325px !important;\n  }\n\n  .mh-sm-350px {\n    max-height: 350px !important;\n  }\n\n  .mh-sm-375px {\n    max-height: 375px !important;\n  }\n\n  .mh-sm-400px {\n    max-height: 400px !important;\n  }\n\n  .mh-sm-425px {\n    max-height: 425px !important;\n  }\n\n  .mh-sm-450px {\n    max-height: 450px !important;\n  }\n\n  .mh-sm-475px {\n    max-height: 475px !important;\n  }\n\n  .mh-sm-500px {\n    max-height: 500px !important;\n  }\n\n  .mh-sm-550px {\n    max-height: 550px !important;\n  }\n\n  .mh-sm-600px {\n    max-height: 600px !important;\n  }\n\n  .mh-sm-650px {\n    max-height: 650px !important;\n  }\n\n  .mh-sm-700px {\n    max-height: 700px !important;\n  }\n\n  .mh-sm-750px {\n    max-height: 750px !important;\n  }\n\n  .mh-sm-800px {\n    max-height: 800px !important;\n  }\n\n  .mh-sm-850px {\n    max-height: 850px !important;\n  }\n\n  .mh-sm-900px {\n    max-height: 900px !important;\n  }\n\n  .mh-sm-950px {\n    max-height: 950px !important;\n  }\n\n  .mh-sm-1000px {\n    max-height: 1000px !important;\n  }\n\n  .flex-sm-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-sm-row {\n    flex-direction: row !important;\n  }\n\n  .flex-sm-column {\n    flex-direction: column !important;\n  }\n\n  .flex-sm-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-sm-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-sm-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-sm-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-sm-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-sm-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-sm-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-sm-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-sm-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-sm-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-sm-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-sm-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-sm-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-sm-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-sm-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-sm-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-sm-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-sm-center {\n    align-items: center !important;\n  }\n\n  .align-items-sm-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-sm-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-sm-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-sm-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-sm-center {\n    align-content: center !important;\n  }\n\n  .align-content-sm-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-sm-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-sm-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-sm-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-sm-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-sm-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-sm-center {\n    align-self: center !important;\n  }\n\n  .align-self-sm-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-sm-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-sm-first {\n    order: -1 !important;\n  }\n\n  .order-sm-0 {\n    order: 0 !important;\n  }\n\n  .order-sm-1 {\n    order: 1 !important;\n  }\n\n  .order-sm-2 {\n    order: 2 !important;\n  }\n\n  .order-sm-3 {\n    order: 3 !important;\n  }\n\n  .order-sm-4 {\n    order: 4 !important;\n  }\n\n  .order-sm-5 {\n    order: 5 !important;\n  }\n\n  .order-sm-last {\n    order: 6 !important;\n  }\n\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-sm-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-sm-4 {\n    margin: 1rem !important;\n  }\n\n  .m-sm-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-sm-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-sm-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-sm-8 {\n    margin: 2rem !important;\n  }\n\n  .m-sm-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-sm-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-sm-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-sm-12 {\n    margin: 3rem !important;\n  }\n\n  .m-sm-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-sm-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-sm-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-sm-16 {\n    margin: 4rem !important;\n  }\n\n  .m-sm-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-sm-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-sm-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-sm-20 {\n    margin: 5rem !important;\n  }\n\n  .m-sm-auto {\n    margin: auto !important;\n  }\n\n  .mx-sm-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-sm-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-sm-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-sm-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-sm-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-sm-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-sm-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-sm-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-sm-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-sm-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-sm-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-sm-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-sm-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-sm-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-sm-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-sm-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-sm-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-sm-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-sm-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-sm-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-sm-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-sm-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-sm-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-sm-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-sm-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-sm-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-sm-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-sm-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-sm-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-sm-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-sm-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-sm-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-sm-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-sm-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-sm-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-sm-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-sm-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-sm-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-sm-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-sm-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-sm-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-sm-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-sm-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-sm-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-sm-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-sm-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-sm-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-sm-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-sm-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-sm-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-sm-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-sm-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-sm-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-sm-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-sm-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-sm-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-sm-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-sm-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-sm-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-sm-auto {\n    margin-top: auto !important;\n  }\n\n  .me-sm-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-sm-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-sm-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-sm-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-sm-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-sm-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-sm-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-sm-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-sm-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-sm-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-sm-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-sm-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-sm-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-sm-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-sm-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-sm-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-sm-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-sm-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-sm-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-sm-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-sm-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-sm-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-sm-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-sm-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-sm-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-sm-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-sm-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-sm-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-sm-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-sm-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-sm-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-sm-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-sm-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-sm-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-sm-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-sm-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-sm-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-sm-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-sm-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-sm-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-sm-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-sm-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-sm-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-sm-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-sm-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-sm-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-sm-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-sm-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-sm-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-sm-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-sm-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-sm-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-sm-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-sm-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-sm-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-sm-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-sm-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-sm-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-sm-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-sm-auto {\n    margin-left: auto !important;\n  }\n\n  .m-sm-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-sm-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-sm-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-sm-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-sm-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-sm-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-sm-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-sm-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-sm-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-sm-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-sm-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-sm-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-sm-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-sm-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-sm-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-sm-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-sm-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-sm-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-sm-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-sm-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-sm-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-sm-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-sm-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-sm-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-sm-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-sm-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-sm-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-sm-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-sm-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-sm-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-sm-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-sm-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-sm-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-sm-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-sm-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-sm-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-sm-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-sm-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-sm-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-sm-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-sm-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-sm-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-sm-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-sm-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-sm-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-sm-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-sm-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-sm-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-sm-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-sm-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-sm-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-sm-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-sm-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-sm-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-sm-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-sm-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-sm-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-sm-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-sm-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-sm-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-sm-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-sm-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-sm-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-sm-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-sm-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-sm-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-sm-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-sm-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-sm-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-sm-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-sm-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-sm-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-sm-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-sm-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-sm-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-sm-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-sm-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-sm-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-sm-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-sm-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-sm-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-sm-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-sm-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-sm-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-sm-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-sm-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-sm-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-sm-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-sm-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-sm-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-sm-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-sm-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-sm-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-sm-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-sm-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-sm-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-sm-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-sm-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-sm-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-sm-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-sm-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-sm-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-sm-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-sm-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-sm-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-sm-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-sm-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-sm-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-sm-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-sm-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-sm-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-sm-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-sm-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-sm-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-sm-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-sm-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-sm-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-sm-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-sm-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-sm-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-sm-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-sm-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-sm-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-sm-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-sm-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-sm-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-sm-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-sm-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-sm-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-sm-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-sm-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-sm-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-sm-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-sm-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-sm-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-sm-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-sm-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-sm-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-sm-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-sm-4 {\n    padding: 1rem !important;\n  }\n\n  .p-sm-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-sm-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-sm-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-sm-8 {\n    padding: 2rem !important;\n  }\n\n  .p-sm-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-sm-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-sm-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-sm-12 {\n    padding: 3rem !important;\n  }\n\n  .p-sm-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-sm-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-sm-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-sm-16 {\n    padding: 4rem !important;\n  }\n\n  .p-sm-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-sm-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-sm-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-sm-20 {\n    padding: 5rem !important;\n  }\n\n  .px-sm-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-sm-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-sm-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-sm-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-sm-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-sm-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-sm-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-sm-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-sm-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-sm-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-sm-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-sm-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-sm-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-sm-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-sm-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-sm-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-sm-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-sm-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-sm-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-sm-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-sm-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-sm-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-sm-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-sm-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-sm-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-sm-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-sm-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-sm-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-sm-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-sm-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-sm-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-sm-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-sm-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-sm-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-sm-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-sm-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-sm-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-sm-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-sm-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-sm-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-sm-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-sm-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-sm-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-sm-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-sm-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-sm-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-sm-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-sm-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-sm-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-sm-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-sm-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-sm-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-sm-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-sm-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-sm-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-sm-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-sm-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-sm-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-sm-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-sm-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-sm-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-sm-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-sm-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-sm-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-sm-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-sm-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-sm-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-sm-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-sm-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-sm-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-sm-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-sm-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-sm-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-sm-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-sm-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-sm-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-sm-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-sm-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-sm-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-sm-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-sm-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-sm-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-sm-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-sm-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-sm-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-sm-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-sm-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-sm-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-sm-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-sm-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-sm-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-sm-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-sm-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-sm-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-sm-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-sm-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-sm-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-sm-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-sm-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-sm-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-sm-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-sm-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-sm-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-sm-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-sm-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-sm-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-sm-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-sm-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-sm-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-sm-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-sm-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-sm-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-sm-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-sm-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-sm-0 {\n    gap: 0 !important;\n  }\n\n  .gap-sm-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-sm-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-sm-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-sm-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-sm-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-sm-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-sm-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-sm-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-sm-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-sm-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-sm-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-sm-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-sm-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-sm-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-sm-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-sm-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-sm-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-sm-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-sm-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-sm-20 {\n    gap: 5rem !important;\n  }\n\n  .fs-sm-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n\n  .fs-sm-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n\n  .fs-sm-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n\n  .fs-sm-4 {\n    font-size: 1.25rem !important;\n  }\n\n  .fs-sm-5 {\n    font-size: 1.15rem !important;\n  }\n\n  .fs-sm-6 {\n    font-size: 1.075rem !important;\n  }\n\n  .fs-sm-7 {\n    font-size: 0.95rem !important;\n  }\n\n  .fs-sm-8 {\n    font-size: 0.85rem !important;\n  }\n\n  .fs-sm-9 {\n    font-size: 0.75rem !important;\n  }\n\n  .fs-sm-10 {\n    font-size: 0.5rem !important;\n  }\n\n  .fs-sm-base {\n    font-size: 1rem !important;\n  }\n\n  .fs-sm-fluid {\n    font-size: 100% !important;\n  }\n\n  .fs-sm-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n\n  .fs-sm-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n\n  .fs-sm-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n\n  .fs-sm-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n\n  .fs-sm-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n\n  .fs-sm-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n\n  .fs-sm-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n\n  .fs-sm-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n\n  .fs-sm-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n\n  .fs-sm-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n\n  .fs-sm-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n\n  .fs-sm-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n\n  .fs-sm-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n\n  .fs-sm-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n\n  .fs-sm-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n\n  .fs-sm-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n\n  .text-sm-start {\n    text-align: left !important;\n  }\n\n  .text-sm-end {\n    text-align: right !important;\n  }\n\n  .text-sm-center {\n    text-align: center !important;\n  }\n\n  .min-w-sm-unset {\n    min-width: unset !important;\n  }\n\n  .min-w-sm-25 {\n    min-width: 25% !important;\n  }\n\n  .min-w-sm-50 {\n    min-width: 50% !important;\n  }\n\n  .min-w-sm-75 {\n    min-width: 75% !important;\n  }\n\n  .min-w-sm-100 {\n    min-width: 100% !important;\n  }\n\n  .min-w-sm-auto {\n    min-width: auto !important;\n  }\n\n  .min-w-sm-1px {\n    min-width: 1px !important;\n  }\n\n  .min-w-sm-2px {\n    min-width: 2px !important;\n  }\n\n  .min-w-sm-3px {\n    min-width: 3px !important;\n  }\n\n  .min-w-sm-4px {\n    min-width: 4px !important;\n  }\n\n  .min-w-sm-5px {\n    min-width: 5px !important;\n  }\n\n  .min-w-sm-6px {\n    min-width: 6px !important;\n  }\n\n  .min-w-sm-7px {\n    min-width: 7px !important;\n  }\n\n  .min-w-sm-8px {\n    min-width: 8px !important;\n  }\n\n  .min-w-sm-9px {\n    min-width: 9px !important;\n  }\n\n  .min-w-sm-10px {\n    min-width: 10px !important;\n  }\n\n  .min-w-sm-15px {\n    min-width: 15px !important;\n  }\n\n  .min-w-sm-20px {\n    min-width: 20px !important;\n  }\n\n  .min-w-sm-25px {\n    min-width: 25px !important;\n  }\n\n  .min-w-sm-30px {\n    min-width: 30px !important;\n  }\n\n  .min-w-sm-35px {\n    min-width: 35px !important;\n  }\n\n  .min-w-sm-40px {\n    min-width: 40px !important;\n  }\n\n  .min-w-sm-45px {\n    min-width: 45px !important;\n  }\n\n  .min-w-sm-50px {\n    min-width: 50px !important;\n  }\n\n  .min-w-sm-55px {\n    min-width: 55px !important;\n  }\n\n  .min-w-sm-60px {\n    min-width: 60px !important;\n  }\n\n  .min-w-sm-65px {\n    min-width: 65px !important;\n  }\n\n  .min-w-sm-70px {\n    min-width: 70px !important;\n  }\n\n  .min-w-sm-75px {\n    min-width: 75px !important;\n  }\n\n  .min-w-sm-80px {\n    min-width: 80px !important;\n  }\n\n  .min-w-sm-85px {\n    min-width: 85px !important;\n  }\n\n  .min-w-sm-90px {\n    min-width: 90px !important;\n  }\n\n  .min-w-sm-95px {\n    min-width: 95px !important;\n  }\n\n  .min-w-sm-100px {\n    min-width: 100px !important;\n  }\n\n  .min-w-sm-125px {\n    min-width: 125px !important;\n  }\n\n  .min-w-sm-150px {\n    min-width: 150px !important;\n  }\n\n  .min-w-sm-175px {\n    min-width: 175px !important;\n  }\n\n  .min-w-sm-200px {\n    min-width: 200px !important;\n  }\n\n  .min-w-sm-225px {\n    min-width: 225px !important;\n  }\n\n  .min-w-sm-250px {\n    min-width: 250px !important;\n  }\n\n  .min-w-sm-275px {\n    min-width: 275px !important;\n  }\n\n  .min-w-sm-300px {\n    min-width: 300px !important;\n  }\n\n  .min-w-sm-325px {\n    min-width: 325px !important;\n  }\n\n  .min-w-sm-350px {\n    min-width: 350px !important;\n  }\n\n  .min-w-sm-375px {\n    min-width: 375px !important;\n  }\n\n  .min-w-sm-400px {\n    min-width: 400px !important;\n  }\n\n  .min-w-sm-425px {\n    min-width: 425px !important;\n  }\n\n  .min-w-sm-450px {\n    min-width: 450px !important;\n  }\n\n  .min-w-sm-475px {\n    min-width: 475px !important;\n  }\n\n  .min-w-sm-500px {\n    min-width: 500px !important;\n  }\n\n  .min-w-sm-550px {\n    min-width: 550px !important;\n  }\n\n  .min-w-sm-600px {\n    min-width: 600px !important;\n  }\n\n  .min-w-sm-650px {\n    min-width: 650px !important;\n  }\n\n  .min-w-sm-700px {\n    min-width: 700px !important;\n  }\n\n  .min-w-sm-750px {\n    min-width: 750px !important;\n  }\n\n  .min-w-sm-800px {\n    min-width: 800px !important;\n  }\n\n  .min-w-sm-850px {\n    min-width: 850px !important;\n  }\n\n  .min-w-sm-900px {\n    min-width: 900px !important;\n  }\n\n  .min-w-sm-950px {\n    min-width: 950px !important;\n  }\n\n  .min-w-sm-1000px {\n    min-width: 1000px !important;\n  }\n\n  .min-h-sm-unset {\n    min-height: unset !important;\n  }\n\n  .min-h-sm-25 {\n    min-height: 25% !important;\n  }\n\n  .min-h-sm-50 {\n    min-height: 50% !important;\n  }\n\n  .min-h-sm-75 {\n    min-height: 75% !important;\n  }\n\n  .min-h-sm-100 {\n    min-height: 100% !important;\n  }\n\n  .min-h-sm-auto {\n    min-height: auto !important;\n  }\n\n  .min-h-sm-1px {\n    min-height: 1px !important;\n  }\n\n  .min-h-sm-2px {\n    min-height: 2px !important;\n  }\n\n  .min-h-sm-3px {\n    min-height: 3px !important;\n  }\n\n  .min-h-sm-4px {\n    min-height: 4px !important;\n  }\n\n  .min-h-sm-5px {\n    min-height: 5px !important;\n  }\n\n  .min-h-sm-6px {\n    min-height: 6px !important;\n  }\n\n  .min-h-sm-7px {\n    min-height: 7px !important;\n  }\n\n  .min-h-sm-8px {\n    min-height: 8px !important;\n  }\n\n  .min-h-sm-9px {\n    min-height: 9px !important;\n  }\n\n  .min-h-sm-10px {\n    min-height: 10px !important;\n  }\n\n  .min-h-sm-15px {\n    min-height: 15px !important;\n  }\n\n  .min-h-sm-20px {\n    min-height: 20px !important;\n  }\n\n  .min-h-sm-25px {\n    min-height: 25px !important;\n  }\n\n  .min-h-sm-30px {\n    min-height: 30px !important;\n  }\n\n  .min-h-sm-35px {\n    min-height: 35px !important;\n  }\n\n  .min-h-sm-40px {\n    min-height: 40px !important;\n  }\n\n  .min-h-sm-45px {\n    min-height: 45px !important;\n  }\n\n  .min-h-sm-50px {\n    min-height: 50px !important;\n  }\n\n  .min-h-sm-55px {\n    min-height: 55px !important;\n  }\n\n  .min-h-sm-60px {\n    min-height: 60px !important;\n  }\n\n  .min-h-sm-65px {\n    min-height: 65px !important;\n  }\n\n  .min-h-sm-70px {\n    min-height: 70px !important;\n  }\n\n  .min-h-sm-75px {\n    min-height: 75px !important;\n  }\n\n  .min-h-sm-80px {\n    min-height: 80px !important;\n  }\n\n  .min-h-sm-85px {\n    min-height: 85px !important;\n  }\n\n  .min-h-sm-90px {\n    min-height: 90px !important;\n  }\n\n  .min-h-sm-95px {\n    min-height: 95px !important;\n  }\n\n  .min-h-sm-100px {\n    min-height: 100px !important;\n  }\n\n  .min-h-sm-125px {\n    min-height: 125px !important;\n  }\n\n  .min-h-sm-150px {\n    min-height: 150px !important;\n  }\n\n  .min-h-sm-175px {\n    min-height: 175px !important;\n  }\n\n  .min-h-sm-200px {\n    min-height: 200px !important;\n  }\n\n  .min-h-sm-225px {\n    min-height: 225px !important;\n  }\n\n  .min-h-sm-250px {\n    min-height: 250px !important;\n  }\n\n  .min-h-sm-275px {\n    min-height: 275px !important;\n  }\n\n  .min-h-sm-300px {\n    min-height: 300px !important;\n  }\n\n  .min-h-sm-325px {\n    min-height: 325px !important;\n  }\n\n  .min-h-sm-350px {\n    min-height: 350px !important;\n  }\n\n  .min-h-sm-375px {\n    min-height: 375px !important;\n  }\n\n  .min-h-sm-400px {\n    min-height: 400px !important;\n  }\n\n  .min-h-sm-425px {\n    min-height: 425px !important;\n  }\n\n  .min-h-sm-450px {\n    min-height: 450px !important;\n  }\n\n  .min-h-sm-475px {\n    min-height: 475px !important;\n  }\n\n  .min-h-sm-500px {\n    min-height: 500px !important;\n  }\n\n  .min-h-sm-550px {\n    min-height: 550px !important;\n  }\n\n  .min-h-sm-600px {\n    min-height: 600px !important;\n  }\n\n  .min-h-sm-650px {\n    min-height: 650px !important;\n  }\n\n  .min-h-sm-700px {\n    min-height: 700px !important;\n  }\n\n  .min-h-sm-750px {\n    min-height: 750px !important;\n  }\n\n  .min-h-sm-800px {\n    min-height: 800px !important;\n  }\n\n  .min-h-sm-850px {\n    min-height: 850px !important;\n  }\n\n  .min-h-sm-900px {\n    min-height: 900px !important;\n  }\n\n  .min-h-sm-950px {\n    min-height: 950px !important;\n  }\n\n  .min-h-sm-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 768px) {\n  .float-md-start {\n    float: left !important;\n  }\n\n  .float-md-end {\n    float: right !important;\n  }\n\n  .float-md-none {\n    float: none !important;\n  }\n\n  .d-md-inline {\n    display: inline !important;\n  }\n\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-md-block {\n    display: block !important;\n  }\n\n  .d-md-grid {\n    display: grid !important;\n  }\n\n  .d-md-table {\n    display: table !important;\n  }\n\n  .d-md-table-row {\n    display: table-row !important;\n  }\n\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-md-flex {\n    display: flex !important;\n  }\n\n  .d-md-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-md-none {\n    display: none !important;\n  }\n\n  .position-md-static {\n    position: static !important;\n  }\n\n  .position-md-relative {\n    position: relative !important;\n  }\n\n  .position-md-absolute {\n    position: absolute !important;\n  }\n\n  .position-md-fixed {\n    position: fixed !important;\n  }\n\n  .position-md-sticky {\n    position: sticky !important;\n  }\n\n  .w-md-unset {\n    width: unset !important;\n  }\n\n  .w-md-25 {\n    width: 25% !important;\n  }\n\n  .w-md-50 {\n    width: 50% !important;\n  }\n\n  .w-md-75 {\n    width: 75% !important;\n  }\n\n  .w-md-100 {\n    width: 100% !important;\n  }\n\n  .w-md-auto {\n    width: auto !important;\n  }\n\n  .w-md-1px {\n    width: 1px !important;\n  }\n\n  .w-md-2px {\n    width: 2px !important;\n  }\n\n  .w-md-3px {\n    width: 3px !important;\n  }\n\n  .w-md-4px {\n    width: 4px !important;\n  }\n\n  .w-md-5px {\n    width: 5px !important;\n  }\n\n  .w-md-6px {\n    width: 6px !important;\n  }\n\n  .w-md-7px {\n    width: 7px !important;\n  }\n\n  .w-md-8px {\n    width: 8px !important;\n  }\n\n  .w-md-9px {\n    width: 9px !important;\n  }\n\n  .w-md-10px {\n    width: 10px !important;\n  }\n\n  .w-md-15px {\n    width: 15px !important;\n  }\n\n  .w-md-20px {\n    width: 20px !important;\n  }\n\n  .w-md-25px {\n    width: 25px !important;\n  }\n\n  .w-md-30px {\n    width: 30px !important;\n  }\n\n  .w-md-35px {\n    width: 35px !important;\n  }\n\n  .w-md-40px {\n    width: 40px !important;\n  }\n\n  .w-md-45px {\n    width: 45px !important;\n  }\n\n  .w-md-50px {\n    width: 50px !important;\n  }\n\n  .w-md-55px {\n    width: 55px !important;\n  }\n\n  .w-md-60px {\n    width: 60px !important;\n  }\n\n  .w-md-65px {\n    width: 65px !important;\n  }\n\n  .w-md-70px {\n    width: 70px !important;\n  }\n\n  .w-md-75px {\n    width: 75px !important;\n  }\n\n  .w-md-80px {\n    width: 80px !important;\n  }\n\n  .w-md-85px {\n    width: 85px !important;\n  }\n\n  .w-md-90px {\n    width: 90px !important;\n  }\n\n  .w-md-95px {\n    width: 95px !important;\n  }\n\n  .w-md-100px {\n    width: 100px !important;\n  }\n\n  .w-md-125px {\n    width: 125px !important;\n  }\n\n  .w-md-150px {\n    width: 150px !important;\n  }\n\n  .w-md-175px {\n    width: 175px !important;\n  }\n\n  .w-md-200px {\n    width: 200px !important;\n  }\n\n  .w-md-225px {\n    width: 225px !important;\n  }\n\n  .w-md-250px {\n    width: 250px !important;\n  }\n\n  .w-md-275px {\n    width: 275px !important;\n  }\n\n  .w-md-300px {\n    width: 300px !important;\n  }\n\n  .w-md-325px {\n    width: 325px !important;\n  }\n\n  .w-md-350px {\n    width: 350px !important;\n  }\n\n  .w-md-375px {\n    width: 375px !important;\n  }\n\n  .w-md-400px {\n    width: 400px !important;\n  }\n\n  .w-md-425px {\n    width: 425px !important;\n  }\n\n  .w-md-450px {\n    width: 450px !important;\n  }\n\n  .w-md-475px {\n    width: 475px !important;\n  }\n\n  .w-md-500px {\n    width: 500px !important;\n  }\n\n  .w-md-550px {\n    width: 550px !important;\n  }\n\n  .w-md-600px {\n    width: 600px !important;\n  }\n\n  .w-md-650px {\n    width: 650px !important;\n  }\n\n  .w-md-700px {\n    width: 700px !important;\n  }\n\n  .w-md-750px {\n    width: 750px !important;\n  }\n\n  .w-md-800px {\n    width: 800px !important;\n  }\n\n  .w-md-850px {\n    width: 850px !important;\n  }\n\n  .w-md-900px {\n    width: 900px !important;\n  }\n\n  .w-md-950px {\n    width: 950px !important;\n  }\n\n  .w-md-1000px {\n    width: 1000px !important;\n  }\n\n  .mw-md-unset {\n    max-width: unset !important;\n  }\n\n  .mw-md-25 {\n    max-width: 25% !important;\n  }\n\n  .mw-md-50 {\n    max-width: 50% !important;\n  }\n\n  .mw-md-75 {\n    max-width: 75% !important;\n  }\n\n  .mw-md-100 {\n    max-width: 100% !important;\n  }\n\n  .mw-md-auto {\n    max-width: auto !important;\n  }\n\n  .mw-md-1px {\n    max-width: 1px !important;\n  }\n\n  .mw-md-2px {\n    max-width: 2px !important;\n  }\n\n  .mw-md-3px {\n    max-width: 3px !important;\n  }\n\n  .mw-md-4px {\n    max-width: 4px !important;\n  }\n\n  .mw-md-5px {\n    max-width: 5px !important;\n  }\n\n  .mw-md-6px {\n    max-width: 6px !important;\n  }\n\n  .mw-md-7px {\n    max-width: 7px !important;\n  }\n\n  .mw-md-8px {\n    max-width: 8px !important;\n  }\n\n  .mw-md-9px {\n    max-width: 9px !important;\n  }\n\n  .mw-md-10px {\n    max-width: 10px !important;\n  }\n\n  .mw-md-15px {\n    max-width: 15px !important;\n  }\n\n  .mw-md-20px {\n    max-width: 20px !important;\n  }\n\n  .mw-md-25px {\n    max-width: 25px !important;\n  }\n\n  .mw-md-30px {\n    max-width: 30px !important;\n  }\n\n  .mw-md-35px {\n    max-width: 35px !important;\n  }\n\n  .mw-md-40px {\n    max-width: 40px !important;\n  }\n\n  .mw-md-45px {\n    max-width: 45px !important;\n  }\n\n  .mw-md-50px {\n    max-width: 50px !important;\n  }\n\n  .mw-md-55px {\n    max-width: 55px !important;\n  }\n\n  .mw-md-60px {\n    max-width: 60px !important;\n  }\n\n  .mw-md-65px {\n    max-width: 65px !important;\n  }\n\n  .mw-md-70px {\n    max-width: 70px !important;\n  }\n\n  .mw-md-75px {\n    max-width: 75px !important;\n  }\n\n  .mw-md-80px {\n    max-width: 80px !important;\n  }\n\n  .mw-md-85px {\n    max-width: 85px !important;\n  }\n\n  .mw-md-90px {\n    max-width: 90px !important;\n  }\n\n  .mw-md-95px {\n    max-width: 95px !important;\n  }\n\n  .mw-md-100px {\n    max-width: 100px !important;\n  }\n\n  .mw-md-125px {\n    max-width: 125px !important;\n  }\n\n  .mw-md-150px {\n    max-width: 150px !important;\n  }\n\n  .mw-md-175px {\n    max-width: 175px !important;\n  }\n\n  .mw-md-200px {\n    max-width: 200px !important;\n  }\n\n  .mw-md-225px {\n    max-width: 225px !important;\n  }\n\n  .mw-md-250px {\n    max-width: 250px !important;\n  }\n\n  .mw-md-275px {\n    max-width: 275px !important;\n  }\n\n  .mw-md-300px {\n    max-width: 300px !important;\n  }\n\n  .mw-md-325px {\n    max-width: 325px !important;\n  }\n\n  .mw-md-350px {\n    max-width: 350px !important;\n  }\n\n  .mw-md-375px {\n    max-width: 375px !important;\n  }\n\n  .mw-md-400px {\n    max-width: 400px !important;\n  }\n\n  .mw-md-425px {\n    max-width: 425px !important;\n  }\n\n  .mw-md-450px {\n    max-width: 450px !important;\n  }\n\n  .mw-md-475px {\n    max-width: 475px !important;\n  }\n\n  .mw-md-500px {\n    max-width: 500px !important;\n  }\n\n  .mw-md-550px {\n    max-width: 550px !important;\n  }\n\n  .mw-md-600px {\n    max-width: 600px !important;\n  }\n\n  .mw-md-650px {\n    max-width: 650px !important;\n  }\n\n  .mw-md-700px {\n    max-width: 700px !important;\n  }\n\n  .mw-md-750px {\n    max-width: 750px !important;\n  }\n\n  .mw-md-800px {\n    max-width: 800px !important;\n  }\n\n  .mw-md-850px {\n    max-width: 850px !important;\n  }\n\n  .mw-md-900px {\n    max-width: 900px !important;\n  }\n\n  .mw-md-950px {\n    max-width: 950px !important;\n  }\n\n  .mw-md-1000px {\n    max-width: 1000px !important;\n  }\n\n  .h-md-unset {\n    height: unset !important;\n  }\n\n  .h-md-25 {\n    height: 25% !important;\n  }\n\n  .h-md-50 {\n    height: 50% !important;\n  }\n\n  .h-md-75 {\n    height: 75% !important;\n  }\n\n  .h-md-100 {\n    height: 100% !important;\n  }\n\n  .h-md-auto {\n    height: auto !important;\n  }\n\n  .h-md-1px {\n    height: 1px !important;\n  }\n\n  .h-md-2px {\n    height: 2px !important;\n  }\n\n  .h-md-3px {\n    height: 3px !important;\n  }\n\n  .h-md-4px {\n    height: 4px !important;\n  }\n\n  .h-md-5px {\n    height: 5px !important;\n  }\n\n  .h-md-6px {\n    height: 6px !important;\n  }\n\n  .h-md-7px {\n    height: 7px !important;\n  }\n\n  .h-md-8px {\n    height: 8px !important;\n  }\n\n  .h-md-9px {\n    height: 9px !important;\n  }\n\n  .h-md-10px {\n    height: 10px !important;\n  }\n\n  .h-md-15px {\n    height: 15px !important;\n  }\n\n  .h-md-20px {\n    height: 20px !important;\n  }\n\n  .h-md-25px {\n    height: 25px !important;\n  }\n\n  .h-md-30px {\n    height: 30px !important;\n  }\n\n  .h-md-35px {\n    height: 35px !important;\n  }\n\n  .h-md-40px {\n    height: 40px !important;\n  }\n\n  .h-md-45px {\n    height: 45px !important;\n  }\n\n  .h-md-50px {\n    height: 50px !important;\n  }\n\n  .h-md-55px {\n    height: 55px !important;\n  }\n\n  .h-md-60px {\n    height: 60px !important;\n  }\n\n  .h-md-65px {\n    height: 65px !important;\n  }\n\n  .h-md-70px {\n    height: 70px !important;\n  }\n\n  .h-md-75px {\n    height: 75px !important;\n  }\n\n  .h-md-80px {\n    height: 80px !important;\n  }\n\n  .h-md-85px {\n    height: 85px !important;\n  }\n\n  .h-md-90px {\n    height: 90px !important;\n  }\n\n  .h-md-95px {\n    height: 95px !important;\n  }\n\n  .h-md-100px {\n    height: 100px !important;\n  }\n\n  .h-md-125px {\n    height: 125px !important;\n  }\n\n  .h-md-150px {\n    height: 150px !important;\n  }\n\n  .h-md-175px {\n    height: 175px !important;\n  }\n\n  .h-md-200px {\n    height: 200px !important;\n  }\n\n  .h-md-225px {\n    height: 225px !important;\n  }\n\n  .h-md-250px {\n    height: 250px !important;\n  }\n\n  .h-md-275px {\n    height: 275px !important;\n  }\n\n  .h-md-300px {\n    height: 300px !important;\n  }\n\n  .h-md-325px {\n    height: 325px !important;\n  }\n\n  .h-md-350px {\n    height: 350px !important;\n  }\n\n  .h-md-375px {\n    height: 375px !important;\n  }\n\n  .h-md-400px {\n    height: 400px !important;\n  }\n\n  .h-md-425px {\n    height: 425px !important;\n  }\n\n  .h-md-450px {\n    height: 450px !important;\n  }\n\n  .h-md-475px {\n    height: 475px !important;\n  }\n\n  .h-md-500px {\n    height: 500px !important;\n  }\n\n  .h-md-550px {\n    height: 550px !important;\n  }\n\n  .h-md-600px {\n    height: 600px !important;\n  }\n\n  .h-md-650px {\n    height: 650px !important;\n  }\n\n  .h-md-700px {\n    height: 700px !important;\n  }\n\n  .h-md-750px {\n    height: 750px !important;\n  }\n\n  .h-md-800px {\n    height: 800px !important;\n  }\n\n  .h-md-850px {\n    height: 850px !important;\n  }\n\n  .h-md-900px {\n    height: 900px !important;\n  }\n\n  .h-md-950px {\n    height: 950px !important;\n  }\n\n  .h-md-1000px {\n    height: 1000px !important;\n  }\n\n  .mh-md-unset {\n    max-height: unset !important;\n  }\n\n  .mh-md-25 {\n    max-height: 25% !important;\n  }\n\n  .mh-md-50 {\n    max-height: 50% !important;\n  }\n\n  .mh-md-75 {\n    max-height: 75% !important;\n  }\n\n  .mh-md-100 {\n    max-height: 100% !important;\n  }\n\n  .mh-md-auto {\n    max-height: auto !important;\n  }\n\n  .mh-md-1px {\n    max-height: 1px !important;\n  }\n\n  .mh-md-2px {\n    max-height: 2px !important;\n  }\n\n  .mh-md-3px {\n    max-height: 3px !important;\n  }\n\n  .mh-md-4px {\n    max-height: 4px !important;\n  }\n\n  .mh-md-5px {\n    max-height: 5px !important;\n  }\n\n  .mh-md-6px {\n    max-height: 6px !important;\n  }\n\n  .mh-md-7px {\n    max-height: 7px !important;\n  }\n\n  .mh-md-8px {\n    max-height: 8px !important;\n  }\n\n  .mh-md-9px {\n    max-height: 9px !important;\n  }\n\n  .mh-md-10px {\n    max-height: 10px !important;\n  }\n\n  .mh-md-15px {\n    max-height: 15px !important;\n  }\n\n  .mh-md-20px {\n    max-height: 20px !important;\n  }\n\n  .mh-md-25px {\n    max-height: 25px !important;\n  }\n\n  .mh-md-30px {\n    max-height: 30px !important;\n  }\n\n  .mh-md-35px {\n    max-height: 35px !important;\n  }\n\n  .mh-md-40px {\n    max-height: 40px !important;\n  }\n\n  .mh-md-45px {\n    max-height: 45px !important;\n  }\n\n  .mh-md-50px {\n    max-height: 50px !important;\n  }\n\n  .mh-md-55px {\n    max-height: 55px !important;\n  }\n\n  .mh-md-60px {\n    max-height: 60px !important;\n  }\n\n  .mh-md-65px {\n    max-height: 65px !important;\n  }\n\n  .mh-md-70px {\n    max-height: 70px !important;\n  }\n\n  .mh-md-75px {\n    max-height: 75px !important;\n  }\n\n  .mh-md-80px {\n    max-height: 80px !important;\n  }\n\n  .mh-md-85px {\n    max-height: 85px !important;\n  }\n\n  .mh-md-90px {\n    max-height: 90px !important;\n  }\n\n  .mh-md-95px {\n    max-height: 95px !important;\n  }\n\n  .mh-md-100px {\n    max-height: 100px !important;\n  }\n\n  .mh-md-125px {\n    max-height: 125px !important;\n  }\n\n  .mh-md-150px {\n    max-height: 150px !important;\n  }\n\n  .mh-md-175px {\n    max-height: 175px !important;\n  }\n\n  .mh-md-200px {\n    max-height: 200px !important;\n  }\n\n  .mh-md-225px {\n    max-height: 225px !important;\n  }\n\n  .mh-md-250px {\n    max-height: 250px !important;\n  }\n\n  .mh-md-275px {\n    max-height: 275px !important;\n  }\n\n  .mh-md-300px {\n    max-height: 300px !important;\n  }\n\n  .mh-md-325px {\n    max-height: 325px !important;\n  }\n\n  .mh-md-350px {\n    max-height: 350px !important;\n  }\n\n  .mh-md-375px {\n    max-height: 375px !important;\n  }\n\n  .mh-md-400px {\n    max-height: 400px !important;\n  }\n\n  .mh-md-425px {\n    max-height: 425px !important;\n  }\n\n  .mh-md-450px {\n    max-height: 450px !important;\n  }\n\n  .mh-md-475px {\n    max-height: 475px !important;\n  }\n\n  .mh-md-500px {\n    max-height: 500px !important;\n  }\n\n  .mh-md-550px {\n    max-height: 550px !important;\n  }\n\n  .mh-md-600px {\n    max-height: 600px !important;\n  }\n\n  .mh-md-650px {\n    max-height: 650px !important;\n  }\n\n  .mh-md-700px {\n    max-height: 700px !important;\n  }\n\n  .mh-md-750px {\n    max-height: 750px !important;\n  }\n\n  .mh-md-800px {\n    max-height: 800px !important;\n  }\n\n  .mh-md-850px {\n    max-height: 850px !important;\n  }\n\n  .mh-md-900px {\n    max-height: 900px !important;\n  }\n\n  .mh-md-950px {\n    max-height: 950px !important;\n  }\n\n  .mh-md-1000px {\n    max-height: 1000px !important;\n  }\n\n  .flex-md-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-md-row {\n    flex-direction: row !important;\n  }\n\n  .flex-md-column {\n    flex-direction: column !important;\n  }\n\n  .flex-md-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-md-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-md-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-md-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-md-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-md-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-md-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-md-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-md-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-md-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-md-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-md-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-md-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-md-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-md-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-md-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-md-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-md-center {\n    align-items: center !important;\n  }\n\n  .align-items-md-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-md-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-md-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-md-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-md-center {\n    align-content: center !important;\n  }\n\n  .align-content-md-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-md-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-md-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-md-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-md-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-md-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-md-center {\n    align-self: center !important;\n  }\n\n  .align-self-md-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-md-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-md-first {\n    order: -1 !important;\n  }\n\n  .order-md-0 {\n    order: 0 !important;\n  }\n\n  .order-md-1 {\n    order: 1 !important;\n  }\n\n  .order-md-2 {\n    order: 2 !important;\n  }\n\n  .order-md-3 {\n    order: 3 !important;\n  }\n\n  .order-md-4 {\n    order: 4 !important;\n  }\n\n  .order-md-5 {\n    order: 5 !important;\n  }\n\n  .order-md-last {\n    order: 6 !important;\n  }\n\n  .m-md-0 {\n    margin: 0 !important;\n  }\n\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-md-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-md-4 {\n    margin: 1rem !important;\n  }\n\n  .m-md-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-md-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-md-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-md-8 {\n    margin: 2rem !important;\n  }\n\n  .m-md-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-md-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-md-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-md-12 {\n    margin: 3rem !important;\n  }\n\n  .m-md-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-md-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-md-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-md-16 {\n    margin: 4rem !important;\n  }\n\n  .m-md-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-md-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-md-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-md-20 {\n    margin: 5rem !important;\n  }\n\n  .m-md-auto {\n    margin: auto !important;\n  }\n\n  .mx-md-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-md-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-md-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-md-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-md-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-md-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-md-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-md-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-md-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-md-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-md-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-md-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-md-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-md-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-md-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-md-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-md-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-md-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-md-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-md-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-md-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-md-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-md-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-md-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-md-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-md-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-md-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-md-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-md-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-md-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-md-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-md-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-md-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-md-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-md-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-md-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-md-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-md-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-md-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-md-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-md-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-md-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-md-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-md-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-md-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-md-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-md-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-md-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-md-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-md-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-md-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-md-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-md-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-md-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-md-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-md-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-md-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-md-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-md-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-md-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-md-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-md-auto {\n    margin-top: auto !important;\n  }\n\n  .me-md-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-md-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-md-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-md-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-md-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-md-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-md-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-md-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-md-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-md-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-md-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-md-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-md-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-md-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-md-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-md-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-md-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-md-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-md-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-md-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-md-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-md-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-md-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-md-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-md-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-md-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-md-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-md-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-md-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-md-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-md-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-md-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-md-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-md-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-md-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-md-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-md-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-md-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-md-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-md-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-md-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-md-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-md-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-md-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-md-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-md-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-md-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-md-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-md-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-md-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-md-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-md-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-md-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-md-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-md-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-md-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-md-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-md-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-md-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-md-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-md-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-md-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-md-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-md-auto {\n    margin-left: auto !important;\n  }\n\n  .m-md-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-md-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-md-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-md-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-md-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-md-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-md-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-md-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-md-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-md-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-md-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-md-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-md-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-md-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-md-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-md-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-md-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-md-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-md-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-md-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-md-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-md-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-md-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-md-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-md-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-md-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-md-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-md-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-md-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-md-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-md-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-md-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-md-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-md-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-md-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-md-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-md-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-md-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-md-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-md-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-md-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-md-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-md-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-md-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-md-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-md-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-md-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-md-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-md-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-md-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-md-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-md-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-md-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-md-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-md-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-md-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-md-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-md-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-md-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-md-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-md-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-md-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-md-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-md-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-md-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-md-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-md-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-md-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-md-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-md-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-md-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-md-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-md-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-md-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-md-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-md-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-md-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-md-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-md-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-md-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-md-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-md-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-md-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-md-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-md-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-md-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-md-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-md-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-md-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-md-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-md-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-md-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-md-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-md-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-md-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-md-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-md-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-md-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-md-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-md-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-md-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-md-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-md-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-md-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-md-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-md-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-md-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-md-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-md-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-md-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-md-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-md-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-md-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-md-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-md-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-md-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-md-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-md-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-md-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-md-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-md-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-md-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-md-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-md-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-md-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-md-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-md-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-md-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-md-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-md-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-md-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-md-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-md-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-md-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-md-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-md-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-md-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-md-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-md-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-md-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-md-0 {\n    padding: 0 !important;\n  }\n\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-md-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-md-4 {\n    padding: 1rem !important;\n  }\n\n  .p-md-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-md-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-md-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-md-8 {\n    padding: 2rem !important;\n  }\n\n  .p-md-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-md-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-md-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-md-12 {\n    padding: 3rem !important;\n  }\n\n  .p-md-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-md-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-md-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-md-16 {\n    padding: 4rem !important;\n  }\n\n  .p-md-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-md-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-md-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-md-20 {\n    padding: 5rem !important;\n  }\n\n  .px-md-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-md-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-md-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-md-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-md-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-md-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-md-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-md-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-md-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-md-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-md-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-md-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-md-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-md-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-md-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-md-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-md-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-md-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-md-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-md-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-md-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-md-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-md-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-md-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-md-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-md-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-md-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-md-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-md-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-md-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-md-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-md-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-md-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-md-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-md-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-md-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-md-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-md-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-md-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-md-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-md-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-md-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-md-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-md-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-md-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-md-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-md-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-md-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-md-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-md-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-md-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-md-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-md-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-md-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-md-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-md-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-md-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-md-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-md-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-md-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-md-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-md-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-md-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-md-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-md-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-md-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-md-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-md-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-md-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-md-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-md-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-md-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-md-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-md-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-md-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-md-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-md-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-md-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-md-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-md-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-md-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-md-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-md-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-md-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-md-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-md-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-md-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-md-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-md-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-md-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-md-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-md-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-md-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-md-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-md-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-md-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-md-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-md-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-md-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-md-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-md-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-md-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-md-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-md-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-md-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-md-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-md-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-md-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-md-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-md-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-md-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-md-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-md-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-md-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-md-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-md-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-md-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-md-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-md-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-md-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-md-0 {\n    gap: 0 !important;\n  }\n\n  .gap-md-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-md-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-md-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-md-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-md-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-md-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-md-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-md-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-md-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-md-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-md-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-md-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-md-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-md-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-md-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-md-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-md-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-md-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-md-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-md-20 {\n    gap: 5rem !important;\n  }\n\n  .fs-md-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n\n  .fs-md-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n\n  .fs-md-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n\n  .fs-md-4 {\n    font-size: 1.25rem !important;\n  }\n\n  .fs-md-5 {\n    font-size: 1.15rem !important;\n  }\n\n  .fs-md-6 {\n    font-size: 1.075rem !important;\n  }\n\n  .fs-md-7 {\n    font-size: 0.95rem !important;\n  }\n\n  .fs-md-8 {\n    font-size: 0.85rem !important;\n  }\n\n  .fs-md-9 {\n    font-size: 0.75rem !important;\n  }\n\n  .fs-md-10 {\n    font-size: 0.5rem !important;\n  }\n\n  .fs-md-base {\n    font-size: 1rem !important;\n  }\n\n  .fs-md-fluid {\n    font-size: 100% !important;\n  }\n\n  .fs-md-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n\n  .fs-md-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n\n  .fs-md-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n\n  .fs-md-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n\n  .fs-md-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n\n  .fs-md-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n\n  .fs-md-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n\n  .fs-md-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n\n  .fs-md-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n\n  .fs-md-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n\n  .fs-md-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n\n  .fs-md-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n\n  .fs-md-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n\n  .fs-md-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n\n  .fs-md-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n\n  .fs-md-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n\n  .text-md-start {\n    text-align: left !important;\n  }\n\n  .text-md-end {\n    text-align: right !important;\n  }\n\n  .text-md-center {\n    text-align: center !important;\n  }\n\n  .min-w-md-unset {\n    min-width: unset !important;\n  }\n\n  .min-w-md-25 {\n    min-width: 25% !important;\n  }\n\n  .min-w-md-50 {\n    min-width: 50% !important;\n  }\n\n  .min-w-md-75 {\n    min-width: 75% !important;\n  }\n\n  .min-w-md-100 {\n    min-width: 100% !important;\n  }\n\n  .min-w-md-auto {\n    min-width: auto !important;\n  }\n\n  .min-w-md-1px {\n    min-width: 1px !important;\n  }\n\n  .min-w-md-2px {\n    min-width: 2px !important;\n  }\n\n  .min-w-md-3px {\n    min-width: 3px !important;\n  }\n\n  .min-w-md-4px {\n    min-width: 4px !important;\n  }\n\n  .min-w-md-5px {\n    min-width: 5px !important;\n  }\n\n  .min-w-md-6px {\n    min-width: 6px !important;\n  }\n\n  .min-w-md-7px {\n    min-width: 7px !important;\n  }\n\n  .min-w-md-8px {\n    min-width: 8px !important;\n  }\n\n  .min-w-md-9px {\n    min-width: 9px !important;\n  }\n\n  .min-w-md-10px {\n    min-width: 10px !important;\n  }\n\n  .min-w-md-15px {\n    min-width: 15px !important;\n  }\n\n  .min-w-md-20px {\n    min-width: 20px !important;\n  }\n\n  .min-w-md-25px {\n    min-width: 25px !important;\n  }\n\n  .min-w-md-30px {\n    min-width: 30px !important;\n  }\n\n  .min-w-md-35px {\n    min-width: 35px !important;\n  }\n\n  .min-w-md-40px {\n    min-width: 40px !important;\n  }\n\n  .min-w-md-45px {\n    min-width: 45px !important;\n  }\n\n  .min-w-md-50px {\n    min-width: 50px !important;\n  }\n\n  .min-w-md-55px {\n    min-width: 55px !important;\n  }\n\n  .min-w-md-60px {\n    min-width: 60px !important;\n  }\n\n  .min-w-md-65px {\n    min-width: 65px !important;\n  }\n\n  .min-w-md-70px {\n    min-width: 70px !important;\n  }\n\n  .min-w-md-75px {\n    min-width: 75px !important;\n  }\n\n  .min-w-md-80px {\n    min-width: 80px !important;\n  }\n\n  .min-w-md-85px {\n    min-width: 85px !important;\n  }\n\n  .min-w-md-90px {\n    min-width: 90px !important;\n  }\n\n  .min-w-md-95px {\n    min-width: 95px !important;\n  }\n\n  .min-w-md-100px {\n    min-width: 100px !important;\n  }\n\n  .min-w-md-125px {\n    min-width: 125px !important;\n  }\n\n  .min-w-md-150px {\n    min-width: 150px !important;\n  }\n\n  .min-w-md-175px {\n    min-width: 175px !important;\n  }\n\n  .min-w-md-200px {\n    min-width: 200px !important;\n  }\n\n  .min-w-md-225px {\n    min-width: 225px !important;\n  }\n\n  .min-w-md-250px {\n    min-width: 250px !important;\n  }\n\n  .min-w-md-275px {\n    min-width: 275px !important;\n  }\n\n  .min-w-md-300px {\n    min-width: 300px !important;\n  }\n\n  .min-w-md-325px {\n    min-width: 325px !important;\n  }\n\n  .min-w-md-350px {\n    min-width: 350px !important;\n  }\n\n  .min-w-md-375px {\n    min-width: 375px !important;\n  }\n\n  .min-w-md-400px {\n    min-width: 400px !important;\n  }\n\n  .min-w-md-425px {\n    min-width: 425px !important;\n  }\n\n  .min-w-md-450px {\n    min-width: 450px !important;\n  }\n\n  .min-w-md-475px {\n    min-width: 475px !important;\n  }\n\n  .min-w-md-500px {\n    min-width: 500px !important;\n  }\n\n  .min-w-md-550px {\n    min-width: 550px !important;\n  }\n\n  .min-w-md-600px {\n    min-width: 600px !important;\n  }\n\n  .min-w-md-650px {\n    min-width: 650px !important;\n  }\n\n  .min-w-md-700px {\n    min-width: 700px !important;\n  }\n\n  .min-w-md-750px {\n    min-width: 750px !important;\n  }\n\n  .min-w-md-800px {\n    min-width: 800px !important;\n  }\n\n  .min-w-md-850px {\n    min-width: 850px !important;\n  }\n\n  .min-w-md-900px {\n    min-width: 900px !important;\n  }\n\n  .min-w-md-950px {\n    min-width: 950px !important;\n  }\n\n  .min-w-md-1000px {\n    min-width: 1000px !important;\n  }\n\n  .min-h-md-unset {\n    min-height: unset !important;\n  }\n\n  .min-h-md-25 {\n    min-height: 25% !important;\n  }\n\n  .min-h-md-50 {\n    min-height: 50% !important;\n  }\n\n  .min-h-md-75 {\n    min-height: 75% !important;\n  }\n\n  .min-h-md-100 {\n    min-height: 100% !important;\n  }\n\n  .min-h-md-auto {\n    min-height: auto !important;\n  }\n\n  .min-h-md-1px {\n    min-height: 1px !important;\n  }\n\n  .min-h-md-2px {\n    min-height: 2px !important;\n  }\n\n  .min-h-md-3px {\n    min-height: 3px !important;\n  }\n\n  .min-h-md-4px {\n    min-height: 4px !important;\n  }\n\n  .min-h-md-5px {\n    min-height: 5px !important;\n  }\n\n  .min-h-md-6px {\n    min-height: 6px !important;\n  }\n\n  .min-h-md-7px {\n    min-height: 7px !important;\n  }\n\n  .min-h-md-8px {\n    min-height: 8px !important;\n  }\n\n  .min-h-md-9px {\n    min-height: 9px !important;\n  }\n\n  .min-h-md-10px {\n    min-height: 10px !important;\n  }\n\n  .min-h-md-15px {\n    min-height: 15px !important;\n  }\n\n  .min-h-md-20px {\n    min-height: 20px !important;\n  }\n\n  .min-h-md-25px {\n    min-height: 25px !important;\n  }\n\n  .min-h-md-30px {\n    min-height: 30px !important;\n  }\n\n  .min-h-md-35px {\n    min-height: 35px !important;\n  }\n\n  .min-h-md-40px {\n    min-height: 40px !important;\n  }\n\n  .min-h-md-45px {\n    min-height: 45px !important;\n  }\n\n  .min-h-md-50px {\n    min-height: 50px !important;\n  }\n\n  .min-h-md-55px {\n    min-height: 55px !important;\n  }\n\n  .min-h-md-60px {\n    min-height: 60px !important;\n  }\n\n  .min-h-md-65px {\n    min-height: 65px !important;\n  }\n\n  .min-h-md-70px {\n    min-height: 70px !important;\n  }\n\n  .min-h-md-75px {\n    min-height: 75px !important;\n  }\n\n  .min-h-md-80px {\n    min-height: 80px !important;\n  }\n\n  .min-h-md-85px {\n    min-height: 85px !important;\n  }\n\n  .min-h-md-90px {\n    min-height: 90px !important;\n  }\n\n  .min-h-md-95px {\n    min-height: 95px !important;\n  }\n\n  .min-h-md-100px {\n    min-height: 100px !important;\n  }\n\n  .min-h-md-125px {\n    min-height: 125px !important;\n  }\n\n  .min-h-md-150px {\n    min-height: 150px !important;\n  }\n\n  .min-h-md-175px {\n    min-height: 175px !important;\n  }\n\n  .min-h-md-200px {\n    min-height: 200px !important;\n  }\n\n  .min-h-md-225px {\n    min-height: 225px !important;\n  }\n\n  .min-h-md-250px {\n    min-height: 250px !important;\n  }\n\n  .min-h-md-275px {\n    min-height: 275px !important;\n  }\n\n  .min-h-md-300px {\n    min-height: 300px !important;\n  }\n\n  .min-h-md-325px {\n    min-height: 325px !important;\n  }\n\n  .min-h-md-350px {\n    min-height: 350px !important;\n  }\n\n  .min-h-md-375px {\n    min-height: 375px !important;\n  }\n\n  .min-h-md-400px {\n    min-height: 400px !important;\n  }\n\n  .min-h-md-425px {\n    min-height: 425px !important;\n  }\n\n  .min-h-md-450px {\n    min-height: 450px !important;\n  }\n\n  .min-h-md-475px {\n    min-height: 475px !important;\n  }\n\n  .min-h-md-500px {\n    min-height: 500px !important;\n  }\n\n  .min-h-md-550px {\n    min-height: 550px !important;\n  }\n\n  .min-h-md-600px {\n    min-height: 600px !important;\n  }\n\n  .min-h-md-650px {\n    min-height: 650px !important;\n  }\n\n  .min-h-md-700px {\n    min-height: 700px !important;\n  }\n\n  .min-h-md-750px {\n    min-height: 750px !important;\n  }\n\n  .min-h-md-800px {\n    min-height: 800px !important;\n  }\n\n  .min-h-md-850px {\n    min-height: 850px !important;\n  }\n\n  .min-h-md-900px {\n    min-height: 900px !important;\n  }\n\n  .min-h-md-950px {\n    min-height: 950px !important;\n  }\n\n  .min-h-md-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 992px) {\n  .float-lg-start {\n    float: left !important;\n  }\n\n  .float-lg-end {\n    float: right !important;\n  }\n\n  .float-lg-none {\n    float: none !important;\n  }\n\n  .d-lg-inline {\n    display: inline !important;\n  }\n\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-lg-block {\n    display: block !important;\n  }\n\n  .d-lg-grid {\n    display: grid !important;\n  }\n\n  .d-lg-table {\n    display: table !important;\n  }\n\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-lg-flex {\n    display: flex !important;\n  }\n\n  .d-lg-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-lg-none {\n    display: none !important;\n  }\n\n  .position-lg-static {\n    position: static !important;\n  }\n\n  .position-lg-relative {\n    position: relative !important;\n  }\n\n  .position-lg-absolute {\n    position: absolute !important;\n  }\n\n  .position-lg-fixed {\n    position: fixed !important;\n  }\n\n  .position-lg-sticky {\n    position: sticky !important;\n  }\n\n  .w-lg-unset {\n    width: unset !important;\n  }\n\n  .w-lg-25 {\n    width: 25% !important;\n  }\n\n  .w-lg-50 {\n    width: 50% !important;\n  }\n\n  .w-lg-75 {\n    width: 75% !important;\n  }\n\n  .w-lg-100 {\n    width: 100% !important;\n  }\n\n  .w-lg-auto {\n    width: auto !important;\n  }\n\n  .w-lg-1px {\n    width: 1px !important;\n  }\n\n  .w-lg-2px {\n    width: 2px !important;\n  }\n\n  .w-lg-3px {\n    width: 3px !important;\n  }\n\n  .w-lg-4px {\n    width: 4px !important;\n  }\n\n  .w-lg-5px {\n    width: 5px !important;\n  }\n\n  .w-lg-6px {\n    width: 6px !important;\n  }\n\n  .w-lg-7px {\n    width: 7px !important;\n  }\n\n  .w-lg-8px {\n    width: 8px !important;\n  }\n\n  .w-lg-9px {\n    width: 9px !important;\n  }\n\n  .w-lg-10px {\n    width: 10px !important;\n  }\n\n  .w-lg-15px {\n    width: 15px !important;\n  }\n\n  .w-lg-20px {\n    width: 20px !important;\n  }\n\n  .w-lg-25px {\n    width: 25px !important;\n  }\n\n  .w-lg-30px {\n    width: 30px !important;\n  }\n\n  .w-lg-35px {\n    width: 35px !important;\n  }\n\n  .w-lg-40px {\n    width: 40px !important;\n  }\n\n  .w-lg-45px {\n    width: 45px !important;\n  }\n\n  .w-lg-50px {\n    width: 50px !important;\n  }\n\n  .w-lg-55px {\n    width: 55px !important;\n  }\n\n  .w-lg-60px {\n    width: 60px !important;\n  }\n\n  .w-lg-65px {\n    width: 65px !important;\n  }\n\n  .w-lg-70px {\n    width: 70px !important;\n  }\n\n  .w-lg-75px {\n    width: 75px !important;\n  }\n\n  .w-lg-80px {\n    width: 80px !important;\n  }\n\n  .w-lg-85px {\n    width: 85px !important;\n  }\n\n  .w-lg-90px {\n    width: 90px !important;\n  }\n\n  .w-lg-95px {\n    width: 95px !important;\n  }\n\n  .w-lg-100px {\n    width: 100px !important;\n  }\n\n  .w-lg-125px {\n    width: 125px !important;\n  }\n\n  .w-lg-150px {\n    width: 150px !important;\n  }\n\n  .w-lg-175px {\n    width: 175px !important;\n  }\n\n  .w-lg-200px {\n    width: 200px !important;\n  }\n\n  .w-lg-225px {\n    width: 225px !important;\n  }\n\n  .w-lg-250px {\n    width: 250px !important;\n  }\n\n  .w-lg-275px {\n    width: 275px !important;\n  }\n\n  .w-lg-300px {\n    width: 300px !important;\n  }\n\n  .w-lg-325px {\n    width: 325px !important;\n  }\n\n  .w-lg-350px {\n    width: 350px !important;\n  }\n\n  .w-lg-375px {\n    width: 375px !important;\n  }\n\n  .w-lg-400px {\n    width: 400px !important;\n  }\n\n  .w-lg-425px {\n    width: 425px !important;\n  }\n\n  .w-lg-450px {\n    width: 450px !important;\n  }\n\n  .w-lg-475px {\n    width: 475px !important;\n  }\n\n  .w-lg-500px {\n    width: 500px !important;\n  }\n\n  .w-lg-550px {\n    width: 550px !important;\n  }\n\n  .w-lg-600px {\n    width: 600px !important;\n  }\n\n  .w-lg-650px {\n    width: 650px !important;\n  }\n\n  .w-lg-700px {\n    width: 700px !important;\n  }\n\n  .w-lg-750px {\n    width: 750px !important;\n  }\n\n  .w-lg-800px {\n    width: 800px !important;\n  }\n\n  .w-lg-850px {\n    width: 850px !important;\n  }\n\n  .w-lg-900px {\n    width: 900px !important;\n  }\n\n  .w-lg-950px {\n    width: 950px !important;\n  }\n\n  .w-lg-1000px {\n    width: 1000px !important;\n  }\n\n  .mw-lg-unset {\n    max-width: unset !important;\n  }\n\n  .mw-lg-25 {\n    max-width: 25% !important;\n  }\n\n  .mw-lg-50 {\n    max-width: 50% !important;\n  }\n\n  .mw-lg-75 {\n    max-width: 75% !important;\n  }\n\n  .mw-lg-100 {\n    max-width: 100% !important;\n  }\n\n  .mw-lg-auto {\n    max-width: auto !important;\n  }\n\n  .mw-lg-1px {\n    max-width: 1px !important;\n  }\n\n  .mw-lg-2px {\n    max-width: 2px !important;\n  }\n\n  .mw-lg-3px {\n    max-width: 3px !important;\n  }\n\n  .mw-lg-4px {\n    max-width: 4px !important;\n  }\n\n  .mw-lg-5px {\n    max-width: 5px !important;\n  }\n\n  .mw-lg-6px {\n    max-width: 6px !important;\n  }\n\n  .mw-lg-7px {\n    max-width: 7px !important;\n  }\n\n  .mw-lg-8px {\n    max-width: 8px !important;\n  }\n\n  .mw-lg-9px {\n    max-width: 9px !important;\n  }\n\n  .mw-lg-10px {\n    max-width: 10px !important;\n  }\n\n  .mw-lg-15px {\n    max-width: 15px !important;\n  }\n\n  .mw-lg-20px {\n    max-width: 20px !important;\n  }\n\n  .mw-lg-25px {\n    max-width: 25px !important;\n  }\n\n  .mw-lg-30px {\n    max-width: 30px !important;\n  }\n\n  .mw-lg-35px {\n    max-width: 35px !important;\n  }\n\n  .mw-lg-40px {\n    max-width: 40px !important;\n  }\n\n  .mw-lg-45px {\n    max-width: 45px !important;\n  }\n\n  .mw-lg-50px {\n    max-width: 50px !important;\n  }\n\n  .mw-lg-55px {\n    max-width: 55px !important;\n  }\n\n  .mw-lg-60px {\n    max-width: 60px !important;\n  }\n\n  .mw-lg-65px {\n    max-width: 65px !important;\n  }\n\n  .mw-lg-70px {\n    max-width: 70px !important;\n  }\n\n  .mw-lg-75px {\n    max-width: 75px !important;\n  }\n\n  .mw-lg-80px {\n    max-width: 80px !important;\n  }\n\n  .mw-lg-85px {\n    max-width: 85px !important;\n  }\n\n  .mw-lg-90px {\n    max-width: 90px !important;\n  }\n\n  .mw-lg-95px {\n    max-width: 95px !important;\n  }\n\n  .mw-lg-100px {\n    max-width: 100px !important;\n  }\n\n  .mw-lg-125px {\n    max-width: 125px !important;\n  }\n\n  .mw-lg-150px {\n    max-width: 150px !important;\n  }\n\n  .mw-lg-175px {\n    max-width: 175px !important;\n  }\n\n  .mw-lg-200px {\n    max-width: 200px !important;\n  }\n\n  .mw-lg-225px {\n    max-width: 225px !important;\n  }\n\n  .mw-lg-250px {\n    max-width: 250px !important;\n  }\n\n  .mw-lg-275px {\n    max-width: 275px !important;\n  }\n\n  .mw-lg-300px {\n    max-width: 300px !important;\n  }\n\n  .mw-lg-325px {\n    max-width: 325px !important;\n  }\n\n  .mw-lg-350px {\n    max-width: 350px !important;\n  }\n\n  .mw-lg-375px {\n    max-width: 375px !important;\n  }\n\n  .mw-lg-400px {\n    max-width: 400px !important;\n  }\n\n  .mw-lg-425px {\n    max-width: 425px !important;\n  }\n\n  .mw-lg-450px {\n    max-width: 450px !important;\n  }\n\n  .mw-lg-475px {\n    max-width: 475px !important;\n  }\n\n  .mw-lg-500px {\n    max-width: 500px !important;\n  }\n\n  .mw-lg-550px {\n    max-width: 550px !important;\n  }\n\n  .mw-lg-600px {\n    max-width: 600px !important;\n  }\n\n  .mw-lg-650px {\n    max-width: 650px !important;\n  }\n\n  .mw-lg-700px {\n    max-width: 700px !important;\n  }\n\n  .mw-lg-750px {\n    max-width: 750px !important;\n  }\n\n  .mw-lg-800px {\n    max-width: 800px !important;\n  }\n\n  .mw-lg-850px {\n    max-width: 850px !important;\n  }\n\n  .mw-lg-900px {\n    max-width: 900px !important;\n  }\n\n  .mw-lg-950px {\n    max-width: 950px !important;\n  }\n\n  .mw-lg-1000px {\n    max-width: 1000px !important;\n  }\n\n  .h-lg-unset {\n    height: unset !important;\n  }\n\n  .h-lg-25 {\n    height: 25% !important;\n  }\n\n  .h-lg-50 {\n    height: 50% !important;\n  }\n\n  .h-lg-75 {\n    height: 75% !important;\n  }\n\n  .h-lg-100 {\n    height: 100% !important;\n  }\n\n  .h-lg-auto {\n    height: auto !important;\n  }\n\n  .h-lg-1px {\n    height: 1px !important;\n  }\n\n  .h-lg-2px {\n    height: 2px !important;\n  }\n\n  .h-lg-3px {\n    height: 3px !important;\n  }\n\n  .h-lg-4px {\n    height: 4px !important;\n  }\n\n  .h-lg-5px {\n    height: 5px !important;\n  }\n\n  .h-lg-6px {\n    height: 6px !important;\n  }\n\n  .h-lg-7px {\n    height: 7px !important;\n  }\n\n  .h-lg-8px {\n    height: 8px !important;\n  }\n\n  .h-lg-9px {\n    height: 9px !important;\n  }\n\n  .h-lg-10px {\n    height: 10px !important;\n  }\n\n  .h-lg-15px {\n    height: 15px !important;\n  }\n\n  .h-lg-20px {\n    height: 20px !important;\n  }\n\n  .h-lg-25px {\n    height: 25px !important;\n  }\n\n  .h-lg-30px {\n    height: 30px !important;\n  }\n\n  .h-lg-35px {\n    height: 35px !important;\n  }\n\n  .h-lg-40px {\n    height: 40px !important;\n  }\n\n  .h-lg-45px {\n    height: 45px !important;\n  }\n\n  .h-lg-50px {\n    height: 50px !important;\n  }\n\n  .h-lg-55px {\n    height: 55px !important;\n  }\n\n  .h-lg-60px {\n    height: 60px !important;\n  }\n\n  .h-lg-65px {\n    height: 65px !important;\n  }\n\n  .h-lg-70px {\n    height: 70px !important;\n  }\n\n  .h-lg-75px {\n    height: 75px !important;\n  }\n\n  .h-lg-80px {\n    height: 80px !important;\n  }\n\n  .h-lg-85px {\n    height: 85px !important;\n  }\n\n  .h-lg-90px {\n    height: 90px !important;\n  }\n\n  .h-lg-95px {\n    height: 95px !important;\n  }\n\n  .h-lg-100px {\n    height: 100px !important;\n  }\n\n  .h-lg-125px {\n    height: 125px !important;\n  }\n\n  .h-lg-150px {\n    height: 150px !important;\n  }\n\n  .h-lg-175px {\n    height: 175px !important;\n  }\n\n  .h-lg-200px {\n    height: 200px !important;\n  }\n\n  .h-lg-225px {\n    height: 225px !important;\n  }\n\n  .h-lg-250px {\n    height: 250px !important;\n  }\n\n  .h-lg-275px {\n    height: 275px !important;\n  }\n\n  .h-lg-300px {\n    height: 300px !important;\n  }\n\n  .h-lg-325px {\n    height: 325px !important;\n  }\n\n  .h-lg-350px {\n    height: 350px !important;\n  }\n\n  .h-lg-375px {\n    height: 375px !important;\n  }\n\n  .h-lg-400px {\n    height: 400px !important;\n  }\n\n  .h-lg-425px {\n    height: 425px !important;\n  }\n\n  .h-lg-450px {\n    height: 450px !important;\n  }\n\n  .h-lg-475px {\n    height: 475px !important;\n  }\n\n  .h-lg-500px {\n    height: 500px !important;\n  }\n\n  .h-lg-550px {\n    height: 550px !important;\n  }\n\n  .h-lg-600px {\n    height: 600px !important;\n  }\n\n  .h-lg-650px {\n    height: 650px !important;\n  }\n\n  .h-lg-700px {\n    height: 700px !important;\n  }\n\n  .h-lg-750px {\n    height: 750px !important;\n  }\n\n  .h-lg-800px {\n    height: 800px !important;\n  }\n\n  .h-lg-850px {\n    height: 850px !important;\n  }\n\n  .h-lg-900px {\n    height: 900px !important;\n  }\n\n  .h-lg-950px {\n    height: 950px !important;\n  }\n\n  .h-lg-1000px {\n    height: 1000px !important;\n  }\n\n  .mh-lg-unset {\n    max-height: unset !important;\n  }\n\n  .mh-lg-25 {\n    max-height: 25% !important;\n  }\n\n  .mh-lg-50 {\n    max-height: 50% !important;\n  }\n\n  .mh-lg-75 {\n    max-height: 75% !important;\n  }\n\n  .mh-lg-100 {\n    max-height: 100% !important;\n  }\n\n  .mh-lg-auto {\n    max-height: auto !important;\n  }\n\n  .mh-lg-1px {\n    max-height: 1px !important;\n  }\n\n  .mh-lg-2px {\n    max-height: 2px !important;\n  }\n\n  .mh-lg-3px {\n    max-height: 3px !important;\n  }\n\n  .mh-lg-4px {\n    max-height: 4px !important;\n  }\n\n  .mh-lg-5px {\n    max-height: 5px !important;\n  }\n\n  .mh-lg-6px {\n    max-height: 6px !important;\n  }\n\n  .mh-lg-7px {\n    max-height: 7px !important;\n  }\n\n  .mh-lg-8px {\n    max-height: 8px !important;\n  }\n\n  .mh-lg-9px {\n    max-height: 9px !important;\n  }\n\n  .mh-lg-10px {\n    max-height: 10px !important;\n  }\n\n  .mh-lg-15px {\n    max-height: 15px !important;\n  }\n\n  .mh-lg-20px {\n    max-height: 20px !important;\n  }\n\n  .mh-lg-25px {\n    max-height: 25px !important;\n  }\n\n  .mh-lg-30px {\n    max-height: 30px !important;\n  }\n\n  .mh-lg-35px {\n    max-height: 35px !important;\n  }\n\n  .mh-lg-40px {\n    max-height: 40px !important;\n  }\n\n  .mh-lg-45px {\n    max-height: 45px !important;\n  }\n\n  .mh-lg-50px {\n    max-height: 50px !important;\n  }\n\n  .mh-lg-55px {\n    max-height: 55px !important;\n  }\n\n  .mh-lg-60px {\n    max-height: 60px !important;\n  }\n\n  .mh-lg-65px {\n    max-height: 65px !important;\n  }\n\n  .mh-lg-70px {\n    max-height: 70px !important;\n  }\n\n  .mh-lg-75px {\n    max-height: 75px !important;\n  }\n\n  .mh-lg-80px {\n    max-height: 80px !important;\n  }\n\n  .mh-lg-85px {\n    max-height: 85px !important;\n  }\n\n  .mh-lg-90px {\n    max-height: 90px !important;\n  }\n\n  .mh-lg-95px {\n    max-height: 95px !important;\n  }\n\n  .mh-lg-100px {\n    max-height: 100px !important;\n  }\n\n  .mh-lg-125px {\n    max-height: 125px !important;\n  }\n\n  .mh-lg-150px {\n    max-height: 150px !important;\n  }\n\n  .mh-lg-175px {\n    max-height: 175px !important;\n  }\n\n  .mh-lg-200px {\n    max-height: 200px !important;\n  }\n\n  .mh-lg-225px {\n    max-height: 225px !important;\n  }\n\n  .mh-lg-250px {\n    max-height: 250px !important;\n  }\n\n  .mh-lg-275px {\n    max-height: 275px !important;\n  }\n\n  .mh-lg-300px {\n    max-height: 300px !important;\n  }\n\n  .mh-lg-325px {\n    max-height: 325px !important;\n  }\n\n  .mh-lg-350px {\n    max-height: 350px !important;\n  }\n\n  .mh-lg-375px {\n    max-height: 375px !important;\n  }\n\n  .mh-lg-400px {\n    max-height: 400px !important;\n  }\n\n  .mh-lg-425px {\n    max-height: 425px !important;\n  }\n\n  .mh-lg-450px {\n    max-height: 450px !important;\n  }\n\n  .mh-lg-475px {\n    max-height: 475px !important;\n  }\n\n  .mh-lg-500px {\n    max-height: 500px !important;\n  }\n\n  .mh-lg-550px {\n    max-height: 550px !important;\n  }\n\n  .mh-lg-600px {\n    max-height: 600px !important;\n  }\n\n  .mh-lg-650px {\n    max-height: 650px !important;\n  }\n\n  .mh-lg-700px {\n    max-height: 700px !important;\n  }\n\n  .mh-lg-750px {\n    max-height: 750px !important;\n  }\n\n  .mh-lg-800px {\n    max-height: 800px !important;\n  }\n\n  .mh-lg-850px {\n    max-height: 850px !important;\n  }\n\n  .mh-lg-900px {\n    max-height: 900px !important;\n  }\n\n  .mh-lg-950px {\n    max-height: 950px !important;\n  }\n\n  .mh-lg-1000px {\n    max-height: 1000px !important;\n  }\n\n  .flex-lg-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-lg-row {\n    flex-direction: row !important;\n  }\n\n  .flex-lg-column {\n    flex-direction: column !important;\n  }\n\n  .flex-lg-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-lg-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-lg-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-lg-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-lg-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-lg-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-lg-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-lg-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-lg-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-lg-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-lg-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-lg-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-lg-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-lg-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-lg-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-lg-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-lg-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-lg-center {\n    align-items: center !important;\n  }\n\n  .align-items-lg-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-lg-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-lg-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-lg-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-lg-center {\n    align-content: center !important;\n  }\n\n  .align-content-lg-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-lg-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-lg-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-lg-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-lg-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-lg-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-lg-center {\n    align-self: center !important;\n  }\n\n  .align-self-lg-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-lg-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-lg-first {\n    order: -1 !important;\n  }\n\n  .order-lg-0 {\n    order: 0 !important;\n  }\n\n  .order-lg-1 {\n    order: 1 !important;\n  }\n\n  .order-lg-2 {\n    order: 2 !important;\n  }\n\n  .order-lg-3 {\n    order: 3 !important;\n  }\n\n  .order-lg-4 {\n    order: 4 !important;\n  }\n\n  .order-lg-5 {\n    order: 5 !important;\n  }\n\n  .order-lg-last {\n    order: 6 !important;\n  }\n\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-lg-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-lg-4 {\n    margin: 1rem !important;\n  }\n\n  .m-lg-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-lg-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-lg-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-lg-8 {\n    margin: 2rem !important;\n  }\n\n  .m-lg-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-lg-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-lg-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-lg-12 {\n    margin: 3rem !important;\n  }\n\n  .m-lg-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-lg-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-lg-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-lg-16 {\n    margin: 4rem !important;\n  }\n\n  .m-lg-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-lg-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-lg-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-lg-20 {\n    margin: 5rem !important;\n  }\n\n  .m-lg-auto {\n    margin: auto !important;\n  }\n\n  .mx-lg-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-lg-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-lg-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-lg-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-lg-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-lg-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-lg-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-lg-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-lg-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-lg-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-lg-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-lg-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-lg-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-lg-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-lg-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-lg-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-lg-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-lg-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-lg-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-lg-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-lg-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-lg-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-lg-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-lg-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-lg-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-lg-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-lg-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-lg-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-lg-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-lg-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-lg-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-lg-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-lg-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-lg-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-lg-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-lg-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-lg-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-lg-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-lg-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-lg-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-lg-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-lg-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-lg-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-lg-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-lg-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-lg-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-lg-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-lg-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-lg-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-lg-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-lg-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-lg-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-lg-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-lg-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-lg-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-lg-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-lg-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-lg-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-lg-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-lg-auto {\n    margin-top: auto !important;\n  }\n\n  .me-lg-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-lg-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-lg-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-lg-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-lg-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-lg-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-lg-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-lg-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-lg-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-lg-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-lg-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-lg-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-lg-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-lg-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-lg-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-lg-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-lg-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-lg-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-lg-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-lg-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-lg-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-lg-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-lg-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-lg-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-lg-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-lg-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-lg-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-lg-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-lg-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-lg-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-lg-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-lg-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-lg-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-lg-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-lg-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-lg-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-lg-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-lg-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-lg-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-lg-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-lg-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-lg-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-lg-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-lg-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-lg-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-lg-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-lg-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-lg-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-lg-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-lg-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-lg-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-lg-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-lg-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-lg-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-lg-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-lg-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-lg-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-lg-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-lg-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-lg-auto {\n    margin-left: auto !important;\n  }\n\n  .m-lg-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-lg-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-lg-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-lg-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-lg-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-lg-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-lg-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-lg-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-lg-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-lg-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-lg-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-lg-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-lg-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-lg-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-lg-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-lg-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-lg-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-lg-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-lg-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-lg-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-lg-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-lg-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-lg-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-lg-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-lg-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-lg-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-lg-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-lg-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-lg-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-lg-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-lg-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-lg-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-lg-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-lg-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-lg-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-lg-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-lg-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-lg-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-lg-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-lg-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-lg-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-lg-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-lg-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-lg-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-lg-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-lg-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-lg-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-lg-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-lg-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-lg-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-lg-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-lg-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-lg-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-lg-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-lg-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-lg-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-lg-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-lg-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-lg-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-lg-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-lg-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-lg-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-lg-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-lg-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-lg-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-lg-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-lg-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-lg-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-lg-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-lg-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-lg-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-lg-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-lg-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-lg-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-lg-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-lg-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-lg-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-lg-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-lg-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-lg-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-lg-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-lg-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-lg-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-lg-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-lg-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-lg-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-lg-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-lg-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-lg-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-lg-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-lg-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-lg-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-lg-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-lg-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-lg-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-lg-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-lg-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-lg-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-lg-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-lg-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-lg-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-lg-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-lg-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-lg-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-lg-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-lg-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-lg-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-lg-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-lg-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-lg-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-lg-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-lg-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-lg-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-lg-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-lg-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-lg-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-lg-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-lg-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-lg-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-lg-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-lg-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-lg-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-lg-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-lg-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-lg-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-lg-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-lg-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-lg-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-lg-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-lg-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-lg-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-lg-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-lg-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-lg-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-lg-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-lg-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-lg-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-lg-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-lg-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-lg-4 {\n    padding: 1rem !important;\n  }\n\n  .p-lg-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-lg-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-lg-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-lg-8 {\n    padding: 2rem !important;\n  }\n\n  .p-lg-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-lg-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-lg-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-lg-12 {\n    padding: 3rem !important;\n  }\n\n  .p-lg-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-lg-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-lg-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-lg-16 {\n    padding: 4rem !important;\n  }\n\n  .p-lg-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-lg-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-lg-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-lg-20 {\n    padding: 5rem !important;\n  }\n\n  .px-lg-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-lg-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-lg-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-lg-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-lg-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-lg-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-lg-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-lg-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-lg-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-lg-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-lg-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-lg-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-lg-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-lg-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-lg-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-lg-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-lg-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-lg-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-lg-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-lg-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-lg-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-lg-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-lg-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-lg-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-lg-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-lg-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-lg-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-lg-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-lg-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-lg-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-lg-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-lg-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-lg-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-lg-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-lg-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-lg-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-lg-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-lg-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-lg-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-lg-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-lg-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-lg-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-lg-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-lg-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-lg-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-lg-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-lg-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-lg-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-lg-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-lg-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-lg-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-lg-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-lg-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-lg-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-lg-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-lg-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-lg-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-lg-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-lg-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-lg-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-lg-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-lg-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-lg-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-lg-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-lg-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-lg-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-lg-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-lg-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-lg-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-lg-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-lg-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-lg-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-lg-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-lg-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-lg-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-lg-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-lg-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-lg-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-lg-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-lg-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-lg-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-lg-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-lg-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-lg-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-lg-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-lg-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-lg-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-lg-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-lg-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-lg-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-lg-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-lg-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-lg-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-lg-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-lg-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-lg-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-lg-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-lg-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-lg-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-lg-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-lg-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-lg-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-lg-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-lg-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-lg-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-lg-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-lg-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-lg-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-lg-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-lg-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-lg-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-lg-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-lg-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-lg-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-lg-0 {\n    gap: 0 !important;\n  }\n\n  .gap-lg-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-lg-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-lg-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-lg-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-lg-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-lg-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-lg-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-lg-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-lg-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-lg-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-lg-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-lg-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-lg-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-lg-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-lg-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-lg-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-lg-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-lg-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-lg-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-lg-20 {\n    gap: 5rem !important;\n  }\n\n  .fs-lg-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n\n  .fs-lg-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n\n  .fs-lg-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n\n  .fs-lg-4 {\n    font-size: 1.25rem !important;\n  }\n\n  .fs-lg-5 {\n    font-size: 1.15rem !important;\n  }\n\n  .fs-lg-6 {\n    font-size: 1.075rem !important;\n  }\n\n  .fs-lg-7 {\n    font-size: 0.95rem !important;\n  }\n\n  .fs-lg-8 {\n    font-size: 0.85rem !important;\n  }\n\n  .fs-lg-9 {\n    font-size: 0.75rem !important;\n  }\n\n  .fs-lg-10 {\n    font-size: 0.5rem !important;\n  }\n\n  .fs-lg-base {\n    font-size: 1rem !important;\n  }\n\n  .fs-lg-fluid {\n    font-size: 100% !important;\n  }\n\n  .fs-lg-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n\n  .fs-lg-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n\n  .fs-lg-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n\n  .fs-lg-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n\n  .fs-lg-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n\n  .fs-lg-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n\n  .fs-lg-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n\n  .fs-lg-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n\n  .fs-lg-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n\n  .fs-lg-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n\n  .fs-lg-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n\n  .fs-lg-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n\n  .fs-lg-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n\n  .fs-lg-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n\n  .fs-lg-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n\n  .fs-lg-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n\n  .text-lg-start {\n    text-align: left !important;\n  }\n\n  .text-lg-end {\n    text-align: right !important;\n  }\n\n  .text-lg-center {\n    text-align: center !important;\n  }\n\n  .min-w-lg-unset {\n    min-width: unset !important;\n  }\n\n  .min-w-lg-25 {\n    min-width: 25% !important;\n  }\n\n  .min-w-lg-50 {\n    min-width: 50% !important;\n  }\n\n  .min-w-lg-75 {\n    min-width: 75% !important;\n  }\n\n  .min-w-lg-100 {\n    min-width: 100% !important;\n  }\n\n  .min-w-lg-auto {\n    min-width: auto !important;\n  }\n\n  .min-w-lg-1px {\n    min-width: 1px !important;\n  }\n\n  .min-w-lg-2px {\n    min-width: 2px !important;\n  }\n\n  .min-w-lg-3px {\n    min-width: 3px !important;\n  }\n\n  .min-w-lg-4px {\n    min-width: 4px !important;\n  }\n\n  .min-w-lg-5px {\n    min-width: 5px !important;\n  }\n\n  .min-w-lg-6px {\n    min-width: 6px !important;\n  }\n\n  .min-w-lg-7px {\n    min-width: 7px !important;\n  }\n\n  .min-w-lg-8px {\n    min-width: 8px !important;\n  }\n\n  .min-w-lg-9px {\n    min-width: 9px !important;\n  }\n\n  .min-w-lg-10px {\n    min-width: 10px !important;\n  }\n\n  .min-w-lg-15px {\n    min-width: 15px !important;\n  }\n\n  .min-w-lg-20px {\n    min-width: 20px !important;\n  }\n\n  .min-w-lg-25px {\n    min-width: 25px !important;\n  }\n\n  .min-w-lg-30px {\n    min-width: 30px !important;\n  }\n\n  .min-w-lg-35px {\n    min-width: 35px !important;\n  }\n\n  .min-w-lg-40px {\n    min-width: 40px !important;\n  }\n\n  .min-w-lg-45px {\n    min-width: 45px !important;\n  }\n\n  .min-w-lg-50px {\n    min-width: 50px !important;\n  }\n\n  .min-w-lg-55px {\n    min-width: 55px !important;\n  }\n\n  .min-w-lg-60px {\n    min-width: 60px !important;\n  }\n\n  .min-w-lg-65px {\n    min-width: 65px !important;\n  }\n\n  .min-w-lg-70px {\n    min-width: 70px !important;\n  }\n\n  .min-w-lg-75px {\n    min-width: 75px !important;\n  }\n\n  .min-w-lg-80px {\n    min-width: 80px !important;\n  }\n\n  .min-w-lg-85px {\n    min-width: 85px !important;\n  }\n\n  .min-w-lg-90px {\n    min-width: 90px !important;\n  }\n\n  .min-w-lg-95px {\n    min-width: 95px !important;\n  }\n\n  .min-w-lg-100px {\n    min-width: 100px !important;\n  }\n\n  .min-w-lg-125px {\n    min-width: 125px !important;\n  }\n\n  .min-w-lg-150px {\n    min-width: 150px !important;\n  }\n\n  .min-w-lg-175px {\n    min-width: 175px !important;\n  }\n\n  .min-w-lg-200px {\n    min-width: 200px !important;\n  }\n\n  .min-w-lg-225px {\n    min-width: 225px !important;\n  }\n\n  .min-w-lg-250px {\n    min-width: 250px !important;\n  }\n\n  .min-w-lg-275px {\n    min-width: 275px !important;\n  }\n\n  .min-w-lg-300px {\n    min-width: 300px !important;\n  }\n\n  .min-w-lg-325px {\n    min-width: 325px !important;\n  }\n\n  .min-w-lg-350px {\n    min-width: 350px !important;\n  }\n\n  .min-w-lg-375px {\n    min-width: 375px !important;\n  }\n\n  .min-w-lg-400px {\n    min-width: 400px !important;\n  }\n\n  .min-w-lg-425px {\n    min-width: 425px !important;\n  }\n\n  .min-w-lg-450px {\n    min-width: 450px !important;\n  }\n\n  .min-w-lg-475px {\n    min-width: 475px !important;\n  }\n\n  .min-w-lg-500px {\n    min-width: 500px !important;\n  }\n\n  .min-w-lg-550px {\n    min-width: 550px !important;\n  }\n\n  .min-w-lg-600px {\n    min-width: 600px !important;\n  }\n\n  .min-w-lg-650px {\n    min-width: 650px !important;\n  }\n\n  .min-w-lg-700px {\n    min-width: 700px !important;\n  }\n\n  .min-w-lg-750px {\n    min-width: 750px !important;\n  }\n\n  .min-w-lg-800px {\n    min-width: 800px !important;\n  }\n\n  .min-w-lg-850px {\n    min-width: 850px !important;\n  }\n\n  .min-w-lg-900px {\n    min-width: 900px !important;\n  }\n\n  .min-w-lg-950px {\n    min-width: 950px !important;\n  }\n\n  .min-w-lg-1000px {\n    min-width: 1000px !important;\n  }\n\n  .min-h-lg-unset {\n    min-height: unset !important;\n  }\n\n  .min-h-lg-25 {\n    min-height: 25% !important;\n  }\n\n  .min-h-lg-50 {\n    min-height: 50% !important;\n  }\n\n  .min-h-lg-75 {\n    min-height: 75% !important;\n  }\n\n  .min-h-lg-100 {\n    min-height: 100% !important;\n  }\n\n  .min-h-lg-auto {\n    min-height: auto !important;\n  }\n\n  .min-h-lg-1px {\n    min-height: 1px !important;\n  }\n\n  .min-h-lg-2px {\n    min-height: 2px !important;\n  }\n\n  .min-h-lg-3px {\n    min-height: 3px !important;\n  }\n\n  .min-h-lg-4px {\n    min-height: 4px !important;\n  }\n\n  .min-h-lg-5px {\n    min-height: 5px !important;\n  }\n\n  .min-h-lg-6px {\n    min-height: 6px !important;\n  }\n\n  .min-h-lg-7px {\n    min-height: 7px !important;\n  }\n\n  .min-h-lg-8px {\n    min-height: 8px !important;\n  }\n\n  .min-h-lg-9px {\n    min-height: 9px !important;\n  }\n\n  .min-h-lg-10px {\n    min-height: 10px !important;\n  }\n\n  .min-h-lg-15px {\n    min-height: 15px !important;\n  }\n\n  .min-h-lg-20px {\n    min-height: 20px !important;\n  }\n\n  .min-h-lg-25px {\n    min-height: 25px !important;\n  }\n\n  .min-h-lg-30px {\n    min-height: 30px !important;\n  }\n\n  .min-h-lg-35px {\n    min-height: 35px !important;\n  }\n\n  .min-h-lg-40px {\n    min-height: 40px !important;\n  }\n\n  .min-h-lg-45px {\n    min-height: 45px !important;\n  }\n\n  .min-h-lg-50px {\n    min-height: 50px !important;\n  }\n\n  .min-h-lg-55px {\n    min-height: 55px !important;\n  }\n\n  .min-h-lg-60px {\n    min-height: 60px !important;\n  }\n\n  .min-h-lg-65px {\n    min-height: 65px !important;\n  }\n\n  .min-h-lg-70px {\n    min-height: 70px !important;\n  }\n\n  .min-h-lg-75px {\n    min-height: 75px !important;\n  }\n\n  .min-h-lg-80px {\n    min-height: 80px !important;\n  }\n\n  .min-h-lg-85px {\n    min-height: 85px !important;\n  }\n\n  .min-h-lg-90px {\n    min-height: 90px !important;\n  }\n\n  .min-h-lg-95px {\n    min-height: 95px !important;\n  }\n\n  .min-h-lg-100px {\n    min-height: 100px !important;\n  }\n\n  .min-h-lg-125px {\n    min-height: 125px !important;\n  }\n\n  .min-h-lg-150px {\n    min-height: 150px !important;\n  }\n\n  .min-h-lg-175px {\n    min-height: 175px !important;\n  }\n\n  .min-h-lg-200px {\n    min-height: 200px !important;\n  }\n\n  .min-h-lg-225px {\n    min-height: 225px !important;\n  }\n\n  .min-h-lg-250px {\n    min-height: 250px !important;\n  }\n\n  .min-h-lg-275px {\n    min-height: 275px !important;\n  }\n\n  .min-h-lg-300px {\n    min-height: 300px !important;\n  }\n\n  .min-h-lg-325px {\n    min-height: 325px !important;\n  }\n\n  .min-h-lg-350px {\n    min-height: 350px !important;\n  }\n\n  .min-h-lg-375px {\n    min-height: 375px !important;\n  }\n\n  .min-h-lg-400px {\n    min-height: 400px !important;\n  }\n\n  .min-h-lg-425px {\n    min-height: 425px !important;\n  }\n\n  .min-h-lg-450px {\n    min-height: 450px !important;\n  }\n\n  .min-h-lg-475px {\n    min-height: 475px !important;\n  }\n\n  .min-h-lg-500px {\n    min-height: 500px !important;\n  }\n\n  .min-h-lg-550px {\n    min-height: 550px !important;\n  }\n\n  .min-h-lg-600px {\n    min-height: 600px !important;\n  }\n\n  .min-h-lg-650px {\n    min-height: 650px !important;\n  }\n\n  .min-h-lg-700px {\n    min-height: 700px !important;\n  }\n\n  .min-h-lg-750px {\n    min-height: 750px !important;\n  }\n\n  .min-h-lg-800px {\n    min-height: 800px !important;\n  }\n\n  .min-h-lg-850px {\n    min-height: 850px !important;\n  }\n\n  .min-h-lg-900px {\n    min-height: 900px !important;\n  }\n\n  .min-h-lg-950px {\n    min-height: 950px !important;\n  }\n\n  .min-h-lg-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 1200px) {\n  .float-xl-start {\n    float: left !important;\n  }\n\n  .float-xl-end {\n    float: right !important;\n  }\n\n  .float-xl-none {\n    float: none !important;\n  }\n\n  .d-xl-inline {\n    display: inline !important;\n  }\n\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xl-block {\n    display: block !important;\n  }\n\n  .d-xl-grid {\n    display: grid !important;\n  }\n\n  .d-xl-table {\n    display: table !important;\n  }\n\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xl-flex {\n    display: flex !important;\n  }\n\n  .d-xl-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-xl-none {\n    display: none !important;\n  }\n\n  .position-xl-static {\n    position: static !important;\n  }\n\n  .position-xl-relative {\n    position: relative !important;\n  }\n\n  .position-xl-absolute {\n    position: absolute !important;\n  }\n\n  .position-xl-fixed {\n    position: fixed !important;\n  }\n\n  .position-xl-sticky {\n    position: sticky !important;\n  }\n\n  .w-xl-unset {\n    width: unset !important;\n  }\n\n  .w-xl-25 {\n    width: 25% !important;\n  }\n\n  .w-xl-50 {\n    width: 50% !important;\n  }\n\n  .w-xl-75 {\n    width: 75% !important;\n  }\n\n  .w-xl-100 {\n    width: 100% !important;\n  }\n\n  .w-xl-auto {\n    width: auto !important;\n  }\n\n  .w-xl-1px {\n    width: 1px !important;\n  }\n\n  .w-xl-2px {\n    width: 2px !important;\n  }\n\n  .w-xl-3px {\n    width: 3px !important;\n  }\n\n  .w-xl-4px {\n    width: 4px !important;\n  }\n\n  .w-xl-5px {\n    width: 5px !important;\n  }\n\n  .w-xl-6px {\n    width: 6px !important;\n  }\n\n  .w-xl-7px {\n    width: 7px !important;\n  }\n\n  .w-xl-8px {\n    width: 8px !important;\n  }\n\n  .w-xl-9px {\n    width: 9px !important;\n  }\n\n  .w-xl-10px {\n    width: 10px !important;\n  }\n\n  .w-xl-15px {\n    width: 15px !important;\n  }\n\n  .w-xl-20px {\n    width: 20px !important;\n  }\n\n  .w-xl-25px {\n    width: 25px !important;\n  }\n\n  .w-xl-30px {\n    width: 30px !important;\n  }\n\n  .w-xl-35px {\n    width: 35px !important;\n  }\n\n  .w-xl-40px {\n    width: 40px !important;\n  }\n\n  .w-xl-45px {\n    width: 45px !important;\n  }\n\n  .w-xl-50px {\n    width: 50px !important;\n  }\n\n  .w-xl-55px {\n    width: 55px !important;\n  }\n\n  .w-xl-60px {\n    width: 60px !important;\n  }\n\n  .w-xl-65px {\n    width: 65px !important;\n  }\n\n  .w-xl-70px {\n    width: 70px !important;\n  }\n\n  .w-xl-75px {\n    width: 75px !important;\n  }\n\n  .w-xl-80px {\n    width: 80px !important;\n  }\n\n  .w-xl-85px {\n    width: 85px !important;\n  }\n\n  .w-xl-90px {\n    width: 90px !important;\n  }\n\n  .w-xl-95px {\n    width: 95px !important;\n  }\n\n  .w-xl-100px {\n    width: 100px !important;\n  }\n\n  .w-xl-125px {\n    width: 125px !important;\n  }\n\n  .w-xl-150px {\n    width: 150px !important;\n  }\n\n  .w-xl-175px {\n    width: 175px !important;\n  }\n\n  .w-xl-200px {\n    width: 200px !important;\n  }\n\n  .w-xl-225px {\n    width: 225px !important;\n  }\n\n  .w-xl-250px {\n    width: 250px !important;\n  }\n\n  .w-xl-275px {\n    width: 275px !important;\n  }\n\n  .w-xl-300px {\n    width: 300px !important;\n  }\n\n  .w-xl-325px {\n    width: 325px !important;\n  }\n\n  .w-xl-350px {\n    width: 350px !important;\n  }\n\n  .w-xl-375px {\n    width: 375px !important;\n  }\n\n  .w-xl-400px {\n    width: 400px !important;\n  }\n\n  .w-xl-425px {\n    width: 425px !important;\n  }\n\n  .w-xl-450px {\n    width: 450px !important;\n  }\n\n  .w-xl-475px {\n    width: 475px !important;\n  }\n\n  .w-xl-500px {\n    width: 500px !important;\n  }\n\n  .w-xl-550px {\n    width: 550px !important;\n  }\n\n  .w-xl-600px {\n    width: 600px !important;\n  }\n\n  .w-xl-650px {\n    width: 650px !important;\n  }\n\n  .w-xl-700px {\n    width: 700px !important;\n  }\n\n  .w-xl-750px {\n    width: 750px !important;\n  }\n\n  .w-xl-800px {\n    width: 800px !important;\n  }\n\n  .w-xl-850px {\n    width: 850px !important;\n  }\n\n  .w-xl-900px {\n    width: 900px !important;\n  }\n\n  .w-xl-950px {\n    width: 950px !important;\n  }\n\n  .w-xl-1000px {\n    width: 1000px !important;\n  }\n\n  .mw-xl-unset {\n    max-width: unset !important;\n  }\n\n  .mw-xl-25 {\n    max-width: 25% !important;\n  }\n\n  .mw-xl-50 {\n    max-width: 50% !important;\n  }\n\n  .mw-xl-75 {\n    max-width: 75% !important;\n  }\n\n  .mw-xl-100 {\n    max-width: 100% !important;\n  }\n\n  .mw-xl-auto {\n    max-width: auto !important;\n  }\n\n  .mw-xl-1px {\n    max-width: 1px !important;\n  }\n\n  .mw-xl-2px {\n    max-width: 2px !important;\n  }\n\n  .mw-xl-3px {\n    max-width: 3px !important;\n  }\n\n  .mw-xl-4px {\n    max-width: 4px !important;\n  }\n\n  .mw-xl-5px {\n    max-width: 5px !important;\n  }\n\n  .mw-xl-6px {\n    max-width: 6px !important;\n  }\n\n  .mw-xl-7px {\n    max-width: 7px !important;\n  }\n\n  .mw-xl-8px {\n    max-width: 8px !important;\n  }\n\n  .mw-xl-9px {\n    max-width: 9px !important;\n  }\n\n  .mw-xl-10px {\n    max-width: 10px !important;\n  }\n\n  .mw-xl-15px {\n    max-width: 15px !important;\n  }\n\n  .mw-xl-20px {\n    max-width: 20px !important;\n  }\n\n  .mw-xl-25px {\n    max-width: 25px !important;\n  }\n\n  .mw-xl-30px {\n    max-width: 30px !important;\n  }\n\n  .mw-xl-35px {\n    max-width: 35px !important;\n  }\n\n  .mw-xl-40px {\n    max-width: 40px !important;\n  }\n\n  .mw-xl-45px {\n    max-width: 45px !important;\n  }\n\n  .mw-xl-50px {\n    max-width: 50px !important;\n  }\n\n  .mw-xl-55px {\n    max-width: 55px !important;\n  }\n\n  .mw-xl-60px {\n    max-width: 60px !important;\n  }\n\n  .mw-xl-65px {\n    max-width: 65px !important;\n  }\n\n  .mw-xl-70px {\n    max-width: 70px !important;\n  }\n\n  .mw-xl-75px {\n    max-width: 75px !important;\n  }\n\n  .mw-xl-80px {\n    max-width: 80px !important;\n  }\n\n  .mw-xl-85px {\n    max-width: 85px !important;\n  }\n\n  .mw-xl-90px {\n    max-width: 90px !important;\n  }\n\n  .mw-xl-95px {\n    max-width: 95px !important;\n  }\n\n  .mw-xl-100px {\n    max-width: 100px !important;\n  }\n\n  .mw-xl-125px {\n    max-width: 125px !important;\n  }\n\n  .mw-xl-150px {\n    max-width: 150px !important;\n  }\n\n  .mw-xl-175px {\n    max-width: 175px !important;\n  }\n\n  .mw-xl-200px {\n    max-width: 200px !important;\n  }\n\n  .mw-xl-225px {\n    max-width: 225px !important;\n  }\n\n  .mw-xl-250px {\n    max-width: 250px !important;\n  }\n\n  .mw-xl-275px {\n    max-width: 275px !important;\n  }\n\n  .mw-xl-300px {\n    max-width: 300px !important;\n  }\n\n  .mw-xl-325px {\n    max-width: 325px !important;\n  }\n\n  .mw-xl-350px {\n    max-width: 350px !important;\n  }\n\n  .mw-xl-375px {\n    max-width: 375px !important;\n  }\n\n  .mw-xl-400px {\n    max-width: 400px !important;\n  }\n\n  .mw-xl-425px {\n    max-width: 425px !important;\n  }\n\n  .mw-xl-450px {\n    max-width: 450px !important;\n  }\n\n  .mw-xl-475px {\n    max-width: 475px !important;\n  }\n\n  .mw-xl-500px {\n    max-width: 500px !important;\n  }\n\n  .mw-xl-550px {\n    max-width: 550px !important;\n  }\n\n  .mw-xl-600px {\n    max-width: 600px !important;\n  }\n\n  .mw-xl-650px {\n    max-width: 650px !important;\n  }\n\n  .mw-xl-700px {\n    max-width: 700px !important;\n  }\n\n  .mw-xl-750px {\n    max-width: 750px !important;\n  }\n\n  .mw-xl-800px {\n    max-width: 800px !important;\n  }\n\n  .mw-xl-850px {\n    max-width: 850px !important;\n  }\n\n  .mw-xl-900px {\n    max-width: 900px !important;\n  }\n\n  .mw-xl-950px {\n    max-width: 950px !important;\n  }\n\n  .mw-xl-1000px {\n    max-width: 1000px !important;\n  }\n\n  .h-xl-unset {\n    height: unset !important;\n  }\n\n  .h-xl-25 {\n    height: 25% !important;\n  }\n\n  .h-xl-50 {\n    height: 50% !important;\n  }\n\n  .h-xl-75 {\n    height: 75% !important;\n  }\n\n  .h-xl-100 {\n    height: 100% !important;\n  }\n\n  .h-xl-auto {\n    height: auto !important;\n  }\n\n  .h-xl-1px {\n    height: 1px !important;\n  }\n\n  .h-xl-2px {\n    height: 2px !important;\n  }\n\n  .h-xl-3px {\n    height: 3px !important;\n  }\n\n  .h-xl-4px {\n    height: 4px !important;\n  }\n\n  .h-xl-5px {\n    height: 5px !important;\n  }\n\n  .h-xl-6px {\n    height: 6px !important;\n  }\n\n  .h-xl-7px {\n    height: 7px !important;\n  }\n\n  .h-xl-8px {\n    height: 8px !important;\n  }\n\n  .h-xl-9px {\n    height: 9px !important;\n  }\n\n  .h-xl-10px {\n    height: 10px !important;\n  }\n\n  .h-xl-15px {\n    height: 15px !important;\n  }\n\n  .h-xl-20px {\n    height: 20px !important;\n  }\n\n  .h-xl-25px {\n    height: 25px !important;\n  }\n\n  .h-xl-30px {\n    height: 30px !important;\n  }\n\n  .h-xl-35px {\n    height: 35px !important;\n  }\n\n  .h-xl-40px {\n    height: 40px !important;\n  }\n\n  .h-xl-45px {\n    height: 45px !important;\n  }\n\n  .h-xl-50px {\n    height: 50px !important;\n  }\n\n  .h-xl-55px {\n    height: 55px !important;\n  }\n\n  .h-xl-60px {\n    height: 60px !important;\n  }\n\n  .h-xl-65px {\n    height: 65px !important;\n  }\n\n  .h-xl-70px {\n    height: 70px !important;\n  }\n\n  .h-xl-75px {\n    height: 75px !important;\n  }\n\n  .h-xl-80px {\n    height: 80px !important;\n  }\n\n  .h-xl-85px {\n    height: 85px !important;\n  }\n\n  .h-xl-90px {\n    height: 90px !important;\n  }\n\n  .h-xl-95px {\n    height: 95px !important;\n  }\n\n  .h-xl-100px {\n    height: 100px !important;\n  }\n\n  .h-xl-125px {\n    height: 125px !important;\n  }\n\n  .h-xl-150px {\n    height: 150px !important;\n  }\n\n  .h-xl-175px {\n    height: 175px !important;\n  }\n\n  .h-xl-200px {\n    height: 200px !important;\n  }\n\n  .h-xl-225px {\n    height: 225px !important;\n  }\n\n  .h-xl-250px {\n    height: 250px !important;\n  }\n\n  .h-xl-275px {\n    height: 275px !important;\n  }\n\n  .h-xl-300px {\n    height: 300px !important;\n  }\n\n  .h-xl-325px {\n    height: 325px !important;\n  }\n\n  .h-xl-350px {\n    height: 350px !important;\n  }\n\n  .h-xl-375px {\n    height: 375px !important;\n  }\n\n  .h-xl-400px {\n    height: 400px !important;\n  }\n\n  .h-xl-425px {\n    height: 425px !important;\n  }\n\n  .h-xl-450px {\n    height: 450px !important;\n  }\n\n  .h-xl-475px {\n    height: 475px !important;\n  }\n\n  .h-xl-500px {\n    height: 500px !important;\n  }\n\n  .h-xl-550px {\n    height: 550px !important;\n  }\n\n  .h-xl-600px {\n    height: 600px !important;\n  }\n\n  .h-xl-650px {\n    height: 650px !important;\n  }\n\n  .h-xl-700px {\n    height: 700px !important;\n  }\n\n  .h-xl-750px {\n    height: 750px !important;\n  }\n\n  .h-xl-800px {\n    height: 800px !important;\n  }\n\n  .h-xl-850px {\n    height: 850px !important;\n  }\n\n  .h-xl-900px {\n    height: 900px !important;\n  }\n\n  .h-xl-950px {\n    height: 950px !important;\n  }\n\n  .h-xl-1000px {\n    height: 1000px !important;\n  }\n\n  .mh-xl-unset {\n    max-height: unset !important;\n  }\n\n  .mh-xl-25 {\n    max-height: 25% !important;\n  }\n\n  .mh-xl-50 {\n    max-height: 50% !important;\n  }\n\n  .mh-xl-75 {\n    max-height: 75% !important;\n  }\n\n  .mh-xl-100 {\n    max-height: 100% !important;\n  }\n\n  .mh-xl-auto {\n    max-height: auto !important;\n  }\n\n  .mh-xl-1px {\n    max-height: 1px !important;\n  }\n\n  .mh-xl-2px {\n    max-height: 2px !important;\n  }\n\n  .mh-xl-3px {\n    max-height: 3px !important;\n  }\n\n  .mh-xl-4px {\n    max-height: 4px !important;\n  }\n\n  .mh-xl-5px {\n    max-height: 5px !important;\n  }\n\n  .mh-xl-6px {\n    max-height: 6px !important;\n  }\n\n  .mh-xl-7px {\n    max-height: 7px !important;\n  }\n\n  .mh-xl-8px {\n    max-height: 8px !important;\n  }\n\n  .mh-xl-9px {\n    max-height: 9px !important;\n  }\n\n  .mh-xl-10px {\n    max-height: 10px !important;\n  }\n\n  .mh-xl-15px {\n    max-height: 15px !important;\n  }\n\n  .mh-xl-20px {\n    max-height: 20px !important;\n  }\n\n  .mh-xl-25px {\n    max-height: 25px !important;\n  }\n\n  .mh-xl-30px {\n    max-height: 30px !important;\n  }\n\n  .mh-xl-35px {\n    max-height: 35px !important;\n  }\n\n  .mh-xl-40px {\n    max-height: 40px !important;\n  }\n\n  .mh-xl-45px {\n    max-height: 45px !important;\n  }\n\n  .mh-xl-50px {\n    max-height: 50px !important;\n  }\n\n  .mh-xl-55px {\n    max-height: 55px !important;\n  }\n\n  .mh-xl-60px {\n    max-height: 60px !important;\n  }\n\n  .mh-xl-65px {\n    max-height: 65px !important;\n  }\n\n  .mh-xl-70px {\n    max-height: 70px !important;\n  }\n\n  .mh-xl-75px {\n    max-height: 75px !important;\n  }\n\n  .mh-xl-80px {\n    max-height: 80px !important;\n  }\n\n  .mh-xl-85px {\n    max-height: 85px !important;\n  }\n\n  .mh-xl-90px {\n    max-height: 90px !important;\n  }\n\n  .mh-xl-95px {\n    max-height: 95px !important;\n  }\n\n  .mh-xl-100px {\n    max-height: 100px !important;\n  }\n\n  .mh-xl-125px {\n    max-height: 125px !important;\n  }\n\n  .mh-xl-150px {\n    max-height: 150px !important;\n  }\n\n  .mh-xl-175px {\n    max-height: 175px !important;\n  }\n\n  .mh-xl-200px {\n    max-height: 200px !important;\n  }\n\n  .mh-xl-225px {\n    max-height: 225px !important;\n  }\n\n  .mh-xl-250px {\n    max-height: 250px !important;\n  }\n\n  .mh-xl-275px {\n    max-height: 275px !important;\n  }\n\n  .mh-xl-300px {\n    max-height: 300px !important;\n  }\n\n  .mh-xl-325px {\n    max-height: 325px !important;\n  }\n\n  .mh-xl-350px {\n    max-height: 350px !important;\n  }\n\n  .mh-xl-375px {\n    max-height: 375px !important;\n  }\n\n  .mh-xl-400px {\n    max-height: 400px !important;\n  }\n\n  .mh-xl-425px {\n    max-height: 425px !important;\n  }\n\n  .mh-xl-450px {\n    max-height: 450px !important;\n  }\n\n  .mh-xl-475px {\n    max-height: 475px !important;\n  }\n\n  .mh-xl-500px {\n    max-height: 500px !important;\n  }\n\n  .mh-xl-550px {\n    max-height: 550px !important;\n  }\n\n  .mh-xl-600px {\n    max-height: 600px !important;\n  }\n\n  .mh-xl-650px {\n    max-height: 650px !important;\n  }\n\n  .mh-xl-700px {\n    max-height: 700px !important;\n  }\n\n  .mh-xl-750px {\n    max-height: 750px !important;\n  }\n\n  .mh-xl-800px {\n    max-height: 800px !important;\n  }\n\n  .mh-xl-850px {\n    max-height: 850px !important;\n  }\n\n  .mh-xl-900px {\n    max-height: 900px !important;\n  }\n\n  .mh-xl-950px {\n    max-height: 950px !important;\n  }\n\n  .mh-xl-1000px {\n    max-height: 1000px !important;\n  }\n\n  .flex-xl-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xl-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xl-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xl-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xl-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-xl-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-xl-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xl-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xl-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xl-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xl-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-xl-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-xl-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xl-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xl-center {\n    align-items: center !important;\n  }\n\n  .align-items-xl-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xl-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xl-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xl-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xl-center {\n    align-content: center !important;\n  }\n\n  .align-content-xl-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xl-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xl-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xl-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xl-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xl-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xl-center {\n    align-self: center !important;\n  }\n\n  .align-self-xl-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xl-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-xl-first {\n    order: -1 !important;\n  }\n\n  .order-xl-0 {\n    order: 0 !important;\n  }\n\n  .order-xl-1 {\n    order: 1 !important;\n  }\n\n  .order-xl-2 {\n    order: 2 !important;\n  }\n\n  .order-xl-3 {\n    order: 3 !important;\n  }\n\n  .order-xl-4 {\n    order: 4 !important;\n  }\n\n  .order-xl-5 {\n    order: 5 !important;\n  }\n\n  .order-xl-last {\n    order: 6 !important;\n  }\n\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-xl-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-xl-4 {\n    margin: 1rem !important;\n  }\n\n  .m-xl-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-xl-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-xl-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-xl-8 {\n    margin: 2rem !important;\n  }\n\n  .m-xl-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-xl-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-xl-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-xl-12 {\n    margin: 3rem !important;\n  }\n\n  .m-xl-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-xl-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-xl-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-xl-16 {\n    margin: 4rem !important;\n  }\n\n  .m-xl-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-xl-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-xl-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-xl-20 {\n    margin: 5rem !important;\n  }\n\n  .m-xl-auto {\n    margin: auto !important;\n  }\n\n  .mx-xl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-xl-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-xl-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-xl-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-xl-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-xl-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-xl-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-xl-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-xl-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-xl-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-xl-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-xl-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-xl-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-xl-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-xl-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-xl-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-xl-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-xl-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-xl-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-xl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-xl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-xl-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-xl-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-xl-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-xl-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-xl-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-xl-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-xl-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-xl-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-xl-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-xl-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-xl-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-xl-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-xl-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-xl-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-xl-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-xl-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-xl-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-xl-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-xl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-xl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-xl-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-xl-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-xl-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-xl-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-xl-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-xl-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-xl-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-xl-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-xl-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-xl-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-xl-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-xl-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-xl-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-xl-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-xl-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-xl-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-xl-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-xl-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-xl-auto {\n    margin-top: auto !important;\n  }\n\n  .me-xl-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-xl-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-xl-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-xl-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-xl-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-xl-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-xl-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-xl-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-xl-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-xl-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-xl-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-xl-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-xl-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-xl-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-xl-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-xl-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-xl-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-xl-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-xl-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-xl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-xl-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-xl-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-xl-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-xl-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-xl-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-xl-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-xl-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-xl-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-xl-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-xl-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-xl-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-xl-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-xl-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-xl-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-xl-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-xl-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-xl-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-xl-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-xl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-xl-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-xl-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-xl-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-xl-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-xl-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-xl-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-xl-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-xl-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-xl-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-xl-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-xl-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-xl-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-xl-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-xl-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-xl-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-xl-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-xl-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-xl-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-xl-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-xl-auto {\n    margin-left: auto !important;\n  }\n\n  .m-xl-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-xl-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-xl-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-xl-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-xl-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-xl-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-xl-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-xl-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-xl-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-xl-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-xl-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-xl-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-xl-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-xl-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-xl-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-xl-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-xl-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-xl-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-xl-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-xl-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-xl-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-xl-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-xl-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-xl-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-xl-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-xl-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-xl-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-xl-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-xl-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-xl-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-xl-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-xl-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-xl-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-xl-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-xl-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-xl-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-xl-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-xl-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-xl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-xl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-xl-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-xl-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-xl-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-xl-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-xl-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-xl-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-xl-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-xl-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-xl-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-xl-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-xl-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-xl-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-xl-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-xl-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-xl-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-xl-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-xl-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-xl-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-xl-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-xl-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-xl-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-xl-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-xl-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-xl-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-xl-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-xl-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-xl-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-xl-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-xl-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-xl-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-xl-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-xl-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-xl-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-xl-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-xl-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-xl-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-xl-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-xl-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-xl-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-xl-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-xl-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-xl-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-xl-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-xl-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-xl-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-xl-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-xl-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-xl-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-xl-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-xl-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-xl-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-xl-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-xl-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-xl-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-xl-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-xl-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-xl-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-xl-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-xl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-xl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-xl-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-xl-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-xl-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-xl-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-xl-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-xl-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-xl-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-xl-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-xl-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-xl-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-xl-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-xl-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-xl-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-xl-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-xl-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-xl-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-xl-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-xl-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-xl-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-xl-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-xl-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-xl-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-xl-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-xl-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-xl-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-xl-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-xl-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-xl-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-xl-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-xl-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-xl-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-xl-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-xl-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-xl-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-xl-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-xl-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-xl-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-xl-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-xl-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-xl-4 {\n    padding: 1rem !important;\n  }\n\n  .p-xl-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-xl-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-xl-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-xl-8 {\n    padding: 2rem !important;\n  }\n\n  .p-xl-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-xl-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-xl-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-xl-12 {\n    padding: 3rem !important;\n  }\n\n  .p-xl-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-xl-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-xl-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-xl-16 {\n    padding: 4rem !important;\n  }\n\n  .p-xl-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-xl-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-xl-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-xl-20 {\n    padding: 5rem !important;\n  }\n\n  .px-xl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-xl-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-xl-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-xl-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-xl-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-xl-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-xl-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-xl-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-xl-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-xl-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-xl-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-xl-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-xl-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-xl-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-xl-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-xl-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-xl-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-xl-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-xl-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-xl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-xl-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-xl-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-xl-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-xl-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-xl-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-xl-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-xl-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-xl-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-xl-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-xl-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-xl-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-xl-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-xl-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-xl-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-xl-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-xl-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-xl-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-xl-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-xl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-xl-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-xl-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-xl-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-xl-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-xl-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-xl-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-xl-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-xl-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-xl-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-xl-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-xl-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-xl-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-xl-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-xl-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-xl-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-xl-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-xl-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-xl-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-xl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-xl-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-xl-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-xl-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-xl-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-xl-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-xl-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-xl-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-xl-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-xl-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-xl-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-xl-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-xl-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-xl-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-xl-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-xl-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-xl-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-xl-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-xl-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-xl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-xl-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-xl-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-xl-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-xl-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-xl-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-xl-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-xl-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-xl-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-xl-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-xl-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-xl-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-xl-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-xl-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-xl-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-xl-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-xl-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-xl-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-xl-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-xl-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-xl-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-xl-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-xl-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-xl-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-xl-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-xl-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-xl-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-xl-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-xl-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-xl-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-xl-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-xl-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-xl-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-xl-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-xl-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-xl-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-xl-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-xl-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-xl-0 {\n    gap: 0 !important;\n  }\n\n  .gap-xl-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-xl-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-xl-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-xl-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-xl-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-xl-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-xl-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-xl-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-xl-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-xl-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-xl-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-xl-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-xl-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-xl-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-xl-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-xl-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-xl-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-xl-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-xl-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-xl-20 {\n    gap: 5rem !important;\n  }\n\n  .fs-xl-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n\n  .fs-xl-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n\n  .fs-xl-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n\n  .fs-xl-4 {\n    font-size: 1.25rem !important;\n  }\n\n  .fs-xl-5 {\n    font-size: 1.15rem !important;\n  }\n\n  .fs-xl-6 {\n    font-size: 1.075rem !important;\n  }\n\n  .fs-xl-7 {\n    font-size: 0.95rem !important;\n  }\n\n  .fs-xl-8 {\n    font-size: 0.85rem !important;\n  }\n\n  .fs-xl-9 {\n    font-size: 0.75rem !important;\n  }\n\n  .fs-xl-10 {\n    font-size: 0.5rem !important;\n  }\n\n  .fs-xl-base {\n    font-size: 1rem !important;\n  }\n\n  .fs-xl-fluid {\n    font-size: 100% !important;\n  }\n\n  .fs-xl-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n\n  .fs-xl-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n\n  .fs-xl-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n\n  .fs-xl-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n\n  .fs-xl-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n\n  .fs-xl-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n\n  .fs-xl-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n\n  .fs-xl-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n\n  .fs-xl-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n\n  .fs-xl-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n\n  .fs-xl-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n\n  .fs-xl-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n\n  .fs-xl-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n\n  .fs-xl-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n\n  .fs-xl-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n\n  .fs-xl-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n\n  .text-xl-start {\n    text-align: left !important;\n  }\n\n  .text-xl-end {\n    text-align: right !important;\n  }\n\n  .text-xl-center {\n    text-align: center !important;\n  }\n\n  .min-w-xl-unset {\n    min-width: unset !important;\n  }\n\n  .min-w-xl-25 {\n    min-width: 25% !important;\n  }\n\n  .min-w-xl-50 {\n    min-width: 50% !important;\n  }\n\n  .min-w-xl-75 {\n    min-width: 75% !important;\n  }\n\n  .min-w-xl-100 {\n    min-width: 100% !important;\n  }\n\n  .min-w-xl-auto {\n    min-width: auto !important;\n  }\n\n  .min-w-xl-1px {\n    min-width: 1px !important;\n  }\n\n  .min-w-xl-2px {\n    min-width: 2px !important;\n  }\n\n  .min-w-xl-3px {\n    min-width: 3px !important;\n  }\n\n  .min-w-xl-4px {\n    min-width: 4px !important;\n  }\n\n  .min-w-xl-5px {\n    min-width: 5px !important;\n  }\n\n  .min-w-xl-6px {\n    min-width: 6px !important;\n  }\n\n  .min-w-xl-7px {\n    min-width: 7px !important;\n  }\n\n  .min-w-xl-8px {\n    min-width: 8px !important;\n  }\n\n  .min-w-xl-9px {\n    min-width: 9px !important;\n  }\n\n  .min-w-xl-10px {\n    min-width: 10px !important;\n  }\n\n  .min-w-xl-15px {\n    min-width: 15px !important;\n  }\n\n  .min-w-xl-20px {\n    min-width: 20px !important;\n  }\n\n  .min-w-xl-25px {\n    min-width: 25px !important;\n  }\n\n  .min-w-xl-30px {\n    min-width: 30px !important;\n  }\n\n  .min-w-xl-35px {\n    min-width: 35px !important;\n  }\n\n  .min-w-xl-40px {\n    min-width: 40px !important;\n  }\n\n  .min-w-xl-45px {\n    min-width: 45px !important;\n  }\n\n  .min-w-xl-50px {\n    min-width: 50px !important;\n  }\n\n  .min-w-xl-55px {\n    min-width: 55px !important;\n  }\n\n  .min-w-xl-60px {\n    min-width: 60px !important;\n  }\n\n  .min-w-xl-65px {\n    min-width: 65px !important;\n  }\n\n  .min-w-xl-70px {\n    min-width: 70px !important;\n  }\n\n  .min-w-xl-75px {\n    min-width: 75px !important;\n  }\n\n  .min-w-xl-80px {\n    min-width: 80px !important;\n  }\n\n  .min-w-xl-85px {\n    min-width: 85px !important;\n  }\n\n  .min-w-xl-90px {\n    min-width: 90px !important;\n  }\n\n  .min-w-xl-95px {\n    min-width: 95px !important;\n  }\n\n  .min-w-xl-100px {\n    min-width: 100px !important;\n  }\n\n  .min-w-xl-125px {\n    min-width: 125px !important;\n  }\n\n  .min-w-xl-150px {\n    min-width: 150px !important;\n  }\n\n  .min-w-xl-175px {\n    min-width: 175px !important;\n  }\n\n  .min-w-xl-200px {\n    min-width: 200px !important;\n  }\n\n  .min-w-xl-225px {\n    min-width: 225px !important;\n  }\n\n  .min-w-xl-250px {\n    min-width: 250px !important;\n  }\n\n  .min-w-xl-275px {\n    min-width: 275px !important;\n  }\n\n  .min-w-xl-300px {\n    min-width: 300px !important;\n  }\n\n  .min-w-xl-325px {\n    min-width: 325px !important;\n  }\n\n  .min-w-xl-350px {\n    min-width: 350px !important;\n  }\n\n  .min-w-xl-375px {\n    min-width: 375px !important;\n  }\n\n  .min-w-xl-400px {\n    min-width: 400px !important;\n  }\n\n  .min-w-xl-425px {\n    min-width: 425px !important;\n  }\n\n  .min-w-xl-450px {\n    min-width: 450px !important;\n  }\n\n  .min-w-xl-475px {\n    min-width: 475px !important;\n  }\n\n  .min-w-xl-500px {\n    min-width: 500px !important;\n  }\n\n  .min-w-xl-550px {\n    min-width: 550px !important;\n  }\n\n  .min-w-xl-600px {\n    min-width: 600px !important;\n  }\n\n  .min-w-xl-650px {\n    min-width: 650px !important;\n  }\n\n  .min-w-xl-700px {\n    min-width: 700px !important;\n  }\n\n  .min-w-xl-750px {\n    min-width: 750px !important;\n  }\n\n  .min-w-xl-800px {\n    min-width: 800px !important;\n  }\n\n  .min-w-xl-850px {\n    min-width: 850px !important;\n  }\n\n  .min-w-xl-900px {\n    min-width: 900px !important;\n  }\n\n  .min-w-xl-950px {\n    min-width: 950px !important;\n  }\n\n  .min-w-xl-1000px {\n    min-width: 1000px !important;\n  }\n\n  .min-h-xl-unset {\n    min-height: unset !important;\n  }\n\n  .min-h-xl-25 {\n    min-height: 25% !important;\n  }\n\n  .min-h-xl-50 {\n    min-height: 50% !important;\n  }\n\n  .min-h-xl-75 {\n    min-height: 75% !important;\n  }\n\n  .min-h-xl-100 {\n    min-height: 100% !important;\n  }\n\n  .min-h-xl-auto {\n    min-height: auto !important;\n  }\n\n  .min-h-xl-1px {\n    min-height: 1px !important;\n  }\n\n  .min-h-xl-2px {\n    min-height: 2px !important;\n  }\n\n  .min-h-xl-3px {\n    min-height: 3px !important;\n  }\n\n  .min-h-xl-4px {\n    min-height: 4px !important;\n  }\n\n  .min-h-xl-5px {\n    min-height: 5px !important;\n  }\n\n  .min-h-xl-6px {\n    min-height: 6px !important;\n  }\n\n  .min-h-xl-7px {\n    min-height: 7px !important;\n  }\n\n  .min-h-xl-8px {\n    min-height: 8px !important;\n  }\n\n  .min-h-xl-9px {\n    min-height: 9px !important;\n  }\n\n  .min-h-xl-10px {\n    min-height: 10px !important;\n  }\n\n  .min-h-xl-15px {\n    min-height: 15px !important;\n  }\n\n  .min-h-xl-20px {\n    min-height: 20px !important;\n  }\n\n  .min-h-xl-25px {\n    min-height: 25px !important;\n  }\n\n  .min-h-xl-30px {\n    min-height: 30px !important;\n  }\n\n  .min-h-xl-35px {\n    min-height: 35px !important;\n  }\n\n  .min-h-xl-40px {\n    min-height: 40px !important;\n  }\n\n  .min-h-xl-45px {\n    min-height: 45px !important;\n  }\n\n  .min-h-xl-50px {\n    min-height: 50px !important;\n  }\n\n  .min-h-xl-55px {\n    min-height: 55px !important;\n  }\n\n  .min-h-xl-60px {\n    min-height: 60px !important;\n  }\n\n  .min-h-xl-65px {\n    min-height: 65px !important;\n  }\n\n  .min-h-xl-70px {\n    min-height: 70px !important;\n  }\n\n  .min-h-xl-75px {\n    min-height: 75px !important;\n  }\n\n  .min-h-xl-80px {\n    min-height: 80px !important;\n  }\n\n  .min-h-xl-85px {\n    min-height: 85px !important;\n  }\n\n  .min-h-xl-90px {\n    min-height: 90px !important;\n  }\n\n  .min-h-xl-95px {\n    min-height: 95px !important;\n  }\n\n  .min-h-xl-100px {\n    min-height: 100px !important;\n  }\n\n  .min-h-xl-125px {\n    min-height: 125px !important;\n  }\n\n  .min-h-xl-150px {\n    min-height: 150px !important;\n  }\n\n  .min-h-xl-175px {\n    min-height: 175px !important;\n  }\n\n  .min-h-xl-200px {\n    min-height: 200px !important;\n  }\n\n  .min-h-xl-225px {\n    min-height: 225px !important;\n  }\n\n  .min-h-xl-250px {\n    min-height: 250px !important;\n  }\n\n  .min-h-xl-275px {\n    min-height: 275px !important;\n  }\n\n  .min-h-xl-300px {\n    min-height: 300px !important;\n  }\n\n  .min-h-xl-325px {\n    min-height: 325px !important;\n  }\n\n  .min-h-xl-350px {\n    min-height: 350px !important;\n  }\n\n  .min-h-xl-375px {\n    min-height: 375px !important;\n  }\n\n  .min-h-xl-400px {\n    min-height: 400px !important;\n  }\n\n  .min-h-xl-425px {\n    min-height: 425px !important;\n  }\n\n  .min-h-xl-450px {\n    min-height: 450px !important;\n  }\n\n  .min-h-xl-475px {\n    min-height: 475px !important;\n  }\n\n  .min-h-xl-500px {\n    min-height: 500px !important;\n  }\n\n  .min-h-xl-550px {\n    min-height: 550px !important;\n  }\n\n  .min-h-xl-600px {\n    min-height: 600px !important;\n  }\n\n  .min-h-xl-650px {\n    min-height: 650px !important;\n  }\n\n  .min-h-xl-700px {\n    min-height: 700px !important;\n  }\n\n  .min-h-xl-750px {\n    min-height: 750px !important;\n  }\n\n  .min-h-xl-800px {\n    min-height: 800px !important;\n  }\n\n  .min-h-xl-850px {\n    min-height: 850px !important;\n  }\n\n  .min-h-xl-900px {\n    min-height: 900px !important;\n  }\n\n  .min-h-xl-950px {\n    min-height: 950px !important;\n  }\n\n  .min-h-xl-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 1400px) {\n  .float-xxl-start {\n    float: left !important;\n  }\n\n  .float-xxl-end {\n    float: right !important;\n  }\n\n  .float-xxl-none {\n    float: none !important;\n  }\n\n  .d-xxl-inline {\n    display: inline !important;\n  }\n\n  .d-xxl-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-xxl-block {\n    display: block !important;\n  }\n\n  .d-xxl-grid {\n    display: grid !important;\n  }\n\n  .d-xxl-table {\n    display: table !important;\n  }\n\n  .d-xxl-table-row {\n    display: table-row !important;\n  }\n\n  .d-xxl-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-xxl-flex {\n    display: flex !important;\n  }\n\n  .d-xxl-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-xxl-none {\n    display: none !important;\n  }\n\n  .position-xxl-static {\n    position: static !important;\n  }\n\n  .position-xxl-relative {\n    position: relative !important;\n  }\n\n  .position-xxl-absolute {\n    position: absolute !important;\n  }\n\n  .position-xxl-fixed {\n    position: fixed !important;\n  }\n\n  .position-xxl-sticky {\n    position: sticky !important;\n  }\n\n  .w-xxl-unset {\n    width: unset !important;\n  }\n\n  .w-xxl-25 {\n    width: 25% !important;\n  }\n\n  .w-xxl-50 {\n    width: 50% !important;\n  }\n\n  .w-xxl-75 {\n    width: 75% !important;\n  }\n\n  .w-xxl-100 {\n    width: 100% !important;\n  }\n\n  .w-xxl-auto {\n    width: auto !important;\n  }\n\n  .w-xxl-1px {\n    width: 1px !important;\n  }\n\n  .w-xxl-2px {\n    width: 2px !important;\n  }\n\n  .w-xxl-3px {\n    width: 3px !important;\n  }\n\n  .w-xxl-4px {\n    width: 4px !important;\n  }\n\n  .w-xxl-5px {\n    width: 5px !important;\n  }\n\n  .w-xxl-6px {\n    width: 6px !important;\n  }\n\n  .w-xxl-7px {\n    width: 7px !important;\n  }\n\n  .w-xxl-8px {\n    width: 8px !important;\n  }\n\n  .w-xxl-9px {\n    width: 9px !important;\n  }\n\n  .w-xxl-10px {\n    width: 10px !important;\n  }\n\n  .w-xxl-15px {\n    width: 15px !important;\n  }\n\n  .w-xxl-20px {\n    width: 20px !important;\n  }\n\n  .w-xxl-25px {\n    width: 25px !important;\n  }\n\n  .w-xxl-30px {\n    width: 30px !important;\n  }\n\n  .w-xxl-35px {\n    width: 35px !important;\n  }\n\n  .w-xxl-40px {\n    width: 40px !important;\n  }\n\n  .w-xxl-45px {\n    width: 45px !important;\n  }\n\n  .w-xxl-50px {\n    width: 50px !important;\n  }\n\n  .w-xxl-55px {\n    width: 55px !important;\n  }\n\n  .w-xxl-60px {\n    width: 60px !important;\n  }\n\n  .w-xxl-65px {\n    width: 65px !important;\n  }\n\n  .w-xxl-70px {\n    width: 70px !important;\n  }\n\n  .w-xxl-75px {\n    width: 75px !important;\n  }\n\n  .w-xxl-80px {\n    width: 80px !important;\n  }\n\n  .w-xxl-85px {\n    width: 85px !important;\n  }\n\n  .w-xxl-90px {\n    width: 90px !important;\n  }\n\n  .w-xxl-95px {\n    width: 95px !important;\n  }\n\n  .w-xxl-100px {\n    width: 100px !important;\n  }\n\n  .w-xxl-125px {\n    width: 125px !important;\n  }\n\n  .w-xxl-150px {\n    width: 150px !important;\n  }\n\n  .w-xxl-175px {\n    width: 175px !important;\n  }\n\n  .w-xxl-200px {\n    width: 200px !important;\n  }\n\n  .w-xxl-225px {\n    width: 225px !important;\n  }\n\n  .w-xxl-250px {\n    width: 250px !important;\n  }\n\n  .w-xxl-275px {\n    width: 275px !important;\n  }\n\n  .w-xxl-300px {\n    width: 300px !important;\n  }\n\n  .w-xxl-325px {\n    width: 325px !important;\n  }\n\n  .w-xxl-350px {\n    width: 350px !important;\n  }\n\n  .w-xxl-375px {\n    width: 375px !important;\n  }\n\n  .w-xxl-400px {\n    width: 400px !important;\n  }\n\n  .w-xxl-425px {\n    width: 425px !important;\n  }\n\n  .w-xxl-450px {\n    width: 450px !important;\n  }\n\n  .w-xxl-475px {\n    width: 475px !important;\n  }\n\n  .w-xxl-500px {\n    width: 500px !important;\n  }\n\n  .w-xxl-550px {\n    width: 550px !important;\n  }\n\n  .w-xxl-600px {\n    width: 600px !important;\n  }\n\n  .w-xxl-650px {\n    width: 650px !important;\n  }\n\n  .w-xxl-700px {\n    width: 700px !important;\n  }\n\n  .w-xxl-750px {\n    width: 750px !important;\n  }\n\n  .w-xxl-800px {\n    width: 800px !important;\n  }\n\n  .w-xxl-850px {\n    width: 850px !important;\n  }\n\n  .w-xxl-900px {\n    width: 900px !important;\n  }\n\n  .w-xxl-950px {\n    width: 950px !important;\n  }\n\n  .w-xxl-1000px {\n    width: 1000px !important;\n  }\n\n  .mw-xxl-unset {\n    max-width: unset !important;\n  }\n\n  .mw-xxl-25 {\n    max-width: 25% !important;\n  }\n\n  .mw-xxl-50 {\n    max-width: 50% !important;\n  }\n\n  .mw-xxl-75 {\n    max-width: 75% !important;\n  }\n\n  .mw-xxl-100 {\n    max-width: 100% !important;\n  }\n\n  .mw-xxl-auto {\n    max-width: auto !important;\n  }\n\n  .mw-xxl-1px {\n    max-width: 1px !important;\n  }\n\n  .mw-xxl-2px {\n    max-width: 2px !important;\n  }\n\n  .mw-xxl-3px {\n    max-width: 3px !important;\n  }\n\n  .mw-xxl-4px {\n    max-width: 4px !important;\n  }\n\n  .mw-xxl-5px {\n    max-width: 5px !important;\n  }\n\n  .mw-xxl-6px {\n    max-width: 6px !important;\n  }\n\n  .mw-xxl-7px {\n    max-width: 7px !important;\n  }\n\n  .mw-xxl-8px {\n    max-width: 8px !important;\n  }\n\n  .mw-xxl-9px {\n    max-width: 9px !important;\n  }\n\n  .mw-xxl-10px {\n    max-width: 10px !important;\n  }\n\n  .mw-xxl-15px {\n    max-width: 15px !important;\n  }\n\n  .mw-xxl-20px {\n    max-width: 20px !important;\n  }\n\n  .mw-xxl-25px {\n    max-width: 25px !important;\n  }\n\n  .mw-xxl-30px {\n    max-width: 30px !important;\n  }\n\n  .mw-xxl-35px {\n    max-width: 35px !important;\n  }\n\n  .mw-xxl-40px {\n    max-width: 40px !important;\n  }\n\n  .mw-xxl-45px {\n    max-width: 45px !important;\n  }\n\n  .mw-xxl-50px {\n    max-width: 50px !important;\n  }\n\n  .mw-xxl-55px {\n    max-width: 55px !important;\n  }\n\n  .mw-xxl-60px {\n    max-width: 60px !important;\n  }\n\n  .mw-xxl-65px {\n    max-width: 65px !important;\n  }\n\n  .mw-xxl-70px {\n    max-width: 70px !important;\n  }\n\n  .mw-xxl-75px {\n    max-width: 75px !important;\n  }\n\n  .mw-xxl-80px {\n    max-width: 80px !important;\n  }\n\n  .mw-xxl-85px {\n    max-width: 85px !important;\n  }\n\n  .mw-xxl-90px {\n    max-width: 90px !important;\n  }\n\n  .mw-xxl-95px {\n    max-width: 95px !important;\n  }\n\n  .mw-xxl-100px {\n    max-width: 100px !important;\n  }\n\n  .mw-xxl-125px {\n    max-width: 125px !important;\n  }\n\n  .mw-xxl-150px {\n    max-width: 150px !important;\n  }\n\n  .mw-xxl-175px {\n    max-width: 175px !important;\n  }\n\n  .mw-xxl-200px {\n    max-width: 200px !important;\n  }\n\n  .mw-xxl-225px {\n    max-width: 225px !important;\n  }\n\n  .mw-xxl-250px {\n    max-width: 250px !important;\n  }\n\n  .mw-xxl-275px {\n    max-width: 275px !important;\n  }\n\n  .mw-xxl-300px {\n    max-width: 300px !important;\n  }\n\n  .mw-xxl-325px {\n    max-width: 325px !important;\n  }\n\n  .mw-xxl-350px {\n    max-width: 350px !important;\n  }\n\n  .mw-xxl-375px {\n    max-width: 375px !important;\n  }\n\n  .mw-xxl-400px {\n    max-width: 400px !important;\n  }\n\n  .mw-xxl-425px {\n    max-width: 425px !important;\n  }\n\n  .mw-xxl-450px {\n    max-width: 450px !important;\n  }\n\n  .mw-xxl-475px {\n    max-width: 475px !important;\n  }\n\n  .mw-xxl-500px {\n    max-width: 500px !important;\n  }\n\n  .mw-xxl-550px {\n    max-width: 550px !important;\n  }\n\n  .mw-xxl-600px {\n    max-width: 600px !important;\n  }\n\n  .mw-xxl-650px {\n    max-width: 650px !important;\n  }\n\n  .mw-xxl-700px {\n    max-width: 700px !important;\n  }\n\n  .mw-xxl-750px {\n    max-width: 750px !important;\n  }\n\n  .mw-xxl-800px {\n    max-width: 800px !important;\n  }\n\n  .mw-xxl-850px {\n    max-width: 850px !important;\n  }\n\n  .mw-xxl-900px {\n    max-width: 900px !important;\n  }\n\n  .mw-xxl-950px {\n    max-width: 950px !important;\n  }\n\n  .mw-xxl-1000px {\n    max-width: 1000px !important;\n  }\n\n  .h-xxl-unset {\n    height: unset !important;\n  }\n\n  .h-xxl-25 {\n    height: 25% !important;\n  }\n\n  .h-xxl-50 {\n    height: 50% !important;\n  }\n\n  .h-xxl-75 {\n    height: 75% !important;\n  }\n\n  .h-xxl-100 {\n    height: 100% !important;\n  }\n\n  .h-xxl-auto {\n    height: auto !important;\n  }\n\n  .h-xxl-1px {\n    height: 1px !important;\n  }\n\n  .h-xxl-2px {\n    height: 2px !important;\n  }\n\n  .h-xxl-3px {\n    height: 3px !important;\n  }\n\n  .h-xxl-4px {\n    height: 4px !important;\n  }\n\n  .h-xxl-5px {\n    height: 5px !important;\n  }\n\n  .h-xxl-6px {\n    height: 6px !important;\n  }\n\n  .h-xxl-7px {\n    height: 7px !important;\n  }\n\n  .h-xxl-8px {\n    height: 8px !important;\n  }\n\n  .h-xxl-9px {\n    height: 9px !important;\n  }\n\n  .h-xxl-10px {\n    height: 10px !important;\n  }\n\n  .h-xxl-15px {\n    height: 15px !important;\n  }\n\n  .h-xxl-20px {\n    height: 20px !important;\n  }\n\n  .h-xxl-25px {\n    height: 25px !important;\n  }\n\n  .h-xxl-30px {\n    height: 30px !important;\n  }\n\n  .h-xxl-35px {\n    height: 35px !important;\n  }\n\n  .h-xxl-40px {\n    height: 40px !important;\n  }\n\n  .h-xxl-45px {\n    height: 45px !important;\n  }\n\n  .h-xxl-50px {\n    height: 50px !important;\n  }\n\n  .h-xxl-55px {\n    height: 55px !important;\n  }\n\n  .h-xxl-60px {\n    height: 60px !important;\n  }\n\n  .h-xxl-65px {\n    height: 65px !important;\n  }\n\n  .h-xxl-70px {\n    height: 70px !important;\n  }\n\n  .h-xxl-75px {\n    height: 75px !important;\n  }\n\n  .h-xxl-80px {\n    height: 80px !important;\n  }\n\n  .h-xxl-85px {\n    height: 85px !important;\n  }\n\n  .h-xxl-90px {\n    height: 90px !important;\n  }\n\n  .h-xxl-95px {\n    height: 95px !important;\n  }\n\n  .h-xxl-100px {\n    height: 100px !important;\n  }\n\n  .h-xxl-125px {\n    height: 125px !important;\n  }\n\n  .h-xxl-150px {\n    height: 150px !important;\n  }\n\n  .h-xxl-175px {\n    height: 175px !important;\n  }\n\n  .h-xxl-200px {\n    height: 200px !important;\n  }\n\n  .h-xxl-225px {\n    height: 225px !important;\n  }\n\n  .h-xxl-250px {\n    height: 250px !important;\n  }\n\n  .h-xxl-275px {\n    height: 275px !important;\n  }\n\n  .h-xxl-300px {\n    height: 300px !important;\n  }\n\n  .h-xxl-325px {\n    height: 325px !important;\n  }\n\n  .h-xxl-350px {\n    height: 350px !important;\n  }\n\n  .h-xxl-375px {\n    height: 375px !important;\n  }\n\n  .h-xxl-400px {\n    height: 400px !important;\n  }\n\n  .h-xxl-425px {\n    height: 425px !important;\n  }\n\n  .h-xxl-450px {\n    height: 450px !important;\n  }\n\n  .h-xxl-475px {\n    height: 475px !important;\n  }\n\n  .h-xxl-500px {\n    height: 500px !important;\n  }\n\n  .h-xxl-550px {\n    height: 550px !important;\n  }\n\n  .h-xxl-600px {\n    height: 600px !important;\n  }\n\n  .h-xxl-650px {\n    height: 650px !important;\n  }\n\n  .h-xxl-700px {\n    height: 700px !important;\n  }\n\n  .h-xxl-750px {\n    height: 750px !important;\n  }\n\n  .h-xxl-800px {\n    height: 800px !important;\n  }\n\n  .h-xxl-850px {\n    height: 850px !important;\n  }\n\n  .h-xxl-900px {\n    height: 900px !important;\n  }\n\n  .h-xxl-950px {\n    height: 950px !important;\n  }\n\n  .h-xxl-1000px {\n    height: 1000px !important;\n  }\n\n  .mh-xxl-unset {\n    max-height: unset !important;\n  }\n\n  .mh-xxl-25 {\n    max-height: 25% !important;\n  }\n\n  .mh-xxl-50 {\n    max-height: 50% !important;\n  }\n\n  .mh-xxl-75 {\n    max-height: 75% !important;\n  }\n\n  .mh-xxl-100 {\n    max-height: 100% !important;\n  }\n\n  .mh-xxl-auto {\n    max-height: auto !important;\n  }\n\n  .mh-xxl-1px {\n    max-height: 1px !important;\n  }\n\n  .mh-xxl-2px {\n    max-height: 2px !important;\n  }\n\n  .mh-xxl-3px {\n    max-height: 3px !important;\n  }\n\n  .mh-xxl-4px {\n    max-height: 4px !important;\n  }\n\n  .mh-xxl-5px {\n    max-height: 5px !important;\n  }\n\n  .mh-xxl-6px {\n    max-height: 6px !important;\n  }\n\n  .mh-xxl-7px {\n    max-height: 7px !important;\n  }\n\n  .mh-xxl-8px {\n    max-height: 8px !important;\n  }\n\n  .mh-xxl-9px {\n    max-height: 9px !important;\n  }\n\n  .mh-xxl-10px {\n    max-height: 10px !important;\n  }\n\n  .mh-xxl-15px {\n    max-height: 15px !important;\n  }\n\n  .mh-xxl-20px {\n    max-height: 20px !important;\n  }\n\n  .mh-xxl-25px {\n    max-height: 25px !important;\n  }\n\n  .mh-xxl-30px {\n    max-height: 30px !important;\n  }\n\n  .mh-xxl-35px {\n    max-height: 35px !important;\n  }\n\n  .mh-xxl-40px {\n    max-height: 40px !important;\n  }\n\n  .mh-xxl-45px {\n    max-height: 45px !important;\n  }\n\n  .mh-xxl-50px {\n    max-height: 50px !important;\n  }\n\n  .mh-xxl-55px {\n    max-height: 55px !important;\n  }\n\n  .mh-xxl-60px {\n    max-height: 60px !important;\n  }\n\n  .mh-xxl-65px {\n    max-height: 65px !important;\n  }\n\n  .mh-xxl-70px {\n    max-height: 70px !important;\n  }\n\n  .mh-xxl-75px {\n    max-height: 75px !important;\n  }\n\n  .mh-xxl-80px {\n    max-height: 80px !important;\n  }\n\n  .mh-xxl-85px {\n    max-height: 85px !important;\n  }\n\n  .mh-xxl-90px {\n    max-height: 90px !important;\n  }\n\n  .mh-xxl-95px {\n    max-height: 95px !important;\n  }\n\n  .mh-xxl-100px {\n    max-height: 100px !important;\n  }\n\n  .mh-xxl-125px {\n    max-height: 125px !important;\n  }\n\n  .mh-xxl-150px {\n    max-height: 150px !important;\n  }\n\n  .mh-xxl-175px {\n    max-height: 175px !important;\n  }\n\n  .mh-xxl-200px {\n    max-height: 200px !important;\n  }\n\n  .mh-xxl-225px {\n    max-height: 225px !important;\n  }\n\n  .mh-xxl-250px {\n    max-height: 250px !important;\n  }\n\n  .mh-xxl-275px {\n    max-height: 275px !important;\n  }\n\n  .mh-xxl-300px {\n    max-height: 300px !important;\n  }\n\n  .mh-xxl-325px {\n    max-height: 325px !important;\n  }\n\n  .mh-xxl-350px {\n    max-height: 350px !important;\n  }\n\n  .mh-xxl-375px {\n    max-height: 375px !important;\n  }\n\n  .mh-xxl-400px {\n    max-height: 400px !important;\n  }\n\n  .mh-xxl-425px {\n    max-height: 425px !important;\n  }\n\n  .mh-xxl-450px {\n    max-height: 450px !important;\n  }\n\n  .mh-xxl-475px {\n    max-height: 475px !important;\n  }\n\n  .mh-xxl-500px {\n    max-height: 500px !important;\n  }\n\n  .mh-xxl-550px {\n    max-height: 550px !important;\n  }\n\n  .mh-xxl-600px {\n    max-height: 600px !important;\n  }\n\n  .mh-xxl-650px {\n    max-height: 650px !important;\n  }\n\n  .mh-xxl-700px {\n    max-height: 700px !important;\n  }\n\n  .mh-xxl-750px {\n    max-height: 750px !important;\n  }\n\n  .mh-xxl-800px {\n    max-height: 800px !important;\n  }\n\n  .mh-xxl-850px {\n    max-height: 850px !important;\n  }\n\n  .mh-xxl-900px {\n    max-height: 900px !important;\n  }\n\n  .mh-xxl-950px {\n    max-height: 950px !important;\n  }\n\n  .mh-xxl-1000px {\n    max-height: 1000px !important;\n  }\n\n  .flex-xxl-fill {\n    flex: 1 1 auto !important;\n  }\n\n  .flex-xxl-row {\n    flex-direction: row !important;\n  }\n\n  .flex-xxl-column {\n    flex-direction: column !important;\n  }\n\n  .flex-xxl-row-reverse {\n    flex-direction: row-reverse !important;\n  }\n\n  .flex-xxl-column-reverse {\n    flex-direction: column-reverse !important;\n  }\n\n  .flex-xxl-grow-0 {\n    flex-grow: 0 !important;\n  }\n\n  .flex-xxl-grow-1 {\n    flex-grow: 1 !important;\n  }\n\n  .flex-xxl-shrink-0 {\n    flex-shrink: 0 !important;\n  }\n\n  .flex-xxl-shrink-1 {\n    flex-shrink: 1 !important;\n  }\n\n  .flex-xxl-wrap {\n    flex-wrap: wrap !important;\n  }\n\n  .flex-xxl-nowrap {\n    flex-wrap: nowrap !important;\n  }\n\n  .flex-xxl-wrap-reverse {\n    flex-wrap: wrap-reverse !important;\n  }\n\n  .justify-content-xxl-start {\n    justify-content: flex-start !important;\n  }\n\n  .justify-content-xxl-end {\n    justify-content: flex-end !important;\n  }\n\n  .justify-content-xxl-center {\n    justify-content: center !important;\n  }\n\n  .justify-content-xxl-between {\n    justify-content: space-between !important;\n  }\n\n  .justify-content-xxl-around {\n    justify-content: space-around !important;\n  }\n\n  .justify-content-xxl-evenly {\n    justify-content: space-evenly !important;\n  }\n\n  .align-items-xxl-start {\n    align-items: flex-start !important;\n  }\n\n  .align-items-xxl-end {\n    align-items: flex-end !important;\n  }\n\n  .align-items-xxl-center {\n    align-items: center !important;\n  }\n\n  .align-items-xxl-baseline {\n    align-items: baseline !important;\n  }\n\n  .align-items-xxl-stretch {\n    align-items: stretch !important;\n  }\n\n  .align-content-xxl-start {\n    align-content: flex-start !important;\n  }\n\n  .align-content-xxl-end {\n    align-content: flex-end !important;\n  }\n\n  .align-content-xxl-center {\n    align-content: center !important;\n  }\n\n  .align-content-xxl-between {\n    align-content: space-between !important;\n  }\n\n  .align-content-xxl-around {\n    align-content: space-around !important;\n  }\n\n  .align-content-xxl-stretch {\n    align-content: stretch !important;\n  }\n\n  .align-self-xxl-auto {\n    align-self: auto !important;\n  }\n\n  .align-self-xxl-start {\n    align-self: flex-start !important;\n  }\n\n  .align-self-xxl-end {\n    align-self: flex-end !important;\n  }\n\n  .align-self-xxl-center {\n    align-self: center !important;\n  }\n\n  .align-self-xxl-baseline {\n    align-self: baseline !important;\n  }\n\n  .align-self-xxl-stretch {\n    align-self: stretch !important;\n  }\n\n  .order-xxl-first {\n    order: -1 !important;\n  }\n\n  .order-xxl-0 {\n    order: 0 !important;\n  }\n\n  .order-xxl-1 {\n    order: 1 !important;\n  }\n\n  .order-xxl-2 {\n    order: 2 !important;\n  }\n\n  .order-xxl-3 {\n    order: 3 !important;\n  }\n\n  .order-xxl-4 {\n    order: 4 !important;\n  }\n\n  .order-xxl-5 {\n    order: 5 !important;\n  }\n\n  .order-xxl-last {\n    order: 6 !important;\n  }\n\n  .m-xxl-0 {\n    margin: 0 !important;\n  }\n\n  .m-xxl-1 {\n    margin: 0.25rem !important;\n  }\n\n  .m-xxl-2 {\n    margin: 0.5rem !important;\n  }\n\n  .m-xxl-3 {\n    margin: 0.75rem !important;\n  }\n\n  .m-xxl-4 {\n    margin: 1rem !important;\n  }\n\n  .m-xxl-5 {\n    margin: 1.25rem !important;\n  }\n\n  .m-xxl-6 {\n    margin: 1.5rem !important;\n  }\n\n  .m-xxl-7 {\n    margin: 1.75rem !important;\n  }\n\n  .m-xxl-8 {\n    margin: 2rem !important;\n  }\n\n  .m-xxl-9 {\n    margin: 2.25rem !important;\n  }\n\n  .m-xxl-10 {\n    margin: 2.5rem !important;\n  }\n\n  .m-xxl-11 {\n    margin: 2.75rem !important;\n  }\n\n  .m-xxl-12 {\n    margin: 3rem !important;\n  }\n\n  .m-xxl-13 {\n    margin: 3.25rem !important;\n  }\n\n  .m-xxl-14 {\n    margin: 3.5rem !important;\n  }\n\n  .m-xxl-15 {\n    margin: 3.75rem !important;\n  }\n\n  .m-xxl-16 {\n    margin: 4rem !important;\n  }\n\n  .m-xxl-17 {\n    margin: 4.25rem !important;\n  }\n\n  .m-xxl-18 {\n    margin: 4.5rem !important;\n  }\n\n  .m-xxl-19 {\n    margin: 4.75rem !important;\n  }\n\n  .m-xxl-20 {\n    margin: 5rem !important;\n  }\n\n  .m-xxl-auto {\n    margin: auto !important;\n  }\n\n  .mx-xxl-0 {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .mx-xxl-1 {\n    margin-right: 0.25rem !important;\n    margin-left: 0.25rem !important;\n  }\n\n  .mx-xxl-2 {\n    margin-right: 0.5rem !important;\n    margin-left: 0.5rem !important;\n  }\n\n  .mx-xxl-3 {\n    margin-right: 0.75rem !important;\n    margin-left: 0.75rem !important;\n  }\n\n  .mx-xxl-4 {\n    margin-right: 1rem !important;\n    margin-left: 1rem !important;\n  }\n\n  .mx-xxl-5 {\n    margin-right: 1.25rem !important;\n    margin-left: 1.25rem !important;\n  }\n\n  .mx-xxl-6 {\n    margin-right: 1.5rem !important;\n    margin-left: 1.5rem !important;\n  }\n\n  .mx-xxl-7 {\n    margin-right: 1.75rem !important;\n    margin-left: 1.75rem !important;\n  }\n\n  .mx-xxl-8 {\n    margin-right: 2rem !important;\n    margin-left: 2rem !important;\n  }\n\n  .mx-xxl-9 {\n    margin-right: 2.25rem !important;\n    margin-left: 2.25rem !important;\n  }\n\n  .mx-xxl-10 {\n    margin-right: 2.5rem !important;\n    margin-left: 2.5rem !important;\n  }\n\n  .mx-xxl-11 {\n    margin-right: 2.75rem !important;\n    margin-left: 2.75rem !important;\n  }\n\n  .mx-xxl-12 {\n    margin-right: 3rem !important;\n    margin-left: 3rem !important;\n  }\n\n  .mx-xxl-13 {\n    margin-right: 3.25rem !important;\n    margin-left: 3.25rem !important;\n  }\n\n  .mx-xxl-14 {\n    margin-right: 3.5rem !important;\n    margin-left: 3.5rem !important;\n  }\n\n  .mx-xxl-15 {\n    margin-right: 3.75rem !important;\n    margin-left: 3.75rem !important;\n  }\n\n  .mx-xxl-16 {\n    margin-right: 4rem !important;\n    margin-left: 4rem !important;\n  }\n\n  .mx-xxl-17 {\n    margin-right: 4.25rem !important;\n    margin-left: 4.25rem !important;\n  }\n\n  .mx-xxl-18 {\n    margin-right: 4.5rem !important;\n    margin-left: 4.5rem !important;\n  }\n\n  .mx-xxl-19 {\n    margin-right: 4.75rem !important;\n    margin-left: 4.75rem !important;\n  }\n\n  .mx-xxl-20 {\n    margin-right: 5rem !important;\n    margin-left: 5rem !important;\n  }\n\n  .mx-xxl-auto {\n    margin-right: auto !important;\n    margin-left: auto !important;\n  }\n\n  .my-xxl-0 {\n    margin-top: 0 !important;\n    margin-bottom: 0 !important;\n  }\n\n  .my-xxl-1 {\n    margin-top: 0.25rem !important;\n    margin-bottom: 0.25rem !important;\n  }\n\n  .my-xxl-2 {\n    margin-top: 0.5rem !important;\n    margin-bottom: 0.5rem !important;\n  }\n\n  .my-xxl-3 {\n    margin-top: 0.75rem !important;\n    margin-bottom: 0.75rem !important;\n  }\n\n  .my-xxl-4 {\n    margin-top: 1rem !important;\n    margin-bottom: 1rem !important;\n  }\n\n  .my-xxl-5 {\n    margin-top: 1.25rem !important;\n    margin-bottom: 1.25rem !important;\n  }\n\n  .my-xxl-6 {\n    margin-top: 1.5rem !important;\n    margin-bottom: 1.5rem !important;\n  }\n\n  .my-xxl-7 {\n    margin-top: 1.75rem !important;\n    margin-bottom: 1.75rem !important;\n  }\n\n  .my-xxl-8 {\n    margin-top: 2rem !important;\n    margin-bottom: 2rem !important;\n  }\n\n  .my-xxl-9 {\n    margin-top: 2.25rem !important;\n    margin-bottom: 2.25rem !important;\n  }\n\n  .my-xxl-10 {\n    margin-top: 2.5rem !important;\n    margin-bottom: 2.5rem !important;\n  }\n\n  .my-xxl-11 {\n    margin-top: 2.75rem !important;\n    margin-bottom: 2.75rem !important;\n  }\n\n  .my-xxl-12 {\n    margin-top: 3rem !important;\n    margin-bottom: 3rem !important;\n  }\n\n  .my-xxl-13 {\n    margin-top: 3.25rem !important;\n    margin-bottom: 3.25rem !important;\n  }\n\n  .my-xxl-14 {\n    margin-top: 3.5rem !important;\n    margin-bottom: 3.5rem !important;\n  }\n\n  .my-xxl-15 {\n    margin-top: 3.75rem !important;\n    margin-bottom: 3.75rem !important;\n  }\n\n  .my-xxl-16 {\n    margin-top: 4rem !important;\n    margin-bottom: 4rem !important;\n  }\n\n  .my-xxl-17 {\n    margin-top: 4.25rem !important;\n    margin-bottom: 4.25rem !important;\n  }\n\n  .my-xxl-18 {\n    margin-top: 4.5rem !important;\n    margin-bottom: 4.5rem !important;\n  }\n\n  .my-xxl-19 {\n    margin-top: 4.75rem !important;\n    margin-bottom: 4.75rem !important;\n  }\n\n  .my-xxl-20 {\n    margin-top: 5rem !important;\n    margin-bottom: 5rem !important;\n  }\n\n  .my-xxl-auto {\n    margin-top: auto !important;\n    margin-bottom: auto !important;\n  }\n\n  .mt-xxl-0 {\n    margin-top: 0 !important;\n  }\n\n  .mt-xxl-1 {\n    margin-top: 0.25rem !important;\n  }\n\n  .mt-xxl-2 {\n    margin-top: 0.5rem !important;\n  }\n\n  .mt-xxl-3 {\n    margin-top: 0.75rem !important;\n  }\n\n  .mt-xxl-4 {\n    margin-top: 1rem !important;\n  }\n\n  .mt-xxl-5 {\n    margin-top: 1.25rem !important;\n  }\n\n  .mt-xxl-6 {\n    margin-top: 1.5rem !important;\n  }\n\n  .mt-xxl-7 {\n    margin-top: 1.75rem !important;\n  }\n\n  .mt-xxl-8 {\n    margin-top: 2rem !important;\n  }\n\n  .mt-xxl-9 {\n    margin-top: 2.25rem !important;\n  }\n\n  .mt-xxl-10 {\n    margin-top: 2.5rem !important;\n  }\n\n  .mt-xxl-11 {\n    margin-top: 2.75rem !important;\n  }\n\n  .mt-xxl-12 {\n    margin-top: 3rem !important;\n  }\n\n  .mt-xxl-13 {\n    margin-top: 3.25rem !important;\n  }\n\n  .mt-xxl-14 {\n    margin-top: 3.5rem !important;\n  }\n\n  .mt-xxl-15 {\n    margin-top: 3.75rem !important;\n  }\n\n  .mt-xxl-16 {\n    margin-top: 4rem !important;\n  }\n\n  .mt-xxl-17 {\n    margin-top: 4.25rem !important;\n  }\n\n  .mt-xxl-18 {\n    margin-top: 4.5rem !important;\n  }\n\n  .mt-xxl-19 {\n    margin-top: 4.75rem !important;\n  }\n\n  .mt-xxl-20 {\n    margin-top: 5rem !important;\n  }\n\n  .mt-xxl-auto {\n    margin-top: auto !important;\n  }\n\n  .me-xxl-0 {\n    margin-right: 0 !important;\n  }\n\n  .me-xxl-1 {\n    margin-right: 0.25rem !important;\n  }\n\n  .me-xxl-2 {\n    margin-right: 0.5rem !important;\n  }\n\n  .me-xxl-3 {\n    margin-right: 0.75rem !important;\n  }\n\n  .me-xxl-4 {\n    margin-right: 1rem !important;\n  }\n\n  .me-xxl-5 {\n    margin-right: 1.25rem !important;\n  }\n\n  .me-xxl-6 {\n    margin-right: 1.5rem !important;\n  }\n\n  .me-xxl-7 {\n    margin-right: 1.75rem !important;\n  }\n\n  .me-xxl-8 {\n    margin-right: 2rem !important;\n  }\n\n  .me-xxl-9 {\n    margin-right: 2.25rem !important;\n  }\n\n  .me-xxl-10 {\n    margin-right: 2.5rem !important;\n  }\n\n  .me-xxl-11 {\n    margin-right: 2.75rem !important;\n  }\n\n  .me-xxl-12 {\n    margin-right: 3rem !important;\n  }\n\n  .me-xxl-13 {\n    margin-right: 3.25rem !important;\n  }\n\n  .me-xxl-14 {\n    margin-right: 3.5rem !important;\n  }\n\n  .me-xxl-15 {\n    margin-right: 3.75rem !important;\n  }\n\n  .me-xxl-16 {\n    margin-right: 4rem !important;\n  }\n\n  .me-xxl-17 {\n    margin-right: 4.25rem !important;\n  }\n\n  .me-xxl-18 {\n    margin-right: 4.5rem !important;\n  }\n\n  .me-xxl-19 {\n    margin-right: 4.75rem !important;\n  }\n\n  .me-xxl-20 {\n    margin-right: 5rem !important;\n  }\n\n  .me-xxl-auto {\n    margin-right: auto !important;\n  }\n\n  .mb-xxl-0 {\n    margin-bottom: 0 !important;\n  }\n\n  .mb-xxl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n\n  .mb-xxl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n\n  .mb-xxl-3 {\n    margin-bottom: 0.75rem !important;\n  }\n\n  .mb-xxl-4 {\n    margin-bottom: 1rem !important;\n  }\n\n  .mb-xxl-5 {\n    margin-bottom: 1.25rem !important;\n  }\n\n  .mb-xxl-6 {\n    margin-bottom: 1.5rem !important;\n  }\n\n  .mb-xxl-7 {\n    margin-bottom: 1.75rem !important;\n  }\n\n  .mb-xxl-8 {\n    margin-bottom: 2rem !important;\n  }\n\n  .mb-xxl-9 {\n    margin-bottom: 2.25rem !important;\n  }\n\n  .mb-xxl-10 {\n    margin-bottom: 2.5rem !important;\n  }\n\n  .mb-xxl-11 {\n    margin-bottom: 2.75rem !important;\n  }\n\n  .mb-xxl-12 {\n    margin-bottom: 3rem !important;\n  }\n\n  .mb-xxl-13 {\n    margin-bottom: 3.25rem !important;\n  }\n\n  .mb-xxl-14 {\n    margin-bottom: 3.5rem !important;\n  }\n\n  .mb-xxl-15 {\n    margin-bottom: 3.75rem !important;\n  }\n\n  .mb-xxl-16 {\n    margin-bottom: 4rem !important;\n  }\n\n  .mb-xxl-17 {\n    margin-bottom: 4.25rem !important;\n  }\n\n  .mb-xxl-18 {\n    margin-bottom: 4.5rem !important;\n  }\n\n  .mb-xxl-19 {\n    margin-bottom: 4.75rem !important;\n  }\n\n  .mb-xxl-20 {\n    margin-bottom: 5rem !important;\n  }\n\n  .mb-xxl-auto {\n    margin-bottom: auto !important;\n  }\n\n  .ms-xxl-0 {\n    margin-left: 0 !important;\n  }\n\n  .ms-xxl-1 {\n    margin-left: 0.25rem !important;\n  }\n\n  .ms-xxl-2 {\n    margin-left: 0.5rem !important;\n  }\n\n  .ms-xxl-3 {\n    margin-left: 0.75rem !important;\n  }\n\n  .ms-xxl-4 {\n    margin-left: 1rem !important;\n  }\n\n  .ms-xxl-5 {\n    margin-left: 1.25rem !important;\n  }\n\n  .ms-xxl-6 {\n    margin-left: 1.5rem !important;\n  }\n\n  .ms-xxl-7 {\n    margin-left: 1.75rem !important;\n  }\n\n  .ms-xxl-8 {\n    margin-left: 2rem !important;\n  }\n\n  .ms-xxl-9 {\n    margin-left: 2.25rem !important;\n  }\n\n  .ms-xxl-10 {\n    margin-left: 2.5rem !important;\n  }\n\n  .ms-xxl-11 {\n    margin-left: 2.75rem !important;\n  }\n\n  .ms-xxl-12 {\n    margin-left: 3rem !important;\n  }\n\n  .ms-xxl-13 {\n    margin-left: 3.25rem !important;\n  }\n\n  .ms-xxl-14 {\n    margin-left: 3.5rem !important;\n  }\n\n  .ms-xxl-15 {\n    margin-left: 3.75rem !important;\n  }\n\n  .ms-xxl-16 {\n    margin-left: 4rem !important;\n  }\n\n  .ms-xxl-17 {\n    margin-left: 4.25rem !important;\n  }\n\n  .ms-xxl-18 {\n    margin-left: 4.5rem !important;\n  }\n\n  .ms-xxl-19 {\n    margin-left: 4.75rem !important;\n  }\n\n  .ms-xxl-20 {\n    margin-left: 5rem !important;\n  }\n\n  .ms-xxl-auto {\n    margin-left: auto !important;\n  }\n\n  .m-xxl-n1 {\n    margin: -0.25rem !important;\n  }\n\n  .m-xxl-n2 {\n    margin: -0.5rem !important;\n  }\n\n  .m-xxl-n3 {\n    margin: -0.75rem !important;\n  }\n\n  .m-xxl-n4 {\n    margin: -1rem !important;\n  }\n\n  .m-xxl-n5 {\n    margin: -1.25rem !important;\n  }\n\n  .m-xxl-n6 {\n    margin: -1.5rem !important;\n  }\n\n  .m-xxl-n7 {\n    margin: -1.75rem !important;\n  }\n\n  .m-xxl-n8 {\n    margin: -2rem !important;\n  }\n\n  .m-xxl-n9 {\n    margin: -2.25rem !important;\n  }\n\n  .m-xxl-n10 {\n    margin: -2.5rem !important;\n  }\n\n  .m-xxl-n11 {\n    margin: -2.75rem !important;\n  }\n\n  .m-xxl-n12 {\n    margin: -3rem !important;\n  }\n\n  .m-xxl-n13 {\n    margin: -3.25rem !important;\n  }\n\n  .m-xxl-n14 {\n    margin: -3.5rem !important;\n  }\n\n  .m-xxl-n15 {\n    margin: -3.75rem !important;\n  }\n\n  .m-xxl-n16 {\n    margin: -4rem !important;\n  }\n\n  .m-xxl-n17 {\n    margin: -4.25rem !important;\n  }\n\n  .m-xxl-n18 {\n    margin: -4.5rem !important;\n  }\n\n  .m-xxl-n19 {\n    margin: -4.75rem !important;\n  }\n\n  .m-xxl-n20 {\n    margin: -5rem !important;\n  }\n\n  .mx-xxl-n1 {\n    margin-right: -0.25rem !important;\n    margin-left: -0.25rem !important;\n  }\n\n  .mx-xxl-n2 {\n    margin-right: -0.5rem !important;\n    margin-left: -0.5rem !important;\n  }\n\n  .mx-xxl-n3 {\n    margin-right: -0.75rem !important;\n    margin-left: -0.75rem !important;\n  }\n\n  .mx-xxl-n4 {\n    margin-right: -1rem !important;\n    margin-left: -1rem !important;\n  }\n\n  .mx-xxl-n5 {\n    margin-right: -1.25rem !important;\n    margin-left: -1.25rem !important;\n  }\n\n  .mx-xxl-n6 {\n    margin-right: -1.5rem !important;\n    margin-left: -1.5rem !important;\n  }\n\n  .mx-xxl-n7 {\n    margin-right: -1.75rem !important;\n    margin-left: -1.75rem !important;\n  }\n\n  .mx-xxl-n8 {\n    margin-right: -2rem !important;\n    margin-left: -2rem !important;\n  }\n\n  .mx-xxl-n9 {\n    margin-right: -2.25rem !important;\n    margin-left: -2.25rem !important;\n  }\n\n  .mx-xxl-n10 {\n    margin-right: -2.5rem !important;\n    margin-left: -2.5rem !important;\n  }\n\n  .mx-xxl-n11 {\n    margin-right: -2.75rem !important;\n    margin-left: -2.75rem !important;\n  }\n\n  .mx-xxl-n12 {\n    margin-right: -3rem !important;\n    margin-left: -3rem !important;\n  }\n\n  .mx-xxl-n13 {\n    margin-right: -3.25rem !important;\n    margin-left: -3.25rem !important;\n  }\n\n  .mx-xxl-n14 {\n    margin-right: -3.5rem !important;\n    margin-left: -3.5rem !important;\n  }\n\n  .mx-xxl-n15 {\n    margin-right: -3.75rem !important;\n    margin-left: -3.75rem !important;\n  }\n\n  .mx-xxl-n16 {\n    margin-right: -4rem !important;\n    margin-left: -4rem !important;\n  }\n\n  .mx-xxl-n17 {\n    margin-right: -4.25rem !important;\n    margin-left: -4.25rem !important;\n  }\n\n  .mx-xxl-n18 {\n    margin-right: -4.5rem !important;\n    margin-left: -4.5rem !important;\n  }\n\n  .mx-xxl-n19 {\n    margin-right: -4.75rem !important;\n    margin-left: -4.75rem !important;\n  }\n\n  .mx-xxl-n20 {\n    margin-right: -5rem !important;\n    margin-left: -5rem !important;\n  }\n\n  .my-xxl-n1 {\n    margin-top: -0.25rem !important;\n    margin-bottom: -0.25rem !important;\n  }\n\n  .my-xxl-n2 {\n    margin-top: -0.5rem !important;\n    margin-bottom: -0.5rem !important;\n  }\n\n  .my-xxl-n3 {\n    margin-top: -0.75rem !important;\n    margin-bottom: -0.75rem !important;\n  }\n\n  .my-xxl-n4 {\n    margin-top: -1rem !important;\n    margin-bottom: -1rem !important;\n  }\n\n  .my-xxl-n5 {\n    margin-top: -1.25rem !important;\n    margin-bottom: -1.25rem !important;\n  }\n\n  .my-xxl-n6 {\n    margin-top: -1.5rem !important;\n    margin-bottom: -1.5rem !important;\n  }\n\n  .my-xxl-n7 {\n    margin-top: -1.75rem !important;\n    margin-bottom: -1.75rem !important;\n  }\n\n  .my-xxl-n8 {\n    margin-top: -2rem !important;\n    margin-bottom: -2rem !important;\n  }\n\n  .my-xxl-n9 {\n    margin-top: -2.25rem !important;\n    margin-bottom: -2.25rem !important;\n  }\n\n  .my-xxl-n10 {\n    margin-top: -2.5rem !important;\n    margin-bottom: -2.5rem !important;\n  }\n\n  .my-xxl-n11 {\n    margin-top: -2.75rem !important;\n    margin-bottom: -2.75rem !important;\n  }\n\n  .my-xxl-n12 {\n    margin-top: -3rem !important;\n    margin-bottom: -3rem !important;\n  }\n\n  .my-xxl-n13 {\n    margin-top: -3.25rem !important;\n    margin-bottom: -3.25rem !important;\n  }\n\n  .my-xxl-n14 {\n    margin-top: -3.5rem !important;\n    margin-bottom: -3.5rem !important;\n  }\n\n  .my-xxl-n15 {\n    margin-top: -3.75rem !important;\n    margin-bottom: -3.75rem !important;\n  }\n\n  .my-xxl-n16 {\n    margin-top: -4rem !important;\n    margin-bottom: -4rem !important;\n  }\n\n  .my-xxl-n17 {\n    margin-top: -4.25rem !important;\n    margin-bottom: -4.25rem !important;\n  }\n\n  .my-xxl-n18 {\n    margin-top: -4.5rem !important;\n    margin-bottom: -4.5rem !important;\n  }\n\n  .my-xxl-n19 {\n    margin-top: -4.75rem !important;\n    margin-bottom: -4.75rem !important;\n  }\n\n  .my-xxl-n20 {\n    margin-top: -5rem !important;\n    margin-bottom: -5rem !important;\n  }\n\n  .mt-xxl-n1 {\n    margin-top: -0.25rem !important;\n  }\n\n  .mt-xxl-n2 {\n    margin-top: -0.5rem !important;\n  }\n\n  .mt-xxl-n3 {\n    margin-top: -0.75rem !important;\n  }\n\n  .mt-xxl-n4 {\n    margin-top: -1rem !important;\n  }\n\n  .mt-xxl-n5 {\n    margin-top: -1.25rem !important;\n  }\n\n  .mt-xxl-n6 {\n    margin-top: -1.5rem !important;\n  }\n\n  .mt-xxl-n7 {\n    margin-top: -1.75rem !important;\n  }\n\n  .mt-xxl-n8 {\n    margin-top: -2rem !important;\n  }\n\n  .mt-xxl-n9 {\n    margin-top: -2.25rem !important;\n  }\n\n  .mt-xxl-n10 {\n    margin-top: -2.5rem !important;\n  }\n\n  .mt-xxl-n11 {\n    margin-top: -2.75rem !important;\n  }\n\n  .mt-xxl-n12 {\n    margin-top: -3rem !important;\n  }\n\n  .mt-xxl-n13 {\n    margin-top: -3.25rem !important;\n  }\n\n  .mt-xxl-n14 {\n    margin-top: -3.5rem !important;\n  }\n\n  .mt-xxl-n15 {\n    margin-top: -3.75rem !important;\n  }\n\n  .mt-xxl-n16 {\n    margin-top: -4rem !important;\n  }\n\n  .mt-xxl-n17 {\n    margin-top: -4.25rem !important;\n  }\n\n  .mt-xxl-n18 {\n    margin-top: -4.5rem !important;\n  }\n\n  .mt-xxl-n19 {\n    margin-top: -4.75rem !important;\n  }\n\n  .mt-xxl-n20 {\n    margin-top: -5rem !important;\n  }\n\n  .me-xxl-n1 {\n    margin-right: -0.25rem !important;\n  }\n\n  .me-xxl-n2 {\n    margin-right: -0.5rem !important;\n  }\n\n  .me-xxl-n3 {\n    margin-right: -0.75rem !important;\n  }\n\n  .me-xxl-n4 {\n    margin-right: -1rem !important;\n  }\n\n  .me-xxl-n5 {\n    margin-right: -1.25rem !important;\n  }\n\n  .me-xxl-n6 {\n    margin-right: -1.5rem !important;\n  }\n\n  .me-xxl-n7 {\n    margin-right: -1.75rem !important;\n  }\n\n  .me-xxl-n8 {\n    margin-right: -2rem !important;\n  }\n\n  .me-xxl-n9 {\n    margin-right: -2.25rem !important;\n  }\n\n  .me-xxl-n10 {\n    margin-right: -2.5rem !important;\n  }\n\n  .me-xxl-n11 {\n    margin-right: -2.75rem !important;\n  }\n\n  .me-xxl-n12 {\n    margin-right: -3rem !important;\n  }\n\n  .me-xxl-n13 {\n    margin-right: -3.25rem !important;\n  }\n\n  .me-xxl-n14 {\n    margin-right: -3.5rem !important;\n  }\n\n  .me-xxl-n15 {\n    margin-right: -3.75rem !important;\n  }\n\n  .me-xxl-n16 {\n    margin-right: -4rem !important;\n  }\n\n  .me-xxl-n17 {\n    margin-right: -4.25rem !important;\n  }\n\n  .me-xxl-n18 {\n    margin-right: -4.5rem !important;\n  }\n\n  .me-xxl-n19 {\n    margin-right: -4.75rem !important;\n  }\n\n  .me-xxl-n20 {\n    margin-right: -5rem !important;\n  }\n\n  .mb-xxl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n\n  .mb-xxl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n\n  .mb-xxl-n3 {\n    margin-bottom: -0.75rem !important;\n  }\n\n  .mb-xxl-n4 {\n    margin-bottom: -1rem !important;\n  }\n\n  .mb-xxl-n5 {\n    margin-bottom: -1.25rem !important;\n  }\n\n  .mb-xxl-n6 {\n    margin-bottom: -1.5rem !important;\n  }\n\n  .mb-xxl-n7 {\n    margin-bottom: -1.75rem !important;\n  }\n\n  .mb-xxl-n8 {\n    margin-bottom: -2rem !important;\n  }\n\n  .mb-xxl-n9 {\n    margin-bottom: -2.25rem !important;\n  }\n\n  .mb-xxl-n10 {\n    margin-bottom: -2.5rem !important;\n  }\n\n  .mb-xxl-n11 {\n    margin-bottom: -2.75rem !important;\n  }\n\n  .mb-xxl-n12 {\n    margin-bottom: -3rem !important;\n  }\n\n  .mb-xxl-n13 {\n    margin-bottom: -3.25rem !important;\n  }\n\n  .mb-xxl-n14 {\n    margin-bottom: -3.5rem !important;\n  }\n\n  .mb-xxl-n15 {\n    margin-bottom: -3.75rem !important;\n  }\n\n  .mb-xxl-n16 {\n    margin-bottom: -4rem !important;\n  }\n\n  .mb-xxl-n17 {\n    margin-bottom: -4.25rem !important;\n  }\n\n  .mb-xxl-n18 {\n    margin-bottom: -4.5rem !important;\n  }\n\n  .mb-xxl-n19 {\n    margin-bottom: -4.75rem !important;\n  }\n\n  .mb-xxl-n20 {\n    margin-bottom: -5rem !important;\n  }\n\n  .ms-xxl-n1 {\n    margin-left: -0.25rem !important;\n  }\n\n  .ms-xxl-n2 {\n    margin-left: -0.5rem !important;\n  }\n\n  .ms-xxl-n3 {\n    margin-left: -0.75rem !important;\n  }\n\n  .ms-xxl-n4 {\n    margin-left: -1rem !important;\n  }\n\n  .ms-xxl-n5 {\n    margin-left: -1.25rem !important;\n  }\n\n  .ms-xxl-n6 {\n    margin-left: -1.5rem !important;\n  }\n\n  .ms-xxl-n7 {\n    margin-left: -1.75rem !important;\n  }\n\n  .ms-xxl-n8 {\n    margin-left: -2rem !important;\n  }\n\n  .ms-xxl-n9 {\n    margin-left: -2.25rem !important;\n  }\n\n  .ms-xxl-n10 {\n    margin-left: -2.5rem !important;\n  }\n\n  .ms-xxl-n11 {\n    margin-left: -2.75rem !important;\n  }\n\n  .ms-xxl-n12 {\n    margin-left: -3rem !important;\n  }\n\n  .ms-xxl-n13 {\n    margin-left: -3.25rem !important;\n  }\n\n  .ms-xxl-n14 {\n    margin-left: -3.5rem !important;\n  }\n\n  .ms-xxl-n15 {\n    margin-left: -3.75rem !important;\n  }\n\n  .ms-xxl-n16 {\n    margin-left: -4rem !important;\n  }\n\n  .ms-xxl-n17 {\n    margin-left: -4.25rem !important;\n  }\n\n  .ms-xxl-n18 {\n    margin-left: -4.5rem !important;\n  }\n\n  .ms-xxl-n19 {\n    margin-left: -4.75rem !important;\n  }\n\n  .ms-xxl-n20 {\n    margin-left: -5rem !important;\n  }\n\n  .p-xxl-0 {\n    padding: 0 !important;\n  }\n\n  .p-xxl-1 {\n    padding: 0.25rem !important;\n  }\n\n  .p-xxl-2 {\n    padding: 0.5rem !important;\n  }\n\n  .p-xxl-3 {\n    padding: 0.75rem !important;\n  }\n\n  .p-xxl-4 {\n    padding: 1rem !important;\n  }\n\n  .p-xxl-5 {\n    padding: 1.25rem !important;\n  }\n\n  .p-xxl-6 {\n    padding: 1.5rem !important;\n  }\n\n  .p-xxl-7 {\n    padding: 1.75rem !important;\n  }\n\n  .p-xxl-8 {\n    padding: 2rem !important;\n  }\n\n  .p-xxl-9 {\n    padding: 2.25rem !important;\n  }\n\n  .p-xxl-10 {\n    padding: 2.5rem !important;\n  }\n\n  .p-xxl-11 {\n    padding: 2.75rem !important;\n  }\n\n  .p-xxl-12 {\n    padding: 3rem !important;\n  }\n\n  .p-xxl-13 {\n    padding: 3.25rem !important;\n  }\n\n  .p-xxl-14 {\n    padding: 3.5rem !important;\n  }\n\n  .p-xxl-15 {\n    padding: 3.75rem !important;\n  }\n\n  .p-xxl-16 {\n    padding: 4rem !important;\n  }\n\n  .p-xxl-17 {\n    padding: 4.25rem !important;\n  }\n\n  .p-xxl-18 {\n    padding: 4.5rem !important;\n  }\n\n  .p-xxl-19 {\n    padding: 4.75rem !important;\n  }\n\n  .p-xxl-20 {\n    padding: 5rem !important;\n  }\n\n  .px-xxl-0 {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .px-xxl-1 {\n    padding-right: 0.25rem !important;\n    padding-left: 0.25rem !important;\n  }\n\n  .px-xxl-2 {\n    padding-right: 0.5rem !important;\n    padding-left: 0.5rem !important;\n  }\n\n  .px-xxl-3 {\n    padding-right: 0.75rem !important;\n    padding-left: 0.75rem !important;\n  }\n\n  .px-xxl-4 {\n    padding-right: 1rem !important;\n    padding-left: 1rem !important;\n  }\n\n  .px-xxl-5 {\n    padding-right: 1.25rem !important;\n    padding-left: 1.25rem !important;\n  }\n\n  .px-xxl-6 {\n    padding-right: 1.5rem !important;\n    padding-left: 1.5rem !important;\n  }\n\n  .px-xxl-7 {\n    padding-right: 1.75rem !important;\n    padding-left: 1.75rem !important;\n  }\n\n  .px-xxl-8 {\n    padding-right: 2rem !important;\n    padding-left: 2rem !important;\n  }\n\n  .px-xxl-9 {\n    padding-right: 2.25rem !important;\n    padding-left: 2.25rem !important;\n  }\n\n  .px-xxl-10 {\n    padding-right: 2.5rem !important;\n    padding-left: 2.5rem !important;\n  }\n\n  .px-xxl-11 {\n    padding-right: 2.75rem !important;\n    padding-left: 2.75rem !important;\n  }\n\n  .px-xxl-12 {\n    padding-right: 3rem !important;\n    padding-left: 3rem !important;\n  }\n\n  .px-xxl-13 {\n    padding-right: 3.25rem !important;\n    padding-left: 3.25rem !important;\n  }\n\n  .px-xxl-14 {\n    padding-right: 3.5rem !important;\n    padding-left: 3.5rem !important;\n  }\n\n  .px-xxl-15 {\n    padding-right: 3.75rem !important;\n    padding-left: 3.75rem !important;\n  }\n\n  .px-xxl-16 {\n    padding-right: 4rem !important;\n    padding-left: 4rem !important;\n  }\n\n  .px-xxl-17 {\n    padding-right: 4.25rem !important;\n    padding-left: 4.25rem !important;\n  }\n\n  .px-xxl-18 {\n    padding-right: 4.5rem !important;\n    padding-left: 4.5rem !important;\n  }\n\n  .px-xxl-19 {\n    padding-right: 4.75rem !important;\n    padding-left: 4.75rem !important;\n  }\n\n  .px-xxl-20 {\n    padding-right: 5rem !important;\n    padding-left: 5rem !important;\n  }\n\n  .py-xxl-0 {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n  }\n\n  .py-xxl-1 {\n    padding-top: 0.25rem !important;\n    padding-bottom: 0.25rem !important;\n  }\n\n  .py-xxl-2 {\n    padding-top: 0.5rem !important;\n    padding-bottom: 0.5rem !important;\n  }\n\n  .py-xxl-3 {\n    padding-top: 0.75rem !important;\n    padding-bottom: 0.75rem !important;\n  }\n\n  .py-xxl-4 {\n    padding-top: 1rem !important;\n    padding-bottom: 1rem !important;\n  }\n\n  .py-xxl-5 {\n    padding-top: 1.25rem !important;\n    padding-bottom: 1.25rem !important;\n  }\n\n  .py-xxl-6 {\n    padding-top: 1.5rem !important;\n    padding-bottom: 1.5rem !important;\n  }\n\n  .py-xxl-7 {\n    padding-top: 1.75rem !important;\n    padding-bottom: 1.75rem !important;\n  }\n\n  .py-xxl-8 {\n    padding-top: 2rem !important;\n    padding-bottom: 2rem !important;\n  }\n\n  .py-xxl-9 {\n    padding-top: 2.25rem !important;\n    padding-bottom: 2.25rem !important;\n  }\n\n  .py-xxl-10 {\n    padding-top: 2.5rem !important;\n    padding-bottom: 2.5rem !important;\n  }\n\n  .py-xxl-11 {\n    padding-top: 2.75rem !important;\n    padding-bottom: 2.75rem !important;\n  }\n\n  .py-xxl-12 {\n    padding-top: 3rem !important;\n    padding-bottom: 3rem !important;\n  }\n\n  .py-xxl-13 {\n    padding-top: 3.25rem !important;\n    padding-bottom: 3.25rem !important;\n  }\n\n  .py-xxl-14 {\n    padding-top: 3.5rem !important;\n    padding-bottom: 3.5rem !important;\n  }\n\n  .py-xxl-15 {\n    padding-top: 3.75rem !important;\n    padding-bottom: 3.75rem !important;\n  }\n\n  .py-xxl-16 {\n    padding-top: 4rem !important;\n    padding-bottom: 4rem !important;\n  }\n\n  .py-xxl-17 {\n    padding-top: 4.25rem !important;\n    padding-bottom: 4.25rem !important;\n  }\n\n  .py-xxl-18 {\n    padding-top: 4.5rem !important;\n    padding-bottom: 4.5rem !important;\n  }\n\n  .py-xxl-19 {\n    padding-top: 4.75rem !important;\n    padding-bottom: 4.75rem !important;\n  }\n\n  .py-xxl-20 {\n    padding-top: 5rem !important;\n    padding-bottom: 5rem !important;\n  }\n\n  .pt-xxl-0 {\n    padding-top: 0 !important;\n  }\n\n  .pt-xxl-1 {\n    padding-top: 0.25rem !important;\n  }\n\n  .pt-xxl-2 {\n    padding-top: 0.5rem !important;\n  }\n\n  .pt-xxl-3 {\n    padding-top: 0.75rem !important;\n  }\n\n  .pt-xxl-4 {\n    padding-top: 1rem !important;\n  }\n\n  .pt-xxl-5 {\n    padding-top: 1.25rem !important;\n  }\n\n  .pt-xxl-6 {\n    padding-top: 1.5rem !important;\n  }\n\n  .pt-xxl-7 {\n    padding-top: 1.75rem !important;\n  }\n\n  .pt-xxl-8 {\n    padding-top: 2rem !important;\n  }\n\n  .pt-xxl-9 {\n    padding-top: 2.25rem !important;\n  }\n\n  .pt-xxl-10 {\n    padding-top: 2.5rem !important;\n  }\n\n  .pt-xxl-11 {\n    padding-top: 2.75rem !important;\n  }\n\n  .pt-xxl-12 {\n    padding-top: 3rem !important;\n  }\n\n  .pt-xxl-13 {\n    padding-top: 3.25rem !important;\n  }\n\n  .pt-xxl-14 {\n    padding-top: 3.5rem !important;\n  }\n\n  .pt-xxl-15 {\n    padding-top: 3.75rem !important;\n  }\n\n  .pt-xxl-16 {\n    padding-top: 4rem !important;\n  }\n\n  .pt-xxl-17 {\n    padding-top: 4.25rem !important;\n  }\n\n  .pt-xxl-18 {\n    padding-top: 4.5rem !important;\n  }\n\n  .pt-xxl-19 {\n    padding-top: 4.75rem !important;\n  }\n\n  .pt-xxl-20 {\n    padding-top: 5rem !important;\n  }\n\n  .pe-xxl-0 {\n    padding-right: 0 !important;\n  }\n\n  .pe-xxl-1 {\n    padding-right: 0.25rem !important;\n  }\n\n  .pe-xxl-2 {\n    padding-right: 0.5rem !important;\n  }\n\n  .pe-xxl-3 {\n    padding-right: 0.75rem !important;\n  }\n\n  .pe-xxl-4 {\n    padding-right: 1rem !important;\n  }\n\n  .pe-xxl-5 {\n    padding-right: 1.25rem !important;\n  }\n\n  .pe-xxl-6 {\n    padding-right: 1.5rem !important;\n  }\n\n  .pe-xxl-7 {\n    padding-right: 1.75rem !important;\n  }\n\n  .pe-xxl-8 {\n    padding-right: 2rem !important;\n  }\n\n  .pe-xxl-9 {\n    padding-right: 2.25rem !important;\n  }\n\n  .pe-xxl-10 {\n    padding-right: 2.5rem !important;\n  }\n\n  .pe-xxl-11 {\n    padding-right: 2.75rem !important;\n  }\n\n  .pe-xxl-12 {\n    padding-right: 3rem !important;\n  }\n\n  .pe-xxl-13 {\n    padding-right: 3.25rem !important;\n  }\n\n  .pe-xxl-14 {\n    padding-right: 3.5rem !important;\n  }\n\n  .pe-xxl-15 {\n    padding-right: 3.75rem !important;\n  }\n\n  .pe-xxl-16 {\n    padding-right: 4rem !important;\n  }\n\n  .pe-xxl-17 {\n    padding-right: 4.25rem !important;\n  }\n\n  .pe-xxl-18 {\n    padding-right: 4.5rem !important;\n  }\n\n  .pe-xxl-19 {\n    padding-right: 4.75rem !important;\n  }\n\n  .pe-xxl-20 {\n    padding-right: 5rem !important;\n  }\n\n  .pb-xxl-0 {\n    padding-bottom: 0 !important;\n  }\n\n  .pb-xxl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n\n  .pb-xxl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n\n  .pb-xxl-3 {\n    padding-bottom: 0.75rem !important;\n  }\n\n  .pb-xxl-4 {\n    padding-bottom: 1rem !important;\n  }\n\n  .pb-xxl-5 {\n    padding-bottom: 1.25rem !important;\n  }\n\n  .pb-xxl-6 {\n    padding-bottom: 1.5rem !important;\n  }\n\n  .pb-xxl-7 {\n    padding-bottom: 1.75rem !important;\n  }\n\n  .pb-xxl-8 {\n    padding-bottom: 2rem !important;\n  }\n\n  .pb-xxl-9 {\n    padding-bottom: 2.25rem !important;\n  }\n\n  .pb-xxl-10 {\n    padding-bottom: 2.5rem !important;\n  }\n\n  .pb-xxl-11 {\n    padding-bottom: 2.75rem !important;\n  }\n\n  .pb-xxl-12 {\n    padding-bottom: 3rem !important;\n  }\n\n  .pb-xxl-13 {\n    padding-bottom: 3.25rem !important;\n  }\n\n  .pb-xxl-14 {\n    padding-bottom: 3.5rem !important;\n  }\n\n  .pb-xxl-15 {\n    padding-bottom: 3.75rem !important;\n  }\n\n  .pb-xxl-16 {\n    padding-bottom: 4rem !important;\n  }\n\n  .pb-xxl-17 {\n    padding-bottom: 4.25rem !important;\n  }\n\n  .pb-xxl-18 {\n    padding-bottom: 4.5rem !important;\n  }\n\n  .pb-xxl-19 {\n    padding-bottom: 4.75rem !important;\n  }\n\n  .pb-xxl-20 {\n    padding-bottom: 5rem !important;\n  }\n\n  .ps-xxl-0 {\n    padding-left: 0 !important;\n  }\n\n  .ps-xxl-1 {\n    padding-left: 0.25rem !important;\n  }\n\n  .ps-xxl-2 {\n    padding-left: 0.5rem !important;\n  }\n\n  .ps-xxl-3 {\n    padding-left: 0.75rem !important;\n  }\n\n  .ps-xxl-4 {\n    padding-left: 1rem !important;\n  }\n\n  .ps-xxl-5 {\n    padding-left: 1.25rem !important;\n  }\n\n  .ps-xxl-6 {\n    padding-left: 1.5rem !important;\n  }\n\n  .ps-xxl-7 {\n    padding-left: 1.75rem !important;\n  }\n\n  .ps-xxl-8 {\n    padding-left: 2rem !important;\n  }\n\n  .ps-xxl-9 {\n    padding-left: 2.25rem !important;\n  }\n\n  .ps-xxl-10 {\n    padding-left: 2.5rem !important;\n  }\n\n  .ps-xxl-11 {\n    padding-left: 2.75rem !important;\n  }\n\n  .ps-xxl-12 {\n    padding-left: 3rem !important;\n  }\n\n  .ps-xxl-13 {\n    padding-left: 3.25rem !important;\n  }\n\n  .ps-xxl-14 {\n    padding-left: 3.5rem !important;\n  }\n\n  .ps-xxl-15 {\n    padding-left: 3.75rem !important;\n  }\n\n  .ps-xxl-16 {\n    padding-left: 4rem !important;\n  }\n\n  .ps-xxl-17 {\n    padding-left: 4.25rem !important;\n  }\n\n  .ps-xxl-18 {\n    padding-left: 4.5rem !important;\n  }\n\n  .ps-xxl-19 {\n    padding-left: 4.75rem !important;\n  }\n\n  .ps-xxl-20 {\n    padding-left: 5rem !important;\n  }\n\n  .gap-xxl-0 {\n    gap: 0 !important;\n  }\n\n  .gap-xxl-1 {\n    gap: 0.25rem !important;\n  }\n\n  .gap-xxl-2 {\n    gap: 0.5rem !important;\n  }\n\n  .gap-xxl-3 {\n    gap: 0.75rem !important;\n  }\n\n  .gap-xxl-4 {\n    gap: 1rem !important;\n  }\n\n  .gap-xxl-5 {\n    gap: 1.25rem !important;\n  }\n\n  .gap-xxl-6 {\n    gap: 1.5rem !important;\n  }\n\n  .gap-xxl-7 {\n    gap: 1.75rem !important;\n  }\n\n  .gap-xxl-8 {\n    gap: 2rem !important;\n  }\n\n  .gap-xxl-9 {\n    gap: 2.25rem !important;\n  }\n\n  .gap-xxl-10 {\n    gap: 2.5rem !important;\n  }\n\n  .gap-xxl-11 {\n    gap: 2.75rem !important;\n  }\n\n  .gap-xxl-12 {\n    gap: 3rem !important;\n  }\n\n  .gap-xxl-13 {\n    gap: 3.25rem !important;\n  }\n\n  .gap-xxl-14 {\n    gap: 3.5rem !important;\n  }\n\n  .gap-xxl-15 {\n    gap: 3.75rem !important;\n  }\n\n  .gap-xxl-16 {\n    gap: 4rem !important;\n  }\n\n  .gap-xxl-17 {\n    gap: 4.25rem !important;\n  }\n\n  .gap-xxl-18 {\n    gap: 4.5rem !important;\n  }\n\n  .gap-xxl-19 {\n    gap: 4.75rem !important;\n  }\n\n  .gap-xxl-20 {\n    gap: 5rem !important;\n  }\n\n  .fs-xxl-1 {\n    font-size: calc(1.3rem + 0.6vw) !important;\n  }\n\n  .fs-xxl-2 {\n    font-size: calc(1.275rem + 0.3vw) !important;\n  }\n\n  .fs-xxl-3 {\n    font-size: calc(1.26rem + 0.12vw) !important;\n  }\n\n  .fs-xxl-4 {\n    font-size: 1.25rem !important;\n  }\n\n  .fs-xxl-5 {\n    font-size: 1.15rem !important;\n  }\n\n  .fs-xxl-6 {\n    font-size: 1.075rem !important;\n  }\n\n  .fs-xxl-7 {\n    font-size: 0.95rem !important;\n  }\n\n  .fs-xxl-8 {\n    font-size: 0.85rem !important;\n  }\n\n  .fs-xxl-9 {\n    font-size: 0.75rem !important;\n  }\n\n  .fs-xxl-10 {\n    font-size: 0.5rem !important;\n  }\n\n  .fs-xxl-base {\n    font-size: 1rem !important;\n  }\n\n  .fs-xxl-fluid {\n    font-size: 100% !important;\n  }\n\n  .fs-xxl-2x {\n    font-size: calc(1.325rem + 0.9vw) !important;\n  }\n\n  .fs-xxl-2qx {\n    font-size: calc(1.35rem + 1.2vw) !important;\n  }\n\n  .fs-xxl-2hx {\n    font-size: calc(1.375rem + 1.5vw) !important;\n  }\n\n  .fs-xxl-2tx {\n    font-size: calc(1.4rem + 1.8vw) !important;\n  }\n\n  .fs-xxl-3x {\n    font-size: calc(1.425rem + 2.1vw) !important;\n  }\n\n  .fs-xxl-3qx {\n    font-size: calc(1.45rem + 2.4vw) !important;\n  }\n\n  .fs-xxl-3hx {\n    font-size: calc(1.475rem + 2.7vw) !important;\n  }\n\n  .fs-xxl-3tx {\n    font-size: calc(1.5rem + 3vw) !important;\n  }\n\n  .fs-xxl-4x {\n    font-size: calc(1.525rem + 3.3vw) !important;\n  }\n\n  .fs-xxl-4qx {\n    font-size: calc(1.55rem + 3.6vw) !important;\n  }\n\n  .fs-xxl-4hx {\n    font-size: calc(1.575rem + 3.9vw) !important;\n  }\n\n  .fs-xxl-4tx {\n    font-size: calc(1.6rem + 4.2vw) !important;\n  }\n\n  .fs-xxl-5x {\n    font-size: calc(1.625rem + 4.5vw) !important;\n  }\n\n  .fs-xxl-5qx {\n    font-size: calc(1.65rem + 4.8vw) !important;\n  }\n\n  .fs-xxl-5hx {\n    font-size: calc(1.675rem + 5.1vw) !important;\n  }\n\n  .fs-xxl-5tx {\n    font-size: calc(1.7rem + 5.4vw) !important;\n  }\n\n  .text-xxl-start {\n    text-align: left !important;\n  }\n\n  .text-xxl-end {\n    text-align: right !important;\n  }\n\n  .text-xxl-center {\n    text-align: center !important;\n  }\n\n  .min-w-xxl-unset {\n    min-width: unset !important;\n  }\n\n  .min-w-xxl-25 {\n    min-width: 25% !important;\n  }\n\n  .min-w-xxl-50 {\n    min-width: 50% !important;\n  }\n\n  .min-w-xxl-75 {\n    min-width: 75% !important;\n  }\n\n  .min-w-xxl-100 {\n    min-width: 100% !important;\n  }\n\n  .min-w-xxl-auto {\n    min-width: auto !important;\n  }\n\n  .min-w-xxl-1px {\n    min-width: 1px !important;\n  }\n\n  .min-w-xxl-2px {\n    min-width: 2px !important;\n  }\n\n  .min-w-xxl-3px {\n    min-width: 3px !important;\n  }\n\n  .min-w-xxl-4px {\n    min-width: 4px !important;\n  }\n\n  .min-w-xxl-5px {\n    min-width: 5px !important;\n  }\n\n  .min-w-xxl-6px {\n    min-width: 6px !important;\n  }\n\n  .min-w-xxl-7px {\n    min-width: 7px !important;\n  }\n\n  .min-w-xxl-8px {\n    min-width: 8px !important;\n  }\n\n  .min-w-xxl-9px {\n    min-width: 9px !important;\n  }\n\n  .min-w-xxl-10px {\n    min-width: 10px !important;\n  }\n\n  .min-w-xxl-15px {\n    min-width: 15px !important;\n  }\n\n  .min-w-xxl-20px {\n    min-width: 20px !important;\n  }\n\n  .min-w-xxl-25px {\n    min-width: 25px !important;\n  }\n\n  .min-w-xxl-30px {\n    min-width: 30px !important;\n  }\n\n  .min-w-xxl-35px {\n    min-width: 35px !important;\n  }\n\n  .min-w-xxl-40px {\n    min-width: 40px !important;\n  }\n\n  .min-w-xxl-45px {\n    min-width: 45px !important;\n  }\n\n  .min-w-xxl-50px {\n    min-width: 50px !important;\n  }\n\n  .min-w-xxl-55px {\n    min-width: 55px !important;\n  }\n\n  .min-w-xxl-60px {\n    min-width: 60px !important;\n  }\n\n  .min-w-xxl-65px {\n    min-width: 65px !important;\n  }\n\n  .min-w-xxl-70px {\n    min-width: 70px !important;\n  }\n\n  .min-w-xxl-75px {\n    min-width: 75px !important;\n  }\n\n  .min-w-xxl-80px {\n    min-width: 80px !important;\n  }\n\n  .min-w-xxl-85px {\n    min-width: 85px !important;\n  }\n\n  .min-w-xxl-90px {\n    min-width: 90px !important;\n  }\n\n  .min-w-xxl-95px {\n    min-width: 95px !important;\n  }\n\n  .min-w-xxl-100px {\n    min-width: 100px !important;\n  }\n\n  .min-w-xxl-125px {\n    min-width: 125px !important;\n  }\n\n  .min-w-xxl-150px {\n    min-width: 150px !important;\n  }\n\n  .min-w-xxl-175px {\n    min-width: 175px !important;\n  }\n\n  .min-w-xxl-200px {\n    min-width: 200px !important;\n  }\n\n  .min-w-xxl-225px {\n    min-width: 225px !important;\n  }\n\n  .min-w-xxl-250px {\n    min-width: 250px !important;\n  }\n\n  .min-w-xxl-275px {\n    min-width: 275px !important;\n  }\n\n  .min-w-xxl-300px {\n    min-width: 300px !important;\n  }\n\n  .min-w-xxl-325px {\n    min-width: 325px !important;\n  }\n\n  .min-w-xxl-350px {\n    min-width: 350px !important;\n  }\n\n  .min-w-xxl-375px {\n    min-width: 375px !important;\n  }\n\n  .min-w-xxl-400px {\n    min-width: 400px !important;\n  }\n\n  .min-w-xxl-425px {\n    min-width: 425px !important;\n  }\n\n  .min-w-xxl-450px {\n    min-width: 450px !important;\n  }\n\n  .min-w-xxl-475px {\n    min-width: 475px !important;\n  }\n\n  .min-w-xxl-500px {\n    min-width: 500px !important;\n  }\n\n  .min-w-xxl-550px {\n    min-width: 550px !important;\n  }\n\n  .min-w-xxl-600px {\n    min-width: 600px !important;\n  }\n\n  .min-w-xxl-650px {\n    min-width: 650px !important;\n  }\n\n  .min-w-xxl-700px {\n    min-width: 700px !important;\n  }\n\n  .min-w-xxl-750px {\n    min-width: 750px !important;\n  }\n\n  .min-w-xxl-800px {\n    min-width: 800px !important;\n  }\n\n  .min-w-xxl-850px {\n    min-width: 850px !important;\n  }\n\n  .min-w-xxl-900px {\n    min-width: 900px !important;\n  }\n\n  .min-w-xxl-950px {\n    min-width: 950px !important;\n  }\n\n  .min-w-xxl-1000px {\n    min-width: 1000px !important;\n  }\n\n  .min-h-xxl-unset {\n    min-height: unset !important;\n  }\n\n  .min-h-xxl-25 {\n    min-height: 25% !important;\n  }\n\n  .min-h-xxl-50 {\n    min-height: 50% !important;\n  }\n\n  .min-h-xxl-75 {\n    min-height: 75% !important;\n  }\n\n  .min-h-xxl-100 {\n    min-height: 100% !important;\n  }\n\n  .min-h-xxl-auto {\n    min-height: auto !important;\n  }\n\n  .min-h-xxl-1px {\n    min-height: 1px !important;\n  }\n\n  .min-h-xxl-2px {\n    min-height: 2px !important;\n  }\n\n  .min-h-xxl-3px {\n    min-height: 3px !important;\n  }\n\n  .min-h-xxl-4px {\n    min-height: 4px !important;\n  }\n\n  .min-h-xxl-5px {\n    min-height: 5px !important;\n  }\n\n  .min-h-xxl-6px {\n    min-height: 6px !important;\n  }\n\n  .min-h-xxl-7px {\n    min-height: 7px !important;\n  }\n\n  .min-h-xxl-8px {\n    min-height: 8px !important;\n  }\n\n  .min-h-xxl-9px {\n    min-height: 9px !important;\n  }\n\n  .min-h-xxl-10px {\n    min-height: 10px !important;\n  }\n\n  .min-h-xxl-15px {\n    min-height: 15px !important;\n  }\n\n  .min-h-xxl-20px {\n    min-height: 20px !important;\n  }\n\n  .min-h-xxl-25px {\n    min-height: 25px !important;\n  }\n\n  .min-h-xxl-30px {\n    min-height: 30px !important;\n  }\n\n  .min-h-xxl-35px {\n    min-height: 35px !important;\n  }\n\n  .min-h-xxl-40px {\n    min-height: 40px !important;\n  }\n\n  .min-h-xxl-45px {\n    min-height: 45px !important;\n  }\n\n  .min-h-xxl-50px {\n    min-height: 50px !important;\n  }\n\n  .min-h-xxl-55px {\n    min-height: 55px !important;\n  }\n\n  .min-h-xxl-60px {\n    min-height: 60px !important;\n  }\n\n  .min-h-xxl-65px {\n    min-height: 65px !important;\n  }\n\n  .min-h-xxl-70px {\n    min-height: 70px !important;\n  }\n\n  .min-h-xxl-75px {\n    min-height: 75px !important;\n  }\n\n  .min-h-xxl-80px {\n    min-height: 80px !important;\n  }\n\n  .min-h-xxl-85px {\n    min-height: 85px !important;\n  }\n\n  .min-h-xxl-90px {\n    min-height: 90px !important;\n  }\n\n  .min-h-xxl-95px {\n    min-height: 95px !important;\n  }\n\n  .min-h-xxl-100px {\n    min-height: 100px !important;\n  }\n\n  .min-h-xxl-125px {\n    min-height: 125px !important;\n  }\n\n  .min-h-xxl-150px {\n    min-height: 150px !important;\n  }\n\n  .min-h-xxl-175px {\n    min-height: 175px !important;\n  }\n\n  .min-h-xxl-200px {\n    min-height: 200px !important;\n  }\n\n  .min-h-xxl-225px {\n    min-height: 225px !important;\n  }\n\n  .min-h-xxl-250px {\n    min-height: 250px !important;\n  }\n\n  .min-h-xxl-275px {\n    min-height: 275px !important;\n  }\n\n  .min-h-xxl-300px {\n    min-height: 300px !important;\n  }\n\n  .min-h-xxl-325px {\n    min-height: 325px !important;\n  }\n\n  .min-h-xxl-350px {\n    min-height: 350px !important;\n  }\n\n  .min-h-xxl-375px {\n    min-height: 375px !important;\n  }\n\n  .min-h-xxl-400px {\n    min-height: 400px !important;\n  }\n\n  .min-h-xxl-425px {\n    min-height: 425px !important;\n  }\n\n  .min-h-xxl-450px {\n    min-height: 450px !important;\n  }\n\n  .min-h-xxl-475px {\n    min-height: 475px !important;\n  }\n\n  .min-h-xxl-500px {\n    min-height: 500px !important;\n  }\n\n  .min-h-xxl-550px {\n    min-height: 550px !important;\n  }\n\n  .min-h-xxl-600px {\n    min-height: 600px !important;\n  }\n\n  .min-h-xxl-650px {\n    min-height: 650px !important;\n  }\n\n  .min-h-xxl-700px {\n    min-height: 700px !important;\n  }\n\n  .min-h-xxl-750px {\n    min-height: 750px !important;\n  }\n\n  .min-h-xxl-800px {\n    min-height: 800px !important;\n  }\n\n  .min-h-xxl-850px {\n    min-height: 850px !important;\n  }\n\n  .min-h-xxl-900px {\n    min-height: 900px !important;\n  }\n\n  .min-h-xxl-950px {\n    min-height: 950px !important;\n  }\n\n  .min-h-xxl-1000px {\n    min-height: 1000px !important;\n  }\n}\n@media (min-width: 1200px) {\n  .fs-1 {\n    font-size: 1.75rem !important;\n  }\n\n  .fs-2 {\n    font-size: 1.5rem !important;\n  }\n\n  .fs-3 {\n    font-size: 1.35rem !important;\n  }\n\n  .fs-2x {\n    font-size: 2rem !important;\n  }\n\n  .fs-2qx {\n    font-size: 2.25rem !important;\n  }\n\n  .fs-2hx {\n    font-size: 2.5rem !important;\n  }\n\n  .fs-2tx {\n    font-size: 2.75rem !important;\n  }\n\n  .fs-3x {\n    font-size: 3rem !important;\n  }\n\n  .fs-3qx {\n    font-size: 3.25rem !important;\n  }\n\n  .fs-3hx {\n    font-size: 3.5rem !important;\n  }\n\n  .fs-3tx {\n    font-size: 3.75rem !important;\n  }\n\n  .fs-4x {\n    font-size: 4rem !important;\n  }\n\n  .fs-4qx {\n    font-size: 4.25rem !important;\n  }\n\n  .fs-4hx {\n    font-size: 4.5rem !important;\n  }\n\n  .fs-4tx {\n    font-size: 4.75rem !important;\n  }\n\n  .fs-5x {\n    font-size: 5rem !important;\n  }\n\n  .fs-5qx {\n    font-size: 5.25rem !important;\n  }\n\n  .fs-5hx {\n    font-size: 5.5rem !important;\n  }\n\n  .fs-5tx {\n    font-size: 5.75rem !important;\n  }\n\n  .fs-sm-1 {\n    font-size: 1.75rem !important;\n  }\n\n  .fs-sm-2 {\n    font-size: 1.5rem !important;\n  }\n\n  .fs-sm-3 {\n    font-size: 1.35rem !important;\n  }\n\n  .fs-sm-2x {\n    font-size: 2rem !important;\n  }\n\n  .fs-sm-2qx {\n    font-size: 2.25rem !important;\n  }\n\n  .fs-sm-2hx {\n    font-size: 2.5rem !important;\n  }\n\n  .fs-sm-2tx {\n    font-size: 2.75rem !important;\n  }\n\n  .fs-sm-3x {\n    font-size: 3rem !important;\n  }\n\n  .fs-sm-3qx {\n    font-size: 3.25rem !important;\n  }\n\n  .fs-sm-3hx {\n    font-size: 3.5rem !important;\n  }\n\n  .fs-sm-3tx {\n    font-size: 3.75rem !important;\n  }\n\n  .fs-sm-4x {\n    font-size: 4rem !important;\n  }\n\n  .fs-sm-4qx {\n    font-size: 4.25rem !important;\n  }\n\n  .fs-sm-4hx {\n    font-size: 4.5rem !important;\n  }\n\n  .fs-sm-4tx {\n    font-size: 4.75rem !important;\n  }\n\n  .fs-sm-5x {\n    font-size: 5rem !important;\n  }\n\n  .fs-sm-5qx {\n    font-size: 5.25rem !important;\n  }\n\n  .fs-sm-5hx {\n    font-size: 5.5rem !important;\n  }\n\n  .fs-sm-5tx {\n    font-size: 5.75rem !important;\n  }\n\n  .fs-md-1 {\n    font-size: 1.75rem !important;\n  }\n\n  .fs-md-2 {\n    font-size: 1.5rem !important;\n  }\n\n  .fs-md-3 {\n    font-size: 1.35rem !important;\n  }\n\n  .fs-md-2x {\n    font-size: 2rem !important;\n  }\n\n  .fs-md-2qx {\n    font-size: 2.25rem !important;\n  }\n\n  .fs-md-2hx {\n    font-size: 2.5rem !important;\n  }\n\n  .fs-md-2tx {\n    font-size: 2.75rem !important;\n  }\n\n  .fs-md-3x {\n    font-size: 3rem !important;\n  }\n\n  .fs-md-3qx {\n    font-size: 3.25rem !important;\n  }\n\n  .fs-md-3hx {\n    font-size: 3.5rem !important;\n  }\n\n  .fs-md-3tx {\n    font-size: 3.75rem !important;\n  }\n\n  .fs-md-4x {\n    font-size: 4rem !important;\n  }\n\n  .fs-md-4qx {\n    font-size: 4.25rem !important;\n  }\n\n  .fs-md-4hx {\n    font-size: 4.5rem !important;\n  }\n\n  .fs-md-4tx {\n    font-size: 4.75rem !important;\n  }\n\n  .fs-md-5x {\n    font-size: 5rem !important;\n  }\n\n  .fs-md-5qx {\n    font-size: 5.25rem !important;\n  }\n\n  .fs-md-5hx {\n    font-size: 5.5rem !important;\n  }\n\n  .fs-md-5tx {\n    font-size: 5.75rem !important;\n  }\n\n  .fs-lg-1 {\n    font-size: 1.75rem !important;\n  }\n\n  .fs-lg-2 {\n    font-size: 1.5rem !important;\n  }\n\n  .fs-lg-3 {\n    font-size: 1.35rem !important;\n  }\n\n  .fs-lg-2x {\n    font-size: 2rem !important;\n  }\n\n  .fs-lg-2qx {\n    font-size: 2.25rem !important;\n  }\n\n  .fs-lg-2hx {\n    font-size: 2.5rem !important;\n  }\n\n  .fs-lg-2tx {\n    font-size: 2.75rem !important;\n  }\n\n  .fs-lg-3x {\n    font-size: 3rem !important;\n  }\n\n  .fs-lg-3qx {\n    font-size: 3.25rem !important;\n  }\n\n  .fs-lg-3hx {\n    font-size: 3.5rem !important;\n  }\n\n  .fs-lg-3tx {\n    font-size: 3.75rem !important;\n  }\n\n  .fs-lg-4x {\n    font-size: 4rem !important;\n  }\n\n  .fs-lg-4qx {\n    font-size: 4.25rem !important;\n  }\n\n  .fs-lg-4hx {\n    font-size: 4.5rem !important;\n  }\n\n  .fs-lg-4tx {\n    font-size: 4.75rem !important;\n  }\n\n  .fs-lg-5x {\n    font-size: 5rem !important;\n  }\n\n  .fs-lg-5qx {\n    font-size: 5.25rem !important;\n  }\n\n  .fs-lg-5hx {\n    font-size: 5.5rem !important;\n  }\n\n  .fs-lg-5tx {\n    font-size: 5.75rem !important;\n  }\n}\n@media print {\n  .d-print-inline {\n    display: inline !important;\n  }\n\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n\n  .d-print-block {\n    display: block !important;\n  }\n\n  .d-print-grid {\n    display: grid !important;\n  }\n\n  .d-print-table {\n    display: table !important;\n  }\n\n  .d-print-table-row {\n    display: table-row !important;\n  }\n\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n\n  .d-print-flex {\n    display: flex !important;\n  }\n\n  .d-print-inline-flex {\n    display: inline-flex !important;\n  }\n\n  .d-print-none {\n    display: none !important;\n  }\n}\n:root,\n[data-theme=light] {\n  --kt-xs:0;\n  --kt-sm:576px;\n  --kt-md:768px;\n  --kt-lg:992px;\n  --kt-xl:1200px;\n  --kt-xxl:1400px;\n  --kt-white: #ffffff;\n  --kt-white-bg-rgb: 255, 255, 255;\n  --kt-black: #000000;\n  --kt-black-bg-rgb: 0, 0, 0;\n  --kt-text-muted: #A1A5B7;\n  --kt-gray-100: #f5f8fa;\n  --kt-gray-200: #eff2f5;\n  --kt-gray-300: #E4E6EF;\n  --kt-gray-400: #B5B5C3;\n  --kt-gray-500: #A1A5B7;\n  --kt-gray-600: #7E8299;\n  --kt-gray-700: #5E6278;\n  --kt-gray-800: #3F4254;\n  --kt-gray-900: #181C32;\n  --kt-gray-100-rgb: 245, 248, 250;\n  --kt-gray-200-rgb: 239, 242, 245;\n  --kt-gray-300-rgb: 228, 230, 239;\n  --kt-gray-400-rgb: 181, 181, 195;\n  --kt-gray-500-rgb: 161, 165, 183;\n  --kt-gray-600-rgb: 126, 130, 153;\n  --kt-gray-700-rgb: 94, 98, 120;\n  --kt-gray-800-rgb: 63, 66, 84;\n  --kt-gray-900-rgb: 24, 28, 50;\n  --kt-white: #ffffff;\n  --kt-light: #f5f8fa;\n  --kt-primary: #009ef7;\n  --kt-secondary: #E4E6EF;\n  --kt-success: #50cd89;\n  --kt-info: #7239ea;\n  --kt-warning: #ffc700;\n  --kt-danger: #f1416c;\n  --kt-dark: #181C32;\n  --kt-primary-active: #0095e8;\n  --kt-secondary-active: #B5B5C3;\n  --kt-light-active: #eff2f5;\n  --kt-success-active: #47be7d;\n  --kt-info-active: #5014d0;\n  --kt-warning-active: #f1bc00;\n  --kt-danger-active: #E32539;\n  --kt-dark-active: #131628;\n  --kt-primary-light: #f1faff;\n  --kt-secondary-light: #f5f8fa;\n  --kt-success-light: #e8fff3;\n  --kt-info-light: #f8f5ff;\n  --kt-warning-light: #fff8dd;\n  --kt-danger-light: #fff5f8;\n  --kt-dark-light: #eff2f5;\n  --kt-primary-inverse: #ffffff;\n  --kt-secondary-inverse: #3F4254;\n  --kt-light-inverse: #7E8299;\n  --kt-success-inverse: #ffffff;\n  --kt-info-inverse: #ffffff;\n  --kt-warning-inverse: #ffffff;\n  --kt-danger-inverse: #ffffff;\n  --kt-dark-inverse: #ffffff;\n  --kt-white-rgb: 255, 255, 255;\n  --kt-light-rgb: 245, 248, 250;\n  --kt-primary-rgb: 0, 158, 247;\n  --kt-secondary-rgb: 228, 230, 239;\n  --kt-success-rgb: 80, 205, 137;\n  --kt-info-rgb: 114, 57, 234;\n  --kt-warning-rgb: 255, 199, 0;\n  --kt-danger-rgb: 241, 65, 108;\n  --kt-dark-rgb: 24, 28, 50;\n  --kt-text-white: #ffffff;\n  --kt-text-primary: #009ef7;\n  --kt-text-secondary: #E4E6EF;\n  --kt-text-light: #f5f8fa;\n  --kt-text-success: #50cd89;\n  --kt-text-info: #7239ea;\n  --kt-text-warning: #ffc700;\n  --kt-text-danger: #f1416c;\n  --kt-text-dark: #181C32;\n  --kt-text-muted: #A1A5B7;\n  --kt-text-gray-100: #f5f8fa;\n  --kt-text-gray-200: #eff2f5;\n  --kt-text-gray-300: #E4E6EF;\n  --kt-text-gray-400: #B5B5C3;\n  --kt-text-gray-500: #A1A5B7;\n  --kt-text-gray-600: #7E8299;\n  --kt-text-gray-700: #5E6278;\n  --kt-text-gray-800: #3F4254;\n  --kt-text-gray-900: #181C32;\n  --kt-body-bg: #ffffff;\n  --kt-body-bg-rgb: 255, 255, 255;\n  --kt-body-color: #181C32;\n  --kt-link-color: #009ef7;\n  --kt-link-hover-color: #0095e8;\n  --kt-border-color: #eff2f5;\n  --kt-border-dashed-color: #E4E6EF;\n  --kt-component-active-color: #ffffff;\n  --kt-component-active-bg: #009ef7;\n  --kt-component-hover-color: #009ef7;\n  --kt-component-hover-bg: #F4F6FA;\n  --kt-component-checked-color: #ffffff;\n  --kt-component-checked-bg: #009ef7;\n  --kt-box-shadow-xs: 0 0.1rem 0.75rem 0.25rem rgba(0, 0, 0, 0.05);\n  --kt-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);\n  --kt-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --kt-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);\n  --kt-headings-color: #181C32;\n  --kt-table-color: #181C32;\n  --kt-table-bg: transparent;\n  --kt-table-striped-color: #181C32;\n  --kt-table-striped-bg: rgba(245, 248, 250, 0.75);\n  --kt-table-accent-bg: transparent;\n  --kt-table-active-color: #181C32;\n  --kt-table-active-bg: #f5f8fa;\n  --kt-table-hover-colorr: #181C32;\n  --kt-table-hover-bg: #f5f8fa;\n  --kt-table-border-color: #eff2f5;\n  --kt-table-caption-color: #A1A5B7;\n  --kt-table-loading-message-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --kt-table-loading-message-bg: #ffffff;\n  --kt-table-loading-message-color: #5E6278;\n  --kt-input-btn-focus-color: rgba(0, 158, 247, 0.25);\n  --kt-input-btn-focus-box-shadow: 0 0 0 0.25rem rgba(0, 158, 247, 0.25);\n  --kt-input-btn-focus-color-opacity: 0.25;\n  --kt-input-color: #5E6278;\n  --kt-input-placeholder-color: #A1A5B7;\n  --kt-input-plaintext-color: #5E6278;\n  --kt-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);\n  --kt-btn-focus-box-shadow: 0 0 0 0.25rem rgba(0, 158, 247, 0.25);\n  --kt-btn-active-box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --kt-btn-disabled-opacity: 0.65;\n  --kt-btn-link-color: #009ef7;\n  --kt-btn-link-hover-color: #0095e8;\n  --kt-btn-link-disabled-color: #7E8299;\n  --kt-form-label-color: #3F4254;\n  --kt-form-text-color: #A1A5B7;\n  --kt-input-bg: #ffffff;\n  --kt-input-disabled-bg: #eff2f5;\n  --kt-input-disabled-color: ;\n  --kt-input-disabled-border-color: #E4E6EF;\n  --kt-input-color: #5E6278;\n  --kt-input-border-color: #E4E6EF;\n  --kt-input-focus-bg: #ffffff;\n  --kt-input-focus-border-color: #B5B5C3;\n  --kt-input-focus-color: #5E6278;\n  --kt-input-solid-bg: #f5f8fa;\n  --kt-input-solid-bg-focus: #eef3f7;\n  --kt-input-solid-placeholder-color: #A1A5B7;\n  --kt-input-solid-color: #5E6278;\n  --kt-form-check-label-color: #A1A5B7;\n  --kt-form-check-label-color-checked: #5E6278;\n  --kt-form-check-input-active-filter: brightness(90%);\n  --kt-form-check-input-bg: transparent;\n  --kt-form-check-input-bg-solid: #eff2f5;\n  --kt-form-check-input-border: 1px solid #E4E6EF;\n  --kt-form-check-input-focus-border: #B5B5C3;\n  --kt-form-check-input-focus-box-shadow: none;\n  --kt-form-check-input-checked-color: #ffffff;\n  --kt-form-check-input-checked-bg-color: #009ef7;\n  --kt-form-check-input-checked-bg-color-solid: #009ef7;\n  --kt-form-check-input-checked-border-color: #009ef7;\n  --kt-form-check-input-checked-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 11' width='13' height='11' fill='none'%3e%3cpath d='M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z' fill='%23ffffff'/%3e%3c/svg%3e\");\n  --kt-form-check-radio-checked-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23ffffff'/%3e%3c/svg%3e\");\n  --kt-form-check-input-indeterminate-color: #ffffff;\n  --kt-form-check-input-indeterminate-bg-color: #009ef7;\n  --kt-form-check-input-indeterminate-border-color: #009ef7;\n  --kt-form-check-input-indeterminate-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n  --kt-form-check-input-disabled-opacity: 0.5;\n  --kt-form-check-label-disabled-opacity: 0.5;\n  --kt-form-check-btn-check-disabled-opacity: 0.65;\n  --kt-form-switch-color: rgba(0, 0, 0, 0.25);\n  --kt-form-switch-color-solid: #ffffff;\n  --kt-form-switch-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%280, 0, 0, 0.25%29'/%3e%3c/svg%3e\");\n  --kt-form-switch-bg-image-solid: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e\");\n  --kt-form-switch-focus-color: #B5B5C3;\n  --kt-form-switch-focus-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23B5B5C3'/%3e%3c/svg%3e\");\n  --kt-form-switch-checked-color: #ffffff;\n  --kt-form-switch-checked-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e\");\n  --kt-input-group-addon-color: #5E6278;\n  --kt-input-group-addon-bg: #f5f8fa;\n  --kt-input-group-addon-border-color: #E4E6EF;\n  --kt-form-select-color: #5E6278;\n  --kt-form-select-bg: #ffffff;\n  --kt-form-select-disabled-color: ;\n  --kt-form-select-disabled-bg: #eff2f5;\n  --kt-form-select-disabled-border-color: #E4E6EF;\n  --kt-form-select-indicator-color: #7E8299;\n  --kt-form-select-indicator: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%237E8299' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  --kt-form-select-border-color: #E4E6EF;\n  --kt-form-select-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --kt-form-select-focus-border-color: #B5B5C3;\n  --kt-form-select-focus-box-shadow: 0 0 0 0.25rem rgba(0, 158, 247, 0.25);\n  --kt-form-file-button-color: #5E6278;\n  --kt-form-file-button-bg: #f5f8fa;\n  --kt-form-file-button-hover-bg: shade-color(#f5f8fa, 5%);\n  --kt-nav-tabs-border-color: #eff2f5;\n  --kt-nav-tabs-link-hover-border-color: #eff2f5 #eff2f5 #eff2f5;\n  --kt-nav-tabs-link-active-color: #5E6278;\n  --kt-nav-tabs-link-active-bg: #ffffff;\n  --kt-nav-tabs-link-active-border-color: #E4E6EF #E4E6EF #ffffff;\n  --kt-nav-pills-link-active-color: #ffffff;\n  --kt-nav-pills-link-active-bg: #009ef7;\n  --kt-dropdown-color: #181C32;\n  --kt-dropdown-bg: #ffffff;\n  --kt-dropdown-divider-bg: #f5f8fa;\n  --kt-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --kt-dropdown-link-color: #181C32;\n  --kt-dropdown-link-hover-color: shade-color(#181C32, 10%);\n  --kt-dropdown-link-hover-bg: #eff2f5;\n  --kt-dropdown-link-active-color: #ffffff;\n  --kt-dropdown-link-active-bg: #009ef7;\n  --kt-dropdown-link-disabled-color: #A1A5B7;\n  --kt-dropdown-header-color: #7E8299;\n  --kt-pagination-item-bg: #ffffff;\n  --kt-pagination-color: #5E6278;\n  --kt-pagination-bg: transparent;\n  --kt-pagination-border-color: transparent;\n  --kt-pagination-focus-color: #009ef7;\n  --kt-pagination-focus-bg: #F4F6FA;\n  --kt-pagination-focus-box-shadow: none;\n  --kt-pagination-focus-outline: 0;\n  --kt-pagination-hover-color: #009ef7;\n  --kt-pagination-hover-bg: #F4F6FA;\n  --kt-pagination-hover-border-color: transparent;\n  --kt-pagination-active-color: #ffffff;\n  --kt-pagination-active-bg: #009ef7;\n  --kt-pagination-active-border-color: transparent;\n  --kt-pagination-disabled-color: #B5B5C3;\n  --kt-pagination-disabled-bg: transparent;\n  --kt-card-color: ;\n  --kt-card-bg: #ffffff;\n  --kt-card-box-shadow: 0px 0px 20px 0px rgba(76, 87, 125, 0.02);\n  --kt-card-border-color: #eff2f5;\n  --kt-card-border-dashed-color: #E4E6EF;\n  --kt-card-cap-bg: transparent;\n  --kt-accordion-color: #181C32;\n  --kt-accordion-bg: #ffffff;\n  --kt-accordion-border-color: #eff2f5;\n  --kt-accordion-button-bg: #ffffff;\n  --kt-accordion-button-color: #181C32;\n  --kt-accordion-button-active-bg: #f5f8fa;\n  --kt-accordion-button-active-color: #009ef7;\n  --kt-accordion-button-focus-border-color: #eff2f5;\n  --kt-accordion-button-focus-box-shadow: none;\n  --kt-accordion-icon-color: #181C32;\n  --kt-accordion-icon-active-color: #009ef7;\n  --kt-accordion-button-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23181C32'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --kt-accordion-button-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23009ef7'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --kt-tooltip-color: #3F4254;\n  --kt-tooltip-bg: #ffffff;\n  --kt-tooltip-opacity: 1;\n  --kt-tooltip-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --kt-popover-bg: #ffffff;\n  --kt-popover-border-color: #ffffff;\n  --kt-popover-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --kt-popover-header-bg: #ffffff;\n  --kt-popover-header-color: #3F4254;\n  --kt-popover-header-border-color: #eff2f5;\n  --kt-popover-body-color: #3F4254;\n  --kt-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --kt-dropdown-bg: #ffffff;\n  --kt-toast-color: ;\n  --kt-toast-background-color: rgba(255, 255, 255, 0.85);\n  --kt-toast-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --kt-toast-header-color: #7E8299;\n  --kt-toast-header-background-color: rgba(255, 255, 255, 0.85);\n  --kt-toast-header-border-color: rgba(0, 0, 0, 0.05);\n  --kt-badge-color: #ffffff;\n  --kt-modal-bg: #ffffff;\n  --kt-modal-color: ;\n  --kt-modal-border-color: var(--bs-border-color-translucent);\n  --kt-modal-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);\n  --kt-modal-content-color: ;\n  --kt-modal-content-bg: #ffffff;\n  --kt-modal-content-border-color: var(--bs-border-color-translucent);\n  --kt-modal-content-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);\n  --kt-modal-content-box-shadow-xs: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);\n  --kt-modal-content-box-shadow-sm-up: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);\n  --kt-modal-header-border-color: #eff2f5;\n  --kt-modal-footer-border-color: #eff2f5;\n  --kt-modal-backdrop-bg: #000000;\n  --kt-modal-backdrop-opacity: 0.3;\n  --kt-progress-bg: #f5f8fa;\n  --kt-progress-box-shadow: none;\n  --kt-list-group-color: #181C32;\n  --kt-list-group-bg: #ffffff;\n  --kt-list-group-border-color: rgba(0, 0, 0, 0.125);\n  --kt-list-group-hover-bg: #f5f8fa;\n  --kt-list-group-active-color: #ffffff;\n  --kt-list-group-active-bg: #009ef7;\n  --kt-list-group-active-border-colorg: #009ef7;\n  --kt-list-group-disabled-color: #7E8299;\n  --kt-list-group-disabled-bg: #ffffff;\n  --kt-list-group-action-colorg: #5E6278;\n  --kt-list-group-action-hover-color: #5E6278;\n  --kt-list-group-action-active-color: #181C32;\n  --kt-list-group-action-active-bg: #eff2f5;\n  --kt-thumbnail-bg: #ffffff;\n  --kt-thumbnail-border-color: #eff2f5;\n  --kt-thumbnail-box-shadow: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);\n  --kt-figure-caption-color: #7E8299;\n  --kt-breadcrumb-bg: ;\n  --kt-breadcrumb-divider-color: #7E8299;\n  --kt-breadcrumb-active-color: #009ef7;\n  --kt-carousel-custom-indicator-default-bg-color: #eff2f5;\n  --kt-carousel-custom-indicator-active-bg-color: #B5B5C3;\n  --kt-carousel-custom-bullet-indicator-default-bg-color: #B5B5C3;\n  --kt-carousel-custom-bullet-indicator-active-bg-color: #7E8299;\n  --kt-code-bg: #F1F3F8;\n  --kt-code-box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);\n  --kt-code-color: #b93993;\n  --kt-btn-close-color: #000000;\n  --kt-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n  --kt-offcanvas-border-color: var(--bs-border-color-translucent);\n  --kt-offcanvas-bg-color: #ffffff;\n  --kt-offcanvas-color: ;\n  --kt-offcanvas-box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);\n  --kt-offcanvas-backdrop-bg: #000000;\n  --kt-offcanvas-backdrop-opacity: 0.3;\n  --kt-symbol-label-color: #3F4254;\n  --kt-symbol-label-bg: #f5f8fa;\n  --kt-symbol-border-color: rgba(255, 255, 255, 0.5);\n  --kt-bullet-bg-color: #B5B5C3;\n  --kt-scrolltop-opacity: 0;\n  --kt-scrolltop-opacity-on: 0.3;\n  --kt-scrolltop-opacity-hover: 1;\n  --kt-scrolltop-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --kt-scrolltop-bg-color: #009ef7;\n  --kt-scrolltop-bg-color-hover: #009ef7;\n  --kt-scrolltop-icon-color: #ffffff;\n  --kt-scrolltop-icon-color-hover: #ffffff;\n  --kt-drawer-box-shadow: 0px 1px 9px -3px rgba(0, 0, 0, 0.05);\n  --kt-drawer-bg-color: #ffffff;\n  --kt-drawer-overlay-bg-color: rgba(0, 0, 0, 0.2);\n  --kt-menu-dropdown-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --kt-menu-dropdown-bg-color: #ffffff;\n  --kt-menu-heading-color: #A1A5B7;\n  --kt-menu-link-color-hover: #009ef7;\n  --kt-menu-link-color-show: #009ef7;\n  --kt-menu-link-color-here: #009ef7;\n  --kt-menu-link-color-active: #009ef7;\n  --kt-menu-link-bg-color-hover: #F4F6FA;\n  --kt-menu-link-bg-color-show: #F4F6FA;\n  --kt-menu-link-bg-color-here: #F4F6FA;\n  --kt-menu-link-bg-color-active: #F4F6FA;\n  --kt-feedback-popup-box-shadow: 0px 0px 50px 0px rgba(82, 63, 105, 0.15);\n  --kt-feedback-popup-background-color: #ffffff;\n  --kt-scrollbar-color: #eff2f5;\n  --kt-scrollbar-hover-color: #e9edf1;\n  --kt-scrollbar-width: 0.4rem;\n  --kt-scrollbar-height: 0.4rem;\n  --kt-scrollbar-space: 0.5rem;\n  --kt-overlay-bg: rgba(0, 0, 0, 0.05);\n  --kt-blockui-overlay-bg: rgba(0, 0, 0, 0.05);\n  --kt-rating-color-default: #B5B5C3;\n  --kt-rating-color-active: #FFAD0F;\n  --kt-ribbon-label-box-shadow: 0px -1px 5px 0px rgba(24, 28, 50, 0.1);\n  --kt-ribbon-label-bg: #009ef7;\n  --kt-ribbon-label-border-color: #005d91;\n  --kt-ribbon-clip-bg: #181C32;\n  --kt-engage-btn-bg: #ffffff;\n  --kt-engage-btn-color: #7E8299;\n  --kt-engage-btn-color-active: #3F4254;\n}\n\n[data-theme=dark] {\n  --kt-text-muted: #565674;\n  --kt-gray-100: #1b1b29;\n  --kt-gray-200: #2B2B40;\n  --kt-gray-300: #323248;\n  --kt-gray-400: #474761;\n  --kt-gray-500: #565674;\n  --kt-gray-600: #6D6D80;\n  --kt-gray-700: #92929F;\n  --kt-gray-800: #CDCDDE;\n  --kt-gray-900: #FFFFFF;\n  --kt-gray-100-rgb: 27, 27, 41;\n  --kt-gray-200-rgb: 43, 43, 64;\n  --kt-gray-300-rgb: 50, 50, 72;\n  --kt-gray-400-rgb: 71, 71, 97;\n  --kt-gray-500-rgb: 86, 86, 116;\n  --kt-gray-600-rgb: 109, 109, 128;\n  --kt-gray-700-rgb: 146, 146, 159;\n  --kt-gray-800-rgb: 205, 205, 222;\n  --kt-gray-900-rgb: 255, 255, 255;\n  --kt-dark: #FFFFFF;\n  --kt-light: #2B2B40;\n  --kt-secondary: #323248;\n  --kt-dark-active: white;\n  --kt-light-active: #323248;\n  --kt-secondary-active: #474761;\n  --kt-primary-light: #212e48;\n  --kt-success-light: #1c3238;\n  --kt-info-light: #2f264f;\n  --kt-warning-light: #392f28;\n  --kt-danger-light: #3a2434;\n  --kt-dark-light: #2B2B40;\n  --kt-secondary-light: #1b1b29;\n  --kt-dark-inverse: #1b1b29;\n  --kt-light-inverse: #6D6D80;\n  --kt-secondary-inverse: #CDCDDE;\n  --kt-dark-rgb: 255, 255, 255;\n  --kt-light-rgb: 43, 43, 64;\n  --kt-secondary-rgb: 50, 50, 72;\n  --kt-text-dark: #FFFFFF;\n  --kt-text-muted: #565674;\n  --kt-text-secondary: #323248;\n  --kt-text-gray-100: #1b1b29;\n  --kt-text-gray-200: #2B2B40;\n  --kt-text-gray-300: #323248;\n  --kt-text-gray-400: #474761;\n  --kt-text-gray-500: #565674;\n  --kt-text-gray-600: #6D6D80;\n  --kt-text-gray-700: #92929F;\n  --kt-text-gray-800: #CDCDDE;\n  --kt-text-gray-900: #FFFFFF;\n  --kt-body-bg: #1e1e2d;\n  --kt-body-bg-rgb: 30, 30, 45;\n  --kt-body-color: #FFFFFF;\n  --kt-link-color: #009ef7;\n  --kt-link-hover-color: #0095e8;\n  --kt-border-color: #2B2B40;\n  --kt-border-dashed-color: #323248;\n  --kt-component-active-color: #ffffff;\n  --kt-component-active-bg: #009ef7;\n  --kt-component-hover-color: #009ef7;\n  --kt-component-hover-bg: #2B2B40;\n  --kt-component-checked-color: #ffffff;\n  --kt-component-checked-bg: #009ef7;\n  --kt-box-shadow-xs: 0 0.1rem 0.75rem 0.25rem rgba(0, 0, 0, 0.05);\n  --kt-box-shadow-sm: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);\n  --kt-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --kt-box-shadow-lg: 0 1rem 2rem 1rem rgba(0, 0, 0, 0.1);\n  --kt-headings-color: #FFFFFF;\n  --kt-table-color: #FFFFFF;\n  --kt-table-bg: transparent;\n  --kt-table-striped-color: #FFFFFF;\n  --kt-table-striped-bg: rgba(27, 27, 41, 0.75);\n  --kt-table-accent-bg: transparent;\n  --kt-table-active-color: #FFFFFF;\n  --kt-table-active-bg: #1b1b29;\n  --kt-table-hover-colorr: #FFFFFF;\n  --kt-table-hover-bg: #1b1b29;\n  --kt-table-border-color: #2B2B40;\n  --kt-table-caption-color: #565674;\n  --kt-table-loading-message-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --kt-table-loading-message-bg: #2B2B40;\n  --kt-table-loading-message-color: #92929F;\n  --kt-input-btn-focus-color: rgba(0, 158, 247, 0.25);\n  --kt-input-btn-focus-box-shadow: ;\n  --kt-input-btn-focus-color-opacity: 0.25;\n  --kt-input-color: #92929F;\n  --kt-input-placeholder-color: #565674;\n  --kt-input-plaintext-color: #92929F;\n  --kt-btn-box-shadow: ;\n  --kt-btn-focus-box-shadow: ;\n  --kt-btn-active-box-shadow: ;\n  --kt-btn-disabled-opacity: 0.65;\n  --kt-btn-link-color: #009ef7;\n  --kt-btn-link-hover-color: #0095e8;\n  --kt-btn-link-disabled-color: #6D6D80;\n  --kt-form-label-color: #CDCDDE;\n  --kt-form-text-color: #565674;\n  --kt-input-bg: #1e1e2d;\n  --kt-input-disabled-bg: #2B2B40;\n  --kt-input-disabled-color: ;\n  --kt-input-disabled-border-color: #323248;\n  --kt-input-color: #92929F;\n  --kt-input-border-color: #323248;\n  --kt-input-focus-bg: #1e1e2d;\n  --kt-input-focus-border-color: #474761;\n  --kt-input-focus-color: #92929F;\n  --kt-input-solid-bg: #1b1b29;\n  --kt-input-solid-bg-focus: #1f1f2f;\n  --kt-input-solid-placeholder-color: #565674;\n  --kt-input-solid-color: #92929F;\n  --kt-form-check-label-color: #565674;\n  --kt-form-check-label-color-checked: #92929F;\n  --kt-form-check-input-active-filter: brightness(90%);\n  --kt-form-check-input-bg: transparent;\n  --kt-form-check-input-bg-solid: #2B2B40;\n  --kt-form-check-input-border: 1px solid #323248;\n  --kt-form-check-input-focus-border: #474761;\n  --kt-form-check-input-focus-box-shadow: none;\n  --kt-form-check-input-checked-color: #ffffff;\n  --kt-form-check-input-checked-bg-color: #009ef7;\n  --kt-form-check-input-checked-border-color: #009ef7;\n  --kt-form-check-input-checked-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 11' width='13' height='11' fill='none'%3e%3cpath d='M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z' fill='%23ffffff'/%3e%3c/svg%3e\");\n  --kt-form-check-radio-checked-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23ffffff'/%3e%3c/svg%3e\");\n  --kt-form-check-input-indeterminate-color: #ffffff;\n  --kt-form-check-input-indeterminate-bg-color: #009ef7;\n  --kt-form-check-input-indeterminate-border-color: #009ef7;\n  --kt-form-check-input-indeterminate-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23ffffff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/%3e%3c/svg%3e\");\n  --kt-form-check-input-disabled-opacity: 0.5;\n  --kt-form-check-label-disabled-opacity: 0.5;\n  --kt-form-check-btn-check-disabled-opacity: 0.65;\n  --kt-form-switch-color: rgba(255, 255, 255, 0.25);\n  --kt-form-switch-color-solid: #A1A5B7;\n  --kt-form-switch-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='rgba%28255, 255, 255, 0.25%29'/%3e%3c/svg%3e\");\n  --kt-form-switch-bg-image-solid: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23A1A5B7'/%3e%3c/svg%3e\");\n  --kt-form-switch-focus-color: #474761;\n  --kt-form-switch-focus-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23474761'/%3e%3c/svg%3e\");\n  --kt-form-switch-checked-color: #ffffff;\n  --kt-form-switch-checked-bg-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ffffff'/%3e%3c/svg%3e\");\n  --kt-input-group-addon-color: #92929F;\n  --kt-input-group-addon-bg: #1b1b29;\n  --kt-input-group-addon-border-color: #323248;\n  --kt-form-select-color: #92929F;\n  --kt-form-select-bg: #1e1e2d;\n  --kt-form-select-disabled-color: ;\n  --kt-form-select-disabled-bg: #2B2B40;\n  --kt-form-select-disabled-border-color: #323248;\n  --kt-form-select-indicator-color: #6D6D80;\n  --kt-form-select-indicator: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%236D6D80' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  --kt-form-select-border-color: #323248;\n  --kt-form-select-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);\n  --kt-form-select-focus-border-color: #474761;\n  --kt-form-select-focus-box-shadow: 0 0 0 0.25rem rgba(0, 158, 247, 0.25);\n  --kt-form-file-button-color: #92929F;\n  --kt-form-file-button-bg: #1b1b29;\n  --kt-form-file-button-hover-bg: shade-color(#1b1b29, 5%);\n  --kt-nav-tabs-border-color: #2B2B40;\n  --kt-nav-tabs-link-hover-border-color: #2B2B40 #2B2B40 #2B2B40;\n  --kt-nav-tabs-link-active-color: #92929F;\n  --kt-nav-tabs-link-active-bg: #1e1e2d;\n  --kt-nav-tabs-link-active-border-color: #323248 #323248 #1e1e2d;\n  --kt-nav-pills-link-active-color: #ffffff;\n  --kt-nav-pills-link-active-bg: #009ef7;\n  --kt-dropdown-color: #FFFFFF;\n  --kt-dropdown-bg: #1e1e2d;\n  --kt-dropdown-divider-bg: #1b1b29;\n  --kt-dropdown-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --kt-dropdown-link-color: #FFFFFF;\n  --kt-dropdown-link-hover-color: shade-color(#FFFFFF, 10%);\n  --kt-dropdown-link-hover-bg: #2B2B40;\n  --kt-dropdown-link-active-color: #ffffff;\n  --kt-dropdown-link-active-bg: #009ef7;\n  --kt-dropdown-link-disabled-color: #565674;\n  --kt-dropdown-header-color: #6D6D80;\n  --kt-pagination-item-bg: #1e1e2d;\n  --kt-pagination-color: #92929F;\n  --kt-pagination-bg: transparent;\n  --kt-pagination-border-color: transparent;\n  --kt-pagination-focus-color: #009ef7;\n  --kt-pagination-focus-bg: #2B2B40;\n  --kt-pagination-focus-box-shadow: none;\n  --kt-pagination-focus-outline: 0;\n  --kt-pagination-hover-color: #009ef7;\n  --kt-pagination-hover-bg: #2B2B40;\n  --kt-pagination-hover-border-color: transparent;\n  --kt-pagination-active-color: #ffffff;\n  --kt-pagination-active-bg: #009ef7;\n  --kt-pagination-active-border-color: transparent;\n  --kt-pagination-disabled-color: #474761;\n  --kt-pagination-disabled-bg: transparent;\n  --kt-card-bg: #1e1e2d;\n  --kt-card-color: ;\n  --kt-card-box-shadow: none;\n  --kt-card-border-color: #2B2B40;\n  --kt-card-border-dashed-color: #323248;\n  --kt-card-cap-bg: transparent;\n  --kt-accordion-color: #FFFFFF;\n  --kt-accordion-bg: #1e1e2d;\n  --kt-accordion-border-color: #2B2B40;\n  --kt-accordion-button-color: #FFFFFF;\n  --kt-accordion-button-bg: #1e1e2d;\n  --kt-accordion-button-active-bg: #1b1b29;\n  --kt-accordion-button-active-color: #009ef7;\n  --kt-accordion-button-focus-border-color: #2B2B40;\n  --kt-accordion-button-focus-box-shadow: none;\n  --kt-accordion-icon-color: #FFFFFF;\n  --kt-accordion-icon-active-color: #009ef7;\n  --kt-accordion-button-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23FFFFFF'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --kt-accordion-button-active-icon: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23009ef7'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n  --kt-tooltip-color: #CDCDDE;\n  --kt-tooltip-bg: #2B2B40;\n  --kt-tooltip-opacity: 1;\n  --kt-tooltip-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --kt-popover-bg: #2B2B40;\n  --kt-popover-border-color: #2B2B40;\n  --kt-popover-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --kt-popover-header-bg: #2B2B40;\n  --kt-popover-header-color: #CDCDDE;\n  --kt-popover-header-border-color: #323248;\n  --kt-popover-body-color: #CDCDDE;\n  --kt-dropdown-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --kt-dropdown-bg: #1e1e2d;\n  --kt-toast-color: ;\n  --kt-toast-background-color: rgba(0, 0, 0, 0.85);\n  --kt-toast-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --kt-toast-header-color: #6D6D80;\n  --kt-toast-header-background-color: rgba(0, 0, 0, 0.85);\n  --kt-toast-header-border-color: rgba(255, 255, 255, 0.05);\n  --kt-badge-color: #1e1e2d;\n  --kt-modal-bg: #1e1e2d;\n  --kt-modal-color: ;\n  --kt-modal-border-color: ;\n  --kt-modal-box-shadow: 0 0.25rem 0.5rem rgba(255, 255, 255, 0.05);\n  --kt-modal-content-color: ;\n  --kt-modal-content-bg: #1e1e2d;\n  --kt-modal-content-border-color: ;\n  --kt-modal-content-box-shadow: 0 0.25rem 0.5rem rgba(255, 255, 255, 0.05);\n  --kt-modal-content-box-shadow-xs: 0 0.25rem 0.5rem rgba(255, 255, 255, 0.1);\n  --kt-modal-content-box-shadow-sm-up: 0 0.5rem 1rem rgba(255, 255, 255, 0.1);\n  --kt-modal-header-border-color: #2B2B40;\n  --kt-modal-footer-border-color: #2B2B40;\n  --kt-modal-backdrop-bg: #000000;\n  --kt-modal-backdrop-opacity: 0.4;\n  --kt-progress-bg: #1b1b29;\n  --kt-progress-box-shadow: none;\n  --kt-list-group-color: #FFFFFF;\n  --kt-list-group-bg: #000000;\n  --kt-list-group-border-color: rgba(255, 255, 255, 0.125);\n  --kt-list-group-hover-bg: #f5f8fa;\n  --kt-list-group-active-color: #ffffff;\n  --kt-list-group-active-bg: #009ef7;\n  --kt-list-group-active-border-colorg: #009ef7;\n  --kt-list-group-disabled-color: #6D6D80;\n  --kt-list-group-disabled-bg: #000000;\n  --kt-list-group-action-colorg: #92929F;\n  --kt-list-group-action-hover-color: #92929F;\n  --kt-list-group-action-active-color: #FFFFFF;\n  --kt-list-group-action-active-bg: #2B2B40;\n  --kt-thumbnail-bg: #1e1e2d;\n  --kt-thumbnail-border-color: #2B2B40;\n  --kt-thumbnail-box-shadow: 0 0.1rem 1rem 0.25rem rgba(0, 0, 0, 0.05);\n  --kt-figure-caption-color: #6D6D80;\n  --kt-breadcrumb-bg: ;\n  --kt-breadcrumb-divider-color: #6D6D80;\n  --kt-breadcrumb-active-color: #009ef7;\n  --kt-carousel-custom-indicator-default-bg-color: #2B2B40;\n  --kt-carousel-custom-indicator-active-bg-color: #474761;\n  --kt-arousel-custom-bullet-indicator-default-bg-color: #474761;\n  --kt-carousel-custom-bullet-indicator-active-bg-color: #6D6D80;\n  --kt-btn-close-color: #ffffff;\n  --kt-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23ffffff'%3e%3cpath d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/%3e%3c/svg%3e\");\n  --kt-code-bg: #2B2B40;\n  --kt-code-box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);\n  --kt-code-color: #b93993;\n  --kt-offcanvas-border-color: ;\n  --kt-offcanvas-bg-color: #1e1e2d;\n  --kt-offcanvas-color: ;\n  --kt-offcanvas-box-shadow: 0 0.25rem 0.5rem rgba(255, 255, 255, 0.1);\n  --kt-offcanvas-backdrop-bg: #000000;\n  --kt-offcanvas-backdrop-opacity: 0.4;\n  --kt-code-bg: #2B2B40;\n  --kt-code-box-shadow: 0px 3px 9px rgba(0, 0, 0, 0.08);\n  --kt-code-color: #b93993;\n  --kt-symbol-label-color: #CDCDDE;\n  --kt-symbol-label-bg: #1b1b29;\n  --kt-symbol-border-color: rgba(255, 255, 255, 0.5);\n  --kt-bullet-bg-color: #474761;\n  --kt-scrolltop-opacity: 0;\n  --kt-scrolltop-opacity-on: 0.3;\n  --kt-scrolltop-opacity-hover: 1;\n  --kt-scrolltop-box-shadow: 0 0.5rem 1.5rem 0.5rem rgba(0, 0, 0, 0.075);\n  --kt-scrolltop-bg-color: #009ef7;\n  --kt-scrolltop-bg-color-hover: #009ef7;\n  --kt-scrolltop-icon-color: #ffffff;\n  --kt-scrolltop-icon-color-hover: #ffffff;\n  --kt-drawer-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);\n  --kt-drawer-bg-color: #1e1e2d;\n  --kt-drawer-overlay-bg-color: rgba(0, 0, 0, 0.4);\n  --kt-menu-dropdown-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --kt-menu-dropdown-bg-color: #1e1e2d;\n  --kt-menu-heading-color: #565674;\n  --kt-menu-link-color-hover: #009ef7;\n  --kt-menu-link-color-show: #009ef7;\n  --kt-menu-link-color-here: #009ef7;\n  --kt-menu-link-color-active: #009ef7;\n  --kt-menu-link-bg-color-hover: #2B2B40;\n  --kt-menu-link-bg-color-show: #2B2B40;\n  --kt-menu-link-bg-color-here: #2B2B40;\n  --kt-menu-link-bg-color-active: #2B2B40;\n  --kt-feedback-popup-box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.3);\n  --kt-feedback-popup-background-color: #1e1e2d;\n  --kt-scrollbar-color: #2B2B40;\n  --kt-scrollbar-hover-color: #27273a;\n  --kt-overlay-bg: rgba(255, 255, 255, 0.05);\n  --kt-blockui-overlay-bg: rgba(255, 255, 255, 0.05);\n  --kt-rating-color-default: #474761;\n  --kt-rating-color-active: #FFAD0F;\n  --kt-ribbon-label-box-shadow: 0px -1px 5px 0px rgba(255, 255, 255, 0.1);\n  --kt-ribbon-label-bg: #009ef7;\n  --kt-ribbon-label-border-color: #005d91;\n  --kt-ribbon-clip-bg: #f5f8fa;\n  --kt-engage-btn-bg: #2B2B40;\n  --kt-engage-btn-color: #6D6D80;\n  --kt-engage-btn-color-active: #CDCDDE;\n}\n\n[data-theme=dark] {\n  --bs-gray-100: #1b1b29;\n  --bs-gray-200: #2B2B40;\n  --bs-gray-300: #323248;\n  --bs-gray-400: #474761;\n  --bs-gray-500: #565674;\n  --bs-gray-600: #6D6D80;\n  --bs-gray-700: #92929F;\n  --bs-gray-800: #CDCDDE;\n  --bs-gray-900: #FFFFFF;\n  --bs-dark: #FFFFFF;\n  --bs-light: #2B2B40;\n  --bs-secondary: #323248;\n  --bs-body-color-rgb: 255, 255, 255;\n  --bs-body-bg-rgb: 30, 30, 45;\n  --bs-body-color: #FFFFFF;\n  --bs-body-bg: #1e1e2d;\n  --bs-border-color: #2B2B40;\n  --bs-heading-color: #FFFFFF;\n  --bs-link-color: #009ef7;\n  --bs-link-hover-color: #0095e8;\n  --bs-code-color: #b93993;\n}\n\nh1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {\n  color: var(--kt-headings-color);\n  outline: 0;\n}\n\n.blockquote-footer {\n  color: var(--kt-blockquote-footer-color);\n}\n\n[data-kt-theme-mode-switching=true] * {\n  transition: none !important;\n}\n\nhtml:not([data-theme=dark]) .theme-dark-show {\n  display: none !important;\n}\nhtml:not([data-theme=dark]) .theme-light-bg-transparent {\n  background-color: transparent !important;\n}\nhtml:not([data-theme=dark]) .theme-light-bg-body {\n  background-color: var(--kt-body-bg) !important;\n}\n\n[data-theme=dark] .theme-light-show {\n  display: none !important;\n}\n[data-theme=dark] .theme-dark-bg-transparent {\n  background-color: transparent !important;\n}\n[data-theme=dark] .theme-dark-bg-body {\n  background-color: var(--kt-body-bg) !important;\n}\n\n.animation {\n  animation-duration: 1s;\n  animation-fill-mode: both;\n}\n\n@keyframes animationSlideInDown {\n  from {\n    transform: translate3d(0, -100%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n.animation-slide-in-down {\n  animation-name: animationSlideInDown;\n}\n\n@keyframes animationSlideInUp {\n  from {\n    transform: translate3d(0, 100%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n.animation-slide-in-up {\n  animation-name: animationSlideInUp;\n}\n\n@keyframes animationFadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.animation-fade-in {\n  animation-name: animationFadeIn;\n}\n\n@keyframes animationFadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n.animation-fade-out {\n  animation-name: animationFadeOut;\n}\n\n.animation-blink {\n  animation: animationBlink 1s steps(5, start) infinite;\n}\n\n@keyframes animationBlink {\n  to {\n    visibility: hidden;\n  }\n}\n.animation-breathe {\n  animation: breathe 1.5s ease-in-out infinite alternate;\n}\n\n@keyframes breathe {\n  from {\n    opacity: 0.3;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.alert-white {\n  color: var(--kt-white);\n  border-color: var(--kt-white);\n  background-color: var(--kt-white-light);\n}\n.alert-white .alert-link {\n  color: var(--kt-white);\n}\n\n.alert-light {\n  color: var(--kt-light);\n  border-color: var(--kt-light);\n  background-color: var(--kt-light-light);\n}\n.alert-light .alert-link {\n  color: var(--kt-light);\n}\n\n.alert-primary {\n  color: var(--kt-primary);\n  border-color: var(--kt-primary);\n  background-color: var(--kt-primary-light);\n}\n.alert-primary .alert-link {\n  color: var(--kt-primary);\n}\n\n.alert-secondary {\n  color: var(--kt-secondary);\n  border-color: var(--kt-secondary);\n  background-color: var(--kt-secondary-light);\n}\n.alert-secondary .alert-link {\n  color: var(--kt-secondary);\n}\n\n.alert-success {\n  color: var(--kt-success);\n  border-color: var(--kt-success);\n  background-color: var(--kt-success-light);\n}\n.alert-success .alert-link {\n  color: var(--kt-success);\n}\n\n.alert-info {\n  color: var(--kt-info);\n  border-color: var(--kt-info);\n  background-color: var(--kt-info-light);\n}\n.alert-info .alert-link {\n  color: var(--kt-info);\n}\n\n.alert-warning {\n  color: var(--kt-warning);\n  border-color: var(--kt-warning);\n  background-color: var(--kt-warning-light);\n}\n.alert-warning .alert-link {\n  color: var(--kt-warning);\n}\n\n.alert-danger {\n  color: var(--kt-danger);\n  border-color: var(--kt-danger);\n  background-color: var(--kt-danger-light);\n}\n.alert-danger .alert-link {\n  color: var(--kt-danger);\n}\n\n.alert-dark {\n  color: var(--kt-dark);\n  border-color: var(--kt-dark);\n  background-color: var(--kt-dark-light);\n}\n.alert-dark .alert-link {\n  color: var(--kt-dark);\n}\n\n.list-group {\n  --bs-list-group-color: var(--kt-list-group-color);\n  --bs-list-group-bg: var(--kt-list-group-bg);\n  --bs-list-group-border-color: var(--kt-list-group-border-color);\n  --bs-list-group-action-color: var(--kt-list-group-action-color);\n  --bs-list-group-action-hover-color: var(--kt-list-group-action-hover-color);\n  --bs-list-group-action-hover-bg: var(--kt-list-group-hover-bg);\n  --bs-list-group-action-active-color: var(--kt-list-group-action-active-color);\n  --bs-list-group-action-active-bg: var(--kt-list-group-action-active-bg);\n  --bs-list-group-disabled-color: var(--kt-list-group-disabled-color);\n  --bs-list-group-disabled-bg: var(--kt-list-group-disabled-bg);\n  --bs-list-group-active-color: var(--kt-list-group-active-color);\n  --bs-list-group-active-bg: var(--kt-list-group-active-bg);\n  --bs-list-group-active-border-color: var(--kt-list-group-active-border-color);\n}\n\n.img-thumbnail {\n  background-color: var(--kt-thumbnail-bg);\n  border: 1px solid var(--kt-thumbnail-border-color);\n  box-shadow: var(--kt-thumbnail-box-shadow);\n}\n\n.figure-caption {\n  color: var(--kt-figure-caption-color);\n}\n\n.btn-group.show .dropdown-toggle {\n  box-shadow: var(--kt-btn-active-box-shadow);\n}\n\n.dropdown-menu {\n  --bs-dropdown-color: var(--kt-dropdown-color);\n  --bs-dropdown-bg: var(--kt-dropdown-bg);\n  --bs-dropdown-border-color: var(--kt-dropdown-border-color);\n  --bs-dropdown-divider-bg: var(--kt-dropdown-divider-bg);\n  --bs-dropdown-box-shadow: var(--kt-dropdown-box-shadow);\n  --bs-dropdown-link-color: var(--kt-dropdown-link-color);\n  --bs-dropdown-link-hover-color: var(--kt-dropdown-link-hover-color);\n  --bs-dropdown-link-hover-bg: var(--kt-dropdown-link-hover-bg);\n  --bs-dropdown-link-active-color: var(--kt-dropdown-link-active-color);\n  --bs-dropdown-link-active-bg: var(--kt-dropdown-link-active-bg);\n  --bs-dropdown-link-disabled-color: var(--kt-dropdown-link-disabled-color);\n  --bs-dropdown-header-color: var(--kt-dropdown-header-color);\n}\n\n.toast {\n  --bs-toast-color: var(--kt-toast-color);\n  --bs-toast-bg: var(--kt-toast-background-color);\n  --bs-toast-border-color: var(--kt-toast-border-color);\n  --bs-toast-box-shadow: var(--kt-toast-box-shadow);\n  --bs-toast-header-color: var(--kt-toast-header-color);\n  --bs-toast-header-bg: var(--kt-toast-header-background-color);\n  --bs-toast-header-border-color: var(--kt-toast-header-border-color);\n}\n.toast .toast-header .btn-close {\n  margin-right: 0;\n}\n\n.btn-close {\n  color: var(--kt-btn-close-color);\n  background-image: var(--kt-btn-close-bg);\n  background-position: center;\n}\n.btn-close:hover {\n  color: var(--kt-btn-close-color);\n}\n\n.offcanvas-sm, .offcanvas-md, .offcanvas-lg, .offcanvas-xl, .offcanvas-xxl, .offcanvas {\n  --bs-offcanvas-color: var(--kt-offcanvas-color);\n  --bs-offcanvas-bg: var(--kt-offcanvas-bg-color);\n  --bs-offcanvas-border-color: var(--kt-offcanvas-border-color);\n  --bs-offcanvas-box-shadow: var(--kt-offcanvas-box-shadow);\n}\n\n.nav {\n  --bs-nav-link-color: var(--kt-nav-link-color);\n  --bs-nav-link-hover-color: var(--kt-nav-link-hover-color);\n  --bs-nav-link-disabled-color: var(--kt-nav-link-disabled-color);\n}\n\n.nav-tabs {\n  --bs-nav-tabs-border-color: var(--kt-nav-tabs-border-color);\n  --bs-nav-tabs-link-hover-border-color: var(--kt-nav-tabs-link-hover-border-color);\n  --bs-nav-tabs-link-active-color: var(--kt-nav-tabs-link-active-color);\n  --bs-nav-tabs-link-active-bg: var(--kt-nav-tabs-link-active-bg);\n  --bs-nav-tabs-link-active-border-color: var(--kt-nav-tabs-link-active-border-color);\n}\n\n.nav-pills {\n  --bs-nav-pills-link-active-color: var(--kt-nav-pills-link-active-color);\n  --bs-nav-pills-link-active-bg: var(--kt-nav-pills-link-active-bg);\n}\n\n.nav-pills .nav-item {\n  margin-right: 0.5rem;\n}\n.nav-pills .nav-item:last-child {\n  margin-right: 0;\n}\n\n.nav-stretch {\n  align-items: stretch;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.nav-stretch .nav-item {\n  display: flex;\n  align-items: stretch;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.nav-stretch .nav-link {\n  display: flex;\n  align-items: center;\n}\n\n.nav-group {\n  padding: 0.35rem;\n  border-radius: 0.475rem;\n  background-color: var(--kt-gray-100);\n}\n.nav-group.nav-group-outline {\n  background-color: transparent;\n  border: 1px solid var(--kt-border-color);\n}\n.nav-group.nav-group-fluid {\n  display: flex;\n}\n.nav-group.nav-group-fluid > label,\n.nav-group.nav-group-fluid > .btn {\n  position: relative;\n  flex-shrink: 0;\n  flex-grow: 1;\n  flex-basis: 0;\n}\n.nav-group.nav-group-fluid > label {\n  margin-right: 0.1rem;\n}\n.nav-group.nav-group-fluid > label > .btn {\n  width: 100%;\n}\n.nav-group.nav-group-fluid > label:last-child {\n  margin-right: 0;\n}\n\n.nav-line-tabs {\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  border-bottom-color: var(--kt-border-color);\n}\n.nav-line-tabs .nav-item {\n  margin-bottom: -1px;\n}\n.nav-line-tabs .nav-item .nav-link {\n  color: var(--kt-gray-500);\n  border: 0;\n  border-bottom: 1px solid transparent;\n  transition: color 0.2s ease;\n  padding: 0.5rem 0;\n  margin: 0 1rem;\n}\n.nav-line-tabs .nav-item:first-child .nav-link {\n  margin-left: 0;\n}\n.nav-line-tabs .nav-item:last-child .nav-link {\n  margin-right: 0;\n}\n.nav-line-tabs .nav-item .nav-link.active,\n.nav-line-tabs .nav-item.show .nav-link,\n.nav-line-tabs .nav-item .nav-link:hover:not(.disabled) {\n  background-color: transparent;\n  border: 0;\n  border-bottom: 1px solid var(--kt-primary);\n  transition: color 0.2s ease;\n}\n.nav-line-tabs.nav-line-tabs-2x {\n  border-bottom-width: 2px;\n}\n.nav-line-tabs.nav-line-tabs-2x .nav-item {\n  margin-bottom: -2px;\n}\n.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link {\n  border-bottom-width: 2px;\n}\n.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link.active,\n.nav-line-tabs.nav-line-tabs-2x .nav-item.show .nav-link,\n.nav-line-tabs.nav-line-tabs-2x .nav-item .nav-link:hover:not(.disabled) {\n  border-bottom-width: 2px;\n}\n\n.nav.nav-pills.nav-pills-custom .show > .nav-link,\n.nav.nav-pills.nav-pills-custom .nav-link {\n  border: 1px dashed var(--kt-border-dashed-color);\n  border-radius: 0.625rem;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.nav-link-border-solid,\n.nav.nav-pills.nav-pills-custom .nav-link.nav-link-border-solid {\n  border: 3px solid var(--kt-border-dashed-color);\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.nav-link-border-solid.active,\n.nav.nav-pills.nav-pills-custom .nav-link.nav-link-border-solid.active {\n  border: 3px solid var(--kt-primary);\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img,\n.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img {\n  width: 30px;\n  transition: color 0.2s ease;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.default,\n.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.default {\n  display: inline-block;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .nav-icon img.active,\n.nav.nav-pills.nav-pills-custom .nav-link .nav-icon img.active {\n  display: none;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.active,\n.nav.nav-pills.nav-pills-custom .nav-link.active {\n  background-color: transparent;\n  border: 1px solid var(--kt-border-dashed-color);\n  transition-duration: 1ms;\n  position: relative;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.active .nav-text,\n.nav.nav-pills.nav-pills-custom .nav-link.active .nav-text {\n  color: var(--kt-gray-800) !important;\n  transition: color 0.2s ease;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link.active .bullet-custom,\n.nav.nav-pills.nav-pills-custom .nav-link.active .bullet-custom {\n  display: block;\n}\n.nav.nav-pills.nav-pills-custom .show > .nav-link .bullet-custom,\n.nav.nav-pills.nav-pills-custom .nav-link .bullet-custom {\n  display: none;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:not(:active) span:nth-child(1) {\n  color: #B5B5C3;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:not(:active) span:nth-child(2) {\n  color: #3F4254;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:hover span:nth-child(1) {\n  color: #ffffff !important;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link:hover span:nth-child(2) {\n  color: #ffffff !important;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link.active span:nth-child(1) {\n  color: #ffffff !important;\n}\n.nav.nav-pills.nav-pills-custom.nav-pills-active-custom .nav-item .nav-link.active span:nth-child(2) {\n  color: #ffffff !important;\n}\n\n.pagination {\n  --bs-pagination-color: var(--kt-pagination-color);\n  --bs-pagination-bg: var(--kt-pagination-bg);\n  --bs-pagination-border-color: var(--kt-pagination-border-color);\n  --bs-pagination-hover-color: var(--kt-pagination-hover-color);\n  --bs-pagination-hover-bg: var(--kt-pagination-hover-bg);\n  --bs-pagination-hover-border-color: var(--kt-pagination-hover-border-color);\n  --bs-pagination-focus-color: var(--kt-pagination-focus-color);\n  --bs-pagination-focus-bg: var(--kt-pagination-focus-bg);\n  --bs-pagination-focus-box-shadow: var(--kt-pagination-focus-box-shadow);\n  --bs-pagination-active-color: var(--kt-pagination-active-color);\n  --bs-pagination-active-bg: var(--kt-pagination-active-bg);\n  --bs-pagination-active-border-color: var(--kt-pagination-active-border-color);\n  --bs-pagination-disabled-color: var(--kt-pagination-disabled-color);\n  --bs-pagination-disabled-bg: var(--kt-pagination-disabled-bg);\n  --bs-pagination-disabled-border-color: var(--kt-pagination-disabled-border-color);\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin: 0;\n}\n.pagination.pagination-circle .page-link {\n  border-radius: 50%;\n}\n.pagination.pagination-outline .page-link {\n  border: 1px solid var(--kt-border-color);\n}\n.pagination.pagination-outline .page-item:hover:not(.disabled) .page-link, .pagination.pagination-outline .page-item.active .page-link {\n  border-color: var(--kt-primary-light);\n}\n\n.page-item {\n  margin-right: 0.5rem;\n  /*rtl:end:ignore*/\n}\n.page-item:last-child {\n  margin-right: 0;\n}\n.page-item .page-link {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 0.475rem;\n  height: 2.5rem;\n  min-width: 2.5rem;\n  font-weight: 500;\n  font-size: 1.075rem;\n  /*rtl:options:{\"autoRename\":false}*/\n  /*rtl:end:ignore*/\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item .page-link i {\n  font-size: 0.85rem;\n}\n.page-item .page-link .previous,\n.page-item .page-link .next {\n  display: block;\n  height: 0.875rem;\n  width: 0.875rem;\n  /*rtl:raw:transform: rotateZ(-180deg);*/\n}\n.page-item .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: #5E6278;\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%235E6278'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%235E6278'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: #5E6278;\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%235E6278'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%235E6278'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n.page-item:focus .page-link {\n  color: var(--kt-pagination-focus-color);\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item:focus .page-link .svg-icon,\n.page-item:focus .page-link i {\n  color: var(--kt-pagination-focus-color);\n}\n.page-item:focus .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-pagination-focus-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-focus-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-focus-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item:focus .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-pagination-focus-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-focus-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-focus-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link {\n  color: var(--kt-pagination-hover-color);\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link.page-text {\n  background-color: transparent;\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .svg-icon,\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link i {\n  color: var(--kt-pagination-hover-color);\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-pagination-hover-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-hover-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-hover-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item:hover:not(.active):not(.offset):not(.disabled) .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-pagination-hover-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-hover-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-hover-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n.page-item.active .page-link {\n  color: var(--kt-pagination-active-color);\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item.active .page-link.page-text {\n  background-color: transparent;\n}\n.page-item.active .page-link .svg-icon,\n.page-item.active .page-link i {\n  color: var(--kt-pagination-active-color);\n}\n.page-item.active .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-pagination-active-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-active-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-active-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item.active .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-pagination-active-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-active-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-active-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n.page-item.disabled .page-link {\n  color: var(--kt-pagination-disabled-color);\n  /*rtl:options:{\"autoRename\":false}*/\n}\n.page-item.disabled .page-link .svg-icon,\n.page-item.disabled .page-link i {\n  color: var(--kt-pagination-disabled-color);\n}\n.page-item.disabled .page-link .previous {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-pagination-disabled-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-disabled-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-disabled-color%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n}\n.page-item.disabled .page-link .next {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-pagination-disabled-color);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-disabled-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-pagination-disabled-color%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n}\n\n@media (max-width: 991.98px) {\n  .page-item {\n    margin-right: 0.25rem;\n  }\n  .page-item:last-child {\n    margin-right: 0;\n  }\n}\n.separator {\n  display: block;\n  height: 0;\n  border-bottom: 1px solid var(--kt-border-color);\n}\n.separator.separator-dotted {\n  border-bottom-style: dotted;\n  border-bottom-color: var(--kt-border-dashed-color);\n}\n.separator.separator-dashed {\n  border-bottom-style: dashed;\n  border-bottom-color: var(--kt-border-dashed-color);\n}\n.separator.separator-content {\n  display: flex;\n  align-items: center;\n  border-bottom: 0;\n  text-align: center;\n}\n.separator.separator-content::before, .separator.separator-content::after {\n  content: \" \";\n  width: 50%;\n  border-bottom: 1px solid var(--kt-border-color);\n}\n.separator.separator-content::before {\n  margin-right: 1.25rem;\n}\n.separator.separator-content::after {\n  margin-left: 1.25rem;\n}\n.separator.separator-content.separator-dotted::before, .separator.separator-content.separator-dotted::after {\n  border-bottom-style: dotted;\n  border-bottom-color: var(--kt-border-dashed-color);\n}\n.separator.separator-content.separator-dashed::before, .separator.separator-content.separator-dashed::after {\n  border-bottom-style: dashed;\n  border-bottom-color: var(--kt-border-dashed-color);\n}\n.separator.separator-content.border-white::before, .separator.separator-content.border-white::after {\n  border-color: #ffffff !important;\n}\n.separator.separator-content.border-light::before, .separator.separator-content.border-light::after {\n  border-color: #f5f8fa !important;\n}\n.separator.separator-content.border-primary::before, .separator.separator-content.border-primary::after {\n  border-color: #009ef7 !important;\n}\n.separator.separator-content.border-secondary::before, .separator.separator-content.border-secondary::after {\n  border-color: #E4E6EF !important;\n}\n.separator.separator-content.border-success::before, .separator.separator-content.border-success::after {\n  border-color: #50cd89 !important;\n}\n.separator.separator-content.border-info::before, .separator.separator-content.border-info::after {\n  border-color: #7239ea !important;\n}\n.separator.separator-content.border-warning::before, .separator.separator-content.border-warning::after {\n  border-color: #ffc700 !important;\n}\n.separator.separator-content.border-danger::before, .separator.separator-content.border-danger::after {\n  border-color: #f1416c !important;\n}\n.separator.separator-content.border-dark::before, .separator.separator-content.border-dark::after {\n  border-color: #181C32 !important;\n}\n\n.carousel-custom .carousel-indicators {\n  align-items: center;\n  position: static;\n  z-index: auto;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.carousel-custom .carousel-indicators li {\n  transform: none;\n  opacity: 1;\n}\n.carousel-custom .carousel-indicators li.active {\n  transform: none;\n  opacity: 1;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-dots li {\n  border-radius: 0;\n  background-color: transparent;\n  height: 13px;\n  width: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-dots li:after {\n  display: inline-block;\n  content: \" \";\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  background-color: var(--kt-carousel-custom-indicator-default-bg-color);\n  height: 9px;\n  width: 9px;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-dots li.active {\n  background-color: transparent;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-dots li.active:after {\n  transition: all 0.3s ease;\n  height: 13px;\n  width: 13px;\n  background-color: var(--kt-carousel-custom-indicator-active-bg-color);\n}\n.carousel-custom .carousel-indicators.carousel-indicators-bullet li {\n  transition: all 0.3s ease;\n  background-color: transparent;\n  border-radius: 6px;\n  height: 6px;\n  width: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-bullet li:after {\n  display: inline-block;\n  content: \" \";\n  transition: all 0.3s ease;\n  background-color: var(--kt-carousel-custom-bullet-indicator-default-bg-color);\n  border-radius: 6px;\n  height: 6px;\n  width: 6px;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-bullet li.active {\n  transition: all 0.3s ease;\n  background-color: transparent;\n  height: 6px;\n  width: 16px;\n}\n.carousel-custom .carousel-indicators.carousel-indicators-bullet li.active:after {\n  transition: all 0.3s ease;\n  height: 6px;\n  width: 16px;\n  background-color: var(--kt-carousel-custom-bullet-indicator-active-bg-color);\n}\n.carousel-custom .carousel-indicators-active-white li.active:after {\n  background-color: #ffffff !important;\n}\n.carousel-custom .carousel-indicators-active-light li.active:after {\n  background-color: #f5f8fa !important;\n}\n.carousel-custom .carousel-indicators-active-primary li.active:after {\n  background-color: #009ef7 !important;\n}\n.carousel-custom .carousel-indicators-active-secondary li.active:after {\n  background-color: #E4E6EF !important;\n}\n.carousel-custom .carousel-indicators-active-success li.active:after {\n  background-color: #50cd89 !important;\n}\n.carousel-custom .carousel-indicators-active-info li.active:after {\n  background-color: #7239ea !important;\n}\n.carousel-custom .carousel-indicators-active-warning li.active:after {\n  background-color: #ffc700 !important;\n}\n.carousel-custom .carousel-indicators-active-danger li.active:after {\n  background-color: #f1416c !important;\n}\n.carousel-custom .carousel-indicators-active-dark li.active:after {\n  background-color: #181C32 !important;\n}\n.carousel-custom.carousel-stretch {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.carousel-custom.carousel-stretch .carousel-inner {\n  flex-grow: 1;\n}\n.carousel-custom.carousel-stretch .carousel-item {\n  height: 100%;\n}\n.carousel-custom.carousel-stretch .carousel-wrapper {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.menu-group {\n  display: flex;\n}\n\n.menu,\n.menu-wrapper {\n  display: flex;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.menu-inner {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.menu-sub {\n  display: none;\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  flex-direction: column;\n}\n\n.menu-item {\n  display: block;\n  padding: 0.15rem 0;\n}\n.menu-item .menu-link {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  padding: 0;\n  flex: 0 0 100%;\n  padding: 0.65rem 1rem;\n  transition: none;\n  outline: none !important;\n}\n.menu-item .menu-link .menu-icon {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 2rem;\n  margin-right: 0.5rem;\n}\n.menu-item .menu-link .menu-icon .svg-icon {\n  line-height: 1;\n}\n.menu-item .menu-link .menu-bullet {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.25rem;\n  margin-right: 0.5rem;\n}\n.menu-item .menu-link .menu-title {\n  display: flex;\n  align-items: center;\n  flex-grow: 1;\n}\n.menu-item .menu-link .menu-badge {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  margin-left: 0.5rem;\n}\n.menu-item .menu-link .menu-arrow {\n  display: flex;\n  align-items: stretch;\n  position: relative;\n  overflow: hidden;\n  flex-shrink: 0;\n  margin-left: 5px;\n  width: 9px;\n  height: 9px;\n}\n.menu-item .menu-link .menu-arrow:after {\n  display: block;\n  width: 100%;\n  content: \" \";\n  will-change: transform;\n  background-size: 100% 100%;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-item .menu-content {\n  padding: 0.65rem 1rem;\n}\n\n.menu-item.show .menu-link .menu-arrow:after {\n  backface-visibility: hidden;\n  transition: transform 0.3s ease;\n}\n\n.menu-center {\n  justify-content: center;\n}\n\n.menu-heading {\n  color: var(--kt-menu-heading-color);\n}\n\n.menu-item.menu-accordion .menu-arrow:after {\n  /*rtl:ignore*/\n  transform: rotateZ(-90deg);\n  /*rtl:remove*/\n  transform: rotateZ(90deg);\n  transition: transform 0.3s ease;\n}\n.menu-item.menu-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n  /*rtl:ignore*/\n  transform: rotateZ(90deg);\n  /*rtl:remove*/\n  transform: rotateZ(-90deg);\n  transition: transform 0.3s ease;\n}\n\n.menu-sub-dropdown {\n  display: none;\n  border-radius: 0.475rem;\n  background-color: var(--kt-menu-dropdown-bg-color);\n  box-shadow: var(--kt-menu-dropdown-box-shadow);\n  z-index: 107;\n}\n.show.menu-dropdown > .menu-sub-dropdown, .menu-sub-dropdown.menu.show, .menu-sub-dropdown.show[data-popper-placement] {\n  display: flex;\n  will-change: transform;\n  animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n}\n\n.menu-sub-accordion {\n  display: none;\n}\n.show:not(.menu-dropdown) > .menu-sub-accordion, .menu-sub-accordion.show {\n  display: flex;\n}\n\n.menu-sub-indention .menu-sub:not([data-popper-placement]) {\n  margin-left: 1rem;\n}\n.menu-sub-indention .menu-item .menu-item .menu-link.active {\n  margin-right: 1rem;\n}\n\n.menu-inline {\n  display: flex;\n}\n\n.menu-fit > .menu-item > .menu-content,\n.menu-fit > .menu-item > .menu-link {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n\n.menu-column {\n  flex-direction: column;\n  width: 100%;\n}\n\n.menu-row {\n  flex-direction: row;\n}\n.menu-row > .menu-item {\n  display: flex;\n  align-items: center;\n}\n.menu-row > .menu-item > .menu-link .menu-arrow:after {\n  /*rtl:ignore*/\n  transform: rotateZ(-90deg);\n  /*rtl:remove*/\n  transform: rotateZ(90deg);\n  transition: transform 0.3s ease;\n}\n\n.menu-rounded .menu-link {\n  border-radius: 0.475rem;\n}\n\n.menu-pill .menu-link {\n  border-radius: 50px;\n}\n\n.menu-rounded-0 .menu-link {\n  border-radius: 0 !important;\n}\n\n@media (min-width: 576px) {\n  .menu-item.menu-sm-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-sm-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-sub-sm-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--kt-menu-dropdown-bg-color);\n    box-shadow: var(--kt-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-sm-dropdown, .menu-sub-sm-dropdown.menu.show, .menu-sub-sm-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n\n  .menu-sub-sm-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-sm-accordion, .menu-sub-sm-accordion.show {\n    display: flex;\n  }\n\n  .menu-sub-sm-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-sm-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n\n  .menu-sm-inline {\n    display: flex;\n  }\n\n  .menu-sm-fit > .menu-item > .menu-content,\n.menu-sm-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-sm-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-sm-row {\n    flex-direction: row;\n  }\n  .menu-sm-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-sm-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-sm-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-sm-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-sm-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 768px) {\n  .menu-item.menu-md-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-md-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-sub-md-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--kt-menu-dropdown-bg-color);\n    box-shadow: var(--kt-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-md-dropdown, .menu-sub-md-dropdown.menu.show, .menu-sub-md-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n\n  .menu-sub-md-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-md-accordion, .menu-sub-md-accordion.show {\n    display: flex;\n  }\n\n  .menu-sub-md-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-md-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n\n  .menu-md-inline {\n    display: flex;\n  }\n\n  .menu-md-fit > .menu-item > .menu-content,\n.menu-md-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-md-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-md-row {\n    flex-direction: row;\n  }\n  .menu-md-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-md-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-md-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-md-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-md-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 992px) {\n  .menu-item.menu-lg-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-lg-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-sub-lg-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--kt-menu-dropdown-bg-color);\n    box-shadow: var(--kt-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-lg-dropdown, .menu-sub-lg-dropdown.menu.show, .menu-sub-lg-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n\n  .menu-sub-lg-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-lg-accordion, .menu-sub-lg-accordion.show {\n    display: flex;\n  }\n\n  .menu-sub-lg-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-lg-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n\n  .menu-lg-inline {\n    display: flex;\n  }\n\n  .menu-lg-fit > .menu-item > .menu-content,\n.menu-lg-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-lg-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-lg-row {\n    flex-direction: row;\n  }\n  .menu-lg-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-lg-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-lg-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-lg-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-lg-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 1200px) {\n  .menu-item.menu-xl-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-xl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-sub-xl-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--kt-menu-dropdown-bg-color);\n    box-shadow: var(--kt-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-xl-dropdown, .menu-sub-xl-dropdown.menu.show, .menu-sub-xl-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n\n  .menu-sub-xl-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xl-accordion, .menu-sub-xl-accordion.show {\n    display: flex;\n  }\n\n  .menu-sub-xl-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-xl-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n\n  .menu-xl-inline {\n    display: flex;\n  }\n\n  .menu-xl-fit > .menu-item > .menu-content,\n.menu-xl-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-xl-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-xl-row {\n    flex-direction: row;\n  }\n  .menu-xl-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xl-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-xl-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-xl-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-xl-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (min-width: 1400px) {\n  .menu-item.menu-xxl-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-xxl-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-sub-xxl-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--kt-menu-dropdown-bg-color);\n    box-shadow: var(--kt-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-xxl-dropdown, .menu-sub-xxl-dropdown.menu.show, .menu-sub-xxl-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n\n  .menu-sub-xxl-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xxl-accordion, .menu-sub-xxl-accordion.show {\n    display: flex;\n  }\n\n  .menu-sub-xxl-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-xxl-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n\n  .menu-xxl-inline {\n    display: flex;\n  }\n\n  .menu-xxl-fit > .menu-item > .menu-content,\n.menu-xxl-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-xxl-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-xxl-row {\n    flex-direction: row;\n  }\n  .menu-xxl-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xxl-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-xxl-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-xxl-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-xxl-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 575.98px) {\n  .menu-item.menu-sm-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-sm-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-sm-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-sub-sm-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--kt-menu-dropdown-bg-color);\n    box-shadow: var(--kt-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-sm-down-dropdown, .menu-sub-sm-down-dropdown.menu.show, .menu-sub-sm-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n\n  .menu-sub-sm-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-sm-down-accordion, .menu-sub-sm-down-accordion.show {\n    display: flex;\n  }\n\n  .menu-sub-sm-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-sm-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n\n  .menu-sm-down-inline {\n    display: flex;\n  }\n\n  .menu-sm-down-fit > .menu-item > .menu-content,\n.menu-sm-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-sm-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-sm-down-row {\n    flex-direction: row;\n  }\n  .menu-sm-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-sm-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-sm-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-sm-down-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-sm-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 767.98px) {\n  .menu-item.menu-md-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-md-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-md-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-sub-md-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--kt-menu-dropdown-bg-color);\n    box-shadow: var(--kt-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-md-down-dropdown, .menu-sub-md-down-dropdown.menu.show, .menu-sub-md-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n\n  .menu-sub-md-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-md-down-accordion, .menu-sub-md-down-accordion.show {\n    display: flex;\n  }\n\n  .menu-sub-md-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-md-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n\n  .menu-md-down-inline {\n    display: flex;\n  }\n\n  .menu-md-down-fit > .menu-item > .menu-content,\n.menu-md-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-md-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-md-down-row {\n    flex-direction: row;\n  }\n  .menu-md-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-md-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-md-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-md-down-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-md-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .menu-item.menu-lg-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-lg-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-lg-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-sub-lg-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--kt-menu-dropdown-bg-color);\n    box-shadow: var(--kt-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-lg-down-dropdown, .menu-sub-lg-down-dropdown.menu.show, .menu-sub-lg-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n\n  .menu-sub-lg-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-lg-down-accordion, .menu-sub-lg-down-accordion.show {\n    display: flex;\n  }\n\n  .menu-sub-lg-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-lg-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n\n  .menu-lg-down-inline {\n    display: flex;\n  }\n\n  .menu-lg-down-fit > .menu-item > .menu-content,\n.menu-lg-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-lg-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-lg-down-row {\n    flex-direction: row;\n  }\n  .menu-lg-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-lg-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-lg-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-lg-down-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-lg-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 1199.98px) {\n  .menu-item.menu-xl-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-xl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-sub-xl-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--kt-menu-dropdown-bg-color);\n    box-shadow: var(--kt-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-xl-down-dropdown, .menu-sub-xl-down-dropdown.menu.show, .menu-sub-xl-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n\n  .menu-sub-xl-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xl-down-accordion, .menu-sub-xl-down-accordion.show {\n    display: flex;\n  }\n\n  .menu-sub-xl-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-xl-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n\n  .menu-xl-down-inline {\n    display: flex;\n  }\n\n  .menu-xl-down-fit > .menu-item > .menu-content,\n.menu-xl-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-xl-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-xl-down-row {\n    flex-direction: row;\n  }\n  .menu-xl-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xl-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-xl-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-xl-down-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-xl-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n@media (max-width: 1399.98px) {\n  .menu-item.menu-xxl-down-accordion .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n  .menu-item.menu-xxl-down-accordion.showing:not(.menu-dropdown) > .menu-link .menu-arrow:after, .menu-item.menu-xxl-down-accordion.show:not(.hiding):not(.menu-dropdown) > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(90deg);\n    /*rtl:remove*/\n    transform: rotateZ(-90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-sub-xxl-down-dropdown {\n    display: none;\n    border-radius: 0.475rem;\n    background-color: var(--kt-menu-dropdown-bg-color);\n    box-shadow: var(--kt-menu-dropdown-box-shadow);\n    z-index: 107;\n  }\n  .show.menu-dropdown > .menu-sub-xxl-down-dropdown, .menu-sub-xxl-down-dropdown.menu.show, .menu-sub-xxl-down-dropdown.show[data-popper-placement] {\n    display: flex;\n    will-change: transform;\n    animation: menu-sub-dropdown-animation-fade-in 0.3s ease 1, menu-sub-dropdown-animation-move-up 0.3s ease 1;\n  }\n\n  .menu-sub-xxl-down-accordion {\n    display: none;\n  }\n  .show:not(.menu-dropdown) > .menu-sub-xxl-down-accordion, .menu-sub-xxl-down-accordion.show {\n    display: flex;\n  }\n\n  .menu-sub-xxl-down-indention .menu-sub:not([data-popper-placement]) {\n    margin-left: 1rem;\n  }\n  .menu-sub-xxl-down-indention .menu-item .menu-item .menu-link.active {\n    margin-right: 1rem;\n  }\n\n  .menu-xxl-down-inline {\n    display: flex;\n  }\n\n  .menu-xxl-down-fit > .menu-item > .menu-content,\n.menu-xxl-down-fit > .menu-item > .menu-link {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n\n  .menu-xxl-down-column {\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .menu-xxl-down-row {\n    flex-direction: row;\n  }\n  .menu-xxl-down-row > .menu-item {\n    display: flex;\n    align-items: center;\n  }\n  .menu-xxl-down-row > .menu-item > .menu-link .menu-arrow:after {\n    /*rtl:ignore*/\n    transform: rotateZ(-90deg);\n    /*rtl:remove*/\n    transform: rotateZ(90deg);\n    transition: transform 0.3s ease;\n  }\n\n  .menu-xxl-down-rounded .menu-link {\n    border-radius: 0.475rem;\n  }\n\n  .menu-xxl-down-pill .menu-link {\n    border-radius: 50px;\n  }\n\n  .menu-xxl-down-rounded-0 .menu-link {\n    border-radius: 0 !important;\n  }\n}\n.menu-link-indention .menu-item {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(1rem + 1rem);\n}\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(2rem + 1rem);\n}\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(3rem + 1rem);\n}\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(4rem + 1rem);\n}\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: 1rem;\n  padding-right: 0;\n}\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(2rem);\n  padding-right: 0;\n}\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(3rem);\n  padding-right: 0;\n}\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-item > .menu-link,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-content,\n.menu-link-indention.menu-fit .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-sub:not([data-popper-placement]) > .menu-inner > .menu-item > .menu-link {\n  padding-left: calc(4rem);\n  padding-right: 0;\n}\n\n@keyframes menu-sub-dropdown-animation-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes menu-sub-dropdown-animation-move-up {\n  from {\n    margin-top: 0.75rem;\n  }\n  to {\n    margin-top: 0;\n  }\n}\n@keyframes menu-sub-dropdown-animation-move-down {\n  from {\n    margin-bottom: 0.75rem;\n  }\n  to {\n    margin-bottom: 0;\n  }\n}\n.menu-white .menu-item .menu-link {\n  color: var(--kt-white);\n}\n.menu-white .menu-item .menu-link .menu-title {\n  color: var(--kt-white);\n}\n.menu-white .menu-item .menu-link .menu-icon,\n.menu-white .menu-item .menu-link .menu-icon .svg-icon,\n.menu-white .menu-item .menu-link .menu-icon i {\n  color: var(--kt-white);\n}\n.menu-white .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-white);\n}\n.menu-white .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-white);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-white%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-white%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-white);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-white%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-white%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-white .menu-item .menu-link {\n  color: var(--kt-text-white);\n}\n.menu-title-white .menu-item .menu-link .menu-title {\n  color: var(--kt-text-white);\n}\n\n.menu-icon-white .menu-item .menu-link .menu-icon,\n.menu-icon-white .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-white .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-white);\n}\n\n.menu-bullet-white .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-white);\n}\n\n.menu-arrow-white .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-white);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-white%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-white%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-white);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-white%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-white%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-primary .menu-item .menu-link {\n  color: var(--kt-primary);\n}\n.menu-primary .menu-item .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n.menu-primary .menu-item .menu-link .menu-icon,\n.menu-primary .menu-item .menu-link .menu-icon .svg-icon,\n.menu-primary .menu-item .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-primary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-primary .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-primary .menu-item .menu-link {\n  color: var(--kt-text-primary);\n}\n.menu-title-primary .menu-item .menu-link .menu-title {\n  color: var(--kt-text-primary);\n}\n\n.menu-icon-primary .menu-item .menu-link .menu-icon,\n.menu-icon-primary .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-primary .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-primary);\n}\n\n.menu-bullet-primary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-primary);\n}\n\n.menu-arrow-primary .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-secondary .menu-item .menu-link {\n  color: var(--kt-secondary);\n}\n.menu-secondary .menu-item .menu-link .menu-title {\n  color: var(--kt-secondary);\n}\n.menu-secondary .menu-item .menu-link .menu-icon,\n.menu-secondary .menu-item .menu-link .menu-icon .svg-icon,\n.menu-secondary .menu-item .menu-link .menu-icon i {\n  color: var(--kt-secondary);\n}\n.menu-secondary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-secondary);\n}\n.menu-secondary .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-secondary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-secondary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-secondary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-secondary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-secondary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-secondary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-secondary .menu-item .menu-link {\n  color: var(--kt-text-secondary);\n}\n.menu-title-secondary .menu-item .menu-link .menu-title {\n  color: var(--kt-text-secondary);\n}\n\n.menu-icon-secondary .menu-item .menu-link .menu-icon,\n.menu-icon-secondary .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-secondary .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-secondary);\n}\n\n.menu-bullet-secondary .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-secondary);\n}\n\n.menu-arrow-secondary .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-secondary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-secondary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-secondary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-secondary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-secondary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-secondary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-light .menu-item .menu-link {\n  color: var(--kt-light);\n}\n.menu-light .menu-item .menu-link .menu-title {\n  color: var(--kt-light);\n}\n.menu-light .menu-item .menu-link .menu-icon,\n.menu-light .menu-item .menu-link .menu-icon .svg-icon,\n.menu-light .menu-item .menu-link .menu-icon i {\n  color: var(--kt-light);\n}\n.menu-light .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-light);\n}\n.menu-light .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-light);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-light%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-light%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-light);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-light%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-light%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-light .menu-item .menu-link {\n  color: var(--kt-text-light);\n}\n.menu-title-light .menu-item .menu-link .menu-title {\n  color: var(--kt-text-light);\n}\n\n.menu-icon-light .menu-item .menu-link .menu-icon,\n.menu-icon-light .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-light .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-light);\n}\n\n.menu-bullet-light .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-light);\n}\n\n.menu-arrow-light .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-light);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-light%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-light%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-light);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-light%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-light%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-success .menu-item .menu-link {\n  color: var(--kt-success);\n}\n.menu-success .menu-item .menu-link .menu-title {\n  color: var(--kt-success);\n}\n.menu-success .menu-item .menu-link .menu-icon,\n.menu-success .menu-item .menu-link .menu-icon .svg-icon,\n.menu-success .menu-item .menu-link .menu-icon i {\n  color: var(--kt-success);\n}\n.menu-success .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-success);\n}\n.menu-success .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-success);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-success%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-success%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-success);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-success%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-success%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-success .menu-item .menu-link {\n  color: var(--kt-text-success);\n}\n.menu-title-success .menu-item .menu-link .menu-title {\n  color: var(--kt-text-success);\n}\n\n.menu-icon-success .menu-item .menu-link .menu-icon,\n.menu-icon-success .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-success .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-success);\n}\n\n.menu-bullet-success .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-success);\n}\n\n.menu-arrow-success .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-success);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-success%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-success%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-success);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-success%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-success%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-info .menu-item .menu-link {\n  color: var(--kt-info);\n}\n.menu-info .menu-item .menu-link .menu-title {\n  color: var(--kt-info);\n}\n.menu-info .menu-item .menu-link .menu-icon,\n.menu-info .menu-item .menu-link .menu-icon .svg-icon,\n.menu-info .menu-item .menu-link .menu-icon i {\n  color: var(--kt-info);\n}\n.menu-info .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-info);\n}\n.menu-info .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-info);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-info%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-info%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-info);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-info%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-info%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-info .menu-item .menu-link {\n  color: var(--kt-text-info);\n}\n.menu-title-info .menu-item .menu-link .menu-title {\n  color: var(--kt-text-info);\n}\n\n.menu-icon-info .menu-item .menu-link .menu-icon,\n.menu-icon-info .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-info .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-info);\n}\n\n.menu-bullet-info .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-info);\n}\n\n.menu-arrow-info .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-info);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-info%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-info%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-info);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-info%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-info%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-warning .menu-item .menu-link {\n  color: var(--kt-warning);\n}\n.menu-warning .menu-item .menu-link .menu-title {\n  color: var(--kt-warning);\n}\n.menu-warning .menu-item .menu-link .menu-icon,\n.menu-warning .menu-item .menu-link .menu-icon .svg-icon,\n.menu-warning .menu-item .menu-link .menu-icon i {\n  color: var(--kt-warning);\n}\n.menu-warning .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-warning);\n}\n.menu-warning .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-warning);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-warning%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-warning%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-warning);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-warning%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-warning%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-warning .menu-item .menu-link {\n  color: var(--kt-text-warning);\n}\n.menu-title-warning .menu-item .menu-link .menu-title {\n  color: var(--kt-text-warning);\n}\n\n.menu-icon-warning .menu-item .menu-link .menu-icon,\n.menu-icon-warning .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-warning .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-warning);\n}\n\n.menu-bullet-warning .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-warning);\n}\n\n.menu-arrow-warning .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-warning);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-warning%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-warning%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-warning);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-warning%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-warning%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-danger .menu-item .menu-link {\n  color: var(--kt-danger);\n}\n.menu-danger .menu-item .menu-link .menu-title {\n  color: var(--kt-danger);\n}\n.menu-danger .menu-item .menu-link .menu-icon,\n.menu-danger .menu-item .menu-link .menu-icon .svg-icon,\n.menu-danger .menu-item .menu-link .menu-icon i {\n  color: var(--kt-danger);\n}\n.menu-danger .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-danger);\n}\n.menu-danger .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-danger);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-danger%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-danger%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-danger);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-danger%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-danger%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-danger .menu-item .menu-link {\n  color: var(--kt-text-danger);\n}\n.menu-title-danger .menu-item .menu-link .menu-title {\n  color: var(--kt-text-danger);\n}\n\n.menu-icon-danger .menu-item .menu-link .menu-icon,\n.menu-icon-danger .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-danger .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-danger);\n}\n\n.menu-bullet-danger .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-danger);\n}\n\n.menu-arrow-danger .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-danger);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-danger%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-danger%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-danger);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-danger%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-danger%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-dark .menu-item .menu-link {\n  color: var(--kt-dark);\n}\n.menu-dark .menu-item .menu-link .menu-title {\n  color: var(--kt-dark);\n}\n.menu-dark .menu-item .menu-link .menu-icon,\n.menu-dark .menu-item .menu-link .menu-icon .svg-icon,\n.menu-dark .menu-item .menu-link .menu-icon i {\n  color: var(--kt-dark);\n}\n.menu-dark .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-dark);\n}\n.menu-dark .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-dark .menu-item .menu-link {\n  color: var(--kt-text-dark);\n}\n.menu-title-dark .menu-item .menu-link .menu-title {\n  color: var(--kt-text-dark);\n}\n\n.menu-icon-dark .menu-item .menu-link .menu-icon,\n.menu-icon-dark .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-dark .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-dark);\n}\n\n.menu-bullet-dark .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-dark);\n}\n\n.menu-arrow-dark .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-muted .menu-item .menu-link {\n  color: var(--kt-muted);\n}\n.menu-muted .menu-item .menu-link .menu-title {\n  color: var(--kt-muted);\n}\n.menu-muted .menu-item .menu-link .menu-icon,\n.menu-muted .menu-item .menu-link .menu-icon .svg-icon,\n.menu-muted .menu-item .menu-link .menu-icon i {\n  color: var(--kt-muted);\n}\n.menu-muted .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-muted);\n}\n.menu-muted .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-muted .menu-item .menu-link {\n  color: var(--kt-text-muted);\n}\n.menu-title-muted .menu-item .menu-link .menu-title {\n  color: var(--kt-text-muted);\n}\n\n.menu-icon-muted .menu-item .menu-link .menu-icon,\n.menu-icon-muted .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-muted .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-muted);\n}\n\n.menu-bullet-muted .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-muted);\n}\n\n.menu-arrow-muted .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-muted%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-muted%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-100 .menu-item .menu-link {\n  color: var(--kt-gray-100);\n}\n.menu-gray-100 .menu-item .menu-link .menu-title {\n  color: var(--kt-gray-100);\n}\n.menu-gray-100 .menu-item .menu-link .menu-icon,\n.menu-gray-100 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-100 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-gray-100);\n}\n.menu-gray-100 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-gray-100);\n}\n.menu-gray-100 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-100);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-100%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-100%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-100);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-100%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-100%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-100 .menu-item .menu-link {\n  color: var(--kt-text-gray-100);\n}\n.menu-title-gray-100 .menu-item .menu-link .menu-title {\n  color: var(--kt-text-gray-100);\n}\n\n.menu-icon-gray-100 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-100 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-100 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-gray-100);\n}\n\n.menu-bullet-gray-100 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-gray-100);\n}\n\n.menu-arrow-gray-100 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-100);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-100%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-100%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-100);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-100%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-100%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-200 .menu-item .menu-link {\n  color: var(--kt-gray-200);\n}\n.menu-gray-200 .menu-item .menu-link .menu-title {\n  color: var(--kt-gray-200);\n}\n.menu-gray-200 .menu-item .menu-link .menu-icon,\n.menu-gray-200 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-200 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-gray-200);\n}\n.menu-gray-200 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-gray-200);\n}\n.menu-gray-200 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-200);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-200%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-200%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-200);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-200%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-200%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-200 .menu-item .menu-link {\n  color: var(--kt-text-gray-200);\n}\n.menu-title-gray-200 .menu-item .menu-link .menu-title {\n  color: var(--kt-text-gray-200);\n}\n\n.menu-icon-gray-200 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-200 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-200 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-gray-200);\n}\n\n.menu-bullet-gray-200 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-gray-200);\n}\n\n.menu-arrow-gray-200 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-200);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-200%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-200%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-200);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-200%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-200%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-300 .menu-item .menu-link {\n  color: var(--kt-gray-300);\n}\n.menu-gray-300 .menu-item .menu-link .menu-title {\n  color: var(--kt-gray-300);\n}\n.menu-gray-300 .menu-item .menu-link .menu-icon,\n.menu-gray-300 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-300 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-gray-300);\n}\n.menu-gray-300 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-gray-300);\n}\n.menu-gray-300 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-300);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-300%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-300%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-300);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-300%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-300%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-300 .menu-item .menu-link {\n  color: var(--kt-text-gray-300);\n}\n.menu-title-gray-300 .menu-item .menu-link .menu-title {\n  color: var(--kt-text-gray-300);\n}\n\n.menu-icon-gray-300 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-300 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-300 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-gray-300);\n}\n\n.menu-bullet-gray-300 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-gray-300);\n}\n\n.menu-arrow-gray-300 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-300);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-300%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-300%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-300);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-300%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-300%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-400 .menu-item .menu-link {\n  color: var(--kt-gray-400);\n}\n.menu-gray-400 .menu-item .menu-link .menu-title {\n  color: var(--kt-gray-400);\n}\n.menu-gray-400 .menu-item .menu-link .menu-icon,\n.menu-gray-400 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-400 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-gray-400);\n}\n.menu-gray-400 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-gray-400);\n}\n.menu-gray-400 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-400);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-400%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-400%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-400);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-400%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-400%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-400 .menu-item .menu-link {\n  color: var(--kt-text-gray-400);\n}\n.menu-title-gray-400 .menu-item .menu-link .menu-title {\n  color: var(--kt-text-gray-400);\n}\n\n.menu-icon-gray-400 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-400 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-400 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-gray-400);\n}\n\n.menu-bullet-gray-400 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-gray-400);\n}\n\n.menu-arrow-gray-400 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-400);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-400%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-400%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-400);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-400%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-400%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-500 .menu-item .menu-link {\n  color: var(--kt-gray-500);\n}\n.menu-gray-500 .menu-item .menu-link .menu-title {\n  color: var(--kt-gray-500);\n}\n.menu-gray-500 .menu-item .menu-link .menu-icon,\n.menu-gray-500 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-500 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-gray-500);\n}\n.menu-gray-500 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-gray-500);\n}\n.menu-gray-500 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-500 .menu-item .menu-link {\n  color: var(--kt-text-gray-500);\n}\n.menu-title-gray-500 .menu-item .menu-link .menu-title {\n  color: var(--kt-text-gray-500);\n}\n\n.menu-icon-gray-500 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-500 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-500 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-gray-500);\n}\n\n.menu-bullet-gray-500 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-gray-500);\n}\n\n.menu-arrow-gray-500 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-600 .menu-item .menu-link {\n  color: var(--kt-gray-600);\n}\n.menu-gray-600 .menu-item .menu-link .menu-title {\n  color: var(--kt-gray-600);\n}\n.menu-gray-600 .menu-item .menu-link .menu-icon,\n.menu-gray-600 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-600 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-gray-600);\n}\n.menu-gray-600 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-gray-600);\n}\n.menu-gray-600 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-600);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-600%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-600%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-600);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-600%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-600%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-600 .menu-item .menu-link {\n  color: var(--kt-text-gray-600);\n}\n.menu-title-gray-600 .menu-item .menu-link .menu-title {\n  color: var(--kt-text-gray-600);\n}\n\n.menu-icon-gray-600 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-600 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-600 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-gray-600);\n}\n\n.menu-bullet-gray-600 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-gray-600);\n}\n\n.menu-arrow-gray-600 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-600);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-600%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-600%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-600);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-600%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-600%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-700 .menu-item .menu-link {\n  color: var(--kt-gray-700);\n}\n.menu-gray-700 .menu-item .menu-link .menu-title {\n  color: var(--kt-gray-700);\n}\n.menu-gray-700 .menu-item .menu-link .menu-icon,\n.menu-gray-700 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-700 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-gray-700);\n}\n.menu-gray-700 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-gray-700);\n}\n.menu-gray-700 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-700 .menu-item .menu-link {\n  color: var(--kt-text-gray-700);\n}\n.menu-title-gray-700 .menu-item .menu-link .menu-title {\n  color: var(--kt-text-gray-700);\n}\n\n.menu-icon-gray-700 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-700 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-700 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-gray-700);\n}\n\n.menu-bullet-gray-700 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-gray-700);\n}\n\n.menu-arrow-gray-700 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-800 .menu-item .menu-link {\n  color: var(--kt-gray-800);\n}\n.menu-gray-800 .menu-item .menu-link .menu-title {\n  color: var(--kt-gray-800);\n}\n.menu-gray-800 .menu-item .menu-link .menu-icon,\n.menu-gray-800 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-800 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-gray-800);\n}\n.menu-gray-800 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-gray-800);\n}\n.menu-gray-800 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-800);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-800%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-800%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-800);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-800%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-800%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-800 .menu-item .menu-link {\n  color: var(--kt-text-gray-800);\n}\n.menu-title-gray-800 .menu-item .menu-link .menu-title {\n  color: var(--kt-text-gray-800);\n}\n\n.menu-icon-gray-800 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-800 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-800 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-gray-800);\n}\n\n.menu-bullet-gray-800 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-gray-800);\n}\n\n.menu-arrow-gray-800 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-800);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-800%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-800%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-800);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-800%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-800%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-gray-900 .menu-item .menu-link {\n  color: var(--kt-gray-900);\n}\n.menu-gray-900 .menu-item .menu-link .menu-title {\n  color: var(--kt-gray-900);\n}\n.menu-gray-900 .menu-item .menu-link .menu-icon,\n.menu-gray-900 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-gray-900 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-gray-900);\n}\n.menu-gray-900 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-gray-900);\n}\n.menu-gray-900 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-title-gray-900 .menu-item .menu-link {\n  color: var(--kt-text-gray-900);\n}\n.menu-title-gray-900 .menu-item .menu-link .menu-title {\n  color: var(--kt-text-gray-900);\n}\n\n.menu-icon-gray-900 .menu-item .menu-link .menu-icon,\n.menu-icon-gray-900 .menu-item .menu-link .menu-icon .svg-icon,\n.menu-icon-gray-900 .menu-item .menu-link .menu-icon i {\n  color: var(--kt-text-gray-900);\n}\n\n.menu-bullet-gray-900 .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-text-gray-900);\n}\n\n.menu-arrow-gray-900 .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-900%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-gray-900);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-gray-900%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--kt-menu-link-bg-color-hover);\n  color: var(--kt-menu-link-color-hover);\n}\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-menu-link-color-hover);\n}\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-menu-link-color-hover);\n}\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-menu-link-color-hover);\n}\n.menu-hover-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-bg .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-menu-link-bg-color-here);\n  color: var(--kt-menu-link-color-here);\n}\n.menu-here-bg .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-menu-link-color-here);\n}\n.menu-here-bg .menu-item.here > .menu-link .menu-icon,\n.menu-here-bg .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-bg .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-menu-link-color-here);\n}\n.menu-here-bg .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-menu-link-color-here);\n}\n.menu-here-bg .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-root-here-bg > .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-menu-link-bg-color-here);\n  color: var(--kt-menu-link-color-here);\n}\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-menu-link-color-here);\n}\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon,\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-menu-link-color-here);\n}\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-menu-link-color-here);\n}\n.menu-root-here-bg > .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n@media (min-width: 992px) {\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link {\n    transition: color 0.2s ease;\n    background-color: var(--kt-menu-link-bg-color-here);\n    color: var(--kt-menu-link-color-here);\n  }\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-title {\n    color: var(--kt-menu-link-color-here);\n  }\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon,\n.menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-icon i {\n    color: var(--kt-menu-link-color-here);\n  }\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-bullet .bullet {\n    background-color: var(--kt-menu-link-color-here);\n  }\n  .menu-root-here-bg-desktop > .menu-item.here > .menu-link .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-menu-link-color-here);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-menu-link-color-here);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n}\n.menu-show-bg .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-menu-link-bg-color-show);\n  color: var(--kt-menu-link-color-show);\n}\n.menu-show-bg .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-menu-link-color-show);\n}\n.menu-show-bg .menu-item.show > .menu-link .menu-icon,\n.menu-show-bg .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-bg .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-menu-link-color-show);\n}\n.menu-show-bg .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-menu-link-color-show);\n}\n.menu-show-bg .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-bg .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--kt-menu-link-bg-color-active);\n  color: var(--kt-menu-link-color-active);\n}\n.menu-active-bg .menu-item .menu-link.active .menu-title {\n  color: var(--kt-menu-link-color-active);\n}\n.menu-active-bg .menu-item .menu-link.active .menu-icon,\n.menu-active-bg .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-bg .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-menu-link-color-active);\n}\n.menu-active-bg .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-menu-link-color-active);\n}\n.menu-active-bg .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--kt-menu-link-bg-color-hover);\n  color: var(--kt-menu-link-color-hover);\n}\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-menu-link-color-hover);\n}\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-menu-link-color-hover);\n}\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-menu-link-color-hover);\n}\n.menu-state-bg .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-menu-link-bg-color-here);\n  color: var(--kt-menu-link-color-here);\n}\n.menu-state-bg .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-menu-link-color-here);\n}\n.menu-state-bg .menu-item.here > .menu-link .menu-icon,\n.menu-state-bg .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-bg .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-menu-link-color-here);\n}\n.menu-state-bg .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-menu-link-color-here);\n}\n.menu-state-bg .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-menu-link-bg-color-show);\n  color: var(--kt-menu-link-color-show);\n}\n.menu-state-bg .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-menu-link-color-show);\n}\n.menu-state-bg .menu-item.show > .menu-link .menu-icon,\n.menu-state-bg .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-bg .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-menu-link-color-show);\n}\n.menu-state-bg .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-menu-link-color-show);\n}\n.menu-state-bg .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--kt-menu-link-bg-color-active);\n  color: var(--kt-menu-link-color-active);\n}\n.menu-state-bg .menu-item .menu-link.active .menu-title {\n  color: var(--kt-menu-link-color-active);\n}\n.menu-state-bg .menu-item .menu-link.active .menu-icon,\n.menu-state-bg .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-bg .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-menu-link-color-active);\n}\n.menu-state-bg .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-menu-link-color-active);\n}\n.menu-state-bg .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--kt-menu-link-color-hover);\n}\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-menu-link-color-hover);\n}\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-menu-link-color-hover);\n}\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-menu-link-color-hover);\n}\n.menu-state-color .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-color .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-hover%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-hover);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-hover%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-color .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-menu-link-color-here);\n}\n.menu-state-color .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-menu-link-color-here);\n}\n.menu-state-color .menu-item.here > .menu-link .menu-icon,\n.menu-state-color .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-color .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-menu-link-color-here);\n}\n.menu-state-color .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-menu-link-color-here);\n}\n.menu-state-color .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-here);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-here%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-color .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-menu-link-color-show);\n}\n.menu-state-color .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-menu-link-color-show);\n}\n.menu-state-color .menu-item.show > .menu-link .menu-icon,\n.menu-state-color .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-color .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-menu-link-color-show);\n}\n.menu-state-color .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-menu-link-color-show);\n}\n.menu-state-color .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-show%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-show);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-show%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-color .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--kt-menu-link-color-active);\n}\n.menu-state-color .menu-item .menu-link.active .menu-title {\n  color: var(--kt-menu-link-color-active);\n}\n.menu-state-color .menu-item .menu-link.active .menu-icon,\n.menu-state-color .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-color .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-menu-link-color-active);\n}\n.menu-state-color .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-menu-link-color-active);\n}\n.menu-state-color .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-active%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-menu-link-color-active);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-menu-link-color-active%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary);\n  color: var(--kt-primary-inverse);\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-primary-inverse);\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-primary-inverse);\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-primary-inverse);\n}\n.menu-hover-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-bg-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary);\n  color: var(--kt-primary-inverse);\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-primary-inverse);\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon,\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-primary-inverse);\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary-inverse);\n}\n.menu-show-bg-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-bg-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary);\n  color: var(--kt-primary-inverse);\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-primary-inverse);\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon,\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-primary-inverse);\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary-inverse);\n}\n.menu-here-bg-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-bg-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary);\n  color: var(--kt-primary-inverse);\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-title {\n  color: var(--kt-primary-inverse);\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-icon,\n.menu-active-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-bg-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-primary-inverse);\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-primary-inverse);\n}\n.menu-active-bg-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary);\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary);\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary);\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon,\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary);\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-title {\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-icon,\n.menu-state-bg-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary);\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary-inverse);\n}\n.menu-state-bg-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-bg-light-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary-light);\n  color: var(--kt-primary);\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon,\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-show-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-bg-light-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary-light);\n  color: var(--kt-primary);\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon,\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-here-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary-light);\n  color: var(--kt-primary);\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-primary);\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-hover-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-bg-light-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary-light);\n  color: var(--kt-primary);\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-title {\n  color: var(--kt-primary);\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon,\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-active-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-bg-light-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary-light);\n  color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary-light);\n  color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon,\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary-light);\n  color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-bg-light-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--kt-primary-light);\n  color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-title {\n  color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon,\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-state-bg-light-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-primary);\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-hover-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-icon,\n.menu-show-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-show-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-icon,\n.menu-here-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-here-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-active-primary .menu-item .menu-link.active .menu-title {\n  color: var(--kt-primary);\n}\n.menu-active-primary .menu-item .menu-link.active .menu-icon,\n.menu-active-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-active-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-active-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-primary);\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-state-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-state-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-icon,\n.menu-state-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-state-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-state-primary .menu-item .menu-link.active .menu-title {\n  color: var(--kt-primary);\n}\n.menu-state-primary .menu-item .menu-link.active .menu-icon,\n.menu-state-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-state-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-state-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--kt-dark);\n}\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-dark);\n}\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-dark);\n}\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-dark);\n}\n.menu-state-dark .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-dark .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-dark .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-dark);\n}\n.menu-state-dark .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-dark);\n}\n.menu-state-dark .menu-item.show > .menu-link .menu-icon,\n.menu-state-dark .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-dark .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-dark);\n}\n.menu-state-dark .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-dark);\n}\n.menu-state-dark .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-dark .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-dark);\n}\n.menu-state-dark .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-dark);\n}\n.menu-state-dark .menu-item.here > .menu-link .menu-icon,\n.menu-state-dark .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-dark .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-dark);\n}\n.menu-state-dark .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-dark);\n}\n.menu-state-dark .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-dark .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--kt-dark);\n}\n.menu-state-dark .menu-item .menu-link.active .menu-title {\n  color: var(--kt-dark);\n}\n.menu-state-dark .menu-item .menu-link.active .menu-icon,\n.menu-state-dark .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-dark .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-dark);\n}\n.menu-state-dark .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-dark);\n}\n.menu-state-dark .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-dark);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-dark%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-hover-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-hover-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-primary);\n}\n\n.menu-here-title-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-here-title-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n\n.menu-show-title-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-show-title-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n\n.menu-active-title-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-active-title-primary .menu-item .menu-link.active .menu-title {\n  color: var(--kt-primary);\n}\n\n.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-state-title-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .menu-state-title-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-primary);\n}\n.menu-state-title-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-state-title-primary .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n.menu-state-title-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-state-title-primary .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n.menu-state-title-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.menu-state-title-primary .menu-item .menu-link.active .menu-title {\n  color: var(--kt-primary);\n}\n\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-hover-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-primary);\n}\n\n.menu-here-icon-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon,\n.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-here-icon-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n\n.menu-show-icon-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon,\n.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-show-icon-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n\n.menu-active-icon-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-active-icon-primary .menu-item .menu-link.active .menu-icon,\n.menu-active-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-active-icon-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-primary);\n}\n\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-state-icon-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon,\n.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-state-icon-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon,\n.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n.menu-state-icon-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-state-icon-primary .menu-item .menu-link.active .menu-icon,\n.menu-state-icon-primary .menu-item .menu-link.active .menu-icon .svg-icon,\n.menu-state-icon-primary .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-primary);\n}\n\n.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-hover-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-hover-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n\n.menu-show-bullet-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-show-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n\n.menu-here-bullet-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-here-bullet-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n\n.menu-active-bullet-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-active-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n\n.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .menu-state-bullet-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-state-bullet-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-state-bullet-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.menu-state-bullet-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-state-bullet-primary .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n\n.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-hover-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-hover-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-here-arrow-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-here-arrow-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-show-arrow-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-show-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-active-arrow-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-active-arrow-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .menu-state-arrow-primary .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-arrow-primary .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-arrow-primary .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.menu-state-arrow-primary .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n}\n.menu-state-arrow-primary .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n.anchor {\n  display: flex;\n  align-items: center;\n}\n.anchor a {\n  position: relative;\n  display: none;\n  align-items: center;\n  justify-content: flex-start;\n  height: 1em;\n  width: 1.25em;\n  margin-left: -1.25em;\n  font-weight: 500;\n  font-size: 0.8em;\n  color: var(--kt-text-muted);\n  transition: all 0.2s ease-in-out;\n}\n.anchor a:before {\n  content: \"#\";\n}\n.anchor:hover a {\n  display: flex;\n}\n.anchor:hover a:hover {\n  color: var(--kt-primary);\n  transition: all 0.2s ease-in-out;\n}\n\n.card {\n  border: 0;\n  box-shadow: var(--kt-card-box-shadow);\n  background-color: var(--kt-card-bg);\n}\n.card .card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  flex-wrap: wrap;\n  min-height: 70px;\n  padding: 0 2.25rem;\n  color: var(--kt-card-cap-color);\n  background-color: var(--kt-card-cap-bg);\n  border-bottom: 1px solid var(--kt-card-border-color);\n}\n.card .card-header .card-title {\n  display: flex;\n  align-items: center;\n  margin: 0.5rem;\n  margin-left: 0;\n}\n.card .card-header .card-title.flex-column {\n  align-items: flex-start;\n  justify-content: center;\n}\n.card .card-header .card-title .card-icon {\n  margin-right: 0.75rem;\n  line-height: 0;\n}\n.card .card-header .card-title .card-icon i {\n  font-size: 1.25rem;\n  color: var(--kt-gray-600);\n  line-height: 0;\n}\n.card .card-header .card-title .card-icon i:after, .card .card-header .card-title .card-icon i:before {\n  line-height: 0;\n}\n.card .card-header .card-title .card-icon .svg-icon {\n  color: var(--kt-gray-600);\n}\n.card .card-header .card-title .card-icon .svg-icon svg {\n  height: 24px;\n  width: 24px;\n}\n.card .card-header .card-title,\n.card .card-header .card-title .card-label {\n  font-weight: 500;\n  font-size: 1.275rem;\n  color: var(--kt-text-dark);\n}\n.card .card-header .card-title .card-label {\n  margin: 0 0.75rem 0 0;\n  flex-wrap: wrap;\n}\n.card .card-header .card-title small, .card .card-header .card-title .small {\n  color: var(--kt-text-muted);\n  font-size: 1rem;\n}\n.card .card-header .card-title h1, .card .card-header .card-title .h1, .card .card-header .card-title h2, .card .card-header .card-title .h2, .card .card-header .card-title h3, .card .card-header .card-title .h3, .card .card-header .card-title h4, .card .card-header .card-title .h4, .card .card-header .card-title h5, .card .card-header .card-title .h5, .card .card-header .card-title h6, .card .card-header .card-title .h6 {\n  margin-bottom: 0;\n}\n.card .card-header .card-toolbar {\n  display: flex;\n  align-items: center;\n  margin: 0.5rem 0;\n  flex-wrap: wrap;\n}\n.card .card-body {\n  padding: 2rem 2.25rem;\n  color: var(--kt-card-color);\n}\n.card .card-footer {\n  padding: 2rem 2.25rem;\n  color: var(--kt-card-cap-color);\n  background-color: var(--kt-card-cap-bg);\n  border-top: 1px solid var(--kt-card-border-color);\n}\n.card .card-scroll {\n  position: relative;\n  overflow: auto;\n}\n.card.card-px-0 .card-header,\n.card.card-px-0 .card-body,\n.card.card-px-0 .card-footer {\n  padding-left: 0;\n  padding-right: 0;\n}\n.card.card-py-0 .card-header,\n.card.card-py-0 .card-body,\n.card.card-py-0 .card-footer {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.card.card-p-0 .card-header,\n.card.card-p-0 .card-body,\n.card.card-p-0 .card-footer {\n  padding: 0;\n}\n.card.card-dashed {\n  box-shadow: none;\n  border: 1px dashed var(--kt-card-border-dashed-color);\n}\n.card.card-dashed > .card-header {\n  border-bottom: 1px dashed var(--kt-card-border-dashed-color);\n}\n.card.card-dashed > .card-footer {\n  border-top: 1px dashed var(--kt-card-border-dashed-color);\n}\n.card.card-bordered {\n  box-shadow: none;\n  border: 1px solid var(--kt-card-border-color);\n}\n.card.card-flush > .card-header {\n  border-bottom: 0 !important;\n}\n.card.card-flush > .card-footer {\n  border-top: 0 !important;\n}\n.card.card-shadow {\n  box-shadow: var(--kt-card-box-shadow);\n  border: 0;\n}\n.card.card-reset {\n  border: 0 !important;\n  box-shadow: none !important;\n  background-color: transparent !important;\n}\n.card.card-reset > .card-header {\n  border-bottom: 0 !important;\n}\n.card.card-reset > .card-footer {\n  border-top: 0 !important;\n}\n\n.card.card-stretch {\n  height: calc(100% - var(--bs-gutter-y));\n}\n.card.card-stretch-75 {\n  height: calc(75% - var(--bs-gutter-y));\n}\n.card.card-stretch-50 {\n  height: calc(50% - var(--bs-gutter-y));\n}\n.card.card-stretch-33 {\n  height: calc(33.333% - var(--bs-gutter-y));\n}\n.card.card-stretch-25 {\n  height: calc(25% - var(--bs-gutter-y));\n}\n.card .card-header-stretch {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  align-items: stretch;\n}\n.card .card-header-stretch .card-toolbar {\n  margin: 0;\n  align-items: stretch;\n}\n@media (min-width: 576px) {\n  .card.card-sm-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-sm-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-sm-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-sm-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 768px) {\n  .card.card-md-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-md-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-md-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-md-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 992px) {\n  .card.card-lg-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-lg-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-lg-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-lg-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 1200px) {\n  .card.card-xl-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-xl-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-xl-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-xl-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n@media (min-width: 1400px) {\n  .card.card-xxl-stretch {\n    height: calc(100% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-75 {\n    height: calc(75% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-50 {\n    height: calc(50% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-33 {\n    height: calc(33.333% - var(--bs-gutter-y));\n  }\n  .card.card-xxl-stretch-25 {\n    height: calc(25% - var(--bs-gutter-y));\n  }\n  .card .card-header-xxl-stretch {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n    align-items: stretch;\n  }\n  .card .card-header-xxl-stretch .card-toolbar {\n    margin: 0;\n    align-items: stretch;\n  }\n}\n\n.card-p {\n  padding: 2rem 2.25rem !important;\n}\n\n.card-px {\n  padding-left: 2.25rem !important;\n  padding-right: 2.25rem !important;\n}\n\n.card-shadow {\n  box-shadow: var(--kt-card-box-shadow);\n}\n\n.card-py {\n  padding-top: 2rem !important;\n  padding-bottom: 2rem !important;\n}\n\n.card-rounded {\n  border-radius: 0.625rem;\n}\n\n.card-rounded-start {\n  border-top-left-radius: 0.625rem;\n  border-bottom-left-radius: 0.625rem;\n}\n\n.card-rounded-end {\n  border-top-right-radius: 0.625rem;\n  border-bottom-right-radius: 0.625rem;\n}\n\n.card-rounded-top {\n  border-top-left-radius: 0.625rem;\n  border-top-right-radius: 0.625rem;\n}\n\n.card-rounded-bottom {\n  border-bottom-left-radius: 0.625rem;\n  border-bottom-right-radius: 0.625rem;\n}\n\n@media (max-width: 767.98px) {\n  .card > .card-header:not(.flex-nowrap) {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n}\n.breadcrumb {\n  --bs-breadcrumb-bg: var(--kt-breadcrumb-bg);\n  --bs-breadcrumb-divider-color: var(--kt-breadcrumb-divider-color);\n  --bs-breadcrumb-item-active-color: var(--kt-breadcrumb-item-active-color);\n  display: flex;\n  align-items: center;\n  background-color: transparent;\n  padding: 0;\n  margin: 0;\n}\n.breadcrumb .breadcrumb-item {\n  display: flex;\n  align-items: center;\n  padding-left: 0;\n  padding-right: 0.5rem;\n}\n.breadcrumb .breadcrumb-item:last-child {\n  padding-right: 0;\n}\n.breadcrumb .breadcrumb-item:after {\n  content: \"/\";\n}\n.breadcrumb .breadcrumb-item:before {\n  display: none;\n}\n.breadcrumb .breadcrumb-item:last-child:after {\n  display: none;\n}\n\n.breadcrumb-line .breadcrumb-item:after {\n  content: \"-\";\n}\n\n.breadcrumb-dot .breadcrumb-item:after {\n  content: \"•\";\n}\n\n.breadcrumb-separatorless .breadcrumb-item:after {\n  display: none;\n}\n\n.btn {\n  --bs-btn-color: var(--kt-body-color);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: transparent;\n  outline: none !important;\n}\n.btn:not(.btn-shadow):not(.shadow):not(.shadow-sm):not(.shadow-lg):not(.shadow-xs) {\n  box-shadow: none !important;\n}\n.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {\n  border: 0;\n  padding: calc(0.775rem + 1px) calc(1.5rem + 1px);\n}\n.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon).btn-lg, .btn-group-lg > .btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {\n  padding: calc(0.825rem + 1px) calc(1.75rem + 1px);\n}\n.btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon).btn-sm, .btn-group-sm > .btn:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {\n  padding: calc(0.55rem + 1px) calc(1.25rem + 1px);\n}\n.btn.btn-link {\n  border: 0;\n  border-radius: 0;\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n  text-decoration: none;\n  font-weight: 500;\n}\n.btn.btn-outline:not(.btn-outline-dashed) {\n  border: 1px solid var(--kt-input-border-color);\n}\n.btn.btn-outline-dashed {\n  border: 1px dashed var(--kt-input-border-color);\n}\n.btn.btn-flush {\n  appearance: none;\n  box-shadow: none;\n  border-radius: 0;\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n  outline: none !important;\n  margin: 0;\n  padding: 0;\n}\n.btn.btn-flex {\n  display: inline-flex;\n  align-items: center;\n}\n.btn.btn-trim-start {\n  justify-content: flex-start !important;\n  padding-left: 0 !important;\n}\n.btn.btn-trim-end {\n  justify-content: flex-end !important;\n  padding-right: 0 !important;\n}\n\n.btn i {\n  display: inline-flex;\n  font-size: 1rem;\n  padding-right: 0.35rem;\n  vertical-align: middle;\n  line-height: 0;\n}\n.btn .svg-icon {\n  flex-shrink: 0;\n  line-height: 0;\n  margin-right: 0.5rem;\n}\n.btn.btn-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  height: calc(1.5em + 1.55rem + 2px);\n  width: calc(1.5em + 1.55rem + 2px);\n}\n.btn.btn-icon:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush) {\n  border: 0;\n}\n.btn.btn-icon.btn-sm, .btn-group-sm > .btn.btn-icon {\n  height: calc(1.5em + 1.1rem + 2px);\n  width: calc(1.5em + 1.1rem + 2px);\n}\n.btn.btn-icon.btn-lg, .btn-group-lg > .btn.btn-icon {\n  height: calc(1.5em + 1.65rem + 2px);\n  width: calc(1.5em + 1.65rem + 2px);\n}\n.btn.btn-icon.btn-circle {\n  border-radius: 50%;\n}\n.btn.btn-icon i,\n.btn.btn-icon .svg-icon {\n  padding: 0;\n  margin: 0;\n  line-height: 1;\n}\n\n.btn.btn-outline.btn-outline-dashed {\n  border-width: 1px;\n  border-style: dashed;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dashed, .btn-check:active + .btn.btn-outline.btn-outline-dashed, .btn.btn-outline.btn-outline-dashed:focus:not(.btn-active), .btn.btn-outline.btn-outline-dashed:hover:not(.btn-active), .btn.btn-outline.btn-outline-dashed:active:not(.btn-active), .btn.btn-outline.btn-outline-dashed.active, .btn.btn-outline.btn-outline-dashed.show, .show > .btn.btn-outline.btn-outline-dashed {\n  border-color: var(--kt-primary);\n}\n\n.btn.btn-white {\n  color: var(--kt-white-inverse);\n  border-color: var(--kt-white);\n  background-color: var(--kt-white);\n}\n.btn.btn-white i,\n.btn.btn-white .svg-icon {\n  color: var(--kt-white-inverse);\n}\n.btn.btn-white.dropdown-toggle:after {\n  color: var(--kt-white-inverse);\n}\n.btn-check:checked + .btn.btn-white, .btn-check:active + .btn.btn-white, .btn.btn-white:focus:not(.btn-active), .btn.btn-white:hover:not(.btn-active), .btn.btn-white:active:not(.btn-active), .btn.btn-white.active, .btn.btn-white.show, .show > .btn.btn-white {\n  color: var(--kt-white-inverse);\n  border-color: var(--kt-white-active);\n  background-color: var(--kt-white-active) !important;\n}\n.btn-check:checked + .btn.btn-white i,\n.btn-check:checked + .btn.btn-white .svg-icon, .btn-check:active + .btn.btn-white i,\n.btn-check:active + .btn.btn-white .svg-icon, .btn.btn-white:focus:not(.btn-active) i,\n.btn.btn-white:focus:not(.btn-active) .svg-icon, .btn.btn-white:hover:not(.btn-active) i,\n.btn.btn-white:hover:not(.btn-active) .svg-icon, .btn.btn-white:active:not(.btn-active) i,\n.btn.btn-white:active:not(.btn-active) .svg-icon, .btn.btn-white.active i,\n.btn.btn-white.active .svg-icon, .btn.btn-white.show i,\n.btn.btn-white.show .svg-icon, .show > .btn.btn-white i,\n.show > .btn.btn-white .svg-icon {\n  color: var(--kt-white-inverse);\n}\n.btn-check:checked + .btn.btn-white.dropdown-toggle:after, .btn-check:active + .btn.btn-white.dropdown-toggle:after, .btn.btn-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-white.active.dropdown-toggle:after, .btn.btn-white.show.dropdown-toggle:after, .show > .btn.btn-white.dropdown-toggle:after {\n  color: var(--kt-white-inverse);\n}\n\n.btn.btn-bg-white {\n  border-color: var(--kt-white);\n  background-color: var(--kt-white);\n}\n.btn-check:checked + .btn.btn-active-white, .btn-check:active + .btn.btn-active-white, .btn.btn-active-white:focus:not(.btn-active), .btn.btn-active-white:hover:not(.btn-active), .btn.btn-active-white:active:not(.btn-active), .btn.btn-active-white.active, .btn.btn-active-white.show, .show > .btn.btn-active-white {\n  color: var(--kt-white-inverse);\n  border-color: var(--kt-white);\n  background-color: var(--kt-white) !important;\n}\n.btn-check:checked + .btn.btn-active-white i,\n.btn-check:checked + .btn.btn-active-white .svg-icon, .btn-check:active + .btn.btn-active-white i,\n.btn-check:active + .btn.btn-active-white .svg-icon, .btn.btn-active-white:focus:not(.btn-active) i,\n.btn.btn-active-white:focus:not(.btn-active) .svg-icon, .btn.btn-active-white:hover:not(.btn-active) i,\n.btn.btn-active-white:hover:not(.btn-active) .svg-icon, .btn.btn-active-white:active:not(.btn-active) i,\n.btn.btn-active-white:active:not(.btn-active) .svg-icon, .btn.btn-active-white.active i,\n.btn.btn-active-white.active .svg-icon, .btn.btn-active-white.show i,\n.btn.btn-active-white.show .svg-icon, .show > .btn.btn-active-white i,\n.show > .btn.btn-active-white .svg-icon {\n  color: var(--kt-white-inverse);\n}\n.btn-check:checked + .btn.btn-active-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-white.dropdown-toggle:after, .btn.btn-active-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-white.active.dropdown-toggle:after, .btn.btn-active-white.show.dropdown-toggle:after, .show > .btn.btn-active-white.dropdown-toggle:after {\n  color: var(--kt-white-inverse);\n}\n\n.btn.btn-outline.btn-outline-white {\n  color: var(--kt-white);\n  border-color: var(--kt-white);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-white i,\n.btn.btn-outline.btn-outline-white .svg-icon {\n  color: var(--kt-white);\n}\n.btn.btn-outline.btn-outline-white.dropdown-toggle:after {\n  color: var(--kt-white);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-white, .btn-check:active + .btn.btn-outline.btn-outline-white, .btn.btn-outline.btn-outline-white:focus:not(.btn-active), .btn.btn-outline.btn-outline-white:hover:not(.btn-active), .btn.btn-outline.btn-outline-white:active:not(.btn-active), .btn.btn-outline.btn-outline-white.active, .btn.btn-outline.btn-outline-white.show, .show > .btn.btn-outline.btn-outline-white {\n  color: var(--kt-white-active);\n  border-color: var(--kt-white);\n  background-color: var(--kt-white-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-white i,\n.btn-check:checked + .btn.btn-outline.btn-outline-white .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-white i,\n.btn-check:active + .btn.btn-outline.btn-outline-white .svg-icon, .btn.btn-outline.btn-outline-white:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-white:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-white:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-white:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-white:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-white:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-white.active i,\n.btn.btn-outline.btn-outline-white.active .svg-icon, .btn.btn-outline.btn-outline-white.show i,\n.btn.btn-outline.btn-outline-white.show .svg-icon, .show > .btn.btn-outline.btn-outline-white i,\n.show > .btn.btn-outline.btn-outline-white .svg-icon {\n  color: var(--kt-white-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-white.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-white.dropdown-toggle:after, .btn.btn-outline.btn-outline-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-white.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-white.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-white.dropdown-toggle:after {\n  color: var(--kt-white-active);\n}\n\n.btn.btn-light {\n  color: var(--kt-light-inverse);\n  border-color: var(--kt-light);\n  background-color: var(--kt-light);\n}\n.btn.btn-light i,\n.btn.btn-light .svg-icon {\n  color: var(--kt-light-inverse);\n}\n.btn.btn-light.dropdown-toggle:after {\n  color: var(--kt-light-inverse);\n}\n.btn-check:checked + .btn.btn-light, .btn-check:active + .btn.btn-light, .btn.btn-light:focus:not(.btn-active), .btn.btn-light:hover:not(.btn-active), .btn.btn-light:active:not(.btn-active), .btn.btn-light.active, .btn.btn-light.show, .show > .btn.btn-light {\n  color: var(--kt-light-inverse);\n  border-color: var(--kt-light-active);\n  background-color: var(--kt-light-active) !important;\n}\n.btn-check:checked + .btn.btn-light i,\n.btn-check:checked + .btn.btn-light .svg-icon, .btn-check:active + .btn.btn-light i,\n.btn-check:active + .btn.btn-light .svg-icon, .btn.btn-light:focus:not(.btn-active) i,\n.btn.btn-light:focus:not(.btn-active) .svg-icon, .btn.btn-light:hover:not(.btn-active) i,\n.btn.btn-light:hover:not(.btn-active) .svg-icon, .btn.btn-light:active:not(.btn-active) i,\n.btn.btn-light:active:not(.btn-active) .svg-icon, .btn.btn-light.active i,\n.btn.btn-light.active .svg-icon, .btn.btn-light.show i,\n.btn.btn-light.show .svg-icon, .show > .btn.btn-light i,\n.show > .btn.btn-light .svg-icon {\n  color: var(--kt-light-inverse);\n}\n.btn-check:checked + .btn.btn-light.dropdown-toggle:after, .btn-check:active + .btn.btn-light.dropdown-toggle:after, .btn.btn-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light.active.dropdown-toggle:after, .btn.btn-light.show.dropdown-toggle:after, .show > .btn.btn-light.dropdown-toggle:after {\n  color: var(--kt-light-inverse);\n}\n\n.btn.btn-bg-light {\n  border-color: var(--kt-light);\n  background-color: var(--kt-light);\n}\n.btn-check:checked + .btn.btn-active-light, .btn-check:active + .btn.btn-active-light, .btn.btn-active-light:focus:not(.btn-active), .btn.btn-active-light:hover:not(.btn-active), .btn.btn-active-light:active:not(.btn-active), .btn.btn-active-light.active, .btn.btn-active-light.show, .show > .btn.btn-active-light {\n  color: var(--kt-light-inverse);\n  border-color: var(--kt-light);\n  background-color: var(--kt-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light i,\n.btn-check:checked + .btn.btn-active-light .svg-icon, .btn-check:active + .btn.btn-active-light i,\n.btn-check:active + .btn.btn-active-light .svg-icon, .btn.btn-active-light:focus:not(.btn-active) i,\n.btn.btn-active-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-light:hover:not(.btn-active) i,\n.btn.btn-active-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-light:active:not(.btn-active) i,\n.btn.btn-active-light:active:not(.btn-active) .svg-icon, .btn.btn-active-light.active i,\n.btn.btn-active-light.active .svg-icon, .btn.btn-active-light.show i,\n.btn.btn-active-light.show .svg-icon, .show > .btn.btn-active-light i,\n.show > .btn.btn-active-light .svg-icon {\n  color: var(--kt-light-inverse);\n}\n.btn-check:checked + .btn.btn-active-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light.dropdown-toggle:after, .btn.btn-active-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light.active.dropdown-toggle:after, .btn.btn-active-light.show.dropdown-toggle:after, .show > .btn.btn-active-light.dropdown-toggle:after {\n  color: var(--kt-light-inverse);\n}\n\n.btn.btn-outline.btn-outline-light {\n  color: var(--kt-light);\n  border-color: var(--kt-light);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-light i,\n.btn.btn-outline.btn-outline-light .svg-icon {\n  color: var(--kt-light);\n}\n.btn.btn-outline.btn-outline-light.dropdown-toggle:after {\n  color: var(--kt-light);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-light, .btn-check:active + .btn.btn-outline.btn-outline-light, .btn.btn-outline.btn-outline-light:focus:not(.btn-active), .btn.btn-outline.btn-outline-light:hover:not(.btn-active), .btn.btn-outline.btn-outline-light:active:not(.btn-active), .btn.btn-outline.btn-outline-light.active, .btn.btn-outline.btn-outline-light.show, .show > .btn.btn-outline.btn-outline-light {\n  color: var(--kt-light-active);\n  border-color: var(--kt-light);\n  background-color: var(--kt-light-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-light i,\n.btn-check:checked + .btn.btn-outline.btn-outline-light .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-light i,\n.btn-check:active + .btn.btn-outline.btn-outline-light .svg-icon, .btn.btn-outline.btn-outline-light:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-light:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-light:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-light:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-light.active i,\n.btn.btn-outline.btn-outline-light.active .svg-icon, .btn.btn-outline.btn-outline-light.show i,\n.btn.btn-outline.btn-outline-light.show .svg-icon, .show > .btn.btn-outline.btn-outline-light i,\n.show > .btn.btn-outline.btn-outline-light .svg-icon {\n  color: var(--kt-light-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-light.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-light.dropdown-toggle:after, .btn.btn-outline.btn-outline-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-light.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-light.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-light.dropdown-toggle:after {\n  color: var(--kt-light-active);\n}\n\n.btn.btn-primary {\n  color: var(--kt-primary-inverse);\n  border-color: var(--kt-primary);\n  background-color: var(--kt-primary);\n}\n.btn.btn-primary i,\n.btn.btn-primary .svg-icon {\n  color: var(--kt-primary-inverse);\n}\n.btn.btn-primary.dropdown-toggle:after {\n  color: var(--kt-primary-inverse);\n}\n.btn-check:checked + .btn.btn-primary, .btn-check:active + .btn.btn-primary, .btn.btn-primary:focus:not(.btn-active), .btn.btn-primary:hover:not(.btn-active), .btn.btn-primary:active:not(.btn-active), .btn.btn-primary.active, .btn.btn-primary.show, .show > .btn.btn-primary {\n  color: var(--kt-primary-inverse);\n  border-color: var(--kt-primary-active);\n  background-color: var(--kt-primary-active) !important;\n}\n.btn-check:checked + .btn.btn-primary i,\n.btn-check:checked + .btn.btn-primary .svg-icon, .btn-check:active + .btn.btn-primary i,\n.btn-check:active + .btn.btn-primary .svg-icon, .btn.btn-primary:focus:not(.btn-active) i,\n.btn.btn-primary:focus:not(.btn-active) .svg-icon, .btn.btn-primary:hover:not(.btn-active) i,\n.btn.btn-primary:hover:not(.btn-active) .svg-icon, .btn.btn-primary:active:not(.btn-active) i,\n.btn.btn-primary:active:not(.btn-active) .svg-icon, .btn.btn-primary.active i,\n.btn.btn-primary.active .svg-icon, .btn.btn-primary.show i,\n.btn.btn-primary.show .svg-icon, .show > .btn.btn-primary i,\n.show > .btn.btn-primary .svg-icon {\n  color: var(--kt-primary-inverse);\n}\n.btn-check:checked + .btn.btn-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-primary.dropdown-toggle:after, .btn.btn-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-primary.active.dropdown-toggle:after, .btn.btn-primary.show.dropdown-toggle:after, .show > .btn.btn-primary.dropdown-toggle:after {\n  color: var(--kt-primary-inverse);\n}\n\n.btn.btn-light-primary {\n  color: var(--kt-primary);\n  border-color: var(--kt-primary-light);\n  background-color: var(--kt-primary-light);\n}\n.btn.btn-light-primary i,\n.btn.btn-light-primary .svg-icon {\n  color: var(--kt-primary);\n}\n.btn.btn-light-primary.dropdown-toggle:after {\n  color: var(--kt-primary);\n}\n.btn-check:checked + .btn.btn-light-primary, .btn-check:active + .btn.btn-light-primary, .btn.btn-light-primary:focus:not(.btn-active), .btn.btn-light-primary:hover:not(.btn-active), .btn.btn-light-primary:active:not(.btn-active), .btn.btn-light-primary.active, .btn.btn-light-primary.show, .show > .btn.btn-light-primary {\n  color: var(--kt-primary-inverse);\n  border-color: var(--kt-primary);\n  background-color: var(--kt-primary) !important;\n}\n.btn-check:checked + .btn.btn-light-primary i,\n.btn-check:checked + .btn.btn-light-primary .svg-icon, .btn-check:active + .btn.btn-light-primary i,\n.btn-check:active + .btn.btn-light-primary .svg-icon, .btn.btn-light-primary:focus:not(.btn-active) i,\n.btn.btn-light-primary:focus:not(.btn-active) .svg-icon, .btn.btn-light-primary:hover:not(.btn-active) i,\n.btn.btn-light-primary:hover:not(.btn-active) .svg-icon, .btn.btn-light-primary:active:not(.btn-active) i,\n.btn.btn-light-primary:active:not(.btn-active) .svg-icon, .btn.btn-light-primary.active i,\n.btn.btn-light-primary.active .svg-icon, .btn.btn-light-primary.show i,\n.btn.btn-light-primary.show .svg-icon, .show > .btn.btn-light-primary i,\n.show > .btn.btn-light-primary .svg-icon {\n  color: var(--kt-primary-inverse);\n}\n.btn-check:checked + .btn.btn-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-light-primary.dropdown-toggle:after, .btn.btn-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-primary.active.dropdown-toggle:after, .btn.btn-light-primary.show.dropdown-toggle:after, .show > .btn.btn-light-primary.dropdown-toggle:after {\n  color: var(--kt-primary-inverse);\n}\n\n.btn.btn-bg-primary {\n  border-color: var(--kt-primary);\n  background-color: var(--kt-primary);\n}\n.btn-check:checked + .btn.btn-active-primary, .btn-check:active + .btn.btn-active-primary, .btn.btn-active-primary:focus:not(.btn-active), .btn.btn-active-primary:hover:not(.btn-active), .btn.btn-active-primary:active:not(.btn-active), .btn.btn-active-primary.active, .btn.btn-active-primary.show, .show > .btn.btn-active-primary {\n  color: var(--kt-primary-inverse);\n  border-color: var(--kt-primary);\n  background-color: var(--kt-primary) !important;\n}\n.btn-check:checked + .btn.btn-active-primary i,\n.btn-check:checked + .btn.btn-active-primary .svg-icon, .btn-check:active + .btn.btn-active-primary i,\n.btn-check:active + .btn.btn-active-primary .svg-icon, .btn.btn-active-primary:focus:not(.btn-active) i,\n.btn.btn-active-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-primary:hover:not(.btn-active) i,\n.btn.btn-active-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-primary:active:not(.btn-active) i,\n.btn.btn-active-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-primary.active i,\n.btn.btn-active-primary.active .svg-icon, .btn.btn-active-primary.show i,\n.btn.btn-active-primary.show .svg-icon, .show > .btn.btn-active-primary i,\n.show > .btn.btn-active-primary .svg-icon {\n  color: var(--kt-primary-inverse);\n}\n.btn-check:checked + .btn.btn-active-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-primary.dropdown-toggle:after, .btn.btn-active-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-primary.active.dropdown-toggle:after, .btn.btn-active-primary.show.dropdown-toggle:after, .show > .btn.btn-active-primary.dropdown-toggle:after {\n  color: var(--kt-primary-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-primary, .btn-check:active + .btn.btn-active-light-primary, .btn.btn-active-light-primary:focus:not(.btn-active), .btn.btn-active-light-primary:hover:not(.btn-active), .btn.btn-active-light-primary:active:not(.btn-active), .btn.btn-active-light-primary.active, .btn.btn-active-light-primary.show, .show > .btn.btn-active-light-primary {\n  color: var(--kt-primary);\n  border-color: var(--kt-primary-light);\n  background-color: var(--kt-primary-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-primary i,\n.btn-check:checked + .btn.btn-active-light-primary .svg-icon, .btn-check:active + .btn.btn-active-light-primary i,\n.btn-check:active + .btn.btn-active-light-primary .svg-icon, .btn.btn-active-light-primary:focus:not(.btn-active) i,\n.btn.btn-active-light-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-primary:hover:not(.btn-active) i,\n.btn.btn-active-light-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-primary:active:not(.btn-active) i,\n.btn.btn-active-light-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-light-primary.active i,\n.btn.btn-active-light-primary.active .svg-icon, .btn.btn-active-light-primary.show i,\n.btn.btn-active-light-primary.show .svg-icon, .show > .btn.btn-active-light-primary i,\n.show > .btn.btn-active-light-primary .svg-icon {\n  color: var(--kt-primary);\n}\n.btn-check:checked + .btn.btn-active-light-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-primary.dropdown-toggle:after, .btn.btn-active-light-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-primary.active.dropdown-toggle:after, .btn.btn-active-light-primary.show.dropdown-toggle:after, .show > .btn.btn-active-light-primary.dropdown-toggle:after {\n  color: var(--kt-primary);\n}\n\n.btn.btn-outline.btn-outline-primary {\n  color: var(--kt-primary);\n  border-color: var(--kt-primary);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-primary i,\n.btn.btn-outline.btn-outline-primary .svg-icon {\n  color: var(--kt-primary);\n}\n.btn.btn-outline.btn-outline-primary.dropdown-toggle:after {\n  color: var(--kt-primary);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-primary, .btn-check:active + .btn.btn-outline.btn-outline-primary, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active), .btn.btn-outline.btn-outline-primary:hover:not(.btn-active), .btn.btn-outline.btn-outline-primary:active:not(.btn-active), .btn.btn-outline.btn-outline-primary.active, .btn.btn-outline.btn-outline-primary.show, .show > .btn.btn-outline.btn-outline-primary {\n  color: var(--kt-primary-active);\n  border-color: var(--kt-primary);\n  background-color: var(--kt-primary-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-primary i,\n.btn-check:checked + .btn.btn-outline.btn-outline-primary .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-primary i,\n.btn-check:active + .btn.btn-outline.btn-outline-primary .svg-icon, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-primary:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-primary:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-primary:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-primary.active i,\n.btn.btn-outline.btn-outline-primary.active .svg-icon, .btn.btn-outline.btn-outline-primary.show i,\n.btn.btn-outline.btn-outline-primary.show .svg-icon, .show > .btn.btn-outline.btn-outline-primary i,\n.show > .btn.btn-outline.btn-outline-primary .svg-icon {\n  color: var(--kt-primary-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-primary.dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-primary.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-primary.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-primary.dropdown-toggle:after {\n  color: var(--kt-primary-active);\n}\n\n.btn.btn-secondary {\n  color: var(--kt-secondary-inverse);\n  border-color: var(--kt-secondary);\n  background-color: var(--kt-secondary);\n}\n.btn.btn-secondary i,\n.btn.btn-secondary .svg-icon {\n  color: var(--kt-secondary-inverse);\n}\n.btn.btn-secondary.dropdown-toggle:after {\n  color: var(--kt-secondary-inverse);\n}\n.btn-check:checked + .btn.btn-secondary, .btn-check:active + .btn.btn-secondary, .btn.btn-secondary:focus:not(.btn-active), .btn.btn-secondary:hover:not(.btn-active), .btn.btn-secondary:active:not(.btn-active), .btn.btn-secondary.active, .btn.btn-secondary.show, .show > .btn.btn-secondary {\n  color: var(--kt-secondary-inverse);\n  border-color: var(--kt-secondary-active);\n  background-color: var(--kt-secondary-active) !important;\n}\n.btn-check:checked + .btn.btn-secondary i,\n.btn-check:checked + .btn.btn-secondary .svg-icon, .btn-check:active + .btn.btn-secondary i,\n.btn-check:active + .btn.btn-secondary .svg-icon, .btn.btn-secondary:focus:not(.btn-active) i,\n.btn.btn-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-secondary:hover:not(.btn-active) i,\n.btn.btn-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-secondary:active:not(.btn-active) i,\n.btn.btn-secondary:active:not(.btn-active) .svg-icon, .btn.btn-secondary.active i,\n.btn.btn-secondary.active .svg-icon, .btn.btn-secondary.show i,\n.btn.btn-secondary.show .svg-icon, .show > .btn.btn-secondary i,\n.show > .btn.btn-secondary .svg-icon {\n  color: var(--kt-secondary-inverse);\n}\n.btn-check:checked + .btn.btn-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-secondary.dropdown-toggle:after, .btn.btn-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-secondary.active.dropdown-toggle:after, .btn.btn-secondary.show.dropdown-toggle:after, .show > .btn.btn-secondary.dropdown-toggle:after {\n  color: var(--kt-secondary-inverse);\n}\n\n.btn.btn-light-secondary {\n  color: var(--kt-secondary);\n  border-color: var(--kt-secondary-light);\n  background-color: var(--kt-secondary-light);\n}\n.btn.btn-light-secondary i,\n.btn.btn-light-secondary .svg-icon {\n  color: var(--kt-secondary);\n}\n.btn.btn-light-secondary.dropdown-toggle:after {\n  color: var(--kt-secondary);\n}\n.btn-check:checked + .btn.btn-light-secondary, .btn-check:active + .btn.btn-light-secondary, .btn.btn-light-secondary:focus:not(.btn-active), .btn.btn-light-secondary:hover:not(.btn-active), .btn.btn-light-secondary:active:not(.btn-active), .btn.btn-light-secondary.active, .btn.btn-light-secondary.show, .show > .btn.btn-light-secondary {\n  color: var(--kt-secondary-inverse);\n  border-color: var(--kt-secondary);\n  background-color: var(--kt-secondary) !important;\n}\n.btn-check:checked + .btn.btn-light-secondary i,\n.btn-check:checked + .btn.btn-light-secondary .svg-icon, .btn-check:active + .btn.btn-light-secondary i,\n.btn-check:active + .btn.btn-light-secondary .svg-icon, .btn.btn-light-secondary:focus:not(.btn-active) i,\n.btn.btn-light-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-light-secondary:hover:not(.btn-active) i,\n.btn.btn-light-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-light-secondary:active:not(.btn-active) i,\n.btn.btn-light-secondary:active:not(.btn-active) .svg-icon, .btn.btn-light-secondary.active i,\n.btn.btn-light-secondary.active .svg-icon, .btn.btn-light-secondary.show i,\n.btn.btn-light-secondary.show .svg-icon, .show > .btn.btn-light-secondary i,\n.show > .btn.btn-light-secondary .svg-icon {\n  color: var(--kt-secondary-inverse);\n}\n.btn-check:checked + .btn.btn-light-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-light-secondary.dropdown-toggle:after, .btn.btn-light-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-secondary.active.dropdown-toggle:after, .btn.btn-light-secondary.show.dropdown-toggle:after, .show > .btn.btn-light-secondary.dropdown-toggle:after {\n  color: var(--kt-secondary-inverse);\n}\n\n.btn.btn-bg-secondary {\n  border-color: var(--kt-secondary);\n  background-color: var(--kt-secondary);\n}\n.btn-check:checked + .btn.btn-active-secondary, .btn-check:active + .btn.btn-active-secondary, .btn.btn-active-secondary:focus:not(.btn-active), .btn.btn-active-secondary:hover:not(.btn-active), .btn.btn-active-secondary:active:not(.btn-active), .btn.btn-active-secondary.active, .btn.btn-active-secondary.show, .show > .btn.btn-active-secondary {\n  color: var(--kt-secondary-inverse);\n  border-color: var(--kt-secondary);\n  background-color: var(--kt-secondary) !important;\n}\n.btn-check:checked + .btn.btn-active-secondary i,\n.btn-check:checked + .btn.btn-active-secondary .svg-icon, .btn-check:active + .btn.btn-active-secondary i,\n.btn-check:active + .btn.btn-active-secondary .svg-icon, .btn.btn-active-secondary:focus:not(.btn-active) i,\n.btn.btn-active-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-secondary:hover:not(.btn-active) i,\n.btn.btn-active-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-secondary:active:not(.btn-active) i,\n.btn.btn-active-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-secondary.active i,\n.btn.btn-active-secondary.active .svg-icon, .btn.btn-active-secondary.show i,\n.btn.btn-active-secondary.show .svg-icon, .show > .btn.btn-active-secondary i,\n.show > .btn.btn-active-secondary .svg-icon {\n  color: var(--kt-secondary-inverse);\n}\n.btn-check:checked + .btn.btn-active-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-secondary.dropdown-toggle:after, .btn.btn-active-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-secondary.active.dropdown-toggle:after, .btn.btn-active-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-secondary.dropdown-toggle:after {\n  color: var(--kt-secondary-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-secondary, .btn-check:active + .btn.btn-active-light-secondary, .btn.btn-active-light-secondary:focus:not(.btn-active), .btn.btn-active-light-secondary:hover:not(.btn-active), .btn.btn-active-light-secondary:active:not(.btn-active), .btn.btn-active-light-secondary.active, .btn.btn-active-light-secondary.show, .show > .btn.btn-active-light-secondary {\n  color: var(--kt-secondary);\n  border-color: var(--kt-secondary-light);\n  background-color: var(--kt-secondary-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-secondary i,\n.btn-check:checked + .btn.btn-active-light-secondary .svg-icon, .btn-check:active + .btn.btn-active-light-secondary i,\n.btn-check:active + .btn.btn-active-light-secondary .svg-icon, .btn.btn-active-light-secondary:focus:not(.btn-active) i,\n.btn.btn-active-light-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary:hover:not(.btn-active) i,\n.btn.btn-active-light-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary:active:not(.btn-active) i,\n.btn.btn-active-light-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-light-secondary.active i,\n.btn.btn-active-light-secondary.active .svg-icon, .btn.btn-active-light-secondary.show i,\n.btn.btn-active-light-secondary.show .svg-icon, .show > .btn.btn-active-light-secondary i,\n.show > .btn.btn-active-light-secondary .svg-icon {\n  color: var(--kt-secondary);\n}\n.btn-check:checked + .btn.btn-active-light-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-secondary.dropdown-toggle:after, .btn.btn-active-light-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-secondary.active.dropdown-toggle:after, .btn.btn-active-light-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-light-secondary.dropdown-toggle:after {\n  color: var(--kt-secondary);\n}\n\n.btn.btn-outline.btn-outline-secondary {\n  color: var(--kt-secondary);\n  border-color: var(--kt-secondary);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-secondary i,\n.btn.btn-outline.btn-outline-secondary .svg-icon {\n  color: var(--kt-secondary);\n}\n.btn.btn-outline.btn-outline-secondary.dropdown-toggle:after {\n  color: var(--kt-secondary);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-secondary, .btn-check:active + .btn.btn-outline.btn-outline-secondary, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active), .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active), .btn.btn-outline.btn-outline-secondary:active:not(.btn-active), .btn.btn-outline.btn-outline-secondary.active, .btn.btn-outline.btn-outline-secondary.show, .show > .btn.btn-outline.btn-outline-secondary {\n  color: var(--kt-secondary-active);\n  border-color: var(--kt-secondary);\n  background-color: var(--kt-secondary-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-secondary i,\n.btn-check:checked + .btn.btn-outline.btn-outline-secondary .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-secondary i,\n.btn-check:active + .btn.btn-outline.btn-outline-secondary .svg-icon, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-secondary:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-secondary.active i,\n.btn.btn-outline.btn-outline-secondary.active .svg-icon, .btn.btn-outline.btn-outline-secondary.show i,\n.btn.btn-outline.btn-outline-secondary.show .svg-icon, .show > .btn.btn-outline.btn-outline-secondary i,\n.show > .btn.btn-outline.btn-outline-secondary .svg-icon {\n  color: var(--kt-secondary-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-secondary.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-secondary.dropdown-toggle:after {\n  color: var(--kt-secondary-active);\n}\n\n.btn.btn-success {\n  color: var(--kt-success-inverse);\n  border-color: var(--kt-success);\n  background-color: var(--kt-success);\n}\n.btn.btn-success i,\n.btn.btn-success .svg-icon {\n  color: var(--kt-success-inverse);\n}\n.btn.btn-success.dropdown-toggle:after {\n  color: var(--kt-success-inverse);\n}\n.btn-check:checked + .btn.btn-success, .btn-check:active + .btn.btn-success, .btn.btn-success:focus:not(.btn-active), .btn.btn-success:hover:not(.btn-active), .btn.btn-success:active:not(.btn-active), .btn.btn-success.active, .btn.btn-success.show, .show > .btn.btn-success {\n  color: var(--kt-success-inverse);\n  border-color: var(--kt-success-active);\n  background-color: var(--kt-success-active) !important;\n}\n.btn-check:checked + .btn.btn-success i,\n.btn-check:checked + .btn.btn-success .svg-icon, .btn-check:active + .btn.btn-success i,\n.btn-check:active + .btn.btn-success .svg-icon, .btn.btn-success:focus:not(.btn-active) i,\n.btn.btn-success:focus:not(.btn-active) .svg-icon, .btn.btn-success:hover:not(.btn-active) i,\n.btn.btn-success:hover:not(.btn-active) .svg-icon, .btn.btn-success:active:not(.btn-active) i,\n.btn.btn-success:active:not(.btn-active) .svg-icon, .btn.btn-success.active i,\n.btn.btn-success.active .svg-icon, .btn.btn-success.show i,\n.btn.btn-success.show .svg-icon, .show > .btn.btn-success i,\n.show > .btn.btn-success .svg-icon {\n  color: var(--kt-success-inverse);\n}\n.btn-check:checked + .btn.btn-success.dropdown-toggle:after, .btn-check:active + .btn.btn-success.dropdown-toggle:after, .btn.btn-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-success.active.dropdown-toggle:after, .btn.btn-success.show.dropdown-toggle:after, .show > .btn.btn-success.dropdown-toggle:after {\n  color: var(--kt-success-inverse);\n}\n\n.btn.btn-light-success {\n  color: var(--kt-success);\n  border-color: var(--kt-success-light);\n  background-color: var(--kt-success-light);\n}\n.btn.btn-light-success i,\n.btn.btn-light-success .svg-icon {\n  color: var(--kt-success);\n}\n.btn.btn-light-success.dropdown-toggle:after {\n  color: var(--kt-success);\n}\n.btn-check:checked + .btn.btn-light-success, .btn-check:active + .btn.btn-light-success, .btn.btn-light-success:focus:not(.btn-active), .btn.btn-light-success:hover:not(.btn-active), .btn.btn-light-success:active:not(.btn-active), .btn.btn-light-success.active, .btn.btn-light-success.show, .show > .btn.btn-light-success {\n  color: var(--kt-success-inverse);\n  border-color: var(--kt-success);\n  background-color: var(--kt-success) !important;\n}\n.btn-check:checked + .btn.btn-light-success i,\n.btn-check:checked + .btn.btn-light-success .svg-icon, .btn-check:active + .btn.btn-light-success i,\n.btn-check:active + .btn.btn-light-success .svg-icon, .btn.btn-light-success:focus:not(.btn-active) i,\n.btn.btn-light-success:focus:not(.btn-active) .svg-icon, .btn.btn-light-success:hover:not(.btn-active) i,\n.btn.btn-light-success:hover:not(.btn-active) .svg-icon, .btn.btn-light-success:active:not(.btn-active) i,\n.btn.btn-light-success:active:not(.btn-active) .svg-icon, .btn.btn-light-success.active i,\n.btn.btn-light-success.active .svg-icon, .btn.btn-light-success.show i,\n.btn.btn-light-success.show .svg-icon, .show > .btn.btn-light-success i,\n.show > .btn.btn-light-success .svg-icon {\n  color: var(--kt-success-inverse);\n}\n.btn-check:checked + .btn.btn-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-light-success.dropdown-toggle:after, .btn.btn-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-success.active.dropdown-toggle:after, .btn.btn-light-success.show.dropdown-toggle:after, .show > .btn.btn-light-success.dropdown-toggle:after {\n  color: var(--kt-success-inverse);\n}\n\n.btn.btn-bg-success {\n  border-color: var(--kt-success);\n  background-color: var(--kt-success);\n}\n.btn-check:checked + .btn.btn-active-success, .btn-check:active + .btn.btn-active-success, .btn.btn-active-success:focus:not(.btn-active), .btn.btn-active-success:hover:not(.btn-active), .btn.btn-active-success:active:not(.btn-active), .btn.btn-active-success.active, .btn.btn-active-success.show, .show > .btn.btn-active-success {\n  color: var(--kt-success-inverse);\n  border-color: var(--kt-success);\n  background-color: var(--kt-success) !important;\n}\n.btn-check:checked + .btn.btn-active-success i,\n.btn-check:checked + .btn.btn-active-success .svg-icon, .btn-check:active + .btn.btn-active-success i,\n.btn-check:active + .btn.btn-active-success .svg-icon, .btn.btn-active-success:focus:not(.btn-active) i,\n.btn.btn-active-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-success:hover:not(.btn-active) i,\n.btn.btn-active-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-success:active:not(.btn-active) i,\n.btn.btn-active-success:active:not(.btn-active) .svg-icon, .btn.btn-active-success.active i,\n.btn.btn-active-success.active .svg-icon, .btn.btn-active-success.show i,\n.btn.btn-active-success.show .svg-icon, .show > .btn.btn-active-success i,\n.show > .btn.btn-active-success .svg-icon {\n  color: var(--kt-success-inverse);\n}\n.btn-check:checked + .btn.btn-active-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-success.dropdown-toggle:after, .btn.btn-active-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-success.active.dropdown-toggle:after, .btn.btn-active-success.show.dropdown-toggle:after, .show > .btn.btn-active-success.dropdown-toggle:after {\n  color: var(--kt-success-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-success, .btn-check:active + .btn.btn-active-light-success, .btn.btn-active-light-success:focus:not(.btn-active), .btn.btn-active-light-success:hover:not(.btn-active), .btn.btn-active-light-success:active:not(.btn-active), .btn.btn-active-light-success.active, .btn.btn-active-light-success.show, .show > .btn.btn-active-light-success {\n  color: var(--kt-success);\n  border-color: var(--kt-success-light);\n  background-color: var(--kt-success-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-success i,\n.btn-check:checked + .btn.btn-active-light-success .svg-icon, .btn-check:active + .btn.btn-active-light-success i,\n.btn-check:active + .btn.btn-active-light-success .svg-icon, .btn.btn-active-light-success:focus:not(.btn-active) i,\n.btn.btn-active-light-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-success:hover:not(.btn-active) i,\n.btn.btn-active-light-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-success:active:not(.btn-active) i,\n.btn.btn-active-light-success:active:not(.btn-active) .svg-icon, .btn.btn-active-light-success.active i,\n.btn.btn-active-light-success.active .svg-icon, .btn.btn-active-light-success.show i,\n.btn.btn-active-light-success.show .svg-icon, .show > .btn.btn-active-light-success i,\n.show > .btn.btn-active-light-success .svg-icon {\n  color: var(--kt-success);\n}\n.btn-check:checked + .btn.btn-active-light-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-success.dropdown-toggle:after, .btn.btn-active-light-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-success.active.dropdown-toggle:after, .btn.btn-active-light-success.show.dropdown-toggle:after, .show > .btn.btn-active-light-success.dropdown-toggle:after {\n  color: var(--kt-success);\n}\n\n.btn.btn-outline.btn-outline-success {\n  color: var(--kt-success);\n  border-color: var(--kt-success);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-success i,\n.btn.btn-outline.btn-outline-success .svg-icon {\n  color: var(--kt-success);\n}\n.btn.btn-outline.btn-outline-success.dropdown-toggle:after {\n  color: var(--kt-success);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-success, .btn-check:active + .btn.btn-outline.btn-outline-success, .btn.btn-outline.btn-outline-success:focus:not(.btn-active), .btn.btn-outline.btn-outline-success:hover:not(.btn-active), .btn.btn-outline.btn-outline-success:active:not(.btn-active), .btn.btn-outline.btn-outline-success.active, .btn.btn-outline.btn-outline-success.show, .show > .btn.btn-outline.btn-outline-success {\n  color: var(--kt-success-active);\n  border-color: var(--kt-success);\n  background-color: var(--kt-success-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-success i,\n.btn-check:checked + .btn.btn-outline.btn-outline-success .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-success i,\n.btn-check:active + .btn.btn-outline.btn-outline-success .svg-icon, .btn.btn-outline.btn-outline-success:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-success:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-success:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-success:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-success.active i,\n.btn.btn-outline.btn-outline-success.active .svg-icon, .btn.btn-outline.btn-outline-success.show i,\n.btn.btn-outline.btn-outline-success.show .svg-icon, .show > .btn.btn-outline.btn-outline-success i,\n.show > .btn.btn-outline.btn-outline-success .svg-icon {\n  color: var(--kt-success-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-success.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-success.dropdown-toggle:after, .btn.btn-outline.btn-outline-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-success.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-success.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-success.dropdown-toggle:after {\n  color: var(--kt-success-active);\n}\n\n.btn.btn-info {\n  color: var(--kt-info-inverse);\n  border-color: var(--kt-info);\n  background-color: var(--kt-info);\n}\n.btn.btn-info i,\n.btn.btn-info .svg-icon {\n  color: var(--kt-info-inverse);\n}\n.btn.btn-info.dropdown-toggle:after {\n  color: var(--kt-info-inverse);\n}\n.btn-check:checked + .btn.btn-info, .btn-check:active + .btn.btn-info, .btn.btn-info:focus:not(.btn-active), .btn.btn-info:hover:not(.btn-active), .btn.btn-info:active:not(.btn-active), .btn.btn-info.active, .btn.btn-info.show, .show > .btn.btn-info {\n  color: var(--kt-info-inverse);\n  border-color: var(--kt-info-active);\n  background-color: var(--kt-info-active) !important;\n}\n.btn-check:checked + .btn.btn-info i,\n.btn-check:checked + .btn.btn-info .svg-icon, .btn-check:active + .btn.btn-info i,\n.btn-check:active + .btn.btn-info .svg-icon, .btn.btn-info:focus:not(.btn-active) i,\n.btn.btn-info:focus:not(.btn-active) .svg-icon, .btn.btn-info:hover:not(.btn-active) i,\n.btn.btn-info:hover:not(.btn-active) .svg-icon, .btn.btn-info:active:not(.btn-active) i,\n.btn.btn-info:active:not(.btn-active) .svg-icon, .btn.btn-info.active i,\n.btn.btn-info.active .svg-icon, .btn.btn-info.show i,\n.btn.btn-info.show .svg-icon, .show > .btn.btn-info i,\n.show > .btn.btn-info .svg-icon {\n  color: var(--kt-info-inverse);\n}\n.btn-check:checked + .btn.btn-info.dropdown-toggle:after, .btn-check:active + .btn.btn-info.dropdown-toggle:after, .btn.btn-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-info.active.dropdown-toggle:after, .btn.btn-info.show.dropdown-toggle:after, .show > .btn.btn-info.dropdown-toggle:after {\n  color: var(--kt-info-inverse);\n}\n\n.btn.btn-light-info {\n  color: var(--kt-info);\n  border-color: var(--kt-info-light);\n  background-color: var(--kt-info-light);\n}\n.btn.btn-light-info i,\n.btn.btn-light-info .svg-icon {\n  color: var(--kt-info);\n}\n.btn.btn-light-info.dropdown-toggle:after {\n  color: var(--kt-info);\n}\n.btn-check:checked + .btn.btn-light-info, .btn-check:active + .btn.btn-light-info, .btn.btn-light-info:focus:not(.btn-active), .btn.btn-light-info:hover:not(.btn-active), .btn.btn-light-info:active:not(.btn-active), .btn.btn-light-info.active, .btn.btn-light-info.show, .show > .btn.btn-light-info {\n  color: var(--kt-info-inverse);\n  border-color: var(--kt-info);\n  background-color: var(--kt-info) !important;\n}\n.btn-check:checked + .btn.btn-light-info i,\n.btn-check:checked + .btn.btn-light-info .svg-icon, .btn-check:active + .btn.btn-light-info i,\n.btn-check:active + .btn.btn-light-info .svg-icon, .btn.btn-light-info:focus:not(.btn-active) i,\n.btn.btn-light-info:focus:not(.btn-active) .svg-icon, .btn.btn-light-info:hover:not(.btn-active) i,\n.btn.btn-light-info:hover:not(.btn-active) .svg-icon, .btn.btn-light-info:active:not(.btn-active) i,\n.btn.btn-light-info:active:not(.btn-active) .svg-icon, .btn.btn-light-info.active i,\n.btn.btn-light-info.active .svg-icon, .btn.btn-light-info.show i,\n.btn.btn-light-info.show .svg-icon, .show > .btn.btn-light-info i,\n.show > .btn.btn-light-info .svg-icon {\n  color: var(--kt-info-inverse);\n}\n.btn-check:checked + .btn.btn-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-light-info.dropdown-toggle:after, .btn.btn-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-info.active.dropdown-toggle:after, .btn.btn-light-info.show.dropdown-toggle:after, .show > .btn.btn-light-info.dropdown-toggle:after {\n  color: var(--kt-info-inverse);\n}\n\n.btn.btn-bg-info {\n  border-color: var(--kt-info);\n  background-color: var(--kt-info);\n}\n.btn-check:checked + .btn.btn-active-info, .btn-check:active + .btn.btn-active-info, .btn.btn-active-info:focus:not(.btn-active), .btn.btn-active-info:hover:not(.btn-active), .btn.btn-active-info:active:not(.btn-active), .btn.btn-active-info.active, .btn.btn-active-info.show, .show > .btn.btn-active-info {\n  color: var(--kt-info-inverse);\n  border-color: var(--kt-info);\n  background-color: var(--kt-info) !important;\n}\n.btn-check:checked + .btn.btn-active-info i,\n.btn-check:checked + .btn.btn-active-info .svg-icon, .btn-check:active + .btn.btn-active-info i,\n.btn-check:active + .btn.btn-active-info .svg-icon, .btn.btn-active-info:focus:not(.btn-active) i,\n.btn.btn-active-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-info:hover:not(.btn-active) i,\n.btn.btn-active-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-info:active:not(.btn-active) i,\n.btn.btn-active-info:active:not(.btn-active) .svg-icon, .btn.btn-active-info.active i,\n.btn.btn-active-info.active .svg-icon, .btn.btn-active-info.show i,\n.btn.btn-active-info.show .svg-icon, .show > .btn.btn-active-info i,\n.show > .btn.btn-active-info .svg-icon {\n  color: var(--kt-info-inverse);\n}\n.btn-check:checked + .btn.btn-active-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-info.dropdown-toggle:after, .btn.btn-active-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-info.active.dropdown-toggle:after, .btn.btn-active-info.show.dropdown-toggle:after, .show > .btn.btn-active-info.dropdown-toggle:after {\n  color: var(--kt-info-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-info, .btn-check:active + .btn.btn-active-light-info, .btn.btn-active-light-info:focus:not(.btn-active), .btn.btn-active-light-info:hover:not(.btn-active), .btn.btn-active-light-info:active:not(.btn-active), .btn.btn-active-light-info.active, .btn.btn-active-light-info.show, .show > .btn.btn-active-light-info {\n  color: var(--kt-info);\n  border-color: var(--kt-info-light);\n  background-color: var(--kt-info-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-info i,\n.btn-check:checked + .btn.btn-active-light-info .svg-icon, .btn-check:active + .btn.btn-active-light-info i,\n.btn-check:active + .btn.btn-active-light-info .svg-icon, .btn.btn-active-light-info:focus:not(.btn-active) i,\n.btn.btn-active-light-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-info:hover:not(.btn-active) i,\n.btn.btn-active-light-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-info:active:not(.btn-active) i,\n.btn.btn-active-light-info:active:not(.btn-active) .svg-icon, .btn.btn-active-light-info.active i,\n.btn.btn-active-light-info.active .svg-icon, .btn.btn-active-light-info.show i,\n.btn.btn-active-light-info.show .svg-icon, .show > .btn.btn-active-light-info i,\n.show > .btn.btn-active-light-info .svg-icon {\n  color: var(--kt-info);\n}\n.btn-check:checked + .btn.btn-active-light-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-info.dropdown-toggle:after, .btn.btn-active-light-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-info.active.dropdown-toggle:after, .btn.btn-active-light-info.show.dropdown-toggle:after, .show > .btn.btn-active-light-info.dropdown-toggle:after {\n  color: var(--kt-info);\n}\n\n.btn.btn-outline.btn-outline-info {\n  color: var(--kt-info);\n  border-color: var(--kt-info);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-info i,\n.btn.btn-outline.btn-outline-info .svg-icon {\n  color: var(--kt-info);\n}\n.btn.btn-outline.btn-outline-info.dropdown-toggle:after {\n  color: var(--kt-info);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-info, .btn-check:active + .btn.btn-outline.btn-outline-info, .btn.btn-outline.btn-outline-info:focus:not(.btn-active), .btn.btn-outline.btn-outline-info:hover:not(.btn-active), .btn.btn-outline.btn-outline-info:active:not(.btn-active), .btn.btn-outline.btn-outline-info.active, .btn.btn-outline.btn-outline-info.show, .show > .btn.btn-outline.btn-outline-info {\n  color: var(--kt-info-active);\n  border-color: var(--kt-info);\n  background-color: var(--kt-info-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-info i,\n.btn-check:checked + .btn.btn-outline.btn-outline-info .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-info i,\n.btn-check:active + .btn.btn-outline.btn-outline-info .svg-icon, .btn.btn-outline.btn-outline-info:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-info:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-info:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-info:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-info.active i,\n.btn.btn-outline.btn-outline-info.active .svg-icon, .btn.btn-outline.btn-outline-info.show i,\n.btn.btn-outline.btn-outline-info.show .svg-icon, .show > .btn.btn-outline.btn-outline-info i,\n.show > .btn.btn-outline.btn-outline-info .svg-icon {\n  color: var(--kt-info-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-info.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-info.dropdown-toggle:after, .btn.btn-outline.btn-outline-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-info.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-info.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-info.dropdown-toggle:after {\n  color: var(--kt-info-active);\n}\n\n.btn.btn-warning {\n  color: var(--kt-warning-inverse);\n  border-color: var(--kt-warning);\n  background-color: var(--kt-warning);\n}\n.btn.btn-warning i,\n.btn.btn-warning .svg-icon {\n  color: var(--kt-warning-inverse);\n}\n.btn.btn-warning.dropdown-toggle:after {\n  color: var(--kt-warning-inverse);\n}\n.btn-check:checked + .btn.btn-warning, .btn-check:active + .btn.btn-warning, .btn.btn-warning:focus:not(.btn-active), .btn.btn-warning:hover:not(.btn-active), .btn.btn-warning:active:not(.btn-active), .btn.btn-warning.active, .btn.btn-warning.show, .show > .btn.btn-warning {\n  color: var(--kt-warning-inverse);\n  border-color: var(--kt-warning-active);\n  background-color: var(--kt-warning-active) !important;\n}\n.btn-check:checked + .btn.btn-warning i,\n.btn-check:checked + .btn.btn-warning .svg-icon, .btn-check:active + .btn.btn-warning i,\n.btn-check:active + .btn.btn-warning .svg-icon, .btn.btn-warning:focus:not(.btn-active) i,\n.btn.btn-warning:focus:not(.btn-active) .svg-icon, .btn.btn-warning:hover:not(.btn-active) i,\n.btn.btn-warning:hover:not(.btn-active) .svg-icon, .btn.btn-warning:active:not(.btn-active) i,\n.btn.btn-warning:active:not(.btn-active) .svg-icon, .btn.btn-warning.active i,\n.btn.btn-warning.active .svg-icon, .btn.btn-warning.show i,\n.btn.btn-warning.show .svg-icon, .show > .btn.btn-warning i,\n.show > .btn.btn-warning .svg-icon {\n  color: var(--kt-warning-inverse);\n}\n.btn-check:checked + .btn.btn-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-warning.dropdown-toggle:after, .btn.btn-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-warning.active.dropdown-toggle:after, .btn.btn-warning.show.dropdown-toggle:after, .show > .btn.btn-warning.dropdown-toggle:after {\n  color: var(--kt-warning-inverse);\n}\n\n.btn.btn-light-warning {\n  color: var(--kt-warning);\n  border-color: var(--kt-warning-light);\n  background-color: var(--kt-warning-light);\n}\n.btn.btn-light-warning i,\n.btn.btn-light-warning .svg-icon {\n  color: var(--kt-warning);\n}\n.btn.btn-light-warning.dropdown-toggle:after {\n  color: var(--kt-warning);\n}\n.btn-check:checked + .btn.btn-light-warning, .btn-check:active + .btn.btn-light-warning, .btn.btn-light-warning:focus:not(.btn-active), .btn.btn-light-warning:hover:not(.btn-active), .btn.btn-light-warning:active:not(.btn-active), .btn.btn-light-warning.active, .btn.btn-light-warning.show, .show > .btn.btn-light-warning {\n  color: var(--kt-warning-inverse);\n  border-color: var(--kt-warning);\n  background-color: var(--kt-warning) !important;\n}\n.btn-check:checked + .btn.btn-light-warning i,\n.btn-check:checked + .btn.btn-light-warning .svg-icon, .btn-check:active + .btn.btn-light-warning i,\n.btn-check:active + .btn.btn-light-warning .svg-icon, .btn.btn-light-warning:focus:not(.btn-active) i,\n.btn.btn-light-warning:focus:not(.btn-active) .svg-icon, .btn.btn-light-warning:hover:not(.btn-active) i,\n.btn.btn-light-warning:hover:not(.btn-active) .svg-icon, .btn.btn-light-warning:active:not(.btn-active) i,\n.btn.btn-light-warning:active:not(.btn-active) .svg-icon, .btn.btn-light-warning.active i,\n.btn.btn-light-warning.active .svg-icon, .btn.btn-light-warning.show i,\n.btn.btn-light-warning.show .svg-icon, .show > .btn.btn-light-warning i,\n.show > .btn.btn-light-warning .svg-icon {\n  color: var(--kt-warning-inverse);\n}\n.btn-check:checked + .btn.btn-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-light-warning.dropdown-toggle:after, .btn.btn-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-warning.active.dropdown-toggle:after, .btn.btn-light-warning.show.dropdown-toggle:after, .show > .btn.btn-light-warning.dropdown-toggle:after {\n  color: var(--kt-warning-inverse);\n}\n\n.btn.btn-bg-warning {\n  border-color: var(--kt-warning);\n  background-color: var(--kt-warning);\n}\n.btn-check:checked + .btn.btn-active-warning, .btn-check:active + .btn.btn-active-warning, .btn.btn-active-warning:focus:not(.btn-active), .btn.btn-active-warning:hover:not(.btn-active), .btn.btn-active-warning:active:not(.btn-active), .btn.btn-active-warning.active, .btn.btn-active-warning.show, .show > .btn.btn-active-warning {\n  color: var(--kt-warning-inverse);\n  border-color: var(--kt-warning);\n  background-color: var(--kt-warning) !important;\n}\n.btn-check:checked + .btn.btn-active-warning i,\n.btn-check:checked + .btn.btn-active-warning .svg-icon, .btn-check:active + .btn.btn-active-warning i,\n.btn-check:active + .btn.btn-active-warning .svg-icon, .btn.btn-active-warning:focus:not(.btn-active) i,\n.btn.btn-active-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-warning:hover:not(.btn-active) i,\n.btn.btn-active-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-warning:active:not(.btn-active) i,\n.btn.btn-active-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-warning.active i,\n.btn.btn-active-warning.active .svg-icon, .btn.btn-active-warning.show i,\n.btn.btn-active-warning.show .svg-icon, .show > .btn.btn-active-warning i,\n.show > .btn.btn-active-warning .svg-icon {\n  color: var(--kt-warning-inverse);\n}\n.btn-check:checked + .btn.btn-active-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-warning.dropdown-toggle:after, .btn.btn-active-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-warning.active.dropdown-toggle:after, .btn.btn-active-warning.show.dropdown-toggle:after, .show > .btn.btn-active-warning.dropdown-toggle:after {\n  color: var(--kt-warning-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-warning, .btn-check:active + .btn.btn-active-light-warning, .btn.btn-active-light-warning:focus:not(.btn-active), .btn.btn-active-light-warning:hover:not(.btn-active), .btn.btn-active-light-warning:active:not(.btn-active), .btn.btn-active-light-warning.active, .btn.btn-active-light-warning.show, .show > .btn.btn-active-light-warning {\n  color: var(--kt-warning);\n  border-color: var(--kt-warning-light);\n  background-color: var(--kt-warning-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-warning i,\n.btn-check:checked + .btn.btn-active-light-warning .svg-icon, .btn-check:active + .btn.btn-active-light-warning i,\n.btn-check:active + .btn.btn-active-light-warning .svg-icon, .btn.btn-active-light-warning:focus:not(.btn-active) i,\n.btn.btn-active-light-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-warning:hover:not(.btn-active) i,\n.btn.btn-active-light-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-warning:active:not(.btn-active) i,\n.btn.btn-active-light-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-light-warning.active i,\n.btn.btn-active-light-warning.active .svg-icon, .btn.btn-active-light-warning.show i,\n.btn.btn-active-light-warning.show .svg-icon, .show > .btn.btn-active-light-warning i,\n.show > .btn.btn-active-light-warning .svg-icon {\n  color: var(--kt-warning);\n}\n.btn-check:checked + .btn.btn-active-light-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-warning.dropdown-toggle:after, .btn.btn-active-light-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-warning.active.dropdown-toggle:after, .btn.btn-active-light-warning.show.dropdown-toggle:after, .show > .btn.btn-active-light-warning.dropdown-toggle:after {\n  color: var(--kt-warning);\n}\n\n.btn.btn-outline.btn-outline-warning {\n  color: var(--kt-warning);\n  border-color: var(--kt-warning);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-warning i,\n.btn.btn-outline.btn-outline-warning .svg-icon {\n  color: var(--kt-warning);\n}\n.btn.btn-outline.btn-outline-warning.dropdown-toggle:after {\n  color: var(--kt-warning);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-warning, .btn-check:active + .btn.btn-outline.btn-outline-warning, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active), .btn.btn-outline.btn-outline-warning:hover:not(.btn-active), .btn.btn-outline.btn-outline-warning:active:not(.btn-active), .btn.btn-outline.btn-outline-warning.active, .btn.btn-outline.btn-outline-warning.show, .show > .btn.btn-outline.btn-outline-warning {\n  color: var(--kt-warning-active);\n  border-color: var(--kt-warning);\n  background-color: var(--kt-warning-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-warning i,\n.btn-check:checked + .btn.btn-outline.btn-outline-warning .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-warning i,\n.btn-check:active + .btn.btn-outline.btn-outline-warning .svg-icon, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-warning:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-warning:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-warning:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-warning.active i,\n.btn.btn-outline.btn-outline-warning.active .svg-icon, .btn.btn-outline.btn-outline-warning.show i,\n.btn.btn-outline.btn-outline-warning.show .svg-icon, .show > .btn.btn-outline.btn-outline-warning i,\n.show > .btn.btn-outline.btn-outline-warning .svg-icon {\n  color: var(--kt-warning-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-warning.dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-warning.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-warning.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-warning.dropdown-toggle:after {\n  color: var(--kt-warning-active);\n}\n\n.btn.btn-danger {\n  color: var(--kt-danger-inverse);\n  border-color: var(--kt-danger);\n  background-color: var(--kt-danger);\n}\n.btn.btn-danger i,\n.btn.btn-danger .svg-icon {\n  color: var(--kt-danger-inverse);\n}\n.btn.btn-danger.dropdown-toggle:after {\n  color: var(--kt-danger-inverse);\n}\n.btn-check:checked + .btn.btn-danger, .btn-check:active + .btn.btn-danger, .btn.btn-danger:focus:not(.btn-active), .btn.btn-danger:hover:not(.btn-active), .btn.btn-danger:active:not(.btn-active), .btn.btn-danger.active, .btn.btn-danger.show, .show > .btn.btn-danger {\n  color: var(--kt-danger-inverse);\n  border-color: var(--kt-danger-active);\n  background-color: var(--kt-danger-active) !important;\n}\n.btn-check:checked + .btn.btn-danger i,\n.btn-check:checked + .btn.btn-danger .svg-icon, .btn-check:active + .btn.btn-danger i,\n.btn-check:active + .btn.btn-danger .svg-icon, .btn.btn-danger:focus:not(.btn-active) i,\n.btn.btn-danger:focus:not(.btn-active) .svg-icon, .btn.btn-danger:hover:not(.btn-active) i,\n.btn.btn-danger:hover:not(.btn-active) .svg-icon, .btn.btn-danger:active:not(.btn-active) i,\n.btn.btn-danger:active:not(.btn-active) .svg-icon, .btn.btn-danger.active i,\n.btn.btn-danger.active .svg-icon, .btn.btn-danger.show i,\n.btn.btn-danger.show .svg-icon, .show > .btn.btn-danger i,\n.show > .btn.btn-danger .svg-icon {\n  color: var(--kt-danger-inverse);\n}\n.btn-check:checked + .btn.btn-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-danger.dropdown-toggle:after, .btn.btn-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-danger.active.dropdown-toggle:after, .btn.btn-danger.show.dropdown-toggle:after, .show > .btn.btn-danger.dropdown-toggle:after {\n  color: var(--kt-danger-inverse);\n}\n\n.btn.btn-light-danger {\n  color: var(--kt-danger);\n  border-color: var(--kt-danger-light);\n  background-color: var(--kt-danger-light);\n}\n.btn.btn-light-danger i,\n.btn.btn-light-danger .svg-icon {\n  color: var(--kt-danger);\n}\n.btn.btn-light-danger.dropdown-toggle:after {\n  color: var(--kt-danger);\n}\n.btn-check:checked + .btn.btn-light-danger, .btn-check:active + .btn.btn-light-danger, .btn.btn-light-danger:focus:not(.btn-active), .btn.btn-light-danger:hover:not(.btn-active), .btn.btn-light-danger:active:not(.btn-active), .btn.btn-light-danger.active, .btn.btn-light-danger.show, .show > .btn.btn-light-danger {\n  color: var(--kt-danger-inverse);\n  border-color: var(--kt-danger);\n  background-color: var(--kt-danger) !important;\n}\n.btn-check:checked + .btn.btn-light-danger i,\n.btn-check:checked + .btn.btn-light-danger .svg-icon, .btn-check:active + .btn.btn-light-danger i,\n.btn-check:active + .btn.btn-light-danger .svg-icon, .btn.btn-light-danger:focus:not(.btn-active) i,\n.btn.btn-light-danger:focus:not(.btn-active) .svg-icon, .btn.btn-light-danger:hover:not(.btn-active) i,\n.btn.btn-light-danger:hover:not(.btn-active) .svg-icon, .btn.btn-light-danger:active:not(.btn-active) i,\n.btn.btn-light-danger:active:not(.btn-active) .svg-icon, .btn.btn-light-danger.active i,\n.btn.btn-light-danger.active .svg-icon, .btn.btn-light-danger.show i,\n.btn.btn-light-danger.show .svg-icon, .show > .btn.btn-light-danger i,\n.show > .btn.btn-light-danger .svg-icon {\n  color: var(--kt-danger-inverse);\n}\n.btn-check:checked + .btn.btn-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-light-danger.dropdown-toggle:after, .btn.btn-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-danger.active.dropdown-toggle:after, .btn.btn-light-danger.show.dropdown-toggle:after, .show > .btn.btn-light-danger.dropdown-toggle:after {\n  color: var(--kt-danger-inverse);\n}\n\n.btn.btn-bg-danger {\n  border-color: var(--kt-danger);\n  background-color: var(--kt-danger);\n}\n.btn-check:checked + .btn.btn-active-danger, .btn-check:active + .btn.btn-active-danger, .btn.btn-active-danger:focus:not(.btn-active), .btn.btn-active-danger:hover:not(.btn-active), .btn.btn-active-danger:active:not(.btn-active), .btn.btn-active-danger.active, .btn.btn-active-danger.show, .show > .btn.btn-active-danger {\n  color: var(--kt-danger-inverse);\n  border-color: var(--kt-danger);\n  background-color: var(--kt-danger) !important;\n}\n.btn-check:checked + .btn.btn-active-danger i,\n.btn-check:checked + .btn.btn-active-danger .svg-icon, .btn-check:active + .btn.btn-active-danger i,\n.btn-check:active + .btn.btn-active-danger .svg-icon, .btn.btn-active-danger:focus:not(.btn-active) i,\n.btn.btn-active-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-danger:hover:not(.btn-active) i,\n.btn.btn-active-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-danger:active:not(.btn-active) i,\n.btn.btn-active-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-danger.active i,\n.btn.btn-active-danger.active .svg-icon, .btn.btn-active-danger.show i,\n.btn.btn-active-danger.show .svg-icon, .show > .btn.btn-active-danger i,\n.show > .btn.btn-active-danger .svg-icon {\n  color: var(--kt-danger-inverse);\n}\n.btn-check:checked + .btn.btn-active-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-danger.dropdown-toggle:after, .btn.btn-active-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-danger.active.dropdown-toggle:after, .btn.btn-active-danger.show.dropdown-toggle:after, .show > .btn.btn-active-danger.dropdown-toggle:after {\n  color: var(--kt-danger-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-danger, .btn-check:active + .btn.btn-active-light-danger, .btn.btn-active-light-danger:focus:not(.btn-active), .btn.btn-active-light-danger:hover:not(.btn-active), .btn.btn-active-light-danger:active:not(.btn-active), .btn.btn-active-light-danger.active, .btn.btn-active-light-danger.show, .show > .btn.btn-active-light-danger {\n  color: var(--kt-danger);\n  border-color: var(--kt-danger-light);\n  background-color: var(--kt-danger-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-danger i,\n.btn-check:checked + .btn.btn-active-light-danger .svg-icon, .btn-check:active + .btn.btn-active-light-danger i,\n.btn-check:active + .btn.btn-active-light-danger .svg-icon, .btn.btn-active-light-danger:focus:not(.btn-active) i,\n.btn.btn-active-light-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-danger:hover:not(.btn-active) i,\n.btn.btn-active-light-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-danger:active:not(.btn-active) i,\n.btn.btn-active-light-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-light-danger.active i,\n.btn.btn-active-light-danger.active .svg-icon, .btn.btn-active-light-danger.show i,\n.btn.btn-active-light-danger.show .svg-icon, .show > .btn.btn-active-light-danger i,\n.show > .btn.btn-active-light-danger .svg-icon {\n  color: var(--kt-danger);\n}\n.btn-check:checked + .btn.btn-active-light-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-danger.dropdown-toggle:after, .btn.btn-active-light-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-danger.active.dropdown-toggle:after, .btn.btn-active-light-danger.show.dropdown-toggle:after, .show > .btn.btn-active-light-danger.dropdown-toggle:after {\n  color: var(--kt-danger);\n}\n\n.btn.btn-outline.btn-outline-danger {\n  color: var(--kt-danger);\n  border-color: var(--kt-danger);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-danger i,\n.btn.btn-outline.btn-outline-danger .svg-icon {\n  color: var(--kt-danger);\n}\n.btn.btn-outline.btn-outline-danger.dropdown-toggle:after {\n  color: var(--kt-danger);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-danger, .btn-check:active + .btn.btn-outline.btn-outline-danger, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active), .btn.btn-outline.btn-outline-danger:hover:not(.btn-active), .btn.btn-outline.btn-outline-danger:active:not(.btn-active), .btn.btn-outline.btn-outline-danger.active, .btn.btn-outline.btn-outline-danger.show, .show > .btn.btn-outline.btn-outline-danger {\n  color: var(--kt-danger-active);\n  border-color: var(--kt-danger);\n  background-color: var(--kt-danger-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-danger i,\n.btn-check:checked + .btn.btn-outline.btn-outline-danger .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-danger i,\n.btn-check:active + .btn.btn-outline.btn-outline-danger .svg-icon, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-danger:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-danger:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-danger:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-danger.active i,\n.btn.btn-outline.btn-outline-danger.active .svg-icon, .btn.btn-outline.btn-outline-danger.show i,\n.btn.btn-outline.btn-outline-danger.show .svg-icon, .show > .btn.btn-outline.btn-outline-danger i,\n.show > .btn.btn-outline.btn-outline-danger .svg-icon {\n  color: var(--kt-danger-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-danger.dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-danger.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-danger.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-danger.dropdown-toggle:after {\n  color: var(--kt-danger-active);\n}\n\n.btn.btn-dark {\n  color: var(--kt-dark-inverse);\n  border-color: var(--kt-dark);\n  background-color: var(--kt-dark);\n}\n.btn.btn-dark i,\n.btn.btn-dark .svg-icon {\n  color: var(--kt-dark-inverse);\n}\n.btn.btn-dark.dropdown-toggle:after {\n  color: var(--kt-dark-inverse);\n}\n.btn-check:checked + .btn.btn-dark, .btn-check:active + .btn.btn-dark, .btn.btn-dark:focus:not(.btn-active), .btn.btn-dark:hover:not(.btn-active), .btn.btn-dark:active:not(.btn-active), .btn.btn-dark.active, .btn.btn-dark.show, .show > .btn.btn-dark {\n  color: var(--kt-dark-inverse);\n  border-color: var(--kt-dark-active);\n  background-color: var(--kt-dark-active) !important;\n}\n.btn-check:checked + .btn.btn-dark i,\n.btn-check:checked + .btn.btn-dark .svg-icon, .btn-check:active + .btn.btn-dark i,\n.btn-check:active + .btn.btn-dark .svg-icon, .btn.btn-dark:focus:not(.btn-active) i,\n.btn.btn-dark:focus:not(.btn-active) .svg-icon, .btn.btn-dark:hover:not(.btn-active) i,\n.btn.btn-dark:hover:not(.btn-active) .svg-icon, .btn.btn-dark:active:not(.btn-active) i,\n.btn.btn-dark:active:not(.btn-active) .svg-icon, .btn.btn-dark.active i,\n.btn.btn-dark.active .svg-icon, .btn.btn-dark.show i,\n.btn.btn-dark.show .svg-icon, .show > .btn.btn-dark i,\n.show > .btn.btn-dark .svg-icon {\n  color: var(--kt-dark-inverse);\n}\n.btn-check:checked + .btn.btn-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-dark.dropdown-toggle:after, .btn.btn-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-dark.active.dropdown-toggle:after, .btn.btn-dark.show.dropdown-toggle:after, .show > .btn.btn-dark.dropdown-toggle:after {\n  color: var(--kt-dark-inverse);\n}\n\n.btn.btn-light-dark {\n  color: var(--kt-dark);\n  border-color: var(--kt-dark-light);\n  background-color: var(--kt-dark-light);\n}\n.btn.btn-light-dark i,\n.btn.btn-light-dark .svg-icon {\n  color: var(--kt-dark);\n}\n.btn.btn-light-dark.dropdown-toggle:after {\n  color: var(--kt-dark);\n}\n.btn-check:checked + .btn.btn-light-dark, .btn-check:active + .btn.btn-light-dark, .btn.btn-light-dark:focus:not(.btn-active), .btn.btn-light-dark:hover:not(.btn-active), .btn.btn-light-dark:active:not(.btn-active), .btn.btn-light-dark.active, .btn.btn-light-dark.show, .show > .btn.btn-light-dark {\n  color: var(--kt-dark-inverse);\n  border-color: var(--kt-dark);\n  background-color: var(--kt-dark) !important;\n}\n.btn-check:checked + .btn.btn-light-dark i,\n.btn-check:checked + .btn.btn-light-dark .svg-icon, .btn-check:active + .btn.btn-light-dark i,\n.btn-check:active + .btn.btn-light-dark .svg-icon, .btn.btn-light-dark:focus:not(.btn-active) i,\n.btn.btn-light-dark:focus:not(.btn-active) .svg-icon, .btn.btn-light-dark:hover:not(.btn-active) i,\n.btn.btn-light-dark:hover:not(.btn-active) .svg-icon, .btn.btn-light-dark:active:not(.btn-active) i,\n.btn.btn-light-dark:active:not(.btn-active) .svg-icon, .btn.btn-light-dark.active i,\n.btn.btn-light-dark.active .svg-icon, .btn.btn-light-dark.show i,\n.btn.btn-light-dark.show .svg-icon, .show > .btn.btn-light-dark i,\n.show > .btn.btn-light-dark .svg-icon {\n  color: var(--kt-dark-inverse);\n}\n.btn-check:checked + .btn.btn-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-light-dark.dropdown-toggle:after, .btn.btn-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-dark.active.dropdown-toggle:after, .btn.btn-light-dark.show.dropdown-toggle:after, .show > .btn.btn-light-dark.dropdown-toggle:after {\n  color: var(--kt-dark-inverse);\n}\n\n.btn.btn-bg-dark {\n  border-color: var(--kt-dark);\n  background-color: var(--kt-dark);\n}\n.btn-check:checked + .btn.btn-active-dark, .btn-check:active + .btn.btn-active-dark, .btn.btn-active-dark:focus:not(.btn-active), .btn.btn-active-dark:hover:not(.btn-active), .btn.btn-active-dark:active:not(.btn-active), .btn.btn-active-dark.active, .btn.btn-active-dark.show, .show > .btn.btn-active-dark {\n  color: var(--kt-dark-inverse);\n  border-color: var(--kt-dark);\n  background-color: var(--kt-dark) !important;\n}\n.btn-check:checked + .btn.btn-active-dark i,\n.btn-check:checked + .btn.btn-active-dark .svg-icon, .btn-check:active + .btn.btn-active-dark i,\n.btn-check:active + .btn.btn-active-dark .svg-icon, .btn.btn-active-dark:focus:not(.btn-active) i,\n.btn.btn-active-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-dark:hover:not(.btn-active) i,\n.btn.btn-active-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-dark:active:not(.btn-active) i,\n.btn.btn-active-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-dark.active i,\n.btn.btn-active-dark.active .svg-icon, .btn.btn-active-dark.show i,\n.btn.btn-active-dark.show .svg-icon, .show > .btn.btn-active-dark i,\n.show > .btn.btn-active-dark .svg-icon {\n  color: var(--kt-dark-inverse);\n}\n.btn-check:checked + .btn.btn-active-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-dark.dropdown-toggle:after, .btn.btn-active-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-dark.active.dropdown-toggle:after, .btn.btn-active-dark.show.dropdown-toggle:after, .show > .btn.btn-active-dark.dropdown-toggle:after {\n  color: var(--kt-dark-inverse);\n}\n\n.btn-check:checked + .btn.btn-active-light-dark, .btn-check:active + .btn.btn-active-light-dark, .btn.btn-active-light-dark:focus:not(.btn-active), .btn.btn-active-light-dark:hover:not(.btn-active), .btn.btn-active-light-dark:active:not(.btn-active), .btn.btn-active-light-dark.active, .btn.btn-active-light-dark.show, .show > .btn.btn-active-light-dark {\n  color: var(--kt-dark);\n  border-color: var(--kt-dark-light);\n  background-color: var(--kt-dark-light) !important;\n}\n.btn-check:checked + .btn.btn-active-light-dark i,\n.btn-check:checked + .btn.btn-active-light-dark .svg-icon, .btn-check:active + .btn.btn-active-light-dark i,\n.btn-check:active + .btn.btn-active-light-dark .svg-icon, .btn.btn-active-light-dark:focus:not(.btn-active) i,\n.btn.btn-active-light-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-light-dark:hover:not(.btn-active) i,\n.btn.btn-active-light-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-light-dark:active:not(.btn-active) i,\n.btn.btn-active-light-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-light-dark.active i,\n.btn.btn-active-light-dark.active .svg-icon, .btn.btn-active-light-dark.show i,\n.btn.btn-active-light-dark.show .svg-icon, .show > .btn.btn-active-light-dark i,\n.show > .btn.btn-active-light-dark .svg-icon {\n  color: var(--kt-dark);\n}\n.btn-check:checked + .btn.btn-active-light-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-light-dark.dropdown-toggle:after, .btn.btn-active-light-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-light-dark.active.dropdown-toggle:after, .btn.btn-active-light-dark.show.dropdown-toggle:after, .show > .btn.btn-active-light-dark.dropdown-toggle:after {\n  color: var(--kt-dark);\n}\n\n.btn.btn-outline.btn-outline-dark {\n  color: var(--kt-dark);\n  border-color: var(--kt-dark);\n  background-color: transparent;\n}\n.btn.btn-outline.btn-outline-dark i,\n.btn.btn-outline.btn-outline-dark .svg-icon {\n  color: var(--kt-dark);\n}\n.btn.btn-outline.btn-outline-dark.dropdown-toggle:after {\n  color: var(--kt-dark);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dark, .btn-check:active + .btn.btn-outline.btn-outline-dark, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active), .btn.btn-outline.btn-outline-dark:hover:not(.btn-active), .btn.btn-outline.btn-outline-dark:active:not(.btn-active), .btn.btn-outline.btn-outline-dark.active, .btn.btn-outline.btn-outline-dark.show, .show > .btn.btn-outline.btn-outline-dark {\n  color: var(--kt-dark-active);\n  border-color: var(--kt-dark);\n  background-color: var(--kt-dark-light) !important;\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dark i,\n.btn-check:checked + .btn.btn-outline.btn-outline-dark .svg-icon, .btn-check:active + .btn.btn-outline.btn-outline-dark i,\n.btn-check:active + .btn.btn-outline.btn-outline-dark .svg-icon, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active) i,\n.btn.btn-outline.btn-outline-dark:focus:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark:hover:not(.btn-active) i,\n.btn.btn-outline.btn-outline-dark:hover:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark:active:not(.btn-active) i,\n.btn.btn-outline.btn-outline-dark:active:not(.btn-active) .svg-icon, .btn.btn-outline.btn-outline-dark.active i,\n.btn.btn-outline.btn-outline-dark.active .svg-icon, .btn.btn-outline.btn-outline-dark.show i,\n.btn.btn-outline.btn-outline-dark.show .svg-icon, .show > .btn.btn-outline.btn-outline-dark i,\n.show > .btn.btn-outline.btn-outline-dark .svg-icon {\n  color: var(--kt-dark-active);\n}\n.btn-check:checked + .btn.btn-outline.btn-outline-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-outline.btn-outline-dark.dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-outline.btn-outline-dark.active.dropdown-toggle:after, .btn.btn-outline.btn-outline-dark.show.dropdown-toggle:after, .show > .btn.btn-outline.btn-outline-dark.dropdown-toggle:after {\n  color: var(--kt-dark-active);\n}\n\n.btn.btn-color-white {\n  color: var(--kt-text-white);\n}\n.btn.btn-color-white i,\n.btn.btn-color-white .svg-icon {\n  color: var(--kt-text-white);\n}\n.btn.btn-color-white.dropdown-toggle:after {\n  color: var(--kt-text-white);\n}\n.btn-check:checked + .btn.btn-active-color-white, .btn-check:active + .btn.btn-active-color-white, .btn.btn-active-color-white:focus:not(.btn-active), .btn.btn-active-color-white:hover:not(.btn-active), .btn.btn-active-color-white:active:not(.btn-active), .btn.btn-active-color-white.active, .btn.btn-active-color-white.show, .show > .btn.btn-active-color-white {\n  color: var(--kt-text-white);\n}\n.btn-check:checked + .btn.btn-active-color-white i,\n.btn-check:checked + .btn.btn-active-color-white .svg-icon, .btn-check:active + .btn.btn-active-color-white i,\n.btn-check:active + .btn.btn-active-color-white .svg-icon, .btn.btn-active-color-white:focus:not(.btn-active) i,\n.btn.btn-active-color-white:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-white:hover:not(.btn-active) i,\n.btn.btn-active-color-white:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-white:active:not(.btn-active) i,\n.btn.btn-active-color-white:active:not(.btn-active) .svg-icon, .btn.btn-active-color-white.active i,\n.btn.btn-active-color-white.active .svg-icon, .btn.btn-active-color-white.show i,\n.btn.btn-active-color-white.show .svg-icon, .show > .btn.btn-active-color-white i,\n.show > .btn.btn-active-color-white .svg-icon {\n  color: var(--kt-text-white);\n}\n.btn-check:checked + .btn.btn-active-color-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-white.dropdown-toggle:after, .btn.btn-active-color-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-white.active.dropdown-toggle:after, .btn.btn-active-color-white.show.dropdown-toggle:after, .show > .btn.btn-active-color-white.dropdown-toggle:after {\n  color: var(--kt-text-white);\n}\n\n.btn.btn-icon-white i,\n.btn.btn-icon-white .svg-icon {\n  color: var(--kt-text-white);\n}\n.btn.btn-icon-white.dropdown-toggle:after {\n  color: var(--kt-text-white);\n}\n.btn-check:checked + .btn.btn-active-icon-white i,\n.btn-check:checked + .btn.btn-active-icon-white .svg-icon, .btn-check:active + .btn.btn-active-icon-white i,\n.btn-check:active + .btn.btn-active-icon-white .svg-icon, .btn.btn-active-icon-white:focus:not(.btn-active) i,\n.btn.btn-active-icon-white:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-white:hover:not(.btn-active) i,\n.btn.btn-active-icon-white:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-white:active:not(.btn-active) i,\n.btn.btn-active-icon-white:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-white.active i,\n.btn.btn-active-icon-white.active .svg-icon, .btn.btn-active-icon-white.show i,\n.btn.btn-active-icon-white.show .svg-icon, .show > .btn.btn-active-icon-white i,\n.show > .btn.btn-active-icon-white .svg-icon {\n  color: var(--kt-text-white);\n}\n.btn-check:checked + .btn.btn-active-icon-white.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-white.dropdown-toggle:after, .btn.btn-active-icon-white:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-white.active.dropdown-toggle:after, .btn.btn-active-icon-white.show.dropdown-toggle:after, .show > .btn.btn-active-icon-white.dropdown-toggle:after {\n  color: var(--kt-text-white);\n}\n\n.btn.btn-text-white {\n  color: var(--kt-text-white);\n}\n.btn-check:checked + .btn.btn-active-text-white, .btn-check:active + .btn.btn-active-text-white, .btn.btn-active-text-white:focus:not(.btn-active), .btn.btn-active-text-white:hover:not(.btn-active), .btn.btn-active-text-white:active:not(.btn-active), .btn.btn-active-text-white.active, .btn.btn-active-text-white.show, .show > .btn.btn-active-text-white {\n  color: var(--kt-text-white);\n}\n\n.btn.btn-color-primary {\n  color: var(--kt-text-primary);\n}\n.btn.btn-color-primary i,\n.btn.btn-color-primary .svg-icon {\n  color: var(--kt-text-primary);\n}\n.btn.btn-color-primary.dropdown-toggle:after {\n  color: var(--kt-text-primary);\n}\n.btn-check:checked + .btn.btn-active-color-primary, .btn-check:active + .btn.btn-active-color-primary, .btn.btn-active-color-primary:focus:not(.btn-active), .btn.btn-active-color-primary:hover:not(.btn-active), .btn.btn-active-color-primary:active:not(.btn-active), .btn.btn-active-color-primary.active, .btn.btn-active-color-primary.show, .show > .btn.btn-active-color-primary {\n  color: var(--kt-text-primary);\n}\n.btn-check:checked + .btn.btn-active-color-primary i,\n.btn-check:checked + .btn.btn-active-color-primary .svg-icon, .btn-check:active + .btn.btn-active-color-primary i,\n.btn-check:active + .btn.btn-active-color-primary .svg-icon, .btn.btn-active-color-primary:focus:not(.btn-active) i,\n.btn.btn-active-color-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-primary:hover:not(.btn-active) i,\n.btn.btn-active-color-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-primary:active:not(.btn-active) i,\n.btn.btn-active-color-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-color-primary.active i,\n.btn.btn-active-color-primary.active .svg-icon, .btn.btn-active-color-primary.show i,\n.btn.btn-active-color-primary.show .svg-icon, .show > .btn.btn-active-color-primary i,\n.show > .btn.btn-active-color-primary .svg-icon {\n  color: var(--kt-text-primary);\n}\n.btn-check:checked + .btn.btn-active-color-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-primary.dropdown-toggle:after, .btn.btn-active-color-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-primary.active.dropdown-toggle:after, .btn.btn-active-color-primary.show.dropdown-toggle:after, .show > .btn.btn-active-color-primary.dropdown-toggle:after {\n  color: var(--kt-text-primary);\n}\n\n.btn.btn-icon-primary i,\n.btn.btn-icon-primary .svg-icon {\n  color: var(--kt-text-primary);\n}\n.btn.btn-icon-primary.dropdown-toggle:after {\n  color: var(--kt-text-primary);\n}\n.btn-check:checked + .btn.btn-active-icon-primary i,\n.btn-check:checked + .btn.btn-active-icon-primary .svg-icon, .btn-check:active + .btn.btn-active-icon-primary i,\n.btn-check:active + .btn.btn-active-icon-primary .svg-icon, .btn.btn-active-icon-primary:focus:not(.btn-active) i,\n.btn.btn-active-icon-primary:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary:hover:not(.btn-active) i,\n.btn.btn-active-icon-primary:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary:active:not(.btn-active) i,\n.btn.btn-active-icon-primary:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-primary.active i,\n.btn.btn-active-icon-primary.active .svg-icon, .btn.btn-active-icon-primary.show i,\n.btn.btn-active-icon-primary.show .svg-icon, .show > .btn.btn-active-icon-primary i,\n.show > .btn.btn-active-icon-primary .svg-icon {\n  color: var(--kt-text-primary);\n}\n.btn-check:checked + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-primary.dropdown-toggle:after, .btn.btn-active-icon-primary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-primary.active.dropdown-toggle:after, .btn.btn-active-icon-primary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-primary.dropdown-toggle:after {\n  color: var(--kt-text-primary);\n}\n\n.btn.btn-text-primary {\n  color: var(--kt-text-primary);\n}\n.btn-check:checked + .btn.btn-active-text-primary, .btn-check:active + .btn.btn-active-text-primary, .btn.btn-active-text-primary:focus:not(.btn-active), .btn.btn-active-text-primary:hover:not(.btn-active), .btn.btn-active-text-primary:active:not(.btn-active), .btn.btn-active-text-primary.active, .btn.btn-active-text-primary.show, .show > .btn.btn-active-text-primary {\n  color: var(--kt-text-primary);\n}\n\n.btn.btn-color-secondary {\n  color: var(--kt-text-secondary);\n}\n.btn.btn-color-secondary i,\n.btn.btn-color-secondary .svg-icon {\n  color: var(--kt-text-secondary);\n}\n.btn.btn-color-secondary.dropdown-toggle:after {\n  color: var(--kt-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-color-secondary, .btn-check:active + .btn.btn-active-color-secondary, .btn.btn-active-color-secondary:focus:not(.btn-active), .btn.btn-active-color-secondary:hover:not(.btn-active), .btn.btn-active-color-secondary:active:not(.btn-active), .btn.btn-active-color-secondary.active, .btn.btn-active-color-secondary.show, .show > .btn.btn-active-color-secondary {\n  color: var(--kt-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-color-secondary i,\n.btn-check:checked + .btn.btn-active-color-secondary .svg-icon, .btn-check:active + .btn.btn-active-color-secondary i,\n.btn-check:active + .btn.btn-active-color-secondary .svg-icon, .btn.btn-active-color-secondary:focus:not(.btn-active) i,\n.btn.btn-active-color-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary:hover:not(.btn-active) i,\n.btn.btn-active-color-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary:active:not(.btn-active) i,\n.btn.btn-active-color-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-color-secondary.active i,\n.btn.btn-active-color-secondary.active .svg-icon, .btn.btn-active-color-secondary.show i,\n.btn.btn-active-color-secondary.show .svg-icon, .show > .btn.btn-active-color-secondary i,\n.show > .btn.btn-active-color-secondary .svg-icon {\n  color: var(--kt-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-secondary.dropdown-toggle:after, .btn.btn-active-color-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-secondary.active.dropdown-toggle:after, .btn.btn-active-color-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-color-secondary.dropdown-toggle:after {\n  color: var(--kt-text-secondary);\n}\n\n.btn.btn-icon-secondary i,\n.btn.btn-icon-secondary .svg-icon {\n  color: var(--kt-text-secondary);\n}\n.btn.btn-icon-secondary.dropdown-toggle:after {\n  color: var(--kt-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-icon-secondary i,\n.btn-check:checked + .btn.btn-active-icon-secondary .svg-icon, .btn-check:active + .btn.btn-active-icon-secondary i,\n.btn-check:active + .btn.btn-active-icon-secondary .svg-icon, .btn.btn-active-icon-secondary:focus:not(.btn-active) i,\n.btn.btn-active-icon-secondary:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary:hover:not(.btn-active) i,\n.btn.btn-active-icon-secondary:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary:active:not(.btn-active) i,\n.btn.btn-active-icon-secondary:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-secondary.active i,\n.btn.btn-active-icon-secondary.active .svg-icon, .btn.btn-active-icon-secondary.show i,\n.btn.btn-active-icon-secondary.show .svg-icon, .show > .btn.btn-active-icon-secondary i,\n.show > .btn.btn-active-icon-secondary .svg-icon {\n  color: var(--kt-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-secondary.dropdown-toggle:after, .btn.btn-active-icon-secondary:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-secondary.active.dropdown-toggle:after, .btn.btn-active-icon-secondary.show.dropdown-toggle:after, .show > .btn.btn-active-icon-secondary.dropdown-toggle:after {\n  color: var(--kt-text-secondary);\n}\n\n.btn.btn-text-secondary {\n  color: var(--kt-text-secondary);\n}\n.btn-check:checked + .btn.btn-active-text-secondary, .btn-check:active + .btn.btn-active-text-secondary, .btn.btn-active-text-secondary:focus:not(.btn-active), .btn.btn-active-text-secondary:hover:not(.btn-active), .btn.btn-active-text-secondary:active:not(.btn-active), .btn.btn-active-text-secondary.active, .btn.btn-active-text-secondary.show, .show > .btn.btn-active-text-secondary {\n  color: var(--kt-text-secondary);\n}\n\n.btn.btn-color-light {\n  color: var(--kt-text-light);\n}\n.btn.btn-color-light i,\n.btn.btn-color-light .svg-icon {\n  color: var(--kt-text-light);\n}\n.btn.btn-color-light.dropdown-toggle:after {\n  color: var(--kt-text-light);\n}\n.btn-check:checked + .btn.btn-active-color-light, .btn-check:active + .btn.btn-active-color-light, .btn.btn-active-color-light:focus:not(.btn-active), .btn.btn-active-color-light:hover:not(.btn-active), .btn.btn-active-color-light:active:not(.btn-active), .btn.btn-active-color-light.active, .btn.btn-active-color-light.show, .show > .btn.btn-active-color-light {\n  color: var(--kt-text-light);\n}\n.btn-check:checked + .btn.btn-active-color-light i,\n.btn-check:checked + .btn.btn-active-color-light .svg-icon, .btn-check:active + .btn.btn-active-color-light i,\n.btn-check:active + .btn.btn-active-color-light .svg-icon, .btn.btn-active-color-light:focus:not(.btn-active) i,\n.btn.btn-active-color-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-light:hover:not(.btn-active) i,\n.btn.btn-active-color-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-light:active:not(.btn-active) i,\n.btn.btn-active-color-light:active:not(.btn-active) .svg-icon, .btn.btn-active-color-light.active i,\n.btn.btn-active-color-light.active .svg-icon, .btn.btn-active-color-light.show i,\n.btn.btn-active-color-light.show .svg-icon, .show > .btn.btn-active-color-light i,\n.show > .btn.btn-active-color-light .svg-icon {\n  color: var(--kt-text-light);\n}\n.btn-check:checked + .btn.btn-active-color-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-light.dropdown-toggle:after, .btn.btn-active-color-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-light.active.dropdown-toggle:after, .btn.btn-active-color-light.show.dropdown-toggle:after, .show > .btn.btn-active-color-light.dropdown-toggle:after {\n  color: var(--kt-text-light);\n}\n\n.btn.btn-icon-light i,\n.btn.btn-icon-light .svg-icon {\n  color: var(--kt-text-light);\n}\n.btn.btn-icon-light.dropdown-toggle:after {\n  color: var(--kt-text-light);\n}\n.btn-check:checked + .btn.btn-active-icon-light i,\n.btn-check:checked + .btn.btn-active-icon-light .svg-icon, .btn-check:active + .btn.btn-active-icon-light i,\n.btn-check:active + .btn.btn-active-icon-light .svg-icon, .btn.btn-active-icon-light:focus:not(.btn-active) i,\n.btn.btn-active-icon-light:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-light:hover:not(.btn-active) i,\n.btn.btn-active-icon-light:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-light:active:not(.btn-active) i,\n.btn.btn-active-icon-light:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-light.active i,\n.btn.btn-active-icon-light.active .svg-icon, .btn.btn-active-icon-light.show i,\n.btn.btn-active-icon-light.show .svg-icon, .show > .btn.btn-active-icon-light i,\n.show > .btn.btn-active-icon-light .svg-icon {\n  color: var(--kt-text-light);\n}\n.btn-check:checked + .btn.btn-active-icon-light.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-light.dropdown-toggle:after, .btn.btn-active-icon-light:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-light.active.dropdown-toggle:after, .btn.btn-active-icon-light.show.dropdown-toggle:after, .show > .btn.btn-active-icon-light.dropdown-toggle:after {\n  color: var(--kt-text-light);\n}\n\n.btn.btn-text-light {\n  color: var(--kt-text-light);\n}\n.btn-check:checked + .btn.btn-active-text-light, .btn-check:active + .btn.btn-active-text-light, .btn.btn-active-text-light:focus:not(.btn-active), .btn.btn-active-text-light:hover:not(.btn-active), .btn.btn-active-text-light:active:not(.btn-active), .btn.btn-active-text-light.active, .btn.btn-active-text-light.show, .show > .btn.btn-active-text-light {\n  color: var(--kt-text-light);\n}\n\n.btn.btn-color-success {\n  color: var(--kt-text-success);\n}\n.btn.btn-color-success i,\n.btn.btn-color-success .svg-icon {\n  color: var(--kt-text-success);\n}\n.btn.btn-color-success.dropdown-toggle:after {\n  color: var(--kt-text-success);\n}\n.btn-check:checked + .btn.btn-active-color-success, .btn-check:active + .btn.btn-active-color-success, .btn.btn-active-color-success:focus:not(.btn-active), .btn.btn-active-color-success:hover:not(.btn-active), .btn.btn-active-color-success:active:not(.btn-active), .btn.btn-active-color-success.active, .btn.btn-active-color-success.show, .show > .btn.btn-active-color-success {\n  color: var(--kt-text-success);\n}\n.btn-check:checked + .btn.btn-active-color-success i,\n.btn-check:checked + .btn.btn-active-color-success .svg-icon, .btn-check:active + .btn.btn-active-color-success i,\n.btn-check:active + .btn.btn-active-color-success .svg-icon, .btn.btn-active-color-success:focus:not(.btn-active) i,\n.btn.btn-active-color-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-success:hover:not(.btn-active) i,\n.btn.btn-active-color-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-success:active:not(.btn-active) i,\n.btn.btn-active-color-success:active:not(.btn-active) .svg-icon, .btn.btn-active-color-success.active i,\n.btn.btn-active-color-success.active .svg-icon, .btn.btn-active-color-success.show i,\n.btn.btn-active-color-success.show .svg-icon, .show > .btn.btn-active-color-success i,\n.show > .btn.btn-active-color-success .svg-icon {\n  color: var(--kt-text-success);\n}\n.btn-check:checked + .btn.btn-active-color-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-success.dropdown-toggle:after, .btn.btn-active-color-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-success.active.dropdown-toggle:after, .btn.btn-active-color-success.show.dropdown-toggle:after, .show > .btn.btn-active-color-success.dropdown-toggle:after {\n  color: var(--kt-text-success);\n}\n\n.btn.btn-icon-success i,\n.btn.btn-icon-success .svg-icon {\n  color: var(--kt-text-success);\n}\n.btn.btn-icon-success.dropdown-toggle:after {\n  color: var(--kt-text-success);\n}\n.btn-check:checked + .btn.btn-active-icon-success i,\n.btn-check:checked + .btn.btn-active-icon-success .svg-icon, .btn-check:active + .btn.btn-active-icon-success i,\n.btn-check:active + .btn.btn-active-icon-success .svg-icon, .btn.btn-active-icon-success:focus:not(.btn-active) i,\n.btn.btn-active-icon-success:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-success:hover:not(.btn-active) i,\n.btn.btn-active-icon-success:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-success:active:not(.btn-active) i,\n.btn.btn-active-icon-success:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-success.active i,\n.btn.btn-active-icon-success.active .svg-icon, .btn.btn-active-icon-success.show i,\n.btn.btn-active-icon-success.show .svg-icon, .show > .btn.btn-active-icon-success i,\n.show > .btn.btn-active-icon-success .svg-icon {\n  color: var(--kt-text-success);\n}\n.btn-check:checked + .btn.btn-active-icon-success.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-success.dropdown-toggle:after, .btn.btn-active-icon-success:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-success.active.dropdown-toggle:after, .btn.btn-active-icon-success.show.dropdown-toggle:after, .show > .btn.btn-active-icon-success.dropdown-toggle:after {\n  color: var(--kt-text-success);\n}\n\n.btn.btn-text-success {\n  color: var(--kt-text-success);\n}\n.btn-check:checked + .btn.btn-active-text-success, .btn-check:active + .btn.btn-active-text-success, .btn.btn-active-text-success:focus:not(.btn-active), .btn.btn-active-text-success:hover:not(.btn-active), .btn.btn-active-text-success:active:not(.btn-active), .btn.btn-active-text-success.active, .btn.btn-active-text-success.show, .show > .btn.btn-active-text-success {\n  color: var(--kt-text-success);\n}\n\n.btn.btn-color-info {\n  color: var(--kt-text-info);\n}\n.btn.btn-color-info i,\n.btn.btn-color-info .svg-icon {\n  color: var(--kt-text-info);\n}\n.btn.btn-color-info.dropdown-toggle:after {\n  color: var(--kt-text-info);\n}\n.btn-check:checked + .btn.btn-active-color-info, .btn-check:active + .btn.btn-active-color-info, .btn.btn-active-color-info:focus:not(.btn-active), .btn.btn-active-color-info:hover:not(.btn-active), .btn.btn-active-color-info:active:not(.btn-active), .btn.btn-active-color-info.active, .btn.btn-active-color-info.show, .show > .btn.btn-active-color-info {\n  color: var(--kt-text-info);\n}\n.btn-check:checked + .btn.btn-active-color-info i,\n.btn-check:checked + .btn.btn-active-color-info .svg-icon, .btn-check:active + .btn.btn-active-color-info i,\n.btn-check:active + .btn.btn-active-color-info .svg-icon, .btn.btn-active-color-info:focus:not(.btn-active) i,\n.btn.btn-active-color-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-info:hover:not(.btn-active) i,\n.btn.btn-active-color-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-info:active:not(.btn-active) i,\n.btn.btn-active-color-info:active:not(.btn-active) .svg-icon, .btn.btn-active-color-info.active i,\n.btn.btn-active-color-info.active .svg-icon, .btn.btn-active-color-info.show i,\n.btn.btn-active-color-info.show .svg-icon, .show > .btn.btn-active-color-info i,\n.show > .btn.btn-active-color-info .svg-icon {\n  color: var(--kt-text-info);\n}\n.btn-check:checked + .btn.btn-active-color-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-info.dropdown-toggle:after, .btn.btn-active-color-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-info.active.dropdown-toggle:after, .btn.btn-active-color-info.show.dropdown-toggle:after, .show > .btn.btn-active-color-info.dropdown-toggle:after {\n  color: var(--kt-text-info);\n}\n\n.btn.btn-icon-info i,\n.btn.btn-icon-info .svg-icon {\n  color: var(--kt-text-info);\n}\n.btn.btn-icon-info.dropdown-toggle:after {\n  color: var(--kt-text-info);\n}\n.btn-check:checked + .btn.btn-active-icon-info i,\n.btn-check:checked + .btn.btn-active-icon-info .svg-icon, .btn-check:active + .btn.btn-active-icon-info i,\n.btn-check:active + .btn.btn-active-icon-info .svg-icon, .btn.btn-active-icon-info:focus:not(.btn-active) i,\n.btn.btn-active-icon-info:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-info:hover:not(.btn-active) i,\n.btn.btn-active-icon-info:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-info:active:not(.btn-active) i,\n.btn.btn-active-icon-info:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-info.active i,\n.btn.btn-active-icon-info.active .svg-icon, .btn.btn-active-icon-info.show i,\n.btn.btn-active-icon-info.show .svg-icon, .show > .btn.btn-active-icon-info i,\n.show > .btn.btn-active-icon-info .svg-icon {\n  color: var(--kt-text-info);\n}\n.btn-check:checked + .btn.btn-active-icon-info.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-info.dropdown-toggle:after, .btn.btn-active-icon-info:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-info.active.dropdown-toggle:after, .btn.btn-active-icon-info.show.dropdown-toggle:after, .show > .btn.btn-active-icon-info.dropdown-toggle:after {\n  color: var(--kt-text-info);\n}\n\n.btn.btn-text-info {\n  color: var(--kt-text-info);\n}\n.btn-check:checked + .btn.btn-active-text-info, .btn-check:active + .btn.btn-active-text-info, .btn.btn-active-text-info:focus:not(.btn-active), .btn.btn-active-text-info:hover:not(.btn-active), .btn.btn-active-text-info:active:not(.btn-active), .btn.btn-active-text-info.active, .btn.btn-active-text-info.show, .show > .btn.btn-active-text-info {\n  color: var(--kt-text-info);\n}\n\n.btn.btn-color-warning {\n  color: var(--kt-text-warning);\n}\n.btn.btn-color-warning i,\n.btn.btn-color-warning .svg-icon {\n  color: var(--kt-text-warning);\n}\n.btn.btn-color-warning.dropdown-toggle:after {\n  color: var(--kt-text-warning);\n}\n.btn-check:checked + .btn.btn-active-color-warning, .btn-check:active + .btn.btn-active-color-warning, .btn.btn-active-color-warning:focus:not(.btn-active), .btn.btn-active-color-warning:hover:not(.btn-active), .btn.btn-active-color-warning:active:not(.btn-active), .btn.btn-active-color-warning.active, .btn.btn-active-color-warning.show, .show > .btn.btn-active-color-warning {\n  color: var(--kt-text-warning);\n}\n.btn-check:checked + .btn.btn-active-color-warning i,\n.btn-check:checked + .btn.btn-active-color-warning .svg-icon, .btn-check:active + .btn.btn-active-color-warning i,\n.btn-check:active + .btn.btn-active-color-warning .svg-icon, .btn.btn-active-color-warning:focus:not(.btn-active) i,\n.btn.btn-active-color-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-warning:hover:not(.btn-active) i,\n.btn.btn-active-color-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-warning:active:not(.btn-active) i,\n.btn.btn-active-color-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-color-warning.active i,\n.btn.btn-active-color-warning.active .svg-icon, .btn.btn-active-color-warning.show i,\n.btn.btn-active-color-warning.show .svg-icon, .show > .btn.btn-active-color-warning i,\n.show > .btn.btn-active-color-warning .svg-icon {\n  color: var(--kt-text-warning);\n}\n.btn-check:checked + .btn.btn-active-color-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-warning.dropdown-toggle:after, .btn.btn-active-color-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-warning.active.dropdown-toggle:after, .btn.btn-active-color-warning.show.dropdown-toggle:after, .show > .btn.btn-active-color-warning.dropdown-toggle:after {\n  color: var(--kt-text-warning);\n}\n\n.btn.btn-icon-warning i,\n.btn.btn-icon-warning .svg-icon {\n  color: var(--kt-text-warning);\n}\n.btn.btn-icon-warning.dropdown-toggle:after {\n  color: var(--kt-text-warning);\n}\n.btn-check:checked + .btn.btn-active-icon-warning i,\n.btn-check:checked + .btn.btn-active-icon-warning .svg-icon, .btn-check:active + .btn.btn-active-icon-warning i,\n.btn-check:active + .btn.btn-active-icon-warning .svg-icon, .btn.btn-active-icon-warning:focus:not(.btn-active) i,\n.btn.btn-active-icon-warning:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning:hover:not(.btn-active) i,\n.btn.btn-active-icon-warning:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning:active:not(.btn-active) i,\n.btn.btn-active-icon-warning:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-warning.active i,\n.btn.btn-active-icon-warning.active .svg-icon, .btn.btn-active-icon-warning.show i,\n.btn.btn-active-icon-warning.show .svg-icon, .show > .btn.btn-active-icon-warning i,\n.show > .btn.btn-active-icon-warning .svg-icon {\n  color: var(--kt-text-warning);\n}\n.btn-check:checked + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-warning.dropdown-toggle:after, .btn.btn-active-icon-warning:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-warning.active.dropdown-toggle:after, .btn.btn-active-icon-warning.show.dropdown-toggle:after, .show > .btn.btn-active-icon-warning.dropdown-toggle:after {\n  color: var(--kt-text-warning);\n}\n\n.btn.btn-text-warning {\n  color: var(--kt-text-warning);\n}\n.btn-check:checked + .btn.btn-active-text-warning, .btn-check:active + .btn.btn-active-text-warning, .btn.btn-active-text-warning:focus:not(.btn-active), .btn.btn-active-text-warning:hover:not(.btn-active), .btn.btn-active-text-warning:active:not(.btn-active), .btn.btn-active-text-warning.active, .btn.btn-active-text-warning.show, .show > .btn.btn-active-text-warning {\n  color: var(--kt-text-warning);\n}\n\n.btn.btn-color-danger {\n  color: var(--kt-text-danger);\n}\n.btn.btn-color-danger i,\n.btn.btn-color-danger .svg-icon {\n  color: var(--kt-text-danger);\n}\n.btn.btn-color-danger.dropdown-toggle:after {\n  color: var(--kt-text-danger);\n}\n.btn-check:checked + .btn.btn-active-color-danger, .btn-check:active + .btn.btn-active-color-danger, .btn.btn-active-color-danger:focus:not(.btn-active), .btn.btn-active-color-danger:hover:not(.btn-active), .btn.btn-active-color-danger:active:not(.btn-active), .btn.btn-active-color-danger.active, .btn.btn-active-color-danger.show, .show > .btn.btn-active-color-danger {\n  color: var(--kt-text-danger);\n}\n.btn-check:checked + .btn.btn-active-color-danger i,\n.btn-check:checked + .btn.btn-active-color-danger .svg-icon, .btn-check:active + .btn.btn-active-color-danger i,\n.btn-check:active + .btn.btn-active-color-danger .svg-icon, .btn.btn-active-color-danger:focus:not(.btn-active) i,\n.btn.btn-active-color-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-danger:hover:not(.btn-active) i,\n.btn.btn-active-color-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-danger:active:not(.btn-active) i,\n.btn.btn-active-color-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-color-danger.active i,\n.btn.btn-active-color-danger.active .svg-icon, .btn.btn-active-color-danger.show i,\n.btn.btn-active-color-danger.show .svg-icon, .show > .btn.btn-active-color-danger i,\n.show > .btn.btn-active-color-danger .svg-icon {\n  color: var(--kt-text-danger);\n}\n.btn-check:checked + .btn.btn-active-color-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-danger.dropdown-toggle:after, .btn.btn-active-color-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-danger.active.dropdown-toggle:after, .btn.btn-active-color-danger.show.dropdown-toggle:after, .show > .btn.btn-active-color-danger.dropdown-toggle:after {\n  color: var(--kt-text-danger);\n}\n\n.btn.btn-icon-danger i,\n.btn.btn-icon-danger .svg-icon {\n  color: var(--kt-text-danger);\n}\n.btn.btn-icon-danger.dropdown-toggle:after {\n  color: var(--kt-text-danger);\n}\n.btn-check:checked + .btn.btn-active-icon-danger i,\n.btn-check:checked + .btn.btn-active-icon-danger .svg-icon, .btn-check:active + .btn.btn-active-icon-danger i,\n.btn-check:active + .btn.btn-active-icon-danger .svg-icon, .btn.btn-active-icon-danger:focus:not(.btn-active) i,\n.btn.btn-active-icon-danger:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger:hover:not(.btn-active) i,\n.btn.btn-active-icon-danger:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger:active:not(.btn-active) i,\n.btn.btn-active-icon-danger:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-danger.active i,\n.btn.btn-active-icon-danger.active .svg-icon, .btn.btn-active-icon-danger.show i,\n.btn.btn-active-icon-danger.show .svg-icon, .show > .btn.btn-active-icon-danger i,\n.show > .btn.btn-active-icon-danger .svg-icon {\n  color: var(--kt-text-danger);\n}\n.btn-check:checked + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-danger.dropdown-toggle:after, .btn.btn-active-icon-danger:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-danger.active.dropdown-toggle:after, .btn.btn-active-icon-danger.show.dropdown-toggle:after, .show > .btn.btn-active-icon-danger.dropdown-toggle:after {\n  color: var(--kt-text-danger);\n}\n\n.btn.btn-text-danger {\n  color: var(--kt-text-danger);\n}\n.btn-check:checked + .btn.btn-active-text-danger, .btn-check:active + .btn.btn-active-text-danger, .btn.btn-active-text-danger:focus:not(.btn-active), .btn.btn-active-text-danger:hover:not(.btn-active), .btn.btn-active-text-danger:active:not(.btn-active), .btn.btn-active-text-danger.active, .btn.btn-active-text-danger.show, .show > .btn.btn-active-text-danger {\n  color: var(--kt-text-danger);\n}\n\n.btn.btn-color-dark {\n  color: var(--kt-text-dark);\n}\n.btn.btn-color-dark i,\n.btn.btn-color-dark .svg-icon {\n  color: var(--kt-text-dark);\n}\n.btn.btn-color-dark.dropdown-toggle:after {\n  color: var(--kt-text-dark);\n}\n.btn-check:checked + .btn.btn-active-color-dark, .btn-check:active + .btn.btn-active-color-dark, .btn.btn-active-color-dark:focus:not(.btn-active), .btn.btn-active-color-dark:hover:not(.btn-active), .btn.btn-active-color-dark:active:not(.btn-active), .btn.btn-active-color-dark.active, .btn.btn-active-color-dark.show, .show > .btn.btn-active-color-dark {\n  color: var(--kt-text-dark);\n}\n.btn-check:checked + .btn.btn-active-color-dark i,\n.btn-check:checked + .btn.btn-active-color-dark .svg-icon, .btn-check:active + .btn.btn-active-color-dark i,\n.btn-check:active + .btn.btn-active-color-dark .svg-icon, .btn.btn-active-color-dark:focus:not(.btn-active) i,\n.btn.btn-active-color-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-dark:hover:not(.btn-active) i,\n.btn.btn-active-color-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-dark:active:not(.btn-active) i,\n.btn.btn-active-color-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-color-dark.active i,\n.btn.btn-active-color-dark.active .svg-icon, .btn.btn-active-color-dark.show i,\n.btn.btn-active-color-dark.show .svg-icon, .show > .btn.btn-active-color-dark i,\n.show > .btn.btn-active-color-dark .svg-icon {\n  color: var(--kt-text-dark);\n}\n.btn-check:checked + .btn.btn-active-color-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-dark.dropdown-toggle:after, .btn.btn-active-color-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-dark.active.dropdown-toggle:after, .btn.btn-active-color-dark.show.dropdown-toggle:after, .show > .btn.btn-active-color-dark.dropdown-toggle:after {\n  color: var(--kt-text-dark);\n}\n\n.btn.btn-icon-dark i,\n.btn.btn-icon-dark .svg-icon {\n  color: var(--kt-text-dark);\n}\n.btn.btn-icon-dark.dropdown-toggle:after {\n  color: var(--kt-text-dark);\n}\n.btn-check:checked + .btn.btn-active-icon-dark i,\n.btn-check:checked + .btn.btn-active-icon-dark .svg-icon, .btn-check:active + .btn.btn-active-icon-dark i,\n.btn-check:active + .btn.btn-active-icon-dark .svg-icon, .btn.btn-active-icon-dark:focus:not(.btn-active) i,\n.btn.btn-active-icon-dark:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark:hover:not(.btn-active) i,\n.btn.btn-active-icon-dark:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark:active:not(.btn-active) i,\n.btn.btn-active-icon-dark:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-dark.active i,\n.btn.btn-active-icon-dark.active .svg-icon, .btn.btn-active-icon-dark.show i,\n.btn.btn-active-icon-dark.show .svg-icon, .show > .btn.btn-active-icon-dark i,\n.show > .btn.btn-active-icon-dark .svg-icon {\n  color: var(--kt-text-dark);\n}\n.btn-check:checked + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-dark.dropdown-toggle:after, .btn.btn-active-icon-dark:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-dark.active.dropdown-toggle:after, .btn.btn-active-icon-dark.show.dropdown-toggle:after, .show > .btn.btn-active-icon-dark.dropdown-toggle:after {\n  color: var(--kt-text-dark);\n}\n\n.btn.btn-text-dark {\n  color: var(--kt-text-dark);\n}\n.btn-check:checked + .btn.btn-active-text-dark, .btn-check:active + .btn.btn-active-text-dark, .btn.btn-active-text-dark:focus:not(.btn-active), .btn.btn-active-text-dark:hover:not(.btn-active), .btn.btn-active-text-dark:active:not(.btn-active), .btn.btn-active-text-dark.active, .btn.btn-active-text-dark.show, .show > .btn.btn-active-text-dark {\n  color: var(--kt-text-dark);\n}\n\n.btn.btn-color-muted {\n  color: var(--kt-text-muted);\n}\n.btn.btn-color-muted i,\n.btn.btn-color-muted .svg-icon {\n  color: var(--kt-text-muted);\n}\n.btn.btn-color-muted.dropdown-toggle:after {\n  color: var(--kt-text-muted);\n}\n.btn-check:checked + .btn.btn-active-color-muted, .btn-check:active + .btn.btn-active-color-muted, .btn.btn-active-color-muted:focus:not(.btn-active), .btn.btn-active-color-muted:hover:not(.btn-active), .btn.btn-active-color-muted:active:not(.btn-active), .btn.btn-active-color-muted.active, .btn.btn-active-color-muted.show, .show > .btn.btn-active-color-muted {\n  color: var(--kt-text-muted);\n}\n.btn-check:checked + .btn.btn-active-color-muted i,\n.btn-check:checked + .btn.btn-active-color-muted .svg-icon, .btn-check:active + .btn.btn-active-color-muted i,\n.btn-check:active + .btn.btn-active-color-muted .svg-icon, .btn.btn-active-color-muted:focus:not(.btn-active) i,\n.btn.btn-active-color-muted:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-muted:hover:not(.btn-active) i,\n.btn.btn-active-color-muted:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-muted:active:not(.btn-active) i,\n.btn.btn-active-color-muted:active:not(.btn-active) .svg-icon, .btn.btn-active-color-muted.active i,\n.btn.btn-active-color-muted.active .svg-icon, .btn.btn-active-color-muted.show i,\n.btn.btn-active-color-muted.show .svg-icon, .show > .btn.btn-active-color-muted i,\n.show > .btn.btn-active-color-muted .svg-icon {\n  color: var(--kt-text-muted);\n}\n.btn-check:checked + .btn.btn-active-color-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-muted.dropdown-toggle:after, .btn.btn-active-color-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-muted.active.dropdown-toggle:after, .btn.btn-active-color-muted.show.dropdown-toggle:after, .show > .btn.btn-active-color-muted.dropdown-toggle:after {\n  color: var(--kt-text-muted);\n}\n\n.btn.btn-icon-muted i,\n.btn.btn-icon-muted .svg-icon {\n  color: var(--kt-text-muted);\n}\n.btn.btn-icon-muted.dropdown-toggle:after {\n  color: var(--kt-text-muted);\n}\n.btn-check:checked + .btn.btn-active-icon-muted i,\n.btn-check:checked + .btn.btn-active-icon-muted .svg-icon, .btn-check:active + .btn.btn-active-icon-muted i,\n.btn-check:active + .btn.btn-active-icon-muted .svg-icon, .btn.btn-active-icon-muted:focus:not(.btn-active) i,\n.btn.btn-active-icon-muted:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted:hover:not(.btn-active) i,\n.btn.btn-active-icon-muted:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted:active:not(.btn-active) i,\n.btn.btn-active-icon-muted:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-muted.active i,\n.btn.btn-active-icon-muted.active .svg-icon, .btn.btn-active-icon-muted.show i,\n.btn.btn-active-icon-muted.show .svg-icon, .show > .btn.btn-active-icon-muted i,\n.show > .btn.btn-active-icon-muted .svg-icon {\n  color: var(--kt-text-muted);\n}\n.btn-check:checked + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-muted.dropdown-toggle:after, .btn.btn-active-icon-muted:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-muted.active.dropdown-toggle:after, .btn.btn-active-icon-muted.show.dropdown-toggle:after, .show > .btn.btn-active-icon-muted.dropdown-toggle:after {\n  color: var(--kt-text-muted);\n}\n\n.btn.btn-text-muted {\n  color: var(--kt-text-muted);\n}\n.btn-check:checked + .btn.btn-active-text-muted, .btn-check:active + .btn.btn-active-text-muted, .btn.btn-active-text-muted:focus:not(.btn-active), .btn.btn-active-text-muted:hover:not(.btn-active), .btn.btn-active-text-muted:active:not(.btn-active), .btn.btn-active-text-muted.active, .btn.btn-active-text-muted.show, .show > .btn.btn-active-text-muted {\n  color: var(--kt-text-muted);\n}\n\n.btn.btn-color-gray-100 {\n  color: var(--kt-text-gray-100);\n}\n.btn.btn-color-gray-100 i,\n.btn.btn-color-gray-100 .svg-icon {\n  color: var(--kt-text-gray-100);\n}\n.btn.btn-color-gray-100.dropdown-toggle:after {\n  color: var(--kt-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-color-gray-100, .btn-check:active + .btn.btn-active-color-gray-100, .btn.btn-active-color-gray-100:focus:not(.btn-active), .btn.btn-active-color-gray-100:hover:not(.btn-active), .btn.btn-active-color-gray-100:active:not(.btn-active), .btn.btn-active-color-gray-100.active, .btn.btn-active-color-gray-100.show, .show > .btn.btn-active-color-gray-100 {\n  color: var(--kt-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-color-gray-100 i,\n.btn-check:checked + .btn.btn-active-color-gray-100 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-100 i,\n.btn-check:active + .btn.btn-active-color-gray-100 .svg-icon, .btn.btn-active-color-gray-100:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-100:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-100:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100:active:not(.btn-active) i,\n.btn.btn-active-color-gray-100:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-100.active i,\n.btn.btn-active-color-gray-100.active .svg-icon, .btn.btn-active-color-gray-100.show i,\n.btn.btn-active-color-gray-100.show .svg-icon, .show > .btn.btn-active-color-gray-100 i,\n.show > .btn.btn-active-color-gray-100 .svg-icon {\n  color: var(--kt-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-100.dropdown-toggle:after, .btn.btn-active-color-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-100.active.dropdown-toggle:after, .btn.btn-active-color-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-100.dropdown-toggle:after {\n  color: var(--kt-text-gray-100);\n}\n\n.btn.btn-icon-gray-100 i,\n.btn.btn-icon-gray-100 .svg-icon {\n  color: var(--kt-text-gray-100);\n}\n.btn.btn-icon-gray-100.dropdown-toggle:after {\n  color: var(--kt-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-100 i,\n.btn-check:checked + .btn.btn-active-icon-gray-100 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-100 i,\n.btn-check:active + .btn.btn-active-icon-gray-100 .svg-icon, .btn.btn-active-icon-gray-100:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-100:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-100:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-100:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-100.active i,\n.btn.btn-active-icon-gray-100.active .svg-icon, .btn.btn-active-icon-gray-100.show i,\n.btn.btn-active-icon-gray-100.show .svg-icon, .show > .btn.btn-active-icon-gray-100 i,\n.show > .btn.btn-active-icon-gray-100 .svg-icon {\n  color: var(--kt-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-100.dropdown-toggle:after, .btn.btn-active-icon-gray-100:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-100.active.dropdown-toggle:after, .btn.btn-active-icon-gray-100.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-100.dropdown-toggle:after {\n  color: var(--kt-text-gray-100);\n}\n\n.btn.btn-text-gray-100 {\n  color: var(--kt-text-gray-100);\n}\n.btn-check:checked + .btn.btn-active-text-gray-100, .btn-check:active + .btn.btn-active-text-gray-100, .btn.btn-active-text-gray-100:focus:not(.btn-active), .btn.btn-active-text-gray-100:hover:not(.btn-active), .btn.btn-active-text-gray-100:active:not(.btn-active), .btn.btn-active-text-gray-100.active, .btn.btn-active-text-gray-100.show, .show > .btn.btn-active-text-gray-100 {\n  color: var(--kt-text-gray-100);\n}\n\n.btn.btn-color-gray-200 {\n  color: var(--kt-text-gray-200);\n}\n.btn.btn-color-gray-200 i,\n.btn.btn-color-gray-200 .svg-icon {\n  color: var(--kt-text-gray-200);\n}\n.btn.btn-color-gray-200.dropdown-toggle:after {\n  color: var(--kt-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-color-gray-200, .btn-check:active + .btn.btn-active-color-gray-200, .btn.btn-active-color-gray-200:focus:not(.btn-active), .btn.btn-active-color-gray-200:hover:not(.btn-active), .btn.btn-active-color-gray-200:active:not(.btn-active), .btn.btn-active-color-gray-200.active, .btn.btn-active-color-gray-200.show, .show > .btn.btn-active-color-gray-200 {\n  color: var(--kt-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-color-gray-200 i,\n.btn-check:checked + .btn.btn-active-color-gray-200 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-200 i,\n.btn-check:active + .btn.btn-active-color-gray-200 .svg-icon, .btn.btn-active-color-gray-200:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-200:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-200:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200:active:not(.btn-active) i,\n.btn.btn-active-color-gray-200:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-200.active i,\n.btn.btn-active-color-gray-200.active .svg-icon, .btn.btn-active-color-gray-200.show i,\n.btn.btn-active-color-gray-200.show .svg-icon, .show > .btn.btn-active-color-gray-200 i,\n.show > .btn.btn-active-color-gray-200 .svg-icon {\n  color: var(--kt-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-200.dropdown-toggle:after, .btn.btn-active-color-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-200.active.dropdown-toggle:after, .btn.btn-active-color-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-200.dropdown-toggle:after {\n  color: var(--kt-text-gray-200);\n}\n\n.btn.btn-icon-gray-200 i,\n.btn.btn-icon-gray-200 .svg-icon {\n  color: var(--kt-text-gray-200);\n}\n.btn.btn-icon-gray-200.dropdown-toggle:after {\n  color: var(--kt-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-200 i,\n.btn-check:checked + .btn.btn-active-icon-gray-200 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-200 i,\n.btn-check:active + .btn.btn-active-icon-gray-200 .svg-icon, .btn.btn-active-icon-gray-200:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-200:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-200:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-200:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-200.active i,\n.btn.btn-active-icon-gray-200.active .svg-icon, .btn.btn-active-icon-gray-200.show i,\n.btn.btn-active-icon-gray-200.show .svg-icon, .show > .btn.btn-active-icon-gray-200 i,\n.show > .btn.btn-active-icon-gray-200 .svg-icon {\n  color: var(--kt-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-200.dropdown-toggle:after, .btn.btn-active-icon-gray-200:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-200.active.dropdown-toggle:after, .btn.btn-active-icon-gray-200.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-200.dropdown-toggle:after {\n  color: var(--kt-text-gray-200);\n}\n\n.btn.btn-text-gray-200 {\n  color: var(--kt-text-gray-200);\n}\n.btn-check:checked + .btn.btn-active-text-gray-200, .btn-check:active + .btn.btn-active-text-gray-200, .btn.btn-active-text-gray-200:focus:not(.btn-active), .btn.btn-active-text-gray-200:hover:not(.btn-active), .btn.btn-active-text-gray-200:active:not(.btn-active), .btn.btn-active-text-gray-200.active, .btn.btn-active-text-gray-200.show, .show > .btn.btn-active-text-gray-200 {\n  color: var(--kt-text-gray-200);\n}\n\n.btn.btn-color-gray-300 {\n  color: var(--kt-text-gray-300);\n}\n.btn.btn-color-gray-300 i,\n.btn.btn-color-gray-300 .svg-icon {\n  color: var(--kt-text-gray-300);\n}\n.btn.btn-color-gray-300.dropdown-toggle:after {\n  color: var(--kt-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-color-gray-300, .btn-check:active + .btn.btn-active-color-gray-300, .btn.btn-active-color-gray-300:focus:not(.btn-active), .btn.btn-active-color-gray-300:hover:not(.btn-active), .btn.btn-active-color-gray-300:active:not(.btn-active), .btn.btn-active-color-gray-300.active, .btn.btn-active-color-gray-300.show, .show > .btn.btn-active-color-gray-300 {\n  color: var(--kt-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-color-gray-300 i,\n.btn-check:checked + .btn.btn-active-color-gray-300 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-300 i,\n.btn-check:active + .btn.btn-active-color-gray-300 .svg-icon, .btn.btn-active-color-gray-300:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-300:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-300:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300:active:not(.btn-active) i,\n.btn.btn-active-color-gray-300:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-300.active i,\n.btn.btn-active-color-gray-300.active .svg-icon, .btn.btn-active-color-gray-300.show i,\n.btn.btn-active-color-gray-300.show .svg-icon, .show > .btn.btn-active-color-gray-300 i,\n.show > .btn.btn-active-color-gray-300 .svg-icon {\n  color: var(--kt-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-300.dropdown-toggle:after, .btn.btn-active-color-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-300.active.dropdown-toggle:after, .btn.btn-active-color-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-300.dropdown-toggle:after {\n  color: var(--kt-text-gray-300);\n}\n\n.btn.btn-icon-gray-300 i,\n.btn.btn-icon-gray-300 .svg-icon {\n  color: var(--kt-text-gray-300);\n}\n.btn.btn-icon-gray-300.dropdown-toggle:after {\n  color: var(--kt-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-300 i,\n.btn-check:checked + .btn.btn-active-icon-gray-300 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-300 i,\n.btn-check:active + .btn.btn-active-icon-gray-300 .svg-icon, .btn.btn-active-icon-gray-300:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-300:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-300:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-300:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-300.active i,\n.btn.btn-active-icon-gray-300.active .svg-icon, .btn.btn-active-icon-gray-300.show i,\n.btn.btn-active-icon-gray-300.show .svg-icon, .show > .btn.btn-active-icon-gray-300 i,\n.show > .btn.btn-active-icon-gray-300 .svg-icon {\n  color: var(--kt-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-300.dropdown-toggle:after, .btn.btn-active-icon-gray-300:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-300.active.dropdown-toggle:after, .btn.btn-active-icon-gray-300.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-300.dropdown-toggle:after {\n  color: var(--kt-text-gray-300);\n}\n\n.btn.btn-text-gray-300 {\n  color: var(--kt-text-gray-300);\n}\n.btn-check:checked + .btn.btn-active-text-gray-300, .btn-check:active + .btn.btn-active-text-gray-300, .btn.btn-active-text-gray-300:focus:not(.btn-active), .btn.btn-active-text-gray-300:hover:not(.btn-active), .btn.btn-active-text-gray-300:active:not(.btn-active), .btn.btn-active-text-gray-300.active, .btn.btn-active-text-gray-300.show, .show > .btn.btn-active-text-gray-300 {\n  color: var(--kt-text-gray-300);\n}\n\n.btn.btn-color-gray-400 {\n  color: var(--kt-text-gray-400);\n}\n.btn.btn-color-gray-400 i,\n.btn.btn-color-gray-400 .svg-icon {\n  color: var(--kt-text-gray-400);\n}\n.btn.btn-color-gray-400.dropdown-toggle:after {\n  color: var(--kt-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-color-gray-400, .btn-check:active + .btn.btn-active-color-gray-400, .btn.btn-active-color-gray-400:focus:not(.btn-active), .btn.btn-active-color-gray-400:hover:not(.btn-active), .btn.btn-active-color-gray-400:active:not(.btn-active), .btn.btn-active-color-gray-400.active, .btn.btn-active-color-gray-400.show, .show > .btn.btn-active-color-gray-400 {\n  color: var(--kt-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-color-gray-400 i,\n.btn-check:checked + .btn.btn-active-color-gray-400 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-400 i,\n.btn-check:active + .btn.btn-active-color-gray-400 .svg-icon, .btn.btn-active-color-gray-400:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-400:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-400:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400:active:not(.btn-active) i,\n.btn.btn-active-color-gray-400:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-400.active i,\n.btn.btn-active-color-gray-400.active .svg-icon, .btn.btn-active-color-gray-400.show i,\n.btn.btn-active-color-gray-400.show .svg-icon, .show > .btn.btn-active-color-gray-400 i,\n.show > .btn.btn-active-color-gray-400 .svg-icon {\n  color: var(--kt-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-400.dropdown-toggle:after, .btn.btn-active-color-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-400.active.dropdown-toggle:after, .btn.btn-active-color-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-400.dropdown-toggle:after {\n  color: var(--kt-text-gray-400);\n}\n\n.btn.btn-icon-gray-400 i,\n.btn.btn-icon-gray-400 .svg-icon {\n  color: var(--kt-text-gray-400);\n}\n.btn.btn-icon-gray-400.dropdown-toggle:after {\n  color: var(--kt-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-400 i,\n.btn-check:checked + .btn.btn-active-icon-gray-400 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-400 i,\n.btn-check:active + .btn.btn-active-icon-gray-400 .svg-icon, .btn.btn-active-icon-gray-400:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-400:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-400:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-400:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-400.active i,\n.btn.btn-active-icon-gray-400.active .svg-icon, .btn.btn-active-icon-gray-400.show i,\n.btn.btn-active-icon-gray-400.show .svg-icon, .show > .btn.btn-active-icon-gray-400 i,\n.show > .btn.btn-active-icon-gray-400 .svg-icon {\n  color: var(--kt-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-400.dropdown-toggle:after, .btn.btn-active-icon-gray-400:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-400.active.dropdown-toggle:after, .btn.btn-active-icon-gray-400.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-400.dropdown-toggle:after {\n  color: var(--kt-text-gray-400);\n}\n\n.btn.btn-text-gray-400 {\n  color: var(--kt-text-gray-400);\n}\n.btn-check:checked + .btn.btn-active-text-gray-400, .btn-check:active + .btn.btn-active-text-gray-400, .btn.btn-active-text-gray-400:focus:not(.btn-active), .btn.btn-active-text-gray-400:hover:not(.btn-active), .btn.btn-active-text-gray-400:active:not(.btn-active), .btn.btn-active-text-gray-400.active, .btn.btn-active-text-gray-400.show, .show > .btn.btn-active-text-gray-400 {\n  color: var(--kt-text-gray-400);\n}\n\n.btn.btn-color-gray-500 {\n  color: var(--kt-text-gray-500);\n}\n.btn.btn-color-gray-500 i,\n.btn.btn-color-gray-500 .svg-icon {\n  color: var(--kt-text-gray-500);\n}\n.btn.btn-color-gray-500.dropdown-toggle:after {\n  color: var(--kt-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-color-gray-500, .btn-check:active + .btn.btn-active-color-gray-500, .btn.btn-active-color-gray-500:focus:not(.btn-active), .btn.btn-active-color-gray-500:hover:not(.btn-active), .btn.btn-active-color-gray-500:active:not(.btn-active), .btn.btn-active-color-gray-500.active, .btn.btn-active-color-gray-500.show, .show > .btn.btn-active-color-gray-500 {\n  color: var(--kt-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-color-gray-500 i,\n.btn-check:checked + .btn.btn-active-color-gray-500 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-500 i,\n.btn-check:active + .btn.btn-active-color-gray-500 .svg-icon, .btn.btn-active-color-gray-500:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-500:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-500:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500:active:not(.btn-active) i,\n.btn.btn-active-color-gray-500:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-500.active i,\n.btn.btn-active-color-gray-500.active .svg-icon, .btn.btn-active-color-gray-500.show i,\n.btn.btn-active-color-gray-500.show .svg-icon, .show > .btn.btn-active-color-gray-500 i,\n.show > .btn.btn-active-color-gray-500 .svg-icon {\n  color: var(--kt-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-500.dropdown-toggle:after, .btn.btn-active-color-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-500.active.dropdown-toggle:after, .btn.btn-active-color-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-500.dropdown-toggle:after {\n  color: var(--kt-text-gray-500);\n}\n\n.btn.btn-icon-gray-500 i,\n.btn.btn-icon-gray-500 .svg-icon {\n  color: var(--kt-text-gray-500);\n}\n.btn.btn-icon-gray-500.dropdown-toggle:after {\n  color: var(--kt-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-500 i,\n.btn-check:checked + .btn.btn-active-icon-gray-500 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-500 i,\n.btn-check:active + .btn.btn-active-icon-gray-500 .svg-icon, .btn.btn-active-icon-gray-500:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-500:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-500:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-500:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-500.active i,\n.btn.btn-active-icon-gray-500.active .svg-icon, .btn.btn-active-icon-gray-500.show i,\n.btn.btn-active-icon-gray-500.show .svg-icon, .show > .btn.btn-active-icon-gray-500 i,\n.show > .btn.btn-active-icon-gray-500 .svg-icon {\n  color: var(--kt-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-500.dropdown-toggle:after, .btn.btn-active-icon-gray-500:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-500.active.dropdown-toggle:after, .btn.btn-active-icon-gray-500.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-500.dropdown-toggle:after {\n  color: var(--kt-text-gray-500);\n}\n\n.btn.btn-text-gray-500 {\n  color: var(--kt-text-gray-500);\n}\n.btn-check:checked + .btn.btn-active-text-gray-500, .btn-check:active + .btn.btn-active-text-gray-500, .btn.btn-active-text-gray-500:focus:not(.btn-active), .btn.btn-active-text-gray-500:hover:not(.btn-active), .btn.btn-active-text-gray-500:active:not(.btn-active), .btn.btn-active-text-gray-500.active, .btn.btn-active-text-gray-500.show, .show > .btn.btn-active-text-gray-500 {\n  color: var(--kt-text-gray-500);\n}\n\n.btn.btn-color-gray-600 {\n  color: var(--kt-text-gray-600);\n}\n.btn.btn-color-gray-600 i,\n.btn.btn-color-gray-600 .svg-icon {\n  color: var(--kt-text-gray-600);\n}\n.btn.btn-color-gray-600.dropdown-toggle:after {\n  color: var(--kt-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-color-gray-600, .btn-check:active + .btn.btn-active-color-gray-600, .btn.btn-active-color-gray-600:focus:not(.btn-active), .btn.btn-active-color-gray-600:hover:not(.btn-active), .btn.btn-active-color-gray-600:active:not(.btn-active), .btn.btn-active-color-gray-600.active, .btn.btn-active-color-gray-600.show, .show > .btn.btn-active-color-gray-600 {\n  color: var(--kt-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-color-gray-600 i,\n.btn-check:checked + .btn.btn-active-color-gray-600 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-600 i,\n.btn-check:active + .btn.btn-active-color-gray-600 .svg-icon, .btn.btn-active-color-gray-600:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-600:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-600:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600:active:not(.btn-active) i,\n.btn.btn-active-color-gray-600:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-600.active i,\n.btn.btn-active-color-gray-600.active .svg-icon, .btn.btn-active-color-gray-600.show i,\n.btn.btn-active-color-gray-600.show .svg-icon, .show > .btn.btn-active-color-gray-600 i,\n.show > .btn.btn-active-color-gray-600 .svg-icon {\n  color: var(--kt-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-600.dropdown-toggle:after, .btn.btn-active-color-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-600.active.dropdown-toggle:after, .btn.btn-active-color-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-600.dropdown-toggle:after {\n  color: var(--kt-text-gray-600);\n}\n\n.btn.btn-icon-gray-600 i,\n.btn.btn-icon-gray-600 .svg-icon {\n  color: var(--kt-text-gray-600);\n}\n.btn.btn-icon-gray-600.dropdown-toggle:after {\n  color: var(--kt-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-600 i,\n.btn-check:checked + .btn.btn-active-icon-gray-600 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-600 i,\n.btn-check:active + .btn.btn-active-icon-gray-600 .svg-icon, .btn.btn-active-icon-gray-600:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-600:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-600:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-600:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-600.active i,\n.btn.btn-active-icon-gray-600.active .svg-icon, .btn.btn-active-icon-gray-600.show i,\n.btn.btn-active-icon-gray-600.show .svg-icon, .show > .btn.btn-active-icon-gray-600 i,\n.show > .btn.btn-active-icon-gray-600 .svg-icon {\n  color: var(--kt-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-600.dropdown-toggle:after, .btn.btn-active-icon-gray-600:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-600.active.dropdown-toggle:after, .btn.btn-active-icon-gray-600.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-600.dropdown-toggle:after {\n  color: var(--kt-text-gray-600);\n}\n\n.btn.btn-text-gray-600 {\n  color: var(--kt-text-gray-600);\n}\n.btn-check:checked + .btn.btn-active-text-gray-600, .btn-check:active + .btn.btn-active-text-gray-600, .btn.btn-active-text-gray-600:focus:not(.btn-active), .btn.btn-active-text-gray-600:hover:not(.btn-active), .btn.btn-active-text-gray-600:active:not(.btn-active), .btn.btn-active-text-gray-600.active, .btn.btn-active-text-gray-600.show, .show > .btn.btn-active-text-gray-600 {\n  color: var(--kt-text-gray-600);\n}\n\n.btn.btn-color-gray-700 {\n  color: var(--kt-text-gray-700);\n}\n.btn.btn-color-gray-700 i,\n.btn.btn-color-gray-700 .svg-icon {\n  color: var(--kt-text-gray-700);\n}\n.btn.btn-color-gray-700.dropdown-toggle:after {\n  color: var(--kt-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-color-gray-700, .btn-check:active + .btn.btn-active-color-gray-700, .btn.btn-active-color-gray-700:focus:not(.btn-active), .btn.btn-active-color-gray-700:hover:not(.btn-active), .btn.btn-active-color-gray-700:active:not(.btn-active), .btn.btn-active-color-gray-700.active, .btn.btn-active-color-gray-700.show, .show > .btn.btn-active-color-gray-700 {\n  color: var(--kt-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-color-gray-700 i,\n.btn-check:checked + .btn.btn-active-color-gray-700 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-700 i,\n.btn-check:active + .btn.btn-active-color-gray-700 .svg-icon, .btn.btn-active-color-gray-700:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-700:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-700:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700:active:not(.btn-active) i,\n.btn.btn-active-color-gray-700:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-700.active i,\n.btn.btn-active-color-gray-700.active .svg-icon, .btn.btn-active-color-gray-700.show i,\n.btn.btn-active-color-gray-700.show .svg-icon, .show > .btn.btn-active-color-gray-700 i,\n.show > .btn.btn-active-color-gray-700 .svg-icon {\n  color: var(--kt-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-700.dropdown-toggle:after, .btn.btn-active-color-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-700.active.dropdown-toggle:after, .btn.btn-active-color-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-700.dropdown-toggle:after {\n  color: var(--kt-text-gray-700);\n}\n\n.btn.btn-icon-gray-700 i,\n.btn.btn-icon-gray-700 .svg-icon {\n  color: var(--kt-text-gray-700);\n}\n.btn.btn-icon-gray-700.dropdown-toggle:after {\n  color: var(--kt-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-700 i,\n.btn-check:checked + .btn.btn-active-icon-gray-700 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-700 i,\n.btn-check:active + .btn.btn-active-icon-gray-700 .svg-icon, .btn.btn-active-icon-gray-700:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-700:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-700:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-700:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-700.active i,\n.btn.btn-active-icon-gray-700.active .svg-icon, .btn.btn-active-icon-gray-700.show i,\n.btn.btn-active-icon-gray-700.show .svg-icon, .show > .btn.btn-active-icon-gray-700 i,\n.show > .btn.btn-active-icon-gray-700 .svg-icon {\n  color: var(--kt-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-700.dropdown-toggle:after, .btn.btn-active-icon-gray-700:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-700.active.dropdown-toggle:after, .btn.btn-active-icon-gray-700.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-700.dropdown-toggle:after {\n  color: var(--kt-text-gray-700);\n}\n\n.btn.btn-text-gray-700 {\n  color: var(--kt-text-gray-700);\n}\n.btn-check:checked + .btn.btn-active-text-gray-700, .btn-check:active + .btn.btn-active-text-gray-700, .btn.btn-active-text-gray-700:focus:not(.btn-active), .btn.btn-active-text-gray-700:hover:not(.btn-active), .btn.btn-active-text-gray-700:active:not(.btn-active), .btn.btn-active-text-gray-700.active, .btn.btn-active-text-gray-700.show, .show > .btn.btn-active-text-gray-700 {\n  color: var(--kt-text-gray-700);\n}\n\n.btn.btn-color-gray-800 {\n  color: var(--kt-text-gray-800);\n}\n.btn.btn-color-gray-800 i,\n.btn.btn-color-gray-800 .svg-icon {\n  color: var(--kt-text-gray-800);\n}\n.btn.btn-color-gray-800.dropdown-toggle:after {\n  color: var(--kt-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-color-gray-800, .btn-check:active + .btn.btn-active-color-gray-800, .btn.btn-active-color-gray-800:focus:not(.btn-active), .btn.btn-active-color-gray-800:hover:not(.btn-active), .btn.btn-active-color-gray-800:active:not(.btn-active), .btn.btn-active-color-gray-800.active, .btn.btn-active-color-gray-800.show, .show > .btn.btn-active-color-gray-800 {\n  color: var(--kt-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-color-gray-800 i,\n.btn-check:checked + .btn.btn-active-color-gray-800 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-800 i,\n.btn-check:active + .btn.btn-active-color-gray-800 .svg-icon, .btn.btn-active-color-gray-800:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-800:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-800:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800:active:not(.btn-active) i,\n.btn.btn-active-color-gray-800:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-800.active i,\n.btn.btn-active-color-gray-800.active .svg-icon, .btn.btn-active-color-gray-800.show i,\n.btn.btn-active-color-gray-800.show .svg-icon, .show > .btn.btn-active-color-gray-800 i,\n.show > .btn.btn-active-color-gray-800 .svg-icon {\n  color: var(--kt-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-800.dropdown-toggle:after, .btn.btn-active-color-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-800.active.dropdown-toggle:after, .btn.btn-active-color-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-800.dropdown-toggle:after {\n  color: var(--kt-text-gray-800);\n}\n\n.btn.btn-icon-gray-800 i,\n.btn.btn-icon-gray-800 .svg-icon {\n  color: var(--kt-text-gray-800);\n}\n.btn.btn-icon-gray-800.dropdown-toggle:after {\n  color: var(--kt-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-800 i,\n.btn-check:checked + .btn.btn-active-icon-gray-800 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-800 i,\n.btn-check:active + .btn.btn-active-icon-gray-800 .svg-icon, .btn.btn-active-icon-gray-800:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-800:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-800:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-800:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-800.active i,\n.btn.btn-active-icon-gray-800.active .svg-icon, .btn.btn-active-icon-gray-800.show i,\n.btn.btn-active-icon-gray-800.show .svg-icon, .show > .btn.btn-active-icon-gray-800 i,\n.show > .btn.btn-active-icon-gray-800 .svg-icon {\n  color: var(--kt-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-800.dropdown-toggle:after, .btn.btn-active-icon-gray-800:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-800.active.dropdown-toggle:after, .btn.btn-active-icon-gray-800.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-800.dropdown-toggle:after {\n  color: var(--kt-text-gray-800);\n}\n\n.btn.btn-text-gray-800 {\n  color: var(--kt-text-gray-800);\n}\n.btn-check:checked + .btn.btn-active-text-gray-800, .btn-check:active + .btn.btn-active-text-gray-800, .btn.btn-active-text-gray-800:focus:not(.btn-active), .btn.btn-active-text-gray-800:hover:not(.btn-active), .btn.btn-active-text-gray-800:active:not(.btn-active), .btn.btn-active-text-gray-800.active, .btn.btn-active-text-gray-800.show, .show > .btn.btn-active-text-gray-800 {\n  color: var(--kt-text-gray-800);\n}\n\n.btn.btn-color-gray-900 {\n  color: var(--kt-text-gray-900);\n}\n.btn.btn-color-gray-900 i,\n.btn.btn-color-gray-900 .svg-icon {\n  color: var(--kt-text-gray-900);\n}\n.btn.btn-color-gray-900.dropdown-toggle:after {\n  color: var(--kt-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-color-gray-900, .btn-check:active + .btn.btn-active-color-gray-900, .btn.btn-active-color-gray-900:focus:not(.btn-active), .btn.btn-active-color-gray-900:hover:not(.btn-active), .btn.btn-active-color-gray-900:active:not(.btn-active), .btn.btn-active-color-gray-900.active, .btn.btn-active-color-gray-900.show, .show > .btn.btn-active-color-gray-900 {\n  color: var(--kt-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-color-gray-900 i,\n.btn-check:checked + .btn.btn-active-color-gray-900 .svg-icon, .btn-check:active + .btn.btn-active-color-gray-900 i,\n.btn-check:active + .btn.btn-active-color-gray-900 .svg-icon, .btn.btn-active-color-gray-900:focus:not(.btn-active) i,\n.btn.btn-active-color-gray-900:focus:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900:hover:not(.btn-active) i,\n.btn.btn-active-color-gray-900:hover:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900:active:not(.btn-active) i,\n.btn.btn-active-color-gray-900:active:not(.btn-active) .svg-icon, .btn.btn-active-color-gray-900.active i,\n.btn.btn-active-color-gray-900.active .svg-icon, .btn.btn-active-color-gray-900.show i,\n.btn.btn-active-color-gray-900.show .svg-icon, .show > .btn.btn-active-color-gray-900 i,\n.show > .btn.btn-active-color-gray-900 .svg-icon {\n  color: var(--kt-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-color-gray-900.dropdown-toggle:after, .btn.btn-active-color-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-color-gray-900.active.dropdown-toggle:after, .btn.btn-active-color-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-color-gray-900.dropdown-toggle:after {\n  color: var(--kt-text-gray-900);\n}\n\n.btn.btn-icon-gray-900 i,\n.btn.btn-icon-gray-900 .svg-icon {\n  color: var(--kt-text-gray-900);\n}\n.btn.btn-icon-gray-900.dropdown-toggle:after {\n  color: var(--kt-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-900 i,\n.btn-check:checked + .btn.btn-active-icon-gray-900 .svg-icon, .btn-check:active + .btn.btn-active-icon-gray-900 i,\n.btn-check:active + .btn.btn-active-icon-gray-900 .svg-icon, .btn.btn-active-icon-gray-900:focus:not(.btn-active) i,\n.btn.btn-active-icon-gray-900:focus:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900:hover:not(.btn-active) i,\n.btn.btn-active-icon-gray-900:hover:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900:active:not(.btn-active) i,\n.btn.btn-active-icon-gray-900:active:not(.btn-active) .svg-icon, .btn.btn-active-icon-gray-900.active i,\n.btn.btn-active-icon-gray-900.active .svg-icon, .btn.btn-active-icon-gray-900.show i,\n.btn.btn-active-icon-gray-900.show .svg-icon, .show > .btn.btn-active-icon-gray-900 i,\n.show > .btn.btn-active-icon-gray-900 .svg-icon {\n  color: var(--kt-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn-check:active + .btn.btn-active-icon-gray-900.dropdown-toggle:after, .btn.btn-active-icon-gray-900:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900:active:not(.btn-active).dropdown-toggle:after, .btn.btn-active-icon-gray-900.active.dropdown-toggle:after, .btn.btn-active-icon-gray-900.show.dropdown-toggle:after, .show > .btn.btn-active-icon-gray-900.dropdown-toggle:after {\n  color: var(--kt-text-gray-900);\n}\n\n.btn.btn-text-gray-900 {\n  color: var(--kt-text-gray-900);\n}\n.btn-check:checked + .btn.btn-active-text-gray-900, .btn-check:active + .btn.btn-active-text-gray-900, .btn.btn-active-text-gray-900:focus:not(.btn-active), .btn.btn-active-text-gray-900:hover:not(.btn-active), .btn.btn-active-text-gray-900:active:not(.btn-active), .btn.btn-active-text-gray-900.active, .btn.btn-active-text-gray-900.show, .show > .btn.btn-active-text-gray-900 {\n  color: var(--kt-text-gray-900);\n}\n\n.btn.btn-facebook {\n  color: #ffffff;\n  border-color: #3b5998;\n  background-color: #3b5998;\n}\n.btn.btn-facebook i,\n.btn.btn-facebook .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-facebook.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-facebook, .btn-check:active + .btn.btn-facebook, .btn.btn-facebook:focus:not(.btn-active), .btn.btn-facebook:hover:not(.btn-active), .btn.btn-facebook:active:not(.btn-active), .btn.btn-facebook.active, .btn.btn-facebook.show, .show > .btn.btn-facebook {\n  border-color: #30497c;\n  background-color: #30497c !important;\n}\n\n.btn.btn-light-facebook {\n  color: #3b5998;\n  border-color: rgba(59, 89, 152, 0.1);\n  background-color: rgba(59, 89, 152, 0.1);\n}\n.btn.btn-light-facebook i,\n.btn.btn-light-facebook .svg-icon {\n  color: #3b5998;\n}\n.btn.btn-light-facebook.dropdown-toggle:after {\n  color: #3b5998;\n}\n.btn-check:checked + .btn.btn-light-facebook, .btn-check:active + .btn.btn-light-facebook, .btn.btn-light-facebook:focus:not(.btn-active), .btn.btn-light-facebook:hover:not(.btn-active), .btn.btn-light-facebook:active:not(.btn-active), .btn.btn-light-facebook.active, .btn.btn-light-facebook.show, .show > .btn.btn-light-facebook {\n  color: #ffffff;\n  border-color: #3b5998;\n  background-color: #3b5998 !important;\n}\n.btn-check:checked + .btn.btn-light-facebook i,\n.btn-check:checked + .btn.btn-light-facebook .svg-icon, .btn-check:active + .btn.btn-light-facebook i,\n.btn-check:active + .btn.btn-light-facebook .svg-icon, .btn.btn-light-facebook:focus:not(.btn-active) i,\n.btn.btn-light-facebook:focus:not(.btn-active) .svg-icon, .btn.btn-light-facebook:hover:not(.btn-active) i,\n.btn.btn-light-facebook:hover:not(.btn-active) .svg-icon, .btn.btn-light-facebook:active:not(.btn-active) i,\n.btn.btn-light-facebook:active:not(.btn-active) .svg-icon, .btn.btn-light-facebook.active i,\n.btn.btn-light-facebook.active .svg-icon, .btn.btn-light-facebook.show i,\n.btn.btn-light-facebook.show .svg-icon, .show > .btn.btn-light-facebook i,\n.show > .btn.btn-light-facebook .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-facebook.dropdown-toggle:after, .btn-check:active + .btn.btn-light-facebook.dropdown-toggle:after, .btn.btn-light-facebook:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-facebook.active.dropdown-toggle:after, .btn.btn-light-facebook.show.dropdown-toggle:after, .show > .btn.btn-light-facebook.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-google {\n  color: #ffffff;\n  border-color: #dd4b39;\n  background-color: #dd4b39;\n}\n.btn.btn-google i,\n.btn.btn-google .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-google.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-google, .btn-check:active + .btn.btn-google, .btn.btn-google:focus:not(.btn-active), .btn.btn-google:hover:not(.btn-active), .btn.btn-google:active:not(.btn-active), .btn.btn-google.active, .btn.btn-google.show, .show > .btn.btn-google {\n  border-color: #cd3623;\n  background-color: #cd3623 !important;\n}\n\n.btn.btn-light-google {\n  color: #dd4b39;\n  border-color: rgba(221, 75, 57, 0.1);\n  background-color: rgba(221, 75, 57, 0.1);\n}\n.btn.btn-light-google i,\n.btn.btn-light-google .svg-icon {\n  color: #dd4b39;\n}\n.btn.btn-light-google.dropdown-toggle:after {\n  color: #dd4b39;\n}\n.btn-check:checked + .btn.btn-light-google, .btn-check:active + .btn.btn-light-google, .btn.btn-light-google:focus:not(.btn-active), .btn.btn-light-google:hover:not(.btn-active), .btn.btn-light-google:active:not(.btn-active), .btn.btn-light-google.active, .btn.btn-light-google.show, .show > .btn.btn-light-google {\n  color: #ffffff;\n  border-color: #dd4b39;\n  background-color: #dd4b39 !important;\n}\n.btn-check:checked + .btn.btn-light-google i,\n.btn-check:checked + .btn.btn-light-google .svg-icon, .btn-check:active + .btn.btn-light-google i,\n.btn-check:active + .btn.btn-light-google .svg-icon, .btn.btn-light-google:focus:not(.btn-active) i,\n.btn.btn-light-google:focus:not(.btn-active) .svg-icon, .btn.btn-light-google:hover:not(.btn-active) i,\n.btn.btn-light-google:hover:not(.btn-active) .svg-icon, .btn.btn-light-google:active:not(.btn-active) i,\n.btn.btn-light-google:active:not(.btn-active) .svg-icon, .btn.btn-light-google.active i,\n.btn.btn-light-google.active .svg-icon, .btn.btn-light-google.show i,\n.btn.btn-light-google.show .svg-icon, .show > .btn.btn-light-google i,\n.show > .btn.btn-light-google .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-google.dropdown-toggle:after, .btn-check:active + .btn.btn-light-google.dropdown-toggle:after, .btn.btn-light-google:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-google.active.dropdown-toggle:after, .btn.btn-light-google.show.dropdown-toggle:after, .show > .btn.btn-light-google.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-twitter {\n  color: #ffffff;\n  border-color: #1da1f2;\n  background-color: #1da1f2;\n}\n.btn.btn-twitter i,\n.btn.btn-twitter .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-twitter.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-twitter, .btn-check:active + .btn.btn-twitter, .btn.btn-twitter:focus:not(.btn-active), .btn.btn-twitter:hover:not(.btn-active), .btn.btn-twitter:active:not(.btn-active), .btn.btn-twitter.active, .btn.btn-twitter.show, .show > .btn.btn-twitter {\n  border-color: #0d8ddc;\n  background-color: #0d8ddc !important;\n}\n\n.btn.btn-light-twitter {\n  color: #1da1f2;\n  border-color: rgba(29, 161, 242, 0.1);\n  background-color: rgba(29, 161, 242, 0.1);\n}\n.btn.btn-light-twitter i,\n.btn.btn-light-twitter .svg-icon {\n  color: #1da1f2;\n}\n.btn.btn-light-twitter.dropdown-toggle:after {\n  color: #1da1f2;\n}\n.btn-check:checked + .btn.btn-light-twitter, .btn-check:active + .btn.btn-light-twitter, .btn.btn-light-twitter:focus:not(.btn-active), .btn.btn-light-twitter:hover:not(.btn-active), .btn.btn-light-twitter:active:not(.btn-active), .btn.btn-light-twitter.active, .btn.btn-light-twitter.show, .show > .btn.btn-light-twitter {\n  color: #ffffff;\n  border-color: #1da1f2;\n  background-color: #1da1f2 !important;\n}\n.btn-check:checked + .btn.btn-light-twitter i,\n.btn-check:checked + .btn.btn-light-twitter .svg-icon, .btn-check:active + .btn.btn-light-twitter i,\n.btn-check:active + .btn.btn-light-twitter .svg-icon, .btn.btn-light-twitter:focus:not(.btn-active) i,\n.btn.btn-light-twitter:focus:not(.btn-active) .svg-icon, .btn.btn-light-twitter:hover:not(.btn-active) i,\n.btn.btn-light-twitter:hover:not(.btn-active) .svg-icon, .btn.btn-light-twitter:active:not(.btn-active) i,\n.btn.btn-light-twitter:active:not(.btn-active) .svg-icon, .btn.btn-light-twitter.active i,\n.btn.btn-light-twitter.active .svg-icon, .btn.btn-light-twitter.show i,\n.btn.btn-light-twitter.show .svg-icon, .show > .btn.btn-light-twitter i,\n.show > .btn.btn-light-twitter .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-twitter.dropdown-toggle:after, .btn-check:active + .btn.btn-light-twitter.dropdown-toggle:after, .btn.btn-light-twitter:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-twitter.active.dropdown-toggle:after, .btn.btn-light-twitter.show.dropdown-toggle:after, .show > .btn.btn-light-twitter.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-instagram {\n  color: #ffffff;\n  border-color: #e1306c;\n  background-color: #e1306c;\n}\n.btn.btn-instagram i,\n.btn.btn-instagram .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-instagram.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-instagram, .btn-check:active + .btn.btn-instagram, .btn.btn-instagram:focus:not(.btn-active), .btn.btn-instagram:hover:not(.btn-active), .btn.btn-instagram:active:not(.btn-active), .btn.btn-instagram.active, .btn.btn-instagram.show, .show > .btn.btn-instagram {\n  border-color: #cd1e59;\n  background-color: #cd1e59 !important;\n}\n\n.btn.btn-light-instagram {\n  color: #e1306c;\n  border-color: rgba(225, 48, 108, 0.1);\n  background-color: rgba(225, 48, 108, 0.1);\n}\n.btn.btn-light-instagram i,\n.btn.btn-light-instagram .svg-icon {\n  color: #e1306c;\n}\n.btn.btn-light-instagram.dropdown-toggle:after {\n  color: #e1306c;\n}\n.btn-check:checked + .btn.btn-light-instagram, .btn-check:active + .btn.btn-light-instagram, .btn.btn-light-instagram:focus:not(.btn-active), .btn.btn-light-instagram:hover:not(.btn-active), .btn.btn-light-instagram:active:not(.btn-active), .btn.btn-light-instagram.active, .btn.btn-light-instagram.show, .show > .btn.btn-light-instagram {\n  color: #ffffff;\n  border-color: #e1306c;\n  background-color: #e1306c !important;\n}\n.btn-check:checked + .btn.btn-light-instagram i,\n.btn-check:checked + .btn.btn-light-instagram .svg-icon, .btn-check:active + .btn.btn-light-instagram i,\n.btn-check:active + .btn.btn-light-instagram .svg-icon, .btn.btn-light-instagram:focus:not(.btn-active) i,\n.btn.btn-light-instagram:focus:not(.btn-active) .svg-icon, .btn.btn-light-instagram:hover:not(.btn-active) i,\n.btn.btn-light-instagram:hover:not(.btn-active) .svg-icon, .btn.btn-light-instagram:active:not(.btn-active) i,\n.btn.btn-light-instagram:active:not(.btn-active) .svg-icon, .btn.btn-light-instagram.active i,\n.btn.btn-light-instagram.active .svg-icon, .btn.btn-light-instagram.show i,\n.btn.btn-light-instagram.show .svg-icon, .show > .btn.btn-light-instagram i,\n.show > .btn.btn-light-instagram .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-instagram.dropdown-toggle:after, .btn-check:active + .btn.btn-light-instagram.dropdown-toggle:after, .btn.btn-light-instagram:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-instagram.active.dropdown-toggle:after, .btn.btn-light-instagram.show.dropdown-toggle:after, .show > .btn.btn-light-instagram.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-youtube {\n  color: #ffffff;\n  border-color: #ff0000;\n  background-color: #ff0000;\n}\n.btn.btn-youtube i,\n.btn.btn-youtube .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-youtube.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-youtube, .btn-check:active + .btn.btn-youtube, .btn.btn-youtube:focus:not(.btn-active), .btn.btn-youtube:hover:not(.btn-active), .btn.btn-youtube:active:not(.btn-active), .btn.btn-youtube.active, .btn.btn-youtube.show, .show > .btn.btn-youtube {\n  border-color: #d90000;\n  background-color: #d90000 !important;\n}\n\n.btn.btn-light-youtube {\n  color: #ff0000;\n  border-color: rgba(255, 0, 0, 0.1);\n  background-color: rgba(255, 0, 0, 0.1);\n}\n.btn.btn-light-youtube i,\n.btn.btn-light-youtube .svg-icon {\n  color: #ff0000;\n}\n.btn.btn-light-youtube.dropdown-toggle:after {\n  color: #ff0000;\n}\n.btn-check:checked + .btn.btn-light-youtube, .btn-check:active + .btn.btn-light-youtube, .btn.btn-light-youtube:focus:not(.btn-active), .btn.btn-light-youtube:hover:not(.btn-active), .btn.btn-light-youtube:active:not(.btn-active), .btn.btn-light-youtube.active, .btn.btn-light-youtube.show, .show > .btn.btn-light-youtube {\n  color: #ffffff;\n  border-color: #ff0000;\n  background-color: #ff0000 !important;\n}\n.btn-check:checked + .btn.btn-light-youtube i,\n.btn-check:checked + .btn.btn-light-youtube .svg-icon, .btn-check:active + .btn.btn-light-youtube i,\n.btn-check:active + .btn.btn-light-youtube .svg-icon, .btn.btn-light-youtube:focus:not(.btn-active) i,\n.btn.btn-light-youtube:focus:not(.btn-active) .svg-icon, .btn.btn-light-youtube:hover:not(.btn-active) i,\n.btn.btn-light-youtube:hover:not(.btn-active) .svg-icon, .btn.btn-light-youtube:active:not(.btn-active) i,\n.btn.btn-light-youtube:active:not(.btn-active) .svg-icon, .btn.btn-light-youtube.active i,\n.btn.btn-light-youtube.active .svg-icon, .btn.btn-light-youtube.show i,\n.btn.btn-light-youtube.show .svg-icon, .show > .btn.btn-light-youtube i,\n.show > .btn.btn-light-youtube .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-youtube.dropdown-toggle:after, .btn-check:active + .btn.btn-light-youtube.dropdown-toggle:after, .btn.btn-light-youtube:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-youtube.active.dropdown-toggle:after, .btn.btn-light-youtube.show.dropdown-toggle:after, .show > .btn.btn-light-youtube.dropdown-toggle:after {\n  color: #ffffff;\n}\n\n.btn.btn-linkedin {\n  color: #ffffff;\n  border-color: #0077b5;\n  background-color: #0077b5;\n}\n.btn.btn-linkedin i,\n.btn.btn-linkedin .svg-icon {\n  color: #ffffff;\n}\n.btn.btn-linkedin.dropdown-toggle:after {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-linkedin, .btn-check:active + .btn.btn-linkedin, .btn.btn-linkedin:focus:not(.btn-active), .btn.btn-linkedin:hover:not(.btn-active), .btn.btn-linkedin:active:not(.btn-active), .btn.btn-linkedin.active, .btn.btn-linkedin.show, .show > .btn.btn-linkedin {\n  border-color: #005e8f;\n  background-color: #005e8f !important;\n}\n\n.btn.btn-light-linkedin {\n  color: #0077b5;\n  border-color: rgba(0, 119, 181, 0.1);\n  background-color: rgba(0, 119, 181, 0.1);\n}\n.btn.btn-light-linkedin i,\n.btn.btn-light-linkedin .svg-icon {\n  color: #0077b5;\n}\n.btn.btn-light-linkedin.dropdown-toggle:after {\n  color: #0077b5;\n}\n.btn-check:checked + .btn.btn-light-linkedin, .btn-check:active + .btn.btn-light-linkedin, .btn.btn-light-linkedin:focus:not(.btn-active), .btn.btn-light-linkedin:hover:not(.btn-active), .btn.btn-light-linkedin:active:not(.btn-active), .btn.btn-light-linkedin.active, .btn.btn-light-linkedin.show, .show > .btn.btn-light-linkedin {\n  color: #ffffff;\n  border-color: #0077b5;\n  background-color: #0077b5 !important;\n}\n.btn-check:checked + .btn.btn-light-linkedin i,\n.btn-check:checked + .btn.btn-light-linkedin .svg-icon, .btn-check:active + .btn.btn-light-linkedin i,\n.btn-check:active + .btn.btn-light-linkedin .svg-icon, .btn.btn-light-linkedin:focus:not(.btn-active) i,\n.btn.btn-light-linkedin:focus:not(.btn-active) .svg-icon, .btn.btn-light-linkedin:hover:not(.btn-active) i,\n.btn.btn-light-linkedin:hover:not(.btn-active) .svg-icon, .btn.btn-light-linkedin:active:not(.btn-active) i,\n.btn.btn-light-linkedin:active:not(.btn-active) .svg-icon, .btn.btn-light-linkedin.active i,\n.btn.btn-light-linkedin.active .svg-icon, .btn.btn-light-linkedin.show i,\n.btn.btn-light-linkedin.show .svg-icon, .show > .btn.btn-light-linkedin i,\n.show > .btn.btn-light-linkedin .svg-icon {\n  color: #ffffff;\n}\n.btn-check:checked + .btn.btn-light-linkedin.dropdown-toggle:after, .btn-check:active + .btn.btn-light-linkedin.dropdown-toggle:after, .btn.btn-light-linkedin:focus:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:hover:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin:active:not(.btn-active).dropdown-toggle:after, .btn.btn-light-linkedin.active.dropdown-toggle:after, .btn.btn-light-linkedin.show.dropdown-toggle:after, .show > .btn.btn-light-linkedin.dropdown-toggle:after {\n  color: #ffffff;\n}\n\ncode:not([class*=language-]) {\n  font-weight: 400;\n  color: var(--kt-code-color);\n  line-height: inherit;\n  font-size: inherit;\n  background-color: var(--kt-code-bg);\n  padding: 0.1rem 0.4rem;\n  margin: 0 0.5rem;\n  box-shadow: var(--kt-code-box-shadow);\n  border-radius: 0.3rem;\n}\n\n.form-label {\n  color: var(--kt-form-label-color);\n}\n\n.col-form-label {\n  color: var(--kt-form-label-color);\n}\n\n.form-text {\n  color: var(--kt-form-text-color);\n}\n\n.form-control {\n  color: var(--kt-input-color);\n  background-color: var(--kt-input-bg);\n  border: 1px solid var(--kt-input-border-color);\n  box-shadow: none !important;\n}\n.form-control:focus {\n  color: var(--kt-input-focus-color);\n  background-color: var(--kt-input-focus-bg);\n  border-color: var(--kt-input-focus-border-color);\n}\n.form-control::placeholder {\n  color: var(--kt-input-placeholder-color);\n}\n.form-control:disabled, .form-control[readonly] {\n  color: var(--kt-input-disabled-color);\n  background-color: var(--kt-input-disabled-bg);\n  border-color: var(--kt-input-disabled-border-color);\n}\n.form-control::file-selector-button {\n  color: var(--kt-form-file-button-color);\n  background-color: var(--kt-form-file-button-bg);\n}\n.form-control:hover:not(:disabled):not([readonly])::file-selector-button {\n  background-color: var(--kt-form-file-button-hover-bg);\n}\n\n.form-control-plaintext {\n  color: var(--kt-input-plaintext-color);\n}\n\n.form-select {\n  color: var(--kt-form-select-color);\n  background-color: var(--kt-form-select-bg);\n  background-image: var(--kt-form-select-indicator);\n  border: 1px solid var(--kt-form-select-border-color);\n  box-shadow: var(--kt-form-select-box-shadow);\n  appearance: none;\n}\n.form-select:focus {\n  border-color: var(--kt-form-select-focus-border-color);\n  box-shadow: var(--kt-form-select-box-shadow), var(--kt-form-select-focus-box-shadow);\n}\n.form-select:disabled {\n  color: var(--kt-form-select-disabled-color);\n  background-color: var(--kt-form-select-disabled-bg);\n  border-color: var(--kt-form-select-disabled-border-color);\n}\n.form-select:-moz-focusring {\n  text-shadow: 0 0 0 var(--kt-form-select-color);\n}\n\n.form-check-input {\n  background-color: var(--kt-form-check-input-bg);\n  border: var(--kt-form-check-input-border);\n}\n.form-check-input:active {\n  filter: var(--kt-form-check-input-active-filter);\n}\n.form-check-input:focus {\n  border-color: var(--kt-form-check-input-focus-border);\n  box-shadow: var(--kt-form-check-input-focus-box-shadow);\n}\n.form-check-input:checked {\n  background-color: var(--kt-form-check-input-checked-bg-color);\n  border-color: var(--kt-form-check-input-checked-border-color);\n}\n.form-check-input:checked[type=checkbox] {\n  background-image: var(--kt-form-check-input-checked-bg-image);\n}\n.form-check-input:checked[type=radio] {\n  background-image: var(--kt-form-check-radio-checked-bg-image);\n}\n.form-check-input[type=checkbox]:indeterminate {\n  background-color: var(--kt-form-check-input-indeterminate-bg-color);\n  border-color: var(--kt-form-check-input-indeterminate-border-color);\n  background-image: var(--kt-form-check-input-indeterminate-bg-image);\n}\n.form-check-input:disabled {\n  opacity: var(--kt-form-check-input-disabled-opacity);\n}\n.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {\n  opacity: var(--kt-form-check-label-disabled-opacity);\n}\n\n.form-check-label {\n  color: var(--kt-form-check-label-color);\n}\n\n.form-check-input:checked + span, .form-check-input:checked + label {\n  color: var(--kt-form-check-label-color-checked);\n}\n\n.form-switch .form-check-input {\n  background-image: var(--kt-form-switch-bg-image);\n}\n.form-switch .form-check-input:focus {\n  background-image: var(--kt-form-switch-focus-bg-image);\n}\n.form-switch .form-check-input:checked {\n  background-image: var(--kt-form-switch-checked-bg-image);\n}\n\n.btn-check[disabled] + .btn, .btn-check:disabled + .btn {\n  opacity: var(--kt-form-check-btn-check-disabled-opacity);\n}\n\n.form-floating .form-control.form-control-solid::placeholder {\n  color: transparent;\n}\n\n.input-group-text {\n  color: var(--kt-input-group-addon-color);\n  background-color: var(--kt-input-group-addon-bg);\n  border: 1px solid var(--kt-input-group-addon-border-color);\n}\n\n.dropdown.show > .form-control {\n  color: var(--kt-input-focus-color);\n  background-color: var(--kt-input-focus-bg);\n  border-color: var(--kt-input-focus-border-color);\n}\n.form-control[readonly] {\n  background-color: var(--kt-input-readonly-bg);\n}\n.form-control.form-control-solid {\n  background-color: var(--kt-input-solid-bg);\n  border-color: var(--kt-input-solid-bg);\n  color: var(--kt-input-solid-color);\n  transition: color 0.2s ease;\n}\n.form-control.form-control-solid::placeholder {\n  color: var(--kt-input-solid-placeholder-color);\n}\n.form-control.form-control-solid::-moz-placeholder {\n  color: var(--kt-input-solid-placeholder-color);\n  opacity: 1;\n}\n.dropdown.show > .form-control.form-control-solid, .form-control.form-control-solid:active, .form-control.form-control-solid.active, .form-control.form-control-solid:focus, .form-control.form-control-solid.focus {\n  background-color: var(--kt-input-solid-bg-focus);\n  border-color: var(--kt-input-solid-bg-focus);\n  color: var(--kt-input-solid-color);\n  transition: color 0.2s ease;\n}\n.form-control.form-control-transparent {\n  background-color: transparent;\n  border-color: transparent;\n}\n.dropdown.show > .form-control.form-control-transparent, .form-control.form-control-transparent:active, .form-control.form-control-transparent.active, .form-control.form-control-transparent:focus, .form-control.form-control-transparent.focus {\n  background-color: transparent;\n  border-color: transparent;\n}\n.form-control.form-control-flush {\n  border: 0;\n  background-color: transparent;\n  outline: none !important;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n.placeholder-gray-500::placeholder {\n  color: var(--kt-gray-500);\n}\n.placeholder-gray-500::-moz-placeholder {\n  color: var(--kt-gray-500);\n  opacity: 1;\n}\n\n.placeholder-white::placeholder {\n  color: #ffffff;\n}\n.placeholder-white::-moz-placeholder {\n  color: #ffffff;\n  opacity: 1;\n}\n\n.resize-none {\n  resize: none;\n}\n\n.form-control-solid-bg {\n  background-color: var(--kt-input-solid-bg);\n}\n\n.form-select {\n  box-shadow: none !important;\n}\n.form-select.form-select-solid {\n  background-color: var(--kt-input-solid-bg);\n  border-color: var(--kt-input-solid-bg);\n  color: var(--kt-input-solid-color);\n  transition: color 0.2s ease;\n}\n.form-select.form-select-solid::placeholder {\n  color: var(--kt-input-solid-placeholder-color);\n}\n.form-select.form-select-solid::-moz-placeholder {\n  color: var(--kt-input-solid-placeholder-color);\n  opacity: 1;\n}\n.dropdown.show > .form-select.form-select-solid, .form-select.form-select-solid:active, .form-select.form-select-solid.active, .form-select.form-select-solid:focus, .form-select.form-select-solid.focus {\n  background-color: var(--kt-input-solid-bg-focus);\n  border-color: var(--kt-input-solid-bg-focus) !important;\n  color: var(--kt-input-solid-color);\n  transition: color 0.2s ease;\n}\n.form-select.form-select-transparent {\n  background-color: transparent;\n  border-color: transparent;\n  color: #5E6278;\n}\n.form-select.form-select-transparent::placeholder {\n  color: var(--kt-input-placeholder-color);\n}\n.form-select.form-select-transparent::-moz-placeholder {\n  color: var(--kt-input-placeholder-color);\n  opacity: 1;\n}\n.dropdown.show > .form-select.form-select-transparent, .form-select.form-select-transparent:active, .form-select.form-select-transparent.active, .form-select.form-select-transparent:focus, .form-select.form-select-transparent.focus {\n  background-color: transparent;\n  border-color: transparent !important;\n  color: #5E6278;\n}\n\n.form-check:not(.form-switch) .form-check-input[type=checkbox] {\n  background-size: 60% 60%;\n}\n\n.form-check-custom {\n  display: flex;\n  align-items: center;\n  padding-left: 0;\n  margin: 0;\n}\n.form-check-custom .form-check-input {\n  margin: 0;\n  float: none;\n  flex-shrink: 0;\n}\n.form-check-custom .form-check-label {\n  margin-left: 0.55rem;\n}\n.form-check-custom.form-check-sm .form-check-input {\n  height: 1.55rem;\n  width: 1.55rem;\n}\n.form-check-custom.form-check-lg .form-check-input {\n  height: 2.25rem;\n  width: 2.25rem;\n}\n.form-check-custom.form-check-solid .form-check-input {\n  border: 0;\n  background-color: var(--kt-form-check-input-bg-solid);\n}\n.form-check-custom.form-check-solid .form-check-input:active, .form-check-custom.form-check-solid .form-check-input:focus {\n  filter: none;\n  background-color: var(--kt-form-check-input-bg-solid);\n}\n.form-check-custom.form-check-solid .form-check-input:checked {\n  background-color: var(--kt-form-check-input-checked-bg-color-solid);\n}\n.form-check-custom.form-check-success .form-check-input:checked {\n  background-color: var(--kt-success);\n}\n.form-check-custom.form-check-danger .form-check-input:checked {\n  background-color: var(--kt-danger);\n}\n.form-check-custom.form-check-warning .form-check-input:checked {\n  background-color: var(--kt-warning);\n}\n\n.form-switch.form-check-solid .form-check-input {\n  height: 2.25rem;\n  background-image: var(--kt-form-switch-bg-image-solid);\n  border-radius: 3.25rem;\n}\n.form-switch.form-check-solid .form-check-input:checked {\n  filter: none;\n  background-image: var(--kt-form-switch-checked-bg-image);\n}\n.form-switch.form-check-solid.form-switch-sm .form-check-input {\n  height: 1.5rem;\n  width: 2.5rem;\n}\n.form-switch.form-check-solid.form-switch-lg .form-check-input {\n  height: 2.75rem;\n  width: 3.75rem;\n}\n\n.form-check-clip {\n  position: relative;\n  overflow: hidden;\n}\n.form-check-clip .form-check-label {\n  padding-top: 0.5rem;\n  font-size: 1.05rem;\n  color: var(--kt-form-label-color);\n  font-weight: 500;\n}\n.form-check-clip .form-check-wrapper {\n  border-radius: 0.625rem;\n  border: 2px solid transparent;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  overflow: hidden;\n}\n.form-check-clip .form-check-indicator {\n  transition: all 0.2s ease-in-out;\n  position: absolute;\n  top: 0;\n  right: 0;\n  opacity: 0;\n  width: 1.75rem;\n  height: 1.75rem;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  background-size: 50%;\n  background-image: var(--kt-form-check-input-checked-bg-image);\n  background-color: var(--kt-component-checked-bg);\n  border-bottom-left-radius: 0.625rem;\n  border-top-right-radius: 0.625rem;\n}\n.form-check-clip .form-check-indicator.form-check-indicator-sm {\n  width: 1.55rem;\n  height: 1.55rem;\n}\n.form-check-clip .form-check-indicator.form-check-indicator-lg {\n  width: 2.25rem;\n  height: 2.25rem;\n}\n.form-check-clip .form-check-content {\n  width: 100%;\n}\n.form-check-clip .btn-check:checked + div {\n  border: 2px solid var(--kt-component-checked-bg);\n  transition: all 0.2s ease-in-out;\n}\n.form-check-clip .btn-check:checked + div .form-check-indicator {\n  transition: all 0.2s ease-in-out;\n  opacity: 1;\n}\n.form-check-clip .btn-check:disabled + div {\n  transition: all 0.2s ease-in-out;\n  opacity: var(--kt-form-check-btn-check-disabled-opacity);\n}\n\n.form-check-image {\n  position: relative;\n  overflow: hidden;\n}\n.form-check-image img {\n  max-width: 100%;\n}\n.form-check-image .form-check-wrapper {\n  border-radius: 0.625rem;\n  border: 2px solid transparent;\n  transition: all 0.2s ease-in-out;\n  cursor: pointer;\n  overflow: hidden;\n  margin-bottom: 0.75rem;\n}\n.form-check-image .form-check-rounded {\n  border-radius: 0.625rem;\n}\n.form-check-image .form-check-label {\n  font-weight: 600;\n  margin-left: 0.5rem;\n}\n.form-check-image.active .form-check-wrapper {\n  border-color: var(--kt-primary);\n}\n.form-check-image.form-check-success.active .form-check-wrapper {\n  border-color: var(--kt-success);\n}\n.form-check-image.form-check-danger.active .form-check-wrapper {\n  border-color: var(--kt-danger);\n}\n.form-check-image.disabled {\n  opacity: var(--kt-form-check-btn-check-disabled-opacity);\n}\n\n.input-group.input-group-solid {\n  border-radius: 0.475rem;\n}\n.input-group.input-group-solid.input-group-sm {\n  border-radius: 0.425rem;\n}\n.input-group.input-group-solid.input-group-lg {\n  border-radius: 0.625rem;\n}\n.input-group.input-group-solid .input-group-text {\n  background-color: var(--kt-input-solid-bg);\n  border-color: var(--kt-input-solid-bg);\n}\n.input-group.input-group-solid .input-group-text + .form-control {\n  border-left-color: var(--kt-input-border-color);\n}\n.input-group.input-group-solid .form-control {\n  background-color: var(--kt-input-solid-bg);\n  border-color: var(--kt-input-solid-bg);\n}\n.input-group.input-group-solid .form-control + .input-group-text {\n  border-left-color: var(--kt-input-border-color);\n}\n\n.form-floating .form-control.form-control-solid::placeholder {\n  color: transparent;\n}\n\n.required:after {\n  content: \"*\";\n  position: relative;\n  font-size: inherit;\n  color: var(--kt-danger);\n  padding-left: 0.25rem;\n  font-weight: 600;\n}\n\n.modal {\n  --bs-modal-color: var(--kt-modal-content-color);\n  --bs-modal-bg: var(--kt-modal-content-bg);\n  --bs-modal-border-color: var(--kt-modal-content-border-color);\n  --bs-modal-box-shadow: var(--kt-modal-content-box-shadow-xs);\n  --bs-modal-header-border-color: var(--kt-modal-header-border-color);\n  --bs-modal-footer-bg: var(--kt-modal-footer-bg);\n  --bs-modal-footer-border-color: var(--kt-modal-footer-border-color);\n}\n\n.modal-dialog {\n  outline: none !important;\n}\n\n.modal-header {\n  align-items: center;\n  justify-content: space-between;\n  border-top-left-radius: 0.475rem;\n  border-top-right-radius: 0.475rem;\n  border-bottom: 1px solid var(--kt-modal-header-border-color);\n}\n.modal-header h1, .modal-header .h1, .modal-header h2, .modal-header .h2, .modal-header h3, .modal-header .h3, .modal-header h4, .modal-header .h4, .modal-header h5, .modal-header .h5, .modal-header h6, .modal-header .h6 {\n  margin-bottom: 0;\n}\n\n.modal-content {\n  color: var(--kt-modal-color);\n  background-color: var(--kt-modal-bg);\n  border: 0 solid var(--kt-modal-border-color);\n  box-shadow: var(--kt-modal-box-shadow);\n}\n\n.modal-footer {\n  background-color: var(--kt-modal-footer-bg);\n  border-top: 1px solid var(--bs-modal-footer-border-color);\n}\n\n.modal-backdrop {\n  --bs-backdrop-bg: var(--kt-modal-backdrop-bg);\n  --bs-backdrop-opacity: var(--kt-modal-backdrop-opacity);\n}\n\n@media (min-width: 576px) {\n  .modal-content {\n    box-shadow: var(--kt-modal-box-shadow-sm-up);\n  }\n}\n.modal-rounded {\n  border-radius: 0.475rem !important;\n}\n\n.progress {\n  --bs-progress-bg: var(--kt-progress-bg);\n  --bs-progress-box-shadow: var(--kt-progress-box-shadow);\n  --bs-progress-bar-color: var(--kt-progress-bar-color);\n  --bs-progress-bar-bg: var(--kt-progress-bar-bg);\n}\n\n.progress-vertical {\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n}\n.progress-vertical .progress {\n  height: 100%;\n  border-radius: 0.475rem;\n  display: flex;\n  align-items: flex-end;\n  margin-right: 1rem;\n}\n.progress-vertical .progress:last-child {\n  margin-right: 0;\n}\n.progress-vertical .progress .progress-bar {\n  width: 8px;\n  border-radius: 0.475rem;\n}\n\n.table {\n  --bs-table-color: var(--kt-table-color);\n  --bs-table-bg: var(--kt-table-bg);\n  --bs-table-border-color: var(--kt-table-border-color);\n  --bs-table-accent-bg: var(--kt-table-accent-bg);\n  --bs-table-striped-color: var(--kt-table-striped-color);\n  --bs-table-striped-bg: var(--kt-table-striped-bg);\n  --bs-table-active-color: var(--kt-table-active-color);\n  --bs-table-active-bg: var(--kt-table-active-bg);\n  --bs-table-hover-color: var(--kt-table-hover-color);\n  --bs-table-hover-bg: var(--kt-table-hover-bg);\n}\n.table > :not(:first-child) {\n  border-color: transparent;\n  border-width: 0;\n  border-style: none;\n}\n.table > :not(:last-child) > :last-child > * {\n  border-bottom-color: inherit;\n}\n.table tr, .table th, .table td {\n  border-color: inherit;\n  border-width: inherit;\n  border-style: inherit;\n  text-transform: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  color: inherit;\n  height: inherit;\n  min-height: inherit;\n}\n.table tr:first-child, .table th:first-child, .table td:first-child {\n  padding-left: 0;\n}\n.table tr:last-child, .table th:last-child, .table td:last-child {\n  padding-right: 0;\n}\n.table tfoot tr:last-child,\n.table tbody tr:last-child {\n  border-bottom: 0 !important;\n}\n.table tfoot tr:last-child th, .table tfoot tr:last-child td,\n.table tbody tr:last-child th,\n.table tbody tr:last-child td {\n  border-bottom: 0 !important;\n}\n.table tfoot th, .table tfoot td {\n  border-top: inherit;\n}\n.table.table-rounded {\n  border-radius: 0.475rem;\n  border-spacing: 0;\n  border-collapse: separate;\n}\n.table.table-flush tr, .table.table-flush th, .table.table-flush td {\n  padding: inherit;\n}\n.table.table-row-bordered tr {\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  border-bottom-color: var(--kt-border-color);\n}\n.table.table-row-bordered tfoot th, .table.table-row-bordered tfoot td {\n  border-top-width: 1px !important;\n}\n.table.table-row-dashed tr {\n  border-bottom-width: 1px;\n  border-bottom-style: dashed;\n  border-bottom-color: var(--kt-border-color);\n}\n.table.table-row-dashed tfoot th, .table.table-row-dashed tfoot td {\n  border-top-width: 1px !important;\n}\n.table.table-row-gray-100 tr {\n  border-bottom-color: var(--kt-gray-100);\n}\n.table.table-row-gray-200 tr {\n  border-bottom-color: var(--kt-gray-200);\n}\n.table.table-row-gray-300 tr {\n  border-bottom-color: var(--kt-gray-300);\n}\n.table.table-row-gray-400 tr {\n  border-bottom-color: var(--kt-gray-400);\n}\n.table.table-row-gray-500 tr {\n  border-bottom-color: var(--kt-gray-500);\n}\n.table.table-row-gray-600 tr {\n  border-bottom-color: var(--kt-gray-600);\n}\n.table.table-row-gray-700 tr {\n  border-bottom-color: var(--kt-gray-700);\n}\n.table.table-row-gray-800 tr {\n  border-bottom-color: var(--kt-gray-800);\n}\n.table.table-row-gray-900 tr {\n  border-bottom-color: var(--kt-gray-900);\n}\n\n.table-layout-fixed {\n  table-layout: fixed;\n}\n\n.table-sort:after {\n  opacity: 0;\n}\n\n.table-sort,\n.table-sort-asc,\n.table-sort-desc {\n  vertical-align: middle;\n}\n.table-sort:after,\n.table-sort-asc:after,\n.table-sort-desc:after {\n  position: relative;\n  display: inline-block;\n  width: 0.75rem;\n  height: 0.75rem;\n  content: \" \";\n  bottom: auto;\n  right: auto;\n  left: auto;\n  margin-left: 0.5rem;\n}\n\n.table-sort-asc:after {\n  opacity: 1;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-muted%29'%3e%3cpath d='M3.23571 2.72011L4.97917 4.46358C5.15176 4.63618 5.43158 4.63617 5.60417 4.46358C5.77676 4.29099 5.77676 4.01118 5.60417 3.83861L3.29463 1.52904C3.13192 1.36629 2.86809 1.36629 2.70538 1.52904L0.395812 3.83861C0.22325 4.01117 0.22325 4.29099 0.395812 4.46358C0.568437 4.63617 0.84825 4.63617 1.02081 4.46358L2.76429 2.72011C2.89446 2.58994 3.10554 2.58994 3.23571 2.72011Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-muted%29'%3e%3cpath d='M3.23571 2.72011L4.97917 4.46358C5.15176 4.63618 5.43158 4.63617 5.60417 4.46358C5.77676 4.29099 5.77676 4.01118 5.60417 3.83861L3.29463 1.52904C3.13192 1.36629 2.86809 1.36629 2.70538 1.52904L0.395812 3.83861C0.22325 4.01117 0.22325 4.29099 0.395812 4.46358C0.568437 4.63617 0.84825 4.63617 1.02081 4.46358L2.76429 2.72011C2.89446 2.58994 3.10554 2.58994 3.23571 2.72011Z'/%3e%3c/svg%3e\");\n}\n\n.table-sort-desc:after {\n  opacity: 1;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-text-muted);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-muted%29'%3e%3cpath d='M2.76429 3.27989L1.02083 1.53642C0.848244 1.36382 0.568419 1.36383 0.395831 1.53642C0.223244 1.70901 0.223244 1.98882 0.395831 2.16139L2.70537 4.47096C2.86808 4.63371 3.13191 4.63371 3.29462 4.47096L5.60419 2.16139C5.77675 1.98883 5.77675 1.70901 5.60419 1.53642C5.43156 1.36383 5.15175 1.36383 4.97919 1.53642L3.23571 3.27989C3.10554 3.41006 2.89446 3.41006 2.76429 3.27989Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-text-muted%29'%3e%3cpath d='M2.76429 3.27989L1.02083 1.53642C0.848244 1.36382 0.568419 1.36383 0.395831 1.53642C0.223244 1.70901 0.223244 1.98882 0.395831 2.16139L2.70537 4.47096C2.86808 4.63371 3.13191 4.63371 3.29462 4.47096L5.60419 2.16139C5.77675 1.98883 5.77675 1.70901 5.60419 1.53642C5.43156 1.36383 5.15175 1.36383 4.97919 1.53642L3.23571 3.27989C3.10554 3.41006 2.89446 3.41006 2.76429 3.27989Z'/%3e%3c/svg%3e\");\n}\n\n.table-loading-message {\n  display: none;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  border-radius: 0.475rem;\n  box-shadow: var(--kt-table-loading-message-box-shadow);\n  background-color: var(--kt-table-loading-message-bg);\n  color: var(--kt-table-loading-message-color);\n  font-weight: 600;\n  margin: 0 !important;\n  width: auto;\n  padding: 0.85rem 2rem !important;\n  transform: translateX(-50%) translateY(-50%);\n}\n\n.table-loading {\n  position: relative;\n}\n.table-loading .table-loading-message {\n  display: block;\n}\n\n.table.g-0 th, .table.g-0 td {\n  padding: 0rem;\n}\n.table.g-0 th.dtr-control, .table.g-0 td.dtr-control {\n  padding-left: 0rem !important;\n}\n\n.table.gy-0 th, .table.gy-0 td {\n  padding-top: 0rem;\n  padding-bottom: 0rem;\n}\n\n.table.gx-0 th, .table.gx-0 td {\n  padding-left: 0rem;\n  padding-right: 0rem;\n}\n.table.gx-0 th.dtr-control, .table.gx-0 td.dtr-control {\n  padding-left: 0rem !important;\n}\n\n.table.gs-0 th:first-child, .table.gs-0 td:first-child {\n  padding-left: 0rem;\n}\n.table.gs-0 th:last-child, .table.gs-0 td:last-child {\n  padding-right: 0rem;\n}\n.table.gs-0 th.dtr-control:first-child, .table.gs-0 td.dtr-control:first-child {\n  padding-left: 0rem !important;\n}\n\n.table.g-1 th, .table.g-1 td {\n  padding: 0.25rem;\n}\n.table.g-1 th.dtr-control, .table.g-1 td.dtr-control {\n  padding-left: 0.25rem !important;\n}\n\n.table.gy-1 th, .table.gy-1 td {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n\n.table.gx-1 th, .table.gx-1 td {\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n.table.gx-1 th.dtr-control, .table.gx-1 td.dtr-control {\n  padding-left: 0.25rem !important;\n}\n\n.table.gs-1 th:first-child, .table.gs-1 td:first-child {\n  padding-left: 0.25rem;\n}\n.table.gs-1 th:last-child, .table.gs-1 td:last-child {\n  padding-right: 0.25rem;\n}\n.table.gs-1 th.dtr-control:first-child, .table.gs-1 td.dtr-control:first-child {\n  padding-left: 0.25rem !important;\n}\n\n.table.g-2 th, .table.g-2 td {\n  padding: 0.5rem;\n}\n.table.g-2 th.dtr-control, .table.g-2 td.dtr-control {\n  padding-left: 0.5rem !important;\n}\n\n.table.gy-2 th, .table.gy-2 td {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.table.gx-2 th, .table.gx-2 td {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n.table.gx-2 th.dtr-control, .table.gx-2 td.dtr-control {\n  padding-left: 0.5rem !important;\n}\n\n.table.gs-2 th:first-child, .table.gs-2 td:first-child {\n  padding-left: 0.5rem;\n}\n.table.gs-2 th:last-child, .table.gs-2 td:last-child {\n  padding-right: 0.5rem;\n}\n.table.gs-2 th.dtr-control:first-child, .table.gs-2 td.dtr-control:first-child {\n  padding-left: 0.5rem !important;\n}\n\n.table.g-3 th, .table.g-3 td {\n  padding: 0.75rem;\n}\n.table.g-3 th.dtr-control, .table.g-3 td.dtr-control {\n  padding-left: 0.75rem !important;\n}\n\n.table.gy-3 th, .table.gy-3 td {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.table.gx-3 th, .table.gx-3 td {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n.table.gx-3 th.dtr-control, .table.gx-3 td.dtr-control {\n  padding-left: 0.75rem !important;\n}\n\n.table.gs-3 th:first-child, .table.gs-3 td:first-child {\n  padding-left: 0.75rem;\n}\n.table.gs-3 th:last-child, .table.gs-3 td:last-child {\n  padding-right: 0.75rem;\n}\n.table.gs-3 th.dtr-control:first-child, .table.gs-3 td.dtr-control:first-child {\n  padding-left: 0.75rem !important;\n}\n\n.table.g-4 th, .table.g-4 td {\n  padding: 1rem;\n}\n.table.g-4 th.dtr-control, .table.g-4 td.dtr-control {\n  padding-left: 1rem !important;\n}\n\n.table.gy-4 th, .table.gy-4 td {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.table.gx-4 th, .table.gx-4 td {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n.table.gx-4 th.dtr-control, .table.gx-4 td.dtr-control {\n  padding-left: 1rem !important;\n}\n\n.table.gs-4 th:first-child, .table.gs-4 td:first-child {\n  padding-left: 1rem;\n}\n.table.gs-4 th:last-child, .table.gs-4 td:last-child {\n  padding-right: 1rem;\n}\n.table.gs-4 th.dtr-control:first-child, .table.gs-4 td.dtr-control:first-child {\n  padding-left: 1rem !important;\n}\n\n.table.g-5 th, .table.g-5 td {\n  padding: 1.25rem;\n}\n.table.g-5 th.dtr-control, .table.g-5 td.dtr-control {\n  padding-left: 1.25rem !important;\n}\n\n.table.gy-5 th, .table.gy-5 td {\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n}\n\n.table.gx-5 th, .table.gx-5 td {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n.table.gx-5 th.dtr-control, .table.gx-5 td.dtr-control {\n  padding-left: 1.25rem !important;\n}\n\n.table.gs-5 th:first-child, .table.gs-5 td:first-child {\n  padding-left: 1.25rem;\n}\n.table.gs-5 th:last-child, .table.gs-5 td:last-child {\n  padding-right: 1.25rem;\n}\n.table.gs-5 th.dtr-control:first-child, .table.gs-5 td.dtr-control:first-child {\n  padding-left: 1.25rem !important;\n}\n\n.table.g-6 th, .table.g-6 td {\n  padding: 1.5rem;\n}\n.table.g-6 th.dtr-control, .table.g-6 td.dtr-control {\n  padding-left: 1.5rem !important;\n}\n\n.table.gy-6 th, .table.gy-6 td {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n\n.table.gx-6 th, .table.gx-6 td {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n.table.gx-6 th.dtr-control, .table.gx-6 td.dtr-control {\n  padding-left: 1.5rem !important;\n}\n\n.table.gs-6 th:first-child, .table.gs-6 td:first-child {\n  padding-left: 1.5rem;\n}\n.table.gs-6 th:last-child, .table.gs-6 td:last-child {\n  padding-right: 1.5rem;\n}\n.table.gs-6 th.dtr-control:first-child, .table.gs-6 td.dtr-control:first-child {\n  padding-left: 1.5rem !important;\n}\n\n.table.g-7 th, .table.g-7 td {\n  padding: 1.75rem;\n}\n.table.g-7 th.dtr-control, .table.g-7 td.dtr-control {\n  padding-left: 1.75rem !important;\n}\n\n.table.gy-7 th, .table.gy-7 td {\n  padding-top: 1.75rem;\n  padding-bottom: 1.75rem;\n}\n\n.table.gx-7 th, .table.gx-7 td {\n  padding-left: 1.75rem;\n  padding-right: 1.75rem;\n}\n.table.gx-7 th.dtr-control, .table.gx-7 td.dtr-control {\n  padding-left: 1.75rem !important;\n}\n\n.table.gs-7 th:first-child, .table.gs-7 td:first-child {\n  padding-left: 1.75rem;\n}\n.table.gs-7 th:last-child, .table.gs-7 td:last-child {\n  padding-right: 1.75rem;\n}\n.table.gs-7 th.dtr-control:first-child, .table.gs-7 td.dtr-control:first-child {\n  padding-left: 1.75rem !important;\n}\n\n.table.g-8 th, .table.g-8 td {\n  padding: 2rem;\n}\n.table.g-8 th.dtr-control, .table.g-8 td.dtr-control {\n  padding-left: 2rem !important;\n}\n\n.table.gy-8 th, .table.gy-8 td {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\n.table.gx-8 th, .table.gx-8 td {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n.table.gx-8 th.dtr-control, .table.gx-8 td.dtr-control {\n  padding-left: 2rem !important;\n}\n\n.table.gs-8 th:first-child, .table.gs-8 td:first-child {\n  padding-left: 2rem;\n}\n.table.gs-8 th:last-child, .table.gs-8 td:last-child {\n  padding-right: 2rem;\n}\n.table.gs-8 th.dtr-control:first-child, .table.gs-8 td.dtr-control:first-child {\n  padding-left: 2rem !important;\n}\n\n.table.g-9 th, .table.g-9 td {\n  padding: 2.25rem;\n}\n.table.g-9 th.dtr-control, .table.g-9 td.dtr-control {\n  padding-left: 2.25rem !important;\n}\n\n.table.gy-9 th, .table.gy-9 td {\n  padding-top: 2.25rem;\n  padding-bottom: 2.25rem;\n}\n\n.table.gx-9 th, .table.gx-9 td {\n  padding-left: 2.25rem;\n  padding-right: 2.25rem;\n}\n.table.gx-9 th.dtr-control, .table.gx-9 td.dtr-control {\n  padding-left: 2.25rem !important;\n}\n\n.table.gs-9 th:first-child, .table.gs-9 td:first-child {\n  padding-left: 2.25rem;\n}\n.table.gs-9 th:last-child, .table.gs-9 td:last-child {\n  padding-right: 2.25rem;\n}\n.table.gs-9 th.dtr-control:first-child, .table.gs-9 td.dtr-control:first-child {\n  padding-left: 2.25rem !important;\n}\n\n.table.g-10 th, .table.g-10 td {\n  padding: 2.5rem;\n}\n.table.g-10 th.dtr-control, .table.g-10 td.dtr-control {\n  padding-left: 2.5rem !important;\n}\n\n.table.gy-10 th, .table.gy-10 td {\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n}\n\n.table.gx-10 th, .table.gx-10 td {\n  padding-left: 2.5rem;\n  padding-right: 2.5rem;\n}\n.table.gx-10 th.dtr-control, .table.gx-10 td.dtr-control {\n  padding-left: 2.5rem !important;\n}\n\n.table.gs-10 th:first-child, .table.gs-10 td:first-child {\n  padding-left: 2.5rem;\n}\n.table.gs-10 th:last-child, .table.gs-10 td:last-child {\n  padding-right: 2.5rem;\n}\n.table.gs-10 th.dtr-control:first-child, .table.gs-10 td.dtr-control:first-child {\n  padding-left: 2.5rem !important;\n}\n\n@media (min-width: 576px) {\n  .table.g-sm-0 th, .table.g-sm-0 td {\n    padding: 0rem;\n  }\n  .table.g-sm-0 th.dtr-control, .table.g-sm-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gy-sm-0 th, .table.gy-sm-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n\n  .table.gx-sm-0 th, .table.gx-sm-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-sm-0 th.dtr-control, .table.gx-sm-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gs-sm-0 th:first-child, .table.gs-sm-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-sm-0 th:last-child, .table.gs-sm-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-sm-0 th.dtr-control:first-child, .table.gs-sm-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n\n  .table.g-sm-1 th, .table.g-sm-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-sm-1 th.dtr-control, .table.g-sm-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gy-sm-1 th, .table.gy-sm-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .table.gx-sm-1 th, .table.gx-sm-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-sm-1 th.dtr-control, .table.gx-sm-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gs-sm-1 th:first-child, .table.gs-sm-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-sm-1 th:last-child, .table.gs-sm-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-sm-1 th.dtr-control:first-child, .table.gs-sm-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.g-sm-2 th, .table.g-sm-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-sm-2 th.dtr-control, .table.g-sm-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gy-sm-2 th, .table.gy-sm-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .table.gx-sm-2 th, .table.gx-sm-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-sm-2 th.dtr-control, .table.gx-sm-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gs-sm-2 th:first-child, .table.gs-sm-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-sm-2 th:last-child, .table.gs-sm-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-sm-2 th.dtr-control:first-child, .table.gs-sm-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.g-sm-3 th, .table.g-sm-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-sm-3 th.dtr-control, .table.g-sm-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gy-sm-3 th, .table.gy-sm-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .table.gx-sm-3 th, .table.gx-sm-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-sm-3 th.dtr-control, .table.gx-sm-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gs-sm-3 th:first-child, .table.gs-sm-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-sm-3 th:last-child, .table.gs-sm-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-sm-3 th.dtr-control:first-child, .table.gs-sm-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.g-sm-4 th, .table.g-sm-4 td {\n    padding: 1rem;\n  }\n  .table.g-sm-4 th.dtr-control, .table.g-sm-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gy-sm-4 th, .table.gy-sm-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .table.gx-sm-4 th, .table.gx-sm-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-sm-4 th.dtr-control, .table.gx-sm-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gs-sm-4 th:first-child, .table.gs-sm-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-sm-4 th:last-child, .table.gs-sm-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-sm-4 th.dtr-control:first-child, .table.gs-sm-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n\n  .table.g-sm-5 th, .table.g-sm-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-sm-5 th.dtr-control, .table.g-sm-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gy-sm-5 th, .table.gy-sm-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .table.gx-sm-5 th, .table.gx-sm-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-sm-5 th.dtr-control, .table.gx-sm-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gs-sm-5 th:first-child, .table.gs-sm-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-sm-5 th:last-child, .table.gs-sm-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-sm-5 th.dtr-control:first-child, .table.gs-sm-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.g-sm-6 th, .table.g-sm-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-sm-6 th.dtr-control, .table.g-sm-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gy-sm-6 th, .table.gy-sm-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .table.gx-sm-6 th, .table.gx-sm-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-sm-6 th.dtr-control, .table.gx-sm-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gs-sm-6 th:first-child, .table.gs-sm-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-sm-6 th:last-child, .table.gs-sm-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-sm-6 th.dtr-control:first-child, .table.gs-sm-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.g-sm-7 th, .table.g-sm-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-sm-7 th.dtr-control, .table.g-sm-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gy-sm-7 th, .table.gy-sm-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n\n  .table.gx-sm-7 th, .table.gx-sm-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-sm-7 th.dtr-control, .table.gx-sm-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gs-sm-7 th:first-child, .table.gs-sm-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-sm-7 th:last-child, .table.gs-sm-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-sm-7 th.dtr-control:first-child, .table.gs-sm-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.g-sm-8 th, .table.g-sm-8 td {\n    padding: 2rem;\n  }\n  .table.g-sm-8 th.dtr-control, .table.g-sm-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gy-sm-8 th, .table.gy-sm-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .table.gx-sm-8 th, .table.gx-sm-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-sm-8 th.dtr-control, .table.gx-sm-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gs-sm-8 th:first-child, .table.gs-sm-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-sm-8 th:last-child, .table.gs-sm-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-sm-8 th.dtr-control:first-child, .table.gs-sm-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n\n  .table.g-sm-9 th, .table.g-sm-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-sm-9 th.dtr-control, .table.g-sm-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gy-sm-9 th, .table.gy-sm-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n\n  .table.gx-sm-9 th, .table.gx-sm-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-sm-9 th.dtr-control, .table.gx-sm-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gs-sm-9 th:first-child, .table.gs-sm-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-sm-9 th:last-child, .table.gs-sm-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-sm-9 th.dtr-control:first-child, .table.gs-sm-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.g-sm-10 th, .table.g-sm-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-sm-10 th.dtr-control, .table.g-sm-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gy-sm-10 th, .table.gy-sm-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .table.gx-sm-10 th, .table.gx-sm-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-sm-10 th.dtr-control, .table.gx-sm-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gs-sm-10 th:first-child, .table.gs-sm-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-sm-10 th:last-child, .table.gs-sm-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-sm-10 th.dtr-control:first-child, .table.gs-sm-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 768px) {\n  .table.g-md-0 th, .table.g-md-0 td {\n    padding: 0rem;\n  }\n  .table.g-md-0 th.dtr-control, .table.g-md-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gy-md-0 th, .table.gy-md-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n\n  .table.gx-md-0 th, .table.gx-md-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-md-0 th.dtr-control, .table.gx-md-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gs-md-0 th:first-child, .table.gs-md-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-md-0 th:last-child, .table.gs-md-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-md-0 th.dtr-control:first-child, .table.gs-md-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n\n  .table.g-md-1 th, .table.g-md-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-md-1 th.dtr-control, .table.g-md-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gy-md-1 th, .table.gy-md-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .table.gx-md-1 th, .table.gx-md-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-md-1 th.dtr-control, .table.gx-md-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gs-md-1 th:first-child, .table.gs-md-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-md-1 th:last-child, .table.gs-md-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-md-1 th.dtr-control:first-child, .table.gs-md-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.g-md-2 th, .table.g-md-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-md-2 th.dtr-control, .table.g-md-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gy-md-2 th, .table.gy-md-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .table.gx-md-2 th, .table.gx-md-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-md-2 th.dtr-control, .table.gx-md-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gs-md-2 th:first-child, .table.gs-md-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-md-2 th:last-child, .table.gs-md-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-md-2 th.dtr-control:first-child, .table.gs-md-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.g-md-3 th, .table.g-md-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-md-3 th.dtr-control, .table.g-md-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gy-md-3 th, .table.gy-md-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .table.gx-md-3 th, .table.gx-md-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-md-3 th.dtr-control, .table.gx-md-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gs-md-3 th:first-child, .table.gs-md-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-md-3 th:last-child, .table.gs-md-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-md-3 th.dtr-control:first-child, .table.gs-md-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.g-md-4 th, .table.g-md-4 td {\n    padding: 1rem;\n  }\n  .table.g-md-4 th.dtr-control, .table.g-md-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gy-md-4 th, .table.gy-md-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .table.gx-md-4 th, .table.gx-md-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-md-4 th.dtr-control, .table.gx-md-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gs-md-4 th:first-child, .table.gs-md-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-md-4 th:last-child, .table.gs-md-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-md-4 th.dtr-control:first-child, .table.gs-md-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n\n  .table.g-md-5 th, .table.g-md-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-md-5 th.dtr-control, .table.g-md-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gy-md-5 th, .table.gy-md-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .table.gx-md-5 th, .table.gx-md-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-md-5 th.dtr-control, .table.gx-md-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gs-md-5 th:first-child, .table.gs-md-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-md-5 th:last-child, .table.gs-md-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-md-5 th.dtr-control:first-child, .table.gs-md-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.g-md-6 th, .table.g-md-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-md-6 th.dtr-control, .table.g-md-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gy-md-6 th, .table.gy-md-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .table.gx-md-6 th, .table.gx-md-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-md-6 th.dtr-control, .table.gx-md-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gs-md-6 th:first-child, .table.gs-md-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-md-6 th:last-child, .table.gs-md-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-md-6 th.dtr-control:first-child, .table.gs-md-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.g-md-7 th, .table.g-md-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-md-7 th.dtr-control, .table.g-md-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gy-md-7 th, .table.gy-md-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n\n  .table.gx-md-7 th, .table.gx-md-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-md-7 th.dtr-control, .table.gx-md-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gs-md-7 th:first-child, .table.gs-md-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-md-7 th:last-child, .table.gs-md-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-md-7 th.dtr-control:first-child, .table.gs-md-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.g-md-8 th, .table.g-md-8 td {\n    padding: 2rem;\n  }\n  .table.g-md-8 th.dtr-control, .table.g-md-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gy-md-8 th, .table.gy-md-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .table.gx-md-8 th, .table.gx-md-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-md-8 th.dtr-control, .table.gx-md-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gs-md-8 th:first-child, .table.gs-md-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-md-8 th:last-child, .table.gs-md-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-md-8 th.dtr-control:first-child, .table.gs-md-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n\n  .table.g-md-9 th, .table.g-md-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-md-9 th.dtr-control, .table.g-md-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gy-md-9 th, .table.gy-md-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n\n  .table.gx-md-9 th, .table.gx-md-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-md-9 th.dtr-control, .table.gx-md-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gs-md-9 th:first-child, .table.gs-md-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-md-9 th:last-child, .table.gs-md-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-md-9 th.dtr-control:first-child, .table.gs-md-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.g-md-10 th, .table.g-md-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-md-10 th.dtr-control, .table.g-md-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gy-md-10 th, .table.gy-md-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .table.gx-md-10 th, .table.gx-md-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-md-10 th.dtr-control, .table.gx-md-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gs-md-10 th:first-child, .table.gs-md-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-md-10 th:last-child, .table.gs-md-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-md-10 th.dtr-control:first-child, .table.gs-md-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 992px) {\n  .table.g-lg-0 th, .table.g-lg-0 td {\n    padding: 0rem;\n  }\n  .table.g-lg-0 th.dtr-control, .table.g-lg-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gy-lg-0 th, .table.gy-lg-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n\n  .table.gx-lg-0 th, .table.gx-lg-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-lg-0 th.dtr-control, .table.gx-lg-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gs-lg-0 th:first-child, .table.gs-lg-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-lg-0 th:last-child, .table.gs-lg-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-lg-0 th.dtr-control:first-child, .table.gs-lg-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n\n  .table.g-lg-1 th, .table.g-lg-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-lg-1 th.dtr-control, .table.g-lg-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gy-lg-1 th, .table.gy-lg-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .table.gx-lg-1 th, .table.gx-lg-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-lg-1 th.dtr-control, .table.gx-lg-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gs-lg-1 th:first-child, .table.gs-lg-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-lg-1 th:last-child, .table.gs-lg-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-lg-1 th.dtr-control:first-child, .table.gs-lg-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.g-lg-2 th, .table.g-lg-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-lg-2 th.dtr-control, .table.g-lg-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gy-lg-2 th, .table.gy-lg-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .table.gx-lg-2 th, .table.gx-lg-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-lg-2 th.dtr-control, .table.gx-lg-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gs-lg-2 th:first-child, .table.gs-lg-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-lg-2 th:last-child, .table.gs-lg-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-lg-2 th.dtr-control:first-child, .table.gs-lg-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.g-lg-3 th, .table.g-lg-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-lg-3 th.dtr-control, .table.g-lg-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gy-lg-3 th, .table.gy-lg-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .table.gx-lg-3 th, .table.gx-lg-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-lg-3 th.dtr-control, .table.gx-lg-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gs-lg-3 th:first-child, .table.gs-lg-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-lg-3 th:last-child, .table.gs-lg-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-lg-3 th.dtr-control:first-child, .table.gs-lg-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.g-lg-4 th, .table.g-lg-4 td {\n    padding: 1rem;\n  }\n  .table.g-lg-4 th.dtr-control, .table.g-lg-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gy-lg-4 th, .table.gy-lg-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .table.gx-lg-4 th, .table.gx-lg-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-lg-4 th.dtr-control, .table.gx-lg-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gs-lg-4 th:first-child, .table.gs-lg-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-lg-4 th:last-child, .table.gs-lg-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-lg-4 th.dtr-control:first-child, .table.gs-lg-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n\n  .table.g-lg-5 th, .table.g-lg-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-lg-5 th.dtr-control, .table.g-lg-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gy-lg-5 th, .table.gy-lg-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .table.gx-lg-5 th, .table.gx-lg-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-lg-5 th.dtr-control, .table.gx-lg-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gs-lg-5 th:first-child, .table.gs-lg-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-lg-5 th:last-child, .table.gs-lg-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-lg-5 th.dtr-control:first-child, .table.gs-lg-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.g-lg-6 th, .table.g-lg-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-lg-6 th.dtr-control, .table.g-lg-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gy-lg-6 th, .table.gy-lg-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .table.gx-lg-6 th, .table.gx-lg-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-lg-6 th.dtr-control, .table.gx-lg-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gs-lg-6 th:first-child, .table.gs-lg-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-lg-6 th:last-child, .table.gs-lg-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-lg-6 th.dtr-control:first-child, .table.gs-lg-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.g-lg-7 th, .table.g-lg-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-lg-7 th.dtr-control, .table.g-lg-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gy-lg-7 th, .table.gy-lg-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n\n  .table.gx-lg-7 th, .table.gx-lg-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-lg-7 th.dtr-control, .table.gx-lg-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gs-lg-7 th:first-child, .table.gs-lg-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-lg-7 th:last-child, .table.gs-lg-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-lg-7 th.dtr-control:first-child, .table.gs-lg-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.g-lg-8 th, .table.g-lg-8 td {\n    padding: 2rem;\n  }\n  .table.g-lg-8 th.dtr-control, .table.g-lg-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gy-lg-8 th, .table.gy-lg-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .table.gx-lg-8 th, .table.gx-lg-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-lg-8 th.dtr-control, .table.gx-lg-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gs-lg-8 th:first-child, .table.gs-lg-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-lg-8 th:last-child, .table.gs-lg-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-lg-8 th.dtr-control:first-child, .table.gs-lg-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n\n  .table.g-lg-9 th, .table.g-lg-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-lg-9 th.dtr-control, .table.g-lg-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gy-lg-9 th, .table.gy-lg-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n\n  .table.gx-lg-9 th, .table.gx-lg-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-lg-9 th.dtr-control, .table.gx-lg-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gs-lg-9 th:first-child, .table.gs-lg-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-lg-9 th:last-child, .table.gs-lg-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-lg-9 th.dtr-control:first-child, .table.gs-lg-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.g-lg-10 th, .table.g-lg-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-lg-10 th.dtr-control, .table.g-lg-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gy-lg-10 th, .table.gy-lg-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .table.gx-lg-10 th, .table.gx-lg-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-lg-10 th.dtr-control, .table.gx-lg-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gs-lg-10 th:first-child, .table.gs-lg-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-lg-10 th:last-child, .table.gs-lg-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-lg-10 th.dtr-control:first-child, .table.gs-lg-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 1200px) {\n  .table.g-xl-0 th, .table.g-xl-0 td {\n    padding: 0rem;\n  }\n  .table.g-xl-0 th.dtr-control, .table.g-xl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gy-xl-0 th, .table.gy-xl-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n\n  .table.gx-xl-0 th, .table.gx-xl-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-xl-0 th.dtr-control, .table.gx-xl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gs-xl-0 th:first-child, .table.gs-xl-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-xl-0 th:last-child, .table.gs-xl-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-xl-0 th.dtr-control:first-child, .table.gs-xl-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n\n  .table.g-xl-1 th, .table.g-xl-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-xl-1 th.dtr-control, .table.g-xl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gy-xl-1 th, .table.gy-xl-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .table.gx-xl-1 th, .table.gx-xl-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-xl-1 th.dtr-control, .table.gx-xl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gs-xl-1 th:first-child, .table.gs-xl-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-xl-1 th:last-child, .table.gs-xl-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-xl-1 th.dtr-control:first-child, .table.gs-xl-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.g-xl-2 th, .table.g-xl-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-xl-2 th.dtr-control, .table.g-xl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gy-xl-2 th, .table.gy-xl-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .table.gx-xl-2 th, .table.gx-xl-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-xl-2 th.dtr-control, .table.gx-xl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gs-xl-2 th:first-child, .table.gs-xl-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-xl-2 th:last-child, .table.gs-xl-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-xl-2 th.dtr-control:first-child, .table.gs-xl-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.g-xl-3 th, .table.g-xl-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-xl-3 th.dtr-control, .table.g-xl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gy-xl-3 th, .table.gy-xl-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .table.gx-xl-3 th, .table.gx-xl-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-xl-3 th.dtr-control, .table.gx-xl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gs-xl-3 th:first-child, .table.gs-xl-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-xl-3 th:last-child, .table.gs-xl-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-xl-3 th.dtr-control:first-child, .table.gs-xl-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.g-xl-4 th, .table.g-xl-4 td {\n    padding: 1rem;\n  }\n  .table.g-xl-4 th.dtr-control, .table.g-xl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gy-xl-4 th, .table.gy-xl-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .table.gx-xl-4 th, .table.gx-xl-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-xl-4 th.dtr-control, .table.gx-xl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gs-xl-4 th:first-child, .table.gs-xl-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-xl-4 th:last-child, .table.gs-xl-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-xl-4 th.dtr-control:first-child, .table.gs-xl-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n\n  .table.g-xl-5 th, .table.g-xl-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-xl-5 th.dtr-control, .table.g-xl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gy-xl-5 th, .table.gy-xl-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .table.gx-xl-5 th, .table.gx-xl-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-xl-5 th.dtr-control, .table.gx-xl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gs-xl-5 th:first-child, .table.gs-xl-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-xl-5 th:last-child, .table.gs-xl-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-xl-5 th.dtr-control:first-child, .table.gs-xl-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.g-xl-6 th, .table.g-xl-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-xl-6 th.dtr-control, .table.g-xl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gy-xl-6 th, .table.gy-xl-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .table.gx-xl-6 th, .table.gx-xl-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-xl-6 th.dtr-control, .table.gx-xl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gs-xl-6 th:first-child, .table.gs-xl-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-xl-6 th:last-child, .table.gs-xl-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-xl-6 th.dtr-control:first-child, .table.gs-xl-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.g-xl-7 th, .table.g-xl-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-xl-7 th.dtr-control, .table.g-xl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gy-xl-7 th, .table.gy-xl-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n\n  .table.gx-xl-7 th, .table.gx-xl-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-xl-7 th.dtr-control, .table.gx-xl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gs-xl-7 th:first-child, .table.gs-xl-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-xl-7 th:last-child, .table.gs-xl-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-xl-7 th.dtr-control:first-child, .table.gs-xl-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.g-xl-8 th, .table.g-xl-8 td {\n    padding: 2rem;\n  }\n  .table.g-xl-8 th.dtr-control, .table.g-xl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gy-xl-8 th, .table.gy-xl-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .table.gx-xl-8 th, .table.gx-xl-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-xl-8 th.dtr-control, .table.gx-xl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gs-xl-8 th:first-child, .table.gs-xl-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-xl-8 th:last-child, .table.gs-xl-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-xl-8 th.dtr-control:first-child, .table.gs-xl-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n\n  .table.g-xl-9 th, .table.g-xl-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-xl-9 th.dtr-control, .table.g-xl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gy-xl-9 th, .table.gy-xl-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n\n  .table.gx-xl-9 th, .table.gx-xl-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-xl-9 th.dtr-control, .table.gx-xl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gs-xl-9 th:first-child, .table.gs-xl-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-xl-9 th:last-child, .table.gs-xl-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-xl-9 th.dtr-control:first-child, .table.gs-xl-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.g-xl-10 th, .table.g-xl-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-xl-10 th.dtr-control, .table.g-xl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gy-xl-10 th, .table.gy-xl-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .table.gx-xl-10 th, .table.gx-xl-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-xl-10 th.dtr-control, .table.gx-xl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gs-xl-10 th:first-child, .table.gs-xl-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-xl-10 th:last-child, .table.gs-xl-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-xl-10 th.dtr-control:first-child, .table.gs-xl-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n@media (min-width: 1400px) {\n  .table.g-xxl-0 th, .table.g-xxl-0 td {\n    padding: 0rem;\n  }\n  .table.g-xxl-0 th.dtr-control, .table.g-xxl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gy-xxl-0 th, .table.gy-xxl-0 td {\n    padding-top: 0rem;\n    padding-bottom: 0rem;\n  }\n\n  .table.gx-xxl-0 th, .table.gx-xxl-0 td {\n    padding-left: 0rem;\n    padding-right: 0rem;\n  }\n  .table.gx-xxl-0 th.dtr-control, .table.gx-xxl-0 td.dtr-control {\n    padding-left: 0rem !important;\n  }\n\n  .table.gs-xxl-0 th:first-child, .table.gs-xxl-0 td:first-child {\n    padding-left: 0rem;\n  }\n  .table.gs-xxl-0 th:last-child, .table.gs-xxl-0 td:last-child {\n    padding-right: 0rem;\n  }\n  .table.gs-xxl-0 th.dtr-control:first-child, .table.gs-xxl-0 td.dtr-control:first-child {\n    padding-left: 0rem !important;\n  }\n\n  .table.g-xxl-1 th, .table.g-xxl-1 td {\n    padding: 0.25rem;\n  }\n  .table.g-xxl-1 th.dtr-control, .table.g-xxl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gy-xxl-1 th, .table.gy-xxl-1 td {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .table.gx-xxl-1 th, .table.gx-xxl-1 td {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n  .table.gx-xxl-1 th.dtr-control, .table.gx-xxl-1 td.dtr-control {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.gs-xxl-1 th:first-child, .table.gs-xxl-1 td:first-child {\n    padding-left: 0.25rem;\n  }\n  .table.gs-xxl-1 th:last-child, .table.gs-xxl-1 td:last-child {\n    padding-right: 0.25rem;\n  }\n  .table.gs-xxl-1 th.dtr-control:first-child, .table.gs-xxl-1 td.dtr-control:first-child {\n    padding-left: 0.25rem !important;\n  }\n\n  .table.g-xxl-2 th, .table.g-xxl-2 td {\n    padding: 0.5rem;\n  }\n  .table.g-xxl-2 th.dtr-control, .table.g-xxl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gy-xxl-2 th, .table.gy-xxl-2 td {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .table.gx-xxl-2 th, .table.gx-xxl-2 td {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .table.gx-xxl-2 th.dtr-control, .table.gx-xxl-2 td.dtr-control {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.gs-xxl-2 th:first-child, .table.gs-xxl-2 td:first-child {\n    padding-left: 0.5rem;\n  }\n  .table.gs-xxl-2 th:last-child, .table.gs-xxl-2 td:last-child {\n    padding-right: 0.5rem;\n  }\n  .table.gs-xxl-2 th.dtr-control:first-child, .table.gs-xxl-2 td.dtr-control:first-child {\n    padding-left: 0.5rem !important;\n  }\n\n  .table.g-xxl-3 th, .table.g-xxl-3 td {\n    padding: 0.75rem;\n  }\n  .table.g-xxl-3 th.dtr-control, .table.g-xxl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gy-xxl-3 th, .table.gy-xxl-3 td {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .table.gx-xxl-3 th, .table.gx-xxl-3 td {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n  .table.gx-xxl-3 th.dtr-control, .table.gx-xxl-3 td.dtr-control {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.gs-xxl-3 th:first-child, .table.gs-xxl-3 td:first-child {\n    padding-left: 0.75rem;\n  }\n  .table.gs-xxl-3 th:last-child, .table.gs-xxl-3 td:last-child {\n    padding-right: 0.75rem;\n  }\n  .table.gs-xxl-3 th.dtr-control:first-child, .table.gs-xxl-3 td.dtr-control:first-child {\n    padding-left: 0.75rem !important;\n  }\n\n  .table.g-xxl-4 th, .table.g-xxl-4 td {\n    padding: 1rem;\n  }\n  .table.g-xxl-4 th.dtr-control, .table.g-xxl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gy-xxl-4 th, .table.gy-xxl-4 td {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .table.gx-xxl-4 th, .table.gx-xxl-4 td {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n  .table.gx-xxl-4 th.dtr-control, .table.gx-xxl-4 td.dtr-control {\n    padding-left: 1rem !important;\n  }\n\n  .table.gs-xxl-4 th:first-child, .table.gs-xxl-4 td:first-child {\n    padding-left: 1rem;\n  }\n  .table.gs-xxl-4 th:last-child, .table.gs-xxl-4 td:last-child {\n    padding-right: 1rem;\n  }\n  .table.gs-xxl-4 th.dtr-control:first-child, .table.gs-xxl-4 td.dtr-control:first-child {\n    padding-left: 1rem !important;\n  }\n\n  .table.g-xxl-5 th, .table.g-xxl-5 td {\n    padding: 1.25rem;\n  }\n  .table.g-xxl-5 th.dtr-control, .table.g-xxl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gy-xxl-5 th, .table.gy-xxl-5 td {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .table.gx-xxl-5 th, .table.gx-xxl-5 td {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n  .table.gx-xxl-5 th.dtr-control, .table.gx-xxl-5 td.dtr-control {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.gs-xxl-5 th:first-child, .table.gs-xxl-5 td:first-child {\n    padding-left: 1.25rem;\n  }\n  .table.gs-xxl-5 th:last-child, .table.gs-xxl-5 td:last-child {\n    padding-right: 1.25rem;\n  }\n  .table.gs-xxl-5 th.dtr-control:first-child, .table.gs-xxl-5 td.dtr-control:first-child {\n    padding-left: 1.25rem !important;\n  }\n\n  .table.g-xxl-6 th, .table.g-xxl-6 td {\n    padding: 1.5rem;\n  }\n  .table.g-xxl-6 th.dtr-control, .table.g-xxl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gy-xxl-6 th, .table.gy-xxl-6 td {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .table.gx-xxl-6 th, .table.gx-xxl-6 td {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n  .table.gx-xxl-6 th.dtr-control, .table.gx-xxl-6 td.dtr-control {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.gs-xxl-6 th:first-child, .table.gs-xxl-6 td:first-child {\n    padding-left: 1.5rem;\n  }\n  .table.gs-xxl-6 th:last-child, .table.gs-xxl-6 td:last-child {\n    padding-right: 1.5rem;\n  }\n  .table.gs-xxl-6 th.dtr-control:first-child, .table.gs-xxl-6 td.dtr-control:first-child {\n    padding-left: 1.5rem !important;\n  }\n\n  .table.g-xxl-7 th, .table.g-xxl-7 td {\n    padding: 1.75rem;\n  }\n  .table.g-xxl-7 th.dtr-control, .table.g-xxl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gy-xxl-7 th, .table.gy-xxl-7 td {\n    padding-top: 1.75rem;\n    padding-bottom: 1.75rem;\n  }\n\n  .table.gx-xxl-7 th, .table.gx-xxl-7 td {\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n  }\n  .table.gx-xxl-7 th.dtr-control, .table.gx-xxl-7 td.dtr-control {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.gs-xxl-7 th:first-child, .table.gs-xxl-7 td:first-child {\n    padding-left: 1.75rem;\n  }\n  .table.gs-xxl-7 th:last-child, .table.gs-xxl-7 td:last-child {\n    padding-right: 1.75rem;\n  }\n  .table.gs-xxl-7 th.dtr-control:first-child, .table.gs-xxl-7 td.dtr-control:first-child {\n    padding-left: 1.75rem !important;\n  }\n\n  .table.g-xxl-8 th, .table.g-xxl-8 td {\n    padding: 2rem;\n  }\n  .table.g-xxl-8 th.dtr-control, .table.g-xxl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gy-xxl-8 th, .table.gy-xxl-8 td {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .table.gx-xxl-8 th, .table.gx-xxl-8 td {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n  .table.gx-xxl-8 th.dtr-control, .table.gx-xxl-8 td.dtr-control {\n    padding-left: 2rem !important;\n  }\n\n  .table.gs-xxl-8 th:first-child, .table.gs-xxl-8 td:first-child {\n    padding-left: 2rem;\n  }\n  .table.gs-xxl-8 th:last-child, .table.gs-xxl-8 td:last-child {\n    padding-right: 2rem;\n  }\n  .table.gs-xxl-8 th.dtr-control:first-child, .table.gs-xxl-8 td.dtr-control:first-child {\n    padding-left: 2rem !important;\n  }\n\n  .table.g-xxl-9 th, .table.g-xxl-9 td {\n    padding: 2.25rem;\n  }\n  .table.g-xxl-9 th.dtr-control, .table.g-xxl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gy-xxl-9 th, .table.gy-xxl-9 td {\n    padding-top: 2.25rem;\n    padding-bottom: 2.25rem;\n  }\n\n  .table.gx-xxl-9 th, .table.gx-xxl-9 td {\n    padding-left: 2.25rem;\n    padding-right: 2.25rem;\n  }\n  .table.gx-xxl-9 th.dtr-control, .table.gx-xxl-9 td.dtr-control {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.gs-xxl-9 th:first-child, .table.gs-xxl-9 td:first-child {\n    padding-left: 2.25rem;\n  }\n  .table.gs-xxl-9 th:last-child, .table.gs-xxl-9 td:last-child {\n    padding-right: 2.25rem;\n  }\n  .table.gs-xxl-9 th.dtr-control:first-child, .table.gs-xxl-9 td.dtr-control:first-child {\n    padding-left: 2.25rem !important;\n  }\n\n  .table.g-xxl-10 th, .table.g-xxl-10 td {\n    padding: 2.5rem;\n  }\n  .table.g-xxl-10 th.dtr-control, .table.g-xxl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gy-xxl-10 th, .table.gy-xxl-10 td {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .table.gx-xxl-10 th, .table.gx-xxl-10 td {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n  .table.gx-xxl-10 th.dtr-control, .table.gx-xxl-10 td.dtr-control {\n    padding-left: 2.5rem !important;\n  }\n\n  .table.gs-xxl-10 th:first-child, .table.gs-xxl-10 td:first-child {\n    padding-left: 2.5rem;\n  }\n  .table.gs-xxl-10 th:last-child, .table.gs-xxl-10 td:last-child {\n    padding-right: 2.5rem;\n  }\n  .table.gs-xxl-10 th.dtr-control:first-child, .table.gs-xxl-10 td.dtr-control:first-child {\n    padding-left: 2.5rem !important;\n  }\n}\n.popover {\n  --bs-popover-bg: var(--kt-popover-bg);\n  --bs-popover-border-color: var(--kt-popover-border-color);\n  --bs-popover-box-shadow: var(--kt-popover-box-shadow);\n  --bs-popover-header-color: var(--kt-popover-header-color);\n  --bs-popover-header-bg: var(--kt-popover-header-bg);\n  --bs-popover-body-color: var(--kt-popover-body-color);\n  --bs-popover-arrow-border: var(--kt-popover-bg);\n}\n.popover .popover-header {\n  font-size: 1rem;\n  font-weight: 500;\n  border-bottom: 1px solid var(--kt-popover-header-border-color);\n}\n.popover .popover-dismiss {\n  position: absolute;\n  top: 0.85rem;\n  right: 0.85rem;\n  height: 1.5rem;\n  width: 1.5rem;\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='var%28--kt-gray-500%29'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='var%28--kt-gray-500%29'%3e%3cpath d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/%3e%3c/svg%3e\");\n  mask-size: 50%;\n  -webkit-mask-size: 50%;\n}\n.popover .popover-dismiss:hover {\n  background-color: var(--kt-primary);\n}\n.popover .popover-dismiss + .popover-header {\n  padding-right: 2.75rem;\n}\n\n.popover-inverse {\n  background-color: var(--kt-gray-900);\n  border: 0;\n}\n.popover-inverse .popover-header {\n  background-color: var(--kt-gray-900);\n  color: var(--kt-gray-200);\n  border-bottom-color: var(--kt-gray-800);\n}\n.popover-inverse .popover-body {\n  color: var(--kt-gray-400);\n}\n.popover-inverse.bs-popover-top > .popover-arrow::before, .popover-inverse.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {\n  border-top-color: var(--kt-gray-100);\n}\n.popover-inverse.bs-popover-top > .popover-arrow::after, .popover-inverse.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {\n  border-top-color: var(--kt-gray-900);\n}\n.popover-inverse.bs-popover-end > .popover-arrow::before, .popover-inverse.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {\n  border-right-color: var(--kt-gray-100);\n}\n.popover-inverse.bs-popover-end > .popover-arrow::after, .popover-inverse.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {\n  border-right-color: var(--kt-gray-900);\n}\n.popover-inverse.bs-popover-bottom > .popover-arrow::before, .popover-inverse.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {\n  border-bottom-color: var(--kt-gray-100);\n}\n.popover-inverse.bs-popover-bottom > .popover-arrow::after, .popover-inverse.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {\n  border-bottom-color: var(--kt-gray-900);\n}\n.popover-inverse.bs-popover-bottom .popover-header::before, .popover-inverse.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {\n  border-bottom-color: var(--kt-gray-900);\n}\n.popover-inverse.bs-popover-start > .popover-arrow::before, .popover-inverse.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {\n  border-left-color: var(--kt-gray-100);\n}\n.popover-inverse.bs-popover-start > .popover-arrow::after, .popover-inverse.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {\n  border-left-color: var(--kt-gray-900);\n}\n\n.tooltip {\n  --bs-tooltip-color: var(--kt-tooltip-color);\n  --bs-tooltip-bg: var(--kt-tooltip-bg);\n  --bs-tooltip-opacity: var(--kt-tooltip-opacity);\n}\n.tooltip .tooltip-inner {\n  box-shadow: var(--kt-tooltip-box-shadow);\n}\n.tooltip.tooltop-auto-width .tooltip-inner {\n  white-space: nowrap;\n  max-width: none;\n}\n.tooltip.tooltip-inverse .tooltip-inner {\n  color: var(--kt-dark-inverse);\n  background-color: var(--kt-dark);\n}\n.tooltip.tooltip-inverse.bs-tooltip-top .tooltip-arrow::before, .tooltip.tooltip-inverse.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {\n  border-top-color: var(--kt-dark);\n}\n.tooltip.tooltip-inverse.bs-tooltip-end .tooltip-arrow::before, .tooltip.tooltip-inverse.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {\n  border-right-color: var(--kt-dark);\n}\n.tooltip.tooltip-inverse.bs-tooltip-bottom .tooltip-arrow::before, .tooltip.tooltip-inverse.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {\n  border-bottom-color: var(--kt-dark);\n}\n.tooltip.tooltip-inverse.bs-tooltip-start .tooltip-arrow::before, .tooltip.tooltip-inverse.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {\n  border-left-color: var(--kt-dark);\n}\n\n.accordion {\n  --bs-accordion-color: var(--kt-accordion-color);\n  --bs-accordion-bg: var(--kt-accordion-bg);\n  --bs-accordion-border-color: var(--kt-accordion-border-color);\n  --bs-accordion-btn-color: var(--kt-accordion-color);\n  --bs-accordion-btn-bg: var(--kt-accordion-button-bg);\n  --bs-accordion-btn-icon: var(--kt-accordion-button-icon);\n  --bs-accordion-btn-active-icon: var(--kt-accordion-button-active-icon);\n  --bs-accordion-btn-focus-border-color: var(--kt-accordion-button-focus-border-color);\n  --bs-accordion-btn-focus-box-shadow: var(--kt-accordion-button-focus-box-shadow);\n  --bs-accordion-active-color: var(--kt-accordion-button-active-color);\n  --bs-accordion-active-bg: var(--kt-accordion-button-active-bg);\n}\n.accordion .accordion-header {\n  cursor: pointer;\n}\n.accordion.accordion-icon-toggle .accordion-icon {\n  display: flex;\n  flex-shrink: 0;\n  transition: all 0.2s ease-in-out;\n  transform: rotate(90deg);\n  align-items: center;\n  justify-content: center;\n}\n.accordion.accordion-icon-toggle .accordion-icon i,\n.accordion.accordion-icon-toggle .accordion-icon .svg-icon {\n  color: var(--kt-primary);\n}\n.accordion.accordion-icon-toggle .collapsed .accordion-icon {\n  transition: all 0.2s ease-in-out;\n  transform: rotate(0);\n}\n.accordion.accordion-icon-toggle .collapsed .accordion-icon i,\n.accordion.accordion-icon-toggle .collapsed .accordion-icon .svg-icon {\n  color: var(--kt-text-muted);\n}\n.accordion.accordion-borderless .accordion-item {\n  border: 0;\n}\n.accordion.accordion-flush .accordion-item {\n  background-color: transparent;\n  border: 0;\n  border-radius: 0;\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.feedback {\n  display: none;\n}\n\n.feedback-popup {\n  display: flex;\n  justify-content: center;\n  margin: 0 auto;\n  position: fixed;\n  z-index: 1000;\n  box-shadow: var(--kt-feedback-popup-box-shadow);\n  background-color: var(--kt-feedback-popup-background-color);\n  border-radius: 0.475rem;\n  padding: 1rem 1.25rem;\n}\n\n.feedback-top-center {\n  display: flex;\n  transition: top 0.6s ease;\n  left: 50%;\n  transform: translateX(-50%);\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.feedback-top-center.feedback-shown {\n  top: 0px;\n  transition: top 0.6s ease;\n}\n\n.image-input {\n  position: relative;\n  display: inline-block;\n  border-radius: 0.475rem;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.image-input:not(.image-input-empty) {\n  background-image: none !important;\n}\n.image-input .image-input-wrapper {\n  width: 120px;\n  height: 120px;\n  border-radius: 0.475rem;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.image-input [data-kt-image-input-action] {\n  cursor: pointer;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n.image-input [data-kt-image-input-action=change] {\n  left: 100%;\n  top: 0;\n}\n.image-input [data-kt-image-input-action=change] input {\n  width: 0 !important;\n  height: 0 !important;\n  overflow: hidden;\n  opacity: 0;\n}\n.image-input [data-kt-image-input-action=cancel],\n.image-input [data-kt-image-input-action=remove] {\n  position: absolute;\n  left: 100%;\n  top: 100%;\n}\n.image-input [data-kt-image-input-action=cancel] {\n  display: none;\n}\n.image-input.image-input-changed [data-kt-image-input-action=cancel] {\n  display: flex;\n}\n.image-input.image-input-changed [data-kt-image-input-action=remove] {\n  display: none;\n}\n.image-input.image-input-empty [data-kt-image-input-action=remove],\n.image-input.image-input-empty [data-kt-image-input-action=cancel] {\n  display: none;\n}\n.image-input.image-input-circle {\n  border-radius: 50%;\n}\n.image-input.image-input-circle .image-input-wrapper {\n  border-radius: 50%;\n}\n.image-input.image-input-circle [data-kt-image-input-action=change] {\n  left: 100%;\n  top: 0;\n  transform: translate(-100%, 0%);\n}\n.image-input.image-input-circle [data-kt-image-input-action=cancel],\n.image-input.image-input-circle [data-kt-image-input-action=remove] {\n  left: 100%;\n  top: 100%;\n  transform: translate(-100%, -100%);\n}\n.image-input.image-input-outline .image-input-wrapper {\n  border: 3px solid var(--kt-body-bg);\n  box-shadow: var(--kt-box-shadow);\n}\n\n.symbol {\n  display: inline-block;\n  flex-shrink: 0;\n  position: relative;\n  border-radius: 0.475rem;\n}\n.symbol .symbol-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 500;\n  color: var(--kt-symbol-label-color);\n  background-color: var(--kt-symbol-label-bg);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  border-radius: 0.475rem;\n}\n.symbol .symbol-label:after {\n  border-radius: 0.475rem;\n}\n.symbol .symbol-badge {\n  position: absolute;\n  border-radius: 100%;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%) !important;\n}\n.symbol > img {\n  width: 100%;\n  flex-shrink: 0;\n  display: inline-block;\n  border-radius: 0.475rem;\n}\n.symbol.symbol-square,\n.symbol.symbol-square > img,\n.symbol.symbol-square .symbol-label {\n  border-radius: 0 !important;\n}\n.symbol.symbol-circle,\n.symbol.symbol-circle > img,\n.symbol.symbol-circle .symbol-label {\n  border-radius: 50%;\n}\n.symbol.symbol-circle:after,\n.symbol.symbol-circle > img:after,\n.symbol.symbol-circle .symbol-label:after {\n  border-radius: 50%;\n}\n.symbol > img {\n  width: 50px;\n  height: 50px;\n}\n.symbol .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-fixed .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-fixed > img {\n  width: 50px;\n  height: 50px;\n  max-width: none;\n}\n.symbol.symbol-2by3 .symbol-label {\n  height: 50px;\n  width: 75px;\n}\n.symbol.symbol-2by3 > img {\n  height: 50px;\n  width: 75px;\n  max-width: none;\n}\n.symbol.symbol-20px > img {\n  width: 20px;\n  height: 20px;\n}\n.symbol.symbol-20px .symbol-label {\n  width: 20px;\n  height: 20px;\n}\n.symbol.symbol-20px.symbol-fixed .symbol-label {\n  width: 20px;\n  height: 20px;\n}\n.symbol.symbol-20px.symbol-fixed > img {\n  width: 20px;\n  height: 20px;\n  max-width: none;\n}\n.symbol.symbol-20px.symbol-2by3 .symbol-label {\n  height: 20px;\n  width: 30px;\n}\n.symbol.symbol-20px.symbol-2by3 > img {\n  height: 20px;\n  width: 30px;\n  max-width: none;\n}\n.symbol.symbol-25px > img {\n  width: 25px;\n  height: 25px;\n}\n.symbol.symbol-25px .symbol-label {\n  width: 25px;\n  height: 25px;\n}\n.symbol.symbol-25px.symbol-fixed .symbol-label {\n  width: 25px;\n  height: 25px;\n}\n.symbol.symbol-25px.symbol-fixed > img {\n  width: 25px;\n  height: 25px;\n  max-width: none;\n}\n.symbol.symbol-25px.symbol-2by3 .symbol-label {\n  height: 25px;\n  width: 37.5px;\n}\n.symbol.symbol-25px.symbol-2by3 > img {\n  height: 25px;\n  width: 37.5px;\n  max-width: none;\n}\n.symbol.symbol-30px > img {\n  width: 30px;\n  height: 30px;\n}\n.symbol.symbol-30px .symbol-label {\n  width: 30px;\n  height: 30px;\n}\n.symbol.symbol-30px.symbol-fixed .symbol-label {\n  width: 30px;\n  height: 30px;\n}\n.symbol.symbol-30px.symbol-fixed > img {\n  width: 30px;\n  height: 30px;\n  max-width: none;\n}\n.symbol.symbol-30px.symbol-2by3 .symbol-label {\n  height: 30px;\n  width: 45px;\n}\n.symbol.symbol-30px.symbol-2by3 > img {\n  height: 30px;\n  width: 45px;\n  max-width: none;\n}\n.symbol.symbol-35px > img {\n  width: 35px;\n  height: 35px;\n}\n.symbol.symbol-35px .symbol-label {\n  width: 35px;\n  height: 35px;\n}\n.symbol.symbol-35px.symbol-fixed .symbol-label {\n  width: 35px;\n  height: 35px;\n}\n.symbol.symbol-35px.symbol-fixed > img {\n  width: 35px;\n  height: 35px;\n  max-width: none;\n}\n.symbol.symbol-35px.symbol-2by3 .symbol-label {\n  height: 35px;\n  width: 52.5px;\n}\n.symbol.symbol-35px.symbol-2by3 > img {\n  height: 35px;\n  width: 52.5px;\n  max-width: none;\n}\n.symbol.symbol-40px > img {\n  width: 40px;\n  height: 40px;\n}\n.symbol.symbol-40px .symbol-label {\n  width: 40px;\n  height: 40px;\n}\n.symbol.symbol-40px.symbol-fixed .symbol-label {\n  width: 40px;\n  height: 40px;\n}\n.symbol.symbol-40px.symbol-fixed > img {\n  width: 40px;\n  height: 40px;\n  max-width: none;\n}\n.symbol.symbol-40px.symbol-2by3 .symbol-label {\n  height: 40px;\n  width: 60px;\n}\n.symbol.symbol-40px.symbol-2by3 > img {\n  height: 40px;\n  width: 60px;\n  max-width: none;\n}\n.symbol.symbol-45px > img {\n  width: 45px;\n  height: 45px;\n}\n.symbol.symbol-45px .symbol-label {\n  width: 45px;\n  height: 45px;\n}\n.symbol.symbol-45px.symbol-fixed .symbol-label {\n  width: 45px;\n  height: 45px;\n}\n.symbol.symbol-45px.symbol-fixed > img {\n  width: 45px;\n  height: 45px;\n  max-width: none;\n}\n.symbol.symbol-45px.symbol-2by3 .symbol-label {\n  height: 45px;\n  width: 67.5px;\n}\n.symbol.symbol-45px.symbol-2by3 > img {\n  height: 45px;\n  width: 67.5px;\n  max-width: none;\n}\n.symbol.symbol-50px > img {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-50px .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-50px.symbol-fixed .symbol-label {\n  width: 50px;\n  height: 50px;\n}\n.symbol.symbol-50px.symbol-fixed > img {\n  width: 50px;\n  height: 50px;\n  max-width: none;\n}\n.symbol.symbol-50px.symbol-2by3 .symbol-label {\n  height: 50px;\n  width: 75px;\n}\n.symbol.symbol-50px.symbol-2by3 > img {\n  height: 50px;\n  width: 75px;\n  max-width: none;\n}\n.symbol.symbol-55px > img {\n  width: 55px;\n  height: 55px;\n}\n.symbol.symbol-55px .symbol-label {\n  width: 55px;\n  height: 55px;\n}\n.symbol.symbol-55px.symbol-fixed .symbol-label {\n  width: 55px;\n  height: 55px;\n}\n.symbol.symbol-55px.symbol-fixed > img {\n  width: 55px;\n  height: 55px;\n  max-width: none;\n}\n.symbol.symbol-55px.symbol-2by3 .symbol-label {\n  height: 55px;\n  width: 82.5px;\n}\n.symbol.symbol-55px.symbol-2by3 > img {\n  height: 55px;\n  width: 82.5px;\n  max-width: none;\n}\n.symbol.symbol-60px > img {\n  width: 60px;\n  height: 60px;\n}\n.symbol.symbol-60px .symbol-label {\n  width: 60px;\n  height: 60px;\n}\n.symbol.symbol-60px.symbol-fixed .symbol-label {\n  width: 60px;\n  height: 60px;\n}\n.symbol.symbol-60px.symbol-fixed > img {\n  width: 60px;\n  height: 60px;\n  max-width: none;\n}\n.symbol.symbol-60px.symbol-2by3 .symbol-label {\n  height: 60px;\n  width: 90px;\n}\n.symbol.symbol-60px.symbol-2by3 > img {\n  height: 60px;\n  width: 90px;\n  max-width: none;\n}\n.symbol.symbol-65px > img {\n  width: 65px;\n  height: 65px;\n}\n.symbol.symbol-65px .symbol-label {\n  width: 65px;\n  height: 65px;\n}\n.symbol.symbol-65px.symbol-fixed .symbol-label {\n  width: 65px;\n  height: 65px;\n}\n.symbol.symbol-65px.symbol-fixed > img {\n  width: 65px;\n  height: 65px;\n  max-width: none;\n}\n.symbol.symbol-65px.symbol-2by3 .symbol-label {\n  height: 65px;\n  width: 97.5px;\n}\n.symbol.symbol-65px.symbol-2by3 > img {\n  height: 65px;\n  width: 97.5px;\n  max-width: none;\n}\n.symbol.symbol-70px > img {\n  width: 70px;\n  height: 70px;\n}\n.symbol.symbol-70px .symbol-label {\n  width: 70px;\n  height: 70px;\n}\n.symbol.symbol-70px.symbol-fixed .symbol-label {\n  width: 70px;\n  height: 70px;\n}\n.symbol.symbol-70px.symbol-fixed > img {\n  width: 70px;\n  height: 70px;\n  max-width: none;\n}\n.symbol.symbol-70px.symbol-2by3 .symbol-label {\n  height: 70px;\n  width: 105px;\n}\n.symbol.symbol-70px.symbol-2by3 > img {\n  height: 70px;\n  width: 105px;\n  max-width: none;\n}\n.symbol.symbol-75px > img {\n  width: 75px;\n  height: 75px;\n}\n.symbol.symbol-75px .symbol-label {\n  width: 75px;\n  height: 75px;\n}\n.symbol.symbol-75px.symbol-fixed .symbol-label {\n  width: 75px;\n  height: 75px;\n}\n.symbol.symbol-75px.symbol-fixed > img {\n  width: 75px;\n  height: 75px;\n  max-width: none;\n}\n.symbol.symbol-75px.symbol-2by3 .symbol-label {\n  height: 75px;\n  width: 112.5px;\n}\n.symbol.symbol-75px.symbol-2by3 > img {\n  height: 75px;\n  width: 112.5px;\n  max-width: none;\n}\n.symbol.symbol-90px > img {\n  width: 90px;\n  height: 90px;\n}\n.symbol.symbol-90px .symbol-label {\n  width: 90px;\n  height: 90px;\n}\n.symbol.symbol-90px.symbol-fixed .symbol-label {\n  width: 90px;\n  height: 90px;\n}\n.symbol.symbol-90px.symbol-fixed > img {\n  width: 90px;\n  height: 90px;\n  max-width: none;\n}\n.symbol.symbol-90px.symbol-2by3 .symbol-label {\n  height: 90px;\n  width: 135px;\n}\n.symbol.symbol-90px.symbol-2by3 > img {\n  height: 90px;\n  width: 135px;\n  max-width: none;\n}\n.symbol.symbol-100px > img {\n  width: 100px;\n  height: 100px;\n}\n.symbol.symbol-100px .symbol-label {\n  width: 100px;\n  height: 100px;\n}\n.symbol.symbol-100px.symbol-fixed .symbol-label {\n  width: 100px;\n  height: 100px;\n}\n.symbol.symbol-100px.symbol-fixed > img {\n  width: 100px;\n  height: 100px;\n  max-width: none;\n}\n.symbol.symbol-100px.symbol-2by3 .symbol-label {\n  height: 100px;\n  width: 150px;\n}\n.symbol.symbol-100px.symbol-2by3 > img {\n  height: 100px;\n  width: 150px;\n  max-width: none;\n}\n.symbol.symbol-125px > img {\n  width: 125px;\n  height: 125px;\n}\n.symbol.symbol-125px .symbol-label {\n  width: 125px;\n  height: 125px;\n}\n.symbol.symbol-125px.symbol-fixed .symbol-label {\n  width: 125px;\n  height: 125px;\n}\n.symbol.symbol-125px.symbol-fixed > img {\n  width: 125px;\n  height: 125px;\n  max-width: none;\n}\n.symbol.symbol-125px.symbol-2by3 .symbol-label {\n  height: 125px;\n  width: 187.5px;\n}\n.symbol.symbol-125px.symbol-2by3 > img {\n  height: 125px;\n  width: 187.5px;\n  max-width: none;\n}\n.symbol.symbol-150px > img {\n  width: 150px;\n  height: 150px;\n}\n.symbol.symbol-150px .symbol-label {\n  width: 150px;\n  height: 150px;\n}\n.symbol.symbol-150px.symbol-fixed .symbol-label {\n  width: 150px;\n  height: 150px;\n}\n.symbol.symbol-150px.symbol-fixed > img {\n  width: 150px;\n  height: 150px;\n  max-width: none;\n}\n.symbol.symbol-150px.symbol-2by3 .symbol-label {\n  height: 150px;\n  width: 225px;\n}\n.symbol.symbol-150px.symbol-2by3 > img {\n  height: 150px;\n  width: 225px;\n  max-width: none;\n}\n.symbol.symbol-160px > img {\n  width: 160px;\n  height: 160px;\n}\n.symbol.symbol-160px .symbol-label {\n  width: 160px;\n  height: 160px;\n}\n.symbol.symbol-160px.symbol-fixed .symbol-label {\n  width: 160px;\n  height: 160px;\n}\n.symbol.symbol-160px.symbol-fixed > img {\n  width: 160px;\n  height: 160px;\n  max-width: none;\n}\n.symbol.symbol-160px.symbol-2by3 .symbol-label {\n  height: 160px;\n  width: 240px;\n}\n.symbol.symbol-160px.symbol-2by3 > img {\n  height: 160px;\n  width: 240px;\n  max-width: none;\n}\n.symbol.symbol-175px > img {\n  width: 175px;\n  height: 175px;\n}\n.symbol.symbol-175px .symbol-label {\n  width: 175px;\n  height: 175px;\n}\n.symbol.symbol-175px.symbol-fixed .symbol-label {\n  width: 175px;\n  height: 175px;\n}\n.symbol.symbol-175px.symbol-fixed > img {\n  width: 175px;\n  height: 175px;\n  max-width: none;\n}\n.symbol.symbol-175px.symbol-2by3 .symbol-label {\n  height: 175px;\n  width: 262.5px;\n}\n.symbol.symbol-175px.symbol-2by3 > img {\n  height: 175px;\n  width: 262.5px;\n  max-width: none;\n}\n.symbol.symbol-200px > img {\n  width: 200px;\n  height: 200px;\n}\n.symbol.symbol-200px .symbol-label {\n  width: 200px;\n  height: 200px;\n}\n.symbol.symbol-200px.symbol-fixed .symbol-label {\n  width: 200px;\n  height: 200px;\n}\n.symbol.symbol-200px.symbol-fixed > img {\n  width: 200px;\n  height: 200px;\n  max-width: none;\n}\n.symbol.symbol-200px.symbol-2by3 .symbol-label {\n  height: 200px;\n  width: 300px;\n}\n.symbol.symbol-200px.symbol-2by3 > img {\n  height: 200px;\n  width: 300px;\n  max-width: none;\n}\n@media (min-width: 576px) {\n  .symbol.symbol-sm-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-sm-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-sm-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-sm-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-sm-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-sm-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-sm-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-sm-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-sm-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-sm-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-sm-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-sm-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-sm-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-sm-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-sm-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-sm-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-sm-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-sm-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-sm-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-sm-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-sm-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-sm-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-sm-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-sm-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-sm-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-sm-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-sm-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-sm-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-sm-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-sm-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-sm-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-sm-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-sm-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-sm-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-sm-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-sm-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-sm-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-sm-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-sm-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-sm-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-sm-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-sm-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-sm-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-sm-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-sm-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-sm-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-sm-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-sm-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-sm-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-sm-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-sm-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-sm-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-sm-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-sm-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-sm-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-sm-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-sm-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-sm-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-sm-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-sm-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-sm-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-sm-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-sm-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-sm-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-sm-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-sm-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-sm-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-sm-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-sm-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-sm-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-sm-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-sm-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-sm-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-sm-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-sm-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-sm-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-sm-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-sm-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n@media (min-width: 768px) {\n  .symbol.symbol-md-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-md-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-md-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-md-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-md-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-md-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-md-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-md-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-md-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-md-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-md-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-md-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-md-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-md-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-md-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-md-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-md-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-md-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-md-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-md-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-md-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-md-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-md-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-md-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-md-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-md-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-md-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-md-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-md-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-md-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-md-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-md-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-md-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-md-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-md-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-md-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-md-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-md-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-md-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-md-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-md-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-md-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-md-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-md-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-md-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-md-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-md-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-md-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-md-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-md-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-md-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-md-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-md-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-md-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-md-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-md-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-md-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-md-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-md-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-md-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-md-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-md-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-md-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-md-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-md-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-md-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-md-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-md-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-md-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-md-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-md-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-md-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-md-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-md-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-md-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-md-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-md-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-md-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-md-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-md-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-md-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-md-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-md-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-md-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-md-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-md-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-md-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-md-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-md-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-md-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-md-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-md-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-md-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-md-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-md-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-md-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-md-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-md-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-md-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-md-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-md-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-md-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-md-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-md-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-md-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-md-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-md-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n@media (min-width: 992px) {\n  .symbol.symbol-lg-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-lg-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-lg-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-lg-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-lg-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-lg-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-lg-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-lg-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-lg-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-lg-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-lg-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-lg-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-lg-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-lg-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-lg-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-lg-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-lg-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-lg-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-lg-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-lg-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-lg-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-lg-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-lg-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-lg-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-lg-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-lg-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-lg-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-lg-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-lg-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-lg-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-lg-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-lg-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-lg-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-lg-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-lg-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-lg-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-lg-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-lg-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-lg-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-lg-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-lg-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-lg-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-lg-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-lg-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-lg-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-lg-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-lg-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-lg-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-lg-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-lg-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-lg-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-lg-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-lg-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-lg-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-lg-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-lg-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-lg-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-lg-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-lg-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-lg-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-lg-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-lg-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-lg-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-lg-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-lg-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-lg-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-lg-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-lg-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-lg-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-lg-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-lg-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-lg-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-lg-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-lg-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-lg-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-lg-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-lg-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-lg-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n@media (min-width: 1200px) {\n  .symbol.symbol-xl-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xl-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xl-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xl-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-xl-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xl-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xl-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xl-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-xl-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xl-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xl-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xl-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-xl-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xl-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xl-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xl-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-xl-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xl-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xl-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xl-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-xl-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xl-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xl-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xl-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-xl-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xl-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xl-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xl-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-xl-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xl-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xl-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xl-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-xl-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xl-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xl-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xl-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-xl-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xl-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xl-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xl-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-xl-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xl-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xl-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xl-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-xl-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xl-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xl-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xl-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-xl-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xl-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xl-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xl-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-xl-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xl-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xl-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xl-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-xl-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xl-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xl-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xl-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-xl-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xl-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xl-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xl-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-xl-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xl-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xl-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xl-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-xl-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xl-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xl-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xl-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-xl-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xl-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xl-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xl-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-xl-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-xl-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n@media (min-width: 1400px) {\n  .symbol.symbol-xxl-20px > img {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xxl-20px .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xxl-20px.symbol-fixed .symbol-label {\n    width: 20px;\n    height: 20px;\n  }\n  .symbol.symbol-xxl-20px.symbol-fixed > img {\n    width: 20px;\n    height: 20px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-20px.symbol-2by3 .symbol-label {\n    height: 20px;\n    width: 30px;\n  }\n  .symbol.symbol-xxl-20px.symbol-2by3 > img {\n    height: 20px;\n    width: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-25px > img {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xxl-25px .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xxl-25px.symbol-fixed .symbol-label {\n    width: 25px;\n    height: 25px;\n  }\n  .symbol.symbol-xxl-25px.symbol-fixed > img {\n    width: 25px;\n    height: 25px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-25px.symbol-2by3 .symbol-label {\n    height: 25px;\n    width: 37.5px;\n  }\n  .symbol.symbol-xxl-25px.symbol-2by3 > img {\n    height: 25px;\n    width: 37.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-30px > img {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xxl-30px .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xxl-30px.symbol-fixed .symbol-label {\n    width: 30px;\n    height: 30px;\n  }\n  .symbol.symbol-xxl-30px.symbol-fixed > img {\n    width: 30px;\n    height: 30px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-30px.symbol-2by3 .symbol-label {\n    height: 30px;\n    width: 45px;\n  }\n  .symbol.symbol-xxl-30px.symbol-2by3 > img {\n    height: 30px;\n    width: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-35px > img {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xxl-35px .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xxl-35px.symbol-fixed .symbol-label {\n    width: 35px;\n    height: 35px;\n  }\n  .symbol.symbol-xxl-35px.symbol-fixed > img {\n    width: 35px;\n    height: 35px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-35px.symbol-2by3 .symbol-label {\n    height: 35px;\n    width: 52.5px;\n  }\n  .symbol.symbol-xxl-35px.symbol-2by3 > img {\n    height: 35px;\n    width: 52.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-40px > img {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xxl-40px .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xxl-40px.symbol-fixed .symbol-label {\n    width: 40px;\n    height: 40px;\n  }\n  .symbol.symbol-xxl-40px.symbol-fixed > img {\n    width: 40px;\n    height: 40px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-40px.symbol-2by3 .symbol-label {\n    height: 40px;\n    width: 60px;\n  }\n  .symbol.symbol-xxl-40px.symbol-2by3 > img {\n    height: 40px;\n    width: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-45px > img {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xxl-45px .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xxl-45px.symbol-fixed .symbol-label {\n    width: 45px;\n    height: 45px;\n  }\n  .symbol.symbol-xxl-45px.symbol-fixed > img {\n    width: 45px;\n    height: 45px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-45px.symbol-2by3 .symbol-label {\n    height: 45px;\n    width: 67.5px;\n  }\n  .symbol.symbol-xxl-45px.symbol-2by3 > img {\n    height: 45px;\n    width: 67.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-50px > img {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xxl-50px .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xxl-50px.symbol-fixed .symbol-label {\n    width: 50px;\n    height: 50px;\n  }\n  .symbol.symbol-xxl-50px.symbol-fixed > img {\n    width: 50px;\n    height: 50px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-50px.symbol-2by3 .symbol-label {\n    height: 50px;\n    width: 75px;\n  }\n  .symbol.symbol-xxl-50px.symbol-2by3 > img {\n    height: 50px;\n    width: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-55px > img {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xxl-55px .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xxl-55px.symbol-fixed .symbol-label {\n    width: 55px;\n    height: 55px;\n  }\n  .symbol.symbol-xxl-55px.symbol-fixed > img {\n    width: 55px;\n    height: 55px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-55px.symbol-2by3 .symbol-label {\n    height: 55px;\n    width: 82.5px;\n  }\n  .symbol.symbol-xxl-55px.symbol-2by3 > img {\n    height: 55px;\n    width: 82.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-60px > img {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xxl-60px .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xxl-60px.symbol-fixed .symbol-label {\n    width: 60px;\n    height: 60px;\n  }\n  .symbol.symbol-xxl-60px.symbol-fixed > img {\n    width: 60px;\n    height: 60px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-60px.symbol-2by3 .symbol-label {\n    height: 60px;\n    width: 90px;\n  }\n  .symbol.symbol-xxl-60px.symbol-2by3 > img {\n    height: 60px;\n    width: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-65px > img {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xxl-65px .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xxl-65px.symbol-fixed .symbol-label {\n    width: 65px;\n    height: 65px;\n  }\n  .symbol.symbol-xxl-65px.symbol-fixed > img {\n    width: 65px;\n    height: 65px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-65px.symbol-2by3 .symbol-label {\n    height: 65px;\n    width: 97.5px;\n  }\n  .symbol.symbol-xxl-65px.symbol-2by3 > img {\n    height: 65px;\n    width: 97.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-70px > img {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xxl-70px .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xxl-70px.symbol-fixed .symbol-label {\n    width: 70px;\n    height: 70px;\n  }\n  .symbol.symbol-xxl-70px.symbol-fixed > img {\n    width: 70px;\n    height: 70px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-70px.symbol-2by3 .symbol-label {\n    height: 70px;\n    width: 105px;\n  }\n  .symbol.symbol-xxl-70px.symbol-2by3 > img {\n    height: 70px;\n    width: 105px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-75px > img {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xxl-75px .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xxl-75px.symbol-fixed .symbol-label {\n    width: 75px;\n    height: 75px;\n  }\n  .symbol.symbol-xxl-75px.symbol-fixed > img {\n    width: 75px;\n    height: 75px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-75px.symbol-2by3 .symbol-label {\n    height: 75px;\n    width: 112.5px;\n  }\n  .symbol.symbol-xxl-75px.symbol-2by3 > img {\n    height: 75px;\n    width: 112.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-90px > img {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xxl-90px .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xxl-90px.symbol-fixed .symbol-label {\n    width: 90px;\n    height: 90px;\n  }\n  .symbol.symbol-xxl-90px.symbol-fixed > img {\n    width: 90px;\n    height: 90px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-90px.symbol-2by3 .symbol-label {\n    height: 90px;\n    width: 135px;\n  }\n  .symbol.symbol-xxl-90px.symbol-2by3 > img {\n    height: 90px;\n    width: 135px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-100px > img {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xxl-100px .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xxl-100px.symbol-fixed .symbol-label {\n    width: 100px;\n    height: 100px;\n  }\n  .symbol.symbol-xxl-100px.symbol-fixed > img {\n    width: 100px;\n    height: 100px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-100px.symbol-2by3 .symbol-label {\n    height: 100px;\n    width: 150px;\n  }\n  .symbol.symbol-xxl-100px.symbol-2by3 > img {\n    height: 100px;\n    width: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-125px > img {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xxl-125px .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xxl-125px.symbol-fixed .symbol-label {\n    width: 125px;\n    height: 125px;\n  }\n  .symbol.symbol-xxl-125px.symbol-fixed > img {\n    width: 125px;\n    height: 125px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-125px.symbol-2by3 .symbol-label {\n    height: 125px;\n    width: 187.5px;\n  }\n  .symbol.symbol-xxl-125px.symbol-2by3 > img {\n    height: 125px;\n    width: 187.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-150px > img {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xxl-150px .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xxl-150px.symbol-fixed .symbol-label {\n    width: 150px;\n    height: 150px;\n  }\n  .symbol.symbol-xxl-150px.symbol-fixed > img {\n    width: 150px;\n    height: 150px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-150px.symbol-2by3 .symbol-label {\n    height: 150px;\n    width: 225px;\n  }\n  .symbol.symbol-xxl-150px.symbol-2by3 > img {\n    height: 150px;\n    width: 225px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-160px > img {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xxl-160px .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xxl-160px.symbol-fixed .symbol-label {\n    width: 160px;\n    height: 160px;\n  }\n  .symbol.symbol-xxl-160px.symbol-fixed > img {\n    width: 160px;\n    height: 160px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-160px.symbol-2by3 .symbol-label {\n    height: 160px;\n    width: 240px;\n  }\n  .symbol.symbol-xxl-160px.symbol-2by3 > img {\n    height: 160px;\n    width: 240px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-175px > img {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xxl-175px .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xxl-175px.symbol-fixed .symbol-label {\n    width: 175px;\n    height: 175px;\n  }\n  .symbol.symbol-xxl-175px.symbol-fixed > img {\n    width: 175px;\n    height: 175px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-175px.symbol-2by3 .symbol-label {\n    height: 175px;\n    width: 262.5px;\n  }\n  .symbol.symbol-xxl-175px.symbol-2by3 > img {\n    height: 175px;\n    width: 262.5px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-200px > img {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xxl-200px .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xxl-200px.symbol-fixed .symbol-label {\n    width: 200px;\n    height: 200px;\n  }\n  .symbol.symbol-xxl-200px.symbol-fixed > img {\n    width: 200px;\n    height: 200px;\n    max-width: none;\n  }\n  .symbol.symbol-xxl-200px.symbol-2by3 .symbol-label {\n    height: 200px;\n    width: 300px;\n  }\n  .symbol.symbol-xxl-200px.symbol-2by3 > img {\n    height: 200px;\n    width: 300px;\n    max-width: none;\n  }\n}\n\n.symbol-group {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-left: 10px;\n}\n.symbol-group .symbol {\n  position: relative;\n  z-index: 0;\n  margin-left: -10px;\n  transition: all 0.3s ease;\n}\n.symbol-group .symbol:hover {\n  transition: all 0.3s ease;\n  z-index: 1;\n}\n.symbol-group .symbol-badge {\n  border: 2px solid var(--kt-body-bg);\n}\n.symbol-group .symbol-label {\n  position: relative;\n}\n.symbol-group .symbol-label:after {\n  display: block;\n  content: \" \";\n  border-radius: inherit;\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  border: 2px solid var(--kt-symbol-border-color);\n  -webkit-background-clip: padding-box;\n  /* for Safari */\n  background-clip: padding-box;\n  /* for IE9+, Firefox 4+, Opera, Chrome */\n}\n.symbol-group.symbol-hover .symbol {\n  cursor: pointer;\n}\n\n.pulse {\n  position: relative;\n}\n.pulse.pulse-white .pulse-ring {\n  border-color: #ffffff;\n}\n.pulse.pulse-light .pulse-ring {\n  border-color: #f5f8fa;\n}\n.pulse.pulse-primary .pulse-ring {\n  border-color: #009ef7;\n}\n.pulse.pulse-secondary .pulse-ring {\n  border-color: #E4E6EF;\n}\n.pulse.pulse-success .pulse-ring {\n  border-color: #50cd89;\n}\n.pulse.pulse-info .pulse-ring {\n  border-color: #7239ea;\n}\n.pulse.pulse-warning .pulse-ring {\n  border-color: #ffc700;\n}\n.pulse.pulse-danger .pulse-ring {\n  border-color: #f1416c;\n}\n.pulse.pulse-dark .pulse-ring {\n  border-color: #181C32;\n}\n\n.pulse-ring {\n  display: block;\n  border-radius: 40px;\n  height: 40px;\n  width: 40px;\n  position: absolute;\n  animation: animation-pulse 3.5s ease-out;\n  animation-iteration-count: infinite;\n  opacity: 0;\n  border-width: 3px;\n  border-style: solid;\n  border-color: var(--kt-gray-500);\n}\n\n@keyframes animation-pulse {\n  0% {\n    -webkit-transform: scale(0.1, 0.1);\n    opacity: 0;\n  }\n  60% {\n    -webkit-transform: scale(0.1, 0.1);\n    opacity: 0;\n  }\n  65% {\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(1.2, 1.2);\n    opacity: 0;\n  }\n}\n[data-kt-app-page-loading=on] *,\n.page-loading * {\n  transition: none !important;\n}\n\n.page-loader {\n  background: var(--kt-body-bg);\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  display: none;\n}\n[data-kt-app-page-loading=on] .page-loader, .page-loading .page-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.scrolltop {\n  position: fixed;\n  display: none;\n  cursor: pointer;\n  z-index: 105;\n  justify-content: center;\n  align-items: center;\n  width: 36px;\n  height: 36px;\n  bottom: 43px;\n  right: 7px;\n  background-color: var(--kt-scrolltop-bg-color);\n  box-shadow: var(--kt-scrolltop-box-shadow);\n  opacity: 0;\n  transition: color 0.2s ease;\n  border-radius: 0.475rem;\n}\n.scrolltop .svg-icon {\n  color: var(--kt-scrolltop-icon-color);\n}\n.scrolltop .svg-icon svg {\n  height: 24px;\n  width: 24px;\n}\n.scrolltop > i {\n  font-size: 1.3rem;\n  color: var(--kt-scrolltop-icon-color);\n}\n.scrolltop:hover {\n  background-color: var(--kt-scrolltop-bg-color-hover);\n}\n.scrolltop:hover .svg-icon,\n.scrolltop:hover i {\n  color: var(--kt-scrolltop-icon-color-hover);\n}\n[data-kt-scrolltop=on] .scrolltop {\n  opacity: var(--kt-scrolltop-opacity-on);\n  animation: animation-scrolltop 0.4s ease-out 1;\n  display: flex;\n}\n[data-kt-scrolltop=on] .scrolltop:hover {\n  transition: color 0.2s ease;\n  opacity: var(--kt-scrolltop-opacity-hover);\n}\n\n@media (max-width: 991.98px) {\n  .scrolltop {\n    bottom: 23px;\n    right: 5px;\n    width: 30px;\n    height: 30px;\n  }\n}\n@keyframes animation-scrolltop {\n  from {\n    margin-bottom: -15px;\n  }\n  to {\n    margin-bottom: 0;\n  }\n}\n.svg-icon {\n  line-height: 1;\n  color: var(--kt-text-muted);\n}\n.svg-icon svg {\n  height: 1.15rem;\n  width: 1.15rem;\n}\n.svg-icon.svg-icon-white {\n  color: var(--kt-text-white);\n}\n.svg-icon.svg-icon-primary {\n  color: var(--kt-text-primary);\n}\n.svg-icon.svg-icon-secondary {\n  color: var(--kt-text-secondary);\n}\n.svg-icon.svg-icon-light {\n  color: var(--kt-text-light);\n}\n.svg-icon.svg-icon-success {\n  color: var(--kt-text-success);\n}\n.svg-icon.svg-icon-info {\n  color: var(--kt-text-info);\n}\n.svg-icon.svg-icon-warning {\n  color: var(--kt-text-warning);\n}\n.svg-icon.svg-icon-danger {\n  color: var(--kt-text-danger);\n}\n.svg-icon.svg-icon-dark {\n  color: var(--kt-text-dark);\n}\n.svg-icon.svg-icon-muted {\n  color: var(--kt-text-muted);\n}\n.svg-icon.svg-icon-gray-100 {\n  color: var(--kt-text-gray-100);\n}\n.svg-icon.svg-icon-gray-200 {\n  color: var(--kt-text-gray-200);\n}\n.svg-icon.svg-icon-gray-300 {\n  color: var(--kt-text-gray-300);\n}\n.svg-icon.svg-icon-gray-400 {\n  color: var(--kt-text-gray-400);\n}\n.svg-icon.svg-icon-gray-500 {\n  color: var(--kt-text-gray-500);\n}\n.svg-icon.svg-icon-gray-600 {\n  color: var(--kt-text-gray-600);\n}\n.svg-icon.svg-icon-gray-700 {\n  color: var(--kt-text-gray-700);\n}\n.svg-icon.svg-icon-gray-800 {\n  color: var(--kt-text-gray-800);\n}\n.svg-icon.svg-icon-gray-900 {\n  color: var(--kt-text-gray-900);\n}\n.svg-icon.svg-icon-1 svg {\n  height: 1.75rem !important;\n  width: 1.75rem !important;\n}\n.svg-icon.svg-icon-2 svg {\n  height: 1.5rem !important;\n  width: 1.5rem !important;\n}\n.svg-icon.svg-icon-3 svg {\n  height: 1.35rem !important;\n  width: 1.35rem !important;\n}\n.svg-icon.svg-icon-4 svg {\n  height: 1.25rem !important;\n  width: 1.25rem !important;\n}\n.svg-icon.svg-icon-5 svg {\n  height: 1.15rem !important;\n  width: 1.15rem !important;\n}\n.svg-icon.svg-icon-6 svg {\n  height: 1.075rem !important;\n  width: 1.075rem !important;\n}\n.svg-icon.svg-icon-7 svg {\n  height: 0.95rem !important;\n  width: 0.95rem !important;\n}\n.svg-icon.svg-icon-8 svg {\n  height: 0.85rem !important;\n  width: 0.85rem !important;\n}\n.svg-icon.svg-icon-9 svg {\n  height: 0.75rem !important;\n  width: 0.75rem !important;\n}\n.svg-icon.svg-icon-10 svg {\n  height: 0.5rem !important;\n  width: 0.5rem !important;\n}\n.svg-icon.svg-icon-base svg {\n  height: 1rem !important;\n  width: 1rem !important;\n}\n.svg-icon.svg-icon-fluid svg {\n  height: 100% !important;\n  width: 100% !important;\n}\n.svg-icon.svg-icon-2x svg {\n  height: 2rem !important;\n  width: 2rem !important;\n}\n.svg-icon.svg-icon-2qx svg {\n  height: 2.25rem !important;\n  width: 2.25rem !important;\n}\n.svg-icon.svg-icon-2hx svg {\n  height: 2.5rem !important;\n  width: 2.5rem !important;\n}\n.svg-icon.svg-icon-2tx svg {\n  height: 2.75rem !important;\n  width: 2.75rem !important;\n}\n.svg-icon.svg-icon-3x svg {\n  height: 3rem !important;\n  width: 3rem !important;\n}\n.svg-icon.svg-icon-3qx svg {\n  height: 3.25rem !important;\n  width: 3.25rem !important;\n}\n.svg-icon.svg-icon-3hx svg {\n  height: 3.5rem !important;\n  width: 3.5rem !important;\n}\n.svg-icon.svg-icon-3tx svg {\n  height: 3.75rem !important;\n  width: 3.75rem !important;\n}\n.svg-icon.svg-icon-4x svg {\n  height: 4rem !important;\n  width: 4rem !important;\n}\n.svg-icon.svg-icon-4qx svg {\n  height: 4.25rem !important;\n  width: 4.25rem !important;\n}\n.svg-icon.svg-icon-4hx svg {\n  height: 4.5rem !important;\n  width: 4.5rem !important;\n}\n.svg-icon.svg-icon-4tx svg {\n  height: 4.75rem !important;\n  width: 4.75rem !important;\n}\n.svg-icon.svg-icon-5x svg {\n  height: 5rem !important;\n  width: 5rem !important;\n}\n.svg-icon.svg-icon-5qx svg {\n  height: 5.25rem !important;\n  width: 5.25rem !important;\n}\n.svg-icon.svg-icon-5hx svg {\n  height: 5.5rem !important;\n  width: 5.5rem !important;\n}\n.svg-icon.svg-icon-5tx svg {\n  height: 5.75rem !important;\n  width: 5.75rem !important;\n}\n@media (min-width: 576px) {\n  .svg-icon.svg-icon-sm-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-sm-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-sm-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-sm-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-sm-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-sm-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-sm-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-sm-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-sm-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-sm-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-sm-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-sm-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-sm-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-sm-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-sm-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n}\n@media (min-width: 768px) {\n  .svg-icon.svg-icon-md-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-md-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-md-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-md-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-md-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-md-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-md-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-md-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-md-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-md-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-md-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-md-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-md-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-md-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-md-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-md-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-md-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-md-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-md-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-md-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-md-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-md-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-md-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-md-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-md-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-md-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-md-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-md-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n}\n@media (min-width: 992px) {\n  .svg-icon.svg-icon-lg-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-lg-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-lg-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-lg-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-lg-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-lg-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-lg-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-lg-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-lg-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-lg-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-lg-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-lg-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-lg-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-lg-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-lg-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n}\n@media (min-width: 1200px) {\n  .svg-icon.svg-icon-xl-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-xl-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-xl-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-xl-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-xl-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-xl-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-xl-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-xl-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-xl-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-xl-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-xl-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-xl-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-xl-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-xl-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-xl-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n}\n@media (min-width: 1400px) {\n  .svg-icon.svg-icon-xxl-1 svg {\n    height: 1.75rem !important;\n    width: 1.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2 svg {\n    height: 1.5rem !important;\n    width: 1.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3 svg {\n    height: 1.35rem !important;\n    width: 1.35rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4 svg {\n    height: 1.25rem !important;\n    width: 1.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5 svg {\n    height: 1.15rem !important;\n    width: 1.15rem !important;\n  }\n  .svg-icon.svg-icon-xxl-6 svg {\n    height: 1.075rem !important;\n    width: 1.075rem !important;\n  }\n  .svg-icon.svg-icon-xxl-7 svg {\n    height: 0.95rem !important;\n    width: 0.95rem !important;\n  }\n  .svg-icon.svg-icon-xxl-8 svg {\n    height: 0.85rem !important;\n    width: 0.85rem !important;\n  }\n  .svg-icon.svg-icon-xxl-9 svg {\n    height: 0.75rem !important;\n    width: 0.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-10 svg {\n    height: 0.5rem !important;\n    width: 0.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-base svg {\n    height: 1rem !important;\n    width: 1rem !important;\n  }\n  .svg-icon.svg-icon-xxl-fluid svg {\n    height: 100% !important;\n    width: 100% !important;\n  }\n  .svg-icon.svg-icon-xxl-2x svg {\n    height: 2rem !important;\n    width: 2rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2qx svg {\n    height: 2.25rem !important;\n    width: 2.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2hx svg {\n    height: 2.5rem !important;\n    width: 2.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-2tx svg {\n    height: 2.75rem !important;\n    width: 2.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3x svg {\n    height: 3rem !important;\n    width: 3rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3qx svg {\n    height: 3.25rem !important;\n    width: 3.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3hx svg {\n    height: 3.5rem !important;\n    width: 3.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-3tx svg {\n    height: 3.75rem !important;\n    width: 3.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4x svg {\n    height: 4rem !important;\n    width: 4rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4qx svg {\n    height: 4.25rem !important;\n    width: 4.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4hx svg {\n    height: 4.5rem !important;\n    width: 4.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-4tx svg {\n    height: 4.75rem !important;\n    width: 4.75rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5x svg {\n    height: 5rem !important;\n    width: 5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5qx svg {\n    height: 5.25rem !important;\n    width: 5.25rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5hx svg {\n    height: 5.5rem !important;\n    width: 5.5rem !important;\n  }\n  .svg-icon.svg-icon-xxl-5tx svg {\n    height: 5.75rem !important;\n    width: 5.75rem !important;\n  }\n}\n\n.fixed-top {\n  position: fixed;\n  z-index: 101;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n@media (min-width: 576px) {\n  .fixed-top-sm {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n@media (min-width: 768px) {\n  .fixed-top-md {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n@media (min-width: 992px) {\n  .fixed-top-lg {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n@media (min-width: 1200px) {\n  .fixed-top-xl {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n@media (min-width: 1400px) {\n  .fixed-top-xxl {\n    position: fixed;\n    z-index: 101;\n    top: 0;\n    left: 0;\n    right: 0;\n  }\n}\n.timeline .timeline-item {\n  position: relative;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  align-items: flex-start;\n}\n.timeline .timeline-item:last-child .timeline-line {\n  bottom: 100%;\n}\n.timeline .timeline-line {\n  display: block;\n  content: \" \";\n  justify-content: center;\n  position: absolute;\n  z-index: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  transform: translate(50%);\n  border-left-width: 1px;\n  border-left-style: dashed;\n  border-left-color: var(--kt-gray-300);\n}\n.timeline .timeline-icon {\n  z-index: 1;\n  flex-shrink: 0;\n  margin-right: 1rem;\n}\n.timeline .timeline-content {\n  width: 100%;\n  overflow: auto;\n  margin-bottom: 1.5rem;\n}\n.timeline.timeline-center .timeline-item {\n  align-items: center;\n}\n.timeline.timeline-center .timeline-item:first-child .timeline-line {\n  top: 50%;\n}\n.timeline.timeline-center .timeline-item:last-child .timeline-line {\n  bottom: 50%;\n}\n\n.timeline-label {\n  position: relative;\n}\n.timeline-label:before {\n  content: \"\";\n  position: absolute;\n  left: 51px;\n  width: 3px;\n  top: 0;\n  bottom: 0;\n  background-color: var(--kt-gray-200);\n}\n.timeline-label .timeline-item {\n  display: flex;\n  align-items: flex-start;\n  position: relative;\n  margin-bottom: 1.7rem;\n}\n.timeline-label .timeline-item:last-child {\n  margin-bottom: 0;\n}\n.timeline-label .timeline-label {\n  width: 50px;\n  flex-shrink: 0;\n  position: relative;\n  color: var(--kt-gray-800);\n}\n.timeline-label .timeline-badge {\n  flex-shrink: 0;\n  background-color: var(--kt-body-bg);\n  width: 1rem;\n  height: 1rem;\n  border-radius: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n  position: relative;\n  margin-top: 1px;\n  margin-left: -0.5rem;\n  padding: 3px !important;\n  border: 6px solid var(--kt-body-bg) !important;\n}\n.timeline-label .timeline-badge span {\n  display: block;\n  border-radius: 100%;\n  width: 6px;\n  height: 6px;\n  background-color: var(--kt-gray-200);\n}\n.timeline-label .timeline-content {\n  flex-grow: 1;\n}\n\n.overlay {\n  position: relative;\n}\n.overlay .overlay-layer {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--kt-overlay-bg);\n  transition: all 0.3s ease;\n  opacity: 0;\n}\n.overlay.overlay-show .overlay-layer, .overlay.overlay-block .overlay-layer, .overlay:hover .overlay-layer {\n  transition: all 0.3s ease;\n  opacity: 1;\n}\n.overlay.overlay-block {\n  cursor: wait;\n}\n\n.bullet {\n  display: inline-block;\n  background-color: var(--kt-bullet-bg-color);\n  border-radius: 6px;\n  width: 8px;\n  height: 4px;\n  flex-shrink: 0;\n}\n\n.bullet-dot {\n  width: 4px;\n  height: 4px;\n  border-radius: 100% !important;\n}\n\n.bullet-vertical {\n  width: 4px;\n  height: 8px;\n}\n\n.bullet-line {\n  width: 5px;\n  height: 1px;\n  border-radius: 0;\n}\n\n.drawer {\n  display: flex !important;\n  overflow: auto;\n  z-index: 110;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  background-color: var(--kt-drawer-bg-color);\n  transition: transform 0.3s ease-in-out !important;\n}\n.drawer.drawer-start {\n  left: 0;\n  transform: translateX(-100%);\n}\n.drawer.drawer-end {\n  right: 0;\n  transform: translateX(100%);\n}\n.drawer.drawer-on {\n  transform: none;\n  box-shadow: var(--kt-drawer-box-shadow);\n  transition: transform 0.3s ease-in-out !important;\n}\n\n.drawer-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  overflow: hidden;\n  z-index: 109;\n  background-color: var(--kt-drawer-overlay-bg-color);\n  animation: animation-drawer-fade-in 0.3s ease-in-out 1;\n}\n\n[data-kt-drawer=true] {\n  display: none;\n}\n\n@keyframes animation-drawer-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@media (max-width: 991.98px) {\n  body[data-kt-drawer=on] {\n    overflow: hidden;\n  }\n}\n.badge {\n  --bs-badge-color: var(--kt-badge-color);\n  display: inline-flex;\n  align-items: center;\n}\n.badge.badge-circle, .badge.badge-square {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 1.75rem;\n  min-width: 1.75rem;\n  padding: 0 0.1rem;\n  line-height: 0;\n}\n.badge.badge-circle {\n  border-radius: 50%;\n  padding: 0;\n  min-width: unset;\n  width: 1.75rem;\n}\n.badge.badge-sm {\n  min-width: 1.5rem;\n  font-size: 0.8rem;\n}\n.badge.badge-sm.badge-square {\n  height: 1.5rem;\n}\n.badge.badge-sm.badge-circle {\n  width: 1.5rem;\n  height: 1.5rem;\n}\n.badge.badge-lg {\n  min-width: 2rem;\n  font-size: 1rem;\n}\n.badge.badge-lg.badge-square {\n  height: 2rem;\n}\n.badge.badge-lg.badge-circle {\n  width: 2rem;\n  height: 2rem;\n}\n\n.badge-white {\n  color: var(--kt-white-inverse);\n  background-color: var(--kt-white);\n}\n.badge-white.badge-outline {\n  border: 1px solid var(--kt-white);\n  color: var(--kt-white);\n  background-color: transparent;\n}\n\n.badge-light-white {\n  color: var(--kt-white);\n  background-color: var(--kt-white-light);\n}\n\n.badge-light {\n  color: var(--kt-light-inverse);\n  background-color: var(--kt-light);\n}\n.badge-light.badge-outline {\n  border: 1px solid var(--kt-light);\n  color: var(--kt-light);\n  background-color: transparent;\n}\n\n.badge-light-light {\n  color: var(--kt-light);\n  background-color: var(--kt-light-light);\n}\n\n.badge-primary {\n  color: var(--kt-primary-inverse);\n  background-color: var(--kt-primary);\n}\n.badge-primary.badge-outline {\n  border: 1px solid var(--kt-primary);\n  color: var(--kt-primary);\n  background-color: transparent;\n}\n\n.badge-light-primary {\n  color: var(--kt-primary);\n  background-color: var(--kt-primary-light);\n}\n\n.badge-secondary {\n  color: var(--kt-secondary-inverse);\n  background-color: var(--kt-secondary);\n}\n.badge-secondary.badge-outline {\n  border: 1px solid var(--kt-secondary);\n  color: var(--kt-secondary);\n  background-color: transparent;\n}\n\n.badge-light-secondary {\n  color: var(--kt-secondary);\n  background-color: var(--kt-secondary-light);\n}\n\n.badge-success {\n  color: var(--kt-success-inverse);\n  background-color: var(--kt-success);\n}\n.badge-success.badge-outline {\n  border: 1px solid var(--kt-success);\n  color: var(--kt-success);\n  background-color: transparent;\n}\n\n.badge-light-success {\n  color: var(--kt-success);\n  background-color: var(--kt-success-light);\n}\n\n.badge-info {\n  color: var(--kt-info-inverse);\n  background-color: var(--kt-info);\n}\n.badge-info.badge-outline {\n  border: 1px solid var(--kt-info);\n  color: var(--kt-info);\n  background-color: transparent;\n}\n\n.badge-light-info {\n  color: var(--kt-info);\n  background-color: var(--kt-info-light);\n}\n\n.badge-warning {\n  color: var(--kt-warning-inverse);\n  background-color: var(--kt-warning);\n}\n.badge-warning.badge-outline {\n  border: 1px solid var(--kt-warning);\n  color: var(--kt-warning);\n  background-color: transparent;\n}\n\n.badge-light-warning {\n  color: var(--kt-warning);\n  background-color: var(--kt-warning-light);\n}\n\n.badge-danger {\n  color: var(--kt-danger-inverse);\n  background-color: var(--kt-danger);\n}\n.badge-danger.badge-outline {\n  border: 1px solid var(--kt-danger);\n  color: var(--kt-danger);\n  background-color: transparent;\n}\n\n.badge-light-danger {\n  color: var(--kt-danger);\n  background-color: var(--kt-danger-light);\n}\n\n.badge-dark {\n  color: var(--kt-dark-inverse);\n  background-color: var(--kt-dark);\n}\n.badge-dark.badge-outline {\n  border: 1px solid var(--kt-dark);\n  color: var(--kt-dark);\n  background-color: transparent;\n}\n\n.badge-light-dark {\n  color: var(--kt-dark);\n  background-color: var(--kt-dark-light);\n}\n\n.indicator-progress {\n  display: none;\n}\n[data-kt-indicator=on] > .indicator-progress {\n  display: inline-block;\n}\n\n[data-kt-indicator=on] > .indicator-label {\n  display: none;\n}\n\n.hover-elevate-up {\n  transition: transform 0.3s ease;\n}\n.hover-elevate-up:hover {\n  transform: translateY(-5%);\n  transition: transform 0.3s ease;\n}\n\n.hover-elevate-down {\n  transition: transform 0.3s ease;\n}\n.hover-elevate-down:hover {\n  transform: translateY(5%);\n  transition: transform 0.3s ease;\n}\n\n.hover-scale {\n  transition: transform 0.3s ease;\n}\n.hover-scale:hover {\n  transform: scale(1.1);\n  transition: transform 0.3s ease;\n}\n\n.hover-rotate-end {\n  transition: transform 0.3s ease;\n}\n.hover-rotate-end:hover {\n  transform: rotate(4deg);\n  transition: transform 0.3s ease;\n}\n\n.hover-rotate-start {\n  transition: transform 0.3s ease;\n}\n.hover-rotate-start:hover {\n  transform: rotate(-4deg);\n  transition: transform 0.3s ease;\n}\n\n.rotate {\n  display: inline-flex;\n  align-items: center;\n}\n\n.rotate-90 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-90, .show > .rotate-90, .active > .rotate-90 {\n  transform: rotateZ(90deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-90, [direction=rtl] .show > .rotate-90, [direction=rtl] .active > .rotate-90 {\n  transform: rotateZ(-90deg);\n}\n\n.rotate-n90 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-n90, .show > .rotate-n90, .active > .rotate-n90 {\n  transform: rotateZ(-90deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-n90, [direction=rtl] .show > .rotate-n90, [direction=rtl] .active > .rotate-n90 {\n  transform: rotateZ(90deg);\n}\n\n.rotate-180 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-180, .show > .rotate-180, .active > .rotate-180 {\n  transform: rotateZ(180deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-180, [direction=rtl] .show > .rotate-180, [direction=rtl] .active > .rotate-180 {\n  transform: rotateZ(-180deg);\n}\n\n.rotate-n180 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-n180, .show > .rotate-n180, .active > .rotate-n180 {\n  transform: rotateZ(-180deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-n180, [direction=rtl] .show > .rotate-n180, [direction=rtl] .active > .rotate-n180 {\n  transform: rotateZ(180deg);\n}\n\n.rotate-270 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-270, .show > .rotate-270, .active > .rotate-270 {\n  transform: rotateZ(270deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-270, [direction=rtl] .show > .rotate-270, [direction=rtl] .active > .rotate-270 {\n  transform: rotateZ(-270deg);\n}\n\n.rotate-n270 {\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n  will-change: transform;\n}\n.collapsible:not(.collapsed) > .rotate-n270, .show > .rotate-n270, .active > .rotate-n270 {\n  transform: rotateZ(-270deg);\n  transition: transform 0.3s ease;\n}\n[direction=rtl] .collapsible:not(.collapsed) > .rotate-n270, [direction=rtl] .show > .rotate-n270, [direction=rtl] .active > .rotate-n270 {\n  transform: rotateZ(270deg);\n}\n\n@media (min-width: 992px) {\n  main,\nspan,\nol,\nul,\npre,\ndiv {\n    scrollbar-width: thin;\n    scrollbar-color: var(--kt-scrollbar-color) transparent;\n  }\n  main::-webkit-scrollbar,\nspan::-webkit-scrollbar,\nol::-webkit-scrollbar,\nul::-webkit-scrollbar,\npre::-webkit-scrollbar,\ndiv::-webkit-scrollbar {\n    width: var(--kt-scrollbar-width);\n    height: var(--kt-scrollbar-height);\n  }\n  main ::-webkit-scrollbar-track,\nspan ::-webkit-scrollbar-track,\nol ::-webkit-scrollbar-track,\nul ::-webkit-scrollbar-track,\npre ::-webkit-scrollbar-track,\ndiv ::-webkit-scrollbar-track {\n    border-radius: 0.5rem;\n  }\n  main ::-webkit-scrollbar-thumb,\nspan ::-webkit-scrollbar-thumb,\nol ::-webkit-scrollbar-thumb,\nul ::-webkit-scrollbar-thumb,\npre ::-webkit-scrollbar-thumb,\ndiv ::-webkit-scrollbar-thumb {\n    border-radius: 0.5rem;\n  }\n  main::-webkit-scrollbar-thumb,\nspan::-webkit-scrollbar-thumb,\nol::-webkit-scrollbar-thumb,\nul::-webkit-scrollbar-thumb,\npre::-webkit-scrollbar-thumb,\ndiv::-webkit-scrollbar-thumb {\n    background-color: var(--kt-scrollbar-color);\n  }\n  main::-webkit-scrollbar-corner,\nspan::-webkit-scrollbar-corner,\nol::-webkit-scrollbar-corner,\nul::-webkit-scrollbar-corner,\npre::-webkit-scrollbar-corner,\ndiv::-webkit-scrollbar-corner {\n    background-color: transparent;\n  }\n  main:hover,\nspan:hover,\nol:hover,\nul:hover,\npre:hover,\ndiv:hover {\n    scrollbar-color: var(--kt-scrollbar-hover-color) transparent;\n  }\n  main:hover::-webkit-scrollbar-thumb,\nspan:hover::-webkit-scrollbar-thumb,\nol:hover::-webkit-scrollbar-thumb,\nul:hover::-webkit-scrollbar-thumb,\npre:hover::-webkit-scrollbar-thumb,\ndiv:hover::-webkit-scrollbar-thumb {\n    background-color: var(--kt-scrollbar-hover-color);\n  }\n  main:hover::-webkit-scrollbar-corner,\nspan:hover::-webkit-scrollbar-corner,\nol:hover::-webkit-scrollbar-corner,\nul:hover::-webkit-scrollbar-corner,\npre:hover::-webkit-scrollbar-corner,\ndiv:hover::-webkit-scrollbar-corner {\n    background-color: transparent;\n  }\n}\n.scroll {\n  overflow: scroll;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .scroll {\n    overflow: auto;\n  }\n}\n\n.scroll-x {\n  overflow-x: scroll;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .scroll-x {\n    overflow-x: auto;\n  }\n}\n\n.scroll-y {\n  overflow-y: scroll;\n  position: relative;\n}\n@media (max-width: 991.98px) {\n  .scroll-y {\n    overflow-y: auto;\n  }\n}\n\n.hover-scroll {\n  position: relative;\n}\n@media (min-width: 992px) {\n  .hover-scroll {\n    overflow: hidden;\n    border-right: var(--kt-scrollbar-width) solid transparent;\n    border-bottom: var(--kt-scrollbar-height) transparent;\n    margin-right: calc(-1 * var(--kt-scrollbar-width));\n    margin-bottom: calc(-1 * var(--kt-scrollbar-height));\n  }\n  .hover-scroll:hover {\n    overflow: scroll;\n    border-right: 0;\n    border-bottom: 0;\n  }\n  @-moz-document url-prefix() {\n    .hover-scroll {\n      overflow: scroll;\n      position: relative;\n      border-right: 0;\n      border-bottom: 0;\n    }\n  }\n}\n@media (max-width: 991.98px) {\n  .hover-scroll {\n    overflow: auto;\n  }\n}\n\n.hover-scroll-y {\n  position: relative;\n}\n@media (min-width: 992px) {\n  .hover-scroll-y {\n    overflow-y: hidden;\n    border-right: var(--kt-scrollbar-width) solid transparent;\n    margin-right: calc(-1 * var(--kt-scrollbar-width));\n  }\n  .hover-scroll-y:hover {\n    overflow-y: scroll;\n    border-right: 0;\n  }\n  @-moz-document url-prefix() {\n    .hover-scroll-y {\n      overflow-y: scroll;\n      position: relative;\n      border-right: 0;\n    }\n  }\n}\n@media (max-width: 991.98px) {\n  .hover-scroll-y {\n    overflow-y: auto;\n  }\n}\n\n.hover-scroll-x {\n  position: relative;\n}\n@media (min-width: 992px) {\n  .hover-scroll-x {\n    overflow-x: hidden;\n    border-bottom: var(--kt-scrollbar-height) solid transparent;\n  }\n  .hover-scroll-x:hover {\n    overflow-x: scroll;\n    border-bottom: 0;\n  }\n  @-moz-document url-prefix() {\n    .hover-scroll-x {\n      overflow-x: scroll;\n      position: relative;\n      border-bottom: 0;\n    }\n  }\n}\n@media (max-width: 991.98px) {\n  .hover-scroll-x {\n    overflow-x: auto;\n  }\n}\n\n.hover-scroll-overlay {\n  position: relative;\n}\n@media (min-width: 992px) {\n  .hover-scroll-overlay {\n    overflow: hidden;\n  }\n  .hover-scroll-overlay::-webkit-scrollbar {\n    width: calc(var(--kt-scrollbar-width) + var(--kt-scrollbar-width));\n    height: calc(var(--kt-scrollbar-width) + var(--kt-scrollbar-width));\n  }\n  .hover-scroll-overlay::-webkit-scrollbar-track {\n    border-radius: 0;\n  }\n  .hover-scroll-overlay::-webkit-scrollbar-thumb {\n    border-radius: 0;\n    background-clip: content-box;\n    border-right: var(--kt-scrollbar-space) solid transparent;\n    border-bottom: var(--kt-scrollbar-space) solid transparent;\n  }\n  .hover-scroll-overlay:hover {\n    overflow: overlay;\n  }\n  @-moz-document url-prefix() {\n    .hover-scroll-overlay {\n      overflow: scroll;\n      position: relative;\n    }\n  }\n}\n@media (max-width: 991.98px) {\n  .hover-scroll-overlay {\n    overflow: auto;\n  }\n}\n\n.hover-scroll-overlay-y {\n  position: relative;\n}\n@media (min-width: 992px) {\n  .hover-scroll-overlay-y {\n    overflow-y: hidden;\n  }\n  .hover-scroll-overlay-y::-webkit-scrollbar {\n    width: calc(var(--kt-scrollbar-width) + var(--kt-scrollbar-space));\n  }\n  .hover-scroll-overlay-y::-webkit-scrollbar-track {\n    border-radius: 0;\n  }\n  .hover-scroll-overlay-y::-webkit-scrollbar-thumb {\n    border-radius: 0;\n    background-clip: content-box;\n    border-right: var(--kt-scrollbar-space) solid transparent;\n  }\n  .hover-scroll-overlay-y:hover {\n    overflow-y: overlay;\n  }\n  @-moz-document url-prefix() {\n    .hover-scroll-overlay-y {\n      overflow-y: scroll;\n      position: relative;\n    }\n  }\n}\n@media (max-width: 991.98px) {\n  .hover-scroll-overlay-y {\n    overflow-y: auto;\n  }\n}\n\n.hover-scroll-overlay-x {\n  position: relative;\n}\n@media (min-width: 992px) {\n  .hover-scroll-overlay-x {\n    overflow-x: hidden;\n  }\n  .hover-scroll-overlay-x::-webkit-scrollbar {\n    height: calc(var(--kt-scrollbar-width) + var(--kt-scrollbar-space));\n  }\n  .hover-scroll-overlay-x::-webkit-scrollbar-track {\n    border-radius: 0;\n  }\n  .hover-scroll-overlay-x::-webkit-scrollbar-thumb {\n    border-radius: 0;\n    background-clip: content-box;\n    border-bottom: var(--kt-scrollbar-space) solid transparent;\n  }\n  .hover-scroll-overlay-x:hover {\n    overflow-x: overlay;\n  }\n  @-moz-document url-prefix() {\n    .hover-scroll-overlay-x {\n      overflow-x: scroll;\n      position: relative;\n    }\n  }\n}\n@media (max-width: 991.98px) {\n  .hover-scroll-overlay-x {\n    overflow-x: auto;\n  }\n}\n\n.scroll-ps {\n  padding-left: var(--kt-scrollbar-width) !important;\n}\n\n.scroll-ms {\n  margin-left: var(--kt-scrollbar-width) !important;\n}\n\n.scroll-mb {\n  margin-bottom: var(--kt-scrollbar-height) !important;\n}\n\n.scroll-pe {\n  padding-right: var(--kt-scrollbar-width) !important;\n}\n\n.scroll-me {\n  margin-right: var(--kt-scrollbar-width) !important;\n}\n\n.scroll-px {\n  padding-left: var(--kt-scrollbar-width) !important;\n  padding-right: var(--kt-scrollbar-width) !important;\n}\n\n.scroll-mx {\n  margin-left: var(--kt-scrollbar-width) !important;\n  margin-right: var(--kt-scrollbar-width) !important;\n}\n\n.rating {\n  display: flex;\n  align-items: center;\n}\n\n.rating-input {\n  position: absolute !important;\n  left: -9999px !important;\n}\n.rating-input[disabled] {\n  display: none;\n}\n\n.rating-label {\n  padding: 0;\n  margin: 0;\n}\n.rating-label > i, .rating-label > .svg-icon {\n  line-height: 1;\n  color: var(--kt-rating-color-default);\n}\n\nlabel.rating-label {\n  cursor: pointer;\n}\n\ndiv.rating-label.checked > i, div.rating-label.checked > .svg-icon,\nlabel.rating-label > i,\nlabel.rating-label > .svg-icon {\n  color: var(--kt-rating-color-active);\n}\n\n.rating-input:checked ~ .rating-label > i, .rating-input:checked ~ .rating-label > .svg-icon {\n  color: var(--kt-rating-color-default);\n}\n\n.rating:hover label.rating-label > i, .rating:hover label.rating-label > .svg-icon {\n  color: var(--kt-rating-color-active);\n}\n\nlabel.rating-label:hover ~ .rating-label {\n  color: var(--kt-rating-color-default);\n}\nlabel.rating-label:hover ~ .rating-label > i, label.rating-label:hover ~ .rating-label > .svg-icon {\n  color: var(--kt-rating-color-default);\n}\n\n.stepper [data-kt-stepper-element=info],\n.stepper [data-kt-stepper-element=content] {\n  display: none;\n}\n.stepper [data-kt-stepper-element=info].current,\n.stepper [data-kt-stepper-element=content].current {\n  display: flex;\n}\n.stepper .stepper-item[data-kt-stepper-action=step] {\n  cursor: pointer;\n}\n.stepper [data-kt-stepper-action=final] {\n  display: none;\n}\n.stepper [data-kt-stepper-action=previous] {\n  display: none;\n}\n.stepper [data-kt-stepper-action=next] {\n  display: inline-block;\n}\n.stepper [data-kt-stepper-action=submit] {\n  display: none;\n}\n.stepper.first [data-kt-stepper-action=previous] {\n  display: none;\n}\n.stepper.first [data-kt-stepper-action=next] {\n  display: inline-block;\n}\n.stepper.first [data-kt-stepper-action=submit] {\n  display: none;\n}\n.stepper.between [data-kt-stepper-action=previous] {\n  display: inline-block;\n}\n.stepper.between [data-kt-stepper-action=next] {\n  display: inline-block;\n}\n.stepper.between [data-kt-stepper-action=submit] {\n  display: none;\n}\n.stepper.last [data-kt-stepper-action=final] {\n  display: inline-block;\n}\n.stepper.last [data-kt-stepper-action=final].btn-flex {\n  display: flex;\n}\n.stepper.last [data-kt-stepper-action=previous] {\n  display: inline-block;\n}\n.stepper.last [data-kt-stepper-action=previous].btn-flex {\n  display: flex;\n}\n.stepper.last [data-kt-stepper-action=next] {\n  display: none;\n}\n.stepper.last [data-kt-stepper-action=next].btn-flex {\n  display: flex;\n}\n.stepper.last [data-kt-stepper-action=submit] {\n  display: inline-block;\n}\n.stepper.last [data-kt-stepper-action=submit].btn-flex {\n  display: flex;\n}\n\n.stepper.stepper-pills {\n  --kt-stepper-pills-size: 40px;\n  --kt-stepper-icon-border-radius: 9px;\n  --kt-stepper-icon-check-size: 1rem;\n  --kt-stepper-icon-bg-color: var(--kt-primary-light);\n  --kt-stepper-icon-bg-color-current: var(--kt-primary);\n  --kt-stepper-icon-bg-color-completed: var(--kt-primary-light);\n  --kt-stepper-icon-border: 0;\n  --kt-stepper-icon-border-current: 0;\n  --kt-stepper-icon-border-completed: 0;\n  --kt-stepper-icon-number-color: var(--kt-primary);\n  --kt-stepper-icon-number-color-current: var(--kt-white);\n  --kt-stepper-icon-check-color-completed: var(--kt-primary);\n  --kt-stepper-label-title-opacity: 1;\n  --kt-stepper-label-title-opacity-current: 1;\n  --kt-stepper-label-title-opacity-completed: 1;\n  --kt-stepper-label-title-color: var(--kt-gray-800);\n  --kt-stepper-label-title-color-current: var(--kt-gray-600);\n  --kt-stepper-label-title-color-completed: var(--kt-text-muted);\n  --kt-stepper-label-desc-opacity: 1;\n  --kt-stepper-label-desc-opacity-current: 1;\n  --kt-stepper-label-desc-opacity-completed: 1;\n  --kt-stepper-label-desc-color: var(--kt-text-muted);\n  --kt-stepper-label-desc-color-current: var(--kt-text-400);\n  --kt-stepper-label-desc-color-completed: var(--kt-gray-400);\n  --kt-stepper-line-border: 1px dashed var(--kt-gray-300);\n}\n.stepper.stepper-pills .stepper-nav {\n  display: flex;\n}\n.stepper.stepper-pills .stepper-item {\n  display: flex;\n  align-items: center;\n  transition: color 0.2s ease;\n}\n.stepper.stepper-pills .stepper-item .stepper-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: color 0.2s ease;\n  width: var(--kt-stepper-pills-size);\n  height: var(--kt-stepper-pills-size);\n  border-radius: var(--kt-stepper-icon-border-radius);\n  background-color: var(--kt-stepper-icon-bg-color);\n  border: var(--kt-stepper-icon-border);\n  margin-right: 1.5rem;\n}\n.stepper.stepper-pills .stepper-item .stepper-icon .stepper-check {\n  display: none;\n  font-size: var(--kt-stepper-icon-check-size);\n}\n.stepper.stepper-pills .stepper-item .stepper-icon .stepper-number {\n  font-weight: 600;\n  color: var(--kt-stepper-icon-number-color);\n  font-size: 1.25rem;\n}\n.stepper.stepper-pills .stepper-item .stepper-label {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.stepper.stepper-pills .stepper-item .stepper-label .stepper-title {\n  color: var(--kt-stepper-label-title-color);\n  opacity: var(--kt-stepper-label-title-opacity);\n  font-weight: 600;\n  font-size: 1.25rem;\n  margin-bottom: 0.3rem;\n}\n.stepper.stepper-pills .stepper-item .stepper-label .stepper-desc {\n  opacity: var(--kt-stepper-label-desc-opacity);\n  color: var(--kt-stepper-label-desc-color);\n}\n.stepper.stepper-pills .stepper-item.current {\n  transition: color 0.2s ease;\n}\n.stepper.stepper-pills .stepper-item.current .stepper-icon {\n  transition: color 0.2s ease;\n  background-color: var(--kt-stepper-icon-bg-color-current);\n  border: var(--kt-stepper-icon-border-current);\n}\n.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-check {\n  display: none;\n}\n.stepper.stepper-pills .stepper-item.current .stepper-icon .stepper-number {\n  color: var(--kt-stepper-icon-number-color-current);\n  font-size: 1.35rem;\n}\n.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-title {\n  opacity: var(--kt-stepper-label-title-opacity-current);\n  color: var(--kt-stepper-label-title-color-current);\n}\n.stepper.stepper-pills .stepper-item.current .stepper-label .stepper-desc {\n  opacity: var(--kt-stepper-label-desc-opacity-current);\n  color: var(--kt-stepper-label-desc-color-current);\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon, .stepper.stepper-pills .stepper-item.completed .stepper-icon {\n  transition: color 0.2s ease;\n  background-color: var(--kt-stepper-icon-bg-color-completed);\n  border: var(--kt-stepper-icon-border-completed);\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon .stepper-check, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-check {\n  color: var(--kt-stepper-icon-check-color-completed);\n  display: inline-block;\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-icon .stepper-number, .stepper.stepper-pills .stepper-item.completed .stepper-icon .stepper-number {\n  display: none;\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-label .stepper-title, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-title {\n  opacity: var(--kt-stepper-label-title-opacity-completed);\n  color: var(--kt-stepper-label-title-color-completed);\n}\n.stepper.stepper-pills .stepper-item.current.mark-completed:last-child .stepper-label .stepper-desc, .stepper.stepper-pills .stepper-item.completed .stepper-label .stepper-desc {\n  opacity: var(--kt-stepper-label-desc-opacity-completed);\n  color: var(--kt-stepper-label-desc-color-completed);\n}\n.stepper.stepper-pills.stepper-column .stepper-nav {\n  flex-direction: column;\n  align-items: start;\n}\n.stepper.stepper-pills.stepper-column .stepper-item {\n  flex-direction: column;\n  justify-content: start;\n  align-items: stretch;\n  padding: 0;\n  margin: 0;\n}\n.stepper.stepper-pills.stepper-column .stepper-wrapper {\n  display: flex;\n  align-items: center;\n}\n.stepper.stepper-pills.stepper-column .stepper-icon {\n  z-index: 1;\n}\n.stepper.stepper-pills.stepper-column .stepper-line {\n  display: block;\n  flex-grow: 1;\n  margin-left: calc(var(--kt-stepper-pills-size) / 2);\n  border-left: var(--kt-stepper-line-border);\n  margin-top: 2px;\n  margin-bottom: 2px;\n}\n\n.stepper.stepper-links .stepper-nav {\n  display: flex;\n  margin: 0 auto;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.stepper.stepper-links .stepper-nav .stepper-item {\n  position: relative;\n  flex-shrink: 0;\n  margin: 1rem 1.5rem;\n}\n.stepper.stepper-links .stepper-nav .stepper-item:after {\n  content: \" \";\n  position: absolute;\n  top: 2.3rem;\n  left: 0;\n  height: 2px;\n  width: 100%;\n  background-color: transparent;\n  transition: color 0.2s ease;\n}\n.stepper.stepper-links .stepper-nav .stepper-item .stepper-title {\n  color: var(--kt-dark);\n  font-weight: 600;\n  font-size: 1.25rem;\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current {\n  transition: color 0.2s ease;\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current .stepper-title {\n  color: var(--kt-primary);\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current:after {\n  background-color: var(--kt-primary);\n}\n.stepper.stepper-links .stepper-nav .stepper-item.current.mark-completed:last-child .stepper-title, .stepper.stepper-links .stepper-nav .stepper-item.completed .stepper-title {\n  color: var(--kt-gray-400);\n}\n\n.toggle.collapsible:not(.collapsed) .toggle-off, .toggle.active .toggle-off {\n  display: none;\n}\n.toggle.collapsible.collapsed .toggle-on, .toggle:not(.collapsible):not(.active) .toggle-on {\n  display: none;\n}\n\n.xehagon {\n  clip-path: polygon(45% 1.3397459622%, 46.5797985667% 0.6030737921%, 48.2635182233% 0.1519224699%, 50% 0%, 51.7364817767% 0.1519224699%, 53.4202014333% 0.6030737921%, 55% 1.3397459622%, 89.6410161514% 21.3397459622%, 91.0688922482% 22.3395555688%, 92.3014605826% 23.5721239031%, 93.3012701892% 25%, 94.0379423592% 26.5797985667%, 94.4890936815% 28.2635182233%, 94.6410161514% 30%, 94.6410161514% 70%, 94.4890936815% 71.7364817767%, 94.0379423592% 73.4202014333%, 93.3012701892% 75%, 92.3014605826% 76.4278760969%, 91.0688922482% 77.6604444312%, 89.6410161514% 78.6602540378%, 55% 98.6602540378%, 53.4202014333% 99.3969262079%, 51.7364817767% 99.8480775301%, 50% 100%, 48.2635182233% 99.8480775301%, 46.5797985667% 99.3969262079%, 45% 98.6602540378%, 10.3589838486% 78.6602540378%, 8.9311077518% 77.6604444312%, 7.6985394174% 76.4278760969%, 6.6987298108% 75%, 5.9620576408% 73.4202014333%, 5.5109063185% 71.7364817767%, 5.3589838486% 70%, 5.3589838486% 30%, 5.5109063185% 28.2635182233%, 5.9620576408% 26.5797985667%, 6.6987298108% 25%, 7.6985394174% 23.5721239031%, 8.9311077518% 22.3395555688%, 10.3589838486% 21.3397459622%);\n}\n\n.octagon {\n  clip-path: polygon(46.1731656763% 0.7612046749%, 47.411809549% 0.3407417371%, 48.6947380778% 0.0855513863%, 50% 0%, 51.3052619222% 0.0855513863%, 52.588190451% 0.3407417371%, 53.8268343237% 0.7612046749%, 82.1111055711% 12.4769334274%, 83.2842712475% 13.0554747147%, 84.3718855375% 13.7821953496%, 85.3553390593% 14.6446609407%, 86.2178046504% 15.6281144625%, 86.9445252853% 16.7157287525%, 87.5230665726% 17.8888944289%, 99.2387953251% 46.1731656763%, 99.6592582629% 47.411809549%, 99.9144486137% 48.6947380778%, 100% 50%, 99.9144486137% 51.3052619222%, 99.6592582629% 52.588190451%, 99.2387953251% 53.8268343237%, 87.5230665726% 82.1111055711%, 86.9445252853% 83.2842712475%, 86.2178046504% 84.3718855375%, 85.3553390593% 85.3553390593%, 84.3718855375% 86.2178046504%, 83.2842712475% 86.9445252853%, 82.1111055711% 87.5230665726%, 53.8268343237% 99.2387953251%, 52.588190451% 99.6592582629%, 51.3052619222% 99.9144486137%, 50% 100%, 48.6947380778% 99.9144486137%, 47.411809549% 99.6592582629%, 46.1731656763% 99.2387953251%, 17.8888944289% 87.5230665726%, 16.7157287525% 86.9445252853%, 15.6281144625% 86.2178046504%, 14.6446609407% 85.3553390593%, 13.7821953496% 84.3718855375%, 13.0554747147% 83.2842712475%, 12.4769334274% 82.1111055711%, 0.7612046749% 53.8268343237%, 0.3407417371% 52.588190451%, 0.0855513863% 51.3052619222%, 0% 50%, 0.0855513863% 48.6947380778%, 0.3407417371% 47.411809549%, 0.7612046749% 46.1731656763%, 12.4769334274% 17.8888944289%, 13.0554747147% 16.7157287525%, 13.7821953496% 15.6281144625%, 14.6446609407% 14.6446609407%, 15.6281144625% 13.7821953496%, 16.7157287525% 13.0554747147%, 17.8888944289% 12.4769334274%);\n}\n\n.ribbon {\n  position: relative;\n}\n.ribbon .ribbon-label {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 10px;\n  position: absolute;\n  z-index: 1;\n  background-color: var(--kt-ribbon-label-bg);\n  box-shadow: var(--kt-ribbon-label-box-shadow);\n  color: var(--kt-primary-inverse);\n  top: 50%;\n  right: 0;\n  transform: translateX(5px) translateY(-50%);\n}\n.ribbon .ribbon-label > .ribbon-inner {\n  z-index: -1;\n  position: absolute;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n.ribbon .ribbon-label:after {\n  border-color: var(--kt-ribbon-label-border-color);\n}\n.ribbon-vertical .ribbon-label {\n  padding: 5px 10px;\n  min-width: 36px;\n  min-height: 46px;\n  text-align: center;\n}\n.ribbon.ribbon-top .ribbon-label {\n  top: 0;\n  transform: translateX(-15px) translateY(-4px);\n  border-bottom-right-radius: 0.475rem;\n  border-bottom-left-radius: 0.475rem;\n}\n.ribbon.ribbon-bottom .ribbon-label {\n  border-top-right-radius: 0.475rem;\n  border-top-left-radius: 0.475rem;\n}\n.ribbon.ribbon-start .ribbon-label {\n  top: 50%;\n  left: 0;\n  right: auto;\n  transform: translateX(-5px) translateY(-50%);\n  border-top-right-radius: 0.475rem;\n  border-bottom-right-radius: 0.475rem;\n}\n.ribbon.ribbon-end .ribbon-label {\n  border-top-left-radius: 0.475rem;\n  border-bottom-left-radius: 0.475rem;\n}\n\n.ribbon.ribbon-clip.ribbon-start .ribbon-label {\n  left: -5px;\n}\n.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner {\n  border-top-right-radius: 0.475rem;\n  border-bottom-right-radius: 0.475rem;\n}\n.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:after {\n  content: \"\";\n  position: absolute;\n  border-style: solid;\n  border-color: transparent !important;\n  bottom: -10px;\n}\n.ribbon.ribbon-clip.ribbon-start .ribbon-label .ribbon-inner:before {\n  border-width: 0 10px 10px 0;\n  border-right-color: var(--kt-ribbon-clip-bg) !important;\n  left: 0;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label {\n  right: -5px;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner {\n  border-top-left-radius: 0.475rem;\n  border-bottom-left-radius: 0.475rem;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before, .ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:after {\n  content: \"\";\n  position: absolute;\n  border-style: solid;\n  border-color: transparent !important;\n  bottom: -10px;\n}\n.ribbon.ribbon-clip.ribbon-end .ribbon-label .ribbon-inner:before {\n  border-width: 0 0 10px 10px;\n  border-left-color: var(--kt-ribbon-clip-bg) !important;\n  right: 0;\n}\n\n.ribbon.ribbon-triangle {\n  position: absolute;\n  z-index: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n}\n.ribbon.ribbon-triangle.ribbon-top-start {\n  top: 0;\n  left: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem transparent !important;\n  border-left: solid 2rem transparent;\n  border-right: solid 2rem transparent !important;\n  border-top: solid 2rem transparent;\n}\n.ribbon.ribbon-triangle.ribbon-top-end {\n  top: 0;\n  right: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem transparent !important;\n  border-left: solid 2rem transparent !important;\n  border-right: solid 2rem transparent;\n  border-top: solid 2rem transparent;\n}\n.ribbon.ribbon-triangle.ribbon-bottom-start {\n  bottom: 0;\n  left: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem transparent;\n  border-left: solid 2rem transparent;\n  border-right: solid 2rem transparent !important;\n  border-top: solid 2rem transparent !important;\n}\n.ribbon.ribbon-triangle.ribbon-bottom-end {\n  bottom: 0;\n  right: 0;\n  width: 4rem;\n  height: 4rem;\n  border-bottom: solid 2rem transparent;\n  border-right: solid 2rem transparent;\n  border-left: solid 2rem transparent !important;\n  border-top: solid 2rem transparent !important;\n}\n\n.blockui {\n  position: relative;\n}\n.blockui .blockui-overlay {\n  transition: all 0.3s ease;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--kt-blockui-overlay-bg);\n}\n.blockui .blockui-overlay .spinner-border {\n  height: 1.35rem;\n  width: 1.35rem;\n}\n.blockui .blockui-message {\n  display: flex;\n  align-items: center;\n  border-radius: 0.475rem;\n  box-shadow: var(--kt-dropdown-box-shadow);\n  background-color: var(--kt-tooltip-bg);\n  color: var(--kt-gray-700);\n  font-weight: 600;\n  margin: 0 !important;\n  width: auto;\n  padding: 0.85rem 1.75rem !important;\n}\n.blockui .blockui-message .spinner-border {\n  margin-right: 0.65rem;\n}\n\n.explore-btn-toggle {\n  color: var(--kt-gray-600);\n  background-color: #ffffff;\n}\n.explore-btn-toggle:hover, .explore-btn-toggle:focus, .explore-btn-toggle:active {\n  color: #ffffff;\n  background-color: #00B2FF;\n}\n\n.explore-btn-dismiss {\n  border: 0;\n}\n.explore-btn-dismiss:hover i,\n.explore-btn-dismiss:hover .svg-icon {\n  color: #00B2FF;\n}\n\n.explore-btn-primary {\n  border: 0;\n  color: #ffffff;\n  background-color: #00B2FF;\n}\n.explore-btn-primary:hover {\n  color: #ffffff;\n  background-color: #0098DA;\n}\n\n.explore-btn-secondary {\n  border: 0;\n  color: var(--kt-gray-600);\n  background-color: var(--kt-gray-100);\n}\n.explore-btn-secondary:hover {\n  color: var(--kt-gray-800);\n  background-color: var(--kt-gray-200);\n}\n\n.explore-btn-outline {\n  border: 1px dashed var(--kt-gray-300) !important;\n}\n.explore-btn-outline:hover, .explore-btn-outline.active {\n  border: 1px dashed #50CD89 !important;\n  background-color: #E8FFF3;\n}\n\n.explore-link {\n  color: #00B2FF;\n}\n.explore-link:hover {\n  color: #0098DA;\n}\n\n.explore-link-hover:hover {\n  color: #00B2FF !important;\n}\n\n.explore-icon-success {\n  color: #50CD89;\n}\n\n.explore-icon-danger {\n  color: #F1416C;\n}\n\n.explore-label-free {\n  color: #ffffff;\n  background-color: #FFC700;\n}\n\n.explore-label-pro {\n  color: #ffffff;\n  background-color: #50CD89;\n}\n\n.engage-btn {\n  display: flex;\n  align-items: center;\n  height: 35px !important;\n  color: var(--kt-engage-btn-color);\n  border-color: var(--kt-engage-btn-bg);\n  background-color: var(--kt-engage-btn-bg);\n}\n.engage-btn i,\n.engage-btn .svg-icon {\n  color: var(--kt-engage-btn-color);\n}\n.engage-btn.dropdown-toggle:after {\n  color: var(--kt-engage-btn-color);\n}\n.btn-check:checked + .engage-btn, .btn-check:active + .engage-btn, .engage-btn:focus:not(.btn-active), .engage-btn:hover:not(.btn-active), .engage-btn:active:not(.btn-active), .engage-btn.active, .engage-btn.show, .show > .engage-btn {\n  color: var(--kt-engage-btn-color-active);\n  border-color: var(--kt-engage-btn-bg);\n  background-color: var(--kt-engage-btn-bg) !important;\n}\n.btn-check:checked + .engage-btn i,\n.btn-check:checked + .engage-btn .svg-icon, .btn-check:active + .engage-btn i,\n.btn-check:active + .engage-btn .svg-icon, .engage-btn:focus:not(.btn-active) i,\n.engage-btn:focus:not(.btn-active) .svg-icon, .engage-btn:hover:not(.btn-active) i,\n.engage-btn:hover:not(.btn-active) .svg-icon, .engage-btn:active:not(.btn-active) i,\n.engage-btn:active:not(.btn-active) .svg-icon, .engage-btn.active i,\n.engage-btn.active .svg-icon, .engage-btn.show i,\n.engage-btn.show .svg-icon, .show > .engage-btn i,\n.show > .engage-btn .svg-icon {\n  color: var(--kt-engage-btn-color-active);\n}\n.btn-check:checked + .engage-btn.dropdown-toggle:after, .btn-check:active + .engage-btn.dropdown-toggle:after, .engage-btn:focus:not(.btn-active).dropdown-toggle:after, .engage-btn:hover:not(.btn-active).dropdown-toggle:after, .engage-btn:active:not(.btn-active).dropdown-toggle:after, .engage-btn.active.dropdown-toggle:after, .engage-btn.show.dropdown-toggle:after, .show > .engage-btn.dropdown-toggle:after {\n  color: var(--kt-engage-btn-color-active);\n}\n\n.cookiealert {\n  background: inherit;\n  color: inherit;\n}\n\n@media print {\n  .print-content-only {\n    padding: 0 !important;\n    background: none !important;\n  }\n  .print-content-only .wrapper,\n.print-content-only .page,\n.print-content-only .page-title .content,\n.print-content-only .container,\n.print-content-only .container-xxl,\n.print-content-only .container-fluid,\n.print-content-only .container-sm,\n.print-content-only .container-md,\n.print-content-only .container-lg,\n.print-content-only .container-xl {\n    background: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  .print-content-only .aside,\n.print-content-only .sidebar,\n.print-content-only .scrolltop,\n.print-content-only .header,\n.print-content-only .footer,\n.print-content-only .toolbar,\n.print-content-only .drawer,\n.print-content-only .btn {\n    display: none !important;\n  }\n}\n.bg-white {\n  --kt-bg-rgb-color: var(--kt-white-bg-rgb);\n  background-color: #000000 !important;\n}\n\n.bg-black {\n  --kt-bg-rgb-color: var(--kt-black-bg-rgb);\n  background-color: #000000 !important;\n}\n\n.bg-body {\n  --kt-bg-rgb-color: var(--kt-body-bg-rgb);\n  background-color: var(--kt-body-bg) !important;\n}\n\n.bg-hover-body {\n  cursor: pointer;\n}\n.bg-hover-body:hover {\n  background-color: var(--kt-body-bg) !important;\n}\n\n.bg-active-body.active {\n  background-color: var(--kt-body-bg) !important;\n}\n\n.bg-state-body {\n  cursor: pointer;\n}\n.bg-state-body.active, .bg-state-body:hover {\n  background-color: var(--kt-body-bg) !important;\n}\n\n.bg-white {\n  --kt-bg-rgb-color: var(--kt-white-rgb);\n  background-color: var(--kt-white) !important;\n}\n\n.bg-hover-white {\n  cursor: pointer;\n}\n.bg-hover-white:hover {\n  background-color: var(--kt-white) !important;\n}\n\n.bg-active-white.active {\n  background-color: var(--kt-white) !important;\n}\n\n.bg-state-white {\n  cursor: pointer;\n}\n.bg-state-white.active, .bg-state-white:hover {\n  background-color: var(--kt-white) !important;\n}\n\n.bg-light {\n  --kt-bg-rgb-color: var(--kt-light-rgb);\n  background-color: var(--kt-light) !important;\n}\n\n.bg-hover-light {\n  cursor: pointer;\n}\n.bg-hover-light:hover {\n  background-color: var(--kt-light) !important;\n}\n\n.bg-active-light.active {\n  background-color: var(--kt-light) !important;\n}\n\n.bg-state-light {\n  cursor: pointer;\n}\n.bg-state-light.active, .bg-state-light:hover {\n  background-color: var(--kt-light) !important;\n}\n\n.bg-light-primary {\n  background-color: var(--kt-primary-light) !important;\n}\n\n.bg-primary {\n  --kt-bg-rgb-color: var(--kt-primary-rgb);\n  background-color: var(--kt-primary) !important;\n}\n\n.bg-hover-light-primary {\n  cursor: pointer;\n}\n.bg-hover-light-primary:hover {\n  background-color: var(--kt-primary-light) !important;\n}\n\n.bg-state-light-primary {\n  cursor: pointer;\n}\n.bg-state-light-primary.active, .bg-state-light-primary:hover {\n  background-color: var(--kt-primary-light) !important;\n}\n\n.bg-hover-primary {\n  cursor: pointer;\n}\n.bg-hover-primary:hover {\n  background-color: var(--kt-primary) !important;\n}\n\n.bg-active-primary.active {\n  background-color: var(--kt-primary) !important;\n}\n\n.bg-state-primary {\n  cursor: pointer;\n}\n.bg-state-primary.active, .bg-state-primary:hover {\n  background-color: var(--kt-primary) !important;\n}\n\n.bg-light-secondary {\n  background-color: var(--kt-secondary-light) !important;\n}\n\n.bg-secondary {\n  --kt-bg-rgb-color: var(--kt-secondary-rgb);\n  background-color: var(--kt-secondary) !important;\n}\n\n.bg-hover-light-secondary {\n  cursor: pointer;\n}\n.bg-hover-light-secondary:hover {\n  background-color: var(--kt-secondary-light) !important;\n}\n\n.bg-state-light-secondary {\n  cursor: pointer;\n}\n.bg-state-light-secondary.active, .bg-state-light-secondary:hover {\n  background-color: var(--kt-secondary-light) !important;\n}\n\n.bg-hover-secondary {\n  cursor: pointer;\n}\n.bg-hover-secondary:hover {\n  background-color: var(--kt-secondary) !important;\n}\n\n.bg-active-secondary.active {\n  background-color: var(--kt-secondary) !important;\n}\n\n.bg-state-secondary {\n  cursor: pointer;\n}\n.bg-state-secondary.active, .bg-state-secondary:hover {\n  background-color: var(--kt-secondary) !important;\n}\n\n.bg-light-success {\n  background-color: var(--kt-success-light) !important;\n}\n\n.bg-success {\n  --kt-bg-rgb-color: var(--kt-success-rgb);\n  background-color: var(--kt-success) !important;\n}\n\n.bg-hover-light-success {\n  cursor: pointer;\n}\n.bg-hover-light-success:hover {\n  background-color: var(--kt-success-light) !important;\n}\n\n.bg-state-light-success {\n  cursor: pointer;\n}\n.bg-state-light-success.active, .bg-state-light-success:hover {\n  background-color: var(--kt-success-light) !important;\n}\n\n.bg-hover-success {\n  cursor: pointer;\n}\n.bg-hover-success:hover {\n  background-color: var(--kt-success) !important;\n}\n\n.bg-active-success.active {\n  background-color: var(--kt-success) !important;\n}\n\n.bg-state-success {\n  cursor: pointer;\n}\n.bg-state-success.active, .bg-state-success:hover {\n  background-color: var(--kt-success) !important;\n}\n\n.bg-light-info {\n  background-color: var(--kt-info-light) !important;\n}\n\n.bg-info {\n  --kt-bg-rgb-color: var(--kt-info-rgb);\n  background-color: var(--kt-info) !important;\n}\n\n.bg-hover-light-info {\n  cursor: pointer;\n}\n.bg-hover-light-info:hover {\n  background-color: var(--kt-info-light) !important;\n}\n\n.bg-state-light-info {\n  cursor: pointer;\n}\n.bg-state-light-info.active, .bg-state-light-info:hover {\n  background-color: var(--kt-info-light) !important;\n}\n\n.bg-hover-info {\n  cursor: pointer;\n}\n.bg-hover-info:hover {\n  background-color: var(--kt-info) !important;\n}\n\n.bg-active-info.active {\n  background-color: var(--kt-info) !important;\n}\n\n.bg-state-info {\n  cursor: pointer;\n}\n.bg-state-info.active, .bg-state-info:hover {\n  background-color: var(--kt-info) !important;\n}\n\n.bg-light-warning {\n  background-color: var(--kt-warning-light) !important;\n}\n\n.bg-warning {\n  --kt-bg-rgb-color: var(--kt-warning-rgb);\n  background-color: var(--kt-warning) !important;\n}\n\n.bg-hover-light-warning {\n  cursor: pointer;\n}\n.bg-hover-light-warning:hover {\n  background-color: var(--kt-warning-light) !important;\n}\n\n.bg-state-light-warning {\n  cursor: pointer;\n}\n.bg-state-light-warning.active, .bg-state-light-warning:hover {\n  background-color: var(--kt-warning-light) !important;\n}\n\n.bg-hover-warning {\n  cursor: pointer;\n}\n.bg-hover-warning:hover {\n  background-color: var(--kt-warning) !important;\n}\n\n.bg-active-warning.active {\n  background-color: var(--kt-warning) !important;\n}\n\n.bg-state-warning {\n  cursor: pointer;\n}\n.bg-state-warning.active, .bg-state-warning:hover {\n  background-color: var(--kt-warning) !important;\n}\n\n.bg-light-danger {\n  background-color: var(--kt-danger-light) !important;\n}\n\n.bg-danger {\n  --kt-bg-rgb-color: var(--kt-danger-rgb);\n  background-color: var(--kt-danger) !important;\n}\n\n.bg-hover-light-danger {\n  cursor: pointer;\n}\n.bg-hover-light-danger:hover {\n  background-color: var(--kt-danger-light) !important;\n}\n\n.bg-state-light-danger {\n  cursor: pointer;\n}\n.bg-state-light-danger.active, .bg-state-light-danger:hover {\n  background-color: var(--kt-danger-light) !important;\n}\n\n.bg-hover-danger {\n  cursor: pointer;\n}\n.bg-hover-danger:hover {\n  background-color: var(--kt-danger) !important;\n}\n\n.bg-active-danger.active {\n  background-color: var(--kt-danger) !important;\n}\n\n.bg-state-danger {\n  cursor: pointer;\n}\n.bg-state-danger.active, .bg-state-danger:hover {\n  background-color: var(--kt-danger) !important;\n}\n\n.bg-light-dark {\n  background-color: var(--kt-dark-light) !important;\n}\n\n.bg-dark {\n  --kt-bg-rgb-color: var(--kt-dark-rgb);\n  background-color: var(--kt-dark) !important;\n}\n\n.bg-hover-light-dark {\n  cursor: pointer;\n}\n.bg-hover-light-dark:hover {\n  background-color: var(--kt-dark-light) !important;\n}\n\n.bg-state-light-dark {\n  cursor: pointer;\n}\n.bg-state-light-dark.active, .bg-state-light-dark:hover {\n  background-color: var(--kt-dark-light) !important;\n}\n\n.bg-hover-dark {\n  cursor: pointer;\n}\n.bg-hover-dark:hover {\n  background-color: var(--kt-dark) !important;\n}\n\n.bg-active-dark.active {\n  background-color: var(--kt-dark) !important;\n}\n\n.bg-state-dark {\n  cursor: pointer;\n}\n.bg-state-dark.active, .bg-state-dark:hover {\n  background-color: var(--kt-dark) !important;\n}\n\n.bg-gray-100 {\n  background-color: var(--kt-gray-100);\n}\n\n.bg-gray-100i {\n  background-color: var(--kt-gray-100) !important;\n}\n\n.bg-gray-200 {\n  background-color: var(--kt-gray-200);\n}\n\n.bg-gray-200i {\n  background-color: var(--kt-gray-200) !important;\n}\n\n.bg-gray-300 {\n  background-color: var(--kt-gray-300);\n}\n\n.bg-gray-300i {\n  background-color: var(--kt-gray-300) !important;\n}\n\n.bg-gray-400 {\n  background-color: var(--kt-gray-400);\n}\n\n.bg-gray-400i {\n  background-color: var(--kt-gray-400) !important;\n}\n\n.bg-gray-500 {\n  background-color: var(--kt-gray-500);\n}\n\n.bg-gray-500i {\n  background-color: var(--kt-gray-500) !important;\n}\n\n.bg-gray-600 {\n  background-color: var(--kt-gray-600);\n}\n\n.bg-gray-600i {\n  background-color: var(--kt-gray-600) !important;\n}\n\n.bg-gray-700 {\n  background-color: var(--kt-gray-700);\n}\n\n.bg-gray-700i {\n  background-color: var(--kt-gray-700) !important;\n}\n\n.bg-gray-800 {\n  background-color: var(--kt-gray-800);\n}\n\n.bg-gray-800i {\n  background-color: var(--kt-gray-800) !important;\n}\n\n.bg-gray-900 {\n  background-color: var(--kt-gray-900);\n}\n\n.bg-gray-900i {\n  background-color: var(--kt-gray-900) !important;\n}\n\n.bg-opacity-0 {\n  background-color: rgba(var(--kt-bg-rgb-color), 0) !important;\n}\n\n.bg-hover-opacity-0:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0) !important;\n}\n\n.bg-active-opacity-0.active {\n  background-color: rgba(var(--kt-bg-rgb-color), 0) !important;\n}\n\n.bg-state-opacity-0 .active, .bg-state-opacity-0:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0) !important;\n}\n\n.bg-opacity-5 {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.05) !important;\n}\n\n.bg-hover-opacity-5:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.05) !important;\n}\n\n.bg-active-opacity-5.active {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.05) !important;\n}\n\n.bg-state-opacity-5 .active, .bg-state-opacity-5:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.05) !important;\n}\n\n.bg-opacity-10 {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.1) !important;\n}\n\n.bg-hover-opacity-10:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.1) !important;\n}\n\n.bg-active-opacity-10.active {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.1) !important;\n}\n\n.bg-state-opacity-10 .active, .bg-state-opacity-10:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.1) !important;\n}\n\n.bg-opacity-15 {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.15) !important;\n}\n\n.bg-hover-opacity-15:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.15) !important;\n}\n\n.bg-active-opacity-15.active {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.15) !important;\n}\n\n.bg-state-opacity-15 .active, .bg-state-opacity-15:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.15) !important;\n}\n\n.bg-opacity-20 {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.2) !important;\n}\n\n.bg-hover-opacity-20:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.2) !important;\n}\n\n.bg-active-opacity-20.active {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.2) !important;\n}\n\n.bg-state-opacity-20 .active, .bg-state-opacity-20:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.2) !important;\n}\n\n.bg-opacity-25 {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.25) !important;\n}\n\n.bg-hover-opacity-25:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.25) !important;\n}\n\n.bg-active-opacity-25.active {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.25) !important;\n}\n\n.bg-state-opacity-25 .active, .bg-state-opacity-25:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.25) !important;\n}\n\n.bg-opacity-50 {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.5) !important;\n}\n\n.bg-hover-opacity-50:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.5) !important;\n}\n\n.bg-active-opacity-50.active {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.5) !important;\n}\n\n.bg-state-opacity-50 .active, .bg-state-opacity-50:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.5) !important;\n}\n\n.bg-opacity-75 {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.75) !important;\n}\n\n.bg-hover-opacity-75:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.75) !important;\n}\n\n.bg-active-opacity-75.active {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.75) !important;\n}\n\n.bg-state-opacity-75 .active, .bg-state-opacity-75:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 0.75) !important;\n}\n\n.bg-opacity-100 {\n  background-color: rgba(var(--kt-bg-rgb-color), 1) !important;\n}\n\n.bg-hover-opacity-100:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 1) !important;\n}\n\n.bg-active-opacity-100.active {\n  background-color: rgba(var(--kt-bg-rgb-color), 1) !important;\n}\n\n.bg-state-opacity-100 .active, .bg-state-opacity-100:hover {\n  background-color: rgba(var(--kt-bg-rgb-color), 1) !important;\n}\n\n.bgi-no-repeat {\n  background-repeat: no-repeat;\n}\n\n.bgi-position-y-top {\n  background-position-y: top;\n}\n\n.bgi-position-y-bottom {\n  background-position-y: bottom;\n}\n\n.bgi-position-y-center {\n  background-position-y: center;\n}\n\n.bgi-position-x-start {\n  background-position-x: left;\n}\n\n.bgi-position-x-end {\n  background-position-x: right;\n}\n\n.bgi-position-x-center {\n  background-position-x: center;\n}\n\n.bgi-position-top {\n  background-position: 0 top;\n}\n\n.bgi-position-bottom {\n  background-position: 0 bottom;\n}\n\n.bgi-position-center {\n  background-position: center;\n}\n\n.bgi-size-auto {\n  background-size: auto;\n}\n\n.bgi-size-cover {\n  background-size: cover;\n}\n\n.bgi-size-contain {\n  background-size: contain;\n}\n\n.bgi-attachment-fixed {\n  background-attachment: fixed;\n}\n\n.bgi-attachment-scroll {\n  background-attachment: scroll;\n}\n\n@media (min-width: 576px) {\n  .bgi-size-sm-auto {\n    background-size: auto;\n  }\n\n  .bgi-size-sm-cover {\n    background-size: cover;\n  }\n\n  .bgi-size-sm-contain {\n    background-size: contain;\n  }\n\n  .bgi-attachment-sm-fixed {\n    background-attachment: fixed;\n  }\n\n  .bgi-attachment-sm-scroll {\n    background-attachment: scroll;\n  }\n}\n@media (min-width: 768px) {\n  .bgi-size-md-auto {\n    background-size: auto;\n  }\n\n  .bgi-size-md-cover {\n    background-size: cover;\n  }\n\n  .bgi-size-md-contain {\n    background-size: contain;\n  }\n\n  .bgi-attachment-md-fixed {\n    background-attachment: fixed;\n  }\n\n  .bgi-attachment-md-scroll {\n    background-attachment: scroll;\n  }\n}\n@media (min-width: 992px) {\n  .bgi-size-lg-auto {\n    background-size: auto;\n  }\n\n  .bgi-size-lg-cover {\n    background-size: cover;\n  }\n\n  .bgi-size-lg-contain {\n    background-size: contain;\n  }\n\n  .bgi-attachment-lg-fixed {\n    background-attachment: fixed;\n  }\n\n  .bgi-attachment-lg-scroll {\n    background-attachment: scroll;\n  }\n}\n@media (min-width: 1200px) {\n  .bgi-size-xl-auto {\n    background-size: auto;\n  }\n\n  .bgi-size-xl-cover {\n    background-size: cover;\n  }\n\n  .bgi-size-xl-contain {\n    background-size: contain;\n  }\n\n  .bgi-attachment-xl-fixed {\n    background-attachment: fixed;\n  }\n\n  .bgi-attachment-xl-scroll {\n    background-attachment: scroll;\n  }\n}\n@media (min-width: 1400px) {\n  .bgi-size-xxl-auto {\n    background-size: auto;\n  }\n\n  .bgi-size-xxl-cover {\n    background-size: cover;\n  }\n\n  .bgi-size-xxl-contain {\n    background-size: contain;\n  }\n\n  .bgi-attachment-xxl-fixed {\n    background-attachment: fixed;\n  }\n\n  .bgi-attachment-xxl-scroll {\n    background-attachment: scroll;\n  }\n}\n.border-active:not(.active):not(:active):not(:hover):not(:focus) {\n  border-color: transparent !important;\n}\n\n.border-hover:not(:hover):not(:focus):not(.active):not(:active) {\n  cursor: pointer;\n  border-color: transparent !important;\n}\n\n.border-gray-100 {\n  border-color: var(--kt-gray-100) !important;\n}\n\n.border-gray-200 {\n  border-color: var(--kt-gray-200) !important;\n}\n\n.border-gray-300 {\n  border-color: var(--kt-gray-300) !important;\n}\n\n.border-gray-400 {\n  border-color: var(--kt-gray-400) !important;\n}\n\n.border-gray-500 {\n  border-color: var(--kt-gray-500) !important;\n}\n\n.border-gray-600 {\n  border-color: var(--kt-gray-600) !important;\n}\n\n.border-gray-700 {\n  border-color: var(--kt-gray-700) !important;\n}\n\n.border-gray-800 {\n  border-color: var(--kt-gray-800) !important;\n}\n\n.border-gray-900 {\n  border-color: var(--kt-gray-900) !important;\n}\n\n.border-hover-white:hover {\n  border-color: var(--kt-white) !important;\n}\n\n.border-active-white.active {\n  border-color: var(--kt-white) !important;\n}\n\n.border-hover-light:hover {\n  border-color: var(--kt-light) !important;\n}\n\n.border-active-light.active {\n  border-color: var(--kt-light) !important;\n}\n\n.border-hover-primary:hover {\n  border-color: var(--kt-primary) !important;\n}\n\n.border-active-primary.active {\n  border-color: var(--kt-primary) !important;\n}\n\n.border-hover-secondary:hover {\n  border-color: var(--kt-secondary) !important;\n}\n\n.border-active-secondary.active {\n  border-color: var(--kt-secondary) !important;\n}\n\n.border-hover-success:hover {\n  border-color: var(--kt-success) !important;\n}\n\n.border-active-success.active {\n  border-color: var(--kt-success) !important;\n}\n\n.border-hover-info:hover {\n  border-color: var(--kt-info) !important;\n}\n\n.border-active-info.active {\n  border-color: var(--kt-info) !important;\n}\n\n.border-hover-warning:hover {\n  border-color: var(--kt-warning) !important;\n}\n\n.border-active-warning.active {\n  border-color: var(--kt-warning) !important;\n}\n\n.border-hover-danger:hover {\n  border-color: var(--kt-danger) !important;\n}\n\n.border-active-danger.active {\n  border-color: var(--kt-danger) !important;\n}\n\n.border-hover-dark:hover {\n  border-color: var(--kt-dark) !important;\n}\n\n.border-active-dark.active {\n  border-color: var(--kt-dark) !important;\n}\n\n.border-hover-transparent:hover {\n  border-color: transparent !important;\n}\n\n.border-dashed {\n  border-style: dashed !important;\n  border-color: var(--kt-border-dashed-color);\n}\n\n.border-top-dashed {\n  border-top-style: dashed !important;\n}\n\n.border-bottom-dashed {\n  border-bottom-style: dashed !important;\n}\n\n.border-start-dashed {\n  border-left-style: dashed !important;\n}\n\n.border-end-dashed {\n  border-right-style: dashed !important;\n}\n\n.border-dotted {\n  border-style: dotted !important;\n}\n\n.border-top-dotted {\n  border-top-style: dotted !important;\n}\n\n.border-bottom-dotted {\n  border-bottom-style: dotted !important;\n}\n\n.border-start-dotted {\n  border-left-style: dotted !important;\n}\n\n.border-end-dotted {\n  border-right-style: dotted !important;\n}\n\n.border-transparent {\n  border-color: transparent !important;\n}\n\n.border-body {\n  border-color: var(--kt-body-bg) !important;\n}\n\n.rounded-top-0 {\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.rounded-bottom-0 {\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-start-0 {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n\n.rounded-end-0 {\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.flex-root {\n  flex: 1;\n}\n\n.flex-column-auto {\n  flex: none;\n}\n\n.flex-column-fluid {\n  flex: 1 0 auto;\n}\n\n.flex-row-auto {\n  flex: 0 0 auto;\n}\n\n.flex-row-fluid {\n  flex: 1 auto;\n  min-width: 0;\n}\n\n.flex-center {\n  justify-content: center;\n  align-items: center;\n}\n\n.flex-start {\n  justify-content: start;\n  align-items: start;\n}\n\n.flex-end {\n  justify-content: end;\n  align-items: end;\n}\n\n.flex-stack {\n  justify-content: space-between;\n  align-items: center;\n}\n\n@media (min-width: 576px) {\n  .flex-sm-root {\n    flex: 1;\n  }\n\n  .flex-sm-column-auto {\n    flex: none;\n  }\n\n  .flex-sm-column-fluid {\n    flex: 1 0 auto;\n  }\n\n  .flex-sm-row-auto {\n    flex: 0 0 auto;\n  }\n\n  .flex-sm-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n\n  .flex-sm-center {\n    justify-content: center;\n    align-items: center;\n  }\n\n  .flex-sm-start {\n    justify-content: start;\n    align-items: start;\n  }\n\n  .flex-sm-end {\n    justify-content: end;\n    align-items: end;\n  }\n\n  .flex-sm-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 768px) {\n  .flex-md-root {\n    flex: 1;\n  }\n\n  .flex-md-column-auto {\n    flex: none;\n  }\n\n  .flex-md-column-fluid {\n    flex: 1 0 auto;\n  }\n\n  .flex-md-row-auto {\n    flex: 0 0 auto;\n  }\n\n  .flex-md-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n\n  .flex-md-center {\n    justify-content: center;\n    align-items: center;\n  }\n\n  .flex-md-start {\n    justify-content: start;\n    align-items: start;\n  }\n\n  .flex-md-end {\n    justify-content: end;\n    align-items: end;\n  }\n\n  .flex-md-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 992px) {\n  .flex-lg-root {\n    flex: 1;\n  }\n\n  .flex-lg-column-auto {\n    flex: none;\n  }\n\n  .flex-lg-column-fluid {\n    flex: 1 0 auto;\n  }\n\n  .flex-lg-row-auto {\n    flex: 0 0 auto;\n  }\n\n  .flex-lg-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n\n  .flex-lg-center {\n    justify-content: center;\n    align-items: center;\n  }\n\n  .flex-lg-start {\n    justify-content: start;\n    align-items: start;\n  }\n\n  .flex-lg-end {\n    justify-content: end;\n    align-items: end;\n  }\n\n  .flex-lg-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 1200px) {\n  .flex-xl-root {\n    flex: 1;\n  }\n\n  .flex-xl-column-auto {\n    flex: none;\n  }\n\n  .flex-xl-column-fluid {\n    flex: 1 0 auto;\n  }\n\n  .flex-xl-row-auto {\n    flex: 0 0 auto;\n  }\n\n  .flex-xl-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n\n  .flex-xl-center {\n    justify-content: center;\n    align-items: center;\n  }\n\n  .flex-xl-start {\n    justify-content: start;\n    align-items: start;\n  }\n\n  .flex-xl-end {\n    justify-content: end;\n    align-items: end;\n  }\n\n  .flex-xl-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n@media (min-width: 1400px) {\n  .flex-xxl-root {\n    flex: 1;\n  }\n\n  .flex-xxl-column-auto {\n    flex: none;\n  }\n\n  .flex-xxl-column-fluid {\n    flex: 1 0 auto;\n  }\n\n  .flex-xxl-row-auto {\n    flex: 0 0 auto;\n  }\n\n  .flex-xxl-row-fluid {\n    flex: 1 auto;\n    min-width: 0;\n  }\n\n  .flex-xxl-center {\n    justify-content: center;\n    align-items: center;\n  }\n\n  .flex-xxl-start {\n    justify-content: start;\n    align-items: start;\n  }\n\n  .flex-xxl-end {\n    justify-content: end;\n    align-items: end;\n  }\n\n  .flex-xxl-stack {\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n.flex-equal {\n  flex-grow: 1;\n  flex-basis: 0;\n  flex-shrink: 0;\n}\n\n.shadow-xs {\n  box-shadow: var(--kt-box-shadow-xs);\n}\n\n.shadow-sm {\n  box-shadow: var(--kt-box-shadow-sm);\n}\n\n.shadow {\n  box-shadow: var(--kt-box-shadow);\n}\n\n.shadow-lg {\n  box-shadow: var(--kt-box-shadow-lg);\n}\n\n.text-white {\n  color: var(--kt-text-white) !important;\n}\n\n.text-hover-white {\n  transition: color 0.2s ease;\n}\n.text-hover-white i {\n  transition: color 0.2s ease;\n}\n.text-hover-white:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-white) !important;\n}\n.text-hover-white:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-white) !important;\n}\n.text-hover-white:hover .svg-icon {\n  color: var(--kt-text-white) !important;\n}\n\n.text-active-white {\n  transition: color 0.2s ease;\n}\n.text-active-white i {\n  transition: color 0.2s ease;\n}\n.text-active-white.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-white) !important;\n}\n.text-active-white.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-white) !important;\n}\n.text-active-white.active .svg-icon {\n  color: var(--kt-text-white) !important;\n}\n\n.text-primary {\n  color: var(--kt-text-primary) !important;\n}\n\n.text-inverse-primary {\n  color: var(--kt-primary-inverse) !important;\n}\n\n.text-light-primary {\n  color: var(--kt-primary-light) !important;\n}\n\n.text-hover-primary {\n  transition: color 0.2s ease;\n}\n.text-hover-primary i {\n  transition: color 0.2s ease;\n}\n.text-hover-primary:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-primary) !important;\n}\n.text-hover-primary:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-primary) !important;\n}\n.text-hover-primary:hover .svg-icon {\n  color: var(--kt-text-primary) !important;\n}\n\n.text-active-primary {\n  transition: color 0.2s ease;\n}\n.text-active-primary i {\n  transition: color 0.2s ease;\n}\n.text-active-primary.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-primary) !important;\n}\n.text-active-primary.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-primary) !important;\n}\n.text-active-primary.active .svg-icon {\n  color: var(--kt-text-primary) !important;\n}\n\n.text-secondary {\n  color: var(--kt-text-secondary) !important;\n}\n\n.text-inverse-secondary {\n  color: var(--kt-secondary-inverse) !important;\n}\n\n.text-light-secondary {\n  color: var(--kt-secondary-light) !important;\n}\n\n.text-hover-secondary {\n  transition: color 0.2s ease;\n}\n.text-hover-secondary i {\n  transition: color 0.2s ease;\n}\n.text-hover-secondary:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-secondary) !important;\n}\n.text-hover-secondary:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-secondary) !important;\n}\n.text-hover-secondary:hover .svg-icon {\n  color: var(--kt-text-secondary) !important;\n}\n\n.text-active-secondary {\n  transition: color 0.2s ease;\n}\n.text-active-secondary i {\n  transition: color 0.2s ease;\n}\n.text-active-secondary.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-secondary) !important;\n}\n.text-active-secondary.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-secondary) !important;\n}\n.text-active-secondary.active .svg-icon {\n  color: var(--kt-text-secondary) !important;\n}\n\n.text-light {\n  color: var(--kt-text-light) !important;\n}\n\n.text-inverse-light {\n  color: var(--kt-light-inverse) !important;\n}\n\n.text-hover-light {\n  transition: color 0.2s ease;\n}\n.text-hover-light i {\n  transition: color 0.2s ease;\n}\n.text-hover-light:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-light) !important;\n}\n.text-hover-light:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-light) !important;\n}\n.text-hover-light:hover .svg-icon {\n  color: var(--kt-text-light) !important;\n}\n\n.text-active-light {\n  transition: color 0.2s ease;\n}\n.text-active-light i {\n  transition: color 0.2s ease;\n}\n.text-active-light.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-light) !important;\n}\n.text-active-light.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-light) !important;\n}\n.text-active-light.active .svg-icon {\n  color: var(--kt-text-light) !important;\n}\n\n.text-success {\n  color: var(--kt-text-success) !important;\n}\n\n.text-inverse-success {\n  color: var(--kt-success-inverse) !important;\n}\n\n.text-light-success {\n  color: var(--kt-success-light) !important;\n}\n\n.text-hover-success {\n  transition: color 0.2s ease;\n}\n.text-hover-success i {\n  transition: color 0.2s ease;\n}\n.text-hover-success:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-success) !important;\n}\n.text-hover-success:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-success) !important;\n}\n.text-hover-success:hover .svg-icon {\n  color: var(--kt-text-success) !important;\n}\n\n.text-active-success {\n  transition: color 0.2s ease;\n}\n.text-active-success i {\n  transition: color 0.2s ease;\n}\n.text-active-success.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-success) !important;\n}\n.text-active-success.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-success) !important;\n}\n.text-active-success.active .svg-icon {\n  color: var(--kt-text-success) !important;\n}\n\n.text-info {\n  color: var(--kt-text-info) !important;\n}\n\n.text-inverse-info {\n  color: var(--kt-info-inverse) !important;\n}\n\n.text-light-info {\n  color: var(--kt-info-light) !important;\n}\n\n.text-hover-info {\n  transition: color 0.2s ease;\n}\n.text-hover-info i {\n  transition: color 0.2s ease;\n}\n.text-hover-info:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-info) !important;\n}\n.text-hover-info:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-info) !important;\n}\n.text-hover-info:hover .svg-icon {\n  color: var(--kt-text-info) !important;\n}\n\n.text-active-info {\n  transition: color 0.2s ease;\n}\n.text-active-info i {\n  transition: color 0.2s ease;\n}\n.text-active-info.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-info) !important;\n}\n.text-active-info.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-info) !important;\n}\n.text-active-info.active .svg-icon {\n  color: var(--kt-text-info) !important;\n}\n\n.text-warning {\n  color: var(--kt-text-warning) !important;\n}\n\n.text-inverse-warning {\n  color: var(--kt-warning-inverse) !important;\n}\n\n.text-light-warning {\n  color: var(--kt-warning-light) !important;\n}\n\n.text-hover-warning {\n  transition: color 0.2s ease;\n}\n.text-hover-warning i {\n  transition: color 0.2s ease;\n}\n.text-hover-warning:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-warning) !important;\n}\n.text-hover-warning:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-warning) !important;\n}\n.text-hover-warning:hover .svg-icon {\n  color: var(--kt-text-warning) !important;\n}\n\n.text-active-warning {\n  transition: color 0.2s ease;\n}\n.text-active-warning i {\n  transition: color 0.2s ease;\n}\n.text-active-warning.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-warning) !important;\n}\n.text-active-warning.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-warning) !important;\n}\n.text-active-warning.active .svg-icon {\n  color: var(--kt-text-warning) !important;\n}\n\n.text-danger {\n  color: var(--kt-text-danger) !important;\n}\n\n.text-inverse-danger {\n  color: var(--kt-danger-inverse) !important;\n}\n\n.text-light-danger {\n  color: var(--kt-danger-light) !important;\n}\n\n.text-hover-danger {\n  transition: color 0.2s ease;\n}\n.text-hover-danger i {\n  transition: color 0.2s ease;\n}\n.text-hover-danger:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-danger) !important;\n}\n.text-hover-danger:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-danger) !important;\n}\n.text-hover-danger:hover .svg-icon {\n  color: var(--kt-text-danger) !important;\n}\n\n.text-active-danger {\n  transition: color 0.2s ease;\n}\n.text-active-danger i {\n  transition: color 0.2s ease;\n}\n.text-active-danger.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-danger) !important;\n}\n.text-active-danger.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-danger) !important;\n}\n.text-active-danger.active .svg-icon {\n  color: var(--kt-text-danger) !important;\n}\n\n.text-dark {\n  color: var(--kt-text-dark) !important;\n}\n\n.text-inverse-dark {\n  color: var(--kt-dark-inverse) !important;\n}\n\n.text-light-dark {\n  color: var(--kt-dark-light) !important;\n}\n\n.text-hover-dark {\n  transition: color 0.2s ease;\n}\n.text-hover-dark i {\n  transition: color 0.2s ease;\n}\n.text-hover-dark:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-dark) !important;\n}\n.text-hover-dark:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-dark) !important;\n}\n.text-hover-dark:hover .svg-icon {\n  color: var(--kt-text-dark) !important;\n}\n\n.text-active-dark {\n  transition: color 0.2s ease;\n}\n.text-active-dark i {\n  transition: color 0.2s ease;\n}\n.text-active-dark.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-dark) !important;\n}\n.text-active-dark.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-dark) !important;\n}\n.text-active-dark.active .svg-icon {\n  color: var(--kt-text-dark) !important;\n}\n\n.text-muted {\n  color: var(--kt-text-muted) !important;\n}\n\n.text-hover-muted {\n  transition: color 0.2s ease;\n}\n.text-hover-muted i {\n  transition: color 0.2s ease;\n}\n.text-hover-muted:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-muted) !important;\n}\n.text-hover-muted:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-muted) !important;\n}\n.text-hover-muted:hover .svg-icon {\n  color: var(--kt-text-muted) !important;\n}\n\n.text-active-muted {\n  transition: color 0.2s ease;\n}\n.text-active-muted i {\n  transition: color 0.2s ease;\n}\n.text-active-muted.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-muted) !important;\n}\n.text-active-muted.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-muted) !important;\n}\n.text-active-muted.active .svg-icon {\n  color: var(--kt-text-muted) !important;\n}\n\n.text-gray-100 {\n  color: var(--kt-text-gray-100) !important;\n}\n\n.text-hover-gray-100 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-100 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-100:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-100) !important;\n}\n.text-hover-gray-100:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-100) !important;\n}\n.text-hover-gray-100:hover .svg-icon {\n  color: var(--kt-text-gray-100) !important;\n}\n\n.text-active-gray-100 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-100 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-100.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-100) !important;\n}\n.text-active-gray-100.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-100) !important;\n}\n.text-active-gray-100.active .svg-icon {\n  color: var(--kt-text-gray-100) !important;\n}\n\n.text-gray-200 {\n  color: var(--kt-text-gray-200) !important;\n}\n\n.text-hover-gray-200 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-200 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-200:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-200) !important;\n}\n.text-hover-gray-200:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-200) !important;\n}\n.text-hover-gray-200:hover .svg-icon {\n  color: var(--kt-text-gray-200) !important;\n}\n\n.text-active-gray-200 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-200 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-200.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-200) !important;\n}\n.text-active-gray-200.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-200) !important;\n}\n.text-active-gray-200.active .svg-icon {\n  color: var(--kt-text-gray-200) !important;\n}\n\n.text-gray-300 {\n  color: var(--kt-text-gray-300) !important;\n}\n\n.text-hover-gray-300 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-300 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-300:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-300) !important;\n}\n.text-hover-gray-300:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-300) !important;\n}\n.text-hover-gray-300:hover .svg-icon {\n  color: var(--kt-text-gray-300) !important;\n}\n\n.text-active-gray-300 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-300 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-300.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-300) !important;\n}\n.text-active-gray-300.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-300) !important;\n}\n.text-active-gray-300.active .svg-icon {\n  color: var(--kt-text-gray-300) !important;\n}\n\n.text-gray-400 {\n  color: var(--kt-text-gray-400) !important;\n}\n\n.text-hover-gray-400 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-400 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-400:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-400) !important;\n}\n.text-hover-gray-400:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-400) !important;\n}\n.text-hover-gray-400:hover .svg-icon {\n  color: var(--kt-text-gray-400) !important;\n}\n\n.text-active-gray-400 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-400 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-400.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-400) !important;\n}\n.text-active-gray-400.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-400) !important;\n}\n.text-active-gray-400.active .svg-icon {\n  color: var(--kt-text-gray-400) !important;\n}\n\n.text-gray-500 {\n  color: var(--kt-text-gray-500) !important;\n}\n\n.text-hover-gray-500 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-500 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-500:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-500) !important;\n}\n.text-hover-gray-500:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-500) !important;\n}\n.text-hover-gray-500:hover .svg-icon {\n  color: var(--kt-text-gray-500) !important;\n}\n\n.text-active-gray-500 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-500 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-500.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-500) !important;\n}\n.text-active-gray-500.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-500) !important;\n}\n.text-active-gray-500.active .svg-icon {\n  color: var(--kt-text-gray-500) !important;\n}\n\n.text-gray-600 {\n  color: var(--kt-text-gray-600) !important;\n}\n\n.text-hover-gray-600 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-600 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-600:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-600) !important;\n}\n.text-hover-gray-600:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-600) !important;\n}\n.text-hover-gray-600:hover .svg-icon {\n  color: var(--kt-text-gray-600) !important;\n}\n\n.text-active-gray-600 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-600 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-600.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-600) !important;\n}\n.text-active-gray-600.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-600) !important;\n}\n.text-active-gray-600.active .svg-icon {\n  color: var(--kt-text-gray-600) !important;\n}\n\n.text-gray-700 {\n  color: var(--kt-text-gray-700) !important;\n}\n\n.text-hover-gray-700 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-700 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-700:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-700) !important;\n}\n.text-hover-gray-700:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-700) !important;\n}\n.text-hover-gray-700:hover .svg-icon {\n  color: var(--kt-text-gray-700) !important;\n}\n\n.text-active-gray-700 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-700 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-700.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-700) !important;\n}\n.text-active-gray-700.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-700) !important;\n}\n.text-active-gray-700.active .svg-icon {\n  color: var(--kt-text-gray-700) !important;\n}\n\n.text-gray-800 {\n  color: var(--kt-text-gray-800) !important;\n}\n\n.text-hover-gray-800 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-800 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-800:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-800) !important;\n}\n.text-hover-gray-800:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-800) !important;\n}\n.text-hover-gray-800:hover .svg-icon {\n  color: var(--kt-text-gray-800) !important;\n}\n\n.text-active-gray-800 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-800 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-800.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-800) !important;\n}\n.text-active-gray-800.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-800) !important;\n}\n.text-active-gray-800.active .svg-icon {\n  color: var(--kt-text-gray-800) !important;\n}\n\n.text-gray-900 {\n  color: var(--kt-text-gray-900) !important;\n}\n\n.text-hover-gray-900 {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-900 i {\n  transition: color 0.2s ease;\n}\n.text-hover-gray-900:hover {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-900) !important;\n}\n.text-hover-gray-900:hover i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-900) !important;\n}\n.text-hover-gray-900:hover .svg-icon {\n  color: var(--kt-text-gray-900) !important;\n}\n\n.text-active-gray-900 {\n  transition: color 0.2s ease;\n}\n.text-active-gray-900 i {\n  transition: color 0.2s ease;\n}\n.text-active-gray-900.active {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-900) !important;\n}\n.text-active-gray-900.active i {\n  transition: color 0.2s ease;\n  color: var(--kt-text-gray-900) !important;\n}\n.text-active-gray-900.active .svg-icon {\n  color: var(--kt-text-gray-900) !important;\n}\n\n.text-transparent {\n  color: transparent;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-default {\n  cursor: default;\n}\n\n.cursor-move {\n  cursor: move;\n}\n\ni.bi, i[class^=fonticon-], i[class*=\" fonticon-\"], i[class^=fa-], i[class*=\" fa-\"], i[class^=la-], i[class*=\" la-\"] {\n  line-height: 1;\n  font-size: 1rem;\n  color: var(--kt-text-muted);\n}\n\na {\n  transition: color 0.2s ease;\n}\na:hover {\n  transition: color 0.2s ease;\n}\n\n.opacity-active-0.active {\n  opacity: 0 !important;\n}\n\n.opacity-state-0:hover, .opacity-state-0.active {\n  opacity: 0 !important;\n}\n\n.opacity-active-5.active {\n  opacity: 0.05 !important;\n}\n\n.opacity-state-5:hover, .opacity-state-5.active {\n  opacity: 0.05 !important;\n}\n\n.opacity-active-10.active {\n  opacity: 0.1 !important;\n}\n\n.opacity-state-10:hover, .opacity-state-10.active {\n  opacity: 0.1 !important;\n}\n\n.opacity-active-15.active {\n  opacity: 0.15 !important;\n}\n\n.opacity-state-15:hover, .opacity-state-15.active {\n  opacity: 0.15 !important;\n}\n\n.opacity-active-20.active {\n  opacity: 0.2 !important;\n}\n\n.opacity-state-20:hover, .opacity-state-20.active {\n  opacity: 0.2 !important;\n}\n\n.opacity-active-25.active {\n  opacity: 0.25 !important;\n}\n\n.opacity-state-25:hover, .opacity-state-25.active {\n  opacity: 0.25 !important;\n}\n\n.opacity-active-50.active {\n  opacity: 0.5 !important;\n}\n\n.opacity-state-50:hover, .opacity-state-50.active {\n  opacity: 0.5 !important;\n}\n\n.opacity-active-75.active {\n  opacity: 0.75 !important;\n}\n\n.opacity-state-75:hover, .opacity-state-75.active {\n  opacity: 0.75 !important;\n}\n\n.opacity-active-100.active {\n  opacity: 1 !important;\n}\n\n.opacity-state-100:hover, .opacity-state-100.active {\n  opacity: 1 !important;\n}\n\n.transform-90 {\n  transform: rotate(90deg);\n  transform-origin: right top;\n}\n\n.stepper.stepper-pills.stepper-multistep {\n  --kt-stepper-pills-size: 46px;\n  --kt-stepper-icon-border-radius: 9px;\n  --kt-stepper-icon-check-size: 1.25rem;\n  --kt-stepper-icon-bg-color: rgba(255, 255, 255, 0.03);\n  --kt-stepper-icon-bg-color-current: var(--kt-success);\n  --kt-stepper-icon-bg-color-completed: rgba(255, 255, 255, 0.03);\n  --kt-stepper-icon-border: 1px dashed rgba(255, 255, 255, 0.3);\n  --kt-stepper-icon-border-current: 0;\n  --kt-stepper-icon-border-completed: 1px dashed rgba(255, 255, 255, 0.3);\n  --kt-stepper-icon-number-color: var(--kt-white);\n  --kt-stepper-icon-number-color-current: var(--kt-white);\n  --kt-stepper-icon-number-color-completed: var(--kt-white);\n  --kt-stepper-icon-check-color-completed: var(--kt-success);\n  --kt-stepper-label-title-opacity: 0.7;\n  --kt-stepper-label-title-opacity-current: 1;\n  --kt-stepper-label-title-opacity-completed: 1;\n  --kt-stepper-label-title-color: var(--kt-white);\n  --kt-stepper-label-title-color-current: var(--kt-white);\n  --kt-stepper-label-title-color-completed: var(--kt-white);\n  --kt-stepper-label-desc-opacity: 0.7;\n  --kt-stepper-label-desc-opacity-current: 0.7;\n  --kt-stepper-label-desc-opacity-completed: 0.7;\n  --kt-stepper-label-desc-color: var(--kt-white);\n  --kt-stepper-label-desc-color-current: var(--kt-white);\n  --kt-stepper-label-desc-color-completed: var(--kt-white);\n  --kt-stepper-line-border: 1px dashed rgba(255, 255, 255, 0.3);\n}\n\n.landing-dark-bg {\n  background-color: #13263C;\n}\n\n.landing-dark-color {\n  color: #13263C;\n}\n\n.landing-dark-border {\n  border: 1px dashed #2C3F5B;\n}\n\n.landing-dark-separator {\n  border-top: 1px dashed #2C3F5B;\n}\n\n.landing-curve {\n  position: relative;\n}\n.landing-curve svg {\n  position: relative;\n  top: 0;\n  display: block;\n}\n\n.landing-header {\n  display: flex;\n  align-items: center;\n  height: 100px;\n}\n.landing-header .logo-default {\n  display: block;\n}\n.landing-header .logo-sticky {\n  display: none;\n}\n.landing-header .menu .menu-link.active {\n  color: #ffffff;\n}\n[data-kt-sticky-landing-header=on] .landing-header .menu .menu-link.active {\n  color: #009ef7;\n  background-color: rgba(239, 242, 245, 0.4);\n}\n[data-kt-sticky-landing-header=on] .landing-header {\n  padding: 0;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 100;\n  background-color: #ffffff;\n  box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  height: 70px;\n}\n[data-kt-sticky-landing-header=on] .landing-header .logo-sticky {\n  display: block;\n}\n[data-kt-sticky-landing-header=on] .landing-header .logo-default {\n  display: none;\n}\n\nbody[data-kt-sticky-landing-header=on] {\n  padding-top: 100px;\n}\n\n@media (max-width: 991.98px) {\n  .landing-header {\n    height: 70px;\n  }\n  .landing-header .landing-menu-wrapper {\n    position: relative;\n    overflow: auto;\n  }\n  [data-kt-sticky-landing-header=on] .landing-header {\n    height: 70px;\n  }\n  .landing-header .menu .menu-link.active {\n    color: #009ef7;\n    background-color: rgba(239, 242, 245, 0.4);\n  }\n\n  body[data-kt-sticky-landing-header=on] {\n    padding-top: 70px;\n  }\n}\n:root,\n[data-theme=light] {\n  --kt-app-bg-color: #f5f8fa;\n  --kt-app-blank-bg-color: #ffffff;\n  --kt-app-header-base-bg-color: #ffffff;\n  --kt-app-header-base-bg-color-mobile: #ffffff;\n  --kt-app-header-base-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  --kt-app-header-base-box-shadow-mobile: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  --kt-app-toolbar-base-bg-color: #ffffff;\n  --kt-app-toolbar-base-bg-color-mobile: #ffffff;\n  --kt-app-toolbar-base-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  --kt-app-toolbar-base-box-shadow-mobile: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  --kt-app-toolbar-base-border-top: 1px solid #eff2f5;\n  --kt-app-toolbar-base-border-top-mobile: 1px solid #eff2f5;\n  --kt-app-footer-bg-color: #ffffff;\n  --kt-app-footer-bg-color-mobile: #ffffff;\n}\n\n[data-theme=dark] {\n  --kt-app-bg-color: #151521;\n  --kt-app-blank-bg-color: #151521;\n  --kt-app-header-base-bg-color: #1e1e2d;\n  --kt-app-header-base-bg-color-mobile: #1e1e2d;\n  --kt-app-header-base-box-shadow: none;\n  --kt-app-header-base-box-shadow-mobile: none;\n  --kt-app-toolbar-base-bg-color: #1a1a27;\n  --kt-app-toolbar-base-bg-color-mobile: #1a1a27;\n  --kt-app-toolbar-base-box-shadow: none;\n  --kt-app-toolbar-base-box-shadow-mobile: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  --kt-app-toolbar-base-border-top: 0;\n  --kt-app-toolbar-base-border-top-mobile: 1px solid #eff2f5;\n  --kt-app-footer-bg-color: #1e1e2d;\n  --kt-app-footer-bg-color-mobile: #1e1e2d;\n}\n\nhtml {\n  font-family: sans-serif;\n  text-size-adjust: 100%;\n}\n\nhtml,\nbody {\n  height: 100%;\n  margin: 0px;\n  padding: 0px;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-size: 13px !important;\n  font-weight: 400;\n  font-family: Inter, Helvetica, \"sans-serif\";\n}\n@media (max-width: 991.98px) {\n  html,\nbody {\n    font-size: 12px !important;\n  }\n}\n@media (max-width: 767.98px) {\n  html,\nbody {\n    font-size: 12px !important;\n  }\n}\n\nbody {\n  display: flex;\n  flex-direction: column;\n}\nbody a:hover,\nbody a:active,\nbody a:focus {\n  text-decoration: none !important;\n}\n\ncanvas {\n  user-select: none;\n}\n\nrouter-outlet {\n  display: none;\n}\n\nbody,\n.app-default {\n  background-color: var(--kt-app-bg-color);\n}\n\n.app-blank {\n  background-color: var(--kt-app-blank-bg-color);\n}\n\n[data-kt-app-reset-transition=true] * {\n  transition: none !important;\n}\n\n.app-page {\n  display: flex;\n}\n\n[data-kt-app-page-loading=on] {\n  overflow: hidden;\n}\n\n[data-kt-app-page-loading=on] * {\n  transition: none !important;\n}\n\n.app-page-loader {\n  background: var(--kt-body-bg);\n  color: var(--kt-body-color);\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 10000;\n  display: none;\n}\n[data-kt-app-page-loading=on] .app-page-loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@media (min-width: 992px) {\n  .app-container {\n    padding-left: 30px !important;\n    padding-right: 30px !important;\n  }\n\n  .app-container-fit-desktop {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-container {\n    max-width: none;\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  }\n\n  .app-container-fit-mobile {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n}\n@media print {\n  .app-print-content-only {\n    padding: 0 !important;\n    background: none !important;\n  }\n  .app-print-content-only .app-wrapper,\n.app-print-content-only .app-page,\n.app-print-content-only .app-page-title,\n.app-print-content-only .app-content,\n.app-print-content-only .app-container {\n    background: none !important;\n    padding: 0 !important;\n    margin: 0 !important;\n  }\n  .app-print-content-only .app-aside,\n.app-print-content-only .app-aside-panel,\n.app-print-content-only .app-sidebar,\n.app-print-content-only .app-sidebar-panel,\n.app-print-content-only .app-header,\n.app-print-content-only .app-footer,\n.app-print-content-only .app-toolbar,\n.app-print-content-only .drawer,\n.app-print-content-only .scrolltop,\n.app-print-content-only .btn {\n    display: none !important;\n  }\n}\n.app-navbar {\n  display: flex;\n  align-items: stretch;\n}\n.app-navbar .app-navbar-item {\n  display: flex;\n  align-items: center;\n}\n.app-navbar.app-navbar-stretch .app-navbar-item {\n  align-items: stretch;\n}\n\n.app-header {\n  transition: none;\n  display: flex;\n  align-items: stretch;\n}\n\n@media (min-width: 992px) {\n  .app-header {\n    background-color: var(--kt-app-header-base-bg-color);\n    box-shadow: var(--kt-app-header-base-box-shadow);\n    border-bottom: var(--kt-app-header-base-border-bottom);\n  }\n\n  :root {\n    --kt-app-header-height: 70px;\n    --kt-app-header-height-actual: 70px;\n  }\n\n  [data-kt-app-header-sticky=on] {\n    --kt-app-header-height: 70px;\n    --kt-app-header-height-actual: 70px;\n  }\n\n  [data-kt-app-header-sticky=on][data-kt-app-header-stacked=true] {\n    --kt-app-header-height: calc(var(--kt-app-header-primary-height, 0px) + var(--kt-app-header-secondary-height, 0px));\n    --kt-app-header-height-actual: calc(70px + 70px);\n  }\n\n  [data-kt-app-header-minimize=on] {\n    --kt-app-header-height: 70px;\n  }\n\n  .app-header {\n    height: var(--kt-app-header-height);\n  }\n  [data-kt-app-header-fixed=true] .app-header {\n    z-index: 100;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n  }\n  [data-kt-app-header-static=true] .app-header {\n    position: relative;\n  }\n  [data-kt-app-header-stacked=true] .app-header {\n    flex-direction: column;\n    height: calc(var(--kt-app-header-primary-height) + var(--kt-app-header-secondary-height, 0px));\n  }\n  [data-kt-app-header-sticky=on] .app-header {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    z-index: 100;\n    background-color: var(--kt-app-header-sticky-bg-color);\n    box-shadow: var(--kt-app-header-sticky-box-shadow);\n    border-bottom: var(--kt-app-header-sticky-border-bottom);\n  }\n  [data-kt-app-header-minimize=on] .app-header {\n    transition: none;\n    z-index: 100;\n    background-color: var(--kt-app-header-minimize-bg-color);\n    box-shadow: var(--kt-app-header-minimize-box-shadow);\n    border-bottom: var(--kt-app-header-minimize-border-bottom);\n  }\n  .app-header .app-header-mobile-drawer {\n    display: flex;\n  }\n\n  [data-kt-app-header-fixed=true][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header, [data-kt-app-header-fixed=true][data-kt-app-sidebar-sticky=on][data-kt-app-sidebar-push-header=true] .app-header {\n    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));\n  }\n  body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header, body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-sticky=on][data-kt-app-sidebar-push-header=true] .app-header {\n    margin-left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-header-fixed=true][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header, [data-kt-app-header-fixed=true][data-kt-app-sidebar-panel-sticky=on][data-kt-app-sidebar-panel-push-header=true] .app-header {\n    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));\n  }\n  body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header, body:not([data-kt-app-header-fixed=true])[data-kt-app-sidebar-panel-sticky=on][data-kt-app-sidebar-panel-push-header=true] .app-header {\n    margin-left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));\n  }\n  [data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true] .app-header {\n    box-shadow: none;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-header {\n    background-color: var(--kt-app-header-base-bg-color-mobile);\n    box-shadow: var(--kt-app-header-base-box-shadow-mobile);\n    border-bottom: var(--kt-app-header-base-border-bottom-mobile);\n  }\n\n  :root {\n    --kt-app-header-height: 60px;\n  }\n\n  [data-kt-app-header-sticky=on] {\n    --kt-app-header-height: 70px;\n    --kt-app-header-height-actual: 70px;\n  }\n\n  [data-kt-app-header-minimize=on] {\n    --kt-app-header-height: 70px;\n    --kt-app-header-height-actual: 70px;\n  }\n\n  .app-header {\n    height: var(--kt-app-header-height);\n    align-items: stretch;\n  }\n  .app-header .app-header-mobile-drawer {\n    display: none;\n  }\n  [data-kt-app-header-stacked=true] .app-header {\n    flex-direction: column;\n  }\n  [data-kt-app-header-fixed-mobile=true] .app-header {\n    z-index: 100;\n    transition: none;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n  }\n  [data-kt-app-header-sticky=on] .app-header {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    z-index: 100;\n    background-color: var(--kt-app-header-sticky-bg-color-mobile);\n    box-shadow: var(--kt-app-header-sticky-box-shadow-mobile);\n    border-bottom: var(--kt-app-header-sticky-border-bottom-mobile);\n  }\n  [data-kt-app-header-minimize=on] .app-header {\n    z-index: 100;\n    transition: none;\n    background-color: var(--kt-app-header-minimize-bg-color-mobile);\n    box-shadow: var(--kt-app-header-minimize-box-shadow-mobile);\n    border-bottom: var(--kt-app-header-minimize-border-bottom-mobile);\n  }\n\n  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-fixed-mobile=true] .app-header {\n    box-shadow: none;\n  }\n  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-sticky=on] .app-header {\n    box-shadow: none;\n  }\n}\n.app-header-primary {\n  transition: none;\n  display: flex;\n  align-items: stretch;\n}\n\n@media (min-width: 992px) {\n  .app-header-primary {\n    background-color: var(--kt-app-header-primary-base-bg-color);\n    box-shadow: var(--kt-app-header-primary-base-box-shadow);\n    border-bottom: var(--kt-app-header-primary-base-border-bottom);\n  }\n\n  :root {\n    --kt-app-header-primary-height: 70px;\n  }\n\n  [data-kt-app-header-sticky=on] {\n    --kt-app-header-primary-height: 70px;\n  }\n\n  [data-kt-app-header-minimize=on] {\n    --kt-app-header-primary-height: 70px;\n  }\n\n  [data-kt-app-header-sticky=on][data-kt-app-header-primary-sticky-hide=true] {\n    --kt-app-header-primary-height: 0;\n  }\n\n  .app-header-primary {\n    height: var(--kt-app-header-primary-height);\n  }\n  [data-kt-app-header-primary-fixed=true] .app-header-primary {\n    z-index: 100;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n  }\n  [data-kt-app-header-primary-static=true] .app-header-primary {\n    position: relative;\n  }\n  [data-kt-app-header-primary-sticky=on] .app-header-primary {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 70px;\n    z-index: 100;\n    background-color: var(--kt-app-header-primary-sticky-bg-color);\n    box-shadow: var(--kt-app-header-primary-sticky-box-shadow);\n    border-bottom: var(--kt-app-header-primary-sticky-border-bottom);\n  }\n  [data-kt-app-header-primary-minimize=on] .app-header-primary {\n    transition: none;\n    height: 70px;\n    z-index: 100;\n    background-color: var(--kt-app-header-primary-minimize-bg-color);\n    box-shadow: var(--kt-app-header-primary-minimize-box-shadow);\n    border-bottom: var(--kt-app-header-primary-minimize-border-bottom);\n  }\n  [data-kt-app-header-sticky=on][data-kt-app-header-primary-sticky-hide=true] .app-header-primary {\n    display: none !important;\n  }\n\n  [data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header-primary {\n    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header-primary {\n    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  .app-header-primary {\n    flex-grow: 1;\n    background-color: var(--kt-app-header-primary-base-bg-color-mobile);\n    box-shadow: var(--kt-app-header-primary-base-box-shadow-mobile);\n    border-bottom: var(--kt-app-header-primary-base-border-bottom-mobile);\n  }\n}\n.app-header-secondary {\n  transition: none;\n  display: flex;\n  align-items: stretch;\n}\n\n@media (min-width: 992px) {\n  .app-header-secondary {\n    background-color: var(--kt-app-header-secondary-base-bg-color);\n    box-shadow: var(--kt-app-header-secondary-base-box-shadow);\n    border-bottom: var(--kt-app-header-secondary-base-border-bottom);\n  }\n\n  :root {\n    --kt-app-header-secondary-height: 70px;\n  }\n\n  [data-kt-app-header-sticky=on] {\n    --kt-app-header-secondary-height: 70px;\n  }\n\n  [data-kt-app-header-minimize=on] {\n    --kt-app-header-secondary-height: 70px;\n  }\n\n  [data-kt-app-header-sticky=on][data-kt-app-header-secondary-sticky-hide=true] {\n    --kt-app-header-secondary-height: 0;\n  }\n\n  .app-header-secondary {\n    height: var(--kt-app-header-secondary-height);\n  }\n  [data-kt-app-header-secondary-fixed=true] .app-header-secondary {\n    z-index: 100;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n  }\n  [data-kt-app-header-secondary-static=true] .app-header-secondary {\n    position: static;\n  }\n  [data-kt-app-header-secondary-sticky=on] .app-header-secondary {\n    transition: none;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 70px;\n    z-index: 100;\n    background-color: var(--kt-app-header-secondary-sticky-bg-color);\n    box-shadow: var(--kt-app-header-secondary-sticky-box-shadow);\n    border-bottom: var(--kt-app-header-secondary-sticky-border-bottom);\n  }\n  [data-kt-app-header-secondary-minimize=on] .app-header-secondary {\n    transition: none;\n    height: 70px;\n    z-index: 100;\n    background-color: var(--kt-app-header-secondary-minimize-bg-color);\n    box-shadow: var(--kt-app-header-secondary-minimize-box-shadow);\n    border-bottom: var(--kt-app-header-secondary-minimize-border-bottom);\n  }\n  [data-kt-app-header-sticky=on][data-kt-app-header-secondary-sticky-hide=true] .app-header-secondary {\n    display: none !important;\n  }\n\n  [data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-header=true] .app-header-secondary {\n    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-header=true] .app-header-secondary {\n    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  .app-header-secondary {\n    flex-grow: 1;\n    background-color: var(--kt-app-header-secondary-base-bg-color-mobile);\n    box-shadow: var(--kt-app-header-secondary-base-box-shadow-mobile);\n    border-left: var(--kt-app-header-secondary-base-border-start-mobile);\n    border-right: var(--kt-app-header-secondary-base-border-end-mobile);\n  }\n}\n.app-toolbar {\n  display: flex;\n  align-items: stretch;\n}\n.app-toolbar.app-toolbar-minimize {\n  transition: none;\n}\n\n@media (min-width: 992px) {\n  .app-toolbar {\n    background-color: var(--kt-app-toolbar-base-bg-color);\n    box-shadow: var(--kt-app-toolbar-base-box-shadow);\n    border-top: var(--kt-app-toolbar-base-border-top);\n    border-bottom: var(--kt-app-toolbar-base-border-bottom);\n  }\n\n  :root {\n    --kt-app-toolbar-height: 55px;\n    --kt-app-toolbar-height-actual: 55px;\n  }\n\n  [data-kt-app-toolbar-sticky=on] {\n    --kt-app-toolbar-height: 70px;\n  }\n\n  [data-kt-app-toolbar-minimize=on] {\n    --kt-app-toolbar-height: 70px;\n  }\n\n  .app-toolbar {\n    height: var(--kt-app-toolbar-height);\n  }\n  [data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true] .app-toolbar {\n    z-index: 99;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n  }\n  [data-kt-app-toolbar-sticky=on] .app-toolbar {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    z-index: 99;\n    box-shadow: var(--kt-app-toolbar-sticky-box-shadow);\n    background-color: var(--kt-app-toolbar-sticky-bg-color);\n    border-top: var(--kt-app-toolbar-sticky-border-top);\n    border-bottom: var(--kt-app-toolbar-sticky-border-bottom);\n  }\n  [data-kt-app-toolbar-minimize=on] .app-toolbar {\n    transition: none;\n    z-index: 99;\n    box-shadow: var(--kt-app-toolbar-minimize-box-shadow);\n    background-color: var(--kt-app-toolbar-minimize-bg-color);\n    border-top: var(--kt-app-toolbar-minimize-border-top);\n    border-bottom: var(--kt-app-toolbar-minimize-border-bottom);\n  }\n\n  [data-kt-app-toolbar-fixed=true][data-kt-app-header-fixed=true] .app-toolbar {\n    top: var(--kt-app-header-height);\n  }\n  [data-kt-app-toolbar-sticky=on][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-toolbar=true] .app-toolbar, [data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-toolbar=true] .app-toolbar {\n    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-toolbar-sticky=on][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-toolbar=true] .app-toolbar, [data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-toolbar=true] .app-toolbar {\n    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));\n  }\n  [data-kt-app-toolbar-sticky=on][data-kt-app-aside-fixed=true][data-kt-app-aside-push-toolbar=true] .app-toolbar, [data-kt-app-toolbar-fixed=true][data-kt-app-aside-fixed=true][data-kt-app-aside-push-toolbar=true] .app-toolbar {\n    right: calc(var(--kt-app-aside-width) + var(--kt-app-aside-gap-start, 0px) + var(--kt-app-aside-gap-end, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  .app-toolbar {\n    z-index: 99;\n    box-shadow: var(--kt-app-toolbar-base-box-shadow-mobile);\n    background-color: var(--kt-app-toolbar-base-bg-color-mobile);\n    border-top: var(--kt-app-toolbar-base-border-top-mobile);\n    border-bottom: var(--kt-app-toolbar-base-border-bottom-mobile);\n  }\n\n  :root {\n    --kt-app-toolbar-height: ;\n  }\n\n  [data-kt-app-toolbar-sticky=on] {\n    --kt-app-toolbar-height: 70px;\n  }\n\n  [data-kt-app-toolbar-minimize=on] {\n    --kt-app-toolbar-height: 70px;\n  }\n\n  .app-toolbar {\n    height: var(--kt-app-toolbar-height);\n  }\n  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-fixed-mobile=true] .app-toolbar {\n    z-index: 99;\n    position: fixed;\n    top: calc(var(--kt-app-header-height, 0px) + var(--kt-app-header-mobile-height, 0px));\n    left: 0;\n    right: 0;\n  }\n  [data-kt-app-toolbar-sticky=on] .app-toolbar {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: var(--kt-app-header-height, 0px);\n    box-shadow: var(--kt-app-toolbar-sticky-box-shadow-mobile);\n    background-color: var(--kt-app-toolbar-sticky-bg-color-mobile);\n    border-top: var(--kt-app-toolbar-sticky-border-top-mobile);\n    border-bottom: var(--kt-app-toolbar-sticky-border-bottom-mobile);\n    z-index: 99;\n  }\n  [data-kt-app-toolbar-minimize=on] .app-toolbar {\n    transition: none;\n    box-shadow: var(--kt-app-toolbar-minimize-box-shadow-mobile);\n    background-color: var(--kt-app-toolbar-minimize-bg-color-mobile);\n    border-top: var(--kt-app-toolbar-minimize-border-top-mobile);\n    border-bottom: var(--kt-app-toolbar-minimize-border-bottom-mobile);\n    z-index: 99;\n  }\n}\n.app-hero {\n  display: flex;\n  align-items: stretch;\n  background-color: var(--kt-app-hero-bg-color);\n  box-shadow: var(--kt-app-hero-box-shadow);\n  border-top: var(--kt-app-hero-border-top);\n  border-bottom: var(--kt-app-hero-border-bottom);\n}\n\n.app-sidebar {\n  transition: width 0.3s ease;\n}\n\n.app-sidebar-minimize-d-flex,\n.app-sidebar-sticky-d-flex,\n.app-sidebar-collapse-d-flex,\n.app-sidebar-minimize-mobile-d-flex,\n.app-sidebar-collapse-mobile-d-flex {\n  display: none;\n}\n\n@media (min-width: 992px) {\n  .app-sidebar {\n    display: flex;\n    flex-shrink: 0;\n    width: var(--kt-app-sidebar-width);\n    background-color: var(--kt-app-sidebar-base-bg-color);\n    box-shadow: var(--kt-app-sidebar-base-box-shadow);\n    border-left: var(--kt-app-sidebar-base-border-start);\n    border-right: var(--kt-app-sidebar-base-border-end);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  :root {\n    --kt-app-sidebar-width: 265px;\n    --kt-app-sidebar-width-actual: 265px;\n    --kt-app-sidebar-gap-start: 0px;\n    --kt-app-sidebar-gap-end: 0px;\n    --kt-app-sidebar-gap-top: 0px;\n    --kt-app-sidebar-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-stacked=true] {\n    --kt-app-sidebar-width: calc(var(--kt-app-sidebar-primary-width) + var(--kt-app-sidebar-secondary-width));\n  }\n\n  [data-kt-app-sidebar-minimize=on] {\n    --kt-app-sidebar-width: 75px;\n    --kt-app-sidebar-gap-start: 0px;\n    --kt-app-sidebar-gap-end: 0px;\n    --kt-app-sidebar-gap-top: 0px;\n    --kt-app-sidebar-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-sticky=on] {\n    --kt-app-sidebar-width: 300px;\n    --kt-app-sidebar-gap-start: 0px;\n    --kt-app-sidebar-gap-end: 0px;\n    --kt-app-sidebar-gap-top: 0px;\n    --kt-app-sidebar-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-collapse=on] {\n    --kt-app-sidebar-width: 0px;\n  }\n\n  [data-kt-app-sidebar-static=true] .app-sidebar {\n    position: relative;\n  }\n  [data-kt-app-sidebar-offcanvas=true] .app-sidebar {\n    display: none;\n  }\n  [data-kt-app-sidebar-fixed=true] .app-sidebar {\n    position: fixed;\n    z-index: 105;\n    top: 0;\n    bottom: 0;\n    left: 0;\n  }\n  [data-kt-app-sidebar-stacked=true] .app-sidebar {\n    align-items: stretch;\n  }\n  [data-kt-app-sidebar-sticky=on] .app-sidebar {\n    position: fixed;\n    transition: width 0.3s ease;\n    top: auto;\n    bottom: auto;\n    left: auto;\n    z-index: 105;\n    box-shadow: var(--kt-app-sidebar-sticky-box-shadow);\n    border-left: var(--kt-app-sidebar-sticky-border-start);\n    border-right: var(--kt-app-sidebar-sticky-border-end);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-minimize=on] .app-sidebar {\n    transition: width 0.3s ease;\n    background-color: var(--kt-app-sidebar-minimize-bg-color);\n    box-shadow: var(--kt-app-sidebar-minimize-box-shadow);\n    border-left: var(--kt-app-sidebar-minimize-border-start);\n    border-right: var(--kt-app-sidebar-minimize-border-end);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-hoverable=true] .app-sidebar .app-sidebar-wrapper {\n    width: var(--kt-app-sidebar-width-actual);\n  }\n  [data-kt-app-sidebar-hoverable=true][data-kt-app-sidebar-minimize=on] .app-sidebar:hover:not(.animating) {\n    transition: width 0.3s ease;\n    width: var(--kt-app-sidebar-width-actual);\n  }\n  [data-kt-app-sidebar-collapse=on] .app-sidebar {\n    transition: width 0.3s ease;\n    width: var(--kt-app-sidebar-width-actual);\n    margin-left: calc(-1 * var(--kt-app-sidebar-width-actual));\n  }\n\n  [data-kt-app-sidebar-minimize=on] .app-sidebar-minimize-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-minimize=on] .app-sidebar-minimize-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-sidebar-sticky=on] .app-sidebar-sticky-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-sticky=on] .app-sidebar-sticky-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-sidebar-collapse=on] .app-sidebar-collapse-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-collapse=on] .app-sidebar-collapse-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true]:not([data-kt-app-sidebar-push-header=true]) .app-sidebar {\n    top: var(--kt-app-header-height);\n  }\n  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true]:not([data-kt-app-sidebar-push-toolbar=true]) .app-sidebar {\n    top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  .app-sidebar {\n    display: none;\n    width: var(--kt-app-sidebar-width);\n    background-color: var(--kt-app-sidebar-base-bg-color-mobile);\n    box-shadow: var(--kt-app-sidebar-base-box-shadow-mobile);\n    border-left: var(--kt-app-sidebar-base-border-start-mobile);\n    border-right: var(--kt-app-sidebar-base-border-end-mobile);\n    z-index: 106;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  :root {\n    --kt-app-sidebar-width: 250px;\n    --kt-app-sidebar-width-actual: 250px;\n    --kt-app-sidebar-gap-start: 0px;\n    --kt-app-sidebar-gap-end: 0px;\n    --kt-app-sidebar-gap-top: 0px;\n    --kt-app-sidebar-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-minimize-mobile=on] {\n    --kt-app-sidebar-width: 75px;\n    --kt-app-sidebar-gap-start: 0px;\n    --kt-app-sidebar-gap-end: 0px;\n    --kt-app-sidebar-gap-top: 0px;\n    --kt-app-sidebar-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-collapse-mobile=on] {\n    --kt-app-sidebar-width: 0px;\n  }\n\n  [data-kt-app-sidebar-stacked=true] .app-sidebar {\n    align-items: stretch;\n  }\n  [data-kt-app-sidebar-minimize-mobile=on] .app-sidebar {\n    transition: width 0.3s ease;\n    background-color: var(--kt-app-sidebar-minimize-bg-color-mobilee);\n    box-shadow: var(--kt-app-sidebar-minimize-box-shadow-mobile);\n    border-left: var(--kt-app-sidebar-minimize-border-start-mobile);\n    border-right: var(--kt-app-sidebar-minimize-border-end-mobile);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-hoverable-mobile=true] .app-sidebar .app-sidebar-wrapper {\n    width: var(--kt-app-sidebar-width-actual);\n  }\n  [data-kt-app-sidebar-hoverable-mobile=true][data-kt-app-sidebar-minimize-mobile=on] .app-sidebar:hover:not(.animating) {\n    transition: width 0.3s ease;\n    width: var(--kt-app-sidebar-width-actual);\n    box-shadow: var(--kt-app-sidebar-minimize-hover-box-shadow-mobile);\n  }\n  [data-kt-app-sidebar-collapse-mobile=on] .app-sidebar {\n    transition: width 0.3s ease;\n    width: var(--kt-app-sidebar-width-actual);\n    margin-left: calc(-1 * var(--kt-app-sidebar-width-actual));\n  }\n\n  [data-kt-app-sidebar-minimize-mobile=on] .app-sidebar-minimize-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-minimize-mobile=on] .app-sidebar-minimize-mobile-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-sidebar-collapse-mobile=on] .app-sidebar-collapse-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-collapse-mobile=on] .app-sidebar-collapse-mobile-d-flex {\n    display: flex !important;\n  }\n}\n.app-sidebar-primary {\n  transition: none;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.app-sidebar-primary-collapse-d-flex,\n.app-sidebar-primary-minimize-d-flex,\n.app-sidebar-primary-collapse-mobile-d-flex,\n.app-sidebar-primary-minimize-mobile-d-flex {\n  display: none;\n}\n\n@media (min-width: 992px) {\n  .app-sidebar-primary {\n    background-color: var(--kt-app-sidebar-primary-base-bg-color);\n    box-shadow: var(--kt-app-sidebar-primary-base-box-shadow);\n    border-left: var(--kt-app-sidebar-primary-base-border-start);\n    border-right: var(--kt-app-sidebar-primary-base-border-end);\n    z-index: 1;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  :root {\n    --kt-app-sidebar-primary-width-actual: 100px;\n  }\n\n  [data-kt-app-sidebar-stacked=true] {\n    --kt-app-sidebar-primary-width: 100px;\n    --kt-app-sidebar-primary-gap-start: 0px;\n    --kt-app-sidebar-primary-gap-end: 0px;\n    --kt-app-sidebar-primary-gap-top: 0px;\n    --kt-app-sidebar-primary-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-primary-minimize=on] {\n    --kt-app-sidebar-primary-width: 75px;\n    --kt-app-sidebar-primary-gap-start: 0px;\n    --kt-app-sidebar-primary-gap-end: 0px;\n    --kt-app-sidebar-primary-gap-top: 0px;\n    --kt-app-sidebar-primary-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-primary-collapse=on] {\n    --kt-app-sidebar-primary-width: 0px;\n  }\n\n  .app-sidebar-primary {\n    width: var(--kt-app-sidebar-primary-width);\n  }\n  [data-kt-app-sidebar-primary-collapse=on] .app-sidebar-primary {\n    transition: none;\n    width: var(--kt-app-sidebar-primary-width-actual);\n    margin-left: calc(-1 * var(--kt-app-sidebar-primary-width-actual));\n  }\n  [data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary {\n    transition: none;\n    background-color: var(--kt-app-sidebar-primary-minimize-bg-color);\n    box-shadow: var(--kt-app-sidebar-primary-minimize-box-shadow);\n    border-left: var(--kt-app-sidebar-primary-minimize-border-start);\n    border-right: var(--kt-app-sidebar-primary-minimize-border-end);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-primary-hoverable=true] .app-sidebar-primary .app-sidebar-primary-hoverable {\n    width: var(--kt-app-sidebar-primary-width-actual);\n  }\n  [data-kt-app-sidebar-primary-hoverable=true][data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary:hover:not(.animating) {\n    transition: none;\n    width: var(--kt-app-sidebar-primary-width-actual);\n    box-shadow: var(--kt-app-sidebar-primary-minimize-hover-box-shadow);\n  }\n\n  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-sidebar-primary-below-header=true] .app-sidebar-primary {\n    top: var(--kt-app-header-height);\n  }\n  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-primary-below-toolbar=true] .app-sidebar-primary {\n    top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0));\n  }\n\n  [data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary-minimize-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-primary-minimize=on] .app-sidebar-primary-minimize-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-sidebar-primary-collapse=on] .app-sidebar-primary-collapse-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-primary-collapse=on] .app-sidebar-primary-collapse-d-flex {\n    display: flex !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-sidebar-primary {\n    z-index: 1;\n    background-color: var(--kt-app-sidebar-primary-base-bg-color-mobile);\n    box-shadow: var(--kt-app-sidebar-primary-base-box-shadow-mobile);\n    border-left: var(--kt-app-sidebar-primary-base-border-start-mobile);\n    border-right: var(--kt-app-sidebar-primary-base-border-end-mobile);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  :root {\n    --kt-app-sidebar-primary-width-actual: 100px;\n  }\n\n  [data-kt-app-sidebar-stacked=true] {\n    --kt-app-sidebar-primary-width: 100px;\n    --kt-app-sidebar-primary-gap-start: 0px;\n    --kt-app-sidebar-primary-gap-end: 0px;\n    --kt-app-sidebar-primary-gap-top: 0px;\n    --kt-app-sidebar-primary-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-primary-minimize-mobile=on] {\n    --kt-app-sidebar-primary-width: 75px;\n    --kt-app-sidebar-primary-gap-start: 0px;\n    --kt-app-sidebar-primary-gap-end: 0px;\n    --kt-app-sidebar-primary-gap-top: 0px;\n    --kt-app-sidebar-primary-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-primary-collapse-mobile=on] {\n    --kt-app-sidebar-primary-width: 0px;\n  }\n\n  .app-sidebar-primary {\n    width: var(--kt-app-sidebar-primary-width);\n  }\n  [data-kt-app-sidebar-primary-collapse-mobile=on] .app-sidebar-primary {\n    transition: none;\n    width: var(--kt-app-sidebar-primary-width-actual);\n    margin-left: calc(-1 * var(--kt-app-sidebar-primary-width-actual));\n  }\n  [data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary {\n    transition: none;\n    background-color: var(--kt-app-sidebar-primary-minimize-bg-color-mobile);\n    box-shadow: var(--kt-app-sidebar-primary-base-box-shadow-mobile);\n    border-left: var(--kt-app-sidebar-primary-minimize-border-start-mobile);\n    border-left: var(--kt-app-sidebar-primary-minimize-border-end-mobile);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-primary-hoverable-mobile=true] .app-sidebar-primary .app-sidebar-primary-hoverable {\n    width: var(--kt-app-sidebar-primary-width-actual);\n  }\n  [data-kt-app-sidebar-primary-hoverable-mobile=true][data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary:hover:not(.animating) {\n    transition: none;\n    width: var(--kt-app-sidebar-primary-width-actual);\n    box-shadow: var(--kt-app-sidebar-primary-minimize-hover-box-shadow-mobile);\n  }\n\n  [data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary-minimize-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-primary-minimize-mobile=on] .app-sidebar-primary-minimize-mobile-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-sidebar-primary-collapse-mobile=on] .app-sidebar-primary-collapse-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-primary-collapse-mobile=on] .app-sidebar-primary-collapse-mobile-d-flex {\n    display: flex !important;\n  }\n}\n.app-sidebar-secondary {\n  transition: none;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.app-sidebar-secondary-collapse-d-flex,\n.app-sidebar-secondary-minimize-d-flex,\n.app-sidebar-secondary-collapse-mobile-d-flex,\n.app-sidebar-secondary-minimize-mobile-d-flex {\n  display: none;\n}\n\n@media (min-width: 992px) {\n  .app-sidebar-secondary {\n    background-color: var(--kt-app-sidebar-secondary-base-bg-color);\n    box-shadow: var(--kt-app-sidebar-secondary-base-box-shadow);\n    border-left: var(--kt-app-sidebar-secondary-base-border-start);\n    border-right: var(--kt-app-sidebar-secondary-base-border-end);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  :root {\n    --kt-app-sidebar-secondary-width-actual: calc(\n        265px -\n        100px -\n        0px -\n        0px -\n        0px -\n        0px\n    );\n  }\n\n  [data-kt-app-sidebar-stacked=true] {\n    --kt-app-sidebar-secondary-width: calc(\n        265px -\n        100px -\n        0px -\n        0px -\n        0px -\n        0px\n    );\n    --kt-app-sidebar-secondary-gap-start: 0px;\n    --kt-app-sidebar-secondary-gap-end: 0px;\n    --kt-app-sidebar-secondary-gap-top: 0px;\n    --kt-app-sidebar-secondary-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-secondary-minimize=on] {\n    --kt-app-sidebar-secondary-width: 75px;\n    --kt-app-sidebar-secondary-gap-start: 0px;\n    --kt-app-sidebar-secondary-gap-end: 0px;\n    --kt-app-sidebar-secondary-gap-top: 0px;\n    --kt-app-sidebar-secondary-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-secondary-collapse=on] {\n    --kt-app-sidebar-secondary-width-actual: calc(\n        265px -\n        100px -\n        0px -\n        0px -\n        0px -\n        0px\n    );\n    --kt-app-sidebar-secondary-width: 0px;\n  }\n\n  .app-sidebar-secondary {\n    width: var(--kt-app-sidebar-secondary-width);\n  }\n  [data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary {\n    transition: none;\n    width: var(--kt-app-sidebar-secondary-width-actual);\n    margin-left: calc(-1 * var(--kt-app-sidebar-secondary-width-actual));\n  }\n  [data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary {\n    transition: none;\n    background-color: var(--kt-app-sidebar-secondary-minimize-bg-color);\n    box-shadow: var(--kt-app-sidebar-secondary-minimize-box-shadow);\n    border-left: var(--kt-app-sidebar-secondary-minimize-border-start);\n    border-right: var(--kt-app-sidebar-secondary-minimize-border-end);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-secondary-hoverable=true] .app-sidebar-secondary .app-sidebar-secondary-hoverable {\n    width: var(--kt-app-sidebar-secondary-width-actual);\n  }\n  [data-kt-app-sidebar-secondary-hoverable=true][data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary:hover:not(.animating) {\n    transition: none;\n    width: var(--kt-app-sidebar-secondary-width-actual);\n    box-shadow: var(--kt-app-sidebar-secondary-minimize-hover-box-shadow);\n  }\n\n  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-sidebar-secondary-below-header=true] .app-sidebar-secondary {\n    top: var(--kt-app-header-height);\n  }\n  [data-kt-app-sidebar-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true][data-kt-app-sidebar-secondary-below-toolbar=true] .app-sidebar-secondary {\n    top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0));\n  }\n\n  [data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary-minimize-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-secondary-minimize=on] .app-sidebar-secondary-minimize-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-d-flex {\n    display: flex !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-sidebar-secondary {\n    background-color: var(--kt-app-sidebar-secondary-base-bg-color-mobile);\n    box-shadow: var(--kt-app-sidebar-secondary-base-box-shadow-mobile);\n    border-left: var(--kt-app-sidebar-secondary-base-border-start-mobile);\n    border-right: var(--kt-app-sidebar-secondary-base-border-end-mobile);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  :root {\n    --kt-app-sidebar-secondary-width-actual: calc(\n        250px -\n        100px -\n        0px -\n        0px -\n        0px -\n        0px\n    );\n  }\n\n  [data-kt-app-sidebar-stacked=true] {\n    --kt-app-sidebar-secondary-width: calc(\n        250px -\n        100px -\n        0px -\n        0px -\n        0px -\n        0px\n    );\n    --kt-app-sidebar-secondary-gap-start: 0px;\n    --kt-app-sidebar-secondary-gap-end: 0px;\n    --kt-app-sidebar-secondary-gap-top: 0px;\n    --kt-app-sidebar-secondary-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-secondary-minimize-mobile=on] {\n    --kt-app-sidebar-secondary-width: 75px;\n    --kt-app-sidebar-secondary-gap-start: 0px;\n    --kt-app-sidebar-secondary-gap-end: 0px;\n    --kt-app-sidebar-secondary-gap-top: 0px;\n    --kt-app-sidebar-secondary-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-secondary-collapse-mobile=on] {\n    --kt-app-sidebar-secondary-width-actual: calc(\n        250px -\n        100px -\n        0px -\n        0px -\n        0px -\n        0px\n    );\n    --kt-app-sidebar-secondary-width: 0px;\n  }\n\n  .app-sidebar-secondary {\n    width: var(--kt-app-sidebar-secondary-width);\n  }\n  [data-kt-app-sidebar-secondary-collapse-mobile=on] .app-sidebar-secondary {\n    transition: none;\n    width: var(--kt-app-sidebar-secondary-width-actual);\n    margin-left: calc(-1 * var(--kt-app-sidebar-secondary-width-actual));\n  }\n  [data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary {\n    transition: none;\n    background-color: var(--kt-app-sidebar-secondary-minimize-bg-color-mobile);\n    box-shadow: var(--kt-app-sidebar-secondary-minimize-box-shadow-mobile);\n    border-left: var(--kt-app-sidebar-secondary-minimize-border-start-mobile);\n    border-right: var(--kt-app-sidebar-secondary-minimize-border-end-mobile);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-secondary-hoverable-mobile=true] .app-sidebar-secondary .app-sidebar-secondary-hoverable {\n    width: var(--kt-app-sidebar-secondary-width-actual);\n  }\n  [data-kt-app-sidebar-secondary-hoverable-mobile=true][data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary:hover:not(.animating) {\n    transition: none;\n    width: var(--kt-app-sidebar-secondary-width-actual);\n    box-shadow: var(--kt-app-sidebar-secondary-minimize-hover-box-shadow-mobile);\n  }\n\n  [data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary-minimize-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-secondary-minimize-mobile=on] .app-sidebar-secondary-minimize-mobile-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-secondary-collapse=on] .app-sidebar-secondary-collapse-mobile-d-flex {\n    display: flex !important;\n  }\n}\n.app-sidebar-panel {\n  transition: none;\n}\n\n.app-sidebar-panel-minimize-d-flex,\n.app-sidebar-panel-sticky-d-flex,\n.app-sidebar-panel-collapse-d-flex,\n.app-sidebar-panel-minimize-mobile-d-flex,\n.app-sidebar-panel-collapse-mobile-d-flex {\n  display: none;\n}\n\n@media (min-width: 992px) {\n  .app-sidebar-panel {\n    display: flex;\n    flex-shrink: 0;\n    width: var(--kt-app-sidebar-panel-width);\n    background-color: var(--kt-app-sidebar-panel-base-bg-color);\n    box-shadow: var(--kt-app-sidebar-panel-base-box-shadow);\n    border-left: var(--kt-app-sidebar-panel-base-border-start);\n    border-right: var(--kt-app-sidebar-panel-base-border-end);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  :root {\n    --kt-app-sidebar-panel-width: 300px;\n    --kt-app-sidebar-panel-width-actual: 300px;\n    --kt-app-sidebar-panel-gap-start: 0px;\n    --kt-app-sidebar-panel-gap-end: 0px;\n    --kt-app-sidebar-panel-gap-top: 0px;\n    --kt-app-sidebar-panel-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-panel-minimize=on] {\n    --kt-app-sidebar-panel-width: 75px;\n    --kt-app-sidebar-panel-gap-start: 0px;\n    --kt-app-sidebar-panel-gap-end: 0px;\n    --kt-app-sidebar-panel-gap-top: 0px;\n    --kt-app-sidebar-panel-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-panel-sticky=on] {\n    --kt-app-sidebar-panel-width: 300px;\n    --kt-app-sidebar-panel-gap-start: 0px;\n    --kt-app-sidebar-panel-gap-end: 0px;\n    --kt-app-sidebar-panel-gap-top: 0px;\n    --kt-app-sidebar-panel-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-panel-collapse=on] {\n    --kt-app-sidebar-panel-width-actual: 300px;\n    --kt-app-sidebar-panel-width: 0px;\n  }\n\n  [data-kt-app-sidebar-panel-static=true] .app-sidebar-panel {\n    position: relative;\n  }\n  [data-kt-app-sidebar-panel-offcanvas=true] .app-sidebar-panel {\n    display: none;\n  }\n  [data-kt-app-sidebar-panel-fixed=true] .app-sidebar-panel {\n    z-index: 104;\n    position: fixed;\n    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));\n    top: 0;\n    bottom: 0;\n  }\n  [data-kt-app-sidebar-panel-sticky=on] .app-sidebar-panel {\n    position: fixed;\n    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));\n    top: 0;\n    bottom: 0;\n    transition: none;\n    box-shadow: var(--kt-app-sidebar-panel-sticky-box-shadow);\n    border-left: var(--kt-app-sidebar-panel-sticky-border-start);\n    border-right: var(--kt-app-sidebar-panel-sticky-border-end);\n    z-index: 104;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel {\n    transition: none;\n    background-color: var(--kt-app-sidebar-panel-minimize-bg-color);\n    box-shadow: var(--kt-app-sidebar-panel-minimize-box-shadow);\n    border-left: var(--kt-app-sidebar-panel-minimize-border-start);\n    border-right: var(--kt-app-sidebar-panel-minimize-border-end);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-panel-hoverable=true] .app-sidebar-panel .app-sidebar-panel-hoverable {\n    width: var(--kt-app-sidebar-panel-width-actual);\n  }\n  [data-kt-app-sidebar-panel-hoverable=true][data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel:hover:not(.animating) {\n    transition: none;\n    width: var(--kt-app-sidebar-panel-width-actual);\n    box-shadow: var(--kt-app-sidebar-panel-minimize-hover-box-shadow);\n  }\n  [data-kt-app-sidebar-panel-collapse=on] .app-sidebar-panel {\n    transition: none;\n    width: var(--kt-app-sidebar-panel-width-actual);\n    margin-left: calc(-1 * (var(--kt-app-sidebar-panel-width-actual) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px)));\n  }\n\n  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-header-fixed=true]:not([data-kt-app-sidebar-panel-push-header=true]) .app-sidebar-panel {\n    top: var(--kt-app-header-height);\n  }\n  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true]:not([data-kt-app-sidebar-panel-push-toolbar=true]) .app-sidebar-panel {\n    top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0));\n  }\n\n  [data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel-minimize-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-panel-minimize=on] .app-sidebar-panel-minimize-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-sidebar-panel-sticky=on] .app-sidebar-panel-sticky-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-panel-sticky=on] .app-sidebar-panel-sticky-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-sidebar-panel-collapse=on] .app-sidebar-panel-collapse-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-panel-collapse=on] .app-sidebar-panel-collapse-d-flex {\n    display: flex !important;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-sidebar-panel {\n    display: none;\n    width: var(--kt-app-sidebar-panel-width);\n    background-color: var(--kt-app-sidebar-panel-base-bg-color-mobile);\n    box-shadow: var(--kt-app-sidebar-panel-base-box-shadow-mobile);\n    border-left: var(--kt-app-sidebar-panel-base-border-start-mobile);\n    border-right: var(--kt-app-sidebar-panel-base-border-end-mobile);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  :root {\n    --kt-app-sidebar-panel-gap-start: 0px;\n    --kt-app-sidebar-panel-gap-end: 0px;\n    --kt-app-sidebar-panel-gap-top: 0px;\n    --kt-app-sidebar-panel-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-panel-minimize-mobile=on] {\n    --kt-app-sidebar-panel-width: 75px;\n    --kt-app-sidebar-panel-gap-start: 0px;\n    --kt-app-sidebar-panel-gap-end: 0px;\n    --kt-app-sidebar-panel-gap-top: 0px;\n    --kt-app-sidebar-panel-gap-bottom: 0px;\n  }\n\n  [data-kt-app-sidebar-panel-collapse-mobile=on] {\n    --kt-app-sidebar-panel-width-actual: 300px;\n    --kt-app-sidebar-panel-width: 0px;\n  }\n\n  [data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel {\n    transition: none;\n    background-color: var(--kt-app-sidebar-panel-minimize-bg-color-mobile);\n    box-shadow: var(--kt-app-sidebar-panel-minimize-box-shadow-mobile);\n    border-left: var(--kt-app-sidebar-panel-minimize-border-start-mobile);\n    border-right: var(--kt-app-sidebar-panel-minimize-border-end-mobile);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-sidebar-panel-hoverable-mobile=true] .app-sidebar-panel .app-sidebar-panel-hoverable {\n    width: var(--kt-app-sidebar-panel-width-actual);\n  }\n  [data-kt-app-sidebar-panel-hoverable-mobile=true][data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel:hover:not(.animating) {\n    transition: none;\n    width: var(--kt-app-sidebar-panel-width-actual);\n    box-shadow: var(--kt-app-sidebar-panel-minimize-hover-box-shadow-mobile);\n  }\n  [data-kt-app-sidebar-panel-collapse-mobile=on] .app-sidebar-panel {\n    transition: none;\n    width: var(--kt-app-sidebar-panel-width-actual);\n    margin-left: calc(-1 * var(--kt-app-sidebar-panel-width-actual));\n  }\n\n  [data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel-minimize-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-panel-minimize-mobile=on] .app-sidebar-panel-minimize-mobile-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-sidebar-panel-collapse-mobile=on] .app-sidebar-panel-collapse-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-sidebar-panel-collapse-mobile=on] .app-sidebar-panel-collapse-mobile-d-flex {\n    display: flex !important;\n  }\n}\n.app-aside {\n  transition: none;\n}\n\n.app-aside-minimize-d-flex,\n.app-aside-sticky-d-flex,\n.app-aside-collapse-d-flex,\n.app-aside-minimize-mobile-d-flex,\n.app-aside-collapse-mobile-d-flex {\n  display: none;\n}\n\n@media (min-width: 992px) {\n  .app-aside {\n    display: flex;\n    flex-shrink: 0;\n    width: var(--kt-app-aside-width);\n    background-color: var(--kt-app-aside-base-bg-color);\n    box-shadow: var(--kt-app-aside-base-box-shadow);\n    border-left: var(--kt-app-aside-base-border-left);\n    border-right: var(--kt-app-aside-base-border-right);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  :root {\n    --kt-app-aside-width: 300px;\n    --kt-app-aside-width-actual: 300px;\n    --kt-app-aside-gap-start: 0px;\n    --kt-app-aside-gap-end: 0px;\n    --kt-app-aside-gap-top: 0px;\n    --kt-app-aside-gap-bottom: 0px;\n  }\n\n  [data-kt-app-aside-stacked=true] {\n    --kt-app-aside-width: calc(var(--kt-app-aside-primary-width) + var(--kt-app-aside-secondary-width));\n  }\n\n  [data-kt-app-aside-minimize=on] {\n    --kt-app-aside-width: 75px;\n    --kt-app-aside-gap-start: 0px;\n    --kt-app-aside-gap-end: 0px;\n    --kt-app-aside-gap-top: 0px;\n    --kt-app-aside-gap-bottom: 0px;\n  }\n\n  [data-kt-app-aside-sticky=on] {\n    --kt-app-aside-width: 300px;\n    --kt-app-aside-gap-start: 0px;\n    --kt-app-aside-gap-end: 0px;\n    --kt-app-aside-gap-top: 0px;\n    --kt-app-aside-gap-bottom: 0px;\n  }\n\n  [data-kt-app-aside-collapse=on] {\n    --kt-app-aside-width: 0px;\n  }\n\n  [data-kt-app-aside-static=true] .app-aside {\n    position: relative;\n  }\n  [data-kt-app-aside-offcanvas=true] .app-aside {\n    display: none;\n  }\n  [data-kt-app-aside-fixed=true] .app-aside {\n    position: fixed;\n    z-index: 105;\n    top: 0;\n    bottom: 0;\n    right: 0;\n  }\n  [data-kt-app-aside-stacked=true] .app-aside {\n    align-items: stretch;\n  }\n  [data-kt-app-aside-sticky=on] .app-aside {\n    position: fixed;\n    transition: none;\n    box-shadow: var(--kt-app-aside-sticky-box-shadow);\n    border-left: var(--kt-aside-sticky-border-start);\n    border-right: var(--kt-app-aside-sticky-border-end);\n    top: auto;\n    bottom: auto;\n    left: auto;\n    z-index: 105;\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-aside-minimize=on] .app-aside {\n    transition: none;\n    background-color: var(--kt-app-aside-minimize-bg-color);\n    box-shadow: var(--kt-app-aside-minimize-box-shadow);\n    border-start: var(--kt-app-aside-minimize-border-start);\n    border-end: var(--kt-app-aside-minimize-border-end);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-aside-hoverable=true] .app-aside .app-aside-wrapper {\n    width: var(--kt-app-aside-width-actual);\n  }\n  [data-kt-app-aside-hoverable=true][data-kt-app-aside-minimize=on] .app-aside:hover:not(.animating) {\n    transition: none;\n    width: var(--kt-app-aside-width-actual);\n    box-shadow: var(--kt-app-aside-minimize-hover-box-shadow);\n  }\n  [data-kt-app-aside-collapse=on] .app-aside {\n    transition: none;\n    width: var(--kt-app-aside-width-actual);\n    margin-right: calc(-1 * var(--kt-app-aside-width-actual));\n  }\n\n  [data-kt-app-aside-minimize=on] .app-aside-minimize-d-none {\n    display: none !important;\n  }\n  [data-kt-app-aside-minimize=on] .app-aside-minimize-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-aside-sticky=on] .app-aside-sticky-d-none {\n    display: none !important;\n  }\n  [data-kt-app-aside-sticky=on] .app-aside-sticky-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-aside-collapse=on] .app-aside-collapse-d-none {\n    display: none !important;\n  }\n  [data-kt-app-aside-collapse=on] .app-aside-collapse-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-aside-fixed=true][data-kt-app-header-fixed=true]:not([data-kt-app-aside-push-header=true]) .app-aside {\n    top: var(--kt-app-header-height);\n  }\n  [data-kt-app-aside-fixed=true][data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true]:not([data-kt-app-aside-push-toolbar=true]) .app-aside {\n    top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  .app-aside {\n    display: none;\n    width: var(--kt-app-aside-width);\n    z-index: 106;\n    background-color: var(--kt-app-aside-base-bg-color-mobile);\n    box-shadow: var(--kt-app-aside-base-box-shadow-mobile);\n    border-left: var(--kt-app-aside-base-border-start-mobile);\n    order-right: var(--kt-app-aside-base-border-end-mobile);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n\n  :root {\n    --kt-app-aside-width: 275px;\n    --kt-app-aside-width-actual: 275px;\n    --kt-app-aside-gap-start: 0px;\n    --kt-app-aside-gap-end: 0px;\n    --kt-app-aside-gap-top: 0px;\n    --kt-app-aside-gap-bottom: 0px;\n  }\n\n  [data-kt-app-aside-minimize-mobile=on] {\n    --kt-app-aside-width: 75px;\n    --kt-app-aside-gap-start: 0px;\n    --kt-app-aside-gap-end: 0px;\n    --kt-app-aside-gap-top: 0px;\n    --kt-app-aside-gap-bottom: 0px;\n  }\n\n  [data-kt-app-aside-collapse-mobile=on] {\n    --kt-app-aside-width: 0px;\n  }\n\n  [data-kt-app-aside-stacked=true] .app-aside {\n    align-items: stretch;\n  }\n  [data-kt-app-aside-minimize-mobile=on] .app-aside {\n    transition: none;\n    background-color: var(--kt-app-aside-minimize-bg-color-mobile);\n    box-shadow: var(--kt-app-aside-minimize-box-shadow-mobile);\n    border-left: var(--kt-app-aside-minimize-border-start-mobile);\n    border-right: var(--kt-app-aside-minimize-border-end-mobile);\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: 0px;\n    margin-bottom: 0px;\n  }\n  [data-kt-app-aside-hoverable-mobile=true] .app-aside .app-aside-wrapper {\n    width: var(--kt-app-aside-width-actual);\n  }\n  [data-kt-app-aside-hoverable-mobile=true][data-kt-app-aside-minimize-mobile=on] .app-aside:hover:not(.animating) {\n    transition: none;\n    width: var(--kt-app-aside-width-actual);\n    box-shadow: var(--kt-app-aside-minimize-hover-box-shadow-mobile);\n  }\n  [data-kt-app-aside-collapse-mobile=on] .app-aside {\n    transition: none;\n    width: var(--kt-app-aside-width-actual);\n    margin-right: calc(-1 * var(--kt-app-aside-width-actual));\n  }\n\n  [data-kt-app-aside-minimize-mobile=on] .app-aside-minimize-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-aside-minimize-mobile=on] .app-aside-minimize-mobile-d-flex {\n    display: flex !important;\n  }\n\n  [data-kt-app-aside-collapse-mobile=on] .app-aside-collapse-mobile-d-none {\n    display: none !important;\n  }\n  [data-kt-app-aside-collapse-mobile=on] .app-aside-collapse-mobile-d-flex {\n    display: flex !important;\n  }\n}\n.app-wrapper {\n  display: flex;\n}\n\n@media (min-width: 992px) {\n  .app-wrapper {\n    transition: margin-left 0.3s ease, margin-right 0.3s ease;\n  }\n  [data-kt-app-header-sticky=on] .app-wrapper {\n    margin-top: var(--kt-app-header-height-actual);\n  }\n  [data-kt-app-header-fixed=true] .app-wrapper {\n    margin-top: var(--kt-app-header-height);\n  }\n  [data-kt-app-toolbar-sticky=on] .app-wrapper {\n    margin-top: var(--kt-app-toolbar-height);\n  }\n  [data-kt-app-header-fixed=true][data-kt-app-toolbar-sticky=on] .app-wrapper {\n    margin-top: calc(var(--kt-app-header-height-actual) + var(--kt-app-toolbar-height-actual));\n  }\n  [data-kt-app-header-fixed=true][data-kt-app-toolbar-fixed=true] .app-wrapper {\n    margin-top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height));\n  }\n  [data-kt-app-sidebar-fixed=true] .app-wrapper {\n    margin-left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-sidebar-panel-fixed=true] .app-wrapper {\n    margin-left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));\n  }\n  [data-kt-app-aside-fixed=true] .app-wrapper {\n    margin-right: calc(var(--kt-app-aside-width) + var(--kt-app-aside-gap-start, 0px) + var(--kt-app-aside-gap-end, 0px));\n  }\n  [data-kt-app-footer-fixed=true] .app-wrapper {\n    margin-bottom: var(--kt-app-footer-height);\n  }\n}\n@media (max-width: 991.98px) {\n  .app-wrapper {\n    transition: margin-left 0.3s ease, margin-right 0.3s ease;\n  }\n  [data-kt-app-header-sticky=on] .app-wrapper {\n    margin-top: var(--kt-app-header-height-actual);\n  }\n  [data-kt-app-header-fixed-mobile=true] .app-wrapper {\n    margin-top: var(--kt-app-header-height);\n  }\n  [data-kt-app-header-fixed-mobile=true][data-kt-app-toolbar-sticky=on] .app-wrapper {\n    margin-top: calc(var(--kt-app-header-height-actual) + var(--kt-app-toolbar-height-actual));\n  }\n  [data-kt-app-footer-fixed-mobile=true] .app-wrapper {\n    margin-bottom: var(--kt-app-footer-height);\n  }\n}\n.app-main {\n  display: flex;\n}\n\n@media (min-width: 992px) {\n  .app-main {\n    transition: margin 0.3s ease;\n  }\n\n  [data-kt-app-sidebar-sticky=true] .app-main {\n    margin-left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-sidebar-panel-sticky=true] .app-main {\n    margin-left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));\n  }\n  [data-kt-app-aside-sticky=true] .app-main {\n    margin-right: calc(var(--kt-app-aside-width) + var(--kt-app-aside-gap-start, 0px) + var(--kt-app-aside-gap-end, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  .app-main {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n@media (min-width: 992px) {\n  .app-content {\n    padding-top: 30px;\n    padding-bottom: 30px;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-content {\n    max-width: none;\n    padding-top: 20px;\n    padding-bottom: 20px;\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n.app-footer {\n  transition: left 0.3s ease, right 0.3s ease;\n  display: flex;\n  align-items: stretch;\n}\n\n@media (min-width: 992px) {\n  .app-footer {\n    background-color: var(--kt-app-footer-bg-color);\n    box-shadow: var(--kt-app-footer-box-shadow);\n    border-top: var(--kt-app-footer-border-top);\n  }\n\n  :root {\n    --kt-app-footer-height: 60px;\n  }\n\n  .app-footer {\n    height: var(--kt-app-footer-height);\n  }\n  [data-kt-app-footer-fixed=true] .app-footer {\n    z-index: 100;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n\n  [data-kt-app-sidebar-fixed=true][data-kt-app-sidebar-push-footer=true] .app-footer {\n    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));\n  }\n  [data-kt-app-sidebar-panel-fixed=true][data-kt-app-sidebar-panel-push-footer=true] .app-footer {\n    left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px) + var(--kt-app-sidebar-panel-width) + var(--kt-app-sidebar-panel-gap-start, 0px) + var(--kt-app-sidebar-panel-gap-end, 0px));\n  }\n  [data-kt-app-aside-fixed=true][data-kt-app-aside-push-footer=true] .app-footer {\n    right: calc(var(--kt-app-aside-width) + var(--kt-app-aside-gap-start, 0px) + var(--kt-app-aside-gap-end, 0px));\n  }\n}\n@media (max-width: 991.98px) {\n  .app-footer {\n    background-color: var(--kt-app-footer-bg-color-mobile);\n    box-shadow: var(--kt-app-footer-box-shadow-mobile);\n    border-top: var(--kt-app-footer-border-top-mobile);\n  }\n\n  body {\n    --kt-app-footer-height: auto;\n  }\n\n  .app-footer {\n    height: var(--kt-app-footer-height);\n  }\n  [data-kt-app-footer-fixed-mobile=true] .app-footer {\n    z-index: 100;\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n  }\n}\n.app-layout-builder-toggle {\n  position: fixed;\n  z-index: 105;\n  bottom: 40px;\n  right: 50px;\n}\n\n@media (max-width: 991.98px) {\n  .app-layout-builder-toggle {\n    bottom: 20px;\n    right: 40px;\n  }\n}\nhtml:not([data-theme=dark]) {\n  --kt-app-bg-color: #f5f8fa;\n  --kt-app-blank-bg-color: #ffffff;\n  --kt-app-header-base-bg-color: #ffffff;\n  --kt-app-header-base-bg-color-mobile: #ffffff;\n  --kt-app-header-base-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  --kt-app-header-base-box-shadow-mobile: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  --kt-app-header-base-menu-link-bg-color-active: #F4F6FA;\n  --kt-app-header-light-separator-color: #E4E6EF;\n  --kt-app-sidebar-base-toggle-btn-box-shadow: 0px 0px 10px rgba(113, 121, 136, 0.1);\n  --kt-app-sidebar-base-toggle-btn-bg-color: #ffffff;\n  --kt-app-sidebar-light-bg-color: #ffffff;\n  --kt-app-sidebar-light-box-shadow: 0 0 28px 0 rgba(82, 63, 105, 0.05);\n  --kt-app-sidebar-light-separator-color: #E4E6EF;\n  --kt-app-sidebar-light-scrollbar-color: #eff2f5;\n  --kt-app-sidebar-light-scrollbar-color-hover: #eff2f5;\n  --kt-app-sidebar-light-menu-heading-color: #B5B5C3;\n  --kt-app-sidebar-light-menu-link-bg-color-active: #F4F6FA;\n  --kt-app-sidebar-light-header-menu-link-bg-color-active: #EAEEF2;\n  --kt-app-toolbar-base-bg-color: #ffffff;\n  --kt-app-toolbar-base-bg-color-mobile: #ffffff;\n  --kt-app-toolbar-base-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  --kt-app-toolbar-base-box-shadow-mobile: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  --kt-app-toolbar-base-border-top: 1px solid #eff2f5;\n  --kt-app-toolbar-base-border-top-mobile: 1px solid #eff2f5;\n  --kt-app-footer-bg-color: #ffffff;\n  --kt-app-footer-bg-color-mobile: #ffffff;\n}\n\n[data-theme=dark] {\n  --kt-app-bg-color: #151521;\n  --kt-app-blank-bg-color: #151521;\n  --kt-app-header-base-bg-color: #1e1e2d;\n  --kt-app-header-base-bg-color-mobile: #1e1e2d;\n  --kt-app-header-base-box-shadow: none;\n  --kt-app-header-base-box-shadow-mobile: none;\n  --kt-app-header-base-menu-link-bg-color-active: #2A2A3C;\n  --kt-app-header-light-separator-color: #2B2B40;\n  --kt-app-sidebar-base-toggle-btn-box-shadow: none;\n  --kt-app-sidebar-base-toggle-btn-bg-color: #2A2A3C;\n  --kt-app-sidebar-light-bg-color: #1e1e2d;\n  --kt-app-sidebar-light-box-shadow: none;\n  --kt-app-sidebar-light-separator-color: #2B2B40;\n  --kt-app-sidebar-light-scrollbar-color: #2B2B40;\n  --kt-app-sidebar-light-scrollbar-color-hover: #2B2B40;\n  --kt-app-sidebar-light-menu-heading-color: #565674;\n  --kt-app-sidebar-light-menu-link-bg-color-active: #2A2A3C;\n  --kt-app-sidebar-light-header-menu-link-bg-color-active: #1b1b29;\n  --kt-app-toolbar-base-bg-color: #1a1a27;\n  --kt-app-toolbar-base-bg-color-mobile: #1a1a27;\n  --kt-app-toolbar-base-box-shadow: none;\n  --kt-app-toolbar-base-box-shadow-mobile: 0px 10px 30px 0px rgba(82, 63, 105, 0.05);\n  --kt-app-toolbar-base-border-top: 0;\n  --kt-app-toolbar-base-border-top-mobile: 1px solid #eff2f5;\n  --kt-app-footer-bg-color: #1e1e2d;\n  --kt-app-footer-bg-color-mobile: #1e1e2d;\n}\n\n@media (min-width: 992px) {\n  .app-sidebar-toggle {\n    box-shadow: var(--kt-app-sidebar-base-toggle-btn-box-shadow) !important;\n    background-color: var(--kt-app-sidebar-base-toggle-btn-bg-color) !important;\n  }\n  .app-sidebar-toggle .active .svg-icon {\n    transform: rotateZ(0deg) !important;\n  }\n\n  [dir=rtl] .app-sidebar-toggle .svg-icon {\n    transform: rotateZ(180deg);\n  }\n  [dir=rtl] .app-sidebar-toggle.active .svg-icon {\n    transform: rotateZ(0deg) !important;\n  }\n\n  .app-sidebar-logo {\n    height: var(--kt-app-header-height);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: relative;\n    flex-shrink: 0;\n  }\n\n  .app-sidebar-menu .menu > .menu-item {\n    margin-left: 0.115rem;\n  }\n}\n@media (max-width: 991.98px) {\n  .app-sidebar-logo {\n    display: none;\n  }\n}\n.app-sidebar-logo-minimize {\n  display: none;\n}\n\n.app-sidebar-footer .btn-custom .btn-icon {\n  display: none;\n}\n\n@media (min-width: 992px) {\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-logo .app-sidebar-logo-default {\n    display: none;\n  }\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-logo .app-sidebar-logo-minimize {\n    display: inline-block;\n  }\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-wrapper {\n    width: var(--kt-app-sidebar-width-actual);\n  }\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-menu .menu-content,\n[data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-menu .menu-title {\n    opacity: 0;\n    transition: opacity 0.3s ease !important;\n  }\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-menu .menu-item.show > .menu-sub {\n    height: 0;\n    overflow: hidden;\n    transition: height 0.3s ease !important;\n  }\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-footer .btn-custom {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-footer .btn-custom .btn-label {\n    width: 0;\n    display: none;\n  }\n  [data-kt-app-sidebar-minimize=on]:not([data-kt-app-sidebar-hoverable=true]) .app-sidebar .app-sidebar-footer .btn-custom .btn-icon {\n    width: auto;\n    display: block;\n  }\n\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-logo .app-sidebar-logo-default {\n    display: none;\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-logo .app-sidebar-logo-minimize {\n    display: inline-block;\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-wrapper {\n    width: var(--kt-app-sidebar-width-actual);\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-menu .menu-content,\n[data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-menu .menu-title {\n    opacity: 0;\n    transition: opacity 0.3s ease !important;\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-menu .menu-item.show > .menu-sub {\n    height: 0;\n    overflow: hidden;\n    transition: height 0.3s ease !important;\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-footer .btn-custom {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-footer .btn-custom .btn-label {\n    width: 0;\n    display: none;\n  }\n  [data-kt-app-sidebar-minimize=on][data-kt-app-sidebar-hoverable=true] .app-sidebar:not(:hover) .app-sidebar-footer .btn-custom .btn-icon {\n    width: auto;\n    display: block;\n  }\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar {\n  background-color: #1e1e2d;\n  border-right: 0 !important;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y {\n  scrollbar-color: #323248 transparent;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-thumb {\n  background-color: #323248;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y:hover {\n  scrollbar-color: #323248 transparent;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-thumb {\n  background-color: #323248;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .app-sidebar-logo {\n  border-bottom: 1px dashed #393945;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom {\n  color: #B5B5C3;\n  background-color: rgba(63, 66, 84, 0.35);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom i,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom .svg-icon {\n  color: #B5B5C3;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom.dropdown-toggle:after {\n  color: #B5B5C3;\n}\n.btn-check:checked + [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom, .btn-check:active + [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom, [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom:focus:not(.btn-active), [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom:hover:not(.btn-active), [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom:active:not(.btn-active), [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom.active, [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom.show, .show > [data-kt-app-layout=dark-sidebar] .app-sidebar .btn-custom {\n  color: #B5B5C3;\n  background-color: rgba(63, 66, 84, 0.35) !important;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-heading {\n  color: #646477 !important;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link {\n  color: #9D9DA6;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-title {\n  color: #9D9DA6;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon i {\n  color: #C5C5D8;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-bullet .bullet {\n  background-color: #787887;\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: #787887;\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: #787887;\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, [data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: #2A2A3C;\n  color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-title {\n  color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon .svg-icon,\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-primary-inverse);\n}\n[data-kt-app-layout=dark-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary-inverse);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n[data-kt-app-layout=light-sidebar] .app-sidebar {\n  background-color: var(--kt-app-sidebar-light-bg-color);\n  border-right: 0 !important;\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y {\n  scrollbar-color: var(--kt-app-sidebar-light-scrollbar-color) transparent;\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-thumb {\n  background-color: var(--kt-app-sidebar-light-scrollbar-color);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y:hover {\n  scrollbar-color: var(--kt-app-sidebar-light-scrollbar-color-hover) transparent;\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-thumb {\n  background-color: var(--kt-app-sidebar-light-scrollbar-color-hover);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .hover-scroll-overlay-y:hover::-webkit-scrollbar-corner {\n  background-color: transparent;\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .app-sidebar-logo {\n  border-bottom: 1px solid var(--kt-app-sidebar-light-separator-color);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu {\n  font-weight: 500;\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-heading {\n  color: var(--kt-app-sidebar-light-menu-heading-color) !important;\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link {\n  color: var(--kt-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-title {\n  color: var(--kt-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-icon i {\n  color: var(--kt-gray-500);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-gray-500);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  color: var(--kt-gray-900);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-gray-900);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, [data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-gray-900);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-gray-900);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-gray-900);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-gray-900);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-gray-700);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-700);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-700%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--kt-app-sidebar-light-menu-link-bg-color-active);\n  color: var(--kt-primary);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-title {\n  color: var(--kt-primary);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-primary);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n[data-kt-app-layout=light-sidebar] .app-sidebar .menu .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n\n[data-kt-app-layout=light-sidebar][data-kt-app-header-fixed=true] .app-sidebar .app-sidebar-logo {\n  border-bottom: 1px dashed var(--kt-app-sidebar-light-separator-color);\n}\n\n.app-header-menu .menu .menu-item .menu-link {\n  color: var(--kt-gray-700);\n}\n.app-header-menu .menu .menu-item .menu-link .menu-title {\n  color: var(--kt-gray-700);\n}\n.app-header-menu .menu .menu-item .menu-link .menu-icon,\n.app-header-menu .menu .menu-item .menu-link .menu-icon .svg-icon,\n.app-header-menu .menu .menu-item .menu-link .menu-icon i {\n  color: var(--kt-gray-500);\n}\n.app-header-menu .menu .menu-item .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-gray-500);\n}\n.app-header-menu .menu .menu-item .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-500%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-gray-500);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-gray-500%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) {\n  transition: color 0.2s ease;\n  background-color: var(--kt-menu-link-bg-color-active);\n  color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n  color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n.app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n.app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n  color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, .app-header-menu .menu .menu-item:not(.here) .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.app-header-menu .menu .menu-item.show > .menu-link {\n  transition: color 0.2s ease;\n  color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item.show > .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item.show > .menu-link .menu-icon,\n.app-header-menu .menu .menu-item.show > .menu-link .menu-icon .svg-icon,\n.app-header-menu .menu .menu-item.show > .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item.show > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item.show > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.app-header-menu .menu .menu-item.here > .menu-link {\n  transition: color 0.2s ease;\n  background-color: var(--kt-menu-link-bg-color-active);\n  color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item.here > .menu-link .menu-title {\n  color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item.here > .menu-link .menu-icon,\n.app-header-menu .menu .menu-item.here > .menu-link .menu-icon .svg-icon,\n.app-header-menu .menu .menu-item.here > .menu-link .menu-icon i {\n  color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item.here > .menu-link .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item.here > .menu-link .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.app-header-menu .menu .menu-item .menu-link.active {\n  transition: color 0.2s ease;\n  background-color: var(--kt-menu-link-bg-color-active);\n  color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item .menu-link.active .menu-title {\n  color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item .menu-link.active .menu-icon,\n.app-header-menu .menu .menu-item .menu-link.active .menu-icon .svg-icon,\n.app-header-menu .menu .menu-item .menu-link.active .menu-icon i {\n  color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item .menu-link.active .menu-bullet .bullet {\n  background-color: var(--kt-primary);\n}\n.app-header-menu .menu .menu-item .menu-link.active .menu-arrow:after {\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n  /*rtl:begin:remove*/\n  mask-repeat: no-repeat;\n  mask-position: center;\n  -webkit-mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  background-color: var(--kt-primary);\n  -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n  /*rtl:end:remove*/\n}\n.app-header-menu .menu-extended {\n  --kt-menu-link-bg-color-active: rgba(var(--kt-gray-100-rgb), 0.7);\n  --kt-menu-link-bg-color-hover: rgba(var(--kt-gray-100-rgb), 0.7);\n}\n.app-header-menu .menu-extended .menu-custom-icon {\n  background-color: var(--kt-gray-100);\n}\n.app-header-menu .menu-extended .menu-link.active .menu-custom-icon, .app-header-menu .menu-extended .menu-link:hover .menu-custom-icon {\n  background-color: var(--kt-gray-200);\n}\n\n@media (min-width: 992px) {\n  .app-header-menu .menu > .menu-item {\n    margin-right: 0.5rem;\n  }\n  .app-header-menu .menu > .menu-item > .menu-link {\n    padding-top: 0.775rem;\n    padding-bottom: 0.775rem;\n    font-weight: 500;\n  }\n  .app-header-menu .menu > .menu-item.here > .menu-link {\n    transition: color 0.2s ease;\n    background-color: var(--kt-app-header-base-menu-link-bg-color-active);\n    color: var(--kt-primary);\n  }\n  .app-header-menu .menu > .menu-item.here > .menu-link .menu-title {\n    color: var(--kt-primary);\n  }\n  .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon,\n.app-header-menu .menu > .menu-item.here > .menu-link .menu-icon .svg-icon,\n.app-header-menu .menu > .menu-item.here > .menu-link .menu-icon i {\n    color: var(--kt-primary);\n  }\n  .app-header-menu .menu > .menu-item.here > .menu-link .menu-bullet .bullet {\n    background-color: var(--kt-primary);\n  }\n  .app-header-menu .menu > .menu-item.here > .menu-link .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-primary);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-primary);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n}\n@media (max-width: 991.98px) {\n  .app-header .page-title {\n    display: none !important;\n  }\n}\n[data-kt-app-layout=dark-header] .app-header {\n  background-color: #1e1e2d;\n  border-bottom: 0 !important;\n}\n[data-kt-app-layout=dark-header] .app-header .btn-custom {\n  color: #B5B5C3;\n}\n[data-kt-app-layout=dark-header] .app-header .btn-custom i,\n[data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon {\n  color: #B5B5C3;\n}\n[data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after {\n  color: #B5B5C3;\n}\n.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom, .btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom, [data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active), [data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active), [data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active), [data-kt-app-layout=dark-header] .app-header .btn-custom.active, [data-kt-app-layout=dark-header] .app-header .btn-custom.show, .show > [data-kt-app-layout=dark-header] .app-header .btn-custom {\n  color: #B5B5C3;\n  background-color: rgba(63, 66, 84, 0.35) !important;\n}\n.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom i,\n.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon, .btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom i,\n.btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active) i,\n[data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active) .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active) i,\n[data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active) .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active) i,\n[data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active) .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom.active i,\n[data-kt-app-layout=dark-header] .app-header .btn-custom.active .svg-icon, [data-kt-app-layout=dark-header] .app-header .btn-custom.show i,\n[data-kt-app-layout=dark-header] .app-header .btn-custom.show .svg-icon, .show > [data-kt-app-layout=dark-header] .app-header .btn-custom i,\n.show > [data-kt-app-layout=dark-header] .app-header .btn-custom .svg-icon {\n  color: var(--kt-primary);\n}\n.btn-check:checked + [data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after, .btn-check:active + [data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom:focus:not(.btn-active).dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom:hover:not(.btn-active).dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom:active:not(.btn-active).dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom.active.dropdown-toggle:after, [data-kt-app-layout=dark-header] .app-header .btn-custom.show.dropdown-toggle:after, .show > [data-kt-app-layout=dark-header] .app-header .btn-custom.dropdown-toggle:after {\n  color: var(--kt-primary);\n}\n@media (min-width: 992px) {\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link {\n    color: #9D9DA6;\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-title {\n    color: #9D9DA6;\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-icon i {\n    color: #C5C5D8;\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-bullet .bullet {\n    background-color: #787887;\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: #787887;\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: #787887;\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='%23787887'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here), [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) {\n    transition: color 0.2s ease;\n    background-color: #2A2A3C;\n    color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-title, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-title {\n    color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-icon i, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon .svg-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-icon i {\n    color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-bullet .bullet, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-bullet .bullet {\n    background-color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here) .menu-arrow:after, [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item:not(.here) > .menu-link:hover:not(.disabled):not(.active):not(.here) .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link {\n    transition: color 0.2s ease;\n    color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-title {\n    color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-icon i {\n    color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-bullet .bullet {\n    background-color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.show > .menu-link .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link {\n    transition: color 0.2s ease;\n    background-color: #2A2A3C;\n    color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-title {\n    color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon i {\n    color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-bullet .bullet {\n    background-color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item.here > .menu-link .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active {\n    transition: color 0.2s ease;\n    background-color: #2A2A3C;\n    color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-title {\n    color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon .svg-icon,\n[data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon i {\n    color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-bullet .bullet {\n    background-color: var(--kt-primary-inverse);\n  }\n  [data-kt-app-layout=dark-header] .app-header-menu .menu > .menu-item > .menu-link.active .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-primary-inverse);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary-inverse%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n}\n\n@media (min-width: 992px) {\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link {\n    transition: color 0.2s ease;\n    background-color: var(--kt-app-sidebar-light-header-menu-link-bg-color-active);\n    color: var(--kt-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-title {\n    color: var(--kt-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-icon i {\n    color: var(--kt-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-bullet .bullet {\n    background-color: var(--kt-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item.here > .menu-link .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-primary);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-primary);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active {\n    transition: color 0.2s ease;\n    background-color: var(--kt-app-sidebar-light-header-menu-link-bg-color-active);\n    color: var(--kt-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-title {\n    color: var(--kt-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon,\n[data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon .svg-icon,\n[data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-icon i {\n    color: var(--kt-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-bullet .bullet {\n    background-color: var(--kt-primary);\n  }\n  [data-kt-app-layout=light-sidebar] .app-header-menu .menu > .menu-item > .menu-link.active .menu-arrow:after {\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-primary);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/%3e%3c/svg%3e\");\n    /*rtl:begin:remove*/\n    mask-repeat: no-repeat;\n    mask-position: center;\n    -webkit-mask-repeat: no-repeat;\n    -webkit-mask-position: center;\n    background-color: var(--kt-primary);\n    -webkit-mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    mask-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='var%28--kt-primary%29'%3e%3cpath d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/%3e%3c/svg%3e\");\n    /*rtl:end:remove*/\n  }\n}\n\n@media (min-width: 992px) {\n  [data-kt-app-layout=light-sidebar]:not([data-kt-app-header-fixed=true]) .app-header {\n    background-color: transparent;\n    box-shadow: none;\n    border-bottom: 1px solid var(--kt-app-sidebar-light-separator-color);\n  }\n}\n@media (max-width: 991.98px) {\n  [data-kt-app-layout=light-sidebar]:not([data-kt-app-header-fixed-mobile=true]) .app-header {\n    background-color: transparent;\n    box-shadow: none;\n    border-bottom: 1px solid var(--kt-app-sidebar-light-separator-color);\n  }\n}\n@media (min-width: 992px) {\n  [data-kt-app-toolbar-enabled=true]:not([data-kt-app-toolbar-fixed=true]) .app-content {\n    padding-top: 0;\n  }\n}\n@media (max-width: 991.98px) {\n  [data-kt-app-toolbar-enabled=true]:not([data-kt-app-toolbar-fixed-mobile=true]) .app-content {\n    padding-top: 0;\n  }\n}\n:is([data-kt-app-layout=light-sidebar], [data-kt-app-layout=light-header], [data-kt-app-layout=dark-header]) .app-toolbar .form-select.form-select {\n  background-color: var(--kt-body-bg) !important;\n}\n\n@media (min-width: 992px) {\n  body:not([data-kt-app-toolbar-fixed=true]) .app-toolbar {\n    height: auto;\n    background-color: transparent;\n    border-top: 0;\n    border-bottom: 0;\n    box-shadow: none;\n  }\n}\n@media (max-width: 991.98px) {\n  body:not([data-kt-app-toolbar-fixed-mobile=true]) .app-toolbar {\n    height: auto;\n    background-color: transparent;\n    border-top: 0;\n    border-bottom: 0;\n    box-shadow: none;\n  }\n}\n@media (min-width: 992px) {\n  [data-kt-app-layout=dark-header] .app-header .page-heading {\n    color: #ffffff !important;\n  }\n}",":root {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{$font-family-base};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  --#{$prefix}body-color: #{$body-color};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n  --#{$prefix}body-bg: #{$body-bg};\n  // scss-docs-end root-body-variables\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-2xl: #{$border-radius-2xl};\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n\n  --#{$prefix}code-color: #{$code-color};\n\n  --#{$prefix}highlight-bg: #{$mark-bg};\n}\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + ' ' + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + ' ' + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      }\n      @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + ' ' + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + ' ' + $value;\n      }\n\n      @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + ' ' +  if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + ' calc(' + $min-width + if($value < 0, ' - ', ' + ') + $variable-width + ')';\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluidVal: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluidVal {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluidVal);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule {\n        #{$property}: if($rfs-mode == max-media-query, $fluidVal, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: var(--#{$prefix}link-color);\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: var(--#{$prefix}link-hover-color);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. Correct the outline style in Safari.\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n\n[type=\"search\"] {\n  outline-offset: -2px; // 1\n  -webkit-appearance: textfield; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n$body-text-align:           null !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-2xl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             $border-width !default;\n$hr-opacity:                  .25 !default;\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}body-color) !default;\n$table-bg:                    transparent !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n$table-border-factor:         .1 !default;\n$table-border-width:          $border-width !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         .25rem !default;\n$input-btn-focus-color-opacity: .25 !default;\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity) !default;\n$input-btn-focus-blur:          0 !default;\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       $text-muted !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              $body-bg !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     $gray-200 !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           $body-color !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      $box-shadow-inset !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 1px solid rgba($black, .25) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $gray-200 !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          $box-shadow-inset !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             $gray-300 !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     $box-shadow-inset !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             $gray-500 !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             $input-group-addon-bg !default;\n$form-file-button-hover-bg:       shade-color($form-file-button-bg, 5%) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:       1.25 !default;\n$form-floating-padding-x:         $input-padding-x !default;\n$form-floating-padding-y:         1rem !default;\n$form-floating-input-padding-t:   1.625rem !default;\n$form-floating-input-padding-b:   .625rem !default;\n$form-floating-label-opacity:     .65 !default;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba($black, .55) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               $box-shadow !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         shade-color($dropdown-link-color, 10%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     $white !default;\n$pagination-border-radius:          $border-radius !default;\n$pagination-border-width:           $border-width !default;\n$pagination-margin-start:           ($pagination-border-width * -1) !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               $gray-200 !default;\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-border-width:                 $border-width !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                $border-radius !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         $body-color !default; // Sass variable because of $accordion-button-icon\n$accordion-bg:                            $body-bg !default;\n$accordion-border-width:                  $border-width !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 $border-radius !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  $accordion-color !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $accordion-button-color !default;\n$accordion-icon-active-color:             $accordion-button-active-color !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                $box-shadow !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 shade-color($popover-bg, 6%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                $border-width !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               $border-radius !default;\n$toast-box-shadow:                  $box-shadow !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba($black, .05) !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               $border-radius !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           $border-radius !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            $border-width !default;\n$alert-bg-scale:                -80% !default;\n$alert-border-scale:            -70% !default;\n$alert-color-scale:             40% !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               $box-shadow-inset !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  $gray-900 !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n$list-group-item-bg-scale:          -80% !default;\n$list-group-item-color-scale:       40% !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              $box-shadow-sm !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              $gray-600 !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                $modal-content-bg !default;\n$offcanvas-color:                   $modal-content-color !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n","//\r\n// Bootstrap & Custom Variables\r\n// Safely override any variable in _variables.custom.scss\r\n//\r\n\r\n\r\n// Bootstrap color system\r\n$white: #ffffff !default;\r\n$black:#000000 !default;\r\n\r\n// Bootstrap grey colors\r\n$gray-100: #f5f8fa !default;\r\n$gray-200: #eff2f5 !default;\r\n$gray-300: #E4E6EF !default;\r\n$gray-400: #B5B5C3 !default;\r\n$gray-500: #A1A5B7 !default;\r\n$gray-600: #7E8299 !default;\r\n$gray-700: #5E6278 !default;\r\n$gray-800: #3F4254 !default;\r\n$gray-900: #181C32 !default;\r\n\r\n$gray-100-dark:  #1b1b29 !default;\r\n$gray-200-dark:  #2B2B40 !default;\r\n$gray-300-dark:  #323248 !default;\r\n$gray-400-dark:  #474761 !default;\r\n$gray-500-dark:  #565674 !default;\r\n$gray-600-dark:  #6D6D80 !default;\r\n$gray-700-dark:  #92929F !default;\r\n$gray-800-dark:  #CDCDDE !default;\r\n$gray-900-dark:  #FFFFFF !default;\r\n\r\n// Bootstrap muted color\r\n$text-muted: $gray-500 !default;\r\n$text-muted-dark: $gray-500-dark !default;\r\n\r\n// Bootstrap gray colors map\r\n$grays: (\r\n\t\"100\": $gray-100,\r\n\t\"200\": $gray-200,\r\n\t\"300\": $gray-300,\r\n\t\"400\": $gray-400,\r\n\t\"500\": $gray-500,\r\n\t\"600\": $gray-600,\r\n\t\"700\": $gray-700,\r\n\t\"800\": $gray-800,\r\n\t\"900\": $gray-900\r\n) !default; \r\n\r\n$grays-dark: (\r\n\t\"100\": $gray-100-dark,\r\n\t\"200\": $gray-200-dark,\r\n\t\"300\": $gray-300-dark,\r\n\t\"400\": $gray-400-dark,\r\n\t\"500\": $gray-500-dark,\r\n\t\"600\": $gray-600-dark,\r\n\t\"700\": $gray-700-dark,\r\n\t\"800\": $gray-800-dark,\r\n\t\"900\": $gray-900-dark\r\n) !default;\r\n\r\n// Bootstrap contextual colors\r\n// Primary colors\r\n$primary:\t\t\t\t\t\t#3699FF !default;\r\n$primary-active:\t\t\t\t#187DE4 !default;\r\n$primary-light: \t\t\t\t#F1FAFF !default;\r\n$primary-light-dark:\t\t\t#212E48 !default;\r\n$primary-inverse: \t\t\t\t$white !default;\r\n\r\n// Secondary colors\r\n$secondary: \t\t\t\t\t$gray-300 !default;\r\n$secondary-dark: \t\t\t\t$gray-300-dark !default;\r\n$secondary-active: \t\t\t\t$gray-400 !default;\r\n$secondary-active-dark: \t\t$gray-400-dark !default;\r\n$secondary-light: \t\t\t\t$gray-100 !default;\r\n$secondary-light-dark: \t\t\t$gray-100-dark !default;\r\n$secondary-inverse:\t\t\t\t$gray-800 !default;\r\n$secondary-inverse-dark:\t\t$gray-800-dark !default;\r\n\r\n// Light colors\r\n$light: \t\t\t\t\t\t$gray-100 !default;\r\n$light-dark: \t\t\t\t\t$gray-200-dark !default; \r\n$light-active: \t\t\t\t\t$gray-200 !default;\r\n$light-active-dark: \t\t\t$gray-300-dark !default;\r\n$light-light: \t\t\t\t\tgba($gray-100, 0.75) !default;\r\n$light-inverse:\t\t\t\t\t$gray-600 !default;\r\n$light-inverse-dark: \t\t\t$gray-600-dark !default;\r\n\r\n// Success colors\r\n$success: \t\t\t\t\t\t#1BC5BD !default; \r\n$success-active: \t\t\t\t#0BB7AF !default;\r\n$success-light: \t\t\t\t#C9F7F5 !default;\r\n$success-light-dark:\t\t\t#1C3833 !default;\r\n$success-inverse: \t\t\t\t$white !default;\r\n\r\n// Info colors\r\n$info: \t\t\t\t\t\t\t#8950FC !default; \r\n$info-active: \t\t\t\t\t#7337EE !default;\r\n$info-light: \t\t\t\t\t#EEE5FF !default;\r\n$info-light-dark: \t\t\t\t#2F264F !default;\r\n$info-inverse: \t\t\t\t\t$white !default;\r\n\r\n// Warning colors\r\n$warning: \t\t\t\t\t\t#FFA800 !default; \r\n$warning-active: \t\t\t\t#EE9D01 !default;\r\n$warning-light: \t\t\t\t#FFF4DE !default;\r\n$warning-light-dark: \t\t\t#392F28 !default;\r\n$warning-inverse: \t\t\t\t$white !default;\r\n\r\n// Danger colors\r\n$danger: \t\t\t\t\t\t#F64E60 !default; \r\n$danger-active: \t\t\t\t#EE2D41 !default;\r\n$danger-light: \t\t\t\t\t#FFE2E5 !default;\r\n$danger-light-dark:\t\t\t\t#3A2434 !default;\r\n$danger-inverse: \t\t\t\t$white !default;\r\n\r\n// Dark colors\r\n$dark: \t\t\t\t\t\t\t$gray-900 !default;\r\n$dark-dark: \t\t\t\t\t$gray-900-dark !default; \r\n$dark-active: \t\t\t\t\tdarken($gray-900, 3%) !default;\r\n$dark-active-dark: \t\t\t\tlighten($gray-900-dark, 3%) !default;\r\n$dark-light: \t\t\t\t\t$gray-200 !default; \r\n$dark-light-dark: \t\t\t\t$gray-200-dark !default;\r\n$dark-inverse: \t\t\t\t\t$white !default;\r\n$dark-inverse-dark: \t\t\t$gray-100-dark !default; \r\n\r\n// Contextual colors\r\n$theme-colors: (\r\n\t\"white\": $white,  // custom color type\r\n\t\"light\": $light,\r\n\t\"primary\": $primary,\r\n\t\"secondary\": $secondary,\r\n\t\"success\": $success,\r\n\t\"info\": $info,\r\n\t\"warning\": $warning,\r\n\t\"danger\": $danger,\r\n\t\"dark\": $dark\r\n) !default;\r\n\t\r\n$theme-colors-dark: (\r\n\t\"dark\":    $dark-dark,\r\n\t\"light\":   $light-dark,\r\n\t\"secondary\":   $secondary-dark,\r\n) !default;\r\n\r\n// Contextual active state colors\r\n$theme-active-colors: (\r\n\t\"primary\": $primary-active,\r\n\t\"secondary\":  $secondary-active,\r\n\t\"light\":   $light-active,\r\n\t\"success\": $success-active,\r\n\t\"info\":    $info-active,\r\n\t\"warning\": $warning-active,\r\n\t\"danger\":  $danger-active,\r\n\t\"dark\":    $dark-active\r\n) !default; \r\n\r\n$theme-active-colors-dark: (\r\n\t\"dark\":    $dark-active-dark,\r\n\t\"light\":   $light-active-dark,\r\n\t\"secondary\":   $secondary-active-dark,\r\n) !default;\r\n\r\n// Contextual inverse state colors\r\n$theme-inverse-colors: (\r\n\t\"primary\": $primary-inverse,\r\n\t\"secondary\":  $secondary-inverse,\r\n\t\"light\":   $light-inverse,\r\n\t\"success\": $success-inverse,\r\n\t\"info\":    $info-inverse,\r\n\t\"warning\": $warning-inverse,\r\n\t\"danger\":  $danger-inverse,\r\n\t\"dark\":    $dark-inverse\r\n) !default; \r\n\r\n$theme-inverse-colors-dark: (\r\n\t\"dark\":    $dark-inverse-dark,\r\n\t\"light\":   $light-inverse-dark,\r\n\t\"secondary\":   $secondary-inverse-dark,\r\n) !default;\r\n\r\n// Contextual light state colors\r\n$theme-light-colors: (\r\n\t\"primary\": $primary-light,\r\n\t\"secondary\": $secondary-light,\r\n\t\"success\": $success-light,\r\n\t\"info\":    $info-light,\r\n\t\"warning\": $warning-light,\r\n\t\"danger\":  $danger-light,\r\n\t\"dark\":    $dark-light\r\n) !default; \r\n\r\n$theme-light-colors-dark: (\r\n\t\"primary\": $primary-light-dark,\r\n\t\"success\": $success-light-dark,\r\n\t\"info\":    $info-light-dark,\r\n\t\"warning\": $warning-light-dark,\r\n\t\"danger\":  $danger-light-dark,\r\n\t\"dark\":    $dark-light-dark,\r\n\t\"secondary\":  $secondary-light-dark\r\n) !default; \r\n\t\r\n// Text colors\r\n$theme-text-colors: (\r\n\t\"white\":   $white,\r\n\t\"primary\": $primary,\r\n\t\"secondary\":  $secondary,\r\n\t\"light\":   $light,\r\n\t\"success\": $success,\r\n\t\"info\":    $info,\r\n\t\"warning\": $warning,\r\n\t\"danger\":  $danger,\r\n\t\"dark\":    $dark,\r\n\t\"muted\":   $text-muted,\r\n\t\"gray-100\":   $gray-100,\r\n\t\"gray-200\":   $gray-200,\r\n\t\"gray-300\":   $gray-300,\r\n\t\"gray-400\":   $gray-400,\r\n\t\"gray-500\":   $gray-500,\r\n\t\"gray-600\":   $gray-600,\r\n\t\"gray-700\":   $gray-700,\r\n\t\"gray-800\":   $gray-800,\r\n\t\"gray-900\":   $gray-900\r\n) !default; \r\n\r\n$theme-text-colors-dark: (\r\n\t\"dark\":    $dark-dark,\r\n\t\"muted\":   $text-muted-dark,\r\n\t\"secondary\":   $secondary-dark,\r\n\t\"gray-100\":   $gray-100-dark,\r\n\t\"gray-200\":   $gray-200-dark,\r\n\t\"gray-300\":   $gray-300-dark,\r\n\t\"gray-400\":   $gray-400-dark,\r\n\t\"gray-500\":   $gray-500-dark,\r\n\t\"gray-600\":   $gray-600-dark,\r\n\t\"gray-700\":   $gray-700-dark,\r\n\t\"gray-800\":   $gray-800-dark,\r\n\t\"gray-900\":   $gray-900-dark\r\n) !default; \r\n\r\n\r\n// Options\r\n//\r\n// Quickly modify global styling by enabling or disabling optional features.\r\n$enable-rounded: true !default;\r\n$enable-shadows: true !default;\r\n$enable-negative-margins: true !default;\r\n$enable-smooth-scroll: false !default;\r\n\r\n// Spacing\r\n//\r\n// Control the default styling of most Bootstrap elements by modifying these\r\n// variables. Mostly focused on spacing.\r\n// You can add more entries to the $spacers map, should you need more variation.\r\n$spacer: 1rem !default;\r\n\r\n$spacers: (\r\n\t0: 0,\r\n\t1: ($spacer * .25), // 3.5px\r\n\t2: ($spacer * .5), // 7px;\r\n\t3: ($spacer * .75), // 10.5px\r\n\t4: ($spacer * 1), // 14px\r\n\t5: ($spacer * 1.25), // 17.5px\r\n\t6: ($spacer * 1.5),  // 21px\r\n\t7: ($spacer * 1.75), // 24.5px\r\n\t8: ($spacer * 2), // 28px\r\n\t9: ($spacer * 2.25), // 31.5px\r\n\t10: ($spacer * 2.5), // 35px\r\n\t11: ($spacer * 2.75), // 38.5px\r\n\t12: ($spacer * 3),   \t// 42px\r\n\t13: ($spacer * 3.25),\t// 45.5px\r\n\t14: ($spacer * 3.5), \t// 49px\r\n\t15: ($spacer * 3.75), \t// 52.5px\r\n\t16: ($spacer * 4), \t\t// 55px\r\n\t17: ($spacer * 4.25), \t// 58.5px\r\n\t18: ($spacer * 4.5), \t// 62px\r\n\t19: ($spacer * 4.75), \t// 65.5px\r\n\t20: ($spacer * 5), \t\t// 69px\r\n);\r\n\r\n\r\n// Position\r\n//\r\n// Define the edge positioning anchors of the position utilities.\r\n$position-values: (\r\n\t0: 0,\r\n\t25: 25%,\r\n\t50: 50%,\r\n\t75: 75%,\r\n\t100: 100%\r\n) !default;\r\n\r\n\r\n// Body\r\n//\r\n// Settings for the `<body>` element.\r\n$body-bg:                   $white !default;\r\n$body-bg-rgb:               to-rgb($body-bg) !default;\r\n$body-bg-dark:              #1e1e2d !default;\r\n$body-bg-rgb-dark:          to-rgb($body-bg-dark) !default;\r\n$body-color:                $gray-900 !default;\r\n$body-color-dark:           $gray-900-dark !default;\r\n$body-text-align:           null !default;\r\n\r\n\r\n// Links\r\n//\r\n// Style anchor elements.\r\n$link-color:                $primary !default;\r\n$link-color-dark:           $primary !default;\r\n$link-decoration:           none !default;\r\n$link-shade-percentage:     20% !default;\r\n$link-hover-color:          $primary-active !default;\r\n$link-hover-color-dark:     $primary-active !default;\r\n$link-hover-decoration:     none !default;\r\n\r\n\r\n// Paragraphs\r\n//\r\n// Style p element.\r\n$paragraph-margin-bottom:         1rem !default;\r\n\r\n\r\n// Grid breakpoints\r\n//\r\n// Define the minimum dimensions at which your layout will change,\r\n// adapting to different screen sizes, for use in media queries.\r\n// scss-docs-start grid-breakpoints\r\n$grid-breakpoints: (\r\n\txs: 0,\r\n\tsm: 576px,\r\n\tmd: 768px,\r\n\tlg: 992px,\r\n\txl: 1200px,\r\n\txxl: 1400px\r\n) !default;\r\n// scss-docs-end grid-breakpoints\r\n\r\n\r\n// Grid containers\r\n//\r\n// Define the maximum width of `.container` for different screen sizes.\r\n$container-max-widths: (\r\n\tsm: 540px,\r\n\tmd: 720px,\r\n\tlg: 960px,\r\n\txl: 1140px,\r\n\txxl: 1320px\r\n) !default;\r\n\r\n\r\n// Components\r\n//\r\n// Define common padding and border radius sizes and more.\r\n$border-width:                  1px !default;\r\n$border-color:                  $gray-200 !default;\r\n$border-color-dark:             $gray-200-dark !default;\r\n$border-dashed-color:           $gray-300 !default;\r\n$border-dashed-color-dark:      $gray-300-dark !default; \r\n\r\n$border-widths: (\r\n\t0: 0,\r\n\t1: 1px,\r\n\t2: 2px,\r\n\t3: 3px,\r\n\t4: 4px,\r\n\t5: 5px\r\n) !default;\r\n\r\n// Border Radiues\r\n$border-radius:                 .475rem !default;\r\n$border-radius-sm:              .425rem !default;\r\n$border-radius-lg:              .625rem !default;\r\n$border-radius-xl:              1rem !default;\r\n$border-radius-2xl:             2rem !default;\r\n$border-radius-pill:            50rem !default;\r\n\r\n// Keenthemes hover states\r\n$component-hover-color: \t\t$primary !default;\r\n$component-hover-color-dark: \t$primary !default;\r\n$component-hover-bg: \t\t\t#F4F6FA !default;\r\n$component-hover-bg-dark: \t\t$gray-200-dark !default;\r\n\r\n// Keenthemes active states\r\n$component-active-color:        $primary-inverse !default;\r\n$component-active-color-dark:   $primary-inverse !default;\r\n$component-active-bg:           $primary !default;\r\n$component-active-bg-dark:      $primary !default;\r\n\r\n// Keenthemes checked states\r\n$component-checked-color:        $primary-inverse !default;\r\n$component-checked-color-dark:   $primary-inverse !default;\r\n$component-checked-bg:           $primary !default;\r\n$component-checked-bg-dark:      $primary !default;\r\n\r\n// Keenthemes custom transition settings\r\n$transition-link: color .2s ease !default; \r\n$transition-input: color .2s ease !default; \r\n\r\n// Box shadow\r\n$box-shadow-xs: 0 .1rem 0.75rem 0.25rem rgba($black, 0.05) !default;\r\n$box-shadow-xs-dark: 0 .1rem 0.75rem 0.25rem rgba($black, 0.05) !default;\r\n$box-shadow-sm: 0 .1rem 1rem 0.25rem rgba($black, .05) !default;\r\n$box-shadow-sm-dark: 0 .1rem 1rem 0.25rem rgba($black, .05) !default;\r\n$box-shadow: 0 .5rem 1.5rem 0.5rem rgba($black, .075) !default;\r\n$box-shadow-dark: 0 .5rem 1.5rem 0.5rem rgba($black, .075) !default;\r\n$box-shadow-lg: 0 1rem 2rem 1rem rgba($black, .1) !default;\r\n$box-shadow-lg-dark: 0 1rem 2rem 1rem rgba($black, .1) !default;\r\n$box-shadow-inset: inset 0 1px 2px rgba($black, .075) !default;\r\n$box-shadow-inset-dark: inset 0 1px 2px rgba($black, .075) !default;\r\n\r\n// Keenthemes custom gutter sizes\r\n$gutters: (\r\n\t0: 0rem,\r\n\t1: ($spacer * .25),  \t// 3.5px\r\n\t2: ($spacer * .5),   \t// 7px;\r\n\t3: ($spacer * .75),  \t// 10.5px\r\n\t4: ($spacer * 1), \t// 14px\r\n\t5: ($spacer * 1.25), \t// 17.5px\r\n\t6: ($spacer * 1.5),  \t// 21px\r\n\t7: ($spacer * 1.75), \t// 24.5px\r\n\t8: ($spacer * 2), \t// 28px\r\n\t9: ($spacer * 2.25), \t// 31.5px\r\n\t10: ($spacer * 2.5), \t// 35px\r\n) !default;\r\n\r\n\r\n// Typography\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n// Font family\r\n$font-family-sans-serif: Inter, Helvetica, \"sans-serif\" !default;\r\n\r\n$font-size-base: 1rem !default; // Assumes the browser default, typically `13px`\r\n$font-size-lg: $font-size-base * 1.075 !default;   // 14.04px\r\n$font-size-sm: $font-size-base * .925 !default;   // 12.025px\r\n\r\n$font-weight-lighter: lighter !default;\r\n$font-weight-light: 300 !default;\r\n$font-weight-normal: 400 !default;\r\n$font-weight-semibold: 500 !default;\r\n$font-weight-bold: 600 !default;\r\n$font-weight-bolder: 700 !default;\r\n\r\n$font-weight-base: $font-weight-normal !default;\r\n\r\n// Line heights\r\n$line-height-base: 1.5 !default;\r\n$line-height-sm: 1.25 !default;\r\n$line-height-lg: 1.75 !default;\r\n\r\n// Keenthemes custom line heights\r\n$line-height-xl: 2 !default;\r\n$line-height-xxl: 2.25 !default;\r\n\r\n// Heading sizes\r\n$h1-font-size:  $font-size-base * 1.75 !default; // 22.75px\r\n$h2-font-size:  $font-size-base * 1.5 !default; // 19.50px\r\n$h3-font-size:  $font-size-base * 1.35 !default; // 17.55px\r\n$h4-font-size:  $font-size-base * 1.25 !default; // 16.25px\r\n$h5-font-size:  $font-size-base * 1.15 !default; // 14.95px\r\n$h6-font-size:  $font-size-base * 1.075 !default; // 13.97px\r\n\r\n// Font Sizes\r\n$font-sizes: (\r\n\t1: $h1-font-size,   // 22.75px\r\n\t2: $h2-font-size,   // 19.50px\r\n\t3: $h3-font-size,   // 17.55px\r\n\t4: $h4-font-size,   // 16.25px\r\n\t5: $h5-font-size,   // 14.95px\r\n\t6: $h6-font-size,   // 13.95px\r\n\r\n\t7: $font-size-base * 0.95,  // 12.35px\r\n\t8: $font-size-base * 0.85,  // 11.05px\r\n\t9: $font-size-base * 0.75,  // 9.75px\r\n\t10: $font-size-base * 0.5,  // 6.50px\r\n\r\n\tbase: $font-size-base, // 13px\r\n\tfluid: 100%, // 100%\r\n\r\n\t2x: $font-size-base * 2,  // 26px\r\n\t2qx: $font-size-base * 2.25, // 29.25px\r\n\t2hx: $font-size-base * 2.5,  // 32.5px\r\n\t2tx: $font-size-base * 2.75, // 35.75px\r\n\r\n\t3x: $font-size-base * 3,  // 39px\r\n\t3qx: $font-size-base * 3.25, // 42.25px\r\n\t3hx: $font-size-base * 3.5,  // 45.5px\r\n\t3tx: $font-size-base * 3.75, // 48.75px\r\n\r\n\t4x: $font-size-base * 4,  // 52px\r\n\t4qx: $font-size-base * 4.25, // 55.25px\r\n\t4hx: $font-size-base * 4.5,  // 58.5px\r\n\t4tx: $font-size-base * 4.75, // 61.75px\r\n\t\r\n\t5x: $font-size-base * 5,  // 65px\r\n\t5qx: $font-size-base * 5.25, // 68.25px\r\n\t5hx: $font-size-base * 5.5,  // 71.5px\r\n\t5tx: $font-size-base * 5.75  // 74.75px\r\n) !default;\r\n\r\n$headings-font-weight: \t\t\t600 !default;\r\n$headings-color: \t\t\t\t$gray-900 !default;\r\n$headings-color-dark: \t\t\t$gray-900-dark !default;\r\n$headings-line-height:        \t1.2 !default;\r\n\r\n$display-font-sizes: (\r\n 1: 5rem,\r\n 2: 4.5rem,\r\n 3: 4rem,\r\n 4: 3.5rem,\r\n 5: 3rem,\r\n 6: 2.5rem\r\n) !default;\r\n\r\n$display-font-weight:  $font-weight-bolder !default;\r\n$display-line-height:  $headings-line-height !default;\r\n\r\n$blockquote-footer-color:     $gray-600 !default;\r\n$blockquote-footer-color:     $gray-600-dark !default;\r\n\r\n\r\n// Tables\r\n//\r\n// Customizes the `.table` component with basic values, each used across all table variations.\r\n\r\n$table-cell-padding-y:                      .75rem !default;\r\n$table-cell-padding-x:                      .75rem !default;\r\n$table-cell-padding-y-sm:                   .5rem !default;\r\n$table-cell-padding-x-sm:                   .5rem !default;\r\n\r\n$table-color:                               $body-color !default;\r\n$table-color-dark:                          $body-color-dark !default;\r\n$table-bg:                                  transparent !default;\r\n$table-bg-dark:                             transparent !default;\r\n$table-accent-bg:                           transparent !default;\r\n$table-accent-bg-dark:                      transparent !default;\r\n$table-striped-color:                       $table-color !default;\r\n$table-striped-color-dark:                  $table-color-dark !default;\r\n$table-striped-bg:                          rgba($gray-100, 0.75) !default;\r\n$table-striped-bg-dark:                     rgba($gray-100-dark, 0.75) !default;\r\n\r\n$table-active-color:                        $table-color !default;\r\n$table-active-color-dark:                   $table-color-dark !default;\r\n$table-active-bg:                           $gray-100 !default;\r\n$table-active-bg-dark:                      $gray-100-dark !default;\r\n\r\n$table-hover-color:                         $table-color !default;\r\n$table-hover-color-dark:                    $table-color-dark !default;\r\n$table-hover-bg:                            $gray-100 !default;\r\n$table-hover-bg-dark:                       $gray-100-dark !default;\r\n\r\n$table-border-factor:                       .1 !default;\r\n$table-border-width:                        $border-width !default;\r\n$table-border-color:                        $border-color !default;\r\n$table-border-color-dark:                   $border-color-dark !default;\r\n\r\n$table-caption-color:                       $text-muted !default;\r\n$table-caption-color-dark:                  $text-muted-dark !default;\r\n\r\n$table-loading-message-box-shadow:          0px 0px 50px 0px rgba(82,63,105, 0.15) !default;\r\n$table-loading-message-box-shadow-dark:     0px 0px 30px rgba(0, 0, 0, 0.3) !default;\r\n$table-loading-message-bg:                  $body-bg !default;\r\n$table-loading-message-bg-dark:             $gray-200-dark !default;\r\n$table-loading-message-color:               $gray-700 !default;\r\n$table-loading-message-color-dark:          $gray-700-dark !default;\r\n\r\n\r\n// Buttons + Forms\r\n//\r\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\r\n$input-btn-padding-y:                       .775rem !default;\r\n$input-btn-padding-x:                       1rem !default;\r\n$input-btn-font-family:                     null !default;\r\n$input-btn-font-size:                       $font-size-base * 1.1 !default;\r\n$input-btn-line-height:                     $line-height-base !default;\r\n\r\n$input-btn-focus-width:                     .25rem !default;\r\n$input-btn-focus-color-opacity:             .25 !default;\r\n$input-btn-focus-color-opacity-dark:        .25 !default;\r\n$input-btn-focus-color:                     rgba($component-active-bg, $input-btn-focus-color-opacity) !default;\r\n$input-btn-focus-color-dark:                rgba($component-active-bg-dark, $input-btn-focus-color-opacity-dark) !default;\r\n$input-btn-focus-box-shadow:                null !default;\r\n$input-btn-focus-box-shadow-dark:           null !default;\r\n\r\n$input-btn-padding-y-sm:                    .55rem !default;\r\n$input-btn-padding-x-sm:                    .75rem !default;\r\n$input-btn-font-size-sm:                    $font-size-sm !default;\r\n\r\n$input-btn-padding-y-lg:                    .825rem !default;\r\n$input-btn-padding-x-lg:                    1.5rem !default;\r\n$input-btn-font-size-lg:                    $font-size-base * 1.15 !default;\r\n\r\n$input-btn-border-width:                    $border-width !default;\r\n\r\n// Buttons\r\n//\r\n// For each of Bootstrap's buttons, define text, background, and border color.\r\n$btn-padding-y:                             $input-btn-padding-y !default;\r\n$btn-padding-x:                             1.5rem !default;\r\n$btn-font-family:                           $input-btn-font-family !default;\r\n$btn-font-size:                             $input-btn-font-size !default;\r\n$btn-line-height:                           $input-btn-line-height !default;\r\n$btn-white-space:                           null !default; // Set to `nowrap` to prevent text wrapping\r\n\r\n$btn-padding-y-sm:                          $input-btn-padding-y-sm !default;\r\n$btn-padding-x-sm:                          1.25rem !default;\r\n$btn-font-size-sm:                          $input-btn-font-size-sm !default;\r\n\r\n$btn-padding-y-lg:                          $input-btn-padding-y-lg !default;\r\n$btn-padding-x-lg:                          1.75rem !default;\r\n$btn-font-size-lg:                          $input-btn-font-size-lg !default;\r\n\r\n$btn-border-width:                          $input-btn-border-width !default;\r\n\r\n$btn-font-weight:                           $font-weight-semibold !default;\r\n$btn-box-shadow:                            null !default;\r\n$btn-box-shadow-dark:                       null !default;\r\n$btn-focus-width:                           $input-btn-focus-width !default;\r\n$btn-focus-box-shadow:                      null !default;\r\n$btn-focus-box-shadow-dark:                 null !default;\r\n$btn-disabled-opacity:                      .65 !default;\r\n$btn-disabled-opacity-dark:                 .65 !default;\r\n$btn-active-box-shadow:                     null !default;\r\n$btn-active-box-shadow-dark:                null !default;\r\n\r\n$btn-link-color:                            $link-color !default;\r\n$btn-link-color-dark:                       $link-color !default;\r\n$btn-link-hover-color:                      $link-hover-color !default;\r\n$btn-link-hover-color-dark:                 $link-hover-color !default;\r\n$btn-link-disabled-color:                   $gray-600 !default;\r\n$btn-link-disabled-color-dark:              $gray-600-dark !default;\r\n\r\n// Allows for customizing button radius independently from global border radius\r\n$btn-border-radius:                         $border-radius !default;\r\n$btn-border-radius-sm:                      $border-radius-sm !default;\r\n$btn-border-radius-lg:                      $border-radius-lg !default;\r\n\r\n\r\n// Forms\r\n$form-text-margin-top:                      .5rem !default;\r\n$form-text-font-size:                       $font-size-sm !default;\r\n$form-text-color:                           $text-muted !default;\r\n$form-text-color-dark:                      $text-muted-dark !default;\r\n\r\n$form-label-margin-bottom:                  .5rem !default;\r\n$form-label-font-size:                      1.05rem !default;\r\n$form-label-font-weight:                    500 !default;\r\n$form-label-color:                          $gray-800 !default;\r\n$form-label-color-dark:                     $gray-800-dark !default;\r\n\r\n$input-padding-y:                           $input-btn-padding-y !default;\r\n$input-padding-x:                           $input-btn-padding-x !default;\r\n$input-font-family:                         $input-btn-font-family !default;\r\n$input-font-size:                           $input-btn-font-size !default;\r\n$input-font-weight:                         $font-weight-semibold !default;\r\n$input-line-height:                         $input-btn-line-height !default;\r\n\r\n$input-bg:                                  $body-bg !default;\r\n$input-bg-dark:                             $body-bg-dark !default;\r\n\r\n$input-border-width:                    \t$input-btn-border-width !default;\r\n$input-color:                               $gray-700 !default;\r\n$input-color-dark:                          $gray-700-dark !default;\r\n$input-border-color:                        $gray-300 !default;\r\n$input-border-color-dark:                   $gray-300-dark !default;\r\n//$input-box-shadow:                        none !default;\r\n//$input-box-shadow-dark:                   none !default;\r\n\r\n$input-border-radius:                       $btn-border-radius !default;\r\n$input-border-radius-sm:                    $btn-border-radius-sm !default;\r\n$input-border-radius-lg:                    $btn-border-radius-lg !default;\r\n\r\n$input-focus-bg:                            $input-bg !default;\r\n$input-focus-bg-dark:                       $input-bg-dark !default;\r\n$input-focus-border-color:                  $gray-400 !default;\r\n$input-focus-border-color-dark:             $gray-400-dark !default;\r\n$input-btn-focus-width:         \t\t\t.25rem !default;\r\n$input-focus-color:                         $input-color !default;\r\n$input-focus-color-dark:                    $input-color-dark !default;\r\n$input-focus-width:                     \t$input-btn-focus-width !default;\r\n//$input-focus-box-shadow:                  none !default;\r\n//$input-focus-box-shadow-dark:             none !default;\r\n\r\n$input-disabled-color:                      null !default;\r\n$input-disabled-color-dark:                 null !default;\r\n$input-disabled-bg:                         $gray-200 !default;\r\n$input-disabled-bg-dark:                    $gray-200-dark !default;\r\n$input-disabled-border-color:               $input-border-color !default;\r\n$input-disabled-border-color-dark:          $input-border-color-dark !default;\r\n\r\n$input-placeholder-color:                   $gray-500 !default;\r\n$input-placeholder-color-dark:              $gray-500-dark !default;\r\n$input-plaintext-color:                     $gray-700 !default;\r\n$input-plaintext-color-dark:                $gray-700-dark !default;\r\n\r\n// Keenthemes solid input style\r\n$input-solid-bg:                            $gray-100 !default;\r\n$input-solid-bg-dark:                       $gray-100-dark !default;\r\n$input-solid-bg-focus:                      darken($gray-100, 2%) !default;\r\n$input-solid-bg-focus-dark:                 lighten($gray-100-dark, 2%) !default;\r\n$input-solid-placeholder-color:             $input-placeholder-color !default; \r\n$input-solid-placeholder-color-dark:        $input-placeholder-color-dark !default; \r\n$input-solid-color:         \t            $gray-700 !default;\r\n$input-solid-color-dark:                    $gray-700-dark !default;\r\n\r\n// Form checks\r\n$form-check-input-width:                    1.75rem !default;\r\n$form-check-input-width-sm:                 1.55rem !default;\r\n$form-check-input-width-lg:                 2.25rem !default;\r\n$form-check-input-bg-size:                  60% 60% !default;\r\n$form-check-min-height:                     $font-size-base * $line-height-base !default;\r\n$form-check-padding-start:                  $form-check-input-width + .5rem !default;\r\n$form-check-padding-left:                   $form-check-input-width + .5rem !default;\r\n$form-check-margin-bottom:                  .125rem !default;\r\n$form-check-label-color:                    $gray-500 !default;\r\n$form-check-label-color-dark:               $gray-500-dark !default;\r\n$form-check-label-color-checked:            $gray-700 !default;\r\n$form-check-label-color-checked-dark:       $gray-700-dark !default;\r\n$form-check-label-cursor:                   null !default;\r\n$form-check-transition:                     null !default;\r\n$form-check-inline-margin-right:            1rem !default;\r\n\r\n$form-check-input-active-filter:            brightness(90%) !default;\r\n$form-check-input-active-filter-dark:       brightness(90%) !default;\r\n\r\n$form-check-input-bg:                       transparent !default;\r\n$form-check-input-bg-dark:                  transparent !default;\r\n$form-check-input-bg-solid:                 $gray-200 !default;\r\n$form-check-input-bg-solid-dark:            $gray-200-dark !default;\r\n$form-check-input-bg-solid:                 $gray-200 !default;\r\n$form-check-input-bg-solid-dark:            $gray-200-dark !default;\r\n$form-check-input-border:                   1px solid $input-border-color !default;\r\n$form-check-input-border-dark:              1px solid $input-border-color-dark !default;\r\n$form-check-input-border-radius:            .45em !default;\r\n$form-check-radio-border-radius:            50% !default;\r\n$form-check-input-focus-border:             $input-focus-border-color !default;\r\n$form-check-input-focus-border-dark:        $input-focus-border-color-dark !default;\r\n$form-check-input-focus-box-shadow:         none !default;\r\n$form-check-input-focus-box-shadow-dark:    none !default;\r\n\r\n$form-check-input-checked-color:                    $component-checked-color !default;\r\n$form-check-input-checked-color-dark:               $component-checked-color-dark !default;\r\n$form-check-input-checked-bg-color:                 $component-checked-bg !default;\r\n$form-check-input-checked-bg-color-solid:           $component-checked-bg !default;\r\n$form-check-input-checked-bg-color-dark:            $component-checked-bg-dark !default;\r\n$form-check-input-checked-bg-color-solid-dark:      $component-checked-bg-dark !default;\r\n$form-check-input-checked-border-color:             $component-checked-bg !default;\r\n$form-check-input-checked-border-color-dark:        $component-checked-bg-dark !default;\r\n$form-check-input-checked-bg-image:                 url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 11' width='13' height='11' fill='none'><path d='M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\r\n$form-check-input-checked-bg-image-dark:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 13 11' width='13' height='11' fill='none'><path d='M11.0426 1.02893C11.3258 0.695792 11.8254 0.655283 12.1585 0.938451C12.4917 1.22162 12.5322 1.72124 12.249 2.05437L5.51985 9.97104C5.23224 10.3094 4.72261 10.3451 4.3907 10.05L0.828197 6.88335C0.50141 6.59288 0.471975 6.09249 0.762452 5.7657C1.05293 5.43891 1.55332 5.40948 1.88011 5.69995L4.83765 8.32889L11.0426 1.02893Z' fill='#{$form-check-input-checked-color-dark}'/></svg>\") !default;\r\n$form-check-radio-checked-bg-image:                 url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\r\n$form-check-radio-checked-bg-image-dark:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color-dark}'/></svg>\") !default;\r\n\r\n$form-check-input-indeterminate-color:              $component-checked-color !default;\r\n$form-check-input-indeterminate-color-dark:         $component-checked-color-dark !default;\r\n$form-check-input-indeterminate-bg-color:           $component-checked-bg !default;\r\n$form-check-input-indeterminate-bg-color-dark:      $component-checked-bg-dark !default;\r\n$form-check-input-indeterminate-border-color:       $component-checked-bg !default;\r\n$form-check-input-indeterminate-border-color-dark:  $component-checked-bg-dark !default;\r\n$form-check-input-indeterminate-bg-image:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\r\n$form-check-input-indeterminate-bg-image-dark:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color-dark}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\r\n\r\n$form-check-input-disabled-opacity:                 .5 !default;\r\n$form-check-input-disabled-opacity-dark:            .5 !default;\r\n$form-check-label-disabled-opacity:                 $form-check-input-disabled-opacity !default;\r\n$form-check-label-disabled-opacity-dark:            $form-check-input-disabled-opacity-dark !default;\r\n$form-check-btn-check-disabled-opacity:             $btn-disabled-opacity !default;\r\n$form-check-btn-check-disabled-opacity-dark:        $btn-disabled-opacity-dark !default;\r\n\r\n$form-switch-color:                                 rgba(0, 0, 0, .25) !default;\r\n$form-switch-color-dark:                            rgba(255, 255, 255, .25) !default;\r\n$form-switch-color-solid:                           $white !default;\r\n$form-switch-color-solid-dark:                      $gray-500 !default;\r\n$form-switch-width:                                 3.25rem !default;\r\n$form-switch-height:                                2.25rem !default;\r\n$form-switch-width-sm:                              2.5rem !default;\r\n$form-switch-height-sm:                             1.5rem !default;\r\n$form-switch-width-lg:                              3.75rem !default;\r\n$form-switch-height-lg:                             2.75rem !default;\r\n\r\n$form-switch-padding-start:                         $form-switch-width + .5rem !default;\r\n$form-switch-padding-left:                          $form-switch-width + .5rem !default;\r\n$form-switch-bg-image:                              url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\r\n$form-switch-bg-image-dark:                         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color-dark}'/></svg>\") !default;\r\n$form-switch-bg-image-solid:                        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color-solid}'/></svg>\") !default;\r\n$form-switch-bg-image-solid-dark:                   url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color-solid-dark}'/></svg>\") !default;\r\n$form-switch-border-radius:                         $form-switch-width !default;\r\n\r\n$form-switch-focus-color:                           $input-focus-border-color !default;\r\n$form-switch-focus-color-dark:                      $input-focus-border-color-dark !default;\r\n$form-switch-focus-bg-image:                        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\r\n$form-switch-focus-bg-image-dark:                   url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color-dark}'/></svg>\") !default;\r\n\r\n$form-switch-checked-color:                         $component-checked-color !default;\r\n$form-switch-checked-color-dark:                    $component-checked-color-dark !default;\r\n$form-switch-checked-bg-image:                      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\r\n$form-switch-checked-bg-image-dark:                 url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color-dark}'/></svg>\") !default;\r\n$form-switch-checked-bg-position:                   right center !default;\r\n\r\n\r\n// Input groups\r\n$input-group-addon-bg:                              $gray-100 !default;\r\n$input-group-addon-bg-dark:                         $gray-100-dark !default;\r\n$input-group-addon-color:                           $gray-700 !default;\r\n$input-group-addon-color-dark:                      $gray-700-dark !default;\r\n$input-group-addon-border-color:                    $input-border-color !default;\r\n$input-group-addon-border-color-dark:               $input-border-color-dark !default;\r\n\r\n\r\n// Form select\r\n$form-select-color:                                 $input-color !default;\r\n$form-select-color-dark:                            $input-color-dark !default;\r\n$form-select-bg:                                    $input-bg !default;\r\n$form-select-bg-dark:                               $input-bg-dark !default;\r\n$form-select-disabled-color:                        null !default;\r\n$form-select-disabled-color-dark:                   null !default;\r\n$form-select-disabled-bg:                           $gray-200 !default;\r\n$form-select-disabled-bg-dark:                      $gray-200-dark !default;\r\n$form-select-disabled-border-color:                 $input-disabled-border-color !default;\r\n$form-select-disabled-border-color-dark:            $input-disabled-border-color-dark !default;\r\n$form-select-indicator-color:                       $gray-600 !default;\r\n$form-select-indicator-color-dark:                  $gray-600-dark !default;\r\n$form-select-indicator:                             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\r\n$form-select-indicator-dark:                        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color-dark}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\r\n$form-select-border-color:                          $input-border-color !default;\r\n$form-select-border-color-dark:                     $input-border-color-dark !default;\r\n$form-select-box-shadow:                            $box-shadow-inset !default;\r\n$form-select-box-shadow-dark:                       $box-shadow-inset-dark !default;\r\n$form-select-focus-border-color:                    $input-focus-border-color !default;\r\n$form-select-focus-border-color-dark:               $input-focus-border-color-dark !default;\r\n$form-select-focus-width:         \t\t\t\t\t$input-focus-width !default;\r\n$form-select-focus-box-shadow:                      0 0 0 $form-select-focus-width $input-btn-focus-color !default;\r\n$form-select-focus-box-shadow-dark:                 0 0 0 $form-select-focus-width $input-btn-focus-color-dark !default;\r\n\r\n\r\n// Form range\r\n$form-range-track-border-radius:                    $border-radius !default;\r\n$form-range-track-bg:                               var(--kt-gray-300) !default;\r\n$form-range-thumb-disabled-bg:                      var(--kt-gray-500) !default;\r\n\r\n\r\n// Form file button\r\n$form-file-button-color:                            $input-color !default;\r\n$form-file-button-color-dark:                       $input-color-dark !default;\r\n$form-file-button-bg:                               $input-group-addon-bg !default;\r\n$form-file-button-bg-dark:                          $input-group-addon-bg-dark !default;\r\n$form-file-button-hover-bg:                         shade-color($form-file-button-bg, 5%) !default;\r\n$form-file-button-hover-bg-dark:                    shade-color($form-file-button-bg-dark, 5%) !default;\r\n\r\n\r\n// Form floating\r\n$input-height-border:                   \t\t\t$input-border-width * 2 !default;\r\n$form-floating-height:            \t\t\t\t\tcalc(3.75rem + #{$input-height-border}) !default;\r\n$form-floating-input-padding-t:                     1.85rem !default;\r\n\r\n\r\n// Navs\r\n$nav-link-transition:               \t\t\t\tcolor .15s ease-in-out !default;\r\n\r\n$nav-tabs-border-color:                             $border-color !default;\r\n$nav-tabs-border-color-dark:                        $border-color-dark !default;\r\n$nav-tabs-border-width:                             $border-width !default;\r\n$nav-tabs-link-hover-border-color:                  $gray-200 $gray-200 $nav-tabs-border-color !default;\r\n$nav-tabs-link-hover-border-color-dark:             $gray-200-dark $gray-200-dark $nav-tabs-border-color-dark !default;\r\n$nav-tabs-link-active-color:                        $gray-700 !default;\r\n$nav-tabs-link-active-color-dark:                   $gray-700-dark !default;\r\n$nav-tabs-link-active-bg:                           $body-bg !default;\r\n$nav-tabs-link-active-bg-dark:                      $body-bg-dark !default;\r\n$nav-tabs-link-active-border-color:                 $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\r\n$nav-tabs-link-active-border-color-dark:            $gray-300-dark $gray-300-dark $nav-tabs-link-active-bg-dark !default;\r\n\r\n$nav-pills-link-active-color:                       $component-active-color !default;\r\n$nav-pills-link-active-color-dark:                  $component-active-color-dark !default;\r\n$nav-pills-link-active-bg:                          $component-active-bg !default;\r\n$nav-pills-link-active-bg-dark:                     $component-active-bg-dark !default;\r\n\r\n\r\n// Dropdowns\r\n// Dropdown menu container and contents.\r\n$dropdown-color:                                    $body-color !default;\r\n$dropdown-color-dark:                               $body-color-dark !default;\r\n$dropdown-bg:                                       $body-bg !default;\r\n$dropdown-bg-dark:                                  $body-bg-dark !default;\r\n$dropdown-divider-bg:                               $gray-100 !default;\r\n$dropdown-divider-bg-dark:                          $gray-100-dark !default;\r\n$dropdown-box-shadow:\t\t\t\t\t\t\t\t0px 0px 50px 0px rgba(82,63,105, 0.15) !default;\r\n$dropdown-box-shadow-dark:\t\t\t\t\t\t\t0px 0px 30px rgba(0, 0, 0, 0.3) !default;\r\n$dropdown-border-radius:                            $border-radius !default;\r\n$dropdown-border-width:                             0 !default;\r\n$dropdown-link-color:                               $gray-900 !default;\r\n$dropdown-link-color-dark:                          $gray-900-dark !default;\r\n$dropdown-link-hover-color:                         shade-color($dropdown-link-color, 10%) !default;\r\n$dropdown-link-hover-color-dark:                    shade-color($dropdown-link-color-dark, 10%) !default;\r\n$dropdown-link-hover-bg:                            $gray-200 !default;\r\n$dropdown-link-hover-bg-dark:                       $gray-200-dark !default;\r\n$dropdown-link-active-color:                        $component-active-color !default;\r\n$dropdown-link-active-color-dark:                   $component-active-color-dark !default;\r\n$dropdown-link-active-bg:                           $component-active-bg !default;\r\n$dropdown-link-active-bg-dark:                      $component-active-bg-dark !default;\r\n$dropdown-link-disabled-color:                      $gray-500 !default;\r\n$dropdown-link-disabled-color-dark:                 $gray-500-dark !default;\r\n$dropdown-header-color:                             $gray-600 !default;\r\n$dropdown-header-color-dark:                        $gray-600-dark !default;\r\n\r\n\r\n// Pagination\r\n$pagination-item-height:                            2.5rem !default;\r\n$pagination-item-bg:                                $body-bg !default;\r\n$pagination-item-bg-dark:                           $body-bg-dark !default;\r\n$pagination-item-space:                             0.5rem !default;\r\n$pagination-item-space-tablet-and-mobile:           0.25rem !default;\r\n$pagination-font-weight:                            $font-weight-semibold !default;\r\n$pagination-font-size:                              $font-size-lg !default;\r\n$pagination-icon-font-size:                         0.85rem !default;\r\n$pagination-icon-height:                            $pagination-item-height * 0.35 !default;\r\n\r\n$pagination-padding-y:                              .375rem !default;\r\n$pagination-padding-x:                              .75rem !default;\r\n$pagination-padding-y-sm:                           .25rem !default;\r\n$pagination-padding-x-sm:                           .5rem !default;\r\n$pagination-padding-y-lg:                           .75rem !default;\r\n$pagination-padding-x-lg:                           1.5rem !default;\r\n\r\n$pagination-color:                                  $gray-700 !default;\r\n$pagination-color-dark:                             $gray-700-dark !default;\r\n$pagination-bg:                                     transparent !default;\r\n$pagination-bg-dark:                                transparent !default;\r\n$pagination-border-width:                           0 !default;\r\n$pagination-border-radius:                          $btn-border-radius !default;\r\n$pagination-margin-left:                            0 !default;\r\n$pagination-border-color:                           transparent !default;\r\n$pagination-border-color-dark:                      transparent !default;\r\n\r\n$pagination-focus-color:                            $component-hover-color !default;\r\n$pagination-focus-color-dark:                       $component-hover-color-dark !default;\r\n$pagination-focus-bg:                               $component-hover-bg !default;\r\n$pagination-focus-bg-dark:                          $component-hover-bg-dark !default;\r\n$pagination-focus-box-shadow:                       none !default;\r\n$pagination-focus-box-shadow-dark:                  none !default;\r\n$pagination-focus-outline:                          0 !default;\r\n$pagination-focus-outline-dark:                     0 !default;\r\n\r\n$pagination-hover-color:                            $component-hover-color !default;\r\n$pagination-hover-color-dark:                       $component-hover-color-dark !default;\r\n$pagination-hover-bg:                               $component-hover-bg !default;\r\n$pagination-hover-bg-dark:                          $component-hover-bg-dark !default;\r\n$pagination-hover-border-color:                     transparent !default;\r\n$pagination-hover-border-color-dark:                transparent !default;\r\n\r\n$pagination-active-color:                           $component-active-color !default;\r\n$pagination-active-color-dark:                      $component-active-color-dark !default;\r\n$pagination-active-bg:                              $component-active-bg !default;\r\n$pagination-active-bg-dark:                         $component-active-bg-dark !default;\r\n$pagination-active-border-color:                    transparent !default;\r\n$pagination-active-border-color-dark:               transparent !default;\r\n\r\n$pagination-disabled-color:                         $gray-400 !default;\r\n$pagination-disabled-color-dark:                    $gray-400-dark !default;\r\n$pagination-disabled-bg:                            transparent !default;\r\n$pagination-disabled-bg-dark:                       transparent !default;\r\n$pagination-disabled-border-color:                  transparent !default;\r\n$pagination-disabled-border-color-dark:             transparent !default;\r\n\r\n\r\n// Card\r\n$card-bg:                           \t\t\t\t$body-bg !default;\r\n$card-bg-dark:                      \t\t\t\t$body-bg-dark !default;\r\n$card-box-shadow:                   \t\t\t\t0px 0px 20px 0px rgba(76,87,125,0.02) !default;\r\n$card-box-shadow-dark: \t\t\t\t\t\t\t\tnone !default;\r\n$card-border-color:     \t\t\t\t\t\t\t$border-color !default;\r\n$card-border-color-dark:     \t    \t\t\t\t$border-color-dark !default;\r\n$card-border-style:                 \t\t\t\tsolid !default;\r\n$card-border-dashed-color:     \t\t\t\t\t\t$border-dashed-color !default;\r\n$card-border-dashed-color-dark:   \t\t\t\t\t$border-dashed-color-dark !default;\r\n$card-color:\t\t\t\t\t\t\t\t\t\tnull !default;\r\n$card-color-dark:\t\t\t\t\t\t\t\t\tnull !default;\r\n$card-cap-bg:        \t\t\t\t\t\t\t\ttransparent !default;\r\n$card-cap-bg-dark:      \t\t\t\t\t\t\ttransparent !default;\r\n$card-py:      \t\t\t\t        \t\t\t\t2rem !default;\r\n$card-px:     \t\t\t\t\t    \t\t\t\t2.25rem !default;\r\n$card-border-radius:    \t\t\t\t\t\t\t$border-radius-lg !default;\r\n$card-header-py:                   \t\t\t\t\t0.5rem !default;\r\n$card-header-height: \t\t\t\t\t\t\t\t70px !default;\r\n$card-border-enabled:               \t\t\t\tfalse !default;\r\n\r\n\r\n// Accordion\r\n$accordion-color:                               $body-color !default;\r\n$accordion-color-dark:                          $body-color-dark !default;\r\n$accordion-bg:                                  $body-bg !default;\r\n$accordion-bg-dark:                             $body-bg-dark !default;\r\n$accordion-padding-y:                           1.5rem !default;\r\n$accordion-padding-x:                           1.5rem !default;\r\n$accordion-border-color:                        $border-color !default;\r\n$accordion-border-color-dark:                   $border-color-dark !default;\r\n$accordion-border-radius:                       $border-radius !default;\r\n$accordion-button-color:                  \t\t$accordion-color !default;\r\n$accordion-button-color-dark:                  \t$accordion-color-dark !default;\r\n$accordion-button-bg:                           $accordion-bg !default;\r\n$accordion-button-bg-dark:                      $accordion-bg-dark !default;\r\n$accordion-button-active-bg:                    $gray-100 !default;\r\n$accordion-button-active-bg-dark:               $gray-100-dark !default;\r\n$accordion-button-active-color:                 $primary !default;\r\n$accordion-button-active-color-dark:            $primary !default;\r\n\r\n$accordion-button-focus-border-color:           $border-color  !default;\r\n$accordion-button-focus-border-color-dark:      $border-color-dark  !default;\r\n$accordion-button-focus-box-shadow:             none !default;\r\n$accordion-button-focus-box-shadow-dark:        none !default;\r\n\r\n$accordion-icon-width:                          1.15rem !default;\r\n$accordion-icon-color:                          $accordion-button-color !default;\r\n$accordion-icon-color-dark:                     $accordion-button-color-dark !default;\r\n$accordion-icon-active-color:                   $accordion-button-active-color !default;\r\n$accordion-icon-active-color-dark:              $accordion-button-active-color-dark !default;\r\n$accordion-button-icon:                         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\r\n$accordion-button-icon-dark:                    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color-dark}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\r\n$accordion-button-active-icon:                  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\r\n$accordion-button-active-icon-dark:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color-dark}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\r\n\r\n\r\n// Tooltips\r\n$tooltip-font-size:     \t\t\t\t$font-size-sm !default;\r\n$tooltip-max-width:     \t\t\t\t200px !default;\r\n$tooltip-color:      \t\t\t\t    $gray-800 !default;\r\n$tooltip-color-dark:      \t\t\t    $gray-800-dark !default;\r\n$tooltip-bg:      \t\t\t\t        $body-bg !default;\r\n$tooltip-bg-dark:      \t\t\t        $gray-200-dark !default;\r\n$tooltip-border-radius:    \t\t\t\t$btn-border-radius !default;\r\n$tooltip-opacity:       \t\t\t\t1 !default;\r\n$tooltip-opacity-dark:     \t\t\t\t1 !default;\r\n$tooltip-box-shadow:    \t\t\t\t$dropdown-box-shadow !default;\r\n$tooltip-box-shadow-dark:    \t\t\t$dropdown-box-shadow-dark !default;\r\n$tooltip-padding-y:     \t\t\t\t.75rem !default;\r\n$tooltip-padding-x:     \t\t\t\t1rem !default;\r\n$tooltip-margin:     \t\t\t\t    0 !default;\r\n\r\n\r\n// Popovers\r\n$popover-bg:                            $body-bg !default;\r\n$popover-bg-dark:                       $gray-200-dark !default;\r\n$popover-font-size:     \t\t\t\t$font-size-base !default;\r\n$popover-border-color:     \t\t\t\t$popover-bg !default;\r\n$popover-border-color-dark:     \t    $popover-bg-dark !default;\r\n$popover-border-radius:    \t\t\t\t$border-radius !default;\r\n$popover-box-shadow:    \t\t\t\t$dropdown-box-shadow !default;\r\n$popover-box-shadow-dark:    \t\t\t$dropdown-box-shadow-dark !default;\r\n$popover-header-bg:     \t\t\t\t$popover-bg !default;\r\n$popover-header-bg-dark:     \t\t\t$popover-bg-dark !default;\r\n$popover-header-color:     \t\t\t\t$gray-800 !default;\r\n$popover-header-color-dark:     \t\t$gray-800-dark !default;\r\n$popover-header-font-weight:     \t\t500 !default; \r\n$popover-header-font-size:    \t\t\t1rem !default; \r\n$popover-header-padding-y:    \t\t\t1rem !default;\r\n$popover-header-padding-x:    \t\t\t1.25rem !default;\r\n$popover-header-border-color:           $gray-200 !default; \r\n$popover-header-border-color-dark:      $gray-300-dark !default; \r\n$popover-body-color:    \t\t\t\t$gray-800 !default;\r\n$popover-body-color-dark:    \t\t\t$gray-800-dark !default;\r\n$popover-body-padding-y:                1.25rem !default;\r\n$popover-body-padding-x:                1.25rem !default;\r\n\r\n$popover-dissmis-btn-height:            1.5rem !default; \r\n$popover-dissmis-btn-top:               0.85rem !default; \r\n$popover-dissmis-btn-end:               0.85rem !default; \r\n\r\n\r\n// Toasts\r\n$toast-color:                           null !default;\r\n$toast-color-dark:                      null !default;\r\n$toast-background-color:                rgba($white, .85) !default;\r\n$toast-background-color-dark:           rgba($black, .85) !default;\r\n$toast-box-shadow:                      $box-shadow !default;\r\n$toast-box-shadow-dark:                 $box-shadow-dark !default;\r\n$toast-header-color:                    $gray-600 !default;\r\n$toast-header-color-dark:               $gray-600-dark !default;\r\n$toast-header-background-color:         rgba($white, .85) !default;\r\n$toast-header-background-color-dark:    rgba($black, .85) !default;\r\n$toast-header-border-color:             rgba($black, .05) !default;\r\n$toast-header-border-color-dark:        rgba($white, .05) !default;\r\n\r\n\r\n// Badges\r\n$badge-font-size:               0.85rem !default;\r\n$badge-font-size-sm:            0.8rem !default;\r\n$badge-font-size-lg:            1rem !default;\r\n$badge-font-weight:             $font-weight-bold !default;\r\n$badge-color:                   $body-bg !default;\r\n$badge-color-dark:              $body-bg-dark !default;\r\n$badge-padding-y:               .325rem !default;\r\n$badge-padding-x:               .5rem !default;\r\n$badge-border-radius:           $border-radius-sm !default;\r\n$badge-size:                    1.75rem !default;\r\n$badge-size-sm:                 1.5rem !default;\r\n$badge-size-lg:                 2rem !default;\r\n\r\n\r\n// Modals\r\n// Padding applied to the modal body\r\n$modal-inner-padding:     \t\t\t\t\t    1.75rem !default;\r\n\r\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\r\n$modal-footer-margin-between:    \t\t\t\t.5rem !default;\r\n\r\n$modal-dialog-margin:      \t\t\t\t        .5rem !default;\r\n$modal-dialog-margin-y-sm-up:    \t\t\t\t1.75rem !default;\r\n\r\n$modal-content-color:      \t\t\t\t        null !default;\r\n$modal-content-color-dark:   \t\t\t\t    null !default;\r\n$modal-content-bg:      \t\t\t\t        $body-bg !default;\r\n$modal-content-bg-dark:      \t\t\t        $body-bg-dark !default;\r\n$modal-content-border-color:  \t\t\t\t    null !default;\r\n$modal-content-border-color-dark:   \t\t\tnull !default;\r\n$modal-content-border-width:  \t\t\t\t    0 !default;\r\n$modal-content-border-radius:    \t\t\t\t$border-radius !default;\r\n$modal-content-inner-border-radius: \t\t\t$border-radius !default;\r\n$modal-content-box-shadow:    \t\t\t\t    0 .25rem .5rem rgba($black, .05) !default;\r\n$modal-content-box-shadow-dark: \t\t\t\t0 .25rem .5rem rgba($white, .05) !default;\r\n$modal-content-box-shadow-xs:    \t\t\t\t0 .25rem .5rem rgba($black, .1) !default;\r\n$modal-content-box-shadow-xs-dark:    \t\t\t0 .25rem .5rem rgba($white, .1) !default;\r\n$modal-content-box-shadow-sm-up:   \t\t\t\t0 .5rem 1rem rgba($black, .1) !default;\r\n$modal-content-box-shadow-sm-up-dark:   \t\t0 .5rem 1rem rgba($white, .1) !default;\r\n\r\n$modal-backdrop-bg:    \t\t \t\t\t        $black !default;\r\n$modal-backdrop-bg-dark:     \t\t \t\t\t$black !default;\r\n$modal-backdrop-opacity:   \t\t\t\t        0.3 !default;\r\n$modal-backdrop-opacity-dark:   \t\t\t\t0.4 !default;\r\n\r\n$modal-header-border-color:                     $border-color !default;\r\n$modal-header-border-color-dark:                $border-color-dark !default;\r\n$modal-footer-border-color:                     $modal-header-border-color !default;\r\n$modal-footer-border-color-dark:                $modal-header-border-color-dark !default;\r\n$modal-header-border-width:                     1px !default;\r\n\r\n\r\n// Progress bars\r\n$progress-height:                   1rem !default;\r\n$progress-font-size:                $font-size-base * .75 !default;\r\n$progress-bg:                       $gray-100 !default;\r\n$progress-bg-dark:                  $gray-100-dark !default;\r\n$progress-border-radius:            6px !default;\r\n$progress-box-shadow:               none !default;\r\n$progress-box-shadow-dark:          none !default;\r\n\r\n\r\n// List group\r\n$list-group-color:                          $gray-900 !default;\r\n$list-group-color-dark:                     $gray-900-dark !default;\r\n$list-group-bg:                             $white !default;\r\n$list-group-bg-dark:                        $black !default;\r\n$list-group-border-color:                   rgba($black, .125) !default;\r\n$list-group-border-color-dark:              rgba($white, .125) !default;\r\n\r\n$list-group-hover-bg:                       $gray-100 !default;\r\n$list-group-hover-bg-dark:                  $gray-100 !default;\r\n$list-group-active-color:                   $component-active-color !default;\r\n$list-group-active-color-dark:              $component-active-color-dark !default;\r\n$list-group-active-bg:                      $component-active-bg !default;\r\n$list-group-active-bg-dark:                 $component-active-bg-dark !default;\r\n$list-group-active-border-color:            $list-group-active-bg !default;\r\n$list-group-active-border-color-dark:       $list-group-active-bg-dark !default;\r\n\r\n$list-group-disabled-color:                 $gray-600 !default;\r\n$list-group-disabled-color-dark:            $gray-600-dark !default;\r\n$list-group-disabled-bg:                    $list-group-bg !default;\r\n$list-group-disabled-bg-dark:               $list-group-bg-dark !default;\r\n\r\n$list-group-action-color:                   $gray-700 !default;\r\n$list-group-action-color-dark:              $gray-700-dark !default;\r\n$list-group-action-hover-color:             $list-group-action-color !default;\r\n$list-group-action-hover-color-dark:        $list-group-action-color-dark !default;\r\n\r\n$list-group-action-active-color:            $body-color !default;\r\n$list-group-action-active-color-dark:       $body-color-dark !default;\r\n$list-group-action-active-bg:               $gray-200 !default;\r\n$list-group-action-active-bg-dark:          $gray-200-dark !default;\r\n\r\n\r\n// Image thumbnails\r\n$thumbnail-bg:                      $body-bg !default;\r\n$thumbnail-bg-dark:                 $body-bg-dark !default;\r\n$thumbnail-border-color:            $border-color !default;\r\n$thumbnail-border-color-dark:       $border-color-dark !default;\r\n$thumbnail-box-shadow:              $box-shadow-sm !default;\r\n$thumbnail-box-shadow-dark:         $box-shadow-sm-dark !default;\r\n\r\n\r\n// Figures\r\n$figure-caption-color:              $gray-600 !default;\r\n$figure-caption-color-dark:         $gray-600-dark !default;\r\n\r\n\r\n// Breadcrumbs\r\n$breadcrumb-bg:                         null !default;\r\n$breadcrumb-bg-dark:                    null !default;\r\n$breadcrumb-divider-color:              $gray-600 !default;\r\n$breadcrumb-divider-color-dark:         $gray-600-dark !default;\r\n$breadcrumb-active-color:               $primary !default;\r\n$breadcrumb-active-color-dark:          $primary !default;\r\n$breadcrumb-item-padding-x:             .5rem !default;\r\n\r\n\r\n// Carousel\r\n$carousel-custom-indicator-transition-speed:                    0.3s !default;\r\n$carousel-custom-indicator-default-bg-color:                    $gray-200 !default;\r\n$carousel-custom-indicator-default-bg-color-dark:               $gray-200-dark !default;\r\n$carousel-custom-indicator-active-bg-color:                     $gray-400 !default;\r\n$carousel-custom-indicator-active-bg-color-dark:                $gray-400-dark !default;\r\n\r\n$carousel-custom-dots-indicator-default-size:                   9px !default;\r\n$carousel-custom-dots-indicator-active-size:                    13px !default;\r\n\r\n$carousel-custom-bullet-indicator-default-size:                 6px !default;\r\n$carousel-custom-bullet-indicator-active-width:                 16px !default;\r\n$carousel-custom-bullet-indicator-default-bg-color:             $gray-400 !default;\r\n$carousel-custom-bullet-indicator-default-bg-color-dark:        $gray-400-dark !default;\r\n$carousel-custom-bullet-indicator-active-bg-color:              $gray-600 !default;\r\n$carousel-custom-bullet-indicator-active-bg-color-dark:         $gray-600-dark !default;\r\n\r\n\r\n// Spinners\r\n$spinner-border-width:   \t\t\t\t\t.185rem !default;\r\n$spinner-animation-speed:   \t\t\t\t.65s !default;\r\n$spinner-border-width-sm:   \t\t\t\t.145em !default;\r\n\r\n\r\n// Close\r\n$btn-close-width:            \t\t\t\t0.75rem !default;\r\n$btn-close-height:           \t\t\t\t$btn-close-width !default;\r\n$btn-close-color:            \t\t\t\t$black !default;\r\n$btn-close-color-dark:        \t\t\t\t$white !default;\r\n$btn-close-bg:               \t\t\t\turl(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\r\n$btn-close-bg-dark:             \t\t\turl(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color-dark}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\r\n$btn-close-focus-shadow:\t\t\t\t\tnone !default;\r\n\r\n\r\n// Offcanvas\r\n$offcanvas-border-color:                    $modal-content-border-color !default;\r\n$offcanvas-border-color-dark:               $modal-content-border-color-dark !default;\r\n$offcanvas-bg-color:                        $modal-content-bg !default;\r\n$offcanvas-bg-color-dark:                   $modal-content-bg-dark !default;\r\n$offcanvas-color:                           $modal-content-color !default;\r\n$offcanvas-color-dark:                      $modal-content-color-dark !default;\r\n$offcanvas-box-shadow:                      $modal-content-box-shadow-xs !default;\r\n$offcanvas-box-shadow-dark:                 $modal-content-box-shadow-xs-dark !default;\r\n$offcanvas-backdrop-bg:                     $modal-backdrop-bg !default;\r\n$offcanvas-backdrop-bg-dark:                $modal-backdrop-bg-dark !default;\r\n$offcanvas-backdrop-opacity:                $modal-backdrop-opacity !default;\r\n$offcanvas-backdrop-opacity-dark:           $modal-backdrop-opacity-dark !default;\r\n\r\n\r\n// Code\r\n$code-bg:                   #F1F3F8 !default;\r\n$code-bg-dark:              $gray-200-dark !default;\r\n$code-box-shadow:           0px 3px 9px rgba(0, 0, 0, 0.08) !default;\r\n$code-box-shadow-dark:      0px 3px 9px rgba(0, 0, 0, 0.08) !default;\r\n$code-padding:              0.1rem 0.4rem !default;\r\n$code-margin:               0 0.5rem !default;\r\n$code-font-weight:          400 !default;\r\n$code-border-radius:        0.3rem !default; \r\n$code-color:                #b93993 !default; \r\n$code-color-dark:           #b93993 !default; \r\n$code-space:                0.25rem !default;\r\n\r\n// Opacity\r\n$opacity-values: (\r\n\t0: 0,\r\n\t5: .05,\r\n\t10: .1,\r\n\t15: .15,\r\n\t20: .20,\r\n\t25: .25,\r\n\t50: .5,\r\n\t75: .75,\r\n\t100: 1,\r\n ) !default;\r\n\r\n// Zindex\r\n$zindex-values: (\r\n\tn1: -1,\r\n\tn2: -2,\r\n\t0: 0,\r\n\t1: 1,\r\n\t2: 2,\r\n\t3: 3\r\n) !default;\r\n\r\n// Letter spacing\r\n$letter-spacing-values: (\r\n\t1: 0.1rem,\r\n\t2: 0.115rem,\r\n\t3: 0.125rem,\r\n\t4: 0.25rem,\r\n\t5: 0.5rem,\r\n\tn1: -0.1rem,\r\n\tn2: -0.115rem,\r\n\tn3: -0.125rem,\r\n\tn4: -0.25rem,\r\n\tn5: -0.5rem,\r\n) !default;\r\n\r\n// Keenthemes hight and width sizes\r\n$custom-sizes: (\r\n\tunset: unset,\r\n\t25: 25%,\r\n\t50: 50%,\r\n\t75: 75%,\r\n\t100: 100%,\r\n\tauto: auto,\r\n\t1px: 1px,\r\n\t2px: 2px,\r\n\t3px: 3px,\r\n\t4px: 4px,\r\n\t5px: 5px,\r\n\t6px: 6px,\r\n\t7px: 7px,\r\n\t8px: 8px,\r\n\t9px: 9px,\r\n\t10px: 10px,\r\n\t15px: 15px,\r\n\t20px: 20px,\r\n\t25px: 25px,\r\n\t30px: 30px,\r\n\t35px: 35px,\r\n\t40px: 40px,\r\n\t45px: 45px,\r\n\t50px: 50px,\r\n\t55px: 55px,\r\n\t60px: 60px,\r\n\t65px: 65px,\r\n\t70px: 70px,\r\n\t75px: 75px,\r\n\t80px: 80px,\r\n\t85px: 85px,\r\n\t90px: 90px,\r\n\t95px: 95px,\r\n\t100px: 100px,\r\n\t125px: 125px,\r\n\t150px: 150px,\r\n\t175px: 175px,\r\n\t200px: 200px,\r\n\t225px: 225px,\r\n\t250px: 250px,\r\n\t275px: 275px,\r\n\t300px: 300px,\r\n\t325px: 325px,\r\n\t350px: 350px,\r\n\t375px: 375px,\r\n\t400px: 400px,\r\n\t425px: 425px,\r\n\t450px: 450px,\r\n\t475px: 475px,\r\n\t500px: 500px,\r\n\t550px: 550px,\r\n\t600px: 600px,\r\n\t650px: 650px,\r\n\t700px: 700px,\r\n\t750px: 750px,\r\n\t800px: 800px,\r\n\t850px: 850px,\r\n\t900px: 900px,\r\n\t950px: 950px,\r\n\t1000px: 1000px\r\n) !default;\r\n\r\n\r\n// Keenthemes symbol component\r\n$symbol-sizes: (\r\n\t20px: 20px,\r\n\t25px: 25px,\r\n\t30px: 30px,\r\n\t35px: 35px,\r\n\t40px: 40px,\r\n\t45px: 45px,\r\n\tdefault: 50px,\r\n\t50px: 50px,\r\n\t55px: 55px,\r\n\t60px: 60px,\r\n\t65px: 65px,\r\n\t70px: 70px,\r\n\t75px: 75px,\r\n\t90px: 90px,\r\n\t100px:100px,\r\n\t125px:125px,\r\n\t150px:150px,\r\n\t160px:160px,\r\n\t175px:175px,\r\n\t200px:200px\r\n) !default;\r\n\r\n$symbol-border-color: rgba($body-bg, 0.5);\r\n$symbol-border-color-dark: rgba($body-bg, 0.5);\r\n$symbol-label-color: $gray-800;\r\n$symbol-label-color-dark: $gray-800-dark;\r\n$symbol-label-bg: $gray-100;\r\n$symbol-label-bg-dark: $gray-100-dark;\r\n\r\n\r\n// Keenthemes bullet component\r\n$bullet-bg-color: $gray-400 !default;\r\n$bullet-bg-color-dark: $gray-400-dark !default;\r\n$bullet-dot-size: 4px !default;\r\n$bullet-bar-height: 4px !default;\r\n$bullet-bar-width: 8px !default;\r\n$bullet-bar-border-radius: 6px !default;\r\n$bullet-line-height: 1px !default;\r\n$bullet-line-width: 5px !default;\r\n\r\n\r\n// Keenthemes scrolltop component\r\n$scrolltop-z-index: 105 !default;\r\n$scrolltop-opacity: 0 !default;\r\n$scrolltop-opacity-dark: 0 !default;\r\n$scrolltop-opacity-on: 0.3 !default;\r\n$scrolltop-opacity-on-dark: 0.3 !default;\r\n$scrolltop-opacity-hover: 1 !default;\r\n$scrolltop-opacity-hover-dark: 1 !default;\r\n$scrolltop-bottom: 40px !default;\r\n$scrolltop-bottom-mobile: 30px !default;\r\n$scrolltop-end: 20px !default;\r\n$scrolltop-end-mobile: 15px !default;\r\n$scrolltop-size: 36px !default;\r\n$scrolltop-size-mobile: 30px !default;\r\n$scrolltop-box-shadow: $box-shadow !default;\r\n$scrolltop-box-shadow-dark: $box-shadow-dark !default;\r\n$scrolltop-bg-color: $primary !default;\r\n$scrolltop-bg-color-dark: $primary !default;\r\n$scrolltop-bg-color-hover: $primary !default;\r\n$scrolltop-bg-color-hover-dark: $primary !default;\r\n$scrolltop-icon-color: $primary-inverse !default;\r\n$scrolltop-icon-color-dark: $primary-inverse !default;\r\n$scrolltop-icon-color-hover: $primary-inverse !default;\r\n$scrolltop-icon-color-hover-dark: $primary-inverse !default;\r\n\r\n\r\n// Keenthemes sticky toolbar component\r\n$sticky-toolbar-z-index: 95 !default;\r\n\r\n\r\n// Keenthemes drawer component\r\n$drawer-z-index: 110 !default;\r\n$drawer-box-shadow: 0px 1px 9px -3px rgba(0,0,0, 0.05) !default;\r\n$drawer-box-shadow-dark: 0px 0px 30px rgba(0, 0, 0, 0.1) !default;\r\n$drawer-bg-color: $body-bg !default;\r\n$drawer-bg-color-dark: $body-bg-dark !default;\r\n$drawer-transition-speed: 0.3s !default;\r\n$drawer-overlay-bg-color: rgba($black, 0.2) !default;\r\n$drawer-overlay-bg-color-dark: rgba($black, 0.4) !default;\r\n$drawer-overlay-animation-speed: 0.3s !default;\r\n\r\n// Keenthemes menu component   \r\n$menu-dropdown-box-shadow: $dropdown-box-shadow !default;\r\n$menu-dropdown-box-shadow-dark: $dropdown-box-shadow-dark !default;\r\n$menu-dropdown-z-index: 107 !default;\r\n$menu-dropdown-bg-color: $dropdown-bg !default;\r\n$menu-dropdown-bg-color-dark: $dropdown-bg-dark !default;\r\n$menu-dropdown-border-radius: $dropdown-border-radius !default;\r\n$menu-dropdown-animation: true !default;\r\n$menu-dropdown-animation-speed: 0.3s !default;\r\n$menu-dropdown-animation-move-offset: 0.75rem !default;\r\n$menu-accordion-indention: 1rem !default;\r\n$menu-accordion-arrow-transition: transform 0.3s ease !default;\r\n$menu-item-padding-y: 0.15rem !default;\r\n$menu-item-padding-x: 0 !default;\r\n$menu-link-padding-y: 0.65rem !default;\r\n$menu-link-padding-x: 1rem !default;\r\n$menu-link-border-radius: $border-radius !default;\r\n$menu-link-color-hover: $component-hover-color !default;\r\n$menu-link-color-hover-dark: $component-hover-color-dark !default;\r\n$menu-link-color-show: $component-hover-color !default;\r\n$menu-link-color-show-dark: $component-hover-color-dark !default;\r\n$menu-link-color-here: $component-hover-color !default;\r\n$menu-link-color-here-dark: $component-hover-color-dark !default;\r\n$menu-link-color-active: $component-hover-color !default;\r\n$menu-link-color-active-dark: $component-hover-color-dark !default;\r\n$menu-link-bg-color-hover: $component-hover-bg !default;\r\n$menu-link-bg-color-hover-dark: $component-hover-bg-dark !default;\r\n$menu-link-bg-color-show: $component-hover-bg !default;\r\n$menu-link-bg-color-show-dark: $component-hover-bg-dark !default;\r\n$menu-link-bg-color-here: $component-hover-bg !default;\r\n$menu-link-bg-color-here-dark: $component-hover-bg-dark !default;\r\n$menu-link-bg-color-active: $component-hover-bg !default;\r\n$menu-link-bg-color-active-dark: $component-hover-bg-dark !default;\r\n$menu-icon-size: 2rem !default;\r\n$menu-icon-space: 0.5rem !default;\r\n$menu-bullet-size: 1.25rem !default;\r\n$menu-bullet-space: 0.5rem !default;\r\n$menu-badge-space: 0.5rem !default;\r\n$menu-arrow-size: 9px !default;\r\n$menu-arrow-space: 5px !default;\r\n$menu-heading-color: $text-muted !default;\r\n$menu-heading-color-dark: $text-muted-dark !default;\r\n\r\n// Keenthemes feedback component \r\n$feedback-popup-z-index: 1000 !default;\r\n$feedback-popup-box-shadow: $dropdown-box-shadow !default;\r\n$feedback-popup-box-shadow-dark: $dropdown-box-shadow-dark !default;\r\n$feedback-popup-background-color: $body-bg !default;\r\n$feedback-popup-background-color-dark: $body-bg-dark !default;\r\n$feedback-popup-border-radius: $border-radius !default;\r\n$feedback-popup-transition-speed: 0.6s !default;\r\n$feedback-popup-padding: 1rem 1.25rem !default;\r\n\r\n// Keenthemes scrollbar component \r\n$scrollbar-space: 0.5rem !default;\r\n$scrollbar-border-radius: 0.5rem !default;\r\n$scrollbar-width: 0.4rem !default;\r\n$scrollbar-height: 0.4rem !default;\r\n$scrollbar-color: $gray-200 !default;\r\n$scrollbar-color-dark: $gray-200-dark !default;\r\n$scrollbar-hover-color: darken($gray-200, 2%) !default;\r\n$scrollbar-hover-color-dark: darken($gray-200-dark, 2%) !default;\r\n\r\n// Keenthemes overlay component \r\n$overlay-bg: rgba($black, 0.05)  !default;\r\n$overlay-bg-dark: rgba($white, 0.05) !default;\r\n\r\n// Keenthemes blockui component \r\n$blockui-overlay-bg: rgba($black, 0.05) !default;\r\n$blockui-overlay-bg-dark: rgba($white, 0.05) !default;\r\n\r\n// Keenthemes rating component \r\n$rating-color-default: $gray-400 !default;\r\n$rating-color-default-dark: $gray-400-dark !default;\r\n$rating-color-active: #FFAD0F !default;\r\n$rating-color-active-dark: #FFAD0F !default;\r\n\r\n// Keenthemes ribbon component \r\n$ribbon-label-box-shadow: 0px -1px 5px 0px rgba($dark, 0.1) !default;\r\n$ribbon-label-box-shadow-dark: 0px -1px 5px 0px rgba($white, 0.1) !default;\r\n$ribbon-label-bg: $primary !default;\r\n$ribbon-label-bg-dark: $primary !default;\r\n$ribbon-label-border-color: darken($primary, 20%) !default;\r\n$ribbon-label-border-color-dark: darken($primary, 20%) !default;\r\n$ribbon-clip-bg: $dark !default;\r\n$ribbon-clip-bg-dark: $light !default;\r\n\r\n// Keenthemes fixed component \r\n$fixed-z-index: 101 !default;\r\n\r\n// Engage panel\r\n$engage-btn-bg: $body-bg;\r\n$engage-btn-bg-dark: $gray-200-dark;\r\n$engage-btn-color: $gray-600;\r\n$engage-btn-color-dark: $gray-600-dark;\r\n$engage-btn-color-active: $gray-800;\r\n$engage-btn-color-active-dark: $gray-800-dark;\r\n\r\n// Social Network Colors Used With Boostrap Buttons(see: https://brandcolors.net)\r\n$social-colors: (\r\n\tfacebook: (\r\n\t\tbase: #3b5998,\r\n\t\tinverse: #ffffff,\r\n\t\tlight: rgba(#3b5998, 0.1),\r\n\t\tactive: darken(#3b5998, 7.5%)\r\n\t),\r\n\tgoogle: (\r\n\t\tbase: #dd4b39,\r\n\t\tinverse: #ffffff,\r\n\t\tlight: rgba(#dd4b39, 0.1),\r\n\t\tactive: darken(#dd4b39, 7.5%)\r\n\t),\r\n\ttwitter: (\r\n\t\tbase: #1da1f2,\r\n\t\tinverse: #ffffff,\r\n\t\tlight: rgba(#1da1f2, 0.1),\r\n\t\tactive: darken(#1da1f2, 7.5%)\r\n\t),\r\n\tinstagram: (\r\n\t\tbase: #e1306c,\r\n\t\tinverse: #ffffff,\r\n\t\tlight: rgba(#e1306c, 0.1),\r\n\t\tactive: darken(#e1306c, 7.5%)\r\n\t),\r\n\tyoutube: (\r\n\t\tbase: #ff0000,\r\n\t\tinverse: #ffffff,\r\n\t\tlight: rgba(#ff0000, 0.1),\r\n\t\tactive: darken(#ff0000, 7.5%)\r\n\t),\r\n\tlinkedin: (\r\n\t\tbase: #0077b5,\r\n\t\tinverse: #ffffff,\r\n\t\tlight: rgba(#0077b5, 0.1),\r\n\t\tactive: darken(#0077b5, 7.5%)\r\n\t)\r\n) !default;","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","//\r\n// To make future updates easier consider overriding the global variables from _variables.bootstrap.scss and _variables.custom.scss for current demo in this file.\r\n// Note that this file is included first and variables defined in _variables.bootstrap.scss and _variables.custom.scss\r\n// are not accessible in this file but you can override any global variable as shown below:\r\n//\r\n\r\n// Bootstrap color system\r\n$white: \t\t\t\t\t\t\t\t\t\t\t#ffffff;\r\n\r\n// Theme colors\r\n// Primary\r\n$primary:       \t\t\t\t\t\t\t\t\t#009ef7;\r\n$primary-active:    \t\t\t\t\t\t\t\t#0095e8;\r\n$primary-light:    \t\t\t\t\t\t\t\t    #f1faff;\r\n$primary-light-dark:    \t\t\t\t\t\t\t#212e48;\r\n$primary-inverse:  \t\t\t\t\t\t\t\t\t$white;\r\n\r\n// Success\r\n$success:       \t\t\t\t\t\t\t\t\t#50cd89;\r\n$success-active:    \t\t\t\t\t\t\t\t#47be7d;\r\n$success-light:    \t\t\t\t\t\t\t\t\t#e8fff3;\r\n$success-light-dark:    \t\t\t\t\t\t\t#1c3238;\r\n$success-inverse:  \t\t\t\t\t\t\t\t\t$white;\r\n\r\n// Info\r\n$info:       \t\t\t\t\t\t\t\t\t    #7239ea;\r\n$info-active:    \t\t\t\t\t\t\t\t\t#5014d0;\r\n$info-light:    \t\t\t\t\t\t\t\t\t#f8f5ff;\r\n$info-light-dark:    \t\t\t\t\t\t\t\t#2f264f;\r\n$info-inverse:  \t\t\t\t\t\t\t\t\t$white;\r\n\r\n// Danger\r\n$danger:       \t\t\t\t\t\t\t\t\t    #f1416c;\r\n$danger-active:    \t\t\t\t\t\t\t\t\t#E32539;\r\n$danger-light:    \t\t\t\t\t\t\t\t\t#fff5f8;\r\n$danger-light-dark:    \t\t\t\t\t\t\t\t#3a2434;\r\n$danger-inverse:  \t\t\t\t\t\t\t\t\t$white;\r\n\r\n// Warning\r\n$warning:       \t\t\t\t\t\t\t\t\t#ffc700;\r\n$warning-active:    \t\t\t\t\t\t\t\t#f1bc00;\r\n$warning-light:    \t\t\t\t\t\t\t\t\t#fff8dd;\r\n$warning-light-dark:    \t\t\t\t\t\t\t#392f28;\r\n$warning-inverse:  \t\t\t\t\t\t\t\t\t$white;","@mixin box-shadow($shadow...) {\n  @if $enable-shadows {\n    $result: ();\n\n    @each $value in $shadow {\n      @if $value != null {\n        $result: append($result, $value, \"comma\");\n      }\n      @if $value == none and length($shadow) > 1 {\n        @warn \"The keyword 'none' must be used as a single argument.\";\n      }\n    }\n\n    @if (length($result) > 0) {\n      box-shadow: $result;\n    }\n  }\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  color: var(--#{$prefix}table-color);\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-accent-bg);\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: ($table-border-width * 2) solid $table-group-separator-color;\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-striped-bg);\n    color: var(--#{$prefix}table-striped-color);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-striped-bg);\n    color: var(--#{$prefix}table-striped-color);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-accent-bg: var(--#{$prefix}table-active-bg);\n  color: var(--#{$prefix}table-active-color);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-hover-bg);\n    color: var(--#{$prefix}table-hover-color);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  background-color: $form-select-bg;\n  background-image: escape-svg($form-select-indicator);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n  appearance: none;\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  background-color: $form-check-input-bg;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  appearance: none;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-input-checked-bg-image);\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-radio-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-radio-checked-bg-image);\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image), var(--#{$prefix}gradient);\n    } @else {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image);\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: escape-svg($form-switch-bg-image);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      background-image: escape-svg($form-switch-focus-bg-image);\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        background-image: escape-svg($form-switch-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-switch-checked-bg-image);\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: -$input-border-width;\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity)\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-image: escape-svg($form-select-indicator), escape-svg($icon);\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$body-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($primary), $primary, 15%))};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down {\n  border-top: $caret-width solid;\n  border-right: $caret-width solid transparent;\n  border-bottom: 0;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-up {\n  border-top: 0;\n  border-right: $caret-width solid transparent;\n  border-bottom: $caret-width solid;\n  border-left: $caret-width solid transparent;\n}\n\n@mixin caret-end {\n  border-top: $caret-width solid transparent;\n  border-right: 0;\n  border-bottom: $caret-width solid transparent;\n  border-left: $caret-width solid;\n}\n\n@mixin caret-start {\n  border-top: $caret-width solid transparent;\n  border-right: $caret-width solid;\n  border-bottom: $caret-width solid transparent;\n}\n\n@mixin caret($direction: down) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $caret-spacing;\n      vertical-align: $caret-vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down();\n      } @else if $direction == up {\n        @include caret-up();\n      } @else if $direction == end {\n        @include caret-end();\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $caret-spacing;\n        vertical-align: $caret-vertical-align;\n        content: \"\";\n        @include caret-start();\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    background: none;\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n\n    &.disabled,\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == ($pagination-border-width * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $state, $value in $theme-colors {\n  $alert-background: shift-color($value, $alert-bg-scale);\n  $alert-border: shift-color($value, $alert-border-scale);\n  $alert-color: shift-color($value, $alert-color-scale);\n\n  @if (contrast-ratio($alert-background, $alert-color) < $min-contrast-ratio) {\n    $alert-color: mix($value, color-contrast($alert-background), abs($alert-color-scale));\n  }\n  .alert-#{$state} {\n    @include alert-variant($alert-background, $alert-border, $alert-color);\n  }\n}\n// scss-docs-end alert-modifiers\n","// scss-docs-start alert-variant-mixin\n@mixin alert-variant($background, $border, $color) {\n  --#{$prefix}alert-color: #{$color};\n  --#{$prefix}alert-bg: #{$background};\n  --#{$prefix}alert-border-color: #{$border};\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n\n  .alert-link {\n    color: shade-color($color, 20%);\n  }\n}\n// scss-docs-end alert-variant-mixin\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $value in $theme-colors {\n  $list-group-variant-bg: shift-color($value, $list-group-item-bg-scale);\n  $list-group-variant-color: shift-color($value, $list-group-item-color-scale);\n  @if (contrast-ratio($list-group-variant-bg, $list-group-variant-color) < $min-contrast-ratio) {\n    $list-group-variant-color: mix($value, color-contrast($list-group-variant-bg), abs($list-group-item-color-scale));\n  }\n\n  @include list-group-item-variant($state, $list-group-variant-bg, $list-group-variant-color);\n}\n// scss-docs-end list-group-modifiers\n","// List Groups\n\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      &:hover,\n      &:focus {\n        color: $color;\n        background-color: shade-color($background, 10%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n// scss-docs-end list-group-mixin\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: $btn-close-color;\n  background: transparent escape-svg($btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: $btn-close-opacity;\n\n  // Override <a>'s hover style\n  &:hover {\n    color: $btn-close-color;\n    text-decoration: none;\n    opacity: $btn-close-hover-opacity;\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-close-focus-shadow;\n    opacity: $btn-close-focus-opacity;\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: $btn-close-disabled-opacity;\n  }\n}\n\n.btn-close-white {\n  filter: $btn-close-white-filter;\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  padding: var(--#{$prefix}tooltip-arrow-height);\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: 0;\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: 0;\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: 0;\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: 0;\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n/* rtl:begin:ignore */\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n/* rtl:end:ignore */\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(transform $offcanvas-transition-duration ease-in-out);\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: $offcanvas-title-line-height;\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// stylelint-disable function-name-case\n\n// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  $color-rgb: to-rgb($value);\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA($color-rgb, var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: $value !important; // stylelint-disable-line declaration-no-important\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage)) !important; // stylelint-disable-line declaration-no-important\n      }\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","//\r\n// CSS Variables\r\n//\r\n\r\n:root,\r\n[data-theme=\"light\"] {\r\n    // Breakpoints\r\n    @each $breakpoint, $value in $grid-breakpoints {\r\n        --kt-#{$breakpoint}:#{$value};\r\n    }\r\n\r\n    // Bootstrap color system\r\n    --kt-white: #{$white};\r\n    --kt-white-bg-rgb: #{to-rgb($white)};\r\n    --kt-black: #{$black};\r\n    --kt-black-bg-rgb: #{to-rgb($black)};\r\n\r\n    // Bootstrap muted color\r\n    --kt-text-muted: #{$text-muted};\r\n\r\n    // Grey colors\r\n    @each $name, $value in $grays {\r\n        --kt-gray-#{$name}: #{$value};\r\n    }\r\n\r\n    // Grey rgba colors\r\n    @each $name, $value in $grays {\r\n        --kt-gray-#{$name}-rgb: #{to-rgb($value)};\r\n    }\r\n\r\n    // Contextual colors\r\n    @each $name, $value in $theme-colors {\r\n        --kt-#{$name}: #{$value};\r\n    }\r\n\r\n    // Contextual active state colors\r\n    @each $name, $value in $theme-active-colors {\r\n        --kt-#{$name}-active: #{$value};\r\n    }\r\n\r\n    // Contextual light state colors\r\n    @each $name, $value in $theme-light-colors {\r\n        --kt-#{$name}-light: #{$value};\r\n    }\r\n\r\n    // Contextual inverse state colors\r\n    @each $name, $value in $theme-inverse-colors {\r\n        --kt-#{$name}-inverse: #{$value};\r\n    }\r\n\r\n    // Contextual rbg colors\r\n    @each $name, $value in $theme-colors {\r\n        --kt-#{$name}-rgb: #{to-rgb($value)};\r\n    }\r\n\r\n    // Text colors\r\n    @each $name, $value in $theme-text-colors {\r\n        --kt-text-#{$name}: #{$value};\r\n    }\r\n\r\n    // Body\r\n    --kt-body-bg: #{$body-bg};\r\n    --kt-body-bg-rgb: #{to-rgb($body-bg)};\r\n    --kt-body-color: #{$body-color};\r\n\r\n    // Links\r\n    --kt-link-color: #{$link-color};\r\n    --kt-link-hover-color: #{$link-hover-color};\r\n\r\n    // Components\r\n    --kt-border-color: #{$border-color};\r\n    --kt-border-dashed-color: #{$border-dashed-color};\r\n\r\n    --kt-component-active-color: #{$component-active-color};\r\n    --kt-component-active-bg: #{$component-active-bg};\r\n    --kt-component-hover-color: #{$component-hover-color};\r\n    --kt-component-hover-bg: #{$component-hover-bg};\r\n    --kt-component-checked-color: #{$component-checked-color};\r\n    --kt-component-checked-bg: #{$component-checked-bg};\r\n\r\n    // Box shadow\r\n    --kt-box-shadow-xs: #{$box-shadow-xs};\r\n    --kt-box-shadow-sm: #{$box-shadow-sm};\r\n    --kt-box-shadow: #{$box-shadow};\r\n    --kt-box-shadow-lg: #{$box-shadow-lg};\r\n\r\n    // Typography\r\n    --kt-headings-color: #{$headings-color};\r\n\r\n    // Tables\r\n    --kt-table-color: #{$table-color};\r\n    --kt-table-bg: #{$table-bg};\r\n    --kt-table-striped-color: #{$table-striped-color};\r\n    --kt-table-striped-bg: #{$table-striped-bg};\r\n    --kt-table-accent-bg: #{$table-accent-bg};\r\n    --kt-table-active-color: #{$table-active-color};\r\n    --kt-table-active-bg: #{$table-active-bg};\r\n    --kt-table-hover-colorr: #{$table-hover-color};\r\n    --kt-table-hover-bg: #{$table-hover-bg};\r\n    --kt-table-border-color: #{$table-border-color};\r\n    --kt-table-caption-color: #{$table-caption-color};\r\n\r\n    --kt-table-loading-message-box-shadow: #{$table-loading-message-box-shadow};\r\n    --kt-table-loading-message-bg: #{$table-loading-message-bg};\r\n    --kt-table-loading-message-color: #{$table-loading-message-color};\r\n\r\n    // Buttons + Forms\r\n    --kt-input-btn-focus-color: #{$input-btn-focus-color};\r\n    --kt-input-btn-focus-box-shadow: #{$input-btn-focus-box-shadow};\r\n    --kt-input-btn-focus-color-opacity: #{$input-btn-focus-color-opacity};\r\n\r\n    --kt-input-color: #{$input-color};\r\n    --kt-input-placeholder-color: #{$input-placeholder-color};\r\n    --kt-input-plaintext-color: #{$input-plaintext-color};\r\n\r\n    // Buttons\r\n    --kt-btn-box-shadow: #{$btn-box-shadow};\r\n    --kt-btn-focus-box-shadow: #{$btn-focus-box-shadow};\r\n    --kt-btn-active-box-shadow: #{$btn-active-box-shadow};\r\n    --kt-btn-disabled-opacity: #{$btn-disabled-opacity};\r\n\r\n    --kt-btn-link-color: #{$btn-link-color};\r\n    --kt-btn-link-hover-color: #{$btn-link-hover-color};\r\n    --kt-btn-link-disabled-color: #{$btn-link-disabled-color};\r\n\r\n    // Forms\r\n    --kt-form-label-color: #{$form-label-color};\r\n    --kt-form-text-color: #{$form-text-color};\r\n\r\n    --kt-input-bg: #{$input-bg};\r\n    --kt-input-disabled-bg: #{$input-disabled-bg};\r\n    --kt-input-disabled-color: #{$input-disabled-color};\r\n    --kt-input-disabled-border-color: #{$input-disabled-border-color};\r\n\r\n    --kt-input-color: #{$input-color};\r\n    --kt-input-border-color: #{$input-border-color};\r\n\r\n    --kt-input-focus-bg: #{$input-focus-bg};\r\n    --kt-input-focus-border-color: #{$input-focus-border-color};\r\n    --kt-input-focus-color: #{$input-focus-color};\r\n\r\n    // Keenthemes solid input style\r\n    --kt-input-solid-bg: #{$input-solid-bg};\r\n    --kt-input-solid-bg-focus: #{$input-solid-bg-focus};\r\n    --kt-input-solid-placeholder-color: #{$input-solid-placeholder-color};\r\n    --kt-input-solid-color: #{$input-solid-color};\r\n\r\n    // Form checks\r\n    --kt-form-check-label-color: #{$form-check-label-color};\r\n    --kt-form-check-label-color-checked: #{$form-check-label-color-checked};\r\n    --kt-form-check-input-active-filter: #{$form-check-input-active-filter};\r\n\r\n    --kt-form-check-input-bg: #{$form-check-input-bg};\r\n    --kt-form-check-input-bg-solid: #{$form-check-input-bg-solid};\r\n    --kt-form-check-input-border: #{$form-check-input-border};\r\n    --kt-form-check-input-focus-border: #{$form-check-input-focus-border};\r\n    --kt-form-check-input-focus-box-shadow: #{$form-check-input-focus-box-shadow};\r\n\r\n    --kt-form-check-input-checked-color: #{$form-check-input-checked-color};\r\n    --kt-form-check-input-checked-bg-color: #{$form-check-input-checked-bg-color};\r\n    --kt-form-check-input-checked-bg-color-solid: #{$form-check-input-checked-bg-color-solid};\r\n    --kt-form-check-input-checked-border-color: #{$form-check-input-checked-border-color};\r\n    --kt-form-check-input-checked-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\r\n    --kt-form-check-radio-checked-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\r\n    \r\n    --kt-form-check-input-indeterminate-color: #{$form-check-input-indeterminate-color};\r\n    --kt-form-check-input-indeterminate-bg-color: #{$form-check-input-indeterminate-bg-color};\r\n    --kt-form-check-input-indeterminate-border-color: #{$form-check-input-indeterminate-border-color};\r\n    --kt-form-check-input-indeterminate-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\r\n\r\n    --kt-form-check-input-disabled-opacity: #{$form-check-input-disabled-opacity};\r\n    --kt-form-check-label-disabled-opacity: #{$form-check-label-disabled-opacity};\r\n    --kt-form-check-btn-check-disabled-opacity: #{$form-check-btn-check-disabled-opacity};\r\n\r\n    --kt-form-switch-color: #{$form-switch-color};\r\n    --kt-form-switch-color-solid: #{$form-switch-color-solid};\r\n    --kt-form-switch-bg-image: #{escape-svg($form-switch-bg-image)};\r\n    --kt-form-switch-bg-image-solid: #{escape-svg($form-switch-bg-image-solid)};\r\n    --kt-form-switch-focus-color: #{$form-switch-focus-color};\r\n    --kt-form-switch-focus-bg-image: #{escape-svg($form-switch-focus-bg-image)};\r\n    --kt-form-switch-checked-color: #{$form-switch-checked-color};\r\n    --kt-form-switch-checked-bg-image: #{escape-svg($form-switch-checked-bg-image)};\r\n\r\n    // Input groups\r\n    --kt-input-group-addon-color: #{$input-group-addon-color};\r\n    --kt-input-group-addon-bg: #{$input-group-addon-bg};\r\n    --kt-input-group-addon-border-color: #{$input-group-addon-border-color};\r\n\r\n    // Form select\r\n    --kt-form-select-color: #{$form-select-color};\r\n    --kt-form-select-bg: #{$form-select-bg};\r\n    --kt-form-select-disabled-color: #{$form-select-disabled-color};\r\n    --kt-form-select-disabled-bg: #{$form-select-disabled-bg};\r\n    --kt-form-select-disabled-border-color: #{$form-select-disabled-border-color};\r\n    --kt-form-select-indicator-color: #{$form-select-indicator-color};\r\n    --kt-form-select-indicator: #{escape-svg($form-select-indicator)};\r\n    --kt-form-select-border-color: #{$form-select-border-color};\r\n    --kt-form-select-box-shadow: #{$form-select-box-shadow};\r\n    --kt-form-select-focus-border-color: #{$form-select-focus-border-color};\r\n    --kt-form-select-focus-box-shadow: #{$form-select-focus-box-shadow};\r\n\r\n    // Form file button\r\n    --kt-form-file-button-color: #{$form-file-button-color};\r\n    --kt-form-file-button-bg: #{$form-file-button-bg};\r\n    --kt-form-file-button-hover-bg: #{$form-file-button-hover-bg};\r\n\r\n    // Navs\r\n    --kt-nav-tabs-border-color: #{$nav-tabs-border-color};\r\n    --kt-nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\r\n    --kt-nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\r\n    --kt-nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\r\n    --kt-nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\r\n\r\n    --kt-nav-pills-link-active-color: #{$nav-pills-link-active-color};\r\n    --kt-nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\r\n\r\n    // Dropdowns        \r\n    --kt-dropdown-color: #{$dropdown-color};\r\n    --kt-dropdown-bg: #{$dropdown-bg};\r\n    --kt-dropdown-divider-bg: #{$dropdown-divider-bg};\r\n    --kt-dropdown-box-shadow: #{$dropdown-box-shadow};\r\n    --kt-dropdown-link-color: #{$dropdown-link-color};\r\n    --kt-dropdown-link-hover-color: #{$dropdown-link-hover-color};\r\n    --kt-dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\r\n    --kt-dropdown-link-active-color: #{$dropdown-link-active-color};\r\n    --kt-dropdown-link-active-bg: #{$dropdown-link-active-bg};\r\n    --kt-dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\r\n    --kt-dropdown-header-color: #{$dropdown-header-color};\r\n\r\n    // Pagination\r\n    --kt-pagination-item-bg: #{$pagination-item-bg};\r\n    --kt-pagination-color: #{$pagination-color};\r\n    --kt-pagination-bg: #{$pagination-bg};\r\n    --kt-pagination-border-color: #{$pagination-border-color};\r\n    --kt-pagination-focus-color: #{$pagination-focus-color};\r\n    --kt-pagination-focus-bg: #{$pagination-focus-bg};\r\n    --kt-pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\r\n    --kt-pagination-focus-outline: #{$pagination-focus-outline};\r\n    --kt-pagination-hover-color: #{$pagination-hover-color};\r\n    --kt-pagination-hover-bg: #{$pagination-hover-bg};\r\n    --kt-pagination-hover-border-color: #{$pagination-hover-border-color};\r\n    --kt-pagination-active-color: #{$pagination-active-color};\r\n    --kt-pagination-active-bg: #{$pagination-active-bg};\r\n    --kt-pagination-active-border-color: #{$pagination-active-border-color};\r\n    --kt-pagination-disabled-color: #{$pagination-disabled-color};\r\n    --kt-pagination-disabled-bg: #{$pagination-disabled-bg};\r\n\r\n    // Card\r\n    --kt-card-color: #{$card-color-dark};\r\n    --kt-card-bg: #{$card-bg};\r\n    --kt-card-box-shadow: #{$card-box-shadow};\r\n    --kt-card-border-color: #{$card-border-color};\r\n    --kt-card-border-dashed-color: #{$card-border-dashed-color};\r\n    --kt-card-cap-bg: #{$card-cap-bg};\r\n\r\n    // Accordion\r\n    --kt-accordion-color: #{$accordion-color};\r\n    --kt-accordion-bg: #{$accordion-bg};\r\n    --kt-accordion-border-color: #{$accordion-border-color}; \r\n    --kt-accordion-button-bg: #{$accordion-button-bg};   \r\n    --kt-accordion-button-color: #{$accordion-button-color};\r\n    --kt-accordion-button-active-bg: #{$accordion-button-active-bg};   \r\n    --kt-accordion-button-active-color: #{$accordion-button-active-color};\r\n    --kt-accordion-button-focus-border-color: #{$accordion-button-focus-border-color};\r\n    --kt-accordion-button-focus-box-shadow: #{$accordion-button-focus-box-shadow};\r\n\r\n    --kt-accordion-icon-color: #{$accordion-icon-color};\r\n    --kt-accordion-icon-active-color: #{$accordion-icon-active-color};\r\n    --kt-accordion-button-icon: #{escape-svg($accordion-button-icon)};\r\n    --kt-accordion-button-active-icon: #{escape-svg($accordion-button-active-icon)};\r\n\r\n    // Tooltips\r\n    --kt-tooltip-color: #{$tooltip-color};\r\n    --kt-tooltip-bg: #{$tooltip-bg};\r\n    --kt-tooltip-opacity: #{$tooltip-opacity};\r\n    --kt-tooltip-box-shadow: #{$tooltip-box-shadow};\r\n   \r\n    // Popovers\r\n    --kt-popover-bg: #{$popover-bg};\r\n    --kt-popover-border-color: #{$popover-border-color};\r\n    --kt-popover-box-shadow: #{$popover-box-shadow};\r\n    --kt-popover-header-bg: #{$popover-header-bg};\r\n    --kt-popover-header-color: #{$popover-header-color};\r\n    --kt-popover-header-border-color: #{$popover-header-border-color};\r\n    --kt-popover-body-color: #{$popover-body-color};\r\n    \r\n    // Dropdowns\r\n    --kt-dropdown-box-shadow: #{$dropdown-box-shadow};\r\n    --kt-dropdown-bg: #{$dropdown-bg};\r\n\r\n    // Toasts\r\n    --kt-toast-color: #{$toast-color};\r\n    --kt-toast-background-color: #{$toast-background-color};\r\n    --kt-toast-box-shadow: #{$toast-box-shadow};\r\n    --kt-toast-header-color: #{$toast-header-color};\r\n    --kt-toast-header-background-color: #{$toast-header-background-color};\r\n    --kt-toast-header-border-color: #{$toast-header-border-color};  \r\n\r\n    // Badges\r\n    --kt-badge-color: #{$badge-color};\r\n\r\n    // Modals    \r\n    --kt-modal-bg: #{$modal-content-bg};\r\n    --kt-modal-color: #{$modal-content-color};\r\n    --kt-modal-border-color: #{$modal-content-border-color};\r\n    --kt-modal-box-shadow: #{$modal-content-box-shadow};    \r\n    --kt-modal-content-color: #{$modal-content-color};\r\n    --kt-modal-content-bg: #{$modal-content-bg};\r\n    --kt-modal-content-border-color: #{$modal-content-border-color};\r\n    --kt-modal-content-box-shadow: #{$modal-content-box-shadow};\r\n    --kt-modal-content-box-shadow-xs: #{$modal-content-box-shadow-xs};\r\n    --kt-modal-content-box-shadow-sm-up: #{$modal-content-box-shadow-sm-up};\r\n    --kt-modal-header-border-color: #{$modal-header-border-color};\r\n    --kt-modal-footer-border-color: #{$modal-footer-border-color};\r\n    --kt-modal-backdrop-bg: #{$modal-backdrop-bg};\r\n    --kt-modal-backdrop-opacity: #{$modal-backdrop-opacity};\r\n\r\n    // Progress bars\r\n    --kt-progress-bg: #{$progress-bg};\r\n    --kt-progress-box-shadow: #{$progress-box-shadow};\r\n\r\n    // List group\r\n    --kt-list-group-color: #{$list-group-color};\r\n    --kt-list-group-bg: #{$list-group-bg};\r\n    --kt-list-group-border-color: #{$list-group-border-color};\r\n    --kt-list-group-hover-bg: #{$list-group-hover-bg};\r\n    --kt-list-group-active-color: #{$list-group-active-color};\r\n    --kt-list-group-active-bg: #{$list-group-active-bg};\r\n    --kt-list-group-active-border-colorg: #{$list-group-active-border-color};\r\n    --kt-list-group-disabled-color: #{$list-group-disabled-color};\r\n    --kt-list-group-disabled-bg: #{$list-group-disabled-bg};\r\n    --kt-list-group-action-colorg: #{$list-group-action-color};\r\n    --kt-list-group-action-hover-color: #{$list-group-action-hover-color};\r\n    --kt-list-group-action-active-color: #{$list-group-action-active-color};\r\n    --kt-list-group-action-active-bg: #{$list-group-action-active-bg};\r\n\r\n    // Image thumbnails\r\n    --kt-thumbnail-bg: #{$thumbnail-bg};\r\n    --kt-thumbnail-border-color: #{$thumbnail-border-color};\r\n    --kt-thumbnail-box-shadow: #{$thumbnail-box-shadow};\r\n\r\n    // Figures\r\n    --kt-figure-caption-color: #{$figure-caption-color};\r\n\r\n    // Breadcrumbs\r\n    --kt-breadcrumb-bg: #{$breadcrumb-bg};\r\n    --kt-breadcrumb-divider-color: #{$breadcrumb-divider-color};\r\n    --kt-breadcrumb-active-color: #{$breadcrumb-active-color};\r\n\r\n    // Carousel\r\n    --kt-carousel-custom-indicator-default-bg-color: #{$carousel-custom-indicator-default-bg-color};\r\n    --kt-carousel-custom-indicator-active-bg-color: #{$carousel-custom-indicator-active-bg-color};\r\n    --kt-carousel-custom-bullet-indicator-default-bg-color: #{$carousel-custom-bullet-indicator-default-bg-color};\r\n    --kt-carousel-custom-bullet-indicator-active-bg-color: #{$carousel-custom-bullet-indicator-active-bg-color};\r\n\r\n    // Code\r\n    --kt-code-bg: #{$code-bg};\r\n    --kt-code-box-shadow: #{$code-box-shadow};\r\n    --kt-code-color: #{$code-color};\r\n\r\n    // Close\r\n    --kt-btn-close-color: #{$btn-close-color};\r\n    --kt-btn-close-bg: #{escape-svg($btn-close-bg)};\r\n\r\n    // Offcanvas\r\n    --kt-offcanvas-border-color: #{$offcanvas-border-color};\r\n    --kt-offcanvas-bg-color: #{$offcanvas-bg-color};\r\n    --kt-offcanvas-color: #{$offcanvas-color};\r\n    --kt-offcanvas-box-shadow: #{$offcanvas-box-shadow};\r\n    --kt-offcanvas-backdrop-bg: #{$offcanvas-backdrop-bg};\r\n    --kt-offcanvas-backdrop-opacity: #{$offcanvas-backdrop-opacity};\r\n\r\n    // Symbol\r\n    --kt-symbol-label-color: #{$symbol-label-color};\r\n    --kt-symbol-label-bg: #{$symbol-label-bg};\r\n    --kt-symbol-border-color: #{$symbol-border-color};   \r\n\r\n    // Bullet\r\n    --kt-bullet-bg-color: #{$bullet-bg-color};\r\n\r\n    // Scrolltop\r\n    --kt-scrolltop-opacity: #{$scrolltop-opacity};\r\n    --kt-scrolltop-opacity-on: #{$scrolltop-opacity-on};\r\n    --kt-scrolltop-opacity-hover: #{$scrolltop-opacity-hover};\r\n    --kt-scrolltop-box-shadow: #{$scrolltop-box-shadow};\r\n    --kt-scrolltop-bg-color: #{$scrolltop-bg-color};\r\n    --kt-scrolltop-bg-color-hover: #{$scrolltop-bg-color-hover};\r\n    --kt-scrolltop-icon-color: #{$scrolltop-icon-color};\r\n    --kt-scrolltop-icon-color-hover: #{$scrolltop-icon-color-hover};\r\n\r\n    // Keenthemes drawer component\r\n    --kt-drawer-box-shadow: #{$drawer-box-shadow};\r\n    --kt-drawer-bg-color: #{$drawer-bg-color};\r\n    --kt-drawer-overlay-bg-color: #{$drawer-overlay-bg-color};\r\n\r\n    // Keenthemes menu component\r\n    --kt-menu-dropdown-box-shadow: #{$menu-dropdown-box-shadow};\r\n    --kt-menu-dropdown-bg-color: #{$menu-dropdown-bg-color};\r\n    --kt-menu-heading-color: #{$menu-heading-color};\r\n    --kt-menu-link-color-hover: #{$menu-link-color-hover};\r\n    --kt-menu-link-color-show: #{$menu-link-color-show};\r\n    --kt-menu-link-color-here: #{$menu-link-color-here};\r\n    --kt-menu-link-color-active: #{$menu-link-color-active};\r\n    --kt-menu-link-bg-color-hover: #{$menu-link-bg-color-hover};\r\n    --kt-menu-link-bg-color-show: #{$menu-link-bg-color-show};\r\n    --kt-menu-link-bg-color-here: #{$menu-link-bg-color-here};\r\n    --kt-menu-link-bg-color-active: #{$menu-link-bg-color-active};    \r\n\r\n    // Keenthemes feedback component\r\n    --kt-feedback-popup-box-shadow: #{$feedback-popup-box-shadow};\r\n    --kt-feedback-popup-background-color: #{$feedback-popup-background-color};\r\n\r\n    // Keenthemes scrollbar component \r\n    --kt-scrollbar-color: #{$scrollbar-color};\r\n    --kt-scrollbar-hover-color: #{$scrollbar-hover-color};\r\n    --kt-scrollbar-width: #{$scrollbar-width};\r\n    --kt-scrollbar-height: #{$scrollbar-height};\r\n    --kt-scrollbar-space: #{$scrollbar-space};\r\n\r\n    // Keenthemes overlay component \r\n    --kt-overlay-bg: #{$overlay-bg};\r\n\r\n    // Keenthemes blockui component\r\n    --kt-blockui-overlay-bg: #{$blockui-overlay-bg};\r\n\r\n    // Keenthemes rating component\r\n    --kt-rating-color-default: #{$rating-color-default};\r\n    --kt-rating-color-active: #{$rating-color-active};\r\n\r\n    // Keenthemes ribbon component \r\n    --kt-ribbon-label-box-shadow: #{$ribbon-label-box-shadow};\r\n    --kt-ribbon-label-bg: #{$ribbon-label-bg};\r\n    --kt-ribbon-label-border-color: #{$ribbon-label-border-color};\r\n    --kt-ribbon-clip-bg: #{$ribbon-clip-bg}; \r\n\r\n    // Engage panel\r\n    --kt-engage-btn-bg: #{$engage-btn-bg};\r\n    --kt-engage-btn-color: #{$engage-btn-color};\r\n    --kt-engage-btn-color-active: #{$engage-btn-color-active};\r\n}\r\n\r\n[data-theme=\"dark\"] {\r\n    // Bootstrap muted color\r\n    --kt-text-muted: #{$text-muted-dark};\r\n\r\n    // Grey colors\r\n    @each $name, $value in $grays-dark {\r\n        --kt-gray-#{$name}: #{$value};\r\n    }\r\n\r\n    // Grey rgba colors\r\n    @each $name, $value in $grays-dark {\r\n        --kt-gray-#{$name}-rgb: #{to-rgb($value)};\r\n    }\r\n\r\n    // Contextual colors\r\n    @each $name, $value in $theme-colors-dark {\r\n        --kt-#{$name}: #{$value};\r\n    }\r\n\r\n    // Contextual active state colors\r\n    @each $name, $value in $theme-active-colors-dark {\r\n        --kt-#{$name}-active: #{$value};\r\n    }\r\n\r\n    // Contextual light state colors\r\n    @each $name, $value in $theme-light-colors-dark {\r\n        --kt-#{$name}-light: #{$value};\r\n    }\r\n\r\n    // Contextual inverse state colors\r\n    @each $name, $value in $theme-inverse-colors-dark {\r\n        --kt-#{$name}-inverse: #{$value};\r\n    }\r\n\r\n    // Contextual rbg colors\r\n    @each $name, $value in $theme-colors-dark {\r\n        --kt-#{$name}-rgb: #{to-rgb($value)};\r\n    }\r\n\r\n    // Text colors\r\n    @each $name, $value in $theme-text-colors-dark {\r\n        --kt-text-#{$name}: #{$value};\r\n    }\r\n\r\n    // Body\r\n    --kt-body-bg: #{$body-bg-dark};\r\n    --kt-body-bg-rgb: #{to-rgb($body-bg-dark)};\r\n    --kt-body-color: #{$body-color-dark};\r\n\r\n    // Links\r\n    --kt-link-color: #{$link-color-dark};\r\n    --kt-link-hover-color: #{$link-hover-color-dark};\r\n\r\n    // Components\r\n    --kt-border-color: #{$border-color-dark};\r\n    --kt-border-dashed-color: #{$border-dashed-color-dark};\r\n\r\n    --kt-component-active-color: #{$component-active-color-dark};\r\n    --kt-component-active-bg: #{$component-active-bg-dark};\r\n    --kt-component-hover-color: #{$component-hover-color-dark};\r\n    --kt-component-hover-bg: #{$component-hover-bg-dark};\r\n    --kt-component-checked-color: #{$component-checked-color-dark};\r\n    --kt-component-checked-bg: #{$component-checked-bg-dark};\r\n\r\n    // Box shadow\r\n    --kt-box-shadow-xs: #{$box-shadow-xs-dark};\r\n    --kt-box-shadow-sm: #{$box-shadow-sm-dark};\r\n    --kt-box-shadow: #{$box-shadow-dark};\r\n    --kt-box-shadow-lg: #{$box-shadow-lg-dark};\r\n\r\n    // Typography\r\n    --kt-headings-color: #{$headings-color-dark};\r\n\r\n    // Tables\r\n    --kt-table-color: #{$table-color-dark};\r\n    --kt-table-bg: #{$table-bg-dark};\r\n    --kt-table-striped-color: #{$table-striped-color-dark};\r\n    --kt-table-striped-bg: #{$table-striped-bg-dark};\r\n    --kt-table-accent-bg: #{$table-accent-bg-dark};\r\n    --kt-table-active-color: #{$table-active-color-dark};\r\n    --kt-table-active-bg: #{$table-active-bg-dark};\r\n    --kt-table-hover-colorr: #{$table-hover-color-dark};\r\n    --kt-table-hover-bg: #{$table-hover-bg-dark};\r\n    --kt-table-border-color: #{$table-border-color-dark};\r\n    --kt-table-caption-color: #{$table-caption-color-dark};\r\n\r\n    --kt-table-loading-message-box-shadow: #{$table-loading-message-box-shadow-dark};\r\n    --kt-table-loading-message-bg: #{$table-loading-message-bg-dark};\r\n    --kt-table-loading-message-color: #{$table-loading-message-color-dark};\r\n\r\n    // Buttons + Forms\r\n    --kt-input-btn-focus-color: #{$input-btn-focus-color-dark};\r\n    --kt-input-btn-focus-box-shadow: #{$input-btn-focus-box-shadow-dark};\r\n    --kt-input-btn-focus-color-opacity: #{$input-btn-focus-color-opacity-dark};\r\n\r\n    --kt-input-color: #{$input-color-dark};\r\n    --kt-input-placeholder-color: #{$input-placeholder-color-dark};\r\n    --kt-input-plaintext-color: #{$input-plaintext-color-dark};\r\n\r\n    // Buttons\r\n    --kt-btn-box-shadow: #{$btn-box-shadow-dark};\r\n    --kt-btn-focus-box-shadow: #{$btn-focus-box-shadow-dark};\r\n    --kt-btn-active-box-shadow: #{$btn-active-box-shadow-dark};\r\n    --kt-btn-disabled-opacity: #{$btn-disabled-opacity-dark};\r\n\r\n    --kt-btn-link-color: #{$btn-link-color-dark};\r\n    --kt-btn-link-hover-color: #{$btn-link-hover-color-dark};\r\n    --kt-btn-link-disabled-color: #{$btn-link-disabled-color-dark};\r\n\r\n    // Forms\r\n    --kt-form-label-color: #{$form-label-color-dark};\r\n    --kt-form-text-color: #{$form-text-color-dark};\r\n\r\n    --kt-input-bg: #{$input-bg-dark};\r\n    --kt-input-disabled-bg: #{$input-disabled-bg-dark};\r\n    --kt-input-disabled-color: #{$input-disabled-color-dark};\r\n    --kt-input-disabled-border-color: #{$input-disabled-border-color-dark};\r\n\r\n    --kt-input-color: #{$input-color-dark};\r\n    --kt-input-border-color: #{$input-border-color-dark};\r\n    \r\n    --kt-input-focus-bg: #{$input-focus-bg-dark};\r\n    --kt-input-focus-border-color: #{$input-focus-border-color-dark};\r\n    --kt-input-focus-color: #{$input-focus-color-dark};\r\n\r\n    // Keenthemes solid input style\r\n    --kt-input-solid-bg: #{$input-solid-bg-dark};\r\n    --kt-input-solid-bg-focus: #{$input-solid-bg-focus-dark};\r\n    --kt-input-solid-placeholder-color: #{$input-solid-placeholder-color-dark};\r\n    --kt-input-solid-color: #{$input-solid-color-dark};\r\n\r\n    // Form checks\r\n    --kt-form-check-label-color: #{$form-check-label-color-dark};\r\n    --kt-form-check-label-color-checked: #{$form-check-label-color-checked-dark};\r\n    --kt-form-check-input-active-filter: #{$form-check-input-active-filter-dark};\r\n\r\n    --kt-form-check-input-bg: #{$form-check-input-bg-dark};\r\n    --kt-form-check-input-bg-solid: #{$form-check-input-bg-solid-dark};\r\n    --kt-form-check-input-border: #{$form-check-input-border-dark};\r\n    --kt-form-check-input-focus-border: #{$form-check-input-focus-border-dark};\r\n    --kt-form-check-input-focus-box-shadow: #{$form-check-input-focus-box-shadow-dark};\r\n\r\n    --kt-form-check-input-checked-color: #{$form-check-input-checked-color-dark};\r\n    --kt-form-check-input-checked-bg-color: #{$form-check-input-checked-bg-color-dark};\r\n    --kt-form-check-input-checked-border-color: #{$form-check-input-checked-border-color-dark};\r\n    --kt-form-check-input-checked-bg-image: #{escape-svg($form-check-input-checked-bg-image-dark)};\r\n    --kt-form-check-radio-checked-bg-image: #{escape-svg($form-check-radio-checked-bg-image-dark)};\r\n    \r\n    --kt-form-check-input-indeterminate-color: #{$form-check-input-indeterminate-color-dark};\r\n    --kt-form-check-input-indeterminate-bg-color: #{$form-check-input-indeterminate-bg-color-dark};\r\n    --kt-form-check-input-indeterminate-border-color: #{$form-check-input-indeterminate-border-color-dark};\r\n    --kt-form-check-input-indeterminate-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image-dark)};\r\n\r\n    --kt-form-check-input-disabled-opacity: #{$form-check-input-disabled-opacity-dark};\r\n    --kt-form-check-label-disabled-opacity: #{$form-check-label-disabled-opacity-dark};\r\n    --kt-form-check-btn-check-disabled-opacity: #{$form-check-btn-check-disabled-opacity-dark};\r\n\r\n    --kt-form-switch-color: #{$form-switch-color-dark};\r\n    --kt-form-switch-color-solid: #{$form-switch-color-solid-dark};\r\n    --kt-form-switch-bg-image: #{escape-svg($form-switch-bg-image-dark)};\r\n    --kt-form-switch-bg-image-solid: #{escape-svg($form-switch-bg-image-solid-dark)};\r\n    --kt-form-switch-focus-color: #{$form-switch-focus-color-dark};\r\n    --kt-form-switch-focus-bg-image: #{escape-svg($form-switch-focus-bg-image-dark)};\r\n    --kt-form-switch-checked-color: #{$form-switch-checked-color-dark};\r\n    --kt-form-switch-checked-bg-image: #{escape-svg($form-switch-checked-bg-image-dark)};\r\n\r\n    // Input groups\r\n    --kt-input-group-addon-color: #{$input-group-addon-color-dark};\r\n    --kt-input-group-addon-bg: #{$input-group-addon-bg-dark};\r\n    --kt-input-group-addon-border-color: #{$input-group-addon-border-color-dark};\r\n\r\n    // Form select\r\n    --kt-form-select-color: #{$form-select-color-dark};\r\n    --kt-form-select-bg: #{$form-select-bg-dark};\r\n    --kt-form-select-disabled-color: #{$form-select-disabled-color-dark};\r\n    --kt-form-select-disabled-bg: #{$form-select-disabled-bg-dark};\r\n    --kt-form-select-disabled-border-color: #{$form-select-disabled-border-color-dark};\r\n    --kt-form-select-indicator-color: #{$form-select-indicator-color-dark};\r\n    --kt-form-select-indicator: #{escape-svg($form-select-indicator-dark)};\r\n    --kt-form-select-border-color: #{$form-select-border-color-dark};\r\n    --kt-form-select-box-shadow: #{$form-select-box-shadow-dark};\r\n    --kt-form-select-focus-border-color: #{$form-select-focus-border-color-dark};\r\n    --kt-form-select-focus-box-shadow: #{$form-select-focus-box-shadow-dark};\r\n\r\n    // Form file button\r\n    --kt-form-file-button-color: #{$form-file-button-color-dark};\r\n    --kt-form-file-button-bg: #{$form-file-button-bg-dark};\r\n    --kt-form-file-button-hover-bg: #{$form-file-button-hover-bg-dark};\r\n\r\n    // Navs\r\n    --kt-nav-tabs-border-color: #{$nav-tabs-border-color-dark};\r\n    --kt-nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color-dark};\r\n    --kt-nav-tabs-link-active-color: #{$nav-tabs-link-active-color-dark};\r\n    --kt-nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg-dark};\r\n    --kt-nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color-dark};\r\n\r\n    --kt-nav-pills-link-active-color: #{$nav-pills-link-active-color-dark};\r\n    --kt-nav-pills-link-active-bg: #{$nav-pills-link-active-bg-dark};\r\n\r\n    // Dropdowns        \r\n    --kt-dropdown-color: #{$dropdown-color-dark};\r\n    --kt-dropdown-bg: #{$dropdown-bg-dark};\r\n    --kt-dropdown-divider-bg: #{$dropdown-divider-bg-dark};\r\n    --kt-dropdown-box-shadow: #{$dropdown-box-shadow-dark};\r\n    --kt-dropdown-link-color: #{$dropdown-link-color-dark};\r\n    --kt-dropdown-link-hover-color: #{$dropdown-link-hover-color-dark};\r\n    --kt-dropdown-link-hover-bg: #{$dropdown-link-hover-bg-dark};\r\n    --kt-dropdown-link-active-color: #{$dropdown-link-active-color-dark};\r\n    --kt-dropdown-link-active-bg: #{$dropdown-link-active-bg-dark};\r\n    --kt-dropdown-link-disabled-color: #{$dropdown-link-disabled-color-dark};\r\n    --kt-dropdown-header-color: #{$dropdown-header-color-dark};\r\n\r\n    // Pagination\r\n    --kt-pagination-item-bg: #{$pagination-item-bg-dark};\r\n    --kt-pagination-color: #{$pagination-color-dark};\r\n    --kt-pagination-bg: #{$pagination-bg-dark};\r\n    --kt-pagination-border-color: #{$pagination-border-color-dark};\r\n    --kt-pagination-focus-color: #{$pagination-focus-color-dark};\r\n    --kt-pagination-focus-bg: #{$pagination-focus-bg-dark};\r\n    --kt-pagination-focus-box-shadow: #{$pagination-focus-box-shadow-dark};\r\n    --kt-pagination-focus-outline: #{$pagination-focus-outline-dark};\r\n    --kt-pagination-hover-color: #{$pagination-hover-color-dark};\r\n    --kt-pagination-hover-bg: #{$pagination-hover-bg-dark};\r\n    --kt-pagination-hover-border-color: #{$pagination-hover-border-color-dark};\r\n    --kt-pagination-active-color: #{$pagination-active-color-dark};\r\n    --kt-pagination-active-bg: #{$pagination-active-bg-dark};\r\n    --kt-pagination-active-border-color: #{$pagination-active-border-color-dark};\r\n    --kt-pagination-disabled-color: #{$pagination-disabled-color-dark};\r\n    --kt-pagination-disabled-bg: #{$pagination-disabled-bg-dark};\r\n\r\n    // Card\r\n    --kt-card-bg: #{$card-bg-dark};\r\n    --kt-card-color: #{$card-color-dark};\r\n    --kt-card-box-shadow: #{$card-box-shadow-dark};\r\n    --kt-card-border-color: #{$card-border-color-dark};\r\n    --kt-card-border-dashed-color: #{$card-border-dashed-color-dark};\r\n    --kt-card-cap-bg: #{$card-cap-bg-dark};\r\n\r\n    // Accordion\r\n    --kt-accordion-color: #{$accordion-color-dark};\r\n    --kt-accordion-bg: #{$accordion-bg-dark};    \r\n    --kt-accordion-border-color: #{$accordion-border-color-dark}; \r\n    --kt-accordion-button-color: #{$accordion-button-color-dark};\r\n    --kt-accordion-button-bg: #{$accordion-button-bg-dark};   \r\n    --kt-accordion-button-active-bg: #{$accordion-button-active-bg-dark};   \r\n    --kt-accordion-button-active-color: #{$accordion-button-active-color-dark};\r\n    --kt-accordion-button-focus-border-color: #{$accordion-button-focus-border-color-dark};\r\n    --kt-accordion-button-focus-box-shadow: #{$accordion-button-focus-box-shadow-dark};\r\n\r\n    --kt-accordion-icon-color: #{$accordion-icon-color-dark};\r\n    --kt-accordion-icon-active-color: #{$accordion-icon-active-color-dark};\r\n    --kt-accordion-button-icon: #{escape-svg($accordion-button-icon-dark)};\r\n    --kt-accordion-button-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\r\n\r\n    // Tooltips\r\n    --kt-tooltip-color: #{$tooltip-color-dark};\r\n    --kt-tooltip-bg: #{$tooltip-bg-dark};\r\n    --kt-tooltip-opacity: #{$tooltip-opacity-dark};\r\n    --kt-tooltip-box-shadow: #{$tooltip-box-shadow-dark};\r\n   \r\n    // Popovers\r\n    --kt-popover-bg: #{$popover-bg-dark};\r\n    --kt-popover-border-color: #{$popover-border-color-dark};\r\n    --kt-popover-box-shadow: #{$popover-box-shadow-dark};\r\n    --kt-popover-header-bg: #{$popover-header-bg-dark};\r\n    --kt-popover-header-color: #{$popover-header-color-dark};\r\n    --kt-popover-header-border-color: #{$popover-header-border-color-dark};\r\n    --kt-popover-body-color: #{$popover-body-color-dark};\r\n    \r\n    // Dropdowns\r\n    --kt-dropdown-box-shadow: #{$dropdown-box-shadow-dark};\r\n    --kt-dropdown-bg: #{$dropdown-bg-dark};\r\n\r\n    // Toasts\r\n    --kt-toast-color: #{$toast-color-dark};\r\n    --kt-toast-background-color: #{$toast-background-color-dark};\r\n    --kt-toast-box-shadow: #{$toast-box-shadow-dark};\r\n    --kt-toast-header-color: #{$toast-header-color-dark};\r\n    --kt-toast-header-background-color: #{$toast-header-background-color-dark};\r\n    --kt-toast-header-border-color: #{$toast-header-border-color-dark};  \r\n\r\n    // Badges\r\n    --kt-badge-color: #{$badge-color-dark};\r\n\r\n    // Modals    \r\n    --kt-modal-bg: #{$modal-content-bg-dark};\r\n    --kt-modal-color: #{$modal-content-color-dark};\r\n    --kt-modal-border-color: #{$modal-content-border-color-dark};\r\n    --kt-modal-box-shadow: #{$modal-content-box-shadow-dark};\r\n    --kt-modal-content-color: #{$modal-content-color-dark};\r\n    --kt-modal-content-bg: #{$modal-content-bg-dark};\r\n    --kt-modal-content-border-color: #{$modal-content-border-color-dark};\r\n    --kt-modal-content-box-shadow: #{$modal-content-box-shadow-dark};\r\n    --kt-modal-content-box-shadow-xs: #{$modal-content-box-shadow-xs-dark};\r\n    --kt-modal-content-box-shadow-sm-up: #{$modal-content-box-shadow-sm-up-dark};\r\n    --kt-modal-header-border-color: #{$modal-header-border-color-dark};\r\n    --kt-modal-footer-border-color: #{$modal-footer-border-color-dark};\r\n    --kt-modal-backdrop-bg: #{$modal-backdrop-bg-dark};\r\n    --kt-modal-backdrop-opacity: #{$modal-backdrop-opacity-dark};\r\n\r\n    // Progress bars\r\n    --kt-progress-bg: #{$progress-bg-dark};\r\n    --kt-progress-box-shadow: #{$progress-box-shadow-dark};\r\n\r\n    // List group\r\n    --kt-list-group-color: #{$list-group-color-dark};\r\n    --kt-list-group-bg: #{$list-group-bg-dark};\r\n    --kt-list-group-border-color: #{$list-group-border-color-dark};\r\n    --kt-list-group-hover-bg: #{$list-group-hover-bg-dark};\r\n    --kt-list-group-active-color: #{$list-group-active-color-dark};\r\n    --kt-list-group-active-bg: #{$list-group-active-bg-dark};\r\n    --kt-list-group-active-border-colorg: #{$list-group-active-border-color-dark};\r\n    --kt-list-group-disabled-color: #{$list-group-disabled-color-dark};\r\n    --kt-list-group-disabled-bg: #{$list-group-disabled-bg-dark};\r\n    --kt-list-group-action-colorg: #{$list-group-action-color-dark};\r\n    --kt-list-group-action-hover-color: #{$list-group-action-hover-color-dark};\r\n    --kt-list-group-action-active-color: #{$list-group-action-active-color-dark};\r\n    --kt-list-group-action-active-bg: #{$list-group-action-active-bg-dark};\r\n\r\n    // Image thumbnails\r\n    --kt-thumbnail-bg: #{$thumbnail-bg-dark};\r\n    --kt-thumbnail-border-color: #{$thumbnail-border-color-dark};\r\n    --kt-thumbnail-box-shadow: #{$thumbnail-box-shadow-dark};\r\n\r\n    // Figures\r\n    --kt-figure-caption-color: #{$figure-caption-color-dark};\r\n\r\n    // Breadcrumbs\r\n    --kt-breadcrumb-bg: #{$breadcrumb-bg-dark};\r\n    --kt-breadcrumb-divider-color: #{$breadcrumb-divider-color-dark};\r\n    --kt-breadcrumb-active-color: #{$breadcrumb-active-color-dark};\r\n\r\n    // Carousel\r\n    --kt-carousel-custom-indicator-default-bg-color: #{$carousel-custom-indicator-default-bg-color-dark};\r\n    --kt-carousel-custom-indicator-active-bg-color: #{$carousel-custom-indicator-active-bg-color-dark};\r\n    --kt-arousel-custom-bullet-indicator-default-bg-color: #{$carousel-custom-bullet-indicator-default-bg-color-dark};\r\n    --kt-carousel-custom-bullet-indicator-active-bg-color: #{$carousel-custom-bullet-indicator-active-bg-color-dark};\r\n\r\n    // Close\r\n    --kt-btn-close-color: #{$btn-close-color-dark};\r\n    --kt-btn-close-bg: #{escape-svg($btn-close-bg-dark)};\r\n\r\n    // Offcanvas\r\n    --kt-code-bg: #{$code-bg-dark};\r\n    --kt-code-box-shadow: #{$code-box-shadow-dark};\r\n    --kt-code-color: #{$code-color-dark};\r\n\r\n    // Offcanvas\r\n    --kt-offcanvas-border-color: #{$offcanvas-border-color-dark};\r\n    --kt-offcanvas-bg-color: #{$offcanvas-bg-color-dark};\r\n    --kt-offcanvas-color: #{$offcanvas-color-dark};\r\n    --kt-offcanvas-box-shadow: #{$offcanvas-box-shadow-dark};\r\n    --kt-offcanvas-backdrop-bg: #{$offcanvas-backdrop-bg-dark};\r\n    --kt-offcanvas-backdrop-opacity: #{$offcanvas-backdrop-opacity-dark};\r\n\r\n    // Code\r\n    --kt-code-bg: #{$code-bg-dark};\r\n    --kt-code-box-shadow: #{$code-box-shadow-dark};\r\n    --kt-code-color: #{$code-color-dark};  \r\n\r\n    // Symbol\r\n    --kt-symbol-label-color: #{$symbol-label-color-dark};\r\n    --kt-symbol-label-bg: #{$symbol-label-bg-dark};\r\n    --kt-symbol-border-color: #{$symbol-border-color-dark};   \r\n\r\n    // Bullet\r\n    --kt-bullet-bg-color: #{$bullet-bg-color-dark};\r\n\r\n    // Scrolltop\r\n    --kt-scrolltop-opacity: #{$scrolltop-opacity-dark};\r\n    --kt-scrolltop-opacity-on: #{$scrolltop-opacity-on-dark};\r\n    --kt-scrolltop-opacity-hover: #{$scrolltop-opacity-hover-dark};\r\n    --kt-scrolltop-box-shadow: #{$scrolltop-box-shadow-dark};\r\n    --kt-scrolltop-bg-color: #{$scrolltop-bg-color-dark};\r\n    --kt-scrolltop-bg-color-hover: #{$scrolltop-bg-color-hover-dark};\r\n    --kt-scrolltop-icon-color: #{$scrolltop-icon-color-dark};\r\n    --kt-scrolltop-icon-color-hover: #{$scrolltop-icon-color-hover-dark};\r\n\r\n    // Keenthemes drawer component\r\n    --kt-drawer-box-shadow: #{$drawer-box-shadow-dark};\r\n    --kt-drawer-bg-color: #{$drawer-bg-color-dark};\r\n    --kt-drawer-overlay-bg-color: #{$drawer-overlay-bg-color-dark};\r\n\r\n    // Keenthemes menu component\r\n    --kt-menu-dropdown-box-shadow: #{$menu-dropdown-box-shadow-dark};\r\n    --kt-menu-dropdown-bg-color: #{$menu-dropdown-bg-color-dark};\r\n    --kt-menu-heading-color: #{$menu-heading-color-dark};\r\n    \r\n    --kt-menu-link-color-hover: #{$menu-link-color-hover-dark};\r\n    --kt-menu-link-color-show: #{$menu-link-color-show-dark};\r\n    --kt-menu-link-color-here: #{$menu-link-color-here-dark};\r\n    --kt-menu-link-color-active: #{$menu-link-color-active-dark};\r\n    --kt-menu-link-bg-color-hover: #{$menu-link-bg-color-hover-dark};\r\n    --kt-menu-link-bg-color-show: #{$menu-link-bg-color-show-dark};\r\n    --kt-menu-link-bg-color-here: #{$menu-link-bg-color-here-dark};\r\n    --kt-menu-link-bg-color-active: #{$menu-link-bg-color-active-dark};\r\n    \r\n\r\n    // Keenthemes feedback component\r\n    --kt-feedback-popup-box-shadow: #{$feedback-popup-box-shadow-dark};\r\n    --kt-feedback-popup-background-color: #{$feedback-popup-background-color-dark};\r\n\r\n    // Keenthemes scrollbar component \r\n    --kt-scrollbar-color: #{$scrollbar-color-dark};\r\n    --kt-scrollbar-hover-color: #{$scrollbar-hover-color-dark};\r\n\r\n    // Keenthemes overlay component \r\n    --kt-overlay-bg: #{$overlay-bg-dark};\r\n\r\n    // Keenthemes blockui component\r\n    --kt-blockui-overlay-bg: #{$blockui-overlay-bg-dark};\r\n\r\n    // Keenthemes rating component\r\n    --kt-rating-color-default: #{$rating-color-default-dark};\r\n    --kt-rating-color-active: #{$rating-color-active-dark};\r\n\r\n    // Keenthemes ribbon component \r\n    --kt-ribbon-label-box-shadow: #{$ribbon-label-box-shadow-dark};\r\n    --kt-ribbon-label-bg: #{$ribbon-label-bg-dark};\r\n    --kt-ribbon-label-border-color: #{$ribbon-label-border-color-dark};\r\n    --kt-ribbon-clip-bg: #{$ribbon-clip-bg-dark};  \r\n\r\n    // Engage panel\r\n    --kt-engage-btn-bg: #{$engage-btn-bg-dark};\r\n    --kt-engage-btn-color: #{$engage-btn-color-dark};\r\n    --kt-engage-btn-color-active: #{$engage-btn-color-active-dark};\r\n}","//\r\n// CSS Variables\r\n//\r\n\r\n[data-theme=\"dark\"] {\r\n\t@each $color, $value in $grays-dark {\r\n\t\t--#{$prefix}gray-#{$color}: #{$value};\r\n\t}\r\n\r\n\t@each $color, $value in $theme-colors-dark {\r\n\t\t--#{$prefix}#{$color}: #{$value};\r\n\t}\r\n\r\n\t--#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\r\n\t--#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\r\n\r\n\t--#{$prefix}body-color: #{$body-color-dark};\r\n\t--#{$prefix}body-bg: #{$body-bg-dark};\r\n\r\n\t--#{$prefix}border-color: #{$border-color-dark};\r\n\r\n\t--#{$prefix}heading-color: #{$headings-color-dark};\r\n\t--#{$prefix}link-color: #{$link-color-dark};\r\n\t--#{$prefix}link-hover-color: #{$link-hover-color-dark};\r\n\r\n\t--#{$prefix}code-color: #{$code-color-dark};\r\n}","//\r\n// Reboot\r\n//\r\n\r\nh1, h2, h3, h4, h5, h6 {\r\n\tcolor: var(--kt-headings-color);\r\n\toutline: 0;\r\n}\r\n","\r\n\r\n.blockquote-footer {\r\n\tcolor: var(--kt-blockquote-footer-color);\r\n}\r\n","//\r\n// Theme Modes\r\n//\r\n\r\n// Used for theme mode switching via JS\r\n[data-kt-theme-mode-switching=\"true\"] * {\r\n    transition: none !important;\r\n}\r\n\r\n// Light mode\r\n@include theme-light() {\r\n\t.theme-dark-show {\r\n\t\tdisplay: none !important;\t\t\r\n\t}\r\n\r\n\t.theme-light-bg-transparent {\r\n\t\tbackground-color: transparent !important;\t\r\n\t}\r\n\r\n\t.theme-light-bg-body {\r\n\t\tbackground-color: var(--kt-body-bg) !important;\t\r\n\t}\r\n}\r\n\r\n// Dark mode\r\n@include theme-dark() {\r\n\t.theme-light-show {\r\n\t\tdisplay: none !important;\t\t\r\n\t}\r\n\r\n\t.theme-dark-bg-transparent {\r\n\t\tbackground-color: transparent !important;\t\r\n\t}\r\n\r\n\t.theme-dark-bg-body {\r\n\t\tbackground-color: var(--kt-body-bg) !important;\t\r\n\t}\r\n}","//\r\n// Animation\r\n//\r\n\r\n// Base\r\n.animation {\r\n  animation-duration: 1s;\r\n  animation-fill-mode: both;\r\n}\r\n\r\n// Slide In Down\r\n@keyframes animationSlideInDown {\r\n    from {\r\n        transform: translate3d(0, -100%, 0);\r\n        visibility: visible;\r\n    }\r\n\r\n    to {\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animation-slide-in-down {\r\n    animation-name: animationSlideInDown;\r\n}\r\n\r\n// Slide In Up\r\n@keyframes animationSlideInUp {\r\n    from {\r\n        transform: translate3d(0, 100%, 0);\r\n        visibility: visible;\r\n    }\r\n\r\n    to {\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n\r\n.animation-slide-in-up {\r\n    animation-name: animationSlideInUp;\r\n}\r\n\r\n// Fade In\r\n@keyframes animationFadeIn {\r\n    from {\r\n        opacity: 0;\r\n    }\r\n\r\n    to {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.animation-fade-in {\r\n    animation-name: animationFadeIn;\r\n}\r\n\r\n// Fade Out\r\n@keyframes animationFadeOut {\r\n    from {\r\n        opacity: 1;\r\n    }\r\n\r\n    to {\r\n        opacity: 0;\r\n    }\r\n}\r\n.animation-fade-out {\r\n    animation-name: animationFadeOut;\r\n}\r\n\r\n// Blink\r\n.animation-blink {\r\n    animation: animationBlink 1s steps(5, start) infinite;\r\n}\r\n\r\n@keyframes animationBlink {\r\n    to {\r\n        visibility: hidden;\r\n    }\r\n}\r\n\r\n.animation-breathe {\r\n    animation: breathe 1.5s ease-in-out infinite alternate;\r\n}\r\n\r\n@keyframes breathe {\r\n    from {\r\n        opacity: 0.3;\r\n    } \r\n    \r\n    to {\r\n        opacity: 1;\r\n    }\r\n}","//\r\n// Alert\r\n//\r\n\t\r\n@each $name, $value in $theme-colors {\r\n\t.alert-#{$name} {\r\n\t\tcolor: var(--kt-#{$name});\r\n\t\tborder-color: var(--kt-#{$name});\r\n\t\tbackground-color: var(--kt-#{$name}-light);\r\n\r\n\t\t.alert-link {\r\n    \t\tcolor: var(--kt-#{$name});\r\n  \t\t}\r\n\t}\r\n}\r\n","//\r\n// List group\r\n//\r\n\r\n.list-group {\r\n\t--#{$prefix}list-group-color: var(--kt-list-group-color);\r\n\t--#{$prefix}list-group-bg: var(--kt-list-group-bg);\r\n\t--#{$prefix}list-group-border-color: var(--kt-list-group-border-color);\r\n\t--#{$prefix}list-group-action-color: var(--kt-list-group-action-color);\r\n\t--#{$prefix}list-group-action-hover-color: var(--kt-list-group-action-hover-color);\r\n\t--#{$prefix}list-group-action-hover-bg: var(--kt-list-group-hover-bg);\r\n\t--#{$prefix}list-group-action-active-color: var(--kt-list-group-action-active-color);\r\n\t--#{$prefix}list-group-action-active-bg: var(--kt-list-group-action-active-bg);\r\n\t--#{$prefix}list-group-disabled-color: var(--kt-list-group-disabled-color);\r\n\t--#{$prefix}list-group-disabled-bg: var(--kt-list-group-disabled-bg);\r\n\t--#{$prefix}list-group-active-color: var(--kt-list-group-active-color);\r\n\t--#{$prefix}list-group-active-bg: var(--kt-list-group-active-bg);\r\n\t--#{$prefix}list-group-active-border-color: var(--kt-list-group-active-border-color);\r\n}\r\n","\r\n\r\n// Image thumbnails\r\n.img-thumbnail {\r\n\tbackground-color: var(--kt-thumbnail-bg);\r\n\tborder: $thumbnail-border-width solid var(--kt-thumbnail-border-color);\r\n\t@include box-shadow(var(--kt-thumbnail-box-shadow));\r\n}\r\n\r\n.figure-caption {\r\n\tcolor: var(--kt-figure-caption-color);\r\n}\r\n","\r\n\r\n// The clickable button for toggling the menu\r\n// Set the same inset shadow as the :active state\r\n.btn-group.show .dropdown-toggle {\r\n  @include box-shadow(var(--kt-btn-active-box-shadow));\r\n}","\r\n// The dropdown menu\r\n.dropdown-menu {\r\n\t--#{$prefix}dropdown-color: var(--kt-dropdown-color);\r\n\t--#{$prefix}dropdown-bg: var(--kt-dropdown-bg);\r\n\t--#{$prefix}dropdown-border-color: var(--kt-dropdown-border-color);\r\n\t--#{$prefix}dropdown-divider-bg: var(--kt-dropdown-divider-bg);\r\n\t--#{$prefix}dropdown-box-shadow: var(--kt-dropdown-box-shadow);\r\n\t--#{$prefix}dropdown-link-color: var(--kt-dropdown-link-color);\r\n\t--#{$prefix}dropdown-link-hover-color: var(--kt-dropdown-link-hover-color);\r\n\t--#{$prefix}dropdown-link-hover-bg: var(--kt-dropdown-link-hover-bg);\r\n\t--#{$prefix}dropdown-link-active-color: var(--kt-dropdown-link-active-color);\r\n\t--#{$prefix}dropdown-link-active-bg: var(--kt-dropdown-link-active-bg);\r\n\t--#{$prefix}dropdown-link-disabled-color: var(--kt-dropdown-link-disabled-color);\r\n\t--#{$prefix}dropdown-header-color: var(--kt-dropdown-header-color);\r\n}\r\n",".toast {\r\n\t--#{$prefix}toast-color: var(--kt-toast-color);\r\n\t--#{$prefix}toast-bg: var(--kt-toast-background-color);\r\n\t--#{$prefix}toast-border-color: var(--kt-toast-border-color);\r\n\t--#{$prefix}toast-box-shadow: var(--kt-toast-box-shadow);\r\n\t--#{$prefix}toast-header-color: var(--kt-toast-header-color);\r\n\t--#{$prefix}toast-header-bg: var(--kt-toast-header-background-color);\r\n\t--#{$prefix}toast-header-border-color: var(--kt-toast-header-border-color);\r\n\r\n\t.toast-header {\r\n\t\t.btn-close {\r\n\t\t\tmargin-right: 0;\t\r\n\t\t}\t\r\n\t}\r\n}","//\r\n// Close\r\n//\r\n\r\n.btn-close {\r\n\tcolor: var(--kt-btn-close-color);\r\n\tbackground-image: var(--kt-btn-close-bg); \r\n\tbackground-position: center;\r\n\t\r\n\r\n\t&:hover {\r\n\t\tcolor: var(--kt-btn-close-color);\r\n\t}\r\n}\r\n","%offcanvas-css-vars {\r\n\t--#{$prefix}offcanvas-color: var(--kt-offcanvas-color);\r\n\t--#{$prefix}offcanvas-bg: var(--kt-offcanvas-bg-color);\r\n\t--#{$prefix}offcanvas-border-color: var(--kt-offcanvas-border-color);\r\n\t--#{$prefix}offcanvas-box-shadow: var(--kt-offcanvas-box-shadow);\r\n}","//\r\n// Nav\r\n//\r\n\r\n// Basic\r\n.nav {\r\n\t--#{$prefix}nav-link-color: var(--kt-nav-link-color);\r\n\t--#{$prefix}nav-link-hover-color: var(--kt-nav-link-hover-color);\r\n\t--#{$prefix}nav-link-disabled-color: var(--kt-nav-link-disabled-color);\r\n}\r\n\r\n// Tabs\r\n.nav-tabs {\r\n\t--#{$prefix}nav-tabs-border-color: var(--kt-nav-tabs-border-color);\r\n\t--#{$prefix}nav-tabs-link-hover-border-color: var(--kt-nav-tabs-link-hover-border-color);\r\n\t--#{$prefix}nav-tabs-link-active-color: var(--kt-nav-tabs-link-active-color);\r\n\t--#{$prefix}nav-tabs-link-active-bg: var(--kt-nav-tabs-link-active-bg);\r\n\t--#{$prefix}nav-tabs-link-active-border-color: var(--kt-nav-tabs-link-active-border-color);\r\n}\r\n\r\n// Pills\r\n.nav-pills {\r\n\t--#{$prefix}nav-pills-link-active-color: var(--kt-nav-pills-link-active-color);\r\n\t--#{$prefix}nav-pills-link-active-bg: var(--kt-nav-pills-link-active-bg);\r\n}\r\n\r\n// Nav pills\r\n.nav-pills {\r\n\t.nav-item {\r\n\t\tmargin-right: 0.5rem;\r\n\r\n\t\t&:last-child {\r\n\t\t\tmargin-right: 0;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Stretch items\r\n.nav-stretch {\r\n\talign-items: stretch;\r\n\tpadding-top: 0 !important;\r\n\tpadding-bottom: 0 !important;\r\n\r\n\t.nav-item {\r\n\t\tdisplay: flex;\r\n\t\talign-items: stretch;\r\n\t\tpadding-top: 0 !important;\r\n\t\tpadding-bottom: 0 !important;\r\n\t}\r\n\r\n\t.nav-link {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t}\r\n}\r\n\r\n// Nav group\r\n.nav-group {\r\n\tpadding: 0.35rem;\r\n\t@include border-radius($border-radius);\r\n\tbackground-color: var(--kt-gray-100);\r\n\r\n\t// Outline nav group\r\n\t&.nav-group-outline {\t\r\n\t\tbackground-color: transparent;\r\n\t\tborder: 1px solid var(--kt-border-color);\t\r\n\t}\r\n\r\n\t// Fluid option\r\n\t&.nav-group-fluid {\r\n\t\tdisplay: flex;\r\n\r\n\t\t> label,\r\n\t\t> .btn {\r\n\t\t\tposition: relative;\r\n\t\t\tflex-shrink: 0;\r\n\t\t\tflex-grow: 1;\r\n\t\t\tflex-basis: 0;\r\n\t\t}\r\n\r\n\t\t> label {\r\n\t\t\tmargin-right: 0.1rem;\r\n\r\n\t\t\t> .btn {\r\n\t\t\t\twidth: 100%;\r\n\t\t\t}\r\n\r\n\t\t\t&:last-child {\r\n\t\t\t\tmargin-right: 0;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}","//\r\n// Nav\r\n//\r\n\r\n// Line tabs\r\n.nav-line-tabs {\r\n\tborder-bottom-width: 1px;\r\n\tborder-bottom-style: solid;\r\n\tborder-bottom-color: var(--kt-border-color);\r\n\r\n\t.nav-item {\r\n\t\tmargin-bottom: -1px;\r\n\r\n\t\t// Base link\r\n\t\t.nav-link {\r\n\t\t\tcolor: var(--kt-gray-500);\r\n\t\t\tborder: 0;\r\n\t\t\tborder-bottom: 1px solid transparent;\r\n\t\t\ttransition: $transition-link;\r\n\t\t\tpadding: 0.5rem 0;\r\n\t\t\tmargin: 0 1rem;\r\n\t\t}\r\n\r\n\t\t// First Item\r\n\t\t&:first-child {\r\n\t\t\t.nav-link {\r\n\t\t\t\tmargin-left: 0;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t// Last Item\r\n\t\t&:last-child {\r\n\t\t\t.nav-link {\r\n\t\t\t\tmargin-right: 0;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t// Active & Hover States\r\n\t.nav-item .nav-link.active,\r\n  \t.nav-item.show .nav-link,\r\n\t.nav-item .nav-link:hover:not(.disabled) {\r\n\t\tbackground-color: transparent;\r\n\t\tborder: 0;\r\n\t\tborder-bottom: 1px solid var(--kt-primary);\r\n\t\ttransition: $transition-link;\r\n  \t}\r\n\r\n\t// 2x Line\r\n\t&.nav-line-tabs-2x {\r\n\t\tborder-bottom-width: 2px;\r\n\r\n\t\t.nav-item {\r\n\t\t\tmargin-bottom: -2px;\r\n\r\n\t\t\t.nav-link {\r\n\t\t\t\tborder-bottom-width: 2px;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t// Active & Hover States\r\n\t\t.nav-item .nav-link.active,\r\n\t  \t.nav-item.show .nav-link,\r\n\t\t.nav-item .nav-link:hover:not(.disabled) {\r\n\t\t\tborder-bottom-width: 2px;\r\n\t\t}\r\n\t}\r\n}","//\r\n// Custom Nav Pills\r\n//\r\n\r\n.nav.nav-pills.nav-pills-custom {\r\n\t// States\r\n\t.show > .nav-link,\r\n\t.nav-link{\t\t\r\n\t\tborder: 1px dashed var(--kt-border-dashed-color);\r\n\t\t@include border-radius($border-radius-lg);\r\n\t\t\r\n\t\t&.nav-link-border-solid {\r\n\t\t\tborder: 3px solid var(--kt-border-dashed-color);\r\n\r\n\t\t\t&.active {\t\t\t\t\t \t\t\r\n\t\t\t\tborder: 3px solid var(--kt-primary);\t \r\n\t\t\t}\r\n\t\t}\r\n\t\t\r\n        .nav-icon {\r\n            img {\r\n                width: 30px;\r\n                transition: $transition-link;\r\n\r\n                &.default {\r\n                    display: inline-block;\r\n                }\r\n\r\n                &.active {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n\r\n        &.active {\t\r\n\t\t\tbackground-color: transparent;\t\t\r\n\t\t\tborder: 1px solid var(--kt-border-dashed-color);\r\n\t\t\ttransition-duration: 1ms;\t\t\t\r\n\t\t\tposition: relative;\r\n\r\n\t\t\t.nav-text {\r\n\t\t\t\tcolor: var(--kt-gray-800) !important;\r\n\t\t\t\ttransition: $transition-link;\r\n\t\t\t}\r\n\t\t\t\r\n\t\t\t.bullet-custom {\r\n\t\t\t\tdisplay: block;\t\t\t  \t\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.bullet-custom {\r\n\t\t\tdisplay: none;\t\t\t  \t\r\n\t\t}\r\n\t}\r\n\r\n\t&.nav-pills-active-custom {\r\n\t\t.nav-item {\t\t\t\t \r\n\t\t\t.nav-link {\r\n\t\t\t\t&:not(:active) {\t\t\t\t \r\n\t\t\t\t\tspan:nth-child(1) {\r\n\t\t\t\t\t\tcolor: #B5B5C3;\r\n\t\t\t\t\t}\r\n\t\r\n\t\t\t\t\tspan:nth-child(2) {\r\n\t\t\t\t\t\tcolor: #3F4254;\r\n\t\t\t\t\t}\t\t\t\t\t\t \t \r\n\t\t\t\t}\t\t\r\n\r\n\t\t\t\t&:hover {\t\t\t\t \r\n\t\t\t\t\tspan:nth-child(1) {\r\n\t\t\t\t\t\tcolor: $white !important;\r\n\t\t\t\t\t}\r\n\t\r\n\t\t\t\t\tspan:nth-child(2) {\r\n\t\t\t\t\t\tcolor: $white !important;\r\n\t\t\t\t\t}\t\t\t\t\t\t \t \r\n\t\t\t\t}\r\n\t\t\t\t\r\n\t\t\t\t&.active {\t\t\t\t \r\n\t\t\t\t\tspan:nth-child(1) {\r\n\t\t\t\t\t\tcolor: $white !important;\r\n\t\t\t\t\t}\r\n\t\r\n\t\t\t\t\tspan:nth-child(2) {\r\n\t\t\t\t\t\tcolor: $white !important;\r\n\t\t\t\t\t}\t\t\t\t\t\t \t \r\n\t\t\t\t}\t\r\n\t\t\t}\t\t\t\t \t\t \r\n\t\t}\t\t \r\n\t}\r\n}\r\n","//\r\n// Pagination\r\n//\r\n\r\n.pagination {\r\n\t--#{$prefix}pagination-color: var(--kt-pagination-color);\r\n\t--#{$prefix}pagination-bg: var(--kt-pagination-bg);\r\n\t--#{$prefix}pagination-border-color: var(--kt-pagination-border-color);\r\n\t--#{$prefix}pagination-hover-color: var(--kt-pagination-hover-color);\r\n\t--#{$prefix}pagination-hover-bg: var(--kt-pagination-hover-bg);\r\n\t--#{$prefix}pagination-hover-border-color: var(--kt-pagination-hover-border-color);\r\n\t--#{$prefix}pagination-focus-color: var(--kt-pagination-focus-color);\r\n\t--#{$prefix}pagination-focus-bg: var(--kt-pagination-focus-bg);\r\n\t--#{$prefix}pagination-focus-box-shadow: var(--kt-pagination-focus-box-shadow);\r\n\t--#{$prefix}pagination-active-color: var(--kt-pagination-active-color);\r\n\t--#{$prefix}pagination-active-bg: var(--kt-pagination-active-bg);\r\n\t--#{$prefix}pagination-active-border-color: var(--kt-pagination-active-border-color);\r\n\t--#{$prefix}pagination-disabled-color: var(--kt-pagination-disabled-color);\r\n\t--#{$prefix}pagination-disabled-bg: var(--kt-pagination-disabled-bg);\r\n\t--#{$prefix}pagination-disabled-border-color: var(--kt-pagination-disabled-border-color);\r\n\r\n\tdisplay:flex;\r\n\tflex-wrap: wrap;\r\n\tjustify-content: center;\r\n\tmargin: 0;\r\n\r\n\t// Pagination circle\r\n\t&.pagination-circle {\r\n\t\t.page-link {\r\n\t\t\tborder-radius: 50%;\r\n\t\t}\r\n\t}\r\n\r\n\t// Pagination outline\r\n\t&.pagination-outline {\r\n\t\t.page-link {\r\n\t\t\tborder: 1px solid var(--kt-border-color);\r\n\t\t}\r\n\r\n\t\t.page-item {\r\n\t\t\t&:hover:not(.disabled),\r\n\t\t    &.active {\r\n\t\t\t    .page-link {\r\n\t\t\t        border-color: var(--kt-primary-light);\r\n\t\t\t\t}\t\r\n\t\t\t}\r\n\t\t}\r\n\t}\t\t\r\n}\r\n\r\n.page-item {\r\n    margin-right: $pagination-item-space;\r\n\r\n\t&:last-child {\r\n        margin-right: 0;\r\n    }\r\n\r\n\t.page-link {\r\n\t\tdisplay:flex;\r\n\t\tjustify-content: center;\r\n\t\talign-items: center;\r\n\t\tborder-radius: $btn-border-radius;\r\n\t\theight: $pagination-item-height;\r\n\t\tmin-width: $pagination-item-height;\r\n\t\tfont-weight: $pagination-font-weight;\r\n\t\tfont-size: $pagination-font-size;\r\n\r\n\t\ti {\r\n\t\t\tfont-size: $pagination-icon-font-size;\r\n\t\t}\r\n\r\n\t\t/*rtl:options:{\"autoRename\":false}*/\r\n\t\t.previous,\r\n\t\t.next {\r\n\t\t\tdisplay: block;\r\n\t\t\theight: $pagination-icon-height;\r\n\t\t\twidth: $pagination-icon-height;\r\n\r\n\t\t\t/*rtl:raw:transform: rotateZ(-180deg);*/\r\n\t\t}\r\n\t\t/*rtl:end:ignore*/\r\n\r\n\t\t.previous {\r\n\t\t\t@include svg-bg-icon(arrow-start, $pagination-color);\r\n\t\t}\r\n\r\n\t\t/*rtl:options:{\"autoRename\":false}*/\r\n\t\t.next {\r\n\t\t\t@include svg-bg-icon(arrow-end, $pagination-color);\r\n\t\t}\r\n\t}\r\n\r\n\t&:focus {\r\n\t\t.page-link {\r\n\t\t\tcolor: var(--kt-pagination-focus-color);\r\n\r\n\t\t\t.svg-icon,\r\n\t\t\ti {\r\n\t\t\t\tcolor: var(--kt-pagination-focus-color);\r\n\t\t\t}\r\n\r\n\t\t\t.previous {\r\n\t\t\t\t@include svg-bg-icon(arrow-start, var(--kt-pagination-focus-color));\r\n\t\t\t}\r\n\r\n\t\t\t/*rtl:options:{\"autoRename\":false}*/\r\n\t\t\t.next {\r\n\t\t\t\t@include svg-bg-icon(arrow-end, var(--kt-pagination-focus-color));\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&:hover:not(.active):not(.offset):not(.disabled) {\r\n\t\t.page-link {\r\n\t\t\tcolor: var(--kt-pagination-hover-color);\r\n\t\t\t\r\n\t\t\t&.page-text {\r\n\t\t\t\tbackground-color: transparent;\t\r\n\t\t\t}\r\n\r\n\t\t\t.svg-icon,\r\n\t\t\ti {\r\n\t\t\t\tcolor: var(--kt-pagination-hover-color);\r\n\t\t\t}\r\n\r\n\t\t\t.previous {\r\n\t\t\t\t@include svg-bg-icon(arrow-start, var(--kt-pagination-hover-color));\r\n\t\t\t}\r\n\r\n\t\t\t/*rtl:options:{\"autoRename\":false}*/\r\n\t\t\t.next {\r\n\t\t\t\t@include svg-bg-icon(arrow-end, var(--kt-pagination-hover-color));\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.active {\r\n\t\t.page-link {\r\n\t\t\tcolor: var(--kt-pagination-active-color);\r\n\r\n\t\t\t&.page-text {\r\n\t\t\t\tbackground-color: transparent;\t\r\n\t\t\t}\r\n\r\n\t\t\t.svg-icon,\r\n\t\t\ti {\r\n\t\t\t\tcolor: var(--kt-pagination-active-color);;\r\n\t\t\t}\r\n\t\t\t\t\r\n\t\t\t.previous {\r\n\t\t\t\t@include svg-bg-icon(arrow-start, var(--kt-pagination-active-color));\r\n\t\t\t}\r\n\r\n\t\t\t/*rtl:options:{\"autoRename\":false}*/\r\n\t\t\t.next {\r\n\t\t\t\t@include svg-bg-icon(arrow-end, var(--kt-pagination-active-color));\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.disabled {\r\n\t\t.page-link {\r\n\t\t\tcolor: var(--kt-pagination-disabled-color);\r\n\r\n\t\t\t.svg-icon,\r\n\t\t\ti {\r\n\t\t\t\tcolor: var(--kt-pagination-disabled-color);\r\n\t\t\t}\r\n\r\n\t\t\t.previous {\r\n\t\t\t\t@include svg-bg-icon(arrow-start, var(--kt-pagination-disabled-color));\r\n\t\t\t}\r\n\r\n\t\t\t/*rtl:options:{\"autoRename\":false}*/\r\n\t\t\t.next {\r\n\t\t\t\t@include svg-bg-icon(arrow-end, var(--kt-pagination-disabled-color));\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\t/*rtl:end:ignore*/\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n\t.page-item {\r\n\t\tmargin-right: $pagination-item-space-tablet-and-mobile;\r\n\r\n\t\t&:last-child {\r\n\t\t\tmargin-right: 0;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n","//\r\n// SVG Bg Icons\r\n//\r\n\r\n@mixin svg-bg-icon($type, $color: none, $update: false) {\r\n    $bg-image: '';\r\n\r\n    // Icon type;\r\n    @if ($type == close) {\r\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\r\n    }\r\n\r\n    @if ($type == check) {\r\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 11'><path fill='#{$color}' d='M4.89557 6.49823L2.79487 4.26513C2.26967 3.70683 1.38251 3.70683 0.857309 4.26513C0.375593 4.77721 0.375593 5.57574 0.857309 6.08781L4.74989 10.2257C5.14476 10.6455 5.81176 10.6455 6.20663 10.2257L13.1427 2.85252C13.6244 2.34044 13.6244 1.54191 13.1427 1.02984C12.6175 0.471537 11.7303 0.471536 11.2051 1.02984L6.06096 6.49823C5.74506 6.83403 5.21146 6.83403 4.89557 6.49823Z'/></svg>\");\r\n    }\r\n\r\n    @if ($type == arrow-top) {\r\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='#{$color}'><path d='M3.23571 2.72011L4.97917 4.46358C5.15176 4.63618 5.43158 4.63617 5.60417 4.46358C5.77676 4.29099 5.77676 4.01118 5.60417 3.83861L3.29463 1.52904C3.13192 1.36629 2.86809 1.36629 2.70538 1.52904L0.395812 3.83861C0.22325 4.01117 0.22325 4.29099 0.395812 4.46358C0.568437 4.63617 0.84825 4.63617 1.02081 4.46358L2.76429 2.72011C2.89446 2.58994 3.10554 2.58994 3.23571 2.72011Z'/></svg>\");\r\n    }\r\n\r\n    @if ($type == arrow-bottom) {\r\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='#{$color}'><path d='M2.76429 3.27989L1.02083 1.53642C0.848244 1.36382 0.568419 1.36383 0.395831 1.53642C0.223244 1.70901 0.223244 1.98882 0.395831 2.16139L2.70537 4.47096C2.86808 4.63371 3.13191 4.63371 3.29462 4.47096L5.60419 2.16139C5.77675 1.98883 5.77675 1.70901 5.60419 1.53642C5.43156 1.36383 5.15175 1.36383 4.97919 1.53642L3.23571 3.27989C3.10554 3.41006 2.89446 3.41006 2.76429 3.27989Z'/></svg>\");\r\n    }\r\n\r\n    @if ($type == arrow-start) {\r\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='#{$color}'><path d='M2.72011 2.76429L4.46358 1.02083C4.63618 0.848244 4.63617 0.568419 4.46358 0.395831C4.29099 0.223244 4.01118 0.223244 3.83861 0.395831L1.52904 2.70537C1.36629 2.86808 1.36629 3.13191 1.52904 3.29462L3.83861 5.60419C4.01117 5.77675 4.29099 5.77675 4.46358 5.60419C4.63617 5.43156 4.63617 5.15175 4.46358 4.97919L2.72011 3.23571C2.58994 3.10554 2.58994 2.89446 2.72011 2.76429Z'/></svg>\");\r\n    }\r\n\r\n    @if ($type == arrow-end) {\r\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' fill='#{$color}'><path d='M3.27989 3.23571L1.53642 4.97917C1.36382 5.15176 1.36383 5.43158 1.53642 5.60417C1.70901 5.77676 1.98882 5.77676 2.16139 5.60417L4.47096 3.29463C4.63371 3.13192 4.63371 2.86809 4.47096 2.70538L2.16139 0.395812C1.98883 0.22325 1.70901 0.22325 1.53642 0.395812C1.36383 0.568437 1.36383 0.84825 1.53642 1.02081L3.27989 2.76429C3.41006 2.89446 3.41006 3.10554 3.27989 3.23571Z'/></svg>\");\r\n    }\r\n\r\n    @if ($type == sort) {\r\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='#{$color}'><path fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/></svg>\");\r\n    }\r\n\r\n    @if ($type == sort-asc) {\r\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='#{$color}'><path fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/></svg>\");\r\n    }\r\n\r\n    @if ($type == sort-desc) {\r\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 9' fill='#{$color}'><path fill-rule='evenodd' clip-rule='evenodd' d='M2.06463 4.42111C1.96161 4.22088 1.9809 3.9637 2.12863 3.78597L5.12847 0.177181C5.31402 -0.046034 5.63049 -0.060261 5.83532 0.145404C6.04015 0.351069 6.05578 0.698744 5.87023 0.921959L3.19406 4.14137L5.84414 7.06417C6.03896 7.27904 6.03835 7.62686 5.84278 7.84105C5.64721 8.05524 5.33073 8.05469 5.13591 7.83982L2.14806 4.54449C2.1141 4.50704 2.08629 4.46541 2.06463 4.42111Z'/></svg>\");\r\n    }\r\n\r\n    @if ($type == expand) {\r\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><rect opacity='0.3' x='2' y='2' width='20' height='20' rx='5' fill='#{$color}'/><rect x='10.8891' y='17.8033' width='12' height='2' rx='1' transform='rotate(-90 10.8891 17.8033)' fill='#{$color}'/><rect x='6.01041' y='10.9247' width='12' height='2' rx='1' fill='#{$color}'/></svg>\");\r\n    }\r\n\r\n    @if ($type == collapse) {\r\n        $bg-image: url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'><rect opacity='0.3' x='2' y='2' width='20' height='20' rx='5' fill='#{$color}'/><rect x='6.0104' y='10.9247' width='12' height='2' rx='1' fill='#{$color}'/></svg>\");\r\n    } \r\n\r\n    // Icon style\r\n    @if $update == false {\r\n        mask-repeat: no-repeat;\r\n        mask-position: center;\r\n        -webkit-mask-repeat: no-repeat;\r\n        -webkit-mask-position: center;\r\n    }   \r\n        \r\n    @if $color != none {\r\n        background-color: $color;\r\n    }\r\n\r\n    -webkit-mask-image: escape-svg($bg-image);\r\n    mask-image: escape-svg($bg-image);\r\n}\r\n\r\n","//\r\n// Separator\r\n//\r\n\r\n.separator {\r\n    display: block;\r\n    height: 0;\r\n    border-bottom: 1px solid var(--kt-border-color);\r\n\r\n    &.separator-dotted {\r\n        border-bottom-style: dotted;\r\n        border-bottom-color: var(--kt-border-dashed-color);\r\n    }\r\n\r\n    &.separator-dashed {\r\n        border-bottom-style: dashed;\r\n        border-bottom-color: var(--kt-border-dashed-color);\r\n    }\r\n\r\n    &.separator-content {\r\n        display: flex;\r\n        align-items: center;\r\n        border-bottom: 0;\r\n        text-align: center;\r\n\r\n        &::before,\r\n        &::after {\r\n            content: \" \";\r\n            width: 50%;\r\n            border-bottom: 1px solid var(--kt-border-color);\r\n        }\r\n\r\n        &::before{\r\n            margin-right: 1.25rem;\r\n        }\r\n\r\n        &::after{\r\n            margin-left: 1.25rem;\r\n        }\r\n\r\n        &.separator-dotted {\r\n            &::before,\r\n            &::after {\r\n                border-bottom-style: dotted;\r\n                border-bottom-color: var(--kt-border-dashed-color);\r\n            }\r\n        }\r\n\r\n        &.separator-dashed {\r\n            &::before,\r\n            &::after {\r\n                border-bottom-style: dashed;\r\n                border-bottom-color: var(--kt-border-dashed-color);\r\n            }\r\n        }\r\n\r\n        @each $color, $value in $theme-colors {\r\n            &.border-#{$color}{\r\n                &::before,\r\n                &::after {\r\n                    border-color: $value !important; \r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Carousel\r\n//\r\n\r\n\r\n.carousel-custom {\r\n    // Indicators\r\n    .carousel-indicators {\r\n        align-items: center;\r\n        position: static;\r\n        z-index: auto;\r\n        margin: 0;\r\n        padding: 0;\r\n        list-style: none;\r\n\r\n        li {\r\n            transform: none;\r\n            opacity: 1;\r\n\r\n            &.active {\r\n                transform: none;\r\n                opacity: 1;\r\n            }\r\n        }\r\n\r\n        // Dots style\r\n        &.carousel-indicators-dots {\r\n            li {\r\n                border-radius: 0;\r\n                background-color: transparent;\r\n                height: $carousel-custom-dots-indicator-active-size;\r\n                width: $carousel-custom-dots-indicator-active-size;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                text-align: center;\r\n\r\n                &:after {\r\n                    display: inline-block;\r\n                    content: \" \";\r\n                    @include border-radius(50%);\r\n                    transition: all $carousel-custom-indicator-transition-speed ease;\r\n                    background-color: var(--kt-carousel-custom-indicator-default-bg-color);\r\n                    height: $carousel-custom-dots-indicator-default-size;\r\n                    width: $carousel-custom-dots-indicator-default-size;\r\n                }\r\n\r\n                &.active {\r\n                    background-color: transparent;\r\n\r\n                    &:after {\r\n                        transition: all $carousel-custom-indicator-transition-speed ease;\r\n                        height: $carousel-custom-dots-indicator-active-size;\r\n                        width: $carousel-custom-dots-indicator-active-size;\r\n                        background-color: var(--kt-carousel-custom-indicator-active-bg-color);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        // Bullet style\r\n        &.carousel-indicators-bullet {\r\n            li {\r\n                transition: all $carousel-custom-indicator-transition-speed ease;\r\n                background-color: transparent;\r\n                border-radius: $carousel-custom-bullet-indicator-default-size;\r\n                height: $carousel-custom-bullet-indicator-default-size;\r\n                width: $carousel-custom-bullet-indicator-default-size;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                text-align: center;\r\n\r\n                &:after {\r\n                    display: inline-block;\r\n                    content: \" \";\r\n                    transition: all $carousel-custom-indicator-transition-speed ease;\r\n                    background-color: var(--kt-carousel-custom-bullet-indicator-default-bg-color);\r\n                    border-radius: $carousel-custom-bullet-indicator-default-size;\r\n                    height: $carousel-custom-bullet-indicator-default-size;\r\n                    width: $carousel-custom-bullet-indicator-default-size;\r\n                }\r\n\r\n                &.active {\r\n                    transition: all $carousel-custom-indicator-transition-speed ease;\r\n                    background-color: transparent;\r\n                    height: $carousel-custom-bullet-indicator-default-size;\r\n                    width: $carousel-custom-bullet-indicator-active-width;\r\n\r\n                    &:after {\r\n                        transition: all $carousel-custom-indicator-transition-speed ease;\r\n                        height: $carousel-custom-bullet-indicator-default-size;\r\n                        width: $carousel-custom-bullet-indicator-active-width;\r\n                        background-color: var(--kt-carousel-custom-bullet-indicator-active-bg-color);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // Theme colors\r\n    @each $name, $value in $theme-colors {\r\n        .carousel-indicators-active-#{$name} {\r\n            li.active:after {\r\n                background-color: $value !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    // Stretch mode\r\n    &.carousel-stretch {\r\n        height: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        .carousel-inner {\r\n            flex-grow: 1;\r\n        }\r\n\r\n        .carousel-item {\r\n            height: 100%;\r\n        }\r\n\r\n        .carousel-wrapper {\r\n            display: flex;\r\n            flex-direction: column;\r\n            height: 100%;\r\n        }\r\n    }   \r\n}\r\n","//\r\n// Menu Base\r\n//\r\n\r\n// Menu group\r\n.menu-group {\r\n    display: flex;\r\n}\r\n\r\n// Menu & wrapper\r\n.menu,\r\n.menu-wrapper {\r\n    display: flex;\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n}\r\n\r\n// Sub inner\r\n.menu-inner {\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n}\r\n\r\n// Sub menu\r\n.menu-sub {\r\n    display: none;\r\n    padding: 0;\r\n    margin: 0;\r\n    list-style: none;\r\n    flex-direction: column;\r\n}\r\n\r\n// Menu item\r\n.menu-item {\r\n    display: block;\r\n    padding: $menu-item-padding-y $menu-item-padding-x;\r\n\r\n    // Menu Link\r\n    .menu-link {\r\n        cursor: pointer;\r\n        display: flex;\r\n        align-items: center;\r\n        padding: 0;\r\n        flex: 0 0 100%;\r\n        padding: $menu-link-padding-y $menu-link-padding-x;\r\n        transition: none;\r\n        outline: none !important;\r\n\r\n        .menu-icon {\r\n            flex-shrink: 0;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            width: $menu-icon-size;\r\n            margin-right: $menu-icon-space;\r\n\r\n            .svg-icon {\r\n                line-height: 1;\r\n            }\r\n        }\r\n\r\n        .menu-bullet {\r\n            flex-shrink: 0;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            width: $menu-bullet-size;\r\n            margin-right: $menu-bullet-space;\r\n        }\r\n\r\n        .menu-title {\r\n            display: flex;\r\n            align-items: center;\r\n            flex-grow: 1;\r\n        }\r\n\r\n        .menu-badge {\r\n            display: flex;\r\n            align-items: center;\r\n            flex-shrink: 0;\r\n            margin-left: $menu-badge-space;\r\n        }\r\n\r\n        .menu-arrow {\r\n            display: flex;\r\n            align-items: stretch;\r\n            position: relative;\r\n            overflow: hidden;\r\n            flex-shrink: 0;\r\n            margin-left: $menu-arrow-space;\r\n            width: $menu-arrow-size;\r\n            height: $menu-arrow-size;\r\n\r\n            &:after {\r\n                display: block;\r\n                width: 100%;\r\n                content: \" \";\r\n                will-change: transform;\r\n                background-size: 100% 100%;\r\n                @include svg-bg-icon(arrow-start, var(--kt-text-muted));\r\n                /*rtl:begin:remove*/\r\n                @include svg-bg-icon(arrow-end, var(--kt-text-muted));\r\n                /*rtl:end:remove*/\r\n            }\r\n        }\r\n    }\r\n\r\n    // Menu Content\r\n    .menu-content {\r\n        padding: $menu-link-padding-y $menu-link-padding-x;\r\n    }\r\n}\r\n\r\n// Accordion arrows\r\n.menu-item {    \r\n    &.show {\r\n        .menu-link {\r\n            .menu-arrow:after {                \r\n                backface-visibility: hidden;\r\n                transition: $menu-accordion-arrow-transition;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Center alignment\r\n.menu-center {\r\n    justify-content: center;\r\n}\r\n\r\n// Heading\r\n.menu-heading {\r\n    color: var(--kt-menu-heading-color);    \r\n}\r\n\r\n// Responsive \r\n@each $direction in (up, down) {\r\n    @each $breakpoint in map-keys($grid-breakpoints) {\r\n        $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n        @if $infix and $direction == down {\r\n            $infix: $infix + \"-\" + $direction;\r\n        }\r\n\r\n        @include media-breakpoint-direction($direction, $breakpoint) {\r\n            // Accordion arrow\r\n            .menu-item.menu#{$infix}-accordion {\r\n                .menu-arrow:after {\r\n                    @include menu-link-arrow-rotate(90deg, -90deg);\r\n                }\r\n\r\n                &.showing:not(.menu-dropdown),\r\n                &.show:not(.hiding):not(.menu-dropdown) {\r\n                    > .menu-link {\r\n                        .menu-arrow:after {\r\n                            @include menu-link-arrow-rotate(-90deg, 90deg);\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            // Sub dropdown\r\n            .menu-sub#{$infix}-dropdown {\r\n                display: none;\r\n                border-radius: $menu-dropdown-border-radius;\r\n                background-color: var(--kt-menu-dropdown-bg-color);\r\n                box-shadow: var(--kt-menu-dropdown-box-shadow);\r\n                z-index: $menu-dropdown-z-index;\r\n\r\n                // Dropdown show\r\n                .show.menu-dropdown > &,\r\n                &.menu.show,\r\n                &.show[data-popper-placement] {\r\n                    display: flex;\r\n                    will-change: transform;\r\n                    \r\n                    // Animation\r\n                    @if ($menu-dropdown-animation == true) {\r\n                        // Move up\r\n                        animation: menu-sub-dropdown-animation-fade-in #{$menu-dropdown-animation-speed} ease 1, menu-sub-dropdown-animation-move-up #{$menu-dropdown-animation-speed} ease 1;\r\n                    }                    \r\n                }\r\n            }\r\n\r\n            // Sub accordion\r\n            .menu-sub#{$infix}-accordion {\r\n                display: none;\r\n\r\n                .show:not(.menu-dropdown) > &,\r\n                &.show {\r\n                    display: flex;\r\n                }\r\n            }\r\n\r\n            // Sub indention\r\n            .menu-sub#{$infix}-indention {\r\n                @include menu-sub-indention($menu-accordion-indention);\r\n\r\n                // Active link\r\n                .menu-item .menu-item .menu-link.active {\r\n                    margin-right: $menu-link-padding-x;\r\n                }\r\n            }\r\n\r\n            // Inline\r\n            .menu#{$infix}-inline {\r\n                display: flex;\r\n            }\r\n\r\n            // Reset link left & right paddings of level 1 menu links\r\n            .menu#{$infix}-fit {\r\n                > .menu-item {\r\n                    > .menu-content,\r\n                    > .menu-link {\r\n                        padding-left: 0 !important;\r\n                        padding-right: 0 !important;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .menu#{$infix}-column {\r\n                flex-direction: column;\r\n                width: 100%;\r\n            }\r\n\r\n            .menu#{$infix}-row {\r\n                flex-direction: row;\r\n\r\n                > .menu-item {\r\n                    display: flex;\r\n                    align-items: center;\r\n\r\n                    > .menu-link {\r\n                        .menu-arrow:after {\r\n                            @include menu-link-arrow-rotate(90deg, -90deg);\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            // Border radiuses\r\n            .menu#{$infix}-rounded {\r\n                .menu-link {\r\n                    @include border-radius($menu-link-border-radius);\r\n                }\r\n            }\r\n\r\n            // Border radiuses\r\n            .menu#{$infix}-pill {\r\n                .menu-link {\r\n                    border-radius: 50px;\r\n                }\r\n            }\r\n\r\n            // Reset border radiuses\r\n            .menu#{$infix}-rounded-0 {\r\n                .menu-link {\r\n                    border-radius: 0 !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Link indention\r\n.menu-link-indention {\r\n    .menu-item {\r\n        padding-top: 0;    \r\n        padding-bottom: 0;    \r\n    }\r\n        \r\n    @include menu-link-indention($menu-accordion-indention, $menu-link-padding-x);\r\n}\r\n\r\n// Menu animations\r\n@keyframes menu-sub-dropdown-animation-fade-in {\r\n    from   { \r\n        opacity: 0; \r\n    }\r\n\r\n    to { \r\n        opacity: 1; \r\n    }\r\n}\r\n\r\n@keyframes menu-sub-dropdown-animation-move-up {\r\n    from   { \r\n        margin-top: #{$menu-dropdown-animation-move-offset};\r\n    }\r\n    \r\n    to { \r\n        margin-top: 0;\r\n    }\r\n}\r\n\r\n@keyframes menu-sub-dropdown-animation-move-down {\r\n    from   { \r\n        margin-bottom: #{$menu-dropdown-animation-move-offset};\r\n    }\r\n\r\n    to { \r\n        margin-bottom: 0;\r\n    }\r\n}","//\r\n// Label\r\n//\r\n\r\n// Set arrow direction\r\n@mixin menu-link-arrow-rotate($angle, $angleRtl) {\r\n\t/*rtl:ignore*/\r\n\ttransform: rotateZ($angleRtl);\r\n\t/*rtl:remove*/\r\n\ttransform: rotateZ($angle);\r\n\ttransition: $menu-accordion-arrow-transition;\r\n}\r\n\r\n// Set menu link padding x\r\n@mixin menu-link-padding-x($value) {\r\n\t// Menu item\r\n\t.menu-item {\r\n\t\t.menu-link,\r\n\t\t.menu-content {\r\n\t\t\tpadding-left: $value;\r\n\t\t\tpadding-right: $value;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Set menu link padding y\r\n@mixin menu-link-padding-y($value) {\r\n\t// Menu item\r\n\t.menu-item {\r\n\t\t.menu-link,\r\n\t\t.menu-content {\r\n\t\t\tpadding-top: $value;\r\n\t\t\tpadding-bottom: $value;\r\n\t\t}\r\n\t}\r\n}\r\n\t\r\n// Set link indention\r\n@mixin menu-link-indention($value, $offset) {\r\n\t.menu-sub:not([data-popper-placement]) {\r\n\t\t> .menu-item,\r\n\t\t> .menu-inner > .menu-item {\r\n\t\t\t> .menu-content,\r\n\t\t\t> .menu-link {\r\n\t\t\t\tpadding-left: calc(#{1 * $value} + #{$offset});\r\n\t\t\t}\r\n\r\n\t\t\t> .menu-sub:not([data-popper-placement]) {\r\n\t\t\t\t> .menu-item,\r\n\t\t\t\t> .menu-inner > .menu-item {\r\n\t\t\t\t\t> .menu-content,\r\n\t\t\t\t\t> .menu-link {\r\n\t\t\t\t\t\tpadding-left: calc(#{2 * $value} + #{$offset});\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\t> .menu-sub:not([data-popper-placement]) {\r\n\t\t\t\t\t\t> .menu-item,\r\n\t\t\t\t\t\t> .menu-inner > .menu-item {\r\n\t\t\t\t\t\t\t> .menu-content,\r\n\t\t\t\t\t\t\t> .menu-link {\r\n\t\t\t\t\t\t\t\tpadding-left: calc(#{3 * $value} + #{$offset});\r\n\t\t\t\t\t\t\t}\r\n\r\n\t\t\t\t\t\t\t> .menu-sub:not([data-popper-placement]) {\r\n\t\t\t\t\t\t\t\t> .menu-item,\r\n\t\t\t\t\t\t\t\t> .menu-inner > .menu-item {\r\n\t\t\t\t\t\t\t\t\t> .menu-content,\r\n\t\t\t\t\t\t\t\t\t> .menu-link {\r\n\t\t\t\t\t\t\t\t\t\tpadding-left: calc(#{4 * $value} + #{$offset});\r\n\t\t\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.menu-fit {\r\n\t\t.menu-sub:not([data-popper-placement]) {\r\n\t\t\t> .menu-item,\r\n\t\t\t> .menu-inner > .menu-item {\r\n\t\t\t\t> .menu-content,\r\n\t\t\t\t> .menu-link {\r\n\t\t\t\t\tpadding-left: #{$value};\r\n\t\t\t\t\tpadding-right: 0;\r\n\t\t\t\t}\r\n\t\t\r\n\t\t\t\t> .menu-sub:not([data-popper-placement]) {\r\n\t\t\t\t\t> .menu-item,\r\n\t\t\t\t\t> .menu-inner > .menu-item {\r\n\t\t\t\t\t\t> .menu-content,\r\n\t\t\t\t\t\t> .menu-link {\r\n\t\t\t\t\t\t\tpadding-left: calc(#{2 * $value});\r\n\t\t\t\t\t\t\tpadding-right: 0;\r\n\t\t\t\t\t\t}\r\n\t\t\r\n\t\t\t\t\t\t> .menu-sub:not([data-popper-placement]) {\r\n\t\t\t\t\t\t\t> .menu-item,\r\n\t\t\t\t\t\t\t> .menu-inner > .menu-item {\r\n\t\t\t\t\t\t\t\t> .menu-content,\r\n\t\t\t\t\t\t\t\t> .menu-link {\r\n\t\t\t\t\t\t\t\t\tpadding-left: calc(#{3 * $value});\r\n\t\t\t\t\t\t\t\t\tpadding-right: 0;\r\n\t\t\t\t\t\t\t\t}\r\n\t\t\r\n\t\t\t\t\t\t\t\t> .menu-sub:not([data-popper-placement]) {\r\n\t\t\t\t\t\t\t\t\t> .menu-item,\r\n\t\t\t\t\t\t\t\t\t> .menu-inner > .menu-item {\r\n\t\t\t\t\t\t\t\t\t\t> .menu-content,\r\n\t\t\t\t\t\t\t\t\t\t> .menu-link {\r\n\t\t\t\t\t\t\t\t\t\t\tpadding-left: calc(#{4 * $value});\r\n\t\t\t\t\t\t\t\t\t\t\tpadding-right: 0;\r\n\t\t\t\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t\t}\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Set sub indention\r\n@mixin menu-sub-indention($value) {\r\n\t.menu-sub:not([data-popper-placement]) {\r\n\t\tmargin-left: $value;\r\n\t}\r\n}\r\n\r\n// Set menu link theme\r\n@mixin menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null) {\r\n\t@if ( $bg-color != null ) {\r\n\t\tbackground-color: $bg-color;\r\n\t}\r\n\r\n\t@if ( $title-color != null ) {\r\n\t\tcolor: $title-color;\r\n\r\n\t\t.menu-title {\r\n\t\t\tcolor: $title-color;\r\n\t\t}\r\n\t}\r\n\r\n\t@if ( $icon-color != null ) {\r\n\t\t.menu-icon {\r\n\t\t\t&,\r\n\t\t\t.svg-icon,\r\n\t\t\ti {\r\n\t\t\t\tcolor: $icon-color;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t@if ( $bullet-color != null ) {\r\n\t\t.menu-bullet {\r\n\t\t\t.bullet {\r\n\t\t\t\tbackground-color: $bullet-color;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t@if ( $arrow-color != null ) {\r\n\t\t// Arrow\r\n\t\t.menu-arrow:after {\r\n\t\t\t@include svg-bg-icon(arrow-start, $arrow-color);\r\n\t\t\t/*rtl:begin:remove*/\r\n\t\t\t@include svg-bg-icon(arrow-end, $arrow-color);\r\n\t\t\t/*rtl:end:remove*/\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Set menu link default state\r\n@mixin menu-link-default-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\r\n\t$sel: '';\r\n\r\n\t@if ($all-links == false) {\r\n\t\t$sel: '& > ';\r\n\t}\r\n\r\n\t#{$sel}.menu-link {\r\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\r\n\t}\r\n}\r\n\r\n// Set menu link hover state\r\n@mixin menu-link-hover-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\r\n\t$sel: '&:not(.here) ';\r\n\r\n\t@if ($all-links == false) {\r\n\t\t$sel: '&:not(.here) > ';\r\n\t}\r\n\r\n\t&.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here),\r\n\t#{$sel}.menu-link:hover:not(.disabled):not(.active):not(.here) {\r\n\t\ttransition: $transition-link;\r\n\r\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\r\n\t}\r\n}\r\n\r\n// Set menu link active state\r\n@mixin menu-link-active-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\r\n\t$sel: '';\r\n\r\n\t@if ($all-links == false) {\r\n\t\t$sel: '& > ';\r\n\t}\r\n\r\n\t#{$sel}.menu-link.active {\r\n\t\ttransition: $transition-link;\r\n\r\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\r\n\t}\r\n}\r\n\r\n// Set menu link show state\r\n@mixin menu-link-show-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\r\n\t//&.here > .menu-link,\r\n\t&.show > .menu-link {\r\n\t\ttransition: $transition-link;\r\n\r\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\r\n\t}\r\n}\r\n\r\n// Set menu link here state\r\n@mixin menu-link-here-state($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color: null, $all-links: true) {\r\n\t&.here > .menu-link {\r\n\t\ttransition: $transition-link;\r\n\r\n\t\t@include menu-link-theme($title-color, $icon-color, $bullet-color, $arrow-color, $bg-color);\r\n\t}\r\n}\r\n\r\n// Set menu link default\r\n@mixin menu-link-default($all-links: true) {\r\n\t$sel: '';\r\n\r\n\t@if ($all-links == false) {\r\n\t\t$sel: '& > ';\r\n\t}\r\n\r\n\t#{$sel}.menu-link {\r\n\t\t@content;\r\n\t}\r\n}\r\n\r\n// Set menu link hover\r\n@mixin menu-link-hover($all-links: true) {\r\n\t$sel: '&:not(.here) ';\r\n\r\n\t@if ($all-links == false) {\r\n\t\t$sel: '&:not(.here) > ';\r\n\t}\r\n\r\n\t&.hover:not(.here) > .menu-link:not(.disabled):not(.active):not(.here),\r\n\t#{$sel}.menu-link:hover:not(.disabled):not(.active):not(.here) {\r\n\t\ttransition: $transition-link;\r\n\r\n\t\t@content;\r\n\t}\r\n}\r\n\r\n// Set menu link active\r\n@mixin menu-link-active($all-links: true) {\r\n\t$sel: '';\r\n\r\n\t@if ($all-links == false) {\r\n\t\t$sel: '& > ';\r\n\t}\r\n\r\n\t#{$sel}.menu-link.active {\r\n\t\ttransition: $transition-link;\r\n\r\n\t\t@content;\r\n\t}\r\n}\r\n\r\n// Set menu link show\r\n@mixin menu-link-show($all-links: true) {\r\n\t//&.here > .menu-link,\r\n\t&.show > .menu-link {\r\n\t\ttransition: $transition-link;\r\n\r\n\t\t@content;\r\n\t}\r\n}\r\n\r\n// Set menu link here\r\n@mixin menu-link-here($all-links: true) {\r\n\t&.here > .menu-link {\r\n\t\ttransition: $transition-link;\r\n\r\n\t\t@content;\r\n\t}\r\n}\r\n","// Media of at most the maximum and minimum breakpoint widths. No query for the largest breakpoint.\r\n// Makes the @content apply to the given breakpoint.\r\n\r\n@mixin media-breakpoint-direction($direction, $name, $breakpoints: $grid-breakpoints) {\r\n    @if $direction == up {\r\n        $min: breakpoint-min($name, $breakpoints);\r\n\r\n        @if $min {\r\n            @media (min-width: $min) {\r\n                @content;\r\n            }\r\n        } @else {\r\n            @content;\r\n        }\r\n\r\n    } @else if $direction == down {\r\n        $max: breakpoint-max($name, $breakpoints);\r\n\r\n        @if $max {\r\n            @media (max-width: $max) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}","//\r\n// Menu Theme\r\n//\r\n\r\n// Theme text colors\r\n@each $name, $color in $theme-text-colors {\r\n    .menu-#{$name} {\r\n        .menu-item {\r\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n            @include menu-link-default-state( var(--kt-#{$name}), var(--kt-#{$name}), var(--kt-#{$name}), var(--kt-#{$name}), null );\r\n        }\r\n    }\r\n\r\n    .menu-title-#{$name} {\r\n        .menu-item {\r\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n            @include menu-link-default-state( var(--kt-text-#{$name}), null, null, null, null );\r\n        }\r\n    }\r\n\r\n    .menu-icon-#{$name} {\r\n        .menu-item {\r\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n            @include menu-link-default-state( null, var(--kt-text-#{$name}), null, null, null );\r\n        }\r\n    }\r\n\r\n    .menu-bullet-#{$name} {\r\n        .menu-item {\r\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n            @include menu-link-default-state( null, null, var(--kt-text-#{$name}), null, null );\r\n        }\r\n    }\r\n\r\n    .menu-arrow-#{$name} {\r\n        .menu-item {\r\n            //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n            @include menu-link-default-state( null, null, null, var(--kt-text-#{$name}), null );\r\n        }\r\n    }\r\n}\r\n\r\n// Default background states\r\n.menu-hover-bg {\r\n    .menu-item {\r\n        @include menu-link-hover-state( \r\n            var(--kt-menu-link-color-hover), \r\n            var(--kt-menu-link-color-hover), \r\n            var(--kt-menu-link-color-hover), \r\n            var(--kt-menu-link-color-hover), \r\n            var(--kt-menu-link-bg-color-hover) \r\n        );\r\n    }\r\n}\r\n\r\n.menu-here-bg {\r\n    .menu-item {\r\n        @include menu-link-here-state( \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-bg-color-here) \r\n        );\r\n    }\r\n}\r\n\r\n.menu-root-here-bg {\r\n    > .menu-item {\r\n        @include menu-link-here-state( \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-bg-color-here) \r\n        );\r\n    }\r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    .menu-root-here-bg-desktop {\r\n        > .menu-item {\r\n            @include menu-link-here-state( \r\n                var(--kt-menu-link-color-here), \r\n                var(--kt-menu-link-color-here), \r\n                var(--kt-menu-link-color-here), \r\n                var(--kt-menu-link-color-here), \r\n                var(--kt-menu-link-bg-color-here) \r\n            );\r\n        }\r\n    }\r\n}\r\n\r\n.menu-show-bg {\r\n    .menu-item {\r\n        @include menu-link-show-state( \r\n            var(--kt-menu-link-color-show), \r\n            var(--kt-menu-link-color-show), \r\n            var(--kt-menu-link-color-show), \r\n            var(--kt-menu-link-color-show), \r\n            var(--kt-menu-link-bg-color-show) \r\n        );\r\n    }\r\n}\r\n\r\n.menu-active-bg {\r\n    .menu-item {\r\n        @include menu-link-active-state( \r\n            var(--kt-menu-link-color-active), \r\n            var(--kt-menu-link-color-active), \r\n            var(--kt-menu-link-color-active), \r\n            var(--kt-menu-link-color-active), \r\n            var(--kt-menu-link-bg-color-active) \r\n        );\r\n    }\r\n}\r\n\r\n.menu-state-bg {\r\n    .menu-item {\r\n        @include menu-link-hover-state( \r\n            var(--kt-menu-link-color-hover), \r\n            var(--kt-menu-link-color-hover), \r\n            var(--kt-menu-link-color-hover), \r\n            var(--kt-menu-link-color-hover), \r\n            var(--kt-menu-link-bg-color-hover) \r\n        );\r\n\r\n        @include menu-link-here-state( \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-bg-color-here) \r\n        );\r\n\r\n        @include menu-link-show-state( \r\n            var(--kt-menu-link-color-show), \r\n            var(--kt-menu-link-color-show), \r\n            var(--kt-menu-link-color-show), \r\n            var(--kt-menu-link-color-show), \r\n            var(--kt-menu-link-bg-color-show) \r\n        );\r\n\r\n        @include menu-link-active-state( \r\n            var(--kt-menu-link-color-active), \r\n            var(--kt-menu-link-color-active), \r\n            var(--kt-menu-link-color-active), \r\n            var(--kt-menu-link-color-active), \r\n            var(--kt-menu-link-bg-color-active) \r\n        );\r\n    }\r\n}\r\n\r\n.menu-state-color {\r\n    .menu-item {\r\n        @include menu-link-hover-state( \r\n            var(--kt-menu-link-color-hover), \r\n            var(--kt-menu-link-color-hover), \r\n            var(--kt-menu-link-color-hover), \r\n            var(--kt-menu-link-color-hover), \r\n            null\r\n        );\r\n\r\n        @include menu-link-here-state( \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-color-here), \r\n            var(--kt-menu-link-color-here), \r\n            null\r\n        );\r\n\r\n        @include menu-link-show-state( \r\n            var(--kt-menu-link-color-show), \r\n            var(--kt-menu-link-color-show), \r\n            var(--kt-menu-link-color-show), \r\n            var(--kt-menu-link-color-show), \r\n            null\r\n        );\r\n\r\n        @include menu-link-active-state( \r\n            var(--kt-menu-link-color-active), \r\n            var(--kt-menu-link-color-active), \r\n            var(--kt-menu-link-color-active), \r\n            var(--kt-menu-link-color-active), \r\n            null\r\n        );\r\n    }\r\n}\r\n\r\n// Primary background states\r\n.menu-hover-bg-primary {\r\n    .menu-item {\r\n        @include menu-link-hover-state( \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary) \r\n        );\r\n    }\r\n}\r\n\r\n.menu-show-bg-primary {\r\n    .menu-item {\r\n        @include menu-link-show-state( \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary) \r\n        );\r\n    }\r\n}\r\n\r\n.menu-here-bg-primary {\r\n    .menu-item {\r\n        @include menu-link-here-state( \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary)\r\n        );\r\n    }\r\n}\r\n\r\n.menu-active-bg-primary {\r\n    .menu-item {\r\n        @include menu-link-active-state( \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary)\r\n        );\r\n    }\r\n}\r\n\r\n.menu-state-bg-primary {\r\n    .menu-item {\r\n        @include menu-link-hover-state( \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary) \r\n        );\r\n\r\n        @include menu-link-show-state( \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary) \r\n        );\r\n\r\n        @include menu-link-here-state( \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary)\r\n        );\r\n\r\n        @include menu-link-active-state( \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary)\r\n        );\r\n\r\n        @include menu-link-show-state( \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary-inverse), \r\n            var(--kt-primary) \r\n        );\r\n    }\r\n}\r\n\r\n// Light primary background states\r\n.menu-show-bg-light-primary {\r\n    .menu-item {\r\n        @include menu-link-show-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary-light) );\r\n    }\r\n}\r\n\r\n.menu-here-bg-light-primary {\r\n    .menu-item {\r\n        @include menu-link-here-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary-light) );\r\n    }\r\n}\r\n\r\n.menu-hover-bg-light-primary {\r\n    .menu-item {\r\n        @include menu-link-hover-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary-light) );\r\n    }\r\n}\r\n\r\n.menu-active-bg-light-primary {\r\n    .menu-item {\r\n        @include menu-link-active-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary-light) );\r\n    }\r\n}\r\n\r\n.menu-state-bg-light-primary {\r\n    .menu-item {\r\n        @include menu-link-show-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary-light) );\r\n        @include menu-link-here-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary-light) );\r\n        @include menu-link-hover-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary-light) );\r\n        @include menu-link-active-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary-light) );\r\n    }\r\n}\r\n\r\n// Primary color states\r\n.menu-hover-primary {\r\n    .menu-item {\r\n        @include menu-link-hover-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), null );\r\n    }\r\n}\r\n\r\n.menu-show-primary {\r\n    .menu-item {\r\n        @include menu-link-show-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), null );\r\n    }\r\n}\r\n\r\n.menu-here-primary {\r\n    .menu-item {\r\n        @include menu-link-here-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), null );\r\n    }\r\n}\r\n\r\n.menu-active-primary {\r\n    .menu-item {\r\n        @include menu-link-active-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), null );\r\n    }\r\n}\r\n\r\n.menu-state-primary {\r\n    .menu-item {\r\n        @include menu-link-hover-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), null );\r\n        @include menu-link-show-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), null );\r\n        @include menu-link-here-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), null );\r\n        @include menu-link-active-state( var(--kt-primary), var(--kt-primary), var(--kt-primary), var(--kt-primary), null );\r\n    }\r\n}\r\n\r\n.menu-state-dark {\r\n    .menu-item {\r\n        @include menu-link-hover-state( var(--kt-dark), var(--kt-dark), var(--kt-dark), var(--kt-dark), null );\r\n        @include menu-link-show-state( var(--kt-dark), var(--kt-dark), var(--kt-dark), var(--kt-dark), null );\r\n        @include menu-link-here-state( var(--kt-dark), var(--kt-dark), var(--kt-dark), var(--kt-dark), null );\r\n        @include menu-link-active-state( var(--kt-dark), var(--kt-dark), var(--kt-dark), var(--kt-dark), null );\r\n    }\r\n}\r\n\r\n// Primary title color states\r\n.menu-hover-title-primary {\r\n    .menu-item {\r\n        @include menu-link-hover-state( var(--kt-primary), null, null, null, null );\r\n    }\r\n}\r\n\r\n.menu-here-title-primary {\r\n    .menu-item {\r\n        @include menu-link-here-state( var(--kt-primary), null, null, null, null );\r\n    }\r\n}\r\n\r\n.menu-show-title-primary {\r\n    .menu-item {\r\n        @include menu-link-show-state( var(--kt-primary), null, null, null, null );\r\n    }\r\n}\r\n\r\n.menu-active-title-primary {\r\n    .menu-item {\r\n        @include menu-link-active-state( var(--kt-primary), null, null, null, null );\r\n    }\r\n}\r\n\r\n.menu-state-title-primary {\r\n    .menu-item {\r\n        @include menu-link-hover-state( var(--kt-primary), null, null, null, null );\r\n        @include menu-link-here-state( var(--kt-primary), null, null, null, null );\r\n        @include menu-link-show-state( var(--kt-primary), null, null, null, null );\r\n        @include menu-link-active-state( var(--kt-primary), null, null, null, null );\r\n    }\r\n}\r\n\r\n// Primary icon color states\r\n.menu-hover-icon-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-hover-state( null, var(--kt-primary), null, null, null );\r\n    }\r\n}\r\n\r\n.menu-here-icon-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-here-state( null, var(--kt-primary), null, null, null );\r\n    }\r\n}\r\n\r\n.menu-show-icon-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-show-state( null, var(--kt-primary), null, null, null );\r\n    }\r\n}\r\n\r\n.menu-active-icon-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-active-state( null, var(--kt-primary), null, null, null );\r\n    }\r\n}\r\n\r\n.menu-state-icon-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-hover-state( null, var(--kt-primary), null, null, null );\r\n        @include menu-link-here-state( null, var(--kt-primary), null, null, null );\r\n        @include menu-link-show-state( null, var(--kt-primary), null, null, null );\r\n        @include menu-link-active-state( null, var(--kt-primary), null, null, null );\r\n    }\r\n}\r\n\r\n// Primary bullet color states\r\n.menu-hover-bullet-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-hover-state( null, null, var(--kt-primary), null, null );\r\n    }\r\n}\r\n\r\n.menu-show-bullet-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-show-state( null, null, var(--kt-primary), null, null );\r\n    }\r\n}\r\n\r\n.menu-here-bullet-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-here-state( null, null, var(--kt-primary), null, null );\r\n    }\r\n}\r\n\r\n.menu-active-bullet-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-active-state( null, null, var(--kt-primary), null, null );\r\n    }\r\n}\r\n\r\n.menu-state-bullet-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-hover-state( null, null, var(--kt-primary), null, null );\r\n        @include menu-link-here-state( null, null, var(--kt-primary), null, null );\r\n        @include menu-link-show-state( null, null, var(--kt-primary), null, null );\r\n        @include menu-link-active-state( null, null, var(--kt-primary), null, null );\r\n    }\r\n}\r\n\r\n// Primary arrow color states\r\n.menu-hover-arrow-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-hover-state( null, null, null, var(--kt-primary), null );\r\n    }\r\n}\r\n\r\n.menu-here-arrow-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-here-state( null, null, null, var(--kt-primary), null );\r\n    }\r\n}\r\n\r\n.menu-show-arrow-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-show-state( null, null, null, var(--kt-primary), null );\r\n    }\r\n}\r\n\r\n.menu-active-arrow-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-active-state( null, null, null, var(--kt-primary), null );\r\n    }\r\n}\r\n\r\n.menu-state-arrow-primary {\r\n    .menu-item {\r\n        //$title-color, $icon-color, $bullet-color, $arrow-color, $bg-color\r\n        @include menu-link-hover-state( null, null, null, var(--kt-primary), null );\r\n        @include menu-link-here-state( null, null, null, var(--kt-primary), null );\r\n        @include menu-link-show-state( null, null, null, var(--kt-primary), null );\r\n        @include menu-link-active-state( null, null, null, var(--kt-primary), null );\r\n    }\r\n}\r\n","//\r\n// Anchor\r\n//\r\n\r\n.anchor {\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    a {\r\n        position: relative;\r\n        display: none;\r\n        align-items: center;\r\n        justify-content:flex-start;\r\n        height: 1em;\r\n        width: 1.25em;\r\n        margin-left: -1.25em;\r\n        font-weight: 500;\r\n        font-size: 0.8em;\r\n        color: var(--kt-text-muted);\r\n        transition: $transition-base;\r\n\r\n        &:before {\r\n            content: '#';\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        a {\r\n            display: flex;\r\n\r\n            &:hover {\r\n                color: var(--kt-primary);\r\n                transition: $transition-base;\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Card\r\n//\r\n\r\n// Base\r\n.card {    \r\n    @if ($card-border-enabled)  {\r\n        border: $card-border-width $card-border-style var(--kt-card-border-color);\r\n    } @else {\r\n        border: 0;\r\n    }  \r\n    \r\n    box-shadow: var(--kt-card-box-shadow); \r\n    background-color: var(--kt-card-bg);\r\n\r\n    // Header\r\n    .card-header {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: stretch;\r\n        flex-wrap: wrap;\r\n        min-height: $card-header-height;\r\n        padding: 0 $card-px;\r\n        color: var(--kt-card-cap-color);\r\n        background-color: var(--kt-card-cap-bg);\r\n        border-bottom: $card-border-width $card-border-style var(--kt-card-border-color);\r\n\r\n        // Title\r\n        .card-title {\r\n            display: flex;\r\n            align-items: center;\r\n            margin: $card-header-py;\r\n            margin-left: 0;\r\n\r\n            &.flex-column {\r\n                align-items: flex-start;\r\n                justify-content: center;\r\n            }\r\n\r\n            .card-icon {\r\n                margin-right: 0.75rem;\r\n                line-height: 0;\r\n\r\n                i {\r\n                    font-size: 1.25rem;\r\n                    color: var(--kt-gray-600);\r\n                    line-height: 0;\r\n\r\n                    &:after,\r\n                    &:before {\r\n                        line-height: 0;\r\n                    }\r\n                }\r\n\r\n                .svg-icon {\r\n                    color: var(--kt-gray-600);\r\n                    @include svg-icon-size(24px);\r\n                }\r\n            }\r\n\r\n            &,\r\n            .card-label {\r\n                font-weight: 500;\r\n                font-size: 1.275rem;\r\n                color: var(--kt-text-dark);\r\n            }\r\n\r\n            .card-label {\r\n                margin: 0 0.75rem 0 0;\r\n                flex-wrap: wrap;\r\n            }\r\n\r\n            // Description\r\n            small {\r\n                color: var(--kt-text-muted);\r\n                font-size: 1rem;\r\n            }\r\n\r\n            // Headings\r\n            h1, h2, h3, h4, h5, h6 {\r\n                margin-bottom: 0;\r\n            }\r\n        }\r\n\r\n        // Toolbar\r\n        .card-toolbar {\r\n            display: flex;\r\n            align-items: center;\r\n            margin: $card-header-py 0;\r\n            flex-wrap: wrap;\r\n        }\r\n    }\r\n\r\n    // Body\r\n    .card-body {\r\n        padding: $card-py $card-px;\r\n        color: var(--kt-card-color);\r\n    }\r\n\r\n    // Footer\r\n    .card-footer {\r\n        padding: $card-py $card-px;\r\n        color: var(--kt-card-cap-color);\r\n        background-color: var(--kt-card-cap-bg);\r\n        border-top: $card-border-width $card-border-style var(--kt-card-border-color);\r\n    }\r\n\r\n    // Scroll\r\n    .card-scroll {\r\n        position: relative;\r\n        overflow: auto;\r\n    }\r\n\r\n    // Reset padding x\r\n    &.card-px-0 {\r\n        .card-header,\r\n        .card-body,\r\n        .card-footer {\r\n            padding-left: 0;\r\n            padding-right: 0;\r\n        }\r\n    }\r\n\r\n    &.card-py-0 {\r\n        .card-header,\r\n        .card-body,\r\n        .card-footer {\r\n            padding-top: 0;\r\n            padding-bottom: 0;\r\n        }\r\n    }\r\n\r\n    &.card-p-0 {\r\n        .card-header,\r\n        .card-body,\r\n        .card-footer {\r\n            padding: 0;\r\n        }\r\n    }\r\n\r\n    // Dashed style\r\n    &.card-dashed {\r\n        box-shadow: none;\r\n        border: $card-border-width dashed var(--kt-card-border-dashed-color);\r\n\r\n        > .card-header {\r\n            border-bottom: 1px dashed var(--kt-card-border-dashed-color);\r\n        }\r\n\r\n        > .card-footer {\r\n            border-top: 1px dashed var(--kt-card-border-dashed-color);\r\n        }\r\n    }\r\n\r\n    // Bordered style\r\n    &.card-bordered {\r\n        box-shadow: none;\r\n        border: $card-border-width $card-border-style var(--kt-card-border-color);\r\n    }\r\n\r\n    // Flush header and footer borders\r\n    &.card-flush {\r\n        > .card-header {\r\n            border-bottom: 0 !important;\r\n        }\r\n\r\n        > .card-footer {\r\n            border-top: 0 !important;\r\n        }\r\n    }\r\n    \r\n    // Enable shadow\r\n    &.card-shadow {\r\n        box-shadow: var(--kt-card-box-shadow);\r\n        border: 0;\r\n    }\r\n\r\n    // Reset styles\r\n    &.card-reset {\r\n        border: 0 !important;\r\n        box-shadow: none !important;\r\n        background-color: transparent !important;\r\n\r\n        > .card-header {\r\n            border-bottom: 0 !important;\r\n        }\r\n\r\n        > .card-footer {\r\n            border-top: 0 !important;\r\n        }\r\n    }\r\n}\r\n\r\n// Responsive stretch heights\r\n.card {\r\n    @each $breakpoint in map-keys($grid-breakpoints) {\r\n    \t@include media-breakpoint-up($breakpoint) {\r\n    \t\t$infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n            // Stretch\r\n            &.card#{$infix}-stretch {\r\n                height: calc(100% - var(--bs-gutter-y));\r\n            }\r\n\r\n            // Stretch 75\r\n            &.card#{$infix}-stretch-75 {\r\n                height: calc(75% - var(--bs-gutter-y));\r\n            }\r\n\r\n            // Stretch 50\r\n            &.card#{$infix}-stretch-50 {\r\n                height: calc(50% - var(--bs-gutter-y));\r\n            }\r\n\r\n             // Stretch 33\r\n            &.card#{$infix}-stretch-33 {\r\n                height: calc(33.333% - var(--bs-gutter-y));\r\n            }\r\n\r\n            // Stretch 25\r\n            &.card#{$infix}-stretch-25 {\r\n                height: calc(25% - var(--bs-gutter-y));\r\n            }\r\n\r\n            // Header stretch\r\n            .card-header#{$infix}-stretch {\r\n                padding-top: 0 !important;\r\n                padding-bottom: 0 !important;\r\n                align-items: stretch;\r\n    \r\n                .card-toolbar {\r\n                    margin: 0;\r\n                    align-items: stretch;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Utilities\r\n.card-p {\r\n    padding: $card-py $card-px !important;\r\n}\r\n\r\n.card-px {\r\n    padding-left: $card-px !important;\r\n    padding-right: $card-px !important;\r\n}\r\n\r\n.card-shadow {\r\n    box-shadow: var(--kt-card-box-shadow);\r\n}\r\n\r\n.card-py {\r\n    padding-top: $card-py !important;\r\n    padding-bottom: $card-py !important;\r\n}\r\n\r\n.card-rounded {\r\n    border-radius: $card-border-radius;\r\n}\r\n\r\n.card-rounded-start {\r\n    border-top-left-radius: $card-border-radius;\r\n    border-bottom-left-radius: $card-border-radius;\r\n}\r\n\r\n.card-rounded-end {\r\n    border-top-right-radius: $card-border-radius;\r\n    border-bottom-right-radius: $card-border-radius;\r\n}\r\n\r\n.card-rounded-top {\r\n    border-top-left-radius: $card-border-radius;\r\n    border-top-right-radius: $card-border-radius;\r\n}\r\n\r\n.card-rounded-bottom {\r\n    border-bottom-left-radius: $card-border-radius;\r\n    border-bottom-right-radius: $card-border-radius;\r\n}\r\n\r\n// Mobile mode\r\n@include media-breakpoint-down(md) {\r\n    .card {\r\n        > .card-header:not(.flex-nowrap) {\r\n            padding-top: $card-header-py;\r\n            padding-bottom: $card-header-py;\r\n        }\r\n    }\r\n}\r\n","//\r\n// SVG Icon\r\n//\r\n\r\n\r\n@mixin svg-icon-size($size, $important: false) {\r\n    svg {\r\n        height: $size valueif($important, !important, null);\r\n        width: $size valueif($important, !important, null);\r\n    }\r\n}\r\n","//\r\n// Breadcrumb\r\n//\r\n\r\n// Breadcrumb\r\n.breadcrumb {\r\n    --#{$prefix}breadcrumb-bg: var(--kt-breadcrumb-bg);\r\n    --#{$prefix}breadcrumb-divider-color: var(--kt-breadcrumb-divider-color);\r\n    --#{$prefix}breadcrumb-item-active-color: var(--kt-breadcrumb-item-active-color);\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: transparent;\r\n    padding: 0;\r\n    margin: 0;    \r\n\r\n    // Item breadcrumb\r\n    .breadcrumb-item {\r\n        display: flex;\r\n        align-items: center;\r\n        padding-left: 0;\r\n        padding-right: $breadcrumb-item-padding-x;\r\n\r\n        &:last-child {\r\n            padding-right: 0;\r\n        }\r\n\r\n        &:after {\r\n            content: \"/\";\r\n            //padding-left: $breadcrumb-item-padding-x;\r\n        }\r\n\r\n        &:before {\r\n            display: none;\r\n        }\r\n\r\n        &:last-child {\r\n            &:after {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Breadcrumb line style\r\n.breadcrumb-line {\r\n    .breadcrumb-item {\r\n        &:after {\r\n            content: \"-\";\r\n        }\r\n    }\r\n}\r\n\r\n// Breadcrumb dot style\r\n.breadcrumb-dot {\r\n    .breadcrumb-item {\r\n        &:after {\r\n            content: \"\\2022\";\r\n        }\r\n    }\r\n}\r\n\r\n// Breadcrumb separatorless style\r\n.breadcrumb-separatorless {\r\n    .breadcrumb-item {\r\n        &:after {\r\n            display:none;\r\n        }\r\n    }\r\n}","//\r\n// Buttons Base\r\n//\r\n\r\n// Button\r\n.btn {\r\n\t--#{$prefix}btn-color: var(--kt-body-color);\r\n\t--#{$prefix}btn-bg: transparent;\r\n\t--#{$prefix}btn-border-color: transparent;\r\n\r\n\t// Reset outline\r\n\toutline: none !important;\t\r\n\r\n\t// Reset focus shadow\r\n\t&:not(.btn-shadow):not(.shadow):not(.shadow-sm):not(.shadow-lg):not(.shadow-xs) {\r\n\t\tbox-shadow: none !important;\r\n\t}\r\n\r\n\t// Remove border\r\n\t&:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush):not(.btn-icon) {\r\n\t\tborder: 0;\r\n\t\tpadding: calc(#{$btn-padding-y} + #{$btn-border-width}) calc(#{$btn-padding-x} + #{$btn-border-width});\r\n\r\n\t\t&.btn-lg {\r\n\t\t\tpadding: calc(#{$btn-padding-y-lg} + #{$btn-border-width}) calc(#{$btn-padding-x-lg} + #{$btn-border-width});\r\n\t\t}\r\n\r\n\t\t&.btn-sm {\r\n\t\t\tpadding: calc(#{$btn-padding-y-sm} + #{$btn-border-width}) calc(#{$btn-padding-x-sm} + #{$btn-border-width});\r\n\t\t}\r\n\t}\r\n\r\n\t// Link\r\n\t&.btn-link {\r\n\t\tborder: 0;\r\n\t\tborder-radius: 0;\r\n\t\tpadding-left: 0 !important;\r\n\t\tpadding-right: 0 !important;\r\n\t\ttext-decoration: none;\r\n\t\tfont-weight: $btn-font-weight;\r\n\t}\r\n \r\n\t// Outline\r\n\t&.btn-outline:not(.btn-outline-dashed) {\r\n\t\tborder: 1px solid var(--kt-input-border-color);\r\n\t}\r\n\r\n\t// Outline dashed\r\n\t&.btn-outline-dashed {\r\n\t\tborder: 1px dashed var(--kt-input-border-color);\r\n\t}\r\n\r\n\t// Flush\r\n\t&.btn-flush {\r\n\t\t@include button-reset();\r\n\t}\r\n\r\n\t// Flex\r\n\t&.btn-flex {\t\t\r\n\t\tdisplay: inline-flex;\r\n\t\talign-items: center;\r\n\t}\r\n\r\n\t// Align start\r\n\t&.btn-trim-start {\r\n\t\tjustify-content: flex-start !important;\r\n\t\tpadding-left: 0 !important;\t\t\r\n\t}\r\n\r\n\t// Align start\r\n\t&.btn-trim-end {\r\n\t\tjustify-content: flex-end !important;\r\n\t\tpadding-right: 0 !important;\t\r\n\t} \r\n}\r\n\r\n// Icons\r\n.btn {\r\n\t// Font icon\r\n\ti {\r\n\t\tdisplay: inline-flex;\r\n\t\tfont-size: $font-size-base;\r\n\t\tpadding-right: 0.35rem;\r\n\t\tvertical-align: middle;\r\n\t\tline-height: 0;\r\n\t}\r\n\r\n\t// Svg icon\r\n\t.svg-icon {\r\n\t\tflex-shrink: 0;\r\n\t\tline-height: 0;\r\n\t\tmargin-right: 0.5rem;\r\n\t}\r\n\r\n\t// Icon only button\r\n\t&.btn-icon {\r\n\t\tdisplay: inline-flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\tpadding: 0;\r\n\t\theight: $input-height;\r\n\t\twidth: $input-height;\r\n\r\n\t\t// Remove border\r\n\t\t&:not(.btn-outline):not(.btn-dashed):not(.border-hover):not(.border-active):not(.btn-flush) {\r\n\t\t\tborder: 0;\r\n\t\t}\r\n\r\n\t\t// Sizes\r\n\t\t&.btn-sm {\r\n\t\t\theight: $input-height-sm;\r\n\t\t\twidth: $input-height-sm;\r\n\t\t\t \r\n\t\t}\r\n\r\n\t\t&.btn-lg {\r\n\t\t\theight: $input-height-lg;\r\n\t\t\twidth: $input-height-lg;\r\n\t\t}\r\n\r\n\t\t&.btn-circle {\r\n\t\t\tborder-radius: 50%;\r\n\t\t}\r\n\r\n\t\ti,\r\n\t\t.svg-icon {\r\n\t\t\tpadding: 0;\r\n\t\t\tmargin: 0;\r\n\t\t\tline-height: 1;\r\n\t\t}\r\n\t}\r\n}\r\n","//\r\n// Reset\r\n//\r\n\r\n@mixin button-reset() {\r\n    appearance: none;\r\n    box-shadow: none;\r\n    border-radius: 0;\r\n    border: none;\r\n    cursor: pointer;\r\n    background-color: transparent;\r\n    outline: none  !important;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n@mixin input-reset() {\r\n\tborder: 0;\r\n\tbackground-color: transparent;\r\n    outline: none !important;\r\n\tbox-shadow: none;\r\n    border-radius: 0;\r\n}\r\n","//\r\n// Buttons Theme\r\n//\r\n\r\n// Outline dashed basic style\r\n.btn.btn-outline.btn-outline-dashed {\r\n\tborder-width: 1px;\r\n\tborder-style: dashed;\t\r\n\t\r\n\t$color: null;\r\n\t$icon-color: null;\r\n\t$border-color: null;\r\n\t$bg-color: null;;\r\n\r\n\t$color-active: null;\r\n\t$icon-color-active: null;\r\n\t$border-color-active: var(--kt-primary);\r\n\t$bg-color-active: null;\r\n\r\n\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n}\r\n\r\n// Theme colors\r\n@each $name, $value in $theme-colors {\r\n\t// Base\r\n\t.btn.btn-#{$name} {\r\n\t\t$color: var(--kt-#{$name}-inverse);\r\n\t\t$icon-color: var(--kt-#{$name}-inverse);\r\n\t\t$border-color: var(--kt-#{$name});\r\n\t\t$bg-color: var(--kt-#{$name});\r\n\r\n\t\t$color-active: var(--kt-#{$name}-inverse);\r\n\t\t$icon-color-active: var(--kt-#{$name}-inverse);\r\n\t\t$border-color-active: var(--kt-#{$name}-active);\r\n\t\t$bg-color-active: var(--kt-#{$name}-active);\r\n\r\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n\t}\r\n\r\n\t// Light\r\n\t@if ( theme-light-color($name) ) {\r\n\t\t.btn.btn-light-#{$name} {\r\n\t\t\t$color: var(--kt-#{$name});\r\n\t\t\t$icon-color: var(--kt-#{$name});\r\n\t\t\t$border-color: var(--kt-#{$name}-light);\r\n\t\t\t$bg-color: var(--kt-#{$name}-light);\r\n\t\r\n\t\t\t$color-active: var(--kt-#{$name}-inverse);\r\n\t\t\t$icon-color-active: var(--kt-#{$name}-inverse);\r\n\t\t\t$border-color-active: var(--kt-#{$name});\r\n\t\t\t$bg-color-active: var(--kt-#{$name});\r\n\t\r\n\t\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n\t\t}\r\n\t}\t\r\n\r\n\t// Background\r\n\t.btn.btn-bg-#{$name} {\r\n\t\t$color: null;\r\n\t\t$icon-color: null;\r\n\t\t$border-color: var(--kt-#{$name});\r\n\t\t$bg-color: var(--kt-#{$name});\t\t\r\n\r\n\t\t$color-active: null;\r\n\t\t$icon-color-active: null;\r\n\t\t$border-color-active: null;\r\n\t\t$bg-color-active: null;\t\t\t\r\n\r\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n\t}\r\n\t\r\n\t// Active\r\n\t.btn.btn-active-#{$name} {\r\n\t\t$color: null;\r\n\t\t$icon-color: null;\r\n\t\t$border-color: null;\r\n\t\t$bg-color: null;\r\n\r\n\t\t$color-active: var(--kt-#{$name}-inverse);\r\n\t\t$icon-color-active: var(--kt-#{$name}-inverse);\r\n\t\t$border-color-active: var(--kt-#{$name});\r\n\t\t$bg-color-active: var(--kt-#{$name});\r\n\r\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n\t}\r\n\r\n\t// Light\r\n\t@if ( theme-light-color($name) ) {\r\n\t\t.btn.btn-active-light-#{$name} {\r\n\t\t\t$color: null;\r\n\t\t\t$icon-color: null;\r\n\t\t\t$border-color: null;\r\n\t\t\t$bg-color: null;\r\n\r\n\t\t\t$color-active: var(--kt-#{$name});\r\n\t\t\t$icon-color-active: var(--kt-#{$name});\r\n\t\t\t$border-color-active: var(--kt-#{$name}-light);\r\n\t\t\t$bg-color-active: var(--kt-#{$name}-light);\r\n\r\n\t\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n\t\t}\r\n\t}\r\n\r\n\t// Outline\r\n\t.btn.btn-outline.btn-outline-#{$name} {\r\n\t\t$color: var(--kt-#{$name});\r\n\t\t$icon-color: var(--kt-#{$name});\r\n\t\t$border-color: var(--kt-#{$name});\r\n\t\t$bg-color: transparent;\r\n\r\n\t\t$color-active: var(--kt-#{$name}-active);\r\n\t\t$icon-color-active: var(--kt-#{$name}-active);\r\n\t\t$border-color-active: var(--kt-#{$name});\r\n\t\t$bg-color-active: var(--kt-#{$name}-light);\r\n\r\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n\t}\r\n}\r\n\r\n// Theme text colors\r\n@each $name, $value in $theme-text-colors {\r\n\t// Text and icon colors\r\n\t.btn.btn-color-#{$name} {\r\n\t\t$color: var(--kt-text-#{$name});\r\n\t\t$icon-color: var(--kt-text-#{$name});\r\n\t\t$bg-color: null;\r\n\t\t$border-color: null;\r\n\r\n\t\t$color-active: null;\r\n\t\t$icon-color-active: null;\r\n\t\t$border-color-active: null;\r\n\t\t$bg-color-active: null;\r\n\r\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n\t}\r\n\r\n\t// Text and icon colors active state\r\n\t.btn.btn-active-color-#{$name} {\r\n\t\t$color: null;\r\n\t\t$icon-color: null;\r\n\t\t$border-color: null;\r\n\t\t$bg-color: null;\r\n\r\n\t\t$color-active: var(--kt-text-#{$name});\r\n\t\t$icon-color-active: var(--kt-text-#{$name});\r\n\t\t$border-color-active: null;\r\n\t\t$bg-color-active: null;\r\n\r\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n\t}\r\n\r\n\t// Icon colors \r\n\t.btn.btn-icon-#{$name} {\r\n\t\t$color: null;\r\n\t\t$icon-color: var(--kt-text-#{$name});\r\n\t\t$bg-color: null;\r\n\t\t$border-color: null;\r\n\r\n\t\t$color-active: null;\r\n\t\t$icon-color-active: null;\r\n\t\t$border-color-active: null;\r\n\t\t$bg-color-active: null;\r\n\r\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n\t}\r\n\r\n\t// Icon colors active state\r\n\t.btn.btn-active-icon-#{$name} {\r\n\t\t$color: null;\r\n\t\t$icon-color: null;\r\n\t\t$bg-color: null;\r\n\t\t$border-color: null;\r\n\r\n\t\t$color-active: null;\r\n\t\t$icon-color-active: var(--kt-text-#{$name});\r\n\t\t$border-color-active: null;\r\n\t\t$bg-color-active: null;\r\n\r\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n\t}\r\n\r\n\t// Text colors\r\n\t.btn.btn-text-#{$name} {\r\n\t\t$color: var(--kt-text-#{$name});\r\n\t\t$icon-color: null;\r\n\t\t$bg-color: null;\r\n\t\t$border-color: null;\r\n\r\n\t\t$color-active: null;\r\n\t\t$icon-color-active: null;\r\n\t\t$border-color-active: null;\r\n\t\t$bg-color-active: null;\r\n\r\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n\t}\r\n\r\n\t// Text colors active state\r\n\t.btn.btn-active-text-#{$name} {\r\n\t\t$color: null;\r\n\t\t$icon-color: null;\r\n\t\t$bg-color: null;\r\n\t\t$border-color: null;\r\n\r\n\t\t$color-active: var(--kt-text-#{$name});\r\n\t\t$icon-color-active: null;\r\n\t\t$border-color-active: null;\r\n\t\t$bg-color-active: null;\r\n\r\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n\t}\t\r\n}\r\n\r\n// Social colors\r\n@each $name, $value in $social-colors {\r\n\t// Base\r\n\t.btn.btn-#{$name} {\r\n\t\t$color: get($value, inverse);\r\n\t\t$icon-color: get($value, inverse);\r\n\t\t$border-color: get($value, base);\r\n\t\t$bg-color: get($value, base);\r\n\r\n\t\t$color-active: null;\r\n\t\t$icon-color-active: null;\r\n\t\t$border-color-active: get($value, active);\r\n\t\t$bg-color-active: get($value, active);\r\n\r\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n\t}\r\n\r\n\t// Light\r\n\t.btn.btn-light-#{$name} {\r\n\t\t$color: get($value, base);\r\n\t\t$icon-color: get($value, base);\r\n\t\t$bg-color: get($value, light);\r\n\t\t$border-color: get($value, light);\r\n\r\n\t\t$color-active: get($value, inverse);\r\n\t\t$icon-color-active: get($value, inverse);\r\n\t\t$bg-color-active: get($value, base);\r\n\t\t$border-color-active: get($value, base);\r\n\r\n\t\t@include button-custom-variant($color, $icon-color, $border-color, $bg-color, $color-active, $icon-color-active, $border-color-active, $bg-color-active);\r\n\t}\r\n}","//\r\n// Button Mixins\r\n//\r\n\r\n// Custom variant\r\n@mixin button-custom-variant(\r\n    $color,\r\n    $icon-color,\r\n    $border-color,\r\n    $bg-color,\r\n    $color-active,\r\n    $icon-color-active,\r\n    $border-color-active,\r\n    $bg-color-active\r\n) {\r\n\r\n    @if ( $color != null ) {\r\n        color: $color;\r\n    }\r\n\r\n    @if ( $icon-color != null ) {\r\n        i,\r\n        .svg-icon {\r\n    \t\tcolor: $icon-color;\r\n    \t}\r\n\r\n        &.dropdown-toggle:after {\r\n            color: $icon-color;\r\n        }\r\n    }\r\n\r\n    @if ( $border-color != null ) {\r\n        border-color: $border-color;\r\n    }\r\n\r\n    @if ( $bg-color != null ) {\r\n        background-color: $bg-color;\r\n    }\r\n\r\n    .btn-check:checked + &,\r\n    .btn-check:active + &,\r\n    &:focus:not(.btn-active),\r\n    &:hover:not(.btn-active),\r\n    &:active:not(.btn-active),\r\n    &.active,\r\n    &.show,\r\n    .show > & {\r\n        @if ( $color-active != null ) {\r\n            color: $color-active;\r\n        }\r\n\r\n        @if ( $icon-color-active != null ) {\r\n            i,\r\n            .svg-icon {\r\n        \t\tcolor: $icon-color-active;\r\n        \t}\r\n\r\n            &.dropdown-toggle:after {\r\n                color: $icon-color-active;\r\n            }\r\n        }\r\n\r\n        @if ( $border-color-active != null ) {\r\n            border-color: $border-color-active;\r\n        }\r\n\r\n        @if ( $bg-color-active != null ) {\r\n            background-color: $bg-color-active !important;\r\n        }\r\n    }\r\n}\r\n\r\n@mixin button-active-state() {    \r\n    .btn-check:checked + &,\r\n    .btn-check:active + &,\r\n    &:focus:not(.btn-active),\r\n    &:hover:not(.btn-active),\r\n    &:active:not(.btn-active),\r\n    &.active,\r\n    &.show,\r\n    .show > & {\r\n        @content;\r\n    }\r\n}\r\n","//\r\n// Code\r\n//\r\n\r\ncode:not([class*=\"language-\"]) {\r\n    font-weight: $code-font-weight;\r\n    color: var(--kt-code-color);\r\n    line-height: inherit;\r\n    font-size: inherit;\r\n    background-color: var(--kt-code-bg);\r\n    padding: $code-padding;\r\n    margin: $code-margin;\r\n    box-shadow: var(--kt-code-box-shadow);\r\n    @include border-radius($code-border-radius);\r\n}\r\n","//\r\n// Labels\r\n//\r\n\r\n.form-label {\r\n\tcolor: var(--kt-form-label-color);\r\n}\r\n\r\n// For use with horizontal and inline forms, when you need the label (or legend)\r\n// text to align with the form controls.\r\n.col-form-label {\r\n\tcolor: var(--kt-form-label-color);\r\n}\r\n","//\r\n// Form text\r\n//\r\n\r\n.form-text {\r\n\tcolor: var(--kt-form-text-color);\r\n}\r\n","//\r\n// Form controls\r\n//\r\n\r\n.form-control {\r\n  \tcolor: var(--kt-input-color);\r\n  \tbackground-color: var(--kt-input-bg);\r\n\tborder: $input-border-width solid var(--kt-input-border-color);\r\n  \tbox-shadow: none !important;\r\n\t//@include box-shadow(var(--kt-input-box-shadow));\r\n\r\n  \t&:focus {\r\n\t\tcolor: var(--kt-input-focus-color);\r\n\t\tbackground-color: var(--kt-input-focus-bg);\r\n\t\tborder-color: var(--kt-input-focus-border-color);\r\n\t\t//box-shadow: var(--kt-input-focus-box-shadow);\r\n  \t}\r\n\r\n  \t// Placeholder\r\n  \t&::placeholder {\r\n    \tcolor: var(--kt-input-placeholder-color);\r\n  \t}\r\n\r\n  \t// Disabled and read-only inputs\r\n  \t&:disabled,\r\n  \t&[readonly] {\r\n    \tcolor: var(--kt-input-disabled-color);\r\n    \tbackground-color: var(--kt-input-disabled-bg);\r\n    \tborder-color: var(--kt-input-disabled-border-color);\r\n  \t}\r\n\r\n  \t// File input buttons theming\r\n  \t&::file-selector-button {\r\n    \tcolor: var(--kt-form-file-button-color);\r\n    \t@include gradient-bg(var(--kt-form-file-button-bg));\r\n  \t}\r\n\r\n  \t&:hover:not(:disabled):not([readonly])::file-selector-button {\r\n    \tbackground-color: var(--kt-form-file-button-hover-bg);\r\n  \t}\r\n}\r\n\r\n// Readonly controls as plain text\r\n.form-control-plaintext {\r\n  \tcolor: var(--kt-input-plaintext-color);\r\n}","// Select\r\n//\r\n// Replaces the browser default select with a custom one, mostly pulled from\r\n// https://primer.github.io/.\r\n\r\n.form-select {\r\n\tcolor: var(--kt-form-select-color);\r\n\tbackground-color: var(--kt-form-select-bg);\r\n\tbackground-image: var(--kt-form-select-indicator);\r\n\tborder: $form-select-border-width solid var(--kt-form-select-border-color);\r\n\t@include box-shadow(var(--kt-form-select-box-shadow));\r\n\tappearance: none;\r\n\r\n\t&:focus {\r\n\t\tborder-color: var(--kt-form-select-focus-border-color);\r\n\t\t@if $enable-shadows {\r\n\t\t\t@include box-shadow(var(--kt-form-select-box-shadow), var(--kt-form-select-focus-box-shadow));\r\n\t\t} @else {\r\n\t\t\t// Avoid using mixin so we can pass custom focus shadow properly\r\n\t\t\tbox-shadow: var(--kt-form-select-focus-box-shadow);\r\n\t\t}\r\n\t}\r\n\r\n\r\n\t&:disabled {\r\n\t\tcolor: var(--kt-form-select-disabled-color);\r\n\t\tbackground-color: var(--kt-form-select-disabled-bg);\r\n\t\tborder-color: var(--kt-form-select-disabled-border-color);\r\n\t}\r\n\r\n\t// Remove outline from select box in FF\r\n\t&:-moz-focusring {\r\n\t\ttext-shadow: 0 0 0 var(--kt-form-select-color);\r\n\t}\r\n}","//\r\n// Check/radio\r\n//\r\n\r\n.form-check-input {\r\n\tbackground-color: var(--kt-form-check-input-bg);\r\n\tborder: var(--kt-form-check-input-border);\r\n\r\n\t&:active {\r\n\t\tfilter: var(--kt-form-check-input-active-filter);\r\n\t}\r\n\r\n\t&:focus {\r\n\t\tborder-color: var(--kt-form-check-input-focus-border);\r\n\t\tbox-shadow: var(--kt-form-check-input-focus-box-shadow);\r\n\t}\r\n\r\n\t&:checked {\r\n\t\tbackground-color: var(--kt-form-check-input-checked-bg-color);\r\n\t\tborder-color: var(--kt-form-check-input-checked-border-color);\r\n\r\n\t\t&[type=\"checkbox\"] {\r\n\t\t\t@if $enable-gradients {\r\n\t\t\t\tbackground-image: var(--kt-form-check-input-checked-bg-image), var(--#{$prefix}gradient);\r\n\t\t\t} @else {\r\n\t\t\t\tbackground-image: var(--kt-form-check-input-checked-bg-image);\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&[type=\"radio\"] {\r\n\t\t\t@if $enable-gradients {\r\n\t\t\t\tbackground-image: var(--kt-form-check-radio-checked-bg-image), var(--#{$prefix}gradient);\r\n\t\t\t} @else {\r\n\t\t\t\tbackground-image: var(--kt-form-check-radio-checked-bg-image);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&[type=\"checkbox\"]:indeterminate {\r\n\t\tbackground-color: var(--kt-form-check-input-indeterminate-bg-color);\r\n\t\tborder-color: var(--kt-form-check-input-indeterminate-border-color);\r\n\r\n\t\t@if $enable-gradients {\r\n\t\t\tbackground-image: var(--kt-form-check-input-indeterminate-bg-image), var(--#{$prefix}gradient);\r\n\t\t} @else {\r\n\t\t\tbackground-image:var(--kt-form-check-input-indeterminate-bg-image);\r\n\t\t}\r\n\t}\r\n\r\n\t&:disabled {\r\n\t\topacity: var(--kt-form-check-input-disabled-opacity);\r\n\t}\r\n\r\n\t// Use disabled attribute in addition of :disabled pseudo-class\r\n\t// See: https://github.com/twbs/bootstrap/issues/28247\r\n\t&[disabled],\r\n\t&:disabled {\r\n\t\t~ .form-check-label {\r\n\t\t\topacity: var(--kt-form-check-label-disabled-opacity);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.form-check-label {\r\n\tcolor: var(--kt-form-check-label-color);\r\n}\r\n\r\n.form-check-input {\r\n\t&:checked {\r\n\t\t& + span,\r\n\t\t& + label {\r\n\t\t\tcolor: var(--kt-form-check-label-color-checked);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n//\r\n// Switch\r\n//\r\n\r\n.form-switch {\r\n\t.form-check-input {\r\n\t\tbackground-image: var(--kt-form-switch-bg-image);\r\n\r\n\t\t&:focus {\r\n\t\t\tbackground-image: var(--kt-form-switch-focus-bg-image);\r\n\t\t}\r\n\r\n\t\t&:checked {\r\n\t\t\t@if $enable-gradients {\r\n\t\t\t\tbackground-image: var(--kt-form-switch-checked-bg-image), var(--#{$prefix}gradient);\r\n\t\t\t} @else {\r\n\t\t\t\tbackground-image: var(--kt-form-switch-checked-bg-image);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.btn-check {\r\n\t&[disabled],\r\n\t&:disabled {\r\n\t\t+ .btn {\r\n\t\t\topacity: var(--kt-form-check-btn-check-disabled-opacity);\r\n\t\t}\r\n\t}\r\n}\r\n","//\r\n// Floating label\r\n//\r\n\r\n.form-floating {\r\n    .form-control.form-control-solid {\r\n        &::placeholder {\r\n            color: transparent;    \r\n        }\r\n    } \r\n}\r\n     ","//\r\n// Input group\r\n//\r\n\r\n.input-group-text {\r\n\tcolor: var(--kt-input-group-addon-color);\r\n\tbackground-color: var(--kt-input-group-addon-bg);\r\n\tborder: $input-border-width solid var(--kt-input-group-addon-border-color);\r\n}\r\n","//\r\n// Form Control\r\n//\r\n\r\n\r\n// Form control\r\n.form-control {\r\n\t// Dropdown shown state\r\n\t.dropdown.show > & {\r\n\t\tcolor: var(--kt-input-focus-color); \r\n\t\tbackground-color: var(--kt-input-focus-bg);\r\n  \t    border-color: var(--kt-input-focus-border-color);\r\n\t}\r\n\r\n\t// Readonly state\r\n\t&[readonly] {\r\n\t\tbackground-color: var(--kt-input-readonly-bg);\r\n\t}\r\n\r\n\t// Solid style\r\n\t&.form-control-solid {\r\n\t\tbackground-color: var(--kt-input-solid-bg);\r\n\t\tborder-color: var(--kt-input-solid-bg);\r\n\t\tcolor: var(--kt-input-solid-color);\r\n\t\t@include placeholder(var(--kt-input-solid-placeholder-color));\r\n\t\ttransition: $transition-input;\r\n\r\n\t\t.dropdown.show > &,\r\n\t\t&:active,\r\n\t\t&.active,\r\n\t\t&:focus,\r\n\t\t&.focus {\r\n\t\t\tbackground-color: var(--kt-input-solid-bg-focus);\r\n\t\t\tborder-color: var(--kt-input-solid-bg-focus);\r\n\t\t\tcolor: var(--kt-input-solid-color);\r\n\t\t\ttransition: $transition-input;\r\n\t\t}\r\n\t}\r\n\r\n\t// Transparent style\r\n\t&.form-control-transparent {\r\n\t\tbackground-color: transparent;\r\n\t\tborder-color: transparent;\r\n\r\n\t\t.dropdown.show > &,\r\n\t\t&:active,\r\n\t\t&.active,\r\n\t\t&:focus,\r\n\t\t&.focus {\r\n\t\t\tbackground-color: transparent;\r\n\t\t\tborder-color: transparent;\r\n\t\t}\r\n\t}\r\n\r\n\t// Flush\r\n\t&.form-control-flush {\r\n\t\t@include input-reset();\r\n\t}\r\n}\r\n\r\n// Placeholder colors\r\n.placeholder-gray-500 {\r\n\t@include placeholder(var(--kt-gray-500));\r\n}\r\n\r\n.placeholder-white {\r\n\t@include placeholder($white);\r\n}\r\n\r\n// Textarea reset resize\r\n.resize-none {\r\n\tresize: none;\r\n}\r\n\r\n// Form control solid bg\r\n.form-control-solid-bg {\r\n\tbackground-color: var(--kt-input-solid-bg);\r\n}\r\n","//\r\n// Input placeholder color\r\n//\r\n\r\n@mixin placeholder($color) {\r\n    // Chrome, Firefox, Opera, Safari 10.1+\r\n    &::placeholder { \r\n        color: $color;\r\n    }\r\n    \r\n    // Firefox\r\n    &::-moz-placeholder {\r\n        color: $color;\r\n        opacity: 1;\r\n    }\r\n}\r\n","//\r\n// Form Select\r\n//\r\n\r\n.form-select {\r\n    box-shadow: none !important;\r\n\r\n    // Solid style\r\n\t&.form-select-solid {\r\n\t\t@include placeholder(var(--kt-input-solid-placeholder-color));\r\n\t\tbackground-color: var(--kt-input-solid-bg);\r\n\t\tborder-color: var(--kt-input-solid-bg);\r\n\t\tcolor: var(--kt-input-solid-color);\r\n\t\ttransition: $transition-input;\r\n\t\t\r\n\t\t.dropdown.show > &,\r\n\t\t&:active,\r\n\t\t&.active,\r\n\t\t&:focus,\r\n\t\t&.focus {\r\n\t\t\tbackground-color: var(--kt-input-solid-bg-focus);\r\n\t\t\tborder-color: var(--kt-input-solid-bg-focus) !important;\r\n\t\t\tcolor: var(--kt-input-solid-color);\r\n\t\t\ttransition: $transition-input;\r\n\t\t}\r\n\t}\r\n\r\n\t// Transparent style\r\n\t&.form-select-transparent {\r\n\t\t@include placeholder(var(--kt-input-placeholder-color));\r\n\t\tbackground-color: transparent;\r\n\t\tborder-color: transparent;\r\n\t\tcolor: $input-color;\r\n\r\n\t\t.dropdown.show > &,\r\n\t\t&:active,\r\n\t\t&.active,\r\n\t\t&:focus,\r\n\t\t&.focus {\r\n\t\t\tbackground-color: transparent;\r\n\t\t\tborder-color: transparent !important;\r\n\t\t\tcolor: $input-color;\r\n\t\t}\r\n\t}\r\n}\r\n","//\r\n// Form Check\r\n//\r\n\r\n// Check input\r\n.form-check:not(.form-switch) {\r\n    .form-check-input {\r\n        &[type=\"checkbox\"] {\r\n            background-size: $form-check-input-bg-size;\r\n        }\r\n    }\r\n}\r\n\r\n// Custom checkbox and radio\r\n.form-check-custom {\r\n    display: flex;\r\n    align-items: center;\r\n    padding-left: 0;\r\n    margin: 0;\r\n\r\n    // Input\r\n    .form-check-input {\r\n        margin: 0;\r\n        float: none;\r\n        flex-shrink: 0;\r\n    }\r\n\r\n    // Label\r\n    .form-check-label {\r\n        margin-left: 0.55rem;\r\n    }\r\n\r\n    // Sizing\r\n    &.form-check-sm {\r\n        .form-check-input {\r\n            height: $form-check-input-width-sm;\r\n            width: $form-check-input-width-sm;\r\n        }\r\n    }\r\n\r\n    &.form-check-lg {\r\n        .form-check-input {\r\n            height: $form-check-input-width-lg;\r\n            width: $form-check-input-width-lg;\r\n        }\r\n    }\r\n\r\n    // Solid\r\n    &.form-check-solid {\r\n        .form-check-input {\r\n            border: 0;\r\n            background-color: var(--kt-form-check-input-bg-solid);\r\n\r\n            &:active,\r\n            &:focus {\r\n                filter: none;\r\n                background-color: var(--kt-form-check-input-bg-solid);\r\n            }\r\n\r\n            &:checked {\r\n                background-color: var(--kt-form-check-input-checked-bg-color-solid);\r\n            }\r\n        }\r\n    }\r\n\r\n    // States\r\n    // Success state\r\n    &.form-check-success {\r\n        .form-check-input {\r\n            &:checked {\r\n                background-color: var(--kt-success);\r\n            }\r\n        }\r\n    }\r\n\r\n    // Danger state\r\n    &.form-check-danger {\r\n        .form-check-input {\r\n            &:checked {\r\n                background-color: var(--kt-danger);\r\n            }\r\n        }\r\n    }\r\n\r\n    // Warning state\r\n    &.form-check-warning {\r\n        .form-check-input {\r\n            &:checked {\r\n                background-color: var(--kt-warning);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Custom switch\r\n.form-switch.form-check-solid {\r\n    .form-check-input {\r\n        height: $form-switch-height;\r\n        background-image: var(--kt-form-switch-bg-image-solid);\r\n        border-radius: $form-switch-border-radius;\r\n\r\n        &:checked {\r\n            filter: none;\r\n            background-image: var(--kt-form-switch-checked-bg-image);\r\n        }\r\n    }\r\n\r\n    &.form-switch-sm {\r\n        .form-check-input {\r\n            height: $form-switch-height-sm;\r\n            width: $form-switch-width-sm;\r\n        }\r\n    }\r\n\r\n    &.form-switch-lg {\r\n        .form-check-input {\r\n            height: $form-switch-height-lg;\r\n            width: $form-switch-width-lg;\r\n        }\r\n    }\r\n}\r\n\r\n// Clip\r\n.form-check-clip {\r\n    position: relative;\r\n    overflow: hidden;\r\n\r\n    .form-check-label {\r\n        padding-top: 0.5rem;\r\n        font-size: $form-label-font-size;\r\n        color: var(--kt-form-label-color);\r\n        font-weight: $form-label-font-weight;    \r\n    }\r\n\r\n    .form-check-wrapper {        \r\n        @include border-radius($border-radius-lg);\r\n        border: 2px solid transparent;    \r\n        transition: $transition-base;\r\n        cursor: pointer;\r\n        overflow: hidden;\r\n    }\r\n\r\n    .form-check-indicator {\r\n        transition: $transition-base;\r\n        position: absolute;\r\n        top: 0;\r\n        right: 0;\r\n        opacity: 0;\r\n        width: $form-check-input-width;\r\n        height: $form-check-input-width;\r\n        background-repeat: no-repeat;\r\n        background-position: center;\r\n        background-size: contain;\r\n        background-size: 50%;   \r\n        background-image: var(--kt-form-check-input-checked-bg-image);\r\n        background-color: var(--kt-component-checked-bg);  \r\n        @include border-bottom-start-radius($border-radius-lg);\r\n        @include border-top-end-radius($border-radius-lg);\r\n\r\n        &.form-check-indicator-sm {\r\n            width: $form-check-input-width-sm;\r\n            height: $form-check-input-width-sm;\r\n        }\r\n\r\n        &.form-check-indicator-lg {\r\n            width: $form-check-input-width-lg;\r\n            height: $form-check-input-width-lg;\r\n        }\r\n    }\r\n\r\n    .form-check-content {\r\n        width: 100%;\r\n    }\r\n\r\n    .btn-check:checked + div {\r\n        border: 2px solid var(--kt-component-checked-bg);\r\n        transition: $transition-base;\r\n\r\n        .form-check-indicator {\r\n            transition: $transition-base;\r\n            opacity: 1;      \r\n        }\r\n    }\r\n\r\n    .btn-check:disabled + div {\r\n        transition: $transition-base;\r\n        opacity: var(--kt-form-check-btn-check-disabled-opacity);\r\n    }\r\n}\r\n\r\n// Image\r\n.form-check-image {\r\n    position: relative;\r\n    overflow: hidden;\r\n\r\n    img {\r\n        max-width: 100%;    \r\n    }\r\n\r\n    .form-check-wrapper {        \r\n        @include border-radius($border-radius-lg);        \r\n        border: 2px solid transparent;    \r\n        transition: $transition-base;\r\n        cursor: pointer;\r\n        overflow: hidden;\r\n        margin-bottom: 0.75rem;\r\n    }\r\n\r\n    .form-check-rounded {\r\n        @include border-radius($border-radius-lg);        \r\n    }        \r\n\r\n    .form-check-label {\r\n        font-weight: $font-weight-bold;    \r\n        margin-left: 0.5rem;\r\n    }\r\n\r\n    &.active {\r\n        .form-check-wrapper {\r\n            border-color: var(--kt-primary);\r\n        }    \r\n    }\r\n\r\n    &.form-check-success.active {\r\n        .form-check-wrapper {\r\n            border-color: var(--kt-success);\r\n        } \r\n    }\r\n\r\n    &.form-check-danger.active {\r\n        .form-check-wrapper {\r\n            border-color: var(--kt-danger);\r\n        } \r\n    }\r\n\r\n    &.disabled {\r\n        opacity: var(--kt-form-check-btn-check-disabled-opacity);\r\n    }\r\n}","//\r\n// Input Group\r\n//\r\n\r\n// Form control\r\n.input-group {\r\n    &.input-group-solid {\r\n        @include border-radius($input-border-radius);\r\n\r\n        &.input-group-sm {\r\n            @include border-radius($input-border-radius-sm);\r\n        }\r\n\r\n        &.input-group-lg {\r\n            @include border-radius($input-border-radius-lg);\r\n        }\r\n\r\n        .input-group-text {\r\n            background-color: var(--kt-input-solid-bg);\r\n\t\t    border-color: var(--kt-input-solid-bg);\r\n\r\n            & + .form-control {\r\n                border-left-color: var(--kt-input-border-color);\r\n            }\r\n        }\r\n\r\n        .form-control {\r\n            background-color: var(--kt-input-solid-bg);\r\n    \t\tborder-color: var(--kt-input-solid-bg);\r\n\r\n            & + .input-group-text {\r\n                border-left-color: var(--kt-input-border-color);\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Required Label\r\n//\r\n\r\n.required {\r\n    &:after {\r\n        content: \"*\";\r\n        position: relative;\r\n        font-size: inherit;\r\n        color: var(--kt-danger);\r\n        padding-left: 0.25rem;\r\n        font-weight: $font-weight-bold;\r\n    }\r\n}","//\r\n// Modal\r\n//\r\n\r\n.modal {\r\n  \t--#{$prefix}modal-color: var(--kt-modal-content-color);\r\n  \t--#{$prefix}modal-bg: var(--kt-modal-content-bg);\r\n  \t--#{$prefix}modal-border-color: var(--kt-modal-content-border-color);\r\n  \t--#{$prefix}modal-box-shadow: var(--kt-modal-content-box-shadow-xs);\r\n  \t--#{$prefix}modal-header-border-color: var(--kt-modal-header-border-color);\r\n  \t--#{$prefix}modal-footer-bg: var(--kt-modal-footer-bg);\r\n  \t--#{$prefix}modal-footer-border-color: var(--kt-modal-footer-border-color);\r\n}\r\n\r\n // Mobile dialog\r\n.modal-dialog {\r\n\toutline: none !important;\r\n}\r\n\r\n// Modal header\r\n.modal-header {\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n\t@include border-top-radius($modal-content-border-radius);\r\n\tborder-bottom: $modal-header-border-width solid var(--kt-modal-header-border-color);\r\n\r\n\t// Headings\r\n\th1,h2,h3,h4,h5,h6 {\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n}\r\n\r\n// Modal content\r\n.modal-content {\r\n\tcolor: var(--kt-modal-color);    \r\n\tbackground-color: var(--kt-modal-bg);\r\n\tborder: $modal-content-border-width solid var(--kt-modal-border-color);\r\n\t@include box-shadow(var(--kt-modal-box-shadow));\r\n}\r\n\r\n// Modal footer\r\n.modal-footer {\r\n\tbackground-color: var(--kt-modal-footer-bg);\r\n\tborder-top: $modal-footer-border-width solid var(--#{$prefix}modal-footer-border-color);\r\n}\r\n\r\n// Modal background\r\n.modal-backdrop {\r\n  \t--#{$prefix}backdrop-bg: var(--kt-modal-backdrop-bg);\r\n  \t--#{$prefix}backdrop-opacity: var(--kt-modal-backdrop-opacity);\r\n}\r\n\r\n// Scale up the modal\r\n@include media-breakpoint-up(sm) {\r\n\t.modal-content {\r\n\t\t@include box-shadow(var(--kt-modal-box-shadow-sm-up));\r\n\t}\r\n}\r\n\r\n// Utilities\r\n.modal-rounded {\r\n\t@if $enable-rounded {\r\n\t\tborder-radius: $modal-content-border-radius !important;\r\n\t}\r\n}","//\r\n// Progress\r\n//\r\n\r\n// Base\r\n.progress {\r\n  --#{$prefix}progress-bg: var(--kt-progress-bg);\r\n  --#{$prefix}progress-box-shadow: var(--kt-progress-box-shadow);\r\n  --#{$prefix}progress-bar-color: var(--kt-progress-bar-color);\r\n  --#{$prefix}progress-bar-bg: var(--kt-progress-bar-bg);\r\n}\r\n\r\n// Vertical Position\r\n.progress-vertical {\r\n    display: flex;\r\n    align-items: stretch;\r\n    justify-content: space-between;\r\n\r\n    .progress {\r\n        height: 100%;\r\n        @include border-radius($border-radius);\r\n        display: flex;\r\n        align-items: flex-end;\r\n        margin-right: 1rem;\r\n\r\n        &:last-child {\r\n            margin-right: 0;\r\n        }\r\n\r\n        .progress-bar {\r\n            width: 8px;\r\n            @include border-radius($border-radius);\r\n        }\r\n    }\r\n}\r\n","//\r\n// Table\r\n//\r\n\r\n// Table\r\n.table {\r\n\t--#{$prefix}table-color: var(--kt-table-color);\r\n\t--#{$prefix}table-bg: var(--kt-table-bg);\r\n\t--#{$prefix}table-border-color: var(--kt-table-border-color);\r\n\t--#{$prefix}table-accent-bg: var(--kt-table-accent-bg);\r\n\t--#{$prefix}table-striped-color: var(--kt-table-striped-color);\r\n\t--#{$prefix}table-striped-bg: var(--kt-table-striped-bg);\r\n\t--#{$prefix}table-active-color: var(--kt-table-active-color);\r\n\t--#{$prefix}table-active-bg: var(--kt-table-active-bg);\r\n\t--#{$prefix}table-hover-color: var(--kt-table-hover-color);\r\n\t--#{$prefix}table-hover-bg: var(--kt-table-hover-bg);\r\n\r\n\t// Fix for BS 5.1.2 update\r\n\t& > :not(:first-child) {\r\n    \tborder-color: transparent;\r\n\t\tborder-width: 0;\r\n\t\tborder-style: none;\r\n\t}\r\n\t\r\n\t>:not(:last-child)>:last-child>* {\r\n\t\tborder-bottom-color: inherit;\r\n\t}\r\n\r\n\ttr, th, td {\r\n\t\tborder-color: inherit;\r\n\t\tborder-width: inherit;\r\n\t\tborder-style: inherit;\r\n\t\ttext-transform: inherit;\r\n\t\tfont-weight: inherit;\r\n\t\tfont-size: inherit;\r\n\t\tcolor: inherit;\r\n\t\theight: inherit;\r\n\t\tmin-height: inherit;\r\n\r\n\t\t&:first-child {\r\n\t\t\tpadding-left: 0;\r\n\t\t}\r\n\r\n\t\t&:last-child {\r\n\t\t\tpadding-right: 0;\r\n\t\t}\r\n\t}\r\n\r\n\ttfoot,\r\n\ttbody {\r\n\t\ttr:last-child {\r\n\t\t\tborder-bottom: 0 !important;\r\n\r\n\t\t\tth, td {\r\n\t\t\t\tborder-bottom: 0 !important;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\ttfoot {\r\n\t\tth, td {\r\n\t\t\tborder-top: inherit;\r\n\t\t}\r\n\t}\r\n\r\n\t// Rounded\r\n\t&.table-rounded {\r\n\t\tborder-radius: $border-radius;\r\n\t\tborder-spacing: 0;\r\n\t\tborder-collapse: separate;\r\n\t}\r\n\r\n\t// Flush\r\n\t&.table-flush {\r\n\t\ttr, th, td {\r\n\t\t\tpadding: inherit;\r\n\t\t}\r\n\t}\r\n\r\n\t// Row bordered\r\n\t&.table-row-bordered {\r\n\t\ttr {\r\n\t\t\tborder-bottom-width: 1px;\r\n\t\t\tborder-bottom-style: solid;\r\n\t\t\tborder-bottom-color: var(--kt-border-color);\r\n\t\t}\r\n\r\n\t\ttfoot {\r\n\t\t\tth, td {\r\n\t\t\t\tborder-top-width: 1px !important;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t// Row dashed\r\n\t&.table-row-dashed {\r\n\t\ttr {\r\n\t\t\tborder-bottom-width: 1px;\r\n\t\t\tborder-bottom-style: dashed;\r\n\t\t\tborder-bottom-color: var(--kt-border-color);\r\n\t\t}\r\n\r\n\t\ttfoot {\r\n\t\t\tth, td {\r\n\t\t\t\tborder-top-width: 1px !important;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t// Row border colors\r\n\t@each $name, $value in $grays {\r\n\t\t&.table-row-gray-#{$name} {\r\n\t\t\ttr { \r\n\t\t\t\tborder-bottom-color: var(--kt-gray-#{$name});\r\n\t\t\t}\r\n\t\t}\r\n\t}\t\r\n}\r\n\r\n// Layout fixed\r\n.table-layout-fixed {\r\n\ttable-layout: fixed;\r\n}\r\n\r\n// Sorting\r\n.table-sort {\r\n\t&:after {\r\n\t\topacity: 0;\r\n\t}\r\n}\r\n\r\n.table-sort,\r\n.table-sort-asc,\r\n.table-sort-desc {\r\n\tvertical-align: middle;\r\n\r\n\t&:after {\r\n\t\tposition: relative;\r\n\t\tdisplay: inline-block;\r\n\t\twidth: 0.75rem;\r\n\t\theight: 0.75rem;\r\n\t\tcontent: \" \";\r\n\t\tbottom: auto;\r\n\t\tright: auto;\r\n\t\tleft: auto;\r\n\t\tmargin-left: 0.5rem;\r\n\t}\t\t\r\n}\r\n\r\n.table-sort-asc {\r\n\t&:after {\r\n\t\topacity: 1;\r\n\t\t@include svg-bg-icon(arrow-top, var(--kt-text-muted));\r\n\t}\r\n}\r\n\r\n.table-sort-desc {\r\n\t&:after {\r\n\t\topacity: 1;\r\n\t\t@include svg-bg-icon(arrow-bottom, var(--kt-text-muted));\r\n\t}\r\n}\r\n\r\n// Loading\r\n.table-loading-message {\r\n\tdisplay: none;\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 50%;\r\n\t@include border-radius($border-radius);\r\n\tbox-shadow: var(--kt-table-loading-message-box-shadow);\r\n\tbackground-color: var(--kt-table-loading-message-bg);\r\n\tcolor: var(--kt-table-loading-message-color);\r\n\tfont-weight: $font-weight-bold;\r\n\tmargin: 0 !important;\r\n\twidth: auto;\r\n\tpadding: 0.85rem 2rem !important;\r\n\ttransform: translateX(-50%) translateY(-50%);\r\n}\r\n\r\n.table-loading {\r\n\tposition: relative;\r\n\r\n\t.table-loading-message {\r\n\t\tdisplay: block;\r\n\t}\t\r\n}\r\n\r\n// Cell gutters\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n    @include media-breakpoint-up($breakpoint) {\r\n        $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n        @each $name, $value in $gutters {\r\n\t\t\t.table.g#{$infix}-#{$name} {\r\n\t\t\t\tth, td {\r\n\t\t\t\t\tpadding: $value;\r\n\r\n\t\t\t\t\t// Datatables responsive mode fix\r\n\t\t\t\t\t&.dtr-control {\r\n\t\t\t\t\t\tpadding-left: $value !important;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n            }\r\n\r\n            .table.gy#{$infix}-#{$name} {\r\n\t\t\t\tth, td {\r\n\t\t\t\t\tpadding-top: $value;\r\n\t\t\t\t\tpadding-bottom: $value;\r\n\t\t\t\t}\r\n            }\r\n\r\n\t\t\t.table.gx#{$infix}-#{$name} {\r\n\t\t\t\tth, td {\r\n\t\t\t\t\tpadding-left: $value;\r\n\t\t\t\t\tpadding-right: $value;\r\n\r\n\t\t\t\t\t// Datatables responsive mode fix\r\n\t\t\t\t\t&.dtr-control {\r\n\t\t\t\t\t\tpadding-left: $value !important;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n            }\r\n\r\n\t\t\t.table.gs#{$infix}-#{$name} {\r\n\t\t\t\t th, td {\r\n\t\t\t\t\t&:first-child {\r\n\t   \t\t\t\t\tpadding-left: $value;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\t&:last-child {\r\n\t   \t\t\t\t\tpadding-right: $value;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\t// Datatables responsive mode fix\r\n\t\t\t\t\t&.dtr-control:first-child {\r\n\t\t\t\t\t\tpadding-left: $value !important;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Popover\r\n//\r\n\r\n\r\n// Base\r\n.popover {\r\n    --#{$prefix}popover-bg: var(--kt-popover-bg);\r\n    --#{$prefix}popover-border-color: var(--kt-popover-border-color);\r\n    --#{$prefix}popover-box-shadow: var(--kt-popover-box-shadow);\r\n    --#{$prefix}popover-header-color: var(--kt-popover-header-color);\r\n    --#{$prefix}popover-header-bg: var(--kt-popover-header-bg);\r\n    --#{$prefix}popover-body-color: var(--kt-popover-body-color);\r\n    --#{$prefix}popover-arrow-border: var(--kt-popover-bg);\r\n\r\n    .popover-header {\r\n        font-size: $popover-header-font-size;\r\n        font-weight: $popover-header-font-weight;\r\n        border-bottom: 1px solid var(--kt-popover-header-border-color);\r\n    }\r\n\r\n    .popover-dismiss {\r\n        position: absolute;\r\n        top: $popover-dissmis-btn-top;\r\n        right: $popover-dissmis-btn-end;\r\n        height: $popover-dissmis-btn-height;\r\n        width: $popover-dissmis-btn-height;\r\n        @include svg-bg-icon(close, var(--kt-gray-500)); // todo: revise\r\n        mask-size: 50%;\r\n        -webkit-mask-size: 50%;\r\n\r\n        &:hover {\r\n            background-color: var(--kt-primary);\r\n        }\r\n\r\n        & + .popover-header {\r\n            padding-right: $popover-body-padding-x + $popover-dissmis-btn-height;\r\n        }\r\n    }\r\n}\r\n\r\n// Inverse\r\n.popover-inverse {\r\n    @include popover-theme(\r\n        $bg-color: var(--kt-gray-900), \r\n        $border-color: var(--kt-gray-800), \r\n        $header-bg-color: var(--kt-gray-900), \r\n        $header-color: var(--kt-gray-200), \r\n        $body-color: var(--kt-gray-400), \r\n        $arrow-outer-color: var(--kt-gray-100), \r\n        $arrow-color: var(--kt-gray-900)\r\n    );\r\n}","//\r\n// Popover Mixin\r\n//\r\n\r\n@mixin popover-theme($bg-color, $border-color, $header-bg-color, $header-color, $body-color, $arrow-outer-color, $arrow-color) {\r\n    background-color: $bg-color;\r\n    border: 0;\r\n\r\n    // Header\r\n    .popover-header {\r\n        background-color: $header-bg-color;\r\n        color: $header-color;\r\n        border-bottom-color: $border-color;\r\n    }\r\n\r\n    // Body\r\n    .popover-body {\r\n        color: $body-color;\r\n    }\r\n\r\n    // Arrows\r\n    &.bs-popover-top {\r\n        > .popover-arrow {\r\n            &::before {\r\n                border-top-color:  $arrow-outer-color;\r\n            }\r\n\r\n            &::after {\r\n                border-top-color: $arrow-color;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.bs-popover-end {\r\n        > .popover-arrow {\r\n            &::before {\r\n                border-right-color: $arrow-outer-color;\r\n            }\r\n\r\n            &::after {\r\n                border-right-color: $arrow-color;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.bs-popover-bottom {\r\n        > .popover-arrow {\r\n            &::before {\r\n                border-bottom-color: $arrow-outer-color;\r\n            }\r\n\r\n            &::after {\r\n                border-bottom-color: $arrow-color;\r\n            }\r\n        }\r\n\r\n        // This will remove the popover-header's border just below the arrow\r\n        .popover-header::before {\r\n            border-bottom-color: $header-bg-color;\r\n        }\r\n    }\r\n\r\n    &.bs-popover-start {\r\n        > .popover-arrow {\r\n            &::before {\r\n                border-left-color: $arrow-outer-color;\r\n            }\r\n\r\n            &::after {\r\n                border-left-color: $arrow-color;\r\n            }\r\n        }\r\n    }\r\n}","//\r\n//  Tooltip\r\n//\r\n\r\n\r\n// Base\r\n.tooltip {\r\n    --#{$prefix}tooltip-color: var(--kt-tooltip-color);\r\n    --#{$prefix}tooltip-bg: var(--kt-tooltip-bg);\r\n    --#{$prefix}tooltip-opacity: var(--kt-tooltip-opacity);\r\n\r\n    .tooltip-inner {\r\n        box-shadow: var(--kt-tooltip-box-shadow);\r\n    }\r\n\r\n    &.tooltop-auto-width {\r\n       \t.tooltip-inner {\r\n       \t\twhite-space: nowrap;\r\n  \t\t\tmax-width: none;\r\n        }\r\n    }\r\n\r\n    // Inverse\r\n    &.tooltip-inverse {\r\n        @include tooltip-theme(\r\n            $bg-color: var(--kt-dark), \r\n            $color: var(--kt-dark-inverse),\r\n            $arrow-color: var(--kt-dark),\r\n        );\r\n    }\r\n}\r\n","//\r\n// Tooltip Mixin\r\n//\r\n\r\n@mixin tooltip-theme($bg-color, $color, $arrow-color) {\r\n    .tooltip-inner {\r\n        color: $color;\r\n        background-color: $bg-color;\r\n    }\r\n\r\n    // Arrows\r\n    &.bs-tooltip-top {\r\n        .tooltip-arrow {\r\n            &::before {\r\n                border-top-color: $arrow-color;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.bs-tooltip-end {\r\n        .tooltip-arrow {\r\n            &::before {\r\n                border-right-color: $arrow-color;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.bs-tooltip-bottom {\r\n        .tooltip-arrow {\r\n            &::before {\r\n                border-bottom-color: $arrow-color;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.bs-tooltip-start {\r\n        .tooltip-arrow {\r\n            &::before {\r\n                border-left-color: $arrow-color;\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Accordion\r\n//\r\n\r\n// Base\r\n.accordion {\r\n\t--#{$prefix}accordion-color: var(--kt-accordion-color);\r\n\t--#{$prefix}accordion-bg: var(--kt-accordion-bg);\r\n\t--#{$prefix}accordion-border-color: var(--kt-accordion-border-color);\r\n\t--#{$prefix}accordion-btn-color: var(--kt-accordion-color);\r\n\t--#{$prefix}accordion-btn-bg: var(--kt-accordion-button-bg);\r\n\t--#{$prefix}accordion-btn-icon: var(--kt-accordion-button-icon);\r\n\t--#{$prefix}accordion-btn-active-icon: var(--kt-accordion-button-active-icon);\r\n\t--#{$prefix}accordion-btn-focus-border-color: var(--kt-accordion-button-focus-border-color);\r\n\t--#{$prefix}accordion-btn-focus-box-shadow: var(--kt-accordion-button-focus-box-shadow);\r\n\t--#{$prefix}accordion-active-color: var(--kt-accordion-button-active-color);\r\n\t--#{$prefix}accordion-active-bg: var(--kt-accordion-button-active-bg);\r\n\r\n\t// According heading\r\n\t.accordion-header {\r\n\t\tcursor: pointer;\r\n\t}\r\n\r\n\t// Icon toggle mode\r\n\t&.accordion-icon-toggle {\r\n\t\t// Accordion icon expaned mode\r\n\t\t.accordion-icon {\r\n\t\t\tdisplay: flex;\r\n\t\t\tflex-shrink: 0;\r\n\t\t\ttransition: $transition-base;\r\n\t\t\ttransform: rotate(90deg);\r\n\t\t\talign-items: center;\r\n\t\t\tjustify-content: center;\r\n\r\n\t\t\ti,\r\n\t\t\t.svg-icon {\r\n\t    \t\tcolor: var(--kt-primary);\r\n\t    \t}\r\n\t\t}\r\n\r\n\t\t// Accordion icon collapsed mode\r\n\t\t.collapsed {\r\n\t\t\t.accordion-icon {\r\n\t\t\t\ttransition: $transition-base;\r\n\t\t\t\ttransform: rotate(0);\r\n\r\n\t\t\t\ti,\r\n\t\t\t\t.svg-icon {\r\n\t\t    \t\tcolor: var(--kt-text-muted);\r\n\t\t    \t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t// Reset accordion item border\r\n\t&.accordion-borderless {\r\n\t\t// According item\r\n\t\t.accordion-item {\r\n\t\t\tborder: 0;\r\n\t\t}\r\n\t}\r\n\r\n\t// Reset accordion item border, border radiues and background color\r\n\t&.accordion-flush {\r\n\t\t// According item\r\n\t\t.accordion-item {\r\n\t\t\tbackground-color: transparent;\r\n\t\t\tborder: 0;\r\n\t\t\tborder-radius: 0;\r\n\t\t\tpadding-left: 0;\r\n\t\t\tpadding-right: 0;\r\n\t\t}\r\n\t}\t\r\n}\r\n","//\r\n// Loading\r\n//\r\n\r\n.feedback {\r\n    display: none;\r\n}\r\n\r\n.feedback-popup {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin: 0 auto;\r\n    position: fixed;\r\n    z-index: $feedback-popup-z-index;\r\n    box-shadow: var(--kt-feedback-popup-box-shadow);\r\n    background-color: var(--kt-feedback-popup-background-color);\r\n    border-radius: $feedback-popup-border-radius;\r\n    padding: $feedback-popup-padding;\r\n}\r\n\r\n// Placement\r\n.feedback-top-center {\r\n    display: flex;\r\n    transition: top $feedback-popup-transition-speed ease;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    @include border-top-start-radius(0);\r\n    @include border-top-end-radius(0);\r\n    \r\n    &.feedback-shown {\r\n        top: 0px;\r\n        transition: top $feedback-popup-transition-speed ease;\r\n    }\r\n}\r\n","//\r\n// Avatar\r\n//\r\n\r\n\r\n// Base\r\n.image-input {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\t@include border-radius($border-radius);\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-size: cover;\r\n\r\n\t// Empty state\r\n\t&:not(.image-input-empty) {\r\n\t\tbackground-image: none !important;\r\n\t}\r\n\r\n\t// Wrapper\r\n\t.image-input-wrapper {\r\n\t\twidth: 120px;\r\n\t\theight: 120px;\r\n\t\t@include border-radius($border-radius);\r\n\t\tbackground-repeat: no-repeat;\r\n\t\tbackground-size: cover;\r\n\t}\r\n\r\n\t// Actions\r\n\t[data-kt-image-input-action] {\r\n\t\tcursor: pointer;\r\n\t\tposition: absolute;\r\n\t\ttransform: translate(-50%,-50%);\r\n\t}\r\n\r\n\t// Change Button\r\n\t[data-kt-image-input-action=\"change\"] {\r\n\t\tleft: 100%;\r\n\t\ttop: 0;\r\n\r\n\t\tinput {\r\n\t\t\twidth: 0 !important;\r\n\t\t\theight: 0 !important;\r\n\t\t\toverflow: hidden;\r\n\t\t\topacity: 0;\r\n\t\t}\r\n\t}\r\n\r\n\t// Cancel & Remove Buttons\r\n\t[data-kt-image-input-action=\"cancel\"],\r\n\t[data-kt-image-input-action=\"remove\"] {\r\n\t\tposition: absolute;\r\n\t\tleft: 100%;\r\n\t\ttop: 100%;\r\n\t}\r\n\r\n\t[data-kt-image-input-action=\"cancel\"] {\r\n\t\tdisplay: none;\r\n\t}\r\n\r\n\t// Input Changed State\r\n\t&.image-input-changed {\r\n\t\t[data-kt-image-input-action=\"cancel\"] {\r\n\t\t\tdisplay: flex;\r\n\t\t}\r\n\r\n\t\t[data-kt-image-input-action=\"remove\"] {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\t}\r\n\r\n\t// Input Empty State\r\n\t&.image-input-empty {\r\n\t\t[data-kt-image-input-action=\"remove\"],\r\n\t\t[data-kt-image-input-action=\"cancel\"] {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\t}\r\n\r\n\t// Circle style\r\n\t&.image-input-circle {\r\n\t\tborder-radius: 50%;\r\n\r\n\t\t// Wrapper\r\n\t\t.image-input-wrapper {\r\n\t\t\tborder-radius: 50%;\r\n\t\t}\r\n\r\n\t\t// Change Control\r\n\t\t[data-kt-image-input-action=\"change\"] {\r\n\t\t\tleft: 100%;\r\n\t\t\ttop: 0;\r\n\t\t\ttransform: translate(-100%, 0%);\r\n\t\t}\r\n\r\n\t\t// Cancel & Remove Buttons\r\n\t\t[data-kt-image-input-action=\"cancel\"],\r\n\t\t[data-kt-image-input-action=\"remove\"] {\r\n\t\t\tleft: 100%;\r\n\t\t\ttop: 100%;\r\n\t\t\ttransform: translate(-100%,-100%);\r\n\t\t}\r\n\t}\r\n\r\n\t// Bordered style\r\n\t&.image-input-outline {\r\n\t\t.image-input-wrapper {\r\n\t\t\tborder: 3px solid var(--kt-body-bg);\r\n\t\t\tbox-shadow: var(--kt-box-shadow);\r\n\t\t}\r\n\t}\r\n}\r\n","//\r\n// symbol\r\n//\r\n\r\n// Base\r\n.symbol {\r\n    display: inline-block;;\r\n    flex-shrink: 0;\r\n    position: relative;\r\n    @include border-radius($border-radius);\r\n\r\n    // Label\r\n    .symbol-label {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        font-weight: 500;\r\n        color: var(--kt-symbol-label-color);\r\n        background-color: var(--kt-symbol-label-bg);\r\n        background-repeat: no-repeat;\r\n        background-position: center center;\r\n        background-size: cover;\r\n        @include border-radius($border-radius);\r\n\r\n        &:after {\r\n            @include border-radius($border-radius);\r\n        }\r\n    }\r\n\r\n    // Badge\r\n    .symbol-badge {\r\n        position: absolute;\r\n        border-radius: 100%;\r\n        top: 0;\r\n        left: 50%;\r\n        transform: translateX(-50%) translateY(-50%) !important;\r\n    }\r\n\r\n    // Image\r\n    > img {\r\n        width: 100%;\r\n        flex-shrink: 0;\r\n        display: inline-block;\r\n        @include border-radius($border-radius);\r\n    }\r\n\r\n    // Square\r\n    &.symbol-square {\r\n        &,\r\n        > img,\r\n        .symbol-label {\r\n            border-radius: 0 !important;\r\n        }\r\n    }\r\n\r\n    // Circle\r\n    &.symbol-circle {\r\n        &,\r\n        > img,\r\n        .symbol-label {\r\n            border-radius: 50%;\r\n\r\n            &:after {\r\n                border-radius: 50%;\r\n            }\r\n        }\r\n    }\r\n\r\n    // Sizes\r\n    @include symbol-size(get($symbol-sizes, default));\r\n\r\n    @each $breakpoint in map-keys($grid-breakpoints) {\r\n        @include media-breakpoint-up($breakpoint) {\r\n            $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n            @each $name, $value in $symbol-sizes {\r\n                @if ($name != 'default') {\r\n                    &.symbol#{$infix}-#{$name} {\r\n                        @include symbol-size($value);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Group\r\n.symbol-group {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    margin-left: 10px;\r\n\r\n    .symbol {\r\n        position: relative;\r\n        z-index: 0;\r\n        margin-left: -10px;\r\n        transition: all 0.3s ease;\r\n\r\n        &:hover {\r\n            transition: all 0.3s ease;\r\n            z-index: 1;\r\n        }\r\n    }\r\n\r\n    .symbol-badge {\r\n        border: 2px solid var(--kt-body-bg);\r\n    }\r\n\r\n    .symbol-label {\r\n        position: relative;\r\n\r\n        &:after {\r\n            display: block;\r\n            content: \" \";\r\n            border-radius: inherit;\r\n            position: absolute;\r\n            top: 0;\r\n            right: 0;\r\n            left: 0;\r\n            bottom: 0;\r\n            border: 2px solid var(--kt-symbol-border-color);\r\n            -webkit-background-clip: padding-box; /* for Safari */\r\n            background-clip: padding-box; /* for IE9+, Firefox 4+, Opera, Chrome */    \r\n        }       \r\n    }\r\n\r\n    &.symbol-hover {\r\n        .symbol {\r\n            cursor: pointer;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Symbol\r\n//\r\n\r\n@mixin symbol-size($size) {\r\n    > img {\r\n        width: $size;\r\n        height: $size;\r\n    }\r\n\r\n    .symbol-label {\r\n        width: $size;\r\n        height: $size;\r\n    }\r\n\r\n    &.symbol-fixed {\r\n        .symbol-label {\r\n            width: $size;\r\n            height: $size;\r\n        }\r\n\r\n        > img {\r\n            width: $size;\r\n            height: $size;\r\n            max-width: none;\r\n        }\r\n    }\r\n\r\n    // Ratios\r\n    &.symbol-2by3 {\r\n        .symbol-label {\r\n            height: $size;\r\n            width:  $size * divide(3, 2);\r\n        }\r\n\r\n        > img {\r\n            height: $size;\r\n            width:  $size * divide(3, 2);\r\n            max-width: none;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Pulse\r\n//\r\n\r\n\r\n// Base\r\n.pulse {\r\n    position: relative;\r\n\r\n    // Theme Colors\r\n    @each $name, $color in $theme-colors {\r\n        &.pulse-#{$name} {\r\n            .pulse-ring {\r\n                border-color: $color;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.pulse-ring {\r\n    display: block;\r\n    border-radius: 40px;\r\n    height: 40px;\r\n    width: 40px;\r\n    position: absolute;\r\n    animation: animation-pulse 3.5s ease-out;\r\n    animation-iteration-count: infinite;\r\n    opacity: 0;\r\n    border-width: 3px;\r\n    border-style: solid;\r\n    border-color: var(--kt-gray-500);\t\r\n}\r\n\r\n@keyframes animation-pulse {\r\n    0% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}\r\n    60% {-webkit-transform: scale(0.1, 0.1); opacity: 0.0;}\r\n    65% {opacity: 1;}\r\n    100% {-webkit-transform: scale(1.2, 1.2); opacity: 0.0;}\r\n}\r\n","//\r\n// Page loader(used by the previous layout system)\r\n//\r\n\r\n// CSS3 Transitions only after page load(.page-loading class added to body tag and remove with JS on page load)\r\n[data-kt-app-page-loading=\"on\"] *,\r\n.page-loading * {\r\n    transition: none !important;\r\n}\r\n\r\n// Base\r\n.page-loader {\r\n\tbackground: var(--kt-body-bg);\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tz-index: 1000;\r\n   \tdisplay: none;\r\n\r\n\t[data-kt-app-page-loading=\"on\"] &,\r\n   \t.page-loading & {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n   \t\talign-items: center;\r\n\t}\r\n}\r\n","//\r\n// Scrolltop\r\n//\r\n\r\n.scrolltop {    \r\n    position: fixed;\r\n    display: none;\r\n    cursor: pointer;\r\n    z-index: $scrolltop-z-index;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: $scrolltop-size;\r\n    height: $scrolltop-size;\r\n    bottom: $scrolltop-bottom;\r\n    right: $scrolltop-end;    \r\n    background-color: var(--kt-scrolltop-bg-color);\r\n    box-shadow: var(--kt-scrolltop-box-shadow);\r\n    opacity: $scrolltop-opacity;\r\n    transition: $transition-link;\r\n    @include border-radius($border-radius);\r\n\r\n    .svg-icon {\r\n        @include svg-icon-size(24px);\r\n        color: var(--kt-scrolltop-icon-color);\r\n    }\r\n\r\n    > i {\r\n        font-size: 1.3rem;\r\n        color: var(--kt-scrolltop-icon-color);\r\n    }\r\n\r\n    &:hover {\r\n        background-color: var(--kt-scrolltop-bg-color-hover);\r\n\r\n        .svg-icon,\r\n        i {\r\n            color: var(--kt-scrolltop-icon-color-hover);\r\n        }\r\n    }\r\n\r\n    [data-kt-scrolltop=\"on\"] & {\r\n        opacity: var(--kt-scrolltop-opacity-on);\r\n        animation: animation-scrolltop .4s ease-out 1;\r\n        display: flex;\r\n\r\n        &:hover {\r\n            transition: $transition-link;\r\n            opacity: var(--kt-scrolltop-opacity-hover);\r\n        }\r\n    }\r\n\r\n    \r\n}\r\n\r\n// Tablet & Mobile Modess\r\n@include media-breakpoint-down(lg) {\r\n    .scrolltop { \r\n        bottom: $scrolltop-bottom-mobile;\r\n        right: $scrolltop-end-mobile;    \r\n        width: $scrolltop-size-mobile;\r\n        height: $scrolltop-size-mobile;\r\n    }\r\n}\r\n\r\n// Animations\r\n@keyframes animation-scrolltop {\r\n    from   { margin-bottom: -15px; }\r\n    to {  margin-bottom: 0; }\r\n}\r\n","//\r\n// Variables\r\n//\r\n\r\n// Reboot\r\n$app-bg-color: #f5f8fa;\r\n$app-bg-color-dark: #151521;\r\n$app-blank-bg-color: $white;\r\n$app-blank-bg-color-dark: $app-bg-color-dark;\r\n\r\n// Header base\r\n$app-header-base-height: 70px;\r\n$app-header-base-height-mobile: 60px;\r\n$app-header-base-bg-color: $body-bg;\r\n$app-header-base-bg-color-dark: #1e1e2d;\r\n$app-header-base-bg-color-mobile: $app-header-base-bg-color;\r\n$app-header-base-bg-color-mobile-dark: $app-header-base-bg-color-dark;\r\n$app-header-base-box-shadow: 0px 10px 30px 0px rgba(82,63,105,0.05);\r\n$app-header-base-box-shadow-dark: none;\r\n$app-header-base-box-shadow-mobile: $app-header-base-box-shadow;\r\n$app-header-base-box-shadow-mobile-dark: $app-header-base-box-shadow-dark;\r\n$app-header-base-menu-link-bg-color-active: $menu-link-bg-color-active;\r\n$app-header-base-menu-link-bg-color-active-dark: #2A2A3C;\r\n\r\n// Header light\r\n$app-header-light-separator-color: #E4E6EF;\r\n$app-header-light-separator-color-dark: $border-color-dark;\r\n\r\n// Header dark\r\n$app-header-dark-bg-color: #1e1e2d;\r\n$app-header-dark-separator-color: #282a3d;\r\n$app-header-dark-scrollbar-color: #3b3b64;\r\n$app-header-dark-scrollbar-color-hover: lighten($app-header-dark-scrollbar-color, 3%);\r\n\r\n// Sidebar base\r\n$app-sidebar-base-width: 265px;\r\n$app-sidebar-base-width-mobile: 250px; \r\n\r\n$app-sidebar-base-toggle-btn-box-shadow: 0px 0px 10px rgba(113, 121, 136, 0.1);\r\n$app-sidebar-base-toggle-btn-box-shadow-dark: none;\r\n$app-sidebar-base-toggle-btn-bg-color: $body-bg;\r\n$app-sidebar-base-toggle-btn-bg-color-dark: $app-header-base-menu-link-bg-color-active-dark;\r\n\r\n// Sidebar minimize\r\n$app-sidebar-minimize-width: 75px;\r\n\r\n// Sidebar light\r\n$app-sidebar-light-bg-color: $body-bg;\r\n$app-sidebar-light-bg-color-dark: #1e1e2d;\r\n\r\n$app-sidebar-light-box-shadow: 0 0 28px 0 rgba(82,63,105,.05);\r\n$app-sidebar-light-box-shadow-dark: none;\r\n\r\n$app-sidebar-light-separator-color: $app-header-light-separator-color;\r\n$app-sidebar-light-separator-color-dark: $app-header-light-separator-color-dark;\r\n\r\n$app-sidebar-light-scrollbar-color: $gray-200;\r\n$app-sidebar-light-scrollbar-color-dark: $gray-200-dark;\r\n$app-sidebar-light-scrollbar-color-hover: $gray-200;\r\n$app-sidebar-light-scrollbar-color-hover-dark: $gray-200-dark;\r\n$app-sidebar-light-menu-heading-color: #B5B5C3;\r\n$app-sidebar-light-menu-heading-color-dark: $gray-500-dark;\r\n$app-sidebar-light-menu-link-bg-color-active: #F4F6FA;\r\n$app-sidebar-light-menu-link-bg-color-active-dark: #2A2A3C;\r\n$app-sidebar-light-header-menu-link-bg-color-active: #EAEEF2;\r\n$app-sidebar-light-header-menu-link-bg-color-active-dark: $gray-100-dark;\r\n    \r\n// Sidebar dark\r\n$app-sidebar-dark-bg-color: #1e1e2d;\r\n$app-sidebar-dark-separator-color: #393945;\r\n$app-sidebar-dark-scrollbar-color: $gray-300-dark;\r\n$app-sidebar-dark-scrollbar-color-hover: $gray-300-dark;\r\n$app-sidebar-dark-menu-heading-color: #646477;\r\n$app-sidebar-dark-menu-link-bg-color-active: #2A2A3C;\r\n\r\n// Toolbar base\r\n$app-toolbar-base-height: 55px;\r\n$app-toolbar-base-bg-color:$body-bg;\r\n$app-toolbar-base-bg-color-dark: darken(#1e1e2d, 2%);\r\n$app-toolbar-base-bg-color-mobile: $app-toolbar-base-bg-color;\r\n$app-toolbar-base-bg-color-mobile-dark: $app-toolbar-base-bg-color-dark;\r\n$app-toolbar-base-box-shadow: 0px 10px 30px 0px rgba(82,63,105,0.05);\r\n$app-toolbar-base-box-shadow-dark: none;\r\n$app-toolbar-base-box-shadow-mobile: $app-toolbar-base-box-shadow;\r\n$app-toolbar-base-box-shadow-mobile-dark: $app-toolbar-base-box-shadow-mobile;\r\n$app-toolbar-base-border-top: 1px solid $border-color;\r\n$app-toolbar-base-border-top-dark: 0;\r\n$app-toolbar-base-border-top-mobile: $app-toolbar-base-border-top;\r\n$app-toolbar-base-border-top-mobile-dark: $app-toolbar-base-border-top-mobile;\r\n\r\n// Footer\r\n$app-footer-height: 60px;\r\n$app-footer-height-mobile: auto;\r\n$app-footer-bg-color: $body-bg;\r\n$app-footer-bg-color-dark: #1e1e2d;\r\n$app-footer-bg-color-mobile: $app-footer-bg-color;\r\n$app-footer-bg-color-mobile-dark: $app-footer-bg-color-dark;\r\n\r\n// Scrolltop\r\n$scrolltop-bottom: 43px;\r\n$scrolltop-bottom-mobile: 23px;\r\n$scrolltop-end: 7px;\r\n$scrolltop-end-mobile: 5px;\r\n\r\n// Layout builder toggle(used for Demo purposes only)\r\n$app-layout-builder-toggle-end: 50px;\r\n$app-layout-builder-toggle-end-mobile: 40px;\r\n$app-layout-builder-toggle-bottom: 40px;\r\n$app-layout-builder-toggle-bottom-mobile: 20px;\r\n\r\n\r\n","//\r\n// SVG Icon\r\n//\r\n\r\n.svg-icon {\r\n    line-height: 1;\r\n    color: var(--kt-text-muted);\r\n    @include svg-icon-size(get($font-sizes, 5));\r\n\r\n    // Theme colors\r\n    @each $name, $color in $theme-text-colors {\r\n        &.svg-icon-#{$name} {\r\n            color: var(--kt-text-#{$name});\r\n        }\r\n    }\r\n\r\n    // Responsive icon sizes\r\n    @each $breakpoint in map-keys($grid-breakpoints) {\r\n        @include media-breakpoint-up($breakpoint) {\r\n            $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n            // Sizes\r\n            @each $name, $value in $font-sizes {\r\n                &.svg-icon#{$infix}-#{$name} {\r\n                    @include svg-icon-size($value, true);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Fixed\r\n//\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n    @include media-breakpoint-up($breakpoint) {\r\n        $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n        .fixed-top#{$infix} {\r\n            position: fixed;\r\n            z-index: $fixed-z-index;\r\n            top: 0;\r\n            left: 0;\r\n            right: 0;    \r\n        }\r\n    }\r\n}\r\n\r\n","//\r\n// Timeline\r\n//\r\n\r\n// Base\r\n.timeline {\r\n\t// Item\r\n\t.timeline-item {\r\n\t\tposition: relative;\r\n\t\tpadding: 0;\r\n\t\tmargin: 0;\r\n\t\tdisplay: flex;\r\n\t\talign-items: flex-start;\r\n\r\n\t\t&:last-child {\r\n\t\t\t.timeline-line {\r\n\t\t\t\tbottom: 100%;\r\n\t\t\t}\r\n\t\t}\r\n\t}        \r\n\r\n\t// Line\r\n\t.timeline-line {\r\n\t\tdisplay: block;\r\n\t\tcontent: \" \";\r\n\t\tjustify-content: center;     \r\n\t\tposition: absolute;\r\n\t\tz-index: 0;\r\n\t\tleft: 0;\r\n\t\ttop:0;\r\n\t\tbottom: 0;\r\n\t\ttransform: translate(50%);\r\n\t\tborder-left-width: 1px;\r\n\t\tborder-left-style: dashed;\r\n\t\tborder-left-color: var(--kt-gray-300); \r\n\t}\r\n\r\n\t// Icon\r\n\t.timeline-icon {\r\n\t\tz-index: 1;\r\n\t\tflex-shrink: 0;\r\n\t\tmargin-right: 1rem;\r\n\t}\r\n\r\n\t// Content\r\n\t.timeline-content {\r\n\t\twidth: 100%;\r\n\t\toverflow: auto;\r\n\t\tmargin-bottom: 1.5rem;\r\n\t}\r\n\r\n\t// Vertical center \r\n\t&.timeline-center {\r\n\t\t.timeline-item {\r\n\t\t\talign-items: center;\r\n\r\n\t\t\t&:first-child {\r\n                .timeline-line {\r\n                    top: 50%;\r\n                }\r\n            }\r\n\r\n            &:last-child {\r\n                .timeline-line {\r\n                    bottom: 50%;\r\n                }\r\n            }\r\n\t\t}\r\n\t}\r\n}\r\n","//\r\n// Timeline Label\r\n//\r\n\r\n\r\n.timeline-label {\r\n\tposition: relative;\r\n\r\n    $label-width: 50px;\r\n\r\n\t&:before {\r\n\t\tcontent: '';\r\n\t\tposition: absolute;\r\n\t\tleft: $label-width + 1px;\r\n\t\twidth: 3px;\r\n\t\ttop: 0;\r\n\t\tbottom: 0;\r\n\t\tbackground-color: var(--kt-gray-200);\r\n\t}\r\n\r\n\t// \r\n\t.timeline-item {\r\n\t\tdisplay: flex;\r\n        align-items: flex-start;\r\n\t\tposition: relative;\r\n\t\tmargin-bottom: 1.7rem;\r\n\r\n        &:last-child {\r\n            margin-bottom: 0;\r\n        }\r\n\t}\r\n\r\n\t.timeline-label {\r\n\t\twidth: $label-width;\r\n\t\tflex-shrink: 0;\r\n\t\tposition: relative;\r\n\t\tcolor: var(--kt-gray-800);\r\n\t}\r\n\r\n\t.timeline-badge {\r\n\t\tflex-shrink: 0;\r\n\t\tbackground-color: var(--kt-body-bg);\r\n\t\twidth: 1rem;\r\n\t\theight: 1rem;\r\n\t\tborder-radius: 100%;\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n\t\talign-items: center;\r\n\t\tz-index: 1;\r\n\t\tposition: relative;\r\n\t\tmargin-top: 1px;\r\n\t\tmargin-left: -0.5rem;\r\n\t\tpadding: 3px !important;\r\n\t\tborder: 6px solid var(--kt-body-bg) !important;\r\n\r\n\t\tspan {\r\n\t\t\tdisplay: block;\r\n\t\t\tborder-radius: 100%;\r\n\t\t\twidth: 6px;\r\n\t\t\theight: 6px;\r\n\t\t\tbackground-color: var(--kt-gray-200);\r\n\t\t}\r\n\t}\r\n\r\n\t.timeline-content {\r\n\t\tflex-grow: 1;\r\n\t}\r\n}\r\n","//\r\n// Demo\r\n//\r\n\r\n\r\n.overlay  {\r\n    position: relative;\r\n\r\n    .overlay-layer {\r\n        position: absolute;\r\n        top: 0;\r\n        bottom: 0;\r\n        left: 0;\r\n        right: 0;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        background-color: var(--kt-overlay-bg);\r\n        transition: all 0.3s ease;\r\n        opacity: 0;\r\n    }\r\n\r\n    &.overlay-show,\r\n    &.overlay-block,\r\n    &:hover {\r\n        .overlay-layer {\r\n            transition: all 0.3s ease;\r\n            opacity: 1;\r\n        }\r\n    }\r\n\r\n    &.overlay-block {\r\n        cursor: wait;\r\n    }\r\n}\r\n","//\r\n// Bullet\r\n//\r\n\r\n// Base\r\n.bullet {\r\n    display: inline-block;\r\n    background-color: var(--kt-bullet-bg-color); \r\n    @include border-radius($bullet-bar-border-radius);\r\n    width: $bullet-bar-width;\r\n    height: $bullet-bar-height;\r\n    flex-shrink: 0;\r\n}\r\n\r\n// Dot bullet\r\n.bullet-dot {\r\n    width: $bullet-dot-size;\r\n    height: $bullet-dot-size;\r\n    border-radius: 100% !important;\r\n}\r\n\r\n// Vertical bullet\r\n.bullet-vertical {\r\n    width: $bullet-bar-height;\r\n    height: $bullet-bar-width;\r\n}\r\n\r\n// Vertical line\r\n.bullet-line {\r\n    width: $bullet-line-width;\r\n    height: $bullet-line-height;\r\n    border-radius: 0;\r\n}","//\r\n// Drawer\r\n//\r\n\r\n// Drawer\r\n.drawer {\r\n\tdisplay: flex !important;\r\n\toverflow: auto;\r\n\tz-index: $drawer-z-index;\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tbackground-color: var(--kt-drawer-bg-color);\r\n\ttransition: transform $drawer-transition-speed ease-in-out !important;\r\n\r\n\t&.drawer-start {\r\n\t\tleft: 0;\r\n\t\ttransform: translateX(-100%);\r\n\t}\r\n\r\n\t&.drawer-end {\r\n\t\tright: 0;\r\n\t\ttransform: translateX(100%);\r\n\t}\r\n\r\n\t&.drawer-on {\r\n\t\ttransform: none;\r\n\t\tbox-shadow: var(--kt-drawer-box-shadow);\r\n\t\ttransition: transform $drawer-transition-speed ease-in-out !important;\r\n\t}\r\n}\r\n\r\n// Drawer Overlay\r\n.drawer-overlay {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tbottom: 0;\r\n\tright: 0;\r\n\toverflow: hidden;\r\n\tz-index: $drawer-z-index - 1;\r\n\tbackground-color: var(--kt-drawer-overlay-bg-color);\r\n\tanimation: animation-drawer-fade-in $drawer-overlay-animation-speed ease-in-out 1;\r\n}\r\n\r\n// Initial state\r\n[data-kt-drawer=\"true\"] {\r\n\tdisplay: none;\r\n}\r\n\r\n// Animation\r\n@keyframes animation-drawer-fade-in {\r\n\tfrom   { opacity: 0; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n// Tablet & Mobile Modes\r\n@include media-breakpoint-down(lg) {\r\n\tbody[data-kt-drawer=\"on\"] {\r\n\t\toverflow: hidden;\r\n\t}\r\n}\r\n","//\r\n// Badge\r\n//\r\n\r\n.badge {\r\n    --#{$prefix}badge-color: var(--kt-badge-color);\r\n\r\n    display: inline-flex;\r\n    align-items: center;\r\n    \r\n    // Fixed size\r\n    &.badge-circle,\r\n    &.badge-square {\r\n        display: inline-flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        height: $badge-size;\r\n        min-width: $badge-size;\r\n        padding: 0 0.1rem;\r\n        line-height: 0;\r\n    }\r\n\r\n    // Circle\r\n    &.badge-circle {\r\n        border-radius: 50%;\r\n        padding: 0;\r\n        min-width: unset;\r\n        width: $badge-size;\r\n    }\r\n\r\n    // Sizes\r\n    &.badge-sm {\r\n        min-width: $badge-size-sm;\r\n        font-size: $badge-font-size-sm;\r\n\r\n        &.badge-square {\r\n            height: $badge-size-sm;\r\n        }\r\n\r\n        &.badge-circle {\r\n            width: $badge-size-sm;\r\n            height: $badge-size-sm;\r\n        }\r\n    }\r\n\r\n    &.badge-lg {\r\n        min-width: $badge-size-lg;\r\n        font-size: $badge-font-size-lg;\r\n\r\n        &.badge-square {\r\n            height: $badge-size-lg;\r\n        }\r\n\r\n        &.badge-circle {\r\n            width: $badge-size-lg;\r\n            height: $badge-size-lg;\r\n        }\r\n    }\r\n}\r\n\r\n@each $name, $value in $theme-colors {\r\n    .badge-#{$name} {\r\n        color: var(--kt-#{$name}-inverse);\r\n        background-color: var(--kt-#{$name});\r\n\r\n        &.badge-outline {\r\n            border: 1px solid var(--kt-#{$name});\r\n            color: var(--kt-#{$name});\r\n            background-color: transparent;\r\n        }\r\n    }\r\n\r\n    .badge-light-#{$name} {\r\n        color: var(--kt-#{$name});\r\n        background-color: var(--kt-#{$name}-light);\r\n    }    \r\n}\r\n","//\r\n// Indicator\r\n//\r\n\r\n.indicator-progress {\r\n    display: none;\r\n\r\n    [data-kt-indicator=\"on\"] > & {\r\n        display: inline-block;\r\n    }\r\n}\r\n\r\n.indicator-label {\r\n    [data-kt-indicator=\"on\"] > & {\r\n        display: none;\r\n    }\r\n}","//\r\n// Hover effects\r\n//\r\n\r\n.hover-elevate-up {\r\n\ttransition: transform 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-5%);\r\n\t\ttransition: transform 0.3s ease;\r\n\t}\r\n}\r\n\r\n.hover-elevate-down {\r\n\ttransition: transform 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(5%);\r\n\t\ttransition: transform 0.3s ease;\r\n\t}\r\n}\r\n\r\n.hover-scale {\r\n\ttransition: transform 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: scale(1.1);\r\n\t\ttransition: transform 0.3s ease;\r\n\t}\r\n}\r\n\r\n.hover-rotate-end {\r\n\ttransition: transform 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: rotate(4deg);\r\n\t\ttransition: transform 0.3s ease;\r\n\t}\r\n}\r\n\r\n.hover-rotate-start {\r\n\ttransition: transform 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: rotate(-4deg);\r\n\t\ttransition: transform 0.3s ease;\r\n\t}\r\n}","//\r\n// Rotate\r\n// \r\n\r\n\r\n$rotate-transition: transform 0.3s ease;\r\n\r\n.rotate {\r\n    display: inline-flex;\r\n    align-items: center;\r\n}\r\n\r\n@each $value in (90, 180, 270) {\r\n    .rotate-#{$value} {\r\n        transition: $rotate-transition;\r\n        backface-visibility: hidden;\r\n        will-change: transform;\r\n\r\n        .collapsible:not(.collapsed)> & ,\r\n        .show > &,\r\n        .active > & {\r\n            transform: rotateZ(#{$value}deg);\r\n            transition: $rotate-transition;\r\n\r\n            [direction=\"rtl\"] & {\r\n                transform: rotateZ(-#{$value}deg);\r\n            }\r\n        }\r\n    }\r\n\r\n    .rotate-n#{$value} {\r\n        transition: $rotate-transition;\r\n        backface-visibility: hidden;\r\n        will-change: transform;\r\n\r\n        .collapsible:not(.collapsed)> &,\r\n        .show > &,\r\n        .active > & {\r\n            transform: rotateZ(-#{$value}deg);\r\n            transition: $rotate-transition;\r\n\r\n            [direction=\"rtl\"] & {\r\n                transform: rotateZ(#{$value}deg);\r\n            }\r\n        }\r\n    }\r\n}","//\r\n// Scroll\r\n//\r\n\r\n\r\n// Customize native scrollbars only for desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    main,\r\n    span,\r\n    ol,\r\n    ul,\r\n    pre,\r\n    div {\r\n        // Firefox\r\n        scrollbar-width: thin;\r\n\r\n        // Webkit\r\n        &::-webkit-scrollbar {            \r\n            width: var(--kt-scrollbar-width);\r\n            height: var(--kt-scrollbar-height);\r\n        }\r\n\r\n        ::-webkit-scrollbar-track {\r\n            @include border-radius($scrollbar-border-radius);\r\n        }\r\n\r\n        ::-webkit-scrollbar-thumb {\r\n            @include border-radius($scrollbar-border-radius);\r\n        }\r\n\r\n        // Default color\r\n        @include scrollbar-color(var(--kt-scrollbar-color), var(--kt-scrollbar-hover-color));\r\n    }\r\n}\r\n\r\n// Overflow scroll\r\n.scroll {\r\n    overflow: scroll;\r\n    position: relative;\r\n\r\n    // Tablet & mobile modes\r\n    @include media-breakpoint-down(lg) {\r\n        overflow: auto;\r\n    }\r\n}\r\n\r\n.scroll-x {\r\n    overflow-x: scroll;\r\n    position: relative;\r\n\r\n    // Tablet & mobile modes\r\n    @include media-breakpoint-down(lg) {\r\n        overflow-x: auto;\r\n    }\r\n}\r\n\r\n.scroll-y {\r\n    overflow-y: scroll;\r\n    position: relative;\r\n\r\n    // Tablet & mobile modes\r\n    @include media-breakpoint-down(lg) {\r\n        overflow-y: auto;\r\n    }\r\n}\r\n\r\n// Hover overflow scroll\r\n.hover-scroll {\r\n    position: relative;\r\n\r\n    // Desktop mode\r\n    @include media-breakpoint-up(lg) {\r\n        overflow: hidden;\r\n\r\n        border-right: var(--kt-scrollbar-width) solid transparent;\r\n        border-bottom: var(--kt-scrollbar-height) transparent;\r\n        margin-right: calc( -1 * var(--kt-scrollbar-width));\r\n        margin-bottom: calc( -1 * var(--kt-scrollbar-height));\r\n\r\n        &:hover {\r\n            overflow: scroll;\r\n            border-right: 0;\r\n            border-bottom: 0;\r\n        }\r\n\r\n        // Firefox hack\r\n        @-moz-document url-prefix() {\r\n            overflow: scroll;\r\n            position: relative;\r\n            border-right: 0;\r\n            border-bottom: 0;\r\n        }\r\n    }\r\n\r\n    // Tablet & mobile modes\r\n    @include media-breakpoint-down(lg) {\r\n        overflow: auto;\r\n    }\r\n}\r\n\r\n// Hover overflow scroll y\r\n.hover-scroll-y {\r\n    position: relative;\r\n\r\n    // Desktop mode\r\n    @include media-breakpoint-up(lg) {\r\n        overflow-y: hidden;\r\n        border-right: var(--kt-scrollbar-width) solid transparent;\r\n        margin-right: calc( -1 * var(--kt-scrollbar-width));\r\n\r\n        &:hover {\r\n            overflow-y: scroll;\r\n            border-right: 0;\r\n        }\r\n\r\n        // Firefox hack\r\n        @-moz-document url-prefix() {\r\n            overflow-y: scroll;\r\n            position: relative;\r\n            border-right: 0;\r\n        }\r\n    }\r\n\r\n    // Tablet & mobile modes\r\n    @include media-breakpoint-down(lg) {\r\n        overflow-y: auto;\r\n    }\r\n}\r\n\r\n// Hover overflow scroll x\r\n.hover-scroll-x {\r\n    position: relative;\r\n\r\n    // Desktop mode\r\n    @include media-breakpoint-up(lg) {\r\n        overflow-x: hidden;\r\n        border-bottom: var(--kt-scrollbar-height) solid transparent;\r\n\r\n        &:hover {\r\n            overflow-x: scroll;\r\n            border-bottom: 0;\r\n        }\r\n\r\n        // Firefox hack\r\n        @-moz-document url-prefix() {\r\n            overflow-x: scroll;\r\n            position: relative;\r\n            border-bottom: 0;\r\n        }\r\n    }\r\n\r\n    // Tablet & mobile modes\r\n    @include media-breakpoint-down(lg) {\r\n        overflow-x: auto;\r\n    }\r\n}\r\n\r\n// Hover overflow overlay\r\n.hover-scroll-overlay {    \r\n    position: relative;\r\n\r\n    // Desktop mode\r\n    @include media-breakpoint-up(lg) {\r\n        overflow: hidden;\r\n\r\n        // Webkit\r\n        &::-webkit-scrollbar {\r\n            width: calc( var(--kt-scrollbar-width) + var(--kt-scrollbar-width) );\r\n            height: calc( var(--kt-scrollbar-width) + var(--kt-scrollbar-width) );\r\n        }\r\n\r\n        &::-webkit-scrollbar-track {\r\n            border-radius: 0;\r\n        }\r\n\r\n        &::-webkit-scrollbar-thumb {\r\n            border-radius: 0;\r\n            background-clip: content-box;\r\n            border-right: var(--kt-scrollbar-space) solid transparent;\r\n            border-bottom: var(--kt-scrollbar-space) solid transparent;\r\n        }\r\n\r\n        &:hover {\r\n            overflow: overlay;\r\n        }\r\n\r\n        // Firefox hack\r\n        @-moz-document url-prefix() {\r\n            overflow: scroll;\r\n            position: relative;\r\n        }\r\n    }\r\n\r\n    // Tablet & mobile modes\r\n    @include media-breakpoint-down(lg) {\r\n        overflow: auto;\r\n    }   \r\n}\r\n\r\n// Hover overflow overlay y\r\n.hover-scroll-overlay-y {    \r\n    position: relative;\r\n\r\n    // Desktop mode\r\n    @include media-breakpoint-up(lg) {\r\n        overflow-y: hidden;\r\n\r\n        // Webkit\r\n        &::-webkit-scrollbar {\r\n            width: calc( var(--kt-scrollbar-width) + var(--kt-scrollbar-space));\r\n        }\r\n\r\n        &::-webkit-scrollbar-track {\r\n            border-radius: 0;\r\n        }\r\n\r\n        &::-webkit-scrollbar-thumb {\r\n            border-radius: 0;\r\n            background-clip: content-box;\r\n            border-right: var(--kt-scrollbar-space) solid transparent;\r\n        }\r\n\r\n        &:hover {\r\n            overflow-y: overlay;\r\n        }\r\n\r\n        // Firefox hack\r\n        @-moz-document url-prefix() {\r\n            overflow-y: scroll;\r\n            position: relative;\r\n        }\r\n    }\r\n\r\n    // Tablet & mobile modes\r\n    @include media-breakpoint-down(lg) {\r\n        overflow-y: auto;\r\n    }   \r\n}\r\n\r\n// Hover overflow overlay x\r\n.hover-scroll-overlay-x {    \r\n    position: relative;\r\n\r\n    // Desktop mode\r\n    @include media-breakpoint-up(lg) {\r\n        overflow-x: hidden;\r\n\r\n        // Webkit\r\n        &::-webkit-scrollbar {\r\n            height: calc( var(--kt-scrollbar-width) + var(--kt-scrollbar-space) );\r\n        }\r\n\r\n        &::-webkit-scrollbar-track {\r\n            border-radius: 0;\r\n        }\r\n\r\n        &::-webkit-scrollbar-thumb {\r\n            border-radius: 0;\r\n            background-clip: content-box;\r\n            border-bottom: var(--kt-scrollbar-space) solid transparent;\r\n        }\r\n\r\n        &:hover {\r\n            overflow-x: overlay;\r\n        }\r\n\r\n        // Firefox hack\r\n        @-moz-document url-prefix() {\r\n            overflow-x: scroll;\r\n            position: relative;\r\n        }\r\n    }\r\n\r\n    // Tablet & mobile modes\r\n    @include media-breakpoint-down(lg) {\r\n        overflow-x: auto;\r\n    }   \r\n}\r\n\r\n// Utility classes  \r\n.scroll-ps {\r\n    padding-left: var(--kt-scrollbar-width) !important;\r\n}\r\n\r\n.scroll-ms {\r\n    margin-left: var(--kt-scrollbar-width) !important;\r\n}\r\n\r\n.scroll-mb {\r\n    margin-bottom: var(--kt-scrollbar-height) !important;\r\n}\r\n\r\n.scroll-pe {\r\n    padding-right: var(--kt-scrollbar-width) !important;\r\n}\r\n\r\n.scroll-me {\r\n    margin-right: var(--kt-scrollbar-width) !important;\r\n}\r\n\r\n.scroll-px {\r\n    padding-left: var(--kt-scrollbar-width) !important;\r\n    padding-right: var(--kt-scrollbar-width) !important;\r\n}\r\n\r\n.scroll-mx {\r\n    margin-left: var(--kt-scrollbar-width) !important;\r\n    margin-right: var(--kt-scrollbar-width) !important;\r\n}","//\r\n// Scroll mixins\r\n//\r\n\r\n@mixin scrollbar-color($color, $hover-color: null) {\r\n    // Firefox\r\n    scrollbar-color: $color transparent;\r\n    \r\n    // Webkit\r\n    &::-webkit-scrollbar-thumb {\r\n        background-color: $color;\r\n    }\r\n\r\n    &::-webkit-scrollbar-corner {\r\n        background-color: transparent;\r\n    }\r\n\r\n    @if ($hover-color != null) {\r\n        // Hover state\r\n        &:hover {\r\n            // Firefox\r\n            scrollbar-color: $hover-color transparent;\r\n\r\n            // Webkit\r\n            &::-webkit-scrollbar-thumb {\r\n                background-color: $hover-color;\r\n            }\r\n\r\n            &::-webkit-scrollbar-corner {\r\n                background-color: transparent;\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// Rating\r\n//\r\n\r\n.rating {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.rating-input {\r\n    position: absolute !important;\r\n    left: -9999px !important;\r\n\r\n    &[disabled] {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.rating-label {\r\n    padding: 0;\r\n    margin: 0;\r\n\r\n    & > i,\r\n    & > .svg-icon {\r\n        line-height: 1;\r\n        color: var(--kt-rating-color-default);\r\n    }\r\n}\r\n\r\nlabel.rating-label {\r\n    cursor: pointer;\r\n}\r\n\r\ndiv.rating-label.checked,\r\nlabel.rating-label {\r\n    & > i,\r\n    & > .svg-icon {\r\n        color: var(--kt-rating-color-active);\r\n    }\r\n}\r\n\r\n.rating-input:checked ~ .rating-label {\r\n    & > i,\r\n    & > .svg-icon {\r\n        color: var(--kt-rating-color-default);\r\n    }\r\n}\r\n\r\n.rating:hover label.rating-label {\r\n    & > i,\r\n    & > .svg-icon {\r\n        color: var(--kt-rating-color-active);\r\n    }\r\n}\r\n\r\nlabel.rating-label:hover ~ .rating-label {\r\n    & > i,\r\n    & > .svg-icon {\r\n        color: var(--kt-rating-color-default);\r\n    }\r\n    color: var(--kt-rating-color-default);\r\n}\r\n","//\r\n// Stepper\r\n//\r\n\r\n// Base\r\n.stepper {\r\n\t// Content\r\n\t[data-kt-stepper-element=\"info\"],\r\n\t[data-kt-stepper-element=\"content\"] {\r\n\t\tdisplay: none;\r\n\r\n\t\t&.current {\r\n\t\t\tdisplay: flex;\r\n\t\t}\r\n\t}\r\n\r\n\t// Enable cursor pointer on clickable steppers\r\n\t.stepper-item[data-kt-stepper-action=\"step\"] {\r\n\t\tcursor: pointer;\r\n\t}\r\n\r\n\t// States\r\n\t& {\r\n\t\t[data-kt-stepper-action=\"final\"] {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\r\n\t\t[data-kt-stepper-action=\"previous\"] {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\r\n\t\t[data-kt-stepper-action=\"next\"] {\r\n\t\t\tdisplay: inline-block;\r\n\t\t}\r\n\r\n\t\t[data-kt-stepper-action=\"submit\"] {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\t}\r\n\r\n\t&.first {\r\n\t\t[data-kt-stepper-action=\"previous\"] {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\r\n\t\t[data-kt-stepper-action=\"next\"] {\r\n\t\t\tdisplay: inline-block;\r\n\t\t}\r\n\r\n\t\t[data-kt-stepper-action=\"submit\"] {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\t}\r\n\r\n\t&.between {\r\n\t\t[data-kt-stepper-action=\"previous\"] {\r\n\t\t\tdisplay: inline-block;\r\n\t\t}\r\n\r\n\t\t[data-kt-stepper-action=\"next\"] {\r\n\t\t\tdisplay: inline-block;\r\n\t\t}\r\n\r\n\t\t[data-kt-stepper-action=\"submit\"] {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\t}\r\n\r\n\t&.last {\r\n\t\t[data-kt-stepper-action=\"final\"] {\r\n\t\t\tdisplay: inline-block;\r\n\t\t}\r\n\r\n\t\t[data-kt-stepper-action=\"final\"].btn-flex {\r\n\t\t\tdisplay: flex;\r\n\t\t}\r\n\r\n\t\t[data-kt-stepper-action=\"previous\"] {\r\n\t\t\tdisplay: inline-block;\r\n\t\t}\r\n\r\n\t\t[data-kt-stepper-action=\"previous\"].btn-flex {\r\n\t\t\tdisplay: flex;\r\n\t\t}\r\n\r\n\t\t[data-kt-stepper-action=\"next\"] {\r\n\t\t\tdisplay: none;\r\n\t\t}\r\n\r\n\t\t[data-kt-stepper-action=\"next\"].btn-flex {\r\n\t\t\tdisplay: flex;\r\n\t\t}\r\n\r\n\t\t[data-kt-stepper-action=\"submit\"] {\r\n\t\t\tdisplay: inline-block;\r\n\t\t}\r\n\r\n\t\t[data-kt-stepper-action=\"submit\"].btn-flex {\r\n\t\t\tdisplay: flex;\r\n\t\t}\r\n\t}\r\n}","//\r\n// Stepper Pills\r\n//\r\n\r\n// Base\r\n.stepper.stepper-pills {\r\n    --kt-stepper-pills-size: 40px;\r\n    --kt-stepper-icon-border-radius: 9px;\r\n    --kt-stepper-icon-check-size: 1rem;\r\n\r\n    --kt-stepper-icon-bg-color: var(--kt-primary-light);    \r\n    --kt-stepper-icon-bg-color-current: var(--kt-primary);\r\n    --kt-stepper-icon-bg-color-completed: var(--kt-primary-light);\r\n\r\n    --kt-stepper-icon-border: 0;\r\n    --kt-stepper-icon-border-current: 0;\r\n    --kt-stepper-icon-border-completed: 0;\r\n\r\n    --kt-stepper-icon-number-color: var(--kt-primary);\r\n    --kt-stepper-icon-number-color-current: var(--kt-white);\r\n\r\n    --kt-stepper-icon-check-color-completed: var(--kt-primary);\r\n\r\n    --kt-stepper-label-title-opacity: 1;\r\n    --kt-stepper-label-title-opacity-current: 1;\r\n    --kt-stepper-label-title-opacity-completed: 1;\r\n\r\n    --kt-stepper-label-title-color: var(--kt-gray-800);\r\n    --kt-stepper-label-title-color-current: var(--kt-gray-600);\r\n    --kt-stepper-label-title-color-completed: var(--kt-text-muted);\r\n\r\n    --kt-stepper-label-desc-opacity: 1;\r\n    --kt-stepper-label-desc-opacity-current: 1;\r\n    --kt-stepper-label-desc-opacity-completed: 1;\r\n    \r\n    --kt-stepper-label-desc-color: var(--kt-text-muted);     \r\n    --kt-stepper-label-desc-color-current: var(--kt-text-400);\r\n    --kt-stepper-label-desc-color-completed: var(--kt-gray-400);\r\n\r\n    --kt-stepper-line-border: 1px dashed var(--kt-gray-300);\r\n    \r\n    // Nav\r\n    .stepper-nav {\r\n        display: flex;\r\n    }\r\n\r\n    // Item\r\n    .stepper-item {\r\n        display: flex;\r\n        align-items: center;\r\n        transition: $transition-link;            \r\n\r\n        // Icon\r\n        .stepper-icon {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            flex-shrink: 0;\r\n            transition: $transition-link;\r\n            width: var(--kt-stepper-pills-size);\r\n            height: var(--kt-stepper-pills-size);\r\n            border-radius: var(--kt-stepper-icon-border-radius);\r\n            background-color: var(--kt-stepper-icon-bg-color);\r\n            border: var(--kt-stepper-icon-border);\r\n            margin-right: 1.5rem;\r\n\r\n            .stepper-check {\r\n                display: none;\r\n                font-size: var(--kt-stepper-icon-check-size);\r\n            }\r\n\r\n            .stepper-number {\r\n                font-weight: $font-weight-bold;\r\n                color: var(--kt-stepper-icon-number-color);\r\n                font-size: 1.25rem;\r\n            }\r\n        }\r\n\r\n        // Label\r\n        .stepper-label {\r\n            display: flex;\r\n            flex-direction: column;\r\n            justify-content: center;\r\n\r\n            .stepper-title {\r\n                color: var(--kt-stepper-label-title-color);\r\n                opacity: var(--kt-stepper-label-title-opacity);\r\n                font-weight: 600;\r\n                font-size: 1.25rem;\r\n                margin-bottom: .3rem;\r\n            }\r\n\r\n            .stepper-desc {\r\n                opacity: var(--kt-stepper-label-desc-opacity);\r\n                color: var(--kt-stepper-label-desc-color);\r\n            }\r\n        }\r\n\r\n        // Current\r\n        &.current {\r\n            transition: $transition-link;\r\n\r\n            .stepper-icon {\r\n                transition: $transition-link;\r\n                background-color: var(--kt-stepper-icon-bg-color-current);\r\n                border: var(--kt-stepper-icon-border-current);\r\n\r\n                .stepper-check {\r\n                    display: none;\r\n                }\r\n\r\n                .stepper-number {\r\n                    color: var(--kt-stepper-icon-number-color-current);\r\n                    font-size: 1.35rem;\r\n                }\r\n            }\r\n\r\n            .stepper-label {\r\n                .stepper-title {\r\n                    opacity: var(--kt-stepper-label-title-opacity-current);\r\n                    color: var(--kt-stepper-label-title-color-current);\r\n                }\r\n\r\n                .stepper-desc {\r\n                    opacity: var(--kt-stepper-label-desc-opacity-current);\r\n                    color: var(--kt-stepper-label-desc-color-current);\r\n                }\r\n            }\r\n        }\r\n\r\n        // Completed\r\n        &.current.mark-completed:last-child,\r\n        &.completed {\r\n            .stepper-icon {\r\n                transition: $transition-link;\r\n                background-color: var(--kt-stepper-icon-bg-color-completed);\r\n                border: var(--kt-stepper-icon-border-completed);\r\n\r\n                .stepper-check {\r\n                    color: var(--kt-stepper-icon-check-color-completed);\r\n                    display: inline-block;\r\n                }\r\n\r\n                .stepper-number {\r\n                    display: none;\r\n                }\r\n            }\r\n\r\n            .stepper-label {\r\n                .stepper-title {\r\n                    opacity: var(--kt-stepper-label-title-opacity-completed);\r\n                    color: var(--kt-stepper-label-title-color-completed);\r\n                }\r\n\r\n                .stepper-desc {\r\n                    opacity: var(--kt-stepper-label-desc-opacity-completed);\r\n                    color: var(--kt-stepper-label-desc-color-completed);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // Column\r\n    &.stepper-column {\r\n        // Nav\r\n        .stepper-nav {\r\n            flex-direction: column;\r\n            align-items: start;\r\n        }\r\n\r\n        // Item\r\n        .stepper-item {\r\n            flex-direction: column;\r\n            justify-content: start;\r\n            align-items: stretch;\r\n            padding: 0;\r\n\t\t    margin: 0;\r\n        }\r\n\r\n        // Wrapper \r\n        .stepper-wrapper {\r\n            display: flex;\r\n            align-items: center;\r\n        }\r\n\r\n        // Icon\r\n        .stepper-icon {\r\n            z-index: 1;\r\n        }\r\n\r\n        // Line\r\n        .stepper-line {\r\n            display: block;\r\n            flex-grow: 1;\r\n            margin-left: calc(var(--kt-stepper-pills-size) / 2);\r\n            border-left: var(--kt-stepper-line-border); \r\n            margin-top: 2px;\r\n            margin-bottom: 2px;\r\n        }\r\n    }    \r\n}","//\r\n// Stepper Links\r\n//\r\n\r\n// Base\r\n.stepper.stepper-links {\r\n    .stepper-nav {\r\n\t\tdisplay: flex;\r\n\t\tmargin: 0 auto;\r\n\t\tjustify-content: center;\r\n\t\talign-items: center;\t\r\n\t\tflex-wrap: wrap;\r\n\r\n        .stepper-item {\r\n\t\t\tposition: relative;\r\n\t\t\tflex-shrink: 0;\r\n\t\t\tmargin: 1rem 1.5rem;\r\n\r\n\t\t\t&:after {\r\n\t\t\t\tcontent: \" \";\r\n\t\t\t\tposition: absolute;\r\n\t\t\t\ttop: 2.3rem;\r\n\t\t\t\tleft: 0;\r\n\t\t\t\theight: 2px;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\tbackground-color: transparent;\r\n\t\t\t\ttransition: $transition-link;\r\n\t\t\t}           \r\n\r\n            .stepper-title {\r\n                color: var(--kt-dark);\t\t\r\n                font-weight: 600;\r\n                font-size: 1.25rem; \r\n            }             \r\n\r\n            // Current\r\n            &.current {\r\n\t\t\t\ttransition: $transition-link;\r\n\t\t\t\t\r\n\t\t\t\t.stepper-title {\r\n\t\t\t\t\tcolor: var(--kt-primary);\t\t\t\t\t \r\n\t\t\t\t}               \r\n                \r\n\t\t\t\t&:after {\t\t\t\t\t\r\n\t\t\t\t\tbackground-color: var(--kt-primary);\r\n\t\t\t\t}\t\t\t\t                              \r\n\t\t\t} \r\n\t\t\t\r\n\t\t\t&.current.mark-completed:last-child,\r\n\t\t\t&.completed {\r\n\t\t\t\t.stepper-title {\r\n\t\t\t\t\tcolor: var(--kt-gray-400);\r\n\t\t\t\t}  \t\t\t\r\n\t\t\t}\r\n        }\r\n    }     \r\n}","//\r\n// Toggle\r\n//\r\n\r\n.toggle {\r\n    &.collapsible:not(.collapsed), // Integration with Bootstrap Collapse\r\n    &.active {\r\n        .toggle-off {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    &.collapsible.collapsed, // Integration with Bootstrap Collapse\r\n    &:not(.collapsible):not(.active) {\r\n        .toggle-on {\r\n            display: none;\r\n        }\r\n    }\r\n}","//\r\n// Shape\r\n// \r\n\r\n.xehagon {\r\n    //$edges-number: 6, $main-radius: 30%, $rounding-radius: 10%, $rotated: true, $precision: 20\r\n    @include shape(6);\r\n}\r\n\r\n.octagon {\r\n    //$edges-number: 6, $main-radius: 30%, $rounding-radius: 10%, $rotated: true, $precision: 20\r\n    @include shape(8);\r\n}","\r\n@use 'sass:math';\r\n\r\n@mixin shape($edges-number: 6, $main-radius: 30%, $rounding-radius: 10%, $rotated: true, $precision: 20) {\r\n\t$central-angle: divide(360deg, $edges-number);\r\n\t$angle: ($edges-number - 2) * divide(180deg, $edges-number);\r\n\t$max-var-angle: 2 * (90deg - divide($angle, 2));\r\n\t$precision: 6;\r\n\t$unit-var-angle: divide($max-var-angle, $precision);\t\r\n\t$r-diff: $main-radius + $rounding-radius;\r\n\r\n\t$points: ();\r\n\r\n\t@for $i from 0 to $edges-number {\r\n\t\t$vertex-angle: $i * $central-angle + if($rotated, -90deg, 0deg);\r\n\t\t$vertex-x: 50% + $r-diff * math.cos($vertex-angle);\r\n\t\t$vertex-y: 50% + $r-diff * math.sin($vertex-angle);\r\n\r\n\t\t@for $j from 0 through $precision {\r\n\t\t\t$curr-angle: $vertex-angle + ($j - 0.5 * $precision) * $unit-var-angle;\r\n\t\t\t$x: $vertex-x + $rounding-radius * math.cos($curr-angle);\r\n\t\t\t$y: $vertex-y + $rounding-radius * math.sin($curr-angle);\r\n\r\n\t\t\t$points: $points, $x $y;\r\n\t\t}\r\n\t}\r\n\t\r\n\tclip-path: polygon($points);\r\n}","//\r\n// Ribbon\r\n//\r\n\r\n// Base\r\n.ribbon {\r\n\tposition: relative;\r\n\r\n\t// Ribbon target\r\n\t.ribbon-label {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n\t\talign-items: center;\r\n\t\tpadding: 5px 10px;\r\n\t\tposition: absolute;\r\n\t\tz-index: 1;\r\n\t\tbackground-color: var(--kt-ribbon-label-bg);\r\n\t\tbox-shadow: var(--kt-ribbon-label-box-shadow);\r\n\t\tcolor: var(--kt-primary-inverse);\r\n\t\ttop: 50%;\r\n\t\tright: 0;\r\n\t\ttransform: translateX(5px) translateY(-50%);\r\n\r\n\t\t> .ribbon-inner {\r\n\t\t\tz-index: -1;\r\n\t\t\tposition: absolute;\r\n\t\t\tpadding: 0;\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\ttop: 0;\r\n\t\t\tleft: 0;\r\n\t\t}\r\n\r\n\t\t&:after {\r\n\t\t\tborder-color: var(--kt-ribbon-label-border-color);\r\n\t\t}\r\n\t}\r\n\r\n\t// Vertical aligment\r\n\t&-vertical {\r\n\t\t.ribbon-label {\r\n\t\t\tpadding: 5px 10px;\r\n\t\t\tmin-width: 36px;\r\n\t\t\tmin-height: 46px;\r\n\t\t\ttext-align: center;\r\n\t\t}\r\n\t}\r\n\r\n\t&.ribbon-top {\r\n\t\t.ribbon-label {\r\n\t\t\ttop: 0;\r\n\t\t\ttransform: translateX(-15px) translateY(-4px);\r\n\t\t\tborder-bottom-right-radius: $border-radius;\r\n\t\t\tborder-bottom-left-radius: $border-radius;\r\n\t\t}\r\n\t}\r\n\r\n\t&.ribbon-bottom {\r\n\t\t.ribbon-label {\r\n\t\t\tborder-top-right-radius: $border-radius;\r\n\t\t\tborder-top-left-radius: $border-radius;\r\n\t\t}\r\n\t}\r\n\r\n\t&.ribbon-start {\r\n\t\t.ribbon-label {\r\n\t\t\ttop: 50%;\r\n\t\t\tleft: 0;\r\n\t\t\tright: auto;\r\n\t\t\ttransform: translateX(-5px) translateY(-50%);\r\n\t\t\tborder-top-right-radius: $border-radius;\r\n\t\t\tborder-bottom-right-radius: $border-radius;\r\n\t\t}\r\n\t}\r\n\r\n\t&.ribbon-end {\r\n\t\t.ribbon-label {\r\n\t\t\tborder-top-left-radius: $border-radius;\r\n\t\t\tborder-bottom-left-radius: $border-radius;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Clip style\r\n.ribbon.ribbon-clip {\r\n\t&.ribbon-start {\r\n\t\t.ribbon-label {\r\n\t\t\tleft: -5px;\r\n\r\n\t\t\t.ribbon-inner {\r\n\t\t\t\tborder-top-right-radius: $border-radius;\r\n\t\t\t\tborder-bottom-right-radius: $border-radius;\r\n\r\n\t\t\t\t&:before,\r\n\t\t\t\t&:after {\r\n\t\t\t\t\tcontent: \"\";\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\tborder-style: solid;\r\n\t\t\t\t\tborder-color: transparent !important;\r\n\t\t\t\t\tbottom: -10px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tborder-width: 0 10px 10px 0;\r\n\t\t\t\t\tborder-right-color: var(--kt-ribbon-clip-bg) !important;\r\n\t\t\t\t\tleft: 0;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.ribbon-end {\r\n\t\t.ribbon-label {\r\n\t\t\tright: -5px;\r\n\r\n\t\t\t.ribbon-inner {\r\n\t\t\t\tborder-top-left-radius: $border-radius;\r\n\t\t\t\tborder-bottom-left-radius: $border-radius;\r\n\r\n\t\t\t\t&:before,\r\n\t\t\t\t&:after {\r\n\t\t\t\t\tcontent: \"\";\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\tborder-style: solid;\r\n\t\t\t\t\tborder-color: transparent !important;\r\n\t\t\t\t\tbottom: -10px;\r\n\t\t\t\t}\r\n\r\n\t\t\t\t&:before {\r\n\t\t\t\t\tborder-width: 0 0 10px 10px;\r\n\t\t\t\t\tborder-left-color: var(--kt-ribbon-clip-bg) !important;\r\n\t\t\t\t\tright: 0;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Triangle style\r\n.ribbon.ribbon-triangle {\r\n\tposition: absolute;\r\n\tz-index: 1;\r\n\tdisplay: flex;\r\n\talign-items: flex-start;\r\n\tjustify-content: flex-start;\r\n\r\n\t// Top start position\r\n\t&.ribbon-top-start {\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\twidth: 4rem;\r\n\t\theight: 4rem;\r\n\t\tborder-bottom: solid 2rem transparent !important;\r\n\t\tborder-left: solid 2rem transparent;\r\n\t\tborder-right: solid 2rem transparent !important;\r\n\t\tborder-top: solid 2rem transparent;\t \r\n\t}\r\n\r\n\t// Top end position\r\n\t&.ribbon-top-end {\r\n\t\ttop: 0;\r\n\t\tright: 0;\r\n\t\twidth: 4rem;\r\n\t\theight: 4rem;\r\n\t\tborder-bottom: solid 2rem transparent !important;\r\n\t\tborder-left: solid 2rem transparent !important;\r\n\t\tborder-right: solid 2rem transparent;\r\n\t\tborder-top: solid 2rem transparent;\t\t \r\n\t}\r\n\r\n\t// Botton start position\r\n\t&.ribbon-bottom-start {\r\n\t\tbottom: 0;\r\n\t\tleft: 0;\r\n\t\twidth: 4rem;\r\n\t\theight: 4rem;\r\n\t\tborder-bottom: solid 2rem transparent;\r\n\t\tborder-left: solid 2rem transparent;\r\n\t\tborder-right: solid 2rem transparent !important;\r\n\t\tborder-top: solid 2rem transparent !important;\t\r\n\t}\t\r\n\t\r\n\t// Botton end position\r\n\t&.ribbon-bottom-end {\r\n\t\tbottom: 0;\r\n\t\tright: 0;\r\n\t\twidth: 4rem;\r\n\t\theight: 4rem;\r\n\t\tborder-bottom: solid 2rem transparent;\r\n\t\tborder-right: solid 2rem transparent;\r\n\t\tborder-left: solid 2rem transparent !important;\r\n\t\tborder-top: solid 2rem transparent !important;\t\t\t \r\n\t}\t\t \r\n}\r\n\r\n","//\r\n// BlockUI\r\n//\r\n\r\n\r\n.blockui  {\r\n    position: relative;\r\n\r\n    .blockui-overlay {\r\n        transition: all 0.3s ease;\r\n        position: absolute;\r\n        top: 0;\r\n        bottom: 0;\r\n        left: 0;\r\n        right: 0;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        background-color: var(--kt-blockui-overlay-bg);\r\n\r\n        .spinner-border {\r\n            height: 1.35rem;\r\n            width: 1.35rem;\r\n        }\r\n    }\r\n\r\n    .blockui-message {\r\n        display: flex;\r\n        align-items: center;\r\n        @include border-radius($border-radius);\r\n        box-shadow: var(--kt-dropdown-box-shadow);\r\n        background-color: var(--kt-tooltip-bg);\r\n        color: var(--kt-gray-700);\r\n        font-weight: $font-weight-bold;\r\n        margin: 0 !important;\r\n        width: auto;\r\n        padding: 0.85rem 1.75rem !important;\r\n\r\n        .spinner-border {\r\n            margin-right: 0.65rem;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Explore(used for demo product demo)\r\n//\r\n\r\n$explore-primary: #00B2FF;\r\n$explore-primary-light: #F1FAFF;\r\n$explore-primary-active: #0098DA;\r\n$explore-primary-inverse: $white;\r\n\r\n$explore-success: #50CD89;\r\n$explore-success-light: #E8FFF3;\r\n$explore-success-active: #47BE7D;\r\n$explore-success-inverse: $white;\r\n\r\n$explore-warning: #FFC700;\r\n$explore-warning-inverse: $white;\r\n\r\n$explore-danger: #F1416C;\r\n$explore-warning-inverse: $white;\r\n\r\n.explore-btn-toggle {\r\n    color: var(--kt-gray-600);\r\n    background-color: $white;\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n        color: $explore-primary-inverse;\r\n        background-color: $explore-primary;\r\n    }\r\n}\r\n\r\n.explore-btn-dismiss {\t\r\n    border: 0;\r\n\r\n    &:hover {\r\n        i,\r\n        .svg-icon {\r\n            color: $explore-primary;\r\n        }\r\n    }\r\n}\r\n\r\n.explore-btn-primary {\t\r\n\tborder: 0;\r\n    color: $explore-primary-inverse;\r\n    background-color: $explore-primary;\r\n\r\n    &:hover {\r\n        color: $explore-primary-inverse;\r\n        background-color: $explore-primary-active;\r\n    }\r\n}\r\n\r\n.explore-btn-secondary {\t\r\n\tborder: 0;\r\n    color: var(--kt-gray-600);\r\n    background-color: var(--kt-gray-100);\r\n\r\n    &:hover {\r\n        color: var(--kt-gray-800);\r\n        background-color: var(--kt-gray-200);\r\n    }\r\n}\r\n\r\n.explore-btn-outline {\r\n    border: 1px dashed var(--kt-gray-300) !important;\r\n\r\n    &:hover,\r\n    &.active {\r\n        border: 1px dashed $explore-success !important;\r\n        background-color: $explore-success-light;\r\n    }\r\n}\r\n\r\n.explore-link {\t\r\n    color: $explore-primary;\r\n\r\n    &:hover {\r\n        color: $explore-primary-active;\r\n    }\r\n}\r\n\r\n.explore-link-hover:hover {\t\r\n    color: $explore-primary !important;\r\n}\r\n\r\n.explore-icon-success {\t\r\n    color: $explore-success;\r\n}\r\n\r\n.explore-icon-danger {\t\r\n    color: $explore-danger;\r\n}\r\n\r\n.explore-label-free {\r\n    color: $explore-warning-inverse;\r\n    background-color: $explore-warning;\r\n}\r\n\r\n.explore-label-pro {\r\n    color: $explore-success-inverse;\r\n    background-color: $explore-success;\r\n}","//\r\n// Engage panel(used for demo product demo)\r\n//\r\n\r\n.engage-btn {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\theight: 35px !important;\r\n\r\n\t@include button-custom-variant(\r\n\t\t$color: var(--kt-engage-btn-color), \r\n\t\t$icon-color: var(--kt-engage-btn-color), \r\n\t\t$border-color: var(--kt-engage-btn-bg), \r\n\t\t$bg-color: var(--kt-engage-btn-bg), \r\n\t\t$color-active: var(--kt-engage-btn-color-active), \r\n\t\t$icon-color-active: var(--kt-engage-btn-color-active), \r\n\t\t$border-color-active: var(--kt-engage-btn-bg),\r\n\t\t$bg-color-active: var(--kt-engage-btn-bg)\r\n\t);\r\n}","//\r\n// Cookie Alert\r\n//\r\n\r\n.cookiealert{\r\n    background: inherit;\r\n    color: inherit;\r\n}","//\r\n// Print Mode\r\n//\r\n\r\n// Add .print-content-only class to body element in order to allow printing only the content area\r\n@media print {\r\n    .print-content-only {\r\n        padding: 0 !important;\r\n        background: none !important;\r\n\r\n        .wrapper,\r\n        .page,\r\n        .page-title\r\n        .content,\r\n        .container,\r\n        .container-xxl,\r\n        .container-fluid {\r\n            background: none !important;\r\n            padding: 0 !important;\r\n            margin: 0 !important;\r\n        }\r\n\r\n        .aside,\r\n        .sidebar,\r\n        .scrolltop,\r\n        .header,\r\n        .footer,\r\n        .toolbar,\r\n        .drawer,\r\n        .btn {\r\n            display: none !important;\r\n        }\r\n    }\r\n}\r\n","//\r\n// Custom background helpers\r\n//\r\n\r\n// Background white color\r\n.bg-white {\r\n\t--kt-bg-rgb-color: var(--kt-white-bg-rgb);\r\n\tbackground-color: $black !important;\r\n}\r\n\r\n// Background black color\r\n.bg-black {\r\n\t--kt-bg-rgb-color: var(--kt-black-bg-rgb);\r\n\tbackground-color: $black !important;\r\n}\r\n\r\n// Background body color\r\n.bg-body {\r\n\t--kt-bg-rgb-color: var(--kt-body-bg-rgb);\r\n\tbackground-color: var(--kt-body-bg) !important;\r\n}\r\n\r\n.bg-hover-body {\r\n\tcursor: pointer;\r\n\r\n\t&:hover {\r\n\t\t\tbackground-color: var(--kt-body-bg) !important;\r\n\t}\r\n}\r\n\r\n.bg-active-body {\r\n\t&.active {\r\n\t\tbackground-color: var(--kt-body-bg) !important;\r\n\t}\r\n}\r\n\r\n.bg-state-body {\r\n\tcursor: pointer;\r\n\r\n\t&.active,\r\n\t&:hover {\t\t\t\t\r\n\t\tbackground-color: var(--kt-body-bg) !important;\r\n\t}\r\n}\r\n\r\n// Background theme light colors\r\n@each $name, $value in $theme-colors {\r\n\t@if (theme-light-color($name)) {\r\n\t\t.bg-light-#{$name} {\r\n\t\t\tbackground-color: var(--kt-#{$name}-light) !important;\r\n\t\t}\r\n\t}\r\n\r\n\t.bg-#{$name} {\r\n\t\t--kt-bg-rgb-color: var(--kt-#{$name}-rgb);\r\n\t\tbackground-color: var(--kt-#{$name}) !important;\r\n\t}\r\n\r\n\t@if (theme-light-color($name)) {\r\n\t\t.bg-hover-light-#{$name} {\r\n\t\t\tcursor: pointer;\r\n\r\n\t\t\t&:hover {\r\n\t\t\t\tbackground-color: var(--kt-#{$name}-light) !important;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t.bg-state-light-#{$name} {\r\n\t\t\tcursor: pointer;\r\n\r\n\t\t\t&.active,\r\n\t\t\t&:hover {\t\t\t\t\r\n\t\t\t\tbackground-color: var(--kt-#{$name}-light) !important;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t.bg-hover-#{$name} {\r\n\t\tcursor: pointer;\r\n\r\n\t\t&:hover {\r\n\t\t\tbackground-color: var(--kt-#{$name}) !important;\r\n\t\t}\r\n\t}\r\n\r\n\t.bg-active-#{$name} {\r\n\t\t&.active {\r\n\t\t\tbackground-color: var(--kt-#{$name}) !important;\r\n\t\t}\r\n\t}\r\n\r\n\t.bg-state-#{$name} {\r\n\t\tcursor: pointer;\r\n\r\n\t\t&.active,\r\n\t\t&:hover {\t\t\t\t\r\n\t\t\tbackground-color: var(--kt-#{$name}) !important;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n// Background gray colors\r\n@each $name, $value in $grays {\r\n    .bg-gray-#{$name} {\r\n\t\tbackground-color: var(--kt-gray-#{$name});\r\n\t}\r\n\r\n\t.bg-gray-#{$name}i {\r\n\t\tbackground-color: var(--kt-gray-#{$name}) !important;\r\n\t}\r\n}\r\n\r\n// Opacity\r\n@each $name, $value in $opacity-values {\r\n\t.bg-opacity-#{$name} {\r\n\t\tbackground-color: rgba(var(--kt-bg-rgb-color), #{$value}) !important;\r\n\t}\r\n\r\n\t.bg-hover-opacity-#{$name}:hover {\r\n\t\tbackground-color: rgba(var(--kt-bg-rgb-color), #{$value}) !important;\r\n\t}\r\n\r\n\t.bg-active-opacity-#{$name}.active {\r\n\t\tbackground-color: rgba(var(--kt-bg-rgb-color), #{$value}) !important;\r\n\t}\r\n\r\n\t.bg-state-opacity-#{$name} {\r\n\t\t.active,\r\n\t\t&:hover {\r\n\t\t\tbackground-color: rgba(var(--kt-bg-rgb-color), #{$value}) !important;\r\n\t\t}\t\t\r\n\t}\r\n}\r\n\r\n// Background image helpers\r\n// Background repeat\r\n.bgi-no-repeat {\r\n\tbackground-repeat: no-repeat;\r\n}\r\n\r\n// Background positions\r\n.bgi-position-y-top {\r\n\tbackground-position-y: top;\r\n}\r\n\r\n.bgi-position-y-bottom {\r\n\tbackground-position-y: bottom;\r\n}\r\n\r\n.bgi-position-y-center {\r\n\tbackground-position-y: center;\r\n}\r\n\r\n.bgi-position-x-start {\r\n\tbackground-position-x: left;\r\n}\r\n\r\n.bgi-position-x-end {\r\n\tbackground-position-x: right;\r\n}\r\n\r\n.bgi-position-x-center {\r\n\tbackground-position-x: center;\r\n}\r\n\r\n.bgi-position-top {\r\n\tbackground-position: 0 top;\r\n}\r\n\r\n.bgi-position-bottom {\r\n\tbackground-position: 0 bottom;\r\n}\r\n\r\n.bgi-position-center {\r\n\tbackground-position: center;\r\n}\r\n\r\n// Responsive helpers\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n    @include media-breakpoint-up($breakpoint) {\r\n\t\t$infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\t\t\r\n\t\t// Background sizes\r\n\t\t.bgi-size#{$infix}-auto {\r\n\t\t\tbackground-size: auto;\r\n\t\t}\r\n\r\n\t\t.bgi-size#{$infix}-cover {\r\n\t\t\tbackground-size: cover;\r\n\t\t}\r\n\r\n\t\t.bgi-size#{$infix}-contain {\r\n\t\t\tbackground-size: contain;\r\n\t\t}\t\r\n\r\n\t\t// Background attachment\r\n\t\t.bgi-attachment#{$infix}-fixed {\r\n\t\t\tbackground-attachment: fixed;\r\n\t\t}\r\n\r\n\t\t.bgi-attachment#{$infix}-scroll {\r\n\t\t\tbackground-attachment: scroll;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n\r\n\r\n","//\r\n// Border\r\n//\r\n\r\n.border-active:not(.active):not(:active):not(:hover):not(:focus) {\r\n    border-color: transparent !important;\r\n}\r\n\r\n.border-hover:not(:hover):not(:focus):not(.active):not(:active) {\r\n    cursor: pointer;\r\n    border-color: transparent !important;\r\n}\r\n\r\n// Gray border colors\r\n@each $name, $value in $grays {\r\n\t// Initial\r\n\t.border-gray-#{$name} {\r\n\t\tborder-color: var(--kt-gray-#{$name}) !important;\r\n\t}\r\n}\r\n\r\n// Hover border colors\r\n@each $name, $value in $theme-colors {\r\n    .border-hover-#{$name}:hover {\r\n        border-color: var(--kt-#{$name}) !important;\r\n    }\r\n\r\n    .border-active-#{$name}.active {\r\n        border-color: var(--kt-#{$name}) !important;\r\n    }   \r\n}\r\n\r\n// Hover transparent\r\n.border-hover-transparent:hover {\r\n    border-color: transparent !important;\r\n}\r\n\r\n// Dashed style\r\n.border-dashed {\r\n    border-style: dashed !important;\r\n    border-color: var(--kt-border-dashed-color);\r\n}\r\n\r\n.border-top-dashed {\r\n    border-top-style: dashed !important;\r\n}\r\n\r\n.border-bottom-dashed {\r\n    border-bottom-style: dashed !important;\r\n}\r\n\r\n.border-start-dashed {\r\n    border-left-style: dashed !important;\r\n}\r\n\r\n.border-end-dashed {\r\n    border-right-style: dashed !important;\r\n}\r\n\r\n// Dotted style\r\n.border-dotted {\r\n    border-style: dotted !important;\r\n}\r\n\r\n.border-top-dotted {\r\n    border-top-style: dotted !important;\r\n}\r\n\r\n.border-bottom-dotted {\r\n    border-bottom-style: dotted !important;\r\n}\r\n\r\n.border-start-dotted {\r\n    border-left-style: dotted !important;\r\n}\r\n\r\n.border-end-dotted {\r\n    border-right-style: dotted !important;\r\n}\r\n\r\n// Border transparent\r\n.border-transparent {\r\n    border-color: transparent !important;\r\n}\r\n\r\n// Border body\r\n.border-body {\r\n    border-color: var(--kt-body-bg) !important;\r\n}\r\n\r\n// Border radiuses\r\n.rounded-top-0 {\r\n    border-top-left-radius: 0 !important;\r\n    border-top-right-radius: 0 !important;\r\n}\r\n\r\n.rounded-bottom-0 {\r\n    border-bottom-left-radius: 0 !important;\r\n    border-bottom-right-radius: 0 !important;\r\n}\r\n\r\n.rounded-start-0 {\r\n    border-top-left-radius: 0 !important;\r\n    border-bottom-left-radius: 0 !important;\r\n}\r\n\r\n.rounded-end-0 {\r\n    border-top-right-radius: 0 !important;\r\n    border-bottom-right-radius: 0 !important;\r\n}\r\n\r\n.rounded-circle {\r\n    border-radius: 50% !important;\r\n}\r\n","//\r\n// Flex Utilities\r\n//\r\n\r\n\r\n@each $breakpoint in map-keys($grid-breakpoints) {\r\n    @include media-breakpoint-up($breakpoint) {\r\n        $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\r\n\r\n        .flex#{$infix}-root {\r\n\t\t\tflex: 1;\r\n\t\t}\r\n\r\n        .flex#{$infix}-column-auto {\r\n            flex: none;\r\n        }\r\n\r\n        .flex#{$infix}-column-fluid {\r\n            flex: 1 0 auto;\r\n        }\r\n\r\n        .flex#{$infix}-row-auto {\r\n            flex: 0 0 auto;\r\n        }\r\n\r\n        .flex#{$infix}-row-fluid {\r\n            flex: 1 auto;\r\n            min-width: 0;\r\n        }\r\n\r\n    \t.flex#{$infix}-center {\r\n    \t\tjustify-content: center;\r\n    \t\talign-items: center;\r\n    \t}\r\n\r\n        .flex#{$infix}-start {\r\n    \t\tjustify-content: start;\r\n    \t\talign-items: start;\r\n    \t}\r\n\r\n        .flex#{$infix}-end {\r\n    \t\tjustify-content: end;\r\n    \t\talign-items: end;\r\n    \t}\r\n\r\n        .flex#{$infix}-stack {\r\n\t\t\tjustify-content: space-between;\r\n    \t\talign-items: center;\r\n\t\t}\r\n    }\r\n}\r\n\r\n.flex-equal {\r\n    flex-grow: 1;\r\n    flex-basis: 0;\r\n    flex-shrink: 0;\r\n}\r\n","//\r\n// Shadow\r\n//\r\n\r\n.shadow-xs {\r\n    box-shadow: var(--kt-box-shadow-xs);\r\n}\r\n\r\n.shadow-sm {\r\n    box-shadow: var(--kt-box-shadow-sm);\r\n}\r\n\r\n.shadow {\r\n    box-shadow: var(--kt-box-shadow);\r\n}\r\n\r\n.shadow-lg {\r\n    box-shadow: var(--kt-box-shadow-lg);\r\n}","//\r\n// Text\r\n//\r\n\r\n// Text colors\r\n@each $name, $color in $theme-text-colors {\r\n    // Base color\r\n    .text-#{$name} {\r\n        color: var(--kt-text-#{$name}) !important;\r\n    }\r\n\r\n    // Inverse color\r\n    @if (theme-inverse-color($name)) {\r\n        .text-inverse-#{$name} {\r\n            color: var(--kt-#{$name}-inverse) !important;\r\n        }\r\n    }\r\n\r\n    @if (theme-light-color($name)) {\r\n        // Light colors\r\n        .text-light-#{$name} {\r\n            color: var(--kt-#{$name}-light) !important;\r\n        }\r\n    }\r\n\r\n    // Hover\r\n    .text-hover-#{$name} {\r\n        transition: $transition-link;\r\n\r\n        i {\r\n            transition: $transition-link;\r\n        }\r\n\r\n        &:hover {\r\n            transition: $transition-link;\r\n            color: var(--kt-text-#{$name}) !important;\r\n\r\n            i {\r\n                transition: $transition-link;\r\n\t\t\t\tcolor: var(--kt-text-#{$name}) !important;\r\n\t\t\t}\r\n\r\n\t\t\t.svg-icon {\r\n\t\t\t\tcolor: var(--kt-text-#{$name}) !important;\r\n\t\t\t}\r\n        }\r\n    }\r\n\r\n    // Active\r\n    .text-active-#{$name} {\r\n        transition: $transition-link;        \r\n\r\n        i {\r\n            transition: $transition-link;\r\n        }\r\n\r\n        &.active {\r\n            transition: $transition-link;\r\n            color: var(--kt-text-#{$name}) !important;\r\n            \r\n            i {\r\n                transition: $transition-link;\r\n                color: var(--kt-text-#{$name}) !important;\r\n            }\r\n    \r\n            .svg-icon {\r\n                color: var(--kt-text-#{$name}) !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Text transparent\r\n.text-transparent {\r\n    color: transparent;\r\n}\r\n\r\n// Cursor pointer\r\n.cursor-pointer {\r\n    cursor: pointer;\r\n}\r\n\r\n// Cursor default\r\n.cursor-default {\r\n    cursor: default;\r\n}\r\n// Cursor move\r\n.cursor-move {\r\n    cursor: move;\r\n}\r\n\r\n// Icons\r\ni {\r\n    &.bi,\r\n    &[class^=\"fonticon-\"],\r\n    &[class*=\" fonticon-\"],\r\n    &[class^=\"fa-\"],\r\n    &[class*=\" fa-\"],\r\n    &[class^=\"la-\"],\r\n    &[class*=\" la-\"] {\r\n        line-height: 1;\r\n        font-size: 1rem;\r\n        color: var(--kt-text-muted);        \r\n    }   \r\n}\r\n\r\n// Link transition\r\na {\r\n    transition: $transition-link;\r\n\r\n    &:hover {\r\n        transition:$transition-link;\r\n    }\r\n}\r\n","//\r\n// Opacity\r\n//\r\n\r\n@each $name, $value in $opacity-values {\r\n\t// Active state\r\n\t.opacity-active-#{$name}.active {\r\n\t\topacity: #{$value} !important;\r\n\t}\r\n\r\n\t// Active and hover states\r\n\t.opacity-state-#{$name} {\r\n\t\t&:hover,\r\n\t\t&.active {\r\n\t\t\topacity: #{$value} !important;\r\n\t\t}\r\n\t}\r\n}","//\r\n// Transform\r\n//\r\n\r\n.transform-90 {\r\n    transform: rotate(90deg);\r\n    transform-origin: right top;\r\n}","//\r\n// Multistep stepper\r\n//\r\n\r\n// Custom\r\n.stepper.stepper-pills.stepper-multistep {\r\n    --kt-stepper-pills-size: 46px;\r\n    --kt-stepper-icon-border-radius: 9px;\r\n    --kt-stepper-icon-check-size: 1.25rem;\r\n\r\n    --kt-stepper-icon-bg-color: rgba(255, 255, 255, 0.03);\r\n    --kt-stepper-icon-bg-color-current: var(--kt-success);\r\n    --kt-stepper-icon-bg-color-completed: rgba(255, 255, 255, 0.03);\r\n\r\n    --kt-stepper-icon-border: 1px dashed rgba(255, 255, 255, 0.3);\r\n    --kt-stepper-icon-border-current: 0;\r\n    --kt-stepper-icon-border-completed: 1px dashed rgba(255, 255, 255, 0.3);\r\n\r\n    --kt-stepper-icon-number-color: var(--kt-white);\r\n    --kt-stepper-icon-number-color-current: var(--kt-white);\r\n    --kt-stepper-icon-number-color-completed: var(--kt-white);\r\n    \r\n    --kt-stepper-icon-check-color-completed: var(--kt-success);\r\n\r\n    --kt-stepper-label-title-opacity: 0.7;\r\n    --kt-stepper-label-title-opacity-current: 1;\r\n    --kt-stepper-label-title-opacity-completed: 1;\r\n\r\n    --kt-stepper-label-title-color: var(--kt-white);\r\n    --kt-stepper-label-title-color-current: var(--kt-white);\r\n    --kt-stepper-label-title-color-completed: var(--kt-white);\r\n    \r\n    --kt-stepper-label-desc-opacity: 0.7;\r\n    --kt-stepper-label-desc-opacity-current: 0.7;\r\n    --kt-stepper-label-desc-opacity-completed: 0.7;\r\n\r\n    --kt-stepper-label-desc-color: var(--kt-white); \r\n    --kt-stepper-label-desc-color-current: var(--kt-white);\r\n    --kt-stepper-label-desc-color-completed: var(--kt-white);\r\n\r\n    --kt-stepper-line-border: 1px dashed rgba(255, 255, 255, 0.3);\r\n}\r\n","//\r\n// Landing elements\r\n//\r\n\r\n// Variables\r\n$landing-dark-color: #13263C;\r\n$landing-header-height: 100px;\r\n$landing-header-height-tablet-and-mobile: 70px;\r\n$landing-header-sticky-height: 70px;\r\n$landing-header-sticky-height-tablet-and-mobile: 70px;\r\n\r\n// Utility classes\r\n.landing-dark-bg {\r\n    background-color: $landing-dark-color;\r\n}\r\n\r\n.landing-dark-color {\r\n    color: $landing-dark-color;\r\n}\r\n\r\n.landing-dark-border {\r\n    border:1px dashed #2C3F5B;\r\n}\r\n\r\n.landing-dark-separator {\r\n    border-top:1px dashed #2C3F5B;\r\n}\r\n\r\n.landing-curve  {\r\n    position: relative;\r\n\r\n    svg {\r\n        position: relative;\r\n        top: 0;  \r\n        display: block;\r\n    }\r\n}\r\n\r\n// Landing header\r\n.landing-header {\r\n    display: flex;\r\n    align-items: center;    \r\n    height: $landing-header-height;\r\n\r\n    // Logos\r\n    .logo-default {\r\n        display: block;\r\n    }\r\n\r\n    .logo-sticky {\r\n        display: none;\r\n    }\r\n\r\n    // Menu\r\n    .menu {\r\n        // Menu link\r\n        .menu-link {\r\n            &.active {\r\n                color: $white;\r\n            }\r\n        }\r\n\r\n        // Header menu sticky mode\r\n        [data-kt-sticky-landing-header=\"on\"] & {\r\n            // Menu link\r\n            .menu-link {\r\n                &.active {\r\n                    color: $primary;\r\n                    background-color: rgba(#EFF2F5, 0.4);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // Sticky header modes\r\n    [data-kt-sticky-landing-header=\"on\"] & {        \r\n        padding: 0;\r\n        position: fixed;\r\n        top: 0;\r\n        right: 0;\r\n        left: 0;\r\n        z-index: 100;\r\n        background-color: $white;\r\n        box-shadow: 0px 10px 30px 0px rgba(82,63,105,0.05);\r\n        height: $landing-header-sticky-height;\r\n        \r\n        // Logos\r\n        .logo-sticky {\r\n            display: block;\r\n        }\r\n\r\n        .logo-default {\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n\r\n// Fix body padding top when Landing sticky header is on\r\nbody[data-kt-sticky-landing-header=\"on\"] {\r\n    padding-top: $landing-header-height;\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    // Landing header\r\n    .landing-header {\r\n        height: $landing-header-height-tablet-and-mobile;\r\n\r\n        // Menu wrapper\r\n        .landing-menu-wrapper {\r\n            position: relative;\r\n            overflow: auto;\r\n        }\r\n\r\n        // Sticky header modes\r\n        [data-kt-sticky-landing-header=\"on\"] & { \r\n            height: $landing-header-sticky-height-tablet-and-mobile;\r\n        }\r\n\r\n        // Menu\r\n        .menu {\r\n            // Menu link\r\n            .menu-link {\r\n                &.active {\r\n                    color: $primary;\r\n                    background-color: rgba(#EFF2F5, 0.4);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    // Fix body padding top when Landing sticky header is on\r\n    body[data-kt-sticky-landing-header=\"on\"] {\r\n        padding-top: $landing-header-height-tablet-and-mobile;\r\n    }\r\n}","//\r\n// Root\r\n//\r\n\r\n:root,\r\n[data-theme=\"light\"] {\r\n    // Layouts\r\n    @include property(--kt-app-bg-color, $app-bg-color);\r\n    @include property(--kt-app-blank-bg-color, $app-blank-bg-color);    \r\n\r\n    // Header base\r\n    @include property(--kt-app-header-base-bg-color, $app-header-base-bg-color);\r\n    @include property(--kt-app-header-base-bg-color-mobile, $app-header-base-bg-color-mobile);\r\n    @include property(--kt-app-header-base-box-shadow, $app-header-base-box-shadow);\r\n    @include property(--kt-app-header-base-box-shadow-mobile, $app-header-base-box-shadow-mobile);\r\n    @include property(--kt-app-header-base-border-bottom, $app-header-base-border-bottom);\r\n    @include property(--kt-app-header-base-border-bottom-mobile, $app-header-base-border-bottom-mobile);\r\n\r\n    // Header minimize\r\n    @include property(--kt-app-header-minimize-bg-color, $app-header-minimize-bg-color);\r\n    @include property(--kt-app-header-minimize-bg-color-mobile, $app-header-minimize-bg-color-mobile);\r\n    @include property(--kt-app-header-minimize-box-shadow, $app-header-minimize-box-shadow);\r\n    @include property(--kt-app-header-minimize-box-shadow-mobile, $app-header-minimize-box-shadow-mobile);\r\n    @include property(--kt-app-header-minimize-border-bottom, $app-header-minimize-border-bottom);\r\n    @include property(--kt-app-header-minimize-border-bottom-mobile, $app-header-minimize-border-bottom-mobile);\r\n\r\n    // Header sticky\r\n    @include property(--kt-app-header-sticky-bg-color, $app-header-sticky-bg-color);\r\n    @include property(--kt-app-header-sticky-bg-color-mobile, $app-header-sticky-bg-color-mobile);\r\n    @include property(--kt-app-header-sticky-box-shadow, $app-header-sticky-box-shadow);\r\n    @include property(--kt-app-header-sticky-box-shadow-mobile, $app-header-sticky-box-shadow-mobile);\r\n    @include property(--kt-app-header-sticky-border-bottom, $app-header-sticky-border-bottom);\r\n    @include property(--kt-app-header-sticky-border-bottom-mobile, $app-header-sticky-border-bottom-mobile);\r\n\r\n    // Header primary\r\n    @include property(--kt-app-header-primary-base-bg-color, $app-header-primary-base-bg-color);\r\n    @include property(--kt-app-header-primary-base-bg-color-mobile, $app-header-primary-base-bg-color-mobile);\r\n    @include property(--kt-app-header-primary-base-box-shadow, $app-header-primary-base-box-shadow);\r\n    @include property(--kt-app-header-primary-base-box-shadow-mobile, $app-header-primary-base-box-shadow-mobile);\r\n    @include property(--kt-app-header-primary-base-border-bottom, $app-header-primary-base-border-bottom);\r\n    @include property(--kt-app-header-primary-base-border-bottom-mobile, $app-header-primary-base-border-bottom-mobile);\r\n\r\n    @include property(--kt-app-header-primary-minimize-bg-color, $app-header-primary-minimize-bg-color);\r\n    @include property(--kt-app-header-primary-minimize-box-shadow, $app-header-primary-minimize-box-shadow);\r\n    @include property(--kt-app-header-primary-minimize-border-top, $app-header-primary-minimize-border-top);\r\n    @include property(--kt-app-header-primary-minimize-border-bottom, $app-header-primary-minimize-border-bottom);\r\n\r\n    @include property(--kt-app-header-primary-sticky-bg-color, $app-header-primary-sticky-bg-color);\r\n    @include property(--kt-app-header-primary-sticky-box-shadow, $app-header-primary-sticky-box-shadow);\r\n    @include property(--kt-app-header-primary-sticky-border-top, $app-header-primary-sticky-border-top);\r\n    @include property(--kt-app-header-primary-sticky-border-bottom, $app-header-primary-sticky-border-bottom);\r\n\r\n    // Header secondary\r\n    @include property(--kt-app-header-secondary-base-bg-color, $app-header-secondary-base-bg-color);\r\n    @include property(--kt-app-header-secondary-base-bg-color-mobile, $app-header-secondary-base-bg-color-mobile);\r\n    @include property(--kt-app-header-secondary-base-box-shadow, $app-header-secondary-base-box-shadow);\r\n    @include property(--kt-app-header-secondary-base-box-shadow-mobile, $app-header-secondary-base-box-shadow-mobile);\r\n    @include property(--kt-app-header-secondary-base-border-top, $app-header-secondary-base-border-top);\r\n    @include property(--kt-app-header-secondary-base-border-bottom, $app-header-secondary-base-border-bottom);\r\n    @include property(--kt-app-header-secondary-base-border-start-mobile, $app-header-secondary-base-border-bottom);\r\n    @include property(--kt-app-header-secondary-base-border-end-mobile, $app-header-secondary-base-border-end-mobile);\r\n\r\n    // Header secondary minimize\r\n    @include property(--kt-app-header-secondary-minimize-bg-color, $app-header-secondary-minimize-bg-color);\r\n    @include property(--kt-app-header-secondary-minimize-box-shadow, $app-header-secondary-minimize-box-shadow);\r\n    @include property(--kt-app-header-secondary-minimize-border-top, $app-header-secondary-minimize-border-top);\r\n    @include property(--kt-app-header-secondary-minimize-border-bottom, $app-header-secondary-minimize-border-bottom);\r\n\r\n    // Header secondary sticky\r\n    @include property(--kt-app-header-secondary-sticky-bg-color, $app-header-secondary-sticky-bg-color);\r\n    @include property(--kt-app-header-secondary-sticky-box-shadow, $app-header-secondary-sticky-box-shadow);\r\n    @include property(--kt-app-header-secondary-sticky-border-top, $app-header-secondary-sticky-border-top);\r\n    @include property(--kt-app-header-secondary-sticky-border-bottom, $app-header-secondary-sticky-border-bottom);\r\n\r\n    // Toolbar base\r\n    @include property(--kt-app-toolbar-base-bg-color, $app-toolbar-base-bg-color);\r\n    @include property(--kt-app-toolbar-base-bg-color-mobile, $app-toolbar-base-bg-color-mobile);\r\n    @include property(--kt-app-toolbar-base-box-shadow, $app-toolbar-base-box-shadow);\r\n    @include property(--kt-app-toolbar-base-box-shadow-mobile, $app-toolbar-base-box-shadow-mobile);\r\n    @include property(--kt-app-toolbar-base-border-top, $app-toolbar-base-border-top);\r\n    @include property(--kt-app-toolbar-base-border-top-mobile, $app-toolbar-base-border-top-mobile);\r\n    @include property(--kt-app-toolbar-base-border-bottom, $app-toolbar-base-border-bottom);\r\n    @include property(--kt-app-toolbar-base-border-bottom-mobile, $app-toolbar-base-border-bottom);\r\n\r\n    // Toolbar minimize\r\n    @include property(--kt-app-toolbar-minimize-bg-color, $app-toolbar-minimize-bg-color);\r\n    @include property(--kt-app-toolbar-minimize-bg-color-mobile, $app-toolbar-minimize-bg-color-mobile);\r\n    @include property(--kt-app-toolbar-minimize-box-shadow, $app-toolbar-minimize-box-shadow);\r\n    @include property(--kt-app-toolbar-minimize-box-shadow-mobile, $app-toolbar-minimize-box-shadow-mobile);\r\n    @include property(--kt-app-toolbar-minimize-border-top, $app-toolbar-minimize-border-top);\r\n    @include property(--kt-app-toolbar-minimize-border-top-mobile, $app-toolbar-minimize-border-top-mobile);\r\n    @include property(--kt-app-toolbar-minimize-border-bottom, $app-toolbar-minimize-border-bottom);\r\n    @include property(--kt-app-toolbar-minimize-border-bottom-mobile, $app-toolbar-minimize-border-bottom-mobile);\r\n\r\n    // Toolbar sticky\r\n    @include property(--kt-app-toolbar-sticky-bg-color, $app-toolbar-sticky-bg-color);\r\n    @include property(--kt-app-toolbar-sticky-bg-color-mobile, $app-toolbar-sticky-bg-color-mobile);\r\n    @include property(--kt-app-toolbar-sticky-box-shadow, $app-toolbar-sticky-box-shadow);\r\n    @include property(--kt-app-toolbar-sticky-box-shadow-mobile, $app-toolbar-sticky-box-shadow-mobile);\r\n    @include property(--kt-app-toolbar-sticky-border-top, $app-toolbar-sticky-border-top);\r\n    @include property(--kt-app-toolbar-sticky-border-top-mobile, $app-toolbar-sticky-border-top-mobile);\r\n    @include property(--kt-app-toolbar-sticky-border-bottom, $app-toolbar-sticky-border-bottom);\r\n    @include property(--kt-app-toolbar-sticky-border-bottom-mobile, $app-toolbar-sticky-border-bottom-mobile);\r\n\r\n    // Sidebar base\r\n    @include property(--kt-app-sidebar-base-bg-color, $app-sidebar-base-bg-color);\r\n    @include property(--kt-app-sidebar-base-bg-color-mobile, $app-sidebar-base-bg-color-mobile);\r\n    @include property(--kt-app-sidebar-base-box-shadow, $app-sidebar-base-box-shadow);\r\n    @include property(--kt-app-sidebar-base-box-shadow-mobile, $app-sidebar-base-box-shadow-mobile);\r\n    @include property(--kt-app-sidebar-base-border-start, $app-sidebar-base-border-start);\r\n    @include property(--kt-app-sidebar-base-border-start-mobile, $app-sidebar-base-border-start-mobile);\r\n    @include property(--kt-app-sidebar-base-border-end, $app-sidebar-base-border-end);\r\n    @include property(--kt-app-sidebar-base-border-end-mobile, $app-sidebar-base-border-end-mobile);\r\n\r\n    // Hero\r\n    @include property(--kt-app-hero-bg-color, $app-hero-bg-color);\r\n    @include property(--kt-app-hero-box-shadow, $app-hero-box-shadow);\r\n    @include property(--kt-app-hero-border-top, $app-hero-border-top);\r\n    @include property(--kt-app-hero-border-bottom, $app-hero-border-bottom);\r\n\r\n    // Sidebar sticky\r\n    @include property(--kt-app-sidebar-sticky-bg-color, $app-sidebar-sticky-bg-color);\r\n    @include property(--kt-app-sidebar-sticky-box-shadow, $app-sidebar-sticky-box-shadow);\r\n    @include property(--kt-app-sidebar-sticky-border-start, $app-sidebar-sticky-border-start);\r\n    @include property(--kt-app-sidebar-sticky-border-end, $app-sidebar-sticky-border-end);\r\n\r\n    // Sidebar minimize\r\n    @include property(--kt-app-sidebar-minimize-bg-color, $app-sidebar-minimize-bg-color);\r\n    @include property(--kt-app-sidebar-minimize-bg-color-mobile, $app-sidebar-minimize-bg-color-mobile);\r\n    @include property(--kt-app-sidebar-minimize-box-shadow, $app-sidebar-minimize-box-shadow);\r\n    @include property(--kt-app-sidebar-minimize-box-shadow-mobile, $app-sidebar-minimize-box-shadow-mobile);\r\n    @include property(--kt-app-sidebar-minimize-hover-box-shadow, $app-sidebar-minimize-hover-box-shadow);\r\n    @include property(--kt-app-sidebar-minimize-hover-box-shadow-mobile, $app-sidebar-minimize-hover-box-shadow-mobile);\r\n    @include property(--kt-app-sidebar-minimize-border-start, $app-sidebar-minimize-border-start);\r\n    @include property(--kt-app-sidebar-minimize-border-start-mobile, $app-sidebar-minimize-border-start-mobile);\r\n    @include property(--kt-app-sidebar-minimize-border-end, $app-sidebar-minimize-border-end);\r\n    @include property(--kt-app-sidebar-minimize-border-end-mobile, $app-sidebar-minimize-border-end-mobile);\r\n\r\n    // Sidebar primary\r\n    @include property(--kt-app-sidebar-primary-base-bg-color, $app-sidebar-primary-base-bg-color);\r\n    @include property(--kt-app-sidebar-primary-base-bg-color-mobile, $app-sidebar-primary-base-bg-color-mobile);\r\n    @include property(--kt-app-sidebar-primary-base-box-shadow, $app-sidebar-primary-base-box-shadow);\r\n    @include property(--kt-app-sidebar-primary-base-box-shadow-mobile, $app-sidebar-primary-base-box-shadow-mobile);\r\n    @include property(--kt-app-sidebar-primary-base-border-start, $app-sidebar-primary-base-border-start);\r\n    @include property(--kt-app-sidebar-primary-base-border-start-mobile, $app-sidebar-primary-base-border-start-mobile);\r\n    @include property(--kt-app-sidebar-primary-base-border-end, $app-sidebar-primary-base-border-end);\r\n    @include property(--kt-app-sidebar-primary-base-border-end-mobile, $app-sidebar-primary-base-border-end-mobile);\r\n\r\n    // Sidebar primary minimize\r\n    @include property(--kt-app-sidebar-primary-minimize-bg-color, $app-sidebar-primary-base-border-end-mobile);\r\n    @include property(--kt-app-sidebar-primary-minimize-bg-color-mobile, $app-sidebar-primary-minimize-bg-color-mobile);\r\n    @include property(--kt-app-sidebar-primary-minimize-box-shadow, $app-sidebar-primary-minimize-box-shadow);\r\n    @include property(--kt-app-sidebar-primary-minimize-box-shadow-mobile, $app-sidebar-primary-minimize-box-shadow-mobile);\r\n    @include property(--kt-app-sidebar-primary-minimize-hover-box-shadow, $app-sidebar-primary-minimize-hover-box-shadow);\r\n    @include property(--kt-app-sidebar-primary-minimize-hover-box-shadow-mobile, $app-sidebar-primary-minimize-hover-box-shadow-mobile);\r\n    @include property(--kt-app-sidebar-primary-minimize-border-start, $app-sidebar-primary-minimize-border-start);\r\n    @include property(--kt-app-sidebar-primary-minimize-border-start-mobile, $app-sidebar-primary-minimize-border-start-mobile);\r\n    @include property(--kt-app-sidebar-primary-minimize-border-end, $app-sidebar-primary-minimize-border-end);\r\n    @include property(--kt-app-sidebar-primary-minimize-border-end-mobile, $app-sidebar-primary-minimize-border-end-mobile);\r\n\r\n    // Sidebar secondary base\r\n    @include property(--kt-app-sidebar-secondary-base-bg-color, $app-sidebar-secondary-base-bg-color);\r\n    @include property(--kt-app-sidebar-secondary-base-bg-color-mobile, $app-sidebar-secondary-base-bg-color-mobile);\r\n    @include property(--kt-app-sidebar-secondary-base-box-shadow, $app-sidebar-secondary-base-box-shadow);\r\n    @include property(--kt-app-sidebar-secondary-base-box-shadow-mobile, $app-sidebar-secondary-base-box-shadow-mobile);\r\n    @include property(--kt-app-sidebar-secondary-base-border-start, $app-sidebar-secondary-base-border-start);\r\n    @include property(--kt-app-sidebar-secondary-base-border-start-mobile, $app-sidebar-secondary-base-border-start-mobile);\r\n    @include property(--kt-app-sidebar-secondary-base-border-end, $app-sidebar-secondary-base-border-end);\r\n    @include property(--kt-app-sidebar-secondary-base-border-end-mobile, $app-sidebar-secondary-base-border-end-mobile);\r\n\r\n    // Sidebar secondary minimize\r\n    @include property(--kt-app-sidebar-secondary-minimize-bg-color, $app-sidebar-secondary-minimize-bg-color);\r\n    @include property(--kt-app-sidebar-secondary-minimize-bg-color-mobile, $app-sidebar-secondary-minimize-bg-color-mobile);\r\n    @include property(--kt-app-sidebar-secondary-minimize-box-shadow, $app-sidebar-secondary-minimize-box-shadow);\r\n    @include property(--kt-app-sidebar-secondary-minimize-box-shadow-mobile, $app-sidebar-secondary-minimize-box-shadow-mobile);\r\n    @include property(--kt-app-sidebar-secondary-minimize-hover-box-shadow, $app-sidebar-secondary-minimize-hover-box-shadow);\r\n    @include property(--kt-app-sidebar-secondary-minimize-hover-box-shadow-mobile, $app-sidebar-secondary-minimize-hover-box-shadow-mobile);\r\n    @include property(--kt-app-sidebar-secondary-minimize-border-start, $app-sidebar-secondary-minimize-border-start);\r\n    @include property(--kt-app-sidebar-secondary-minimize-border-start-mobile, $app-sidebar-secondary-minimize-border-start-mobile);\r\n    @include property(--kt-app-sidebar-secondary-minimize-border-end, $app-sidebar-secondary-minimize-border-end);\r\n    @include property(--kt-app-sidebar-secondary-minimize-border-end-mobile, $app-sidebar-secondary-minimize-border-end-mobile);\r\n\r\n    // Sidebar panel base\r\n    @include property(--kt-app-sidebar-panel-base-bg-color, $app-sidebar-panel-base-bg-color);\r\n    @include property(--kt-app-sidebar-panel-base-bg-color-mobile, $app-sidebar-panel-base-bg-color-mobile);\r\n    @include property(--kt-app-sidebar-panel-base-box-shadow, $app-sidebar-panel-base-box-shadow);\r\n    @include property(--kt-app-sidebar-panel-base-box-shadow-mobile, $app-sidebar-panel-base-box-shadow-mobile);\r\n    @include property(--kt-app-sidebar-panel-base-border-start, $app-sidebar-panel-base-border-start);\r\n    @include property(--kt-app-sidebar-panel-base-border-start-mobile, $app-sidebar-panel-base-border-start-mobile);\r\n    @include property(--kt-app-sidebar-panel-base-border-end, $app-sidebar-panel-base-border-end);\r\n    @include property(--kt-app-sidebar-panel-base-border-end-mobile, $app-sidebar-panel-base-border-end-mobile);\r\n\r\n    // Sidebar panel sticky\r\n    @include property(--kt-app-sidebar-panel-sticky-bg-color, $app-sidebar-panel-sticky-bg-color);\r\n    @include property(--kt-app-sidebar-panel-sticky-box-shadow, $app-sidebar-panel-sticky-box-shadow);\r\n    @include property(--kt-app-sidebar-panel-sticky-border-start, $app-sidebar-panel-sticky-border-start);\r\n    @include property(--kt-app-sidebar-panel-sticky-border-end, $app-sidebar-panel-sticky-border-end);\r\n\r\n    // Sidebar panel minimize\r\n    @include property(--kt-app-sidebar-panel-minimize-bg-color, $app-sidebar-panel-minimize-bg-color);\r\n    @include property(--kt-app-sidebar-panel-minimize-bg-color-mobile, $app-sidebar-panel-minimize-bg-color-mobile);\r\n    @include property(--kt-app-sidebar-panel-minimize-box-shadow, $app-sidebar-panel-minimize-box-shadow);\r\n    @include property(--kt-app-sidebar-panel-minimize-box-shadow-mobile, $app-sidebar-panel-minimize-box-shadow-mobile);\r\n    @include property(--kt-app-sidebar-panel-minimize-hover-box-shadow, $app-sidebar-panel-minimize-hover-box-shadow);\r\n    @include property(--kt-app-sidebar-panel-minimize-hover-box-shadow-mobile, $app-sidebar-panel-minimize-hover-box-shadow-mobile);\r\n    @include property(--kt-app-sidebar-panel-minimize-border-start, $app-sidebar-panel-minimize-border-start);\r\n    @include property(--kt-app-sidebar-panel-minimize-border-start-mobile, $app-sidebar-panel-minimize-border-start-mobile);\r\n    @include property(--kt-app-sidebar-panel-minimize-border-end, $app-sidebar-panel-minimize-border-end);\r\n    @include property(--kt-app-sidebar-panel-minimize-border-end-mobile, $app-sidebar-panel-minimize-border-end-mobile);\r\n\r\n    // Aside base\r\n    @include property(--kt-app-aside-base-bg-color, $app-aside-base-bg-color);\r\n    @include property(--kt-app-aside-base-bg-color-mobile, $app-aside-base-bg-color-mobile);\r\n    @include property(--kt-app-aside-base-box-shadow, $app-aside-base-box-shadow);\r\n    @include property(--kt-app-aside-base-box-shadow-mobile, $app-aside-base-box-shadow-mobile);\r\n    @include property(--kt-app-aside-base-border-start, $app-aside-base-border-start);\r\n    @include property(--kt-app-aside-base-border-start-mobile, $app-aside-base-border-start-mobile);\r\n    @include property(--kt-app-aside-base-border-end, $app-aside-base-border-end);\r\n    @include property(--kt-app-aside-base-border-end-mobile, $app-aside-base-border-end-mobile);\r\n\r\n    // Aside sticky\r\n    @include property(--kt-app-aside-sticky-bg-color, $app-aside-sticky-bg-color);\r\n    @include property(--kt-app-aside-sticky-box-shadow, $app-aside-sticky-box-shadow);\r\n    @include property(--kt-app-aside-sticky-border-start, $app-aside-sticky-border-start);\r\n    @include property(--kt-app-aside-sticky-border-end, $app-aside-sticky-border-end);\r\n\r\n    // Aside minimize\r\n    @include property(--kt-app-aside-minimize-bg-color, $app-aside-minimize-bg-color);\r\n    @include property(--kt-app-aside-minimize-bg-color-mobile, $app-aside-minimize-bg-color-mobile);\r\n    @include property(--kt-app-aside-minimize-box-shadow, $app-aside-minimize-box-shadow);\r\n    @include property(--kt-app-aside-minimize-box-shadow-mobile, $app-aside-minimize-box-shadow-mobile);\r\n    @include property(--kt-app-aside-minimize-hover-box-shadow, $app-aside-minimize-hover-box-shadow);\r\n    @include property(--kt-app-aside-minimize-hover-box-shadow-mobile, $app-aside-minimize-hover-box-shadow-mobile);\r\n    @include property(--kt-app-aside-minimize-border-start, $app-aside-minimize-border-start);\r\n    @include property(--kt-app-aside-minimize-border-start-mobile, $app-aside-minimize-border-start-mobile);\r\n    @include property(--kt-app-aside-minimize-border-end, $app-aside-minimize-border-end);\r\n    @include property(--kt-app-aside-minimize-border-end-mobile, $app-aside-minimize-border-end-mobile);\r\n\r\n    // Page\r\n    @include property(--kt-app-page-bg-color, $app-page-bg-color);\r\n\r\n    // Wrapper\r\n    @include property(--kt-app-wrapper-bg-color, $app-wrapper-bg-color);\r\n\r\n    // Footer\r\n    @include property(--kt-app-footer-bg-color, $app-footer-bg-color);\r\n    @include property(--kt-app-footer-bg-color-mobile, $app-footer-bg-color-mobile);\r\n    @include property(--kt-app-footer-box-shadow, $app-footer-box-shadow);\r\n    @include property(--kt-app-footer-box-shadow-mobile, $app-footer-box-shadow-mobile);\r\n    @include property(--kt-app-footer-border-top, $app-footer-border-top);\r\n    @include property(--kt-app-footer-border-top-mobile, $app-footer-border-top-mobile);\r\n}\r\n\r\n[data-theme=\"dark\"] {\r\n    // Layouts\r\n    @include property(--kt-app-bg-color, $app-bg-color-dark);\r\n    @include property(--kt-app-blank-bg-color, $app-blank-bg-color-dark);\r\n\r\n    // Header base\r\n    @include property(--kt-app-header-base-bg-color, $app-header-base-bg-color-dark);\r\n    @include property(--kt-app-header-base-bg-color-mobile, $app-header-base-bg-color-mobile-dark);\r\n    @include property(--kt-app-header-base-box-shadow, $app-header-base-box-shadow-dark);\r\n    @include property(--kt-app-header-base-box-shadow-mobile, $app-header-base-box-shadow-mobile-dark);\r\n    @include property(--kt-app-header-base-border-bottom, $app-header-base-border-bottom-dark);\r\n    @include property(--kt-app-header-base-border-bottom-mobile, $app-header-base-border-bottom-mobile-dark);\r\n\r\n    // Header minimize\r\n    @include property(--kt-app-header-minimize-bg-color, $app-header-minimize-bg-color-dark);\r\n    @include property(--kt-app-header-minimize-bg-color-mobile, $app-header-minimize-bg-color-mobile-dark);\r\n    @include property(--kt-app-header-minimize-box-shadow, $app-header-minimize-box-shadow-dark);\r\n    @include property(--kt-app-header-minimize-box-shadow-mobile, $app-header-minimize-box-shadow-mobile-dark);\r\n    @include property(--kt-app-header-minimize-border-bottom, $app-header-minimize-border-bottom-dark);\r\n    @include property(--kt-app-header-minimize-border-bottom-mobile, $app-header-minimize-border-bottom-mobile-dark);\r\n\r\n    // Header sticky\r\n    @include property(--kt-app-header-sticky-bg-color, $app-header-sticky-bg-color-dark);\r\n    @include property(--kt-app-header-sticky-bg-color-mobile, $app-header-sticky-bg-color-mobile-dark);\r\n    @include property(--kt-app-header-sticky-box-shadow, $app-header-sticky-box-shadow-dark);\r\n    @include property(--kt-app-header-sticky-box-shadow-mobile, $app-header-sticky-box-shadow-mobile-dark);\r\n    @include property(--kt-app-header-sticky-border-bottom, $app-header-sticky-border-bottom-dark);\r\n    @include property(--kt-app-header-sticky-border-bottom-mobile, $app-header-sticky-border-bottom-mobile-dark);\r\n\r\n    // Header primary\r\n    @include property(--kt-app-header-primary-base-bg-color, $app-header-primary-base-bg-color-dark);\r\n    @include property(--kt-app-header-primary-base-bg-color-mobile, $app-header-primary-base-bg-color-mobile-dark);\r\n    @include property(--kt-app-header-primary-base-box-shadow, $app-header-primary-base-box-shadow-dark);\r\n    @include property(--kt-app-header-primary-base-box-shadow-mobile, $app-header-primary-base-box-shadow-mobile-dark);\r\n    @include property(--kt-app-header-primary-base-border-bottom, $app-header-primary-base-border-bottom-dark);\r\n    @include property(--kt-app-header-primary-base-border-bottom-mobile, $app-header-primary-base-border-bottom-mobile-dark);\r\n\r\n    @include property(--kt-app-header-primary-minimize-bg-color, $app-header-primary-minimize-bg-color-dark);\r\n    @include property(--kt-app-header-primary-minimize-box-shadow, $app-header-primary-minimize-box-shadow-dark);\r\n    @include property(--kt-app-header-primary-minimize-border-top, $app-header-primary-minimize-border-top-dark);\r\n    @include property(--kt-app-header-primary-minimize-border-bottom, $app-header-primary-minimize-border-bottom-dark);\r\n\r\n    @include property(--kt-app-header-primary-sticky-bg-color, $app-header-primary-sticky-bg-color-dark);\r\n    @include property(--kt-app-header-primary-sticky-box-shadow, $app-header-primary-sticky-box-shadow-dark);\r\n    @include property(--kt-app-header-primary-sticky-border-top, $app-header-primary-sticky-border-top-dark);\r\n    @include property(--kt-app-header-primary-sticky-border-bottom, $app-header-primary-sticky-border-bottom-dark);\r\n\r\n    // Header secondary\r\n    @include property(--kt-app-header-secondary-base-bg-color, $app-header-secondary-base-bg-color-dark);\r\n    @include property(--kt-app-header-secondary-base-bg-color-mobile, $app-header-secondary-base-bg-color-mobile-dark);\r\n    @include property(--kt-app-header-secondary-base-box-shadow, $app-header-secondary-base-box-shadow-dark);\r\n    @include property(--kt-app-header-secondary-base-box-shadow-mobile, $app-header-secondary-base-box-shadow-mobile-dark);\r\n    @include property(--kt-app-header-secondary-base-border-top, $app-header-secondary-base-border-top-dark);\r\n    @include property(--kt-app-header-secondary-base-border-bottom, $app-header-secondary-base-border-bottom-dark);\r\n    @include property(--kt-app-header-secondary-base-border-start-mobile, $app-header-secondary-base-border-bottom-dark);\r\n    @include property(--kt-app-header-secondary-base-border-end-mobile, $app-header-secondary-base-border-end-mobile-dark);\r\n\r\n    @include property(--kt-app-header-secondary-minimize-bg-color, $app-header-secondary-minimize-bg-color-dark);\r\n    @include property(--kt-app-header-secondary-minimize-box-shadow, $app-header-secondary-minimize-box-shadow-dark);\r\n    @include property(--kt-app-header-secondary-minimize-border-top, $app-header-secondary-minimize-border-top-dark);\r\n    @include property(--kt-app-header-secondary-minimize-border-bottom, $app-header-secondary-minimize-border-bottom-dark);\r\n\r\n    @include property(--kt-app-header-secondary-sticky-bg-color, $app-header-secondary-sticky-bg-color-dark);\r\n    @include property(--kt-app-header-secondary-sticky-box-shadow, $app-header-secondary-sticky-box-shadow-dark);\r\n    @include property(--kt-app-header-secondary-sticky-border-top, $app-header-secondary-sticky-border-top-dark);\r\n    @include property(--kt-app-header-secondary-sticky-border-bottom, $app-header-secondary-sticky-border-bottom-dark);\r\n\r\n    // Toolbar base\r\n    @include property(--kt-app-toolbar-base-bg-color, $app-toolbar-base-bg-color-dark);\r\n    @include property(--kt-app-toolbar-base-bg-color-mobile, $app-toolbar-base-bg-color-mobile-dark);\r\n    @include property(--kt-app-toolbar-base-box-shadow, $app-toolbar-base-box-shadow-dark);\r\n    @include property(--kt-app-toolbar-base-box-shadow-mobile, $app-toolbar-base-box-shadow-mobile-dark);\r\n    @include property(--kt-app-toolbar-base-border-top, $app-toolbar-base-border-top-dark);\r\n    @include property(--kt-app-toolbar-base-border-top-mobile, $app-toolbar-base-border-top-mobile-dark);\r\n    @include property(--kt-app-toolbar-base-border-bottom, $app-toolbar-base-border-bottom-dark);\r\n    @include property(--kt-app-toolbar-base-border-bottom-mobile, $app-toolbar-base-border-bottom-dark);\r\n\r\n    // Toolbar minimize\r\n    @include property(--kt-app-toolbar-minimize-bg-color, $app-toolbar-minimize-bg-color-dark);\r\n    @include property(--kt-app-toolbar-minimize-bg-color-mobile, $app-toolbar-minimize-bg-color-mobile-dark);\r\n    @include property(--kt-app-toolbar-minimize-box-shadow, $app-toolbar-minimize-box-shadow-dark);\r\n    @include property(--kt-app-toolbar-minimize-box-shadow-mobile, $app-toolbar-minimize-box-shadow-mobile-dark);\r\n    @include property(--kt-app-toolbar-minimize-border-top, $app-toolbar-minimize-border-top-dark);\r\n    @include property(--kt-app-toolbar-minimize-border-top-mobile, $app-toolbar-minimize-border-top-mobile-dark);\r\n    @include property(--kt-app-toolbar-minimize-border-bottom, $app-toolbar-minimize-border-bottom-dark);\r\n    @include property(--kt-app-toolbar-minimize-border-bottom-mobile, $app-toolbar-minimize-border-bottom-mobile-dark);\r\n\r\n    // Toolbar sticky\r\n    @include property(--kt-app-toolbar-sticky-bg-color, $app-toolbar-sticky-bg-color-dark);\r\n    @include property(--kt-app-toolbar-sticky-bg-color-mobile, $app-toolbar-sticky-bg-color-mobile-dark);\r\n    @include property(--kt-app-toolbar-sticky-box-shadow, $app-toolbar-sticky-box-shadow-dark);\r\n    @include property(--kt-app-toolbar-sticky-box-shadow-mobile, $app-toolbar-sticky-box-shadow-mobile-dark);\r\n    @include property(--kt-app-toolbar-sticky-border-top, $app-toolbar-sticky-border-top-dark);\r\n    @include property(--kt-app-toolbar-sticky-border-top-mobile, $app-toolbar-sticky-border-top-mobile-dark);\r\n    @include property(--kt-app-toolbar-sticky-border-bottom, $app-toolbar-sticky-border-bottom-dark);\r\n    @include property(--kt-app-toolbar-sticky-border-bottom-mobile, $app-toolbar-sticky-border-bottom-mobile-dark);\r\n\r\n    // Hero\r\n    @include property(--kt-app-hero-bg-color, $app-hero-bg-color-dark);\r\n    @include property(--kt-app-hero-box-shadow, $app-hero-box-shadow-dark);\r\n    @include property(--kt-app-hero-border-top, $app-hero-border-top-dark);\r\n    @include property(--kt-app-hero-border-bottom, $app-hero-border-bottom-dark);\r\n\r\n    // Sidebar base\r\n    @include property(--kt-app-sidebar-base-bg-color, $app-sidebar-base-bg-color-dark);\r\n    @include property(--kt-app-sidebar-base-bg-color-mobile, $app-sidebar-base-bg-color-mobile-dark);\r\n    @include property(--kt-app-sidebar-base-box-shadow, $app-sidebar-base-box-shadow-dark);\r\n    @include property(--kt-app-sidebar-base-box-shadow-mobile, $app-sidebar-base-box-shadow-mobile-dark);\r\n    @include property(--kt-app-sidebar-base-border-start, $app-sidebar-base-border-start-dark);\r\n    @include property(--kt-app-sidebar-base-border-start-mobile, $app-sidebar-base-border-start-mobile-dark);\r\n    @include property(--kt-app-sidebar-base-border-end, $app-sidebar-base-border-end-dark);\r\n    @include property(--kt-app-sidebar-base-border-end-mobile, $app-sidebar-base-border-end-mobile-dark);\r\n\r\n    // Sidebar sticky\r\n    @include property(--kt-app-sidebar-sticky-bg-color, $app-sidebar-sticky-bg-color-dark);\r\n    @include property(--kt-app-sidebar-sticky-box-shadow, $app-sidebar-sticky-box-shadow-dark);\r\n    @include property(--kt-app-sidebar-sticky-border-start, $app-sidebar-sticky-border-start-dark);\r\n    @include property(--kt-app-sidebar-sticky-border-end, $app-sidebar-sticky-border-end-dark);\r\n\r\n    // Sidebar minimize\r\n    @include property(--kt-app-sidebar-minimize-bg-color, $app-sidebar-minimize-bg-color-dark);\r\n    @include property(--kt-app-sidebar-minimize-bg-color-mobile, $app-sidebar-minimize-bg-color-mobile-dark);\r\n    @include property(--kt-app-sidebar-minimize-box-shadow, $app-sidebar-minimize-box-shadow-dark);\r\n    @include property(--kt-app-sidebar-minimize-box-shadow-mobile, $app-sidebar-minimize-box-shadow-mobile-dark);\r\n    @include property(--kt-app-sidebar-minimize-hover-box-shadow, $app-sidebar-minimize-hover-box-shadow-dark);\r\n    @include property(--kt-app-sidebar-minimize-hover-box-shadow-mobile, $app-sidebar-minimize-hover-box-shadow-mobile-dark);\r\n    @include property(--kt-app-sidebar-minimize-border-start, $app-sidebar-minimize-border-start-dark);\r\n    @include property(--kt-app-sidebar-minimize-border-start-mobile, $app-sidebar-minimize-border-start-mobile-dark);\r\n    @include property(--kt-app-sidebar-minimize-border-end, $app-sidebar-minimize-border-end-dark);\r\n    @include property(--kt-app-sidebar-minimize-border-end-mobile, $app-sidebar-minimize-border-end-mobile-dark);\r\n\r\n    // Sidebar primary\r\n    @include property(--kt-app-sidebar-primary-base-bg-color, $app-sidebar-primary-base-bg-color-dark);\r\n    @include property(--kt-app-sidebar-primary-base-bg-color-mobile, $app-sidebar-primary-base-bg-color-mobile-dark);\r\n    @include property(--kt-app-sidebar-primary-base-box-shadow, $app-sidebar-primary-base-box-shadow-dark);\r\n    @include property(--kt-app-sidebar-primary-base-box-shadow-mobile, $app-sidebar-primary-base-box-shadow-mobile-dark);\r\n    @include property(--kt-app-sidebar-primary-base-border-start, $app-sidebar-primary-base-border-start-dark);\r\n    @include property(--kt-app-sidebar-primary-base-border-start-mobile, $app-sidebar-primary-base-border-start-mobile-dark);\r\n    @include property(--kt-app-sidebar-primary-base-border-end, $app-sidebar-primary-base-border-end-dark);\r\n    @include property(--kt-app-sidebar-primary-base-border-end-mobile, $app-sidebar-primary-base-border-end-mobile-dark);\r\n\r\n    @include property(--kt-app-sidebar-primary-minimize-bg-color, $app-sidebar-primary-base-border-end-mobile-dark);\r\n    @include property(--kt-app-sidebar-primary-minimize-bg-color-mobile, $app-sidebar-primary-minimize-bg-color-mobile-dark);\r\n    @include property(--kt-app-sidebar-primary-minimize-box-shadow, $app-sidebar-primary-minimize-box-shadow-dark);\r\n    @include property(--kt-app-sidebar-primary-minimize-box-shadow-mobile, $app-sidebar-primary-minimize-box-shadow-mobile-dark);\r\n    @include property(--kt-app-sidebar-primary-minimize-hover-box-shadow, $app-sidebar-primary-minimize-hover-box-shadow-dark);\r\n    @include property(--kt-app-sidebar-primary-minimize-hover-box-shadow-mobile, $app-sidebar-primary-minimize-hover-box-shadow-mobile-dark);\r\n    @include property(--kt-app-sidebar-primary-minimize-border-start, $app-sidebar-primary-minimize-border-start-dark);\r\n    @include property(--kt-app-sidebar-primary-minimize-border-start-mobile, $app-sidebar-primary-minimize-border-start-mobile-dark);\r\n    @include property(--kt-app-sidebar-primary-minimize-border-end, $app-sidebar-primary-minimize-border-end-dark);\r\n    @include property(--kt-app-sidebar-primary-minimize-border-end-mobile, $app-sidebar-primary-minimize-border-end-mobile-dark);\r\n\r\n    // Sidebar secondary\r\n    @include property(--kt-app-sidebar-secondary-base-bg-color, $app-sidebar-secondary-base-bg-color-dark);\r\n    @include property(--kt-app-sidebar-secondary-base-bg-color-mobile, $app-sidebar-secondary-base-bg-color-mobile-dark);\r\n    @include property(--kt-app-sidebar-secondary-base-box-shadow, $app-sidebar-secondary-base-box-shadow-dark);\r\n    @include property(--kt-app-sidebar-secondary-base-box-shadow-mobile, $app-sidebar-secondary-base-box-shadow-mobile-dark);\r\n    @include property(--kt-app-sidebar-secondary-base-border-start, $app-sidebar-secondary-base-border-start-dark);\r\n    @include property(--kt-app-sidebar-secondary-base-border-start-mobile, $app-sidebar-secondary-base-border-start-mobile-dark);\r\n    @include property(--kt-app-sidebar-secondary-base-border-end, $app-sidebar-secondary-base-border-end-dark);\r\n    @include property(--kt-app-sidebar-secondary-base-border-end-mobile, $app-sidebar-secondary-base-border-end-mobile-dark);\r\n\r\n    @include property(--kt-app-sidebar-secondary-minimize-bg-color, $app-sidebar-secondary-minimize-bg-color-dark);\r\n    @include property(--kt-app-sidebar-secondary-minimize-bg-color-mobile, $app-sidebar-secondary-minimize-bg-color-mobile-dark);\r\n    @include property(--kt-app-sidebar-secondary-minimize-box-shadow, $app-sidebar-secondary-minimize-box-shadow-dark);\r\n    @include property(--kt-app-sidebar-secondary-minimize-box-shadow-mobile, $app-sidebar-secondary-minimize-box-shadow-mobile-dark);\r\n    @include property(--kt-app-sidebar-secondary-minimize-hover-box-shadow, $app-sidebar-secondary-minimize-hover-box-shadow-dark);\r\n    @include property(--kt-app-sidebar-secondary-minimize-hover-box-shadow-mobile, $app-sidebar-secondary-minimize-hover-box-shadow-mobile-dark);\r\n    @include property(--kt-app-sidebar-secondary-minimize-border-start, $app-sidebar-secondary-minimize-border-start-dark);\r\n    @include property(--kt-app-sidebar-secondary-minimize-border-start-mobile, $app-sidebar-secondary-minimize-border-start-mobile-dark);\r\n    @include property(--kt-app-sidebar-secondary-minimize-border-end, $app-sidebar-secondary-minimize-border-end-dark);\r\n    @include property(--kt-app-sidebar-secondary-minimize-border-end-mobile, $app-sidebar-secondary-minimize-border-end-mobile-dark);\r\n\r\n    // Sidebar panel base\r\n    @include property(--kt-app-sidebar-panel-base-bg-color, $app-sidebar-panel-base-bg-color-dark);\r\n    @include property(--kt-app-sidebar-panel-base-bg-color-mobile, $app-sidebar-panel-base-bg-color-mobile-dark);\r\n    @include property(--kt-app-sidebar-panel-base-box-shadow, $app-sidebar-panel-base-box-shadow-dark);\r\n    @include property(--kt-app-sidebar-panel-base-box-shadow-mobile, $app-sidebar-panel-base-box-shadow-mobile-dark);\r\n    @include property(--kt-app-sidebar-panel-base-border-start, $app-sidebar-panel-base-border-start-dark);\r\n    @include property(--kt-app-sidebar-panel-base-border-start-mobile, $app-sidebar-panel-base-border-start-mobile-dark);\r\n    @include property(--kt-app-sidebar-panel-base-border-end, $app-sidebar-panel-base-border-end-dark);\r\n    @include property(--kt-app-sidebar-panel-base-border-end-mobile, $app-sidebar-panel-base-border-end-mobile-dark);\r\n\r\n    // Sidebar panel sticky\r\n    @include property(--kt-app-sidebar-panel-sticky-bg-color, $app-sidebar-panel-sticky-bg-color-dark);\r\n    @include property(--kt-app-sidebar-panel-sticky-box-shadow, $app-sidebar-panel-sticky-box-shadow-dark);\r\n    @include property(--kt-app-sidebar-panel-sticky-border-start, $app-sidebar-panel-sticky-border-start-dark);\r\n    @include property(--kt-app-sidebar-panel-sticky-border-end, $app-sidebar-panel-sticky-border-end-dark);\r\n\r\n    // Sidebar panel minimize\r\n    @include property(--kt-app-sidebar-panel-minimize-bg-color, $app-sidebar-panel-minimize-bg-color-dark);\r\n    @include property(--kt-app-sidebar-panel-minimize-bg-color-mobile, $app-sidebar-panel-minimize-bg-color-mobile-dark);\r\n    @include property(--kt-app-sidebar-panel-minimize-box-shadow, $app-sidebar-panel-minimize-box-shadow-dark);\r\n    @include property(--kt-app-sidebar-panel-minimize-box-shadow-mobile, $app-sidebar-panel-minimize-box-shadow-mobile-dark);\r\n    @include property(--kt-app-sidebar-panel-minimize-hover-box-shadow, $app-sidebar-panel-minimize-hover-box-shadow-dark);\r\n    @include property(--kt-app-sidebar-panel-minimize-hover-box-shadow-mobile, $app-sidebar-panel-minimize-hover-box-shadow-mobile-dark);\r\n    @include property(--kt-app-sidebar-panel-minimize-border-start, $app-sidebar-panel-minimize-border-start-dark);\r\n    @include property(--kt-app-sidebar-panel-minimize-border-start-mobile, $app-sidebar-panel-minimize-border-start-mobile-dark);\r\n    @include property(--kt-app-sidebar-panel-minimize-border-end, $app-sidebar-panel-minimize-border-end-dark);\r\n    @include property(--kt-app-sidebar-panel-minimize-border-end-mobile, $app-sidebar-panel-minimize-border-end-mobile-dark);\r\n\r\n    // Aside base\r\n    @include property(--kt-app-aside-base-bg-color, $app-aside-base-bg-color-dark);\r\n    @include property(--kt-app-aside-base-bg-color-mobile, $app-aside-base-bg-color-mobile-dark);\r\n    @include property(--kt-app-aside-base-box-shadow, $app-aside-base-box-shadow-dark);\r\n    @include property(--kt-app-aside-base-box-shadow-mobile, $app-aside-base-box-shadow-mobile-dark);\r\n    @include property(--kt-app-aside-base-border-start, $app-aside-base-border-start-dark);\r\n    @include property(--kt-app-aside-base-border-start-mobile, $app-aside-base-border-start-mobile-dark);\r\n    @include property(--kt-app-aside-base-border-end, $app-aside-base-border-end-dark);\r\n    @include property(--kt-app-aside-base-border-end-mobile, $app-aside-base-border-end-mobile-dark);\r\n\r\n    // Aside sticky\r\n    @include property(--kt-app-aside-sticky-bg-color, $app-aside-sticky-bg-color-dark);\r\n    @include property(--kt-app-aside-sticky-box-shadow, $app-aside-sticky-box-shadow-dark);\r\n    @include property(--kt-app-aside-sticky-border-start, $app-aside-sticky-border-start-dark);\r\n    @include property(--kt-app-aside-sticky-border-end, $app-aside-sticky-border-end-dark);\r\n\r\n    // Aside minimize\r\n    @include property(--kt-app-aside-minimize-bg-color, $app-aside-minimize-bg-color-dark);\r\n    @include property(--kt-app-aside-minimize-bg-color-mobile, $app-aside-minimize-bg-color-mobile-dark);\r\n    @include property(--kt-app-aside-minimize-box-shadow, $app-aside-minimize-box-shadow-dark);\r\n    @include property(--kt-app-aside-minimize-box-shadow-mobile, $app-aside-minimize-box-shadow-mobile-dark);\r\n    @include property(--kt-app-aside-minimize-hover-box-shadow, $app-aside-minimize-hover-box-shadow-dark);\r\n    @include property(--kt-app-aside-minimize-hover-box-shadow-mobile, $app-aside-minimize-hover-box-shadow-mobile-dark);\r\n    @include property(--kt-app-aside-minimize-border-start, $app-aside-minimize-border-start-dark);\r\n    @include property(--kt-app-aside-minimize-border-start-mobile, $app-aside-minimize-border-start-mobile-dark);\r\n    @include property(--kt-app-aside-minimize-border-end, $app-aside-minimize-border-end-dark);\r\n    @include property(--kt-app-aside-minimize-border-end-mobile, $app-aside-minimize-border-end-mobile-dark);\r\n\r\n    // Page\r\n    @include property(--kt-app-page-bg-color, $app-page-bg-color-dark);\r\n\r\n    // Wrapper\r\n    @include property(--kt-app-wrapper-bg-color, $app-wrapper-bg-color-dark);\r\n\r\n    // Footer\r\n    @include property(--kt-app-footer-bg-color, $app-footer-bg-color-dark);\r\n    @include property(--kt-app-footer-bg-color-mobile, $app-footer-bg-color-mobile-dark);\r\n    @include property(--kt-app-footer-box-shadow, $app-footer-box-shadow-dark);\r\n    @include property(--kt-app-footer-box-shadow-mobile, $app-footer-box-shadow-mobile-dark);\r\n    @include property(--kt-app-footer-border-top, $app-footer-border-top-dark);\r\n    @include property(--kt-app-footer-border-top-mobile, $app-footer-border-top-mobile-dark);\r\n}","//\r\n// CSS Property\r\n//\r\n\r\n@mixin property($attr, $value, $important: '') {\r\n    @if  $value != null and $value != false  {\r\n        #{$attr}: #{$value} #{$important};\r\n    }\r\n}","//\r\n// Reboot\r\n//\r\n\r\nhtml {\r\n  font-family: sans-serif;\r\n  text-size-adjust: 100%;\r\n}\r\n\r\nhtml,\r\nbody {\r\n    height: 100%;\r\n    margin: 0px;\r\n    padding: 0px;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    font-size: $app-general-root-font-size-desktop !important;\r\n    font-weight: $font-weight-base;\r\n    font-family: $font-family-sans-serif;\r\n\r\n    // Tablet mode\r\n    @include media-breakpoint-down(lg) {\r\n        font-size: $app-general-root-font-size-tablet !important;\r\n    }\r\n\r\n    // Mobile mode\r\n    @include media-breakpoint-down(md) {\r\n        font-size: $app-general-root-font-size-mobile !important;\r\n    }    \r\n}\r\n\r\nbody {\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    a:hover,\r\n    a:active,\r\n    a:focus {\r\n        text-decoration: none !important;\r\n    }\r\n}\r\n\r\ncanvas {\r\n    user-select: none;\r\n}\r\n\r\n// Angular integration\r\nrouter-outlet {\r\n    display: none;\r\n}\r\n\r\n// Layouts\r\nbody,\r\n.app-default {\r\n    background-color: var(--kt-app-bg-color);    \r\n}\r\n\r\n.app-blank {\r\n    background-color: var(--kt-app-blank-bg-color);    \r\n}\r\n\r\n// Reset CSS3 Transitions for child elements\r\n[data-kt-app-reset-transition=\"true\"] * {\r\n    transition: none !important;\r\n}","//\r\n// Page\r\n//\r\n\r\n.app-page {\r\n    display: flex;\r\n}","//\r\n// Page loader\r\n//\r\n\r\n// CSS3 Transitions only after page load(data-kt-app-page-loading=\"on\" attribute added to body tag and removed with JS on page loaded)\r\n[data-kt-app-page-loading=\"on\"] {\r\n\toverflow: hidden;\r\n}\r\n\r\n[data-kt-app-page-loading=\"on\"] * {\r\n    transition: none !important;\r\n}\r\n\r\n// Base\r\n.app-page-loader {\r\n\tbackground: var(--kt-body-bg);\r\n\tcolor: var(--kt-body-color);\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tleft: 0;\r\n\tright: 0;\r\n\tz-index: 10000;\r\n   \tdisplay: none;\r\n\r\n   \t[data-kt-app-page-loading=\"on\"] & {\r\n\t\tdisplay: flex;\r\n\t\tjustify-content: center;\r\n   \t\talign-items: center;\r\n\t}\r\n}\r\n","//\r\n// Container\r\n//\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n\t.app-container {\r\n\t\tpadding-left: $app-container-padding-x !important;\r\n        padding-right: $app-container-padding-x !important;\r\n\t}\r\n\r\n\t.app-container-fit-desktop {\r\n\t\tpadding-left: 0 !important;\r\n\t\tpadding-right: 0 !important;\r\n\t}\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n\t.app-container { \r\n\t\tmax-width: none;\r\n\t\tpadding-left: $app-container-padding-x-mobile !important;\r\n        padding-right: $app-container-padding-x-mobile !important;\r\n\t}\r\n\r\n\t.app-container-fit-mobile {\r\n\t\tpadding-left: 0 !important;\r\n\t\tpadding-right: 0 !important;\r\n\t}\r\n}\r\n","//\r\n// Print\r\n//\r\n\r\n// Add .app-print-content-only class to body element in order to allow printing only the content area\r\n@media print {\r\n    .app-print-content-only {\r\n        padding: 0 !important;\r\n        background: none !important;\r\n\r\n        .app-wrapper,\r\n        .app-page,\r\n        .app-page-title,\r\n        .app-content,\r\n        .app-container {\r\n            background: none !important;\r\n            padding: 0 !important;\r\n            margin: 0 !important;\r\n        }\r\n\r\n        .app-aside,\r\n        .app-aside-panel,\r\n        .app-sidebar,\r\n        .app-sidebar-panel,\r\n        .app-header,\r\n        .app-footer,\r\n        .app-toolbar,\r\n        .drawer,\r\n        .scrolltop,\r\n        .btn {\r\n            display: none !important;\r\n        }\r\n    }\r\n}\r\n","//\r\n// App Navbar\r\n//\r\n\r\n.app-navbar {\r\n    display: flex;\r\n    align-items: stretch;\r\n\r\n    .app-navbar-item {\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n\r\n    &.app-navbar-stretch {\r\n        .app-navbar-item {\r\n            align-items: stretch;\r\n        }\r\n    }\r\n}","//\r\n// sidebar\r\n//\r\n\r\n// General mode\r\n.app-header {\r\n    transition: $app-header-base-transition;   \r\n    display: flex;\r\n    align-items: stretch;\r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    // Base\r\n    .app-header {\r\n        @include property( z-index, $app-header-base-z-index);\r\n\r\n        background-color: var(--kt-app-header-base-bg-color);\r\n        box-shadow: var(--kt-app-header-base-box-shadow);\r\n        border-bottom: var(--kt-app-header-base-border-bottom);\r\n    }    \r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-header-height: #{$app-header-base-height};\r\n        --kt-app-header-height-actual: #{$app-header-base-height};\r\n    }\r\n\r\n    [data-kt-app-header-sticky=\"on\"] {\r\n        --kt-app-header-height: #{$app-header-sticky-height};\r\n        --kt-app-header-height-actual: #{$app-header-base-height};\r\n    }\r\n\r\n    [data-kt-app-header-sticky=\"on\"][data-kt-app-header-stacked=\"true\"] {\r\n        --kt-app-header-height: calc(var(--kt-app-header-primary-height, 0px) + var(--kt-app-header-secondary-height, 0px));\r\n        --kt-app-header-height-actual: calc(#{$app-header-primary-base-height} + #{$app-header-secondary-base-height});\r\n    }\r\n\r\n    [data-kt-app-header-minimize=\"on\"] {\r\n        --kt-app-header-height: #{$app-header-minimize-height};\r\n    } \r\n\r\n    // States\r\n    .app-header {\r\n        height: var(--kt-app-header-height);\r\n\r\n        [data-kt-app-header-fixed=\"true\"] & {\r\n            @include property( z-index, $app-header-fixed-z-index);\r\n            position: fixed;\r\n            left: 0;\r\n            right: 0;\r\n            top: 0;            \r\n        }\r\n\r\n        [data-kt-app-header-static=\"true\"] & {\r\n            position: relative;\r\n        }\r\n\r\n        [data-kt-app-header-stacked=\"true\"] & {\r\n            flex-direction: column;\r\n            height: calc(var(--kt-app-header-primary-height) + var(--kt-app-header-secondary-height, 0px));\r\n        }\r\n\r\n        [data-kt-app-header-sticky=\"on\"] & {\r\n            position: fixed;\r\n            left: 0;\r\n            right: 0;\r\n            top: 0;\r\n            @include property( z-index, $app-header-sticky-z-index);\r\n            @include property( backdrop-filter, $app-header-sticky-backdrop-filter);\r\n\r\n            background-color: var(--kt-app-header-sticky-bg-color);\r\n            box-shadow: var(--kt-app-header-sticky-box-shadow);\r\n            border-bottom: var(--kt-app-header-sticky-border-bottom);\r\n        }\r\n\r\n        [data-kt-app-header-minimize=\"on\"] & {\r\n            transition: $app-header-base-transition; \r\n            @include property( z-index, $app-header-minimize-z-index);\r\n            @include property( backdrop-filter, $app-header-minimize-backdrop-filter);\r\n\r\n            background-color: var(--kt-app-header-minimize-bg-color);\r\n            box-shadow: var(--kt-app-header-minimize-box-shadow);\r\n            border-bottom: var(--kt-app-header-minimize-border-bottom);\r\n        }\r\n\r\n        .app-header-mobile-drawer {\r\n            display: flex;    \r\n        }\r\n    }\r\n\r\n    // Integration\r\n    .app-header {\r\n        // Sidebar\r\n        [data-kt-app-header-fixed=\"true\"][data-kt-app-sidebar-fixed=\"true\"][data-kt-app-sidebar-push-header=\"true\"] &,\r\n        [data-kt-app-header-fixed=\"true\"][data-kt-app-sidebar-sticky=\"on\"][data-kt-app-sidebar-push-header=\"true\"] & {\r\n            left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px)\r\n            );\r\n        }\r\n\r\n        body:not([data-kt-app-header-fixed=\"true\"])[data-kt-app-sidebar-fixed=\"true\"][data-kt-app-sidebar-push-header=\"true\"] &,\r\n        body:not([data-kt-app-header-fixed=\"true\"])[data-kt-app-sidebar-sticky=\"on\"][data-kt-app-sidebar-push-header=\"true\"] & {\r\n            margin-left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px)\r\n            );\r\n        }\r\n\r\n        // Sidebar Panel\r\n        [data-kt-app-header-fixed=\"true\"][data-kt-app-sidebar-panel-fixed=\"true\"][data-kt-app-sidebar-panel-push-header=\"true\"] &,\r\n        [data-kt-app-header-fixed=\"true\"][data-kt-app-sidebar-panel-sticky=\"on\"][data-kt-app-sidebar-panel-push-header=\"true\"] & {\r\n            left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px) +\r\n                var(--kt-app-sidebar-panel-width) + \r\n                var(--kt-app-sidebar-panel-gap-start, 0px) + \r\n                var(--kt-app-sidebar-panel-gap-end, 0px)\r\n            );\r\n        }\r\n\r\n        body:not([data-kt-app-header-fixed=\"true\"])[data-kt-app-sidebar-panel-fixed=\"true\"][data-kt-app-sidebar-panel-push-header=\"true\"] &,\r\n        body:not([data-kt-app-header-fixed=\"true\"])[data-kt-app-sidebar-panel-sticky=\"on\"][data-kt-app-sidebar-panel-push-header=\"true\"] & {\r\n            margin-left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px) +\r\n                var(--kt-app-sidebar-panel-width) + \r\n                var(--kt-app-sidebar-panel-gap-start, 0px) + \r\n                var(--kt-app-sidebar-panel-gap-end, 0px)\r\n            );\r\n        }        \r\n\r\n        // Toolbar\r\n        [data-kt-app-header-fixed=\"true\"][data-kt-app-toolbar-fixed=\"true\"] & {\r\n            box-shadow: none;    \r\n        }\r\n    } \r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    // Base\r\n    .app-header {\r\n        @include property( z-index, $app-header-base-z-index-mobile);\r\n\r\n        background-color: var(--kt-app-header-base-bg-color-mobile);\r\n        box-shadow: var(--kt-app-header-base-box-shadow-mobile);\r\n        border-bottom: var(--kt-app-header-base-border-bottom-mobile);\r\n    }\r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-header-height: #{$app-header-base-height-mobile};\r\n    }\r\n\r\n    [data-kt-app-header-sticky=\"on\"] {\r\n        --kt-app-header-height: #{$app-header-sticky-height-mobile};\r\n        --kt-app-header-height-actual: #{$app-header-sticky-height-mobile};\r\n    }\r\n\r\n    [data-kt-app-header-minimize=\"on\"] {\r\n        --kt-app-header-height: #{$app-header-minimize-height-mobile};\r\n        --kt-app-header-height-actual: #{$app-header-minimize-height-mobile};\r\n    }\r\n\r\n    // States\r\n    .app-header {\r\n        height: var(--kt-app-header-height);\r\n        align-items: stretch;\r\n        \r\n        .app-header-mobile-drawer {\r\n            display: none;    \r\n        }\r\n\r\n        [data-kt-app-header-stacked=\"true\"] & {\r\n            flex-direction: column;\r\n        }\r\n\r\n        [data-kt-app-header-fixed-mobile=\"true\"] & {\r\n            @include property( z-index, $app-header-fixed-z-index-mobile);\r\n            transition: $app-header-base-transition;   \r\n            position: fixed;\r\n            left: 0;\r\n            right: 0;\r\n            top: 0;        \r\n        }\r\n\r\n        [data-kt-app-header-sticky=\"on\"] & {\r\n            position: fixed;\r\n            left: 0;\r\n            right: 0;\r\n            top: 0;\r\n            @include property( z-index, $app-header-sticky-z-index-mobile);\r\n            @include property( backdrop-filter, $app-header-sticky-backdrop-filter-mobile);\r\n\r\n            background-color: var(--kt-app-header-sticky-bg-color-mobile);\r\n            box-shadow: var(--kt-app-header-sticky-box-shadow-mobile);\r\n            border-bottom: var(--kt-app-header-sticky-border-bottom-mobile);\r\n        }\r\n\r\n        [data-kt-app-header-minimize=\"on\"] & {            \r\n            @include property( z-index, $app-header-minimize-z-index-mobile);\r\n            @include property( backdrop-filter, $app-header-minimize-backdrop-filter-mobile);\r\n\r\n            transition: $app-header-base-transition; \r\n            background-color: var(--kt-app-header-minimize-bg-color-mobile);\r\n            box-shadow: var(--kt-app-header-minimize-box-shadow-mobile);\r\n            border-bottom: var(--kt-app-header-minimize-border-bottom-mobile);\r\n        }\r\n    }\r\n\r\n    // Integration\r\n    .app-header {\r\n        // Toolbar\r\n        [data-kt-app-header-fixed-mobile=\"true\"][data-kt-app-toolbar-fixed-mobile=\"true\"] & {\r\n            box-shadow: none;    \r\n        }\r\n\r\n        [data-kt-app-header-fixed-mobile=\"true\"][data-kt-app-toolbar-sticky=\"on\"] & {\r\n            box-shadow: none;    \r\n        }\r\n    }    \r\n}","//\r\n// Variables\r\n//\r\n\r\n// Reboot\r\n$app-bg-color: #f5f8fa  !default;\r\n$app-bg-color-dark: #151521 !default;\r\n$app-blank-bg-color: $white;\r\n$app-blank-bg-color-dark: $app-bg-color-dark;\r\n\r\n// General\r\n$app-general-transition-duration: .3s !default;\r\n$app-general-transition-timing: ease !default;\r\n$app-general-root-font-size-desktop: 13px !default;\r\n$app-general-root-font-size-tablet: 12px !default;\r\n$app-general-root-font-size-mobile: 12px !default;\r\n\r\n// Container\r\n$app-container-padding-x: 30px !default;\r\n$app-container-padding-x-mobile: 20px !default;\r\n\r\n// Page\r\n$app-page-bg-color: null !default;\r\n$app-page-bg-color-dark: null !default;\r\n\r\n// Main\r\n$app-main-transition: margin $app-general-transition-duration $app-general-transition-timing;\r\n$app-main-padding-y: null !default;\r\n$app-main-padding-y-mobile: null !default;\r\n$app-main-padding-x: null !default;\r\n$app-main-padding-x-mobile: 0 !default;\r\n$app-main-margin-y: null !default;\r\n$app-main-margin-y-mobile: null !default;\r\n$app-main-margin-x: null !default;\r\n$app-main-margin-x-mobile: null !default;\r\n\r\n// Wrapper\r\n$app-wrapper-transition: margin-left $app-general-transition-duration $app-general-transition-timing, margin-right $app-general-transition-duration $app-general-transition-timing;\r\n$app-wrapper-bg-color: null !default;\r\n$app-wrapper-bg-color-dark: null !default;\r\n\r\n// Content\r\n$app-content-padding-y: 30px !default;\r\n$app-content-padding-y-mobile: 20px !default;\r\n$app-content-padding-x: 0 !default;\r\n$app-content-padding-x-mobile: 0 !default;\r\n\r\n// Header base\r\n$app-header-base-transition: none !default;\r\n$app-header-base-height: 70px !default;\r\n$app-header-base-height-mobile: 70px !default;\r\n$app-header-base-z-index: null !default;\r\n$app-header-base-z-index-mobile: null !default;\r\n$app-header-base-bg-color: null !default;\r\n$app-header-base-bg-color-dark: null !default;\r\n$app-header-base-bg-color-mobile: null !default;\r\n$app-header-base-bg-color-mobile-dark: null !default;\r\n$app-header-base-box-shadow: null !default;\r\n$app-header-base-box-shadow-dark: null !default;\r\n$app-header-base-box-shadow-mobile: null !default;\r\n$app-header-base-box-shadow-mobile-dark: null !default;\r\n$app-header-base-border-bottom: null !default;\r\n$app-header-base-border-bottom-dark: null !default;\r\n$app-header-base-border-bottom-mobile: null !default;\r\n$app-header-base-border-bottom-mobile-dark: null !default;\r\n\r\n// Header fixed\r\n$app-header-fixed-z-index: 100 !default;\r\n$app-header-fixed-z-index-mobile: 100 !default;\r\n\r\n// Header minimize\r\n$app-header-minimize-height: 70px !default;\r\n$app-header-minimize-height-mobile: 70px !default;\r\n$app-header-minimize-z-index: 100 !default;\r\n$app-header-minimize-z-index-mobile: 100 !default;\r\n$app-header-minimize-backdrop-filter: null !default;\r\n$app-header-minimize-backdrop-filter-mobile: null !default;\r\n$app-header-minimize-bg-color: null !default;\r\n$app-header-minimize-bg-color-dark: null !default;\r\n$app-header-minimize-bg-color-mobile: null !default;\r\n$app-header-minimize-bg-color-mobile-dark: null !default;\r\n$app-header-minimize-box-shadow: null !default;\r\n$app-header-minimize-box-shadow-dark: null !default;\r\n$app-header-minimize-box-shadow-mobile: null !default;\r\n$app-header-minimize-box-shadow-mobile-dark: null !default;\r\n$app-header-minimize-border-bottom: null !default;\r\n$app-header-minimize-border-bottom-dark: null !default;\r\n$app-header-minimize-border-bottom-mobile: null !default;\r\n$app-header-minimize-border-bottom-mobile-dark: null !default;\r\n\r\n// Header sticky\r\n$app-header-sticky-height: 70px !default;\r\n$app-header-sticky-height-mobile: 70px !default;\r\n$app-header-sticky-z-index: 100 !default;\r\n$app-header-sticky-z-index-mobile: 100 !default;\r\n$app-header-sticky-backdrop-filter: null !default;\r\n$app-header-sticky-backdrop-filter-mobile: null !default;\r\n$app-header-sticky-bg-color: null !default;\r\n$app-header-sticky-bg-color-dark: null !default;\r\n$app-header-sticky-bg-color-mobile: null !default;\r\n$app-header-sticky-bg-color-mobile-dark: null !default;\r\n$app-header-sticky-box-shadow: null !default;\r\n$app-header-sticky-box-shadow-dark: null !default;\r\n$app-header-sticky-box-shadow-mobile: null !default;\r\n$app-header-sticky-box-shadow-mobile-dark: null !default;\r\n$app-header-sticky-border-bottom: null !default;\r\n$app-header-sticky-border-bottom-dark: null !default;\r\n$app-header-sticky-border-bottom-mobile: null !default;\r\n$app-header-sticky-border-bottom-mobile-dark: null !default;\r\n\r\n// Header primary\r\n$app-header-primary-base-transition: none !default;\r\n$app-header-primary-base-height: 70px !default;\r\n$app-header-primary-base-z-index: null !default;\r\n$app-header-primary-base-z-index-mobile: null !default;\r\n$app-header-primary-base-bg-color: null !default;\r\n$app-header-primary-base-bg-color-dark: null !default;\r\n$app-header-primary-base-bg-color-mobile: null !default;\r\n$app-header-primary-base-bg-color-mobile-dark: null !default;\r\n$app-header-primary-base-box-shadow: null !default;\r\n$app-header-primary-base-box-shadow-dark: null !default;\r\n$app-header-primary-base-box-shadow-mobile: null !default;\r\n$app-header-primary-base-box-shadow-mobile-dark: null !default;\r\n$app-header-primary-base-border-bottom: null !default;\r\n$app-header-primary-base-border-bottom-dark: null !default;\r\n$app-header-primary-base-border-bottom-mobile: null !default;\r\n$app-header-primary-base-border-bottom-mobile-dark: null !default;\r\n\r\n$app-header-primary-fixed-z-index: 100 !default;\r\n\r\n$app-header-primary-minimize-height: 70px !default;\r\n$app-header-primary-minimize-z-index: 100 !default;\r\n$app-header-primary-minimize-bg-color: null !default;\r\n$app-header-primary-minimize-bg-color-dark: null !default;\r\n$app-header-primary-minimize-box-shadow: null !default;\r\n$app-header-primary-minimize-box-shadow-dark: null !default;\r\n$app-header-primary-minimize-border-top: null !default;\r\n$app-header-primary-minimize-border-top-dark: null !default;\r\n$app-header-primary-minimize-border-bottom: null !default;\r\n$app-header-primary-minimize-border-bottom-dark: null !default;\r\n\r\n$app-header-primary-sticky-height: 70px !default;\r\n$app-header-primary-sticky-z-index: 100 !default;\r\n$app-header-primary-sticky-bg-color: null !default;\r\n$app-header-primary-sticky-bg-color-dark: null !default;\r\n$app-header-primary-sticky-box-shadow: null !default;\r\n$app-header-primary-sticky-box-shadow-dark: null !default;\r\n$app-header-primary-sticky-border-top: null !default;\r\n$app-header-primary-sticky-border-top-dark: null !default;\r\n$app-header-primary-sticky-border-bottom: null !default;\r\n$app-header-primary-sticky-border-bottom-dark: null !default;\r\n\r\n// Header secondary\r\n$app-header-secondary-base-transition: none !default;\r\n$app-header-secondary-base-height: 70px !default;\r\n$app-header-secondary-base-z-index: null !default;\r\n$app-header-secondary-base-bg-color: null !default;\r\n$app-header-secondary-base-bg-color-dark: null !default;\r\n$app-header-secondary-base-bg-color-mobile: null !default;\r\n$app-header-secondary-base-bg-color-mobile-dark: null !default;\r\n$app-header-secondary-base-box-shadow: null !default;\r\n$app-header-secondary-base-box-shadow-dark: null !default;\r\n$app-header-secondary-base-box-shadow-mobile: null !default;\r\n$app-header-secondary-base-box-shadow-mobile-dark: null !default;\r\n$app-header-secondary-base-border-top: null !default;\r\n$app-header-secondary-base-border-top-dark: null !default;\r\n$app-header-secondary-base-border-bottom: null !default;\r\n$app-header-secondary-base-border-bottom-dark: null !default;\r\n$app-header-secondary-base-border-start-mobile: null !default;\r\n$app-header-secondary-base-border-start-mobile-dark: null !default;\r\n$app-header-secondary-base-border-end-mobile: null !default;\r\n$app-header-secondary-base-border-end-mobile-dark: null !default;\r\n\r\n$app-header-secondary-fixed-z-index: 100 !default;\r\n\r\n$app-header-secondary-minimize-height: 70px !default;\r\n$app-header-secondary-minimize-z-index: 100 !default;\r\n$app-header-secondary-minimize-bg-color: null !default;\r\n$app-header-secondary-minimize-bg-color-dark: null !default;\r\n$app-header-secondary-minimize-box-shadow: null !default;\r\n$app-header-secondary-minimize-box-shadow-dark: null !default;\r\n$app-header-secondary-minimize-border-top: null !default;\r\n$app-header-secondary-minimize-border-top-dark: null !default;\r\n$app-header-secondary-minimize-border-bottom: null !default;\r\n$app-header-secondary-minimize-border-bottom-dark: null !default;\r\n\r\n$app-header-secondary-sticky-height: 70px !default;\r\n$app-header-secondary-sticky-z-index: 100 !default;\r\n$app-header-secondary-sticky-bg-color: null !default;\r\n$app-header-secondary-sticky-bg-color-dark: null !default;\r\n$app-header-secondary-sticky-box-shadow: null !default;\r\n$app-header-secondary-sticky-box-shadow-dark: null !default;\r\n$app-header-secondary-sticky-border-top: null !default;\r\n$app-header-secondary-sticky-border-top-dark: null !default;\r\n$app-header-secondary-sticky-border-bottom: null !default;\r\n$app-header-secondary-sticky-border-bottom-dark: null !default;\r\n\r\n// Toolbar base\r\n$app-toolbar-base-transition: none !default;\r\n$app-toolbar-base-height: null !default;\r\n$app-toolbar-base-height-mobile: null !default;\r\n$app-toolbar-base-z-index: 99 !default;\r\n$app-toolbar-base-z-index-mobile: 99 !default;\r\n$app-toolbar-base-bg-color: null !default;\r\n$app-toolbar-base-bg-color-dark: null !default;\r\n$app-toolbar-base-bg-color-mobile: null !default;\r\n$app-toolbar-base-bg-color-mobile-dark: null !default;\r\n$app-toolbar-base-box-shadow: null !default;\r\n$app-toolbar-base-box-shadow-dark: null !default;\r\n$app-toolbar-base-box-shadow-mobile: null !default;\r\n$app-toolbar-base-box-shadow-mobile-dark: null !default;\r\n$app-toolbar-base-border-top: null !default;\r\n$app-toolbar-base-border-top-dark: null !default;\r\n$app-toolbar-base-border-top-mobile: null !default;\r\n$app-toolbar-base-border-top-mobile-dark: null !default;\r\n$app-toolbar-base-border-bottom: null !default;\r\n$app-toolbar-base-border-bottom-dark: null !default;\r\n$app-toolbar-base-border-bottom-mobile: null !default;\r\n$app-toolbar-base-border-bottom-mobile-dark: null !default;\r\n\r\n// Toolbar minimize\r\n$app-toolbar-minimize-height: 70px !default;\r\n$app-toolbar-minimize-height-mobile: 70px !default;\r\n$app-toolbar-minimize-z-index: 99 !default;\r\n$app-toolbar-minimize-z-index-mobile: 99 !default;\r\n$app-toolbar-minimize-backdrop-filter: null !default;\r\n$app-toolbar-minimize-backdrop-filter-mobile: null !default;\r\n$app-toolbar-minimize-bg-color: null !default;\r\n$app-toolbar-minimize-bg-color-dark: null !default;\r\n$app-toolbar-minimize-bg-color-mobile: null !default;\r\n$app-toolbar-minimize-bg-color-mobile-dark: null !default;\r\n$app-toolbar-minimize-box-shadow: null !default;\r\n$app-toolbar-minimize-box-shadow-dark: null !default;\r\n$app-toolbar-minimize-box-shadow-mobile: null !default;\r\n$app-toolbar-minimize-box-shadow-mobile-dark: null !default;\r\n$app-toolbar-minimize-border-top: null !default;\r\n$app-toolbar-minimize-border-top-dark: null !default;\r\n$app-toolbar-minimize-border-top-mobile: null !default;\r\n$app-toolbar-minimize-border-top-mobile-dark: null !default;\r\n$app-toolbar-minimize-border-bottom: null !default;\r\n$app-toolbar-minimize-border-bottom-dark: null !default;\r\n$app-toolbar-minimize-border-bottom-mobile: null !default;\r\n$app-toolbar-minimize-border-bottom-mobile-dark: null !default;\r\n\r\n// Toolbar sticky\r\n$app-toolbar-sticky-height: 70px !default;\r\n$app-toolbar-sticky-height-mobile: 70px !default;\r\n$app-toolbar-sticky-z-index: 99 !default;\r\n$app-toolbar-sticky-z-index-mobile: 99 !default;\r\n$app-toolbar-sticky-backdrop-filter: null !default;\r\n$app-toolbar-sticky-backdrop-filter-mobile: null !default;\r\n$app-toolbar-sticky-bg-color: null !default;\r\n$app-toolbar-sticky-bg-color-dark: null !default;\r\n$app-toolbar-sticky-bg-color-mobile: null !default;\r\n$app-toolbar-sticky-bg-color-mobile-dark: null !default;\r\n$app-toolbar-sticky-box-shadow: null !default;\r\n$app-toolbar-sticky-box-shadow-dark: null !default;\r\n$app-toolbar-sticky-box-shadow-mobile: null !default;\r\n$app-toolbar-sticky-box-shadow-mobile-dark: null !default;\r\n$app-toolbar-sticky-border-top: null !default;\r\n$app-toolbar-sticky-border-top-dark: null !default;\r\n$app-toolbar-sticky-border-top-mobile: null !default;\r\n$app-toolbar-sticky-border-top-mobile-dark: null !default;\r\n$app-toolbar-sticky-border-bottom: null !default;\r\n$app-toolbar-sticky-border-bottom-dark: null !default;\r\n$app-toolbar-sticky-border-bottom-mobile: null !default;\r\n$app-toolbar-sticky-border-bottom-mobile-dark: null !default;\r\n\r\n// Hero\r\n$app-hero-bg-color: null !default;\r\n$app-hero-bg-color-dark: null !default;\r\n$app-hero-box-shadow: null !default;\r\n$app-hero-box-shadow-dark: null !default;\r\n$app-hero-border-top: null !default;\r\n$app-hero-border-top-dark: null !default;\r\n$app-hero-border-bottom: null !default;\r\n$app-hero-border-bottom-dark: null !default;\r\n\r\n// Sidebar base\r\n$app-sidebar-base-transition: width $app-general-transition-duration $app-general-transition-timing !default;\r\n$app-sidebar-base-width: 300px !default;\r\n$app-sidebar-base-width-mobile: 275px !default;      \r\n$app-sidebar-base-z-index: null !default;\r\n$app-sidebar-base-z-index-mobile: 106 !default; \r\n$app-sidebar-base-bg-color: null !default;\r\n$app-sidebar-base-bg-color-dark: null !default;\r\n$app-sidebar-base-bg-color-mobile: null !default;\r\n$app-sidebar-base-bg-color-mobile-dark: null !default;\r\n$app-sidebar-base-box-shadow: null !default;\r\n$app-sidebar-base-box-shadow-dark: null !default;\r\n$app-sidebar-base-box-shadow-mobile: null !default;\r\n$app-sidebar-base-box-shadow-mobile-dark: null !default;\r\n$app-sidebar-base-border-start: null !default;\r\n$app-sidebar-base-border-start-dark: null !default;\r\n$app-sidebar-base-border-start-mobile: null !default;\r\n$app-sidebar-base-border-start-mobile-dark: null !default;\r\n$app-sidebar-base-border-end: null !default;\r\n$app-sidebar-base-border-end-dark: null !default;\r\n$app-sidebar-base-border-end-mobile: null !default;\r\n$app-sidebar-base-border-end-mobile-dark: null !default;\r\n$app-sidebar-base-gap-start: 0px !default;\r\n$app-sidebar-base-gap-start-mobile: 0px !default;\r\n$app-sidebar-base-gap-end: 0px !default;\r\n$app-sidebar-base-gap-end-mobile: 0px !default;\r\n$app-sidebar-base-gap-top: 0px !default;\r\n$app-sidebar-base-gap-top-mobile: 0px !default;\r\n$app-sidebar-base-gap-bottom: 0px !default;\r\n$app-sidebar-base-gap-bottom-mobile: 0px !default;\r\n\r\n// Sidebar fixed\r\n$app-sidebar-fixed-z-index: 105 !default;\r\n$app-sidebar-fixed-left: 0 !default;\r\n$app-sidebar-fixed-top: 0 !default;\r\n$app-sidebar-fixed-bottom: 0 !default;\r\n\r\n// Sidebar sticky\r\n$app-sidebar-sticky-top: auto !default;\r\n$app-sidebar-sticky-bottom: auto !default;\r\n$app-sidebar-sticky-left: auto !default;\r\n$app-sidebar-sticky-width: 300px !default;\r\n$app-sidebar-sticky-z-index: 105 !default;\r\n$app-sidebar-sticky-bg-color: null !default;\r\n$app-sidebar-sticky-bg-color-dark: null !default;\r\n$app-sidebar-sticky-box-shadow: null !default;\r\n$app-sidebar-sticky-box-shadow-dark: null !default;\r\n$app-sidebar-sticky-border-start: null !default;\r\n$app-sidebar-sticky-border-start-dark: null !default;\r\n$app-sidebar-sticky-border-end: null !default;\r\n$app-sidebar-sticky-border-end-dark: null !default;\r\n$app-sidebar-sticky-gap-start: 0px !default;\r\n$app-sidebar-sticky-gap-end: 0px !default;\r\n$app-sidebar-sticky-gap-top: 0px !default;\r\n$app-sidebar-sticky-gap-bottom: 0px !default;\r\n\r\n// Sidebar minimize\r\n$app-sidebar-minimize-width: 75px !default;\r\n$app-sidebar-minimize-width-mobile: 75px !default;\r\n$app-sidebar-minimize-bg-color: null !default;\r\n$app-sidebar-minimize-bg-color-dark: null !default;\r\n$app-sidebar-minimize-bg-color-mobile: null !default;\r\n$app-sidebar-minimize-bg-color-mobile-dark: null !default;\r\n$app-sidebar-minimize-box-shadow: null !default;\r\n$app-sidebar-minimize-box-shadow-dark: null !default;\r\n$app-sidebar-minimize-box-shadow-mobile: null !default;\r\n$app-sidebar-minimize-box-shadow-mobile-dark: null !default;\r\n$app-sidebar-minimize-hover-box-shadow: null !default;\r\n$app-sidebar-minimize-hover-box-shadow-dark: null !default;\r\n$app-sidebar-minimize-hover-box-shadow-mobile: null !default;\r\n$app-sidebar-minimize-hover-box-shadow-mobile-dark: null !default;\r\n$app-sidebar-minimize-border-start: null !default;\r\n$app-sidebar-minimize-border-start-dark: null !default;\r\n$app-sidebar-minimize-border-start-mobile: null !default;\r\n$app-sidebar-minimize-border-start-mobile-dark: null !default;\r\n$app-sidebar-minimize-border-end: null !default;\r\n$app-sidebar-minimize-border-end-dark: null !default;\r\n$app-sidebar-minimize-border-end-mobile: null !default;\r\n$app-sidebar-minimize-border-end-mobile-dark: null !default;\r\n$app-sidebar-minimize-gap-start: 0px !default;\r\n$app-sidebar-minimize-gap-start-mobile: 0px !default;\r\n$app-sidebar-minimize-gap-end: 0px !default;\r\n$app-sidebar-minimize-gap-end-mobile: 0px !default;\r\n$app-sidebar-minimize-gap-top: 0px !default;\r\n$app-sidebar-minimize-gap-top-mobile: 0px !default;\r\n$app-sidebar-minimize-gap-bottom: 0px !default;\r\n$app-sidebar-minimize-gap-bottom-mobile: 0px !default;\r\n\r\n// Sidebar primary\r\n$app-sidebar-primary-base-transition: none !default;\r\n$app-sidebar-primary-base-width: 100px !default;\r\n$app-sidebar-primary-base-width-mobile: 100px !default;\r\n$app-sidebar-primary-base-z-index: 1 !default;\r\n$app-sidebar-primary-base-z-index-mobile: 1 !default;\r\n$app-sidebar-primary-base-bg-color: null !default;\r\n$app-sidebar-primary-base-bg-color-dark: null !default;\r\n$app-sidebar-primary-base-bg-color-mobile: null !default;\r\n$app-sidebar-primary-base-bg-color-mobile-dark: null !default;\r\n$app-sidebar-primary-base-box-shadow: null !default;\r\n$app-sidebar-primary-base-box-shadow-dark: null !default;\r\n$app-sidebar-primary-base-box-shadow-mobile: null !default;\r\n$app-sidebar-primary-base-box-shadow-mobile-dark: null !default;\r\n$app-sidebar-primary-base-border-start: null !default;\r\n$app-sidebar-primary-base-border-start-dark: null !default;\r\n$app-sidebar-primary-base-border-start-mobile: null !default;\r\n$app-sidebar-primary-base-border-start-mobile-dark: null !default;\r\n$app-sidebar-primary-base-border-end: null !default;\r\n$app-sidebar-primary-base-border-end-dark: null !default;\r\n$app-sidebar-primary-base-border-end-mobile: null !default;\r\n$app-sidebar-primary-base-border-end-mobile-dark: null !default;\r\n$app-sidebar-primary-base-gap-start: 0px !default;\r\n$app-sidebar-primary-base-gap-start-mobile: 0px !default;\r\n$app-sidebar-primary-base-gap-end: 0px !default;\r\n$app-sidebar-primary-base-gap-end-mobile: 0px !default;\r\n$app-sidebar-primary-base-gap-top: 0px !default;\r\n$app-sidebar-primary-base-gap-top-mobile: 0px !default;\r\n$app-sidebar-primary-base-gap-bottom: 0px !default;\r\n$app-sidebar-primary-base-gap-bottom-mobile: 0px !default;\r\n\r\n$app-sidebar-primary-minimize-width: 75px !default;\r\n$app-sidebar-primary-minimize-width-mobile: 75px !default;\r\n$app-sidebar-primary-minimize-z-index: null !default;\r\n$app-sidebar-primary-minimize-bg-color: null !default;\r\n$app-sidebar-primary-minimize-bg-color-dark: null !default;\r\n$app-sidebar-primary-minimize-bg-color-mobile: null !default;\r\n$app-sidebar-primary-minimize-bg-color-mobile-dark: null !default;\r\n$app-sidebar-primary-minimize-box-shadow: null !default;\r\n$app-sidebar-primary-minimize-box-shadow-dark: null !default;\r\n$app-sidebar-primary-minimize-box-shadow-mobile: null !default;\r\n$app-sidebar-primary-minimize-box-shadow-mobile-dark: null !default;\r\n$app-sidebar-primary-minimize-hover-box-shadow: null !default;\r\n$app-sidebar-primary-minimize-hover-box-shadow-dark: null !default;\r\n$app-sidebar-primary-minimize-hover-box-shadow-mobile: null !default;\r\n$app-sidebar-primary-minimize-hover-box-shadow-mobile-dark: null !default;\r\n$app-sidebar-primary-minimize-border-start: null !default;\r\n$app-sidebar-primary-minimize-border-start-dark: null !default;\r\n$app-sidebar-primary-minimize-border-start-mobile: null !default;\r\n$app-sidebar-primary-minimize-border-start-mobile-dark: null !default;\r\n$app-sidebar-primary-minimize-border-end: null !default;\r\n$app-sidebar-primary-minimize-border-end-dark: null !default;\r\n$app-sidebar-primary-minimize-border-end-mobile: null !default;\r\n$app-sidebar-primary-minimize-border-end-mobile-dark: null !default;\r\n$app-sidebar-primary-minimize-gap-start: 0px !default;\r\n$app-sidebar-primary-minimize-gap-start-mobile: 0px !default;\r\n$app-sidebar-primary-minimize-gap-end: 0px !default;\r\n$app-sidebar-primary-minimize-gap-end-mobile: 0px !default;\r\n$app-sidebar-primary-minimize-gap-top: 0px !default;\r\n$app-sidebar-primary-minimize-gap-top-mobile: 0px !default;\r\n$app-sidebar-primary-minimize-gap-bottom: 0px !default;\r\n$app-sidebar-primary-minimize-gap-bottom-mobile: 0px !default;\r\n\r\n// Sidebar secondary\r\n$app-sidebar-secondary-base-transition: none !default;\r\n$app-sidebar-secondary-base-z-index: null !default;\r\n$app-sidebar-secondary-base-z-index-mobile: null !default;\r\n$app-sidebar-secondary-base-bg-color: null !default;\r\n$app-sidebar-secondary-base-bg-color-dark: null !default;\r\n$app-sidebar-secondary-base-bg-color-mobile: null !default;\r\n$app-sidebar-secondary-base-bg-color-mobile-dark: null !default;\r\n$app-sidebar-secondary-base-box-shadow: null !default;\r\n$app-sidebar-secondary-base-box-shadow-dark: null !default;\r\n$app-sidebar-secondary-base-box-shadow-mobile: null !default;\r\n$app-sidebar-secondary-base-box-shadow-mobile-dark: null !default;\r\n$app-sidebar-secondary-base-border-start: null !default;\r\n$app-sidebar-secondary-base-border-start-dark: null !default;\r\n$app-sidebar-secondary-base-border-start-mobile: null !default;\r\n$app-sidebar-secondary-base-border-start-mobile-dark: null !default;\r\n$app-sidebar-secondary-base-border-end: null !default;\r\n$app-sidebar-secondary-base-border-end-dark: null !default;\r\n$app-sidebar-secondary-base-border-end-mobile: null !default;\r\n$app-sidebar-secondary-base-border-end-mobile-dark: null !default;\r\n$app-sidebar-secondary-base-gap-start: 0px !default;\r\n$app-sidebar-secondary-base-gap-start-mobile: 0px !default;\r\n$app-sidebar-secondary-base-gap-end: 0px !default;\r\n$app-sidebar-secondary-base-gap-end-mobile: 0px !default;\r\n$app-sidebar-secondary-base-gap-top: 0px !default;\r\n$app-sidebar-secondary-base-gap-top-mobile: 0px !default;\r\n$app-sidebar-secondary-base-gap-bottom: 0px !default;\r\n$app-sidebar-secondary-base-gap-bottom-mobile: 0px !default;\r\n\r\n$app-sidebar-secondary-minimize-width: 75px !default;\r\n$app-sidebar-secondary-minimize-width-mobile: 75px !default;\r\n$app-sidebar-secondary-minimize-z-index: null !default;\r\n$app-sidebar-secondary-minimize-bg-color: null !default;\r\n$app-sidebar-secondary-minimize-bg-color-dark: null !default;\r\n$app-sidebar-secondary-minimize-bg-color-mobile: null !default;\r\n$app-sidebar-secondary-minimize-bg-color-mobile-dark: null !default;\r\n$app-sidebar-secondary-minimize-box-shadow: null !default;\r\n$app-sidebar-secondary-minimize-box-shadow-dark: null !default;\r\n$app-sidebar-secondary-minimize-box-shadow-mobile: null !default;\r\n$app-sidebar-secondary-minimize-box-shadow-mobile-dark: null !default;\r\n$app-sidebar-secondary-minimize-hover-box-shadow: null !default;\r\n$app-sidebar-secondary-minimize-hover-box-shadow-dark: null !default;\r\n$app-sidebar-secondary-minimize-hover-box-shadow-mobile: null !default;\r\n$app-sidebar-secondary-minimize-hover-box-shadow-mobile-dark: null !default;\r\n$app-sidebar-secondary-minimize-border-start: null !default;\r\n$app-sidebar-secondary-minimize-border-start-dark: null !default;\r\n$app-sidebar-secondary-minimize-border-start-mobile: null !default;\r\n$app-sidebar-secondary-minimize-border-start-mobile-dark: null !default;\r\n$app-sidebar-secondary-minimize-border-end: null !default;\r\n$app-sidebar-secondary-minimize-border-end-dark: null !default;\r\n$app-sidebar-secondary-minimize-border-end-mobile: null !default;\r\n$app-sidebar-secondary-minimize-border-end-mobile-dark: null !default;\r\n$app-sidebar-secondary-minimize-gap-start: 0px !default;\r\n$app-sidebar-secondary-minimize-gap-start-mobile: 0px !default;\r\n$app-sidebar-secondary-minimize-gap-end: 0px !default;\r\n$app-sidebar-secondary-minimize-gap-end-mobile: 0px !default;\r\n$app-sidebar-secondary-minimize-gap-top: 0px !default;\r\n$app-sidebar-secondary-minimize-gap-top-mobile: 0px !default;\r\n$app-sidebar-secondary-minimize-gap-bottom: 0px !default;\r\n$app-sidebar-secondary-minimize-gap-bottom-mobile: 0px !default;\r\n\r\n// Sidebar panel base\r\n$app-sidebar-panel-base-transition: none !default;\r\n$app-sidebar-panel-base-width: 300px !default;\r\n$app-sidebar-panel-base-width-mobile: 300px !default;    \r\n$app-sidebar-panel-base-z-index: null !default;\r\n$app-sidebar-panel-base-z-index-mobile: null !default;\r\n$app-sidebar-panel-base-bg-color: null !default;\r\n$app-sidebar-panel-base-bg-color-dark: null !default;\r\n$app-sidebar-panel-base-bg-color-mobile: null !default;\r\n$app-sidebar-panel-base-bg-color-mobile-dark: null !default;\r\n$app-sidebar-panel-base-box-shadow: null !default;\r\n$app-sidebar-panel-base-box-shadow-dark: null !default;\r\n$app-sidebar-panel-base-box-shadow-mobile: null !default;\r\n$app-sidebar-panel-base-box-shadow-mobile-dark: null !default;\r\n$app-sidebar-panel-base-border-start: null !default;\r\n$app-sidebar-panel-base-border-start-dark: null !default;\r\n$app-sidebar-panel-base-border-start-mobile: null !default;\r\n$app-sidebar-panel-base-border-start-mobile-dark: null !default;\r\n$app-sidebar-panel-base-border-end: null !default;\r\n$app-sidebar-panel-base-border-end-dark: null !default;\r\n$app-sidebar-panel-base-border-end-mobile: null !default;\r\n$app-sidebar-panel-base-border-end-mobile-dark: null !default;\r\n$app-sidebar-panel-base-gap-start: 0px !default;\r\n$app-sidebar-panel-base-gap-start-mobile: 0px !default;\r\n$app-sidebar-panel-base-gap-end: 0px !default;\r\n$app-sidebar-panel-base-gap-end-mobile: 0px !default;\r\n$app-sidebar-panel-base-gap-top: 0px !default;\r\n$app-sidebar-panel-base-gap-top-mobile: 0px !default;\r\n$app-sidebar-panel-base-gap-bottom: 0px !default;\r\n$app-sidebar-panel-base-gap-bottom-mobile: 0px !default;\r\n\r\n// Sidebar panel fixed\r\n$app-sidebar-panel-fixed-z-index: 104 !default;\r\n$app-sidebar-panel-fixed-z-index-mobile: 105 !default;\r\n\r\n// Sidebar panel sticky\r\n$app-sidebar-panel-sticky-top: auto !default;\r\n$app-sidebar-panel-sticky-bottom: auto !default;\r\n$app-sidebar-panel-sticky-width: 300px !default;\r\n$app-sidebar-panel-sticky-z-index: 104 !default;\r\n$app-sidebar-panel-sticky-bg-color: null !default;\r\n$app-sidebar-panel-sticky-bg-color-dark: null !default;\r\n$app-sidebar-panel-sticky-box-shadow: null !default;\r\n$app-sidebar-panel-sticky-box-shadow-dark: null !default;\r\n$app-sidebar-panel-sticky-border-start: null !default;\r\n$app-sidebar-panel-sticky-border-start-dark: null !default;\r\n$app-sidebar-panel-sticky-border-end: null !default;\r\n$app-sidebar-panel-sticky-border-end-dark: null !default;\r\n$app-sidebar-panel-sticky-gap-start: 0px !default;\r\n$app-sidebar-panel-sticky-gap-start-mobile: 0px !default;\r\n$app-sidebar-panel-sticky-gap-end: 0px !default;\r\n$app-sidebar-panel-sticky-gap-end-mobile: 0px !default;\r\n$app-sidebar-panel-sticky-gap-top: 0px !default;\r\n$app-sidebar-panel-sticky-gap-top-mobile: 0px !default;\r\n$app-sidebar-panel-sticky-gap-bottom: 0px !default;\r\n$app-sidebar-panel-sticky-gap-bottom-mobile: 0px !default;\r\n\r\n// Sidebar panel minimize\r\n$app-sidebar-panel-minimize-width: 75px !default;\r\n$app-sidebar-panel-minimize-width-mobile: 75px !default;\r\n$app-sidebar-panel-minimize-bg-color: null !default;\r\n$app-sidebar-panel-minimize-bg-color-dark: null !default;\r\n$app-sidebar-panel-minimize-bg-color-mobile: null !default;\r\n$app-sidebar-panel-minimize-bg-color-mobile-dark: null !default;\r\n$app-sidebar-panel-minimize-box-shadow: null !default;\r\n$app-sidebar-panel-minimize-box-shadow-dark: null !default;\r\n$app-sidebar-panel-minimize-box-shadow-mobile: null !default;\r\n$app-sidebar-panel-minimize-box-shadow-mobile-dark: null !default;\r\n$app-sidebar-panel-minimize-hover-box-shadow: null !default;\r\n$app-sidebar-panel-minimize-hover-box-shadow-dark: null !default;\r\n$app-sidebar-panel-minimize-hover-box-shadow-mobile: null !default;\r\n$app-sidebar-panel-minimize-hover-box-shadow-mobile-dark: null !default;\r\n$app-sidebar-panel-minimize-border-start: null !default;\r\n$app-sidebar-panel-minimize-border-start-dark: null !default;\r\n$app-sidebar-panel-minimize-border-start-mobile: null !default;\r\n$app-sidebar-panel-minimize-border-start-mobile-dark: null !default;\r\n$app-sidebar-panel-minimize-border-end: null !default;\r\n$app-sidebar-panel-minimize-border-end-dark: null !default;\r\n$app-sidebar-panel-minimize-border-end-mobile: null !default;\r\n$app-sidebar-panel-minimize-border-end-mobile-dark: null !default;\r\n$app-sidebar-panel-minimize-gap-start: 0px !default;\r\n$app-sidebar-panel-minimize-gap-start-mobile: 0px !default;\r\n$app-sidebar-panel-minimize-gap-end: 0px !default;\r\n$app-sidebar-panel-minimize-gap-end-mobile: 0px !default;\r\n$app-sidebar-panel-minimize-gap-top: 0px !default;\r\n$app-sidebar-panel-minimize-gap-top-mobile: 0px !default;\r\n$app-sidebar-panel-minimize-gap-bottom: 0px !default;\r\n$app-sidebar-panel-minimize-gap-bottom-mobile: 0px !default;\r\n\r\n// Aside base\r\n$app-aside-base-transition: none;\r\n$app-aside-base-width: 300px !default;\r\n$app-aside-base-width-mobile: 275px !default;      \r\n$app-aside-base-z-index: null !default;\r\n$app-aside-base-z-index-mobile: 106 !default; \r\n$app-aside-base-bg-color: null !default;\r\n$app-aside-base-bg-color-dark: null !default;\r\n$app-aside-base-bg-color-mobile: null !default;\r\n$app-aside-base-bg-color-mobile-dark: null !default;\r\n$app-aside-base-box-shadow: null !default;\r\n$app-aside-base-box-shadow-dark: null !default;\r\n$app-aside-base-box-shadow-mobile: null !default;\r\n$app-aside-base-box-shadow-mobile-dark: null !default;\r\n$app-aside-base-border-start: null !default;\r\n$app-aside-base-border-start-dark: null !default;\r\n$app-aside-base-border-start-mobile: null !default;\r\n$app-aside-base-border-start-mobile-dark: null !default;\r\n$app-aside-base-border-end: null !default;\r\n$app-aside-base-border-end-dark: null !default;\r\n$app-aside-base-border-end-mobile: null !default;\r\n$app-aside-base-border-end-mobile-dark: null !default;\r\n$app-aside-base-gap-start: 0px !default;\r\n$app-aside-base-gap-start-mobile: 0px !default;\r\n$app-aside-base-gap-end: 0px !default;\r\n$app-aside-base-gap-end-mobile: 0px !default;\r\n$app-aside-base-gap-top: 0px !default;\r\n$app-aside-base-gap-top-mobile: 0px !default;\r\n$app-aside-base-gap-bottom: 0px !default;\r\n$app-aside-base-gap-bottom-mobile: 0px !default;\r\n\r\n// Aside fixed\r\n$app-aside-fixed-z-index: 105 !default;\r\n$app-aside-fixed-right: 0 !default;\r\n$app-aside-fixed-top: 0 !default;\r\n$app-aside-fixed-bottom: 0 !default;\r\n\r\n// Aside sticky\r\n$app-aside-sticky-top: auto !default;\r\n$app-aside-sticky-bottom: auto !default;\r\n$app-aside-sticky-left: auto !default;\r\n$app-aside-sticky-width: 300px !default;\r\n$app-aside-sticky-z-index: 105 !default;\r\n$app-aside-sticky-bg-color: null !default;\r\n$app-aside-sticky-bg-color-dark: null !default;\r\n$app-aside-sticky-box-shadow: null !default;\r\n$app-aside-sticky-box-shadow-dark: null !default;\r\n$app-aside-sticky-border-start: null !default;\r\n$app-aside-sticky-border-start-dark: null !default;\r\n$app-aside-sticky-border-end: null !default;\r\n$app-aside-sticky-border-end-dark: null !default;\r\n$app-aside-sticky-gap-start: 0px !default;\r\n$app-aside-sticky-gap-end: 0px !default;\r\n$app-aside-sticky-gap-top: 0px !default;\r\n$app-aside-sticky-gap-bottom: 0px !default;\r\n\r\n// Aside minimize\r\n$app-aside-minimize-width: 75px !default;\r\n$app-aside-minimize-width-mobile: 75px !default;\r\n$app-aside-minimize-bg-color: null !default;\r\n$app-aside-minimize-bg-color-dark: null !default;\r\n$app-aside-minimize-bg-color-mobile: null !default;\r\n$app-aside-minimize-bg-color-mobile-dark: null !default;\r\n$app-aside-minimize-box-shadow: null !default;\r\n$app-aside-minimize-box-shadow-dark: null !default;\r\n$app-aside-minimize-box-shadow-mobile: null !default;\r\n$app-aside-minimize-box-shadow-mobile-dark: null !default;\r\n$app-aside-minimize-hover-box-shadow: null !default;\r\n$app-aside-minimize-hover-box-shadow-dark: null !default;\r\n$app-aside-minimize-hover-box-shadow-mobile: null !default;\r\n$app-aside-minimize-hover-box-shadow-mobile-dark: null !default;\r\n$app-aside-minimize-border-start: null !default;\r\n$app-aside-minimize-border-start-dark: null !default;\r\n$app-aside-minimize-border-start-mobile: null !default;\r\n$app-aside-minimize-border-start-mobile-dark: null !default;\r\n$app-aside-minimize-border-end: null !default;\r\n$app-aside-minimize-border-end-dark: null !default;\r\n$app-aside-minimize-border-end-mobile: null !default;\r\n$app-aside-minimize-border-end-mobile-dark: null !default;\r\n$app-aside-minimize-gap-start: 0px !default;\r\n$app-aside-minimize-gap-start-mobile: 0px !default;\r\n$app-aside-minimize-gap-end: 0px !default;\r\n$app-aside-minimize-gap-end-mobile: 0px !default;\r\n$app-aside-minimize-gap-top: 0px !default;\r\n$app-aside-minimize-gap-top-mobile: 0px !default;\r\n$app-aside-minimize-gap-bottom: 0px !default;\r\n$app-aside-minimize-gap-bottom-mobile: 0px !default;\r\n\r\n// Footer\r\n$app-footer-transition: left $app-general-transition-duration $app-general-transition-timing, right $app-general-transition-duration $app-general-transition-timing;\r\n$app-footer-height: 70px !default;\r\n$app-footer-height-mobile: 70px !default;\r\n$app-footer-z-index: null !default;\r\n$app-footer-z-index-mobile: null !default;\r\n$app-footer-bg-color: null !default;\r\n$app-footer-bg-color-dark: null !default;\r\n$app-footer-bg-color-mobile: null !default;\r\n$app-footer-bg-color-mobile-dark: null !default;\r\n$app-footer-box-shadow: null !default;\r\n$app-footer-box-shadow-dark: null !default;\r\n$app-footer-box-shadow-mobile: null !default;\r\n$app-footer-box-shadow-mobile-dark: null !default;\r\n$app-footer-border-top: null !default;\r\n$app-footer-border-top-dark: null !default;\r\n$app-footer-border-top-mobile: null !default;\r\n$app-footer-border-top-mobile-dark: null !default;\r\n\r\n// Footer fixed\r\n$app-footer-fixed-z-index: 100 !default;\r\n$app-footer-fixed-z-index-mobile: 100 !default;\r\n\r\n// Layout Builder\r\n$app-layout-builder-toggle-z-index: 105 !default;\r\n$app-layout-builder-toggle-bottom: 40px !default;\r\n$app-layout-builder-toggle-bottom-mobile: 15px !default;\r\n$app-layout-builder-toggle-end: 40px !default;\r\n$app-layout-builder-toggle-end-mobile: 15px !default;","//\r\n// Header primary\r\n//\r\n\r\n// General mode\r\n.app-header-primary {\r\n    transition: $app-header-primary-base-transition;\r\n    display: flex;\r\n    align-items: stretch;   \r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    // Base\r\n    .app-header-primary {\r\n        @include property( z-index, $app-header-primary-base-z-index);\r\n\r\n        background-color: var(--kt-app-header-primary-base-bg-color);\r\n        box-shadow: var(--kt-app-header-primary-base-box-shadow);\r\n        border-bottom: var(--kt-app-header-primary-base-border-bottom);\r\n    }    \r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-header-primary-height: #{$app-header-primary-base-height};\r\n    }\r\n\r\n    [data-kt-app-header-sticky=\"on\"] {\r\n        --kt-app-header-primary-height: #{$app-header-primary-sticky-height};\r\n    }\r\n\r\n    [data-kt-app-header-minimize=\"on\"] {\r\n        --kt-app-header-primary-height: #{$app-header-primary-minimize-height};\r\n    } \r\n\r\n    [data-kt-app-header-sticky=\"on\"][data-kt-app-header-primary-sticky-hide=\"true\"] {\r\n        --kt-app-header-primary-height: 0;\r\n    }\r\n\r\n    // States\r\n    .app-header-primary {\r\n        height: var(--kt-app-header-primary-height);\r\n\r\n        [data-kt-app-header-primary-fixed=\"true\"] & {\r\n            @include property( z-index, $app-header-primary-fixed-z-index);\r\n            position: fixed;\r\n            left: 0;\r\n            right: 0;\r\n            top: 0;            \r\n        }\r\n\r\n        [data-kt-app-header-primary-static=\"true\"] & {\r\n            position: relative;\r\n        }\r\n\r\n        [data-kt-app-header-primary-sticky=\"on\"] & {\r\n            position: fixed;\r\n            left: 0;\r\n            right: 0;\r\n            top: 0;\r\n            @include property( height, $app-header-primary-sticky-height);\r\n            @include property( z-index, $app-header-primary-sticky-z-index);\r\n\r\n            background-color: var(--kt-app-header-primary-sticky-bg-color);\r\n            box-shadow: var(--kt-app-header-primary-sticky-box-shadow);\r\n            border-bottom: var(--kt-app-header-primary-sticky-border-bottom);\r\n        }\r\n\r\n        [data-kt-app-header-primary-minimize=\"on\"] & {\r\n            transition: $app-header-primary-base-transition;\r\n            @include property( height, $app-header-primary-minimize-height);\r\n            @include property( z-index, $app-header-primary-minimize-z-index);\r\n\r\n            background-color: var(--kt-app-header-primary-minimize-bg-color);\r\n            box-shadow: var(--kt-app-header-primary-minimize-box-shadow);\r\n            border-bottom: var(--kt-app-header-primary-minimize-border-bottom);\r\n        }\r\n\r\n        [data-kt-app-header-sticky=\"on\"][data-kt-app-header-primary-sticky-hide=\"true\"] & {\r\n            display: none !important;\r\n        }\r\n    }\r\n\r\n    // Integration\r\n    .app-header-primary {\r\n        // Sidebar\r\n        [data-kt-app-sidebar-fixed=\"true\"][data-kt-app-sidebar-push-header=\"true\"] & {\r\n            left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px)\r\n            );\r\n        }  \r\n\r\n        // Sidebar Panel\r\n        [data-kt-app-sidebar-panel-fixed=\"true\"][data-kt-app-sidebar-panel-push-header=\"true\"] & {\r\n            left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px) +\r\n                var(--kt-app-sidebar-panel-width) + \r\n                var(--kt-app-sidebar-panel-gap-start, 0px) + \r\n                var(--kt-app-sidebar-panel-gap-end, 0px)\r\n            );\r\n        }\r\n    } \r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    // Base\r\n    .app-header-primary {\r\n        flex-grow: 1;\r\n        @include property( z-index, $app-header-primary-base-z-index-mobile);\r\n\r\n        background-color: var(--kt-app-header-primary-base-bg-color-mobile);\r\n        box-shadow: var(--kt-app-header-primary-base-box-shadow-mobile);\r\n        border-bottom: var(--kt-app-header-primary-base-border-bottom-mobile);\r\n    }  \r\n}","//\r\n// Header secondary\r\n//\r\n\r\n// General mode\r\n.app-header-secondary {\r\n    transition: $app-header-secondary-base-transition;\r\n    display: flex;\r\n    align-items: stretch; \r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    // Base\r\n    .app-header-secondary {\r\n        @include property( z-index, $app-header-secondary-base-z-index);\r\n\r\n        background-color: var(--kt-app-header-secondary-base-bg-color);\r\n        box-shadow: var(--kt-app-header-secondary-base-box-shadow);\r\n        border-bottom: var(--kt-app-header-secondary-base-border-bottom);\r\n    }    \r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-header-secondary-height: #{$app-header-secondary-base-height};\r\n    }\r\n\r\n    [data-kt-app-header-sticky=\"on\"] {\r\n        --kt-app-header-secondary-height: #{$app-header-secondary-sticky-height};\r\n    }\r\n\r\n    [data-kt-app-header-minimize=\"on\"] {\r\n        --kt-app-header-secondary-height: #{$app-header-secondary-minimize-height};\r\n    } \r\n\r\n    [data-kt-app-header-sticky=\"on\"][data-kt-app-header-secondary-sticky-hide=\"true\"] {\r\n        --kt-app-header-secondary-height: 0;\r\n    }\r\n\r\n    // States\r\n    .app-header-secondary {\r\n        height: var(--kt-app-header-secondary-height);\r\n\r\n        [data-kt-app-header-secondary-fixed=\"true\"] & {\r\n            @include property( z-index, $app-header-secondary-fixed-z-index);\r\n            position: fixed;\r\n            left: 0;\r\n            right: 0;\r\n            top: 0;            \r\n        }\r\n\r\n        [data-kt-app-header-secondary-static=\"true\"] & {\r\n            position: static;\r\n        }\r\n\r\n        [data-kt-app-header-secondary-sticky=\"on\"] & {\r\n            transition: $app-header-secondary-base-transition;\r\n            position: fixed;\r\n            left: 0;\r\n            right: 0;\r\n            top: 0;\r\n            @include property( height, $app-header-secondary-sticky-height);\r\n            @include property( z-index, $app-header-secondary-sticky-z-index);\r\n\r\n            background-color: var(--kt-app-header-secondary-sticky-bg-color);\r\n            box-shadow: var(--kt-app-header-secondary-sticky-box-shadow);\r\n            border-bottom: var(--kt-app-header-secondary-sticky-border-bottom);\r\n        }\r\n\r\n        [data-kt-app-header-secondary-minimize=\"on\"] & {\r\n            transition: $app-header-secondary-base-transition;\r\n            @include property( height, $app-header-secondary-minimize-height);\r\n            @include property( z-index, $app-header-secondary-minimize-z-index);\r\n\r\n            background-color: var(--kt-app-header-secondary-minimize-bg-color);\r\n            box-shadow: var(--kt-app-header-secondary-minimize-box-shadow);\r\n            border-bottom: var(--kt-app-header-secondary-minimize-border-bottom);\r\n        }\r\n\r\n        [data-kt-app-header-sticky=\"on\"][data-kt-app-header-secondary-sticky-hide=\"true\"] & {\r\n            display: none !important;\r\n        }\r\n    }\r\n\r\n    // Integration\r\n    .app-header-secondary {\r\n        // Sidebar\r\n        [data-kt-app-sidebar-fixed=\"true\"][data-kt-app-sidebar-push-header=\"true\"] & {\r\n            left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px)\r\n            );\r\n        }  \r\n\r\n        // Sidebar Panel\r\n        [data-kt-app-sidebar-panel-fixed=\"true\"][data-kt-app-sidebar-panel-push-header=\"true\"] & {\r\n            left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px) +\r\n                var(--kt-app-sidebar-panel-width) + \r\n                var(--kt-app-sidebar-panel-gap-start, 0px) + \r\n                var(--kt-app-sidebar-panel-gap-end, 0px)\r\n            );\r\n        }\r\n    } \r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    // Base\r\n    .app-header-secondary {\r\n        flex-grow: 1;\r\n        background-color: var(--kt-app-header-secondary-base-bg-color-mobile);\r\n        box-shadow: var(--kt-app-header-secondary-base-box-shadow-mobile);\r\n        border-left: var(--kt-app-header-secondary-base-border-start-mobile);\r\n        border-right: var(--kt-app-header-secondary-base-border-end-mobile);\r\n    }\r\n}","//\r\n// Toolbar\r\n//\r\n\r\n// General mode\r\n.app-toolbar { \r\n    display: flex;\r\n    align-items: stretch;\r\n    \r\n    &.app-toolbar-minimize {        \r\n        transition: $app-toolbar-base-transition;\r\n    }\r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    // Base\r\n    .app-toolbar {\r\n        background-color: var(--kt-app-toolbar-base-bg-color); \r\n        box-shadow: var(--kt-app-toolbar-base-box-shadow); \r\n        border-top: var(--kt-app-toolbar-base-border-top); \r\n        border-bottom: var(--kt-app-toolbar-base-border-bottom); \r\n    }    \r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-toolbar-height: #{$app-toolbar-base-height};\r\n        --kt-app-toolbar-height-actual: #{$app-toolbar-base-height};\r\n    }\r\n\r\n    [data-kt-app-toolbar-sticky=\"on\"] {\r\n        --kt-app-toolbar-height: #{$app-toolbar-sticky-height};\r\n    }\r\n\r\n    [data-kt-app-toolbar-minimize=\"on\"] {\r\n        --kt-app-toolbar-height: #{$app-toolbar-minimize-height};\r\n    } \r\n\r\n    // States\r\n    .app-toolbar {\r\n        height: var(--kt-app-toolbar-height);\r\n\r\n        [data-kt-app-header-fixed=\"true\"][data-kt-app-toolbar-fixed=\"true\"] & {            \r\n            @include property( z-index, $app-toolbar-base-z-index);\r\n            position: fixed;\r\n            left: 0;\r\n            right: 0;\r\n            top: 0; \r\n        }\r\n\r\n        [data-kt-app-toolbar-sticky=\"on\"] & {\r\n            position: fixed;\r\n            left: 0;\r\n            right: 0;\r\n            top: 0;\r\n            @include property( z-index, $app-toolbar-sticky-z-index);\r\n            @include property( backdrop-filter, $app-toolbar-sticky-backdrop-filter);\r\n\r\n            box-shadow: var(--kt-app-toolbar-sticky-box-shadow);\r\n            background-color: var(--kt-app-toolbar-sticky-bg-color);\r\n            border-top: var(--kt-app-toolbar-sticky-border-top);\r\n            border-bottom: var(--kt-app-toolbar-sticky-border-bottom);\r\n        }\r\n\r\n        [data-kt-app-toolbar-minimize=\"on\"] & {\r\n            transition: $app-toolbar-base-transition;\r\n            @include property( z-index, $app-toolbar-minimize-z-index);\r\n            @include property( backdrop-filter, $app-toolbar-minimize-backdrop-filter);\r\n\r\n            box-shadow: var(--kt-app-toolbar-minimize-box-shadow);\r\n            background-color: var(--kt-app-toolbar-minimize-bg-color);\r\n            border-top: var(--kt-app-toolbar-minimize-border-top);\r\n            border-bottom: var(--kt-app-toolbar-minimize-border-bottom);\r\n        }\r\n    }\r\n\r\n    // Integration\r\n    .app-toolbar {\r\n        // Header\r\n        [data-kt-app-toolbar-fixed=\"true\"][data-kt-app-header-fixed=\"true\"] & {\r\n            top: var(--kt-app-header-height);\r\n        }\r\n\r\n        // Sidebar\r\n        [data-kt-app-toolbar-sticky=\"on\"][data-kt-app-sidebar-fixed=\"true\"][data-kt-app-sidebar-push-toolbar=\"true\"] &,\r\n        [data-kt-app-toolbar-fixed=\"true\"][data-kt-app-sidebar-fixed=\"true\"][data-kt-app-sidebar-push-toolbar=\"true\"] & {\r\n            left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px)\r\n            );\r\n        } \r\n\r\n        // Sidebar panel\r\n        [data-kt-app-toolbar-sticky=\"on\"][data-kt-app-sidebar-panel-fixed=\"true\"][data-kt-app-sidebar-panel-push-toolbar=\"true\"] &,\r\n        [data-kt-app-toolbar-fixed=\"true\"][data-kt-app-sidebar-panel-fixed=\"true\"][data-kt-app-sidebar-panel-push-toolbar=\"true\"] & {\r\n            left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px) +\r\n                var(--kt-app-sidebar-panel-width) + \r\n                var(--kt-app-sidebar-panel-gap-start, 0px) + \r\n                var(--kt-app-sidebar-panel-gap-end, 0px)\r\n            );\r\n        }\r\n\r\n        // Aside\r\n        [data-kt-app-toolbar-sticky=\"on\"][data-kt-app-aside-fixed=\"true\"][data-kt-app-aside-push-toolbar=\"true\"] &,\r\n        [data-kt-app-toolbar-fixed=\"true\"][data-kt-app-aside-fixed=\"true\"][data-kt-app-aside-push-toolbar=\"true\"] & {\r\n            right: calc(\r\n                var(--kt-app-aside-width) + \r\n                var(--kt-app-aside-gap-start, 0px) + \r\n                var(--kt-app-aside-gap-end, 0px)\r\n            );\r\n        } \r\n    } \r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    // Base\r\n    .app-toolbar {\r\n        @include property( z-index, $app-toolbar-base-z-index-mobile);\r\n\r\n        box-shadow: var(--kt-app-toolbar-base-box-shadow-mobile);\r\n        background-color: var(--kt-app-toolbar-base-bg-color-mobile);\r\n        border-top: var(--kt-app-toolbar-base-border-top-mobile);\r\n        border-bottom: var(--kt-app-toolbar-base-border-bottom-mobile);\r\n    }\r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-toolbar-height: #{$app-toolbar-base-height-mobile};\r\n    }\r\n\r\n    [data-kt-app-toolbar-sticky=\"on\"] {\r\n        --kt-app-toolbar-height: #{$app-toolbar-sticky-height-mobile};\r\n    }\r\n\r\n    [data-kt-app-toolbar-minimize=\"on\"] {\r\n        --kt-app-toolbar-height: #{$app-toolbar-minimize-height-mobile};\r\n    } \r\n\r\n    // States\r\n    .app-toolbar {\r\n        height: var(--kt-app-toolbar-height);\r\n\r\n        [data-kt-app-header-fixed-mobile=\"true\"][data-kt-app-toolbar-fixed-mobile=\"true\"] & {\r\n            @include property( z-index, $app-toolbar-base-z-index-mobile);\r\n            position: fixed;            \r\n            top: calc(var(--kt-app-header-height, 0px) + var(--kt-app-header-mobile-height, 0px));          \r\n            left: 0;\r\n            right: 0;\r\n        }\r\n\r\n        [data-kt-app-toolbar-sticky=\"on\"] & {\r\n            position: fixed;\r\n            left: 0;\r\n            right: 0;\r\n            top: var(--kt-app-header-height, 0px);\r\n\r\n            box-shadow: var(--kt-app-toolbar-sticky-box-shadow-mobile);\r\n            background-color: var(--kt-app-toolbar-sticky-bg-color-mobile);\r\n            border-top: var(--kt-app-toolbar-sticky-border-top-mobile);\r\n            border-bottom: var(--kt-app-toolbar-sticky-border-bottom-mobile);\r\n\r\n            @include property( z-index, $app-toolbar-sticky-z-index-mobile);\r\n            @include property( backdrop-filter, $app-toolbar-sticky-backdrop-filter-mobile);\r\n        }\r\n\r\n        [data-kt-app-toolbar-minimize=\"on\"] & {\r\n            transition: $app-toolbar-base-transition;\r\n\r\n            box-shadow: var(--kt-app-toolbar-minimize-box-shadow-mobile);\r\n            background-color: var(--kt-app-toolbar-minimize-bg-color-mobile);\r\n            border-top: var(--kt-app-toolbar-minimize-border-top-mobile);\r\n            border-bottom: var(--kt-app-toolbar-minimize-border-bottom-mobile);\r\n\r\n            @include property( z-index, $app-toolbar-minimize-z-index-mobile);\r\n            @include property( backdrop-filter, $app-toolbar-minimize-backdrop-filter-mobile);\r\n        }\r\n    }\r\n}","//\r\n// Hero\r\n//\r\n\r\n// General mode\r\n.app-hero { \r\n    display: flex;\r\n    align-items: stretch;\r\n    background-color: var(--kt-app-hero-bg-color); \r\n    box-shadow: var(--kt-app-hero-box-shadow); \r\n    border-top: var(--kt-app-hero-border-top); \r\n    border-bottom: var(--kt-app-hero-border-bottom); \r\n}","//\r\n// sidebar\r\n//\r\n\r\n// General mode\r\n.app-sidebar {    \r\n    transition: $app-sidebar-base-transition;\r\n}\r\n\r\n// Utilities\r\n.app-sidebar-minimize-d-flex,\r\n.app-sidebar-sticky-d-flex,\r\n.app-sidebar-collapse-d-flex,\r\n.app-sidebar-minimize-mobile-d-flex,\r\n.app-sidebar-collapse-mobile-d-flex {\r\n    display: none;    \r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    // Base\r\n    .app-sidebar {        \r\n        display: flex;    \r\n        flex-shrink: 0;\r\n        width: var(--kt-app-sidebar-width);        \r\n\r\n        background-color: var(--kt-app-sidebar-base-bg-color);\r\n        box-shadow: var(--kt-app-sidebar-base-box-shadow);\r\n        border-left: var(--kt-app-sidebar-base-border-start);\r\n        border-right: var(--kt-app-sidebar-base-border-end);\r\n\r\n        @include property( z-index, $app-sidebar-base-z-index);\r\n        @include property( margin-left, $app-sidebar-base-gap-start);\r\n        @include property( margin-right, $app-sidebar-base-gap-end);\r\n        @include property( margin-top, $app-sidebar-base-gap-top);\r\n        @include property( margin-bottom, $app-sidebar-base-gap-bottom);\r\n    }    \r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-sidebar-width: #{$app-sidebar-base-width};\r\n        --kt-app-sidebar-width-actual: #{$app-sidebar-base-width};\r\n\r\n        --kt-app-sidebar-gap-start: #{$app-sidebar-base-gap-start};\r\n        --kt-app-sidebar-gap-end: #{$app-sidebar-base-gap-end};\r\n        --kt-app-sidebar-gap-top: #{$app-sidebar-base-gap-top};\r\n        --kt-app-sidebar-gap-bottom: #{$app-sidebar-base-gap-bottom};\r\n    }\r\n\r\n    [data-kt-app-sidebar-stacked=\"true\"] {\r\n        --kt-app-sidebar-width: calc(var(--kt-app-sidebar-primary-width) + var(--kt-app-sidebar-secondary-width));\r\n    }\r\n\r\n    [data-kt-app-sidebar-minimize=\"on\"] {\r\n        --kt-app-sidebar-width: #{$app-sidebar-minimize-width};\r\n\r\n        --kt-app-sidebar-gap-start: #{$app-sidebar-minimize-gap-start};\r\n        --kt-app-sidebar-gap-end: #{$app-sidebar-minimize-gap-end};\r\n        --kt-app-sidebar-gap-top: #{$app-sidebar-minimize-gap-top};\r\n        --kt-app-sidebar-gap-bottom: #{$app-sidebar-minimize-gap-bottom};\r\n    }\r\n\r\n    [data-kt-app-sidebar-sticky=\"on\"] {\r\n        --kt-app-sidebar-width: #{$app-sidebar-sticky-width};\r\n\r\n        --kt-app-sidebar-gap-start: #{$app-sidebar-sticky-gap-start};\r\n        --kt-app-sidebar-gap-end: #{$app-sidebar-sticky-gap-end};\r\n        --kt-app-sidebar-gap-top: #{$app-sidebar-sticky-gap-top};\r\n        --kt-app-sidebar-gap-bottom: #{$app-sidebar-sticky-gap-bottom};\r\n    }    \r\n\r\n    [data-kt-app-sidebar-collapse=\"on\"] {\r\n        --kt-app-sidebar-width: 0px;  \r\n    }\r\n\r\n    // States\r\n    .app-sidebar {\r\n        [data-kt-app-sidebar-static=\"true\"] & {\r\n            position: relative;\r\n        }\r\n\r\n        [data-kt-app-sidebar-offcanvas=\"true\"] & {\r\n            display: none;\r\n        }\r\n\r\n        [data-kt-app-sidebar-fixed=\"true\"] & {\r\n            position: fixed;\r\n            @include property( z-index, $app-sidebar-fixed-z-index);\r\n            @include property( top, $app-sidebar-fixed-top);\r\n            @include property( bottom, $app-sidebar-fixed-bottom);\r\n            @include property( left, $app-sidebar-fixed-left);\r\n        }  \r\n\r\n        [data-kt-app-sidebar-stacked=\"true\"] & {\r\n            align-items: stretch; \r\n        }\r\n\r\n        [data-kt-app-sidebar-sticky=\"on\"] & {\r\n            position: fixed;\r\n            transition: $app-sidebar-base-transition;\r\n            @include property( top, $app-sidebar-sticky-top);\r\n            @include property( bottom, $app-sidebar-sticky-bottom);\r\n            @include property( left, $app-sidebar-sticky-left);\r\n            @include property( z-index, $app-sidebar-sticky-z-index);\r\n\r\n            box-shadow: var(--kt-app-sidebar-sticky-box-shadow);\r\n            border-left: var(--kt-app-sidebar-sticky-border-start);\r\n            border-right: var(--kt-app-sidebar-sticky-border-end);\r\n\r\n            @include property( margin-left, $app-sidebar-sticky-gap-start);\r\n            @include property( margin-right, $app-sidebar-sticky-gap-end);\r\n            @include property( margin-top, $app-sidebar-sticky-gap-top);\r\n            @include property( margin-bottom, $app-sidebar-sticky-gap-bottom);\r\n        }\r\n\r\n        [data-kt-app-sidebar-minimize=\"on\"] & {\r\n            transition: $app-sidebar-base-transition;\r\n\r\n            background-color: var(--kt-app-sidebar-minimize-bg-color);\r\n            box-shadow: var(--kt-app-sidebar-minimize-box-shadow);\r\n            border-left: var(--kt-app-sidebar-minimize-border-start);\r\n            border-right: var(--kt-app-sidebar-minimize-border-end);\r\n\r\n            @include property( margin-left, $app-sidebar-minimize-gap-start);\r\n            @include property( margin-right, $app-sidebar-minimize-gap-end);\r\n            @include property( margin-top, $app-sidebar-minimize-gap-top);\r\n            @include property( margin-bottom, $app-sidebar-minimize-gap-bottom);\r\n        }\r\n\r\n        [data-kt-app-sidebar-hoverable=\"true\"] & {\r\n            .app-sidebar-wrapper {\r\n                width: var(--kt-app-sidebar-width-actual); \r\n            }\r\n        }\r\n\r\n        [data-kt-app-sidebar-hoverable=\"true\"][data-kt-app-sidebar-minimize=\"on\"] &:hover:not(.animating) {\r\n            transition: $app-sidebar-base-transition;\r\n\t\t\twidth: var(--kt-app-sidebar-width-actual);\r\n            @include property( box-shadow, $app-sidebar-minimize-hover-box-shadow);\r\n        }\r\n\r\n        [data-kt-app-sidebar-collapse=\"on\"] & {\r\n            transition: $app-sidebar-base-transition;\r\n            width: var(--kt-app-sidebar-width-actual);\r\n            margin-left: calc( -1 * var(--kt-app-sidebar-width-actual));\r\n        }\r\n    }\r\n\r\n    // Utilities\r\n    [data-kt-app-sidebar-minimize=\"on\"] {\r\n        .app-sidebar-minimize-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-minimize-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n\r\n    [data-kt-app-sidebar-sticky=\"on\"] {\r\n        .app-sidebar-sticky-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-sticky-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    } \r\n\r\n    [data-kt-app-sidebar-collapse=\"on\"] {\r\n        .app-sidebar-collapse-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-collapse-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n\r\n    // Integration\r\n    .app-sidebar {\r\n        // Header\r\n        [data-kt-app-sidebar-fixed=\"true\"][data-kt-app-header-fixed=\"true\"]:not([data-kt-app-sidebar-push-header=\"true\"]) & {\r\n            top: var(--kt-app-header-height);\r\n        }\r\n\r\n        // Toolbar\r\n        [data-kt-app-sidebar-fixed=\"true\"][data-kt-app-header-fixed=\"true\"][data-kt-app-toolbar-fixed=\"true\"]:not([data-kt-app-sidebar-push-toolbar=\"true\"]) & {\r\n            top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0px));\r\n        }\r\n    }\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    // Base\r\n    .app-sidebar {\r\n        display: none;\r\n        width: var(--kt-app-sidebar-width);\r\n\r\n        background-color: var(--kt-app-sidebar-base-bg-color-mobile);\r\n        box-shadow: var(--kt-app-sidebar-base-box-shadow-mobile);\r\n        border-left: var(--kt-app-sidebar-base-border-start-mobile);\r\n        border-right: var(--kt-app-sidebar-base-border-end-mobile);\r\n\r\n        @include property( z-index, $app-sidebar-base-z-index-mobile);\r\n        @include property( margin-left, $app-sidebar-base-gap-start-mobile);\r\n        @include property( margin-right, $app-sidebar-base-gap-end-mobile);\r\n        @include property( margin-top, $app-sidebar-base-gap-top-mobile);\r\n        @include property( margin-bottom, $app-sidebar-base-gap-bottom-mobile);\r\n    }\r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-sidebar-width: #{$app-sidebar-base-width-mobile};\r\n        --kt-app-sidebar-width-actual: #{$app-sidebar-base-width-mobile};\r\n\r\n        --kt-app-sidebar-gap-start: #{$app-sidebar-base-gap-start-mobile};\r\n        --kt-app-sidebar-gap-end: #{$app-sidebar-base-gap-end-mobile};\r\n        --kt-app-sidebar-gap-top: #{$app-sidebar-base-gap-top-mobile};\r\n        --kt-app-sidebar-gap-bottom: #{$app-sidebar-base-gap-bottom-mobile};\r\n    }\r\n\r\n    [data-kt-app-sidebar-minimize-mobile=\"on\"] {\r\n        --kt-app-sidebar-width: #{$app-sidebar-minimize-width-mobile};\r\n\r\n        --kt-app-sidebar-gap-start: #{$app-sidebar-minimize-gap-start-mobile};\r\n        --kt-app-sidebar-gap-end: #{$app-sidebar-minimize-gap-end-mobile};\r\n        --kt-app-sidebar-gap-top: #{$app-sidebar-minimize-gap-top-mobile};\r\n        --kt-app-sidebar-gap-bottom: #{$app-sidebar-minimize-gap-bottom-mobile};\r\n    }\r\n\r\n    [data-kt-app-sidebar-collapse-mobile=\"on\"] {\r\n        --kt-app-sidebar-width: 0px;\r\n    }\r\n\r\n    // States\r\n    .app-sidebar {\r\n        [data-kt-app-sidebar-stacked=\"true\"] & {\r\n            align-items: stretch; \r\n        }\r\n            \r\n        [data-kt-app-sidebar-minimize-mobile=\"on\"] & {\r\n            transition: $app-sidebar-base-transition;\r\n\r\n            background-color: var(--kt-app-sidebar-minimize-bg-color-mobilee);\r\n            box-shadow: var(--kt-app-sidebar-minimize-box-shadow-mobile);\r\n            border-left: var(--kt-app-sidebar-minimize-border-start-mobile);\r\n            border-right: var(--kt-app-sidebar-minimize-border-end-mobile);\r\n\r\n            @include property( margin-left, $app-sidebar-minimize-gap-start-mobile);\r\n            @include property( margin-right, $app-sidebar-minimize-gap-end-mobile);\r\n            @include property( margin-top, $app-sidebar-minimize-gap-top-mobile);\r\n            @include property( margin-bottom, $app-sidebar-minimize-gap-bottom-mobile);\r\n        }\r\n\r\n        [data-kt-app-sidebar-hoverable-mobile=\"true\"] & {\r\n            .app-sidebar-wrapper {\r\n                width: var(--kt-app-sidebar-width-actual); \r\n            }\r\n        }\r\n\r\n        [data-kt-app-sidebar-hoverable-mobile=\"true\"][data-kt-app-sidebar-minimize-mobile=\"on\"] &:hover:not(.animating) {\r\n            transition: $app-sidebar-base-transition;\r\n\t\t\twidth: var(--kt-app-sidebar-width-actual);\r\n            box-shadow: var(--kt-app-sidebar-minimize-hover-box-shadow-mobile); \r\n        }\r\n\r\n        [data-kt-app-sidebar-collapse-mobile=\"on\"] & {\r\n            transition: $app-sidebar-base-transition;\r\n            width: var(--kt-app-sidebar-width-actual);\r\n            margin-left: calc( -1 * var(--kt-app-sidebar-width-actual));\r\n        }\r\n    }\r\n\r\n    // Utilities\r\n    [data-kt-app-sidebar-minimize-mobile=\"on\"] {\r\n        .app-sidebar-minimize-mobile-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-minimize-mobile-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n\r\n    [data-kt-app-sidebar-collapse-mobile=\"on\"] {\r\n        .app-sidebar-collapse-mobile-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-collapse-mobile-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n}","//\r\n// sidebar Primary\r\n//\r\n\r\n// General mode\r\n.app-sidebar-primary {\r\n    transition: $app-sidebar-primary-base-transition;\r\n    position: relative;\r\n    flex-shrink: 0;\r\n}\r\n\r\n// Utilities\r\n.app-sidebar-primary-collapse-d-flex,\r\n.app-sidebar-primary-minimize-d-flex,\r\n.app-sidebar-primary-collapse-mobile-d-flex,\r\n.app-sidebar-primary-minimize-mobile-d-flex {\r\n    display: none;\r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    // Base\r\n    .app-sidebar-primary {        \r\n        background-color: var(--kt-app-sidebar-primary-base-bg-color);\r\n        box-shadow: var(--kt-app-sidebar-primary-base-box-shadow);\r\n        border-left: var(--kt-app-sidebar-primary-base-border-start);\r\n        border-right: var(--kt-app-sidebar-primary-base-border-end);\r\n\r\n        @include property( z-index, $app-sidebar-primary-base-z-index);\r\n        @include property( margin-left, $app-sidebar-primary-base-gap-start);\r\n        @include property( margin-right, $app-sidebar-primary-base-gap-end);\r\n        @include property( margin-top, $app-sidebar-primary-base-gap-top);\r\n        @include property( margin-bottom, $app-sidebar-primary-base-gap-bottom);\r\n    }    \r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-sidebar-primary-width-actual: #{$app-sidebar-primary-base-width};\r\n    }\r\n\r\n    [data-kt-app-sidebar-stacked=\"true\"] {\r\n        --kt-app-sidebar-primary-width: #{$app-sidebar-primary-base-width};\r\n\r\n        --kt-app-sidebar-primary-gap-start: #{$app-sidebar-primary-base-gap-start};\r\n        --kt-app-sidebar-primary-gap-end: #{$app-sidebar-primary-base-gap-end};\r\n        --kt-app-sidebar-primary-gap-top: #{$app-sidebar-primary-base-gap-top};\r\n        --kt-app-sidebar-primary-gap-bottom: #{$app-sidebar-primary-base-gap-bottom};\r\n    }\r\n\r\n    [data-kt-app-sidebar-primary-minimize=\"on\"] {\r\n        --kt-app-sidebar-primary-width: #{$app-sidebar-primary-minimize-width};\r\n\r\n        --kt-app-sidebar-primary-gap-start: #{$app-sidebar-primary-minimize-gap-start};\r\n        --kt-app-sidebar-primary-gap-end: #{$app-sidebar-primary-minimize-gap-end};\r\n        --kt-app-sidebar-primary-gap-top: #{$app-sidebar-primary-minimize-gap-top};\r\n        --kt-app-sidebar-primary-gap-bottom: #{$app-sidebar-primary-minimize-gap-bottom};\r\n    }   \r\n\r\n    [data-kt-app-sidebar-primary-collapse=\"on\"] {        \r\n        --kt-app-sidebar-primary-width: 0px;\r\n    }    \r\n\r\n    // States\r\n    .app-sidebar-primary {\r\n        width: var(--kt-app-sidebar-primary-width);\r\n\r\n        [data-kt-app-sidebar-primary-collapse=\"on\"] & {\r\n            transition: $app-sidebar-primary-base-transition;\r\n            width: var(--kt-app-sidebar-primary-width-actual);\r\n            margin-left: calc( -1 * var(--kt-app-sidebar-primary-width-actual));\r\n        }\r\n\r\n        [data-kt-app-sidebar-primary-minimize=\"on\"] & {\r\n            transition: $app-sidebar-primary-base-transition;\r\n\r\n            background-color: var(--kt-app-sidebar-primary-minimize-bg-color);\r\n            box-shadow: var(--kt-app-sidebar-primary-minimize-box-shadow);\r\n            border-left: var(--kt-app-sidebar-primary-minimize-border-start);\r\n            border-right: var(--kt-app-sidebar-primary-minimize-border-end);\r\n\r\n            @include property( margin-left, $app-sidebar-primary-minimize-gap-start);\r\n            @include property( margin-right, $app-sidebar-primary-minimize-gap-end);\r\n            @include property( margin-top, $app-sidebar-primary-minimize-gap-top);\r\n            @include property( margin-bottom, $app-sidebar-primary-minimize-gap-bottom);\r\n        }\r\n\r\n        [data-kt-app-sidebar-primary-hoverable=\"true\"] & {\r\n            .app-sidebar-primary-hoverable {\r\n                width: var(--kt-app-sidebar-primary-width-actual); \r\n            }\r\n        }\r\n\r\n        // Hover minimized\r\n        [data-kt-app-sidebar-primary-hoverable=\"true\"][data-kt-app-sidebar-primary-minimize=\"on\"] &:hover:not(.animating) {\r\n            transition: $app-sidebar-primary-base-transition;\r\n\t\t\twidth: var(--kt-app-sidebar-primary-width-actual);\r\n            box-shadow: var(--kt-app-sidebar-primary-minimize-hover-box-shadow);\r\n        }\r\n    }\r\n\r\n    // Integration\r\n    .app-sidebar-primary {\r\n        // Header\r\n        [data-kt-app-sidebar-fixed=\"true\"][data-kt-app-header-fixed=\"true\"][data-kt-app-sidebar-primary-below-header=\"true\"] & {\r\n            top: var(--kt-app-header-height);\r\n        }\r\n\r\n        // Toolbar\r\n        [data-kt-app-sidebar-fixed=\"true\"][data-kt-app-header-fixed=\"true\"][data-kt-app-toolbar-fixed=\"true\"][data-kt-app-sidebar-primary-below-toolbar=\"true\"] & {\r\n            top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0));\r\n        }\r\n    }\r\n\r\n    // Utilities\r\n    [data-kt-app-sidebar-primary-minimize=\"on\"] {\r\n        .app-sidebar-primary-minimize-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-primary-minimize-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    } \r\n\r\n    [data-kt-app-sidebar-primary-collapse=\"on\"] {\r\n        .app-sidebar-primary-collapse-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-primary-collapse-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    // Base\r\n    .app-sidebar-primary {        \r\n        @include property( z-index, $app-sidebar-primary-base-z-index-mobile);\r\n\r\n        background-color: var(--kt-app-sidebar-primary-base-bg-color-mobile);\r\n        box-shadow: var(--kt-app-sidebar-primary-base-box-shadow-mobile);\r\n        border-left: var(--kt-app-sidebar-primary-base-border-start-mobile);\r\n        border-right: var(--kt-app-sidebar-primary-base-border-end-mobile);\r\n\r\n        @include property( margin-left, $app-sidebar-primary-base-gap-start-mobile);\r\n        @include property( margin-right, $app-sidebar-primary-base-gap-end-mobile);\r\n        @include property( margin-top, $app-sidebar-primary-base-gap-top-mobile);\r\n        @include property( margin-bottom, $app-sidebar-primary-base-gap-bottom-mobile);\r\n    }    \r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-sidebar-primary-width-actual: #{$app-sidebar-primary-base-width-mobile};\r\n    }\r\n\r\n    [data-kt-app-sidebar-stacked=\"true\"] {\r\n        --kt-app-sidebar-primary-width: #{$app-sidebar-primary-base-width-mobile};\r\n\r\n        --kt-app-sidebar-primary-gap-start: #{$app-sidebar-primary-base-gap-start-mobile};\r\n        --kt-app-sidebar-primary-gap-end: #{$app-sidebar-primary-base-gap-end-mobile};\r\n        --kt-app-sidebar-primary-gap-top: #{$app-sidebar-primary-base-gap-top-mobile};\r\n        --kt-app-sidebar-primary-gap-bottom: #{$app-sidebar-primary-base-gap-bottom-mobile};\r\n    }\r\n\r\n    [data-kt-app-sidebar-primary-minimize-mobile=\"on\"] {\r\n        --kt-app-sidebar-primary-width: #{$app-sidebar-primary-minimize-width-mobile};\r\n\r\n        --kt-app-sidebar-primary-gap-start: #{$app-sidebar-primary-minimize-gap-start-mobile};\r\n        --kt-app-sidebar-primary-gap-end: #{$app-sidebar-primary-minimize-gap-end-mobile};\r\n        --kt-app-sidebar-primary-gap-top: #{$app-sidebar-primary-minimize-gap-top-mobile};\r\n        --kt-app-sidebar-primary-gap-bottom: #{$app-sidebar-primary-minimize-gap-bottom-mobile};\r\n    }   \r\n\r\n    [data-kt-app-sidebar-primary-collapse-mobile=\"on\"] {\r\n        --kt-app-sidebar-primary-width: 0px;\r\n    }\r\n\r\n    // States\r\n    .app-sidebar-primary {\r\n        width: var(--kt-app-sidebar-primary-width);\r\n\r\n        [data-kt-app-sidebar-primary-collapse-mobile=\"on\"] & {\r\n            transition: $app-sidebar-primary-base-transition;\r\n            width: var(--kt-app-sidebar-primary-width-actual);\r\n            margin-left: calc( -1 * var(--kt-app-sidebar-primary-width-actual));\r\n        }\r\n\r\n        [data-kt-app-sidebar-primary-minimize-mobile=\"on\"] & {\r\n            transition: $app-sidebar-primary-base-transition;\r\n            background-color: var(--kt-app-sidebar-primary-minimize-bg-color-mobile);\r\n            box-shadow: var(--kt-app-sidebar-primary-base-box-shadow-mobile);\r\n            border-left: var(--kt-app-sidebar-primary-minimize-border-start-mobile);\r\n            border-left: var(--kt-app-sidebar-primary-minimize-border-end-mobile);\r\n\r\n            @include property( margin-left, $app-sidebar-primary-minimize-gap-start-mobile);\r\n            @include property( margin-right, $app-sidebar-primary-minimize-gap-end-mobile);\r\n            @include property( margin-top, $app-sidebar-primary-minimize-gap-top-mobile);\r\n            @include property( margin-bottom, $app-sidebar-primary-minimize-gap-bottom-mobile);\r\n        }\r\n\r\n        [data-kt-app-sidebar-primary-hoverable-mobile=\"true\"] & {\r\n            .app-sidebar-primary-hoverable {\r\n                width: var(--kt-app-sidebar-primary-width-actual); \r\n            }\r\n        }\r\n\r\n        [data-kt-app-sidebar-primary-hoverable-mobile=\"true\"][data-kt-app-sidebar-primary-minimize-mobile=\"on\"] &:hover:not(.animating) {\r\n            transition: $app-sidebar-primary-base-transition;\r\n\t\t\twidth: var(--kt-app-sidebar-primary-width-actual);\r\n            box-shadow: var(--kt-app-sidebar-primary-minimize-hover-box-shadow-mobile);\r\n        }\r\n    }\r\n\r\n    // Utilities\r\n    [data-kt-app-sidebar-primary-minimize-mobile=\"on\"] {\r\n        .app-sidebar-primary-minimize-mobile-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-primary-minimize-mobile-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    } \r\n\r\n    [data-kt-app-sidebar-primary-collapse-mobile=\"on\"] {\r\n        .app-sidebar-primary-collapse-mobile-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-primary-collapse-mobile-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n}","//\r\n// sidebar Secondary\r\n//\r\n\r\n// General mode\r\n.app-sidebar-secondary {\r\n    transition: $app-sidebar-secondary-base-transition;\r\n    position: relative;\r\n    flex-shrink: 0;\r\n}\r\n\r\n// Utilities\r\n.app-sidebar-secondary-collapse-d-flex,\r\n.app-sidebar-secondary-minimize-d-flex,\r\n.app-sidebar-secondary-collapse-mobile-d-flex,\r\n.app-sidebar-secondary-minimize-mobile-d-flex {\r\n    display: none;\r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    // Base\r\n    .app-sidebar-secondary {        \r\n        @include property( z-index, $app-sidebar-secondary-base-z-index);\r\n\r\n        background-color: var(--kt-app-sidebar-secondary-base-bg-color);\r\n        box-shadow: var(--kt-app-sidebar-secondary-base-box-shadow);\r\n        border-left: var(--kt-app-sidebar-secondary-base-border-start);\r\n        border-right: var(--kt-app-sidebar-secondary-base-border-end);\r\n\r\n        @include property( margin-left, $app-sidebar-secondary-base-gap-start-mobile);\r\n        @include property( margin-right, $app-sidebar-secondary-base-gap-end-mobile);\r\n        @include property( margin-top, $app-sidebar-secondary-base-gap-top-mobile);\r\n        @include property( margin-bottom, $app-sidebar-secondary-base-gap-bottom-mobile);\r\n    }    \r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-sidebar-secondary-width-actual: calc(\r\n            #{$app-sidebar-base-width} - \r\n            #{$app-sidebar-primary-base-width} - \r\n            #{$app-sidebar-primary-base-gap-start} - \r\n            #{$app-sidebar-primary-base-gap-end} -\r\n            #{$app-sidebar-secondary-base-gap-start} - \r\n            #{$app-sidebar-secondary-base-gap-end}\r\n        );\r\n    }\r\n\r\n    [data-kt-app-sidebar-stacked=\"true\"] {\r\n        --kt-app-sidebar-secondary-width: calc(\r\n            #{$app-sidebar-base-width} - \r\n            #{$app-sidebar-primary-base-width} - \r\n            #{$app-sidebar-primary-base-gap-start} - \r\n            #{$app-sidebar-primary-base-gap-end} -\r\n            #{$app-sidebar-secondary-base-gap-start} - \r\n            #{$app-sidebar-secondary-base-gap-end}\r\n        );        \r\n\r\n        --kt-app-sidebar-secondary-gap-start: #{$app-sidebar-secondary-base-gap-start};\r\n        --kt-app-sidebar-secondary-gap-end: #{$app-sidebar-secondary-base-gap-end};\r\n        --kt-app-sidebar-secondary-gap-top: #{$app-sidebar-secondary-base-gap-top};\r\n        --kt-app-sidebar-secondary-gap-bottom: #{$app-sidebar-secondary-base-gap-bottom};\r\n    }\r\n\r\n    [data-kt-app-sidebar-secondary-minimize=\"on\"] {\r\n        --kt-app-sidebar-secondary-width: #{$app-sidebar-secondary-minimize-width};\r\n\r\n        --kt-app-sidebar-secondary-gap-start: #{$app-sidebar-secondary-minimize-gap-start};\r\n        --kt-app-sidebar-secondary-gap-end: #{$app-sidebar-secondary-minimize-gap-end};\r\n        --kt-app-sidebar-secondary-gap-top: #{$app-sidebar-secondary-minimize-gap-top};\r\n        --kt-app-sidebar-secondary-gap-bottom: #{$app-sidebar-secondary-minimize-gap-bottom};\r\n    } \r\n\r\n    [data-kt-app-sidebar-secondary-collapse=\"on\"] {\r\n        --kt-app-sidebar-secondary-width-actual: calc(\r\n            #{$app-sidebar-base-width} - \r\n            #{$app-sidebar-primary-base-width} - \r\n            #{$app-sidebar-primary-base-gap-start} - \r\n            #{$app-sidebar-primary-base-gap-end} -\r\n            #{$app-sidebar-secondary-base-gap-start} - \r\n            #{$app-sidebar-secondary-base-gap-end}\r\n        );\r\n\r\n        --kt-app-sidebar-secondary-width: 0px;\r\n    }       \r\n\r\n    // States\r\n    .app-sidebar-secondary {\r\n        width: var(--kt-app-sidebar-secondary-width);\r\n\r\n        [data-kt-app-sidebar-secondary-collapse=\"on\"] & {\r\n            transition: $app-sidebar-secondary-base-transition;\r\n            width: var(--kt-app-sidebar-secondary-width-actual);\r\n            margin-left: calc( -1 * var(--kt-app-sidebar-secondary-width-actual));\r\n        }\r\n\r\n        [data-kt-app-sidebar-secondary-minimize=\"on\"] & {\r\n            transition: $app-sidebar-secondary-base-transition;\r\n            \r\n            background-color: var(--kt-app-sidebar-secondary-minimize-bg-color);\r\n            box-shadow: var(--kt-app-sidebar-secondary-minimize-box-shadow);\r\n            border-left: var(--kt-app-sidebar-secondary-minimize-border-start);\r\n            border-right: var(--kt-app-sidebar-secondary-minimize-border-end);\r\n\r\n            @include property( margin-left, $app-sidebar-secondary-minimize-gap-start-mobile);\r\n            @include property( margin-right, $app-sidebar-secondary-minimize-gap-end-mobile);\r\n            @include property( margin-top, $app-sidebar-secondary-minimize-gap-top-mobile);\r\n            @include property( margin-bottom, $app-sidebar-secondary-minimize-gap-bottom-mobile);\r\n        }\r\n\r\n        [data-kt-app-sidebar-secondary-hoverable=\"true\"] & {\r\n            .app-sidebar-secondary-hoverable {\r\n                width: var(--kt-app-sidebar-secondary-width-actual); \r\n            }\r\n        }\r\n\r\n        [data-kt-app-sidebar-secondary-hoverable=\"true\"][data-kt-app-sidebar-secondary-minimize=\"on\"] &:hover:not(.animating) {\r\n            transition: $app-sidebar-secondary-base-transition;\r\n\t\t\twidth: var(--kt-app-sidebar-secondary-width-actual);\r\n            box-shadow: var(--kt-app-sidebar-secondary-minimize-hover-box-shadow);\r\n        }\r\n    }\r\n\r\n    // Integration\r\n    .app-sidebar-secondary {\r\n        // Header\r\n        [data-kt-app-sidebar-fixed=\"true\"][data-kt-app-header-fixed=\"true\"][data-kt-app-sidebar-secondary-below-header=\"true\"] & {\r\n            top: var(--kt-app-header-height);\r\n        }\r\n\r\n        // Toolbar\r\n        [data-kt-app-sidebar-fixed=\"true\"][data-kt-app-header-fixed=\"true\"][data-kt-app-toolbar-fixed=\"true\"][data-kt-app-sidebar-secondary-below-toolbar=\"true\"] & {\r\n            top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0));\r\n        }\r\n    }\r\n\r\n    // Utilities\r\n    [data-kt-app-sidebar-secondary-minimize=\"on\"] {\r\n        .app-sidebar-secondary-minimize-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-secondary-minimize-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    } \r\n\r\n    [data-kt-app-sidebar-secondary-collapse=\"on\"] {\r\n        .app-sidebar-secondary-collapse-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-secondary-collapse-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    // Base\r\n    .app-sidebar-secondary {        \r\n        @include property( z-index, $app-sidebar-secondary-base-z-index-mobile);\r\n\r\n        background-color: var(--kt-app-sidebar-secondary-base-bg-color-mobile);\r\n        box-shadow: var(--kt-app-sidebar-secondary-base-box-shadow-mobile);\r\n        border-left: var(--kt-app-sidebar-secondary-base-border-start-mobile);\r\n        border-right: var(--kt-app-sidebar-secondary-base-border-end-mobile);\r\n\r\n        @include property( margin-left, $app-sidebar-secondary-base-gap-start-mobile);\r\n        @include property( margin-right, $app-sidebar-secondary-base-gap-end-mobile);\r\n        @include property( margin-top, $app-sidebar-secondary-base-gap-top-mobile);\r\n        @include property( margin-bottom, $app-sidebar-secondary-base-gap-bottom-mobile);\r\n    }    \r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-sidebar-secondary-width-actual: calc(\r\n            #{$app-sidebar-base-width-mobile} - \r\n            #{$app-sidebar-primary-base-width-mobile} - \r\n            #{$app-sidebar-primary-base-gap-start-mobile} - \r\n            #{$app-sidebar-primary-base-gap-end-mobile} - \r\n            #{$app-sidebar-secondary-base-gap-start-mobile} - \r\n            #{$app-sidebar-secondary-base-gap-end-mobile}\r\n        );\r\n    }\r\n\r\n    [data-kt-app-sidebar-stacked=\"true\"] {\r\n        --kt-app-sidebar-secondary-width: calc(\r\n            #{$app-sidebar-base-width-mobile} - \r\n            #{$app-sidebar-primary-base-width-mobile} - \r\n            #{$app-sidebar-primary-base-gap-start-mobile} - \r\n            #{$app-sidebar-primary-base-gap-end-mobile} - \r\n            #{$app-sidebar-secondary-base-gap-start-mobile} - \r\n            #{$app-sidebar-secondary-base-gap-end-mobile}\r\n        );       \r\n\r\n        --kt-app-sidebar-secondary-gap-start: #{$app-sidebar-secondary-base-gap-start-mobile};\r\n        --kt-app-sidebar-secondary-gap-end: #{$app-sidebar-secondary-base-gap-end-mobile};\r\n        --kt-app-sidebar-secondary-gap-top: #{$app-sidebar-secondary-base-gap-top-mobile};\r\n        --kt-app-sidebar-secondary-gap-bottom: #{$app-sidebar-secondary-base-gap-bottom-mobile};\r\n    }\r\n\r\n    [data-kt-app-sidebar-secondary-minimize-mobile=\"on\"] {\r\n        --kt-app-sidebar-secondary-width: #{$app-sidebar-secondary-minimize-width-mobile};\r\n\r\n        --kt-app-sidebar-secondary-gap-start: #{$app-sidebar-secondary-minimize-gap-start-mobile};\r\n        --kt-app-sidebar-secondary-gap-end: #{$app-sidebar-secondary-minimize-gap-end-mobile};\r\n        --kt-app-sidebar-secondary-gap-top: #{$app-sidebar-secondary-minimize-gap-top-mobile};\r\n        --kt-app-sidebar-secondary-gap-bottom: #{$app-sidebar-secondary-minimize-gap-bottom-mobile};\r\n    }        \r\n\r\n    [data-kt-app-sidebar-secondary-collapse-mobile=\"on\"] {\r\n        --kt-app-sidebar-secondary-width-actual:  calc(\r\n            #{$app-sidebar-base-width-mobile} - \r\n            #{$app-sidebar-primary-base-width-mobile} - \r\n            #{$app-sidebar-primary-base-gap-start-mobile} - \r\n            #{$app-sidebar-primary-base-gap-end-mobile} - \r\n            #{$app-sidebar-secondary-base-gap-start-mobile} - \r\n            #{$app-sidebar-secondary-base-gap-end-mobile}\r\n        );\r\n\r\n        --kt-app-sidebar-secondary-width: 0px;\r\n    }\r\n\r\n    // States\r\n    .app-sidebar-secondary {\r\n        width: var(--kt-app-sidebar-secondary-width);\r\n\r\n        [data-kt-app-sidebar-secondary-collapse-mobile=\"on\"] & {\r\n            transition: $app-sidebar-secondary-base-transition;\r\n            width: var(--kt-app-sidebar-secondary-width-actual);\r\n            margin-left: calc( -1 * var(--kt-app-sidebar-secondary-width-actual));\r\n        }\r\n\r\n        [data-kt-app-sidebar-secondary-minimize-mobile=\"on\"] & {\r\n            transition: $app-sidebar-secondary-base-transition;\r\n            background-color: var(--kt-app-sidebar-secondary-minimize-bg-color-mobile);\r\n            box-shadow: var(--kt-app-sidebar-secondary-minimize-box-shadow-mobile);\r\n            border-left: var(--kt-app-sidebar-secondary-minimize-border-start-mobile);\r\n            border-right: var(--kt-app-sidebar-secondary-minimize-border-end-mobile);\r\n\r\n            @include property( margin-left, $app-sidebar-secondary-minimize-gap-start-mobile);\r\n            @include property( margin-right, $app-sidebar-secondary-minimize-gap-end-mobile);\r\n            @include property( margin-top, $app-sidebar-secondary-minimize-gap-top-mobile);\r\n            @include property( margin-bottom, $app-sidebar-secondary-minimize-gap-bottom-mobile);\r\n        }\r\n\r\n        [data-kt-app-sidebar-secondary-hoverable-mobile=\"true\"] & {\r\n            .app-sidebar-secondary-hoverable {\r\n                width: var(--kt-app-sidebar-secondary-width-actual); \r\n            }\r\n        }\r\n\r\n        [data-kt-app-sidebar-secondary-hoverable-mobile=\"true\"][data-kt-app-sidebar-secondary-minimize-mobile=\"on\"] &:hover:not(.animating) {\r\n            transition: $app-sidebar-secondary-base-transition;\r\n\t\t\twidth: var(--kt-app-sidebar-secondary-width-actual);\r\n            box-shadow: var(--kt-app-sidebar-secondary-minimize-hover-box-shadow-mobile);\r\n        }\r\n    }\r\n\r\n    // Utilities\r\n    [data-kt-app-sidebar-secondary-minimize-mobile=\"on\"] {\r\n        .app-sidebar-secondary-minimize-mobile-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-secondary-minimize-mobile-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    } \r\n\r\n    [data-kt-app-sidebar-secondary-collapse=\"on\"] {\r\n        .app-sidebar-secondary-collapse-mobile-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-secondary-collapse-mobile-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n}","//\r\n// sidebar\r\n//\r\n\r\n// General mode\r\n.app-sidebar-panel {    \r\n    transition: $app-sidebar-panel-base-transition;\r\n}\r\n\r\n// Utilities\r\n.app-sidebar-panel-minimize-d-flex,\r\n.app-sidebar-panel-sticky-d-flex,\r\n.app-sidebar-panel-collapse-d-flex,\r\n.app-sidebar-panel-minimize-mobile-d-flex,\r\n.app-sidebar-panel-collapse-mobile-d-flex {\r\n    display: none;    \r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    // Base\r\n    .app-sidebar-panel {        \r\n        display: flex;    \r\n        flex-shrink: 0;\r\n        width: var(--kt-app-sidebar-panel-width);\r\n        background-color: var(--kt-app-sidebar-panel-base-bg-color);\r\n        box-shadow: var(--kt-app-sidebar-panel-base-box-shadow);\r\n        border-left: var(--kt-app-sidebar-panel-base-border-start);\r\n        border-right: var(--kt-app-sidebar-panel-base-border-end);\r\n\r\n        @include property( z-index, $app-sidebar-panel-base-z-index);\r\n        @include property( margin-left, $app-sidebar-panel-base-gap-start);\r\n        @include property( margin-right, $app-sidebar-panel-base-gap-end);\r\n        @include property( margin-top, $app-sidebar-panel-base-gap-top);\r\n        @include property( margin-bottom, $app-sidebar-panel-base-gap-bottom);\r\n    }    \r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-sidebar-panel-width: #{$app-sidebar-panel-base-width};\r\n        --kt-app-sidebar-panel-width-actual: #{$app-sidebar-panel-base-width};\r\n\r\n        --kt-app-sidebar-panel-gap-start: #{$app-sidebar-panel-base-gap-start};\r\n        --kt-app-sidebar-panel-gap-end: #{$app-sidebar-panel-base-gap-end};\r\n        --kt-app-sidebar-panel-gap-top: #{$app-sidebar-panel-base-gap-top};\r\n        --kt-app-sidebar-panel-gap-bottom: #{$app-sidebar-panel-base-gap-bottom};\r\n    }\r\n\r\n    [data-kt-app-sidebar-panel-minimize=\"on\"] {\r\n        --kt-app-sidebar-panel-width: #{$app-sidebar-panel-minimize-width};\r\n\r\n        --kt-app-sidebar-panel-gap-start: #{$app-sidebar-panel-minimize-gap-start};\r\n        --kt-app-sidebar-panel-gap-end: #{$app-sidebar-panel-minimize-gap-end};\r\n        --kt-app-sidebar-panel-gap-top: #{$app-sidebar-panel-minimize-gap-top};\r\n        --kt-app-sidebar-panel-gap-bottom: #{$app-sidebar-panel-minimize-gap-bottom};\r\n    }    \r\n\r\n    [data-kt-app-sidebar-panel-sticky=\"on\"] {\r\n        --kt-app-sidebar-panel-width: #{$app-sidebar-panel-sticky-width};\r\n\r\n        --kt-app-sidebar-panel-gap-start: #{$app-sidebar-panel-sticky-gap-start};\r\n        --kt-app-sidebar-panel-gap-end: #{$app-sidebar-panel-sticky-gap-end};\r\n        --kt-app-sidebar-panel-gap-top: #{$app-sidebar-panel-sticky-gap-top};\r\n        --kt-app-sidebar-panel-gap-bottom: #{$app-sidebar-panel-sticky-gap-bottom};\r\n    }\r\n\r\n    [data-kt-app-sidebar-panel-collapse=\"on\"] {\r\n        --kt-app-sidebar-panel-width-actual: #{$app-sidebar-panel-base-width};\r\n        --kt-app-sidebar-panel-width: 0px;        \r\n    }\r\n\r\n    // States\r\n    .app-sidebar-panel {\r\n        [data-kt-app-sidebar-panel-static=\"true\"] & {\r\n            position: relative;\r\n        }\r\n\r\n        [data-kt-app-sidebar-panel-offcanvas=\"true\"] & {\r\n            display: none;\r\n        }\r\n\r\n        [data-kt-app-sidebar-panel-fixed=\"true\"] & {\r\n            @include property( z-index, $app-sidebar-panel-fixed-z-index);\r\n            position: fixed;\r\n            left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));\r\n            top: 0;\r\n            bottom: 0;\r\n        }  \r\n\r\n        [data-kt-app-sidebar-panel-sticky=\"on\"] & {\r\n            position: fixed;\r\n            left: calc(var(--kt-app-sidebar-width) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px));\r\n            top: 0;\r\n            bottom: 0;\r\n            transition: $app-sidebar-panel-base-transition;\r\n\r\n            box-shadow: var(--kt-app-sidebar-panel-sticky-box-shadow);\r\n            border-left: var(--kt-app-sidebar-panel-sticky-border-start);\r\n            border-right: var(--kt-app-sidebar-panel-sticky-border-end);\r\n\r\n            @include property( z-index, $app-sidebar-panel-sticky-z-index);\r\n            @include property( margin-left, $app-sidebar-panel-sticky-gap-start);\r\n            @include property( margin-right, $app-sidebar-panel-sticky-gap-end);\r\n            @include property( margin-top, $app-sidebar-panel-sticky-gap-top);\r\n            @include property( margin-bottom, $app-sidebar-panel-sticky-gap-bottom);\r\n        }\r\n\r\n        [data-kt-app-sidebar-panel-minimize=\"on\"] & {\r\n            transition: $app-sidebar-panel-base-transition;\r\n            background-color: var(--kt-app-sidebar-panel-minimize-bg-color);\r\n            box-shadow: var(--kt-app-sidebar-panel-minimize-box-shadow);\r\n            border-left: var(--kt-app-sidebar-panel-minimize-border-start);\r\n            border-right: var(--kt-app-sidebar-panel-minimize-border-end);\r\n\r\n\r\n            @include property( margin-left, $app-sidebar-panel-minimize-gap-start);\r\n            @include property( margin-right, $app-sidebar-panel-minimize-gap-end);\r\n            @include property( margin-top, $app-sidebar-panel-minimize-gap-top);\r\n            @include property( margin-bottom, $app-sidebar-panel-minimize-gap-bottom);\r\n        }\r\n\r\n        [data-kt-app-sidebar-panel-hoverable=\"true\"] & {\r\n            .app-sidebar-panel-hoverable {\r\n                width: var(--kt-app-sidebar-panel-width-actual); \r\n            }\r\n        }\r\n\r\n        [data-kt-app-sidebar-panel-hoverable=\"true\"][data-kt-app-sidebar-panel-minimize=\"on\"] &:hover:not(.animating) {\r\n            transition: $app-sidebar-panel-base-transition;\r\n\t\t\twidth: var(--kt-app-sidebar-panel-width-actual);\r\n            box-shadow: var(--kt-app-sidebar-panel-minimize-hover-box-shadow);\r\n        }\r\n\r\n        [data-kt-app-sidebar-panel-collapse=\"on\"] & {\r\n            transition: $app-sidebar-panel-base-transition;\r\n            width: var(--kt-app-sidebar-panel-width-actual);\r\n            margin-left: calc( -1 * (var(--kt-app-sidebar-panel-width-actual) + var(--kt-app-sidebar-gap-start, 0px) + var(--kt-app-sidebar-gap-end, 0px)));\r\n        }\r\n    }\r\n\r\n    // Integration\r\n    .app-sidebar-panel {\r\n        // Header\r\n        [data-kt-app-sidebar-panel-fixed=\"true\"][data-kt-app-header-fixed=\"true\"]:not([data-kt-app-sidebar-panel-push-header=\"true\"]) & {\r\n            top: var(--kt-app-header-height);\r\n        }\r\n\r\n        // Toolbar\r\n        [data-kt-app-sidebar-panel-fixed=\"true\"][data-kt-app-header-fixed=\"true\"][data-kt-app-toolbar-fixed=\"true\"]:not([data-kt-app-sidebar-panel-push-toolbar=\"true\"]) & {\r\n            top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0));\r\n        }\r\n    }\r\n\r\n    // Utilities\r\n    [data-kt-app-sidebar-panel-minimize=\"on\"] {\r\n        .app-sidebar-panel-minimize-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-panel-minimize-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n\r\n    [data-kt-app-sidebar-panel-sticky=\"on\"] {\r\n        .app-sidebar-panel-sticky-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-panel-sticky-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }  \r\n\r\n    [data-kt-app-sidebar-panel-collapse=\"on\"] {\r\n        .app-sidebar-panel-collapse-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-panel-collapse-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    // Base\r\n    .app-sidebar-panel {\r\n        display: none;\r\n        width: var(--kt-app-sidebar-panel-width);\r\n        \r\n        background-color: var(--kt-app-sidebar-panel-base-bg-color-mobile);\r\n        box-shadow: var(--kt-app-sidebar-panel-base-box-shadow-mobile);\r\n        border-left: var(--kt-app-sidebar-panel-base-border-start-mobile);\r\n        border-right: var(--kt-app-sidebar-panel-base-border-end-mobile);\r\n\r\n        @include property( z-index, $app-sidebar-panel-base-z-index-mobile);\r\n        @include property( margin-left, $app-sidebar-panel-base-gap-start-mobile);\r\n        @include property( margin-right, $app-sidebar-panel-base-gap-end-mobile);\r\n        @include property( margin-top, $app-sidebar-panel-base-gap-top-mobile);\r\n        @include property( margin-bottom, $app-sidebar-panel-base-gap-bottom-mobile);\r\n    }\r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-sidebar-panel-gap-start: #{$app-sidebar-panel-base-gap-start-mobile};\r\n        --kt-app-sidebar-panel-gap-end: #{$app-sidebar-panel-base-gap-end-mobile};\r\n        --kt-app-sidebar-panel-gap-top: #{$app-sidebar-panel-base-gap-top-mobile};\r\n        --kt-app-sidebar-panel-gap-bottom: #{$app-sidebar-panel-base-gap-bottom-mobile};\r\n    }\r\n\r\n    [data-kt-app-sidebar-panel-minimize-mobile=\"on\"] {\r\n        --kt-app-sidebar-panel-width: #{$app-sidebar-panel-minimize-width-mobile};\r\n\r\n        --kt-app-sidebar-panel-gap-start: #{$app-sidebar-panel-minimize-gap-start-mobile};\r\n        --kt-app-sidebar-panel-gap-end: #{$app-sidebar-panel-minimize-gap-end-mobile};\r\n        --kt-app-sidebar-panel-gap-top: #{$app-sidebar-panel-minimize-gap-top-mobile};\r\n        --kt-app-sidebar-panel-gap-bottom: #{$app-sidebar-panel-minimize-gap-bottom-mobile};\r\n    }\r\n\r\n    [data-kt-app-sidebar-panel-collapse-mobile=\"on\"] {\r\n        --kt-app-sidebar-panel-width-actual: #{$app-sidebar-panel-base-width-mobile};\r\n        --kt-app-sidebar-panel-width: 0px;\r\n    }\r\n\r\n    // States\r\n    .app-sidebar-panel {            \r\n        [data-kt-app-sidebar-panel-minimize-mobile=\"on\"] & {\r\n            transition: $app-sidebar-panel-base-transition;\r\n\r\n            background-color: var(--kt-app-sidebar-panel-minimize-bg-color-mobile);\r\n            box-shadow: var(--kt-app-sidebar-panel-minimize-box-shadow-mobile);\r\n            border-left: var(--kt-app-sidebar-panel-minimize-border-start-mobile);\r\n            border-right: var(--kt-app-sidebar-panel-minimize-border-end-mobile);\r\n\r\n            @include property( margin-left, $app-sidebar-panel-minimize-gap-start-mobile);\r\n            @include property( margin-right, $app-sidebar-panel-minimize-gap-end-mobile);\r\n            @include property( margin-top, $app-sidebar-panel-minimize-gap-top-mobile);\r\n            @include property( margin-bottom, $app-sidebar-panel-minimize-gap-bottom-mobile);\r\n        }\r\n\r\n        [data-kt-app-sidebar-panel-hoverable-mobile=\"true\"] & {\r\n            .app-sidebar-panel-hoverable {\r\n                width: var(--kt-app-sidebar-panel-width-actual); \r\n            }\r\n        }\r\n\r\n        [data-kt-app-sidebar-panel-hoverable-mobile=\"true\"][data-kt-app-sidebar-panel-minimize-mobile=\"on\"] &:hover:not(.animating) {\r\n            transition: $app-sidebar-panel-base-transition;\r\n\t\t\twidth: var(--kt-app-sidebar-panel-width-actual);\r\n\r\n            box-shadow: var(--kt-app-sidebar-panel-minimize-hover-box-shadow-mobile);\r\n        }\r\n\r\n        [data-kt-app-sidebar-panel-collapse-mobile=\"on\"] & {\r\n            transition: $app-sidebar-panel-base-transition;\r\n            width: var(--kt-app-sidebar-panel-width-actual);\r\n            margin-left: calc( -1 * var(--kt-app-sidebar-panel-width-actual));\r\n        }\r\n    }\r\n\r\n    // Utilities\r\n    [data-kt-app-sidebar-panel-minimize-mobile=\"on\"] {\r\n        .app-sidebar-panel-minimize-mobile-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-panel-minimize-mobile-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }  \r\n\r\n    [data-kt-app-sidebar-panel-collapse-mobile=\"on\"] {\r\n        .app-sidebar-panel-collapse-mobile-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-sidebar-panel-collapse-mobile-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n}","//\r\n// Aside\r\n//\r\n\r\n// General mode\r\n.app-aside {    \r\n    transition: $app-aside-base-transition;\r\n}\r\n\r\n// Utilities\r\n.app-aside-minimize-d-flex,\r\n.app-aside-sticky-d-flex,\r\n.app-aside-collapse-d-flex,\r\n.app-aside-minimize-mobile-d-flex,\r\n.app-aside-collapse-mobile-d-flex {\r\n    display: none;    \r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    // Base\r\n    .app-aside {        \r\n        display: flex;    \r\n        flex-shrink: 0;\r\n        width: var(--kt-app-aside-width);      \r\n        background-color: var(--kt-app-aside-base-bg-color);\r\n        box-shadow: var(--kt-app-aside-base-box-shadow);\r\n        border-left: var(--kt-app-aside-base-border-left);\r\n        border-right: var(--kt-app-aside-base-border-right);\r\n\r\n        @include property( margin-left, $app-aside-base-gap-start);\r\n        @include property( margin-right, $app-aside-base-gap-end);\r\n        @include property( margin-top, $app-aside-base-gap-top);\r\n        @include property( margin-bottom, $app-aside-base-gap-bottom);\r\n        @include property( z-index, $app-aside-base-z-index);\r\n    }    \r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-aside-width: #{$app-aside-base-width};\r\n        --kt-app-aside-width-actual: #{$app-aside-base-width};\r\n\r\n        --kt-app-aside-gap-start: #{$app-aside-base-gap-start};\r\n        --kt-app-aside-gap-end: #{$app-aside-base-gap-end};\r\n        --kt-app-aside-gap-top: #{$app-aside-base-gap-top};\r\n        --kt-app-aside-gap-bottom: #{$app-aside-base-gap-bottom};\r\n    }\r\n\r\n    [data-kt-app-aside-stacked=\"true\"] {\r\n        --kt-app-aside-width: calc(var(--kt-app-aside-primary-width) + var(--kt-app-aside-secondary-width));\r\n    }\r\n\r\n    [data-kt-app-aside-minimize=\"on\"] {\r\n        --kt-app-aside-width: #{$app-aside-minimize-width};\r\n\r\n        --kt-app-aside-gap-start: #{$app-aside-minimize-gap-start};\r\n        --kt-app-aside-gap-end: #{$app-aside-minimize-gap-end};\r\n        --kt-app-aside-gap-top: #{$app-aside-minimize-gap-top};\r\n        --kt-app-aside-gap-bottom: #{$app-aside-minimize-gap-bottom};\r\n    }\r\n\r\n    [data-kt-app-aside-sticky=\"on\"] {\r\n        --kt-app-aside-width: #{$app-aside-sticky-width};\r\n\r\n        --kt-app-aside-gap-start: #{$app-aside-sticky-gap-start};\r\n        --kt-app-aside-gap-end: #{$app-aside-sticky-gap-end};\r\n        --kt-app-aside-gap-top: #{$app-aside-sticky-gap-top};\r\n        --kt-app-aside-gap-bottom: #{$app-aside-sticky-gap-bottom};\r\n    }    \r\n\r\n    [data-kt-app-aside-collapse=\"on\"] {\r\n        --kt-app-aside-width: 0px;  \r\n    }\r\n\r\n    // States\r\n    .app-aside {\r\n        [data-kt-app-aside-static=\"true\"] & {\r\n            position: relative;\r\n        }\r\n\r\n        [data-kt-app-aside-offcanvas=\"true\"] & {\r\n            display: none;\r\n        }\r\n\r\n        [data-kt-app-aside-fixed=\"true\"] & {\r\n            position: fixed;\r\n            @include property( z-index, $app-aside-fixed-z-index);\r\n            @include property( top, $app-aside-fixed-top);\r\n            @include property( bottom, $app-aside-fixed-bottom);\r\n            @include property( right, $app-aside-fixed-right);\r\n        }  \r\n\r\n        [data-kt-app-aside-stacked=\"true\"] & {\r\n            align-items: stretch; \r\n        }\r\n\r\n        [data-kt-app-aside-sticky=\"on\"] & {\r\n            position: fixed;\r\n            transition: $app-aside-base-transition;\r\n\r\n            box-shadow: var(--kt-app-aside-sticky-box-shadow);\r\n            border-left: var(--kt-aside-sticky-border-start);\r\n            border-right: var(--kt-app-aside-sticky-border-end);\r\n\r\n            @include property( top, $app-aside-sticky-top);\r\n            @include property( bottom, $app-aside-sticky-bottom);\r\n            @include property( left, $app-aside-sticky-left);\r\n            @include property( z-index, $app-aside-sticky-z-index);\r\n            @include property( margin-left, $app-aside-sticky-gap-start);\r\n            @include property( margin-right, $app-aside-sticky-gap-end);\r\n            @include property( margin-top, $app-aside-sticky-gap-top);\r\n            @include property( margin-bottom, $app-aside-sticky-gap-bottom);\r\n        }\r\n\r\n        [data-kt-app-aside-minimize=\"on\"] & {\r\n            transition: $app-aside-base-transition;\r\n\r\n            background-color: var(--kt-app-aside-minimize-bg-color);\r\n            box-shadow: var(--kt-app-aside-minimize-box-shadow);\r\n            border-start: var(--kt-app-aside-minimize-border-start);\r\n            border-end: var(--kt-app-aside-minimize-border-end);\r\n\r\n            @include property( margin-left, $app-aside-minimize-gap-start);\r\n            @include property( margin-right, $app-aside-minimize-gap-end);\r\n            @include property( margin-top, $app-aside-minimize-gap-top);\r\n            @include property( margin-bottom, $app-aside-minimize-gap-bottom);\r\n        }\r\n\r\n        [data-kt-app-aside-hoverable=\"true\"] & {\r\n            .app-aside-wrapper {\r\n                width: var(--kt-app-aside-width-actual); \r\n            }\r\n        }\r\n\r\n        [data-kt-app-aside-hoverable=\"true\"][data-kt-app-aside-minimize=\"on\"] &:hover:not(.animating) {\r\n            transition: $app-aside-base-transition;\r\n\t\t\twidth: var(--kt-app-aside-width-actual);\r\n            box-shadow: var(--kt-app-aside-minimize-hover-box-shadow);\r\n        }\r\n\r\n        [data-kt-app-aside-collapse=\"on\"] & {\r\n            transition: $app-aside-base-transition;\r\n            width: var(--kt-app-aside-width-actual);\r\n            margin-right: calc( -1 * var(--kt-app-aside-width-actual));\r\n        }\r\n    }\r\n\r\n    // Utilities\r\n    [data-kt-app-aside-minimize=\"on\"] {\r\n        .app-aside-minimize-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-aside-minimize-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n\r\n    [data-kt-app-aside-sticky=\"on\"] {\r\n        .app-aside-sticky-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-aside-sticky-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    } \r\n\r\n    [data-kt-app-aside-collapse=\"on\"] {\r\n        .app-aside-collapse-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-aside-collapse-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n\r\n    // Integration\r\n    .app-aside {\r\n        // Header\r\n        [data-kt-app-aside-fixed=\"true\"][data-kt-app-header-fixed=\"true\"]:not([data-kt-app-aside-push-header=\"true\"]) & {\r\n            top: var(--kt-app-header-height);\r\n        }\r\n\r\n        // Toolbar\r\n        [data-kt-app-aside-fixed=\"true\"][data-kt-app-header-fixed=\"true\"][data-kt-app-toolbar-fixed=\"true\"]:not([data-kt-app-aside-push-toolbar=\"true\"]) & {\r\n            top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height, 0px));\r\n        }\r\n    }\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    // Base\r\n    .app-aside {\r\n        display: none;\r\n        width: var(--kt-app-aside-width);\r\n        @include property( z-index, $app-aside-base-z-index-mobile);\r\n\r\n        background-color: var(--kt-app-aside-base-bg-color-mobile);\r\n        box-shadow: var(--kt-app-aside-base-box-shadow-mobile);\r\n        border-left: var(--kt-app-aside-base-border-start-mobile);\r\n        order-right: var(--kt-app-aside-base-border-end-mobile);\r\n\r\n        @include property( margin-left, $app-aside-base-gap-start-mobile);\r\n        @include property( margin-right, $app-aside-base-gap-end-mobile);\r\n        @include property( margin-top, $app-aside-base-gap-top-mobile);\r\n        @include property( margin-bottom, $app-aside-base-gap-bottom-mobile);\r\n    }\r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-aside-width: #{$app-aside-base-width-mobile};\r\n        --kt-app-aside-width-actual: #{$app-aside-base-width-mobile};\r\n\r\n        --kt-app-aside-gap-start: #{$app-aside-base-gap-start-mobile};\r\n        --kt-app-aside-gap-end: #{$app-aside-base-gap-end-mobile};\r\n        --kt-app-aside-gap-top: #{$app-aside-base-gap-top-mobile};\r\n        --kt-app-aside-gap-bottom: #{$app-aside-base-gap-bottom-mobile};\r\n    }\r\n\r\n    [data-kt-app-aside-minimize-mobile=\"on\"] {\r\n        --kt-app-aside-width: #{$app-aside-minimize-width-mobile};\r\n\r\n        --kt-app-aside-gap-start: #{$app-aside-minimize-gap-start-mobile};\r\n        --kt-app-aside-gap-end: #{$app-aside-minimize-gap-end-mobile};\r\n        --kt-app-aside-gap-top: #{$app-aside-minimize-gap-top-mobile};\r\n        --kt-app-aside-gap-bottom: #{$app-aside-minimize-gap-bottom-mobile};\r\n    }\r\n\r\n    [data-kt-app-aside-collapse-mobile=\"on\"] {\r\n        --kt-app-aside-width: 0px;\r\n    }\r\n\r\n    // States\r\n    .app-aside {\r\n        [data-kt-app-aside-stacked=\"true\"] & {\r\n            align-items: stretch; \r\n        }\r\n            \r\n        [data-kt-app-aside-minimize-mobile=\"on\"] & {\r\n            transition: $app-aside-base-transition;\r\n            background-color: var(--kt-app-aside-minimize-bg-color-mobile);\r\n            box-shadow: var(--kt-app-aside-minimize-box-shadow-mobile);\r\n            border-left: var(--kt-app-aside-minimize-border-start-mobile);\r\n            border-right: var(--kt-app-aside-minimize-border-end-mobile);\r\n        \r\n            @include property( margin-left, $app-aside-minimize-gap-start-mobile);\r\n            @include property( margin-right, $app-aside-minimize-gap-end-mobile);\r\n            @include property( margin-top, $app-aside-minimize-gap-top-mobile);\r\n            @include property( margin-bottom, $app-aside-minimize-gap-bottom-mobile);\r\n        }\r\n\r\n        [data-kt-app-aside-hoverable-mobile=\"true\"] & {\r\n            .app-aside-wrapper {\r\n                width: var(--kt-app-aside-width-actual); \r\n            }\r\n        }\r\n\r\n        [data-kt-app-aside-hoverable-mobile=\"true\"][data-kt-app-aside-minimize-mobile=\"on\"] &:hover:not(.animating) {\r\n            transition: $app-aside-base-transition;\r\n\t\t\twidth: var(--kt-app-aside-width-actual);\r\n            box-shadow: var(--kt-app-aside-minimize-hover-box-shadow-mobile);\r\n        }\r\n\r\n        [data-kt-app-aside-collapse-mobile=\"on\"] & {\r\n            transition: $app-aside-base-transition;\r\n            width: var(--kt-app-aside-width-actual);\r\n            margin-right: calc( -1 * var(--kt-app-aside-width-actual));\r\n        }\r\n    }\r\n\r\n    // Utilities\r\n    [data-kt-app-aside-minimize-mobile=\"on\"] {\r\n        .app-aside-minimize-mobile-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-aside-minimize-mobile-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n\r\n    [data-kt-app-aside-collapse-mobile=\"on\"] {\r\n        .app-aside-collapse-mobile-d-none {\r\n            display: none !important;    \r\n        }\r\n\r\n        .app-aside-collapse-mobile-d-flex {\r\n            display: flex !important;    \r\n        }\r\n    }\r\n}","//\r\n// Wrapper\r\n//\r\n\r\n// General mode\r\n.app-wrapper {\r\n    display: flex;\r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    // Integration\r\n    .app-wrapper {\r\n        transition: $app-wrapper-transition;\r\n        \r\n        // Header\r\n        [data-kt-app-header-sticky=\"on\"] & {\r\n            margin-top: var(--kt-app-header-height-actual);\r\n        }\r\n\r\n        [data-kt-app-header-fixed=\"true\"] & {\r\n            margin-top: var(--kt-app-header-height);\r\n        }\r\n\r\n        // Toolbar\r\n        [data-kt-app-toolbar-sticky=\"on\"] & {\r\n            margin-top: var(--kt-app-toolbar-height);\r\n        }\r\n\r\n        [data-kt-app-header-fixed=\"true\"][data-kt-app-toolbar-sticky=\"on\"] & {\r\n            margin-top: calc(var(--kt-app-header-height-actual) + var(--kt-app-toolbar-height-actual));\r\n        }\r\n\r\n        [data-kt-app-header-fixed=\"true\"][data-kt-app-toolbar-fixed=\"true\"] & {\r\n            margin-top: calc(var(--kt-app-header-height) + var(--kt-app-toolbar-height));\r\n        }\r\n\r\n        // Sidebar\r\n        [data-kt-app-sidebar-fixed=\"true\"] & {\r\n            margin-left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px)\r\n            );\r\n        }\r\n\r\n        // Sidebar Panel\r\n        [data-kt-app-sidebar-panel-fixed=\"true\"] & {\r\n            margin-left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px) +\r\n                var(--kt-app-sidebar-panel-width) + \r\n                var(--kt-app-sidebar-panel-gap-start, 0px) + \r\n                var(--kt-app-sidebar-panel-gap-end, 0px)\r\n            );\r\n        }\r\n\r\n        // Aside\r\n        [data-kt-app-aside-fixed=\"true\"] & {\r\n            margin-right: calc(\r\n                var(--kt-app-aside-width) + \r\n                var(--kt-app-aside-gap-start, 0px) + \r\n                var(--kt-app-aside-gap-end, 0px)\r\n            );\r\n        }\r\n\r\n        // Footer\r\n        [data-kt-app-footer-fixed=\"true\"] & {\r\n            margin-bottom: var(--kt-app-footer-height);\r\n        }  \r\n    }\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    // Integration\r\n    .app-wrapper {\r\n        transition: $app-wrapper-transition;\r\n        \r\n        // Header\r\n        [data-kt-app-header-sticky=\"on\"] & {\r\n            margin-top: var(--kt-app-header-height-actual);\r\n        }\r\n\r\n        [data-kt-app-header-fixed-mobile=\"true\"] & {\r\n            margin-top: var(--kt-app-header-height);\r\n        }\r\n\r\n        // Toolbar\r\n        [data-kt-app-header-fixed-mobile=\"true\"][data-kt-app-toolbar-sticky=\"on\"] & {\r\n            margin-top: calc(var(--kt-app-header-height-actual) + var(--kt-app-toolbar-height-actual));\r\n        }\r\n\r\n        // Footer\r\n        [data-kt-app-footer-fixed-mobile=\"true\"] & {\r\n            margin-bottom: var(--kt-app-footer-height);\r\n        }  \r\n    }\r\n}","//\r\n// Main\r\n//\r\n\r\n// General mode\r\n.app-main {\r\n    display: flex;\r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    // Base\r\n    .app-main {\r\n        transition: $app-main-transition;\r\n\r\n        @include property( padding-left, $app-main-padding-x );\r\n        @include property( padding-right, $app-main-padding-x );\r\n        @include property( padding-top, $app-main-padding-y );\r\n        @include property( padding-bottom, $app-main-padding-y );\r\n\r\n        @include property( margin-left, $app-main-margin-x );\r\n        @include property( margin-right, $app-main-margin-x );\r\n        @include property( margin-top, $app-main-margin-y );\r\n        @include property( margin-bottom, $app-main-margin-y );\r\n    }\r\n\r\n    // Integration\r\n    .app-main {\r\n        // Sidebar\r\n        [data-kt-app-sidebar-sticky=\"true\"] & {\r\n            margin-left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px)\r\n            );\r\n        }\r\n\r\n        // Sidebar Panel\r\n        [data-kt-app-sidebar-panel-sticky=\"true\"] & {\r\n            margin-left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px) + \r\n                var(--kt-app-sidebar-panel-width) + \r\n                var(--kt-app-sidebar-panel-gap-start, 0px) + \r\n                var(--kt-app-sidebar-panel-gap-end, 0px)\r\n            );\r\n        }\r\n\r\n        // Aside\r\n        [data-kt-app-aside-sticky=\"true\"] & {\r\n            margin-right: calc(\r\n                var(--kt-app-aside-width) + \r\n                var(--kt-app-aside-gap-start, 0px) + \r\n                var(--kt-app-aside-gap-end, 0px)\r\n            );\r\n        }\r\n    }\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n\t// Base\r\n    .app-main {\r\n        @include property( padding-left, $app-main-padding-x-mobile );\r\n        @include property( padding-right, $app-main-padding-x-mobile );\r\n        @include property( padding-top, $app-main-padding-y-mobile );\r\n        @include property( padding-bottom, $app-main-padding-y-mobile );\r\n\r\n        @include property( margin-left, $app-main-margin-x-mobile );\r\n        @include property( margin-right, $app-main-margin-x-mobile );\r\n        @include property( margin-top, $app-main-margin-y-mobile );\r\n        @include property( margin-bottom, $app-main-margin-y-mobile );\r\n    }\r\n}","//\r\n// Content\r\n//\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n\t.app-content {\r\n\t\tpadding-top: $app-content-padding-y;\r\n        padding-bottom: $app-content-padding-y;\r\n        padding-left: $app-content-padding-x;\r\n        padding-right: $app-content-padding-x;\r\n\t}\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n\t.app-content { \r\n\t\tmax-width: none;\r\n\t\tpadding-top: $app-content-padding-y-mobile;\r\n        padding-bottom: $app-content-padding-y-mobile;\r\n        padding-left: $app-content-padding-x-mobile;\r\n        padding-right: $app-content-padding-x-mobile;\r\n\t}\r\n}","//\r\n// Footer\r\n//\r\n\r\n// General mode\r\n.app-footer {\r\n    transition: $app-footer-transition;\r\n    display: flex;\r\n    align-items: stretch;\r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    // Base\r\n    .app-footer {\r\n        @include property( z-index, $app-footer-z-index);\r\n\r\n        background-color: var(--kt-app-footer-bg-color); \r\n        box-shadow: var(--kt-app-footer-box-shadow); \r\n        border-top: var(--kt-app-footer-border-top); \r\n    }    \r\n\r\n    // Vars\r\n    :root {\r\n        --kt-app-footer-height: #{$app-footer-height};\r\n    }\r\n\r\n    // States\r\n    .app-footer {\r\n        height: var(--kt-app-footer-height);\r\n\r\n        [data-kt-app-footer-fixed=\"true\"] & {        \r\n            @include property( z-index, $app-footer-fixed-z-index);   \r\n            position: fixed;\r\n            left: 0;\r\n            right: 0;\r\n            bottom: 0;\r\n        }\r\n    }\r\n\r\n    // Integration\r\n    .app-footer {\r\n        // Sidebar\r\n        [data-kt-app-sidebar-fixed=\"true\"][data-kt-app-sidebar-push-footer=\"true\"] & {\r\n            left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px)\r\n            );\r\n        }   \r\n\r\n        // Sidebar Panel\r\n        [data-kt-app-sidebar-panel-fixed=\"true\"][data-kt-app-sidebar-panel-push-footer=\"true\"] & {\r\n            left: calc(\r\n                var(--kt-app-sidebar-width) + \r\n                var(--kt-app-sidebar-gap-start, 0px) + \r\n                var(--kt-app-sidebar-gap-end, 0px) +\r\n                var(--kt-app-sidebar-panel-width) + \r\n                var(--kt-app-sidebar-panel-gap-start, 0px) + \r\n                var(--kt-app-sidebar-panel-gap-end, 0px)\r\n            );\r\n        }\r\n\r\n        // Aside\r\n        [data-kt-app-aside-fixed=\"true\"][data-kt-app-aside-push-footer=\"true\"] & {\r\n            right: calc(\r\n                var(--kt-app-aside-width) + \r\n                var(--kt-app-aside-gap-start, 0px) + \r\n                var(--kt-app-aside-gap-end, 0px)\r\n            );\r\n        }\r\n    } \r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    // Base\r\n    .app-footer {\r\n        @include property( z-index, $app-footer-z-index-mobile);\r\n\r\n        background-color: var(--kt-app-footer-bg-color-mobile); \r\n        box-shadow: var(--kt-app-footer-box-shadow-mobile); \r\n        border-top: var(--kt-app-footer-border-top-mobile); \r\n    }\r\n\r\n    // Vars\r\n    body {\r\n        --kt-app-footer-height: #{$app-footer-height-mobile};\r\n    }\r\n\r\n    // States\r\n    .app-footer {\r\n        height: var(--kt-app-footer-height);\r\n\r\n        [data-kt-app-footer-fixed-mobile=\"true\"] & {\r\n            @include property( z-index, $app-footer-fixed-z-index-mobile);\r\n            position: fixed;\r\n            left: 0;\r\n            right: 0;\r\n            bottom: 0;            \r\n        }\r\n    }\r\n}","//\r\n// Layout builder\r\n//\r\n\r\n// General mode\r\n.app-layout-builder-toggle {\r\n    position: fixed;\r\n    z-index: $app-layout-builder-toggle-z-index;\r\n    bottom: $app-layout-builder-toggle-bottom;\r\n    right: $app-layout-builder-toggle-end;\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n\t.app-layout-builder-toggle { \r\n\t\tbottom: $app-layout-builder-toggle-bottom-mobile;\r\n        right: $app-layout-builder-toggle-end-mobile;\r\n\t}\r\n}","//\r\n// Theme Mode\r\n//\r\n\r\n@mixin theme-light() {\r\n\thtml:not([data-theme=\"dark\"]) {\r\n\t\t@content;\r\n\t}\r\n}\r\n\r\n@mixin theme-dark() {\r\n\t[data-theme=\"dark\"] {\r\n\t\t@content;\r\n\t}\r\n}","//\r\n// Root\r\n//\r\n\r\n// Light mode\r\n@include theme-light() {\r\n    // Reboot\r\n    --kt-app-bg-color: #{$app-bg-color};\r\n    --kt-app-blank-bg-color: #{$app-blank-bg-color};\r\n\r\n    // Header base\r\n    --kt-app-header-base-bg-color: #{$app-header-base-bg-color};\r\n    --kt-app-header-base-bg-color-mobile: #{$app-header-base-bg-color-mobile};\r\n    --kt-app-header-base-box-shadow: #{$app-header-base-box-shadow};\r\n    --kt-app-header-base-box-shadow-mobile: #{$app-header-base-box-shadow-mobile};\r\n    --kt-app-header-base-menu-link-bg-color-active: #{$app-header-base-menu-link-bg-color-active};\r\n\r\n    // Header light\r\n    --kt-app-header-light-separator-color: #{$app-header-light-separator-color};\r\n\r\n    // Sidebar base\r\n    --kt-app-sidebar-base-toggle-btn-box-shadow: #{$app-sidebar-base-toggle-btn-box-shadow};\r\n    --kt-app-sidebar-base-toggle-btn-bg-color: #{$app-sidebar-base-toggle-btn-bg-color};\r\n\r\n    // Sidebar light\r\n    --kt-app-sidebar-light-bg-color: #{$app-sidebar-light-bg-color};\r\n    --kt-app-sidebar-light-box-shadow: #{$app-sidebar-light-box-shadow};\r\n    --kt-app-sidebar-light-separator-color: #{$app-sidebar-light-separator-color};\r\n    --kt-app-sidebar-light-scrollbar-color: #{$app-sidebar-light-scrollbar-color};\r\n    --kt-app-sidebar-light-scrollbar-color-hover: #{$app-sidebar-light-scrollbar-color-hover};\r\n    --kt-app-sidebar-light-menu-heading-color: #{$app-sidebar-light-menu-heading-color};\r\n    --kt-app-sidebar-light-menu-link-bg-color-active: #{$app-sidebar-light-menu-link-bg-color-active};\r\n    --kt-app-sidebar-light-header-menu-link-bg-color-active: #{$app-sidebar-light-header-menu-link-bg-color-active};\r\n \r\n    // Toolbar base\r\n    --kt-app-toolbar-base-bg-color: #{$app-toolbar-base-bg-color};\r\n    --kt-app-toolbar-base-bg-color-mobile: #{$app-toolbar-base-bg-color-mobile};\r\n    --kt-app-toolbar-base-box-shadow: #{$app-toolbar-base-box-shadow};\r\n    --kt-app-toolbar-base-box-shadow-mobile: #{$app-toolbar-base-box-shadow-mobile};\r\n    --kt-app-toolbar-base-border-top: #{$app-toolbar-base-border-top};\r\n    --kt-app-toolbar-base-border-top-mobile: #{$app-toolbar-base-border-top-mobile};\r\n\r\n    // Footer\r\n    --kt-app-footer-bg-color: #{$app-footer-bg-color};\r\n    --kt-app-footer-bg-color-mobile: #{$app-footer-bg-color-mobile};\r\n}\r\n\r\n// Dark mode\r\n@include theme-dark() {\r\n\t// Reboot\r\n    --kt-app-bg-color: #{$app-bg-color-dark};\r\n    --kt-app-blank-bg-color: #{$app-blank-bg-color-dark};\r\n\r\n    // Header base\r\n    --kt-app-header-base-bg-color: #{$app-header-base-bg-color-dark};\r\n    --kt-app-header-base-bg-color-mobile: #{$app-header-base-bg-color-mobile-dark};\r\n    --kt-app-header-base-box-shadow: #{$app-header-base-box-shadow-dark};\r\n    --kt-app-header-base-box-shadow-mobile: #{$app-header-base-box-shadow-mobile-dark};\r\n    --kt-app-header-base-menu-link-bg-color-active: #{$app-header-base-menu-link-bg-color-active-dark};\r\n\r\n    // Header light\r\n    --kt-app-header-light-separator-color: #{$app-header-light-separator-color-dark};\r\n\r\n    // Sidebar base\r\n    --kt-app-sidebar-base-toggle-btn-box-shadow: #{$app-sidebar-base-toggle-btn-box-shadow-dark};\r\n    --kt-app-sidebar-base-toggle-btn-bg-color: #{$app-sidebar-base-toggle-btn-bg-color-dark};\r\n\r\n    // Sidebar light\r\n    --kt-app-sidebar-light-bg-color: #{$app-sidebar-light-bg-color-dark};\r\n    --kt-app-sidebar-light-box-shadow: #{$app-sidebar-light-box-shadow-dark};\r\n    --kt-app-sidebar-light-separator-color: #{$app-sidebar-light-separator-color-dark};\r\n    --kt-app-sidebar-light-scrollbar-color: #{$app-sidebar-light-scrollbar-color-dark};\r\n    --kt-app-sidebar-light-scrollbar-color-hover: #{$app-sidebar-light-scrollbar-color-hover-dark};\r\n    --kt-app-sidebar-light-menu-heading-color: #{$app-sidebar-light-menu-heading-color-dark};\r\n    --kt-app-sidebar-light-menu-link-bg-color-active: #{$app-sidebar-light-menu-link-bg-color-active-dark};\r\n    --kt-app-sidebar-light-header-menu-link-bg-color-active: #{$app-sidebar-light-header-menu-link-bg-color-active-dark};\r\n \r\n    // Toolbar base\r\n    --kt-app-toolbar-base-bg-color: #{$app-toolbar-base-bg-color-dark};\r\n    --kt-app-toolbar-base-bg-color-mobile: #{$app-toolbar-base-bg-color-mobile-dark};\r\n    --kt-app-toolbar-base-box-shadow: #{$app-toolbar-base-box-shadow-dark};\r\n    --kt-app-toolbar-base-box-shadow-mobile: #{$app-toolbar-base-box-shadow-mobile-dark};\r\n    --kt-app-toolbar-base-border-top: #{$app-toolbar-base-border-top-dark};\r\n    --kt-app-toolbar-base-border-top-mobile: #{$app-toolbar-base-border-top-mobile-dark};\r\n\r\n    // Footer\r\n    --kt-app-footer-bg-color: #{$app-footer-bg-color-dark};\r\n    --kt-app-footer-bg-color-mobile: #{$app-footer-bg-color-mobile-dark};\r\n}\r\n","//\r\n// Sidebar\r\n//\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    .app-sidebar-toggle {\r\n        box-shadow: var(--kt-app-sidebar-base-toggle-btn-box-shadow) !important; \r\n        background-color: var(--kt-app-sidebar-base-toggle-btn-bg-color) !important; \r\n\r\n        .active .svg-icon {\r\n            transform: rotateZ(0deg) !important;\r\n        }        \r\n    }\r\n\r\n    [dir=\"rtl\"] {\r\n        .app-sidebar-toggle {\r\n            .svg-icon {\r\n                transform: rotateZ(180deg);\r\n            }\r\n\r\n            &.active .svg-icon {\r\n                transform: rotateZ(0deg) !important;\r\n            }\r\n        }\r\n    }\r\n        \r\n    .app-sidebar-logo {\r\n        height: var(--kt-app-header-height); \r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;        \r\n        position: relative;\r\n        flex-shrink: 0;\r\n    }\r\n        \r\n    .app-sidebar-menu {\r\n        .menu  {\r\n            & > .menu-item {\r\n                margin-left: 0.115rem;  \r\n            }    \r\n        }    \r\n    }\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    .app-sidebar-logo {\r\n        display: none;\r\n    }\r\n}","//\r\n// Sidebar Minimize\r\n//\r\n\r\n.app-sidebar-logo-minimize {\r\n    display: none;\r\n}\r\n\r\n// Sidebar footer\r\n.app-sidebar-footer {\r\n    .btn-custom {\r\n        .btn-icon {\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n    \r\n// Desktop sidebar minimize mode\r\n@include app-layout-minimize(app-sidebar) {\r\n    .app-sidebar-logo {\r\n        .app-sidebar-logo-default {\r\n            display: none;\r\n        }\r\n\r\n        .app-sidebar-logo-minimize {\r\n            display: inline-block;\r\n        }\r\n    }\r\n\r\n    .app-sidebar-wrapper {\r\n        width: var(--kt-app-sidebar-width-actual); \r\n    }\r\n\r\n    .app-sidebar-menu {\r\n        .menu-content,\r\n        .menu-title {\r\n            opacity: 0;\r\n            @include app-layout-transition(opacity);\r\n        }\r\n\r\n        .menu-item.show > .menu-sub {\r\n            height: 0;\r\n            overflow: hidden;\r\n            @include app-layout-transition(height);\r\n        }\r\n    }\r\n\r\n    .app-sidebar-footer {\r\n        .btn-custom {\r\n            padding-left: 0 !important;\r\n            padding-right: 0 !important;\r\n\r\n            .btn-label {\r\n                width: 0;\r\n                display: none;\r\n            }\t\r\n\r\n            .btn-icon {\r\n                width: auto;\r\n                display: block;\r\n            }\r\n        }\r\n    }\r\n}","//\r\n// Layout Transition Mixin\r\n//\r\n\r\n@mixin app-layout-transition($properties: all) {\r\n    transition: $properties $app-general-transition-duration $app-general-transition-timing !important;    \r\n}","//\r\n// Dark Sidebar(used by Dark Sidebar layout only)\r\n//\r\n\r\n[data-kt-app-layout=\"dark-sidebar\"] {\r\n    .app-sidebar {\r\n        background-color: $app-sidebar-dark-bg-color;\r\n        border-right: 0 !important;\r\n\r\n        .hover-scroll-overlay-y {        \r\n            @include scrollbar-color($app-sidebar-dark-scrollbar-color, $app-sidebar-dark-scrollbar-color-hover);\r\n        }\r\n\r\n        .app-sidebar-logo {\r\n            border-bottom: 1px dashed $app-sidebar-dark-separator-color;\r\n        }\r\n\r\n        .btn-custom {\r\n            @include button-custom-variant(\r\n                $color:#B5B5C3, \r\n                $icon-color: #B5B5C3, \r\n                $border-color: null, \r\n                $bg-color: rgba(63, 66, 84, 0.35), \r\n                $color-active: #B5B5C3, \r\n                $icon-color-active: null, \r\n                $border-color-active: null, \r\n                $bg-color-active: rgba(63, 66, 84, 0.35)\r\n            );\r\n        }\r\n\r\n        .menu {\r\n            .menu-item {                    \r\n                .menu-heading {\r\n                    color: $app-sidebar-dark-menu-heading-color !important;\r\n                }\r\n\r\n                @include menu-link-default-state( \r\n                    $title-color: #9D9DA6, \r\n                    $icon-color:#C5C5D8, \r\n                    $bullet-color:#787887, \r\n                    $arrow-color: #787887, \r\n                    $bg-color: null  \r\n                );\r\n                \r\n                @include menu-link-hover-state( \r\n                    $title-color: var(--kt-primary-inverse), \r\n                    $icon-color: var(--kt-primary-inverse), \r\n                    $bullet-color: var(--kt-primary-inverse), \r\n                    $arrow-color: var(--kt-primary-inverse), \r\n                    $bg-color: null\r\n                );\r\n                \r\n                @include menu-link-here-state( \r\n                    $title-color: var(--kt-primary-inverse), \r\n                    $icon-color: var(--kt-primary-inverse), \r\n                    $bullet-color: var(--kt-primary-inverse), \r\n                    $arrow-color: var(--kt-primary-inverse), \r\n                    $bg-color: null\r\n                );\r\n                \r\n                @include menu-link-show-state( \r\n                    $title-color: var(--kt-primary-inverse), \r\n                    $icon-color: var(--kt-primary-inverse), \r\n                    $bullet-color: var(--kt-primary-inverse), \r\n                    $arrow-color: var(--kt-primary-inverse), \r\n                    $bg-color: null\r\n                );\r\n                \r\n                @include menu-link-active-state( \r\n                    $title-color: var(--kt-primary-inverse), \r\n                    $icon-color: var(--kt-primary-inverse), \r\n                    $bullet-color: var(--kt-primary-inverse), \r\n                    $arrow-color: var(--kt-primary-inverse), \r\n                    $bg-color: $app-sidebar-dark-menu-link-bg-color-active\r\n                );\r\n            }\r\n        }\r\n    } \r\n}","//\r\n// Light Sidebar(used by Light Sidebar layout only)\r\n//\r\n\r\n[data-kt-app-layout=\"light-sidebar\"] {\r\n    .app-sidebar {\r\n        background-color: var(--kt-app-sidebar-light-bg-color);\r\n        border-right: 0 !important;\r\n\r\n        .hover-scroll-overlay-y {        \r\n            @include scrollbar-color(var(--kt-app-sidebar-light-scrollbar-color), var(--kt-app-sidebar-light-scrollbar-color-hover));\r\n        }\r\n\r\n        .app-sidebar-logo {\r\n            border-bottom: 1px solid var(--kt-app-sidebar-light-separator-color);\r\n        }\r\n\r\n        .menu {\r\n            font-weight: $font-weight-semibold;\r\n\r\n            .menu-item {                    \r\n                .menu-heading {\r\n                    color: var(--kt-app-sidebar-light-menu-heading-color) !important;\r\n                }\r\n\r\n                @include menu-link-default-state( \r\n                    $title-color: var(--kt-gray-700), \r\n                    $icon-color: var(--kt-gray-500), \r\n                    $bullet-color: var(--kt-gray-500), \r\n                    $arrow-color: var(--kt-gray-500),\r\n                    $bg-color: null  \r\n                );\r\n                \r\n                @include menu-link-hover-state( \r\n                    $title-color: var(--kt-gray-900), \r\n                    $icon-color: var(--kt-gray-700), \r\n                    $bullet-color: var(--kt-gray-700), \r\n                    $arrow-color: var(--kt-gray-700), \r\n                    $bg-color: null\r\n                );\r\n                \r\n                @include menu-link-show-state( \r\n                    $title-color: var(--kt-gray-900), \r\n                    $icon-color: var(--kt-gray-700), \r\n                    $bullet-color: var(--kt-gray-700), \r\n                    $arrow-color: var(--kt-gray-700), \r\n                    $bg-color: null\r\n                );\r\n                \r\n                @include menu-link-here-state( \r\n                    $title-color: var(--kt-gray-900), \r\n                    $icon-color: var(--kt-gray-700), \r\n                    $bullet-color: var(--kt-gray-700), \r\n                    $arrow-color: var(--kt-gray-700), \r\n                    $bg-color: null\r\n                );\r\n\r\n                @include menu-link-active-state( \r\n                    $title-color: var(--kt-primary), \r\n                    $icon-color: var(--kt-primary), \r\n                    $bullet-color: var(--kt-primary), \r\n                    $arrow-color: var(--kt-primary), \r\n                    $bg-color: var(--kt-app-sidebar-light-menu-link-bg-color-active)\r\n                );\r\n            }\r\n        }\r\n    } \r\n}\r\n\r\n[data-kt-app-layout=\"light-sidebar\"][data-kt-app-header-fixed=\"true\"] {\r\n    .app-sidebar {\r\n        .app-sidebar-logo {\r\n            border-bottom: 1px dashed var(--kt-app-sidebar-light-separator-color);\r\n        }\r\n    }\r\n}","//\r\n// Header\r\n//\r\n\r\n// General mode\r\n.app-header-menu {\r\n    .menu {\r\n        .menu-item {\r\n            @include menu-link-default-state( \r\n                $title-color: var(--kt-gray-700), \r\n                $icon-color: var(--kt-gray-500), \r\n                $bullet-color: var(--kt-gray-500), \r\n                $arrow-color: var(--kt-gray-500),\r\n                $bg-color: null,\r\n            );\r\n            \r\n            @include menu-link-hover-state( \r\n                $title-color: var(--kt-primary), \r\n                $icon-color: var(--kt-primary), \r\n                $bullet-color: var(--kt-primary), \r\n                $arrow-color: var(--kt-primary), \r\n                $bg-color: var(--kt-menu-link-bg-color-active)\r\n            );\r\n            \r\n            @include menu-link-show-state( \r\n                $title-color: var(--kt-primary), \r\n                $icon-color: var(--kt-primary), \r\n                $bullet-color: var(--kt-primary), \r\n                $arrow-color: var(--kt-primary), \r\n                $bg-color: null,\r\n            );\r\n\r\n            @include menu-link-here-state( \r\n                $title-color: var(--kt-primary), \r\n                $icon-color: var(--kt-primary),\r\n                $bullet-color: var(--kt-primary), \r\n                $arrow-color: var(--kt-primary),\r\n                $bg-color: var(--kt-menu-link-bg-color-active)\r\n            );\r\n\r\n            @include menu-link-active-state( \r\n                $title-color: var(--kt-primary), \r\n                $icon-color: var(--kt-primary), \r\n                $bullet-color: var(--kt-primary), \r\n                $arrow-color: var(--kt-primary), \r\n                $bg-color: var(--kt-menu-link-bg-color-active)\r\n            );                \r\n        }\r\n    }\r\n\r\n    .menu-extended {\r\n        --kt-menu-link-bg-color-active: rgba(var(--kt-gray-100-rgb), 0.7);\r\n        --kt-menu-link-bg-color-hover: rgba(var(--kt-gray-100-rgb), 0.7);\r\n        \r\n\r\n        .menu-custom-icon {\r\n            background-color: var(--kt-gray-100);    \r\n        }\r\n\r\n        .menu-link {\r\n            &.active,\r\n            &:hover {\r\n                .menu-custom-icon {\r\n                    background-color: var(--kt-gray-200);    \r\n                }\r\n            }    \r\n        }\r\n    }\r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    .app-header-menu {\r\n        .menu {\r\n            // Menu root item\r\n            > .menu-item {\r\n                margin-right: 0.5rem;\r\n\r\n                > .menu-link {\r\n                    padding-top: 0.775rem;\r\n                    padding-bottom: 0.775rem;    \r\n                    font-weight: $font-weight-semibold;\r\n                }\r\n\r\n                @include menu-link-here-state( \r\n                    $title-color: var(--kt-primary), \r\n                    $icon-color: var(--kt-primary), \r\n                    $bullet-color: var(--kt-primary), \r\n                    $arrow-color: var(--kt-primary), \r\n                    $bg-color: var(--kt-app-header-base-menu-link-bg-color-active)\r\n                );\r\n            }\r\n        }\r\n    } \r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n\t.app-header { \r\n\t\t.page-title {\r\n            display: none !important;    \r\n        }\r\n\t}\r\n}","//\r\n// Dark Header(used by Dark Header layout only)\r\n//\r\n\r\n[data-kt-app-layout=\"dark-header\"] {\r\n    .app-header {\r\n        background-color: $app-header-dark-bg-color;\r\n        border-bottom: 0 !important;\r\n\r\n        .btn-custom {\r\n            @include button-custom-variant(\r\n                $color:#B5B5C3, \r\n                $icon-color: #B5B5C3, \r\n                $border-color: null, \r\n                $bg-color: null, \r\n                $color-active: #B5B5C3, \r\n                $icon-color-active: var(--kt-primary), \r\n                $border-color-active: null, \r\n                $bg-color-active: rgba(63, 66, 84, 0.35)\r\n            );\r\n        }\r\n    }\r\n\r\n    // Desktop mode\r\n    @include media-breakpoint-up(lg) {\r\n        // General mode\r\n        .app-header-menu {\r\n            .menu {                  \r\n                // Menu root links          \r\n                > .menu-item {\r\n                    @include menu-link-default-state( \r\n                        $title-color: #9D9DA6, \r\n                        $icon-color:#C5C5D8, \r\n                        $bullet-color:#787887, \r\n                        $arrow-color: #787887, \r\n                        $bg-color: null,\r\n                        $all-links: false\r\n                    );\r\n\r\n                    @include menu-link-hover-state( \r\n                        $title-color: var(--kt-primary-inverse), \r\n                        $icon-color: var(--kt-primary-inverse), \r\n                        $bullet-color: var(--kt-primary-inverse), \r\n                        $arrow-color: var(--kt-primary-inverse), \r\n                        $bg-color: $app-sidebar-dark-menu-link-bg-color-active,\r\n                        $all-links: false\r\n                    );\r\n\r\n                    @include menu-link-show-state( \r\n                        $title-color: var(--kt-primary-inverse), \r\n                        $icon-color: var(--kt-primary-inverse), \r\n                        $bullet-color: var(--kt-primary-inverse), \r\n                        $arrow-color: var(--kt-primary-inverse), \r\n                        $bg-color: null,\r\n                        $all-links: false\r\n                    );\r\n\r\n                    @include menu-link-here-state( \r\n                        $title-color: var(--kt-primary-inverse), \r\n                        $icon-color: var(--kt-primary-inverse), \r\n                        $bullet-color: var(--kt-primary-inverse), \r\n                        $arrow-color: var(--kt-primary-inverse), \r\n                        $bg-color: $app-sidebar-dark-menu-link-bg-color-active,\r\n                        $all-links: false\r\n                    );   \r\n                    \r\n                    @include menu-link-active-state( \r\n                        $title-color: var(--kt-primary-inverse), \r\n                        $icon-color: var(--kt-primary-inverse), \r\n                        $bullet-color: var(--kt-primary-inverse), \r\n                        $arrow-color: var(--kt-primary-inverse), \r\n                        $bg-color: $app-sidebar-dark-menu-link-bg-color-active,\r\n                        $all-links: false\r\n                    );\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n","//\r\n// Custom Header(used by Light Sidebar layout only)\r\n//\r\n\r\n[data-kt-app-layout=\"light-sidebar\"] {\r\n    // Desktop mode\r\n    @include media-breakpoint-up(lg) {\r\n        .app-header-menu {\r\n            .menu {\r\n                // Menu root item\r\n                > .menu-item {\r\n                    @include menu-link-here-state( \r\n                        $title-color: var(--kt-primary), \r\n                        $icon-color: var(--kt-primary), \r\n                        $bullet-color: var(--kt-primary), \r\n                        $arrow-color: var(--kt-primary), \r\n                        $bg-color: var(--kt-app-sidebar-light-header-menu-link-bg-color-active),\r\n                        $all-links: false\r\n                    );\r\n\r\n                    @include menu-link-active-state( \r\n                        $title-color: var(--kt-primary), \r\n                        $icon-color: var(--kt-primary), \r\n                        $bullet-color: var(--kt-primary), \r\n                        $arrow-color: var(--kt-primary), \r\n                        $bg-color: var(--kt-app-sidebar-light-header-menu-link-bg-color-active),\r\n                        $all-links: false\r\n                    );\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    [data-kt-app-layout=\"light-sidebar\"]:not([data-kt-app-header-fixed=\"true\"]) {\r\n        .app-header {\r\n            background-color: transparent;    \r\n            box-shadow: none;\r\n            border-bottom: 1px solid var(--kt-app-sidebar-light-separator-color);\r\n        }\r\n    }\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    [data-kt-app-layout=\"light-sidebar\"]:not([data-kt-app-header-fixed-mobile=\"true\"]) {\r\n        .app-header {\r\n            background-color: transparent;    \r\n            box-shadow: none;\r\n            border-bottom: 1px solid var(--kt-app-sidebar-light-separator-color);\r\n        }\r\n    }\r\n}","//\r\n// Content\r\n//\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n\t.app-content {\r\n\t\t[data-kt-app-toolbar-enabled=\"true\"]:not([data-kt-app-toolbar-fixed=\"true\"]) & {\r\n\t\t\tpadding-top: 0;\r\n\t\t}\t\t\r\n\t}\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n\t.app-content { \r\n\t\t[data-kt-app-toolbar-enabled=\"true\"]:not([data-kt-app-toolbar-fixed-mobile=\"true\"]) & {\r\n\t\t\tpadding-top: 0;\r\n\t\t}\r\n\t}\r\n}","//\r\n// Toolbar\r\n//\r\n\r\n// Form controls\r\n:is([data-kt-app-layout=\"light-sidebar\"], [data-kt-app-layout=\"light-header\"], [data-kt-app-layout=\"dark-header\"]) {\r\n    .app-toolbar {\r\n        .form-select.form-select {\r\n            background-color: var(--kt-body-bg) !important;    \r\n        }    \r\n    }\r\n}\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    .app-toolbar {\r\n        body:not([data-kt-app-toolbar-fixed=\"true\"]) & {\r\n            height: auto;\r\n            background-color: transparent;\r\n            border-top: 0;\r\n            border-bottom: 0;\r\n            box-shadow: none;    \r\n        }\r\n    }\r\n}\r\n\r\n// Tablet & mobile modes\r\n@include media-breakpoint-down(lg) {\r\n    .app-toolbar {\r\n        body:not([data-kt-app-toolbar-fixed-mobile=\"true\"]) & {\r\n            height: auto;\r\n            background-color: transparent;\r\n            border-top: 0;\r\n            border-bottom: 0;\r\n            box-shadow: none;    \r\n        }\r\n    }\r\n}","//\r\n// Page Title(used by Dark Header layout only)\r\n//\r\n\r\n// Desktop mode\r\n@include media-breakpoint-up(lg) {\r\n    [data-kt-app-layout=\"dark-header\"] {\r\n        .app-header {\r\n            .page-heading {\r\n                color: $white !important;\r\n            }  \r\n        } \r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
